/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			var _m = moreModules[moduleId];
/******/
/******/ 			// Check if module is deduplicated
/******/ 			switch(typeof _m) {
/******/ 			case "object":
/******/ 				// Module can be created from a template
/******/ 				modules[moduleId] = (function(_m) {
/******/ 					var args = _m.slice(1), templateId = _m[0];
/******/ 					return function (a,b,c) {
/******/ 						modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 					};
/******/ 				}(_m));
/******/ 				break;
/******/ 			case "function":
/******/ 				// Normal module
/******/ 				modules[moduleId] = _m;
/******/ 				break;
/******/ 			default:
/******/ 				// Module is a copy of another module
/******/ 				modules[moduleId] = modules[_m];
/******/ 				break;
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + ({"1":"public-menu-app","2":"admin-app","3":"locations","4":"slider-detail","5":"root","6":"store-displays-app","7":"menu","8":"location-detail","9":"cart-expanded-modal","10":"slider-display-page","11":"wall-slider","12":"public-my-account-app","13":"slider-print-format","14":"menu-display-page","15":"cart-review","16":"menu-item-expanded","17":"slides-full","18":"slide-detail","19":"order-detail","20":"product-detail","21":"location-display-detail","22":"menu-slider","23":"public-cannapoint-sync-app","24":"composite-slide-details","25":"menu-items","26":"menu-item-thumb","27":"header-control-bar","28":"header-control-bar-kiosk","29":"menu-subscriber-page","30":"entry-flow","31":"slide-list","32":"till-menu","33":"location-display","34":"product-list","35":"my-account-orders","36":"product-selector","37":"order-list","38":"product-thumbs","39":"order-compare","40":"product-variant-detail","41":"searched-postal-codes","42":"public-footer-app","43":"subfilters","44":"slider-list","45":"slider-slide-list","46":"pickup-delivery-select","47":"location-display-schedule","48":"public-location-select-app","49":"product-tile","50":"order-detail-items","51":"locations-map","52":"search","53":"video-detail","54":"order-details","55":"location-displays-list","56":"order-message-items","57":"videos-list","58":"product-video-list","59":"picked-product-list","60":"order-detail-log-items","61":"vendor-list","62":"public-redirect-app","63":"create-or-update-display-event","64":"search-modal","65":"vendor-detail","66":"location-displays-console","67":"cart-items","68":"order-with-tips-list","69":"order-to-be-refunded-list","70":"location-list","71":"category-list","72":"search-filters","73":"order-filters","74":"product-filters","75":"slide-filters","76":"kiosk-intro-overlay","77":"text-menu","78":"my-account-details","79":"cart-item","80":"footer-control-bar","81":"product-zoomer-modal","82":"category-detail","83":"delivery-postal-code-form","84":"cart-payment","85":"slider","86":"sidebar-modal","87":"transition-splash","88":"menu-item-prices-location-table","89":"session-timeout-overlay","90":"product-location-meta-updater-app","91":"cart-delivery-phone-form","92":"specials-bar","93":"product-locations","94":"entry-flow-modal","95":"product-tools","96":"product","97":"import-products","98":"product-slide-details","99":"algolia-vendor-search","100":"menu-item-prices","101":"category","102":"searched-postal-codes-filters","103":"cart-delivery-tip","104":"slides-condensed","105":"active-orders","106":"age-gate","107":"video-group","108":"search-filter-tabs","109":"locations-list","110":"admin","111":"delivery-postal-code-input","112":"order-items","113":"category-text-menu","114":"my-account-club-signup","115":"vendor-select-selected","116":"search-filters-item","117":"image-display","118":"order-status-button-flow","119":"video-items","120":"video-expanded-modal","121":"product-prices","122":"search-options","123":"composite-slide","124":"page-loading","125":"cart-payment-challenge","126":"cart-loading","127":"order-item","128":"cart-location-display","129":"send-message","130":"header-bar","131":"cart-delivery-time","132":"image-slide-details","133":"entities","134":"thumbnail-selector","135":"search-button","136":"farm-branding","137":"index","138":"menu-product","139":"modal","140":"favourite-button","141":"profile-button","142":"hamburger-button","143":"shopping-cart-indicator","144":"order-complete","145":"cart-item-count-incrementor","146":"feature-popup-content","147":"s3-file-uploader","148":"delivery-location-map","149":"credit-card-form","150":"slider-slide","151":"slide-indicator","152":"video-item","153":"search-options-item","154":"menu-item-price","155":"available-at-locations","156":"mega-menu-modal","157":"cart-empty","158":"cart-delivery-tip-button-toggle","159":"geojson-map","160":"slide","161":"specials-bar-category","162":"select-product-highlight","163":"my-account-details-password-change-form","164":"my-account-details-name-change-form","165":"my-account-details-email-change-form","166":"my-account-details-email-awaiting-validation","167":"tag-bar","168":"page-not-found","169":"page-no-permission","170":"thumbnail-item","171":"product-zoomer","172":"product-zoom-toggle","173":"photo-swiper","174":"potency-display","175":"shopping-cart-menu","176":"menu-item-price-location-check","177":"loader-expanded","178":"cookie-policy","179":"count-down","180":"click-blocker-modal","181":"checkbox-list","182":"cart-total-weight","183":"cart-error-message","184":"cart-gift-form","185":"cart-delivery-notes-form","186":"cart-delivery-address-form","187":"unavailable-product-slide","188":"image-slide","189":"slide-condensed","190":"order-status","191":"online-status","192":"location-day-hours","193":"select-and-display-image","194":"image-thumb","195":"cart","196":"video-player","197":"location","198":"applicant","199":"specials-bar-category-product","200":"my-account-payment-methods","201":"my-account-menu","202":"my-account-dashboard","203":"preferred-store-select","204":"my-account-addresses","205":"sub-category","206":"order-details-table","207":"feature-popup-content-default-view","208":"base","209":"refresh-overlay","210":"slide-list-grid-cells","211":"videos","212":"product-icon-name-cell","213":"product-vendor","214":"customer","215":"product-category","216":"pubsub","217":"strain","218":"strain-group","219":"product-variant","220":"postal-codes","221":"order","222":"menu-product-base","223":"video-conference","224":"video-conference-request","225":"base_rest","226":"applicant-status-history","227":"applicant-navigation-history","228":"applicant-email-history","229":"applicant-comment","230":"admin-user","231":"dates","232":"router","233":"ui","234":"url","235":"tok-box","236":"strings","237":"public","238":"notifications-manager","239":"validation","240":"province","241":"core","242":"constants","243":"menu-item-mixin","244":"header-dynamic-region","245":"footer-dynamic-region","246":"dynamic-region","247":"unsaved-changes-controller","248":"product-mixin"}[chunkId]||chunkId) + "-" + {"1":"88f836d1dab0aecd862c","2":"d8aa6336874298a9e654","3":"3313fd51cd9bc30087be","4":"dc4093db81987cc311af","5":"2d998a52e39b60190e3d","6":"c12a21587cb2d6934219","7":"e4037ac57e6dde7f3322","8":"f582b946f59ef685f7fe","9":"20d87663013fe2dfe327","10":"35808f649caea0cb48b4","11":"3dfcef23d10b2cb8b072","12":"c3e860dfbc6d64cded59","13":"b40f07fed0b44550fcce","14":"919fd760d8d145ec7bb9","15":"6c1c1cf3edded4935f67","16":"5b4ff38bc26b259653a9","17":"c9b31d3734968d819100","18":"11792de0f6fc8a7dee74","19":"f11e2d9ea73bb2a3fb63","20":"e12e4f5c666b050d9cd8","21":"e103ee0637b6e29589c0","22":"c64f62eec6a098db1880","23":"74e7aaf3bf0ec5788125","24":"b24e3673d4b3fabba958","25":"2d6fe0eb31a0e57b0926","26":"80e095a1565a7566e409","27":"6fde8780a013a1af28d5","28":"5d57b4ec9417169bcb4b","29":"fbf00c5e2a45d0dbd9cf","30":"82698e7970be8dd16d21","31":"89a2cbf29e510a7c9ec8","32":"dad01c6f1345bc5e9f4d","33":"19f9678e702a4caec85f","34":"35f63733d51670013520","35":"139189fc590b0b779085","36":"355a46106b55f02ef805","37":"3a9b3217488d2da1dd06","38":"3c710eb95074d96b8df1","39":"42f035464e45e9c59647","40":"bce2d829d017c89ab1ed","41":"794d7bea048aee12d489","42":"53328fba24ca022030f8","43":"7090f6e07551030efd08","44":"84f57c044d18474a4f06","45":"841b67d36f83a74d7251","46":"d0b13fb30a7a9c958591","47":"4b9d9651d3a46e5d4caa","48":"5d36c44125670ecde39c","49":"113ad235d060312b8021","50":"bc28ec6923151faffb2a","51":"2d231cdf21293271f557","52":"1c907badb46785cb7778","53":"92dbfd1a0841d00fa0cc","54":"8bcddfb4c10775febca6","55":"1b2385741f4e94e44e69","56":"b2686407fa28db768dfb","57":"6f14cd8d2f198859177a","58":"5ba70f9dceb3e03e3da2","59":"681db1ac21723a826305","60":"2b6f9263b6764f0c3151","61":"6776f3b89fffd68867f2","62":"07e60a67d079d21a792e","63":"b17c9bcfd665b0a2b22b","64":"68f3750aa161f51df1e1","65":"85d74387cb625a22d54f","66":"1ffc967efe1b4017a8ca","67":"b35bf098b4e5731d7455","68":"beefdf7f89a1a2375126","69":"2bbf7e674cbcea73df87","70":"bfad57dca61ad61bacde","71":"7e5ec5761b27a57c741c","72":"6e979e6b8995bc6ff667","73":"732a48884b7c556c1cea","74":"4f25892569bad8c1f242","75":"4cf0b6458898c00c14c4","76":"11907920be54448b804e","77":"2e07ceb9e188c0a1aa5d","78":"c1c8087057d9161a10b6","79":"97048eb54d3ad304f096","80":"6fe3911747d035e8a114","81":"b65830fb0a89ce9f43a2","82":"64390d70ed31c6fff493","83":"aa6eed08e09081948c97","84":"30cc16a31440a91299c5","85":"e51ffec11c8ff3e336cd","86":"e659c79ef1e589d9bf19","87":"8f2ff018570edb1c4262","88":"e2d03a3d6b810f4653ca","89":"74a5a024270da02a3d7a","90":"140c881ba44eff92783d","91":"fd68dde11498fedf08fa","92":"bda3e6d003076029f6a6","93":"30bc742ffe5354823b81","94":"7ddf8b556b031858ffb2","95":"756d4094cb06efdba8d8","96":"3acc02ad53abf9c7b374","97":"24fd316cc76ed52aac85","98":"75a6422df1ae6aa51840","99":"122dfcaf9167b5a43458","100":"35c9ab99b729d5918468","101":"777ea465430489d2a3b5","102":"8f5895b376e9295136bb","103":"c5b351ba097e01484ea2","104":"9cc77f67f80b5b8ac786","105":"9e592ca4519995c808fe","106":"93f76960da6d4348e1e2","107":"10310d020aabcea1305a","108":"9e6b70212ead4bff18ba","109":"955f0f84f77d1fc15384","110":"8f49deacf70d0476c815","111":"fd9198a7889cdef86b26","112":"948f74dba6bbac7bebdf","113":"0bed9cb10f8a1be62392","114":"fb8f27d72206f27075e3","115":"85ebdddb39f446fb4198","116":"e5394878dd4f8bb12f62","117":"c2c67bca7d080748cc96","118":"122281bb702b961214a4","119":"265a9672b9f069d78c73","120":"5a86ad5d7d4b5edcd1cd","121":"7ac8dbaa0c2b43969428","122":"c64e40ffc21b15f8f969","123":"851ae453cbfb546bf3fc","124":"f9796a1d3c54d1bf4e36","125":"0d9b5533f70a47bee47a","126":"bd52374122314b92105f","127":"1e891c78a6e20d6980c0","128":"4d12efffd40016192fff","129":"e2ef5de03c0805a3bff8","130":"0c7cf0b7ca538d9f7a1f","131":"ffbee1176002d720f81a","132":"c0c72cb47949cc8eae54","133":"4a78b0b92099b53daebd","134":"b3016893c2261c3c4bc0","135":"8bedc0378c3d00068548","136":"b5476c80f9268de94d5b","137":"ea0bc6d99680a331b7c4","138":"1202b11fda176aa17c45","139":"fa3015b8b9161677fed5","140":"1e1ce5446a4c8be9f01d","141":"956af7f9288923d3f62f","142":"c758c70b127c85191bc2","143":"09d47024704779a94aac","144":"7b63168027d44d96f832","145":"e87be551512c38979688","146":"6ccdab2496d9d720279c","147":"b6c818fa3f84d878d030","148":"50fed2f35b3618b45cb2","149":"207182c83fd38052c2a3","150":"f9d8f92ab896c400898d","151":"fbafc79a584aa9b12043","152":"348571aa7a276b107ac6","153":"f302fdb1aafcd3b9329b","154":"858e37246d09b11ea284","155":"8433e32e6cc9e281647e","156":"4338b83bb1c0b7c9c06f","157":"b923d8bf563462fffbbe","158":"82581532dc0869a21fc3","159":"d019c425a94413c906d0","160":"0c100d87b247af726abc","161":"15c7f4f010feb2e645bb","162":"a3894aa3844a96f36b27","163":"48438f9af9ca98f2124a","164":"e68f039151475937e3d9","165":"427fed6833486944836c","166":"0b70432e17f4d6bf5d31","167":"0a310deb523844616d31","168":"94f71d38dc7ec304fdbf","169":"723ccaf550a50e014b26","170":"4238422090aa403119aa","171":"0dee54f73a7abbb5b84c","172":"9bb3401150b9af789501","173":"bb57bdbbe2836e89f8c0","174":"0de2164cd67e120472d9","175":"9cb1e3bc758db7b0eb76","176":"508cbb9213a66301e9d6","177":"b1be0e4fd4afde64bf91","178":"f2f8fd8e40be198cc60b","179":"1ff6714bd626a414eaae","180":"5b9c4da12890dd74031b","181":"9911f79f369a4fb6c4b0","182":"d1a2804ef09d680ca4b1","183":"7a5c4d703688a90a74b6","184":"a264fdfd16a31432f6fe","185":"27015204d1f0e0d7ccaf","186":"4b3c4183edcfe83bbe77","187":"508dc3c86c880fba3cb8","188":"204fc932f365b7b56e39","189":"76d2924c696606d0e3ca","190":"625547ea0b78f1754d10","191":"eac889ebf194d3af200c","192":"7723b78ea39607c045b6","193":"b1bb6af7655ffe8682a7","194":"99756173aaa1f96871cf","195":"68f10eb4380045940ecf","196":"d3f4630a5246385db60e","197":"68bc4c1224a68de58d7c","198":"f81e7e5877b5629860b3","199":"bc782a8737b0772db763","200":"4c7cde2b0f67f19129d7","201":"94857a3e0ff54fc85364","202":"ac2bee384da903fc8bef","203":"4bf4eff0c30e17282878","204":"2eb732232a05f025811c","205":"d4d0f796f73e8db14fe6","206":"68608d90d156e7d84d46","207":"38405dc84663b5ae4c0f","208":"4e46bf8db46ba40e6787","209":"ae65e2300afa978687d2","210":"56c12aa840463acaaa97","211":"274bc12dc0fd9b12619d","212":"0decda07484902563351","213":"f044034584ab6a87243a","214":"8d64b20ce81c0fedf20c","215":"e18364f922a2aa560e57","216":"5e853dd8e46b5467bd2d","217":"b9791bd887f4311fb8e5","218":"093b2f2573f27159ba72","219":"60ca8402ee9a1e988770","220":"cdb8dff1113019acc435","221":"19e775e1ba4fbde3d432","222":"44f70e3bb152c6484e0a","223":"886cf129c17a11d0543b","224":"53b9def6fa94ded6ad9a","225":"7fb482fc789bade8c834","226":"918051f2809ab6f9728b","227":"458029ce665d9a455eaa","228":"301e44145668058075be","229":"03ed2966e0bdc70d0416","230":"78e74764e4a1a61f178a","231":"eabfb3c366a5babd3d26","232":"5acd1c012b243e2698fc","233":"f1c771dde3897a2dd96e","234":"ef3ddfac7b5c26121e08","235":"5470c9b5057e8a027d6b","236":"409c657edf43d0082f20","237":"fa1df2a63c33540b4230","238":"695a013269bedcf02299","239":"47ec6eb60a3fbfedf0e2","240":"3b80239f7859cefc86c4","241":"50b47c0a9fd37bad24a1","242":"99805fbc9fe98b319f10","243":"5d823d121ad3d79f83a1","244":"7ca58d40af0ab86d6b03","245":"87edf754920d56bcc290","246":"8eb8677fe9c5a5b81eb8","247":"206fb64e3314fd5699e2","248":"a5890b2d8da8bc3eb617"}[chunkId] + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */,
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ },
/* 2 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function(useSourceMap) {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			return this.map(function (item) {
				var content = cssWithMappingToString(item, useSourceMap);
				if(item[2]) {
					return "@media " + item[2] + "{" + content + "}";
				} else {
					return content;
				}
			}).join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};
	
	function cssWithMappingToString(item, useSourceMap) {
		var content = item[1] || '';
		var cssMapping = item[3];
		if (!cssMapping) {
			return content;
		}
	
		if (useSourceMap && typeof btoa === 'function') {
			var sourceMapping = toComment(cssMapping);
			var sourceURLs = cssMapping.sources.map(function (source) {
				return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
			});
	
			return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
		}
	
		return [content].join('\n');
	}
	
	// Adapted from convert-source-map (MIT)
	function toComment(sourceMap) {
		// eslint-disable-next-line no-undef
		var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
		var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
	
		return '/*# ' + data + ' */';
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			// Test for IE <= 9 as proposed by Browserhacks
			// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
			// Tests for existence of standard globals is to allow style-loader 
			// to operate correctly into non-standard environments
			// @see https://github.com/webpack-contrib/style-loader/issues/177
			return window && document && document.all && !window.atob;
		}),
		getElement = (function(fn) {
			var memo = {};
			return function(selector) {
				if (typeof memo[selector] === "undefined") {
					memo[selector] = fn.call(this, selector);
				}
				return memo[selector]
			};
		})(function (styleTarget) {
			return document.querySelector(styleTarget)
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [],
		fixUrls = __webpack_require__(1873);
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		options.attrs = typeof options.attrs === "object" ? options.attrs : {};
	
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the <head> element
		if (typeof options.insertInto === "undefined") options.insertInto = "head";
	
		// By default, add <style> tags to the bottom of the target
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list, options);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList, options);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	};
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list, options) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = options.base ? item[0] + options.base : item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var styleTarget = getElement(options.insertInto)
		if (!styleTarget) {
			throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
		}
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				styleTarget.insertBefore(styleElement, styleTarget.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				styleTarget.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			styleTarget.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		options.attrs.type = "text/css";
	
		attachTagAttrs(styleElement, options.attrs);
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		options.attrs.type = "text/css";
		options.attrs.rel = "stylesheet";
	
		attachTagAttrs(linkElement, options.attrs);
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function attachTagAttrs(element, attrs) {
		Object.keys(attrs).forEach(function (key) {
			element.setAttribute(key, attrs[key]);
		});
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove, transformResult;
	
		// If a transform function was defined, run it on the css
		if (options.transform && obj.css) {
		    transformResult = options.transform(obj.css);
		    
		    if (transformResult) {
		    	// If transform returns a value, use that instead of the original css.
		    	// This allows running runtime transformations on the css.
		    	obj.css = transformResult;
		    } else {
		    	// If the transform function returns a falsy value, don't add this css. 
		    	// This allows conditional loading of css
		    	return function() {
		    		// noop
		    	};
		    }
		}
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement, options);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, options, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
		*/
		var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;
	
		if (options.convertToAbsoluteUrls || autoFixUrls){
			css = fixUrls(css);
		}
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 4 */
[1959, 1, 11],
/* 5 */,
/* 6 */
[1954, 16, 1510, 1512, 1508],
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define('underscore', factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
	    var current = global._;
	    var exports = global._ = factory();
	    exports.noConflict = function () { global._ = current; return exports; };
	  }()));
	}(this, (function () {
	  //     Underscore.js 1.13.7
	  //     https://underscorejs.org
	  //     (c) 2009-2024 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
	  //     Underscore may be freely distributed under the MIT license.
	
	  // Current version.
	  var VERSION = '1.13.7';
	
	  // Establish the root object, `window` (`self`) in the browser, `global`
	  // on the server, or `this` in some virtual machines. We use `self`
	  // instead of `window` for `WebWorker` support.
	  var root = (typeof self == 'object' && self.self === self && self) ||
	            (typeof global == 'object' && global.global === global && global) ||
	            Function('return this')() ||
	            {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
	  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // Modern feature detection.
	  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
	      supportsDataView = typeof DataView !== 'undefined';
	
	  // All **ECMAScript 5+** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeCreate = Object.create,
	      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;
	
	  // Create references to these builtin functions because we override them.
	  var _isNaN = isNaN,
	      _isFinite = isFinite;
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  // The largest integer that can be represented exactly.
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	
	  // Some functions take a variable number of arguments, or a few expected
	  // arguments at the beginning and then a variable number of values to operate
	  // on. This helper accumulates all remaining arguments past the function’s
	  // argument length (or an explicit `startIndex`), into an array that becomes
	  // the last argument. Similar to ES6’s "rest parameter".
	  function restArguments(func, startIndex) {
	    startIndex = startIndex == null ? func.length - 1 : +startIndex;
	    return function() {
	      var length = Math.max(arguments.length - startIndex, 0),
	          rest = Array(length),
	          index = 0;
	      for (; index < length; index++) {
	        rest[index] = arguments[index + startIndex];
	      }
	      switch (startIndex) {
	        case 0: return func.call(this, rest);
	        case 1: return func.call(this, arguments[0], rest);
	        case 2: return func.call(this, arguments[0], arguments[1], rest);
	      }
	      var args = Array(startIndex + 1);
	      for (index = 0; index < startIndex; index++) {
	        args[index] = arguments[index];
	      }
	      args[startIndex] = rest;
	      return func.apply(this, args);
	    };
	  }
	
	  // Is a given variable an object?
	  function isObject(obj) {
	    var type = typeof obj;
	    return type === 'function' || (type === 'object' && !!obj);
	  }
	
	  // Is a given value equal to null?
	  function isNull(obj) {
	    return obj === null;
	  }
	
	  // Is a given variable undefined?
	  function isUndefined(obj) {
	    return obj === void 0;
	  }
	
	  // Is a given value a boolean?
	  function isBoolean(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  }
	
	  // Is a given value a DOM element?
	  function isElement(obj) {
	    return !!(obj && obj.nodeType === 1);
	  }
	
	  // Internal function for creating a `toString`-based type tester.
	  function tagTester(name) {
	    var tag = '[object ' + name + ']';
	    return function(obj) {
	      return toString.call(obj) === tag;
	    };
	  }
	
	  var isString = tagTester('String');
	
	  var isNumber = tagTester('Number');
	
	  var isDate = tagTester('Date');
	
	  var isRegExp = tagTester('RegExp');
	
	  var isError = tagTester('Error');
	
	  var isSymbol = tagTester('Symbol');
	
	  var isArrayBuffer = tagTester('ArrayBuffer');
	
	  var isFunction = tagTester('Function');
	
	  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
	  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
	  var nodelist = root.document && root.document.childNodes;
	  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
	    isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  var isFunction$1 = isFunction;
	
	  var hasObjectTag = tagTester('Object');
	
	  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
	  // In IE 11, the most common among them, this problem also applies to
	  // `Map`, `WeakMap` and `Set`.
	  // Also, there are cases where an application can override the native
	  // `DataView` object, in cases like that we can't use the constructor
	  // safely and should just rely on alternate `DataView` checks
	  var hasDataViewBug = (
	        supportsDataView && (!/\[native code\]/.test(String(DataView)) || hasObjectTag(new DataView(new ArrayBuffer(8))))
	      ),
	      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));
	
	  var isDataView = tagTester('DataView');
	
	  // In IE 10 - Edge 13, we need a different heuristic
	  // to determine whether an object is a `DataView`.
	  // Also, in cases where the native `DataView` is
	  // overridden we can't rely on the tag itself.
	  function alternateIsDataView(obj) {
	    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
	  }
	
	  var isDataView$1 = (hasDataViewBug ? alternateIsDataView : isDataView);
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native `Array.isArray`.
	  var isArray = nativeIsArray || tagTester('Array');
	
	  // Internal function to check whether `key` is an own property name of `obj`.
	  function has$1(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  }
	
	  var isArguments = tagTester('Arguments');
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  (function() {
	    if (!isArguments(arguments)) {
	      isArguments = function(obj) {
	        return has$1(obj, 'callee');
	      };
	    }
	  }());
	
	  var isArguments$1 = isArguments;
	
	  // Is a given object a finite number?
	  function isFinite$1(obj) {
	    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
	  }
	
	  // Is the given value `NaN`?
	  function isNaN$1(obj) {
	    return isNumber(obj) && _isNaN(obj);
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function constant(value) {
	    return function() {
	      return value;
	    };
	  }
	
	  // Common internal logic for `isArrayLike` and `isBufferLike`.
	  function createSizePropertyCheck(getSizeProperty) {
	    return function(collection) {
	      var sizeProperty = getSizeProperty(collection);
	      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
	    }
	  }
	
	  // Internal helper to generate a function to obtain property `key` from `obj`.
	  function shallowProperty(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  }
	
	  // Internal helper to obtain the `byteLength` property of an object.
	  var getByteLength = shallowProperty('byteLength');
	
	  // Internal helper to determine whether we should spend extensive checks against
	  // `ArrayBuffer` et al.
	  var isBufferLike = createSizePropertyCheck(getByteLength);
	
	  // Is a given value a typed array?
	  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
	  function isTypedArray(obj) {
	    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
	    // Otherwise, fall back on the above regular expression.
	    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
	                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
	  }
	
	  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);
	
	  // Internal helper to obtain the `length` property of an object.
	  var getLength = shallowProperty('length');
	
	  // Internal helper to create a simple lookup structure.
	  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
	  // circular imports. `emulatedSet` is a one-off solution that only works for
	  // arrays of strings.
	  function emulatedSet(keys) {
	    var hash = {};
	    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
	    return {
	      contains: function(key) { return hash[key] === true; },
	      push: function(key) {
	        hash[key] = true;
	        return keys.push(key);
	      }
	    };
	  }
	
	  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
	  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
	  // needed.
	  function collectNonEnumProps(obj, keys) {
	    keys = emulatedSet(keys);
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (isFunction$1(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`.
	  function keys(obj) {
	    if (!isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (has$1(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  function isEmpty(obj) {
	    if (obj == null) return true;
	    // Skip the more expensive `toString`-based type checks if `obj` has no
	    // `.length`.
	    var length = getLength(obj);
	    if (typeof length == 'number' && (
	      isArray(obj) || isString(obj) || isArguments$1(obj)
	    )) return length === 0;
	    return getLength(keys(obj)) === 0;
	  }
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  function isMatch(object, attrs) {
	    var _keys = keys(attrs), length = _keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = _keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  }
	
	  // If Underscore is called as a function, it returns a wrapped object that can
	  // be used OO-style. This wrapper holds altered versions of all functions added
	  // through `_.mixin`. Wrapped objects may be chained.
	  function _$1(obj) {
	    if (obj instanceof _$1) return obj;
	    if (!(this instanceof _$1)) return new _$1(obj);
	    this._wrapped = obj;
	  }
	
	  _$1.VERSION = VERSION;
	
	  // Extracts the result from a wrapped and chained object.
	  _$1.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxies for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;
	
	  _$1.prototype.toString = function() {
	    return String(this._wrapped);
	  };
	
	  // Internal function to wrap or shallow-copy an ArrayBuffer,
	  // typed array or DataView to a new view, reusing the buffer.
	  function toBufferView(bufferSource) {
	    return new Uint8Array(
	      bufferSource.buffer || bufferSource,
	      bufferSource.byteOffset || 0,
	      getByteLength(bufferSource)
	    );
	  }
	
	  // We use this string twice, so give it a name for minification.
	  var tagDataView = '[object DataView]';
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null) return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a) return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
	    return deepEq(a, b, aStack, bStack);
	  }
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    if (a instanceof _$1) a = a._wrapped;
	    if (b instanceof _$1) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    // Work around a bug in IE 10 - Edge 13.
	    if (hasDataViewBug && className == '[object Object]' && isDataView$1(a)) {
	      if (!isDataView$1(b)) return false;
	      className = tagDataView;
	    }
	    switch (className) {
	      // These types are compared by value.
	      case '[object RegExp]':
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN.
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	      case '[object Symbol]':
	        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
	      case '[object ArrayBuffer]':
	      case tagDataView:
	        // Coerce to typed array so we can fall through.
	        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays && isTypedArray$1(a)) {
	        var byteLength = getByteLength(a);
	        if (byteLength !== getByteLength(b)) return false;
	        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
	        areArrays = true;
	    }
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
	                               isFunction$1(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var _keys = keys(a), key;
	      length = _keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = _keys[length];
	        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  }
	
	  // Perform a deep comparison to check if two objects are equal.
	  function isEqual(a, b) {
	    return eq(a, b);
	  }
	
	  // Retrieve all the enumerable property names of an object.
	  function allKeys(obj) {
	    if (!isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Since the regular `Object.prototype.toString` type tests don't work for
	  // some types in IE 11, we use a fingerprinting heuristic instead, based
	  // on the methods. It's not great, but it's the best we got.
	  // The fingerprint method lists are defined below.
	  function ie11fingerprint(methods) {
	    var length = getLength(methods);
	    return function(obj) {
	      if (obj == null) return false;
	      // `Map`, `WeakMap` and `Set` have no enumerable keys.
	      var keys = allKeys(obj);
	      if (getLength(keys)) return false;
	      for (var i = 0; i < length; i++) {
	        if (!isFunction$1(obj[methods[i]])) return false;
	      }
	      // If we are testing against `WeakMap`, we need to ensure that
	      // `obj` doesn't have a `forEach` method in order to distinguish
	      // it from a regular `Map`.
	      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
	    };
	  }
	
	  // In the interest of compact minification, we write
	  // each string in the fingerprints only once.
	  var forEachName = 'forEach',
	      hasName = 'has',
	      commonInit = ['clear', 'delete'],
	      mapTail = ['get', hasName, 'set'];
	
	  // `Map`, `WeakMap` and `Set` each have slightly different
	  // combinations of the above sublists.
	  var mapMethods = commonInit.concat(forEachName, mapTail),
	      weakMapMethods = commonInit.concat(mapTail),
	      setMethods = ['add'].concat(commonInit, forEachName, hasName);
	
	  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');
	
	  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');
	
	  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');
	
	  var isWeakSet = tagTester('WeakSet');
	
	  // Retrieve the values of an object's properties.
	  function values(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[_keys[i]];
	    }
	    return values;
	  }
	
	  // Convert an object into a list of `[key, value]` pairs.
	  // The opposite of `_.object` with one argument.
	  function pairs(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [_keys[i], obj[_keys[i]]];
	    }
	    return pairs;
	  }
	
	  // Invert the keys and values of an object. The values must be serializable.
	  function invert(obj) {
	    var result = {};
	    var _keys = keys(obj);
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      result[obj[_keys[i]]] = _keys[i];
	    }
	    return result;
	  }
	
	  // Return a sorted list of the function names available on the object.
	  function functions(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (isFunction$1(obj[key])) names.push(key);
	    }
	    return names.sort();
	  }
	
	  // An internal function for creating assigner functions.
	  function createAssigner(keysFunc, defaults) {
	    return function(obj) {
	      var length = arguments.length;
	      if (defaults) obj = Object(obj);
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!defaults || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  }
	
	  // Extend a given object with all the properties in passed-in object(s).
	  var extend = createAssigner(allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in
	  // object(s).
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  var extendOwn = createAssigner(keys);
	
	  // Fill in a given object with default properties.
	  var defaults = createAssigner(allKeys, true);
	
	  // Create a naked function reference for surrogate-prototype-swapping.
	  function ctor() {
	    return function(){};
	  }
	
	  // An internal function for creating a new object that inherits from another.
	  function baseCreate(prototype) {
	    if (!isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    var Ctor = ctor();
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  }
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  function create(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) extendOwn(result, props);
	    return result;
	  }
	
	  // Create a (shallow-cloned) duplicate of an object.
	  function clone(obj) {
	    if (!isObject(obj)) return obj;
	    return isArray(obj) ? obj.slice() : extend({}, obj);
	  }
	
	  // Invokes `interceptor` with the `obj` and then returns `obj`.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  function tap(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  }
	
	  // Normalize a (deep) property `path` to array.
	  // Like `_.iteratee`, this function can be customized.
	  function toPath$1(path) {
	    return isArray(path) ? path : [path];
	  }
	  _$1.toPath = toPath$1;
	
	  // Internal wrapper for `_.toPath` to enable minification.
	  // Similar to `cb` for `_.iteratee`.
	  function toPath(path) {
	    return _$1.toPath(path);
	  }
	
	  // Internal function to obtain a nested property in `obj` along `path`.
	  function deepGet(obj, path) {
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      if (obj == null) return void 0;
	      obj = obj[path[i]];
	    }
	    return length ? obj : void 0;
	  }
	
	  // Get the value of the (deep) property on `path` from `object`.
	  // If any property in `path` does not exist or if the value is
	  // `undefined`, return `defaultValue` instead.
	  // The `path` is normalized through `_.toPath`.
	  function get(object, path, defaultValue) {
	    var value = deepGet(object, toPath(path));
	    return isUndefined(value) ? defaultValue : value;
	  }
	
	  // Shortcut function for checking if an object has a given property directly on
	  // itself (in other words, not on a prototype). Unlike the internal `has`
	  // function, this public version can also traverse nested properties.
	  function has(obj, path) {
	    path = toPath(path);
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      var key = path[i];
	      if (!has$1(obj, key)) return false;
	      obj = obj[key];
	    }
	    return !!length;
	  }
	
	  // Keep the identity function around for default iteratees.
	  function identity(value) {
	    return value;
	  }
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  function matcher(attrs) {
	    attrs = extendOwn({}, attrs);
	    return function(obj) {
	      return isMatch(obj, attrs);
	    };
	  }
	
	  // Creates a function that, when passed an object, will traverse that object’s
	  // properties down the given `path`, specified as an array of keys or indices.
	  function property(path) {
	    path = toPath(path);
	    return function(obj) {
	      return deepGet(obj, path);
	    };
	  }
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  function optimizeCb(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      // The 2-argument case is omitted because we’re not using it.
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  }
	
	  // An internal function to generate callbacks that can be applied to each
	  // element in a collection, returning the desired result — either `_.identity`,
	  // an arbitrary callback, a property matcher, or a property accessor.
	  function baseIteratee(value, context, argCount) {
	    if (value == null) return identity;
	    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
	    if (isObject(value) && !isArray(value)) return matcher(value);
	    return property(value);
	  }
	
	  // External wrapper for our callback generator. Users may customize
	  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
	  // This abstraction hides the internal-only `argCount` argument.
	  function iteratee(value, context) {
	    return baseIteratee(value, context, Infinity);
	  }
	  _$1.iteratee = iteratee;
	
	  // The function we call internally to generate a callback. It invokes
	  // `_.iteratee` if overridden, otherwise `baseIteratee`.
	  function cb(value, context, argCount) {
	    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
	    return baseIteratee(value, context, argCount);
	  }
	
	  // Returns the results of applying the `iteratee` to each element of `obj`.
	  // In contrast to `_.map` it returns an object.
	  function mapObject(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = keys(obj),
	        length = _keys.length,
	        results = {};
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function noop(){}
	
	  // Generates a function for a given object that returns a given property.
	  function propertyOf(obj) {
	    if (obj == null) return noop;
	    return function(path) {
	      return get(obj, path);
	    };
	  }
	
	  // Run a function **n** times.
	  function times(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  }
	
	  // Return a random integer between `min` and `max` (inclusive).
	  function random(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  }
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  var now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	  // Internal helper to generate functions for escaping and unescaping strings
	  // to/from HTML interpolation.
	  function createEscaper(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  }
	
	  // Internal list of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	
	  // Function for escaping strings to HTML interpolation.
	  var _escape = createEscaper(escapeMap);
	
	  // Internal list of HTML entities for unescaping.
	  var unescapeMap = invert(escapeMap);
	
	  // Function for unescaping strings from HTML interpolation.
	  var _unescape = createEscaper(unescapeMap);
	
	  // By default, Underscore uses ERB-style template delimiters. Change the
	  // following template settings to use alternative delimiters.
	  var templateSettings = _$1.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `_.templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  function escapeChar(match) {
	    return '\\' + escapes[match];
	  }
	
	  // In order to prevent third-party code injection through
	  // `_.templateSettings.variable`, we test it against the following regular
	  // expression. It is intentionally a bit more liberal than just matching valid
	  // identifiers, but still prevents possible loopholes through defaults or
	  // destructuring assignment.
	  var bareIdentifier = /^\s*(\w|\$)+\s*$/;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  function template(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = defaults({}, settings, _$1.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offset.
	      return match;
	    });
	    source += "';\n";
	
	    var argument = settings.variable;
	    if (argument) {
	      // Insure against third-party code injection. (CVE-2021-23358)
	      if (!bareIdentifier.test(argument)) throw new Error(
	        'variable is not a bare identifier: ' + argument
	      );
	    } else {
	      // If a variable is not specified, place data values in local scope.
	      source = 'with(obj||{}){\n' + source + '}\n';
	      argument = 'obj';
	    }
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    var render;
	    try {
	      render = new Function(argument, '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _$1);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  }
	
	  // Traverses the children of `obj` along `path`. If a child is a function, it
	  // is invoked with its parent as context. Returns the value of the final
	  // child, or `fallback` if any child is undefined.
	  function result(obj, path, fallback) {
	    path = toPath(path);
	    var length = path.length;
	    if (!length) {
	      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
	    }
	    for (var i = 0; i < length; i++) {
	      var prop = obj == null ? void 0 : obj[path[i]];
	      if (prop === void 0) {
	        prop = fallback;
	        i = length; // Ensure we don't continue iterating.
	      }
	      obj = isFunction$1(prop) ? prop.call(obj) : prop;
	    }
	    return obj;
	  }
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  function uniqueId(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  }
	
	  // Start chaining a wrapped Underscore object.
	  function chain(obj) {
	    var instance = _$1(obj);
	    instance._chain = true;
	    return instance;
	  }
	
	  // Internal function to execute `sourceFunc` bound to `context` with optional
	  // `args`. Determines whether to execute a function as a constructor or as a
	  // normal function.
	  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (isObject(result)) return result;
	    return self;
	  }
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
	  // as a placeholder by default, allowing any combination of arguments to be
	  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
	  var partial = restArguments(function(func, boundArgs) {
	    var placeholder = partial.placeholder;
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  });
	
	  partial.placeholder = _$1;
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally).
	  var bind = restArguments(function(func, context, args) {
	    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
	    var bound = restArguments(function(callArgs) {
	      return executeBound(func, bound, context, this, args.concat(callArgs));
	    });
	    return bound;
	  });
	
	  // Internal helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object.
	  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var isArrayLike = createSizePropertyCheck(getLength);
	
	  // Internal implementation of a recursive `flatten` function.
	  function flatten$1(input, depth, strict, output) {
	    output = output || [];
	    if (!depth && depth !== 0) {
	      depth = Infinity;
	    } else if (depth <= 0) {
	      return output.concat(input);
	    }
	    var idx = output.length;
	    for (var i = 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
	        // Flatten current level of array or arguments object.
	        if (depth > 1) {
	          flatten$1(value, depth - 1, strict, output);
	          idx = output.length;
	        } else {
	          var j = 0, len = value.length;
	          while (j < len) output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  }
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  var bindAll = restArguments(function(obj, keys) {
	    keys = flatten$1(keys, false, false);
	    var index = keys.length;
	    if (index < 1) throw new Error('bindAll must be passed function names');
	    while (index--) {
	      var key = keys[index];
	      obj[key] = bind(obj[key], obj);
	    }
	    return obj;
	  });
	
	  // Memoize an expensive function by storing its results.
	  function memoize(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  }
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  var delay = restArguments(function(func, wait, args) {
	    return setTimeout(function() {
	      return func.apply(null, args);
	    }, wait);
	  });
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  var defer = partial(delay, _$1, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  function throttle(func, wait, options) {
	    var timeout, context, args, result;
	    var previous = 0;
	    if (!options) options = {};
	
	    var later = function() {
	      previous = options.leading === false ? 0 : now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	
	    var throttled = function() {
	      var _now = now();
	      if (!previous && options.leading === false) previous = _now;
	      var remaining = wait - (_now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = _now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	
	    throttled.cancel = function() {
	      clearTimeout(timeout);
	      previous = 0;
	      timeout = context = args = null;
	    };
	
	    return throttled;
	  }
	
	  // When a sequence of calls of the returned function ends, the argument
	  // function is triggered. The end of a sequence is defined by the `wait`
	  // parameter. If `immediate` is passed, the argument function will be
	  // triggered at the beginning of the sequence instead of at the end.
	  function debounce(func, wait, immediate) {
	    var timeout, previous, args, result, context;
	
	    var later = function() {
	      var passed = now() - previous;
	      if (wait > passed) {
	        timeout = setTimeout(later, wait - passed);
	      } else {
	        timeout = null;
	        if (!immediate) result = func.apply(context, args);
	        // This check is needed because `func` can recursively invoke `debounced`.
	        if (!timeout) args = context = null;
	      }
	    };
	
	    var debounced = restArguments(function(_args) {
	      context = this;
	      args = _args;
	      previous = now();
	      if (!timeout) {
	        timeout = setTimeout(later, wait);
	        if (immediate) result = func.apply(context, args);
	      }
	      return result;
	    });
	
	    debounced.cancel = function() {
	      clearTimeout(timeout);
	      timeout = args = context = null;
	    };
	
	    return debounced;
	  }
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  function wrap(func, wrapper) {
	    return partial(wrapper, func);
	  }
	
	  // Returns a negated version of the passed-in predicate.
	  function negate(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  }
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  }
	
	  // Returns a function that will only be executed on and after the Nth call.
	  function after(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  }
	
	  // Returns a function that will only be executed up to (but not including) the
	  // Nth call.
	  function before(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  }
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  var once = partial(before, 2);
	
	  // Returns the first key on an object that passes a truth test.
	  function findKey(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = keys(obj), key;
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      key = _keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  }
	
	  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a truth test.
	  var findIndex = createPredicateIndexFinder(1);
	
	  // Returns the last index on an array-like that passes a truth test.
	  var findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  function sortedIndex(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  }
	
	  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), isNaN$1);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  var indexOf = createIndexFinder(1, findIndex, sortedIndex);
	
	  // Return the position of the last occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  var lastIndexOf = createIndexFinder(-1, findLastIndex);
	
	  // Return the first value which passes a truth test.
	  function find(obj, predicate, context) {
	    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
	    var key = keyFinder(obj, predicate, context);
	    if (key !== void 0 && key !== -1) return obj[key];
	  }
	
	  // Convenience version of a common use case of `_.find`: getting the first
	  // object containing specific `key:value` pairs.
	  function findWhere(obj, attrs) {
	    return find(obj, matcher(attrs));
	  }
	
	  // The cornerstone for collection functions, an `each`
	  // implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  function each(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var _keys = keys(obj);
	      for (i = 0, length = _keys.length; i < length; i++) {
	        iteratee(obj[_keys[i]], _keys[i], obj);
	      }
	    }
	    return obj;
	  }
	
	  // Return the results of applying the iteratee to each element.
	  function map(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Internal helper to create a reducing function, iterating left or right.
	  function createReduce(dir) {
	    // Wrap code that reassigns argument variables in a separate function than
	    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
	    var reducer = function(obj, iteratee, memo, initial) {
	      var _keys = !isArrayLike(obj) && keys(obj),
	          length = (_keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      if (!initial) {
	        memo = obj[_keys ? _keys[index] : index];
	        index += dir;
	      }
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = _keys ? _keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    };
	
	    return function(obj, iteratee, memo, context) {
	      var initial = arguments.length >= 3;
	      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  var reduce = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  var reduceRight = createReduce(-1);
	
	  // Return all the elements that pass a truth test.
	  function filter(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  }
	
	  // Return all the elements for which a truth test fails.
	  function reject(obj, predicate, context) {
	    return filter(obj, negate(cb(predicate)), context);
	  }
	
	  // Determine whether all of the elements pass a truth test.
	  function every(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  }
	
	  // Determine if at least one element in the object passes a truth test.
	  function some(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  }
	
	  // Determine if the array or object contains a given item (using `===`).
	  function contains(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return indexOf(obj, item, fromIndex) >= 0;
	  }
	
	  // Invoke a method (with arguments) on every item in a collection.
	  var invoke = restArguments(function(obj, path, args) {
	    var contextPath, func;
	    if (isFunction$1(path)) {
	      func = path;
	    } else {
	      path = toPath(path);
	      contextPath = path.slice(0, -1);
	      path = path[path.length - 1];
	    }
	    return map(obj, function(context) {
	      var method = func;
	      if (!method) {
	        if (contextPath && contextPath.length) {
	          context = deepGet(context, contextPath);
	        }
	        if (context == null) return void 0;
	        method = context[path];
	      }
	      return method == null ? method : method.apply(context, args);
	    });
	  });
	
	  // Convenience version of a common use case of `_.map`: fetching a property.
	  function pluck(obj, key) {
	    return map(obj, property(key));
	  }
	
	  // Convenience version of a common use case of `_.filter`: selecting only
	  // objects containing specific `key:value` pairs.
	  function where(obj, attrs) {
	    return filter(obj, matcher(attrs));
	  }
	
	  // Return the maximum element (or element-based computation).
	  function max(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed > lastComputed || (computed === -Infinity && result === -Infinity)) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Return the minimum element (or element-based computation).
	  function min(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed < lastComputed || (computed === Infinity && result === Infinity)) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Safely create a real, live array from anything iterable.
	  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
	  function toArray(obj) {
	    if (!obj) return [];
	    if (isArray(obj)) return slice.call(obj);
	    if (isString(obj)) {
	      // Keep surrogate pair characters together.
	      return obj.match(reStrSymbol);
	    }
	    if (isArrayLike(obj)) return map(obj, identity);
	    return values(obj);
	  }
	
	  // Sample **n** random values from a collection using the modern version of the
	  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `_.map`.
	  function sample(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = values(obj);
	      return obj[random(obj.length - 1)];
	    }
	    var sample = toArray(obj);
	    var length = getLength(sample);
	    n = Math.max(Math.min(n, length), 0);
	    var last = length - 1;
	    for (var index = 0; index < n; index++) {
	      var rand = random(index, last);
	      var temp = sample[index];
	      sample[index] = sample[rand];
	      sample[rand] = temp;
	    }
	    return sample.slice(0, n);
	  }
	
	  // Shuffle a collection.
	  function shuffle(obj) {
	    return sample(obj, Infinity);
	  }
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  function sortBy(obj, iteratee, context) {
	    var index = 0;
	    iteratee = cb(iteratee, context);
	    return pluck(map(obj, function(value, key, list) {
	      return {
	        value: value,
	        index: index++,
	        criteria: iteratee(value, key, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  }
	
	  // An internal function used for aggregate "group by" operations.
	  function group(behavior, partition) {
	    return function(obj, iteratee, context) {
	      var result = partition ? [[], []] : {};
	      iteratee = cb(iteratee, context);
	      each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  }
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  var groupBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
	  // when you know that your index values will be unique.
	  var indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  var countBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Split a collection into two arrays: one whose elements all pass the given
	  // truth test, and one whose elements all do not pass the truth test.
	  var partition = group(function(result, value, pass) {
	    result[pass ? 0 : 1].push(value);
	  }, true);
	
	  // Return the number of elements in a collection.
	  function size(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : keys(obj).length;
	  }
	
	  // Internal `_.pick` helper function to determine whether `key` is an enumerable
	  // property name of `obj`.
	  function keyInObj(value, key, obj) {
	    return key in obj;
	  }
	
	  // Return a copy of the object only containing the allowed properties.
	  var pick = restArguments(function(obj, keys) {
	    var result = {}, iteratee = keys[0];
	    if (obj == null) return result;
	    if (isFunction$1(iteratee)) {
	      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
	      keys = allKeys(obj);
	    } else {
	      iteratee = keyInObj;
	      keys = flatten$1(keys, false, false);
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  });
	
	  // Return a copy of the object without the disallowed properties.
	  var omit = restArguments(function(obj, keys) {
	    var iteratee = keys[0], context;
	    if (isFunction$1(iteratee)) {
	      iteratee = negate(iteratee);
	      if (keys.length > 1) context = keys[1];
	    } else {
	      keys = map(flatten$1(keys, false, false), String);
	      iteratee = function(value, key) {
	        return !contains(keys, key);
	      };
	    }
	    return pick(obj, iteratee, context);
	  });
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  function initial(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  }
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  function first(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[0];
	    return initial(array, array.length - n);
	  }
	
	  // Returns everything but the first entry of the `array`. Especially useful on
	  // the `arguments` object. Passing an **n** will return the rest N values in the
	  // `array`.
	  function rest(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  }
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  function last(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[array.length - 1];
	    return rest(array, Math.max(0, array.length - n));
	  }
	
	  // Trim out all falsy values from an array.
	  function compact(array) {
	    return filter(array, Boolean);
	  }
	
	  // Flatten out an array, either recursively (by default), or up to `depth`.
	  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
	  function flatten(array, depth) {
	    return flatten$1(array, depth, false);
	  }
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  var difference = restArguments(function(array, rest) {
	    rest = flatten$1(rest, true, true);
	    return filter(array, function(value){
	      return !contains(rest, value);
	    });
	  });
	
	  // Return a version of the array that does not contain the specified value(s).
	  var without = restArguments(function(array, otherArrays) {
	    return difference(array, otherArrays);
	  });
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // The faster algorithm will not work with an iteratee if the iteratee
	  // is not a one-to-one function, so providing an iteratee will disable
	  // the faster algorithm.
	  function uniq(array, isSorted, iteratee, context) {
	    if (!isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted && !iteratee) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  var union = restArguments(function(arrays) {
	    return uniq(flatten$1(arrays, true, true));
	  });
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  function intersection(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (contains(result, item)) continue;
	      var j;
	      for (j = 1; j < argsLength; j++) {
	        if (!contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  }
	
	  // Complement of zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices.
	  function unzip(array) {
	    var length = (array && max(array, getLength).length) || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = pluck(array, index);
	    }
	    return result;
	  }
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  var zip = restArguments(unzip);
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
	  function object(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  }
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](https://docs.python.org/library/functions.html#range).
	  function range(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    if (!step) {
	      step = stop < start ? -1 : 1;
	    }
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  }
	
	  // Chunk a single array into multiple arrays, each containing `count` or fewer
	  // items.
	  function chunk(array, count) {
	    if (count == null || count < 1) return [];
	    var result = [];
	    var i = 0, length = array.length;
	    while (i < length) {
	      result.push(slice.call(array, i, i += count));
	    }
	    return result;
	  }
	
	  // Helper function to continue chaining intermediate results.
	  function chainResult(instance, obj) {
	    return instance._chain ? _$1(obj).chain() : obj;
	  }
	
	  // Add your own custom functions to the Underscore object.
	  function mixin(obj) {
	    each(functions(obj), function(name) {
	      var func = _$1[name] = obj[name];
	      _$1.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return chainResult(this, func.apply(_$1, args));
	      };
	    });
	    return _$1;
	  }
	
	  // Add all mutator `Array` functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) {
	        method.apply(obj, arguments);
	        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
	          delete obj[0];
	        }
	      }
	      return chainResult(this, obj);
	    };
	  });
	
	  // Add all accessor `Array` functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) obj = method.apply(obj, arguments);
	      return chainResult(this, obj);
	    };
	  });
	
	  // Named Exports
	
	  var allExports = {
	    __proto__: null,
	    VERSION: VERSION,
	    restArguments: restArguments,
	    isObject: isObject,
	    isNull: isNull,
	    isUndefined: isUndefined,
	    isBoolean: isBoolean,
	    isElement: isElement,
	    isString: isString,
	    isNumber: isNumber,
	    isDate: isDate,
	    isRegExp: isRegExp,
	    isError: isError,
	    isSymbol: isSymbol,
	    isArrayBuffer: isArrayBuffer,
	    isDataView: isDataView$1,
	    isArray: isArray,
	    isFunction: isFunction$1,
	    isArguments: isArguments$1,
	    isFinite: isFinite$1,
	    isNaN: isNaN$1,
	    isTypedArray: isTypedArray$1,
	    isEmpty: isEmpty,
	    isMatch: isMatch,
	    isEqual: isEqual,
	    isMap: isMap,
	    isWeakMap: isWeakMap,
	    isSet: isSet,
	    isWeakSet: isWeakSet,
	    keys: keys,
	    allKeys: allKeys,
	    values: values,
	    pairs: pairs,
	    invert: invert,
	    functions: functions,
	    methods: functions,
	    extend: extend,
	    extendOwn: extendOwn,
	    assign: extendOwn,
	    defaults: defaults,
	    create: create,
	    clone: clone,
	    tap: tap,
	    get: get,
	    has: has,
	    mapObject: mapObject,
	    identity: identity,
	    constant: constant,
	    noop: noop,
	    toPath: toPath$1,
	    property: property,
	    propertyOf: propertyOf,
	    matcher: matcher,
	    matches: matcher,
	    times: times,
	    random: random,
	    now: now,
	    escape: _escape,
	    unescape: _unescape,
	    templateSettings: templateSettings,
	    template: template,
	    result: result,
	    uniqueId: uniqueId,
	    chain: chain,
	    iteratee: iteratee,
	    partial: partial,
	    bind: bind,
	    bindAll: bindAll,
	    memoize: memoize,
	    delay: delay,
	    defer: defer,
	    throttle: throttle,
	    debounce: debounce,
	    wrap: wrap,
	    negate: negate,
	    compose: compose,
	    after: after,
	    before: before,
	    once: once,
	    findKey: findKey,
	    findIndex: findIndex,
	    findLastIndex: findLastIndex,
	    sortedIndex: sortedIndex,
	    indexOf: indexOf,
	    lastIndexOf: lastIndexOf,
	    find: find,
	    detect: find,
	    findWhere: findWhere,
	    each: each,
	    forEach: each,
	    map: map,
	    collect: map,
	    reduce: reduce,
	    foldl: reduce,
	    inject: reduce,
	    reduceRight: reduceRight,
	    foldr: reduceRight,
	    filter: filter,
	    select: filter,
	    reject: reject,
	    every: every,
	    all: every,
	    some: some,
	    any: some,
	    contains: contains,
	    includes: contains,
	    include: contains,
	    invoke: invoke,
	    pluck: pluck,
	    where: where,
	    max: max,
	    min: min,
	    shuffle: shuffle,
	    sample: sample,
	    sortBy: sortBy,
	    groupBy: groupBy,
	    indexBy: indexBy,
	    countBy: countBy,
	    partition: partition,
	    toArray: toArray,
	    size: size,
	    pick: pick,
	    omit: omit,
	    first: first,
	    head: first,
	    take: first,
	    initial: initial,
	    last: last,
	    rest: rest,
	    tail: rest,
	    drop: rest,
	    compact: compact,
	    flatten: flatten,
	    without: without,
	    uniq: uniq,
	    unique: uniq,
	    union: union,
	    intersection: intersection,
	    difference: difference,
	    unzip: unzip,
	    transpose: unzip,
	    zip: zip,
	    object: object,
	    range: range,
	    chunk: chunk,
	    mixin: mixin,
	    'default': _$1
	  };
	
	  // Default Export
	
	  // Add all of the Underscore functions to the wrapper object.
	  var _ = mixin(allExports);
	  // Legacy Node.js API.
	  _._ = _;
	
	  return _;
	
	})));
	//# sourceMappingURL=underscore-umd.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 8 */
[2098, 1833],
/* 9 */,
/* 10 */,
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.7.1
	 * https://jquery.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2023-08-28T13:37Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket trac-14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var version = "3.7.1",
	
		rhtmlSuffix = /HTML$/i,
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
	
		// Retrieve the text value of an array of DOM nodes
		text: function( elem ) {
			var node,
				ret = "",
				i = 0,
				nodeType = elem.nodeType;
	
			if ( !nodeType ) {
	
				// If no nodeType, this is expected to be an array
				while ( ( node = elem[ i++ ] ) ) {
	
					// Do not traverse comment nodes
					ret += jQuery.text( node );
				}
			}
			if ( nodeType === 1 || nodeType === 11 ) {
				return elem.textContent;
			}
			if ( nodeType === 9 ) {
				return elem.documentElement.textContent;
			}
			if ( nodeType === 3 || nodeType === 4 ) {
				return elem.nodeValue;
			}
	
			// Do not include comment or processing instruction nodes
	
			return ret;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		isXMLDoc: function( elem ) {
			var namespace = elem && elem.namespaceURI,
				docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
			// Assume HTML when documentElement doesn't yet exist, such as inside
			// document fragments.
			return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var pop = arr.pop;
	
	
	var sort = arr.sort;
	
	
	var splice = arr.splice;
	
	
	var whitespace = "[\\x20\\t\\r\\n\\f]";
	
	
	var rtrimCSS = new RegExp(
		"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
		"g"
	);
	
	
	
	
	// Note: an element does not contain itself
	jQuery.contains = function( a, b ) {
		var bup = b && b.parentNode;
	
		return a === bup || !!( bup && bup.nodeType === 1 && (
	
			// Support: IE 9 - 11+
			// IE doesn't have `contains` on SVG.
			a.contains ?
				a.contains( bup ) :
				a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
		) );
	};
	
	
	
	
	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
	
	function fcssescape( ch, asCodePoint ) {
		if ( asCodePoint ) {
	
			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}
	
			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}
	
		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	}
	
	jQuery.escapeSelector = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	
	
	
	var preferredDoc = document,
		pushNative = push;
	
	( function() {
	
	var i,
		Expr,
		outermostContext,
		sortInput,
		hasDuplicate,
		push = pushNative,
	
		// Local document vars
		document,
		documentElement,
		documentIsHTML,
		rbuggyQSA,
		matches,
	
		// Instance-specific data
		expando = jQuery.expando,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
			"loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
			whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			ID: new RegExp( "^#(" + identifier + ")" ),
			CLASS: new RegExp( "^\\.(" + identifier + ")" ),
			TAG: new RegExp( "^(" + identifier + "|[*])" ),
			ATTR: new RegExp( "^" + attributes ),
			PSEUDO: new RegExp( "^" + pseudos ),
			CHILD: new RegExp(
				"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
					whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
					whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			bool: new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			needsContext: new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			if ( nonHex ) {
	
				// Strip the backslash prefix from a non-hex escape sequence
				return nonHex;
			}
	
			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			return high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes; see `setDocument`.
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE/Edge.
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && nodeName( elem, "fieldset" );
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android <=4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = {
			apply: function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			},
			call: function( target ) {
				pushNative.apply( target, slice.call( arguments, 1 ) );
			}
		};
	}
	
	function find( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE 9 only
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									push.call( results, elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								find.contains( context, elem ) &&
								elem.id === m ) {
	
								push.call( results, elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( !nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when
						// strict-comparing two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( newContext != context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = jQuery.escapeSelector( nid );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties
			// (see https://github.com/jquery/sizzle/issues/157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by jQuery selector module
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			return nodeName( elem, "input" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
				elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11+
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a jQuery selector context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [node] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	function setDocument( node ) {
		var subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		documentElement = document.documentElement;
		documentIsHTML = !jQuery.isXMLDoc( document );
	
		// Support: iOS 7 only, IE 9 - 11+
		// Older browsers didn't support unprefixed `matches`.
		matches = documentElement.matches ||
			documentElement.webkitMatchesSelector ||
			documentElement.msMatchesSelector;
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors
		// (see trac-13936).
		// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
		// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
		if ( documentElement.msMatchesSelector &&
	
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 9 - 11+, Edge 12 - 18+
			subWindow.addEventListener( "unload", unloadHandler );
		}
	
		// Support: IE <10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			documentElement.appendChild( el ).id = jQuery.expando;
			return !document.getElementsByName ||
				!document.getElementsByName( jQuery.expando ).length;
		} );
	
		// Support: IE 9 only
		// Check to see if it's possible to do matchesSelector
		// on a disconnected node.
		support.disconnectedMatch = assert( function( el ) {
			return matches.call( el, "*" );
		} );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// IE/Edge don't support the :scope pseudo-class.
		support.scope = assert( function() {
			return document.querySelectorAll( ":scope" );
		} );
	
		// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
		// Make sure the `:has()` argument is parsed unforgivingly.
		// We include `*` in the test to detect buggy implementations that are
		// _selectively_ forgiving (specifically when the list includes at least
		// one valid selector).
		// Note that we treat complete lack of support for `:has()` as if it were
		// spec-compliant support, which is fine because use of `:has()` in such
		// environments will fail in the qSA path and fall back to jQuery traversal
		// anyway.
		support.cssHas = assert( function() {
			try {
				document.querySelector( ":has(*,:jqfake)" );
				return false;
			} catch ( e ) {
				return true;
			}
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter.ID = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter.ID =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find.TAG = function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );
	
			// DocumentFragment nodes don't have gEBTN
			} else {
				return context.querySelectorAll( tag );
			}
		};
	
		// Class
		Expr.find.CLASS = function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		rbuggyQSA = [];
	
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {
	
			var input;
	
			documentElement.appendChild( el ).innerHTML =
				"<a id='" + expando + "' href='' disabled='disabled'></a>" +
				"<select id='" + expando + "-\r\\' disabled='disabled'>" +
				"<option selected=''></option></select>";
	
			// Support: iOS <=7 - 8 only
			// Boolean attributes and "value" are not treated correctly in some XML documents
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}
	
			// Support: iOS <=7 - 8 only
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}
	
			// Support: iOS 8 only
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}
	
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}
	
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );
	
			// Support: IE 9 - 11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			documentElement.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}
	
			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}
		} );
	
		if ( !support.cssHas ) {
	
			// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
			// Our regular `try-catch` mechanism fails to detect natively-unsupported
			// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
			// in browsers that parse the `:has()` argument as a forgiving selector list.
			// https://drafts.csswg.org/selectors/#relational now requires the argument
			// to be parsed unforgivingly, but browsers have not yet fully adjusted.
			rbuggyQSA.push( ":has" );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a === document || a.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b === document || b.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		};
	
		return document;
	}
	
	find.matches = function( expr, elements ) {
		return find( expr, null, null, elements );
	};
	
	find.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return find( expr, document, null, [ elem ] ).length > 0;
	};
	
	find.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return jQuery.contains( context, elem );
	};
	
	
	find.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (see trac-13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		if ( val !== undefined ) {
			return val;
		}
	
		return elem.getAttribute( name );
	};
	
	find.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	jQuery.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		//
		// Support: Android <=4.0+
		// Testing for detecting duplicates is unpredictable so instead assume we can't
		// depend on duplicate detection in all browsers without a stable sort.
		hasDuplicate = !support.sortStable;
		sortInput = !support.sortStable && slice.call( results, 0 );
		sort.call( results, sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				splice.call( results, duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	jQuery.fn.uniqueSort = function() {
		return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
	};
	
	Expr = jQuery.expr = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			ATTR: function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
					.replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			CHILD: function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						find.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
					);
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					find.error( match[ 0 ] );
				}
	
				return match;
			},
	
			PSEUDO: function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			TAG: function( nodeNameSelector ) {
				var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return nodeName( elem, expectedNodeName );
					};
			},
	
			CLASS: function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace + ")" + className +
						"(" + whitespace + "|$)" ) ) &&
					classCache( className, function( elem ) {
						return pattern.test(
							typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
						);
					} );
			},
	
			ATTR: function( name, operator, check ) {
				return function( elem ) {
					var result = find.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					if ( operator === "=" ) {
						return result === check;
					}
					if ( operator === "!=" ) {
						return result !== check;
					}
					if ( operator === "^=" ) {
						return check && result.indexOf( check ) === 0;
					}
					if ( operator === "*=" ) {
						return check && result.indexOf( check ) > -1;
					}
					if ( operator === "$=" ) {
						return check && result.slice( -check.length ) === check;
					}
					if ( operator === "~=" ) {
						return ( " " + result.replace( rwhitespace, " " ) + " " )
							.indexOf( check ) > -1;
					}
					if ( operator === "|=" ) {
						return result === check || result.slice( 0, check.length + 1 ) === check + "-";
					}
	
					return false;
				};
			},
	
			CHILD: function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || ( parent[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
									outerCache = elem[ expando ] || ( elem[ expando ] = {} );
									cache = outerCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
												outerCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			PSEUDO: function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// https://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						find.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as jQuery does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf.call( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			not: markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrimCSS, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element
						// (see https://github.com/jquery/sizzle/issues/299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			has: markFunction( function( selector ) {
				return function( elem ) {
					return find( selector, elem ).length > 0;
				};
			} ),
	
			contains: markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// https://www.w3.org/TR/selectors/#lang-pseudo
			lang: markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					find.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			target: function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			root: function( elem ) {
				return elem === documentElement;
			},
	
			focus: function( elem ) {
				return elem === safeActiveElement() &&
					document.hasFocus() &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			enabled: createDisabledPseudo( false ),
			disabled: createDisabledPseudo( true ),
	
			checked: function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				return ( nodeName( elem, "input" ) && !!elem.checked ) ||
					( nodeName( elem, "option" ) && !!elem.selected );
			},
	
			selected: function( elem ) {
	
				// Support: IE <=11+
				// Accessing the selectedIndex property
				// forces the browser to treat the default option as
				// selected when in an optgroup.
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			empty: function( elem ) {
	
				// https://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			parent: function( elem ) {
				return !Expr.pseudos.empty( elem );
			},
	
			// Element/input types
			header: function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			input: function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			button: function( elem ) {
				return nodeName( elem, "input" ) && elem.type === "button" ||
					nodeName( elem, "button" );
			},
	
			text: function( elem ) {
				var attr;
				return nodeName( elem, "input" ) && elem.type === "text" &&
	
					// Support: IE <10 only
					// New HTML5 attribute values (e.g., "search") appear
					// with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			first: createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			last: createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			even: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			odd: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i;
	
				if ( argument < 0 ) {
					i = argument + length;
				} else if ( argument > length ) {
					i = length;
				} else {
					i = argument;
				}
	
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos.nth = Expr.pseudos.eq;
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	function tokenize( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrimCSS, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		if ( parseOnly ) {
			return soFar.length;
		}
	
		return soFar ?
			find.error( selector ) :
	
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
	}
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							if ( skip && nodeName( elem, skip ) ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = outerCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			find( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem, matcherOut,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed ||
					multipleContexts( selector || "*",
						context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems;
	
			if ( matcher ) {
	
				// If we have a postFinder, or filtered seed, or non-seed postFilter
				// or preexisting results,
				matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
					// ...intermediate processing is necessary
					[] :
	
					// ...otherwise use results directly
					results;
	
				// Find primary matches
				matcher( matcherIn, matcherOut, context, xml );
			} else {
				matcherOut = matcherIn;
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf.call( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element
				// (see https://github.com/jquery/sizzle/issues/299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 )
								.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrimCSS, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find.TAG( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: iOS <=7 - 9 only
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
				// elements by id. (see trac-14142)
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								push.call( results, elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						jQuery.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	function compile( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	}
	
	/**
	 * A low-level selection function that works with jQuery's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with jQuery selector compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	function select( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find.ID(
					token.matches[ 0 ].replace( runescape, funescape ),
					context
				) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) &&
							testContext( context.parentNode ) || context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	}
	
	// One-time assignments
	
	// Support: Android <=4.0 - 4.1+
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Android <=4.0 - 4.1+
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	jQuery.find = find;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.unique = jQuery.uniqueSort;
	
	// These have always been private, but they used to be documented as part of
	// Sizzle so let's maintain them for now for backwards compatibility purposes.
	find.compile = compile;
	find.select = select;
	find.setDocument = setDocument;
	find.tokenize = tokenize;
	
	find.escape = jQuery.escapeSelector;
	find.getText = jQuery.text;
	find.isXML = jQuery.isXMLDoc;
	find.selectors = jQuery.expr;
	find.support = jQuery.support;
	find.uniqueSort = jQuery.uniqueSort;
	
		/* eslint-enable */
	
	} )();
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
		// Strict HTML recognition (trac-11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to jQuery#find
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.error );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the error, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getErrorHook ) {
										process.error = jQuery.Deferred.getErrorHook();
	
									// The deprecated alias of the above. While the name suggests
									// returning the stack, not an error instance, jQuery just passes
									// it directly to `console.warn` so both will work; an instance
									// just better cooperates with source maps.
									} else if ( jQuery.Deferred.getStackHook ) {
										process.error = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
	// captured before the async barrier to get the original error cause
	// which may otherwise be hidden.
	jQuery.Deferred.exceptionHook = function( error, asyncError ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message,
				error.stack, asyncError );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See trac-6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (trac-9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see trac-8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (trac-14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (trac-11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (trac-14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (trac-13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (trac-12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (trac-13208)
					// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (trac-13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", true );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, isSetup ) {
	
		// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
		if ( !isSetup ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					if ( !saved ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						this[ type ]();
						result = dataPriv.get( this, type );
						dataPriv.set( this, type, false );
	
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							return result;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering
					// the native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved ) {
	
					// ...and capture the result
					dataPriv.set( this, type, jQuery.event.trigger(
						saved[ 0 ],
						saved.slice( 1 ),
						this
					) );
	
					// Abort handling of the native event by all jQuery handlers while allowing
					// native handlers on the same element to run. On target, this is achieved
					// by stopping immediate propagation just on the jQuery event. However,
					// the native event is re-wrapped by a jQuery one on each level of the
					// propagation so the only way to stop it for jQuery is to stop it for
					// everyone via native `stopPropagation()`. This is not a problem for
					// focus/blur which don't bubble, but it does also stop click on checkboxes
					// and radios. We accept this limitation.
					event.stopPropagation();
					event.isImmediatePropagationStopped = returnTrue;
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (trac-504, trac-13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	
		function focusMappedHandler( nativeEvent ) {
			if ( document.documentMode ) {
	
				// Support: IE 11+
				// Attach a single focusin/focusout handler on the document while someone wants
				// focus/blur. This is because the former are synchronous in IE while the latter
				// are async. In other browsers, all those handlers are invoked synchronously.
	
				// `handle` from private data would already wrap the event, but we need
				// to change the `type` here.
				var handle = dataPriv.get( this, "handle" ),
					event = jQuery.event.fix( nativeEvent );
				event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
				event.isSimulated = true;
	
				// First, handle focusin/focusout
				handle( nativeEvent );
	
				// ...then, handle focus/blur
				//
				// focus/blur don't bubble while focusin/focusout do; simulate the former by only
				// invoking the handler at the lower level.
				if ( event.target === event.currentTarget ) {
	
					// The setup part calls `leverageNative`, which, in turn, calls
					// `jQuery.event.add`, so event handle will already have been set
					// by this point.
					handle( event );
				}
			} else {
	
				// For non-IE browsers, attach a single capturing handler on the document
				// while someone wants focusin/focusout.
				jQuery.event.simulate( delegateType, nativeEvent.target,
					jQuery.event.fix( nativeEvent ) );
			}
		}
	
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				var attaches;
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, true );
	
				if ( document.documentMode ) {
	
					// Support: IE 9 - 11+
					// We use the same native handler for focusin & focus (and focusout & blur)
					// so we need to coordinate setup & teardown parts between those events.
					// Use `delegateType` as the key as `type` is already used by `leverageNative`.
					attaches = dataPriv.get( this, delegateType );
					if ( !attaches ) {
						this.addEventListener( delegateType, focusMappedHandler );
					}
					dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
				} else {
	
					// Return false to allow normal processing in the caller
					return false;
				}
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			teardown: function() {
				var attaches;
	
				if ( document.documentMode ) {
					attaches = dataPriv.get( this, delegateType ) - 1;
					if ( !attaches ) {
						this.removeEventListener( delegateType, focusMappedHandler );
						dataPriv.remove( this, delegateType );
					} else {
						dataPriv.set( this, delegateType, attaches );
					}
				} else {
	
					// Return false to indicate standard teardown should be applied
					return false;
				}
			},
	
			// Suppress native focus or blur if we're currently inside
			// a leveraged native-event stack
			_default: function( event ) {
				return dataPriv.get( event.target, type );
			},
	
			delegateType: delegateType
		};
	
		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		//
		// Support: IE 9 - 11+
		// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
		// attach a single handler for both events in IE.
		jQuery.event.special[ delegateType ] = {
			setup: function() {
	
				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType );
	
				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.addEventListener( delegateType, focusMappedHandler );
					} else {
						doc.addEventListener( type, focusMappedHandler, true );
					}
				}
				dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType ) - 1;
	
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.removeEventListener( delegateType, focusMappedHandler );
					} else {
						doc.removeEventListener( type, focusMappedHandler, true );
					}
					dataPriv.remove( dataHolder, delegateType );
				} else {
					dataPriv.set( dataHolder, delegateType, attaches );
				}
			}
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	
		rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (trac-8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Re-enable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
	
								// Unwrap a CDATA section containing script contents. This shouldn't be
								// needed as in XML documents they're already not visible when
								// inspecting element contents and in HTML documents they have no
								// meaning but we're preserving that logic for backwards compatibility.
								// This will be removed completely in 4.0. See gh-4904.
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew jQuery#find here for performance reasons:
				// https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var rcustomProp = /^--/;
	
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (trac-8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "box-sizing:content-box;border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is `display: block`
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			isCustomProp = rcustomProp.test( name ),
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, trac-12537)
		//   .css('--customProperty) (gh-3144)
		if ( computed ) {
	
			// Support: IE <=9 - 11+
			// IE only supports `"float"` in `getPropertyValue`; in computed styles
			// it's only available as `"cssFloat"`. We no longer modify properties
			// sent to `.css()` apart from camelCasing, so we need to check both.
			// Normally, this would create difference in behavior: if
			// `getPropertyValue` returns an empty string, the value returned
			// by `.css()` would be `undefined`. This is usually the case for
			// disconnected elements. However, in IE even disconnected elements
			// with no styles return `"none"` for `getPropertyValue( "float" )`
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( isCustomProp && ret ) {
	
				// Support: Firefox 105+, Chrome <=105+
				// Spec requires trimming whitespace for custom properties (gh-4926).
				// Firefox only trims leading whitespace. Chrome just collapses
				// both leading & trailing whitespace to a single space.
				//
				// Fall back to `undefined` if empty string returned.
				// This collapses a missing definition with property defined
				// and set to an empty string but there's no standard API
				// allowing us to differentiate them without a performance penalty
				// and returning `undefined` aligns with older jQuery.
				//
				// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
				// as whitespace while CSS does not, but this is not a problem
				// because CSS preprocessing replaces them with U+000A LINE FEED
				// (which *is* CSS whitespace)
				// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
				ret = ret.replace( rtrimCSS, "$1" ) || undefined;
			}
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0,
			marginDelta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			// Count margin delta separately to only add it after scroll gutter adjustment.
			// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
			if ( box === "margin" ) {
				marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta + marginDelta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			animationIterationCount: true,
			aspectRatio: true,
			borderImageSlice: true,
			columnCount: true,
			flexGrow: true,
			flexShrink: true,
			fontWeight: true,
			gridArea: true,
			gridColumn: true,
			gridColumnEnd: true,
			gridColumnStart: true,
			gridRow: true,
			gridRowEnd: true,
			gridRowStart: true,
			lineHeight: true,
			opacity: true,
			order: true,
			orphans: true,
			scale: true,
			widows: true,
			zIndex: true,
			zoom: true,
	
			// SVG-related
			fillOpacity: true,
			floodOpacity: true,
			stopOpacity: true,
			strokeMiterlimit: true,
			strokeOpacity: true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (trac-7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug trac-9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (trac-7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// Use proper attribute retrieval (trac-12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
							if ( cur.indexOf( " " + className + " " ) < 0 ) {
								cur += className + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
	
					// This expression is here for better compressibility (see addClass)
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
	
							// Remove *all* instances
							while ( cur.indexOf( " " + className + " " ) > -1 ) {
								cur = cur.replace( " " + className + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var classNames, className, i, self,
				type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			classNames = classesToArray( value );
	
			return this.each( function() {
				if ( isValidValue ) {
	
					// Toggle individual class names
					self = jQuery( this );
	
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (trac-14686, trac-14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (trac-2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (trac-9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (trac-6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// trac-7653, trac-8125, trac-8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes trac-9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (trac-10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket trac-12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// trac-9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (trac-11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// trac-1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see trac-8605, trac-14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// trac-14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this
				.on( "mouseenter", fnOver )
				.on( "mouseleave", fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	// Require that the "whitespace run" starts from a non-whitespace
	// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
	var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "$1" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (trac-13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	// Backbone.Validation v0.11.5
	//
	// Copyright (c) 2011-2015 Thomas Pedersen
	// Distributed under MIT License
	//
	// Documentation and full license available at:
	// http://thedersen.com/projects/backbone-validation
	(function (factory) {
	  if (true) {
	    module.exports = factory(__webpack_require__(4), __webpack_require__(1));
	  } else if (typeof define === 'function' && define.amd) {
	    define(['backbone', 'underscore'], factory);
	  }
	}(function (Backbone, _) {
	  Backbone.Validation = (function(_){
	    'use strict';
	  
	    // Default options
	    // ---------------
	  
	    var defaultOptions = {
	      forceUpdate: false,
	      selector: 'name',
	      labelFormatter: 'sentenceCase',
	      valid: Function.prototype,
	      invalid: Function.prototype
	    };
	  
	  
	    // Helper functions
	    // ----------------
	  
	    // Formatting functions used for formatting error messages
	    var formatFunctions = {
	      // Uses the configured label formatter to format the attribute name
	      // to make it more readable for the user
	      formatLabel: function(attrName, model) {
	        return defaultLabelFormatters[defaultOptions.labelFormatter](attrName, model);
	      },
	  
	      // Replaces nummeric placeholders like {0} in a string with arguments
	      // passed to the function
	      format: function() {
	        var args = Array.prototype.slice.call(arguments),
	            text = args.shift();
	        return text.replace(/\{(\d+)\}/g, function(match, number) {
	          return typeof args[number] !== 'undefined' ? args[number] : match;
	        });
	      }
	    };
	  
	    // Flattens an object
	    // eg:
	    //
	    //     var o = {
	    //       owner: {
	    //         name: 'Backbone',
	    //         address: {
	    //           street: 'Street',
	    //           zip: 1234
	    //         }
	    //       }
	    //     };
	    //
	    // becomes:
	    //
	    //     var o = {
	    //       'owner': {
	    //         name: 'Backbone',
	    //         address: {
	    //           street: 'Street',
	    //           zip: 1234
	    //         }
	    //       },
	    //       'owner.name': 'Backbone',
	    //       'owner.address': {
	    //         street: 'Street',
	    //         zip: 1234
	    //       },
	    //       'owner.address.street': 'Street',
	    //       'owner.address.zip': 1234
	    //     };
	    // This may seem redundant, but it allows for maximum flexibility
	    // in validation rules.
	    var flatten = function (obj, into, prefix) {
	      into = into || {};
	      prefix = prefix || '';
	  
	      _.each(obj, function(val, key) {
	        if(obj.hasOwnProperty(key)) {
	          if (!!val && _.isArray(val)) {
	            _.forEach(val, function(v, k) {
	              flatten(v, into, prefix + key + '.' + k + '.');
	              into[prefix + key + '.' + k] = v;
	            });
	          } else if (!!val && typeof val === 'object' && val.constructor === Object) {
	            flatten(val, into, prefix + key + '.');
	          }
	  
	          // Register the current level object as well
	          into[prefix + key] = val;
	        }
	      });
	  
	      return into;
	    };
	  
	    // Validation
	    // ----------
	  
	    var Validation = (function(){
	  
	      // Returns an object with undefined properties for all
	      // attributes on the model that has defined one or more
	      // validation rules.
	      var getValidatedAttrs = function(model, attrs) {
	        attrs = attrs || _.keys(_.result(model, 'validation') || {});
	        return _.reduce(attrs, function(memo, key) {
	          memo[key] = void 0;
	          return memo;
	        }, {});
	      };
	  
	      // Returns an array with attributes passed through options
	      var getOptionsAttrs = function(options, view) {
	        var attrs = options.attributes;
	        if (_.isFunction(attrs)) {
	          attrs = attrs(view);
	        } else if (_.isString(attrs) && (_.isFunction(defaultAttributeLoaders[attrs]))) {
	          attrs = defaultAttributeLoaders[attrs](view);
	        }
	        if (_.isArray(attrs)) {
	          return attrs;
	        }
	      };
	  
	  
	      // Looks on the model for validations for a specified
	      // attribute. Returns an array of any validators defined,
	      // or an empty array if none is defined.
	      var getValidators = function(model, attr) {
	        var attrValidationSet = model.validation ? _.result(model, 'validation')[attr] || {} : {};
	  
	        // If the validator is a function or a string, wrap it in a function validator
	        if (_.isFunction(attrValidationSet) || _.isString(attrValidationSet)) {
	          attrValidationSet = {
	            fn: attrValidationSet
	          };
	        }
	  
	        // Stick the validator object into an array
	        if(!_.isArray(attrValidationSet)) {
	          attrValidationSet = [attrValidationSet];
	        }
	  
	        // Reduces the array of validators into a new array with objects
	        // with a validation method to call, the value to validate against
	        // and the specified error message, if any
	        return _.reduce(attrValidationSet, function(memo, attrValidation) {
	          _.each(_.without(_.keys(attrValidation), 'msg'), function(validator) {
	            memo.push({
	              fn: defaultValidators[validator],
	              val: attrValidation[validator],
	              msg: attrValidation.msg
	            });
	          });
	          return memo;
	        }, []);
	      };
	  
	      // Validates an attribute against all validators defined
	      // for that attribute. If one or more errors are found,
	      // the first error message is returned.
	      // If the attribute is valid, an empty string is returned.
	      var validateAttr = function(model, attr, value, computed) {
	        // Reduces the array of validators to an error message by
	        // applying all the validators and returning the first error
	        // message, if any.
	        return _.reduce(getValidators(model, attr), function(memo, validator){
	          // Pass the format functions plus the default
	          // validators as the context to the validator
	          var ctx = _.extend({}, formatFunctions, defaultValidators),
	              result = validator.fn.call(ctx, value, attr, validator.val, model, computed);
	  
	          if(result === false || memo === false) {
	            return false;
	          }
	          if (result && !memo) {
	            return _.result(validator, 'msg') || result;
	          }
	          return memo;
	        }, '');
	      };
	  
	      // Loops through the model's attributes and validates the specified attrs.
	      // Returns and object containing names of invalid attributes
	      // as well as error messages.
	      var validateModel = function(model, attrs, validatedAttrs) {
	        var error,
	            invalidAttrs = {},
	            isValid = true,
	            computed = _.clone(attrs);
	  
	        _.each(validatedAttrs, function(val, attr) {
	          error = validateAttr(model, attr, val, computed);
	          if (error) {
	            invalidAttrs[attr] = error;
	            isValid = false;
	          }
	        });
	  
	        return {
	          invalidAttrs: invalidAttrs,
	          isValid: isValid
	        };
	      };
	  
	      // Contains the methods that are mixed in on the model when binding
	      var mixin = function(view, options) {
	        return {
	  
	          // Check whether or not a value, or a hash of values
	          // passes validation without updating the model
	          preValidate: function(attr, value) {
	            var self = this,
	                result = {},
	                error;
	  
	            if(_.isObject(attr)){
	              _.each(attr, function(value, key) {
	                error = self.preValidate(key, value);
	                if(error){
	                  result[key] = error;
	                }
	              });
	  
	              return _.isEmpty(result) ? undefined : result;
	            }
	            else {
	              return validateAttr(this, attr, value, _.extend({}, this.attributes));
	            }
	          },
	  
	          // Check to see if an attribute, an array of attributes or the
	          // entire model is valid. Passing true will force a validation
	          // of the model.
	          isValid: function(option) {
	            var flattened, attrs, error, invalidAttrs;
	  
	            option = option || getOptionsAttrs(options, view);
	  
	            if(_.isString(option)){
	              attrs = [option];
	            } else if(_.isArray(option)) {
	              attrs = option;
	            }
	            if (attrs) {
	              flattened = flatten(this.attributes);
	              //Loop through all associated views
	              _.each(this.associatedViews, function(view) {
	                _.each(attrs, function (attr) {
	                  error = validateAttr(this, attr, flattened[attr], _.extend({}, this.attributes));
	                  if (error) {
	                    options.invalid(view, attr, error, options.selector);
	                    invalidAttrs = invalidAttrs || {};
	                    invalidAttrs[attr] = error;
	                  } else {
	                    options.valid(view, attr, options.selector);
	                  }
	                }, this);
	              }, this);
	            }
	  
	            if(option === true) {
	              invalidAttrs = this.validate();
	            }
	            if (invalidAttrs) {
	              this.trigger('invalid', this, invalidAttrs, {validationError: invalidAttrs});
	            }
	            return attrs ? !invalidAttrs : this.validation ? this._isValid : true;
	          },
	  
	          // This is called by Backbone when it needs to perform validation.
	          // You can call it manually without any parameters to validate the
	          // entire model.
	          validate: function(attrs, setOptions){
	            var model = this,
	                validateAll = !attrs,
	                opt = _.extend({}, options, setOptions),
	                validatedAttrs = getValidatedAttrs(model, getOptionsAttrs(options, view)),
	                allAttrs = _.extend({}, validatedAttrs, model.attributes, attrs),
	                flattened = flatten(allAttrs),
	                changedAttrs = attrs ? flatten(attrs) : flattened,
	                result = validateModel(model, allAttrs, _.pick(flattened, _.keys(validatedAttrs)));
	  
	            model._isValid = result.isValid;
	  
	            //After validation is performed, loop through all associated views
	            _.each(model.associatedViews, function(view){
	  
	              // After validation is performed, loop through all validated and changed attributes
	              // and call the valid and invalid callbacks so the view is updated.
	              _.each(validatedAttrs, function(val, attr){
	                  var invalid = result.invalidAttrs.hasOwnProperty(attr),
	                    changed = changedAttrs.hasOwnProperty(attr);
	  
	                  if(!invalid){
	                    opt.valid(view, attr, opt.selector);
	                  }
	                  if(invalid && (changed || validateAll)){
	                    opt.invalid(view, attr, result.invalidAttrs[attr], opt.selector);
	                  }
	              });
	            });
	  
	            // Trigger validated events.
	            // Need to defer this so the model is actually updated before
	            // the event is triggered.
	            _.defer(function() {
	              model.trigger('validated', model._isValid, model, result.invalidAttrs);
	              model.trigger('validated:' + (model._isValid ? 'valid' : 'invalid'), model, result.invalidAttrs);
	            });
	  
	            // Return any error messages to Backbone, unless the forceUpdate flag is set.
	            // Then we do not return anything and fools Backbone to believe the validation was
	            // a success. That way Backbone will update the model regardless.
	            if (!opt.forceUpdate && _.intersection(_.keys(result.invalidAttrs), _.keys(changedAttrs)).length > 0) {
	              return result.invalidAttrs;
	            }
	          }
	        };
	      };
	  
	      // Helper to mix in validation on a model. Stores the view in the associated views array.
	      var bindModel = function(view, model, options) {
	        if (model.associatedViews) {
	          model.associatedViews.push(view);
	        } else {
	          model.associatedViews = [view];
	        }
	        _.extend(model, mixin(view, options));
	      };
	  
	      // Removes view from associated views of the model or the methods
	      // added to a model if no view or single view provided
	      var unbindModel = function(model, view) {
	        if (view && model.associatedViews && model.associatedViews.length > 1){
	          model.associatedViews = _.without(model.associatedViews, view);
	        } else {
	          delete model.validate;
	          delete model.preValidate;
	          delete model.isValid;
	          delete model.associatedViews;
	        }
	      };
	  
	      // Mix in validation on a model whenever a model is
	      // added to a collection
	      var collectionAdd = function(model) {
	        bindModel(this.view, model, this.options);
	      };
	  
	      // Remove validation from a model whenever a model is
	      // removed from a collection
	      var collectionRemove = function(model) {
	        unbindModel(model);
	      };
	  
	      // Returns the public methods on Backbone.Validation
	      return {
	  
	        // Current version of the library
	        version: '0.11.3',
	  
	        // Called to configure the default options
	        configure: function(options) {
	          _.extend(defaultOptions, options);
	        },
	  
	        // Hooks up validation on a view with a model
	        // or collection
	        bind: function(view, options) {
	          options = _.extend({}, defaultOptions, defaultCallbacks, options);
	  
	          var model = options.model || view.model,
	              collection = options.collection || view.collection;
	  
	          if(typeof model === 'undefined' && typeof collection === 'undefined'){
	            throw 'Before you execute the binding your view must have a model or a collection.\n' +
	                  'See http://thedersen.com/projects/backbone-validation/#using-form-model-validation for more information.';
	          }
	  
	          if(model) {
	            bindModel(view, model, options);
	          }
	          else if(collection) {
	            collection.each(function(model){
	              bindModel(view, model, options);
	            });
	            collection.bind('add', collectionAdd, {view: view, options: options});
	            collection.bind('remove', collectionRemove);
	          }
	        },
	  
	        // Removes validation from a view with a model
	        // or collection
	        unbind: function(view, options) {
	          options = _.extend({}, options);
	          var model = options.model || view.model,
	              collection = options.collection || view.collection;
	  
	          if(model) {
	            unbindModel(model, view);
	          }
	          else if(collection) {
	            collection.each(function(model){
	              unbindModel(model, view);
	            });
	            collection.unbind('add', collectionAdd);
	            collection.unbind('remove', collectionRemove);
	          }
	        },
	  
	        // Used to extend the Backbone.Model.prototype
	        // with validation
	        mixin: mixin(null, defaultOptions)
	      };
	    }());
	  
	  
	    // Callbacks
	    // ---------
	  
	    var defaultCallbacks = Validation.callbacks = {
	  
	      // Gets called when a previously invalid field in the
	      // view becomes valid. Removes any error message.
	      // Should be overridden with custom functionality.
	      valid: function(view, attr, selector) {
	        view.$('[' + selector + '~="' + attr + '"]')
	            .removeClass('invalid')
	            .removeAttr('data-error');
	      },
	  
	      // Gets called when a field in the view becomes invalid.
	      // Adds a error message.
	      // Should be overridden with custom functionality.
	      invalid: function(view, attr, error, selector) {
	        view.$('[' + selector + '~="' + attr + '"]')
	            .addClass('invalid')
	            .attr('data-error', error);
	      }
	    };
	  
	  
	    // Patterns
	    // --------
	  
	    var defaultPatterns = Validation.patterns = {
	      // Matches any digit(s) (i.e. 0-9)
	      digits: /^\d+$/,
	  
	      // Matches any number (e.g. 100.000)
	      number: /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/,
	  
	      // Matches a valid email address (e.g. mail@example.com)
	      email: /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i,
	  
	      // Mathes any valid url (e.g. http://www.xample.com)
	      url: /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
	    };
	  
	  
	    // Error messages
	    // --------------
	  
	    // Error message for the build in validators.
	    // {x} gets swapped out with arguments form the validator.
	    var defaultMessages = Validation.messages = {
	      required: '{0} is required',
	      acceptance: '{0} must be accepted',
	      min: '{0} must be greater than or equal to {1}',
	      max: '{0} must be less than or equal to {1}',
	      range: '{0} must be between {1} and {2}',
	      length: '{0} must be {1} characters',
	      minLength: '{0} must be at least {1} characters',
	      maxLength: '{0} must be at most {1} characters',
	      rangeLength: '{0} must be between {1} and {2} characters',
	      oneOf: '{0} must be one of: {1}',
	      equalTo: '{0} must be the same as {1}',
	      digits: '{0} must only contain digits',
	      number: '{0} must be a number',
	      email: '{0} must be a valid email',
	      url: '{0} must be a valid url',
	      inlinePattern: '{0} is invalid'
	    };
	  
	    // Label formatters
	    // ----------------
	  
	    // Label formatters are used to convert the attribute name
	    // to a more human friendly label when using the built in
	    // error messages.
	    // Configure which one to use with a call to
	    //
	    //     Backbone.Validation.configure({
	    //       labelFormatter: 'label'
	    //     });
	    var defaultLabelFormatters = Validation.labelFormatters = {
	  
	      // Returns the attribute name with applying any formatting
	      none: function(attrName) {
	        return attrName;
	      },
	  
	      // Converts attributeName or attribute_name to Attribute name
	      sentenceCase: function(attrName) {
	        return attrName.replace(/(?:^\w|[A-Z]|\b\w)/g, function(match, index) {
	          return index === 0 ? match.toUpperCase() : ' ' + match.toLowerCase();
	        }).replace(/_/g, ' ');
	      },
	  
	      // Looks for a label configured on the model and returns it
	      //
	      //      var Model = Backbone.Model.extend({
	      //        validation: {
	      //          someAttribute: {
	      //            required: true
	      //          }
	      //        },
	      //
	      //        labels: {
	      //          someAttribute: 'Custom label'
	      //        }
	      //      });
	      label: function(attrName, model) {
	        return (model.labels && model.labels[attrName]) || defaultLabelFormatters.sentenceCase(attrName, model);
	      }
	    };
	  
	    // AttributeLoaders
	  
	    var defaultAttributeLoaders = Validation.attributeLoaders = {
	      inputNames: function (view) {
	        var attrs = [];
	        if (view) {
	          view.$('form [name]').each(function () {
	            if (/^(?:input|select|textarea)$/i.test(this.nodeName) && this.name &&
	              this.type !== 'submit' && attrs.indexOf(this.name) === -1) {
	              attrs.push(this.name);
	            }
	          });
	        }
	        return attrs;
	      }
	    };
	  
	  
	    // Built in validators
	    // -------------------
	  
	    var defaultValidators = Validation.validators = (function(){
	      // Use native trim when defined
	      var trim = String.prototype.trim ?
	        function(text) {
	          return text === null ? '' : String.prototype.trim.call(text);
	        } :
	        function(text) {
	          var trimLeft = /^\s+/,
	              trimRight = /\s+$/;
	  
	          return text === null ? '' : text.toString().replace(trimLeft, '').replace(trimRight, '');
	        };
	  
	      // Determines whether or not a value is a number
	      var isNumber = function(value){
	        return _.isNumber(value) || (_.isString(value) && value.match(defaultPatterns.number));
	      };
	  
	      // Determines whether or not a value is empty
	      var hasValue = function(value) {
	        return !(_.isNull(value) || _.isUndefined(value) || (_.isString(value) && trim(value) === '') || (_.isArray(value) && _.isEmpty(value)));
	      };
	  
	      return {
	        // Function validator
	        // Lets you implement a custom function used for validation
	        fn: function(value, attr, fn, model, computed) {
	          if(_.isString(fn)){
	            fn = model[fn];
	          }
	          return fn.call(model, value, attr, computed);
	        },
	  
	        // Required validator
	        // Validates if the attribute is required or not
	        // This can be specified as either a boolean value or a function that returns a boolean value
	        required: function(value, attr, required, model, computed) {
	          var isRequired = _.isFunction(required) ? required.call(model, value, attr, computed) : required;
	          if(!isRequired && !hasValue(value)) {
	            return false; // overrides all other validators
	          }
	          if (isRequired && !hasValue(value)) {
	            return this.format(defaultMessages.required, this.formatLabel(attr, model));
	          }
	        },
	  
	        // Acceptance validator
	        // Validates that something has to be accepted, e.g. terms of use
	        // `true` or 'true' are valid
	        acceptance: function(value, attr, accept, model) {
	          if(value !== 'true' && (!_.isBoolean(value) || value === false)) {
	            return this.format(defaultMessages.acceptance, this.formatLabel(attr, model));
	          }
	        },
	  
	        // Min validator
	        // Validates that the value has to be a number and equal to or greater than
	        // the min value specified
	        min: function(value, attr, minValue, model) {
	          if (!isNumber(value) || value < minValue) {
	            return this.format(defaultMessages.min, this.formatLabel(attr, model), minValue);
	          }
	        },
	  
	        // Max validator
	        // Validates that the value has to be a number and equal to or less than
	        // the max value specified
	        max: function(value, attr, maxValue, model) {
	          if (!isNumber(value) || value > maxValue) {
	            return this.format(defaultMessages.max, this.formatLabel(attr, model), maxValue);
	          }
	        },
	  
	        // Range validator
	        // Validates that the value has to be a number and equal to or between
	        // the two numbers specified
	        range: function(value, attr, range, model) {
	          if(!isNumber(value) || value < range[0] || value > range[1]) {
	            return this.format(defaultMessages.range, this.formatLabel(attr, model), range[0], range[1]);
	          }
	        },
	  
	        // Length validator
	        // Validates that the value has to be a string with length equal to
	        // the length value specified
	        length: function(value, attr, length, model) {
	          if (!_.isString(value) || value.length !== length) {
	            return this.format(defaultMessages.length, this.formatLabel(attr, model), length);
	          }
	        },
	  
	        // Min length validator
	        // Validates that the value has to be a string with length equal to or greater than
	        // the min length value specified
	        minLength: function(value, attr, minLength, model) {
	          if (!_.isString(value) || value.length < minLength) {
	            return this.format(defaultMessages.minLength, this.formatLabel(attr, model), minLength);
	          }
	        },
	  
	        // Max length validator
	        // Validates that the value has to be a string with length equal to or less than
	        // the max length value specified
	        maxLength: function(value, attr, maxLength, model) {
	          if (!_.isString(value) || value.length > maxLength) {
	            return this.format(defaultMessages.maxLength, this.formatLabel(attr, model), maxLength);
	          }
	        },
	  
	        // Range length validator
	        // Validates that the value has to be a string and equal to or between
	        // the two numbers specified
	        rangeLength: function(value, attr, range, model) {
	          if (!_.isString(value) || value.length < range[0] || value.length > range[1]) {
	            return this.format(defaultMessages.rangeLength, this.formatLabel(attr, model), range[0], range[1]);
	          }
	        },
	  
	        // One of validator
	        // Validates that the value has to be equal to one of the elements in
	        // the specified array. Case sensitive matching
	        oneOf: function(value, attr, values, model) {
	          if(!_.include(values, value)){
	            return this.format(defaultMessages.oneOf, this.formatLabel(attr, model), values.join(', '));
	          }
	        },
	  
	        // Equal to validator
	        // Validates that the value has to be equal to the value of the attribute
	        // with the name specified
	        equalTo: function(value, attr, equalTo, model, computed) {
	          if(value !== computed[equalTo]) {
	            return this.format(defaultMessages.equalTo, this.formatLabel(attr, model), this.formatLabel(equalTo, model));
	          }
	        },
	  
	        // Pattern validator
	        // Validates that the value has to match the pattern specified.
	        // Can be a regular expression or the name of one of the built in patterns
	        pattern: function(value, attr, pattern, model) {
	          if (!hasValue(value) || !value.toString().match(defaultPatterns[pattern] || pattern)) {
	            return this.format(defaultMessages[pattern] || defaultMessages.inlinePattern, this.formatLabel(attr, model), pattern);
	          }
	        }
	      };
	    }());
	  
	    // Set the correct context for all validators
	    // when used from within a method validator
	    _.each(defaultValidators, function(validator, key){
	      defaultValidators[key] = _.bind(defaultValidators[key], _.extend({}, formatFunctions, defaultValidators));
	    });
	  
	    return Validation;
	  }(_));
	  return Backbone.Validation;
	}));

/***/ },
/* 13 */,
/* 14 */,
/* 15 */
[1954, 4, 1595, 1597, 1594],
/* 16 */
[1959, 7, 18],
/* 17 */,
/* 18 */
11,
/* 19 */,
/* 20 */,
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1598), __esModule: true };

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e(__webpack_require__(8)):"function"==typeof define&&define.amd?define("moment-range",["moment"],e):"object"==typeof exports?exports["moment-range"]=e(require("moment")):t["moment-range"]=e(t.moment)}(this,function(t){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=3)}([function(t,e,n){"use strict";var r=n(5)();t.exports=function(t){return t!==r&&null!==t}},function(t,e,n){"use strict";t.exports=n(18)()?Symbol:n(20)},function(e,n){e.exports=t},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t){return t.range=function(e,n){var r=this;return"string"==typeof e&&y.hasOwnProperty(e)?new h(t(r).startOf(e),t(r).endOf(e)):new h(e,n)},t.rangeFromInterval=function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:t();if(t.isMoment(r)||(r=t(r)),!r.isValid())throw new Error("Invalid date.");var o=r.clone().add(n,e),i=[];return i.push(t.min(r,o)),i.push(t.max(r,o)),new h(i)},t.rangeFromISOString=function(e){var n=a(e),r=t.parseZone(n[0]),o=t.parseZone(n[1]);return new h(r,o)},t.parseZoneRange=t.rangeFromISOString,t.fn.range=t.range,t.range.constructor=h,t.isRange=function(t){return t instanceof h},t.fn.within=function(t){return t.contains(this.toDate())},t}function a(t){return t.split("/")}Object.defineProperty(e,"__esModule",{value:!0}),e.DateRange=void 0;var s=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var u,a=t[Symbol.iterator]();!(r=(u=a.next()).done)&&(n.push(u.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},f=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}();e.extendMoment=u;var l=n(2),v=r(l),d=n(1),p=r(d),y={year:!0,quarter:!0,month:!0,week:!0,day:!0,hour:!0,minute:!0,second:!0},h=e.DateRange=function(){function t(e,n){i(this,t);var r=e,o=n;if(1===arguments.length||void 0===n)if("object"===(void 0===e?"undefined":c(e))&&2===e.length){var u=s(e,2);r=u[0],o=u[1]}else if("string"==typeof e){var f=a(e),l=s(f,2);r=l[0],o=l[1]}this.start=r||0===r?(0,v.default)(r):(0,v.default)(-864e13),this.end=o||0===o?(0,v.default)(o):(0,v.default)(864e13)}return f(t,[{key:"adjacent",value:function(t){var e=this.start.isSame(t.end),n=this.end.isSame(t.start);return e&&t.start.valueOf()<=this.start.valueOf()||n&&t.end.valueOf()>=this.end.valueOf()}},{key:"add",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{adjacent:!1};return this.overlaps(t,e)?new this.constructor(v.default.min(this.start,t.start),v.default.max(this.end,t.end)):null}},{key:"by",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeEnd:!1,step:1},n=this;return o({},p.default.iterator,function(){var r=e.step||1,o=Math.abs(n.start.diff(n.end,t))/r,i=e.excludeEnd||!1,u=0;return e.hasOwnProperty("exclusive")&&(i=e.exclusive),{next:function(){var e=n.start.clone().add(u*r,t),a=i?!(u<o):!(u<=o);return u++,{done:a,value:a?void 0:e}}}})}},{key:"byRange",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeEnd:!1,step:1},n=this,r=e.step||1,i=this.valueOf()/t.valueOf()/r,u=Math.floor(i),a=e.excludeEnd||!1,s=0;return e.hasOwnProperty("exclusive")&&(a=e.exclusive),o({},p.default.iterator,function(){return u===1/0?{done:!0}:{next:function(){var e=(0,v.default)(n.start.valueOf()+t.valueOf()*s*r),o=u===i&&a?!(s<u):!(s<=u);return s++,{done:o,value:o?void 0:e}}}})}},{key:"center",value:function(){var t=this.start.valueOf()+this.diff()/2;return(0,v.default)(t)}},{key:"clone",value:function(){return new this.constructor(this.start.clone(),this.end.clone())}},{key:"contains",value:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeStart:!1,excludeEnd:!1},r=this.start.valueOf(),o=this.end.valueOf(),i=e.valueOf(),u=e.valueOf(),a=n.excludeStart||!1,s=n.excludeEnd||!1;n.hasOwnProperty("exclusive")&&(a=s=n.exclusive),e instanceof t&&(i=e.start.valueOf(),u=e.end.valueOf());var c=r<i||r<=i&&!a,f=o>u||o>=u&&!s;return c&&f}},{key:"diff",value:function(t,e){return this.end.diff(this.start,t,e)}},{key:"duration",value:function(t,e){return this.diff(t,e)}},{key:"intersect",value:function(t){var e=this.start.valueOf(),n=this.end.valueOf(),r=t.start.valueOf(),o=t.end.valueOf(),i=e==n,u=r==o;if(i){var a=e;if(a==r||a==o)return null;if(a>r&&a<o)return this.clone()}else if(u){var s=r;if(s==e||s==n)return null;if(s>e&&s<n)return new this.constructor(s,s)}return e<=r&&r<n&&n<o?new this.constructor(r,n):r<e&&e<o&&o<=n?new this.constructor(e,o):r<e&&e<=n&&n<o?this.clone():e<=r&&r<=o&&o<=n?new this.constructor(r,o):null}},{key:"isEqual",value:function(t){return this.start.isSame(t.start)&&this.end.isSame(t.end)}},{key:"isSame",value:function(t){return this.isEqual(t)}},{key:"overlaps",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{adjacent:!1},n=null!==this.intersect(t);return e.adjacent&&!n?this.adjacent(t):n}},{key:"reverseBy",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeStart:!1,step:1},n=this;return o({},p.default.iterator,function(){var r=e.step||1,o=Math.abs(n.start.diff(n.end,t))/r,i=e.excludeStart||!1,u=0;return e.hasOwnProperty("exclusive")&&(i=e.exclusive),{next:function(){var e=n.end.clone().subtract(u*r,t),a=i?!(u<o):!(u<=o);return u++,{done:a,value:a?void 0:e}}}})}},{key:"reverseByRange",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeStart:!1,step:1},n=this,r=e.step||1,i=this.valueOf()/t.valueOf()/r,u=Math.floor(i),a=e.excludeStart||!1,s=0;return e.hasOwnProperty("exclusive")&&(a=e.exclusive),o({},p.default.iterator,function(){return u===1/0?{done:!0}:{next:function(){var e=(0,v.default)(n.end.valueOf()-t.valueOf()*s*r),o=u===i&&a?!(s<u):!(s<=u);return s++,{done:o,value:o?void 0:e}}}})}},{key:"snapTo",value:function(t){var e=this.clone();return e.start.isSame((0,v.default)(-864e13))||(e.start=e.start.startOf(t)),e.end.isSame((0,v.default)(864e13))||(e.end=e.end.endOf(t)),e}},{key:"subtract",value:function(t){var e=this.start.valueOf(),n=this.end.valueOf(),r=t.start.valueOf(),o=t.end.valueOf();return null===this.intersect(t)?[this]:r<=e&&e<n&&n<=o?[]:r<=e&&e<o&&o<n?[new this.constructor(o,n)]:e<r&&r<n&&n<=o?[new this.constructor(e,r)]:e<r&&r<o&&o<n?[new this.constructor(e,r),new this.constructor(o,n)]:e<r&&r<n&&o<n?[new this.constructor(e,r),new this.constructor(r,n)]:[]}},{key:"toDate",value:function(){return[this.start.toDate(),this.end.toDate()]}},{key:"toString",value:function(){return this.start.format()+"/"+this.end.format()}},{key:"valueOf",value:function(){return this.end.valueOf()-this.start.valueOf()}}]),t}()},function(t,e,n){"use strict";var r,o=n(6),i=n(13),u=n(9),a=n(15);r=t.exports=function(t,e){var n,r,u,s,c;return arguments.length<2||"string"!=typeof t?(s=e,e=t,t=null):s=arguments[2],null==t?(n=u=!0,r=!1):(n=a.call(t,"c"),r=a.call(t,"e"),u=a.call(t,"w")),c={value:e,configurable:n,enumerable:r,writable:u},s?o(i(s),c):c},r.gs=function(t,e,n){var r,s,c,f;return"string"!=typeof t?(c=n,n=e,e=t,t=null):c=arguments[3],null==e?e=void 0:u(e)?null==n?n=void 0:u(n)||(c=n,n=void 0):(c=e,e=n=void 0),null==t?(r=!0,s=!1):(r=a.call(t,"c"),s=a.call(t,"e")),f={get:e,set:n,configurable:r,enumerable:s},c?o(i(c),f):f}},function(t,e,n){"use strict";t.exports=function(){}},function(t,e,n){"use strict";t.exports=n(7)()?Object.assign:n(8)},function(t,e,n){"use strict";t.exports=function(){var t,e=Object.assign;return"function"==typeof e&&(t={foo:"raz"},e(t,{bar:"dwa"},{trzy:"trzy"}),t.foo+t.bar+t.trzy==="razdwatrzy")}},function(t,e,n){"use strict";var r=n(10),o=n(14),i=Math.max;t.exports=function(t,e){var n,u,a,s=i(arguments.length,2);for(t=Object(o(t)),a=function(r){try{t[r]=e[r]}catch(t){n||(n=t)}},u=1;u<s;++u)e=arguments[u],r(e).forEach(a);if(void 0!==n)throw n;return t}},function(t,e,n){"use strict";t.exports=function(t){return"function"==typeof t}},function(t,e,n){"use strict";t.exports=n(11)()?Object.keys:n(12)},function(t,e,n){"use strict";t.exports=function(){try{return Object.keys("primitive"),!0}catch(t){return!1}}},function(t,e,n){"use strict";var r=n(0),o=Object.keys;t.exports=function(t){return o(r(t)?Object(t):t)}},function(t,e,n){"use strict";var r=n(0),o=Array.prototype.forEach,i=Object.create,u=function(t,e){var n;for(n in t)e[n]=t[n]};t.exports=function(t){var e=i(null);return o.call(arguments,function(t){r(t)&&u(Object(t),e)}),e}},function(t,e,n){"use strict";var r=n(0);t.exports=function(t){if(!r(t))throw new TypeError("Cannot use null or undefined");return t}},function(t,e,n){"use strict";t.exports=n(16)()?String.prototype.contains:n(17)},function(t,e,n){"use strict";var r="razdwatrzy";t.exports=function(){return"function"==typeof r.contains&&(!0===r.contains("dwa")&&!1===r.contains("foo"))}},function(t,e,n){"use strict";var r=String.prototype.indexOf;t.exports=function(t){return r.call(this,t,arguments[1])>-1}},function(t,e,n){"use strict";var r={object:!0,symbol:!0};t.exports=function(){var t;if("function"!=typeof Symbol)return!1;t=Symbol("test symbol");try{String(t)}catch(t){return!1}return!!r[typeof Symbol.iterator]&&(!!r[typeof Symbol.toPrimitive]&&!!r[typeof Symbol.toStringTag])}},function(t,e,n){"use strict";t.exports=function(t){return!!t&&("symbol"==typeof t||!!t.constructor&&("Symbol"===t.constructor.name&&"Symbol"===t[t.constructor.toStringTag]))}},function(t,e,n){"use strict";var r,o,i,u,a=n(4),s=n(21),c=Object.create,f=Object.defineProperties,l=Object.defineProperty,v=Object.prototype,d=c(null);if("function"==typeof Symbol){r=Symbol;try{String(r()),u=!0}catch(t){}}var p=function(){var t=c(null);return function(e){for(var n,r,o=0;t[e+(o||"")];)++o;return e+=o||"",t[e]=!0,n="@@"+e,l(v,n,a.gs(null,function(t){r||(r=!0,l(this,n,a(t)),r=!1)})),n}}();i=function(t){if(this instanceof i)throw new TypeError("Symbol is not a constructor");return o(t)},t.exports=o=function t(e){var n;if(this instanceof t)throw new TypeError("Symbol is not a constructor");return u?r(e):(n=c(i.prototype),e=void 0===e?"":String(e),f(n,{__description__:a("",e),__name__:a("",p(e))}))},f(o,{for:a(function(t){return d[t]?d[t]:d[t]=o(String(t))}),keyFor:a(function(t){var e;s(t);for(e in d)if(d[e]===t)return e}),hasInstance:a("",r&&r.hasInstance||o("hasInstance")),isConcatSpreadable:a("",r&&r.isConcatSpreadable||o("isConcatSpreadable")),iterator:a("",r&&r.iterator||o("iterator")),match:a("",r&&r.match||o("match")),replace:a("",r&&r.replace||o("replace")),search:a("",r&&r.search||o("search")),species:a("",r&&r.species||o("species")),split:a("",r&&r.split||o("split")),toPrimitive:a("",r&&r.toPrimitive||o("toPrimitive")),toStringTag:a("",r&&r.toStringTag||o("toStringTag")),unscopables:a("",r&&r.unscopables||o("unscopables"))}),f(i.prototype,{constructor:a(o),toString:a("",function(){return this.__name__})}),f(o.prototype,{toString:a(function(){return"Symbol ("+s(this).__description__+")"}),valueOf:a(function(){return s(this)})}),l(o.prototype,o.toPrimitive,a("",function(){var t=s(this);return"symbol"==typeof t?t:t.toString()})),l(o.prototype,o.toStringTag,a("c","Symbol")),l(i.prototype,o.toStringTag,a("c",o.prototype[o.toStringTag])),l(i.prototype,o.toPrimitive,a("c",o.prototype[o.toPrimitive]))},function(t,e,n){"use strict";var r=n(19);t.exports=function(t){if(!r(t))throw new TypeError(t+" is not a symbol");return t}}])});
	//# sourceMappingURL=moment-range.js.map

/***/ },
/* 23 */
[1960, 1832, 1806],
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// HumanizeDuration.js - https://git.io/j0HgmQ
	
	// @ts-check
	
	/**
	 * @typedef {string | ((unitCount: number) => string)} Unit
	 */
	
	/**
	 * @typedef {("y" | "mo" | "w" | "d" | "h" | "m" | "s" | "ms")} UnitName
	 */
	
	/**
	 * @typedef {Object} UnitMeasures
	 * @prop {number} y
	 * @prop {number} mo
	 * @prop {number} w
	 * @prop {number} d
	 * @prop {number} h
	 * @prop {number} m
	 * @prop {number} s
	 * @prop {number} ms
	 */
	
	/**
	 * @internal
	 * @typedef {[string, string, string, string, string, string, string, string, string, string]} DigitReplacements
	 */
	
	/**
	 * @typedef {Object} Language
	 * @prop {Unit} y
	 * @prop {Unit} mo
	 * @prop {Unit} w
	 * @prop {Unit} d
	 * @prop {Unit} h
	 * @prop {Unit} m
	 * @prop {Unit} s
	 * @prop {Unit} ms
	 * @prop {string} [decimal]
	 * @prop {string} [delimiter]
	 * @prop {DigitReplacements} [_digitReplacements]
	 * @prop {boolean} [_numberFirst]
	 * @prop {boolean} [_hideCountIf2]
	 */
	
	/**
	 * @typedef {Object} Options
	 * @prop {string} [language]
	 * @prop {Record<string, Language>} [languages]
	 * @prop {string[]} [fallbacks]
	 * @prop {string} [delimiter]
	 * @prop {string} [spacer]
	 * @prop {boolean} [round]
	 * @prop {number} [largest]
	 * @prop {UnitName[]} [units]
	 * @prop {string} [decimal]
	 * @prop {string} [conjunction]
	 * @prop {number} [maxDecimalPoints]
	 * @prop {UnitMeasures} [unitMeasures]
	 * @prop {boolean} [serialComma]
	 * @prop {DigitReplacements} [digitReplacements]
	 */
	
	/**
	 * @internal
	 * @typedef {Required<Options>} NormalizedOptions
	 */
	
	(function () {
	  // Fallback for `Object.assign` if relevant.
	  var assign =
	    Object.assign ||
	    /** @param {...any} destination */
	    function (destination) {
	      var source;
	      for (var i = 1; i < arguments.length; i++) {
	        source = arguments[i];
	        for (var prop in source) {
	          if (has(source, prop)) {
	            destination[prop] = source[prop];
	          }
	        }
	      }
	      return destination;
	    };
	
	  // Fallback for `Array.isArray` if relevant.
	  var isArray =
	    Array.isArray ||
	    function (arg) {
	      return Object.prototype.toString.call(arg) === "[object Array]";
	    };
	
	  // This has to be defined separately because of a bug: we want to alias
	  // `gr` and `el` for backwards-compatiblity. In a breaking change, we can
	  // remove `gr` entirely.
	  // See https://github.com/EvanHahn/HumanizeDuration.js/issues/143 for more.
	  var GREEK = language(
	    function (c) {
	      return c === 1 ? "χρόνος" : "χρόνια";
	    },
	    function (c) {
	      return c === 1 ? "μήνας" : "μήνες";
	    },
	    function (c) {
	      return c === 1 ? "εβδομάδα" : "εβδομάδες";
	    },
	    function (c) {
	      return c === 1 ? "μέρα" : "μέρες";
	    },
	    function (c) {
	      return c === 1 ? "ώρα" : "ώρες";
	    },
	    function (c) {
	      return c === 1 ? "λεπτό" : "λεπτά";
	    },
	    function (c) {
	      return c === 1 ? "δευτερόλεπτο" : "δευτερόλεπτα";
	    },
	    function (c) {
	      return (c === 1 ? "χιλιοστό" : "χιλιοστά") + " του δευτερολέπτου";
	    },
	    ","
	  );
	
	  /**
	   * @internal
	   * @type {Record<string, Language>}
	   */
	  var LANGUAGES = {
	    af: language(
	      "jaar",
	      function (c) {
	        return "maand" + (c === 1 ? "" : "e");
	      },
	      function (c) {
	        return c === 1 ? "week" : "weke";
	      },
	      function (c) {
	        return c === 1 ? "dag" : "dae";
	      },
	      function (c) {
	        return c === 1 ? "uur" : "ure";
	      },
	      function (c) {
	        return c === 1 ? "minuut" : "minute";
	      },
	      function (c) {
	        return "sekonde" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "millisekonde" + (c === 1 ? "" : "s");
	      },
	      ","
	    ),
	    am: language("ዓመት", "ወር", "ሳምንት", "ቀን", "ሰዓት", "ደቂቃ", "ሰከንድ", "ሚሊሰከንድ"),
	    ar: assign(
	      language(
	        function (c) {
	          return ["سنة", "سنتان", "سنوات"][getArabicForm(c)];
	        },
	        function (c) {
	          return ["شهر", "شهران", "أشهر"][getArabicForm(c)];
	        },
	        function (c) {
	          return ["أسبوع", "أسبوعين", "أسابيع"][getArabicForm(c)];
	        },
	        function (c) {
	          return ["يوم", "يومين", "أيام"][getArabicForm(c)];
	        },
	        function (c) {
	          return ["ساعة", "ساعتين", "ساعات"][getArabicForm(c)];
	        },
	        function (c) {
	          return ["دقيقة", "دقيقتان", "دقائق"][getArabicForm(c)];
	        },
	        function (c) {
	          return ["ثانية", "ثانيتان", "ثواني"][getArabicForm(c)];
	        },
	        function (c) {
	          return ["جزء من الثانية", "جزآن من الثانية", "أجزاء من الثانية"][
	            getArabicForm(c)
	          ];
	        },
	        ","
	      ),
	      {
	        delimiter: " ﻭ ",
	        _hideCountIf2: true,
	        _digitReplacements: ["۰", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"]
	      }
	    ),
	    bg: language(
	      function (c) {
	        return ["години", "година", "години"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["месеца", "месец", "месеца"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["седмици", "седмица", "седмици"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["дни", "ден", "дни"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["часа", "час", "часа"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["минути", "минута", "минути"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["секунди", "секунда", "секунди"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["милисекунди", "милисекунда", "милисекунди"][getSlavicForm(c)];
	      },
	      ","
	    ),
	    bn: language(
	      "বছর",
	      "মাস",
	      "সপ্তাহ",
	      "দিন",
	      "ঘন্টা",
	      "মিনিট",
	      "সেকেন্ড",
	      "মিলিসেকেন্ড"
	    ),
	    ca: language(
	      function (c) {
	        return "any" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "mes" + (c === 1 ? "" : "os");
	      },
	      function (c) {
	        return "setman" + (c === 1 ? "a" : "es");
	      },
	      function (c) {
	        return "di" + (c === 1 ? "a" : "es");
	      },
	      function (c) {
	        return "hor" + (c === 1 ? "a" : "es");
	      },
	      function (c) {
	        return "minut" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "segon" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "milisegon" + (c === 1 ? "" : "s");
	      },
	      ","
	    ),
	    ckb: language(
	      "ساڵ",
	      "مانگ",
	      "هەفتە",
	      "ڕۆژ",
	      "کاژێر",
	      "خولەک",
	      "چرکە",
	      "میلی چرکە",
	      "."
	    ),
	    cs: language(
	      function (c) {
	        return ["rok", "roku", "roky", "let"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["měsíc", "měsíce", "měsíce", "měsíců"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["týden", "týdne", "týdny", "týdnů"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["den", "dne", "dny", "dní"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["hodina", "hodiny", "hodiny", "hodin"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["minuta", "minuty", "minuty", "minut"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["sekunda", "sekundy", "sekundy", "sekund"][
	          getCzechOrSlovakForm(c)
	        ];
	      },
	      function (c) {
	        return ["milisekunda", "milisekundy", "milisekundy", "milisekund"][
	          getCzechOrSlovakForm(c)
	        ];
	      },
	      ","
	    ),
	    cy: language(
	      "flwyddyn",
	      "mis",
	      "wythnos",
	      "diwrnod",
	      "awr",
	      "munud",
	      "eiliad",
	      "milieiliad"
	    ),
	    da: language(
	      "år",
	      function (c) {
	        return "måned" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "uge" + (c === 1 ? "" : "r");
	      },
	      function (c) {
	        return "dag" + (c === 1 ? "" : "e");
	      },
	      function (c) {
	        return "time" + (c === 1 ? "" : "r");
	      },
	      function (c) {
	        return "minut" + (c === 1 ? "" : "ter");
	      },
	      function (c) {
	        return "sekund" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "millisekund" + (c === 1 ? "" : "er");
	      },
	      ","
	    ),
	    de: language(
	      function (c) {
	        return "Jahr" + (c === 1 ? "" : "e");
	      },
	      function (c) {
	        return "Monat" + (c === 1 ? "" : "e");
	      },
	      function (c) {
	        return "Woche" + (c === 1 ? "" : "n");
	      },
	      function (c) {
	        return "Tag" + (c === 1 ? "" : "e");
	      },
	      function (c) {
	        return "Stunde" + (c === 1 ? "" : "n");
	      },
	      function (c) {
	        return "Minute" + (c === 1 ? "" : "n");
	      },
	      function (c) {
	        return "Sekunde" + (c === 1 ? "" : "n");
	      },
	      function (c) {
	        return "Millisekunde" + (c === 1 ? "" : "n");
	      },
	      ","
	    ),
	    el: GREEK,
	    en: language(
	      function (c) {
	        return "year" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "month" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "week" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "day" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "hour" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "minute" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "second" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "millisecond" + (c === 1 ? "" : "s");
	      }
	    ),
	    eo: language(
	      function (c) {
	        return "jaro" + (c === 1 ? "" : "j");
	      },
	      function (c) {
	        return "monato" + (c === 1 ? "" : "j");
	      },
	      function (c) {
	        return "semajno" + (c === 1 ? "" : "j");
	      },
	      function (c) {
	        return "tago" + (c === 1 ? "" : "j");
	      },
	      function (c) {
	        return "horo" + (c === 1 ? "" : "j");
	      },
	      function (c) {
	        return "minuto" + (c === 1 ? "" : "j");
	      },
	      function (c) {
	        return "sekundo" + (c === 1 ? "" : "j");
	      },
	      function (c) {
	        return "milisekundo" + (c === 1 ? "" : "j");
	      },
	      ","
	    ),
	    es: language(
	      function (c) {
	        return "año" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "mes" + (c === 1 ? "" : "es");
	      },
	      function (c) {
	        return "semana" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "día" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "hora" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "minuto" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "segundo" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "milisegundo" + (c === 1 ? "" : "s");
	      },
	      ","
	    ),
	    et: language(
	      function (c) {
	        return "aasta" + (c === 1 ? "" : "t");
	      },
	      function (c) {
	        return "kuu" + (c === 1 ? "" : "d");
	      },
	      function (c) {
	        return "nädal" + (c === 1 ? "" : "at");
	      },
	      function (c) {
	        return "päev" + (c === 1 ? "" : "a");
	      },
	      function (c) {
	        return "tund" + (c === 1 ? "" : "i");
	      },
	      function (c) {
	        return "minut" + (c === 1 ? "" : "it");
	      },
	      function (c) {
	        return "sekund" + (c === 1 ? "" : "it");
	      },
	      function (c) {
	        return "millisekund" + (c === 1 ? "" : "it");
	      },
	      ","
	    ),
	    eu: language(
	      "urte",
	      "hilabete",
	      "aste",
	      "egun",
	      "ordu",
	      "minutu",
	      "segundo",
	      "milisegundo",
	      ","
	    ),
	    fa: language(
	      "سال",
	      "ماه",
	      "هفته",
	      "روز",
	      "ساعت",
	      "دقیقه",
	      "ثانیه",
	      "میلی ثانیه"
	    ),
	    fi: language(
	      function (c) {
	        return c === 1 ? "vuosi" : "vuotta";
	      },
	      function (c) {
	        return c === 1 ? "kuukausi" : "kuukautta";
	      },
	      function (c) {
	        return "viikko" + (c === 1 ? "" : "a");
	      },
	      function (c) {
	        return "päivä" + (c === 1 ? "" : "ä");
	      },
	      function (c) {
	        return "tunti" + (c === 1 ? "" : "a");
	      },
	      function (c) {
	        return "minuutti" + (c === 1 ? "" : "a");
	      },
	      function (c) {
	        return "sekunti" + (c === 1 ? "" : "a");
	      },
	      function (c) {
	        return "millisekunti" + (c === 1 ? "" : "a");
	      },
	      ","
	    ),
	    fo: language(
	      "ár",
	      function (c) {
	        return c === 1 ? "mánaður" : "mánaðir";
	      },
	      function (c) {
	        return c === 1 ? "vika" : "vikur";
	      },
	      function (c) {
	        return c === 1 ? "dagur" : "dagar";
	      },
	      function (c) {
	        return c === 1 ? "tími" : "tímar";
	      },
	      function (c) {
	        return c === 1 ? "minuttur" : "minuttir";
	      },
	      "sekund",
	      "millisekund",
	      ","
	    ),
	    fr: language(
	      function (c) {
	        return "an" + (c >= 2 ? "s" : "");
	      },
	      "mois",
	      function (c) {
	        return "semaine" + (c >= 2 ? "s" : "");
	      },
	      function (c) {
	        return "jour" + (c >= 2 ? "s" : "");
	      },
	      function (c) {
	        return "heure" + (c >= 2 ? "s" : "");
	      },
	      function (c) {
	        return "minute" + (c >= 2 ? "s" : "");
	      },
	      function (c) {
	        return "seconde" + (c >= 2 ? "s" : "");
	      },
	      function (c) {
	        return "milliseconde" + (c >= 2 ? "s" : "");
	      },
	      ","
	    ),
	    gr: GREEK,
	    he: language(
	      function (c) {
	        return c === 1 ? "שנה" : "שנים";
	      },
	      function (c) {
	        return c === 1 ? "חודש" : "חודשים";
	      },
	      function (c) {
	        return c === 1 ? "שבוע" : "שבועות";
	      },
	      function (c) {
	        return c === 1 ? "יום" : "ימים";
	      },
	      function (c) {
	        return c === 1 ? "שעה" : "שעות";
	      },
	      function (c) {
	        return c === 1 ? "דקה" : "דקות";
	      },
	      function (c) {
	        return c === 1 ? "שניה" : "שניות";
	      },
	      function (c) {
	        return c === 1 ? "מילישנייה" : "מילישניות";
	      }
	    ),
	    hr: language(
	      function (c) {
	        if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) {
	          return "godine";
	        }
	        return "godina";
	      },
	      function (c) {
	        if (c === 1) {
	          return "mjesec";
	        } else if (c === 2 || c === 3 || c === 4) {
	          return "mjeseca";
	        }
	        return "mjeseci";
	      },
	      function (c) {
	        if (c % 10 === 1 && c !== 11) {
	          return "tjedan";
	        }
	        return "tjedna";
	      },
	      function (c) {
	        return c === 1 ? "dan" : "dana";
	      },
	      function (c) {
	        if (c === 1) {
	          return "sat";
	        } else if (c === 2 || c === 3 || c === 4) {
	          return "sata";
	        }
	        return "sati";
	      },
	      function (c) {
	        var mod10 = c % 10;
	        if ((mod10 === 2 || mod10 === 3 || mod10 === 4) && (c < 10 || c > 14)) {
	          return "minute";
	        }
	        return "minuta";
	      },
	      function (c) {
	        var mod10 = c % 10;
	        if (mod10 === 5 || (Math.floor(c) === c && c >= 10 && c <= 19)) {
	          return "sekundi";
	        } else if (mod10 === 1) {
	          return "sekunda";
	        } else if (mod10 === 2 || mod10 === 3 || mod10 === 4) {
	          return "sekunde";
	        }
	        return "sekundi";
	      },
	      function (c) {
	        if (c === 1) {
	          return "milisekunda";
	        } else if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) {
	          return "milisekunde";
	        }
	        return "milisekundi";
	      },
	      ","
	    ),
	    hi: language(
	      "साल",
	      function (c) {
	        return c === 1 ? "महीना" : "महीने";
	      },
	      function (c) {
	        return c === 1 ? "हफ़्ता" : "हफ्ते";
	      },
	      "दिन",
	      function (c) {
	        return c === 1 ? "घंटा" : "घंटे";
	      },
	      "मिनट",
	      "सेकंड",
	      "मिलीसेकंड"
	    ),
	    hu: language(
	      "év",
	      "hónap",
	      "hét",
	      "nap",
	      "óra",
	      "perc",
	      "másodperc",
	      "ezredmásodperc",
	      ","
	    ),
	    id: language(
	      "tahun",
	      "bulan",
	      "minggu",
	      "hari",
	      "jam",
	      "menit",
	      "detik",
	      "milidetik"
	    ),
	    is: language(
	      "ár",
	      function (c) {
	        return "mánuð" + (c === 1 ? "ur" : "ir");
	      },
	      function (c) {
	        return "vik" + (c === 1 ? "a" : "ur");
	      },
	      function (c) {
	        return "dag" + (c === 1 ? "ur" : "ar");
	      },
	      function (c) {
	        return "klukkutím" + (c === 1 ? "i" : "ar");
	      },
	      function (c) {
	        return "mínút" + (c === 1 ? "a" : "ur");
	      },
	      function (c) {
	        return "sekúnd" + (c === 1 ? "a" : "ur");
	      },
	      function (c) {
	        return "millisekúnd" + (c === 1 ? "a" : "ur");
	      }
	    ),
	    it: language(
	      function (c) {
	        return "ann" + (c === 1 ? "o" : "i");
	      },
	      function (c) {
	        return "mes" + (c === 1 ? "e" : "i");
	      },
	      function (c) {
	        return "settiman" + (c === 1 ? "a" : "e");
	      },
	      function (c) {
	        return "giorn" + (c === 1 ? "o" : "i");
	      },
	      function (c) {
	        return "or" + (c === 1 ? "a" : "e");
	      },
	      function (c) {
	        return "minut" + (c === 1 ? "o" : "i");
	      },
	      function (c) {
	        return "second" + (c === 1 ? "o" : "i");
	      },
	      function (c) {
	        return "millisecond" + (c === 1 ? "o" : "i");
	      },
	      ","
	    ),
	    ja: language("年", "ヶ月", "週", "日", "時間", "分", "秒", "ミリ秒"),
	    km: language(
	      "ឆ្នាំ",
	      "ខែ",
	      "សប្តាហ៍",
	      "ថ្ងៃ",
	      "ម៉ោង",
	      "នាទី",
	      "វិនាទី",
	      "មិល្លីវិនាទី"
	    ),
	    kn: language(
	      function (c) {
	        return c === 1 ? "ವರ್ಷ" : "ವರ್ಷಗಳು";
	      },
	      function (c) {
	        return c === 1 ? "ತಿಂಗಳು" : "ತಿಂಗಳುಗಳು";
	      },
	      function (c) {
	        return c === 1 ? "ವಾರ" : "ವಾರಗಳು";
	      },
	      function (c) {
	        return c === 1 ? "ದಿನ" : "ದಿನಗಳು";
	      },
	      function (c) {
	        return c === 1 ? "ಗಂಟೆ" : "ಗಂಟೆಗಳು";
	      },
	      function (c) {
	        return c === 1 ? "ನಿಮಿಷ" : "ನಿಮಿಷಗಳು";
	      },
	      function (c) {
	        return c === 1 ? "ಸೆಕೆಂಡ್" : "ಸೆಕೆಂಡುಗಳು";
	      },
	      function (c) {
	        return c === 1 ? "ಮಿಲಿಸೆಕೆಂಡ್" : "ಮಿಲಿಸೆಕೆಂಡುಗಳು";
	      }
	    ),
	    ko: language("년", "개월", "주일", "일", "시간", "분", "초", "밀리 초"),
	    ku: language(
	      "sal",
	      "meh",
	      "hefte",
	      "roj",
	      "seet",
	      "deqe",
	      "saniye",
	      "mîlîçirk",
	      ","
	    ),
	    lo: language(
	      "ປີ",
	      "ເດືອນ",
	      "ອາທິດ",
	      "ມື້",
	      "ຊົ່ວໂມງ",
	      "ນາທີ",
	      "ວິນາທີ",
	      "ມິນລິວິນາທີ",
	      ","
	    ),
	    lt: language(
	      function (c) {
	        return c % 10 === 0 || (c % 100 >= 10 && c % 100 <= 20)
	          ? "metų"
	          : "metai";
	      },
	      function (c) {
	        return ["mėnuo", "mėnesiai", "mėnesių"][getLithuanianForm(c)];
	      },
	      function (c) {
	        return ["savaitė", "savaitės", "savaičių"][getLithuanianForm(c)];
	      },
	      function (c) {
	        return ["diena", "dienos", "dienų"][getLithuanianForm(c)];
	      },
	      function (c) {
	        return ["valanda", "valandos", "valandų"][getLithuanianForm(c)];
	      },
	      function (c) {
	        return ["minutė", "minutės", "minučių"][getLithuanianForm(c)];
	      },
	      function (c) {
	        return ["sekundė", "sekundės", "sekundžių"][getLithuanianForm(c)];
	      },
	      function (c) {
	        return ["milisekundė", "milisekundės", "milisekundžių"][
	          getLithuanianForm(c)
	        ];
	      },
	      ","
	    ),
	    lv: language(
	      function (c) {
	        return getLatvianForm(c) ? "gads" : "gadi";
	      },
	      function (c) {
	        return getLatvianForm(c) ? "mēnesis" : "mēneši";
	      },
	      function (c) {
	        return getLatvianForm(c) ? "nedēļa" : "nedēļas";
	      },
	      function (c) {
	        return getLatvianForm(c) ? "diena" : "dienas";
	      },
	      function (c) {
	        return getLatvianForm(c) ? "stunda" : "stundas";
	      },
	      function (c) {
	        return getLatvianForm(c) ? "minūte" : "minūtes";
	      },
	      function (c) {
	        return getLatvianForm(c) ? "sekunde" : "sekundes";
	      },
	      function (c) {
	        return getLatvianForm(c) ? "milisekunde" : "milisekundes";
	      },
	      ","
	    ),
	    mk: language(
	      function (c) {
	        return c === 1 ? "година" : "години";
	      },
	      function (c) {
	        return c === 1 ? "месец" : "месеци";
	      },
	      function (c) {
	        return c === 1 ? "недела" : "недели";
	      },
	      function (c) {
	        return c === 1 ? "ден" : "дена";
	      },
	      function (c) {
	        return c === 1 ? "час" : "часа";
	      },
	      function (c) {
	        return c === 1 ? "минута" : "минути";
	      },
	      function (c) {
	        return c === 1 ? "секунда" : "секунди";
	      },
	      function (c) {
	        return c === 1 ? "милисекунда" : "милисекунди";
	      },
	      ","
	    ),
	    mn: language(
	      "жил",
	      "сар",
	      "долоо хоног",
	      "өдөр",
	      "цаг",
	      "минут",
	      "секунд",
	      "миллисекунд"
	    ),
	    mr: language(
	      function (c) {
	        return c === 1 ? "वर्ष" : "वर्षे";
	      },
	      function (c) {
	        return c === 1 ? "महिना" : "महिने";
	      },
	      function (c) {
	        return c === 1 ? "आठवडा" : "आठवडे";
	      },
	      "दिवस",
	      "तास",
	      function (c) {
	        return c === 1 ? "मिनिट" : "मिनिटे";
	      },
	      "सेकंद",
	      "मिलिसेकंद"
	    ),
	    ms: language(
	      "tahun",
	      "bulan",
	      "minggu",
	      "hari",
	      "jam",
	      "minit",
	      "saat",
	      "milisaat"
	    ),
	    nl: language(
	      "jaar",
	      function (c) {
	        return c === 1 ? "maand" : "maanden";
	      },
	      function (c) {
	        return c === 1 ? "week" : "weken";
	      },
	      function (c) {
	        return c === 1 ? "dag" : "dagen";
	      },
	      "uur",
	      function (c) {
	        return c === 1 ? "minuut" : "minuten";
	      },
	      function (c) {
	        return c === 1 ? "seconde" : "seconden";
	      },
	      function (c) {
	        return c === 1 ? "milliseconde" : "milliseconden";
	      },
	      ","
	    ),
	    no: language(
	      "år",
	      function (c) {
	        return "måned" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "uke" + (c === 1 ? "" : "r");
	      },
	      function (c) {
	        return "dag" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "time" + (c === 1 ? "" : "r");
	      },
	      function (c) {
	        return "minutt" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "sekund" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "millisekund" + (c === 1 ? "" : "er");
	      },
	      ","
	    ),
	    pl: language(
	      function (c) {
	        return ["rok", "roku", "lata", "lat"][getPolishForm(c)];
	      },
	      function (c) {
	        return ["miesiąc", "miesiąca", "miesiące", "miesięcy"][
	          getPolishForm(c)
	        ];
	      },
	      function (c) {
	        return ["tydzień", "tygodnia", "tygodnie", "tygodni"][getPolishForm(c)];
	      },
	      function (c) {
	        return ["dzień", "dnia", "dni", "dni"][getPolishForm(c)];
	      },
	      function (c) {
	        return ["godzina", "godziny", "godziny", "godzin"][getPolishForm(c)];
	      },
	      function (c) {
	        return ["minuta", "minuty", "minuty", "minut"][getPolishForm(c)];
	      },
	      function (c) {
	        return ["sekunda", "sekundy", "sekundy", "sekund"][getPolishForm(c)];
	      },
	      function (c) {
	        return ["milisekunda", "milisekundy", "milisekundy", "milisekund"][
	          getPolishForm(c)
	        ];
	      },
	      ","
	    ),
	    pt: language(
	      function (c) {
	        return "ano" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return c === 1 ? "mês" : "meses";
	      },
	      function (c) {
	        return "semana" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "dia" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "hora" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "minuto" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "segundo" + (c === 1 ? "" : "s");
	      },
	      function (c) {
	        return "milissegundo" + (c === 1 ? "" : "s");
	      },
	      ","
	    ),
	    ro: language(
	      function (c) {
	        return c === 1 ? "an" : "ani";
	      },
	      function (c) {
	        return c === 1 ? "lună" : "luni";
	      },
	      function (c) {
	        return c === 1 ? "săptămână" : "săptămâni";
	      },
	      function (c) {
	        return c === 1 ? "zi" : "zile";
	      },
	      function (c) {
	        return c === 1 ? "oră" : "ore";
	      },
	      function (c) {
	        return c === 1 ? "minut" : "minute";
	      },
	      function (c) {
	        return c === 1 ? "secundă" : "secunde";
	      },
	      function (c) {
	        return c === 1 ? "milisecundă" : "milisecunde";
	      },
	      ","
	    ),
	    ru: language(
	      function (c) {
	        return ["лет", "год", "года"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["месяцев", "месяц", "месяца"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["недель", "неделя", "недели"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["дней", "день", "дня"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["часов", "час", "часа"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["минут", "минута", "минуты"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["секунд", "секунда", "секунды"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["миллисекунд", "миллисекунда", "миллисекунды"][
	          getSlavicForm(c)
	        ];
	      },
	      ","
	    ),
	    sq: language(
	      function (c) {
	        return c === 1 ? "vit" : "vjet";
	      },
	      "muaj",
	      "javë",
	      "ditë",
	      "orë",
	      function (c) {
	        return "minut" + (c === 1 ? "ë" : "a");
	      },
	      function (c) {
	        return "sekond" + (c === 1 ? "ë" : "a");
	      },
	      function (c) {
	        return "milisekond" + (c === 1 ? "ë" : "a");
	      },
	      ","
	    ),
	    sr: language(
	      function (c) {
	        return ["години", "година", "године"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["месеци", "месец", "месеца"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["недељи", "недеља", "недеље"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["дани", "дан", "дана"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["сати", "сат", "сата"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["минута", "минут", "минута"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["секунди", "секунда", "секунде"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["милисекунди", "милисекунда", "милисекунде"][getSlavicForm(c)];
	      },
	      ","
	    ),
	    ta: language(
	      function (c) {
	        return c === 1 ? "வருடம்" : "ஆண்டுகள்";
	      },
	      function (c) {
	        return c === 1 ? "மாதம்" : "மாதங்கள்";
	      },
	      function (c) {
	        return c === 1 ? "வாரம்" : "வாரங்கள்";
	      },
	      function (c) {
	        return c === 1 ? "நாள்" : "நாட்கள்";
	      },
	      function (c) {
	        return c === 1 ? "மணி" : "மணிநேரம்";
	      },
	      function (c) {
	        return "நிமிட" + (c === 1 ? "ம்" : "ங்கள்");
	      },
	      function (c) {
	        return "வினாடி" + (c === 1 ? "" : "கள்");
	      },
	      function (c) {
	        return "மில்லி விநாடி" + (c === 1 ? "" : "கள்");
	      }
	    ),
	    te: language(
	      function (c) {
	        return "సంవత్స" + (c === 1 ? "రం" : "రాల");
	      },
	      function (c) {
	        return "నెల" + (c === 1 ? "" : "ల");
	      },
	      function (c) {
	        return c === 1 ? "వారం" : "వారాలు";
	      },
	      function (c) {
	        return "రోజు" + (c === 1 ? "" : "లు");
	      },
	      function (c) {
	        return "గంట" + (c === 1 ? "" : "లు");
	      },
	      function (c) {
	        return c === 1 ? "నిమిషం" : "నిమిషాలు";
	      },
	      function (c) {
	        return c === 1 ? "సెకను" : "సెకన్లు";
	      },
	      function (c) {
	        return c === 1 ? "మిల్లీసెకన్" : "మిల్లీసెకన్లు";
	      }
	    ),
	    uk: language(
	      function (c) {
	        return ["років", "рік", "роки"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["місяців", "місяць", "місяці"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["тижнів", "тиждень", "тижні"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["днів", "день", "дні"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["годин", "година", "години"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["хвилин", "хвилина", "хвилини"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["секунд", "секунда", "секунди"][getSlavicForm(c)];
	      },
	      function (c) {
	        return ["мілісекунд", "мілісекунда", "мілісекунди"][getSlavicForm(c)];
	      },
	      ","
	    ),
	    ur: language(
	      "سال",
	      function (c) {
	        return c === 1 ? "مہینہ" : "مہینے";
	      },
	      function (c) {
	        return c === 1 ? "ہفتہ" : "ہفتے";
	      },
	      "دن",
	      function (c) {
	        return c === 1 ? "گھنٹہ" : "گھنٹے";
	      },
	      "منٹ",
	      "سیکنڈ",
	      "ملی سیکنڈ"
	    ),
	    sk: language(
	      function (c) {
	        return ["rok", "roky", "roky", "rokov"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["mesiac", "mesiace", "mesiace", "mesiacov"][
	          getCzechOrSlovakForm(c)
	        ];
	      },
	      function (c) {
	        return ["týždeň", "týždne", "týždne", "týždňov"][
	          getCzechOrSlovakForm(c)
	        ];
	      },
	      function (c) {
	        return ["deň", "dni", "dni", "dní"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["hodina", "hodiny", "hodiny", "hodín"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["minúta", "minúty", "minúty", "minút"][getCzechOrSlovakForm(c)];
	      },
	      function (c) {
	        return ["sekunda", "sekundy", "sekundy", "sekúnd"][
	          getCzechOrSlovakForm(c)
	        ];
	      },
	      function (c) {
	        return ["milisekunda", "milisekundy", "milisekundy", "milisekúnd"][
	          getCzechOrSlovakForm(c)
	        ];
	      },
	      ","
	    ),
	    sl: language(
	      function (c) {
	        if (c % 10 === 1) {
	          return "leto";
	        } else if (c % 100 === 2) {
	          return "leti";
	        } else if (
	          c % 100 === 3 ||
	          c % 100 === 4 ||
	          (Math.floor(c) !== c && c % 100 <= 5)
	        ) {
	          return "leta";
	        } else {
	          return "let";
	        }
	      },
	      function (c) {
	        if (c % 10 === 1) {
	          return "mesec";
	        } else if (c % 100 === 2 || (Math.floor(c) !== c && c % 100 <= 5)) {
	          return "meseca";
	        } else if (c % 10 === 3 || c % 10 === 4) {
	          return "mesece";
	        } else {
	          return "mesecev";
	        }
	      },
	      function (c) {
	        if (c % 10 === 1) {
	          return "teden";
	        } else if (c % 10 === 2 || (Math.floor(c) !== c && c % 100 <= 4)) {
	          return "tedna";
	        } else if (c % 10 === 3 || c % 10 === 4) {
	          return "tedne";
	        } else {
	          return "tednov";
	        }
	      },
	      function (c) {
	        return c % 100 === 1 ? "dan" : "dni";
	      },
	      function (c) {
	        if (c % 10 === 1) {
	          return "ura";
	        } else if (c % 100 === 2) {
	          return "uri";
	        } else if (c % 10 === 3 || c % 10 === 4 || Math.floor(c) !== c) {
	          return "ure";
	        } else {
	          return "ur";
	        }
	      },
	      function (c) {
	        if (c % 10 === 1) {
	          return "minuta";
	        } else if (c % 10 === 2) {
	          return "minuti";
	        } else if (
	          c % 10 === 3 ||
	          c % 10 === 4 ||
	          (Math.floor(c) !== c && c % 100 <= 4)
	        ) {
	          return "minute";
	        } else {
	          return "minut";
	        }
	      },
	      function (c) {
	        if (c % 10 === 1) {
	          return "sekunda";
	        } else if (c % 100 === 2) {
	          return "sekundi";
	        } else if (c % 100 === 3 || c % 100 === 4 || Math.floor(c) !== c) {
	          return "sekunde";
	        } else {
	          return "sekund";
	        }
	      },
	      function (c) {
	        if (c % 10 === 1) {
	          return "milisekunda";
	        } else if (c % 100 === 2) {
	          return "milisekundi";
	        } else if (c % 100 === 3 || c % 100 === 4 || Math.floor(c) !== c) {
	          return "milisekunde";
	        } else {
	          return "milisekund";
	        }
	      },
	      ","
	    ),
	    sv: language(
	      "år",
	      function (c) {
	        return "månad" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "veck" + (c === 1 ? "a" : "or");
	      },
	      function (c) {
	        return "dag" + (c === 1 ? "" : "ar");
	      },
	      function (c) {
	        return "timm" + (c === 1 ? "e" : "ar");
	      },
	      function (c) {
	        return "minut" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "sekund" + (c === 1 ? "" : "er");
	      },
	      function (c) {
	        return "millisekund" + (c === 1 ? "" : "er");
	      },
	      ","
	    ),
	    sw: assign(
	      language(
	        function (c) {
	          return c === 1 ? "mwaka" : "miaka";
	        },
	        function (c) {
	          return c === 1 ? "mwezi" : "miezi";
	        },
	        "wiki",
	        function (c) {
	          return c === 1 ? "siku" : "masiku";
	        },
	        function (c) {
	          return c === 1 ? "saa" : "masaa";
	        },
	        "dakika",
	        "sekunde",
	        "milisekunde"
	      ),
	      { _numberFirst: true }
	    ),
	    tr: language(
	      "yıl",
	      "ay",
	      "hafta",
	      "gün",
	      "saat",
	      "dakika",
	      "saniye",
	      "milisaniye",
	      ","
	    ),
	    th: language(
	      "ปี",
	      "เดือน",
	      "สัปดาห์",
	      "วัน",
	      "ชั่วโมง",
	      "นาที",
	      "วินาที",
	      "มิลลิวินาที"
	    ),
	    uz: language(
	      "yil",
	      "oy",
	      "hafta",
	      "kun",
	      "soat",
	      "minut",
	      "sekund",
	      "millisekund"
	    ),
	    uz_CYR: language(
	      "йил",
	      "ой",
	      "ҳафта",
	      "кун",
	      "соат",
	      "минут",
	      "секунд",
	      "миллисекунд"
	    ),
	    vi: language(
	      "năm",
	      "tháng",
	      "tuần",
	      "ngày",
	      "giờ",
	      "phút",
	      "giây",
	      "mili giây",
	      ","
	    ),
	    zh_CN: language("年", "个月", "周", "天", "小时", "分钟", "秒", "毫秒"),
	    zh_TW: language("年", "個月", "周", "天", "小時", "分鐘", "秒", "毫秒")
	  };
	
	  /**
	   * Helper function for creating language definitions.
	   *
	   * @internal
	   * @param {Unit} y
	   * @param {Unit} mo
	   * @param {Unit} w
	   * @param {Unit} d
	   * @param {Unit} h
	   * @param {Unit} m
	   * @param {Unit} s
	   * @param {Unit} ms
	   * @param {string} [decimal]
	   * @returns {Language}
	   */
	  function language(y, mo, w, d, h, m, s, ms, decimal) {
	    /** @type {Language} */
	    var result = { y: y, mo: mo, w: w, d: d, h: h, m: m, s: s, ms: ms };
	    if (typeof decimal !== "undefined") {
	      result.decimal = decimal;
	    }
	    return result;
	  }
	
	  /**
	   * Helper function for Arabic.
	   *
	   * @internal
	   * @param {number} c
	   * @returns {0 | 1 | 2}
	   */
	  function getArabicForm(c) {
	    if (c === 2) {
	      return 1;
	    }
	    if (c > 2 && c < 11) {
	      return 2;
	    }
	    return 0;
	  }
	
	  /**
	   * Helper function for Polish.
	   *
	   * @internal
	   * @param {number} c
	   * @returns {0 | 1 | 2 | 3}
	   */
	  function getPolishForm(c) {
	    if (c === 1) {
	      return 0;
	    }
	    if (Math.floor(c) !== c) {
	      return 1;
	    }
	    if (c % 10 >= 2 && c % 10 <= 4 && !(c % 100 > 10 && c % 100 < 20)) {
	      return 2;
	    }
	    return 3;
	  }
	
	  /**
	   * Helper function for Slavic languages.
	   *
	   * @internal
	   * @param {number} c
	   * @returns {0 | 1 | 2 | 3}
	   */
	  function getSlavicForm(c) {
	    if (Math.floor(c) !== c) {
	      return 2;
	    }
	    if (
	      (c % 100 >= 5 && c % 100 <= 20) ||
	      (c % 10 >= 5 && c % 10 <= 9) ||
	      c % 10 === 0
	    ) {
	      return 0;
	    }
	    if (c % 10 === 1) {
	      return 1;
	    }
	    if (c > 1) {
	      return 2;
	    }
	    return 0;
	  }
	
	  /**
	   * Helper function for Czech or Slovak.
	   *
	   * @internal
	   * @param {number} c
	   * @returns {0 | 1 | 2 | 3}
	   */
	  function getCzechOrSlovakForm(c) {
	    if (c === 1) {
	      return 0;
	    }
	    if (Math.floor(c) !== c) {
	      return 1;
	    }
	    if (c % 10 >= 2 && c % 10 <= 4 && c % 100 < 10) {
	      return 2;
	    }
	    return 3;
	  }
	
	  /**
	   * Helper function for Lithuanian.
	   *
	   * @internal
	   * @param {number} c
	   * @returns {0 | 1 | 2}
	   */
	  function getLithuanianForm(c) {
	    if (c === 1 || (c % 10 === 1 && c % 100 > 20)) {
	      return 0;
	    }
	    if (
	      Math.floor(c) !== c ||
	      (c % 10 >= 2 && c % 100 > 20) ||
	      (c % 10 >= 2 && c % 100 < 10)
	    ) {
	      return 1;
	    }
	    return 2;
	  }
	
	  /**
	   * Helper function for Latvian.
	   *
	   * @internal
	   * @param {number} c
	   * @returns {boolean}
	   */
	  function getLatvianForm(c) {
	    return c % 10 === 1 && c % 100 !== 11;
	  }
	
	  /**
	   * @internal
	   * @template T
	   * @param {T} obj
	   * @param {keyof T} key
	   * @returns {boolean}
	   */
	  function has(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	  }
	
	  /**
	   * @internal
	   * @param {Pick<Required<Options>, "language" | "fallbacks" | "languages">} options
	   * @throws {Error} Throws an error if language is not found.
	   * @returns {Language}
	   */
	  function getLanguage(options) {
	    var possibleLanguages = [options.language];
	
	    if (has(options, "fallbacks")) {
	      if (isArray(options.fallbacks) && options.fallbacks.length) {
	        possibleLanguages = possibleLanguages.concat(options.fallbacks);
	      } else {
	        throw new Error("fallbacks must be an array with at least one element");
	      }
	    }
	
	    for (var i = 0; i < possibleLanguages.length; i++) {
	      var languageToTry = possibleLanguages[i];
	      if (has(options.languages, languageToTry)) {
	        return options.languages[languageToTry];
	      }
	      if (has(LANGUAGES, languageToTry)) {
	        return LANGUAGES[languageToTry];
	      }
	    }
	
	    throw new Error("No language found.");
	  }
	
	  /**
	   * @internal
	   * @param {Piece} piece
	   * @param {Language} language
	   * @param {Pick<Required<Options>, "decimal" | "spacer" | "maxDecimalPoints" | "digitReplacements">} options
	   */
	  function renderPiece(piece, language, options) {
	    var unitName = piece.unitName;
	    var unitCount = piece.unitCount;
	
	    var spacer = options.spacer;
	    var maxDecimalPoints = options.maxDecimalPoints;
	
	    /** @type {string} */
	    var decimal;
	    if (has(options, "decimal")) {
	      decimal = options.decimal;
	    } else if (has(language, "decimal")) {
	      decimal = language.decimal;
	    } else {
	      decimal = ".";
	    }
	
	    /** @type {undefined | DigitReplacements} */
	    var digitReplacements;
	    if ("digitReplacements" in options) {
	      digitReplacements = options.digitReplacements;
	    } else if ("_digitReplacements" in language) {
	      digitReplacements = language._digitReplacements;
	    }
	
	    /** @type {string} */
	    var formattedCount;
	    var normalizedUnitCount =
	      maxDecimalPoints === void 0
	        ? unitCount
	        : Math.floor(unitCount * Math.pow(10, maxDecimalPoints)) /
	          Math.pow(10, maxDecimalPoints);
	    var countStr = normalizedUnitCount.toString();
	
	    if (language._hideCountIf2 && unitCount === 2) {
	      formattedCount = "";
	      spacer = "";
	    } else {
	      if (digitReplacements) {
	        formattedCount = "";
	        for (var i = 0; i < countStr.length; i++) {
	          var char = countStr[i];
	          if (char === ".") {
	            formattedCount += decimal;
	          } else {
	            // @ts-ignore because `char` should always be 0-9 at this point.
	            formattedCount += digitReplacements[char];
	          }
	        }
	      } else {
	        formattedCount = countStr.replace(".", decimal);
	      }
	    }
	
	    var languageWord = language[unitName];
	    var word;
	    if (typeof languageWord === "function") {
	      word = languageWord(unitCount);
	    } else {
	      word = languageWord;
	    }
	
	    if (language._numberFirst) {
	      return word + spacer + formattedCount;
	    }
	    return formattedCount + spacer + word;
	  }
	
	  /**
	   * @internal
	   * @typedef {Object} Piece
	   * @prop {UnitName} unitName
	   * @prop {number} unitCount
	   */
	
	  /**
	   * @internal
	   * @param {number} ms
	   * @param {Pick<Required<Options>, "units" | "unitMeasures" | "largest" | "round">} options
	   * @returns {Piece[]}
	   */
	  function getPieces(ms, options) {
	    /** @type {UnitName} */
	    var unitName;
	
	    /** @type {number} */
	    var i;
	
	    /** @type {number} */
	    var unitCount;
	
	    /** @type {number} */
	    var msRemaining;
	
	    var units = options.units;
	    var unitMeasures = options.unitMeasures;
	    var largest = "largest" in options ? options.largest : Infinity;
	
	    if (!units.length) return [];
	
	    // Get the counts for each unit. Doesn't round or truncate anything.
	    // For example, might create an object like `{ y: 7, m: 6, w: 0, d: 5, h: 23.99 }`.
	    /** @type {Partial<Record<UnitName, number>>} */
	    var unitCounts = {};
	    msRemaining = ms;
	    for (i = 0; i < units.length; i++) {
	      unitName = units[i];
	      var unitMs = unitMeasures[unitName];
	
	      var isLast = i === units.length - 1;
	      unitCount = isLast
	        ? msRemaining / unitMs
	        : Math.floor(msRemaining / unitMs);
	      unitCounts[unitName] = unitCount;
	
	      msRemaining -= unitCount * unitMs;
	    }
	
	    if (options.round) {
	      // Update counts based on the `largest` option.
	      // For example, if `largest === 2` and `unitCount` is `{ y: 7, m: 6, w: 0, d: 5, h: 23.99 }`,
	      // updates to something like `{ y: 7, m: 6.2 }`.
	      var unitsRemainingBeforeRound = largest;
	      for (i = 0; i < units.length; i++) {
	        unitName = units[i];
	        unitCount = unitCounts[unitName];
	
	        if (unitCount === 0) continue;
	
	        unitsRemainingBeforeRound--;
	
	        // "Take" the rest of the units into this one.
	        if (unitsRemainingBeforeRound === 0) {
	          for (var j = i + 1; j < units.length; j++) {
	            var smallerUnitName = units[j];
	            var smallerUnitCount = unitCounts[smallerUnitName];
	            unitCounts[unitName] +=
	              (smallerUnitCount * unitMeasures[smallerUnitName]) /
	              unitMeasures[unitName];
	            unitCounts[smallerUnitName] = 0;
	          }
	          break;
	        }
	      }
	
	      // Round the last piece (which should be the only non-integer).
	      //
	      // This can be a little tricky if the last piece "bubbles up" to a larger
	      // unit. For example, "3 days, 23.99 hours" should be rounded to "4 days".
	      // It can also require multiple passes. For example, "6 days, 23.99 hours"
	      // should become "1 week".
	      for (i = units.length - 1; i >= 0; i--) {
	        unitName = units[i];
	        unitCount = unitCounts[unitName];
	
	        if (unitCount === 0) continue;
	
	        var rounded = Math.round(unitCount);
	        unitCounts[unitName] = rounded;
	
	        if (i === 0) break;
	
	        var previousUnitName = units[i - 1];
	        var previousUnitMs = unitMeasures[previousUnitName];
	        var amountOfPreviousUnit = Math.floor(
	          (rounded * unitMeasures[unitName]) / previousUnitMs
	        );
	        if (amountOfPreviousUnit) {
	          unitCounts[previousUnitName] += amountOfPreviousUnit;
	          unitCounts[unitName] = 0;
	        } else {
	          break;
	        }
	      }
	    }
	
	    /** @type {Piece[]} */
	    var result = [];
	    for (i = 0; i < units.length && result.length < largest; i++) {
	      unitName = units[i];
	      unitCount = unitCounts[unitName];
	      if (unitCount) {
	        result.push({ unitName: unitName, unitCount: unitCount });
	      }
	    }
	    return result;
	  }
	
	  /**
	   * @internal
	   * @param {Piece[]} pieces
	   * @param {Pick<Required<Options>, "units" | "language" | "languages" | "fallbacks" | "delimiter" | "spacer" | "decimal" | "conjunction" | "maxDecimalPoints" | "serialComma" | "digitReplacements">} options
	   * @returns {string}
	   */
	  function formatPieces(pieces, options) {
	    var language = getLanguage(options);
	
	    if (!pieces.length) {
	      var units = options.units;
	      var smallestUnitName = units[units.length - 1];
	      return renderPiece(
	        { unitName: smallestUnitName, unitCount: 0 },
	        language,
	        options
	      );
	    }
	
	    var conjunction = options.conjunction;
	    var serialComma = options.serialComma;
	
	    var delimiter;
	    if (has(options, "delimiter")) {
	      delimiter = options.delimiter;
	    } else if (has(language, "delimiter")) {
	      delimiter = language.delimiter;
	    } else {
	      delimiter = ", ";
	    }
	
	    /** @type {string[]} */
	    var renderedPieces = [];
	    for (var i = 0; i < pieces.length; i++) {
	      renderedPieces.push(renderPiece(pieces[i], language, options));
	    }
	
	    if (!conjunction || pieces.length === 1) {
	      return renderedPieces.join(delimiter);
	    }
	
	    if (pieces.length === 2) {
	      return renderedPieces.join(conjunction);
	    }
	
	    return (
	      renderedPieces.slice(0, -1).join(delimiter) +
	      (serialComma ? "," : "") +
	      conjunction +
	      renderedPieces.slice(-1)
	    );
	  }
	
	  /**
	   * Create a humanizer, which lets you change the default options.
	   *
	   * @param {Options} [passedOptions]
	   */
	  function humanizer(passedOptions) {
	    /**
	     * @param {number} ms
	     * @param {Options} [humanizerOptions]
	     * @returns {string}
	     */
	    var result = function humanizer(ms, humanizerOptions) {
	      // Make sure we have a positive number.
	      //
	      // Has the nice side-effect of converting things to numbers. For example,
	      // converts `"123"` and `Number(123)` to `123`.
	      ms = Math.abs(ms);
	
	      var options = assign({}, result, humanizerOptions || {});
	
	      var pieces = getPieces(ms, options);
	
	      return formatPieces(pieces, options);
	    };
	
	    return assign(
	      result,
	      {
	        language: "en",
	        spacer: " ",
	        conjunction: "",
	        serialComma: true,
	        units: ["y", "mo", "w", "d", "h", "m", "s"],
	        languages: {},
	        round: false,
	        unitMeasures: {
	          y: 31557600000,
	          mo: 2629800000,
	          w: 604800000,
	          d: 86400000,
	          h: 3600000,
	          m: 60000,
	          s: 1000,
	          ms: 1
	        }
	      },
	      passedOptions
	    );
	  }
	
	  /**
	   * Humanize a duration.
	   *
	   * This is a wrapper around the default humanizer.
	   */
	  var humanizeDuration = assign(humanizer({}), {
	    getSupportedLanguages: function getSupportedLanguages() {
	      var result = [];
	      for (var language in LANGUAGES) {
	        if (has(LANGUAGES, language) && language !== "gr") {
	          result.push(language);
	        }
	      }
	      return result;
	    },
	    humanizer: humanizer
	  });
	
	  // @ts-ignore
	  if (true) {
	    // @ts-ignore
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return humanizeDuration;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== "undefined" && module.exports) {
	    module.exports = humanizeDuration;
	  } else {
	    this.humanizeDuration = humanizeDuration;
	  }
	})();


/***/ },
/* 25 */,
/* 26 */
[1957, 1, 4],
/* 27 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Default values for all Dinero objects.
	 *
	 * You can override default values for all subsequent Dinero objects by changing them directly on the global `Dinero` object.
	 * Existing instances won't be affected.
	 *
	 * @property {Number} defaultAmount - The default amount for new Dinero objects (see {@link module:Dinero Dinero} for format).
	 * @property {String} defaultCurrency - The default currency for new Dinero objects (see {@link module:Dinero Dinero} for format).
	 * @property {Number} defaultPrecision - The default precision for new Dinero objects (see {@link module:Dinero Dinero} for format).
	 *
	 * @example
	 * // Will set currency to 'EUR' for all Dinero objects.
	 * Dinero.defaultCurrency = 'EUR'
	 *
	 * @type {Object}
	 */
	var Defaults = {
	  defaultAmount: 0,
	  defaultCurrency: 'USD',
	  defaultPrecision: 2
	};
	/**
	 * Global settings for all Dinero objects.
	 *
	 * You can override global values for all subsequent Dinero objects by changing them directly on the global `Dinero` object.
	 * Existing instances won't be affected.
	 *
	 * @property {String}  globalLocale - The global locale for new Dinero objects (see {@link module:Dinero~setLocale setLocale} for format).
	 * @property {String}  globalFormat - The global format for new Dinero objects (see {@link module:Dinero~toFormat toFormat} for format).
	 * @property {String}  globalRoundingMode - The global rounding mode for new Dinero objects (see {@link module:Dinero~multiply multiply} or {@link module:Dinero~divide divide} for format).
	 * @property {String}  globalFormatRoundingMode - The global rounding mode to format new Dinero objects (see {@link module:Dinero~toFormat toFormat} or {@link module:Dinero~toRoundedUnit toRoundedUnit} for format).
	 * @property {(String|Promise)}  globalExchangeRatesApi.endpoint - The global exchange rate API endpoint for new Dinero objects, or the global promise that resolves to the exchanges rates (see {@link module:Dinero~convert convert} for format).
	 * @property {String}  globalExchangeRatesApi.propertyPath - The global exchange rate API property path for new Dinero objects (see {@link module:Dinero~convert convert} for format).
	 * @property {Object}  globalExchangeRatesApi.headers - The global exchange rate API headers for new Dinero objects (see {@link module:Dinero~convert convert} for format).
	 *
	 * @example
	 * // Will set locale to 'fr-FR' for all Dinero objects.
	 * Dinero.globalLocale = 'fr-FR'
	 * @example
	 * // Will set global exchange rate API parameters for all Dinero objects.
	 * Dinero.globalExchangeRatesApi = {
	 *  endpoint: 'https://yourexchangerates.api/latest?base={{from}}',
	 *  propertyPath: 'data.rates.{{to}}',
	 *  headers: {
	 *    'user-key': 'xxxxxxxxx'
	 *  }
	 * }
	 *
	 * @type {Object}
	 */
	
	var Globals = {
	  globalLocale: 'en-US',
	  globalFormat: '$0,0.00',
	  globalRoundingMode: 'HALF_EVEN',
	  globalFormatRoundingMode: 'HALF_AWAY_FROM_ZERO',
	  globalExchangeRatesApi: {
	    endpoint: undefined,
	    headers: undefined,
	    propertyPath: undefined
	  }
	};
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	function _toArray(arr) {
	  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	
	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	
	  return arr2;
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	/**
	 * Static methods for Dinero.
	 * @ignore
	 *
	 * @type {Object}
	 */
	var Static = {
	  /**
	   * Returns an array of Dinero objects, normalized to the same precision (the highest).
	   *
	   * @memberof module:Dinero
	   * @method
	   *
	   * @param {Dinero[]} objects - An array of Dinero objects
	   *
	   * @example
	   * // returns an array of Dinero objects
	   * // both with a precision of 3
	   * // and an amount of 1000
	   * Dinero.normalizePrecision([
	   *   Dinero({ amount: 100, precision: 2 }),
	   *   Dinero({ amount: 1000, precision: 3 })
	   * ])
	   *
	   * @return {Dinero[]}
	   */
	  normalizePrecision: function normalizePrecision(objects) {
	    var highestPrecision = objects.reduce(function (a, b) {
	      return Math.max(a.getPrecision(), b.getPrecision());
	    });
	    return objects.map(function (object) {
	      return object.getPrecision() !== highestPrecision ? object.convertPrecision(highestPrecision) : object;
	    });
	  },
	
	  /**
	   * Returns the smallest Dinero object from an array of Dinero objects
	   *
	   * @memberof module:Dinero
	   * @method
	   *
	   * @param {Dinero[]} objects - An array of Dinero objects
	   *
	   * @example
	   * // returns the smallest Dinero object with amount of 500 from an array of Dinero objects with different precisions
	   * Dinero.minimum([
	   *   Dinero({ amount: 500, precision: 3 }),
	   *   Dinero({ amount: 100, precision: 2 })
	   * ])
	   * @example
	   * // returns the smallest Dinero object with amount of 50 from an array of Dinero objects
	   * Dinero.minimum([
	   *   Dinero({ amount: 50 }),
	   *   Dinero({ amount: 100 })
	   * ])
	   *
	   * @return {Dinero[]}
	   */
	  minimum: function minimum(objects) {
	    var _objects = _toArray(objects),
	        firstObject = _objects[0],
	        tailObjects = _objects.slice(1);
	
	    var currentMinimum = firstObject;
	    tailObjects.forEach(function (obj) {
	      currentMinimum = currentMinimum.lessThan(obj) ? currentMinimum : obj;
	    });
	    return currentMinimum;
	  },
	
	  /**
	   * Returns the biggest Dinero object from an array of Dinero objects
	   *
	   * @memberof module:Dinero
	   * @method
	   *
	   * @param {Dinero[]} objects - An array of Dinero objects
	   *
	   * @example
	   * // returns the biggest Dinero object with amount of 20, from an array of Dinero objects with different precisions
	   * Dinero.maximum([
	   *   Dinero({ amount: 20, precision: 2 }),
	   *   Dinero({ amount: 150, precision: 3 })
	   * ])
	   * @example
	   * // returns the biggest Dinero object with amount of 100, from an array of Dinero objects
	   * Dinero.maximum([
	   *   Dinero({ amount: 100 }),
	   *   Dinero({ amount: 50 })
	   * ])
	   *
	   * @return {Dinero[]}
	   */
	  maximum: function maximum(objects) {
	    var _objects2 = _toArray(objects),
	        firstObject = _objects2[0],
	        tailObjects = _objects2.slice(1);
	
	    var currentMaximum = firstObject;
	    tailObjects.forEach(function (obj) {
	      currentMaximum = currentMaximum.greaterThan(obj) ? currentMaximum : obj;
	    });
	    return currentMaximum;
	  }
	};
	
	/**
	 * Returns whether a value is numeric.
	 * @ignore
	 *
	 * @param  {} value - The value to test.
	 *
	 * @return {Boolean}
	 */
	function isNumeric(value) {
	  return !isNaN(parseInt(value)) && isFinite(value);
	}
	/**
	 * Returns whether a value is a percentage.
	 * @ignore
	 *
	 * @param  {}  percentage - The percentage to test.
	 *
	 * @return {Boolean}
	 */
	
	function isPercentage(percentage) {
	  return isNumeric(percentage) && percentage <= 100 && percentage >= 0;
	}
	/**
	 * Returns whether an array of ratios is valid.
	 * @ignore
	 *
	 * @param  {}  ratios - The ratios to test.
	 *
	 * @return {Boolean}
	 */
	
	function areValidRatios(ratios) {
	  return ratios.length > 0 && ratios.every(function (ratio) {
	    return ratio >= 0;
	  }) && ratios.some(function (ratio) {
	    return ratio > 0;
	  });
	}
	/**
	 * Returns whether a value is even.
	 * @ignore
	 *
	 * @param  {Number} value - The value to test.
	 *
	 * @return {Boolean}
	 */
	
	function isEven(value) {
	  return value % 2 === 0;
	}
	/**
	 * Returns whether a value is a float.
	 * @ignore
	 *
	 * @param  {}  value - The value to test.
	 *
	 * @return {Boolean}
	 */
	
	function isFloat(value) {
	  return isNumeric(value) && !Number.isInteger(value);
	}
	/**
	 * Returns how many fraction digits a number has.
	 * @ignore
	 *
	 * @param  {Number} [number=0] - The number to test.
	 *
	 * @return {Number}
	 */
	
	function countFractionDigits() {
	  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var stringRepresentation = number.toString();
	
	  if (stringRepresentation.indexOf('e-') > 0) {
	    // It's too small for a normal string representation, e.g. 1e-7 instead of 0.00000001
	    return parseInt(stringRepresentation.split('e-')[1]);
	  } else {
	    var fractionDigits = stringRepresentation.split('.')[1];
	    return fractionDigits ? fractionDigits.length : 0;
	  }
	}
	/**
	 * Returns whether a number is half.
	 * @ignore
	 *
	 * @param {Number} number - The number to test.
	 *
	 * @return {Number}
	 */
	
	function isHalf(number) {
	  return Math.abs(number) % 1 === 0.5;
	}
	/**
	 * Fetches a JSON resource.
	 * @ignore
	 *
	 * @param  {String} url - The resource to fetch.
	 * @param  {Object} [options.headers] - The headers to pass.
	 *
	 * @throws {Error} If `request.status` is lesser than 200 or greater or equal to 400.
	 * @throws {Error} If network fails.
	 *
	 * @return {JSON}
	 */
	
	function getJSON(url) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    var request = Object.assign(new XMLHttpRequest(), {
	      onreadystatechange: function onreadystatechange() {
	        if (request.readyState === 4) {
	          if (request.status >= 200 && request.status < 400) resolve(JSON.parse(request.responseText));else reject(new Error(request.statusText));
	        }
	      },
	      onerror: function onerror() {
	        reject(new Error('Network error'));
	      }
	    });
	    request.open('GET', url, true);
	    setXHRHeaders(request, options.headers);
	    request.send();
	  });
	}
	/**
	 * Returns an XHR object with attached headers.
	 * @ignore
	 *
	 * @param {XMLHttpRequest} xhr - The XHR request to set headers to.
	 * @param {Object} headers - The headers to set.
	 *
	 * @return {XMLHttpRequest}
	 */
	
	function setXHRHeaders(xhr) {
	  var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  for (var header in headers) {
	    xhr.setRequestHeader(header, headers[header]);
	  }
	
	  return xhr;
	}
	/**
	 * Returns whether a value is undefined.
	 * @ignore
	 *
	 * @param {} value - The value to test.
	 *
	 * @return {Boolean}
	 */
	
	function isUndefined(value) {
	  return typeof value === 'undefined';
	}
	/**
	 * Returns an object flattened to one level deep.
	 * @ignore
	 *
	 * @param {Object} object - The object to flatten.
	 * @param {String} separator - The separator to use between flattened nodes.
	 *
	 * @return {Object}
	 */
	
	function flattenObject(object) {
	  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.';
	  var finalObject = {};
	  Object.entries(object).forEach(function (item) {
	    if (_typeof(item[1]) === 'object') {
	      var flatObject = flattenObject(item[1]);
	      Object.entries(flatObject).forEach(function (node) {
	        finalObject[item[0] + separator + node[0]] = node[1];
	      });
	    } else {
	      finalObject[item[0]] = item[1];
	    }
	  });
	  return finalObject;
	}
	/**
	 * Returns whether a value is thenable.
	 * @ignore
	 *
	 * @param {} value - The value to test.
	 *
	 * @return {Boolean}
	 */
	
	function isThenable(value) {
	  return Boolean(value) && (_typeof(value) === 'object' || typeof value === 'function') && typeof value.then === 'function';
	}
	
	function Calculator() {
	  var floatMultiply = function floatMultiply(a, b) {
	    var getFactor = function getFactor(number) {
	      return Math.pow(10, countFractionDigits(number));
	    };
	
	    var factor = Math.max(getFactor(a), getFactor(b));
	    return Math.round(a * factor) * Math.round(b * factor) / (factor * factor);
	  };
	
	  var roundingModes = {
	    HALF_ODD: function HALF_ODD(number) {
	      var rounded = Math.round(number);
	      return isHalf(number) ? isEven(rounded) ? rounded - 1 : rounded : rounded;
	    },
	    HALF_EVEN: function HALF_EVEN(number) {
	      var rounded = Math.round(number);
	      return isHalf(number) ? isEven(rounded) ? rounded : rounded - 1 : rounded;
	    },
	    HALF_UP: function HALF_UP(number) {
	      return Math.round(number);
	    },
	    HALF_DOWN: function HALF_DOWN(number) {
	      return isHalf(number) ? Math.floor(number) : Math.round(number);
	    },
	    HALF_TOWARDS_ZERO: function HALF_TOWARDS_ZERO(number) {
	      return isHalf(number) ? Math.sign(number) * Math.floor(Math.abs(number)) : Math.round(number);
	    },
	    HALF_AWAY_FROM_ZERO: function HALF_AWAY_FROM_ZERO(number) {
	      return isHalf(number) ? Math.sign(number) * Math.ceil(Math.abs(number)) : Math.round(number);
	    },
	    DOWN: function DOWN(number) {
	      return Math.floor(number);
	    }
	  };
	  return {
	    /**
	     * Returns the sum of two numbers.
	     * @ignore
	     *
	     * @param {Number} a - The first number to add.
	     * @param {Number} b - The second number to add.
	     *
	     * @return {Number}
	     */
	    add: function add(a, b) {
	      return a + b;
	    },
	
	    /**
	     * Returns the difference of two numbers.
	     * @ignore
	     *
	     * @param {Number} a - The first number to subtract.
	     * @param {Number} b - The second number to subtract.
	     *
	     * @return {Number}
	     */
	    subtract: function subtract(a, b) {
	      return a - b;
	    },
	
	    /**
	     * Returns the product of two numbers.
	     * @ignore
	     *
	     * @param {Number} a - The first number to multiply.
	     * @param {Number} b - The second number to multiply.
	     *
	     * @return {Number}
	     */
	    multiply: function multiply(a, b) {
	      return isFloat(a) || isFloat(b) ? floatMultiply(a, b) : a * b;
	    },
	
	    /**
	     * Returns the quotient of two numbers.
	     * @ignore
	     *
	     * @param {Number} a - The first number to divide.
	     * @param {Number} b - The second number to divide.
	     *
	     * @return {Number}
	     */
	    divide: function divide(a, b) {
	      return a / b;
	    },
	
	    /**
	     * Returns the remainder of two numbers.
	     * @ignore
	     *
	     * @param  {Number} a - The first number to divide.
	     * @param  {Number} b - The second number to divide.
	     *
	     * @return {Number}
	     */
	    modulo: function modulo(a, b) {
	      return a % b;
	    },
	
	    /**
	     * Returns a rounded number based off a specific rounding mode.
	     * @ignore
	     *
	     * @param {Number} number - The number to round.
	     * @param {String} [roundingMode='HALF_EVEN'] - The rounding mode to use.
	     *
	     * @returns {Number}
	     */
	    round: function round(number) {
	      var roundingMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'HALF_EVEN';
	      return roundingModes[roundingMode](number);
	    }
	  };
	}
	
	var calculator = Calculator();
	function Format(format) {
	  var matches = /^(?:(\$|USD)?0(?:(,)0)?(\.)?(0+)?|0(?:(,)0)?(\.)?(0+)?\s?(dollar)?)$/gm.exec(format);
	  return {
	    /**
	     * Returns the matches.
	     * @ignore
	     *
	     * @return {Array}
	     */
	    getMatches: function getMatches() {
	      return matches !== null ? matches.slice(1).filter(function (match) {
	        return !isUndefined(match);
	      }) : [];
	    },
	
	    /**
	     * Returns the amount of fraction digits to display.
	     * @ignore
	     *
	     * @return {Number}
	     */
	    getMinimumFractionDigits: function getMinimumFractionDigits() {
	      var decimalPosition = function decimalPosition(match) {
	        return match === '.';
	      };
	
	      return !isUndefined(this.getMatches().find(decimalPosition)) ? this.getMatches()[calculator.add(this.getMatches().findIndex(decimalPosition), 1)].split('').length : 0;
	    },
	
	    /**
	     * Returns the currency display mode.
	     * @ignore
	     *
	     * @return {String}
	     */
	    getCurrencyDisplay: function getCurrencyDisplay() {
	      var modes = {
	        USD: 'code',
	        dollar: 'name',
	        $: 'symbol'
	      };
	      return modes[this.getMatches().find(function (match) {
	        return match === 'USD' || match === 'dollar' || match === '$';
	      })];
	    },
	
	    /**
	     * Returns the formatting style.
	     * @ignore
	     *
	     * @return {String}
	     */
	    getStyle: function getStyle() {
	      return !isUndefined(this.getCurrencyDisplay(this.getMatches())) ? 'currency' : 'decimal';
	    },
	
	    /**
	     * Returns whether grouping should be used or not.
	     * @ignore
	     *
	     * @return {Boolean}
	     */
	    getUseGrouping: function getUseGrouping() {
	      return !isUndefined(this.getMatches().find(function (match) {
	        return match === ',';
	      }));
	    }
	  };
	}
	
	function CurrencyConverter(options) {
	  /* istanbul ignore next */
	  var mergeTags = function mergeTags() {
	    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var tags = arguments.length > 1 ? arguments[1] : undefined;
	
	    for (var tag in tags) {
	      string = string.replace("{{".concat(tag, "}}"), tags[tag]);
	    }
	
	    return string;
	  };
	  /* istanbul ignore next */
	
	
	  var getRatesFromRestApi = function getRatesFromRestApi(from, to) {
	    return getJSON(mergeTags(options.endpoint, {
	      from: from,
	      to: to
	    }), {
	      headers: options.headers
	    });
	  };
	
	  return {
	    /**
	     * Returns the exchange rate.
	     * @ignore
	     *
	     * @param  {String} from - The base currency.
	     * @param  {String} to   - The destination currency.
	     *
	     * @return {Promise}
	     */
	    getExchangeRate: function getExchangeRate(from, to) {
	      return (isThenable(options.endpoint) ? options.endpoint : getRatesFromRestApi(from, to)).then(function (data) {
	        return flattenObject(data)[mergeTags(options.propertyPath, {
	          from: from,
	          to: to
	        })];
	      });
	    }
	  };
	}
	
	/**
	 * Performs an assertion.
	 * @ignore
	 *
	 * @param  {Boolean} condition - The expression to assert.
	 * @param  {String}  errorMessage - The message to throw if the assertion fails
	 * @param  {ErrorConstructor}   [ErrorType=Error] - The error to throw if the assertion fails.
	 *
	 * @throws {Error} If `condition` returns `false`.
	 */
	
	function assert(condition, errorMessage) {
	  var ErrorType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Error;
	  if (!condition) throw new ErrorType(errorMessage);
	}
	/**
	 * Asserts a value is a percentage.
	 * @ignore
	 *
	 * @param  {}  percentage - The percentage to test.
	 *
	 * @throws {RangeError} If `percentage` is out of range.
	 */
	
	function assertPercentage(percentage) {
	  assert(isPercentage(percentage), 'You must provide a numeric value between 0 and 100.', RangeError);
	}
	/**
	 * Asserts an array of ratios is valid.
	 * @ignore
	 *
	 * @param  {}  ratios - The ratios to test.
	 *
	 * @throws {TypeError} If `ratios` are invalid.
	 */
	
	function assertValidRatios(ratios) {
	  assert(areValidRatios(ratios), 'You must provide a non-empty array of numeric values greater than 0.', TypeError);
	}
	/**
	 * Asserts a value is an integer.
	 * @ignore
	 *
	 * @param  {}  number - The value to test.
	 *
	 * @throws {TypeError}
	 */
	
	function assertInteger(number) {
	  assert(Number.isInteger(number), 'You must provide an integer.', TypeError);
	}
	
	var calculator$1 = Calculator();
	/**
	 * A Dinero object is an immutable data structure representing a specific monetary value.
	 * It comes with methods for creating, parsing, manipulating, testing, transforming and formatting them.
	 *
	 * A Dinero object has:
	 *
	 * * An `amount`, expressed in minor currency units, as an integer.
	 * * A `currency`, expressed as an {@link https://en.wikipedia.org/wiki/ISO_4217#Active_codes ISO 4217 currency code}.
	 * * A `precision`, expressed as an integer, to represent the number of decimal places in the `amount`.
	 *   This is helpful when you want to represent fractional minor currency units (e.g.: $10.4545).
	 *   You can also use it to represent a currency with a different [exponent](https://en.wikipedia.org/wiki/ISO_4217#Treatment_of_minor_currency_units_.28the_.22exponent.22.29) than `2` (e.g.: Iraqi dinar with 1000 fils in 1 dinar (exponent of `3`), Japanese yen with no sub-units (exponent of `0`)).
	 * * An optional `locale` property that affects how output strings are formatted.
	 *
	 * Here's an overview of the public API:
	 *
	 * * **Access:** {@link module:Dinero~getAmount getAmount}, {@link module:Dinero~getCurrency getCurrency}, {@link module:Dinero~getLocale getLocale} and {@link module:Dinero~getPrecision getPrecision}.
	 * * **Manipulation:** {@link module:Dinero~add add}, {@link module:Dinero~subtract subtract}, {@link module:Dinero~multiply multiply}, {@link module:Dinero~divide divide}, {@link module:Dinero~percentage percentage}, {@link module:Dinero~allocate allocate} and {@link module:Dinero~convert convert}.
	 * * **Testing:** {@link module:Dinero~equalsTo equalsTo}, {@link module:Dinero~lessThan lessThan}, {@link module:Dinero~lessThanOrEqual lessThanOrEqual}, {@link module:Dinero~greaterThan greaterThan}, {@link module:Dinero~greaterThanOrEqual greaterThanOrEqual}, {@link module:Dinero~isZero isZero}, {@link module:Dinero~isPositive isPositive}, {@link module:Dinero~isNegative isNegative}, {@link module:Dinero~hasSubUnits hasSubUnits}, {@link module:Dinero~hasSameCurrency hasSameCurrency} and {@link module:Dinero~hasSameAmount hasSameAmount}.
	 * * **Configuration:** {@link module:Dinero~setLocale setLocale}.
	 * * **Conversion & formatting:** {@link module:Dinero~toFormat toFormat}, {@link module:Dinero~toUnit toUnit}, {@link module:Dinero~toRoundedUnit toRoundedUnit}, {@link module:Dinero~toObject toObject}, {@link module:Dinero~toJSON toJSON}, {@link module:Dinero~convertPrecision convertPrecision} and {@link module:Dinero.normalizePrecision normalizePrecision}.
	 *
	 * Dinero.js uses `number`s under the hood, so it's constrained by the [double-precision floating-point format](https://en.wikipedia.org/wiki/Double-precision_floating-point_format). Using values over [`Number.MAX_SAFE_INTEGER`](https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Objets_globaux/Number/MAX_SAFE_INTEGER) or below [`Number.MIN_SAFE_INTEGER`](https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Objets_globaux/Number/MIN_SAFE_INTEGER) will yield unpredictable results.
	 * Same goes with performing calculations: once the internal `amount` value exceeds those limits, precision is no longer guaranteed.
	 *
	 * @module Dinero
	 * @param  {Number} [options.amount=0] - The amount in minor currency units (as an integer).
	 * @param  {String} [options.currency='USD'] - An ISO 4217 currency code.
	 * @param  {String} [options.precision=2] - The number of decimal places to represent.
	 *
	 * @throws {TypeError} If `amount` or `precision` is invalid. Integers over [`Number.MAX_SAFE_INTEGER`](https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Objets_globaux/Number/MAX_SAFE_INTEGER) or below [`Number.MIN_SAFE_INTEGER`](https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Objets_globaux/Number/MIN_SAFE_INTEGER) are considered valid, even though they can lead to imprecise amounts.
	 *
	 * @return {Object}
	 */
	
	var Dinero = function Dinero(options) {
	  var _Object$assign = Object.assign({}, {
	    amount: Dinero.defaultAmount,
	    currency: Dinero.defaultCurrency,
	    precision: Dinero.defaultPrecision
	  }, options),
	      amount = _Object$assign.amount,
	      currency = _Object$assign.currency,
	      precision = _Object$assign.precision;
	
	  assertInteger(amount);
	  assertInteger(precision);
	  var globalLocale = Dinero.globalLocale,
	      globalFormat = Dinero.globalFormat,
	      globalRoundingMode = Dinero.globalRoundingMode,
	      globalFormatRoundingMode = Dinero.globalFormatRoundingMode;
	  var globalExchangeRatesApi = Object.assign({}, Dinero.globalExchangeRatesApi);
	  /**
	   * Uses ES5 function notation so `this` can be passed through call, apply and bind
	   * @ignore
	   */
	
	  var create = function create(options) {
	    var obj = Object.assign({}, Object.assign({}, {
	      amount: amount,
	      currency: currency,
	      precision: precision
	    }, options), Object.assign({}, {
	      locale: this.locale
	    }, options));
	    return Object.assign(Dinero({
	      amount: obj.amount,
	      currency: obj.currency,
	      precision: obj.precision
	    }), {
	      locale: obj.locale
	    });
	  };
	  /**
	   * Uses ES5 function notation so `this` can be passed through call, apply and bind
	   * @ignore
	   */
	
	
	  var assertSameCurrency = function assertSameCurrency(comparator) {
	    assert(this.hasSameCurrency(comparator), 'You must provide a Dinero instance with the same currency.', TypeError);
	  };
	
	  return {
	    /**
	     * Returns the amount.
	     *
	     * @example
	     * // returns 500
	     * Dinero({ amount: 500 }).getAmount()
	     *
	     * @return {Number}
	     */
	    getAmount: function getAmount() {
	      return amount;
	    },
	
	    /**
	     * Returns the currency.
	     *
	     * @example
	     * // returns 'EUR'
	     * Dinero({ currency: 'EUR' }).getCurrency()
	     *
	     * @return {String}
	     */
	    getCurrency: function getCurrency() {
	      return currency;
	    },
	
	    /**
	     * Returns the locale.
	     *
	     * @example
	     * // returns 'fr-FR'
	     * Dinero().setLocale('fr-FR').getLocale()
	     *
	     * @return {String}
	     */
	    getLocale: function getLocale() {
	      return this.locale || globalLocale;
	    },
	
	    /**
	     * Returns a new Dinero object with an embedded locale.
	     *
	     * @param {String} newLocale - The new locale as an {@link http://tools.ietf.org/html/rfc5646 BCP 47 language tag}.
	     *
	     * @example
	     * // Returns a Dinero object with locale 'ja-JP'
	     * Dinero().setLocale('ja-JP')
	     *
	     * @return {Dinero}
	     */
	    setLocale: function setLocale(newLocale) {
	      return create.call(this, {
	        locale: newLocale
	      });
	    },
	
	    /**
	     * Returns the precision.
	     *
	     * @example
	     * // returns 3
	     * Dinero({ precision: 3 }).getPrecision()
	     *
	     * @return {Number}
	     */
	    getPrecision: function getPrecision() {
	      return precision;
	    },
	
	    /**
	     * Returns a new Dinero object with a new precision and a converted amount.
	     *
	     * By default, fractional minor currency units are rounded using the **half to even** rule ([banker's rounding](http://wiki.c2.com/?BankersRounding)).
	     * This can be necessary when you need to convert objects to a smaller precision.
	     *
	     * Rounding *can* lead to accuracy issues as you chain many times. Consider a minimal amount of subsequent conversions for safer results.
	     * You can also specify a different `roundingMode` to better fit your needs.
	     *
	     * @param {Number} newPrecision - The new precision.
	     * @param {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
	     *
	     * @example
	     * // Returns a Dinero object with precision 3 and amount 1000
	     * Dinero({ amount: 100, precision: 2 }).convertPrecision(3)
	     *
	     * @throws {TypeError} If `newPrecision` is invalid.
	     *
	     * @return {Dinero}
	     */
	    convertPrecision: function convertPrecision(newPrecision) {
	      var roundingMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalFormatRoundingMode;
	      assertInteger(newPrecision);
	      var precision = this.getPrecision();
	      var isNewPrecisionLarger = newPrecision > precision;
	      var operation = isNewPrecisionLarger ? calculator$1.multiply : calculator$1.divide;
	      var terms = isNewPrecisionLarger ? [newPrecision, precision] : [precision, newPrecision];
	      var factor = Math.pow(10, calculator$1.subtract.apply(calculator$1, terms));
	      return create.call(this, {
	        amount: calculator$1.round(operation(this.getAmount(), factor), roundingMode),
	        precision: newPrecision
	      });
	    },
	
	    /**
	     * Returns a new Dinero object that represents the sum of this and an other Dinero object.
	     *
	     * If Dinero objects have a different `precision`, they will be first converted to the highest.
	     *
	     * @param {Dinero} addend - The Dinero object to add.
	     *
	     * @example
	     * // returns a Dinero object with amount 600
	     * Dinero({ amount: 400 }).add(Dinero({ amount: 200 }))
	     * @example
	     * // returns a Dinero object with amount 144545 and precision 4
	     * Dinero({ amount: 400 }).add(Dinero({ amount: 104545, precision: 4 }))
	     *
	     * @throws {TypeError} If `addend` has a different currency.
	     *
	     * @return {Dinero}
	     */
	    add: function add(addend) {
	      assertSameCurrency.call(this, addend);
	      var addends = Dinero.normalizePrecision([this, addend]);
	      return create.call(this, {
	        amount: calculator$1.add(addends[0].getAmount(), addends[1].getAmount()),
	        precision: addends[0].getPrecision()
	      });
	    },
	
	    /**
	     * Returns a new Dinero object that represents the difference of this and an other Dinero object.
	     *
	     * If Dinero objects have a different `precision`, they will be first converted to the highest.
	     *
	     * @param  {Dinero} subtrahend - The Dinero object to subtract.
	     *
	     * @example
	     * // returns a Dinero object with amount 200
	     * Dinero({ amount: 400 }).subtract(Dinero({ amount: 200 }))
	     * @example
	     * // returns a Dinero object with amount 64545 and precision 4
	     * Dinero({ amount: 104545, precision: 4 }).subtract(Dinero({ amount: 400 }))
	     *
	     * @throws {TypeError} If `subtrahend` has a different currency.
	     *
	     * @return {Dinero}
	     */
	    subtract: function subtract(subtrahend) {
	      assertSameCurrency.call(this, subtrahend);
	      var subtrahends = Dinero.normalizePrecision([this, subtrahend]);
	      return create.call(this, {
	        amount: calculator$1.subtract(subtrahends[0].getAmount(), subtrahends[1].getAmount()),
	        precision: subtrahends[0].getPrecision()
	      });
	    },
	
	    /**
	     * Returns a new Dinero object that represents the multiplied value by the given factor.
	     *
	     * By default, fractional minor currency units are rounded using the **half to even** rule ([banker's rounding](http://wiki.c2.com/?BankersRounding)).
	     *
	     * Rounding *can* lead to accuracy issues as you chain many times. Consider a minimal amount of subsequent calculations for safer results.
	     * You can also specify a different `roundingMode` to better fit your needs.
	     *
	     * @param  {Number} multiplier - The factor to multiply by.
	     * @param  {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
	     *
	     * @example
	     * // returns a Dinero object with amount 1600
	     * Dinero({ amount: 400 }).multiply(4)
	     * @example
	     * // returns a Dinero object with amount 800
	     * Dinero({ amount: 400 }).multiply(2.001)
	     * @example
	     * // returns a Dinero object with amount 801
	     * Dinero({ amount: 400 }).multiply(2.00125, 'HALF_UP')
	     *
	     * @return {Dinero}
	     */
	    multiply: function multiply(multiplier) {
	      var roundingMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalRoundingMode;
	      return create.call(this, {
	        amount: calculator$1.round(calculator$1.multiply(this.getAmount(), multiplier), roundingMode)
	      });
	    },
	
	    /**
	     * Returns a new Dinero object that represents the divided value by the given factor.
	     *
	     * By default, fractional minor currency units are rounded using the **half to even** rule ([banker's rounding](http://wiki.c2.com/?BankersRounding)).
	     *
	     * Rounding *can* lead to accuracy issues as you chain many times. Consider a minimal amount of subsequent calculations for safer results.
	     * You can also specify a different `roundingMode` to better fit your needs.
	     *
	     * As rounding is applied, precision may be lost in the process. If you want to accurately split a Dinero object, use {@link module:Dinero~allocate allocate} instead.
	     *
	     * @param  {Number} divisor - The factor to divide by.
	     * @param  {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
	     *
	     * @example
	     * // returns a Dinero object with amount 100
	     * Dinero({ amount: 400 }).divide(4)
	     * @example
	     * // returns a Dinero object with amount 52
	     * Dinero({ amount: 105 }).divide(2)
	     * @example
	     * // returns a Dinero object with amount 53
	     * Dinero({ amount: 105 }).divide(2, 'HALF_UP')
	     *
	     * @return {Dinero}
	     */
	    divide: function divide(divisor) {
	      var roundingMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalRoundingMode;
	      return create.call(this, {
	        amount: calculator$1.round(calculator$1.divide(this.getAmount(), divisor), roundingMode)
	      });
	    },
	
	    /**
	     * Returns a new Dinero object that represents a percentage of this.
	     *
	     * As rounding is applied, precision may be lost in the process. If you want to accurately split a Dinero object, use {@link module:Dinero~allocate allocate} instead.
	     *
	     * @param  {Number} percentage - The percentage to extract (between 0 and 100).
	     * @param  {String} [roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
	     *
	     * @example
	     * // returns a Dinero object with amount 5000
	     * Dinero({ amount: 10000 }).percentage(50)
	     * @example
	     * // returns a Dinero object with amount 29
	     * Dinero({ amount: 57 }).percentage(50, "HALF_ODD")
	     *
	     * @throws {RangeError} If `percentage` is out of range.
	     *
	     * @return {Dinero}
	     */
	    percentage: function percentage(_percentage) {
	      var roundingMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalRoundingMode;
	      assertPercentage(_percentage);
	      return this.multiply(calculator$1.divide(_percentage, 100), roundingMode);
	    },
	
	    /**
	     * Allocates the amount of a Dinero object according to a list of ratios.
	     *
	     * Sometimes you need to split monetary values but percentages can't cut it without adding or losing pennies.
	     * A good example is invoicing: let's say you need to bill $1,000.03 and you want a 50% downpayment.
	     * If you use {@link module:Dinero~percentage percentage}, you'll get an accurate Dinero object but the amount won't be billable: you can't split a penny.
	     * If you round it, you'll bill a penny extra.
	     * With {@link module:Dinero~allocate allocate}, you can split a monetary amount then distribute the remainder as evenly as possible.
	     *
	     * You can use percentage style or ratio style for `ratios`: `[25, 75]` and `[1, 3]` will do the same thing.
	     *
	     * Since v1.8.0, you can use zero ratios (such as [0, 50, 50]). If there's a remainder to distribute, zero ratios are skipped and return a Dinero object with amount zero.
	     *
	     * @param  {Number[]} ratios - The ratios to allocate the money to.
	     *
	     * @example
	     * // returns an array of two Dinero objects
	     * // the first one with an amount of 502
	     * // the second one with an amount of 501
	     * Dinero({ amount: 1003 }).allocate([50, 50])
	     * @example
	     * // returns an array of two Dinero objects
	     * // the first one with an amount of 25
	     * // the second one with an amount of 75
	     * Dinero({ amount: 100 }).allocate([1, 3])
	     * @example
	     * // since version 1.8.0
	     * // returns an array of three Dinero objects
	     * // the first one with an amount of 0
	     * // the second one with an amount of 502
	     * // the third one with an amount of 501
	     * Dinero({ amount: 1003 }).allocate([0, 50, 50])
	     *
	     * @throws {TypeError} If ratios are invalid.
	     *
	     * @return {Dinero[]}
	     */
	    allocate: function allocate(ratios) {
	      var _this = this;
	
	      assertValidRatios(ratios);
	      var total = ratios.reduce(function (a, b) {
	        return calculator$1.add(a, b);
	      });
	      var remainder = this.getAmount();
	      var shares = ratios.map(function (ratio) {
	        var share = Math.floor(calculator$1.divide(calculator$1.multiply(_this.getAmount(), ratio), total));
	        remainder = calculator$1.subtract(remainder, share);
	        return create.call(_this, {
	          amount: share
	        });
	      });
	      var i = 0;
	
	      while (remainder > 0) {
	        if (ratios[i] > 0) {
	          shares[i] = shares[i].add(create.call(this, {
	            amount: 1
	          }));
	          remainder = calculator$1.subtract(remainder, 1);
	        }
	
	        i += 1;
	      }
	
	      return shares;
	    },
	
	    /**
	     * Returns a Promise containing a new Dinero object converted to another currency.
	     *
	     * You have two options to provide the exchange rates:
	     *
	     * 1. **Use an exchange rate REST API, and let Dinero handle the fetching and conversion.**
	     *   This is a simple option if you have access to an exchange rate REST API and want Dinero to do the rest.
	     * 2. **Fetch the exchange rates on your own and provide them directly.**
	     *   This is useful if you're fetching your rates from somewhere else (a file, a database), use a different protocol or query language than REST (SOAP, GraphQL) or want to fetch rates once and cache them instead of making new requests every time.
	     *
	     * **If you want to use a REST API**, you must provide a third-party endpoint yourself. Dinero doesn't come bundled with an exchange rates endpoint.
	     *
	     * Here are some exchange rate APIs you can use:
	     *
	     * * [Fixer](https://fixer.io)
	     * * [Open Exchange Rates](https://openexchangerates.org)
	     * * [Coinbase](https://api.coinbase.com/v2/exchange-rates)
	     * * More [foreign](https://github.com/toddmotto/public-apis#currency-exchange) and [crypto](https://github.com/toddmotto/public-apis#cryptocurrency) exchange rate APIs.
	     *
	     * **If you want to fetch your own rates and provide them directly**, you need to pass a promise that resolves to the exchanges rates.
	     *
	     * In both cases, you need to specify at least:
	     *
	     * * a **destination currency**: the currency in which you want to convert your Dinero object. You can specify it with `currency`.
	     * * an **endpoint**: the API URL to query exchange rates, with parameters, or a promise that resolves to the exchange rates. You can specify it with `options.endpoint`.
	     * * a **property path**: the path to access the wanted rate in your API's JSON response (or the custom promise's payload). For example, with a response of:
	     * ```json
	     * {
	     *     "data": {
	     *       "base": "USD",
	     *       "destination": "EUR",
	     *       "rate": "0.827728919"
	     *     }
	     * }
	     * ```
	     * Then the property path is `'data.rate'`. You can specify it with `options.propertyPath`.
	     *
	     * The base currency (the one of your Dinero object) and the destination currency can be used as "merge tags" with the mustache syntax, respectively `{{from}}` and `{{to}}`.
	     * You can use these tags to refer to these values in `options.endpoint` and `options.propertyPath`.
	     *
	     * For example, if you need to specify the base currency as a query parameter, you can do the following:
	     *
	     * ```js
	     * {
	     *   endpoint: 'https://yourexchangerates.api/latest?base={{from}}'
	     * }
	     * ```
	     *
	     * @param  {String} currency - The destination currency, expressed as an {@link https://en.wikipedia.org/wiki/ISO_4217#Active_codes ISO 4217 currency code}.
	     * @param  {(String|Promise)} options.endpoint - The API endpoint to retrieve exchange rates. You can substitute this with a promise that resolves to the exchanges rates if you already have them.
	     * @param  {String} [options.propertyPath='rates.{{to}}'] - The property path to the rate.
	     * @param  {Object} [options.headers] - The HTTP headers to provide, if needed.
	     * @param  {String} [options.roundingMode='HALF_EVEN'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
	     *
	     * @example
	     * // your global API parameters
	     * Dinero.globalExchangeRatesApi = { ... }
	     *
	     * // returns a Promise containing a Dinero object with the destination currency
	     * // and the initial amount converted to the new currency.
	     * Dinero({ amount: 500 }).convert('EUR')
	     * @example
	     * // returns a Promise containing a Dinero object,
	     * // with specific API parameters and rounding mode for this specific instance.
	     * Dinero({ amount: 500 })
	     *   .convert('XBT', {
	     *     endpoint: 'https://yourexchangerates.api/latest?base={{from}}',
	     *     propertyPath: 'data.rates.{{to}}',
	     *     headers: {
	     *       'user-key': 'xxxxxxxxx'
	     *     },
	     *     roundingMode: 'HALF_UP'
	     *   })
	     * @example
	     * // usage with exchange rates provided as a custom promise
	     * // using the default `propertyPath` format (so it doesn't have to be specified)
	     * const rates = {
	     *   rates: {
	     *     EUR: 0.81162
	     *   }
	     * }
	     *
	     * Dinero({ amount: 500 })
	     *   .convert('EUR', {
	     *     endpoint: new Promise(resolve => resolve(rates))
	     *   })
	     * @example
	     * // usage with Promise.prototype.then and Promise.prototype.catch
	     * Dinero({ amount: 500 })
	     *   .convert('EUR')
	     *   .then(dinero => {
	     *     dinero.getCurrency() // returns 'EUR'
	     *   })
	     *   .catch(err => {
	     *     // handle errors
	     *   })
	     * @example
	     * // usage with async/await
	     * (async () => {
	     *   const price = await Dinero({ amount: 500 }).convert('EUR')
	     *   price.getCurrency() // returns 'EUR'
	     * })()
	     *
	     * @return {Promise}
	     */
	    convert: function convert(currency) {
	      var _this2 = this;
	
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          _ref$endpoint = _ref.endpoint,
	          endpoint = _ref$endpoint === void 0 ? globalExchangeRatesApi.endpoint : _ref$endpoint,
	          _ref$propertyPath = _ref.propertyPath,
	          propertyPath = _ref$propertyPath === void 0 ? globalExchangeRatesApi.propertyPath || 'rates.{{to}}' : _ref$propertyPath,
	          _ref$headers = _ref.headers,
	          headers = _ref$headers === void 0 ? globalExchangeRatesApi.headers : _ref$headers,
	          _ref$roundingMode = _ref.roundingMode,
	          roundingMode = _ref$roundingMode === void 0 ? globalRoundingMode : _ref$roundingMode;
	
	      var options = Object.assign({}, {
	        endpoint: endpoint,
	        propertyPath: propertyPath,
	        headers: headers,
	        roundingMode: roundingMode
	      });
	      return CurrencyConverter(options).getExchangeRate(this.getCurrency(), currency).then(function (rate) {
	        assert(!isUndefined(rate), "No rate was found for the destination currency \"".concat(currency, "\"."), TypeError);
	        return create.call(_this2, {
	          amount: calculator$1.round(calculator$1.multiply(_this2.getAmount(), parseFloat(rate)), options.roundingMode),
	          currency: currency
	        });
	      });
	    },
	
	    /**
	     * Checks whether the value represented by this object equals to the other.
	     *
	     * @param  {Dinero} comparator - The Dinero object to compare to.
	     *
	     * @example
	     * // returns true
	     * Dinero({ amount: 500, currency: 'EUR' }).equalsTo(Dinero({ amount: 500, currency: 'EUR' }))
	     * @example
	     * // returns false
	     * Dinero({ amount: 500, currency: 'EUR' }).equalsTo(Dinero({ amount: 800, currency: 'EUR' }))
	     * @example
	     * // returns false
	     * Dinero({ amount: 500, currency: 'USD' }).equalsTo(Dinero({ amount: 500, currency: 'EUR' }))
	     * @example
	     * // returns false
	     * Dinero({ amount: 500, currency: 'USD' }).equalsTo(Dinero({ amount: 800, currency: 'EUR' }))
	     * @example
	     * // returns true
	     * Dinero({ amount: 1000, currency: 'EUR', precision: 2 }).equalsTo(Dinero({ amount: 10000, currency: 'EUR', precision: 3 }))
	     * @example
	     * // returns false
	     * Dinero({ amount: 10000, currency: 'EUR', precision: 2 }).equalsTo(Dinero({ amount: 10000, currency: 'EUR', precision: 3 }))
	     *
	     * @return {Boolean}
	     */
	    equalsTo: function equalsTo(comparator) {
	      return this.hasSameAmount(comparator) && this.hasSameCurrency(comparator);
	    },
	
	    /**
	     * Checks whether the value represented by this object is less than the other.
	     *
	     * @param  {Dinero} comparator - The Dinero object to compare to.
	     *
	     * @example
	     * // returns true
	     * Dinero({ amount: 500 }).lessThan(Dinero({ amount: 800 }))
	     * @example
	     * // returns false
	     * Dinero({ amount: 800 }).lessThan(Dinero({ amount: 500 }))
	     * @example
	     * // returns true
	     * Dinero({ amount: 5000, precision: 3 }).lessThan(Dinero({ amount: 800 }))
	     * @example
	     * // returns false
	     * Dinero({ amount: 800 }).lessThan(Dinero({ amount: 5000, precision: 3 }))
	     *
	     * @throws {TypeError} If `comparator` has a different currency.
	     *
	     * @return {Boolean}
	     */
	    lessThan: function lessThan(comparator) {
	      assertSameCurrency.call(this, comparator);
	      var comparators = Dinero.normalizePrecision([this, comparator]);
	      return comparators[0].getAmount() < comparators[1].getAmount();
	    },
	
	    /**
	     * Checks whether the value represented by this object is less than or equal to the other.
	     *
	     * @param  {Dinero} comparator - The Dinero object to compare to.
	     *
	     * @example
	     * // returns true
	     * Dinero({ amount: 500 }).lessThanOrEqual(Dinero({ amount: 800 }))
	     * @example
	     * // returns true
	     * Dinero({ amount: 500 }).lessThanOrEqual(Dinero({ amount: 500 }))
	     * @example
	     * // returns false
	     * Dinero({ amount: 500 }).lessThanOrEqual(Dinero({ amount: 300 }))
	     * @example
	     * // returns true
	     * Dinero({ amount: 5000, precision: 3 }).lessThanOrEqual(Dinero({ amount: 800 }))
	     * @example
	     * // returns true
	     * Dinero({ amount: 5000, precision: 3 }).lessThanOrEqual(Dinero({ amount: 500 }))
	     * @example
	     * // returns false
	     * Dinero({ amount: 800 }).lessThanOrEqual(Dinero({ amount: 5000, precision: 3 }))
	     *
	     * @throws {TypeError} If `comparator` has a different currency.
	     *
	     * @return {Boolean}
	     */
	    lessThanOrEqual: function lessThanOrEqual(comparator) {
	      assertSameCurrency.call(this, comparator);
	      var comparators = Dinero.normalizePrecision([this, comparator]);
	      return comparators[0].getAmount() <= comparators[1].getAmount();
	    },
	
	    /**
	     * Checks whether the value represented by this object is greater than the other.
	     *
	     * @param  {Dinero} comparator - The Dinero object to compare to.
	     *
	     * @example
	     * // returns false
	     * Dinero({ amount: 500 }).greaterThan(Dinero({ amount: 800 }))
	     * @example
	     * // returns true
	     * Dinero({ amount: 800 }).greaterThan(Dinero({ amount: 500 }))
	     * @example
	     * // returns true
	     * Dinero({ amount: 800 }).greaterThan(Dinero({ amount: 5000, precision: 3 }))
	     * @example
	     * // returns false
	     * Dinero({ amount: 5000, precision: 3 }).greaterThan(Dinero({ amount: 800 }))
	     *
	     * @throws {TypeError} If `comparator` has a different currency.
	     *
	     * @return {Boolean}
	     */
	    greaterThan: function greaterThan(comparator) {
	      assertSameCurrency.call(this, comparator);
	      var comparators = Dinero.normalizePrecision([this, comparator]);
	      return comparators[0].getAmount() > comparators[1].getAmount();
	    },
	
	    /**
	     * Checks whether the value represented by this object is greater than or equal to the other.
	     *
	     * @param  {Dinero} comparator - The Dinero object to compare to.
	     *
	     * @example
	     * // returns true
	     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 300 }))
	     * @example
	     * // returns true
	     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 500 }))
	     * @example
	     * // returns false
	     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 800 }))
	     * @example
	     * // returns true
	     * Dinero({ amount: 800 }).greaterThanOrEqual(Dinero({ amount: 5000, precision: 3 }))
	     * @example
	     * // returns true
	     * Dinero({ amount: 500 }).greaterThanOrEqual(Dinero({ amount: 5000, precision: 3 }))
	     * @example
	     * // returns false
	     * Dinero({ amount: 5000, precision: 3 }).greaterThanOrEqual(Dinero({ amount: 800 }))
	     *
	     * @throws {TypeError} If `comparator` has a different currency.
	     *
	     * @return {Boolean}
	     */
	    greaterThanOrEqual: function greaterThanOrEqual(comparator) {
	      assertSameCurrency.call(this, comparator);
	      var comparators = Dinero.normalizePrecision([this, comparator]);
	      return comparators[0].getAmount() >= comparators[1].getAmount();
	    },
	
	    /**
	     * Checks if the value represented by this object is zero.
	     *
	     * @example
	     * // returns true
	     * Dinero({ amount: 0 }).isZero()
	     * @example
	     * // returns false
	     * Dinero({ amount: 100 }).isZero()
	     *
	     * @return {Boolean}
	     */
	    isZero: function isZero() {
	      return this.getAmount() === 0;
	    },
	
	    /**
	     * Checks if the value represented by this object is positive.
	     *
	     * @example
	     * // returns false
	     * Dinero({ amount: -10 }).isPositive()
	     * @example
	     * // returns true
	     * Dinero({ amount: 10 }).isPositive()
	     * @example
	     * // returns true
	     * Dinero({ amount: 0 }).isPositive()
	     *
	     * @return {Boolean}
	     */
	    isPositive: function isPositive() {
	      return this.getAmount() >= 0;
	    },
	
	    /**
	     * Checks if the value represented by this object is negative.
	     *
	     * @example
	     * // returns true
	     * Dinero({ amount: -10 }).isNegative()
	     * @example
	     * // returns false
	     * Dinero({ amount: 10 }).isNegative()
	     * @example
	     * // returns false
	     * Dinero({ amount: 0 }).isNegative()
	     *
	     * @return {Boolean}
	     */
	    isNegative: function isNegative() {
	      return this.getAmount() < 0;
	    },
	
	    /**
	     * Checks if this has minor currency units.
	     * Deprecates {@link module:Dinero~hasCents hasCents}.
	     *
	     * @example
	     * // returns false
	     * Dinero({ amount: 1100 }).hasSubUnits()
	     * @example
	     * // returns true
	     * Dinero({ amount: 1150 }).hasSubUnits()
	     *
	     * @return {Boolean}
	     */
	    hasSubUnits: function hasSubUnits() {
	      return calculator$1.modulo(this.getAmount(), Math.pow(10, precision)) !== 0;
	    },
	
	    /**
	     * Checks if this has minor currency units.
	     *
	     * @deprecated since version 1.4.0, will be removed in 2.0.0
	     * Use {@link module:Dinero~hasSubUnits hasSubUnits} instead.
	     *
	     * @example
	     * // returns false
	     * Dinero({ amount: 1100 }).hasCents()
	     * @example
	     * // returns true
	     * Dinero({ amount: 1150 }).hasCents()
	     *
	     * @return {Boolean}
	     */
	    hasCents: function hasCents() {
	      return calculator$1.modulo(this.getAmount(), Math.pow(10, precision)) !== 0;
	    },
	
	    /**
	     * Checks whether the currency represented by this object equals to the other.
	     *
	     * @param  {Dinero}  comparator - The Dinero object to compare to.
	     *
	     * @example
	     * // returns true
	     * Dinero({ amount: 2000, currency: 'EUR' }).hasSameCurrency(Dinero({ amount: 1000, currency: 'EUR' }))
	     * @example
	     * // returns false
	     * Dinero({ amount: 1000, currency: 'EUR' }).hasSameCurrency(Dinero({ amount: 1000, currency: 'USD' }))
	     *
	     * @return {Boolean}
	     */
	    hasSameCurrency: function hasSameCurrency(comparator) {
	      return this.getCurrency() === comparator.getCurrency();
	    },
	
	    /**
	     * Checks whether the amount represented by this object equals to the other.
	     *
	     * @param  {Dinero}  comparator - The Dinero object to compare to.
	     *
	     * @example
	     * // returns true
	     * Dinero({ amount: 1000, currency: 'EUR' }).hasSameAmount(Dinero({ amount: 1000 }))
	     * @example
	     * // returns false
	     * Dinero({ amount: 2000, currency: 'EUR' }).hasSameAmount(Dinero({ amount: 1000, currency: 'EUR' }))
	     * @example
	     * // returns true
	     * Dinero({ amount: 1000, currency: 'EUR', precision: 2 }).hasSameAmount(Dinero({ amount: 10000, precision: 3 }))
	     * @example
	     * // returns false
	     * Dinero({ amount: 10000, currency: 'EUR', precision: 2 }).hasSameAmount(Dinero({ amount: 10000, precision: 3 }))
	     *
	     * @return {Boolean}
	     */
	    hasSameAmount: function hasSameAmount(comparator) {
	      var comparators = Dinero.normalizePrecision([this, comparator]);
	      return comparators[0].getAmount() === comparators[1].getAmount();
	    },
	
	    /**
	     * Returns this object formatted as a string.
	     *
	     * The format is a mask which defines how the output string will be formatted.
	     * It defines whether to display a currency, in what format, how many fraction digits to display and whether to use grouping separators.
	     * The output is formatted according to the applying locale.
	     *
	     * Object                       | Format            | String
	     * :--------------------------- | :---------------- | :---
	     * `Dinero({ amount: 500050 })` | `'$0,0.00'`       | $5,000.50
	     * `Dinero({ amount: 500050 })` | `'$0,0'`          | $5,001
	     * `Dinero({ amount: 500050 })` | `'$0'`            | $5001
	     * `Dinero({ amount: 500050 })` | `'$0.0'`          | $5000.5
	     * `Dinero({ amount: 500050 })` | `'USD0,0.0'`      | USD5,000.5
	     * `Dinero({ amount: 500050 })` | `'0,0.0 dollar'`  | 5,000.5 dollars
	     *
	     * Don't try to substitute the `$` sign or the `USD` code with your target currency, nor adapt the format string to the exact format you want.
	     * The format is a mask which defines a pattern and returns a valid, localized currency string.
	     * If you want to display the object in a custom way, either use {@link module:Dinero~getAmount getAmount}, {@link module:Dinero~toUnit toUnit} or {@link module:Dinero~toRoundedUnit toRoundedUnit} and manipulate the output string as you wish.
	     *
	     * {@link module:Dinero~toFormat toFormat} wraps around `Number.prototype.toLocaleString`. For that reason, **format will vary depending on how it's implemented in the end user's environment**.
	     *
	     * You can also use `toLocaleString` directly:
	     * `Dinero().toRoundedUnit(digits, roundingMode).toLocaleString(locale, options)`.
	     *
	     * By default, amounts are rounded using the **half away from zero** rule ([commercial rounding](https://en.wikipedia.org/wiki/Rounding#Round_half_away_from_zero)).
	     * You can also specify a different `roundingMode` to better fit your needs.
	     *
	     * @param  {String} [format='$0,0.00'] - The format mask to format to.
	     * @param  {String} [roundingMode='HALF_AWAY_FROM_ZERO'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
	     *
	     * @example
	     * // returns $2,000
	     * Dinero({ amount: 200000 }).toFormat('$0,0')
	     * @example
	     * // returns €50.5
	     * Dinero({ amount: 5050, currency: 'EUR' }).toFormat('$0,0.0')
	     * @example
	     * // returns 100 euros
	     * Dinero({ amount: 10000, currency: 'EUR' }).setLocale('fr-FR').toFormat('0,0 dollar')
	     * @example
	     * // returns 2000
	     * Dinero({ amount: 200000, currency: 'EUR' }).toFormat()
	     * @example
	     * // returns $10
	     * Dinero({ amount: 1050 }).toFormat('$0', 'HALF_EVEN')
	     *
	     * @return {String}
	     */
	    toFormat: function toFormat() {
	      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalFormat;
	      var roundingMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalFormatRoundingMode;
	      var formatter = Format(format);
	      return this.toRoundedUnit(formatter.getMinimumFractionDigits(), roundingMode).toLocaleString(this.getLocale(), {
	        currencyDisplay: formatter.getCurrencyDisplay(),
	        useGrouping: formatter.getUseGrouping(),
	        minimumFractionDigits: formatter.getMinimumFractionDigits(),
	        style: formatter.getStyle(),
	        currency: this.getCurrency()
	      });
	    },
	
	    /**
	     * Returns the amount represented by this object in units.
	     *
	     * @example
	     * // returns 10.5
	     * Dinero({ amount: 1050 }).toUnit()
	     * @example
	     * // returns 10.545
	     * Dinero({ amount: 10545, precision: 3 }).toUnit()
	     *
	     * @return {Number}
	     */
	    toUnit: function toUnit() {
	      return calculator$1.divide(this.getAmount(), Math.pow(10, precision));
	    },
	
	    /**
	     * Returns the amount represented by this object in rounded units.
	     *
	     * By default, the method uses the **half away from zero** rule ([commercial rounding](https://en.wikipedia.org/wiki/Rounding#Round_half_away_from_zero)).
	     * You can also specify a different `roundingMode` to better fit your needs.
	     *
	     * @example
	     * // returns 10.6
	     * Dinero({ amount: 1055 }).toRoundedUnit(1)
	     * @example
	     * // returns 10
	     * Dinero({ amount: 1050 }).toRoundedUnit(0, 'HALF_EVEN')
	     *
	     * @param  {Number} digits - The number of fraction digits to round to.
	     * @param  {String} [roundingMode='HALF_AWAY_FROM_ZERO'] - The rounding mode to use: `'HALF_ODD'`, `'HALF_EVEN'`, `'HALF_UP'`, `'HALF_DOWN'`, `'HALF_TOWARDS_ZERO'`, `'HALF_AWAY_FROM_ZERO'` or `'DOWN'`.
	     *
	     * @return {Number}
	     */
	    toRoundedUnit: function toRoundedUnit(digits) {
	      var roundingMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalFormatRoundingMode;
	      var factor = Math.pow(10, digits);
	      return calculator$1.divide(calculator$1.round(calculator$1.multiply(this.toUnit(), factor), roundingMode), factor);
	    },
	
	    /**
	     * Returns the object's data as an object literal.
	     *
	     * @example
	     * // returns { amount: 500, currency: 'EUR', precision: 2 }
	     * Dinero({ amount: 500, currency: 'EUR', precision: 2 }).toObject()
	     *
	     * @return {Object}
	     */
	    toObject: function toObject() {
	      return {
	        amount: amount,
	        currency: currency,
	        precision: precision
	      };
	    },
	
	    /**
	     * Returns the object's data as an object literal.
	     *
	     * Alias of {@link module:Dinero~toObject toObject}.
	     * It is defined so that calling `JSON.stringify` on a Dinero object will automatically extract the relevant data.
	     *
	     * @example
	     * // returns '{"amount":500,"currency":"EUR","precision":2}'
	     * JSON.stringify(Dinero({ amount: 500, currency: 'EUR', precision: 2 }))
	     *
	     * @return {Object}
	     */
	    toJSON: function toJSON() {
	      return this.toObject();
	    }
	  };
	};
	
	var dinero = Object.assign(Dinero, Defaults, Globals, Static);
	
	module.exports = dinero;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* Underscore.string
	* (c) 2010 Esa-Matti Suuronen <esa-matti aet suuronen dot org>
	* Underscore.string is freely distributable under the terms of the MIT license.
	* Documentation: https://github.com/epeli/underscore.string
	* Some code is borrowed from MooTools and Alexandru Marasteanu.
	* Version '3.3.6'
	* @preserve
	*/
	
	'use strict';
	
	function s(value) {
	  /* jshint validthis: true */
	  if (!(this instanceof s)) return new s(value);
	  this._wrapped = value;
	}
	
	s.VERSION = '3.3.6';
	
	s.isBlank          = __webpack_require__(1500);
	s.stripTags        = __webpack_require__(1930);
	s.capitalize       = __webpack_require__(1133);
	s.decapitalize     = __webpack_require__(1495);
	s.chop             = __webpack_require__(1894);
	s.trim             = __webpack_require__(455);
	s.clean            = __webpack_require__(1896);
	s.cleanDiacritics  = __webpack_require__(1493);
	s.count            = __webpack_require__(1897);
	s.chars            = __webpack_require__(1134);
	s.swapCase         = __webpack_require__(1932);
	s.escapeHTML       = __webpack_require__(1900);
	s.unescapeHTML     = __webpack_require__(1938);
	s.splice           = __webpack_require__(1501);
	s.insert           = __webpack_require__(1906);
	s.replaceAll       = __webpack_require__(1920);
	s.include          = __webpack_require__(1905);
	s.join             = __webpack_require__(1907);
	s.lines            = __webpack_require__(1909);
	s.dedent           = __webpack_require__(1898);
	s.reverse          = __webpack_require__(1921);
	s.startsWith       = __webpack_require__(1925);
	s.endsWith         = __webpack_require__(1899);
	s.pred             = __webpack_require__(1916);
	s.succ             = __webpack_require__(1931);
	s.titleize         = __webpack_require__(1933);
	s.camelize         = __webpack_require__(1492);
	s.underscored      = __webpack_require__(1504);
	s.dasherize        = __webpack_require__(1494);
	s.classify         = __webpack_require__(1895);
	s.humanize         = __webpack_require__(1904);
	s.ltrim            = __webpack_require__(1912);
	s.rtrim            = __webpack_require__(1136);
	s.truncate         = __webpack_require__(1937);
	s.prune            = __webpack_require__(1917);
	s.words            = __webpack_require__(1941);
	s.pad              = __webpack_require__(937);
	s.lpad             = __webpack_require__(1910);
	s.rpad             = __webpack_require__(1922);
	s.lrpad            = __webpack_require__(1911);
	s.sprintf          = __webpack_require__(1924);
	s.vsprintf         = __webpack_require__(1940);
	s.toNumber         = __webpack_require__(1935);
	s.numberFormat     = __webpack_require__(1915);
	s.strRight         = __webpack_require__(1928);
	s.strRightBack     = __webpack_require__(1929);
	s.strLeft          = __webpack_require__(1926);
	s.strLeftBack      = __webpack_require__(1927);
	s.toSentence       = __webpack_require__(1503);
	s.toSentenceSerial = __webpack_require__(1936);
	s.slugify          = __webpack_require__(1923);
	s.surround         = __webpack_require__(1502);
	s.quote            = __webpack_require__(1918);
	s.unquote          = __webpack_require__(1939);
	s.repeat           = __webpack_require__(1919);
	s.naturalCmp       = __webpack_require__(1914);
	s.levenshtein      = __webpack_require__(1908);
	s.toBoolean        = __webpack_require__(1934);
	s.exports          = __webpack_require__(1901);
	s.escapeRegExp     = __webpack_require__(1497);
	s.wrap             = __webpack_require__(1942);
	s.map              = __webpack_require__(1913);
	
	// Aliases
	s.strip     = s.trim;
	s.lstrip    = s.ltrim;
	s.rstrip    = s.rtrim;
	s.center    = s.lrpad;
	s.rjust     = s.lpad;
	s.ljust     = s.rpad;
	s.contains  = s.include;
	s.q         = s.quote;
	s.toBool    = s.toBoolean;
	s.camelcase = s.camelize;
	s.mapChars  = s.map;
	
	
	// Implement chaining
	s.prototype = {
	  value: function value() {
	    return this._wrapped;
	  }
	};
	
	function fn2method(key, fn) {
	  if (typeof fn !== 'function') return;
	  s.prototype[key] = function() {
	    var args = [this._wrapped].concat(Array.prototype.slice.call(arguments));
	    var res = fn.apply(null, args);
	    // if the result is non-string stop the chain and return the value
	    return typeof res === 'string' ? new s(res) : res;
	  };
	}
	
	// Copy functions to instance methods for chaining
	for (var key in s) fn2method(key, s[key]);
	
	fn2method('tap', function tap(string, fn) {
	  return fn(string);
	});
	
	function prototype2method(methodName) {
	  fn2method(methodName, function(context) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return String.prototype[methodName].apply(context, args);
	  });
	}
	
	var prototypeMethods = [
	  'toUpperCase',
	  'toLowerCase',
	  'split',
	  'replace',
	  'slice',
	  'substring',
	  'substr',
	  'concat'
	];
	
	for (var method in prototypeMethods) prototype2method(prototypeMethods[method]);
	
	
	module.exports = s;


/***/ },
/* 29 */,
/* 30 */
[2098, 1515],
/* 31 */
[1955, 1, 4],
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {(function() {
	
	  // Unsaved Record Keeping
	  // ----------------------
	
	  // Collection of all models in an app that have unsaved changes.
	  var unsavedModels = [];
	
	  // If the given model has unsaved changes then add it to
	  // the `unsavedModels` collection, otherwise remove it.
	  var updateUnsavedModels = function(model) {
	    if (!_.isEmpty(model._unsavedChanges)) {
	      if (!_.findWhere(unsavedModels, {cid:model.cid})) unsavedModels.push(model);
	    } else {
	      unsavedModels = _.filter(unsavedModels, function(m) { return model.cid != m.cid; });
	    }
	  };
	
	  // Unload Handlers
	  // ---------------
	
	  // Helper which returns a prompt message for an unload handler.
	  // Uses the given function name (one of the callback names
	  // from the `model.unsaved` configuration hash) to evaluate
	  // whether a prompt is needed/returned.
	  var getPrompt = function(fnName) {
	    var prompt, args = _.rest(arguments);
	    // Evaluate and return a boolean result. The given `fn` may be a
	    // boolean value, a function, or the name of a function on the model.
	    var evaluateModelFn = function(model, fn) {
	      if (_.isBoolean(fn)) return fn;
	      return (_.isString(fn) ? model[fn] : fn).apply(model, args);
	    };
	    _.each(unsavedModels, function(model) {
	      if (!prompt && evaluateModelFn(model, model._unsavedConfig[fnName]))
	        prompt = model._unsavedConfig.prompt;
	    });
	    return prompt;
	  };
	
	  // Wrap Backbone.History.navigate so that in-app routing
	  // (`router.navigate('/path')`) can be intercepted with a
	  // confirmation if there are any unsaved models.
	  Backbone.History.prototype.navigate = _.wrap(Backbone.History.prototype.navigate, function(oldNav, fragment, options) {
	    var prompt = getPrompt('unloadRouterPrompt', fragment, options);
	    if (prompt) {
	      if (confirm(prompt + ' \n\nAre you sure you want to leave this page?')) {
	        oldNav.call(this, fragment, options);
	      }
	    } else {
	      oldNav.call(this, fragment, options);
	    }
	  });
	
	  // Create a browser unload handler which is triggered
	  // on the refresh, back, or forward button.
	  window.onbeforeunload = function(e) {
	    return getPrompt('unloadWindowPrompt', e);
	  };
	
	  // Backbone.Model API
	  // ------------------
	
	  _.extend(Backbone.Model.prototype, {
	
	    unsaved: {},
	    _trackingChanges: false,
	    _originalAttrs: {},
	    _unsavedChanges: {},
	
	    // Opt in to tracking attribute changes
	    // between saves.
	    startTracking: function() {
	      this._unsavedConfig = _.extend({}, {
	        prompt: 'You have unsaved changes!',
	        unloadRouterPrompt: false,
	        unloadWindowPrompt: false
	      }, this.unsaved || {});
	      this._trackingChanges = true;
	      this._resetTracking();
	      this._triggerUnsavedChanges();
	      return this;
	    },
	
	    // Resets the default tracking values
	    // and stops tracking attribute changes.
	    stopTracking: function() {
	      this._trackingChanges = false;
	      this._originalAttrs = {};
	      this._unsavedChanges = {};
	      this._triggerUnsavedChanges();
	      return this;
	    },
	
	    // Gets rid of accrued changes and
	    // resets state.
	    restartTracking: function() {
	      this._resetTracking();
	      this._triggerUnsavedChanges();
	      return this;
	    },
	
	    // Restores this model's attributes to
	    // their original values since tracking
	    // started, the last save, or last restart.
	    resetAttributes: function() {
	      if (!this._trackingChanges) return;
	      this.attributes = this._originalAttrs;
	      this._resetTracking();
	      this._triggerUnsavedChanges();
	      return this;
	    },
	
	    // Symmetric to Backbone's `model.changedAttributes()`,
	    // except that this returns a hash of the model's attributes that
	    // have changed since the last save, or `false` if there are none.
	    // Like `changedAttributes`, an external attributes hash can be
	    // passed in, returning the attributes in that hash which differ
	    // from the model.
	    unsavedAttributes: function(attrs) {
	      if (!attrs) return _.isEmpty(this._unsavedChanges) ? false : _.clone(this._unsavedChanges);
	      var val, changed = false, old = this._unsavedChanges;
	      for (var attr in attrs) {
	        if (_.isEqual(old[attr], (val = attrs[attr]))) continue;
	        (changed || (changed = {}))[attr] = val;
	      }
	      return changed;
	    },
	
	    _resetTracking: function() {
	      this._originalAttrs = _.clone(this.attributes);
	      this._unsavedChanges = {};
	    },
	
	    // Trigger an `unsavedChanges` event on this model,
	    // supplying the result of whether there are unsaved
	    // changes and a changed attributes hash.
	    _triggerUnsavedChanges: function() {
	      this.trigger('unsavedChanges', !_.isEmpty(this._unsavedChanges), _.clone(this._unsavedChanges), this);
	      if (this.unsaved) updateUnsavedModels(this);
	    }
	  });
	
	  // Wrap `model.set()` and update the internal
	  // unsaved changes record keeping.
	  Backbone.Model.prototype.set = _.wrap(Backbone.Model.prototype.set, function(oldSet, key, val, options) {
	    var attrs, ret;
	    if (key == null) return this;
	    // Handle both `"key", value` and `{key: value}` -style arguments.
	    if (typeof key === 'object') {
	      attrs = key;
	      options = val;
	    } else {
	      (attrs = {})[key] = val;
	    }
	    options || (options = {});
	
	    // Delegate to Backbone's set.
	    ret = oldSet.call(this, attrs, options);
	
	    if (this._trackingChanges && !options.silent && !options.trackit_silent) {
	      _.each(attrs, _.bind(function(val, key) {
	        if (_.isEqual(this._originalAttrs[key], val))
	          delete this._unsavedChanges[key];
	        else
	          this._unsavedChanges[key] = val;
	      }, this));
	      this._triggerUnsavedChanges();
	    }
	    return ret;
	  });
	
	  // Intercept `model.save()` and reset tracking/unsaved
	  // changes if it was successful.
	  Backbone.sync = _.wrap(Backbone.sync, function(oldSync, method, model, options) {
	    options || (options = {});
	
	    if (method == 'update' || method == 'create' || method == 'patch') {
	      options.success = _.wrap(options.success, _.bind(function(oldSuccess, data, textStatus, jqXHR) {
	        var ret;
	        if (oldSuccess) ret = oldSuccess.call(this, data, textStatus, jqXHR);
	        if (model._trackingChanges) {
	          model._resetTracking();
	          model._triggerUnsavedChanges();
	        }
	        return ret;
	      }, this));
	    }
	    return oldSync(method, model, options);
	  });
	
	})();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ function(module, exports) {

	module.exports = function escape(url) {
	    if (typeof url !== 'string') {
	        return url
	    }
	    // If url is already wrapped in quotes, remove them
	    if (/^['"].*['"]$/.test(url)) {
	        url = url.slice(1, -1);
	    }
	    // Should url be wrapped?
	    // See https://drafts.csswg.org/css-values-3/#urls
	    if (/["'() \t\n]/.test(url)) {
	        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
	    }
	
	    return url
	}


/***/ },
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1599), __esModule: true };

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1753);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./core.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./core.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(220)
	  , core      = __webpack_require__(469)
	  , hide      = __webpack_require__(374)
	  , redefine  = __webpack_require__(342)
	  , ctx       = __webpack_require__(372)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target && !own)redefine(target, key, out);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ },
/* 57 */,
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  backgrid 0.3.8
	  http://github.com/cloudflare/backgrid
	
	  Copyright (c) 2017 Cloudflare, Inc. and contributors <jwong@cloudflare.com>
	  Licensed under the MIT license.
	*/
	
	(function (root, factory) {
	
	  if (true) {
	    // AMD (+ global for extensions)
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone) {
	      return (root.Backgrid = factory(_, Backbone));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === "object") {
	    // CommonJS
	    module.exports = factory(require("underscore"), require("backbone"));
	  } else {
	    // Browser
	    root.Backgrid = factory(root._, root.Backbone);
	  }}(this, function (_, Backbone) {
	
	  "use strict";
	
	/*
	  backgrid
	  http://github.com/cloudflare/backgrid
	
	  Copyright (c) 2013-present Cloudflare, Inc. and contributors
	  Licensed under the MIT license.
	*/
	
	// Copyright 2009, 2010 Kristopher Michael Kowal
	// https://github.com/kriskowal/es5-shim
	// ES5 15.5.4.20
	// http://es5.github.com/#x15.5.4.20
	var ws = "\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003" +
	  "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028" +
	  "\u2029\uFEFF";
	if (!String.prototype.trim || ws.trim()) {
	  // http://blog.stevenlevithan.com/archives/faster-trim-javascript
	  // http://perfectionkills.com/whitespace-deviations/
	  ws = "[" + ws + "]";
	  var trimBeginRegexp = new RegExp("^" + ws + ws + "*"),
	  trimEndRegexp = new RegExp(ws + ws + "*$");
	  String.prototype.trim = function trim() {
	    if (this === undefined || this === null) {
	      throw new TypeError("can't convert " + this + " to object");
	    }
	    return String(this)
	      .replace(trimBeginRegexp, "")
	      .replace(trimEndRegexp, "");
	  };
	}
	
	function lpad(str, length, padstr) {
	  var paddingLen = length - (str + '').length;
	  paddingLen =  paddingLen < 0 ? 0 : paddingLen;
	  var padding = '';
	  for (var i = 0; i < paddingLen; i++) {
	    padding = padding + padstr;
	  }
	  return padding + str;
	}
	
	var $ = Backbone.$;
	
	var Backgrid = {
	
	  Extension: {},
	
	  resolveNameToClass: function (name, suffix) {
	    if (_.isString(name)) {
	      var key = _.map(name.split('-'), function (e) {
	        return e.slice(0, 1).toUpperCase() + e.slice(1);
	      }).join('') + suffix;
	      var klass = Backgrid[key] || Backgrid.Extension[key];
	      if (_.isUndefined(klass)) {
	        throw new ReferenceError("Class '" + key + "' not found");
	      }
	      return klass;
	    }
	
	    return name;
	  },
	
	  callByNeed: function () {
	    var value = arguments[0];
	    if (!_.isFunction(value)) return value;
	
	    var context = arguments[1];
	    var args = [].slice.call(arguments, 2);
	    return value.apply(context, !!(args + '') ? args : []);
	  }
	
	};
	_.extend(Backgrid, Backbone.Events);
	
	/**
	   Command translates a DOM Event into commands that Backgrid
	   recognizes. Interested parties can listen on selected Backgrid events that
	   come with an instance of this class and act on the commands.
	
	   It is also possible to globally rebind the keyboard shortcuts by replacing
	   the methods in this class' prototype.
	
	   @class Backgrid.Command
	   @constructor
	 */
	var Command = Backgrid.Command = function (evt) {
	  _.extend(this, {
	    altKey: !!evt.altKey,
	    "char": evt["char"],
	    charCode: evt.charCode,
	    ctrlKey: !!evt.ctrlKey,
	    key: evt.key,
	    keyCode: evt.keyCode,
	    locale: evt.locale,
	    location: evt.location,
	    metaKey: !!evt.metaKey,
	    repeat: !!evt.repeat,
	    shiftKey: !!evt.shiftKey,
	    which: evt.which
	  });
	};
	_.extend(Command.prototype, {
	  /**
	     Up Arrow
	
	     @member Backgrid.Command
	   */
	  moveUp: function () { return this.keyCode == 38; },
	  /**
	     Down Arrow
	
	     @member Backgrid.Command
	   */
	  moveDown: function () { return this.keyCode === 40; },
	  /**
	     Shift Tab
	
	     @member Backgrid.Command
	   */
	  moveLeft: function () { return this.shiftKey && this.keyCode === 9; },
	  /**
	     Tab
	
	     @member Backgrid.Command
	   */
	  moveRight: function () { return !this.shiftKey && this.keyCode === 9; },
	  /**
	     Enter
	
	     @member Backgrid.Command
	   */
	  save: function () { return this.keyCode === 13; },
	  /**
	     Esc
	
	     @member Backgrid.Command
	   */
	  cancel: function () { return this.keyCode === 27; },
	  /**
	     None of the above.
	
	     @member Backgrid.Command
	   */
	  passThru: function () {
	    return !(this.moveUp() || this.moveDown() || this.moveLeft() ||
	             this.moveRight() || this.save() || this.cancel());
	  }
	});
	
	/*
	  backgrid
	  http://github.com/cloudflare/backgrid
	
	  Copyright (c) 2013-present Cloudflare, Inc. and contributors
	  Licensed under the MIT license.
	*/
	
	/**
	   Just a convenient class for interested parties to subclass.
	
	   The default Cell classes don't require the formatter to be a subclass of
	   Formatter as long as the fromRaw(rawData) and toRaw(formattedData) methods
	   are defined.
	
	   @abstract
	   @class Backgrid.CellFormatter
	   @constructor
	*/
	var CellFormatter = Backgrid.CellFormatter = function () {};
	_.extend(CellFormatter.prototype, {
	
	  /**
	     Takes a raw value from a model and returns an optionally formatted string
	     for display. The default implementation simply returns the supplied value
	     as is without any type conversion.
	
	     @member Backgrid.CellFormatter
	     @param {*} rawData
	     @param {Backbone.Model} model Used for more complicated formatting
	     @return {*}
	  */
	  fromRaw: function (rawData, model) {
	    return rawData;
	  },
	
	  /**
	     Takes a formatted string, usually from user input, and returns a
	     appropriately typed value for persistence in the model.
	
	     If the user input is invalid or unable to be converted to a raw value
	     suitable for persistence in the model, toRaw must return `undefined`.
	
	     @member Backgrid.CellFormatter
	     @param {string} formattedData
	     @param {Backbone.Model} model Used for more complicated formatting
	     @return {*|undefined}
	  */
	  toRaw: function (formattedData, model) {
	    return formattedData;
	  }
	
	});
	
	/**
	   A floating point number formatter. Doesn't understand scientific notation at
	   the moment.
	
	   @class Backgrid.NumberFormatter
	   @extends Backgrid.CellFormatter
	   @constructor
	   @throws {RangeError} If decimals < 0 or > 20.
	*/
	var NumberFormatter = Backgrid.NumberFormatter = function (options) {
	  _.extend(this, this.defaults, options || {});
	
	  if (this.decimals < 0 || this.decimals > 20) {
	    throw new RangeError("decimals must be between 0 and 20");
	  }
	};
	NumberFormatter.prototype = new CellFormatter();
	_.extend(NumberFormatter.prototype, {
	
	  /**
	     @member Backgrid.NumberFormatter
	     @cfg {Object} options
	
	     @cfg {number} [options.decimals=2] Number of decimals to display. Must be an integer.
	
	     @cfg {string} [options.decimalSeparator='.'] The separator to use when
	     displaying decimals.
	
	     @cfg {string} [options.orderSeparator=','] The separator to use to
	     separator thousands. May be an empty string.
	   */
	  defaults: {
	    decimals: 2,
	    decimalSeparator: '.',
	    orderSeparator: ','
	  },
	
	  HUMANIZED_NUM_RE: /(\d)(?=(?:\d{3})+$)/g,
	
	  /**
	     Takes a floating point number and convert it to a formatted string where
	     every thousand is separated by `orderSeparator`, with a `decimal` number of
	     decimals separated by `decimalSeparator`. The number returned is rounded
	     the usual way.
	
	     @member Backgrid.NumberFormatter
	     @param {number} number
	     @param {Backbone.Model} model Used for more complicated formatting
	     @return {string}
	  */
	  fromRaw: function (number, model) {
	    if (_.isNull(number) || _.isUndefined(number)) return '';
	
	    number = parseFloat(number).toFixed(~~this.decimals);
	
	    var parts = number.split('.');
	    var integerPart = parts[0];
	    var decimalPart = parts[1] ? (this.decimalSeparator || '.') + parts[1] : '';
	
	    return integerPart.replace(this.HUMANIZED_NUM_RE, '$1' + this.orderSeparator) + decimalPart;
	  },
	
	  /**
	     Takes a string, possibly formatted with `orderSeparator` and/or
	     `decimalSeparator`, and convert it back to a number.
	
	     @member Backgrid.NumberFormatter
	     @param {string} formattedData
	     @param {Backbone.Model} model Used for more complicated formatting
	     @return {number|undefined} Undefined if the string cannot be converted to
	     a number.
	  */
	  toRaw: function (formattedData, model) {
	    formattedData = formattedData.trim();
	
	    if (formattedData === '') return null;
	
	    var rawData = '';
	
	    var thousands = formattedData.split(this.orderSeparator);
	    for (var i = 0; i < thousands.length; i++) {
	      rawData += thousands[i];
	    }
	
	    var decimalParts = rawData.split(this.decimalSeparator);
	    rawData = '';
	    for (var i = 0; i < decimalParts.length; i++) {
	      rawData = rawData + decimalParts[i] + '.';
	    }
	
	    if (rawData[rawData.length - 1] === '.') {
	      rawData = rawData.slice(0, rawData.length - 1);
	    }
	
	    var result = (rawData * 1).toFixed(~~this.decimals) * 1;
	    if (_.isNumber(result) && !_.isNaN(result)) return result;
	  }
	
	});
	
	/**
	   A number formatter that converts a floating point number, optionally
	   multiplied by a multiplier, to a percentage string and vice versa.
	
	   @class Backgrid.PercentFormatter
	   @extends Backgrid.NumberFormatter
	   @constructor
	   @throws {RangeError} If decimals < 0 or > 20.
	 */
	var PercentFormatter = Backgrid.PercentFormatter = function () {
	  Backgrid.NumberFormatter.apply(this, arguments);
	};
	
	PercentFormatter.prototype = new Backgrid.NumberFormatter(),
	
	_.extend(PercentFormatter.prototype, {
	
	  /**
	     @member Backgrid.PercentFormatter
	     @cfg {Object} options
	
	     @cfg {number} [options.multiplier=1] The number used to multiply the model
	     value for display.
	
	     @cfg {string} [options.symbol='%'] The symbol to append to the percentage
	     string.
	   */
	  defaults: _.extend({}, NumberFormatter.prototype.defaults, {
	    multiplier: 1,
	    symbol: "%"
	  }),
	
	  /**
	     Takes a floating point number, where the number is first multiplied by
	     `multiplier`, then converted to a formatted string like
	     NumberFormatter#fromRaw, then finally append `symbol` to the end.
	
	     @member Backgrid.PercentFormatter
	     @param {number} rawValue
	     @param {Backbone.Model} model Used for more complicated formatting
	     @return {string}
	  */
	  fromRaw: function (number, model) {
	    var args = [].slice.call(arguments, 1);
	    args.unshift(number * this.multiplier);
	    return (NumberFormatter.prototype.fromRaw.apply(this, args) || "0") + this.symbol;
	  },
	
	  /**
	     Takes a string, possibly appended with `symbol` and/or `decimalSeparator`,
	     and convert it back to a number for the model like NumberFormatter#toRaw,
	     and then dividing it by `multiplier`.
	
	     @member Backgrid.PercentFormatter
	     @param {string} formattedData
	     @param {Backbone.Model} model Used for more complicated formatting
	     @return {number|undefined} Undefined if the string cannot be converted to
	     a number.
	  */
	  toRaw: function (formattedValue, model) {
	    var tokens = formattedValue.split(this.symbol);
	    if (tokens && tokens[0] && tokens[1] === "" || tokens[1] == null) {
	      var rawValue = NumberFormatter.prototype.toRaw.call(this, tokens[0]);
	      if (_.isUndefined(rawValue)) return rawValue;
	      return rawValue / this.multiplier;
	    }
	  }
	
	});
	
	/**
	   Formatter to converts between various datetime formats.
	
	   This class only understands ISO-8601 formatted datetime strings and UNIX
	   offset (number of milliseconds since UNIX Epoch). See
	   Backgrid.Extension.MomentFormatter if you need a much more flexible datetime
	   formatter.
	
	   @class Backgrid.DatetimeFormatter
	   @extends Backgrid.CellFormatter
	   @constructor
	   @throws {Error} If both `includeDate` and `includeTime` are false.
	*/
	var DatetimeFormatter = Backgrid.DatetimeFormatter = function (options) {
	  _.extend(this, this.defaults, options || {});
	
	  if (!this.includeDate && !this.includeTime) {
	    throw new Error("Either includeDate or includeTime must be true");
	  }
	};
	DatetimeFormatter.prototype = new CellFormatter();
	_.extend(DatetimeFormatter.prototype, {
	
	  /**
	     @member Backgrid.DatetimeFormatter
	
	     @cfg {Object} options
	
	     @cfg {boolean} [options.includeDate=true] Whether the values include the
	     date part.
	
	     @cfg {boolean} [options.includeTime=true] Whether the values include the
	     time part.
	
	     @cfg {boolean} [options.includeMilli=false] If `includeTime` is true,
	     whether to include the millisecond part, if it exists.
	   */
	  defaults: {
	    includeDate: true,
	    includeTime: true,
	    includeMilli: false
	  },
	
	  DATE_RE: /^([+\-]?\d{4})-(\d{2})-(\d{2})$/,
	  TIME_RE: /^(\d{2}):(\d{2}):(\d{2})(\.(\d{3}))?$/,
	  ISO_SPLITTER_RE: /T|Z| +/,
	
	  _convert: function (data, validate) {
	    if ((data + '').trim() === '') return null;
	
	    var date, time = null;
	    if (_.isNumber(data)) {
	      var jsDate = new Date(data);
	      date = lpad(jsDate.getUTCFullYear(), 4, 0) + '-' + lpad(jsDate.getUTCMonth() + 1, 2, 0) + '-' + lpad(jsDate.getUTCDate(), 2, 0);
	      time = lpad(jsDate.getUTCHours(), 2, 0) + ':' + lpad(jsDate.getUTCMinutes(), 2, 0) + ':' + lpad(jsDate.getUTCSeconds(), 2, 0);
	    }
	    else {
	      data = data.trim();
	      var parts = data.split(this.ISO_SPLITTER_RE) || [];
	      date = this.DATE_RE.test(parts[0]) ? parts[0] : '';
	      time = date && parts[1] ? parts[1] : this.TIME_RE.test(parts[0]) ? parts[0] : '';
	    }
	
	    var YYYYMMDD = this.DATE_RE.exec(date) || [];
	    var HHmmssSSS = this.TIME_RE.exec(time) || [];
	
	    if (validate) {
	      if (this.includeDate && _.isUndefined(YYYYMMDD[0])) return;
	      if (this.includeTime && _.isUndefined(HHmmssSSS[0])) return;
	      if (!this.includeDate && date) return;
	      if (!this.includeTime && time) return;
	    }
	
	    var jsDate = new Date(Date.UTC(YYYYMMDD[1] * 1 || 0,
	                                   YYYYMMDD[2] * 1 - 1 || 0,
	                                   YYYYMMDD[3] * 1 || 0,
	                                   HHmmssSSS[1] * 1 || null,
	                                   HHmmssSSS[2] * 1 || null,
	                                   HHmmssSSS[3] * 1 || null,
	                                   HHmmssSSS[5] * 1 || null));
	
	    var result = '';
	
	    if (this.includeDate) {
	      result = lpad(jsDate.getUTCFullYear(), 4, 0) + '-' + lpad(jsDate.getUTCMonth() + 1, 2, 0) + '-' + lpad(jsDate.getUTCDate(), 2, 0);
	    }
	
	    if (this.includeTime) {
	      result = result + (this.includeDate ? 'T' : '') + lpad(jsDate.getUTCHours(), 2, 0) + ':' + lpad(jsDate.getUTCMinutes(), 2, 0) + ':' + lpad(jsDate.getUTCSeconds(), 2, 0);
	
	      if (this.includeMilli) {
	        result = result + '.' + lpad(jsDate.getUTCMilliseconds(), 3, 0);
	      }
	    }
	
	    if (this.includeDate && this.includeTime) {
	      result += "Z";
	    }
	
	    return result;
	  },
	
	  /**
	     Converts an ISO-8601 formatted datetime string to a datetime string, date
	     string or a time string. The timezone is ignored if supplied.
	
	     @member Backgrid.DatetimeFormatter
	     @param {string} rawData
	     @param {Backbone.Model} model Used for more complicated formatting
	     @return {string|null|undefined} ISO-8601 string in UTC. Null and undefined
	     values are returned as is.
	  */
	  fromRaw: function (rawData, model) {
	    if (_.isNull(rawData) || _.isUndefined(rawData)) return '';
	    return this._convert(rawData);
	  },
	
	  /**
	     Converts an ISO-8601 formatted datetime string to a datetime string, date
	     string or a time string. The timezone is ignored if supplied. This method
	     parses the input values exactly the same way as
	     Backgrid.Extension.MomentFormatter#fromRaw(), in addition to doing some
	     sanity checks.
	
	     @member Backgrid.DatetimeFormatter
	     @param {string} formattedData
	     @param {Backbone.Model} model Used for more complicated formatting
	     @return {string|undefined} ISO-8601 string in UTC. Undefined if a date is
	     found when `includeDate` is false, or a time is found when `includeTime` is
	     false, or if `includeDate` is true and a date is not found, or if
	     `includeTime` is true and a time is not found.
	  */
	  toRaw: function (formattedData, model) {
	    return this._convert(formattedData, true);
	  }
	
	});
	
	/**
	   Formatter to convert any value to string.
	
	   @class Backgrid.StringFormatter
	   @extends Backgrid.CellFormatter
	   @constructor
	 */
	var StringFormatter = Backgrid.StringFormatter = function () {};
	StringFormatter.prototype = new CellFormatter();
	_.extend(StringFormatter.prototype, {
	  /**
	     Converts any value to a string using Ecmascript's implicit type
	     conversion. If the given value is `null` or `undefined`, an empty string is
	     returned instead.
	
	     @member Backgrid.StringFormatter
	     @param {*} rawValue
	     @param {Backbone.Model} model Used for more complicated formatting
	     @return {string}
	   */
	  fromRaw: function (rawValue, model) {
	    if (_.isUndefined(rawValue) || _.isNull(rawValue)) return '';
	    return rawValue + '';
	  }
	});
	
	/**
	   Simple email validation formatter.
	
	   @class Backgrid.EmailFormatter
	   @extends Backgrid.CellFormatter
	   @constructor
	 */
	var EmailFormatter = Backgrid.EmailFormatter = function () {};
	EmailFormatter.prototype = new CellFormatter();
	_.extend(EmailFormatter.prototype, {
	  /**
	     Return the input if it is a string that contains an '@' character and if
	     the strings before and after '@' are non-empty. If the input does not
	     validate, `undefined` is returned.
	
	     @member Backgrid.EmailFormatter
	     @param {*} formattedData
	     @param {Backbone.Model} model Used for more complicated formatting
	     @return {string|undefined}
	   */
	  toRaw: function (formattedData, model) {
	    var parts = formattedData.trim().split("@");
	    if (parts.length === 2 && _.all(parts)) {
	      return formattedData;
	    }
	  }
	});
	
	/**
	   Formatter for SelectCell.
	
	   If the type of a model value is not a string, it is expected that a subclass
	   of this formatter is provided to the SelectCell, with #toRaw overridden to
	   convert the string value returned from the DOM back to whatever value is
	   expected in the model.
	
	   @class Backgrid.SelectFormatter
	   @extends Backgrid.CellFormatter
	   @constructor
	*/
	var SelectFormatter = Backgrid.SelectFormatter = function () {};
	SelectFormatter.prototype = new CellFormatter();
	_.extend(SelectFormatter.prototype, {
	
	  /**
	     Normalizes raw scalar or array values to an array.
	
	     @member Backgrid.SelectFormatter
	     @param {*} rawValue
	     @param {Backbone.Model} model Used for more complicated formatting
	     @return {Array.<*>}
	  */
	  fromRaw: function (rawValue, model) {
	    return _.isArray(rawValue) ? rawValue : rawValue != null ? [rawValue] : [];
	  }
	});
	
	/*
	  backgrid
	  http://github.com/cloudflare/backgrid
	
	  Copyright (c) 2013-present Cloudflare, Inc. and contributors
	  Licensed under the MIT license.
	*/
	
	/**
	   Generic cell editor base class. Only defines an initializer for a number of
	   required parameters.
	
	   @abstract
	   @class Backgrid.CellEditor
	   @extends Backbone.View
	*/
	var CellEditor = Backgrid.CellEditor = Backbone.View.extend({
	
	  /**
	     Initializer.
	
	     @param {Object} options
	     @param {Backgrid.CellFormatter} options.formatter
	     @param {Backgrid.Column} options.column
	     @param {Backbone.Model} options.model
	
	     @throws {TypeError} If `formatter` is not a formatter instance, or when
	     `model` or `column` are undefined.
	  */
	  initialize: function (options) {
	    this.formatter = options.formatter;
	    this.column = options.column;
	    if (!(this.column instanceof Column)) {
	      this.column = new Column(this.column);
	    }
	
	    this.listenTo(this.model, "backgrid:editing", this.postRender);
	  },
	
	  /**
	     Post-rendering setup and initialization. Focuses the cell editor's `el` in
	     this default implementation. **Should** be called by Cell classes after
	     calling Backgrid.CellEditor#render.
	  */
	  postRender: function (model, column) {
	    if (column == null || column.get("name") == this.column.get("name")) {
	      this.$el.focus();
	    }
	    return this;
	  }
	
	});
	
	/**
	   InputCellEditor the cell editor type used by most core cell types. This cell
	   editor renders a text input box as its editor. The input will render a
	   placeholder if the value is empty on supported browsers.
	
	   @class Backgrid.InputCellEditor
	   @extends Backgrid.CellEditor
	*/
	var InputCellEditor = Backgrid.InputCellEditor = CellEditor.extend({
	
	  /** @property */
	  tagName: "input",
	
	  /** @property */
	  attributes: {
	    type: "text"
	  },
	
	  /** @property */
	  events: {
	    "blur": "saveOrCancel",
	    "keydown": "saveOrCancel"
	  },
	
	  /**
	     Initializer. Removes this `el` from the DOM when a `done` event is
	     triggered.
	
	     @param {Object} options
	     @param {Backgrid.CellFormatter} options.formatter
	     @param {Backgrid.Column} options.column
	     @param {Backbone.Model} options.model
	     @param {string} [options.placeholder]
	  */
	  initialize: function (options) {
	    InputCellEditor.__super__.initialize.apply(this, arguments);
	
	    if (options.placeholder) {
	      this.$el.attr("placeholder", options.placeholder);
	    }
	  },
	
	  /**
	     Renders a text input with the cell value formatted for display, if it
	     exists.
	  */
	  render: function () {
	    var model = this.model;
	    this.$el.val(this.formatter.fromRaw(model.get(this.column.get("name")), model));
	    return this;
	  },
	
	  /**
	     If the key pressed is `enter`, `tab`, `up`, or `down`, converts the value
	     in the editor to a raw value for saving into the model using the formatter.
	
	     If the key pressed is `esc` the changes are undone.
	
	     If the editor goes out of focus (`blur`) but the value is invalid, the
	     event is intercepted and cancelled so the cell remains in focus pending for
	     further action. The changes are saved otherwise.
	
	     Triggers a Backbone `backgrid:edited` event from the model when successful,
	     and `backgrid:error` if the value cannot be converted. Classes listening to
	     the `error` event, usually the Cell classes, should respond appropriately,
	     usually by rendering some kind of error feedback.
	
	     @param {Event} e
	  */
	  saveOrCancel: function (e) {
	
	    var formatter = this.formatter;
	    var model = this.model;
	    var column = this.column;
	
	    var command = new Command(e);
	    var blurred = e.type === "blur";
	
	    if (command.moveUp() || command.moveDown() || command.moveLeft() || command.moveRight() ||
	        command.save() || blurred) {
	
	      e.preventDefault();
	      e.stopPropagation();
	
	      var val = this.$el.val();
	      var newValue = formatter.toRaw(val, model);
	      if (_.isUndefined(newValue)) {
	        model.trigger("backgrid:error", model, column, val);
	      }
	      else {
	        model.set(column.get("name"), newValue);
	        model.trigger("backgrid:edited", model, column, command);
	      }
	    }
	    // esc
	    else if (command.cancel()) {
	      // undo
	      e.stopPropagation();
	      model.trigger("backgrid:edited", model, column, command);
	    }
	  },
	
	  postRender: function (model, column) {
	    if (column == null || column.get("name") == this.column.get("name")) {
	      // move the cursor to the end on firefox if text is right aligned
	      if (this.$el.css("text-align") === "right") {
	        var val = this.$el.val();
	        this.$el.focus().val(null).val(val);
	      }
	      else this.$el.focus();
	    }
	    return this;
	  }
	
	});
	
	/**
	   The super-class for all Cell types. By default, this class renders a plain
	   table cell with the model value converted to a string using the
	   formatter. The table cell is clickable, upon which the cell will go into
	   editor mode, which is rendered by a Backgrid.InputCellEditor instance by
	   default. Upon encountering any formatting errors, this class will add an
	   `error` CSS class to the table cell.
	
	   @abstract
	   @class Backgrid.Cell
	   @extends Backbone.View
	*/
	var Cell = Backgrid.Cell = Backbone.View.extend({
	
	  /** @property */
	  tagName: "td",
	
	  /**
	     @property {Backgrid.CellFormatter|Object|string} [formatter=CellFormatter]
	  */
	  formatter: CellFormatter,
	
	  /**
	     @property {Backgrid.CellEditor} [editor=Backgrid.InputCellEditor] The
	     default editor for all cell instances of this class. This value must be a
	     class, it will be automatically instantiated upon entering edit mode.
	
	     See Backgrid.CellEditor
	  */
	  editor: InputCellEditor,
	
	  /** @property */
	  events: {
	    "click": "enterEditMode"
	  },
	
	  /**
	     Initializer.
	
	     @param {Object} options
	     @param {Backbone.Model} options.model
	     @param {Backgrid.Column} options.column
	
	     @throws {ReferenceError} If formatter is a string but a formatter class of
	     said name cannot be found in the Backgrid module.
	  */
	  initialize: function (options) {
	    this.column = options.column;
	    if (!(this.column instanceof Column)) {
	      this.column = new Column(this.column);
	    }
	
	    var column = this.column, model = this.model, $el = this.$el;
	
	    var formatter = Backgrid.resolveNameToClass(column.get("formatter") ||
	                                                this.formatter, "Formatter");
	
	    if (!_.isFunction(formatter.fromRaw) && !_.isFunction(formatter.toRaw)) {
	      formatter = new formatter();
	    }
	
	    this.formatter = formatter;
	
	    this.editor = Backgrid.resolveNameToClass(this.editor, "CellEditor");
	
	    this.listenTo(model, "change:" + column.get("name"), function () {
	      if (!$el.hasClass("editor")) this.render();
	    });
	
	    this.listenTo(model, "backgrid:error", this.renderError);
	
	    this.listenTo(column, "change:editable change:sortable change:renderable",
	                  function (column) {
	                    var changed = column.changedAttributes();
	                    for (var key in changed) {
	                      if (changed.hasOwnProperty(key)) {
	                        $el.toggleClass(key, changed[key]);
	                      }
	                    }
	                  });
	
	    this.updateStateClassesMaybe();
	  },
	
	  updateStateClassesMaybe: function () {
	    var model = this.model;
	    var column = this.column;
	    var $el = this.$el;
	    $el.toggleClass("editable", Backgrid.callByNeed(column.editable(), column, model));
	    $el.toggleClass("sortable", Backgrid.callByNeed(column.sortable(), column, model));
	    $el.toggleClass("renderable", Backgrid.callByNeed(column.renderable(), column, model));
	  },
	
	  /**
	     Render a text string in a table cell. The text is converted from the
	     model's raw value for this cell's column.
	  */
	  render: function () {
	    var $el = this.$el;
	    $el.empty();
	    var model = this.model;
	    var columnName = this.column.get("name");
	    $el.text(this.formatter.fromRaw(model.get(columnName), model));
	    $el.addClass(columnName);
	    this.updateStateClassesMaybe();
	    this.delegateEvents();
	    return this;
	  },
	
	  /**
	     If this column is editable, a new CellEditor instance is instantiated with
	     its required parameters. An `editor` CSS class is added to the cell upon
	     entering edit mode.
	
	     This method triggers a Backbone `backgrid:edit` event from the model when
	     the cell is entering edit mode and an editor instance has been constructed,
	     but before it is rendered and inserted into the DOM. The cell and the
	     constructed cell editor instance are sent as event parameters when this
	     event is triggered.
	
	     When this cell has finished switching to edit mode, a Backbone
	     `backgrid:editing` event is triggered from the model. The cell and the
	     constructed cell instance are also sent as parameters in the event.
	
	     When the model triggers a `backgrid:error` event, it means the editor is
	     unable to convert the current user input to an apprpriate value for the
	     model's column, and an `error` CSS class is added to the cell accordingly.
	  */
	  enterEditMode: function () {
	    var model = this.model;
	    var column = this.column;
	
	    var editable = Backgrid.callByNeed(column.editable(), column, model);
	    if (editable) {
	
	      this.currentEditor = new this.editor({
	        column: this.column,
	        model: this.model,
	        formatter: this.formatter
	      });
	
	      model.trigger("backgrid:edit", model, column, this, this.currentEditor);
	
	      // Need to redundantly undelegate events for Firefox
	      this.undelegateEvents();
	      this.$el.empty();
	      this.$el.append(this.currentEditor.$el);
	      this.currentEditor.render();
	      this.$el.addClass("editor");
	
	      model.trigger("backgrid:editing", model, column, this, this.currentEditor);
	    }
	  },
	
	  /**
	     Put an `error` CSS class on the table cell.
	  */
	  renderError: function (model, column) {
	    if (column == null || column.get("name") == this.column.get("name")) {
	      this.$el.addClass("error");
	    }
	  },
	
	  /**
	     Removes the editor and re-render in display mode.
	  */
	  exitEditMode: function () {
	    this.$el.removeClass("error");
	    this.currentEditor.remove();
	    this.stopListening(this.currentEditor);
	    delete this.currentEditor;
	    this.$el.removeClass("editor");
	    this.render();
	  },
	
	  /**
	     Clean up this cell.
	
	     @chainable
	  */
	  remove: function () {
	    if (this.currentEditor) {
	      this.currentEditor.remove.apply(this.currentEditor, arguments);
	      delete this.currentEditor;
	    }
	    return Cell.__super__.remove.apply(this, arguments);
	  }
	
	});
	
	/**
	   StringCell displays HTML escaped strings and accepts anything typed in.
	
	   @class Backgrid.StringCell
	   @extends Backgrid.Cell
	*/
	var StringCell = Backgrid.StringCell = Cell.extend({
	
	  /** @property */
	  className: "string-cell",
	
	  formatter: StringFormatter
	
	});
	
	/**
	   UriCell renders an HTML `<a>` anchor for the value and accepts URIs as user
	   input values. No type conversion or URL validation is done by the formatter
	   of this cell. Users who need URL validation are encourage to subclass UriCell
	   to take advantage of the parsing capabilities of the HTMLAnchorElement
	   available on HTML5-capable browsers or using a third-party library like
	   [URI.js](https://github.com/medialize/URI.js).
	
	   @class Backgrid.UriCell
	   @extends Backgrid.Cell
	*/
	var UriCell = Backgrid.UriCell = Cell.extend({
	
	  /** @property */
	  className: "uri-cell",
	
	  /**
	     @property {string} [title] The title attribute of the generated anchor. It
	     uses the display value formatted by the `formatter.fromRaw` by default.
	  */
	  title: null,
	
	  /**
	     @property {string} [target="_blank"] The target attribute of the generated
	     anchor.
	  */
	  target: "_blank",
	
	  initialize: function (options) {
	    UriCell.__super__.initialize.apply(this, arguments);
	    this.title = options.title || this.title;
	    this.target = options.target || this.target;
	  },
	
	  render: function () {
	    this.$el.empty();
	    var rawValue = this.model.get(this.column.get("name"));
	    var formattedValue = this.formatter.fromRaw(rawValue, this.model);
	    this.$el.append($("<a>", {
	      tabIndex: -1,
	      href: rawValue,
	      title: this.title || formattedValue,
	      target: this.target
	    }).text(formattedValue));
	    this.delegateEvents();
	    return this;
	  }
	
	});
	
	/**
	   Like Backgrid.UriCell, EmailCell renders an HTML `<a>` anchor for the
	   value. The `href` in the anchor is prefixed with `mailto:`. EmailCell will
	   complain if the user enters a string that doesn't contain the `@` sign.
	
	   @class Backgrid.EmailCell
	   @extends Backgrid.StringCell
	*/
	var EmailCell = Backgrid.EmailCell = StringCell.extend({
	
	  /** @property */
	  className: "email-cell",
	
	  formatter: EmailFormatter,
	
	  render: function () {
	    this.$el.empty();
	    var model = this.model;
	    var formattedValue = this.formatter.fromRaw(model.get(this.column.get("name")), model);
	    this.$el.append($("<a>", {
	      tabIndex: -1,
	      href: "mailto:" + formattedValue,
	      title: formattedValue
	    }).text(formattedValue));
	    this.delegateEvents();
	    return this;
	  }
	
	});
	
	/**
	   NumberCell is a generic cell that renders all numbers. Numbers are formatted
	   using a Backgrid.NumberFormatter.
	
	   @class Backgrid.NumberCell
	   @extends Backgrid.Cell
	*/
	var NumberCell = Backgrid.NumberCell = Cell.extend({
	
	  /** @property */
	  className: "number-cell",
	
	  /**
	     @property {number} [decimals=2] Must be an integer.
	  */
	  decimals: NumberFormatter.prototype.defaults.decimals,
	
	  /** @property {string} [decimalSeparator='.'] */
	  decimalSeparator: NumberFormatter.prototype.defaults.decimalSeparator,
	
	  /** @property {string} [orderSeparator=','] */
	  orderSeparator: NumberFormatter.prototype.defaults.orderSeparator,
	
	  /** @property {Backgrid.CellFormatter} [formatter=Backgrid.NumberFormatter] */
	  formatter: NumberFormatter,
	
	  /**
	     Initializes this cell and the number formatter.
	
	     @param {Object} options
	     @param {Backbone.Model} options.model
	     @param {Backgrid.Column} options.column
	  */
	  initialize: function (options) {
	    NumberCell.__super__.initialize.apply(this, arguments);
	    var formatter = this.formatter;
	    formatter.decimals = this.decimals;
	    formatter.decimalSeparator = this.decimalSeparator;
	    formatter.orderSeparator = this.orderSeparator;
	  }
	
	});
	
	/**
	   An IntegerCell is just a Backgrid.NumberCell with 0 decimals. If a floating
	   point number is supplied, the number is simply rounded the usual way when
	   displayed.
	
	   @class Backgrid.IntegerCell
	   @extends Backgrid.NumberCell
	*/
	var IntegerCell = Backgrid.IntegerCell = NumberCell.extend({
	
	  /** @property */
	  className: "integer-cell",
	
	  /**
	     @property {number} decimals Must be an integer.
	  */
	  decimals: 0
	});
	
	/**
	   A PercentCell is another Backgrid.NumberCell that takes a floating number,
	   optionally multiplied by a multiplier and display it as a percentage.
	
	   @class Backgrid.PercentCell
	   @extends Backgrid.NumberCell
	 */
	var PercentCell = Backgrid.PercentCell = NumberCell.extend({
	
	  /** @property */
	  className: "percent-cell",
	
	  /** @property {number} [multiplier=1] */
	  multiplier: PercentFormatter.prototype.defaults.multiplier,
	
	  /** @property {string} [symbol='%'] */
	  symbol: PercentFormatter.prototype.defaults.symbol,
	
	  /** @property {Backgrid.CellFormatter} [formatter=Backgrid.PercentFormatter] */
	  formatter: PercentFormatter,
	
	  /**
	     Initializes this cell and the percent formatter.
	
	     @param {Object} options
	     @param {Backbone.Model} options.model
	     @param {Backgrid.Column} options.column
	  */
	  initialize: function () {
	    PercentCell.__super__.initialize.apply(this, arguments);
	    var formatter = this.formatter;
	    formatter.multiplier = this.multiplier;
	    formatter.symbol = this.symbol;
	  }
	
	});
	
	/**
	   DatetimeCell is a basic cell that accepts datetime string values in RFC-2822
	   or W3C's subset of ISO-8601 and displays them in ISO-8601 format. For a much
	   more sophisticated date time cell with better datetime formatting, take a
	   look at the Backgrid.Extension.MomentCell extension.
	
	   @class Backgrid.DatetimeCell
	   @extends Backgrid.Cell
	
	   See:
	
	   - Backgrid.Extension.MomentCell
	   - Backgrid.DatetimeFormatter
	*/
	var DatetimeCell = Backgrid.DatetimeCell = Cell.extend({
	
	  /** @property */
	  className: "datetime-cell",
	
	  /**
	     @property {boolean} [includeDate=true]
	  */
	  includeDate: DatetimeFormatter.prototype.defaults.includeDate,
	
	  /**
	     @property {boolean} [includeTime=true]
	  */
	  includeTime: DatetimeFormatter.prototype.defaults.includeTime,
	
	  /**
	     @property {boolean} [includeMilli=false]
	  */
	  includeMilli: DatetimeFormatter.prototype.defaults.includeMilli,
	
	  /** @property {Backgrid.CellFormatter} [formatter=Backgrid.DatetimeFormatter] */
	  formatter: DatetimeFormatter,
	
	  /**
	     Initializes this cell and the datetime formatter.
	
	     @param {Object} options
	     @param {Backbone.Model} options.model
	     @param {Backgrid.Column} options.column
	  */
	  initialize: function (options) {
	    DatetimeCell.__super__.initialize.apply(this, arguments);
	    var formatter = this.formatter;
	    formatter.includeDate = this.includeDate;
	    formatter.includeTime = this.includeTime;
	    formatter.includeMilli = this.includeMilli;
	
	    var placeholder = this.includeDate ? "YYYY-MM-DD" : "";
	    placeholder += (this.includeDate && this.includeTime) ? "T" : "";
	    placeholder += this.includeTime ? "HH:mm:ss" : "";
	    placeholder += (this.includeTime && this.includeMilli) ? ".SSS" : "";
	
	    this.editor = this.editor.extend({
	      attributes: _.extend({}, this.editor.prototype.attributes, this.editor.attributes, {
	        placeholder: placeholder
	      })
	    });
	  }
	
	});
	
	/**
	   DateCell is a Backgrid.DatetimeCell without the time part.
	
	   @class Backgrid.DateCell
	   @extends Backgrid.DatetimeCell
	*/
	var DateCell = Backgrid.DateCell = DatetimeCell.extend({
	
	  /** @property */
	  className: "date-cell",
	
	  /** @property */
	  includeTime: false
	
	});
	
	/**
	   TimeCell is a Backgrid.DatetimeCell without the date part.
	
	   @class Backgrid.TimeCell
	   @extends Backgrid.DatetimeCell
	*/
	var TimeCell = Backgrid.TimeCell = DatetimeCell.extend({
	
	  /** @property */
	  className: "time-cell",
	
	  /** @property */
	  includeDate: false
	
	});
	
	/**
	   BooleanCellEditor renders a checkbox as its editor.
	
	   @class Backgrid.BooleanCellEditor
	   @extends Backgrid.CellEditor
	*/
	var BooleanCellEditor = Backgrid.BooleanCellEditor = CellEditor.extend({
	
	  /** @property */
	  tagName: "input",
	
	  /** @property */
	  attributes: {
	    tabIndex: -1,
	    type: "checkbox"
	  },
	
	  /** @property */
	  events: {
	    "mousedown": function () {
	      this.mouseDown = true;
	    },
	    "blur": "enterOrExitEditMode",
	    "mouseup": function () {
	      this.mouseDown = false;
	    },
	    "change": "saveOrCancel",
	    "keydown": "saveOrCancel"
	  },
	
	  /**
	     Renders a checkbox and check it if the model value of this column is true,
	     uncheck otherwise.
	  */
	  render: function () {
	    var model = this.model;
	    var val = this.formatter.fromRaw(model.get(this.column.get("name")), model);
	    this.$el.prop("checked", val);
	    return this;
	  },
	
	  /**
	     Event handler. Hack to deal with the case where `blur` is fired before
	     `change` and `click` on a checkbox.
	  */
	  enterOrExitEditMode: function (e) {
	    if (!this.mouseDown) {
	      var model = this.model;
	      model.trigger("backgrid:edited", model, this.column, new Command(e));
	    }
	  },
	
	  /**
	     Event handler. Save the value into the model if the event is `change` or
	     one of the keyboard navigation key presses. Exit edit mode without saving
	     if `escape` was pressed.
	  */
	  saveOrCancel: function (e) {
	    var model = this.model;
	    var column = this.column;
	    var formatter = this.formatter;
	    var command = new Command(e);
	    // skip ahead to `change` when space is pressed
	    if (command.passThru() && e.type != "change") return true;
	    if (command.cancel()) {
	      e.stopPropagation();
	      model.trigger("backgrid:edited", model, column, command);
	    }
	
	    var $el = this.$el;
	    if (command.save() || command.moveLeft() || command.moveRight() || command.moveUp() ||
	        command.moveDown()) {
	      e.preventDefault();
	      e.stopPropagation();
	      var val = formatter.toRaw($el.prop("checked"), model);
	      model.set(column.get("name"), val);
	      model.trigger("backgrid:edited", model, column, command);
	    }
	    else if (e.type == "change") {
	      var val = formatter.toRaw($el.prop("checked"), model);
	      model.set(column.get("name"), val);
	      $el.focus();
	    }
	  }
	
	});
	
	/**
	   BooleanCell renders a checkbox both during display mode and edit mode. The
	   checkbox is checked if the model value is true, unchecked otherwise.
	
	   @class Backgrid.BooleanCell
	   @extends Backgrid.Cell
	*/
	var BooleanCell = Backgrid.BooleanCell = Cell.extend({
	
	  /** @property */
	  className: "boolean-cell",
	
	  /** @property */
	  editor: BooleanCellEditor,
	
	  /** @property */
	  events: {
	    "click": "enterEditMode"
	  },
	
	  /**
	     Renders a checkbox and check it if the model value of this column is true,
	     uncheck otherwise.
	  */
	  render: function () {
	    this.$el.empty();
	    var model = this.model, column = this.column;
	    var editable = Backgrid.callByNeed(column.editable(), column, model);
	    this.$el.append($("<input>", {
	      tabIndex: -1,
	      type: "checkbox",
	      checked: this.formatter.fromRaw(model.get(column.get("name")), model),
	      disabled: !editable
	    }));
	    this.delegateEvents();
	    return this;
	  }
	
	});
	
	/**
	   SelectCellEditor renders an HTML `<select>` fragment as the editor.
	
	   @class Backgrid.SelectCellEditor
	   @extends Backgrid.CellEditor
	*/
	var SelectCellEditor = Backgrid.SelectCellEditor = CellEditor.extend({
	
	  /** @property */
	  tagName: "select",
	
	  /** @property */
	  events: {
	    "change": "save",
	    "blur": "close",
	    "keydown": "close"
	  },
	
	  /** @property {function(Object, ?Object=): string} template */
	  template: _.template(
	    '<option value="<%- value %>" <%= selected ? \'selected="selected"\' : "" %>><%- text %></option>',
	    null,
	    {
	        variable    : null,
	        evaluate    : /<%([\s\S]+?)%>/g,
	        interpolate : /<%=([\s\S]+?)%>/g,
	        escape      : /<%-([\s\S]+?)%>/g
	    }),
	
	  setOptionValues: function (optionValues) {
	    this.optionValues = optionValues;
	    this.optionValues = _.result(this, "optionValues");
	  },
	
	  setMultiple: function (multiple) {
	    this.multiple = multiple;
	    this.$el.prop("multiple", multiple);
	  },
	
	  _renderOptions: function (nvps, selectedValues) {
	    var options = '';
	    for (var i = 0; i < nvps.length; i++) {
	      options = options + this.template({
	        text: nvps[i][0],
	        value: nvps[i][1],
	        selected: _.indexOf(selectedValues, nvps[i][1]) > -1
	      });
	    }
	    return options;
	  },
	
	  /**
	     Renders the options if `optionValues` is a list of name-value pairs. The
	     options are contained inside option groups if `optionValues` is a list of
	     object hashes. The name is rendered at the option text and the value is the
	     option value. If `optionValues` is a function, it is called without a
	     parameter.
	  */
	  render: function () {
	    this.$el.empty();
	
	    var optionValues = _.result(this, "optionValues");
	    var model = this.model;
	    var selectedValues = this.formatter.fromRaw(model.get(this.column.get("name")), model);
	
	    if (!_.isArray(optionValues)) throw new TypeError("optionValues must be an array");
	
	    var optionValue = null;
	    var optionText = null;
	    var optionValue = null;
	    var optgroupName = null;
	    var optgroup = null;
	
	    for (var i = 0; i < optionValues.length; i++) {
	      var optionValue = optionValues[i];
	
	      if (_.isArray(optionValue)) {
	        optionText  = optionValue[0];
	        optionValue = optionValue[1];
	
	        this.$el.append(this.template({
	          text: optionText,
	          value: optionValue,
	          selected: _.indexOf(selectedValues, optionValue) > -1
	        }));
	      }
	      else if (_.isObject(optionValue)) {
	        optgroupName = optionValue.name;
	        optgroup = $("<optgroup></optgroup>", { label: optgroupName });
	        optgroup.append(this._renderOptions.call(this, optionValue.values, selectedValues));
	        this.$el.append(optgroup);
	      }
	      else {
	        throw new TypeError("optionValues elements must be a name-value pair or an object hash of { name: 'optgroup label', value: [option name-value pairs] }");
	      }
	    }
	
	    this.delegateEvents();
	
	    return this;
	  },
	
	  /**
	     Saves the value of the selected option to the model attribute.
	  */
	  save: function (e) {
	    var model = this.model;
	    var column = this.column;
	    model.set(column.get("name"), this.formatter.toRaw(this.$el.val(), model));
	  },
	
	  /**
	     Triggers a `backgrid:edited` event from the model so the body can close
	     this editor.
	  */
	  close: function (e) {
	    var model = this.model;
	    var column = this.column;
	    var command = new Command(e);
	    if (command.cancel()) {
	      e.stopPropagation();
	      model.trigger("backgrid:edited", model, column, new Command(e));
	    }
	    else if (command.save() || command.moveLeft() || command.moveRight() ||
	             command.moveUp() || command.moveDown() || e.type == "blur") {
	      e.preventDefault();
	      e.stopPropagation();
	      this.save(e);
	      model.trigger("backgrid:edited", model, column, new Command(e));
	    }
	  }
	
	});
	
	/**
	   SelectCell is also a different kind of cell in that upon going into edit mode
	   the cell renders a list of options to pick from, as opposed to an input box.
	
	   SelectCell cannot be referenced by its string name when used in a column
	   definition because it requires an `optionValues` class attribute to be
	   defined. `optionValues` can either be a list of name-value pairs, to be
	   rendered as options, or a list of object hashes which consist of a key *name*
	   which is the option group name, and a key *values* which is a list of
	   name-value pairs to be rendered as options under that option group.
	
	   In addition, `optionValues` can also be a parameter-less function that
	   returns one of the above. If the options are static, it is recommended the
	   returned values to be memoized. `_.memoize()` is a good function to help with
	   that.
	
	   During display mode, the default formatter will normalize the raw model value
	   to an array of values whether the raw model value is a scalar or an
	   array. Each value is compared with the `optionValues` values using
	   Ecmascript's implicit type conversion rules. When exiting edit mode, no type
	   conversion is performed when saving into the model. This behavior is not
	   always desirable when the value type is anything other than string. To
	   control type conversion on the client-side, you should subclass SelectCell to
	   provide a custom formatter or provide the formatter to your column
	   definition.
	
	   See:
	     [$.fn.val()](http://api.jquery.com/val/)
	
	   @class Backgrid.SelectCell
	   @extends Backgrid.Cell
	*/
	var SelectCell = Backgrid.SelectCell = Cell.extend({
	
	  /** @property */
	  className: "select-cell",
	
	  /** @property */
	  editor: SelectCellEditor,
	
	  /** @property */
	  multiple: false,
	
	  /** @property */
	  formatter: SelectFormatter,
	
	  /**
	     @property {Array.<Array>|Array.<{name: string, values: Array.<Array>}>} optionValues
	  */
	  optionValues: undefined,
	
	  /** @property */
	  delimiter: ', ',
	
	  /**
	     Initializer.
	
	     @param {Object} options
	     @param {Backbone.Model} options.model
	     @param {Backgrid.Column} options.column
	
	     @throws {TypeError} If `optionsValues` is undefined.
	  */
	  initialize: function (options) {
	    SelectCell.__super__.initialize.apply(this, arguments);
	    this.listenTo(this.model, "backgrid:edit", function (model, column, cell, editor) {
	      if (column.get("name") == this.column.get("name")) {
	        editor.setOptionValues(this.optionValues);
	        editor.setMultiple(this.multiple);
	      }
	    });
	  },
	
	  /**
	     Renders the label using the raw value as key to look up from `optionValues`.
	
	     @throws {TypeError} If `optionValues` is malformed.
	  */
	  render: function () {
	    this.$el.empty();
	
	    var optionValues = _.result(this, "optionValues");
	    var model = this.model;
	    var rawData = this.formatter.fromRaw(model.get(this.column.get("name")), model);
	
	    var selectedText = [];
	
	    try {
	      if (!_.isArray(optionValues) || _.isEmpty(optionValues)) throw new TypeError;
	
	      for (var k = 0; k < rawData.length; k++) {
	        var rawDatum = rawData[k];
	
	        for (var i = 0; i < optionValues.length; i++) {
	          var optionValue = optionValues[i];
	
	          if (_.isArray(optionValue)) {
	            var optionText  = optionValue[0];
	            var optionValue = optionValue[1];
	
	            if (optionValue == rawDatum) selectedText.push(optionText);
	          }
	          else if (_.isObject(optionValue)) {
	            var optionGroupValues = optionValue.values;
	
	            for (var j = 0; j < optionGroupValues.length; j++) {
	              var optionGroupValue = optionGroupValues[j];
	              if (optionGroupValue[1] == rawDatum) {
	                selectedText.push(optionGroupValue[0]);
	              }
	            }
	          }
	          else {
	            throw new TypeError;
	          }
	        }
	      }
	
	      this.$el.append(selectedText.join(this.delimiter));
	    }
	    catch (ex) {
	      if (ex instanceof TypeError) {
	        throw new TypeError("'optionValues' must be of type {Array.<Array>|Array.<{name: string, values: Array.<Array>}>}");
	      }
	      throw ex;
	    }
	
	    this.delegateEvents();
	
	    return this;
	  }
	
	});
	
	/*
	  backgrid
	  http://github.com/cloudflare/backgrid
	
	  Copyright (c) 2013-present Cloudflare, Inc. and contributors
	  Licensed under the MIT license.
	*/
	
	/**
	   A Column is a placeholder for column metadata.
	
	   You usually don't need to create an instance of this class yourself as a
	   collection of column instances will be created for you from a list of column
	   attributes in the Backgrid.js view class constructors.
	
	   @class Backgrid.Column
	   @extends Backbone.Model
	*/
	var Column = Backgrid.Column = Backbone.Model.extend({
	
	  /**
	     @cfg {Object} defaults Column defaults. To override any of these default
	     values, you can either change the prototype directly to override
	     Column.defaults globally or extend Column and supply the custom class to
	     Backgrid.Grid:
	
	         // Override Column defaults globally
	         Column.prototype.defaults.sortable = false;
	
	         // Override Column defaults locally
	         var MyColumn = Column.extend({
	           defaults: _.defaults({
	             editable: false
	           }, Column.prototype.defaults)
	         });
	
	         var grid = new Backgrid.Grid(columns: new Columns([{...}, {...}], {
	           model: MyColumn
	         }));
	
	     @cfg {string} [defaults.name] The default name of the model attribute.
	
	     @cfg {string} [defaults.label] The default label to show in the header.
	
	     @cfg {string|Backgrid.Cell} [defaults.cell] The default cell type. If this
	     is a string, the capitalized form will be used to look up a cell class in
	     Backbone, i.e.: string => StringCell. If a Cell subclass is supplied, it is
	     initialized with a hash of parameters. If a Cell instance is supplied, it
	     is used directly.
	
	     @cfg {string|Backgrid.HeaderCell} [defaults.headerCell] The default header
	     cell type.
	
	     @cfg {boolean|string|function(): boolean} [defaults.sortable=true] Whether
	     this column is sortable. If the value is a string, a method will the same
	     name will be looked up from the column instance to determine whether the
	     column should be sortable. The method's signature must be `function
	     (Backbone.Model): boolean`. The function's context is the column instance.
	
	     @cfg {boolean|string|function(): boolean} [defaults.editable=true] Whether
	     this column is editable. If the value is a string, a method will the same
	     name will be looked up from the column instance to determine whether the
	     column should be editable. The method's signature must be `function
	     (Backbone.Model): boolean`. The function's context is the column instance.
	
	     @cfg {boolean|string|function(): boolean} [defaults.renderable=true]
	     Whether this column is renderable. If the value is a string, a method will
	     the same name will be looked up from the column instance to determine
	     whether the column should be renderable. The method's signature must be
	     `function (Backbone.Model): boolean`. The function's context is the column
	     instance.
	
	     @cfg {Backgrid.CellFormatter | Object | string} [defaults.formatter] The
	     formatter to use to convert between raw model values and user input.
	
	     @cfg {"toggle"|"cycle"} [defaults.sortType="cycle"] Whether sorting will
	     toggle between ascending and descending order, or cycle between insertion
	     order, ascending and descending order.
	
	     @cfg {(function(Backbone.Model, string): *) | string} [defaults.sortValue]
	     The function to use to extract a value from the model for comparison during
	     sorting. If this value is a string, a method with the same name will be
	     looked up from the column instance.
	
	     @cfg {"ascending"|"descending"|null} [defaults.direction=null] The initial
	     sorting direction for this column. The default is ordered by
	     Backbone.Model.cid, which usually means the collection is ordered by
	     insertion order.
	  */
	  defaults: {
	    name: undefined,
	    label: undefined,
	    sortable: true,
	    editable: true,
	    renderable: true,
	    formatter: undefined,
	    sortType: "cycle",
	    sortValue: undefined,
	    direction: null,
	    cell: undefined,
	    headerCell: undefined
	  },
	
	  /**
	     Initializes this Column instance.
	
	     @param {Object} attrs
	
	     @param {string} attrs.name The model attribute this column is responsible
	     for.
	
	     @param {string|Backgrid.Cell} attrs.cell The cell type to use to render
	     this column.
	
	     @param {string} [attrs.label]
	
	     @param {string|Backgrid.HeaderCell} [attrs.headerCell]
	
	     @param {boolean|string|function(): boolean} [attrs.sortable=true]
	
	     @param {boolean|string|function(): boolean} [attrs.editable=true]
	
	     @param {boolean|string|function(): boolean} [attrs.renderable=true]
	
	     @param {Backgrid.CellFormatter | Object | string} [attrs.formatter]
	
	     @param {"toggle"|"cycle"}  [attrs.sortType="cycle"]
	
	     @param {(function(Backbone.Model, string): *) | string} [attrs.sortValue]
	
	     @throws {TypeError} If attrs.cell or attrs.options are not supplied.
	
	     @throws {ReferenceError} If formatter is a string but a formatter class of
	     said name cannot be found in the Backgrid module.
	
	     See:
	
	     - Backgrid.Column.defaults
	     - Backgrid.Cell
	     - Backgrid.CellFormatter
	   */
	  initialize: function () {
	    if (!this.has("label")) {
	      this.set({ label: this.get("name") }, { silent: true });
	    }
	
	    var headerCell = Backgrid.resolveNameToClass(this.get("headerCell"), "HeaderCell");
	
	    var cell = Backgrid.resolveNameToClass(this.get("cell"), "Cell");
	
	    this.set({cell: cell, headerCell: headerCell}, { silent: true });
	  },
	
	  /**
	     Returns an appropriate value extraction function from a model for sorting.
	
	     If the column model contains an attribute `sortValue`, if it is a string, a
	     method from the column instance identifified by the `sortValue` string is
	     returned. If it is a function, it it returned as is. If `sortValue` isn't
	     found from the column model's attributes, a default value extraction
	     function is returned which will compare according to the natural order of
	     the value's type.
	
	     @return {function(Backbone.Model, string): *}
	   */
	  sortValue: function () {
	    var sortValue = this.get("sortValue");
	    if (_.isString(sortValue)) return this[sortValue];
	    else if (_.isFunction(sortValue)) return sortValue;
	
	    return function (model, colName) {
	      return model.get(colName);
	    };
	  }
	
	  /**
	     If you cannot always determine whether a column should be sortable before
	     the grid get initialized, you can override this method.
	
	     @member Backgrid.Column
	     @protected
	     @method sortable
	     @return {function(Backbone.Model): boolean | boolean}
	  */
	
	  /**
	     If you cannot always determine whether a column should be editable before
	     the grid get initialized, you can override this method.
	
	     @member Backgrid.Column
	     @protected
	     @method editable
	     @return {function(Backbone.Model): boolean | boolean}
	  */
	
	  /**
	     If you cannot always determine whether a column should be renderable before
	     the grid get initialized, you can override this method.
	
	     @member Backgrid.Column
	     @protected
	     @method renderable
	     @return {function(Backbone.Model): boolean | boolean}
	  */
	});
	
	_.each(["sortable", "renderable", "editable"], function (key) {
	  Column.prototype[key] = function () {
	    var value = this.get(key);
	    if (_.isString(value)) return this[value];
	    else if (_.isFunction(value)) return value;
	
	    return !!value;
	  };
	});
	
	/**
	   A Backbone collection of Column instances.
	
	   @class Backgrid.Columns
	   @extends Backbone.Collection
	 */
	var Columns = Backgrid.Columns = Backbone.Collection.extend({
	
	  /**
	     @property {Backgrid.Column} model
	   */
	  model: Column
	});
	
	/*
	  backgrid
	  http://github.com/cloudflare/backgrid
	
	  Copyright (c) 2013-present Cloudflare, Inc. and contributors
	  Licensed under the MIT license.
	*/
	
	/**
	   Row is a simple container view that takes a model instance and a list of
	   column metadata describing how each of the model's attribute is to be
	   rendered, and apply the appropriate cell to each attribute.
	
	   @class Backgrid.Row
	   @extends Backbone.View
	*/
	var Row = Backgrid.Row = Backbone.View.extend({
	
	  /** @property */
	  tagName: "tr",
	
	  /**
	     Initializes a row view instance.
	
	     @param {Object} options
	     @param {Backbone.Collection.<Backgrid.Column>|Array.<Backgrid.Column>|Array.<Object>} options.columns Column metadata.
	     @param {Backbone.Model} options.model The model instance to render.
	
	     @throws {TypeError} If options.columns or options.model is undefined.
	  */
	  initialize: function (options) {
	
	    var columns = this.columns = options.columns;
	    if (!(columns instanceof Backbone.Collection)) {
	      columns = this.columns = new Columns(columns);
	    }
	
	    var cells = this.cells = [];
	    for (var i = 0; i < columns.length; i++) {
	      cells.push(this.makeCell(columns.at(i), options));
	    }
	
	    this.listenTo(columns, "add", function (column, columns) {
	      var i = columns.indexOf(column);
	      var cell = this.makeCell(column, options);
	      cells.splice(i, 0, cell);
	
	      var $el = this.$el;
	      if (i === 0) {
	        $el.prepend(cell.render().$el);
	      }
	      else if (i === columns.length - 1) {
	        $el.append(cell.render().$el);
	      }
	      else {
	        $el.children().eq(i).before(cell.render().$el);
	      }
	    });
	
	    this.listenTo(columns, "remove", function (column, columns, opts) {
	      cells[opts.index].remove();
	      cells.splice(opts.index, 1);
	    });
	  },
	
	  /**
	     Factory method for making a cell. Used by #initialize internally. Override
	     this to provide an appropriate cell instance for a custom Row subclass.
	
	     @protected
	
	     @param {Backgrid.Column} column
	     @param {Object} options The options passed to #initialize.
	
	     @return {Backgrid.Cell}
	  */
	  makeCell: function (column) {
	    return new (column.get("cell"))({
	      column: column,
	      model: this.model
	    });
	  },
	
	  /**
	     Renders a row of cells for this row's model.
	  */
	  render: function () {
	    this.$el.empty();
	
	    var fragment = document.createDocumentFragment();
	    for (var i = 0; i < this.cells.length; i++) {
	      fragment.appendChild(this.cells[i].render().el);
	    }
	
	    this.el.appendChild(fragment);
	
	    this.delegateEvents();
	
	    return this;
	  },
	
	  /**
	     Clean up this row and its cells.
	
	     @chainable
	  */
	  remove: function () {
	    for (var i = 0; i < this.cells.length; i++) {
	      var cell = this.cells[i];
	      cell.remove.apply(cell, arguments);
	    }
	    return Backbone.View.prototype.remove.apply(this, arguments);
	  }
	
	});
	
	/**
	   EmptyRow is a simple container view that takes a list of column and render a
	   row with a single column.
	
	   @class Backgrid.EmptyRow
	   @extends Backbone.View
	*/
	var EmptyRow = Backgrid.EmptyRow = Backbone.View.extend({
	
	  /** @property */
	  tagName: "tr",
	
	  /** @property {string|function(): string} */
	  emptyText: null,
	
	  /**
	     Initializer.
	
	     @param {Object} options
	     @param {string|function(): string} options.emptyText
	     @param {Backbone.Collection.<Backgrid.Column>|Array.<Backgrid.Column>|Array.<Object>} options.columns Column metadata.
	   */
	  initialize: function (options) {
	    this.emptyText = options.emptyText;
	    this.columns =  options.columns;
	  },
	
	  /**
	     Renders an empty row.
	  */
	  render: function () {
	    this.$el.empty();
	
	    var td = document.createElement("td");
	    td.setAttribute("colspan", this.columns.length);
	    var span = document.createElement("span");
	    span.innerHTML = _.result(this, "emptyText");
	    td.appendChild(span);
	
	    this.el.className = "empty";
	    this.el.appendChild(td);
	
	    return this;
	  }
	});
	
	/*
	  backgrid
	  http://github.com/cloudflare/backgrid
	
	  Copyright (c) 2013-present Cloudflare, Inc. and contributors
	  Licensed under the MIT license.
	*/
	
	/**
	   HeaderCell is a special cell class that renders a column header cell. If the
	   column is sortable, a sorter is also rendered and will trigger a table
	   refresh after sorting.
	
	   @class Backgrid.HeaderCell
	   @extends Backbone.View
	 */
	var HeaderCell = Backgrid.HeaderCell = Backbone.View.extend({
	
	  /** @property */
	  tagName: "th",
	
	  /** @property */
	  events: {
	    "click button": "onClick"
	  },
	
	  /**
	     Initializer.
	
	     @param {Object} options
	     @param {Backgrid.Column|Object} options.column
	
	     @throws {TypeError} If options.column or options.collection is undefined.
	   */
	  initialize: function (options) {
	    this.column = options.column;
	    if (!(this.column instanceof Column)) {
	      this.column = new Column(this.column);
	    }
	
	    var column = this.column, collection = this.collection, $el = this.$el;
	
	    this.listenTo(column, "change:editable change:sortable change:renderable",
	                  function (column) {
	                    var changed = column.changedAttributes();
	                    for (var key in changed) {
	                      if (changed.hasOwnProperty(key)) {
	                        $el.toggleClass(key, changed[key]);
	                      }
	                    }
	                  });
	    this.listenTo(column, "change:direction", this.setCellDirection);
	    this.listenTo(column, "change:name change:label", this.render);
	
	    if (Backgrid.callByNeed(column.editable(), column, collection)) $el.addClass("editable");
	    if (Backgrid.callByNeed(column.sortable(), column, collection)) $el.addClass("sortable");
	    if (Backgrid.callByNeed(column.renderable(), column, collection)) $el.addClass("renderable");
	
	    this.listenTo(collection.fullCollection || collection, "backgrid:sorted", this.removeCellDirection);
	  },
	
	  /**
	     Event handler for the collection's `backgrid:sorted` event. Removes
	     all the CSS direction classes.
	   */
	  removeCellDirection: function () {
	    this.$el.removeClass("ascending").removeClass("descending");
	    this.column.set("direction", null);
	  },
	
	  /**
	     Event handler for the column's `change:direction` event. If this
	     HeaderCell's column is being sorted on, it applies the direction given as a
	     CSS class to the header cell. Removes all the CSS direction classes
	     otherwise.
	   */
	  setCellDirection: function (column, direction) {
	    this.$el.removeClass("ascending").removeClass("descending");
	    if (column.cid == this.column.cid) this.$el.addClass(direction);
	  },
	
	  /**
	     Event handler for the `click` event on the cell's anchor. If the column is
	     sortable, clicking on the anchor will cycle through 3 sorting orderings -
	     `ascending`, `descending`, and default.
	   */
	  onClick: function (e) {
	    e.preventDefault();
	
	    var column = this.column;
	    var collection = this.collection;
	    var event = "backgrid:sort";
	
	    function cycleSort(header, col) {
	      if (column.get("direction") === "ascending") collection.trigger(event, col, "descending");
	      else if (column.get("direction") === "descending") collection.trigger(event, col, null);
	      else collection.trigger(event, col, "ascending");
	    }
	
	    function toggleSort(header, col) {
	      if (column.get("direction") === "ascending") collection.trigger(event, col, "descending");
	      else collection.trigger(event, col, "ascending");
	    }
	
	    var sortable = Backgrid.callByNeed(column.sortable(), column, this.collection);
	    if (sortable) {
	      var sortType = column.get("sortType");
	      if (sortType === "toggle") toggleSort(this, column);
	      else cycleSort(this, column);
	    }
	  },
	
	  /**
	     Renders a header cell with a sorter, a label, and a class name for this
	     column.
	   */
	  render: function () {
	    this.$el.empty();
	    var column = this.column;
	    var sortable = Backgrid.callByNeed(column.sortable(), column, this.collection);
	    var label;
	    if(sortable){
	      label = $("<button>").text(column.get("label")).append("<span class='sort-caret' aria-hidden='true'></span>");
	    } else {
	      label = document.createTextNode(column.get("label"));
	    }
	
	    this.$el.append(label);
	    this.$el.addClass(column.get("name"));
	    this.$el.addClass(column.get("direction"));
	    this.delegateEvents();
	    return this;
	  }
	
	});
	
	/**
	   HeaderRow is a controller for a row of header cells.
	
	   @class Backgrid.HeaderRow
	   @extends Backgrid.Row
	 */
	var HeaderRow = Backgrid.HeaderRow = Backgrid.Row.extend({
	
	  /**
	     Initializer.
	
	     @param {Object} options
	     @param {Backbone.Collection.<Backgrid.Column>|Array.<Backgrid.Column>|Array.<Object>} options.columns
	     @param {Backgrid.HeaderCell} [options.headerCell] Customized default
	     HeaderCell for all the columns. Supply a HeaderCell class or instance to a
	     the `headerCell` key in a column definition for column-specific header
	     rendering.
	
	     @throws {TypeError} If options.columns or options.collection is undefined.
	   */
	  initialize: function () {
	    Backgrid.Row.prototype.initialize.apply(this, arguments);
	  },
	
	  makeCell: function (column, options) {
	    var headerCell = column.get("headerCell") || options.headerCell || HeaderCell;
	    headerCell = new headerCell({
	      column: column,
	      collection: this.collection
	    });
	    return headerCell;
	  }
	
	});
	
	/**
	   Header is a special structural view class that renders a table head with a
	   single row of header cells.
	
	   @class Backgrid.Header
	   @extends Backbone.View
	 */
	var Header = Backgrid.Header = Backbone.View.extend({
	
	  /** @property */
	  tagName: "thead",
	
	  /**
	     Initializer. Initializes this table head view to contain a single header
	     row view.
	
	     @param {Object} options
	     @param {Backbone.Collection.<Backgrid.Column>|Array.<Backgrid.Column>|Array.<Object>} options.columns Column metadata.
	     @param {Backbone.Model} options.model The model instance to render.
	
	     @throws {TypeError} If options.columns or options.model is undefined.
	   */
	  initialize: function (options) {
	    this.columns = options.columns;
	    if (!(this.columns instanceof Backbone.Collection)) {
	      this.columns = new Columns(this.columns);
	    }
	
	    this.row = new Backgrid.HeaderRow({
	      columns: this.columns,
	      collection: this.collection
	    });
	  },
	
	  /**
	     Renders this table head with a single row of header cells.
	   */
	  render: function () {
	    this.$el.append(this.row.render().$el);
	    this.delegateEvents();
	    return this;
	  },
	
	  /**
	     Clean up this header and its row.
	
	     @chainable
	   */
	  remove: function () {
	    this.row.remove.apply(this.row, arguments);
	    return Backbone.View.prototype.remove.apply(this, arguments);
	  }
	
	});
	
	/*
	  backgrid
	  http://github.com/cloudflare/backgrid
	
	  Copyright (c) 2013-present Cloudflare, Inc. and contributors
	  Licensed under the MIT license.
	*/
	
	/**
	   Body is the table body which contains the rows inside a table. Body is
	   responsible for refreshing the rows after sorting, insertion and removal.
	
	   @class Backgrid.Body
	   @extends Backbone.View
	*/
	var Body = Backgrid.Body = Backbone.View.extend({
	
	  /** @property */
	  tagName: "tbody",
	
	  /**
	     Initializer.
	
	     @param {Object} options
	     @param {Backbone.Collection} options.collection
	     @param {Backbone.Collection.<Backgrid.Column>|Array.<Backgrid.Column>|Array.<Object>} options.columns
	     Column metadata.
	     @param {Backgrid.Row} [options.row=Backgrid.Row] The Row class to use.
	     @param {string|function(): string} [options.emptyText] The text to display in the empty row.
	
	     @throws {TypeError} If options.columns or options.collection is undefined.
	
	     See Backgrid.Row.
	  */
	  initialize: function (options) {
	
	    this.columns = options.columns;
	    if (!(this.columns instanceof Backbone.Collection)) {
	      this.columns = new Columns(this.columns);
	    }
	
	    this.row = options.row || this.row || Row;
	    this.rows = this.collection.map(function (model) {
	      var row = new this.row({
	        columns: this.columns,
	        model: model
	      });
	
	      return row;
	    }, this);
	
	    this.emptyText = options.emptyText;
	    this._unshiftEmptyRowMayBe();
	
	    var collection = this.collection;
	    this.listenTo(collection, "add", this.insertRow);
	    this.listenTo(collection, "remove", this.removeRow);
	    this.listenTo(collection, "sort", this.refresh);
	    this.listenTo(collection, "reset", this.refresh);
	    this.listenTo(collection, "backgrid:sort", this.sort);
	    this.listenTo(collection, "backgrid:edited", this.moveToNextCell);
	
	    this.listenTo(this.columns, "add remove", this.updateEmptyRow);
	  },
	
	  _unshiftEmptyRowMayBe: function () {
	    if (this.rows.length === 0 && this.emptyText != null) {
	      this.emptyRow = new EmptyRow({
	        emptyText: this.emptyText,
	        columns: this.columns
	      });
	
	      this.rows.unshift(this.emptyRow);
	      return true
	    }
	  },
	
	  /**
	     This method can be called either directly or as a callback to a
	     [Backbone.Collecton#add](http://backbonejs.org/#Collection-add) event.
	
	     When called directly, it accepts a model or an array of models and an
	     option hash just like
	     [Backbone.Collection#add](http://backbonejs.org/#Collection-add) and
	     delegates to it. Once the model is added, a new row is inserted into the
	     body and automatically rendered.
	
	     When called as a callback of an `add` event, splices a new row into the
	     body and renders it.
	
	     @param {Backbone.Model} model The model to render as a row.
	     @param {Backbone.Collection} collection When called directly, this
	     parameter is actually the options to
	     [Backbone.Collection#add](http://backbonejs.org/#Collection-add).
	     @param {Object} options When called directly, this must be null.
	
	     See:
	
	     - [Backbone.Collection#add](http://backbonejs.org/#Collection-add)
	  */
	  insertRow: function (model, collection, options) {
	
	    if (this.rows[0] instanceof EmptyRow) this.rows.pop().remove();
	
	    // insertRow() is called directly
	    if (!(collection instanceof Backbone.Collection) && !options) {
	      this.collection.add(model, (options = collection));
	      return;
	    }
	
	    var row = new this.row({
	      columns: this.columns,
	      model: model
	    });
	
	    var index = collection.indexOf(model);
	    this.rows.splice(index, 0, row);
	
	    var $el = this.$el;
	    var $children = $el.children();
	    var $rowEl = row.render().$el;
	
	    if (index >= $children.length) {
	      $el.append($rowEl);
	    }
	    else {
	      $children.eq(index).before($rowEl);
	    }
	
	    return this;
	  },
	
	  /**
	     The method can be called either directly or as a callback to a
	     [Backbone.Collection#remove](http://backbonejs.org/#Collection-remove)
	     event.
	
	     When called directly, it accepts a model or an array of models and an
	     option hash just like
	     [Backbone.Collection#remove](http://backbonejs.org/#Collection-remove) and
	     delegates to it. Once the model is removed, a corresponding row is removed
	     from the body.
	
	     When called as a callback of a `remove` event, splices into the rows and
	     removes the row responsible for rendering the model.
	
	     @param {Backbone.Model} model The model to remove from the body.
	     @param {Backbone.Collection} collection When called directly, this
	     parameter is actually the options to
	     [Backbone.Collection#remove](http://backbonejs.org/#Collection-remove).
	     @param {Object} options When called directly, this must be null.
	
	     See:
	
	     - [Backbone.Collection#remove](http://backbonejs.org/#Collection-remove)
	  */
	  removeRow: function (model, collection, options) {
	
	    // removeRow() is called directly
	    if (!options) {
	      this.collection.remove(model, (options = collection));
	      if (this._unshiftEmptyRowMayBe()) {
	        this.render();
	      }
	      return;
	    }
	
	    if (_.isUndefined(options.render) || options.render) {
	      this.rows[options.index].remove();
	    }
	
	    this.rows.splice(options.index, 1);
	    if (this._unshiftEmptyRowMayBe()) {
	      this.render();
	    }
	
	    return this;
	  },
	
	  /**
	     Rerender the EmptyRow which empties the DOM element, creates the td with the
	     updated colspan, and appends it back into the DOM
	  */
	
	  updateEmptyRow: function () {
	    if (this.emptyRow != null) {
	      this.emptyRow.render();
	    }
	  },
	
	  /**
	     Reinitialize all the rows inside the body and re-render them. Triggers a
	     Backbone `backgrid:refresh` event from the collection along with the body
	     instance as its sole parameter when done.
	  */
	  refresh: function () {
	    for (var i = 0; i < this.rows.length; i++) {
	      this.rows[i].remove();
	    }
	
	    this.rows = this.collection.map(function (model) {
	      var row = new this.row({
	        columns: this.columns,
	        model: model
	      });
	
	      return row;
	    }, this);
	    this._unshiftEmptyRowMayBe();
	
	    this.render();
	
	    this.collection.trigger("backgrid:refresh", this);
	
	    return this;
	  },
	
	  /**
	     Renders all the rows inside this body. If the collection is empty and
	     `options.emptyText` is defined and not null in the constructor, an empty
	     row is rendered, otherwise no row is rendered.
	  */
	  render: function () {
	    this.$el.empty();
	
	    var fragment = document.createDocumentFragment();
	    for (var i = 0; i < this.rows.length; i++) {
	      var row = this.rows[i];
	      fragment.appendChild(row.render().el);
	    }
	
	    this.el.appendChild(fragment);
	
	    this.delegateEvents();
	
	    return this;
	  },
	
	  /**
	     Clean up this body and it's rows.
	
	     @chainable
	  */
	  remove: function () {
	    for (var i = 0; i < this.rows.length; i++) {
	      var row = this.rows[i];
	      row.remove.apply(row, arguments);
	    }
	    return Backbone.View.prototype.remove.apply(this, arguments);
	  },
	
	  /**
	     If the underlying collection is a Backbone.PageableCollection in
	     server-mode or infinite-mode, a page of models is fetched after sorting is
	     done on the server.
	
	     If the underlying collection is a Backbone.PageableCollection in
	     client-mode, or any
	     [Backbone.Collection](http://backbonejs.org/#Collection) instance, sorting
	     is done on the client side. If the collection is an instance of a
	     Backbone.PageableCollection, sorting will be done globally on all the pages
	     and the current page will then be returned.
	
	     Triggers a Backbone `backgrid:sorted` event from the collection when done
	     with the column, direction and a reference to the collection.
	
	     @param {Backgrid.Column|string} column
	     @param {null|"ascending"|"descending"} direction
	
	     See [Backbone.Collection#comparator](http://backbonejs.org/#Collection-comparator)
	  */
	  sort: function (column, direction) {
	
	    if (!_.contains(["ascending", "descending", null], direction)) {
	      throw new RangeError('direction must be one of "ascending", "descending" or `null`');
	    }
	
	    if (_.isString(column)) column = this.columns.findWhere({name: column});
	
	    var collection = this.collection;
	
	    var order;
	    if (direction === "ascending") order = -1;
	    else if (direction === "descending") order = 1;
	    else order = null;
	
	    var comparator = this.makeComparator(column.get("name"), order,
	                                         order ?
	                                         column.sortValue() :
	                                         function (model) {
	                                           return model.cid.replace('c', '') * 1;
	                                         });
	
	    if (Backbone.PageableCollection &&
	        collection instanceof Backbone.PageableCollection) {
	
	      collection.setSorting(order && column.get("name"), order,
	                            {sortValue: column.sortValue()});
	
	      if (collection.fullCollection) {
	        // If order is null, pageable will remove the comparator on both sides,
	        // in this case the default insertion order comparator needs to be
	        // attached to get back to the order before sorting.
	        if (collection.fullCollection.comparator == null) {
	          collection.fullCollection.comparator = comparator;
	        }
	        collection.fullCollection.sort();
	        collection.trigger("backgrid:sorted", column, direction, collection);
	        column.set("direction", direction);
	      }
	      else collection.fetch({reset: true, success: function () {
	        collection.trigger("backgrid:sorted", column, direction, collection);
	        column.set("direction", direction);
	      }});
	    }
	    else {
	      collection.comparator = comparator;
	      collection.sort();
	      collection.trigger("backgrid:sorted", column, direction, collection);
	      column.set("direction", direction);
	    }
	
	    return this;
	  },
	
	  makeComparator: function (attr, order, func) {
	
	    return function (left, right) {
	      // extract the values from the models
	      var l = func(left, attr), r = func(right, attr), t;
	
	      // if descending order, swap left and right
	      if (order === 1) t = l, l = r, r = t;
	
	      // compare as usual
	      if (l === r) return 0;
	      else if (l < r) return -1;
	      return 1;
	    };
	  },
	
	  /**
	     Moves focus to the next renderable and editable cell and return the
	     currently editing cell to display mode.
	
	     Triggers a `backgrid:next` event on the model with the indices of the row
	     and column the user *intended* to move to, and whether the intended move
	     was going to go out of bounds. Note that *out of bound* always means an
	     attempt to go past the end of the last row.
	
	     @param {Backbone.Model} model The originating model
	     @param {Backgrid.Column} column The originating model column
	     @param {Backgrid.Command} command The Command object constructed from a DOM
	     event
	  */
	  moveToNextCell: function (model, column, command) {
	    var i = this.collection.indexOf(model);
	    var j = this.columns.indexOf(column);
	    var cell, renderable, editable, m, n;
	
	    // return if model being edited in a different grid
	    if (j === -1) return this;
	
	    this.rows[i].cells[j].exitEditMode();
	
	    if (command.moveUp() || command.moveDown() || command.moveLeft() ||
	        command.moveRight() || command.save()) {
	      var l = this.columns.length;
	      var maxOffset = l * this.collection.length;
	
	      if (command.moveUp() || command.moveDown()) {
	        m = i + (command.moveUp() ? -1 : 1);
	        var row = this.rows[m];
	        if (row) {
	          cell = row.cells[j];
	          if (Backgrid.callByNeed(cell.column.editable(), cell.column, model)) {
	            cell.enterEditMode();
	            model.trigger("backgrid:next", m, j, false);
	          }
	        }
	        else model.trigger("backgrid:next", m, j, true);
	      }
	      else if (command.moveLeft() || command.moveRight()) {
	        var right = command.moveRight();
	        for (var offset = i * l + j + (right ? 1 : -1);
	             offset >= 0 && offset < maxOffset;
	             right ? offset++ : offset--) {
	          m = ~~(offset / l);
	          n = offset - m * l;
	          cell = this.rows[m].cells[n];
	          renderable = Backgrid.callByNeed(cell.column.renderable(), cell.column, cell.model);
	          editable = Backgrid.callByNeed(cell.column.editable(), cell.column, model);
	          if (renderable && editable) {
	            cell.enterEditMode();
	            model.trigger("backgrid:next", m, n, false);
	            break;
	          }
	        }
	
	        if (offset == maxOffset) {
	          model.trigger("backgrid:next", ~~(offset / l), offset - m * l, true);
	        }
	      }
	    }
	
	    return this;
	  }
	});
	
	/*
	  backgrid
	  http://github.com/cloudflare/backgrid
	
	  Copyright (c) 2013-present Cloudflare, Inc. and contributors
	  Licensed under the MIT license.
	*/
	
	/**
	   A Footer is a generic class that only defines a default tag `tfoot` and
	   number of required parameters in the initializer.
	
	   @abstract
	   @class Backgrid.Footer
	   @extends Backbone.View
	 */
	var Footer = Backgrid.Footer = Backbone.View.extend({
	
	  /** @property */
	  tagName: "tfoot",
	
	  /**
	     Initializer.
	
	     @param {Object} options
	     @param {Backbone.Collection.<Backgrid.Column>|Array.<Backgrid.Column>|Array.<Object>} options.columns
	     Column metadata.
	     @param {Backbone.Collection} options.collection
	
	     @throws {TypeError} If options.columns or options.collection is undefined.
	  */
	  initialize: function (options) {
	    this.columns = options.columns;
	    if (!(this.columns instanceof Backbone.Collection)) {
	      this.columns = new Backgrid.Columns(this.columns);
	    }
	  }
	
	});
	
	/*
	  backgrid
	  http://github.com/cloudflare/backgrid
	
	  Copyright (c) 2013-present Cloudflare, Inc. and contributors
	  Licensed under the MIT license.
	*/
	
	/**
	   Grid represents a data grid that has a header, body and an optional footer.
	
	   By default, a Grid treats each model in a collection as a row, and each
	   attribute in a model as a column. To render a grid you must provide a list of
	   column metadata and a collection to the Grid constructor. Just like any
	   Backbone.View class, the grid is rendered as a DOM node fragment when you
	   call render().
	
	       var grid = Backgrid.Grid({
	         columns: [{ name: "id", label: "ID", type: "string" },
	          // ...
	         ],
	         collections: books
	       });
	
	       $("#table-container").append(grid.render().el);
	
	   Optionally, if you want to customize the rendering of the grid's header and
	   footer, you may choose to extend Backgrid.Header and Backgrid.Footer, and
	   then supply that class or an instance of that class to the Grid constructor.
	   See the documentation for Header and Footer for further details.
	
	       var grid = Backgrid.Grid({
	         columns: [{ name: "id", label: "ID", type: "string" }],
	         collections: books,
	         header: Backgrid.Header.extend({
	              //...
	         }),
	         footer: Backgrid.Paginator
	       });
	
	   Finally, if you want to override how the rows are rendered in the table body,
	   you can supply a Body subclass as the `body` attribute that uses a different
	   Row class.
	
	   @class Backgrid.Grid
	   @extends Backbone.View
	
	   See:
	
	   - Backgrid.Column
	   - Backgrid.Header
	   - Backgrid.Body
	   - Backgrid.Row
	   - Backgrid.Footer
	*/
	var Grid = Backgrid.Grid = Backbone.View.extend({
	
	  /** @property */
	  tagName: "table",
	
	  /** @property */
	  className: "backgrid",
	
	  /** @property */
	  header: Header,
	
	  /** @property */
	  body: Body,
	
	  /** @property */
	  footer: null,
	
	  /**
	     Initializes a Grid instance.
	
	     @param {Object} options
	     @param {Backbone.Collection.<Backgrid.Columns>|Array.<Backgrid.Column>|Array.<Object>} options.columns Column metadata.
	     @param {Backbone.Collection} options.collection The collection of tabular model data to display.
	     @param {string} [options.caption=string] An optional caption to be added to the table.
	     @param {Backgrid.Header} [options.header=Backgrid.Header] An optional Header class to override the default.
	     @param {Backgrid.Body} [options.body=Backgrid.Body] An optional Body class to override the default.
	     @param {Backgrid.Row} [options.row=Backgrid.Row] An optional Row class to override the default.
	     @param {Backgrid.Footer} [options.footer=Backgrid.Footer] An optional Footer class.
	   */
	  initialize: function (options) {
	    // Convert the list of column objects here first so the subviews don't have
	    // to.
	    if (!(options.columns instanceof Backbone.Collection)) {
	      options.columns = new Columns(options.columns || this.columns);
	    }
	    this.columns = options.columns;
	    
	    this.caption = options.caption;
	
	    var filteredOptions = _.omit(options, ["el", "id", "attributes",
	                                           "className", "tagName", "events"]);
	
	    // must construct body first so it listens to backgrid:sort first
	    this.body = options.body || this.body;
	    this.body = new this.body(filteredOptions);
	
	    this.header = options.header || this.header;
	    if (this.header) {
	      this.header = new this.header(filteredOptions);
	    }
	
	    this.footer = options.footer || this.footer;
	    if (this.footer) {
	      this.footer = new this.footer(filteredOptions);
	    }
	
	    this.listenTo(this.columns, "reset", function () {
	      if (this.header) {
	        this.header = new (this.header.remove().constructor)(filteredOptions);
	      }
	      this.body = new (this.body.remove().constructor)(filteredOptions);
	      if (this.footer) {
	        this.footer = new (this.footer.remove().constructor)(filteredOptions);
	      }
	      this.render();
	    });
	  },
	
	  /**
	     Delegates to Backgrid.Body#insertRow.
	   */
	  insertRow: function () {
	    this.body.insertRow.apply(this.body, arguments);
	    return this;
	  },
	
	  /**
	     Delegates to Backgrid.Body#removeRow.
	   */
	  removeRow: function () {
	    this.body.removeRow.apply(this.body, arguments);
	    return this;
	  },
	
	  /**
	     Delegates to Backgrid.Columns#add for adding a column. Subviews can listen
	     to the `add` event from their internal `columns` if rerendering needs to
	     happen.
	
	     @param {Object} [options] Options for `Backgrid.Columns#add`.
	   */
	  insertColumn: function () {
	    this.columns.add.apply(this.columns, arguments);
	    return this;
	  },
	
	  /**
	     Delegates to Backgrid.Columns#remove for removing a column. Subviews can
	     listen to the `remove` event from the internal `columns` if rerendering
	     needs to happen.
	
	     @param {Object} [options] Options for `Backgrid.Columns#remove`.
	   */
	  removeColumn: function () {
	    this.columns.remove.apply(this.columns, arguments);
	    return this;
	  },
	
	  /**
	     Delegates to Backgrid.Body#sort.
	   */
	  sort: function () {
	    this.body.sort.apply(this.body, arguments);
	    return this;
	  },
	
	  /**
	     Renders the grid's caption, then header, then footer, then finally the body. Triggers a
	     Backbone `backgrid:rendered` event along with a reference to the grid when
	     the it has successfully been rendered.
	   */
	  render: function () {
	    this.$el.empty();
	    
	    if (this.caption) {
	      this.$el.append($("<caption>").text(this.caption));
	    }
	
	    if (this.header) {
	      this.$el.append(this.header.render().$el);
	    }
	
	    if (this.footer) {
	      this.$el.append(this.footer.render().$el);
	    }
	
	    this.$el.append(this.body.render().$el);
	
	    this.delegateEvents();
	
	    this.trigger("backgrid:rendered", this);
	
	    return this;
	  },
	
	  /**
	     Clean up this grid and its subviews.
	
	     @chainable
	   */
	  remove: function () {
	    this.header && this.header.remove.apply(this.header, arguments);
	    this.body.remove.apply(this.body, arguments);
	    this.footer && this.footer.remove.apply(this.footer, arguments);
	    return Backbone.View.prototype.remove.apply(this, arguments);
	  }
	
	});
	  return Backgrid;
	}));

/***/ },
/* 59 */,
/* 60 */
[1957, 7, 16],
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/* WEBPACK VAR INJECTION */(function($) {/*!
	 * Select2 4.0.13
	 * https://select2.github.io
	 *
	 * Released under the MIT license
	 * https://github.com/select2/select2/blob/master/LICENSE.md
	 */
	;(function (factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(18)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node/CommonJS
	    module.exports = function (root, jQuery) {
	      if (jQuery === undefined) {
	        // require('jQuery') returns a factory that requires window to
	        // build a jQuery instance, we normalize how we use modules
	        // that require this pattern but the window provided is a noop
	        // if it's defined (how jquery works)
	        if (typeof window !== 'undefined') {
	          jQuery = require('jquery');
	        }
	        else {
	          jQuery = require('jquery')(root);
	        }
	      }
	      factory(jQuery);
	      return jQuery;
	    };
	  } else {
	    // Browser globals
	    factory(jQuery);
	  }
	} (function (jQuery) {
	  // This is needed so we can catch the AMD loader configuration and use it
	  // The inner file should be wrapped (by `banner.start.js`) in a function that
	  // returns the AMD loader references.
	  var S2 =(function () {
	  // Restore the Select2 AMD loader so it can be used
	  // Needed mostly in the language files, where the loader is not inserted
	  if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) {
	    var S2 = jQuery.fn.select2.amd;
	  }
	var S2;(function () { if (!S2 || !S2.requirejs) {
	if (!S2) { S2 = {}; } else { require = S2; }
	/**
	 * @license almond 0.3.3 Copyright jQuery Foundation and other contributors.
	 * Released under MIT license, http://github.com/requirejs/almond/LICENSE
	 */
	//Going sloppy to avoid 'use strict' string cost, but strict practices should
	//be followed.
	/*global setTimeout: false */
	
	var requirejs, require, define;
	(function (undef) {
	    var main, req, makeMap, handlers,
	        defined = {},
	        waiting = {},
	        config = {},
	        defining = {},
	        hasOwn = Object.prototype.hasOwnProperty,
	        aps = [].slice,
	        jsSuffixRegExp = /\.js$/;
	
	    function hasProp(obj, prop) {
	        return hasOwn.call(obj, prop);
	    }
	
	    /**
	     * Given a relative module name, like ./something, normalize it to
	     * a real name that can be mapped to a path.
	     * @param {String} name the relative name
	     * @param {String} baseName a real name that the name arg is relative
	     * to.
	     * @returns {String} normalized name
	     */
	    function normalize(name, baseName) {
	        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
	            foundI, foundStarMap, starI, i, j, part, normalizedBaseParts,
	            baseParts = baseName && baseName.split("/"),
	            map = config.map,
	            starMap = (map && map['*']) || {};
	
	        //Adjust any relative paths.
	        if (name) {
	            name = name.split('/');
	            lastIndex = name.length - 1;
	
	            // If wanting node ID compatibility, strip .js from end
	            // of IDs. Have to do this here, and not in nameToUrl
	            // because node allows either .js or non .js to map
	            // to same file.
	            if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
	                name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
	            }
	
	            // Starts with a '.' so need the baseName
	            if (name[0].charAt(0) === '.' && baseParts) {
	                //Convert baseName to array, and lop off the last part,
	                //so that . matches that 'directory' and not name of the baseName's
	                //module. For instance, baseName of 'one/two/three', maps to
	                //'one/two/three.js', but we want the directory, 'one/two' for
	                //this normalization.
	                normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
	                name = normalizedBaseParts.concat(name);
	            }
	
	            //start trimDots
	            for (i = 0; i < name.length; i++) {
	                part = name[i];
	                if (part === '.') {
	                    name.splice(i, 1);
	                    i -= 1;
	                } else if (part === '..') {
	                    // If at the start, or previous value is still ..,
	                    // keep them so that when converted to a path it may
	                    // still work when converted to a path, even though
	                    // as an ID it is less than ideal. In larger point
	                    // releases, may be better to just kick out an error.
	                    if (i === 0 || (i === 1 && name[2] === '..') || name[i - 1] === '..') {
	                        continue;
	                    } else if (i > 0) {
	                        name.splice(i - 1, 2);
	                        i -= 2;
	                    }
	                }
	            }
	            //end trimDots
	
	            name = name.join('/');
	        }
	
	        //Apply map config if available.
	        if ((baseParts || starMap) && map) {
	            nameParts = name.split('/');
	
	            for (i = nameParts.length; i > 0; i -= 1) {
	                nameSegment = nameParts.slice(0, i).join("/");
	
	                if (baseParts) {
	                    //Find the longest baseName segment match in the config.
	                    //So, do joins on the biggest to smallest lengths of baseParts.
	                    for (j = baseParts.length; j > 0; j -= 1) {
	                        mapValue = map[baseParts.slice(0, j).join('/')];
	
	                        //baseName segment has  config, find if it has one for
	                        //this name.
	                        if (mapValue) {
	                            mapValue = mapValue[nameSegment];
	                            if (mapValue) {
	                                //Match, update name to the new value.
	                                foundMap = mapValue;
	                                foundI = i;
	                                break;
	                            }
	                        }
	                    }
	                }
	
	                if (foundMap) {
	                    break;
	                }
	
	                //Check for a star map match, but just hold on to it,
	                //if there is a shorter segment match later in a matching
	                //config, then favor over this star map.
	                if (!foundStarMap && starMap && starMap[nameSegment]) {
	                    foundStarMap = starMap[nameSegment];
	                    starI = i;
	                }
	            }
	
	            if (!foundMap && foundStarMap) {
	                foundMap = foundStarMap;
	                foundI = starI;
	            }
	
	            if (foundMap) {
	                nameParts.splice(0, foundI, foundMap);
	                name = nameParts.join('/');
	            }
	        }
	
	        return name;
	    }
	
	    function makeRequire(relName, forceSync) {
	        return function () {
	            //A version of a require function that passes a moduleName
	            //value for items that may need to
	            //look up paths relative to the moduleName
	            var args = aps.call(arguments, 0);
	
	            //If first arg is not require('string'), and there is only
	            //one arg, it is the array form without a callback. Insert
	            //a null so that the following concat is correct.
	            if (typeof args[0] !== 'string' && args.length === 1) {
	                args.push(null);
	            }
	            return req.apply(undef, args.concat([relName, forceSync]));
	        };
	    }
	
	    function makeNormalize(relName) {
	        return function (name) {
	            return normalize(name, relName);
	        };
	    }
	
	    function makeLoad(depName) {
	        return function (value) {
	            defined[depName] = value;
	        };
	    }
	
	    function callDep(name) {
	        if (hasProp(waiting, name)) {
	            var args = waiting[name];
	            delete waiting[name];
	            defining[name] = true;
	            main.apply(undef, args);
	        }
	
	        if (!hasProp(defined, name) && !hasProp(defining, name)) {
	            throw new Error('No ' + name);
	        }
	        return defined[name];
	    }
	
	    //Turns a plugin!resource to [plugin, resource]
	    //with the plugin being undefined if the name
	    //did not have a plugin prefix.
	    function splitPrefix(name) {
	        var prefix,
	            index = name ? name.indexOf('!') : -1;
	        if (index > -1) {
	            prefix = name.substring(0, index);
	            name = name.substring(index + 1, name.length);
	        }
	        return [prefix, name];
	    }
	
	    //Creates a parts array for a relName where first part is plugin ID,
	    //second part is resource ID. Assumes relName has already been normalized.
	    function makeRelParts(relName) {
	        return relName ? splitPrefix(relName) : [];
	    }
	
	    /**
	     * Makes a name map, normalizing the name, and using a plugin
	     * for normalization if necessary. Grabs a ref to plugin
	     * too, as an optimization.
	     */
	    makeMap = function (name, relParts) {
	        var plugin,
	            parts = splitPrefix(name),
	            prefix = parts[0],
	            relResourceName = relParts[1];
	
	        name = parts[1];
	
	        if (prefix) {
	            prefix = normalize(prefix, relResourceName);
	            plugin = callDep(prefix);
	        }
	
	        //Normalize according
	        if (prefix) {
	            if (plugin && plugin.normalize) {
	                name = plugin.normalize(name, makeNormalize(relResourceName));
	            } else {
	                name = normalize(name, relResourceName);
	            }
	        } else {
	            name = normalize(name, relResourceName);
	            parts = splitPrefix(name);
	            prefix = parts[0];
	            name = parts[1];
	            if (prefix) {
	                plugin = callDep(prefix);
	            }
	        }
	
	        //Using ridiculous property names for space reasons
	        return {
	            f: prefix ? prefix + '!' + name : name, //fullName
	            n: name,
	            pr: prefix,
	            p: plugin
	        };
	    };
	
	    function makeConfig(name) {
	        return function () {
	            return (config && config.config && config.config[name]) || {};
	        };
	    }
	
	    handlers = {
	        require: function (name) {
	            return makeRequire(name);
	        },
	        exports: function (name) {
	            var e = defined[name];
	            if (typeof e !== 'undefined') {
	                return e;
	            } else {
	                return (defined[name] = {});
	            }
	        },
	        module: function (name) {
	            return {
	                id: name,
	                uri: '',
	                exports: defined[name],
	                config: makeConfig(name)
	            };
	        }
	    };
	
	    main = function (name, deps, callback, relName) {
	        var cjsModule, depName, ret, map, i, relParts,
	            args = [],
	            callbackType = typeof callback,
	            usingExports;
	
	        //Use name if no relName
	        relName = relName || name;
	        relParts = makeRelParts(relName);
	
	        //Call the callback to define the module, if necessary.
	        if (callbackType === 'undefined' || callbackType === 'function') {
	            //Pull out the defined dependencies and pass the ordered
	            //values to the callback.
	            //Default to [require, exports, module] if no deps
	            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
	            for (i = 0; i < deps.length; i += 1) {
	                map = makeMap(deps[i], relParts);
	                depName = map.f;
	
	                //Fast path CommonJS standard dependencies.
	                if (depName === "require") {
	                    args[i] = handlers.require(name);
	                } else if (depName === "exports") {
	                    //CommonJS module spec 1.1
	                    args[i] = handlers.exports(name);
	                    usingExports = true;
	                } else if (depName === "module") {
	                    //CommonJS module spec 1.1
	                    cjsModule = args[i] = handlers.module(name);
	                } else if (hasProp(defined, depName) ||
	                           hasProp(waiting, depName) ||
	                           hasProp(defining, depName)) {
	                    args[i] = callDep(depName);
	                } else if (map.p) {
	                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
	                    args[i] = defined[depName];
	                } else {
	                    throw new Error(name + ' missing ' + depName);
	                }
	            }
	
	            ret = callback ? callback.apply(defined[name], args) : undefined;
	
	            if (name) {
	                //If setting exports via "module" is in play,
	                //favor that over return value and exports. After that,
	                //favor a non-undefined return value over exports use.
	                if (cjsModule && cjsModule.exports !== undef &&
	                        cjsModule.exports !== defined[name]) {
	                    defined[name] = cjsModule.exports;
	                } else if (ret !== undef || !usingExports) {
	                    //Use the return value from the function.
	                    defined[name] = ret;
	                }
	            }
	        } else if (name) {
	            //May just be an object definition for the module. Only
	            //worry about defining if have a module name.
	            defined[name] = callback;
	        }
	    };
	
	    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
	        if (typeof deps === "string") {
	            if (handlers[deps]) {
	                //callback in this case is really relName
	                return handlers[deps](callback);
	            }
	            //Just return the module wanted. In this scenario, the
	            //deps arg is the module name, and second arg (if passed)
	            //is just the relName.
	            //Normalize module name, if it contains . or ..
	            return callDep(makeMap(deps, makeRelParts(callback)).f);
	        } else if (!deps.splice) {
	            //deps is a config object, not an array.
	            config = deps;
	            if (config.deps) {
	                req(config.deps, config.callback);
	            }
	            if (!callback) {
	                return;
	            }
	
	            if (callback.splice) {
	                //callback is an array, which means it is a dependency list.
	                //Adjust args if there are dependencies
	                deps = callback;
	                callback = relName;
	                relName = null;
	            } else {
	                deps = undef;
	            }
	        }
	
	        //Support require(['a'])
	        callback = callback || function () {};
	
	        //If relName is a function, it is an errback handler,
	        //so remove it.
	        if (typeof relName === 'function') {
	            relName = forceSync;
	            forceSync = alt;
	        }
	
	        //Simulate async callback;
	        if (forceSync) {
	            main(undef, deps, callback, relName);
	        } else {
	            //Using a non-zero value because of concern for what old browsers
	            //do, and latest browsers "upgrade" to 4 if lower value is used:
	            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
	            //If want a value immediately, use require('id') instead -- something
	            //that works in almond on the global level, but not guaranteed and
	            //unlikely to work in other AMD implementations.
	            setTimeout(function () {
	                main(undef, deps, callback, relName);
	            }, 4);
	        }
	
	        return req;
	    };
	
	    /**
	     * Just drops the config on the floor, but returns req in case
	     * the config return value is used.
	     */
	    req.config = function (cfg) {
	        return req(cfg);
	    };
	
	    /**
	     * Expose module registry for debugging and tooling
	     */
	    requirejs._defined = defined;
	
	    define = function (name, deps, callback) {
	        if (typeof name !== 'string') {
	            throw new Error('See almond README: incorrect module build, no module name');
	        }
	
	        //This module may not have dependencies
	        if (!deps.splice) {
	            //deps is not an array, so probably means
	            //an object literal or factory function for
	            //the value. Adjust args.
	            callback = deps;
	            deps = [];
	        }
	
	        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
	            waiting[name] = [name, deps, callback];
	        }
	    };
	
	    define.amd = {
	        jQuery: true
	    };
	}());
	
	S2.requirejs = requirejs;S2.require = require;S2.define = define;
	}
	}());
	S2.define("almond", function(){});
	
	/* global jQuery:false, $:false */
	S2.define('jquery',[],function () {
	  var _$ = jQuery || $;
	
	  if (_$ == null && console && console.error) {
	    console.error(
	      'Select2: An instance of jQuery or a jQuery-compatible library was not ' +
	      'found. Make sure that you are including jQuery before Select2 on your ' +
	      'web page.'
	    );
	  }
	
	  return _$;
	});
	
	S2.define('select2/utils',[
	  'jquery'
	], function ($) {
	  var Utils = {};
	
	  Utils.Extend = function (ChildClass, SuperClass) {
	    var __hasProp = {}.hasOwnProperty;
	
	    function BaseConstructor () {
	      this.constructor = ChildClass;
	    }
	
	    for (var key in SuperClass) {
	      if (__hasProp.call(SuperClass, key)) {
	        ChildClass[key] = SuperClass[key];
	      }
	    }
	
	    BaseConstructor.prototype = SuperClass.prototype;
	    ChildClass.prototype = new BaseConstructor();
	    ChildClass.__super__ = SuperClass.prototype;
	
	    return ChildClass;
	  };
	
	  function getMethods (theClass) {
	    var proto = theClass.prototype;
	
	    var methods = [];
	
	    for (var methodName in proto) {
	      var m = proto[methodName];
	
	      if (typeof m !== 'function') {
	        continue;
	      }
	
	      if (methodName === 'constructor') {
	        continue;
	      }
	
	      methods.push(methodName);
	    }
	
	    return methods;
	  }
	
	  Utils.Decorate = function (SuperClass, DecoratorClass) {
	    var decoratedMethods = getMethods(DecoratorClass);
	    var superMethods = getMethods(SuperClass);
	
	    function DecoratedClass () {
	      var unshift = Array.prototype.unshift;
	
	      var argCount = DecoratorClass.prototype.constructor.length;
	
	      var calledConstructor = SuperClass.prototype.constructor;
	
	      if (argCount > 0) {
	        unshift.call(arguments, SuperClass.prototype.constructor);
	
	        calledConstructor = DecoratorClass.prototype.constructor;
	      }
	
	      calledConstructor.apply(this, arguments);
	    }
	
	    DecoratorClass.displayName = SuperClass.displayName;
	
	    function ctr () {
	      this.constructor = DecoratedClass;
	    }
	
	    DecoratedClass.prototype = new ctr();
	
	    for (var m = 0; m < superMethods.length; m++) {
	      var superMethod = superMethods[m];
	
	      DecoratedClass.prototype[superMethod] =
	        SuperClass.prototype[superMethod];
	    }
	
	    var calledMethod = function (methodName) {
	      // Stub out the original method if it's not decorating an actual method
	      var originalMethod = function () {};
	
	      if (methodName in DecoratedClass.prototype) {
	        originalMethod = DecoratedClass.prototype[methodName];
	      }
	
	      var decoratedMethod = DecoratorClass.prototype[methodName];
	
	      return function () {
	        var unshift = Array.prototype.unshift;
	
	        unshift.call(arguments, originalMethod);
	
	        return decoratedMethod.apply(this, arguments);
	      };
	    };
	
	    for (var d = 0; d < decoratedMethods.length; d++) {
	      var decoratedMethod = decoratedMethods[d];
	
	      DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
	    }
	
	    return DecoratedClass;
	  };
	
	  var Observable = function () {
	    this.listeners = {};
	  };
	
	  Observable.prototype.on = function (event, callback) {
	    this.listeners = this.listeners || {};
	
	    if (event in this.listeners) {
	      this.listeners[event].push(callback);
	    } else {
	      this.listeners[event] = [callback];
	    }
	  };
	
	  Observable.prototype.trigger = function (event) {
	    var slice = Array.prototype.slice;
	    var params = slice.call(arguments, 1);
	
	    this.listeners = this.listeners || {};
	
	    // Params should always come in as an array
	    if (params == null) {
	      params = [];
	    }
	
	    // If there are no arguments to the event, use a temporary object
	    if (params.length === 0) {
	      params.push({});
	    }
	
	    // Set the `_type` of the first object to the event
	    params[0]._type = event;
	
	    if (event in this.listeners) {
	      this.invoke(this.listeners[event], slice.call(arguments, 1));
	    }
	
	    if ('*' in this.listeners) {
	      this.invoke(this.listeners['*'], arguments);
	    }
	  };
	
	  Observable.prototype.invoke = function (listeners, params) {
	    for (var i = 0, len = listeners.length; i < len; i++) {
	      listeners[i].apply(this, params);
	    }
	  };
	
	  Utils.Observable = Observable;
	
	  Utils.generateChars = function (length) {
	    var chars = '';
	
	    for (var i = 0; i < length; i++) {
	      var randomChar = Math.floor(Math.random() * 36);
	      chars += randomChar.toString(36);
	    }
	
	    return chars;
	  };
	
	  Utils.bind = function (func, context) {
	    return function () {
	      func.apply(context, arguments);
	    };
	  };
	
	  Utils._convertData = function (data) {
	    for (var originalKey in data) {
	      var keys = originalKey.split('-');
	
	      var dataLevel = data;
	
	      if (keys.length === 1) {
	        continue;
	      }
	
	      for (var k = 0; k < keys.length; k++) {
	        var key = keys[k];
	
	        // Lowercase the first letter
	        // By default, dash-separated becomes camelCase
	        key = key.substring(0, 1).toLowerCase() + key.substring(1);
	
	        if (!(key in dataLevel)) {
	          dataLevel[key] = {};
	        }
	
	        if (k == keys.length - 1) {
	          dataLevel[key] = data[originalKey];
	        }
	
	        dataLevel = dataLevel[key];
	      }
	
	      delete data[originalKey];
	    }
	
	    return data;
	  };
	
	  Utils.hasScroll = function (index, el) {
	    // Adapted from the function created by @ShadowScripter
	    // and adapted by @BillBarry on the Stack Exchange Code Review website.
	    // The original code can be found at
	    // http://codereview.stackexchange.com/q/13338
	    // and was designed to be used with the Sizzle selector engine.
	
	    var $el = $(el);
	    var overflowX = el.style.overflowX;
	    var overflowY = el.style.overflowY;
	
	    //Check both x and y declarations
	    if (overflowX === overflowY &&
	        (overflowY === 'hidden' || overflowY === 'visible')) {
	      return false;
	    }
	
	    if (overflowX === 'scroll' || overflowY === 'scroll') {
	      return true;
	    }
	
	    return ($el.innerHeight() < el.scrollHeight ||
	      $el.innerWidth() < el.scrollWidth);
	  };
	
	  Utils.escapeMarkup = function (markup) {
	    var replaceMap = {
	      '\\': '&#92;',
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      '\'': '&#39;',
	      '/': '&#47;'
	    };
	
	    // Do not try to escape the markup if it's not a string
	    if (typeof markup !== 'string') {
	      return markup;
	    }
	
	    return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
	      return replaceMap[match];
	    });
	  };
	
	  // Append an array of jQuery nodes to a given element.
	  Utils.appendMany = function ($element, $nodes) {
	    // jQuery 1.7.x does not support $.fn.append() with an array
	    // Fall back to a jQuery object collection using $.fn.add()
	    if ($.fn.jquery.substr(0, 3) === '1.7') {
	      var $jqNodes = $();
	
	      $.map($nodes, function (node) {
	        $jqNodes = $jqNodes.add(node);
	      });
	
	      $nodes = $jqNodes;
	    }
	
	    $element.append($nodes);
	  };
	
	  // Cache objects in Utils.__cache instead of $.data (see #4346)
	  Utils.__cache = {};
	
	  var id = 0;
	  Utils.GetUniqueElementId = function (element) {
	    // Get a unique element Id. If element has no id,
	    // creates a new unique number, stores it in the id
	    // attribute and returns the new id.
	    // If an id already exists, it simply returns it.
	
	    var select2Id = element.getAttribute('data-select2-id');
	    if (select2Id == null) {
	      // If element has id, use it.
	      if (element.id) {
	        select2Id = element.id;
	        element.setAttribute('data-select2-id', select2Id);
	      } else {
	        element.setAttribute('data-select2-id', ++id);
	        select2Id = id.toString();
	      }
	    }
	    return select2Id;
	  };
	
	  Utils.StoreData = function (element, name, value) {
	    // Stores an item in the cache for a specified element.
	    // name is the cache key.
	    var id = Utils.GetUniqueElementId(element);
	    if (!Utils.__cache[id]) {
	      Utils.__cache[id] = {};
	    }
	
	    Utils.__cache[id][name] = value;
	  };
	
	  Utils.GetData = function (element, name) {
	    // Retrieves a value from the cache by its key (name)
	    // name is optional. If no name specified, return
	    // all cache items for the specified element.
	    // and for a specified element.
	    var id = Utils.GetUniqueElementId(element);
	    if (name) {
	      if (Utils.__cache[id]) {
	        if (Utils.__cache[id][name] != null) {
	          return Utils.__cache[id][name];
	        }
	        return $(element).data(name); // Fallback to HTML5 data attribs.
	      }
	      return $(element).data(name); // Fallback to HTML5 data attribs.
	    } else {
	      return Utils.__cache[id];
	    }
	  };
	
	  Utils.RemoveData = function (element) {
	    // Removes all cached items for a specified element.
	    var id = Utils.GetUniqueElementId(element);
	    if (Utils.__cache[id] != null) {
	      delete Utils.__cache[id];
	    }
	
	    element.removeAttribute('data-select2-id');
	  };
	
	  return Utils;
	});
	
	S2.define('select2/results',[
	  'jquery',
	  './utils'
	], function ($, Utils) {
	  function Results ($element, options, dataAdapter) {
	    this.$element = $element;
	    this.data = dataAdapter;
	    this.options = options;
	
	    Results.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(Results, Utils.Observable);
	
	  Results.prototype.render = function () {
	    var $results = $(
	      '<ul class="select2-results__options" role="listbox"></ul>'
	    );
	
	    if (this.options.get('multiple')) {
	      $results.attr('aria-multiselectable', 'true');
	    }
	
	    this.$results = $results;
	
	    return $results;
	  };
	
	  Results.prototype.clear = function () {
	    this.$results.empty();
	  };
	
	  Results.prototype.displayMessage = function (params) {
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    this.clear();
	    this.hideLoading();
	
	    var $message = $(
	      '<li role="alert" aria-live="assertive"' +
	      ' class="select2-results__option"></li>'
	    );
	
	    var message = this.options.get('translations').get(params.message);
	
	    $message.append(
	      escapeMarkup(
	        message(params.args)
	      )
	    );
	
	    $message[0].className += ' select2-results__message';
	
	    this.$results.append($message);
	  };
	
	  Results.prototype.hideMessages = function () {
	    this.$results.find('.select2-results__message').remove();
	  };
	
	  Results.prototype.append = function (data) {
	    this.hideLoading();
	
	    var $options = [];
	
	    if (data.results == null || data.results.length === 0) {
	      if (this.$results.children().length === 0) {
	        this.trigger('results:message', {
	          message: 'noResults'
	        });
	      }
	
	      return;
	    }
	
	    data.results = this.sort(data.results);
	
	    for (var d = 0; d < data.results.length; d++) {
	      var item = data.results[d];
	
	      var $option = this.option(item);
	
	      $options.push($option);
	    }
	
	    this.$results.append($options);
	  };
	
	  Results.prototype.position = function ($results, $dropdown) {
	    var $resultsContainer = $dropdown.find('.select2-results');
	    $resultsContainer.append($results);
	  };
	
	  Results.prototype.sort = function (data) {
	    var sorter = this.options.get('sorter');
	
	    return sorter(data);
	  };
	
	  Results.prototype.highlightFirstItem = function () {
	    var $options = this.$results
	      .find('.select2-results__option[aria-selected]');
	
	    var $selected = $options.filter('[aria-selected=true]');
	
	    // Check if there are any selected options
	    if ($selected.length > 0) {
	      // If there are selected options, highlight the first
	      $selected.first().trigger('mouseenter');
	    } else {
	      // If there are no selected options, highlight the first option
	      // in the dropdown
	      $options.first().trigger('mouseenter');
	    }
	
	    this.ensureHighlightVisible();
	  };
	
	  Results.prototype.setClasses = function () {
	    var self = this;
	
	    this.data.current(function (selected) {
	      var selectedIds = $.map(selected, function (s) {
	        return s.id.toString();
	      });
	
	      var $options = self.$results
	        .find('.select2-results__option[aria-selected]');
	
	      $options.each(function () {
	        var $option = $(this);
	
	        var item = Utils.GetData(this, 'data');
	
	        // id needs to be converted to a string when comparing
	        var id = '' + item.id;
	
	        if ((item.element != null && item.element.selected) ||
	            (item.element == null && $.inArray(id, selectedIds) > -1)) {
	          $option.attr('aria-selected', 'true');
	        } else {
	          $option.attr('aria-selected', 'false');
	        }
	      });
	
	    });
	  };
	
	  Results.prototype.showLoading = function (params) {
	    this.hideLoading();
	
	    var loadingMore = this.options.get('translations').get('searching');
	
	    var loading = {
	      disabled: true,
	      loading: true,
	      text: loadingMore(params)
	    };
	    var $loading = this.option(loading);
	    $loading.className += ' loading-results';
	
	    this.$results.prepend($loading);
	  };
	
	  Results.prototype.hideLoading = function () {
	    this.$results.find('.loading-results').remove();
	  };
	
	  Results.prototype.option = function (data) {
	    var option = document.createElement('li');
	    option.className = 'select2-results__option';
	
	    var attrs = {
	      'role': 'option',
	      'aria-selected': 'false'
	    };
	
	    var matches = window.Element.prototype.matches ||
	      window.Element.prototype.msMatchesSelector ||
	      window.Element.prototype.webkitMatchesSelector;
	
	    if ((data.element != null && matches.call(data.element, ':disabled')) ||
	        (data.element == null && data.disabled)) {
	      delete attrs['aria-selected'];
	      attrs['aria-disabled'] = 'true';
	    }
	
	    if (data.id == null) {
	      delete attrs['aria-selected'];
	    }
	
	    if (data._resultId != null) {
	      option.id = data._resultId;
	    }
	
	    if (data.title) {
	      option.title = data.title;
	    }
	
	    if (data.children) {
	      attrs.role = 'group';
	      attrs['aria-label'] = data.text;
	      delete attrs['aria-selected'];
	    }
	
	    for (var attr in attrs) {
	      var val = attrs[attr];
	
	      option.setAttribute(attr, val);
	    }
	
	    if (data.children) {
	      var $option = $(option);
	
	      var label = document.createElement('strong');
	      label.className = 'select2-results__group';
	
	      var $label = $(label);
	      this.template(data, label);
	
	      var $children = [];
	
	      for (var c = 0; c < data.children.length; c++) {
	        var child = data.children[c];
	
	        var $child = this.option(child);
	
	        $children.push($child);
	      }
	
	      var $childrenContainer = $('<ul></ul>', {
	        'class': 'select2-results__options select2-results__options--nested'
	      });
	
	      $childrenContainer.append($children);
	
	      $option.append(label);
	      $option.append($childrenContainer);
	    } else {
	      this.template(data, option);
	    }
	
	    Utils.StoreData(option, 'data', data);
	
	    return option;
	  };
	
	  Results.prototype.bind = function (container, $container) {
	    var self = this;
	
	    var id = container.id + '-results';
	
	    this.$results.attr('id', id);
	
	    container.on('results:all', function (params) {
	      self.clear();
	      self.append(params.data);
	
	      if (container.isOpen()) {
	        self.setClasses();
	        self.highlightFirstItem();
	      }
	    });
	
	    container.on('results:append', function (params) {
	      self.append(params.data);
	
	      if (container.isOpen()) {
	        self.setClasses();
	      }
	    });
	
	    container.on('query', function (params) {
	      self.hideMessages();
	      self.showLoading(params);
	    });
	
	    container.on('select', function () {
	      if (!container.isOpen()) {
	        return;
	      }
	
	      self.setClasses();
	
	      if (self.options.get('scrollAfterSelect')) {
	        self.highlightFirstItem();
	      }
	    });
	
	    container.on('unselect', function () {
	      if (!container.isOpen()) {
	        return;
	      }
	
	      self.setClasses();
	
	      if (self.options.get('scrollAfterSelect')) {
	        self.highlightFirstItem();
	      }
	    });
	
	    container.on('open', function () {
	      // When the dropdown is open, aria-expended="true"
	      self.$results.attr('aria-expanded', 'true');
	      self.$results.attr('aria-hidden', 'false');
	
	      self.setClasses();
	      self.ensureHighlightVisible();
	    });
	
	    container.on('close', function () {
	      // When the dropdown is closed, aria-expended="false"
	      self.$results.attr('aria-expanded', 'false');
	      self.$results.attr('aria-hidden', 'true');
	      self.$results.removeAttr('aria-activedescendant');
	    });
	
	    container.on('results:toggle', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      if ($highlighted.length === 0) {
	        return;
	      }
	
	      $highlighted.trigger('mouseup');
	    });
	
	    container.on('results:select', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      if ($highlighted.length === 0) {
	        return;
	      }
	
	      var data = Utils.GetData($highlighted[0], 'data');
	
	      if ($highlighted.attr('aria-selected') == 'true') {
	        self.trigger('close', {});
	      } else {
	        self.trigger('select', {
	          data: data
	        });
	      }
	    });
	
	    container.on('results:previous', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      var $options = self.$results.find('[aria-selected]');
	
	      var currentIndex = $options.index($highlighted);
	
	      // If we are already at the top, don't move further
	      // If no options, currentIndex will be -1
	      if (currentIndex <= 0) {
	        return;
	      }
	
	      var nextIndex = currentIndex - 1;
	
	      // If none are highlighted, highlight the first
	      if ($highlighted.length === 0) {
	        nextIndex = 0;
	      }
	
	      var $next = $options.eq(nextIndex);
	
	      $next.trigger('mouseenter');
	
	      var currentOffset = self.$results.offset().top;
	      var nextTop = $next.offset().top;
	      var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);
	
	      if (nextIndex === 0) {
	        self.$results.scrollTop(0);
	      } else if (nextTop - currentOffset < 0) {
	        self.$results.scrollTop(nextOffset);
	      }
	    });
	
	    container.on('results:next', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      var $options = self.$results.find('[aria-selected]');
	
	      var currentIndex = $options.index($highlighted);
	
	      var nextIndex = currentIndex + 1;
	
	      // If we are at the last option, stay there
	      if (nextIndex >= $options.length) {
	        return;
	      }
	
	      var $next = $options.eq(nextIndex);
	
	      $next.trigger('mouseenter');
	
	      var currentOffset = self.$results.offset().top +
	        self.$results.outerHeight(false);
	      var nextBottom = $next.offset().top + $next.outerHeight(false);
	      var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;
	
	      if (nextIndex === 0) {
	        self.$results.scrollTop(0);
	      } else if (nextBottom > currentOffset) {
	        self.$results.scrollTop(nextOffset);
	      }
	    });
	
	    container.on('results:focus', function (params) {
	      params.element.addClass('select2-results__option--highlighted');
	    });
	
	    container.on('results:message', function (params) {
	      self.displayMessage(params);
	    });
	
	    if ($.fn.mousewheel) {
	      this.$results.on('mousewheel', function (e) {
	        var top = self.$results.scrollTop();
	
	        var bottom = self.$results.get(0).scrollHeight - top + e.deltaY;
	
	        var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
	        var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();
	
	        if (isAtTop) {
	          self.$results.scrollTop(0);
	
	          e.preventDefault();
	          e.stopPropagation();
	        } else if (isAtBottom) {
	          self.$results.scrollTop(
	            self.$results.get(0).scrollHeight - self.$results.height()
	          );
	
	          e.preventDefault();
	          e.stopPropagation();
	        }
	      });
	    }
	
	    this.$results.on('mouseup', '.select2-results__option[aria-selected]',
	      function (evt) {
	      var $this = $(this);
	
	      var data = Utils.GetData(this, 'data');
	
	      if ($this.attr('aria-selected') === 'true') {
	        if (self.options.get('multiple')) {
	          self.trigger('unselect', {
	            originalEvent: evt,
	            data: data
	          });
	        } else {
	          self.trigger('close', {});
	        }
	
	        return;
	      }
	
	      self.trigger('select', {
	        originalEvent: evt,
	        data: data
	      });
	    });
	
	    this.$results.on('mouseenter', '.select2-results__option[aria-selected]',
	      function (evt) {
	      var data = Utils.GetData(this, 'data');
	
	      self.getHighlightedResults()
	          .removeClass('select2-results__option--highlighted');
	
	      self.trigger('results:focus', {
	        data: data,
	        element: $(this)
	      });
	    });
	  };
	
	  Results.prototype.getHighlightedResults = function () {
	    var $highlighted = this.$results
	    .find('.select2-results__option--highlighted');
	
	    return $highlighted;
	  };
	
	  Results.prototype.destroy = function () {
	    this.$results.remove();
	  };
	
	  Results.prototype.ensureHighlightVisible = function () {
	    var $highlighted = this.getHighlightedResults();
	
	    if ($highlighted.length === 0) {
	      return;
	    }
	
	    var $options = this.$results.find('[aria-selected]');
	
	    var currentIndex = $options.index($highlighted);
	
	    var currentOffset = this.$results.offset().top;
	    var nextTop = $highlighted.offset().top;
	    var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);
	
	    var offsetDelta = nextTop - currentOffset;
	    nextOffset -= $highlighted.outerHeight(false) * 2;
	
	    if (currentIndex <= 2) {
	      this.$results.scrollTop(0);
	    } else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) {
	      this.$results.scrollTop(nextOffset);
	    }
	  };
	
	  Results.prototype.template = function (result, container) {
	    var template = this.options.get('templateResult');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    var content = template(result, container);
	
	    if (content == null) {
	      container.style.display = 'none';
	    } else if (typeof content === 'string') {
	      container.innerHTML = escapeMarkup(content);
	    } else {
	      $(container).append(content);
	    }
	  };
	
	  return Results;
	});
	
	S2.define('select2/keys',[
	
	], function () {
	  var KEYS = {
	    BACKSPACE: 8,
	    TAB: 9,
	    ENTER: 13,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    ESC: 27,
	    SPACE: 32,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    END: 35,
	    HOME: 36,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    DELETE: 46
	  };
	
	  return KEYS;
	});
	
	S2.define('select2/selection/base',[
	  'jquery',
	  '../utils',
	  '../keys'
	], function ($, Utils, KEYS) {
	  function BaseSelection ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    BaseSelection.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(BaseSelection, Utils.Observable);
	
	  BaseSelection.prototype.render = function () {
	    var $selection = $(
	      '<span class="select2-selection" role="combobox" ' +
	      ' aria-haspopup="true" aria-expanded="false">' +
	      '</span>'
	    );
	
	    this._tabindex = 0;
	
	    if (Utils.GetData(this.$element[0], 'old-tabindex') != null) {
	      this._tabindex = Utils.GetData(this.$element[0], 'old-tabindex');
	    } else if (this.$element.attr('tabindex') != null) {
	      this._tabindex = this.$element.attr('tabindex');
	    }
	
	    $selection.attr('title', this.$element.attr('title'));
	    $selection.attr('tabindex', this._tabindex);
	    $selection.attr('aria-disabled', 'false');
	
	    this.$selection = $selection;
	
	    return $selection;
	  };
	
	  BaseSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    var resultsId = container.id + '-results';
	
	    this.container = container;
	
	    this.$selection.on('focus', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this.$selection.on('blur', function (evt) {
	      self._handleBlur(evt);
	    });
	
	    this.$selection.on('keydown', function (evt) {
	      self.trigger('keypress', evt);
	
	      if (evt.which === KEYS.SPACE) {
	        evt.preventDefault();
	      }
	    });
	
	    container.on('results:focus', function (params) {
	      self.$selection.attr('aria-activedescendant', params.data._resultId);
	    });
	
	    container.on('selection:update', function (params) {
	      self.update(params.data);
	    });
	
	    container.on('open', function () {
	      // When the dropdown is open, aria-expanded="true"
	      self.$selection.attr('aria-expanded', 'true');
	      self.$selection.attr('aria-owns', resultsId);
	
	      self._attachCloseHandler(container);
	    });
	
	    container.on('close', function () {
	      // When the dropdown is closed, aria-expanded="false"
	      self.$selection.attr('aria-expanded', 'false');
	      self.$selection.removeAttr('aria-activedescendant');
	      self.$selection.removeAttr('aria-owns');
	
	      self.$selection.trigger('focus');
	
	      self._detachCloseHandler(container);
	    });
	
	    container.on('enable', function () {
	      self.$selection.attr('tabindex', self._tabindex);
	      self.$selection.attr('aria-disabled', 'false');
	    });
	
	    container.on('disable', function () {
	      self.$selection.attr('tabindex', '-1');
	      self.$selection.attr('aria-disabled', 'true');
	    });
	  };
	
	  BaseSelection.prototype._handleBlur = function (evt) {
	    var self = this;
	
	    // This needs to be delayed as the active element is the body when the tab
	    // key is pressed, possibly along with others.
	    window.setTimeout(function () {
	      // Don't trigger `blur` if the focus is still in the selection
	      if (
	        (document.activeElement == self.$selection[0]) ||
	        ($.contains(self.$selection[0], document.activeElement))
	      ) {
	        return;
	      }
	
	      self.trigger('blur', evt);
	    }, 1);
	  };
	
	  BaseSelection.prototype._attachCloseHandler = function (container) {
	
	    $(document.body).on('mousedown.select2.' + container.id, function (e) {
	      var $target = $(e.target);
	
	      var $select = $target.closest('.select2');
	
	      var $all = $('.select2.select2-container--open');
	
	      $all.each(function () {
	        if (this == $select[0]) {
	          return;
	        }
	
	        var $element = Utils.GetData(this, 'element');
	
	        $element.select2('close');
	      });
	    });
	  };
	
	  BaseSelection.prototype._detachCloseHandler = function (container) {
	    $(document.body).off('mousedown.select2.' + container.id);
	  };
	
	  BaseSelection.prototype.position = function ($selection, $container) {
	    var $selectionContainer = $container.find('.selection');
	    $selectionContainer.append($selection);
	  };
	
	  BaseSelection.prototype.destroy = function () {
	    this._detachCloseHandler(this.container);
	  };
	
	  BaseSelection.prototype.update = function (data) {
	    throw new Error('The `update` method must be defined in child classes.');
	  };
	
	  /**
	   * Helper method to abstract the "enabled" (not "disabled") state of this
	   * object.
	   *
	   * @return {true} if the instance is not disabled.
	   * @return {false} if the instance is disabled.
	   */
	  BaseSelection.prototype.isEnabled = function () {
	    return !this.isDisabled();
	  };
	
	  /**
	   * Helper method to abstract the "disabled" state of this object.
	   *
	   * @return {true} if the disabled option is true.
	   * @return {false} if the disabled option is false.
	   */
	  BaseSelection.prototype.isDisabled = function () {
	    return this.options.get('disabled');
	  };
	
	  return BaseSelection;
	});
	
	S2.define('select2/selection/single',[
	  'jquery',
	  './base',
	  '../utils',
	  '../keys'
	], function ($, BaseSelection, Utils, KEYS) {
	  function SingleSelection () {
	    SingleSelection.__super__.constructor.apply(this, arguments);
	  }
	
	  Utils.Extend(SingleSelection, BaseSelection);
	
	  SingleSelection.prototype.render = function () {
	    var $selection = SingleSelection.__super__.render.call(this);
	
	    $selection.addClass('select2-selection--single');
	
	    $selection.html(
	      '<span class="select2-selection__rendered"></span>' +
	      '<span class="select2-selection__arrow" role="presentation">' +
	        '<b role="presentation"></b>' +
	      '</span>'
	    );
	
	    return $selection;
	  };
	
	  SingleSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    SingleSelection.__super__.bind.apply(this, arguments);
	
	    var id = container.id + '-container';
	
	    this.$selection.find('.select2-selection__rendered')
	      .attr('id', id)
	      .attr('role', 'textbox')
	      .attr('aria-readonly', 'true');
	    this.$selection.attr('aria-labelledby', id);
	
	    this.$selection.on('mousedown', function (evt) {
	      // Only respond to left clicks
	      if (evt.which !== 1) {
	        return;
	      }
	
	      self.trigger('toggle', {
	        originalEvent: evt
	      });
	    });
	
	    this.$selection.on('focus', function (evt) {
	      // User focuses on the container
	    });
	
	    this.$selection.on('blur', function (evt) {
	      // User exits the container
	    });
	
	    container.on('focus', function (evt) {
	      if (!container.isOpen()) {
	        self.$selection.trigger('focus');
	      }
	    });
	  };
	
	  SingleSelection.prototype.clear = function () {
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	    $rendered.empty();
	    $rendered.removeAttr('title'); // clear tooltip on empty
	  };
	
	  SingleSelection.prototype.display = function (data, container) {
	    var template = this.options.get('templateSelection');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    return escapeMarkup(template(data, container));
	  };
	
	  SingleSelection.prototype.selectionContainer = function () {
	    return $('<span></span>');
	  };
	
	  SingleSelection.prototype.update = function (data) {
	    if (data.length === 0) {
	      this.clear();
	      return;
	    }
	
	    var selection = data[0];
	
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	    var formatted = this.display(selection, $rendered);
	
	    $rendered.empty().append(formatted);
	
	    var title = selection.title || selection.text;
	
	    if (title) {
	      $rendered.attr('title', title);
	    } else {
	      $rendered.removeAttr('title');
	    }
	  };
	
	  return SingleSelection;
	});
	
	S2.define('select2/selection/multiple',[
	  'jquery',
	  './base',
	  '../utils'
	], function ($, BaseSelection, Utils) {
	  function MultipleSelection ($element, options) {
	    MultipleSelection.__super__.constructor.apply(this, arguments);
	  }
	
	  Utils.Extend(MultipleSelection, BaseSelection);
	
	  MultipleSelection.prototype.render = function () {
	    var $selection = MultipleSelection.__super__.render.call(this);
	
	    $selection.addClass('select2-selection--multiple');
	
	    $selection.html(
	      '<ul class="select2-selection__rendered"></ul>'
	    );
	
	    return $selection;
	  };
	
	  MultipleSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    MultipleSelection.__super__.bind.apply(this, arguments);
	
	    this.$selection.on('click', function (evt) {
	      self.trigger('toggle', {
	        originalEvent: evt
	      });
	    });
	
	    this.$selection.on(
	      'click',
	      '.select2-selection__choice__remove',
	      function (evt) {
	        // Ignore the event if it is disabled
	        if (self.isDisabled()) {
	          return;
	        }
	
	        var $remove = $(this);
	        var $selection = $remove.parent();
	
	        var data = Utils.GetData($selection[0], 'data');
	
	        self.trigger('unselect', {
	          originalEvent: evt,
	          data: data
	        });
	      }
	    );
	  };
	
	  MultipleSelection.prototype.clear = function () {
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	    $rendered.empty();
	    $rendered.removeAttr('title');
	  };
	
	  MultipleSelection.prototype.display = function (data, container) {
	    var template = this.options.get('templateSelection');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    return escapeMarkup(template(data, container));
	  };
	
	  MultipleSelection.prototype.selectionContainer = function () {
	    var $container = $(
	      '<li class="select2-selection__choice">' +
	        '<span class="select2-selection__choice__remove" role="presentation">' +
	          '&times;' +
	        '</span>' +
	      '</li>'
	    );
	
	    return $container;
	  };
	
	  MultipleSelection.prototype.update = function (data) {
	    this.clear();
	
	    if (data.length === 0) {
	      return;
	    }
	
	    var $selections = [];
	
	    for (var d = 0; d < data.length; d++) {
	      var selection = data[d];
	
	      var $selection = this.selectionContainer();
	      var formatted = this.display(selection, $selection);
	
	      $selection.append(formatted);
	
	      var title = selection.title || selection.text;
	
	      if (title) {
	        $selection.attr('title', title);
	      }
	
	      Utils.StoreData($selection[0], 'data', selection);
	
	      $selections.push($selection);
	    }
	
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	
	    Utils.appendMany($rendered, $selections);
	  };
	
	  return MultipleSelection;
	});
	
	S2.define('select2/selection/placeholder',[
	  '../utils'
	], function (Utils) {
	  function Placeholder (decorated, $element, options) {
	    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));
	
	    decorated.call(this, $element, options);
	  }
	
	  Placeholder.prototype.normalizePlaceholder = function (_, placeholder) {
	    if (typeof placeholder === 'string') {
	      placeholder = {
	        id: '',
	        text: placeholder
	      };
	    }
	
	    return placeholder;
	  };
	
	  Placeholder.prototype.createPlaceholder = function (decorated, placeholder) {
	    var $placeholder = this.selectionContainer();
	
	    $placeholder.html(this.display(placeholder));
	    $placeholder.addClass('select2-selection__placeholder')
	                .removeClass('select2-selection__choice');
	
	    return $placeholder;
	  };
	
	  Placeholder.prototype.update = function (decorated, data) {
	    var singlePlaceholder = (
	      data.length == 1 && data[0].id != this.placeholder.id
	    );
	    var multipleSelections = data.length > 1;
	
	    if (multipleSelections || singlePlaceholder) {
	      return decorated.call(this, data);
	    }
	
	    this.clear();
	
	    var $placeholder = this.createPlaceholder(this.placeholder);
	
	    this.$selection.find('.select2-selection__rendered').append($placeholder);
	  };
	
	  return Placeholder;
	});
	
	S2.define('select2/selection/allowClear',[
	  'jquery',
	  '../keys',
	  '../utils'
	], function ($, KEYS, Utils) {
	  function AllowClear () { }
	
	  AllowClear.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    if (this.placeholder == null) {
	      if (this.options.get('debug') && window.console && console.error) {
	        console.error(
	          'Select2: The `allowClear` option should be used in combination ' +
	          'with the `placeholder` option.'
	        );
	      }
	    }
	
	    this.$selection.on('mousedown', '.select2-selection__clear',
	      function (evt) {
	        self._handleClear(evt);
	    });
	
	    container.on('keypress', function (evt) {
	      self._handleKeyboardClear(evt, container);
	    });
	  };
	
	  AllowClear.prototype._handleClear = function (_, evt) {
	    // Ignore the event if it is disabled
	    if (this.isDisabled()) {
	      return;
	    }
	
	    var $clear = this.$selection.find('.select2-selection__clear');
	
	    // Ignore the event if nothing has been selected
	    if ($clear.length === 0) {
	      return;
	    }
	
	    evt.stopPropagation();
	
	    var data = Utils.GetData($clear[0], 'data');
	
	    var previousVal = this.$element.val();
	    this.$element.val(this.placeholder.id);
	
	    var unselectData = {
	      data: data
	    };
	    this.trigger('clear', unselectData);
	    if (unselectData.prevented) {
	      this.$element.val(previousVal);
	      return;
	    }
	
	    for (var d = 0; d < data.length; d++) {
	      unselectData = {
	        data: data[d]
	      };
	
	      // Trigger the `unselect` event, so people can prevent it from being
	      // cleared.
	      this.trigger('unselect', unselectData);
	
	      // If the event was prevented, don't clear it out.
	      if (unselectData.prevented) {
	        this.$element.val(previousVal);
	        return;
	      }
	    }
	
	    this.$element.trigger('input').trigger('change');
	
	    this.trigger('toggle', {});
	  };
	
	  AllowClear.prototype._handleKeyboardClear = function (_, evt, container) {
	    if (container.isOpen()) {
	      return;
	    }
	
	    if (evt.which == KEYS.DELETE || evt.which == KEYS.BACKSPACE) {
	      this._handleClear(evt);
	    }
	  };
	
	  AllowClear.prototype.update = function (decorated, data) {
	    decorated.call(this, data);
	
	    if (this.$selection.find('.select2-selection__placeholder').length > 0 ||
	        data.length === 0) {
	      return;
	    }
	
	    var removeAll = this.options.get('translations').get('removeAllItems');
	
	    var $remove = $(
	      '<span class="select2-selection__clear" title="' + removeAll() +'">' +
	        '&times;' +
	      '</span>'
	    );
	    Utils.StoreData($remove[0], 'data', data);
	
	    this.$selection.find('.select2-selection__rendered').prepend($remove);
	  };
	
	  return AllowClear;
	});
	
	S2.define('select2/selection/search',[
	  'jquery',
	  '../utils',
	  '../keys'
	], function ($, Utils, KEYS) {
	  function Search (decorated, $element, options) {
	    decorated.call(this, $element, options);
	  }
	
	  Search.prototype.render = function (decorated) {
	    var $search = $(
	      '<li class="select2-search select2-search--inline">' +
	        '<input class="select2-search__field" type="search" tabindex="-1"' +
	        ' autocomplete="off" autocorrect="off" autocapitalize="none"' +
	        ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' +
	      '</li>'
	    );
	
	    this.$searchContainer = $search;
	    this.$search = $search.find('input');
	
	    var $rendered = decorated.call(this);
	
	    this._transferTabIndex();
	
	    return $rendered;
	  };
	
	  Search.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    var resultsId = container.id + '-results';
	
	    decorated.call(this, container, $container);
	
	    container.on('open', function () {
	      self.$search.attr('aria-controls', resultsId);
	      self.$search.trigger('focus');
	    });
	
	    container.on('close', function () {
	      self.$search.val('');
	      self.$search.removeAttr('aria-controls');
	      self.$search.removeAttr('aria-activedescendant');
	      self.$search.trigger('focus');
	    });
	
	    container.on('enable', function () {
	      self.$search.prop('disabled', false);
	
	      self._transferTabIndex();
	    });
	
	    container.on('disable', function () {
	      self.$search.prop('disabled', true);
	    });
	
	    container.on('focus', function (evt) {
	      self.$search.trigger('focus');
	    });
	
	    container.on('results:focus', function (params) {
	      if (params.data._resultId) {
	        self.$search.attr('aria-activedescendant', params.data._resultId);
	      } else {
	        self.$search.removeAttr('aria-activedescendant');
	      }
	    });
	
	    this.$selection.on('focusin', '.select2-search--inline', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this.$selection.on('focusout', '.select2-search--inline', function (evt) {
	      self._handleBlur(evt);
	    });
	
	    this.$selection.on('keydown', '.select2-search--inline', function (evt) {
	      evt.stopPropagation();
	
	      self.trigger('keypress', evt);
	
	      self._keyUpPrevented = evt.isDefaultPrevented();
	
	      var key = evt.which;
	
	      if (key === KEYS.BACKSPACE && self.$search.val() === '') {
	        var $previousChoice = self.$searchContainer
	          .prev('.select2-selection__choice');
	
	        if ($previousChoice.length > 0) {
	          var item = Utils.GetData($previousChoice[0], 'data');
	
	          self.searchRemoveChoice(item);
	
	          evt.preventDefault();
	        }
	      }
	    });
	
	    this.$selection.on('click', '.select2-search--inline', function (evt) {
	      if (self.$search.val()) {
	        evt.stopPropagation();
	      }
	    });
	
	    // Try to detect the IE version should the `documentMode` property that
	    // is stored on the document. This is only implemented in IE and is
	    // slightly cleaner than doing a user agent check.
	    // This property is not available in Edge, but Edge also doesn't have
	    // this bug.
	    var msie = document.documentMode;
	    var disableInputEvents = msie && msie <= 11;
	
	    // Workaround for browsers which do not support the `input` event
	    // This will prevent double-triggering of events for browsers which support
	    // both the `keyup` and `input` events.
	    this.$selection.on(
	      'input.searchcheck',
	      '.select2-search--inline',
	      function (evt) {
	        // IE will trigger the `input` event when a placeholder is used on a
	        // search box. To get around this issue, we are forced to ignore all
	        // `input` events in IE and keep using `keyup`.
	        if (disableInputEvents) {
	          self.$selection.off('input.search input.searchcheck');
	          return;
	        }
	
	        // Unbind the duplicated `keyup` event
	        self.$selection.off('keyup.search');
	      }
	    );
	
	    this.$selection.on(
	      'keyup.search input.search',
	      '.select2-search--inline',
	      function (evt) {
	        // IE will trigger the `input` event when a placeholder is used on a
	        // search box. To get around this issue, we are forced to ignore all
	        // `input` events in IE and keep using `keyup`.
	        if (disableInputEvents && evt.type === 'input') {
	          self.$selection.off('input.search input.searchcheck');
	          return;
	        }
	
	        var key = evt.which;
	
	        // We can freely ignore events from modifier keys
	        if (key == KEYS.SHIFT || key == KEYS.CTRL || key == KEYS.ALT) {
	          return;
	        }
	
	        // Tabbing will be handled during the `keydown` phase
	        if (key == KEYS.TAB) {
	          return;
	        }
	
	        self.handleSearch(evt);
	      }
	    );
	  };
	
	  /**
	   * This method will transfer the tabindex attribute from the rendered
	   * selection to the search box. This allows for the search box to be used as
	   * the primary focus instead of the selection container.
	   *
	   * @private
	   */
	  Search.prototype._transferTabIndex = function (decorated) {
	    this.$search.attr('tabindex', this.$selection.attr('tabindex'));
	    this.$selection.attr('tabindex', '-1');
	  };
	
	  Search.prototype.createPlaceholder = function (decorated, placeholder) {
	    this.$search.attr('placeholder', placeholder.text);
	  };
	
	  Search.prototype.update = function (decorated, data) {
	    var searchHadFocus = this.$search[0] == document.activeElement;
	
	    this.$search.attr('placeholder', '');
	
	    decorated.call(this, data);
	
	    this.$selection.find('.select2-selection__rendered')
	                   .append(this.$searchContainer);
	
	    this.resizeSearch();
	    if (searchHadFocus) {
	      this.$search.trigger('focus');
	    }
	  };
	
	  Search.prototype.handleSearch = function () {
	    this.resizeSearch();
	
	    if (!this._keyUpPrevented) {
	      var input = this.$search.val();
	
	      this.trigger('query', {
	        term: input
	      });
	    }
	
	    this._keyUpPrevented = false;
	  };
	
	  Search.prototype.searchRemoveChoice = function (decorated, item) {
	    this.trigger('unselect', {
	      data: item
	    });
	
	    this.$search.val(item.text);
	    this.handleSearch();
	  };
	
	  Search.prototype.resizeSearch = function () {
	    this.$search.css('width', '25px');
	
	    var width = '';
	
	    if (this.$search.attr('placeholder') !== '') {
	      width = this.$selection.find('.select2-selection__rendered').width();
	    } else {
	      var minimumWidth = this.$search.val().length + 1;
	
	      width = (minimumWidth * 0.75) + 'em';
	    }
	
	    this.$search.css('width', width);
	  };
	
	  return Search;
	});
	
	S2.define('select2/selection/eventRelay',[
	  'jquery'
	], function ($) {
	  function EventRelay () { }
	
	  EventRelay.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	    var relayEvents = [
	      'open', 'opening',
	      'close', 'closing',
	      'select', 'selecting',
	      'unselect', 'unselecting',
	      'clear', 'clearing'
	    ];
	
	    var preventableEvents = [
	      'opening', 'closing', 'selecting', 'unselecting', 'clearing'
	    ];
	
	    decorated.call(this, container, $container);
	
	    container.on('*', function (name, params) {
	      // Ignore events that should not be relayed
	      if ($.inArray(name, relayEvents) === -1) {
	        return;
	      }
	
	      // The parameters should always be an object
	      params = params || {};
	
	      // Generate the jQuery event for the Select2 event
	      var evt = $.Event('select2:' + name, {
	        params: params
	      });
	
	      self.$element.trigger(evt);
	
	      // Only handle preventable events if it was one
	      if ($.inArray(name, preventableEvents) === -1) {
	        return;
	      }
	
	      params.prevented = evt.isDefaultPrevented();
	    });
	  };
	
	  return EventRelay;
	});
	
	S2.define('select2/translation',[
	  'jquery',
	  'require'
	], function ($, require) {
	  function Translation (dict) {
	    this.dict = dict || {};
	  }
	
	  Translation.prototype.all = function () {
	    return this.dict;
	  };
	
	  Translation.prototype.get = function (key) {
	    return this.dict[key];
	  };
	
	  Translation.prototype.extend = function (translation) {
	    this.dict = $.extend({}, translation.all(), this.dict);
	  };
	
	  // Static functions
	
	  Translation._cache = {};
	
	  Translation.loadPath = function (path) {
	    if (!(path in Translation._cache)) {
	      var translations = require(path);
	
	      Translation._cache[path] = translations;
	    }
	
	    return new Translation(Translation._cache[path]);
	  };
	
	  return Translation;
	});
	
	S2.define('select2/diacritics',[
	
	], function () {
	  var diacritics = {
	    '\u24B6': 'A',
	    '\uFF21': 'A',
	    '\u00C0': 'A',
	    '\u00C1': 'A',
	    '\u00C2': 'A',
	    '\u1EA6': 'A',
	    '\u1EA4': 'A',
	    '\u1EAA': 'A',
	    '\u1EA8': 'A',
	    '\u00C3': 'A',
	    '\u0100': 'A',
	    '\u0102': 'A',
	    '\u1EB0': 'A',
	    '\u1EAE': 'A',
	    '\u1EB4': 'A',
	    '\u1EB2': 'A',
	    '\u0226': 'A',
	    '\u01E0': 'A',
	    '\u00C4': 'A',
	    '\u01DE': 'A',
	    '\u1EA2': 'A',
	    '\u00C5': 'A',
	    '\u01FA': 'A',
	    '\u01CD': 'A',
	    '\u0200': 'A',
	    '\u0202': 'A',
	    '\u1EA0': 'A',
	    '\u1EAC': 'A',
	    '\u1EB6': 'A',
	    '\u1E00': 'A',
	    '\u0104': 'A',
	    '\u023A': 'A',
	    '\u2C6F': 'A',
	    '\uA732': 'AA',
	    '\u00C6': 'AE',
	    '\u01FC': 'AE',
	    '\u01E2': 'AE',
	    '\uA734': 'AO',
	    '\uA736': 'AU',
	    '\uA738': 'AV',
	    '\uA73A': 'AV',
	    '\uA73C': 'AY',
	    '\u24B7': 'B',
	    '\uFF22': 'B',
	    '\u1E02': 'B',
	    '\u1E04': 'B',
	    '\u1E06': 'B',
	    '\u0243': 'B',
	    '\u0182': 'B',
	    '\u0181': 'B',
	    '\u24B8': 'C',
	    '\uFF23': 'C',
	    '\u0106': 'C',
	    '\u0108': 'C',
	    '\u010A': 'C',
	    '\u010C': 'C',
	    '\u00C7': 'C',
	    '\u1E08': 'C',
	    '\u0187': 'C',
	    '\u023B': 'C',
	    '\uA73E': 'C',
	    '\u24B9': 'D',
	    '\uFF24': 'D',
	    '\u1E0A': 'D',
	    '\u010E': 'D',
	    '\u1E0C': 'D',
	    '\u1E10': 'D',
	    '\u1E12': 'D',
	    '\u1E0E': 'D',
	    '\u0110': 'D',
	    '\u018B': 'D',
	    '\u018A': 'D',
	    '\u0189': 'D',
	    '\uA779': 'D',
	    '\u01F1': 'DZ',
	    '\u01C4': 'DZ',
	    '\u01F2': 'Dz',
	    '\u01C5': 'Dz',
	    '\u24BA': 'E',
	    '\uFF25': 'E',
	    '\u00C8': 'E',
	    '\u00C9': 'E',
	    '\u00CA': 'E',
	    '\u1EC0': 'E',
	    '\u1EBE': 'E',
	    '\u1EC4': 'E',
	    '\u1EC2': 'E',
	    '\u1EBC': 'E',
	    '\u0112': 'E',
	    '\u1E14': 'E',
	    '\u1E16': 'E',
	    '\u0114': 'E',
	    '\u0116': 'E',
	    '\u00CB': 'E',
	    '\u1EBA': 'E',
	    '\u011A': 'E',
	    '\u0204': 'E',
	    '\u0206': 'E',
	    '\u1EB8': 'E',
	    '\u1EC6': 'E',
	    '\u0228': 'E',
	    '\u1E1C': 'E',
	    '\u0118': 'E',
	    '\u1E18': 'E',
	    '\u1E1A': 'E',
	    '\u0190': 'E',
	    '\u018E': 'E',
	    '\u24BB': 'F',
	    '\uFF26': 'F',
	    '\u1E1E': 'F',
	    '\u0191': 'F',
	    '\uA77B': 'F',
	    '\u24BC': 'G',
	    '\uFF27': 'G',
	    '\u01F4': 'G',
	    '\u011C': 'G',
	    '\u1E20': 'G',
	    '\u011E': 'G',
	    '\u0120': 'G',
	    '\u01E6': 'G',
	    '\u0122': 'G',
	    '\u01E4': 'G',
	    '\u0193': 'G',
	    '\uA7A0': 'G',
	    '\uA77D': 'G',
	    '\uA77E': 'G',
	    '\u24BD': 'H',
	    '\uFF28': 'H',
	    '\u0124': 'H',
	    '\u1E22': 'H',
	    '\u1E26': 'H',
	    '\u021E': 'H',
	    '\u1E24': 'H',
	    '\u1E28': 'H',
	    '\u1E2A': 'H',
	    '\u0126': 'H',
	    '\u2C67': 'H',
	    '\u2C75': 'H',
	    '\uA78D': 'H',
	    '\u24BE': 'I',
	    '\uFF29': 'I',
	    '\u00CC': 'I',
	    '\u00CD': 'I',
	    '\u00CE': 'I',
	    '\u0128': 'I',
	    '\u012A': 'I',
	    '\u012C': 'I',
	    '\u0130': 'I',
	    '\u00CF': 'I',
	    '\u1E2E': 'I',
	    '\u1EC8': 'I',
	    '\u01CF': 'I',
	    '\u0208': 'I',
	    '\u020A': 'I',
	    '\u1ECA': 'I',
	    '\u012E': 'I',
	    '\u1E2C': 'I',
	    '\u0197': 'I',
	    '\u24BF': 'J',
	    '\uFF2A': 'J',
	    '\u0134': 'J',
	    '\u0248': 'J',
	    '\u24C0': 'K',
	    '\uFF2B': 'K',
	    '\u1E30': 'K',
	    '\u01E8': 'K',
	    '\u1E32': 'K',
	    '\u0136': 'K',
	    '\u1E34': 'K',
	    '\u0198': 'K',
	    '\u2C69': 'K',
	    '\uA740': 'K',
	    '\uA742': 'K',
	    '\uA744': 'K',
	    '\uA7A2': 'K',
	    '\u24C1': 'L',
	    '\uFF2C': 'L',
	    '\u013F': 'L',
	    '\u0139': 'L',
	    '\u013D': 'L',
	    '\u1E36': 'L',
	    '\u1E38': 'L',
	    '\u013B': 'L',
	    '\u1E3C': 'L',
	    '\u1E3A': 'L',
	    '\u0141': 'L',
	    '\u023D': 'L',
	    '\u2C62': 'L',
	    '\u2C60': 'L',
	    '\uA748': 'L',
	    '\uA746': 'L',
	    '\uA780': 'L',
	    '\u01C7': 'LJ',
	    '\u01C8': 'Lj',
	    '\u24C2': 'M',
	    '\uFF2D': 'M',
	    '\u1E3E': 'M',
	    '\u1E40': 'M',
	    '\u1E42': 'M',
	    '\u2C6E': 'M',
	    '\u019C': 'M',
	    '\u24C3': 'N',
	    '\uFF2E': 'N',
	    '\u01F8': 'N',
	    '\u0143': 'N',
	    '\u00D1': 'N',
	    '\u1E44': 'N',
	    '\u0147': 'N',
	    '\u1E46': 'N',
	    '\u0145': 'N',
	    '\u1E4A': 'N',
	    '\u1E48': 'N',
	    '\u0220': 'N',
	    '\u019D': 'N',
	    '\uA790': 'N',
	    '\uA7A4': 'N',
	    '\u01CA': 'NJ',
	    '\u01CB': 'Nj',
	    '\u24C4': 'O',
	    '\uFF2F': 'O',
	    '\u00D2': 'O',
	    '\u00D3': 'O',
	    '\u00D4': 'O',
	    '\u1ED2': 'O',
	    '\u1ED0': 'O',
	    '\u1ED6': 'O',
	    '\u1ED4': 'O',
	    '\u00D5': 'O',
	    '\u1E4C': 'O',
	    '\u022C': 'O',
	    '\u1E4E': 'O',
	    '\u014C': 'O',
	    '\u1E50': 'O',
	    '\u1E52': 'O',
	    '\u014E': 'O',
	    '\u022E': 'O',
	    '\u0230': 'O',
	    '\u00D6': 'O',
	    '\u022A': 'O',
	    '\u1ECE': 'O',
	    '\u0150': 'O',
	    '\u01D1': 'O',
	    '\u020C': 'O',
	    '\u020E': 'O',
	    '\u01A0': 'O',
	    '\u1EDC': 'O',
	    '\u1EDA': 'O',
	    '\u1EE0': 'O',
	    '\u1EDE': 'O',
	    '\u1EE2': 'O',
	    '\u1ECC': 'O',
	    '\u1ED8': 'O',
	    '\u01EA': 'O',
	    '\u01EC': 'O',
	    '\u00D8': 'O',
	    '\u01FE': 'O',
	    '\u0186': 'O',
	    '\u019F': 'O',
	    '\uA74A': 'O',
	    '\uA74C': 'O',
	    '\u0152': 'OE',
	    '\u01A2': 'OI',
	    '\uA74E': 'OO',
	    '\u0222': 'OU',
	    '\u24C5': 'P',
	    '\uFF30': 'P',
	    '\u1E54': 'P',
	    '\u1E56': 'P',
	    '\u01A4': 'P',
	    '\u2C63': 'P',
	    '\uA750': 'P',
	    '\uA752': 'P',
	    '\uA754': 'P',
	    '\u24C6': 'Q',
	    '\uFF31': 'Q',
	    '\uA756': 'Q',
	    '\uA758': 'Q',
	    '\u024A': 'Q',
	    '\u24C7': 'R',
	    '\uFF32': 'R',
	    '\u0154': 'R',
	    '\u1E58': 'R',
	    '\u0158': 'R',
	    '\u0210': 'R',
	    '\u0212': 'R',
	    '\u1E5A': 'R',
	    '\u1E5C': 'R',
	    '\u0156': 'R',
	    '\u1E5E': 'R',
	    '\u024C': 'R',
	    '\u2C64': 'R',
	    '\uA75A': 'R',
	    '\uA7A6': 'R',
	    '\uA782': 'R',
	    '\u24C8': 'S',
	    '\uFF33': 'S',
	    '\u1E9E': 'S',
	    '\u015A': 'S',
	    '\u1E64': 'S',
	    '\u015C': 'S',
	    '\u1E60': 'S',
	    '\u0160': 'S',
	    '\u1E66': 'S',
	    '\u1E62': 'S',
	    '\u1E68': 'S',
	    '\u0218': 'S',
	    '\u015E': 'S',
	    '\u2C7E': 'S',
	    '\uA7A8': 'S',
	    '\uA784': 'S',
	    '\u24C9': 'T',
	    '\uFF34': 'T',
	    '\u1E6A': 'T',
	    '\u0164': 'T',
	    '\u1E6C': 'T',
	    '\u021A': 'T',
	    '\u0162': 'T',
	    '\u1E70': 'T',
	    '\u1E6E': 'T',
	    '\u0166': 'T',
	    '\u01AC': 'T',
	    '\u01AE': 'T',
	    '\u023E': 'T',
	    '\uA786': 'T',
	    '\uA728': 'TZ',
	    '\u24CA': 'U',
	    '\uFF35': 'U',
	    '\u00D9': 'U',
	    '\u00DA': 'U',
	    '\u00DB': 'U',
	    '\u0168': 'U',
	    '\u1E78': 'U',
	    '\u016A': 'U',
	    '\u1E7A': 'U',
	    '\u016C': 'U',
	    '\u00DC': 'U',
	    '\u01DB': 'U',
	    '\u01D7': 'U',
	    '\u01D5': 'U',
	    '\u01D9': 'U',
	    '\u1EE6': 'U',
	    '\u016E': 'U',
	    '\u0170': 'U',
	    '\u01D3': 'U',
	    '\u0214': 'U',
	    '\u0216': 'U',
	    '\u01AF': 'U',
	    '\u1EEA': 'U',
	    '\u1EE8': 'U',
	    '\u1EEE': 'U',
	    '\u1EEC': 'U',
	    '\u1EF0': 'U',
	    '\u1EE4': 'U',
	    '\u1E72': 'U',
	    '\u0172': 'U',
	    '\u1E76': 'U',
	    '\u1E74': 'U',
	    '\u0244': 'U',
	    '\u24CB': 'V',
	    '\uFF36': 'V',
	    '\u1E7C': 'V',
	    '\u1E7E': 'V',
	    '\u01B2': 'V',
	    '\uA75E': 'V',
	    '\u0245': 'V',
	    '\uA760': 'VY',
	    '\u24CC': 'W',
	    '\uFF37': 'W',
	    '\u1E80': 'W',
	    '\u1E82': 'W',
	    '\u0174': 'W',
	    '\u1E86': 'W',
	    '\u1E84': 'W',
	    '\u1E88': 'W',
	    '\u2C72': 'W',
	    '\u24CD': 'X',
	    '\uFF38': 'X',
	    '\u1E8A': 'X',
	    '\u1E8C': 'X',
	    '\u24CE': 'Y',
	    '\uFF39': 'Y',
	    '\u1EF2': 'Y',
	    '\u00DD': 'Y',
	    '\u0176': 'Y',
	    '\u1EF8': 'Y',
	    '\u0232': 'Y',
	    '\u1E8E': 'Y',
	    '\u0178': 'Y',
	    '\u1EF6': 'Y',
	    '\u1EF4': 'Y',
	    '\u01B3': 'Y',
	    '\u024E': 'Y',
	    '\u1EFE': 'Y',
	    '\u24CF': 'Z',
	    '\uFF3A': 'Z',
	    '\u0179': 'Z',
	    '\u1E90': 'Z',
	    '\u017B': 'Z',
	    '\u017D': 'Z',
	    '\u1E92': 'Z',
	    '\u1E94': 'Z',
	    '\u01B5': 'Z',
	    '\u0224': 'Z',
	    '\u2C7F': 'Z',
	    '\u2C6B': 'Z',
	    '\uA762': 'Z',
	    '\u24D0': 'a',
	    '\uFF41': 'a',
	    '\u1E9A': 'a',
	    '\u00E0': 'a',
	    '\u00E1': 'a',
	    '\u00E2': 'a',
	    '\u1EA7': 'a',
	    '\u1EA5': 'a',
	    '\u1EAB': 'a',
	    '\u1EA9': 'a',
	    '\u00E3': 'a',
	    '\u0101': 'a',
	    '\u0103': 'a',
	    '\u1EB1': 'a',
	    '\u1EAF': 'a',
	    '\u1EB5': 'a',
	    '\u1EB3': 'a',
	    '\u0227': 'a',
	    '\u01E1': 'a',
	    '\u00E4': 'a',
	    '\u01DF': 'a',
	    '\u1EA3': 'a',
	    '\u00E5': 'a',
	    '\u01FB': 'a',
	    '\u01CE': 'a',
	    '\u0201': 'a',
	    '\u0203': 'a',
	    '\u1EA1': 'a',
	    '\u1EAD': 'a',
	    '\u1EB7': 'a',
	    '\u1E01': 'a',
	    '\u0105': 'a',
	    '\u2C65': 'a',
	    '\u0250': 'a',
	    '\uA733': 'aa',
	    '\u00E6': 'ae',
	    '\u01FD': 'ae',
	    '\u01E3': 'ae',
	    '\uA735': 'ao',
	    '\uA737': 'au',
	    '\uA739': 'av',
	    '\uA73B': 'av',
	    '\uA73D': 'ay',
	    '\u24D1': 'b',
	    '\uFF42': 'b',
	    '\u1E03': 'b',
	    '\u1E05': 'b',
	    '\u1E07': 'b',
	    '\u0180': 'b',
	    '\u0183': 'b',
	    '\u0253': 'b',
	    '\u24D2': 'c',
	    '\uFF43': 'c',
	    '\u0107': 'c',
	    '\u0109': 'c',
	    '\u010B': 'c',
	    '\u010D': 'c',
	    '\u00E7': 'c',
	    '\u1E09': 'c',
	    '\u0188': 'c',
	    '\u023C': 'c',
	    '\uA73F': 'c',
	    '\u2184': 'c',
	    '\u24D3': 'd',
	    '\uFF44': 'd',
	    '\u1E0B': 'd',
	    '\u010F': 'd',
	    '\u1E0D': 'd',
	    '\u1E11': 'd',
	    '\u1E13': 'd',
	    '\u1E0F': 'd',
	    '\u0111': 'd',
	    '\u018C': 'd',
	    '\u0256': 'd',
	    '\u0257': 'd',
	    '\uA77A': 'd',
	    '\u01F3': 'dz',
	    '\u01C6': 'dz',
	    '\u24D4': 'e',
	    '\uFF45': 'e',
	    '\u00E8': 'e',
	    '\u00E9': 'e',
	    '\u00EA': 'e',
	    '\u1EC1': 'e',
	    '\u1EBF': 'e',
	    '\u1EC5': 'e',
	    '\u1EC3': 'e',
	    '\u1EBD': 'e',
	    '\u0113': 'e',
	    '\u1E15': 'e',
	    '\u1E17': 'e',
	    '\u0115': 'e',
	    '\u0117': 'e',
	    '\u00EB': 'e',
	    '\u1EBB': 'e',
	    '\u011B': 'e',
	    '\u0205': 'e',
	    '\u0207': 'e',
	    '\u1EB9': 'e',
	    '\u1EC7': 'e',
	    '\u0229': 'e',
	    '\u1E1D': 'e',
	    '\u0119': 'e',
	    '\u1E19': 'e',
	    '\u1E1B': 'e',
	    '\u0247': 'e',
	    '\u025B': 'e',
	    '\u01DD': 'e',
	    '\u24D5': 'f',
	    '\uFF46': 'f',
	    '\u1E1F': 'f',
	    '\u0192': 'f',
	    '\uA77C': 'f',
	    '\u24D6': 'g',
	    '\uFF47': 'g',
	    '\u01F5': 'g',
	    '\u011D': 'g',
	    '\u1E21': 'g',
	    '\u011F': 'g',
	    '\u0121': 'g',
	    '\u01E7': 'g',
	    '\u0123': 'g',
	    '\u01E5': 'g',
	    '\u0260': 'g',
	    '\uA7A1': 'g',
	    '\u1D79': 'g',
	    '\uA77F': 'g',
	    '\u24D7': 'h',
	    '\uFF48': 'h',
	    '\u0125': 'h',
	    '\u1E23': 'h',
	    '\u1E27': 'h',
	    '\u021F': 'h',
	    '\u1E25': 'h',
	    '\u1E29': 'h',
	    '\u1E2B': 'h',
	    '\u1E96': 'h',
	    '\u0127': 'h',
	    '\u2C68': 'h',
	    '\u2C76': 'h',
	    '\u0265': 'h',
	    '\u0195': 'hv',
	    '\u24D8': 'i',
	    '\uFF49': 'i',
	    '\u00EC': 'i',
	    '\u00ED': 'i',
	    '\u00EE': 'i',
	    '\u0129': 'i',
	    '\u012B': 'i',
	    '\u012D': 'i',
	    '\u00EF': 'i',
	    '\u1E2F': 'i',
	    '\u1EC9': 'i',
	    '\u01D0': 'i',
	    '\u0209': 'i',
	    '\u020B': 'i',
	    '\u1ECB': 'i',
	    '\u012F': 'i',
	    '\u1E2D': 'i',
	    '\u0268': 'i',
	    '\u0131': 'i',
	    '\u24D9': 'j',
	    '\uFF4A': 'j',
	    '\u0135': 'j',
	    '\u01F0': 'j',
	    '\u0249': 'j',
	    '\u24DA': 'k',
	    '\uFF4B': 'k',
	    '\u1E31': 'k',
	    '\u01E9': 'k',
	    '\u1E33': 'k',
	    '\u0137': 'k',
	    '\u1E35': 'k',
	    '\u0199': 'k',
	    '\u2C6A': 'k',
	    '\uA741': 'k',
	    '\uA743': 'k',
	    '\uA745': 'k',
	    '\uA7A3': 'k',
	    '\u24DB': 'l',
	    '\uFF4C': 'l',
	    '\u0140': 'l',
	    '\u013A': 'l',
	    '\u013E': 'l',
	    '\u1E37': 'l',
	    '\u1E39': 'l',
	    '\u013C': 'l',
	    '\u1E3D': 'l',
	    '\u1E3B': 'l',
	    '\u017F': 'l',
	    '\u0142': 'l',
	    '\u019A': 'l',
	    '\u026B': 'l',
	    '\u2C61': 'l',
	    '\uA749': 'l',
	    '\uA781': 'l',
	    '\uA747': 'l',
	    '\u01C9': 'lj',
	    '\u24DC': 'm',
	    '\uFF4D': 'm',
	    '\u1E3F': 'm',
	    '\u1E41': 'm',
	    '\u1E43': 'm',
	    '\u0271': 'm',
	    '\u026F': 'm',
	    '\u24DD': 'n',
	    '\uFF4E': 'n',
	    '\u01F9': 'n',
	    '\u0144': 'n',
	    '\u00F1': 'n',
	    '\u1E45': 'n',
	    '\u0148': 'n',
	    '\u1E47': 'n',
	    '\u0146': 'n',
	    '\u1E4B': 'n',
	    '\u1E49': 'n',
	    '\u019E': 'n',
	    '\u0272': 'n',
	    '\u0149': 'n',
	    '\uA791': 'n',
	    '\uA7A5': 'n',
	    '\u01CC': 'nj',
	    '\u24DE': 'o',
	    '\uFF4F': 'o',
	    '\u00F2': 'o',
	    '\u00F3': 'o',
	    '\u00F4': 'o',
	    '\u1ED3': 'o',
	    '\u1ED1': 'o',
	    '\u1ED7': 'o',
	    '\u1ED5': 'o',
	    '\u00F5': 'o',
	    '\u1E4D': 'o',
	    '\u022D': 'o',
	    '\u1E4F': 'o',
	    '\u014D': 'o',
	    '\u1E51': 'o',
	    '\u1E53': 'o',
	    '\u014F': 'o',
	    '\u022F': 'o',
	    '\u0231': 'o',
	    '\u00F6': 'o',
	    '\u022B': 'o',
	    '\u1ECF': 'o',
	    '\u0151': 'o',
	    '\u01D2': 'o',
	    '\u020D': 'o',
	    '\u020F': 'o',
	    '\u01A1': 'o',
	    '\u1EDD': 'o',
	    '\u1EDB': 'o',
	    '\u1EE1': 'o',
	    '\u1EDF': 'o',
	    '\u1EE3': 'o',
	    '\u1ECD': 'o',
	    '\u1ED9': 'o',
	    '\u01EB': 'o',
	    '\u01ED': 'o',
	    '\u00F8': 'o',
	    '\u01FF': 'o',
	    '\u0254': 'o',
	    '\uA74B': 'o',
	    '\uA74D': 'o',
	    '\u0275': 'o',
	    '\u0153': 'oe',
	    '\u01A3': 'oi',
	    '\u0223': 'ou',
	    '\uA74F': 'oo',
	    '\u24DF': 'p',
	    '\uFF50': 'p',
	    '\u1E55': 'p',
	    '\u1E57': 'p',
	    '\u01A5': 'p',
	    '\u1D7D': 'p',
	    '\uA751': 'p',
	    '\uA753': 'p',
	    '\uA755': 'p',
	    '\u24E0': 'q',
	    '\uFF51': 'q',
	    '\u024B': 'q',
	    '\uA757': 'q',
	    '\uA759': 'q',
	    '\u24E1': 'r',
	    '\uFF52': 'r',
	    '\u0155': 'r',
	    '\u1E59': 'r',
	    '\u0159': 'r',
	    '\u0211': 'r',
	    '\u0213': 'r',
	    '\u1E5B': 'r',
	    '\u1E5D': 'r',
	    '\u0157': 'r',
	    '\u1E5F': 'r',
	    '\u024D': 'r',
	    '\u027D': 'r',
	    '\uA75B': 'r',
	    '\uA7A7': 'r',
	    '\uA783': 'r',
	    '\u24E2': 's',
	    '\uFF53': 's',
	    '\u00DF': 's',
	    '\u015B': 's',
	    '\u1E65': 's',
	    '\u015D': 's',
	    '\u1E61': 's',
	    '\u0161': 's',
	    '\u1E67': 's',
	    '\u1E63': 's',
	    '\u1E69': 's',
	    '\u0219': 's',
	    '\u015F': 's',
	    '\u023F': 's',
	    '\uA7A9': 's',
	    '\uA785': 's',
	    '\u1E9B': 's',
	    '\u24E3': 't',
	    '\uFF54': 't',
	    '\u1E6B': 't',
	    '\u1E97': 't',
	    '\u0165': 't',
	    '\u1E6D': 't',
	    '\u021B': 't',
	    '\u0163': 't',
	    '\u1E71': 't',
	    '\u1E6F': 't',
	    '\u0167': 't',
	    '\u01AD': 't',
	    '\u0288': 't',
	    '\u2C66': 't',
	    '\uA787': 't',
	    '\uA729': 'tz',
	    '\u24E4': 'u',
	    '\uFF55': 'u',
	    '\u00F9': 'u',
	    '\u00FA': 'u',
	    '\u00FB': 'u',
	    '\u0169': 'u',
	    '\u1E79': 'u',
	    '\u016B': 'u',
	    '\u1E7B': 'u',
	    '\u016D': 'u',
	    '\u00FC': 'u',
	    '\u01DC': 'u',
	    '\u01D8': 'u',
	    '\u01D6': 'u',
	    '\u01DA': 'u',
	    '\u1EE7': 'u',
	    '\u016F': 'u',
	    '\u0171': 'u',
	    '\u01D4': 'u',
	    '\u0215': 'u',
	    '\u0217': 'u',
	    '\u01B0': 'u',
	    '\u1EEB': 'u',
	    '\u1EE9': 'u',
	    '\u1EEF': 'u',
	    '\u1EED': 'u',
	    '\u1EF1': 'u',
	    '\u1EE5': 'u',
	    '\u1E73': 'u',
	    '\u0173': 'u',
	    '\u1E77': 'u',
	    '\u1E75': 'u',
	    '\u0289': 'u',
	    '\u24E5': 'v',
	    '\uFF56': 'v',
	    '\u1E7D': 'v',
	    '\u1E7F': 'v',
	    '\u028B': 'v',
	    '\uA75F': 'v',
	    '\u028C': 'v',
	    '\uA761': 'vy',
	    '\u24E6': 'w',
	    '\uFF57': 'w',
	    '\u1E81': 'w',
	    '\u1E83': 'w',
	    '\u0175': 'w',
	    '\u1E87': 'w',
	    '\u1E85': 'w',
	    '\u1E98': 'w',
	    '\u1E89': 'w',
	    '\u2C73': 'w',
	    '\u24E7': 'x',
	    '\uFF58': 'x',
	    '\u1E8B': 'x',
	    '\u1E8D': 'x',
	    '\u24E8': 'y',
	    '\uFF59': 'y',
	    '\u1EF3': 'y',
	    '\u00FD': 'y',
	    '\u0177': 'y',
	    '\u1EF9': 'y',
	    '\u0233': 'y',
	    '\u1E8F': 'y',
	    '\u00FF': 'y',
	    '\u1EF7': 'y',
	    '\u1E99': 'y',
	    '\u1EF5': 'y',
	    '\u01B4': 'y',
	    '\u024F': 'y',
	    '\u1EFF': 'y',
	    '\u24E9': 'z',
	    '\uFF5A': 'z',
	    '\u017A': 'z',
	    '\u1E91': 'z',
	    '\u017C': 'z',
	    '\u017E': 'z',
	    '\u1E93': 'z',
	    '\u1E95': 'z',
	    '\u01B6': 'z',
	    '\u0225': 'z',
	    '\u0240': 'z',
	    '\u2C6C': 'z',
	    '\uA763': 'z',
	    '\u0386': '\u0391',
	    '\u0388': '\u0395',
	    '\u0389': '\u0397',
	    '\u038A': '\u0399',
	    '\u03AA': '\u0399',
	    '\u038C': '\u039F',
	    '\u038E': '\u03A5',
	    '\u03AB': '\u03A5',
	    '\u038F': '\u03A9',
	    '\u03AC': '\u03B1',
	    '\u03AD': '\u03B5',
	    '\u03AE': '\u03B7',
	    '\u03AF': '\u03B9',
	    '\u03CA': '\u03B9',
	    '\u0390': '\u03B9',
	    '\u03CC': '\u03BF',
	    '\u03CD': '\u03C5',
	    '\u03CB': '\u03C5',
	    '\u03B0': '\u03C5',
	    '\u03CE': '\u03C9',
	    '\u03C2': '\u03C3',
	    '\u2019': '\''
	  };
	
	  return diacritics;
	});
	
	S2.define('select2/data/base',[
	  '../utils'
	], function (Utils) {
	  function BaseAdapter ($element, options) {
	    BaseAdapter.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(BaseAdapter, Utils.Observable);
	
	  BaseAdapter.prototype.current = function (callback) {
	    throw new Error('The `current` method must be defined in child classes.');
	  };
	
	  BaseAdapter.prototype.query = function (params, callback) {
	    throw new Error('The `query` method must be defined in child classes.');
	  };
	
	  BaseAdapter.prototype.bind = function (container, $container) {
	    // Can be implemented in subclasses
	  };
	
	  BaseAdapter.prototype.destroy = function () {
	    // Can be implemented in subclasses
	  };
	
	  BaseAdapter.prototype.generateResultId = function (container, data) {
	    var id = container.id + '-result-';
	
	    id += Utils.generateChars(4);
	
	    if (data.id != null) {
	      id += '-' + data.id.toString();
	    } else {
	      id += '-' + Utils.generateChars(4);
	    }
	    return id;
	  };
	
	  return BaseAdapter;
	});
	
	S2.define('select2/data/select',[
	  './base',
	  '../utils',
	  'jquery'
	], function (BaseAdapter, Utils, $) {
	  function SelectAdapter ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    SelectAdapter.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(SelectAdapter, BaseAdapter);
	
	  SelectAdapter.prototype.current = function (callback) {
	    var data = [];
	    var self = this;
	
	    this.$element.find(':selected').each(function () {
	      var $option = $(this);
	
	      var option = self.item($option);
	
	      data.push(option);
	    });
	
	    callback(data);
	  };
	
	  SelectAdapter.prototype.select = function (data) {
	    var self = this;
	
	    data.selected = true;
	
	    // If data.element is a DOM node, use it instead
	    if ($(data.element).is('option')) {
	      data.element.selected = true;
	
	      this.$element.trigger('input').trigger('change');
	
	      return;
	    }
	
	    if (this.$element.prop('multiple')) {
	      this.current(function (currentData) {
	        var val = [];
	
	        data = [data];
	        data.push.apply(data, currentData);
	
	        for (var d = 0; d < data.length; d++) {
	          var id = data[d].id;
	
	          if ($.inArray(id, val) === -1) {
	            val.push(id);
	          }
	        }
	
	        self.$element.val(val);
	        self.$element.trigger('input').trigger('change');
	      });
	    } else {
	      var val = data.id;
	
	      this.$element.val(val);
	      this.$element.trigger('input').trigger('change');
	    }
	  };
	
	  SelectAdapter.prototype.unselect = function (data) {
	    var self = this;
	
	    if (!this.$element.prop('multiple')) {
	      return;
	    }
	
	    data.selected = false;
	
	    if ($(data.element).is('option')) {
	      data.element.selected = false;
	
	      this.$element.trigger('input').trigger('change');
	
	      return;
	    }
	
	    this.current(function (currentData) {
	      var val = [];
	
	      for (var d = 0; d < currentData.length; d++) {
	        var id = currentData[d].id;
	
	        if (id !== data.id && $.inArray(id, val) === -1) {
	          val.push(id);
	        }
	      }
	
	      self.$element.val(val);
	
	      self.$element.trigger('input').trigger('change');
	    });
	  };
	
	  SelectAdapter.prototype.bind = function (container, $container) {
	    var self = this;
	
	    this.container = container;
	
	    container.on('select', function (params) {
	      self.select(params.data);
	    });
	
	    container.on('unselect', function (params) {
	      self.unselect(params.data);
	    });
	  };
	
	  SelectAdapter.prototype.destroy = function () {
	    // Remove anything added to child elements
	    this.$element.find('*').each(function () {
	      // Remove any custom data set by Select2
	      Utils.RemoveData(this);
	    });
	  };
	
	  SelectAdapter.prototype.query = function (params, callback) {
	    var data = [];
	    var self = this;
	
	    var $options = this.$element.children();
	
	    $options.each(function () {
	      var $option = $(this);
	
	      if (!$option.is('option') && !$option.is('optgroup')) {
	        return;
	      }
	
	      var option = self.item($option);
	
	      var matches = self.matches(params, option);
	
	      if (matches !== null) {
	        data.push(matches);
	      }
	    });
	
	    callback({
	      results: data
	    });
	  };
	
	  SelectAdapter.prototype.addOptions = function ($options) {
	    Utils.appendMany(this.$element, $options);
	  };
	
	  SelectAdapter.prototype.option = function (data) {
	    var option;
	
	    if (data.children) {
	      option = document.createElement('optgroup');
	      option.label = data.text;
	    } else {
	      option = document.createElement('option');
	
	      if (option.textContent !== undefined) {
	        option.textContent = data.text;
	      } else {
	        option.innerText = data.text;
	      }
	    }
	
	    if (data.id !== undefined) {
	      option.value = data.id;
	    }
	
	    if (data.disabled) {
	      option.disabled = true;
	    }
	
	    if (data.selected) {
	      option.selected = true;
	    }
	
	    if (data.title) {
	      option.title = data.title;
	    }
	
	    var $option = $(option);
	
	    var normalizedData = this._normalizeItem(data);
	    normalizedData.element = option;
	
	    // Override the option's data with the combined data
	    Utils.StoreData(option, 'data', normalizedData);
	
	    return $option;
	  };
	
	  SelectAdapter.prototype.item = function ($option) {
	    var data = {};
	
	    data = Utils.GetData($option[0], 'data');
	
	    if (data != null) {
	      return data;
	    }
	
	    if ($option.is('option')) {
	      data = {
	        id: $option.val(),
	        text: $option.text(),
	        disabled: $option.prop('disabled'),
	        selected: $option.prop('selected'),
	        title: $option.prop('title')
	      };
	    } else if ($option.is('optgroup')) {
	      data = {
	        text: $option.prop('label'),
	        children: [],
	        title: $option.prop('title')
	      };
	
	      var $children = $option.children('option');
	      var children = [];
	
	      for (var c = 0; c < $children.length; c++) {
	        var $child = $($children[c]);
	
	        var child = this.item($child);
	
	        children.push(child);
	      }
	
	      data.children = children;
	    }
	
	    data = this._normalizeItem(data);
	    data.element = $option[0];
	
	    Utils.StoreData($option[0], 'data', data);
	
	    return data;
	  };
	
	  SelectAdapter.prototype._normalizeItem = function (item) {
	    if (item !== Object(item)) {
	      item = {
	        id: item,
	        text: item
	      };
	    }
	
	    item = $.extend({}, {
	      text: ''
	    }, item);
	
	    var defaults = {
	      selected: false,
	      disabled: false
	    };
	
	    if (item.id != null) {
	      item.id = item.id.toString();
	    }
	
	    if (item.text != null) {
	      item.text = item.text.toString();
	    }
	
	    if (item._resultId == null && item.id && this.container != null) {
	      item._resultId = this.generateResultId(this.container, item);
	    }
	
	    return $.extend({}, defaults, item);
	  };
	
	  SelectAdapter.prototype.matches = function (params, data) {
	    var matcher = this.options.get('matcher');
	
	    return matcher(params, data);
	  };
	
	  return SelectAdapter;
	});
	
	S2.define('select2/data/array',[
	  './select',
	  '../utils',
	  'jquery'
	], function (SelectAdapter, Utils, $) {
	  function ArrayAdapter ($element, options) {
	    this._dataToConvert = options.get('data') || [];
	
	    ArrayAdapter.__super__.constructor.call(this, $element, options);
	  }
	
	  Utils.Extend(ArrayAdapter, SelectAdapter);
	
	  ArrayAdapter.prototype.bind = function (container, $container) {
	    ArrayAdapter.__super__.bind.call(this, container, $container);
	
	    this.addOptions(this.convertToOptions(this._dataToConvert));
	  };
	
	  ArrayAdapter.prototype.select = function (data) {
	    var $option = this.$element.find('option').filter(function (i, elm) {
	      return elm.value == data.id.toString();
	    });
	
	    if ($option.length === 0) {
	      $option = this.option(data);
	
	      this.addOptions($option);
	    }
	
	    ArrayAdapter.__super__.select.call(this, data);
	  };
	
	  ArrayAdapter.prototype.convertToOptions = function (data) {
	    var self = this;
	
	    var $existing = this.$element.find('option');
	    var existingIds = $existing.map(function () {
	      return self.item($(this)).id;
	    }).get();
	
	    var $options = [];
	
	    // Filter out all items except for the one passed in the argument
	    function onlyItem (item) {
	      return function () {
	        return $(this).val() == item.id;
	      };
	    }
	
	    for (var d = 0; d < data.length; d++) {
	      var item = this._normalizeItem(data[d]);
	
	      // Skip items which were pre-loaded, only merge the data
	      if ($.inArray(item.id, existingIds) >= 0) {
	        var $existingOption = $existing.filter(onlyItem(item));
	
	        var existingData = this.item($existingOption);
	        var newData = $.extend(true, {}, item, existingData);
	
	        var $newOption = this.option(newData);
	
	        $existingOption.replaceWith($newOption);
	
	        continue;
	      }
	
	      var $option = this.option(item);
	
	      if (item.children) {
	        var $children = this.convertToOptions(item.children);
	
	        Utils.appendMany($option, $children);
	      }
	
	      $options.push($option);
	    }
	
	    return $options;
	  };
	
	  return ArrayAdapter;
	});
	
	S2.define('select2/data/ajax',[
	  './array',
	  '../utils',
	  'jquery'
	], function (ArrayAdapter, Utils, $) {
	  function AjaxAdapter ($element, options) {
	    this.ajaxOptions = this._applyDefaults(options.get('ajax'));
	
	    if (this.ajaxOptions.processResults != null) {
	      this.processResults = this.ajaxOptions.processResults;
	    }
	
	    AjaxAdapter.__super__.constructor.call(this, $element, options);
	  }
	
	  Utils.Extend(AjaxAdapter, ArrayAdapter);
	
	  AjaxAdapter.prototype._applyDefaults = function (options) {
	    var defaults = {
	      data: function (params) {
	        return $.extend({}, params, {
	          q: params.term
	        });
	      },
	      transport: function (params, success, failure) {
	        var $request = $.ajax(params);
	
	        $request.then(success);
	        $request.fail(failure);
	
	        return $request;
	      }
	    };
	
	    return $.extend({}, defaults, options, true);
	  };
	
	  AjaxAdapter.prototype.processResults = function (results) {
	    return results;
	  };
	
	  AjaxAdapter.prototype.query = function (params, callback) {
	    var matches = [];
	    var self = this;
	
	    if (this._request != null) {
	      // JSONP requests cannot always be aborted
	      if ($.isFunction(this._request.abort)) {
	        this._request.abort();
	      }
	
	      this._request = null;
	    }
	
	    var options = $.extend({
	      type: 'GET'
	    }, this.ajaxOptions);
	
	    if (typeof options.url === 'function') {
	      options.url = options.url.call(this.$element, params);
	    }
	
	    if (typeof options.data === 'function') {
	      options.data = options.data.call(this.$element, params);
	    }
	
	    function request () {
	      var $request = options.transport(options, function (data) {
	        var results = self.processResults(data, params);
	
	        if (self.options.get('debug') && window.console && console.error) {
	          // Check to make sure that the response included a `results` key.
	          if (!results || !results.results || !$.isArray(results.results)) {
	            console.error(
	              'Select2: The AJAX results did not return an array in the ' +
	              '`results` key of the response.'
	            );
	          }
	        }
	
	        callback(results);
	      }, function () {
	        // Attempt to detect if a request was aborted
	        // Only works if the transport exposes a status property
	        if ('status' in $request &&
	            ($request.status === 0 || $request.status === '0')) {
	          return;
	        }
	
	        self.trigger('results:message', {
	          message: 'errorLoading'
	        });
	      });
	
	      self._request = $request;
	    }
	
	    if (this.ajaxOptions.delay && params.term != null) {
	      if (this._queryTimeout) {
	        window.clearTimeout(this._queryTimeout);
	      }
	
	      this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
	    } else {
	      request();
	    }
	  };
	
	  return AjaxAdapter;
	});
	
	S2.define('select2/data/tags',[
	  'jquery'
	], function ($) {
	  function Tags (decorated, $element, options) {
	    var tags = options.get('tags');
	
	    var createTag = options.get('createTag');
	
	    if (createTag !== undefined) {
	      this.createTag = createTag;
	    }
	
	    var insertTag = options.get('insertTag');
	
	    if (insertTag !== undefined) {
	        this.insertTag = insertTag;
	    }
	
	    decorated.call(this, $element, options);
	
	    if ($.isArray(tags)) {
	      for (var t = 0; t < tags.length; t++) {
	        var tag = tags[t];
	        var item = this._normalizeItem(tag);
	
	        var $option = this.option(item);
	
	        this.$element.append($option);
	      }
	    }
	  }
	
	  Tags.prototype.query = function (decorated, params, callback) {
	    var self = this;
	
	    this._removeOldTags();
	
	    if (params.term == null || params.page != null) {
	      decorated.call(this, params, callback);
	      return;
	    }
	
	    function wrapper (obj, child) {
	      var data = obj.results;
	
	      for (var i = 0; i < data.length; i++) {
	        var option = data[i];
	
	        var checkChildren = (
	          option.children != null &&
	          !wrapper({
	            results: option.children
	          }, true)
	        );
	
	        var optionText = (option.text || '').toUpperCase();
	        var paramsTerm = (params.term || '').toUpperCase();
	
	        var checkText = optionText === paramsTerm;
	
	        if (checkText || checkChildren) {
	          if (child) {
	            return false;
	          }
	
	          obj.data = data;
	          callback(obj);
	
	          return;
	        }
	      }
	
	      if (child) {
	        return true;
	      }
	
	      var tag = self.createTag(params);
	
	      if (tag != null) {
	        var $option = self.option(tag);
	        $option.attr('data-select2-tag', true);
	
	        self.addOptions([$option]);
	
	        self.insertTag(data, tag);
	      }
	
	      obj.results = data;
	
	      callback(obj);
	    }
	
	    decorated.call(this, params, wrapper);
	  };
	
	  Tags.prototype.createTag = function (decorated, params) {
	    var term = $.trim(params.term);
	
	    if (term === '') {
	      return null;
	    }
	
	    return {
	      id: term,
	      text: term
	    };
	  };
	
	  Tags.prototype.insertTag = function (_, data, tag) {
	    data.unshift(tag);
	  };
	
	  Tags.prototype._removeOldTags = function (_) {
	    var $options = this.$element.find('option[data-select2-tag]');
	
	    $options.each(function () {
	      if (this.selected) {
	        return;
	      }
	
	      $(this).remove();
	    });
	  };
	
	  return Tags;
	});
	
	S2.define('select2/data/tokenizer',[
	  'jquery'
	], function ($) {
	  function Tokenizer (decorated, $element, options) {
	    var tokenizer = options.get('tokenizer');
	
	    if (tokenizer !== undefined) {
	      this.tokenizer = tokenizer;
	    }
	
	    decorated.call(this, $element, options);
	  }
	
	  Tokenizer.prototype.bind = function (decorated, container, $container) {
	    decorated.call(this, container, $container);
	
	    this.$search =  container.dropdown.$search || container.selection.$search ||
	      $container.find('.select2-search__field');
	  };
	
	  Tokenizer.prototype.query = function (decorated, params, callback) {
	    var self = this;
	
	    function createAndSelect (data) {
	      // Normalize the data object so we can use it for checks
	      var item = self._normalizeItem(data);
	
	      // Check if the data object already exists as a tag
	      // Select it if it doesn't
	      var $existingOptions = self.$element.find('option').filter(function () {
	        return $(this).val() === item.id;
	      });
	
	      // If an existing option wasn't found for it, create the option
	      if (!$existingOptions.length) {
	        var $option = self.option(item);
	        $option.attr('data-select2-tag', true);
	
	        self._removeOldTags();
	        self.addOptions([$option]);
	      }
	
	      // Select the item, now that we know there is an option for it
	      select(item);
	    }
	
	    function select (data) {
	      self.trigger('select', {
	        data: data
	      });
	    }
	
	    params.term = params.term || '';
	
	    var tokenData = this.tokenizer(params, this.options, createAndSelect);
	
	    if (tokenData.term !== params.term) {
	      // Replace the search term if we have the search box
	      if (this.$search.length) {
	        this.$search.val(tokenData.term);
	        this.$search.trigger('focus');
	      }
	
	      params.term = tokenData.term;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  Tokenizer.prototype.tokenizer = function (_, params, options, callback) {
	    var separators = options.get('tokenSeparators') || [];
	    var term = params.term;
	    var i = 0;
	
	    var createTag = this.createTag || function (params) {
	      return {
	        id: params.term,
	        text: params.term
	      };
	    };
	
	    while (i < term.length) {
	      var termChar = term[i];
	
	      if ($.inArray(termChar, separators) === -1) {
	        i++;
	
	        continue;
	      }
	
	      var part = term.substr(0, i);
	      var partParams = $.extend({}, params, {
	        term: part
	      });
	
	      var data = createTag(partParams);
	
	      if (data == null) {
	        i++;
	        continue;
	      }
	
	      callback(data);
	
	      // Reset the term to not include the tokenized portion
	      term = term.substr(i + 1) || '';
	      i = 0;
	    }
	
	    return {
	      term: term
	    };
	  };
	
	  return Tokenizer;
	});
	
	S2.define('select2/data/minimumInputLength',[
	
	], function () {
	  function MinimumInputLength (decorated, $e, options) {
	    this.minimumInputLength = options.get('minimumInputLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MinimumInputLength.prototype.query = function (decorated, params, callback) {
	    params.term = params.term || '';
	
	    if (params.term.length < this.minimumInputLength) {
	      this.trigger('results:message', {
	        message: 'inputTooShort',
	        args: {
	          minimum: this.minimumInputLength,
	          input: params.term,
	          params: params
	        }
	      });
	
	      return;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  return MinimumInputLength;
	});
	
	S2.define('select2/data/maximumInputLength',[
	
	], function () {
	  function MaximumInputLength (decorated, $e, options) {
	    this.maximumInputLength = options.get('maximumInputLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MaximumInputLength.prototype.query = function (decorated, params, callback) {
	    params.term = params.term || '';
	
	    if (this.maximumInputLength > 0 &&
	        params.term.length > this.maximumInputLength) {
	      this.trigger('results:message', {
	        message: 'inputTooLong',
	        args: {
	          maximum: this.maximumInputLength,
	          input: params.term,
	          params: params
	        }
	      });
	
	      return;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  return MaximumInputLength;
	});
	
	S2.define('select2/data/maximumSelectionLength',[
	
	], function (){
	  function MaximumSelectionLength (decorated, $e, options) {
	    this.maximumSelectionLength = options.get('maximumSelectionLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MaximumSelectionLength.prototype.bind =
	    function (decorated, container, $container) {
	      var self = this;
	
	      decorated.call(this, container, $container);
	
	      container.on('select', function () {
	        self._checkIfMaximumSelected();
	      });
	  };
	
	  MaximumSelectionLength.prototype.query =
	    function (decorated, params, callback) {
	      var self = this;
	
	      this._checkIfMaximumSelected(function () {
	        decorated.call(self, params, callback);
	      });
	  };
	
	  MaximumSelectionLength.prototype._checkIfMaximumSelected =
	    function (_, successCallback) {
	      var self = this;
	
	      this.current(function (currentData) {
	        var count = currentData != null ? currentData.length : 0;
	        if (self.maximumSelectionLength > 0 &&
	          count >= self.maximumSelectionLength) {
	          self.trigger('results:message', {
	            message: 'maximumSelected',
	            args: {
	              maximum: self.maximumSelectionLength
	            }
	          });
	          return;
	        }
	
	        if (successCallback) {
	          successCallback();
	        }
	      });
	  };
	
	  return MaximumSelectionLength;
	});
	
	S2.define('select2/dropdown',[
	  'jquery',
	  './utils'
	], function ($, Utils) {
	  function Dropdown ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    Dropdown.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(Dropdown, Utils.Observable);
	
	  Dropdown.prototype.render = function () {
	    var $dropdown = $(
	      '<span class="select2-dropdown">' +
	        '<span class="select2-results"></span>' +
	      '</span>'
	    );
	
	    $dropdown.attr('dir', this.options.get('dir'));
	
	    this.$dropdown = $dropdown;
	
	    return $dropdown;
	  };
	
	  Dropdown.prototype.bind = function () {
	    // Should be implemented in subclasses
	  };
	
	  Dropdown.prototype.position = function ($dropdown, $container) {
	    // Should be implemented in subclasses
	  };
	
	  Dropdown.prototype.destroy = function () {
	    // Remove the dropdown from the DOM
	    this.$dropdown.remove();
	  };
	
	  return Dropdown;
	});
	
	S2.define('select2/dropdown/search',[
	  'jquery',
	  '../utils'
	], function ($, Utils) {
	  function Search () { }
	
	  Search.prototype.render = function (decorated) {
	    var $rendered = decorated.call(this);
	
	    var $search = $(
	      '<span class="select2-search select2-search--dropdown">' +
	        '<input class="select2-search__field" type="search" tabindex="-1"' +
	        ' autocomplete="off" autocorrect="off" autocapitalize="none"' +
	        ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' +
	      '</span>'
	    );
	
	    this.$searchContainer = $search;
	    this.$search = $search.find('input');
	
	    $rendered.prepend($search);
	
	    return $rendered;
	  };
	
	  Search.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    var resultsId = container.id + '-results';
	
	    decorated.call(this, container, $container);
	
	    this.$search.on('keydown', function (evt) {
	      self.trigger('keypress', evt);
	
	      self._keyUpPrevented = evt.isDefaultPrevented();
	    });
	
	    // Workaround for browsers which do not support the `input` event
	    // This will prevent double-triggering of events for browsers which support
	    // both the `keyup` and `input` events.
	    this.$search.on('input', function (evt) {
	      // Unbind the duplicated `keyup` event
	      $(this).off('keyup');
	    });
	
	    this.$search.on('keyup input', function (evt) {
	      self.handleSearch(evt);
	    });
	
	    container.on('open', function () {
	      self.$search.attr('tabindex', 0);
	      self.$search.attr('aria-controls', resultsId);
	
	      self.$search.trigger('focus');
	
	      window.setTimeout(function () {
	        self.$search.trigger('focus');
	      }, 0);
	    });
	
	    container.on('close', function () {
	      self.$search.attr('tabindex', -1);
	      self.$search.removeAttr('aria-controls');
	      self.$search.removeAttr('aria-activedescendant');
	
	      self.$search.val('');
	      self.$search.trigger('blur');
	    });
	
	    container.on('focus', function () {
	      if (!container.isOpen()) {
	        self.$search.trigger('focus');
	      }
	    });
	
	    container.on('results:all', function (params) {
	      if (params.query.term == null || params.query.term === '') {
	        var showSearch = self.showSearch(params);
	
	        if (showSearch) {
	          self.$searchContainer.removeClass('select2-search--hide');
	        } else {
	          self.$searchContainer.addClass('select2-search--hide');
	        }
	      }
	    });
	
	    container.on('results:focus', function (params) {
	      if (params.data._resultId) {
	        self.$search.attr('aria-activedescendant', params.data._resultId);
	      } else {
	        self.$search.removeAttr('aria-activedescendant');
	      }
	    });
	  };
	
	  Search.prototype.handleSearch = function (evt) {
	    if (!this._keyUpPrevented) {
	      var input = this.$search.val();
	
	      this.trigger('query', {
	        term: input
	      });
	    }
	
	    this._keyUpPrevented = false;
	  };
	
	  Search.prototype.showSearch = function (_, params) {
	    return true;
	  };
	
	  return Search;
	});
	
	S2.define('select2/dropdown/hidePlaceholder',[
	
	], function () {
	  function HidePlaceholder (decorated, $element, options, dataAdapter) {
	    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));
	
	    decorated.call(this, $element, options, dataAdapter);
	  }
	
	  HidePlaceholder.prototype.append = function (decorated, data) {
	    data.results = this.removePlaceholder(data.results);
	
	    decorated.call(this, data);
	  };
	
	  HidePlaceholder.prototype.normalizePlaceholder = function (_, placeholder) {
	    if (typeof placeholder === 'string') {
	      placeholder = {
	        id: '',
	        text: placeholder
	      };
	    }
	
	    return placeholder;
	  };
	
	  HidePlaceholder.prototype.removePlaceholder = function (_, data) {
	    var modifiedData = data.slice(0);
	
	    for (var d = data.length - 1; d >= 0; d--) {
	      var item = data[d];
	
	      if (this.placeholder.id === item.id) {
	        modifiedData.splice(d, 1);
	      }
	    }
	
	    return modifiedData;
	  };
	
	  return HidePlaceholder;
	});
	
	S2.define('select2/dropdown/infiniteScroll',[
	  'jquery'
	], function ($) {
	  function InfiniteScroll (decorated, $element, options, dataAdapter) {
	    this.lastParams = {};
	
	    decorated.call(this, $element, options, dataAdapter);
	
	    this.$loadingMore = this.createLoadingMore();
	    this.loading = false;
	  }
	
	  InfiniteScroll.prototype.append = function (decorated, data) {
	    this.$loadingMore.remove();
	    this.loading = false;
	
	    decorated.call(this, data);
	
	    if (this.showLoadingMore(data)) {
	      this.$results.append(this.$loadingMore);
	      this.loadMoreIfNeeded();
	    }
	  };
	
	  InfiniteScroll.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('query', function (params) {
	      self.lastParams = params;
	      self.loading = true;
	    });
	
	    container.on('query:append', function (params) {
	      self.lastParams = params;
	      self.loading = true;
	    });
	
	    this.$results.on('scroll', this.loadMoreIfNeeded.bind(this));
	  };
	
	  InfiniteScroll.prototype.loadMoreIfNeeded = function () {
	    var isLoadMoreVisible = $.contains(
	      document.documentElement,
	      this.$loadingMore[0]
	    );
	
	    if (this.loading || !isLoadMoreVisible) {
	      return;
	    }
	
	    var currentOffset = this.$results.offset().top +
	      this.$results.outerHeight(false);
	    var loadingMoreOffset = this.$loadingMore.offset().top +
	      this.$loadingMore.outerHeight(false);
	
	    if (currentOffset + 50 >= loadingMoreOffset) {
	      this.loadMore();
	    }
	  };
	
	  InfiniteScroll.prototype.loadMore = function () {
	    this.loading = true;
	
	    var params = $.extend({}, {page: 1}, this.lastParams);
	
	    params.page++;
	
	    this.trigger('query:append', params);
	  };
	
	  InfiniteScroll.prototype.showLoadingMore = function (_, data) {
	    return data.pagination && data.pagination.more;
	  };
	
	  InfiniteScroll.prototype.createLoadingMore = function () {
	    var $option = $(
	      '<li ' +
	      'class="select2-results__option select2-results__option--load-more"' +
	      'role="option" aria-disabled="true"></li>'
	    );
	
	    var message = this.options.get('translations').get('loadingMore');
	
	    $option.html(message(this.lastParams));
	
	    return $option;
	  };
	
	  return InfiniteScroll;
	});
	
	S2.define('select2/dropdown/attachBody',[
	  'jquery',
	  '../utils'
	], function ($, Utils) {
	  function AttachBody (decorated, $element, options) {
	    this.$dropdownParent = $(options.get('dropdownParent') || document.body);
	
	    decorated.call(this, $element, options);
	  }
	
	  AttachBody.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('open', function () {
	      self._showDropdown();
	      self._attachPositioningHandler(container);
	
	      // Must bind after the results handlers to ensure correct sizing
	      self._bindContainerResultHandlers(container);
	    });
	
	    container.on('close', function () {
	      self._hideDropdown();
	      self._detachPositioningHandler(container);
	    });
	
	    this.$dropdownContainer.on('mousedown', function (evt) {
	      evt.stopPropagation();
	    });
	  };
	
	  AttachBody.prototype.destroy = function (decorated) {
	    decorated.call(this);
	
	    this.$dropdownContainer.remove();
	  };
	
	  AttachBody.prototype.position = function (decorated, $dropdown, $container) {
	    // Clone all of the container classes
	    $dropdown.attr('class', $container.attr('class'));
	
	    $dropdown.removeClass('select2');
	    $dropdown.addClass('select2-container--open');
	
	    $dropdown.css({
	      position: 'absolute',
	      top: -999999
	    });
	
	    this.$container = $container;
	  };
	
	  AttachBody.prototype.render = function (decorated) {
	    var $container = $('<span></span>');
	
	    var $dropdown = decorated.call(this);
	    $container.append($dropdown);
	
	    this.$dropdownContainer = $container;
	
	    return $container;
	  };
	
	  AttachBody.prototype._hideDropdown = function (decorated) {
	    this.$dropdownContainer.detach();
	  };
	
	  AttachBody.prototype._bindContainerResultHandlers =
	      function (decorated, container) {
	
	    // These should only be bound once
	    if (this._containerResultsHandlersBound) {
	      return;
	    }
	
	    var self = this;
	
	    container.on('results:all', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    container.on('results:append', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    container.on('results:message', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    container.on('select', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    container.on('unselect', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    this._containerResultsHandlersBound = true;
	  };
	
	  AttachBody.prototype._attachPositioningHandler =
	      function (decorated, container) {
	    var self = this;
	
	    var scrollEvent = 'scroll.select2.' + container.id;
	    var resizeEvent = 'resize.select2.' + container.id;
	    var orientationEvent = 'orientationchange.select2.' + container.id;
	
	    var $watchers = this.$container.parents().filter(Utils.hasScroll);
	    $watchers.each(function () {
	      Utils.StoreData(this, 'select2-scroll-position', {
	        x: $(this).scrollLeft(),
	        y: $(this).scrollTop()
	      });
	    });
	
	    $watchers.on(scrollEvent, function (ev) {
	      var position = Utils.GetData(this, 'select2-scroll-position');
	      $(this).scrollTop(position.y);
	    });
	
	    $(window).on(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent,
	      function (e) {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	  };
	
	  AttachBody.prototype._detachPositioningHandler =
	      function (decorated, container) {
	    var scrollEvent = 'scroll.select2.' + container.id;
	    var resizeEvent = 'resize.select2.' + container.id;
	    var orientationEvent = 'orientationchange.select2.' + container.id;
	
	    var $watchers = this.$container.parents().filter(Utils.hasScroll);
	    $watchers.off(scrollEvent);
	
	    $(window).off(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent);
	  };
	
	  AttachBody.prototype._positionDropdown = function () {
	    var $window = $(window);
	
	    var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
	    var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');
	
	    var newDirection = null;
	
	    var offset = this.$container.offset();
	
	    offset.bottom = offset.top + this.$container.outerHeight(false);
	
	    var container = {
	      height: this.$container.outerHeight(false)
	    };
	
	    container.top = offset.top;
	    container.bottom = offset.top + container.height;
	
	    var dropdown = {
	      height: this.$dropdown.outerHeight(false)
	    };
	
	    var viewport = {
	      top: $window.scrollTop(),
	      bottom: $window.scrollTop() + $window.height()
	    };
	
	    var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
	    var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);
	
	    var css = {
	      left: offset.left,
	      top: container.bottom
	    };
	
	    // Determine what the parent element is to use for calculating the offset
	    var $offsetParent = this.$dropdownParent;
	
	    // For statically positioned elements, we need to get the element
	    // that is determining the offset
	    if ($offsetParent.css('position') === 'static') {
	      $offsetParent = $offsetParent.offsetParent();
	    }
	
	    var parentOffset = {
	      top: 0,
	      left: 0
	    };
	
	    if (
	      $.contains(document.body, $offsetParent[0]) ||
	      $offsetParent[0].isConnected
	      ) {
	      parentOffset = $offsetParent.offset();
	    }
	
	    css.top -= parentOffset.top;
	    css.left -= parentOffset.left;
	
	    if (!isCurrentlyAbove && !isCurrentlyBelow) {
	      newDirection = 'below';
	    }
	
	    if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
	      newDirection = 'above';
	    } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
	      newDirection = 'below';
	    }
	
	    if (newDirection == 'above' ||
	      (isCurrentlyAbove && newDirection !== 'below')) {
	      css.top = container.top - parentOffset.top - dropdown.height;
	    }
	
	    if (newDirection != null) {
	      this.$dropdown
	        .removeClass('select2-dropdown--below select2-dropdown--above')
	        .addClass('select2-dropdown--' + newDirection);
	      this.$container
	        .removeClass('select2-container--below select2-container--above')
	        .addClass('select2-container--' + newDirection);
	    }
	
	    this.$dropdownContainer.css(css);
	  };
	
	  AttachBody.prototype._resizeDropdown = function () {
	    var css = {
	      width: this.$container.outerWidth(false) + 'px'
	    };
	
	    if (this.options.get('dropdownAutoWidth')) {
	      css.minWidth = css.width;
	      css.position = 'relative';
	      css.width = 'auto';
	    }
	
	    this.$dropdown.css(css);
	  };
	
	  AttachBody.prototype._showDropdown = function (decorated) {
	    this.$dropdownContainer.appendTo(this.$dropdownParent);
	
	    this._positionDropdown();
	    this._resizeDropdown();
	  };
	
	  return AttachBody;
	});
	
	S2.define('select2/dropdown/minimumResultsForSearch',[
	
	], function () {
	  function countResults (data) {
	    var count = 0;
	
	    for (var d = 0; d < data.length; d++) {
	      var item = data[d];
	
	      if (item.children) {
	        count += countResults(item.children);
	      } else {
	        count++;
	      }
	    }
	
	    return count;
	  }
	
	  function MinimumResultsForSearch (decorated, $element, options, dataAdapter) {
	    this.minimumResultsForSearch = options.get('minimumResultsForSearch');
	
	    if (this.minimumResultsForSearch < 0) {
	      this.minimumResultsForSearch = Infinity;
	    }
	
	    decorated.call(this, $element, options, dataAdapter);
	  }
	
	  MinimumResultsForSearch.prototype.showSearch = function (decorated, params) {
	    if (countResults(params.data.results) < this.minimumResultsForSearch) {
	      return false;
	    }
	
	    return decorated.call(this, params);
	  };
	
	  return MinimumResultsForSearch;
	});
	
	S2.define('select2/dropdown/selectOnClose',[
	  '../utils'
	], function (Utils) {
	  function SelectOnClose () { }
	
	  SelectOnClose.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('close', function (params) {
	      self._handleSelectOnClose(params);
	    });
	  };
	
	  SelectOnClose.prototype._handleSelectOnClose = function (_, params) {
	    if (params && params.originalSelect2Event != null) {
	      var event = params.originalSelect2Event;
	
	      // Don't select an item if the close event was triggered from a select or
	      // unselect event
	      if (event._type === 'select' || event._type === 'unselect') {
	        return;
	      }
	    }
	
	    var $highlightedResults = this.getHighlightedResults();
	
	    // Only select highlighted results
	    if ($highlightedResults.length < 1) {
	      return;
	    }
	
	    var data = Utils.GetData($highlightedResults[0], 'data');
	
	    // Don't re-select already selected resulte
	    if (
	      (data.element != null && data.element.selected) ||
	      (data.element == null && data.selected)
	    ) {
	      return;
	    }
	
	    this.trigger('select', {
	        data: data
	    });
	  };
	
	  return SelectOnClose;
	});
	
	S2.define('select2/dropdown/closeOnSelect',[
	
	], function () {
	  function CloseOnSelect () { }
	
	  CloseOnSelect.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('select', function (evt) {
	      self._selectTriggered(evt);
	    });
	
	    container.on('unselect', function (evt) {
	      self._selectTriggered(evt);
	    });
	  };
	
	  CloseOnSelect.prototype._selectTriggered = function (_, evt) {
	    var originalEvent = evt.originalEvent;
	
	    // Don't close if the control key is being held
	    if (originalEvent && (originalEvent.ctrlKey || originalEvent.metaKey)) {
	      return;
	    }
	
	    this.trigger('close', {
	      originalEvent: originalEvent,
	      originalSelect2Event: evt
	    });
	  };
	
	  return CloseOnSelect;
	});
	
	S2.define('select2/i18n/en',[],function () {
	  // English
	  return {
	    errorLoading: function () {
	      return 'The results could not be loaded.';
	    },
	    inputTooLong: function (args) {
	      var overChars = args.input.length - args.maximum;
	
	      var message = 'Please delete ' + overChars + ' character';
	
	      if (overChars != 1) {
	        message += 's';
	      }
	
	      return message;
	    },
	    inputTooShort: function (args) {
	      var remainingChars = args.minimum - args.input.length;
	
	      var message = 'Please enter ' + remainingChars + ' or more characters';
	
	      return message;
	    },
	    loadingMore: function () {
	      return 'Loading more results…';
	    },
	    maximumSelected: function (args) {
	      var message = 'You can only select ' + args.maximum + ' item';
	
	      if (args.maximum != 1) {
	        message += 's';
	      }
	
	      return message;
	    },
	    noResults: function () {
	      return 'No results found';
	    },
	    searching: function () {
	      return 'Searching…';
	    },
	    removeAllItems: function () {
	      return 'Remove all items';
	    }
	  };
	});
	
	S2.define('select2/defaults',[
	  'jquery',
	  'require',
	
	  './results',
	
	  './selection/single',
	  './selection/multiple',
	  './selection/placeholder',
	  './selection/allowClear',
	  './selection/search',
	  './selection/eventRelay',
	
	  './utils',
	  './translation',
	  './diacritics',
	
	  './data/select',
	  './data/array',
	  './data/ajax',
	  './data/tags',
	  './data/tokenizer',
	  './data/minimumInputLength',
	  './data/maximumInputLength',
	  './data/maximumSelectionLength',
	
	  './dropdown',
	  './dropdown/search',
	  './dropdown/hidePlaceholder',
	  './dropdown/infiniteScroll',
	  './dropdown/attachBody',
	  './dropdown/minimumResultsForSearch',
	  './dropdown/selectOnClose',
	  './dropdown/closeOnSelect',
	
	  './i18n/en'
	], function ($, require,
	
	             ResultsList,
	
	             SingleSelection, MultipleSelection, Placeholder, AllowClear,
	             SelectionSearch, EventRelay,
	
	             Utils, Translation, DIACRITICS,
	
	             SelectData, ArrayData, AjaxData, Tags, Tokenizer,
	             MinimumInputLength, MaximumInputLength, MaximumSelectionLength,
	
	             Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll,
	             AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect,
	
	             EnglishTranslation) {
	  function Defaults () {
	    this.reset();
	  }
	
	  Defaults.prototype.apply = function (options) {
	    options = $.extend(true, {}, this.defaults, options);
	
	    if (options.dataAdapter == null) {
	      if (options.ajax != null) {
	        options.dataAdapter = AjaxData;
	      } else if (options.data != null) {
	        options.dataAdapter = ArrayData;
	      } else {
	        options.dataAdapter = SelectData;
	      }
	
	      if (options.minimumInputLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MinimumInputLength
	        );
	      }
	
	      if (options.maximumInputLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MaximumInputLength
	        );
	      }
	
	      if (options.maximumSelectionLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MaximumSelectionLength
	        );
	      }
	
	      if (options.tags) {
	        options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
	      }
	
	      if (options.tokenSeparators != null || options.tokenizer != null) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          Tokenizer
	        );
	      }
	
	      if (options.query != null) {
	        var Query = require(options.amdBase + 'compat/query');
	
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          Query
	        );
	      }
	
	      if (options.initSelection != null) {
	        var InitSelection = require(options.amdBase + 'compat/initSelection');
	
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          InitSelection
	        );
	      }
	    }
	
	    if (options.resultsAdapter == null) {
	      options.resultsAdapter = ResultsList;
	
	      if (options.ajax != null) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          InfiniteScroll
	        );
	      }
	
	      if (options.placeholder != null) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          HidePlaceholder
	        );
	      }
	
	      if (options.selectOnClose) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          SelectOnClose
	        );
	      }
	    }
	
	    if (options.dropdownAdapter == null) {
	      if (options.multiple) {
	        options.dropdownAdapter = Dropdown;
	      } else {
	        var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);
	
	        options.dropdownAdapter = SearchableDropdown;
	      }
	
	      if (options.minimumResultsForSearch !== 0) {
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          MinimumResultsForSearch
	        );
	      }
	
	      if (options.closeOnSelect) {
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          CloseOnSelect
	        );
	      }
	
	      if (
	        options.dropdownCssClass != null ||
	        options.dropdownCss != null ||
	        options.adaptDropdownCssClass != null
	      ) {
	        var DropdownCSS = require(options.amdBase + 'compat/dropdownCss');
	
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          DropdownCSS
	        );
	      }
	
	      options.dropdownAdapter = Utils.Decorate(
	        options.dropdownAdapter,
	        AttachBody
	      );
	    }
	
	    if (options.selectionAdapter == null) {
	      if (options.multiple) {
	        options.selectionAdapter = MultipleSelection;
	      } else {
	        options.selectionAdapter = SingleSelection;
	      }
	
	      // Add the placeholder mixin if a placeholder was specified
	      if (options.placeholder != null) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          Placeholder
	        );
	      }
	
	      if (options.allowClear) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          AllowClear
	        );
	      }
	
	      if (options.multiple) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          SelectionSearch
	        );
	      }
	
	      if (
	        options.containerCssClass != null ||
	        options.containerCss != null ||
	        options.adaptContainerCssClass != null
	      ) {
	        var ContainerCSS = require(options.amdBase + 'compat/containerCss');
	
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          ContainerCSS
	        );
	      }
	
	      options.selectionAdapter = Utils.Decorate(
	        options.selectionAdapter,
	        EventRelay
	      );
	    }
	
	    // If the defaults were not previously applied from an element, it is
	    // possible for the language option to have not been resolved
	    options.language = this._resolveLanguage(options.language);
	
	    // Always fall back to English since it will always be complete
	    options.language.push('en');
	
	    var uniqueLanguages = [];
	
	    for (var l = 0; l < options.language.length; l++) {
	      var language = options.language[l];
	
	      if (uniqueLanguages.indexOf(language) === -1) {
	        uniqueLanguages.push(language);
	      }
	    }
	
	    options.language = uniqueLanguages;
	
	    options.translations = this._processTranslations(
	      options.language,
	      options.debug
	    );
	
	    return options;
	  };
	
	  Defaults.prototype.reset = function () {
	    function stripDiacritics (text) {
	      // Used 'uni range + named function' from http://jsperf.com/diacritics/18
	      function match(a) {
	        return DIACRITICS[a] || a;
	      }
	
	      return text.replace(/[^\u0000-\u007E]/g, match);
	    }
	
	    function matcher (params, data) {
	      // Always return the object if there is nothing to compare
	      if ($.trim(params.term) === '') {
	        return data;
	      }
	
	      // Do a recursive check for options with children
	      if (data.children && data.children.length > 0) {
	        // Clone the data object if there are children
	        // This is required as we modify the object to remove any non-matches
	        var match = $.extend(true, {}, data);
	
	        // Check each child of the option
	        for (var c = data.children.length - 1; c >= 0; c--) {
	          var child = data.children[c];
	
	          var matches = matcher(params, child);
	
	          // If there wasn't a match, remove the object in the array
	          if (matches == null) {
	            match.children.splice(c, 1);
	          }
	        }
	
	        // If any children matched, return the new object
	        if (match.children.length > 0) {
	          return match;
	        }
	
	        // If there were no matching children, check just the plain object
	        return matcher(params, match);
	      }
	
	      var original = stripDiacritics(data.text).toUpperCase();
	      var term = stripDiacritics(params.term).toUpperCase();
	
	      // Check if the text contains the term
	      if (original.indexOf(term) > -1) {
	        return data;
	      }
	
	      // If it doesn't contain the term, don't return anything
	      return null;
	    }
	
	    this.defaults = {
	      amdBase: './',
	      amdLanguageBase: './i18n/',
	      closeOnSelect: true,
	      debug: false,
	      dropdownAutoWidth: false,
	      escapeMarkup: Utils.escapeMarkup,
	      language: {},
	      matcher: matcher,
	      minimumInputLength: 0,
	      maximumInputLength: 0,
	      maximumSelectionLength: 0,
	      minimumResultsForSearch: 0,
	      selectOnClose: false,
	      scrollAfterSelect: false,
	      sorter: function (data) {
	        return data;
	      },
	      templateResult: function (result) {
	        return result.text;
	      },
	      templateSelection: function (selection) {
	        return selection.text;
	      },
	      theme: 'default',
	      width: 'resolve'
	    };
	  };
	
	  Defaults.prototype.applyFromElement = function (options, $element) {
	    var optionLanguage = options.language;
	    var defaultLanguage = this.defaults.language;
	    var elementLanguage = $element.prop('lang');
	    var parentLanguage = $element.closest('[lang]').prop('lang');
	
	    var languages = Array.prototype.concat.call(
	      this._resolveLanguage(elementLanguage),
	      this._resolveLanguage(optionLanguage),
	      this._resolveLanguage(defaultLanguage),
	      this._resolveLanguage(parentLanguage)
	    );
	
	    options.language = languages;
	
	    return options;
	  };
	
	  Defaults.prototype._resolveLanguage = function (language) {
	    if (!language) {
	      return [];
	    }
	
	    if ($.isEmptyObject(language)) {
	      return [];
	    }
	
	    if ($.isPlainObject(language)) {
	      return [language];
	    }
	
	    var languages;
	
	    if (!$.isArray(language)) {
	      languages = [language];
	    } else {
	      languages = language;
	    }
	
	    var resolvedLanguages = [];
	
	    for (var l = 0; l < languages.length; l++) {
	      resolvedLanguages.push(languages[l]);
	
	      if (typeof languages[l] === 'string' && languages[l].indexOf('-') > 0) {
	        // Extract the region information if it is included
	        var languageParts = languages[l].split('-');
	        var baseLanguage = languageParts[0];
	
	        resolvedLanguages.push(baseLanguage);
	      }
	    }
	
	    return resolvedLanguages;
	  };
	
	  Defaults.prototype._processTranslations = function (languages, debug) {
	    var translations = new Translation();
	
	    for (var l = 0; l < languages.length; l++) {
	      var languageData = new Translation();
	
	      var language = languages[l];
	
	      if (typeof language === 'string') {
	        try {
	          // Try to load it with the original name
	          languageData = Translation.loadPath(language);
	        } catch (e) {
	          try {
	            // If we couldn't load it, check if it wasn't the full path
	            language = this.defaults.amdLanguageBase + language;
	            languageData = Translation.loadPath(language);
	          } catch (ex) {
	            // The translation could not be loaded at all. Sometimes this is
	            // because of a configuration problem, other times this can be
	            // because of how Select2 helps load all possible translation files
	            if (debug && window.console && console.warn) {
	              console.warn(
	                'Select2: The language file for "' + language + '" could ' +
	                'not be automatically loaded. A fallback will be used instead.'
	              );
	            }
	          }
	        }
	      } else if ($.isPlainObject(language)) {
	        languageData = new Translation(language);
	      } else {
	        languageData = language;
	      }
	
	      translations.extend(languageData);
	    }
	
	    return translations;
	  };
	
	  Defaults.prototype.set = function (key, value) {
	    var camelKey = $.camelCase(key);
	
	    var data = {};
	    data[camelKey] = value;
	
	    var convertedData = Utils._convertData(data);
	
	    $.extend(true, this.defaults, convertedData);
	  };
	
	  var defaults = new Defaults();
	
	  return defaults;
	});
	
	S2.define('select2/options',[
	  'require',
	  'jquery',
	  './defaults',
	  './utils'
	], function (require, $, Defaults, Utils) {
	  function Options (options, $element) {
	    this.options = options;
	
	    if ($element != null) {
	      this.fromElement($element);
	    }
	
	    if ($element != null) {
	      this.options = Defaults.applyFromElement(this.options, $element);
	    }
	
	    this.options = Defaults.apply(this.options);
	
	    if ($element && $element.is('input')) {
	      var InputCompat = require(this.get('amdBase') + 'compat/inputData');
	
	      this.options.dataAdapter = Utils.Decorate(
	        this.options.dataAdapter,
	        InputCompat
	      );
	    }
	  }
	
	  Options.prototype.fromElement = function ($e) {
	    var excludedData = ['select2'];
	
	    if (this.options.multiple == null) {
	      this.options.multiple = $e.prop('multiple');
	    }
	
	    if (this.options.disabled == null) {
	      this.options.disabled = $e.prop('disabled');
	    }
	
	    if (this.options.dir == null) {
	      if ($e.prop('dir')) {
	        this.options.dir = $e.prop('dir');
	      } else if ($e.closest('[dir]').prop('dir')) {
	        this.options.dir = $e.closest('[dir]').prop('dir');
	      } else {
	        this.options.dir = 'ltr';
	      }
	    }
	
	    $e.prop('disabled', this.options.disabled);
	    $e.prop('multiple', this.options.multiple);
	
	    if (Utils.GetData($e[0], 'select2Tags')) {
	      if (this.options.debug && window.console && console.warn) {
	        console.warn(
	          'Select2: The `data-select2-tags` attribute has been changed to ' +
	          'use the `data-data` and `data-tags="true"` attributes and will be ' +
	          'removed in future versions of Select2.'
	        );
	      }
	
	      Utils.StoreData($e[0], 'data', Utils.GetData($e[0], 'select2Tags'));
	      Utils.StoreData($e[0], 'tags', true);
	    }
	
	    if (Utils.GetData($e[0], 'ajaxUrl')) {
	      if (this.options.debug && window.console && console.warn) {
	        console.warn(
	          'Select2: The `data-ajax-url` attribute has been changed to ' +
	          '`data-ajax--url` and support for the old attribute will be removed' +
	          ' in future versions of Select2.'
	        );
	      }
	
	      $e.attr('ajax--url', Utils.GetData($e[0], 'ajaxUrl'));
	      Utils.StoreData($e[0], 'ajax-Url', Utils.GetData($e[0], 'ajaxUrl'));
	    }
	
	    var dataset = {};
	
	    function upperCaseLetter(_, letter) {
	      return letter.toUpperCase();
	    }
	
	    // Pre-load all of the attributes which are prefixed with `data-`
	    for (var attr = 0; attr < $e[0].attributes.length; attr++) {
	      var attributeName = $e[0].attributes[attr].name;
	      var prefix = 'data-';
	
	      if (attributeName.substr(0, prefix.length) == prefix) {
	        // Get the contents of the attribute after `data-`
	        var dataName = attributeName.substring(prefix.length);
	
	        // Get the data contents from the consistent source
	        // This is more than likely the jQuery data helper
	        var dataValue = Utils.GetData($e[0], dataName);
	
	        // camelCase the attribute name to match the spec
	        var camelDataName = dataName.replace(/-([a-z])/g, upperCaseLetter);
	
	        // Store the data attribute contents into the dataset since
	        dataset[camelDataName] = dataValue;
	      }
	    }
	
	    // Prefer the element's `dataset` attribute if it exists
	    // jQuery 1.x does not correctly handle data attributes with multiple dashes
	    if ($.fn.jquery && $.fn.jquery.substr(0, 2) == '1.' && $e[0].dataset) {
	      dataset = $.extend(true, {}, $e[0].dataset, dataset);
	    }
	
	    // Prefer our internal data cache if it exists
	    var data = $.extend(true, {}, Utils.GetData($e[0]), dataset);
	
	    data = Utils._convertData(data);
	
	    for (var key in data) {
	      if ($.inArray(key, excludedData) > -1) {
	        continue;
	      }
	
	      if ($.isPlainObject(this.options[key])) {
	        $.extend(this.options[key], data[key]);
	      } else {
	        this.options[key] = data[key];
	      }
	    }
	
	    return this;
	  };
	
	  Options.prototype.get = function (key) {
	    return this.options[key];
	  };
	
	  Options.prototype.set = function (key, val) {
	    this.options[key] = val;
	  };
	
	  return Options;
	});
	
	S2.define('select2/core',[
	  'jquery',
	  './options',
	  './utils',
	  './keys'
	], function ($, Options, Utils, KEYS) {
	  var Select2 = function ($element, options) {
	    if (Utils.GetData($element[0], 'select2') != null) {
	      Utils.GetData($element[0], 'select2').destroy();
	    }
	
	    this.$element = $element;
	
	    this.id = this._generateId($element);
	
	    options = options || {};
	
	    this.options = new Options(options, $element);
	
	    Select2.__super__.constructor.call(this);
	
	    // Set up the tabindex
	
	    var tabindex = $element.attr('tabindex') || 0;
	    Utils.StoreData($element[0], 'old-tabindex', tabindex);
	    $element.attr('tabindex', '-1');
	
	    // Set up containers and adapters
	
	    var DataAdapter = this.options.get('dataAdapter');
	    this.dataAdapter = new DataAdapter($element, this.options);
	
	    var $container = this.render();
	
	    this._placeContainer($container);
	
	    var SelectionAdapter = this.options.get('selectionAdapter');
	    this.selection = new SelectionAdapter($element, this.options);
	    this.$selection = this.selection.render();
	
	    this.selection.position(this.$selection, $container);
	
	    var DropdownAdapter = this.options.get('dropdownAdapter');
	    this.dropdown = new DropdownAdapter($element, this.options);
	    this.$dropdown = this.dropdown.render();
	
	    this.dropdown.position(this.$dropdown, $container);
	
	    var ResultsAdapter = this.options.get('resultsAdapter');
	    this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
	    this.$results = this.results.render();
	
	    this.results.position(this.$results, this.$dropdown);
	
	    // Bind events
	
	    var self = this;
	
	    // Bind the container to all of the adapters
	    this._bindAdapters();
	
	    // Register any DOM event handlers
	    this._registerDomEvents();
	
	    // Register any internal event handlers
	    this._registerDataEvents();
	    this._registerSelectionEvents();
	    this._registerDropdownEvents();
	    this._registerResultsEvents();
	    this._registerEvents();
	
	    // Set the initial state
	    this.dataAdapter.current(function (initialData) {
	      self.trigger('selection:update', {
	        data: initialData
	      });
	    });
	
	    // Hide the original select
	    $element.addClass('select2-hidden-accessible');
	    $element.attr('aria-hidden', 'true');
	
	    // Synchronize any monitored attributes
	    this._syncAttributes();
	
	    Utils.StoreData($element[0], 'select2', this);
	
	    // Ensure backwards compatibility with $element.data('select2').
	    $element.data('select2', this);
	  };
	
	  Utils.Extend(Select2, Utils.Observable);
	
	  Select2.prototype._generateId = function ($element) {
	    var id = '';
	
	    if ($element.attr('id') != null) {
	      id = $element.attr('id');
	    } else if ($element.attr('name') != null) {
	      id = $element.attr('name') + '-' + Utils.generateChars(2);
	    } else {
	      id = Utils.generateChars(4);
	    }
	
	    id = id.replace(/(:|\.|\[|\]|,)/g, '');
	    id = 'select2-' + id;
	
	    return id;
	  };
	
	  Select2.prototype._placeContainer = function ($container) {
	    $container.insertAfter(this.$element);
	
	    var width = this._resolveWidth(this.$element, this.options.get('width'));
	
	    if (width != null) {
	      $container.css('width', width);
	    }
	  };
	
	  Select2.prototype._resolveWidth = function ($element, method) {
	    var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
	
	    if (method == 'resolve') {
	      var styleWidth = this._resolveWidth($element, 'style');
	
	      if (styleWidth != null) {
	        return styleWidth;
	      }
	
	      return this._resolveWidth($element, 'element');
	    }
	
	    if (method == 'element') {
	      var elementWidth = $element.outerWidth(false);
	
	      if (elementWidth <= 0) {
	        return 'auto';
	      }
	
	      return elementWidth + 'px';
	    }
	
	    if (method == 'style') {
	      var style = $element.attr('style');
	
	      if (typeof(style) !== 'string') {
	        return null;
	      }
	
	      var attrs = style.split(';');
	
	      for (var i = 0, l = attrs.length; i < l; i = i + 1) {
	        var attr = attrs[i].replace(/\s/g, '');
	        var matches = attr.match(WIDTH);
	
	        if (matches !== null && matches.length >= 1) {
	          return matches[1];
	        }
	      }
	
	      return null;
	    }
	
	    if (method == 'computedstyle') {
	      var computedStyle = window.getComputedStyle($element[0]);
	
	      return computedStyle.width;
	    }
	
	    return method;
	  };
	
	  Select2.prototype._bindAdapters = function () {
	    this.dataAdapter.bind(this, this.$container);
	    this.selection.bind(this, this.$container);
	
	    this.dropdown.bind(this, this.$container);
	    this.results.bind(this, this.$container);
	  };
	
	  Select2.prototype._registerDomEvents = function () {
	    var self = this;
	
	    this.$element.on('change.select2', function () {
	      self.dataAdapter.current(function (data) {
	        self.trigger('selection:update', {
	          data: data
	        });
	      });
	    });
	
	    this.$element.on('focus.select2', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this._syncA = Utils.bind(this._syncAttributes, this);
	    this._syncS = Utils.bind(this._syncSubtree, this);
	
	    if (this.$element[0].attachEvent) {
	      this.$element[0].attachEvent('onpropertychange', this._syncA);
	    }
	
	    var observer = window.MutationObserver ||
	      window.WebKitMutationObserver ||
	      window.MozMutationObserver
	    ;
	
	    if (observer != null) {
	      this._observer = new observer(function (mutations) {
	        self._syncA();
	        self._syncS(null, mutations);
	      });
	      this._observer.observe(this.$element[0], {
	        attributes: true,
	        childList: true,
	        subtree: false
	      });
	    } else if (this.$element[0].addEventListener) {
	      this.$element[0].addEventListener(
	        'DOMAttrModified',
	        self._syncA,
	        false
	      );
	      this.$element[0].addEventListener(
	        'DOMNodeInserted',
	        self._syncS,
	        false
	      );
	      this.$element[0].addEventListener(
	        'DOMNodeRemoved',
	        self._syncS,
	        false
	      );
	    }
	  };
	
	  Select2.prototype._registerDataEvents = function () {
	    var self = this;
	
	    this.dataAdapter.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerSelectionEvents = function () {
	    var self = this;
	    var nonRelayEvents = ['toggle', 'focus'];
	
	    this.selection.on('toggle', function () {
	      self.toggleDropdown();
	    });
	
	    this.selection.on('focus', function (params) {
	      self.focus(params);
	    });
	
	    this.selection.on('*', function (name, params) {
	      if ($.inArray(name, nonRelayEvents) !== -1) {
	        return;
	      }
	
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerDropdownEvents = function () {
	    var self = this;
	
	    this.dropdown.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerResultsEvents = function () {
	    var self = this;
	
	    this.results.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerEvents = function () {
	    var self = this;
	
	    this.on('open', function () {
	      self.$container.addClass('select2-container--open');
	    });
	
	    this.on('close', function () {
	      self.$container.removeClass('select2-container--open');
	    });
	
	    this.on('enable', function () {
	      self.$container.removeClass('select2-container--disabled');
	    });
	
	    this.on('disable', function () {
	      self.$container.addClass('select2-container--disabled');
	    });
	
	    this.on('blur', function () {
	      self.$container.removeClass('select2-container--focus');
	    });
	
	    this.on('query', function (params) {
	      if (!self.isOpen()) {
	        self.trigger('open', {});
	      }
	
	      this.dataAdapter.query(params, function (data) {
	        self.trigger('results:all', {
	          data: data,
	          query: params
	        });
	      });
	    });
	
	    this.on('query:append', function (params) {
	      this.dataAdapter.query(params, function (data) {
	        self.trigger('results:append', {
	          data: data,
	          query: params
	        });
	      });
	    });
	
	    this.on('keypress', function (evt) {
	      var key = evt.which;
	
	      if (self.isOpen()) {
	        if (key === KEYS.ESC || key === KEYS.TAB ||
	            (key === KEYS.UP && evt.altKey)) {
	          self.close(evt);
	
	          evt.preventDefault();
	        } else if (key === KEYS.ENTER) {
	          self.trigger('results:select', {});
	
	          evt.preventDefault();
	        } else if ((key === KEYS.SPACE && evt.ctrlKey)) {
	          self.trigger('results:toggle', {});
	
	          evt.preventDefault();
	        } else if (key === KEYS.UP) {
	          self.trigger('results:previous', {});
	
	          evt.preventDefault();
	        } else if (key === KEYS.DOWN) {
	          self.trigger('results:next', {});
	
	          evt.preventDefault();
	        }
	      } else {
	        if (key === KEYS.ENTER || key === KEYS.SPACE ||
	            (key === KEYS.DOWN && evt.altKey)) {
	          self.open();
	
	          evt.preventDefault();
	        }
	      }
	    });
	  };
	
	  Select2.prototype._syncAttributes = function () {
	    this.options.set('disabled', this.$element.prop('disabled'));
	
	    if (this.isDisabled()) {
	      if (this.isOpen()) {
	        this.close();
	      }
	
	      this.trigger('disable', {});
	    } else {
	      this.trigger('enable', {});
	    }
	  };
	
	  Select2.prototype._isChangeMutation = function (evt, mutations) {
	    var changed = false;
	    var self = this;
	
	    // Ignore any mutation events raised for elements that aren't options or
	    // optgroups. This handles the case when the select element is destroyed
	    if (
	      evt && evt.target && (
	        evt.target.nodeName !== 'OPTION' && evt.target.nodeName !== 'OPTGROUP'
	      )
	    ) {
	      return;
	    }
	
	    if (!mutations) {
	      // If mutation events aren't supported, then we can only assume that the
	      // change affected the selections
	      changed = true;
	    } else if (mutations.addedNodes && mutations.addedNodes.length > 0) {
	      for (var n = 0; n < mutations.addedNodes.length; n++) {
	        var node = mutations.addedNodes[n];
	
	        if (node.selected) {
	          changed = true;
	        }
	      }
	    } else if (mutations.removedNodes && mutations.removedNodes.length > 0) {
	      changed = true;
	    } else if ($.isArray(mutations)) {
	      $.each(mutations, function(evt, mutation) {
	        if (self._isChangeMutation(evt, mutation)) {
	          // We've found a change mutation.
	          // Let's escape from the loop and continue
	          changed = true;
	          return false;
	        }
	      });
	    }
	    return changed;
	  };
	
	  Select2.prototype._syncSubtree = function (evt, mutations) {
	    var changed = this._isChangeMutation(evt, mutations);
	    var self = this;
	
	    // Only re-pull the data if we think there is a change
	    if (changed) {
	      this.dataAdapter.current(function (currentData) {
	        self.trigger('selection:update', {
	          data: currentData
	        });
	      });
	    }
	  };
	
	  /**
	   * Override the trigger method to automatically trigger pre-events when
	   * there are events that can be prevented.
	   */
	  Select2.prototype.trigger = function (name, args) {
	    var actualTrigger = Select2.__super__.trigger;
	    var preTriggerMap = {
	      'open': 'opening',
	      'close': 'closing',
	      'select': 'selecting',
	      'unselect': 'unselecting',
	      'clear': 'clearing'
	    };
	
	    if (args === undefined) {
	      args = {};
	    }
	
	    if (name in preTriggerMap) {
	      var preTriggerName = preTriggerMap[name];
	      var preTriggerArgs = {
	        prevented: false,
	        name: name,
	        args: args
	      };
	
	      actualTrigger.call(this, preTriggerName, preTriggerArgs);
	
	      if (preTriggerArgs.prevented) {
	        args.prevented = true;
	
	        return;
	      }
	    }
	
	    actualTrigger.call(this, name, args);
	  };
	
	  Select2.prototype.toggleDropdown = function () {
	    if (this.isDisabled()) {
	      return;
	    }
	
	    if (this.isOpen()) {
	      this.close();
	    } else {
	      this.open();
	    }
	  };
	
	  Select2.prototype.open = function () {
	    if (this.isOpen()) {
	      return;
	    }
	
	    if (this.isDisabled()) {
	      return;
	    }
	
	    this.trigger('query', {});
	  };
	
	  Select2.prototype.close = function (evt) {
	    if (!this.isOpen()) {
	      return;
	    }
	
	    this.trigger('close', { originalEvent : evt });
	  };
	
	  /**
	   * Helper method to abstract the "enabled" (not "disabled") state of this
	   * object.
	   *
	   * @return {true} if the instance is not disabled.
	   * @return {false} if the instance is disabled.
	   */
	  Select2.prototype.isEnabled = function () {
	    return !this.isDisabled();
	  };
	
	  /**
	   * Helper method to abstract the "disabled" state of this object.
	   *
	   * @return {true} if the disabled option is true.
	   * @return {false} if the disabled option is false.
	   */
	  Select2.prototype.isDisabled = function () {
	    return this.options.get('disabled');
	  };
	
	  Select2.prototype.isOpen = function () {
	    return this.$container.hasClass('select2-container--open');
	  };
	
	  Select2.prototype.hasFocus = function () {
	    return this.$container.hasClass('select2-container--focus');
	  };
	
	  Select2.prototype.focus = function (data) {
	    // No need to re-trigger focus events if we are already focused
	    if (this.hasFocus()) {
	      return;
	    }
	
	    this.$container.addClass('select2-container--focus');
	    this.trigger('focus', {});
	  };
	
	  Select2.prototype.enable = function (args) {
	    if (this.options.get('debug') && window.console && console.warn) {
	      console.warn(
	        'Select2: The `select2("enable")` method has been deprecated and will' +
	        ' be removed in later Select2 versions. Use $element.prop("disabled")' +
	        ' instead.'
	      );
	    }
	
	    if (args == null || args.length === 0) {
	      args = [true];
	    }
	
	    var disabled = !args[0];
	
	    this.$element.prop('disabled', disabled);
	  };
	
	  Select2.prototype.data = function () {
	    if (this.options.get('debug') &&
	        arguments.length > 0 && window.console && console.warn) {
	      console.warn(
	        'Select2: Data can no longer be set using `select2("data")`. You ' +
	        'should consider setting the value instead using `$element.val()`.'
	      );
	    }
	
	    var data = [];
	
	    this.dataAdapter.current(function (currentData) {
	      data = currentData;
	    });
	
	    return data;
	  };
	
	  Select2.prototype.val = function (args) {
	    if (this.options.get('debug') && window.console && console.warn) {
	      console.warn(
	        'Select2: The `select2("val")` method has been deprecated and will be' +
	        ' removed in later Select2 versions. Use $element.val() instead.'
	      );
	    }
	
	    if (args == null || args.length === 0) {
	      return this.$element.val();
	    }
	
	    var newVal = args[0];
	
	    if ($.isArray(newVal)) {
	      newVal = $.map(newVal, function (obj) {
	        return obj.toString();
	      });
	    }
	
	    this.$element.val(newVal).trigger('input').trigger('change');
	  };
	
	  Select2.prototype.destroy = function () {
	    this.$container.remove();
	
	    if (this.$element[0].detachEvent) {
	      this.$element[0].detachEvent('onpropertychange', this._syncA);
	    }
	
	    if (this._observer != null) {
	      this._observer.disconnect();
	      this._observer = null;
	    } else if (this.$element[0].removeEventListener) {
	      this.$element[0]
	        .removeEventListener('DOMAttrModified', this._syncA, false);
	      this.$element[0]
	        .removeEventListener('DOMNodeInserted', this._syncS, false);
	      this.$element[0]
	        .removeEventListener('DOMNodeRemoved', this._syncS, false);
	    }
	
	    this._syncA = null;
	    this._syncS = null;
	
	    this.$element.off('.select2');
	    this.$element.attr('tabindex',
	    Utils.GetData(this.$element[0], 'old-tabindex'));
	
	    this.$element.removeClass('select2-hidden-accessible');
	    this.$element.attr('aria-hidden', 'false');
	    Utils.RemoveData(this.$element[0]);
	    this.$element.removeData('select2');
	
	    this.dataAdapter.destroy();
	    this.selection.destroy();
	    this.dropdown.destroy();
	    this.results.destroy();
	
	    this.dataAdapter = null;
	    this.selection = null;
	    this.dropdown = null;
	    this.results = null;
	  };
	
	  Select2.prototype.render = function () {
	    var $container = $(
	      '<span class="select2 select2-container">' +
	        '<span class="selection"></span>' +
	        '<span class="dropdown-wrapper" aria-hidden="true"></span>' +
	      '</span>'
	    );
	
	    $container.attr('dir', this.options.get('dir'));
	
	    this.$container = $container;
	
	    this.$container.addClass('select2-container--' + this.options.get('theme'));
	
	    Utils.StoreData($container[0], 'element', this.$element);
	
	    return $container;
	  };
	
	  return Select2;
	});
	
	S2.define('select2/compat/utils',[
	  'jquery'
	], function ($) {
	  function syncCssClasses ($dest, $src, adapter) {
	    var classes, replacements = [], adapted;
	
	    classes = $.trim($dest.attr('class'));
	
	    if (classes) {
	      classes = '' + classes; // for IE which returns object
	
	      $(classes.split(/\s+/)).each(function () {
	        // Save all Select2 classes
	        if (this.indexOf('select2-') === 0) {
	          replacements.push(this);
	        }
	      });
	    }
	
	    classes = $.trim($src.attr('class'));
	
	    if (classes) {
	      classes = '' + classes; // for IE which returns object
	
	      $(classes.split(/\s+/)).each(function () {
	        // Only adapt non-Select2 classes
	        if (this.indexOf('select2-') !== 0) {
	          adapted = adapter(this);
	
	          if (adapted != null) {
	            replacements.push(adapted);
	          }
	        }
	      });
	    }
	
	    $dest.attr('class', replacements.join(' '));
	  }
	
	  return {
	    syncCssClasses: syncCssClasses
	  };
	});
	
	S2.define('select2/compat/containerCss',[
	  'jquery',
	  './utils'
	], function ($, CompatUtils) {
	  // No-op CSS adapter that discards all classes by default
	  function _containerAdapter (clazz) {
	    return null;
	  }
	
	  function ContainerCSS () { }
	
	  ContainerCSS.prototype.render = function (decorated) {
	    var $container = decorated.call(this);
	
	    var containerCssClass = this.options.get('containerCssClass') || '';
	
	    if ($.isFunction(containerCssClass)) {
	      containerCssClass = containerCssClass(this.$element);
	    }
	
	    var containerCssAdapter = this.options.get('adaptContainerCssClass');
	    containerCssAdapter = containerCssAdapter || _containerAdapter;
	
	    if (containerCssClass.indexOf(':all:') !== -1) {
	      containerCssClass = containerCssClass.replace(':all:', '');
	
	      var _cssAdapter = containerCssAdapter;
	
	      containerCssAdapter = function (clazz) {
	        var adapted = _cssAdapter(clazz);
	
	        if (adapted != null) {
	          // Append the old one along with the adapted one
	          return adapted + ' ' + clazz;
	        }
	
	        return clazz;
	      };
	    }
	
	    var containerCss = this.options.get('containerCss') || {};
	
	    if ($.isFunction(containerCss)) {
	      containerCss = containerCss(this.$element);
	    }
	
	    CompatUtils.syncCssClasses($container, this.$element, containerCssAdapter);
	
	    $container.css(containerCss);
	    $container.addClass(containerCssClass);
	
	    return $container;
	  };
	
	  return ContainerCSS;
	});
	
	S2.define('select2/compat/dropdownCss',[
	  'jquery',
	  './utils'
	], function ($, CompatUtils) {
	  // No-op CSS adapter that discards all classes by default
	  function _dropdownAdapter (clazz) {
	    return null;
	  }
	
	  function DropdownCSS () { }
	
	  DropdownCSS.prototype.render = function (decorated) {
	    var $dropdown = decorated.call(this);
	
	    var dropdownCssClass = this.options.get('dropdownCssClass') || '';
	
	    if ($.isFunction(dropdownCssClass)) {
	      dropdownCssClass = dropdownCssClass(this.$element);
	    }
	
	    var dropdownCssAdapter = this.options.get('adaptDropdownCssClass');
	    dropdownCssAdapter = dropdownCssAdapter || _dropdownAdapter;
	
	    if (dropdownCssClass.indexOf(':all:') !== -1) {
	      dropdownCssClass = dropdownCssClass.replace(':all:', '');
	
	      var _cssAdapter = dropdownCssAdapter;
	
	      dropdownCssAdapter = function (clazz) {
	        var adapted = _cssAdapter(clazz);
	
	        if (adapted != null) {
	          // Append the old one along with the adapted one
	          return adapted + ' ' + clazz;
	        }
	
	        return clazz;
	      };
	    }
	
	    var dropdownCss = this.options.get('dropdownCss') || {};
	
	    if ($.isFunction(dropdownCss)) {
	      dropdownCss = dropdownCss(this.$element);
	    }
	
	    CompatUtils.syncCssClasses($dropdown, this.$element, dropdownCssAdapter);
	
	    $dropdown.css(dropdownCss);
	    $dropdown.addClass(dropdownCssClass);
	
	    return $dropdown;
	  };
	
	  return DropdownCSS;
	});
	
	S2.define('select2/compat/initSelection',[
	  'jquery'
	], function ($) {
	  function InitSelection (decorated, $element, options) {
	    if (options.get('debug') && window.console && console.warn) {
	      console.warn(
	        'Select2: The `initSelection` option has been deprecated in favor' +
	        ' of a custom data adapter that overrides the `current` method. ' +
	        'This method is now called multiple times instead of a single ' +
	        'time when the instance is initialized. Support will be removed ' +
	        'for the `initSelection` option in future versions of Select2'
	      );
	    }
	
	    this.initSelection = options.get('initSelection');
	    this._isInitialized = false;
	
	    decorated.call(this, $element, options);
	  }
	
	  InitSelection.prototype.current = function (decorated, callback) {
	    var self = this;
	
	    if (this._isInitialized) {
	      decorated.call(this, callback);
	
	      return;
	    }
	
	    this.initSelection.call(null, this.$element, function (data) {
	      self._isInitialized = true;
	
	      if (!$.isArray(data)) {
	        data = [data];
	      }
	
	      callback(data);
	    });
	  };
	
	  return InitSelection;
	});
	
	S2.define('select2/compat/inputData',[
	  'jquery',
	  '../utils'
	], function ($, Utils) {
	  function InputData (decorated, $element, options) {
	    this._currentData = [];
	    this._valueSeparator = options.get('valueSeparator') || ',';
	
	    if ($element.prop('type') === 'hidden') {
	      if (options.get('debug') && console && console.warn) {
	        console.warn(
	          'Select2: Using a hidden input with Select2 is no longer ' +
	          'supported and may stop working in the future. It is recommended ' +
	          'to use a `<select>` element instead.'
	        );
	      }
	    }
	
	    decorated.call(this, $element, options);
	  }
	
	  InputData.prototype.current = function (_, callback) {
	    function getSelected (data, selectedIds) {
	      var selected = [];
	
	      if (data.selected || $.inArray(data.id, selectedIds) !== -1) {
	        data.selected = true;
	        selected.push(data);
	      } else {
	        data.selected = false;
	      }
	
	      if (data.children) {
	        selected.push.apply(selected, getSelected(data.children, selectedIds));
	      }
	
	      return selected;
	    }
	
	    var selected = [];
	
	    for (var d = 0; d < this._currentData.length; d++) {
	      var data = this._currentData[d];
	
	      selected.push.apply(
	        selected,
	        getSelected(
	          data,
	          this.$element.val().split(
	            this._valueSeparator
	          )
	        )
	      );
	    }
	
	    callback(selected);
	  };
	
	  InputData.prototype.select = function (_, data) {
	    if (!this.options.get('multiple')) {
	      this.current(function (allData) {
	        $.map(allData, function (data) {
	          data.selected = false;
	        });
	      });
	
	      this.$element.val(data.id);
	      this.$element.trigger('input').trigger('change');
	    } else {
	      var value = this.$element.val();
	      value += this._valueSeparator + data.id;
	
	      this.$element.val(value);
	      this.$element.trigger('input').trigger('change');
	    }
	  };
	
	  InputData.prototype.unselect = function (_, data) {
	    var self = this;
	
	    data.selected = false;
	
	    this.current(function (allData) {
	      var values = [];
	
	      for (var d = 0; d < allData.length; d++) {
	        var item = allData[d];
	
	        if (data.id == item.id) {
	          continue;
	        }
	
	        values.push(item.id);
	      }
	
	      self.$element.val(values.join(self._valueSeparator));
	      self.$element.trigger('input').trigger('change');
	    });
	  };
	
	  InputData.prototype.query = function (_, params, callback) {
	    var results = [];
	
	    for (var d = 0; d < this._currentData.length; d++) {
	      var data = this._currentData[d];
	
	      var matches = this.matches(params, data);
	
	      if (matches !== null) {
	        results.push(matches);
	      }
	    }
	
	    callback({
	      results: results
	    });
	  };
	
	  InputData.prototype.addOptions = function (_, $options) {
	    var options = $.map($options, function ($option) {
	      return Utils.GetData($option[0], 'data');
	    });
	
	    this._currentData.push.apply(this._currentData, options);
	  };
	
	  return InputData;
	});
	
	S2.define('select2/compat/matcher',[
	  'jquery'
	], function ($) {
	  function oldMatcher (matcher) {
	    function wrappedMatcher (params, data) {
	      var match = $.extend(true, {}, data);
	
	      if (params.term == null || $.trim(params.term) === '') {
	        return match;
	      }
	
	      if (data.children) {
	        for (var c = data.children.length - 1; c >= 0; c--) {
	          var child = data.children[c];
	
	          // Check if the child object matches
	          // The old matcher returned a boolean true or false
	          var doesMatch = matcher(params.term, child.text, child);
	
	          // If the child didn't match, pop it off
	          if (!doesMatch) {
	            match.children.splice(c, 1);
	          }
	        }
	
	        if (match.children.length > 0) {
	          return match;
	        }
	      }
	
	      if (matcher(params.term, data.text, data)) {
	        return match;
	      }
	
	      return null;
	    }
	
	    return wrappedMatcher;
	  }
	
	  return oldMatcher;
	});
	
	S2.define('select2/compat/query',[
	
	], function () {
	  function Query (decorated, $element, options) {
	    if (options.get('debug') && window.console && console.warn) {
	      console.warn(
	        'Select2: The `query` option has been deprecated in favor of a ' +
	        'custom data adapter that overrides the `query` method. Support ' +
	        'will be removed for the `query` option in future versions of ' +
	        'Select2.'
	      );
	    }
	
	    decorated.call(this, $element, options);
	  }
	
	  Query.prototype.query = function (_, params, callback) {
	    params.callback = callback;
	
	    var query = this.options.get('query');
	
	    query.call(null, params);
	  };
	
	  return Query;
	});
	
	S2.define('select2/dropdown/attachContainer',[
	
	], function () {
	  function AttachContainer (decorated, $element, options) {
	    decorated.call(this, $element, options);
	  }
	
	  AttachContainer.prototype.position =
	    function (decorated, $dropdown, $container) {
	    var $dropdownContainer = $container.find('.dropdown-wrapper');
	    $dropdownContainer.append($dropdown);
	
	    $dropdown.addClass('select2-dropdown--below');
	    $container.addClass('select2-container--below');
	  };
	
	  return AttachContainer;
	});
	
	S2.define('select2/dropdown/stopPropagation',[
	
	], function () {
	  function StopPropagation () { }
	
	  StopPropagation.prototype.bind = function (decorated, container, $container) {
	    decorated.call(this, container, $container);
	
	    var stoppedEvents = [
	    'blur',
	    'change',
	    'click',
	    'dblclick',
	    'focus',
	    'focusin',
	    'focusout',
	    'input',
	    'keydown',
	    'keyup',
	    'keypress',
	    'mousedown',
	    'mouseenter',
	    'mouseleave',
	    'mousemove',
	    'mouseover',
	    'mouseup',
	    'search',
	    'touchend',
	    'touchstart'
	    ];
	
	    this.$dropdown.on(stoppedEvents.join(' '), function (evt) {
	      evt.stopPropagation();
	    });
	  };
	
	  return StopPropagation;
	});
	
	S2.define('select2/selection/stopPropagation',[
	
	], function () {
	  function StopPropagation () { }
	
	  StopPropagation.prototype.bind = function (decorated, container, $container) {
	    decorated.call(this, container, $container);
	
	    var stoppedEvents = [
	      'blur',
	      'change',
	      'click',
	      'dblclick',
	      'focus',
	      'focusin',
	      'focusout',
	      'input',
	      'keydown',
	      'keyup',
	      'keypress',
	      'mousedown',
	      'mouseenter',
	      'mouseleave',
	      'mousemove',
	      'mouseover',
	      'mouseup',
	      'search',
	      'touchend',
	      'touchstart'
	    ];
	
	    this.$selection.on(stoppedEvents.join(' '), function (evt) {
	      evt.stopPropagation();
	    });
	  };
	
	  return StopPropagation;
	});
	
	/*!
	 * jQuery Mousewheel 3.1.13
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 */
	
	(function (factory) {
	    if ( typeof S2.define === 'function' && S2.define.amd ) {
	        // AMD. Register as an anonymous module.
	        S2.define('jquery-mousewheel',['jquery'], factory);
	    } else if (true) {
	        // Node/CommonJS style for Browserify
	        module.exports = factory;
	    } else {
	        // Browser globals
	        factory(jQuery);
	    }
	}(function ($) {
	
	    var toFix  = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'],
	        toBind = ( 'onwheel' in document || document.documentMode >= 9 ) ?
	                    ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'],
	        slice  = Array.prototype.slice,
	        nullLowestDeltaTimeout, lowestDelta;
	
	    if ( $.event.fixHooks ) {
	        for ( var i = toFix.length; i; ) {
	            $.event.fixHooks[ toFix[--i] ] = $.event.mouseHooks;
	        }
	    }
	
	    var special = $.event.special.mousewheel = {
	        version: '3.1.12',
	
	        setup: function() {
	            if ( this.addEventListener ) {
	                for ( var i = toBind.length; i; ) {
	                    this.addEventListener( toBind[--i], handler, false );
	                }
	            } else {
	                this.onmousewheel = handler;
	            }
	            // Store the line height and page height for this particular element
	            $.data(this, 'mousewheel-line-height', special.getLineHeight(this));
	            $.data(this, 'mousewheel-page-height', special.getPageHeight(this));
	        },
	
	        teardown: function() {
	            if ( this.removeEventListener ) {
	                for ( var i = toBind.length; i; ) {
	                    this.removeEventListener( toBind[--i], handler, false );
	                }
	            } else {
	                this.onmousewheel = null;
	            }
	            // Clean up the data we added to the element
	            $.removeData(this, 'mousewheel-line-height');
	            $.removeData(this, 'mousewheel-page-height');
	        },
	
	        getLineHeight: function(elem) {
	            var $elem = $(elem),
	                $parent = $elem['offsetParent' in $.fn ? 'offsetParent' : 'parent']();
	            if (!$parent.length) {
	                $parent = $('body');
	            }
	            return parseInt($parent.css('fontSize'), 10) || parseInt($elem.css('fontSize'), 10) || 16;
	        },
	
	        getPageHeight: function(elem) {
	            return $(elem).height();
	        },
	
	        settings: {
	            adjustOldDeltas: true, // see shouldAdjustOldDeltas() below
	            normalizeOffset: true  // calls getBoundingClientRect for each event
	        }
	    };
	
	    $.fn.extend({
	        mousewheel: function(fn) {
	            return fn ? this.bind('mousewheel', fn) : this.trigger('mousewheel');
	        },
	
	        unmousewheel: function(fn) {
	            return this.unbind('mousewheel', fn);
	        }
	    });
	
	
	    function handler(event) {
	        var orgEvent   = event || window.event,
	            args       = slice.call(arguments, 1),
	            delta      = 0,
	            deltaX     = 0,
	            deltaY     = 0,
	            absDelta   = 0,
	            offsetX    = 0,
	            offsetY    = 0;
	        event = $.event.fix(orgEvent);
	        event.type = 'mousewheel';
	
	        // Old school scrollwheel delta
	        if ( 'detail'      in orgEvent ) { deltaY = orgEvent.detail * -1;      }
	        if ( 'wheelDelta'  in orgEvent ) { deltaY = orgEvent.wheelDelta;       }
	        if ( 'wheelDeltaY' in orgEvent ) { deltaY = orgEvent.wheelDeltaY;      }
	        if ( 'wheelDeltaX' in orgEvent ) { deltaX = orgEvent.wheelDeltaX * -1; }
	
	        // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
	        if ( 'axis' in orgEvent && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
	            deltaX = deltaY * -1;
	            deltaY = 0;
	        }
	
	        // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
	        delta = deltaY === 0 ? deltaX : deltaY;
	
	        // New school wheel delta (wheel event)
	        if ( 'deltaY' in orgEvent ) {
	            deltaY = orgEvent.deltaY * -1;
	            delta  = deltaY;
	        }
	        if ( 'deltaX' in orgEvent ) {
	            deltaX = orgEvent.deltaX;
	            if ( deltaY === 0 ) { delta  = deltaX * -1; }
	        }
	
	        // No change actually happened, no reason to go any further
	        if ( deltaY === 0 && deltaX === 0 ) { return; }
	
	        // Need to convert lines and pages to pixels if we aren't already in pixels
	        // There are three delta modes:
	        //   * deltaMode 0 is by pixels, nothing to do
	        //   * deltaMode 1 is by lines
	        //   * deltaMode 2 is by pages
	        if ( orgEvent.deltaMode === 1 ) {
	            var lineHeight = $.data(this, 'mousewheel-line-height');
	            delta  *= lineHeight;
	            deltaY *= lineHeight;
	            deltaX *= lineHeight;
	        } else if ( orgEvent.deltaMode === 2 ) {
	            var pageHeight = $.data(this, 'mousewheel-page-height');
	            delta  *= pageHeight;
	            deltaY *= pageHeight;
	            deltaX *= pageHeight;
	        }
	
	        // Store lowest absolute delta to normalize the delta values
	        absDelta = Math.max( Math.abs(deltaY), Math.abs(deltaX) );
	
	        if ( !lowestDelta || absDelta < lowestDelta ) {
	            lowestDelta = absDelta;
	
	            // Adjust older deltas if necessary
	            if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
	                lowestDelta /= 40;
	            }
	        }
	
	        // Adjust older deltas if necessary
	        if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
	            // Divide all the things by 40!
	            delta  /= 40;
	            deltaX /= 40;
	            deltaY /= 40;
	        }
	
	        // Get a whole, normalized value for the deltas
	        delta  = Math[ delta  >= 1 ? 'floor' : 'ceil' ](delta  / lowestDelta);
	        deltaX = Math[ deltaX >= 1 ? 'floor' : 'ceil' ](deltaX / lowestDelta);
	        deltaY = Math[ deltaY >= 1 ? 'floor' : 'ceil' ](deltaY / lowestDelta);
	
	        // Normalise offsetX and offsetY properties
	        if ( special.settings.normalizeOffset && this.getBoundingClientRect ) {
	            var boundingRect = this.getBoundingClientRect();
	            offsetX = event.clientX - boundingRect.left;
	            offsetY = event.clientY - boundingRect.top;
	        }
	
	        // Add information to the event object
	        event.deltaX = deltaX;
	        event.deltaY = deltaY;
	        event.deltaFactor = lowestDelta;
	        event.offsetX = offsetX;
	        event.offsetY = offsetY;
	        // Go ahead and set deltaMode to 0 since we converted to pixels
	        // Although this is a little odd since we overwrite the deltaX/Y
	        // properties with normalized deltas.
	        event.deltaMode = 0;
	
	        // Add event and delta to the front of the arguments
	        args.unshift(event, delta, deltaX, deltaY);
	
	        // Clearout lowestDelta after sometime to better
	        // handle multiple device types that give different
	        // a different lowestDelta
	        // Ex: trackpad = 3 and mouse wheel = 120
	        if (nullLowestDeltaTimeout) { clearTimeout(nullLowestDeltaTimeout); }
	        nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);
	
	        return ($.event.dispatch || $.event.handle).apply(this, args);
	    }
	
	    function nullLowestDelta() {
	        lowestDelta = null;
	    }
	
	    function shouldAdjustOldDeltas(orgEvent, absDelta) {
	        // If this is an older event and the delta is divisable by 120,
	        // then we are assuming that the browser is treating this as an
	        // older mouse wheel event and that we should divide the deltas
	        // by 40 to try and get a more usable deltaFactor.
	        // Side note, this actually impacts the reported scroll distance
	        // in older browsers and can cause scrolling to be slower than native.
	        // Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
	        return special.settings.adjustOldDeltas && orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
	    }
	
	}));
	
	S2.define('jquery.select2',[
	  'jquery',
	  'jquery-mousewheel',
	
	  './select2/core',
	  './select2/defaults',
	  './select2/utils'
	], function ($, _, Select2, Defaults, Utils) {
	  if ($.fn.select2 == null) {
	    // All methods that should return the element
	    var thisMethods = ['open', 'close', 'destroy'];
	
	    $.fn.select2 = function (options) {
	      options = options || {};
	
	      if (typeof options === 'object') {
	        this.each(function () {
	          var instanceOptions = $.extend(true, {}, options);
	
	          var instance = new Select2($(this), instanceOptions);
	        });
	
	        return this;
	      } else if (typeof options === 'string') {
	        var ret;
	        var args = Array.prototype.slice.call(arguments, 1);
	
	        this.each(function () {
	          var instance = Utils.GetData(this, 'select2');
	
	          if (instance == null && window.console && console.error) {
	            console.error(
	              'The select2(\'' + options + '\') method was called on an ' +
	              'element that is not using Select2.'
	            );
	          }
	
	          ret = instance[options].apply(instance, args);
	        });
	
	        // Check if we should be returning `this`
	        if ($.inArray(options, thisMethods) > -1) {
	          return this;
	        }
	
	        return ret;
	      } else {
	        throw new Error('Invalid arguments for Select2: ' + options);
	      }
	    };
	  }
	
	  if ($.fn.select2.defaults == null) {
	    $.fn.select2.defaults = Defaults;
	  }
	
	  return Select2;
	});
	
	  // Return the AMD loader configuration so it can be used outside of this file
	  return {
	    define: S2.define,
	    require: S2.require
	  };
	}());
	
	  // Autoload the jQuery bindings
	  // We know that all of the modules exist above this, so we're safe
	  var select2 = S2.require('jquery.select2');
	
	  // Hold the AMD module references on the jQuery function that was just loaded
	  // This allows Select2 to use the internal loader outside of this file, such
	  // as in the language files.
	  jQuery.fn.select2.amd = S2;
	
	  // Return the Select2 instance for anyone who is importing it.
	  return select2;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ },
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ function(module, exports) {

	/*!
	* @license PreloadJS
	* Visit http://createjs.com/ for documentation, updates and examples.
	*
	* Copyright (c) 2011-2013 gskinner.com, inc.
	*
	* Distributed under the terms of the MIT license.
	* http://www.opensource.org/licenses/mit-license.html
	*
	* This notice shall be included in all copies or substantial portions of the Software.
	*/
	window.createjs=window.createjs||{},function(){"use strict";var a=createjs.PreloadJS=createjs.PreloadJS||{};a.version="0.4.1",a.buildDate="Thu, 12 Dec 2013 23:33:38 GMT"}(),function(){"use strict";var a=function(a,b,c){this.initialize(a,b,c)},b=a.prototype;b.type=null,b.target=null,b.currentTarget=null,b.eventPhase=0,b.bubbles=!1,b.cancelable=!1,b.timeStamp=0,b.defaultPrevented=!1,b.propagationStopped=!1,b.immediatePropagationStopped=!1,b.removed=!1,b.initialize=function(a,b,c){this.type=a,this.bubbles=b,this.cancelable=c,this.timeStamp=(new Date).getTime()},b.preventDefault=function(){this.defaultPrevented=!0},b.stopPropagation=function(){this.propagationStopped=!0},b.stopImmediatePropagation=function(){this.immediatePropagationStopped=this.propagationStopped=!0},b.remove=function(){this.removed=!0},b.clone=function(){return new a(this.type,this.bubbles,this.cancelable)},b.toString=function(){return"[Event (type="+this.type+")]"},createjs.Event=a}(),function(){"use strict";var a=function(){},b=a.prototype;a.initialize=function(a){a.addEventListener=b.addEventListener,a.on=b.on,a.removeEventListener=a.off=b.removeEventListener,a.removeAllEventListeners=b.removeAllEventListeners,a.hasEventListener=b.hasEventListener,a.dispatchEvent=b.dispatchEvent,a._dispatchEvent=b._dispatchEvent,a.willTrigger=b.willTrigger},b._listeners=null,b._captureListeners=null,b.initialize=function(){},b.addEventListener=function(a,b,c){var d;d=c?this._captureListeners=this._captureListeners||{}:this._listeners=this._listeners||{};var e=d[a];return e&&this.removeEventListener(a,b,c),e=d[a],e?e.push(b):d[a]=[b],b},b.on=function(a,b,c,d,e,f){return b.handleEvent&&(c=c||b,b=b.handleEvent),c=c||this,this.addEventListener(a,function(a){b.call(c,a,e),d&&a.remove()},f)},b.removeEventListener=function(a,b,c){var d=c?this._captureListeners:this._listeners;if(d){var e=d[a];if(e)for(var f=0,g=e.length;g>f;f++)if(e[f]==b){1==g?delete d[a]:e.splice(f,1);break}}},b.off=b.removeEventListener,b.removeAllEventListeners=function(a){a?(this._listeners&&delete this._listeners[a],this._captureListeners&&delete this._captureListeners[a]):this._listeners=this._captureListeners=null},b.dispatchEvent=function(a,b){if("string"==typeof a){var c=this._listeners;if(!c||!c[a])return!1;a=new createjs.Event(a)}if(a.target=b||this,a.bubbles&&this.parent){for(var d=this,e=[d];d.parent;)e.push(d=d.parent);var f,g=e.length;for(f=g-1;f>=0&&!a.propagationStopped;f--)e[f]._dispatchEvent(a,1+(0==f));for(f=1;g>f&&!a.propagationStopped;f++)e[f]._dispatchEvent(a,3)}else this._dispatchEvent(a,2);return a.defaultPrevented},b.hasEventListener=function(a){var b=this._listeners,c=this._captureListeners;return!!(b&&b[a]||c&&c[a])},b.willTrigger=function(a){for(var b=this;b;){if(b.hasEventListener(a))return!0;b=b.parent}return!1},b.toString=function(){return"[EventDispatcher]"},b._dispatchEvent=function(a,b){var c,d=1==b?this._captureListeners:this._listeners;if(a&&d){var e=d[a.type];if(!e||!(c=e.length))return;a.currentTarget=this,a.eventPhase=b,a.removed=!1,e=e.slice();for(var f=0;c>f&&!a.immediatePropagationStopped;f++){var g=e[f];g.handleEvent?g.handleEvent(a):g(a),a.removed&&(this.off(a.type,g,1==b),a.removed=!1)}}},createjs.EventDispatcher=a}(),function(){"use strict";createjs.indexOf=function(a,b){for(var c=0,d=a.length;d>c;c++)if(b===a[c])return c;return-1}}(),function(){"use strict";createjs.proxy=function(a,b){var c=Array.prototype.slice.call(arguments,2);return function(){return a.apply(b,Array.prototype.slice.call(arguments,0).concat(c))}}}(),function(){"use strict";var a=function(){this.init()};a.prototype=new createjs.EventDispatcher;var b=a.prototype,c=a;c.FILE_PATTERN=/^(?:(\w+:)\/{2}(\w+(?:\.\w+)*\/?)|(.{0,2}\/{1}))?([/.]*?(?:[^?]+)?\/)?((?:[^/?]+)\.(\w+))(?:\?(\S+)?)?$/,c.PATH_PATTERN=/^(?:(\w+:)\/{2})|(.{0,2}\/{1})?([/.]*?(?:[^?]+)?\/?)?$/,b.loaded=!1,b.canceled=!1,b.progress=0,b._item=null,b.getItem=function(){return this._item},b.init=function(){},b.load=function(){},b.close=function(){},b._sendLoadStart=function(){this._isCanceled()||this.dispatchEvent("loadstart")},b._sendProgress=function(a){if(!this._isCanceled()){var b=null;"number"==typeof a?(this.progress=a,b=new createjs.Event("progress"),b.loaded=this.progress,b.total=1):(b=a,this.progress=a.loaded/a.total,(isNaN(this.progress)||1/0==this.progress)&&(this.progress=0)),b.progress=this.progress,this.hasEventListener("progress")&&this.dispatchEvent(b)}},b._sendComplete=function(){this._isCanceled()||this.dispatchEvent("complete")},b._sendError=function(a){!this._isCanceled()&&this.hasEventListener("error")&&(null==a&&(a=new createjs.Event("error")),this.dispatchEvent(a))},b._isCanceled=function(){return null==window.createjs||this.canceled?!0:!1},b._parseURI=function(a){return a?a.match(c.FILE_PATTERN):null},b._parsePath=function(a){return a?a.match(c.PATH_PATTERN):null},b._formatQueryString=function(a,b){if(null==a)throw new Error("You must specify data.");var c=[];for(var d in a)c.push(d+"="+escape(a[d]));return b&&(c=c.concat(b)),c.join("&")},b.buildPath=function(a,b){if(null==b)return a;var c=[],d=a.indexOf("?");if(-1!=d){var e=a.slice(d+1);c=c.concat(e.split("&"))}return-1!=d?a.slice(0,d)+"?"+this._formatQueryString(b,c):a+"?"+this._formatQueryString(b,c)},b._isCrossDomain=function(a){var b=document.createElement("a");b.href=a.src;var c=document.createElement("a");c.href=location.href;var d=""!=b.hostname&&(b.port!=c.port||b.protocol!=c.protocol||b.hostname!=c.hostname);return d},b._isLocal=function(a){var b=document.createElement("a");return b.href=a.src,""==b.hostname&&"file:"==b.protocol},b.toString=function(){return"[PreloadJS AbstractLoader]"},createjs.AbstractLoader=a}(),function(){"use strict";var a=function(a,b,c){this.init(a,b,c)},b=a.prototype=new createjs.AbstractLoader,c=a;c.loadTimeout=8e3,c.LOAD_TIMEOUT=0,c.BINARY="binary",c.CSS="css",c.IMAGE="image",c.JAVASCRIPT="javascript",c.JSON="json",c.JSONP="jsonp",c.MANIFEST="manifest",c.SOUND="sound",c.SVG="svg",c.TEXT="text",c.XML="xml",c.POST="POST",c.GET="GET",b._basePath=null,b._crossOrigin="",b.useXHR=!0,b.stopOnError=!1,b.maintainScriptOrder=!0,b.next=null,b._typeCallbacks=null,b._extensionCallbacks=null,b._loadStartWasDispatched=!1,b._maxConnections=1,b._currentlyLoadingScript=null,b._currentLoads=null,b._loadQueue=null,b._loadQueueBackup=null,b._loadItemsById=null,b._loadItemsBySrc=null,b._loadedResults=null,b._loadedRawResults=null,b._numItems=0,b._numItemsLoaded=0,b._scriptOrder=null,b._loadedScripts=null,b.init=function(a,b,c){this._numItems=this._numItemsLoaded=0,this._paused=!1,this._loadStartWasDispatched=!1,this._currentLoads=[],this._loadQueue=[],this._loadQueueBackup=[],this._scriptOrder=[],this._loadedScripts=[],this._loadItemsById={},this._loadItemsBySrc={},this._loadedResults={},this._loadedRawResults={},this._typeCallbacks={},this._extensionCallbacks={},this._basePath=b,this.setUseXHR(a),this._crossOrigin=c===!0?"Anonymous":c===!1||null==c?"":c},b.setUseXHR=function(a){return this.useXHR=0!=a&&null!=window.XMLHttpRequest,this.useXHR},b.removeAll=function(){this.remove()},b.remove=function(a){var b=null;if(!a||a instanceof Array){if(a)b=a;else if(arguments.length>0)return}else b=[a];var c=!1;if(b){for(;b.length;){var d=b.pop(),e=this.getResult(d);for(f=this._loadQueue.length-1;f>=0;f--)if(g=this._loadQueue[f].getItem(),g.id==d||g.src==d){this._loadQueue.splice(f,1)[0].cancel();break}for(f=this._loadQueueBackup.length-1;f>=0;f--)if(g=this._loadQueueBackup[f].getItem(),g.id==d||g.src==d){this._loadQueueBackup.splice(f,1)[0].cancel();break}if(e)delete this._loadItemsById[e.id],delete this._loadItemsBySrc[e.src],this._disposeItem(e);else for(var f=this._currentLoads.length-1;f>=0;f--){var g=this._currentLoads[f].getItem();if(g.id==d||g.src==d){this._currentLoads.splice(f,1)[0].cancel(),c=!0;break}}}c&&this._loadNext()}else{this.close();for(var h in this._loadItemsById)this._disposeItem(this._loadItemsById[h]);this.init(this.useXHR)}},b.reset=function(){this.close();for(var a in this._loadItemsById)this._disposeItem(this._loadItemsById[a]);for(var b=[],c=0,d=this._loadQueueBackup.length;d>c;c++)b.push(this._loadQueueBackup[c].getItem());this.loadManifest(b,!1)},c.isBinary=function(a){switch(a){case createjs.LoadQueue.IMAGE:case createjs.LoadQueue.BINARY:return!0;default:return!1}},c.isText=function(a){switch(a){case createjs.LoadQueue.TEXT:case createjs.LoadQueue.JSON:case createjs.LoadQueue.MANIFEST:case createjs.LoadQueue.XML:case createjs.LoadQueue.HTML:case createjs.LoadQueue.CSS:case createjs.LoadQueue.SVG:case createjs.LoadQueue.JAVASCRIPT:return!0;default:return!1}},b.installPlugin=function(a){if(null!=a&&null!=a.getPreloadHandlers){var b=a.getPreloadHandlers();if(b.scope=a,null!=b.types)for(var c=0,d=b.types.length;d>c;c++)this._typeCallbacks[b.types[c]]=b;if(null!=b.extensions)for(c=0,d=b.extensions.length;d>c;c++)this._extensionCallbacks[b.extensions[c]]=b}},b.setMaxConnections=function(a){this._maxConnections=a,!this._paused&&this._loadQueue.length>0&&this._loadNext()},b.loadFile=function(a,b,c){if(null==a){var d=new createjs.Event("error");return d.text="PRELOAD_NO_FILE",this._sendError(d),void 0}this._addItem(a,null,c),b!==!1?this.setPaused(!1):this.setPaused(!0)},b.loadManifest=function(a,b,d){var e=null,f=null;if(a instanceof Array){if(0==a.length){var g=new createjs.Event("error");return g.text="PRELOAD_MANIFEST_EMPTY",this._sendError(g),void 0}e=a}else if("string"==typeof a)e=[{src:a,type:c.MANIFEST}];else{if("object"!=typeof a){var g=new createjs.Event("error");return g.text="PRELOAD_MANIFEST_NULL",this._sendError(g),void 0}if(void 0!==a.src){if(null==a.type)a.type=c.MANIFEST;else if(a.type!=c.MANIFEST){var g=new createjs.Event("error");g.text="PRELOAD_MANIFEST_ERROR",this._sendError(g)}e=[a]}else void 0!==a.manifest&&(e=a.manifest,f=a.path)}for(var h=0,i=e.length;i>h;h++)this._addItem(e[h],f,d);b!==!1?this.setPaused(!1):this.setPaused(!0)},b.load=function(){this.setPaused(!1)},b.getItem=function(a){return this._loadItemsById[a]||this._loadItemsBySrc[a]},b.getResult=function(a,b){var c=this._loadItemsById[a]||this._loadItemsBySrc[a];if(null==c)return null;var d=c.id;return b&&this._loadedRawResults[d]?this._loadedRawResults[d]:this._loadedResults[d]},b.setPaused=function(a){this._paused=a,this._paused||this._loadNext()},b.close=function(){for(;this._currentLoads.length;)this._currentLoads.pop().cancel();this._scriptOrder.length=0,this._loadedScripts.length=0,this.loadStartWasDispatched=!1},b._addItem=function(a,b,c){var d=this._createLoadItem(a,b,c);if(null!=d){var e=this._createLoader(d);null!=e&&(this._loadQueue.push(e),this._loadQueueBackup.push(e),this._numItems++,this._updateProgress(),this.maintainScriptOrder&&d.type==createjs.LoadQueue.JAVASCRIPT&&e instanceof createjs.XHRLoader&&(this._scriptOrder.push(d),this._loadedScripts.push(null)))}},b._createLoadItem=function(a,b,c){var d=null;switch(typeof a){case"string":d={src:a};break;case"object":d=window.HTMLAudioElement&&a instanceof window.HTMLAudioElement?{tag:a,src:d.tag.src,type:createjs.LoadQueue.SOUND}:a;break;default:return null}var e=this._parseURI(d.src);null!=e&&(d.ext=e[6]),null==d.type&&(d.type=this._getTypeByExtension(d.ext));var f="",g=c||this._basePath,h=d.src;if(e&&null==e[1]&&null==e[3])if(b){f=b;var i=this._parsePath(b);h=b+h,null!=g&&i&&null==i[1]&&null==i[2]&&(f=g+f)}else null!=g&&(f=g);if(d.src=f+d.src,d.path=f,(d.type==createjs.LoadQueue.JSON||d.type==createjs.LoadQueue.MANIFEST)&&(d._loadAsJSONP=null!=d.callback),d.type==createjs.LoadQueue.JSONP&&null==d.callback)throw new Error("callback is required for loading JSONP requests.");(void 0===d.tag||null===d.tag)&&(d.tag=this._createTag(d)),(void 0===d.id||null===d.id||""===d.id)&&(d.id=h);var j=this._typeCallbacks[d.type]||this._extensionCallbacks[d.ext];if(j){var k=j.callback.call(j.scope,d.src,d.type,d.id,d.data,f,this);if(k===!1)return null;k===!0||(null!=k.src&&(d.src=k.src),null!=k.id&&(d.id=k.id),null!=k.tag&&(d.tag=k.tag),null!=k.completeHandler&&(d.completeHandler=k.completeHandler),k.type&&(d.type=k.type),e=this._parseURI(d.src),null!=e&&null!=e[6]&&(d.ext=e[6].toLowerCase()))}return this._loadItemsById[d.id]=d,this._loadItemsBySrc[d.src]=d,d},b._createLoader=function(a){var b=this.useXHR;switch(a.type){case createjs.LoadQueue.JSON:case createjs.LoadQueue.MANIFEST:b=!a._loadAsJSONP;break;case createjs.LoadQueue.XML:case createjs.LoadQueue.TEXT:b=!0;break;case createjs.LoadQueue.SOUND:case createjs.LoadQueue.JSONP:b=!1;break;case null:return null}return b?new createjs.XHRLoader(a,this._crossOrigin):new createjs.TagLoader(a)},b._loadNext=function(){if(!this._paused){this._loadStartWasDispatched||(this._sendLoadStart(),this._loadStartWasDispatched=!0),this._numItems==this._numItemsLoaded?(this.loaded=!0,this._sendComplete(),this.next&&this.next.load&&this.next.load()):this.loaded=!1;for(var a=0;a<this._loadQueue.length&&!(this._currentLoads.length>=this._maxConnections);a++){var b=this._loadQueue[a];if(this.maintainScriptOrder&&b instanceof createjs.TagLoader&&b.getItem().type==createjs.LoadQueue.JAVASCRIPT){if(this._currentlyLoadingScript)continue;this._currentlyLoadingScript=!0}this._loadQueue.splice(a,1),a--,this._loadItem(b)}}},b._loadItem=function(a){a.on("progress",this._handleProgress,this),a.on("complete",this._handleFileComplete,this),a.on("error",this._handleFileError,this),this._currentLoads.push(a),this._sendFileStart(a.getItem()),a.load()},b._handleFileError=function(a){var b=a.target;this._numItemsLoaded++,this._updateProgress();var c=new createjs.Event("error");c.text="FILE_LOAD_ERROR",c.item=b.getItem(),this._sendError(c),this.stopOnError||(this._removeLoadItem(b),this._loadNext())},b._handleFileComplete=function(a){var b=a.target,c=b.getItem();if(this._loadedResults[c.id]=b.getResult(),b instanceof createjs.XHRLoader&&(this._loadedRawResults[c.id]=b.getResult(!0)),this._removeLoadItem(b),this.maintainScriptOrder&&c.type==createjs.LoadQueue.JAVASCRIPT){if(!(b instanceof createjs.TagLoader))return this._loadedScripts[createjs.indexOf(this._scriptOrder,c)]=c,this._checkScriptLoadOrder(b),void 0;this._currentlyLoadingScript=!1}if(delete c._loadAsJSONP,c.type==createjs.LoadQueue.MANIFEST){var d=b.getResult();null!=d&&void 0!==d.manifest&&this.loadManifest(d,!0)}this._processFinishedLoad(c,b)},b._processFinishedLoad=function(a,b){this._numItemsLoaded++,this._updateProgress(),this._sendFileComplete(a,b),this._loadNext()},b._checkScriptLoadOrder=function(){for(var a=this._loadedScripts.length,b=0;a>b;b++){var c=this._loadedScripts[b];if(null===c)break;if(c!==!0){var d=this._loadedResults[c.id];(document.body||document.getElementsByTagName("body")[0]).appendChild(d),this._processFinishedLoad(c),this._loadedScripts[b]=!0}}},b._removeLoadItem=function(a){for(var b=this._currentLoads.length,c=0;b>c;c++)if(this._currentLoads[c]==a){this._currentLoads.splice(c,1);break}},b._handleProgress=function(a){var b=a.target;this._sendFileProgress(b.getItem(),b.progress),this._updateProgress()},b._updateProgress=function(){var a=this._numItemsLoaded/this._numItems,b=this._numItems-this._numItemsLoaded;if(b>0){for(var c=0,d=0,e=this._currentLoads.length;e>d;d++)c+=this._currentLoads[d].progress;a+=c/b*(b/this._numItems)}this._sendProgress(a)},b._disposeItem=function(a){delete this._loadedResults[a.id],delete this._loadedRawResults[a.id],delete this._loadItemsById[a.id],delete this._loadItemsBySrc[a.src]},b._createTag=function(a){var b=null;switch(a.type){case createjs.LoadQueue.IMAGE:return b=document.createElement("img"),""==this._crossOrigin||this._isLocal(a)||(b.crossOrigin=this._crossOrigin),b;case createjs.LoadQueue.SOUND:return b=document.createElement("audio"),b.autoplay=!1,b;case createjs.LoadQueue.JSON:case createjs.LoadQueue.JSONP:case createjs.LoadQueue.JAVASCRIPT:case createjs.LoadQueue.MANIFEST:return b=document.createElement("script"),b.type="text/javascript",b;case createjs.LoadQueue.CSS:return b=this.useXHR?document.createElement("style"):document.createElement("link"),b.rel="stylesheet",b.type="text/css",b;case createjs.LoadQueue.SVG:return this.useXHR?b=document.createElement("svg"):(b=document.createElement("object"),b.type="image/svg+xml"),b}return null},b._getTypeByExtension=function(a){if(null==a)return createjs.LoadQueue.TEXT;switch(a.toLowerCase()){case"jpeg":case"jpg":case"gif":case"png":case"webp":case"bmp":return createjs.LoadQueue.IMAGE;case"ogg":case"mp3":case"wav":return createjs.LoadQueue.SOUND;case"json":return createjs.LoadQueue.JSON;case"xml":return createjs.LoadQueue.XML;case"css":return createjs.LoadQueue.CSS;case"js":return createjs.LoadQueue.JAVASCRIPT;case"svg":return createjs.LoadQueue.SVG;default:return createjs.LoadQueue.TEXT}},b._sendFileProgress=function(a,b){if(this._isCanceled())return this._cleanUp(),void 0;if(this.hasEventListener("fileprogress")){var c=new createjs.Event("fileprogress");c.progress=b,c.loaded=b,c.total=1,c.item=a,this.dispatchEvent(c)}},b._sendFileComplete=function(a,b){if(!this._isCanceled()){var c=new createjs.Event("fileload");c.loader=b,c.item=a,c.result=this._loadedResults[a.id],c.rawResult=this._loadedRawResults[a.id],a.completeHandler&&a.completeHandler(c),this.hasEventListener("fileload")&&this.dispatchEvent(c)}},b._sendFileStart=function(a){var b=new createjs.Event("filestart");b.item=a,this.hasEventListener("filestart")&&this.dispatchEvent(b)},b.toString=function(){return"[PreloadJS LoadQueue]"},createjs.LoadQueue=a;var d=function(){};d.init=function(){var a=navigator.userAgent;d.isFirefox=a.indexOf("Firefox")>-1,d.isOpera=null!=window.opera,d.isChrome=a.indexOf("Chrome")>-1,d.isIOS=a.indexOf("iPod")>-1||a.indexOf("iPhone")>-1||a.indexOf("iPad")>-1},d.init(),createjs.LoadQueue.BrowserDetect=d}(),function(){"use strict";var a=function(a){this.init(a)},b=a.prototype=new createjs.AbstractLoader;b._loadTimeout=null,b._tagCompleteProxy=null,b._isAudio=!1,b._tag=null,b._jsonResult=null,b.init=function(a){this._item=a,this._tag=a.tag,this._isAudio=window.HTMLAudioElement&&a.tag instanceof window.HTMLAudioElement,this._tagCompleteProxy=createjs.proxy(this._handleLoad,this)},b.getResult=function(){return this._item.type==createjs.LoadQueue.JSONP||this._item.type==createjs.LoadQueue.MANIFEST?this._jsonResult:this._tag},b.cancel=function(){this.canceled=!0,this._clean()},b.load=function(){var a=this._item,b=this._tag;clearTimeout(this._loadTimeout);var c=createjs.LoadQueue.LOAD_TIMEOUT;0==c&&(c=createjs.LoadQueue.loadTimeout),this._loadTimeout=setTimeout(createjs.proxy(this._handleTimeout,this),c),this._isAudio&&(b.src=null,b.preload="auto"),b.onerror=createjs.proxy(this._handleError,this),this._isAudio?(b.onstalled=createjs.proxy(this._handleStalled,this),b.addEventListener("canplaythrough",this._tagCompleteProxy,!1)):(b.onload=createjs.proxy(this._handleLoad,this),b.onreadystatechange=createjs.proxy(this._handleReadyStateChange,this));var d=this.buildPath(a.src,a.values);switch(a.type){case createjs.LoadQueue.CSS:b.href=d;break;case createjs.LoadQueue.SVG:b.data=d;break;default:b.src=d}if(a.type==createjs.LoadQueue.JSONP||a.type==createjs.LoadQueue.JSON||a.type==createjs.LoadQueue.MANIFEST){if(null==a.callback)throw new Error("callback is required for loading JSONP requests.");if(null!=window[a.callback])throw new Error('JSONP callback "'+a.callback+'" already exists on window. You need to specify a different callback. Or re-name the current one.');window[a.callback]=createjs.proxy(this._handleJSONPLoad,this)}(a.type==createjs.LoadQueue.SVG||a.type==createjs.LoadQueue.JSONP||a.type==createjs.LoadQueue.JSON||a.type==createjs.LoadQueue.MANIFEST||a.type==createjs.LoadQueue.JAVASCRIPT||a.type==createjs.LoadQueue.CSS)&&(this._startTagVisibility=b.style.visibility,b.style.visibility="hidden",(document.body||document.getElementsByTagName("body")[0]).appendChild(b)),null!=b.load&&b.load()},b._handleJSONPLoad=function(a){this._jsonResult=a},b._handleTimeout=function(){this._clean();var a=new createjs.Event("error");a.text="PRELOAD_TIMEOUT",this._sendError(a)},b._handleStalled=function(){},b._handleError=function(){this._clean();var a=new createjs.Event("error");this._sendError(a)},b._handleReadyStateChange=function(){clearTimeout(this._loadTimeout);var a=this.getItem().tag;("loaded"==a.readyState||"complete"==a.readyState)&&this._handleLoad()},b._handleLoad=function(){if(!this._isCanceled()){var a=this.getItem(),b=a.tag;if(!(this.loaded||this._isAudio&&4!==b.readyState)){switch(this.loaded=!0,a.type){case createjs.LoadQueue.SVG:case createjs.LoadQueue.JSON:case createjs.LoadQueue.JSONP:case createjs.LoadQueue.MANIFEST:case createjs.LoadQueue.CSS:b.style.visibility=this._startTagVisibility,(document.body||document.getElementsByTagName("body")[0]).removeChild(b)}this._clean(),this._sendComplete()}}},b._clean=function(){clearTimeout(this._loadTimeout);var a=this.getItem(),b=a.tag;null!=b&&(b.onload=null,b.removeEventListener&&b.removeEventListener("canplaythrough",this._tagCompleteProxy,!1),b.onstalled=null,b.onprogress=null,b.onerror=null,null!=b.parentNode&&a.type==createjs.LoadQueue.SVG&&a.type==createjs.LoadQueue.JSON&&a.type==createjs.LoadQueue.MANIFEST&&a.type==createjs.LoadQueue.CSS&&a.type==createjs.LoadQueue.JSONP&&b.parentNode.removeChild(b));var a=this.getItem();(a.type==createjs.LoadQueue.JSONP||a.type==createjs.LoadQueue.MANIFEST)&&(window[a.callback]=null)},b.toString=function(){return"[PreloadJS TagLoader]"},createjs.TagLoader=a}(),function(){"use strict";var a=function(a,b){this.init(a,b)},b=a.prototype=new createjs.AbstractLoader;b._request=null,b._loadTimeout=null,b._xhrLevel=1,b._response=null,b._rawResponse=null,b._crossOrigin="",b.init=function(a,b){this._item=a,this._crossOrigin=b,!this._createXHR(a)},b.getResult=function(a){return a&&this._rawResponse?this._rawResponse:this._response},b.cancel=function(){this.canceled=!0,this._clean(),this._request.abort()},b.load=function(){if(null==this._request)return this._handleError(),void 0;if(this._request.onloadstart=createjs.proxy(this._handleLoadStart,this),this._request.onprogress=createjs.proxy(this._handleProgress,this),this._request.onabort=createjs.proxy(this._handleAbort,this),this._request.onerror=createjs.proxy(this._handleError,this),this._request.ontimeout=createjs.proxy(this._handleTimeout,this),1==this._xhrLevel){var a=createjs.LoadQueue.LOAD_TIMEOUT;if(0==a)a=createjs.LoadQueue.loadTimeout;else try{console.warn("LoadQueue.LOAD_TIMEOUT has been deprecated in favor of LoadQueue.loadTimeout")}catch(b){}this._loadTimeout=setTimeout(createjs.proxy(this._handleTimeout,this),a)}this._request.onload=createjs.proxy(this._handleLoad,this),this._request.onreadystatechange=createjs.proxy(this._handleReadyStateChange,this);try{this._item.values&&this._item.method!=createjs.LoadQueue.GET?this._item.method==createjs.LoadQueue.POST&&this._request.send(this._formatQueryString(this._item.values)):this._request.send()}catch(c){var d=new createjs.Event("error");d.error=c,this._sendError(d)}},b.getAllResponseHeaders=function(){return this._request.getAllResponseHeaders instanceof Function?this._request.getAllResponseHeaders():null},b.getResponseHeader=function(a){return this._request.getResponseHeader instanceof Function?this._request.getResponseHeader(a):null},b._handleProgress=function(a){if(a&&!(a.loaded>0&&0==a.total)){var b=new createjs.Event("progress");b.loaded=a.loaded,b.total=a.total,this._sendProgress(b)}},b._handleLoadStart=function(){clearTimeout(this._loadTimeout),this._sendLoadStart()},b._handleAbort=function(){this._clean();var a=new createjs.Event("error");a.text="XHR_ABORTED",this._sendError(a)},b._handleError=function(){this._clean();var a=new createjs.Event("error");this._sendError(a)},b._handleReadyStateChange=function(){4==this._request.readyState&&this._handleLoad()},b._handleLoad=function(){if(!this.loaded){if(this.loaded=!0,!this._checkError())return this._handleError(),void 0;this._response=this._getResponse(),this._clean();var a=this._generateTag();a&&this._sendComplete()}},b._handleTimeout=function(a){this._clean();var b=new createjs.Event("error");b.text="PRELOAD_TIMEOUT",this._sendError(a)},b._checkError=function(){var a=parseInt(this._request.status);switch(a){case 404:case 0:return!1}return!0},b._getResponse=function(){if(null!=this._response)return this._response;if(null!=this._request.response)return this._request.response;try{if(null!=this._request.responseText)return this._request.responseText}catch(a){}try{if(null!=this._request.responseXML)return this._request.responseXML}catch(a){}return null},b._createXHR=function(a){var b=this._isCrossDomain(a),c=null;if(b&&window.XDomainRequest)c=new XDomainRequest;else if(window.XMLHttpRequest)c=new XMLHttpRequest;else try{c=new ActiveXObject("Msxml2.XMLHTTP.6.0")}catch(d){try{c=new ActiveXObject("Msxml2.XMLHTTP.3.0")}catch(d){try{c=new ActiveXObject("Msxml2.XMLHTTP")}catch(d){return!1}}}createjs.LoadQueue.isText(a.type)&&c.overrideMimeType&&c.overrideMimeType("text/plain; charset=utf-8"),this._xhrLevel="string"==typeof c.responseType?2:1;var e=null;return e=a.method==createjs.LoadQueue.GET?this.buildPath(a.src,a.values):a.src,c.open(a.method||createjs.LoadQueue.GET,e,!0),b&&c instanceof XMLHttpRequest&&1==this._xhrLevel&&c.setRequestHeader("Origin",location.origin),a.values&&a.method==createjs.LoadQueue.POST&&c.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),createjs.LoadQueue.isBinary(a.type)&&(c.responseType="arraybuffer"),this._request=c,!0},b._clean=function(){clearTimeout(this._loadTimeout);var a=this._request;a.onloadstart=null,a.onprogress=null,a.onabort=null,a.onerror=null,a.onload=null,a.ontimeout=null,a.onloadend=null,a.onreadystatechange=null},b._generateTag=function(){var a=this._item.type,b=this._item.tag;switch(a){case createjs.LoadQueue.IMAGE:return b.onload=createjs.proxy(this._handleTagReady,this),""!=this._crossOrigin&&(b.crossOrigin="Anonymous"),b.src=this.buildPath(this._item.src,this._item.values),this._rawResponse=this._response,this._response=b,!1;case createjs.LoadQueue.JAVASCRIPT:return b=document.createElement("script"),b.text=this._response,this._rawResponse=this._response,this._response=b,!0;case createjs.LoadQueue.CSS:var c=document.getElementsByTagName("head")[0];if(c.appendChild(b),b.styleSheet)b.styleSheet.cssText=this._response;else{var d=document.createTextNode(this._response);b.appendChild(d)}return this._rawResponse=this._response,this._response=b,!0;case createjs.LoadQueue.XML:var e=this._parseXML(this._response,"text/xml");return this._rawResponse=this._response,this._response=e,!0;case createjs.LoadQueue.SVG:var e=this._parseXML(this._response,"image/svg+xml");return this._rawResponse=this._response,null!=e.documentElement?(b.appendChild(e.documentElement),this._response=b):this._response=e,!0;case createjs.LoadQueue.JSON:case createjs.LoadQueue.MANIFEST:var f={};try{f=JSON.parse(this._response)}catch(g){f=g}return this._rawResponse=this._response,this._response=f,!0}return!0},b._parseXML=function(a,b){var c=null;try{if(window.DOMParser){var d=new DOMParser;c=d.parseFromString(a,b)}else c=new ActiveXObject("Microsoft.XMLDOM"),c.async=!1,c.loadXML(a)}catch(e){}return c},b._handleTagReady=function(){this._sendComplete()},b.toString=function(){return"[PreloadJS XHRLoader]"},createjs.XHRLoader=a}(),"object"!=typeof JSON&&(JSON={}),function(){"use strict";function f(a){return 10>a?"0"+a:a}function quote(a){return escapable.lastIndex=0,escapable.test(a)?'"'+a.replace(escapable,function(a){var b=meta[a];return"string"==typeof b?b:"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+a+'"'}function str(a,b){var c,d,e,f,g,h=gap,i=b[a];switch(i&&"object"==typeof i&&"function"==typeof i.toJSON&&(i=i.toJSON(a)),"function"==typeof rep&&(i=rep.call(b,a,i)),typeof i){case"string":return quote(i);case"number":return isFinite(i)?String(i):"null";case"boolean":case"null":return String(i);case"object":if(!i)return"null";if(gap+=indent,g=[],"[object Array]"===Object.prototype.toString.apply(i)){for(f=i.length,c=0;f>c;c+=1)g[c]=str(c,i)||"null";return e=0===g.length?"[]":gap?"[\n"+gap+g.join(",\n"+gap)+"\n"+h+"]":"["+g.join(",")+"]",gap=h,e}if(rep&&"object"==typeof rep)for(f=rep.length,c=0;f>c;c+=1)"string"==typeof rep[c]&&(d=rep[c],e=str(d,i),e&&g.push(quote(d)+(gap?": ":":")+e));else for(d in i)Object.prototype.hasOwnProperty.call(i,d)&&(e=str(d,i),e&&g.push(quote(d)+(gap?": ":":")+e));return e=0===g.length?"{}":gap?"{\n"+gap+g.join(",\n"+gap)+"\n"+h+"}":"{"+g.join(",")+"}",gap=h,e}}"function"!=typeof Date.prototype.toJSON&&(Date.prototype.toJSON=function(){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+f(this.getUTCMonth()+1)+"-"+f(this.getUTCDate())+"T"+f(this.getUTCHours())+":"+f(this.getUTCMinutes())+":"+f(this.getUTCSeconds())+"Z":null},String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(){return this.valueOf()});var cx=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,escapable=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,gap,indent,meta={"\b":"\\b","	":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},rep;"function"!=typeof JSON.stringify&&(JSON.stringify=function(a,b,c){var d;if(gap="",indent="","number"==typeof c)for(d=0;c>d;d+=1)indent+=" ";else"string"==typeof c&&(indent=c);if(rep=b,b&&"function"!=typeof b&&("object"!=typeof b||"number"!=typeof b.length))throw new Error("JSON.stringify");return str("",{"":a})}),"function"!=typeof JSON.parse&&(JSON.parse=function(text,reviver){function walk(a,b){var c,d,e=a[b];if(e&&"object"==typeof e)for(c in e)Object.prototype.hasOwnProperty.call(e,c)&&(d=walk(e,c),void 0!==d?e[c]=d:delete e[c]);return reviver.call(a,b,e)}var j;if(text=String(text),cx.lastIndex=0,cx.test(text)&&(text=text.replace(cx,function(a){return"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)})),/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,"@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:\s*\[)+/g,"")))return j=eval("("+text+")"),"function"==typeof reviver?walk({"":j},""):j;throw new SyntaxError("JSON.parse")})}();module.exports=window.createjs;


/***/ },
/* 75 */,
/* 76 */,
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * lscache library
	 * Copyright (c) 2011, Pamela Fox
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *       http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/* jshint undef:true, browser:true, node:true */
	/* global define */
	
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== "undefined" && module.exports) {
	        // CommonJS/Node module
	        module.exports = factory();
	    } else {
	        // Browser globals
	        root.lscache = factory();
	    }
	}(this, function () {
	
	  // Prefix for all lscache keys
	  var CACHE_PREFIX = 'lscache-';
	
	  // Suffix for the key name on the expiration items in localStorage
	  var CACHE_SUFFIX = '-cacheexpiration';
	
	  // expiration date radix (set to Base-36 for most space savings)
	  var EXPIRY_RADIX = 10;
	
	  // time resolution in milliseconds
	  var expiryMilliseconds = 60 * 1000;
	  // ECMAScript max Date (epoch + 1e8 days)
	  var maxDate = calculateMaxDate(expiryMilliseconds);
	
	  var cachedStorage;
	  var cachedJSON;
	  var cacheBucket = '';
	  var warnings = false;
	
	  // Determines if localStorage is supported in the browser;
	  // result is cached for better performance instead of being run each time.
	  // Feature detection is based on how Modernizr does it;
	  // it's not straightforward due to FF4 issues.
	  // It's not run at parse-time as it takes 200ms in Android.
	  function supportsStorage() {
	    var key = '__lscachetest__';
	    var value = key;
	
	    if (cachedStorage !== undefined) {
	      return cachedStorage;
	    }
	
	    // some browsers will throw an error if you try to access local storage (e.g. brave browser)
	    // hence check is inside a try/catch
	    try {
	      if (!localStorage) {
	        return false;
	      }
	    } catch (ex) {
	      return false;
	    }
	
	    try {
	      setItem(key, value);
	      removeItem(key);
	      cachedStorage = true;
	    } catch (e) {
	        // If we hit the limit, and we don't have an empty localStorage then it means we have support
	        if (isOutOfSpace(e) && localStorage.length) {
	            cachedStorage = true; // just maxed it out and even the set test failed.
	        } else {
	            cachedStorage = false;
	        }
	    }
	    return cachedStorage;
	  }
	
	  // Check to set if the error is us dealing with being out of space
	  function isOutOfSpace(e) {
	    return e && (
	      e.name === 'QUOTA_EXCEEDED_ERR' ||
	      e.name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
	      e.name === 'QuotaExceededError'
	    );
	  }
	
	  // Determines if native JSON (de-)serialization is supported in the browser.
	  function supportsJSON() {
	    /*jshint eqnull:true */
	    if (cachedJSON === undefined) {
	      cachedJSON = (window.JSON != null);
	    }
	    return cachedJSON;
	  }
	
	  /**
	   * Returns a string where all RegExp special characters are escaped with a \.
	   * @param {String} text
	   * @return {string}
	   */
	  function escapeRegExpSpecialCharacters(text) {
	    return text.replace(/[[\]{}()*+?.\\^$|]/g, '\\$&');
	  }
	
	  /**
	   * Returns the full string for the localStorage expiration item.
	   * @param {String} key
	   * @return {string}
	   */
	  function expirationKey(key) {
	    return key + CACHE_SUFFIX;
	  }
	
	  /**
	   * Returns the number of minutes since the epoch.
	   * @return {number}
	   */
	  function currentTime() {
	    return Math.floor((new Date().getTime())/expiryMilliseconds);
	  }
	
	  /**
	   * Wrapper functions for localStorage methods
	   */
	
	  function getItem(key) {
	    return localStorage.getItem(CACHE_PREFIX + cacheBucket + key);
	  }
	
	  function setItem(key, value) {
	    // Fix for iPad issue - sometimes throws QUOTA_EXCEEDED_ERR on setItem.
	    localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
	    localStorage.setItem(CACHE_PREFIX + cacheBucket + key, value);
	  }
	
	  function removeItem(key) {
	    localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
	  }
	
	  function eachKey(fn) {
	    var prefixRegExp = new RegExp('^' + CACHE_PREFIX + escapeRegExpSpecialCharacters(cacheBucket) + '(.*)');
	    // We first identify which keys to process
	    var keysToProcess = [];
	    var key, i;
	    for (i = 0; i < localStorage.length; i++) {
	      key = localStorage.key(i);
	      key = key && key.match(prefixRegExp);
	      key = key && key[1];
	      if (key && key.indexOf(CACHE_SUFFIX) < 0) {
	        keysToProcess.push(key);
	      }
	    }
	    // Then we apply the processing function to each key
	    for (i = 0; i < keysToProcess.length; i++) {
	      fn(keysToProcess[i], expirationKey(keysToProcess[i]));
	    }
	  }
	
	  function flushItem(key) {
	    var exprKey = expirationKey(key);
	
	    removeItem(key);
	    removeItem(exprKey);
	  }
	
	  function flushExpiredItem(key) {
	    var exprKey = expirationKey(key);
	    var expr = getItem(exprKey);
	
	    if (expr) {
	      var expirationTime = parseInt(expr, EXPIRY_RADIX);
	
	      // Check if we should actually kick item out of storage
	      if (currentTime() >= expirationTime) {
	        removeItem(key);
	        removeItem(exprKey);
	        return true;
	      }
	    }
	  }
	
	  function warn(message, err) {
	    if (!warnings) return;
	    if (!('console' in window) || typeof window.console.warn !== 'function') return;
	    window.console.warn("lscache - " + message);
	    if (err) window.console.warn("lscache - The error was: " + err.message);
	  }
	
	  function calculateMaxDate(expiryMilliseconds) {
	    return Math.floor(8.64e15/expiryMilliseconds);
	  }
	
	  var lscache = {
	    /**
	     * Stores the value in localStorage. Expires after specified number of minutes.
	     * @param {string} key
	     * @param {Object|string} value
	     * @param {number} time
	     * @return {boolean} whether the value was inserted successfully
	     */
	    set: function(key, value, time) {
	      if (!supportsStorage()) return false;
	
	      // If we don't get a string value, try to stringify
	      // In future, localStorage may properly support storing non-strings
	      // and this can be removed.
	
	      if (!supportsJSON()) return false;
	      try {
	        value = JSON.stringify(value);
	      } catch (e) {
	        // Sometimes we can't stringify due to circular refs
	        // in complex objects, so we won't bother storing then.
	        return false;
	      }
	
	      try {
	        setItem(key, value);
	      } catch (e) {
	        if (isOutOfSpace(e)) {
	          // If we exceeded the quota, then we will sort
	          // by the expire time, and then remove the N oldest
	          var storedKeys = [];
	          var storedKey;
	          eachKey(function(key, exprKey) {
	            var expiration = getItem(exprKey);
	            if (expiration) {
	              expiration = parseInt(expiration, EXPIRY_RADIX);
	            } else {
	              // TODO: Store date added for non-expiring items for smarter removal
	              expiration = maxDate;
	            }
	            storedKeys.push({
	              key: key,
	              size: (getItem(key) || '').length,
	              expiration: expiration
	            });
	          });
	          // Sorts the keys with oldest expiration time last
	          storedKeys.sort(function(a, b) { return (b.expiration-a.expiration); });
	
	          var targetSize = (value||'').length;
	          while (storedKeys.length && targetSize > 0) {
	            storedKey = storedKeys.pop();
	            warn("Cache is full, removing item with key '" + storedKey.key + "'");
	            flushItem(storedKey.key);
	            targetSize -= storedKey.size;
	          }
	          try {
	            setItem(key, value);
	          } catch (e) {
	            // value may be larger than total quota
	            warn("Could not add item with key '" + key + "', perhaps it's too big?", e);
	            return false;
	          }
	        } else {
	          // If it was some other error, just give up.
	          warn("Could not add item with key '" + key + "'", e);
	          return false;
	        }
	      }
	
	      // If a time is specified, store expiration info in localStorage
	      if (time) {
	        setItem(expirationKey(key), (currentTime() + time).toString(EXPIRY_RADIX));
	      } else {
	        // In case they previously set a time, remove that info from localStorage.
	        removeItem(expirationKey(key));
	      }
	      return true;
	    },
	
	    /**
	     * Retrieves specified value from localStorage, if not expired.
	     * @param {string} key
	     * @return {string|Object}
	     */
	    get: function(key) {
	      if (!supportsStorage()) return null;
	
	      // Return the de-serialized item if not expired
	      if (flushExpiredItem(key)) { return null; }
	
	      // Tries to de-serialize stored value if its an object, and returns the normal value otherwise.
	      var value = getItem(key);
	      if (!value || !supportsJSON()) {
	        return value;
	      }
	
	      try {
	        // We can't tell if its JSON or a string, so we try to parse
	        return JSON.parse(value);
	      } catch (e) {
	        // If we can't parse, it's probably because it isn't an object
	        return value;
	      }
	    },
	
	    /**
	     * Removes a value from localStorage.
	     * Equivalent to 'delete' in memcache, but that's a keyword in JS.
	     * @param {string} key
	     */
	    remove: function(key) {
	      if (!supportsStorage()) return;
	
	      flushItem(key);
	    },
	
	    /**
	     * Returns whether local storage is supported.
	     * Currently exposed for testing purposes.
	     * @return {boolean}
	     */
	    supported: function() {
	      return supportsStorage();
	    },
	
	    /**
	     * Flushes all lscache items and expiry markers without affecting rest of localStorage
	     */
	    flush: function() {
	      if (!supportsStorage()) return;
	
	      eachKey(function(key) {
	        flushItem(key);
	      });
	    },
	
	    /**
	     * Flushes expired lscache items and expiry markers without affecting rest of localStorage
	     */
	    flushExpired: function() {
	      if (!supportsStorage()) return;
	
	      eachKey(function(key) {
	        flushExpiredItem(key);
	      });
	    },
	
	    /**
	     * Appends CACHE_PREFIX so lscache will partition data in to different buckets.
	     * @param {string} bucket
	     */
	    setBucket: function(bucket) {
	      cacheBucket = bucket;
	    },
	
	    /**
	     * Resets the string being appended to CACHE_PREFIX so lscache will use the default storage behavior.
	     */
	    resetBucket: function() {
	      cacheBucket = '';
	    },
	
	    /**
	     * @returns {number} The currently set number of milliseconds each time unit represents in
	     *   the set() function's "time" argument.
	     */
	    getExpiryMilliseconds: function() {
	      return expiryMilliseconds;
	    },
	
	    /**
	     * Sets the number of milliseconds each time unit represents in the set() function's
	     *   "time" argument.
	     * Sample values:
	     *  1: each time unit = 1 millisecond
	     *  1000: each time unit = 1 second
	     *  60000: each time unit = 1 minute (Default value)
	     *  360000: each time unit = 1 hour
	     * @param {number} milliseconds
	     */
	    setExpiryMilliseconds: function(milliseconds) {
	        expiryMilliseconds = milliseconds;
	        maxDate = calculateMaxDate(expiryMilliseconds);
	    },
	
	    /**
	     * Sets whether to display warnings when an item is removed from the cache or not.
	     */
	    enableWarnings: function(enabled) {
	      warnings = enabled;
	    }
	  };
	
	  // Return the module
	  return lscache;
	}));


/***/ },
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	
	var _ = __webpack_require__(1);
	var Backbone = __webpack_require__(4);
	
	var FilteredCollection = __webpack_require__(1589);
	var SortedCollection = __webpack_require__(1592);
	var PaginatedCollection = __webpack_require__(1591);
	var proxyCollection = __webpack_require__(917);
	var proxyEvents = __webpack_require__(1596);
	
	function Obscura(superset, options) {
	  this._superset = superset;
	
	  this._filtered = new FilteredCollection(superset, options);
	  this._sorted = new SortedCollection(this._filtered, options);
	  this._paginated = new PaginatedCollection(this._sorted, options);
	
	  proxyCollection(this._paginated, this);
	  proxyEvents.call(this, this._filtered, filteredEvents);
	  proxyEvents.call(this, this._sorted, sortedEvents);
	  proxyEvents.call(this, this._paginated, paginatedEvents);
	  this.initialize(options);
	}
	
	var methods = {
	
	  superset: function() {
	    return this._superset;
	  },
	
	  getFilteredLength: function() {
	    return this._filtered.length;
	  },
	
	  removeTransforms: function() {
	    this._filtered.resetFilters();
	    this._sorted.removeSort();
	    this._paginated.removePagination();
	    return this;
	  },
	
	  destroy: function() {
	    this.stopListening();
	    this._filtered.destroy();
	    this._sorted.destroy();
	    this._paginated.destroy();
	    this.length = 0;
	
	    this.trigger('obscura:destroy');
	  }
	
	};
	
	// Methods on `this._filtered` we will expose to the outside world
	var filteredMethods = [
	  'filterBy', 'removeFilter', 'resetFilters', 'refilter', 'hasFilter',
	  'getFilters'
	];
	
	// Events fired from `this._filtered` that we will forward
	var filteredEvents = [
	  'filtered:add', 'filtered:remove', 'filtered:reset'
	];
	
	// Methods on `this._sorted` we will expose to the outside world
	var sortedMethods = [ 'setSort', 'reverseSort', 'removeSort' ];
	
	// Events fired from `this._sorted` that we will forward
	var sortedEvents = [
	  'sorted:add', 'sorted:remove'
	];
	
	// Methods on `this._paginated` we will expose to the outside world
	var paginatedMethods = [
	  'setPerPage', 'setPage', 'getPerPage', 'getNumPages', 'getPage',
	  'hasNextPage', 'hasPrevPage', 'nextPage', 'prevPage', 'movePage',
	  'removePagination', 'firstPage', 'lastPage'
	];
	
	// Events fired from `this._paginated` that we will forward
	var paginatedEvents = [
	  'paginated:change:perPage', 'paginated:change:page', 'paginated:change:numPages'
	];
	
	var unsupportedMethods = [
	  'add', 'create', 'remove', 'set', 'reset', 'sort', 'parse',
	  'sync', 'fetch', 'push', 'pop', 'shift', 'unshift'
	];
	
	// Extend obscura with each of the above methods, passing the call to the underlying
	// collection.
	//
	// The return value is checked because some of the methods return `this` to allow
	// chaining, and returning the internal collection would break the abstraction. In
	// the cases where it would return the internal collection, we can return a reference
	// to the Obscura proxy, which gives it the expected behavior.
	
	_.each(filteredMethods, function(method) {
	  methods[method] = function() {
	    var result = FilteredCollection.prototype[method].apply(this._filtered, arguments);
	    return result === this._filtered ? this : result;
	  };
	});
	
	_.each(paginatedMethods, function(method) {
	  methods[method] = function() {
	    var result = PaginatedCollection.prototype[method].apply(this._paginated, arguments);
	    return result === this._paginated ? this : result;
	  };
	});
	
	_.each(sortedMethods, function(method) {
	  methods[method] = function() {
	    var result = SortedCollection.prototype[method].apply(this._sorted, arguments);
	    return result === this._sorted ? this : result;
	  };
	});
	
	_.each(unsupportedMethods, function(method) {
	  methods[method] = function() {
	    throw new Error("Backbone.Obscura: Unsupported method: " + method + 'called on read-only proxy');
	  };
	});
	
	_.extend(Obscura.prototype, methods, Backbone.Events);
	
	// Now that we've over-written all of the backbone collection methods, we can safely
	// inherit from backbone's Collection
	Obscura = Backbone.Collection.extend(Obscura.prototype);
	
	// Expose the other proxy types so that the user can use them on their own if they want
	Obscura.FilteredCollection = FilteredCollection;
	Obscura.SortedCollection = SortedCollection;
	Obscura.PaginatedCollection = PaginatedCollection;
	
	module.exports = Obscura;
	


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	  backgrid-moment-cell
	  http://github.com/wyuenho/backgrid
	
	  Copyright (c) 2013 Jimmy Yuen Ho Wong and contributors
	  Licensed under the MIT @license.
	*/
	(function (root, factory) {
	
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(58), __webpack_require__(30)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // CommonJS
	    module.exports = factory(require("underscore"), require("backgrid"),
	                             require("moment"));
	  } else {
	    // Browser globals
	    factory(root._, root.Backgrid, root.moment);
	  }
	
	}(this, function (_, Backgrid, moment) {
	
	  "use strict";
	
	  var exports = {};
	
	  /**
	     MomentFormatter converts bi-directionally any datetime values in any format
	     supported by [moment()](http://momentjs.com/docs/#/parsing/) to any
	     datetime format
	     [moment.fn.format()](http://momentjs.com/docs/#/displaying/format/)
	     supports.
	
	     @class Backgrid.Extension.MomentFormatter
	     @extends Backgrid.CellFormatter
	     @constructor
	   */
	  var MomentFormatter = exports.MomentFormatter = Backgrid.Extension.MomentFormatter = function (options) {
	      _.extend(this, this.defaults, options);
	  };
	  var useLocale = "locale" in moment && _.isFunction(moment, "locale");
	  MomentFormatter.prototype = new Backgrid.CellFormatter;
	  _.extend(MomentFormatter.prototype, {
	
	    /**
	       @cfg {Object} options
	
	       @cfg {boolean} [options.modelInUnixOffset=false] Whether the model values
	       should be read/written as the number of milliseconds since UNIX Epoch.
	
	       @cfg {boolean} [options.modelInUnixTimestamp=false] Whether the model
	       values should be read/written as the number of seconds since UNIX Epoch.
	
	       @cfg {boolean} [options.modelInUTC=true] Whether the model values should
	       be read/written in UTC mode or local mode.
	
	       @cfg {string} [options.modelLang=moment.locale() moment>=2.8.0 |
	       moment.lang() moment<2.8.0] The locale the model values should be
	       read/written in.
	
	       @cfg {string} [options.modelFormat=moment.defaultFormat] The format this
	       moment formatter should use to read/write model values. Only meaningful if
	       the values are strings.
	
	       @cfg {boolean} [options.displayInUnixOffset=false] Whether the display
	       values should be read/written as the number of milliseconds since UNIX
	       Epoch.
	
	       @cfg {boolean} [options.displayInUnixTimestamp=false] Whether the display
	       values should be read/written as the number of seconds since UNIX Epoch.
	
	       @cfg {boolean} [options.displayInUTC=true] Whether the display values
	       should be read/written in UTC mode or local mode.
	
	       @cfg {string} [options.displayLang=moment.locale() moment>=2.8.0 |
	       moment.lang() moment<2.8.0] The locale the display values should be
	       read/written in.
	
	       @cfg {string} [options.displayFormat=moment.defaultFormat] The format
	       this moment formatter should use to read/write dislay values.
	     */
	    defaults: {
	      modelInUnixOffset: false,
	      modelInUnixTimestamp: false,
	      modelInUTC: true,
	      modelLang: useLocale ? moment.locale() : moment.lang(),
	      modelFormat: moment.defaultFormat,
	      displayInUnixOffset: false,
	      displayInUnixTimestamp: false,
	      displayInUTC: true,
	      displayLang: useLocale ? moment.locale() : moment.lang(),
	      displayFormat: moment.defaultFormat
	    },
	
	    /**
	       Converts datetime values from the model for display.
	
	       @member Backgrid.Extension.MomentFormatter
	       @param {*} rawData
	       @return {string}
	     */
	    fromRaw: function (rawData) {
	      if (rawData == null) return '';
	
	      var m = this.modelInUnixOffset ? moment(rawData) :
	        this.modelInUnixTimestamp ? moment.unix(rawData) :
	        this.modelInUTC ?
	        moment.utc(rawData, this.modelFormat, this.modelLang) :
	        moment(rawData, this.modelFormat, this.modelLang);
	
	      if (this.displayInUnixOffset) return +m;
	
	      if (this.displayInUnixTimestamp) return m.unix();
	
	      if (this.displayLang) {
	        if (useLocale) m.locale(this.displayLang); else m.lang(this.displayLang);
	      }
	
	      if (this.displayInUTC) m.utc(); else m.local();
	
	      return m.format(this.displayFormat);
	    },
	
	    /**
	       Converts datetime values from user input to model values.
	
	       @member Backgrid.Extension.MomentFormatter
	       @param {string} formattedData
	       @return {string}
	     */
	    toRaw: function (formattedData) {
	
	      var m = this.displayInUnixOffset ? moment(+formattedData) :
	        this.displayInUnixTimestamp ? moment.unix(+formattedData) :
	        this.displayInUTC ?
	        moment.utc(formattedData, this.displayFormat, this.displayLang) :
	        moment(formattedData, this.displayFormat, this.displayLang);
	
	      if (!m || !m.isValid()) return;
	
	      if (this.modelInUnixOffset) return +m;
	
	      if (this.modelInUnixTimestamp) return m.unix();
	
	      if (this.modelLang) {
	        if (useLocale) m.locale(this.modelLang); else m.lang(this.modelLang);
	      }
	
	      if (this.modelInUTC) m.utc(); else m.local();
	
	      return m.format(this.modelFormat);
	    }
	
	  });
	
	  /**
	     Renders a datetime cell that uses a Backgrid.Extension.MomentFormatter to
	     convert and validate values.
	
	     @class Backgrid.Extension.MomentCell
	     @extends Backgrid.Cell
	   */
	  var MomentCell = exports.MomentCell = Backgrid.Extension.MomentCell = Backgrid.Cell.extend({
	
	    editor: Backgrid.InputCellEditor,
	
	    /** @property */
	    className: "moment-cell",
	
	    /** @property {Backgrid.CellFormatter} [formatter=Backgrid.Extension.MomentFormatter] */
	    formatter: MomentFormatter,
	
	    /**
	       Initializer. Accept Backgrid.Extension.MomentFormatter.options and
	       Backgrid.Cell.initialize required parameters.
	     */
	    initialize: function (options) {
	
	      MomentCell.__super__.initialize.apply(this, arguments);
	
	      var formatterDefaults = MomentFormatter.prototype.defaults;
	      var formatterDefaultKeys = _.keys(formatterDefaults);
	      var classAttrs = _.pick(this, formatterDefaultKeys);
	      var formatterOptions = _.pick(options, formatterDefaultKeys);
	
	      // Priority of the options for the formatter, from highest to lowerest
	      // 1. MomentCell instance options
	      // 2. MomentCell class attributes
	      // 3. MomentFormatter defaults
	
	      // this.formatter will have been instantiated now
	      _.extend(this.formatter, formatterDefaults, classAttrs, formatterOptions);
	
	      this.editor = this.editor.extend({
	        attributes: _.extend({}, this.editor.prototype.attributes || this.editor.attributes || {}, {
	          placeholder: this.formatter.displayFormat
	        })
	      });
	    }
	
	  });
	
	  _.extend(MomentCell.prototype, MomentFormatter.prototype.defaults);
	
	  return exports;
	
	}));


/***/ },
/* 105 */
[1960, 1514, 1800],
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 2.0.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        global.numeral = factory();
	    }
	}(this, function () {
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        _,
	        VERSION = '2.0.6',
	        formats = {},
	        locales = {},
	        defaults = {
	            currentLocale: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0',
	            scalePercentBy100: true
	        },
	        options = {
	            currentLocale: defaults.currentLocale,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat,
	            scalePercentBy100: defaults.scalePercentBy100
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(input, number) {
	        this._input = input;
	
	        this._value = number;
	    }
	
	    numeral = function(input) {
	        var value,
	            kind,
	            unformatFunction,
	            regexp;
	
	        if (numeral.isNumeral(input)) {
	            value = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            value = 0;
	        } else if (input === null || _.isNaN(input)) {
	            value = null;
	        } else if (typeof input === 'string') {
	            if (options.zeroFormat && input === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                for (kind in formats) {
	                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
	
	                    if (regexp && input.match(regexp)) {
	                        unformatFunction = formats[kind].unformat;
	
	                        break;
	                    }
	                }
	
	                unformatFunction = unformatFunction || numeral._.stringToNumber;
	
	                value = unformatFunction(input);
	            }
	        } else {
	            value = Number(input)|| null;
	        }
	
	        return new Numeral(input, value);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	    // helper functions
	    numeral._ = _ = {
	        // formats numbers separators, decimals places, signs, abbreviations
	        numberToFormat: function(value, format, roundingFunction) {
	            var locale = locales[numeral.options.currentLocale],
	                negP = false,
	                optDec = false,
	                leadingCount = 0,
	                abbr = '',
	                trillion = 1000000000000,
	                billion = 1000000000,
	                million = 1000000,
	                thousand = 1000,
	                decimal = '',
	                neg = false,
	                abbrForce, // force abbreviation
	                abs,
	                min,
	                max,
	                power,
	                int,
	                precision,
	                signed,
	                thousands,
	                output;
	
	            // make sure we never format a null value
	            value = value || 0;
	
	            abs = Math.abs(value);
	
	            // see if we should use parentheses for negative number or if we should prefix with a sign
	            // if both are present we default to parentheses
	            if (numeral._.includes(format, '(')) {
	                negP = true;
	                format = format.replace(/[\(|\)]/g, '');
	            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
	                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
	                format = format.replace(/[\+|\-]/g, '');
	            }
	
	            // see if abbreviation is wanted
	            if (numeral._.includes(format, 'a')) {
	                abbrForce = format.match(/a(k|m|b|t)?/);
	
	                abbrForce = abbrForce ? abbrForce[1] : false;
	
	                // check for space before abbreviation
	                if (numeral._.includes(format, ' a')) {
	                    abbr = ' ';
	                }
	
	                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
	
	                if (abs >= trillion && !abbrForce || abbrForce === 't') {
	                    // trillion
	                    abbr += locale.abbreviations.trillion;
	                    value = value / trillion;
	                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
	                    // billion
	                    abbr += locale.abbreviations.billion;
	                    value = value / billion;
	                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
	                    // million
	                    abbr += locale.abbreviations.million;
	                    value = value / million;
	                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
	                    // thousand
	                    abbr += locale.abbreviations.thousand;
	                    value = value / thousand;
	                }
	            }
	
	            // check for optional decimals
	            if (numeral._.includes(format, '[.]')) {
	                optDec = true;
	                format = format.replace('[.]', '.');
	            }
	
	            // break number and format
	            int = value.toString().split('.')[0];
	            precision = format.split('.')[1];
	            thousands = format.indexOf(',');
	            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
	
	            if (precision) {
	                if (numeral._.includes(precision, '[')) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	                } else {
	                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
	                }
	
	                int = decimal.split('.')[0];
	
	                if (numeral._.includes(decimal, '.')) {
	                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
	                } else {
	                    decimal = '';
	                }
	
	                if (optDec && Number(decimal.slice(1)) === 0) {
	                    decimal = '';
	                }
	            } else {
	                int = numeral._.toFixed(value, 0, roundingFunction);
	            }
	
	            // check abbreviation again after rounding
	            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
	                int = String(Number(int) / 1000);
	
	                switch (abbr) {
	                    case locale.abbreviations.thousand:
	                        abbr = locale.abbreviations.million;
	                        break;
	                    case locale.abbreviations.million:
	                        abbr = locale.abbreviations.billion;
	                        break;
	                    case locale.abbreviations.billion:
	                        abbr = locale.abbreviations.trillion;
	                        break;
	                }
	            }
	
	
	            // format number
	            if (numeral._.includes(int, '-')) {
	                int = int.slice(1);
	                neg = true;
	            }
	
	            if (int.length < leadingCount) {
	                for (var i = leadingCount - int.length; i > 0; i--) {
	                    int = '0' + int;
	                }
	            }
	
	            if (thousands > -1) {
	                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
	            }
	
	            if (format.indexOf('.') === 0) {
	                int = '';
	            }
	
	            output = int + decimal + (abbr ? abbr : '');
	
	            if (negP) {
	                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
	            } else {
	                if (signed >= 0) {
	                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
	                } else if (neg) {
	                    output = '-' + output;
	                }
	            }
	
	            return output;
	        },
	        // unformats numbers separators, decimals places, signs, abbreviations
	        stringToNumber: function(string) {
	            var locale = locales[options.currentLocale],
	                stringOriginal = string,
	                abbreviations = {
	                    thousand: 3,
	                    million: 6,
	                    billion: 9,
	                    trillion: 12
	                },
	                abbreviation,
	                value,
	                i,
	                regexp;
	
	            if (options.zeroFormat && string === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                value = 1;
	
	                if (locale.delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
	                }
	
	                for (abbreviation in abbreviations) {
	                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
	
	                    if (stringOriginal.match(regexp)) {
	                        value *= Math.pow(10, abbreviations[abbreviation]);
	                        break;
	                    }
	                }
	
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	
	                // remove non numbers
	                string = string.replace(/[^0-9\.]+/g, '');
	
	                value *= Number(string);
	            }
	
	            return value;
	        },
	        isNaN: function(value) {
	            return typeof value === 'number' && isNaN(value);
	        },
	        includes: function(string, search) {
	            return string.indexOf(search) !== -1;
	        },
	        insert: function(string, subString, start) {
	            return string.slice(0, start) + subString + string.slice(start);
	        },
	        reduce: function(array, callback /*, initialValue*/) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(array),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 3) {
	                value = arguments[2];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        },
	        /**
	         * Computes the multiplier necessary to make x >= 1,
	         * effectively eliminating miscalculations caused by
	         * finite precision.
	         */
	        multiplier: function (x) {
	            var parts = x.toString().split('.');
	
	            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
	        },
	        /**
	         * Given a variable number of arguments, returns the maximum
	         * multiplier that must be used to normalize an operation involving
	         * all of them.
	         */
	        correctionFactor: function () {
	            var args = Array.prototype.slice.call(arguments);
	
	            return args.reduce(function(accum, next) {
	                var mn = _.multiplier(next);
	                return accum > mn ? accum : mn;
	            }, 1);
	        },
	        /**
	         * Implementation of toFixed() that treats floats more like decimals
	         *
	         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	         * problems for accounting- and finance-related software.
	         */
	        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
	            var splitValue = value.toString().split('.'),
	                minDecimals = maxDecimals - (optionals || 0),
	                boundedPrecision,
	                optionalsRegExp,
	                power,
	                output;
	
	            // Use the smallest precision value possible to avoid errors from floating point representation
	            if (splitValue.length === 2) {
	              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	            } else {
	              boundedPrecision = minDecimals;
	            }
	
	            power = Math.pow(10, boundedPrecision);
	
	            // Multiply up by precision, round accurately, then divide and use native toFixed():
	            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
	
	            if (optionals > maxDecimals - boundedPrecision) {
	                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	                output = output.replace(optionalsRegExp, '');
	            }
	
	            return output;
	        }
	    };
	
	    // avaliable options
	    numeral.options = options;
	
	    // avaliable formats
	    numeral.formats = formats;
	
	    // avaliable formats
	    numeral.locales = locales;
	
	    // This function sets the current locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    numeral.locale = function(key) {
	        if (key) {
	            options.currentLocale = key.toLowerCase();
	        }
	
	        return options.currentLocale;
	    };
	
	    // This function provides access to the loaded locale data.  If
	    // no arguments are passed in, it will simply return the current
	    // global locale object.
	    numeral.localeData = function(key) {
	        if (!key) {
	            return locales[options.currentLocale];
	        }
	
	        key = key.toLowerCase();
	
	        if (!locales[key]) {
	            throw new Error('Unknown locale : ' + key);
	        }
	
	        return locales[key];
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.register = function(type, name, format) {
	        name = name.toLowerCase();
	
	        if (this[type + 's'][name]) {
	            throw new TypeError(name + ' ' + type + ' already registered.');
	        }
	
	        this[type + 's'][name] = format;
	
	        return format;
	    };
	
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            localeData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.localeData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current locale
	            localeData = numeral.localeData(culture);
	        } catch (e) {
	            localeData = numeral.localeData(numeral.locale());
	        }
	
	        //setup the delimiters and currency symbol based on culture/locale
	        _currSymbol = localeData.currency.symbol;
	        _abbrObj = localeData.abbreviations;
	        _decimalSep = localeData.delimiters.decimal;
	        if (localeData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = localeData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    numeral.fn = Numeral.prototype = {
	        clone: function() {
	            return numeral(this);
	        },
	        format: function(inputString, roundingFunction) {
	            var value = this._value,
	                format = inputString || options.defaultFormat,
	                kind,
	                output,
	                formatFunction;
	
	            // make sure we have a roundingFunction
	            roundingFunction = roundingFunction || Math.round;
	
	            // format based on value
	            if (value === 0 && options.zeroFormat !== null) {
	                output = options.zeroFormat;
	            } else if (value === null && options.nullFormat !== null) {
	                output = options.nullFormat;
	            } else {
	                for (kind in formats) {
	                    if (format.match(formats[kind].regexps.format)) {
	                        formatFunction = formats[kind].format;
	
	                        break;
	                    }
	                }
	
	                formatFunction = formatFunction || numeral._.numberToFormat;
	
	                output = formatFunction(value, format, roundingFunction);
	            }
	
	            return output;
	        },
	        value: function() {
	            return this._value;
	        },
	        input: function() {
	            return this._input;
	        },
	        set: function(value) {
	            this._value = Number(value);
	
	            return this;
	        },
	        add: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
	
	            return this;
	        },
	        subtract: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
	
	            return this;
	        },
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 1);
	
	            return this;
	        },
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback);
	
	            return this;
	        },
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	    };
	
	    /************************************
	        Default Locale && Format
	    ************************************/
	
	    numeral.register('locale', 'en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    
	
	(function() {
	        numeral.register('format', 'bps', {
	            regexps: {
	                format: /(BPS)/,
	                unformat: /(BPS)/
	            },
	            format: function(value, format, roundingFunction) {
	                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
	                    output;
	
	                value = value * 10000;
	
	                // check for space before BPS
	                format = format.replace(/\s?BPS/, '');
	
	                output = numeral._.numberToFormat(value, format, roundingFunction);
	
	                if (numeral._.includes(output, ')')) {
	                    output = output.split('');
	
	                    output.splice(-1, 0, space + 'BPS');
	
	                    output = output.join('');
	                } else {
	                    output = output + space + 'BPS';
	                }
	
	                return output;
	            },
	            unformat: function(string) {
	                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
	            }
	        });
	})();
	
	
	(function() {
	        var decimal = {
	            base: 1000,
	            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	        },
	        binary = {
	            base: 1024,
	            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
	            return decimal.suffixes.indexOf(item) < 0;
	        }));
	        var unformatRegex = allSuffixes.join('|');
	        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
	        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
	
	    numeral.register('format', 'bytes', {
	        regexps: {
	            format: /([0\s]i?b)/,
	            unformat: new RegExp(unformatRegex)
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
	                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
	                power,
	                min,
	                max;
	
	            // check for space before
	            format = format.replace(/\s?i?b/, '');
	
	            for (power = 0; power <= bytes.suffixes.length; power++) {
	                min = Math.pow(bytes.base, power);
	                max = Math.pow(bytes.base, power + 1);
	
	                if (value === null || value === 0 || value >= min && value < max) {
	                    suffix += bytes.suffixes[power];
	
	                    if (min > 0) {
	                        value = value / min;
	                    }
	
	                    break;
	                }
	            }
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + suffix;
	        },
	        unformat: function(string) {
	            var value = numeral._.stringToNumber(string),
	                power,
	                bytesMultiplier;
	
	            if (value) {
	                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
	                    if (numeral._.includes(string, decimal.suffixes[power])) {
	                        bytesMultiplier = Math.pow(decimal.base, power);
	
	                        break;
	                    }
	
	                    if (numeral._.includes(string, binary.suffixes[power])) {
	                        bytesMultiplier = Math.pow(binary.base, power);
	
	                        break;
	                    }
	                }
	
	                value *= (bytesMultiplier || 1);
	            }
	
	            return value;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'currency', {
	        regexps: {
	            format: /(\$)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                symbols = {
	                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
	                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
	                },
	                output,
	                symbol,
	                i;
	
	            // strip format of spaces and $
	            format = format.replace(/\s?\$\s?/, '');
	
	            // format the number
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            // update the before and after based on value
	            if (value >= 0) {
	                symbols.before = symbols.before.replace(/[\-\(]/, '');
	                symbols.after = symbols.after.replace(/[\-\)]/, '');
	            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
	                symbols.before = '-' + symbols.before;
	            }
	
	            // loop through each before symbol
	            for (i = 0; i < symbols.before.length; i++) {
	                symbol = symbols.before[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = numeral._.insert(output, locale.currency.symbol, i);
	                        break;
	                    case ' ':
	                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
	                        break;
	                }
	            }
	
	            // loop through each after symbol
	            for (i = symbols.after.length - 1; i >= 0; i--) {
	                symbol = symbols.after[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
	                        break;
	                    case ' ':
	                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
	                        break;
	                }
	            }
	
	
	            return output;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'exponential', {
	        regexps: {
	            format: /(e\+|e-)/,
	            unformat: /(e\+|e-)/
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
	                parts = exponential.split('e');
	
	            format = format.replace(/e[\+|\-]{1}0/, '');
	
	            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
	
	            return output + 'e' + parts[1];
	        },
	        unformat: function(string) {
	            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
	                value = Number(parts[0]),
	                power = Number(parts[1]);
	
	            power = numeral._.includes(string, 'e-') ? power *= -1 : power;
	
	            function cback(accum, curr, currI, O) {
	                var corrFactor = numeral._.correctionFactor(accum, curr),
	                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
	                return num;
	            }
	
	            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'ordinal', {
	        regexps: {
	            format: /(o)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                output,
	                ordinal = numeral._.includes(format, ' o') ? ' ' : '';
	
	            // check for space before
	            format = format.replace(/\s?o/, '');
	
	            ordinal += locale.ordinal(value);
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + ordinal;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'percentage', {
	        regexps: {
	            format: /(%)/,
	            unformat: /(%)/
	        },
	        format: function(value, format, roundingFunction) {
	            var space = numeral._.includes(format, ' %') ? ' ' : '',
	                output;
	
	            if (numeral.options.scalePercentBy100) {
	                value = value * 100;
	            }
	
	            // check for space before %
	            format = format.replace(/\s?\%/, '');
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            if (numeral._.includes(output, ')')) {
	                output = output.split('');
	
	                output.splice(-1, 0, space + '%');
	
	                output = output.join('');
	            } else {
	                output = output + space + '%';
	            }
	
	            return output;
	        },
	        unformat: function(string) {
	            var number = numeral._.stringToNumber(string);
	            if (numeral.options.scalePercentBy100) {
	                return number * 0.01;
	            }
	            return number;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'time', {
	        regexps: {
	            format: /(:)/,
	            unformat: /(:)/
	        },
	        format: function(value, format, roundingFunction) {
	            var hours = Math.floor(value / 60 / 60),
	                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
	                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));
	
	            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	        },
	        unformat: function(string) {
	            var timeArray = string.split(':'),
	                seconds = 0;
	
	            // turn hours and minutes into seconds and add them all up
	            if (timeArray.length === 3) {
	                // hours
	                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	                // minutes
	                seconds = seconds + (Number(timeArray[1]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[2]);
	            } else if (timeArray.length === 2) {
	                // minutes
	                seconds = seconds + (Number(timeArray[0]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[1]);
	            }
	            return Number(seconds);
	        }
	    });
	})();
	
	return numeral;
	}));


/***/ },
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/*
	  backgrid-paginator
	  http://github.com/wyuenho/backgrid
	
	  Copyright (c) 2013 Jimmy Yuen Ho Wong and contributors
	  Licensed under the MIT @license.
	*/
	(function (root, factory) {
	
	  // CommonJS
	  if (true) {
	    module.exports = factory(__webpack_require__(7),
	                             __webpack_require__(16),
	                             __webpack_require__(58),
	                             __webpack_require__(1511));
	  }
	  // AMD. Register as an anonymous module.
	  else if (typeof define == "function" && define.amd) {
	    define(["underscore", "backbone", "backgrid", "backbone.paginator"], factory);
	  }
	  // Browser
	  else {
	    factory(root._, root.Backbone, root.Backgrid);
	  }
	
	}(this, function (_, Backbone, Backgrid) {
	
	  "use strict";
	
	  /**
	     PageHandle is a class that renders the actual page handles and reacts to
	     click events for pagination.
	
	     This class acts in two modes - control or discrete page handle modes. If
	     one of the `is*` flags is `true`, an instance of this class is under
	     control page handle mode. Setting a `pageIndex` to an instance of this
	     class under control mode has no effect and the correct page index will
	     always be inferred from the `is*` flag. Only one of the `is*` flags should
	     be set to `true` at a time. For example, an instance of this class cannot
	     simultaneously be a rewind control and a fast forward control. A `label`
	     and a `title` function or a string are required to be passed to the
	     constuctor under this mode. If a `title` function is provided, it __MUST__
	     accept a hash parameter `data`, which contains a key `label`. Its result
	     will be used to render the generated anchor's title attribute.
	
	     If all of the `is*` flags is set to `false`, which is the default, an
	     instance of this class will be in discrete page handle mode. An instance
	     under this mode requires the `pageIndex` to be passed from the constructor
	     as an option and it __MUST__ be a 0-based index of the list of page numbers
	     to render. The constuctor will normalize the base to the same base the
	     underlying PageableCollection collection instance uses. A `label` is not
	     required under this mode, which will default to the equivalent 1-based page
	     index calculated from `pageIndex` and the underlying PageableCollection
	     instance. A provided `label` will still be honored however. The `title`
	     parameter is also not required under this mode, in which case the default
	     `title` function will be used. You are encouraged to provide your own
	     `title` function however if you wish to localize the title strings.
	
	     If this page handle represents the current page, an `active` class will be
	     placed on the root list element.
	
	     If this page handle is at the border of the list of pages, a `disabled`
	     class will be placed on the root list element.
	
	     Only page handles that are neither `active` nor `disabled` will respond to
	     click events and triggers pagination.
	
	     @class Backgrid.Extension.PageHandle
	  */
	  var PageHandle = Backgrid.Extension.PageHandle = Backbone.View.extend({
	
	    /** @property */
	    tagName: "li",
	
	    /** @property */
	    events: {
	      "click a": "changePage"
	    },
	
	    /**
	       @property {string|function(Object.<string, string>): string} title
	       The title to use for the `title` attribute of the generated page handle
	       anchor elements. It can be a string or a function that takes a `data`
	       parameter, which contains a mandatory `label` key which provides the
	       label value to be displayed.
	    */
	    title: function (data) {
	      return 'Page ' + data.label;
	    },
	
	    /**
	       @property {boolean} isRewind Whether this handle represents a rewind
	       control
	    */
	    isRewind: false,
	
	    /**
	       @property {boolean} isBack Whether this handle represents a back
	       control
	    */
	    isBack: false,
	
	    /**
	       @property {boolean} isForward Whether this handle represents a forward
	       control
	    */
	    isForward: false,
	
	    /**
	       @property {boolean} isFastForward Whether this handle represents a fast
	       forward control
	    */
	    isFastForward: false,
	
	    /**
	       Initializer.
	
	       @param {Object} options
	       @param {Backbone.Collection} options.collection
	       @param {number} pageIndex 0-based index of the page number this handle
	       handles. This parameter will be normalized to the base the underlying
	       PageableCollection uses.
	       @param {string} [options.label] If provided it is used to render the
	       anchor text, otherwise the normalized pageIndex will be used
	       instead. Required if any of the `is*` flags is set to `true`.
	       @param {string} [options.title]
	       @param {boolean} [options.isRewind=false]
	       @param {boolean} [options.isBack=false]
	       @param {boolean} [options.isForward=false]
	       @param {boolean} [options.isFastForward=false]
	    */
	    initialize: function (options) {
	      var collection = this.collection;
	      var state = collection.state;
	      var currentPage = state.currentPage;
	      var firstPage = state.firstPage;
	      var lastPage = state.lastPage;
	
	      _.extend(this, _.pick(options,
	                            ["isRewind", "isBack", "isForward", "isFastForward"]));
	
	      var pageIndex;
	      if (this.isRewind) pageIndex = firstPage;
	      else if (this.isBack) pageIndex = Math.max(firstPage, currentPage - 1);
	      else if (this.isForward) pageIndex = Math.min(lastPage, currentPage + 1);
	      else if (this.isFastForward) pageIndex = lastPage;
	      else {
	        pageIndex = +options.pageIndex;
	        pageIndex = (firstPage ? pageIndex + 1 : pageIndex);
	      }
	      this.pageIndex = pageIndex;
	
	      this.label = (options.label || (firstPage ? pageIndex : pageIndex + 1)) + '';
	      var title = options.title || this.title;
	      this.title = _.isFunction(title) ? title({label: this.label}) : title;
	    },
	
	    /**
	       Renders a clickable anchor element under a list item.
	    */
	    render: function () {
	      this.$el.empty();
	      var anchor = document.createElement("a");
	      anchor.href = '#';
	      if (this.title) anchor.title = this.title;
	      anchor.innerHTML = this.label;
	      this.el.appendChild(anchor);
	
	      var collection = this.collection;
	      var state = collection.state;
	      var currentPage = state.currentPage;
	      var pageIndex = this.pageIndex;
	
	      if (this.isRewind && currentPage == state.firstPage ||
	         this.isBack && !collection.hasPreviousPage() ||
	         this.isForward && !collection.hasNextPage() ||
	         this.isFastForward && (currentPage == state.lastPage || state.totalPages < 1)) {
	        this.$el.addClass("disabled");
	      }
	      else if (!(this.isRewind ||
	                 this.isBack ||
	                 this.isForward ||
	                 this.isFastForward) &&
	               state.currentPage == pageIndex) {
	        this.$el.addClass("active");
	      }
	
	      this.delegateEvents();
	      return this;
	    },
	
	    /**
	       jQuery click event handler. Goes to the page this PageHandle instance
	       represents. No-op if this page handle is currently active or disabled.
	    */
	    changePage: function (e) {
	      e.preventDefault();
	      var $el = this.$el, col = this.collection;
	      if (!$el.hasClass("active") && !$el.hasClass("disabled")) {
	        if (this.isRewind) col.getFirstPage({reset: true});
	        else if (this.isBack) col.getPreviousPage({reset: true});
	        else if (this.isForward) col.getNextPage({reset: true});
	        else if (this.isFastForward) col.getLastPage({reset: true});
	        else col.getPage(this.pageIndex, {reset: true});
	      }
	      return this;
	    }
	
	  });
	
	  /**
	     Paginator is a Backgrid extension that renders a series of configurable
	     pagination handles. This extension is best used for splitting a large data
	     set across multiple pages. If the number of pages is larger then a
	     threshold, which is set to 10 by default, the page handles are rendered
	     within a sliding window, plus the rewind, back, forward and fast forward
	     control handles. The individual control handles can be turned off.
	
	     @class Backgrid.Extension.Paginator
	  */
	  var Paginator = Backgrid.Extension.Paginator = Backbone.View.extend({
	
	    /** @property */
	    className: "backgrid-paginator",
	
	    /** @property */
	    windowSize: 10,
	
	    /**
	       @property {number} slideScale the number used by #slideHowMuch to scale
	       `windowSize` to yield the number of pages to slide. For example, the
	       default windowSize(10) * slideScale(0.5) yields 5, which means the window
	       will slide forward 5 pages as soon as you've reached page 6. The smaller
	       the scale factor the less pages to slide, and vice versa.
	
	       Also See:
	
	       - #slideMaybe
	       - #slideHowMuch
	    */
	    slideScale: 0.5,
	
	    /**
	       @property {Object.<string, Object.<string, string>>} controls You can
	       disable specific control handles by setting the keys in question to
	       null. The defaults will be merged with your controls object, with your
	       changes taking precedent.
	    */
	    controls: {
	      rewind: {
	        label: "《",
	        title: "First"
	      },
	      back: {
	        label: "〈",
	        title: "Previous"
	      },
	      forward: {
	        label: "〉",
	        title: "Next"
	      },
	      fastForward: {
	        label: "》",
	        title: "Last"
	      }
	    },
	
	    /** @property */
	    renderIndexedPageHandles: true,
	
	    /**
	      @property renderMultiplePagesOnly. Determines if the paginator
	      should show in cases where the collection has more than one page.
	      Default is false for backwards compatibility.
	    */
	    renderMultiplePagesOnly: false,
	
	    /**
	       @property {Backgrid.Extension.PageHandle} pageHandle. The PageHandle
	       class to use for rendering individual handles
	    */
	    pageHandle: PageHandle,
	
	    /** @property */
	    goBackFirstOnSort: true,
	
	    /**
	       Initializer.
	
	       @param {Object} options
	       @param {Backbone.Collection} options.collection
	       @param {boolean} [options.controls]
	       @param {boolean} [options.pageHandle=Backgrid.Extension.PageHandle]
	       @param {boolean} [options.goBackFirstOnSort=true]
	       @param {boolean} [options.renderMultiplePagesOnly=false]
	    */
	    initialize: function (options) {
	      var self = this;
	      self.controls = _.defaults(options.controls || {}, self.controls,
	                                 Paginator.prototype.controls);
	
	      _.extend(self, _.pick(options || {}, "windowSize", "pageHandle",
	                            "slideScale", "goBackFirstOnSort",
	                            "renderIndexedPageHandles",
	                            "renderMultiplePagesOnly"));
	
	      var col = self.collection;
	      self.listenTo(col, "add", self.render);
	      self.listenTo(col, "remove", self.render);
	      self.listenTo(col, "reset", self.render);
	      self.listenTo(col, "backgrid:sorted", function () {
	        if (self.goBackFirstOnSort && col.state.currentPage !== col.state.firstPage) col.getFirstPage({reset: true});
	      });
	    },
	
	    /**
	      Decides whether the window should slide. This method should return 1 if
	      sliding should occur and 0 otherwise. The default is sliding should occur
	      if half of the pages in a window has been reached.
	
	      __Note__: All the parameters have been normalized to be 0-based.
	
	      @param {number} firstPage
	      @param {number} lastPage
	      @param {number} currentPage
	      @param {number} windowSize
	      @param {number} slideScale
	
	      @return {0|1}
	     */
	    slideMaybe: function (firstPage, lastPage, currentPage, windowSize, slideScale) {
	      return Math.round(currentPage % windowSize / windowSize);
	    },
	
	    /**
	      Decides how many pages to slide when sliding should occur. The default
	      simply scales the `windowSize` to arrive at a fraction of the `windowSize`
	      to increment.
	
	      __Note__: All the parameters have been normalized to be 0-based.
	
	      @param {number} firstPage
	      @param {number} lastPage
	      @param {number} currentPage
	      @param {number} windowSize
	      @param {number} slideScale
	
	      @return {number}
	     */
	    slideThisMuch: function (firstPage, lastPage, currentPage, windowSize, slideScale) {
	      return ~~(windowSize * slideScale);
	    },
	
	    _calculateWindow: function () {
	      var collection = this.collection;
	      var state = collection.state;
	
	      // convert all indices to 0-based here
	      var firstPage = state.firstPage;
	      var lastPage = +state.lastPage;
	      lastPage = Math.max(0, firstPage ? lastPage - 1 : lastPage);
	      var currentPage = Math.max(state.currentPage, state.firstPage);
	      currentPage = firstPage ? currentPage - 1 : currentPage;
	      var windowSize = this.windowSize;
	      var slideScale = this.slideScale;
	      var windowStart = Math.floor(currentPage / windowSize) * windowSize;
	      if (currentPage <= lastPage - this.slideThisMuch()) {
	        windowStart += (this.slideMaybe(firstPage, lastPage, currentPage, windowSize, slideScale) *
	                        this.slideThisMuch(firstPage, lastPage, currentPage, windowSize, slideScale));
	      }
	      var windowEnd = Math.min(lastPage + 1, windowStart + windowSize);
	      return [windowStart, windowEnd];
	    },
	
	    /**
	       Creates a list of page handle objects for rendering.
	
	       @return {Array.<Object>} an array of page handle objects hashes
	    */
	    makeHandles: function () {
	
	      var handles = [];
	      var collection = this.collection;
	
	      var window = this._calculateWindow();
	      var winStart = window[0], winEnd = window[1];
	
	      if (this.renderIndexedPageHandles) {
	        for (var i = winStart; i < winEnd; i++) {
	          handles.push(new this.pageHandle({
	            collection: collection,
	            pageIndex: i
	          }));
	        }
	      }
	
	      var controls = this.controls;
	      _.each(["back", "rewind", "forward", "fastForward"], function (key) {
	        var value = controls[key];
	        if (value) {
	          var handleCtorOpts = {
	            collection: collection,
	            title: value.title,
	            label: value.label
	          };
	          handleCtorOpts["is" + key.slice(0, 1).toUpperCase() + key.slice(1)] = true;
	          var handle = new this.pageHandle(handleCtorOpts);
	          if (key == "rewind" || key == "back") handles.unshift(handle);
	          else handles.push(handle);
	        }
	      }, this);
	
	      return handles;
	    },
	
	    /**
	       Render the paginator handles inside an unordered list.
	    */
	    render: function () {
	      this.$el.empty();
	
	      var totalPages = this.collection.state.totalPages;
	
	      // Don't render if collection is empty
	      if(this.renderMultiplePagesOnly && totalPages <= 1) {
	        return this;
	      }
	
	      if (this.handles) {
	        for (var i = 0, l = this.handles.length; i < l; i++) {
	          this.handles[i].remove();
	        }
	      }
	
	      var handles = this.handles = this.makeHandles();
	
	      var ul = document.createElement("ul");
	      for (var i = 0; i < handles.length; i++) {
	        ul.appendChild(handles[i].render().el);
	      }
	
	      this.el.appendChild(ul);
	
	      return this;
	    }
	
	  });
	
	}));


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	  backgrid-select-all
	  http://github.com/wyuenho/backgrid
	
	  Copyright (c) 2013 Jimmy Yuen Ho Wong and contributors
	  Licensed under the MIT @license.
	*/
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16), __webpack_require__(58), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports == "object") {
	    // CommonJS
	    module.exports = factory(require("backbone"), require("backgrid"), require("underscore"));
	  }
	  // Browser
	  else factory(root.Backbone, root.Backgrid, root._);
	
	}(this, function (Backbone, Backgrid, _) {
	
	  "use strict";
	
	  /**
	     Renders a checkbox for row selection.
	
	     @class Backgrid.Extension.SelectRowCell
	     @extends Backbone.View
	  */
	  var SelectRowCell = Backgrid.Extension.SelectRowCell = Backbone.View.extend({
	
	    /** @property */
	    className: "select-row-cell",
	
	    /** @property */
	    tagName: "td",
	
	    /** @property */
	    events: {
	      "keydown input[type=checkbox]": "onKeydown",
	      "change input[type=checkbox]": "onChange",
	      "click input[type=checkbox]": "enterEditMode"
	    },
	
	    /**
	       Initializer. If the underlying model triggers a `select` event, this cell
	       will change its checked value according to the event's `selected` value.
	
	       @param {Object} options
	       @param {Backgrid.Column} options.column
	       @param {Backbone.Model} options.model
	    */
	    initialize: function (options) {
	
	      this.column = options.column;
	      if (!(this.column instanceof Backgrid.Column)) {
	        this.column = new Backgrid.Column(this.column);
	      }
	
	      var column = this.column, model = this.model, $el = this.$el;
	      this.listenTo(column, "change:renderable", function (column, renderable) {
	        $el.toggleClass("renderable", renderable);
	      });
	
	      if (Backgrid.callByNeed(column.renderable(), column, model)) $el.addClass("renderable");
	
	      this.listenTo(model, "backgrid:select", function (model, selected) {
	        this.checkbox().prop("checked", selected).change();
	      });
	    },
	
	    /**
	       Returns the checkbox.
	     */
	    checkbox: function () {
	      return this.$el.find("input[type=checkbox]");
	    },
	
	    /**
	       Focuses the checkbox.
	    */
	    enterEditMode: function () {
	      this.checkbox().focus();
	    },
	
	    /**
	       Unfocuses the checkbox.
	    */
	    exitEditMode: function () {
	      this.checkbox().blur();
	    },
	
	    /**
	       Process keyboard navigation.
	    */
	    onKeydown: function (e) {
	      var command = new Backgrid.Command(e);
	      if (command.passThru()) return true; // skip ahead to `change`
	      if (command.cancel()) {
	        e.stopPropagation();
	        this.checkbox().blur();
	      }
	      else if (command.save() || command.moveLeft() || command.moveRight() ||
	               command.moveUp() || command.moveDown()) {
	        e.preventDefault();
	        e.stopPropagation();
	        this.model.trigger("backgrid:edited", this.model, this.column, command);
	      }
	    },
	
	    /**
	       When the checkbox's value changes, this method will trigger a Backbone
	       `backgrid:selected` event with a reference of the model and the
	       checkbox's `checked` value.
	    */
	    onChange: function () {
	      var checked = this.checkbox().prop("checked");
	      this.$el.parent().toggleClass("selected", checked);
	      this.model.trigger("backgrid:selected", this.model, checked);
	    },
	
	    /**
	       Renders a checkbox in a table cell.
	    */
	    render: function () {
	      this.$el.empty().append('<input tabindex="-1" type="checkbox" />');
	      this.delegateEvents();
	      return this;
	    }
	
	  });
	
	  /**
	     Renders a checkbox to select all rows on the current page.
	
	     @class Backgrid.Extension.SelectAllHeaderCell
	     @extends Backgrid.Extension.SelectRowCell
	  */
	  var SelectAllHeaderCell = Backgrid.Extension.SelectAllHeaderCell = SelectRowCell.extend({
	
	    /** @property */
	    className: "select-all-header-cell",
	
	    /** @property */
	    tagName: "th",
	
	    /**
	       Initializer. When this cell's checkbox is checked, a Backbone
	       `backgrid:select` event will be triggered for each model for the current
	       page in the underlying collection. If a `SelectRowCell` instance exists
	       for the rows representing the models, they will check themselves. If any
	       of the SelectRowCell instances trigger a Backbone `backgrid:selected`
	       event with a `false` value, this cell will uncheck its checkbox. In the
	       event of a Backbone `backgrid:refresh` event, which is triggered when the
	       body refreshes its rows, which can happen under a number of conditions
	       such as paging or the columns were reset, this cell will still remember
	       the previously selected models and trigger a Backbone `backgrid:select`
	       event on them such that the SelectRowCells can recheck themselves upon
	       refreshing.
	
	       @param {Object} options
	       @param {Backgrid.Column} options.column
	       @param {Backbone.Collection} options.collection
	    */
	    initialize: function (options) {
	
	      this.column = options.column;
	      if (!(this.column instanceof Backgrid.Column)) {
	        this.column = new Backgrid.Column(this.column);
	      }
	
	      var collection = this.collection;
	      var selectedModels = this.selectedModels = {};
	      this.listenTo(collection.fullCollection || collection,
	                    "backgrid:selected", function (model, selected) {
	        if (selected) selectedModels[model.id || model.cid] = 1;
	        else {
	          delete selectedModels[model.id || model.cid];
	          this.checkbox().prop("checked", false);
	        }
	        if (_.keys(selectedModels).length === (collection.fullCollection|| collection).length) {
	          this.checkbox().prop("checked", true);
	        }
	      });
	
	      this.listenTo(collection.fullCollection || collection, "remove", function (model) {
	        delete selectedModels[model.id || model.cid];
	        if ((collection.fullCollection || collection).length === 0) {
	          this.checkbox().prop("checked", false);
	        }
	      });
	
	      this.listenTo(collection, "backgrid:refresh", function () {
	        if ((collection.fullCollection || collection).length === 0) {
	          this.checkbox().prop("checked", false);
	        }
	        else {
	          var checked = this.checkbox().prop("checked");
	          for (var i = 0; i < collection.length; i++) {
	            var model = collection.at(i);
	            if (checked || selectedModels[model.id || model.cid]) {
	              model.trigger("backgrid:select", model, true);
	            }
	          }
	        }
	      });
	
	      var column = this.column, $el = this.$el;
	      this.listenTo(column, "change:renderable", function (column, renderable) {
	        $el.toggleClass("renderable", renderable);
	      });
	
	      if (Backgrid.callByNeed(column.renderable(), column, collection)) $el.addClass("renderable");
	    },
	
	    /**
	       Propagates the checked value of this checkbox to all the models of the
	       underlying collection by triggering a Backbone `backgrid:select` event on
	       the models on the current page, passing each model and the current
	       `checked` value of the checkbox in each event.
	
	       A `backgrid:selected` event will also be triggered with the current
	       `checked` value on all the models regardless of whether they are on the
	       current page.
	
	       This method triggers a 'backgrid:select-all' event on the collection
	       afterwards.
	    */
	    onChange: function () {
	      var checked = this.checkbox().prop("checked");
	
	      var collection = this.collection;
	      collection.each(function (model) {
	        model.trigger("backgrid:select", model, checked);
	      });
	
	      if (collection.fullCollection) {
	        collection.fullCollection.each(function (model) {
	          if (!collection.get(model.cid)) {
	            model.trigger("backgrid:selected", model, checked);
	          }
	        });
	      }
	
	      this.collection.trigger("backgrid:select-all", this.collection, checked);
	    }
	
	  });
	
	  /**
	     Convenient method to retrieve a list of selected models. This method only
	     exists when the `SelectAll` extension has been included. Selected models
	     are retained across pagination.
	
	     @member Backgrid.Grid
	     @return {Array.<Backbone.Model>}
	  */
	  Backgrid.Grid.prototype.getSelectedModels = function () {
	    var selectAllHeaderCell;
	    var headerCells = this.header.row.cells;
	    for (var i = 0, l = headerCells.length; i < l; i++) {
	      var headerCell = headerCells[i];
	      if (headerCell instanceof SelectAllHeaderCell) {
	        selectAllHeaderCell = headerCell;
	        break;
	      }
	    }
	
	    var result = [];
	    if (selectAllHeaderCell) {
	      var selectedModels = selectAllHeaderCell.selectedModels;
	      var collection = this.collection.fullCollection || this.collection;
	      for (var modelId in selectedModels) {
	        result.push(collection.get(modelId));
	      }
	    }
	
	    return result;
	  };
	
	  /**
	     Convenient method to deselect the selected models. This method is only
	     available when the `SelectAll` extension has been included.
	
	     @member Backgrid.Grid
	   */
	  Backgrid.Grid.prototype.clearSelectedModels = function () {
	    var selectedModels = this.getSelectedModels();
	    for (var i = 0, l = selectedModels.length; i < l; i++) {
	      var model = selectedModels[i];
	      model.trigger("backgrid:select", model, false);
	    }
	  };
	
	}));


/***/ },
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1750);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./backgrid-paginator.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./backgrid-paginator.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1751);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./backgrid.css", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./backgrid.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ function(module, exports) {

	/**
	 * Ensure some object is a coerced to a string
	 **/
	module.exports = function makeString(object) {
	  if (object == null) return '';
	  return '' + object;
	};


/***/ },
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ },
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
[2105, 184],
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * jquery.mask.js
	 * @version: v1.14.16
	 * @author: Igor Escobar
	 *
	 * Created by Igor Escobar on 2012-03-10. Please report any bug at github.com/igorescobar/jQuery-Mask-Plugin
	 *
	 * Copyright (c) 2012 Igor Escobar http://igorescobar.com
	 *
	 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
	 *
	 * Permission is hereby granted, free of charge, to any person
	 * obtaining a copy of this software and associated documentation
	 * files (the "Software"), to deal in the Software without
	 * restriction, including without limitation the rights to use,
	 * copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the
	 * Software is furnished to do so, subject to the following
	 * conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	 * OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	/* jshint laxbreak: true */
	/* jshint maxcomplexity:17 */
	/* global define */
	
	// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
	// https://github.com/umdjs/umd/blob/master/templates/jqueryPlugin.js
	(function (factory, jQuery, Zepto) {
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object' && typeof Meteor === 'undefined') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery || Zepto);
	    }
	
	}(function ($) {
	    'use strict';
	
	    var Mask = function (el, mask, options) {
	
	        var p = {
	            invalid: [],
	            getCaret: function () {
	                try {
	                    var sel,
	                        pos = 0,
	                        ctrl = el.get(0),
	                        dSel = document.selection,
	                        cSelStart = ctrl.selectionStart;
	
	                    // IE Support
	                    if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
	                        sel = dSel.createRange();
	                        sel.moveStart('character', -p.val().length);
	                        pos = sel.text.length;
	                    }
	                    // Firefox support
	                    else if (cSelStart || cSelStart === '0') {
	                        pos = cSelStart;
	                    }
	
	                    return pos;
	                } catch (e) {}
	            },
	            setCaret: function(pos) {
	                try {
	                    if (el.is(':focus')) {
	                        var range, ctrl = el.get(0);
	
	                        // Firefox, WebKit, etc..
	                        if (ctrl.setSelectionRange) {
	                            ctrl.setSelectionRange(pos, pos);
	                        } else { // IE
	                            range = ctrl.createTextRange();
	                            range.collapse(true);
	                            range.moveEnd('character', pos);
	                            range.moveStart('character', pos);
	                            range.select();
	                        }
	                    }
	                } catch (e) {}
	            },
	            events: function() {
	                el
	                .on('keydown.mask', function(e) {
	                    el.data('mask-keycode', e.keyCode || e.which);
	                    el.data('mask-previus-value', el.val());
	                    el.data('mask-previus-caret-pos', p.getCaret());
	                    p.maskDigitPosMapOld = p.maskDigitPosMap;
	                })
	                .on($.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', p.behaviour)
	                .on('paste.mask drop.mask', function() {
	                    setTimeout(function() {
	                        el.keydown().keyup();
	                    }, 100);
	                })
	                .on('change.mask', function(){
	                    el.data('changed', true);
	                })
	                .on('blur.mask', function(){
	                    if (oldValue !== p.val() && !el.data('changed')) {
	                        el.trigger('change');
	                    }
	                    el.data('changed', false);
	                })
	                // it's very important that this callback remains in this position
	                // otherwhise oldValue it's going to work buggy
	                .on('blur.mask', function() {
	                    oldValue = p.val();
	                })
	                // select all text on focus
	                .on('focus.mask', function (e) {
	                    if (options.selectOnFocus === true) {
	                        $(e.target).select();
	                    }
	                })
	                // clear the value if it not complete the mask
	                .on('focusout.mask', function() {
	                    if (options.clearIfNotMatch && !regexMask.test(p.val())) {
	                       p.val('');
	                   }
	                });
	            },
	            getRegexMask: function() {
	                var maskChunks = [], translation, pattern, optional, recursive, oRecursive, r;
	
	                for (var i = 0; i < mask.length; i++) {
	                    translation = jMask.translation[mask.charAt(i)];
	
	                    if (translation) {
	
	                        pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
	                        optional = translation.optional;
	                        recursive = translation.recursive;
	
	                        if (recursive) {
	                            maskChunks.push(mask.charAt(i));
	                            oRecursive = {digit: mask.charAt(i), pattern: pattern};
	                        } else {
	                            maskChunks.push(!optional && !recursive ? pattern : (pattern + '?'));
	                        }
	
	                    } else {
	                        maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
	                    }
	                }
	
	                r = maskChunks.join('');
	
	                if (oRecursive) {
	                    r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?')
	                         .replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
	                }
	
	                return new RegExp(r);
	            },
	            destroyEvents: function() {
	                el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
	            },
	            val: function(v) {
	                var isInput = el.is('input'),
	                    method = isInput ? 'val' : 'text',
	                    r;
	
	                if (arguments.length > 0) {
	                    if (el[method]() !== v) {
	                        el[method](v);
	                    }
	                    r = el;
	                } else {
	                    r = el[method]();
	                }
	
	                return r;
	            },
	            calculateCaretPosition: function(oldVal) {
	                var newVal = p.getMasked(),
	                    caretPosNew = p.getCaret();
	                if (oldVal !== newVal) {
	                    var caretPosOld = el.data('mask-previus-caret-pos') || 0,
	                        newValL = newVal.length,
	                        oldValL = oldVal.length,
	                        maskDigitsBeforeCaret = 0,
	                        maskDigitsAfterCaret = 0,
	                        maskDigitsBeforeCaretAll = 0,
	                        maskDigitsBeforeCaretAllOld = 0,
	                        i = 0;
	
	                    for (i = caretPosNew; i < newValL; i++) {
	                        if (!p.maskDigitPosMap[i]) {
	                            break;
	                        }
	                        maskDigitsAfterCaret++;
	                    }
	
	                    for (i = caretPosNew - 1; i >= 0; i--) {
	                        if (!p.maskDigitPosMap[i]) {
	                            break;
	                        }
	                        maskDigitsBeforeCaret++;
	                    }
	
	                    for (i = caretPosNew - 1; i >= 0; i--) {
	                        if (p.maskDigitPosMap[i]) {
	                            maskDigitsBeforeCaretAll++;
	                        }
	                    }
	
	                    for (i = caretPosOld - 1; i >= 0; i--) {
	                        if (p.maskDigitPosMapOld[i]) {
	                            maskDigitsBeforeCaretAllOld++;
	                        }
	                    }
	
	                    // if the cursor is at the end keep it there
	                    if (caretPosNew > oldValL) {
	                      caretPosNew = newValL * 10;
	                    } else if (caretPosOld >= caretPosNew && caretPosOld !== oldValL) {
	                        if (!p.maskDigitPosMapOld[caretPosNew])  {
	                          var caretPos = caretPosNew;
	                          caretPosNew -= maskDigitsBeforeCaretAllOld - maskDigitsBeforeCaretAll;
	                          caretPosNew -= maskDigitsBeforeCaret;
	                          if (p.maskDigitPosMap[caretPosNew])  {
	                            caretPosNew = caretPos;
	                          }
	                        }
	                    }
	                    else if (caretPosNew > caretPosOld) {
	                        caretPosNew += maskDigitsBeforeCaretAll - maskDigitsBeforeCaretAllOld;
	                        caretPosNew += maskDigitsAfterCaret;
	                    }
	                }
	                return caretPosNew;
	            },
	            behaviour: function(e) {
	                e = e || window.event;
	                p.invalid = [];
	
	                var keyCode = el.data('mask-keycode');
	
	                if ($.inArray(keyCode, jMask.byPassKeys) === -1) {
	                    var newVal = p.getMasked(),
	                        caretPos = p.getCaret(),
	                        oldVal = el.data('mask-previus-value') || '';
	
	                    // this is a compensation to devices/browsers that don't compensate
	                    // caret positioning the right way
	                    setTimeout(function() {
	                      p.setCaret(p.calculateCaretPosition(oldVal));
	                    }, $.jMaskGlobals.keyStrokeCompensation);
	
	                    p.val(newVal);
	                    p.setCaret(caretPos);
	                    return p.callbacks(e);
	                }
	            },
	            getMasked: function(skipMaskChars, val) {
	                var buf = [],
	                    value = val === undefined ? p.val() : val + '',
	                    m = 0, maskLen = mask.length,
	                    v = 0, valLen = value.length,
	                    offset = 1, addMethod = 'push',
	                    resetPos = -1,
	                    maskDigitCount = 0,
	                    maskDigitPosArr = [],
	                    lastMaskChar,
	                    check;
	
	                if (options.reverse) {
	                    addMethod = 'unshift';
	                    offset = -1;
	                    lastMaskChar = 0;
	                    m = maskLen - 1;
	                    v = valLen - 1;
	                    check = function () {
	                        return m > -1 && v > -1;
	                    };
	                } else {
	                    lastMaskChar = maskLen - 1;
	                    check = function () {
	                        return m < maskLen && v < valLen;
	                    };
	                }
	
	                var lastUntranslatedMaskChar;
	                while (check()) {
	                    var maskDigit = mask.charAt(m),
	                        valDigit = value.charAt(v),
	                        translation = jMask.translation[maskDigit];
	
	                    if (translation) {
	                        if (valDigit.match(translation.pattern)) {
	                            buf[addMethod](valDigit);
	                             if (translation.recursive) {
	                                if (resetPos === -1) {
	                                    resetPos = m;
	                                } else if (m === lastMaskChar && m !== resetPos) {
	                                    m = resetPos - offset;
	                                }
	
	                                if (lastMaskChar === resetPos) {
	                                    m -= offset;
	                                }
	                            }
	                            m += offset;
	                        } else if (valDigit === lastUntranslatedMaskChar) {
	                            // matched the last untranslated (raw) mask character that we encountered
	                            // likely an insert offset the mask character from the last entry; fall
	                            // through and only increment v
	                            maskDigitCount--;
	                            lastUntranslatedMaskChar = undefined;
	                        } else if (translation.optional) {
	                            m += offset;
	                            v -= offset;
	                        } else if (translation.fallback) {
	                            buf[addMethod](translation.fallback);
	                            m += offset;
	                            v -= offset;
	                        } else {
	                          p.invalid.push({p: v, v: valDigit, e: translation.pattern});
	                        }
	                        v += offset;
	                    } else {
	                        if (!skipMaskChars) {
	                            buf[addMethod](maskDigit);
	                        }
	
	                        if (valDigit === maskDigit) {
	                            maskDigitPosArr.push(v);
	                            v += offset;
	                        } else {
	                            lastUntranslatedMaskChar = maskDigit;
	                            maskDigitPosArr.push(v + maskDigitCount);
	                            maskDigitCount++;
	                        }
	
	                        m += offset;
	                    }
	                }
	
	                var lastMaskCharDigit = mask.charAt(lastMaskChar);
	                if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
	                    buf.push(lastMaskCharDigit);
	                }
	
	                var newVal = buf.join('');
	                p.mapMaskdigitPositions(newVal, maskDigitPosArr, valLen);
	                return newVal;
	            },
	            mapMaskdigitPositions: function(newVal, maskDigitPosArr, valLen) {
	              var maskDiff = options.reverse ? newVal.length - valLen : 0;
	              p.maskDigitPosMap = {};
	              for (var i = 0; i < maskDigitPosArr.length; i++) {
	                p.maskDigitPosMap[maskDigitPosArr[i] + maskDiff] = 1;
	              }
	            },
	            callbacks: function (e) {
	                var val = p.val(),
	                    changed = val !== oldValue,
	                    defaultArgs = [val, e, el, options],
	                    callback = function(name, criteria, args) {
	                        if (typeof options[name] === 'function' && criteria) {
	                            options[name].apply(this, args);
	                        }
	                    };
	
	                callback('onChange', changed === true, defaultArgs);
	                callback('onKeyPress', changed === true, defaultArgs);
	                callback('onComplete', val.length === mask.length, defaultArgs);
	                callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
	            }
	        };
	
	        el = $(el);
	        var jMask = this, oldValue = p.val(), regexMask;
	
	        mask = typeof mask === 'function' ? mask(p.val(), undefined, el,  options) : mask;
	
	        // public methods
	        jMask.mask = mask;
	        jMask.options = options;
	        jMask.remove = function() {
	            var caret = p.getCaret();
	            if (jMask.options.placeholder) {
	                el.removeAttr('placeholder');
	            }
	            if (el.data('mask-maxlength')) {
	                el.removeAttr('maxlength');
	            }
	            p.destroyEvents();
	            p.val(jMask.getCleanVal());
	            p.setCaret(caret);
	            return el;
	        };
	
	        // get value without mask
	        jMask.getCleanVal = function() {
	           return p.getMasked(true);
	        };
	
	        // get masked value without the value being in the input or element
	        jMask.getMaskedVal = function(val) {
	           return p.getMasked(false, val);
	        };
	
	       jMask.init = function(onlyMask) {
	            onlyMask = onlyMask || false;
	            options = options || {};
	
	            jMask.clearIfNotMatch  = $.jMaskGlobals.clearIfNotMatch;
	            jMask.byPassKeys       = $.jMaskGlobals.byPassKeys;
	            jMask.translation      = $.extend({}, $.jMaskGlobals.translation, options.translation);
	
	            jMask = $.extend(true, {}, jMask, options);
	
	            regexMask = p.getRegexMask();
	
	            if (onlyMask) {
	                p.events();
	                p.val(p.getMasked());
	            } else {
	                if (options.placeholder) {
	                    el.attr('placeholder' , options.placeholder);
	                }
	
	                // this is necessary, otherwise if the user submit the form
	                // and then press the "back" button, the autocomplete will erase
	                // the data. Works fine on IE9+, FF, Opera, Safari.
	                if (el.data('mask')) {
	                  el.attr('autocomplete', 'off');
	                }
	
	                // detect if is necessary let the user type freely.
	                // for is a lot faster than forEach.
	                for (var i = 0, maxlength = true; i < mask.length; i++) {
	                    var translation = jMask.translation[mask.charAt(i)];
	                    if (translation && translation.recursive) {
	                        maxlength = false;
	                        break;
	                    }
	                }
	
	                if (maxlength) {
	                    el.attr('maxlength', mask.length).data('mask-maxlength', true);
	                }
	
	                p.destroyEvents();
	                p.events();
	
	                var caret = p.getCaret();
	                p.val(p.getMasked());
	                p.setCaret(caret);
	            }
	        };
	
	        jMask.init(!el.is('input'));
	    };
	
	    $.maskWatchers = {};
	    var HTMLAttributes = function () {
	        var input = $(this),
	            options = {},
	            prefix = 'data-mask-',
	            mask = input.attr('data-mask');
	
	        if (input.attr(prefix + 'reverse')) {
	            options.reverse = true;
	        }
	
	        if (input.attr(prefix + 'clearifnotmatch')) {
	            options.clearIfNotMatch = true;
	        }
	
	        if (input.attr(prefix + 'selectonfocus') === 'true') {
	           options.selectOnFocus = true;
	        }
	
	        if (notSameMaskObject(input, mask, options)) {
	            return input.data('mask', new Mask(this, mask, options));
	        }
	    },
	    notSameMaskObject = function(field, mask, options) {
	        options = options || {};
	        var maskObject = $(field).data('mask'),
	            stringify = JSON.stringify,
	            value = $(field).val() || $(field).text();
	        try {
	            if (typeof mask === 'function') {
	                mask = mask(value);
	            }
	            return typeof maskObject !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
	        } catch (e) {}
	    },
	    eventSupported = function(eventName) {
	        var el = document.createElement('div'), isSupported;
	
	        eventName = 'on' + eventName;
	        isSupported = (eventName in el);
	
	        if ( !isSupported ) {
	            el.setAttribute(eventName, 'return;');
	            isSupported = typeof el[eventName] === 'function';
	        }
	        el = null;
	
	        return isSupported;
	    };
	
	    $.fn.mask = function(mask, options) {
	        options = options || {};
	        var selector = this.selector,
	            globals = $.jMaskGlobals,
	            interval = globals.watchInterval,
	            watchInputs = options.watchInputs || globals.watchInputs,
	            maskFunction = function() {
	                if (notSameMaskObject(this, mask, options)) {
	                    return $(this).data('mask', new Mask(this, mask, options));
	                }
	            };
	
	        $(this).each(maskFunction);
	
	        if (selector && selector !== '' && watchInputs) {
	            clearInterval($.maskWatchers[selector]);
	            $.maskWatchers[selector] = setInterval(function(){
	                $(document).find(selector).each(maskFunction);
	            }, interval);
	        }
	        return this;
	    };
	
	    $.fn.masked = function(val) {
	        return this.data('mask').getMaskedVal(val);
	    };
	
	    $.fn.unmask = function() {
	        clearInterval($.maskWatchers[this.selector]);
	        delete $.maskWatchers[this.selector];
	        return this.each(function() {
	            var dataMask = $(this).data('mask');
	            if (dataMask) {
	                dataMask.remove().removeData('mask');
	            }
	        });
	    };
	
	    $.fn.cleanVal = function() {
	        return this.data('mask').getCleanVal();
	    };
	
	    $.applyDataMask = function(selector) {
	        selector = selector || $.jMaskGlobals.maskElements;
	        var $selector = (selector instanceof $) ? selector : $(selector);
	        $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
	    };
	
	    var globals = {
	        maskElements: 'input,td,span,div',
	        dataMaskAttr: '*[data-mask]',
	        dataMask: true,
	        watchInterval: 300,
	        watchInputs: true,
	        keyStrokeCompensation: 10,
	        // old versions of chrome dont work great with input event
	        useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && eventSupported('input'),
	        watchDataMask: false,
	        byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
	        translation: {
	            '0': {pattern: /\d/},
	            '9': {pattern: /\d/, optional: true},
	            '#': {pattern: /\d/, recursive: true},
	            'A': {pattern: /[a-zA-Z0-9]/},
	            'S': {pattern: /[a-zA-Z]/}
	        }
	    };
	
	    $.jMaskGlobals = $.jMaskGlobals || {};
	    globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);
	
	    // looking for inputs with data-mask attribute
	    if (globals.dataMask) {
	        $.applyDataMask();
	    }
	
	    setInterval(function() {
	        if ($.jMaskGlobals.watchDataMask) {
	            $.applyDataMask();
	        }
	    }, globals.watchInterval);
	}, window.jQuery, window.Zepto));


/***/ },
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */
[2128, 1326, 680, 220],
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/*
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/*
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var NODE_ENV = process.env.NODE_ENV;
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (NODE_ENV !== 'production') {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(235)))

/***/ },
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ function(module, exports) {

	/*! ========================================================================
	 * Bootstrap Toggle: bootstrap-toggle.js v2.2.0
	 * http://www.bootstraptoggle.com
	 * ========================================================================
	 * Copyright 2014 Min Hur, The New York Times Company
	 * Licensed under MIT
	 * ======================================================================== */
	
	
	 +function ($) {
	 	'use strict';
	
		// TOGGLE PUBLIC CLASS DEFINITION
		// ==============================
	
		var Toggle = function (element, options) {
			this.$element  = $(element)
			this.options   = $.extend({}, this.defaults(), options)
			this.render()
		}
	
		Toggle.VERSION  = '2.2.0'
	
		Toggle.DEFAULTS = {
			on: 'On',
			off: 'Off',
			onstyle: 'primary',
			offstyle: 'default',
			size: 'normal',
			style: '',
			width: null,
			height: null
		}
	
		Toggle.prototype.defaults = function() {
			return {
				on: this.$element.attr('data-on') || Toggle.DEFAULTS.on,
				off: this.$element.attr('data-off') || Toggle.DEFAULTS.off,
				onstyle: this.$element.attr('data-onstyle') || Toggle.DEFAULTS.onstyle,
				offstyle: this.$element.attr('data-offstyle') || Toggle.DEFAULTS.offstyle,
				size: this.$element.attr('data-size') || Toggle.DEFAULTS.size,
				style: this.$element.attr('data-style') || Toggle.DEFAULTS.style,
				width: this.$element.attr('data-width') || Toggle.DEFAULTS.width,
				height: this.$element.attr('data-height') || Toggle.DEFAULTS.height
			}
		}
	
		Toggle.prototype.render = function () {
			this._onstyle = 'btn-' + this.options.onstyle
			this._offstyle = 'btn-' + this.options.offstyle
			var size = this.options.size === 'large' ? 'btn-lg'
				: this.options.size === 'small' ? 'btn-sm'
				: this.options.size === 'mini' ? 'btn-xs'
				: ''
			var $toggleOn = $('<label class="btn">').html(this.options.on)
				.addClass(this._onstyle + ' ' + size)
			var $toggleOff = $('<label class="btn">').html(this.options.off)
				.addClass(this._offstyle + ' ' + size + ' active')
			var $toggleHandle = $('<span class="toggle-handle btn btn-default">')
				.addClass(size)
			var $toggleGroup = $('<div class="toggle-group">')
				.append($toggleOn, $toggleOff, $toggleHandle)
			var $toggle = $('<div class="toggle btn" data-toggle="toggle">')
				.addClass( this.$element.prop('checked') ? this._onstyle : this._offstyle+' off' )
				.addClass(size).addClass(this.options.style)
	
			this.$element.wrap($toggle)
			$.extend(this, {
				$toggle: this.$element.parent(),
				$toggleOn: $toggleOn,
				$toggleOff: $toggleOff,
				$toggleGroup: $toggleGroup
			})
			this.$toggle.append($toggleGroup)
	
			var width = this.options.width || Math.max($toggleOn.outerWidth(), $toggleOff.outerWidth())+($toggleHandle.outerWidth()/2)
			var height = this.options.height || Math.max($toggleOn.outerHeight(), $toggleOff.outerHeight())
			$toggleOn.addClass('toggle-on')
			$toggleOff.addClass('toggle-off')
			this.$toggle.css({ width: width, height: height })
			if (this.options.height) {
				$toggleOn.css('line-height', $toggleOn.height() + 'px')
				$toggleOff.css('line-height', $toggleOff.height() + 'px')
			}
			this.update(true)
			this.trigger(true)
		}
	
		Toggle.prototype.toggle = function () {
			if (this.$element.prop('checked')) this.off()
			else this.on()
		}
	
		Toggle.prototype.on = function (silent) {
			if (this.$element.prop('disabled')) return false
			this.$toggle.removeClass(this._offstyle + ' off').addClass(this._onstyle)
			this.$element.prop('checked', true)
			if (!silent) this.trigger()
		}
	
		Toggle.prototype.off = function (silent) {
			if (this.$element.prop('disabled')) return false
			this.$toggle.removeClass(this._onstyle).addClass(this._offstyle + ' off')
			this.$element.prop('checked', false)
			if (!silent) this.trigger()
		}
	
		Toggle.prototype.enable = function () {
			this.$toggle.removeAttr('disabled')
			this.$element.prop('disabled', false)
		}
	
		Toggle.prototype.disable = function () {
			this.$toggle.attr('disabled', 'disabled')
			this.$element.prop('disabled', true)
		}
	
		Toggle.prototype.update = function (silent) {
			if (this.$element.prop('disabled')) this.disable()
			else this.enable()
			if (this.$element.prop('checked')) this.on(silent)
			else this.off(silent)
		}
	
		Toggle.prototype.trigger = function (silent) {
			this.$element.off('change.bs.toggle')
			if (!silent) this.$element.change()
			this.$element.on('change.bs.toggle', $.proxy(function() {
				this.update()
			}, this))
		}
	
		Toggle.prototype.destroy = function() {
			this.$element.off('change.bs.toggle')
			this.$toggleGroup.remove()
			this.$element.removeData('bs.toggle')
			this.$element.unwrap()
		}
	
		// TOGGLE PLUGIN DEFINITION
		// ========================
	
		function Plugin(option) {
			return this.each(function () {
				var $this   = $(this)
				var data    = $this.data('bs.toggle')
				var options = typeof option == 'object' && option
	
				if (!data) $this.data('bs.toggle', (data = new Toggle(this, options)))
				if (typeof option == 'string' && data[option]) data[option]()
			})
		}
	
		var old = $.fn.bootstrapToggle
	
		$.fn.bootstrapToggle             = Plugin
		$.fn.bootstrapToggle.Constructor = Toggle
	
		// TOGGLE NO CONFLICT
		// ==================
	
		$.fn.toggle.noConflict = function () {
			$.fn.bootstrapToggle = old
			return this
		}
	
		// TOGGLE DATA-API
		// ===============
	
		$(function() {
			$('input[type=checkbox][data-toggle^=toggle]').bootstrapToggle()
		})
	
		$(document).on('click.bs.toggle', 'div[data-toggle^=toggle]', function(e) {
			var $checkbox = $(this).find('input[type=checkbox]')
			$checkbox.bootstrapToggle('toggle')
			e.preventDefault()
		})
	
	}(jQuery);


/***/ },
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */
[1956, 1, 4],
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	* jquery-match-height 0.7.2 by @liabru
	* http://brm.io/jquery-match-height/
	* License: MIT
	*/
	
	;(function(factory) { // eslint-disable-line no-extra-semi
	    'use strict';
	    if (true) {
	        // AMD
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined' && module.exports) {
	        // CommonJS
	        module.exports = factory(require('jquery'));
	    } else {
	        // Global
	        factory(jQuery);
	    }
	})(function($) {
	    /*
	    *  internal
	    */
	
	    var _previousResizeWidth = -1,
	        _updateTimeout = -1;
	
	    /*
	    *  _parse
	    *  value parse utility function
	    */
	
	    var _parse = function(value) {
	        // parse value and convert NaN to 0
	        return parseFloat(value) || 0;
	    };
	
	    /*
	    *  _rows
	    *  utility function returns array of jQuery selections representing each row
	    *  (as displayed after float wrapping applied by browser)
	    */
	
	    var _rows = function(elements) {
	        var tolerance = 1,
	            $elements = $(elements),
	            lastTop = null,
	            rows = [];
	
	        // group elements by their top position
	        $elements.each(function(){
	            var $that = $(this),
	                top = $that.offset().top - _parse($that.css('margin-top')),
	                lastRow = rows.length > 0 ? rows[rows.length - 1] : null;
	
	            if (lastRow === null) {
	                // first item on the row, so just push it
	                rows.push($that);
	            } else {
	                // if the row top is the same, add to the row group
	                if (Math.floor(Math.abs(lastTop - top)) <= tolerance) {
	                    rows[rows.length - 1] = lastRow.add($that);
	                } else {
	                    // otherwise start a new row group
	                    rows.push($that);
	                }
	            }
	
	            // keep track of the last row top
	            lastTop = top;
	        });
	
	        return rows;
	    };
	
	    /*
	    *  _parseOptions
	    *  handle plugin options
	    */
	
	    var _parseOptions = function(options) {
	        var opts = {
	            byRow: true,
	            property: 'height',
	            target: null,
	            remove: false
	        };
	
	        if (typeof options === 'object') {
	            return $.extend(opts, options);
	        }
	
	        if (typeof options === 'boolean') {
	            opts.byRow = options;
	        } else if (options === 'remove') {
	            opts.remove = true;
	        }
	
	        return opts;
	    };
	
	    /*
	    *  matchHeight
	    *  plugin definition
	    */
	
	    var matchHeight = $.fn.matchHeight = function(options) {
	        var opts = _parseOptions(options);
	
	        // handle remove
	        if (opts.remove) {
	            var that = this;
	
	            // remove fixed height from all selected elements
	            this.css(opts.property, '');
	
	            // remove selected elements from all groups
	            $.each(matchHeight._groups, function(key, group) {
	                group.elements = group.elements.not(that);
	            });
	
	            // TODO: cleanup empty groups
	
	            return this;
	        }
	
	        if (this.length <= 1 && !opts.target) {
	            return this;
	        }
	
	        // keep track of this group so we can re-apply later on load and resize events
	        matchHeight._groups.push({
	            elements: this,
	            options: opts
	        });
	
	        // match each element's height to the tallest element in the selection
	        matchHeight._apply(this, opts);
	
	        return this;
	    };
	
	    /*
	    *  plugin global options
	    */
	
	    matchHeight.version = '0.7.2';
	    matchHeight._groups = [];
	    matchHeight._throttle = 80;
	    matchHeight._maintainScroll = false;
	    matchHeight._beforeUpdate = null;
	    matchHeight._afterUpdate = null;
	    matchHeight._rows = _rows;
	    matchHeight._parse = _parse;
	    matchHeight._parseOptions = _parseOptions;
	
	    /*
	    *  matchHeight._apply
	    *  apply matchHeight to given elements
	    */
	
	    matchHeight._apply = function(elements, options) {
	        var opts = _parseOptions(options),
	            $elements = $(elements),
	            rows = [$elements];
	
	        // take note of scroll position
	        var scrollTop = $(window).scrollTop(),
	            htmlHeight = $('html').outerHeight(true);
	
	        // get hidden parents
	        var $hiddenParents = $elements.parents().filter(':hidden');
	
	        // cache the original inline style
	        $hiddenParents.each(function() {
	            var $that = $(this);
	            $that.data('style-cache', $that.attr('style'));
	        });
	
	        // temporarily must force hidden parents visible
	        $hiddenParents.css('display', 'block');
	
	        // get rows if using byRow, otherwise assume one row
	        if (opts.byRow && !opts.target) {
	
	            // must first force an arbitrary equal height so floating elements break evenly
	            $elements.each(function() {
	                var $that = $(this),
	                    display = $that.css('display');
	
	                // temporarily force a usable display value
	                if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
	                    display = 'block';
	                }
	
	                // cache the original inline style
	                $that.data('style-cache', $that.attr('style'));
	
	                $that.css({
	                    'display': display,
	                    'padding-top': '0',
	                    'padding-bottom': '0',
	                    'margin-top': '0',
	                    'margin-bottom': '0',
	                    'border-top-width': '0',
	                    'border-bottom-width': '0',
	                    'height': '100px',
	                    'overflow': 'hidden'
	                });
	            });
	
	            // get the array of rows (based on element top position)
	            rows = _rows($elements);
	
	            // revert original inline styles
	            $elements.each(function() {
	                var $that = $(this);
	                $that.attr('style', $that.data('style-cache') || '');
	            });
	        }
	
	        $.each(rows, function(key, row) {
	            var $row = $(row),
	                targetHeight = 0;
	
	            if (!opts.target) {
	                // skip apply to rows with only one item
	                if (opts.byRow && $row.length <= 1) {
	                    $row.css(opts.property, '');
	                    return;
	                }
	
	                // iterate the row and find the max height
	                $row.each(function(){
	                    var $that = $(this),
	                        style = $that.attr('style'),
	                        display = $that.css('display');
	
	                    // temporarily force a usable display value
	                    if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
	                        display = 'block';
	                    }
	
	                    // ensure we get the correct actual height (and not a previously set height value)
	                    var css = { 'display': display };
	                    css[opts.property] = '';
	                    $that.css(css);
	
	                    // find the max height (including padding, but not margin)
	                    if ($that.outerHeight(false) > targetHeight) {
	                        targetHeight = $that.outerHeight(false);
	                    }
	
	                    // revert styles
	                    if (style) {
	                        $that.attr('style', style);
	                    } else {
	                        $that.css('display', '');
	                    }
	                });
	            } else {
	                // if target set, use the height of the target element
	                targetHeight = opts.target.outerHeight(false);
	            }
	
	            // iterate the row and apply the height to all elements
	            $row.each(function(){
	                var $that = $(this),
	                    verticalPadding = 0;
	
	                // don't apply to a target
	                if (opts.target && $that.is(opts.target)) {
	                    return;
	                }
	
	                // handle padding and border correctly (required when not using border-box)
	                if ($that.css('box-sizing') !== 'border-box') {
	                    verticalPadding += _parse($that.css('border-top-width')) + _parse($that.css('border-bottom-width'));
	                    verticalPadding += _parse($that.css('padding-top')) + _parse($that.css('padding-bottom'));
	                }
	
	                // set the height (accounting for padding and border)
	                $that.css(opts.property, (targetHeight - verticalPadding) + 'px');
	            });
	        });
	
	        // revert hidden parents
	        $hiddenParents.each(function() {
	            var $that = $(this);
	            $that.attr('style', $that.data('style-cache') || null);
	        });
	
	        // restore scroll position if enabled
	        if (matchHeight._maintainScroll) {
	            $(window).scrollTop((scrollTop / htmlHeight) * $('html').outerHeight(true));
	        }
	
	        return this;
	    };
	
	    /*
	    *  matchHeight._applyDataApi
	    *  applies matchHeight to all elements with a data-match-height attribute
	    */
	
	    matchHeight._applyDataApi = function() {
	        var groups = {};
	
	        // generate groups by their groupId set by elements using data-match-height
	        $('[data-match-height], [data-mh]').each(function() {
	            var $this = $(this),
	                groupId = $this.attr('data-mh') || $this.attr('data-match-height');
	
	            if (groupId in groups) {
	                groups[groupId] = groups[groupId].add($this);
	            } else {
	                groups[groupId] = $this;
	            }
	        });
	
	        // apply matchHeight to each group
	        $.each(groups, function() {
	            this.matchHeight(true);
	        });
	    };
	
	    /*
	    *  matchHeight._update
	    *  updates matchHeight on all current groups with their correct options
	    */
	
	    var _update = function(event) {
	        if (matchHeight._beforeUpdate) {
	            matchHeight._beforeUpdate(event, matchHeight._groups);
	        }
	
	        $.each(matchHeight._groups, function() {
	            matchHeight._apply(this.elements, this.options);
	        });
	
	        if (matchHeight._afterUpdate) {
	            matchHeight._afterUpdate(event, matchHeight._groups);
	        }
	    };
	
	    matchHeight._update = function(throttle, event) {
	        // prevent update if fired from a resize event
	        // where the viewport width hasn't actually changed
	        // fixes an event looping bug in IE8
	        if (event && event.type === 'resize') {
	            var windowWidth = $(window).width();
	            if (windowWidth === _previousResizeWidth) {
	                return;
	            }
	            _previousResizeWidth = windowWidth;
	        }
	
	        // throttle updates
	        if (!throttle) {
	            _update(event);
	        } else if (_updateTimeout === -1) {
	            _updateTimeout = setTimeout(function() {
	                _update(event);
	                _updateTimeout = -1;
	            }, matchHeight._throttle);
	        }
	    };
	
	    /*
	    *  bind events
	    */
	
	    // apply on DOM ready event
	    $(matchHeight._applyDataApi);
	
	    // use on or bind where supported
	    var on = $.fn.on ? 'on' : 'bind';
	
	    // update heights on load and resize events
	    $(window)[on]('load', function(event) {
	        matchHeight._update(false, event);
	    });
	
	    // throttled update heights on resize events
	    $(window)[on]('resize orientationchange', function(event) {
	        matchHeight._update(true, event);
	    });
	
	});


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(245);
	var constants = __webpack_require__(1813);
	var client = __webpack_require__(1812);
	var getUser = __webpack_require__(1339);
	
	/**
	 * Services all have the same constructor pattern: you initialize them
	 * with an access token and options, and they validate those arguments
	 * in a predictable way. This is a constructor-generator that makes
	 * it possible to require each service's API individually.
	 *
	 * @private
	 * @param {string} name the name of the Mapbox API this class will access:
	 * this is set to the name of the function so it will show up in tracebacks
	 * @returns {Function} constructor function
	 */
	function makeService(name) {
	
	  function service(accessToken, options) {
	    this.name = name;
	
	    invariant(typeof accessToken === 'string',
	      'accessToken required to instantiate Mapbox client');
	
	    var endpoint = constants.DEFAULT_ENDPOINT;
	
	    if (options !== undefined) {
	      invariant(typeof options === 'object', 'options must be an object');
	      if (options.endpoint) {
	        invariant(typeof options.endpoint === 'string', 'endpoint must be a string');
	        endpoint = options.endpoint;
	      }
	      if (options.account) {
	        invariant(typeof options.account === 'string', 'account must be a string');
	        this.owner = options.account;
	      }
	    }
	
	    this.client = client({
	      endpoint: endpoint,
	      accessToken: accessToken
	    });
	
	    this.accessToken = accessToken;
	    this.endpoint = endpoint;
	    this.owner = this.owner || getUser(accessToken);
	    invariant(!!this.owner, 'could not determine account from provided accessToken');
	
	  }
	
	  return service;
	}
	
	module.exports = makeService;


/***/ },
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1752);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./bootstrap-toggle.css", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./bootstrap-toggle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1759);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./video-js.css", function() {
				var newContent = require("!!../../css-loader/index.js!./video-js.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * @license
	 * Video.js 7.21.7 <http://videojs.com/>
	 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
	 * Available under Apache License Version 2.0
	 * <https://github.com/videojs/video.js/blob/main/LICENSE>
	 *
	 * Includes vtt.js <https://github.com/mozilla/vtt.js>
	 * Available under Apache License Version 2.0
	 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
	 */
	
	'use strict';
	
	var window$1 = __webpack_require__(344);
	var document = __webpack_require__(1335);
	var _extends = __webpack_require__(940);
	var keycode = __webpack_require__(1807);
	var _assertThisInitialized = __webpack_require__(1275);
	var _inheritsLoose = __webpack_require__(1277);
	var safeParseTuple = __webpack_require__(1865);
	var XHR = __webpack_require__(1533);
	var vtt = __webpack_require__(1948);
	var _construct = __webpack_require__(1276);
	var _inherits = __webpack_require__(1519);
	var _resolveUrl = __webpack_require__(1281);
	var m3u8Parser = __webpack_require__(1810);
	var codecs_js = __webpack_require__(1523);
	var mediaTypes_js = __webpack_require__(1527);
	var byteHelpers = __webpack_require__(476);
	var mpdParser = __webpack_require__(1834);
	var parseSidx = __webpack_require__(1836);
	var id3Helpers = __webpack_require__(1280);
	var containers = __webpack_require__(1524);
	var clock = __webpack_require__(1837);
	var _wrapNativeSuper = __webpack_require__(1522);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var window__default = /*#__PURE__*/_interopDefaultLegacy(window$1);
	var document__default = /*#__PURE__*/_interopDefaultLegacy(document);
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var keycode__default = /*#__PURE__*/_interopDefaultLegacy(keycode);
	var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
	var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
	var safeParseTuple__default = /*#__PURE__*/_interopDefaultLegacy(safeParseTuple);
	var XHR__default = /*#__PURE__*/_interopDefaultLegacy(XHR);
	var vtt__default = /*#__PURE__*/_interopDefaultLegacy(vtt);
	var _construct__default = /*#__PURE__*/_interopDefaultLegacy(_construct);
	var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
	var _resolveUrl__default = /*#__PURE__*/_interopDefaultLegacy(_resolveUrl);
	var parseSidx__default = /*#__PURE__*/_interopDefaultLegacy(parseSidx);
	var _wrapNativeSuper__default = /*#__PURE__*/_interopDefaultLegacy(_wrapNativeSuper);
	
	var version$5 = "7.21.7";
	
	/**
	 * An Object that contains lifecycle hooks as keys which point to an array
	 * of functions that are run when a lifecycle is triggered
	 *
	 * @private
	 */
	var hooks_ = {};
	/**
	 * Get a list of hooks for a specific lifecycle
	 *
	 * @param  {string} type
	 *         the lifecyle to get hooks from
	 *
	 * @param  {Function|Function[]} [fn]
	 *         Optionally add a hook (or hooks) to the lifecycle that your are getting.
	 *
	 * @return {Array}
	 *         an array of hooks, or an empty array if there are none.
	 */
	
	var hooks = function hooks(type, fn) {
	  hooks_[type] = hooks_[type] || [];
	
	  if (fn) {
	    hooks_[type] = hooks_[type].concat(fn);
	  }
	
	  return hooks_[type];
	};
	/**
	 * Add a function hook to a specific videojs lifecycle.
	 *
	 * @param {string} type
	 *        the lifecycle to hook the function to.
	 *
	 * @param {Function|Function[]}
	 *        The function or array of functions to attach.
	 */
	
	
	var hook = function hook(type, fn) {
	  hooks(type, fn);
	};
	/**
	 * Remove a hook from a specific videojs lifecycle.
	 *
	 * @param  {string} type
	 *         the lifecycle that the function hooked to
	 *
	 * @param  {Function} fn
	 *         The hooked function to remove
	 *
	 * @return {boolean}
	 *         The function that was removed or undef
	 */
	
	
	var removeHook = function removeHook(type, fn) {
	  var index = hooks(type).indexOf(fn);
	
	  if (index <= -1) {
	    return false;
	  }
	
	  hooks_[type] = hooks_[type].slice();
	  hooks_[type].splice(index, 1);
	  return true;
	};
	/**
	 * Add a function hook that will only run once to a specific videojs lifecycle.
	 *
	 * @param {string} type
	 *        the lifecycle to hook the function to.
	 *
	 * @param {Function|Function[]}
	 *        The function or array of functions to attach.
	 */
	
	
	var hookOnce = function hookOnce(type, fn) {
	  hooks(type, [].concat(fn).map(function (original) {
	    var wrapper = function wrapper() {
	      removeHook(type, wrapper);
	      return original.apply(void 0, arguments);
	    };
	
	    return wrapper;
	  }));
	};
	
	/**
	 * @file fullscreen-api.js
	 * @module fullscreen-api
	 * @private
	 */
	/**
	 * Store the browser-specific methods for the fullscreen API.
	 *
	 * @type {Object}
	 * @see [Specification]{@link https://fullscreen.spec.whatwg.org}
	 * @see [Map Approach From Screenfull.js]{@link https://github.com/sindresorhus/screenfull.js}
	 */
	
	var FullscreenApi = {
	  prefixed: true
	}; // browser API methods
	
	var apiMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror', 'fullscreen'], // WebKit
	['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror', '-webkit-full-screen'], // Mozilla
	['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror', '-moz-full-screen'], // Microsoft
	['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError', '-ms-fullscreen']];
	var specApi = apiMap[0];
	var browserApi; // determine the supported set of functions
	
	for (var i = 0; i < apiMap.length; i++) {
	  // check for exitFullscreen function
	  if (apiMap[i][1] in document__default['default']) {
	    browserApi = apiMap[i];
	    break;
	  }
	} // map the browser API names to the spec API names
	
	
	if (browserApi) {
	  for (var _i = 0; _i < browserApi.length; _i++) {
	    FullscreenApi[specApi[_i]] = browserApi[_i];
	  }
	
	  FullscreenApi.prefixed = browserApi[0] !== specApi[0];
	}
	
	/**
	 * @file create-logger.js
	 * @module create-logger
	 */
	
	var history = [];
	/**
	 * Log messages to the console and history based on the type of message
	 *
	 * @private
	 * @param  {string} type
	 *         The name of the console method to use.
	 *
	 * @param  {Array} args
	 *         The arguments to be passed to the matching console method.
	 */
	
	var LogByTypeFactory = function LogByTypeFactory(name, log) {
	  return function (type, level, args) {
	    var lvl = log.levels[level];
	    var lvlRegExp = new RegExp("^(" + lvl + ")$");
	
	    if (type !== 'log') {
	      // Add the type to the front of the message when it's not "log".
	      args.unshift(type.toUpperCase() + ':');
	    } // Add console prefix after adding to history.
	
	
	    args.unshift(name + ':'); // Add a clone of the args at this point to history.
	
	    if (history) {
	      history.push([].concat(args)); // only store 1000 history entries
	
	      var splice = history.length - 1000;
	      history.splice(0, splice > 0 ? splice : 0);
	    } // If there's no console then don't try to output messages, but they will
	    // still be stored in history.
	
	
	    if (!window__default['default'].console) {
	      return;
	    } // Was setting these once outside of this function, but containing them
	    // in the function makes it easier to test cases where console doesn't exist
	    // when the module is executed.
	
	
	    var fn = window__default['default'].console[type];
	
	    if (!fn && type === 'debug') {
	      // Certain browsers don't have support for console.debug. For those, we
	      // should default to the closest comparable log.
	      fn = window__default['default'].console.info || window__default['default'].console.log;
	    } // Bail out if there's no console or if this type is not allowed by the
	    // current logging level.
	
	
	    if (!fn || !lvl || !lvlRegExp.test(type)) {
	      return;
	    }
	
	    fn[Array.isArray(args) ? 'apply' : 'call'](window__default['default'].console, args);
	  };
	};
	
	function createLogger$1(name) {
	  // This is the private tracking variable for logging level.
	  var level = 'info'; // the curried logByType bound to the specific log and history
	
	  var logByType;
	  /**
	   * Logs plain debug messages. Similar to `console.log`.
	   *
	   * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
	   * of our JSDoc template, we cannot properly document this as both a function
	   * and a namespace, so its function signature is documented here.
	   *
	   * #### Arguments
	   * ##### *args
	   * Mixed[]
	   *
	   * Any combination of values that could be passed to `console.log()`.
	   *
	   * #### Return Value
	   *
	   * `undefined`
	   *
	   * @namespace
	   * @param    {Mixed[]} args
	   *           One or more messages or objects that should be logged.
	   */
	
	  var log = function log() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    logByType('log', level, args);
	  }; // This is the logByType helper that the logging methods below use
	
	
	  logByType = LogByTypeFactory(name, log);
	  /**
	   * Create a new sublogger which chains the old name to the new name.
	   *
	   * For example, doing `videojs.log.createLogger('player')` and then using that logger will log the following:
	   * ```js
	   *  mylogger('foo');
	   *  // > VIDEOJS: player: foo
	   * ```
	   *
	   * @param {string} name
	   *        The name to add call the new logger
	   * @return {Object}
	   */
	
	  log.createLogger = function (subname) {
	    return createLogger$1(name + ': ' + subname);
	  };
	  /**
	   * Enumeration of available logging levels, where the keys are the level names
	   * and the values are `|`-separated strings containing logging methods allowed
	   * in that logging level. These strings are used to create a regular expression
	   * matching the function name being called.
	   *
	   * Levels provided by Video.js are:
	   *
	   * - `off`: Matches no calls. Any value that can be cast to `false` will have
	   *   this effect. The most restrictive.
	   * - `all`: Matches only Video.js-provided functions (`debug`, `log`,
	   *   `log.warn`, and `log.error`).
	   * - `debug`: Matches `log.debug`, `log`, `log.warn`, and `log.error` calls.
	   * - `info` (default): Matches `log`, `log.warn`, and `log.error` calls.
	   * - `warn`: Matches `log.warn` and `log.error` calls.
	   * - `error`: Matches only `log.error` calls.
	   *
	   * @type {Object}
	   */
	
	
	  log.levels = {
	    all: 'debug|log|warn|error',
	    off: '',
	    debug: 'debug|log|warn|error',
	    info: 'log|warn|error',
	    warn: 'warn|error',
	    error: 'error',
	    DEFAULT: level
	  };
	  /**
	   * Get or set the current logging level.
	   *
	   * If a string matching a key from {@link module:log.levels} is provided, acts
	   * as a setter.
	   *
	   * @param  {string} [lvl]
	   *         Pass a valid level to set a new logging level.
	   *
	   * @return {string}
	   *         The current logging level.
	   */
	
	  log.level = function (lvl) {
	    if (typeof lvl === 'string') {
	      if (!log.levels.hasOwnProperty(lvl)) {
	        throw new Error("\"" + lvl + "\" in not a valid log level");
	      }
	
	      level = lvl;
	    }
	
	    return level;
	  };
	  /**
	   * Returns an array containing everything that has been logged to the history.
	   *
	   * This array is a shallow clone of the internal history record. However, its
	   * contents are _not_ cloned; so, mutating objects inside this array will
	   * mutate them in history.
	   *
	   * @return {Array}
	   */
	
	
	  log.history = function () {
	    return history ? [].concat(history) : [];
	  };
	  /**
	   * Allows you to filter the history by the given logger name
	   *
	   * @param {string} fname
	   *        The name to filter by
	   *
	   * @return {Array}
	   *         The filtered list to return
	   */
	
	
	  log.history.filter = function (fname) {
	    return (history || []).filter(function (historyItem) {
	      // if the first item in each historyItem includes `fname`, then it's a match
	      return new RegExp(".*" + fname + ".*").test(historyItem[0]);
	    });
	  };
	  /**
	   * Clears the internal history tracking, but does not prevent further history
	   * tracking.
	   */
	
	
	  log.history.clear = function () {
	    if (history) {
	      history.length = 0;
	    }
	  };
	  /**
	   * Disable history tracking if it is currently enabled.
	   */
	
	
	  log.history.disable = function () {
	    if (history !== null) {
	      history.length = 0;
	      history = null;
	    }
	  };
	  /**
	   * Enable history tracking if it is currently disabled.
	   */
	
	
	  log.history.enable = function () {
	    if (history === null) {
	      history = [];
	    }
	  };
	  /**
	   * Logs error messages. Similar to `console.error`.
	   *
	   * @param {Mixed[]} args
	   *        One or more messages or objects that should be logged as an error
	   */
	
	
	  log.error = function () {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return logByType('error', level, args);
	  };
	  /**
	   * Logs warning messages. Similar to `console.warn`.
	   *
	   * @param {Mixed[]} args
	   *        One or more messages or objects that should be logged as a warning.
	   */
	
	
	  log.warn = function () {
	    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return logByType('warn', level, args);
	  };
	  /**
	   * Logs debug messages. Similar to `console.debug`, but may also act as a comparable
	   * log if `console.debug` is not available
	   *
	   * @param {Mixed[]} args
	   *        One or more messages or objects that should be logged as debug.
	   */
	
	
	  log.debug = function () {
	    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    return logByType('debug', level, args);
	  };
	
	  return log;
	}
	
	/**
	 * @file log.js
	 * @module log
	 */
	var log$1 = createLogger$1('VIDEOJS');
	var createLogger = log$1.createLogger;
	
	/**
	 * @file obj.js
	 * @module obj
	 */
	
	/**
	 * @callback obj:EachCallback
	 *
	 * @param {Mixed} value
	 *        The current key for the object that is being iterated over.
	 *
	 * @param {string} key
	 *        The current key-value for object that is being iterated over
	 */
	
	/**
	 * @callback obj:ReduceCallback
	 *
	 * @param {Mixed} accum
	 *        The value that is accumulating over the reduce loop.
	 *
	 * @param {Mixed} value
	 *        The current key for the object that is being iterated over.
	 *
	 * @param {string} key
	 *        The current key-value for object that is being iterated over
	 *
	 * @return {Mixed}
	 *         The new accumulated value.
	 */
	var toString = Object.prototype.toString;
	/**
	 * Get the keys of an Object
	 *
	 * @param {Object}
	 *        The Object to get the keys from
	 *
	 * @return {string[]}
	 *         An array of the keys from the object. Returns an empty array if the
	 *         object passed in was invalid or had no keys.
	 *
	 * @private
	 */
	
	var keys = function keys(object) {
	  return isObject(object) ? Object.keys(object) : [];
	};
	/**
	 * Array-like iteration for objects.
	 *
	 * @param {Object} object
	 *        The object to iterate over
	 *
	 * @param {obj:EachCallback} fn
	 *        The callback function which is called for each key in the object.
	 */
	
	
	function each(object, fn) {
	  keys(object).forEach(function (key) {
	    return fn(object[key], key);
	  });
	}
	/**
	 * Array-like reduce for objects.
	 *
	 * @param {Object} object
	 *        The Object that you want to reduce.
	 *
	 * @param {Function} fn
	 *         A callback function which is called for each key in the object. It
	 *         receives the accumulated value and the per-iteration value and key
	 *         as arguments.
	 *
	 * @param {Mixed} [initial = 0]
	 *        Starting value
	 *
	 * @return {Mixed}
	 *         The final accumulated value.
	 */
	
	function reduce(object, fn, initial) {
	  if (initial === void 0) {
	    initial = 0;
	  }
	
	  return keys(object).reduce(function (accum, key) {
	    return fn(accum, object[key], key);
	  }, initial);
	}
	/**
	 * Object.assign-style object shallow merge/extend.
	 *
	 * @param  {Object} target
	 * @param  {Object} ...sources
	 * @return {Object}
	 */
	
	function assign(target) {
	  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    sources[_key - 1] = arguments[_key];
	  }
	
	  if (Object.assign) {
	    return _extends__default['default'].apply(void 0, [target].concat(sources));
	  }
	
	  sources.forEach(function (source) {
	    if (!source) {
	      return;
	    }
	
	    each(source, function (value, key) {
	      target[key] = value;
	    });
	  });
	  return target;
	}
	/**
	 * Returns whether a value is an object of any kind - including DOM nodes,
	 * arrays, regular expressions, etc. Not functions, though.
	 *
	 * This avoids the gotcha where using `typeof` on a `null` value
	 * results in `'object'`.
	 *
	 * @param  {Object} value
	 * @return {boolean}
	 */
	
	function isObject(value) {
	  return !!value && typeof value === 'object';
	}
	/**
	 * Returns whether an object appears to be a "plain" object - that is, a
	 * direct instance of `Object`.
	 *
	 * @param  {Object} value
	 * @return {boolean}
	 */
	
	function isPlain(value) {
	  return isObject(value) && toString.call(value) === '[object Object]' && value.constructor === Object;
	}
	
	/**
	 * @file computed-style.js
	 * @module computed-style
	 */
	/**
	 * A safe getComputedStyle.
	 *
	 * This is needed because in Firefox, if the player is loaded in an iframe with
	 * `display:none`, then `getComputedStyle` returns `null`, so, we do a
	 * null-check to make sure that the player doesn't break in these cases.
	 *
	 * @function
	 * @param    {Element} el
	 *           The element you want the computed style of
	 *
	 * @param    {string} prop
	 *           The property name you want
	 *
	 * @see      https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 */
	
	function computedStyle(el, prop) {
	  if (!el || !prop) {
	    return '';
	  }
	
	  if (typeof window__default['default'].getComputedStyle === 'function') {
	    var computedStyleValue;
	
	    try {
	      computedStyleValue = window__default['default'].getComputedStyle(el);
	    } catch (e) {
	      return '';
	    }
	
	    return computedStyleValue ? computedStyleValue.getPropertyValue(prop) || computedStyleValue[prop] : '';
	  }
	
	  return '';
	}
	
	/**
	 * @file browser.js
	 * @module browser
	 */
	var USER_AGENT = window__default['default'].navigator && window__default['default'].navigator.userAgent || '';
	var webkitVersionMap = /AppleWebKit\/([\d.]+)/i.exec(USER_AGENT);
	var appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;
	/**
	 * Whether or not this device is an iPod.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_IPOD = /iPod/i.test(USER_AGENT);
	/**
	 * The detected iOS version - or `null`.
	 *
	 * @static
	 * @const
	 * @type {string|null}
	 */
	
	var IOS_VERSION = function () {
	  var match = USER_AGENT.match(/OS (\d+)_/i);
	
	  if (match && match[1]) {
	    return match[1];
	  }
	
	  return null;
	}();
	/**
	 * Whether or not this is an Android device.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_ANDROID = /Android/i.test(USER_AGENT);
	/**
	 * The detected Android version - or `null`.
	 *
	 * @static
	 * @const
	 * @type {number|string|null}
	 */
	
	var ANDROID_VERSION = function () {
	  // This matches Android Major.Minor.Patch versions
	  // ANDROID_VERSION is Major.Minor as a Number, if Minor isn't available, then only Major is returned
	  var match = USER_AGENT.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
	
	  if (!match) {
	    return null;
	  }
	
	  var major = match[1] && parseFloat(match[1]);
	  var minor = match[2] && parseFloat(match[2]);
	
	  if (major && minor) {
	    return parseFloat(match[1] + '.' + match[2]);
	  } else if (major) {
	    return major;
	  }
	
	  return null;
	}();
	/**
	 * Whether or not this is a native Android browser.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_NATIVE_ANDROID = IS_ANDROID && ANDROID_VERSION < 5 && appleWebkitVersion < 537;
	/**
	 * Whether or not this is Mozilla Firefox.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_FIREFOX = /Firefox/i.test(USER_AGENT);
	/**
	 * Whether or not this is Microsoft Edge.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_EDGE = /Edg/i.test(USER_AGENT);
	/**
	 * Whether or not this is Google Chrome.
	 *
	 * This will also be `true` for Chrome on iOS, which will have different support
	 * as it is actually Safari under the hood.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_CHROME = !IS_EDGE && (/Chrome/i.test(USER_AGENT) || /CriOS/i.test(USER_AGENT));
	/**
	 * The detected Google Chrome version - or `null`.
	 *
	 * @static
	 * @const
	 * @type {number|null}
	 */
	
	var CHROME_VERSION = function () {
	  var match = USER_AGENT.match(/(Chrome|CriOS)\/(\d+)/);
	
	  if (match && match[2]) {
	    return parseFloat(match[2]);
	  }
	
	  return null;
	}();
	/**
	 * The detected Internet Explorer version - or `null`.
	 *
	 * @static
	 * @const
	 * @type {number|null}
	 */
	
	var IE_VERSION = function () {
	  var result = /MSIE\s(\d+)\.\d/.exec(USER_AGENT);
	  var version = result && parseFloat(result[1]);
	
	  if (!version && /Trident\/7.0/i.test(USER_AGENT) && /rv:11.0/.test(USER_AGENT)) {
	    // IE 11 has a different user agent string than other IE versions
	    version = 11.0;
	  }
	
	  return version;
	}();
	/**
	 * Whether or not this is desktop Safari.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_SAFARI = /Safari/i.test(USER_AGENT) && !IS_CHROME && !IS_ANDROID && !IS_EDGE;
	/**
	 * Whether or not this is a Windows machine.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_WINDOWS = /Windows/i.test(USER_AGENT);
	/**
	 * Whether or not this device is touch-enabled.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var TOUCH_ENABLED = Boolean(isReal() && ('ontouchstart' in window__default['default'] || window__default['default'].navigator.maxTouchPoints || window__default['default'].DocumentTouch && window__default['default'].document instanceof window__default['default'].DocumentTouch));
	/**
	 * Whether or not this device is an iPad.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_IPAD = /iPad/i.test(USER_AGENT) || IS_SAFARI && TOUCH_ENABLED && !/iPhone/i.test(USER_AGENT);
	/**
	 * Whether or not this device is an iPhone.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	// The Facebook app's UIWebView identifies as both an iPhone and iPad, so
	// to identify iPhones, we need to exclude iPads.
	// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
	
	var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
	/**
	 * Whether or not this is an iOS device.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
	/**
	 * Whether or not this is any flavor of Safari - including iOS.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_ANY_SAFARI = (IS_SAFARI || IS_IOS) && !IS_CHROME;
	
	var browser = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  IS_IPOD: IS_IPOD,
	  IOS_VERSION: IOS_VERSION,
	  IS_ANDROID: IS_ANDROID,
	  ANDROID_VERSION: ANDROID_VERSION,
	  IS_NATIVE_ANDROID: IS_NATIVE_ANDROID,
	  IS_FIREFOX: IS_FIREFOX,
	  IS_EDGE: IS_EDGE,
	  IS_CHROME: IS_CHROME,
	  CHROME_VERSION: CHROME_VERSION,
	  IE_VERSION: IE_VERSION,
	  IS_SAFARI: IS_SAFARI,
	  IS_WINDOWS: IS_WINDOWS,
	  TOUCH_ENABLED: TOUCH_ENABLED,
	  IS_IPAD: IS_IPAD,
	  IS_IPHONE: IS_IPHONE,
	  IS_IOS: IS_IOS,
	  IS_ANY_SAFARI: IS_ANY_SAFARI
	});
	
	/**
	 * @file dom.js
	 * @module dom
	 */
	/**
	 * Detect if a value is a string with any non-whitespace characters.
	 *
	 * @private
	 * @param  {string} str
	 *         The string to check
	 *
	 * @return {boolean}
	 *         Will be `true` if the string is non-blank, `false` otherwise.
	 *
	 */
	
	function isNonBlankString(str) {
	  // we use str.trim as it will trim any whitespace characters
	  // from the front or back of non-whitespace characters. aka
	  // Any string that contains non-whitespace characters will
	  // still contain them after `trim` but whitespace only strings
	  // will have a length of 0, failing this check.
	  return typeof str === 'string' && Boolean(str.trim());
	}
	/**
	 * Throws an error if the passed string has whitespace. This is used by
	 * class methods to be relatively consistent with the classList API.
	 *
	 * @private
	 * @param  {string} str
	 *         The string to check for whitespace.
	 *
	 * @throws {Error}
	 *         Throws an error if there is whitespace in the string.
	 */
	
	
	function throwIfWhitespace(str) {
	  // str.indexOf instead of regex because str.indexOf is faster performance wise.
	  if (str.indexOf(' ') >= 0) {
	    throw new Error('class has illegal whitespace characters');
	  }
	}
	/**
	 * Produce a regular expression for matching a className within an elements className.
	 *
	 * @private
	 * @param  {string} className
	 *         The className to generate the RegExp for.
	 *
	 * @return {RegExp}
	 *         The RegExp that will check for a specific `className` in an elements
	 *         className.
	 */
	
	
	function classRegExp(className) {
	  return new RegExp('(^|\\s)' + className + '($|\\s)');
	}
	/**
	 * Whether the current DOM interface appears to be real (i.e. not simulated).
	 *
	 * @return {boolean}
	 *         Will be `true` if the DOM appears to be real, `false` otherwise.
	 */
	
	
	function isReal() {
	  // Both document and window will never be undefined thanks to `global`.
	  return document__default['default'] === window__default['default'].document;
	}
	/**
	 * Determines, via duck typing, whether or not a value is a DOM element.
	 *
	 * @param  {Mixed} value
	 *         The value to check.
	 *
	 * @return {boolean}
	 *         Will be `true` if the value is a DOM element, `false` otherwise.
	 */
	
	function isEl(value) {
	  return isObject(value) && value.nodeType === 1;
	}
	/**
	 * Determines if the current DOM is embedded in an iframe.
	 *
	 * @return {boolean}
	 *         Will be `true` if the DOM is embedded in an iframe, `false`
	 *         otherwise.
	 */
	
	function isInFrame() {
	  // We need a try/catch here because Safari will throw errors when attempting
	  // to get either `parent` or `self`
	  try {
	    return window__default['default'].parent !== window__default['default'].self;
	  } catch (x) {
	    return true;
	  }
	}
	/**
	 * Creates functions to query the DOM using a given method.
	 *
	 * @private
	 * @param   {string} method
	 *          The method to create the query with.
	 *
	 * @return  {Function}
	 *          The query method
	 */
	
	function createQuerier(method) {
	  return function (selector, context) {
	    if (!isNonBlankString(selector)) {
	      return document__default['default'][method](null);
	    }
	
	    if (isNonBlankString(context)) {
	      context = document__default['default'].querySelector(context);
	    }
	
	    var ctx = isEl(context) ? context : document__default['default'];
	    return ctx[method] && ctx[method](selector);
	  };
	}
	/**
	 * Creates an element and applies properties, attributes, and inserts content.
	 *
	 * @param  {string} [tagName='div']
	 *         Name of tag to be created.
	 *
	 * @param  {Object} [properties={}]
	 *         Element properties to be applied.
	 *
	 * @param  {Object} [attributes={}]
	 *         Element attributes to be applied.
	 *
	 * @param {module:dom~ContentDescriptor} content
	 *        A content descriptor object.
	 *
	 * @return {Element}
	 *         The element that was created.
	 */
	
	
	function createEl(tagName, properties, attributes, content) {
	  if (tagName === void 0) {
	    tagName = 'div';
	  }
	
	  if (properties === void 0) {
	    properties = {};
	  }
	
	  if (attributes === void 0) {
	    attributes = {};
	  }
	
	  var el = document__default['default'].createElement(tagName);
	  Object.getOwnPropertyNames(properties).forEach(function (propName) {
	    var val = properties[propName]; // See #2176
	    // We originally were accepting both properties and attributes in the
	    // same object, but that doesn't work so well.
	
	    if (propName.indexOf('aria-') !== -1 || propName === 'role' || propName === 'type') {
	      log$1.warn('Setting attributes in the second argument of createEl()\n' + 'has been deprecated. Use the third argument instead.\n' + ("createEl(type, properties, attributes). Attempting to set " + propName + " to " + val + "."));
	      el.setAttribute(propName, val); // Handle textContent since it's not supported everywhere and we have a
	      // method for it.
	    } else if (propName === 'textContent') {
	      textContent(el, val);
	    } else if (el[propName] !== val || propName === 'tabIndex') {
	      el[propName] = val;
	    }
	  });
	  Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
	    el.setAttribute(attrName, attributes[attrName]);
	  });
	
	  if (content) {
	    appendContent(el, content);
	  }
	
	  return el;
	}
	/**
	 * Injects text into an element, replacing any existing contents entirely.
	 *
	 * @param  {Element} el
	 *         The element to add text content into
	 *
	 * @param  {string} text
	 *         The text content to add.
	 *
	 * @return {Element}
	 *         The element with added text content.
	 */
	
	function textContent(el, text) {
	  if (typeof el.textContent === 'undefined') {
	    el.innerText = text;
	  } else {
	    el.textContent = text;
	  }
	
	  return el;
	}
	/**
	 * Insert an element as the first child node of another
	 *
	 * @param {Element} child
	 *        Element to insert
	 *
	 * @param {Element} parent
	 *        Element to insert child into
	 */
	
	function prependTo(child, parent) {
	  if (parent.firstChild) {
	    parent.insertBefore(child, parent.firstChild);
	  } else {
	    parent.appendChild(child);
	  }
	}
	/**
	 * Check if an element has a class name.
	 *
	 * @param  {Element} element
	 *         Element to check
	 *
	 * @param  {string} classToCheck
	 *         Class name to check for
	 *
	 * @return {boolean}
	 *         Will be `true` if the element has a class, `false` otherwise.
	 *
	 * @throws {Error}
	 *         Throws an error if `classToCheck` has white space.
	 */
	
	function hasClass(element, classToCheck) {
	  throwIfWhitespace(classToCheck);
	
	  if (element.classList) {
	    return element.classList.contains(classToCheck);
	  }
	
	  return classRegExp(classToCheck).test(element.className);
	}
	/**
	 * Add a class name to an element.
	 *
	 * @param  {Element} element
	 *         Element to add class name to.
	 *
	 * @param  {string} classToAdd
	 *         Class name to add.
	 *
	 * @return {Element}
	 *         The DOM element with the added class name.
	 */
	
	function addClass(element, classToAdd) {
	  if (element.classList) {
	    element.classList.add(classToAdd); // Don't need to `throwIfWhitespace` here because `hasElClass` will do it
	    // in the case of classList not being supported.
	  } else if (!hasClass(element, classToAdd)) {
	    element.className = (element.className + ' ' + classToAdd).trim();
	  }
	
	  return element;
	}
	/**
	 * Remove a class name from an element.
	 *
	 * @param  {Element} element
	 *         Element to remove a class name from.
	 *
	 * @param  {string} classToRemove
	 *         Class name to remove
	 *
	 * @return {Element}
	 *         The DOM element with class name removed.
	 */
	
	function removeClass(element, classToRemove) {
	  // Protect in case the player gets disposed
	  if (!element) {
	    log$1.warn("removeClass was called with an element that doesn't exist");
	    return null;
	  }
	
	  if (element.classList) {
	    element.classList.remove(classToRemove);
	  } else {
	    throwIfWhitespace(classToRemove);
	    element.className = element.className.split(/\s+/).filter(function (c) {
	      return c !== classToRemove;
	    }).join(' ');
	  }
	
	  return element;
	}
	/**
	 * The callback definition for toggleClass.
	 *
	 * @callback module:dom~PredicateCallback
	 * @param    {Element} element
	 *           The DOM element of the Component.
	 *
	 * @param    {string} classToToggle
	 *           The `className` that wants to be toggled
	 *
	 * @return   {boolean|undefined}
	 *           If `true` is returned, the `classToToggle` will be added to the
	 *           `element`. If `false`, the `classToToggle` will be removed from
	 *           the `element`. If `undefined`, the callback will be ignored.
	 */
	
	/**
	 * Adds or removes a class name to/from an element depending on an optional
	 * condition or the presence/absence of the class name.
	 *
	 * @param  {Element} element
	 *         The element to toggle a class name on.
	 *
	 * @param  {string} classToToggle
	 *         The class that should be toggled.
	 *
	 * @param  {boolean|module:dom~PredicateCallback} [predicate]
	 *         See the return value for {@link module:dom~PredicateCallback}
	 *
	 * @return {Element}
	 *         The element with a class that has been toggled.
	 */
	
	function toggleClass(element, classToToggle, predicate) {
	  // This CANNOT use `classList` internally because IE11 does not support the
	  // second parameter to the `classList.toggle()` method! Which is fine because
	  // `classList` will be used by the add/remove functions.
	  var has = hasClass(element, classToToggle);
	
	  if (typeof predicate === 'function') {
	    predicate = predicate(element, classToToggle);
	  }
	
	  if (typeof predicate !== 'boolean') {
	    predicate = !has;
	  } // If the necessary class operation matches the current state of the
	  // element, no action is required.
	
	
	  if (predicate === has) {
	    return;
	  }
	
	  if (predicate) {
	    addClass(element, classToToggle);
	  } else {
	    removeClass(element, classToToggle);
	  }
	
	  return element;
	}
	/**
	 * Apply attributes to an HTML element.
	 *
	 * @param {Element} el
	 *        Element to add attributes to.
	 *
	 * @param {Object} [attributes]
	 *        Attributes to be applied.
	 */
	
	function setAttributes(el, attributes) {
	  Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
	    var attrValue = attributes[attrName];
	
	    if (attrValue === null || typeof attrValue === 'undefined' || attrValue === false) {
	      el.removeAttribute(attrName);
	    } else {
	      el.setAttribute(attrName, attrValue === true ? '' : attrValue);
	    }
	  });
	}
	/**
	 * Get an element's attribute values, as defined on the HTML tag.
	 *
	 * Attributes are not the same as properties. They're defined on the tag
	 * or with setAttribute.
	 *
	 * @param  {Element} tag
	 *         Element from which to get tag attributes.
	 *
	 * @return {Object}
	 *         All attributes of the element. Boolean attributes will be `true` or
	 *         `false`, others will be strings.
	 */
	
	function getAttributes(tag) {
	  var obj = {}; // known boolean attributes
	  // we can check for matching boolean properties, but not all browsers
	  // and not all tags know about these attributes, so, we still want to check them manually
	
	  var knownBooleans = ',' + 'autoplay,controls,playsinline,loop,muted,default,defaultMuted' + ',';
	
	  if (tag && tag.attributes && tag.attributes.length > 0) {
	    var attrs = tag.attributes;
	
	    for (var i = attrs.length - 1; i >= 0; i--) {
	      var attrName = attrs[i].name;
	      var attrVal = attrs[i].value; // check for known booleans
	      // the matching element property will return a value for typeof
	
	      if (typeof tag[attrName] === 'boolean' || knownBooleans.indexOf(',' + attrName + ',') !== -1) {
	        // the value of an included boolean attribute is typically an empty
	        // string ('') which would equal false if we just check for a false value.
	        // we also don't want support bad code like autoplay='false'
	        attrVal = attrVal !== null ? true : false;
	      }
	
	      obj[attrName] = attrVal;
	    }
	  }
	
	  return obj;
	}
	/**
	 * Get the value of an element's attribute.
	 *
	 * @param {Element} el
	 *        A DOM element.
	 *
	 * @param {string} attribute
	 *        Attribute to get the value of.
	 *
	 * @return {string}
	 *         The value of the attribute.
	 */
	
	function getAttribute(el, attribute) {
	  return el.getAttribute(attribute);
	}
	/**
	 * Set the value of an element's attribute.
	 *
	 * @param {Element} el
	 *        A DOM element.
	 *
	 * @param {string} attribute
	 *        Attribute to set.
	 *
	 * @param {string} value
	 *        Value to set the attribute to.
	 */
	
	function setAttribute(el, attribute, value) {
	  el.setAttribute(attribute, value);
	}
	/**
	 * Remove an element's attribute.
	 *
	 * @param {Element} el
	 *        A DOM element.
	 *
	 * @param {string} attribute
	 *        Attribute to remove.
	 */
	
	function removeAttribute(el, attribute) {
	  el.removeAttribute(attribute);
	}
	/**
	 * Attempt to block the ability to select text.
	 */
	
	function blockTextSelection() {
	  document__default['default'].body.focus();
	
	  document__default['default'].onselectstart = function () {
	    return false;
	  };
	}
	/**
	 * Turn off text selection blocking.
	 */
	
	function unblockTextSelection() {
	  document__default['default'].onselectstart = function () {
	    return true;
	  };
	}
	/**
	 * Identical to the native `getBoundingClientRect` function, but ensures that
	 * the method is supported at all (it is in all browsers we claim to support)
	 * and that the element is in the DOM before continuing.
	 *
	 * This wrapper function also shims properties which are not provided by some
	 * older browsers (namely, IE8).
	 *
	 * Additionally, some browsers do not support adding properties to a
	 * `ClientRect`/`DOMRect` object; so, we shallow-copy it with the standard
	 * properties (except `x` and `y` which are not widely supported). This helps
	 * avoid implementations where keys are non-enumerable.
	 *
	 * @param  {Element} el
	 *         Element whose `ClientRect` we want to calculate.
	 *
	 * @return {Object|undefined}
	 *         Always returns a plain object - or `undefined` if it cannot.
	 */
	
	function getBoundingClientRect(el) {
	  if (el && el.getBoundingClientRect && el.parentNode) {
	    var rect = el.getBoundingClientRect();
	    var result = {};
	    ['bottom', 'height', 'left', 'right', 'top', 'width'].forEach(function (k) {
	      if (rect[k] !== undefined) {
	        result[k] = rect[k];
	      }
	    });
	
	    if (!result.height) {
	      result.height = parseFloat(computedStyle(el, 'height'));
	    }
	
	    if (!result.width) {
	      result.width = parseFloat(computedStyle(el, 'width'));
	    }
	
	    return result;
	  }
	}
	/**
	 * Represents the position of a DOM element on the page.
	 *
	 * @typedef  {Object} module:dom~Position
	 *
	 * @property {number} left
	 *           Pixels to the left.
	 *
	 * @property {number} top
	 *           Pixels from the top.
	 */
	
	/**
	 * Get the position of an element in the DOM.
	 *
	 * Uses `getBoundingClientRect` technique from John Resig.
	 *
	 * @see http://ejohn.org/blog/getboundingclientrect-is-awesome/
	 *
	 * @param  {Element} el
	 *         Element from which to get offset.
	 *
	 * @return {module:dom~Position}
	 *         The position of the element that was passed in.
	 */
	
	function findPosition(el) {
	  if (!el || el && !el.offsetParent) {
	    return {
	      left: 0,
	      top: 0,
	      width: 0,
	      height: 0
	    };
	  }
	
	  var width = el.offsetWidth;
	  var height = el.offsetHeight;
	  var left = 0;
	  var top = 0;
	
	  while (el.offsetParent && el !== document__default['default'][FullscreenApi.fullscreenElement]) {
	    left += el.offsetLeft;
	    top += el.offsetTop;
	    el = el.offsetParent;
	  }
	
	  return {
	    left: left,
	    top: top,
	    width: width,
	    height: height
	  };
	}
	/**
	 * Represents x and y coordinates for a DOM element or mouse pointer.
	 *
	 * @typedef  {Object} module:dom~Coordinates
	 *
	 * @property {number} x
	 *           x coordinate in pixels
	 *
	 * @property {number} y
	 *           y coordinate in pixels
	 */
	
	/**
	 * Get the pointer position within an element.
	 *
	 * The base on the coordinates are the bottom left of the element.
	 *
	 * @param  {Element} el
	 *         Element on which to get the pointer position on.
	 *
	 * @param  {EventTarget~Event} event
	 *         Event object.
	 *
	 * @return {module:dom~Coordinates}
	 *         A coordinates object corresponding to the mouse position.
	 *
	 */
	
	function getPointerPosition(el, event) {
	  var translated = {
	    x: 0,
	    y: 0
	  };
	
	  if (IS_IOS) {
	    var item = el;
	
	    while (item && item.nodeName.toLowerCase() !== 'html') {
	      var transform = computedStyle(item, 'transform');
	
	      if (/^matrix/.test(transform)) {
	        var values = transform.slice(7, -1).split(/,\s/).map(Number);
	        translated.x += values[4];
	        translated.y += values[5];
	      } else if (/^matrix3d/.test(transform)) {
	        var _values = transform.slice(9, -1).split(/,\s/).map(Number);
	
	        translated.x += _values[12];
	        translated.y += _values[13];
	      }
	
	      item = item.parentNode;
	    }
	  }
	
	  var position = {};
	  var boxTarget = findPosition(event.target);
	  var box = findPosition(el);
	  var boxW = box.width;
	  var boxH = box.height;
	  var offsetY = event.offsetY - (box.top - boxTarget.top);
	  var offsetX = event.offsetX - (box.left - boxTarget.left);
	
	  if (event.changedTouches) {
	    offsetX = event.changedTouches[0].pageX - box.left;
	    offsetY = event.changedTouches[0].pageY + box.top;
	
	    if (IS_IOS) {
	      offsetX -= translated.x;
	      offsetY -= translated.y;
	    }
	  }
	
	  position.y = 1 - Math.max(0, Math.min(1, offsetY / boxH));
	  position.x = Math.max(0, Math.min(1, offsetX / boxW));
	  return position;
	}
	/**
	 * Determines, via duck typing, whether or not a value is a text node.
	 *
	 * @param  {Mixed} value
	 *         Check if this value is a text node.
	 *
	 * @return {boolean}
	 *         Will be `true` if the value is a text node, `false` otherwise.
	 */
	
	function isTextNode(value) {
	  return isObject(value) && value.nodeType === 3;
	}
	/**
	 * Empties the contents of an element.
	 *
	 * @param  {Element} el
	 *         The element to empty children from
	 *
	 * @return {Element}
	 *         The element with no children
	 */
	
	function emptyEl(el) {
	  while (el.firstChild) {
	    el.removeChild(el.firstChild);
	  }
	
	  return el;
	}
	/**
	 * This is a mixed value that describes content to be injected into the DOM
	 * via some method. It can be of the following types:
	 *
	 * Type       | Description
	 * -----------|-------------
	 * `string`   | The value will be normalized into a text node.
	 * `Element`  | The value will be accepted as-is.
	 * `TextNode` | The value will be accepted as-is.
	 * `Array`    | A one-dimensional array of strings, elements, text nodes, or functions. These functions should return a string, element, or text node (any other return value, like an array, will be ignored).
	 * `Function` | A function, which is expected to return a string, element, text node, or array - any of the other possible values described above. This means that a content descriptor could be a function that returns an array of functions, but those second-level functions must return strings, elements, or text nodes.
	 *
	 * @typedef {string|Element|TextNode|Array|Function} module:dom~ContentDescriptor
	 */
	
	/**
	 * Normalizes content for eventual insertion into the DOM.
	 *
	 * This allows a wide range of content definition methods, but helps protect
	 * from falling into the trap of simply writing to `innerHTML`, which could
	 * be an XSS concern.
	 *
	 * The content for an element can be passed in multiple types and
	 * combinations, whose behavior is as follows:
	 *
	 * @param {module:dom~ContentDescriptor} content
	 *        A content descriptor value.
	 *
	 * @return {Array}
	 *         All of the content that was passed in, normalized to an array of
	 *         elements or text nodes.
	 */
	
	function normalizeContent(content) {
	  // First, invoke content if it is a function. If it produces an array,
	  // that needs to happen before normalization.
	  if (typeof content === 'function') {
	    content = content();
	  } // Next up, normalize to an array, so one or many items can be normalized,
	  // filtered, and returned.
	
	
	  return (Array.isArray(content) ? content : [content]).map(function (value) {
	    // First, invoke value if it is a function to produce a new value,
	    // which will be subsequently normalized to a Node of some kind.
	    if (typeof value === 'function') {
	      value = value();
	    }
	
	    if (isEl(value) || isTextNode(value)) {
	      return value;
	    }
	
	    if (typeof value === 'string' && /\S/.test(value)) {
	      return document__default['default'].createTextNode(value);
	    }
	  }).filter(function (value) {
	    return value;
	  });
	}
	/**
	 * Normalizes and appends content to an element.
	 *
	 * @param  {Element} el
	 *         Element to append normalized content to.
	 *
	 * @param {module:dom~ContentDescriptor} content
	 *        A content descriptor value.
	 *
	 * @return {Element}
	 *         The element with appended normalized content.
	 */
	
	function appendContent(el, content) {
	  normalizeContent(content).forEach(function (node) {
	    return el.appendChild(node);
	  });
	  return el;
	}
	/**
	 * Normalizes and inserts content into an element; this is identical to
	 * `appendContent()`, except it empties the element first.
	 *
	 * @param {Element} el
	 *        Element to insert normalized content into.
	 *
	 * @param {module:dom~ContentDescriptor} content
	 *        A content descriptor value.
	 *
	 * @return {Element}
	 *         The element with inserted normalized content.
	 */
	
	function insertContent(el, content) {
	  return appendContent(emptyEl(el), content);
	}
	/**
	 * Check if an event was a single left click.
	 *
	 * @param  {EventTarget~Event} event
	 *         Event object.
	 *
	 * @return {boolean}
	 *         Will be `true` if a single left click, `false` otherwise.
	 */
	
	function isSingleLeftClick(event) {
	  // Note: if you create something draggable, be sure to
	  // call it on both `mousedown` and `mousemove` event,
	  // otherwise `mousedown` should be enough for a button
	  if (event.button === undefined && event.buttons === undefined) {
	    // Why do we need `buttons` ?
	    // Because, middle mouse sometimes have this:
	    // e.button === 0 and e.buttons === 4
	    // Furthermore, we want to prevent combination click, something like
	    // HOLD middlemouse then left click, that would be
	    // e.button === 0, e.buttons === 5
	    // just `button` is not gonna work
	    // Alright, then what this block does ?
	    // this is for chrome `simulate mobile devices`
	    // I want to support this as well
	    return true;
	  }
	
	  if (event.button === 0 && event.buttons === undefined) {
	    // Touch screen, sometimes on some specific device, `buttons`
	    // doesn't have anything (safari on ios, blackberry...)
	    return true;
	  } // `mouseup` event on a single left click has
	  // `button` and `buttons` equal to 0
	
	
	  if (event.type === 'mouseup' && event.button === 0 && event.buttons === 0) {
	    return true;
	  }
	
	  if (event.button !== 0 || event.buttons !== 1) {
	    // This is the reason we have those if else block above
	    // if any special case we can catch and let it slide
	    // we do it above, when get to here, this definitely
	    // is-not-left-click
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Finds a single DOM element matching `selector` within the optional
	 * `context` of another DOM element (defaulting to `document`).
	 *
	 * @param  {string} selector
	 *         A valid CSS selector, which will be passed to `querySelector`.
	 *
	 * @param  {Element|String} [context=document]
	 *         A DOM element within which to query. Can also be a selector
	 *         string in which case the first matching element will be used
	 *         as context. If missing (or no element matches selector), falls
	 *         back to `document`.
	 *
	 * @return {Element|null}
	 *         The element that was found or null.
	 */
	
	var $ = createQuerier('querySelector');
	/**
	 * Finds a all DOM elements matching `selector` within the optional
	 * `context` of another DOM element (defaulting to `document`).
	 *
	 * @param  {string} selector
	 *         A valid CSS selector, which will be passed to `querySelectorAll`.
	 *
	 * @param  {Element|String} [context=document]
	 *         A DOM element within which to query. Can also be a selector
	 *         string in which case the first matching element will be used
	 *         as context. If missing (or no element matches selector), falls
	 *         back to `document`.
	 *
	 * @return {NodeList}
	 *         A element list of elements that were found. Will be empty if none
	 *         were found.
	 *
	 */
	
	var $$ = createQuerier('querySelectorAll');
	
	var Dom = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  isReal: isReal,
	  isEl: isEl,
	  isInFrame: isInFrame,
	  createEl: createEl,
	  textContent: textContent,
	  prependTo: prependTo,
	  hasClass: hasClass,
	  addClass: addClass,
	  removeClass: removeClass,
	  toggleClass: toggleClass,
	  setAttributes: setAttributes,
	  getAttributes: getAttributes,
	  getAttribute: getAttribute,
	  setAttribute: setAttribute,
	  removeAttribute: removeAttribute,
	  blockTextSelection: blockTextSelection,
	  unblockTextSelection: unblockTextSelection,
	  getBoundingClientRect: getBoundingClientRect,
	  findPosition: findPosition,
	  getPointerPosition: getPointerPosition,
	  isTextNode: isTextNode,
	  emptyEl: emptyEl,
	  normalizeContent: normalizeContent,
	  appendContent: appendContent,
	  insertContent: insertContent,
	  isSingleLeftClick: isSingleLeftClick,
	  $: $,
	  $$: $$
	});
	
	/**
	 * @file setup.js - Functions for setting up a player without
	 * user interaction based on the data-setup `attribute` of the video tag.
	 *
	 * @module setup
	 */
	var _windowLoaded = false;
	var videojs$1;
	/**
	 * Set up any tags that have a data-setup `attribute` when the player is started.
	 */
	
	var autoSetup = function autoSetup() {
	  if (videojs$1.options.autoSetup === false) {
	    return;
	  }
	
	  var vids = Array.prototype.slice.call(document__default['default'].getElementsByTagName('video'));
	  var audios = Array.prototype.slice.call(document__default['default'].getElementsByTagName('audio'));
	  var divs = Array.prototype.slice.call(document__default['default'].getElementsByTagName('video-js'));
	  var mediaEls = vids.concat(audios, divs); // Check if any media elements exist
	
	  if (mediaEls && mediaEls.length > 0) {
	    for (var i = 0, e = mediaEls.length; i < e; i++) {
	      var mediaEl = mediaEls[i]; // Check if element exists, has getAttribute func.
	
	      if (mediaEl && mediaEl.getAttribute) {
	        // Make sure this player hasn't already been set up.
	        if (mediaEl.player === undefined) {
	          var options = mediaEl.getAttribute('data-setup'); // Check if data-setup attr exists.
	          // We only auto-setup if they've added the data-setup attr.
	
	          if (options !== null) {
	            // Create new video.js instance.
	            videojs$1(mediaEl);
	          }
	        } // If getAttribute isn't defined, we need to wait for the DOM.
	
	      } else {
	        autoSetupTimeout(1);
	        break;
	      }
	    } // No videos were found, so keep looping unless page is finished loading.
	
	  } else if (!_windowLoaded) {
	    autoSetupTimeout(1);
	  }
	};
	/**
	 * Wait until the page is loaded before running autoSetup. This will be called in
	 * autoSetup if `hasLoaded` returns false.
	 *
	 * @param {number} wait
	 *        How long to wait in ms
	 *
	 * @param {module:videojs} [vjs]
	 *        The videojs library function
	 */
	
	
	function autoSetupTimeout(wait, vjs) {
	  // Protect against breakage in non-browser environments
	  if (!isReal()) {
	    return;
	  }
	
	  if (vjs) {
	    videojs$1 = vjs;
	  }
	
	  window__default['default'].setTimeout(autoSetup, wait);
	}
	/**
	 * Used to set the internal tracking of window loaded state to true.
	 *
	 * @private
	 */
	
	
	function setWindowLoaded() {
	  _windowLoaded = true;
	  window__default['default'].removeEventListener('load', setWindowLoaded);
	}
	
	if (isReal()) {
	  if (document__default['default'].readyState === 'complete') {
	    setWindowLoaded();
	  } else {
	    /**
	     * Listen for the load event on window, and set _windowLoaded to true.
	     *
	     * We use a standard event listener here to avoid incrementing the GUID
	     * before any players are created.
	     *
	     * @listens load
	     */
	    window__default['default'].addEventListener('load', setWindowLoaded);
	  }
	}
	
	/**
	 * @file stylesheet.js
	 * @module stylesheet
	 */
	/**
	 * Create a DOM syle element given a className for it.
	 *
	 * @param {string} className
	 *        The className to add to the created style element.
	 *
	 * @return {Element}
	 *         The element that was created.
	 */
	
	var createStyleElement = function createStyleElement(className) {
	  var style = document__default['default'].createElement('style');
	  style.className = className;
	  return style;
	};
	/**
	 * Add text to a DOM element.
	 *
	 * @param {Element} el
	 *        The Element to add text content to.
	 *
	 * @param {string} content
	 *        The text to add to the element.
	 */
	
	var setTextContent = function setTextContent(el, content) {
	  if (el.styleSheet) {
	    el.styleSheet.cssText = content;
	  } else {
	    el.textContent = content;
	  }
	};
	
	/**
	 * @file guid.js
	 * @module guid
	 */
	// Default value for GUIDs. This allows us to reset the GUID counter in tests.
	//
	// The initial GUID is 3 because some users have come to rely on the first
	// default player ID ending up as `vjs_video_3`.
	//
	// See: https://github.com/videojs/video.js/pull/6216
	var _initialGuid = 3;
	/**
	 * Unique ID for an element or function
	 *
	 * @type {Number}
	 */
	
	var _guid = _initialGuid;
	/**
	 * Get a unique auto-incrementing ID by number that has not been returned before.
	 *
	 * @return {number}
	 *         A new unique ID.
	 */
	
	function newGUID() {
	  return _guid++;
	}
	
	/**
	 * @file dom-data.js
	 * @module dom-data
	 */
	var FakeWeakMap;
	
	if (!window__default['default'].WeakMap) {
	  FakeWeakMap = /*#__PURE__*/function () {
	    function FakeWeakMap() {
	      this.vdata = 'vdata' + Math.floor(window__default['default'].performance && window__default['default'].performance.now() || Date.now());
	      this.data = {};
	    }
	
	    var _proto = FakeWeakMap.prototype;
	
	    _proto.set = function set(key, value) {
	      var access = key[this.vdata] || newGUID();
	
	      if (!key[this.vdata]) {
	        key[this.vdata] = access;
	      }
	
	      this.data[access] = value;
	      return this;
	    };
	
	    _proto.get = function get(key) {
	      var access = key[this.vdata]; // we have data, return it
	
	      if (access) {
	        return this.data[access];
	      } // we don't have data, return nothing.
	      // return undefined explicitly as that's the contract for this method
	
	
	      log$1('We have no data for this element', key);
	      return undefined;
	    };
	
	    _proto.has = function has(key) {
	      var access = key[this.vdata];
	      return access in this.data;
	    };
	
	    _proto["delete"] = function _delete(key) {
	      var access = key[this.vdata];
	
	      if (access) {
	        delete this.data[access];
	        delete key[this.vdata];
	      }
	    };
	
	    return FakeWeakMap;
	  }();
	}
	/**
	 * Element Data Store.
	 *
	 * Allows for binding data to an element without putting it directly on the
	 * element. Ex. Event listeners are stored here.
	 * (also from jsninja.com, slightly modified and updated for closure compiler)
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	var DomData = window__default['default'].WeakMap ? new WeakMap() : new FakeWeakMap();
	
	/**
	 * @file events.js. An Event System (John Resig - Secrets of a JS Ninja http://jsninja.com/)
	 * (Original book version wasn't completely usable, so fixed some things and made Closure Compiler compatible)
	 * This should work very similarly to jQuery's events, however it's based off the book version which isn't as
	 * robust as jquery's, so there's probably some differences.
	 *
	 * @file events.js
	 * @module events
	 */
	/**
	 * Clean up the listener cache and dispatchers
	 *
	 * @param {Element|Object} elem
	 *        Element to clean up
	 *
	 * @param {string} type
	 *        Type of event to clean up
	 */
	
	function _cleanUpEvents(elem, type) {
	  if (!DomData.has(elem)) {
	    return;
	  }
	
	  var data = DomData.get(elem); // Remove the events of a particular type if there are none left
	
	  if (data.handlers[type].length === 0) {
	    delete data.handlers[type]; // data.handlers[type] = null;
	    // Setting to null was causing an error with data.handlers
	    // Remove the meta-handler from the element
	
	    if (elem.removeEventListener) {
	      elem.removeEventListener(type, data.dispatcher, false);
	    } else if (elem.detachEvent) {
	      elem.detachEvent('on' + type, data.dispatcher);
	    }
	  } // Remove the events object if there are no types left
	
	
	  if (Object.getOwnPropertyNames(data.handlers).length <= 0) {
	    delete data.handlers;
	    delete data.dispatcher;
	    delete data.disabled;
	  } // Finally remove the element data if there is no data left
	
	
	  if (Object.getOwnPropertyNames(data).length === 0) {
	    DomData["delete"](elem);
	  }
	}
	/**
	 * Loops through an array of event types and calls the requested method for each type.
	 *
	 * @param {Function} fn
	 *        The event method we want to use.
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind listeners to
	 *
	 * @param {string} type
	 *        Type of event to bind to.
	 *
	 * @param {EventTarget~EventListener} callback
	 *        Event listener.
	 */
	
	
	function _handleMultipleEvents(fn, elem, types, callback) {
	  types.forEach(function (type) {
	    // Call the event method for each one of the types
	    fn(elem, type, callback);
	  });
	}
	/**
	 * Fix a native event to have standard property values
	 *
	 * @param {Object} event
	 *        Event object to fix.
	 *
	 * @return {Object}
	 *         Fixed event object.
	 */
	
	
	function fixEvent(event) {
	  if (event.fixed_) {
	    return event;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function returnFalse() {
	    return false;
	  } // Test if fixing up is needed
	  // Used to check if !event.stopPropagation instead of isPropagationStopped
	  // But native events return true for stopPropagation, but don't have
	  // other expected methods like isPropagationStopped. Seems to be a problem
	  // with the Javascript Ninja code. So we're just overriding all events now.
	
	
	  if (!event || !event.isPropagationStopped || !event.isImmediatePropagationStopped) {
	    var old = event || window__default['default'].event;
	    event = {}; // Clone the old object so that we can modify the values event = {};
	    // IE8 Doesn't like when you mess with native event properties
	    // Firefox returns false for event.hasOwnProperty('type') and other props
	    //  which makes copying more difficult.
	    // TODO: Probably best to create a whitelist of event props
	
	    for (var key in old) {
	      // Safari 6.0.3 warns you if you try to copy deprecated layerX/Y
	      // Chrome warns you if you try to copy deprecated keyboardEvent.keyLocation
	      // and webkitMovementX/Y
	      // Lighthouse complains if Event.path is copied
	      if (key !== 'layerX' && key !== 'layerY' && key !== 'keyLocation' && key !== 'webkitMovementX' && key !== 'webkitMovementY' && key !== 'path') {
	        // Chrome 32+ warns if you try to copy deprecated returnValue, but
	        // we still want to if preventDefault isn't supported (IE8).
	        if (!(key === 'returnValue' && old.preventDefault)) {
	          event[key] = old[key];
	        }
	      }
	    } // The event occurred on this element
	
	
	    if (!event.target) {
	      event.target = event.srcElement || document__default['default'];
	    } // Handle which other element the event is related to
	
	
	    if (!event.relatedTarget) {
	      event.relatedTarget = event.fromElement === event.target ? event.toElement : event.fromElement;
	    } // Stop the default browser action
	
	
	    event.preventDefault = function () {
	      if (old.preventDefault) {
	        old.preventDefault();
	      }
	
	      event.returnValue = false;
	      old.returnValue = false;
	      event.defaultPrevented = true;
	    };
	
	    event.defaultPrevented = false; // Stop the event from bubbling
	
	    event.stopPropagation = function () {
	      if (old.stopPropagation) {
	        old.stopPropagation();
	      }
	
	      event.cancelBubble = true;
	      old.cancelBubble = true;
	      event.isPropagationStopped = returnTrue;
	    };
	
	    event.isPropagationStopped = returnFalse; // Stop the event from bubbling and executing other handlers
	
	    event.stopImmediatePropagation = function () {
	      if (old.stopImmediatePropagation) {
	        old.stopImmediatePropagation();
	      }
	
	      event.isImmediatePropagationStopped = returnTrue;
	      event.stopPropagation();
	    };
	
	    event.isImmediatePropagationStopped = returnFalse; // Handle mouse position
	
	    if (event.clientX !== null && event.clientX !== undefined) {
	      var doc = document__default['default'].documentElement;
	      var body = document__default['default'].body;
	      event.pageX = event.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = event.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    } // Handle key presses
	
	
	    event.which = event.charCode || event.keyCode; // Fix button for mouse clicks:
	    // 0 == left; 1 == middle; 2 == right
	
	    if (event.button !== null && event.button !== undefined) {
	      // The following is disabled because it does not pass videojs-standard
	      // and... yikes.
	
	      /* eslint-disable */
	      event.button = event.button & 1 ? 0 : event.button & 4 ? 1 : event.button & 2 ? 2 : 0;
	      /* eslint-enable */
	    }
	  }
	
	  event.fixed_ = true; // Returns fixed-up instance
	
	  return event;
	}
	/**
	 * Whether passive event listeners are supported
	 */
	
	var _supportsPassive;
	
	var supportsPassive = function supportsPassive() {
	  if (typeof _supportsPassive !== 'boolean') {
	    _supportsPassive = false;
	
	    try {
	      var opts = Object.defineProperty({}, 'passive', {
	        get: function get() {
	          _supportsPassive = true;
	        }
	      });
	      window__default['default'].addEventListener('test', null, opts);
	      window__default['default'].removeEventListener('test', null, opts);
	    } catch (e) {// disregard
	    }
	  }
	
	  return _supportsPassive;
	};
	/**
	 * Touch events Chrome expects to be passive
	 */
	
	
	var passiveEvents = ['touchstart', 'touchmove'];
	/**
	 * Add an event listener to element
	 * It stores the handler function in a separate cache object
	 * and adds a generic handler to the element's event,
	 * along with a unique id (guid) to the element.
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind listeners to
	 *
	 * @param {string|string[]} type
	 *        Type of event to bind to.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        Event listener.
	 */
	
	function on(elem, type, fn) {
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(on, elem, type, fn);
	  }
	
	  if (!DomData.has(elem)) {
	    DomData.set(elem, {});
	  }
	
	  var data = DomData.get(elem); // We need a place to store all our handler data
	
	  if (!data.handlers) {
	    data.handlers = {};
	  }
	
	  if (!data.handlers[type]) {
	    data.handlers[type] = [];
	  }
	
	  if (!fn.guid) {
	    fn.guid = newGUID();
	  }
	
	  data.handlers[type].push(fn);
	
	  if (!data.dispatcher) {
	    data.disabled = false;
	
	    data.dispatcher = function (event, hash) {
	      if (data.disabled) {
	        return;
	      }
	
	      event = fixEvent(event);
	      var handlers = data.handlers[event.type];
	
	      if (handlers) {
	        // Copy handlers so if handlers are added/removed during the process it doesn't throw everything off.
	        var handlersCopy = handlers.slice(0);
	
	        for (var m = 0, n = handlersCopy.length; m < n; m++) {
	          if (event.isImmediatePropagationStopped()) {
	            break;
	          } else {
	            try {
	              handlersCopy[m].call(elem, event, hash);
	            } catch (e) {
	              log$1.error(e);
	            }
	          }
	        }
	      }
	    };
	  }
	
	  if (data.handlers[type].length === 1) {
	    if (elem.addEventListener) {
	      var options = false;
	
	      if (supportsPassive() && passiveEvents.indexOf(type) > -1) {
	        options = {
	          passive: true
	        };
	      }
	
	      elem.addEventListener(type, data.dispatcher, options);
	    } else if (elem.attachEvent) {
	      elem.attachEvent('on' + type, data.dispatcher);
	    }
	  }
	}
	/**
	 * Removes event listeners from an element
	 *
	 * @param {Element|Object} elem
	 *        Object to remove listeners from.
	 *
	 * @param {string|string[]} [type]
	 *        Type of listener to remove. Don't include to remove all events from element.
	 *
	 * @param {EventTarget~EventListener} [fn]
	 *        Specific listener to remove. Don't include to remove listeners for an event
	 *        type.
	 */
	
	function off(elem, type, fn) {
	  // Don't want to add a cache object through getElData if not needed
	  if (!DomData.has(elem)) {
	    return;
	  }
	
	  var data = DomData.get(elem); // If no events exist, nothing to unbind
	
	  if (!data.handlers) {
	    return;
	  }
	
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(off, elem, type, fn);
	  } // Utility function
	
	
	  var removeType = function removeType(el, t) {
	    data.handlers[t] = [];
	
	    _cleanUpEvents(el, t);
	  }; // Are we removing all bound events?
	
	
	  if (type === undefined) {
	    for (var t in data.handlers) {
	      if (Object.prototype.hasOwnProperty.call(data.handlers || {}, t)) {
	        removeType(elem, t);
	      }
	    }
	
	    return;
	  }
	
	  var handlers = data.handlers[type]; // If no handlers exist, nothing to unbind
	
	  if (!handlers) {
	    return;
	  } // If no listener was provided, remove all listeners for type
	
	
	  if (!fn) {
	    removeType(elem, type);
	    return;
	  } // We're only removing a single handler
	
	
	  if (fn.guid) {
	    for (var n = 0; n < handlers.length; n++) {
	      if (handlers[n].guid === fn.guid) {
	        handlers.splice(n--, 1);
	      }
	    }
	  }
	
	  _cleanUpEvents(elem, type);
	}
	/**
	 * Trigger an event for an element
	 *
	 * @param {Element|Object} elem
	 *        Element to trigger an event on
	 *
	 * @param {EventTarget~Event|string} event
	 *        A string (the type) or an event object with a type attribute
	 *
	 * @param {Object} [hash]
	 *        data hash to pass along with the event
	 *
	 * @return {boolean|undefined}
	 *         Returns the opposite of `defaultPrevented` if default was
	 *         prevented. Otherwise, returns `undefined`
	 */
	
	function trigger(elem, event, hash) {
	  // Fetches element data and a reference to the parent (for bubbling).
	  // Don't want to add a data object to cache for every parent,
	  // so checking hasElData first.
	  var elemData = DomData.has(elem) ? DomData.get(elem) : {};
	  var parent = elem.parentNode || elem.ownerDocument; // type = event.type || event,
	  // handler;
	  // If an event name was passed as a string, creates an event out of it
	
	  if (typeof event === 'string') {
	    event = {
	      type: event,
	      target: elem
	    };
	  } else if (!event.target) {
	    event.target = elem;
	  } // Normalizes the event properties.
	
	
	  event = fixEvent(event); // If the passed element has a dispatcher, executes the established handlers.
	
	  if (elemData.dispatcher) {
	    elemData.dispatcher.call(elem, event, hash);
	  } // Unless explicitly stopped or the event does not bubble (e.g. media events)
	  // recursively calls this function to bubble the event up the DOM.
	
	
	  if (parent && !event.isPropagationStopped() && event.bubbles === true) {
	    trigger.call(null, parent, event, hash); // If at the top of the DOM, triggers the default action unless disabled.
	  } else if (!parent && !event.defaultPrevented && event.target && event.target[event.type]) {
	    if (!DomData.has(event.target)) {
	      DomData.set(event.target, {});
	    }
	
	    var targetData = DomData.get(event.target); // Checks if the target has a default action for this event.
	
	    if (event.target[event.type]) {
	      // Temporarily disables event dispatching on the target as we have already executed the handler.
	      targetData.disabled = true; // Executes the default action.
	
	      if (typeof event.target[event.type] === 'function') {
	        event.target[event.type]();
	      } // Re-enables event dispatching.
	
	
	      targetData.disabled = false;
	    }
	  } // Inform the triggerer if the default was prevented by returning false
	
	
	  return !event.defaultPrevented;
	}
	/**
	 * Trigger a listener only once for an event.
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind to.
	 *
	 * @param {string|string[]} type
	 *        Name/type of event
	 *
	 * @param {Event~EventListener} fn
	 *        Event listener function
	 */
	
	function one(elem, type, fn) {
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(one, elem, type, fn);
	  }
	
	  var func = function func() {
	    off(elem, type, func);
	    fn.apply(this, arguments);
	  }; // copy the guid to the new function so it can removed using the original function's ID
	
	
	  func.guid = fn.guid = fn.guid || newGUID();
	  on(elem, type, func);
	}
	/**
	 * Trigger a listener only once and then turn if off for all
	 * configured events
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind to.
	 *
	 * @param {string|string[]} type
	 *        Name/type of event
	 *
	 * @param {Event~EventListener} fn
	 *        Event listener function
	 */
	
	function any(elem, type, fn) {
	  var func = function func() {
	    off(elem, type, func);
	    fn.apply(this, arguments);
	  }; // copy the guid to the new function so it can removed using the original function's ID
	
	
	  func.guid = fn.guid = fn.guid || newGUID(); // multiple ons, but one off for everything
	
	  on(elem, type, func);
	}
	
	var Events = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  fixEvent: fixEvent,
	  on: on,
	  off: off,
	  trigger: trigger,
	  one: one,
	  any: any
	});
	
	/**
	 * @file fn.js
	 * @module fn
	 */
	var UPDATE_REFRESH_INTERVAL = 30;
	/**
	 * Bind (a.k.a proxy or context). A simple method for changing the context of
	 * a function.
	 *
	 * It also stores a unique id on the function so it can be easily removed from
	 * events.
	 *
	 * @function
	 * @param    {Mixed} context
	 *           The object to bind as scope.
	 *
	 * @param    {Function} fn
	 *           The function to be bound to a scope.
	 *
	 * @param    {number} [uid]
	 *           An optional unique ID for the function to be set
	 *
	 * @return   {Function}
	 *           The new function that will be bound into the context given
	 */
	
	var bind = function bind(context, fn, uid) {
	  // Make sure the function has a unique ID
	  if (!fn.guid) {
	    fn.guid = newGUID();
	  } // Create the new function that changes the context
	
	
	  var bound = fn.bind(context); // Allow for the ability to individualize this function
	  // Needed in the case where multiple objects might share the same prototype
	  // IF both items add an event listener with the same function, then you try to remove just one
	  // it will remove both because they both have the same guid.
	  // when using this, you need to use the bind method when you remove the listener as well.
	  // currently used in text tracks
	
	  bound.guid = uid ? uid + '_' + fn.guid : fn.guid;
	  return bound;
	};
	/**
	 * Wraps the given function, `fn`, with a new function that only invokes `fn`
	 * at most once per every `wait` milliseconds.
	 *
	 * @function
	 * @param    {Function} fn
	 *           The function to be throttled.
	 *
	 * @param    {number}   wait
	 *           The number of milliseconds by which to throttle.
	 *
	 * @return   {Function}
	 */
	
	var throttle = function throttle(fn, wait) {
	  var last = window__default['default'].performance.now();
	
	  var throttled = function throttled() {
	    var now = window__default['default'].performance.now();
	
	    if (now - last >= wait) {
	      fn.apply(void 0, arguments);
	      last = now;
	    }
	  };
	
	  return throttled;
	};
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked.
	 *
	 * Inspired by lodash and underscore implementations.
	 *
	 * @function
	 * @param    {Function} func
	 *           The function to wrap with debounce behavior.
	 *
	 * @param    {number} wait
	 *           The number of milliseconds to wait after the last invocation.
	 *
	 * @param    {boolean} [immediate]
	 *           Whether or not to invoke the function immediately upon creation.
	 *
	 * @param    {Object} [context=window]
	 *           The "context" in which the debounced function should debounce. For
	 *           example, if this function should be tied to a Video.js player,
	 *           the player can be passed here. Alternatively, defaults to the
	 *           global `window` object.
	 *
	 * @return   {Function}
	 *           A debounced function.
	 */
	
	var debounce = function debounce(func, wait, immediate, context) {
	  if (context === void 0) {
	    context = window__default['default'];
	  }
	
	  var timeout;
	
	  var cancel = function cancel() {
	    context.clearTimeout(timeout);
	    timeout = null;
	  };
	  /* eslint-disable consistent-this */
	
	
	  var debounced = function debounced() {
	    var self = this;
	    var args = arguments;
	
	    var _later = function later() {
	      timeout = null;
	      _later = null;
	
	      if (!immediate) {
	        func.apply(self, args);
	      }
	    };
	
	    if (!timeout && immediate) {
	      func.apply(self, args);
	    }
	
	    context.clearTimeout(timeout);
	    timeout = context.setTimeout(_later, wait);
	  };
	  /* eslint-enable consistent-this */
	
	
	  debounced.cancel = cancel;
	  return debounced;
	};
	
	/**
	 * @file src/js/event-target.js
	 */
	/**
	 * `EventTarget` is a class that can have the same API as the DOM `EventTarget`. It
	 * adds shorthand functions that wrap around lengthy functions. For example:
	 * the `on` function is a wrapper around `addEventListener`.
	 *
	 * @see [EventTarget Spec]{@link https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget}
	 * @class EventTarget
	 */
	
	var EventTarget$2 = function EventTarget() {};
	/**
	 * A Custom DOM event.
	 *
	 * @typedef {Object} EventTarget~Event
	 * @see [Properties]{@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
	 */
	
	/**
	 * All event listeners should follow the following format.
	 *
	 * @callback EventTarget~EventListener
	 * @this {EventTarget}
	 *
	 * @param {EventTarget~Event} event
	 *        the event that triggered this function
	 *
	 * @param {Object} [hash]
	 *        hash of data sent during the event
	 */
	
	/**
	 * An object containing event names as keys and booleans as values.
	 *
	 * > NOTE: If an event name is set to a true value here {@link EventTarget#trigger}
	 *         will have extra functionality. See that function for more information.
	 *
	 * @property EventTarget.prototype.allowedEvents_
	 * @private
	 */
	
	
	EventTarget$2.prototype.allowedEvents_ = {};
	/**
	 * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
	 * function that will get called when an event with a certain name gets triggered.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to call with `EventTarget`s
	 */
	
	EventTarget$2.prototype.on = function (type, fn) {
	  // Remove the addEventListener alias before calling Events.on
	  // so we don't get into an infinite type loop
	  var ael = this.addEventListener;
	
	  this.addEventListener = function () {};
	
	  on(this, type, fn);
	  this.addEventListener = ael;
	};
	/**
	 * An alias of {@link EventTarget#on}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#on}
	 */
	
	
	EventTarget$2.prototype.addEventListener = EventTarget$2.prototype.on;
	/**
	 * Removes an `event listener` for a specific event from an instance of `EventTarget`.
	 * This makes it so that the `event listener` will no longer get called when the
	 * named event happens.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to remove.
	 */
	
	EventTarget$2.prototype.off = function (type, fn) {
	  off(this, type, fn);
	};
	/**
	 * An alias of {@link EventTarget#off}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#off}
	 */
	
	
	EventTarget$2.prototype.removeEventListener = EventTarget$2.prototype.off;
	/**
	 * This function will add an `event listener` that gets triggered only once. After the
	 * first trigger it will get removed. This is like adding an `event listener`
	 * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to be called once for each event name.
	 */
	
	EventTarget$2.prototype.one = function (type, fn) {
	  // Remove the addEventListener aliasing Events.on
	  // so we don't get into an infinite type loop
	  var ael = this.addEventListener;
	
	  this.addEventListener = function () {};
	
	  one(this, type, fn);
	  this.addEventListener = ael;
	};
	
	EventTarget$2.prototype.any = function (type, fn) {
	  // Remove the addEventListener aliasing Events.on
	  // so we don't get into an infinite type loop
	  var ael = this.addEventListener;
	
	  this.addEventListener = function () {};
	
	  any(this, type, fn);
	  this.addEventListener = ael;
	};
	/**
	 * This function causes an event to happen. This will then cause any `event listeners`
	 * that are waiting for that event, to get called. If there are no `event listeners`
	 * for an event then nothing will happen.
	 *
	 * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
	 * Trigger will also call the `on` + `uppercaseEventName` function.
	 *
	 * Example:
	 * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
	 * `onClick` if it exists.
	 *
	 * @param {string|EventTarget~Event|Object} event
	 *        The name of the event, an `Event`, or an object with a key of type set to
	 *        an event name.
	 */
	
	
	EventTarget$2.prototype.trigger = function (event) {
	  var type = event.type || event; // deprecation
	  // In a future version we should default target to `this`
	  // similar to how we default the target to `elem` in
	  // `Events.trigger`. Right now the default `target` will be
	  // `document` due to the `Event.fixEvent` call.
	
	  if (typeof event === 'string') {
	    event = {
	      type: type
	    };
	  }
	
	  event = fixEvent(event);
	
	  if (this.allowedEvents_[type] && this['on' + type]) {
	    this['on' + type](event);
	  }
	
	  trigger(this, event);
	};
	/**
	 * An alias of {@link EventTarget#trigger}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#trigger}
	 */
	
	
	EventTarget$2.prototype.dispatchEvent = EventTarget$2.prototype.trigger;
	var EVENT_MAP;
	
	EventTarget$2.prototype.queueTrigger = function (event) {
	  var _this = this;
	
	  // only set up EVENT_MAP if it'll be used
	  if (!EVENT_MAP) {
	    EVENT_MAP = new Map();
	  }
	
	  var type = event.type || event;
	  var map = EVENT_MAP.get(this);
	
	  if (!map) {
	    map = new Map();
	    EVENT_MAP.set(this, map);
	  }
	
	  var oldTimeout = map.get(type);
	  map["delete"](type);
	  window__default['default'].clearTimeout(oldTimeout);
	  var timeout = window__default['default'].setTimeout(function () {
	    map["delete"](type); // if we cleared out all timeouts for the current target, delete its map
	
	    if (map.size === 0) {
	      map = null;
	      EVENT_MAP["delete"](_this);
	    }
	
	    _this.trigger(event);
	  }, 0);
	  map.set(type, timeout);
	};
	
	/**
	 * @file mixins/evented.js
	 * @module evented
	 */
	
	var objName = function objName(obj) {
	  if (typeof obj.name === 'function') {
	    return obj.name();
	  }
	
	  if (typeof obj.name === 'string') {
	    return obj.name;
	  }
	
	  if (obj.name_) {
	    return obj.name_;
	  }
	
	  if (obj.constructor && obj.constructor.name) {
	    return obj.constructor.name;
	  }
	
	  return typeof obj;
	};
	/**
	 * Returns whether or not an object has had the evented mixin applied.
	 *
	 * @param  {Object} object
	 *         An object to test.
	 *
	 * @return {boolean}
	 *         Whether or not the object appears to be evented.
	 */
	
	
	var isEvented = function isEvented(object) {
	  return object instanceof EventTarget$2 || !!object.eventBusEl_ && ['on', 'one', 'off', 'trigger'].every(function (k) {
	    return typeof object[k] === 'function';
	  });
	};
	/**
	 * Adds a callback to run after the evented mixin applied.
	 *
	 * @param  {Object} object
	 *         An object to Add
	 * @param  {Function} callback
	 *         The callback to run.
	 */
	
	
	var addEventedCallback = function addEventedCallback(target, callback) {
	  if (isEvented(target)) {
	    callback();
	  } else {
	    if (!target.eventedCallbacks) {
	      target.eventedCallbacks = [];
	    }
	
	    target.eventedCallbacks.push(callback);
	  }
	};
	/**
	 * Whether a value is a valid event type - non-empty string or array.
	 *
	 * @private
	 * @param  {string|Array} type
	 *         The type value to test.
	 *
	 * @return {boolean}
	 *         Whether or not the type is a valid event type.
	 */
	
	
	var isValidEventType = function isValidEventType(type) {
	  return (// The regex here verifies that the `type` contains at least one non-
	    // whitespace character.
	    typeof type === 'string' && /\S/.test(type) || Array.isArray(type) && !!type.length
	  );
	};
	/**
	 * Validates a value to determine if it is a valid event target. Throws if not.
	 *
	 * @private
	 * @throws {Error}
	 *         If the target does not appear to be a valid event target.
	 *
	 * @param  {Object} target
	 *         The object to test.
	 *
	 * @param  {Object} obj
	 *         The evented object we are validating for
	 *
	 * @param  {string} fnName
	 *         The name of the evented mixin function that called this.
	 */
	
	
	var validateTarget = function validateTarget(target, obj, fnName) {
	  if (!target || !target.nodeName && !isEvented(target)) {
	    throw new Error("Invalid target for " + objName(obj) + "#" + fnName + "; must be a DOM node or evented object.");
	  }
	};
	/**
	 * Validates a value to determine if it is a valid event target. Throws if not.
	 *
	 * @private
	 * @throws {Error}
	 *         If the type does not appear to be a valid event type.
	 *
	 * @param  {string|Array} type
	 *         The type to test.
	 *
	 * @param  {Object} obj
	*         The evented object we are validating for
	 *
	 * @param  {string} fnName
	 *         The name of the evented mixin function that called this.
	 */
	
	
	var validateEventType = function validateEventType(type, obj, fnName) {
	  if (!isValidEventType(type)) {
	    throw new Error("Invalid event type for " + objName(obj) + "#" + fnName + "; must be a non-empty string or array.");
	  }
	};
	/**
	 * Validates a value to determine if it is a valid listener. Throws if not.
	 *
	 * @private
	 * @throws {Error}
	 *         If the listener is not a function.
	 *
	 * @param  {Function} listener
	 *         The listener to test.
	 *
	 * @param  {Object} obj
	 *         The evented object we are validating for
	 *
	 * @param  {string} fnName
	 *         The name of the evented mixin function that called this.
	 */
	
	
	var validateListener = function validateListener(listener, obj, fnName) {
	  if (typeof listener !== 'function') {
	    throw new Error("Invalid listener for " + objName(obj) + "#" + fnName + "; must be a function.");
	  }
	};
	/**
	 * Takes an array of arguments given to `on()` or `one()`, validates them, and
	 * normalizes them into an object.
	 *
	 * @private
	 * @param  {Object} self
	 *         The evented object on which `on()` or `one()` was called. This
	 *         object will be bound as the `this` value for the listener.
	 *
	 * @param  {Array} args
	 *         An array of arguments passed to `on()` or `one()`.
	 *
	 * @param  {string} fnName
	 *         The name of the evented mixin function that called this.
	 *
	 * @return {Object}
	 *         An object containing useful values for `on()` or `one()` calls.
	 */
	
	
	var normalizeListenArgs = function normalizeListenArgs(self, args, fnName) {
	  // If the number of arguments is less than 3, the target is always the
	  // evented object itself.
	  var isTargetingSelf = args.length < 3 || args[0] === self || args[0] === self.eventBusEl_;
	  var target;
	  var type;
	  var listener;
	
	  if (isTargetingSelf) {
	    target = self.eventBusEl_; // Deal with cases where we got 3 arguments, but we are still listening to
	    // the evented object itself.
	
	    if (args.length >= 3) {
	      args.shift();
	    }
	
	    type = args[0];
	    listener = args[1];
	  } else {
	    target = args[0];
	    type = args[1];
	    listener = args[2];
	  }
	
	  validateTarget(target, self, fnName);
	  validateEventType(type, self, fnName);
	  validateListener(listener, self, fnName);
	  listener = bind(self, listener);
	  return {
	    isTargetingSelf: isTargetingSelf,
	    target: target,
	    type: type,
	    listener: listener
	  };
	};
	/**
	 * Adds the listener to the event type(s) on the target, normalizing for
	 * the type of target.
	 *
	 * @private
	 * @param  {Element|Object} target
	 *         A DOM node or evented object.
	 *
	 * @param  {string} method
	 *         The event binding method to use ("on" or "one").
	 *
	 * @param  {string|Array} type
	 *         One or more event type(s).
	 *
	 * @param  {Function} listener
	 *         A listener function.
	 */
	
	
	var listen = function listen(target, method, type, listener) {
	  validateTarget(target, target, method);
	
	  if (target.nodeName) {
	    Events[method](target, type, listener);
	  } else {
	    target[method](type, listener);
	  }
	};
	/**
	 * Contains methods that provide event capabilities to an object which is passed
	 * to {@link module:evented|evented}.
	 *
	 * @mixin EventedMixin
	 */
	
	
	var EventedMixin = {
	  /**
	   * Add a listener to an event (or events) on this object or another evented
	   * object.
	   *
	   * @param  {string|Array|Element|Object} targetOrType
	   *         If this is a string or array, it represents the event type(s)
	   *         that will trigger the listener.
	   *
	   *         Another evented object can be passed here instead, which will
	   *         cause the listener to listen for events on _that_ object.
	   *
	   *         In either case, the listener's `this` value will be bound to
	   *         this object.
	   *
	   * @param  {string|Array|Function} typeOrListener
	   *         If the first argument was a string or array, this should be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function.
	   */
	  on: function on() {
	    var _this = this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _normalizeListenArgs = normalizeListenArgs(this, args, 'on'),
	        isTargetingSelf = _normalizeListenArgs.isTargetingSelf,
	        target = _normalizeListenArgs.target,
	        type = _normalizeListenArgs.type,
	        listener = _normalizeListenArgs.listener;
	
	    listen(target, 'on', type, listener); // If this object is listening to another evented object.
	
	    if (!isTargetingSelf) {
	      // If this object is disposed, remove the listener.
	      var removeListenerOnDispose = function removeListenerOnDispose() {
	        return _this.off(target, type, listener);
	      }; // Use the same function ID as the listener so we can remove it later it
	      // using the ID of the original listener.
	
	
	      removeListenerOnDispose.guid = listener.guid; // Add a listener to the target's dispose event as well. This ensures
	      // that if the target is disposed BEFORE this object, we remove the
	      // removal listener that was just added. Otherwise, we create a memory leak.
	
	      var removeRemoverOnTargetDispose = function removeRemoverOnTargetDispose() {
	        return _this.off('dispose', removeListenerOnDispose);
	      }; // Use the same function ID as the listener so we can remove it later
	      // it using the ID of the original listener.
	
	
	      removeRemoverOnTargetDispose.guid = listener.guid;
	      listen(this, 'on', 'dispose', removeListenerOnDispose);
	      listen(target, 'on', 'dispose', removeRemoverOnTargetDispose);
	    }
	  },
	
	  /**
	   * Add a listener to an event (or events) on this object or another evented
	   * object. The listener will be called once per event and then removed.
	   *
	   * @param  {string|Array|Element|Object} targetOrType
	   *         If this is a string or array, it represents the event type(s)
	   *         that will trigger the listener.
	   *
	   *         Another evented object can be passed here instead, which will
	   *         cause the listener to listen for events on _that_ object.
	   *
	   *         In either case, the listener's `this` value will be bound to
	   *         this object.
	   *
	   * @param  {string|Array|Function} typeOrListener
	   *         If the first argument was a string or array, this should be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function.
	   */
	  one: function one() {
	    var _this2 = this;
	
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var _normalizeListenArgs2 = normalizeListenArgs(this, args, 'one'),
	        isTargetingSelf = _normalizeListenArgs2.isTargetingSelf,
	        target = _normalizeListenArgs2.target,
	        type = _normalizeListenArgs2.type,
	        listener = _normalizeListenArgs2.listener; // Targeting this evented object.
	
	
	    if (isTargetingSelf) {
	      listen(target, 'one', type, listener); // Targeting another evented object.
	    } else {
	      // TODO: This wrapper is incorrect! It should only
	      //       remove the wrapper for the event type that called it.
	      //       Instead all listners are removed on the first trigger!
	      //       see https://github.com/videojs/video.js/issues/5962
	      var wrapper = function wrapper() {
	        _this2.off(target, type, wrapper);
	
	        for (var _len3 = arguments.length, largs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	          largs[_key3] = arguments[_key3];
	        }
	
	        listener.apply(null, largs);
	      }; // Use the same function ID as the listener so we can remove it later
	      // it using the ID of the original listener.
	
	
	      wrapper.guid = listener.guid;
	      listen(target, 'one', type, wrapper);
	    }
	  },
	
	  /**
	   * Add a listener to an event (or events) on this object or another evented
	   * object. The listener will only be called once for the first event that is triggered
	   * then removed.
	   *
	   * @param  {string|Array|Element|Object} targetOrType
	   *         If this is a string or array, it represents the event type(s)
	   *         that will trigger the listener.
	   *
	   *         Another evented object can be passed here instead, which will
	   *         cause the listener to listen for events on _that_ object.
	   *
	   *         In either case, the listener's `this` value will be bound to
	   *         this object.
	   *
	   * @param  {string|Array|Function} typeOrListener
	   *         If the first argument was a string or array, this should be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function.
	   */
	  any: function any() {
	    var _this3 = this;
	
	    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    var _normalizeListenArgs3 = normalizeListenArgs(this, args, 'any'),
	        isTargetingSelf = _normalizeListenArgs3.isTargetingSelf,
	        target = _normalizeListenArgs3.target,
	        type = _normalizeListenArgs3.type,
	        listener = _normalizeListenArgs3.listener; // Targeting this evented object.
	
	
	    if (isTargetingSelf) {
	      listen(target, 'any', type, listener); // Targeting another evented object.
	    } else {
	      var wrapper = function wrapper() {
	        _this3.off(target, type, wrapper);
	
	        for (var _len5 = arguments.length, largs = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	          largs[_key5] = arguments[_key5];
	        }
	
	        listener.apply(null, largs);
	      }; // Use the same function ID as the listener so we can remove it later
	      // it using the ID of the original listener.
	
	
	      wrapper.guid = listener.guid;
	      listen(target, 'any', type, wrapper);
	    }
	  },
	
	  /**
	   * Removes listener(s) from event(s) on an evented object.
	   *
	   * @param  {string|Array|Element|Object} [targetOrType]
	   *         If this is a string or array, it represents the event type(s).
	   *
	   *         Another evented object can be passed here instead, in which case
	   *         ALL 3 arguments are _required_.
	   *
	   * @param  {string|Array|Function} [typeOrListener]
	   *         If the first argument was a string or array, this may be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function; otherwise, _all_ listeners bound to the
	   *         event type(s) will be removed.
	   */
	  off: function off$1(targetOrType, typeOrListener, listener) {
	    // Targeting this evented object.
	    if (!targetOrType || isValidEventType(targetOrType)) {
	      off(this.eventBusEl_, targetOrType, typeOrListener); // Targeting another evented object.
	    } else {
	      var target = targetOrType;
	      var type = typeOrListener; // Fail fast and in a meaningful way!
	
	      validateTarget(target, this, 'off');
	      validateEventType(type, this, 'off');
	      validateListener(listener, this, 'off'); // Ensure there's at least a guid, even if the function hasn't been used
	
	      listener = bind(this, listener); // Remove the dispose listener on this evented object, which was given
	      // the same guid as the event listener in on().
	
	      this.off('dispose', listener);
	
	      if (target.nodeName) {
	        off(target, type, listener);
	        off(target, 'dispose', listener);
	      } else if (isEvented(target)) {
	        target.off(type, listener);
	        target.off('dispose', listener);
	      }
	    }
	  },
	
	  /**
	   * Fire an event on this evented object, causing its listeners to be called.
	   *
	   * @param   {string|Object} event
	   *          An event type or an object with a type property.
	   *
	   * @param   {Object} [hash]
	   *          An additional object to pass along to listeners.
	   *
	   * @return {boolean}
	   *          Whether or not the default behavior was prevented.
	   */
	  trigger: function trigger$1(event, hash) {
	    validateTarget(this.eventBusEl_, this, 'trigger');
	    var type = event && typeof event !== 'string' ? event.type : event;
	
	    if (!isValidEventType(type)) {
	      var error = "Invalid event type for " + objName(this) + "#trigger; " + 'must be a non-empty string or object with a type key that has a non-empty value.';
	
	      if (event) {
	        (this.log || log$1).error(error);
	      } else {
	        throw new Error(error);
	      }
	    }
	
	    return trigger(this.eventBusEl_, event, hash);
	  }
	};
	/**
	 * Applies {@link module:evented~EventedMixin|EventedMixin} to a target object.
	 *
	 * @param  {Object} target
	 *         The object to which to add event methods.
	 *
	 * @param  {Object} [options={}]
	 *         Options for customizing the mixin behavior.
	 *
	 * @param  {string} [options.eventBusKey]
	 *         By default, adds a `eventBusEl_` DOM element to the target object,
	 *         which is used as an event bus. If the target object already has a
	 *         DOM element that should be used, pass its key here.
	 *
	 * @return {Object}
	 *         The target object.
	 */
	
	function evented(target, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var _options = options,
	      eventBusKey = _options.eventBusKey; // Set or create the eventBusEl_.
	
	  if (eventBusKey) {
	    if (!target[eventBusKey].nodeName) {
	      throw new Error("The eventBusKey \"" + eventBusKey + "\" does not refer to an element.");
	    }
	
	    target.eventBusEl_ = target[eventBusKey];
	  } else {
	    target.eventBusEl_ = createEl('span', {
	      className: 'vjs-event-bus'
	    });
	  }
	
	  assign(target, EventedMixin);
	
	  if (target.eventedCallbacks) {
	    target.eventedCallbacks.forEach(function (callback) {
	      callback();
	    });
	  } // When any evented object is disposed, it removes all its listeners.
	
	
	  target.on('dispose', function () {
	    target.off();
	    [target, target.el_, target.eventBusEl_].forEach(function (val) {
	      if (val && DomData.has(val)) {
	        DomData["delete"](val);
	      }
	    });
	    window__default['default'].setTimeout(function () {
	      target.eventBusEl_ = null;
	    }, 0);
	  });
	  return target;
	}
	
	/**
	 * @file mixins/stateful.js
	 * @module stateful
	 */
	/**
	 * Contains methods that provide statefulness to an object which is passed
	 * to {@link module:stateful}.
	 *
	 * @mixin StatefulMixin
	 */
	
	var StatefulMixin = {
	  /**
	   * A hash containing arbitrary keys and values representing the state of
	   * the object.
	   *
	   * @type {Object}
	   */
	  state: {},
	
	  /**
	   * Set the state of an object by mutating its
	   * {@link module:stateful~StatefulMixin.state|state} object in place.
	   *
	   * @fires   module:stateful~StatefulMixin#statechanged
	   * @param   {Object|Function} stateUpdates
	   *          A new set of properties to shallow-merge into the plugin state.
	   *          Can be a plain object or a function returning a plain object.
	   *
	   * @return {Object|undefined}
	   *          An object containing changes that occurred. If no changes
	   *          occurred, returns `undefined`.
	   */
	  setState: function setState(stateUpdates) {
	    var _this = this;
	
	    // Support providing the `stateUpdates` state as a function.
	    if (typeof stateUpdates === 'function') {
	      stateUpdates = stateUpdates();
	    }
	
	    var changes;
	    each(stateUpdates, function (value, key) {
	      // Record the change if the value is different from what's in the
	      // current state.
	      if (_this.state[key] !== value) {
	        changes = changes || {};
	        changes[key] = {
	          from: _this.state[key],
	          to: value
	        };
	      }
	
	      _this.state[key] = value;
	    }); // Only trigger "statechange" if there were changes AND we have a trigger
	    // function. This allows us to not require that the target object be an
	    // evented object.
	
	    if (changes && isEvented(this)) {
	      /**
	       * An event triggered on an object that is both
	       * {@link module:stateful|stateful} and {@link module:evented|evented}
	       * indicating that its state has changed.
	       *
	       * @event    module:stateful~StatefulMixin#statechanged
	       * @type     {Object}
	       * @property {Object} changes
	       *           A hash containing the properties that were changed and
	       *           the values they were changed `from` and `to`.
	       */
	      this.trigger({
	        changes: changes,
	        type: 'statechanged'
	      });
	    }
	
	    return changes;
	  }
	};
	/**
	 * Applies {@link module:stateful~StatefulMixin|StatefulMixin} to a target
	 * object.
	 *
	 * If the target object is {@link module:evented|evented} and has a
	 * `handleStateChanged` method, that method will be automatically bound to the
	 * `statechanged` event on itself.
	 *
	 * @param   {Object} target
	 *          The object to be made stateful.
	 *
	 * @param   {Object} [defaultState]
	 *          A default set of properties to populate the newly-stateful object's
	 *          `state` property.
	 *
	 * @return {Object}
	 *          Returns the `target`.
	 */
	
	function stateful(target, defaultState) {
	  assign(target, StatefulMixin); // This happens after the mixing-in because we need to replace the `state`
	  // added in that step.
	
	  target.state = assign({}, target.state, defaultState); // Auto-bind the `handleStateChanged` method of the target object if it exists.
	
	  if (typeof target.handleStateChanged === 'function' && isEvented(target)) {
	    target.on('statechanged', target.handleStateChanged);
	  }
	
	  return target;
	}
	
	/**
	 * @file string-cases.js
	 * @module to-lower-case
	 */
	
	/**
	 * Lowercase the first letter of a string.
	 *
	 * @param {string} string
	 *        String to be lowercased
	 *
	 * @return {string}
	 *         The string with a lowercased first letter
	 */
	var toLowerCase = function toLowerCase(string) {
	  if (typeof string !== 'string') {
	    return string;
	  }
	
	  return string.replace(/./, function (w) {
	    return w.toLowerCase();
	  });
	};
	/**
	 * Uppercase the first letter of a string.
	 *
	 * @param {string} string
	 *        String to be uppercased
	 *
	 * @return {string}
	 *         The string with an uppercased first letter
	 */
	
	var toTitleCase$1 = function toTitleCase(string) {
	  if (typeof string !== 'string') {
	    return string;
	  }
	
	  return string.replace(/./, function (w) {
	    return w.toUpperCase();
	  });
	};
	/**
	 * Compares the TitleCase versions of the two strings for equality.
	 *
	 * @param {string} str1
	 *        The first string to compare
	 *
	 * @param {string} str2
	 *        The second string to compare
	 *
	 * @return {boolean}
	 *         Whether the TitleCase versions of the strings are equal
	 */
	
	var titleCaseEquals = function titleCaseEquals(str1, str2) {
	  return toTitleCase$1(str1) === toTitleCase$1(str2);
	};
	
	/**
	 * @file merge-options.js
	 * @module merge-options
	 */
	/**
	 * Merge two objects recursively.
	 *
	 * Performs a deep merge like
	 * {@link https://lodash.com/docs/4.17.10#merge|lodash.merge}, but only merges
	 * plain objects (not arrays, elements, or anything else).
	 *
	 * Non-plain object values will be copied directly from the right-most
	 * argument.
	 *
	 * @static
	 * @param   {Object[]} sources
	 *          One or more objects to merge into a new object.
	 *
	 * @return {Object}
	 *          A new object that is the merged result of all sources.
	 */
	
	function mergeOptions$3() {
	  var result = {};
	
	  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
	    sources[_key] = arguments[_key];
	  }
	
	  sources.forEach(function (source) {
	    if (!source) {
	      return;
	    }
	
	    each(source, function (value, key) {
	      if (!isPlain(value)) {
	        result[key] = value;
	        return;
	      }
	
	      if (!isPlain(result[key])) {
	        result[key] = {};
	      }
	
	      result[key] = mergeOptions$3(result[key], value);
	    });
	  });
	  return result;
	}
	
	var MapSham = /*#__PURE__*/function () {
	  function MapSham() {
	    this.map_ = {};
	  }
	
	  var _proto = MapSham.prototype;
	
	  _proto.has = function has(key) {
	    return key in this.map_;
	  };
	
	  _proto["delete"] = function _delete(key) {
	    var has = this.has(key);
	    delete this.map_[key];
	    return has;
	  };
	
	  _proto.set = function set(key, value) {
	    this.map_[key] = value;
	    return this;
	  };
	
	  _proto.forEach = function forEach(callback, thisArg) {
	    for (var key in this.map_) {
	      callback.call(thisArg, this.map_[key], key, this);
	    }
	  };
	
	  return MapSham;
	}();
	
	var Map$1 = window__default['default'].Map ? window__default['default'].Map : MapSham;
	
	var SetSham = /*#__PURE__*/function () {
	  function SetSham() {
	    this.set_ = {};
	  }
	
	  var _proto = SetSham.prototype;
	
	  _proto.has = function has(key) {
	    return key in this.set_;
	  };
	
	  _proto["delete"] = function _delete(key) {
	    var has = this.has(key);
	    delete this.set_[key];
	    return has;
	  };
	
	  _proto.add = function add(key) {
	    this.set_[key] = 1;
	    return this;
	  };
	
	  _proto.forEach = function forEach(callback, thisArg) {
	    for (var key in this.set_) {
	      callback.call(thisArg, key, key, this);
	    }
	  };
	
	  return SetSham;
	}();
	
	var Set$1 = window__default['default'].Set ? window__default['default'].Set : SetSham;
	
	/**
	 * Player Component - Base class for all UI objects
	 *
	 * @file component.js
	 */
	/**
	 * Base class for all UI Components.
	 * Components are UI objects which represent both a javascript object and an element
	 * in the DOM. They can be children of other components, and can have
	 * children themselves.
	 *
	 * Components can also use methods from {@link EventTarget}
	 */
	
	var Component$1 = /*#__PURE__*/function () {
	  /**
	   * A callback that is called when a component is ready. Does not have any
	   * paramters and any callback value will be ignored.
	   *
	   * @callback Component~ReadyCallback
	   * @this Component
	   */
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of component options.
	   *
	   * @param {Object[]} [options.children]
	   *        An array of children objects to intialize this component with. Children objects have
	   *        a name property that will be used if more than one component of the same type needs to be
	   *        added.
	   *
	   * @param  {string} [options.className]
	   *         A class or space separated list of classes to add the component
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        Function that gets called when the `Component` is ready.
	   */
	  function Component(player, options, ready) {
	    var _this = this;
	
	    // The component might be the player itself and we can't pass `this` to super
	    if (!player && this.play) {
	      this.player_ = player = this; // eslint-disable-line
	    } else {
	      this.player_ = player;
	    }
	
	    this.isDisposed_ = false; // Hold the reference to the parent component via `addChild` method
	
	    this.parentComponent_ = null; // Make a copy of prototype.options_ to protect against overriding defaults
	
	    this.options_ = mergeOptions$3({}, this.options_); // Updated options with supplied options
	
	    options = this.options_ = mergeOptions$3(this.options_, options); // Get ID from options or options element if one is supplied
	
	    this.id_ = options.id || options.el && options.el.id; // If there was no ID from the options, generate one
	
	    if (!this.id_) {
	      // Don't require the player ID function in the case of mock players
	      var id = player && player.id && player.id() || 'no_player';
	      this.id_ = id + "_component_" + newGUID();
	    }
	
	    this.name_ = options.name || null; // Create element if one wasn't provided in options
	
	    if (options.el) {
	      this.el_ = options.el;
	    } else if (options.createEl !== false) {
	      this.el_ = this.createEl();
	    }
	
	    if (options.className && this.el_) {
	      options.className.split(' ').forEach(function (c) {
	        return _this.addClass(c);
	      });
	    } // if evented is anything except false, we want to mixin in evented
	
	
	    if (options.evented !== false) {
	      // Make this an evented object and use `el_`, if available, as its event bus
	      evented(this, {
	        eventBusKey: this.el_ ? 'el_' : null
	      });
	      this.handleLanguagechange = this.handleLanguagechange.bind(this);
	      this.on(this.player_, 'languagechange', this.handleLanguagechange);
	    }
	
	    stateful(this, this.constructor.defaultState);
	    this.children_ = [];
	    this.childIndex_ = {};
	    this.childNameIndex_ = {};
	    this.setTimeoutIds_ = new Set$1();
	    this.setIntervalIds_ = new Set$1();
	    this.rafIds_ = new Set$1();
	    this.namedRafs_ = new Map$1();
	    this.clearingTimersOnDispose_ = false; // Add any child components in options
	
	    if (options.initChildren !== false) {
	      this.initChildren();
	    } // Don't want to trigger ready here or it will go before init is actually
	    // finished for all children that run this constructor
	
	
	    this.ready(ready);
	
	    if (options.reportTouchActivity !== false) {
	      this.enableTouchActivity();
	    }
	  }
	  /**
	   * Dispose of the `Component` and all child components.
	   *
	   * @fires Component#dispose
	   *
	   * @param {Object} options
	   * @param {Element} options.originalEl element with which to replace player element
	   */
	
	
	  var _proto = Component.prototype;
	
	  _proto.dispose = function dispose(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    // Bail out if the component has already been disposed.
	    if (this.isDisposed_) {
	      return;
	    }
	
	    if (this.readyQueue_) {
	      this.readyQueue_.length = 0;
	    }
	    /**
	     * Triggered when a `Component` is disposed.
	     *
	     * @event Component#dispose
	     * @type {EventTarget~Event}
	     *
	     * @property {boolean} [bubbles=false]
	     *           set to false so that the dispose event does not
	     *           bubble up
	     */
	
	
	    this.trigger({
	      type: 'dispose',
	      bubbles: false
	    });
	    this.isDisposed_ = true; // Dispose all children.
	
	    if (this.children_) {
	      for (var i = this.children_.length - 1; i >= 0; i--) {
	        if (this.children_[i].dispose) {
	          this.children_[i].dispose();
	        }
	      }
	    } // Delete child references
	
	
	    this.children_ = null;
	    this.childIndex_ = null;
	    this.childNameIndex_ = null;
	    this.parentComponent_ = null;
	
	    if (this.el_) {
	      // Remove element from DOM
	      if (this.el_.parentNode) {
	        if (options.restoreEl) {
	          this.el_.parentNode.replaceChild(options.restoreEl, this.el_);
	        } else {
	          this.el_.parentNode.removeChild(this.el_);
	        }
	      }
	
	      this.el_ = null;
	    } // remove reference to the player after disposing of the element
	
	
	    this.player_ = null;
	  }
	  /**
	   * Determine whether or not this component has been disposed.
	   *
	   * @return {boolean}
	   *         If the component has been disposed, will be `true`. Otherwise, `false`.
	   */
	  ;
	
	  _proto.isDisposed = function isDisposed() {
	    return Boolean(this.isDisposed_);
	  }
	  /**
	   * Return the {@link Player} that the `Component` has attached to.
	   *
	   * @return {Player}
	   *         The player that this `Component` has attached to.
	   */
	  ;
	
	  _proto.player = function player() {
	    return this.player_;
	  }
	  /**
	   * Deep merge of options objects with new options.
	   * > Note: When both `obj` and `options` contain properties whose values are objects.
	   *         The two properties get merged using {@link module:mergeOptions}
	   *
	   * @param {Object} obj
	   *        The object that contains new options.
	   *
	   * @return {Object}
	   *         A new object of `this.options_` and `obj` merged together.
	   */
	  ;
	
	  _proto.options = function options(obj) {
	    if (!obj) {
	      return this.options_;
	    }
	
	    this.options_ = mergeOptions$3(this.options_, obj);
	    return this.options_;
	  }
	  /**
	   * Get the `Component`s DOM element
	   *
	   * @return {Element}
	   *         The DOM element for this `Component`.
	   */
	  ;
	
	  _proto.el = function el() {
	    return this.el_;
	  }
	  /**
	   * Create the `Component`s DOM element.
	   *
	   * @param {string} [tagName]
	   *        Element's DOM node type. e.g. 'div'
	   *
	   * @param {Object} [properties]
	   *        An object of properties that should be set.
	   *
	   * @param {Object} [attributes]
	   *        An object of attributes that should be set.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl$1(tagName, properties, attributes) {
	    return createEl(tagName, properties, attributes);
	  }
	  /**
	   * Localize a string given the string in english.
	   *
	   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
	   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
	   *
	   * If a `defaultValue` is provided, it'll use that over `string`,
	   * if a value isn't found in provided language files.
	   * This is useful if you want to have a descriptive key for token replacement
	   * but have a succinct localized string and not require `en.json` to be included.
	   *
	   * Currently, it is used for the progress bar timing.
	   * ```js
	   * {
	   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
	   * }
	   * ```
	   * It is then used like so:
	   * ```js
	   * this.localize('progress bar timing: currentTime={1} duration{2}',
	   *               [this.player_.currentTime(), this.player_.duration()],
	   *               '{1} of {2}');
	   * ```
	   *
	   * Which outputs something like: `01:23 of 24:56`.
	   *
	   *
	   * @param {string} string
	   *        The string to localize and the key to lookup in the language files.
	   * @param {string[]} [tokens]
	   *        If the current item has token replacements, provide the tokens here.
	   * @param {string} [defaultValue]
	   *        Defaults to `string`. Can be a default value to use for token replacement
	   *        if the lookup key is needed to be separate.
	   *
	   * @return {string}
	   *         The localized string or if no localization exists the english string.
	   */
	  ;
	
	  _proto.localize = function localize(string, tokens, defaultValue) {
	    if (defaultValue === void 0) {
	      defaultValue = string;
	    }
	
	    var code = this.player_.language && this.player_.language();
	    var languages = this.player_.languages && this.player_.languages();
	    var language = languages && languages[code];
	    var primaryCode = code && code.split('-')[0];
	    var primaryLang = languages && languages[primaryCode];
	    var localizedString = defaultValue;
	
	    if (language && language[string]) {
	      localizedString = language[string];
	    } else if (primaryLang && primaryLang[string]) {
	      localizedString = primaryLang[string];
	    }
	
	    if (tokens) {
	      localizedString = localizedString.replace(/\{(\d+)\}/g, function (match, index) {
	        var value = tokens[index - 1];
	        var ret = value;
	
	        if (typeof value === 'undefined') {
	          ret = match;
	        }
	
	        return ret;
	      });
	    }
	
	    return localizedString;
	  }
	  /**
	   * Handles language change for the player in components. Should be overriden by sub-components.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.handleLanguagechange = function handleLanguagechange() {}
	  /**
	   * Return the `Component`s DOM element. This is where children get inserted.
	   * This will usually be the the same as the element returned in {@link Component#el}.
	   *
	   * @return {Element}
	   *         The content element for this `Component`.
	   */
	  ;
	
	  _proto.contentEl = function contentEl() {
	    return this.contentEl_ || this.el_;
	  }
	  /**
	   * Get this `Component`s ID
	   *
	   * @return {string}
	   *         The id of this `Component`
	   */
	  ;
	
	  _proto.id = function id() {
	    return this.id_;
	  }
	  /**
	   * Get the `Component`s name. The name gets used to reference the `Component`
	   * and is set during registration.
	   *
	   * @return {string}
	   *         The name of this `Component`.
	   */
	  ;
	
	  _proto.name = function name() {
	    return this.name_;
	  }
	  /**
	   * Get an array of all child components
	   *
	   * @return {Array}
	   *         The children
	   */
	  ;
	
	  _proto.children = function children() {
	    return this.children_;
	  }
	  /**
	   * Returns the child `Component` with the given `id`.
	   *
	   * @param {string} id
	   *        The id of the child `Component` to get.
	   *
	   * @return {Component|undefined}
	   *         The child `Component` with the given `id` or undefined.
	   */
	  ;
	
	  _proto.getChildById = function getChildById(id) {
	    return this.childIndex_[id];
	  }
	  /**
	   * Returns the child `Component` with the given `name`.
	   *
	   * @param {string} name
	   *        The name of the child `Component` to get.
	   *
	   * @return {Component|undefined}
	   *         The child `Component` with the given `name` or undefined.
	   */
	  ;
	
	  _proto.getChild = function getChild(name) {
	    if (!name) {
	      return;
	    }
	
	    return this.childNameIndex_[name];
	  }
	  /**
	   * Returns the descendant `Component` following the givent
	   * descendant `names`. For instance ['foo', 'bar', 'baz'] would
	   * try to get 'foo' on the current component, 'bar' on the 'foo'
	   * component and 'baz' on the 'bar' component and return undefined
	   * if any of those don't exist.
	   *
	   * @param {...string[]|...string} names
	   *        The name of the child `Component` to get.
	   *
	   * @return {Component|undefined}
	   *         The descendant `Component` following the given descendant
	   *         `names` or undefined.
	   */
	  ;
	
	  _proto.getDescendant = function getDescendant() {
	    for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
	      names[_key] = arguments[_key];
	    }
	
	    // flatten array argument into the main array
	    names = names.reduce(function (acc, n) {
	      return acc.concat(n);
	    }, []);
	    var currentChild = this;
	
	    for (var i = 0; i < names.length; i++) {
	      currentChild = currentChild.getChild(names[i]);
	
	      if (!currentChild || !currentChild.getChild) {
	        return;
	      }
	    }
	
	    return currentChild;
	  }
	  /**
	   * Add a child `Component` inside the current `Component`.
	   *
	   *
	   * @param {string|Component} child
	   *        The name or instance of a child to add.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of options that will get passed to children of
	   *        the child.
	   *
	   * @param {number} [index=this.children_.length]
	   *        The index to attempt to add a child into.
	   *
	   * @return {Component}
	   *         The `Component` that gets added as a child. When using a string the
	   *         `Component` will get created by this process.
	   */
	  ;
	
	  _proto.addChild = function addChild(child, options, index) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (index === void 0) {
	      index = this.children_.length;
	    }
	
	    var component;
	    var componentName; // If child is a string, create component with options
	
	    if (typeof child === 'string') {
	      componentName = toTitleCase$1(child);
	      var componentClassName = options.componentClass || componentName; // Set name through options
	
	      options.name = componentName; // Create a new object & element for this controls set
	      // If there's no .player_, this is a player
	
	      var ComponentClass = Component.getComponent(componentClassName);
	
	      if (!ComponentClass) {
	        throw new Error("Component " + componentClassName + " does not exist");
	      } // data stored directly on the videojs object may be
	      // misidentified as a component to retain
	      // backwards-compatibility with 4.x. check to make sure the
	      // component class can be instantiated.
	
	
	      if (typeof ComponentClass !== 'function') {
	        return null;
	      }
	
	      component = new ComponentClass(this.player_ || this, options); // child is a component instance
	    } else {
	      component = child;
	    }
	
	    if (component.parentComponent_) {
	      component.parentComponent_.removeChild(component);
	    }
	
	    this.children_.splice(index, 0, component);
	    component.parentComponent_ = this;
	
	    if (typeof component.id === 'function') {
	      this.childIndex_[component.id()] = component;
	    } // If a name wasn't used to create the component, check if we can use the
	    // name function of the component
	
	
	    componentName = componentName || component.name && toTitleCase$1(component.name());
	
	    if (componentName) {
	      this.childNameIndex_[componentName] = component;
	      this.childNameIndex_[toLowerCase(componentName)] = component;
	    } // Add the UI object's element to the container div (box)
	    // Having an element is not required
	
	
	    if (typeof component.el === 'function' && component.el()) {
	      // If inserting before a component, insert before that component's element
	      var refNode = null;
	
	      if (this.children_[index + 1]) {
	        // Most children are components, but the video tech is an HTML element
	        if (this.children_[index + 1].el_) {
	          refNode = this.children_[index + 1].el_;
	        } else if (isEl(this.children_[index + 1])) {
	          refNode = this.children_[index + 1];
	        }
	      }
	
	      this.contentEl().insertBefore(component.el(), refNode);
	    } // Return so it can stored on parent object if desired.
	
	
	    return component;
	  }
	  /**
	   * Remove a child `Component` from this `Component`s list of children. Also removes
	   * the child `Component`s element from this `Component`s element.
	   *
	   * @param {Component} component
	   *        The child `Component` to remove.
	   */
	  ;
	
	  _proto.removeChild = function removeChild(component) {
	    if (typeof component === 'string') {
	      component = this.getChild(component);
	    }
	
	    if (!component || !this.children_) {
	      return;
	    }
	
	    var childFound = false;
	
	    for (var i = this.children_.length - 1; i >= 0; i--) {
	      if (this.children_[i] === component) {
	        childFound = true;
	        this.children_.splice(i, 1);
	        break;
	      }
	    }
	
	    if (!childFound) {
	      return;
	    }
	
	    component.parentComponent_ = null;
	    this.childIndex_[component.id()] = null;
	    this.childNameIndex_[toTitleCase$1(component.name())] = null;
	    this.childNameIndex_[toLowerCase(component.name())] = null;
	    var compEl = component.el();
	
	    if (compEl && compEl.parentNode === this.contentEl()) {
	      this.contentEl().removeChild(component.el());
	    }
	  }
	  /**
	   * Add and initialize default child `Component`s based upon options.
	   */
	  ;
	
	  _proto.initChildren = function initChildren() {
	    var _this2 = this;
	
	    var children = this.options_.children;
	
	    if (children) {
	      // `this` is `parent`
	      var parentOptions = this.options_;
	
	      var handleAdd = function handleAdd(child) {
	        var name = child.name;
	        var opts = child.opts; // Allow options for children to be set at the parent options
	        // e.g. videojs(id, { controlBar: false });
	        // instead of videojs(id, { children: { controlBar: false });
	
	        if (parentOptions[name] !== undefined) {
	          opts = parentOptions[name];
	        } // Allow for disabling default components
	        // e.g. options['children']['posterImage'] = false
	
	
	        if (opts === false) {
	          return;
	        } // Allow options to be passed as a simple boolean if no configuration
	        // is necessary.
	
	
	        if (opts === true) {
	          opts = {};
	        } // We also want to pass the original player options
	        // to each component as well so they don't need to
	        // reach back into the player for options later.
	
	
	        opts.playerOptions = _this2.options_.playerOptions; // Create and add the child component.
	        // Add a direct reference to the child by name on the parent instance.
	        // If two of the same component are used, different names should be supplied
	        // for each
	
	        var newChild = _this2.addChild(name, opts);
	
	        if (newChild) {
	          _this2[name] = newChild;
	        }
	      }; // Allow for an array of children details to passed in the options
	
	
	      var workingChildren;
	      var Tech = Component.getComponent('Tech');
	
	      if (Array.isArray(children)) {
	        workingChildren = children;
	      } else {
	        workingChildren = Object.keys(children);
	      }
	
	      workingChildren // children that are in this.options_ but also in workingChildren  would
	      // give us extra children we do not want. So, we want to filter them out.
	      .concat(Object.keys(this.options_).filter(function (child) {
	        return !workingChildren.some(function (wchild) {
	          if (typeof wchild === 'string') {
	            return child === wchild;
	          }
	
	          return child === wchild.name;
	        });
	      })).map(function (child) {
	        var name;
	        var opts;
	
	        if (typeof child === 'string') {
	          name = child;
	          opts = children[name] || _this2.options_[name] || {};
	        } else {
	          name = child.name;
	          opts = child;
	        }
	
	        return {
	          name: name,
	          opts: opts
	        };
	      }).filter(function (child) {
	        // we have to make sure that child.name isn't in the techOrder since
	        // techs are registerd as Components but can't aren't compatible
	        // See https://github.com/videojs/video.js/issues/2772
	        var c = Component.getComponent(child.opts.componentClass || toTitleCase$1(child.name));
	        return c && !Tech.isTech(c);
	      }).forEach(handleAdd);
	    }
	  }
	  /**
	   * Builds the default DOM class name. Should be overriden by sub-components.
	   *
	   * @return {string}
	   *         The DOM class name for this object.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    // Child classes can include a function that does:
	    // return 'CLASS NAME' + this._super();
	    return '';
	  }
	  /**
	   * Bind a listener to the component's ready state.
	   * Different from event listeners in that if the ready event has already happened
	   * it will trigger the function immediately.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   */
	  ;
	
	  _proto.ready = function ready(fn, sync) {
	    if (sync === void 0) {
	      sync = false;
	    }
	
	    if (!fn) {
	      return;
	    }
	
	    if (!this.isReady_) {
	      this.readyQueue_ = this.readyQueue_ || [];
	      this.readyQueue_.push(fn);
	      return;
	    }
	
	    if (sync) {
	      fn.call(this);
	    } else {
	      // Call the function asynchronously by default for consistency
	      this.setTimeout(fn, 1);
	    }
	  }
	  /**
	   * Trigger all the ready listeners for this `Component`.
	   *
	   * @fires Component#ready
	   */
	  ;
	
	  _proto.triggerReady = function triggerReady() {
	    this.isReady_ = true; // Ensure ready is triggered asynchronously
	
	    this.setTimeout(function () {
	      var readyQueue = this.readyQueue_; // Reset Ready Queue
	
	      this.readyQueue_ = [];
	
	      if (readyQueue && readyQueue.length > 0) {
	        readyQueue.forEach(function (fn) {
	          fn.call(this);
	        }, this);
	      } // Allow for using event listeners also
	
	      /**
	       * Triggered when a `Component` is ready.
	       *
	       * @event Component#ready
	       * @type {EventTarget~Event}
	       */
	
	
	      this.trigger('ready');
	    }, 1);
	  }
	  /**
	   * Find a single DOM element matching a `selector`. This can be within the `Component`s
	   * `contentEl()` or another custom context.
	   *
	   * @param {string} selector
	   *        A valid CSS selector, which will be passed to `querySelector`.
	   *
	   * @param {Element|string} [context=this.contentEl()]
	   *        A DOM element within which to query. Can also be a selector string in
	   *        which case the first matching element will get used as context. If
	   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
	   *        nothing it falls back to `document`.
	   *
	   * @return {Element|null}
	   *         the dom element that was found, or null
	   *
	   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
	   */
	  ;
	
	  _proto.$ = function $$1(selector, context) {
	    return $(selector, context || this.contentEl());
	  }
	  /**
	   * Finds all DOM element matching a `selector`. This can be within the `Component`s
	   * `contentEl()` or another custom context.
	   *
	   * @param {string} selector
	   *        A valid CSS selector, which will be passed to `querySelectorAll`.
	   *
	   * @param {Element|string} [context=this.contentEl()]
	   *        A DOM element within which to query. Can also be a selector string in
	   *        which case the first matching element will get used as context. If
	   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
	   *        nothing it falls back to `document`.
	   *
	   * @return {NodeList}
	   *         a list of dom elements that were found
	   *
	   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
	   */
	  ;
	
	  _proto.$$ = function $$$1(selector, context) {
	    return $$(selector, context || this.contentEl());
	  }
	  /**
	   * Check if a component's element has a CSS class name.
	   *
	   * @param {string} classToCheck
	   *        CSS class name to check.
	   *
	   * @return {boolean}
	   *         - True if the `Component` has the class.
	   *         - False if the `Component` does not have the class`
	   */
	  ;
	
	  _proto.hasClass = function hasClass$1(classToCheck) {
	    return hasClass(this.el_, classToCheck);
	  }
	  /**
	   * Add a CSS class name to the `Component`s element.
	   *
	   * @param {string} classToAdd
	   *        CSS class name to add
	   */
	  ;
	
	  _proto.addClass = function addClass$1(classToAdd) {
	    addClass(this.el_, classToAdd);
	  }
	  /**
	   * Remove a CSS class name from the `Component`s element.
	   *
	   * @param {string} classToRemove
	   *        CSS class name to remove
	   */
	  ;
	
	  _proto.removeClass = function removeClass$1(classToRemove) {
	    removeClass(this.el_, classToRemove);
	  }
	  /**
	   * Add or remove a CSS class name from the component's element.
	   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
	   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
	   *
	   * @param  {string} classToToggle
	   *         The class to add or remove based on (@link Component#hasClass}
	   *
	   * @param  {boolean|Dom~predicate} [predicate]
	   *         An {@link Dom~predicate} function or a boolean
	   */
	  ;
	
	  _proto.toggleClass = function toggleClass$1(classToToggle, predicate) {
	    toggleClass(this.el_, classToToggle, predicate);
	  }
	  /**
	   * Show the `Component`s element if it is hidden by removing the
	   * 'vjs-hidden' class name from it.
	   */
	  ;
	
	  _proto.show = function show() {
	    this.removeClass('vjs-hidden');
	  }
	  /**
	   * Hide the `Component`s element if it is currently showing by adding the
	   * 'vjs-hidden` class name to it.
	   */
	  ;
	
	  _proto.hide = function hide() {
	    this.addClass('vjs-hidden');
	  }
	  /**
	   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
	   * class name to it. Used during fadeIn/fadeOut.
	   *
	   * @private
	   */
	  ;
	
	  _proto.lockShowing = function lockShowing() {
	    this.addClass('vjs-lock-showing');
	  }
	  /**
	   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
	   * class name from it. Used during fadeIn/fadeOut.
	   *
	   * @private
	   */
	  ;
	
	  _proto.unlockShowing = function unlockShowing() {
	    this.removeClass('vjs-lock-showing');
	  }
	  /**
	   * Get the value of an attribute on the `Component`s element.
	   *
	   * @param {string} attribute
	   *        Name of the attribute to get the value from.
	   *
	   * @return {string|null}
	   *         - The value of the attribute that was asked for.
	   *         - Can be an empty string on some browsers if the attribute does not exist
	   *           or has no value
	   *         - Most browsers will return null if the attibute does not exist or has
	   *           no value.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
	   */
	  ;
	
	  _proto.getAttribute = function getAttribute$1(attribute) {
	    return getAttribute(this.el_, attribute);
	  }
	  /**
	   * Set the value of an attribute on the `Component`'s element
	   *
	   * @param {string} attribute
	   *        Name of the attribute to set.
	   *
	   * @param {string} value
	   *        Value to set the attribute to.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
	   */
	  ;
	
	  _proto.setAttribute = function setAttribute$1(attribute, value) {
	    setAttribute(this.el_, attribute, value);
	  }
	  /**
	   * Remove an attribute from the `Component`s element.
	   *
	   * @param {string} attribute
	   *        Name of the attribute to remove.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
	   */
	  ;
	
	  _proto.removeAttribute = function removeAttribute$1(attribute) {
	    removeAttribute(this.el_, attribute);
	  }
	  /**
	   * Get or set the width of the component based upon the CSS styles.
	   * See {@link Component#dimension} for more detailed information.
	   *
	   * @param {number|string} [num]
	   *        The width that you want to set postfixed with '%', 'px' or nothing.
	   *
	   * @param {boolean} [skipListeners]
	   *        Skip the componentresize event trigger
	   *
	   * @return {number|string}
	   *         The width when getting, zero if there is no width. Can be a string
	   *           postpixed with '%' or 'px'.
	   */
	  ;
	
	  _proto.width = function width(num, skipListeners) {
	    return this.dimension('width', num, skipListeners);
	  }
	  /**
	   * Get or set the height of the component based upon the CSS styles.
	   * See {@link Component#dimension} for more detailed information.
	   *
	   * @param {number|string} [num]
	   *        The height that you want to set postfixed with '%', 'px' or nothing.
	   *
	   * @param {boolean} [skipListeners]
	   *        Skip the componentresize event trigger
	   *
	   * @return {number|string}
	   *         The width when getting, zero if there is no width. Can be a string
	   *         postpixed with '%' or 'px'.
	   */
	  ;
	
	  _proto.height = function height(num, skipListeners) {
	    return this.dimension('height', num, skipListeners);
	  }
	  /**
	   * Set both the width and height of the `Component` element at the same time.
	   *
	   * @param  {number|string} width
	   *         Width to set the `Component`s element to.
	   *
	   * @param  {number|string} height
	   *         Height to set the `Component`s element to.
	   */
	  ;
	
	  _proto.dimensions = function dimensions(width, height) {
	    // Skip componentresize listeners on width for optimization
	    this.width(width, true);
	    this.height(height);
	  }
	  /**
	   * Get or set width or height of the `Component` element. This is the shared code
	   * for the {@link Component#width} and {@link Component#height}.
	   *
	   * Things to know:
	   * - If the width or height in an number this will return the number postfixed with 'px'.
	   * - If the width/height is a percent this will return the percent postfixed with '%'
	   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
	   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
	   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
	   *   for more information
	   * - If you want the computed style of the component, use {@link Component#currentWidth}
	   *   and {@link {Component#currentHeight}
	   *
	   * @fires Component#componentresize
	   *
	   * @param {string} widthOrHeight
	   8        'width' or 'height'
	   *
	   * @param  {number|string} [num]
	   8         New dimension
	   *
	   * @param  {boolean} [skipListeners]
	   *         Skip componentresize event trigger
	   *
	   * @return {number}
	   *         The dimension when getting or 0 if unset
	   */
	  ;
	
	  _proto.dimension = function dimension(widthOrHeight, num, skipListeners) {
	    if (num !== undefined) {
	      // Set to zero if null or literally NaN (NaN !== NaN)
	      if (num === null || num !== num) {
	        num = 0;
	      } // Check if using css width/height (% or px) and adjust
	
	
	      if (('' + num).indexOf('%') !== -1 || ('' + num).indexOf('px') !== -1) {
	        this.el_.style[widthOrHeight] = num;
	      } else if (num === 'auto') {
	        this.el_.style[widthOrHeight] = '';
	      } else {
	        this.el_.style[widthOrHeight] = num + 'px';
	      } // skipListeners allows us to avoid triggering the resize event when setting both width and height
	
	
	      if (!skipListeners) {
	        /**
	         * Triggered when a component is resized.
	         *
	         * @event Component#componentresize
	         * @type {EventTarget~Event}
	         */
	        this.trigger('componentresize');
	      }
	
	      return;
	    } // Not setting a value, so getting it
	    // Make sure element exists
	
	
	    if (!this.el_) {
	      return 0;
	    } // Get dimension value from style
	
	
	    var val = this.el_.style[widthOrHeight];
	    var pxIndex = val.indexOf('px');
	
	    if (pxIndex !== -1) {
	      // Return the pixel value with no 'px'
	      return parseInt(val.slice(0, pxIndex), 10);
	    } // No px so using % or no style was set, so falling back to offsetWidth/height
	    // If component has display:none, offset will return 0
	    // TODO: handle display:none and no dimension style using px
	
	
	    return parseInt(this.el_['offset' + toTitleCase$1(widthOrHeight)], 10);
	  }
	  /**
	   * Get the computed width or the height of the component's element.
	   *
	   * Uses `window.getComputedStyle`.
	   *
	   * @param {string} widthOrHeight
	   *        A string containing 'width' or 'height'. Whichever one you want to get.
	   *
	   * @return {number}
	   *         The dimension that gets asked for or 0 if nothing was set
	   *         for that dimension.
	   */
	  ;
	
	  _proto.currentDimension = function currentDimension(widthOrHeight) {
	    var computedWidthOrHeight = 0;
	
	    if (widthOrHeight !== 'width' && widthOrHeight !== 'height') {
	      throw new Error('currentDimension only accepts width or height value');
	    }
	
	    computedWidthOrHeight = computedStyle(this.el_, widthOrHeight); // remove 'px' from variable and parse as integer
	
	    computedWidthOrHeight = parseFloat(computedWidthOrHeight); // if the computed value is still 0, it's possible that the browser is lying
	    // and we want to check the offset values.
	    // This code also runs wherever getComputedStyle doesn't exist.
	
	    if (computedWidthOrHeight === 0 || isNaN(computedWidthOrHeight)) {
	      var rule = "offset" + toTitleCase$1(widthOrHeight);
	      computedWidthOrHeight = this.el_[rule];
	    }
	
	    return computedWidthOrHeight;
	  }
	  /**
	   * An object that contains width and height values of the `Component`s
	   * computed style. Uses `window.getComputedStyle`.
	   *
	   * @typedef {Object} Component~DimensionObject
	   *
	   * @property {number} width
	   *           The width of the `Component`s computed style.
	   *
	   * @property {number} height
	   *           The height of the `Component`s computed style.
	   */
	
	  /**
	   * Get an object that contains computed width and height values of the
	   * component's element.
	   *
	   * Uses `window.getComputedStyle`.
	   *
	   * @return {Component~DimensionObject}
	   *         The computed dimensions of the component's element.
	   */
	  ;
	
	  _proto.currentDimensions = function currentDimensions() {
	    return {
	      width: this.currentDimension('width'),
	      height: this.currentDimension('height')
	    };
	  }
	  /**
	   * Get the computed width of the component's element.
	   *
	   * Uses `window.getComputedStyle`.
	   *
	   * @return {number}
	   *         The computed width of the component's element.
	   */
	  ;
	
	  _proto.currentWidth = function currentWidth() {
	    return this.currentDimension('width');
	  }
	  /**
	   * Get the computed height of the component's element.
	   *
	   * Uses `window.getComputedStyle`.
	   *
	   * @return {number}
	   *         The computed height of the component's element.
	   */
	  ;
	
	  _proto.currentHeight = function currentHeight() {
	    return this.currentDimension('height');
	  }
	  /**
	   * Set the focus to this component
	   */
	  ;
	
	  _proto.focus = function focus() {
	    this.el_.focus();
	  }
	  /**
	   * Remove the focus from this component
	   */
	  ;
	
	  _proto.blur = function blur() {
	    this.el_.blur();
	  }
	  /**
	   * When this Component receives a `keydown` event which it does not process,
	   *  it passes the event to the Player for handling.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    if (this.player_) {
	      // We only stop propagation here because we want unhandled events to fall
	      // back to the browser. Exclude Tab for focus trapping.
	      if (!keycode__default['default'].isEventKey(event, 'Tab')) {
	        event.stopPropagation();
	      }
	
	      this.player_.handleKeyDown(event);
	    }
	  }
	  /**
	   * Many components used to have a `handleKeyPress` method, which was poorly
	   * named because it listened to a `keydown` event. This method name now
	   * delegates to `handleKeyDown`. This means anyone calling `handleKeyPress`
	   * will not see their method calls stop working.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleKeyPress = function handleKeyPress(event) {
	    this.handleKeyDown(event);
	  }
	  /**
	   * Emit a 'tap' events when touch event support gets detected. This gets used to
	   * support toggling the controls through a tap on the video. They get enabled
	   * because every sub-component would have extra overhead otherwise.
	   *
	   * @private
	   * @fires Component#tap
	   * @listens Component#touchstart
	   * @listens Component#touchmove
	   * @listens Component#touchleave
	   * @listens Component#touchcancel
	   * @listens Component#touchend
	    */
	  ;
	
	  _proto.emitTapEvents = function emitTapEvents() {
	    // Track the start time so we can determine how long the touch lasted
	    var touchStart = 0;
	    var firstTouch = null; // Maximum movement allowed during a touch event to still be considered a tap
	    // Other popular libs use anywhere from 2 (hammer.js) to 15,
	    // so 10 seems like a nice, round number.
	
	    var tapMovementThreshold = 10; // The maximum length a touch can be while still being considered a tap
	
	    var touchTimeThreshold = 200;
	    var couldBeTap;
	    this.on('touchstart', function (event) {
	      // If more than one finger, don't consider treating this as a click
	      if (event.touches.length === 1) {
	        // Copy pageX/pageY from the object
	        firstTouch = {
	          pageX: event.touches[0].pageX,
	          pageY: event.touches[0].pageY
	        }; // Record start time so we can detect a tap vs. "touch and hold"
	
	        touchStart = window__default['default'].performance.now(); // Reset couldBeTap tracking
	
	        couldBeTap = true;
	      }
	    });
	    this.on('touchmove', function (event) {
	      // If more than one finger, don't consider treating this as a click
	      if (event.touches.length > 1) {
	        couldBeTap = false;
	      } else if (firstTouch) {
	        // Some devices will throw touchmoves for all but the slightest of taps.
	        // So, if we moved only a small distance, this could still be a tap
	        var xdiff = event.touches[0].pageX - firstTouch.pageX;
	        var ydiff = event.touches[0].pageY - firstTouch.pageY;
	        var touchDistance = Math.sqrt(xdiff * xdiff + ydiff * ydiff);
	
	        if (touchDistance > tapMovementThreshold) {
	          couldBeTap = false;
	        }
	      }
	    });
	
	    var noTap = function noTap() {
	      couldBeTap = false;
	    }; // TODO: Listen to the original target. http://youtu.be/DujfpXOKUp8?t=13m8s
	
	
	    this.on('touchleave', noTap);
	    this.on('touchcancel', noTap); // When the touch ends, measure how long it took and trigger the appropriate
	    // event
	
	    this.on('touchend', function (event) {
	      firstTouch = null; // Proceed only if the touchmove/leave/cancel event didn't happen
	
	      if (couldBeTap === true) {
	        // Measure how long the touch lasted
	        var touchTime = window__default['default'].performance.now() - touchStart; // Make sure the touch was less than the threshold to be considered a tap
	
	        if (touchTime < touchTimeThreshold) {
	          // Don't let browser turn this into a click
	          event.preventDefault();
	          /**
	           * Triggered when a `Component` is tapped.
	           *
	           * @event Component#tap
	           * @type {EventTarget~Event}
	           */
	
	          this.trigger('tap'); // It may be good to copy the touchend event object and change the
	          // type to tap, if the other event properties aren't exact after
	          // Events.fixEvent runs (e.g. event.target)
	        }
	      }
	    });
	  }
	  /**
	   * This function reports user activity whenever touch events happen. This can get
	   * turned off by any sub-components that wants touch events to act another way.
	   *
	   * Report user touch activity when touch events occur. User activity gets used to
	   * determine when controls should show/hide. It is simple when it comes to mouse
	   * events, because any mouse event should show the controls. So we capture mouse
	   * events that bubble up to the player and report activity when that happens.
	   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
	   * controls. So touch events can't help us at the player level either.
	   *
	   * User activity gets checked asynchronously. So what could happen is a tap event
	   * on the video turns the controls off. Then the `touchend` event bubbles up to
	   * the player. Which, if it reported user activity, would turn the controls right
	   * back on. We also don't want to completely block touch events from bubbling up.
	   * Furthermore a `touchmove` event and anything other than a tap, should not turn
	   * controls back on.
	   *
	   * @listens Component#touchstart
	   * @listens Component#touchmove
	   * @listens Component#touchend
	   * @listens Component#touchcancel
	   */
	  ;
	
	  _proto.enableTouchActivity = function enableTouchActivity() {
	    // Don't continue if the root player doesn't support reporting user activity
	    if (!this.player() || !this.player().reportUserActivity) {
	      return;
	    } // listener for reporting that the user is active
	
	
	    var report = bind(this.player(), this.player().reportUserActivity);
	    var touchHolding;
	    this.on('touchstart', function () {
	      report(); // For as long as the they are touching the device or have their mouse down,
	      // we consider them active even if they're not moving their finger or mouse.
	      // So we want to continue to update that they are active
	
	      this.clearInterval(touchHolding); // report at the same interval as activityCheck
	
	      touchHolding = this.setInterval(report, 250);
	    });
	
	    var touchEnd = function touchEnd(event) {
	      report(); // stop the interval that maintains activity if the touch is holding
	
	      this.clearInterval(touchHolding);
	    };
	
	    this.on('touchmove', report);
	    this.on('touchend', touchEnd);
	    this.on('touchcancel', touchEnd);
	  }
	  /**
	   * A callback that has no parameters and is bound into `Component`s context.
	   *
	   * @callback Component~GenericCallback
	   * @this Component
	   */
	
	  /**
	   * Creates a function that runs after an `x` millisecond timeout. This function is a
	   * wrapper around `window.setTimeout`. There are a few reasons to use this one
	   * instead though:
	   * 1. It gets cleared via  {@link Component#clearTimeout} when
	   *    {@link Component#dispose} gets called.
	   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
	   *
	   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
	   *         will cause its dispose listener not to get cleaned up! Please use
	   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
	   *
	   * @param {Component~GenericCallback} fn
	   *        The function that will be run after `timeout`.
	   *
	   * @param {number} timeout
	   *        Timeout in milliseconds to delay before executing the specified function.
	   *
	   * @return {number}
	   *         Returns a timeout ID that gets used to identify the timeout. It can also
	   *         get used in {@link Component#clearTimeout} to clear the timeout that
	   *         was set.
	   *
	   * @listens Component#dispose
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
	   */
	  ;
	
	  _proto.setTimeout = function setTimeout(fn, timeout) {
	    var _this3 = this;
	
	    // declare as variables so they are properly available in timeout function
	    // eslint-disable-next-line
	    var timeoutId;
	    fn = bind(this, fn);
	    this.clearTimersOnDispose_();
	    timeoutId = window__default['default'].setTimeout(function () {
	      if (_this3.setTimeoutIds_.has(timeoutId)) {
	        _this3.setTimeoutIds_["delete"](timeoutId);
	      }
	
	      fn();
	    }, timeout);
	    this.setTimeoutIds_.add(timeoutId);
	    return timeoutId;
	  }
	  /**
	   * Clears a timeout that gets created via `window.setTimeout` or
	   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
	   * use this function instead of `window.clearTimout`. If you don't your dispose
	   * listener will not get cleaned up until {@link Component#dispose}!
	   *
	   * @param {number} timeoutId
	   *        The id of the timeout to clear. The return value of
	   *        {@link Component#setTimeout} or `window.setTimeout`.
	   *
	   * @return {number}
	   *         Returns the timeout id that was cleared.
	   *
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
	   */
	  ;
	
	  _proto.clearTimeout = function clearTimeout(timeoutId) {
	    if (this.setTimeoutIds_.has(timeoutId)) {
	      this.setTimeoutIds_["delete"](timeoutId);
	      window__default['default'].clearTimeout(timeoutId);
	    }
	
	    return timeoutId;
	  }
	  /**
	   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
	   * around `window.setInterval`. There are a few reasons to use this one instead though.
	   * 1. It gets cleared via  {@link Component#clearInterval} when
	   *    {@link Component#dispose} gets called.
	   * 2. The function callback will be a {@link Component~GenericCallback}
	   *
	   * @param {Component~GenericCallback} fn
	   *        The function to run every `x` seconds.
	   *
	   * @param {number} interval
	   *        Execute the specified function every `x` milliseconds.
	   *
	   * @return {number}
	   *         Returns an id that can be used to identify the interval. It can also be be used in
	   *         {@link Component#clearInterval} to clear the interval.
	   *
	   * @listens Component#dispose
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
	   */
	  ;
	
	  _proto.setInterval = function setInterval(fn, interval) {
	    fn = bind(this, fn);
	    this.clearTimersOnDispose_();
	    var intervalId = window__default['default'].setInterval(fn, interval);
	    this.setIntervalIds_.add(intervalId);
	    return intervalId;
	  }
	  /**
	   * Clears an interval that gets created via `window.setInterval` or
	   * {@link Component#setInterval}. If you set an inteval via {@link Component#setInterval}
	   * use this function instead of `window.clearInterval`. If you don't your dispose
	   * listener will not get cleaned up until {@link Component#dispose}!
	   *
	   * @param {number} intervalId
	   *        The id of the interval to clear. The return value of
	   *        {@link Component#setInterval} or `window.setInterval`.
	   *
	   * @return {number}
	   *         Returns the interval id that was cleared.
	   *
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
	   */
	  ;
	
	  _proto.clearInterval = function clearInterval(intervalId) {
	    if (this.setIntervalIds_.has(intervalId)) {
	      this.setIntervalIds_["delete"](intervalId);
	      window__default['default'].clearInterval(intervalId);
	    }
	
	    return intervalId;
	  }
	  /**
	   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
	   * with a few extra bonuses:
	   *
	   * - Supports browsers that do not support rAF by falling back to
	   *   {@link Component#setTimeout}.
	   *
	   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
	   *   bound to the component).
	   *
	   * - Automatic cancellation of the rAF callback is handled if the component
	   *   is disposed before it is called.
	   *
	   * @param  {Component~GenericCallback} fn
	   *         A function that will be bound to this component and executed just
	   *         before the browser's next repaint.
	   *
	   * @return {number}
	   *         Returns an rAF ID that gets used to identify the timeout. It can
	   *         also be used in {@link Component#cancelAnimationFrame} to cancel
	   *         the animation frame callback.
	   *
	   * @listens Component#dispose
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
	   */
	  ;
	
	  _proto.requestAnimationFrame = function requestAnimationFrame(fn) {
	    var _this4 = this;
	
	    // Fall back to using a timer.
	    if (!this.supportsRaf_) {
	      return this.setTimeout(fn, 1000 / 60);
	    }
	
	    this.clearTimersOnDispose_(); // declare as variables so they are properly available in rAF function
	    // eslint-disable-next-line
	
	    var id;
	    fn = bind(this, fn);
	    id = window__default['default'].requestAnimationFrame(function () {
	      if (_this4.rafIds_.has(id)) {
	        _this4.rafIds_["delete"](id);
	      }
	
	      fn();
	    });
	    this.rafIds_.add(id);
	    return id;
	  }
	  /**
	   * Request an animation frame, but only one named animation
	   * frame will be queued. Another will never be added until
	   * the previous one finishes.
	   *
	   * @param {string} name
	   *        The name to give this requestAnimationFrame
	   *
	   * @param  {Component~GenericCallback} fn
	   *         A function that will be bound to this component and executed just
	   *         before the browser's next repaint.
	   */
	  ;
	
	  _proto.requestNamedAnimationFrame = function requestNamedAnimationFrame(name, fn) {
	    var _this5 = this;
	
	    if (this.namedRafs_.has(name)) {
	      return;
	    }
	
	    this.clearTimersOnDispose_();
	    fn = bind(this, fn);
	    var id = this.requestAnimationFrame(function () {
	      fn();
	
	      if (_this5.namedRafs_.has(name)) {
	        _this5.namedRafs_["delete"](name);
	      }
	    });
	    this.namedRafs_.set(name, id);
	    return name;
	  }
	  /**
	   * Cancels a current named animation frame if it exists.
	   *
	   * @param {string} name
	   *        The name of the requestAnimationFrame to cancel.
	   */
	  ;
	
	  _proto.cancelNamedAnimationFrame = function cancelNamedAnimationFrame(name) {
	    if (!this.namedRafs_.has(name)) {
	      return;
	    }
	
	    this.cancelAnimationFrame(this.namedRafs_.get(name));
	    this.namedRafs_["delete"](name);
	  }
	  /**
	   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
	   * (rAF).
	   *
	   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
	   * use this function instead of `window.cancelAnimationFrame`. If you don't,
	   * your dispose listener will not get cleaned up until {@link Component#dispose}!
	   *
	   * @param {number} id
	   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
	   *
	   * @return {number}
	   *         Returns the rAF ID that was cleared.
	   *
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
	   */
	  ;
	
	  _proto.cancelAnimationFrame = function cancelAnimationFrame(id) {
	    // Fall back to using a timer.
	    if (!this.supportsRaf_) {
	      return this.clearTimeout(id);
	    }
	
	    if (this.rafIds_.has(id)) {
	      this.rafIds_["delete"](id);
	      window__default['default'].cancelAnimationFrame(id);
	    }
	
	    return id;
	  }
	  /**
	   * A function to setup `requestAnimationFrame`, `setTimeout`,
	   * and `setInterval`, clearing on dispose.
	   *
	   * > Previously each timer added and removed dispose listeners on it's own.
	   * For better performance it was decided to batch them all, and use `Set`s
	   * to track outstanding timer ids.
	   *
	   * @private
	   */
	  ;
	
	  _proto.clearTimersOnDispose_ = function clearTimersOnDispose_() {
	    var _this6 = this;
	
	    if (this.clearingTimersOnDispose_) {
	      return;
	    }
	
	    this.clearingTimersOnDispose_ = true;
	    this.one('dispose', function () {
	      [['namedRafs_', 'cancelNamedAnimationFrame'], ['rafIds_', 'cancelAnimationFrame'], ['setTimeoutIds_', 'clearTimeout'], ['setIntervalIds_', 'clearInterval']].forEach(function (_ref) {
	        var idName = _ref[0],
	            cancelName = _ref[1];
	
	        // for a `Set` key will actually be the value again
	        // so forEach((val, val) =>` but for maps we want to use
	        // the key.
	        _this6[idName].forEach(function (val, key) {
	          return _this6[cancelName](key);
	        });
	      });
	      _this6.clearingTimersOnDispose_ = false;
	    });
	  }
	  /**
	   * Register a `Component` with `videojs` given the name and the component.
	   *
	   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
	   *         should be registered using {@link Tech.registerTech} or
	   *         {@link videojs:videojs.registerTech}.
	   *
	   * > NOTE: This function can also be seen on videojs as
	   *         {@link videojs:videojs.registerComponent}.
	   *
	   * @param {string} name
	   *        The name of the `Component` to register.
	   *
	   * @param {Component} ComponentToRegister
	   *        The `Component` class to register.
	   *
	   * @return {Component}
	   *         The `Component` that was registered.
	   */
	  ;
	
	  Component.registerComponent = function registerComponent(name, ComponentToRegister) {
	    if (typeof name !== 'string' || !name) {
	      throw new Error("Illegal component name, \"" + name + "\"; must be a non-empty string.");
	    }
	
	    var Tech = Component.getComponent('Tech'); // We need to make sure this check is only done if Tech has been registered.
	
	    var isTech = Tech && Tech.isTech(ComponentToRegister);
	    var isComp = Component === ComponentToRegister || Component.prototype.isPrototypeOf(ComponentToRegister.prototype);
	
	    if (isTech || !isComp) {
	      var reason;
	
	      if (isTech) {
	        reason = 'techs must be registered using Tech.registerTech()';
	      } else {
	        reason = 'must be a Component subclass';
	      }
	
	      throw new Error("Illegal component, \"" + name + "\"; " + reason + ".");
	    }
	
	    name = toTitleCase$1(name);
	
	    if (!Component.components_) {
	      Component.components_ = {};
	    }
	
	    var Player = Component.getComponent('Player');
	
	    if (name === 'Player' && Player && Player.players) {
	      var players = Player.players;
	      var playerNames = Object.keys(players); // If we have players that were disposed, then their name will still be
	      // in Players.players. So, we must loop through and verify that the value
	      // for each item is not null. This allows registration of the Player component
	      // after all players have been disposed or before any were created.
	
	      if (players && playerNames.length > 0 && playerNames.map(function (pname) {
	        return players[pname];
	      }).every(Boolean)) {
	        throw new Error('Can not register Player component after player has been created.');
	      }
	    }
	
	    Component.components_[name] = ComponentToRegister;
	    Component.components_[toLowerCase(name)] = ComponentToRegister;
	    return ComponentToRegister;
	  }
	  /**
	   * Get a `Component` based on the name it was registered with.
	   *
	   * @param {string} name
	   *        The Name of the component to get.
	   *
	   * @return {Component}
	   *         The `Component` that got registered under the given name.
	   */
	  ;
	
	  Component.getComponent = function getComponent(name) {
	    if (!name || !Component.components_) {
	      return;
	    }
	
	    return Component.components_[name];
	  };
	
	  return Component;
	}();
	/**
	 * Whether or not this component supports `requestAnimationFrame`.
	 *
	 * This is exposed primarily for testing purposes.
	 *
	 * @private
	 * @type {Boolean}
	 */
	
	
	Component$1.prototype.supportsRaf_ = typeof window__default['default'].requestAnimationFrame === 'function' && typeof window__default['default'].cancelAnimationFrame === 'function';
	Component$1.registerComponent('Component', Component$1);
	
	/**
	 * @file time-ranges.js
	 * @module time-ranges
	 */
	/**
	 * Returns the time for the specified index at the start or end
	 * of a TimeRange object.
	 *
	 * @typedef    {Function} TimeRangeIndex
	 *
	 * @param      {number} [index=0]
	 *             The range number to return the time for.
	 *
	 * @return     {number}
	 *             The time offset at the specified index.
	 *
	 * @deprecated The index argument must be provided.
	 *             In the future, leaving it out will throw an error.
	 */
	
	/**
	 * An object that contains ranges of time.
	 *
	 * @typedef  {Object} TimeRange
	 *
	 * @property {number} length
	 *           The number of time ranges represented by this object.
	 *
	 * @property {module:time-ranges~TimeRangeIndex} start
	 *           Returns the time offset at which a specified time range begins.
	 *
	 * @property {module:time-ranges~TimeRangeIndex} end
	 *           Returns the time offset at which a specified time range ends.
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges
	 */
	
	/**
	 * Check if any of the time ranges are over the maximum index.
	 *
	 * @private
	 * @param   {string} fnName
	 *          The function name to use for logging
	 *
	 * @param   {number} index
	 *          The index to check
	 *
	 * @param   {number} maxIndex
	 *          The maximum possible index
	 *
	 * @throws  {Error} if the timeRanges provided are over the maxIndex
	 */
	
	function rangeCheck(fnName, index, maxIndex) {
	  if (typeof index !== 'number' || index < 0 || index > maxIndex) {
	    throw new Error("Failed to execute '" + fnName + "' on 'TimeRanges': The index provided (" + index + ") is non-numeric or out of bounds (0-" + maxIndex + ").");
	  }
	}
	/**
	 * Get the time for the specified index at the start or end
	 * of a TimeRange object.
	 *
	 * @private
	 * @param      {string} fnName
	 *             The function name to use for logging
	 *
	 * @param      {string} valueIndex
	 *             The property that should be used to get the time. should be
	 *             'start' or 'end'
	 *
	 * @param      {Array} ranges
	 *             An array of time ranges
	 *
	 * @param      {Array} [rangeIndex=0]
	 *             The index to start the search at
	 *
	 * @return     {number}
	 *             The time that offset at the specified index.
	 *
	 * @deprecated rangeIndex must be set to a value, in the future this will throw an error.
	 * @throws     {Error} if rangeIndex is more than the length of ranges
	 */
	
	
	function getRange(fnName, valueIndex, ranges, rangeIndex) {
	  rangeCheck(fnName, rangeIndex, ranges.length - 1);
	  return ranges[rangeIndex][valueIndex];
	}
	/**
	 * Create a time range object given ranges of time.
	 *
	 * @private
	 * @param   {Array} [ranges]
	 *          An array of time ranges.
	 */
	
	
	function createTimeRangesObj(ranges) {
	  var timeRangesObj;
	
	  if (ranges === undefined || ranges.length === 0) {
	    timeRangesObj = {
	      length: 0,
	      start: function start() {
	        throw new Error('This TimeRanges object is empty');
	      },
	      end: function end() {
	        throw new Error('This TimeRanges object is empty');
	      }
	    };
	  } else {
	    timeRangesObj = {
	      length: ranges.length,
	      start: getRange.bind(null, 'start', 0, ranges),
	      end: getRange.bind(null, 'end', 1, ranges)
	    };
	  }
	
	  if (window__default['default'].Symbol && window__default['default'].Symbol.iterator) {
	    timeRangesObj[window__default['default'].Symbol.iterator] = function () {
	      return (ranges || []).values();
	    };
	  }
	
	  return timeRangesObj;
	}
	/**
	 * Create a `TimeRange` object which mimics an
	 * {@link https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges|HTML5 TimeRanges instance}.
	 *
	 * @param {number|Array[]} start
	 *        The start of a single range (a number) or an array of ranges (an
	 *        array of arrays of two numbers each).
	 *
	 * @param {number} end
	 *        The end of a single range. Cannot be used with the array form of
	 *        the `start` argument.
	 */
	
	
	function createTimeRanges(start, end) {
	  if (Array.isArray(start)) {
	    return createTimeRangesObj(start);
	  } else if (start === undefined || end === undefined) {
	    return createTimeRangesObj();
	  }
	
	  return createTimeRangesObj([[start, end]]);
	}
	
	/**
	 * @file buffer.js
	 * @module buffer
	 */
	/**
	 * Compute the percentage of the media that has been buffered.
	 *
	 * @param {TimeRange} buffered
	 *        The current `TimeRange` object representing buffered time ranges
	 *
	 * @param {number} duration
	 *        Total duration of the media
	 *
	 * @return {number}
	 *         Percent buffered of the total duration in decimal form.
	 */
	
	function bufferedPercent(buffered, duration) {
	  var bufferedDuration = 0;
	  var start;
	  var end;
	
	  if (!duration) {
	    return 0;
	  }
	
	  if (!buffered || !buffered.length) {
	    buffered = createTimeRanges(0, 0);
	  }
	
	  for (var i = 0; i < buffered.length; i++) {
	    start = buffered.start(i);
	    end = buffered.end(i); // buffered end can be bigger than duration by a very small fraction
	
	    if (end > duration) {
	      end = duration;
	    }
	
	    bufferedDuration += end - start;
	  }
	
	  return bufferedDuration / duration;
	}
	
	/**
	 * @file media-error.js
	 */
	/**
	 * A Custom `MediaError` class which mimics the standard HTML5 `MediaError` class.
	 *
	 * @param {number|string|Object|MediaError} value
	 *        This can be of multiple types:
	 *        - number: should be a standard error code
	 *        - string: an error message (the code will be 0)
	 *        - Object: arbitrary properties
	 *        - `MediaError` (native): used to populate a video.js `MediaError` object
	 *        - `MediaError` (video.js): will return itself if it's already a
	 *          video.js `MediaError` object.
	 *
	 * @see [MediaError Spec]{@link https://dev.w3.org/html5/spec-author-view/video.html#mediaerror}
	 * @see [Encrypted MediaError Spec]{@link https://www.w3.org/TR/2013/WD-encrypted-media-20130510/#error-codes}
	 *
	 * @class MediaError
	 */
	
	function MediaError(value) {
	  // Allow redundant calls to this constructor to avoid having `instanceof`
	  // checks peppered around the code.
	  if (value instanceof MediaError) {
	    return value;
	  }
	
	  if (typeof value === 'number') {
	    this.code = value;
	  } else if (typeof value === 'string') {
	    // default code is zero, so this is a custom error
	    this.message = value;
	  } else if (isObject(value)) {
	    // We assign the `code` property manually because native `MediaError` objects
	    // do not expose it as an own/enumerable property of the object.
	    if (typeof value.code === 'number') {
	      this.code = value.code;
	    }
	
	    assign(this, value);
	  }
	
	  if (!this.message) {
	    this.message = MediaError.defaultMessages[this.code] || '';
	  }
	}
	/**
	 * The error code that refers two one of the defined `MediaError` types
	 *
	 * @type {Number}
	 */
	
	
	MediaError.prototype.code = 0;
	/**
	 * An optional message that to show with the error. Message is not part of the HTML5
	 * video spec but allows for more informative custom errors.
	 *
	 * @type {String}
	 */
	
	MediaError.prototype.message = '';
	/**
	 * An optional status code that can be set by plugins to allow even more detail about
	 * the error. For example a plugin might provide a specific HTTP status code and an
	 * error message for that code. Then when the plugin gets that error this class will
	 * know how to display an error message for it. This allows a custom message to show
	 * up on the `Player` error overlay.
	 *
	 * @type {Array}
	 */
	
	MediaError.prototype.status = null;
	/**
	 * Errors indexed by the W3C standard. The order **CANNOT CHANGE**! See the
	 * specification listed under {@link MediaError} for more information.
	 *
	 * @enum {array}
	 * @readonly
	 * @property {string} 0 - MEDIA_ERR_CUSTOM
	 * @property {string} 1 - MEDIA_ERR_ABORTED
	 * @property {string} 2 - MEDIA_ERR_NETWORK
	 * @property {string} 3 - MEDIA_ERR_DECODE
	 * @property {string} 4 - MEDIA_ERR_SRC_NOT_SUPPORTED
	 * @property {string} 5 - MEDIA_ERR_ENCRYPTED
	 */
	
	MediaError.errorTypes = ['MEDIA_ERR_CUSTOM', 'MEDIA_ERR_ABORTED', 'MEDIA_ERR_NETWORK', 'MEDIA_ERR_DECODE', 'MEDIA_ERR_SRC_NOT_SUPPORTED', 'MEDIA_ERR_ENCRYPTED'];
	/**
	 * The default `MediaError` messages based on the {@link MediaError.errorTypes}.
	 *
	 * @type {Array}
	 * @constant
	 */
	
	MediaError.defaultMessages = {
	  1: 'You aborted the media playback',
	  2: 'A network error caused the media download to fail part-way.',
	  3: 'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.',
	  4: 'The media could not be loaded, either because the server or network failed or because the format is not supported.',
	  5: 'The media is encrypted and we do not have the keys to decrypt it.'
	}; // Add types as properties on MediaError
	// e.g. MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
	
	for (var errNum = 0; errNum < MediaError.errorTypes.length; errNum++) {
	  MediaError[MediaError.errorTypes[errNum]] = errNum; // values should be accessible on both the class and instance
	
	  MediaError.prototype[MediaError.errorTypes[errNum]] = errNum;
	} // jsdocs for instance/static members added above
	
	/**
	 * Returns whether an object is `Promise`-like (i.e. has a `then` method).
	 *
	 * @param  {Object}  value
	 *         An object that may or may not be `Promise`-like.
	 *
	 * @return {boolean}
	 *         Whether or not the object is `Promise`-like.
	 */
	function isPromise(value) {
	  return value !== undefined && value !== null && typeof value.then === 'function';
	}
	/**
	 * Silence a Promise-like object.
	 *
	 * This is useful for avoiding non-harmful, but potentially confusing "uncaught
	 * play promise" rejection error messages.
	 *
	 * @param  {Object} value
	 *         An object that may or may not be `Promise`-like.
	 */
	
	function silencePromise(value) {
	  if (isPromise(value)) {
	    value.then(null, function (e) {});
	  }
	}
	
	/**
	 * @file text-track-list-converter.js Utilities for capturing text track state and
	 * re-creating tracks based on a capture.
	 *
	 * @module text-track-list-converter
	 */
	
	/**
	 * Examine a single {@link TextTrack} and return a JSON-compatible javascript object that
	 * represents the {@link TextTrack}'s state.
	 *
	 * @param {TextTrack} track
	 *        The text track to query.
	 *
	 * @return {Object}
	 *         A serializable javascript representation of the TextTrack.
	 * @private
	 */
	var trackToJson_ = function trackToJson_(track) {
	  var ret = ['kind', 'label', 'language', 'id', 'inBandMetadataTrackDispatchType', 'mode', 'src'].reduce(function (acc, prop, i) {
	    if (track[prop]) {
	      acc[prop] = track[prop];
	    }
	
	    return acc;
	  }, {
	    cues: track.cues && Array.prototype.map.call(track.cues, function (cue) {
	      return {
	        startTime: cue.startTime,
	        endTime: cue.endTime,
	        text: cue.text,
	        id: cue.id
	      };
	    })
	  });
	  return ret;
	};
	/**
	 * Examine a {@link Tech} and return a JSON-compatible javascript array that represents the
	 * state of all {@link TextTrack}s currently configured. The return array is compatible with
	 * {@link text-track-list-converter:jsonToTextTracks}.
	 *
	 * @param {Tech} tech
	 *        The tech object to query
	 *
	 * @return {Array}
	 *         A serializable javascript representation of the {@link Tech}s
	 *         {@link TextTrackList}.
	 */
	
	
	var textTracksToJson = function textTracksToJson(tech) {
	  var trackEls = tech.$$('track');
	  var trackObjs = Array.prototype.map.call(trackEls, function (t) {
	    return t.track;
	  });
	  var tracks = Array.prototype.map.call(trackEls, function (trackEl) {
	    var json = trackToJson_(trackEl.track);
	
	    if (trackEl.src) {
	      json.src = trackEl.src;
	    }
	
	    return json;
	  });
	  return tracks.concat(Array.prototype.filter.call(tech.textTracks(), function (track) {
	    return trackObjs.indexOf(track) === -1;
	  }).map(trackToJson_));
	};
	/**
	 * Create a set of remote {@link TextTrack}s on a {@link Tech} based on an array of javascript
	 * object {@link TextTrack} representations.
	 *
	 * @param {Array} json
	 *        An array of `TextTrack` representation objects, like those that would be
	 *        produced by `textTracksToJson`.
	 *
	 * @param {Tech} tech
	 *        The `Tech` to create the `TextTrack`s on.
	 */
	
	
	var jsonToTextTracks = function jsonToTextTracks(json, tech) {
	  json.forEach(function (track) {
	    var addedTrack = tech.addRemoteTextTrack(track).track;
	
	    if (!track.src && track.cues) {
	      track.cues.forEach(function (cue) {
	        return addedTrack.addCue(cue);
	      });
	    }
	  });
	  return tech.textTracks();
	};
	
	var textTrackConverter = {
	  textTracksToJson: textTracksToJson,
	  jsonToTextTracks: jsonToTextTracks,
	  trackToJson_: trackToJson_
	};
	
	var MODAL_CLASS_NAME = 'vjs-modal-dialog';
	/**
	 * The `ModalDialog` displays over the video and its controls, which blocks
	 * interaction with the player until it is closed.
	 *
	 * Modal dialogs include a "Close" button and will close when that button
	 * is activated - or when ESC is pressed anywhere.
	 *
	 * @extends Component
	 */
	
	var ModalDialog = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ModalDialog, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Mixed} [options.content=undefined]
	   *        Provide customized content for this modal.
	   *
	   * @param {string} [options.description]
	   *        A text description for the modal, primarily for accessibility.
	   *
	   * @param {boolean} [options.fillAlways=false]
	   *        Normally, modals are automatically filled only the first time
	   *        they open. This tells the modal to refresh its content
	   *        every time it opens.
	   *
	   * @param {string} [options.label]
	   *        A text label for the modal, primarily for accessibility.
	   *
	   * @param {boolean} [options.pauseOnOpen=true]
	   *        If `true`, playback will will be paused if playing when
	   *        the modal opens, and resumed when it closes.
	   *
	   * @param {boolean} [options.temporary=true]
	   *        If `true`, the modal can only be opened once; it will be
	   *        disposed as soon as it's closed.
	   *
	   * @param {boolean} [options.uncloseable=false]
	   *        If `true`, the user will not be able to close the modal
	   *        through the UI in the normal ways. Programmatic closing is
	   *        still possible.
	   */
	  function ModalDialog(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    _this.handleKeyDown_ = function (e) {
	      return _this.handleKeyDown(e);
	    };
	
	    _this.close_ = function (e) {
	      return _this.close(e);
	    };
	
	    _this.opened_ = _this.hasBeenOpened_ = _this.hasBeenFilled_ = false;
	
	    _this.closeable(!_this.options_.uncloseable);
	
	    _this.content(_this.options_.content); // Make sure the contentEl is defined AFTER any children are initialized
	    // because we only want the contents of the modal in the contentEl
	    // (not the UI elements like the close button).
	
	
	    _this.contentEl_ = createEl('div', {
	      className: MODAL_CLASS_NAME + "-content"
	    }, {
	      role: 'document'
	    });
	    _this.descEl_ = createEl('p', {
	      className: MODAL_CLASS_NAME + "-description vjs-control-text",
	      id: _this.el().getAttribute('aria-describedby')
	    });
	    textContent(_this.descEl_, _this.description());
	
	    _this.el_.appendChild(_this.descEl_);
	
	    _this.el_.appendChild(_this.contentEl_);
	
	    return _this;
	  }
	  /**
	   * Create the `ModalDialog`'s DOM element
	   *
	   * @return {Element}
	   *         The DOM element that gets created.
	   */
	
	
	  var _proto = ModalDialog.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: this.buildCSSClass(),
	      tabIndex: -1
	    }, {
	      'aria-describedby': this.id() + "_description",
	      'aria-hidden': 'true',
	      'aria-label': this.label(),
	      'role': 'dialog'
	    });
	  };
	
	  _proto.dispose = function dispose() {
	    this.contentEl_ = null;
	    this.descEl_ = null;
	    this.previouslyActiveEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return MODAL_CLASS_NAME + " vjs-hidden " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Returns the label string for this modal. Primarily used for accessibility.
	   *
	   * @return {string}
	   *         the localized or raw label of this modal.
	   */
	  ;
	
	  _proto.label = function label() {
	    return this.localize(this.options_.label || 'Modal Window');
	  }
	  /**
	   * Returns the description string for this modal. Primarily used for
	   * accessibility.
	   *
	   * @return {string}
	   *         The localized or raw description of this modal.
	   */
	  ;
	
	  _proto.description = function description() {
	    var desc = this.options_.description || this.localize('This is a modal window.'); // Append a universal closeability message if the modal is closeable.
	
	    if (this.closeable()) {
	      desc += ' ' + this.localize('This modal can be closed by pressing the Escape key or activating the close button.');
	    }
	
	    return desc;
	  }
	  /**
	   * Opens the modal.
	   *
	   * @fires ModalDialog#beforemodalopen
	   * @fires ModalDialog#modalopen
	   */
	  ;
	
	  _proto.open = function open() {
	    if (!this.opened_) {
	      var player = this.player();
	      /**
	        * Fired just before a `ModalDialog` is opened.
	        *
	        * @event ModalDialog#beforemodalopen
	        * @type {EventTarget~Event}
	        */
	
	      this.trigger('beforemodalopen');
	      this.opened_ = true; // Fill content if the modal has never opened before and
	      // never been filled.
	
	      if (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) {
	        this.fill();
	      } // If the player was playing, pause it and take note of its previously
	      // playing state.
	
	
	      this.wasPlaying_ = !player.paused();
	
	      if (this.options_.pauseOnOpen && this.wasPlaying_) {
	        player.pause();
	      }
	
	      this.on('keydown', this.handleKeyDown_); // Hide controls and note if they were enabled.
	
	      this.hadControls_ = player.controls();
	      player.controls(false);
	      this.show();
	      this.conditionalFocus_();
	      this.el().setAttribute('aria-hidden', 'false');
	      /**
	        * Fired just after a `ModalDialog` is opened.
	        *
	        * @event ModalDialog#modalopen
	        * @type {EventTarget~Event}
	        */
	
	      this.trigger('modalopen');
	      this.hasBeenOpened_ = true;
	    }
	  }
	  /**
	   * If the `ModalDialog` is currently open or closed.
	   *
	   * @param  {boolean} [value]
	   *         If given, it will open (`true`) or close (`false`) the modal.
	   *
	   * @return {boolean}
	   *         the current open state of the modaldialog
	   */
	  ;
	
	  _proto.opened = function opened(value) {
	    if (typeof value === 'boolean') {
	      this[value ? 'open' : 'close']();
	    }
	
	    return this.opened_;
	  }
	  /**
	   * Closes the modal, does nothing if the `ModalDialog` is
	   * not open.
	   *
	   * @fires ModalDialog#beforemodalclose
	   * @fires ModalDialog#modalclose
	   */
	  ;
	
	  _proto.close = function close() {
	    if (!this.opened_) {
	      return;
	    }
	
	    var player = this.player();
	    /**
	      * Fired just before a `ModalDialog` is closed.
	      *
	      * @event ModalDialog#beforemodalclose
	      * @type {EventTarget~Event}
	      */
	
	    this.trigger('beforemodalclose');
	    this.opened_ = false;
	
	    if (this.wasPlaying_ && this.options_.pauseOnOpen) {
	      player.play();
	    }
	
	    this.off('keydown', this.handleKeyDown_);
	
	    if (this.hadControls_) {
	      player.controls(true);
	    }
	
	    this.hide();
	    this.el().setAttribute('aria-hidden', 'true');
	    /**
	      * Fired just after a `ModalDialog` is closed.
	      *
	      * @event ModalDialog#modalclose
	      * @type {EventTarget~Event}
	      */
	
	    this.trigger('modalclose');
	    this.conditionalBlur_();
	
	    if (this.options_.temporary) {
	      this.dispose();
	    }
	  }
	  /**
	   * Check to see if the `ModalDialog` is closeable via the UI.
	   *
	   * @param  {boolean} [value]
	   *         If given as a boolean, it will set the `closeable` option.
	   *
	   * @return {boolean}
	   *         Returns the final value of the closable option.
	   */
	  ;
	
	  _proto.closeable = function closeable(value) {
	    if (typeof value === 'boolean') {
	      var closeable = this.closeable_ = !!value;
	      var close = this.getChild('closeButton'); // If this is being made closeable and has no close button, add one.
	
	      if (closeable && !close) {
	        // The close button should be a child of the modal - not its
	        // content element, so temporarily change the content element.
	        var temp = this.contentEl_;
	        this.contentEl_ = this.el_;
	        close = this.addChild('closeButton', {
	          controlText: 'Close Modal Dialog'
	        });
	        this.contentEl_ = temp;
	        this.on(close, 'close', this.close_);
	      } // If this is being made uncloseable and has a close button, remove it.
	
	
	      if (!closeable && close) {
	        this.off(close, 'close', this.close_);
	        this.removeChild(close);
	        close.dispose();
	      }
	    }
	
	    return this.closeable_;
	  }
	  /**
	   * Fill the modal's content element with the modal's "content" option.
	   * The content element will be emptied before this change takes place.
	   */
	  ;
	
	  _proto.fill = function fill() {
	    this.fillWith(this.content());
	  }
	  /**
	   * Fill the modal's content element with arbitrary content.
	   * The content element will be emptied before this change takes place.
	   *
	   * @fires ModalDialog#beforemodalfill
	   * @fires ModalDialog#modalfill
	   *
	   * @param {Mixed} [content]
	   *        The same rules apply to this as apply to the `content` option.
	   */
	  ;
	
	  _proto.fillWith = function fillWith(content) {
	    var contentEl = this.contentEl();
	    var parentEl = contentEl.parentNode;
	    var nextSiblingEl = contentEl.nextSibling;
	    /**
	      * Fired just before a `ModalDialog` is filled with content.
	      *
	      * @event ModalDialog#beforemodalfill
	      * @type {EventTarget~Event}
	      */
	
	    this.trigger('beforemodalfill');
	    this.hasBeenFilled_ = true; // Detach the content element from the DOM before performing
	    // manipulation to avoid modifying the live DOM multiple times.
	
	    parentEl.removeChild(contentEl);
	    this.empty();
	    insertContent(contentEl, content);
	    /**
	     * Fired just after a `ModalDialog` is filled with content.
	     *
	     * @event ModalDialog#modalfill
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('modalfill'); // Re-inject the re-filled content element.
	
	    if (nextSiblingEl) {
	      parentEl.insertBefore(contentEl, nextSiblingEl);
	    } else {
	      parentEl.appendChild(contentEl);
	    } // make sure that the close button is last in the dialog DOM
	
	
	    var closeButton = this.getChild('closeButton');
	
	    if (closeButton) {
	      parentEl.appendChild(closeButton.el_);
	    }
	  }
	  /**
	   * Empties the content element. This happens anytime the modal is filled.
	   *
	   * @fires ModalDialog#beforemodalempty
	   * @fires ModalDialog#modalempty
	   */
	  ;
	
	  _proto.empty = function empty() {
	    /**
	    * Fired just before a `ModalDialog` is emptied.
	    *
	    * @event ModalDialog#beforemodalempty
	    * @type {EventTarget~Event}
	    */
	    this.trigger('beforemodalempty');
	    emptyEl(this.contentEl());
	    /**
	    * Fired just after a `ModalDialog` is emptied.
	    *
	    * @event ModalDialog#modalempty
	    * @type {EventTarget~Event}
	    */
	
	    this.trigger('modalempty');
	  }
	  /**
	   * Gets or sets the modal content, which gets normalized before being
	   * rendered into the DOM.
	   *
	   * This does not update the DOM or fill the modal, but it is called during
	   * that process.
	   *
	   * @param  {Mixed} [value]
	   *         If defined, sets the internal content value to be used on the
	   *         next call(s) to `fill`. This value is normalized before being
	   *         inserted. To "clear" the internal content value, pass `null`.
	   *
	   * @return {Mixed}
	   *         The current content of the modal dialog
	   */
	  ;
	
	  _proto.content = function content(value) {
	    if (typeof value !== 'undefined') {
	      this.content_ = value;
	    }
	
	    return this.content_;
	  }
	  /**
	   * conditionally focus the modal dialog if focus was previously on the player.
	   *
	   * @private
	   */
	  ;
	
	  _proto.conditionalFocus_ = function conditionalFocus_() {
	    var activeEl = document__default['default'].activeElement;
	    var playerEl = this.player_.el_;
	    this.previouslyActiveEl_ = null;
	
	    if (playerEl.contains(activeEl) || playerEl === activeEl) {
	      this.previouslyActiveEl_ = activeEl;
	      this.focus();
	    }
	  }
	  /**
	   * conditionally blur the element and refocus the last focused element
	   *
	   * @private
	   */
	  ;
	
	  _proto.conditionalBlur_ = function conditionalBlur_() {
	    if (this.previouslyActiveEl_) {
	      this.previouslyActiveEl_.focus();
	      this.previouslyActiveEl_ = null;
	    }
	  }
	  /**
	   * Keydown handler. Attached when modal is focused.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Do not allow keydowns to reach out of the modal dialog.
	    event.stopPropagation();
	
	    if (keycode__default['default'].isEventKey(event, 'Escape') && this.closeable()) {
	      event.preventDefault();
	      this.close();
	      return;
	    } // exit early if it isn't a tab key
	
	
	    if (!keycode__default['default'].isEventKey(event, 'Tab')) {
	      return;
	    }
	
	    var focusableEls = this.focusableEls_();
	    var activeEl = this.el_.querySelector(':focus');
	    var focusIndex;
	
	    for (var i = 0; i < focusableEls.length; i++) {
	      if (activeEl === focusableEls[i]) {
	        focusIndex = i;
	        break;
	      }
	    }
	
	    if (document__default['default'].activeElement === this.el_) {
	      focusIndex = 0;
	    }
	
	    if (event.shiftKey && focusIndex === 0) {
	      focusableEls[focusableEls.length - 1].focus();
	      event.preventDefault();
	    } else if (!event.shiftKey && focusIndex === focusableEls.length - 1) {
	      focusableEls[0].focus();
	      event.preventDefault();
	    }
	  }
	  /**
	   * get all focusable elements
	   *
	   * @private
	   */
	  ;
	
	  _proto.focusableEls_ = function focusableEls_() {
	    var allChildren = this.el_.querySelectorAll('*');
	    return Array.prototype.filter.call(allChildren, function (child) {
	      return (child instanceof window__default['default'].HTMLAnchorElement || child instanceof window__default['default'].HTMLAreaElement) && child.hasAttribute('href') || (child instanceof window__default['default'].HTMLInputElement || child instanceof window__default['default'].HTMLSelectElement || child instanceof window__default['default'].HTMLTextAreaElement || child instanceof window__default['default'].HTMLButtonElement) && !child.hasAttribute('disabled') || child instanceof window__default['default'].HTMLIFrameElement || child instanceof window__default['default'].HTMLObjectElement || child instanceof window__default['default'].HTMLEmbedElement || child.hasAttribute('tabindex') && child.getAttribute('tabindex') !== -1 || child.hasAttribute('contenteditable');
	    });
	  };
	
	  return ModalDialog;
	}(Component$1);
	/**
	 * Default options for `ModalDialog` default options.
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ModalDialog.prototype.options_ = {
	  pauseOnOpen: true,
	  temporary: true
	};
	Component$1.registerComponent('ModalDialog', ModalDialog);
	
	/**
	 * Common functionaliy between {@link TextTrackList}, {@link AudioTrackList}, and
	 * {@link VideoTrackList}
	 *
	 * @extends EventTarget
	 */
	
	var TrackList = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](TrackList, _EventTarget);
	
	  /**
	   * Create an instance of this class
	   *
	   * @param {Track[]} tracks
	   *        A list of tracks to initialize the list with.
	   *
	   * @abstract
	   */
	  function TrackList(tracks) {
	    var _this;
	
	    if (tracks === void 0) {
	      tracks = [];
	    }
	
	    _this = _EventTarget.call(this) || this;
	    _this.tracks_ = [];
	    /**
	     * @memberof TrackList
	     * @member {number} length
	     *         The current number of `Track`s in the this Trackist.
	     * @instance
	     */
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'length', {
	      get: function get() {
	        return this.tracks_.length;
	      }
	    });
	
	    for (var i = 0; i < tracks.length; i++) {
	      _this.addTrack(tracks[i]);
	    }
	
	    return _this;
	  }
	  /**
	   * Add a {@link Track} to the `TrackList`
	   *
	   * @param {Track} track
	   *        The audio, video, or text track to add to the list.
	   *
	   * @fires TrackList#addtrack
	   */
	
	
	  var _proto = TrackList.prototype;
	
	  _proto.addTrack = function addTrack(track) {
	    var _this2 = this;
	
	    var index = this.tracks_.length;
	
	    if (!('' + index in this)) {
	      Object.defineProperty(this, index, {
	        get: function get() {
	          return this.tracks_[index];
	        }
	      });
	    } // Do not add duplicate tracks
	
	
	    if (this.tracks_.indexOf(track) === -1) {
	      this.tracks_.push(track);
	      /**
	       * Triggered when a track is added to a track list.
	       *
	       * @event TrackList#addtrack
	       * @type {EventTarget~Event}
	       * @property {Track} track
	       *           A reference to track that was added.
	       */
	
	      this.trigger({
	        track: track,
	        type: 'addtrack',
	        target: this
	      });
	    }
	    /**
	     * Triggered when a track label is changed.
	     *
	     * @event TrackList#addtrack
	     * @type {EventTarget~Event}
	     * @property {Track} track
	     *           A reference to track that was added.
	     */
	
	
	    track.labelchange_ = function () {
	      _this2.trigger({
	        track: track,
	        type: 'labelchange',
	        target: _this2
	      });
	    };
	
	    if (isEvented(track)) {
	      track.addEventListener('labelchange', track.labelchange_);
	    }
	  }
	  /**
	   * Remove a {@link Track} from the `TrackList`
	   *
	   * @param {Track} rtrack
	   *        The audio, video, or text track to remove from the list.
	   *
	   * @fires TrackList#removetrack
	   */
	  ;
	
	  _proto.removeTrack = function removeTrack(rtrack) {
	    var track;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      if (this[i] === rtrack) {
	        track = this[i];
	
	        if (track.off) {
	          track.off();
	        }
	
	        this.tracks_.splice(i, 1);
	        break;
	      }
	    }
	
	    if (!track) {
	      return;
	    }
	    /**
	     * Triggered when a track is removed from track list.
	     *
	     * @event TrackList#removetrack
	     * @type {EventTarget~Event}
	     * @property {Track} track
	     *           A reference to track that was removed.
	     */
	
	
	    this.trigger({
	      track: track,
	      type: 'removetrack',
	      target: this
	    });
	  }
	  /**
	   * Get a Track from the TrackList by a tracks id
	   *
	   * @param {string} id - the id of the track to get
	   * @method getTrackById
	   * @return {Track}
	   * @private
	   */
	  ;
	
	  _proto.getTrackById = function getTrackById(id) {
	    var result = null;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      var track = this[i];
	
	      if (track.id === id) {
	        result = track;
	        break;
	      }
	    }
	
	    return result;
	  };
	
	  return TrackList;
	}(EventTarget$2);
	/**
	 * Triggered when a different track is selected/enabled.
	 *
	 * @event TrackList#change
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Events that can be called with on + eventName. See {@link EventHandler}.
	 *
	 * @property {Object} TrackList#allowedEvents_
	 * @private
	 */
	
	
	TrackList.prototype.allowedEvents_ = {
	  change: 'change',
	  addtrack: 'addtrack',
	  removetrack: 'removetrack',
	  labelchange: 'labelchange'
	}; // emulate attribute EventHandler support to allow for feature detection
	
	for (var event in TrackList.prototype.allowedEvents_) {
	  TrackList.prototype['on' + event] = null;
	}
	
	/**
	 * Anywhere we call this function we diverge from the spec
	 * as we only support one enabled audiotrack at a time
	 *
	 * @param {AudioTrackList} list
	 *        list to work on
	 *
	 * @param {AudioTrack} track
	 *        The track to skip
	 *
	 * @private
	 */
	
	var disableOthers$1 = function disableOthers(list, track) {
	  for (var i = 0; i < list.length; i++) {
	    if (!Object.keys(list[i]).length || track.id === list[i].id) {
	      continue;
	    } // another audio track is enabled, disable it
	
	
	    list[i].enabled = false;
	  }
	};
	/**
	 * The current list of {@link AudioTrack} for a media file.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist}
	 * @extends TrackList
	 */
	
	
	var AudioTrackList = /*#__PURE__*/function (_TrackList) {
	  _inheritsLoose__default['default'](AudioTrackList, _TrackList);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {AudioTrack[]} [tracks=[]]
	   *        A list of `AudioTrack` to instantiate the list with.
	   */
	  function AudioTrackList(tracks) {
	    var _this;
	
	    if (tracks === void 0) {
	      tracks = [];
	    }
	
	    // make sure only 1 track is enabled
	    // sorted from last index to first index
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      if (tracks[i].enabled) {
	        disableOthers$1(tracks, tracks[i]);
	        break;
	      }
	    }
	
	    _this = _TrackList.call(this, tracks) || this;
	    _this.changing_ = false;
	    return _this;
	  }
	  /**
	   * Add an {@link AudioTrack} to the `AudioTrackList`.
	   *
	   * @param {AudioTrack} track
	   *        The AudioTrack to add to the list
	   *
	   * @fires TrackList#addtrack
	   */
	
	
	  var _proto = AudioTrackList.prototype;
	
	  _proto.addTrack = function addTrack(track) {
	    var _this2 = this;
	
	    if (track.enabled) {
	      disableOthers$1(this, track);
	    }
	
	    _TrackList.prototype.addTrack.call(this, track); // native tracks don't have this
	
	
	    if (!track.addEventListener) {
	      return;
	    }
	
	    track.enabledChange_ = function () {
	      // when we are disabling other tracks (since we don't support
	      // more than one track at a time) we will set changing_
	      // to true so that we don't trigger additional change events
	      if (_this2.changing_) {
	        return;
	      }
	
	      _this2.changing_ = true;
	      disableOthers$1(_this2, track);
	      _this2.changing_ = false;
	
	      _this2.trigger('change');
	    };
	    /**
	     * @listens AudioTrack#enabledchange
	     * @fires TrackList#change
	     */
	
	
	    track.addEventListener('enabledchange', track.enabledChange_);
	  };
	
	  _proto.removeTrack = function removeTrack(rtrack) {
	    _TrackList.prototype.removeTrack.call(this, rtrack);
	
	    if (rtrack.removeEventListener && rtrack.enabledChange_) {
	      rtrack.removeEventListener('enabledchange', rtrack.enabledChange_);
	      rtrack.enabledChange_ = null;
	    }
	  };
	
	  return AudioTrackList;
	}(TrackList);
	
	/**
	 * Un-select all other {@link VideoTrack}s that are selected.
	 *
	 * @param {VideoTrackList} list
	 *        list to work on
	 *
	 * @param {VideoTrack} track
	 *        The track to skip
	 *
	 * @private
	 */
	
	var disableOthers = function disableOthers(list, track) {
	  for (var i = 0; i < list.length; i++) {
	    if (!Object.keys(list[i]).length || track.id === list[i].id) {
	      continue;
	    } // another video track is enabled, disable it
	
	
	    list[i].selected = false;
	  }
	};
	/**
	 * The current list of {@link VideoTrack} for a video.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist}
	 * @extends TrackList
	 */
	
	
	var VideoTrackList = /*#__PURE__*/function (_TrackList) {
	  _inheritsLoose__default['default'](VideoTrackList, _TrackList);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {VideoTrack[]} [tracks=[]]
	   *        A list of `VideoTrack` to instantiate the list with.
	   */
	  function VideoTrackList(tracks) {
	    var _this;
	
	    if (tracks === void 0) {
	      tracks = [];
	    }
	
	    // make sure only 1 track is enabled
	    // sorted from last index to first index
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      if (tracks[i].selected) {
	        disableOthers(tracks, tracks[i]);
	        break;
	      }
	    }
	
	    _this = _TrackList.call(this, tracks) || this;
	    _this.changing_ = false;
	    /**
	     * @member {number} VideoTrackList#selectedIndex
	     *         The current index of the selected {@link VideoTrack`}.
	     */
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'selectedIndex', {
	      get: function get() {
	        for (var _i = 0; _i < this.length; _i++) {
	          if (this[_i].selected) {
	            return _i;
	          }
	        }
	
	        return -1;
	      },
	      set: function set() {}
	    });
	    return _this;
	  }
	  /**
	   * Add a {@link VideoTrack} to the `VideoTrackList`.
	   *
	   * @param {VideoTrack} track
	   *        The VideoTrack to add to the list
	   *
	   * @fires TrackList#addtrack
	   */
	
	
	  var _proto = VideoTrackList.prototype;
	
	  _proto.addTrack = function addTrack(track) {
	    var _this2 = this;
	
	    if (track.selected) {
	      disableOthers(this, track);
	    }
	
	    _TrackList.prototype.addTrack.call(this, track); // native tracks don't have this
	
	
	    if (!track.addEventListener) {
	      return;
	    }
	
	    track.selectedChange_ = function () {
	      if (_this2.changing_) {
	        return;
	      }
	
	      _this2.changing_ = true;
	      disableOthers(_this2, track);
	      _this2.changing_ = false;
	
	      _this2.trigger('change');
	    };
	    /**
	     * @listens VideoTrack#selectedchange
	     * @fires TrackList#change
	     */
	
	
	    track.addEventListener('selectedchange', track.selectedChange_);
	  };
	
	  _proto.removeTrack = function removeTrack(rtrack) {
	    _TrackList.prototype.removeTrack.call(this, rtrack);
	
	    if (rtrack.removeEventListener && rtrack.selectedChange_) {
	      rtrack.removeEventListener('selectedchange', rtrack.selectedChange_);
	      rtrack.selectedChange_ = null;
	    }
	  };
	
	  return VideoTrackList;
	}(TrackList);
	
	/**
	 * The current list of {@link TextTrack} for a media file.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttracklist}
	 * @extends TrackList
	 */
	
	var TextTrackList = /*#__PURE__*/function (_TrackList) {
	  _inheritsLoose__default['default'](TextTrackList, _TrackList);
	
	  function TextTrackList() {
	    return _TrackList.apply(this, arguments) || this;
	  }
	
	  var _proto = TextTrackList.prototype;
	
	  /**
	   * Add a {@link TextTrack} to the `TextTrackList`
	   *
	   * @param {TextTrack} track
	   *        The text track to add to the list.
	   *
	   * @fires TrackList#addtrack
	   */
	  _proto.addTrack = function addTrack(track) {
	    var _this = this;
	
	    _TrackList.prototype.addTrack.call(this, track);
	
	    if (!this.queueChange_) {
	      this.queueChange_ = function () {
	        return _this.queueTrigger('change');
	      };
	    }
	
	    if (!this.triggerSelectedlanguagechange) {
	      this.triggerSelectedlanguagechange_ = function () {
	        return _this.trigger('selectedlanguagechange');
	      };
	    }
	    /**
	     * @listens TextTrack#modechange
	     * @fires TrackList#change
	     */
	
	
	    track.addEventListener('modechange', this.queueChange_);
	    var nonLanguageTextTrackKind = ['metadata', 'chapters'];
	
	    if (nonLanguageTextTrackKind.indexOf(track.kind) === -1) {
	      track.addEventListener('modechange', this.triggerSelectedlanguagechange_);
	    }
	  };
	
	  _proto.removeTrack = function removeTrack(rtrack) {
	    _TrackList.prototype.removeTrack.call(this, rtrack); // manually remove the event handlers we added
	
	
	    if (rtrack.removeEventListener) {
	      if (this.queueChange_) {
	        rtrack.removeEventListener('modechange', this.queueChange_);
	      }
	
	      if (this.selectedlanguagechange_) {
	        rtrack.removeEventListener('modechange', this.triggerSelectedlanguagechange_);
	      }
	    }
	  };
	
	  return TextTrackList;
	}(TrackList);
	
	/**
	 * @file html-track-element-list.js
	 */
	
	/**
	 * The current list of {@link HtmlTrackElement}s.
	 */
	var HtmlTrackElementList = /*#__PURE__*/function () {
	  /**
	   * Create an instance of this class.
	   *
	   * @param {HtmlTrackElement[]} [tracks=[]]
	   *        A list of `HtmlTrackElement` to instantiate the list with.
	   */
	  function HtmlTrackElementList(trackElements) {
	    if (trackElements === void 0) {
	      trackElements = [];
	    }
	
	    this.trackElements_ = [];
	    /**
	     * @memberof HtmlTrackElementList
	     * @member {number} length
	     *         The current number of `Track`s in the this Trackist.
	     * @instance
	     */
	
	    Object.defineProperty(this, 'length', {
	      get: function get() {
	        return this.trackElements_.length;
	      }
	    });
	
	    for (var i = 0, length = trackElements.length; i < length; i++) {
	      this.addTrackElement_(trackElements[i]);
	    }
	  }
	  /**
	   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
	   *
	   * @param {HtmlTrackElement} trackElement
	   *        The track element to add to the list.
	   *
	   * @private
	   */
	
	
	  var _proto = HtmlTrackElementList.prototype;
	
	  _proto.addTrackElement_ = function addTrackElement_(trackElement) {
	    var index = this.trackElements_.length;
	
	    if (!('' + index in this)) {
	      Object.defineProperty(this, index, {
	        get: function get() {
	          return this.trackElements_[index];
	        }
	      });
	    } // Do not add duplicate elements
	
	
	    if (this.trackElements_.indexOf(trackElement) === -1) {
	      this.trackElements_.push(trackElement);
	    }
	  }
	  /**
	   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
	   * {@link TextTrack}.
	   *
	   * @param {TextTrack} track
	   *        The track associated with a track element.
	   *
	   * @return {HtmlTrackElement|undefined}
	   *         The track element that was found or undefined.
	   *
	   * @private
	   */
	  ;
	
	  _proto.getTrackElementByTrack_ = function getTrackElementByTrack_(track) {
	    var trackElement_;
	
	    for (var i = 0, length = this.trackElements_.length; i < length; i++) {
	      if (track === this.trackElements_[i].track) {
	        trackElement_ = this.trackElements_[i];
	        break;
	      }
	    }
	
	    return trackElement_;
	  }
	  /**
	   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
	   *
	   * @param {HtmlTrackElement} trackElement
	   *        The track element to remove from the list.
	   *
	   * @private
	   */
	  ;
	
	  _proto.removeTrackElement_ = function removeTrackElement_(trackElement) {
	    for (var i = 0, length = this.trackElements_.length; i < length; i++) {
	      if (trackElement === this.trackElements_[i]) {
	        if (this.trackElements_[i].track && typeof this.trackElements_[i].track.off === 'function') {
	          this.trackElements_[i].track.off();
	        }
	
	        if (typeof this.trackElements_[i].off === 'function') {
	          this.trackElements_[i].off();
	        }
	
	        this.trackElements_.splice(i, 1);
	        break;
	      }
	    }
	  };
	
	  return HtmlTrackElementList;
	}();
	
	/**
	 * @file text-track-cue-list.js
	 */
	
	/**
	 * @typedef {Object} TextTrackCueList~TextTrackCue
	 *
	 * @property {string} id
	 *           The unique id for this text track cue
	 *
	 * @property {number} startTime
	 *           The start time for this text track cue
	 *
	 * @property {number} endTime
	 *           The end time for this text track cue
	 *
	 * @property {boolean} pauseOnExit
	 *           Pause when the end time is reached if true.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcue}
	 */
	
	/**
	 * A List of TextTrackCues.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcuelist}
	 */
	var TextTrackCueList = /*#__PURE__*/function () {
	  /**
	   * Create an instance of this class..
	   *
	   * @param {Array} cues
	   *        A list of cues to be initialized with
	   */
	  function TextTrackCueList(cues) {
	    TextTrackCueList.prototype.setCues_.call(this, cues);
	    /**
	     * @memberof TextTrackCueList
	     * @member {number} length
	     *         The current number of `TextTrackCue`s in the TextTrackCueList.
	     * @instance
	     */
	
	    Object.defineProperty(this, 'length', {
	      get: function get() {
	        return this.length_;
	      }
	    });
	  }
	  /**
	   * A setter for cues in this list. Creates getters
	   * an an index for the cues.
	   *
	   * @param {Array} cues
	   *        An array of cues to set
	   *
	   * @private
	   */
	
	
	  var _proto = TextTrackCueList.prototype;
	
	  _proto.setCues_ = function setCues_(cues) {
	    var oldLength = this.length || 0;
	    var i = 0;
	    var l = cues.length;
	    this.cues_ = cues;
	    this.length_ = cues.length;
	
	    var defineProp = function defineProp(index) {
	      if (!('' + index in this)) {
	        Object.defineProperty(this, '' + index, {
	          get: function get() {
	            return this.cues_[index];
	          }
	        });
	      }
	    };
	
	    if (oldLength < l) {
	      i = oldLength;
	
	      for (; i < l; i++) {
	        defineProp.call(this, i);
	      }
	    }
	  }
	  /**
	   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
	   *
	   * @param {string} id
	   *        The id of the cue that should be searched for.
	   *
	   * @return {TextTrackCueList~TextTrackCue|null}
	   *         A single cue or null if none was found.
	   */
	  ;
	
	  _proto.getCueById = function getCueById(id) {
	    var result = null;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      var cue = this[i];
	
	      if (cue.id === id) {
	        result = cue;
	        break;
	      }
	    }
	
	    return result;
	  };
	
	  return TextTrackCueList;
	}();
	
	/**
	 * @file track-kinds.js
	 */
	
	/**
	 * All possible `VideoTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-videotrack-kind
	 * @typedef VideoTrack~Kind
	 * @enum
	 */
	var VideoTrackKind = {
	  alternative: 'alternative',
	  captions: 'captions',
	  main: 'main',
	  sign: 'sign',
	  subtitles: 'subtitles',
	  commentary: 'commentary'
	};
	/**
	 * All possible `AudioTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-audiotrack-kind
	 * @typedef AudioTrack~Kind
	 * @enum
	 */
	
	var AudioTrackKind = {
	  'alternative': 'alternative',
	  'descriptions': 'descriptions',
	  'main': 'main',
	  'main-desc': 'main-desc',
	  'translation': 'translation',
	  'commentary': 'commentary'
	};
	/**
	 * All possible `TextTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-texttrack-kind
	 * @typedef TextTrack~Kind
	 * @enum
	 */
	
	var TextTrackKind = {
	  subtitles: 'subtitles',
	  captions: 'captions',
	  descriptions: 'descriptions',
	  chapters: 'chapters',
	  metadata: 'metadata'
	};
	/**
	 * All possible `TextTrackMode`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackmode
	 * @typedef TextTrack~Mode
	 * @enum
	 */
	
	var TextTrackMode = {
	  disabled: 'disabled',
	  hidden: 'hidden',
	  showing: 'showing'
	};
	
	/**
	 * A Track class that contains all of the common functionality for {@link AudioTrack},
	 * {@link VideoTrack}, and {@link TextTrack}.
	 *
	 * > Note: This class should not be used directly
	 *
	 * @see {@link https://html.spec.whatwg.org/multipage/embedded-content.html}
	 * @extends EventTarget
	 * @abstract
	 */
	
	var Track = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](Track, _EventTarget);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {string} [options.kind='']
	   *        A valid kind for the track type you are creating.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @abstract
	   */
	  function Track(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _EventTarget.call(this) || this;
	    var trackProps = {
	      id: options.id || 'vjs_track_' + newGUID(),
	      kind: options.kind || '',
	      language: options.language || ''
	    };
	    var label = options.label || '';
	    /**
	     * @memberof Track
	     * @member {string} id
	     *         The id of this track. Cannot be changed after creation.
	     * @instance
	     *
	     * @readonly
	     */
	
	    /**
	     * @memberof Track
	     * @member {string} kind
	     *         The kind of track that this is. Cannot be changed after creation.
	     * @instance
	     *
	     * @readonly
	     */
	
	    /**
	     * @memberof Track
	     * @member {string} language
	     *         The two letter language code for this track. Cannot be changed after
	     *         creation.
	     * @instance
	     *
	     * @readonly
	     */
	
	    var _loop = function _loop(key) {
	      Object.defineProperty(_assertThisInitialized__default['default'](_this), key, {
	        get: function get() {
	          return trackProps[key];
	        },
	        set: function set() {}
	      });
	    };
	
	    for (var key in trackProps) {
	      _loop(key);
	    }
	    /**
	     * @memberof Track
	     * @member {string} label
	     *         The label of this track. Cannot be changed after creation.
	     * @instance
	     *
	     * @fires Track#labelchange
	     */
	
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'label', {
	      get: function get() {
	        return label;
	      },
	      set: function set(newLabel) {
	        if (newLabel !== label) {
	          label = newLabel;
	          /**
	           * An event that fires when label changes on this track.
	           *
	           * > Note: This is not part of the spec!
	           *
	           * @event Track#labelchange
	           * @type {EventTarget~Event}
	           */
	
	          this.trigger('labelchange');
	        }
	      }
	    });
	    return _this;
	  }
	
	  return Track;
	}(EventTarget$2);
	
	/**
	 * @file url.js
	 * @module url
	 */
	/**
	 * @typedef {Object} url:URLObject
	 *
	 * @property {string} protocol
	 *           The protocol of the url that was parsed.
	 *
	 * @property {string} hostname
	 *           The hostname of the url that was parsed.
	 *
	 * @property {string} port
	 *           The port of the url that was parsed.
	 *
	 * @property {string} pathname
	 *           The pathname of the url that was parsed.
	 *
	 * @property {string} search
	 *           The search query of the url that was parsed.
	 *
	 * @property {string} hash
	 *           The hash of the url that was parsed.
	 *
	 * @property {string} host
	 *           The host of the url that was parsed.
	 */
	
	/**
	 * Resolve and parse the elements of a URL.
	 *
	 * @function
	 * @param    {String} url
	 *           The url to parse
	 *
	 * @return   {url:URLObject}
	 *           An object of url details
	 */
	
	var parseUrl = function parseUrl(url) {
	  // This entire method can be replace with URL once we are able to drop IE11
	  var props = ['protocol', 'hostname', 'port', 'pathname', 'search', 'hash', 'host']; // add the url to an anchor and let the browser parse the URL
	
	  var a = document__default['default'].createElement('a');
	  a.href = url; // Copy the specific URL properties to a new object
	  // This is also needed for IE because the anchor loses its
	  // properties when it's removed from the dom
	
	  var details = {};
	
	  for (var i = 0; i < props.length; i++) {
	    details[props[i]] = a[props[i]];
	  } // IE adds the port to the host property unlike everyone else. If
	  // a port identifier is added for standard ports, strip it.
	
	
	  if (details.protocol === 'http:') {
	    details.host = details.host.replace(/:80$/, '');
	  }
	
	  if (details.protocol === 'https:') {
	    details.host = details.host.replace(/:443$/, '');
	  }
	
	  if (!details.protocol) {
	    details.protocol = window__default['default'].location.protocol;
	  }
	  /* istanbul ignore if */
	
	
	  if (!details.host) {
	    details.host = window__default['default'].location.host;
	  }
	
	  return details;
	};
	/**
	 * Get absolute version of relative URL. Used to tell Flash the correct URL.
	 *
	 * @function
	 * @param    {string} url
	 *           URL to make absolute
	 *
	 * @return   {string}
	 *           Absolute URL
	 *
	 * @see      http://stackoverflow.com/questions/470832/getting-an-absolute-url-from-a-relative-one-ie6-issue
	 */
	
	var getAbsoluteURL = function getAbsoluteURL(url) {
	  // Check if absolute URL
	  if (!url.match(/^https?:\/\//)) {
	    // Convert to absolute URL. Flash hosted off-site needs an absolute URL.
	    // add the url to an anchor and let the browser parse the URL
	    var a = document__default['default'].createElement('a');
	    a.href = url;
	    url = a.href;
	  }
	
	  return url;
	};
	/**
	 * Returns the extension of the passed file name. It will return an empty string
	 * if passed an invalid path.
	 *
	 * @function
	 * @param    {string} path
	 *           The fileName path like '/path/to/file.mp4'
	 *
	 * @return  {string}
	 *           The extension in lower case or an empty string if no
	 *           extension could be found.
	 */
	
	var getFileExtension = function getFileExtension(path) {
	  if (typeof path === 'string') {
	    var splitPathRe = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/;
	    var pathParts = splitPathRe.exec(path);
	
	    if (pathParts) {
	      return pathParts.pop().toLowerCase();
	    }
	  }
	
	  return '';
	};
	/**
	 * Returns whether the url passed is a cross domain request or not.
	 *
	 * @function
	 * @param    {string} url
	 *           The url to check.
	 *
	 * @param    {Object} [winLoc]
	 *           the domain to check the url against, defaults to window.location
	 *
	 * @param    {string} [winLoc.protocol]
	 *           The window location protocol defaults to window.location.protocol
	 *
	 * @param    {string} [winLoc.host]
	 *           The window location host defaults to window.location.host
	 *
	 * @return   {boolean}
	 *           Whether it is a cross domain request or not.
	 */
	
	var isCrossOrigin = function isCrossOrigin(url, winLoc) {
	  if (winLoc === void 0) {
	    winLoc = window__default['default'].location;
	  }
	
	  var urlInfo = parseUrl(url); // IE8 protocol relative urls will return ':' for protocol
	
	  var srcProtocol = urlInfo.protocol === ':' ? winLoc.protocol : urlInfo.protocol; // Check if url is for another domain/origin
	  // IE8 doesn't know location.origin, so we won't rely on it here
	
	  var crossOrigin = srcProtocol + urlInfo.host !== winLoc.protocol + winLoc.host;
	  return crossOrigin;
	};
	
	var Url = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  parseUrl: parseUrl,
	  getAbsoluteURL: getAbsoluteURL,
	  getFileExtension: getFileExtension,
	  isCrossOrigin: isCrossOrigin
	});
	
	/**
	 * Takes a webvtt file contents and parses it into cues
	 *
	 * @param {string} srcContent
	 *        webVTT file contents
	 *
	 * @param {TextTrack} track
	 *        TextTrack to add cues to. Cues come from the srcContent.
	 *
	 * @private
	 */
	
	var parseCues = function parseCues(srcContent, track) {
	  var parser = new window__default['default'].WebVTT.Parser(window__default['default'], window__default['default'].vttjs, window__default['default'].WebVTT.StringDecoder());
	  var errors = [];
	
	  parser.oncue = function (cue) {
	    track.addCue(cue);
	  };
	
	  parser.onparsingerror = function (error) {
	    errors.push(error);
	  };
	
	  parser.onflush = function () {
	    track.trigger({
	      type: 'loadeddata',
	      target: track
	    });
	  };
	
	  parser.parse(srcContent);
	
	  if (errors.length > 0) {
	    if (window__default['default'].console && window__default['default'].console.groupCollapsed) {
	      window__default['default'].console.groupCollapsed("Text Track parsing errors for " + track.src);
	    }
	
	    errors.forEach(function (error) {
	      return log$1.error(error);
	    });
	
	    if (window__default['default'].console && window__default['default'].console.groupEnd) {
	      window__default['default'].console.groupEnd();
	    }
	  }
	
	  parser.flush();
	};
	/**
	 * Load a `TextTrack` from a specified url.
	 *
	 * @param {string} src
	 *        Url to load track from.
	 *
	 * @param {TextTrack} track
	 *        Track to add cues to. Comes from the content at the end of `url`.
	 *
	 * @private
	 */
	
	
	var loadTrack = function loadTrack(src, track) {
	  var opts = {
	    uri: src
	  };
	  var crossOrigin = isCrossOrigin(src);
	
	  if (crossOrigin) {
	    opts.cors = crossOrigin;
	  }
	
	  var withCredentials = track.tech_.crossOrigin() === 'use-credentials';
	
	  if (withCredentials) {
	    opts.withCredentials = withCredentials;
	  }
	
	  XHR__default['default'](opts, bind(this, function (err, response, responseBody) {
	    if (err) {
	      return log$1.error(err, response);
	    }
	
	    track.loaded_ = true; // Make sure that vttjs has loaded, otherwise, wait till it finished loading
	    // NOTE: this is only used for the alt/video.novtt.js build
	
	    if (typeof window__default['default'].WebVTT !== 'function') {
	      if (track.tech_) {
	        // to prevent use before define eslint error, we define loadHandler
	        // as a let here
	        track.tech_.any(['vttjsloaded', 'vttjserror'], function (event) {
	          if (event.type === 'vttjserror') {
	            log$1.error("vttjs failed to load, stopping trying to process " + track.src);
	            return;
	          }
	
	          return parseCues(responseBody, track);
	        });
	      }
	    } else {
	      parseCues(responseBody, track);
	    }
	  }));
	};
	/**
	 * A representation of a single `TextTrack`.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrack}
	 * @extends Track
	 */
	
	
	var TextTrack = /*#__PURE__*/function (_Track) {
	  _inheritsLoose__default['default'](TextTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} options={}
	   *        Object of option names and values
	   *
	   * @param {Tech} options.tech
	   *        A reference to the tech that owns this TextTrack.
	   *
	   * @param {TextTrack~Kind} [options.kind='subtitles']
	   *        A valid text track kind.
	   *
	   * @param {TextTrack~Mode} [options.mode='disabled']
	   *        A valid text track mode.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this TextTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {string} [options.srclang='']
	   *        A valid two character language code. An alternative, but deprioritized
	   *        version of `options.language`
	   *
	   * @param {string} [options.src]
	   *        A url to TextTrack cues.
	   *
	   * @param {boolean} [options.default]
	   *        If this track should default to on or off.
	   */
	  function TextTrack(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!options.tech) {
	      throw new Error('A tech was not provided.');
	    }
	
	    var settings = mergeOptions$3(options, {
	      kind: TextTrackKind[options.kind] || 'subtitles',
	      language: options.language || options.srclang || ''
	    });
	    var mode = TextTrackMode[settings.mode] || 'disabled';
	    var default_ = settings["default"];
	
	    if (settings.kind === 'metadata' || settings.kind === 'chapters') {
	      mode = 'hidden';
	    }
	
	    _this = _Track.call(this, settings) || this;
	    _this.tech_ = settings.tech;
	    _this.cues_ = [];
	    _this.activeCues_ = [];
	    _this.preload_ = _this.tech_.preloadTextTracks !== false;
	    var cues = new TextTrackCueList(_this.cues_);
	    var activeCues = new TextTrackCueList(_this.activeCues_);
	    var changed = false;
	    _this.timeupdateHandler = bind(_assertThisInitialized__default['default'](_this), function (event) {
	      if (event === void 0) {
	        event = {};
	      }
	
	      if (this.tech_.isDisposed()) {
	        return;
	      }
	
	      if (!this.tech_.isReady_) {
	        if (event.type !== 'timeupdate') {
	          this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
	        }
	
	        return;
	      } // Accessing this.activeCues for the side-effects of updating itself
	      // due to its nature as a getter function. Do not remove or cues will
	      // stop updating!
	      // Use the setter to prevent deletion from uglify (pure_getters rule)
	
	
	      this.activeCues = this.activeCues;
	
	      if (changed) {
	        this.trigger('cuechange');
	        changed = false;
	      }
	
	      if (event.type !== 'timeupdate') {
	        this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
	      }
	    });
	
	    var disposeHandler = function disposeHandler() {
	      _this.stopTracking();
	    };
	
	    _this.tech_.one('dispose', disposeHandler);
	
	    if (mode !== 'disabled') {
	      _this.startTracking();
	    }
	
	    Object.defineProperties(_assertThisInitialized__default['default'](_this), {
	      /**
	       * @memberof TextTrack
	       * @member {boolean} default
	       *         If this track was set to be on or off by default. Cannot be changed after
	       *         creation.
	       * @instance
	       *
	       * @readonly
	       */
	      "default": {
	        get: function get() {
	          return default_;
	        },
	        set: function set() {}
	      },
	
	      /**
	       * @memberof TextTrack
	       * @member {string} mode
	       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
	       *         not be set if setting to an invalid mode.
	       * @instance
	       *
	       * @fires TextTrack#modechange
	       */
	      mode: {
	        get: function get() {
	          return mode;
	        },
	        set: function set(newMode) {
	          if (!TextTrackMode[newMode]) {
	            return;
	          }
	
	          if (mode === newMode) {
	            return;
	          }
	
	          mode = newMode;
	
	          if (!this.preload_ && mode !== 'disabled' && this.cues.length === 0) {
	            // On-demand load.
	            loadTrack(this.src, this);
	          }
	
	          this.stopTracking();
	
	          if (mode !== 'disabled') {
	            this.startTracking();
	          }
	          /**
	           * An event that fires when mode changes on this track. This allows
	           * the TextTrackList that holds this track to act accordingly.
	           *
	           * > Note: This is not part of the spec!
	           *
	           * @event TextTrack#modechange
	           * @type {EventTarget~Event}
	           */
	
	
	          this.trigger('modechange');
	        }
	      },
	
	      /**
	       * @memberof TextTrack
	       * @member {TextTrackCueList} cues
	       *         The text track cue list for this TextTrack.
	       * @instance
	       */
	      cues: {
	        get: function get() {
	          if (!this.loaded_) {
	            return null;
	          }
	
	          return cues;
	        },
	        set: function set() {}
	      },
	
	      /**
	       * @memberof TextTrack
	       * @member {TextTrackCueList} activeCues
	       *         The list text track cues that are currently active for this TextTrack.
	       * @instance
	       */
	      activeCues: {
	        get: function get() {
	          if (!this.loaded_) {
	            return null;
	          } // nothing to do
	
	
	          if (this.cues.length === 0) {
	            return activeCues;
	          }
	
	          var ct = this.tech_.currentTime();
	          var active = [];
	
	          for (var i = 0, l = this.cues.length; i < l; i++) {
	            var cue = this.cues[i];
	
	            if (cue.startTime <= ct && cue.endTime >= ct) {
	              active.push(cue);
	            } else if (cue.startTime === cue.endTime && cue.startTime <= ct && cue.startTime + 0.5 >= ct) {
	              active.push(cue);
	            }
	          }
	
	          changed = false;
	
	          if (active.length !== this.activeCues_.length) {
	            changed = true;
	          } else {
	            for (var _i = 0; _i < active.length; _i++) {
	              if (this.activeCues_.indexOf(active[_i]) === -1) {
	                changed = true;
	              }
	            }
	          }
	
	          this.activeCues_ = active;
	          activeCues.setCues_(this.activeCues_);
	          return activeCues;
	        },
	        // /!\ Keep this setter empty (see the timeupdate handler above)
	        set: function set() {}
	      }
	    });
	
	    if (settings.src) {
	      _this.src = settings.src;
	
	      if (!_this.preload_) {
	        // Tracks will load on-demand.
	        // Act like we're loaded for other purposes.
	        _this.loaded_ = true;
	      }
	
	      if (_this.preload_ || settings.kind !== 'subtitles' && settings.kind !== 'captions') {
	        loadTrack(_this.src, _assertThisInitialized__default['default'](_this));
	      }
	    } else {
	      _this.loaded_ = true;
	    }
	
	    return _this;
	  }
	
	  var _proto = TextTrack.prototype;
	
	  _proto.startTracking = function startTracking() {
	    // More precise cues based on requestVideoFrameCallback with a requestAnimationFram fallback
	    this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler); // Also listen to timeupdate in case rVFC/rAF stops (window in background, audio in video el)
	
	    this.tech_.on('timeupdate', this.timeupdateHandler);
	  };
	
	  _proto.stopTracking = function stopTracking() {
	    if (this.rvf_) {
	      this.tech_.cancelVideoFrameCallback(this.rvf_);
	      this.rvf_ = undefined;
	    }
	
	    this.tech_.off('timeupdate', this.timeupdateHandler);
	  }
	  /**
	   * Add a cue to the internal list of cues.
	   *
	   * @param {TextTrack~Cue} cue
	   *        The cue to add to our internal list
	   */
	  ;
	
	  _proto.addCue = function addCue(originalCue) {
	    var cue = originalCue; // Testing if the cue is a VTTCue in a way that survives minification
	
	    if (!('getCueAsHTML' in cue)) {
	      cue = new window__default['default'].vttjs.VTTCue(originalCue.startTime, originalCue.endTime, originalCue.text);
	
	      for (var prop in originalCue) {
	        if (!(prop in cue)) {
	          cue[prop] = originalCue[prop];
	        }
	      } // make sure that `id` is copied over
	
	
	      cue.id = originalCue.id;
	      cue.originalCue_ = originalCue;
	    }
	
	    var tracks = this.tech_.textTracks();
	
	    for (var i = 0; i < tracks.length; i++) {
	      if (tracks[i] !== this) {
	        tracks[i].removeCue(cue);
	      }
	    }
	
	    this.cues_.push(cue);
	    this.cues.setCues_(this.cues_);
	  }
	  /**
	   * Remove a cue from our internal list
	   *
	   * @param {TextTrack~Cue} removeCue
	   *        The cue to remove from our internal list
	   */
	  ;
	
	  _proto.removeCue = function removeCue(_removeCue) {
	    var i = this.cues_.length;
	
	    while (i--) {
	      var cue = this.cues_[i];
	
	      if (cue === _removeCue || cue.originalCue_ && cue.originalCue_ === _removeCue) {
	        this.cues_.splice(i, 1);
	        this.cues.setCues_(this.cues_);
	        break;
	      }
	    }
	  };
	
	  return TextTrack;
	}(Track);
	/**
	 * cuechange - One or more cues in the track have become active or stopped being active.
	 */
	
	
	TextTrack.prototype.allowedEvents_ = {
	  cuechange: 'cuechange'
	};
	
	/**
	 * A representation of a single `AudioTrack`. If it is part of an {@link AudioTrackList}
	 * only one `AudioTrack` in the list will be enabled at a time.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotrack}
	 * @extends Track
	 */
	
	var AudioTrack = /*#__PURE__*/function (_Track) {
	  _inheritsLoose__default['default'](AudioTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {AudioTrack~Kind} [options.kind='']
	   *        A valid audio track kind
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {boolean} [options.enabled]
	   *        If this track is the one that is currently playing. If this track is part of
	   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
	   */
	  function AudioTrack(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    var settings = mergeOptions$3(options, {
	      kind: AudioTrackKind[options.kind] || ''
	    });
	    _this = _Track.call(this, settings) || this;
	    var enabled = false;
	    /**
	     * @memberof AudioTrack
	     * @member {boolean} enabled
	     *         If this `AudioTrack` is enabled or not. When setting this will
	     *         fire {@link AudioTrack#enabledchange} if the state of enabled is changed.
	     * @instance
	     *
	     * @fires VideoTrack#selectedchange
	     */
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'enabled', {
	      get: function get() {
	        return enabled;
	      },
	      set: function set(newEnabled) {
	        // an invalid or unchanged value
	        if (typeof newEnabled !== 'boolean' || newEnabled === enabled) {
	          return;
	        }
	
	        enabled = newEnabled;
	        /**
	         * An event that fires when enabled changes on this track. This allows
	         * the AudioTrackList that holds this track to act accordingly.
	         *
	         * > Note: This is not part of the spec! Native tracks will do
	         *         this internally without an event.
	         *
	         * @event AudioTrack#enabledchange
	         * @type {EventTarget~Event}
	         */
	
	        this.trigger('enabledchange');
	      }
	    }); // if the user sets this track to selected then
	    // set selected to that true value otherwise
	    // we keep it false
	
	    if (settings.enabled) {
	      _this.enabled = settings.enabled;
	    }
	
	    _this.loaded_ = true;
	    return _this;
	  }
	
	  return AudioTrack;
	}(Track);
	
	/**
	 * A representation of a single `VideoTrack`.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotrack}
	 * @extends Track
	 */
	
	var VideoTrack = /*#__PURE__*/function (_Track) {
	  _inheritsLoose__default['default'](VideoTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {string} [options.kind='']
	   *        A valid {@link VideoTrack~Kind}
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {boolean} [options.selected]
	   *        If this track is the one that is currently playing.
	   */
	  function VideoTrack(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    var settings = mergeOptions$3(options, {
	      kind: VideoTrackKind[options.kind] || ''
	    });
	    _this = _Track.call(this, settings) || this;
	    var selected = false;
	    /**
	     * @memberof VideoTrack
	     * @member {boolean} selected
	     *         If this `VideoTrack` is selected or not. When setting this will
	     *         fire {@link VideoTrack#selectedchange} if the state of selected changed.
	     * @instance
	     *
	     * @fires VideoTrack#selectedchange
	     */
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'selected', {
	      get: function get() {
	        return selected;
	      },
	      set: function set(newSelected) {
	        // an invalid or unchanged value
	        if (typeof newSelected !== 'boolean' || newSelected === selected) {
	          return;
	        }
	
	        selected = newSelected;
	        /**
	         * An event that fires when selected changes on this track. This allows
	         * the VideoTrackList that holds this track to act accordingly.
	         *
	         * > Note: This is not part of the spec! Native tracks will do
	         *         this internally without an event.
	         *
	         * @event VideoTrack#selectedchange
	         * @type {EventTarget~Event}
	         */
	
	        this.trigger('selectedchange');
	      }
	    }); // if the user sets this track to selected then
	    // set selected to that true value otherwise
	    // we keep it false
	
	    if (settings.selected) {
	      _this.selected = settings.selected;
	    }
	
	    return _this;
	  }
	
	  return VideoTrack;
	}(Track);
	
	/**
	 * @memberof HTMLTrackElement
	 * @typedef {HTMLTrackElement~ReadyState}
	 * @enum {number}
	 */
	
	var NONE = 0;
	var LOADING = 1;
	var LOADED = 2;
	var ERROR = 3;
	/**
	 * A single track represented in the DOM.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#htmltrackelement}
	 * @extends EventTarget
	 */
	
	var HTMLTrackElement = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](HTMLTrackElement, _EventTarget);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} options={}
	   *        Object of option names and values
	   *
	   * @param {Tech} options.tech
	   *        A reference to the tech that owns this HTMLTrackElement.
	   *
	   * @param {TextTrack~Kind} [options.kind='subtitles']
	   *        A valid text track kind.
	   *
	   * @param {TextTrack~Mode} [options.mode='disabled']
	   *        A valid text track mode.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this TextTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {string} [options.srclang='']
	   *        A valid two character language code. An alternative, but deprioritized
	   *        version of `options.language`
	   *
	   * @param {string} [options.src]
	   *        A url to TextTrack cues.
	   *
	   * @param {boolean} [options.default]
	   *        If this track should default to on or off.
	   */
	  function HTMLTrackElement(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _EventTarget.call(this) || this;
	    var readyState;
	    var track = new TextTrack(options);
	    _this.kind = track.kind;
	    _this.src = track.src;
	    _this.srclang = track.language;
	    _this.label = track.label;
	    _this["default"] = track["default"];
	    Object.defineProperties(_assertThisInitialized__default['default'](_this), {
	      /**
	       * @memberof HTMLTrackElement
	       * @member {HTMLTrackElement~ReadyState} readyState
	       *         The current ready state of the track element.
	       * @instance
	       */
	      readyState: {
	        get: function get() {
	          return readyState;
	        }
	      },
	
	      /**
	       * @memberof HTMLTrackElement
	       * @member {TextTrack} track
	       *         The underlying TextTrack object.
	       * @instance
	       *
	       */
	      track: {
	        get: function get() {
	          return track;
	        }
	      }
	    });
	    readyState = NONE;
	    /**
	     * @listens TextTrack#loadeddata
	     * @fires HTMLTrackElement#load
	     */
	
	    track.addEventListener('loadeddata', function () {
	      readyState = LOADED;
	
	      _this.trigger({
	        type: 'load',
	        target: _assertThisInitialized__default['default'](_this)
	      });
	    });
	    return _this;
	  }
	
	  return HTMLTrackElement;
	}(EventTarget$2);
	
	HTMLTrackElement.prototype.allowedEvents_ = {
	  load: 'load'
	};
	HTMLTrackElement.NONE = NONE;
	HTMLTrackElement.LOADING = LOADING;
	HTMLTrackElement.LOADED = LOADED;
	HTMLTrackElement.ERROR = ERROR;
	
	/*
	 * This file contains all track properties that are used in
	 * player.js, tech.js, html5.js and possibly other techs in the future.
	 */
	
	var NORMAL = {
	  audio: {
	    ListClass: AudioTrackList,
	    TrackClass: AudioTrack,
	    capitalName: 'Audio'
	  },
	  video: {
	    ListClass: VideoTrackList,
	    TrackClass: VideoTrack,
	    capitalName: 'Video'
	  },
	  text: {
	    ListClass: TextTrackList,
	    TrackClass: TextTrack,
	    capitalName: 'Text'
	  }
	};
	Object.keys(NORMAL).forEach(function (type) {
	  NORMAL[type].getterName = type + "Tracks";
	  NORMAL[type].privateName = type + "Tracks_";
	});
	var REMOTE = {
	  remoteText: {
	    ListClass: TextTrackList,
	    TrackClass: TextTrack,
	    capitalName: 'RemoteText',
	    getterName: 'remoteTextTracks',
	    privateName: 'remoteTextTracks_'
	  },
	  remoteTextEl: {
	    ListClass: HtmlTrackElementList,
	    TrackClass: HTMLTrackElement,
	    capitalName: 'RemoteTextTrackEls',
	    getterName: 'remoteTextTrackEls',
	    privateName: 'remoteTextTrackEls_'
	  }
	};
	
	var ALL = _extends__default['default']({}, NORMAL, REMOTE);
	
	REMOTE.names = Object.keys(REMOTE);
	NORMAL.names = Object.keys(NORMAL);
	ALL.names = [].concat(REMOTE.names).concat(NORMAL.names);
	
	/**
	 * An Object containing a structure like: `{src: 'url', type: 'mimetype'}` or string
	 * that just contains the src url alone.
	 * * `var SourceObject = {src: 'http://ex.com/video.mp4', type: 'video/mp4'};`
	   * `var SourceString = 'http://example.com/some-video.mp4';`
	 *
	 * @typedef {Object|string} Tech~SourceObject
	 *
	 * @property {string} src
	 *           The url to the source
	 *
	 * @property {string} type
	 *           The mime type of the source
	 */
	
	/**
	 * A function used by {@link Tech} to create a new {@link TextTrack}.
	 *
	 * @private
	 *
	 * @param {Tech} self
	 *        An instance of the Tech class.
	 *
	 * @param {string} kind
	 *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	 *
	 * @param {string} [label]
	 *        Label to identify the text track
	 *
	 * @param {string} [language]
	 *        Two letter language abbreviation
	 *
	 * @param {Object} [options={}]
	 *        An object with additional text track options
	 *
	 * @return {TextTrack}
	 *          The text track that was created.
	 */
	
	function createTrackHelper(self, kind, label, language, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var tracks = self.textTracks();
	  options.kind = kind;
	
	  if (label) {
	    options.label = label;
	  }
	
	  if (language) {
	    options.language = language;
	  }
	
	  options.tech = self;
	  var track = new ALL.text.TrackClass(options);
	  tracks.addTrack(track);
	  return track;
	}
	/**
	 * This is the base class for media playback technology controllers, such as
	 * {@link HTML5}
	 *
	 * @extends Component
	 */
	
	
	var Tech = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Tech, _Component);
	
	  /**
	  * Create an instance of this Tech.
	  *
	  * @param {Object} [options]
	  *        The key/value store of player options.
	  *
	  * @param {Component~ReadyCallback} ready
	  *        Callback function to call when the `HTML5` Tech is ready.
	  */
	  function Tech(options, ready) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (ready === void 0) {
	      ready = function ready() {};
	    }
	
	    // we don't want the tech to report user activity automatically.
	    // This is done manually in addControlsListeners
	    options.reportTouchActivity = false;
	    _this = _Component.call(this, null, options, ready) || this;
	
	    _this.onDurationChange_ = function (e) {
	      return _this.onDurationChange(e);
	    };
	
	    _this.trackProgress_ = function (e) {
	      return _this.trackProgress(e);
	    };
	
	    _this.trackCurrentTime_ = function (e) {
	      return _this.trackCurrentTime(e);
	    };
	
	    _this.stopTrackingCurrentTime_ = function (e) {
	      return _this.stopTrackingCurrentTime(e);
	    };
	
	    _this.disposeSourceHandler_ = function (e) {
	      return _this.disposeSourceHandler(e);
	    };
	
	    _this.queuedHanders_ = new Set(); // keep track of whether the current source has played at all to
	    // implement a very limited played()
	
	    _this.hasStarted_ = false;
	
	    _this.on('playing', function () {
	      this.hasStarted_ = true;
	    });
	
	    _this.on('loadstart', function () {
	      this.hasStarted_ = false;
	    });
	
	    ALL.names.forEach(function (name) {
	      var props = ALL[name];
	
	      if (options && options[props.getterName]) {
	        _this[props.privateName] = options[props.getterName];
	      }
	    }); // Manually track progress in cases where the browser/tech doesn't report it.
	
	    if (!_this.featuresProgressEvents) {
	      _this.manualProgressOn();
	    } // Manually track timeupdates in cases where the browser/tech doesn't report it.
	
	
	    if (!_this.featuresTimeupdateEvents) {
	      _this.manualTimeUpdatesOn();
	    }
	
	    ['Text', 'Audio', 'Video'].forEach(function (track) {
	      if (options["native" + track + "Tracks"] === false) {
	        _this["featuresNative" + track + "Tracks"] = false;
	      }
	    });
	
	    if (options.nativeCaptions === false || options.nativeTextTracks === false) {
	      _this.featuresNativeTextTracks = false;
	    } else if (options.nativeCaptions === true || options.nativeTextTracks === true) {
	      _this.featuresNativeTextTracks = true;
	    }
	
	    if (!_this.featuresNativeTextTracks) {
	      _this.emulateTextTracks();
	    }
	
	    _this.preloadTextTracks = options.preloadTextTracks !== false;
	    _this.autoRemoteTextTracks_ = new ALL.text.ListClass();
	
	    _this.initTrackListeners(); // Turn on component tap events only if not using native controls
	
	
	    if (!options.nativeControlsForTouch) {
	      _this.emitTapEvents();
	    }
	
	    if (_this.constructor) {
	      _this.name_ = _this.constructor.name || 'Unknown Tech';
	    }
	
	    return _this;
	  }
	  /**
	   * A special function to trigger source set in a way that will allow player
	   * to re-trigger if the player or tech are not ready yet.
	   *
	   * @fires Tech#sourceset
	   * @param {string} src The source string at the time of the source changing.
	   */
	
	
	  var _proto = Tech.prototype;
	
	  _proto.triggerSourceset = function triggerSourceset(src) {
	    var _this2 = this;
	
	    if (!this.isReady_) {
	      // on initial ready we have to trigger source set
	      // 1ms after ready so that player can watch for it.
	      this.one('ready', function () {
	        return _this2.setTimeout(function () {
	          return _this2.triggerSourceset(src);
	        }, 1);
	      });
	    }
	    /**
	     * Fired when the source is set on the tech causing the media element
	     * to reload.
	     *
	     * @see {@link Player#event:sourceset}
	     * @event Tech#sourceset
	     * @type {EventTarget~Event}
	     */
	
	
	    this.trigger({
	      src: src,
	      type: 'sourceset'
	    });
	  }
	  /* Fallbacks for unsupported event types
	  ================================================================================ */
	
	  /**
	   * Polyfill the `progress` event for browsers that don't support it natively.
	   *
	   * @see {@link Tech#trackProgress}
	   */
	  ;
	
	  _proto.manualProgressOn = function manualProgressOn() {
	    this.on('durationchange', this.onDurationChange_);
	    this.manualProgress = true; // Trigger progress watching when a source begins loading
	
	    this.one('ready', this.trackProgress_);
	  }
	  /**
	   * Turn off the polyfill for `progress` events that was created in
	   * {@link Tech#manualProgressOn}
	   */
	  ;
	
	  _proto.manualProgressOff = function manualProgressOff() {
	    this.manualProgress = false;
	    this.stopTrackingProgress();
	    this.off('durationchange', this.onDurationChange_);
	  }
	  /**
	   * This is used to trigger a `progress` event when the buffered percent changes. It
	   * sets an interval function that will be called every 500 milliseconds to check if the
	   * buffer end percent has changed.
	   *
	   * > This function is called by {@link Tech#manualProgressOn}
	   *
	   * @param {EventTarget~Event} event
	   *        The `ready` event that caused this to run.
	   *
	   * @listens Tech#ready
	   * @fires Tech#progress
	   */
	  ;
	
	  _proto.trackProgress = function trackProgress(event) {
	    this.stopTrackingProgress();
	    this.progressInterval = this.setInterval(bind(this, function () {
	      // Don't trigger unless buffered amount is greater than last time
	      var numBufferedPercent = this.bufferedPercent();
	
	      if (this.bufferedPercent_ !== numBufferedPercent) {
	        /**
	         * See {@link Player#progress}
	         *
	         * @event Tech#progress
	         * @type {EventTarget~Event}
	         */
	        this.trigger('progress');
	      }
	
	      this.bufferedPercent_ = numBufferedPercent;
	
	      if (numBufferedPercent === 1) {
	        this.stopTrackingProgress();
	      }
	    }), 500);
	  }
	  /**
	   * Update our internal duration on a `durationchange` event by calling
	   * {@link Tech#duration}.
	   *
	   * @param {EventTarget~Event} event
	   *        The `durationchange` event that caused this to run.
	   *
	   * @listens Tech#durationchange
	   */
	  ;
	
	  _proto.onDurationChange = function onDurationChange(event) {
	    this.duration_ = this.duration();
	  }
	  /**
	   * Get and create a `TimeRange` object for buffering.
	   *
	   * @return {TimeRange}
	   *         The time range object that was created.
	   */
	  ;
	
	  _proto.buffered = function buffered() {
	    return createTimeRanges(0, 0);
	  }
	  /**
	   * Get the percentage of the current video that is currently buffered.
	   *
	   * @return {number}
	   *         A number from 0 to 1 that represents the decimal percentage of the
	   *         video that is buffered.
	   *
	   */
	  ;
	
	  _proto.bufferedPercent = function bufferedPercent$1() {
	    return bufferedPercent(this.buffered(), this.duration_);
	  }
	  /**
	   * Turn off the polyfill for `progress` events that was created in
	   * {@link Tech#manualProgressOn}
	   * Stop manually tracking progress events by clearing the interval that was set in
	   * {@link Tech#trackProgress}.
	   */
	  ;
	
	  _proto.stopTrackingProgress = function stopTrackingProgress() {
	    this.clearInterval(this.progressInterval);
	  }
	  /**
	   * Polyfill the `timeupdate` event for browsers that don't support it.
	   *
	   * @see {@link Tech#trackCurrentTime}
	   */
	  ;
	
	  _proto.manualTimeUpdatesOn = function manualTimeUpdatesOn() {
	    this.manualTimeUpdates = true;
	    this.on('play', this.trackCurrentTime_);
	    this.on('pause', this.stopTrackingCurrentTime_);
	  }
	  /**
	   * Turn off the polyfill for `timeupdate` events that was created in
	   * {@link Tech#manualTimeUpdatesOn}
	   */
	  ;
	
	  _proto.manualTimeUpdatesOff = function manualTimeUpdatesOff() {
	    this.manualTimeUpdates = false;
	    this.stopTrackingCurrentTime();
	    this.off('play', this.trackCurrentTime_);
	    this.off('pause', this.stopTrackingCurrentTime_);
	  }
	  /**
	   * Sets up an interval function to track current time and trigger `timeupdate` every
	   * 250 milliseconds.
	   *
	   * @listens Tech#play
	   * @triggers Tech#timeupdate
	   */
	  ;
	
	  _proto.trackCurrentTime = function trackCurrentTime() {
	    if (this.currentTimeInterval) {
	      this.stopTrackingCurrentTime();
	    }
	
	    this.currentTimeInterval = this.setInterval(function () {
	      /**
	       * Triggered at an interval of 250ms to indicated that time is passing in the video.
	       *
	       * @event Tech#timeupdate
	       * @type {EventTarget~Event}
	       */
	      this.trigger({
	        type: 'timeupdate',
	        target: this,
	        manuallyTriggered: true
	      }); // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
	    }, 250);
	  }
	  /**
	   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
	   * `timeupdate` event is no longer triggered.
	   *
	   * @listens {Tech#pause}
	   */
	  ;
	
	  _proto.stopTrackingCurrentTime = function stopTrackingCurrentTime() {
	    this.clearInterval(this.currentTimeInterval); // #1002 - if the video ends right before the next timeupdate would happen,
	    // the progress bar won't make it all the way to the end
	
	    this.trigger({
	      type: 'timeupdate',
	      target: this,
	      manuallyTriggered: true
	    });
	  }
	  /**
	   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
	   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
	   *
	   * @fires Component#dispose
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    // clear out all tracks because we can't reuse them between techs
	    this.clearTracks(NORMAL.names); // Turn off any manual progress or timeupdate tracking
	
	    if (this.manualProgress) {
	      this.manualProgressOff();
	    }
	
	    if (this.manualTimeUpdates) {
	      this.manualTimeUpdatesOff();
	    }
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
	   *
	   * > Note: Techs without source handlers should call this between sources for `video`
	   *         & `audio` tracks. You don't want to use them between tracks!
	   *
	   * @param {string[]|string} types
	   *        TrackList names to clear, valid names are `video`, `audio`, and
	   *        `text`.
	   */
	  ;
	
	  _proto.clearTracks = function clearTracks(types) {
	    var _this3 = this;
	
	    types = [].concat(types); // clear out all tracks because we can't reuse them between techs
	
	    types.forEach(function (type) {
	      var list = _this3[type + "Tracks"]() || [];
	      var i = list.length;
	
	      while (i--) {
	        var track = list[i];
	
	        if (type === 'text') {
	          _this3.removeRemoteTextTrack(track);
	        }
	
	        list.removeTrack(track);
	      }
	    });
	  }
	  /**
	   * Remove any TextTracks added via addRemoteTextTrack that are
	   * flagged for automatic garbage collection
	   */
	  ;
	
	  _proto.cleanupAutoTextTracks = function cleanupAutoTextTracks() {
	    var list = this.autoRemoteTextTracks_ || [];
	    var i = list.length;
	
	    while (i--) {
	      var track = list[i];
	      this.removeRemoteTextTrack(track);
	    }
	  }
	  /**
	   * Reset the tech, which will removes all sources and reset the internal readyState.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.reset = function reset() {}
	  /**
	   * Get the value of `crossOrigin` from the tech.
	   *
	   * @abstract
	   *
	   * @see {Html5#crossOrigin}
	   */
	  ;
	
	  _proto.crossOrigin = function crossOrigin() {}
	  /**
	   * Set the value of `crossOrigin` on the tech.
	   *
	   * @abstract
	   *
	   * @param {string} crossOrigin the crossOrigin value
	   * @see {Html5#setCrossOrigin}
	   */
	  ;
	
	  _proto.setCrossOrigin = function setCrossOrigin() {}
	  /**
	   * Get or set an error on the Tech.
	   *
	   * @param {MediaError} [err]
	   *        Error to set on the Tech
	   *
	   * @return {MediaError|null}
	   *         The current error object on the tech, or null if there isn't one.
	   */
	  ;
	
	  _proto.error = function error(err) {
	    if (err !== undefined) {
	      this.error_ = new MediaError(err);
	      this.trigger('error');
	    }
	
	    return this.error_;
	  }
	  /**
	   * Returns the `TimeRange`s that have been played through for the current source.
	   *
	   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
	   *         It only checks whether the source has played at all or not.
	   *
	   * @return {TimeRange}
	   *         - A single time range if this video has played
	   *         - An empty set of ranges if not.
	   */
	  ;
	
	  _proto.played = function played() {
	    if (this.hasStarted_) {
	      return createTimeRanges(0, 0);
	    }
	
	    return createTimeRanges();
	  }
	  /**
	   * Start playback
	   *
	   * @abstract
	   *
	   * @see {Html5#play}
	   */
	  ;
	
	  _proto.play = function play() {}
	  /**
	   * Set whether we are scrubbing or not
	   *
	   * @abstract
	   *
	   * @see {Html5#setScrubbing}
	   */
	  ;
	
	  _proto.setScrubbing = function setScrubbing() {}
	  /**
	   * Get whether we are scrubbing or not
	   *
	   * @abstract
	   *
	   * @see {Html5#scrubbing}
	   */
	  ;
	
	  _proto.scrubbing = function scrubbing() {}
	  /**
	   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
	   * previously called.
	   *
	   * @fires Tech#timeupdate
	   */
	  ;
	
	  _proto.setCurrentTime = function setCurrentTime() {
	    // improve the accuracy of manual timeupdates
	    if (this.manualTimeUpdates) {
	      /**
	       * A manual `timeupdate` event.
	       *
	       * @event Tech#timeupdate
	       * @type {EventTarget~Event}
	       */
	      this.trigger({
	        type: 'timeupdate',
	        target: this,
	        manuallyTriggered: true
	      });
	    }
	  }
	  /**
	   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
	   * {@link TextTrackList} events.
	   *
	   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
	   *
	   * @fires Tech#audiotrackchange
	   * @fires Tech#videotrackchange
	   * @fires Tech#texttrackchange
	   */
	  ;
	
	  _proto.initTrackListeners = function initTrackListeners() {
	    var _this4 = this;
	
	    /**
	      * Triggered when tracks are added or removed on the Tech {@link AudioTrackList}
	      *
	      * @event Tech#audiotrackchange
	      * @type {EventTarget~Event}
	      */
	
	    /**
	      * Triggered when tracks are added or removed on the Tech {@link VideoTrackList}
	      *
	      * @event Tech#videotrackchange
	      * @type {EventTarget~Event}
	      */
	
	    /**
	      * Triggered when tracks are added or removed on the Tech {@link TextTrackList}
	      *
	      * @event Tech#texttrackchange
	      * @type {EventTarget~Event}
	      */
	    NORMAL.names.forEach(function (name) {
	      var props = NORMAL[name];
	
	      var trackListChanges = function trackListChanges() {
	        _this4.trigger(name + "trackchange");
	      };
	
	      var tracks = _this4[props.getterName]();
	
	      tracks.addEventListener('removetrack', trackListChanges);
	      tracks.addEventListener('addtrack', trackListChanges);
	
	      _this4.on('dispose', function () {
	        tracks.removeEventListener('removetrack', trackListChanges);
	        tracks.removeEventListener('addtrack', trackListChanges);
	      });
	    });
	  }
	  /**
	   * Emulate TextTracks using vtt.js if necessary
	   *
	   * @fires Tech#vttjsloaded
	   * @fires Tech#vttjserror
	   */
	  ;
	
	  _proto.addWebVttScript_ = function addWebVttScript_() {
	    var _this5 = this;
	
	    if (window__default['default'].WebVTT) {
	      return;
	    } // Initially, Tech.el_ is a child of a dummy-div wait until the Component system
	    // signals that the Tech is ready at which point Tech.el_ is part of the DOM
	    // before inserting the WebVTT script
	
	
	    if (document__default['default'].body.contains(this.el())) {
	      // load via require if available and vtt.js script location was not passed in
	      // as an option. novtt builds will turn the above require call into an empty object
	      // which will cause this if check to always fail.
	      if (!this.options_['vtt.js'] && isPlain(vtt__default['default']) && Object.keys(vtt__default['default']).length > 0) {
	        this.trigger('vttjsloaded');
	        return;
	      } // load vtt.js via the script location option or the cdn of no location was
	      // passed in
	
	
	      var script = document__default['default'].createElement('script');
	      script.src = this.options_['vtt.js'] || 'https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js';
	
	      script.onload = function () {
	        /**
	         * Fired when vtt.js is loaded.
	         *
	         * @event Tech#vttjsloaded
	         * @type {EventTarget~Event}
	         */
	        _this5.trigger('vttjsloaded');
	      };
	
	      script.onerror = function () {
	        /**
	         * Fired when vtt.js was not loaded due to an error
	         *
	         * @event Tech#vttjsloaded
	         * @type {EventTarget~Event}
	         */
	        _this5.trigger('vttjserror');
	      };
	
	      this.on('dispose', function () {
	        script.onload = null;
	        script.onerror = null;
	      }); // but have not loaded yet and we set it to true before the inject so that
	      // we don't overwrite the injected window.WebVTT if it loads right away
	
	      window__default['default'].WebVTT = true;
	      this.el().parentNode.appendChild(script);
	    } else {
	      this.ready(this.addWebVttScript_);
	    }
	  }
	  /**
	   * Emulate texttracks
	   *
	   */
	  ;
	
	  _proto.emulateTextTracks = function emulateTextTracks() {
	    var _this6 = this;
	
	    var tracks = this.textTracks();
	    var remoteTracks = this.remoteTextTracks();
	
	    var handleAddTrack = function handleAddTrack(e) {
	      return tracks.addTrack(e.track);
	    };
	
	    var handleRemoveTrack = function handleRemoveTrack(e) {
	      return tracks.removeTrack(e.track);
	    };
	
	    remoteTracks.on('addtrack', handleAddTrack);
	    remoteTracks.on('removetrack', handleRemoveTrack);
	    this.addWebVttScript_();
	
	    var updateDisplay = function updateDisplay() {
	      return _this6.trigger('texttrackchange');
	    };
	
	    var textTracksChanges = function textTracksChanges() {
	      updateDisplay();
	
	      for (var i = 0; i < tracks.length; i++) {
	        var track = tracks[i];
	        track.removeEventListener('cuechange', updateDisplay);
	
	        if (track.mode === 'showing') {
	          track.addEventListener('cuechange', updateDisplay);
	        }
	      }
	    };
	
	    textTracksChanges();
	    tracks.addEventListener('change', textTracksChanges);
	    tracks.addEventListener('addtrack', textTracksChanges);
	    tracks.addEventListener('removetrack', textTracksChanges);
	    this.on('dispose', function () {
	      remoteTracks.off('addtrack', handleAddTrack);
	      remoteTracks.off('removetrack', handleRemoveTrack);
	      tracks.removeEventListener('change', textTracksChanges);
	      tracks.removeEventListener('addtrack', textTracksChanges);
	      tracks.removeEventListener('removetrack', textTracksChanges);
	
	      for (var i = 0; i < tracks.length; i++) {
	        var track = tracks[i];
	        track.removeEventListener('cuechange', updateDisplay);
	      }
	    });
	  }
	  /**
	   * Create and returns a remote {@link TextTrack} object.
	   *
	   * @param {string} kind
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	   *
	   * @param {string} [label]
	   *        Label to identify the text track
	   *
	   * @param {string} [language]
	   *        Two letter language abbreviation
	   *
	   * @return {TextTrack}
	   *         The TextTrack that gets created.
	   */
	  ;
	
	  _proto.addTextTrack = function addTextTrack(kind, label, language) {
	    if (!kind) {
	      throw new Error('TextTrack kind is required but was not provided');
	    }
	
	    return createTrackHelper(this, kind, label, language);
	  }
	  /**
	   * Create an emulated TextTrack for use by addRemoteTextTrack
	   *
	   * This is intended to be overridden by classes that inherit from
	   * Tech in order to create native or custom TextTracks.
	   *
	   * @param {Object} options
	   *        The object should contain the options to initialize the TextTrack with.
	   *
	   * @param {string} [options.kind]
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
	   *
	   * @param {string} [options.label].
	   *        Label to identify the text track
	   *
	   * @param {string} [options.language]
	   *        Two letter language abbreviation.
	   *
	   * @return {HTMLTrackElement}
	   *         The track element that gets created.
	   */
	  ;
	
	  _proto.createRemoteTextTrack = function createRemoteTextTrack(options) {
	    var track = mergeOptions$3(options, {
	      tech: this
	    });
	    return new REMOTE.remoteTextEl.TrackClass(track);
	  }
	  /**
	   * Creates a remote text track object and returns an html track element.
	   *
	   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
	   *
	   * @param {Object} options
	   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
	   *
	   * @param {boolean} [manualCleanup=true]
	   *        - When false: the TextTrack will be automatically removed from the video
	   *          element whenever the source changes
	   *        - When True: The TextTrack will have to be cleaned up manually
	   *
	   * @return {HTMLTrackElement}
	   *         An Html Track Element.
	   *
	   * @deprecated The default functionality for this function will be equivalent
	   *             to "manualCleanup=false" in the future. The manualCleanup parameter will
	   *             also be removed.
	   */
	  ;
	
	  _proto.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
	    var _this7 = this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    var htmlTrackElement = this.createRemoteTextTrack(options);
	
	    if (manualCleanup !== true && manualCleanup !== false) {
	      // deprecation warning
	      log$1.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js');
	      manualCleanup = true;
	    } // store HTMLTrackElement and TextTrack to remote list
	
	
	    this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);
	    this.remoteTextTracks().addTrack(htmlTrackElement.track);
	
	    if (manualCleanup !== true) {
	      // create the TextTrackList if it doesn't exist
	      this.ready(function () {
	        return _this7.autoRemoteTextTracks_.addTrack(htmlTrackElement.track);
	      });
	    }
	
	    return htmlTrackElement;
	  }
	  /**
	   * Remove a remote text track from the remote `TextTrackList`.
	   *
	   * @param {TextTrack} track
	   *        `TextTrack` to remove from the `TextTrackList`
	   */
	  ;
	
	  _proto.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
	    var trackElement = this.remoteTextTrackEls().getTrackElementByTrack_(track); // remove HTMLTrackElement and TextTrack from remote list
	
	    this.remoteTextTrackEls().removeTrackElement_(trackElement);
	    this.remoteTextTracks().removeTrack(track);
	    this.autoRemoteTextTracks_.removeTrack(track);
	  }
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object}
	   *         An object with supported media playback quality metrics
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    return {};
	  }
	  /**
	   * Attempt to create a floating video window always on top of other windows
	   * so that users may continue consuming media while they interact with other
	   * content sites, or applications on their device.
	   *
	   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
	   *
	   * @return {Promise|undefined}
	   *         A promise with a Picture-in-Picture window if the browser supports
	   *         Promises (or one was passed in as an option). It returns undefined
	   *         otherwise.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.requestPictureInPicture = function requestPictureInPicture() {
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      return PromiseClass.reject();
	    }
	  }
	  /**
	   * A method to check for the value of the 'disablePictureInPicture' <video> property.
	   * Defaults to true, as it should be considered disabled if the tech does not support pip
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.disablePictureInPicture = function disablePictureInPicture() {
	    return true;
	  }
	  /**
	   * A method to set or unset the 'disablePictureInPicture' <video> property.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.setDisablePictureInPicture = function setDisablePictureInPicture() {}
	  /**
	   * A fallback implementation of requestVideoFrameCallback using requestAnimationFrame
	   *
	   * @param {function} cb
	   * @return {number} request id
	   */
	  ;
	
	  _proto.requestVideoFrameCallback = function requestVideoFrameCallback(cb) {
	    var _this8 = this;
	
	    var id = newGUID();
	
	    if (!this.isReady_ || this.paused()) {
	      this.queuedHanders_.add(id);
	      this.one('playing', function () {
	        if (_this8.queuedHanders_.has(id)) {
	          _this8.queuedHanders_["delete"](id);
	
	          cb();
	        }
	      });
	    } else {
	      this.requestNamedAnimationFrame(id, cb);
	    }
	
	    return id;
	  }
	  /**
	   * A fallback implementation of cancelVideoFrameCallback
	   *
	   * @param {number} id id of callback to be cancelled
	   */
	  ;
	
	  _proto.cancelVideoFrameCallback = function cancelVideoFrameCallback(id) {
	    if (this.queuedHanders_.has(id)) {
	      this.queuedHanders_["delete"](id);
	    } else {
	      this.cancelNamedAnimationFrame(id);
	    }
	  }
	  /**
	   * A method to set a poster from a `Tech`.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.setPoster = function setPoster() {}
	  /**
	   * A method to check for the presence of the 'playsinline' <video> attribute.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.playsinline = function playsinline() {}
	  /**
	   * A method to set or unset the 'playsinline' <video> attribute.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.setPlaysinline = function setPlaysinline() {}
	  /**
	   * Attempt to force override of native audio tracks.
	   *
	   * @param {boolean} override - If set to true native audio will be overridden,
	   * otherwise native audio will potentially be used.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.overrideNativeAudioTracks = function overrideNativeAudioTracks() {}
	  /**
	   * Attempt to force override of native video tracks.
	   *
	   * @param {boolean} override - If set to true native video will be overridden,
	   * otherwise native video will potentially be used.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.overrideNativeVideoTracks = function overrideNativeVideoTracks() {}
	  /*
	   * Check if the tech can support the given mime-type.
	   *
	   * The base tech does not support any type, but source handlers might
	   * overwrite this.
	   *
	   * @param  {string} type
	   *         The mimetype to check for support
	   *
	   * @return {string}
	   *         'probably', 'maybe', or empty string
	   *
	   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.canPlayType = function canPlayType() {
	    return '';
	  }
	  /**
	   * Check if the type is supported by this tech.
	   *
	   * The base tech does not support any type, but source handlers might
	   * overwrite this.
	   *
	   * @param {string} type
	   *        The media type to check
	   * @return {string} Returns the native video element's response
	   */
	  ;
	
	  Tech.canPlayType = function canPlayType() {
	    return '';
	  }
	  /**
	   * Check if the tech can support the given source
	   *
	   * @param {Object} srcObj
	   *        The source object
	   * @param {Object} options
	   *        The options passed to the tech
	   * @return {string} 'probably', 'maybe', or '' (empty string)
	   */
	  ;
	
	  Tech.canPlaySource = function canPlaySource(srcObj, options) {
	    return Tech.canPlayType(srcObj.type);
	  }
	  /*
	   * Return whether the argument is a Tech or not.
	   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
	   *
	   * @param {Object} component
	   *        The item to check
	   *
	   * @return {boolean}
	   *         Whether it is a tech or not
	   *         - True if it is a tech
	   *         - False if it is not
	   */
	  ;
	
	  Tech.isTech = function isTech(component) {
	    return component.prototype instanceof Tech || component instanceof Tech || component === Tech;
	  }
	  /**
	   * Registers a `Tech` into a shared list for videojs.
	   *
	   * @param {string} name
	   *        Name of the `Tech` to register.
	   *
	   * @param {Object} tech
	   *        The `Tech` class to register.
	   */
	  ;
	
	  Tech.registerTech = function registerTech(name, tech) {
	    if (!Tech.techs_) {
	      Tech.techs_ = {};
	    }
	
	    if (!Tech.isTech(tech)) {
	      throw new Error("Tech " + name + " must be a Tech");
	    }
	
	    if (!Tech.canPlayType) {
	      throw new Error('Techs must have a static canPlayType method on them');
	    }
	
	    if (!Tech.canPlaySource) {
	      throw new Error('Techs must have a static canPlaySource method on them');
	    }
	
	    name = toTitleCase$1(name);
	    Tech.techs_[name] = tech;
	    Tech.techs_[toLowerCase(name)] = tech;
	
	    if (name !== 'Tech') {
	      // camel case the techName for use in techOrder
	      Tech.defaultTechOrder_.push(name);
	    }
	
	    return tech;
	  }
	  /**
	   * Get a `Tech` from the shared list by name.
	   *
	   * @param {string} name
	   *        `camelCase` or `TitleCase` name of the Tech to get
	   *
	   * @return {Tech|undefined}
	   *         The `Tech` or undefined if there was no tech with the name requested.
	   */
	  ;
	
	  Tech.getTech = function getTech(name) {
	    if (!name) {
	      return;
	    }
	
	    if (Tech.techs_ && Tech.techs_[name]) {
	      return Tech.techs_[name];
	    }
	
	    name = toTitleCase$1(name);
	
	    if (window__default['default'] && window__default['default'].videojs && window__default['default'].videojs[name]) {
	      log$1.warn("The " + name + " tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)");
	      return window__default['default'].videojs[name];
	    }
	  };
	
	  return Tech;
	}(Component$1);
	/**
	 * Get the {@link VideoTrackList}
	 *
	 * @returns {VideoTrackList}
	 * @method Tech.prototype.videoTracks
	 */
	
	/**
	 * Get the {@link AudioTrackList}
	 *
	 * @returns {AudioTrackList}
	 * @method Tech.prototype.audioTracks
	 */
	
	/**
	 * Get the {@link TextTrackList}
	 *
	 * @returns {TextTrackList}
	 * @method Tech.prototype.textTracks
	 */
	
	/**
	 * Get the remote element {@link TextTrackList}
	 *
	 * @returns {TextTrackList}
	 * @method Tech.prototype.remoteTextTracks
	 */
	
	/**
	 * Get the remote element {@link HtmlTrackElementList}
	 *
	 * @returns {HtmlTrackElementList}
	 * @method Tech.prototype.remoteTextTrackEls
	 */
	
	
	ALL.names.forEach(function (name) {
	  var props = ALL[name];
	
	  Tech.prototype[props.getterName] = function () {
	    this[props.privateName] = this[props.privateName] || new props.ListClass();
	    return this[props.privateName];
	  };
	});
	/**
	 * List of associated text tracks
	 *
	 * @type {TextTrackList}
	 * @private
	 * @property Tech#textTracks_
	 */
	
	/**
	 * List of associated audio tracks.
	 *
	 * @type {AudioTrackList}
	 * @private
	 * @property Tech#audioTracks_
	 */
	
	/**
	 * List of associated video tracks.
	 *
	 * @type {VideoTrackList}
	 * @private
	 * @property Tech#videoTracks_
	 */
	
	/**
	 * Boolean indicating whether the `Tech` supports volume control.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresVolumeControl = true;
	/**
	 * Boolean indicating whether the `Tech` supports muting volume.
	 *
	 * @type {bolean}
	 * @default
	 */
	
	Tech.prototype.featuresMuteControl = true;
	/**
	 * Boolean indicating whether the `Tech` supports fullscreen resize control.
	 * Resizing plugins using request fullscreen reloads the plugin
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresFullscreenResize = false;
	/**
	 * Boolean indicating whether the `Tech` supports changing the speed at which the video
	 * plays. Examples:
	 *   - Set player to play 2x (twice) as fast
	 *   - Set player to play 0.5x (half) as fast
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresPlaybackRate = false;
	/**
	 * Boolean indicating whether the `Tech` supports the `progress` event. This is currently
	 * not triggered by video-js-swf. This will be used to determine if
	 * {@link Tech#manualProgressOn} should be called.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresProgressEvents = false;
	/**
	 * Boolean indicating whether the `Tech` supports the `sourceset` event.
	 *
	 * A tech should set this to `true` and then use {@link Tech#triggerSourceset}
	 * to trigger a {@link Tech#event:sourceset} at the earliest time after getting
	 * a new source.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresSourceset = false;
	/**
	 * Boolean indicating whether the `Tech` supports the `timeupdate` event. This is currently
	 * not triggered by video-js-swf. This will be used to determine if
	 * {@link Tech#manualTimeUpdates} should be called.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresTimeupdateEvents = false;
	/**
	 * Boolean indicating whether the `Tech` supports the native `TextTrack`s.
	 * This will help us integrate with native `TextTrack`s if the browser supports them.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresNativeTextTracks = false;
	/**
	 * Boolean indicating whether the `Tech` supports `requestVideoFrameCallback`.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresVideoFrameCallback = false;
	/**
	 * A functional mixin for techs that want to use the Source Handler pattern.
	 * Source handlers are scripts for handling specific formats.
	 * The source handler pattern is used for adaptive formats (HLS, DASH) that
	 * manually load video data and feed it into a Source Buffer (Media Source Extensions)
	 * Example: `Tech.withSourceHandlers.call(MyTech);`
	 *
	 * @param {Tech} _Tech
	 *        The tech to add source handler functions to.
	 *
	 * @mixes Tech~SourceHandlerAdditions
	 */
	
	Tech.withSourceHandlers = function (_Tech) {
	  /**
	   * Register a source handler
	   *
	   * @param {Function} handler
	   *        The source handler class
	   *
	   * @param {number} [index]
	   *        Register it at the following index
	   */
	  _Tech.registerSourceHandler = function (handler, index) {
	    var handlers = _Tech.sourceHandlers;
	
	    if (!handlers) {
	      handlers = _Tech.sourceHandlers = [];
	    }
	
	    if (index === undefined) {
	      // add to the end of the list
	      index = handlers.length;
	    }
	
	    handlers.splice(index, 0, handler);
	  };
	  /**
	   * Check if the tech can support the given type. Also checks the
	   * Techs sourceHandlers.
	   *
	   * @param {string} type
	   *         The mimetype to check.
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	
	
	  _Tech.canPlayType = function (type) {
	    var handlers = _Tech.sourceHandlers || [];
	    var can;
	
	    for (var i = 0; i < handlers.length; i++) {
	      can = handlers[i].canPlayType(type);
	
	      if (can) {
	        return can;
	      }
	    }
	
	    return '';
	  };
	  /**
	   * Returns the first source handler that supports the source.
	   *
	   * TODO: Answer question: should 'probably' be prioritized over 'maybe'
	   *
	   * @param {Tech~SourceObject} source
	   *        The source object
	   *
	   * @param {Object} options
	   *        The options passed to the tech
	   *
	   * @return {SourceHandler|null}
	   *          The first source handler that supports the source or null if
	   *          no SourceHandler supports the source
	   */
	
	
	  _Tech.selectSourceHandler = function (source, options) {
	    var handlers = _Tech.sourceHandlers || [];
	    var can;
	
	    for (var i = 0; i < handlers.length; i++) {
	      can = handlers[i].canHandleSource(source, options);
	
	      if (can) {
	        return handlers[i];
	      }
	    }
	
	    return null;
	  };
	  /**
	   * Check if the tech can support the given source.
	   *
	   * @param {Tech~SourceObject} srcObj
	   *        The source object
	   *
	   * @param {Object} options
	   *        The options passed to the tech
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	
	
	  _Tech.canPlaySource = function (srcObj, options) {
	    var sh = _Tech.selectSourceHandler(srcObj, options);
	
	    if (sh) {
	      return sh.canHandleSource(srcObj, options);
	    }
	
	    return '';
	  };
	  /**
	   * When using a source handler, prefer its implementation of
	   * any function normally provided by the tech.
	   */
	
	
	  var deferrable = ['seekable', 'seeking', 'duration'];
	  /**
	   * A wrapper around {@link Tech#seekable} that will call a `SourceHandler`s seekable
	   * function if it exists, with a fallback to the Techs seekable function.
	   *
	   * @method _Tech.seekable
	   */
	
	  /**
	   * A wrapper around {@link Tech#duration} that will call a `SourceHandler`s duration
	   * function if it exists, otherwise it will fallback to the techs duration function.
	   *
	   * @method _Tech.duration
	   */
	
	  deferrable.forEach(function (fnName) {
	    var originalFn = this[fnName];
	
	    if (typeof originalFn !== 'function') {
	      return;
	    }
	
	    this[fnName] = function () {
	      if (this.sourceHandler_ && this.sourceHandler_[fnName]) {
	        return this.sourceHandler_[fnName].apply(this.sourceHandler_, arguments);
	      }
	
	      return originalFn.apply(this, arguments);
	    };
	  }, _Tech.prototype);
	  /**
	   * Create a function for setting the source using a source object
	   * and source handlers.
	   * Should never be called unless a source handler was found.
	   *
	   * @param {Tech~SourceObject} source
	   *        A source object with src and type keys
	   */
	
	  _Tech.prototype.setSource = function (source) {
	    var sh = _Tech.selectSourceHandler(source, this.options_);
	
	    if (!sh) {
	      // Fall back to a native source hander when unsupported sources are
	      // deliberately set
	      if (_Tech.nativeSourceHandler) {
	        sh = _Tech.nativeSourceHandler;
	      } else {
	        log$1.error('No source handler found for the current source.');
	      }
	    } // Dispose any existing source handler
	
	
	    this.disposeSourceHandler();
	    this.off('dispose', this.disposeSourceHandler_);
	
	    if (sh !== _Tech.nativeSourceHandler) {
	      this.currentSource_ = source;
	    }
	
	    this.sourceHandler_ = sh.handleSource(source, this, this.options_);
	    this.one('dispose', this.disposeSourceHandler_);
	  };
	  /**
	   * Clean up any existing SourceHandlers and listeners when the Tech is disposed.
	   *
	   * @listens Tech#dispose
	   */
	
	
	  _Tech.prototype.disposeSourceHandler = function () {
	    // if we have a source and get another one
	    // then we are loading something new
	    // than clear all of our current tracks
	    if (this.currentSource_) {
	      this.clearTracks(['audio', 'video']);
	      this.currentSource_ = null;
	    } // always clean up auto-text tracks
	
	
	    this.cleanupAutoTextTracks();
	
	    if (this.sourceHandler_) {
	      if (this.sourceHandler_.dispose) {
	        this.sourceHandler_.dispose();
	      }
	
	      this.sourceHandler_ = null;
	    }
	  };
	}; // The base Tech class needs to be registered as a Component. It is the only
	// Tech that can be registered as a Component.
	
	
	Component$1.registerComponent('Tech', Tech);
	Tech.registerTech('Tech', Tech);
	/**
	 * A list of techs that should be added to techOrder on Players
	 *
	 * @private
	 */
	
	Tech.defaultTechOrder_ = [];
	
	/**
	 * @file middleware.js
	 * @module middleware
	 */
	var middlewares = {};
	var middlewareInstances = {};
	var TERMINATOR = {};
	/**
	 * A middleware object is a plain JavaScript object that has methods that
	 * match the {@link Tech} methods found in the lists of allowed
	 * {@link module:middleware.allowedGetters|getters},
	 * {@link module:middleware.allowedSetters|setters}, and
	 * {@link module:middleware.allowedMediators|mediators}.
	 *
	 * @typedef {Object} MiddlewareObject
	 */
	
	/**
	 * A middleware factory function that should return a
	 * {@link module:middleware~MiddlewareObject|MiddlewareObject}.
	 *
	 * This factory will be called for each player when needed, with the player
	 * passed in as an argument.
	 *
	 * @callback MiddlewareFactory
	 * @param {Player} player
	 *        A Video.js player.
	 */
	
	/**
	 * Define a middleware that the player should use by way of a factory function
	 * that returns a middleware object.
	 *
	 * @param  {string} type
	 *         The MIME type to match or `"*"` for all MIME types.
	 *
	 * @param  {MiddlewareFactory} middleware
	 *         A middleware factory function that will be executed for
	 *         matching types.
	 */
	
	function use(type, middleware) {
	  middlewares[type] = middlewares[type] || [];
	  middlewares[type].push(middleware);
	}
	/**
	 * Asynchronously sets a source using middleware by recursing through any
	 * matching middlewares and calling `setSource` on each, passing along the
	 * previous returned value each time.
	 *
	 * @param  {Player} player
	 *         A {@link Player} instance.
	 *
	 * @param  {Tech~SourceObject} src
	 *         A source object.
	 *
	 * @param  {Function}
	 *         The next middleware to run.
	 */
	
	function setSource(player, src, next) {
	  player.setTimeout(function () {
	    return setSourceHelper(src, middlewares[src.type], next, player);
	  }, 1);
	}
	/**
	 * When the tech is set, passes the tech to each middleware's `setTech` method.
	 *
	 * @param {Object[]} middleware
	 *        An array of middleware instances.
	 *
	 * @param {Tech} tech
	 *        A Video.js tech.
	 */
	
	function setTech(middleware, tech) {
	  middleware.forEach(function (mw) {
	    return mw.setTech && mw.setTech(tech);
	  });
	}
	/**
	 * Calls a getter on the tech first, through each middleware
	 * from right to left to the player.
	 *
	 * @param  {Object[]} middleware
	 *         An array of middleware instances.
	 *
	 * @param  {Tech} tech
	 *         The current tech.
	 *
	 * @param  {string} method
	 *         A method name.
	 *
	 * @return {Mixed}
	 *         The final value from the tech after middleware has intercepted it.
	 */
	
	function get(middleware, tech, method) {
	  return middleware.reduceRight(middlewareIterator(method), tech[method]());
	}
	/**
	 * Takes the argument given to the player and calls the setter method on each
	 * middleware from left to right to the tech.
	 *
	 * @param  {Object[]} middleware
	 *         An array of middleware instances.
	 *
	 * @param  {Tech} tech
	 *         The current tech.
	 *
	 * @param  {string} method
	 *         A method name.
	 *
	 * @param  {Mixed} arg
	 *         The value to set on the tech.
	 *
	 * @return {Mixed}
	 *         The return value of the `method` of the `tech`.
	 */
	
	function set(middleware, tech, method, arg) {
	  return tech[method](middleware.reduce(middlewareIterator(method), arg));
	}
	/**
	 * Takes the argument given to the player and calls the `call` version of the
	 * method on each middleware from left to right.
	 *
	 * Then, call the passed in method on the tech and return the result unchanged
	 * back to the player, through middleware, this time from right to left.
	 *
	 * @param  {Object[]} middleware
	 *         An array of middleware instances.
	 *
	 * @param  {Tech} tech
	 *         The current tech.
	 *
	 * @param  {string} method
	 *         A method name.
	 *
	 * @param  {Mixed} arg
	 *         The value to set on the tech.
	 *
	 * @return {Mixed}
	 *         The return value of the `method` of the `tech`, regardless of the
	 *         return values of middlewares.
	 */
	
	function mediate(middleware, tech, method, arg) {
	  if (arg === void 0) {
	    arg = null;
	  }
	
	  var callMethod = 'call' + toTitleCase$1(method);
	  var middlewareValue = middleware.reduce(middlewareIterator(callMethod), arg);
	  var terminated = middlewareValue === TERMINATOR; // deprecated. The `null` return value should instead return TERMINATOR to
	  // prevent confusion if a techs method actually returns null.
	
	  var returnValue = terminated ? null : tech[method](middlewareValue);
	  executeRight(middleware, method, returnValue, terminated);
	  return returnValue;
	}
	/**
	 * Enumeration of allowed getters where the keys are method names.
	 *
	 * @type {Object}
	 */
	
	var allowedGetters = {
	  buffered: 1,
	  currentTime: 1,
	  duration: 1,
	  muted: 1,
	  played: 1,
	  paused: 1,
	  seekable: 1,
	  volume: 1,
	  ended: 1
	};
	/**
	 * Enumeration of allowed setters where the keys are method names.
	 *
	 * @type {Object}
	 */
	
	var allowedSetters = {
	  setCurrentTime: 1,
	  setMuted: 1,
	  setVolume: 1
	};
	/**
	 * Enumeration of allowed mediators where the keys are method names.
	 *
	 * @type {Object}
	 */
	
	var allowedMediators = {
	  play: 1,
	  pause: 1
	};
	
	function middlewareIterator(method) {
	  return function (value, mw) {
	    // if the previous middleware terminated, pass along the termination
	    if (value === TERMINATOR) {
	      return TERMINATOR;
	    }
	
	    if (mw[method]) {
	      return mw[method](value);
	    }
	
	    return value;
	  };
	}
	
	function executeRight(mws, method, value, terminated) {
	  for (var i = mws.length - 1; i >= 0; i--) {
	    var mw = mws[i];
	
	    if (mw[method]) {
	      mw[method](terminated, value);
	    }
	  }
	}
	/**
	 * Clear the middleware cache for a player.
	 *
	 * @param  {Player} player
	 *         A {@link Player} instance.
	 */
	
	
	function clearCacheForPlayer(player) {
	  middlewareInstances[player.id()] = null;
	}
	/**
	 * {
	 *  [playerId]: [[mwFactory, mwInstance], ...]
	 * }
	 *
	 * @private
	 */
	
	function getOrCreateFactory(player, mwFactory) {
	  var mws = middlewareInstances[player.id()];
	  var mw = null;
	
	  if (mws === undefined || mws === null) {
	    mw = mwFactory(player);
	    middlewareInstances[player.id()] = [[mwFactory, mw]];
	    return mw;
	  }
	
	  for (var i = 0; i < mws.length; i++) {
	    var _mws$i = mws[i],
	        mwf = _mws$i[0],
	        mwi = _mws$i[1];
	
	    if (mwf !== mwFactory) {
	      continue;
	    }
	
	    mw = mwi;
	  }
	
	  if (mw === null) {
	    mw = mwFactory(player);
	    mws.push([mwFactory, mw]);
	  }
	
	  return mw;
	}
	
	function setSourceHelper(src, middleware, next, player, acc, lastRun) {
	  if (src === void 0) {
	    src = {};
	  }
	
	  if (middleware === void 0) {
	    middleware = [];
	  }
	
	  if (acc === void 0) {
	    acc = [];
	  }
	
	  if (lastRun === void 0) {
	    lastRun = false;
	  }
	
	  var _middleware = middleware,
	      mwFactory = _middleware[0],
	      mwrest = _middleware.slice(1); // if mwFactory is a string, then we're at a fork in the road
	
	
	  if (typeof mwFactory === 'string') {
	    setSourceHelper(src, middlewares[mwFactory], next, player, acc, lastRun); // if we have an mwFactory, call it with the player to get the mw,
	    // then call the mw's setSource method
	  } else if (mwFactory) {
	    var mw = getOrCreateFactory(player, mwFactory); // if setSource isn't present, implicitly select this middleware
	
	    if (!mw.setSource) {
	      acc.push(mw);
	      return setSourceHelper(src, mwrest, next, player, acc, lastRun);
	    }
	
	    mw.setSource(assign({}, src), function (err, _src) {
	      // something happened, try the next middleware on the current level
	      // make sure to use the old src
	      if (err) {
	        return setSourceHelper(src, mwrest, next, player, acc, lastRun);
	      } // we've succeeded, now we need to go deeper
	
	
	      acc.push(mw); // if it's the same type, continue down the current chain
	      // otherwise, we want to go down the new chain
	
	      setSourceHelper(_src, src.type === _src.type ? mwrest : middlewares[_src.type], next, player, acc, lastRun);
	    });
	  } else if (mwrest.length) {
	    setSourceHelper(src, mwrest, next, player, acc, lastRun);
	  } else if (lastRun) {
	    next(src, acc);
	  } else {
	    setSourceHelper(src, middlewares['*'], next, player, acc, true);
	  }
	}
	
	/**
	 * Mimetypes
	 *
	 * @see https://www.iana.org/assignments/media-types/media-types.xhtml
	 * @typedef Mimetypes~Kind
	 * @enum
	 */
	
	var MimetypesKind = {
	  opus: 'video/ogg',
	  ogv: 'video/ogg',
	  mp4: 'video/mp4',
	  mov: 'video/mp4',
	  m4v: 'video/mp4',
	  mkv: 'video/x-matroska',
	  m4a: 'audio/mp4',
	  mp3: 'audio/mpeg',
	  aac: 'audio/aac',
	  caf: 'audio/x-caf',
	  flac: 'audio/flac',
	  oga: 'audio/ogg',
	  wav: 'audio/wav',
	  m3u8: 'application/x-mpegURL',
	  mpd: 'application/dash+xml',
	  jpg: 'image/jpeg',
	  jpeg: 'image/jpeg',
	  gif: 'image/gif',
	  png: 'image/png',
	  svg: 'image/svg+xml',
	  webp: 'image/webp'
	};
	/**
	 * Get the mimetype of a given src url if possible
	 *
	 * @param {string} src
	 *        The url to the src
	 *
	 * @return {string}
	 *         return the mimetype if it was known or empty string otherwise
	 */
	
	var getMimetype = function getMimetype(src) {
	  if (src === void 0) {
	    src = '';
	  }
	
	  var ext = getFileExtension(src);
	  var mimetype = MimetypesKind[ext.toLowerCase()];
	  return mimetype || '';
	};
	/**
	 * Find the mime type of a given source string if possible. Uses the player
	 * source cache.
	 *
	 * @param {Player} player
	 *        The player object
	 *
	 * @param {string} src
	 *        The source string
	 *
	 * @return {string}
	 *         The type that was found
	 */
	
	var findMimetype = function findMimetype(player, src) {
	  if (!src) {
	    return '';
	  } // 1. check for the type in the `source` cache
	
	
	  if (player.cache_.source.src === src && player.cache_.source.type) {
	    return player.cache_.source.type;
	  } // 2. see if we have this source in our `currentSources` cache
	
	
	  var matchingSources = player.cache_.sources.filter(function (s) {
	    return s.src === src;
	  });
	
	  if (matchingSources.length) {
	    return matchingSources[0].type;
	  } // 3. look for the src url in source elements and use the type there
	
	
	  var sources = player.$$('source');
	
	  for (var i = 0; i < sources.length; i++) {
	    var s = sources[i];
	
	    if (s.type && s.src && s.src === src) {
	      return s.type;
	    }
	  } // 4. finally fallback to our list of mime types based on src url extension
	
	
	  return getMimetype(src);
	};
	
	/**
	 * @module filter-source
	 */
	/**
	 * Filter out single bad source objects or multiple source objects in an
	 * array. Also flattens nested source object arrays into a 1 dimensional
	 * array of source objects.
	 *
	 * @param {Tech~SourceObject|Tech~SourceObject[]} src
	 *        The src object to filter
	 *
	 * @return {Tech~SourceObject[]}
	 *         An array of sourceobjects containing only valid sources
	 *
	 * @private
	 */
	
	var filterSource = function filterSource(src) {
	  // traverse array
	  if (Array.isArray(src)) {
	    var newsrc = [];
	    src.forEach(function (srcobj) {
	      srcobj = filterSource(srcobj);
	
	      if (Array.isArray(srcobj)) {
	        newsrc = newsrc.concat(srcobj);
	      } else if (isObject(srcobj)) {
	        newsrc.push(srcobj);
	      }
	    });
	    src = newsrc;
	  } else if (typeof src === 'string' && src.trim()) {
	    // convert string into object
	    src = [fixSource({
	      src: src
	    })];
	  } else if (isObject(src) && typeof src.src === 'string' && src.src && src.src.trim()) {
	    // src is already valid
	    src = [fixSource(src)];
	  } else {
	    // invalid source, turn it into an empty array
	    src = [];
	  }
	
	  return src;
	};
	/**
	 * Checks src mimetype, adding it when possible
	 *
	 * @param {Tech~SourceObject} src
	 *        The src object to check
	 * @return {Tech~SourceObject}
	 *        src Object with known type
	 */
	
	
	function fixSource(src) {
	  if (!src.type) {
	    var mimetype = getMimetype(src.src);
	
	    if (mimetype) {
	      src.type = mimetype;
	    }
	  }
	
	  return src;
	}
	
	/**
	 * The `MediaLoader` is the `Component` that decides which playback technology to load
	 * when a player is initialized.
	 *
	 * @extends Component
	 */
	
	var MediaLoader = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](MediaLoader, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should attach to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function that is run when this component is ready.
	   */
	  function MediaLoader(player, options, ready) {
	    var _this;
	
	    // MediaLoader has no element
	    var options_ = mergeOptions$3({
	      createEl: false
	    }, options);
	    _this = _Component.call(this, player, options_, ready) || this; // If there are no sources when the player is initialized,
	    // load the first supported playback technology.
	
	    if (!options.playerOptions.sources || options.playerOptions.sources.length === 0) {
	      for (var i = 0, j = options.playerOptions.techOrder; i < j.length; i++) {
	        var techName = toTitleCase$1(j[i]);
	        var tech = Tech.getTech(techName); // Support old behavior of techs being registered as components.
	        // Remove once that deprecated behavior is removed.
	
	        if (!techName) {
	          tech = Component$1.getComponent(techName);
	        } // Check if the browser supports this technology
	
	
	        if (tech && tech.isSupported()) {
	          player.loadTech_(techName);
	          break;
	        }
	      }
	    } else {
	      // Loop through playback technologies (e.g. HTML5) and check for support.
	      // Then load the best source.
	      // A few assumptions here:
	      //   All playback technologies respect preload false.
	      player.src(options.playerOptions.sources);
	    }
	
	    return _this;
	  }
	
	  return MediaLoader;
	}(Component$1);
	
	Component$1.registerComponent('MediaLoader', MediaLoader);
	
	/**
	 * Component which is clickable or keyboard actionable, but is not a
	 * native HTML button.
	 *
	 * @extends Component
	 */
	
	var ClickableComponent = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ClickableComponent, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param  {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param  {Object} [options]
	   *         The key/value store of component options.
	   *
	   * @param  {function} [options.clickHandler]
	   *         The function to call when the button is clicked / activated
	   *
	   * @param  {string} [options.controlText]
	   *         The text to set on the button
	   *
	   * @param  {string} [options.className]
	   *         A class or space separated list of classes to add the component
	   *
	   */
	  function ClickableComponent(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    if (_this.options_.controlText) {
	      _this.controlText(_this.options_.controlText);
	    }
	
	    _this.handleMouseOver_ = function (e) {
	      return _this.handleMouseOver(e);
	    };
	
	    _this.handleMouseOut_ = function (e) {
	      return _this.handleMouseOut(e);
	    };
	
	    _this.handleClick_ = function (e) {
	      return _this.handleClick(e);
	    };
	
	    _this.handleKeyDown_ = function (e) {
	      return _this.handleKeyDown(e);
	    };
	
	    _this.emitTapEvents();
	
	    _this.enable();
	
	    return _this;
	  }
	  /**
	   * Create the `ClickableComponent`s DOM element.
	   *
	   * @param {string} [tag=div]
	   *        The element's node type.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element.
	   *
	   * @param {Object} [attributes={}]
	   *        An object of attributes that should be set on the element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  var _proto = ClickableComponent.prototype;
	
	  _proto.createEl = function createEl$1(tag, props, attributes) {
	    if (tag === void 0) {
	      tag = 'div';
	    }
	
	    if (props === void 0) {
	      props = {};
	    }
	
	    if (attributes === void 0) {
	      attributes = {};
	    }
	
	    props = assign({
	      className: this.buildCSSClass(),
	      tabIndex: 0
	    }, props);
	
	    if (tag === 'button') {
	      log$1.error("Creating a ClickableComponent with an HTML element of " + tag + " is not supported; use a Button instead.");
	    } // Add ARIA attributes for clickable element which is not a native HTML button
	
	
	    attributes = assign({
	      role: 'button'
	    }, attributes);
	    this.tabIndex_ = props.tabIndex;
	    var el = createEl(tag, props, attributes);
	    el.appendChild(createEl('span', {
	      className: 'vjs-icon-placeholder'
	    }, {
	      'aria-hidden': true
	    }));
	    this.createControlTextEl(el);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    // remove controlTextEl_ on dispose
	    this.controlTextEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Create a control text element on this `ClickableComponent`
	   *
	   * @param {Element} [el]
	   *        Parent element for the control text.
	   *
	   * @return {Element}
	   *         The control text element that gets created.
	   */
	  ;
	
	  _proto.createControlTextEl = function createControlTextEl(el) {
	    this.controlTextEl_ = createEl('span', {
	      className: 'vjs-control-text'
	    }, {
	      // let the screen reader user know that the text of the element may change
	      'aria-live': 'polite'
	    });
	
	    if (el) {
	      el.appendChild(this.controlTextEl_);
	    }
	
	    this.controlText(this.controlText_, el);
	    return this.controlTextEl_;
	  }
	  /**
	   * Get or set the localize text to use for the controls on the `ClickableComponent`.
	   *
	   * @param {string} [text]
	   *        Control text for element.
	   *
	   * @param {Element} [el=this.el()]
	   *        Element to set the title on.
	   *
	   * @return {string}
	   *         - The control text when getting
	   */
	  ;
	
	  _proto.controlText = function controlText(text, el) {
	    if (el === void 0) {
	      el = this.el();
	    }
	
	    if (text === undefined) {
	      return this.controlText_ || 'Need Text';
	    }
	
	    var localizedText = this.localize(text);
	    this.controlText_ = text;
	    textContent(this.controlTextEl_, localizedText);
	
	    if (!this.nonIconControl && !this.player_.options_.noUITitleAttributes) {
	      // Set title attribute if only an icon is shown
	      el.setAttribute('title', localizedText);
	    }
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-control vjs-button " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Enable this `ClickableComponent`
	   */
	  ;
	
	  _proto.enable = function enable() {
	    if (!this.enabled_) {
	      this.enabled_ = true;
	      this.removeClass('vjs-disabled');
	      this.el_.setAttribute('aria-disabled', 'false');
	
	      if (typeof this.tabIndex_ !== 'undefined') {
	        this.el_.setAttribute('tabIndex', this.tabIndex_);
	      }
	
	      this.on(['tap', 'click'], this.handleClick_);
	      this.on('keydown', this.handleKeyDown_);
	    }
	  }
	  /**
	   * Disable this `ClickableComponent`
	   */
	  ;
	
	  _proto.disable = function disable() {
	    this.enabled_ = false;
	    this.addClass('vjs-disabled');
	    this.el_.setAttribute('aria-disabled', 'true');
	
	    if (typeof this.tabIndex_ !== 'undefined') {
	      this.el_.removeAttribute('tabIndex');
	    }
	
	    this.off('mouseover', this.handleMouseOver_);
	    this.off('mouseout', this.handleMouseOut_);
	    this.off(['tap', 'click'], this.handleClick_);
	    this.off('keydown', this.handleKeyDown_);
	  }
	  /**
	   * Handles language change in ClickableComponent for the player in components
	   *
	   *
	   */
	  ;
	
	  _proto.handleLanguagechange = function handleLanguagechange() {
	    this.controlText(this.controlText_);
	  }
	  /**
	   * Event handler that is called when a `ClickableComponent` receives a
	   * `click` or `tap` event.
	   *
	   * @param {EventTarget~Event} event
	   *        The `tap` or `click` event that caused this function to be called.
	   *
	   * @listens tap
	   * @listens click
	   * @abstract
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (this.options_.clickHandler) {
	      this.options_.clickHandler.call(this, arguments);
	    }
	  }
	  /**
	   * Event handler that is called when a `ClickableComponent` receives a
	   * `keydown` event.
	   *
	   * By default, if the key is Space or Enter, it will trigger a `click` event.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Support Space or Enter key operation to fire a click event. Also,
	    // prevent the event from propagating through the DOM and triggering
	    // Player hotkeys.
	    if (keycode__default['default'].isEventKey(event, 'Space') || keycode__default['default'].isEventKey(event, 'Enter')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.trigger('click');
	    } else {
	      // Pass keypress handling up for unsupported keys
	      _Component.prototype.handleKeyDown.call(this, event);
	    }
	  };
	
	  return ClickableComponent;
	}(Component$1);
	
	Component$1.registerComponent('ClickableComponent', ClickableComponent);
	
	/**
	 * A `ClickableComponent` that handles showing the poster image for the player.
	 *
	 * @extends ClickableComponent
	 */
	
	var PosterImage = /*#__PURE__*/function (_ClickableComponent) {
	  _inheritsLoose__default['default'](PosterImage, _ClickableComponent);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should attach to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PosterImage(player, options) {
	    var _this;
	
	    _this = _ClickableComponent.call(this, player, options) || this;
	
	    _this.update();
	
	    _this.update_ = function (e) {
	      return _this.update(e);
	    };
	
	    player.on('posterchange', _this.update_);
	    return _this;
	  }
	  /**
	   * Clean up and dispose of the `PosterImage`.
	   */
	
	
	  var _proto = PosterImage.prototype;
	
	  _proto.dispose = function dispose() {
	    this.player().off('posterchange', this.update_);
	
	    _ClickableComponent.prototype.dispose.call(this);
	  }
	  /**
	   * Create the `PosterImage`s DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl$1() {
	    var el = createEl('div', {
	      className: 'vjs-poster',
	      // Don't want poster to be tabbable.
	      tabIndex: -1
	    });
	    return el;
	  }
	  /**
	   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
	   *
	   * @listens Player#posterchange
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `Player#posterchange` event that triggered this function.
	   */
	  ;
	
	  _proto.update = function update(event) {
	    var url = this.player().poster();
	    this.setSrc(url); // If there's no poster source we should display:none on this component
	    // so it's not still clickable or right-clickable
	
	    if (url) {
	      this.show();
	    } else {
	      this.hide();
	    }
	  }
	  /**
	   * Set the source of the `PosterImage` depending on the display method.
	   *
	   * @param {string} url
	   *        The URL to the source for the `PosterImage`.
	   */
	  ;
	
	  _proto.setSrc = function setSrc(url) {
	    var backgroundImage = ''; // Any falsy value should stay as an empty string, otherwise
	    // this will throw an extra error
	
	    if (url) {
	      backgroundImage = "url(\"" + url + "\")";
	    }
	
	    this.el_.style.backgroundImage = backgroundImage;
	  }
	  /**
	   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
	   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
	   *
	   * @listens tap
	   * @listens click
	   * @listens keydown
	   *
	   * @param {EventTarget~Event} event
	   +        The `click`, `tap` or `keydown` event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    // We don't want a click to trigger playback when controls are disabled
	    if (!this.player_.controls()) {
	      return;
	    }
	
	    var sourceIsEncrypted = this.player_.usingPlugin('eme') && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
	
	    if (this.player_.tech(true) && // We've observed a bug in IE and Edge when playing back DRM content where
	    // calling .focus() on the video element causes the video to go black,
	    // so we avoid it in that specific case
	    !((IE_VERSION || IS_EDGE) && sourceIsEncrypted)) {
	      this.player_.tech(true).focus();
	    }
	
	    if (this.player_.paused()) {
	      silencePromise(this.player_.play());
	    } else {
	      this.player_.pause();
	    }
	  };
	
	  return PosterImage;
	}(ClickableComponent);
	
	Component$1.registerComponent('PosterImage', PosterImage);
	
	var darkGray = '#222';
	var lightGray = '#ccc';
	var fontMap = {
	  monospace: 'monospace',
	  sansSerif: 'sans-serif',
	  serif: 'serif',
	  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
	  monospaceSerif: '"Courier New", monospace',
	  proportionalSansSerif: 'sans-serif',
	  proportionalSerif: 'serif',
	  casual: '"Comic Sans MS", Impact, fantasy',
	  script: '"Monotype Corsiva", cursive',
	  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
	};
	/**
	 * Construct an rgba color from a given hex color code.
	 *
	 * @param {number} color
	 *        Hex number for color, like #f0e or #f604e2.
	 *
	 * @param {number} opacity
	 *        Value for opacity, 0.0 - 1.0.
	 *
	 * @return {string}
	 *         The rgba color that was created, like 'rgba(255, 0, 0, 0.3)'.
	 */
	
	function constructColor(color, opacity) {
	  var hex;
	
	  if (color.length === 4) {
	    // color looks like "#f0e"
	    hex = color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
	  } else if (color.length === 7) {
	    // color looks like "#f604e2"
	    hex = color.slice(1);
	  } else {
	    throw new Error('Invalid color code provided, ' + color + '; must be formatted as e.g. #f0e or #f604e2.');
	  }
	
	  return 'rgba(' + parseInt(hex.slice(0, 2), 16) + ',' + parseInt(hex.slice(2, 4), 16) + ',' + parseInt(hex.slice(4, 6), 16) + ',' + opacity + ')';
	}
	/**
	 * Try to update the style of a DOM element. Some style changes will throw an error,
	 * particularly in IE8. Those should be noops.
	 *
	 * @param {Element} el
	 *        The DOM element to be styled.
	 *
	 * @param {string} style
	 *        The CSS property on the element that should be styled.
	 *
	 * @param {string} rule
	 *        The style rule that should be applied to the property.
	 *
	 * @private
	 */
	
	function tryUpdateStyle(el, style, rule) {
	  try {
	    el.style[style] = rule;
	  } catch (e) {
	    // Satisfies linter.
	    return;
	  }
	}
	/**
	 * The component for displaying text track cues.
	 *
	 * @extends Component
	 */
	
	
	var TextTrackDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](TextTrackDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when `TextTrackDisplay` is ready.
	   */
	  function TextTrackDisplay(player, options, ready) {
	    var _this;
	
	    _this = _Component.call(this, player, options, ready) || this;
	
	    var updateDisplayHandler = function updateDisplayHandler(e) {
	      return _this.updateDisplay(e);
	    };
	
	    player.on('loadstart', function (e) {
	      return _this.toggleDisplay(e);
	    });
	    player.on('texttrackchange', updateDisplayHandler);
	    player.on('loadedmetadata', function (e) {
	      return _this.preselectTrack(e);
	    }); // This used to be called during player init, but was causing an error
	    // if a track should show by default and the display hadn't loaded yet.
	    // Should probably be moved to an external track loader when we support
	    // tracks that don't need a display.
	
	    player.ready(bind(_assertThisInitialized__default['default'](_this), function () {
	      if (player.tech_ && player.tech_.featuresNativeTextTracks) {
	        this.hide();
	        return;
	      }
	
	      player.on('fullscreenchange', updateDisplayHandler);
	      player.on('playerresize', updateDisplayHandler);
	      window__default['default'].addEventListener('orientationchange', updateDisplayHandler);
	      player.on('dispose', function () {
	        return window__default['default'].removeEventListener('orientationchange', updateDisplayHandler);
	      });
	      var tracks = this.options_.playerOptions.tracks || [];
	
	      for (var i = 0; i < tracks.length; i++) {
	        this.player_.addRemoteTextTrack(tracks[i], true);
	      }
	
	      this.preselectTrack();
	    }));
	    return _this;
	  }
	  /**
	  * Preselect a track following this precedence:
	  * - matches the previously selected {@link TextTrack}'s language and kind
	  * - matches the previously selected {@link TextTrack}'s language only
	  * - is the first default captions track
	  * - is the first default descriptions track
	  *
	  * @listens Player#loadstart
	  */
	
	
	  var _proto = TextTrackDisplay.prototype;
	
	  _proto.preselectTrack = function preselectTrack() {
	    var modes = {
	      captions: 1,
	      subtitles: 1
	    };
	    var trackList = this.player_.textTracks();
	    var userPref = this.player_.cache_.selectedLanguage;
	    var firstDesc;
	    var firstCaptions;
	    var preferredTrack;
	
	    for (var i = 0; i < trackList.length; i++) {
	      var track = trackList[i];
	
	      if (userPref && userPref.enabled && userPref.language && userPref.language === track.language && track.kind in modes) {
	        // Always choose the track that matches both language and kind
	        if (track.kind === userPref.kind) {
	          preferredTrack = track; // or choose the first track that matches language
	        } else if (!preferredTrack) {
	          preferredTrack = track;
	        } // clear everything if offTextTrackMenuItem was clicked
	
	      } else if (userPref && !userPref.enabled) {
	        preferredTrack = null;
	        firstDesc = null;
	        firstCaptions = null;
	      } else if (track["default"]) {
	        if (track.kind === 'descriptions' && !firstDesc) {
	          firstDesc = track;
	        } else if (track.kind in modes && !firstCaptions) {
	          firstCaptions = track;
	        }
	      }
	    } // The preferredTrack matches the user preference and takes
	    // precedence over all the other tracks.
	    // So, display the preferredTrack before the first default track
	    // and the subtitles/captions track before the descriptions track
	
	
	    if (preferredTrack) {
	      preferredTrack.mode = 'showing';
	    } else if (firstCaptions) {
	      firstCaptions.mode = 'showing';
	    } else if (firstDesc) {
	      firstDesc.mode = 'showing';
	    }
	  }
	  /**
	   * Turn display of {@link TextTrack}'s from the current state into the other state.
	   * There are only two states:
	   * - 'shown'
	   * - 'hidden'
	   *
	   * @listens Player#loadstart
	   */
	  ;
	
	  _proto.toggleDisplay = function toggleDisplay() {
	    if (this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  }
	  /**
	   * Create the {@link Component}'s DOM element.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-text-track-display'
	    }, {
	      'translate': 'yes',
	      'aria-live': 'off',
	      'aria-atomic': 'true'
	    });
	  }
	  /**
	   * Clear all displayed {@link TextTrack}s.
	   */
	  ;
	
	  _proto.clearDisplay = function clearDisplay() {
	    if (typeof window__default['default'].WebVTT === 'function') {
	      window__default['default'].WebVTT.processCues(window__default['default'], [], this.el_);
	    }
	  }
	  /**
	   * Update the displayed TextTrack when a either a {@link Player#texttrackchange} or
	   * a {@link Player#fullscreenchange} is fired.
	   *
	   * @listens Player#texttrackchange
	   * @listens Player#fullscreenchange
	   */
	  ;
	
	  _proto.updateDisplay = function updateDisplay() {
	    var tracks = this.player_.textTracks();
	    var allowMultipleShowingTracks = this.options_.allowMultipleShowingTracks;
	    this.clearDisplay();
	
	    if (allowMultipleShowingTracks) {
	      var showingTracks = [];
	
	      for (var _i = 0; _i < tracks.length; ++_i) {
	        var track = tracks[_i];
	
	        if (track.mode !== 'showing') {
	          continue;
	        }
	
	        showingTracks.push(track);
	      }
	
	      this.updateForTrack(showingTracks);
	      return;
	    } //  Track display prioritization model: if multiple tracks are 'showing',
	    //  display the first 'subtitles' or 'captions' track which is 'showing',
	    //  otherwise display the first 'descriptions' track which is 'showing'
	
	
	    var descriptionsTrack = null;
	    var captionsSubtitlesTrack = null;
	    var i = tracks.length;
	
	    while (i--) {
	      var _track = tracks[i];
	
	      if (_track.mode === 'showing') {
	        if (_track.kind === 'descriptions') {
	          descriptionsTrack = _track;
	        } else {
	          captionsSubtitlesTrack = _track;
	        }
	      }
	    }
	
	    if (captionsSubtitlesTrack) {
	      if (this.getAttribute('aria-live') !== 'off') {
	        this.setAttribute('aria-live', 'off');
	      }
	
	      this.updateForTrack(captionsSubtitlesTrack);
	    } else if (descriptionsTrack) {
	      if (this.getAttribute('aria-live') !== 'assertive') {
	        this.setAttribute('aria-live', 'assertive');
	      }
	
	      this.updateForTrack(descriptionsTrack);
	    }
	  }
	  /**
	   * Style {@Link TextTrack} activeCues according to {@Link TextTrackSettings}.
	   *
	   * @param {TextTrack} track
	   *        Text track object containing active cues to style.
	   */
	  ;
	
	  _proto.updateDisplayState = function updateDisplayState(track) {
	    var overrides = this.player_.textTrackSettings.getValues();
	    var cues = track.activeCues;
	    var i = cues.length;
	
	    while (i--) {
	      var cue = cues[i];
	
	      if (!cue) {
	        continue;
	      }
	
	      var cueDiv = cue.displayState;
	
	      if (overrides.color) {
	        cueDiv.firstChild.style.color = overrides.color;
	      }
	
	      if (overrides.textOpacity) {
	        tryUpdateStyle(cueDiv.firstChild, 'color', constructColor(overrides.color || '#fff', overrides.textOpacity));
	      }
	
	      if (overrides.backgroundColor) {
	        cueDiv.firstChild.style.backgroundColor = overrides.backgroundColor;
	      }
	
	      if (overrides.backgroundOpacity) {
	        tryUpdateStyle(cueDiv.firstChild, 'backgroundColor', constructColor(overrides.backgroundColor || '#000', overrides.backgroundOpacity));
	      }
	
	      if (overrides.windowColor) {
	        if (overrides.windowOpacity) {
	          tryUpdateStyle(cueDiv, 'backgroundColor', constructColor(overrides.windowColor, overrides.windowOpacity));
	        } else {
	          cueDiv.style.backgroundColor = overrides.windowColor;
	        }
	      }
	
	      if (overrides.edgeStyle) {
	        if (overrides.edgeStyle === 'dropshadow') {
	          cueDiv.firstChild.style.textShadow = "2px 2px 3px " + darkGray + ", 2px 2px 4px " + darkGray + ", 2px 2px 5px " + darkGray;
	        } else if (overrides.edgeStyle === 'raised') {
	          cueDiv.firstChild.style.textShadow = "1px 1px " + darkGray + ", 2px 2px " + darkGray + ", 3px 3px " + darkGray;
	        } else if (overrides.edgeStyle === 'depressed') {
	          cueDiv.firstChild.style.textShadow = "1px 1px " + lightGray + ", 0 1px " + lightGray + ", -1px -1px " + darkGray + ", 0 -1px " + darkGray;
	        } else if (overrides.edgeStyle === 'uniform') {
	          cueDiv.firstChild.style.textShadow = "0 0 4px " + darkGray + ", 0 0 4px " + darkGray + ", 0 0 4px " + darkGray + ", 0 0 4px " + darkGray;
	        }
	      }
	
	      if (overrides.fontPercent && overrides.fontPercent !== 1) {
	        var fontSize = window__default['default'].parseFloat(cueDiv.style.fontSize);
	        cueDiv.style.fontSize = fontSize * overrides.fontPercent + 'px';
	        cueDiv.style.height = 'auto';
	        cueDiv.style.top = 'auto';
	      }
	
	      if (overrides.fontFamily && overrides.fontFamily !== 'default') {
	        if (overrides.fontFamily === 'small-caps') {
	          cueDiv.firstChild.style.fontVariant = 'small-caps';
	        } else {
	          cueDiv.firstChild.style.fontFamily = fontMap[overrides.fontFamily];
	        }
	      }
	    }
	  }
	  /**
	   * Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
	   *
	   * @param {TextTrack|TextTrack[]} tracks
	   *        Text track object or text track array to be added to the list.
	   */
	  ;
	
	  _proto.updateForTrack = function updateForTrack(tracks) {
	    if (!Array.isArray(tracks)) {
	      tracks = [tracks];
	    }
	
	    if (typeof window__default['default'].WebVTT !== 'function' || tracks.every(function (track) {
	      return !track.activeCues;
	    })) {
	      return;
	    }
	
	    var cues = []; // push all active track cues
	
	    for (var i = 0; i < tracks.length; ++i) {
	      var track = tracks[i];
	
	      for (var j = 0; j < track.activeCues.length; ++j) {
	        cues.push(track.activeCues[j]);
	      }
	    } // removes all cues before it processes new ones
	
	
	    window__default['default'].WebVTT.processCues(window__default['default'], cues, this.el_); // add unique class to each language text track & add settings styling if necessary
	
	    for (var _i2 = 0; _i2 < tracks.length; ++_i2) {
	      var _track2 = tracks[_i2];
	
	      for (var _j = 0; _j < _track2.activeCues.length; ++_j) {
	        var cueEl = _track2.activeCues[_j].displayState;
	        addClass(cueEl, 'vjs-text-track-cue');
	        addClass(cueEl, 'vjs-text-track-cue-' + (_track2.language ? _track2.language : _i2));
	
	        if (_track2.language) {
	          setAttribute(cueEl, 'lang', _track2.language);
	        }
	      }
	
	      if (this.player_.textTrackSettings) {
	        this.updateDisplayState(_track2);
	      }
	    }
	  };
	
	  return TextTrackDisplay;
	}(Component$1);
	
	Component$1.registerComponent('TextTrackDisplay', TextTrackDisplay);
	
	/**
	 * A loading spinner for use during waiting/loading events.
	 *
	 * @extends Component
	 */
	
	var LoadingSpinner = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](LoadingSpinner, _Component);
	
	  function LoadingSpinner() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = LoadingSpinner.prototype;
	
	  /**
	   * Create the `LoadingSpinner`s DOM element.
	   *
	   * @return {Element}
	   *         The dom element that gets created.
	   */
	  _proto.createEl = function createEl$1() {
	    var isAudio = this.player_.isAudio();
	    var playerType = this.localize(isAudio ? 'Audio Player' : 'Video Player');
	    var controlText = createEl('span', {
	      className: 'vjs-control-text',
	      textContent: this.localize('{1} is loading.', [playerType])
	    });
	
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-loading-spinner',
	      dir: 'ltr'
	    });
	
	    el.appendChild(controlText);
	    return el;
	  };
	
	  return LoadingSpinner;
	}(Component$1);
	
	Component$1.registerComponent('LoadingSpinner', LoadingSpinner);
	
	/**
	 * Base class for all buttons.
	 *
	 * @extends ClickableComponent
	 */
	
	var Button = /*#__PURE__*/function (_ClickableComponent) {
	  _inheritsLoose__default['default'](Button, _ClickableComponent);
	
	  function Button() {
	    return _ClickableComponent.apply(this, arguments) || this;
	  }
	
	  var _proto = Button.prototype;
	
	  /**
	   * Create the `Button`s DOM element.
	   *
	   * @param {string} [tag="button"]
	   *        The element's node type. This argument is IGNORED: no matter what
	   *        is passed, it will always create a `button` element.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element.
	   *
	   * @param {Object} [attributes={}]
	   *        An object of attributes that should be set on the element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  _proto.createEl = function createEl$1(tag, props, attributes) {
	    if (props === void 0) {
	      props = {};
	    }
	
	    if (attributes === void 0) {
	      attributes = {};
	    }
	
	    tag = 'button';
	    props = assign({
	      className: this.buildCSSClass()
	    }, props); // Add attributes for button element
	
	    attributes = assign({
	      // Necessary since the default button type is "submit"
	      type: 'button'
	    }, attributes);
	
	    var el = createEl(tag, props, attributes);
	
	    el.appendChild(createEl('span', {
	      className: 'vjs-icon-placeholder'
	    }, {
	      'aria-hidden': true
	    }));
	    this.createControlTextEl(el);
	    return el;
	  }
	  /**
	   * Add a child `Component` inside of this `Button`.
	   *
	   * @param {string|Component} child
	   *        The name or instance of a child to add.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of options that will get passed to children of
	   *        the child.
	   *
	   * @return {Component}
	   *         The `Component` that gets added as a child. When using a string the
	   *         `Component` will get created by this process.
	   *
	   * @deprecated since version 5
	   */
	  ;
	
	  _proto.addChild = function addChild(child, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var className = this.constructor.name;
	    log$1.warn("Adding an actionable (user controllable) child to a Button (" + className + ") is not supported; use a ClickableComponent instead."); // Avoid the error message generated by ClickableComponent's addChild method
	
	    return Component$1.prototype.addChild.call(this, child, options);
	  }
	  /**
	   * Enable the `Button` element so that it can be activated or clicked. Use this with
	   * {@link Button#disable}.
	   */
	  ;
	
	  _proto.enable = function enable() {
	    _ClickableComponent.prototype.enable.call(this);
	
	    this.el_.removeAttribute('disabled');
	  }
	  /**
	   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
	   * {@link Button#enable}.
	   */
	  ;
	
	  _proto.disable = function disable() {
	    _ClickableComponent.prototype.disable.call(this);
	
	    this.el_.setAttribute('disabled', 'disabled');
	  }
	  /**
	   * This gets called when a `Button` has focus and `keydown` is triggered via a key
	   * press.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to get called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Ignore Space or Enter key operation, which is handled by the browser for
	    // a button - though not for its super class, ClickableComponent. Also,
	    // prevent the event from propagating through the DOM and triggering Player
	    // hotkeys. We do not preventDefault here because we _want_ the browser to
	    // handle it.
	    if (keycode__default['default'].isEventKey(event, 'Space') || keycode__default['default'].isEventKey(event, 'Enter')) {
	      event.stopPropagation();
	      return;
	    } // Pass keypress handling up for unsupported keys
	
	
	    _ClickableComponent.prototype.handleKeyDown.call(this, event);
	  };
	
	  return Button;
	}(ClickableComponent);
	
	Component$1.registerComponent('Button', Button);
	
	/**
	 * The initial play button that shows before the video has played. The hiding of the
	 * `BigPlayButton` get done via CSS and `Player` states.
	 *
	 * @extends Button
	 */
	
	var BigPlayButton = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](BigPlayButton, _Button);
	
	  function BigPlayButton(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	    _this.mouseused_ = false;
	
	    _this.on('mousedown', function (e) {
	      return _this.handleMouseDown(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
	   */
	
	
	  var _proto = BigPlayButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return 'vjs-big-play-button';
	  }
	  /**
	   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
	   * for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    var playPromise = this.player_.play(); // exit early if clicked via the mouse
	
	    if (this.mouseused_ && event.clientX && event.clientY) {
	      var sourceIsEncrypted = this.player_.usingPlugin('eme') && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
	      silencePromise(playPromise);
	
	      if (this.player_.tech(true) && // We've observed a bug in IE and Edge when playing back DRM content where
	      // calling .focus() on the video element causes the video to go black,
	      // so we avoid it in that specific case
	      !((IE_VERSION || IS_EDGE) && sourceIsEncrypted)) {
	        this.player_.tech(true).focus();
	      }
	
	      return;
	    }
	
	    var cb = this.player_.getChild('controlBar');
	    var playToggle = cb && cb.getChild('playToggle');
	
	    if (!playToggle) {
	      this.player_.tech(true).focus();
	      return;
	    }
	
	    var playFocus = function playFocus() {
	      return playToggle.focus();
	    };
	
	    if (isPromise(playPromise)) {
	      playPromise.then(playFocus, function () {});
	    } else {
	      this.setTimeout(playFocus, 1);
	    }
	  };
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    this.mouseused_ = false;
	
	    _Button.prototype.handleKeyDown.call(this, event);
	  };
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    this.mouseused_ = true;
	  };
	
	  return BigPlayButton;
	}(Button);
	/**
	 * The text that should display over the `BigPlayButton`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	BigPlayButton.prototype.controlText_ = 'Play Video';
	Component$1.registerComponent('BigPlayButton', BigPlayButton);
	
	/**
	 * The `CloseButton` is a `{@link Button}` that fires a `close` event when
	 * it gets clicked.
	 *
	 * @extends Button
	 */
	
	var CloseButton = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](CloseButton, _Button);
	
	  /**
	  * Creates an instance of the this class.
	  *
	  * @param  {Player} player
	  *         The `Player` that this class should be attached to.
	  *
	  * @param  {Object} [options]
	  *         The key/value store of player options.
	  */
	  function CloseButton(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	
	    _this.controlText(options && options.controlText || _this.localize('Close'));
	
	    return _this;
	  }
	  /**
	  * Builds the default DOM `className`.
	  *
	  * @return {string}
	  *         The DOM `className` for this object.
	  */
	
	
	  var _proto = CloseButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-close-button " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * This gets called when a `CloseButton` gets clicked. See
	   * {@link ClickableComponent#handleClick} for more information on when
	   * this will be triggered
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   * @fires CloseButton#close
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    /**
	     * Triggered when the a `CloseButton` is clicked.
	     *
	     * @event CloseButton#close
	     * @type {EventTarget~Event}
	     *
	     * @property {boolean} [bubbles=false]
	     *           set to false so that the close event does not
	     *           bubble up to parents if there is no listener
	     */
	    this.trigger({
	      type: 'close',
	      bubbles: false
	    });
	  }
	  /**
	   * Event handler that is called when a `CloseButton` receives a
	   * `keydown` event.
	   *
	   * By default, if the key is Esc, it will trigger a `click` event.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Esc button will trigger `click` event
	    if (keycode__default['default'].isEventKey(event, 'Esc')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.trigger('click');
	    } else {
	      // Pass keypress handling up for unsupported keys
	      _Button.prototype.handleKeyDown.call(this, event);
	    }
	  };
	
	  return CloseButton;
	}(Button);
	
	Component$1.registerComponent('CloseButton', CloseButton);
	
	/**
	 * Button to toggle between play and pause.
	 *
	 * @extends Button
	 */
	
	var PlayToggle = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](PlayToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function PlayToggle(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _Button.call(this, player, options) || this; // show or hide replay icon
	
	    options.replay = options.replay === undefined || options.replay;
	
	    _this.on(player, 'play', function (e) {
	      return _this.handlePlay(e);
	    });
	
	    _this.on(player, 'pause', function (e) {
	      return _this.handlePause(e);
	    });
	
	    if (options.replay) {
	      _this.on(player, 'ended', function (e) {
	        return _this.handleEnded(e);
	      });
	    }
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = PlayToggle.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-play-control " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * This gets called when an `PlayToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (this.player_.paused()) {
	      silencePromise(this.player_.play());
	    } else {
	      this.player_.pause();
	    }
	  }
	  /**
	   * This gets called once after the video has ended and the user seeks so that
	   * we can change the replay button back to a play button.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#seeked
	   */
	  ;
	
	  _proto.handleSeeked = function handleSeeked(event) {
	    this.removeClass('vjs-ended');
	
	    if (this.player_.paused()) {
	      this.handlePause(event);
	    } else {
	      this.handlePlay(event);
	    }
	  }
	  /**
	   * Add the vjs-playing class to the element so it can change appearance.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#play
	   */
	  ;
	
	  _proto.handlePlay = function handlePlay(event) {
	    this.removeClass('vjs-ended');
	    this.removeClass('vjs-paused');
	    this.addClass('vjs-playing'); // change the button text to "Pause"
	
	    this.controlText('Pause');
	  }
	  /**
	   * Add the vjs-paused class to the element so it can change appearance.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#pause
	   */
	  ;
	
	  _proto.handlePause = function handlePause(event) {
	    this.removeClass('vjs-playing');
	    this.addClass('vjs-paused'); // change the button text to "Play"
	
	    this.controlText('Play');
	  }
	  /**
	   * Add the vjs-ended class to the element so it can change appearance
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#ended
	   */
	  ;
	
	  _proto.handleEnded = function handleEnded(event) {
	    var _this2 = this;
	
	    this.removeClass('vjs-playing');
	    this.addClass('vjs-ended'); // change the button text to "Replay"
	
	    this.controlText('Replay'); // on the next seek remove the replay button
	
	    this.one(this.player_, 'seeked', function (e) {
	      return _this2.handleSeeked(e);
	    });
	  };
	
	  return PlayToggle;
	}(Button);
	/**
	 * The text that should display over the `PlayToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlayToggle.prototype.controlText_ = 'Play';
	Component$1.registerComponent('PlayToggle', PlayToggle);
	
	/**
	 * @file format-time.js
	 * @module format-time
	 */
	
	/**
	 * Format seconds as a time string, H:MM:SS or M:SS. Supplying a guide (in
	 * seconds) will force a number of leading zeros to cover the length of the
	 * guide.
	 *
	 * @private
	 * @param  {number} seconds
	 *         Number of seconds to be turned into a string
	 *
	 * @param  {number} guide
	 *         Number (in seconds) to model the string after
	 *
	 * @return {string}
	 *         Time formatted as H:MM:SS or M:SS
	 */
	var defaultImplementation = function defaultImplementation(seconds, guide) {
	  seconds = seconds < 0 ? 0 : seconds;
	  var s = Math.floor(seconds % 60);
	  var m = Math.floor(seconds / 60 % 60);
	  var h = Math.floor(seconds / 3600);
	  var gm = Math.floor(guide / 60 % 60);
	  var gh = Math.floor(guide / 3600); // handle invalid times
	
	  if (isNaN(seconds) || seconds === Infinity) {
	    // '-' is false for all relational operators (e.g. <, >=) so this setting
	    // will add the minimum number of fields specified by the guide
	    h = m = s = '-';
	  } // Check if we need to show hours
	
	
	  h = h > 0 || gh > 0 ? h + ':' : ''; // If hours are showing, we may need to add a leading zero.
	  // Always show at least one digit of minutes.
	
	  m = ((h || gm >= 10) && m < 10 ? '0' + m : m) + ':'; // Check if leading zero is need for seconds
	
	  s = s < 10 ? '0' + s : s;
	  return h + m + s;
	}; // Internal pointer to the current implementation.
	
	
	var implementation = defaultImplementation;
	/**
	 * Replaces the default formatTime implementation with a custom implementation.
	 *
	 * @param {Function} customImplementation
	 *        A function which will be used in place of the default formatTime
	 *        implementation. Will receive the current time in seconds and the
	 *        guide (in seconds) as arguments.
	 */
	
	function setFormatTime(customImplementation) {
	  implementation = customImplementation;
	}
	/**
	 * Resets formatTime to the default implementation.
	 */
	
	function resetFormatTime() {
	  implementation = defaultImplementation;
	}
	/**
	 * Delegates to either the default time formatting function or a custom
	 * function supplied via `setFormatTime`.
	 *
	 * Formats seconds as a time string (H:MM:SS or M:SS). Supplying a
	 * guide (in seconds) will force a number of leading zeros to cover the
	 * length of the guide.
	 *
	 * @static
	 * @example  formatTime(125, 600) === "02:05"
	 * @param    {number} seconds
	 *           Number of seconds to be turned into a string
	 *
	 * @param    {number} guide
	 *           Number (in seconds) to model the string after
	 *
	 * @return   {string}
	 *           Time formatted as H:MM:SS or M:SS
	 */
	
	function formatTime(seconds, guide) {
	  if (guide === void 0) {
	    guide = seconds;
	  }
	
	  return implementation(seconds, guide);
	}
	
	/**
	 * Displays time information about the video
	 *
	 * @extends Component
	 */
	
	var TimeDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](TimeDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TimeDisplay(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    _this.on(player, ['timeupdate', 'ended'], function (e) {
	      return _this.updateContent(e);
	    });
	
	    _this.updateTextNode_();
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = TimeDisplay.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var className = this.buildCSSClass();
	
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: className + " vjs-time-control vjs-control"
	    });
	
	    var span = createEl('span', {
	      className: 'vjs-control-text',
	      textContent: this.localize(this.labelText_) + "\xA0"
	    }, {
	      role: 'presentation'
	    });
	    el.appendChild(span);
	    this.contentEl_ = createEl('span', {
	      className: className + "-display"
	    }, {
	      // tell screen readers not to automatically read the time as it changes
	      'aria-live': 'off',
	      // span elements have no implicit role, but some screen readers (notably VoiceOver)
	      // treat them as a break between items in the DOM when using arrow keys
	      // (or left-to-right swipes on iOS) to read contents of a page. Using
	      // role='presentation' causes VoiceOver to NOT treat this span as a break.
	      'role': 'presentation'
	    });
	    el.appendChild(this.contentEl_);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.contentEl_ = null;
	    this.textNode_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Updates the time display text node with a new time
	   *
	   * @param {number} [time=0] the time to update to
	   *
	   * @private
	   */
	  ;
	
	  _proto.updateTextNode_ = function updateTextNode_(time) {
	    var _this2 = this;
	
	    if (time === void 0) {
	      time = 0;
	    }
	
	    time = formatTime(time);
	
	    if (this.formattedTime_ === time) {
	      return;
	    }
	
	    this.formattedTime_ = time;
	    this.requestNamedAnimationFrame('TimeDisplay#updateTextNode_', function () {
	      if (!_this2.contentEl_) {
	        return;
	      }
	
	      var oldNode = _this2.textNode_;
	
	      if (oldNode && _this2.contentEl_.firstChild !== oldNode) {
	        oldNode = null;
	        log$1.warn('TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.');
	      }
	
	      _this2.textNode_ = document__default['default'].createTextNode(_this2.formattedTime_);
	
	      if (!_this2.textNode_) {
	        return;
	      }
	
	      if (oldNode) {
	        _this2.contentEl_.replaceChild(_this2.textNode_, oldNode);
	      } else {
	        _this2.contentEl_.appendChild(_this2.textNode_);
	      }
	    });
	  }
	  /**
	   * To be filled out in the child class, should update the displayed time
	   * in accordance with the fact that the current time has changed.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate`  event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   */
	  ;
	
	  _proto.updateContent = function updateContent(event) {};
	
	  return TimeDisplay;
	}(Component$1);
	/**
	 * The text that is added to the `TimeDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	TimeDisplay.prototype.labelText_ = 'Time';
	/**
	 * The text that should display over the `TimeDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	
	TimeDisplay.prototype.controlText_ = 'Time';
	Component$1.registerComponent('TimeDisplay', TimeDisplay);
	
	/**
	 * Displays the current time
	 *
	 * @extends Component
	 */
	
	var CurrentTimeDisplay = /*#__PURE__*/function (_TimeDisplay) {
	  _inheritsLoose__default['default'](CurrentTimeDisplay, _TimeDisplay);
	
	  function CurrentTimeDisplay() {
	    return _TimeDisplay.apply(this, arguments) || this;
	  }
	
	  var _proto = CurrentTimeDisplay.prototype;
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  _proto.buildCSSClass = function buildCSSClass() {
	    return 'vjs-current-time';
	  }
	  /**
	   * Update current time display
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` event that caused this function to run.
	   *
	   * @listens Player#timeupdate
	   */
	  ;
	
	  _proto.updateContent = function updateContent(event) {
	    // Allows for smooth scrubbing, when player can't keep up.
	    var time;
	
	    if (this.player_.ended()) {
	      time = this.player_.duration();
	    } else {
	      time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	    }
	
	    this.updateTextNode_(time);
	  };
	
	  return CurrentTimeDisplay;
	}(TimeDisplay);
	/**
	 * The text that is added to the `CurrentTimeDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	CurrentTimeDisplay.prototype.labelText_ = 'Current Time';
	/**
	 * The text that should display over the `CurrentTimeDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	
	CurrentTimeDisplay.prototype.controlText_ = 'Current Time';
	Component$1.registerComponent('CurrentTimeDisplay', CurrentTimeDisplay);
	
	/**
	 * Displays the duration
	 *
	 * @extends Component
	 */
	
	var DurationDisplay = /*#__PURE__*/function (_TimeDisplay) {
	  _inheritsLoose__default['default'](DurationDisplay, _TimeDisplay);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function DurationDisplay(player, options) {
	    var _this;
	
	    _this = _TimeDisplay.call(this, player, options) || this;
	
	    var updateContent = function updateContent(e) {
	      return _this.updateContent(e);
	    }; // we do not want to/need to throttle duration changes,
	    // as they should always display the changed duration as
	    // it has changed
	
	
	    _this.on(player, 'durationchange', updateContent); // Listen to loadstart because the player duration is reset when a new media element is loaded,
	    // but the durationchange on the user agent will not fire.
	    // @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
	
	
	    _this.on(player, 'loadstart', updateContent); // Also listen for timeupdate (in the parent) and loadedmetadata because removing those
	    // listeners could have broken dependent applications/libraries. These
	    // can likely be removed for 7.0.
	
	
	    _this.on(player, 'loadedmetadata', updateContent);
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = DurationDisplay.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return 'vjs-duration';
	  }
	  /**
	   * Update duration time display.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
	   *        this function to be called.
	   *
	   * @listens Player#durationchange
	   * @listens Player#timeupdate
	   * @listens Player#loadedmetadata
	   */
	  ;
	
	  _proto.updateContent = function updateContent(event) {
	    var duration = this.player_.duration();
	    this.updateTextNode_(duration);
	  };
	
	  return DurationDisplay;
	}(TimeDisplay);
	/**
	 * The text that is added to the `DurationDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	DurationDisplay.prototype.labelText_ = 'Duration';
	/**
	 * The text that should display over the `DurationDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	
	DurationDisplay.prototype.controlText_ = 'Duration';
	Component$1.registerComponent('DurationDisplay', DurationDisplay);
	
	/**
	 * The separator between the current time and duration.
	 * Can be hidden if it's not needed in the design.
	 *
	 * @extends Component
	 */
	
	var TimeDivider = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](TimeDivider, _Component);
	
	  function TimeDivider() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = TimeDivider.prototype;
	
	  /**
	   * Create the component's DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  _proto.createEl = function createEl() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-time-control vjs-time-divider'
	    }, {
	      // this element and its contents can be hidden from assistive techs since
	      // it is made extraneous by the announcement of the control text
	      // for the current time and duration displays
	      'aria-hidden': true
	    });
	
	    var div = _Component.prototype.createEl.call(this, 'div');
	
	    var span = _Component.prototype.createEl.call(this, 'span', {
	      textContent: '/'
	    });
	
	    div.appendChild(span);
	    el.appendChild(div);
	    return el;
	  };
	
	  return TimeDivider;
	}(Component$1);
	
	Component$1.registerComponent('TimeDivider', TimeDivider);
	
	/**
	 * Displays the time left in the video
	 *
	 * @extends Component
	 */
	
	var RemainingTimeDisplay = /*#__PURE__*/function (_TimeDisplay) {
	  _inheritsLoose__default['default'](RemainingTimeDisplay, _TimeDisplay);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function RemainingTimeDisplay(player, options) {
	    var _this;
	
	    _this = _TimeDisplay.call(this, player, options) || this;
	
	    _this.on(player, 'durationchange', function (e) {
	      return _this.updateContent(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = RemainingTimeDisplay.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return 'vjs-remaining-time';
	  }
	  /**
	   * Create the `Component`'s DOM element with the "minus" characted prepend to the time
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl$1() {
	    var el = _TimeDisplay.prototype.createEl.call(this);
	
	    if (this.options_.displayNegative !== false) {
	      el.insertBefore(createEl('span', {}, {
	        'aria-hidden': true
	      }, '-'), this.contentEl_);
	    }
	
	    return el;
	  }
	  /**
	   * Update remaining time display.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` or `durationchange` event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   * @listens Player#durationchange
	   */
	  ;
	
	  _proto.updateContent = function updateContent(event) {
	    if (typeof this.player_.duration() !== 'number') {
	      return;
	    }
	
	    var time; // @deprecated We should only use remainingTimeDisplay
	    // as of video.js 7
	
	    if (this.player_.ended()) {
	      time = 0;
	    } else if (this.player_.remainingTimeDisplay) {
	      time = this.player_.remainingTimeDisplay();
	    } else {
	      time = this.player_.remainingTime();
	    }
	
	    this.updateTextNode_(time);
	  };
	
	  return RemainingTimeDisplay;
	}(TimeDisplay);
	/**
	 * The text that is added to the `RemainingTimeDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	RemainingTimeDisplay.prototype.labelText_ = 'Remaining Time';
	/**
	 * The text that should display over the `RemainingTimeDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	
	RemainingTimeDisplay.prototype.controlText_ = 'Remaining Time';
	Component$1.registerComponent('RemainingTimeDisplay', RemainingTimeDisplay);
	
	/**
	 * Displays the live indicator when duration is Infinity.
	 *
	 * @extends Component
	 */
	
	var LiveDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](LiveDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function LiveDisplay(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    _this.updateShowing();
	
	    _this.on(_this.player(), 'durationchange', function (e) {
	      return _this.updateShowing(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = LiveDisplay.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-live-control vjs-control'
	    });
	
	    this.contentEl_ = createEl('div', {
	      className: 'vjs-live-display'
	    }, {
	      'aria-live': 'off'
	    });
	    this.contentEl_.appendChild(createEl('span', {
	      className: 'vjs-control-text',
	      textContent: this.localize('Stream Type') + "\xA0"
	    }));
	    this.contentEl_.appendChild(document__default['default'].createTextNode(this.localize('LIVE')));
	    el.appendChild(this.contentEl_);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.contentEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
	   * it accordingly
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#durationchange} event that caused this function to run.
	   *
	   * @listens Player#durationchange
	   */
	  ;
	
	  _proto.updateShowing = function updateShowing(event) {
	    if (this.player().duration() === Infinity) {
	      this.show();
	    } else {
	      this.hide();
	    }
	  };
	
	  return LiveDisplay;
	}(Component$1);
	
	Component$1.registerComponent('LiveDisplay', LiveDisplay);
	
	/**
	 * Displays the live indicator when duration is Infinity.
	 *
	 * @extends Component
	 */
	
	var SeekToLive = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](SeekToLive, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function SeekToLive(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	
	    _this.updateLiveEdgeStatus();
	
	    if (_this.player_.liveTracker) {
	      _this.updateLiveEdgeStatusHandler_ = function (e) {
	        return _this.updateLiveEdgeStatus(e);
	      };
	
	      _this.on(_this.player_.liveTracker, 'liveedgechange', _this.updateLiveEdgeStatusHandler_);
	    }
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = SeekToLive.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var el = _Button.prototype.createEl.call(this, 'button', {
	      className: 'vjs-seek-to-live-control vjs-control'
	    });
	
	    this.textEl_ = createEl('span', {
	      className: 'vjs-seek-to-live-text',
	      textContent: this.localize('LIVE')
	    }, {
	      'aria-hidden': 'true'
	    });
	    el.appendChild(this.textEl_);
	    return el;
	  }
	  /**
	   * Update the state of this button if we are at the live edge
	   * or not
	   */
	  ;
	
	  _proto.updateLiveEdgeStatus = function updateLiveEdgeStatus() {
	    // default to live edge
	    if (!this.player_.liveTracker || this.player_.liveTracker.atLiveEdge()) {
	      this.setAttribute('aria-disabled', true);
	      this.addClass('vjs-at-live-edge');
	      this.controlText('Seek to live, currently playing live');
	    } else {
	      this.setAttribute('aria-disabled', false);
	      this.removeClass('vjs-at-live-edge');
	      this.controlText('Seek to live, currently behind live');
	    }
	  }
	  /**
	   * On click bring us as near to the live point as possible.
	   * This requires that we wait for the next `live-seekable-change`
	   * event which will happen every segment length seconds.
	   */
	  ;
	
	  _proto.handleClick = function handleClick() {
	    this.player_.liveTracker.seekToLiveEdge();
	  }
	  /**
	   * Dispose of the element and stop tracking
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    if (this.player_.liveTracker) {
	      this.off(this.player_.liveTracker, 'liveedgechange', this.updateLiveEdgeStatusHandler_);
	    }
	
	    this.textEl_ = null;
	
	    _Button.prototype.dispose.call(this);
	  };
	
	  return SeekToLive;
	}(Button);
	
	SeekToLive.prototype.controlText_ = 'Seek to live, currently playing live';
	Component$1.registerComponent('SeekToLive', SeekToLive);
	
	/**
	 * Keep a number between a min and a max value
	 *
	 * @param {number} number
	 *        The number to clamp
	 *
	 * @param {number} min
	 *        The minimum value
	 * @param {number} max
	 *        The maximum value
	 *
	 * @return {number}
	 *         the clamped number
	 */
	var clamp = function clamp(number, min, max) {
	  number = Number(number);
	  return Math.min(max, Math.max(min, isNaN(number) ? min : number));
	};
	
	/**
	 * The base functionality for a slider. Can be vertical or horizontal.
	 * For instance the volume bar or the seek bar on a video is a slider.
	 *
	 * @extends Component
	 */
	
	var Slider = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Slider, _Component);
	
	  /**
	  * Create an instance of this class
	  *
	  * @param {Player} player
	  *        The `Player` that this class should be attached to.
	  *
	  * @param {Object} [options]
	  *        The key/value store of player options.
	  */
	  function Slider(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    _this.handleMouseDown_ = function (e) {
	      return _this.handleMouseDown(e);
	    };
	
	    _this.handleMouseUp_ = function (e) {
	      return _this.handleMouseUp(e);
	    };
	
	    _this.handleKeyDown_ = function (e) {
	      return _this.handleKeyDown(e);
	    };
	
	    _this.handleClick_ = function (e) {
	      return _this.handleClick(e);
	    };
	
	    _this.handleMouseMove_ = function (e) {
	      return _this.handleMouseMove(e);
	    };
	
	    _this.update_ = function (e) {
	      return _this.update(e);
	    }; // Set property names to bar to match with the child Slider class is looking for
	
	
	    _this.bar = _this.getChild(_this.options_.barName); // Set a horizontal or vertical class on the slider depending on the slider type
	
	    _this.vertical(!!_this.options_.vertical);
	
	    _this.enable();
	
	    return _this;
	  }
	  /**
	   * Are controls are currently enabled for this slider or not.
	   *
	   * @return {boolean}
	   *         true if controls are enabled, false otherwise
	   */
	
	
	  var _proto = Slider.prototype;
	
	  _proto.enabled = function enabled() {
	    return this.enabled_;
	  }
	  /**
	   * Enable controls for this slider if they are disabled
	   */
	  ;
	
	  _proto.enable = function enable() {
	    if (this.enabled()) {
	      return;
	    }
	
	    this.on('mousedown', this.handleMouseDown_);
	    this.on('touchstart', this.handleMouseDown_);
	    this.on('keydown', this.handleKeyDown_);
	    this.on('click', this.handleClick_); // TODO: deprecated, controlsvisible does not seem to be fired
	
	    this.on(this.player_, 'controlsvisible', this.update);
	
	    if (this.playerEvent) {
	      this.on(this.player_, this.playerEvent, this.update);
	    }
	
	    this.removeClass('disabled');
	    this.setAttribute('tabindex', 0);
	    this.enabled_ = true;
	  }
	  /**
	   * Disable controls for this slider if they are enabled
	   */
	  ;
	
	  _proto.disable = function disable() {
	    if (!this.enabled()) {
	      return;
	    }
	
	    var doc = this.bar.el_.ownerDocument;
	    this.off('mousedown', this.handleMouseDown_);
	    this.off('touchstart', this.handleMouseDown_);
	    this.off('keydown', this.handleKeyDown_);
	    this.off('click', this.handleClick_);
	    this.off(this.player_, 'controlsvisible', this.update_);
	    this.off(doc, 'mousemove', this.handleMouseMove_);
	    this.off(doc, 'mouseup', this.handleMouseUp_);
	    this.off(doc, 'touchmove', this.handleMouseMove_);
	    this.off(doc, 'touchend', this.handleMouseUp_);
	    this.removeAttribute('tabindex');
	    this.addClass('disabled');
	
	    if (this.playerEvent) {
	      this.off(this.player_, this.playerEvent, this.update);
	    }
	
	    this.enabled_ = false;
	  }
	  /**
	   * Create the `Slider`s DOM element.
	   *
	   * @param {string} type
	   *        Type of element to create.
	   *
	   * @param {Object} [props={}]
	   *        List of properties in Object form.
	   *
	   * @param {Object} [attributes={}]
	   *        list of attributes in Object form.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl(type, props, attributes) {
	    if (props === void 0) {
	      props = {};
	    }
	
	    if (attributes === void 0) {
	      attributes = {};
	    }
	
	    // Add the slider element class to all sub classes
	    props.className = props.className + ' vjs-slider';
	    props = assign({
	      tabIndex: 0
	    }, props);
	    attributes = assign({
	      'role': 'slider',
	      'aria-valuenow': 0,
	      'aria-valuemin': 0,
	      'aria-valuemax': 100,
	      'tabIndex': 0
	    }, attributes);
	    return _Component.prototype.createEl.call(this, type, props, attributes);
	  }
	  /**
	   * Handle `mousedown` or `touchstart` events on the `Slider`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   * @fires Slider#slideractive
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    var doc = this.bar.el_.ownerDocument;
	
	    if (event.type === 'mousedown') {
	      event.preventDefault();
	    } // Do not call preventDefault() on touchstart in Chrome
	    // to avoid console warnings. Use a 'touch-action: none' style
	    // instead to prevent unintented scrolling.
	    // https://developers.google.com/web/updates/2017/01/scrolling-intervention
	
	
	    if (event.type === 'touchstart' && !IS_CHROME) {
	      event.preventDefault();
	    }
	
	    blockTextSelection();
	    this.addClass('vjs-sliding');
	    /**
	     * Triggered when the slider is in an active state
	     *
	     * @event Slider#slideractive
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('slideractive');
	    this.on(doc, 'mousemove', this.handleMouseMove_);
	    this.on(doc, 'mouseup', this.handleMouseUp_);
	    this.on(doc, 'touchmove', this.handleMouseMove_);
	    this.on(doc, 'touchend', this.handleMouseUp_);
	    this.handleMouseMove(event, true);
	  }
	  /**
	   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
	   * The `mousemove` and `touchmove` events will only only trigger this function during
	   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
	   * {@link Slider#handleMouseUp}.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
	   *        this function
	   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false.
	   *
	   * @listens mousemove
	   * @listens touchmove
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event) {}
	  /**
	   * Handle `mouseup` or `touchend` events on the `Slider`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mouseup` or `touchend` event that triggered this function.
	   *
	   * @listens touchend
	   * @listens mouseup
	   * @fires Slider#sliderinactive
	   */
	  ;
	
	  _proto.handleMouseUp = function handleMouseUp() {
	    var doc = this.bar.el_.ownerDocument;
	    unblockTextSelection();
	    this.removeClass('vjs-sliding');
	    /**
	     * Triggered when the slider is no longer in an active state.
	     *
	     * @event Slider#sliderinactive
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('sliderinactive');
	    this.off(doc, 'mousemove', this.handleMouseMove_);
	    this.off(doc, 'mouseup', this.handleMouseUp_);
	    this.off(doc, 'touchmove', this.handleMouseMove_);
	    this.off(doc, 'touchend', this.handleMouseUp_);
	    this.update();
	  }
	  /**
	   * Update the progress bar of the `Slider`.
	   *
	   * @return {number}
	   *          The percentage of progress the progress bar represents as a
	   *          number from 0 to 1.
	   */
	  ;
	
	  _proto.update = function update() {
	    var _this2 = this;
	
	    // In VolumeBar init we have a setTimeout for update that pops and update
	    // to the end of the execution stack. The player is destroyed before then
	    // update will cause an error
	    // If there's no bar...
	    if (!this.el_ || !this.bar) {
	      return;
	    } // clamp progress between 0 and 1
	    // and only round to four decimal places, as we round to two below
	
	
	    var progress = this.getProgress();
	
	    if (progress === this.progress_) {
	      return progress;
	    }
	
	    this.progress_ = progress;
	    this.requestNamedAnimationFrame('Slider#update', function () {
	      // Set the new bar width or height
	      var sizeKey = _this2.vertical() ? 'height' : 'width'; // Convert to a percentage for css value
	
	      _this2.bar.el().style[sizeKey] = (progress * 100).toFixed(2) + '%';
	    });
	    return progress;
	  }
	  /**
	   * Get the percentage of the bar that should be filled
	   * but clamped and rounded.
	   *
	   * @return {number}
	   *         percentage filled that the slider is
	   */
	  ;
	
	  _proto.getProgress = function getProgress() {
	    return Number(clamp(this.getPercent(), 0, 1).toFixed(4));
	  }
	  /**
	   * Calculate distance for slider
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run.
	   *
	   * @return {number}
	   *         The current position of the Slider.
	   *         - position.x for vertical `Slider`s
	   *         - position.y for horizontal `Slider`s
	   */
	  ;
	
	  _proto.calculateDistance = function calculateDistance(event) {
	    var position = getPointerPosition(this.el_, event);
	
	    if (this.vertical()) {
	      return position.y;
	    }
	
	    return position.x;
	  }
	  /**
	   * Handle a `keydown` event on the `Slider`. Watches for left, rigth, up, and down
	   * arrow keys. This function will only be called when the slider has focus. See
	   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
	   *
	   * @param {EventTarget~Event} event
	   *        the `keydown` event that caused this function to run.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Left and Down Arrows
	    if (keycode__default['default'].isEventKey(event, 'Left') || keycode__default['default'].isEventKey(event, 'Down')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.stepBack(); // Up and Right Arrows
	    } else if (keycode__default['default'].isEventKey(event, 'Right') || keycode__default['default'].isEventKey(event, 'Up')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.stepForward();
	    } else {
	      // Pass keydown handling up for unsupported keys
	      _Component.prototype.handleKeyDown.call(this, event);
	    }
	  }
	  /**
	   * Listener for click events on slider, used to prevent clicks
	   *   from bubbling up to parent elements like button menus.
	   *
	   * @param {Object} event
	   *        Event that caused this object to run
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    event.stopPropagation();
	    event.preventDefault();
	  }
	  /**
	   * Get/set if slider is horizontal for vertical
	   *
	   * @param {boolean} [bool]
	   *        - true if slider is vertical,
	   *        - false is horizontal
	   *
	   * @return {boolean}
	   *         - true if slider is vertical, and getting
	   *         - false if the slider is horizontal, and getting
	   */
	  ;
	
	  _proto.vertical = function vertical(bool) {
	    if (bool === undefined) {
	      return this.vertical_ || false;
	    }
	
	    this.vertical_ = !!bool;
	
	    if (this.vertical_) {
	      this.addClass('vjs-slider-vertical');
	    } else {
	      this.addClass('vjs-slider-horizontal');
	    }
	  };
	
	  return Slider;
	}(Component$1);
	
	Component$1.registerComponent('Slider', Slider);
	
	var percentify = function percentify(time, end) {
	  return clamp(time / end * 100, 0, 100).toFixed(2) + '%';
	};
	/**
	 * Shows loading progress
	 *
	 * @extends Component
	 */
	
	
	var LoadProgressBar = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](LoadProgressBar, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function LoadProgressBar(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.partEls_ = [];
	
	    _this.on(player, 'progress', function (e) {
	      return _this.update(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = LoadProgressBar.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-load-progress'
	    });
	
	    var wrapper = createEl('span', {
	      className: 'vjs-control-text'
	    });
	    var loadedText = createEl('span', {
	      textContent: this.localize('Loaded')
	    });
	    var separator = document__default['default'].createTextNode(': ');
	    this.percentageEl_ = createEl('span', {
	      className: 'vjs-control-text-loaded-percentage',
	      textContent: '0%'
	    });
	    el.appendChild(wrapper);
	    wrapper.appendChild(loadedText);
	    wrapper.appendChild(separator);
	    wrapper.appendChild(this.percentageEl_);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.partEls_ = null;
	    this.percentageEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Update progress bar
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `progress` event that caused this function to run.
	   *
	   * @listens Player#progress
	   */
	  ;
	
	  _proto.update = function update(event) {
	    var _this2 = this;
	
	    this.requestNamedAnimationFrame('LoadProgressBar#update', function () {
	      var liveTracker = _this2.player_.liveTracker;
	
	      var buffered = _this2.player_.buffered();
	
	      var duration = liveTracker && liveTracker.isLive() ? liveTracker.seekableEnd() : _this2.player_.duration();
	
	      var bufferedEnd = _this2.player_.bufferedEnd();
	
	      var children = _this2.partEls_;
	      var percent = percentify(bufferedEnd, duration);
	
	      if (_this2.percent_ !== percent) {
	        // update the width of the progress bar
	        _this2.el_.style.width = percent; // update the control-text
	
	        textContent(_this2.percentageEl_, percent);
	        _this2.percent_ = percent;
	      } // add child elements to represent the individual buffered time ranges
	
	
	      for (var i = 0; i < buffered.length; i++) {
	        var start = buffered.start(i);
	        var end = buffered.end(i);
	        var part = children[i];
	
	        if (!part) {
	          part = _this2.el_.appendChild(createEl());
	          children[i] = part;
	        } //  only update if changed
	
	
	        if (part.dataset.start === start && part.dataset.end === end) {
	          continue;
	        }
	
	        part.dataset.start = start;
	        part.dataset.end = end; // set the percent based on the width of the progress bar (bufferedEnd)
	
	        part.style.left = percentify(start, bufferedEnd);
	        part.style.width = percentify(end - start, bufferedEnd);
	      } // remove unused buffered range elements
	
	
	      for (var _i = children.length; _i > buffered.length; _i--) {
	        _this2.el_.removeChild(children[_i - 1]);
	      }
	
	      children.length = buffered.length;
	    });
	  };
	
	  return LoadProgressBar;
	}(Component$1);
	
	Component$1.registerComponent('LoadProgressBar', LoadProgressBar);
	
	/**
	 * Time tooltips display a time above the progress bar.
	 *
	 * @extends Component
	 */
	
	var TimeTooltip = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](TimeTooltip, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TimeTooltip(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the time tooltip DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = TimeTooltip.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-time-tooltip'
	    }, {
	      'aria-hidden': 'true'
	    });
	  }
	  /**
	   * Updates the position of the time tooltip relative to the `SeekBar`.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   */
	  ;
	
	  _proto.update = function update(seekBarRect, seekBarPoint, content) {
	    var tooltipRect = findPosition(this.el_);
	    var playerRect = getBoundingClientRect(this.player_.el());
	    var seekBarPointPx = seekBarRect.width * seekBarPoint; // do nothing if either rect isn't available
	    // for example, if the player isn't in the DOM for testing
	
	    if (!playerRect || !tooltipRect) {
	      return;
	    } // This is the space left of the `seekBarPoint` available within the bounds
	    // of the player. We calculate any gap between the left edge of the player
	    // and the left edge of the `SeekBar` and add the number of pixels in the
	    // `SeekBar` before hitting the `seekBarPoint`
	
	
	    var spaceLeftOfPoint = seekBarRect.left - playerRect.left + seekBarPointPx; // This is the space right of the `seekBarPoint` available within the bounds
	    // of the player. We calculate the number of pixels from the `seekBarPoint`
	    // to the right edge of the `SeekBar` and add to that any gap between the
	    // right edge of the `SeekBar` and the player.
	
	    var spaceRightOfPoint = seekBarRect.width - seekBarPointPx + (playerRect.right - seekBarRect.right); // This is the number of pixels by which the tooltip will need to be pulled
	    // further to the right to center it over the `seekBarPoint`.
	
	    var pullTooltipBy = tooltipRect.width / 2; // Adjust the `pullTooltipBy` distance to the left or right depending on
	    // the results of the space calculations above.
	
	    if (spaceLeftOfPoint < pullTooltipBy) {
	      pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
	    } else if (spaceRightOfPoint < pullTooltipBy) {
	      pullTooltipBy = spaceRightOfPoint;
	    } // Due to the imprecision of decimal/ratio based calculations and varying
	    // rounding behaviors, there are cases where the spacing adjustment is off
	    // by a pixel or two. This adds insurance to these calculations.
	
	
	    if (pullTooltipBy < 0) {
	      pullTooltipBy = 0;
	    } else if (pullTooltipBy > tooltipRect.width) {
	      pullTooltipBy = tooltipRect.width;
	    } // prevent small width fluctuations within 0.4px from
	    // changing the value below.
	    // This really helps for live to prevent the play
	    // progress time tooltip from jittering
	
	
	    pullTooltipBy = Math.round(pullTooltipBy);
	    this.el_.style.right = "-" + pullTooltipBy + "px";
	    this.write(content);
	  }
	  /**
	   * Write the time to the tooltip DOM element.
	   *
	   * @param {string} content
	   *        The formatted time for the tooltip.
	   */
	  ;
	
	  _proto.write = function write(content) {
	    textContent(this.el_, content);
	  }
	  /**
	   * Updates the position of the time tooltip relative to the `SeekBar`.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   *
	   * @param {number} time
	   *        The time to update the tooltip to, not used during live playback
	   *
	   * @param {Function} cb
	   *        A function that will be called during the request animation frame
	   *        for tooltips that need to do additional animations from the default
	   */
	  ;
	
	  _proto.updateTime = function updateTime(seekBarRect, seekBarPoint, time, cb) {
	    var _this2 = this;
	
	    this.requestNamedAnimationFrame('TimeTooltip#updateTime', function () {
	      var content;
	
	      var duration = _this2.player_.duration();
	
	      if (_this2.player_.liveTracker && _this2.player_.liveTracker.isLive()) {
	        var liveWindow = _this2.player_.liveTracker.liveWindow();
	
	        var secondsBehind = liveWindow - seekBarPoint * liveWindow;
	        content = (secondsBehind < 1 ? '' : '-') + formatTime(secondsBehind, liveWindow);
	      } else {
	        content = formatTime(time, duration);
	      }
	
	      _this2.update(seekBarRect, seekBarPoint, content);
	
	      if (cb) {
	        cb();
	      }
	    });
	  };
	
	  return TimeTooltip;
	}(Component$1);
	
	Component$1.registerComponent('TimeTooltip', TimeTooltip);
	
	/**
	 * Used by {@link SeekBar} to display media playback progress as part of the
	 * {@link ProgressControl}.
	 *
	 * @extends Component
	 */
	
	var PlayProgressBar = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](PlayProgressBar, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlayProgressBar(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the the DOM element for this class.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = PlayProgressBar.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-play-progress vjs-slider-bar'
	    }, {
	      'aria-hidden': 'true'
	    });
	  }
	  /**
	   * Enqueues updates to its own DOM as well as the DOM of its
	   * {@link TimeTooltip} child.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   */
	  ;
	
	  _proto.update = function update(seekBarRect, seekBarPoint) {
	    var timeTooltip = this.getChild('timeTooltip');
	
	    if (!timeTooltip) {
	      return;
	    }
	
	    var time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	    timeTooltip.updateTime(seekBarRect, seekBarPoint, time);
	  };
	
	  return PlayProgressBar;
	}(Component$1);
	/**
	 * Default options for {@link PlayProgressBar}.
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	PlayProgressBar.prototype.options_ = {
	  children: []
	}; // Time tooltips should not be added to a player on mobile devices
	
	if (!IS_IOS && !IS_ANDROID) {
	  PlayProgressBar.prototype.options_.children.push('timeTooltip');
	}
	
	Component$1.registerComponent('PlayProgressBar', PlayProgressBar);
	
	/**
	 * The {@link MouseTimeDisplay} component tracks mouse movement over the
	 * {@link ProgressControl}. It displays an indicator and a {@link TimeTooltip}
	 * indicating the time which is represented by a given point in the
	 * {@link ProgressControl}.
	 *
	 * @extends Component
	 */
	
	var MouseTimeDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](MouseTimeDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function MouseTimeDisplay(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the DOM element for this class.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = MouseTimeDisplay.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-mouse-display'
	    });
	  }
	  /**
	   * Enqueues updates to its own DOM as well as the DOM of its
	   * {@link TimeTooltip} child.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   */
	  ;
	
	  _proto.update = function update(seekBarRect, seekBarPoint) {
	    var _this2 = this;
	
	    var time = seekBarPoint * this.player_.duration();
	    this.getChild('timeTooltip').updateTime(seekBarRect, seekBarPoint, time, function () {
	      _this2.el_.style.left = seekBarRect.width * seekBarPoint + "px";
	    });
	  };
	
	  return MouseTimeDisplay;
	}(Component$1);
	/**
	 * Default options for `MouseTimeDisplay`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	MouseTimeDisplay.prototype.options_ = {
	  children: ['timeTooltip']
	};
	Component$1.registerComponent('MouseTimeDisplay', MouseTimeDisplay);
	
	var STEP_SECONDS = 5; // The multiplier of STEP_SECONDS that PgUp/PgDown move the timeline.
	
	var PAGE_KEY_MULTIPLIER = 12;
	/**
	 * Seek bar and container for the progress bars. Uses {@link PlayProgressBar}
	 * as its `bar`.
	 *
	 * @extends Slider
	 */
	
	var SeekBar = /*#__PURE__*/function (_Slider) {
	  _inheritsLoose__default['default'](SeekBar, _Slider);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function SeekBar(player, options) {
	    var _this;
	
	    _this = _Slider.call(this, player, options) || this;
	
	    _this.setEventHandlers_();
	
	    return _this;
	  }
	  /**
	   * Sets the event handlers
	   *
	   * @private
	   */
	
	
	  var _proto = SeekBar.prototype;
	
	  _proto.setEventHandlers_ = function setEventHandlers_() {
	    var _this2 = this;
	
	    this.update_ = bind(this, this.update);
	    this.update = throttle(this.update_, UPDATE_REFRESH_INTERVAL);
	    this.on(this.player_, ['ended', 'durationchange', 'timeupdate'], this.update);
	
	    if (this.player_.liveTracker) {
	      this.on(this.player_.liveTracker, 'liveedgechange', this.update);
	    } // when playing, let's ensure we smoothly update the play progress bar
	    // via an interval
	
	
	    this.updateInterval = null;
	
	    this.enableIntervalHandler_ = function (e) {
	      return _this2.enableInterval_(e);
	    };
	
	    this.disableIntervalHandler_ = function (e) {
	      return _this2.disableInterval_(e);
	    };
	
	    this.on(this.player_, ['playing'], this.enableIntervalHandler_);
	    this.on(this.player_, ['ended', 'pause', 'waiting'], this.disableIntervalHandler_); // we don't need to update the play progress if the document is hidden,
	    // also, this causes the CPU to spike and eventually crash the page on IE11.
	
	    if ('hidden' in document__default['default'] && 'visibilityState' in document__default['default']) {
	      this.on(document__default['default'], 'visibilitychange', this.toggleVisibility_);
	    }
	  };
	
	  _proto.toggleVisibility_ = function toggleVisibility_(e) {
	    if (document__default['default'].visibilityState === 'hidden') {
	      this.cancelNamedAnimationFrame('SeekBar#update');
	      this.cancelNamedAnimationFrame('Slider#update');
	      this.disableInterval_(e);
	    } else {
	      if (!this.player_.ended() && !this.player_.paused()) {
	        this.enableInterval_();
	      } // we just switched back to the page and someone may be looking, so, update ASAP
	
	
	      this.update();
	    }
	  };
	
	  _proto.enableInterval_ = function enableInterval_() {
	    if (this.updateInterval) {
	      return;
	    }
	
	    this.updateInterval = this.setInterval(this.update, UPDATE_REFRESH_INTERVAL);
	  };
	
	  _proto.disableInterval_ = function disableInterval_(e) {
	    if (this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== 'ended') {
	      return;
	    }
	
	    if (!this.updateInterval) {
	      return;
	    }
	
	    this.clearInterval(this.updateInterval);
	    this.updateInterval = null;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    return _Slider.prototype.createEl.call(this, 'div', {
	      className: 'vjs-progress-holder'
	    }, {
	      'aria-label': this.localize('Progress Bar')
	    });
	  }
	  /**
	   * This function updates the play progress bar and accessibility
	   * attributes to whatever is passed in.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` or `ended` event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   *
	   * @return {number}
	   *          The current percent at a number from 0-1
	   */
	  ;
	
	  _proto.update = function update(event) {
	    var _this3 = this;
	
	    // ignore updates while the tab is hidden
	    if (document__default['default'].visibilityState === 'hidden') {
	      return;
	    }
	
	    var percent = _Slider.prototype.update.call(this);
	
	    this.requestNamedAnimationFrame('SeekBar#update', function () {
	      var currentTime = _this3.player_.ended() ? _this3.player_.duration() : _this3.getCurrentTime_();
	      var liveTracker = _this3.player_.liveTracker;
	
	      var duration = _this3.player_.duration();
	
	      if (liveTracker && liveTracker.isLive()) {
	        duration = _this3.player_.liveTracker.liveCurrentTime();
	      }
	
	      if (_this3.percent_ !== percent) {
	        // machine readable value of progress bar (percentage complete)
	        _this3.el_.setAttribute('aria-valuenow', (percent * 100).toFixed(2));
	
	        _this3.percent_ = percent;
	      }
	
	      if (_this3.currentTime_ !== currentTime || _this3.duration_ !== duration) {
	        // human readable value of progress bar (time complete)
	        _this3.el_.setAttribute('aria-valuetext', _this3.localize('progress bar timing: currentTime={1} duration={2}', [formatTime(currentTime, duration), formatTime(duration, duration)], '{1} of {2}'));
	
	        _this3.currentTime_ = currentTime;
	        _this3.duration_ = duration;
	      } // update the progress bar time tooltip with the current time
	
	
	      if (_this3.bar) {
	        _this3.bar.update(getBoundingClientRect(_this3.el()), _this3.getProgress());
	      }
	    });
	    return percent;
	  }
	  /**
	   * Prevent liveThreshold from causing seeks to seem like they
	   * are not happening from a user perspective.
	   *
	   * @param {number} ct
	   *        current time to seek to
	   */
	  ;
	
	  _proto.userSeek_ = function userSeek_(ct) {
	    if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
	      this.player_.liveTracker.nextSeekedFromUser();
	    }
	
	    this.player_.currentTime(ct);
	  }
	  /**
	   * Get the value of current time but allows for smooth scrubbing,
	   * when player can't keep up.
	   *
	   * @return {number}
	   *         The current time value to display
	   *
	   * @private
	   */
	  ;
	
	  _proto.getCurrentTime_ = function getCurrentTime_() {
	    return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	  }
	  /**
	   * Get the percentage of media played so far.
	   *
	   * @return {number}
	   *         The percentage of media played so far (0 to 1).
	   */
	  ;
	
	  _proto.getPercent = function getPercent() {
	    var currentTime = this.getCurrentTime_();
	    var percent;
	    var liveTracker = this.player_.liveTracker;
	
	    if (liveTracker && liveTracker.isLive()) {
	      percent = (currentTime - liveTracker.seekableStart()) / liveTracker.liveWindow(); // prevent the percent from changing at the live edge
	
	      if (liveTracker.atLiveEdge()) {
	        percent = 1;
	      }
	    } else {
	      percent = currentTime / this.player_.duration();
	    }
	
	    return percent;
	  }
	  /**
	   * Handle mouse down on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousedown` event that caused this to run.
	   *
	   * @listens mousedown
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    if (!isSingleLeftClick(event)) {
	      return;
	    } // Stop event propagation to prevent double fire in progress-control.js
	
	
	    event.stopPropagation();
	    this.videoWasPlaying = !this.player_.paused();
	    this.player_.pause();
	
	    _Slider.prototype.handleMouseDown.call(this, event);
	  }
	  /**
	   * Handle mouse move on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousemove` event that caused this to run.
	   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false
	   *
	   * @listens mousemove
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event, mouseDown) {
	    if (mouseDown === void 0) {
	      mouseDown = false;
	    }
	
	    if (!isSingleLeftClick(event)) {
	      return;
	    }
	
	    if (!mouseDown && !this.player_.scrubbing()) {
	      this.player_.scrubbing(true);
	    }
	
	    var newTime;
	    var distance = this.calculateDistance(event);
	    var liveTracker = this.player_.liveTracker;
	
	    if (!liveTracker || !liveTracker.isLive()) {
	      newTime = distance * this.player_.duration(); // Don't let video end while scrubbing.
	
	      if (newTime === this.player_.duration()) {
	        newTime = newTime - 0.1;
	      }
	    } else {
	      if (distance >= 0.99) {
	        liveTracker.seekToLiveEdge();
	        return;
	      }
	
	      var seekableStart = liveTracker.seekableStart();
	      var seekableEnd = liveTracker.liveCurrentTime();
	      newTime = seekableStart + distance * liveTracker.liveWindow(); // Don't let video end while scrubbing.
	
	      if (newTime >= seekableEnd) {
	        newTime = seekableEnd;
	      } // Compensate for precision differences so that currentTime is not less
	      // than seekable start
	
	
	      if (newTime <= seekableStart) {
	        newTime = seekableStart + 0.1;
	      } // On android seekableEnd can be Infinity sometimes,
	      // this will cause newTime to be Infinity, which is
	      // not a valid currentTime.
	
	
	      if (newTime === Infinity) {
	        return;
	      }
	    } // Set new time (tell player to seek to new time)
	
	
	    this.userSeek_(newTime);
	  };
	
	  _proto.enable = function enable() {
	    _Slider.prototype.enable.call(this);
	
	    var mouseTimeDisplay = this.getChild('mouseTimeDisplay');
	
	    if (!mouseTimeDisplay) {
	      return;
	    }
	
	    mouseTimeDisplay.show();
	  };
	
	  _proto.disable = function disable() {
	    _Slider.prototype.disable.call(this);
	
	    var mouseTimeDisplay = this.getChild('mouseTimeDisplay');
	
	    if (!mouseTimeDisplay) {
	      return;
	    }
	
	    mouseTimeDisplay.hide();
	  }
	  /**
	   * Handle mouse up on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mouseup` event that caused this to run.
	   *
	   * @listens mouseup
	   */
	  ;
	
	  _proto.handleMouseUp = function handleMouseUp(event) {
	    _Slider.prototype.handleMouseUp.call(this, event); // Stop event propagation to prevent double fire in progress-control.js
	
	
	    if (event) {
	      event.stopPropagation();
	    }
	
	    this.player_.scrubbing(false);
	    /**
	     * Trigger timeupdate because we're done seeking and the time has changed.
	     * This is particularly useful for if the player is paused to time the time displays.
	     *
	     * @event Tech#timeupdate
	     * @type {EventTarget~Event}
	     */
	
	    this.player_.trigger({
	      type: 'timeupdate',
	      target: this,
	      manuallyTriggered: true
	    });
	
	    if (this.videoWasPlaying) {
	      silencePromise(this.player_.play());
	    } else {
	      // We're done seeking and the time has changed.
	      // If the player is paused, make sure we display the correct time on the seek bar.
	      this.update_();
	    }
	  }
	  /**
	   * Move more quickly fast forward for keyboard-only users
	   */
	  ;
	
	  _proto.stepForward = function stepForward() {
	    this.userSeek_(this.player_.currentTime() + STEP_SECONDS);
	  }
	  /**
	   * Move more quickly rewind for keyboard-only users
	   */
	  ;
	
	  _proto.stepBack = function stepBack() {
	    this.userSeek_(this.player_.currentTime() - STEP_SECONDS);
	  }
	  /**
	   * Toggles the playback state of the player
	   * This gets called when enter or space is used on the seekbar
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called
	   *
	   */
	  ;
	
	  _proto.handleAction = function handleAction(event) {
	    if (this.player_.paused()) {
	      this.player_.play();
	    } else {
	      this.player_.pause();
	    }
	  }
	  /**
	   * Called when this SeekBar has focus and a key gets pressed down.
	   * Supports the following keys:
	   *
	   *   Space or Enter key fire a click event
	   *   Home key moves to start of the timeline
	   *   End key moves to end of the timeline
	   *   Digit "0" through "9" keys move to 0%, 10% ... 80%, 90% of the timeline
	   *   PageDown key moves back a larger step than ArrowDown
	   *   PageUp key moves forward a large step
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    var liveTracker = this.player_.liveTracker;
	
	    if (keycode__default['default'].isEventKey(event, 'Space') || keycode__default['default'].isEventKey(event, 'Enter')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.handleAction(event);
	    } else if (keycode__default['default'].isEventKey(event, 'Home')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.userSeek_(0);
	    } else if (keycode__default['default'].isEventKey(event, 'End')) {
	      event.preventDefault();
	      event.stopPropagation();
	
	      if (liveTracker && liveTracker.isLive()) {
	        this.userSeek_(liveTracker.liveCurrentTime());
	      } else {
	        this.userSeek_(this.player_.duration());
	      }
	    } else if (/^[0-9]$/.test(keycode__default['default'](event))) {
	      event.preventDefault();
	      event.stopPropagation();
	      var gotoFraction = (keycode__default['default'].codes[keycode__default['default'](event)] - keycode__default['default'].codes['0']) * 10.0 / 100.0;
	
	      if (liveTracker && liveTracker.isLive()) {
	        this.userSeek_(liveTracker.seekableStart() + liveTracker.liveWindow() * gotoFraction);
	      } else {
	        this.userSeek_(this.player_.duration() * gotoFraction);
	      }
	    } else if (keycode__default['default'].isEventKey(event, 'PgDn')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.userSeek_(this.player_.currentTime() - STEP_SECONDS * PAGE_KEY_MULTIPLIER);
	    } else if (keycode__default['default'].isEventKey(event, 'PgUp')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.userSeek_(this.player_.currentTime() + STEP_SECONDS * PAGE_KEY_MULTIPLIER);
	    } else {
	      // Pass keydown handling up for unsupported keys
	      _Slider.prototype.handleKeyDown.call(this, event);
	    }
	  };
	
	  _proto.dispose = function dispose() {
	    this.disableInterval_();
	    this.off(this.player_, ['ended', 'durationchange', 'timeupdate'], this.update);
	
	    if (this.player_.liveTracker) {
	      this.off(this.player_.liveTracker, 'liveedgechange', this.update);
	    }
	
	    this.off(this.player_, ['playing'], this.enableIntervalHandler_);
	    this.off(this.player_, ['ended', 'pause', 'waiting'], this.disableIntervalHandler_); // we don't need to update the play progress if the document is hidden,
	    // also, this causes the CPU to spike and eventually crash the page on IE11.
	
	    if ('hidden' in document__default['default'] && 'visibilityState' in document__default['default']) {
	      this.off(document__default['default'], 'visibilitychange', this.toggleVisibility_);
	    }
	
	    _Slider.prototype.dispose.call(this);
	  };
	
	  return SeekBar;
	}(Slider);
	/**
	 * Default options for the `SeekBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	SeekBar.prototype.options_ = {
	  children: ['loadProgressBar', 'playProgressBar'],
	  barName: 'playProgressBar'
	}; // MouseTimeDisplay tooltips should not be added to a player on mobile devices
	
	if (!IS_IOS && !IS_ANDROID) {
	  SeekBar.prototype.options_.children.splice(1, 0, 'mouseTimeDisplay');
	}
	
	Component$1.registerComponent('SeekBar', SeekBar);
	
	/**
	 * The Progress Control component contains the seek bar, load progress,
	 * and play progress.
	 *
	 * @extends Component
	 */
	
	var ProgressControl = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ProgressControl, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function ProgressControl(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.handleMouseMove = throttle(bind(_assertThisInitialized__default['default'](_this), _this.handleMouseMove), UPDATE_REFRESH_INTERVAL);
	    _this.throttledHandleMouseSeek = throttle(bind(_assertThisInitialized__default['default'](_this), _this.handleMouseSeek), UPDATE_REFRESH_INTERVAL);
	
	    _this.handleMouseUpHandler_ = function (e) {
	      return _this.handleMouseUp(e);
	    };
	
	    _this.handleMouseDownHandler_ = function (e) {
	      return _this.handleMouseDown(e);
	    };
	
	    _this.enable();
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = ProgressControl.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-progress-control vjs-control'
	    });
	  }
	  /**
	   * When the mouse moves over the `ProgressControl`, the pointer position
	   * gets passed down to the `MouseTimeDisplay` component.
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousemove` event that caused this function to run.
	   *
	   * @listen mousemove
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event) {
	    var seekBar = this.getChild('seekBar');
	
	    if (!seekBar) {
	      return;
	    }
	
	    var playProgressBar = seekBar.getChild('playProgressBar');
	    var mouseTimeDisplay = seekBar.getChild('mouseTimeDisplay');
	
	    if (!playProgressBar && !mouseTimeDisplay) {
	      return;
	    }
	
	    var seekBarEl = seekBar.el();
	    var seekBarRect = findPosition(seekBarEl);
	    var seekBarPoint = getPointerPosition(seekBarEl, event).x; // The default skin has a gap on either side of the `SeekBar`. This means
	    // that it's possible to trigger this behavior outside the boundaries of
	    // the `SeekBar`. This ensures we stay within it at all times.
	
	    seekBarPoint = clamp(seekBarPoint, 0, 1);
	
	    if (mouseTimeDisplay) {
	      mouseTimeDisplay.update(seekBarRect, seekBarPoint);
	    }
	
	    if (playProgressBar) {
	      playProgressBar.update(seekBarRect, seekBar.getProgress());
	    }
	  }
	  /**
	   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
	   *
	   * @method ProgressControl#throttledHandleMouseSeek
	   * @param {EventTarget~Event} event
	   *        The `mousemove` event that caused this function to run.
	   *
	   * @listen mousemove
	   * @listen touchmove
	   */
	
	  /**
	   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousemove
	   * @listens touchmove
	   */
	  ;
	
	  _proto.handleMouseSeek = function handleMouseSeek(event) {
	    var seekBar = this.getChild('seekBar');
	
	    if (seekBar) {
	      seekBar.handleMouseMove(event);
	    }
	  }
	  /**
	   * Are controls are currently enabled for this progress control.
	   *
	   * @return {boolean}
	   *         true if controls are enabled, false otherwise
	   */
	  ;
	
	  _proto.enabled = function enabled() {
	    return this.enabled_;
	  }
	  /**
	   * Disable all controls on the progress control and its children
	   */
	  ;
	
	  _proto.disable = function disable() {
	    this.children().forEach(function (child) {
	      return child.disable && child.disable();
	    });
	
	    if (!this.enabled()) {
	      return;
	    }
	
	    this.off(['mousedown', 'touchstart'], this.handleMouseDownHandler_);
	    this.off(this.el_, 'mousemove', this.handleMouseMove);
	    this.removeListenersAddedOnMousedownAndTouchstart();
	    this.addClass('disabled');
	    this.enabled_ = false; // Restore normal playback state if controls are disabled while scrubbing
	
	    if (this.player_.scrubbing()) {
	      var seekBar = this.getChild('seekBar');
	      this.player_.scrubbing(false);
	
	      if (seekBar.videoWasPlaying) {
	        silencePromise(this.player_.play());
	      }
	    }
	  }
	  /**
	   * Enable all controls on the progress control and its children
	   */
	  ;
	
	  _proto.enable = function enable() {
	    this.children().forEach(function (child) {
	      return child.enable && child.enable();
	    });
	
	    if (this.enabled()) {
	      return;
	    }
	
	    this.on(['mousedown', 'touchstart'], this.handleMouseDownHandler_);
	    this.on(this.el_, 'mousemove', this.handleMouseMove);
	    this.removeClass('disabled');
	    this.enabled_ = true;
	  }
	  /**
	   * Cleanup listeners after the user finishes interacting with the progress controls
	   */
	  ;
	
	  _proto.removeListenersAddedOnMousedownAndTouchstart = function removeListenersAddedOnMousedownAndTouchstart() {
	    var doc = this.el_.ownerDocument;
	    this.off(doc, 'mousemove', this.throttledHandleMouseSeek);
	    this.off(doc, 'touchmove', this.throttledHandleMouseSeek);
	    this.off(doc, 'mouseup', this.handleMouseUpHandler_);
	    this.off(doc, 'touchend', this.handleMouseUpHandler_);
	  }
	  /**
	   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    var doc = this.el_.ownerDocument;
	    var seekBar = this.getChild('seekBar');
	
	    if (seekBar) {
	      seekBar.handleMouseDown(event);
	    }
	
	    this.on(doc, 'mousemove', this.throttledHandleMouseSeek);
	    this.on(doc, 'touchmove', this.throttledHandleMouseSeek);
	    this.on(doc, 'mouseup', this.handleMouseUpHandler_);
	    this.on(doc, 'touchend', this.handleMouseUpHandler_);
	  }
	  /**
	   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mouseup` or `touchend` event that triggered this function.
	   *
	   * @listens touchend
	   * @listens mouseup
	   */
	  ;
	
	  _proto.handleMouseUp = function handleMouseUp(event) {
	    var seekBar = this.getChild('seekBar');
	
	    if (seekBar) {
	      seekBar.handleMouseUp(event);
	    }
	
	    this.removeListenersAddedOnMousedownAndTouchstart();
	  };
	
	  return ProgressControl;
	}(Component$1);
	/**
	 * Default options for `ProgressControl`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ProgressControl.prototype.options_ = {
	  children: ['seekBar']
	};
	Component$1.registerComponent('ProgressControl', ProgressControl);
	
	/**
	 * Toggle Picture-in-Picture mode
	 *
	 * @extends Button
	 */
	
	var PictureInPictureToggle = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](PictureInPictureToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @listens Player#enterpictureinpicture
	   * @listens Player#leavepictureinpicture
	   */
	  function PictureInPictureToggle(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	
	    _this.on(player, ['enterpictureinpicture', 'leavepictureinpicture'], function (e) {
	      return _this.handlePictureInPictureChange(e);
	    });
	
	    _this.on(player, ['disablepictureinpicturechanged', 'loadedmetadata'], function (e) {
	      return _this.handlePictureInPictureEnabledChange(e);
	    });
	
	    _this.on(player, ['loadedmetadata', 'audioonlymodechange', 'audiopostermodechange'], function () {
	      // This audio detection will not detect HLS or DASH audio-only streams because there was no reliable way to detect them at the time
	      var isSourceAudio = player.currentType().substring(0, 5) === 'audio';
	
	      if (isSourceAudio || player.audioPosterMode() || player.audioOnlyMode()) {
	        if (player.isInPictureInPicture()) {
	          player.exitPictureInPicture();
	        }
	
	        _this.hide();
	      } else {
	        _this.show();
	      }
	    }); // TODO: Deactivate button on player emptied event.
	
	
	    _this.disable();
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = PictureInPictureToggle.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-picture-in-picture-control " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Enables or disables button based on document.pictureInPictureEnabled property value
	   * or on value returned by player.disablePictureInPicture() method.
	   */
	  ;
	
	  _proto.handlePictureInPictureEnabledChange = function handlePictureInPictureEnabledChange() {
	    if (document__default['default'].pictureInPictureEnabled && this.player_.disablePictureInPicture() === false) {
	      this.enable();
	    } else {
	      this.disable();
	    }
	  }
	  /**
	   * Handles enterpictureinpicture and leavepictureinpicture on the player and change control text accordingly.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#enterpictureinpicture} or {@link Player#leavepictureinpicture} event that caused this function to be
	   *        called.
	   *
	   * @listens Player#enterpictureinpicture
	   * @listens Player#leavepictureinpicture
	   */
	  ;
	
	  _proto.handlePictureInPictureChange = function handlePictureInPictureChange(event) {
	    if (this.player_.isInPictureInPicture()) {
	      this.controlText('Exit Picture-in-Picture');
	    } else {
	      this.controlText('Picture-in-Picture');
	    }
	
	    this.handlePictureInPictureEnabledChange();
	  }
	  /**
	   * This gets called when an `PictureInPictureToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (!this.player_.isInPictureInPicture()) {
	      this.player_.requestPictureInPicture();
	    } else {
	      this.player_.exitPictureInPicture();
	    }
	  };
	
	  return PictureInPictureToggle;
	}(Button);
	/**
	 * The text that should display over the `PictureInPictureToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PictureInPictureToggle.prototype.controlText_ = 'Picture-in-Picture';
	Component$1.registerComponent('PictureInPictureToggle', PictureInPictureToggle);
	
	/**
	 * Toggle fullscreen video
	 *
	 * @extends Button
	 */
	
	var FullscreenToggle = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](FullscreenToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function FullscreenToggle(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	
	    _this.on(player, 'fullscreenchange', function (e) {
	      return _this.handleFullscreenChange(e);
	    });
	
	    if (document__default['default'][player.fsApi_.fullscreenEnabled] === false) {
	      _this.disable();
	    }
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = FullscreenToggle.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-fullscreen-control " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Handles fullscreenchange on the player and change control text accordingly.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#fullscreenchange} event that caused this function to be
	   *        called.
	   *
	   * @listens Player#fullscreenchange
	   */
	  ;
	
	  _proto.handleFullscreenChange = function handleFullscreenChange(event) {
	    if (this.player_.isFullscreen()) {
	      this.controlText('Non-Fullscreen');
	    } else {
	      this.controlText('Fullscreen');
	    }
	  }
	  /**
	   * This gets called when an `FullscreenToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (!this.player_.isFullscreen()) {
	      this.player_.requestFullscreen();
	    } else {
	      this.player_.exitFullscreen();
	    }
	  };
	
	  return FullscreenToggle;
	}(Button);
	/**
	 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	FullscreenToggle.prototype.controlText_ = 'Fullscreen';
	Component$1.registerComponent('FullscreenToggle', FullscreenToggle);
	
	/**
	 * Check if volume control is supported and if it isn't hide the
	 * `Component` that was passed  using the `vjs-hidden` class.
	 *
	 * @param {Component} self
	 *        The component that should be hidden if volume is unsupported
	 *
	 * @param {Player} player
	 *        A reference to the player
	 *
	 * @private
	 */
	var checkVolumeSupport = function checkVolumeSupport(self, player) {
	  // hide volume controls when they're not supported by the current tech
	  if (player.tech_ && !player.tech_.featuresVolumeControl) {
	    self.addClass('vjs-hidden');
	  }
	
	  self.on(player, 'loadstart', function () {
	    if (!player.tech_.featuresVolumeControl) {
	      self.addClass('vjs-hidden');
	    } else {
	      self.removeClass('vjs-hidden');
	    }
	  });
	};
	
	/**
	 * Shows volume level
	 *
	 * @extends Component
	 */
	
	var VolumeLevel = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VolumeLevel, _Component);
	
	  function VolumeLevel() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = VolumeLevel.prototype;
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  _proto.createEl = function createEl() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-level'
	    });
	
	    el.appendChild(_Component.prototype.createEl.call(this, 'span', {
	      className: 'vjs-control-text'
	    }));
	    return el;
	  };
	
	  return VolumeLevel;
	}(Component$1);
	
	Component$1.registerComponent('VolumeLevel', VolumeLevel);
	
	/**
	 * Volume level tooltips display a volume above or side by side the volume bar.
	 *
	 * @extends Component
	 */
	
	var VolumeLevelTooltip = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VolumeLevelTooltip, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function VolumeLevelTooltip(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the volume tooltip DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = VolumeLevelTooltip.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-tooltip'
	    }, {
	      'aria-hidden': 'true'
	    });
	  }
	  /**
	   * Updates the position of the tooltip relative to the `VolumeBar` and
	   * its content text.
	   *
	   * @param {Object} rangeBarRect
	   *        The `ClientRect` for the {@link VolumeBar} element.
	   *
	   * @param {number} rangeBarPoint
	   *        A number from 0 to 1, representing a horizontal/vertical reference point
	   *        from the left edge of the {@link VolumeBar}
	   *
	   * @param {boolean} vertical
	   *        Referees to the Volume control position
	   *        in the control bar{@link VolumeControl}
	   *
	   */
	  ;
	
	  _proto.update = function update(rangeBarRect, rangeBarPoint, vertical, content) {
	    if (!vertical) {
	      var tooltipRect = getBoundingClientRect(this.el_);
	      var playerRect = getBoundingClientRect(this.player_.el());
	      var volumeBarPointPx = rangeBarRect.width * rangeBarPoint;
	
	      if (!playerRect || !tooltipRect) {
	        return;
	      }
	
	      var spaceLeftOfPoint = rangeBarRect.left - playerRect.left + volumeBarPointPx;
	      var spaceRightOfPoint = rangeBarRect.width - volumeBarPointPx + (playerRect.right - rangeBarRect.right);
	      var pullTooltipBy = tooltipRect.width / 2;
	
	      if (spaceLeftOfPoint < pullTooltipBy) {
	        pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
	      } else if (spaceRightOfPoint < pullTooltipBy) {
	        pullTooltipBy = spaceRightOfPoint;
	      }
	
	      if (pullTooltipBy < 0) {
	        pullTooltipBy = 0;
	      } else if (pullTooltipBy > tooltipRect.width) {
	        pullTooltipBy = tooltipRect.width;
	      }
	
	      this.el_.style.right = "-" + pullTooltipBy + "px";
	    }
	
	    this.write(content + "%");
	  }
	  /**
	   * Write the volume to the tooltip DOM element.
	   *
	   * @param {string} content
	   *        The formatted volume for the tooltip.
	   */
	  ;
	
	  _proto.write = function write(content) {
	    textContent(this.el_, content);
	  }
	  /**
	   * Updates the position of the volume tooltip relative to the `VolumeBar`.
	   *
	   * @param {Object} rangeBarRect
	   *        The `ClientRect` for the {@link VolumeBar} element.
	   *
	   * @param {number} rangeBarPoint
	   *        A number from 0 to 1, representing a horizontal/vertical reference point
	   *        from the left edge of the {@link VolumeBar}
	   *
	   * @param {boolean} vertical
	   *        Referees to the Volume control position
	   *        in the control bar{@link VolumeControl}
	   *
	   * @param {number} volume
	   *        The volume level to update the tooltip to
	   *
	   * @param {Function} cb
	   *        A function that will be called during the request animation frame
	   *        for tooltips that need to do additional animations from the default
	   */
	  ;
	
	  _proto.updateVolume = function updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, cb) {
	    var _this2 = this;
	
	    this.requestNamedAnimationFrame('VolumeLevelTooltip#updateVolume', function () {
	      _this2.update(rangeBarRect, rangeBarPoint, vertical, volume.toFixed(0));
	
	      if (cb) {
	        cb();
	      }
	    });
	  };
	
	  return VolumeLevelTooltip;
	}(Component$1);
	
	Component$1.registerComponent('VolumeLevelTooltip', VolumeLevelTooltip);
	
	/**
	 * The {@link MouseVolumeLevelDisplay} component tracks mouse movement over the
	 * {@link VolumeControl}. It displays an indicator and a {@link VolumeLevelTooltip}
	 * indicating the volume level which is represented by a given point in the
	 * {@link VolumeBar}.
	 *
	 * @extends Component
	 */
	
	var MouseVolumeLevelDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](MouseVolumeLevelDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function MouseVolumeLevelDisplay(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the DOM element for this class.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = MouseVolumeLevelDisplay.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-mouse-display'
	    });
	  }
	  /**
	   * Enquires updates to its own DOM as well as the DOM of its
	   * {@link VolumeLevelTooltip} child.
	   *
	   * @param {Object} rangeBarRect
	   *        The `ClientRect` for the {@link VolumeBar} element.
	   *
	   * @param {number} rangeBarPoint
	   *        A number from 0 to 1, representing a horizontal/vertical reference point
	   *        from the left edge of the {@link VolumeBar}
	   *
	   * @param {boolean} vertical
	   *        Referees to the Volume control position
	   *        in the control bar{@link VolumeControl}
	   *
	   */
	  ;
	
	  _proto.update = function update(rangeBarRect, rangeBarPoint, vertical) {
	    var _this2 = this;
	
	    var volume = 100 * rangeBarPoint;
	    this.getChild('volumeLevelTooltip').updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, function () {
	      if (vertical) {
	        _this2.el_.style.bottom = rangeBarRect.height * rangeBarPoint + "px";
	      } else {
	        _this2.el_.style.left = rangeBarRect.width * rangeBarPoint + "px";
	      }
	    });
	  };
	
	  return MouseVolumeLevelDisplay;
	}(Component$1);
	/**
	 * Default options for `MouseVolumeLevelDisplay`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	MouseVolumeLevelDisplay.prototype.options_ = {
	  children: ['volumeLevelTooltip']
	};
	Component$1.registerComponent('MouseVolumeLevelDisplay', MouseVolumeLevelDisplay);
	
	/**
	 * The bar that contains the volume level and can be clicked on to adjust the level
	 *
	 * @extends Slider
	 */
	
	var VolumeBar = /*#__PURE__*/function (_Slider) {
	  _inheritsLoose__default['default'](VolumeBar, _Slider);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function VolumeBar(player, options) {
	    var _this;
	
	    _this = _Slider.call(this, player, options) || this;
	
	    _this.on('slideractive', function (e) {
	      return _this.updateLastVolume_(e);
	    });
	
	    _this.on(player, 'volumechange', function (e) {
	      return _this.updateARIAAttributes(e);
	    });
	
	    player.ready(function () {
	      return _this.updateARIAAttributes();
	    });
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = VolumeBar.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Slider.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-bar vjs-slider-bar'
	    }, {
	      'aria-label': this.localize('Volume Level'),
	      'aria-live': 'polite'
	    });
	  }
	  /**
	   * Handle mouse down on volume bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousedown` event that caused this to run.
	   *
	   * @listens mousedown
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    if (!isSingleLeftClick(event)) {
	      return;
	    }
	
	    _Slider.prototype.handleMouseDown.call(this, event);
	  }
	  /**
	   * Handle movement events on the {@link VolumeMenuButton}.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run.
	   *
	   * @listens mousemove
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event) {
	    var mouseVolumeLevelDisplay = this.getChild('mouseVolumeLevelDisplay');
	
	    if (mouseVolumeLevelDisplay) {
	      var volumeBarEl = this.el();
	      var volumeBarRect = getBoundingClientRect(volumeBarEl);
	      var vertical = this.vertical();
	      var volumeBarPoint = getPointerPosition(volumeBarEl, event);
	      volumeBarPoint = vertical ? volumeBarPoint.y : volumeBarPoint.x; // The default skin has a gap on either side of the `VolumeBar`. This means
	      // that it's possible to trigger this behavior outside the boundaries of
	      // the `VolumeBar`. This ensures we stay within it at all times.
	
	      volumeBarPoint = clamp(volumeBarPoint, 0, 1);
	      mouseVolumeLevelDisplay.update(volumeBarRect, volumeBarPoint, vertical);
	    }
	
	    if (!isSingleLeftClick(event)) {
	      return;
	    }
	
	    this.checkMuted();
	    this.player_.volume(this.calculateDistance(event));
	  }
	  /**
	   * If the player is muted unmute it.
	   */
	  ;
	
	  _proto.checkMuted = function checkMuted() {
	    if (this.player_.muted()) {
	      this.player_.muted(false);
	    }
	  }
	  /**
	   * Get percent of volume level
	   *
	   * @return {number}
	   *         Volume level percent as a decimal number.
	   */
	  ;
	
	  _proto.getPercent = function getPercent() {
	    if (this.player_.muted()) {
	      return 0;
	    }
	
	    return this.player_.volume();
	  }
	  /**
	   * Increase volume level for keyboard users
	   */
	  ;
	
	  _proto.stepForward = function stepForward() {
	    this.checkMuted();
	    this.player_.volume(this.player_.volume() + 0.1);
	  }
	  /**
	   * Decrease volume level for keyboard users
	   */
	  ;
	
	  _proto.stepBack = function stepBack() {
	    this.checkMuted();
	    this.player_.volume(this.player_.volume() - 0.1);
	  }
	  /**
	   * Update ARIA accessibility attributes
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `volumechange` event that caused this function to run.
	   *
	   * @listens Player#volumechange
	   */
	  ;
	
	  _proto.updateARIAAttributes = function updateARIAAttributes(event) {
	    var ariaValue = this.player_.muted() ? 0 : this.volumeAsPercentage_();
	    this.el_.setAttribute('aria-valuenow', ariaValue);
	    this.el_.setAttribute('aria-valuetext', ariaValue + '%');
	  }
	  /**
	   * Returns the current value of the player volume as a percentage
	   *
	   * @private
	   */
	  ;
	
	  _proto.volumeAsPercentage_ = function volumeAsPercentage_() {
	    return Math.round(this.player_.volume() * 100);
	  }
	  /**
	   * When user starts dragging the VolumeBar, store the volume and listen for
	   * the end of the drag. When the drag ends, if the volume was set to zero,
	   * set lastVolume to the stored volume.
	   *
	   * @listens slideractive
	   * @private
	   */
	  ;
	
	  _proto.updateLastVolume_ = function updateLastVolume_() {
	    var _this2 = this;
	
	    var volumeBeforeDrag = this.player_.volume();
	    this.one('sliderinactive', function () {
	      if (_this2.player_.volume() === 0) {
	        _this2.player_.lastVolume_(volumeBeforeDrag);
	      }
	    });
	  };
	
	  return VolumeBar;
	}(Slider);
	/**
	 * Default options for the `VolumeBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	VolumeBar.prototype.options_ = {
	  children: ['volumeLevel'],
	  barName: 'volumeLevel'
	}; // MouseVolumeLevelDisplay tooltip should not be added to a player on mobile devices
	
	if (!IS_IOS && !IS_ANDROID) {
	  VolumeBar.prototype.options_.children.splice(0, 0, 'mouseVolumeLevelDisplay');
	}
	/**
	 * Call the update event for this Slider when this event happens on the player.
	 *
	 * @type {string}
	 */
	
	
	VolumeBar.prototype.playerEvent = 'volumechange';
	Component$1.registerComponent('VolumeBar', VolumeBar);
	
	/**
	 * The component for controlling the volume level
	 *
	 * @extends Component
	 */
	
	var VolumeControl = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VolumeControl, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function VolumeControl(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    options.vertical = options.vertical || false; // Pass the vertical option down to the VolumeBar if
	    // the VolumeBar is turned on.
	
	    if (typeof options.volumeBar === 'undefined' || isPlain(options.volumeBar)) {
	      options.volumeBar = options.volumeBar || {};
	      options.volumeBar.vertical = options.vertical;
	    }
	
	    _this = _Component.call(this, player, options) || this; // hide this control if volume support is missing
	
	    checkVolumeSupport(_assertThisInitialized__default['default'](_this), player);
	    _this.throttledHandleMouseMove = throttle(bind(_assertThisInitialized__default['default'](_this), _this.handleMouseMove), UPDATE_REFRESH_INTERVAL);
	
	    _this.handleMouseUpHandler_ = function (e) {
	      return _this.handleMouseUp(e);
	    };
	
	    _this.on('mousedown', function (e) {
	      return _this.handleMouseDown(e);
	    });
	
	    _this.on('touchstart', function (e) {
	      return _this.handleMouseDown(e);
	    });
	
	    _this.on('mousemove', function (e) {
	      return _this.handleMouseMove(e);
	    }); // while the slider is active (the mouse has been pressed down and
	    // is dragging) or in focus we do not want to hide the VolumeBar
	
	
	    _this.on(_this.volumeBar, ['focus', 'slideractive'], function () {
	      _this.volumeBar.addClass('vjs-slider-active');
	
	      _this.addClass('vjs-slider-active');
	
	      _this.trigger('slideractive');
	    });
	
	    _this.on(_this.volumeBar, ['blur', 'sliderinactive'], function () {
	      _this.volumeBar.removeClass('vjs-slider-active');
	
	      _this.removeClass('vjs-slider-active');
	
	      _this.trigger('sliderinactive');
	    });
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = VolumeControl.prototype;
	
	  _proto.createEl = function createEl() {
	    var orientationClass = 'vjs-volume-horizontal';
	
	    if (this.options_.vertical) {
	      orientationClass = 'vjs-volume-vertical';
	    }
	
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: "vjs-volume-control vjs-control " + orientationClass
	    });
	  }
	  /**
	   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    var doc = this.el_.ownerDocument;
	    this.on(doc, 'mousemove', this.throttledHandleMouseMove);
	    this.on(doc, 'touchmove', this.throttledHandleMouseMove);
	    this.on(doc, 'mouseup', this.handleMouseUpHandler_);
	    this.on(doc, 'touchend', this.handleMouseUpHandler_);
	  }
	  /**
	   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mouseup` or `touchend` event that triggered this function.
	   *
	   * @listens touchend
	   * @listens mouseup
	   */
	  ;
	
	  _proto.handleMouseUp = function handleMouseUp(event) {
	    var doc = this.el_.ownerDocument;
	    this.off(doc, 'mousemove', this.throttledHandleMouseMove);
	    this.off(doc, 'touchmove', this.throttledHandleMouseMove);
	    this.off(doc, 'mouseup', this.handleMouseUpHandler_);
	    this.off(doc, 'touchend', this.handleMouseUpHandler_);
	  }
	  /**
	   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event) {
	    this.volumeBar.handleMouseMove(event);
	  };
	
	  return VolumeControl;
	}(Component$1);
	/**
	 * Default options for the `VolumeControl`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	VolumeControl.prototype.options_ = {
	  children: ['volumeBar']
	};
	Component$1.registerComponent('VolumeControl', VolumeControl);
	
	/**
	 * Check if muting volume is supported and if it isn't hide the mute toggle
	 * button.
	 *
	 * @param {Component} self
	 *        A reference to the mute toggle button
	 *
	 * @param {Player} player
	 *        A reference to the player
	 *
	 * @private
	 */
	var checkMuteSupport = function checkMuteSupport(self, player) {
	  // hide mute toggle button if it's not supported by the current tech
	  if (player.tech_ && !player.tech_.featuresMuteControl) {
	    self.addClass('vjs-hidden');
	  }
	
	  self.on(player, 'loadstart', function () {
	    if (!player.tech_.featuresMuteControl) {
	      self.addClass('vjs-hidden');
	    } else {
	      self.removeClass('vjs-hidden');
	    }
	  });
	};
	
	/**
	 * A button component for muting the audio.
	 *
	 * @extends Button
	 */
	
	var MuteToggle = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](MuteToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function MuteToggle(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this; // hide this control if volume support is missing
	
	    checkMuteSupport(_assertThisInitialized__default['default'](_this), player);
	
	    _this.on(player, ['loadstart', 'volumechange'], function (e) {
	      return _this.update(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = MuteToggle.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-mute-control " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * This gets called when an `MuteToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    var vol = this.player_.volume();
	    var lastVolume = this.player_.lastVolume_();
	
	    if (vol === 0) {
	      var volumeToSet = lastVolume < 0.1 ? 0.1 : lastVolume;
	      this.player_.volume(volumeToSet);
	      this.player_.muted(false);
	    } else {
	      this.player_.muted(this.player_.muted() ? false : true);
	    }
	  }
	  /**
	   * Update the `MuteToggle` button based on the state of `volume` and `muted`
	   * on the player.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#loadstart} event if this function was called
	   *        through an event.
	   *
	   * @listens Player#loadstart
	   * @listens Player#volumechange
	   */
	  ;
	
	  _proto.update = function update(event) {
	    this.updateIcon_();
	    this.updateControlText_();
	  }
	  /**
	   * Update the appearance of the `MuteToggle` icon.
	   *
	   * Possible states (given `level` variable below):
	   * - 0: crossed out
	   * - 1: zero bars of volume
	   * - 2: one bar of volume
	   * - 3: two bars of volume
	   *
	   * @private
	   */
	  ;
	
	  _proto.updateIcon_ = function updateIcon_() {
	    var vol = this.player_.volume();
	    var level = 3; // in iOS when a player is loaded with muted attribute
	    // and volume is changed with a native mute button
	    // we want to make sure muted state is updated
	
	    if (IS_IOS && this.player_.tech_ && this.player_.tech_.el_) {
	      this.player_.muted(this.player_.tech_.el_.muted);
	    }
	
	    if (vol === 0 || this.player_.muted()) {
	      level = 0;
	    } else if (vol < 0.33) {
	      level = 1;
	    } else if (vol < 0.67) {
	      level = 2;
	    } // TODO improve muted icon classes
	
	
	    for (var i = 0; i < 4; i++) {
	      removeClass(this.el_, "vjs-vol-" + i);
	    }
	
	    addClass(this.el_, "vjs-vol-" + level);
	  }
	  /**
	   * If `muted` has changed on the player, update the control text
	   * (`title` attribute on `vjs-mute-control` element and content of
	   * `vjs-control-text` element).
	   *
	   * @private
	   */
	  ;
	
	  _proto.updateControlText_ = function updateControlText_() {
	    var soundOff = this.player_.muted() || this.player_.volume() === 0;
	    var text = soundOff ? 'Unmute' : 'Mute';
	
	    if (this.controlText() !== text) {
	      this.controlText(text);
	    }
	  };
	
	  return MuteToggle;
	}(Button);
	/**
	 * The text that should display over the `MuteToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	MuteToggle.prototype.controlText_ = 'Mute';
	Component$1.registerComponent('MuteToggle', MuteToggle);
	
	/**
	 * A Component to contain the MuteToggle and VolumeControl so that
	 * they can work together.
	 *
	 * @extends Component
	 */
	
	var VolumePanel = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VolumePanel, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function VolumePanel(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (typeof options.inline !== 'undefined') {
	      options.inline = options.inline;
	    } else {
	      options.inline = true;
	    } // pass the inline option down to the VolumeControl as vertical if
	    // the VolumeControl is on.
	
	
	    if (typeof options.volumeControl === 'undefined' || isPlain(options.volumeControl)) {
	      options.volumeControl = options.volumeControl || {};
	      options.volumeControl.vertical = !options.inline;
	    }
	
	    _this = _Component.call(this, player, options) || this; // this handler is used by mouse handler methods below
	
	    _this.handleKeyPressHandler_ = function (e) {
	      return _this.handleKeyPress(e);
	    };
	
	    _this.on(player, ['loadstart'], function (e) {
	      return _this.volumePanelState_(e);
	    });
	
	    _this.on(_this.muteToggle, 'keyup', function (e) {
	      return _this.handleKeyPress(e);
	    });
	
	    _this.on(_this.volumeControl, 'keyup', function (e) {
	      return _this.handleVolumeControlKeyUp(e);
	    });
	
	    _this.on('keydown', function (e) {
	      return _this.handleKeyPress(e);
	    });
	
	    _this.on('mouseover', function (e) {
	      return _this.handleMouseOver(e);
	    });
	
	    _this.on('mouseout', function (e) {
	      return _this.handleMouseOut(e);
	    }); // while the slider is active (the mouse has been pressed down and
	    // is dragging) we do not want to hide the VolumeBar
	
	
	    _this.on(_this.volumeControl, ['slideractive'], _this.sliderActive_);
	
	    _this.on(_this.volumeControl, ['sliderinactive'], _this.sliderInactive_);
	
	    return _this;
	  }
	  /**
	   * Add vjs-slider-active class to the VolumePanel
	   *
	   * @listens VolumeControl#slideractive
	   * @private
	   */
	
	
	  var _proto = VolumePanel.prototype;
	
	  _proto.sliderActive_ = function sliderActive_() {
	    this.addClass('vjs-slider-active');
	  }
	  /**
	   * Removes vjs-slider-active class to the VolumePanel
	   *
	   * @listens VolumeControl#sliderinactive
	   * @private
	   */
	  ;
	
	  _proto.sliderInactive_ = function sliderInactive_() {
	    this.removeClass('vjs-slider-active');
	  }
	  /**
	   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
	   * depending on MuteToggle and VolumeControl state
	   *
	   * @listens Player#loadstart
	   * @private
	   */
	  ;
	
	  _proto.volumePanelState_ = function volumePanelState_() {
	    // hide volume panel if neither volume control or mute toggle
	    // are displayed
	    if (this.volumeControl.hasClass('vjs-hidden') && this.muteToggle.hasClass('vjs-hidden')) {
	      this.addClass('vjs-hidden');
	    } // if only mute toggle is visible we don't want
	    // volume panel expanding when hovered or active
	
	
	    if (this.volumeControl.hasClass('vjs-hidden') && !this.muteToggle.hasClass('vjs-hidden')) {
	      this.addClass('vjs-mute-toggle-only');
	    }
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    var orientationClass = 'vjs-volume-panel-horizontal';
	
	    if (!this.options_.inline) {
	      orientationClass = 'vjs-volume-panel-vertical';
	    }
	
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: "vjs-volume-panel vjs-control " + orientationClass
	    });
	  }
	  /**
	   * Dispose of the `volume-panel` and all child components.
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.handleMouseOut();
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Handles `keyup` events on the `VolumeControl`, looking for ESC, which closes
	   * the volume panel and sets focus on `MuteToggle`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keyup` event that caused this function to be called.
	   *
	   * @listens keyup
	   */
	  ;
	
	  _proto.handleVolumeControlKeyUp = function handleVolumeControlKeyUp(event) {
	    if (keycode__default['default'].isEventKey(event, 'Esc')) {
	      this.muteToggle.focus();
	    }
	  }
	  /**
	   * This gets called when a `VolumePanel` gains hover via a `mouseover` event.
	   * Turns on listening for `mouseover` event. When they happen it
	   * calls `this.handleMouseOver`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `mouseover` event that caused this function to be called.
	   *
	   * @listens mouseover
	   */
	  ;
	
	  _proto.handleMouseOver = function handleMouseOver(event) {
	    this.addClass('vjs-hover');
	    on(document__default['default'], 'keyup', this.handleKeyPressHandler_);
	  }
	  /**
	   * This gets called when a `VolumePanel` gains hover via a `mouseout` event.
	   * Turns on listening for `mouseout` event. When they happen it
	   * calls `this.handleMouseOut`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `mouseout` event that caused this function to be called.
	   *
	   * @listens mouseout
	   */
	  ;
	
	  _proto.handleMouseOut = function handleMouseOut(event) {
	    this.removeClass('vjs-hover');
	    off(document__default['default'], 'keyup', this.handleKeyPressHandler_);
	  }
	  /**
	   * Handles `keyup` event on the document or `keydown` event on the `VolumePanel`,
	   * looking for ESC, which hides the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        The keypress that triggered this event.
	   *
	   * @listens keydown | keyup
	   */
	  ;
	
	  _proto.handleKeyPress = function handleKeyPress(event) {
	    if (keycode__default['default'].isEventKey(event, 'Esc')) {
	      this.handleMouseOut();
	    }
	  };
	
	  return VolumePanel;
	}(Component$1);
	/**
	 * Default options for the `VolumeControl`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	VolumePanel.prototype.options_ = {
	  children: ['muteToggle', 'volumeControl']
	};
	Component$1.registerComponent('VolumePanel', VolumePanel);
	
	/**
	 * The Menu component is used to build popup menus, including subtitle and
	 * captions selection menus.
	 *
	 * @extends Component
	 */
	
	var Menu = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Menu, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        the player that this component should attach to
	   *
	   * @param {Object} [options]
	   *        Object of option names and values
	   *
	   */
	  function Menu(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    if (options) {
	      _this.menuButton_ = options.menuButton;
	    }
	
	    _this.focusedChild_ = -1;
	
	    _this.on('keydown', function (e) {
	      return _this.handleKeyDown(e);
	    }); // All the menu item instances share the same blur handler provided by the menu container.
	
	
	    _this.boundHandleBlur_ = function (e) {
	      return _this.handleBlur(e);
	    };
	
	    _this.boundHandleTapClick_ = function (e) {
	      return _this.handleTapClick(e);
	    };
	
	    return _this;
	  }
	  /**
	   * Add event listeners to the {@link MenuItem}.
	   *
	   * @param {Object} component
	   *        The instance of the `MenuItem` to add listeners to.
	   *
	   */
	
	
	  var _proto = Menu.prototype;
	
	  _proto.addEventListenerForItem = function addEventListenerForItem(component) {
	    if (!(component instanceof Component$1)) {
	      return;
	    }
	
	    this.on(component, 'blur', this.boundHandleBlur_);
	    this.on(component, ['tap', 'click'], this.boundHandleTapClick_);
	  }
	  /**
	   * Remove event listeners from the {@link MenuItem}.
	   *
	   * @param {Object} component
	   *        The instance of the `MenuItem` to remove listeners.
	   *
	   */
	  ;
	
	  _proto.removeEventListenerForItem = function removeEventListenerForItem(component) {
	    if (!(component instanceof Component$1)) {
	      return;
	    }
	
	    this.off(component, 'blur', this.boundHandleBlur_);
	    this.off(component, ['tap', 'click'], this.boundHandleTapClick_);
	  }
	  /**
	   * This method will be called indirectly when the component has been added
	   * before the component adds to the new menu instance by `addItem`.
	   * In this case, the original menu instance will remove the component
	   * by calling `removeChild`.
	   *
	   * @param {Object} component
	   *        The instance of the `MenuItem`
	   */
	  ;
	
	  _proto.removeChild = function removeChild(component) {
	    if (typeof component === 'string') {
	      component = this.getChild(component);
	    }
	
	    this.removeEventListenerForItem(component);
	
	    _Component.prototype.removeChild.call(this, component);
	  }
	  /**
	   * Add a {@link MenuItem} to the menu.
	   *
	   * @param {Object|string} component
	   *        The name or instance of the `MenuItem` to add.
	   *
	   */
	  ;
	
	  _proto.addItem = function addItem(component) {
	    var childComponent = this.addChild(component);
	
	    if (childComponent) {
	      this.addEventListenerForItem(childComponent);
	    }
	  }
	  /**
	   * Create the `Menu`s DOM element.
	   *
	   * @return {Element}
	   *         the element that was created
	   */
	  ;
	
	  _proto.createEl = function createEl$1() {
	    var contentElType = this.options_.contentElType || 'ul';
	    this.contentEl_ = createEl(contentElType, {
	      className: 'vjs-menu-content'
	    });
	    this.contentEl_.setAttribute('role', 'menu');
	
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      append: this.contentEl_,
	      className: 'vjs-menu'
	    });
	
	    el.appendChild(this.contentEl_); // Prevent clicks from bubbling up. Needed for Menu Buttons,
	    // where a click on the parent is significant
	
	    on(el, 'click', function (event) {
	      event.preventDefault();
	      event.stopImmediatePropagation();
	    });
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.contentEl_ = null;
	    this.boundHandleBlur_ = null;
	    this.boundHandleTapClick_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Called when a `MenuItem` loses focus.
	   *
	   * @param {EventTarget~Event} event
	   *        The `blur` event that caused this function to be called.
	   *
	   * @listens blur
	   */
	  ;
	
	  _proto.handleBlur = function handleBlur(event) {
	    var relatedTarget = event.relatedTarget || document__default['default'].activeElement; // Close menu popup when a user clicks outside the menu
	
	    if (!this.children().some(function (element) {
	      return element.el() === relatedTarget;
	    })) {
	      var btn = this.menuButton_;
	
	      if (btn && btn.buttonPressed_ && relatedTarget !== btn.el().firstChild) {
	        btn.unpressButton();
	      }
	    }
	  }
	  /**
	   * Called when a `MenuItem` gets clicked or tapped.
	   *
	   * @param {EventTarget~Event} event
	   *        The `click` or `tap` event that caused this function to be called.
	   *
	   * @listens click,tap
	   */
	  ;
	
	  _proto.handleTapClick = function handleTapClick(event) {
	    // Unpress the associated MenuButton, and move focus back to it
	    if (this.menuButton_) {
	      this.menuButton_.unpressButton();
	      var childComponents = this.children();
	
	      if (!Array.isArray(childComponents)) {
	        return;
	      }
	
	      var foundComponent = childComponents.filter(function (component) {
	        return component.el() === event.target;
	      })[0];
	
	      if (!foundComponent) {
	        return;
	      } // don't focus menu button if item is a caption settings item
	      // because focus will move elsewhere
	
	
	      if (foundComponent.name() !== 'CaptionSettingsMenuItem') {
	        this.menuButton_.focus();
	      }
	    }
	  }
	  /**
	   * Handle a `keydown` event on this menu. This listener is added in the constructor.
	   *
	   * @param {EventTarget~Event} event
	   *        A `keydown` event that happened on the menu.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Left and Down Arrows
	    if (keycode__default['default'].isEventKey(event, 'Left') || keycode__default['default'].isEventKey(event, 'Down')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.stepForward(); // Up and Right Arrows
	    } else if (keycode__default['default'].isEventKey(event, 'Right') || keycode__default['default'].isEventKey(event, 'Up')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.stepBack();
	    }
	  }
	  /**
	   * Move to next (lower) menu item for keyboard users.
	   */
	  ;
	
	  _proto.stepForward = function stepForward() {
	    var stepChild = 0;
	
	    if (this.focusedChild_ !== undefined) {
	      stepChild = this.focusedChild_ + 1;
	    }
	
	    this.focus(stepChild);
	  }
	  /**
	   * Move to previous (higher) menu item for keyboard users.
	   */
	  ;
	
	  _proto.stepBack = function stepBack() {
	    var stepChild = 0;
	
	    if (this.focusedChild_ !== undefined) {
	      stepChild = this.focusedChild_ - 1;
	    }
	
	    this.focus(stepChild);
	  }
	  /**
	   * Set focus on a {@link MenuItem} in the `Menu`.
	   *
	   * @param {Object|string} [item=0]
	   *        Index of child item set focus on.
	   */
	  ;
	
	  _proto.focus = function focus(item) {
	    if (item === void 0) {
	      item = 0;
	    }
	
	    var children = this.children().slice();
	    var haveTitle = children.length && children[0].hasClass('vjs-menu-title');
	
	    if (haveTitle) {
	      children.shift();
	    }
	
	    if (children.length > 0) {
	      if (item < 0) {
	        item = 0;
	      } else if (item >= children.length) {
	        item = children.length - 1;
	      }
	
	      this.focusedChild_ = item;
	      children[item].el_.focus();
	    }
	  };
	
	  return Menu;
	}(Component$1);
	
	Component$1.registerComponent('Menu', Menu);
	
	/**
	 * A `MenuButton` class for any popup {@link Menu}.
	 *
	 * @extends Component
	 */
	
	var MenuButton = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](MenuButton, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function MenuButton(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _Component.call(this, player, options) || this;
	    _this.menuButton_ = new Button(player, options);
	
	    _this.menuButton_.controlText(_this.controlText_);
	
	    _this.menuButton_.el_.setAttribute('aria-haspopup', 'true'); // Add buildCSSClass values to the button, not the wrapper
	
	
	    var buttonClass = Button.prototype.buildCSSClass();
	    _this.menuButton_.el_.className = _this.buildCSSClass() + ' ' + buttonClass;
	
	    _this.menuButton_.removeClass('vjs-control');
	
	    _this.addChild(_this.menuButton_);
	
	    _this.update();
	
	    _this.enabled_ = true;
	
	    var handleClick = function handleClick(e) {
	      return _this.handleClick(e);
	    };
	
	    _this.handleMenuKeyUp_ = function (e) {
	      return _this.handleMenuKeyUp(e);
	    };
	
	    _this.on(_this.menuButton_, 'tap', handleClick);
	
	    _this.on(_this.menuButton_, 'click', handleClick);
	
	    _this.on(_this.menuButton_, 'keydown', function (e) {
	      return _this.handleKeyDown(e);
	    });
	
	    _this.on(_this.menuButton_, 'mouseenter', function () {
	      _this.addClass('vjs-hover');
	
	      _this.menu.show();
	
	      on(document__default['default'], 'keyup', _this.handleMenuKeyUp_);
	    });
	
	    _this.on('mouseleave', function (e) {
	      return _this.handleMouseLeave(e);
	    });
	
	    _this.on('keydown', function (e) {
	      return _this.handleSubmenuKeyDown(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Update the menu based on the current state of its items.
	   */
	
	
	  var _proto = MenuButton.prototype;
	
	  _proto.update = function update() {
	    var menu = this.createMenu();
	
	    if (this.menu) {
	      this.menu.dispose();
	      this.removeChild(this.menu);
	    }
	
	    this.menu = menu;
	    this.addChild(menu);
	    /**
	     * Track the state of the menu button
	     *
	     * @type {Boolean}
	     * @private
	     */
	
	    this.buttonPressed_ = false;
	    this.menuButton_.el_.setAttribute('aria-expanded', 'false');
	
	    if (this.items && this.items.length <= this.hideThreshold_) {
	      this.hide();
	      this.menu.contentEl_.removeAttribute('role');
	    } else {
	      this.show();
	      this.menu.contentEl_.setAttribute('role', 'menu');
	    }
	  }
	  /**
	   * Create the menu and add all items to it.
	   *
	   * @return {Menu}
	   *         The constructed menu
	   */
	  ;
	
	  _proto.createMenu = function createMenu() {
	    var menu = new Menu(this.player_, {
	      menuButton: this
	    });
	    /**
	     * Hide the menu if the number of items is less than or equal to this threshold. This defaults
	     * to 0 and whenever we add items which can be hidden to the menu we'll increment it. We list
	     * it here because every time we run `createMenu` we need to reset the value.
	     *
	     * @protected
	     * @type {Number}
	     */
	
	    this.hideThreshold_ = 0; // Add a title list item to the top
	
	    if (this.options_.title) {
	      var titleEl = createEl('li', {
	        className: 'vjs-menu-title',
	        textContent: toTitleCase$1(this.options_.title),
	        tabIndex: -1
	      });
	      var titleComponent = new Component$1(this.player_, {
	        el: titleEl
	      });
	      menu.addItem(titleComponent);
	    }
	
	    this.items = this.createItems();
	
	    if (this.items) {
	      // Add menu items to the menu
	      for (var i = 0; i < this.items.length; i++) {
	        menu.addItem(this.items[i]);
	      }
	    }
	
	    return menu;
	  }
	  /**
	   * Create the list of menu items. Specific to each subclass.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.createItems = function createItems() {}
	  /**
	   * Create the `MenuButtons`s DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: this.buildWrapperCSSClass()
	    }, {});
	  }
	  /**
	   * Allow sub components to stack CSS class names for the wrapper element
	   *
	   * @return {string}
	   *         The constructed wrapper DOM `className`
	   */
	  ;
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    var menuButtonClass = 'vjs-menu-button'; // If the inline option is passed, we want to use different styles altogether.
	
	    if (this.options_.inline === true) {
	      menuButtonClass += '-inline';
	    } else {
	      menuButtonClass += '-popup';
	    } // TODO: Fix the CSS so that this isn't necessary
	
	
	    var buttonClass = Button.prototype.buildCSSClass();
	    return "vjs-menu-button " + menuButtonClass + " " + buttonClass + " " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    var menuButtonClass = 'vjs-menu-button'; // If the inline option is passed, we want to use different styles altogether.
	
	    if (this.options_.inline === true) {
	      menuButtonClass += '-inline';
	    } else {
	      menuButtonClass += '-popup';
	    }
	
	    return "vjs-menu-button " + menuButtonClass + " " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Get or set the localized control text that will be used for accessibility.
	   *
	   * > NOTE: This will come from the internal `menuButton_` element.
	   *
	   * @param {string} [text]
	   *        Control text for element.
	   *
	   * @param {Element} [el=this.menuButton_.el()]
	   *        Element to set the title on.
	   *
	   * @return {string}
	   *         - The control text when getting
	   */
	  ;
	
	  _proto.controlText = function controlText(text, el) {
	    if (el === void 0) {
	      el = this.menuButton_.el();
	    }
	
	    return this.menuButton_.controlText(text, el);
	  }
	  /**
	   * Dispose of the `menu-button` and all child components.
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.handleMouseLeave();
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Handle a click on a `MenuButton`.
	   * See {@link ClickableComponent#handleClick} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (this.buttonPressed_) {
	      this.unpressButton();
	    } else {
	      this.pressButton();
	    }
	  }
	  /**
	   * Handle `mouseleave` for `MenuButton`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `mouseleave` event that caused this function to be called.
	   *
	   * @listens mouseleave
	   */
	  ;
	
	  _proto.handleMouseLeave = function handleMouseLeave(event) {
	    this.removeClass('vjs-hover');
	    off(document__default['default'], 'keyup', this.handleMenuKeyUp_);
	  }
	  /**
	   * Set the focus to the actual button, not to this element
	   */
	  ;
	
	  _proto.focus = function focus() {
	    this.menuButton_.focus();
	  }
	  /**
	   * Remove the focus from the actual button, not this element
	   */
	  ;
	
	  _proto.blur = function blur() {
	    this.menuButton_.blur();
	  }
	  /**
	   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
	   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Escape or Tab unpress the 'button'
	    if (keycode__default['default'].isEventKey(event, 'Esc') || keycode__default['default'].isEventKey(event, 'Tab')) {
	      if (this.buttonPressed_) {
	        this.unpressButton();
	      } // Don't preventDefault for Tab key - we still want to lose focus
	
	
	      if (!keycode__default['default'].isEventKey(event, 'Tab')) {
	        event.preventDefault(); // Set focus back to the menu button's button
	
	        this.menuButton_.focus();
	      } // Up Arrow or Down Arrow also 'press' the button to open the menu
	
	    } else if (keycode__default['default'].isEventKey(event, 'Up') || keycode__default['default'].isEventKey(event, 'Down')) {
	      if (!this.buttonPressed_) {
	        event.preventDefault();
	        this.pressButton();
	      }
	    }
	  }
	  /**
	   * Handle a `keyup` event on a `MenuButton`. The listener for this is added in
	   * the constructor.
	   *
	   * @param {EventTarget~Event} event
	   *        Key press event
	   *
	   * @listens keyup
	   */
	  ;
	
	  _proto.handleMenuKeyUp = function handleMenuKeyUp(event) {
	    // Escape hides popup menu
	    if (keycode__default['default'].isEventKey(event, 'Esc') || keycode__default['default'].isEventKey(event, 'Tab')) {
	      this.removeClass('vjs-hover');
	    }
	  }
	  /**
	   * This method name now delegates to `handleSubmenuKeyDown`. This means
	   * anyone calling `handleSubmenuKeyPress` will not see their method calls
	   * stop working.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleSubmenuKeyPress = function handleSubmenuKeyPress(event) {
	    this.handleSubmenuKeyDown(event);
	  }
	  /**
	   * Handle a `keydown` event on a sub-menu. The listener for this is added in
	   * the constructor.
	   *
	   * @param {EventTarget~Event} event
	   *        Key press event
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleSubmenuKeyDown = function handleSubmenuKeyDown(event) {
	    // Escape or Tab unpress the 'button'
	    if (keycode__default['default'].isEventKey(event, 'Esc') || keycode__default['default'].isEventKey(event, 'Tab')) {
	      if (this.buttonPressed_) {
	        this.unpressButton();
	      } // Don't preventDefault for Tab key - we still want to lose focus
	
	
	      if (!keycode__default['default'].isEventKey(event, 'Tab')) {
	        event.preventDefault(); // Set focus back to the menu button's button
	
	        this.menuButton_.focus();
	      }
	    }
	  }
	  /**
	   * Put the current `MenuButton` into a pressed state.
	   */
	  ;
	
	  _proto.pressButton = function pressButton() {
	    if (this.enabled_) {
	      this.buttonPressed_ = true;
	      this.menu.show();
	      this.menu.lockShowing();
	      this.menuButton_.el_.setAttribute('aria-expanded', 'true'); // set the focus into the submenu, except on iOS where it is resulting in
	      // undesired scrolling behavior when the player is in an iframe
	
	      if (IS_IOS && isInFrame()) {
	        // Return early so that the menu isn't focused
	        return;
	      }
	
	      this.menu.focus();
	    }
	  }
	  /**
	   * Take the current `MenuButton` out of a pressed state.
	   */
	  ;
	
	  _proto.unpressButton = function unpressButton() {
	    if (this.enabled_) {
	      this.buttonPressed_ = false;
	      this.menu.unlockShowing();
	      this.menu.hide();
	      this.menuButton_.el_.setAttribute('aria-expanded', 'false');
	    }
	  }
	  /**
	   * Disable the `MenuButton`. Don't allow it to be clicked.
	   */
	  ;
	
	  _proto.disable = function disable() {
	    this.unpressButton();
	    this.enabled_ = false;
	    this.addClass('vjs-disabled');
	    this.menuButton_.disable();
	  }
	  /**
	   * Enable the `MenuButton`. Allow it to be clicked.
	   */
	  ;
	
	  _proto.enable = function enable() {
	    this.enabled_ = true;
	    this.removeClass('vjs-disabled');
	    this.menuButton_.enable();
	  };
	
	  return MenuButton;
	}(Component$1);
	
	Component$1.registerComponent('MenuButton', MenuButton);
	
	/**
	 * The base class for buttons that toggle specific  track types (e.g. subtitles).
	 *
	 * @extends MenuButton
	 */
	
	var TrackButton = /*#__PURE__*/function (_MenuButton) {
	  _inheritsLoose__default['default'](TrackButton, _MenuButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TrackButton(player, options) {
	    var _this;
	
	    var tracks = options.tracks;
	    _this = _MenuButton.call(this, player, options) || this;
	
	    if (_this.items.length <= 1) {
	      _this.hide();
	    }
	
	    if (!tracks) {
	      return _assertThisInitialized__default['default'](_this);
	    }
	
	    var updateHandler = bind(_assertThisInitialized__default['default'](_this), _this.update);
	    tracks.addEventListener('removetrack', updateHandler);
	    tracks.addEventListener('addtrack', updateHandler);
	    tracks.addEventListener('labelchange', updateHandler);
	
	    _this.player_.on('ready', updateHandler);
	
	    _this.player_.on('dispose', function () {
	      tracks.removeEventListener('removetrack', updateHandler);
	      tracks.removeEventListener('addtrack', updateHandler);
	      tracks.removeEventListener('labelchange', updateHandler);
	    });
	
	    return _this;
	  }
	
	  return TrackButton;
	}(MenuButton);
	
	Component$1.registerComponent('TrackButton', TrackButton);
	
	/**
	 * @file menu-keys.js
	 */
	
	/**
	  * All keys used for operation of a menu (`MenuButton`, `Menu`, and `MenuItem`)
	  * Note that 'Enter' and 'Space' are not included here (otherwise they would
	  * prevent the `MenuButton` and `MenuItem` from being keyboard-clickable)
	  * @typedef MenuKeys
	  * @array
	  */
	var MenuKeys = ['Tab', 'Esc', 'Up', 'Down', 'Right', 'Left'];
	
	/**
	 * The component for a menu item. `<li>`
	 *
	 * @extends ClickableComponent
	 */
	
	var MenuItem = /*#__PURE__*/function (_ClickableComponent) {
	  _inheritsLoose__default['default'](MenuItem, _ClickableComponent);
	
	  /**
	   * Creates an instance of the this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   *
	   */
	  function MenuItem(player, options) {
	    var _this;
	
	    _this = _ClickableComponent.call(this, player, options) || this;
	    _this.selectable = options.selectable;
	    _this.isSelected_ = options.selected || false;
	    _this.multiSelectable = options.multiSelectable;
	
	    _this.selected(_this.isSelected_);
	
	    if (_this.selectable) {
	      if (_this.multiSelectable) {
	        _this.el_.setAttribute('role', 'menuitemcheckbox');
	      } else {
	        _this.el_.setAttribute('role', 'menuitemradio');
	      }
	    } else {
	      _this.el_.setAttribute('role', 'menuitem');
	    }
	
	    return _this;
	  }
	  /**
	   * Create the `MenuItem's DOM element
	   *
	   * @param {string} [type=li]
	   *        Element's node type, not actually used, always set to `li`.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element
	   *
	   * @param {Object} [attrs={}]
	   *        An object of attributes that should be set on the element
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  var _proto = MenuItem.prototype;
	
	  _proto.createEl = function createEl$1(type, props, attrs) {
	    // The control is textual, not just an icon
	    this.nonIconControl = true;
	
	    var el = _ClickableComponent.prototype.createEl.call(this, 'li', assign({
	      className: 'vjs-menu-item',
	      tabIndex: -1
	    }, props), attrs); // swap icon with menu item text.
	
	
	    el.replaceChild(createEl('span', {
	      className: 'vjs-menu-item-text',
	      textContent: this.localize(this.options_.label)
	    }), el.querySelector('.vjs-icon-placeholder'));
	    return el;
	  }
	  /**
	   * Ignore keys which are used by the menu, but pass any other ones up. See
	   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    if (!MenuKeys.some(function (key) {
	      return keycode__default['default'].isEventKey(event, key);
	    })) {
	      // Pass keydown handling up for unused keys
	      _ClickableComponent.prototype.handleKeyDown.call(this, event);
	    }
	  }
	  /**
	   * Any click on a `MenuItem` puts it into the selected state.
	   * See {@link ClickableComponent#handleClick} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    this.selected(true);
	  }
	  /**
	   * Set the state for this menu item as selected or not.
	   *
	   * @param {boolean} selected
	   *        if the menu item is selected or not
	   */
	  ;
	
	  _proto.selected = function selected(_selected) {
	    if (this.selectable) {
	      if (_selected) {
	        this.addClass('vjs-selected');
	        this.el_.setAttribute('aria-checked', 'true'); // aria-checked isn't fully supported by browsers/screen readers,
	        // so indicate selected state to screen reader in the control text.
	
	        this.controlText(', selected');
	        this.isSelected_ = true;
	      } else {
	        this.removeClass('vjs-selected');
	        this.el_.setAttribute('aria-checked', 'false'); // Indicate un-selected state to screen reader
	
	        this.controlText('');
	        this.isSelected_ = false;
	      }
	    }
	  };
	
	  return MenuItem;
	}(ClickableComponent);
	
	Component$1.registerComponent('MenuItem', MenuItem);
	
	/**
	 * The specific menu item type for selecting a language within a text track kind
	 *
	 * @extends MenuItem
	 */
	
	var TextTrackMenuItem = /*#__PURE__*/function (_MenuItem) {
	  _inheritsLoose__default['default'](TextTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TextTrackMenuItem(player, options) {
	    var _this;
	
	    var track = options.track;
	    var tracks = player.textTracks(); // Modify options for parent MenuItem class's init.
	
	    options.label = track.label || track.language || 'Unknown';
	    options.selected = track.mode === 'showing';
	    _this = _MenuItem.call(this, player, options) || this;
	    _this.track = track; // Determine the relevant kind(s) of tracks for this component and filter
	    // out empty kinds.
	
	    _this.kinds = (options.kinds || [options.kind || _this.track.kind]).filter(Boolean);
	
	    var changeHandler = function changeHandler() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this.handleTracksChange.apply(_assertThisInitialized__default['default'](_this), args);
	    };
	
	    var selectedLanguageChangeHandler = function selectedLanguageChangeHandler() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      _this.handleSelectedLanguageChange.apply(_assertThisInitialized__default['default'](_this), args);
	    };
	
	    player.on(['loadstart', 'texttrackchange'], changeHandler);
	    tracks.addEventListener('change', changeHandler);
	    tracks.addEventListener('selectedlanguagechange', selectedLanguageChangeHandler);
	
	    _this.on('dispose', function () {
	      player.off(['loadstart', 'texttrackchange'], changeHandler);
	      tracks.removeEventListener('change', changeHandler);
	      tracks.removeEventListener('selectedlanguagechange', selectedLanguageChangeHandler);
	    }); // iOS7 doesn't dispatch change events to TextTrackLists when an
	    // associated track's mode changes. Without something like
	    // Object.observe() (also not present on iOS7), it's not
	    // possible to detect changes to the mode attribute and polyfill
	    // the change event. As a poor substitute, we manually dispatch
	    // change events whenever the controls modify the mode.
	
	
	    if (tracks.onchange === undefined) {
	      var event;
	
	      _this.on(['tap', 'click'], function () {
	        if (typeof window__default['default'].Event !== 'object') {
	          // Android 2.3 throws an Illegal Constructor error for window.Event
	          try {
	            event = new window__default['default'].Event('change');
	          } catch (err) {// continue regardless of error
	          }
	        }
	
	        if (!event) {
	          event = document__default['default'].createEvent('Event');
	          event.initEvent('change', true, true);
	        }
	
	        tracks.dispatchEvent(event);
	      });
	    } // set the default state based on current tracks
	
	
	    _this.handleTracksChange();
	
	    return _this;
	  }
	  /**
	   * This gets called when an `TextTrackMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  var _proto = TextTrackMenuItem.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    var referenceTrack = this.track;
	    var tracks = this.player_.textTracks();
	
	    _MenuItem.prototype.handleClick.call(this, event);
	
	    if (!tracks) {
	      return;
	    }
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i]; // If the track from the text tracks list is not of the right kind,
	      // skip it. We do not want to affect tracks of incompatible kind(s).
	
	      if (this.kinds.indexOf(track.kind) === -1) {
	        continue;
	      } // If this text track is the component's track and it is not showing,
	      // set it to showing.
	
	
	      if (track === referenceTrack) {
	        if (track.mode !== 'showing') {
	          track.mode = 'showing';
	        } // If this text track is not the component's track and it is not
	        // disabled, set it to disabled.
	
	      } else if (track.mode !== 'disabled') {
	        track.mode = 'disabled';
	      }
	    }
	  }
	  /**
	   * Handle text track list change
	   *
	   * @param {EventTarget~Event} event
	   *        The `change` event that caused this function to be called.
	   *
	   * @listens TextTrackList#change
	   */
	  ;
	
	  _proto.handleTracksChange = function handleTracksChange(event) {
	    var shouldBeSelected = this.track.mode === 'showing'; // Prevent redundant selected() calls because they may cause
	    // screen readers to read the appended control text unnecessarily
	
	    if (shouldBeSelected !== this.isSelected_) {
	      this.selected(shouldBeSelected);
	    }
	  };
	
	  _proto.handleSelectedLanguageChange = function handleSelectedLanguageChange(event) {
	    if (this.track.mode === 'showing') {
	      var selectedLanguage = this.player_.cache_.selectedLanguage; // Don't replace the kind of track across the same language
	
	      if (selectedLanguage && selectedLanguage.enabled && selectedLanguage.language === this.track.language && selectedLanguage.kind !== this.track.kind) {
	        return;
	      }
	
	      this.player_.cache_.selectedLanguage = {
	        enabled: true,
	        language: this.track.language,
	        kind: this.track.kind
	      };
	    }
	  };
	
	  _proto.dispose = function dispose() {
	    // remove reference to track object on dispose
	    this.track = null;
	
	    _MenuItem.prototype.dispose.call(this);
	  };
	
	  return TextTrackMenuItem;
	}(MenuItem);
	
	Component$1.registerComponent('TextTrackMenuItem', TextTrackMenuItem);
	
	/**
	 * A special menu item for turning of a specific type of text track
	 *
	 * @extends TextTrackMenuItem
	 */
	
	var OffTextTrackMenuItem = /*#__PURE__*/function (_TextTrackMenuItem) {
	  _inheritsLoose__default['default'](OffTextTrackMenuItem, _TextTrackMenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function OffTextTrackMenuItem(player, options) {
	    // Create pseudo track info
	    // Requires options['kind']
	    options.track = {
	      player: player,
	      // it is no longer necessary to store `kind` or `kinds` on the track itself
	      // since they are now stored in the `kinds` property of all instances of
	      // TextTrackMenuItem, but this will remain for backwards compatibility
	      kind: options.kind,
	      kinds: options.kinds,
	      "default": false,
	      mode: 'disabled'
	    };
	
	    if (!options.kinds) {
	      options.kinds = [options.kind];
	    }
	
	    if (options.label) {
	      options.track.label = options.label;
	    } else {
	      options.track.label = options.kinds.join(' and ') + ' off';
	    } // MenuItem is selectable
	
	
	    options.selectable = true; // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
	
	    options.multiSelectable = false;
	    return _TextTrackMenuItem.call(this, player, options) || this;
	  }
	  /**
	   * Handle text track change
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run
	   */
	
	
	  var _proto = OffTextTrackMenuItem.prototype;
	
	  _proto.handleTracksChange = function handleTracksChange(event) {
	    var tracks = this.player().textTracks();
	    var shouldBeSelected = true;
	
	    for (var i = 0, l = tracks.length; i < l; i++) {
	      var track = tracks[i];
	
	      if (this.options_.kinds.indexOf(track.kind) > -1 && track.mode === 'showing') {
	        shouldBeSelected = false;
	        break;
	      }
	    } // Prevent redundant selected() calls because they may cause
	    // screen readers to read the appended control text unnecessarily
	
	
	    if (shouldBeSelected !== this.isSelected_) {
	      this.selected(shouldBeSelected);
	    }
	  };
	
	  _proto.handleSelectedLanguageChange = function handleSelectedLanguageChange(event) {
	    var tracks = this.player().textTracks();
	    var allHidden = true;
	
	    for (var i = 0, l = tracks.length; i < l; i++) {
	      var track = tracks[i];
	
	      if (['captions', 'descriptions', 'subtitles'].indexOf(track.kind) > -1 && track.mode === 'showing') {
	        allHidden = false;
	        break;
	      }
	    }
	
	    if (allHidden) {
	      this.player_.cache_.selectedLanguage = {
	        enabled: false
	      };
	    }
	  };
	
	  return OffTextTrackMenuItem;
	}(TextTrackMenuItem);
	
	Component$1.registerComponent('OffTextTrackMenuItem', OffTextTrackMenuItem);
	
	/**
	 * The base class for buttons that toggle specific text track types (e.g. subtitles)
	 *
	 * @extends MenuButton
	 */
	
	var TextTrackButton = /*#__PURE__*/function (_TrackButton) {
	  _inheritsLoose__default['default'](TextTrackButton, _TrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function TextTrackButton(player, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    options.tracks = player.textTracks();
	    return _TrackButton.call(this, player, options) || this;
	  }
	  /**
	   * Create a menu item for each text track
	   *
	   * @param {TextTrackMenuItem[]} [items=[]]
	   *        Existing array of items to use during creation
	   *
	   * @return {TextTrackMenuItem[]}
	   *         Array of menu items that were created
	   */
	
	
	  var _proto = TextTrackButton.prototype;
	
	  _proto.createItems = function createItems(items, TrackMenuItem) {
	    if (items === void 0) {
	      items = [];
	    }
	
	    if (TrackMenuItem === void 0) {
	      TrackMenuItem = TextTrackMenuItem;
	    }
	
	    // Label is an override for the [track] off label
	    // USed to localise captions/subtitles
	    var label;
	
	    if (this.label_) {
	      label = this.label_ + " off";
	    } // Add an OFF menu item to turn all tracks off
	
	
	    items.push(new OffTextTrackMenuItem(this.player_, {
	      kinds: this.kinds_,
	      kind: this.kind_,
	      label: label
	    }));
	    this.hideThreshold_ += 1;
	    var tracks = this.player_.textTracks();
	
	    if (!Array.isArray(this.kinds_)) {
	      this.kinds_ = [this.kind_];
	    }
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i]; // only add tracks that are of an appropriate kind and have a label
	
	      if (this.kinds_.indexOf(track.kind) > -1) {
	        var item = new TrackMenuItem(this.player_, {
	          track: track,
	          kinds: this.kinds_,
	          kind: this.kind_,
	          // MenuItem is selectable
	          selectable: true,
	          // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
	          multiSelectable: false
	        });
	        item.addClass("vjs-" + track.kind + "-menu-item");
	        items.push(item);
	      }
	    }
	
	    return items;
	  };
	
	  return TextTrackButton;
	}(TrackButton);
	
	Component$1.registerComponent('TextTrackButton', TextTrackButton);
	
	/**
	 * The chapter track menu item
	 *
	 * @extends MenuItem
	 */
	
	var ChaptersTrackMenuItem = /*#__PURE__*/function (_MenuItem) {
	  _inheritsLoose__default['default'](ChaptersTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function ChaptersTrackMenuItem(player, options) {
	    var _this;
	
	    var track = options.track;
	    var cue = options.cue;
	    var currentTime = player.currentTime(); // Modify options for parent MenuItem class's init.
	
	    options.selectable = true;
	    options.multiSelectable = false;
	    options.label = cue.text;
	    options.selected = cue.startTime <= currentTime && currentTime < cue.endTime;
	    _this = _MenuItem.call(this, player, options) || this;
	    _this.track = track;
	    _this.cue = cue;
	    return _this;
	  }
	  /**
	   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  var _proto = ChaptersTrackMenuItem.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    _MenuItem.prototype.handleClick.call(this);
	
	    this.player_.currentTime(this.cue.startTime);
	  };
	
	  return ChaptersTrackMenuItem;
	}(MenuItem);
	
	Component$1.registerComponent('ChaptersTrackMenuItem', ChaptersTrackMenuItem);
	
	/**
	 * The button component for toggling and selecting chapters
	 * Chapters act much differently than other text tracks
	 * Cues are navigation vs. other tracks of alternative languages
	 *
	 * @extends TextTrackButton
	 */
	
	var ChaptersButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](ChaptersButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this function is ready.
	   */
	  function ChaptersButton(player, options, ready) {
	    var _this;
	
	    _this = _TextTrackButton.call(this, player, options, ready) || this;
	
	    _this.selectCurrentItem_ = function () {
	      _this.items.forEach(function (item) {
	        item.selected(_this.track_.activeCues[0] === item.cue);
	      });
	    };
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = ChaptersButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-chapters-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-chapters-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Update the menu based on the current state of its items.
	   *
	   * @param {EventTarget~Event} [event]
	   *        An event that triggered this function to run.
	   *
	   * @listens TextTrackList#addtrack
	   * @listens TextTrackList#removetrack
	   * @listens TextTrackList#change
	   */
	  ;
	
	  _proto.update = function update(event) {
	    if (event && event.track && event.track.kind !== 'chapters') {
	      return;
	    }
	
	    var track = this.findChaptersTrack();
	
	    if (track !== this.track_) {
	      this.setTrack(track);
	
	      _TextTrackButton.prototype.update.call(this);
	    } else if (!this.items || track && track.cues && track.cues.length !== this.items.length) {
	      // Update the menu initially or if the number of cues has changed since set
	      _TextTrackButton.prototype.update.call(this);
	    }
	  }
	  /**
	   * Set the currently selected track for the chapters button.
	   *
	   * @param {TextTrack} track
	   *        The new track to select. Nothing will change if this is the currently selected
	   *        track.
	   */
	  ;
	
	  _proto.setTrack = function setTrack(track) {
	    if (this.track_ === track) {
	      return;
	    }
	
	    if (!this.updateHandler_) {
	      this.updateHandler_ = this.update.bind(this);
	    } // here this.track_ refers to the old track instance
	
	
	    if (this.track_) {
	      var remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
	
	      if (remoteTextTrackEl) {
	        remoteTextTrackEl.removeEventListener('load', this.updateHandler_);
	      }
	
	      this.track_.removeEventListener('cuechange', this.selectCurrentItem_);
	      this.track_ = null;
	    }
	
	    this.track_ = track; // here this.track_ refers to the new track instance
	
	    if (this.track_) {
	      this.track_.mode = 'hidden';
	
	      var _remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
	
	      if (_remoteTextTrackEl) {
	        _remoteTextTrackEl.addEventListener('load', this.updateHandler_);
	      }
	
	      this.track_.addEventListener('cuechange', this.selectCurrentItem_);
	    }
	  }
	  /**
	   * Find the track object that is currently in use by this ChaptersButton
	   *
	   * @return {TextTrack|undefined}
	   *         The current track or undefined if none was found.
	   */
	  ;
	
	  _proto.findChaptersTrack = function findChaptersTrack() {
	    var tracks = this.player_.textTracks() || [];
	
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      // We will always choose the last track as our chaptersTrack
	      var track = tracks[i];
	
	      if (track.kind === this.kind_) {
	        return track;
	      }
	    }
	  }
	  /**
	   * Get the caption for the ChaptersButton based on the track label. This will also
	   * use the current tracks localized kind as a fallback if a label does not exist.
	   *
	   * @return {string}
	   *         The tracks current label or the localized track kind.
	   */
	  ;
	
	  _proto.getMenuCaption = function getMenuCaption() {
	    if (this.track_ && this.track_.label) {
	      return this.track_.label;
	    }
	
	    return this.localize(toTitleCase$1(this.kind_));
	  }
	  /**
	   * Create menu from chapter track
	   *
	   * @return {Menu}
	   *         New menu for the chapter buttons
	   */
	  ;
	
	  _proto.createMenu = function createMenu() {
	    this.options_.title = this.getMenuCaption();
	    return _TextTrackButton.prototype.createMenu.call(this);
	  }
	  /**
	   * Create a menu item for each text track
	   *
	   * @return {TextTrackMenuItem[]}
	   *         Array of menu items
	   */
	  ;
	
	  _proto.createItems = function createItems() {
	    var items = [];
	
	    if (!this.track_) {
	      return items;
	    }
	
	    var cues = this.track_.cues;
	
	    if (!cues) {
	      return items;
	    }
	
	    for (var i = 0, l = cues.length; i < l; i++) {
	      var cue = cues[i];
	      var mi = new ChaptersTrackMenuItem(this.player_, {
	        track: this.track_,
	        cue: cue
	      });
	      items.push(mi);
	    }
	
	    return items;
	  };
	
	  return ChaptersButton;
	}(TextTrackButton);
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	ChaptersButton.prototype.kind_ = 'chapters';
	/**
	 * The text that should display over the `ChaptersButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	ChaptersButton.prototype.controlText_ = 'Chapters';
	Component$1.registerComponent('ChaptersButton', ChaptersButton);
	
	/**
	 * The button component for toggling and selecting descriptions
	 *
	 * @extends TextTrackButton
	 */
	
	var DescriptionsButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](DescriptionsButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function DescriptionsButton(player, options, ready) {
	    var _this;
	
	    _this = _TextTrackButton.call(this, player, options, ready) || this;
	    var tracks = player.textTracks();
	    var changeHandler = bind(_assertThisInitialized__default['default'](_this), _this.handleTracksChange);
	    tracks.addEventListener('change', changeHandler);
	
	    _this.on('dispose', function () {
	      tracks.removeEventListener('change', changeHandler);
	    });
	
	    return _this;
	  }
	  /**
	   * Handle text track change
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run
	   *
	   * @listens TextTrackList#change
	   */
	
	
	  var _proto = DescriptionsButton.prototype;
	
	  _proto.handleTracksChange = function handleTracksChange(event) {
	    var tracks = this.player().textTracks();
	    var disabled = false; // Check whether a track of a different kind is showing
	
	    for (var i = 0, l = tracks.length; i < l; i++) {
	      var track = tracks[i];
	
	      if (track.kind !== this.kind_ && track.mode === 'showing') {
	        disabled = true;
	        break;
	      }
	    } // If another track is showing, disable this menu button
	
	
	    if (disabled) {
	      this.disable();
	    } else {
	      this.enable();
	    }
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-descriptions-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-descriptions-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  };
	
	  return DescriptionsButton;
	}(TextTrackButton);
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	DescriptionsButton.prototype.kind_ = 'descriptions';
	/**
	 * The text that should display over the `DescriptionsButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	DescriptionsButton.prototype.controlText_ = 'Descriptions';
	Component$1.registerComponent('DescriptionsButton', DescriptionsButton);
	
	/**
	 * The button component for toggling and selecting subtitles
	 *
	 * @extends TextTrackButton
	 */
	
	var SubtitlesButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](SubtitlesButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function SubtitlesButton(player, options, ready) {
	    return _TextTrackButton.call(this, player, options, ready) || this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = SubtitlesButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-subtitles-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-subtitles-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  };
	
	  return SubtitlesButton;
	}(TextTrackButton);
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	SubtitlesButton.prototype.kind_ = 'subtitles';
	/**
	 * The text that should display over the `SubtitlesButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	SubtitlesButton.prototype.controlText_ = 'Subtitles';
	Component$1.registerComponent('SubtitlesButton', SubtitlesButton);
	
	/**
	 * The menu item for caption track settings menu
	 *
	 * @extends TextTrackMenuItem
	 */
	
	var CaptionSettingsMenuItem = /*#__PURE__*/function (_TextTrackMenuItem) {
	  _inheritsLoose__default['default'](CaptionSettingsMenuItem, _TextTrackMenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function CaptionSettingsMenuItem(player, options) {
	    var _this;
	
	    options.track = {
	      player: player,
	      kind: options.kind,
	      label: options.kind + ' settings',
	      selectable: false,
	      "default": false,
	      mode: 'disabled'
	    }; // CaptionSettingsMenuItem has no concept of 'selected'
	
	    options.selectable = false;
	    options.name = 'CaptionSettingsMenuItem';
	    _this = _TextTrackMenuItem.call(this, player, options) || this;
	
	    _this.addClass('vjs-texttrack-settings');
	
	    _this.controlText(', opens ' + options.kind + ' settings dialog');
	
	    return _this;
	  }
	  /**
	   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  var _proto = CaptionSettingsMenuItem.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    this.player().getChild('textTrackSettings').open();
	  };
	
	  return CaptionSettingsMenuItem;
	}(TextTrackMenuItem);
	
	Component$1.registerComponent('CaptionSettingsMenuItem', CaptionSettingsMenuItem);
	
	/**
	 * The button component for toggling and selecting captions
	 *
	 * @extends TextTrackButton
	 */
	
	var CaptionsButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](CaptionsButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function CaptionsButton(player, options, ready) {
	    return _TextTrackButton.call(this, player, options, ready) || this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = CaptionsButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-captions-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-captions-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Create caption menu items
	   *
	   * @return {CaptionSettingsMenuItem[]}
	   *         The array of current menu items.
	   */
	  ;
	
	  _proto.createItems = function createItems() {
	    var items = [];
	
	    if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild('textTrackSettings')) {
	      items.push(new CaptionSettingsMenuItem(this.player_, {
	        kind: this.kind_
	      }));
	      this.hideThreshold_ += 1;
	    }
	
	    return _TextTrackButton.prototype.createItems.call(this, items);
	  };
	
	  return CaptionsButton;
	}(TextTrackButton);
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	CaptionsButton.prototype.kind_ = 'captions';
	/**
	 * The text that should display over the `CaptionsButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	CaptionsButton.prototype.controlText_ = 'Captions';
	Component$1.registerComponent('CaptionsButton', CaptionsButton);
	
	/**
	 * SubsCapsMenuItem has an [cc] icon to distinguish captions from subtitles
	 * in the SubsCapsMenu.
	 *
	 * @extends TextTrackMenuItem
	 */
	
	var SubsCapsMenuItem = /*#__PURE__*/function (_TextTrackMenuItem) {
	  _inheritsLoose__default['default'](SubsCapsMenuItem, _TextTrackMenuItem);
	
	  function SubsCapsMenuItem() {
	    return _TextTrackMenuItem.apply(this, arguments) || this;
	  }
	
	  var _proto = SubsCapsMenuItem.prototype;
	
	  _proto.createEl = function createEl$1(type, props, attrs) {
	    var el = _TextTrackMenuItem.prototype.createEl.call(this, type, props, attrs);
	
	    var parentSpan = el.querySelector('.vjs-menu-item-text');
	
	    if (this.options_.track.kind === 'captions') {
	      parentSpan.appendChild(createEl('span', {
	        className: 'vjs-icon-placeholder'
	      }, {
	        'aria-hidden': true
	      }));
	      parentSpan.appendChild(createEl('span', {
	        className: 'vjs-control-text',
	        // space added as the text will visually flow with the
	        // label
	        textContent: " " + this.localize('Captions')
	      }));
	    }
	
	    return el;
	  };
	
	  return SubsCapsMenuItem;
	}(TextTrackMenuItem);
	
	Component$1.registerComponent('SubsCapsMenuItem', SubsCapsMenuItem);
	
	/**
	 * The button component for toggling and selecting captions and/or subtitles
	 *
	 * @extends TextTrackButton
	 */
	
	var SubsCapsButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](SubsCapsButton, _TextTrackButton);
	
	  function SubsCapsButton(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _TextTrackButton.call(this, player, options) || this; // Although North America uses "captions" in most cases for
	    // "captions and subtitles" other locales use "subtitles"
	
	    _this.label_ = 'subtitles';
	
	    if (['en', 'en-us', 'en-ca', 'fr-ca'].indexOf(_this.player_.language_) > -1) {
	      _this.label_ = 'captions';
	    }
	
	    _this.menuButton_.controlText(toTitleCase$1(_this.label_));
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = SubsCapsButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-subs-caps-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-subs-caps-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Create caption/subtitles menu items
	   *
	   * @return {CaptionSettingsMenuItem[]}
	   *         The array of current menu items.
	   */
	  ;
	
	  _proto.createItems = function createItems() {
	    var items = [];
	
	    if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild('textTrackSettings')) {
	      items.push(new CaptionSettingsMenuItem(this.player_, {
	        kind: this.label_
	      }));
	      this.hideThreshold_ += 1;
	    }
	
	    items = _TextTrackButton.prototype.createItems.call(this, items, SubsCapsMenuItem);
	    return items;
	  };
	
	  return SubsCapsButton;
	}(TextTrackButton);
	/**
	 * `kind`s of TextTrack to look for to associate it with this menu.
	 *
	 * @type {array}
	 * @private
	 */
	
	
	SubsCapsButton.prototype.kinds_ = ['captions', 'subtitles'];
	/**
	 * The text that should display over the `SubsCapsButton`s controls.
	 *
	 *
	 * @type {string}
	 * @private
	 */
	
	SubsCapsButton.prototype.controlText_ = 'Subtitles';
	Component$1.registerComponent('SubsCapsButton', SubsCapsButton);
	
	/**
	 * An {@link AudioTrack} {@link MenuItem}
	 *
	 * @extends MenuItem
	 */
	
	var AudioTrackMenuItem = /*#__PURE__*/function (_MenuItem) {
	  _inheritsLoose__default['default'](AudioTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function AudioTrackMenuItem(player, options) {
	    var _this;
	
	    var track = options.track;
	    var tracks = player.audioTracks(); // Modify options for parent MenuItem class's init.
	
	    options.label = track.label || track.language || 'Unknown';
	    options.selected = track.enabled;
	    _this = _MenuItem.call(this, player, options) || this;
	    _this.track = track;
	
	    _this.addClass("vjs-" + track.kind + "-menu-item");
	
	    var changeHandler = function changeHandler() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this.handleTracksChange.apply(_assertThisInitialized__default['default'](_this), args);
	    };
	
	    tracks.addEventListener('change', changeHandler);
	
	    _this.on('dispose', function () {
	      tracks.removeEventListener('change', changeHandler);
	    });
	
	    return _this;
	  }
	
	  var _proto = AudioTrackMenuItem.prototype;
	
	  _proto.createEl = function createEl$1(type, props, attrs) {
	    var el = _MenuItem.prototype.createEl.call(this, type, props, attrs);
	
	    var parentSpan = el.querySelector('.vjs-menu-item-text');
	
	    if (this.options_.track.kind === 'main-desc') {
	      parentSpan.appendChild(createEl('span', {
	        className: 'vjs-icon-placeholder'
	      }, {
	        'aria-hidden': true
	      }));
	      parentSpan.appendChild(createEl('span', {
	        className: 'vjs-control-text',
	        textContent: ' ' + this.localize('Descriptions')
	      }));
	    }
	
	    return el;
	  }
	  /**
	   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
	   * for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    _MenuItem.prototype.handleClick.call(this, event); // the audio track list will automatically toggle other tracks
	    // off for us.
	
	
	    this.track.enabled = true; // when native audio tracks are used, we want to make sure that other tracks are turned off
	
	    if (this.player_.tech_.featuresNativeAudioTracks) {
	      var tracks = this.player_.audioTracks();
	
	      for (var i = 0; i < tracks.length; i++) {
	        var track = tracks[i]; // skip the current track since we enabled it above
	
	        if (track === this.track) {
	          continue;
	        }
	
	        track.enabled = track === this.track;
	      }
	    }
	  }
	  /**
	   * Handle any {@link AudioTrack} change.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link AudioTrackList#change} event that caused this to run.
	   *
	   * @listens AudioTrackList#change
	   */
	  ;
	
	  _proto.handleTracksChange = function handleTracksChange(event) {
	    this.selected(this.track.enabled);
	  };
	
	  return AudioTrackMenuItem;
	}(MenuItem);
	
	Component$1.registerComponent('AudioTrackMenuItem', AudioTrackMenuItem);
	
	/**
	 * The base class for buttons that toggle specific {@link AudioTrack} types.
	 *
	 * @extends TrackButton
	 */
	
	var AudioTrackButton = /*#__PURE__*/function (_TrackButton) {
	  _inheritsLoose__default['default'](AudioTrackButton, _TrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function AudioTrackButton(player, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    options.tracks = player.audioTracks();
	    return _TrackButton.call(this, player, options) || this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = AudioTrackButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-audio-button " + _TrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-audio-button " + _TrackButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Create a menu item for each audio track
	   *
	   * @param {AudioTrackMenuItem[]} [items=[]]
	   *        An array of existing menu items to use.
	   *
	   * @return {AudioTrackMenuItem[]}
	   *         An array of menu items
	   */
	  ;
	
	  _proto.createItems = function createItems(items) {
	    if (items === void 0) {
	      items = [];
	    }
	
	    // if there's only one audio track, there no point in showing it
	    this.hideThreshold_ = 1;
	    var tracks = this.player_.audioTracks();
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i];
	      items.push(new AudioTrackMenuItem(this.player_, {
	        track: track,
	        // MenuItem is selectable
	        selectable: true,
	        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
	        multiSelectable: false
	      }));
	    }
	
	    return items;
	  };
	
	  return AudioTrackButton;
	}(TrackButton);
	/**
	 * The text that should display over the `AudioTrackButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	AudioTrackButton.prototype.controlText_ = 'Audio Track';
	Component$1.registerComponent('AudioTrackButton', AudioTrackButton);
	
	/**
	 * The specific menu item type for selecting a playback rate.
	 *
	 * @extends MenuItem
	 */
	
	var PlaybackRateMenuItem = /*#__PURE__*/function (_MenuItem) {
	  _inheritsLoose__default['default'](PlaybackRateMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlaybackRateMenuItem(player, options) {
	    var _this;
	
	    var label = options.rate;
	    var rate = parseFloat(label, 10); // Modify options for parent MenuItem class's init.
	
	    options.label = label;
	    options.selected = rate === player.playbackRate();
	    options.selectable = true;
	    options.multiSelectable = false;
	    _this = _MenuItem.call(this, player, options) || this;
	    _this.label = label;
	    _this.rate = rate;
	
	    _this.on(player, 'ratechange', function (e) {
	      return _this.update(e);
	    });
	
	    return _this;
	  }
	  /**
	   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  var _proto = PlaybackRateMenuItem.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    _MenuItem.prototype.handleClick.call(this);
	
	    this.player().playbackRate(this.rate);
	  }
	  /**
	   * Update the PlaybackRateMenuItem when the playbackrate changes.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `ratechange` event that caused this function to run.
	   *
	   * @listens Player#ratechange
	   */
	  ;
	
	  _proto.update = function update(event) {
	    this.selected(this.player().playbackRate() === this.rate);
	  };
	
	  return PlaybackRateMenuItem;
	}(MenuItem);
	/**
	 * The text that should display over the `PlaybackRateMenuItem`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlaybackRateMenuItem.prototype.contentElType = 'button';
	Component$1.registerComponent('PlaybackRateMenuItem', PlaybackRateMenuItem);
	
	/**
	 * The component for controlling the playback rate.
	 *
	 * @extends MenuButton
	 */
	
	var PlaybackRateMenuButton = /*#__PURE__*/function (_MenuButton) {
	  _inheritsLoose__default['default'](PlaybackRateMenuButton, _MenuButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlaybackRateMenuButton(player, options) {
	    var _this;
	
	    _this = _MenuButton.call(this, player, options) || this;
	
	    _this.menuButton_.el_.setAttribute('aria-describedby', _this.labelElId_);
	
	    _this.updateVisibility();
	
	    _this.updateLabel();
	
	    _this.on(player, 'loadstart', function (e) {
	      return _this.updateVisibility(e);
	    });
	
	    _this.on(player, 'ratechange', function (e) {
	      return _this.updateLabel(e);
	    });
	
	    _this.on(player, 'playbackrateschange', function (e) {
	      return _this.handlePlaybackRateschange(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = PlaybackRateMenuButton.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var el = _MenuButton.prototype.createEl.call(this);
	
	    this.labelElId_ = 'vjs-playback-rate-value-label-' + this.id_;
	    this.labelEl_ = createEl('div', {
	      className: 'vjs-playback-rate-value',
	      id: this.labelElId_,
	      textContent: '1x'
	    });
	    el.appendChild(this.labelEl_);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.labelEl_ = null;
	
	    _MenuButton.prototype.dispose.call(this);
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-playback-rate " + _MenuButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-playback-rate " + _MenuButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Create the list of menu items. Specific to each subclass.
	   *
	   */
	  ;
	
	  _proto.createItems = function createItems() {
	    var rates = this.playbackRates();
	    var items = [];
	
	    for (var i = rates.length - 1; i >= 0; i--) {
	      items.push(new PlaybackRateMenuItem(this.player(), {
	        rate: rates[i] + 'x'
	      }));
	    }
	
	    return items;
	  }
	  /**
	   * Updates ARIA accessibility attributes
	   */
	  ;
	
	  _proto.updateARIAAttributes = function updateARIAAttributes() {
	    // Current playback rate
	    this.el().setAttribute('aria-valuenow', this.player().playbackRate());
	  }
	  /**
	   * This gets called when an `PlaybackRateMenuButton` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    // select next rate option
	    var currentRate = this.player().playbackRate();
	    var rates = this.playbackRates();
	    var currentIndex = rates.indexOf(currentRate); // this get the next rate and it will select first one if the last one currently selected
	
	    var newIndex = (currentIndex + 1) % rates.length;
	    this.player().playbackRate(rates[newIndex]);
	  }
	  /**
	   * On playbackrateschange, update the menu to account for the new items.
	   *
	   * @listens Player#playbackrateschange
	   */
	  ;
	
	  _proto.handlePlaybackRateschange = function handlePlaybackRateschange(event) {
	    this.update();
	  }
	  /**
	   * Get possible playback rates
	   *
	   * @return {Array}
	   *         All possible playback rates
	   */
	  ;
	
	  _proto.playbackRates = function playbackRates() {
	    var player = this.player();
	    return player.playbackRates && player.playbackRates() || [];
	  }
	  /**
	   * Get whether playback rates is supported by the tech
	   * and an array of playback rates exists
	   *
	   * @return {boolean}
	   *         Whether changing playback rate is supported
	   */
	  ;
	
	  _proto.playbackRateSupported = function playbackRateSupported() {
	    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
	  }
	  /**
	   * Hide playback rate controls when they're no playback rate options to select
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#loadstart
	   */
	  ;
	
	  _proto.updateVisibility = function updateVisibility(event) {
	    if (this.playbackRateSupported()) {
	      this.removeClass('vjs-hidden');
	    } else {
	      this.addClass('vjs-hidden');
	    }
	  }
	  /**
	   * Update button label when rate changed
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#ratechange
	   */
	  ;
	
	  _proto.updateLabel = function updateLabel(event) {
	    if (this.playbackRateSupported()) {
	      this.labelEl_.textContent = this.player().playbackRate() + 'x';
	    }
	  };
	
	  return PlaybackRateMenuButton;
	}(MenuButton);
	/**
	 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlaybackRateMenuButton.prototype.controlText_ = 'Playback Rate';
	Component$1.registerComponent('PlaybackRateMenuButton', PlaybackRateMenuButton);
	
	/**
	 * Just an empty spacer element that can be used as an append point for plugins, etc.
	 * Also can be used to create space between elements when necessary.
	 *
	 * @extends Component
	 */
	
	var Spacer = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Spacer, _Component);
	
	  function Spacer() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Spacer.prototype;
	
	  /**
	  * Builds the default DOM `className`.
	  *
	  * @return {string}
	  *         The DOM `className` for this object.
	  */
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-spacer " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl(tag, props, attributes) {
	    if (tag === void 0) {
	      tag = 'div';
	    }
	
	    if (props === void 0) {
	      props = {};
	    }
	
	    if (attributes === void 0) {
	      attributes = {};
	    }
	
	    if (!props.className) {
	      props.className = this.buildCSSClass();
	    }
	
	    return _Component.prototype.createEl.call(this, tag, props, attributes);
	  };
	
	  return Spacer;
	}(Component$1);
	
	Component$1.registerComponent('Spacer', Spacer);
	
	/**
	 * Spacer specifically meant to be used as an insertion point for new plugins, etc.
	 *
	 * @extends Spacer
	 */
	
	var CustomControlSpacer = /*#__PURE__*/function (_Spacer) {
	  _inheritsLoose__default['default'](CustomControlSpacer, _Spacer);
	
	  function CustomControlSpacer() {
	    return _Spacer.apply(this, arguments) || this;
	  }
	
	  var _proto = CustomControlSpacer.prototype;
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-custom-control-spacer " + _Spacer.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    return _Spacer.prototype.createEl.call(this, 'div', {
	      className: this.buildCSSClass(),
	      // No-flex/table-cell mode requires there be some content
	      // in the cell to fill the remaining space of the table.
	      textContent: "\xA0"
	    });
	  };
	
	  return CustomControlSpacer;
	}(Spacer);
	
	Component$1.registerComponent('CustomControlSpacer', CustomControlSpacer);
	
	/**
	 * Container of main controls.
	 *
	 * @extends Component
	 */
	
	var ControlBar = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ControlBar, _Component);
	
	  function ControlBar() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ControlBar.prototype;
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-control-bar',
	      dir: 'ltr'
	    });
	  };
	
	  return ControlBar;
	}(Component$1);
	/**
	 * Default options for `ControlBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ControlBar.prototype.options_ = {
	  children: ['playToggle', 'volumePanel', 'currentTimeDisplay', 'timeDivider', 'durationDisplay', 'progressControl', 'liveDisplay', 'seekToLive', 'remainingTimeDisplay', 'customControlSpacer', 'playbackRateMenuButton', 'chaptersButton', 'descriptionsButton', 'subsCapsButton', 'audioTrackButton', 'fullscreenToggle']
	};
	
	if ('exitPictureInPicture' in document__default['default']) {
	  ControlBar.prototype.options_.children.splice(ControlBar.prototype.options_.children.length - 1, 0, 'pictureInPictureToggle');
	}
	
	Component$1.registerComponent('ControlBar', ControlBar);
	
	/**
	 * A display that indicates an error has occurred. This means that the video
	 * is unplayable.
	 *
	 * @extends ModalDialog
	 */
	
	var ErrorDisplay = /*#__PURE__*/function (_ModalDialog) {
	  _inheritsLoose__default['default'](ErrorDisplay, _ModalDialog);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param  {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param  {Object} [options]
	   *         The key/value store of player options.
	   */
	  function ErrorDisplay(player, options) {
	    var _this;
	
	    _this = _ModalDialog.call(this, player, options) || this;
	
	    _this.on(player, 'error', function (e) {
	      return _this.open(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   *
	   * @deprecated Since version 5.
	   */
	
	
	  var _proto = ErrorDisplay.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-error-display " + _ModalDialog.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Gets the localized error message based on the `Player`s error.
	   *
	   * @return {string}
	   *         The `Player`s error message localized or an empty string.
	   */
	  ;
	
	  _proto.content = function content() {
	    var error = this.player().error();
	    return error ? this.localize(error.message) : '';
	  };
	
	  return ErrorDisplay;
	}(ModalDialog);
	/**
	 * The default options for an `ErrorDisplay`.
	 *
	 * @private
	 */
	
	
	ErrorDisplay.prototype.options_ = _extends__default['default']({}, ModalDialog.prototype.options_, {
	  pauseOnOpen: false,
	  fillAlways: true,
	  temporary: false,
	  uncloseable: true
	});
	Component$1.registerComponent('ErrorDisplay', ErrorDisplay);
	
	var LOCAL_STORAGE_KEY$1 = 'vjs-text-track-settings';
	var COLOR_BLACK = ['#000', 'Black'];
	var COLOR_BLUE = ['#00F', 'Blue'];
	var COLOR_CYAN = ['#0FF', 'Cyan'];
	var COLOR_GREEN = ['#0F0', 'Green'];
	var COLOR_MAGENTA = ['#F0F', 'Magenta'];
	var COLOR_RED = ['#F00', 'Red'];
	var COLOR_WHITE = ['#FFF', 'White'];
	var COLOR_YELLOW = ['#FF0', 'Yellow'];
	var OPACITY_OPAQUE = ['1', 'Opaque'];
	var OPACITY_SEMI = ['0.5', 'Semi-Transparent'];
	var OPACITY_TRANS = ['0', 'Transparent']; // Configuration for the various <select> elements in the DOM of this component.
	//
	// Possible keys include:
	//
	// `default`:
	//   The default option index. Only needs to be provided if not zero.
	// `parser`:
	//   A function which is used to parse the value from the selected option in
	//   a customized way.
	// `selector`:
	//   The selector used to find the associated <select> element.
	
	var selectConfigs = {
	  backgroundColor: {
	    selector: '.vjs-bg-color > select',
	    id: 'captions-background-color-%s',
	    label: 'Color',
	    options: [COLOR_BLACK, COLOR_WHITE, COLOR_RED, COLOR_GREEN, COLOR_BLUE, COLOR_YELLOW, COLOR_MAGENTA, COLOR_CYAN]
	  },
	  backgroundOpacity: {
	    selector: '.vjs-bg-opacity > select',
	    id: 'captions-background-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_OPAQUE, OPACITY_SEMI, OPACITY_TRANS]
	  },
	  color: {
	    selector: '.vjs-fg-color > select',
	    id: 'captions-foreground-color-%s',
	    label: 'Color',
	    options: [COLOR_WHITE, COLOR_BLACK, COLOR_RED, COLOR_GREEN, COLOR_BLUE, COLOR_YELLOW, COLOR_MAGENTA, COLOR_CYAN]
	  },
	  edgeStyle: {
	    selector: '.vjs-edge-style > select',
	    id: '%s',
	    label: 'Text Edge Style',
	    options: [['none', 'None'], ['raised', 'Raised'], ['depressed', 'Depressed'], ['uniform', 'Uniform'], ['dropshadow', 'Dropshadow']]
	  },
	  fontFamily: {
	    selector: '.vjs-font-family > select',
	    id: 'captions-font-family-%s',
	    label: 'Font Family',
	    options: [['proportionalSansSerif', 'Proportional Sans-Serif'], ['monospaceSansSerif', 'Monospace Sans-Serif'], ['proportionalSerif', 'Proportional Serif'], ['monospaceSerif', 'Monospace Serif'], ['casual', 'Casual'], ['script', 'Script'], ['small-caps', 'Small Caps']]
	  },
	  fontPercent: {
	    selector: '.vjs-font-percent > select',
	    id: 'captions-font-size-%s',
	    label: 'Font Size',
	    options: [['0.50', '50%'], ['0.75', '75%'], ['1.00', '100%'], ['1.25', '125%'], ['1.50', '150%'], ['1.75', '175%'], ['2.00', '200%'], ['3.00', '300%'], ['4.00', '400%']],
	    "default": 2,
	    parser: function parser(v) {
	      return v === '1.00' ? null : Number(v);
	    }
	  },
	  textOpacity: {
	    selector: '.vjs-text-opacity > select',
	    id: 'captions-foreground-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_OPAQUE, OPACITY_SEMI]
	  },
	  // Options for this object are defined below.
	  windowColor: {
	    selector: '.vjs-window-color > select',
	    id: 'captions-window-color-%s',
	    label: 'Color'
	  },
	  // Options for this object are defined below.
	  windowOpacity: {
	    selector: '.vjs-window-opacity > select',
	    id: 'captions-window-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_TRANS, OPACITY_SEMI, OPACITY_OPAQUE]
	  }
	};
	selectConfigs.windowColor.options = selectConfigs.backgroundColor.options;
	/**
	 * Get the actual value of an option.
	 *
	 * @param  {string} value
	 *         The value to get
	 *
	 * @param  {Function} [parser]
	 *         Optional function to adjust the value.
	 *
	 * @return {Mixed}
	 *         - Will be `undefined` if no value exists
	 *         - Will be `undefined` if the given value is "none".
	 *         - Will be the actual value otherwise.
	 *
	 * @private
	 */
	
	function parseOptionValue(value, parser) {
	  if (parser) {
	    value = parser(value);
	  }
	
	  if (value && value !== 'none') {
	    return value;
	  }
	}
	/**
	 * Gets the value of the selected <option> element within a <select> element.
	 *
	 * @param  {Element} el
	 *         the element to look in
	 *
	 * @param  {Function} [parser]
	 *         Optional function to adjust the value.
	 *
	 * @return {Mixed}
	 *         - Will be `undefined` if no value exists
	 *         - Will be `undefined` if the given value is "none".
	 *         - Will be the actual value otherwise.
	 *
	 * @private
	 */
	
	
	function getSelectedOptionValue(el, parser) {
	  var value = el.options[el.options.selectedIndex].value;
	  return parseOptionValue(value, parser);
	}
	/**
	 * Sets the selected <option> element within a <select> element based on a
	 * given value.
	 *
	 * @param {Element} el
	 *        The element to look in.
	 *
	 * @param {string} value
	 *        the property to look on.
	 *
	 * @param {Function} [parser]
	 *        Optional function to adjust the value before comparing.
	 *
	 * @private
	 */
	
	
	function setSelectedOption(el, value, parser) {
	  if (!value) {
	    return;
	  }
	
	  for (var i = 0; i < el.options.length; i++) {
	    if (parseOptionValue(el.options[i].value, parser) === value) {
	      el.selectedIndex = i;
	      break;
	    }
	  }
	}
	/**
	 * Manipulate Text Tracks settings.
	 *
	 * @extends ModalDialog
	 */
	
	
	var TextTrackSettings = /*#__PURE__*/function (_ModalDialog) {
	  _inheritsLoose__default['default'](TextTrackSettings, _ModalDialog);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *         The key/value store of player options.
	   */
	  function TextTrackSettings(player, options) {
	    var _this;
	
	    options.temporary = false;
	    _this = _ModalDialog.call(this, player, options) || this;
	    _this.updateDisplay = _this.updateDisplay.bind(_assertThisInitialized__default['default'](_this)); // fill the modal and pretend we have opened it
	
	    _this.fill();
	
	    _this.hasBeenOpened_ = _this.hasBeenFilled_ = true;
	    _this.endDialog = createEl('p', {
	      className: 'vjs-control-text',
	      textContent: _this.localize('End of dialog window.')
	    });
	
	    _this.el().appendChild(_this.endDialog);
	
	    _this.setDefaults(); // Grab `persistTextTrackSettings` from the player options if not passed in child options
	
	
	    if (options.persistTextTrackSettings === undefined) {
	      _this.options_.persistTextTrackSettings = _this.options_.playerOptions.persistTextTrackSettings;
	    }
	
	    _this.on(_this.$('.vjs-done-button'), 'click', function () {
	      _this.saveSettings();
	
	      _this.close();
	    });
	
	    _this.on(_this.$('.vjs-default-button'), 'click', function () {
	      _this.setDefaults();
	
	      _this.updateDisplay();
	    });
	
	    each(selectConfigs, function (config) {
	      _this.on(_this.$(config.selector), 'change', _this.updateDisplay);
	    });
	
	    if (_this.options_.persistTextTrackSettings) {
	      _this.restoreSettings();
	    }
	
	    return _this;
	  }
	
	  var _proto = TextTrackSettings.prototype;
	
	  _proto.dispose = function dispose() {
	    this.endDialog = null;
	
	    _ModalDialog.prototype.dispose.call(this);
	  }
	  /**
	   * Create a <select> element with configured options.
	   *
	   * @param {string} key
	   *        Configuration key to use during creation.
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElSelect_ = function createElSelect_(key, legendId, type) {
	    var _this2 = this;
	
	    if (legendId === void 0) {
	      legendId = '';
	    }
	
	    if (type === void 0) {
	      type = 'label';
	    }
	
	    var config = selectConfigs[key];
	    var id = config.id.replace('%s', this.id_);
	    var selectLabelledbyIds = [legendId, id].join(' ').trim();
	    return ["<" + type + " id=\"" + id + "\" class=\"" + (type === 'label' ? 'vjs-label' : '') + "\">", this.localize(config.label), "</" + type + ">", "<select aria-labelledby=\"" + selectLabelledbyIds + "\">"].concat(config.options.map(function (o) {
	      var optionId = id + '-' + o[1].replace(/\W+/g, '');
	      return ["<option id=\"" + optionId + "\" value=\"" + o[0] + "\" ", "aria-labelledby=\"" + selectLabelledbyIds + " " + optionId + "\">", _this2.localize(o[1]), '</option>'].join('');
	    })).concat('</select>').join('');
	  }
	  /**
	   * Create foreground color element for the component
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElFgColor_ = function createElFgColor_() {
	    var legendId = "captions-text-legend-" + this.id_;
	    return ['<fieldset class="vjs-fg-color vjs-track-setting">', "<legend id=\"" + legendId + "\">", this.localize('Text'), '</legend>', this.createElSelect_('color', legendId), '<span class="vjs-text-opacity vjs-opacity">', this.createElSelect_('textOpacity', legendId), '</span>', '</fieldset>'].join('');
	  }
	  /**
	   * Create background color element for the component
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElBgColor_ = function createElBgColor_() {
	    var legendId = "captions-background-" + this.id_;
	    return ['<fieldset class="vjs-bg-color vjs-track-setting">', "<legend id=\"" + legendId + "\">", this.localize('Background'), '</legend>', this.createElSelect_('backgroundColor', legendId), '<span class="vjs-bg-opacity vjs-opacity">', this.createElSelect_('backgroundOpacity', legendId), '</span>', '</fieldset>'].join('');
	  }
	  /**
	   * Create window color element for the component
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElWinColor_ = function createElWinColor_() {
	    var legendId = "captions-window-" + this.id_;
	    return ['<fieldset class="vjs-window-color vjs-track-setting">', "<legend id=\"" + legendId + "\">", this.localize('Window'), '</legend>', this.createElSelect_('windowColor', legendId), '<span class="vjs-window-opacity vjs-opacity">', this.createElSelect_('windowOpacity', legendId), '</span>', '</fieldset>'].join('');
	  }
	  /**
	   * Create color elements for the component
	   *
	   * @return {Element}
	   *         The element that was created
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElColors_ = function createElColors_() {
	    return createEl('div', {
	      className: 'vjs-track-settings-colors',
	      innerHTML: [this.createElFgColor_(), this.createElBgColor_(), this.createElWinColor_()].join('')
	    });
	  }
	  /**
	   * Create font elements for the component
	   *
	   * @return {Element}
	   *         The element that was created.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElFont_ = function createElFont_() {
	    return createEl('div', {
	      className: 'vjs-track-settings-font',
	      innerHTML: ['<fieldset class="vjs-font-percent vjs-track-setting">', this.createElSelect_('fontPercent', '', 'legend'), '</fieldset>', '<fieldset class="vjs-edge-style vjs-track-setting">', this.createElSelect_('edgeStyle', '', 'legend'), '</fieldset>', '<fieldset class="vjs-font-family vjs-track-setting">', this.createElSelect_('fontFamily', '', 'legend'), '</fieldset>'].join('')
	    });
	  }
	  /**
	   * Create controls for the component
	   *
	   * @return {Element}
	   *         The element that was created.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElControls_ = function createElControls_() {
	    var defaultsDescription = this.localize('restore all settings to the default values');
	    return createEl('div', {
	      className: 'vjs-track-settings-controls',
	      innerHTML: ["<button type=\"button\" class=\"vjs-default-button\" title=\"" + defaultsDescription + "\">", this.localize('Reset'), "<span class=\"vjs-control-text\"> " + defaultsDescription + "</span>", '</button>', "<button type=\"button\" class=\"vjs-done-button\">" + this.localize('Done') + "</button>"].join('')
	    });
	  };
	
	  _proto.content = function content() {
	    return [this.createElColors_(), this.createElFont_(), this.createElControls_()];
	  };
	
	  _proto.label = function label() {
	    return this.localize('Caption Settings Dialog');
	  };
	
	  _proto.description = function description() {
	    return this.localize('Beginning of dialog window. Escape will cancel and close the window.');
	  };
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return _ModalDialog.prototype.buildCSSClass.call(this) + ' vjs-text-track-settings';
	  }
	  /**
	   * Gets an object of text track settings (or null).
	   *
	   * @return {Object}
	   *         An object with config values parsed from the DOM or localStorage.
	   */
	  ;
	
	  _proto.getValues = function getValues() {
	    var _this3 = this;
	
	    return reduce(selectConfigs, function (accum, config, key) {
	      var value = getSelectedOptionValue(_this3.$(config.selector), config.parser);
	
	      if (value !== undefined) {
	        accum[key] = value;
	      }
	
	      return accum;
	    }, {});
	  }
	  /**
	   * Sets text track settings from an object of values.
	   *
	   * @param {Object} values
	   *        An object with config values parsed from the DOM or localStorage.
	   */
	  ;
	
	  _proto.setValues = function setValues(values) {
	    var _this4 = this;
	
	    each(selectConfigs, function (config, key) {
	      setSelectedOption(_this4.$(config.selector), values[key], config.parser);
	    });
	  }
	  /**
	   * Sets all `<select>` elements to their default values.
	   */
	  ;
	
	  _proto.setDefaults = function setDefaults() {
	    var _this5 = this;
	
	    each(selectConfigs, function (config) {
	      var index = config.hasOwnProperty('default') ? config["default"] : 0;
	      _this5.$(config.selector).selectedIndex = index;
	    });
	  }
	  /**
	   * Restore texttrack settings from localStorage
	   */
	  ;
	
	  _proto.restoreSettings = function restoreSettings() {
	    var values;
	
	    try {
	      values = JSON.parse(window__default['default'].localStorage.getItem(LOCAL_STORAGE_KEY$1));
	    } catch (err) {
	      log$1.warn(err);
	    }
	
	    if (values) {
	      this.setValues(values);
	    }
	  }
	  /**
	   * Save text track settings to localStorage
	   */
	  ;
	
	  _proto.saveSettings = function saveSettings() {
	    if (!this.options_.persistTextTrackSettings) {
	      return;
	    }
	
	    var values = this.getValues();
	
	    try {
	      if (Object.keys(values).length) {
	        window__default['default'].localStorage.setItem(LOCAL_STORAGE_KEY$1, JSON.stringify(values));
	      } else {
	        window__default['default'].localStorage.removeItem(LOCAL_STORAGE_KEY$1);
	      }
	    } catch (err) {
	      log$1.warn(err);
	    }
	  }
	  /**
	   * Update display of text track settings
	   */
	  ;
	
	  _proto.updateDisplay = function updateDisplay() {
	    var ttDisplay = this.player_.getChild('textTrackDisplay');
	
	    if (ttDisplay) {
	      ttDisplay.updateDisplay();
	    }
	  }
	  /**
	   * conditionally blur the element and refocus the captions button
	   *
	   * @private
	   */
	  ;
	
	  _proto.conditionalBlur_ = function conditionalBlur_() {
	    this.previouslyActiveEl_ = null;
	    var cb = this.player_.controlBar;
	    var subsCapsBtn = cb && cb.subsCapsButton;
	    var ccBtn = cb && cb.captionsButton;
	
	    if (subsCapsBtn) {
	      subsCapsBtn.focus();
	    } else if (ccBtn) {
	      ccBtn.focus();
	    }
	  };
	
	  return TextTrackSettings;
	}(ModalDialog);
	
	Component$1.registerComponent('TextTrackSettings', TextTrackSettings);
	
	/**
	 * A Resize Manager. It is in charge of triggering `playerresize` on the player in the right conditions.
	 *
	 * It'll either create an iframe and use a debounced resize handler on it or use the new {@link https://wicg.github.io/ResizeObserver/|ResizeObserver}.
	 *
	 * If the ResizeObserver is available natively, it will be used. A polyfill can be passed in as an option.
	 * If a `playerresize` event is not needed, the ResizeManager component can be removed from the player, see the example below.
	 * @example <caption>How to disable the resize manager</caption>
	 * const player = videojs('#vid', {
	 *   resizeManager: false
	 * });
	 *
	 * @see {@link https://wicg.github.io/ResizeObserver/|ResizeObserver specification}
	 *
	 * @extends Component
	 */
	
	var ResizeManager = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ResizeManager, _Component);
	
	  /**
	   * Create the ResizeManager.
	   *
	   * @param {Object} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of ResizeManager options.
	   *
	   * @param {Object} [options.ResizeObserver]
	   *        A polyfill for ResizeObserver can be passed in here.
	   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
	   */
	  function ResizeManager(player, options) {
	    var _this;
	
	    var RESIZE_OBSERVER_AVAILABLE = options.ResizeObserver || window__default['default'].ResizeObserver; // if `null` was passed, we want to disable the ResizeObserver
	
	    if (options.ResizeObserver === null) {
	      RESIZE_OBSERVER_AVAILABLE = false;
	    } // Only create an element when ResizeObserver isn't available
	
	
	    var options_ = mergeOptions$3({
	      createEl: !RESIZE_OBSERVER_AVAILABLE,
	      reportTouchActivity: false
	    }, options);
	    _this = _Component.call(this, player, options_) || this;
	    _this.ResizeObserver = options.ResizeObserver || window__default['default'].ResizeObserver;
	    _this.loadListener_ = null;
	    _this.resizeObserver_ = null;
	    _this.debouncedHandler_ = debounce(function () {
	      _this.resizeHandler();
	    }, 100, false, _assertThisInitialized__default['default'](_this));
	
	    if (RESIZE_OBSERVER_AVAILABLE) {
	      _this.resizeObserver_ = new _this.ResizeObserver(_this.debouncedHandler_);
	
	      _this.resizeObserver_.observe(player.el());
	    } else {
	      _this.loadListener_ = function () {
	        if (!_this.el_ || !_this.el_.contentWindow) {
	          return;
	        }
	
	        var debouncedHandler_ = _this.debouncedHandler_;
	
	        var unloadListener_ = _this.unloadListener_ = function () {
	          off(this, 'resize', debouncedHandler_);
	          off(this, 'unload', unloadListener_);
	          unloadListener_ = null;
	        }; // safari and edge can unload the iframe before resizemanager dispose
	        // we have to dispose of event handlers correctly before that happens
	
	
	        on(_this.el_.contentWindow, 'unload', unloadListener_);
	        on(_this.el_.contentWindow, 'resize', debouncedHandler_);
	      };
	
	      _this.one('load', _this.loadListener_);
	    }
	
	    return _this;
	  }
	
	  var _proto = ResizeManager.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'iframe', {
	      className: 'vjs-resize-manager',
	      tabIndex: -1,
	      title: this.localize('No content')
	    }, {
	      'aria-hidden': 'true'
	    });
	  }
	  /**
	   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
	   *
	   * @fires Player#playerresize
	   */
	  ;
	
	  _proto.resizeHandler = function resizeHandler() {
	    /**
	     * Called when the player size has changed
	     *
	     * @event Player#playerresize
	     * @type {EventTarget~Event}
	     */
	    // make sure player is still around to trigger
	    // prevents this from causing an error after dispose
	    if (!this.player_ || !this.player_.trigger) {
	      return;
	    }
	
	    this.player_.trigger('playerresize');
	  };
	
	  _proto.dispose = function dispose() {
	    if (this.debouncedHandler_) {
	      this.debouncedHandler_.cancel();
	    }
	
	    if (this.resizeObserver_) {
	      if (this.player_.el()) {
	        this.resizeObserver_.unobserve(this.player_.el());
	      }
	
	      this.resizeObserver_.disconnect();
	    }
	
	    if (this.loadListener_) {
	      this.off('load', this.loadListener_);
	    }
	
	    if (this.el_ && this.el_.contentWindow && this.unloadListener_) {
	      this.unloadListener_.call(this.el_.contentWindow);
	    }
	
	    this.ResizeObserver = null;
	    this.resizeObserver = null;
	    this.debouncedHandler_ = null;
	    this.loadListener_ = null;
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  return ResizeManager;
	}(Component$1);
	
	Component$1.registerComponent('ResizeManager', ResizeManager);
	
	var defaults = {
	  trackingThreshold: 20,
	  liveTolerance: 15
	};
	/*
	  track when we are at the live edge, and other helpers for live playback */
	
	/**
	 * A class for checking live current time and determining when the player
	 * is at or behind the live edge.
	 */
	
	var LiveTracker = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](LiveTracker, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {number} [options.trackingThreshold=20]
	   *        Number of seconds of live window (seekableEnd - seekableStart) that
	   *        media needs to have before the liveui will be shown.
	   *
	   * @param {number} [options.liveTolerance=15]
	   *        Number of seconds behind live that we have to be
	   *        before we will be considered non-live. Note that this will only
	   *        be used when playing at the live edge. This allows large seekable end
	   *        changes to not effect wether we are live or not.
	   */
	  function LiveTracker(player, options) {
	    var _this;
	
	    // LiveTracker does not need an element
	    var options_ = mergeOptions$3(defaults, options, {
	      createEl: false
	    });
	    _this = _Component.call(this, player, options_) || this;
	
	    _this.handleVisibilityChange_ = function (e) {
	      return _this.handleVisibilityChange(e);
	    };
	
	    _this.trackLiveHandler_ = function () {
	      return _this.trackLive_();
	    };
	
	    _this.handlePlay_ = function (e) {
	      return _this.handlePlay(e);
	    };
	
	    _this.handleFirstTimeupdate_ = function (e) {
	      return _this.handleFirstTimeupdate(e);
	    };
	
	    _this.handleSeeked_ = function (e) {
	      return _this.handleSeeked(e);
	    };
	
	    _this.seekToLiveEdge_ = function (e) {
	      return _this.seekToLiveEdge(e);
	    };
	
	    _this.reset_();
	
	    _this.on(_this.player_, 'durationchange', function (e) {
	      return _this.handleDurationchange(e);
	    }); // we should try to toggle tracking on canplay as native playback engines, like Safari
	    // may not have the proper values for things like seekableEnd until then
	
	
	    _this.on(_this.player_, 'canplay', function () {
	      return _this.toggleTracking();
	    }); // we don't need to track live playback if the document is hidden,
	    // also, tracking when the document is hidden can
	    // cause the CPU to spike and eventually crash the page on IE11.
	
	
	    if (IE_VERSION && 'hidden' in document__default['default'] && 'visibilityState' in document__default['default']) {
	      _this.on(document__default['default'], 'visibilitychange', _this.handleVisibilityChange_);
	    }
	
	    return _this;
	  }
	  /**
	   * toggle tracking based on document visiblility
	   */
	
	
	  var _proto = LiveTracker.prototype;
	
	  _proto.handleVisibilityChange = function handleVisibilityChange() {
	    if (this.player_.duration() !== Infinity) {
	      return;
	    }
	
	    if (document__default['default'].hidden) {
	      this.stopTracking();
	    } else {
	      this.startTracking();
	    }
	  }
	  /**
	   * all the functionality for tracking when seek end changes
	   * and for tracking how far past seek end we should be
	   */
	  ;
	
	  _proto.trackLive_ = function trackLive_() {
	    var seekable = this.player_.seekable(); // skip undefined seekable
	
	    if (!seekable || !seekable.length) {
	      return;
	    }
	
	    var newTime = Number(window__default['default'].performance.now().toFixed(4));
	    var deltaTime = this.lastTime_ === -1 ? 0 : (newTime - this.lastTime_) / 1000;
	    this.lastTime_ = newTime;
	    this.pastSeekEnd_ = this.pastSeekEnd() + deltaTime;
	    var liveCurrentTime = this.liveCurrentTime();
	    var currentTime = this.player_.currentTime(); // we are behind live if any are true
	    // 1. the player is paused
	    // 2. the user seeked to a location 2 seconds away from live
	    // 3. the difference between live and current time is greater
	    //    liveTolerance which defaults to 15s
	
	    var isBehind = this.player_.paused() || this.seekedBehindLive_ || Math.abs(liveCurrentTime - currentTime) > this.options_.liveTolerance; // we cannot be behind if
	    // 1. until we have not seen a timeupdate yet
	    // 2. liveCurrentTime is Infinity, which happens on Android and Native Safari
	
	    if (!this.timeupdateSeen_ || liveCurrentTime === Infinity) {
	      isBehind = false;
	    }
	
	    if (isBehind !== this.behindLiveEdge_) {
	      this.behindLiveEdge_ = isBehind;
	      this.trigger('liveedgechange');
	    }
	  }
	  /**
	   * handle a durationchange event on the player
	   * and start/stop tracking accordingly.
	   */
	  ;
	
	  _proto.handleDurationchange = function handleDurationchange() {
	    this.toggleTracking();
	  }
	  /**
	   * start/stop tracking
	   */
	  ;
	
	  _proto.toggleTracking = function toggleTracking() {
	    if (this.player_.duration() === Infinity && this.liveWindow() >= this.options_.trackingThreshold) {
	      if (this.player_.options_.liveui) {
	        this.player_.addClass('vjs-liveui');
	      }
	
	      this.startTracking();
	    } else {
	      this.player_.removeClass('vjs-liveui');
	      this.stopTracking();
	    }
	  }
	  /**
	   * start tracking live playback
	   */
	  ;
	
	  _proto.startTracking = function startTracking() {
	    if (this.isTracking()) {
	      return;
	    } // If we haven't seen a timeupdate, we need to check whether playback
	    // began before this component started tracking. This can happen commonly
	    // when using autoplay.
	
	
	    if (!this.timeupdateSeen_) {
	      this.timeupdateSeen_ = this.player_.hasStarted();
	    }
	
	    this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, UPDATE_REFRESH_INTERVAL);
	    this.trackLive_();
	    this.on(this.player_, ['play', 'pause'], this.trackLiveHandler_);
	
	    if (!this.timeupdateSeen_) {
	      this.one(this.player_, 'play', this.handlePlay_);
	      this.one(this.player_, 'timeupdate', this.handleFirstTimeupdate_);
	    } else {
	      this.on(this.player_, 'seeked', this.handleSeeked_);
	    }
	  }
	  /**
	   * handle the first timeupdate on the player if it wasn't already playing
	   * when live tracker started tracking.
	   */
	  ;
	
	  _proto.handleFirstTimeupdate = function handleFirstTimeupdate() {
	    this.timeupdateSeen_ = true;
	    this.on(this.player_, 'seeked', this.handleSeeked_);
	  }
	  /**
	   * Keep track of what time a seek starts, and listen for seeked
	   * to find where a seek ends.
	   */
	  ;
	
	  _proto.handleSeeked = function handleSeeked() {
	    var timeDiff = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
	    this.seekedBehindLive_ = this.nextSeekedFromUser_ && timeDiff > 2;
	    this.nextSeekedFromUser_ = false;
	    this.trackLive_();
	  }
	  /**
	   * handle the first play on the player, and make sure that we seek
	   * right to the live edge.
	   */
	  ;
	
	  _proto.handlePlay = function handlePlay() {
	    this.one(this.player_, 'timeupdate', this.seekToLiveEdge_);
	  }
	  /**
	   * Stop tracking, and set all internal variables to
	   * their initial value.
	   */
	  ;
	
	  _proto.reset_ = function reset_() {
	    this.lastTime_ = -1;
	    this.pastSeekEnd_ = 0;
	    this.lastSeekEnd_ = -1;
	    this.behindLiveEdge_ = true;
	    this.timeupdateSeen_ = false;
	    this.seekedBehindLive_ = false;
	    this.nextSeekedFromUser_ = false;
	    this.clearInterval(this.trackingInterval_);
	    this.trackingInterval_ = null;
	    this.off(this.player_, ['play', 'pause'], this.trackLiveHandler_);
	    this.off(this.player_, 'seeked', this.handleSeeked_);
	    this.off(this.player_, 'play', this.handlePlay_);
	    this.off(this.player_, 'timeupdate', this.handleFirstTimeupdate_);
	    this.off(this.player_, 'timeupdate', this.seekToLiveEdge_);
	  }
	  /**
	   * The next seeked event is from the user. Meaning that any seek
	   * > 2s behind live will be considered behind live for real and
	   * liveTolerance will be ignored.
	   */
	  ;
	
	  _proto.nextSeekedFromUser = function nextSeekedFromUser() {
	    this.nextSeekedFromUser_ = true;
	  }
	  /**
	   * stop tracking live playback
	   */
	  ;
	
	  _proto.stopTracking = function stopTracking() {
	    if (!this.isTracking()) {
	      return;
	    }
	
	    this.reset_();
	    this.trigger('liveedgechange');
	  }
	  /**
	   * A helper to get the player seekable end
	   * so that we don't have to null check everywhere
	   *
	   * @return {number}
	   *         The furthest seekable end or Infinity.
	   */
	  ;
	
	  _proto.seekableEnd = function seekableEnd() {
	    var seekable = this.player_.seekable();
	    var seekableEnds = [];
	    var i = seekable ? seekable.length : 0;
	
	    while (i--) {
	      seekableEnds.push(seekable.end(i));
	    } // grab the furthest seekable end after sorting, or if there are none
	    // default to Infinity
	
	
	    return seekableEnds.length ? seekableEnds.sort()[seekableEnds.length - 1] : Infinity;
	  }
	  /**
	   * A helper to get the player seekable start
	   * so that we don't have to null check everywhere
	   *
	   * @return {number}
	   *         The earliest seekable start or 0.
	   */
	  ;
	
	  _proto.seekableStart = function seekableStart() {
	    var seekable = this.player_.seekable();
	    var seekableStarts = [];
	    var i = seekable ? seekable.length : 0;
	
	    while (i--) {
	      seekableStarts.push(seekable.start(i));
	    } // grab the first seekable start after sorting, or if there are none
	    // default to 0
	
	
	    return seekableStarts.length ? seekableStarts.sort()[0] : 0;
	  }
	  /**
	   * Get the live time window aka
	   * the amount of time between seekable start and
	   * live current time.
	   *
	   * @return {number}
	   *         The amount of seconds that are seekable in
	   *         the live video.
	   */
	  ;
	
	  _proto.liveWindow = function liveWindow() {
	    var liveCurrentTime = this.liveCurrentTime(); // if liveCurrenTime is Infinity then we don't have a liveWindow at all
	
	    if (liveCurrentTime === Infinity) {
	      return 0;
	    }
	
	    return liveCurrentTime - this.seekableStart();
	  }
	  /**
	   * Determines if the player is live, only checks if this component
	   * is tracking live playback or not
	   *
	   * @return {boolean}
	   *         Wether liveTracker is tracking
	   */
	  ;
	
	  _proto.isLive = function isLive() {
	    return this.isTracking();
	  }
	  /**
	   * Determines if currentTime is at the live edge and won't fall behind
	   * on each seekableendchange
	   *
	   * @return {boolean}
	   *         Wether playback is at the live edge
	   */
	  ;
	
	  _proto.atLiveEdge = function atLiveEdge() {
	    return !this.behindLiveEdge();
	  }
	  /**
	   * get what we expect the live current time to be
	   *
	   * @return {number}
	   *         The expected live current time
	   */
	  ;
	
	  _proto.liveCurrentTime = function liveCurrentTime() {
	    return this.pastSeekEnd() + this.seekableEnd();
	  }
	  /**
	   * The number of seconds that have occured after seekable end
	   * changed. This will be reset to 0 once seekable end changes.
	   *
	   * @return {number}
	   *         Seconds past the current seekable end
	   */
	  ;
	
	  _proto.pastSeekEnd = function pastSeekEnd() {
	    var seekableEnd = this.seekableEnd();
	
	    if (this.lastSeekEnd_ !== -1 && seekableEnd !== this.lastSeekEnd_) {
	      this.pastSeekEnd_ = 0;
	    }
	
	    this.lastSeekEnd_ = seekableEnd;
	    return this.pastSeekEnd_;
	  }
	  /**
	   * If we are currently behind the live edge, aka currentTime will be
	   * behind on a seekableendchange
	   *
	   * @return {boolean}
	   *         If we are behind the live edge
	   */
	  ;
	
	  _proto.behindLiveEdge = function behindLiveEdge() {
	    return this.behindLiveEdge_;
	  }
	  /**
	   * Wether live tracker is currently tracking or not.
	   */
	  ;
	
	  _proto.isTracking = function isTracking() {
	    return typeof this.trackingInterval_ === 'number';
	  }
	  /**
	   * Seek to the live edge if we are behind the live edge
	   */
	  ;
	
	  _proto.seekToLiveEdge = function seekToLiveEdge() {
	    this.seekedBehindLive_ = false;
	
	    if (this.atLiveEdge()) {
	      return;
	    }
	
	    this.nextSeekedFromUser_ = false;
	    this.player_.currentTime(this.liveCurrentTime());
	  }
	  /**
	   * Dispose of liveTracker
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.off(document__default['default'], 'visibilitychange', this.handleVisibilityChange_);
	    this.stopTracking();
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  return LiveTracker;
	}(Component$1);
	
	Component$1.registerComponent('LiveTracker', LiveTracker);
	
	/**
	 * This function is used to fire a sourceset when there is something
	 * similar to `mediaEl.load()` being called. It will try to find the source via
	 * the `src` attribute and then the `<source>` elements. It will then fire `sourceset`
	 * with the source that was found or empty string if we cannot know. If it cannot
	 * find a source then `sourceset` will not be fired.
	 *
	 * @param {Html5} tech
	 *        The tech object that sourceset was setup on
	 *
	 * @return {boolean}
	 *         returns false if the sourceset was not fired and true otherwise.
	 */
	
	var sourcesetLoad = function sourcesetLoad(tech) {
	  var el = tech.el(); // if `el.src` is set, that source will be loaded.
	
	  if (el.hasAttribute('src')) {
	    tech.triggerSourceset(el.src);
	    return true;
	  }
	  /**
	   * Since there isn't a src property on the media element, source elements will be used for
	   * implementing the source selection algorithm. This happens asynchronously and
	   * for most cases were there is more than one source we cannot tell what source will
	   * be loaded, without re-implementing the source selection algorithm. At this time we are not
	   * going to do that. There are three special cases that we do handle here though:
	   *
	   * 1. If there are no sources, do not fire `sourceset`.
	   * 2. If there is only one `<source>` with a `src` property/attribute that is our `src`
	   * 3. If there is more than one `<source>` but all of them have the same `src` url.
	   *    That will be our src.
	   */
	
	
	  var sources = tech.$$('source');
	  var srcUrls = [];
	  var src = ''; // if there are no sources, do not fire sourceset
	
	  if (!sources.length) {
	    return false;
	  } // only count valid/non-duplicate source elements
	
	
	  for (var i = 0; i < sources.length; i++) {
	    var url = sources[i].src;
	
	    if (url && srcUrls.indexOf(url) === -1) {
	      srcUrls.push(url);
	    }
	  } // there were no valid sources
	
	
	  if (!srcUrls.length) {
	    return false;
	  } // there is only one valid source element url
	  // use that
	
	
	  if (srcUrls.length === 1) {
	    src = srcUrls[0];
	  }
	
	  tech.triggerSourceset(src);
	  return true;
	};
	/**
	 * our implementation of an `innerHTML` descriptor for browsers
	 * that do not have one.
	 */
	
	
	var innerHTMLDescriptorPolyfill = Object.defineProperty({}, 'innerHTML', {
	  get: function get() {
	    return this.cloneNode(true).innerHTML;
	  },
	  set: function set(v) {
	    // make a dummy node to use innerHTML on
	    var dummy = document__default['default'].createElement(this.nodeName.toLowerCase()); // set innerHTML to the value provided
	
	    dummy.innerHTML = v; // make a document fragment to hold the nodes from dummy
	
	    var docFrag = document__default['default'].createDocumentFragment(); // copy all of the nodes created by the innerHTML on dummy
	    // to the document fragment
	
	    while (dummy.childNodes.length) {
	      docFrag.appendChild(dummy.childNodes[0]);
	    } // remove content
	
	
	    this.innerText = ''; // now we add all of that html in one by appending the
	    // document fragment. This is how innerHTML does it.
	
	    window__default['default'].Element.prototype.appendChild.call(this, docFrag); // then return the result that innerHTML's setter would
	
	    return this.innerHTML;
	  }
	});
	/**
	 * Get a property descriptor given a list of priorities and the
	 * property to get.
	 */
	
	var getDescriptor = function getDescriptor(priority, prop) {
	  var descriptor = {};
	
	  for (var i = 0; i < priority.length; i++) {
	    descriptor = Object.getOwnPropertyDescriptor(priority[i], prop);
	
	    if (descriptor && descriptor.set && descriptor.get) {
	      break;
	    }
	  }
	
	  descriptor.enumerable = true;
	  descriptor.configurable = true;
	  return descriptor;
	};
	
	var getInnerHTMLDescriptor = function getInnerHTMLDescriptor(tech) {
	  return getDescriptor([tech.el(), window__default['default'].HTMLMediaElement.prototype, window__default['default'].Element.prototype, innerHTMLDescriptorPolyfill], 'innerHTML');
	};
	/**
	 * Patches browser internal functions so that we can tell synchronously
	 * if a `<source>` was appended to the media element. For some reason this
	 * causes a `sourceset` if the the media element is ready and has no source.
	 * This happens when:
	 * - The page has just loaded and the media element does not have a source.
	 * - The media element was emptied of all sources, then `load()` was called.
	 *
	 * It does this by patching the following functions/properties when they are supported:
	 *
	 * - `append()` - can be used to add a `<source>` element to the media element
	 * - `appendChild()` - can be used to add a `<source>` element to the media element
	 * - `insertAdjacentHTML()` -  can be used to add a `<source>` element to the media element
	 * - `innerHTML` -  can be used to add a `<source>` element to the media element
	 *
	 * @param {Html5} tech
	 *        The tech object that sourceset is being setup on.
	 */
	
	
	var firstSourceWatch = function firstSourceWatch(tech) {
	  var el = tech.el(); // make sure firstSourceWatch isn't setup twice.
	
	  if (el.resetSourceWatch_) {
	    return;
	  }
	
	  var old = {};
	  var innerDescriptor = getInnerHTMLDescriptor(tech);
	
	  var appendWrapper = function appendWrapper(appendFn) {
	    return function () {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var retval = appendFn.apply(el, args);
	      sourcesetLoad(tech);
	      return retval;
	    };
	  };
	
	  ['append', 'appendChild', 'insertAdjacentHTML'].forEach(function (k) {
	    if (!el[k]) {
	      return;
	    } // store the old function
	
	
	    old[k] = el[k]; // call the old function with a sourceset if a source
	    // was loaded
	
	    el[k] = appendWrapper(old[k]);
	  });
	  Object.defineProperty(el, 'innerHTML', mergeOptions$3(innerDescriptor, {
	    set: appendWrapper(innerDescriptor.set)
	  }));
	
	  el.resetSourceWatch_ = function () {
	    el.resetSourceWatch_ = null;
	    Object.keys(old).forEach(function (k) {
	      el[k] = old[k];
	    });
	    Object.defineProperty(el, 'innerHTML', innerDescriptor);
	  }; // on the first sourceset, we need to revert our changes
	
	
	  tech.one('sourceset', el.resetSourceWatch_);
	};
	/**
	 * our implementation of a `src` descriptor for browsers
	 * that do not have one.
	 */
	
	
	var srcDescriptorPolyfill = Object.defineProperty({}, 'src', {
	  get: function get() {
	    if (this.hasAttribute('src')) {
	      return getAbsoluteURL(window__default['default'].Element.prototype.getAttribute.call(this, 'src'));
	    }
	
	    return '';
	  },
	  set: function set(v) {
	    window__default['default'].Element.prototype.setAttribute.call(this, 'src', v);
	    return v;
	  }
	});
	
	var getSrcDescriptor = function getSrcDescriptor(tech) {
	  return getDescriptor([tech.el(), window__default['default'].HTMLMediaElement.prototype, srcDescriptorPolyfill], 'src');
	};
	/**
	 * setup `sourceset` handling on the `Html5` tech. This function
	 * patches the following element properties/functions:
	 *
	 * - `src` - to determine when `src` is set
	 * - `setAttribute()` - to determine when `src` is set
	 * - `load()` - this re-triggers the source selection algorithm, and can
	 *              cause a sourceset.
	 *
	 * If there is no source when we are adding `sourceset` support or during a `load()`
	 * we also patch the functions listed in `firstSourceWatch`.
	 *
	 * @param {Html5} tech
	 *        The tech to patch
	 */
	
	
	var setupSourceset = function setupSourceset(tech) {
	  if (!tech.featuresSourceset) {
	    return;
	  }
	
	  var el = tech.el(); // make sure sourceset isn't setup twice.
	
	  if (el.resetSourceset_) {
	    return;
	  }
	
	  var srcDescriptor = getSrcDescriptor(tech);
	  var oldSetAttribute = el.setAttribute;
	  var oldLoad = el.load;
	  Object.defineProperty(el, 'src', mergeOptions$3(srcDescriptor, {
	    set: function set(v) {
	      var retval = srcDescriptor.set.call(el, v); // we use the getter here to get the actual value set on src
	
	      tech.triggerSourceset(el.src);
	      return retval;
	    }
	  }));
	
	  el.setAttribute = function (n, v) {
	    var retval = oldSetAttribute.call(el, n, v);
	
	    if (/src/i.test(n)) {
	      tech.triggerSourceset(el.src);
	    }
	
	    return retval;
	  };
	
	  el.load = function () {
	    var retval = oldLoad.call(el); // if load was called, but there was no source to fire
	    // sourceset on. We have to watch for a source append
	    // as that can trigger a `sourceset` when the media element
	    // has no source
	
	    if (!sourcesetLoad(tech)) {
	      tech.triggerSourceset('');
	      firstSourceWatch(tech);
	    }
	
	    return retval;
	  };
	
	  if (el.currentSrc) {
	    tech.triggerSourceset(el.currentSrc);
	  } else if (!sourcesetLoad(tech)) {
	    firstSourceWatch(tech);
	  }
	
	  el.resetSourceset_ = function () {
	    el.resetSourceset_ = null;
	    el.load = oldLoad;
	    el.setAttribute = oldSetAttribute;
	    Object.defineProperty(el, 'src', srcDescriptor);
	
	    if (el.resetSourceWatch_) {
	      el.resetSourceWatch_();
	    }
	  };
	};
	
	/**
	 * Object.defineProperty but "lazy", which means that the value is only set after
	 * it retrieved the first time, rather than being set right away.
	 *
	 * @param {Object} obj the object to set the property on
	 * @param {string} key the key for the property to set
	 * @param {Function} getValue the function used to get the value when it is needed.
	 * @param {boolean} setter wether a setter shoould be allowed or not
	 */
	var defineLazyProperty = function defineLazyProperty(obj, key, getValue, setter) {
	  if (setter === void 0) {
	    setter = true;
	  }
	
	  var set = function set(value) {
	    return Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      writable: true
	    });
	  };
	
	  var options = {
	    configurable: true,
	    enumerable: true,
	    get: function get() {
	      var value = getValue();
	      set(value);
	      return value;
	    }
	  };
	
	  if (setter) {
	    options.set = set;
	  }
	
	  return Object.defineProperty(obj, key, options);
	};
	
	/**
	 * HTML5 Media Controller - Wrapper for HTML5 Media API
	 *
	 * @mixes Tech~SourceHandlerAdditions
	 * @extends Tech
	 */
	
	var Html5 = /*#__PURE__*/function (_Tech) {
	  _inheritsLoose__default['default'](Html5, _Tech);
	
	  /**
	  * Create an instance of this Tech.
	  *
	  * @param {Object} [options]
	  *        The key/value store of player options.
	  *
	  * @param {Component~ReadyCallback} ready
	  *        Callback function to call when the `HTML5` Tech is ready.
	  */
	  function Html5(options, ready) {
	    var _this;
	
	    _this = _Tech.call(this, options, ready) || this;
	    var source = options.source;
	    var crossoriginTracks = false;
	    _this.featuresVideoFrameCallback = _this.featuresVideoFrameCallback && _this.el_.tagName === 'VIDEO'; // Set the source if one is provided
	    // 1) Check if the source is new (if not, we want to keep the original so playback isn't interrupted)
	    // 2) Check to see if the network state of the tag was failed at init, and if so, reset the source
	    // anyway so the error gets fired.
	
	    if (source && (_this.el_.currentSrc !== source.src || options.tag && options.tag.initNetworkState_ === 3)) {
	      _this.setSource(source);
	    } else {
	      _this.handleLateInit_(_this.el_);
	    } // setup sourceset after late sourceset/init
	
	
	    if (options.enableSourceset) {
	      _this.setupSourcesetHandling_();
	    }
	
	    _this.isScrubbing_ = false;
	
	    if (_this.el_.hasChildNodes()) {
	      var nodes = _this.el_.childNodes;
	      var nodesLength = nodes.length;
	      var removeNodes = [];
	
	      while (nodesLength--) {
	        var node = nodes[nodesLength];
	        var nodeName = node.nodeName.toLowerCase();
	
	        if (nodeName === 'track') {
	          if (!_this.featuresNativeTextTracks) {
	            // Empty video tag tracks so the built-in player doesn't use them also.
	            // This may not be fast enough to stop HTML5 browsers from reading the tags
	            // so we'll need to turn off any default tracks if we're manually doing
	            // captions and subtitles. videoElement.textTracks
	            removeNodes.push(node);
	          } else {
	            // store HTMLTrackElement and TextTrack to remote list
	            _this.remoteTextTrackEls().addTrackElement_(node);
	
	            _this.remoteTextTracks().addTrack(node.track);
	
	            _this.textTracks().addTrack(node.track);
	
	            if (!crossoriginTracks && !_this.el_.hasAttribute('crossorigin') && isCrossOrigin(node.src)) {
	              crossoriginTracks = true;
	            }
	          }
	        }
	      }
	
	      for (var i = 0; i < removeNodes.length; i++) {
	        _this.el_.removeChild(removeNodes[i]);
	      }
	    }
	
	    _this.proxyNativeTracks_();
	
	    if (_this.featuresNativeTextTracks && crossoriginTracks) {
	      log$1.warn('Text Tracks are being loaded from another origin but the crossorigin attribute isn\'t used.\n' + 'This may prevent text tracks from loading.');
	    } // prevent iOS Safari from disabling metadata text tracks during native playback
	
	
	    _this.restoreMetadataTracksInIOSNativePlayer_(); // Determine if native controls should be used
	    // Our goal should be to get the custom controls on mobile solid everywhere
	    // so we can remove this all together. Right now this will block custom
	    // controls on touch enabled laptops like the Chrome Pixel
	
	
	    if ((TOUCH_ENABLED || IS_IPHONE || IS_NATIVE_ANDROID) && options.nativeControlsForTouch === true) {
	      _this.setControls(true);
	    } // on iOS, we want to proxy `webkitbeginfullscreen` and `webkitendfullscreen`
	    // into a `fullscreenchange` event
	
	
	    _this.proxyWebkitFullscreen_();
	
	    _this.triggerReady();
	
	    return _this;
	  }
	  /**
	   * Dispose of `HTML5` media element and remove all tracks.
	   */
	
	
	  var _proto = Html5.prototype;
	
	  _proto.dispose = function dispose() {
	    if (this.el_ && this.el_.resetSourceset_) {
	      this.el_.resetSourceset_();
	    }
	
	    Html5.disposeMediaElement(this.el_);
	    this.options_ = null; // tech will handle clearing of the emulated track list
	
	    _Tech.prototype.dispose.call(this);
	  }
	  /**
	   * Modify the media element so that we can detect when
	   * the source is changed. Fires `sourceset` just after the source has changed
	   */
	  ;
	
	  _proto.setupSourcesetHandling_ = function setupSourcesetHandling_() {
	    setupSourceset(this);
	  }
	  /**
	   * When a captions track is enabled in the iOS Safari native player, all other
	   * tracks are disabled (including metadata tracks), which nulls all of their
	   * associated cue points. This will restore metadata tracks to their pre-fullscreen
	   * state in those cases so that cue points are not needlessly lost.
	   *
	   * @private
	   */
	  ;
	
	  _proto.restoreMetadataTracksInIOSNativePlayer_ = function restoreMetadataTracksInIOSNativePlayer_() {
	    var textTracks = this.textTracks();
	    var metadataTracksPreFullscreenState; // captures a snapshot of every metadata track's current state
	
	    var takeMetadataTrackSnapshot = function takeMetadataTrackSnapshot() {
	      metadataTracksPreFullscreenState = [];
	
	      for (var i = 0; i < textTracks.length; i++) {
	        var track = textTracks[i];
	
	        if (track.kind === 'metadata') {
	          metadataTracksPreFullscreenState.push({
	            track: track,
	            storedMode: track.mode
	          });
	        }
	      }
	    }; // snapshot each metadata track's initial state, and update the snapshot
	    // each time there is a track 'change' event
	
	
	    takeMetadataTrackSnapshot();
	    textTracks.addEventListener('change', takeMetadataTrackSnapshot);
	    this.on('dispose', function () {
	      return textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
	    });
	
	    var restoreTrackMode = function restoreTrackMode() {
	      for (var i = 0; i < metadataTracksPreFullscreenState.length; i++) {
	        var storedTrack = metadataTracksPreFullscreenState[i];
	
	        if (storedTrack.track.mode === 'disabled' && storedTrack.track.mode !== storedTrack.storedMode) {
	          storedTrack.track.mode = storedTrack.storedMode;
	        }
	      } // we only want this handler to be executed on the first 'change' event
	
	
	      textTracks.removeEventListener('change', restoreTrackMode);
	    }; // when we enter fullscreen playback, stop updating the snapshot and
	    // restore all track modes to their pre-fullscreen state
	
	
	    this.on('webkitbeginfullscreen', function () {
	      textTracks.removeEventListener('change', takeMetadataTrackSnapshot); // remove the listener before adding it just in case it wasn't previously removed
	
	      textTracks.removeEventListener('change', restoreTrackMode);
	      textTracks.addEventListener('change', restoreTrackMode);
	    }); // start updating the snapshot again after leaving fullscreen
	
	    this.on('webkitendfullscreen', function () {
	      // remove the listener before adding it just in case it wasn't previously removed
	      textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
	      textTracks.addEventListener('change', takeMetadataTrackSnapshot); // remove the restoreTrackMode handler in case it wasn't triggered during fullscreen playback
	
	      textTracks.removeEventListener('change', restoreTrackMode);
	    });
	  }
	  /**
	   * Attempt to force override of tracks for the given type
	   *
	   * @param {string} type - Track type to override, possible values include 'Audio',
	   * 'Video', and 'Text'.
	   * @param {boolean} override - If set to true native audio/video will be overridden,
	   * otherwise native audio/video will potentially be used.
	   * @private
	   */
	  ;
	
	  _proto.overrideNative_ = function overrideNative_(type, override) {
	    var _this2 = this;
	
	    // If there is no behavioral change don't add/remove listeners
	    if (override !== this["featuresNative" + type + "Tracks"]) {
	      return;
	    }
	
	    var lowerCaseType = type.toLowerCase();
	
	    if (this[lowerCaseType + "TracksListeners_"]) {
	      Object.keys(this[lowerCaseType + "TracksListeners_"]).forEach(function (eventName) {
	        var elTracks = _this2.el()[lowerCaseType + "Tracks"];
	
	        elTracks.removeEventListener(eventName, _this2[lowerCaseType + "TracksListeners_"][eventName]);
	      });
	    }
	
	    this["featuresNative" + type + "Tracks"] = !override;
	    this[lowerCaseType + "TracksListeners_"] = null;
	    this.proxyNativeTracksForType_(lowerCaseType);
	  }
	  /**
	   * Attempt to force override of native audio tracks.
	   *
	   * @param {boolean} override - If set to true native audio will be overridden,
	   * otherwise native audio will potentially be used.
	   */
	  ;
	
	  _proto.overrideNativeAudioTracks = function overrideNativeAudioTracks(override) {
	    this.overrideNative_('Audio', override);
	  }
	  /**
	   * Attempt to force override of native video tracks.
	   *
	   * @param {boolean} override - If set to true native video will be overridden,
	   * otherwise native video will potentially be used.
	   */
	  ;
	
	  _proto.overrideNativeVideoTracks = function overrideNativeVideoTracks(override) {
	    this.overrideNative_('Video', override);
	  }
	  /**
	   * Proxy native track list events for the given type to our track
	   * lists if the browser we are playing in supports that type of track list.
	   *
	   * @param {string} name - Track type; values include 'audio', 'video', and 'text'
	   * @private
	   */
	  ;
	
	  _proto.proxyNativeTracksForType_ = function proxyNativeTracksForType_(name) {
	    var _this3 = this;
	
	    var props = NORMAL[name];
	    var elTracks = this.el()[props.getterName];
	    var techTracks = this[props.getterName]();
	
	    if (!this["featuresNative" + props.capitalName + "Tracks"] || !elTracks || !elTracks.addEventListener) {
	      return;
	    }
	
	    var listeners = {
	      change: function change(e) {
	        var event = {
	          type: 'change',
	          target: techTracks,
	          currentTarget: techTracks,
	          srcElement: techTracks
	        };
	        techTracks.trigger(event); // if we are a text track change event, we should also notify the
	        // remote text track list. This can potentially cause a false positive
	        // if we were to get a change event on a non-remote track and
	        // we triggered the event on the remote text track list which doesn't
	        // contain that track. However, best practices mean looping through the
	        // list of tracks and searching for the appropriate mode value, so,
	        // this shouldn't pose an issue
	
	        if (name === 'text') {
	          _this3[REMOTE.remoteText.getterName]().trigger(event);
	        }
	      },
	      addtrack: function addtrack(e) {
	        techTracks.addTrack(e.track);
	      },
	      removetrack: function removetrack(e) {
	        techTracks.removeTrack(e.track);
	      }
	    };
	
	    var removeOldTracks = function removeOldTracks() {
	      var removeTracks = [];
	
	      for (var i = 0; i < techTracks.length; i++) {
	        var found = false;
	
	        for (var j = 0; j < elTracks.length; j++) {
	          if (elTracks[j] === techTracks[i]) {
	            found = true;
	            break;
	          }
	        }
	
	        if (!found) {
	          removeTracks.push(techTracks[i]);
	        }
	      }
	
	      while (removeTracks.length) {
	        techTracks.removeTrack(removeTracks.shift());
	      }
	    };
	
	    this[props.getterName + 'Listeners_'] = listeners;
	    Object.keys(listeners).forEach(function (eventName) {
	      var listener = listeners[eventName];
	      elTracks.addEventListener(eventName, listener);
	
	      _this3.on('dispose', function (e) {
	        return elTracks.removeEventListener(eventName, listener);
	      });
	    }); // Remove (native) tracks that are not used anymore
	
	    this.on('loadstart', removeOldTracks);
	    this.on('dispose', function (e) {
	      return _this3.off('loadstart', removeOldTracks);
	    });
	  }
	  /**
	   * Proxy all native track list events to our track lists if the browser we are playing
	   * in supports that type of track list.
	   *
	   * @private
	   */
	  ;
	
	  _proto.proxyNativeTracks_ = function proxyNativeTracks_() {
	    var _this4 = this;
	
	    NORMAL.names.forEach(function (name) {
	      _this4.proxyNativeTracksForType_(name);
	    });
	  }
	  /**
	   * Create the `Html5` Tech's DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    var el = this.options_.tag; // Check if this browser supports moving the element into the box.
	    // On the iPhone video will break if you move the element,
	    // So we have to create a brand new element.
	    // If we ingested the player div, we do not need to move the media element.
	
	    if (!el || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
	      // If the original tag is still there, clone and remove it.
	      if (el) {
	        var clone = el.cloneNode(true);
	
	        if (el.parentNode) {
	          el.parentNode.insertBefore(clone, el);
	        }
	
	        Html5.disposeMediaElement(el);
	        el = clone;
	      } else {
	        el = document__default['default'].createElement('video'); // determine if native controls should be used
	
	        var tagAttributes = this.options_.tag && getAttributes(this.options_.tag);
	        var attributes = mergeOptions$3({}, tagAttributes);
	
	        if (!TOUCH_ENABLED || this.options_.nativeControlsForTouch !== true) {
	          delete attributes.controls;
	        }
	
	        setAttributes(el, assign(attributes, {
	          id: this.options_.techId,
	          "class": 'vjs-tech'
	        }));
	      }
	
	      el.playerId = this.options_.playerId;
	    }
	
	    if (typeof this.options_.preload !== 'undefined') {
	      setAttribute(el, 'preload', this.options_.preload);
	    }
	
	    if (this.options_.disablePictureInPicture !== undefined) {
	      el.disablePictureInPicture = this.options_.disablePictureInPicture;
	    } // Update specific tag settings, in case they were overridden
	    // `autoplay` has to be *last* so that `muted` and `playsinline` are present
	    // when iOS/Safari or other browsers attempt to autoplay.
	
	
	    var settingsAttrs = ['loop', 'muted', 'playsinline', 'autoplay'];
	
	    for (var i = 0; i < settingsAttrs.length; i++) {
	      var attr = settingsAttrs[i];
	      var value = this.options_[attr];
	
	      if (typeof value !== 'undefined') {
	        if (value) {
	          setAttribute(el, attr, attr);
	        } else {
	          removeAttribute(el, attr);
	        }
	
	        el[attr] = value;
	      }
	    }
	
	    return el;
	  }
	  /**
	   * This will be triggered if the loadstart event has already fired, before videojs was
	   * ready. Two known examples of when this can happen are:
	   * 1. If we're loading the playback object after it has started loading
	   * 2. The media is already playing the (often with autoplay on) then
	   *
	   * This function will fire another loadstart so that videojs can catchup.
	   *
	   * @fires Tech#loadstart
	   *
	   * @return {undefined}
	   *         returns nothing.
	   */
	  ;
	
	  _proto.handleLateInit_ = function handleLateInit_(el) {
	    if (el.networkState === 0 || el.networkState === 3) {
	      // The video element hasn't started loading the source yet
	      // or didn't find a source
	      return;
	    }
	
	    if (el.readyState === 0) {
	      // NetworkState is set synchronously BUT loadstart is fired at the
	      // end of the current stack, usually before setInterval(fn, 0).
	      // So at this point we know loadstart may have already fired or is
	      // about to fire, and either way the player hasn't seen it yet.
	      // We don't want to fire loadstart prematurely here and cause a
	      // double loadstart so we'll wait and see if it happens between now
	      // and the next loop, and fire it if not.
	      // HOWEVER, we also want to make sure it fires before loadedmetadata
	      // which could also happen between now and the next loop, so we'll
	      // watch for that also.
	      var loadstartFired = false;
	
	      var setLoadstartFired = function setLoadstartFired() {
	        loadstartFired = true;
	      };
	
	      this.on('loadstart', setLoadstartFired);
	
	      var triggerLoadstart = function triggerLoadstart() {
	        // We did miss the original loadstart. Make sure the player
	        // sees loadstart before loadedmetadata
	        if (!loadstartFired) {
	          this.trigger('loadstart');
	        }
	      };
	
	      this.on('loadedmetadata', triggerLoadstart);
	      this.ready(function () {
	        this.off('loadstart', setLoadstartFired);
	        this.off('loadedmetadata', triggerLoadstart);
	
	        if (!loadstartFired) {
	          // We did miss the original native loadstart. Fire it now.
	          this.trigger('loadstart');
	        }
	      });
	      return;
	    } // From here on we know that loadstart already fired and we missed it.
	    // The other readyState events aren't as much of a problem if we double
	    // them, so not going to go to as much trouble as loadstart to prevent
	    // that unless we find reason to.
	
	
	    var eventsToTrigger = ['loadstart']; // loadedmetadata: newly equal to HAVE_METADATA (1) or greater
	
	    eventsToTrigger.push('loadedmetadata'); // loadeddata: newly increased to HAVE_CURRENT_DATA (2) or greater
	
	    if (el.readyState >= 2) {
	      eventsToTrigger.push('loadeddata');
	    } // canplay: newly increased to HAVE_FUTURE_DATA (3) or greater
	
	
	    if (el.readyState >= 3) {
	      eventsToTrigger.push('canplay');
	    } // canplaythrough: newly equal to HAVE_ENOUGH_DATA (4)
	
	
	    if (el.readyState >= 4) {
	      eventsToTrigger.push('canplaythrough');
	    } // We still need to give the player time to add event listeners
	
	
	    this.ready(function () {
	      eventsToTrigger.forEach(function (type) {
	        this.trigger(type);
	      }, this);
	    });
	  }
	  /**
	   * Set whether we are scrubbing or not.
	   * This is used to decide whether we should use `fastSeek` or not.
	   * `fastSeek` is used to provide trick play on Safari browsers.
	   *
	   * @param {boolean} isScrubbing
	   *                  - true for we are currently scrubbing
	   *                  - false for we are no longer scrubbing
	   */
	  ;
	
	  _proto.setScrubbing = function setScrubbing(isScrubbing) {
	    this.isScrubbing_ = isScrubbing;
	  }
	  /**
	   * Get whether we are scrubbing or not.
	   *
	   * @return {boolean} isScrubbing
	   *                  - true for we are currently scrubbing
	   *                  - false for we are no longer scrubbing
	   */
	  ;
	
	  _proto.scrubbing = function scrubbing() {
	    return this.isScrubbing_;
	  }
	  /**
	   * Set current time for the `HTML5` tech.
	   *
	   * @param {number} seconds
	   *        Set the current time of the media to this.
	   */
	  ;
	
	  _proto.setCurrentTime = function setCurrentTime(seconds) {
	    try {
	      if (this.isScrubbing_ && this.el_.fastSeek && IS_ANY_SAFARI) {
	        this.el_.fastSeek(seconds);
	      } else {
	        this.el_.currentTime = seconds;
	      }
	    } catch (e) {
	      log$1(e, 'Video is not ready. (Video.js)'); // this.warning(VideoJS.warnings.videoNotReady);
	    }
	  }
	  /**
	   * Get the current duration of the HTML5 media element.
	   *
	   * @return {number}
	   *         The duration of the media or 0 if there is no duration.
	   */
	  ;
	
	  _proto.duration = function duration() {
	    var _this5 = this;
	
	    // Android Chrome will report duration as Infinity for VOD HLS until after
	    // playback has started, which triggers the live display erroneously.
	    // Return NaN if playback has not started and trigger a durationupdate once
	    // the duration can be reliably known.
	    if (this.el_.duration === Infinity && IS_ANDROID && IS_CHROME && this.el_.currentTime === 0) {
	      // Wait for the first `timeupdate` with currentTime > 0 - there may be
	      // several with 0
	      var checkProgress = function checkProgress() {
	        if (_this5.el_.currentTime > 0) {
	          // Trigger durationchange for genuinely live video
	          if (_this5.el_.duration === Infinity) {
	            _this5.trigger('durationchange');
	          }
	
	          _this5.off('timeupdate', checkProgress);
	        }
	      };
	
	      this.on('timeupdate', checkProgress);
	      return NaN;
	    }
	
	    return this.el_.duration || NaN;
	  }
	  /**
	   * Get the current width of the HTML5 media element.
	   *
	   * @return {number}
	   *         The width of the HTML5 media element.
	   */
	  ;
	
	  _proto.width = function width() {
	    return this.el_.offsetWidth;
	  }
	  /**
	   * Get the current height of the HTML5 media element.
	   *
	   * @return {number}
	   *         The height of the HTML5 media element.
	   */
	  ;
	
	  _proto.height = function height() {
	    return this.el_.offsetHeight;
	  }
	  /**
	   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
	   * `fullscreenchange` event.
	   *
	   * @private
	   * @fires fullscreenchange
	   * @listens webkitendfullscreen
	   * @listens webkitbeginfullscreen
	   * @listens webkitbeginfullscreen
	   */
	  ;
	
	  _proto.proxyWebkitFullscreen_ = function proxyWebkitFullscreen_() {
	    var _this6 = this;
	
	    if (!('webkitDisplayingFullscreen' in this.el_)) {
	      return;
	    }
	
	    var endFn = function endFn() {
	      this.trigger('fullscreenchange', {
	        isFullscreen: false
	      }); // Safari will sometimes set contols on the videoelement when existing fullscreen.
	
	      if (this.el_.controls && !this.options_.nativeControlsForTouch && this.controls()) {
	        this.el_.controls = false;
	      }
	    };
	
	    var beginFn = function beginFn() {
	      if ('webkitPresentationMode' in this.el_ && this.el_.webkitPresentationMode !== 'picture-in-picture') {
	        this.one('webkitendfullscreen', endFn);
	        this.trigger('fullscreenchange', {
	          isFullscreen: true,
	          // set a flag in case another tech triggers fullscreenchange
	          nativeIOSFullscreen: true
	        });
	      }
	    };
	
	    this.on('webkitbeginfullscreen', beginFn);
	    this.on('dispose', function () {
	      _this6.off('webkitbeginfullscreen', beginFn);
	
	      _this6.off('webkitendfullscreen', endFn);
	    });
	  }
	  /**
	   * Check if fullscreen is supported on the current playback device.
	   *
	   * @return {boolean}
	   *         - True if fullscreen is supported.
	   *         - False if fullscreen is not supported.
	   */
	  ;
	
	  _proto.supportsFullScreen = function supportsFullScreen() {
	    if (typeof this.el_.webkitEnterFullScreen === 'function') {
	      var userAgent = window__default['default'].navigator && window__default['default'].navigator.userAgent || ''; // Seems to be broken in Chromium/Chrome && Safari in Leopard
	
	      if (/Android/.test(userAgent) || !/Chrome|Mac OS X 10.5/.test(userAgent)) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	  /**
	   * Request that the `HTML5` Tech enter fullscreen.
	   */
	  ;
	
	  _proto.enterFullScreen = function enterFullScreen() {
	    var video = this.el_;
	
	    if (video.paused && video.networkState <= video.HAVE_METADATA) {
	      // attempt to prime the video element for programmatic access
	      // this isn't necessary on the desktop but shouldn't hurt
	      silencePromise(this.el_.play()); // playing and pausing synchronously during the transition to fullscreen
	      // can get iOS ~6.1 devices into a play/pause loop
	
	      this.setTimeout(function () {
	        video.pause();
	
	        try {
	          video.webkitEnterFullScreen();
	        } catch (e) {
	          this.trigger('fullscreenerror', e);
	        }
	      }, 0);
	    } else {
	      try {
	        video.webkitEnterFullScreen();
	      } catch (e) {
	        this.trigger('fullscreenerror', e);
	      }
	    }
	  }
	  /**
	   * Request that the `HTML5` Tech exit fullscreen.
	   */
	  ;
	
	  _proto.exitFullScreen = function exitFullScreen() {
	    if (!this.el_.webkitDisplayingFullscreen) {
	      this.trigger('fullscreenerror', new Error('The video is not fullscreen'));
	      return;
	    }
	
	    this.el_.webkitExitFullScreen();
	  }
	  /**
	   * Create a floating video window always on top of other windows so that users may
	   * continue consuming media while they interact with other content sites, or
	   * applications on their device.
	   *
	   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
	   *
	   * @return {Promise}
	   *         A promise with a Picture-in-Picture window.
	   */
	  ;
	
	  _proto.requestPictureInPicture = function requestPictureInPicture() {
	    return this.el_.requestPictureInPicture();
	  }
	  /**
	   * Native requestVideoFrameCallback if supported by browser/tech, or fallback
	   * Don't use rVCF on Safari when DRM is playing, as it doesn't fire
	   * Needs to be checked later than the constructor
	   * This will be a false positive for clear sources loaded after a Fairplay source
	   *
	   * @param {function} cb function to call
	   * @return {number} id of request
	   */
	  ;
	
	  _proto.requestVideoFrameCallback = function requestVideoFrameCallback(cb) {
	    if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) {
	      return this.el_.requestVideoFrameCallback(cb);
	    }
	
	    return _Tech.prototype.requestVideoFrameCallback.call(this, cb);
	  }
	  /**
	   * Native or fallback requestVideoFrameCallback
	   *
	   * @param {number} id request id to cancel
	   */
	  ;
	
	  _proto.cancelVideoFrameCallback = function cancelVideoFrameCallback(id) {
	    if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) {
	      this.el_.cancelVideoFrameCallback(id);
	    } else {
	      _Tech.prototype.cancelVideoFrameCallback.call(this, id);
	    }
	  }
	  /**
	   * A getter/setter for the `Html5` Tech's source object.
	   * > Note: Please use {@link Html5#setSource}
	   *
	   * @param {Tech~SourceObject} [src]
	   *        The source object you want to set on the `HTML5` techs element.
	   *
	   * @return {Tech~SourceObject|undefined}
	   *         - The current source object when a source is not passed in.
	   *         - undefined when setting
	   *
	   * @deprecated Since version 5.
	   */
	  ;
	
	  _proto.src = function src(_src) {
	    if (_src === undefined) {
	      return this.el_.src;
	    } // Setting src through `src` instead of `setSrc` will be deprecated
	
	
	    this.setSrc(_src);
	  }
	  /**
	   * Reset the tech by removing all sources and then calling
	   * {@link Html5.resetMediaElement}.
	   */
	  ;
	
	  _proto.reset = function reset() {
	    Html5.resetMediaElement(this.el_);
	  }
	  /**
	   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
	   * the HTML5 media element.
	   *
	   * @return {Tech~SourceObject}
	   *         The current source object from the HTML5 tech. With a fallback to the
	   *         elements source.
	   */
	  ;
	
	  _proto.currentSrc = function currentSrc() {
	    if (this.currentSource_) {
	      return this.currentSource_.src;
	    }
	
	    return this.el_.currentSrc;
	  }
	  /**
	   * Set controls attribute for the HTML5 media Element.
	   *
	   * @param {string} val
	   *        Value to set the controls attribute to
	   */
	  ;
	
	  _proto.setControls = function setControls(val) {
	    this.el_.controls = !!val;
	  }
	  /**
	   * Create and returns a remote {@link TextTrack} object.
	   *
	   * @param {string} kind
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	   *
	   * @param {string} [label]
	   *        Label to identify the text track
	   *
	   * @param {string} [language]
	   *        Two letter language abbreviation
	   *
	   * @return {TextTrack}
	   *         The TextTrack that gets created.
	   */
	  ;
	
	  _proto.addTextTrack = function addTextTrack(kind, label, language) {
	    if (!this.featuresNativeTextTracks) {
	      return _Tech.prototype.addTextTrack.call(this, kind, label, language);
	    }
	
	    return this.el_.addTextTrack(kind, label, language);
	  }
	  /**
	   * Creates either native TextTrack or an emulated TextTrack depending
	   * on the value of `featuresNativeTextTracks`
	   *
	   * @param {Object} options
	   *        The object should contain the options to initialize the TextTrack with.
	   *
	   * @param {string} [options.kind]
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
	   *
	   * @param {string} [options.label]
	   *        Label to identify the text track
	   *
	   * @param {string} [options.language]
	   *        Two letter language abbreviation.
	   *
	   * @param {boolean} [options.default]
	   *        Default this track to on.
	   *
	   * @param {string} [options.id]
	   *        The internal id to assign this track.
	   *
	   * @param {string} [options.src]
	   *        A source url for the track.
	   *
	   * @return {HTMLTrackElement}
	   *         The track element that gets created.
	   */
	  ;
	
	  _proto.createRemoteTextTrack = function createRemoteTextTrack(options) {
	    if (!this.featuresNativeTextTracks) {
	      return _Tech.prototype.createRemoteTextTrack.call(this, options);
	    }
	
	    var htmlTrackElement = document__default['default'].createElement('track');
	
	    if (options.kind) {
	      htmlTrackElement.kind = options.kind;
	    }
	
	    if (options.label) {
	      htmlTrackElement.label = options.label;
	    }
	
	    if (options.language || options.srclang) {
	      htmlTrackElement.srclang = options.language || options.srclang;
	    }
	
	    if (options["default"]) {
	      htmlTrackElement["default"] = options["default"];
	    }
	
	    if (options.id) {
	      htmlTrackElement.id = options.id;
	    }
	
	    if (options.src) {
	      htmlTrackElement.src = options.src;
	    }
	
	    return htmlTrackElement;
	  }
	  /**
	   * Creates a remote text track object and returns an html track element.
	   *
	   * @param {Object} options The object should contain values for
	   * kind, language, label, and src (location of the WebVTT file)
	   * @param {boolean} [manualCleanup=true] if set to false, the TextTrack will be
	   * automatically removed from the video element whenever the source changes
	   * @return {HTMLTrackElement} An Html Track Element.
	   * This can be an emulated {@link HTMLTrackElement} or a native one.
	   * @deprecated The default value of the "manualCleanup" parameter will default
	   * to "false" in upcoming versions of Video.js
	   */
	  ;
	
	  _proto.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
	    var htmlTrackElement = _Tech.prototype.addRemoteTextTrack.call(this, options, manualCleanup);
	
	    if (this.featuresNativeTextTracks) {
	      this.el().appendChild(htmlTrackElement);
	    }
	
	    return htmlTrackElement;
	  }
	  /**
	   * Remove remote `TextTrack` from `TextTrackList` object
	   *
	   * @param {TextTrack} track
	   *        `TextTrack` object to remove
	   */
	  ;
	
	  _proto.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
	    _Tech.prototype.removeRemoteTextTrack.call(this, track);
	
	    if (this.featuresNativeTextTracks) {
	      var tracks = this.$$('track');
	      var i = tracks.length;
	
	      while (i--) {
	        if (track === tracks[i] || track === tracks[i].track) {
	          this.el().removeChild(tracks[i]);
	        }
	      }
	    }
	  }
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object}
	   *         An object with supported media playback quality metrics
	   */
	  ;
	
	  _proto.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    if (typeof this.el().getVideoPlaybackQuality === 'function') {
	      return this.el().getVideoPlaybackQuality();
	    }
	
	    var videoPlaybackQuality = {};
	
	    if (typeof this.el().webkitDroppedFrameCount !== 'undefined' && typeof this.el().webkitDecodedFrameCount !== 'undefined') {
	      videoPlaybackQuality.droppedVideoFrames = this.el().webkitDroppedFrameCount;
	      videoPlaybackQuality.totalVideoFrames = this.el().webkitDecodedFrameCount;
	    }
	
	    if (window__default['default'].performance && typeof window__default['default'].performance.now === 'function') {
	      videoPlaybackQuality.creationTime = window__default['default'].performance.now();
	    } else if (window__default['default'].performance && window__default['default'].performance.timing && typeof window__default['default'].performance.timing.navigationStart === 'number') {
	      videoPlaybackQuality.creationTime = window__default['default'].Date.now() - window__default['default'].performance.timing.navigationStart;
	    }
	
	    return videoPlaybackQuality;
	  };
	
	  return Html5;
	}(Tech);
	/* HTML5 Support Testing ---------------------------------------------------- */
	
	/**
	 * Element for testing browser HTML5 media capabilities
	 *
	 * @type {Element}
	 * @constant
	 * @private
	 */
	
	
	defineLazyProperty(Html5, 'TEST_VID', function () {
	  if (!isReal()) {
	    return;
	  }
	
	  var video = document__default['default'].createElement('video');
	  var track = document__default['default'].createElement('track');
	  track.kind = 'captions';
	  track.srclang = 'en';
	  track.label = 'English';
	  video.appendChild(track);
	  return video;
	});
	/**
	 * Check if HTML5 media is supported by this browser/device.
	 *
	 * @return {boolean}
	 *         - True if HTML5 media is supported.
	 *         - False if HTML5 media is not supported.
	 */
	
	Html5.isSupported = function () {
	  // IE with no Media Player is a LIAR! (#984)
	  try {
	    Html5.TEST_VID.volume = 0.5;
	  } catch (e) {
	    return false;
	  }
	
	  return !!(Html5.TEST_VID && Html5.TEST_VID.canPlayType);
	};
	/**
	 * Check if the tech can support the given type
	 *
	 * @param {string} type
	 *        The mimetype to check
	 * @return {string} 'probably', 'maybe', or '' (empty string)
	 */
	
	
	Html5.canPlayType = function (type) {
	  return Html5.TEST_VID.canPlayType(type);
	};
	/**
	 * Check if the tech can support the given source
	 *
	 * @param {Object} srcObj
	 *        The source object
	 * @param {Object} options
	 *        The options passed to the tech
	 * @return {string} 'probably', 'maybe', or '' (empty string)
	 */
	
	
	Html5.canPlaySource = function (srcObj, options) {
	  return Html5.canPlayType(srcObj.type);
	};
	/**
	 * Check if the volume can be changed in this browser/device.
	 * Volume cannot be changed in a lot of mobile devices.
	 * Specifically, it can't be changed from 1 on iOS.
	 *
	 * @return {boolean}
	 *         - True if volume can be controlled
	 *         - False otherwise
	 */
	
	
	Html5.canControlVolume = function () {
	  // IE will error if Windows Media Player not installed #3315
	  try {
	    var volume = Html5.TEST_VID.volume;
	    Html5.TEST_VID.volume = volume / 2 + 0.1;
	    var canControl = volume !== Html5.TEST_VID.volume; // With the introduction of iOS 15, there are cases where the volume is read as
	    // changed but reverts back to its original state at the start of the next tick.
	    // To determine whether volume can be controlled on iOS,
	    // a timeout is set and the volume is checked asynchronously.
	    // Since `features` doesn't currently work asynchronously, the value is manually set.
	
	    if (canControl && IS_IOS) {
	      window__default['default'].setTimeout(function () {
	        if (Html5 && Html5.prototype) {
	          Html5.prototype.featuresVolumeControl = volume !== Html5.TEST_VID.volume;
	        }
	      }); // default iOS to false, which will be updated in the timeout above.
	
	      return false;
	    }
	
	    return canControl;
	  } catch (e) {
	    return false;
	  }
	};
	/**
	 * Check if the volume can be muted in this browser/device.
	 * Some devices, e.g. iOS, don't allow changing volume
	 * but permits muting/unmuting.
	 *
	 * @return {bolean}
	 *      - True if volume can be muted
	 *      - False otherwise
	 */
	
	
	Html5.canMuteVolume = function () {
	  try {
	    var muted = Html5.TEST_VID.muted; // in some versions of iOS muted property doesn't always
	    // work, so we want to set both property and attribute
	
	    Html5.TEST_VID.muted = !muted;
	
	    if (Html5.TEST_VID.muted) {
	      setAttribute(Html5.TEST_VID, 'muted', 'muted');
	    } else {
	      removeAttribute(Html5.TEST_VID, 'muted', 'muted');
	    }
	
	    return muted !== Html5.TEST_VID.muted;
	  } catch (e) {
	    return false;
	  }
	};
	/**
	 * Check if the playback rate can be changed in this browser/device.
	 *
	 * @return {boolean}
	 *         - True if playback rate can be controlled
	 *         - False otherwise
	 */
	
	
	Html5.canControlPlaybackRate = function () {
	  // Playback rate API is implemented in Android Chrome, but doesn't do anything
	  // https://github.com/videojs/video.js/issues/3180
	  if (IS_ANDROID && IS_CHROME && CHROME_VERSION < 58) {
	    return false;
	  } // IE will error if Windows Media Player not installed #3315
	
	
	  try {
	    var playbackRate = Html5.TEST_VID.playbackRate;
	    Html5.TEST_VID.playbackRate = playbackRate / 2 + 0.1;
	    return playbackRate !== Html5.TEST_VID.playbackRate;
	  } catch (e) {
	    return false;
	  }
	};
	/**
	 * Check if we can override a video/audio elements attributes, with
	 * Object.defineProperty.
	 *
	 * @return {boolean}
	 *         - True if builtin attributes can be overridden
	 *         - False otherwise
	 */
	
	
	Html5.canOverrideAttributes = function () {
	  // if we cannot overwrite the src/innerHTML property, there is no support
	  // iOS 7 safari for instance cannot do this.
	  try {
	    var noop = function noop() {};
	
	    Object.defineProperty(document__default['default'].createElement('video'), 'src', {
	      get: noop,
	      set: noop
	    });
	    Object.defineProperty(document__default['default'].createElement('audio'), 'src', {
	      get: noop,
	      set: noop
	    });
	    Object.defineProperty(document__default['default'].createElement('video'), 'innerHTML', {
	      get: noop,
	      set: noop
	    });
	    Object.defineProperty(document__default['default'].createElement('audio'), 'innerHTML', {
	      get: noop,
	      set: noop
	    });
	  } catch (e) {
	    return false;
	  }
	
	  return true;
	};
	/**
	 * Check to see if native `TextTrack`s are supported by this browser/device.
	 *
	 * @return {boolean}
	 *         - True if native `TextTrack`s are supported.
	 *         - False otherwise
	 */
	
	
	Html5.supportsNativeTextTracks = function () {
	  return IS_ANY_SAFARI || IS_IOS && IS_CHROME;
	};
	/**
	 * Check to see if native `VideoTrack`s are supported by this browser/device
	 *
	 * @return {boolean}
	 *        - True if native `VideoTrack`s are supported.
	 *        - False otherwise
	 */
	
	
	Html5.supportsNativeVideoTracks = function () {
	  return !!(Html5.TEST_VID && Html5.TEST_VID.videoTracks);
	};
	/**
	 * Check to see if native `AudioTrack`s are supported by this browser/device
	 *
	 * @return {boolean}
	 *        - True if native `AudioTrack`s are supported.
	 *        - False otherwise
	 */
	
	
	Html5.supportsNativeAudioTracks = function () {
	  return !!(Html5.TEST_VID && Html5.TEST_VID.audioTracks);
	};
	/**
	 * An array of events available on the Html5 tech.
	 *
	 * @private
	 * @type {Array}
	 */
	
	
	Html5.Events = ['loadstart', 'suspend', 'abort', 'error', 'emptied', 'stalled', 'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough', 'playing', 'waiting', 'seeking', 'seeked', 'ended', 'durationchange', 'timeupdate', 'progress', 'play', 'pause', 'ratechange', 'resize', 'volumechange'];
	/**
	 * Boolean indicating whether the `Tech` supports volume control.
	 *
	 * @type {boolean}
	 * @default {@link Html5.canControlVolume}
	 */
	
	/**
	 * Boolean indicating whether the `Tech` supports muting volume.
	 *
	 * @type {bolean}
	 * @default {@link Html5.canMuteVolume}
	 */
	
	/**
	 * Boolean indicating whether the `Tech` supports changing the speed at which the media
	 * plays. Examples:
	 *   - Set player to play 2x (twice) as fast
	 *   - Set player to play 0.5x (half) as fast
	 *
	 * @type {boolean}
	 * @default {@link Html5.canControlPlaybackRate}
	 */
	
	/**
	 * Boolean indicating whether the `Tech` supports the `sourceset` event.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `TextTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeTextTracks}
	 */
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `VideoTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeVideoTracks}
	 */
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `AudioTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeAudioTracks}
	 */
	
	[['featuresMuteControl', 'canMuteVolume'], ['featuresPlaybackRate', 'canControlPlaybackRate'], ['featuresSourceset', 'canOverrideAttributes'], ['featuresNativeTextTracks', 'supportsNativeTextTracks'], ['featuresNativeVideoTracks', 'supportsNativeVideoTracks'], ['featuresNativeAudioTracks', 'supportsNativeAudioTracks']].forEach(function (_ref) {
	  var key = _ref[0],
	      fn = _ref[1];
	  defineLazyProperty(Html5.prototype, key, function () {
	    return Html5[fn]();
	  }, true);
	});
	Html5.prototype.featuresVolumeControl = Html5.canControlVolume();
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the media element
	 * moving in the DOM. iOS breaks if you move the media element, so this is set this to
	 * false there. Everywhere else this should be true.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Html5.prototype.movingMediaElementInDOM = !IS_IOS; // TODO: Previous comment: No longer appears to be used. Can probably be removed.
	//       Is this true?
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports automatic media resize
	 * when going into fullscreen.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Html5.prototype.featuresFullscreenResize = true;
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the progress event.
	 * If this is false, manual `progress` events will be triggered instead.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Html5.prototype.featuresProgressEvents = true;
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the timeupdate event.
	 * If this is false, manual `timeupdate` events will be triggered instead.
	 *
	 * @default
	 */
	
	Html5.prototype.featuresTimeupdateEvents = true;
	/**
	 * Whether the HTML5 el supports `requestVideoFrameCallback`
	 *
	 * @type {boolean}
	 */
	
	Html5.prototype.featuresVideoFrameCallback = !!(Html5.TEST_VID && Html5.TEST_VID.requestVideoFrameCallback); // HTML5 Feature detection and Device Fixes --------------------------------- //
	
	var canPlayType;
	
	Html5.patchCanPlayType = function () {
	  // Android 4.0 and above can play HLS to some extent but it reports being unable to do so
	  // Firefox and Chrome report correctly
	  if (ANDROID_VERSION >= 4.0 && !IS_FIREFOX && !IS_CHROME) {
	    canPlayType = Html5.TEST_VID && Html5.TEST_VID.constructor.prototype.canPlayType;
	
	    Html5.TEST_VID.constructor.prototype.canPlayType = function (type) {
	      var mpegurlRE = /^application\/(?:x-|vnd\.apple\.)mpegurl/i;
	
	      if (type && mpegurlRE.test(type)) {
	        return 'maybe';
	      }
	
	      return canPlayType.call(this, type);
	    };
	  }
	};
	
	Html5.unpatchCanPlayType = function () {
	  var r = Html5.TEST_VID.constructor.prototype.canPlayType;
	
	  if (canPlayType) {
	    Html5.TEST_VID.constructor.prototype.canPlayType = canPlayType;
	  }
	
	  return r;
	}; // by default, patch the media element
	
	
	Html5.patchCanPlayType();
	
	Html5.disposeMediaElement = function (el) {
	  if (!el) {
	    return;
	  }
	
	  if (el.parentNode) {
	    el.parentNode.removeChild(el);
	  } // remove any child track or source nodes to prevent their loading
	
	
	  while (el.hasChildNodes()) {
	    el.removeChild(el.firstChild);
	  } // remove any src reference. not setting `src=''` because that causes a warning
	  // in firefox
	
	
	  el.removeAttribute('src'); // force the media element to update its loading state by calling load()
	  // however IE on Windows 7N has a bug that throws an error so need a try/catch (#793)
	
	  if (typeof el.load === 'function') {
	    // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
	    (function () {
	      try {
	        el.load();
	      } catch (e) {// not supported
	      }
	    })();
	  }
	};
	
	Html5.resetMediaElement = function (el) {
	  if (!el) {
	    return;
	  }
	
	  var sources = el.querySelectorAll('source');
	  var i = sources.length;
	
	  while (i--) {
	    el.removeChild(sources[i]);
	  } // remove any src reference.
	  // not setting `src=''` because that throws an error
	
	
	  el.removeAttribute('src');
	
	  if (typeof el.load === 'function') {
	    // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
	    (function () {
	      try {
	        el.load();
	      } catch (e) {// satisfy linter
	      }
	    })();
	  }
	};
	/* Native HTML5 element property wrapping ----------------------------------- */
	// Wrap native boolean attributes with getters that check both property and attribute
	// The list is as followed:
	// muted, defaultMuted, autoplay, controls, loop, playsinline
	
	
	[
	/**
	 * Get the value of `muted` from the media element. `muted` indicates
	 * that the volume for the media should be set to silent. This does not actually change
	 * the `volume` attribute.
	 *
	 * @method Html5#muted
	 * @return {boolean}
	 *         - True if the value of `volume` should be ignored and the audio set to silent.
	 *         - False if the value of `volume` should be used.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
	 */
	'muted',
	/**
	 * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
	 * whether the media should start muted or not. Only changes the default state of the
	 * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
	 * current state.
	 *
	 * @method Html5#defaultMuted
	 * @return {boolean}
	 *         - The value of `defaultMuted` from the media element.
	 *         - True indicates that the media should start muted.
	 *         - False indicates that the media should not start muted
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
	 */
	'defaultMuted',
	/**
	 * Get the value of `autoplay` from the media element. `autoplay` indicates
	 * that the media should start to play as soon as the page is ready.
	 *
	 * @method Html5#autoplay
	 * @return {boolean}
	 *         - The value of `autoplay` from the media element.
	 *         - True indicates that the media should start as soon as the page loads.
	 *         - False indicates that the media should not start as soon as the page loads.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
	 */
	'autoplay',
	/**
	 * Get the value of `controls` from the media element. `controls` indicates
	 * whether the native media controls should be shown or hidden.
	 *
	 * @method Html5#controls
	 * @return {boolean}
	 *         - The value of `controls` from the media element.
	 *         - True indicates that native controls should be showing.
	 *         - False indicates that native controls should be hidden.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
	 */
	'controls',
	/**
	 * Get the value of `loop` from the media element. `loop` indicates
	 * that the media should return to the start of the media and continue playing once
	 * it reaches the end.
	 *
	 * @method Html5#loop
	 * @return {boolean}
	 *         - The value of `loop` from the media element.
	 *         - True indicates that playback should seek back to start once
	 *           the end of a media is reached.
	 *         - False indicates that playback should not loop back to the start when the
	 *           end of the media is reached.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
	 */
	'loop',
	/**
	 * Get the value of `playsinline` from the media element. `playsinline` indicates
	 * to the browser that non-fullscreen playback is preferred when fullscreen
	 * playback is the native default, such as in iOS Safari.
	 *
	 * @method Html5#playsinline
	 * @return {boolean}
	 *         - The value of `playsinline` from the media element.
	 *         - True indicates that the media should play inline.
	 *         - False indicates that the media should not play inline.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	 */
	'playsinline'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop] || this.el_.hasAttribute(prop);
	  };
	}); // Wrap native boolean attributes with setters that set both property and attribute
	// The list is as followed:
	// setMuted, setDefaultMuted, setAutoplay, setLoop, setPlaysinline
	// setControls is special-cased above
	
	[
	/**
	 * Set the value of `muted` on the media element. `muted` indicates that the current
	 * audio level should be silent.
	 *
	 * @method Html5#setMuted
	 * @param {boolean} muted
	 *        - True if the audio should be set to silent
	 *        - False otherwise
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
	 */
	'muted',
	/**
	 * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
	 * audio level should be silent, but will only effect the muted level on initial playback..
	 *
	 * @method Html5.prototype.setDefaultMuted
	 * @param {boolean} defaultMuted
	 *        - True if the audio should be set to silent
	 *        - False otherwise
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
	 */
	'defaultMuted',
	/**
	 * Set the value of `autoplay` on the media element. `autoplay` indicates
	 * that the media should start to play as soon as the page is ready.
	 *
	 * @method Html5#setAutoplay
	 * @param {boolean} autoplay
	 *         - True indicates that the media should start as soon as the page loads.
	 *         - False indicates that the media should not start as soon as the page loads.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
	 */
	'autoplay',
	/**
	 * Set the value of `loop` on the media element. `loop` indicates
	 * that the media should return to the start of the media and continue playing once
	 * it reaches the end.
	 *
	 * @method Html5#setLoop
	 * @param {boolean} loop
	 *         - True indicates that playback should seek back to start once
	 *           the end of a media is reached.
	 *         - False indicates that playback should not loop back to the start when the
	 *           end of the media is reached.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
	 */
	'loop',
	/**
	 * Set the value of `playsinline` from the media element. `playsinline` indicates
	 * to the browser that non-fullscreen playback is preferred when fullscreen
	 * playback is the native default, such as in iOS Safari.
	 *
	 * @method Html5#setPlaysinline
	 * @param {boolean} playsinline
	 *         - True indicates that the media should play inline.
	 *         - False indicates that the media should not play inline.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	 */
	'playsinline'].forEach(function (prop) {
	  Html5.prototype['set' + toTitleCase$1(prop)] = function (v) {
	    this.el_[prop] = v;
	
	    if (v) {
	      this.el_.setAttribute(prop, prop);
	    } else {
	      this.el_.removeAttribute(prop);
	    }
	  };
	}); // Wrap native properties with a getter
	// The list is as followed
	// paused, currentTime, buffered, volume, poster, preload, error, seeking
	// seekable, ended, playbackRate, defaultPlaybackRate, disablePictureInPicture
	// played, networkState, readyState, videoWidth, videoHeight, crossOrigin
	
	[
	/**
	 * Get the value of `paused` from the media element. `paused` indicates whether the media element
	 * is currently paused or not.
	 *
	 * @method Html5#paused
	 * @return {boolean}
	 *         The value of `paused` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
	 */
	'paused',
	/**
	 * Get the value of `currentTime` from the media element. `currentTime` indicates
	 * the current second that the media is at in playback.
	 *
	 * @method Html5#currentTime
	 * @return {number}
	 *         The value of `currentTime` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
	 */
	'currentTime',
	/**
	 * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
	 * object that represents the parts of the media that are already downloaded and
	 * available for playback.
	 *
	 * @method Html5#buffered
	 * @return {TimeRange}
	 *         The value of `buffered` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
	 */
	'buffered',
	/**
	 * Get the value of `volume` from the media element. `volume` indicates
	 * the current playback volume of audio for a media. `volume` will be a value from 0
	 * (silent) to 1 (loudest and default).
	 *
	 * @method Html5#volume
	 * @return {number}
	 *         The value of `volume` from the media element. Value will be between 0-1.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
	 */
	'volume',
	/**
	 * Get the value of `poster` from the media element. `poster` indicates
	 * that the url of an image file that can/will be shown when no media data is available.
	 *
	 * @method Html5#poster
	 * @return {string}
	 *         The value of `poster` from the media element. Value will be a url to an
	 *         image.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
	 */
	'poster',
	/**
	 * Get the value of `preload` from the media element. `preload` indicates
	 * what should download before the media is interacted with. It can have the following
	 * values:
	 * - none: nothing should be downloaded
	 * - metadata: poster and the first few frames of the media may be downloaded to get
	 *   media dimensions and other metadata
	 * - auto: allow the media and metadata for the media to be downloaded before
	 *    interaction
	 *
	 * @method Html5#preload
	 * @return {string}
	 *         The value of `preload` from the media element. Will be 'none', 'metadata',
	 *         or 'auto'.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
	 */
	'preload',
	/**
	 * Get the value of the `error` from the media element. `error` indicates any
	 * MediaError that may have occurred during playback. If error returns null there is no
	 * current error.
	 *
	 * @method Html5#error
	 * @return {MediaError|null}
	 *         The value of `error` from the media element. Will be `MediaError` if there
	 *         is a current error and null otherwise.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
	 */
	'error',
	/**
	 * Get the value of `seeking` from the media element. `seeking` indicates whether the
	 * media is currently seeking to a new position or not.
	 *
	 * @method Html5#seeking
	 * @return {boolean}
	 *         - The value of `seeking` from the media element.
	 *         - True indicates that the media is currently seeking to a new position.
	 *         - False indicates that the media is not seeking to a new position at this time.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
	 */
	'seeking',
	/**
	 * Get the value of `seekable` from the media element. `seekable` returns a
	 * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
	 *
	 * @method Html5#seekable
	 * @return {TimeRange}
	 *         The value of `seekable` from the media element. A `TimeRange` object
	 *         indicating the current ranges of time that can be seeked to.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
	 */
	'seekable',
	/**
	 * Get the value of `ended` from the media element. `ended` indicates whether
	 * the media has reached the end or not.
	 *
	 * @method Html5#ended
	 * @return {boolean}
	 *         - The value of `ended` from the media element.
	 *         - True indicates that the media has ended.
	 *         - False indicates that the media has not ended.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
	 */
	'ended',
	/**
	 * Get the value of `playbackRate` from the media element. `playbackRate` indicates
	 * the rate at which the media is currently playing back. Examples:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5#playbackRate
	 * @return {number}
	 *         The value of `playbackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
	 */
	'playbackRate',
	/**
	 * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
	 * the rate at which the media is currently playing back. This value will not indicate the current
	 * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
	 *
	 * Examples:
	 *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
	 *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5.prototype.defaultPlaybackRate
	 * @return {number}
	 *         The value of `defaultPlaybackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
	 */
	'defaultPlaybackRate',
	/**
	 * Get the value of 'disablePictureInPicture' from the video element.
	 *
	 * @method Html5#disablePictureInPicture
	 * @return {boolean} value
	 *         - The value of `disablePictureInPicture` from the video element.
	 *         - True indicates that the video can't be played in Picture-In-Picture mode
	 *         - False indicates that the video can be played in Picture-In-Picture mode
	 *
	 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
	 */
	'disablePictureInPicture',
	/**
	 * Get the value of `played` from the media element. `played` returns a `TimeRange`
	 * object representing points in the media timeline that have been played.
	 *
	 * @method Html5#played
	 * @return {TimeRange}
	 *         The value of `played` from the media element. A `TimeRange` object indicating
	 *         the ranges of time that have been played.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
	 */
	'played',
	/**
	 * Get the value of `networkState` from the media element. `networkState` indicates
	 * the current network state. It returns an enumeration from the following list:
	 * - 0: NETWORK_EMPTY
	 * - 1: NETWORK_IDLE
	 * - 2: NETWORK_LOADING
	 * - 3: NETWORK_NO_SOURCE
	 *
	 * @method Html5#networkState
	 * @return {number}
	 *         The value of `networkState` from the media element. This will be a number
	 *         from the list in the description.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
	 */
	'networkState',
	/**
	 * Get the value of `readyState` from the media element. `readyState` indicates
	 * the current state of the media element. It returns an enumeration from the
	 * following list:
	 * - 0: HAVE_NOTHING
	 * - 1: HAVE_METADATA
	 * - 2: HAVE_CURRENT_DATA
	 * - 3: HAVE_FUTURE_DATA
	 * - 4: HAVE_ENOUGH_DATA
	 *
	 * @method Html5#readyState
	 * @return {number}
	 *         The value of `readyState` from the media element. This will be a number
	 *         from the list in the description.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
	 */
	'readyState',
	/**
	 * Get the value of `videoWidth` from the video element. `videoWidth` indicates
	 * the current width of the video in css pixels.
	 *
	 * @method Html5#videoWidth
	 * @return {number}
	 *         The value of `videoWidth` from the video element. This will be a number
	 *         in css pixels.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
	 */
	'videoWidth',
	/**
	 * Get the value of `videoHeight` from the video element. `videoHeight` indicates
	 * the current height of the video in css pixels.
	 *
	 * @method Html5#videoHeight
	 * @return {number}
	 *         The value of `videoHeight` from the video element. This will be a number
	 *         in css pixels.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
	 */
	'videoHeight',
	/**
	 * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
	 * to the browser that should sent the cookies along with the requests for the
	 * different assets/playlists
	 *
	 * @method Html5#crossOrigin
	 * @return {string}
	 *         - anonymous indicates that the media should not sent cookies.
	 *         - use-credentials indicates that the media should sent cookies along the requests.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
	 */
	'crossOrigin'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop];
	  };
	}); // Wrap native properties with a setter in this format:
	// set + toTitleCase(name)
	// The list is as follows:
	// setVolume, setSrc, setPoster, setPreload, setPlaybackRate, setDefaultPlaybackRate,
	// setDisablePictureInPicture, setCrossOrigin
	
	[
	/**
	 * Set the value of `volume` on the media element. `volume` indicates the current
	 * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
	 * so on.
	 *
	 * @method Html5#setVolume
	 * @param {number} percentAsDecimal
	 *        The volume percent as a decimal. Valid range is from 0-1.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
	 */
	'volume',
	/**
	 * Set the value of `src` on the media element. `src` indicates the current
	 * {@link Tech~SourceObject} for the media.
	 *
	 * @method Html5#setSrc
	 * @param {Tech~SourceObject} src
	 *        The source object to set as the current source.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
	 */
	'src',
	/**
	 * Set the value of `poster` on the media element. `poster` is the url to
	 * an image file that can/will be shown when no media data is available.
	 *
	 * @method Html5#setPoster
	 * @param {string} poster
	 *        The url to an image that should be used as the `poster` for the media
	 *        element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
	 */
	'poster',
	/**
	 * Set the value of `preload` on the media element. `preload` indicates
	 * what should download before the media is interacted with. It can have the following
	 * values:
	 * - none: nothing should be downloaded
	 * - metadata: poster and the first few frames of the media may be downloaded to get
	 *   media dimensions and other metadata
	 * - auto: allow the media and metadata for the media to be downloaded before
	 *    interaction
	 *
	 * @method Html5#setPreload
	 * @param {string} preload
	 *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
	 *         or 'auto'.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
	 */
	'preload',
	/**
	 * Set the value of `playbackRate` on the media element. `playbackRate` indicates
	 * the rate at which the media should play back. Examples:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5#setPlaybackRate
	 * @return {number}
	 *         The value of `playbackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
	 */
	'playbackRate',
	/**
	 * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
	 * the rate at which the media should play back upon initial startup. Changing this value
	 * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
	 *
	 * Example Values:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5.prototype.setDefaultPlaybackRate
	 * @return {number}
	 *         The value of `defaultPlaybackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
	 */
	'defaultPlaybackRate',
	/**
	 * Prevents the browser from suggesting a Picture-in-Picture context menu
	 * or to request Picture-in-Picture automatically in some cases.
	 *
	 * @method Html5#setDisablePictureInPicture
	 * @param {boolean} value
	 *         The true value will disable Picture-in-Picture mode.
	 *
	 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
	 */
	'disablePictureInPicture',
	/**
	 * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
	 * to the browser that should sent the cookies along with the requests for the
	 * different assets/playlists
	 *
	 * @method Html5#setCrossOrigin
	 * @param {string} crossOrigin
	 *         - anonymous indicates that the media should not sent cookies.
	 *         - use-credentials indicates that the media should sent cookies along the requests.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
	 */
	'crossOrigin'].forEach(function (prop) {
	  Html5.prototype['set' + toTitleCase$1(prop)] = function (v) {
	    this.el_[prop] = v;
	  };
	}); // wrap native functions with a function
	// The list is as follows:
	// pause, load, play
	
	[
	/**
	 * A wrapper around the media elements `pause` function. This will call the `HTML5`
	 * media elements `pause` function.
	 *
	 * @method Html5#pause
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
	 */
	'pause',
	/**
	 * A wrapper around the media elements `load` function. This will call the `HTML5`s
	 * media element `load` function.
	 *
	 * @method Html5#load
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
	 */
	'load',
	/**
	 * A wrapper around the media elements `play` function. This will call the `HTML5`s
	 * media element `play` function.
	 *
	 * @method Html5#play
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
	 */
	'play'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop]();
	  };
	});
	Tech.withSourceHandlers(Html5);
	/**
	 * Native source handler for Html5, simply passes the source to the media element.
	 *
	 * @property {Tech~SourceObject} source
	 *        The source object
	 *
	 * @property {Html5} tech
	 *        The instance of the HTML5 tech.
	 */
	
	Html5.nativeSourceHandler = {};
	/**
	 * Check if the media element can play the given mime type.
	 *
	 * @param {string} type
	 *        The mimetype to check
	 *
	 * @return {string}
	 *         'probably', 'maybe', or '' (empty string)
	 */
	
	Html5.nativeSourceHandler.canPlayType = function (type) {
	  // IE without MediaPlayer throws an error (#519)
	  try {
	    return Html5.TEST_VID.canPlayType(type);
	  } catch (e) {
	    return '';
	  }
	};
	/**
	 * Check if the media element can handle a source natively.
	 *
	 * @param {Tech~SourceObject} source
	 *         The source object
	 *
	 * @param {Object} [options]
	 *         Options to be passed to the tech.
	 *
	 * @return {string}
	 *         'probably', 'maybe', or '' (empty string).
	 */
	
	
	Html5.nativeSourceHandler.canHandleSource = function (source, options) {
	  // If a type was provided we should rely on that
	  if (source.type) {
	    return Html5.nativeSourceHandler.canPlayType(source.type); // If no type, fall back to checking 'video/[EXTENSION]'
	  } else if (source.src) {
	    var ext = getFileExtension(source.src);
	    return Html5.nativeSourceHandler.canPlayType("video/" + ext);
	  }
	
	  return '';
	};
	/**
	 * Pass the source to the native media element.
	 *
	 * @param {Tech~SourceObject} source
	 *        The source object
	 *
	 * @param {Html5} tech
	 *        The instance of the Html5 tech
	 *
	 * @param {Object} [options]
	 *        The options to pass to the source
	 */
	
	
	Html5.nativeSourceHandler.handleSource = function (source, tech, options) {
	  tech.setSrc(source.src);
	};
	/**
	 * A noop for the native dispose function, as cleanup is not needed.
	 */
	
	
	Html5.nativeSourceHandler.dispose = function () {}; // Register the native source handler
	
	
	Html5.registerSourceHandler(Html5.nativeSourceHandler);
	Tech.registerTech('Html5', Html5);
	
	// on the player when they happen
	
	var TECH_EVENTS_RETRIGGER = [
	/**
	 * Fired while the user agent is downloading media data.
	 *
	 * @event Player#progress
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `progress` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechProgress_
	 * @fires Player#progress
	 * @listens Tech#progress
	 */
	'progress',
	/**
	 * Fires when the loading of an audio/video is aborted.
	 *
	 * @event Player#abort
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `abort` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechAbort_
	 * @fires Player#abort
	 * @listens Tech#abort
	 */
	'abort',
	/**
	 * Fires when the browser is intentionally not getting media data.
	 *
	 * @event Player#suspend
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `suspend` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechSuspend_
	 * @fires Player#suspend
	 * @listens Tech#suspend
	 */
	'suspend',
	/**
	 * Fires when the current playlist is empty.
	 *
	 * @event Player#emptied
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `emptied` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechEmptied_
	 * @fires Player#emptied
	 * @listens Tech#emptied
	 */
	'emptied',
	/**
	 * Fires when the browser is trying to get media data, but data is not available.
	 *
	 * @event Player#stalled
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechStalled_
	 * @fires Player#stalled
	 * @listens Tech#stalled
	 */
	'stalled',
	/**
	 * Fires when the browser has loaded meta data for the audio/video.
	 *
	 * @event Player#loadedmetadata
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechLoadedmetadata_
	 * @fires Player#loadedmetadata
	 * @listens Tech#loadedmetadata
	 */
	'loadedmetadata',
	/**
	 * Fires when the browser has loaded the current frame of the audio/video.
	 *
	 * @event Player#loadeddata
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechLoaddeddata_
	 * @fires Player#loadeddata
	 * @listens Tech#loadeddata
	 */
	'loadeddata',
	/**
	 * Fires when the current playback position has changed.
	 *
	 * @event Player#timeupdate
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechTimeUpdate_
	 * @fires Player#timeupdate
	 * @listens Tech#timeupdate
	 */
	'timeupdate',
	/**
	 * Fires when the video's intrinsic dimensions change
	 *
	 * @event Player#resize
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `resize` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechResize_
	 * @fires Player#resize
	 * @listens Tech#resize
	 */
	'resize',
	/**
	 * Fires when the volume has been changed
	 *
	 * @event Player#volumechange
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechVolumechange_
	 * @fires Player#volumechange
	 * @listens Tech#volumechange
	 */
	'volumechange',
	/**
	 * Fires when the text track has been changed
	 *
	 * @event Player#texttrackchange
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechTexttrackchange_
	 * @fires Player#texttrackchange
	 * @listens Tech#texttrackchange
	 */
	'texttrackchange']; // events to queue when playback rate is zero
	// this is a hash for the sole purpose of mapping non-camel-cased event names
	// to camel-cased function names
	
	var TECH_EVENTS_QUEUE = {
	  canplay: 'CanPlay',
	  canplaythrough: 'CanPlayThrough',
	  playing: 'Playing',
	  seeked: 'Seeked'
	};
	var BREAKPOINT_ORDER = ['tiny', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'huge'];
	var BREAKPOINT_CLASSES = {}; // grep: vjs-layout-tiny
	// grep: vjs-layout-x-small
	// grep: vjs-layout-small
	// grep: vjs-layout-medium
	// grep: vjs-layout-large
	// grep: vjs-layout-x-large
	// grep: vjs-layout-huge
	
	BREAKPOINT_ORDER.forEach(function (k) {
	  var v = k.charAt(0) === 'x' ? "x-" + k.substring(1) : k;
	  BREAKPOINT_CLASSES[k] = "vjs-layout-" + v;
	});
	var DEFAULT_BREAKPOINTS = {
	  tiny: 210,
	  xsmall: 320,
	  small: 425,
	  medium: 768,
	  large: 1440,
	  xlarge: 2560,
	  huge: Infinity
	};
	/**
	 * An instance of the `Player` class is created when any of the Video.js setup methods
	 * are used to initialize a video.
	 *
	 * After an instance has been created it can be accessed globally in two ways:
	 * 1. By calling `videojs('example_video_1');`
	 * 2. By using it directly via  `videojs.players.example_video_1;`
	 *
	 * @extends Component
	 */
	
	var Player = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Player, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Element} tag
	   *        The original video DOM element used for configuring options.
	   *
	   * @param {Object} [options]
	   *        Object of option names and values.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        Ready callback function.
	   */
	  function Player(tag, options, ready) {
	    var _this;
	
	    // Make sure tag ID exists
	    tag.id = tag.id || options.id || "vjs_video_" + newGUID(); // Set Options
	    // The options argument overrides options set in the video tag
	    // which overrides globally set options.
	    // This latter part coincides with the load order
	    // (tag must exist before Player)
	
	    options = assign(Player.getTagSettings(tag), options); // Delay the initialization of children because we need to set up
	    // player properties first, and can't use `this` before `super()`
	
	    options.initChildren = false; // Same with creating the element
	
	    options.createEl = false; // don't auto mixin the evented mixin
	
	    options.evented = false; // we don't want the player to report touch activity on itself
	    // see enableTouchActivity in Component
	
	    options.reportTouchActivity = false; // If language is not set, get the closest lang attribute
	
	    if (!options.language) {
	      if (typeof tag.closest === 'function') {
	        var closest = tag.closest('[lang]');
	
	        if (closest && closest.getAttribute) {
	          options.language = closest.getAttribute('lang');
	        }
	      } else {
	        var element = tag;
	
	        while (element && element.nodeType === 1) {
	          if (getAttributes(element).hasOwnProperty('lang')) {
	            options.language = element.getAttribute('lang');
	            break;
	          }
	
	          element = element.parentNode;
	        }
	      }
	    } // Run base component initializing with new options
	
	
	    _this = _Component.call(this, null, options, ready) || this; // Create bound methods for document listeners.
	
	    _this.boundDocumentFullscreenChange_ = function (e) {
	      return _this.documentFullscreenChange_(e);
	    };
	
	    _this.boundFullWindowOnEscKey_ = function (e) {
	      return _this.fullWindowOnEscKey(e);
	    };
	
	    _this.boundUpdateStyleEl_ = function (e) {
	      return _this.updateStyleEl_(e);
	    };
	
	    _this.boundApplyInitTime_ = function (e) {
	      return _this.applyInitTime_(e);
	    };
	
	    _this.boundUpdateCurrentBreakpoint_ = function (e) {
	      return _this.updateCurrentBreakpoint_(e);
	    };
	
	    _this.boundHandleTechClick_ = function (e) {
	      return _this.handleTechClick_(e);
	    };
	
	    _this.boundHandleTechDoubleClick_ = function (e) {
	      return _this.handleTechDoubleClick_(e);
	    };
	
	    _this.boundHandleTechTouchStart_ = function (e) {
	      return _this.handleTechTouchStart_(e);
	    };
	
	    _this.boundHandleTechTouchMove_ = function (e) {
	      return _this.handleTechTouchMove_(e);
	    };
	
	    _this.boundHandleTechTouchEnd_ = function (e) {
	      return _this.handleTechTouchEnd_(e);
	    };
	
	    _this.boundHandleTechTap_ = function (e) {
	      return _this.handleTechTap_(e);
	    }; // default isFullscreen_ to false
	
	
	    _this.isFullscreen_ = false; // create logger
	
	    _this.log = createLogger(_this.id_); // Hold our own reference to fullscreen api so it can be mocked in tests
	
	    _this.fsApi_ = FullscreenApi; // Tracks when a tech changes the poster
	
	    _this.isPosterFromTech_ = false; // Holds callback info that gets queued when playback rate is zero
	    // and a seek is happening
	
	    _this.queuedCallbacks_ = []; // Turn off API access because we're loading a new tech that might load asynchronously
	
	    _this.isReady_ = false; // Init state hasStarted_
	
	    _this.hasStarted_ = false; // Init state userActive_
	
	    _this.userActive_ = false; // Init debugEnabled_
	
	    _this.debugEnabled_ = false; // Init state audioOnlyMode_
	
	    _this.audioOnlyMode_ = false; // Init state audioPosterMode_
	
	    _this.audioPosterMode_ = false; // Init state audioOnlyCache_
	
	    _this.audioOnlyCache_ = {
	      playerHeight: null,
	      hiddenChildren: []
	    }; // if the global option object was accidentally blown away by
	    // someone, bail early with an informative error
	
	    if (!_this.options_ || !_this.options_.techOrder || !_this.options_.techOrder.length) {
	      throw new Error('No techOrder specified. Did you overwrite ' + 'videojs.options instead of just changing the ' + 'properties you want to override?');
	    } // Store the original tag used to set options
	
	
	    _this.tag = tag; // Store the tag attributes used to restore html5 element
	
	    _this.tagAttributes = tag && getAttributes(tag); // Update current language
	
	    _this.language(_this.options_.language); // Update Supported Languages
	
	
	    if (options.languages) {
	      // Normalise player option languages to lowercase
	      var languagesToLower = {};
	      Object.getOwnPropertyNames(options.languages).forEach(function (name) {
	        languagesToLower[name.toLowerCase()] = options.languages[name];
	      });
	      _this.languages_ = languagesToLower;
	    } else {
	      _this.languages_ = Player.prototype.options_.languages;
	    }
	
	    _this.resetCache_(); // Set poster
	
	
	    _this.poster_ = options.poster || ''; // Set controls
	
	    _this.controls_ = !!options.controls; // Original tag settings stored in options
	    // now remove immediately so native controls don't flash.
	    // May be turned back on by HTML5 tech if nativeControlsForTouch is true
	
	    tag.controls = false;
	    tag.removeAttribute('controls');
	    _this.changingSrc_ = false;
	    _this.playCallbacks_ = [];
	    _this.playTerminatedQueue_ = []; // the attribute overrides the option
	
	    if (tag.hasAttribute('autoplay')) {
	      _this.autoplay(true);
	    } else {
	      // otherwise use the setter to validate and
	      // set the correct value.
	      _this.autoplay(_this.options_.autoplay);
	    } // check plugins
	
	
	    if (options.plugins) {
	      Object.keys(options.plugins).forEach(function (name) {
	        if (typeof _this[name] !== 'function') {
	          throw new Error("plugin \"" + name + "\" does not exist");
	        }
	      });
	    }
	    /*
	     * Store the internal state of scrubbing
	     *
	     * @private
	     * @return {Boolean} True if the user is scrubbing
	     */
	
	
	    _this.scrubbing_ = false;
	    _this.el_ = _this.createEl(); // Make this an evented object and use `el_` as its event bus.
	
	    evented(_assertThisInitialized__default['default'](_this), {
	      eventBusKey: 'el_'
	    }); // listen to document and player fullscreenchange handlers so we receive those events
	    // before a user can receive them so we can update isFullscreen appropriately.
	    // make sure that we listen to fullscreenchange events before everything else to make sure that
	    // our isFullscreen method is updated properly for internal components as well as external.
	
	    if (_this.fsApi_.requestFullscreen) {
	      on(document__default['default'], _this.fsApi_.fullscreenchange, _this.boundDocumentFullscreenChange_);
	
	      _this.on(_this.fsApi_.fullscreenchange, _this.boundDocumentFullscreenChange_);
	    }
	
	    if (_this.fluid_) {
	      _this.on(['playerreset', 'resize'], _this.boundUpdateStyleEl_);
	    } // We also want to pass the original player options to each component and plugin
	    // as well so they don't need to reach back into the player for options later.
	    // We also need to do another copy of this.options_ so we don't end up with
	    // an infinite loop.
	
	
	    var playerOptionsCopy = mergeOptions$3(_this.options_); // Load plugins
	
	    if (options.plugins) {
	      Object.keys(options.plugins).forEach(function (name) {
	        _this[name](options.plugins[name]);
	      });
	    } // Enable debug mode to fire debugon event for all plugins.
	
	
	    if (options.debug) {
	      _this.debug(true);
	    }
	
	    _this.options_.playerOptions = playerOptionsCopy;
	    _this.middleware_ = [];
	
	    _this.playbackRates(options.playbackRates);
	
	    _this.initChildren(); // Set isAudio based on whether or not an audio tag was used
	
	
	    _this.isAudio(tag.nodeName.toLowerCase() === 'audio'); // Update controls className. Can't do this when the controls are initially
	    // set because the element doesn't exist yet.
	
	
	    if (_this.controls()) {
	      _this.addClass('vjs-controls-enabled');
	    } else {
	      _this.addClass('vjs-controls-disabled');
	    } // Set ARIA label and region role depending on player type
	
	
	    _this.el_.setAttribute('role', 'region');
	
	    if (_this.isAudio()) {
	      _this.el_.setAttribute('aria-label', _this.localize('Audio Player'));
	    } else {
	      _this.el_.setAttribute('aria-label', _this.localize('Video Player'));
	    }
	
	    if (_this.isAudio()) {
	      _this.addClass('vjs-audio');
	    }
	
	    if (_this.flexNotSupported_()) {
	      _this.addClass('vjs-no-flex');
	    } // TODO: Make this smarter. Toggle user state between touching/mousing
	    // using events, since devices can have both touch and mouse events.
	    // TODO: Make this check be performed again when the window switches between monitors
	    // (See https://github.com/videojs/video.js/issues/5683)
	
	
	    if (TOUCH_ENABLED) {
	      _this.addClass('vjs-touch-enabled');
	    } // iOS Safari has broken hover handling
	
	
	    if (!IS_IOS) {
	      _this.addClass('vjs-workinghover');
	    } // Make player easily findable by ID
	
	
	    Player.players[_this.id_] = _assertThisInitialized__default['default'](_this); // Add a major version class to aid css in plugins
	
	    var majorVersion = version$5.split('.')[0];
	
	    _this.addClass("vjs-v" + majorVersion); // When the player is first initialized, trigger activity so components
	    // like the control bar show themselves if needed
	
	
	    _this.userActive(true);
	
	    _this.reportUserActivity();
	
	    _this.one('play', function (e) {
	      return _this.listenForUserActivity_(e);
	    });
	
	    _this.on('stageclick', function (e) {
	      return _this.handleStageClick_(e);
	    });
	
	    _this.on('keydown', function (e) {
	      return _this.handleKeyDown(e);
	    });
	
	    _this.on('languagechange', function (e) {
	      return _this.handleLanguagechange(e);
	    });
	
	    _this.breakpoints(_this.options_.breakpoints);
	
	    _this.responsive(_this.options_.responsive); // Calling both the audio mode methods after the player is fully
	    // setup to be able to listen to the events triggered by them
	
	
	    _this.on('ready', function () {
	      // Calling the audioPosterMode method first so that
	      // the audioOnlyMode can take precedence when both options are set to true
	      _this.audioPosterMode(_this.options_.audioPosterMode);
	
	      _this.audioOnlyMode(_this.options_.audioOnlyMode);
	    });
	
	    return _this;
	  }
	  /**
	   * Destroys the video player and does any necessary cleanup.
	   *
	   * This is especially helpful if you are dynamically adding and removing videos
	   * to/from the DOM.
	   *
	   * @fires Player#dispose
	   */
	
	
	  var _proto = Player.prototype;
	
	  _proto.dispose = function dispose() {
	    var _this2 = this;
	
	    /**
	     * Called when the player is being disposed of.
	     *
	     * @event Player#dispose
	     * @type {EventTarget~Event}
	     */
	    this.trigger('dispose'); // prevent dispose from being called twice
	
	    this.off('dispose'); // Make sure all player-specific document listeners are unbound. This is
	
	    off(document__default['default'], this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
	    off(document__default['default'], 'keydown', this.boundFullWindowOnEscKey_);
	
	    if (this.styleEl_ && this.styleEl_.parentNode) {
	      this.styleEl_.parentNode.removeChild(this.styleEl_);
	      this.styleEl_ = null;
	    } // Kill reference to this player
	
	
	    Player.players[this.id_] = null;
	
	    if (this.tag && this.tag.player) {
	      this.tag.player = null;
	    }
	
	    if (this.el_ && this.el_.player) {
	      this.el_.player = null;
	    }
	
	    if (this.tech_) {
	      this.tech_.dispose();
	      this.isPosterFromTech_ = false;
	      this.poster_ = '';
	    }
	
	    if (this.playerElIngest_) {
	      this.playerElIngest_ = null;
	    }
	
	    if (this.tag) {
	      this.tag = null;
	    }
	
	    clearCacheForPlayer(this); // remove all event handlers for track lists
	    // all tracks and track listeners are removed on
	    // tech dispose
	
	    ALL.names.forEach(function (name) {
	      var props = ALL[name];
	
	      var list = _this2[props.getterName](); // if it is not a native list
	      // we have to manually remove event listeners
	
	
	      if (list && list.off) {
	        list.off();
	      }
	    }); // the actual .el_ is removed here, or replaced if
	
	    _Component.prototype.dispose.call(this, {
	      restoreEl: this.options_.restoreEl
	    });
	  }
	  /**
	   * Create the `Player`'s DOM element.
	   *
	   * @return {Element}
	   *         The DOM element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    var tag = this.tag;
	    var el;
	    var playerElIngest = this.playerElIngest_ = tag.parentNode && tag.parentNode.hasAttribute && tag.parentNode.hasAttribute('data-vjs-player');
	    var divEmbed = this.tag.tagName.toLowerCase() === 'video-js';
	
	    if (playerElIngest) {
	      el = this.el_ = tag.parentNode;
	    } else if (!divEmbed) {
	      el = this.el_ = _Component.prototype.createEl.call(this, 'div');
	    } // Copy over all the attributes from the tag, including ID and class
	    // ID will now reference player box, not the video tag
	
	
	    var attrs = getAttributes(tag);
	
	    if (divEmbed) {
	      el = this.el_ = tag;
	      tag = this.tag = document__default['default'].createElement('video');
	
	      while (el.children.length) {
	        tag.appendChild(el.firstChild);
	      }
	
	      if (!hasClass(el, 'video-js')) {
	        addClass(el, 'video-js');
	      }
	
	      el.appendChild(tag);
	      playerElIngest = this.playerElIngest_ = el; // move properties over from our custom `video-js` element
	      // to our new `video` element. This will move things like
	      // `src` or `controls` that were set via js before the player
	      // was initialized.
	
	      Object.keys(el).forEach(function (k) {
	        try {
	          tag[k] = el[k];
	        } catch (e) {// we got a a property like outerHTML which we can't actually copy, ignore it
	        }
	      });
	    } // set tabindex to -1 to remove the video element from the focus order
	
	
	    tag.setAttribute('tabindex', '-1');
	    attrs.tabindex = '-1'; // Workaround for #4583 (JAWS+IE doesn't announce BPB or play button), and
	    // for the same issue with Chrome (on Windows) with JAWS.
	    // See https://github.com/FreedomScientific/VFO-standards-support/issues/78
	    // Note that we can't detect if JAWS is being used, but this ARIA attribute
	    //  doesn't change behavior of IE11 or Chrome if JAWS is not being used
	
	    if (IE_VERSION || IS_CHROME && IS_WINDOWS) {
	      tag.setAttribute('role', 'application');
	      attrs.role = 'application';
	    } // Remove width/height attrs from tag so CSS can make it 100% width/height
	
	
	    tag.removeAttribute('width');
	    tag.removeAttribute('height');
	
	    if ('width' in attrs) {
	      delete attrs.width;
	    }
	
	    if ('height' in attrs) {
	      delete attrs.height;
	    }
	
	    Object.getOwnPropertyNames(attrs).forEach(function (attr) {
	      // don't copy over the class attribute to the player element when we're in a div embed
	      // the class is already set up properly in the divEmbed case
	      // and we want to make sure that the `video-js` class doesn't get lost
	      if (!(divEmbed && attr === 'class')) {
	        el.setAttribute(attr, attrs[attr]);
	      }
	
	      if (divEmbed) {
	        tag.setAttribute(attr, attrs[attr]);
	      }
	    }); // Update tag id/class for use as HTML5 playback tech
	    // Might think we should do this after embedding in container so .vjs-tech class
	    // doesn't flash 100% width/height, but class only applies with .video-js parent
	
	    tag.playerId = tag.id;
	    tag.id += '_html5_api';
	    tag.className = 'vjs-tech'; // Make player findable on elements
	
	    tag.player = el.player = this; // Default state of video is paused
	
	    this.addClass('vjs-paused'); // Add a style element in the player that we'll use to set the width/height
	    // of the player in a way that's still overrideable by CSS, just like the
	    // video element
	
	    if (window__default['default'].VIDEOJS_NO_DYNAMIC_STYLE !== true) {
	      this.styleEl_ = createStyleElement('vjs-styles-dimensions');
	      var defaultsStyleEl = $('.vjs-styles-defaults');
	      var head = $('head');
	      head.insertBefore(this.styleEl_, defaultsStyleEl ? defaultsStyleEl.nextSibling : head.firstChild);
	    }
	
	    this.fill_ = false;
	    this.fluid_ = false; // Pass in the width/height/aspectRatio options which will update the style el
	
	    this.width(this.options_.width);
	    this.height(this.options_.height);
	    this.fill(this.options_.fill);
	    this.fluid(this.options_.fluid);
	    this.aspectRatio(this.options_.aspectRatio); // support both crossOrigin and crossorigin to reduce confusion and issues around the name
	
	    this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin); // Hide any links within the video/audio tag,
	    // because IE doesn't hide them completely from screen readers.
	
	    var links = tag.getElementsByTagName('a');
	
	    for (var i = 0; i < links.length; i++) {
	      var linkEl = links.item(i);
	      addClass(linkEl, 'vjs-hidden');
	      linkEl.setAttribute('hidden', 'hidden');
	    } // insertElFirst seems to cause the networkState to flicker from 3 to 2, so
	    // keep track of the original for later so we can know if the source originally failed
	
	
	    tag.initNetworkState_ = tag.networkState; // Wrap video tag in div (el/box) container
	
	    if (tag.parentNode && !playerElIngest) {
	      tag.parentNode.insertBefore(el, tag);
	    } // insert the tag as the first child of the player element
	    // then manually add it to the children array so that this.addChild
	    // will work properly for other components
	    //
	    // Breaks iPhone, fixed in HTML5 setup.
	
	
	    prependTo(tag, el);
	    this.children_.unshift(tag); // Set lang attr on player to ensure CSS :lang() in consistent with player
	    // if it's been set to something different to the doc
	
	    this.el_.setAttribute('lang', this.language_);
	    this.el_.setAttribute('translate', 'no');
	    this.el_ = el;
	    return el;
	  }
	  /**
	   * Get or set the `Player`'s crossOrigin option. For the HTML5 player, this
	   * sets the `crossOrigin` property on the `<video>` tag to control the CORS
	   * behavior.
	   *
	   * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
	   *
	   * @param {string} [value]
	   *        The value to set the `Player`'s crossOrigin to. If an argument is
	   *        given, must be one of `anonymous` or `use-credentials`.
	   *
	   * @return {string|undefined}
	   *         - The current crossOrigin value of the `Player` when getting.
	   *         - undefined when setting
	   */
	  ;
	
	  _proto.crossOrigin = function crossOrigin(value) {
	    if (!value) {
	      return this.techGet_('crossOrigin');
	    }
	
	    if (value !== 'anonymous' && value !== 'use-credentials') {
	      log$1.warn("crossOrigin must be \"anonymous\" or \"use-credentials\", given \"" + value + "\"");
	      return;
	    }
	
	    this.techCall_('setCrossOrigin', value);
	    return;
	  }
	  /**
	   * A getter/setter for the `Player`'s width. Returns the player's configured value.
	   * To get the current width use `currentWidth()`.
	   *
	   * @param {number} [value]
	   *        The value to set the `Player`'s width to.
	   *
	   * @return {number}
	   *         The current width of the `Player` when getting.
	   */
	  ;
	
	  _proto.width = function width(value) {
	    return this.dimension('width', value);
	  }
	  /**
	   * A getter/setter for the `Player`'s height. Returns the player's configured value.
	   * To get the current height use `currentheight()`.
	   *
	   * @param {number} [value]
	   *        The value to set the `Player`'s heigth to.
	   *
	   * @return {number}
	   *         The current height of the `Player` when getting.
	   */
	  ;
	
	  _proto.height = function height(value) {
	    return this.dimension('height', value);
	  }
	  /**
	   * A getter/setter for the `Player`'s width & height.
	   *
	   * @param {string} dimension
	   *        This string can be:
	   *        - 'width'
	   *        - 'height'
	   *
	   * @param {number} [value]
	   *        Value for dimension specified in the first argument.
	   *
	   * @return {number}
	   *         The dimension arguments value when getting (width/height).
	   */
	  ;
	
	  _proto.dimension = function dimension(_dimension, value) {
	    var privDimension = _dimension + '_';
	
	    if (value === undefined) {
	      return this[privDimension] || 0;
	    }
	
	    if (value === '' || value === 'auto') {
	      // If an empty string is given, reset the dimension to be automatic
	      this[privDimension] = undefined;
	      this.updateStyleEl_();
	      return;
	    }
	
	    var parsedVal = parseFloat(value);
	
	    if (isNaN(parsedVal)) {
	      log$1.error("Improper value \"" + value + "\" supplied for for " + _dimension);
	      return;
	    }
	
	    this[privDimension] = parsedVal;
	    this.updateStyleEl_();
	  }
	  /**
	   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
	   *
	   * Turning this on will turn off fill mode.
	   *
	   * @param {boolean} [bool]
	   *        - A value of true adds the class.
	   *        - A value of false removes the class.
	   *        - No value will be a getter.
	   *
	   * @return {boolean|undefined}
	   *         - The value of fluid when getting.
	   *         - `undefined` when setting.
	   */
	  ;
	
	  _proto.fluid = function fluid(bool) {
	    var _this3 = this;
	
	    if (bool === undefined) {
	      return !!this.fluid_;
	    }
	
	    this.fluid_ = !!bool;
	
	    if (isEvented(this)) {
	      this.off(['playerreset', 'resize'], this.boundUpdateStyleEl_);
	    }
	
	    if (bool) {
	      this.addClass('vjs-fluid');
	      this.fill(false);
	      addEventedCallback(this, function () {
	        _this3.on(['playerreset', 'resize'], _this3.boundUpdateStyleEl_);
	      });
	    } else {
	      this.removeClass('vjs-fluid');
	    }
	
	    this.updateStyleEl_();
	  }
	  /**
	   * A getter/setter/toggler for the vjs-fill `className` on the `Player`.
	   *
	   * Turning this on will turn off fluid mode.
	   *
	   * @param {boolean} [bool]
	   *        - A value of true adds the class.
	   *        - A value of false removes the class.
	   *        - No value will be a getter.
	   *
	   * @return {boolean|undefined}
	   *         - The value of fluid when getting.
	   *         - `undefined` when setting.
	   */
	  ;
	
	  _proto.fill = function fill(bool) {
	    if (bool === undefined) {
	      return !!this.fill_;
	    }
	
	    this.fill_ = !!bool;
	
	    if (bool) {
	      this.addClass('vjs-fill');
	      this.fluid(false);
	    } else {
	      this.removeClass('vjs-fill');
	    }
	  }
	  /**
	   * Get/Set the aspect ratio
	   *
	   * @param {string} [ratio]
	   *        Aspect ratio for player
	   *
	   * @return {string|undefined}
	   *         returns the current aspect ratio when getting
	   */
	
	  /**
	   * A getter/setter for the `Player`'s aspect ratio.
	   *
	   * @param {string} [ratio]
	   *        The value to set the `Player`'s aspect ratio to.
	   *
	   * @return {string|undefined}
	   *         - The current aspect ratio of the `Player` when getting.
	   *         - undefined when setting
	   */
	  ;
	
	  _proto.aspectRatio = function aspectRatio(ratio) {
	    if (ratio === undefined) {
	      return this.aspectRatio_;
	    } // Check for width:height format
	
	
	    if (!/^\d+\:\d+$/.test(ratio)) {
	      throw new Error('Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.');
	    }
	
	    this.aspectRatio_ = ratio; // We're assuming if you set an aspect ratio you want fluid mode,
	    // because in fixed mode you could calculate width and height yourself.
	
	    this.fluid(true);
	    this.updateStyleEl_();
	  }
	  /**
	   * Update styles of the `Player` element (height, width and aspect ratio).
	   *
	   * @private
	   * @listens Tech#loadedmetadata
	   */
	  ;
	
	  _proto.updateStyleEl_ = function updateStyleEl_() {
	    if (window__default['default'].VIDEOJS_NO_DYNAMIC_STYLE === true) {
	      var _width = typeof this.width_ === 'number' ? this.width_ : this.options_.width;
	
	      var _height = typeof this.height_ === 'number' ? this.height_ : this.options_.height;
	
	      var techEl = this.tech_ && this.tech_.el();
	
	      if (techEl) {
	        if (_width >= 0) {
	          techEl.width = _width;
	        }
	
	        if (_height >= 0) {
	          techEl.height = _height;
	        }
	      }
	
	      return;
	    }
	
	    var width;
	    var height;
	    var aspectRatio;
	    var idClass; // The aspect ratio is either used directly or to calculate width and height.
	
	    if (this.aspectRatio_ !== undefined && this.aspectRatio_ !== 'auto') {
	      // Use any aspectRatio that's been specifically set
	      aspectRatio = this.aspectRatio_;
	    } else if (this.videoWidth() > 0) {
	      // Otherwise try to get the aspect ratio from the video metadata
	      aspectRatio = this.videoWidth() + ':' + this.videoHeight();
	    } else {
	      // Or use a default. The video element's is 2:1, but 16:9 is more common.
	      aspectRatio = '16:9';
	    } // Get the ratio as a decimal we can use to calculate dimensions
	
	
	    var ratioParts = aspectRatio.split(':');
	    var ratioMultiplier = ratioParts[1] / ratioParts[0];
	
	    if (this.width_ !== undefined) {
	      // Use any width that's been specifically set
	      width = this.width_;
	    } else if (this.height_ !== undefined) {
	      // Or calulate the width from the aspect ratio if a height has been set
	      width = this.height_ / ratioMultiplier;
	    } else {
	      // Or use the video's metadata, or use the video el's default of 300
	      width = this.videoWidth() || 300;
	    }
	
	    if (this.height_ !== undefined) {
	      // Use any height that's been specifically set
	      height = this.height_;
	    } else {
	      // Otherwise calculate the height from the ratio and the width
	      height = width * ratioMultiplier;
	    } // Ensure the CSS class is valid by starting with an alpha character
	
	
	    if (/^[^a-zA-Z]/.test(this.id())) {
	      idClass = 'dimensions-' + this.id();
	    } else {
	      idClass = this.id() + '-dimensions';
	    } // Ensure the right class is still on the player for the style element
	
	
	    this.addClass(idClass);
	    setTextContent(this.styleEl_, "\n      ." + idClass + " {\n        width: " + width + "px;\n        height: " + height + "px;\n      }\n\n      ." + idClass + ".vjs-fluid:not(.vjs-audio-only-mode) {\n        padding-top: " + ratioMultiplier * 100 + "%;\n      }\n    ");
	  }
	  /**
	   * Load/Create an instance of playback {@link Tech} including element
	   * and API methods. Then append the `Tech` element in `Player` as a child.
	   *
	   * @param {string} techName
	   *        name of the playback technology
	   *
	   * @param {string} source
	   *        video source
	   *
	   * @private
	   */
	  ;
	
	  _proto.loadTech_ = function loadTech_(techName, source) {
	    var _this4 = this;
	
	    // Pause and remove current playback technology
	    if (this.tech_) {
	      this.unloadTech_();
	    }
	
	    var titleTechName = toTitleCase$1(techName);
	    var camelTechName = techName.charAt(0).toLowerCase() + techName.slice(1); // get rid of the HTML5 video tag as soon as we are using another tech
	
	    if (titleTechName !== 'Html5' && this.tag) {
	      Tech.getTech('Html5').disposeMediaElement(this.tag);
	      this.tag.player = null;
	      this.tag = null;
	    }
	
	    this.techName_ = titleTechName; // Turn off API access because we're loading a new tech that might load asynchronously
	
	    this.isReady_ = false;
	    var autoplay = this.autoplay(); // if autoplay is a string (or `true` with normalizeAutoplay: true) we pass false to the tech
	    // because the player is going to handle autoplay on `loadstart`
	
	    if (typeof this.autoplay() === 'string' || this.autoplay() === true && this.options_.normalizeAutoplay) {
	      autoplay = false;
	    } // Grab tech-specific options from player options and add source and parent element to use.
	
	
	    var techOptions = {
	      source: source,
	      autoplay: autoplay,
	      'nativeControlsForTouch': this.options_.nativeControlsForTouch,
	      'playerId': this.id(),
	      'techId': this.id() + "_" + camelTechName + "_api",
	      'playsinline': this.options_.playsinline,
	      'preload': this.options_.preload,
	      'loop': this.options_.loop,
	      'disablePictureInPicture': this.options_.disablePictureInPicture,
	      'muted': this.options_.muted,
	      'poster': this.poster(),
	      'language': this.language(),
	      'playerElIngest': this.playerElIngest_ || false,
	      'vtt.js': this.options_['vtt.js'],
	      'canOverridePoster': !!this.options_.techCanOverridePoster,
	      'enableSourceset': this.options_.enableSourceset,
	      'Promise': this.options_.Promise
	    };
	    ALL.names.forEach(function (name) {
	      var props = ALL[name];
	      techOptions[props.getterName] = _this4[props.privateName];
	    });
	    assign(techOptions, this.options_[titleTechName]);
	    assign(techOptions, this.options_[camelTechName]);
	    assign(techOptions, this.options_[techName.toLowerCase()]);
	
	    if (this.tag) {
	      techOptions.tag = this.tag;
	    }
	
	    if (source && source.src === this.cache_.src && this.cache_.currentTime > 0) {
	      techOptions.startTime = this.cache_.currentTime;
	    } // Initialize tech instance
	
	
	    var TechClass = Tech.getTech(techName);
	
	    if (!TechClass) {
	      throw new Error("No Tech named '" + titleTechName + "' exists! '" + titleTechName + "' should be registered using videojs.registerTech()'");
	    }
	
	    this.tech_ = new TechClass(techOptions); // player.triggerReady is always async, so don't need this to be async
	
	    this.tech_.ready(bind(this, this.handleTechReady_), true);
	    textTrackConverter.jsonToTextTracks(this.textTracksJson_ || [], this.tech_); // Listen to all HTML5-defined events and trigger them on the player
	
	    TECH_EVENTS_RETRIGGER.forEach(function (event) {
	      _this4.on(_this4.tech_, event, function (e) {
	        return _this4["handleTech" + toTitleCase$1(event) + "_"](e);
	      });
	    });
	    Object.keys(TECH_EVENTS_QUEUE).forEach(function (event) {
	      _this4.on(_this4.tech_, event, function (eventObj) {
	        if (_this4.tech_.playbackRate() === 0 && _this4.tech_.seeking()) {
	          _this4.queuedCallbacks_.push({
	            callback: _this4["handleTech" + TECH_EVENTS_QUEUE[event] + "_"].bind(_this4),
	            event: eventObj
	          });
	
	          return;
	        }
	
	        _this4["handleTech" + TECH_EVENTS_QUEUE[event] + "_"](eventObj);
	      });
	    });
	    this.on(this.tech_, 'loadstart', function (e) {
	      return _this4.handleTechLoadStart_(e);
	    });
	    this.on(this.tech_, 'sourceset', function (e) {
	      return _this4.handleTechSourceset_(e);
	    });
	    this.on(this.tech_, 'waiting', function (e) {
	      return _this4.handleTechWaiting_(e);
	    });
	    this.on(this.tech_, 'ended', function (e) {
	      return _this4.handleTechEnded_(e);
	    });
	    this.on(this.tech_, 'seeking', function (e) {
	      return _this4.handleTechSeeking_(e);
	    });
	    this.on(this.tech_, 'play', function (e) {
	      return _this4.handleTechPlay_(e);
	    });
	    this.on(this.tech_, 'firstplay', function (e) {
	      return _this4.handleTechFirstPlay_(e);
	    });
	    this.on(this.tech_, 'pause', function (e) {
	      return _this4.handleTechPause_(e);
	    });
	    this.on(this.tech_, 'durationchange', function (e) {
	      return _this4.handleTechDurationChange_(e);
	    });
	    this.on(this.tech_, 'fullscreenchange', function (e, data) {
	      return _this4.handleTechFullscreenChange_(e, data);
	    });
	    this.on(this.tech_, 'fullscreenerror', function (e, err) {
	      return _this4.handleTechFullscreenError_(e, err);
	    });
	    this.on(this.tech_, 'enterpictureinpicture', function (e) {
	      return _this4.handleTechEnterPictureInPicture_(e);
	    });
	    this.on(this.tech_, 'leavepictureinpicture', function (e) {
	      return _this4.handleTechLeavePictureInPicture_(e);
	    });
	    this.on(this.tech_, 'error', function (e) {
	      return _this4.handleTechError_(e);
	    });
	    this.on(this.tech_, 'posterchange', function (e) {
	      return _this4.handleTechPosterChange_(e);
	    });
	    this.on(this.tech_, 'textdata', function (e) {
	      return _this4.handleTechTextData_(e);
	    });
	    this.on(this.tech_, 'ratechange', function (e) {
	      return _this4.handleTechRateChange_(e);
	    });
	    this.on(this.tech_, 'loadedmetadata', this.boundUpdateStyleEl_);
	    this.usingNativeControls(this.techGet_('controls'));
	
	    if (this.controls() && !this.usingNativeControls()) {
	      this.addTechControlsListeners_();
	    } // Add the tech element in the DOM if it was not already there
	    // Make sure to not insert the original video element if using Html5
	
	
	    if (this.tech_.el().parentNode !== this.el() && (titleTechName !== 'Html5' || !this.tag)) {
	      prependTo(this.tech_.el(), this.el());
	    } // Get rid of the original video tag reference after the first tech is loaded
	
	
	    if (this.tag) {
	      this.tag.player = null;
	      this.tag = null;
	    }
	  }
	  /**
	   * Unload and dispose of the current playback {@link Tech}.
	   *
	   * @private
	   */
	  ;
	
	  _proto.unloadTech_ = function unloadTech_() {
	    var _this5 = this;
	
	    // Save the current text tracks so that we can reuse the same text tracks with the next tech
	    ALL.names.forEach(function (name) {
	      var props = ALL[name];
	      _this5[props.privateName] = _this5[props.getterName]();
	    });
	    this.textTracksJson_ = textTrackConverter.textTracksToJson(this.tech_);
	    this.isReady_ = false;
	    this.tech_.dispose();
	    this.tech_ = false;
	
	    if (this.isPosterFromTech_) {
	      this.poster_ = '';
	      this.trigger('posterchange');
	    }
	
	    this.isPosterFromTech_ = false;
	  }
	  /**
	   * Return a reference to the current {@link Tech}.
	   * It will print a warning by default about the danger of using the tech directly
	   * but any argument that is passed in will silence the warning.
	   *
	   * @param {*} [safety]
	   *        Anything passed in to silence the warning
	   *
	   * @return {Tech}
	   *         The Tech
	   */
	  ;
	
	  _proto.tech = function tech(safety) {
	    if (safety === undefined) {
	      log$1.warn('Using the tech directly can be dangerous. I hope you know what you\'re doing.\n' + 'See https://github.com/videojs/video.js/issues/2617 for more info.\n');
	    }
	
	    return this.tech_;
	  }
	  /**
	   * Set up click and touch listeners for the playback element
	   *
	   * - On desktops: a click on the video itself will toggle playback
	   * - On mobile devices: a click on the video toggles controls
	   *   which is done by toggling the user state between active and
	   *   inactive
	   * - A tap can signal that a user has become active or has become inactive
	   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
	   *   quick tap should hide them again (signaling the user is in an inactive
	   *   viewing state)
	   * - In addition to this, we still want the user to be considered inactive after
	   *   a few seconds of inactivity.
	   *
	   * > Note: the only part of iOS interaction we can't mimic with this setup
	   * is a touch and hold on the video element counting as activity in order to
	   * keep the controls showing, but that shouldn't be an issue. A touch and hold
	   * on any controls will still keep the user active
	   *
	   * @private
	   */
	  ;
	
	  _proto.addTechControlsListeners_ = function addTechControlsListeners_() {
	    // Make sure to remove all the previous listeners in case we are called multiple times.
	    this.removeTechControlsListeners_();
	    this.on(this.tech_, 'click', this.boundHandleTechClick_);
	    this.on(this.tech_, 'dblclick', this.boundHandleTechDoubleClick_); // If the controls were hidden we don't want that to change without a tap event
	    // so we'll check if the controls were already showing before reporting user
	    // activity
	
	    this.on(this.tech_, 'touchstart', this.boundHandleTechTouchStart_);
	    this.on(this.tech_, 'touchmove', this.boundHandleTechTouchMove_);
	    this.on(this.tech_, 'touchend', this.boundHandleTechTouchEnd_); // The tap listener needs to come after the touchend listener because the tap
	    // listener cancels out any reportedUserActivity when setting userActive(false)
	
	    this.on(this.tech_, 'tap', this.boundHandleTechTap_);
	  }
	  /**
	   * Remove the listeners used for click and tap controls. This is needed for
	   * toggling to controls disabled, where a tap/touch should do nothing.
	   *
	   * @private
	   */
	  ;
	
	  _proto.removeTechControlsListeners_ = function removeTechControlsListeners_() {
	    // We don't want to just use `this.off()` because there might be other needed
	    // listeners added by techs that extend this.
	    this.off(this.tech_, 'tap', this.boundHandleTechTap_);
	    this.off(this.tech_, 'touchstart', this.boundHandleTechTouchStart_);
	    this.off(this.tech_, 'touchmove', this.boundHandleTechTouchMove_);
	    this.off(this.tech_, 'touchend', this.boundHandleTechTouchEnd_);
	    this.off(this.tech_, 'click', this.boundHandleTechClick_);
	    this.off(this.tech_, 'dblclick', this.boundHandleTechDoubleClick_);
	  }
	  /**
	   * Player waits for the tech to be ready
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleTechReady_ = function handleTechReady_() {
	    this.triggerReady(); // Keep the same volume as before
	
	    if (this.cache_.volume) {
	      this.techCall_('setVolume', this.cache_.volume);
	    } // Look if the tech found a higher resolution poster while loading
	
	
	    this.handleTechPosterChange_(); // Update the duration if available
	
	    this.handleTechDurationChange_();
	  }
	  /**
	   * Retrigger the `loadstart` event that was triggered by the {@link Tech}. This
	   * function will also trigger {@link Player#firstplay} if it is the first loadstart
	   * for a video.
	   *
	   * @fires Player#loadstart
	   * @fires Player#firstplay
	   * @listens Tech#loadstart
	   * @private
	   */
	  ;
	
	  _proto.handleTechLoadStart_ = function handleTechLoadStart_() {
	    // TODO: Update to use `emptied` event instead. See #1277.
	    this.removeClass('vjs-ended');
	    this.removeClass('vjs-seeking'); // reset the error state
	
	    this.error(null); // Update the duration
	
	    this.handleTechDurationChange_(); // If it's already playing we want to trigger a firstplay event now.
	    // The firstplay event relies on both the play and loadstart events
	    // which can happen in any order for a new source
	
	    if (!this.paused()) {
	      /**
	       * Fired when the user agent begins looking for media data
	       *
	       * @event Player#loadstart
	       * @type {EventTarget~Event}
	       */
	      this.trigger('loadstart');
	      this.trigger('firstplay');
	    } else {
	      // reset the hasStarted state
	      this.hasStarted(false);
	      this.trigger('loadstart');
	    } // autoplay happens after loadstart for the browser,
	    // so we mimic that behavior
	
	
	    this.manualAutoplay_(this.autoplay() === true && this.options_.normalizeAutoplay ? 'play' : this.autoplay());
	  }
	  /**
	   * Handle autoplay string values, rather than the typical boolean
	   * values that should be handled by the tech. Note that this is not
	   * part of any specification. Valid values and what they do can be
	   * found on the autoplay getter at Player#autoplay()
	   */
	  ;
	
	  _proto.manualAutoplay_ = function manualAutoplay_(type) {
	    var _this6 = this;
	
	    if (!this.tech_ || typeof type !== 'string') {
	      return;
	    } // Save original muted() value, set muted to true, and attempt to play().
	    // On promise rejection, restore muted from saved value
	
	
	    var resolveMuted = function resolveMuted() {
	      var previouslyMuted = _this6.muted();
	
	      _this6.muted(true);
	
	      var restoreMuted = function restoreMuted() {
	        _this6.muted(previouslyMuted);
	      }; // restore muted on play terminatation
	
	
	      _this6.playTerminatedQueue_.push(restoreMuted);
	
	      var mutedPromise = _this6.play();
	
	      if (!isPromise(mutedPromise)) {
	        return;
	      }
	
	      return mutedPromise["catch"](function (err) {
	        restoreMuted();
	        throw new Error("Rejection at manualAutoplay. Restoring muted value. " + (err ? err : ''));
	      });
	    };
	
	    var promise; // if muted defaults to true
	    // the only thing we can do is call play
	
	    if (type === 'any' && !this.muted()) {
	      promise = this.play();
	
	      if (isPromise(promise)) {
	        promise = promise["catch"](resolveMuted);
	      }
	    } else if (type === 'muted' && !this.muted()) {
	      promise = resolveMuted();
	    } else {
	      promise = this.play();
	    }
	
	    if (!isPromise(promise)) {
	      return;
	    }
	
	    return promise.then(function () {
	      _this6.trigger({
	        type: 'autoplay-success',
	        autoplay: type
	      });
	    })["catch"](function () {
	      _this6.trigger({
	        type: 'autoplay-failure',
	        autoplay: type
	      });
	    });
	  }
	  /**
	   * Update the internal source caches so that we return the correct source from
	   * `src()`, `currentSource()`, and `currentSources()`.
	   *
	   * > Note: `currentSources` will not be updated if the source that is passed in exists
	   *         in the current `currentSources` cache.
	   *
	   *
	   * @param {Tech~SourceObject} srcObj
	   *        A string or object source to update our caches to.
	   */
	  ;
	
	  _proto.updateSourceCaches_ = function updateSourceCaches_(srcObj) {
	    if (srcObj === void 0) {
	      srcObj = '';
	    }
	
	    var src = srcObj;
	    var type = '';
	
	    if (typeof src !== 'string') {
	      src = srcObj.src;
	      type = srcObj.type;
	    } // make sure all the caches are set to default values
	    // to prevent null checking
	
	
	    this.cache_.source = this.cache_.source || {};
	    this.cache_.sources = this.cache_.sources || []; // try to get the type of the src that was passed in
	
	    if (src && !type) {
	      type = findMimetype(this, src);
	    } // update `currentSource` cache always
	
	
	    this.cache_.source = mergeOptions$3({}, srcObj, {
	      src: src,
	      type: type
	    });
	    var matchingSources = this.cache_.sources.filter(function (s) {
	      return s.src && s.src === src;
	    });
	    var sourceElSources = [];
	    var sourceEls = this.$$('source');
	    var matchingSourceEls = [];
	
	    for (var i = 0; i < sourceEls.length; i++) {
	      var sourceObj = getAttributes(sourceEls[i]);
	      sourceElSources.push(sourceObj);
	
	      if (sourceObj.src && sourceObj.src === src) {
	        matchingSourceEls.push(sourceObj.src);
	      }
	    } // if we have matching source els but not matching sources
	    // the current source cache is not up to date
	
	
	    if (matchingSourceEls.length && !matchingSources.length) {
	      this.cache_.sources = sourceElSources; // if we don't have matching source or source els set the
	      // sources cache to the `currentSource` cache
	    } else if (!matchingSources.length) {
	      this.cache_.sources = [this.cache_.source];
	    } // update the tech `src` cache
	
	
	    this.cache_.src = src;
	  }
	  /**
	   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
	   * causing the media element to reload.
	   *
	   * It will fire for the initial source and each subsequent source.
	   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
	   *
	   * The event object for this event contains a `src` property that will contain the source
	   * that was available when the event was triggered. This is generally only necessary if Video.js
	   * is switching techs while the source was being changed.
	   *
	   * It is also fired when `load` is called on the player (or media element)
	   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
	   * says that the resource selection algorithm needs to be aborted and restarted.
	   * In this case, it is very likely that the `src` property will be set to the
	   * empty string `""` to indicate we do not know what the source will be but
	   * that it is changing.
	   *
	   * *This event is currently still experimental and may change in minor releases.*
	   * __To use this, pass `enableSourceset` option to the player.__
	   *
	   * @event Player#sourceset
	   * @type {EventTarget~Event}
	   * @prop {string} src
	   *                The source url available when the `sourceset` was triggered.
	   *                It will be an empty string if we cannot know what the source is
	   *                but know that the source will change.
	   */
	
	  /**
	   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#sourceset
	   * @listens Tech#sourceset
	   * @private
	   */
	  ;
	
	  _proto.handleTechSourceset_ = function handleTechSourceset_(event) {
	    var _this7 = this;
	
	    // only update the source cache when the source
	    // was not updated using the player api
	    if (!this.changingSrc_) {
	      var updateSourceCaches = function updateSourceCaches(src) {
	        return _this7.updateSourceCaches_(src);
	      };
	
	      var playerSrc = this.currentSource().src;
	      var eventSrc = event.src; // if we have a playerSrc that is not a blob, and a tech src that is a blob
	
	      if (playerSrc && !/^blob:/.test(playerSrc) && /^blob:/.test(eventSrc)) {
	        // if both the tech source and the player source were updated we assume
	        // something like @videojs/http-streaming did the sourceset and skip updating the source cache.
	        if (!this.lastSource_ || this.lastSource_.tech !== eventSrc && this.lastSource_.player !== playerSrc) {
	          updateSourceCaches = function updateSourceCaches() {};
	        }
	      } // update the source to the initial source right away
	      // in some cases this will be empty string
	
	
	      updateSourceCaches(eventSrc); // if the `sourceset` `src` was an empty string
	      // wait for a `loadstart` to update the cache to `currentSrc`.
	      // If a sourceset happens before a `loadstart`, we reset the state
	
	      if (!event.src) {
	        this.tech_.any(['sourceset', 'loadstart'], function (e) {
	          // if a sourceset happens before a `loadstart` there
	          // is nothing to do as this `handleTechSourceset_`
	          // will be called again and this will be handled there.
	          if (e.type === 'sourceset') {
	            return;
	          }
	
	          var techSrc = _this7.techGet('currentSrc');
	
	          _this7.lastSource_.tech = techSrc;
	
	          _this7.updateSourceCaches_(techSrc);
	        });
	      }
	    }
	
	    this.lastSource_ = {
	      player: this.currentSource().src,
	      tech: event.src
	    };
	    this.trigger({
	      src: event.src,
	      type: 'sourceset'
	    });
	  }
	  /**
	   * Add/remove the vjs-has-started class
	   *
	   * @fires Player#firstplay
	   *
	   * @param {boolean} request
	   *        - true: adds the class
	   *        - false: remove the class
	   *
	   * @return {boolean}
	   *         the boolean value of hasStarted_
	   */
	  ;
	
	  _proto.hasStarted = function hasStarted(request) {
	    if (request === undefined) {
	      // act as getter, if we have no request to change
	      return this.hasStarted_;
	    }
	
	    if (request === this.hasStarted_) {
	      return;
	    }
	
	    this.hasStarted_ = request;
	
	    if (this.hasStarted_) {
	      this.addClass('vjs-has-started');
	      this.trigger('firstplay');
	    } else {
	      this.removeClass('vjs-has-started');
	    }
	  }
	  /**
	   * Fired whenever the media begins or resumes playback
	   *
	   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
	   * @fires Player#play
	   * @listens Tech#play
	   * @private
	   */
	  ;
	
	  _proto.handleTechPlay_ = function handleTechPlay_() {
	    this.removeClass('vjs-ended');
	    this.removeClass('vjs-paused');
	    this.addClass('vjs-playing'); // hide the poster when the user hits play
	
	    this.hasStarted(true);
	    /**
	     * Triggered whenever an {@link Tech#play} event happens. Indicates that
	     * playback has started or resumed.
	     *
	     * @event Player#play
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('play');
	  }
	  /**
	   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
	   *
	   * If there were any events queued while the playback rate was zero, fire
	   * those events now.
	   *
	   * @private
	   * @method Player#handleTechRateChange_
	   * @fires Player#ratechange
	   * @listens Tech#ratechange
	   */
	  ;
	
	  _proto.handleTechRateChange_ = function handleTechRateChange_() {
	    if (this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0) {
	      this.queuedCallbacks_.forEach(function (queued) {
	        return queued.callback(queued.event);
	      });
	      this.queuedCallbacks_ = [];
	    }
	
	    this.cache_.lastPlaybackRate = this.tech_.playbackRate();
	    /**
	     * Fires when the playing speed of the audio/video is changed
	     *
	     * @event Player#ratechange
	     * @type {event}
	     */
	
	    this.trigger('ratechange');
	  }
	  /**
	   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#waiting
	   * @listens Tech#waiting
	   * @private
	   */
	  ;
	
	  _proto.handleTechWaiting_ = function handleTechWaiting_() {
	    var _this8 = this;
	
	    this.addClass('vjs-waiting');
	    /**
	     * A readyState change on the DOM element has caused playback to stop.
	     *
	     * @event Player#waiting
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('waiting'); // Browsers may emit a timeupdate event after a waiting event. In order to prevent
	    // premature removal of the waiting class, wait for the time to change.
	
	    var timeWhenWaiting = this.currentTime();
	
	    var timeUpdateListener = function timeUpdateListener() {
	      if (timeWhenWaiting !== _this8.currentTime()) {
	        _this8.removeClass('vjs-waiting');
	
	        _this8.off('timeupdate', timeUpdateListener);
	      }
	    };
	
	    this.on('timeupdate', timeUpdateListener);
	  }
	  /**
	   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
	   * > Note: This is not consistent between browsers. See #1351
	   *
	   * @fires Player#canplay
	   * @listens Tech#canplay
	   * @private
	   */
	  ;
	
	  _proto.handleTechCanPlay_ = function handleTechCanPlay_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media has a readyState of HAVE_FUTURE_DATA or greater.
	     *
	     * @event Player#canplay
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('canplay');
	  }
	  /**
	   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#canplaythrough
	   * @listens Tech#canplaythrough
	   * @private
	   */
	  ;
	
	  _proto.handleTechCanPlayThrough_ = function handleTechCanPlayThrough_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media has a readyState of HAVE_ENOUGH_DATA or greater. This means that the
	     * entire media file can be played without buffering.
	     *
	     * @event Player#canplaythrough
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('canplaythrough');
	  }
	  /**
	   * Retrigger the `playing` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#playing
	   * @listens Tech#playing
	   * @private
	   */
	  ;
	
	  _proto.handleTechPlaying_ = function handleTechPlaying_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media is no longer blocked from playback, and has started playing.
	     *
	     * @event Player#playing
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('playing');
	  }
	  /**
	   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#seeking
	   * @listens Tech#seeking
	   * @private
	   */
	  ;
	
	  _proto.handleTechSeeking_ = function handleTechSeeking_() {
	    this.addClass('vjs-seeking');
	    /**
	     * Fired whenever the player is jumping to a new time
	     *
	     * @event Player#seeking
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('seeking');
	  }
	  /**
	   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#seeked
	   * @listens Tech#seeked
	   * @private
	   */
	  ;
	
	  _proto.handleTechSeeked_ = function handleTechSeeked_() {
	    this.removeClass('vjs-seeking');
	    this.removeClass('vjs-ended');
	    /**
	     * Fired when the player has finished jumping to a new time
	     *
	     * @event Player#seeked
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('seeked');
	  }
	  /**
	   * Retrigger the `firstplay` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#firstplay
	   * @listens Tech#firstplay
	   * @deprecated As of 6.0 firstplay event is deprecated.
	   *             As of 6.0 passing the `starttime` option to the player and the firstplay event are deprecated.
	   * @private
	   */
	  ;
	
	  _proto.handleTechFirstPlay_ = function handleTechFirstPlay_() {
	    // If the first starttime attribute is specified
	    // then we will start at the given offset in seconds
	    if (this.options_.starttime) {
	      log$1.warn('Passing the `starttime` option to the player will be deprecated in 6.0');
	      this.currentTime(this.options_.starttime);
	    }
	
	    this.addClass('vjs-has-started');
	    /**
	     * Fired the first time a video is played. Not part of the HLS spec, and this is
	     * probably not the best implementation yet, so use sparingly. If you don't have a
	     * reason to prevent playback, use `myPlayer.one('play');` instead.
	     *
	     * @event Player#firstplay
	     * @deprecated As of 6.0 firstplay event is deprecated.
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('firstplay');
	  }
	  /**
	   * Retrigger the `pause` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#pause
	   * @listens Tech#pause
	   * @private
	   */
	  ;
	
	  _proto.handleTechPause_ = function handleTechPause_() {
	    this.removeClass('vjs-playing');
	    this.addClass('vjs-paused');
	    /**
	     * Fired whenever the media has been paused
	     *
	     * @event Player#pause
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('pause');
	  }
	  /**
	   * Retrigger the `ended` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#ended
	   * @listens Tech#ended
	   * @private
	   */
	  ;
	
	  _proto.handleTechEnded_ = function handleTechEnded_() {
	    this.addClass('vjs-ended');
	    this.removeClass('vjs-waiting');
	
	    if (this.options_.loop) {
	      this.currentTime(0);
	      this.play();
	    } else if (!this.paused()) {
	      this.pause();
	    }
	    /**
	     * Fired when the end of the media resource is reached (currentTime == duration)
	     *
	     * @event Player#ended
	     * @type {EventTarget~Event}
	     */
	
	
	    this.trigger('ended');
	  }
	  /**
	   * Fired when the duration of the media resource is first known or changed
	   *
	   * @listens Tech#durationchange
	   * @private
	   */
	  ;
	
	  _proto.handleTechDurationChange_ = function handleTechDurationChange_() {
	    this.duration(this.techGet_('duration'));
	  }
	  /**
	   * Handle a click on the media element to play/pause
	   *
	   * @param {EventTarget~Event} event
	   *        the event that caused this function to trigger
	   *
	   * @listens Tech#click
	   * @private
	   */
	  ;
	
	  _proto.handleTechClick_ = function handleTechClick_(event) {
	    // When controls are disabled a click should not toggle playback because
	    // the click is considered a control
	    if (!this.controls_) {
	      return;
	    }
	
	    if (this.options_ === undefined || this.options_.userActions === undefined || this.options_.userActions.click === undefined || this.options_.userActions.click !== false) {
	      if (this.options_ !== undefined && this.options_.userActions !== undefined && typeof this.options_.userActions.click === 'function') {
	        this.options_.userActions.click.call(this, event);
	      } else if (this.paused()) {
	        silencePromise(this.play());
	      } else {
	        this.pause();
	      }
	    }
	  }
	  /**
	   * Handle a double-click on the media element to enter/exit fullscreen
	   *
	   * @param {EventTarget~Event} event
	   *        the event that caused this function to trigger
	   *
	   * @listens Tech#dblclick
	   * @private
	   */
	  ;
	
	  _proto.handleTechDoubleClick_ = function handleTechDoubleClick_(event) {
	    if (!this.controls_) {
	      return;
	    } // we do not want to toggle fullscreen state
	    // when double-clicking inside a control bar or a modal
	
	
	    var inAllowedEls = Array.prototype.some.call(this.$$('.vjs-control-bar, .vjs-modal-dialog'), function (el) {
	      return el.contains(event.target);
	    });
	
	    if (!inAllowedEls) {
	      /*
	       * options.userActions.doubleClick
	       *
	       * If `undefined` or `true`, double-click toggles fullscreen if controls are present
	       * Set to `false` to disable double-click handling
	       * Set to a function to substitute an external double-click handler
	       */
	      if (this.options_ === undefined || this.options_.userActions === undefined || this.options_.userActions.doubleClick === undefined || this.options_.userActions.doubleClick !== false) {
	        if (this.options_ !== undefined && this.options_.userActions !== undefined && typeof this.options_.userActions.doubleClick === 'function') {
	          this.options_.userActions.doubleClick.call(this, event);
	        } else if (this.isFullscreen()) {
	          this.exitFullscreen();
	        } else {
	          this.requestFullscreen();
	        }
	      }
	    }
	  }
	  /**
	   * Handle a tap on the media element. It will toggle the user
	   * activity state, which hides and shows the controls.
	   *
	   * @listens Tech#tap
	   * @private
	   */
	  ;
	
	  _proto.handleTechTap_ = function handleTechTap_() {
	    this.userActive(!this.userActive());
	  }
	  /**
	   * Handle touch to start
	   *
	   * @listens Tech#touchstart
	   * @private
	   */
	  ;
	
	  _proto.handleTechTouchStart_ = function handleTechTouchStart_() {
	    this.userWasActive = this.userActive();
	  }
	  /**
	   * Handle touch to move
	   *
	   * @listens Tech#touchmove
	   * @private
	   */
	  ;
	
	  _proto.handleTechTouchMove_ = function handleTechTouchMove_() {
	    if (this.userWasActive) {
	      this.reportUserActivity();
	    }
	  }
	  /**
	   * Handle touch to end
	   *
	   * @param {EventTarget~Event} event
	   *        the touchend event that triggered
	   *        this function
	   *
	   * @listens Tech#touchend
	   * @private
	   */
	  ;
	
	  _proto.handleTechTouchEnd_ = function handleTechTouchEnd_(event) {
	    // Stop the mouse events from also happening
	    if (event.cancelable) {
	      event.preventDefault();
	    }
	  }
	  /**
	   * native click events on the SWF aren't triggered on IE11, Win8.1RT
	   * use stageclick events triggered from inside the SWF instead
	   *
	   * @private
	   * @listens stageclick
	   */
	  ;
	
	  _proto.handleStageClick_ = function handleStageClick_() {
	    this.reportUserActivity();
	  }
	  /**
	   * @private
	   */
	  ;
	
	  _proto.toggleFullscreenClass_ = function toggleFullscreenClass_() {
	    if (this.isFullscreen()) {
	      this.addClass('vjs-fullscreen');
	    } else {
	      this.removeClass('vjs-fullscreen');
	    }
	  }
	  /**
	   * when the document fschange event triggers it calls this
	   */
	  ;
	
	  _proto.documentFullscreenChange_ = function documentFullscreenChange_(e) {
	    var targetPlayer = e.target.player; // if another player was fullscreen
	    // do a null check for targetPlayer because older firefox's would put document as e.target
	
	    if (targetPlayer && targetPlayer !== this) {
	      return;
	    }
	
	    var el = this.el();
	    var isFs = document__default['default'][this.fsApi_.fullscreenElement] === el;
	
	    if (!isFs && el.matches) {
	      isFs = el.matches(':' + this.fsApi_.fullscreen);
	    } else if (!isFs && el.msMatchesSelector) {
	      isFs = el.msMatchesSelector(':' + this.fsApi_.fullscreen);
	    }
	
	    this.isFullscreen(isFs);
	  }
	  /**
	   * Handle Tech Fullscreen Change
	   *
	   * @param {EventTarget~Event} event
	   *        the fullscreenchange event that triggered this function
	   *
	   * @param {Object} data
	   *        the data that was sent with the event
	   *
	   * @private
	   * @listens Tech#fullscreenchange
	   * @fires Player#fullscreenchange
	   */
	  ;
	
	  _proto.handleTechFullscreenChange_ = function handleTechFullscreenChange_(event, data) {
	    var _this9 = this;
	
	    if (data) {
	      if (data.nativeIOSFullscreen) {
	        this.addClass('vjs-ios-native-fs');
	        this.tech_.one('webkitendfullscreen', function () {
	          _this9.removeClass('vjs-ios-native-fs');
	        });
	      }
	
	      this.isFullscreen(data.isFullscreen);
	    }
	  };
	
	  _proto.handleTechFullscreenError_ = function handleTechFullscreenError_(event, err) {
	    this.trigger('fullscreenerror', err);
	  }
	  /**
	   * @private
	   */
	  ;
	
	  _proto.togglePictureInPictureClass_ = function togglePictureInPictureClass_() {
	    if (this.isInPictureInPicture()) {
	      this.addClass('vjs-picture-in-picture');
	    } else {
	      this.removeClass('vjs-picture-in-picture');
	    }
	  }
	  /**
	   * Handle Tech Enter Picture-in-Picture.
	   *
	   * @param {EventTarget~Event} event
	   *        the enterpictureinpicture event that triggered this function
	   *
	   * @private
	   * @listens Tech#enterpictureinpicture
	   */
	  ;
	
	  _proto.handleTechEnterPictureInPicture_ = function handleTechEnterPictureInPicture_(event) {
	    this.isInPictureInPicture(true);
	  }
	  /**
	   * Handle Tech Leave Picture-in-Picture.
	   *
	   * @param {EventTarget~Event} event
	   *        the leavepictureinpicture event that triggered this function
	   *
	   * @private
	   * @listens Tech#leavepictureinpicture
	   */
	  ;
	
	  _proto.handleTechLeavePictureInPicture_ = function handleTechLeavePictureInPicture_(event) {
	    this.isInPictureInPicture(false);
	  }
	  /**
	   * Fires when an error occurred during the loading of an audio/video.
	   *
	   * @private
	   * @listens Tech#error
	   */
	  ;
	
	  _proto.handleTechError_ = function handleTechError_() {
	    var error = this.tech_.error();
	    this.error(error);
	  }
	  /**
	   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#textdata
	   * @listens Tech#textdata
	   * @private
	   */
	  ;
	
	  _proto.handleTechTextData_ = function handleTechTextData_() {
	    var data = null;
	
	    if (arguments.length > 1) {
	      data = arguments[1];
	    }
	    /**
	     * Fires when we get a textdata event from tech
	     *
	     * @event Player#textdata
	     * @type {EventTarget~Event}
	     */
	
	
	    this.trigger('textdata', data);
	  }
	  /**
	   * Get object for cached values.
	   *
	   * @return {Object}
	   *         get the current object cache
	   */
	  ;
	
	  _proto.getCache = function getCache() {
	    return this.cache_;
	  }
	  /**
	   * Resets the internal cache object.
	   *
	   * Using this function outside the player constructor or reset method may
	   * have unintended side-effects.
	   *
	   * @private
	   */
	  ;
	
	  _proto.resetCache_ = function resetCache_() {
	    this.cache_ = {
	      // Right now, the currentTime is not _really_ cached because it is always
	      // retrieved from the tech (see: currentTime). However, for completeness,
	      // we set it to zero here to ensure that if we do start actually caching
	      // it, we reset it along with everything else.
	      currentTime: 0,
	      initTime: 0,
	      inactivityTimeout: this.options_.inactivityTimeout,
	      duration: NaN,
	      lastVolume: 1,
	      lastPlaybackRate: this.defaultPlaybackRate(),
	      media: null,
	      src: '',
	      source: {},
	      sources: [],
	      playbackRates: [],
	      volume: 1
	    };
	  }
	  /**
	   * Pass values to the playback tech
	   *
	   * @param {string} [method]
	   *        the method to call
	   *
	   * @param {Object} arg
	   *        the argument to pass
	   *
	   * @private
	   */
	  ;
	
	  _proto.techCall_ = function techCall_(method, arg) {
	    // If it's not ready yet, call method when it is
	    this.ready(function () {
	      if (method in allowedSetters) {
	        return set(this.middleware_, this.tech_, method, arg);
	      } else if (method in allowedMediators) {
	        return mediate(this.middleware_, this.tech_, method, arg);
	      }
	
	      try {
	        if (this.tech_) {
	          this.tech_[method](arg);
	        }
	      } catch (e) {
	        log$1(e);
	        throw e;
	      }
	    }, true);
	  }
	  /**
	   * Get calls can't wait for the tech, and sometimes don't need to.
	   *
	   * @param {string} method
	   *        Tech method
	   *
	   * @return {Function|undefined}
	   *         the method or undefined
	   *
	   * @private
	   */
	  ;
	
	  _proto.techGet_ = function techGet_(method) {
	    if (!this.tech_ || !this.tech_.isReady_) {
	      return;
	    }
	
	    if (method in allowedGetters) {
	      return get(this.middleware_, this.tech_, method);
	    } else if (method in allowedMediators) {
	      return mediate(this.middleware_, this.tech_, method);
	    } // Flash likes to die and reload when you hide or reposition it.
	    // In these cases the object methods go away and we get errors.
	    // TODO: Is this needed for techs other than Flash?
	    // When that happens we'll catch the errors and inform tech that it's not ready any more.
	
	
	    try {
	      return this.tech_[method]();
	    } catch (e) {
	      // When building additional tech libs, an expected method may not be defined yet
	      if (this.tech_[method] === undefined) {
	        log$1("Video.js: " + method + " method not defined for " + this.techName_ + " playback technology.", e);
	        throw e;
	      } // When a method isn't available on the object it throws a TypeError
	
	
	      if (e.name === 'TypeError') {
	        log$1("Video.js: " + method + " unavailable on " + this.techName_ + " playback technology element.", e);
	        this.tech_.isReady_ = false;
	        throw e;
	      } // If error unknown, just log and throw
	
	
	      log$1(e);
	      throw e;
	    }
	  }
	  /**
	   * Attempt to begin playback at the first opportunity.
	   *
	   * @return {Promise|undefined}
	   *         Returns a promise if the browser supports Promises (or one
	   *         was passed in as an option). This promise will be resolved on
	   *         the return value of play. If this is undefined it will fulfill the
	   *         promise chain otherwise the promise chain will be fulfilled when
	   *         the promise from play is fulfilled.
	   */
	  ;
	
	  _proto.play = function play() {
	    var _this10 = this;
	
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      return new PromiseClass(function (resolve) {
	        _this10.play_(resolve);
	      });
	    }
	
	    return this.play_();
	  }
	  /**
	   * The actual logic for play, takes a callback that will be resolved on the
	   * return value of play. This allows us to resolve to the play promise if there
	   * is one on modern browsers.
	   *
	   * @private
	   * @param {Function} [callback]
	   *        The callback that should be called when the techs play is actually called
	   */
	  ;
	
	  _proto.play_ = function play_(callback) {
	    var _this11 = this;
	
	    if (callback === void 0) {
	      callback = silencePromise;
	    }
	
	    this.playCallbacks_.push(callback);
	    var isSrcReady = Boolean(!this.changingSrc_ && (this.src() || this.currentSrc()));
	    var isSafariOrIOS = Boolean(IS_ANY_SAFARI || IS_IOS); // treat calls to play_ somewhat like the `one` event function
	
	    if (this.waitToPlay_) {
	      this.off(['ready', 'loadstart'], this.waitToPlay_);
	      this.waitToPlay_ = null;
	    } // if the player/tech is not ready or the src itself is not ready
	    // queue up a call to play on `ready` or `loadstart`
	
	
	    if (!this.isReady_ || !isSrcReady) {
	      this.waitToPlay_ = function (e) {
	        _this11.play_();
	      };
	
	      this.one(['ready', 'loadstart'], this.waitToPlay_); // if we are in Safari, there is a high chance that loadstart will trigger after the gesture timeperiod
	      // in that case, we need to prime the video element by calling load so it'll be ready in time
	
	      if (!isSrcReady && isSafariOrIOS) {
	        this.load();
	      }
	
	      return;
	    } // If the player/tech is ready and we have a source, we can attempt playback.
	
	
	    var val = this.techGet_('play'); // For native playback, reset the progress bar if we get a play call from a replay.
	
	    var isNativeReplay = isSafariOrIOS && this.hasClass('vjs-ended');
	
	    if (isNativeReplay) {
	      this.resetProgressBar_();
	    } // play was terminated if the returned value is null
	
	
	    if (val === null) {
	      this.runPlayTerminatedQueue_();
	    } else {
	      this.runPlayCallbacks_(val);
	    }
	  }
	  /**
	   * These functions will be run when if play is terminated. If play
	   * runPlayCallbacks_ is run these function will not be run. This allows us
	   * to differenciate between a terminated play and an actual call to play.
	   */
	  ;
	
	  _proto.runPlayTerminatedQueue_ = function runPlayTerminatedQueue_() {
	    var queue = this.playTerminatedQueue_.slice(0);
	    this.playTerminatedQueue_ = [];
	    queue.forEach(function (q) {
	      q();
	    });
	  }
	  /**
	   * When a callback to play is delayed we have to run these
	   * callbacks when play is actually called on the tech. This function
	   * runs the callbacks that were delayed and accepts the return value
	   * from the tech.
	   *
	   * @param {undefined|Promise} val
	   *        The return value from the tech.
	   */
	  ;
	
	  _proto.runPlayCallbacks_ = function runPlayCallbacks_(val) {
	    var callbacks = this.playCallbacks_.slice(0);
	    this.playCallbacks_ = []; // clear play terminatedQueue since we finished a real play
	
	    this.playTerminatedQueue_ = [];
	    callbacks.forEach(function (cb) {
	      cb(val);
	    });
	  }
	  /**
	   * Pause the video playback
	   *
	   * @return {Player}
	   *         A reference to the player object this function was called on
	   */
	  ;
	
	  _proto.pause = function pause() {
	    this.techCall_('pause');
	  }
	  /**
	   * Check if the player is paused or has yet to play
	   *
	   * @return {boolean}
	   *         - false: if the media is currently playing
	   *         - true: if media is not currently playing
	   */
	  ;
	
	  _proto.paused = function paused() {
	    // The initial state of paused should be true (in Safari it's actually false)
	    return this.techGet_('paused') === false ? false : true;
	  }
	  /**
	   * Get a TimeRange object representing the current ranges of time that the user
	   * has played.
	   *
	   * @return {TimeRange}
	   *         A time range object that represents all the increments of time that have
	   *         been played.
	   */
	  ;
	
	  _proto.played = function played() {
	    return this.techGet_('played') || createTimeRanges(0, 0);
	  }
	  /**
	   * Returns whether or not the user is "scrubbing". Scrubbing is
	   * when the user has clicked the progress bar handle and is
	   * dragging it along the progress bar.
	   *
	   * @param {boolean} [isScrubbing]
	   *        whether the user is or is not scrubbing
	   *
	   * @return {boolean}
	   *         The value of scrubbing when getting
	   */
	  ;
	
	  _proto.scrubbing = function scrubbing(isScrubbing) {
	    if (typeof isScrubbing === 'undefined') {
	      return this.scrubbing_;
	    }
	
	    this.scrubbing_ = !!isScrubbing;
	    this.techCall_('setScrubbing', this.scrubbing_);
	
	    if (isScrubbing) {
	      this.addClass('vjs-scrubbing');
	    } else {
	      this.removeClass('vjs-scrubbing');
	    }
	  }
	  /**
	   * Get or set the current time (in seconds)
	   *
	   * @param {number|string} [seconds]
	   *        The time to seek to in seconds
	   *
	   * @return {number}
	   *         - the current time in seconds when getting
	   */
	  ;
	
	  _proto.currentTime = function currentTime(seconds) {
	    if (typeof seconds !== 'undefined') {
	      if (seconds < 0) {
	        seconds = 0;
	      }
	
	      if (!this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
	        this.cache_.initTime = seconds;
	        this.off('canplay', this.boundApplyInitTime_);
	        this.one('canplay', this.boundApplyInitTime_);
	        return;
	      }
	
	      this.techCall_('setCurrentTime', seconds);
	      this.cache_.initTime = 0;
	      return;
	    } // cache last currentTime and return. default to 0 seconds
	    //
	    // Caching the currentTime is meant to prevent a massive amount of reads on the tech's
	    // currentTime when scrubbing, but may not provide much performance benefit afterall.
	    // Should be tested. Also something has to read the actual current time or the cache will
	    // never get updated.
	
	
	    this.cache_.currentTime = this.techGet_('currentTime') || 0;
	    return this.cache_.currentTime;
	  }
	  /**
	   * Apply the value of initTime stored in cache as currentTime.
	   *
	   * @private
	   */
	  ;
	
	  _proto.applyInitTime_ = function applyInitTime_() {
	    this.currentTime(this.cache_.initTime);
	  }
	  /**
	   * Normally gets the length in time of the video in seconds;
	   * in all but the rarest use cases an argument will NOT be passed to the method
	   *
	   * > **NOTE**: The video must have started loading before the duration can be
	   * known, and depending on preload behaviour may not be known until the video starts
	   * playing.
	   *
	   * @fires Player#durationchange
	   *
	   * @param {number} [seconds]
	   *        The duration of the video to set in seconds
	   *
	   * @return {number}
	   *         - The duration of the video in seconds when getting
	   */
	  ;
	
	  _proto.duration = function duration(seconds) {
	    if (seconds === undefined) {
	      // return NaN if the duration is not known
	      return this.cache_.duration !== undefined ? this.cache_.duration : NaN;
	    }
	
	    seconds = parseFloat(seconds); // Standardize on Infinity for signaling video is live
	
	    if (seconds < 0) {
	      seconds = Infinity;
	    }
	
	    if (seconds !== this.cache_.duration) {
	      // Cache the last set value for optimized scrubbing (esp. Flash)
	      // TODO: Required for techs other than Flash?
	      this.cache_.duration = seconds;
	
	      if (seconds === Infinity) {
	        this.addClass('vjs-live');
	      } else {
	        this.removeClass('vjs-live');
	      }
	
	      if (!isNaN(seconds)) {
	        // Do not fire durationchange unless the duration value is known.
	        // @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
	
	        /**
	         * @event Player#durationchange
	         * @type {EventTarget~Event}
	         */
	        this.trigger('durationchange');
	      }
	    }
	  }
	  /**
	   * Calculates how much time is left in the video. Not part
	   * of the native video API.
	   *
	   * @return {number}
	   *         The time remaining in seconds
	   */
	  ;
	
	  _proto.remainingTime = function remainingTime() {
	    return this.duration() - this.currentTime();
	  }
	  /**
	   * A remaining time function that is intented to be used when
	   * the time is to be displayed directly to the user.
	   *
	   * @return {number}
	   *         The rounded time remaining in seconds
	   */
	  ;
	
	  _proto.remainingTimeDisplay = function remainingTimeDisplay() {
	    return Math.floor(this.duration()) - Math.floor(this.currentTime());
	  } //
	  // Kind of like an array of portions of the video that have been downloaded.
	
	  /**
	   * Get a TimeRange object with an array of the times of the video
	   * that have been downloaded. If you just want the percent of the
	   * video that's been downloaded, use bufferedPercent.
	   *
	   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
	   *
	   * @return {TimeRange}
	   *         A mock TimeRange object (following HTML spec)
	   */
	  ;
	
	  _proto.buffered = function buffered() {
	    var buffered = this.techGet_('buffered');
	
	    if (!buffered || !buffered.length) {
	      buffered = createTimeRanges(0, 0);
	    }
	
	    return buffered;
	  }
	  /**
	   * Get the percent (as a decimal) of the video that's been downloaded.
	   * This method is not a part of the native HTML video API.
	   *
	   * @return {number}
	   *         A decimal between 0 and 1 representing the percent
	   *         that is buffered 0 being 0% and 1 being 100%
	   */
	  ;
	
	  _proto.bufferedPercent = function bufferedPercent$1() {
	    return bufferedPercent(this.buffered(), this.duration());
	  }
	  /**
	   * Get the ending time of the last buffered time range
	   * This is used in the progress bar to encapsulate all time ranges.
	   *
	   * @return {number}
	   *         The end of the last buffered time range
	   */
	  ;
	
	  _proto.bufferedEnd = function bufferedEnd() {
	    var buffered = this.buffered();
	    var duration = this.duration();
	    var end = buffered.end(buffered.length - 1);
	
	    if (end > duration) {
	      end = duration;
	    }
	
	    return end;
	  }
	  /**
	   * Get or set the current volume of the media
	   *
	   * @param  {number} [percentAsDecimal]
	   *         The new volume as a decimal percent:
	   *         - 0 is muted/0%/off
	   *         - 1.0 is 100%/full
	   *         - 0.5 is half volume or 50%
	   *
	   * @return {number}
	   *         The current volume as a percent when getting
	   */
	  ;
	
	  _proto.volume = function volume(percentAsDecimal) {
	    var vol;
	
	    if (percentAsDecimal !== undefined) {
	      // Force value to between 0 and 1
	      vol = Math.max(0, Math.min(1, parseFloat(percentAsDecimal)));
	      this.cache_.volume = vol;
	      this.techCall_('setVolume', vol);
	
	      if (vol > 0) {
	        this.lastVolume_(vol);
	      }
	
	      return;
	    } // Default to 1 when returning current volume.
	
	
	    vol = parseFloat(this.techGet_('volume'));
	    return isNaN(vol) ? 1 : vol;
	  }
	  /**
	   * Get the current muted state, or turn mute on or off
	   *
	   * @param {boolean} [muted]
	   *        - true to mute
	   *        - false to unmute
	   *
	   * @return {boolean}
	   *         - true if mute is on and getting
	   *         - false if mute is off and getting
	   */
	  ;
	
	  _proto.muted = function muted(_muted) {
	    if (_muted !== undefined) {
	      this.techCall_('setMuted', _muted);
	      return;
	    }
	
	    return this.techGet_('muted') || false;
	  }
	  /**
	   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
	   * indicates the state of muted on initial playback.
	   *
	   * ```js
	   *   var myPlayer = videojs('some-player-id');
	   *
	   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
	   *
	   *   // get, should be false
	   *   console.log(myPlayer.defaultMuted());
	   *   // set to true
	   *   myPlayer.defaultMuted(true);
	   *   // get should be true
	   *   console.log(myPlayer.defaultMuted());
	   * ```
	   *
	   * @param {boolean} [defaultMuted]
	   *        - true to mute
	   *        - false to unmute
	   *
	   * @return {boolean|Player}
	   *         - true if defaultMuted is on and getting
	   *         - false if defaultMuted is off and getting
	   *         - A reference to the current player when setting
	   */
	  ;
	
	  _proto.defaultMuted = function defaultMuted(_defaultMuted) {
	    if (_defaultMuted !== undefined) {
	      return this.techCall_('setDefaultMuted', _defaultMuted);
	    }
	
	    return this.techGet_('defaultMuted') || false;
	  }
	  /**
	   * Get the last volume, or set it
	   *
	   * @param  {number} [percentAsDecimal]
	   *         The new last volume as a decimal percent:
	   *         - 0 is muted/0%/off
	   *         - 1.0 is 100%/full
	   *         - 0.5 is half volume or 50%
	   *
	   * @return {number}
	   *         the current value of lastVolume as a percent when getting
	   *
	   * @private
	   */
	  ;
	
	  _proto.lastVolume_ = function lastVolume_(percentAsDecimal) {
	    if (percentAsDecimal !== undefined && percentAsDecimal !== 0) {
	      this.cache_.lastVolume = percentAsDecimal;
	      return;
	    }
	
	    return this.cache_.lastVolume;
	  }
	  /**
	   * Check if current tech can support native fullscreen
	   * (e.g. with built in controls like iOS)
	   *
	   * @return {boolean}
	   *         if native fullscreen is supported
	   */
	  ;
	
	  _proto.supportsFullScreen = function supportsFullScreen() {
	    return this.techGet_('supportsFullScreen') || false;
	  }
	  /**
	   * Check if the player is in fullscreen mode or tell the player that it
	   * is or is not in fullscreen mode.
	   *
	   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
	   * property and instead document.fullscreenElement is used. But isFullscreen is
	   * still a valuable property for internal player workings.
	   *
	   * @param  {boolean} [isFS]
	   *         Set the players current fullscreen state
	   *
	   * @return {boolean}
	   *         - true if fullscreen is on and getting
	   *         - false if fullscreen is off and getting
	   */
	  ;
	
	  _proto.isFullscreen = function isFullscreen(isFS) {
	    if (isFS !== undefined) {
	      var oldValue = this.isFullscreen_;
	      this.isFullscreen_ = Boolean(isFS); // if we changed fullscreen state and we're in prefixed mode, trigger fullscreenchange
	      // this is the only place where we trigger fullscreenchange events for older browsers
	      // fullWindow mode is treated as a prefixed event and will get a fullscreenchange event as well
	
	      if (this.isFullscreen_ !== oldValue && this.fsApi_.prefixed) {
	        /**
	           * @event Player#fullscreenchange
	           * @type {EventTarget~Event}
	           */
	        this.trigger('fullscreenchange');
	      }
	
	      this.toggleFullscreenClass_();
	      return;
	    }
	
	    return this.isFullscreen_;
	  }
	  /**
	   * Increase the size of the video to full screen
	   * In some browsers, full screen is not supported natively, so it enters
	   * "full window mode", where the video fills the browser window.
	   * In browsers and devices that support native full screen, sometimes the
	   * browser's default controls will be shown, and not the Video.js custom skin.
	   * This includes most mobile devices (iOS, Android) and older versions of
	   * Safari.
	   *
	   * @param  {Object} [fullscreenOptions]
	   *         Override the player fullscreen options
	   *
	   * @fires Player#fullscreenchange
	   */
	  ;
	
	  _proto.requestFullscreen = function requestFullscreen(fullscreenOptions) {
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      var self = this;
	      return new PromiseClass(function (resolve, reject) {
	        function offHandler() {
	          self.off('fullscreenerror', errorHandler);
	          self.off('fullscreenchange', changeHandler);
	        }
	
	        function changeHandler() {
	          offHandler();
	          resolve();
	        }
	
	        function errorHandler(e, err) {
	          offHandler();
	          reject(err);
	        }
	
	        self.one('fullscreenchange', changeHandler);
	        self.one('fullscreenerror', errorHandler);
	        var promise = self.requestFullscreenHelper_(fullscreenOptions);
	
	        if (promise) {
	          promise.then(offHandler, offHandler);
	          promise.then(resolve, reject);
	        }
	      });
	    }
	
	    return this.requestFullscreenHelper_();
	  };
	
	  _proto.requestFullscreenHelper_ = function requestFullscreenHelper_(fullscreenOptions) {
	    var _this12 = this;
	
	    var fsOptions; // Only pass fullscreen options to requestFullscreen in spec-compliant browsers.
	    // Use defaults or player configured option unless passed directly to this method.
	
	    if (!this.fsApi_.prefixed) {
	      fsOptions = this.options_.fullscreen && this.options_.fullscreen.options || {};
	
	      if (fullscreenOptions !== undefined) {
	        fsOptions = fullscreenOptions;
	      }
	    } // This method works as follows:
	    // 1. if a fullscreen api is available, use it
	    //   1. call requestFullscreen with potential options
	    //   2. if we got a promise from above, use it to update isFullscreen()
	    // 2. otherwise, if the tech supports fullscreen, call `enterFullScreen` on it.
	    //   This is particularly used for iPhone, older iPads, and non-safari browser on iOS.
	    // 3. otherwise, use "fullWindow" mode
	
	
	    if (this.fsApi_.requestFullscreen) {
	      var promise = this.el_[this.fsApi_.requestFullscreen](fsOptions);
	
	      if (promise) {
	        promise.then(function () {
	          return _this12.isFullscreen(true);
	        }, function () {
	          return _this12.isFullscreen(false);
	        });
	      }
	
	      return promise;
	    } else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) {
	      // we can't take the video.js controls fullscreen but we can go fullscreen
	      // with native controls
	      this.techCall_('enterFullScreen');
	    } else {
	      // fullscreen isn't supported so we'll just stretch the video element to
	      // fill the viewport
	      this.enterFullWindow();
	    }
	  }
	  /**
	   * Return the video to its normal size after having been in full screen mode
	   *
	   * @fires Player#fullscreenchange
	   */
	  ;
	
	  _proto.exitFullscreen = function exitFullscreen() {
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      var self = this;
	      return new PromiseClass(function (resolve, reject) {
	        function offHandler() {
	          self.off('fullscreenerror', errorHandler);
	          self.off('fullscreenchange', changeHandler);
	        }
	
	        function changeHandler() {
	          offHandler();
	          resolve();
	        }
	
	        function errorHandler(e, err) {
	          offHandler();
	          reject(err);
	        }
	
	        self.one('fullscreenchange', changeHandler);
	        self.one('fullscreenerror', errorHandler);
	        var promise = self.exitFullscreenHelper_();
	
	        if (promise) {
	          promise.then(offHandler, offHandler); // map the promise to our resolve/reject methods
	
	          promise.then(resolve, reject);
	        }
	      });
	    }
	
	    return this.exitFullscreenHelper_();
	  };
	
	  _proto.exitFullscreenHelper_ = function exitFullscreenHelper_() {
	    var _this13 = this;
	
	    if (this.fsApi_.requestFullscreen) {
	      var promise = document__default['default'][this.fsApi_.exitFullscreen]();
	
	      if (promise) {
	        // we're splitting the promise here, so, we want to catch the
	        // potential error so that this chain doesn't have unhandled errors
	        silencePromise(promise.then(function () {
	          return _this13.isFullscreen(false);
	        }));
	      }
	
	      return promise;
	    } else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) {
	      this.techCall_('exitFullScreen');
	    } else {
	      this.exitFullWindow();
	    }
	  }
	  /**
	   * When fullscreen isn't supported we can stretch the
	   * video container to as wide as the browser will let us.
	   *
	   * @fires Player#enterFullWindow
	   */
	  ;
	
	  _proto.enterFullWindow = function enterFullWindow() {
	    this.isFullscreen(true);
	    this.isFullWindow = true; // Storing original doc overflow value to return to when fullscreen is off
	
	    this.docOrigOverflow = document__default['default'].documentElement.style.overflow; // Add listener for esc key to exit fullscreen
	
	    on(document__default['default'], 'keydown', this.boundFullWindowOnEscKey_); // Hide any scroll bars
	
	    document__default['default'].documentElement.style.overflow = 'hidden'; // Apply fullscreen styles
	
	    addClass(document__default['default'].body, 'vjs-full-window');
	    /**
	     * @event Player#enterFullWindow
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('enterFullWindow');
	  }
	  /**
	   * Check for call to either exit full window or
	   * full screen on ESC key
	   *
	   * @param {string} event
	   *        Event to check for key press
	   */
	  ;
	
	  _proto.fullWindowOnEscKey = function fullWindowOnEscKey(event) {
	    if (keycode__default['default'].isEventKey(event, 'Esc')) {
	      if (this.isFullscreen() === true) {
	        if (!this.isFullWindow) {
	          this.exitFullscreen();
	        } else {
	          this.exitFullWindow();
	        }
	      }
	    }
	  }
	  /**
	   * Exit full window
	   *
	   * @fires Player#exitFullWindow
	   */
	  ;
	
	  _proto.exitFullWindow = function exitFullWindow() {
	    this.isFullscreen(false);
	    this.isFullWindow = false;
	    off(document__default['default'], 'keydown', this.boundFullWindowOnEscKey_); // Unhide scroll bars.
	
	    document__default['default'].documentElement.style.overflow = this.docOrigOverflow; // Remove fullscreen styles
	
	    removeClass(document__default['default'].body, 'vjs-full-window'); // Resize the box, controller, and poster to original sizes
	    // this.positionAll();
	
	    /**
	     * @event Player#exitFullWindow
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('exitFullWindow');
	  }
	  /**
	   * Disable Picture-in-Picture mode.
	   *
	   * @param {boolean} value
	   *                  - true will disable Picture-in-Picture mode
	   *                  - false will enable Picture-in-Picture mode
	   */
	  ;
	
	  _proto.disablePictureInPicture = function disablePictureInPicture(value) {
	    if (value === undefined) {
	      return this.techGet_('disablePictureInPicture');
	    }
	
	    this.techCall_('setDisablePictureInPicture', value);
	    this.options_.disablePictureInPicture = value;
	    this.trigger('disablepictureinpicturechanged');
	  }
	  /**
	   * Check if the player is in Picture-in-Picture mode or tell the player that it
	   * is or is not in Picture-in-Picture mode.
	   *
	   * @param  {boolean} [isPiP]
	   *         Set the players current Picture-in-Picture state
	   *
	   * @return {boolean}
	   *         - true if Picture-in-Picture is on and getting
	   *         - false if Picture-in-Picture is off and getting
	   */
	  ;
	
	  _proto.isInPictureInPicture = function isInPictureInPicture(isPiP) {
	    if (isPiP !== undefined) {
	      this.isInPictureInPicture_ = !!isPiP;
	      this.togglePictureInPictureClass_();
	      return;
	    }
	
	    return !!this.isInPictureInPicture_;
	  }
	  /**
	   * Create a floating video window always on top of other windows so that users may
	   * continue consuming media while they interact with other content sites, or
	   * applications on their device.
	   *
	   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
	   *
	   * @fires Player#enterpictureinpicture
	   *
	   * @return {Promise}
	   *         A promise with a Picture-in-Picture window.
	   */
	  ;
	
	  _proto.requestPictureInPicture = function requestPictureInPicture() {
	    if ('pictureInPictureEnabled' in document__default['default'] && this.disablePictureInPicture() === false) {
	      /**
	       * This event fires when the player enters picture in picture mode
	       *
	       * @event Player#enterpictureinpicture
	       * @type {EventTarget~Event}
	       */
	      return this.techGet_('requestPictureInPicture');
	    }
	  }
	  /**
	   * Exit Picture-in-Picture mode.
	   *
	   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
	   *
	   * @fires Player#leavepictureinpicture
	   *
	   * @return {Promise}
	   *         A promise.
	   */
	  ;
	
	  _proto.exitPictureInPicture = function exitPictureInPicture() {
	    if ('pictureInPictureEnabled' in document__default['default']) {
	      /**
	       * This event fires when the player leaves picture in picture mode
	       *
	       * @event Player#leavepictureinpicture
	       * @type {EventTarget~Event}
	       */
	      return document__default['default'].exitPictureInPicture();
	    }
	  }
	  /**
	   * Called when this Player has focus and a key gets pressed down, or when
	   * any Component of this player receives a key press that it doesn't handle.
	   * This allows player-wide hotkeys (either as defined below, or optionally
	   * by an external function).
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    var userActions = this.options_.userActions; // Bail out if hotkeys are not configured.
	
	    if (!userActions || !userActions.hotkeys) {
	      return;
	    } // Function that determines whether or not to exclude an element from
	    // hotkeys handling.
	
	
	    var excludeElement = function excludeElement(el) {
	      var tagName = el.tagName.toLowerCase(); // The first and easiest test is for `contenteditable` elements.
	
	      if (el.isContentEditable) {
	        return true;
	      } // Inputs matching these types will still trigger hotkey handling as
	      // they are not text inputs.
	
	
	      var allowedInputTypes = ['button', 'checkbox', 'hidden', 'radio', 'reset', 'submit'];
	
	      if (tagName === 'input') {
	        return allowedInputTypes.indexOf(el.type) === -1;
	      } // The final test is by tag name. These tags will be excluded entirely.
	
	
	      var excludedTags = ['textarea'];
	      return excludedTags.indexOf(tagName) !== -1;
	    }; // Bail out if the user is focused on an interactive form element.
	
	
	    if (excludeElement(this.el_.ownerDocument.activeElement)) {
	      return;
	    }
	
	    if (typeof userActions.hotkeys === 'function') {
	      userActions.hotkeys.call(this, event);
	    } else {
	      this.handleHotkeys(event);
	    }
	  }
	  /**
	   * Called when this Player receives a hotkey keydown event.
	   * Supported player-wide hotkeys are:
	   *
	   *   f          - toggle fullscreen
	   *   m          - toggle mute
	   *   k or Space - toggle play/pause
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleHotkeys = function handleHotkeys(event) {
	    var hotkeys = this.options_.userActions ? this.options_.userActions.hotkeys : {}; // set fullscreenKey, muteKey, playPauseKey from `hotkeys`, use defaults if not set
	
	    var _hotkeys$fullscreenKe = hotkeys.fullscreenKey,
	        fullscreenKey = _hotkeys$fullscreenKe === void 0 ? function (keydownEvent) {
	      return keycode__default['default'].isEventKey(keydownEvent, 'f');
	    } : _hotkeys$fullscreenKe,
	        _hotkeys$muteKey = hotkeys.muteKey,
	        muteKey = _hotkeys$muteKey === void 0 ? function (keydownEvent) {
	      return keycode__default['default'].isEventKey(keydownEvent, 'm');
	    } : _hotkeys$muteKey,
	        _hotkeys$playPauseKey = hotkeys.playPauseKey,
	        playPauseKey = _hotkeys$playPauseKey === void 0 ? function (keydownEvent) {
	      return keycode__default['default'].isEventKey(keydownEvent, 'k') || keycode__default['default'].isEventKey(keydownEvent, 'Space');
	    } : _hotkeys$playPauseKey;
	
	    if (fullscreenKey.call(this, event)) {
	      event.preventDefault();
	      event.stopPropagation();
	      var FSToggle = Component$1.getComponent('FullscreenToggle');
	
	      if (document__default['default'][this.fsApi_.fullscreenEnabled] !== false) {
	        FSToggle.prototype.handleClick.call(this, event);
	      }
	    } else if (muteKey.call(this, event)) {
	      event.preventDefault();
	      event.stopPropagation();
	      var MuteToggle = Component$1.getComponent('MuteToggle');
	      MuteToggle.prototype.handleClick.call(this, event);
	    } else if (playPauseKey.call(this, event)) {
	      event.preventDefault();
	      event.stopPropagation();
	      var PlayToggle = Component$1.getComponent('PlayToggle');
	      PlayToggle.prototype.handleClick.call(this, event);
	    }
	  }
	  /**
	   * Check whether the player can play a given mimetype
	   *
	   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
	   *
	   * @param {string} type
	   *        The mimetype to check
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	  ;
	
	  _proto.canPlayType = function canPlayType(type) {
	    var can; // Loop through each playback technology in the options order
	
	    for (var i = 0, j = this.options_.techOrder; i < j.length; i++) {
	      var techName = j[i];
	      var tech = Tech.getTech(techName); // Support old behavior of techs being registered as components.
	      // Remove once that deprecated behavior is removed.
	
	      if (!tech) {
	        tech = Component$1.getComponent(techName);
	      } // Check if the current tech is defined before continuing
	
	
	      if (!tech) {
	        log$1.error("The \"" + techName + "\" tech is undefined. Skipped browser support check for that tech.");
	        continue;
	      } // Check if the browser supports this technology
	
	
	      if (tech.isSupported()) {
	        can = tech.canPlayType(type);
	
	        if (can) {
	          return can;
	        }
	      }
	    }
	
	    return '';
	  }
	  /**
	   * Select source based on tech-order or source-order
	   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
	   * defaults to tech-order selection
	   *
	   * @param {Array} sources
	   *        The sources for a media asset
	   *
	   * @return {Object|boolean}
	   *         Object of source and tech order or false
	   */
	  ;
	
	  _proto.selectSource = function selectSource(sources) {
	    var _this14 = this;
	
	    // Get only the techs specified in `techOrder` that exist and are supported by the
	    // current platform
	    var techs = this.options_.techOrder.map(function (techName) {
	      return [techName, Tech.getTech(techName)];
	    }).filter(function (_ref) {
	      var techName = _ref[0],
	          tech = _ref[1];
	
	      // Check if the current tech is defined before continuing
	      if (tech) {
	        // Check if the browser supports this technology
	        return tech.isSupported();
	      }
	
	      log$1.error("The \"" + techName + "\" tech is undefined. Skipped browser support check for that tech.");
	      return false;
	    }); // Iterate over each `innerArray` element once per `outerArray` element and execute
	    // `tester` with both. If `tester` returns a non-falsy value, exit early and return
	    // that value.
	
	    var findFirstPassingTechSourcePair = function findFirstPassingTechSourcePair(outerArray, innerArray, tester) {
	      var found;
	      outerArray.some(function (outerChoice) {
	        return innerArray.some(function (innerChoice) {
	          found = tester(outerChoice, innerChoice);
	
	          if (found) {
	            return true;
	          }
	        });
	      });
	      return found;
	    };
	
	    var foundSourceAndTech;
	
	    var flip = function flip(fn) {
	      return function (a, b) {
	        return fn(b, a);
	      };
	    };
	
	    var finder = function finder(_ref2, source) {
	      var techName = _ref2[0],
	          tech = _ref2[1];
	
	      if (tech.canPlaySource(source, _this14.options_[techName.toLowerCase()])) {
	        return {
	          source: source,
	          tech: techName
	        };
	      }
	    }; // Depending on the truthiness of `options.sourceOrder`, we swap the order of techs and sources
	    // to select from them based on their priority.
	
	
	    if (this.options_.sourceOrder) {
	      // Source-first ordering
	      foundSourceAndTech = findFirstPassingTechSourcePair(sources, techs, flip(finder));
	    } else {
	      // Tech-first ordering
	      foundSourceAndTech = findFirstPassingTechSourcePair(techs, sources, finder);
	    }
	
	    return foundSourceAndTech || false;
	  }
	  /**
	   * Executes source setting and getting logic
	   *
	   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
	   *        A SourceObject, an array of SourceObjects, or a string referencing
	   *        a URL to a media source. It is _highly recommended_ that an object
	   *        or array of objects is used here, so that source selection
	   *        algorithms can take the `type` into account.
	   *
	   *        If not provided, this method acts as a getter.
	   * @param {boolean} isRetry
	   *        Indicates whether this is being called internally as a result of a retry
	   *
	   * @return {string|undefined}
	   *         If the `source` argument is missing, returns the current source
	   *         URL. Otherwise, returns nothing/undefined.
	   */
	  ;
	
	  _proto.handleSrc_ = function handleSrc_(source, isRetry) {
	    var _this15 = this;
	
	    // getter usage
	    if (typeof source === 'undefined') {
	      return this.cache_.src || '';
	    } // Reset retry behavior for new source
	
	
	    if (this.resetRetryOnError_) {
	      this.resetRetryOnError_();
	    } // filter out invalid sources and turn our source into
	    // an array of source objects
	
	
	    var sources = filterSource(source); // if a source was passed in then it is invalid because
	    // it was filtered to a zero length Array. So we have to
	    // show an error
	
	    if (!sources.length) {
	      this.setTimeout(function () {
	        this.error({
	          code: 4,
	          message: this.options_.notSupportedMessage
	        });
	      }, 0);
	      return;
	    } // initial sources
	
	
	    this.changingSrc_ = true; // Only update the cached source list if we are not retrying a new source after error,
	    // since in that case we want to include the failed source(s) in the cache
	
	    if (!isRetry) {
	      this.cache_.sources = sources;
	    }
	
	    this.updateSourceCaches_(sources[0]); // middlewareSource is the source after it has been changed by middleware
	
	    setSource(this, sources[0], function (middlewareSource, mws) {
	      _this15.middleware_ = mws; // since sourceSet is async we have to update the cache again after we select a source since
	      // the source that is selected could be out of order from the cache update above this callback.
	
	      if (!isRetry) {
	        _this15.cache_.sources = sources;
	      }
	
	      _this15.updateSourceCaches_(middlewareSource);
	
	      var err = _this15.src_(middlewareSource);
	
	      if (err) {
	        if (sources.length > 1) {
	          return _this15.handleSrc_(sources.slice(1));
	        }
	
	        _this15.changingSrc_ = false; // We need to wrap this in a timeout to give folks a chance to add error event handlers
	
	        _this15.setTimeout(function () {
	          this.error({
	            code: 4,
	            message: this.options_.notSupportedMessage
	          });
	        }, 0); // we could not find an appropriate tech, but let's still notify the delegate that this is it
	        // this needs a better comment about why this is needed
	
	
	        _this15.triggerReady();
	
	        return;
	      }
	
	      setTech(mws, _this15.tech_);
	    }); // Try another available source if this one fails before playback.
	
	    if (this.options_.retryOnError && sources.length > 1) {
	      var retry = function retry() {
	        // Remove the error modal
	        _this15.error(null);
	
	        _this15.handleSrc_(sources.slice(1), true);
	      };
	
	      var stopListeningForErrors = function stopListeningForErrors() {
	        _this15.off('error', retry);
	      };
	
	      this.one('error', retry);
	      this.one('playing', stopListeningForErrors);
	
	      this.resetRetryOnError_ = function () {
	        _this15.off('error', retry);
	
	        _this15.off('playing', stopListeningForErrors);
	      };
	    }
	  }
	  /**
	   * Get or set the video source.
	   *
	   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
	   *        A SourceObject, an array of SourceObjects, or a string referencing
	   *        a URL to a media source. It is _highly recommended_ that an object
	   *        or array of objects is used here, so that source selection
	   *        algorithms can take the `type` into account.
	   *
	   *        If not provided, this method acts as a getter.
	   *
	   * @return {string|undefined}
	   *         If the `source` argument is missing, returns the current source
	   *         URL. Otherwise, returns nothing/undefined.
	   */
	  ;
	
	  _proto.src = function src(source) {
	    return this.handleSrc_(source, false);
	  }
	  /**
	   * Set the source object on the tech, returns a boolean that indicates whether
	   * there is a tech that can play the source or not
	   *
	   * @param {Tech~SourceObject} source
	   *        The source object to set on the Tech
	   *
	   * @return {boolean}
	   *         - True if there is no Tech to playback this source
	   *         - False otherwise
	   *
	   * @private
	   */
	  ;
	
	  _proto.src_ = function src_(source) {
	    var _this16 = this;
	
	    var sourceTech = this.selectSource([source]);
	
	    if (!sourceTech) {
	      return true;
	    }
	
	    if (!titleCaseEquals(sourceTech.tech, this.techName_)) {
	      this.changingSrc_ = true; // load this technology with the chosen source
	
	      this.loadTech_(sourceTech.tech, sourceTech.source);
	      this.tech_.ready(function () {
	        _this16.changingSrc_ = false;
	      });
	      return false;
	    } // wait until the tech is ready to set the source
	    // and set it synchronously if possible (#2326)
	
	
	    this.ready(function () {
	      // The setSource tech method was added with source handlers
	      // so older techs won't support it
	      // We need to check the direct prototype for the case where subclasses
	      // of the tech do not support source handlers
	      if (this.tech_.constructor.prototype.hasOwnProperty('setSource')) {
	        this.techCall_('setSource', source);
	      } else {
	        this.techCall_('src', source.src);
	      }
	
	      this.changingSrc_ = false;
	    }, true);
	    return false;
	  }
	  /**
	   * Begin loading the src data.
	   */
	  ;
	
	  _proto.load = function load() {
	    this.techCall_('load');
	  }
	  /**
	   * Reset the player. Loads the first tech in the techOrder,
	   * removes all the text tracks in the existing `tech`,
	   * and calls `reset` on the `tech`.
	   */
	  ;
	
	  _proto.reset = function reset() {
	    var _this17 = this;
	
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (this.paused() || !PromiseClass) {
	      this.doReset_();
	    } else {
	      var playPromise = this.play();
	      silencePromise(playPromise.then(function () {
	        return _this17.doReset_();
	      }));
	    }
	  };
	
	  _proto.doReset_ = function doReset_() {
	    if (this.tech_) {
	      this.tech_.clearTracks('text');
	    }
	
	    this.resetCache_();
	    this.poster('');
	    this.loadTech_(this.options_.techOrder[0], null);
	    this.techCall_('reset');
	    this.resetControlBarUI_();
	
	    if (isEvented(this)) {
	      this.trigger('playerreset');
	    }
	  }
	  /**
	   * Reset Control Bar's UI by calling sub-methods that reset
	   * all of Control Bar's components
	   */
	  ;
	
	  _proto.resetControlBarUI_ = function resetControlBarUI_() {
	    this.resetProgressBar_();
	    this.resetPlaybackRate_();
	    this.resetVolumeBar_();
	  }
	  /**
	   * Reset tech's progress so progress bar is reset in the UI
	   */
	  ;
	
	  _proto.resetProgressBar_ = function resetProgressBar_() {
	    this.currentTime(0);
	
	    var _ref3 = this.controlBar || {},
	        durationDisplay = _ref3.durationDisplay,
	        remainingTimeDisplay = _ref3.remainingTimeDisplay;
	
	    if (durationDisplay) {
	      durationDisplay.updateContent();
	    }
	
	    if (remainingTimeDisplay) {
	      remainingTimeDisplay.updateContent();
	    }
	  }
	  /**
	   * Reset Playback ratio
	   */
	  ;
	
	  _proto.resetPlaybackRate_ = function resetPlaybackRate_() {
	    this.playbackRate(this.defaultPlaybackRate());
	    this.handleTechRateChange_();
	  }
	  /**
	   * Reset Volume bar
	   */
	  ;
	
	  _proto.resetVolumeBar_ = function resetVolumeBar_() {
	    this.volume(1.0);
	    this.trigger('volumechange');
	  }
	  /**
	   * Returns all of the current source objects.
	   *
	   * @return {Tech~SourceObject[]}
	   *         The current source objects
	   */
	  ;
	
	  _proto.currentSources = function currentSources() {
	    var source = this.currentSource();
	    var sources = []; // assume `{}` or `{ src }`
	
	    if (Object.keys(source).length !== 0) {
	      sources.push(source);
	    }
	
	    return this.cache_.sources || sources;
	  }
	  /**
	   * Returns the current source object.
	   *
	   * @return {Tech~SourceObject}
	   *         The current source object
	   */
	  ;
	
	  _proto.currentSource = function currentSource() {
	    return this.cache_.source || {};
	  }
	  /**
	   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
	   * Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
	   *
	   * @return {string}
	   *         The current source
	   */
	  ;
	
	  _proto.currentSrc = function currentSrc() {
	    return this.currentSource() && this.currentSource().src || '';
	  }
	  /**
	   * Get the current source type e.g. video/mp4
	   * This can allow you rebuild the current source object so that you could load the same
	   * source and tech later
	   *
	   * @return {string}
	   *         The source MIME type
	   */
	  ;
	
	  _proto.currentType = function currentType() {
	    return this.currentSource() && this.currentSource().type || '';
	  }
	  /**
	   * Get or set the preload attribute
	   *
	   * @param {boolean} [value]
	   *        - true means that we should preload
	   *        - false means that we should not preload
	   *
	   * @return {string}
	   *         The preload attribute value when getting
	   */
	  ;
	
	  _proto.preload = function preload(value) {
	    if (value !== undefined) {
	      this.techCall_('setPreload', value);
	      this.options_.preload = value;
	      return;
	    }
	
	    return this.techGet_('preload');
	  }
	  /**
	   * Get or set the autoplay option. When this is a boolean it will
	   * modify the attribute on the tech. When this is a string the attribute on
	   * the tech will be removed and `Player` will handle autoplay on loadstarts.
	   *
	   * @param {boolean|string} [value]
	   *        - true: autoplay using the browser behavior
	   *        - false: do not autoplay
	   *        - 'play': call play() on every loadstart
	   *        - 'muted': call muted() then play() on every loadstart
	   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
	   *        - *: values other than those listed here will be set `autoplay` to true
	   *
	   * @return {boolean|string}
	   *         The current value of autoplay when getting
	   */
	  ;
	
	  _proto.autoplay = function autoplay(value) {
	    // getter usage
	    if (value === undefined) {
	      return this.options_.autoplay || false;
	    }
	
	    var techAutoplay; // if the value is a valid string set it to that, or normalize `true` to 'play', if need be
	
	    if (typeof value === 'string' && /(any|play|muted)/.test(value) || value === true && this.options_.normalizeAutoplay) {
	      this.options_.autoplay = value;
	      this.manualAutoplay_(typeof value === 'string' ? value : 'play');
	      techAutoplay = false; // any falsy value sets autoplay to false in the browser,
	      // lets do the same
	    } else if (!value) {
	      this.options_.autoplay = false; // any other value (ie truthy) sets autoplay to true
	    } else {
	      this.options_.autoplay = true;
	    }
	
	    techAutoplay = typeof techAutoplay === 'undefined' ? this.options_.autoplay : techAutoplay; // if we don't have a tech then we do not queue up
	    // a setAutoplay call on tech ready. We do this because the
	    // autoplay option will be passed in the constructor and we
	    // do not need to set it twice
	
	    if (this.tech_) {
	      this.techCall_('setAutoplay', techAutoplay);
	    }
	  }
	  /**
	   * Set or unset the playsinline attribute.
	   * Playsinline tells the browser that non-fullscreen playback is preferred.
	   *
	   * @param {boolean} [value]
	   *        - true means that we should try to play inline by default
	   *        - false means that we should use the browser's default playback mode,
	   *          which in most cases is inline. iOS Safari is a notable exception
	   *          and plays fullscreen by default.
	   *
	   * @return {string|Player}
	   *         - the current value of playsinline
	   *         - the player when setting
	   *
	   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	   */
	  ;
	
	  _proto.playsinline = function playsinline(value) {
	    if (value !== undefined) {
	      this.techCall_('setPlaysinline', value);
	      this.options_.playsinline = value;
	      return this;
	    }
	
	    return this.techGet_('playsinline');
	  }
	  /**
	   * Get or set the loop attribute on the video element.
	   *
	   * @param {boolean} [value]
	   *        - true means that we should loop the video
	   *        - false means that we should not loop the video
	   *
	   * @return {boolean}
	   *         The current value of loop when getting
	   */
	  ;
	
	  _proto.loop = function loop(value) {
	    if (value !== undefined) {
	      this.techCall_('setLoop', value);
	      this.options_.loop = value;
	      return;
	    }
	
	    return this.techGet_('loop');
	  }
	  /**
	   * Get or set the poster image source url
	   *
	   * @fires Player#posterchange
	   *
	   * @param {string} [src]
	   *        Poster image source URL
	   *
	   * @return {string}
	   *         The current value of poster when getting
	   */
	  ;
	
	  _proto.poster = function poster(src) {
	    if (src === undefined) {
	      return this.poster_;
	    } // The correct way to remove a poster is to set as an empty string
	    // other falsey values will throw errors
	
	
	    if (!src) {
	      src = '';
	    }
	
	    if (src === this.poster_) {
	      return;
	    } // update the internal poster variable
	
	
	    this.poster_ = src; // update the tech's poster
	
	    this.techCall_('setPoster', src);
	    this.isPosterFromTech_ = false; // alert components that the poster has been set
	
	    /**
	     * This event fires when the poster image is changed on the player.
	     *
	     * @event Player#posterchange
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('posterchange');
	  }
	  /**
	   * Some techs (e.g. YouTube) can provide a poster source in an
	   * asynchronous way. We want the poster component to use this
	   * poster source so that it covers up the tech's controls.
	   * (YouTube's play button). However we only want to use this
	   * source if the player user hasn't set a poster through
	   * the normal APIs.
	   *
	   * @fires Player#posterchange
	   * @listens Tech#posterchange
	   * @private
	   */
	  ;
	
	  _proto.handleTechPosterChange_ = function handleTechPosterChange_() {
	    if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
	      var newPoster = this.tech_.poster() || '';
	
	      if (newPoster !== this.poster_) {
	        this.poster_ = newPoster;
	        this.isPosterFromTech_ = true; // Let components know the poster has changed
	
	        this.trigger('posterchange');
	      }
	    }
	  }
	  /**
	   * Get or set whether or not the controls are showing.
	   *
	   * @fires Player#controlsenabled
	   *
	   * @param {boolean} [bool]
	   *        - true to turn controls on
	   *        - false to turn controls off
	   *
	   * @return {boolean}
	   *         The current value of controls when getting
	   */
	  ;
	
	  _proto.controls = function controls(bool) {
	    if (bool === undefined) {
	      return !!this.controls_;
	    }
	
	    bool = !!bool; // Don't trigger a change event unless it actually changed
	
	    if (this.controls_ === bool) {
	      return;
	    }
	
	    this.controls_ = bool;
	
	    if (this.usingNativeControls()) {
	      this.techCall_('setControls', bool);
	    }
	
	    if (this.controls_) {
	      this.removeClass('vjs-controls-disabled');
	      this.addClass('vjs-controls-enabled');
	      /**
	       * @event Player#controlsenabled
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('controlsenabled');
	
	      if (!this.usingNativeControls()) {
	        this.addTechControlsListeners_();
	      }
	    } else {
	      this.removeClass('vjs-controls-enabled');
	      this.addClass('vjs-controls-disabled');
	      /**
	       * @event Player#controlsdisabled
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('controlsdisabled');
	
	      if (!this.usingNativeControls()) {
	        this.removeTechControlsListeners_();
	      }
	    }
	  }
	  /**
	   * Toggle native controls on/off. Native controls are the controls built into
	   * devices (e.g. default iPhone controls) or other techs
	   * (e.g. Vimeo Controls)
	   * **This should only be set by the current tech, because only the tech knows
	   * if it can support native controls**
	   *
	   * @fires Player#usingnativecontrols
	   * @fires Player#usingcustomcontrols
	   *
	   * @param {boolean} [bool]
	   *        - true to turn native controls on
	   *        - false to turn native controls off
	   *
	   * @return {boolean}
	   *         The current value of native controls when getting
	   */
	  ;
	
	  _proto.usingNativeControls = function usingNativeControls(bool) {
	    if (bool === undefined) {
	      return !!this.usingNativeControls_;
	    }
	
	    bool = !!bool; // Don't trigger a change event unless it actually changed
	
	    if (this.usingNativeControls_ === bool) {
	      return;
	    }
	
	    this.usingNativeControls_ = bool;
	
	    if (this.usingNativeControls_) {
	      this.addClass('vjs-using-native-controls');
	      /**
	       * player is using the native device controls
	       *
	       * @event Player#usingnativecontrols
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('usingnativecontrols');
	    } else {
	      this.removeClass('vjs-using-native-controls');
	      /**
	       * player is using the custom HTML controls
	       *
	       * @event Player#usingcustomcontrols
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('usingcustomcontrols');
	    }
	  }
	  /**
	   * Set or get the current MediaError
	   *
	   * @fires Player#error
	   *
	   * @param  {MediaError|string|number} [err]
	   *         A MediaError or a string/number to be turned
	   *         into a MediaError
	   *
	   * @return {MediaError|null}
	   *         The current MediaError when getting (or null)
	   */
	  ;
	
	  _proto.error = function error(err) {
	    var _this18 = this;
	
	    if (err === undefined) {
	      return this.error_ || null;
	    } // allow hooks to modify error object
	
	
	    hooks('beforeerror').forEach(function (hookFunction) {
	      var newErr = hookFunction(_this18, err);
	
	      if (!(isObject(newErr) && !Array.isArray(newErr) || typeof newErr === 'string' || typeof newErr === 'number' || newErr === null)) {
	        _this18.log.error('please return a value that MediaError expects in beforeerror hooks');
	
	        return;
	      }
	
	      err = newErr;
	    }); // Suppress the first error message for no compatible source until
	    // user interaction
	
	    if (this.options_.suppressNotSupportedError && err && err.code === 4) {
	      var triggerSuppressedError = function triggerSuppressedError() {
	        this.error(err);
	      };
	
	      this.options_.suppressNotSupportedError = false;
	      this.any(['click', 'touchstart'], triggerSuppressedError);
	      this.one('loadstart', function () {
	        this.off(['click', 'touchstart'], triggerSuppressedError);
	      });
	      return;
	    } // restoring to default
	
	
	    if (err === null) {
	      this.error_ = err;
	      this.removeClass('vjs-error');
	
	      if (this.errorDisplay) {
	        this.errorDisplay.close();
	      }
	
	      return;
	    }
	
	    this.error_ = new MediaError(err); // add the vjs-error classname to the player
	
	    this.addClass('vjs-error'); // log the name of the error type and any message
	    // IE11 logs "[object object]" and required you to expand message to see error object
	
	    log$1.error("(CODE:" + this.error_.code + " " + MediaError.errorTypes[this.error_.code] + ")", this.error_.message, this.error_);
	    /**
	     * @event Player#error
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('error'); // notify hooks of the per player error
	
	    hooks('error').forEach(function (hookFunction) {
	      return hookFunction(_this18, _this18.error_);
	    });
	    return;
	  }
	  /**
	   * Report user activity
	   *
	   * @param {Object} event
	   *        Event object
	   */
	  ;
	
	  _proto.reportUserActivity = function reportUserActivity(event) {
	    this.userActivity_ = true;
	  }
	  /**
	   * Get/set if user is active
	   *
	   * @fires Player#useractive
	   * @fires Player#userinactive
	   *
	   * @param {boolean} [bool]
	   *        - true if the user is active
	   *        - false if the user is inactive
	   *
	   * @return {boolean}
	   *         The current value of userActive when getting
	   */
	  ;
	
	  _proto.userActive = function userActive(bool) {
	    if (bool === undefined) {
	      return this.userActive_;
	    }
	
	    bool = !!bool;
	
	    if (bool === this.userActive_) {
	      return;
	    }
	
	    this.userActive_ = bool;
	
	    if (this.userActive_) {
	      this.userActivity_ = true;
	      this.removeClass('vjs-user-inactive');
	      this.addClass('vjs-user-active');
	      /**
	       * @event Player#useractive
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('useractive');
	      return;
	    } // Chrome/Safari/IE have bugs where when you change the cursor it can
	    // trigger a mousemove event. This causes an issue when you're hiding
	    // the cursor when the user is inactive, and a mousemove signals user
	    // activity. Making it impossible to go into inactive mode. Specifically
	    // this happens in fullscreen when we really need to hide the cursor.
	    //
	    // When this gets resolved in ALL browsers it can be removed
	    // https://code.google.com/p/chromium/issues/detail?id=103041
	
	
	    if (this.tech_) {
	      this.tech_.one('mousemove', function (e) {
	        e.stopPropagation();
	        e.preventDefault();
	      });
	    }
	
	    this.userActivity_ = false;
	    this.removeClass('vjs-user-active');
	    this.addClass('vjs-user-inactive');
	    /**
	     * @event Player#userinactive
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('userinactive');
	  }
	  /**
	   * Listen for user activity based on timeout value
	   *
	   * @private
	   */
	  ;
	
	  _proto.listenForUserActivity_ = function listenForUserActivity_() {
	    var mouseInProgress;
	    var lastMoveX;
	    var lastMoveY;
	    var handleActivity = bind(this, this.reportUserActivity);
	
	    var handleMouseMove = function handleMouseMove(e) {
	      // #1068 - Prevent mousemove spamming
	      // Chrome Bug: https://code.google.com/p/chromium/issues/detail?id=366970
	      if (e.screenX !== lastMoveX || e.screenY !== lastMoveY) {
	        lastMoveX = e.screenX;
	        lastMoveY = e.screenY;
	        handleActivity();
	      }
	    };
	
	    var handleMouseDown = function handleMouseDown() {
	      handleActivity(); // For as long as the they are touching the device or have their mouse down,
	      // we consider them active even if they're not moving their finger or mouse.
	      // So we want to continue to update that they are active
	
	      this.clearInterval(mouseInProgress); // Setting userActivity=true now and setting the interval to the same time
	      // as the activityCheck interval (250) should ensure we never miss the
	      // next activityCheck
	
	      mouseInProgress = this.setInterval(handleActivity, 250);
	    };
	
	    var handleMouseUpAndMouseLeave = function handleMouseUpAndMouseLeave(event) {
	      handleActivity(); // Stop the interval that maintains activity if the mouse/touch is down
	
	      this.clearInterval(mouseInProgress);
	    }; // Any mouse movement will be considered user activity
	
	
	    this.on('mousedown', handleMouseDown);
	    this.on('mousemove', handleMouseMove);
	    this.on('mouseup', handleMouseUpAndMouseLeave);
	    this.on('mouseleave', handleMouseUpAndMouseLeave);
	    var controlBar = this.getChild('controlBar'); // Fixes bug on Android & iOS where when tapping progressBar (when control bar is displayed)
	    // controlBar would no longer be hidden by default timeout.
	
	    if (controlBar && !IS_IOS && !IS_ANDROID) {
	      controlBar.on('mouseenter', function (event) {
	        if (this.player().options_.inactivityTimeout !== 0) {
	          this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout;
	        }
	
	        this.player().options_.inactivityTimeout = 0;
	      });
	      controlBar.on('mouseleave', function (event) {
	        this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
	      });
	    } // Listen for keyboard navigation
	    // Shouldn't need to use inProgress interval because of key repeat
	
	
	    this.on('keydown', handleActivity);
	    this.on('keyup', handleActivity); // Run an interval every 250 milliseconds instead of stuffing everything into
	    // the mousemove/touchmove function itself, to prevent performance degradation.
	    // `this.reportUserActivity` simply sets this.userActivity_ to true, which
	    // then gets picked up by this loop
	    // http://ejohn.org/blog/learning-from-twitter/
	
	    var inactivityTimeout;
	    this.setInterval(function () {
	      // Check to see if mouse/touch activity has happened
	      if (!this.userActivity_) {
	        return;
	      } // Reset the activity tracker
	
	
	      this.userActivity_ = false; // If the user state was inactive, set the state to active
	
	      this.userActive(true); // Clear any existing inactivity timeout to start the timer over
	
	      this.clearTimeout(inactivityTimeout);
	      var timeout = this.options_.inactivityTimeout;
	
	      if (timeout <= 0) {
	        return;
	      } // In <timeout> milliseconds, if no more activity has occurred the
	      // user will be considered inactive
	
	
	      inactivityTimeout = this.setTimeout(function () {
	        // Protect against the case where the inactivityTimeout can trigger just
	        // before the next user activity is picked up by the activity check loop
	        // causing a flicker
	        if (!this.userActivity_) {
	          this.userActive(false);
	        }
	      }, timeout);
	    }, 250);
	  }
	  /**
	   * Gets or sets the current playback rate. A playback rate of
	   * 1.0 represents normal speed and 0.5 would indicate half-speed
	   * playback, for instance.
	   *
	   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
	   *
	   * @param {number} [rate]
	   *       New playback rate to set.
	   *
	   * @return {number}
	   *         The current playback rate when getting or 1.0
	   */
	  ;
	
	  _proto.playbackRate = function playbackRate(rate) {
	    if (rate !== undefined) {
	      // NOTE: this.cache_.lastPlaybackRate is set from the tech handler
	      // that is registered above
	      this.techCall_('setPlaybackRate', rate);
	      return;
	    }
	
	    if (this.tech_ && this.tech_.featuresPlaybackRate) {
	      return this.cache_.lastPlaybackRate || this.techGet_('playbackRate');
	    }
	
	    return 1.0;
	  }
	  /**
	   * Gets or sets the current default playback rate. A default playback rate of
	   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
	   * defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
	   * not the current playbackRate.
	   *
	   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
	   *
	   * @param {number} [rate]
	   *       New default playback rate to set.
	   *
	   * @return {number|Player}
	   *         - The default playback rate when getting or 1.0
	   *         - the player when setting
	   */
	  ;
	
	  _proto.defaultPlaybackRate = function defaultPlaybackRate(rate) {
	    if (rate !== undefined) {
	      return this.techCall_('setDefaultPlaybackRate', rate);
	    }
	
	    if (this.tech_ && this.tech_.featuresPlaybackRate) {
	      return this.techGet_('defaultPlaybackRate');
	    }
	
	    return 1.0;
	  }
	  /**
	   * Gets or sets the audio flag
	   *
	   * @param {boolean} bool
	   *        - true signals that this is an audio player
	   *        - false signals that this is not an audio player
	   *
	   * @return {boolean}
	   *         The current value of isAudio when getting
	   */
	  ;
	
	  _proto.isAudio = function isAudio(bool) {
	    if (bool !== undefined) {
	      this.isAudio_ = !!bool;
	      return;
	    }
	
	    return !!this.isAudio_;
	  };
	
	  _proto.enableAudioOnlyUI_ = function enableAudioOnlyUI_() {
	    var _this19 = this;
	
	    // Update styling immediately to show the control bar so we can get its height
	    this.addClass('vjs-audio-only-mode');
	    var playerChildren = this.children();
	    var controlBar = this.getChild('ControlBar');
	    var controlBarHeight = controlBar && controlBar.currentHeight(); // Hide all player components except the control bar. Control bar components
	    // needed only for video are hidden with CSS
	
	    playerChildren.forEach(function (child) {
	      if (child === controlBar) {
	        return;
	      }
	
	      if (child.el_ && !child.hasClass('vjs-hidden')) {
	        child.hide();
	
	        _this19.audioOnlyCache_.hiddenChildren.push(child);
	      }
	    });
	    this.audioOnlyCache_.playerHeight = this.currentHeight(); // Set the player height the same as the control bar
	
	    this.height(controlBarHeight);
	    this.trigger('audioonlymodechange');
	  };
	
	  _proto.disableAudioOnlyUI_ = function disableAudioOnlyUI_() {
	    this.removeClass('vjs-audio-only-mode'); // Show player components that were previously hidden
	
	    this.audioOnlyCache_.hiddenChildren.forEach(function (child) {
	      return child.show();
	    }); // Reset player height
	
	    this.height(this.audioOnlyCache_.playerHeight);
	    this.trigger('audioonlymodechange');
	  }
	  /**
	   * Get the current audioOnlyMode state or set audioOnlyMode to true or false.
	   *
	   * Setting this to `true` will hide all player components except the control bar,
	   * as well as control bar components needed only for video.
	   *
	   * @param {boolean} [value]
	   *         The value to set audioOnlyMode to.
	   *
	   * @return {Promise|boolean}
	   *        A Promise is returned when setting the state, and a boolean when getting
	   *        the present state
	   */
	  ;
	
	  _proto.audioOnlyMode = function audioOnlyMode(value) {
	    var _this20 = this;
	
	    if (typeof value !== 'boolean' || value === this.audioOnlyMode_) {
	      return this.audioOnlyMode_;
	    }
	
	    this.audioOnlyMode_ = value;
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      // Enable Audio Only Mode
	      if (value) {
	        var exitPromises = []; // Fullscreen and PiP are not supported in audioOnlyMode, so exit if we need to.
	
	        if (this.isInPictureInPicture()) {
	          exitPromises.push(this.exitPictureInPicture());
	        }
	
	        if (this.isFullscreen()) {
	          exitPromises.push(this.exitFullscreen());
	        }
	
	        if (this.audioPosterMode()) {
	          exitPromises.push(this.audioPosterMode(false));
	        }
	
	        return PromiseClass.all(exitPromises).then(function () {
	          return _this20.enableAudioOnlyUI_();
	        });
	      } // Disable Audio Only Mode
	
	
	      return PromiseClass.resolve().then(function () {
	        return _this20.disableAudioOnlyUI_();
	      });
	    }
	
	    if (value) {
	      if (this.isInPictureInPicture()) {
	        this.exitPictureInPicture();
	      }
	
	      if (this.isFullscreen()) {
	        this.exitFullscreen();
	      }
	
	      this.enableAudioOnlyUI_();
	    } else {
	      this.disableAudioOnlyUI_();
	    }
	  };
	
	  _proto.enablePosterModeUI_ = function enablePosterModeUI_() {
	    // Hide the video element and show the poster image to enable posterModeUI
	    var tech = this.tech_ && this.tech_;
	    tech.hide();
	    this.addClass('vjs-audio-poster-mode');
	    this.trigger('audiopostermodechange');
	  };
	
	  _proto.disablePosterModeUI_ = function disablePosterModeUI_() {
	    // Show the video element and hide the poster image to disable posterModeUI
	    var tech = this.tech_ && this.tech_;
	    tech.show();
	    this.removeClass('vjs-audio-poster-mode');
	    this.trigger('audiopostermodechange');
	  }
	  /**
	   * Get the current audioPosterMode state or set audioPosterMode to true or false
	   *
	   * @param {boolean} [value]
	   *         The value to set audioPosterMode to.
	   *
	   * @return {Promise|boolean}
	   *         A Promise is returned when setting the state, and a boolean when getting
	   *        the present state
	   */
	  ;
	
	  _proto.audioPosterMode = function audioPosterMode(value) {
	    var _this21 = this;
	
	    if (typeof value !== 'boolean' || value === this.audioPosterMode_) {
	      return this.audioPosterMode_;
	    }
	
	    this.audioPosterMode_ = value;
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      if (value) {
	        if (this.audioOnlyMode()) {
	          var audioOnlyModePromise = this.audioOnlyMode(false);
	          return audioOnlyModePromise.then(function () {
	            // enable audio poster mode after audio only mode is disabled
	            _this21.enablePosterModeUI_();
	          });
	        }
	
	        return PromiseClass.resolve().then(function () {
	          // enable audio poster mode
	          _this21.enablePosterModeUI_();
	        });
	      }
	
	      return PromiseClass.resolve().then(function () {
	        // disable audio poster mode
	        _this21.disablePosterModeUI_();
	      });
	    }
	
	    if (value) {
	      if (this.audioOnlyMode()) {
	        this.audioOnlyMode(false);
	      }
	
	      this.enablePosterModeUI_();
	      return;
	    }
	
	    this.disablePosterModeUI_();
	  }
	  /**
	   * A helper method for adding a {@link TextTrack} to our
	   * {@link TextTrackList}.
	   *
	   * In addition to the W3C settings we allow adding additional info through options.
	   *
	   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
	   *
	   * @param {string} [kind]
	   *        the kind of TextTrack you are adding
	   *
	   * @param {string} [label]
	   *        the label to give the TextTrack label
	   *
	   * @param {string} [language]
	   *        the language to set on the TextTrack
	   *
	   * @return {TextTrack|undefined}
	   *         the TextTrack that was added or undefined
	   *         if there is no tech
	   */
	  ;
	
	  _proto.addTextTrack = function addTextTrack(kind, label, language) {
	    if (this.tech_) {
	      return this.tech_.addTextTrack(kind, label, language);
	    }
	  }
	  /**
	   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}.
	   * When manualCleanup is set to false, the track will be automatically removed
	   * on source changes.
	   *
	   * @param {Object} options
	   *        Options to pass to {@link HTMLTrackElement} during creation. See
	   *        {@link HTMLTrackElement} for object properties that you should use.
	   *
	   * @param {boolean} [manualCleanup=true] if set to false, the TextTrack will be
	   *                                       removed on a source change
	   *
	   * @return {HtmlTrackElement}
	   *         the HTMLTrackElement that was created and added
	   *         to the HtmlTrackElementList and the remote
	   *         TextTrackList
	   *
	   * @deprecated The default value of the "manualCleanup" parameter will default
	   *             to "false" in upcoming versions of Video.js
	   */
	  ;
	
	  _proto.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
	    if (this.tech_) {
	      return this.tech_.addRemoteTextTrack(options, manualCleanup);
	    }
	  }
	  /**
	   * Remove a remote {@link TextTrack} from the respective
	   * {@link TextTrackList} and {@link HtmlTrackElementList}.
	   *
	   * @param {Object} track
	   *        Remote {@link TextTrack} to remove
	   *
	   * @return {undefined}
	   *         does not return anything
	   */
	  ;
	
	  _proto.removeRemoteTextTrack = function removeRemoteTextTrack(obj) {
	    if (obj === void 0) {
	      obj = {};
	    }
	
	    var _obj = obj,
	        track = _obj.track;
	
	    if (!track) {
	      track = obj;
	    } // destructure the input into an object with a track argument, defaulting to arguments[0]
	    // default the whole argument to an empty object if nothing was passed in
	
	
	    if (this.tech_) {
	      return this.tech_.removeRemoteTextTrack(track);
	    }
	  }
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object|undefined}
	   *         An object with supported media playback quality metrics or undefined if there
	   *         is no tech or the tech does not support it.
	   */
	  ;
	
	  _proto.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    return this.techGet_('getVideoPlaybackQuality');
	  }
	  /**
	   * Get video width
	   *
	   * @return {number}
	   *         current video width
	   */
	  ;
	
	  _proto.videoWidth = function videoWidth() {
	    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
	  }
	  /**
	   * Get video height
	   *
	   * @return {number}
	   *         current video height
	   */
	  ;
	
	  _proto.videoHeight = function videoHeight() {
	    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
	  }
	  /**
	   * The player's language code.
	   *
	   * Changing the language will trigger
	   * [languagechange]{@link Player#event:languagechange}
	   * which Components can use to update control text.
	   * ClickableComponent will update its control text by default on
	   * [languagechange]{@link Player#event:languagechange}.
	   *
	   * @fires Player#languagechange
	   *
	   * @param {string} [code]
	   *        the language code to set the player to
	   *
	   * @return {string}
	   *         The current language code when getting
	   */
	  ;
	
	  _proto.language = function language(code) {
	    if (code === undefined) {
	      return this.language_;
	    }
	
	    if (this.language_ !== String(code).toLowerCase()) {
	      this.language_ = String(code).toLowerCase(); // during first init, it's possible some things won't be evented
	
	      if (isEvented(this)) {
	        /**
	        * fires when the player language change
	        *
	        * @event Player#languagechange
	        * @type {EventTarget~Event}
	        */
	        this.trigger('languagechange');
	      }
	    }
	  }
	  /**
	   * Get the player's language dictionary
	   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
	   * Languages specified directly in the player options have precedence
	   *
	   * @return {Array}
	   *         An array of of supported languages
	   */
	  ;
	
	  _proto.languages = function languages() {
	    return mergeOptions$3(Player.prototype.options_.languages, this.languages_);
	  }
	  /**
	   * returns a JavaScript object reperesenting the current track
	   * information. **DOES not return it as JSON**
	   *
	   * @return {Object}
	   *         Object representing the current of track info
	   */
	  ;
	
	  _proto.toJSON = function toJSON() {
	    var options = mergeOptions$3(this.options_);
	    var tracks = options.tracks;
	    options.tracks = [];
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i]; // deep merge tracks and null out player so no circular references
	
	      track = mergeOptions$3(track);
	      track.player = undefined;
	      options.tracks[i] = track;
	    }
	
	    return options;
	  }
	  /**
	   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
	   * component) that immediately overlays the player with arbitrary
	   * content and removes itself when closed.
	   *
	   * @param {string|Function|Element|Array|null} content
	   *        Same as {@link ModalDialog#content}'s param of the same name.
	   *        The most straight-forward usage is to provide a string or DOM
	   *        element.
	   *
	   * @param {Object} [options]
	   *        Extra options which will be passed on to the {@link ModalDialog}.
	   *
	   * @return {ModalDialog}
	   *         the {@link ModalDialog} that was created
	   */
	  ;
	
	  _proto.createModal = function createModal(content, options) {
	    var _this22 = this;
	
	    options = options || {};
	    options.content = content || '';
	    var modal = new ModalDialog(this, options);
	    this.addChild(modal);
	    modal.on('dispose', function () {
	      _this22.removeChild(modal);
	    });
	    modal.open();
	    return modal;
	  }
	  /**
	   * Change breakpoint classes when the player resizes.
	   *
	   * @private
	   */
	  ;
	
	  _proto.updateCurrentBreakpoint_ = function updateCurrentBreakpoint_() {
	    if (!this.responsive()) {
	      return;
	    }
	
	    var currentBreakpoint = this.currentBreakpoint();
	    var currentWidth = this.currentWidth();
	
	    for (var i = 0; i < BREAKPOINT_ORDER.length; i++) {
	      var candidateBreakpoint = BREAKPOINT_ORDER[i];
	      var maxWidth = this.breakpoints_[candidateBreakpoint];
	
	      if (currentWidth <= maxWidth) {
	        // The current breakpoint did not change, nothing to do.
	        if (currentBreakpoint === candidateBreakpoint) {
	          return;
	        } // Only remove a class if there is a current breakpoint.
	
	
	        if (currentBreakpoint) {
	          this.removeClass(BREAKPOINT_CLASSES[currentBreakpoint]);
	        }
	
	        this.addClass(BREAKPOINT_CLASSES[candidateBreakpoint]);
	        this.breakpoint_ = candidateBreakpoint;
	        break;
	      }
	    }
	  }
	  /**
	   * Removes the current breakpoint.
	   *
	   * @private
	   */
	  ;
	
	  _proto.removeCurrentBreakpoint_ = function removeCurrentBreakpoint_() {
	    var className = this.currentBreakpointClass();
	    this.breakpoint_ = '';
	
	    if (className) {
	      this.removeClass(className);
	    }
	  }
	  /**
	   * Get or set breakpoints on the player.
	   *
	   * Calling this method with an object or `true` will remove any previous
	   * custom breakpoints and start from the defaults again.
	   *
	   * @param  {Object|boolean} [breakpoints]
	   *         If an object is given, it can be used to provide custom
	   *         breakpoints. If `true` is given, will set default breakpoints.
	   *         If this argument is not given, will simply return the current
	   *         breakpoints.
	   *
	   * @param  {number} [breakpoints.tiny]
	   *         The maximum width for the "vjs-layout-tiny" class.
	   *
	   * @param  {number} [breakpoints.xsmall]
	   *         The maximum width for the "vjs-layout-x-small" class.
	   *
	   * @param  {number} [breakpoints.small]
	   *         The maximum width for the "vjs-layout-small" class.
	   *
	   * @param  {number} [breakpoints.medium]
	   *         The maximum width for the "vjs-layout-medium" class.
	   *
	   * @param  {number} [breakpoints.large]
	   *         The maximum width for the "vjs-layout-large" class.
	   *
	   * @param  {number} [breakpoints.xlarge]
	   *         The maximum width for the "vjs-layout-x-large" class.
	   *
	   * @param  {number} [breakpoints.huge]
	   *         The maximum width for the "vjs-layout-huge" class.
	   *
	   * @return {Object}
	   *         An object mapping breakpoint names to maximum width values.
	   */
	  ;
	
	  _proto.breakpoints = function breakpoints(_breakpoints) {
	    // Used as a getter.
	    if (_breakpoints === undefined) {
	      return assign(this.breakpoints_);
	    }
	
	    this.breakpoint_ = '';
	    this.breakpoints_ = assign({}, DEFAULT_BREAKPOINTS, _breakpoints); // When breakpoint definitions change, we need to update the currently
	    // selected breakpoint.
	
	    this.updateCurrentBreakpoint_(); // Clone the breakpoints before returning.
	
	    return assign(this.breakpoints_);
	  }
	  /**
	   * Get or set a flag indicating whether or not this player should adjust
	   * its UI based on its dimensions.
	   *
	   * @param  {boolean} value
	   *         Should be `true` if the player should adjust its UI based on its
	   *         dimensions; otherwise, should be `false`.
	   *
	   * @return {boolean}
	   *         Will be `true` if this player should adjust its UI based on its
	   *         dimensions; otherwise, will be `false`.
	   */
	  ;
	
	  _proto.responsive = function responsive(value) {
	    // Used as a getter.
	    if (value === undefined) {
	      return this.responsive_;
	    }
	
	    value = Boolean(value);
	    var current = this.responsive_; // Nothing changed.
	
	    if (value === current) {
	      return;
	    } // The value actually changed, set it.
	
	
	    this.responsive_ = value; // Start listening for breakpoints and set the initial breakpoint if the
	    // player is now responsive.
	
	    if (value) {
	      this.on('playerresize', this.boundUpdateCurrentBreakpoint_);
	      this.updateCurrentBreakpoint_(); // Stop listening for breakpoints if the player is no longer responsive.
	    } else {
	      this.off('playerresize', this.boundUpdateCurrentBreakpoint_);
	      this.removeCurrentBreakpoint_();
	    }
	
	    return value;
	  }
	  /**
	   * Get current breakpoint name, if any.
	   *
	   * @return {string}
	   *         If there is currently a breakpoint set, returns a the key from the
	   *         breakpoints object matching it. Otherwise, returns an empty string.
	   */
	  ;
	
	  _proto.currentBreakpoint = function currentBreakpoint() {
	    return this.breakpoint_;
	  }
	  /**
	   * Get the current breakpoint class name.
	   *
	   * @return {string}
	   *         The matching class name (e.g. `"vjs-layout-tiny"` or
	   *         `"vjs-layout-large"`) for the current breakpoint. Empty string if
	   *         there is no current breakpoint.
	   */
	  ;
	
	  _proto.currentBreakpointClass = function currentBreakpointClass() {
	    return BREAKPOINT_CLASSES[this.breakpoint_] || '';
	  }
	  /**
	   * An object that describes a single piece of media.
	   *
	   * Properties that are not part of this type description will be retained; so,
	   * this can be viewed as a generic metadata storage mechanism as well.
	   *
	   * @see      {@link https://wicg.github.io/mediasession/#the-mediametadata-interface}
	   * @typedef  {Object} Player~MediaObject
	   *
	   * @property {string} [album]
	   *           Unused, except if this object is passed to the `MediaSession`
	   *           API.
	   *
	   * @property {string} [artist]
	   *           Unused, except if this object is passed to the `MediaSession`
	   *           API.
	   *
	   * @property {Object[]} [artwork]
	   *           Unused, except if this object is passed to the `MediaSession`
	   *           API. If not specified, will be populated via the `poster`, if
	   *           available.
	   *
	   * @property {string} [poster]
	   *           URL to an image that will display before playback.
	   *
	   * @property {Tech~SourceObject|Tech~SourceObject[]|string} [src]
	   *           A single source object, an array of source objects, or a string
	   *           referencing a URL to a media source. It is _highly recommended_
	   *           that an object or array of objects is used here, so that source
	   *           selection algorithms can take the `type` into account.
	   *
	   * @property {string} [title]
	   *           Unused, except if this object is passed to the `MediaSession`
	   *           API.
	   *
	   * @property {Object[]} [textTracks]
	   *           An array of objects to be used to create text tracks, following
	   *           the {@link https://www.w3.org/TR/html50/embedded-content-0.html#the-track-element|native track element format}.
	   *           For ease of removal, these will be created as "remote" text
	   *           tracks and set to automatically clean up on source changes.
	   *
	   *           These objects may have properties like `src`, `kind`, `label`,
	   *           and `language`, see {@link Tech#createRemoteTextTrack}.
	   */
	
	  /**
	   * Populate the player using a {@link Player~MediaObject|MediaObject}.
	   *
	   * @param  {Player~MediaObject} media
	   *         A media object.
	   *
	   * @param  {Function} ready
	   *         A callback to be called when the player is ready.
	   */
	  ;
	
	  _proto.loadMedia = function loadMedia(media, ready) {
	    var _this23 = this;
	
	    if (!media || typeof media !== 'object') {
	      return;
	    }
	
	    this.reset(); // Clone the media object so it cannot be mutated from outside.
	
	    this.cache_.media = mergeOptions$3(media);
	    var _this$cache_$media = this.cache_.media,
	        artwork = _this$cache_$media.artwork,
	        poster = _this$cache_$media.poster,
	        src = _this$cache_$media.src,
	        textTracks = _this$cache_$media.textTracks; // If `artwork` is not given, create it using `poster`.
	
	    if (!artwork && poster) {
	      this.cache_.media.artwork = [{
	        src: poster,
	        type: getMimetype(poster)
	      }];
	    }
	
	    if (src) {
	      this.src(src);
	    }
	
	    if (poster) {
	      this.poster(poster);
	    }
	
	    if (Array.isArray(textTracks)) {
	      textTracks.forEach(function (tt) {
	        return _this23.addRemoteTextTrack(tt, false);
	      });
	    }
	
	    this.ready(ready);
	  }
	  /**
	   * Get a clone of the current {@link Player~MediaObject} for this player.
	   *
	   * If the `loadMedia` method has not been used, will attempt to return a
	   * {@link Player~MediaObject} based on the current state of the player.
	   *
	   * @return {Player~MediaObject}
	   */
	  ;
	
	  _proto.getMedia = function getMedia() {
	    if (!this.cache_.media) {
	      var poster = this.poster();
	      var src = this.currentSources();
	      var textTracks = Array.prototype.map.call(this.remoteTextTracks(), function (tt) {
	        return {
	          kind: tt.kind,
	          label: tt.label,
	          language: tt.language,
	          src: tt.src
	        };
	      });
	      var media = {
	        src: src,
	        textTracks: textTracks
	      };
	
	      if (poster) {
	        media.poster = poster;
	        media.artwork = [{
	          src: media.poster,
	          type: getMimetype(media.poster)
	        }];
	      }
	
	      return media;
	    }
	
	    return mergeOptions$3(this.cache_.media);
	  }
	  /**
	   * Gets tag settings
	   *
	   * @param {Element} tag
	   *        The player tag
	   *
	   * @return {Object}
	   *         An object containing all of the settings
	   *         for a player tag
	   */
	  ;
	
	  Player.getTagSettings = function getTagSettings(tag) {
	    var baseOptions = {
	      sources: [],
	      tracks: []
	    };
	    var tagOptions = getAttributes(tag);
	    var dataSetup = tagOptions['data-setup'];
	
	    if (hasClass(tag, 'vjs-fill')) {
	      tagOptions.fill = true;
	    }
	
	    if (hasClass(tag, 'vjs-fluid')) {
	      tagOptions.fluid = true;
	    } // Check if data-setup attr exists.
	
	
	    if (dataSetup !== null) {
	      // Parse options JSON
	      // If empty string, make it a parsable json object.
	      var _safeParseTuple = safeParseTuple__default['default'](dataSetup || '{}'),
	          err = _safeParseTuple[0],
	          data = _safeParseTuple[1];
	
	      if (err) {
	        log$1.error(err);
	      }
	
	      assign(tagOptions, data);
	    }
	
	    assign(baseOptions, tagOptions); // Get tag children settings
	
	    if (tag.hasChildNodes()) {
	      var children = tag.childNodes;
	
	      for (var i = 0, j = children.length; i < j; i++) {
	        var child = children[i]; // Change case needed: http://ejohn.org/blog/nodename-case-sensitivity/
	
	        var childName = child.nodeName.toLowerCase();
	
	        if (childName === 'source') {
	          baseOptions.sources.push(getAttributes(child));
	        } else if (childName === 'track') {
	          baseOptions.tracks.push(getAttributes(child));
	        }
	      }
	    }
	
	    return baseOptions;
	  }
	  /**
	   * Determine whether or not flexbox is supported
	   *
	   * @return {boolean}
	   *         - true if flexbox is supported
	   *         - false if flexbox is not supported
	   */
	  ;
	
	  _proto.flexNotSupported_ = function flexNotSupported_() {
	    var elem = document__default['default'].createElement('i'); // Note: We don't actually use flexBasis (or flexOrder), but it's one of the more
	    // common flex features that we can rely on when checking for flex support.
	
	    return !('flexBasis' in elem.style || 'webkitFlexBasis' in elem.style || 'mozFlexBasis' in elem.style || 'msFlexBasis' in elem.style || // IE10-specific (2012 flex spec), available for completeness
	    'msFlexOrder' in elem.style);
	  }
	  /**
	   * Set debug mode to enable/disable logs at info level.
	   *
	   * @param {boolean} enabled
	   * @fires Player#debugon
	   * @fires Player#debugoff
	   */
	  ;
	
	  _proto.debug = function debug(enabled) {
	    if (enabled === undefined) {
	      return this.debugEnabled_;
	    }
	
	    if (enabled) {
	      this.trigger('debugon');
	      this.previousLogLevel_ = this.log.level;
	      this.log.level('debug');
	      this.debugEnabled_ = true;
	    } else {
	      this.trigger('debugoff');
	      this.log.level(this.previousLogLevel_);
	      this.previousLogLevel_ = undefined;
	      this.debugEnabled_ = false;
	    }
	  }
	  /**
	   * Set or get current playback rates.
	   * Takes an array and updates the playback rates menu with the new items.
	   * Pass in an empty array to hide the menu.
	   * Values other than arrays are ignored.
	   *
	   * @fires Player#playbackrateschange
	   * @param {number[]} newRates
	   *                   The new rates that the playback rates menu should update to.
	   *                   An empty array will hide the menu
	   * @return {number[]} When used as a getter will return the current playback rates
	   */
	  ;
	
	  _proto.playbackRates = function playbackRates(newRates) {
	    if (newRates === undefined) {
	      return this.cache_.playbackRates;
	    } // ignore any value that isn't an array
	
	
	    if (!Array.isArray(newRates)) {
	      return;
	    } // ignore any arrays that don't only contain numbers
	
	
	    if (!newRates.every(function (rate) {
	      return typeof rate === 'number';
	    })) {
	      return;
	    }
	
	    this.cache_.playbackRates = newRates;
	    /**
	    * fires when the playback rates in a player are changed
	    *
	    * @event Player#playbackrateschange
	    * @type {EventTarget~Event}
	    */
	
	    this.trigger('playbackrateschange');
	  };
	
	  return Player;
	}(Component$1);
	/**
	 * Get the {@link VideoTrackList}
	 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist
	 *
	 * @return {VideoTrackList}
	 *         the current video track list
	 *
	 * @method Player.prototype.videoTracks
	 */
	
	/**
	 * Get the {@link AudioTrackList}
	 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist
	 *
	 * @return {AudioTrackList}
	 *         the current audio track list
	 *
	 * @method Player.prototype.audioTracks
	 */
	
	/**
	 * Get the {@link TextTrackList}
	 *
	 * @link http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-texttracks
	 *
	 * @return {TextTrackList}
	 *         the current text track list
	 *
	 * @method Player.prototype.textTracks
	 */
	
	/**
	 * Get the remote {@link TextTrackList}
	 *
	 * @return {TextTrackList}
	 *         The current remote text track list
	 *
	 * @method Player.prototype.remoteTextTracks
	 */
	
	/**
	 * Get the remote {@link HtmlTrackElementList} tracks.
	 *
	 * @return {HtmlTrackElementList}
	 *         The current remote text track element list
	 *
	 * @method Player.prototype.remoteTextTrackEls
	 */
	
	
	ALL.names.forEach(function (name) {
	  var props = ALL[name];
	
	  Player.prototype[props.getterName] = function () {
	    if (this.tech_) {
	      return this.tech_[props.getterName]();
	    } // if we have not yet loadTech_, we create {video,audio,text}Tracks_
	    // these will be passed to the tech during loading
	
	
	    this[props.privateName] = this[props.privateName] || new props.ListClass();
	    return this[props.privateName];
	  };
	});
	/**
	 * Get or set the `Player`'s crossorigin option. For the HTML5 player, this
	 * sets the `crossOrigin` property on the `<video>` tag to control the CORS
	 * behavior.
	 *
	 * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
	 *
	 * @param {string} [value]
	 *        The value to set the `Player`'s crossorigin to. If an argument is
	 *        given, must be one of `anonymous` or `use-credentials`.
	 *
	 * @return {string|undefined}
	 *         - The current crossorigin value of the `Player` when getting.
	 *         - undefined when setting
	 */
	
	Player.prototype.crossorigin = Player.prototype.crossOrigin;
	/**
	 * Global enumeration of players.
	 *
	 * The keys are the player IDs and the values are either the {@link Player}
	 * instance or `null` for disposed players.
	 *
	 * @type {Object}
	 */
	
	Player.players = {};
	var navigator = window__default['default'].navigator;
	/*
	 * Player instance options, surfaced using options
	 * options = Player.prototype.options_
	 * Make changes in options, not here.
	 *
	 * @type {Object}
	 * @private
	 */
	
	Player.prototype.options_ = {
	  // Default order of fallback technology
	  techOrder: Tech.defaultTechOrder_,
	  html5: {},
	  // default inactivity timeout
	  inactivityTimeout: 2000,
	  // default playback rates
	  playbackRates: [],
	  // Add playback rate selection by adding rates
	  // 'playbackRates': [0.5, 1, 1.5, 2],
	  liveui: false,
	  // Included control sets
	  children: ['mediaLoader', 'posterImage', 'textTrackDisplay', 'loadingSpinner', 'bigPlayButton', 'liveTracker', 'controlBar', 'errorDisplay', 'textTrackSettings', 'resizeManager'],
	  language: navigator && (navigator.languages && navigator.languages[0] || navigator.userLanguage || navigator.language) || 'en',
	  // locales and their language translations
	  languages: {},
	  // Default message to show when a video cannot be played.
	  notSupportedMessage: 'No compatible source was found for this media.',
	  normalizeAutoplay: false,
	  fullscreen: {
	    options: {
	      navigationUI: 'hide'
	    }
	  },
	  breakpoints: {},
	  responsive: false,
	  audioOnlyMode: false,
	  audioPosterMode: false
	};
	[
	/**
	 * Returns whether or not the player is in the "ended" state.
	 *
	 * @return {Boolean} True if the player is in the ended state, false if not.
	 * @method Player#ended
	 */
	'ended',
	/**
	 * Returns whether or not the player is in the "seeking" state.
	 *
	 * @return {Boolean} True if the player is in the seeking state, false if not.
	 * @method Player#seeking
	 */
	'seeking',
	/**
	 * Returns the TimeRanges of the media that are currently available
	 * for seeking to.
	 *
	 * @return {TimeRanges} the seekable intervals of the media timeline
	 * @method Player#seekable
	 */
	'seekable',
	/**
	 * Returns the current state of network activity for the element, from
	 * the codes in the list below.
	 * - NETWORK_EMPTY (numeric value 0)
	 *   The element has not yet been initialised. All attributes are in
	 *   their initial states.
	 * - NETWORK_IDLE (numeric value 1)
	 *   The element's resource selection algorithm is active and has
	 *   selected a resource, but it is not actually using the network at
	 *   this time.
	 * - NETWORK_LOADING (numeric value 2)
	 *   The user agent is actively trying to download data.
	 * - NETWORK_NO_SOURCE (numeric value 3)
	 *   The element's resource selection algorithm is active, but it has
	 *   not yet found a resource to use.
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
	 * @return {number} the current network activity state
	 * @method Player#networkState
	 */
	'networkState',
	/**
	 * Returns a value that expresses the current state of the element
	 * with respect to rendering the current playback position, from the
	 * codes in the list below.
	 * - HAVE_NOTHING (numeric value 0)
	 *   No information regarding the media resource is available.
	 * - HAVE_METADATA (numeric value 1)
	 *   Enough of the resource has been obtained that the duration of the
	 *   resource is available.
	 * - HAVE_CURRENT_DATA (numeric value 2)
	 *   Data for the immediate current playback position is available.
	 * - HAVE_FUTURE_DATA (numeric value 3)
	 *   Data for the immediate current playback position is available, as
	 *   well as enough data for the user agent to advance the current
	 *   playback position in the direction of playback.
	 * - HAVE_ENOUGH_DATA (numeric value 4)
	 *   The user agent estimates that enough data is available for
	 *   playback to proceed uninterrupted.
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
	 * @return {number} the current playback rendering state
	 * @method Player#readyState
	 */
	'readyState'].forEach(function (fn) {
	  Player.prototype[fn] = function () {
	    return this.techGet_(fn);
	  };
	});
	TECH_EVENTS_RETRIGGER.forEach(function (event) {
	  Player.prototype["handleTech" + toTitleCase$1(event) + "_"] = function () {
	    return this.trigger(event);
	  };
	});
	/**
	 * Fired when the player has initial duration and dimension information
	 *
	 * @event Player#loadedmetadata
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the player has downloaded data at the current playback position
	 *
	 * @event Player#loadeddata
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the current playback position has changed *
	 * During playback this is fired every 15-250 milliseconds, depending on the
	 * playback technology in use.
	 *
	 * @event Player#timeupdate
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the volume changes
	 *
	 * @event Player#volumechange
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Reports whether or not a player has a plugin available.
	 *
	 * This does not report whether or not the plugin has ever been initialized
	 * on this player. For that, [usingPlugin]{@link Player#usingPlugin}.
	 *
	 * @method Player#hasPlugin
	 * @param  {string}  name
	 *         The name of a plugin.
	 *
	 * @return {boolean}
	 *         Whether or not this player has the requested plugin available.
	 */
	
	/**
	 * Reports whether or not a player is using a plugin by name.
	 *
	 * For basic plugins, this only reports whether the plugin has _ever_ been
	 * initialized on this player.
	 *
	 * @method Player#usingPlugin
	 * @param  {string} name
	 *         The name of a plugin.
	 *
	 * @return {boolean}
	 *         Whether or not this player is using the requested plugin.
	 */
	
	Component$1.registerComponent('Player', Player);
	
	/**
	 * The base plugin name.
	 *
	 * @private
	 * @constant
	 * @type {string}
	 */
	
	var BASE_PLUGIN_NAME = 'plugin';
	/**
	 * The key on which a player's active plugins cache is stored.
	 *
	 * @private
	 * @constant
	 * @type     {string}
	 */
	
	var PLUGIN_CACHE_KEY = 'activePlugins_';
	/**
	 * Stores registered plugins in a private space.
	 *
	 * @private
	 * @type    {Object}
	 */
	
	var pluginStorage = {};
	/**
	 * Reports whether or not a plugin has been registered.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of a plugin.
	 *
	 * @return {boolean}
	 *          Whether or not the plugin has been registered.
	 */
	
	var pluginExists = function pluginExists(name) {
	  return pluginStorage.hasOwnProperty(name);
	};
	/**
	 * Get a single registered plugin by name.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of a plugin.
	 *
	 * @return {Function|undefined}
	 *          The plugin (or undefined).
	 */
	
	
	var getPlugin = function getPlugin(name) {
	  return pluginExists(name) ? pluginStorage[name] : undefined;
	};
	/**
	 * Marks a plugin as "active" on a player.
	 *
	 * Also, ensures that the player has an object for tracking active plugins.
	 *
	 * @private
	 * @param   {Player} player
	 *          A Video.js player instance.
	 *
	 * @param   {string} name
	 *          The name of a plugin.
	 */
	
	
	var markPluginAsActive = function markPluginAsActive(player, name) {
	  player[PLUGIN_CACHE_KEY] = player[PLUGIN_CACHE_KEY] || {};
	  player[PLUGIN_CACHE_KEY][name] = true;
	};
	/**
	 * Triggers a pair of plugin setup events.
	 *
	 * @private
	 * @param  {Player} player
	 *         A Video.js player instance.
	 *
	 * @param  {Plugin~PluginEventHash} hash
	 *         A plugin event hash.
	 *
	 * @param  {boolean} [before]
	 *         If true, prefixes the event name with "before". In other words,
	 *         use this to trigger "beforepluginsetup" instead of "pluginsetup".
	 */
	
	
	var triggerSetupEvent = function triggerSetupEvent(player, hash, before) {
	  var eventName = (before ? 'before' : '') + 'pluginsetup';
	  player.trigger(eventName, hash);
	  player.trigger(eventName + ':' + hash.name, hash);
	};
	/**
	 * Takes a basic plugin function and returns a wrapper function which marks
	 * on the player that the plugin has been activated.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of the plugin.
	 *
	 * @param   {Function} plugin
	 *          The basic plugin.
	 *
	 * @return {Function}
	 *          A wrapper function for the given plugin.
	 */
	
	
	var createBasicPlugin = function createBasicPlugin(name, plugin) {
	  var basicPluginWrapper = function basicPluginWrapper() {
	    // We trigger the "beforepluginsetup" and "pluginsetup" events on the player
	    // regardless, but we want the hash to be consistent with the hash provided
	    // for advanced plugins.
	    //
	    // The only potentially counter-intuitive thing here is the `instance` in
	    // the "pluginsetup" event is the value returned by the `plugin` function.
	    triggerSetupEvent(this, {
	      name: name,
	      plugin: plugin,
	      instance: null
	    }, true);
	    var instance = plugin.apply(this, arguments);
	    markPluginAsActive(this, name);
	    triggerSetupEvent(this, {
	      name: name,
	      plugin: plugin,
	      instance: instance
	    });
	    return instance;
	  };
	
	  Object.keys(plugin).forEach(function (prop) {
	    basicPluginWrapper[prop] = plugin[prop];
	  });
	  return basicPluginWrapper;
	};
	/**
	 * Takes a plugin sub-class and returns a factory function for generating
	 * instances of it.
	 *
	 * This factory function will replace itself with an instance of the requested
	 * sub-class of Plugin.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of the plugin.
	 *
	 * @param   {Plugin} PluginSubClass
	 *          The advanced plugin.
	 *
	 * @return {Function}
	 */
	
	
	var createPluginFactory = function createPluginFactory(name, PluginSubClass) {
	  // Add a `name` property to the plugin prototype so that each plugin can
	  // refer to itself by name.
	  PluginSubClass.prototype.name = name;
	  return function () {
	    triggerSetupEvent(this, {
	      name: name,
	      plugin: PluginSubClass,
	      instance: null
	    }, true);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var instance = _construct__default['default'](PluginSubClass, [this].concat(args)); // The plugin is replaced by a function that returns the current instance.
	
	
	    this[name] = function () {
	      return instance;
	    };
	
	    triggerSetupEvent(this, instance.getEventHash());
	    return instance;
	  };
	};
	/**
	 * Parent class for all advanced plugins.
	 *
	 * @mixes   module:evented~EventedMixin
	 * @mixes   module:stateful~StatefulMixin
	 * @fires   Player#beforepluginsetup
	 * @fires   Player#beforepluginsetup:$name
	 * @fires   Player#pluginsetup
	 * @fires   Player#pluginsetup:$name
	 * @listens Player#dispose
	 * @throws  {Error}
	 *          If attempting to instantiate the base {@link Plugin} class
	 *          directly instead of via a sub-class.
	 */
	
	
	var Plugin = /*#__PURE__*/function () {
	  /**
	   * Creates an instance of this class.
	   *
	   * Sub-classes should call `super` to ensure plugins are properly initialized.
	   *
	   * @param {Player} player
	   *        A Video.js player instance.
	   */
	  function Plugin(player) {
	    if (this.constructor === Plugin) {
	      throw new Error('Plugin must be sub-classed; not directly instantiated.');
	    }
	
	    this.player = player;
	
	    if (!this.log) {
	      this.log = this.player.log.createLogger(this.name);
	    } // Make this object evented, but remove the added `trigger` method so we
	    // use the prototype version instead.
	
	
	    evented(this);
	    delete this.trigger;
	    stateful(this, this.constructor.defaultState);
	    markPluginAsActive(player, this.name); // Auto-bind the dispose method so we can use it as a listener and unbind
	    // it later easily.
	
	    this.dispose = this.dispose.bind(this); // If the player is disposed, dispose the plugin.
	
	    player.on('dispose', this.dispose);
	  }
	  /**
	   * Get the version of the plugin that was set on <pluginName>.VERSION
	   */
	
	
	  var _proto = Plugin.prototype;
	
	  _proto.version = function version() {
	    return this.constructor.VERSION;
	  }
	  /**
	   * Each event triggered by plugins includes a hash of additional data with
	   * conventional properties.
	   *
	   * This returns that object or mutates an existing hash.
	   *
	   * @param   {Object} [hash={}]
	   *          An object to be used as event an event hash.
	   *
	   * @return {Plugin~PluginEventHash}
	   *          An event hash object with provided properties mixed-in.
	   */
	  ;
	
	  _proto.getEventHash = function getEventHash(hash) {
	    if (hash === void 0) {
	      hash = {};
	    }
	
	    hash.name = this.name;
	    hash.plugin = this.constructor;
	    hash.instance = this;
	    return hash;
	  }
	  /**
	   * Triggers an event on the plugin object and overrides
	   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
	   *
	   * @param   {string|Object} event
	   *          An event type or an object with a type property.
	   *
	   * @param   {Object} [hash={}]
	   *          Additional data hash to merge with a
	   *          {@link Plugin~PluginEventHash|PluginEventHash}.
	   *
	   * @return {boolean}
	   *          Whether or not default was prevented.
	   */
	  ;
	
	  _proto.trigger = function trigger$1(event, hash) {
	    if (hash === void 0) {
	      hash = {};
	    }
	
	    return trigger(this.eventBusEl_, event, this.getEventHash(hash));
	  }
	  /**
	   * Handles "statechanged" events on the plugin. No-op by default, override by
	   * subclassing.
	   *
	   * @abstract
	   * @param    {Event} e
	   *           An event object provided by a "statechanged" event.
	   *
	   * @param    {Object} e.changes
	   *           An object describing changes that occurred with the "statechanged"
	   *           event.
	   */
	  ;
	
	  _proto.handleStateChanged = function handleStateChanged(e) {}
	  /**
	   * Disposes a plugin.
	   *
	   * Subclasses can override this if they want, but for the sake of safety,
	   * it's probably best to subscribe the "dispose" event.
	   *
	   * @fires Plugin#dispose
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    var name = this.name,
	        player = this.player;
	    /**
	     * Signals that a advanced plugin is about to be disposed.
	     *
	     * @event Plugin#dispose
	     * @type  {EventTarget~Event}
	     */
	
	    this.trigger('dispose');
	    this.off();
	    player.off('dispose', this.dispose); // Eliminate any possible sources of leaking memory by clearing up
	    // references between the player and the plugin instance and nulling out
	    // the plugin's state and replacing methods with a function that throws.
	
	    player[PLUGIN_CACHE_KEY][name] = false;
	    this.player = this.state = null; // Finally, replace the plugin name on the player with a new factory
	    // function, so that the plugin is ready to be set up again.
	
	    player[name] = createPluginFactory(name, pluginStorage[name]);
	  }
	  /**
	   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
	   *
	   * @param   {string|Function} plugin
	   *          If a string, matches the name of a plugin. If a function, will be
	   *          tested directly.
	   *
	   * @return {boolean}
	   *          Whether or not a plugin is a basic plugin.
	   */
	  ;
	
	  Plugin.isBasic = function isBasic(plugin) {
	    var p = typeof plugin === 'string' ? getPlugin(plugin) : plugin;
	    return typeof p === 'function' && !Plugin.prototype.isPrototypeOf(p.prototype);
	  }
	  /**
	   * Register a Video.js plugin.
	   *
	   * @param   {string} name
	   *          The name of the plugin to be registered. Must be a string and
	   *          must not match an existing plugin or a method on the `Player`
	   *          prototype.
	   *
	   * @param   {Function} plugin
	   *          A sub-class of `Plugin` or a function for basic plugins.
	   *
	   * @return {Function}
	   *          For advanced plugins, a factory function for that plugin. For
	   *          basic plugins, a wrapper function that initializes the plugin.
	   */
	  ;
	
	  Plugin.registerPlugin = function registerPlugin(name, plugin) {
	    if (typeof name !== 'string') {
	      throw new Error("Illegal plugin name, \"" + name + "\", must be a string, was " + typeof name + ".");
	    }
	
	    if (pluginExists(name)) {
	      log$1.warn("A plugin named \"" + name + "\" already exists. You may want to avoid re-registering plugins!");
	    } else if (Player.prototype.hasOwnProperty(name)) {
	      throw new Error("Illegal plugin name, \"" + name + "\", cannot share a name with an existing player method!");
	    }
	
	    if (typeof plugin !== 'function') {
	      throw new Error("Illegal plugin for \"" + name + "\", must be a function, was " + typeof plugin + ".");
	    }
	
	    pluginStorage[name] = plugin; // Add a player prototype method for all sub-classed plugins (but not for
	    // the base Plugin class).
	
	    if (name !== BASE_PLUGIN_NAME) {
	      if (Plugin.isBasic(plugin)) {
	        Player.prototype[name] = createBasicPlugin(name, plugin);
	      } else {
	        Player.prototype[name] = createPluginFactory(name, plugin);
	      }
	    }
	
	    return plugin;
	  }
	  /**
	   * De-register a Video.js plugin.
	   *
	   * @param  {string} name
	   *         The name of the plugin to be de-registered. Must be a string that
	   *         matches an existing plugin.
	   *
	   * @throws {Error}
	   *         If an attempt is made to de-register the base plugin.
	   */
	  ;
	
	  Plugin.deregisterPlugin = function deregisterPlugin(name) {
	    if (name === BASE_PLUGIN_NAME) {
	      throw new Error('Cannot de-register base plugin.');
	    }
	
	    if (pluginExists(name)) {
	      delete pluginStorage[name];
	      delete Player.prototype[name];
	    }
	  }
	  /**
	   * Gets an object containing multiple Video.js plugins.
	   *
	   * @param   {Array} [names]
	   *          If provided, should be an array of plugin names. Defaults to _all_
	   *          plugin names.
	   *
	   * @return {Object|undefined}
	   *          An object containing plugin(s) associated with their name(s) or
	   *          `undefined` if no matching plugins exist).
	   */
	  ;
	
	  Plugin.getPlugins = function getPlugins(names) {
	    if (names === void 0) {
	      names = Object.keys(pluginStorage);
	    }
	
	    var result;
	    names.forEach(function (name) {
	      var plugin = getPlugin(name);
	
	      if (plugin) {
	        result = result || {};
	        result[name] = plugin;
	      }
	    });
	    return result;
	  }
	  /**
	   * Gets a plugin's version, if available
	   *
	   * @param   {string} name
	   *          The name of a plugin.
	   *
	   * @return {string}
	   *          The plugin's version or an empty string.
	   */
	  ;
	
	  Plugin.getPluginVersion = function getPluginVersion(name) {
	    var plugin = getPlugin(name);
	    return plugin && plugin.VERSION || '';
	  };
	
	  return Plugin;
	}();
	/**
	 * Gets a plugin by name if it exists.
	 *
	 * @static
	 * @method   getPlugin
	 * @memberOf Plugin
	 * @param    {string} name
	 *           The name of a plugin.
	 *
	 * @returns  {Function|undefined}
	 *           The plugin (or `undefined`).
	 */
	
	
	Plugin.getPlugin = getPlugin;
	/**
	 * The name of the base plugin class as it is registered.
	 *
	 * @type {string}
	 */
	
	Plugin.BASE_PLUGIN_NAME = BASE_PLUGIN_NAME;
	Plugin.registerPlugin(BASE_PLUGIN_NAME, Plugin);
	/**
	 * Documented in player.js
	 *
	 * @ignore
	 */
	
	Player.prototype.usingPlugin = function (name) {
	  return !!this[PLUGIN_CACHE_KEY] && this[PLUGIN_CACHE_KEY][name] === true;
	};
	/**
	 * Documented in player.js
	 *
	 * @ignore
	 */
	
	
	Player.prototype.hasPlugin = function (name) {
	  return !!pluginExists(name);
	};
	/**
	 * Signals that a plugin is about to be set up on a player.
	 *
	 * @event    Player#beforepluginsetup
	 * @type     {Plugin~PluginEventHash}
	 */
	
	/**
	 * Signals that a plugin is about to be set up on a player - by name. The name
	 * is the name of the plugin.
	 *
	 * @event    Player#beforepluginsetup:$name
	 * @type     {Plugin~PluginEventHash}
	 */
	
	/**
	 * Signals that a plugin has just been set up on a player.
	 *
	 * @event    Player#pluginsetup
	 * @type     {Plugin~PluginEventHash}
	 */
	
	/**
	 * Signals that a plugin has just been set up on a player - by name. The name
	 * is the name of the plugin.
	 *
	 * @event    Player#pluginsetup:$name
	 * @type     {Plugin~PluginEventHash}
	 */
	
	/**
	 * @typedef  {Object} Plugin~PluginEventHash
	 *
	 * @property {string} instance
	 *           For basic plugins, the return value of the plugin function. For
	 *           advanced plugins, the plugin instance on which the event is fired.
	 *
	 * @property {string} name
	 *           The name of the plugin.
	 *
	 * @property {string} plugin
	 *           For basic plugins, the plugin function. For advanced plugins, the
	 *           plugin class/constructor.
	 */
	
	/**
	 * @file extend.js
	 * @module extend
	 */
	var hasLogged = false;
	/**
	 * Used to subclass an existing class by emulating ES subclassing using the
	 * `extends` keyword.
	 *
	 * @function
	 * @deprecated
	 * @example
	 * var MyComponent = videojs.extend(videojs.getComponent('Component'), {
	 *   myCustomMethod: function() {
	 *     // Do things in my method.
	 *   }
	 * });
	 *
	 * @param    {Function} superClass
	 *           The class to inherit from
	 *
	 * @param    {Object}   [subClassMethods={}]
	 *           Methods of the new class
	 *
	 * @return   {Function}
	 *           The new class with subClassMethods that inherited superClass.
	 */
	
	var extend = function extend(superClass, subClassMethods) {
	  if (subClassMethods === void 0) {
	    subClassMethods = {};
	  }
	
	  // Log a warning the first time extend is called to note that it is deprecated
	  // It was previously deprecated in our documentation (guides, specifically),
	  // but was never formally deprecated in code.
	  if (!hasLogged) {
	    log$1.warn('videojs.extend is deprecated as of Video.js 7.22.0 and will be removed in Video.js 8.0.0');
	    hasLogged = true;
	  }
	
	  var subClass = function subClass() {
	    superClass.apply(this, arguments);
	  };
	
	  var methods = {};
	
	  if (typeof subClassMethods === 'object') {
	    if (subClassMethods.constructor !== Object.prototype.constructor) {
	      subClass = subClassMethods.constructor;
	    }
	
	    methods = subClassMethods;
	  } else if (typeof subClassMethods === 'function') {
	    subClass = subClassMethods;
	  }
	
	  _inherits__default['default'](subClass, superClass); // this is needed for backward-compatibility and node compatibility.
	
	
	  if (superClass) {
	    subClass.super_ = superClass;
	  } // Extend subObj's prototype with functions and other properties from props
	
	
	  for (var name in methods) {
	    if (methods.hasOwnProperty(name)) {
	      subClass.prototype[name] = methods[name];
	    }
	  }
	
	  return subClass;
	};
	
	/**
	 * @file video.js
	 * @module videojs
	 */
	/**
	 * Normalize an `id` value by trimming off a leading `#`
	 *
	 * @private
	 * @param   {string} id
	 *          A string, maybe with a leading `#`.
	 *
	 * @return {string}
	 *          The string, without any leading `#`.
	 */
	
	var normalizeId = function normalizeId(id) {
	  return id.indexOf('#') === 0 ? id.slice(1) : id;
	};
	/**
	 * The `videojs()` function doubles as the main function for users to create a
	 * {@link Player} instance as well as the main library namespace.
	 *
	 * It can also be used as a getter for a pre-existing {@link Player} instance.
	 * However, we _strongly_ recommend using `videojs.getPlayer()` for this
	 * purpose because it avoids any potential for unintended initialization.
	 *
	 * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
	 * of our JSDoc template, we cannot properly document this as both a function
	 * and a namespace, so its function signature is documented here.
	 *
	 * #### Arguments
	 * ##### id
	 * string|Element, **required**
	 *
	 * Video element or video element ID.
	 *
	 * ##### options
	 * Object, optional
	 *
	 * Options object for providing settings.
	 * See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
	 *
	 * ##### ready
	 * {@link Component~ReadyCallback}, optional
	 *
	 * A function to be called when the {@link Player} and {@link Tech} are ready.
	 *
	 * #### Return Value
	 *
	 * The `videojs()` function returns a {@link Player} instance.
	 *
	 * @namespace
	 *
	 * @borrows AudioTrack as AudioTrack
	 * @borrows Component.getComponent as getComponent
	 * @borrows module:computed-style~computedStyle as computedStyle
	 * @borrows module:events.on as on
	 * @borrows module:events.one as one
	 * @borrows module:events.off as off
	 * @borrows module:events.trigger as trigger
	 * @borrows EventTarget as EventTarget
	 * @borrows module:extend~extend as extend
	 * @borrows module:fn.bind as bind
	 * @borrows module:format-time.formatTime as formatTime
	 * @borrows module:format-time.resetFormatTime as resetFormatTime
	 * @borrows module:format-time.setFormatTime as setFormatTime
	 * @borrows module:merge-options.mergeOptions as mergeOptions
	 * @borrows module:middleware.use as use
	 * @borrows Player.players as players
	 * @borrows Plugin.registerPlugin as registerPlugin
	 * @borrows Plugin.deregisterPlugin as deregisterPlugin
	 * @borrows Plugin.getPlugins as getPlugins
	 * @borrows Plugin.getPlugin as getPlugin
	 * @borrows Plugin.getPluginVersion as getPluginVersion
	 * @borrows Tech.getTech as getTech
	 * @borrows Tech.registerTech as registerTech
	 * @borrows TextTrack as TextTrack
	 * @borrows module:time-ranges.createTimeRanges as createTimeRange
	 * @borrows module:time-ranges.createTimeRanges as createTimeRanges
	 * @borrows module:url.isCrossOrigin as isCrossOrigin
	 * @borrows module:url.parseUrl as parseUrl
	 * @borrows VideoTrack as VideoTrack
	 *
	 * @param  {string|Element} id
	 *         Video element or video element ID.
	 *
	 * @param  {Object} [options]
	 *         Options object for providing settings.
	 *         See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
	 *
	 * @param  {Component~ReadyCallback} [ready]
	 *         A function to be called when the {@link Player} and {@link Tech} are
	 *         ready.
	 *
	 * @return {Player}
	 *         The `videojs()` function returns a {@link Player|Player} instance.
	 */
	
	
	function videojs(id, options, ready) {
	  var player = videojs.getPlayer(id);
	
	  if (player) {
	    if (options) {
	      log$1.warn("Player \"" + id + "\" is already initialised. Options will not be applied.");
	    }
	
	    if (ready) {
	      player.ready(ready);
	    }
	
	    return player;
	  }
	
	  var el = typeof id === 'string' ? $('#' + normalizeId(id)) : id;
	
	  if (!isEl(el)) {
	    throw new TypeError('The element or ID supplied is not valid. (videojs)');
	  } // document.body.contains(el) will only check if el is contained within that one document.
	  // This causes problems for elements in iframes.
	  // Instead, use the element's ownerDocument instead of the global document.
	  // This will make sure that the element is indeed in the dom of that document.
	  // Additionally, check that the document in question has a default view.
	  // If the document is no longer attached to the dom, the defaultView of the document will be null.
	
	
	  if (!el.ownerDocument.defaultView || !el.ownerDocument.body.contains(el)) {
	    log$1.warn('The element supplied is not included in the DOM');
	  }
	
	  options = options || {}; // Store a copy of the el before modification, if it is to be restored in destroy()
	  // If div ingest, store the parent div
	
	  if (options.restoreEl === true) {
	    options.restoreEl = (el.parentNode && el.parentNode.hasAttribute('data-vjs-player') ? el.parentNode : el).cloneNode(true);
	  }
	
	  hooks('beforesetup').forEach(function (hookFunction) {
	    var opts = hookFunction(el, mergeOptions$3(options));
	
	    if (!isObject(opts) || Array.isArray(opts)) {
	      log$1.error('please return an object in beforesetup hooks');
	      return;
	    }
	
	    options = mergeOptions$3(options, opts);
	  }); // We get the current "Player" component here in case an integration has
	  // replaced it with a custom player.
	
	  var PlayerComponent = Component$1.getComponent('Player');
	  player = new PlayerComponent(el, options, ready);
	  hooks('setup').forEach(function (hookFunction) {
	    return hookFunction(player);
	  });
	  return player;
	}
	
	videojs.hooks_ = hooks_;
	videojs.hooks = hooks;
	videojs.hook = hook;
	videojs.hookOnce = hookOnce;
	videojs.removeHook = removeHook; // Add default styles
	
	if (window__default['default'].VIDEOJS_NO_DYNAMIC_STYLE !== true && isReal()) {
	  var style = $('.vjs-styles-defaults');
	
	  if (!style) {
	    style = createStyleElement('vjs-styles-defaults');
	    var head = $('head');
	
	    if (head) {
	      head.insertBefore(style, head.firstChild);
	    }
	
	    setTextContent(style, "\n      .video-js {\n        width: 300px;\n        height: 150px;\n      }\n\n      .vjs-fluid:not(.vjs-audio-only-mode) {\n        padding-top: 56.25%\n      }\n    ");
	  }
	} // Run Auto-load players
	// You have to wait at least once in case this script is loaded after your
	// video in the DOM (weird behavior only with minified version)
	
	
	autoSetupTimeout(1, videojs);
	/**
	 * Current Video.js version. Follows [semantic versioning](https://semver.org/).
	 *
	 * @type {string}
	 */
	
	videojs.VERSION = version$5;
	/**
	 * The global options object. These are the settings that take effect
	 * if no overrides are specified when the player is created.
	 *
	 * @type {Object}
	 */
	
	videojs.options = Player.prototype.options_;
	/**
	 * Get an object with the currently created players, keyed by player ID
	 *
	 * @return {Object}
	 *         The created players
	 */
	
	videojs.getPlayers = function () {
	  return Player.players;
	};
	/**
	 * Get a single player based on an ID or DOM element.
	 *
	 * This is useful if you want to check if an element or ID has an associated
	 * Video.js player, but not create one if it doesn't.
	 *
	 * @param   {string|Element} id
	 *          An HTML element - `<video>`, `<audio>`, or `<video-js>` -
	 *          or a string matching the `id` of such an element.
	 *
	 * @return {Player|undefined}
	 *          A player instance or `undefined` if there is no player instance
	 *          matching the argument.
	 */
	
	
	videojs.getPlayer = function (id) {
	  var players = Player.players;
	  var tag;
	
	  if (typeof id === 'string') {
	    var nId = normalizeId(id);
	    var player = players[nId];
	
	    if (player) {
	      return player;
	    }
	
	    tag = $('#' + nId);
	  } else {
	    tag = id;
	  }
	
	  if (isEl(tag)) {
	    var _tag = tag,
	        _player = _tag.player,
	        playerId = _tag.playerId; // Element may have a `player` property referring to an already created
	    // player instance. If so, return that.
	
	    if (_player || players[playerId]) {
	      return _player || players[playerId];
	    }
	  }
	};
	/**
	 * Returns an array of all current players.
	 *
	 * @return {Array}
	 *         An array of all players. The array will be in the order that
	 *         `Object.keys` provides, which could potentially vary between
	 *         JavaScript engines.
	 *
	 */
	
	
	videojs.getAllPlayers = function () {
	  return (// Disposed players leave a key with a `null` value, so we need to make sure
	    // we filter those out.
	    Object.keys(Player.players).map(function (k) {
	      return Player.players[k];
	    }).filter(Boolean)
	  );
	};
	
	videojs.players = Player.players;
	videojs.getComponent = Component$1.getComponent;
	/**
	 * Register a component so it can referred to by name. Used when adding to other
	 * components, either through addChild `component.addChild('myComponent')` or through
	 * default children options  `{ children: ['myComponent'] }`.
	 *
	 * > NOTE: You could also just initialize the component before adding.
	 * `component.addChild(new MyComponent());`
	 *
	 * @param {string} name
	 *        The class name of the component
	 *
	 * @param {Component} comp
	 *        The component class
	 *
	 * @return {Component}
	 *         The newly registered component
	 */
	
	videojs.registerComponent = function (name, comp) {
	  if (Tech.isTech(comp)) {
	    log$1.warn("The " + name + " tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)");
	  }
	
	  Component$1.registerComponent.call(Component$1, name, comp);
	};
	
	videojs.getTech = Tech.getTech;
	videojs.registerTech = Tech.registerTech;
	videojs.use = use;
	/**
	 * An object that can be returned by a middleware to signify
	 * that the middleware is being terminated.
	 *
	 * @type {object}
	 * @property {object} middleware.TERMINATOR
	 */
	
	Object.defineProperty(videojs, 'middleware', {
	  value: {},
	  writeable: false,
	  enumerable: true
	});
	Object.defineProperty(videojs.middleware, 'TERMINATOR', {
	  value: TERMINATOR,
	  writeable: false,
	  enumerable: true
	});
	/**
	 * A reference to the {@link module:browser|browser utility module} as an object.
	 *
	 * @type {Object}
	 * @see  {@link module:browser|browser}
	 */
	
	videojs.browser = browser;
	/**
	 * Use {@link module:browser.TOUCH_ENABLED|browser.TOUCH_ENABLED} instead; only
	 * included for backward-compatibility with 4.x.
	 *
	 * @deprecated Since version 5.0, use {@link module:browser.TOUCH_ENABLED|browser.TOUCH_ENABLED instead.
	 * @type {boolean}
	 */
	
	videojs.TOUCH_ENABLED = TOUCH_ENABLED;
	videojs.extend = extend;
	videojs.mergeOptions = mergeOptions$3;
	videojs.bind = bind;
	videojs.registerPlugin = Plugin.registerPlugin;
	videojs.deregisterPlugin = Plugin.deregisterPlugin;
	/**
	 * Deprecated method to register a plugin with Video.js
	 *
	 * @deprecated videojs.plugin() is deprecated; use videojs.registerPlugin() instead
	 *
	 * @param {string} name
	 *        The plugin name
	 *
	 * @param {Plugin|Function} plugin
	 *         The plugin sub-class or function
	 */
	
	videojs.plugin = function (name, plugin) {
	  log$1.warn('videojs.plugin() is deprecated; use videojs.registerPlugin() instead');
	  return Plugin.registerPlugin(name, plugin);
	};
	
	videojs.getPlugins = Plugin.getPlugins;
	videojs.getPlugin = Plugin.getPlugin;
	videojs.getPluginVersion = Plugin.getPluginVersion;
	/**
	 * Adding languages so that they're available to all players.
	 * Example: `videojs.addLanguage('es', { 'Hello': 'Hola' });`
	 *
	 * @param {string} code
	 *        The language code or dictionary property
	 *
	 * @param {Object} data
	 *        The data values to be translated
	 *
	 * @return {Object}
	 *         The resulting language dictionary object
	 */
	
	videojs.addLanguage = function (code, data) {
	  var _mergeOptions;
	
	  code = ('' + code).toLowerCase();
	  videojs.options.languages = mergeOptions$3(videojs.options.languages, (_mergeOptions = {}, _mergeOptions[code] = data, _mergeOptions));
	  return videojs.options.languages[code];
	};
	/**
	 * A reference to the {@link module:log|log utility module} as an object.
	 *
	 * @type {Function}
	 * @see  {@link module:log|log}
	 */
	
	
	videojs.log = log$1;
	videojs.createLogger = createLogger;
	videojs.createTimeRange = videojs.createTimeRanges = createTimeRanges;
	videojs.formatTime = formatTime;
	videojs.setFormatTime = setFormatTime;
	videojs.resetFormatTime = resetFormatTime;
	videojs.parseUrl = parseUrl;
	videojs.isCrossOrigin = isCrossOrigin;
	videojs.EventTarget = EventTarget$2;
	videojs.on = on;
	videojs.one = one;
	videojs.off = off;
	videojs.trigger = trigger;
	/**
	 * A cross-browser XMLHttpRequest wrapper.
	 *
	 * @function
	 * @param    {Object} options
	 *           Settings for the request.
	 *
	 * @return   {XMLHttpRequest|XDomainRequest}
	 *           The request object.
	 *
	 * @see      https://github.com/Raynos/xhr
	 */
	
	videojs.xhr = XHR__default['default'];
	videojs.TextTrack = TextTrack;
	videojs.AudioTrack = AudioTrack;
	videojs.VideoTrack = VideoTrack;
	['isEl', 'isTextNode', 'createEl', 'hasClass', 'addClass', 'removeClass', 'toggleClass', 'setAttributes', 'getAttributes', 'emptyEl', 'appendContent', 'insertContent'].forEach(function (k) {
	  videojs[k] = function () {
	    log$1.warn("videojs." + k + "() is deprecated; use videojs.dom." + k + "() instead");
	    return Dom[k].apply(null, arguments);
	  };
	});
	videojs.computedStyle = computedStyle;
	/**
	 * A reference to the {@link module:dom|DOM utility module} as an object.
	 *
	 * @type {Object}
	 * @see  {@link module:dom|dom}
	 */
	
	videojs.dom = Dom;
	/**
	 * A reference to the {@link module:url|URL utility module} as an object.
	 *
	 * @type {Object}
	 * @see  {@link module:url|url}
	 */
	
	videojs.url = Url;
	videojs.defineLazyProperty = defineLazyProperty; // Adding less ambiguous text for fullscreen button.
	// In a major update this could become the default text and key.
	
	videojs.addLanguage('en', {
	  'Non-Fullscreen': 'Exit Fullscreen'
	});
	
	/*! @name @videojs/http-streaming @version 2.16.3 @license Apache-2.0 */
	/**
	 * @file resolve-url.js - Handling how URLs are resolved and manipulated
	 */
	
	var resolveUrl = _resolveUrl__default['default'];
	/**
	 * Checks whether xhr request was redirected and returns correct url depending
	 * on `handleManifestRedirects` option
	 *
	 * @api private
	 *
	 * @param  {string} url - an url being requested
	 * @param  {XMLHttpRequest} req - xhr request result
	 *
	 * @return {string}
	 */
	
	var resolveManifestRedirect = function resolveManifestRedirect(handleManifestRedirect, url, req) {
	  // To understand how the responseURL below is set and generated:
	  // - https://fetch.spec.whatwg.org/#concept-response-url
	  // - https://fetch.spec.whatwg.org/#atomic-http-redirect-handling
	  if (handleManifestRedirect && req && req.responseURL && url !== req.responseURL) {
	    return req.responseURL;
	  }
	
	  return url;
	};
	
	var logger = function logger(source) {
	  if (videojs.log.debug) {
	    return videojs.log.debug.bind(videojs, 'VHS:', source + " >");
	  }
	
	  return function () {};
	};
	/**
	 * ranges
	 *
	 * Utilities for working with TimeRanges.
	 *
	 */
	
	
	var TIME_FUDGE_FACTOR = 1 / 30; // Comparisons between time values such as current time and the end of the buffered range
	// can be misleading because of precision differences or when the current media has poorly
	// aligned audio and video, which can cause values to be slightly off from what you would
	// expect. This value is what we consider to be safe to use in such comparisons to account
	// for these scenarios.
	
	var SAFE_TIME_DELTA = TIME_FUDGE_FACTOR * 3;
	
	var filterRanges = function filterRanges(timeRanges, predicate) {
	  var results = [];
	  var i;
	
	  if (timeRanges && timeRanges.length) {
	    // Search for ranges that match the predicate
	    for (i = 0; i < timeRanges.length; i++) {
	      if (predicate(timeRanges.start(i), timeRanges.end(i))) {
	        results.push([timeRanges.start(i), timeRanges.end(i)]);
	      }
	    }
	  }
	
	  return videojs.createTimeRanges(results);
	};
	/**
	 * Attempts to find the buffered TimeRange that contains the specified
	 * time.
	 *
	 * @param {TimeRanges} buffered - the TimeRanges object to query
	 * @param {number} time  - the time to filter on.
	 * @return {TimeRanges} a new TimeRanges object
	 */
	
	
	var findRange = function findRange(buffered, time) {
	  return filterRanges(buffered, function (start, end) {
	    return start - SAFE_TIME_DELTA <= time && end + SAFE_TIME_DELTA >= time;
	  });
	};
	/**
	 * Returns the TimeRanges that begin later than the specified time.
	 *
	 * @param {TimeRanges} timeRanges - the TimeRanges object to query
	 * @param {number} time - the time to filter on.
	 * @return {TimeRanges} a new TimeRanges object.
	 */
	
	
	var findNextRange = function findNextRange(timeRanges, time) {
	  return filterRanges(timeRanges, function (start) {
	    return start - TIME_FUDGE_FACTOR >= time;
	  });
	};
	/**
	 * Returns gaps within a list of TimeRanges
	 *
	 * @param {TimeRanges} buffered - the TimeRanges object
	 * @return {TimeRanges} a TimeRanges object of gaps
	 */
	
	
	var findGaps = function findGaps(buffered) {
	  if (buffered.length < 2) {
	    return videojs.createTimeRanges();
	  }
	
	  var ranges = [];
	
	  for (var i = 1; i < buffered.length; i++) {
	    var start = buffered.end(i - 1);
	    var end = buffered.start(i);
	    ranges.push([start, end]);
	  }
	
	  return videojs.createTimeRanges(ranges);
	};
	/**
	 * Calculate the intersection of two TimeRanges
	 *
	 * @param {TimeRanges} bufferA
	 * @param {TimeRanges} bufferB
	 * @return {TimeRanges} The interesection of `bufferA` with `bufferB`
	 */
	
	
	var bufferIntersection = function bufferIntersection(bufferA, bufferB) {
	  var start = null;
	  var end = null;
	  var arity = 0;
	  var extents = [];
	  var ranges = [];
	
	  if (!bufferA || !bufferA.length || !bufferB || !bufferB.length) {
	    return videojs.createTimeRange();
	  } // Handle the case where we have both buffers and create an
	  // intersection of the two
	
	
	  var count = bufferA.length; // A) Gather up all start and end times
	
	  while (count--) {
	    extents.push({
	      time: bufferA.start(count),
	      type: 'start'
	    });
	    extents.push({
	      time: bufferA.end(count),
	      type: 'end'
	    });
	  }
	
	  count = bufferB.length;
	
	  while (count--) {
	    extents.push({
	      time: bufferB.start(count),
	      type: 'start'
	    });
	    extents.push({
	      time: bufferB.end(count),
	      type: 'end'
	    });
	  } // B) Sort them by time
	
	
	  extents.sort(function (a, b) {
	    return a.time - b.time;
	  }); // C) Go along one by one incrementing arity for start and decrementing
	  //    arity for ends
	
	  for (count = 0; count < extents.length; count++) {
	    if (extents[count].type === 'start') {
	      arity++; // D) If arity is ever incremented to 2 we are entering an
	      //    overlapping range
	
	      if (arity === 2) {
	        start = extents[count].time;
	      }
	    } else if (extents[count].type === 'end') {
	      arity--; // E) If arity is ever decremented to 1 we leaving an
	      //    overlapping range
	
	      if (arity === 1) {
	        end = extents[count].time;
	      }
	    } // F) Record overlapping ranges
	
	
	    if (start !== null && end !== null) {
	      ranges.push([start, end]);
	      start = null;
	      end = null;
	    }
	  }
	
	  return videojs.createTimeRanges(ranges);
	};
	/**
	 * Gets a human readable string for a TimeRange
	 *
	 * @param {TimeRange} range
	 * @return {string} a human readable string
	 */
	
	
	var printableRange = function printableRange(range) {
	  var strArr = [];
	
	  if (!range || !range.length) {
	    return '';
	  }
	
	  for (var i = 0; i < range.length; i++) {
	    strArr.push(range.start(i) + ' => ' + range.end(i));
	  }
	
	  return strArr.join(', ');
	};
	/**
	 * Calculates the amount of time left in seconds until the player hits the end of the
	 * buffer and causes a rebuffer
	 *
	 * @param {TimeRange} buffered
	 *        The state of the buffer
	 * @param {Numnber} currentTime
	 *        The current time of the player
	 * @param {number} playbackRate
	 *        The current playback rate of the player. Defaults to 1.
	 * @return {number}
	 *         Time until the player has to start rebuffering in seconds.
	 * @function timeUntilRebuffer
	 */
	
	
	var timeUntilRebuffer = function timeUntilRebuffer(buffered, currentTime, playbackRate) {
	  if (playbackRate === void 0) {
	    playbackRate = 1;
	  }
	
	  var bufferedEnd = buffered.length ? buffered.end(buffered.length - 1) : 0;
	  return (bufferedEnd - currentTime) / playbackRate;
	};
	/**
	 * Converts a TimeRanges object into an array representation
	 *
	 * @param {TimeRanges} timeRanges
	 * @return {Array}
	 */
	
	
	var timeRangesToArray = function timeRangesToArray(timeRanges) {
	  var timeRangesList = [];
	
	  for (var i = 0; i < timeRanges.length; i++) {
	    timeRangesList.push({
	      start: timeRanges.start(i),
	      end: timeRanges.end(i)
	    });
	  }
	
	  return timeRangesList;
	};
	/**
	 * Determines if two time range objects are different.
	 *
	 * @param {TimeRange} a
	 *        the first time range object to check
	 *
	 * @param {TimeRange} b
	 *        the second time range object to check
	 *
	 * @return {Boolean}
	 *         Whether the time range objects differ
	 */
	
	
	var isRangeDifferent = function isRangeDifferent(a, b) {
	  // same object
	  if (a === b) {
	    return false;
	  } // one or the other is undefined
	
	
	  if (!a && b || !b && a) {
	    return true;
	  } // length is different
	
	
	  if (a.length !== b.length) {
	    return true;
	  } // see if any start/end pair is different
	
	
	  for (var i = 0; i < a.length; i++) {
	    if (a.start(i) !== b.start(i) || a.end(i) !== b.end(i)) {
	      return true;
	    }
	  } // if the length and every pair is the same
	  // this is the same time range
	
	
	  return false;
	};
	
	var lastBufferedEnd = function lastBufferedEnd(a) {
	  if (!a || !a.length || !a.end) {
	    return;
	  }
	
	  return a.end(a.length - 1);
	};
	/**
	 * A utility function to add up the amount of time in a timeRange
	 * after a specified startTime.
	 * ie:[[0, 10], [20, 40], [50, 60]] with a startTime 0
	 *     would return 40 as there are 40s seconds after 0 in the timeRange
	 *
	 * @param {TimeRange} range
	 *        The range to check against
	 * @param {number} startTime
	 *        The time in the time range that you should start counting from
	 *
	 * @return {number}
	 *          The number of seconds in the buffer passed the specified time.
	 */
	
	
	var timeAheadOf = function timeAheadOf(range, startTime) {
	  var time = 0;
	
	  if (!range || !range.length) {
	    return time;
	  }
	
	  for (var i = 0; i < range.length; i++) {
	    var start = range.start(i);
	    var end = range.end(i); // startTime is after this range entirely
	
	    if (startTime > end) {
	      continue;
	    } // startTime is within this range
	
	
	    if (startTime > start && startTime <= end) {
	      time += end - startTime;
	      continue;
	    } // startTime is before this range.
	
	
	    time += end - start;
	  }
	
	  return time;
	};
	/**
	 * @file playlist.js
	 *
	 * Playlist related utilities.
	 */
	
	
	var createTimeRange = videojs.createTimeRange;
	/**
	 * Get the duration of a segment, with special cases for
	 * llhls segments that do not have a duration yet.
	 *
	 * @param {Object} playlist
	 *        the playlist that the segment belongs to.
	 * @param {Object} segment
	 *        the segment to get a duration for.
	 *
	 * @return {number}
	 *          the segment duration
	 */
	
	var segmentDurationWithParts = function segmentDurationWithParts(playlist, segment) {
	  // if this isn't a preload segment
	  // then we will have a segment duration that is accurate.
	  if (!segment.preload) {
	    return segment.duration;
	  } // otherwise we have to add up parts and preload hints
	  // to get an up to date duration.
	
	
	  var result = 0;
	  (segment.parts || []).forEach(function (p) {
	    result += p.duration;
	  }); // for preload hints we have to use partTargetDuration
	  // as they won't even have a duration yet.
	
	  (segment.preloadHints || []).forEach(function (p) {
	    if (p.type === 'PART') {
	      result += playlist.partTargetDuration;
	    }
	  });
	  return result;
	};
	/**
	 * A function to get a combined list of parts and segments with durations
	 * and indexes.
	 *
	 * @param {Playlist} playlist the playlist to get the list for.
	 *
	 * @return {Array} The part/segment list.
	 */
	
	
	var getPartsAndSegments = function getPartsAndSegments(playlist) {
	  return (playlist.segments || []).reduce(function (acc, segment, si) {
	    if (segment.parts) {
	      segment.parts.forEach(function (part, pi) {
	        acc.push({
	          duration: part.duration,
	          segmentIndex: si,
	          partIndex: pi,
	          part: part,
	          segment: segment
	        });
	      });
	    } else {
	      acc.push({
	        duration: segment.duration,
	        segmentIndex: si,
	        partIndex: null,
	        segment: segment,
	        part: null
	      });
	    }
	
	    return acc;
	  }, []);
	};
	
	var getLastParts = function getLastParts(media) {
	  var lastSegment = media.segments && media.segments.length && media.segments[media.segments.length - 1];
	  return lastSegment && lastSegment.parts || [];
	};
	
	var getKnownPartCount = function getKnownPartCount(_ref) {
	  var preloadSegment = _ref.preloadSegment;
	
	  if (!preloadSegment) {
	    return;
	  }
	
	  var parts = preloadSegment.parts,
	      preloadHints = preloadSegment.preloadHints;
	  var partCount = (preloadHints || []).reduce(function (count, hint) {
	    return count + (hint.type === 'PART' ? 1 : 0);
	  }, 0);
	  partCount += parts && parts.length ? parts.length : 0;
	  return partCount;
	};
	/**
	 * Get the number of seconds to delay from the end of a
	 * live playlist.
	 *
	 * @param {Playlist} master the master playlist
	 * @param {Playlist} media the media playlist
	 * @return {number} the hold back in seconds.
	 */
	
	
	var liveEdgeDelay = function liveEdgeDelay(master, media) {
	  if (media.endList) {
	    return 0;
	  } // dash suggestedPresentationDelay trumps everything
	
	
	  if (master && master.suggestedPresentationDelay) {
	    return master.suggestedPresentationDelay;
	  }
	
	  var hasParts = getLastParts(media).length > 0; // look for "part" delays from ll-hls first
	
	  if (hasParts && media.serverControl && media.serverControl.partHoldBack) {
	    return media.serverControl.partHoldBack;
	  } else if (hasParts && media.partTargetDuration) {
	    return media.partTargetDuration * 3; // finally look for full segment delays
	  } else if (media.serverControl && media.serverControl.holdBack) {
	    return media.serverControl.holdBack;
	  } else if (media.targetDuration) {
	    return media.targetDuration * 3;
	  }
	
	  return 0;
	};
	/**
	 * walk backward until we find a duration we can use
	 * or return a failure
	 *
	 * @param {Playlist} playlist the playlist to walk through
	 * @param {Number} endSequence the mediaSequence to stop walking on
	 */
	
	
	var backwardDuration = function backwardDuration(playlist, endSequence) {
	  var result = 0;
	  var i = endSequence - playlist.mediaSequence; // if a start time is available for segment immediately following
	  // the interval, use it
	
	  var segment = playlist.segments[i]; // Walk backward until we find the latest segment with timeline
	  // information that is earlier than endSequence
	
	  if (segment) {
	    if (typeof segment.start !== 'undefined') {
	      return {
	        result: segment.start,
	        precise: true
	      };
	    }
	
	    if (typeof segment.end !== 'undefined') {
	      return {
	        result: segment.end - segment.duration,
	        precise: true
	      };
	    }
	  }
	
	  while (i--) {
	    segment = playlist.segments[i];
	
	    if (typeof segment.end !== 'undefined') {
	      return {
	        result: result + segment.end,
	        precise: true
	      };
	    }
	
	    result += segmentDurationWithParts(playlist, segment);
	
	    if (typeof segment.start !== 'undefined') {
	      return {
	        result: result + segment.start,
	        precise: true
	      };
	    }
	  }
	
	  return {
	    result: result,
	    precise: false
	  };
	};
	/**
	 * walk forward until we find a duration we can use
	 * or return a failure
	 *
	 * @param {Playlist} playlist the playlist to walk through
	 * @param {number} endSequence the mediaSequence to stop walking on
	 */
	
	
	var forwardDuration = function forwardDuration(playlist, endSequence) {
	  var result = 0;
	  var segment;
	  var i = endSequence - playlist.mediaSequence; // Walk forward until we find the earliest segment with timeline
	  // information
	
	  for (; i < playlist.segments.length; i++) {
	    segment = playlist.segments[i];
	
	    if (typeof segment.start !== 'undefined') {
	      return {
	        result: segment.start - result,
	        precise: true
	      };
	    }
	
	    result += segmentDurationWithParts(playlist, segment);
	
	    if (typeof segment.end !== 'undefined') {
	      return {
	        result: segment.end - result,
	        precise: true
	      };
	    }
	  } // indicate we didn't find a useful duration estimate
	
	
	  return {
	    result: -1,
	    precise: false
	  };
	};
	/**
	  * Calculate the media duration from the segments associated with a
	  * playlist. The duration of a subinterval of the available segments
	  * may be calculated by specifying an end index.
	  *
	  * @param {Object} playlist a media playlist object
	  * @param {number=} endSequence an exclusive upper boundary
	  * for the playlist.  Defaults to playlist length.
	  * @param {number} expired the amount of time that has dropped
	  * off the front of the playlist in a live scenario
	  * @return {number} the duration between the first available segment
	  * and end index.
	  */
	
	
	var intervalDuration = function intervalDuration(playlist, endSequence, expired) {
	  if (typeof endSequence === 'undefined') {
	    endSequence = playlist.mediaSequence + playlist.segments.length;
	  }
	
	  if (endSequence < playlist.mediaSequence) {
	    return 0;
	  } // do a backward walk to estimate the duration
	
	
	  var backward = backwardDuration(playlist, endSequence);
	
	  if (backward.precise) {
	    // if we were able to base our duration estimate on timing
	    // information provided directly from the Media Source, return
	    // it
	    return backward.result;
	  } // walk forward to see if a precise duration estimate can be made
	  // that way
	
	
	  var forward = forwardDuration(playlist, endSequence);
	
	  if (forward.precise) {
	    // we found a segment that has been buffered and so it's
	    // position is known precisely
	    return forward.result;
	  } // return the less-precise, playlist-based duration estimate
	
	
	  return backward.result + expired;
	};
	/**
	  * Calculates the duration of a playlist. If a start and end index
	  * are specified, the duration will be for the subset of the media
	  * timeline between those two indices. The total duration for live
	  * playlists is always Infinity.
	  *
	  * @param {Object} playlist a media playlist object
	  * @param {number=} endSequence an exclusive upper
	  * boundary for the playlist. Defaults to the playlist media
	  * sequence number plus its length.
	  * @param {number=} expired the amount of time that has
	  * dropped off the front of the playlist in a live scenario
	  * @return {number} the duration between the start index and end
	  * index.
	  */
	
	
	var duration = function duration(playlist, endSequence, expired) {
	  if (!playlist) {
	    return 0;
	  }
	
	  if (typeof expired !== 'number') {
	    expired = 0;
	  } // if a slice of the total duration is not requested, use
	  // playlist-level duration indicators when they're present
	
	
	  if (typeof endSequence === 'undefined') {
	    // if present, use the duration specified in the playlist
	    if (playlist.totalDuration) {
	      return playlist.totalDuration;
	    } // duration should be Infinity for live playlists
	
	
	    if (!playlist.endList) {
	      return window__default['default'].Infinity;
	    }
	  } // calculate the total duration based on the segment durations
	
	
	  return intervalDuration(playlist, endSequence, expired);
	};
	/**
	  * Calculate the time between two indexes in the current playlist
	  * neight the start- nor the end-index need to be within the current
	  * playlist in which case, the targetDuration of the playlist is used
	  * to approximate the durations of the segments
	  *
	  * @param {Array} options.durationList list to iterate over for durations.
	  * @param {number} options.defaultDuration duration to use for elements before or after the durationList
	  * @param {number} options.startIndex partsAndSegments index to start
	  * @param {number} options.endIndex partsAndSegments index to end.
	  * @return {number} the number of seconds between startIndex and endIndex
	  */
	
	
	var sumDurations = function sumDurations(_ref2) {
	  var defaultDuration = _ref2.defaultDuration,
	      durationList = _ref2.durationList,
	      startIndex = _ref2.startIndex,
	      endIndex = _ref2.endIndex;
	  var durations = 0;
	
	  if (startIndex > endIndex) {
	    var _ref3 = [endIndex, startIndex];
	    startIndex = _ref3[0];
	    endIndex = _ref3[1];
	  }
	
	  if (startIndex < 0) {
	    for (var i = startIndex; i < Math.min(0, endIndex); i++) {
	      durations += defaultDuration;
	    }
	
	    startIndex = 0;
	  }
	
	  for (var _i = startIndex; _i < endIndex; _i++) {
	    durations += durationList[_i].duration;
	  }
	
	  return durations;
	};
	/**
	 * Calculates the playlist end time
	 *
	 * @param {Object} playlist a media playlist object
	 * @param {number=} expired the amount of time that has
	 *                  dropped off the front of the playlist in a live scenario
	 * @param {boolean|false} useSafeLiveEnd a boolean value indicating whether or not the
	 *                        playlist end calculation should consider the safe live end
	 *                        (truncate the playlist end by three segments). This is normally
	 *                        used for calculating the end of the playlist's seekable range.
	 *                        This takes into account the value of liveEdgePadding.
	 *                        Setting liveEdgePadding to 0 is equivalent to setting this to false.
	 * @param {number} liveEdgePadding a number indicating how far from the end of the playlist we should be in seconds.
	 *                 If this is provided, it is used in the safe live end calculation.
	 *                 Setting useSafeLiveEnd=false or liveEdgePadding=0 are equivalent.
	 *                 Corresponds to suggestedPresentationDelay in DASH manifests.
	 * @return {number} the end time of playlist
	 * @function playlistEnd
	 */
	
	
	var playlistEnd = function playlistEnd(playlist, expired, useSafeLiveEnd, liveEdgePadding) {
	  if (!playlist || !playlist.segments) {
	    return null;
	  }
	
	  if (playlist.endList) {
	    return duration(playlist);
	  }
	
	  if (expired === null) {
	    return null;
	  }
	
	  expired = expired || 0;
	  var lastSegmentEndTime = intervalDuration(playlist, playlist.mediaSequence + playlist.segments.length, expired);
	
	  if (useSafeLiveEnd) {
	    liveEdgePadding = typeof liveEdgePadding === 'number' ? liveEdgePadding : liveEdgeDelay(null, playlist);
	    lastSegmentEndTime -= liveEdgePadding;
	  } // don't return a time less than zero
	
	
	  return Math.max(0, lastSegmentEndTime);
	};
	/**
	  * Calculates the interval of time that is currently seekable in a
	  * playlist. The returned time ranges are relative to the earliest
	  * moment in the specified playlist that is still available. A full
	  * seekable implementation for live streams would need to offset
	  * these values by the duration of content that has expired from the
	  * stream.
	  *
	  * @param {Object} playlist a media playlist object
	  * dropped off the front of the playlist in a live scenario
	  * @param {number=} expired the amount of time that has
	  * dropped off the front of the playlist in a live scenario
	  * @param {number} liveEdgePadding how far from the end of the playlist we should be in seconds.
	  *        Corresponds to suggestedPresentationDelay in DASH manifests.
	  * @return {TimeRanges} the periods of time that are valid targets
	  * for seeking
	  */
	
	
	var seekable = function seekable(playlist, expired, liveEdgePadding) {
	  var useSafeLiveEnd = true;
	  var seekableStart = expired || 0;
	  var seekableEnd = playlistEnd(playlist, expired, useSafeLiveEnd, liveEdgePadding);
	
	  if (seekableEnd === null) {
	    return createTimeRange();
	  }
	
	  return createTimeRange(seekableStart, seekableEnd);
	};
	/**
	 * Determine the index and estimated starting time of the segment that
	 * contains a specified playback position in a media playlist.
	 *
	 * @param {Object} options.playlist the media playlist to query
	 * @param {number} options.currentTime The number of seconds since the earliest
	 * possible position to determine the containing segment for
	 * @param {number} options.startTime the time when the segment/part starts
	 * @param {number} options.startingSegmentIndex the segment index to start looking at.
	 * @param {number?} [options.startingPartIndex] the part index to look at within the segment.
	 *
	 * @return {Object} an object with partIndex, segmentIndex, and startTime.
	 */
	
	
	var getMediaInfoForTime = function getMediaInfoForTime(_ref4) {
	  var playlist = _ref4.playlist,
	      currentTime = _ref4.currentTime,
	      startingSegmentIndex = _ref4.startingSegmentIndex,
	      startingPartIndex = _ref4.startingPartIndex,
	      startTime = _ref4.startTime,
	      experimentalExactManifestTimings = _ref4.experimentalExactManifestTimings;
	  var time = currentTime - startTime;
	  var partsAndSegments = getPartsAndSegments(playlist);
	  var startIndex = 0;
	
	  for (var i = 0; i < partsAndSegments.length; i++) {
	    var partAndSegment = partsAndSegments[i];
	
	    if (startingSegmentIndex !== partAndSegment.segmentIndex) {
	      continue;
	    } // skip this if part index does not match.
	
	
	    if (typeof startingPartIndex === 'number' && typeof partAndSegment.partIndex === 'number' && startingPartIndex !== partAndSegment.partIndex) {
	      continue;
	    }
	
	    startIndex = i;
	    break;
	  }
	
	  if (time < 0) {
	    // Walk backward from startIndex in the playlist, adding durations
	    // until we find a segment that contains `time` and return it
	    if (startIndex > 0) {
	      for (var _i2 = startIndex - 1; _i2 >= 0; _i2--) {
	        var _partAndSegment = partsAndSegments[_i2];
	        time += _partAndSegment.duration;
	
	        if (experimentalExactManifestTimings) {
	          if (time < 0) {
	            continue;
	          }
	        } else if (time + TIME_FUDGE_FACTOR <= 0) {
	          continue;
	        }
	
	        return {
	          partIndex: _partAndSegment.partIndex,
	          segmentIndex: _partAndSegment.segmentIndex,
	          startTime: startTime - sumDurations({
	            defaultDuration: playlist.targetDuration,
	            durationList: partsAndSegments,
	            startIndex: startIndex,
	            endIndex: _i2
	          })
	        };
	      }
	    } // We were unable to find a good segment within the playlist
	    // so select the first segment
	
	
	    return {
	      partIndex: partsAndSegments[0] && partsAndSegments[0].partIndex || null,
	      segmentIndex: partsAndSegments[0] && partsAndSegments[0].segmentIndex || 0,
	      startTime: currentTime
	    };
	  } // When startIndex is negative, we first walk forward to first segment
	  // adding target durations. If we "run out of time" before getting to
	  // the first segment, return the first segment
	
	
	  if (startIndex < 0) {
	    for (var _i3 = startIndex; _i3 < 0; _i3++) {
	      time -= playlist.targetDuration;
	
	      if (time < 0) {
	        return {
	          partIndex: partsAndSegments[0] && partsAndSegments[0].partIndex || null,
	          segmentIndex: partsAndSegments[0] && partsAndSegments[0].segmentIndex || 0,
	          startTime: currentTime
	        };
	      }
	    }
	
	    startIndex = 0;
	  } // Walk forward from startIndex in the playlist, subtracting durations
	  // until we find a segment that contains `time` and return it
	
	
	  for (var _i4 = startIndex; _i4 < partsAndSegments.length; _i4++) {
	    var _partAndSegment2 = partsAndSegments[_i4];
	    time -= _partAndSegment2.duration;
	
	    if (experimentalExactManifestTimings) {
	      if (time > 0) {
	        continue;
	      }
	    } else if (time - TIME_FUDGE_FACTOR >= 0) {
	      continue;
	    }
	
	    return {
	      partIndex: _partAndSegment2.partIndex,
	      segmentIndex: _partAndSegment2.segmentIndex,
	      startTime: startTime + sumDurations({
	        defaultDuration: playlist.targetDuration,
	        durationList: partsAndSegments,
	        startIndex: startIndex,
	        endIndex: _i4
	      })
	    };
	  } // We are out of possible candidates so load the last one...
	
	
	  return {
	    segmentIndex: partsAndSegments[partsAndSegments.length - 1].segmentIndex,
	    partIndex: partsAndSegments[partsAndSegments.length - 1].partIndex,
	    startTime: currentTime
	  };
	};
	/**
	 * Check whether the playlist is blacklisted or not.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is blacklisted or not
	 * @function isBlacklisted
	 */
	
	
	var isBlacklisted = function isBlacklisted(playlist) {
	  return playlist.excludeUntil && playlist.excludeUntil > Date.now();
	};
	/**
	 * Check whether the playlist is compatible with current playback configuration or has
	 * been blacklisted permanently for being incompatible.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is incompatible or not
	 * @function isIncompatible
	 */
	
	
	var isIncompatible = function isIncompatible(playlist) {
	  return playlist.excludeUntil && playlist.excludeUntil === Infinity;
	};
	/**
	 * Check whether the playlist is enabled or not.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is enabled or not
	 * @function isEnabled
	 */
	
	
	var isEnabled = function isEnabled(playlist) {
	  var blacklisted = isBlacklisted(playlist);
	  return !playlist.disabled && !blacklisted;
	};
	/**
	 * Check whether the playlist has been manually disabled through the representations api.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is disabled manually or not
	 * @function isDisabled
	 */
	
	
	var isDisabled = function isDisabled(playlist) {
	  return playlist.disabled;
	};
	/**
	 * Returns whether the current playlist is an AES encrypted HLS stream
	 *
	 * @return {boolean} true if it's an AES encrypted HLS stream
	 */
	
	
	var isAes = function isAes(media) {
	  for (var i = 0; i < media.segments.length; i++) {
	    if (media.segments[i].key) {
	      return true;
	    }
	  }
	
	  return false;
	};
	/**
	 * Checks if the playlist has a value for the specified attribute
	 *
	 * @param {string} attr
	 *        Attribute to check for
	 * @param {Object} playlist
	 *        The media playlist object
	 * @return {boolean}
	 *         Whether the playlist contains a value for the attribute or not
	 * @function hasAttribute
	 */
	
	
	var hasAttribute = function hasAttribute(attr, playlist) {
	  return playlist.attributes && playlist.attributes[attr];
	};
	/**
	 * Estimates the time required to complete a segment download from the specified playlist
	 *
	 * @param {number} segmentDuration
	 *        Duration of requested segment
	 * @param {number} bandwidth
	 *        Current measured bandwidth of the player
	 * @param {Object} playlist
	 *        The media playlist object
	 * @param {number=} bytesReceived
	 *        Number of bytes already received for the request. Defaults to 0
	 * @return {number|NaN}
	 *         The estimated time to request the segment. NaN if bandwidth information for
	 *         the given playlist is unavailable
	 * @function estimateSegmentRequestTime
	 */
	
	
	var estimateSegmentRequestTime = function estimateSegmentRequestTime(segmentDuration, bandwidth, playlist, bytesReceived) {
	  if (bytesReceived === void 0) {
	    bytesReceived = 0;
	  }
	
	  if (!hasAttribute('BANDWIDTH', playlist)) {
	    return NaN;
	  }
	
	  var size = segmentDuration * playlist.attributes.BANDWIDTH;
	  return (size - bytesReceived * 8) / bandwidth;
	};
	/*
	 * Returns whether the current playlist is the lowest rendition
	 *
	 * @return {Boolean} true if on lowest rendition
	 */
	
	
	var isLowestEnabledRendition = function isLowestEnabledRendition(master, media) {
	  if (master.playlists.length === 1) {
	    return true;
	  }
	
	  var currentBandwidth = media.attributes.BANDWIDTH || Number.MAX_VALUE;
	  return master.playlists.filter(function (playlist) {
	    if (!isEnabled(playlist)) {
	      return false;
	    }
	
	    return (playlist.attributes.BANDWIDTH || 0) < currentBandwidth;
	  }).length === 0;
	};
	
	var playlistMatch = function playlistMatch(a, b) {
	  // both playlits are null
	  // or only one playlist is non-null
	  // no match
	  if (!a && !b || !a && b || a && !b) {
	    return false;
	  } // playlist objects are the same, match
	
	
	  if (a === b) {
	    return true;
	  } // first try to use id as it should be the most
	  // accurate
	
	
	  if (a.id && b.id && a.id === b.id) {
	    return true;
	  } // next try to use reslovedUri as it should be the
	  // second most accurate.
	
	
	  if (a.resolvedUri && b.resolvedUri && a.resolvedUri === b.resolvedUri) {
	    return true;
	  } // finally try to use uri as it should be accurate
	  // but might miss a few cases for relative uris
	
	
	  if (a.uri && b.uri && a.uri === b.uri) {
	    return true;
	  }
	
	  return false;
	};
	
	var someAudioVariant = function someAudioVariant(master, callback) {
	  var AUDIO = master && master.mediaGroups && master.mediaGroups.AUDIO || {};
	  var found = false;
	
	  for (var groupName in AUDIO) {
	    for (var label in AUDIO[groupName]) {
	      found = callback(AUDIO[groupName][label]);
	
	      if (found) {
	        break;
	      }
	    }
	
	    if (found) {
	      break;
	    }
	  }
	
	  return !!found;
	};
	
	var isAudioOnly = function isAudioOnly(master) {
	  // we are audio only if we have no main playlists but do
	  // have media group playlists.
	  if (!master || !master.playlists || !master.playlists.length) {
	    // without audio variants or playlists this
	    // is not an audio only master.
	    var found = someAudioVariant(master, function (variant) {
	      return variant.playlists && variant.playlists.length || variant.uri;
	    });
	    return found;
	  } // if every playlist has only an audio codec it is audio only
	
	
	  var _loop = function _loop(i) {
	    var playlist = master.playlists[i];
	    var CODECS = playlist.attributes && playlist.attributes.CODECS; // all codecs are audio, this is an audio playlist.
	
	    if (CODECS && CODECS.split(',').every(function (c) {
	      return codecs_js.isAudioCodec(c);
	    })) {
	      return "continue";
	    } // playlist is in an audio group it is audio only
	
	
	    var found = someAudioVariant(master, function (variant) {
	      return playlistMatch(playlist, variant);
	    });
	
	    if (found) {
	      return "continue";
	    } // if we make it here this playlist isn't audio and we
	    // are not audio only
	
	
	    return {
	      v: false
	    };
	  };
	
	  for (var i = 0; i < master.playlists.length; i++) {
	    var _ret = _loop(i);
	
	    if (_ret === "continue") continue;
	    if (typeof _ret === "object") return _ret.v;
	  } // if we make it past every playlist without returning, then
	  // this is an audio only playlist.
	
	
	  return true;
	}; // exports
	
	
	var Playlist = {
	  liveEdgeDelay: liveEdgeDelay,
	  duration: duration,
	  seekable: seekable,
	  getMediaInfoForTime: getMediaInfoForTime,
	  isEnabled: isEnabled,
	  isDisabled: isDisabled,
	  isBlacklisted: isBlacklisted,
	  isIncompatible: isIncompatible,
	  playlistEnd: playlistEnd,
	  isAes: isAes,
	  hasAttribute: hasAttribute,
	  estimateSegmentRequestTime: estimateSegmentRequestTime,
	  isLowestEnabledRendition: isLowestEnabledRendition,
	  isAudioOnly: isAudioOnly,
	  playlistMatch: playlistMatch,
	  segmentDurationWithParts: segmentDurationWithParts
	};
	var log = videojs.log;
	
	var createPlaylistID = function createPlaylistID(index, uri) {
	  return index + "-" + uri;
	}; // default function for creating a group id
	
	
	var groupID = function groupID(type, group, label) {
	  return "placeholder-uri-" + type + "-" + group + "-" + label;
	};
	/**
	 * Parses a given m3u8 playlist
	 *
	 * @param {Function} [onwarn]
	 *        a function to call when the parser triggers a warning event.
	 * @param {Function} [oninfo]
	 *        a function to call when the parser triggers an info event.
	 * @param {string} manifestString
	 *        The downloaded manifest string
	 * @param {Object[]} [customTagParsers]
	 *        An array of custom tag parsers for the m3u8-parser instance
	 * @param {Object[]} [customTagMappers]
	 *        An array of custom tag mappers for the m3u8-parser instance
	 * @param {boolean} [experimentalLLHLS=false]
	 *        Whether to keep ll-hls features in the manifest after parsing.
	 * @return {Object}
	 *         The manifest object
	 */
	
	
	var parseManifest = function parseManifest(_ref) {
	  var onwarn = _ref.onwarn,
	      oninfo = _ref.oninfo,
	      manifestString = _ref.manifestString,
	      _ref$customTagParsers = _ref.customTagParsers,
	      customTagParsers = _ref$customTagParsers === void 0 ? [] : _ref$customTagParsers,
	      _ref$customTagMappers = _ref.customTagMappers,
	      customTagMappers = _ref$customTagMappers === void 0 ? [] : _ref$customTagMappers,
	      experimentalLLHLS = _ref.experimentalLLHLS;
	  var parser = new m3u8Parser.Parser();
	
	  if (onwarn) {
	    parser.on('warn', onwarn);
	  }
	
	  if (oninfo) {
	    parser.on('info', oninfo);
	  }
	
	  customTagParsers.forEach(function (customParser) {
	    return parser.addParser(customParser);
	  });
	  customTagMappers.forEach(function (mapper) {
	    return parser.addTagMapper(mapper);
	  });
	  parser.push(manifestString);
	  parser.end();
	  var manifest = parser.manifest; // remove llhls features from the parsed manifest
	  // if we don't want llhls support.
	
	  if (!experimentalLLHLS) {
	    ['preloadSegment', 'skip', 'serverControl', 'renditionReports', 'partInf', 'partTargetDuration'].forEach(function (k) {
	      if (manifest.hasOwnProperty(k)) {
	        delete manifest[k];
	      }
	    });
	
	    if (manifest.segments) {
	      manifest.segments.forEach(function (segment) {
	        ['parts', 'preloadHints'].forEach(function (k) {
	          if (segment.hasOwnProperty(k)) {
	            delete segment[k];
	          }
	        });
	      });
	    }
	  }
	
	  if (!manifest.targetDuration) {
	    var targetDuration = 10;
	
	    if (manifest.segments && manifest.segments.length) {
	      targetDuration = manifest.segments.reduce(function (acc, s) {
	        return Math.max(acc, s.duration);
	      }, 0);
	    }
	
	    if (onwarn) {
	      onwarn("manifest has no targetDuration defaulting to " + targetDuration);
	    }
	
	    manifest.targetDuration = targetDuration;
	  }
	
	  var parts = getLastParts(manifest);
	
	  if (parts.length && !manifest.partTargetDuration) {
	    var partTargetDuration = parts.reduce(function (acc, p) {
	      return Math.max(acc, p.duration);
	    }, 0);
	
	    if (onwarn) {
	      onwarn("manifest has no partTargetDuration defaulting to " + partTargetDuration);
	      log.error('LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.');
	    }
	
	    manifest.partTargetDuration = partTargetDuration;
	  }
	
	  return manifest;
	};
	/**
	 * Loops through all supported media groups in master and calls the provided
	 * callback for each group
	 *
	 * @param {Object} master
	 *        The parsed master manifest object
	 * @param {Function} callback
	 *        Callback to call for each media group
	 */
	
	
	var forEachMediaGroup = function forEachMediaGroup(master, callback) {
	  if (!master.mediaGroups) {
	    return;
	  }
	
	  ['AUDIO', 'SUBTITLES'].forEach(function (mediaType) {
	    if (!master.mediaGroups[mediaType]) {
	      return;
	    }
	
	    for (var groupKey in master.mediaGroups[mediaType]) {
	      for (var labelKey in master.mediaGroups[mediaType][groupKey]) {
	        var mediaProperties = master.mediaGroups[mediaType][groupKey][labelKey];
	        callback(mediaProperties, mediaType, groupKey, labelKey);
	      }
	    }
	  });
	};
	/**
	 * Adds properties and attributes to the playlist to keep consistent functionality for
	 * playlists throughout VHS.
	 *
	 * @param {Object} config
	 *        Arguments object
	 * @param {Object} config.playlist
	 *        The media playlist
	 * @param {string} [config.uri]
	 *        The uri to the media playlist (if media playlist is not from within a master
	 *        playlist)
	 * @param {string} id
	 *        ID to use for the playlist
	 */
	
	
	var setupMediaPlaylist = function setupMediaPlaylist(_ref2) {
	  var playlist = _ref2.playlist,
	      uri = _ref2.uri,
	      id = _ref2.id;
	  playlist.id = id;
	  playlist.playlistErrors_ = 0;
	
	  if (uri) {
	    // For media playlists, m3u8-parser does not have access to a URI, as HLS media
	    // playlists do not contain their own source URI, but one is needed for consistency in
	    // VHS.
	    playlist.uri = uri;
	  } // For HLS master playlists, even though certain attributes MUST be defined, the
	  // stream may still be played without them.
	  // For HLS media playlists, m3u8-parser does not attach an attributes object to the
	  // manifest.
	  //
	  // To avoid undefined reference errors through the project, and make the code easier
	  // to write/read, add an empty attributes object for these cases.
	
	
	  playlist.attributes = playlist.attributes || {};
	};
	/**
	 * Adds ID, resolvedUri, and attributes properties to each playlist of the master, where
	 * necessary. In addition, creates playlist IDs for each playlist and adds playlist ID to
	 * playlist references to the playlists array.
	 *
	 * @param {Object} master
	 *        The master playlist
	 */
	
	
	var setupMediaPlaylists = function setupMediaPlaylists(master) {
	  var i = master.playlists.length;
	
	  while (i--) {
	    var playlist = master.playlists[i];
	    setupMediaPlaylist({
	      playlist: playlist,
	      id: createPlaylistID(i, playlist.uri)
	    });
	    playlist.resolvedUri = resolveUrl(master.uri, playlist.uri);
	    master.playlists[playlist.id] = playlist; // URI reference added for backwards compatibility
	
	    master.playlists[playlist.uri] = playlist; // Although the spec states an #EXT-X-STREAM-INF tag MUST have a BANDWIDTH attribute,
	    // the stream can be played without it. Although an attributes property may have been
	    // added to the playlist to prevent undefined references, issue a warning to fix the
	    // manifest.
	
	    if (!playlist.attributes.BANDWIDTH) {
	      log.warn('Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.');
	    }
	  }
	};
	/**
	 * Adds resolvedUri properties to each media group.
	 *
	 * @param {Object} master
	 *        The master playlist
	 */
	
	
	var resolveMediaGroupUris = function resolveMediaGroupUris(master) {
	  forEachMediaGroup(master, function (properties) {
	    if (properties.uri) {
	      properties.resolvedUri = resolveUrl(master.uri, properties.uri);
	    }
	  });
	};
	/**
	 * Creates a master playlist wrapper to insert a sole media playlist into.
	 *
	 * @param {Object} media
	 *        Media playlist
	 * @param {string} uri
	 *        The media URI
	 *
	 * @return {Object}
	 *         Master playlist
	 */
	
	
	var masterForMedia = function masterForMedia(media, uri) {
	  var id = createPlaylistID(0, uri);
	  var master = {
	    mediaGroups: {
	      'AUDIO': {},
	      'VIDEO': {},
	      'CLOSED-CAPTIONS': {},
	      'SUBTITLES': {}
	    },
	    uri: window__default['default'].location.href,
	    resolvedUri: window__default['default'].location.href,
	    playlists: [{
	      uri: uri,
	      id: id,
	      resolvedUri: uri,
	      // m3u8-parser does not attach an attributes property to media playlists so make
	      // sure that the property is attached to avoid undefined reference errors
	      attributes: {}
	    }]
	  }; // set up ID reference
	
	  master.playlists[id] = master.playlists[0]; // URI reference added for backwards compatibility
	
	  master.playlists[uri] = master.playlists[0];
	  return master;
	};
	/**
	 * Does an in-place update of the master manifest to add updated playlist URI references
	 * as well as other properties needed by VHS that aren't included by the parser.
	 *
	 * @param {Object} master
	 *        Master manifest object
	 * @param {string} uri
	 *        The source URI
	 * @param {function} createGroupID
	 *        A function to determine how to create the groupID for mediaGroups
	 */
	
	
	var addPropertiesToMaster = function addPropertiesToMaster(master, uri, createGroupID) {
	  if (createGroupID === void 0) {
	    createGroupID = groupID;
	  }
	
	  master.uri = uri;
	
	  for (var i = 0; i < master.playlists.length; i++) {
	    if (!master.playlists[i].uri) {
	      // Set up phony URIs for the playlists since playlists are referenced by their URIs
	      // throughout VHS, but some formats (e.g., DASH) don't have external URIs
	      // TODO: consider adding dummy URIs in mpd-parser
	      var phonyUri = "placeholder-uri-" + i;
	      master.playlists[i].uri = phonyUri;
	    }
	  }
	
	  var audioOnlyMaster = isAudioOnly(master);
	  forEachMediaGroup(master, function (properties, mediaType, groupKey, labelKey) {
	    // add a playlist array under properties
	    if (!properties.playlists || !properties.playlists.length) {
	      // If the manifest is audio only and this media group does not have a uri, check
	      // if the media group is located in the main list of playlists. If it is, don't add
	      // placeholder properties as it shouldn't be considered an alternate audio track.
	      if (audioOnlyMaster && mediaType === 'AUDIO' && !properties.uri) {
	        for (var _i = 0; _i < master.playlists.length; _i++) {
	          var p = master.playlists[_i];
	
	          if (p.attributes && p.attributes.AUDIO && p.attributes.AUDIO === groupKey) {
	            return;
	          }
	        }
	      }
	
	      properties.playlists = [_extends__default['default']({}, properties)];
	    }
	
	    properties.playlists.forEach(function (p, i) {
	      var groupId = createGroupID(mediaType, groupKey, labelKey, p);
	      var id = createPlaylistID(i, groupId);
	
	      if (p.uri) {
	        p.resolvedUri = p.resolvedUri || resolveUrl(master.uri, p.uri);
	      } else {
	        // DEPRECATED, this has been added to prevent a breaking change.
	        // previously we only ever had a single media group playlist, so
	        // we mark the first playlist uri without prepending the index as we used to
	        // ideally we would do all of the playlists the same way.
	        p.uri = i === 0 ? groupId : id; // don't resolve a placeholder uri to an absolute url, just use
	        // the placeholder again
	
	        p.resolvedUri = p.uri;
	      }
	
	      p.id = p.id || id; // add an empty attributes object, all playlists are
	      // expected to have this.
	
	      p.attributes = p.attributes || {}; // setup ID and URI references (URI for backwards compatibility)
	
	      master.playlists[p.id] = p;
	      master.playlists[p.uri] = p;
	    });
	  });
	  setupMediaPlaylists(master);
	  resolveMediaGroupUris(master);
	};
	
	var mergeOptions$2 = videojs.mergeOptions,
	    EventTarget$1 = videojs.EventTarget;
	
	var addLLHLSQueryDirectives = function addLLHLSQueryDirectives(uri, media) {
	  if (media.endList || !media.serverControl) {
	    return uri;
	  }
	
	  var parameters = {};
	
	  if (media.serverControl.canBlockReload) {
	    var preloadSegment = media.preloadSegment; // next msn is a zero based value, length is not.
	
	    var nextMSN = media.mediaSequence + media.segments.length; // If preload segment has parts then it is likely
	    // that we are going to request a part of that preload segment.
	    // the logic below is used to determine that.
	
	    if (preloadSegment) {
	      var parts = preloadSegment.parts || []; // _HLS_part is a zero based index
	
	      var nextPart = getKnownPartCount(media) - 1; // if nextPart is > -1 and not equal to just the
	      // length of parts, then we know we had part preload hints
	      // and we need to add the _HLS_part= query
	
	      if (nextPart > -1 && nextPart !== parts.length - 1) {
	        // add existing parts to our preload hints
	        // eslint-disable-next-line
	        parameters._HLS_part = nextPart;
	      } // this if statement makes sure that we request the msn
	      // of the preload segment if:
	      // 1. the preload segment had parts (and was not yet a full segment)
	      //    but was added to our segments array
	      // 2. the preload segment had preload hints for parts that are not in
	      //    the manifest yet.
	      // in all other cases we want the segment after the preload segment
	      // which will be given by using media.segments.length because it is 1 based
	      // rather than 0 based.
	
	
	      if (nextPart > -1 || parts.length) {
	        nextMSN--;
	      }
	    } // add _HLS_msn= in front of any _HLS_part query
	    // eslint-disable-next-line
	
	
	    parameters._HLS_msn = nextMSN;
	  }
	
	  if (media.serverControl && media.serverControl.canSkipUntil) {
	    // add _HLS_skip= infront of all other queries.
	    // eslint-disable-next-line
	    parameters._HLS_skip = media.serverControl.canSkipDateranges ? 'v2' : 'YES';
	  }
	
	  if (Object.keys(parameters).length) {
	    var parsedUri = new window__default['default'].URL(uri);
	    ['_HLS_skip', '_HLS_msn', '_HLS_part'].forEach(function (name) {
	      if (!parameters.hasOwnProperty(name)) {
	        return;
	      }
	
	      parsedUri.searchParams.set(name, parameters[name]);
	    });
	    uri = parsedUri.toString();
	  }
	
	  return uri;
	};
	/**
	 * Returns a new segment object with properties and
	 * the parts array merged.
	 *
	 * @param {Object} a the old segment
	 * @param {Object} b the new segment
	 *
	 * @return {Object} the merged segment
	 */
	
	
	var updateSegment = function updateSegment(a, b) {
	  if (!a) {
	    return b;
	  }
	
	  var result = mergeOptions$2(a, b); // if only the old segment has preload hints
	  // and the new one does not, remove preload hints.
	
	  if (a.preloadHints && !b.preloadHints) {
	    delete result.preloadHints;
	  } // if only the old segment has parts
	  // then the parts are no longer valid
	
	
	  if (a.parts && !b.parts) {
	    delete result.parts; // if both segments have parts
	    // copy part propeties from the old segment
	    // to the new one.
	  } else if (a.parts && b.parts) {
	    for (var i = 0; i < b.parts.length; i++) {
	      if (a.parts && a.parts[i]) {
	        result.parts[i] = mergeOptions$2(a.parts[i], b.parts[i]);
	      }
	    }
	  } // set skipped to false for segments that have
	  // have had information merged from the old segment.
	
	
	  if (!a.skipped && b.skipped) {
	    result.skipped = false;
	  } // set preload to false for segments that have
	  // had information added in the new segment.
	
	
	  if (a.preload && !b.preload) {
	    result.preload = false;
	  }
	
	  return result;
	};
	/**
	 * Returns a new array of segments that is the result of merging
	 * properties from an older list of segments onto an updated
	 * list. No properties on the updated playlist will be ovewritten.
	 *
	 * @param {Array} original the outdated list of segments
	 * @param {Array} update the updated list of segments
	 * @param {number=} offset the index of the first update
	 * segment in the original segment list. For non-live playlists,
	 * this should always be zero and does not need to be
	 * specified. For live playlists, it should be the difference
	 * between the media sequence numbers in the original and updated
	 * playlists.
	 * @return {Array} a list of merged segment objects
	 */
	
	
	var updateSegments = function updateSegments(original, update, offset) {
	  var oldSegments = original.slice();
	  var newSegments = update.slice();
	  offset = offset || 0;
	  var result = [];
	  var currentMap;
	
	  for (var newIndex = 0; newIndex < newSegments.length; newIndex++) {
	    var oldSegment = oldSegments[newIndex + offset];
	    var newSegment = newSegments[newIndex];
	
	    if (oldSegment) {
	      currentMap = oldSegment.map || currentMap;
	      result.push(updateSegment(oldSegment, newSegment));
	    } else {
	      // carry over map to new segment if it is missing
	      if (currentMap && !newSegment.map) {
	        newSegment.map = currentMap;
	      }
	
	      result.push(newSegment);
	    }
	  }
	
	  return result;
	};
	
	var resolveSegmentUris = function resolveSegmentUris(segment, baseUri) {
	  // preloadSegment will not have a uri at all
	  // as the segment isn't actually in the manifest yet, only parts
	  if (!segment.resolvedUri && segment.uri) {
	    segment.resolvedUri = resolveUrl(baseUri, segment.uri);
	  }
	
	  if (segment.key && !segment.key.resolvedUri) {
	    segment.key.resolvedUri = resolveUrl(baseUri, segment.key.uri);
	  }
	
	  if (segment.map && !segment.map.resolvedUri) {
	    segment.map.resolvedUri = resolveUrl(baseUri, segment.map.uri);
	  }
	
	  if (segment.map && segment.map.key && !segment.map.key.resolvedUri) {
	    segment.map.key.resolvedUri = resolveUrl(baseUri, segment.map.key.uri);
	  }
	
	  if (segment.parts && segment.parts.length) {
	    segment.parts.forEach(function (p) {
	      if (p.resolvedUri) {
	        return;
	      }
	
	      p.resolvedUri = resolveUrl(baseUri, p.uri);
	    });
	  }
	
	  if (segment.preloadHints && segment.preloadHints.length) {
	    segment.preloadHints.forEach(function (p) {
	      if (p.resolvedUri) {
	        return;
	      }
	
	      p.resolvedUri = resolveUrl(baseUri, p.uri);
	    });
	  }
	};
	
	var getAllSegments = function getAllSegments(media) {
	  var segments = media.segments || [];
	  var preloadSegment = media.preloadSegment; // a preloadSegment with only preloadHints is not currently
	  // a usable segment, only include a preloadSegment that has
	  // parts.
	
	  if (preloadSegment && preloadSegment.parts && preloadSegment.parts.length) {
	    // if preloadHints has a MAP that means that the
	    // init segment is going to change. We cannot use any of the parts
	    // from this preload segment.
	    if (preloadSegment.preloadHints) {
	      for (var i = 0; i < preloadSegment.preloadHints.length; i++) {
	        if (preloadSegment.preloadHints[i].type === 'MAP') {
	          return segments;
	        }
	      }
	    } // set the duration for our preload segment to target duration.
	
	
	    preloadSegment.duration = media.targetDuration;
	    preloadSegment.preload = true;
	    segments.push(preloadSegment);
	  }
	
	  return segments;
	}; // consider the playlist unchanged if the playlist object is the same or
	// the number of segments is equal, the media sequence number is unchanged,
	// and this playlist hasn't become the end of the playlist
	
	
	var isPlaylistUnchanged = function isPlaylistUnchanged(a, b) {
	  return a === b || a.segments && b.segments && a.segments.length === b.segments.length && a.endList === b.endList && a.mediaSequence === b.mediaSequence && a.preloadSegment === b.preloadSegment;
	};
	/**
	  * Returns a new master playlist that is the result of merging an
	  * updated media playlist into the original version. If the
	  * updated media playlist does not match any of the playlist
	  * entries in the original master playlist, null is returned.
	  *
	  * @param {Object} master a parsed master M3U8 object
	  * @param {Object} media a parsed media M3U8 object
	  * @return {Object} a new object that represents the original
	  * master playlist with the updated media playlist merged in, or
	  * null if the merge produced no change.
	  */
	
	
	var updateMaster$1 = function updateMaster(master, newMedia, unchangedCheck) {
	  if (unchangedCheck === void 0) {
	    unchangedCheck = isPlaylistUnchanged;
	  }
	
	  var result = mergeOptions$2(master, {});
	  var oldMedia = result.playlists[newMedia.id];
	
	  if (!oldMedia) {
	    return null;
	  }
	
	  if (unchangedCheck(oldMedia, newMedia)) {
	    return null;
	  }
	
	  newMedia.segments = getAllSegments(newMedia);
	  var mergedPlaylist = mergeOptions$2(oldMedia, newMedia); // always use the new media's preload segment
	
	  if (mergedPlaylist.preloadSegment && !newMedia.preloadSegment) {
	    delete mergedPlaylist.preloadSegment;
	  } // if the update could overlap existing segment information, merge the two segment lists
	
	
	  if (oldMedia.segments) {
	    if (newMedia.skip) {
	      newMedia.segments = newMedia.segments || []; // add back in objects for skipped segments, so that we merge
	      // old properties into the new segments
	
	      for (var i = 0; i < newMedia.skip.skippedSegments; i++) {
	        newMedia.segments.unshift({
	          skipped: true
	        });
	      }
	    }
	
	    mergedPlaylist.segments = updateSegments(oldMedia.segments, newMedia.segments, newMedia.mediaSequence - oldMedia.mediaSequence);
	  } // resolve any segment URIs to prevent us from having to do it later
	
	
	  mergedPlaylist.segments.forEach(function (segment) {
	    resolveSegmentUris(segment, mergedPlaylist.resolvedUri);
	  }); // TODO Right now in the playlists array there are two references to each playlist, one
	  // that is referenced by index, and one by URI. The index reference may no longer be
	  // necessary.
	
	  for (var _i = 0; _i < result.playlists.length; _i++) {
	    if (result.playlists[_i].id === newMedia.id) {
	      result.playlists[_i] = mergedPlaylist;
	    }
	  }
	
	  result.playlists[newMedia.id] = mergedPlaylist; // URI reference added for backwards compatibility
	
	  result.playlists[newMedia.uri] = mergedPlaylist; // update media group playlist references.
	
	  forEachMediaGroup(master, function (properties, mediaType, groupKey, labelKey) {
	    if (!properties.playlists) {
	      return;
	    }
	
	    for (var _i2 = 0; _i2 < properties.playlists.length; _i2++) {
	      if (newMedia.id === properties.playlists[_i2].id) {
	        properties.playlists[_i2] = mergedPlaylist;
	      }
	    }
	  });
	  return result;
	};
	/**
	 * Calculates the time to wait before refreshing a live playlist
	 *
	 * @param {Object} media
	 *        The current media
	 * @param {boolean} update
	 *        True if there were any updates from the last refresh, false otherwise
	 * @return {number}
	 *         The time in ms to wait before refreshing the live playlist
	 */
	
	
	var refreshDelay = function refreshDelay(media, update) {
	  var segments = media.segments || [];
	  var lastSegment = segments[segments.length - 1];
	  var lastPart = lastSegment && lastSegment.parts && lastSegment.parts[lastSegment.parts.length - 1];
	  var lastDuration = lastPart && lastPart.duration || lastSegment && lastSegment.duration;
	
	  if (update && lastDuration) {
	    return lastDuration * 1000;
	  } // if the playlist is unchanged since the last reload or last segment duration
	  // cannot be determined, try again after half the target duration
	
	
	  return (media.partTargetDuration || media.targetDuration || 10) * 500;
	};
	/**
	 * Load a playlist from a remote location
	 *
	 * @class PlaylistLoader
	 * @extends Stream
	 * @param {string|Object} src url or object of manifest
	 * @param {boolean} withCredentials the withCredentials xhr option
	 * @class
	 */
	
	
	var PlaylistLoader = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](PlaylistLoader, _EventTarget);
	
	  function PlaylistLoader(src, vhs, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _EventTarget.call(this) || this;
	
	    if (!src) {
	      throw new Error('A non-empty playlist URL or object is required');
	    }
	
	    _this.logger_ = logger('PlaylistLoader');
	    var _options = options,
	        _options$withCredenti = _options.withCredentials,
	        withCredentials = _options$withCredenti === void 0 ? false : _options$withCredenti,
	        _options$handleManife = _options.handleManifestRedirects,
	        handleManifestRedirects = _options$handleManife === void 0 ? false : _options$handleManife;
	    _this.src = src;
	    _this.vhs_ = vhs;
	    _this.withCredentials = withCredentials;
	    _this.handleManifestRedirects = handleManifestRedirects;
	    var vhsOptions = vhs.options_;
	    _this.customTagParsers = vhsOptions && vhsOptions.customTagParsers || [];
	    _this.customTagMappers = vhsOptions && vhsOptions.customTagMappers || [];
	    _this.experimentalLLHLS = vhsOptions && vhsOptions.experimentalLLHLS || false; // force experimentalLLHLS for IE 11
	
	    if (videojs.browser.IE_VERSION) {
	      _this.experimentalLLHLS = false;
	    } // initialize the loader state
	
	
	    _this.state = 'HAVE_NOTHING'; // live playlist staleness timeout
	
	    _this.handleMediaupdatetimeout_ = _this.handleMediaupdatetimeout_.bind(_assertThisInitialized__default['default'](_this));
	
	    _this.on('mediaupdatetimeout', _this.handleMediaupdatetimeout_);
	
	    return _this;
	  }
	
	  var _proto = PlaylistLoader.prototype;
	
	  _proto.handleMediaupdatetimeout_ = function handleMediaupdatetimeout_() {
	    var _this2 = this;
	
	    if (this.state !== 'HAVE_METADATA') {
	      // only refresh the media playlist if no other activity is going on
	      return;
	    }
	
	    var media = this.media();
	    var uri = resolveUrl(this.master.uri, media.uri);
	
	    if (this.experimentalLLHLS) {
	      uri = addLLHLSQueryDirectives(uri, media);
	    }
	
	    this.state = 'HAVE_CURRENT_METADATA';
	    this.request = this.vhs_.xhr({
	      uri: uri,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      // disposed
	      if (!_this2.request) {
	        return;
	      }
	
	      if (error) {
	        return _this2.playlistRequestError(_this2.request, _this2.media(), 'HAVE_METADATA');
	      }
	
	      _this2.haveMetadata({
	        playlistString: _this2.request.responseText,
	        url: _this2.media().uri,
	        id: _this2.media().id
	      });
	    });
	  };
	
	  _proto.playlistRequestError = function playlistRequestError(xhr, playlist, startingState) {
	    var uri = playlist.uri,
	        id = playlist.id; // any in-flight request is now finished
	
	    this.request = null;
	
	    if (startingState) {
	      this.state = startingState;
	    }
	
	    this.error = {
	      playlist: this.master.playlists[id],
	      status: xhr.status,
	      message: "HLS playlist request error at URL: " + uri + ".",
	      responseText: xhr.responseText,
	      code: xhr.status >= 500 ? 4 : 2
	    };
	    this.trigger('error');
	  };
	
	  _proto.parseManifest_ = function parseManifest_(_ref) {
	    var _this3 = this;
	
	    var url = _ref.url,
	        manifestString = _ref.manifestString;
	    return parseManifest({
	      onwarn: function onwarn(_ref2) {
	        var message = _ref2.message;
	        return _this3.logger_("m3u8-parser warn for " + url + ": " + message);
	      },
	      oninfo: function oninfo(_ref3) {
	        var message = _ref3.message;
	        return _this3.logger_("m3u8-parser info for " + url + ": " + message);
	      },
	      manifestString: manifestString,
	      customTagParsers: this.customTagParsers,
	      customTagMappers: this.customTagMappers,
	      experimentalLLHLS: this.experimentalLLHLS
	    });
	  }
	  /**
	   * Update the playlist loader's state in response to a new or updated playlist.
	   *
	   * @param {string} [playlistString]
	   *        Playlist string (if playlistObject is not provided)
	   * @param {Object} [playlistObject]
	   *        Playlist object (if playlistString is not provided)
	   * @param {string} url
	   *        URL of playlist
	   * @param {string} id
	   *        ID to use for playlist
	   */
	  ;
	
	  _proto.haveMetadata = function haveMetadata(_ref4) {
	    var playlistString = _ref4.playlistString,
	        playlistObject = _ref4.playlistObject,
	        url = _ref4.url,
	        id = _ref4.id; // any in-flight request is now finished
	
	    this.request = null;
	    this.state = 'HAVE_METADATA';
	    var playlist = playlistObject || this.parseManifest_({
	      url: url,
	      manifestString: playlistString
	    });
	    playlist.lastRequest = Date.now();
	    setupMediaPlaylist({
	      playlist: playlist,
	      uri: url,
	      id: id
	    }); // merge this playlist into the master
	
	    var update = updateMaster$1(this.master, playlist);
	    this.targetDuration = playlist.partTargetDuration || playlist.targetDuration;
	    this.pendingMedia_ = null;
	
	    if (update) {
	      this.master = update;
	      this.media_ = this.master.playlists[id];
	    } else {
	      this.trigger('playlistunchanged');
	    }
	
	    this.updateMediaUpdateTimeout_(refreshDelay(this.media(), !!update));
	    this.trigger('loadedplaylist');
	  }
	  /**
	    * Abort any outstanding work and clean up.
	    */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.stopRequest();
	    window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	    window__default['default'].clearTimeout(this.finalRenditionTimeout);
	    this.off();
	  };
	
	  _proto.stopRequest = function stopRequest() {
	    if (this.request) {
	      var oldRequest = this.request;
	      this.request = null;
	      oldRequest.onreadystatechange = null;
	      oldRequest.abort();
	    }
	  }
	  /**
	    * When called without any arguments, returns the currently
	    * active media playlist. When called with a single argument,
	    * triggers the playlist loader to asynchronously switch to the
	    * specified media playlist. Calling this method while the
	    * loader is in the HAVE_NOTHING causes an error to be emitted
	    * but otherwise has no effect.
	    *
	    * @param {Object=} playlist the parsed media playlist
	    * object to switch to
	    * @param {boolean=} shouldDelay whether we should delay the request by half target duration
	    *
	    * @return {Playlist} the current loaded media
	    */
	  ;
	
	  _proto.media = function media(playlist, shouldDelay) {
	    var _this4 = this; // getter
	
	
	    if (!playlist) {
	      return this.media_;
	    } // setter
	
	
	    if (this.state === 'HAVE_NOTHING') {
	      throw new Error('Cannot switch media playlist from ' + this.state);
	    } // find the playlist object if the target playlist has been
	    // specified by URI
	
	
	    if (typeof playlist === 'string') {
	      if (!this.master.playlists[playlist]) {
	        throw new Error('Unknown playlist URI: ' + playlist);
	      }
	
	      playlist = this.master.playlists[playlist];
	    }
	
	    window__default['default'].clearTimeout(this.finalRenditionTimeout);
	
	    if (shouldDelay) {
	      var delay = (playlist.partTargetDuration || playlist.targetDuration) / 2 * 1000 || 5 * 1000;
	      this.finalRenditionTimeout = window__default['default'].setTimeout(this.media.bind(this, playlist, false), delay);
	      return;
	    }
	
	    var startingState = this.state;
	    var mediaChange = !this.media_ || playlist.id !== this.media_.id;
	    var masterPlaylistRef = this.master.playlists[playlist.id]; // switch to fully loaded playlists immediately
	
	    if (masterPlaylistRef && masterPlaylistRef.endList || // handle the case of a playlist object (e.g., if using vhs-json with a resolved
	    // media playlist or, for the case of demuxed audio, a resolved audio media group)
	    playlist.endList && playlist.segments.length) {
	      // abort outstanding playlist requests
	      if (this.request) {
	        this.request.onreadystatechange = null;
	        this.request.abort();
	        this.request = null;
	      }
	
	      this.state = 'HAVE_METADATA';
	      this.media_ = playlist; // trigger media change if the active media has been updated
	
	      if (mediaChange) {
	        this.trigger('mediachanging');
	
	        if (startingState === 'HAVE_MASTER') {
	          // The initial playlist was a master manifest, and the first media selected was
	          // also provided (in the form of a resolved playlist object) as part of the
	          // source object (rather than just a URL). Therefore, since the media playlist
	          // doesn't need to be requested, loadedmetadata won't trigger as part of the
	          // normal flow, and needs an explicit trigger here.
	          this.trigger('loadedmetadata');
	        } else {
	          this.trigger('mediachange');
	        }
	      }
	
	      return;
	    } // We update/set the timeout here so that live playlists
	    // that are not a media change will "start" the loader as expected.
	    // We expect that this function will start the media update timeout
	    // cycle again. This also prevents a playlist switch failure from
	    // causing us to stall during live.
	
	
	    this.updateMediaUpdateTimeout_(refreshDelay(playlist, true)); // switching to the active playlist is a no-op
	
	    if (!mediaChange) {
	      return;
	    }
	
	    this.state = 'SWITCHING_MEDIA'; // there is already an outstanding playlist request
	
	    if (this.request) {
	      if (playlist.resolvedUri === this.request.url) {
	        // requesting to switch to the same playlist multiple times
	        // has no effect after the first
	        return;
	      }
	
	      this.request.onreadystatechange = null;
	      this.request.abort();
	      this.request = null;
	    } // request the new playlist
	
	
	    if (this.media_) {
	      this.trigger('mediachanging');
	    }
	
	    this.pendingMedia_ = playlist;
	    this.request = this.vhs_.xhr({
	      uri: playlist.resolvedUri,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      // disposed
	      if (!_this4.request) {
	        return;
	      }
	
	      playlist.lastRequest = Date.now();
	      playlist.resolvedUri = resolveManifestRedirect(_this4.handleManifestRedirects, playlist.resolvedUri, req);
	
	      if (error) {
	        return _this4.playlistRequestError(_this4.request, playlist, startingState);
	      }
	
	      _this4.haveMetadata({
	        playlistString: req.responseText,
	        url: playlist.uri,
	        id: playlist.id
	      }); // fire loadedmetadata the first time a media playlist is loaded
	
	
	      if (startingState === 'HAVE_MASTER') {
	        _this4.trigger('loadedmetadata');
	      } else {
	        _this4.trigger('mediachange');
	      }
	    });
	  }
	  /**
	   * pause loading of the playlist
	   */
	  ;
	
	  _proto.pause = function pause() {
	    if (this.mediaUpdateTimeout) {
	      window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	      this.mediaUpdateTimeout = null;
	    }
	
	    this.stopRequest();
	
	    if (this.state === 'HAVE_NOTHING') {
	      // If we pause the loader before any data has been retrieved, its as if we never
	      // started, so reset to an unstarted state.
	      this.started = false;
	    } // Need to restore state now that no activity is happening
	
	
	    if (this.state === 'SWITCHING_MEDIA') {
	      // if the loader was in the process of switching media, it should either return to
	      // HAVE_MASTER or HAVE_METADATA depending on if the loader has loaded a media
	      // playlist yet. This is determined by the existence of loader.media_
	      if (this.media_) {
	        this.state = 'HAVE_METADATA';
	      } else {
	        this.state = 'HAVE_MASTER';
	      }
	    } else if (this.state === 'HAVE_CURRENT_METADATA') {
	      this.state = 'HAVE_METADATA';
	    }
	  }
	  /**
	   * start loading of the playlist
	   */
	  ;
	
	  _proto.load = function load(shouldDelay) {
	    var _this5 = this;
	
	    if (this.mediaUpdateTimeout) {
	      window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	      this.mediaUpdateTimeout = null;
	    }
	
	    var media = this.media();
	
	    if (shouldDelay) {
	      var delay = media ? (media.partTargetDuration || media.targetDuration) / 2 * 1000 : 5 * 1000;
	      this.mediaUpdateTimeout = window__default['default'].setTimeout(function () {
	        _this5.mediaUpdateTimeout = null;
	
	        _this5.load();
	      }, delay);
	      return;
	    }
	
	    if (!this.started) {
	      this.start();
	      return;
	    }
	
	    if (media && !media.endList) {
	      this.trigger('mediaupdatetimeout');
	    } else {
	      this.trigger('loadedplaylist');
	    }
	  };
	
	  _proto.updateMediaUpdateTimeout_ = function updateMediaUpdateTimeout_(delay) {
	    var _this6 = this;
	
	    if (this.mediaUpdateTimeout) {
	      window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	      this.mediaUpdateTimeout = null;
	    } // we only have use mediaupdatetimeout for live playlists.
	
	
	    if (!this.media() || this.media().endList) {
	      return;
	    }
	
	    this.mediaUpdateTimeout = window__default['default'].setTimeout(function () {
	      _this6.mediaUpdateTimeout = null;
	
	      _this6.trigger('mediaupdatetimeout');
	
	      _this6.updateMediaUpdateTimeout_(delay);
	    }, delay);
	  }
	  /**
	   * start loading of the playlist
	   */
	  ;
	
	  _proto.start = function start() {
	    var _this7 = this;
	
	    this.started = true;
	
	    if (typeof this.src === 'object') {
	      // in the case of an entirely constructed manifest object (meaning there's no actual
	      // manifest on a server), default the uri to the page's href
	      if (!this.src.uri) {
	        this.src.uri = window__default['default'].location.href;
	      } // resolvedUri is added on internally after the initial request. Since there's no
	      // request for pre-resolved manifests, add on resolvedUri here.
	
	
	      this.src.resolvedUri = this.src.uri; // Since a manifest object was passed in as the source (instead of a URL), the first
	      // request can be skipped (since the top level of the manifest, at a minimum, is
	      // already available as a parsed manifest object). However, if the manifest object
	      // represents a master playlist, some media playlists may need to be resolved before
	      // the starting segment list is available. Therefore, go directly to setup of the
	      // initial playlist, and let the normal flow continue from there.
	      //
	      // Note that the call to setup is asynchronous, as other sections of VHS may assume
	      // that the first request is asynchronous.
	
	      setTimeout(function () {
	        _this7.setupInitialPlaylist(_this7.src);
	      }, 0);
	      return;
	    } // request the specified URL
	
	
	    this.request = this.vhs_.xhr({
	      uri: this.src,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      // disposed
	      if (!_this7.request) {
	        return;
	      } // clear the loader's request reference
	
	
	      _this7.request = null;
	
	      if (error) {
	        _this7.error = {
	          status: req.status,
	          message: "HLS playlist request error at URL: " + _this7.src + ".",
	          responseText: req.responseText,
	          // MEDIA_ERR_NETWORK
	          code: 2
	        };
	
	        if (_this7.state === 'HAVE_NOTHING') {
	          _this7.started = false;
	        }
	
	        return _this7.trigger('error');
	      }
	
	      _this7.src = resolveManifestRedirect(_this7.handleManifestRedirects, _this7.src, req);
	
	      var manifest = _this7.parseManifest_({
	        manifestString: req.responseText,
	        url: _this7.src
	      });
	
	      _this7.setupInitialPlaylist(manifest);
	    });
	  };
	
	  _proto.srcUri = function srcUri() {
	    return typeof this.src === 'string' ? this.src : this.src.uri;
	  }
	  /**
	   * Given a manifest object that's either a master or media playlist, trigger the proper
	   * events and set the state of the playlist loader.
	   *
	   * If the manifest object represents a master playlist, `loadedplaylist` will be
	   * triggered to allow listeners to select a playlist. If none is selected, the loader
	   * will default to the first one in the playlists array.
	   *
	   * If the manifest object represents a media playlist, `loadedplaylist` will be
	   * triggered followed by `loadedmetadata`, as the only available playlist is loaded.
	   *
	   * In the case of a media playlist, a master playlist object wrapper with one playlist
	   * will be created so that all logic can handle playlists in the same fashion (as an
	   * assumed manifest object schema).
	   *
	   * @param {Object} manifest
	   *        The parsed manifest object
	   */
	  ;
	
	  _proto.setupInitialPlaylist = function setupInitialPlaylist(manifest) {
	    this.state = 'HAVE_MASTER';
	
	    if (manifest.playlists) {
	      this.master = manifest;
	      addPropertiesToMaster(this.master, this.srcUri()); // If the initial master playlist has playlists wtih segments already resolved,
	      // then resolve URIs in advance, as they are usually done after a playlist request,
	      // which may not happen if the playlist is resolved.
	
	      manifest.playlists.forEach(function (playlist) {
	        playlist.segments = getAllSegments(playlist);
	        playlist.segments.forEach(function (segment) {
	          resolveSegmentUris(segment, playlist.resolvedUri);
	        });
	      });
	      this.trigger('loadedplaylist');
	
	      if (!this.request) {
	        // no media playlist was specifically selected so start
	        // from the first listed one
	        this.media(this.master.playlists[0]);
	      }
	
	      return;
	    } // In order to support media playlists passed in as vhs-json, the case where the uri
	    // is not provided as part of the manifest should be considered, and an appropriate
	    // default used.
	
	
	    var uri = this.srcUri() || window__default['default'].location.href;
	    this.master = masterForMedia(manifest, uri);
	    this.haveMetadata({
	      playlistObject: manifest,
	      url: uri,
	      id: this.master.playlists[0].id
	    });
	    this.trigger('loadedmetadata');
	  };
	
	  return PlaylistLoader;
	}(EventTarget$1);
	/**
	 * @file xhr.js
	 */
	
	
	var videojsXHR = videojs.xhr,
	    mergeOptions$1 = videojs.mergeOptions;
	
	var callbackWrapper = function callbackWrapper(request, error, response, callback) {
	  var reqResponse = request.responseType === 'arraybuffer' ? request.response : request.responseText;
	
	  if (!error && reqResponse) {
	    request.responseTime = Date.now();
	    request.roundTripTime = request.responseTime - request.requestTime;
	    request.bytesReceived = reqResponse.byteLength || reqResponse.length;
	
	    if (!request.bandwidth) {
	      request.bandwidth = Math.floor(request.bytesReceived / request.roundTripTime * 8 * 1000);
	    }
	  }
	
	  if (response.headers) {
	    request.responseHeaders = response.headers;
	  } // videojs.xhr now uses a specific code on the error
	  // object to signal that a request has timed out instead
	  // of setting a boolean on the request object
	
	
	  if (error && error.code === 'ETIMEDOUT') {
	    request.timedout = true;
	  } // videojs.xhr no longer considers status codes outside of 200 and 0
	  // (for file uris) to be errors, but the old XHR did, so emulate that
	  // behavior. Status 206 may be used in response to byterange requests.
	
	
	  if (!error && !request.aborted && response.statusCode !== 200 && response.statusCode !== 206 && response.statusCode !== 0) {
	    error = new Error('XHR Failed with a response of: ' + (request && (reqResponse || request.responseText)));
	  }
	
	  callback(error, request);
	};
	
	var xhrFactory = function xhrFactory() {
	  var xhr = function XhrFunction(options, callback) {
	    // Add a default timeout
	    options = mergeOptions$1({
	      timeout: 45e3
	    }, options); // Allow an optional user-specified function to modify the option
	    // object before we construct the xhr request
	
	    var beforeRequest = XhrFunction.beforeRequest || videojs.Vhs.xhr.beforeRequest;
	
	    if (beforeRequest && typeof beforeRequest === 'function') {
	      var newOptions = beforeRequest(options);
	
	      if (newOptions) {
	        options = newOptions;
	      }
	    } // Use the standard videojs.xhr() method unless `videojs.Vhs.xhr` has been overriden
	    // TODO: switch back to videojs.Vhs.xhr.name === 'XhrFunction' when we drop IE11
	
	
	    var xhrMethod = videojs.Vhs.xhr.original === true ? videojsXHR : videojs.Vhs.xhr;
	    var request = xhrMethod(options, function (error, response) {
	      return callbackWrapper(request, error, response, callback);
	    });
	    var originalAbort = request.abort;
	
	    request.abort = function () {
	      request.aborted = true;
	      return originalAbort.apply(request, arguments);
	    };
	
	    request.uri = options.uri;
	    request.requestTime = Date.now();
	    return request;
	  };
	
	  xhr.original = true;
	  return xhr;
	};
	/**
	 * Turns segment byterange into a string suitable for use in
	 * HTTP Range requests
	 *
	 * @param {Object} byterange - an object with two values defining the start and end
	 *                             of a byte-range
	 */
	
	
	var byterangeStr = function byterangeStr(byterange) {
	  // `byterangeEnd` is one less than `offset + length` because the HTTP range
	  // header uses inclusive ranges
	  var byterangeEnd;
	  var byterangeStart = byterange.offset;
	
	  if (typeof byterange.offset === 'bigint' || typeof byterange.length === 'bigint') {
	    byterangeEnd = window__default['default'].BigInt(byterange.offset) + window__default['default'].BigInt(byterange.length) - window__default['default'].BigInt(1);
	  } else {
	    byterangeEnd = byterange.offset + byterange.length - 1;
	  }
	
	  return 'bytes=' + byterangeStart + '-' + byterangeEnd;
	};
	/**
	 * Defines headers for use in the xhr request for a particular segment.
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 */
	
	
	var segmentXhrHeaders = function segmentXhrHeaders(segment) {
	  var headers = {};
	
	  if (segment.byterange) {
	    headers.Range = byterangeStr(segment.byterange);
	  }
	
	  return headers;
	};
	/**
	 * @file bin-utils.js
	 */
	
	/**
	 * convert a TimeRange to text
	 *
	 * @param {TimeRange} range the timerange to use for conversion
	 * @param {number} i the iterator on the range to convert
	 * @return {string} the range in string format
	 */
	
	
	var textRange = function textRange(range, i) {
	  return range.start(i) + '-' + range.end(i);
	};
	/**
	 * format a number as hex string
	 *
	 * @param {number} e The number
	 * @param {number} i the iterator
	 * @return {string} the hex formatted number as a string
	 */
	
	
	var formatHexString = function formatHexString(e, i) {
	  var value = e.toString(16);
	  return '00'.substring(0, 2 - value.length) + value + (i % 2 ? ' ' : '');
	};
	
	var formatAsciiString = function formatAsciiString(e) {
	  if (e >= 0x20 && e < 0x7e) {
	    return String.fromCharCode(e);
	  }
	
	  return '.';
	};
	/**
	 * Creates an object for sending to a web worker modifying properties that are TypedArrays
	 * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
	 *
	 * @param {Object} message
	 *        Object of properties and values to send to the web worker
	 * @return {Object}
	 *         Modified message with TypedArray values expanded
	 * @function createTransferableMessage
	 */
	
	
	var createTransferableMessage = function createTransferableMessage(message) {
	  var transferable = {};
	  Object.keys(message).forEach(function (key) {
	    var value = message[key];
	
	    if (byteHelpers.isArrayBufferView(value)) {
	      transferable[key] = {
	        bytes: value.buffer,
	        byteOffset: value.byteOffset,
	        byteLength: value.byteLength
	      };
	    } else {
	      transferable[key] = value;
	    }
	  });
	  return transferable;
	};
	/**
	 * Returns a unique string identifier for a media initialization
	 * segment.
	 *
	 * @param {Object} initSegment
	 *        the init segment object.
	 *
	 * @return {string} the generated init segment id
	 */
	
	
	var initSegmentId = function initSegmentId(initSegment) {
	  var byterange = initSegment.byterange || {
	    length: Infinity,
	    offset: 0
	  };
	  return [byterange.length, byterange.offset, initSegment.resolvedUri].join(',');
	};
	/**
	 * Returns a unique string identifier for a media segment key.
	 *
	 * @param {Object} key the encryption key
	 * @return {string} the unique id for the media segment key.
	 */
	
	
	var segmentKeyId = function segmentKeyId(key) {
	  return key.resolvedUri;
	};
	/**
	 * utils to help dump binary data to the console
	 *
	 * @param {Array|TypedArray} data
	 *        data to dump to a string
	 *
	 * @return {string} the data as a hex string.
	 */
	
	
	var hexDump = function hexDump(data) {
	  var bytes = Array.prototype.slice.call(data);
	  var step = 16;
	  var result = '';
	  var hex;
	  var ascii;
	
	  for (var j = 0; j < bytes.length / step; j++) {
	    hex = bytes.slice(j * step, j * step + step).map(formatHexString).join('');
	    ascii = bytes.slice(j * step, j * step + step).map(formatAsciiString).join('');
	    result += hex + ' ' + ascii + '\n';
	  }
	
	  return result;
	};
	
	var tagDump = function tagDump(_ref) {
	  var bytes = _ref.bytes;
	  return hexDump(bytes);
	};
	
	var textRanges = function textRanges(ranges) {
	  var result = '';
	  var i;
	
	  for (i = 0; i < ranges.length; i++) {
	    result += textRange(ranges, i) + ' ';
	  }
	
	  return result;
	};
	
	var utils = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  createTransferableMessage: createTransferableMessage,
	  initSegmentId: initSegmentId,
	  segmentKeyId: segmentKeyId,
	  hexDump: hexDump,
	  tagDump: tagDump,
	  textRanges: textRanges
	}); // TODO handle fmp4 case where the timing info is accurate and doesn't involve transmux
	// 25% was arbitrarily chosen, and may need to be refined over time.
	
	var SEGMENT_END_FUDGE_PERCENT = 0.25;
	/**
	 * Converts a player time (any time that can be gotten/set from player.currentTime(),
	 * e.g., any time within player.seekable().start(0) to player.seekable().end(0)) to a
	 * program time (any time referencing the real world (e.g., EXT-X-PROGRAM-DATE-TIME)).
	 *
	 * The containing segment is required as the EXT-X-PROGRAM-DATE-TIME serves as an "anchor
	 * point" (a point where we have a mapping from program time to player time, with player
	 * time being the post transmux start of the segment).
	 *
	 * For more details, see [this doc](../../docs/program-time-from-player-time.md).
	 *
	 * @param {number} playerTime the player time
	 * @param {Object} segment the segment which contains the player time
	 * @return {Date} program time
	 */
	
	var playerTimeToProgramTime = function playerTimeToProgramTime(playerTime, segment) {
	  if (!segment.dateTimeObject) {
	    // Can't convert without an "anchor point" for the program time (i.e., a time that can
	    // be used to map the start of a segment with a real world time).
	    return null;
	  }
	
	  var transmuxerPrependedSeconds = segment.videoTimingInfo.transmuxerPrependedSeconds;
	  var transmuxedStart = segment.videoTimingInfo.transmuxedPresentationStart; // get the start of the content from before old content is prepended
	
	  var startOfSegment = transmuxedStart + transmuxerPrependedSeconds;
	  var offsetFromSegmentStart = playerTime - startOfSegment;
	  return new Date(segment.dateTimeObject.getTime() + offsetFromSegmentStart * 1000);
	};
	
	var originalSegmentVideoDuration = function originalSegmentVideoDuration(videoTimingInfo) {
	  return videoTimingInfo.transmuxedPresentationEnd - videoTimingInfo.transmuxedPresentationStart - videoTimingInfo.transmuxerPrependedSeconds;
	};
	/**
	 * Finds a segment that contains the time requested given as an ISO-8601 string. The
	 * returned segment might be an estimate or an accurate match.
	 *
	 * @param {string} programTime The ISO-8601 programTime to find a match for
	 * @param {Object} playlist A playlist object to search within
	 */
	
	
	var findSegmentForProgramTime = function findSegmentForProgramTime(programTime, playlist) {
	  // Assumptions:
	  //  - verifyProgramDateTimeTags has already been run
	  //  - live streams have been started
	  var dateTimeObject;
	
	  try {
	    dateTimeObject = new Date(programTime);
	  } catch (e) {
	    return null;
	  }
	
	  if (!playlist || !playlist.segments || playlist.segments.length === 0) {
	    return null;
	  }
	
	  var segment = playlist.segments[0];
	
	  if (dateTimeObject < segment.dateTimeObject) {
	    // Requested time is before stream start.
	    return null;
	  }
	
	  for (var i = 0; i < playlist.segments.length - 1; i++) {
	    segment = playlist.segments[i];
	    var nextSegmentStart = playlist.segments[i + 1].dateTimeObject;
	
	    if (dateTimeObject < nextSegmentStart) {
	      break;
	    }
	  }
	
	  var lastSegment = playlist.segments[playlist.segments.length - 1];
	  var lastSegmentStart = lastSegment.dateTimeObject;
	  var lastSegmentDuration = lastSegment.videoTimingInfo ? originalSegmentVideoDuration(lastSegment.videoTimingInfo) : lastSegment.duration + lastSegment.duration * SEGMENT_END_FUDGE_PERCENT;
	  var lastSegmentEnd = new Date(lastSegmentStart.getTime() + lastSegmentDuration * 1000);
	
	  if (dateTimeObject > lastSegmentEnd) {
	    // Beyond the end of the stream, or our best guess of the end of the stream.
	    return null;
	  }
	
	  if (dateTimeObject > lastSegmentStart) {
	    segment = lastSegment;
	  }
	
	  return {
	    segment: segment,
	    estimatedStart: segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationStart : Playlist.duration(playlist, playlist.mediaSequence + playlist.segments.indexOf(segment)),
	    // Although, given that all segments have accurate date time objects, the segment
	    // selected should be accurate, unless the video has been transmuxed at some point
	    // (determined by the presence of the videoTimingInfo object), the segment's "player
	    // time" (the start time in the player) can't be considered accurate.
	    type: segment.videoTimingInfo ? 'accurate' : 'estimate'
	  };
	};
	/**
	 * Finds a segment that contains the given player time(in seconds).
	 *
	 * @param {number} time The player time to find a match for
	 * @param {Object} playlist A playlist object to search within
	 */
	
	
	var findSegmentForPlayerTime = function findSegmentForPlayerTime(time, playlist) {
	  // Assumptions:
	  // - there will always be a segment.duration
	  // - we can start from zero
	  // - segments are in time order
	  if (!playlist || !playlist.segments || playlist.segments.length === 0) {
	    return null;
	  }
	
	  var segmentEnd = 0;
	  var segment;
	
	  for (var i = 0; i < playlist.segments.length; i++) {
	    segment = playlist.segments[i]; // videoTimingInfo is set after the segment is downloaded and transmuxed, and
	    // should contain the most accurate values we have for the segment's player times.
	    //
	    // Use the accurate transmuxedPresentationEnd value if it is available, otherwise fall
	    // back to an estimate based on the manifest derived (inaccurate) segment.duration, to
	    // calculate an end value.
	
	    segmentEnd = segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationEnd : segmentEnd + segment.duration;
	
	    if (time <= segmentEnd) {
	      break;
	    }
	  }
	
	  var lastSegment = playlist.segments[playlist.segments.length - 1];
	
	  if (lastSegment.videoTimingInfo && lastSegment.videoTimingInfo.transmuxedPresentationEnd < time) {
	    // The time requested is beyond the stream end.
	    return null;
	  }
	
	  if (time > segmentEnd) {
	    // The time is within or beyond the last segment.
	    //
	    // Check to see if the time is beyond a reasonable guess of the end of the stream.
	    if (time > segmentEnd + lastSegment.duration * SEGMENT_END_FUDGE_PERCENT) {
	      // Technically, because the duration value is only an estimate, the time may still
	      // exist in the last segment, however, there isn't enough information to make even
	      // a reasonable estimate.
	      return null;
	    }
	
	    segment = lastSegment;
	  }
	
	  return {
	    segment: segment,
	    estimatedStart: segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationStart : segmentEnd - segment.duration,
	    // Because videoTimingInfo is only set after transmux, it is the only way to get
	    // accurate timing values.
	    type: segment.videoTimingInfo ? 'accurate' : 'estimate'
	  };
	};
	/**
	 * Gives the offset of the comparisonTimestamp from the programTime timestamp in seconds.
	 * If the offset returned is positive, the programTime occurs after the
	 * comparisonTimestamp.
	 * If the offset is negative, the programTime occurs before the comparisonTimestamp.
	 *
	 * @param {string} comparisonTimeStamp An ISO-8601 timestamp to compare against
	 * @param {string} programTime The programTime as an ISO-8601 string
	 * @return {number} offset
	 */
	
	
	var getOffsetFromTimestamp = function getOffsetFromTimestamp(comparisonTimeStamp, programTime) {
	  var segmentDateTime;
	  var programDateTime;
	
	  try {
	    segmentDateTime = new Date(comparisonTimeStamp);
	    programDateTime = new Date(programTime);
	  } catch (e) {// TODO handle error
	  }
	
	  var segmentTimeEpoch = segmentDateTime.getTime();
	  var programTimeEpoch = programDateTime.getTime();
	  return (programTimeEpoch - segmentTimeEpoch) / 1000;
	};
	/**
	 * Checks that all segments in this playlist have programDateTime tags.
	 *
	 * @param {Object} playlist A playlist object
	 */
	
	
	var verifyProgramDateTimeTags = function verifyProgramDateTimeTags(playlist) {
	  if (!playlist.segments || playlist.segments.length === 0) {
	    return false;
	  }
	
	  for (var i = 0; i < playlist.segments.length; i++) {
	    var segment = playlist.segments[i];
	
	    if (!segment.dateTimeObject) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Returns the programTime of the media given a playlist and a playerTime.
	 * The playlist must have programDateTime tags for a programDateTime tag to be returned.
	 * If the segments containing the time requested have not been buffered yet, an estimate
	 * may be returned to the callback.
	 *
	 * @param {Object} args
	 * @param {Object} args.playlist A playlist object to search within
	 * @param {number} time A playerTime in seconds
	 * @param {Function} callback(err, programTime)
	 * @return {string} err.message A detailed error message
	 * @return {Object} programTime
	 * @return {number} programTime.mediaSeconds The streamTime in seconds
	 * @return {string} programTime.programDateTime The programTime as an ISO-8601 String
	 */
	
	
	var getProgramTime = function getProgramTime(_ref) {
	  var playlist = _ref.playlist,
	      _ref$time = _ref.time,
	      time = _ref$time === void 0 ? undefined : _ref$time,
	      callback = _ref.callback;
	
	  if (!callback) {
	    throw new Error('getProgramTime: callback must be provided');
	  }
	
	  if (!playlist || time === undefined) {
	    return callback({
	      message: 'getProgramTime: playlist and time must be provided'
	    });
	  }
	
	  var matchedSegment = findSegmentForPlayerTime(time, playlist);
	
	  if (!matchedSegment) {
	    return callback({
	      message: 'valid programTime was not found'
	    });
	  }
	
	  if (matchedSegment.type === 'estimate') {
	    return callback({
	      message: 'Accurate programTime could not be determined.' + ' Please seek to e.seekTime and try again',
	      seekTime: matchedSegment.estimatedStart
	    });
	  }
	
	  var programTimeObject = {
	    mediaSeconds: time
	  };
	  var programTime = playerTimeToProgramTime(time, matchedSegment.segment);
	
	  if (programTime) {
	    programTimeObject.programDateTime = programTime.toISOString();
	  }
	
	  return callback(null, programTimeObject);
	};
	/**
	 * Seeks in the player to a time that matches the given programTime ISO-8601 string.
	 *
	 * @param {Object} args
	 * @param {string} args.programTime A programTime to seek to as an ISO-8601 String
	 * @param {Object} args.playlist A playlist to look within
	 * @param {number} args.retryCount The number of times to try for an accurate seek. Default is 2.
	 * @param {Function} args.seekTo A method to perform a seek
	 * @param {boolean} args.pauseAfterSeek Whether to end in a paused state after seeking. Default is true.
	 * @param {Object} args.tech The tech to seek on
	 * @param {Function} args.callback(err, newTime) A callback to return the new time to
	 * @return {string} err.message A detailed error message
	 * @return {number} newTime The exact time that was seeked to in seconds
	 */
	
	
	var seekToProgramTime = function seekToProgramTime(_ref2) {
	  var programTime = _ref2.programTime,
	      playlist = _ref2.playlist,
	      _ref2$retryCount = _ref2.retryCount,
	      retryCount = _ref2$retryCount === void 0 ? 2 : _ref2$retryCount,
	      seekTo = _ref2.seekTo,
	      _ref2$pauseAfterSeek = _ref2.pauseAfterSeek,
	      pauseAfterSeek = _ref2$pauseAfterSeek === void 0 ? true : _ref2$pauseAfterSeek,
	      tech = _ref2.tech,
	      callback = _ref2.callback;
	
	  if (!callback) {
	    throw new Error('seekToProgramTime: callback must be provided');
	  }
	
	  if (typeof programTime === 'undefined' || !playlist || !seekTo) {
	    return callback({
	      message: 'seekToProgramTime: programTime, seekTo and playlist must be provided'
	    });
	  }
	
	  if (!playlist.endList && !tech.hasStarted_) {
	    return callback({
	      message: 'player must be playing a live stream to start buffering'
	    });
	  }
	
	  if (!verifyProgramDateTimeTags(playlist)) {
	    return callback({
	      message: 'programDateTime tags must be provided in the manifest ' + playlist.resolvedUri
	    });
	  }
	
	  var matchedSegment = findSegmentForProgramTime(programTime, playlist); // no match
	
	  if (!matchedSegment) {
	    return callback({
	      message: programTime + " was not found in the stream"
	    });
	  }
	
	  var segment = matchedSegment.segment;
	  var mediaOffset = getOffsetFromTimestamp(segment.dateTimeObject, programTime);
	
	  if (matchedSegment.type === 'estimate') {
	    // we've run out of retries
	    if (retryCount === 0) {
	      return callback({
	        message: programTime + " is not buffered yet. Try again"
	      });
	    }
	
	    seekTo(matchedSegment.estimatedStart + mediaOffset);
	    tech.one('seeked', function () {
	      seekToProgramTime({
	        programTime: programTime,
	        playlist: playlist,
	        retryCount: retryCount - 1,
	        seekTo: seekTo,
	        pauseAfterSeek: pauseAfterSeek,
	        tech: tech,
	        callback: callback
	      });
	    });
	    return;
	  } // Since the segment.start value is determined from the buffered end or ending time
	  // of the prior segment, the seekToTime doesn't need to account for any transmuxer
	  // modifications.
	
	
	  var seekToTime = segment.start + mediaOffset;
	
	  var seekedCallback = function seekedCallback() {
	    return callback(null, tech.currentTime());
	  }; // listen for seeked event
	
	
	  tech.one('seeked', seekedCallback); // pause before seeking as video.js will restore this state
	
	  if (pauseAfterSeek) {
	    tech.pause();
	  }
	
	  seekTo(seekToTime);
	}; // which will only happen if the request is complete.
	
	
	var callbackOnCompleted = function callbackOnCompleted(request, cb) {
	  if (request.readyState === 4) {
	    return cb();
	  }
	
	  return;
	};
	
	var containerRequest = function containerRequest(uri, xhr, cb) {
	  var bytes = [];
	  var id3Offset;
	  var finished = false;
	
	  var endRequestAndCallback = function endRequestAndCallback(err, req, type, _bytes) {
	    req.abort();
	    finished = true;
	    return cb(err, req, type, _bytes);
	  };
	
	  var progressListener = function progressListener(error, request) {
	    if (finished) {
	      return;
	    }
	
	    if (error) {
	      return endRequestAndCallback(error, request, '', bytes);
	    } // grap the new part of content that was just downloaded
	
	
	    var newPart = request.responseText.substring(bytes && bytes.byteLength || 0, request.responseText.length); // add that onto bytes
	
	    bytes = byteHelpers.concatTypedArrays(bytes, byteHelpers.stringToBytes(newPart, true));
	    id3Offset = id3Offset || id3Helpers.getId3Offset(bytes); // we need at least 10 bytes to determine a type
	    // or we need at least two bytes after an id3Offset
	
	    if (bytes.length < 10 || id3Offset && bytes.length < id3Offset + 2) {
	      return callbackOnCompleted(request, function () {
	        return endRequestAndCallback(error, request, '', bytes);
	      });
	    }
	
	    var type = containers.detectContainerForBytes(bytes); // if this looks like a ts segment but we don't have enough data
	    // to see the second sync byte, wait until we have enough data
	    // before declaring it ts
	
	    if (type === 'ts' && bytes.length < 188) {
	      return callbackOnCompleted(request, function () {
	        return endRequestAndCallback(error, request, '', bytes);
	      });
	    } // this may be an unsynced ts segment
	    // wait for 376 bytes before detecting no container
	
	
	    if (!type && bytes.length < 376) {
	      return callbackOnCompleted(request, function () {
	        return endRequestAndCallback(error, request, '', bytes);
	      });
	    }
	
	    return endRequestAndCallback(null, request, type, bytes);
	  };
	
	  var options = {
	    uri: uri,
	    beforeSend: function beforeSend(request) {
	      // this forces the browser to pass the bytes to us unprocessed
	      request.overrideMimeType('text/plain; charset=x-user-defined');
	      request.addEventListener('progress', function (_ref) {
	        _ref.total;
	        _ref.loaded;
	        return callbackWrapper(request, null, {
	          statusCode: request.status
	        }, progressListener);
	      });
	    }
	  };
	  var request = xhr(options, function (error, response) {
	    return callbackWrapper(request, error, response, progressListener);
	  });
	  return request;
	};
	
	var EventTarget = videojs.EventTarget,
	    mergeOptions = videojs.mergeOptions;
	
	var dashPlaylistUnchanged = function dashPlaylistUnchanged(a, b) {
	  if (!isPlaylistUnchanged(a, b)) {
	    return false;
	  } // for dash the above check will often return true in scenarios where
	  // the playlist actually has changed because mediaSequence isn't a
	  // dash thing, and we often set it to 1. So if the playlists have the same amount
	  // of segments we return true.
	  // So for dash we need to make sure that the underlying segments are different.
	  // if sidx changed then the playlists are different.
	
	
	  if (a.sidx && b.sidx && (a.sidx.offset !== b.sidx.offset || a.sidx.length !== b.sidx.length)) {
	    return false;
	  } else if (!a.sidx && b.sidx || a.sidx && !b.sidx) {
	    return false;
	  } // one or the other does not have segments
	  // there was a change.
	
	
	  if (a.segments && !b.segments || !a.segments && b.segments) {
	    return false;
	  } // neither has segments nothing changed
	
	
	  if (!a.segments && !b.segments) {
	    return true;
	  } // check segments themselves
	
	
	  for (var i = 0; i < a.segments.length; i++) {
	    var aSegment = a.segments[i];
	    var bSegment = b.segments[i]; // if uris are different between segments there was a change
	
	    if (aSegment.uri !== bSegment.uri) {
	      return false;
	    } // neither segment has a byterange, there will be no byterange change.
	
	
	    if (!aSegment.byterange && !bSegment.byterange) {
	      continue;
	    }
	
	    var aByterange = aSegment.byterange;
	    var bByterange = bSegment.byterange; // if byterange only exists on one of the segments, there was a change.
	
	    if (aByterange && !bByterange || !aByterange && bByterange) {
	      return false;
	    } // if both segments have byterange with different offsets, there was a change.
	
	
	    if (aByterange.offset !== bByterange.offset || aByterange.length !== bByterange.length) {
	      return false;
	    }
	  } // if everything was the same with segments, this is the same playlist.
	
	
	  return true;
	};
	/**
	 * Use the representation IDs from the mpd object to create groupIDs, the NAME is set to mandatory representation
	 * ID in the parser. This allows for continuous playout across periods with the same representation IDs
	 * (continuous periods as defined in DASH-IF 3.2.12). This is assumed in the mpd-parser as well. If we want to support
	 * periods without continuous playback this function may need modification as well as the parser.
	 */
	
	
	var dashGroupId = function dashGroupId(type, group, label, playlist) {
	  // If the manifest somehow does not have an ID (non-dash compliant), use the label.
	  var playlistId = playlist.attributes.NAME || label;
	  return "placeholder-uri-" + type + "-" + group + "-" + playlistId;
	};
	/**
	 * Parses the master XML string and updates playlist URI references.
	 *
	 * @param {Object} config
	 *        Object of arguments
	 * @param {string} config.masterXml
	 *        The mpd XML
	 * @param {string} config.srcUrl
	 *        The mpd URL
	 * @param {Date} config.clientOffset
	 *         A time difference between server and client
	 * @param {Object} config.sidxMapping
	 *        SIDX mappings for moof/mdat URIs and byte ranges
	 * @return {Object}
	 *         The parsed mpd manifest object
	 */
	
	
	var parseMasterXml = function parseMasterXml(_ref) {
	  var masterXml = _ref.masterXml,
	      srcUrl = _ref.srcUrl,
	      clientOffset = _ref.clientOffset,
	      sidxMapping = _ref.sidxMapping,
	      previousManifest = _ref.previousManifest;
	  var manifest = mpdParser.parse(masterXml, {
	    manifestUri: srcUrl,
	    clientOffset: clientOffset,
	    sidxMapping: sidxMapping,
	    previousManifest: previousManifest
	  });
	  addPropertiesToMaster(manifest, srcUrl, dashGroupId);
	  return manifest;
	};
	/**
	 * Removes any mediaGroup labels that no longer exist in the newMaster
	 *
	 * @param {Object} update
	 *         The previous mpd object being updated
	 * @param {Object} newMaster
	 *         The new mpd object
	 */
	
	
	var removeOldMediaGroupLabels = function removeOldMediaGroupLabels(update, newMaster) {
	  forEachMediaGroup(update, function (properties, type, group, label) {
	    if (!(label in newMaster.mediaGroups[type][group])) {
	      delete update.mediaGroups[type][group][label];
	    }
	  });
	};
	/**
	 * Returns a new master manifest that is the result of merging an updated master manifest
	 * into the original version.
	 *
	 * @param {Object} oldMaster
	 *        The old parsed mpd object
	 * @param {Object} newMaster
	 *        The updated parsed mpd object
	 * @return {Object}
	 *         A new object representing the original master manifest with the updated media
	 *         playlists merged in
	 */
	
	
	var updateMaster = function updateMaster(oldMaster, newMaster, sidxMapping) {
	  var noChanges = true;
	  var update = mergeOptions(oldMaster, {
	    // These are top level properties that can be updated
	    duration: newMaster.duration,
	    minimumUpdatePeriod: newMaster.minimumUpdatePeriod,
	    timelineStarts: newMaster.timelineStarts
	  }); // First update the playlists in playlist list
	
	  for (var i = 0; i < newMaster.playlists.length; i++) {
	    var playlist = newMaster.playlists[i];
	
	    if (playlist.sidx) {
	      var sidxKey = mpdParser.generateSidxKey(playlist.sidx); // add sidx segments to the playlist if we have all the sidx info already
	
	      if (sidxMapping && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx) {
	        mpdParser.addSidxSegmentsToPlaylist(playlist, sidxMapping[sidxKey].sidx, playlist.sidx.resolvedUri);
	      }
	    }
	
	    var playlistUpdate = updateMaster$1(update, playlist, dashPlaylistUnchanged);
	
	    if (playlistUpdate) {
	      update = playlistUpdate;
	      noChanges = false;
	    }
	  } // Then update media group playlists
	
	
	  forEachMediaGroup(newMaster, function (properties, type, group, label) {
	    if (properties.playlists && properties.playlists.length) {
	      var id = properties.playlists[0].id;
	
	      var _playlistUpdate = updateMaster$1(update, properties.playlists[0], dashPlaylistUnchanged);
	
	      if (_playlistUpdate) {
	        update = _playlistUpdate; // add new mediaGroup label if it doesn't exist and assign the new mediaGroup.
	
	        if (!(label in update.mediaGroups[type][group])) {
	          update.mediaGroups[type][group][label] = properties;
	        } // update the playlist reference within media groups
	
	
	        update.mediaGroups[type][group][label].playlists[0] = update.playlists[id];
	        noChanges = false;
	      }
	    }
	  }); // remove mediaGroup labels and references that no longer exist in the newMaster
	
	  removeOldMediaGroupLabels(update, newMaster);
	
	  if (newMaster.minimumUpdatePeriod !== oldMaster.minimumUpdatePeriod) {
	    noChanges = false;
	  }
	
	  if (noChanges) {
	    return null;
	  }
	
	  return update;
	}; // SIDX should be equivalent if the URI and byteranges of the SIDX match.
	// If the SIDXs have maps, the two maps should match,
	// both `a` and `b` missing SIDXs is considered matching.
	// If `a` or `b` but not both have a map, they aren't matching.
	
	
	var equivalentSidx = function equivalentSidx(a, b) {
	  var neitherMap = Boolean(!a.map && !b.map);
	  var equivalentMap = neitherMap || Boolean(a.map && b.map && a.map.byterange.offset === b.map.byterange.offset && a.map.byterange.length === b.map.byterange.length);
	  return equivalentMap && a.uri === b.uri && a.byterange.offset === b.byterange.offset && a.byterange.length === b.byterange.length;
	}; // exported for testing
	
	
	var compareSidxEntry = function compareSidxEntry(playlists, oldSidxMapping) {
	  var newSidxMapping = {};
	
	  for (var id in playlists) {
	    var playlist = playlists[id];
	    var currentSidxInfo = playlist.sidx;
	
	    if (currentSidxInfo) {
	      var key = mpdParser.generateSidxKey(currentSidxInfo);
	
	      if (!oldSidxMapping[key]) {
	        break;
	      }
	
	      var savedSidxInfo = oldSidxMapping[key].sidxInfo;
	
	      if (equivalentSidx(savedSidxInfo, currentSidxInfo)) {
	        newSidxMapping[key] = oldSidxMapping[key];
	      }
	    }
	  }
	
	  return newSidxMapping;
	};
	/**
	 *  A function that filters out changed items as they need to be requested separately.
	 *
	 *  The method is exported for testing
	 *
	 *  @param {Object} master the parsed mpd XML returned via mpd-parser
	 *  @param {Object} oldSidxMapping the SIDX to compare against
	 */
	
	
	var filterChangedSidxMappings = function filterChangedSidxMappings(master, oldSidxMapping) {
	  var videoSidx = compareSidxEntry(master.playlists, oldSidxMapping);
	  var mediaGroupSidx = videoSidx;
	  forEachMediaGroup(master, function (properties, mediaType, groupKey, labelKey) {
	    if (properties.playlists && properties.playlists.length) {
	      var playlists = properties.playlists;
	      mediaGroupSidx = mergeOptions(mediaGroupSidx, compareSidxEntry(playlists, oldSidxMapping));
	    }
	  });
	  return mediaGroupSidx;
	};
	
	var DashPlaylistLoader = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](DashPlaylistLoader, _EventTarget); // DashPlaylistLoader must accept either a src url or a playlist because subsequent
	  // playlist loader setups from media groups will expect to be able to pass a playlist
	  // (since there aren't external URLs to media playlists with DASH)
	
	
	  function DashPlaylistLoader(srcUrlOrPlaylist, vhs, options, masterPlaylistLoader) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _EventTarget.call(this) || this;
	    _this.masterPlaylistLoader_ = masterPlaylistLoader || _assertThisInitialized__default['default'](_this);
	
	    if (!masterPlaylistLoader) {
	      _this.isMaster_ = true;
	    }
	
	    var _options = options,
	        _options$withCredenti = _options.withCredentials,
	        withCredentials = _options$withCredenti === void 0 ? false : _options$withCredenti,
	        _options$handleManife = _options.handleManifestRedirects,
	        handleManifestRedirects = _options$handleManife === void 0 ? false : _options$handleManife;
	    _this.vhs_ = vhs;
	    _this.withCredentials = withCredentials;
	    _this.handleManifestRedirects = handleManifestRedirects;
	
	    if (!srcUrlOrPlaylist) {
	      throw new Error('A non-empty playlist URL or object is required');
	    } // event naming?
	
	
	    _this.on('minimumUpdatePeriod', function () {
	      _this.refreshXml_();
	    }); // live playlist staleness timeout
	
	
	    _this.on('mediaupdatetimeout', function () {
	      _this.refreshMedia_(_this.media().id);
	    });
	
	    _this.state = 'HAVE_NOTHING';
	    _this.loadedPlaylists_ = {};
	    _this.logger_ = logger('DashPlaylistLoader'); // initialize the loader state
	    // The masterPlaylistLoader will be created with a string
	
	    if (_this.isMaster_) {
	      _this.masterPlaylistLoader_.srcUrl = srcUrlOrPlaylist; // TODO: reset sidxMapping between period changes
	      // once multi-period is refactored
	
	      _this.masterPlaylistLoader_.sidxMapping_ = {};
	    } else {
	      _this.childPlaylist_ = srcUrlOrPlaylist;
	    }
	
	    return _this;
	  }
	
	  var _proto = DashPlaylistLoader.prototype;
	
	  _proto.requestErrored_ = function requestErrored_(err, request, startingState) {
	    // disposed
	    if (!this.request) {
	      return true;
	    } // pending request is cleared
	
	
	    this.request = null;
	
	    if (err) {
	      // use the provided error object or create one
	      // based on the request/response
	      this.error = typeof err === 'object' && !(err instanceof Error) ? err : {
	        status: request.status,
	        message: 'DASH request error at URL: ' + request.uri,
	        response: request.response,
	        // MEDIA_ERR_NETWORK
	        code: 2
	      };
	
	      if (startingState) {
	        this.state = startingState;
	      }
	
	      this.trigger('error');
	      return true;
	    }
	  }
	  /**
	   * Verify that the container of the sidx segment can be parsed
	   * and if it can, get and parse that segment.
	   */
	  ;
	
	  _proto.addSidxSegments_ = function addSidxSegments_(playlist, startingState, cb) {
	    var _this2 = this;
	
	    var sidxKey = playlist.sidx && mpdParser.generateSidxKey(playlist.sidx); // playlist lacks sidx or sidx segments were added to this playlist already.
	
	    if (!playlist.sidx || !sidxKey || this.masterPlaylistLoader_.sidxMapping_[sidxKey]) {
	      // keep this function async
	      this.mediaRequest_ = window__default['default'].setTimeout(function () {
	        return cb(false);
	      }, 0);
	      return;
	    } // resolve the segment URL relative to the playlist
	
	
	    var uri = resolveManifestRedirect(this.handleManifestRedirects, playlist.sidx.resolvedUri);
	
	    var fin = function fin(err, request) {
	      if (_this2.requestErrored_(err, request, startingState)) {
	        return;
	      }
	
	      var sidxMapping = _this2.masterPlaylistLoader_.sidxMapping_;
	      var sidx;
	
	      try {
	        sidx = parseSidx__default['default'](byteHelpers.toUint8(request.response).subarray(8));
	      } catch (e) {
	        // sidx parsing failed.
	        _this2.requestErrored_(e, request, startingState);
	
	        return;
	      }
	
	      sidxMapping[sidxKey] = {
	        sidxInfo: playlist.sidx,
	        sidx: sidx
	      };
	      mpdParser.addSidxSegmentsToPlaylist(playlist, sidx, playlist.sidx.resolvedUri);
	      return cb(true);
	    };
	
	    this.request = containerRequest(uri, this.vhs_.xhr, function (err, request, container, bytes) {
	      if (err) {
	        return fin(err, request);
	      }
	
	      if (!container || container !== 'mp4') {
	        return fin({
	          status: request.status,
	          message: "Unsupported " + (container || 'unknown') + " container type for sidx segment at URL: " + uri,
	          // response is just bytes in this case
	          // but we really don't want to return that.
	          response: '',
	          playlist: playlist,
	          internal: true,
	          blacklistDuration: Infinity,
	          // MEDIA_ERR_NETWORK
	          code: 2
	        }, request);
	      } // if we already downloaded the sidx bytes in the container request, use them
	
	
	      var _playlist$sidx$bytera = playlist.sidx.byterange,
	          offset = _playlist$sidx$bytera.offset,
	          length = _playlist$sidx$bytera.length;
	
	      if (bytes.length >= length + offset) {
	        return fin(err, {
	          response: bytes.subarray(offset, offset + length),
	          status: request.status,
	          uri: request.uri
	        });
	      } // otherwise request sidx bytes
	
	
	      _this2.request = _this2.vhs_.xhr({
	        uri: uri,
	        responseType: 'arraybuffer',
	        headers: segmentXhrHeaders({
	          byterange: playlist.sidx.byterange
	        })
	      }, fin);
	    });
	  };
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.stopRequest();
	    this.loadedPlaylists_ = {};
	    window__default['default'].clearTimeout(this.minimumUpdatePeriodTimeout_);
	    window__default['default'].clearTimeout(this.mediaRequest_);
	    window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	    this.mediaUpdateTimeout = null;
	    this.mediaRequest_ = null;
	    this.minimumUpdatePeriodTimeout_ = null;
	
	    if (this.masterPlaylistLoader_.createMupOnMedia_) {
	      this.off('loadedmetadata', this.masterPlaylistLoader_.createMupOnMedia_);
	      this.masterPlaylistLoader_.createMupOnMedia_ = null;
	    }
	
	    this.off();
	  };
	
	  _proto.hasPendingRequest = function hasPendingRequest() {
	    return this.request || this.mediaRequest_;
	  };
	
	  _proto.stopRequest = function stopRequest() {
	    if (this.request) {
	      var oldRequest = this.request;
	      this.request = null;
	      oldRequest.onreadystatechange = null;
	      oldRequest.abort();
	    }
	  };
	
	  _proto.media = function media(playlist) {
	    var _this3 = this; // getter
	
	
	    if (!playlist) {
	      return this.media_;
	    } // setter
	
	
	    if (this.state === 'HAVE_NOTHING') {
	      throw new Error('Cannot switch media playlist from ' + this.state);
	    }
	
	    var startingState = this.state; // find the playlist object if the target playlist has been specified by URI
	
	    if (typeof playlist === 'string') {
	      if (!this.masterPlaylistLoader_.master.playlists[playlist]) {
	        throw new Error('Unknown playlist URI: ' + playlist);
	      }
	
	      playlist = this.masterPlaylistLoader_.master.playlists[playlist];
	    }
	
	    var mediaChange = !this.media_ || playlist.id !== this.media_.id; // switch to previously loaded playlists immediately
	
	    if (mediaChange && this.loadedPlaylists_[playlist.id] && this.loadedPlaylists_[playlist.id].endList) {
	      this.state = 'HAVE_METADATA';
	      this.media_ = playlist; // trigger media change if the active media has been updated
	
	      if (mediaChange) {
	        this.trigger('mediachanging');
	        this.trigger('mediachange');
	      }
	
	      return;
	    } // switching to the active playlist is a no-op
	
	
	    if (!mediaChange) {
	      return;
	    } // switching from an already loaded playlist
	
	
	    if (this.media_) {
	      this.trigger('mediachanging');
	    }
	
	    this.addSidxSegments_(playlist, startingState, function (sidxChanged) {
	      // everything is ready just continue to haveMetadata
	      _this3.haveMetadata({
	        startingState: startingState,
	        playlist: playlist
	      });
	    });
	  };
	
	  _proto.haveMetadata = function haveMetadata(_ref2) {
	    var startingState = _ref2.startingState,
	        playlist = _ref2.playlist;
	    this.state = 'HAVE_METADATA';
	    this.loadedPlaylists_[playlist.id] = playlist;
	    this.mediaRequest_ = null; // This will trigger loadedplaylist
	
	    this.refreshMedia_(playlist.id); // fire loadedmetadata the first time a media playlist is loaded
	    // to resolve setup of media groups
	
	    if (startingState === 'HAVE_MASTER') {
	      this.trigger('loadedmetadata');
	    } else {
	      // trigger media change if the active media has been updated
	      this.trigger('mediachange');
	    }
	  };
	
	  _proto.pause = function pause() {
	    if (this.masterPlaylistLoader_.createMupOnMedia_) {
	      this.off('loadedmetadata', this.masterPlaylistLoader_.createMupOnMedia_);
	      this.masterPlaylistLoader_.createMupOnMedia_ = null;
	    }
	
	    this.stopRequest();
	    window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	    this.mediaUpdateTimeout = null;
	
	    if (this.isMaster_) {
	      window__default['default'].clearTimeout(this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_);
	      this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_ = null;
	    }
	
	    if (this.state === 'HAVE_NOTHING') {
	      // If we pause the loader before any data has been retrieved, its as if we never
	      // started, so reset to an unstarted state.
	      this.started = false;
	    }
	  };
	
	  _proto.load = function load(isFinalRendition) {
	    var _this4 = this;
	
	    window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	    this.mediaUpdateTimeout = null;
	    var media = this.media();
	
	    if (isFinalRendition) {
	      var delay = media ? media.targetDuration / 2 * 1000 : 5 * 1000;
	      this.mediaUpdateTimeout = window__default['default'].setTimeout(function () {
	        return _this4.load();
	      }, delay);
	      return;
	    } // because the playlists are internal to the manifest, load should either load the
	    // main manifest, or do nothing but trigger an event
	
	
	    if (!this.started) {
	      this.start();
	      return;
	    }
	
	    if (media && !media.endList) {
	      // Check to see if this is the master loader and the MUP was cleared (this happens
	      // when the loader was paused). `media` should be set at this point since one is always
	      // set during `start()`.
	      if (this.isMaster_ && !this.minimumUpdatePeriodTimeout_) {
	        // Trigger minimumUpdatePeriod to refresh the master manifest
	        this.trigger('minimumUpdatePeriod'); // Since there was no prior minimumUpdatePeriodTimeout it should be recreated
	
	        this.updateMinimumUpdatePeriodTimeout_();
	      }
	
	      this.trigger('mediaupdatetimeout');
	    } else {
	      this.trigger('loadedplaylist');
	    }
	  };
	
	  _proto.start = function start() {
	    var _this5 = this;
	
	    this.started = true; // We don't need to request the master manifest again
	    // Call this asynchronously to match the xhr request behavior below
	
	    if (!this.isMaster_) {
	      this.mediaRequest_ = window__default['default'].setTimeout(function () {
	        return _this5.haveMaster_();
	      }, 0);
	      return;
	    }
	
	    this.requestMaster_(function (req, masterChanged) {
	      _this5.haveMaster_();
	
	      if (!_this5.hasPendingRequest() && !_this5.media_) {
	        _this5.media(_this5.masterPlaylistLoader_.master.playlists[0]);
	      }
	    });
	  };
	
	  _proto.requestMaster_ = function requestMaster_(cb) {
	    var _this6 = this;
	
	    this.request = this.vhs_.xhr({
	      uri: this.masterPlaylistLoader_.srcUrl,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      if (_this6.requestErrored_(error, req)) {
	        if (_this6.state === 'HAVE_NOTHING') {
	          _this6.started = false;
	        }
	
	        return;
	      }
	
	      var masterChanged = req.responseText !== _this6.masterPlaylistLoader_.masterXml_;
	      _this6.masterPlaylistLoader_.masterXml_ = req.responseText;
	
	      if (req.responseHeaders && req.responseHeaders.date) {
	        _this6.masterLoaded_ = Date.parse(req.responseHeaders.date);
	      } else {
	        _this6.masterLoaded_ = Date.now();
	      }
	
	      _this6.masterPlaylistLoader_.srcUrl = resolveManifestRedirect(_this6.handleManifestRedirects, _this6.masterPlaylistLoader_.srcUrl, req);
	
	      if (masterChanged) {
	        _this6.handleMaster_();
	
	        _this6.syncClientServerClock_(function () {
	          return cb(req, masterChanged);
	        });
	
	        return;
	      }
	
	      return cb(req, masterChanged);
	    });
	  }
	  /**
	   * Parses the master xml for UTCTiming node to sync the client clock to the server
	   * clock. If the UTCTiming node requires a HEAD or GET request, that request is made.
	   *
	   * @param {Function} done
	   *        Function to call when clock sync has completed
	   */
	  ;
	
	  _proto.syncClientServerClock_ = function syncClientServerClock_(done) {
	    var _this7 = this;
	
	    var utcTiming = mpdParser.parseUTCTiming(this.masterPlaylistLoader_.masterXml_); // No UTCTiming element found in the mpd. Use Date header from mpd request as the
	    // server clock
	
	    if (utcTiming === null) {
	      this.masterPlaylistLoader_.clientOffset_ = this.masterLoaded_ - Date.now();
	      return done();
	    }
	
	    if (utcTiming.method === 'DIRECT') {
	      this.masterPlaylistLoader_.clientOffset_ = utcTiming.value - Date.now();
	      return done();
	    }
	
	    this.request = this.vhs_.xhr({
	      uri: resolveUrl(this.masterPlaylistLoader_.srcUrl, utcTiming.value),
	      method: utcTiming.method,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      // disposed
	      if (!_this7.request) {
	        return;
	      }
	
	      if (error) {
	        // sync request failed, fall back to using date header from mpd
	        // TODO: log warning
	        _this7.masterPlaylistLoader_.clientOffset_ = _this7.masterLoaded_ - Date.now();
	        return done();
	      }
	
	      var serverTime;
	
	      if (utcTiming.method === 'HEAD') {
	        if (!req.responseHeaders || !req.responseHeaders.date) {
	          // expected date header not preset, fall back to using date header from mpd
	          // TODO: log warning
	          serverTime = _this7.masterLoaded_;
	        } else {
	          serverTime = Date.parse(req.responseHeaders.date);
	        }
	      } else {
	        serverTime = Date.parse(req.responseText);
	      }
	
	      _this7.masterPlaylistLoader_.clientOffset_ = serverTime - Date.now();
	      done();
	    });
	  };
	
	  _proto.haveMaster_ = function haveMaster_() {
	    this.state = 'HAVE_MASTER';
	
	    if (this.isMaster_) {
	      // We have the master playlist at this point, so
	      // trigger this to allow MasterPlaylistController
	      // to make an initial playlist selection
	      this.trigger('loadedplaylist');
	    } else if (!this.media_) {
	      // no media playlist was specifically selected so select
	      // the one the child playlist loader was created with
	      this.media(this.childPlaylist_);
	    }
	  };
	
	  _proto.handleMaster_ = function handleMaster_() {
	    // clear media request
	    this.mediaRequest_ = null;
	    var oldMaster = this.masterPlaylistLoader_.master;
	    var newMaster = parseMasterXml({
	      masterXml: this.masterPlaylistLoader_.masterXml_,
	      srcUrl: this.masterPlaylistLoader_.srcUrl,
	      clientOffset: this.masterPlaylistLoader_.clientOffset_,
	      sidxMapping: this.masterPlaylistLoader_.sidxMapping_,
	      previousManifest: oldMaster
	    }); // if we have an old master to compare the new master against
	
	    if (oldMaster) {
	      newMaster = updateMaster(oldMaster, newMaster, this.masterPlaylistLoader_.sidxMapping_);
	    } // only update master if we have a new master
	
	
	    this.masterPlaylistLoader_.master = newMaster ? newMaster : oldMaster;
	    var location = this.masterPlaylistLoader_.master.locations && this.masterPlaylistLoader_.master.locations[0];
	
	    if (location && location !== this.masterPlaylistLoader_.srcUrl) {
	      this.masterPlaylistLoader_.srcUrl = location;
	    }
	
	    if (!oldMaster || newMaster && newMaster.minimumUpdatePeriod !== oldMaster.minimumUpdatePeriod) {
	      this.updateMinimumUpdatePeriodTimeout_();
	    }
	
	    return Boolean(newMaster);
	  };
	
	  _proto.updateMinimumUpdatePeriodTimeout_ = function updateMinimumUpdatePeriodTimeout_() {
	    var mpl = this.masterPlaylistLoader_; // cancel any pending creation of mup on media
	    // a new one will be added if needed.
	
	    if (mpl.createMupOnMedia_) {
	      mpl.off('loadedmetadata', mpl.createMupOnMedia_);
	      mpl.createMupOnMedia_ = null;
	    } // clear any pending timeouts
	
	
	    if (mpl.minimumUpdatePeriodTimeout_) {
	      window__default['default'].clearTimeout(mpl.minimumUpdatePeriodTimeout_);
	      mpl.minimumUpdatePeriodTimeout_ = null;
	    }
	
	    var mup = mpl.master && mpl.master.minimumUpdatePeriod; // If the minimumUpdatePeriod has a value of 0, that indicates that the current
	    // MPD has no future validity, so a new one will need to be acquired when new
	    // media segments are to be made available. Thus, we use the target duration
	    // in this case
	
	    if (mup === 0) {
	      if (mpl.media()) {
	        mup = mpl.media().targetDuration * 1000;
	      } else {
	        mpl.createMupOnMedia_ = mpl.updateMinimumUpdatePeriodTimeout_;
	        mpl.one('loadedmetadata', mpl.createMupOnMedia_);
	      }
	    } // if minimumUpdatePeriod is invalid or <= zero, which
	    // can happen when a live video becomes VOD. skip timeout
	    // creation.
	
	
	    if (typeof mup !== 'number' || mup <= 0) {
	      if (mup < 0) {
	        this.logger_("found invalid minimumUpdatePeriod of " + mup + ", not setting a timeout");
	      }
	
	      return;
	    }
	
	    this.createMUPTimeout_(mup);
	  };
	
	  _proto.createMUPTimeout_ = function createMUPTimeout_(mup) {
	    var mpl = this.masterPlaylistLoader_;
	    mpl.minimumUpdatePeriodTimeout_ = window__default['default'].setTimeout(function () {
	      mpl.minimumUpdatePeriodTimeout_ = null;
	      mpl.trigger('minimumUpdatePeriod');
	      mpl.createMUPTimeout_(mup);
	    }, mup);
	  }
	  /**
	   * Sends request to refresh the master xml and updates the parsed master manifest
	   */
	  ;
	
	  _proto.refreshXml_ = function refreshXml_() {
	    var _this8 = this;
	
	    this.requestMaster_(function (req, masterChanged) {
	      if (!masterChanged) {
	        return;
	      }
	
	      if (_this8.media_) {
	        _this8.media_ = _this8.masterPlaylistLoader_.master.playlists[_this8.media_.id];
	      } // This will filter out updated sidx info from the mapping
	
	
	      _this8.masterPlaylistLoader_.sidxMapping_ = filterChangedSidxMappings(_this8.masterPlaylistLoader_.master, _this8.masterPlaylistLoader_.sidxMapping_);
	
	      _this8.addSidxSegments_(_this8.media(), _this8.state, function (sidxChanged) {
	        // TODO: do we need to reload the current playlist?
	        _this8.refreshMedia_(_this8.media().id);
	      });
	    });
	  }
	  /**
	   * Refreshes the media playlist by re-parsing the master xml and updating playlist
	   * references. If this is an alternate loader, the updated parsed manifest is retrieved
	   * from the master loader.
	   */
	  ;
	
	  _proto.refreshMedia_ = function refreshMedia_(mediaID) {
	    var _this9 = this;
	
	    if (!mediaID) {
	      throw new Error('refreshMedia_ must take a media id');
	    } // for master we have to reparse the master xml
	    // to re-create segments based on current timing values
	    // which may change media. We only skip updating master
	    // if this is the first time this.media_ is being set.
	    // as master was just parsed in that case.
	
	
	    if (this.media_ && this.isMaster_) {
	      this.handleMaster_();
	    }
	
	    var playlists = this.masterPlaylistLoader_.master.playlists;
	    var mediaChanged = !this.media_ || this.media_ !== playlists[mediaID];
	
	    if (mediaChanged) {
	      this.media_ = playlists[mediaID];
	    } else {
	      this.trigger('playlistunchanged');
	    }
	
	    if (!this.mediaUpdateTimeout) {
	      var createMediaUpdateTimeout = function createMediaUpdateTimeout() {
	        if (_this9.media().endList) {
	          return;
	        }
	
	        _this9.mediaUpdateTimeout = window__default['default'].setTimeout(function () {
	          _this9.trigger('mediaupdatetimeout');
	
	          createMediaUpdateTimeout();
	        }, refreshDelay(_this9.media(), Boolean(mediaChanged)));
	      };
	
	      createMediaUpdateTimeout();
	    }
	
	    this.trigger('loadedplaylist');
	  };
	
	  return DashPlaylistLoader;
	}(EventTarget);
	
	var Config = {
	  GOAL_BUFFER_LENGTH: 30,
	  MAX_GOAL_BUFFER_LENGTH: 60,
	  BACK_BUFFER_LENGTH: 30,
	  GOAL_BUFFER_LENGTH_RATE: 1,
	  // 0.5 MB/s
	  INITIAL_BANDWIDTH: 4194304,
	  // A fudge factor to apply to advertised playlist bitrates to account for
	  // temporary flucations in client bandwidth
	  BANDWIDTH_VARIANCE: 1.2,
	  // How much of the buffer must be filled before we consider upswitching
	  BUFFER_LOW_WATER_LINE: 0,
	  MAX_BUFFER_LOW_WATER_LINE: 30,
	  // TODO: Remove this when experimentalBufferBasedABR is removed
	  EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
	  BUFFER_LOW_WATER_LINE_RATE: 1,
	  // If the buffer is greater than the high water line, we won't switch down
	  BUFFER_HIGH_WATER_LINE: 30
	};
	
	var stringToArrayBuffer = function stringToArrayBuffer(string) {
	  var view = new Uint8Array(new ArrayBuffer(string.length));
	
	  for (var i = 0; i < string.length; i++) {
	    view[i] = string.charCodeAt(i);
	  }
	
	  return view.buffer;
	};
	/* global Blob, BlobBuilder, Worker */
	// unify worker interface
	
	
	var browserWorkerPolyFill = function browserWorkerPolyFill(workerObj) {
	  // node only supports on/off
	  workerObj.on = workerObj.addEventListener;
	  workerObj.off = workerObj.removeEventListener;
	  return workerObj;
	};
	
	var createObjectURL = function createObjectURL(str) {
	  try {
	    return URL.createObjectURL(new Blob([str], {
	      type: 'application/javascript'
	    }));
	  } catch (e) {
	    var blob = new BlobBuilder();
	    blob.append(str);
	    return URL.createObjectURL(blob.getBlob());
	  }
	};
	
	var factory = function factory(code) {
	  return function () {
	    var objectUrl = createObjectURL(code);
	    var worker = browserWorkerPolyFill(new Worker(objectUrl));
	    worker.objURL = objectUrl;
	    var terminate = worker.terminate;
	    worker.on = worker.addEventListener;
	    worker.off = worker.removeEventListener;
	
	    worker.terminate = function () {
	      URL.revokeObjectURL(objectUrl);
	      return terminate.call(this);
	    };
	
	    return worker;
	  };
	};
	
	var transform = function transform(code) {
	  return "var browserWorkerPolyFill = " + browserWorkerPolyFill.toString() + ";\n" + 'browserWorkerPolyFill(self);\n' + code;
	};
	
	var getWorkerString = function getWorkerString(fn) {
	  return fn.toString().replace(/^function.+?{/, '').slice(0, -1);
	};
	/* rollup-plugin-worker-factory start for worker!/home/runner/work/http-streaming/http-streaming/src/transmuxer-worker.js */
	
	
	var workerCode$1 = transform(getWorkerString(function () {
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   *
	   * A lightweight readable stream implemention that handles event dispatching.
	   * Objects that inherit from streams should call init in their constructors.
	   */
	  var Stream = function Stream() {
	    this.init = function () {
	      var listeners = {};
	      /**
	       * Add a listener for a specified event type.
	       * @param type {string} the event name
	       * @param listener {function} the callback to be invoked when an event of
	       * the specified type occurs
	       */
	
	      this.on = function (type, listener) {
	        if (!listeners[type]) {
	          listeners[type] = [];
	        }
	
	        listeners[type] = listeners[type].concat(listener);
	      };
	      /**
	       * Remove a listener for a specified event type.
	       * @param type {string} the event name
	       * @param listener {function} a function previously registered for this
	       * type of event through `on`
	       */
	
	
	      this.off = function (type, listener) {
	        var index;
	
	        if (!listeners[type]) {
	          return false;
	        }
	
	        index = listeners[type].indexOf(listener);
	        listeners[type] = listeners[type].slice();
	        listeners[type].splice(index, 1);
	        return index > -1;
	      };
	      /**
	       * Trigger an event of the specified type on this stream. Any additional
	       * arguments to this function are passed as parameters to event listeners.
	       * @param type {string} the event name
	       */
	
	
	      this.trigger = function (type) {
	        var callbacks, i, length, args;
	        callbacks = listeners[type];
	
	        if (!callbacks) {
	          return;
	        } // Slicing the arguments on every invocation of this method
	        // can add a significant amount of overhead. Avoid the
	        // intermediate object creation for the common case of a
	        // single callback argument
	
	
	        if (arguments.length === 2) {
	          length = callbacks.length;
	
	          for (i = 0; i < length; ++i) {
	            callbacks[i].call(this, arguments[1]);
	          }
	        } else {
	          args = [];
	          i = arguments.length;
	
	          for (i = 1; i < arguments.length; ++i) {
	            args.push(arguments[i]);
	          }
	
	          length = callbacks.length;
	
	          for (i = 0; i < length; ++i) {
	            callbacks[i].apply(this, args);
	          }
	        }
	      };
	      /**
	       * Destroys the stream and cleans up.
	       */
	
	
	      this.dispose = function () {
	        listeners = {};
	      };
	    };
	  };
	  /**
	   * Forwards all `data` events on this stream to the destination stream. The
	   * destination stream should provide a method `push` to receive the data
	   * events as they arrive.
	   * @param destination {stream} the stream that will receive all `data` events
	   * @param autoFlush {boolean} if false, we will not call `flush` on the destination
	   *                            when the current stream emits a 'done' event
	   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	   */
	
	
	  Stream.prototype.pipe = function (destination) {
	    this.on('data', function (data) {
	      destination.push(data);
	    });
	    this.on('done', function (flushSource) {
	      destination.flush(flushSource);
	    });
	    this.on('partialdone', function (flushSource) {
	      destination.partialFlush(flushSource);
	    });
	    this.on('endedtimeline', function (flushSource) {
	      destination.endTimeline(flushSource);
	    });
	    this.on('reset', function (flushSource) {
	      destination.reset(flushSource);
	    });
	    return destination;
	  }; // Default stream functions that are expected to be overridden to perform
	  // actual work. These are provided by the prototype as a sort of no-op
	  // implementation so that we don't have to check for their existence in the
	  // `pipe` function above.
	
	
	  Stream.prototype.push = function (data) {
	    this.trigger('data', data);
	  };
	
	  Stream.prototype.flush = function (flushSource) {
	    this.trigger('done', flushSource);
	  };
	
	  Stream.prototype.partialFlush = function (flushSource) {
	    this.trigger('partialdone', flushSource);
	  };
	
	  Stream.prototype.endTimeline = function (flushSource) {
	    this.trigger('endedtimeline', flushSource);
	  };
	
	  Stream.prototype.reset = function (flushSource) {
	    this.trigger('reset', flushSource);
	  };
	
	  var stream = Stream;
	  var MAX_UINT32$1 = Math.pow(2, 32);
	
	  var getUint64$2 = function getUint64(uint8) {
	    var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
	    var value;
	
	    if (dv.getBigUint64) {
	      value = dv.getBigUint64(0);
	
	      if (value < Number.MAX_SAFE_INTEGER) {
	        return Number(value);
	      }
	
	      return value;
	    }
	
	    return dv.getUint32(0) * MAX_UINT32$1 + dv.getUint32(4);
	  };
	
	  var numbers = {
	    getUint64: getUint64$2,
	    MAX_UINT32: MAX_UINT32$1
	  };
	  var MAX_UINT32 = numbers.MAX_UINT32;
	  var box, dinf, esds, ftyp, mdat, mfhd, minf, moof, moov, mvex, mvhd, trak, tkhd, mdia, mdhd, hdlr, sdtp, stbl, stsd, traf, trex, trun$1, types, MAJOR_BRAND, MINOR_VERSION, AVC1_BRAND, VIDEO_HDLR, AUDIO_HDLR, HDLR_TYPES, VMHD, SMHD, DREF, STCO, STSC, STSZ, STTS; // pre-calculate constants
	
	  (function () {
	    var i;
	    types = {
	      avc1: [],
	      // codingname
	      avcC: [],
	      btrt: [],
	      dinf: [],
	      dref: [],
	      esds: [],
	      ftyp: [],
	      hdlr: [],
	      mdat: [],
	      mdhd: [],
	      mdia: [],
	      mfhd: [],
	      minf: [],
	      moof: [],
	      moov: [],
	      mp4a: [],
	      // codingname
	      mvex: [],
	      mvhd: [],
	      pasp: [],
	      sdtp: [],
	      smhd: [],
	      stbl: [],
	      stco: [],
	      stsc: [],
	      stsd: [],
	      stsz: [],
	      stts: [],
	      styp: [],
	      tfdt: [],
	      tfhd: [],
	      traf: [],
	      trak: [],
	      trun: [],
	      trex: [],
	      tkhd: [],
	      vmhd: []
	    }; // In environments where Uint8Array is undefined (e.g., IE8), skip set up so that we
	    // don't throw an error
	
	    if (typeof Uint8Array === 'undefined') {
	      return;
	    }
	
	    for (i in types) {
	      if (types.hasOwnProperty(i)) {
	        types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
	      }
	    }
	
	    MAJOR_BRAND = new Uint8Array(['i'.charCodeAt(0), 's'.charCodeAt(0), 'o'.charCodeAt(0), 'm'.charCodeAt(0)]);
	    AVC1_BRAND = new Uint8Array(['a'.charCodeAt(0), 'v'.charCodeAt(0), 'c'.charCodeAt(0), '1'.charCodeAt(0)]);
	    MINOR_VERSION = new Uint8Array([0, 0, 0, 1]);
	    VIDEO_HDLR = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // pre_defined
	    0x76, 0x69, 0x64, 0x65, // handler_type: 'vide'
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x56, 0x69, 0x64, 0x65, 0x6f, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
	    ]);
	    AUDIO_HDLR = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // pre_defined
	    0x73, 0x6f, 0x75, 0x6e, // handler_type: 'soun'
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x53, 0x6f, 0x75, 0x6e, 0x64, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
	    ]);
	    HDLR_TYPES = {
	      video: VIDEO_HDLR,
	      audio: AUDIO_HDLR
	    };
	    DREF = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x01, // entry_count
	    0x00, 0x00, 0x00, 0x0c, // entry_size
	    0x75, 0x72, 0x6c, 0x20, // 'url' type
	    0x00, // version 0
	    0x00, 0x00, 0x01 // entry_flags
	    ]);
	    SMHD = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, // balance, 0 means centered
	    0x00, 0x00 // reserved
	    ]);
	    STCO = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00 // entry_count
	    ]);
	    STSC = STCO;
	    STSZ = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // sample_size
	    0x00, 0x00, 0x00, 0x00 // sample_count
	    ]);
	    STTS = STCO;
	    VMHD = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x01, // flags
	    0x00, 0x00, // graphicsmode
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00 // opcolor
	    ]);
	  })();
	
	  box = function box(type) {
	    var payload = [],
	        size = 0,
	        i,
	        result,
	        view;
	
	    for (i = 1; i < arguments.length; i++) {
	      payload.push(arguments[i]);
	    }
	
	    i = payload.length; // calculate the total size we need to allocate
	
	    while (i--) {
	      size += payload[i].byteLength;
	    }
	
	    result = new Uint8Array(size + 8);
	    view = new DataView(result.buffer, result.byteOffset, result.byteLength);
	    view.setUint32(0, result.byteLength);
	    result.set(type, 4); // copy the payload into the result
	
	    for (i = 0, size = 8; i < payload.length; i++) {
	      result.set(payload[i], size);
	      size += payload[i].byteLength;
	    }
	
	    return result;
	  };
	
	  dinf = function dinf() {
	    return box(types.dinf, box(types.dref, DREF));
	  };
	
	  esds = function esds(track) {
	    return box(types.esds, new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    // ES_Descriptor
	    0x03, // tag, ES_DescrTag
	    0x19, // length
	    0x00, 0x00, // ES_ID
	    0x00, // streamDependenceFlag, URL_flag, reserved, streamPriority
	    // DecoderConfigDescriptor
	    0x04, // tag, DecoderConfigDescrTag
	    0x11, // length
	    0x40, // object type
	    0x15, // streamType
	    0x00, 0x06, 0x00, // bufferSizeDB
	    0x00, 0x00, 0xda, 0xc0, // maxBitrate
	    0x00, 0x00, 0xda, 0xc0, // avgBitrate
	    // DecoderSpecificInfo
	    0x05, // tag, DecoderSpecificInfoTag
	    0x02, // length
	    // ISO/IEC 14496-3, AudioSpecificConfig
	    // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
	    track.audioobjecttype << 3 | track.samplingfrequencyindex >>> 1, track.samplingfrequencyindex << 7 | track.channelcount << 3, 0x06, 0x01, 0x02 // GASpecificConfig
	    ]));
	  };
	
	  ftyp = function ftyp() {
	    return box(types.ftyp, MAJOR_BRAND, MINOR_VERSION, MAJOR_BRAND, AVC1_BRAND);
	  };
	
	  hdlr = function hdlr(type) {
	    return box(types.hdlr, HDLR_TYPES[type]);
	  };
	
	  mdat = function mdat(data) {
	    return box(types.mdat, data);
	  };
	
	  mdhd = function mdhd(track) {
	    var result = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x02, // creation_time
	    0x00, 0x00, 0x00, 0x03, // modification_time
	    0x00, 0x01, 0x5f, 0x90, // timescale, 90,000 "ticks" per second
	    track.duration >>> 24 & 0xFF, track.duration >>> 16 & 0xFF, track.duration >>> 8 & 0xFF, track.duration & 0xFF, // duration
	    0x55, 0xc4, // 'und' language (undetermined)
	    0x00, 0x00]); // Use the sample rate from the track metadata, when it is
	    // defined. The sample rate can be parsed out of an ADTS header, for
	    // instance.
	
	    if (track.samplerate) {
	      result[12] = track.samplerate >>> 24 & 0xFF;
	      result[13] = track.samplerate >>> 16 & 0xFF;
	      result[14] = track.samplerate >>> 8 & 0xFF;
	      result[15] = track.samplerate & 0xFF;
	    }
	
	    return box(types.mdhd, result);
	  };
	
	  mdia = function mdia(track) {
	    return box(types.mdia, mdhd(track), hdlr(track.type), minf(track));
	  };
	
	  mfhd = function mfhd(sequenceNumber) {
	    return box(types.mfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00, // flags
	    (sequenceNumber & 0xFF000000) >> 24, (sequenceNumber & 0xFF0000) >> 16, (sequenceNumber & 0xFF00) >> 8, sequenceNumber & 0xFF // sequence_number
	    ]));
	  };
	
	  minf = function minf(track) {
	    return box(types.minf, track.type === 'video' ? box(types.vmhd, VMHD) : box(types.smhd, SMHD), dinf(), stbl(track));
	  };
	
	  moof = function moof(sequenceNumber, tracks) {
	    var trackFragments = [],
	        i = tracks.length; // build traf boxes for each track fragment
	
	    while (i--) {
	      trackFragments[i] = traf(tracks[i]);
	    }
	
	    return box.apply(null, [types.moof, mfhd(sequenceNumber)].concat(trackFragments));
	  };
	  /**
	   * Returns a movie box.
	   * @param tracks {array} the tracks associated with this movie
	   * @see ISO/IEC 14496-12:2012(E), section 8.2.1
	   */
	
	
	  moov = function moov(tracks) {
	    var i = tracks.length,
	        boxes = [];
	
	    while (i--) {
	      boxes[i] = trak(tracks[i]);
	    }
	
	    return box.apply(null, [types.moov, mvhd(0xffffffff)].concat(boxes).concat(mvex(tracks)));
	  };
	
	  mvex = function mvex(tracks) {
	    var i = tracks.length,
	        boxes = [];
	
	    while (i--) {
	      boxes[i] = trex(tracks[i]);
	    }
	
	    return box.apply(null, [types.mvex].concat(boxes));
	  };
	
	  mvhd = function mvhd(duration) {
	    var bytes = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x01, // creation_time
	    0x00, 0x00, 0x00, 0x02, // modification_time
	    0x00, 0x01, 0x5f, 0x90, // timescale, 90,000 "ticks" per second
	    (duration & 0xFF000000) >> 24, (duration & 0xFF0000) >> 16, (duration & 0xFF00) >> 8, duration & 0xFF, // duration
	    0x00, 0x01, 0x00, 0x00, // 1.0 rate
	    0x01, 0x00, // 1.0 volume
	    0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
	    0xff, 0xff, 0xff, 0xff // next_track_ID
	    ]);
	    return box(types.mvhd, bytes);
	  };
	
	  sdtp = function sdtp(track) {
	    var samples = track.samples || [],
	        bytes = new Uint8Array(4 + samples.length),
	        flags,
	        i; // leave the full box header (4 bytes) all zero
	    // write the sample table
	
	    for (i = 0; i < samples.length; i++) {
	      flags = samples[i].flags;
	      bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
	    }
	
	    return box(types.sdtp, bytes);
	  };
	
	  stbl = function stbl(track) {
	    return box(types.stbl, stsd(track), box(types.stts, STTS), box(types.stsc, STSC), box(types.stsz, STSZ), box(types.stco, STCO));
	  };
	
	  (function () {
	    var videoSample, audioSample;
	
	    stsd = function stsd(track) {
	      return box(types.stsd, new Uint8Array([0x00, // version 0
	      0x00, 0x00, 0x00, // flags
	      0x00, 0x00, 0x00, 0x01]), track.type === 'video' ? videoSample(track) : audioSample(track));
	    };
	
	    videoSample = function videoSample(track) {
	      var sps = track.sps || [],
	          pps = track.pps || [],
	          sequenceParameterSets = [],
	          pictureParameterSets = [],
	          i,
	          avc1Box; // assemble the SPSs
	
	      for (i = 0; i < sps.length; i++) {
	        sequenceParameterSets.push((sps[i].byteLength & 0xFF00) >>> 8);
	        sequenceParameterSets.push(sps[i].byteLength & 0xFF); // sequenceParameterSetLength
	
	        sequenceParameterSets = sequenceParameterSets.concat(Array.prototype.slice.call(sps[i])); // SPS
	      } // assemble the PPSs
	
	
	      for (i = 0; i < pps.length; i++) {
	        pictureParameterSets.push((pps[i].byteLength & 0xFF00) >>> 8);
	        pictureParameterSets.push(pps[i].byteLength & 0xFF);
	        pictureParameterSets = pictureParameterSets.concat(Array.prototype.slice.call(pps[i]));
	      }
	
	      avc1Box = [types.avc1, new Uint8Array([0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x01, // data_reference_index
	      0x00, 0x00, // pre_defined
	      0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
	      (track.width & 0xff00) >> 8, track.width & 0xff, // width
	      (track.height & 0xff00) >> 8, track.height & 0xff, // height
	      0x00, 0x48, 0x00, 0x00, // horizresolution
	      0x00, 0x48, 0x00, 0x00, // vertresolution
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x01, // frame_count
	      0x13, 0x76, 0x69, 0x64, 0x65, 0x6f, 0x6a, 0x73, 0x2d, 0x63, 0x6f, 0x6e, 0x74, 0x72, 0x69, 0x62, 0x2d, 0x68, 0x6c, 0x73, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // compressorname
	      0x00, 0x18, // depth = 24
	      0x11, 0x11 // pre_defined = -1
	      ]), box(types.avcC, new Uint8Array([0x01, // configurationVersion
	      track.profileIdc, // AVCProfileIndication
	      track.profileCompatibility, // profile_compatibility
	      track.levelIdc, // AVCLevelIndication
	      0xff // lengthSizeMinusOne, hard-coded to 4 bytes
	      ].concat([sps.length], // numOfSequenceParameterSets
	      sequenceParameterSets, // "SPS"
	      [pps.length], // numOfPictureParameterSets
	      pictureParameterSets // "PPS"
	      ))), box(types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80, // bufferSizeDB
	      0x00, 0x2d, 0xc6, 0xc0, // maxBitrate
	      0x00, 0x2d, 0xc6, 0xc0 // avgBitrate
	      ]))];
	
	      if (track.sarRatio) {
	        var hSpacing = track.sarRatio[0],
	            vSpacing = track.sarRatio[1];
	        avc1Box.push(box(types.pasp, new Uint8Array([(hSpacing & 0xFF000000) >> 24, (hSpacing & 0xFF0000) >> 16, (hSpacing & 0xFF00) >> 8, hSpacing & 0xFF, (vSpacing & 0xFF000000) >> 24, (vSpacing & 0xFF0000) >> 16, (vSpacing & 0xFF00) >> 8, vSpacing & 0xFF])));
	      }
	
	      return box.apply(null, avc1Box);
	    };
	
	    audioSample = function audioSample(track) {
	      return box(types.mp4a, new Uint8Array([// SampleEntry, ISO/IEC 14496-12
	      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x01, // data_reference_index
	      // AudioSampleEntry, ISO/IEC 14496-12
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, // reserved
	      (track.channelcount & 0xff00) >> 8, track.channelcount & 0xff, // channelcount
	      (track.samplesize & 0xff00) >> 8, track.samplesize & 0xff, // samplesize
	      0x00, 0x00, // pre_defined
	      0x00, 0x00, // reserved
	      (track.samplerate & 0xff00) >> 8, track.samplerate & 0xff, 0x00, 0x00 // samplerate, 16.16
	      // MP4AudioSampleEntry, ISO/IEC 14496-14
	      ]), esds(track));
	    };
	  })();
	
	  tkhd = function tkhd(track) {
	    var result = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x07, // flags
	    0x00, 0x00, 0x00, 0x00, // creation_time
	    0x00, 0x00, 0x00, 0x00, // modification_time
	    (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	    0x00, 0x00, 0x00, 0x00, // reserved
	    (track.duration & 0xFF000000) >> 24, (track.duration & 0xFF0000) >> 16, (track.duration & 0xFF00) >> 8, track.duration & 0xFF, // duration
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, // layer
	    0x00, 0x00, // alternate_group
	    0x01, 0x00, // non-audio track volume
	    0x00, 0x00, // reserved
	    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
	    (track.width & 0xFF00) >> 8, track.width & 0xFF, 0x00, 0x00, // width
	    (track.height & 0xFF00) >> 8, track.height & 0xFF, 0x00, 0x00 // height
	    ]);
	    return box(types.tkhd, result);
	  };
	  /**
	   * Generate a track fragment (traf) box. A traf box collects metadata
	   * about tracks in a movie fragment (moof) box.
	   */
	
	
	  traf = function traf(track) {
	    var trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable, dataOffset, upperWordBaseMediaDecodeTime, lowerWordBaseMediaDecodeTime;
	    trackFragmentHeader = box(types.tfhd, new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x3a, // flags
	    (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	    0x00, 0x00, 0x00, 0x01, // sample_description_index
	    0x00, 0x00, 0x00, 0x00, // default_sample_duration
	    0x00, 0x00, 0x00, 0x00, // default_sample_size
	    0x00, 0x00, 0x00, 0x00 // default_sample_flags
	    ]));
	    upperWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime / MAX_UINT32);
	    lowerWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime % MAX_UINT32);
	    trackFragmentDecodeTime = box(types.tfdt, new Uint8Array([0x01, // version 1
	    0x00, 0x00, 0x00, // flags
	    // baseMediaDecodeTime
	    upperWordBaseMediaDecodeTime >>> 24 & 0xFF, upperWordBaseMediaDecodeTime >>> 16 & 0xFF, upperWordBaseMediaDecodeTime >>> 8 & 0xFF, upperWordBaseMediaDecodeTime & 0xFF, lowerWordBaseMediaDecodeTime >>> 24 & 0xFF, lowerWordBaseMediaDecodeTime >>> 16 & 0xFF, lowerWordBaseMediaDecodeTime >>> 8 & 0xFF, lowerWordBaseMediaDecodeTime & 0xFF])); // the data offset specifies the number of bytes from the start of
	    // the containing moof to the first payload byte of the associated
	    // mdat
	
	    dataOffset = 32 + // tfhd
	    20 + // tfdt
	    8 + // traf header
	    16 + // mfhd
	    8 + // moof header
	    8; // mdat header
	    // audio tracks require less metadata
	
	    if (track.type === 'audio') {
	      trackFragmentRun = trun$1(track, dataOffset);
	      return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun);
	    } // video tracks should contain an independent and disposable samples
	    // box (sdtp)
	    // generate one and adjust offsets to match
	
	
	    sampleDependencyTable = sdtp(track);
	    trackFragmentRun = trun$1(track, sampleDependencyTable.length + dataOffset);
	    return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable);
	  };
	  /**
	   * Generate a track box.
	   * @param track {object} a track definition
	   * @return {Uint8Array} the track box
	   */
	
	
	  trak = function trak(track) {
	    track.duration = track.duration || 0xffffffff;
	    return box(types.trak, tkhd(track), mdia(track));
	  };
	
	  trex = function trex(track) {
	    var result = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	    0x00, 0x00, 0x00, 0x01, // default_sample_description_index
	    0x00, 0x00, 0x00, 0x00, // default_sample_duration
	    0x00, 0x00, 0x00, 0x00, // default_sample_size
	    0x00, 0x01, 0x00, 0x01 // default_sample_flags
	    ]); // the last two bytes of default_sample_flags is the sample
	    // degradation priority, a hint about the importance of this sample
	    // relative to others. Lower the degradation priority for all sample
	    // types other than video.
	
	    if (track.type !== 'video') {
	      result[result.length - 1] = 0x00;
	    }
	
	    return box(types.trex, result);
	  };
	
	  (function () {
	    var audioTrun, videoTrun, trunHeader; // This method assumes all samples are uniform. That is, if a
	    // duration is present for the first sample, it will be present for
	    // all subsequent samples.
	    // see ISO/IEC 14496-12:2012, Section 8.8.8.1
	
	    trunHeader = function trunHeader(samples, offset) {
	      var durationPresent = 0,
	          sizePresent = 0,
	          flagsPresent = 0,
	          compositionTimeOffset = 0; // trun flag constants
	
	      if (samples.length) {
	        if (samples[0].duration !== undefined) {
	          durationPresent = 0x1;
	        }
	
	        if (samples[0].size !== undefined) {
	          sizePresent = 0x2;
	        }
	
	        if (samples[0].flags !== undefined) {
	          flagsPresent = 0x4;
	        }
	
	        if (samples[0].compositionTimeOffset !== undefined) {
	          compositionTimeOffset = 0x8;
	        }
	      }
	
	      return [0x00, // version 0
	      0x00, durationPresent | sizePresent | flagsPresent | compositionTimeOffset, 0x01, // flags
	      (samples.length & 0xFF000000) >>> 24, (samples.length & 0xFF0000) >>> 16, (samples.length & 0xFF00) >>> 8, samples.length & 0xFF, // sample_count
	      (offset & 0xFF000000) >>> 24, (offset & 0xFF0000) >>> 16, (offset & 0xFF00) >>> 8, offset & 0xFF // data_offset
	      ];
	    };
	
	    videoTrun = function videoTrun(track, offset) {
	      var bytesOffest, bytes, header, samples, sample, i;
	      samples = track.samples || [];
	      offset += 8 + 12 + 16 * samples.length;
	      header = trunHeader(samples, offset);
	      bytes = new Uint8Array(header.length + samples.length * 16);
	      bytes.set(header);
	      bytesOffest = header.length;
	
	      for (i = 0; i < samples.length; i++) {
	        sample = samples[i];
	        bytes[bytesOffest++] = (sample.duration & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.duration & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.duration & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.duration & 0xFF; // sample_duration
	
	        bytes[bytesOffest++] = (sample.size & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.size & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.size & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.size & 0xFF; // sample_size
	
	        bytes[bytesOffest++] = sample.flags.isLeading << 2 | sample.flags.dependsOn;
	        bytes[bytesOffest++] = sample.flags.isDependedOn << 6 | sample.flags.hasRedundancy << 4 | sample.flags.paddingValue << 1 | sample.flags.isNonSyncSample;
	        bytes[bytesOffest++] = sample.flags.degradationPriority & 0xF0 << 8;
	        bytes[bytesOffest++] = sample.flags.degradationPriority & 0x0F; // sample_flags
	
	        bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.compositionTimeOffset & 0xFF; // sample_composition_time_offset
	      }
	
	      return box(types.trun, bytes);
	    };
	
	    audioTrun = function audioTrun(track, offset) {
	      var bytes, bytesOffest, header, samples, sample, i;
	      samples = track.samples || [];
	      offset += 8 + 12 + 8 * samples.length;
	      header = trunHeader(samples, offset);
	      bytes = new Uint8Array(header.length + samples.length * 8);
	      bytes.set(header);
	      bytesOffest = header.length;
	
	      for (i = 0; i < samples.length; i++) {
	        sample = samples[i];
	        bytes[bytesOffest++] = (sample.duration & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.duration & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.duration & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.duration & 0xFF; // sample_duration
	
	        bytes[bytesOffest++] = (sample.size & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.size & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.size & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.size & 0xFF; // sample_size
	      }
	
	      return box(types.trun, bytes);
	    };
	
	    trun$1 = function trun(track, offset) {
	      if (track.type === 'audio') {
	        return audioTrun(track, offset);
	      }
	
	      return videoTrun(track, offset);
	    };
	  })();
	
	  var mp4Generator = {
	    ftyp: ftyp,
	    mdat: mdat,
	    moof: moof,
	    moov: moov,
	    initSegment: function initSegment(tracks) {
	      var fileType = ftyp(),
	          movie = moov(tracks),
	          result;
	      result = new Uint8Array(fileType.byteLength + movie.byteLength);
	      result.set(fileType);
	      result.set(movie, fileType.byteLength);
	      return result;
	    }
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	  // Convert an array of nal units into an array of frames with each frame being
	  // composed of the nal units that make up that frame
	  // Also keep track of cummulative data about the frame from the nal units such
	  // as the frame duration, starting pts, etc.
	
	  var groupNalsIntoFrames = function groupNalsIntoFrames(nalUnits) {
	    var i,
	        currentNal,
	        currentFrame = [],
	        frames = []; // TODO added for LHLS, make sure this is OK
	
	    frames.byteLength = 0;
	    frames.nalCount = 0;
	    frames.duration = 0;
	    currentFrame.byteLength = 0;
	
	    for (i = 0; i < nalUnits.length; i++) {
	      currentNal = nalUnits[i]; // Split on 'aud'-type nal units
	
	      if (currentNal.nalUnitType === 'access_unit_delimiter_rbsp') {
	        // Since the very first nal unit is expected to be an AUD
	        // only push to the frames array when currentFrame is not empty
	        if (currentFrame.length) {
	          currentFrame.duration = currentNal.dts - currentFrame.dts; // TODO added for LHLS, make sure this is OK
	
	          frames.byteLength += currentFrame.byteLength;
	          frames.nalCount += currentFrame.length;
	          frames.duration += currentFrame.duration;
	          frames.push(currentFrame);
	        }
	
	        currentFrame = [currentNal];
	        currentFrame.byteLength = currentNal.data.byteLength;
	        currentFrame.pts = currentNal.pts;
	        currentFrame.dts = currentNal.dts;
	      } else {
	        // Specifically flag key frames for ease of use later
	        if (currentNal.nalUnitType === 'slice_layer_without_partitioning_rbsp_idr') {
	          currentFrame.keyFrame = true;
	        }
	
	        currentFrame.duration = currentNal.dts - currentFrame.dts;
	        currentFrame.byteLength += currentNal.data.byteLength;
	        currentFrame.push(currentNal);
	      }
	    } // For the last frame, use the duration of the previous frame if we
	    // have nothing better to go on
	
	
	    if (frames.length && (!currentFrame.duration || currentFrame.duration <= 0)) {
	      currentFrame.duration = frames[frames.length - 1].duration;
	    } // Push the final frame
	    // TODO added for LHLS, make sure this is OK
	
	
	    frames.byteLength += currentFrame.byteLength;
	    frames.nalCount += currentFrame.length;
	    frames.duration += currentFrame.duration;
	    frames.push(currentFrame);
	    return frames;
	  }; // Convert an array of frames into an array of Gop with each Gop being composed
	  // of the frames that make up that Gop
	  // Also keep track of cummulative data about the Gop from the frames such as the
	  // Gop duration, starting pts, etc.
	
	
	  var groupFramesIntoGops = function groupFramesIntoGops(frames) {
	    var i,
	        currentFrame,
	        currentGop = [],
	        gops = []; // We must pre-set some of the values on the Gop since we
	    // keep running totals of these values
	
	    currentGop.byteLength = 0;
	    currentGop.nalCount = 0;
	    currentGop.duration = 0;
	    currentGop.pts = frames[0].pts;
	    currentGop.dts = frames[0].dts; // store some metadata about all the Gops
	
	    gops.byteLength = 0;
	    gops.nalCount = 0;
	    gops.duration = 0;
	    gops.pts = frames[0].pts;
	    gops.dts = frames[0].dts;
	
	    for (i = 0; i < frames.length; i++) {
	      currentFrame = frames[i];
	
	      if (currentFrame.keyFrame) {
	        // Since the very first frame is expected to be an keyframe
	        // only push to the gops array when currentGop is not empty
	        if (currentGop.length) {
	          gops.push(currentGop);
	          gops.byteLength += currentGop.byteLength;
	          gops.nalCount += currentGop.nalCount;
	          gops.duration += currentGop.duration;
	        }
	
	        currentGop = [currentFrame];
	        currentGop.nalCount = currentFrame.length;
	        currentGop.byteLength = currentFrame.byteLength;
	        currentGop.pts = currentFrame.pts;
	        currentGop.dts = currentFrame.dts;
	        currentGop.duration = currentFrame.duration;
	      } else {
	        currentGop.duration += currentFrame.duration;
	        currentGop.nalCount += currentFrame.length;
	        currentGop.byteLength += currentFrame.byteLength;
	        currentGop.push(currentFrame);
	      }
	    }
	
	    if (gops.length && currentGop.duration <= 0) {
	      currentGop.duration = gops[gops.length - 1].duration;
	    }
	
	    gops.byteLength += currentGop.byteLength;
	    gops.nalCount += currentGop.nalCount;
	    gops.duration += currentGop.duration; // push the final Gop
	
	    gops.push(currentGop);
	    return gops;
	  };
	  /*
	   * Search for the first keyframe in the GOPs and throw away all frames
	   * until that keyframe. Then extend the duration of the pulled keyframe
	   * and pull the PTS and DTS of the keyframe so that it covers the time
	   * range of the frames that were disposed.
	   *
	   * @param {Array} gops video GOPs
	   * @returns {Array} modified video GOPs
	   */
	
	
	  var extendFirstKeyFrame = function extendFirstKeyFrame(gops) {
	    var currentGop;
	
	    if (!gops[0][0].keyFrame && gops.length > 1) {
	      // Remove the first GOP
	      currentGop = gops.shift();
	      gops.byteLength -= currentGop.byteLength;
	      gops.nalCount -= currentGop.nalCount; // Extend the first frame of what is now the
	      // first gop to cover the time period of the
	      // frames we just removed
	
	      gops[0][0].dts = currentGop.dts;
	      gops[0][0].pts = currentGop.pts;
	      gops[0][0].duration += currentGop.duration;
	    }
	
	    return gops;
	  };
	  /**
	   * Default sample object
	   * see ISO/IEC 14496-12:2012, section 8.6.4.3
	   */
	
	
	  var createDefaultSample = function createDefaultSample() {
	    return {
	      size: 0,
	      flags: {
	        isLeading: 0,
	        dependsOn: 1,
	        isDependedOn: 0,
	        hasRedundancy: 0,
	        degradationPriority: 0,
	        isNonSyncSample: 1
	      }
	    };
	  };
	  /*
	   * Collates information from a video frame into an object for eventual
	   * entry into an MP4 sample table.
	   *
	   * @param {Object} frame the video frame
	   * @param {Number} dataOffset the byte offset to position the sample
	   * @return {Object} object containing sample table info for a frame
	   */
	
	
	  var sampleForFrame = function sampleForFrame(frame, dataOffset) {
	    var sample = createDefaultSample();
	    sample.dataOffset = dataOffset;
	    sample.compositionTimeOffset = frame.pts - frame.dts;
	    sample.duration = frame.duration;
	    sample.size = 4 * frame.length; // Space for nal unit size
	
	    sample.size += frame.byteLength;
	
	    if (frame.keyFrame) {
	      sample.flags.dependsOn = 2;
	      sample.flags.isNonSyncSample = 0;
	    }
	
	    return sample;
	  }; // generate the track's sample table from an array of gops
	
	
	  var generateSampleTable$1 = function generateSampleTable(gops, baseDataOffset) {
	    var h,
	        i,
	        sample,
	        currentGop,
	        currentFrame,
	        dataOffset = baseDataOffset || 0,
	        samples = [];
	
	    for (h = 0; h < gops.length; h++) {
	      currentGop = gops[h];
	
	      for (i = 0; i < currentGop.length; i++) {
	        currentFrame = currentGop[i];
	        sample = sampleForFrame(currentFrame, dataOffset);
	        dataOffset += sample.size;
	        samples.push(sample);
	      }
	    }
	
	    return samples;
	  }; // generate the track's raw mdat data from an array of gops
	
	
	  var concatenateNalData = function concatenateNalData(gops) {
	    var h,
	        i,
	        j,
	        currentGop,
	        currentFrame,
	        currentNal,
	        dataOffset = 0,
	        nalsByteLength = gops.byteLength,
	        numberOfNals = gops.nalCount,
	        totalByteLength = nalsByteLength + 4 * numberOfNals,
	        data = new Uint8Array(totalByteLength),
	        view = new DataView(data.buffer); // For each Gop..
	
	    for (h = 0; h < gops.length; h++) {
	      currentGop = gops[h]; // For each Frame..
	
	      for (i = 0; i < currentGop.length; i++) {
	        currentFrame = currentGop[i]; // For each NAL..
	
	        for (j = 0; j < currentFrame.length; j++) {
	          currentNal = currentFrame[j];
	          view.setUint32(dataOffset, currentNal.data.byteLength);
	          dataOffset += 4;
	          data.set(currentNal.data, dataOffset);
	          dataOffset += currentNal.data.byteLength;
	        }
	      }
	    }
	
	    return data;
	  }; // generate the track's sample table from a frame
	
	
	  var generateSampleTableForFrame = function generateSampleTableForFrame(frame, baseDataOffset) {
	    var sample,
	        dataOffset = baseDataOffset || 0,
	        samples = [];
	    sample = sampleForFrame(frame, dataOffset);
	    samples.push(sample);
	    return samples;
	  }; // generate the track's raw mdat data from a frame
	
	
	  var concatenateNalDataForFrame = function concatenateNalDataForFrame(frame) {
	    var i,
	        currentNal,
	        dataOffset = 0,
	        nalsByteLength = frame.byteLength,
	        numberOfNals = frame.length,
	        totalByteLength = nalsByteLength + 4 * numberOfNals,
	        data = new Uint8Array(totalByteLength),
	        view = new DataView(data.buffer); // For each NAL..
	
	    for (i = 0; i < frame.length; i++) {
	      currentNal = frame[i];
	      view.setUint32(dataOffset, currentNal.data.byteLength);
	      dataOffset += 4;
	      data.set(currentNal.data, dataOffset);
	      dataOffset += currentNal.data.byteLength;
	    }
	
	    return data;
	  };
	
	  var frameUtils = {
	    groupNalsIntoFrames: groupNalsIntoFrames,
	    groupFramesIntoGops: groupFramesIntoGops,
	    extendFirstKeyFrame: extendFirstKeyFrame,
	    generateSampleTable: generateSampleTable$1,
	    concatenateNalData: concatenateNalData,
	    generateSampleTableForFrame: generateSampleTableForFrame,
	    concatenateNalDataForFrame: concatenateNalDataForFrame
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var highPrefix = [33, 16, 5, 32, 164, 27];
	  var lowPrefix = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252];
	
	  var zeroFill = function zeroFill(count) {
	    var a = [];
	
	    while (count--) {
	      a.push(0);
	    }
	
	    return a;
	  };
	
	  var makeTable = function makeTable(metaTable) {
	    return Object.keys(metaTable).reduce(function (obj, key) {
	      obj[key] = new Uint8Array(metaTable[key].reduce(function (arr, part) {
	        return arr.concat(part);
	      }, []));
	      return obj;
	    }, {});
	  };
	
	  var silence;
	
	  var silence_1 = function silence_1() {
	    if (!silence) {
	      // Frames-of-silence to use for filling in missing AAC frames
	      var coneOfSilence = {
	        96000: [highPrefix, [227, 64], zeroFill(154), [56]],
	        88200: [highPrefix, [231], zeroFill(170), [56]],
	        64000: [highPrefix, [248, 192], zeroFill(240), [56]],
	        48000: [highPrefix, [255, 192], zeroFill(268), [55, 148, 128], zeroFill(54), [112]],
	        44100: [highPrefix, [255, 192], zeroFill(268), [55, 163, 128], zeroFill(84), [112]],
	        32000: [highPrefix, [255, 192], zeroFill(268), [55, 234], zeroFill(226), [112]],
	        24000: [highPrefix, [255, 192], zeroFill(268), [55, 255, 128], zeroFill(268), [111, 112], zeroFill(126), [224]],
	        16000: [highPrefix, [255, 192], zeroFill(268), [55, 255, 128], zeroFill(268), [111, 255], zeroFill(269), [223, 108], zeroFill(195), [1, 192]],
	        12000: [lowPrefix, zeroFill(268), [3, 127, 248], zeroFill(268), [6, 255, 240], zeroFill(268), [13, 255, 224], zeroFill(268), [27, 253, 128], zeroFill(259), [56]],
	        11025: [lowPrefix, zeroFill(268), [3, 127, 248], zeroFill(268), [6, 255, 240], zeroFill(268), [13, 255, 224], zeroFill(268), [27, 255, 192], zeroFill(268), [55, 175, 128], zeroFill(108), [112]],
	        8000: [lowPrefix, zeroFill(268), [3, 121, 16], zeroFill(47), [7]]
	      };
	      silence = makeTable(coneOfSilence);
	    }
	
	    return silence;
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	
	  var ONE_SECOND_IN_TS$4 = 90000,
	      // 90kHz clock
	  secondsToVideoTs,
	      secondsToAudioTs,
	      videoTsToSeconds,
	      audioTsToSeconds,
	      audioTsToVideoTs,
	      videoTsToAudioTs,
	      metadataTsToSeconds;
	
	  secondsToVideoTs = function secondsToVideoTs(seconds) {
	    return seconds * ONE_SECOND_IN_TS$4;
	  };
	
	  secondsToAudioTs = function secondsToAudioTs(seconds, sampleRate) {
	    return seconds * sampleRate;
	  };
	
	  videoTsToSeconds = function videoTsToSeconds(timestamp) {
	    return timestamp / ONE_SECOND_IN_TS$4;
	  };
	
	  audioTsToSeconds = function audioTsToSeconds(timestamp, sampleRate) {
	    return timestamp / sampleRate;
	  };
	
	  audioTsToVideoTs = function audioTsToVideoTs(timestamp, sampleRate) {
	    return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
	  };
	
	  videoTsToAudioTs = function videoTsToAudioTs(timestamp, sampleRate) {
	    return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
	  };
	  /**
	   * Adjust ID3 tag or caption timing information by the timeline pts values
	   * (if keepOriginalTimestamps is false) and convert to seconds
	   */
	
	
	  metadataTsToSeconds = function metadataTsToSeconds(timestamp, timelineStartPts, keepOriginalTimestamps) {
	    return videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
	  };
	
	  var clock = {
	    ONE_SECOND_IN_TS: ONE_SECOND_IN_TS$4,
	    secondsToVideoTs: secondsToVideoTs,
	    secondsToAudioTs: secondsToAudioTs,
	    videoTsToSeconds: videoTsToSeconds,
	    audioTsToSeconds: audioTsToSeconds,
	    audioTsToVideoTs: audioTsToVideoTs,
	    videoTsToAudioTs: videoTsToAudioTs,
	    metadataTsToSeconds: metadataTsToSeconds
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  /**
	   * Sum the `byteLength` properties of the data in each AAC frame
	   */
	
	  var sumFrameByteLengths = function sumFrameByteLengths(array) {
	    var i,
	        currentObj,
	        sum = 0; // sum the byteLength's all each nal unit in the frame
	
	    for (i = 0; i < array.length; i++) {
	      currentObj = array[i];
	      sum += currentObj.data.byteLength;
	    }
	
	    return sum;
	  }; // Possibly pad (prefix) the audio track with silence if appending this track
	  // would lead to the introduction of a gap in the audio buffer
	
	
	  var prefixWithSilence = function prefixWithSilence(track, frames, audioAppendStartTs, videoBaseMediaDecodeTime) {
	    var baseMediaDecodeTimeTs,
	        frameDuration = 0,
	        audioGapDuration = 0,
	        audioFillFrameCount = 0,
	        audioFillDuration = 0,
	        silentFrame,
	        i,
	        firstFrame;
	
	    if (!frames.length) {
	      return;
	    }
	
	    baseMediaDecodeTimeTs = clock.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate); // determine frame clock duration based on sample rate, round up to avoid overfills
	
	    frameDuration = Math.ceil(clock.ONE_SECOND_IN_TS / (track.samplerate / 1024));
	
	    if (audioAppendStartTs && videoBaseMediaDecodeTime) {
	      // insert the shortest possible amount (audio gap or audio to video gap)
	      audioGapDuration = baseMediaDecodeTimeTs - Math.max(audioAppendStartTs, videoBaseMediaDecodeTime); // number of full frames in the audio gap
	
	      audioFillFrameCount = Math.floor(audioGapDuration / frameDuration);
	      audioFillDuration = audioFillFrameCount * frameDuration;
	    } // don't attempt to fill gaps smaller than a single frame or larger
	    // than a half second
	
	
	    if (audioFillFrameCount < 1 || audioFillDuration > clock.ONE_SECOND_IN_TS / 2) {
	      return;
	    }
	
	    silentFrame = silence_1()[track.samplerate];
	
	    if (!silentFrame) {
	      // we don't have a silent frame pregenerated for the sample rate, so use a frame
	      // from the content instead
	      silentFrame = frames[0].data;
	    }
	
	    for (i = 0; i < audioFillFrameCount; i++) {
	      firstFrame = frames[0];
	      frames.splice(0, 0, {
	        data: silentFrame,
	        dts: firstFrame.dts - frameDuration,
	        pts: firstFrame.pts - frameDuration
	      });
	    }
	
	    track.baseMediaDecodeTime -= Math.floor(clock.videoTsToAudioTs(audioFillDuration, track.samplerate));
	    return audioFillDuration;
	  }; // If the audio segment extends before the earliest allowed dts
	  // value, remove AAC frames until starts at or after the earliest
	  // allowed DTS so that we don't end up with a negative baseMedia-
	  // DecodeTime for the audio track
	
	
	  var trimAdtsFramesByEarliestDts = function trimAdtsFramesByEarliestDts(adtsFrames, track, earliestAllowedDts) {
	    if (track.minSegmentDts >= earliestAllowedDts) {
	      return adtsFrames;
	    } // We will need to recalculate the earliest segment Dts
	
	
	    track.minSegmentDts = Infinity;
	    return adtsFrames.filter(function (currentFrame) {
	      // If this is an allowed frame, keep it and record it's Dts
	      if (currentFrame.dts >= earliestAllowedDts) {
	        track.minSegmentDts = Math.min(track.minSegmentDts, currentFrame.dts);
	        track.minSegmentPts = track.minSegmentDts;
	        return true;
	      } // Otherwise, discard it
	
	
	      return false;
	    });
	  }; // generate the track's raw mdat data from an array of frames
	
	
	  var generateSampleTable = function generateSampleTable(frames) {
	    var i,
	        currentFrame,
	        samples = [];
	
	    for (i = 0; i < frames.length; i++) {
	      currentFrame = frames[i];
	      samples.push({
	        size: currentFrame.data.byteLength,
	        duration: 1024 // For AAC audio, all samples contain 1024 samples
	
	      });
	    }
	
	    return samples;
	  }; // generate the track's sample table from an array of frames
	
	
	  var concatenateFrameData = function concatenateFrameData(frames) {
	    var i,
	        currentFrame,
	        dataOffset = 0,
	        data = new Uint8Array(sumFrameByteLengths(frames));
	
	    for (i = 0; i < frames.length; i++) {
	      currentFrame = frames[i];
	      data.set(currentFrame.data, dataOffset);
	      dataOffset += currentFrame.data.byteLength;
	    }
	
	    return data;
	  };
	
	  var audioFrameUtils = {
	    prefixWithSilence: prefixWithSilence,
	    trimAdtsFramesByEarliestDts: trimAdtsFramesByEarliestDts,
	    generateSampleTable: generateSampleTable,
	    concatenateFrameData: concatenateFrameData
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var ONE_SECOND_IN_TS$3 = clock.ONE_SECOND_IN_TS;
	  /**
	   * Store information about the start and end of the track and the
	   * duration for each frame/sample we process in order to calculate
	   * the baseMediaDecodeTime
	   */
	
	  var collectDtsInfo = function collectDtsInfo(track, data) {
	    if (typeof data.pts === 'number') {
	      if (track.timelineStartInfo.pts === undefined) {
	        track.timelineStartInfo.pts = data.pts;
	      }
	
	      if (track.minSegmentPts === undefined) {
	        track.minSegmentPts = data.pts;
	      } else {
	        track.minSegmentPts = Math.min(track.minSegmentPts, data.pts);
	      }
	
	      if (track.maxSegmentPts === undefined) {
	        track.maxSegmentPts = data.pts;
	      } else {
	        track.maxSegmentPts = Math.max(track.maxSegmentPts, data.pts);
	      }
	    }
	
	    if (typeof data.dts === 'number') {
	      if (track.timelineStartInfo.dts === undefined) {
	        track.timelineStartInfo.dts = data.dts;
	      }
	
	      if (track.minSegmentDts === undefined) {
	        track.minSegmentDts = data.dts;
	      } else {
	        track.minSegmentDts = Math.min(track.minSegmentDts, data.dts);
	      }
	
	      if (track.maxSegmentDts === undefined) {
	        track.maxSegmentDts = data.dts;
	      } else {
	        track.maxSegmentDts = Math.max(track.maxSegmentDts, data.dts);
	      }
	    }
	  };
	  /**
	   * Clear values used to calculate the baseMediaDecodeTime between
	   * tracks
	   */
	
	
	  var clearDtsInfo = function clearDtsInfo(track) {
	    delete track.minSegmentDts;
	    delete track.maxSegmentDts;
	    delete track.minSegmentPts;
	    delete track.maxSegmentPts;
	  };
	  /**
	   * Calculate the track's baseMediaDecodeTime based on the earliest
	   * DTS the transmuxer has ever seen and the minimum DTS for the
	   * current track
	   * @param track {object} track metadata configuration
	   * @param keepOriginalTimestamps {boolean} If true, keep the timestamps
	   *        in the source; false to adjust the first segment to start at 0.
	   */
	
	
	  var calculateTrackBaseMediaDecodeTime = function calculateTrackBaseMediaDecodeTime(track, keepOriginalTimestamps) {
	    var baseMediaDecodeTime,
	        scale,
	        minSegmentDts = track.minSegmentDts; // Optionally adjust the time so the first segment starts at zero.
	
	    if (!keepOriginalTimestamps) {
	      minSegmentDts -= track.timelineStartInfo.dts;
	    } // track.timelineStartInfo.baseMediaDecodeTime is the location, in time, where
	    // we want the start of the first segment to be placed
	
	
	    baseMediaDecodeTime = track.timelineStartInfo.baseMediaDecodeTime; // Add to that the distance this segment is from the very first
	
	    baseMediaDecodeTime += minSegmentDts; // baseMediaDecodeTime must not become negative
	
	    baseMediaDecodeTime = Math.max(0, baseMediaDecodeTime);
	
	    if (track.type === 'audio') {
	      // Audio has a different clock equal to the sampling_rate so we need to
	      // scale the PTS values into the clock rate of the track
	      scale = track.samplerate / ONE_SECOND_IN_TS$3;
	      baseMediaDecodeTime *= scale;
	      baseMediaDecodeTime = Math.floor(baseMediaDecodeTime);
	    }
	
	    return baseMediaDecodeTime;
	  };
	
	  var trackDecodeInfo = {
	    clearDtsInfo: clearDtsInfo,
	    calculateTrackBaseMediaDecodeTime: calculateTrackBaseMediaDecodeTime,
	    collectDtsInfo: collectDtsInfo
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   *
	   * Reads in-band caption information from a video elementary
	   * stream. Captions must follow the CEA-708 standard for injection
	   * into an MPEG-2 transport streams.
	   * @see https://en.wikipedia.org/wiki/CEA-708
	   * @see https://www.gpo.gov/fdsys/pkg/CFR-2007-title47-vol1/pdf/CFR-2007-title47-vol1-sec15-119.pdf
	   */
	  // payload type field to indicate how they are to be
	  // interpreted. CEAS-708 caption content is always transmitted with
	  // payload type 0x04.
	
	  var USER_DATA_REGISTERED_ITU_T_T35 = 4,
	      RBSP_TRAILING_BITS = 128;
	  /**
	    * Parse a supplemental enhancement information (SEI) NAL unit.
	    * Stops parsing once a message of type ITU T T35 has been found.
	    *
	    * @param bytes {Uint8Array} the bytes of a SEI NAL unit
	    * @return {object} the parsed SEI payload
	    * @see Rec. ITU-T H.264, 7.3.2.3.1
	    */
	
	  var parseSei = function parseSei(bytes) {
	    var i = 0,
	        result = {
	      payloadType: -1,
	      payloadSize: 0
	    },
	        payloadType = 0,
	        payloadSize = 0; // go through the sei_rbsp parsing each each individual sei_message
	
	    while (i < bytes.byteLength) {
	      // stop once we have hit the end of the sei_rbsp
	      if (bytes[i] === RBSP_TRAILING_BITS) {
	        break;
	      } // Parse payload type
	
	
	      while (bytes[i] === 0xFF) {
	        payloadType += 255;
	        i++;
	      }
	
	      payloadType += bytes[i++]; // Parse payload size
	
	      while (bytes[i] === 0xFF) {
	        payloadSize += 255;
	        i++;
	      }
	
	      payloadSize += bytes[i++]; // this sei_message is a 608/708 caption so save it and break
	      // there can only ever be one caption message in a frame's sei
	
	      if (!result.payload && payloadType === USER_DATA_REGISTERED_ITU_T_T35) {
	        var userIdentifier = String.fromCharCode(bytes[i + 3], bytes[i + 4], bytes[i + 5], bytes[i + 6]);
	
	        if (userIdentifier === 'GA94') {
	          result.payloadType = payloadType;
	          result.payloadSize = payloadSize;
	          result.payload = bytes.subarray(i, i + payloadSize);
	          break;
	        } else {
	          result.payload = void 0;
	        }
	      } // skip the payload and parse the next message
	
	
	      i += payloadSize;
	      payloadType = 0;
	      payloadSize = 0;
	    }
	
	    return result;
	  }; // see ANSI/SCTE 128-1 (2013), section 8.1
	
	
	  var parseUserData = function parseUserData(sei) {
	    // itu_t_t35_contry_code must be 181 (United States) for
	    // captions
	    if (sei.payload[0] !== 181) {
	      return null;
	    } // itu_t_t35_provider_code should be 49 (ATSC) for captions
	
	
	    if ((sei.payload[1] << 8 | sei.payload[2]) !== 49) {
	      return null;
	    } // the user_identifier should be "GA94" to indicate ATSC1 data
	
	
	    if (String.fromCharCode(sei.payload[3], sei.payload[4], sei.payload[5], sei.payload[6]) !== 'GA94') {
	      return null;
	    } // finally, user_data_type_code should be 0x03 for caption data
	
	
	    if (sei.payload[7] !== 0x03) {
	      return null;
	    } // return the user_data_type_structure and strip the trailing
	    // marker bits
	
	
	    return sei.payload.subarray(8, sei.payload.length - 1);
	  }; // see CEA-708-D, section 4.4
	
	
	  var parseCaptionPackets = function parseCaptionPackets(pts, userData) {
	    var results = [],
	        i,
	        count,
	        offset,
	        data; // if this is just filler, return immediately
	
	    if (!(userData[0] & 0x40)) {
	      return results;
	    } // parse out the cc_data_1 and cc_data_2 fields
	
	
	    count = userData[0] & 0x1f;
	
	    for (i = 0; i < count; i++) {
	      offset = i * 3;
	      data = {
	        type: userData[offset + 2] & 0x03,
	        pts: pts
	      }; // capture cc data when cc_valid is 1
	
	      if (userData[offset + 2] & 0x04) {
	        data.ccData = userData[offset + 3] << 8 | userData[offset + 4];
	        results.push(data);
	      }
	    }
	
	    return results;
	  };
	
	  var discardEmulationPreventionBytes$1 = function discardEmulationPreventionBytes(data) {
	    var length = data.byteLength,
	        emulationPreventionBytesPositions = [],
	        i = 1,
	        newLength,
	        newData; // Find all `Emulation Prevention Bytes`
	
	    while (i < length - 2) {
	      if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
	        emulationPreventionBytesPositions.push(i + 2);
	        i += 2;
	      } else {
	        i++;
	      }
	    } // If no Emulation Prevention Bytes were found just return the original
	    // array
	
	
	    if (emulationPreventionBytesPositions.length === 0) {
	      return data;
	    } // Create a new array to hold the NAL unit data
	
	
	    newLength = length - emulationPreventionBytesPositions.length;
	    newData = new Uint8Array(newLength);
	    var sourceIndex = 0;
	
	    for (i = 0; i < newLength; sourceIndex++, i++) {
	      if (sourceIndex === emulationPreventionBytesPositions[0]) {
	        // Skip this byte
	        sourceIndex++; // Remove this position index
	
	        emulationPreventionBytesPositions.shift();
	      }
	
	      newData[i] = data[sourceIndex];
	    }
	
	    return newData;
	  }; // exports
	
	
	  var captionPacketParser = {
	    parseSei: parseSei,
	    parseUserData: parseUserData,
	    parseCaptionPackets: parseCaptionPackets,
	    discardEmulationPreventionBytes: discardEmulationPreventionBytes$1,
	    USER_DATA_REGISTERED_ITU_T_T35: USER_DATA_REGISTERED_ITU_T_T35
	  }; // Link To Transport
	  // -----------------
	
	  var CaptionStream$1 = function CaptionStream(options) {
	    options = options || {};
	    CaptionStream.prototype.init.call(this); // parse708captions flag, default to true
	
	    this.parse708captions_ = typeof options.parse708captions === 'boolean' ? options.parse708captions : true;
	    this.captionPackets_ = [];
	    this.ccStreams_ = [new Cea608Stream(0, 0), // eslint-disable-line no-use-before-define
	    new Cea608Stream(0, 1), // eslint-disable-line no-use-before-define
	    new Cea608Stream(1, 0), // eslint-disable-line no-use-before-define
	    new Cea608Stream(1, 1) // eslint-disable-line no-use-before-define
	    ];
	
	    if (this.parse708captions_) {
	      this.cc708Stream_ = new Cea708Stream({
	        captionServices: options.captionServices
	      }); // eslint-disable-line no-use-before-define
	    }
	
	    this.reset(); // forward data and done events from CCs to this CaptionStream
	
	    this.ccStreams_.forEach(function (cc) {
	      cc.on('data', this.trigger.bind(this, 'data'));
	      cc.on('partialdone', this.trigger.bind(this, 'partialdone'));
	      cc.on('done', this.trigger.bind(this, 'done'));
	    }, this);
	
	    if (this.parse708captions_) {
	      this.cc708Stream_.on('data', this.trigger.bind(this, 'data'));
	      this.cc708Stream_.on('partialdone', this.trigger.bind(this, 'partialdone'));
	      this.cc708Stream_.on('done', this.trigger.bind(this, 'done'));
	    }
	  };
	
	  CaptionStream$1.prototype = new stream();
	
	  CaptionStream$1.prototype.push = function (event) {
	    var sei, userData, newCaptionPackets; // only examine SEI NALs
	
	    if (event.nalUnitType !== 'sei_rbsp') {
	      return;
	    } // parse the sei
	
	
	    sei = captionPacketParser.parseSei(event.escapedRBSP); // no payload data, skip
	
	    if (!sei.payload) {
	      return;
	    } // ignore everything but user_data_registered_itu_t_t35
	
	
	    if (sei.payloadType !== captionPacketParser.USER_DATA_REGISTERED_ITU_T_T35) {
	      return;
	    } // parse out the user data payload
	
	
	    userData = captionPacketParser.parseUserData(sei); // ignore unrecognized userData
	
	    if (!userData) {
	      return;
	    } // Sometimes, the same segment # will be downloaded twice. To stop the
	    // caption data from being processed twice, we track the latest dts we've
	    // received and ignore everything with a dts before that. However, since
	    // data for a specific dts can be split across packets on either side of
	    // a segment boundary, we need to make sure we *don't* ignore the packets
	    // from the *next* segment that have dts === this.latestDts_. By constantly
	    // tracking the number of packets received with dts === this.latestDts_, we
	    // know how many should be ignored once we start receiving duplicates.
	
	
	    if (event.dts < this.latestDts_) {
	      // We've started getting older data, so set the flag.
	      this.ignoreNextEqualDts_ = true;
	      return;
	    } else if (event.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
	      this.numSameDts_--;
	
	      if (!this.numSameDts_) {
	        // We've received the last duplicate packet, time to start processing again
	        this.ignoreNextEqualDts_ = false;
	      }
	
	      return;
	    } // parse out CC data packets and save them for later
	
	
	    newCaptionPackets = captionPacketParser.parseCaptionPackets(event.pts, userData);
	    this.captionPackets_ = this.captionPackets_.concat(newCaptionPackets);
	
	    if (this.latestDts_ !== event.dts) {
	      this.numSameDts_ = 0;
	    }
	
	    this.numSameDts_++;
	    this.latestDts_ = event.dts;
	  };
	
	  CaptionStream$1.prototype.flushCCStreams = function (flushType) {
	    this.ccStreams_.forEach(function (cc) {
	      return flushType === 'flush' ? cc.flush() : cc.partialFlush();
	    }, this);
	  };
	
	  CaptionStream$1.prototype.flushStream = function (flushType) {
	    // make sure we actually parsed captions before proceeding
	    if (!this.captionPackets_.length) {
	      this.flushCCStreams(flushType);
	      return;
	    } // In Chrome, the Array#sort function is not stable so add a
	    // presortIndex that we can use to ensure we get a stable-sort
	
	
	    this.captionPackets_.forEach(function (elem, idx) {
	      elem.presortIndex = idx;
	    }); // sort caption byte-pairs based on their PTS values
	
	    this.captionPackets_.sort(function (a, b) {
	      if (a.pts === b.pts) {
	        return a.presortIndex - b.presortIndex;
	      }
	
	      return a.pts - b.pts;
	    });
	    this.captionPackets_.forEach(function (packet) {
	      if (packet.type < 2) {
	        // Dispatch packet to the right Cea608Stream
	        this.dispatchCea608Packet(packet);
	      } else {
	        // Dispatch packet to the Cea708Stream
	        this.dispatchCea708Packet(packet);
	      }
	    }, this);
	    this.captionPackets_.length = 0;
	    this.flushCCStreams(flushType);
	  };
	
	  CaptionStream$1.prototype.flush = function () {
	    return this.flushStream('flush');
	  }; // Only called if handling partial data
	
	
	  CaptionStream$1.prototype.partialFlush = function () {
	    return this.flushStream('partialFlush');
	  };
	
	  CaptionStream$1.prototype.reset = function () {
	    this.latestDts_ = null;
	    this.ignoreNextEqualDts_ = false;
	    this.numSameDts_ = 0;
	    this.activeCea608Channel_ = [null, null];
	    this.ccStreams_.forEach(function (ccStream) {
	      ccStream.reset();
	    });
	  }; // From the CEA-608 spec:
	
	  /*
	   * When XDS sub-packets are interleaved with other services, the end of each sub-packet shall be followed
	   * by a control pair to change to a different service. When any of the control codes from 0x10 to 0x1F is
	   * used to begin a control code pair, it indicates the return to captioning or Text data. The control code pair
	   * and subsequent data should then be processed according to the FCC rules. It may be necessary for the
	   * line 21 data encoder to automatically insert a control code pair (i.e. RCL, RU2, RU3, RU4, RDC, or RTD)
	   * to switch to captioning or Text.
	  */
	  // With that in mind, we ignore any data between an XDS control code and a
	  // subsequent closed-captioning control code.
	
	
	  CaptionStream$1.prototype.dispatchCea608Packet = function (packet) {
	    // NOTE: packet.type is the CEA608 field
	    if (this.setsTextOrXDSActive(packet)) {
	      this.activeCea608Channel_[packet.type] = null;
	    } else if (this.setsChannel1Active(packet)) {
	      this.activeCea608Channel_[packet.type] = 0;
	    } else if (this.setsChannel2Active(packet)) {
	      this.activeCea608Channel_[packet.type] = 1;
	    }
	
	    if (this.activeCea608Channel_[packet.type] === null) {
	      // If we haven't received anything to set the active channel, or the
	      // packets are Text/XDS data, discard the data; we don't want jumbled
	      // captions
	      return;
	    }
	
	    this.ccStreams_[(packet.type << 1) + this.activeCea608Channel_[packet.type]].push(packet);
	  };
	
	  CaptionStream$1.prototype.setsChannel1Active = function (packet) {
	    return (packet.ccData & 0x7800) === 0x1000;
	  };
	
	  CaptionStream$1.prototype.setsChannel2Active = function (packet) {
	    return (packet.ccData & 0x7800) === 0x1800;
	  };
	
	  CaptionStream$1.prototype.setsTextOrXDSActive = function (packet) {
	    return (packet.ccData & 0x7100) === 0x0100 || (packet.ccData & 0x78fe) === 0x102a || (packet.ccData & 0x78fe) === 0x182a;
	  };
	
	  CaptionStream$1.prototype.dispatchCea708Packet = function (packet) {
	    if (this.parse708captions_) {
	      this.cc708Stream_.push(packet);
	    }
	  }; // ----------------------
	  // Session to Application
	  // ----------------------
	  // This hash maps special and extended character codes to their
	  // proper Unicode equivalent. The first one-byte key is just a
	  // non-standard character code. The two-byte keys that follow are
	  // the extended CEA708 character codes, along with the preceding
	  // 0x10 extended character byte to distinguish these codes from
	  // non-extended character codes. Every CEA708 character code that
	  // is not in this object maps directly to a standard unicode
	  // character code.
	  // The transparent space and non-breaking transparent space are
	  // technically not fully supported since there is no code to
	  // make them transparent, so they have normal non-transparent
	  // stand-ins.
	  // The special closed caption (CC) character isn't a standard
	  // unicode character, so a fairly similar unicode character was
	  // chosen in it's place.
	
	
	  var CHARACTER_TRANSLATION_708 = {
	    0x7f: 0x266a,
	    // ♪
	    0x1020: 0x20,
	    // Transparent Space
	    0x1021: 0xa0,
	    // Nob-breaking Transparent Space
	    0x1025: 0x2026,
	    // …
	    0x102a: 0x0160,
	    // Š
	    0x102c: 0x0152,
	    // Œ
	    0x1030: 0x2588,
	    // █
	    0x1031: 0x2018,
	    // ‘
	    0x1032: 0x2019,
	    // ’
	    0x1033: 0x201c,
	    // “
	    0x1034: 0x201d,
	    // ”
	    0x1035: 0x2022,
	    // •
	    0x1039: 0x2122,
	    // ™
	    0x103a: 0x0161,
	    // š
	    0x103c: 0x0153,
	    // œ
	    0x103d: 0x2120,
	    // ℠
	    0x103f: 0x0178,
	    // Ÿ
	    0x1076: 0x215b,
	    // ⅛
	    0x1077: 0x215c,
	    // ⅜
	    0x1078: 0x215d,
	    // ⅝
	    0x1079: 0x215e,
	    // ⅞
	    0x107a: 0x23d0,
	    // ⏐
	    0x107b: 0x23a4,
	    // ⎤
	    0x107c: 0x23a3,
	    // ⎣
	    0x107d: 0x23af,
	    // ⎯
	    0x107e: 0x23a6,
	    // ⎦
	    0x107f: 0x23a1,
	    // ⎡
	    0x10a0: 0x3138 // ㄸ (CC char)
	
	  };
	
	  var get708CharFromCode = function get708CharFromCode(code) {
	    var newCode = CHARACTER_TRANSLATION_708[code] || code;
	
	    if (code & 0x1000 && code === newCode) {
	      // Invalid extended code
	      return '';
	    }
	
	    return String.fromCharCode(newCode);
	  };
	
	  var within708TextBlock = function within708TextBlock(b) {
	    return 0x20 <= b && b <= 0x7f || 0xa0 <= b && b <= 0xff;
	  };
	
	  var Cea708Window = function Cea708Window(windowNum) {
	    this.windowNum = windowNum;
	    this.reset();
	  };
	
	  Cea708Window.prototype.reset = function () {
	    this.clearText();
	    this.pendingNewLine = false;
	    this.winAttr = {};
	    this.penAttr = {};
	    this.penLoc = {};
	    this.penColor = {}; // These default values are arbitrary,
	    // defineWindow will usually override them
	
	    this.visible = 0;
	    this.rowLock = 0;
	    this.columnLock = 0;
	    this.priority = 0;
	    this.relativePositioning = 0;
	    this.anchorVertical = 0;
	    this.anchorHorizontal = 0;
	    this.anchorPoint = 0;
	    this.rowCount = 1;
	    this.virtualRowCount = this.rowCount + 1;
	    this.columnCount = 41;
	    this.windowStyle = 0;
	    this.penStyle = 0;
	  };
	
	  Cea708Window.prototype.getText = function () {
	    return this.rows.join('\n');
	  };
	
	  Cea708Window.prototype.clearText = function () {
	    this.rows = [''];
	    this.rowIdx = 0;
	  };
	
	  Cea708Window.prototype.newLine = function (pts) {
	    if (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow === 'function') {
	      this.beforeRowOverflow(pts);
	    }
	
	    if (this.rows.length > 0) {
	      this.rows.push('');
	      this.rowIdx++;
	    } // Show all virtual rows since there's no visible scrolling
	
	
	    while (this.rows.length > this.virtualRowCount) {
	      this.rows.shift();
	      this.rowIdx--;
	    }
	  };
	
	  Cea708Window.prototype.isEmpty = function () {
	    if (this.rows.length === 0) {
	      return true;
	    } else if (this.rows.length === 1) {
	      return this.rows[0] === '';
	    }
	
	    return false;
	  };
	
	  Cea708Window.prototype.addText = function (text) {
	    this.rows[this.rowIdx] += text;
	  };
	
	  Cea708Window.prototype.backspace = function () {
	    if (!this.isEmpty()) {
	      var row = this.rows[this.rowIdx];
	      this.rows[this.rowIdx] = row.substr(0, row.length - 1);
	    }
	  };
	
	  var Cea708Service = function Cea708Service(serviceNum, encoding, stream) {
	    this.serviceNum = serviceNum;
	    this.text = '';
	    this.currentWindow = new Cea708Window(-1);
	    this.windows = [];
	    this.stream = stream; // Try to setup a TextDecoder if an `encoding` value was provided
	
	    if (typeof encoding === 'string') {
	      this.createTextDecoder(encoding);
	    }
	  };
	  /**
	   * Initialize service windows
	   * Must be run before service use
	   *
	   * @param  {Integer}  pts               PTS value
	   * @param  {Function} beforeRowOverflow Function to execute before row overflow of a window
	   */
	
	
	  Cea708Service.prototype.init = function (pts, beforeRowOverflow) {
	    this.startPts = pts;
	
	    for (var win = 0; win < 8; win++) {
	      this.windows[win] = new Cea708Window(win);
	
	      if (typeof beforeRowOverflow === 'function') {
	        this.windows[win].beforeRowOverflow = beforeRowOverflow;
	      }
	    }
	  };
	  /**
	   * Set current window of service to be affected by commands
	   *
	   * @param  {Integer} windowNum Window number
	   */
	
	
	  Cea708Service.prototype.setCurrentWindow = function (windowNum) {
	    this.currentWindow = this.windows[windowNum];
	  };
	  /**
	   * Try to create a TextDecoder if it is natively supported
	   */
	
	
	  Cea708Service.prototype.createTextDecoder = function (encoding) {
	    if (typeof TextDecoder === 'undefined') {
	      this.stream.trigger('log', {
	        level: 'warn',
	        message: 'The `encoding` option is unsupported without TextDecoder support'
	      });
	    } else {
	      try {
	        this.textDecoder_ = new TextDecoder(encoding);
	      } catch (error) {
	        this.stream.trigger('log', {
	          level: 'warn',
	          message: 'TextDecoder could not be created with ' + encoding + ' encoding. ' + error
	        });
	      }
	    }
	  };
	
	  var Cea708Stream = function Cea708Stream(options) {
	    options = options || {};
	    Cea708Stream.prototype.init.call(this);
	    var self = this;
	    var captionServices = options.captionServices || {};
	    var captionServiceEncodings = {};
	    var serviceProps; // Get service encodings from captionServices option block
	
	    Object.keys(captionServices).forEach(function (serviceName) {
	      serviceProps = captionServices[serviceName];
	
	      if (/^SERVICE/.test(serviceName)) {
	        captionServiceEncodings[serviceName] = serviceProps.encoding;
	      }
	    });
	    this.serviceEncodings = captionServiceEncodings;
	    this.current708Packet = null;
	    this.services = {};
	
	    this.push = function (packet) {
	      if (packet.type === 3) {
	        // 708 packet start
	        self.new708Packet();
	        self.add708Bytes(packet);
	      } else {
	        if (self.current708Packet === null) {
	          // This should only happen at the start of a file if there's no packet start.
	          self.new708Packet();
	        }
	
	        self.add708Bytes(packet);
	      }
	    };
	  };
	
	  Cea708Stream.prototype = new stream();
	  /**
	   * Push current 708 packet, create new 708 packet.
	   */
	
	  Cea708Stream.prototype.new708Packet = function () {
	    if (this.current708Packet !== null) {
	      this.push708Packet();
	    }
	
	    this.current708Packet = {
	      data: [],
	      ptsVals: []
	    };
	  };
	  /**
	   * Add pts and both bytes from packet into current 708 packet.
	   */
	
	
	  Cea708Stream.prototype.add708Bytes = function (packet) {
	    var data = packet.ccData;
	    var byte0 = data >>> 8;
	    var byte1 = data & 0xff; // I would just keep a list of packets instead of bytes, but it isn't clear in the spec
	    // that service blocks will always line up with byte pairs.
	
	    this.current708Packet.ptsVals.push(packet.pts);
	    this.current708Packet.data.push(byte0);
	    this.current708Packet.data.push(byte1);
	  };
	  /**
	   * Parse completed 708 packet into service blocks and push each service block.
	   */
	
	
	  Cea708Stream.prototype.push708Packet = function () {
	    var packet708 = this.current708Packet;
	    var packetData = packet708.data;
	    var serviceNum = null;
	    var blockSize = null;
	    var i = 0;
	    var b = packetData[i++];
	    packet708.seq = b >> 6;
	    packet708.sizeCode = b & 0x3f; // 0b00111111;
	
	    for (; i < packetData.length; i++) {
	      b = packetData[i++];
	      serviceNum = b >> 5;
	      blockSize = b & 0x1f; // 0b00011111
	
	      if (serviceNum === 7 && blockSize > 0) {
	        // Extended service num
	        b = packetData[i++];
	        serviceNum = b;
	      }
	
	      this.pushServiceBlock(serviceNum, i, blockSize);
	
	      if (blockSize > 0) {
	        i += blockSize - 1;
	      }
	    }
	  };
	  /**
	   * Parse service block, execute commands, read text.
	   *
	   * Note: While many of these commands serve important purposes,
	   * many others just parse out the parameters or attributes, but
	   * nothing is done with them because this is not a full and complete
	   * implementation of the entire 708 spec.
	   *
	   * @param  {Integer} serviceNum Service number
	   * @param  {Integer} start      Start index of the 708 packet data
	   * @param  {Integer} size       Block size
	   */
	
	
	  Cea708Stream.prototype.pushServiceBlock = function (serviceNum, start, size) {
	    var b;
	    var i = start;
	    var packetData = this.current708Packet.data;
	    var service = this.services[serviceNum];
	
	    if (!service) {
	      service = this.initService(serviceNum, i);
	    }
	
	    for (; i < start + size && i < packetData.length; i++) {
	      b = packetData[i];
	
	      if (within708TextBlock(b)) {
	        i = this.handleText(i, service);
	      } else if (b === 0x18) {
	        i = this.multiByteCharacter(i, service);
	      } else if (b === 0x10) {
	        i = this.extendedCommands(i, service);
	      } else if (0x80 <= b && b <= 0x87) {
	        i = this.setCurrentWindow(i, service);
	      } else if (0x98 <= b && b <= 0x9f) {
	        i = this.defineWindow(i, service);
	      } else if (b === 0x88) {
	        i = this.clearWindows(i, service);
	      } else if (b === 0x8c) {
	        i = this.deleteWindows(i, service);
	      } else if (b === 0x89) {
	        i = this.displayWindows(i, service);
	      } else if (b === 0x8a) {
	        i = this.hideWindows(i, service);
	      } else if (b === 0x8b) {
	        i = this.toggleWindows(i, service);
	      } else if (b === 0x97) {
	        i = this.setWindowAttributes(i, service);
	      } else if (b === 0x90) {
	        i = this.setPenAttributes(i, service);
	      } else if (b === 0x91) {
	        i = this.setPenColor(i, service);
	      } else if (b === 0x92) {
	        i = this.setPenLocation(i, service);
	      } else if (b === 0x8f) {
	        service = this.reset(i, service);
	      } else if (b === 0x08) {
	        // BS: Backspace
	        service.currentWindow.backspace();
	      } else if (b === 0x0c) {
	        // FF: Form feed
	        service.currentWindow.clearText();
	      } else if (b === 0x0d) {
	        // CR: Carriage return
	        service.currentWindow.pendingNewLine = true;
	      } else if (b === 0x0e) {
	        // HCR: Horizontal carriage return
	        service.currentWindow.clearText();
	      } else if (b === 0x8d) {
	        // DLY: Delay, nothing to do
	        i++;
	      } else ;
	    }
	  };
	  /**
	   * Execute an extended command
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.extendedCommands = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	
	    if (within708TextBlock(b)) {
	      i = this.handleText(i, service, {
	        isExtended: true
	      });
	    }
	
	    return i;
	  };
	  /**
	   * Get PTS value of a given byte index
	   *
	   * @param  {Integer} byteIndex  Index of the byte
	   * @return {Integer}            PTS
	   */
	
	
	  Cea708Stream.prototype.getPts = function (byteIndex) {
	    // There's 1 pts value per 2 bytes
	    return this.current708Packet.ptsVals[Math.floor(byteIndex / 2)];
	  };
	  /**
	   * Initializes a service
	   *
	   * @param  {Integer} serviceNum Service number
	   * @return {Service}            Initialized service object
	   */
	
	
	  Cea708Stream.prototype.initService = function (serviceNum, i) {
	    var serviceName = 'SERVICE' + serviceNum;
	    var self = this;
	    var serviceName;
	    var encoding;
	
	    if (serviceName in this.serviceEncodings) {
	      encoding = this.serviceEncodings[serviceName];
	    }
	
	    this.services[serviceNum] = new Cea708Service(serviceNum, encoding, self);
	    this.services[serviceNum].init(this.getPts(i), function (pts) {
	      self.flushDisplayed(pts, self.services[serviceNum]);
	    });
	    return this.services[serviceNum];
	  };
	  /**
	   * Execute text writing to current window
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.handleText = function (i, service, options) {
	    var isExtended = options && options.isExtended;
	    var isMultiByte = options && options.isMultiByte;
	    var packetData = this.current708Packet.data;
	    var extended = isExtended ? 0x1000 : 0x0000;
	    var currentByte = packetData[i];
	    var nextByte = packetData[i + 1];
	    var win = service.currentWindow;
	
	    var _char;
	
	    var charCodeArray; // Use the TextDecoder if one was created for this service
	
	    if (service.textDecoder_ && !isExtended) {
	      if (isMultiByte) {
	        charCodeArray = [currentByte, nextByte];
	        i++;
	      } else {
	        charCodeArray = [currentByte];
	      }
	
	      _char = service.textDecoder_.decode(new Uint8Array(charCodeArray));
	    } else {
	      _char = get708CharFromCode(extended | currentByte);
	    }
	
	    if (win.pendingNewLine && !win.isEmpty()) {
	      win.newLine(this.getPts(i));
	    }
	
	    win.pendingNewLine = false;
	    win.addText(_char);
	    return i;
	  };
	  /**
	   * Handle decoding of multibyte character
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.multiByteCharacter = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var firstByte = packetData[i + 1];
	    var secondByte = packetData[i + 2];
	
	    if (within708TextBlock(firstByte) && within708TextBlock(secondByte)) {
	      i = this.handleText(++i, service, {
	        isMultiByte: true
	      });
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the CW# command.
	   *
	   * Set the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setCurrentWindow = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var windowNum = b & 0x07;
	    service.setCurrentWindow(windowNum);
	    return i;
	  };
	  /**
	   * Parse and execute the DF# command.
	   *
	   * Define a window and set it as the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.defineWindow = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var windowNum = b & 0x07;
	    service.setCurrentWindow(windowNum);
	    var win = service.currentWindow;
	    b = packetData[++i];
	    win.visible = (b & 0x20) >> 5; // v
	
	    win.rowLock = (b & 0x10) >> 4; // rl
	
	    win.columnLock = (b & 0x08) >> 3; // cl
	
	    win.priority = b & 0x07; // p
	
	    b = packetData[++i];
	    win.relativePositioning = (b & 0x80) >> 7; // rp
	
	    win.anchorVertical = b & 0x7f; // av
	
	    b = packetData[++i];
	    win.anchorHorizontal = b; // ah
	
	    b = packetData[++i];
	    win.anchorPoint = (b & 0xf0) >> 4; // ap
	
	    win.rowCount = b & 0x0f; // rc
	
	    b = packetData[++i];
	    win.columnCount = b & 0x3f; // cc
	
	    b = packetData[++i];
	    win.windowStyle = (b & 0x38) >> 3; // ws
	
	    win.penStyle = b & 0x07; // ps
	    // The spec says there are (rowCount+1) "virtual rows"
	
	    win.virtualRowCount = win.rowCount + 1;
	    return i;
	  };
	  /**
	   * Parse and execute the SWA command.
	   *
	   * Set attributes of the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setWindowAttributes = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var winAttr = service.currentWindow.winAttr;
	    b = packetData[++i];
	    winAttr.fillOpacity = (b & 0xc0) >> 6; // fo
	
	    winAttr.fillRed = (b & 0x30) >> 4; // fr
	
	    winAttr.fillGreen = (b & 0x0c) >> 2; // fg
	
	    winAttr.fillBlue = b & 0x03; // fb
	
	    b = packetData[++i];
	    winAttr.borderType = (b & 0xc0) >> 6; // bt
	
	    winAttr.borderRed = (b & 0x30) >> 4; // br
	
	    winAttr.borderGreen = (b & 0x0c) >> 2; // bg
	
	    winAttr.borderBlue = b & 0x03; // bb
	
	    b = packetData[++i];
	    winAttr.borderType += (b & 0x80) >> 5; // bt
	
	    winAttr.wordWrap = (b & 0x40) >> 6; // ww
	
	    winAttr.printDirection = (b & 0x30) >> 4; // pd
	
	    winAttr.scrollDirection = (b & 0x0c) >> 2; // sd
	
	    winAttr.justify = b & 0x03; // j
	
	    b = packetData[++i];
	    winAttr.effectSpeed = (b & 0xf0) >> 4; // es
	
	    winAttr.effectDirection = (b & 0x0c) >> 2; // ed
	
	    winAttr.displayEffect = b & 0x03; // de
	
	    return i;
	  };
	  /**
	   * Gather text from all displayed windows and push a caption to output.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   */
	
	
	  Cea708Stream.prototype.flushDisplayed = function (pts, service) {
	    var displayedText = []; // TODO: Positioning not supported, displaying multiple windows will not necessarily
	    // display text in the correct order, but sample files so far have not shown any issue.
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (service.windows[winId].visible && !service.windows[winId].isEmpty()) {
	        displayedText.push(service.windows[winId].getText());
	      }
	    }
	
	    service.endPts = pts;
	    service.text = displayedText.join('\n\n');
	    this.pushCaption(service);
	    service.startPts = pts;
	  };
	  /**
	   * Push a caption to output if the caption contains text.
	   *
	   * @param  {Service} service  The service object to be affected
	   */
	
	
	  Cea708Stream.prototype.pushCaption = function (service) {
	    if (service.text !== '') {
	      this.trigger('data', {
	        startPts: service.startPts,
	        endPts: service.endPts,
	        text: service.text,
	        stream: 'cc708_' + service.serviceNum
	      });
	      service.text = '';
	      service.startPts = service.endPts;
	    }
	  };
	  /**
	   * Parse and execute the DSW command.
	   *
	   * Set visible property of windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.displayWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].visible = 1;
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the HDW command.
	   *
	   * Set visible property of windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.hideWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].visible = 0;
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the TGW command.
	   *
	   * Set visible property of windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.toggleWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].visible ^= 1;
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the CLW command.
	   *
	   * Clear text of windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.clearWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].clearText();
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the DLW command.
	   *
	   * Re-initialize windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.deleteWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].reset();
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the SPA command.
	   *
	   * Set pen attributes of the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setPenAttributes = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var penAttr = service.currentWindow.penAttr;
	    b = packetData[++i];
	    penAttr.textTag = (b & 0xf0) >> 4; // tt
	
	    penAttr.offset = (b & 0x0c) >> 2; // o
	
	    penAttr.penSize = b & 0x03; // s
	
	    b = packetData[++i];
	    penAttr.italics = (b & 0x80) >> 7; // i
	
	    penAttr.underline = (b & 0x40) >> 6; // u
	
	    penAttr.edgeType = (b & 0x38) >> 3; // et
	
	    penAttr.fontStyle = b & 0x07; // fs
	
	    return i;
	  };
	  /**
	   * Parse and execute the SPC command.
	   *
	   * Set pen color of the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setPenColor = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var penColor = service.currentWindow.penColor;
	    b = packetData[++i];
	    penColor.fgOpacity = (b & 0xc0) >> 6; // fo
	
	    penColor.fgRed = (b & 0x30) >> 4; // fr
	
	    penColor.fgGreen = (b & 0x0c) >> 2; // fg
	
	    penColor.fgBlue = b & 0x03; // fb
	
	    b = packetData[++i];
	    penColor.bgOpacity = (b & 0xc0) >> 6; // bo
	
	    penColor.bgRed = (b & 0x30) >> 4; // br
	
	    penColor.bgGreen = (b & 0x0c) >> 2; // bg
	
	    penColor.bgBlue = b & 0x03; // bb
	
	    b = packetData[++i];
	    penColor.edgeRed = (b & 0x30) >> 4; // er
	
	    penColor.edgeGreen = (b & 0x0c) >> 2; // eg
	
	    penColor.edgeBlue = b & 0x03; // eb
	
	    return i;
	  };
	  /**
	   * Parse and execute the SPL command.
	   *
	   * Set pen location of the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setPenLocation = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var penLoc = service.currentWindow.penLoc; // Positioning isn't really supported at the moment, so this essentially just inserts a linebreak
	
	    service.currentWindow.pendingNewLine = true;
	    b = packetData[++i];
	    penLoc.row = b & 0x0f; // r
	
	    b = packetData[++i];
	    penLoc.column = b & 0x3f; // c
	
	    return i;
	  };
	  /**
	   * Execute the RST command.
	   *
	   * Reset service to a clean slate. Re-initialize.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Service}          Re-initialized service
	   */
	
	
	  Cea708Stream.prototype.reset = function (i, service) {
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	    return this.initService(service.serviceNum, i);
	  }; // This hash maps non-ASCII, special, and extended character codes to their
	  // proper Unicode equivalent. The first keys that are only a single byte
	  // are the non-standard ASCII characters, which simply map the CEA608 byte
	  // to the standard ASCII/Unicode. The two-byte keys that follow are the CEA608
	  // character codes, but have their MSB bitmasked with 0x03 so that a lookup
	  // can be performed regardless of the field and data channel on which the
	  // character code was received.
	
	
	  var CHARACTER_TRANSLATION = {
	    0x2a: 0xe1,
	    // á
	    0x5c: 0xe9,
	    // é
	    0x5e: 0xed,
	    // í
	    0x5f: 0xf3,
	    // ó
	    0x60: 0xfa,
	    // ú
	    0x7b: 0xe7,
	    // ç
	    0x7c: 0xf7,
	    // ÷
	    0x7d: 0xd1,
	    // Ñ
	    0x7e: 0xf1,
	    // ñ
	    0x7f: 0x2588,
	    // █
	    0x0130: 0xae,
	    // ®
	    0x0131: 0xb0,
	    // °
	    0x0132: 0xbd,
	    // ½
	    0x0133: 0xbf,
	    // ¿
	    0x0134: 0x2122,
	    // ™
	    0x0135: 0xa2,
	    // ¢
	    0x0136: 0xa3,
	    // £
	    0x0137: 0x266a,
	    // ♪
	    0x0138: 0xe0,
	    // à
	    0x0139: 0xa0,
	    //
	    0x013a: 0xe8,
	    // è
	    0x013b: 0xe2,
	    // â
	    0x013c: 0xea,
	    // ê
	    0x013d: 0xee,
	    // î
	    0x013e: 0xf4,
	    // ô
	    0x013f: 0xfb,
	    // û
	    0x0220: 0xc1,
	    // Á
	    0x0221: 0xc9,
	    // É
	    0x0222: 0xd3,
	    // Ó
	    0x0223: 0xda,
	    // Ú
	    0x0224: 0xdc,
	    // Ü
	    0x0225: 0xfc,
	    // ü
	    0x0226: 0x2018,
	    // ‘
	    0x0227: 0xa1,
	    // ¡
	    0x0228: 0x2a,
	    // *
	    0x0229: 0x27,
	    // '
	    0x022a: 0x2014,
	    // —
	    0x022b: 0xa9,
	    // ©
	    0x022c: 0x2120,
	    // ℠
	    0x022d: 0x2022,
	    // •
	    0x022e: 0x201c,
	    // “
	    0x022f: 0x201d,
	    // ”
	    0x0230: 0xc0,
	    // À
	    0x0231: 0xc2,
	    // Â
	    0x0232: 0xc7,
	    // Ç
	    0x0233: 0xc8,
	    // È
	    0x0234: 0xca,
	    // Ê
	    0x0235: 0xcb,
	    // Ë
	    0x0236: 0xeb,
	    // ë
	    0x0237: 0xce,
	    // Î
	    0x0238: 0xcf,
	    // Ï
	    0x0239: 0xef,
	    // ï
	    0x023a: 0xd4,
	    // Ô
	    0x023b: 0xd9,
	    // Ù
	    0x023c: 0xf9,
	    // ù
	    0x023d: 0xdb,
	    // Û
	    0x023e: 0xab,
	    // «
	    0x023f: 0xbb,
	    // »
	    0x0320: 0xc3,
	    // Ã
	    0x0321: 0xe3,
	    // ã
	    0x0322: 0xcd,
	    // Í
	    0x0323: 0xcc,
	    // Ì
	    0x0324: 0xec,
	    // ì
	    0x0325: 0xd2,
	    // Ò
	    0x0326: 0xf2,
	    // ò
	    0x0327: 0xd5,
	    // Õ
	    0x0328: 0xf5,
	    // õ
	    0x0329: 0x7b,
	    // {
	    0x032a: 0x7d,
	    // }
	    0x032b: 0x5c,
	    // \
	    0x032c: 0x5e,
	    // ^
	    0x032d: 0x5f,
	    // _
	    0x032e: 0x7c,
	    // |
	    0x032f: 0x7e,
	    // ~
	    0x0330: 0xc4,
	    // Ä
	    0x0331: 0xe4,
	    // ä
	    0x0332: 0xd6,
	    // Ö
	    0x0333: 0xf6,
	    // ö
	    0x0334: 0xdf,
	    // ß
	    0x0335: 0xa5,
	    // ¥
	    0x0336: 0xa4,
	    // ¤
	    0x0337: 0x2502,
	    // │
	    0x0338: 0xc5,
	    // Å
	    0x0339: 0xe5,
	    // å
	    0x033a: 0xd8,
	    // Ø
	    0x033b: 0xf8,
	    // ø
	    0x033c: 0x250c,
	    // ┌
	    0x033d: 0x2510,
	    // ┐
	    0x033e: 0x2514,
	    // └
	    0x033f: 0x2518 // ┘
	
	  };
	
	  var getCharFromCode = function getCharFromCode(code) {
	    if (code === null) {
	      return '';
	    }
	
	    code = CHARACTER_TRANSLATION[code] || code;
	    return String.fromCharCode(code);
	  }; // the index of the last row in a CEA-608 display buffer
	
	
	  var BOTTOM_ROW = 14; // This array is used for mapping PACs -> row #, since there's no way of
	  // getting it through bit logic.
	
	  var ROWS = [0x1100, 0x1120, 0x1200, 0x1220, 0x1500, 0x1520, 0x1600, 0x1620, 0x1700, 0x1720, 0x1000, 0x1300, 0x1320, 0x1400, 0x1420]; // CEA-608 captions are rendered onto a 34x15 matrix of character
	  // cells. The "bottom" row is the last element in the outer array.
	
	  var createDisplayBuffer = function createDisplayBuffer() {
	    var result = [],
	        i = BOTTOM_ROW + 1;
	
	    while (i--) {
	      result.push('');
	    }
	
	    return result;
	  };
	
	  var Cea608Stream = function Cea608Stream(field, dataChannel) {
	    Cea608Stream.prototype.init.call(this);
	    this.field_ = field || 0;
	    this.dataChannel_ = dataChannel || 0;
	    this.name_ = 'CC' + ((this.field_ << 1 | this.dataChannel_) + 1);
	    this.setConstants();
	    this.reset();
	
	    this.push = function (packet) {
	      var data, swap, char0, char1, text; // remove the parity bits
	
	      data = packet.ccData & 0x7f7f; // ignore duplicate control codes; the spec demands they're sent twice
	
	      if (data === this.lastControlCode_) {
	        this.lastControlCode_ = null;
	        return;
	      } // Store control codes
	
	
	      if ((data & 0xf000) === 0x1000) {
	        this.lastControlCode_ = data;
	      } else if (data !== this.PADDING_) {
	        this.lastControlCode_ = null;
	      }
	
	      char0 = data >>> 8;
	      char1 = data & 0xff;
	
	      if (data === this.PADDING_) {
	        return;
	      } else if (data === this.RESUME_CAPTION_LOADING_) {
	        this.mode_ = 'popOn';
	      } else if (data === this.END_OF_CAPTION_) {
	        // If an EOC is received while in paint-on mode, the displayed caption
	        // text should be swapped to non-displayed memory as if it was a pop-on
	        // caption. Because of that, we should explicitly switch back to pop-on
	        // mode
	        this.mode_ = 'popOn';
	        this.clearFormatting(packet.pts); // if a caption was being displayed, it's gone now
	
	        this.flushDisplayed(packet.pts); // flip memory
	
	        swap = this.displayed_;
	        this.displayed_ = this.nonDisplayed_;
	        this.nonDisplayed_ = swap; // start measuring the time to display the caption
	
	        this.startPts_ = packet.pts;
	      } else if (data === this.ROLL_UP_2_ROWS_) {
	        this.rollUpRows_ = 2;
	        this.setRollUp(packet.pts);
	      } else if (data === this.ROLL_UP_3_ROWS_) {
	        this.rollUpRows_ = 3;
	        this.setRollUp(packet.pts);
	      } else if (data === this.ROLL_UP_4_ROWS_) {
	        this.rollUpRows_ = 4;
	        this.setRollUp(packet.pts);
	      } else if (data === this.CARRIAGE_RETURN_) {
	        this.clearFormatting(packet.pts);
	        this.flushDisplayed(packet.pts);
	        this.shiftRowsUp_();
	        this.startPts_ = packet.pts;
	      } else if (data === this.BACKSPACE_) {
	        if (this.mode_ === 'popOn') {
	          this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1);
	        } else {
	          this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
	        }
	      } else if (data === this.ERASE_DISPLAYED_MEMORY_) {
	        this.flushDisplayed(packet.pts);
	        this.displayed_ = createDisplayBuffer();
	      } else if (data === this.ERASE_NON_DISPLAYED_MEMORY_) {
	        this.nonDisplayed_ = createDisplayBuffer();
	      } else if (data === this.RESUME_DIRECT_CAPTIONING_) {
	        if (this.mode_ !== 'paintOn') {
	          // NOTE: This should be removed when proper caption positioning is
	          // implemented
	          this.flushDisplayed(packet.pts);
	          this.displayed_ = createDisplayBuffer();
	        }
	
	        this.mode_ = 'paintOn';
	        this.startPts_ = packet.pts; // Append special characters to caption text
	      } else if (this.isSpecialCharacter(char0, char1)) {
	        // Bitmask char0 so that we can apply character transformations
	        // regardless of field and data channel.
	        // Then byte-shift to the left and OR with char1 so we can pass the
	        // entire character code to `getCharFromCode`.
	        char0 = (char0 & 0x03) << 8;
	        text = getCharFromCode(char0 | char1);
	        this[this.mode_](packet.pts, text);
	        this.column_++; // Append extended characters to caption text
	      } else if (this.isExtCharacter(char0, char1)) {
	        // Extended characters always follow their "non-extended" equivalents.
	        // IE if a "è" is desired, you'll always receive "eè"; non-compliant
	        // decoders are supposed to drop the "è", while compliant decoders
	        // backspace the "e" and insert "è".
	        // Delete the previous character
	        if (this.mode_ === 'popOn') {
	          this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1);
	        } else {
	          this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
	        } // Bitmask char0 so that we can apply character transformations
	        // regardless of field and data channel.
	        // Then byte-shift to the left and OR with char1 so we can pass the
	        // entire character code to `getCharFromCode`.
	
	
	        char0 = (char0 & 0x03) << 8;
	        text = getCharFromCode(char0 | char1);
	        this[this.mode_](packet.pts, text);
	        this.column_++; // Process mid-row codes
	      } else if (this.isMidRowCode(char0, char1)) {
	        // Attributes are not additive, so clear all formatting
	        this.clearFormatting(packet.pts); // According to the standard, mid-row codes
	        // should be replaced with spaces, so add one now
	
	        this[this.mode_](packet.pts, ' ');
	        this.column_++;
	
	        if ((char1 & 0xe) === 0xe) {
	          this.addFormatting(packet.pts, ['i']);
	        }
	
	        if ((char1 & 0x1) === 0x1) {
	          this.addFormatting(packet.pts, ['u']);
	        } // Detect offset control codes and adjust cursor
	
	      } else if (this.isOffsetControlCode(char0, char1)) {
	        // Cursor position is set by indent PAC (see below) in 4-column
	        // increments, with an additional offset code of 1-3 to reach any
	        // of the 32 columns specified by CEA-608. So all we need to do
	        // here is increment the column cursor by the given offset.
	        this.column_ += char1 & 0x03; // Detect PACs (Preamble Address Codes)
	      } else if (this.isPAC(char0, char1)) {
	        // There's no logic for PAC -> row mapping, so we have to just
	        // find the row code in an array and use its index :(
	        var row = ROWS.indexOf(data & 0x1f20); // Configure the caption window if we're in roll-up mode
	
	        if (this.mode_ === 'rollUp') {
	          // This implies that the base row is incorrectly set.
	          // As per the recommendation in CEA-608(Base Row Implementation), defer to the number
	          // of roll-up rows set.
	          if (row - this.rollUpRows_ + 1 < 0) {
	            row = this.rollUpRows_ - 1;
	          }
	
	          this.setRollUp(packet.pts, row);
	        }
	
	        if (row !== this.row_) {
	          // formatting is only persistent for current row
	          this.clearFormatting(packet.pts);
	          this.row_ = row;
	        } // All PACs can apply underline, so detect and apply
	        // (All odd-numbered second bytes set underline)
	
	
	        if (char1 & 0x1 && this.formatting_.indexOf('u') === -1) {
	          this.addFormatting(packet.pts, ['u']);
	        }
	
	        if ((data & 0x10) === 0x10) {
	          // We've got an indent level code. Each successive even number
	          // increments the column cursor by 4, so we can get the desired
	          // column position by bit-shifting to the right (to get n/2)
	          // and multiplying by 4.
	          this.column_ = ((data & 0xe) >> 1) * 4;
	        }
	
	        if (this.isColorPAC(char1)) {
	          // it's a color code, though we only support white, which
	          // can be either normal or italicized. white italics can be
	          // either 0x4e or 0x6e depending on the row, so we just
	          // bitwise-and with 0xe to see if italics should be turned on
	          if ((char1 & 0xe) === 0xe) {
	            this.addFormatting(packet.pts, ['i']);
	          }
	        } // We have a normal character in char0, and possibly one in char1
	
	      } else if (this.isNormalChar(char0)) {
	        if (char1 === 0x00) {
	          char1 = null;
	        }
	
	        text = getCharFromCode(char0);
	        text += getCharFromCode(char1);
	        this[this.mode_](packet.pts, text);
	        this.column_ += text.length;
	      } // finish data processing
	
	    };
	  };
	
	  Cea608Stream.prototype = new stream(); // Trigger a cue point that captures the current state of the
	  // display buffer
	
	  Cea608Stream.prototype.flushDisplayed = function (pts) {
	    var content = this.displayed_ // remove spaces from the start and end of the string
	    .map(function (row, index) {
	      try {
	        return row.trim();
	      } catch (e) {
	        // Ordinarily, this shouldn't happen. However, caption
	        // parsing errors should not throw exceptions and
	        // break playback.
	        this.trigger('log', {
	          level: 'warn',
	          message: 'Skipping a malformed 608 caption at index ' + index + '.'
	        });
	        return '';
	      }
	    }, this) // combine all text rows to display in one cue
	    .join('\n') // and remove blank rows from the start and end, but not the middle
	    .replace(/^\n+|\n+$/g, '');
	
	    if (content.length) {
	      this.trigger('data', {
	        startPts: this.startPts_,
	        endPts: pts,
	        text: content,
	        stream: this.name_
	      });
	    }
	  };
	  /**
	   * Zero out the data, used for startup and on seek
	   */
	
	
	  Cea608Stream.prototype.reset = function () {
	    this.mode_ = 'popOn'; // When in roll-up mode, the index of the last row that will
	    // actually display captions. If a caption is shifted to a row
	    // with a lower index than this, it is cleared from the display
	    // buffer
	
	    this.topRow_ = 0;
	    this.startPts_ = 0;
	    this.displayed_ = createDisplayBuffer();
	    this.nonDisplayed_ = createDisplayBuffer();
	    this.lastControlCode_ = null; // Track row and column for proper line-breaking and spacing
	
	    this.column_ = 0;
	    this.row_ = BOTTOM_ROW;
	    this.rollUpRows_ = 2; // This variable holds currently-applied formatting
	
	    this.formatting_ = [];
	  };
	  /**
	   * Sets up control code and related constants for this instance
	   */
	
	
	  Cea608Stream.prototype.setConstants = function () {
	    // The following attributes have these uses:
	    // ext_ :    char0 for mid-row codes, and the base for extended
	    //           chars (ext_+0, ext_+1, and ext_+2 are char0s for
	    //           extended codes)
	    // control_: char0 for control codes, except byte-shifted to the
	    //           left so that we can do this.control_ | CONTROL_CODE
	    // offset_:  char0 for tab offset codes
	    //
	    // It's also worth noting that control codes, and _only_ control codes,
	    // differ between field 1 and field2. Field 2 control codes are always
	    // their field 1 value plus 1. That's why there's the "| field" on the
	    // control value.
	    if (this.dataChannel_ === 0) {
	      this.BASE_ = 0x10;
	      this.EXT_ = 0x11;
	      this.CONTROL_ = (0x14 | this.field_) << 8;
	      this.OFFSET_ = 0x17;
	    } else if (this.dataChannel_ === 1) {
	      this.BASE_ = 0x18;
	      this.EXT_ = 0x19;
	      this.CONTROL_ = (0x1c | this.field_) << 8;
	      this.OFFSET_ = 0x1f;
	    } // Constants for the LSByte command codes recognized by Cea608Stream. This
	    // list is not exhaustive. For a more comprehensive listing and semantics see
	    // http://www.gpo.gov/fdsys/pkg/CFR-2010-title47-vol1/pdf/CFR-2010-title47-vol1-sec15-119.pdf
	    // Padding
	
	
	    this.PADDING_ = 0x0000; // Pop-on Mode
	
	    this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 0x20;
	    this.END_OF_CAPTION_ = this.CONTROL_ | 0x2f; // Roll-up Mode
	
	    this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 0x25;
	    this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 0x26;
	    this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 0x27;
	    this.CARRIAGE_RETURN_ = this.CONTROL_ | 0x2d; // paint-on mode
	
	    this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 0x29; // Erasure
	
	    this.BACKSPACE_ = this.CONTROL_ | 0x21;
	    this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2c;
	    this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2e;
	  };
	  /**
	   * Detects if the 2-byte packet data is a special character
	   *
	   * Special characters have a second byte in the range 0x30 to 0x3f,
	   * with the first byte being 0x11 (for data channel 1) or 0x19 (for
	   * data channel 2).
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are an special character
	   */
	
	
	  Cea608Stream.prototype.isSpecialCharacter = function (char0, char1) {
	    return char0 === this.EXT_ && char1 >= 0x30 && char1 <= 0x3f;
	  };
	  /**
	   * Detects if the 2-byte packet data is an extended character
	   *
	   * Extended characters have a second byte in the range 0x20 to 0x3f,
	   * with the first byte being 0x12 or 0x13 (for data channel 1) or
	   * 0x1a or 0x1b (for data channel 2).
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are an extended character
	   */
	
	
	  Cea608Stream.prototype.isExtCharacter = function (char0, char1) {
	    return (char0 === this.EXT_ + 1 || char0 === this.EXT_ + 2) && char1 >= 0x20 && char1 <= 0x3f;
	  };
	  /**
	   * Detects if the 2-byte packet is a mid-row code
	   *
	   * Mid-row codes have a second byte in the range 0x20 to 0x2f, with
	   * the first byte being 0x11 (for data channel 1) or 0x19 (for data
	   * channel 2).
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are a mid-row code
	   */
	
	
	  Cea608Stream.prototype.isMidRowCode = function (char0, char1) {
	    return char0 === this.EXT_ && char1 >= 0x20 && char1 <= 0x2f;
	  };
	  /**
	   * Detects if the 2-byte packet is an offset control code
	   *
	   * Offset control codes have a second byte in the range 0x21 to 0x23,
	   * with the first byte being 0x17 (for data channel 1) or 0x1f (for
	   * data channel 2).
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are an offset control code
	   */
	
	
	  Cea608Stream.prototype.isOffsetControlCode = function (char0, char1) {
	    return char0 === this.OFFSET_ && char1 >= 0x21 && char1 <= 0x23;
	  };
	  /**
	   * Detects if the 2-byte packet is a Preamble Address Code
	   *
	   * PACs have a first byte in the range 0x10 to 0x17 (for data channel 1)
	   * or 0x18 to 0x1f (for data channel 2), with the second byte in the
	   * range 0x40 to 0x7f.
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are a PAC
	   */
	
	
	  Cea608Stream.prototype.isPAC = function (char0, char1) {
	    return char0 >= this.BASE_ && char0 < this.BASE_ + 8 && char1 >= 0x40 && char1 <= 0x7f;
	  };
	  /**
	   * Detects if a packet's second byte is in the range of a PAC color code
	   *
	   * PAC color codes have the second byte be in the range 0x40 to 0x4f, or
	   * 0x60 to 0x6f.
	   *
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the byte is a color PAC
	   */
	
	
	  Cea608Stream.prototype.isColorPAC = function (char1) {
	    return char1 >= 0x40 && char1 <= 0x4f || char1 >= 0x60 && char1 <= 0x7f;
	  };
	  /**
	   * Detects if a single byte is in the range of a normal character
	   *
	   * Normal text bytes are in the range 0x20 to 0x7f.
	   *
	   * @param  {Integer} char  The byte
	   * @return {Boolean}       Whether the byte is a normal character
	   */
	
	
	  Cea608Stream.prototype.isNormalChar = function (_char2) {
	    return _char2 >= 0x20 && _char2 <= 0x7f;
	  };
	  /**
	   * Configures roll-up
	   *
	   * @param  {Integer} pts         Current PTS
	   * @param  {Integer} newBaseRow  Used by PACs to slide the current window to
	   *                               a new position
	   */
	
	
	  Cea608Stream.prototype.setRollUp = function (pts, newBaseRow) {
	    // Reset the base row to the bottom row when switching modes
	    if (this.mode_ !== 'rollUp') {
	      this.row_ = BOTTOM_ROW;
	      this.mode_ = 'rollUp'; // Spec says to wipe memories when switching to roll-up
	
	      this.flushDisplayed(pts);
	      this.nonDisplayed_ = createDisplayBuffer();
	      this.displayed_ = createDisplayBuffer();
	    }
	
	    if (newBaseRow !== undefined && newBaseRow !== this.row_) {
	      // move currently displayed captions (up or down) to the new base row
	      for (var i = 0; i < this.rollUpRows_; i++) {
	        this.displayed_[newBaseRow - i] = this.displayed_[this.row_ - i];
	        this.displayed_[this.row_ - i] = '';
	      }
	    }
	
	    if (newBaseRow === undefined) {
	      newBaseRow = this.row_;
	    }
	
	    this.topRow_ = newBaseRow - this.rollUpRows_ + 1;
	  }; // Adds the opening HTML tag for the passed character to the caption text,
	  // and keeps track of it for later closing
	
	
	  Cea608Stream.prototype.addFormatting = function (pts, format) {
	    this.formatting_ = this.formatting_.concat(format);
	    var text = format.reduce(function (text, format) {
	      return text + '<' + format + '>';
	    }, '');
	    this[this.mode_](pts, text);
	  }; // Adds HTML closing tags for current formatting to caption text and
	  // clears remembered formatting
	
	
	  Cea608Stream.prototype.clearFormatting = function (pts) {
	    if (!this.formatting_.length) {
	      return;
	    }
	
	    var text = this.formatting_.reverse().reduce(function (text, format) {
	      return text + '</' + format + '>';
	    }, '');
	    this.formatting_ = [];
	    this[this.mode_](pts, text);
	  }; // Mode Implementations
	
	
	  Cea608Stream.prototype.popOn = function (pts, text) {
	    var baseRow = this.nonDisplayed_[this.row_]; // buffer characters
	
	    baseRow += text;
	    this.nonDisplayed_[this.row_] = baseRow;
	  };
	
	  Cea608Stream.prototype.rollUp = function (pts, text) {
	    var baseRow = this.displayed_[this.row_];
	    baseRow += text;
	    this.displayed_[this.row_] = baseRow;
	  };
	
	  Cea608Stream.prototype.shiftRowsUp_ = function () {
	    var i; // clear out inactive rows
	
	    for (i = 0; i < this.topRow_; i++) {
	      this.displayed_[i] = '';
	    }
	
	    for (i = this.row_ + 1; i < BOTTOM_ROW + 1; i++) {
	      this.displayed_[i] = '';
	    } // shift displayed rows up
	
	
	    for (i = this.topRow_; i < this.row_; i++) {
	      this.displayed_[i] = this.displayed_[i + 1];
	    } // clear out the bottom row
	
	
	    this.displayed_[this.row_] = '';
	  };
	
	  Cea608Stream.prototype.paintOn = function (pts, text) {
	    var baseRow = this.displayed_[this.row_];
	    baseRow += text;
	    this.displayed_[this.row_] = baseRow;
	  }; // exports
	
	
	  var captionStream = {
	    CaptionStream: CaptionStream$1,
	    Cea608Stream: Cea608Stream,
	    Cea708Stream: Cea708Stream
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var streamTypes = {
	    H264_STREAM_TYPE: 0x1B,
	    ADTS_STREAM_TYPE: 0x0F,
	    METADATA_STREAM_TYPE: 0x15
	  };
	  var MAX_TS = 8589934592;
	  var RO_THRESH = 4294967296;
	  var TYPE_SHARED = 'shared';
	
	  var handleRollover$1 = function handleRollover(value, reference) {
	    var direction = 1;
	
	    if (value > reference) {
	      // If the current timestamp value is greater than our reference timestamp and we detect a
	      // timestamp rollover, this means the roll over is happening in the opposite direction.
	      // Example scenario: Enter a long stream/video just after a rollover occurred. The reference
	      // point will be set to a small number, e.g. 1. The user then seeks backwards over the
	      // rollover point. In loading this segment, the timestamp values will be very large,
	      // e.g. 2^33 - 1. Since this comes before the data we loaded previously, we want to adjust
	      // the time stamp to be `value - 2^33`.
	      direction = -1;
	    } // Note: A seek forwards or back that is greater than the RO_THRESH (2^32, ~13 hours) will
	    // cause an incorrect adjustment.
	
	
	    while (Math.abs(reference - value) > RO_THRESH) {
	      value += direction * MAX_TS;
	    }
	
	    return value;
	  };
	
	  var TimestampRolloverStream$1 = function TimestampRolloverStream(type) {
	    var lastDTS, referenceDTS;
	    TimestampRolloverStream.prototype.init.call(this); // The "shared" type is used in cases where a stream will contain muxed
	    // video and audio. We could use `undefined` here, but having a string
	    // makes debugging a little clearer.
	
	    this.type_ = type || TYPE_SHARED;
	
	    this.push = function (data) {
	      // Any "shared" rollover streams will accept _all_ data. Otherwise,
	      // streams will only accept data that matches their type.
	      if (this.type_ !== TYPE_SHARED && data.type !== this.type_) {
	        return;
	      }
	
	      if (referenceDTS === undefined) {
	        referenceDTS = data.dts;
	      }
	
	      data.dts = handleRollover$1(data.dts, referenceDTS);
	      data.pts = handleRollover$1(data.pts, referenceDTS);
	      lastDTS = data.dts;
	      this.trigger('data', data);
	    };
	
	    this.flush = function () {
	      referenceDTS = lastDTS;
	      this.trigger('done');
	    };
	
	    this.endTimeline = function () {
	      this.flush();
	      this.trigger('endedtimeline');
	    };
	
	    this.discontinuity = function () {
	      referenceDTS = void 0;
	      lastDTS = void 0;
	    };
	
	    this.reset = function () {
	      this.discontinuity();
	      this.trigger('reset');
	    };
	  };
	
	  TimestampRolloverStream$1.prototype = new stream();
	  var timestampRolloverStream = {
	    TimestampRolloverStream: TimestampRolloverStream$1,
	    handleRollover: handleRollover$1
	  };
	
	  var percentEncode$1 = function percentEncode(bytes, start, end) {
	    var i,
	        result = '';
	
	    for (i = start; i < end; i++) {
	      result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
	    }
	
	    return result;
	  },
	      // return the string representation of the specified byte range,
	  // interpreted as UTf-8.
	  parseUtf8 = function parseUtf8(bytes, start, end) {
	    return decodeURIComponent(percentEncode$1(bytes, start, end));
	  },
	      // return the string representation of the specified byte range,
	  // interpreted as ISO-8859-1.
	  parseIso88591$1 = function parseIso88591(bytes, start, end) {
	    return unescape(percentEncode$1(bytes, start, end)); // jshint ignore:line
	  },
	      parseSyncSafeInteger$1 = function parseSyncSafeInteger(data) {
	    return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
	  },
	      tagParsers = {
	    TXXX: function TXXX(tag) {
	      var i;
	
	      if (tag.data[0] !== 3) {
	        // ignore frames with unrecognized character encodings
	        return;
	      }
	
	      for (i = 1; i < tag.data.length; i++) {
	        if (tag.data[i] === 0) {
	          // parse the text fields
	          tag.description = parseUtf8(tag.data, 1, i); // do not include the null terminator in the tag value
	
	          tag.value = parseUtf8(tag.data, i + 1, tag.data.length).replace(/\0*$/, '');
	          break;
	        }
	      }
	
	      tag.data = tag.value;
	    },
	    WXXX: function WXXX(tag) {
	      var i;
	
	      if (tag.data[0] !== 3) {
	        // ignore frames with unrecognized character encodings
	        return;
	      }
	
	      for (i = 1; i < tag.data.length; i++) {
	        if (tag.data[i] === 0) {
	          // parse the description and URL fields
	          tag.description = parseUtf8(tag.data, 1, i);
	          tag.url = parseUtf8(tag.data, i + 1, tag.data.length);
	          break;
	        }
	      }
	    },
	    PRIV: function PRIV(tag) {
	      var i;
	
	      for (i = 0; i < tag.data.length; i++) {
	        if (tag.data[i] === 0) {
	          // parse the description and URL fields
	          tag.owner = parseIso88591$1(tag.data, 0, i);
	          break;
	        }
	      }
	
	      tag.privateData = tag.data.subarray(i + 1);
	      tag.data = tag.privateData;
	    }
	  },
	      _MetadataStream;
	
	  _MetadataStream = function MetadataStream(options) {
	    var settings = {
	      // the bytes of the program-level descriptor field in MP2T
	      // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
	      // program element descriptors"
	      descriptor: options && options.descriptor
	    },
	        // the total size in bytes of the ID3 tag being parsed
	    tagSize = 0,
	        // tag data that is not complete enough to be parsed
	    buffer = [],
	        // the total number of bytes currently in the buffer
	    bufferSize = 0,
	        i;
	
	    _MetadataStream.prototype.init.call(this); // calculate the text track in-band metadata track dispatch type
	    // https://html.spec.whatwg.org/multipage/embedded-content.html#steps-to-expose-a-media-resource-specific-text-track
	
	
	    this.dispatchType = streamTypes.METADATA_STREAM_TYPE.toString(16);
	
	    if (settings.descriptor) {
	      for (i = 0; i < settings.descriptor.length; i++) {
	        this.dispatchType += ('00' + settings.descriptor[i].toString(16)).slice(-2);
	      }
	    }
	
	    this.push = function (chunk) {
	      var tag, frameStart, frameSize, frame, i, frameHeader;
	
	      if (chunk.type !== 'timed-metadata') {
	        return;
	      } // if data_alignment_indicator is set in the PES header,
	      // we must have the start of a new ID3 tag. Assume anything
	      // remaining in the buffer was malformed and throw it out
	
	
	      if (chunk.dataAlignmentIndicator) {
	        bufferSize = 0;
	        buffer.length = 0;
	      } // ignore events that don't look like ID3 data
	
	
	      if (buffer.length === 0 && (chunk.data.length < 10 || chunk.data[0] !== 'I'.charCodeAt(0) || chunk.data[1] !== 'D'.charCodeAt(0) || chunk.data[2] !== '3'.charCodeAt(0))) {
	        this.trigger('log', {
	          level: 'warn',
	          message: 'Skipping unrecognized metadata packet'
	        });
	        return;
	      } // add this chunk to the data we've collected so far
	
	
	      buffer.push(chunk);
	      bufferSize += chunk.data.byteLength; // grab the size of the entire frame from the ID3 header
	
	      if (buffer.length === 1) {
	        // the frame size is transmitted as a 28-bit integer in the
	        // last four bytes of the ID3 header.
	        // The most significant bit of each byte is dropped and the
	        // results concatenated to recover the actual value.
	        tagSize = parseSyncSafeInteger$1(chunk.data.subarray(6, 10)); // ID3 reports the tag size excluding the header but it's more
	        // convenient for our comparisons to include it
	
	        tagSize += 10;
	      } // if the entire frame has not arrived, wait for more data
	
	
	      if (bufferSize < tagSize) {
	        return;
	      } // collect the entire frame so it can be parsed
	
	
	      tag = {
	        data: new Uint8Array(tagSize),
	        frames: [],
	        pts: buffer[0].pts,
	        dts: buffer[0].dts
	      };
	
	      for (i = 0; i < tagSize;) {
	        tag.data.set(buffer[0].data.subarray(0, tagSize - i), i);
	        i += buffer[0].data.byteLength;
	        bufferSize -= buffer[0].data.byteLength;
	        buffer.shift();
	      } // find the start of the first frame and the end of the tag
	
	
	      frameStart = 10;
	
	      if (tag.data[5] & 0x40) {
	        // advance the frame start past the extended header
	        frameStart += 4; // header size field
	
	        frameStart += parseSyncSafeInteger$1(tag.data.subarray(10, 14)); // clip any padding off the end
	
	        tagSize -= parseSyncSafeInteger$1(tag.data.subarray(16, 20));
	      } // parse one or more ID3 frames
	      // http://id3.org/id3v2.3.0#ID3v2_frame_overview
	
	
	      do {
	        // determine the number of bytes in this frame
	        frameSize = parseSyncSafeInteger$1(tag.data.subarray(frameStart + 4, frameStart + 8));
	
	        if (frameSize < 1) {
	          this.trigger('log', {
	            level: 'warn',
	            message: 'Malformed ID3 frame encountered. Skipping metadata parsing.'
	          });
	          return;
	        }
	
	        frameHeader = String.fromCharCode(tag.data[frameStart], tag.data[frameStart + 1], tag.data[frameStart + 2], tag.data[frameStart + 3]);
	        frame = {
	          id: frameHeader,
	          data: tag.data.subarray(frameStart + 10, frameStart + frameSize + 10)
	        };
	        frame.key = frame.id;
	
	        if (tagParsers[frame.id]) {
	          tagParsers[frame.id](frame); // handle the special PRIV frame used to indicate the start
	          // time for raw AAC data
	
	          if (frame.owner === 'com.apple.streaming.transportStreamTimestamp') {
	            var d = frame.data,
	                size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
	            size *= 4;
	            size += d[7] & 0x03;
	            frame.timeStamp = size; // in raw AAC, all subsequent data will be timestamped based
	            // on the value of this frame
	            // we couldn't have known the appropriate pts and dts before
	            // parsing this ID3 tag so set those values now
	
	            if (tag.pts === undefined && tag.dts === undefined) {
	              tag.pts = frame.timeStamp;
	              tag.dts = frame.timeStamp;
	            }
	
	            this.trigger('timestamp', frame);
	          }
	        }
	
	        tag.frames.push(frame);
	        frameStart += 10; // advance past the frame header
	
	        frameStart += frameSize; // advance past the frame body
	      } while (frameStart < tagSize);
	
	      this.trigger('data', tag);
	    };
	  };
	
	  _MetadataStream.prototype = new stream();
	  var metadataStream = _MetadataStream;
	  var TimestampRolloverStream = timestampRolloverStream.TimestampRolloverStream; // object types
	
	  var _TransportPacketStream, _TransportParseStream, _ElementaryStream; // constants
	
	
	  var MP2T_PACKET_LENGTH$1 = 188,
	      // bytes
	  SYNC_BYTE$1 = 0x47;
	  /**
	   * Splits an incoming stream of binary data into MPEG-2 Transport
	   * Stream packets.
	   */
	
	  _TransportPacketStream = function TransportPacketStream() {
	    var buffer = new Uint8Array(MP2T_PACKET_LENGTH$1),
	        bytesInBuffer = 0;
	
	    _TransportPacketStream.prototype.init.call(this); // Deliver new bytes to the stream.
	
	    /**
	     * Split a stream of data into M2TS packets
	    **/
	
	
	    this.push = function (bytes) {
	      var startIndex = 0,
	          endIndex = MP2T_PACKET_LENGTH$1,
	          everything; // If there are bytes remaining from the last segment, prepend them to the
	      // bytes that were pushed in
	
	      if (bytesInBuffer) {
	        everything = new Uint8Array(bytes.byteLength + bytesInBuffer);
	        everything.set(buffer.subarray(0, bytesInBuffer));
	        everything.set(bytes, bytesInBuffer);
	        bytesInBuffer = 0;
	      } else {
	        everything = bytes;
	      } // While we have enough data for a packet
	
	
	      while (endIndex < everything.byteLength) {
	        // Look for a pair of start and end sync bytes in the data..
	        if (everything[startIndex] === SYNC_BYTE$1 && everything[endIndex] === SYNC_BYTE$1) {
	          // We found a packet so emit it and jump one whole packet forward in
	          // the stream
	          this.trigger('data', everything.subarray(startIndex, endIndex));
	          startIndex += MP2T_PACKET_LENGTH$1;
	          endIndex += MP2T_PACKET_LENGTH$1;
	          continue;
	        } // If we get here, we have somehow become de-synchronized and we need to step
	        // forward one byte at a time until we find a pair of sync bytes that denote
	        // a packet
	
	
	        startIndex++;
	        endIndex++;
	      } // If there was some data left over at the end of the segment that couldn't
	      // possibly be a whole packet, keep it because it might be the start of a packet
	      // that continues in the next segment
	
	
	      if (startIndex < everything.byteLength) {
	        buffer.set(everything.subarray(startIndex), 0);
	        bytesInBuffer = everything.byteLength - startIndex;
	      }
	    };
	    /**
	     * Passes identified M2TS packets to the TransportParseStream to be parsed
	    **/
	
	
	    this.flush = function () {
	      // If the buffer contains a whole packet when we are being flushed, emit it
	      // and empty the buffer. Otherwise hold onto the data because it may be
	      // important for decoding the next segment
	      if (bytesInBuffer === MP2T_PACKET_LENGTH$1 && buffer[0] === SYNC_BYTE$1) {
	        this.trigger('data', buffer);
	        bytesInBuffer = 0;
	      }
	
	      this.trigger('done');
	    };
	
	    this.endTimeline = function () {
	      this.flush();
	      this.trigger('endedtimeline');
	    };
	
	    this.reset = function () {
	      bytesInBuffer = 0;
	      this.trigger('reset');
	    };
	  };
	
	  _TransportPacketStream.prototype = new stream();
	  /**
	   * Accepts an MP2T TransportPacketStream and emits data events with parsed
	   * forms of the individual transport stream packets.
	   */
	
	  _TransportParseStream = function TransportParseStream() {
	    var parsePsi, parsePat, parsePmt, self;
	
	    _TransportParseStream.prototype.init.call(this);
	
	    self = this;
	    this.packetsWaitingForPmt = [];
	    this.programMapTable = undefined;
	
	    parsePsi = function parsePsi(payload, psi) {
	      var offset = 0; // PSI packets may be split into multiple sections and those
	      // sections may be split into multiple packets. If a PSI
	      // section starts in this packet, the payload_unit_start_indicator
	      // will be true and the first byte of the payload will indicate
	      // the offset from the current position to the start of the
	      // section.
	
	      if (psi.payloadUnitStartIndicator) {
	        offset += payload[offset] + 1;
	      }
	
	      if (psi.type === 'pat') {
	        parsePat(payload.subarray(offset), psi);
	      } else {
	        parsePmt(payload.subarray(offset), psi);
	      }
	    };
	
	    parsePat = function parsePat(payload, pat) {
	      pat.section_number = payload[7]; // eslint-disable-line camelcase
	
	      pat.last_section_number = payload[8]; // eslint-disable-line camelcase
	      // skip the PSI header and parse the first PMT entry
	
	      self.pmtPid = (payload[10] & 0x1F) << 8 | payload[11];
	      pat.pmtPid = self.pmtPid;
	    };
	    /**
	     * Parse out the relevant fields of a Program Map Table (PMT).
	     * @param payload {Uint8Array} the PMT-specific portion of an MP2T
	     * packet. The first byte in this array should be the table_id
	     * field.
	     * @param pmt {object} the object that should be decorated with
	     * fields parsed from the PMT.
	     */
	
	
	    parsePmt = function parsePmt(payload, pmt) {
	      var sectionLength, tableEnd, programInfoLength, offset; // PMTs can be sent ahead of the time when they should actually
	      // take effect. We don't believe this should ever be the case
	      // for HLS but we'll ignore "forward" PMT declarations if we see
	      // them. Future PMT declarations have the current_next_indicator
	      // set to zero.
	
	      if (!(payload[5] & 0x01)) {
	        return;
	      } // overwrite any existing program map table
	
	
	      self.programMapTable = {
	        video: null,
	        audio: null,
	        'timed-metadata': {}
	      }; // the mapping table ends at the end of the current section
	
	      sectionLength = (payload[1] & 0x0f) << 8 | payload[2];
	      tableEnd = 3 + sectionLength - 4; // to determine where the table is, we have to figure out how
	      // long the program info descriptors are
	
	      programInfoLength = (payload[10] & 0x0f) << 8 | payload[11]; // advance the offset to the first entry in the mapping table
	
	      offset = 12 + programInfoLength;
	
	      while (offset < tableEnd) {
	        var streamType = payload[offset];
	        var pid = (payload[offset + 1] & 0x1F) << 8 | payload[offset + 2]; // only map a single elementary_pid for audio and video stream types
	        // TODO: should this be done for metadata too? for now maintain behavior of
	        //       multiple metadata streams
	
	        if (streamType === streamTypes.H264_STREAM_TYPE && self.programMapTable.video === null) {
	          self.programMapTable.video = pid;
	        } else if (streamType === streamTypes.ADTS_STREAM_TYPE && self.programMapTable.audio === null) {
	          self.programMapTable.audio = pid;
	        } else if (streamType === streamTypes.METADATA_STREAM_TYPE) {
	          // map pid to stream type for metadata streams
	          self.programMapTable['timed-metadata'][pid] = streamType;
	        } // move to the next table entry
	        // skip past the elementary stream descriptors, if present
	
	
	        offset += ((payload[offset + 3] & 0x0F) << 8 | payload[offset + 4]) + 5;
	      } // record the map on the packet as well
	
	
	      pmt.programMapTable = self.programMapTable;
	    };
	    /**
	     * Deliver a new MP2T packet to the next stream in the pipeline.
	     */
	
	
	    this.push = function (packet) {
	      var result = {},
	          offset = 4;
	      result.payloadUnitStartIndicator = !!(packet[1] & 0x40); // pid is a 13-bit field starting at the last bit of packet[1]
	
	      result.pid = packet[1] & 0x1f;
	      result.pid <<= 8;
	      result.pid |= packet[2]; // if an adaption field is present, its length is specified by the
	      // fifth byte of the TS packet header. The adaptation field is
	      // used to add stuffing to PES packets that don't fill a complete
	      // TS packet, and to specify some forms of timing and control data
	      // that we do not currently use.
	
	      if ((packet[3] & 0x30) >>> 4 > 0x01) {
	        offset += packet[offset] + 1;
	      } // parse the rest of the packet based on the type
	
	
	      if (result.pid === 0) {
	        result.type = 'pat';
	        parsePsi(packet.subarray(offset), result);
	        this.trigger('data', result);
	      } else if (result.pid === this.pmtPid) {
	        result.type = 'pmt';
	        parsePsi(packet.subarray(offset), result);
	        this.trigger('data', result); // if there are any packets waiting for a PMT to be found, process them now
	
	        while (this.packetsWaitingForPmt.length) {
	          this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
	        }
	      } else if (this.programMapTable === undefined) {
	        // When we have not seen a PMT yet, defer further processing of
	        // PES packets until one has been parsed
	        this.packetsWaitingForPmt.push([packet, offset, result]);
	      } else {
	        this.processPes_(packet, offset, result);
	      }
	    };
	
	    this.processPes_ = function (packet, offset, result) {
	      // set the appropriate stream type
	      if (result.pid === this.programMapTable.video) {
	        result.streamType = streamTypes.H264_STREAM_TYPE;
	      } else if (result.pid === this.programMapTable.audio) {
	        result.streamType = streamTypes.ADTS_STREAM_TYPE;
	      } else {
	        // if not video or audio, it is timed-metadata or unknown
	        // if unknown, streamType will be undefined
	        result.streamType = this.programMapTable['timed-metadata'][result.pid];
	      }
	
	      result.type = 'pes';
	      result.data = packet.subarray(offset);
	      this.trigger('data', result);
	    };
	  };
	
	  _TransportParseStream.prototype = new stream();
	  _TransportParseStream.STREAM_TYPES = {
	    h264: 0x1b,
	    adts: 0x0f
	  };
	  /**
	   * Reconsistutes program elementary stream (PES) packets from parsed
	   * transport stream packets. That is, if you pipe an
	   * mp2t.TransportParseStream into a mp2t.ElementaryStream, the output
	   * events will be events which capture the bytes for individual PES
	   * packets plus relevant metadata that has been extracted from the
	   * container.
	   */
	
	  _ElementaryStream = function ElementaryStream() {
	    var self = this,
	        segmentHadPmt = false,
	        // PES packet fragments
	    video = {
	      data: [],
	      size: 0
	    },
	        audio = {
	      data: [],
	      size: 0
	    },
	        timedMetadata = {
	      data: [],
	      size: 0
	    },
	        programMapTable,
	        parsePes = function parsePes(payload, pes) {
	      var ptsDtsFlags;
	      var startPrefix = payload[0] << 16 | payload[1] << 8 | payload[2]; // default to an empty array
	
	      pes.data = new Uint8Array(); // In certain live streams, the start of a TS fragment has ts packets
	      // that are frame data that is continuing from the previous fragment. This
	      // is to check that the pes data is the start of a new pes payload
	
	      if (startPrefix !== 1) {
	        return;
	      } // get the packet length, this will be 0 for video
	
	
	      pes.packetLength = 6 + (payload[4] << 8 | payload[5]); // find out if this packets starts a new keyframe
	
	      pes.dataAlignmentIndicator = (payload[6] & 0x04) !== 0; // PES packets may be annotated with a PTS value, or a PTS value
	      // and a DTS value. Determine what combination of values is
	      // available to work with.
	
	      ptsDtsFlags = payload[7]; // PTS and DTS are normally stored as a 33-bit number.  Javascript
	      // performs all bitwise operations on 32-bit integers but javascript
	      // supports a much greater range (52-bits) of integer using standard
	      // mathematical operations.
	      // We construct a 31-bit value using bitwise operators over the 31
	      // most significant bits and then multiply by 4 (equal to a left-shift
	      // of 2) before we add the final 2 least significant bits of the
	      // timestamp (equal to an OR.)
	
	      if (ptsDtsFlags & 0xC0) {
	        // the PTS and DTS are not written out directly. For information
	        // on how they are encoded, see
	        // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
	        pes.pts = (payload[9] & 0x0E) << 27 | (payload[10] & 0xFF) << 20 | (payload[11] & 0xFE) << 12 | (payload[12] & 0xFF) << 5 | (payload[13] & 0xFE) >>> 3;
	        pes.pts *= 4; // Left shift by 2
	
	        pes.pts += (payload[13] & 0x06) >>> 1; // OR by the two LSBs
	
	        pes.dts = pes.pts;
	
	        if (ptsDtsFlags & 0x40) {
	          pes.dts = (payload[14] & 0x0E) << 27 | (payload[15] & 0xFF) << 20 | (payload[16] & 0xFE) << 12 | (payload[17] & 0xFF) << 5 | (payload[18] & 0xFE) >>> 3;
	          pes.dts *= 4; // Left shift by 2
	
	          pes.dts += (payload[18] & 0x06) >>> 1; // OR by the two LSBs
	        }
	      } // the data section starts immediately after the PES header.
	      // pes_header_data_length specifies the number of header bytes
	      // that follow the last byte of the field.
	
	
	      pes.data = payload.subarray(9 + payload[8]);
	    },
	
	    /**
	      * Pass completely parsed PES packets to the next stream in the pipeline
	     **/
	    flushStream = function flushStream(stream, type, forceFlush) {
	      var packetData = new Uint8Array(stream.size),
	          event = {
	        type: type
	      },
	          i = 0,
	          offset = 0,
	          packetFlushable = false,
	          fragment; // do nothing if there is not enough buffered data for a complete
	      // PES header
	
	      if (!stream.data.length || stream.size < 9) {
	        return;
	      }
	
	      event.trackId = stream.data[0].pid; // reassemble the packet
	
	      for (i = 0; i < stream.data.length; i++) {
	        fragment = stream.data[i];
	        packetData.set(fragment.data, offset);
	        offset += fragment.data.byteLength;
	      } // parse assembled packet's PES header
	
	
	      parsePes(packetData, event); // non-video PES packets MUST have a non-zero PES_packet_length
	      // check that there is enough stream data to fill the packet
	
	      packetFlushable = type === 'video' || event.packetLength <= stream.size; // flush pending packets if the conditions are right
	
	      if (forceFlush || packetFlushable) {
	        stream.size = 0;
	        stream.data.length = 0;
	      } // only emit packets that are complete. this is to avoid assembling
	      // incomplete PES packets due to poor segmentation
	
	
	      if (packetFlushable) {
	        self.trigger('data', event);
	      }
	    };
	
	    _ElementaryStream.prototype.init.call(this);
	    /**
	     * Identifies M2TS packet types and parses PES packets using metadata
	     * parsed from the PMT
	     **/
	
	
	    this.push = function (data) {
	      ({
	        pat: function pat() {// we have to wait for the PMT to arrive as well before we
	          // have any meaningful metadata
	        },
	        pes: function pes() {
	          var stream, streamType;
	
	          switch (data.streamType) {
	            case streamTypes.H264_STREAM_TYPE:
	              stream = video;
	              streamType = 'video';
	              break;
	
	            case streamTypes.ADTS_STREAM_TYPE:
	              stream = audio;
	              streamType = 'audio';
	              break;
	
	            case streamTypes.METADATA_STREAM_TYPE:
	              stream = timedMetadata;
	              streamType = 'timed-metadata';
	              break;
	
	            default:
	              // ignore unknown stream types
	              return;
	          } // if a new packet is starting, we can flush the completed
	          // packet
	
	
	          if (data.payloadUnitStartIndicator) {
	            flushStream(stream, streamType, true);
	          } // buffer this fragment until we are sure we've received the
	          // complete payload
	
	
	          stream.data.push(data);
	          stream.size += data.data.byteLength;
	        },
	        pmt: function pmt() {
	          var event = {
	            type: 'metadata',
	            tracks: []
	          };
	          programMapTable = data.programMapTable; // translate audio and video streams to tracks
	
	          if (programMapTable.video !== null) {
	            event.tracks.push({
	              timelineStartInfo: {
	                baseMediaDecodeTime: 0
	              },
	              id: +programMapTable.video,
	              codec: 'avc',
	              type: 'video'
	            });
	          }
	
	          if (programMapTable.audio !== null) {
	            event.tracks.push({
	              timelineStartInfo: {
	                baseMediaDecodeTime: 0
	              },
	              id: +programMapTable.audio,
	              codec: 'adts',
	              type: 'audio'
	            });
	          }
	
	          segmentHadPmt = true;
	          self.trigger('data', event);
	        }
	      })[data.type]();
	    };
	
	    this.reset = function () {
	      video.size = 0;
	      video.data.length = 0;
	      audio.size = 0;
	      audio.data.length = 0;
	      this.trigger('reset');
	    };
	    /**
	     * Flush any remaining input. Video PES packets may be of variable
	     * length. Normally, the start of a new video packet can trigger the
	     * finalization of the previous packet. That is not possible if no
	     * more video is forthcoming, however. In that case, some other
	     * mechanism (like the end of the file) has to be employed. When it is
	     * clear that no additional data is forthcoming, calling this method
	     * will flush the buffered packets.
	     */
	
	
	    this.flushStreams_ = function () {
	      // !!THIS ORDER IS IMPORTANT!!
	      // video first then audio
	      flushStream(video, 'video');
	      flushStream(audio, 'audio');
	      flushStream(timedMetadata, 'timed-metadata');
	    };
	
	    this.flush = function () {
	      // if on flush we haven't had a pmt emitted
	      // and we have a pmt to emit. emit the pmt
	      // so that we trigger a trackinfo downstream.
	      if (!segmentHadPmt && programMapTable) {
	        var pmt = {
	          type: 'metadata',
	          tracks: []
	        }; // translate audio and video streams to tracks
	
	        if (programMapTable.video !== null) {
	          pmt.tracks.push({
	            timelineStartInfo: {
	              baseMediaDecodeTime: 0
	            },
	            id: +programMapTable.video,
	            codec: 'avc',
	            type: 'video'
	          });
	        }
	
	        if (programMapTable.audio !== null) {
	          pmt.tracks.push({
	            timelineStartInfo: {
	              baseMediaDecodeTime: 0
	            },
	            id: +programMapTable.audio,
	            codec: 'adts',
	            type: 'audio'
	          });
	        }
	
	        self.trigger('data', pmt);
	      }
	
	      segmentHadPmt = false;
	      this.flushStreams_();
	      this.trigger('done');
	    };
	  };
	
	  _ElementaryStream.prototype = new stream();
	  var m2ts = {
	    PAT_PID: 0x0000,
	    MP2T_PACKET_LENGTH: MP2T_PACKET_LENGTH$1,
	    TransportPacketStream: _TransportPacketStream,
	    TransportParseStream: _TransportParseStream,
	    ElementaryStream: _ElementaryStream,
	    TimestampRolloverStream: TimestampRolloverStream,
	    CaptionStream: captionStream.CaptionStream,
	    Cea608Stream: captionStream.Cea608Stream,
	    Cea708Stream: captionStream.Cea708Stream,
	    MetadataStream: metadataStream
	  };
	
	  for (var type in streamTypes) {
	    if (streamTypes.hasOwnProperty(type)) {
	      m2ts[type] = streamTypes[type];
	    }
	  }
	
	  var m2ts_1 = m2ts;
	  var ONE_SECOND_IN_TS$2 = clock.ONE_SECOND_IN_TS;
	
	  var _AdtsStream;
	
	  var ADTS_SAMPLING_FREQUENCIES$1 = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
	  /*
	   * Accepts a ElementaryStream and emits data events with parsed
	   * AAC Audio Frames of the individual packets. Input audio in ADTS
	   * format is unpacked and re-emitted as AAC frames.
	   *
	   * @see http://wiki.multimedia.cx/index.php?title=ADTS
	   * @see http://wiki.multimedia.cx/?title=Understanding_AAC
	   */
	
	  _AdtsStream = function AdtsStream(handlePartialSegments) {
	    var buffer,
	        frameNum = 0;
	
	    _AdtsStream.prototype.init.call(this);
	
	    this.skipWarn_ = function (start, end) {
	      this.trigger('log', {
	        level: 'warn',
	        message: "adts skiping bytes " + start + " to " + end + " in frame " + frameNum + " outside syncword"
	      });
	    };
	
	    this.push = function (packet) {
	      var i = 0,
	          frameLength,
	          protectionSkipBytes,
	          oldBuffer,
	          sampleCount,
	          adtsFrameDuration;
	
	      if (!handlePartialSegments) {
	        frameNum = 0;
	      }
	
	      if (packet.type !== 'audio') {
	        // ignore non-audio data
	        return;
	      } // Prepend any data in the buffer to the input data so that we can parse
	      // aac frames the cross a PES packet boundary
	
	
	      if (buffer && buffer.length) {
	        oldBuffer = buffer;
	        buffer = new Uint8Array(oldBuffer.byteLength + packet.data.byteLength);
	        buffer.set(oldBuffer);
	        buffer.set(packet.data, oldBuffer.byteLength);
	      } else {
	        buffer = packet.data;
	      } // unpack any ADTS frames which have been fully received
	      // for details on the ADTS header, see http://wiki.multimedia.cx/index.php?title=ADTS
	
	
	      var skip; // We use i + 7 here because we want to be able to parse the entire header.
	      // If we don't have enough bytes to do that, then we definitely won't have a full frame.
	
	      while (i + 7 < buffer.length) {
	        // Look for the start of an ADTS header..
	        if (buffer[i] !== 0xFF || (buffer[i + 1] & 0xF6) !== 0xF0) {
	          if (typeof skip !== 'number') {
	            skip = i;
	          } // If a valid header was not found,  jump one forward and attempt to
	          // find a valid ADTS header starting at the next byte
	
	
	          i++;
	          continue;
	        }
	
	        if (typeof skip === 'number') {
	          this.skipWarn_(skip, i);
	          skip = null;
	        } // The protection skip bit tells us if we have 2 bytes of CRC data at the
	        // end of the ADTS header
	
	
	        protectionSkipBytes = (~buffer[i + 1] & 0x01) * 2; // Frame length is a 13 bit integer starting 16 bits from the
	        // end of the sync sequence
	        // NOTE: frame length includes the size of the header
	
	        frameLength = (buffer[i + 3] & 0x03) << 11 | buffer[i + 4] << 3 | (buffer[i + 5] & 0xe0) >> 5;
	        sampleCount = ((buffer[i + 6] & 0x03) + 1) * 1024;
	        adtsFrameDuration = sampleCount * ONE_SECOND_IN_TS$2 / ADTS_SAMPLING_FREQUENCIES$1[(buffer[i + 2] & 0x3c) >>> 2]; // If we don't have enough data to actually finish this ADTS frame,
	        // then we have to wait for more data
	
	        if (buffer.byteLength - i < frameLength) {
	          break;
	        } // Otherwise, deliver the complete AAC frame
	
	
	        this.trigger('data', {
	          pts: packet.pts + frameNum * adtsFrameDuration,
	          dts: packet.dts + frameNum * adtsFrameDuration,
	          sampleCount: sampleCount,
	          audioobjecttype: (buffer[i + 2] >>> 6 & 0x03) + 1,
	          channelcount: (buffer[i + 2] & 1) << 2 | (buffer[i + 3] & 0xc0) >>> 6,
	          samplerate: ADTS_SAMPLING_FREQUENCIES$1[(buffer[i + 2] & 0x3c) >>> 2],
	          samplingfrequencyindex: (buffer[i + 2] & 0x3c) >>> 2,
	          // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
	          samplesize: 16,
	          // data is the frame without it's header
	          data: buffer.subarray(i + 7 + protectionSkipBytes, i + frameLength)
	        });
	        frameNum++;
	        i += frameLength;
	      }
	
	      if (typeof skip === 'number') {
	        this.skipWarn_(skip, i);
	        skip = null;
	      } // remove processed bytes from the buffer.
	
	
	      buffer = buffer.subarray(i);
	    };
	
	    this.flush = function () {
	      frameNum = 0;
	      this.trigger('done');
	    };
	
	    this.reset = function () {
	      buffer = void 0;
	      this.trigger('reset');
	    };
	
	    this.endTimeline = function () {
	      buffer = void 0;
	      this.trigger('endedtimeline');
	    };
	  };
	
	  _AdtsStream.prototype = new stream();
	  var adts = _AdtsStream;
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var ExpGolomb;
	  /**
	   * Parser for exponential Golomb codes, a variable-bitwidth number encoding
	   * scheme used by h264.
	   */
	
	  ExpGolomb = function ExpGolomb(workingData) {
	    var // the number of bytes left to examine in workingData
	    workingBytesAvailable = workingData.byteLength,
	        // the current word being examined
	    workingWord = 0,
	        // :uint
	    // the number of bits left to examine in the current word
	    workingBitsAvailable = 0; // :uint;
	    // ():uint
	
	    this.length = function () {
	      return 8 * workingBytesAvailable;
	    }; // ():uint
	
	
	    this.bitsAvailable = function () {
	      return 8 * workingBytesAvailable + workingBitsAvailable;
	    }; // ():void
	
	
	    this.loadWord = function () {
	      var position = workingData.byteLength - workingBytesAvailable,
	          workingBytes = new Uint8Array(4),
	          availableBytes = Math.min(4, workingBytesAvailable);
	
	      if (availableBytes === 0) {
	        throw new Error('no bytes available');
	      }
	
	      workingBytes.set(workingData.subarray(position, position + availableBytes));
	      workingWord = new DataView(workingBytes.buffer).getUint32(0); // track the amount of workingData that has been processed
	
	      workingBitsAvailable = availableBytes * 8;
	      workingBytesAvailable -= availableBytes;
	    }; // (count:int):void
	
	
	    this.skipBits = function (count) {
	      var skipBytes; // :int
	
	      if (workingBitsAvailable > count) {
	        workingWord <<= count;
	        workingBitsAvailable -= count;
	      } else {
	        count -= workingBitsAvailable;
	        skipBytes = Math.floor(count / 8);
	        count -= skipBytes * 8;
	        workingBytesAvailable -= skipBytes;
	        this.loadWord();
	        workingWord <<= count;
	        workingBitsAvailable -= count;
	      }
	    }; // (size:int):uint
	
	
	    this.readBits = function (size) {
	      var bits = Math.min(workingBitsAvailable, size),
	          // :uint
	      valu = workingWord >>> 32 - bits; // :uint
	      // if size > 31, handle error
	
	      workingBitsAvailable -= bits;
	
	      if (workingBitsAvailable > 0) {
	        workingWord <<= bits;
	      } else if (workingBytesAvailable > 0) {
	        this.loadWord();
	      }
	
	      bits = size - bits;
	
	      if (bits > 0) {
	        return valu << bits | this.readBits(bits);
	      }
	
	      return valu;
	    }; // ():uint
	
	
	    this.skipLeadingZeros = function () {
	      var leadingZeroCount; // :uint
	
	      for (leadingZeroCount = 0; leadingZeroCount < workingBitsAvailable; ++leadingZeroCount) {
	        if ((workingWord & 0x80000000 >>> leadingZeroCount) !== 0) {
	          // the first bit of working word is 1
	          workingWord <<= leadingZeroCount;
	          workingBitsAvailable -= leadingZeroCount;
	          return leadingZeroCount;
	        }
	      } // we exhausted workingWord and still have not found a 1
	
	
	      this.loadWord();
	      return leadingZeroCount + this.skipLeadingZeros();
	    }; // ():void
	
	
	    this.skipUnsignedExpGolomb = function () {
	      this.skipBits(1 + this.skipLeadingZeros());
	    }; // ():void
	
	
	    this.skipExpGolomb = function () {
	      this.skipBits(1 + this.skipLeadingZeros());
	    }; // ():uint
	
	
	    this.readUnsignedExpGolomb = function () {
	      var clz = this.skipLeadingZeros(); // :uint
	
	      return this.readBits(clz + 1) - 1;
	    }; // ():int
	
	
	    this.readExpGolomb = function () {
	      var valu = this.readUnsignedExpGolomb(); // :int
	
	      if (0x01 & valu) {
	        // the number is odd if the low order bit is set
	        return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
	      }
	
	      return -1 * (valu >>> 1); // divide by two then make it negative
	    }; // Some convenience functions
	    // :Boolean
	
	
	    this.readBoolean = function () {
	      return this.readBits(1) === 1;
	    }; // ():int
	
	
	    this.readUnsignedByte = function () {
	      return this.readBits(8);
	    };
	
	    this.loadWord();
	  };
	
	  var expGolomb = ExpGolomb;
	
	  var _H264Stream, _NalByteStream;
	
	  var PROFILES_WITH_OPTIONAL_SPS_DATA;
	  /**
	   * Accepts a NAL unit byte stream and unpacks the embedded NAL units.
	   */
	
	  _NalByteStream = function NalByteStream() {
	    var syncPoint = 0,
	        i,
	        buffer;
	
	    _NalByteStream.prototype.init.call(this);
	    /*
	     * Scans a byte stream and triggers a data event with the NAL units found.
	     * @param {Object} data Event received from H264Stream
	     * @param {Uint8Array} data.data The h264 byte stream to be scanned
	     *
	     * @see H264Stream.push
	     */
	
	
	    this.push = function (data) {
	      var swapBuffer;
	
	      if (!buffer) {
	        buffer = data.data;
	      } else {
	        swapBuffer = new Uint8Array(buffer.byteLength + data.data.byteLength);
	        swapBuffer.set(buffer);
	        swapBuffer.set(data.data, buffer.byteLength);
	        buffer = swapBuffer;
	      }
	
	      var len = buffer.byteLength; // Rec. ITU-T H.264, Annex B
	      // scan for NAL unit boundaries
	      // a match looks like this:
	      // 0 0 1 .. NAL .. 0 0 1
	      // ^ sync point        ^ i
	      // or this:
	      // 0 0 1 .. NAL .. 0 0 0
	      // ^ sync point        ^ i
	      // advance the sync point to a NAL start, if necessary
	
	      for (; syncPoint < len - 3; syncPoint++) {
	        if (buffer[syncPoint + 2] === 1) {
	          // the sync point is properly aligned
	          i = syncPoint + 5;
	          break;
	        }
	      }
	
	      while (i < len) {
	        // look at the current byte to determine if we've hit the end of
	        // a NAL unit boundary
	        switch (buffer[i]) {
	          case 0:
	            // skip past non-sync sequences
	            if (buffer[i - 1] !== 0) {
	              i += 2;
	              break;
	            } else if (buffer[i - 2] !== 0) {
	              i++;
	              break;
	            } // deliver the NAL unit if it isn't empty
	
	
	            if (syncPoint + 3 !== i - 2) {
	              this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
	            } // drop trailing zeroes
	
	
	            do {
	              i++;
	            } while (buffer[i] !== 1 && i < len);
	
	            syncPoint = i - 2;
	            i += 3;
	            break;
	
	          case 1:
	            // skip past non-sync sequences
	            if (buffer[i - 1] !== 0 || buffer[i - 2] !== 0) {
	              i += 3;
	              break;
	            } // deliver the NAL unit
	
	
	            this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
	            syncPoint = i - 2;
	            i += 3;
	            break;
	
	          default:
	            // the current byte isn't a one or zero, so it cannot be part
	            // of a sync sequence
	            i += 3;
	            break;
	        }
	      } // filter out the NAL units that were delivered
	
	
	      buffer = buffer.subarray(syncPoint);
	      i -= syncPoint;
	      syncPoint = 0;
	    };
	
	    this.reset = function () {
	      buffer = null;
	      syncPoint = 0;
	      this.trigger('reset');
	    };
	
	    this.flush = function () {
	      // deliver the last buffered NAL unit
	      if (buffer && buffer.byteLength > 3) {
	        this.trigger('data', buffer.subarray(syncPoint + 3));
	      } // reset the stream state
	
	
	      buffer = null;
	      syncPoint = 0;
	      this.trigger('done');
	    };
	
	    this.endTimeline = function () {
	      this.flush();
	      this.trigger('endedtimeline');
	    };
	  };
	
	  _NalByteStream.prototype = new stream(); // values of profile_idc that indicate additional fields are included in the SPS
	  // see Recommendation ITU-T H.264 (4/2013),
	  // 7.3.2.1.1 Sequence parameter set data syntax
	
	  PROFILES_WITH_OPTIONAL_SPS_DATA = {
	    100: true,
	    110: true,
	    122: true,
	    244: true,
	    44: true,
	    83: true,
	    86: true,
	    118: true,
	    128: true,
	    // TODO: the three profiles below don't
	    // appear to have sps data in the specificiation anymore?
	    138: true,
	    139: true,
	    134: true
	  };
	  /**
	   * Accepts input from a ElementaryStream and produces H.264 NAL unit data
	   * events.
	   */
	
	  _H264Stream = function H264Stream() {
	    var nalByteStream = new _NalByteStream(),
	        self,
	        trackId,
	        currentPts,
	        currentDts,
	        discardEmulationPreventionBytes,
	        readSequenceParameterSet,
	        skipScalingList;
	
	    _H264Stream.prototype.init.call(this);
	
	    self = this;
	    /*
	     * Pushes a packet from a stream onto the NalByteStream
	     *
	     * @param {Object} packet - A packet received from a stream
	     * @param {Uint8Array} packet.data - The raw bytes of the packet
	     * @param {Number} packet.dts - Decode timestamp of the packet
	     * @param {Number} packet.pts - Presentation timestamp of the packet
	     * @param {Number} packet.trackId - The id of the h264 track this packet came from
	     * @param {('video'|'audio')} packet.type - The type of packet
	     *
	     */
	
	    this.push = function (packet) {
	      if (packet.type !== 'video') {
	        return;
	      }
	
	      trackId = packet.trackId;
	      currentPts = packet.pts;
	      currentDts = packet.dts;
	      nalByteStream.push(packet);
	    };
	    /*
	     * Identify NAL unit types and pass on the NALU, trackId, presentation and decode timestamps
	     * for the NALUs to the next stream component.
	     * Also, preprocess caption and sequence parameter NALUs.
	     *
	     * @param {Uint8Array} data - A NAL unit identified by `NalByteStream.push`
	     * @see NalByteStream.push
	     */
	
	
	    nalByteStream.on('data', function (data) {
	      var event = {
	        trackId: trackId,
	        pts: currentPts,
	        dts: currentDts,
	        data: data,
	        nalUnitTypeCode: data[0] & 0x1f
	      };
	
	      switch (event.nalUnitTypeCode) {
	        case 0x05:
	          event.nalUnitType = 'slice_layer_without_partitioning_rbsp_idr';
	          break;
	
	        case 0x06:
	          event.nalUnitType = 'sei_rbsp';
	          event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
	          break;
	
	        case 0x07:
	          event.nalUnitType = 'seq_parameter_set_rbsp';
	          event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
	          event.config = readSequenceParameterSet(event.escapedRBSP);
	          break;
	
	        case 0x08:
	          event.nalUnitType = 'pic_parameter_set_rbsp';
	          break;
	
	        case 0x09:
	          event.nalUnitType = 'access_unit_delimiter_rbsp';
	          break;
	      } // This triggers data on the H264Stream
	
	
	      self.trigger('data', event);
	    });
	    nalByteStream.on('done', function () {
	      self.trigger('done');
	    });
	    nalByteStream.on('partialdone', function () {
	      self.trigger('partialdone');
	    });
	    nalByteStream.on('reset', function () {
	      self.trigger('reset');
	    });
	    nalByteStream.on('endedtimeline', function () {
	      self.trigger('endedtimeline');
	    });
	
	    this.flush = function () {
	      nalByteStream.flush();
	    };
	
	    this.partialFlush = function () {
	      nalByteStream.partialFlush();
	    };
	
	    this.reset = function () {
	      nalByteStream.reset();
	    };
	
	    this.endTimeline = function () {
	      nalByteStream.endTimeline();
	    };
	    /**
	     * Advance the ExpGolomb decoder past a scaling list. The scaling
	     * list is optionally transmitted as part of a sequence parameter
	     * set and is not relevant to transmuxing.
	     * @param count {number} the number of entries in this scaling list
	     * @param expGolombDecoder {object} an ExpGolomb pointed to the
	     * start of a scaling list
	     * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
	     */
	
	
	    skipScalingList = function skipScalingList(count, expGolombDecoder) {
	      var lastScale = 8,
	          nextScale = 8,
	          j,
	          deltaScale;
	
	      for (j = 0; j < count; j++) {
	        if (nextScale !== 0) {
	          deltaScale = expGolombDecoder.readExpGolomb();
	          nextScale = (lastScale + deltaScale + 256) % 256;
	        }
	
	        lastScale = nextScale === 0 ? lastScale : nextScale;
	      }
	    };
	    /**
	     * Expunge any "Emulation Prevention" bytes from a "Raw Byte
	     * Sequence Payload"
	     * @param data {Uint8Array} the bytes of a RBSP from a NAL
	     * unit
	     * @return {Uint8Array} the RBSP without any Emulation
	     * Prevention Bytes
	     */
	
	
	    discardEmulationPreventionBytes = function discardEmulationPreventionBytes(data) {
	      var length = data.byteLength,
	          emulationPreventionBytesPositions = [],
	          i = 1,
	          newLength,
	          newData; // Find all `Emulation Prevention Bytes`
	
	      while (i < length - 2) {
	        if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
	          emulationPreventionBytesPositions.push(i + 2);
	          i += 2;
	        } else {
	          i++;
	        }
	      } // If no Emulation Prevention Bytes were found just return the original
	      // array
	
	
	      if (emulationPreventionBytesPositions.length === 0) {
	        return data;
	      } // Create a new array to hold the NAL unit data
	
	
	      newLength = length - emulationPreventionBytesPositions.length;
	      newData = new Uint8Array(newLength);
	      var sourceIndex = 0;
	
	      for (i = 0; i < newLength; sourceIndex++, i++) {
	        if (sourceIndex === emulationPreventionBytesPositions[0]) {
	          // Skip this byte
	          sourceIndex++; // Remove this position index
	
	          emulationPreventionBytesPositions.shift();
	        }
	
	        newData[i] = data[sourceIndex];
	      }
	
	      return newData;
	    };
	    /**
	     * Read a sequence parameter set and return some interesting video
	     * properties. A sequence parameter set is the H264 metadata that
	     * describes the properties of upcoming video frames.
	     * @param data {Uint8Array} the bytes of a sequence parameter set
	     * @return {object} an object with configuration parsed from the
	     * sequence parameter set, including the dimensions of the
	     * associated video frames.
	     */
	
	
	    readSequenceParameterSet = function readSequenceParameterSet(data) {
	      var frameCropLeftOffset = 0,
	          frameCropRightOffset = 0,
	          frameCropTopOffset = 0,
	          frameCropBottomOffset = 0,
	          expGolombDecoder,
	          profileIdc,
	          levelIdc,
	          profileCompatibility,
	          chromaFormatIdc,
	          picOrderCntType,
	          numRefFramesInPicOrderCntCycle,
	          picWidthInMbsMinus1,
	          picHeightInMapUnitsMinus1,
	          frameMbsOnlyFlag,
	          scalingListCount,
	          sarRatio = [1, 1],
	          aspectRatioIdc,
	          i;
	      expGolombDecoder = new expGolomb(data);
	      profileIdc = expGolombDecoder.readUnsignedByte(); // profile_idc
	
	      profileCompatibility = expGolombDecoder.readUnsignedByte(); // constraint_set[0-5]_flag
	
	      levelIdc = expGolombDecoder.readUnsignedByte(); // level_idc u(8)
	
	      expGolombDecoder.skipUnsignedExpGolomb(); // seq_parameter_set_id
	      // some profiles have more optional data we don't need
	
	      if (PROFILES_WITH_OPTIONAL_SPS_DATA[profileIdc]) {
	        chromaFormatIdc = expGolombDecoder.readUnsignedExpGolomb();
	
	        if (chromaFormatIdc === 3) {
	          expGolombDecoder.skipBits(1); // separate_colour_plane_flag
	        }
	
	        expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_luma_minus8
	
	        expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_chroma_minus8
	
	        expGolombDecoder.skipBits(1); // qpprime_y_zero_transform_bypass_flag
	
	        if (expGolombDecoder.readBoolean()) {
	          // seq_scaling_matrix_present_flag
	          scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
	
	          for (i = 0; i < scalingListCount; i++) {
	            if (expGolombDecoder.readBoolean()) {
	              // seq_scaling_list_present_flag[ i ]
	              if (i < 6) {
	                skipScalingList(16, expGolombDecoder);
	              } else {
	                skipScalingList(64, expGolombDecoder);
	              }
	            }
	          }
	        }
	      }
	
	      expGolombDecoder.skipUnsignedExpGolomb(); // log2_max_frame_num_minus4
	
	      picOrderCntType = expGolombDecoder.readUnsignedExpGolomb();
	
	      if (picOrderCntType === 0) {
	        expGolombDecoder.readUnsignedExpGolomb(); // log2_max_pic_order_cnt_lsb_minus4
	      } else if (picOrderCntType === 1) {
	        expGolombDecoder.skipBits(1); // delta_pic_order_always_zero_flag
	
	        expGolombDecoder.skipExpGolomb(); // offset_for_non_ref_pic
	
	        expGolombDecoder.skipExpGolomb(); // offset_for_top_to_bottom_field
	
	        numRefFramesInPicOrderCntCycle = expGolombDecoder.readUnsignedExpGolomb();
	
	        for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
	          expGolombDecoder.skipExpGolomb(); // offset_for_ref_frame[ i ]
	        }
	      }
	
	      expGolombDecoder.skipUnsignedExpGolomb(); // max_num_ref_frames
	
	      expGolombDecoder.skipBits(1); // gaps_in_frame_num_value_allowed_flag
	
	      picWidthInMbsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
	      picHeightInMapUnitsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
	      frameMbsOnlyFlag = expGolombDecoder.readBits(1);
	
	      if (frameMbsOnlyFlag === 0) {
	        expGolombDecoder.skipBits(1); // mb_adaptive_frame_field_flag
	      }
	
	      expGolombDecoder.skipBits(1); // direct_8x8_inference_flag
	
	      if (expGolombDecoder.readBoolean()) {
	        // frame_cropping_flag
	        frameCropLeftOffset = expGolombDecoder.readUnsignedExpGolomb();
	        frameCropRightOffset = expGolombDecoder.readUnsignedExpGolomb();
	        frameCropTopOffset = expGolombDecoder.readUnsignedExpGolomb();
	        frameCropBottomOffset = expGolombDecoder.readUnsignedExpGolomb();
	      }
	
	      if (expGolombDecoder.readBoolean()) {
	        // vui_parameters_present_flag
	        if (expGolombDecoder.readBoolean()) {
	          // aspect_ratio_info_present_flag
	          aspectRatioIdc = expGolombDecoder.readUnsignedByte();
	
	          switch (aspectRatioIdc) {
	            case 1:
	              sarRatio = [1, 1];
	              break;
	
	            case 2:
	              sarRatio = [12, 11];
	              break;
	
	            case 3:
	              sarRatio = [10, 11];
	              break;
	
	            case 4:
	              sarRatio = [16, 11];
	              break;
	
	            case 5:
	              sarRatio = [40, 33];
	              break;
	
	            case 6:
	              sarRatio = [24, 11];
	              break;
	
	            case 7:
	              sarRatio = [20, 11];
	              break;
	
	            case 8:
	              sarRatio = [32, 11];
	              break;
	
	            case 9:
	              sarRatio = [80, 33];
	              break;
	
	            case 10:
	              sarRatio = [18, 11];
	              break;
	
	            case 11:
	              sarRatio = [15, 11];
	              break;
	
	            case 12:
	              sarRatio = [64, 33];
	              break;
	
	            case 13:
	              sarRatio = [160, 99];
	              break;
	
	            case 14:
	              sarRatio = [4, 3];
	              break;
	
	            case 15:
	              sarRatio = [3, 2];
	              break;
	
	            case 16:
	              sarRatio = [2, 1];
	              break;
	
	            case 255:
	              {
	                sarRatio = [expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte(), expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte()];
	                break;
	              }
	          }
	
	          if (sarRatio) {
	            sarRatio[0] / sarRatio[1];
	          }
	        }
	      }
	
	      return {
	        profileIdc: profileIdc,
	        levelIdc: levelIdc,
	        profileCompatibility: profileCompatibility,
	        width: (picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2,
	        height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - frameCropTopOffset * 2 - frameCropBottomOffset * 2,
	        // sar is sample aspect ratio
	        sarRatio: sarRatio
	      };
	    };
	  };
	
	  _H264Stream.prototype = new stream();
	  var h264 = {
	    H264Stream: _H264Stream,
	    NalByteStream: _NalByteStream
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   *
	   * Utilities to detect basic properties and metadata about Aac data.
	   */
	
	  var ADTS_SAMPLING_FREQUENCIES = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
	
	  var parseId3TagSize = function parseId3TagSize(header, byteIndex) {
	    var returnSize = header[byteIndex + 6] << 21 | header[byteIndex + 7] << 14 | header[byteIndex + 8] << 7 | header[byteIndex + 9],
	        flags = header[byteIndex + 5],
	        footerPresent = (flags & 16) >> 4; // if we get a negative returnSize clamp it to 0
	
	    returnSize = returnSize >= 0 ? returnSize : 0;
	
	    if (footerPresent) {
	      return returnSize + 20;
	    }
	
	    return returnSize + 10;
	  };
	
	  var getId3Offset = function getId3Offset(data, offset) {
	    if (data.length - offset < 10 || data[offset] !== 'I'.charCodeAt(0) || data[offset + 1] !== 'D'.charCodeAt(0) || data[offset + 2] !== '3'.charCodeAt(0)) {
	      return offset;
	    }
	
	    offset += parseId3TagSize(data, offset);
	    return getId3Offset(data, offset);
	  }; // TODO: use vhs-utils
	
	
	  var isLikelyAacData$1 = function isLikelyAacData(data) {
	    var offset = getId3Offset(data, 0);
	    return data.length >= offset + 2 && (data[offset] & 0xFF) === 0xFF && (data[offset + 1] & 0xF0) === 0xF0 && // verify that the 2 layer bits are 0, aka this
	    // is not mp3 data but aac data.
	    (data[offset + 1] & 0x16) === 0x10;
	  };
	
	  var parseSyncSafeInteger = function parseSyncSafeInteger(data) {
	    return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
	  }; // return a percent-encoded representation of the specified byte range
	  // @see http://en.wikipedia.org/wiki/Percent-encoding
	
	
	  var percentEncode = function percentEncode(bytes, start, end) {
	    var i,
	        result = '';
	
	    for (i = start; i < end; i++) {
	      result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
	    }
	
	    return result;
	  }; // return the string representation of the specified byte range,
	  // interpreted as ISO-8859-1.
	
	
	  var parseIso88591 = function parseIso88591(bytes, start, end) {
	    return unescape(percentEncode(bytes, start, end)); // jshint ignore:line
	  };
	
	  var parseAdtsSize = function parseAdtsSize(header, byteIndex) {
	    var lowThree = (header[byteIndex + 5] & 0xE0) >> 5,
	        middle = header[byteIndex + 4] << 3,
	        highTwo = header[byteIndex + 3] & 0x3 << 11;
	    return highTwo | middle | lowThree;
	  };
	
	  var parseType$2 = function parseType(header, byteIndex) {
	    if (header[byteIndex] === 'I'.charCodeAt(0) && header[byteIndex + 1] === 'D'.charCodeAt(0) && header[byteIndex + 2] === '3'.charCodeAt(0)) {
	      return 'timed-metadata';
	    } else if (header[byteIndex] & 0xff === 0xff && (header[byteIndex + 1] & 0xf0) === 0xf0) {
	      return 'audio';
	    }
	
	    return null;
	  };
	
	  var parseSampleRate = function parseSampleRate(packet) {
	    var i = 0;
	
	    while (i + 5 < packet.length) {
	      if (packet[i] !== 0xFF || (packet[i + 1] & 0xF6) !== 0xF0) {
	        // If a valid header was not found,  jump one forward and attempt to
	        // find a valid ADTS header starting at the next byte
	        i++;
	        continue;
	      }
	
	      return ADTS_SAMPLING_FREQUENCIES[(packet[i + 2] & 0x3c) >>> 2];
	    }
	
	    return null;
	  };
	
	  var parseAacTimestamp = function parseAacTimestamp(packet) {
	    var frameStart, frameSize, frame, frameHeader; // find the start of the first frame and the end of the tag
	
	    frameStart = 10;
	
	    if (packet[5] & 0x40) {
	      // advance the frame start past the extended header
	      frameStart += 4; // header size field
	
	      frameStart += parseSyncSafeInteger(packet.subarray(10, 14));
	    } // parse one or more ID3 frames
	    // http://id3.org/id3v2.3.0#ID3v2_frame_overview
	
	
	    do {
	      // determine the number of bytes in this frame
	      frameSize = parseSyncSafeInteger(packet.subarray(frameStart + 4, frameStart + 8));
	
	      if (frameSize < 1) {
	        return null;
	      }
	
	      frameHeader = String.fromCharCode(packet[frameStart], packet[frameStart + 1], packet[frameStart + 2], packet[frameStart + 3]);
	
	      if (frameHeader === 'PRIV') {
	        frame = packet.subarray(frameStart + 10, frameStart + frameSize + 10);
	
	        for (var i = 0; i < frame.byteLength; i++) {
	          if (frame[i] === 0) {
	            var owner = parseIso88591(frame, 0, i);
	
	            if (owner === 'com.apple.streaming.transportStreamTimestamp') {
	              var d = frame.subarray(i + 1);
	              var size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
	              size *= 4;
	              size += d[7] & 0x03;
	              return size;
	            }
	
	            break;
	          }
	        }
	      }
	
	      frameStart += 10; // advance past the frame header
	
	      frameStart += frameSize; // advance past the frame body
	    } while (frameStart < packet.byteLength);
	
	    return null;
	  };
	
	  var utils = {
	    isLikelyAacData: isLikelyAacData$1,
	    parseId3TagSize: parseId3TagSize,
	    parseAdtsSize: parseAdtsSize,
	    parseType: parseType$2,
	    parseSampleRate: parseSampleRate,
	    parseAacTimestamp: parseAacTimestamp
	  };
	
	  var _AacStream;
	  /**
	   * Splits an incoming stream of binary data into ADTS and ID3 Frames.
	   */
	
	
	  _AacStream = function AacStream() {
	    var everything = new Uint8Array(),
	        timeStamp = 0;
	
	    _AacStream.prototype.init.call(this);
	
	    this.setTimestamp = function (timestamp) {
	      timeStamp = timestamp;
	    };
	
	    this.push = function (bytes) {
	      var frameSize = 0,
	          byteIndex = 0,
	          bytesLeft,
	          chunk,
	          packet,
	          tempLength; // If there are bytes remaining from the last segment, prepend them to the
	      // bytes that were pushed in
	
	      if (everything.length) {
	        tempLength = everything.length;
	        everything = new Uint8Array(bytes.byteLength + tempLength);
	        everything.set(everything.subarray(0, tempLength));
	        everything.set(bytes, tempLength);
	      } else {
	        everything = bytes;
	      }
	
	      while (everything.length - byteIndex >= 3) {
	        if (everything[byteIndex] === 'I'.charCodeAt(0) && everything[byteIndex + 1] === 'D'.charCodeAt(0) && everything[byteIndex + 2] === '3'.charCodeAt(0)) {
	          // Exit early because we don't have enough to parse
	          // the ID3 tag header
	          if (everything.length - byteIndex < 10) {
	            break;
	          } // check framesize
	
	
	          frameSize = utils.parseId3TagSize(everything, byteIndex); // Exit early if we don't have enough in the buffer
	          // to emit a full packet
	          // Add to byteIndex to support multiple ID3 tags in sequence
	
	          if (byteIndex + frameSize > everything.length) {
	            break;
	          }
	
	          chunk = {
	            type: 'timed-metadata',
	            data: everything.subarray(byteIndex, byteIndex + frameSize)
	          };
	          this.trigger('data', chunk);
	          byteIndex += frameSize;
	          continue;
	        } else if ((everything[byteIndex] & 0xff) === 0xff && (everything[byteIndex + 1] & 0xf0) === 0xf0) {
	          // Exit early because we don't have enough to parse
	          // the ADTS frame header
	          if (everything.length - byteIndex < 7) {
	            break;
	          }
	
	          frameSize = utils.parseAdtsSize(everything, byteIndex); // Exit early if we don't have enough in the buffer
	          // to emit a full packet
	
	          if (byteIndex + frameSize > everything.length) {
	            break;
	          }
	
	          packet = {
	            type: 'audio',
	            data: everything.subarray(byteIndex, byteIndex + frameSize),
	            pts: timeStamp,
	            dts: timeStamp
	          };
	          this.trigger('data', packet);
	          byteIndex += frameSize;
	          continue;
	        }
	
	        byteIndex++;
	      }
	
	      bytesLeft = everything.length - byteIndex;
	
	      if (bytesLeft > 0) {
	        everything = everything.subarray(byteIndex);
	      } else {
	        everything = new Uint8Array();
	      }
	    };
	
	    this.reset = function () {
	      everything = new Uint8Array();
	      this.trigger('reset');
	    };
	
	    this.endTimeline = function () {
	      everything = new Uint8Array();
	      this.trigger('endedtimeline');
	    };
	  };
	
	  _AacStream.prototype = new stream();
	  var aac = _AacStream; // constants
	
	  var AUDIO_PROPERTIES = ['audioobjecttype', 'channelcount', 'samplerate', 'samplingfrequencyindex', 'samplesize'];
	  var audioProperties = AUDIO_PROPERTIES;
	  var VIDEO_PROPERTIES = ['width', 'height', 'profileIdc', 'levelIdc', 'profileCompatibility', 'sarRatio'];
	  var videoProperties = VIDEO_PROPERTIES;
	  var H264Stream = h264.H264Stream;
	  var isLikelyAacData = utils.isLikelyAacData;
	  var ONE_SECOND_IN_TS$1 = clock.ONE_SECOND_IN_TS; // object types
	
	  var _VideoSegmentStream, _AudioSegmentStream, _Transmuxer, _CoalesceStream;
	
	  var retriggerForStream = function retriggerForStream(key, event) {
	    event.stream = key;
	    this.trigger('log', event);
	  };
	
	  var addPipelineLogRetriggers = function addPipelineLogRetriggers(transmuxer, pipeline) {
	    var keys = Object.keys(pipeline);
	
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i]; // skip non-stream keys and headOfPipeline
	      // which is just a duplicate
	
	      if (key === 'headOfPipeline' || !pipeline[key].on) {
	        continue;
	      }
	
	      pipeline[key].on('log', retriggerForStream.bind(transmuxer, key));
	    }
	  };
	  /**
	   * Compare two arrays (even typed) for same-ness
	   */
	
	
	  var arrayEquals = function arrayEquals(a, b) {
	    var i;
	
	    if (a.length !== b.length) {
	      return false;
	    } // compare the value of each element in the array
	
	
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  var generateSegmentTimingInfo = function generateSegmentTimingInfo(baseMediaDecodeTime, startDts, startPts, endDts, endPts, prependedContentDuration) {
	    var ptsOffsetFromDts = startPts - startDts,
	        decodeDuration = endDts - startDts,
	        presentationDuration = endPts - startPts; // The PTS and DTS values are based on the actual stream times from the segment,
	    // however, the player time values will reflect a start from the baseMediaDecodeTime.
	    // In order to provide relevant values for the player times, base timing info on the
	    // baseMediaDecodeTime and the DTS and PTS durations of the segment.
	
	    return {
	      start: {
	        dts: baseMediaDecodeTime,
	        pts: baseMediaDecodeTime + ptsOffsetFromDts
	      },
	      end: {
	        dts: baseMediaDecodeTime + decodeDuration,
	        pts: baseMediaDecodeTime + presentationDuration
	      },
	      prependedContentDuration: prependedContentDuration,
	      baseMediaDecodeTime: baseMediaDecodeTime
	    };
	  };
	  /**
	   * Constructs a single-track, ISO BMFF media segment from AAC data
	   * events. The output of this stream can be fed to a SourceBuffer
	   * configured with a suitable initialization segment.
	   * @param track {object} track metadata configuration
	   * @param options {object} transmuxer options object
	   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
	   *        in the source; false to adjust the first segment to start at 0.
	   */
	
	
	  _AudioSegmentStream = function AudioSegmentStream(track, options) {
	    var adtsFrames = [],
	        sequenceNumber,
	        earliestAllowedDts = 0,
	        audioAppendStartTs = 0,
	        videoBaseMediaDecodeTime = Infinity;
	    options = options || {};
	    sequenceNumber = options.firstSequenceNumber || 0;
	
	    _AudioSegmentStream.prototype.init.call(this);
	
	    this.push = function (data) {
	      trackDecodeInfo.collectDtsInfo(track, data);
	
	      if (track) {
	        audioProperties.forEach(function (prop) {
	          track[prop] = data[prop];
	        });
	      } // buffer audio data until end() is called
	
	
	      adtsFrames.push(data);
	    };
	
	    this.setEarliestDts = function (earliestDts) {
	      earliestAllowedDts = earliestDts;
	    };
	
	    this.setVideoBaseMediaDecodeTime = function (baseMediaDecodeTime) {
	      videoBaseMediaDecodeTime = baseMediaDecodeTime;
	    };
	
	    this.setAudioAppendStart = function (timestamp) {
	      audioAppendStartTs = timestamp;
	    };
	
	    this.flush = function () {
	      var frames, moof, mdat, boxes, frameDuration, segmentDuration, videoClockCyclesOfSilencePrefixed; // return early if no audio data has been observed
	
	      if (adtsFrames.length === 0) {
	        this.trigger('done', 'AudioSegmentStream');
	        return;
	      }
	
	      frames = audioFrameUtils.trimAdtsFramesByEarliestDts(adtsFrames, track, earliestAllowedDts);
	      track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps); // amount of audio filled but the value is in video clock rather than audio clock
	
	      videoClockCyclesOfSilencePrefixed = audioFrameUtils.prefixWithSilence(track, frames, audioAppendStartTs, videoBaseMediaDecodeTime); // we have to build the index from byte locations to
	      // samples (that is, adts frames) in the audio data
	
	      track.samples = audioFrameUtils.generateSampleTable(frames); // concatenate the audio data to constuct the mdat
	
	      mdat = mp4Generator.mdat(audioFrameUtils.concatenateFrameData(frames));
	      adtsFrames = [];
	      moof = mp4Generator.moof(sequenceNumber, [track]);
	      boxes = new Uint8Array(moof.byteLength + mdat.byteLength); // bump the sequence number for next time
	
	      sequenceNumber++;
	      boxes.set(moof);
	      boxes.set(mdat, moof.byteLength);
	      trackDecodeInfo.clearDtsInfo(track);
	      frameDuration = Math.ceil(ONE_SECOND_IN_TS$1 * 1024 / track.samplerate); // TODO this check was added to maintain backwards compatibility (particularly with
	      // tests) on adding the timingInfo event. However, it seems unlikely that there's a
	      // valid use-case where an init segment/data should be triggered without associated
	      // frames. Leaving for now, but should be looked into.
	
	      if (frames.length) {
	        segmentDuration = frames.length * frameDuration;
	        this.trigger('segmentTimingInfo', generateSegmentTimingInfo( // The audio track's baseMediaDecodeTime is in audio clock cycles, but the
	        // frame info is in video clock cycles. Convert to match expectation of
	        // listeners (that all timestamps will be based on video clock cycles).
	        clock.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate), // frame times are already in video clock, as is segment duration
	        frames[0].dts, frames[0].pts, frames[0].dts + segmentDuration, frames[0].pts + segmentDuration, videoClockCyclesOfSilencePrefixed || 0));
	        this.trigger('timingInfo', {
	          start: frames[0].pts,
	          end: frames[0].pts + segmentDuration
	        });
	      }
	
	      this.trigger('data', {
	        track: track,
	        boxes: boxes
	      });
	      this.trigger('done', 'AudioSegmentStream');
	    };
	
	    this.reset = function () {
	      trackDecodeInfo.clearDtsInfo(track);
	      adtsFrames = [];
	      this.trigger('reset');
	    };
	  };
	
	  _AudioSegmentStream.prototype = new stream();
	  /**
	   * Constructs a single-track, ISO BMFF media segment from H264 data
	   * events. The output of this stream can be fed to a SourceBuffer
	   * configured with a suitable initialization segment.
	   * @param track {object} track metadata configuration
	   * @param options {object} transmuxer options object
	   * @param options.alignGopsAtEnd {boolean} If true, start from the end of the
	   *        gopsToAlignWith list when attempting to align gop pts
	   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
	   *        in the source; false to adjust the first segment to start at 0.
	   */
	
	  _VideoSegmentStream = function VideoSegmentStream(track, options) {
	    var sequenceNumber,
	        nalUnits = [],
	        gopsToAlignWith = [],
	        config,
	        pps;
	    options = options || {};
	    sequenceNumber = options.firstSequenceNumber || 0;
	
	    _VideoSegmentStream.prototype.init.call(this);
	
	    delete track.minPTS;
	    this.gopCache_ = [];
	    /**
	      * Constructs a ISO BMFF segment given H264 nalUnits
	      * @param {Object} nalUnit A data event representing a nalUnit
	      * @param {String} nalUnit.nalUnitType
	      * @param {Object} nalUnit.config Properties for a mp4 track
	      * @param {Uint8Array} nalUnit.data The nalUnit bytes
	      * @see lib/codecs/h264.js
	     **/
	
	    this.push = function (nalUnit) {
	      trackDecodeInfo.collectDtsInfo(track, nalUnit); // record the track config
	
	      if (nalUnit.nalUnitType === 'seq_parameter_set_rbsp' && !config) {
	        config = nalUnit.config;
	        track.sps = [nalUnit.data];
	        videoProperties.forEach(function (prop) {
	          track[prop] = config[prop];
	        }, this);
	      }
	
	      if (nalUnit.nalUnitType === 'pic_parameter_set_rbsp' && !pps) {
	        pps = nalUnit.data;
	        track.pps = [nalUnit.data];
	      } // buffer video until flush() is called
	
	
	      nalUnits.push(nalUnit);
	    };
	    /**
	      * Pass constructed ISO BMFF track and boxes on to the
	      * next stream in the pipeline
	     **/
	
	
	    this.flush = function () {
	      var frames,
	          gopForFusion,
	          gops,
	          moof,
	          mdat,
	          boxes,
	          prependedContentDuration = 0,
	          firstGop,
	          lastGop; // Throw away nalUnits at the start of the byte stream until
	      // we find the first AUD
	
	      while (nalUnits.length) {
	        if (nalUnits[0].nalUnitType === 'access_unit_delimiter_rbsp') {
	          break;
	        }
	
	        nalUnits.shift();
	      } // Return early if no video data has been observed
	
	
	      if (nalUnits.length === 0) {
	        this.resetStream_();
	        this.trigger('done', 'VideoSegmentStream');
	        return;
	      } // Organize the raw nal-units into arrays that represent
	      // higher-level constructs such as frames and gops
	      // (group-of-pictures)
	
	
	      frames = frameUtils.groupNalsIntoFrames(nalUnits);
	      gops = frameUtils.groupFramesIntoGops(frames); // If the first frame of this fragment is not a keyframe we have
	      // a problem since MSE (on Chrome) requires a leading keyframe.
	      //
	      // We have two approaches to repairing this situation:
	      // 1) GOP-FUSION:
	      //    This is where we keep track of the GOPS (group-of-pictures)
	      //    from previous fragments and attempt to find one that we can
	      //    prepend to the current fragment in order to create a valid
	      //    fragment.
	      // 2) KEYFRAME-PULLING:
	      //    Here we search for the first keyframe in the fragment and
	      //    throw away all the frames between the start of the fragment
	      //    and that keyframe. We then extend the duration and pull the
	      //    PTS of the keyframe forward so that it covers the time range
	      //    of the frames that were disposed of.
	      //
	      // #1 is far prefereable over #2 which can cause "stuttering" but
	      // requires more things to be just right.
	
	      if (!gops[0][0].keyFrame) {
	        // Search for a gop for fusion from our gopCache
	        gopForFusion = this.getGopForFusion_(nalUnits[0], track);
	
	        if (gopForFusion) {
	          // in order to provide more accurate timing information about the segment, save
	          // the number of seconds prepended to the original segment due to GOP fusion
	          prependedContentDuration = gopForFusion.duration;
	          gops.unshift(gopForFusion); // Adjust Gops' metadata to account for the inclusion of the
	          // new gop at the beginning
	
	          gops.byteLength += gopForFusion.byteLength;
	          gops.nalCount += gopForFusion.nalCount;
	          gops.pts = gopForFusion.pts;
	          gops.dts = gopForFusion.dts;
	          gops.duration += gopForFusion.duration;
	        } else {
	          // If we didn't find a candidate gop fall back to keyframe-pulling
	          gops = frameUtils.extendFirstKeyFrame(gops);
	        }
	      } // Trim gops to align with gopsToAlignWith
	
	
	      if (gopsToAlignWith.length) {
	        var alignedGops;
	
	        if (options.alignGopsAtEnd) {
	          alignedGops = this.alignGopsAtEnd_(gops);
	        } else {
	          alignedGops = this.alignGopsAtStart_(gops);
	        }
	
	        if (!alignedGops) {
	          // save all the nals in the last GOP into the gop cache
	          this.gopCache_.unshift({
	            gop: gops.pop(),
	            pps: track.pps,
	            sps: track.sps
	          }); // Keep a maximum of 6 GOPs in the cache
	
	          this.gopCache_.length = Math.min(6, this.gopCache_.length); // Clear nalUnits
	
	          nalUnits = []; // return early no gops can be aligned with desired gopsToAlignWith
	
	          this.resetStream_();
	          this.trigger('done', 'VideoSegmentStream');
	          return;
	        } // Some gops were trimmed. clear dts info so minSegmentDts and pts are correct
	        // when recalculated before sending off to CoalesceStream
	
	
	        trackDecodeInfo.clearDtsInfo(track);
	        gops = alignedGops;
	      }
	
	      trackDecodeInfo.collectDtsInfo(track, gops); // First, we have to build the index from byte locations to
	      // samples (that is, frames) in the video data
	
	      track.samples = frameUtils.generateSampleTable(gops); // Concatenate the video data and construct the mdat
	
	      mdat = mp4Generator.mdat(frameUtils.concatenateNalData(gops));
	      track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps);
	      this.trigger('processedGopsInfo', gops.map(function (gop) {
	        return {
	          pts: gop.pts,
	          dts: gop.dts,
	          byteLength: gop.byteLength
	        };
	      }));
	      firstGop = gops[0];
	      lastGop = gops[gops.length - 1];
	      this.trigger('segmentTimingInfo', generateSegmentTimingInfo(track.baseMediaDecodeTime, firstGop.dts, firstGop.pts, lastGop.dts + lastGop.duration, lastGop.pts + lastGop.duration, prependedContentDuration));
	      this.trigger('timingInfo', {
	        start: gops[0].pts,
	        end: gops[gops.length - 1].pts + gops[gops.length - 1].duration
	      }); // save all the nals in the last GOP into the gop cache
	
	      this.gopCache_.unshift({
	        gop: gops.pop(),
	        pps: track.pps,
	        sps: track.sps
	      }); // Keep a maximum of 6 GOPs in the cache
	
	      this.gopCache_.length = Math.min(6, this.gopCache_.length); // Clear nalUnits
	
	      nalUnits = [];
	      this.trigger('baseMediaDecodeTime', track.baseMediaDecodeTime);
	      this.trigger('timelineStartInfo', track.timelineStartInfo);
	      moof = mp4Generator.moof(sequenceNumber, [track]); // it would be great to allocate this array up front instead of
	      // throwing away hundreds of media segment fragments
	
	      boxes = new Uint8Array(moof.byteLength + mdat.byteLength); // Bump the sequence number for next time
	
	      sequenceNumber++;
	      boxes.set(moof);
	      boxes.set(mdat, moof.byteLength);
	      this.trigger('data', {
	        track: track,
	        boxes: boxes
	      });
	      this.resetStream_(); // Continue with the flush process now
	
	      this.trigger('done', 'VideoSegmentStream');
	    };
	
	    this.reset = function () {
	      this.resetStream_();
	      nalUnits = [];
	      this.gopCache_.length = 0;
	      gopsToAlignWith.length = 0;
	      this.trigger('reset');
	    };
	
	    this.resetStream_ = function () {
	      trackDecodeInfo.clearDtsInfo(track); // reset config and pps because they may differ across segments
	      // for instance, when we are rendition switching
	
	      config = undefined;
	      pps = undefined;
	    }; // Search for a candidate Gop for gop-fusion from the gop cache and
	    // return it or return null if no good candidate was found
	
	
	    this.getGopForFusion_ = function (nalUnit) {
	      var halfSecond = 45000,
	          // Half-a-second in a 90khz clock
	      allowableOverlap = 10000,
	          // About 3 frames @ 30fps
	      nearestDistance = Infinity,
	          dtsDistance,
	          nearestGopObj,
	          currentGop,
	          currentGopObj,
	          i; // Search for the GOP nearest to the beginning of this nal unit
	
	      for (i = 0; i < this.gopCache_.length; i++) {
	        currentGopObj = this.gopCache_[i];
	        currentGop = currentGopObj.gop; // Reject Gops with different SPS or PPS
	
	        if (!(track.pps && arrayEquals(track.pps[0], currentGopObj.pps[0])) || !(track.sps && arrayEquals(track.sps[0], currentGopObj.sps[0]))) {
	          continue;
	        } // Reject Gops that would require a negative baseMediaDecodeTime
	
	
	        if (currentGop.dts < track.timelineStartInfo.dts) {
	          continue;
	        } // The distance between the end of the gop and the start of the nalUnit
	
	
	        dtsDistance = nalUnit.dts - currentGop.dts - currentGop.duration; // Only consider GOPS that start before the nal unit and end within
	        // a half-second of the nal unit
	
	        if (dtsDistance >= -allowableOverlap && dtsDistance <= halfSecond) {
	          // Always use the closest GOP we found if there is more than
	          // one candidate
	          if (!nearestGopObj || nearestDistance > dtsDistance) {
	            nearestGopObj = currentGopObj;
	            nearestDistance = dtsDistance;
	          }
	        }
	      }
	
	      if (nearestGopObj) {
	        return nearestGopObj.gop;
	      }
	
	      return null;
	    }; // trim gop list to the first gop found that has a matching pts with a gop in the list
	    // of gopsToAlignWith starting from the START of the list
	
	
	    this.alignGopsAtStart_ = function (gops) {
	      var alignIndex, gopIndex, align, gop, byteLength, nalCount, duration, alignedGops;
	      byteLength = gops.byteLength;
	      nalCount = gops.nalCount;
	      duration = gops.duration;
	      alignIndex = gopIndex = 0;
	
	      while (alignIndex < gopsToAlignWith.length && gopIndex < gops.length) {
	        align = gopsToAlignWith[alignIndex];
	        gop = gops[gopIndex];
	
	        if (align.pts === gop.pts) {
	          break;
	        }
	
	        if (gop.pts > align.pts) {
	          // this current gop starts after the current gop we want to align on, so increment
	          // align index
	          alignIndex++;
	          continue;
	        } // current gop starts before the current gop we want to align on. so increment gop
	        // index
	
	
	        gopIndex++;
	        byteLength -= gop.byteLength;
	        nalCount -= gop.nalCount;
	        duration -= gop.duration;
	      }
	
	      if (gopIndex === 0) {
	        // no gops to trim
	        return gops;
	      }
	
	      if (gopIndex === gops.length) {
	        // all gops trimmed, skip appending all gops
	        return null;
	      }
	
	      alignedGops = gops.slice(gopIndex);
	      alignedGops.byteLength = byteLength;
	      alignedGops.duration = duration;
	      alignedGops.nalCount = nalCount;
	      alignedGops.pts = alignedGops[0].pts;
	      alignedGops.dts = alignedGops[0].dts;
	      return alignedGops;
	    }; // trim gop list to the first gop found that has a matching pts with a gop in the list
	    // of gopsToAlignWith starting from the END of the list
	
	
	    this.alignGopsAtEnd_ = function (gops) {
	      var alignIndex, gopIndex, align, gop, alignEndIndex, matchFound;
	      alignIndex = gopsToAlignWith.length - 1;
	      gopIndex = gops.length - 1;
	      alignEndIndex = null;
	      matchFound = false;
	
	      while (alignIndex >= 0 && gopIndex >= 0) {
	        align = gopsToAlignWith[alignIndex];
	        gop = gops[gopIndex];
	
	        if (align.pts === gop.pts) {
	          matchFound = true;
	          break;
	        }
	
	        if (align.pts > gop.pts) {
	          alignIndex--;
	          continue;
	        }
	
	        if (alignIndex === gopsToAlignWith.length - 1) {
	          // gop.pts is greater than the last alignment candidate. If no match is found
	          // by the end of this loop, we still want to append gops that come after this
	          // point
	          alignEndIndex = gopIndex;
	        }
	
	        gopIndex--;
	      }
	
	      if (!matchFound && alignEndIndex === null) {
	        return null;
	      }
	
	      var trimIndex;
	
	      if (matchFound) {
	        trimIndex = gopIndex;
	      } else {
	        trimIndex = alignEndIndex;
	      }
	
	      if (trimIndex === 0) {
	        return gops;
	      }
	
	      var alignedGops = gops.slice(trimIndex);
	      var metadata = alignedGops.reduce(function (total, gop) {
	        total.byteLength += gop.byteLength;
	        total.duration += gop.duration;
	        total.nalCount += gop.nalCount;
	        return total;
	      }, {
	        byteLength: 0,
	        duration: 0,
	        nalCount: 0
	      });
	      alignedGops.byteLength = metadata.byteLength;
	      alignedGops.duration = metadata.duration;
	      alignedGops.nalCount = metadata.nalCount;
	      alignedGops.pts = alignedGops[0].pts;
	      alignedGops.dts = alignedGops[0].dts;
	      return alignedGops;
	    };
	
	    this.alignGopsWith = function (newGopsToAlignWith) {
	      gopsToAlignWith = newGopsToAlignWith;
	    };
	  };
	
	  _VideoSegmentStream.prototype = new stream();
	  /**
	   * A Stream that can combine multiple streams (ie. audio & video)
	   * into a single output segment for MSE. Also supports audio-only
	   * and video-only streams.
	   * @param options {object} transmuxer options object
	   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
	   *        in the source; false to adjust the first segment to start at media timeline start.
	   */
	
	  _CoalesceStream = function CoalesceStream(options, metadataStream) {
	    // Number of Tracks per output segment
	    // If greater than 1, we combine multiple
	    // tracks into a single segment
	    this.numberOfTracks = 0;
	    this.metadataStream = metadataStream;
	    options = options || {};
	
	    if (typeof options.remux !== 'undefined') {
	      this.remuxTracks = !!options.remux;
	    } else {
	      this.remuxTracks = true;
	    }
	
	    if (typeof options.keepOriginalTimestamps === 'boolean') {
	      this.keepOriginalTimestamps = options.keepOriginalTimestamps;
	    } else {
	      this.keepOriginalTimestamps = false;
	    }
	
	    this.pendingTracks = [];
	    this.videoTrack = null;
	    this.pendingBoxes = [];
	    this.pendingCaptions = [];
	    this.pendingMetadata = [];
	    this.pendingBytes = 0;
	    this.emittedTracks = 0;
	
	    _CoalesceStream.prototype.init.call(this); // Take output from multiple
	
	
	    this.push = function (output) {
	      // buffer incoming captions until the associated video segment
	      // finishes
	      if (output.text) {
	        return this.pendingCaptions.push(output);
	      } // buffer incoming id3 tags until the final flush
	
	
	      if (output.frames) {
	        return this.pendingMetadata.push(output);
	      } // Add this track to the list of pending tracks and store
	      // important information required for the construction of
	      // the final segment
	
	
	      this.pendingTracks.push(output.track);
	      this.pendingBytes += output.boxes.byteLength; // TODO: is there an issue for this against chrome?
	      // We unshift audio and push video because
	      // as of Chrome 75 when switching from
	      // one init segment to another if the video
	      // mdat does not appear after the audio mdat
	      // only audio will play for the duration of our transmux.
	
	      if (output.track.type === 'video') {
	        this.videoTrack = output.track;
	        this.pendingBoxes.push(output.boxes);
	      }
	
	      if (output.track.type === 'audio') {
	        this.audioTrack = output.track;
	        this.pendingBoxes.unshift(output.boxes);
	      }
	    };
	  };
	
	  _CoalesceStream.prototype = new stream();
	
	  _CoalesceStream.prototype.flush = function (flushSource) {
	    var offset = 0,
	        event = {
	      captions: [],
	      captionStreams: {},
	      metadata: [],
	      info: {}
	    },
	        caption,
	        id3,
	        initSegment,
	        timelineStartPts = 0,
	        i;
	
	    if (this.pendingTracks.length < this.numberOfTracks) {
	      if (flushSource !== 'VideoSegmentStream' && flushSource !== 'AudioSegmentStream') {
	        // Return because we haven't received a flush from a data-generating
	        // portion of the segment (meaning that we have only recieved meta-data
	        // or captions.)
	        return;
	      } else if (this.remuxTracks) {
	        // Return until we have enough tracks from the pipeline to remux (if we
	        // are remuxing audio and video into a single MP4)
	        return;
	      } else if (this.pendingTracks.length === 0) {
	        // In the case where we receive a flush without any data having been
	        // received we consider it an emitted track for the purposes of coalescing
	        // `done` events.
	        // We do this for the case where there is an audio and video track in the
	        // segment but no audio data. (seen in several playlists with alternate
	        // audio tracks and no audio present in the main TS segments.)
	        this.emittedTracks++;
	
	        if (this.emittedTracks >= this.numberOfTracks) {
	          this.trigger('done');
	          this.emittedTracks = 0;
	        }
	
	        return;
	      }
	    }
	
	    if (this.videoTrack) {
	      timelineStartPts = this.videoTrack.timelineStartInfo.pts;
	      videoProperties.forEach(function (prop) {
	        event.info[prop] = this.videoTrack[prop];
	      }, this);
	    } else if (this.audioTrack) {
	      timelineStartPts = this.audioTrack.timelineStartInfo.pts;
	      audioProperties.forEach(function (prop) {
	        event.info[prop] = this.audioTrack[prop];
	      }, this);
	    }
	
	    if (this.videoTrack || this.audioTrack) {
	      if (this.pendingTracks.length === 1) {
	        event.type = this.pendingTracks[0].type;
	      } else {
	        event.type = 'combined';
	      }
	
	      this.emittedTracks += this.pendingTracks.length;
	      initSegment = mp4Generator.initSegment(this.pendingTracks); // Create a new typed array to hold the init segment
	
	      event.initSegment = new Uint8Array(initSegment.byteLength); // Create an init segment containing a moov
	      // and track definitions
	
	      event.initSegment.set(initSegment); // Create a new typed array to hold the moof+mdats
	
	      event.data = new Uint8Array(this.pendingBytes); // Append each moof+mdat (one per track) together
	
	      for (i = 0; i < this.pendingBoxes.length; i++) {
	        event.data.set(this.pendingBoxes[i], offset);
	        offset += this.pendingBoxes[i].byteLength;
	      } // Translate caption PTS times into second offsets to match the
	      // video timeline for the segment, and add track info
	
	
	      for (i = 0; i < this.pendingCaptions.length; i++) {
	        caption = this.pendingCaptions[i];
	        caption.startTime = clock.metadataTsToSeconds(caption.startPts, timelineStartPts, this.keepOriginalTimestamps);
	        caption.endTime = clock.metadataTsToSeconds(caption.endPts, timelineStartPts, this.keepOriginalTimestamps);
	        event.captionStreams[caption.stream] = true;
	        event.captions.push(caption);
	      } // Translate ID3 frame PTS times into second offsets to match the
	      // video timeline for the segment
	
	
	      for (i = 0; i < this.pendingMetadata.length; i++) {
	        id3 = this.pendingMetadata[i];
	        id3.cueTime = clock.metadataTsToSeconds(id3.pts, timelineStartPts, this.keepOriginalTimestamps);
	        event.metadata.push(id3);
	      } // We add this to every single emitted segment even though we only need
	      // it for the first
	
	
	      event.metadata.dispatchType = this.metadataStream.dispatchType; // Reset stream state
	
	      this.pendingTracks.length = 0;
	      this.videoTrack = null;
	      this.pendingBoxes.length = 0;
	      this.pendingCaptions.length = 0;
	      this.pendingBytes = 0;
	      this.pendingMetadata.length = 0; // Emit the built segment
	      // We include captions and ID3 tags for backwards compatibility,
	      // ideally we should send only video and audio in the data event
	
	      this.trigger('data', event); // Emit each caption to the outside world
	      // Ideally, this would happen immediately on parsing captions,
	      // but we need to ensure that video data is sent back first
	      // so that caption timing can be adjusted to match video timing
	
	      for (i = 0; i < event.captions.length; i++) {
	        caption = event.captions[i];
	        this.trigger('caption', caption);
	      } // Emit each id3 tag to the outside world
	      // Ideally, this would happen immediately on parsing the tag,
	      // but we need to ensure that video data is sent back first
	      // so that ID3 frame timing can be adjusted to match video timing
	
	
	      for (i = 0; i < event.metadata.length; i++) {
	        id3 = event.metadata[i];
	        this.trigger('id3Frame', id3);
	      }
	    } // Only emit `done` if all tracks have been flushed and emitted
	
	
	    if (this.emittedTracks >= this.numberOfTracks) {
	      this.trigger('done');
	      this.emittedTracks = 0;
	    }
	  };
	
	  _CoalesceStream.prototype.setRemux = function (val) {
	    this.remuxTracks = val;
	  };
	  /**
	   * A Stream that expects MP2T binary data as input and produces
	   * corresponding media segments, suitable for use with Media Source
	   * Extension (MSE) implementations that support the ISO BMFF byte
	   * stream format, like Chrome.
	   */
	
	
	  _Transmuxer = function Transmuxer(options) {
	    var self = this,
	        hasFlushed = true,
	        videoTrack,
	        audioTrack;
	
	    _Transmuxer.prototype.init.call(this);
	
	    options = options || {};
	    this.baseMediaDecodeTime = options.baseMediaDecodeTime || 0;
	    this.transmuxPipeline_ = {};
	
	    this.setupAacPipeline = function () {
	      var pipeline = {};
	      this.transmuxPipeline_ = pipeline;
	      pipeline.type = 'aac';
	      pipeline.metadataStream = new m2ts_1.MetadataStream(); // set up the parsing pipeline
	
	      pipeline.aacStream = new aac();
	      pipeline.audioTimestampRolloverStream = new m2ts_1.TimestampRolloverStream('audio');
	      pipeline.timedMetadataTimestampRolloverStream = new m2ts_1.TimestampRolloverStream('timed-metadata');
	      pipeline.adtsStream = new adts();
	      pipeline.coalesceStream = new _CoalesceStream(options, pipeline.metadataStream);
	      pipeline.headOfPipeline = pipeline.aacStream;
	      pipeline.aacStream.pipe(pipeline.audioTimestampRolloverStream).pipe(pipeline.adtsStream);
	      pipeline.aacStream.pipe(pipeline.timedMetadataTimestampRolloverStream).pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);
	      pipeline.metadataStream.on('timestamp', function (frame) {
	        pipeline.aacStream.setTimestamp(frame.timeStamp);
	      });
	      pipeline.aacStream.on('data', function (data) {
	        if (data.type !== 'timed-metadata' && data.type !== 'audio' || pipeline.audioSegmentStream) {
	          return;
	        }
	
	        audioTrack = audioTrack || {
	          timelineStartInfo: {
	            baseMediaDecodeTime: self.baseMediaDecodeTime
	          },
	          codec: 'adts',
	          type: 'audio'
	        }; // hook up the audio segment stream to the first track with aac data
	
	        pipeline.coalesceStream.numberOfTracks++;
	        pipeline.audioSegmentStream = new _AudioSegmentStream(audioTrack, options);
	        pipeline.audioSegmentStream.on('log', self.getLogTrigger_('audioSegmentStream'));
	        pipeline.audioSegmentStream.on('timingInfo', self.trigger.bind(self, 'audioTimingInfo')); // Set up the final part of the audio pipeline
	
	        pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream); // emit pmt info
	
	        self.trigger('trackinfo', {
	          hasAudio: !!audioTrack,
	          hasVideo: !!videoTrack
	        });
	      }); // Re-emit any data coming from the coalesce stream to the outside world
	
	      pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data')); // Let the consumer know we have finished flushing the entire pipeline
	
	      pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
	      addPipelineLogRetriggers(this, pipeline);
	    };
	
	    this.setupTsPipeline = function () {
	      var pipeline = {};
	      this.transmuxPipeline_ = pipeline;
	      pipeline.type = 'ts';
	      pipeline.metadataStream = new m2ts_1.MetadataStream(); // set up the parsing pipeline
	
	      pipeline.packetStream = new m2ts_1.TransportPacketStream();
	      pipeline.parseStream = new m2ts_1.TransportParseStream();
	      pipeline.elementaryStream = new m2ts_1.ElementaryStream();
	      pipeline.timestampRolloverStream = new m2ts_1.TimestampRolloverStream();
	      pipeline.adtsStream = new adts();
	      pipeline.h264Stream = new H264Stream();
	      pipeline.captionStream = new m2ts_1.CaptionStream(options);
	      pipeline.coalesceStream = new _CoalesceStream(options, pipeline.metadataStream);
	      pipeline.headOfPipeline = pipeline.packetStream; // disassemble MPEG2-TS packets into elementary streams
	
	      pipeline.packetStream.pipe(pipeline.parseStream).pipe(pipeline.elementaryStream).pipe(pipeline.timestampRolloverStream); // !!THIS ORDER IS IMPORTANT!!
	      // demux the streams
	
	      pipeline.timestampRolloverStream.pipe(pipeline.h264Stream);
	      pipeline.timestampRolloverStream.pipe(pipeline.adtsStream);
	      pipeline.timestampRolloverStream.pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream); // Hook up CEA-608/708 caption stream
	
	      pipeline.h264Stream.pipe(pipeline.captionStream).pipe(pipeline.coalesceStream);
	      pipeline.elementaryStream.on('data', function (data) {
	        var i;
	
	        if (data.type === 'metadata') {
	          i = data.tracks.length; // scan the tracks listed in the metadata
	
	          while (i--) {
	            if (!videoTrack && data.tracks[i].type === 'video') {
	              videoTrack = data.tracks[i];
	              videoTrack.timelineStartInfo.baseMediaDecodeTime = self.baseMediaDecodeTime;
	            } else if (!audioTrack && data.tracks[i].type === 'audio') {
	              audioTrack = data.tracks[i];
	              audioTrack.timelineStartInfo.baseMediaDecodeTime = self.baseMediaDecodeTime;
	            }
	          } // hook up the video segment stream to the first track with h264 data
	
	
	          if (videoTrack && !pipeline.videoSegmentStream) {
	            pipeline.coalesceStream.numberOfTracks++;
	            pipeline.videoSegmentStream = new _VideoSegmentStream(videoTrack, options);
	            pipeline.videoSegmentStream.on('log', self.getLogTrigger_('videoSegmentStream'));
	            pipeline.videoSegmentStream.on('timelineStartInfo', function (timelineStartInfo) {
	              // When video emits timelineStartInfo data after a flush, we forward that
	              // info to the AudioSegmentStream, if it exists, because video timeline
	              // data takes precedence.  Do not do this if keepOriginalTimestamps is set,
	              // because this is a particularly subtle form of timestamp alteration.
	              if (audioTrack && !options.keepOriginalTimestamps) {
	                audioTrack.timelineStartInfo = timelineStartInfo; // On the first segment we trim AAC frames that exist before the
	                // very earliest DTS we have seen in video because Chrome will
	                // interpret any video track with a baseMediaDecodeTime that is
	                // non-zero as a gap.
	
	                pipeline.audioSegmentStream.setEarliestDts(timelineStartInfo.dts - self.baseMediaDecodeTime);
	              }
	            });
	            pipeline.videoSegmentStream.on('processedGopsInfo', self.trigger.bind(self, 'gopInfo'));
	            pipeline.videoSegmentStream.on('segmentTimingInfo', self.trigger.bind(self, 'videoSegmentTimingInfo'));
	            pipeline.videoSegmentStream.on('baseMediaDecodeTime', function (baseMediaDecodeTime) {
	              if (audioTrack) {
	                pipeline.audioSegmentStream.setVideoBaseMediaDecodeTime(baseMediaDecodeTime);
	              }
	            });
	            pipeline.videoSegmentStream.on('timingInfo', self.trigger.bind(self, 'videoTimingInfo')); // Set up the final part of the video pipeline
	
	            pipeline.h264Stream.pipe(pipeline.videoSegmentStream).pipe(pipeline.coalesceStream);
	          }
	
	          if (audioTrack && !pipeline.audioSegmentStream) {
	            // hook up the audio segment stream to the first track with aac data
	            pipeline.coalesceStream.numberOfTracks++;
	            pipeline.audioSegmentStream = new _AudioSegmentStream(audioTrack, options);
	            pipeline.audioSegmentStream.on('log', self.getLogTrigger_('audioSegmentStream'));
	            pipeline.audioSegmentStream.on('timingInfo', self.trigger.bind(self, 'audioTimingInfo'));
	            pipeline.audioSegmentStream.on('segmentTimingInfo', self.trigger.bind(self, 'audioSegmentTimingInfo')); // Set up the final part of the audio pipeline
	
	            pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);
	          } // emit pmt info
	
	
	          self.trigger('trackinfo', {
	            hasAudio: !!audioTrack,
	            hasVideo: !!videoTrack
	          });
	        }
	      }); // Re-emit any data coming from the coalesce stream to the outside world
	
	      pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data'));
	      pipeline.coalesceStream.on('id3Frame', function (id3Frame) {
	        id3Frame.dispatchType = pipeline.metadataStream.dispatchType;
	        self.trigger('id3Frame', id3Frame);
	      });
	      pipeline.coalesceStream.on('caption', this.trigger.bind(this, 'caption')); // Let the consumer know we have finished flushing the entire pipeline
	
	      pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
	      addPipelineLogRetriggers(this, pipeline);
	    }; // hook up the segment streams once track metadata is delivered
	
	
	    this.setBaseMediaDecodeTime = function (baseMediaDecodeTime) {
	      var pipeline = this.transmuxPipeline_;
	
	      if (!options.keepOriginalTimestamps) {
	        this.baseMediaDecodeTime = baseMediaDecodeTime;
	      }
	
	      if (audioTrack) {
	        audioTrack.timelineStartInfo.dts = undefined;
	        audioTrack.timelineStartInfo.pts = undefined;
	        trackDecodeInfo.clearDtsInfo(audioTrack);
	
	        if (pipeline.audioTimestampRolloverStream) {
	          pipeline.audioTimestampRolloverStream.discontinuity();
	        }
	      }
	
	      if (videoTrack) {
	        if (pipeline.videoSegmentStream) {
	          pipeline.videoSegmentStream.gopCache_ = [];
	        }
	
	        videoTrack.timelineStartInfo.dts = undefined;
	        videoTrack.timelineStartInfo.pts = undefined;
	        trackDecodeInfo.clearDtsInfo(videoTrack);
	        pipeline.captionStream.reset();
	      }
	
	      if (pipeline.timestampRolloverStream) {
	        pipeline.timestampRolloverStream.discontinuity();
	      }
	    };
	
	    this.setAudioAppendStart = function (timestamp) {
	      if (audioTrack) {
	        this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(timestamp);
	      }
	    };
	
	    this.setRemux = function (val) {
	      var pipeline = this.transmuxPipeline_;
	      options.remux = val;
	
	      if (pipeline && pipeline.coalesceStream) {
	        pipeline.coalesceStream.setRemux(val);
	      }
	    };
	
	    this.alignGopsWith = function (gopsToAlignWith) {
	      if (videoTrack && this.transmuxPipeline_.videoSegmentStream) {
	        this.transmuxPipeline_.videoSegmentStream.alignGopsWith(gopsToAlignWith);
	      }
	    };
	
	    this.getLogTrigger_ = function (key) {
	      var self = this;
	      return function (event) {
	        event.stream = key;
	        self.trigger('log', event);
	      };
	    }; // feed incoming data to the front of the parsing pipeline
	
	
	    this.push = function (data) {
	      if (hasFlushed) {
	        var isAac = isLikelyAacData(data);
	
	        if (isAac && this.transmuxPipeline_.type !== 'aac') {
	          this.setupAacPipeline();
	        } else if (!isAac && this.transmuxPipeline_.type !== 'ts') {
	          this.setupTsPipeline();
	        }
	
	        hasFlushed = false;
	      }
	
	      this.transmuxPipeline_.headOfPipeline.push(data);
	    }; // flush any buffered data
	
	
	    this.flush = function () {
	      hasFlushed = true; // Start at the top of the pipeline and flush all pending work
	
	      this.transmuxPipeline_.headOfPipeline.flush();
	    };
	
	    this.endTimeline = function () {
	      this.transmuxPipeline_.headOfPipeline.endTimeline();
	    };
	
	    this.reset = function () {
	      if (this.transmuxPipeline_.headOfPipeline) {
	        this.transmuxPipeline_.headOfPipeline.reset();
	      }
	    }; // Caption data has to be reset when seeking outside buffered range
	
	
	    this.resetCaptions = function () {
	      if (this.transmuxPipeline_.captionStream) {
	        this.transmuxPipeline_.captionStream.reset();
	      }
	    };
	  };
	
	  _Transmuxer.prototype = new stream();
	  var transmuxer = {
	    Transmuxer: _Transmuxer,
	    VideoSegmentStream: _VideoSegmentStream,
	    AudioSegmentStream: _AudioSegmentStream,
	    AUDIO_PROPERTIES: audioProperties,
	    VIDEO_PROPERTIES: videoProperties,
	    // exported for testing
	    generateSegmentTimingInfo: generateSegmentTimingInfo
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var toUnsigned$3 = function toUnsigned(value) {
	    return value >>> 0;
	  };
	
	  var toHexString$1 = function toHexString(value) {
	    return ('00' + value.toString(16)).slice(-2);
	  };
	
	  var bin = {
	    toUnsigned: toUnsigned$3,
	    toHexString: toHexString$1
	  };
	
	  var parseType$1 = function parseType(buffer) {
	    var result = '';
	    result += String.fromCharCode(buffer[0]);
	    result += String.fromCharCode(buffer[1]);
	    result += String.fromCharCode(buffer[2]);
	    result += String.fromCharCode(buffer[3]);
	    return result;
	  };
	
	  var parseType_1 = parseType$1;
	  var toUnsigned$2 = bin.toUnsigned;
	
	  var findBox = function findBox(data, path) {
	    var results = [],
	        i,
	        size,
	        type,
	        end,
	        subresults;
	
	    if (!path.length) {
	      // short-circuit the search for empty paths
	      return null;
	    }
	
	    for (i = 0; i < data.byteLength;) {
	      size = toUnsigned$2(data[i] << 24 | data[i + 1] << 16 | data[i + 2] << 8 | data[i + 3]);
	      type = parseType_1(data.subarray(i + 4, i + 8));
	      end = size > 1 ? i + size : data.byteLength;
	
	      if (type === path[0]) {
	        if (path.length === 1) {
	          // this is the end of the path and we've found the box we were
	          // looking for
	          results.push(data.subarray(i + 8, end));
	        } else {
	          // recursively search for the next box along the path
	          subresults = findBox(data.subarray(i + 8, end), path.slice(1));
	
	          if (subresults.length) {
	            results = results.concat(subresults);
	          }
	        }
	      }
	
	      i = end;
	    } // we've finished searching all of data
	
	
	    return results;
	  };
	
	  var findBox_1 = findBox;
	  var toUnsigned$1 = bin.toUnsigned;
	  var getUint64$1 = numbers.getUint64;
	
	  var tfdt = function tfdt(data) {
	    var result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4))
	    };
	
	    if (result.version === 1) {
	      result.baseMediaDecodeTime = getUint64$1(data.subarray(4));
	    } else {
	      result.baseMediaDecodeTime = toUnsigned$1(data[4] << 24 | data[5] << 16 | data[6] << 8 | data[7]);
	    }
	
	    return result;
	  };
	
	  var parseTfdt = tfdt;
	
	  var parseSampleFlags = function parseSampleFlags(flags) {
	    return {
	      isLeading: (flags[0] & 0x0c) >>> 2,
	      dependsOn: flags[0] & 0x03,
	      isDependedOn: (flags[1] & 0xc0) >>> 6,
	      hasRedundancy: (flags[1] & 0x30) >>> 4,
	      paddingValue: (flags[1] & 0x0e) >>> 1,
	      isNonSyncSample: flags[1] & 0x01,
	      degradationPriority: flags[2] << 8 | flags[3]
	    };
	  };
	
	  var parseSampleFlags_1 = parseSampleFlags;
	
	  var trun = function trun(data) {
	    var result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      samples: []
	    },
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        // Flag interpretation
	    dataOffsetPresent = result.flags[2] & 0x01,
	        // compare with 2nd byte of 0x1
	    firstSampleFlagsPresent = result.flags[2] & 0x04,
	        // compare with 2nd byte of 0x4
	    sampleDurationPresent = result.flags[1] & 0x01,
	        // compare with 2nd byte of 0x100
	    sampleSizePresent = result.flags[1] & 0x02,
	        // compare with 2nd byte of 0x200
	    sampleFlagsPresent = result.flags[1] & 0x04,
	        // compare with 2nd byte of 0x400
	    sampleCompositionTimeOffsetPresent = result.flags[1] & 0x08,
	        // compare with 2nd byte of 0x800
	    sampleCount = view.getUint32(4),
	        offset = 8,
	        sample;
	
	    if (dataOffsetPresent) {
	      // 32 bit signed integer
	      result.dataOffset = view.getInt32(offset);
	      offset += 4;
	    } // Overrides the flags for the first sample only. The order of
	    // optional values will be: duration, size, compositionTimeOffset
	
	
	    if (firstSampleFlagsPresent && sampleCount) {
	      sample = {
	        flags: parseSampleFlags_1(data.subarray(offset, offset + 4))
	      };
	      offset += 4;
	
	      if (sampleDurationPresent) {
	        sample.duration = view.getUint32(offset);
	        offset += 4;
	      }
	
	      if (sampleSizePresent) {
	        sample.size = view.getUint32(offset);
	        offset += 4;
	      }
	
	      if (sampleCompositionTimeOffsetPresent) {
	        if (result.version === 1) {
	          sample.compositionTimeOffset = view.getInt32(offset);
	        } else {
	          sample.compositionTimeOffset = view.getUint32(offset);
	        }
	
	        offset += 4;
	      }
	
	      result.samples.push(sample);
	      sampleCount--;
	    }
	
	    while (sampleCount--) {
	      sample = {};
	
	      if (sampleDurationPresent) {
	        sample.duration = view.getUint32(offset);
	        offset += 4;
	      }
	
	      if (sampleSizePresent) {
	        sample.size = view.getUint32(offset);
	        offset += 4;
	      }
	
	      if (sampleFlagsPresent) {
	        sample.flags = parseSampleFlags_1(data.subarray(offset, offset + 4));
	        offset += 4;
	      }
	
	      if (sampleCompositionTimeOffsetPresent) {
	        if (result.version === 1) {
	          sample.compositionTimeOffset = view.getInt32(offset);
	        } else {
	          sample.compositionTimeOffset = view.getUint32(offset);
	        }
	
	        offset += 4;
	      }
	
	      result.samples.push(sample);
	    }
	
	    return result;
	  };
	
	  var parseTrun = trun;
	
	  var tfhd = function tfhd(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      trackId: view.getUint32(4)
	    },
	        baseDataOffsetPresent = result.flags[2] & 0x01,
	        sampleDescriptionIndexPresent = result.flags[2] & 0x02,
	        defaultSampleDurationPresent = result.flags[2] & 0x08,
	        defaultSampleSizePresent = result.flags[2] & 0x10,
	        defaultSampleFlagsPresent = result.flags[2] & 0x20,
	        durationIsEmpty = result.flags[0] & 0x010000,
	        defaultBaseIsMoof = result.flags[0] & 0x020000,
	        i;
	    i = 8;
	
	    if (baseDataOffsetPresent) {
	      i += 4; // truncate top 4 bytes
	      // FIXME: should we read the full 64 bits?
	
	      result.baseDataOffset = view.getUint32(12);
	      i += 4;
	    }
	
	    if (sampleDescriptionIndexPresent) {
	      result.sampleDescriptionIndex = view.getUint32(i);
	      i += 4;
	    }
	
	    if (defaultSampleDurationPresent) {
	      result.defaultSampleDuration = view.getUint32(i);
	      i += 4;
	    }
	
	    if (defaultSampleSizePresent) {
	      result.defaultSampleSize = view.getUint32(i);
	      i += 4;
	    }
	
	    if (defaultSampleFlagsPresent) {
	      result.defaultSampleFlags = view.getUint32(i);
	    }
	
	    if (durationIsEmpty) {
	      result.durationIsEmpty = true;
	    }
	
	    if (!baseDataOffsetPresent && defaultBaseIsMoof) {
	      result.baseDataOffsetIsMoof = true;
	    }
	
	    return result;
	  };
	
	  var parseTfhd = tfhd;
	  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	  var win;
	
	  if (typeof window !== "undefined") {
	    win = window;
	  } else if (typeof commonjsGlobal !== "undefined") {
	    win = commonjsGlobal;
	  } else if (typeof self !== "undefined") {
	    win = self;
	  } else {
	    win = {};
	  }
	
	  var window_1 = win;
	  var discardEmulationPreventionBytes = captionPacketParser.discardEmulationPreventionBytes;
	  var CaptionStream = captionStream.CaptionStream;
	  /**
	    * Maps an offset in the mdat to a sample based on the the size of the samples.
	    * Assumes that `parseSamples` has been called first.
	    *
	    * @param {Number} offset - The offset into the mdat
	    * @param {Object[]} samples - An array of samples, parsed using `parseSamples`
	    * @return {?Object} The matching sample, or null if no match was found.
	    *
	    * @see ISO-BMFF-12/2015, Section 8.8.8
	   **/
	
	  var mapToSample = function mapToSample(offset, samples) {
	    var approximateOffset = offset;
	
	    for (var i = 0; i < samples.length; i++) {
	      var sample = samples[i];
	
	      if (approximateOffset < sample.size) {
	        return sample;
	      }
	
	      approximateOffset -= sample.size;
	    }
	
	    return null;
	  };
	  /**
	    * Finds SEI nal units contained in a Media Data Box.
	    * Assumes that `parseSamples` has been called first.
	    *
	    * @param {Uint8Array} avcStream - The bytes of the mdat
	    * @param {Object[]} samples - The samples parsed out by `parseSamples`
	    * @param {Number} trackId - The trackId of this video track
	    * @return {Object[]} seiNals - the parsed SEI NALUs found.
	    *   The contents of the seiNal should match what is expected by
	    *   CaptionStream.push (nalUnitType, size, data, escapedRBSP, pts, dts)
	    *
	    * @see ISO-BMFF-12/2015, Section 8.1.1
	    * @see Rec. ITU-T H.264, 7.3.2.3.1
	   **/
	
	
	  var findSeiNals = function findSeiNals(avcStream, samples, trackId) {
	    var avcView = new DataView(avcStream.buffer, avcStream.byteOffset, avcStream.byteLength),
	        result = {
	      logs: [],
	      seiNals: []
	    },
	        seiNal,
	        i,
	        length,
	        lastMatchedSample;
	
	    for (i = 0; i + 4 < avcStream.length; i += length) {
	      length = avcView.getUint32(i);
	      i += 4; // Bail if this doesn't appear to be an H264 stream
	
	      if (length <= 0) {
	        continue;
	      }
	
	      switch (avcStream[i] & 0x1F) {
	        case 0x06:
	          var data = avcStream.subarray(i + 1, i + 1 + length);
	          var matchingSample = mapToSample(i, samples);
	          seiNal = {
	            nalUnitType: 'sei_rbsp',
	            size: length,
	            data: data,
	            escapedRBSP: discardEmulationPreventionBytes(data),
	            trackId: trackId
	          };
	
	          if (matchingSample) {
	            seiNal.pts = matchingSample.pts;
	            seiNal.dts = matchingSample.dts;
	            lastMatchedSample = matchingSample;
	          } else if (lastMatchedSample) {
	            // If a matching sample cannot be found, use the last
	            // sample's values as they should be as close as possible
	            seiNal.pts = lastMatchedSample.pts;
	            seiNal.dts = lastMatchedSample.dts;
	          } else {
	            result.logs.push({
	              level: 'warn',
	              message: 'We\'ve encountered a nal unit without data at ' + i + ' for trackId ' + trackId + '. See mux.js#223.'
	            });
	            break;
	          }
	
	          result.seiNals.push(seiNal);
	          break;
	      }
	    }
	
	    return result;
	  };
	  /**
	    * Parses sample information out of Track Run Boxes and calculates
	    * the absolute presentation and decode timestamps of each sample.
	    *
	    * @param {Array<Uint8Array>} truns - The Trun Run boxes to be parsed
	    * @param {Number|BigInt} baseMediaDecodeTime - base media decode time from tfdt
	        @see ISO-BMFF-12/2015, Section 8.8.12
	    * @param {Object} tfhd - The parsed Track Fragment Header
	    *   @see inspect.parseTfhd
	    * @return {Object[]} the parsed samples
	    *
	    * @see ISO-BMFF-12/2015, Section 8.8.8
	   **/
	
	
	  var parseSamples = function parseSamples(truns, baseMediaDecodeTime, tfhd) {
	    var currentDts = baseMediaDecodeTime;
	    var defaultSampleDuration = tfhd.defaultSampleDuration || 0;
	    var defaultSampleSize = tfhd.defaultSampleSize || 0;
	    var trackId = tfhd.trackId;
	    var allSamples = [];
	    truns.forEach(function (trun) {
	      // Note: We currently do not parse the sample table as well
	      // as the trun. It's possible some sources will require this.
	      // moov > trak > mdia > minf > stbl
	      var trackRun = parseTrun(trun);
	      var samples = trackRun.samples;
	      samples.forEach(function (sample) {
	        if (sample.duration === undefined) {
	          sample.duration = defaultSampleDuration;
	        }
	
	        if (sample.size === undefined) {
	          sample.size = defaultSampleSize;
	        }
	
	        sample.trackId = trackId;
	        sample.dts = currentDts;
	
	        if (sample.compositionTimeOffset === undefined) {
	          sample.compositionTimeOffset = 0;
	        }
	
	        if (typeof currentDts === 'bigint') {
	          sample.pts = currentDts + window_1.BigInt(sample.compositionTimeOffset);
	          currentDts += window_1.BigInt(sample.duration);
	        } else {
	          sample.pts = currentDts + sample.compositionTimeOffset;
	          currentDts += sample.duration;
	        }
	      });
	      allSamples = allSamples.concat(samples);
	    });
	    return allSamples;
	  };
	  /**
	    * Parses out caption nals from an FMP4 segment's video tracks.
	    *
	    * @param {Uint8Array} segment - The bytes of a single segment
	    * @param {Number} videoTrackId - The trackId of a video track in the segment
	    * @return {Object.<Number, Object[]>} A mapping of video trackId to
	    *   a list of seiNals found in that track
	   **/
	
	
	  var parseCaptionNals = function parseCaptionNals(segment, videoTrackId) {
	    // To get the samples
	    var trafs = findBox_1(segment, ['moof', 'traf']); // To get SEI NAL units
	
	    var mdats = findBox_1(segment, ['mdat']);
	    var captionNals = {};
	    var mdatTrafPairs = []; // Pair up each traf with a mdat as moofs and mdats are in pairs
	
	    mdats.forEach(function (mdat, index) {
	      var matchingTraf = trafs[index];
	      mdatTrafPairs.push({
	        mdat: mdat,
	        traf: matchingTraf
	      });
	    });
	    mdatTrafPairs.forEach(function (pair) {
	      var mdat = pair.mdat;
	      var traf = pair.traf;
	      var tfhd = findBox_1(traf, ['tfhd']); // Exactly 1 tfhd per traf
	
	      var headerInfo = parseTfhd(tfhd[0]);
	      var trackId = headerInfo.trackId;
	      var tfdt = findBox_1(traf, ['tfdt']); // Either 0 or 1 tfdt per traf
	
	      var baseMediaDecodeTime = tfdt.length > 0 ? parseTfdt(tfdt[0]).baseMediaDecodeTime : 0;
	      var truns = findBox_1(traf, ['trun']);
	      var samples;
	      var result; // Only parse video data for the chosen video track
	
	      if (videoTrackId === trackId && truns.length > 0) {
	        samples = parseSamples(truns, baseMediaDecodeTime, headerInfo);
	        result = findSeiNals(mdat, samples, trackId);
	
	        if (!captionNals[trackId]) {
	          captionNals[trackId] = {
	            seiNals: [],
	            logs: []
	          };
	        }
	
	        captionNals[trackId].seiNals = captionNals[trackId].seiNals.concat(result.seiNals);
	        captionNals[trackId].logs = captionNals[trackId].logs.concat(result.logs);
	      }
	    });
	    return captionNals;
	  };
	  /**
	    * Parses out inband captions from an MP4 container and returns
	    * caption objects that can be used by WebVTT and the TextTrack API.
	    * @see https://developer.mozilla.org/en-US/docs/Web/API/VTTCue
	    * @see https://developer.mozilla.org/en-US/docs/Web/API/TextTrack
	    * Assumes that `probe.getVideoTrackIds` and `probe.timescale` have been called first
	    *
	    * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
	    * @param {Number} trackId - The id of the video track to parse
	    * @param {Number} timescale - The timescale for the video track from the init segment
	    *
	    * @return {?Object[]} parsedCaptions - A list of captions or null if no video tracks
	    * @return {Number} parsedCaptions[].startTime - The time to show the caption in seconds
	    * @return {Number} parsedCaptions[].endTime - The time to stop showing the caption in seconds
	    * @return {String} parsedCaptions[].text - The visible content of the caption
	   **/
	
	
	  var parseEmbeddedCaptions = function parseEmbeddedCaptions(segment, trackId, timescale) {
	    var captionNals; // the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
	
	    if (trackId === null) {
	      return null;
	    }
	
	    captionNals = parseCaptionNals(segment, trackId);
	    var trackNals = captionNals[trackId] || {};
	    return {
	      seiNals: trackNals.seiNals,
	      logs: trackNals.logs,
	      timescale: timescale
	    };
	  };
	  /**
	    * Converts SEI NALUs into captions that can be used by video.js
	   **/
	
	
	  var CaptionParser = function CaptionParser() {
	    var isInitialized = false;
	    var captionStream; // Stores segments seen before trackId and timescale are set
	
	    var segmentCache; // Stores video track ID of the track being parsed
	
	    var trackId; // Stores the timescale of the track being parsed
	
	    var timescale; // Stores captions parsed so far
	
	    var parsedCaptions; // Stores whether we are receiving partial data or not
	
	    var parsingPartial;
	    /**
	      * A method to indicate whether a CaptionParser has been initalized
	      * @returns {Boolean}
	     **/
	
	    this.isInitialized = function () {
	      return isInitialized;
	    };
	    /**
	      * Initializes the underlying CaptionStream, SEI NAL parsing
	      * and management, and caption collection
	     **/
	
	
	    this.init = function (options) {
	      captionStream = new CaptionStream();
	      isInitialized = true;
	      parsingPartial = options ? options.isPartial : false; // Collect dispatched captions
	
	      captionStream.on('data', function (event) {
	        // Convert to seconds in the source's timescale
	        event.startTime = event.startPts / timescale;
	        event.endTime = event.endPts / timescale;
	        parsedCaptions.captions.push(event);
	        parsedCaptions.captionStreams[event.stream] = true;
	      });
	      captionStream.on('log', function (log) {
	        parsedCaptions.logs.push(log);
	      });
	    };
	    /**
	      * Determines if a new video track will be selected
	      * or if the timescale changed
	      * @return {Boolean}
	     **/
	
	
	    this.isNewInit = function (videoTrackIds, timescales) {
	      if (videoTrackIds && videoTrackIds.length === 0 || timescales && typeof timescales === 'object' && Object.keys(timescales).length === 0) {
	        return false;
	      }
	
	      return trackId !== videoTrackIds[0] || timescale !== timescales[trackId];
	    };
	    /**
	      * Parses out SEI captions and interacts with underlying
	      * CaptionStream to return dispatched captions
	      *
	      * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
	      * @param {Number[]} videoTrackIds - A list of video tracks found in the init segment
	      * @param {Object.<Number, Number>} timescales - The timescales found in the init segment
	      * @see parseEmbeddedCaptions
	      * @see m2ts/caption-stream.js
	     **/
	
	
	    this.parse = function (segment, videoTrackIds, timescales) {
	      var parsedData;
	
	      if (!this.isInitialized()) {
	        return null; // This is not likely to be a video segment
	      } else if (!videoTrackIds || !timescales) {
	        return null;
	      } else if (this.isNewInit(videoTrackIds, timescales)) {
	        // Use the first video track only as there is no
	        // mechanism to switch to other video tracks
	        trackId = videoTrackIds[0];
	        timescale = timescales[trackId]; // If an init segment has not been seen yet, hold onto segment
	        // data until we have one.
	        // the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
	      } else if (trackId === null || !timescale) {
	        segmentCache.push(segment);
	        return null;
	      } // Now that a timescale and trackId is set, parse cached segments
	
	
	      while (segmentCache.length > 0) {
	        var cachedSegment = segmentCache.shift();
	        this.parse(cachedSegment, videoTrackIds, timescales);
	      }
	
	      parsedData = parseEmbeddedCaptions(segment, trackId, timescale);
	
	      if (parsedData && parsedData.logs) {
	        parsedCaptions.logs = parsedCaptions.logs.concat(parsedData.logs);
	      }
	
	      if (parsedData === null || !parsedData.seiNals) {
	        if (parsedCaptions.logs.length) {
	          return {
	            logs: parsedCaptions.logs,
	            captions: [],
	            captionStreams: []
	          };
	        }
	
	        return null;
	      }
	
	      this.pushNals(parsedData.seiNals); // Force the parsed captions to be dispatched
	
	      this.flushStream();
	      return parsedCaptions;
	    };
	    /**
	      * Pushes SEI NALUs onto CaptionStream
	      * @param {Object[]} nals - A list of SEI nals parsed using `parseCaptionNals`
	      * Assumes that `parseCaptionNals` has been called first
	      * @see m2ts/caption-stream.js
	      **/
	
	
	    this.pushNals = function (nals) {
	      if (!this.isInitialized() || !nals || nals.length === 0) {
	        return null;
	      }
	
	      nals.forEach(function (nal) {
	        captionStream.push(nal);
	      });
	    };
	    /**
	      * Flushes underlying CaptionStream to dispatch processed, displayable captions
	      * @see m2ts/caption-stream.js
	     **/
	
	
	    this.flushStream = function () {
	      if (!this.isInitialized()) {
	        return null;
	      }
	
	      if (!parsingPartial) {
	        captionStream.flush();
	      } else {
	        captionStream.partialFlush();
	      }
	    };
	    /**
	      * Reset caption buckets for new data
	     **/
	
	
	    this.clearParsedCaptions = function () {
	      parsedCaptions.captions = [];
	      parsedCaptions.captionStreams = {};
	      parsedCaptions.logs = [];
	    };
	    /**
	      * Resets underlying CaptionStream
	      * @see m2ts/caption-stream.js
	     **/
	
	
	    this.resetCaptionStream = function () {
	      if (!this.isInitialized()) {
	        return null;
	      }
	
	      captionStream.reset();
	    };
	    /**
	      * Convenience method to clear all captions flushed from the
	      * CaptionStream and still being parsed
	      * @see m2ts/caption-stream.js
	     **/
	
	
	    this.clearAllCaptions = function () {
	      this.clearParsedCaptions();
	      this.resetCaptionStream();
	    };
	    /**
	      * Reset caption parser
	     **/
	
	
	    this.reset = function () {
	      segmentCache = [];
	      trackId = null;
	      timescale = null;
	
	      if (!parsedCaptions) {
	        parsedCaptions = {
	          captions: [],
	          // CC1, CC2, CC3, CC4
	          captionStreams: {},
	          logs: []
	        };
	      } else {
	        this.clearParsedCaptions();
	      }
	
	      this.resetCaptionStream();
	    };
	
	    this.reset();
	  };
	
	  var captionParser = CaptionParser;
	  var toUnsigned = bin.toUnsigned;
	  var toHexString = bin.toHexString;
	  var getUint64 = numbers.getUint64;
	  var timescale, startTime, compositionStartTime, getVideoTrackIds, getTracks, getTimescaleFromMediaHeader;
	  /**
	   * Parses an MP4 initialization segment and extracts the timescale
	   * values for any declared tracks. Timescale values indicate the
	   * number of clock ticks per second to assume for time-based values
	   * elsewhere in the MP4.
	   *
	   * To determine the start time of an MP4, you need two pieces of
	   * information: the timescale unit and the earliest base media decode
	   * time. Multiple timescales can be specified within an MP4 but the
	   * base media decode time is always expressed in the timescale from
	   * the media header box for the track:
	   * ```
	   * moov > trak > mdia > mdhd.timescale
	   * ```
	   * @param init {Uint8Array} the bytes of the init segment
	   * @return {object} a hash of track ids to timescale values or null if
	   * the init segment is malformed.
	   */
	
	  timescale = function timescale(init) {
	    var result = {},
	        traks = findBox_1(init, ['moov', 'trak']); // mdhd timescale
	
	    return traks.reduce(function (result, trak) {
	      var tkhd, version, index, id, mdhd;
	      tkhd = findBox_1(trak, ['tkhd'])[0];
	
	      if (!tkhd) {
	        return null;
	      }
	
	      version = tkhd[0];
	      index = version === 0 ? 12 : 20;
	      id = toUnsigned(tkhd[index] << 24 | tkhd[index + 1] << 16 | tkhd[index + 2] << 8 | tkhd[index + 3]);
	      mdhd = findBox_1(trak, ['mdia', 'mdhd'])[0];
	
	      if (!mdhd) {
	        return null;
	      }
	
	      version = mdhd[0];
	      index = version === 0 ? 12 : 20;
	      result[id] = toUnsigned(mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]);
	      return result;
	    }, result);
	  };
	  /**
	   * Determine the base media decode start time, in seconds, for an MP4
	   * fragment. If multiple fragments are specified, the earliest time is
	   * returned.
	   *
	   * The base media decode time can be parsed from track fragment
	   * metadata:
	   * ```
	   * moof > traf > tfdt.baseMediaDecodeTime
	   * ```
	   * It requires the timescale value from the mdhd to interpret.
	   *
	   * @param timescale {object} a hash of track ids to timescale values.
	   * @return {number} the earliest base media decode start time for the
	   * fragment, in seconds
	   */
	
	
	  startTime = function startTime(timescale, fragment) {
	    var trafs; // we need info from two childrend of each track fragment box
	
	    trafs = findBox_1(fragment, ['moof', 'traf']); // determine the start times for each track
	
	    var lowestTime = trafs.reduce(function (acc, traf) {
	      var tfhd = findBox_1(traf, ['tfhd'])[0]; // get the track id from the tfhd
	
	      var id = toUnsigned(tfhd[4] << 24 | tfhd[5] << 16 | tfhd[6] << 8 | tfhd[7]); // assume a 90kHz clock if no timescale was specified
	
	      var scale = timescale[id] || 90e3; // get the base media decode time from the tfdt
	
	      var tfdt = findBox_1(traf, ['tfdt'])[0];
	      var dv = new DataView(tfdt.buffer, tfdt.byteOffset, tfdt.byteLength);
	      var baseTime; // version 1 is 64 bit
	
	      if (tfdt[0] === 1) {
	        baseTime = getUint64(tfdt.subarray(4, 12));
	      } else {
	        baseTime = dv.getUint32(4);
	      } // convert base time to seconds if it is a valid number.
	
	
	      var seconds;
	
	      if (typeof baseTime === 'bigint') {
	        seconds = baseTime / window_1.BigInt(scale);
	      } else if (typeof baseTime === 'number' && !isNaN(baseTime)) {
	        seconds = baseTime / scale;
	      }
	
	      if (seconds < Number.MAX_SAFE_INTEGER) {
	        seconds = Number(seconds);
	      }
	
	      if (seconds < acc) {
	        acc = seconds;
	      }
	
	      return acc;
	    }, Infinity);
	    return typeof lowestTime === 'bigint' || isFinite(lowestTime) ? lowestTime : 0;
	  };
	  /**
	   * Determine the composition start, in seconds, for an MP4
	   * fragment.
	   *
	   * The composition start time of a fragment can be calculated using the base
	   * media decode time, composition time offset, and timescale, as follows:
	   *
	   * compositionStartTime = (baseMediaDecodeTime + compositionTimeOffset) / timescale
	   *
	   * All of the aforementioned information is contained within a media fragment's
	   * `traf` box, except for timescale info, which comes from the initialization
	   * segment, so a track id (also contained within a `traf`) is also necessary to
	   * associate it with a timescale
	   *
	   *
	   * @param timescales {object} - a hash of track ids to timescale values.
	   * @param fragment {Unit8Array} - the bytes of a media segment
	   * @return {number} the composition start time for the fragment, in seconds
	   **/
	
	
	  compositionStartTime = function compositionStartTime(timescales, fragment) {
	    var trafBoxes = findBox_1(fragment, ['moof', 'traf']);
	    var baseMediaDecodeTime = 0;
	    var compositionTimeOffset = 0;
	    var trackId;
	
	    if (trafBoxes && trafBoxes.length) {
	      // The spec states that track run samples contained within a `traf` box are contiguous, but
	      // it does not explicitly state whether the `traf` boxes themselves are contiguous.
	      // We will assume that they are, so we only need the first to calculate start time.
	      var tfhd = findBox_1(trafBoxes[0], ['tfhd'])[0];
	      var trun = findBox_1(trafBoxes[0], ['trun'])[0];
	      var tfdt = findBox_1(trafBoxes[0], ['tfdt'])[0];
	
	      if (tfhd) {
	        var parsedTfhd = parseTfhd(tfhd);
	        trackId = parsedTfhd.trackId;
	      }
	
	      if (tfdt) {
	        var parsedTfdt = parseTfdt(tfdt);
	        baseMediaDecodeTime = parsedTfdt.baseMediaDecodeTime;
	      }
	
	      if (trun) {
	        var parsedTrun = parseTrun(trun);
	
	        if (parsedTrun.samples && parsedTrun.samples.length) {
	          compositionTimeOffset = parsedTrun.samples[0].compositionTimeOffset || 0;
	        }
	      }
	    } // Get timescale for this specific track. Assume a 90kHz clock if no timescale was
	    // specified.
	
	
	    var timescale = timescales[trackId] || 90e3; // return the composition start time, in seconds
	
	    if (typeof baseMediaDecodeTime === 'bigint') {
	      compositionTimeOffset = window_1.BigInt(compositionTimeOffset);
	      timescale = window_1.BigInt(timescale);
	    }
	
	    var result = (baseMediaDecodeTime + compositionTimeOffset) / timescale;
	
	    if (typeof result === 'bigint' && result < Number.MAX_SAFE_INTEGER) {
	      result = Number(result);
	    }
	
	    return result;
	  };
	  /**
	    * Find the trackIds of the video tracks in this source.
	    * Found by parsing the Handler Reference and Track Header Boxes:
	    *   moov > trak > mdia > hdlr
	    *   moov > trak > tkhd
	    *
	    * @param {Uint8Array} init - The bytes of the init segment for this source
	    * @return {Number[]} A list of trackIds
	    *
	    * @see ISO-BMFF-12/2015, Section 8.4.3
	   **/
	
	
	  getVideoTrackIds = function getVideoTrackIds(init) {
	    var traks = findBox_1(init, ['moov', 'trak']);
	    var videoTrackIds = [];
	    traks.forEach(function (trak) {
	      var hdlrs = findBox_1(trak, ['mdia', 'hdlr']);
	      var tkhds = findBox_1(trak, ['tkhd']);
	      hdlrs.forEach(function (hdlr, index) {
	        var handlerType = parseType_1(hdlr.subarray(8, 12));
	        var tkhd = tkhds[index];
	        var view;
	        var version;
	        var trackId;
	
	        if (handlerType === 'vide') {
	          view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
	          version = view.getUint8(0);
	          trackId = version === 0 ? view.getUint32(12) : view.getUint32(20);
	          videoTrackIds.push(trackId);
	        }
	      });
	    });
	    return videoTrackIds;
	  };
	
	  getTimescaleFromMediaHeader = function getTimescaleFromMediaHeader(mdhd) {
	    // mdhd is a FullBox, meaning it will have its own version as the first byte
	    var version = mdhd[0];
	    var index = version === 0 ? 12 : 20;
	    return toUnsigned(mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]);
	  };
	  /**
	   * Get all the video, audio, and hint tracks from a non fragmented
	   * mp4 segment
	   */
	
	
	  getTracks = function getTracks(init) {
	    var traks = findBox_1(init, ['moov', 'trak']);
	    var tracks = [];
	    traks.forEach(function (trak) {
	      var track = {};
	      var tkhd = findBox_1(trak, ['tkhd'])[0];
	      var view, tkhdVersion; // id
	
	      if (tkhd) {
	        view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
	        tkhdVersion = view.getUint8(0);
	        track.id = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
	      }
	
	      var hdlr = findBox_1(trak, ['mdia', 'hdlr'])[0]; // type
	
	      if (hdlr) {
	        var type = parseType_1(hdlr.subarray(8, 12));
	
	        if (type === 'vide') {
	          track.type = 'video';
	        } else if (type === 'soun') {
	          track.type = 'audio';
	        } else {
	          track.type = type;
	        }
	      } // codec
	
	
	      var stsd = findBox_1(trak, ['mdia', 'minf', 'stbl', 'stsd'])[0];
	
	      if (stsd) {
	        var sampleDescriptions = stsd.subarray(8); // gives the codec type string
	
	        track.codec = parseType_1(sampleDescriptions.subarray(4, 8));
	        var codecBox = findBox_1(sampleDescriptions, [track.codec])[0];
	        var codecConfig, codecConfigType;
	
	        if (codecBox) {
	          // https://tools.ietf.org/html/rfc6381#section-3.3
	          if (/^[asm]vc[1-9]$/i.test(track.codec)) {
	            // we don't need anything but the "config" parameter of the
	            // avc1 codecBox
	            codecConfig = codecBox.subarray(78);
	            codecConfigType = parseType_1(codecConfig.subarray(4, 8));
	
	            if (codecConfigType === 'avcC' && codecConfig.length > 11) {
	              track.codec += '.'; // left padded with zeroes for single digit hex
	              // profile idc
	
	              track.codec += toHexString(codecConfig[9]); // the byte containing the constraint_set flags
	
	              track.codec += toHexString(codecConfig[10]); // level idc
	
	              track.codec += toHexString(codecConfig[11]);
	            } else {
	              // TODO: show a warning that we couldn't parse the codec
	              // and are using the default
	              track.codec = 'avc1.4d400d';
	            }
	          } else if (/^mp4[a,v]$/i.test(track.codec)) {
	            // we do not need anything but the streamDescriptor of the mp4a codecBox
	            codecConfig = codecBox.subarray(28);
	            codecConfigType = parseType_1(codecConfig.subarray(4, 8));
	
	            if (codecConfigType === 'esds' && codecConfig.length > 20 && codecConfig[19] !== 0) {
	              track.codec += '.' + toHexString(codecConfig[19]); // this value is only a single digit
	
	              track.codec += '.' + toHexString(codecConfig[20] >>> 2 & 0x3f).replace(/^0/, '');
	            } else {
	              // TODO: show a warning that we couldn't parse the codec
	              // and are using the default
	              track.codec = 'mp4a.40.2';
	            }
	          } else {
	            // flac, opus, etc
	            track.codec = track.codec.toLowerCase();
	          }
	        }
	      }
	
	      var mdhd = findBox_1(trak, ['mdia', 'mdhd'])[0];
	
	      if (mdhd) {
	        track.timescale = getTimescaleFromMediaHeader(mdhd);
	      }
	
	      tracks.push(track);
	    });
	    return tracks;
	  };
	
	  var probe$2 = {
	    // export mp4 inspector's findBox and parseType for backwards compatibility
	    findBox: findBox_1,
	    parseType: parseType_1,
	    timescale: timescale,
	    startTime: startTime,
	    compositionStartTime: compositionStartTime,
	    videoTrackIds: getVideoTrackIds,
	    tracks: getTracks,
	    getTimescaleFromMediaHeader: getTimescaleFromMediaHeader
	  };
	
	  var parsePid = function parsePid(packet) {
	    var pid = packet[1] & 0x1f;
	    pid <<= 8;
	    pid |= packet[2];
	    return pid;
	  };
	
	  var parsePayloadUnitStartIndicator = function parsePayloadUnitStartIndicator(packet) {
	    return !!(packet[1] & 0x40);
	  };
	
	  var parseAdaptionField = function parseAdaptionField(packet) {
	    var offset = 0; // if an adaption field is present, its length is specified by the
	    // fifth byte of the TS packet header. The adaptation field is
	    // used to add stuffing to PES packets that don't fill a complete
	    // TS packet, and to specify some forms of timing and control data
	    // that we do not currently use.
	
	    if ((packet[3] & 0x30) >>> 4 > 0x01) {
	      offset += packet[4] + 1;
	    }
	
	    return offset;
	  };
	
	  var parseType = function parseType(packet, pmtPid) {
	    var pid = parsePid(packet);
	
	    if (pid === 0) {
	      return 'pat';
	    } else if (pid === pmtPid) {
	      return 'pmt';
	    } else if (pmtPid) {
	      return 'pes';
	    }
	
	    return null;
	  };
	
	  var parsePat = function parsePat(packet) {
	    var pusi = parsePayloadUnitStartIndicator(packet);
	    var offset = 4 + parseAdaptionField(packet);
	
	    if (pusi) {
	      offset += packet[offset] + 1;
	    }
	
	    return (packet[offset + 10] & 0x1f) << 8 | packet[offset + 11];
	  };
	
	  var parsePmt = function parsePmt(packet) {
	    var programMapTable = {};
	    var pusi = parsePayloadUnitStartIndicator(packet);
	    var payloadOffset = 4 + parseAdaptionField(packet);
	
	    if (pusi) {
	      payloadOffset += packet[payloadOffset] + 1;
	    } // PMTs can be sent ahead of the time when they should actually
	    // take effect. We don't believe this should ever be the case
	    // for HLS but we'll ignore "forward" PMT declarations if we see
	    // them. Future PMT declarations have the current_next_indicator
	    // set to zero.
	
	
	    if (!(packet[payloadOffset + 5] & 0x01)) {
	      return;
	    }
	
	    var sectionLength, tableEnd, programInfoLength; // the mapping table ends at the end of the current section
	
	    sectionLength = (packet[payloadOffset + 1] & 0x0f) << 8 | packet[payloadOffset + 2];
	    tableEnd = 3 + sectionLength - 4; // to determine where the table is, we have to figure out how
	    // long the program info descriptors are
	
	    programInfoLength = (packet[payloadOffset + 10] & 0x0f) << 8 | packet[payloadOffset + 11]; // advance the offset to the first entry in the mapping table
	
	    var offset = 12 + programInfoLength;
	
	    while (offset < tableEnd) {
	      var i = payloadOffset + offset; // add an entry that maps the elementary_pid to the stream_type
	
	      programMapTable[(packet[i + 1] & 0x1F) << 8 | packet[i + 2]] = packet[i]; // move to the next table entry
	      // skip past the elementary stream descriptors, if present
	
	      offset += ((packet[i + 3] & 0x0F) << 8 | packet[i + 4]) + 5;
	    }
	
	    return programMapTable;
	  };
	
	  var parsePesType = function parsePesType(packet, programMapTable) {
	    var pid = parsePid(packet);
	    var type = programMapTable[pid];
	
	    switch (type) {
	      case streamTypes.H264_STREAM_TYPE:
	        return 'video';
	
	      case streamTypes.ADTS_STREAM_TYPE:
	        return 'audio';
	
	      case streamTypes.METADATA_STREAM_TYPE:
	        return 'timed-metadata';
	
	      default:
	        return null;
	    }
	  };
	
	  var parsePesTime = function parsePesTime(packet) {
	    var pusi = parsePayloadUnitStartIndicator(packet);
	
	    if (!pusi) {
	      return null;
	    }
	
	    var offset = 4 + parseAdaptionField(packet);
	
	    if (offset >= packet.byteLength) {
	      // From the H 222.0 MPEG-TS spec
	      // "For transport stream packets carrying PES packets, stuffing is needed when there
	      //  is insufficient PES packet data to completely fill the transport stream packet
	      //  payload bytes. Stuffing is accomplished by defining an adaptation field longer than
	      //  the sum of the lengths of the data elements in it, so that the payload bytes
	      //  remaining after the adaptation field exactly accommodates the available PES packet
	      //  data."
	      //
	      // If the offset is >= the length of the packet, then the packet contains no data
	      // and instead is just adaption field stuffing bytes
	      return null;
	    }
	
	    var pes = null;
	    var ptsDtsFlags; // PES packets may be annotated with a PTS value, or a PTS value
	    // and a DTS value. Determine what combination of values is
	    // available to work with.
	
	    ptsDtsFlags = packet[offset + 7]; // PTS and DTS are normally stored as a 33-bit number.  Javascript
	    // performs all bitwise operations on 32-bit integers but javascript
	    // supports a much greater range (52-bits) of integer using standard
	    // mathematical operations.
	    // We construct a 31-bit value using bitwise operators over the 31
	    // most significant bits and then multiply by 4 (equal to a left-shift
	    // of 2) before we add the final 2 least significant bits of the
	    // timestamp (equal to an OR.)
	
	    if (ptsDtsFlags & 0xC0) {
	      pes = {}; // the PTS and DTS are not written out directly. For information
	      // on how they are encoded, see
	      // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
	
	      pes.pts = (packet[offset + 9] & 0x0E) << 27 | (packet[offset + 10] & 0xFF) << 20 | (packet[offset + 11] & 0xFE) << 12 | (packet[offset + 12] & 0xFF) << 5 | (packet[offset + 13] & 0xFE) >>> 3;
	      pes.pts *= 4; // Left shift by 2
	
	      pes.pts += (packet[offset + 13] & 0x06) >>> 1; // OR by the two LSBs
	
	      pes.dts = pes.pts;
	
	      if (ptsDtsFlags & 0x40) {
	        pes.dts = (packet[offset + 14] & 0x0E) << 27 | (packet[offset + 15] & 0xFF) << 20 | (packet[offset + 16] & 0xFE) << 12 | (packet[offset + 17] & 0xFF) << 5 | (packet[offset + 18] & 0xFE) >>> 3;
	        pes.dts *= 4; // Left shift by 2
	
	        pes.dts += (packet[offset + 18] & 0x06) >>> 1; // OR by the two LSBs
	      }
	    }
	
	    return pes;
	  };
	
	  var parseNalUnitType = function parseNalUnitType(type) {
	    switch (type) {
	      case 0x05:
	        return 'slice_layer_without_partitioning_rbsp_idr';
	
	      case 0x06:
	        return 'sei_rbsp';
	
	      case 0x07:
	        return 'seq_parameter_set_rbsp';
	
	      case 0x08:
	        return 'pic_parameter_set_rbsp';
	
	      case 0x09:
	        return 'access_unit_delimiter_rbsp';
	
	      default:
	        return null;
	    }
	  };
	
	  var videoPacketContainsKeyFrame = function videoPacketContainsKeyFrame(packet) {
	    var offset = 4 + parseAdaptionField(packet);
	    var frameBuffer = packet.subarray(offset);
	    var frameI = 0;
	    var frameSyncPoint = 0;
	    var foundKeyFrame = false;
	    var nalType; // advance the sync point to a NAL start, if necessary
	
	    for (; frameSyncPoint < frameBuffer.byteLength - 3; frameSyncPoint++) {
	      if (frameBuffer[frameSyncPoint + 2] === 1) {
	        // the sync point is properly aligned
	        frameI = frameSyncPoint + 5;
	        break;
	      }
	    }
	
	    while (frameI < frameBuffer.byteLength) {
	      // look at the current byte to determine if we've hit the end of
	      // a NAL unit boundary
	      switch (frameBuffer[frameI]) {
	        case 0:
	          // skip past non-sync sequences
	          if (frameBuffer[frameI - 1] !== 0) {
	            frameI += 2;
	            break;
	          } else if (frameBuffer[frameI - 2] !== 0) {
	            frameI++;
	            break;
	          }
	
	          if (frameSyncPoint + 3 !== frameI - 2) {
	            nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	
	            if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	              foundKeyFrame = true;
	            }
	          } // drop trailing zeroes
	
	
	          do {
	            frameI++;
	          } while (frameBuffer[frameI] !== 1 && frameI < frameBuffer.length);
	
	          frameSyncPoint = frameI - 2;
	          frameI += 3;
	          break;
	
	        case 1:
	          // skip past non-sync sequences
	          if (frameBuffer[frameI - 1] !== 0 || frameBuffer[frameI - 2] !== 0) {
	            frameI += 3;
	            break;
	          }
	
	          nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	
	          if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	            foundKeyFrame = true;
	          }
	
	          frameSyncPoint = frameI - 2;
	          frameI += 3;
	          break;
	
	        default:
	          // the current byte isn't a one or zero, so it cannot be part
	          // of a sync sequence
	          frameI += 3;
	          break;
	      }
	    }
	
	    frameBuffer = frameBuffer.subarray(frameSyncPoint);
	    frameI -= frameSyncPoint;
	    frameSyncPoint = 0; // parse the final nal
	
	    if (frameBuffer && frameBuffer.byteLength > 3) {
	      nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	
	      if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	        foundKeyFrame = true;
	      }
	    }
	
	    return foundKeyFrame;
	  };
	
	  var probe$1 = {
	    parseType: parseType,
	    parsePat: parsePat,
	    parsePmt: parsePmt,
	    parsePayloadUnitStartIndicator: parsePayloadUnitStartIndicator,
	    parsePesType: parsePesType,
	    parsePesTime: parsePesTime,
	    videoPacketContainsKeyFrame: videoPacketContainsKeyFrame
	  };
	  var handleRollover = timestampRolloverStream.handleRollover;
	  var probe = {};
	  probe.ts = probe$1;
	  probe.aac = utils;
	  var ONE_SECOND_IN_TS = clock.ONE_SECOND_IN_TS;
	  var MP2T_PACKET_LENGTH = 188,
	      // bytes
	  SYNC_BYTE = 0x47;
	  /**
	   * walks through segment data looking for pat and pmt packets to parse out
	   * program map table information
	   */
	
	  var parsePsi_ = function parsePsi_(bytes, pmt) {
	    var startIndex = 0,
	        endIndex = MP2T_PACKET_LENGTH,
	        packet,
	        type;
	
	    while (endIndex < bytes.byteLength) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pat':
	            pmt.pid = probe.ts.parsePat(packet);
	            break;
	
	          case 'pmt':
	            var table = probe.ts.parsePmt(packet);
	            pmt.table = pmt.table || {};
	            Object.keys(table).forEach(function (key) {
	              pmt.table[key] = table[key];
	            });
	            break;
	        }
	
	        startIndex += MP2T_PACKET_LENGTH;
	        endIndex += MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex++;
	      endIndex++;
	    }
	  };
	  /**
	   * walks through the segment data from the start and end to get timing information
	   * for the first and last audio pes packets
	   */
	
	
	  var parseAudioPes_ = function parseAudioPes_(bytes, pmt, result) {
	    var startIndex = 0,
	        endIndex = MP2T_PACKET_LENGTH,
	        packet,
	        type,
	        pesType,
	        pusi,
	        parsed;
	    var endLoop = false; // Start walking from start of segment to get first audio packet
	
	    while (endIndex <= bytes.byteLength) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && (bytes[endIndex] === SYNC_BYTE || endIndex === bytes.byteLength)) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pes':
	            pesType = probe.ts.parsePesType(packet, pmt.table);
	            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	
	            if (pesType === 'audio' && pusi) {
	              parsed = probe.ts.parsePesTime(packet);
	
	              if (parsed) {
	                parsed.type = 'audio';
	                result.audio.push(parsed);
	                endLoop = true;
	              }
	            }
	
	            break;
	        }
	
	        if (endLoop) {
	          break;
	        }
	
	        startIndex += MP2T_PACKET_LENGTH;
	        endIndex += MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex++;
	      endIndex++;
	    } // Start walking from end of segment to get last audio packet
	
	
	    endIndex = bytes.byteLength;
	    startIndex = endIndex - MP2T_PACKET_LENGTH;
	    endLoop = false;
	
	    while (startIndex >= 0) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && (bytes[endIndex] === SYNC_BYTE || endIndex === bytes.byteLength)) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pes':
	            pesType = probe.ts.parsePesType(packet, pmt.table);
	            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	
	            if (pesType === 'audio' && pusi) {
	              parsed = probe.ts.parsePesTime(packet);
	
	              if (parsed) {
	                parsed.type = 'audio';
	                result.audio.push(parsed);
	                endLoop = true;
	              }
	            }
	
	            break;
	        }
	
	        if (endLoop) {
	          break;
	        }
	
	        startIndex -= MP2T_PACKET_LENGTH;
	        endIndex -= MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex--;
	      endIndex--;
	    }
	  };
	  /**
	   * walks through the segment data from the start and end to get timing information
	   * for the first and last video pes packets as well as timing information for the first
	   * key frame.
	   */
	
	
	  var parseVideoPes_ = function parseVideoPes_(bytes, pmt, result) {
	    var startIndex = 0,
	        endIndex = MP2T_PACKET_LENGTH,
	        packet,
	        type,
	        pesType,
	        pusi,
	        parsed,
	        frame,
	        i,
	        pes;
	    var endLoop = false;
	    var currentFrame = {
	      data: [],
	      size: 0
	    }; // Start walking from start of segment to get first video packet
	
	    while (endIndex < bytes.byteLength) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pes':
	            pesType = probe.ts.parsePesType(packet, pmt.table);
	            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	
	            if (pesType === 'video') {
	              if (pusi && !endLoop) {
	                parsed = probe.ts.parsePesTime(packet);
	
	                if (parsed) {
	                  parsed.type = 'video';
	                  result.video.push(parsed);
	                  endLoop = true;
	                }
	              }
	
	              if (!result.firstKeyFrame) {
	                if (pusi) {
	                  if (currentFrame.size !== 0) {
	                    frame = new Uint8Array(currentFrame.size);
	                    i = 0;
	
	                    while (currentFrame.data.length) {
	                      pes = currentFrame.data.shift();
	                      frame.set(pes, i);
	                      i += pes.byteLength;
	                    }
	
	                    if (probe.ts.videoPacketContainsKeyFrame(frame)) {
	                      var firstKeyFrame = probe.ts.parsePesTime(frame); // PTS/DTS may not be available. Simply *not* setting
	                      // the keyframe seems to work fine with HLS playback
	                      // and definitely preferable to a crash with TypeError...
	
	                      if (firstKeyFrame) {
	                        result.firstKeyFrame = firstKeyFrame;
	                        result.firstKeyFrame.type = 'video';
	                      } else {
	                        // eslint-disable-next-line
	                        console.warn('Failed to extract PTS/DTS from PES at first keyframe. ' + 'This could be an unusual TS segment, or else mux.js did not ' + 'parse your TS segment correctly. If you know your TS ' + 'segments do contain PTS/DTS on keyframes please file a bug ' + 'report! You can try ffprobe to double check for yourself.');
	                      }
	                    }
	
	                    currentFrame.size = 0;
	                  }
	                }
	
	                currentFrame.data.push(packet);
	                currentFrame.size += packet.byteLength;
	              }
	            }
	
	            break;
	        }
	
	        if (endLoop && result.firstKeyFrame) {
	          break;
	        }
	
	        startIndex += MP2T_PACKET_LENGTH;
	        endIndex += MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex++;
	      endIndex++;
	    } // Start walking from end of segment to get last video packet
	
	
	    endIndex = bytes.byteLength;
	    startIndex = endIndex - MP2T_PACKET_LENGTH;
	    endLoop = false;
	
	    while (startIndex >= 0) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pes':
	            pesType = probe.ts.parsePesType(packet, pmt.table);
	            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	
	            if (pesType === 'video' && pusi) {
	              parsed = probe.ts.parsePesTime(packet);
	
	              if (parsed) {
	                parsed.type = 'video';
	                result.video.push(parsed);
	                endLoop = true;
	              }
	            }
	
	            break;
	        }
	
	        if (endLoop) {
	          break;
	        }
	
	        startIndex -= MP2T_PACKET_LENGTH;
	        endIndex -= MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex--;
	      endIndex--;
	    }
	  };
	  /**
	   * Adjusts the timestamp information for the segment to account for
	   * rollover and convert to seconds based on pes packet timescale (90khz clock)
	   */
	
	
	  var adjustTimestamp_ = function adjustTimestamp_(segmentInfo, baseTimestamp) {
	    if (segmentInfo.audio && segmentInfo.audio.length) {
	      var audioBaseTimestamp = baseTimestamp;
	
	      if (typeof audioBaseTimestamp === 'undefined' || isNaN(audioBaseTimestamp)) {
	        audioBaseTimestamp = segmentInfo.audio[0].dts;
	      }
	
	      segmentInfo.audio.forEach(function (info) {
	        info.dts = handleRollover(info.dts, audioBaseTimestamp);
	        info.pts = handleRollover(info.pts, audioBaseTimestamp); // time in seconds
	
	        info.dtsTime = info.dts / ONE_SECOND_IN_TS;
	        info.ptsTime = info.pts / ONE_SECOND_IN_TS;
	      });
	    }
	
	    if (segmentInfo.video && segmentInfo.video.length) {
	      var videoBaseTimestamp = baseTimestamp;
	
	      if (typeof videoBaseTimestamp === 'undefined' || isNaN(videoBaseTimestamp)) {
	        videoBaseTimestamp = segmentInfo.video[0].dts;
	      }
	
	      segmentInfo.video.forEach(function (info) {
	        info.dts = handleRollover(info.dts, videoBaseTimestamp);
	        info.pts = handleRollover(info.pts, videoBaseTimestamp); // time in seconds
	
	        info.dtsTime = info.dts / ONE_SECOND_IN_TS;
	        info.ptsTime = info.pts / ONE_SECOND_IN_TS;
	      });
	
	      if (segmentInfo.firstKeyFrame) {
	        var frame = segmentInfo.firstKeyFrame;
	        frame.dts = handleRollover(frame.dts, videoBaseTimestamp);
	        frame.pts = handleRollover(frame.pts, videoBaseTimestamp); // time in seconds
	
	        frame.dtsTime = frame.dts / ONE_SECOND_IN_TS;
	        frame.ptsTime = frame.pts / ONE_SECOND_IN_TS;
	      }
	    }
	  };
	  /**
	   * inspects the aac data stream for start and end time information
	   */
	
	
	  var inspectAac_ = function inspectAac_(bytes) {
	    var endLoop = false,
	        audioCount = 0,
	        sampleRate = null,
	        timestamp = null,
	        frameSize = 0,
	        byteIndex = 0,
	        packet;
	
	    while (bytes.length - byteIndex >= 3) {
	      var type = probe.aac.parseType(bytes, byteIndex);
	
	      switch (type) {
	        case 'timed-metadata':
	          // Exit early because we don't have enough to parse
	          // the ID3 tag header
	          if (bytes.length - byteIndex < 10) {
	            endLoop = true;
	            break;
	          }
	
	          frameSize = probe.aac.parseId3TagSize(bytes, byteIndex); // Exit early if we don't have enough in the buffer
	          // to emit a full packet
	
	          if (frameSize > bytes.length) {
	            endLoop = true;
	            break;
	          }
	
	          if (timestamp === null) {
	            packet = bytes.subarray(byteIndex, byteIndex + frameSize);
	            timestamp = probe.aac.parseAacTimestamp(packet);
	          }
	
	          byteIndex += frameSize;
	          break;
	
	        case 'audio':
	          // Exit early because we don't have enough to parse
	          // the ADTS frame header
	          if (bytes.length - byteIndex < 7) {
	            endLoop = true;
	            break;
	          }
	
	          frameSize = probe.aac.parseAdtsSize(bytes, byteIndex); // Exit early if we don't have enough in the buffer
	          // to emit a full packet
	
	          if (frameSize > bytes.length) {
	            endLoop = true;
	            break;
	          }
	
	          if (sampleRate === null) {
	            packet = bytes.subarray(byteIndex, byteIndex + frameSize);
	            sampleRate = probe.aac.parseSampleRate(packet);
	          }
	
	          audioCount++;
	          byteIndex += frameSize;
	          break;
	
	        default:
	          byteIndex++;
	          break;
	      }
	
	      if (endLoop) {
	        return null;
	      }
	    }
	
	    if (sampleRate === null || timestamp === null) {
	      return null;
	    }
	
	    var audioTimescale = ONE_SECOND_IN_TS / sampleRate;
	    var result = {
	      audio: [{
	        type: 'audio',
	        dts: timestamp,
	        pts: timestamp
	      }, {
	        type: 'audio',
	        dts: timestamp + audioCount * 1024 * audioTimescale,
	        pts: timestamp + audioCount * 1024 * audioTimescale
	      }]
	    };
	    return result;
	  };
	  /**
	   * inspects the transport stream segment data for start and end time information
	   * of the audio and video tracks (when present) as well as the first key frame's
	   * start time.
	   */
	
	
	  var inspectTs_ = function inspectTs_(bytes) {
	    var pmt = {
	      pid: null,
	      table: null
	    };
	    var result = {};
	    parsePsi_(bytes, pmt);
	
	    for (var pid in pmt.table) {
	      if (pmt.table.hasOwnProperty(pid)) {
	        var type = pmt.table[pid];
	
	        switch (type) {
	          case streamTypes.H264_STREAM_TYPE:
	            result.video = [];
	            parseVideoPes_(bytes, pmt, result);
	
	            if (result.video.length === 0) {
	              delete result.video;
	            }
	
	            break;
	
	          case streamTypes.ADTS_STREAM_TYPE:
	            result.audio = [];
	            parseAudioPes_(bytes, pmt, result);
	
	            if (result.audio.length === 0) {
	              delete result.audio;
	            }
	
	            break;
	        }
	      }
	    }
	
	    return result;
	  };
	  /**
	   * Inspects segment byte data and returns an object with start and end timing information
	   *
	   * @param {Uint8Array} bytes The segment byte data
	   * @param {Number} baseTimestamp Relative reference timestamp used when adjusting frame
	   *  timestamps for rollover. This value must be in 90khz clock.
	   * @return {Object} Object containing start and end frame timing info of segment.
	   */
	
	
	  var inspect = function inspect(bytes, baseTimestamp) {
	    var isAacData = probe.aac.isLikelyAacData(bytes);
	    var result;
	
	    if (isAacData) {
	      result = inspectAac_(bytes);
	    } else {
	      result = inspectTs_(bytes);
	    }
	
	    if (!result || !result.audio && !result.video) {
	      return null;
	    }
	
	    adjustTimestamp_(result, baseTimestamp);
	    return result;
	  };
	
	  var tsInspector = {
	    inspect: inspect,
	    parseAudioPes_: parseAudioPes_
	  };
	  /* global self */
	
	  /**
	   * Re-emits transmuxer events by converting them into messages to the
	   * world outside the worker.
	   *
	   * @param {Object} transmuxer the transmuxer to wire events on
	   * @private
	   */
	
	  var wireTransmuxerEvents = function wireTransmuxerEvents(self, transmuxer) {
	    transmuxer.on('data', function (segment) {
	      // transfer ownership of the underlying ArrayBuffer
	      // instead of doing a copy to save memory
	      // ArrayBuffers are transferable but generic TypedArrays are not
	      // @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers#Passing_data_by_transferring_ownership_(transferable_objects)
	      var initArray = segment.initSegment;
	      segment.initSegment = {
	        data: initArray.buffer,
	        byteOffset: initArray.byteOffset,
	        byteLength: initArray.byteLength
	      };
	      var typedArray = segment.data;
	      segment.data = typedArray.buffer;
	      self.postMessage({
	        action: 'data',
	        segment: segment,
	        byteOffset: typedArray.byteOffset,
	        byteLength: typedArray.byteLength
	      }, [segment.data]);
	    });
	    transmuxer.on('done', function (data) {
	      self.postMessage({
	        action: 'done'
	      });
	    });
	    transmuxer.on('gopInfo', function (gopInfo) {
	      self.postMessage({
	        action: 'gopInfo',
	        gopInfo: gopInfo
	      });
	    });
	    transmuxer.on('videoSegmentTimingInfo', function (timingInfo) {
	      var videoSegmentTimingInfo = {
	        start: {
	          decode: clock.videoTsToSeconds(timingInfo.start.dts),
	          presentation: clock.videoTsToSeconds(timingInfo.start.pts)
	        },
	        end: {
	          decode: clock.videoTsToSeconds(timingInfo.end.dts),
	          presentation: clock.videoTsToSeconds(timingInfo.end.pts)
	        },
	        baseMediaDecodeTime: clock.videoTsToSeconds(timingInfo.baseMediaDecodeTime)
	      };
	
	      if (timingInfo.prependedContentDuration) {
	        videoSegmentTimingInfo.prependedContentDuration = clock.videoTsToSeconds(timingInfo.prependedContentDuration);
	      }
	
	      self.postMessage({
	        action: 'videoSegmentTimingInfo',
	        videoSegmentTimingInfo: videoSegmentTimingInfo
	      });
	    });
	    transmuxer.on('audioSegmentTimingInfo', function (timingInfo) {
	      // Note that all times for [audio/video]SegmentTimingInfo events are in video clock
	      var audioSegmentTimingInfo = {
	        start: {
	          decode: clock.videoTsToSeconds(timingInfo.start.dts),
	          presentation: clock.videoTsToSeconds(timingInfo.start.pts)
	        },
	        end: {
	          decode: clock.videoTsToSeconds(timingInfo.end.dts),
	          presentation: clock.videoTsToSeconds(timingInfo.end.pts)
	        },
	        baseMediaDecodeTime: clock.videoTsToSeconds(timingInfo.baseMediaDecodeTime)
	      };
	
	      if (timingInfo.prependedContentDuration) {
	        audioSegmentTimingInfo.prependedContentDuration = clock.videoTsToSeconds(timingInfo.prependedContentDuration);
	      }
	
	      self.postMessage({
	        action: 'audioSegmentTimingInfo',
	        audioSegmentTimingInfo: audioSegmentTimingInfo
	      });
	    });
	    transmuxer.on('id3Frame', function (id3Frame) {
	      self.postMessage({
	        action: 'id3Frame',
	        id3Frame: id3Frame
	      });
	    });
	    transmuxer.on('caption', function (caption) {
	      self.postMessage({
	        action: 'caption',
	        caption: caption
	      });
	    });
	    transmuxer.on('trackinfo', function (trackInfo) {
	      self.postMessage({
	        action: 'trackinfo',
	        trackInfo: trackInfo
	      });
	    });
	    transmuxer.on('audioTimingInfo', function (audioTimingInfo) {
	      // convert to video TS since we prioritize video time over audio
	      self.postMessage({
	        action: 'audioTimingInfo',
	        audioTimingInfo: {
	          start: clock.videoTsToSeconds(audioTimingInfo.start),
	          end: clock.videoTsToSeconds(audioTimingInfo.end)
	        }
	      });
	    });
	    transmuxer.on('videoTimingInfo', function (videoTimingInfo) {
	      self.postMessage({
	        action: 'videoTimingInfo',
	        videoTimingInfo: {
	          start: clock.videoTsToSeconds(videoTimingInfo.start),
	          end: clock.videoTsToSeconds(videoTimingInfo.end)
	        }
	      });
	    });
	    transmuxer.on('log', function (log) {
	      self.postMessage({
	        action: 'log',
	        log: log
	      });
	    });
	  };
	  /**
	   * All incoming messages route through this hash. If no function exists
	   * to handle an incoming message, then we ignore the message.
	   *
	   * @class MessageHandlers
	   * @param {Object} options the options to initialize with
	   */
	
	
	  var MessageHandlers = /*#__PURE__*/function () {
	    function MessageHandlers(self, options) {
	      this.options = options || {};
	      this.self = self;
	      this.init();
	    }
	    /**
	     * initialize our web worker and wire all the events.
	     */
	
	
	    var _proto = MessageHandlers.prototype;
	
	    _proto.init = function init() {
	      if (this.transmuxer) {
	        this.transmuxer.dispose();
	      }
	
	      this.transmuxer = new transmuxer.Transmuxer(this.options);
	      wireTransmuxerEvents(this.self, this.transmuxer);
	    };
	
	    _proto.pushMp4Captions = function pushMp4Captions(data) {
	      if (!this.captionParser) {
	        this.captionParser = new captionParser();
	        this.captionParser.init();
	      }
	
	      var segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
	      var parsed = this.captionParser.parse(segment, data.trackIds, data.timescales);
	      this.self.postMessage({
	        action: 'mp4Captions',
	        captions: parsed && parsed.captions || [],
	        logs: parsed && parsed.logs || [],
	        data: segment.buffer
	      }, [segment.buffer]);
	    };
	
	    _proto.probeMp4StartTime = function probeMp4StartTime(_ref) {
	      var timescales = _ref.timescales,
	          data = _ref.data;
	      var startTime = probe$2.startTime(timescales, data);
	      this.self.postMessage({
	        action: 'probeMp4StartTime',
	        startTime: startTime,
	        data: data
	      }, [data.buffer]);
	    };
	
	    _proto.probeMp4Tracks = function probeMp4Tracks(_ref2) {
	      var data = _ref2.data;
	      var tracks = probe$2.tracks(data);
	      this.self.postMessage({
	        action: 'probeMp4Tracks',
	        tracks: tracks,
	        data: data
	      }, [data.buffer]);
	    }
	    /**
	     * Probe an mpeg2-ts segment to determine the start time of the segment in it's
	     * internal "media time," as well as whether it contains video and/or audio.
	     *
	     * @private
	     * @param {Uint8Array} bytes - segment bytes
	     * @param {number} baseStartTime
	     *        Relative reference timestamp used when adjusting frame timestamps for rollover.
	     *        This value should be in seconds, as it's converted to a 90khz clock within the
	     *        function body.
	     * @return {Object} The start time of the current segment in "media time" as well as
	     *                  whether it contains video and/or audio
	     */
	    ;
	
	    _proto.probeTs = function probeTs(_ref3) {
	      var data = _ref3.data,
	          baseStartTime = _ref3.baseStartTime;
	      var tsStartTime = typeof baseStartTime === 'number' && !isNaN(baseStartTime) ? baseStartTime * clock.ONE_SECOND_IN_TS : void 0;
	      var timeInfo = tsInspector.inspect(data, tsStartTime);
	      var result = null;
	
	      if (timeInfo) {
	        result = {
	          // each type's time info comes back as an array of 2 times, start and end
	          hasVideo: timeInfo.video && timeInfo.video.length === 2 || false,
	          hasAudio: timeInfo.audio && timeInfo.audio.length === 2 || false
	        };
	
	        if (result.hasVideo) {
	          result.videoStart = timeInfo.video[0].ptsTime;
	        }
	
	        if (result.hasAudio) {
	          result.audioStart = timeInfo.audio[0].ptsTime;
	        }
	      }
	
	      this.self.postMessage({
	        action: 'probeTs',
	        result: result,
	        data: data
	      }, [data.buffer]);
	    };
	
	    _proto.clearAllMp4Captions = function clearAllMp4Captions() {
	      if (this.captionParser) {
	        this.captionParser.clearAllCaptions();
	      }
	    };
	
	    _proto.clearParsedMp4Captions = function clearParsedMp4Captions() {
	      if (this.captionParser) {
	        this.captionParser.clearParsedCaptions();
	      }
	    }
	    /**
	     * Adds data (a ts segment) to the start of the transmuxer pipeline for
	     * processing.
	     *
	     * @param {ArrayBuffer} data data to push into the muxer
	     */
	    ;
	
	    _proto.push = function push(data) {
	      // Cast array buffer to correct type for transmuxer
	      var segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
	      this.transmuxer.push(segment);
	    }
	    /**
	     * Recreate the transmuxer so that the next segment added via `push`
	     * start with a fresh transmuxer.
	     */
	    ;
	
	    _proto.reset = function reset() {
	      this.transmuxer.reset();
	    }
	    /**
	     * Set the value that will be used as the `baseMediaDecodeTime` time for the
	     * next segment pushed in. Subsequent segments will have their `baseMediaDecodeTime`
	     * set relative to the first based on the PTS values.
	     *
	     * @param {Object} data used to set the timestamp offset in the muxer
	     */
	    ;
	
	    _proto.setTimestampOffset = function setTimestampOffset(data) {
	      var timestampOffset = data.timestampOffset || 0;
	      this.transmuxer.setBaseMediaDecodeTime(Math.round(clock.secondsToVideoTs(timestampOffset)));
	    };
	
	    _proto.setAudioAppendStart = function setAudioAppendStart(data) {
	      this.transmuxer.setAudioAppendStart(Math.ceil(clock.secondsToVideoTs(data.appendStart)));
	    };
	
	    _proto.setRemux = function setRemux(data) {
	      this.transmuxer.setRemux(data.remux);
	    }
	    /**
	     * Forces the pipeline to finish processing the last segment and emit it's
	     * results.
	     *
	     * @param {Object} data event data, not really used
	     */
	    ;
	
	    _proto.flush = function flush(data) {
	      this.transmuxer.flush(); // transmuxed done action is fired after both audio/video pipelines are flushed
	
	      self.postMessage({
	        action: 'done',
	        type: 'transmuxed'
	      });
	    };
	
	    _proto.endTimeline = function endTimeline() {
	      this.transmuxer.endTimeline(); // transmuxed endedtimeline action is fired after both audio/video pipelines end their
	      // timelines
	
	      self.postMessage({
	        action: 'endedtimeline',
	        type: 'transmuxed'
	      });
	    };
	
	    _proto.alignGopsWith = function alignGopsWith(data) {
	      this.transmuxer.alignGopsWith(data.gopsToAlignWith.slice());
	    };
	
	    return MessageHandlers;
	  }();
	  /**
	   * Our web worker interface so that things can talk to mux.js
	   * that will be running in a web worker. the scope is passed to this by
	   * webworkify.
	   *
	   * @param {Object} self the scope for the web worker
	   */
	
	
	  self.onmessage = function (event) {
	    if (event.data.action === 'init' && event.data.options) {
	      this.messageHandlers = new MessageHandlers(self, event.data.options);
	      return;
	    }
	
	    if (!this.messageHandlers) {
	      this.messageHandlers = new MessageHandlers(self);
	    }
	
	    if (event.data && event.data.action && event.data.action !== 'init') {
	      if (this.messageHandlers[event.data.action]) {
	        this.messageHandlers[event.data.action](event.data);
	      }
	    }
	  };
	}));
	var TransmuxWorker = factory(workerCode$1);
	/* rollup-plugin-worker-factory end for worker!/home/runner/work/http-streaming/http-streaming/src/transmuxer-worker.js */
	
	var handleData_ = function handleData_(event, transmuxedData, callback) {
	  var _event$data$segment = event.data.segment,
	      type = _event$data$segment.type,
	      initSegment = _event$data$segment.initSegment,
	      captions = _event$data$segment.captions,
	      captionStreams = _event$data$segment.captionStreams,
	      metadata = _event$data$segment.metadata,
	      videoFrameDtsTime = _event$data$segment.videoFrameDtsTime,
	      videoFramePtsTime = _event$data$segment.videoFramePtsTime;
	  transmuxedData.buffer.push({
	    captions: captions,
	    captionStreams: captionStreams,
	    metadata: metadata
	  });
	  var boxes = event.data.segment.boxes || {
	    data: event.data.segment.data
	  };
	  var result = {
	    type: type,
	    // cast ArrayBuffer to TypedArray
	    data: new Uint8Array(boxes.data, boxes.data.byteOffset, boxes.data.byteLength),
	    initSegment: new Uint8Array(initSegment.data, initSegment.byteOffset, initSegment.byteLength)
	  };
	
	  if (typeof videoFrameDtsTime !== 'undefined') {
	    result.videoFrameDtsTime = videoFrameDtsTime;
	  }
	
	  if (typeof videoFramePtsTime !== 'undefined') {
	    result.videoFramePtsTime = videoFramePtsTime;
	  }
	
	  callback(result);
	};
	
	var handleDone_ = function handleDone_(_ref) {
	  var transmuxedData = _ref.transmuxedData,
	      callback = _ref.callback; // Previously we only returned data on data events,
	  // not on done events. Clear out the buffer to keep that consistent.
	
	  transmuxedData.buffer = []; // all buffers should have been flushed from the muxer, so start processing anything we
	  // have received
	
	  callback(transmuxedData);
	};
	
	var handleGopInfo_ = function handleGopInfo_(event, transmuxedData) {
	  transmuxedData.gopInfo = event.data.gopInfo;
	};
	
	var processTransmux = function processTransmux(options) {
	  var transmuxer = options.transmuxer,
	      bytes = options.bytes,
	      audioAppendStart = options.audioAppendStart,
	      gopsToAlignWith = options.gopsToAlignWith,
	      remux = options.remux,
	      onData = options.onData,
	      onTrackInfo = options.onTrackInfo,
	      onAudioTimingInfo = options.onAudioTimingInfo,
	      onVideoTimingInfo = options.onVideoTimingInfo,
	      onVideoSegmentTimingInfo = options.onVideoSegmentTimingInfo,
	      onAudioSegmentTimingInfo = options.onAudioSegmentTimingInfo,
	      onId3 = options.onId3,
	      onCaptions = options.onCaptions,
	      onDone = options.onDone,
	      onEndedTimeline = options.onEndedTimeline,
	      onTransmuxerLog = options.onTransmuxerLog,
	      isEndOfTimeline = options.isEndOfTimeline;
	  var transmuxedData = {
	    buffer: []
	  };
	  var waitForEndedTimelineEvent = isEndOfTimeline;
	
	  var handleMessage = function handleMessage(event) {
	    if (transmuxer.currentTransmux !== options) {
	      // disposed
	      return;
	    }
	
	    if (event.data.action === 'data') {
	      handleData_(event, transmuxedData, onData);
	    }
	
	    if (event.data.action === 'trackinfo') {
	      onTrackInfo(event.data.trackInfo);
	    }
	
	    if (event.data.action === 'gopInfo') {
	      handleGopInfo_(event, transmuxedData);
	    }
	
	    if (event.data.action === 'audioTimingInfo') {
	      onAudioTimingInfo(event.data.audioTimingInfo);
	    }
	
	    if (event.data.action === 'videoTimingInfo') {
	      onVideoTimingInfo(event.data.videoTimingInfo);
	    }
	
	    if (event.data.action === 'videoSegmentTimingInfo') {
	      onVideoSegmentTimingInfo(event.data.videoSegmentTimingInfo);
	    }
	
	    if (event.data.action === 'audioSegmentTimingInfo') {
	      onAudioSegmentTimingInfo(event.data.audioSegmentTimingInfo);
	    }
	
	    if (event.data.action === 'id3Frame') {
	      onId3([event.data.id3Frame], event.data.id3Frame.dispatchType);
	    }
	
	    if (event.data.action === 'caption') {
	      onCaptions(event.data.caption);
	    }
	
	    if (event.data.action === 'endedtimeline') {
	      waitForEndedTimelineEvent = false;
	      onEndedTimeline();
	    }
	
	    if (event.data.action === 'log') {
	      onTransmuxerLog(event.data.log);
	    } // wait for the transmuxed event since we may have audio and video
	
	
	    if (event.data.type !== 'transmuxed') {
	      return;
	    } // If the "endedtimeline" event has not yet fired, and this segment represents the end
	    // of a timeline, that means there may still be data events before the segment
	    // processing can be considerred complete. In that case, the final event should be
	    // an "endedtimeline" event with the type "transmuxed."
	
	
	    if (waitForEndedTimelineEvent) {
	      return;
	    }
	
	    transmuxer.onmessage = null;
	    handleDone_({
	      transmuxedData: transmuxedData,
	      callback: onDone
	    });
	    /* eslint-disable no-use-before-define */
	
	    dequeue(transmuxer);
	    /* eslint-enable */
	  };
	
	  transmuxer.onmessage = handleMessage;
	
	  if (audioAppendStart) {
	    transmuxer.postMessage({
	      action: 'setAudioAppendStart',
	      appendStart: audioAppendStart
	    });
	  } // allow empty arrays to be passed to clear out GOPs
	
	
	  if (Array.isArray(gopsToAlignWith)) {
	    transmuxer.postMessage({
	      action: 'alignGopsWith',
	      gopsToAlignWith: gopsToAlignWith
	    });
	  }
	
	  if (typeof remux !== 'undefined') {
	    transmuxer.postMessage({
	      action: 'setRemux',
	      remux: remux
	    });
	  }
	
	  if (bytes.byteLength) {
	    var buffer = bytes instanceof ArrayBuffer ? bytes : bytes.buffer;
	    var byteOffset = bytes instanceof ArrayBuffer ? 0 : bytes.byteOffset;
	    transmuxer.postMessage({
	      action: 'push',
	      // Send the typed-array of data as an ArrayBuffer so that
	      // it can be sent as a "Transferable" and avoid the costly
	      // memory copy
	      data: buffer,
	      // To recreate the original typed-array, we need information
	      // about what portion of the ArrayBuffer it was a view into
	      byteOffset: byteOffset,
	      byteLength: bytes.byteLength
	    }, [buffer]);
	  }
	
	  if (isEndOfTimeline) {
	    transmuxer.postMessage({
	      action: 'endTimeline'
	    });
	  } // even if we didn't push any bytes, we have to make sure we flush in case we reached
	  // the end of the segment
	
	
	  transmuxer.postMessage({
	    action: 'flush'
	  });
	};
	
	var dequeue = function dequeue(transmuxer) {
	  transmuxer.currentTransmux = null;
	
	  if (transmuxer.transmuxQueue.length) {
	    transmuxer.currentTransmux = transmuxer.transmuxQueue.shift();
	
	    if (typeof transmuxer.currentTransmux === 'function') {
	      transmuxer.currentTransmux();
	    } else {
	      processTransmux(transmuxer.currentTransmux);
	    }
	  }
	};
	
	var processAction = function processAction(transmuxer, action) {
	  transmuxer.postMessage({
	    action: action
	  });
	  dequeue(transmuxer);
	};
	
	var enqueueAction = function enqueueAction(action, transmuxer) {
	  if (!transmuxer.currentTransmux) {
	    transmuxer.currentTransmux = action;
	    processAction(transmuxer, action);
	    return;
	  }
	
	  transmuxer.transmuxQueue.push(processAction.bind(null, transmuxer, action));
	};
	
	var reset = function reset(transmuxer) {
	  enqueueAction('reset', transmuxer);
	};
	
	var endTimeline = function endTimeline(transmuxer) {
	  enqueueAction('endTimeline', transmuxer);
	};
	
	var transmux = function transmux(options) {
	  if (!options.transmuxer.currentTransmux) {
	    options.transmuxer.currentTransmux = options;
	    processTransmux(options);
	    return;
	  }
	
	  options.transmuxer.transmuxQueue.push(options);
	};
	
	var createTransmuxer = function createTransmuxer(options) {
	  var transmuxer = new TransmuxWorker();
	  transmuxer.currentTransmux = null;
	  transmuxer.transmuxQueue = [];
	  var term = transmuxer.terminate;
	
	  transmuxer.terminate = function () {
	    transmuxer.currentTransmux = null;
	    transmuxer.transmuxQueue.length = 0;
	    return term.call(transmuxer);
	  };
	
	  transmuxer.postMessage({
	    action: 'init',
	    options: options
	  });
	  return transmuxer;
	};
	
	var segmentTransmuxer = {
	  reset: reset,
	  endTimeline: endTimeline,
	  transmux: transmux,
	  createTransmuxer: createTransmuxer
	};
	
	var workerCallback = function workerCallback(options) {
	  var transmuxer = options.transmuxer;
	  var endAction = options.endAction || options.action;
	  var callback = options.callback;
	
	  var message = _extends__default['default']({}, options, {
	    endAction: null,
	    transmuxer: null,
	    callback: null
	  });
	
	  var listenForEndEvent = function listenForEndEvent(event) {
	    if (event.data.action !== endAction) {
	      return;
	    }
	
	    transmuxer.removeEventListener('message', listenForEndEvent); // transfer ownership of bytes back to us.
	
	    if (event.data.data) {
	      event.data.data = new Uint8Array(event.data.data, options.byteOffset || 0, options.byteLength || event.data.data.byteLength);
	
	      if (options.data) {
	        options.data = event.data.data;
	      }
	    }
	
	    callback(event.data);
	  };
	
	  transmuxer.addEventListener('message', listenForEndEvent);
	
	  if (options.data) {
	    var isArrayBuffer = options.data instanceof ArrayBuffer;
	    message.byteOffset = isArrayBuffer ? 0 : options.data.byteOffset;
	    message.byteLength = options.data.byteLength;
	    var transfers = [isArrayBuffer ? options.data : options.data.buffer];
	    transmuxer.postMessage(message, transfers);
	  } else {
	    transmuxer.postMessage(message);
	  }
	};
	
	var REQUEST_ERRORS = {
	  FAILURE: 2,
	  TIMEOUT: -101,
	  ABORTED: -102
	};
	/**
	 * Abort all requests
	 *
	 * @param {Object} activeXhrs - an object that tracks all XHR requests
	 */
	
	var abortAll = function abortAll(activeXhrs) {
	  activeXhrs.forEach(function (xhr) {
	    xhr.abort();
	  });
	};
	/**
	 * Gather important bandwidth stats once a request has completed
	 *
	 * @param {Object} request - the XHR request from which to gather stats
	 */
	
	
	var getRequestStats = function getRequestStats(request) {
	  return {
	    bandwidth: request.bandwidth,
	    bytesReceived: request.bytesReceived || 0,
	    roundTripTime: request.roundTripTime || 0
	  };
	};
	/**
	 * If possible gather bandwidth stats as a request is in
	 * progress
	 *
	 * @param {Event} progressEvent - an event object from an XHR's progress event
	 */
	
	
	var getProgressStats = function getProgressStats(progressEvent) {
	  var request = progressEvent.target;
	  var roundTripTime = Date.now() - request.requestTime;
	  var stats = {
	    bandwidth: Infinity,
	    bytesReceived: 0,
	    roundTripTime: roundTripTime || 0
	  };
	  stats.bytesReceived = progressEvent.loaded; // This can result in Infinity if stats.roundTripTime is 0 but that is ok
	  // because we should only use bandwidth stats on progress to determine when
	  // abort a request early due to insufficient bandwidth
	
	  stats.bandwidth = Math.floor(stats.bytesReceived / stats.roundTripTime * 8 * 1000);
	  return stats;
	};
	/**
	 * Handle all error conditions in one place and return an object
	 * with all the information
	 *
	 * @param {Error|null} error - if non-null signals an error occured with the XHR
	 * @param {Object} request -  the XHR request that possibly generated the error
	 */
	
	
	var handleErrors = function handleErrors(error, request) {
	  if (request.timedout) {
	    return {
	      status: request.status,
	      message: 'HLS request timed-out at URL: ' + request.uri,
	      code: REQUEST_ERRORS.TIMEOUT,
	      xhr: request
	    };
	  }
	
	  if (request.aborted) {
	    return {
	      status: request.status,
	      message: 'HLS request aborted at URL: ' + request.uri,
	      code: REQUEST_ERRORS.ABORTED,
	      xhr: request
	    };
	  }
	
	  if (error) {
	    return {
	      status: request.status,
	      message: 'HLS request errored at URL: ' + request.uri,
	      code: REQUEST_ERRORS.FAILURE,
	      xhr: request
	    };
	  }
	
	  if (request.responseType === 'arraybuffer' && request.response.byteLength === 0) {
	    return {
	      status: request.status,
	      message: 'Empty HLS response at URL: ' + request.uri,
	      code: REQUEST_ERRORS.FAILURE,
	      xhr: request
	    };
	  }
	
	  return null;
	};
	/**
	 * Handle responses for key data and convert the key data to the correct format
	 * for the decryption step later
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Array} objects - objects to add the key bytes to.
	 * @param {Function} finishProcessingFn - a callback to execute to continue processing
	 *                                        this request
	 */
	
	
	var handleKeyResponse = function handleKeyResponse(segment, objects, finishProcessingFn) {
	  return function (error, request) {
	    var response = request.response;
	    var errorObj = handleErrors(error, request);
	
	    if (errorObj) {
	      return finishProcessingFn(errorObj, segment);
	    }
	
	    if (response.byteLength !== 16) {
	      return finishProcessingFn({
	        status: request.status,
	        message: 'Invalid HLS key at URL: ' + request.uri,
	        code: REQUEST_ERRORS.FAILURE,
	        xhr: request
	      }, segment);
	    }
	
	    var view = new DataView(response);
	    var bytes = new Uint32Array([view.getUint32(0), view.getUint32(4), view.getUint32(8), view.getUint32(12)]);
	
	    for (var i = 0; i < objects.length; i++) {
	      objects[i].bytes = bytes;
	    }
	
	    return finishProcessingFn(null, segment);
	  };
	};
	
	var parseInitSegment = function parseInitSegment(segment, _callback) {
	  var type = containers.detectContainerForBytes(segment.map.bytes); // TODO: We should also handle ts init segments here, but we
	  // only know how to parse mp4 init segments at the moment
	
	  if (type !== 'mp4') {
	    var uri = segment.map.resolvedUri || segment.map.uri;
	    return _callback({
	      internal: true,
	      message: "Found unsupported " + (type || 'unknown') + " container for initialization segment at URL: " + uri,
	      code: REQUEST_ERRORS.FAILURE
	    });
	  }
	
	  workerCallback({
	    action: 'probeMp4Tracks',
	    data: segment.map.bytes,
	    transmuxer: segment.transmuxer,
	    callback: function callback(_ref) {
	      var tracks = _ref.tracks,
	          data = _ref.data; // transfer bytes back to us
	
	      segment.map.bytes = data;
	      tracks.forEach(function (track) {
	        segment.map.tracks = segment.map.tracks || {}; // only support one track of each type for now
	
	        if (segment.map.tracks[track.type]) {
	          return;
	        }
	
	        segment.map.tracks[track.type] = track;
	
	        if (typeof track.id === 'number' && track.timescale) {
	          segment.map.timescales = segment.map.timescales || {};
	          segment.map.timescales[track.id] = track.timescale;
	        }
	      });
	      return _callback(null);
	    }
	  });
	};
	/**
	 * Handle init-segment responses
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} finishProcessingFn - a callback to execute to continue processing
	 *                                        this request
	 */
	
	
	var handleInitSegmentResponse = function handleInitSegmentResponse(_ref2) {
	  var segment = _ref2.segment,
	      finishProcessingFn = _ref2.finishProcessingFn;
	  return function (error, request) {
	    var errorObj = handleErrors(error, request);
	
	    if (errorObj) {
	      return finishProcessingFn(errorObj, segment);
	    }
	
	    var bytes = new Uint8Array(request.response); // init segment is encypted, we will have to wait
	    // until the key request is done to decrypt.
	
	    if (segment.map.key) {
	      segment.map.encryptedBytes = bytes;
	      return finishProcessingFn(null, segment);
	    }
	
	    segment.map.bytes = bytes;
	    parseInitSegment(segment, function (parseError) {
	      if (parseError) {
	        parseError.xhr = request;
	        parseError.status = request.status;
	        return finishProcessingFn(parseError, segment);
	      }
	
	      finishProcessingFn(null, segment);
	    });
	  };
	};
	/**
	 * Response handler for segment-requests being sure to set the correct
	 * property depending on whether the segment is encryped or not
	 * Also records and keeps track of stats that are used for ABR purposes
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} finishProcessingFn - a callback to execute to continue processing
	 *                                        this request
	 */
	
	
	var handleSegmentResponse = function handleSegmentResponse(_ref3) {
	  var segment = _ref3.segment,
	      finishProcessingFn = _ref3.finishProcessingFn,
	      responseType = _ref3.responseType;
	  return function (error, request) {
	    var errorObj = handleErrors(error, request);
	
	    if (errorObj) {
	      return finishProcessingFn(errorObj, segment);
	    }
	
	    var newBytes = // although responseText "should" exist, this guard serves to prevent an error being
	    // thrown for two primary cases:
	    // 1. the mime type override stops working, or is not implemented for a specific
	    //    browser
	    // 2. when using mock XHR libraries like sinon that do not allow the override behavior
	    responseType === 'arraybuffer' || !request.responseText ? request.response : stringToArrayBuffer(request.responseText.substring(segment.lastReachedChar || 0));
	    segment.stats = getRequestStats(request);
	
	    if (segment.key) {
	      segment.encryptedBytes = new Uint8Array(newBytes);
	    } else {
	      segment.bytes = new Uint8Array(newBytes);
	    }
	
	    return finishProcessingFn(null, segment);
	  };
	};
	
	var transmuxAndNotify = function transmuxAndNotify(_ref4) {
	  var segment = _ref4.segment,
	      bytes = _ref4.bytes,
	      trackInfoFn = _ref4.trackInfoFn,
	      timingInfoFn = _ref4.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref4.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref4.audioSegmentTimingInfoFn,
	      id3Fn = _ref4.id3Fn,
	      captionsFn = _ref4.captionsFn,
	      isEndOfTimeline = _ref4.isEndOfTimeline,
	      endedTimelineFn = _ref4.endedTimelineFn,
	      dataFn = _ref4.dataFn,
	      doneFn = _ref4.doneFn,
	      onTransmuxerLog = _ref4.onTransmuxerLog;
	  var fmp4Tracks = segment.map && segment.map.tracks || {};
	  var isMuxed = Boolean(fmp4Tracks.audio && fmp4Tracks.video); // Keep references to each function so we can null them out after we're done with them.
	  // One reason for this is that in the case of full segments, we want to trust start
	  // times from the probe, rather than the transmuxer.
	
	  var audioStartFn = timingInfoFn.bind(null, segment, 'audio', 'start');
	  var audioEndFn = timingInfoFn.bind(null, segment, 'audio', 'end');
	  var videoStartFn = timingInfoFn.bind(null, segment, 'video', 'start');
	  var videoEndFn = timingInfoFn.bind(null, segment, 'video', 'end');
	
	  var finish = function finish() {
	    return transmux({
	      bytes: bytes,
	      transmuxer: segment.transmuxer,
	      audioAppendStart: segment.audioAppendStart,
	      gopsToAlignWith: segment.gopsToAlignWith,
	      remux: isMuxed,
	      onData: function onData(result) {
	        result.type = result.type === 'combined' ? 'video' : result.type;
	        dataFn(segment, result);
	      },
	      onTrackInfo: function onTrackInfo(trackInfo) {
	        if (trackInfoFn) {
	          if (isMuxed) {
	            trackInfo.isMuxed = true;
	          }
	
	          trackInfoFn(segment, trackInfo);
	        }
	      },
	      onAudioTimingInfo: function onAudioTimingInfo(audioTimingInfo) {
	        // we only want the first start value we encounter
	        if (audioStartFn && typeof audioTimingInfo.start !== 'undefined') {
	          audioStartFn(audioTimingInfo.start);
	          audioStartFn = null;
	        } // we want to continually update the end time
	
	
	        if (audioEndFn && typeof audioTimingInfo.end !== 'undefined') {
	          audioEndFn(audioTimingInfo.end);
	        }
	      },
	      onVideoTimingInfo: function onVideoTimingInfo(videoTimingInfo) {
	        // we only want the first start value we encounter
	        if (videoStartFn && typeof videoTimingInfo.start !== 'undefined') {
	          videoStartFn(videoTimingInfo.start);
	          videoStartFn = null;
	        } // we want to continually update the end time
	
	
	        if (videoEndFn && typeof videoTimingInfo.end !== 'undefined') {
	          videoEndFn(videoTimingInfo.end);
	        }
	      },
	      onVideoSegmentTimingInfo: function onVideoSegmentTimingInfo(videoSegmentTimingInfo) {
	        videoSegmentTimingInfoFn(videoSegmentTimingInfo);
	      },
	      onAudioSegmentTimingInfo: function onAudioSegmentTimingInfo(audioSegmentTimingInfo) {
	        audioSegmentTimingInfoFn(audioSegmentTimingInfo);
	      },
	      onId3: function onId3(id3Frames, dispatchType) {
	        id3Fn(segment, id3Frames, dispatchType);
	      },
	      onCaptions: function onCaptions(captions) {
	        captionsFn(segment, [captions]);
	      },
	      isEndOfTimeline: isEndOfTimeline,
	      onEndedTimeline: function onEndedTimeline() {
	        endedTimelineFn();
	      },
	      onTransmuxerLog: onTransmuxerLog,
	      onDone: function onDone(result) {
	        if (!doneFn) {
	          return;
	        }
	
	        result.type = result.type === 'combined' ? 'video' : result.type;
	        doneFn(null, segment, result);
	      }
	    });
	  }; // In the transmuxer, we don't yet have the ability to extract a "proper" start time.
	  // Meaning cached frame data may corrupt our notion of where this segment
	  // really starts. To get around this, probe for the info needed.
	
	
	  workerCallback({
	    action: 'probeTs',
	    transmuxer: segment.transmuxer,
	    data: bytes,
	    baseStartTime: segment.baseStartTime,
	    callback: function callback(data) {
	      segment.bytes = bytes = data.data;
	      var probeResult = data.result;
	
	      if (probeResult) {
	        trackInfoFn(segment, {
	          hasAudio: probeResult.hasAudio,
	          hasVideo: probeResult.hasVideo,
	          isMuxed: isMuxed
	        });
	        trackInfoFn = null;
	
	        if (probeResult.hasAudio && !isMuxed) {
	          audioStartFn(probeResult.audioStart);
	        }
	
	        if (probeResult.hasVideo) {
	          videoStartFn(probeResult.videoStart);
	        }
	
	        audioStartFn = null;
	        videoStartFn = null;
	      }
	
	      finish();
	    }
	  });
	};
	
	var handleSegmentBytes = function handleSegmentBytes(_ref5) {
	  var segment = _ref5.segment,
	      bytes = _ref5.bytes,
	      trackInfoFn = _ref5.trackInfoFn,
	      timingInfoFn = _ref5.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref5.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref5.audioSegmentTimingInfoFn,
	      id3Fn = _ref5.id3Fn,
	      captionsFn = _ref5.captionsFn,
	      isEndOfTimeline = _ref5.isEndOfTimeline,
	      endedTimelineFn = _ref5.endedTimelineFn,
	      dataFn = _ref5.dataFn,
	      doneFn = _ref5.doneFn,
	      onTransmuxerLog = _ref5.onTransmuxerLog;
	  var bytesAsUint8Array = new Uint8Array(bytes); // TODO:
	  // We should have a handler that fetches the number of bytes required
	  // to check if something is fmp4. This will allow us to save bandwidth
	  // because we can only blacklist a playlist and abort requests
	  // by codec after trackinfo triggers.
	
	  if (containers.isLikelyFmp4MediaSegment(bytesAsUint8Array)) {
	    segment.isFmp4 = true;
	    var tracks = segment.map.tracks;
	    var trackInfo = {
	      isFmp4: true,
	      hasVideo: !!tracks.video,
	      hasAudio: !!tracks.audio
	    }; // if we have a audio track, with a codec that is not set to
	    // encrypted audio
	
	    if (tracks.audio && tracks.audio.codec && tracks.audio.codec !== 'enca') {
	      trackInfo.audioCodec = tracks.audio.codec;
	    } // if we have a video track, with a codec that is not set to
	    // encrypted video
	
	
	    if (tracks.video && tracks.video.codec && tracks.video.codec !== 'encv') {
	      trackInfo.videoCodec = tracks.video.codec;
	    }
	
	    if (tracks.video && tracks.audio) {
	      trackInfo.isMuxed = true;
	    } // since we don't support appending fmp4 data on progress, we know we have the full
	    // segment here
	
	
	    trackInfoFn(segment, trackInfo); // The probe doesn't provide the segment end time, so only callback with the start
	    // time. The end time can be roughly calculated by the receiver using the duration.
	    //
	    // Note that the start time returned by the probe reflects the baseMediaDecodeTime, as
	    // that is the true start of the segment (where the playback engine should begin
	    // decoding).
	
	    var finishLoading = function finishLoading(captions) {
	      // if the track still has audio at this point it is only possible
	      // for it to be audio only. See `tracks.video && tracks.audio` if statement
	      // above.
	      // we make sure to use segment.bytes here as that
	      dataFn(segment, {
	        data: bytesAsUint8Array,
	        type: trackInfo.hasAudio && !trackInfo.isMuxed ? 'audio' : 'video'
	      });
	
	      if (captions && captions.length) {
	        captionsFn(segment, captions);
	      }
	
	      doneFn(null, segment, {});
	    };
	
	    workerCallback({
	      action: 'probeMp4StartTime',
	      timescales: segment.map.timescales,
	      data: bytesAsUint8Array,
	      transmuxer: segment.transmuxer,
	      callback: function callback(_ref6) {
	        var data = _ref6.data,
	            startTime = _ref6.startTime; // transfer bytes back to us
	
	        bytes = data.buffer;
	        segment.bytes = bytesAsUint8Array = data;
	
	        if (trackInfo.hasAudio && !trackInfo.isMuxed) {
	          timingInfoFn(segment, 'audio', 'start', startTime);
	        }
	
	        if (trackInfo.hasVideo) {
	          timingInfoFn(segment, 'video', 'start', startTime);
	        } // Run through the CaptionParser in case there are captions.
	        // Initialize CaptionParser if it hasn't been yet
	
	
	        if (!tracks.video || !data.byteLength || !segment.transmuxer) {
	          finishLoading();
	          return;
	        }
	
	        workerCallback({
	          action: 'pushMp4Captions',
	          endAction: 'mp4Captions',
	          transmuxer: segment.transmuxer,
	          data: bytesAsUint8Array,
	          timescales: segment.map.timescales,
	          trackIds: [tracks.video.id],
	          callback: function callback(message) {
	            // transfer bytes back to us
	            bytes = message.data.buffer;
	            segment.bytes = bytesAsUint8Array = message.data;
	            message.logs.forEach(function (log) {
	              onTransmuxerLog(videojs.mergeOptions(log, {
	                stream: 'mp4CaptionParser'
	              }));
	            });
	            finishLoading(message.captions);
	          }
	        });
	      }
	    });
	    return;
	  } // VTT or other segments that don't need processing
	
	
	  if (!segment.transmuxer) {
	    doneFn(null, segment, {});
	    return;
	  }
	
	  if (typeof segment.container === 'undefined') {
	    segment.container = containers.detectContainerForBytes(bytesAsUint8Array);
	  }
	
	  if (segment.container !== 'ts' && segment.container !== 'aac') {
	    trackInfoFn(segment, {
	      hasAudio: false,
	      hasVideo: false
	    });
	    doneFn(null, segment, {});
	    return;
	  } // ts or aac
	
	
	  transmuxAndNotify({
	    segment: segment,
	    bytes: bytes,
	    trackInfoFn: trackInfoFn,
	    timingInfoFn: timingInfoFn,
	    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	    id3Fn: id3Fn,
	    captionsFn: captionsFn,
	    isEndOfTimeline: isEndOfTimeline,
	    endedTimelineFn: endedTimelineFn,
	    dataFn: dataFn,
	    doneFn: doneFn,
	    onTransmuxerLog: onTransmuxerLog
	  });
	};
	
	var decrypt = function decrypt(_ref7, callback) {
	  var id = _ref7.id,
	      key = _ref7.key,
	      encryptedBytes = _ref7.encryptedBytes,
	      decryptionWorker = _ref7.decryptionWorker;
	
	  var decryptionHandler = function decryptionHandler(event) {
	    if (event.data.source === id) {
	      decryptionWorker.removeEventListener('message', decryptionHandler);
	      var decrypted = event.data.decrypted;
	      callback(new Uint8Array(decrypted.bytes, decrypted.byteOffset, decrypted.byteLength));
	    }
	  };
	
	  decryptionWorker.addEventListener('message', decryptionHandler);
	  var keyBytes;
	
	  if (key.bytes.slice) {
	    keyBytes = key.bytes.slice();
	  } else {
	    keyBytes = new Uint32Array(Array.prototype.slice.call(key.bytes));
	  } // incrementally decrypt the bytes
	
	
	  decryptionWorker.postMessage(createTransferableMessage({
	    source: id,
	    encrypted: encryptedBytes,
	    key: keyBytes,
	    iv: key.iv
	  }), [encryptedBytes.buffer, keyBytes.buffer]);
	};
	/**
	 * Decrypt the segment via the decryption web worker
	 *
	 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
	 *                                       routines
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} trackInfoFn - a callback that receives track info
	 * @param {Function} timingInfoFn - a callback that receives timing info
	 * @param {Function} videoSegmentTimingInfoFn
	 *                   a callback that receives video timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} audioSegmentTimingInfoFn
	 *                   a callback that receives audio timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {boolean}  isEndOfTimeline
	 *                   true if this segment represents the last segment in a timeline
	 * @param {Function} endedTimelineFn
	 *                   a callback made when a timeline is ended, will only be called if
	 *                   isEndOfTimeline is true
	 * @param {Function} dataFn - a callback that is executed when segment bytes are available
	 *                            and ready to use
	 * @param {Function} doneFn - a callback that is executed after decryption has completed
	 */
	
	
	var decryptSegment = function decryptSegment(_ref8) {
	  var decryptionWorker = _ref8.decryptionWorker,
	      segment = _ref8.segment,
	      trackInfoFn = _ref8.trackInfoFn,
	      timingInfoFn = _ref8.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref8.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref8.audioSegmentTimingInfoFn,
	      id3Fn = _ref8.id3Fn,
	      captionsFn = _ref8.captionsFn,
	      isEndOfTimeline = _ref8.isEndOfTimeline,
	      endedTimelineFn = _ref8.endedTimelineFn,
	      dataFn = _ref8.dataFn,
	      doneFn = _ref8.doneFn,
	      onTransmuxerLog = _ref8.onTransmuxerLog;
	  decrypt({
	    id: segment.requestId,
	    key: segment.key,
	    encryptedBytes: segment.encryptedBytes,
	    decryptionWorker: decryptionWorker
	  }, function (decryptedBytes) {
	    segment.bytes = decryptedBytes;
	    handleSegmentBytes({
	      segment: segment,
	      bytes: segment.bytes,
	      trackInfoFn: trackInfoFn,
	      timingInfoFn: timingInfoFn,
	      videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	      id3Fn: id3Fn,
	      captionsFn: captionsFn,
	      isEndOfTimeline: isEndOfTimeline,
	      endedTimelineFn: endedTimelineFn,
	      dataFn: dataFn,
	      doneFn: doneFn,
	      onTransmuxerLog: onTransmuxerLog
	    });
	  });
	};
	/**
	 * This function waits for all XHRs to finish (with either success or failure)
	 * before continueing processing via it's callback. The function gathers errors
	 * from each request into a single errors array so that the error status for
	 * each request can be examined later.
	 *
	 * @param {Object} activeXhrs - an object that tracks all XHR requests
	 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
	 *                                       routines
	 * @param {Function} trackInfoFn - a callback that receives track info
	 * @param {Function} timingInfoFn - a callback that receives timing info
	 * @param {Function} videoSegmentTimingInfoFn
	 *                   a callback that receives video timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} audioSegmentTimingInfoFn
	 *                   a callback that receives audio timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} id3Fn - a callback that receives ID3 metadata
	 * @param {Function} captionsFn - a callback that receives captions
	 * @param {boolean}  isEndOfTimeline
	 *                   true if this segment represents the last segment in a timeline
	 * @param {Function} endedTimelineFn
	 *                   a callback made when a timeline is ended, will only be called if
	 *                   isEndOfTimeline is true
	 * @param {Function} dataFn - a callback that is executed when segment bytes are available
	 *                            and ready to use
	 * @param {Function} doneFn - a callback that is executed after all resources have been
	 *                            downloaded and any decryption completed
	 */
	
	
	var waitForCompletion = function waitForCompletion(_ref9) {
	  var activeXhrs = _ref9.activeXhrs,
	      decryptionWorker = _ref9.decryptionWorker,
	      trackInfoFn = _ref9.trackInfoFn,
	      timingInfoFn = _ref9.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref9.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref9.audioSegmentTimingInfoFn,
	      id3Fn = _ref9.id3Fn,
	      captionsFn = _ref9.captionsFn,
	      isEndOfTimeline = _ref9.isEndOfTimeline,
	      endedTimelineFn = _ref9.endedTimelineFn,
	      dataFn = _ref9.dataFn,
	      doneFn = _ref9.doneFn,
	      onTransmuxerLog = _ref9.onTransmuxerLog;
	  var count = 0;
	  var didError = false;
	  return function (error, segment) {
	    if (didError) {
	      return;
	    }
	
	    if (error) {
	      didError = true; // If there are errors, we have to abort any outstanding requests
	
	      abortAll(activeXhrs); // Even though the requests above are aborted, and in theory we could wait until we
	      // handle the aborted events from those requests, there are some cases where we may
	      // never get an aborted event. For instance, if the network connection is lost and
	      // there were two requests, the first may have triggered an error immediately, while
	      // the second request remains unsent. In that case, the aborted algorithm will not
	      // trigger an abort: see https://xhr.spec.whatwg.org/#the-abort()-method
	      //
	      // We also can't rely on the ready state of the XHR, since the request that
	      // triggered the connection error may also show as a ready state of 0 (unsent).
	      // Therefore, we have to finish this group of requests immediately after the first
	      // seen error.
	
	      return doneFn(error, segment);
	    }
	
	    count += 1;
	
	    if (count === activeXhrs.length) {
	      var segmentFinish = function segmentFinish() {
	        if (segment.encryptedBytes) {
	          return decryptSegment({
	            decryptionWorker: decryptionWorker,
	            segment: segment,
	            trackInfoFn: trackInfoFn,
	            timingInfoFn: timingInfoFn,
	            videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	            audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	            id3Fn: id3Fn,
	            captionsFn: captionsFn,
	            isEndOfTimeline: isEndOfTimeline,
	            endedTimelineFn: endedTimelineFn,
	            dataFn: dataFn,
	            doneFn: doneFn,
	            onTransmuxerLog: onTransmuxerLog
	          });
	        } // Otherwise, everything is ready just continue
	
	
	        handleSegmentBytes({
	          segment: segment,
	          bytes: segment.bytes,
	          trackInfoFn: trackInfoFn,
	          timingInfoFn: timingInfoFn,
	          videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	          audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	          id3Fn: id3Fn,
	          captionsFn: captionsFn,
	          isEndOfTimeline: isEndOfTimeline,
	          endedTimelineFn: endedTimelineFn,
	          dataFn: dataFn,
	          doneFn: doneFn,
	          onTransmuxerLog: onTransmuxerLog
	        });
	      }; // Keep track of when *all* of the requests have completed
	
	
	      segment.endOfAllRequests = Date.now();
	
	      if (segment.map && segment.map.encryptedBytes && !segment.map.bytes) {
	        return decrypt({
	          decryptionWorker: decryptionWorker,
	          // add -init to the "id" to differentiate between segment
	          // and init segment decryption, just in case they happen
	          // at the same time at some point in the future.
	          id: segment.requestId + '-init',
	          encryptedBytes: segment.map.encryptedBytes,
	          key: segment.map.key
	        }, function (decryptedBytes) {
	          segment.map.bytes = decryptedBytes;
	          parseInitSegment(segment, function (parseError) {
	            if (parseError) {
	              abortAll(activeXhrs);
	              return doneFn(parseError, segment);
	            }
	
	            segmentFinish();
	          });
	        });
	      }
	
	      segmentFinish();
	    }
	  };
	};
	/**
	 * Calls the abort callback if any request within the batch was aborted. Will only call
	 * the callback once per batch of requests, even if multiple were aborted.
	 *
	 * @param {Object} loadendState - state to check to see if the abort function was called
	 * @param {Function} abortFn - callback to call for abort
	 */
	
	
	var handleLoadEnd = function handleLoadEnd(_ref10) {
	  var loadendState = _ref10.loadendState,
	      abortFn = _ref10.abortFn;
	  return function (event) {
	    var request = event.target;
	
	    if (request.aborted && abortFn && !loadendState.calledAbortFn) {
	      abortFn();
	      loadendState.calledAbortFn = true;
	    }
	  };
	};
	/**
	 * Simple progress event callback handler that gathers some stats before
	 * executing a provided callback with the `segment` object
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} progressFn - a callback that is executed each time a progress event
	 *                                is received
	 * @param {Function} trackInfoFn - a callback that receives track info
	 * @param {Function} timingInfoFn - a callback that receives timing info
	 * @param {Function} videoSegmentTimingInfoFn
	 *                   a callback that receives video timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} audioSegmentTimingInfoFn
	 *                   a callback that receives audio timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {boolean}  isEndOfTimeline
	 *                   true if this segment represents the last segment in a timeline
	 * @param {Function} endedTimelineFn
	 *                   a callback made when a timeline is ended, will only be called if
	 *                   isEndOfTimeline is true
	 * @param {Function} dataFn - a callback that is executed when segment bytes are available
	 *                            and ready to use
	 * @param {Event} event - the progress event object from XMLHttpRequest
	 */
	
	
	var handleProgress = function handleProgress(_ref11) {
	  var segment = _ref11.segment,
	      progressFn = _ref11.progressFn;
	  _ref11.trackInfoFn;
	  _ref11.timingInfoFn;
	  _ref11.videoSegmentTimingInfoFn;
	  _ref11.audioSegmentTimingInfoFn;
	  _ref11.id3Fn;
	  _ref11.captionsFn;
	  _ref11.isEndOfTimeline;
	  _ref11.endedTimelineFn;
	  _ref11.dataFn;
	  return function (event) {
	    var request = event.target;
	
	    if (request.aborted) {
	      return;
	    }
	
	    segment.stats = videojs.mergeOptions(segment.stats, getProgressStats(event)); // record the time that we receive the first byte of data
	
	    if (!segment.stats.firstBytesReceivedAt && segment.stats.bytesReceived) {
	      segment.stats.firstBytesReceivedAt = Date.now();
	    }
	
	    return progressFn(event, segment);
	  };
	};
	/**
	 * Load all resources and does any processing necessary for a media-segment
	 *
	 * Features:
	 *   decrypts the media-segment if it has a key uri and an iv
	 *   aborts *all* requests if *any* one request fails
	 *
	 * The segment object, at minimum, has the following format:
	 * {
	 *   resolvedUri: String,
	 *   [transmuxer]: Object,
	 *   [byterange]: {
	 *     offset: Number,
	 *     length: Number
	 *   },
	 *   [key]: {
	 *     resolvedUri: String
	 *     [byterange]: {
	 *       offset: Number,
	 *       length: Number
	 *     },
	 *     iv: {
	 *       bytes: Uint32Array
	 *     }
	 *   },
	 *   [map]: {
	 *     resolvedUri: String,
	 *     [byterange]: {
	 *       offset: Number,
	 *       length: Number
	 *     },
	 *     [bytes]: Uint8Array
	 *   }
	 * }
	 * ...where [name] denotes optional properties
	 *
	 * @param {Function} xhr - an instance of the xhr wrapper in xhr.js
	 * @param {Object} xhrOptions - the base options to provide to all xhr requests
	 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128
	 *                                       decryption routines
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} abortFn - a callback called (only once) if any piece of a request was
	 *                             aborted
	 * @param {Function} progressFn - a callback that receives progress events from the main
	 *                                segment's xhr request
	 * @param {Function} trackInfoFn - a callback that receives track info
	 * @param {Function} timingInfoFn - a callback that receives timing info
	 * @param {Function} videoSegmentTimingInfoFn
	 *                   a callback that receives video timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} audioSegmentTimingInfoFn
	 *                   a callback that receives audio timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} id3Fn - a callback that receives ID3 metadata
	 * @param {Function} captionsFn - a callback that receives captions
	 * @param {boolean}  isEndOfTimeline
	 *                   true if this segment represents the last segment in a timeline
	 * @param {Function} endedTimelineFn
	 *                   a callback made when a timeline is ended, will only be called if
	 *                   isEndOfTimeline is true
	 * @param {Function} dataFn - a callback that receives data from the main segment's xhr
	 *                            request, transmuxed if needed
	 * @param {Function} doneFn - a callback that is executed only once all requests have
	 *                            succeeded or failed
	 * @return {Function} a function that, when invoked, immediately aborts all
	 *                     outstanding requests
	 */
	
	
	var mediaSegmentRequest = function mediaSegmentRequest(_ref12) {
	  var xhr = _ref12.xhr,
	      xhrOptions = _ref12.xhrOptions,
	      decryptionWorker = _ref12.decryptionWorker,
	      segment = _ref12.segment,
	      abortFn = _ref12.abortFn,
	      progressFn = _ref12.progressFn,
	      trackInfoFn = _ref12.trackInfoFn,
	      timingInfoFn = _ref12.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref12.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref12.audioSegmentTimingInfoFn,
	      id3Fn = _ref12.id3Fn,
	      captionsFn = _ref12.captionsFn,
	      isEndOfTimeline = _ref12.isEndOfTimeline,
	      endedTimelineFn = _ref12.endedTimelineFn,
	      dataFn = _ref12.dataFn,
	      doneFn = _ref12.doneFn,
	      onTransmuxerLog = _ref12.onTransmuxerLog;
	  var activeXhrs = [];
	  var finishProcessingFn = waitForCompletion({
	    activeXhrs: activeXhrs,
	    decryptionWorker: decryptionWorker,
	    trackInfoFn: trackInfoFn,
	    timingInfoFn: timingInfoFn,
	    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	    id3Fn: id3Fn,
	    captionsFn: captionsFn,
	    isEndOfTimeline: isEndOfTimeline,
	    endedTimelineFn: endedTimelineFn,
	    dataFn: dataFn,
	    doneFn: doneFn,
	    onTransmuxerLog: onTransmuxerLog
	  }); // optionally, request the decryption key
	
	  if (segment.key && !segment.key.bytes) {
	    var objects = [segment.key];
	
	    if (segment.map && !segment.map.bytes && segment.map.key && segment.map.key.resolvedUri === segment.key.resolvedUri) {
	      objects.push(segment.map.key);
	    }
	
	    var keyRequestOptions = videojs.mergeOptions(xhrOptions, {
	      uri: segment.key.resolvedUri,
	      responseType: 'arraybuffer'
	    });
	    var keyRequestCallback = handleKeyResponse(segment, objects, finishProcessingFn);
	    var keyXhr = xhr(keyRequestOptions, keyRequestCallback);
	    activeXhrs.push(keyXhr);
	  } // optionally, request the associated media init segment
	
	
	  if (segment.map && !segment.map.bytes) {
	    var differentMapKey = segment.map.key && (!segment.key || segment.key.resolvedUri !== segment.map.key.resolvedUri);
	
	    if (differentMapKey) {
	      var mapKeyRequestOptions = videojs.mergeOptions(xhrOptions, {
	        uri: segment.map.key.resolvedUri,
	        responseType: 'arraybuffer'
	      });
	      var mapKeyRequestCallback = handleKeyResponse(segment, [segment.map.key], finishProcessingFn);
	      var mapKeyXhr = xhr(mapKeyRequestOptions, mapKeyRequestCallback);
	      activeXhrs.push(mapKeyXhr);
	    }
	
	    var initSegmentOptions = videojs.mergeOptions(xhrOptions, {
	      uri: segment.map.resolvedUri,
	      responseType: 'arraybuffer',
	      headers: segmentXhrHeaders(segment.map)
	    });
	    var initSegmentRequestCallback = handleInitSegmentResponse({
	      segment: segment,
	      finishProcessingFn: finishProcessingFn
	    });
	    var initSegmentXhr = xhr(initSegmentOptions, initSegmentRequestCallback);
	    activeXhrs.push(initSegmentXhr);
	  }
	
	  var segmentRequestOptions = videojs.mergeOptions(xhrOptions, {
	    uri: segment.part && segment.part.resolvedUri || segment.resolvedUri,
	    responseType: 'arraybuffer',
	    headers: segmentXhrHeaders(segment)
	  });
	  var segmentRequestCallback = handleSegmentResponse({
	    segment: segment,
	    finishProcessingFn: finishProcessingFn,
	    responseType: segmentRequestOptions.responseType
	  });
	  var segmentXhr = xhr(segmentRequestOptions, segmentRequestCallback);
	  segmentXhr.addEventListener('progress', handleProgress({
	    segment: segment,
	    progressFn: progressFn,
	    trackInfoFn: trackInfoFn,
	    timingInfoFn: timingInfoFn,
	    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	    id3Fn: id3Fn,
	    captionsFn: captionsFn,
	    isEndOfTimeline: isEndOfTimeline,
	    endedTimelineFn: endedTimelineFn,
	    dataFn: dataFn
	  }));
	  activeXhrs.push(segmentXhr); // since all parts of the request must be considered, but should not make callbacks
	  // multiple times, provide a shared state object
	
	  var loadendState = {};
	  activeXhrs.forEach(function (activeXhr) {
	    activeXhr.addEventListener('loadend', handleLoadEnd({
	      loadendState: loadendState,
	      abortFn: abortFn
	    }));
	  });
	  return function () {
	    return abortAll(activeXhrs);
	  };
	};
	/**
	 * @file - codecs.js - Handles tasks regarding codec strings such as translating them to
	 * codec strings, or translating codec strings into objects that can be examined.
	 */
	
	
	var logFn$1 = logger('CodecUtils');
	/**
	 * Returns a set of codec strings parsed from the playlist or the default
	 * codec strings if no codecs were specified in the playlist
	 *
	 * @param {Playlist} media the current media playlist
	 * @return {Object} an object with the video and audio codecs
	 */
	
	var getCodecs = function getCodecs(media) {
	  // if the codecs were explicitly specified, use them instead of the
	  // defaults
	  var mediaAttributes = media.attributes || {};
	
	  if (mediaAttributes.CODECS) {
	    return codecs_js.parseCodecs(mediaAttributes.CODECS);
	  }
	};
	
	var isMaat = function isMaat(master, media) {
	  var mediaAttributes = media.attributes || {};
	  return master && master.mediaGroups && master.mediaGroups.AUDIO && mediaAttributes.AUDIO && master.mediaGroups.AUDIO[mediaAttributes.AUDIO];
	};
	
	var isMuxed = function isMuxed(master, media) {
	  if (!isMaat(master, media)) {
	    return true;
	  }
	
	  var mediaAttributes = media.attributes || {};
	  var audioGroup = master.mediaGroups.AUDIO[mediaAttributes.AUDIO];
	
	  for (var groupId in audioGroup) {
	    // If an audio group has a URI (the case for HLS, as HLS will use external playlists),
	    // or there are listed playlists (the case for DASH, as the manifest will have already
	    // provided all of the details necessary to generate the audio playlist, as opposed to
	    // HLS' externally requested playlists), then the content is demuxed.
	    if (!audioGroup[groupId].uri && !audioGroup[groupId].playlists) {
	      return true;
	    }
	  }
	
	  return false;
	};
	
	var unwrapCodecList = function unwrapCodecList(codecList) {
	  var codecs = {};
	  codecList.forEach(function (_ref) {
	    var mediaType = _ref.mediaType,
	        type = _ref.type,
	        details = _ref.details;
	    codecs[mediaType] = codecs[mediaType] || [];
	    codecs[mediaType].push(codecs_js.translateLegacyCodec("" + type + details));
	  });
	  Object.keys(codecs).forEach(function (mediaType) {
	    if (codecs[mediaType].length > 1) {
	      logFn$1("multiple " + mediaType + " codecs found as attributes: " + codecs[mediaType].join(', ') + ". Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.");
	      codecs[mediaType] = null;
	      return;
	    }
	
	    codecs[mediaType] = codecs[mediaType][0];
	  });
	  return codecs;
	};
	
	var codecCount = function codecCount(codecObj) {
	  var count = 0;
	
	  if (codecObj.audio) {
	    count++;
	  }
	
	  if (codecObj.video) {
	    count++;
	  }
	
	  return count;
	};
	/**
	 * Calculates the codec strings for a working configuration of
	 * SourceBuffers to play variant streams in a master playlist. If
	 * there is no possible working configuration, an empty object will be
	 * returned.
	 *
	 * @param master {Object} the m3u8 object for the master playlist
	 * @param media {Object} the m3u8 object for the variant playlist
	 * @return {Object} the codec strings.
	 *
	 * @private
	 */
	
	
	var codecsForPlaylist = function codecsForPlaylist(master, media) {
	  var mediaAttributes = media.attributes || {};
	  var codecInfo = unwrapCodecList(getCodecs(media) || []); // HLS with multiple-audio tracks must always get an audio codec.
	  // Put another way, there is no way to have a video-only multiple-audio HLS!
	
	  if (isMaat(master, media) && !codecInfo.audio) {
	    if (!isMuxed(master, media)) {
	      // It is possible for codecs to be specified on the audio media group playlist but
	      // not on the rendition playlist. This is mostly the case for DASH, where audio and
	      // video are always separate (and separately specified).
	      var defaultCodecs = unwrapCodecList(codecs_js.codecsFromDefault(master, mediaAttributes.AUDIO) || []);
	
	      if (defaultCodecs.audio) {
	        codecInfo.audio = defaultCodecs.audio;
	      }
	    }
	  }
	
	  return codecInfo;
	};
	
	var logFn = logger('PlaylistSelector');
	
	var representationToString = function representationToString(representation) {
	  if (!representation || !representation.playlist) {
	    return;
	  }
	
	  var playlist = representation.playlist;
	  return JSON.stringify({
	    id: playlist.id,
	    bandwidth: representation.bandwidth,
	    width: representation.width,
	    height: representation.height,
	    codecs: playlist.attributes && playlist.attributes.CODECS || ''
	  });
	}; // Utilities
	
	/**
	 * Returns the CSS value for the specified property on an element
	 * using `getComputedStyle`. Firefox has a long-standing issue where
	 * getComputedStyle() may return null when running in an iframe with
	 * `display: none`.
	 *
	 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 * @param {HTMLElement} el the htmlelement to work on
	 * @param {string} the proprety to get the style for
	 */
	
	
	var safeGetComputedStyle = function safeGetComputedStyle(el, property) {
	  if (!el) {
	    return '';
	  }
	
	  var result = window__default['default'].getComputedStyle(el);
	
	  if (!result) {
	    return '';
	  }
	
	  return result[property];
	};
	/**
	 * Resuable stable sort function
	 *
	 * @param {Playlists} array
	 * @param {Function} sortFn Different comparators
	 * @function stableSort
	 */
	
	
	var stableSort = function stableSort(array, sortFn) {
	  var newArray = array.slice();
	  array.sort(function (left, right) {
	    var cmp = sortFn(left, right);
	
	    if (cmp === 0) {
	      return newArray.indexOf(left) - newArray.indexOf(right);
	    }
	
	    return cmp;
	  });
	};
	/**
	 * A comparator function to sort two playlist object by bandwidth.
	 *
	 * @param {Object} left a media playlist object
	 * @param {Object} right a media playlist object
	 * @return {number} Greater than zero if the bandwidth attribute of
	 * left is greater than the corresponding attribute of right. Less
	 * than zero if the bandwidth of right is greater than left and
	 * exactly zero if the two are equal.
	 */
	
	
	var comparePlaylistBandwidth = function comparePlaylistBandwidth(left, right) {
	  var leftBandwidth;
	  var rightBandwidth;
	
	  if (left.attributes.BANDWIDTH) {
	    leftBandwidth = left.attributes.BANDWIDTH;
	  }
	
	  leftBandwidth = leftBandwidth || window__default['default'].Number.MAX_VALUE;
	
	  if (right.attributes.BANDWIDTH) {
	    rightBandwidth = right.attributes.BANDWIDTH;
	  }
	
	  rightBandwidth = rightBandwidth || window__default['default'].Number.MAX_VALUE;
	  return leftBandwidth - rightBandwidth;
	};
	/**
	 * A comparator function to sort two playlist object by resolution (width).
	 *
	 * @param {Object} left a media playlist object
	 * @param {Object} right a media playlist object
	 * @return {number} Greater than zero if the resolution.width attribute of
	 * left is greater than the corresponding attribute of right. Less
	 * than zero if the resolution.width of right is greater than left and
	 * exactly zero if the two are equal.
	 */
	
	
	var comparePlaylistResolution = function comparePlaylistResolution(left, right) {
	  var leftWidth;
	  var rightWidth;
	
	  if (left.attributes.RESOLUTION && left.attributes.RESOLUTION.width) {
	    leftWidth = left.attributes.RESOLUTION.width;
	  }
	
	  leftWidth = leftWidth || window__default['default'].Number.MAX_VALUE;
	
	  if (right.attributes.RESOLUTION && right.attributes.RESOLUTION.width) {
	    rightWidth = right.attributes.RESOLUTION.width;
	  }
	
	  rightWidth = rightWidth || window__default['default'].Number.MAX_VALUE; // NOTE - Fallback to bandwidth sort as appropriate in cases where multiple renditions
	  // have the same media dimensions/ resolution
	
	  if (leftWidth === rightWidth && left.attributes.BANDWIDTH && right.attributes.BANDWIDTH) {
	    return left.attributes.BANDWIDTH - right.attributes.BANDWIDTH;
	  }
	
	  return leftWidth - rightWidth;
	};
	/**
	 * Chooses the appropriate media playlist based on bandwidth and player size
	 *
	 * @param {Object} master
	 *        Object representation of the master manifest
	 * @param {number} playerBandwidth
	 *        Current calculated bandwidth of the player
	 * @param {number} playerWidth
	 *        Current width of the player element (should account for the device pixel ratio)
	 * @param {number} playerHeight
	 *        Current height of the player element (should account for the device pixel ratio)
	 * @param {boolean} limitRenditionByPlayerDimensions
	 *        True if the player width and height should be used during the selection, false otherwise
	 * @param {Object} masterPlaylistController
	 *        the current masterPlaylistController object
	 * @return {Playlist} the highest bitrate playlist less than the
	 * currently detected bandwidth, accounting for some amount of
	 * bandwidth variance
	 */
	
	
	var simpleSelector = function simpleSelector(master, playerBandwidth, playerWidth, playerHeight, limitRenditionByPlayerDimensions, masterPlaylistController) {
	  // If we end up getting called before `master` is available, exit early
	  if (!master) {
	    return;
	  }
	
	  var options = {
	    bandwidth: playerBandwidth,
	    width: playerWidth,
	    height: playerHeight,
	    limitRenditionByPlayerDimensions: limitRenditionByPlayerDimensions
	  };
	  var playlists = master.playlists; // if playlist is audio only, select between currently active audio group playlists.
	
	  if (Playlist.isAudioOnly(master)) {
	    playlists = masterPlaylistController.getAudioTrackPlaylists_(); // add audioOnly to options so that we log audioOnly: true
	    // at the buttom of this function for debugging.
	
	    options.audioOnly = true;
	  } // convert the playlists to an intermediary representation to make comparisons easier
	
	
	  var sortedPlaylistReps = playlists.map(function (playlist) {
	    var bandwidth;
	    var width = playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.width;
	    var height = playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height;
	    bandwidth = playlist.attributes && playlist.attributes.BANDWIDTH;
	    bandwidth = bandwidth || window__default['default'].Number.MAX_VALUE;
	    return {
	      bandwidth: bandwidth,
	      width: width,
	      height: height,
	      playlist: playlist
	    };
	  });
	  stableSort(sortedPlaylistReps, function (left, right) {
	    return left.bandwidth - right.bandwidth;
	  }); // filter out any playlists that have been excluded due to
	  // incompatible configurations
	
	  sortedPlaylistReps = sortedPlaylistReps.filter(function (rep) {
	    return !Playlist.isIncompatible(rep.playlist);
	  }); // filter out any playlists that have been disabled manually through the representations
	  // api or blacklisted temporarily due to playback errors.
	
	  var enabledPlaylistReps = sortedPlaylistReps.filter(function (rep) {
	    return Playlist.isEnabled(rep.playlist);
	  });
	
	  if (!enabledPlaylistReps.length) {
	    // if there are no enabled playlists, then they have all been blacklisted or disabled
	    // by the user through the representations api. In this case, ignore blacklisting and
	    // fallback to what the user wants by using playlists the user has not disabled.
	    enabledPlaylistReps = sortedPlaylistReps.filter(function (rep) {
	      return !Playlist.isDisabled(rep.playlist);
	    });
	  } // filter out any variant that has greater effective bitrate
	  // than the current estimated bandwidth
	
	
	  var bandwidthPlaylistReps = enabledPlaylistReps.filter(function (rep) {
	    return rep.bandwidth * Config.BANDWIDTH_VARIANCE < playerBandwidth;
	  });
	  var highestRemainingBandwidthRep = bandwidthPlaylistReps[bandwidthPlaylistReps.length - 1]; // get all of the renditions with the same (highest) bandwidth
	  // and then taking the very first element
	
	  var bandwidthBestRep = bandwidthPlaylistReps.filter(function (rep) {
	    return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
	  })[0]; // if we're not going to limit renditions by player size, make an early decision.
	
	  if (limitRenditionByPlayerDimensions === false) {
	    var _chosenRep = bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
	
	    if (_chosenRep && _chosenRep.playlist) {
	      var type = 'sortedPlaylistReps';
	
	      if (bandwidthBestRep) {
	        type = 'bandwidthBestRep';
	      }
	
	      if (enabledPlaylistReps[0]) {
	        type = 'enabledPlaylistReps';
	      }
	
	      logFn("choosing " + representationToString(_chosenRep) + " using " + type + " with options", options);
	      return _chosenRep.playlist;
	    }
	
	    logFn('could not choose a playlist with options', options);
	    return null;
	  } // filter out playlists without resolution information
	
	
	  var haveResolution = bandwidthPlaylistReps.filter(function (rep) {
	    return rep.width && rep.height;
	  }); // sort variants by resolution
	
	  stableSort(haveResolution, function (left, right) {
	    return left.width - right.width;
	  }); // if we have the exact resolution as the player use it
	
	  var resolutionBestRepList = haveResolution.filter(function (rep) {
	    return rep.width === playerWidth && rep.height === playerHeight;
	  });
	  highestRemainingBandwidthRep = resolutionBestRepList[resolutionBestRepList.length - 1]; // ensure that we pick the highest bandwidth variant that have exact resolution
	
	  var resolutionBestRep = resolutionBestRepList.filter(function (rep) {
	    return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
	  })[0];
	  var resolutionPlusOneList;
	  var resolutionPlusOneSmallest;
	  var resolutionPlusOneRep; // find the smallest variant that is larger than the player
	  // if there is no match of exact resolution
	
	  if (!resolutionBestRep) {
	    resolutionPlusOneList = haveResolution.filter(function (rep) {
	      return rep.width > playerWidth || rep.height > playerHeight;
	    }); // find all the variants have the same smallest resolution
	
	    resolutionPlusOneSmallest = resolutionPlusOneList.filter(function (rep) {
	      return rep.width === resolutionPlusOneList[0].width && rep.height === resolutionPlusOneList[0].height;
	    }); // ensure that we also pick the highest bandwidth variant that
	    // is just-larger-than the video player
	
	    highestRemainingBandwidthRep = resolutionPlusOneSmallest[resolutionPlusOneSmallest.length - 1];
	    resolutionPlusOneRep = resolutionPlusOneSmallest.filter(function (rep) {
	      return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
	    })[0];
	  }
	
	  var leastPixelDiffRep; // If this selector proves to be better than others,
	  // resolutionPlusOneRep and resolutionBestRep and all
	  // the code involving them should be removed.
	
	  if (masterPlaylistController.experimentalLeastPixelDiffSelector) {
	    // find the variant that is closest to the player's pixel size
	    var leastPixelDiffList = haveResolution.map(function (rep) {
	      rep.pixelDiff = Math.abs(rep.width - playerWidth) + Math.abs(rep.height - playerHeight);
	      return rep;
	    }); // get the highest bandwidth, closest resolution playlist
	
	    stableSort(leastPixelDiffList, function (left, right) {
	      // sort by highest bandwidth if pixelDiff is the same
	      if (left.pixelDiff === right.pixelDiff) {
	        return right.bandwidth - left.bandwidth;
	      }
	
	      return left.pixelDiff - right.pixelDiff;
	    });
	    leastPixelDiffRep = leastPixelDiffList[0];
	  } // fallback chain of variants
	
	
	  var chosenRep = leastPixelDiffRep || resolutionPlusOneRep || resolutionBestRep || bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
	
	  if (chosenRep && chosenRep.playlist) {
	    var _type = 'sortedPlaylistReps';
	
	    if (leastPixelDiffRep) {
	      _type = 'leastPixelDiffRep';
	    } else if (resolutionPlusOneRep) {
	      _type = 'resolutionPlusOneRep';
	    } else if (resolutionBestRep) {
	      _type = 'resolutionBestRep';
	    } else if (bandwidthBestRep) {
	      _type = 'bandwidthBestRep';
	    } else if (enabledPlaylistReps[0]) {
	      _type = 'enabledPlaylistReps';
	    }
	
	    logFn("choosing " + representationToString(chosenRep) + " using " + _type + " with options", options);
	    return chosenRep.playlist;
	  }
	
	  logFn('could not choose a playlist with options', options);
	  return null;
	};
	/**
	 * Chooses the appropriate media playlist based on the most recent
	 * bandwidth estimate and the player size.
	 *
	 * Expects to be called within the context of an instance of VhsHandler
	 *
	 * @return {Playlist} the highest bitrate playlist less than the
	 * currently detected bandwidth, accounting for some amount of
	 * bandwidth variance
	 */
	
	
	var lastBandwidthSelector = function lastBandwidthSelector() {
	  var pixelRatio = this.useDevicePixelRatio ? window__default['default'].devicePixelRatio || 1 : 1;
	  return simpleSelector(this.playlists.master, this.systemBandwidth, parseInt(safeGetComputedStyle(this.tech_.el(), 'width'), 10) * pixelRatio, parseInt(safeGetComputedStyle(this.tech_.el(), 'height'), 10) * pixelRatio, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_);
	};
	/**
	 * Chooses the appropriate media playlist based on an
	 * exponential-weighted moving average of the bandwidth after
	 * filtering for player size.
	 *
	 * Expects to be called within the context of an instance of VhsHandler
	 *
	 * @param {number} decay - a number between 0 and 1. Higher values of
	 * this parameter will cause previous bandwidth estimates to lose
	 * significance more quickly.
	 * @return {Function} a function which can be invoked to create a new
	 * playlist selector function.
	 * @see https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
	 */
	
	
	var movingAverageBandwidthSelector = function movingAverageBandwidthSelector(decay) {
	  var average = -1;
	  var lastSystemBandwidth = -1;
	
	  if (decay < 0 || decay > 1) {
	    throw new Error('Moving average bandwidth decay must be between 0 and 1.');
	  }
	
	  return function () {
	    var pixelRatio = this.useDevicePixelRatio ? window__default['default'].devicePixelRatio || 1 : 1;
	
	    if (average < 0) {
	      average = this.systemBandwidth;
	      lastSystemBandwidth = this.systemBandwidth;
	    } // stop the average value from decaying for every 250ms
	    // when the systemBandwidth is constant
	    // and
	    // stop average from setting to a very low value when the
	    // systemBandwidth becomes 0 in case of chunk cancellation
	
	
	    if (this.systemBandwidth > 0 && this.systemBandwidth !== lastSystemBandwidth) {
	      average = decay * this.systemBandwidth + (1 - decay) * average;
	      lastSystemBandwidth = this.systemBandwidth;
	    }
	
	    return simpleSelector(this.playlists.master, average, parseInt(safeGetComputedStyle(this.tech_.el(), 'width'), 10) * pixelRatio, parseInt(safeGetComputedStyle(this.tech_.el(), 'height'), 10) * pixelRatio, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_);
	  };
	};
	/**
	 * Chooses the appropriate media playlist based on the potential to rebuffer
	 *
	 * @param {Object} settings
	 *        Object of information required to use this selector
	 * @param {Object} settings.master
	 *        Object representation of the master manifest
	 * @param {number} settings.currentTime
	 *        The current time of the player
	 * @param {number} settings.bandwidth
	 *        Current measured bandwidth
	 * @param {number} settings.duration
	 *        Duration of the media
	 * @param {number} settings.segmentDuration
	 *        Segment duration to be used in round trip time calculations
	 * @param {number} settings.timeUntilRebuffer
	 *        Time left in seconds until the player has to rebuffer
	 * @param {number} settings.currentTimeline
	 *        The current timeline segments are being loaded from
	 * @param {SyncController} settings.syncController
	 *        SyncController for determining if we have a sync point for a given playlist
	 * @return {Object|null}
	 *         {Object} return.playlist
	 *         The highest bandwidth playlist with the least amount of rebuffering
	 *         {Number} return.rebufferingImpact
	 *         The amount of time in seconds switching to this playlist will rebuffer. A
	 *         negative value means that switching will cause zero rebuffering.
	 */
	
	
	var minRebufferMaxBandwidthSelector = function minRebufferMaxBandwidthSelector(settings) {
	  var master = settings.master,
	      currentTime = settings.currentTime,
	      bandwidth = settings.bandwidth,
	      duration = settings.duration,
	      segmentDuration = settings.segmentDuration,
	      timeUntilRebuffer = settings.timeUntilRebuffer,
	      currentTimeline = settings.currentTimeline,
	      syncController = settings.syncController; // filter out any playlists that have been excluded due to
	  // incompatible configurations
	
	  var compatiblePlaylists = master.playlists.filter(function (playlist) {
	    return !Playlist.isIncompatible(playlist);
	  }); // filter out any playlists that have been disabled manually through the representations
	  // api or blacklisted temporarily due to playback errors.
	
	  var enabledPlaylists = compatiblePlaylists.filter(Playlist.isEnabled);
	
	  if (!enabledPlaylists.length) {
	    // if there are no enabled playlists, then they have all been blacklisted or disabled
	    // by the user through the representations api. In this case, ignore blacklisting and
	    // fallback to what the user wants by using playlists the user has not disabled.
	    enabledPlaylists = compatiblePlaylists.filter(function (playlist) {
	      return !Playlist.isDisabled(playlist);
	    });
	  }
	
	  var bandwidthPlaylists = enabledPlaylists.filter(Playlist.hasAttribute.bind(null, 'BANDWIDTH'));
	  var rebufferingEstimates = bandwidthPlaylists.map(function (playlist) {
	    var syncPoint = syncController.getSyncPoint(playlist, duration, currentTimeline, currentTime); // If there is no sync point for this playlist, switching to it will require a
	    // sync request first. This will double the request time
	
	    var numRequests = syncPoint ? 1 : 2;
	    var requestTimeEstimate = Playlist.estimateSegmentRequestTime(segmentDuration, bandwidth, playlist);
	    var rebufferingImpact = requestTimeEstimate * numRequests - timeUntilRebuffer;
	    return {
	      playlist: playlist,
	      rebufferingImpact: rebufferingImpact
	    };
	  });
	  var noRebufferingPlaylists = rebufferingEstimates.filter(function (estimate) {
	    return estimate.rebufferingImpact <= 0;
	  }); // Sort by bandwidth DESC
	
	  stableSort(noRebufferingPlaylists, function (a, b) {
	    return comparePlaylistBandwidth(b.playlist, a.playlist);
	  });
	
	  if (noRebufferingPlaylists.length) {
	    return noRebufferingPlaylists[0];
	  }
	
	  stableSort(rebufferingEstimates, function (a, b) {
	    return a.rebufferingImpact - b.rebufferingImpact;
	  });
	  return rebufferingEstimates[0] || null;
	};
	/**
	 * Chooses the appropriate media playlist, which in this case is the lowest bitrate
	 * one with video.  If no renditions with video exist, return the lowest audio rendition.
	 *
	 * Expects to be called within the context of an instance of VhsHandler
	 *
	 * @return {Object|null}
	 *         {Object} return.playlist
	 *         The lowest bitrate playlist that contains a video codec.  If no such rendition
	 *         exists pick the lowest audio rendition.
	 */
	
	
	var lowestBitrateCompatibleVariantSelector = function lowestBitrateCompatibleVariantSelector() {
	  var _this = this; // filter out any playlists that have been excluded due to
	  // incompatible configurations or playback errors
	
	
	  var playlists = this.playlists.master.playlists.filter(Playlist.isEnabled); // Sort ascending by bitrate
	
	  stableSort(playlists, function (a, b) {
	    return comparePlaylistBandwidth(a, b);
	  }); // Parse and assume that playlists with no video codec have no video
	  // (this is not necessarily true, although it is generally true).
	  //
	  // If an entire manifest has no valid videos everything will get filtered
	  // out.
	
	  var playlistsWithVideo = playlists.filter(function (playlist) {
	    return !!codecsForPlaylist(_this.playlists.master, playlist).video;
	  });
	  return playlistsWithVideo[0] || null;
	};
	/**
	 * Combine all segments into a single Uint8Array
	 *
	 * @param {Object} segmentObj
	 * @return {Uint8Array} concatenated bytes
	 * @private
	 */
	
	
	var concatSegments = function concatSegments(segmentObj) {
	  var offset = 0;
	  var tempBuffer;
	
	  if (segmentObj.bytes) {
	    tempBuffer = new Uint8Array(segmentObj.bytes); // combine the individual segments into one large typed-array
	
	    segmentObj.segments.forEach(function (segment) {
	      tempBuffer.set(segment, offset);
	      offset += segment.byteLength;
	    });
	  }
	
	  return tempBuffer;
	};
	/**
	 * @file text-tracks.js
	 */
	
	/**
	 * Create captions text tracks on video.js if they do not exist
	 *
	 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
	 * @param {Object} tech the video.js tech
	 * @param {Object} captionStream the caption stream to create
	 * @private
	 */
	
	
	var createCaptionsTrackIfNotExists = function createCaptionsTrackIfNotExists(inbandTextTracks, tech, captionStream) {
	  if (!inbandTextTracks[captionStream]) {
	    tech.trigger({
	      type: 'usage',
	      name: 'vhs-608'
	    });
	    tech.trigger({
	      type: 'usage',
	      name: 'hls-608'
	    });
	    var instreamId = captionStream; // we need to translate SERVICEn for 708 to how mux.js currently labels them
	
	    if (/^cc708_/.test(captionStream)) {
	      instreamId = 'SERVICE' + captionStream.split('_')[1];
	    }
	
	    var track = tech.textTracks().getTrackById(instreamId);
	
	    if (track) {
	      // Resuse an existing track with a CC# id because this was
	      // very likely created by videojs-contrib-hls from information
	      // in the m3u8 for us to use
	      inbandTextTracks[captionStream] = track;
	    } else {
	      // This section gets called when we have caption services that aren't specified in the manifest.
	      // Manifest level caption services are handled in media-groups.js under CLOSED-CAPTIONS.
	      var captionServices = tech.options_.vhs && tech.options_.vhs.captionServices || {};
	      var label = captionStream;
	      var language = captionStream;
	      var def = false;
	      var captionService = captionServices[instreamId];
	
	      if (captionService) {
	        label = captionService.label;
	        language = captionService.language;
	        def = captionService["default"];
	      } // Otherwise, create a track with the default `CC#` label and
	      // without a language
	
	
	      inbandTextTracks[captionStream] = tech.addRemoteTextTrack({
	        kind: 'captions',
	        id: instreamId,
	        // TODO: investigate why this doesn't seem to turn the caption on by default
	        "default": def,
	        label: label,
	        language: language
	      }, false).track;
	    }
	  }
	};
	/**
	 * Add caption text track data to a source handler given an array of captions
	 *
	 * @param {Object}
	 *   @param {Object} inbandTextTracks the inband text tracks
	 *   @param {number} timestampOffset the timestamp offset of the source buffer
	 *   @param {Array} captionArray an array of caption data
	 * @private
	 */
	
	
	var addCaptionData = function addCaptionData(_ref) {
	  var inbandTextTracks = _ref.inbandTextTracks,
	      captionArray = _ref.captionArray,
	      timestampOffset = _ref.timestampOffset;
	
	  if (!captionArray) {
	    return;
	  }
	
	  var Cue = window__default['default'].WebKitDataCue || window__default['default'].VTTCue;
	  captionArray.forEach(function (caption) {
	    var track = caption.stream;
	    inbandTextTracks[track].addCue(new Cue(caption.startTime + timestampOffset, caption.endTime + timestampOffset, caption.text));
	  });
	};
	/**
	 * Define properties on a cue for backwards compatability,
	 * but warn the user that the way that they are using it
	 * is depricated and will be removed at a later date.
	 *
	 * @param {Cue} cue the cue to add the properties on
	 * @private
	 */
	
	
	var deprecateOldCue = function deprecateOldCue(cue) {
	  Object.defineProperties(cue.frame, {
	    id: {
	      get: function get() {
	        videojs.log.warn('cue.frame.id is deprecated. Use cue.value.key instead.');
	        return cue.value.key;
	      }
	    },
	    value: {
	      get: function get() {
	        videojs.log.warn('cue.frame.value is deprecated. Use cue.value.data instead.');
	        return cue.value.data;
	      }
	    },
	    privateData: {
	      get: function get() {
	        videojs.log.warn('cue.frame.privateData is deprecated. Use cue.value.data instead.');
	        return cue.value.data;
	      }
	    }
	  });
	};
	/**
	 * Add metadata text track data to a source handler given an array of metadata
	 *
	 * @param {Object}
	 *   @param {Object} inbandTextTracks the inband text tracks
	 *   @param {Array} metadataArray an array of meta data
	 *   @param {number} timestampOffset the timestamp offset of the source buffer
	 *   @param {number} videoDuration the duration of the video
	 * @private
	 */
	
	
	var addMetadata = function addMetadata(_ref2) {
	  var inbandTextTracks = _ref2.inbandTextTracks,
	      metadataArray = _ref2.metadataArray,
	      timestampOffset = _ref2.timestampOffset,
	      videoDuration = _ref2.videoDuration;
	
	  if (!metadataArray) {
	    return;
	  }
	
	  var Cue = window__default['default'].WebKitDataCue || window__default['default'].VTTCue;
	  var metadataTrack = inbandTextTracks.metadataTrack_;
	
	  if (!metadataTrack) {
	    return;
	  }
	
	  metadataArray.forEach(function (metadata) {
	    var time = metadata.cueTime + timestampOffset; // if time isn't a finite number between 0 and Infinity, like NaN,
	    // ignore this bit of metadata.
	    // This likely occurs when you have an non-timed ID3 tag like TIT2,
	    // which is the "Title/Songname/Content description" frame
	
	    if (typeof time !== 'number' || window__default['default'].isNaN(time) || time < 0 || !(time < Infinity)) {
	      return;
	    }
	
	    metadata.frames.forEach(function (frame) {
	      var cue = new Cue(time, time, frame.value || frame.url || frame.data || '');
	      cue.frame = frame;
	      cue.value = frame;
	      deprecateOldCue(cue);
	      metadataTrack.addCue(cue);
	    });
	  });
	
	  if (!metadataTrack.cues || !metadataTrack.cues.length) {
	    return;
	  } // Updating the metadeta cues so that
	  // the endTime of each cue is the startTime of the next cue
	  // the endTime of last cue is the duration of the video
	
	
	  var cues = metadataTrack.cues;
	  var cuesArray = []; // Create a copy of the TextTrackCueList...
	  // ...disregarding cues with a falsey value
	
	  for (var i = 0; i < cues.length; i++) {
	    if (cues[i]) {
	      cuesArray.push(cues[i]);
	    }
	  } // Group cues by their startTime value
	
	
	  var cuesGroupedByStartTime = cuesArray.reduce(function (obj, cue) {
	    var timeSlot = obj[cue.startTime] || [];
	    timeSlot.push(cue);
	    obj[cue.startTime] = timeSlot;
	    return obj;
	  }, {}); // Sort startTimes by ascending order
	
	  var sortedStartTimes = Object.keys(cuesGroupedByStartTime).sort(function (a, b) {
	    return Number(a) - Number(b);
	  }); // Map each cue group's endTime to the next group's startTime
	
	  sortedStartTimes.forEach(function (startTime, idx) {
	    var cueGroup = cuesGroupedByStartTime[startTime];
	    var nextTime = Number(sortedStartTimes[idx + 1]) || videoDuration; // Map each cue's endTime the next group's startTime
	
	    cueGroup.forEach(function (cue) {
	      cue.endTime = nextTime;
	    });
	  });
	};
	/**
	 * Create metadata text track on video.js if it does not exist
	 *
	 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
	 * @param {string} dispatchType the inband metadata track dispatch type
	 * @param {Object} tech the video.js tech
	 * @private
	 */
	
	
	var createMetadataTrackIfNotExists = function createMetadataTrackIfNotExists(inbandTextTracks, dispatchType, tech) {
	  if (inbandTextTracks.metadataTrack_) {
	    return;
	  }
	
	  inbandTextTracks.metadataTrack_ = tech.addRemoteTextTrack({
	    kind: 'metadata',
	    label: 'Timed Metadata'
	  }, false).track;
	  inbandTextTracks.metadataTrack_.inBandMetadataTrackDispatchType = dispatchType;
	};
	/**
	 * Remove cues from a track on video.js.
	 *
	 * @param {Double} start start of where we should remove the cue
	 * @param {Double} end end of where the we should remove the cue
	 * @param {Object} track the text track to remove the cues from
	 * @private
	 */
	
	
	var removeCuesFromTrack = function removeCuesFromTrack(start, end, track) {
	  var i;
	  var cue;
	
	  if (!track) {
	    return;
	  }
	
	  if (!track.cues) {
	    return;
	  }
	
	  i = track.cues.length;
	
	  while (i--) {
	    cue = track.cues[i]; // Remove any cue within the provided start and end time
	
	    if (cue.startTime >= start && cue.endTime <= end) {
	      track.removeCue(cue);
	    }
	  }
	};
	/**
	 * Remove duplicate cues from a track on video.js (a cue is considered a
	 * duplicate if it has the same time interval and text as another)
	 *
	 * @param {Object} track the text track to remove the duplicate cues from
	 * @private
	 */
	
	
	var removeDuplicateCuesFromTrack = function removeDuplicateCuesFromTrack(track) {
	  var cues = track.cues;
	
	  if (!cues) {
	    return;
	  }
	
	  for (var i = 0; i < cues.length; i++) {
	    var duplicates = [];
	    var occurrences = 0;
	
	    for (var j = 0; j < cues.length; j++) {
	      if (cues[i].startTime === cues[j].startTime && cues[i].endTime === cues[j].endTime && cues[i].text === cues[j].text) {
	        occurrences++;
	
	        if (occurrences > 1) {
	          duplicates.push(cues[j]);
	        }
	      }
	    }
	
	    if (duplicates.length) {
	      duplicates.forEach(function (dupe) {
	        return track.removeCue(dupe);
	      });
	    }
	  }
	};
	/**
	 * Returns a list of gops in the buffer that have a pts value of 3 seconds or more in
	 * front of current time.
	 *
	 * @param {Array} buffer
	 *        The current buffer of gop information
	 * @param {number} currentTime
	 *        The current time
	 * @param {Double} mapping
	 *        Offset to map display time to stream presentation time
	 * @return {Array}
	 *         List of gops considered safe to append over
	 */
	
	
	var gopsSafeToAlignWith = function gopsSafeToAlignWith(buffer, currentTime, mapping) {
	  if (typeof currentTime === 'undefined' || currentTime === null || !buffer.length) {
	    return [];
	  } // pts value for current time + 3 seconds to give a bit more wiggle room
	
	
	  var currentTimePts = Math.ceil((currentTime - mapping + 3) * clock.ONE_SECOND_IN_TS);
	  var i;
	
	  for (i = 0; i < buffer.length; i++) {
	    if (buffer[i].pts > currentTimePts) {
	      break;
	    }
	  }
	
	  return buffer.slice(i);
	};
	/**
	 * Appends gop information (timing and byteLength) received by the transmuxer for the
	 * gops appended in the last call to appendBuffer
	 *
	 * @param {Array} buffer
	 *        The current buffer of gop information
	 * @param {Array} gops
	 *        List of new gop information
	 * @param {boolean} replace
	 *        If true, replace the buffer with the new gop information. If false, append the
	 *        new gop information to the buffer in the right location of time.
	 * @return {Array}
	 *         Updated list of gop information
	 */
	
	
	var updateGopBuffer = function updateGopBuffer(buffer, gops, replace) {
	  if (!gops.length) {
	    return buffer;
	  }
	
	  if (replace) {
	    // If we are in safe append mode, then completely overwrite the gop buffer
	    // with the most recent appeneded data. This will make sure that when appending
	    // future segments, we only try to align with gops that are both ahead of current
	    // time and in the last segment appended.
	    return gops.slice();
	  }
	
	  var start = gops[0].pts;
	  var i = 0;
	
	  for (i; i < buffer.length; i++) {
	    if (buffer[i].pts >= start) {
	      break;
	    }
	  }
	
	  return buffer.slice(0, i).concat(gops);
	};
	/**
	 * Removes gop information in buffer that overlaps with provided start and end
	 *
	 * @param {Array} buffer
	 *        The current buffer of gop information
	 * @param {Double} start
	 *        position to start the remove at
	 * @param {Double} end
	 *        position to end the remove at
	 * @param {Double} mapping
	 *        Offset to map display time to stream presentation time
	 */
	
	
	var removeGopBuffer = function removeGopBuffer(buffer, start, end, mapping) {
	  var startPts = Math.ceil((start - mapping) * clock.ONE_SECOND_IN_TS);
	  var endPts = Math.ceil((end - mapping) * clock.ONE_SECOND_IN_TS);
	  var updatedBuffer = buffer.slice();
	  var i = buffer.length;
	
	  while (i--) {
	    if (buffer[i].pts <= endPts) {
	      break;
	    }
	  }
	
	  if (i === -1) {
	    // no removal because end of remove range is before start of buffer
	    return updatedBuffer;
	  }
	
	  var j = i + 1;
	
	  while (j--) {
	    if (buffer[j].pts <= startPts) {
	      break;
	    }
	  } // clamp remove range start to 0 index
	
	
	  j = Math.max(j, 0);
	  updatedBuffer.splice(j, i - j + 1);
	  return updatedBuffer;
	};
	
	var shallowEqual = function shallowEqual(a, b) {
	  // if both are undefined
	  // or one or the other is undefined
	  // they are not equal
	  if (!a && !b || !a && b || a && !b) {
	    return false;
	  } // they are the same object and thus, equal
	
	
	  if (a === b) {
	    return true;
	  } // sort keys so we can make sure they have
	  // all the same keys later.
	
	
	  var akeys = Object.keys(a).sort();
	  var bkeys = Object.keys(b).sort(); // different number of keys, not equal
	
	  if (akeys.length !== bkeys.length) {
	    return false;
	  }
	
	  for (var i = 0; i < akeys.length; i++) {
	    var key = akeys[i]; // different sorted keys, not equal
	
	    if (key !== bkeys[i]) {
	      return false;
	    } // different values, not equal
	
	
	    if (a[key] !== b[key]) {
	      return false;
	    }
	  }
	
	  return true;
	}; // https://www.w3.org/TR/WebIDL-1/#quotaexceedederror
	
	
	var QUOTA_EXCEEDED_ERR = 22;
	/**
	 * The segment loader has no recourse except to fetch a segment in the
	 * current playlist and use the internal timestamps in that segment to
	 * generate a syncPoint. This function returns a good candidate index
	 * for that process.
	 *
	 * @param {Array} segments - the segments array from a playlist.
	 * @return {number} An index of a segment from the playlist to load
	 */
	
	var getSyncSegmentCandidate = function getSyncSegmentCandidate(currentTimeline, segments, targetTime) {
	  segments = segments || [];
	  var timelineSegments = [];
	  var time = 0;
	
	  for (var i = 0; i < segments.length; i++) {
	    var segment = segments[i];
	
	    if (currentTimeline === segment.timeline) {
	      timelineSegments.push(i);
	      time += segment.duration;
	
	      if (time > targetTime) {
	        return i;
	      }
	    }
	  }
	
	  if (timelineSegments.length === 0) {
	    return 0;
	  } // default to the last timeline segment
	
	
	  return timelineSegments[timelineSegments.length - 1];
	}; // In the event of a quota exceeded error, keep at least one second of back buffer. This
	// number was arbitrarily chosen and may be updated in the future, but seemed reasonable
	// as a start to prevent any potential issues with removing content too close to the
	// playhead.
	
	
	var MIN_BACK_BUFFER = 1; // in ms
	
	var CHECK_BUFFER_DELAY = 500;
	
	var finite = function finite(num) {
	  return typeof num === 'number' && isFinite(num);
	}; // With most content hovering around 30fps, if a segment has a duration less than a half
	// frame at 30fps or one frame at 60fps, the bandwidth and throughput calculations will
	// not accurately reflect the rest of the content.
	
	
	var MIN_SEGMENT_DURATION_TO_SAVE_STATS = 1 / 60;
	
	var illegalMediaSwitch = function illegalMediaSwitch(loaderType, startingMedia, trackInfo) {
	  // Although these checks should most likely cover non 'main' types, for now it narrows
	  // the scope of our checks.
	  if (loaderType !== 'main' || !startingMedia || !trackInfo) {
	    return null;
	  }
	
	  if (!trackInfo.hasAudio && !trackInfo.hasVideo) {
	    return 'Neither audio nor video found in segment.';
	  }
	
	  if (startingMedia.hasVideo && !trackInfo.hasVideo) {
	    return 'Only audio found in segment when we expected video.' + ' We can\'t switch to audio only from a stream that had video.' + ' To get rid of this message, please add codec information to the manifest.';
	  }
	
	  if (!startingMedia.hasVideo && trackInfo.hasVideo) {
	    return 'Video found in segment when we expected only audio.' + ' We can\'t switch to a stream with video from an audio only stream.' + ' To get rid of this message, please add codec information to the manifest.';
	  }
	
	  return null;
	};
	/**
	 * Calculates a time value that is safe to remove from the back buffer without interrupting
	 * playback.
	 *
	 * @param {TimeRange} seekable
	 *        The current seekable range
	 * @param {number} currentTime
	 *        The current time of the player
	 * @param {number} targetDuration
	 *        The target duration of the current playlist
	 * @return {number}
	 *         Time that is safe to remove from the back buffer without interrupting playback
	 */
	
	
	var safeBackBufferTrimTime = function safeBackBufferTrimTime(seekable, currentTime, targetDuration) {
	  // 30 seconds before the playhead provides a safe default for trimming.
	  //
	  // Choosing a reasonable default is particularly important for high bitrate content and
	  // VOD videos/live streams with large windows, as the buffer may end up overfilled and
	  // throw an APPEND_BUFFER_ERR.
	  var trimTime = currentTime - Config.BACK_BUFFER_LENGTH;
	
	  if (seekable.length) {
	    // Some live playlists may have a shorter window of content than the full allowed back
	    // buffer. For these playlists, don't save content that's no longer within the window.
	    trimTime = Math.max(trimTime, seekable.start(0));
	  } // Don't remove within target duration of the current time to avoid the possibility of
	  // removing the GOP currently being played, as removing it can cause playback stalls.
	
	
	  var maxTrimTime = currentTime - targetDuration;
	  return Math.min(maxTrimTime, trimTime);
	};
	
	var segmentInfoString = function segmentInfoString(segmentInfo) {
	  var startOfSegment = segmentInfo.startOfSegment,
	      duration = segmentInfo.duration,
	      segment = segmentInfo.segment,
	      part = segmentInfo.part,
	      _segmentInfo$playlist = segmentInfo.playlist,
	      seq = _segmentInfo$playlist.mediaSequence,
	      id = _segmentInfo$playlist.id,
	      _segmentInfo$playlist2 = _segmentInfo$playlist.segments,
	      segments = _segmentInfo$playlist2 === void 0 ? [] : _segmentInfo$playlist2,
	      index = segmentInfo.mediaIndex,
	      partIndex = segmentInfo.partIndex,
	      timeline = segmentInfo.timeline;
	  var segmentLen = segments.length - 1;
	  var selection = 'mediaIndex/partIndex increment';
	
	  if (segmentInfo.getMediaInfoForTime) {
	    selection = "getMediaInfoForTime (" + segmentInfo.getMediaInfoForTime + ")";
	  } else if (segmentInfo.isSyncRequest) {
	    selection = 'getSyncSegmentCandidate (isSyncRequest)';
	  }
	
	  if (segmentInfo.independent) {
	    selection += " with independent " + segmentInfo.independent;
	  }
	
	  var hasPartIndex = typeof partIndex === 'number';
	  var name = segmentInfo.segment.uri ? 'segment' : 'pre-segment';
	  var zeroBasedPartCount = hasPartIndex ? getKnownPartCount({
	    preloadSegment: segment
	  }) - 1 : 0;
	  return name + " [" + (seq + index) + "/" + (seq + segmentLen) + "]" + (hasPartIndex ? " part [" + partIndex + "/" + zeroBasedPartCount + "]" : '') + (" segment start/end [" + segment.start + " => " + segment.end + "]") + (hasPartIndex ? " part start/end [" + part.start + " => " + part.end + "]" : '') + (" startOfSegment [" + startOfSegment + "]") + (" duration [" + duration + "]") + (" timeline [" + timeline + "]") + (" selected by [" + selection + "]") + (" playlist [" + id + "]");
	};
	
	var timingInfoPropertyForMedia = function timingInfoPropertyForMedia(mediaType) {
	  return mediaType + "TimingInfo";
	};
	/**
	 * Returns the timestamp offset to use for the segment.
	 *
	 * @param {number} segmentTimeline
	 *        The timeline of the segment
	 * @param {number} currentTimeline
	 *        The timeline currently being followed by the loader
	 * @param {number} startOfSegment
	 *        The estimated segment start
	 * @param {TimeRange[]} buffered
	 *        The loader's buffer
	 * @param {boolean} overrideCheck
	 *        If true, no checks are made to see if the timestamp offset value should be set,
	 *        but sets it directly to a value.
	 *
	 * @return {number|null}
	 *         Either a number representing a new timestamp offset, or null if the segment is
	 *         part of the same timeline
	 */
	
	
	var timestampOffsetForSegment = function timestampOffsetForSegment(_ref) {
	  var segmentTimeline = _ref.segmentTimeline,
	      currentTimeline = _ref.currentTimeline,
	      startOfSegment = _ref.startOfSegment,
	      buffered = _ref.buffered,
	      overrideCheck = _ref.overrideCheck; // Check to see if we are crossing a discontinuity to see if we need to set the
	  // timestamp offset on the transmuxer and source buffer.
	  //
	  // Previously, we changed the timestampOffset if the start of this segment was less than
	  // the currently set timestampOffset, but this isn't desirable as it can produce bad
	  // behavior, especially around long running live streams.
	
	  if (!overrideCheck && segmentTimeline === currentTimeline) {
	    return null;
	  } // When changing renditions, it's possible to request a segment on an older timeline. For
	  // instance, given two renditions with the following:
	  //
	  // #EXTINF:10
	  // segment1
	  // #EXT-X-DISCONTINUITY
	  // #EXTINF:10
	  // segment2
	  // #EXTINF:10
	  // segment3
	  //
	  // And the current player state:
	  //
	  // current time: 8
	  // buffer: 0 => 20
	  //
	  // The next segment on the current rendition would be segment3, filling the buffer from
	  // 20s onwards. However, if a rendition switch happens after segment2 was requested,
	  // then the next segment to be requested will be segment1 from the new rendition in
	  // order to fill time 8 and onwards. Using the buffered end would result in repeated
	  // content (since it would position segment1 of the new rendition starting at 20s). This
	  // case can be identified when the new segment's timeline is a prior value. Instead of
	  // using the buffered end, the startOfSegment can be used, which, hopefully, will be
	  // more accurate to the actual start time of the segment.
	
	
	  if (segmentTimeline < currentTimeline) {
	    return startOfSegment;
	  } // segmentInfo.startOfSegment used to be used as the timestamp offset, however, that
	  // value uses the end of the last segment if it is available. While this value
	  // should often be correct, it's better to rely on the buffered end, as the new
	  // content post discontinuity should line up with the buffered end as if it were
	  // time 0 for the new content.
	
	
	  return buffered.length ? buffered.end(buffered.length - 1) : startOfSegment;
	};
	/**
	 * Returns whether or not the loader should wait for a timeline change from the timeline
	 * change controller before processing the segment.
	 *
	 * Primary timing in VHS goes by video. This is different from most media players, as
	 * audio is more often used as the primary timing source. For the foreseeable future, VHS
	 * will continue to use video as the primary timing source, due to the current logic and
	 * expectations built around it.
	
	 * Since the timing follows video, in order to maintain sync, the video loader is
	 * responsible for setting both audio and video source buffer timestamp offsets.
	 *
	 * Setting different values for audio and video source buffers could lead to
	 * desyncing. The following examples demonstrate some of the situations where this
	 * distinction is important. Note that all of these cases involve demuxed content. When
	 * content is muxed, the audio and video are packaged together, therefore syncing
	 * separate media playlists is not an issue.
	 *
	 * CASE 1: Audio prepares to load a new timeline before video:
	 *
	 * Timeline:       0                 1
	 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Audio Loader:                     ^
	 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Video Loader              ^
	 *
	 * In the above example, the audio loader is preparing to load the 6th segment, the first
	 * after a discontinuity, while the video loader is still loading the 5th segment, before
	 * the discontinuity.
	 *
	 * If the audio loader goes ahead and loads and appends the 6th segment before the video
	 * loader crosses the discontinuity, then when appended, the 6th audio segment will use
	 * the timestamp offset from timeline 0. This will likely lead to desyncing. In addition,
	 * the audio loader must provide the audioAppendStart value to trim the content in the
	 * transmuxer, and that value relies on the audio timestamp offset. Since the audio
	 * timestamp offset is set by the video (main) loader, the audio loader shouldn't load the
	 * segment until that value is provided.
	 *
	 * CASE 2: Video prepares to load a new timeline before audio:
	 *
	 * Timeline:       0                 1
	 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Audio Loader:             ^
	 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Video Loader                      ^
	 *
	 * In the above example, the video loader is preparing to load the 6th segment, the first
	 * after a discontinuity, while the audio loader is still loading the 5th segment, before
	 * the discontinuity.
	 *
	 * If the video loader goes ahead and loads and appends the 6th segment, then once the
	 * segment is loaded and processed, both the video and audio timestamp offsets will be
	 * set, since video is used as the primary timing source. This is to ensure content lines
	 * up appropriately, as any modifications to the video timing are reflected by audio when
	 * the video loader sets the audio and video timestamp offsets to the same value. However,
	 * setting the timestamp offset for audio before audio has had a chance to change
	 * timelines will likely lead to desyncing, as the audio loader will append segment 5 with
	 * a timestamp intended to apply to segments from timeline 1 rather than timeline 0.
	 *
	 * CASE 3: When seeking, audio prepares to load a new timeline before video
	 *
	 * Timeline:       0                 1
	 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Audio Loader:           ^
	 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Video Loader            ^
	 *
	 * In the above example, both audio and video loaders are loading segments from timeline
	 * 0, but imagine that the seek originated from timeline 1.
	 *
	 * When seeking to a new timeline, the timestamp offset will be set based on the expected
	 * segment start of the loaded video segment. In order to maintain sync, the audio loader
	 * must wait for the video loader to load its segment and update both the audio and video
	 * timestamp offsets before it may load and append its own segment. This is the case
	 * whether the seek results in a mismatched segment request (e.g., the audio loader
	 * chooses to load segment 3 and the video loader chooses to load segment 4) or the
	 * loaders choose to load the same segment index from each playlist, as the segments may
	 * not be aligned perfectly, even for matching segment indexes.
	 *
	 * @param {Object} timelinechangeController
	 * @param {number} currentTimeline
	 *        The timeline currently being followed by the loader
	 * @param {number} segmentTimeline
	 *        The timeline of the segment being loaded
	 * @param {('main'|'audio')} loaderType
	 *        The loader type
	 * @param {boolean} audioDisabled
	 *        Whether the audio is disabled for the loader. This should only be true when the
	 *        loader may have muxed audio in its segment, but should not append it, e.g., for
	 *        the main loader when an alternate audio playlist is active.
	 *
	 * @return {boolean}
	 *         Whether the loader should wait for a timeline change from the timeline change
	 *         controller before processing the segment
	 */
	
	
	var shouldWaitForTimelineChange = function shouldWaitForTimelineChange(_ref2) {
	  var timelineChangeController = _ref2.timelineChangeController,
	      currentTimeline = _ref2.currentTimeline,
	      segmentTimeline = _ref2.segmentTimeline,
	      loaderType = _ref2.loaderType,
	      audioDisabled = _ref2.audioDisabled;
	
	  if (currentTimeline === segmentTimeline) {
	    return false;
	  }
	
	  if (loaderType === 'audio') {
	    var lastMainTimelineChange = timelineChangeController.lastTimelineChange({
	      type: 'main'
	    }); // Audio loader should wait if:
	    //
	    // * main hasn't had a timeline change yet (thus has not loaded its first segment)
	    // * main hasn't yet changed to the timeline audio is looking to load
	
	    return !lastMainTimelineChange || lastMainTimelineChange.to !== segmentTimeline;
	  } // The main loader only needs to wait for timeline changes if there's demuxed audio.
	  // Otherwise, there's nothing to wait for, since audio would be muxed into the main
	  // loader's segments (or the content is audio/video only and handled by the main
	  // loader).
	
	
	  if (loaderType === 'main' && audioDisabled) {
	    var pendingAudioTimelineChange = timelineChangeController.pendingTimelineChange({
	      type: 'audio'
	    }); // Main loader should wait for the audio loader if audio is not pending a timeline
	    // change to the current timeline.
	    //
	    // Since the main loader is responsible for setting the timestamp offset for both
	    // audio and video, the main loader must wait for audio to be about to change to its
	    // timeline before setting the offset, otherwise, if audio is behind in loading,
	    // segments from the previous timeline would be adjusted by the new timestamp offset.
	    //
	    // This requirement means that video will not cross a timeline until the audio is
	    // about to cross to it, so that way audio and video will always cross the timeline
	    // together.
	    //
	    // In addition to normal timeline changes, these rules also apply to the start of a
	    // stream (going from a non-existent timeline, -1, to timeline 0). It's important
	    // that these rules apply to the first timeline change because if they did not, it's
	    // possible that the main loader will cross two timelines before the audio loader has
	    // crossed one. Logic may be implemented to handle the startup as a special case, but
	    // it's easier to simply treat all timeline changes the same.
	
	    if (pendingAudioTimelineChange && pendingAudioTimelineChange.to === segmentTimeline) {
	      return false;
	    }
	
	    return true;
	  }
	
	  return false;
	};
	
	var mediaDuration = function mediaDuration(timingInfos) {
	  var maxDuration = 0;
	  ['video', 'audio'].forEach(function (type) {
	    var typeTimingInfo = timingInfos[type + "TimingInfo"];
	
	    if (!typeTimingInfo) {
	      return;
	    }
	
	    var start = typeTimingInfo.start,
	        end = typeTimingInfo.end;
	    var duration;
	
	    if (typeof start === 'bigint' || typeof end === 'bigint') {
	      duration = window__default['default'].BigInt(end) - window__default['default'].BigInt(start);
	    } else if (typeof start === 'number' && typeof end === 'number') {
	      duration = end - start;
	    }
	
	    if (typeof duration !== 'undefined' && duration > maxDuration) {
	      maxDuration = duration;
	    }
	  }); // convert back to a number if it is lower than MAX_SAFE_INTEGER
	  // as we only need BigInt when we are above that.
	
	  if (typeof maxDuration === 'bigint' && maxDuration < Number.MAX_SAFE_INTEGER) {
	    maxDuration = Number(maxDuration);
	  }
	
	  return maxDuration;
	};
	
	var segmentTooLong = function segmentTooLong(_ref3) {
	  var segmentDuration = _ref3.segmentDuration,
	      maxDuration = _ref3.maxDuration; // 0 duration segments are most likely due to metadata only segments or a lack of
	  // information.
	
	  if (!segmentDuration) {
	    return false;
	  } // For HLS:
	  //
	  // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1
	  // The EXTINF duration of each Media Segment in the Playlist
	  // file, when rounded to the nearest integer, MUST be less than or equal
	  // to the target duration; longer segments can trigger playback stalls
	  // or other errors.
	  //
	  // For DASH, the mpd-parser uses the largest reported segment duration as the target
	  // duration. Although that reported duration is occasionally approximate (i.e., not
	  // exact), a strict check may report that a segment is too long more often in DASH.
	
	
	  return Math.round(segmentDuration) > maxDuration + TIME_FUDGE_FACTOR;
	};
	
	var getTroublesomeSegmentDurationMessage = function getTroublesomeSegmentDurationMessage(segmentInfo, sourceType) {
	  // Right now we aren't following DASH's timing model exactly, so only perform
	  // this check for HLS content.
	  if (sourceType !== 'hls') {
	    return null;
	  }
	
	  var segmentDuration = mediaDuration({
	    audioTimingInfo: segmentInfo.audioTimingInfo,
	    videoTimingInfo: segmentInfo.videoTimingInfo
	  }); // Don't report if we lack information.
	  //
	  // If the segment has a duration of 0 it is either a lack of information or a
	  // metadata only segment and shouldn't be reported here.
	
	  if (!segmentDuration) {
	    return null;
	  }
	
	  var targetDuration = segmentInfo.playlist.targetDuration;
	  var isSegmentWayTooLong = segmentTooLong({
	    segmentDuration: segmentDuration,
	    maxDuration: targetDuration * 2
	  });
	  var isSegmentSlightlyTooLong = segmentTooLong({
	    segmentDuration: segmentDuration,
	    maxDuration: targetDuration
	  });
	  var segmentTooLongMessage = "Segment with index " + segmentInfo.mediaIndex + " " + ("from playlist " + segmentInfo.playlist.id + " ") + ("has a duration of " + segmentDuration + " ") + ("when the reported duration is " + segmentInfo.duration + " ") + ("and the target duration is " + targetDuration + ". ") + 'For HLS content, a duration in excess of the target duration may result in ' + 'playback issues. See the HLS specification section on EXT-X-TARGETDURATION for ' + 'more details: ' + 'https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1';
	
	  if (isSegmentWayTooLong || isSegmentSlightlyTooLong) {
	    return {
	      severity: isSegmentWayTooLong ? 'warn' : 'info',
	      message: segmentTooLongMessage
	    };
	  }
	
	  return null;
	};
	/**
	 * An object that manages segment loading and appending.
	 *
	 * @class SegmentLoader
	 * @param {Object} options required and optional options
	 * @extends videojs.EventTarget
	 */
	
	
	var SegmentLoader = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](SegmentLoader, _videojs$EventTarget);
	
	  function SegmentLoader(settings, options) {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this; // check pre-conditions
	
	    if (!settings) {
	      throw new TypeError('Initialization settings are required');
	    }
	
	    if (typeof settings.currentTime !== 'function') {
	      throw new TypeError('No currentTime getter specified');
	    }
	
	    if (!settings.mediaSource) {
	      throw new TypeError('No MediaSource specified');
	    } // public properties
	
	
	    _this.bandwidth = settings.bandwidth;
	    _this.throughput = {
	      rate: 0,
	      count: 0
	    };
	    _this.roundTrip = NaN;
	
	    _this.resetStats_();
	
	    _this.mediaIndex = null;
	    _this.partIndex = null; // private settings
	
	    _this.hasPlayed_ = settings.hasPlayed;
	    _this.currentTime_ = settings.currentTime;
	    _this.seekable_ = settings.seekable;
	    _this.seeking_ = settings.seeking;
	    _this.duration_ = settings.duration;
	    _this.mediaSource_ = settings.mediaSource;
	    _this.vhs_ = settings.vhs;
	    _this.loaderType_ = settings.loaderType;
	    _this.currentMediaInfo_ = void 0;
	    _this.startingMediaInfo_ = void 0;
	    _this.segmentMetadataTrack_ = settings.segmentMetadataTrack;
	    _this.goalBufferLength_ = settings.goalBufferLength;
	    _this.sourceType_ = settings.sourceType;
	    _this.sourceUpdater_ = settings.sourceUpdater;
	    _this.inbandTextTracks_ = settings.inbandTextTracks;
	    _this.state_ = 'INIT';
	    _this.timelineChangeController_ = settings.timelineChangeController;
	    _this.shouldSaveSegmentTimingInfo_ = true;
	    _this.parse708captions_ = settings.parse708captions;
	    _this.useDtsForTimestampOffset_ = settings.useDtsForTimestampOffset;
	    _this.captionServices_ = settings.captionServices;
	    _this.experimentalExactManifestTimings = settings.experimentalExactManifestTimings; // private instance variables
	
	    _this.checkBufferTimeout_ = null;
	    _this.error_ = void 0;
	    _this.currentTimeline_ = -1;
	    _this.pendingSegment_ = null;
	    _this.xhrOptions_ = null;
	    _this.pendingSegments_ = [];
	    _this.audioDisabled_ = false;
	    _this.isPendingTimestampOffset_ = false; // TODO possibly move gopBuffer and timeMapping info to a separate controller
	
	    _this.gopBuffer_ = [];
	    _this.timeMapping_ = 0;
	    _this.safeAppend_ = videojs.browser.IE_VERSION >= 11;
	    _this.appendInitSegment_ = {
	      audio: true,
	      video: true
	    };
	    _this.playlistOfLastInitSegment_ = {
	      audio: null,
	      video: null
	    };
	    _this.callQueue_ = []; // If the segment loader prepares to load a segment, but does not have enough
	    // information yet to start the loading process (e.g., if the audio loader wants to
	    // load a segment from the next timeline but the main loader hasn't yet crossed that
	    // timeline), then the load call will be added to the queue until it is ready to be
	    // processed.
	
	    _this.loadQueue_ = [];
	    _this.metadataQueue_ = {
	      id3: [],
	      caption: []
	    };
	    _this.waitingOnRemove_ = false;
	    _this.quotaExceededErrorRetryTimeout_ = null; // Fragmented mp4 playback
	
	    _this.activeInitSegmentId_ = null;
	    _this.initSegments_ = {}; // HLSe playback
	
	    _this.cacheEncryptionKeys_ = settings.cacheEncryptionKeys;
	    _this.keyCache_ = {};
	    _this.decrypter_ = settings.decrypter; // Manages the tracking and generation of sync-points, mappings
	    // between a time in the display time and a segment index within
	    // a playlist
	
	    _this.syncController_ = settings.syncController;
	    _this.syncPoint_ = {
	      segmentIndex: 0,
	      time: 0
	    };
	    _this.transmuxer_ = _this.createTransmuxer_();
	
	    _this.triggerSyncInfoUpdate_ = function () {
	      return _this.trigger('syncinfoupdate');
	    };
	
	    _this.syncController_.on('syncinfoupdate', _this.triggerSyncInfoUpdate_);
	
	    _this.mediaSource_.addEventListener('sourceopen', function () {
	      if (!_this.isEndOfStream_()) {
	        _this.ended_ = false;
	      }
	    }); // ...for determining the fetch location
	
	
	    _this.fetchAtBuffer_ = false;
	    _this.logger_ = logger("SegmentLoader[" + _this.loaderType_ + "]");
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'state', {
	      get: function get() {
	        return this.state_;
	      },
	      set: function set(newState) {
	        if (newState !== this.state_) {
	          this.logger_(this.state_ + " -> " + newState);
	          this.state_ = newState;
	          this.trigger('statechange');
	        }
	      }
	    });
	
	    _this.sourceUpdater_.on('ready', function () {
	      if (_this.hasEnoughInfoToAppend_()) {
	        _this.processCallQueue_();
	      }
	    }); // Only the main loader needs to listen for pending timeline changes, as the main
	    // loader should wait for audio to be ready to change its timeline so that both main
	    // and audio timelines change together. For more details, see the
	    // shouldWaitForTimelineChange function.
	
	
	    if (_this.loaderType_ === 'main') {
	      _this.timelineChangeController_.on('pendingtimelinechange', function () {
	        if (_this.hasEnoughInfoToAppend_()) {
	          _this.processCallQueue_();
	        }
	      });
	    } // The main loader only listens on pending timeline changes, but the audio loader,
	    // since its loads follow main, needs to listen on timeline changes. For more details,
	    // see the shouldWaitForTimelineChange function.
	
	
	    if (_this.loaderType_ === 'audio') {
	      _this.timelineChangeController_.on('timelinechange', function () {
	        if (_this.hasEnoughInfoToLoad_()) {
	          _this.processLoadQueue_();
	        }
	
	        if (_this.hasEnoughInfoToAppend_()) {
	          _this.processCallQueue_();
	        }
	      });
	    }
	
	    return _this;
	  }
	
	  var _proto = SegmentLoader.prototype;
	
	  _proto.createTransmuxer_ = function createTransmuxer_() {
	    return segmentTransmuxer.createTransmuxer({
	      remux: false,
	      alignGopsAtEnd: this.safeAppend_,
	      keepOriginalTimestamps: true,
	      parse708captions: this.parse708captions_,
	      captionServices: this.captionServices_
	    });
	  }
	  /**
	   * reset all of our media stats
	   *
	   * @private
	   */
	  ;
	
	  _proto.resetStats_ = function resetStats_() {
	    this.mediaBytesTransferred = 0;
	    this.mediaRequests = 0;
	    this.mediaRequestsAborted = 0;
	    this.mediaRequestsTimedout = 0;
	    this.mediaRequestsErrored = 0;
	    this.mediaTransferDuration = 0;
	    this.mediaSecondsLoaded = 0;
	    this.mediaAppends = 0;
	  }
	  /**
	   * dispose of the SegmentLoader and reset to the default state
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.state = 'DISPOSED';
	    this.pause();
	    this.abort_();
	
	    if (this.transmuxer_) {
	      this.transmuxer_.terminate();
	    }
	
	    this.resetStats_();
	
	    if (this.checkBufferTimeout_) {
	      window__default['default'].clearTimeout(this.checkBufferTimeout_);
	    }
	
	    if (this.syncController_ && this.triggerSyncInfoUpdate_) {
	      this.syncController_.off('syncinfoupdate', this.triggerSyncInfoUpdate_);
	    }
	
	    this.off();
	  };
	
	  _proto.setAudio = function setAudio(enable) {
	    this.audioDisabled_ = !enable;
	
	    if (enable) {
	      this.appendInitSegment_.audio = true;
	    } else {
	      // remove current track audio if it gets disabled
	      this.sourceUpdater_.removeAudio(0, this.duration_());
	    }
	  }
	  /**
	   * abort anything that is currently doing on with the SegmentLoader
	   * and reset to a default state
	   */
	  ;
	
	  _proto.abort = function abort() {
	    if (this.state !== 'WAITING') {
	      if (this.pendingSegment_) {
	        this.pendingSegment_ = null;
	      }
	
	      return;
	    }
	
	    this.abort_(); // We aborted the requests we were waiting on, so reset the loader's state to READY
	    // since we are no longer "waiting" on any requests. XHR callback is not always run
	    // when the request is aborted. This will prevent the loader from being stuck in the
	    // WAITING state indefinitely.
	
	    this.state = 'READY'; // don't wait for buffer check timeouts to begin fetching the
	    // next segment
	
	    if (!this.paused()) {
	      this.monitorBuffer_();
	    }
	  }
	  /**
	   * abort all pending xhr requests and null any pending segements
	   *
	   * @private
	   */
	  ;
	
	  _proto.abort_ = function abort_() {
	    if (this.pendingSegment_ && this.pendingSegment_.abortRequests) {
	      this.pendingSegment_.abortRequests();
	    } // clear out the segment being processed
	
	
	    this.pendingSegment_ = null;
	    this.callQueue_ = [];
	    this.loadQueue_ = [];
	    this.metadataQueue_.id3 = [];
	    this.metadataQueue_.caption = [];
	    this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
	    this.waitingOnRemove_ = false;
	    window__default['default'].clearTimeout(this.quotaExceededErrorRetryTimeout_);
	    this.quotaExceededErrorRetryTimeout_ = null;
	  };
	
	  _proto.checkForAbort_ = function checkForAbort_(requestId) {
	    // If the state is APPENDING, then aborts will not modify the state, meaning the first
	    // callback that happens should reset the state to READY so that loading can continue.
	    if (this.state === 'APPENDING' && !this.pendingSegment_) {
	      this.state = 'READY';
	      return true;
	    }
	
	    if (!this.pendingSegment_ || this.pendingSegment_.requestId !== requestId) {
	      return true;
	    }
	
	    return false;
	  }
	  /**
	   * set an error on the segment loader and null out any pending segements
	   *
	   * @param {Error} error the error to set on the SegmentLoader
	   * @return {Error} the error that was set or that is currently set
	   */
	  ;
	
	  _proto.error = function error(_error) {
	    if (typeof _error !== 'undefined') {
	      this.logger_('error occurred:', _error);
	      this.error_ = _error;
	    }
	
	    this.pendingSegment_ = null;
	    return this.error_;
	  };
	
	  _proto.endOfStream = function endOfStream() {
	    this.ended_ = true;
	
	    if (this.transmuxer_) {
	      // need to clear out any cached data to prepare for the new segment
	      segmentTransmuxer.reset(this.transmuxer_);
	    }
	
	    this.gopBuffer_.length = 0;
	    this.pause();
	    this.trigger('ended');
	  }
	  /**
	   * Indicates which time ranges are buffered
	   *
	   * @return {TimeRange}
	   *         TimeRange object representing the current buffered ranges
	   */
	  ;
	
	  _proto.buffered_ = function buffered_() {
	    var trackInfo = this.getMediaInfo_();
	
	    if (!this.sourceUpdater_ || !trackInfo) {
	      return videojs.createTimeRanges();
	    }
	
	    if (this.loaderType_ === 'main') {
	      var hasAudio = trackInfo.hasAudio,
	          hasVideo = trackInfo.hasVideo,
	          isMuxed = trackInfo.isMuxed;
	
	      if (hasVideo && hasAudio && !this.audioDisabled_ && !isMuxed) {
	        return this.sourceUpdater_.buffered();
	      }
	
	      if (hasVideo) {
	        return this.sourceUpdater_.videoBuffered();
	      }
	    } // One case that can be ignored for now is audio only with alt audio,
	    // as we don't yet have proper support for that.
	
	
	    return this.sourceUpdater_.audioBuffered();
	  }
	  /**
	   * Gets and sets init segment for the provided map
	   *
	   * @param {Object} map
	   *        The map object representing the init segment to get or set
	   * @param {boolean=} set
	   *        If true, the init segment for the provided map should be saved
	   * @return {Object}
	   *         map object for desired init segment
	   */
	  ;
	
	  _proto.initSegmentForMap = function initSegmentForMap(map, set) {
	    if (set === void 0) {
	      set = false;
	    }
	
	    if (!map) {
	      return null;
	    }
	
	    var id = initSegmentId(map);
	    var storedMap = this.initSegments_[id];
	
	    if (set && !storedMap && map.bytes) {
	      this.initSegments_[id] = storedMap = {
	        resolvedUri: map.resolvedUri,
	        byterange: map.byterange,
	        bytes: map.bytes,
	        tracks: map.tracks,
	        timescales: map.timescales
	      };
	    }
	
	    return storedMap || map;
	  }
	  /**
	   * Gets and sets key for the provided key
	   *
	   * @param {Object} key
	   *        The key object representing the key to get or set
	   * @param {boolean=} set
	   *        If true, the key for the provided key should be saved
	   * @return {Object}
	   *         Key object for desired key
	   */
	  ;
	
	  _proto.segmentKey = function segmentKey(key, set) {
	    if (set === void 0) {
	      set = false;
	    }
	
	    if (!key) {
	      return null;
	    }
	
	    var id = segmentKeyId(key);
	    var storedKey = this.keyCache_[id]; // TODO: We should use the HTTP Expires header to invalidate our cache per
	    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-6.2.3
	
	    if (this.cacheEncryptionKeys_ && set && !storedKey && key.bytes) {
	      this.keyCache_[id] = storedKey = {
	        resolvedUri: key.resolvedUri,
	        bytes: key.bytes
	      };
	    }
	
	    var result = {
	      resolvedUri: (storedKey || key).resolvedUri
	    };
	
	    if (storedKey) {
	      result.bytes = storedKey.bytes;
	    }
	
	    return result;
	  }
	  /**
	   * Returns true if all configuration required for loading is present, otherwise false.
	   *
	   * @return {boolean} True if the all configuration is ready for loading
	   * @private
	   */
	  ;
	
	  _proto.couldBeginLoading_ = function couldBeginLoading_() {
	    return this.playlist_ && !this.paused();
	  }
	  /**
	   * load a playlist and start to fill the buffer
	   */
	  ;
	
	  _proto.load = function load() {
	    // un-pause
	    this.monitorBuffer_(); // if we don't have a playlist yet, keep waiting for one to be
	    // specified
	
	    if (!this.playlist_) {
	      return;
	    } // if all the configuration is ready, initialize and begin loading
	
	
	    if (this.state === 'INIT' && this.couldBeginLoading_()) {
	      return this.init_();
	    } // if we're in the middle of processing a segment already, don't
	    // kick off an additional segment request
	
	
	    if (!this.couldBeginLoading_() || this.state !== 'READY' && this.state !== 'INIT') {
	      return;
	    }
	
	    this.state = 'READY';
	  }
	  /**
	   * Once all the starting parameters have been specified, begin
	   * operation. This method should only be invoked from the INIT
	   * state.
	   *
	   * @private
	   */
	  ;
	
	  _proto.init_ = function init_() {
	    this.state = 'READY'; // if this is the audio segment loader, and it hasn't been inited before, then any old
	    // audio data from the muxed content should be removed
	
	    this.resetEverything();
	    return this.monitorBuffer_();
	  }
	  /**
	   * set a playlist on the segment loader
	   *
	   * @param {PlaylistLoader} media the playlist to set on the segment loader
	   */
	  ;
	
	  _proto.playlist = function playlist(newPlaylist, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!newPlaylist) {
	      return;
	    }
	
	    var oldPlaylist = this.playlist_;
	    var segmentInfo = this.pendingSegment_;
	    this.playlist_ = newPlaylist;
	    this.xhrOptions_ = options; // when we haven't started playing yet, the start of a live playlist
	    // is always our zero-time so force a sync update each time the playlist
	    // is refreshed from the server
	    //
	    // Use the INIT state to determine if playback has started, as the playlist sync info
	    // should be fixed once requests begin (as sync points are generated based on sync
	    // info), but not before then.
	
	    if (this.state === 'INIT') {
	      newPlaylist.syncInfo = {
	        mediaSequence: newPlaylist.mediaSequence,
	        time: 0
	      }; // Setting the date time mapping means mapping the program date time (if available)
	      // to time 0 on the player's timeline. The playlist's syncInfo serves a similar
	      // purpose, mapping the initial mediaSequence to time zero. Since the syncInfo can
	      // be updated as the playlist is refreshed before the loader starts loading, the
	      // program date time mapping needs to be updated as well.
	      //
	      // This mapping is only done for the main loader because a program date time should
	      // map equivalently between playlists.
	
	      if (this.loaderType_ === 'main') {
	        this.syncController_.setDateTimeMappingForStart(newPlaylist);
	      }
	    }
	
	    var oldId = null;
	
	    if (oldPlaylist) {
	      if (oldPlaylist.id) {
	        oldId = oldPlaylist.id;
	      } else if (oldPlaylist.uri) {
	        oldId = oldPlaylist.uri;
	      }
	    }
	
	    this.logger_("playlist update [" + oldId + " => " + (newPlaylist.id || newPlaylist.uri) + "]"); // in VOD, this is always a rendition switch (or we updated our syncInfo above)
	    // in LIVE, we always want to update with new playlists (including refreshes)
	
	    this.trigger('syncinfoupdate'); // if we were unpaused but waiting for a playlist, start
	    // buffering now
	
	    if (this.state === 'INIT' && this.couldBeginLoading_()) {
	      return this.init_();
	    }
	
	    if (!oldPlaylist || oldPlaylist.uri !== newPlaylist.uri) {
	      if (this.mediaIndex !== null) {
	        // we must reset/resync the segment loader when we switch renditions and
	        // the segment loader is already synced to the previous rendition
	        // on playlist changes we want it to be possible to fetch
	        // at the buffer for vod but not for live. So we use resetLoader
	        // for live and resyncLoader for vod. We want this because
	        // if a playlist uses independent and non-independent segments/parts the
	        // buffer may not accurately reflect the next segment that we should try
	        // downloading.
	        if (!newPlaylist.endList) {
	          this.resetLoader();
	        } else {
	          this.resyncLoader();
	        }
	      }
	
	      this.currentMediaInfo_ = void 0;
	      this.trigger('playlistupdate'); // the rest of this function depends on `oldPlaylist` being defined
	
	      return;
	    } // we reloaded the same playlist so we are in a live scenario
	    // and we will likely need to adjust the mediaIndex
	
	
	    var mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence;
	    this.logger_("live window shift [" + mediaSequenceDiff + "]"); // update the mediaIndex on the SegmentLoader
	    // this is important because we can abort a request and this value must be
	    // equal to the last appended mediaIndex
	
	    if (this.mediaIndex !== null) {
	      this.mediaIndex -= mediaSequenceDiff; // this can happen if we are going to load the first segment, but get a playlist
	      // update during that. mediaIndex would go from 0 to -1 if mediaSequence in the
	      // new playlist was incremented by 1.
	
	      if (this.mediaIndex < 0) {
	        this.mediaIndex = null;
	        this.partIndex = null;
	      } else {
	        var segment = this.playlist_.segments[this.mediaIndex]; // partIndex should remain the same for the same segment
	        // unless parts fell off of the playlist for this segment.
	        // In that case we need to reset partIndex and resync
	
	        if (this.partIndex && (!segment.parts || !segment.parts.length || !segment.parts[this.partIndex])) {
	          var mediaIndex = this.mediaIndex;
	          this.logger_("currently processing part (index " + this.partIndex + ") no longer exists.");
	          this.resetLoader(); // We want to throw away the partIndex and the data associated with it,
	          // as the part was dropped from our current playlists segment.
	          // The mediaIndex will still be valid so keep that around.
	
	          this.mediaIndex = mediaIndex;
	        }
	      }
	    } // update the mediaIndex on the SegmentInfo object
	    // this is important because we will update this.mediaIndex with this value
	    // in `handleAppendsDone_` after the segment has been successfully appended
	
	
	    if (segmentInfo) {
	      segmentInfo.mediaIndex -= mediaSequenceDiff;
	
	      if (segmentInfo.mediaIndex < 0) {
	        segmentInfo.mediaIndex = null;
	        segmentInfo.partIndex = null;
	      } else {
	        // we need to update the referenced segment so that timing information is
	        // saved for the new playlist's segment, however, if the segment fell off the
	        // playlist, we can leave the old reference and just lose the timing info
	        if (segmentInfo.mediaIndex >= 0) {
	          segmentInfo.segment = newPlaylist.segments[segmentInfo.mediaIndex];
	        }
	
	        if (segmentInfo.partIndex >= 0 && segmentInfo.segment.parts) {
	          segmentInfo.part = segmentInfo.segment.parts[segmentInfo.partIndex];
	        }
	      }
	    }
	
	    this.syncController_.saveExpiredSegmentInfo(oldPlaylist, newPlaylist);
	  }
	  /**
	   * Prevent the loader from fetching additional segments. If there
	   * is a segment request outstanding, it will finish processing
	   * before the loader halts. A segment loader can be unpaused by
	   * calling load().
	   */
	  ;
	
	  _proto.pause = function pause() {
	    if (this.checkBufferTimeout_) {
	      window__default['default'].clearTimeout(this.checkBufferTimeout_);
	      this.checkBufferTimeout_ = null;
	    }
	  }
	  /**
	   * Returns whether the segment loader is fetching additional
	   * segments when given the opportunity. This property can be
	   * modified through calls to pause() and load().
	   */
	  ;
	
	  _proto.paused = function paused() {
	    return this.checkBufferTimeout_ === null;
	  }
	  /**
	   * Delete all the buffered data and reset the SegmentLoader
	   *
	   * @param {Function} [done] an optional callback to be executed when the remove
	   * operation is complete
	   */
	  ;
	
	  _proto.resetEverything = function resetEverything(done) {
	    this.ended_ = false;
	    this.activeInitSegmentId_ = null;
	    this.appendInitSegment_ = {
	      audio: true,
	      video: true
	    };
	    this.resetLoader(); // remove from 0, the earliest point, to Infinity, to signify removal of everything.
	    // VTT Segment Loader doesn't need to do anything but in the regular SegmentLoader,
	    // we then clamp the value to duration if necessary.
	
	    this.remove(0, Infinity, done); // clears fmp4 captions
	
	    if (this.transmuxer_) {
	      this.transmuxer_.postMessage({
	        action: 'clearAllMp4Captions'
	      }); // reset the cache in the transmuxer
	
	      this.transmuxer_.postMessage({
	        action: 'reset'
	      });
	    }
	  }
	  /**
	   * Force the SegmentLoader to resync and start loading around the currentTime instead
	   * of starting at the end of the buffer
	   *
	   * Useful for fast quality changes
	   */
	  ;
	
	  _proto.resetLoader = function resetLoader() {
	    this.fetchAtBuffer_ = false;
	    this.resyncLoader();
	  }
	  /**
	   * Force the SegmentLoader to restart synchronization and make a conservative guess
	   * before returning to the simple walk-forward method
	   */
	  ;
	
	  _proto.resyncLoader = function resyncLoader() {
	    if (this.transmuxer_) {
	      // need to clear out any cached data to prepare for the new segment
	      segmentTransmuxer.reset(this.transmuxer_);
	    }
	
	    this.mediaIndex = null;
	    this.partIndex = null;
	    this.syncPoint_ = null;
	    this.isPendingTimestampOffset_ = false;
	    this.callQueue_ = [];
	    this.loadQueue_ = [];
	    this.metadataQueue_.id3 = [];
	    this.metadataQueue_.caption = [];
	    this.abort();
	
	    if (this.transmuxer_) {
	      this.transmuxer_.postMessage({
	        action: 'clearParsedMp4Captions'
	      });
	    }
	  }
	  /**
	   * Remove any data in the source buffer between start and end times
	   *
	   * @param {number} start - the start time of the region to remove from the buffer
	   * @param {number} end - the end time of the region to remove from the buffer
	   * @param {Function} [done] - an optional callback to be executed when the remove
	   * @param {boolean} force - force all remove operations to happen
	   * operation is complete
	   */
	  ;
	
	  _proto.remove = function remove(start, end, done, force) {
	    if (done === void 0) {
	      done = function done() {};
	    }
	
	    if (force === void 0) {
	      force = false;
	    } // clamp end to duration if we need to remove everything.
	    // This is due to a browser bug that causes issues if we remove to Infinity.
	    // videojs/videojs-contrib-hls#1225
	
	
	    if (end === Infinity) {
	      end = this.duration_();
	    } // skip removes that would throw an error
	    // commonly happens during a rendition switch at the start of a video
	    // from start 0 to end 0
	
	
	    if (end <= start) {
	      this.logger_('skipping remove because end ${end} is <= start ${start}');
	      return;
	    }
	
	    if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
	      this.logger_('skipping remove because no source updater or starting media info'); // nothing to remove if we haven't processed any media
	
	      return;
	    } // set it to one to complete this function's removes
	
	
	    var removesRemaining = 1;
	
	    var removeFinished = function removeFinished() {
	      removesRemaining--;
	
	      if (removesRemaining === 0) {
	        done();
	      }
	    };
	
	    if (force || !this.audioDisabled_) {
	      removesRemaining++;
	      this.sourceUpdater_.removeAudio(start, end, removeFinished);
	    } // While it would be better to only remove video if the main loader has video, this
	    // should be safe with audio only as removeVideo will call back even if there's no
	    // video buffer.
	    //
	    // In theory we can check to see if there's video before calling the remove, but in
	    // the event that we're switching between renditions and from video to audio only
	    // (when we add support for that), we may need to clear the video contents despite
	    // what the new media will contain.
	
	
	    if (force || this.loaderType_ === 'main') {
	      this.gopBuffer_ = removeGopBuffer(this.gopBuffer_, start, end, this.timeMapping_);
	      removesRemaining++;
	      this.sourceUpdater_.removeVideo(start, end, removeFinished);
	    } // remove any captions and ID3 tags
	
	
	    for (var track in this.inbandTextTracks_) {
	      removeCuesFromTrack(start, end, this.inbandTextTracks_[track]);
	    }
	
	    removeCuesFromTrack(start, end, this.segmentMetadataTrack_); // finished this function's removes
	
	    removeFinished();
	  }
	  /**
	   * (re-)schedule monitorBufferTick_ to run as soon as possible
	   *
	   * @private
	   */
	  ;
	
	  _proto.monitorBuffer_ = function monitorBuffer_() {
	    if (this.checkBufferTimeout_) {
	      window__default['default'].clearTimeout(this.checkBufferTimeout_);
	    }
	
	    this.checkBufferTimeout_ = window__default['default'].setTimeout(this.monitorBufferTick_.bind(this), 1);
	  }
	  /**
	   * As long as the SegmentLoader is in the READY state, periodically
	   * invoke fillBuffer_().
	   *
	   * @private
	   */
	  ;
	
	  _proto.monitorBufferTick_ = function monitorBufferTick_() {
	    if (this.state === 'READY') {
	      this.fillBuffer_();
	    }
	
	    if (this.checkBufferTimeout_) {
	      window__default['default'].clearTimeout(this.checkBufferTimeout_);
	    }
	
	    this.checkBufferTimeout_ = window__default['default'].setTimeout(this.monitorBufferTick_.bind(this), CHECK_BUFFER_DELAY);
	  }
	  /**
	   * fill the buffer with segements unless the sourceBuffers are
	   * currently updating
	   *
	   * Note: this function should only ever be called by monitorBuffer_
	   * and never directly
	   *
	   * @private
	   */
	  ;
	
	  _proto.fillBuffer_ = function fillBuffer_() {
	    // TODO since the source buffer maintains a queue, and we shouldn't call this function
	    // except when we're ready for the next segment, this check can most likely be removed
	    if (this.sourceUpdater_.updating()) {
	      return;
	    } // see if we need to begin loading immediately
	
	
	    var segmentInfo = this.chooseNextRequest_();
	
	    if (!segmentInfo) {
	      return;
	    }
	
	    if (typeof segmentInfo.timestampOffset === 'number') {
	      this.isPendingTimestampOffset_ = false;
	      this.timelineChangeController_.pendingTimelineChange({
	        type: this.loaderType_,
	        from: this.currentTimeline_,
	        to: segmentInfo.timeline
	      });
	    }
	
	    this.loadSegment_(segmentInfo);
	  }
	  /**
	   * Determines if we should call endOfStream on the media source based
	   * on the state of the buffer or if appened segment was the final
	   * segment in the playlist.
	   *
	   * @param {number} [mediaIndex] the media index of segment we last appended
	   * @param {Object} [playlist] a media playlist object
	   * @return {boolean} do we need to call endOfStream on the MediaSource
	   */
	  ;
	
	  _proto.isEndOfStream_ = function isEndOfStream_(mediaIndex, playlist, partIndex) {
	    if (mediaIndex === void 0) {
	      mediaIndex = this.mediaIndex;
	    }
	
	    if (playlist === void 0) {
	      playlist = this.playlist_;
	    }
	
	    if (partIndex === void 0) {
	      partIndex = this.partIndex;
	    }
	
	    if (!playlist || !this.mediaSource_) {
	      return false;
	    }
	
	    var segment = typeof mediaIndex === 'number' && playlist.segments[mediaIndex]; // mediaIndex is zero based but length is 1 based
	
	    var appendedLastSegment = mediaIndex + 1 === playlist.segments.length; // true if there are no parts, or this is the last part.
	
	    var appendedLastPart = !segment || !segment.parts || partIndex + 1 === segment.parts.length; // if we've buffered to the end of the video, we need to call endOfStream
	    // so that MediaSources can trigger the `ended` event when it runs out of
	    // buffered data instead of waiting for me
	
	    return playlist.endList && this.mediaSource_.readyState === 'open' && appendedLastSegment && appendedLastPart;
	  }
	  /**
	   * Determines what request should be made given current segment loader state.
	   *
	   * @return {Object} a request object that describes the segment/part to load
	   */
	  ;
	
	  _proto.chooseNextRequest_ = function chooseNextRequest_() {
	    var buffered = this.buffered_();
	    var bufferedEnd = lastBufferedEnd(buffered) || 0;
	    var bufferedTime = timeAheadOf(buffered, this.currentTime_());
	    var preloaded = !this.hasPlayed_() && bufferedTime >= 1;
	    var haveEnoughBuffer = bufferedTime >= this.goalBufferLength_();
	    var segments = this.playlist_.segments; // return no segment if:
	    // 1. we don't have segments
	    // 2. The video has not yet played and we already downloaded a segment
	    // 3. we already have enough buffered time
	
	    if (!segments.length || preloaded || haveEnoughBuffer) {
	      return null;
	    }
	
	    this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_());
	    var next = {
	      partIndex: null,
	      mediaIndex: null,
	      startOfSegment: null,
	      playlist: this.playlist_,
	      isSyncRequest: Boolean(!this.syncPoint_)
	    };
	
	    if (next.isSyncRequest) {
	      next.mediaIndex = getSyncSegmentCandidate(this.currentTimeline_, segments, bufferedEnd);
	    } else if (this.mediaIndex !== null) {
	      var segment = segments[this.mediaIndex];
	      var partIndex = typeof this.partIndex === 'number' ? this.partIndex : -1;
	      next.startOfSegment = segment.end ? segment.end : bufferedEnd;
	
	      if (segment.parts && segment.parts[partIndex + 1]) {
	        next.mediaIndex = this.mediaIndex;
	        next.partIndex = partIndex + 1;
	      } else {
	        next.mediaIndex = this.mediaIndex + 1;
	      }
	    } else {
	      // Find the segment containing the end of the buffer or current time.
	      var _Playlist$getMediaInf = Playlist.getMediaInfoForTime({
	        experimentalExactManifestTimings: this.experimentalExactManifestTimings,
	        playlist: this.playlist_,
	        currentTime: this.fetchAtBuffer_ ? bufferedEnd : this.currentTime_(),
	        startingPartIndex: this.syncPoint_.partIndex,
	        startingSegmentIndex: this.syncPoint_.segmentIndex,
	        startTime: this.syncPoint_.time
	      }),
	          segmentIndex = _Playlist$getMediaInf.segmentIndex,
	          startTime = _Playlist$getMediaInf.startTime,
	          _partIndex = _Playlist$getMediaInf.partIndex;
	
	      next.getMediaInfoForTime = this.fetchAtBuffer_ ? "bufferedEnd " + bufferedEnd : "currentTime " + this.currentTime_();
	      next.mediaIndex = segmentIndex;
	      next.startOfSegment = startTime;
	      next.partIndex = _partIndex;
	    }
	
	    var nextSegment = segments[next.mediaIndex];
	    var nextPart = nextSegment && typeof next.partIndex === 'number' && nextSegment.parts && nextSegment.parts[next.partIndex]; // if the next segment index is invalid or
	    // the next partIndex is invalid do not choose a next segment.
	
	    if (!nextSegment || typeof next.partIndex === 'number' && !nextPart) {
	      return null;
	    } // if the next segment has parts, and we don't have a partIndex.
	    // Set partIndex to 0
	
	
	    if (typeof next.partIndex !== 'number' && nextSegment.parts) {
	      next.partIndex = 0;
	      nextPart = nextSegment.parts[0];
	    } // if we have no buffered data then we need to make sure
	    // that the next part we append is "independent" if possible.
	    // So we check if the previous part is independent, and request
	    // it if it is.
	
	
	    if (!bufferedTime && nextPart && !nextPart.independent) {
	      if (next.partIndex === 0) {
	        var lastSegment = segments[next.mediaIndex - 1];
	        var lastSegmentLastPart = lastSegment.parts && lastSegment.parts.length && lastSegment.parts[lastSegment.parts.length - 1];
	
	        if (lastSegmentLastPart && lastSegmentLastPart.independent) {
	          next.mediaIndex -= 1;
	          next.partIndex = lastSegment.parts.length - 1;
	          next.independent = 'previous segment';
	        }
	      } else if (nextSegment.parts[next.partIndex - 1].independent) {
	        next.partIndex -= 1;
	        next.independent = 'previous part';
	      }
	    }
	
	    var ended = this.mediaSource_ && this.mediaSource_.readyState === 'ended'; // do not choose a next segment if all of the following:
	    // 1. this is the last segment in the playlist
	    // 2. end of stream has been called on the media source already
	    // 3. the player is not seeking
	
	    if (next.mediaIndex >= segments.length - 1 && ended && !this.seeking_()) {
	      return null;
	    }
	
	    return this.generateSegmentInfo_(next);
	  };
	
	  _proto.generateSegmentInfo_ = function generateSegmentInfo_(options) {
	    var independent = options.independent,
	        playlist = options.playlist,
	        mediaIndex = options.mediaIndex,
	        startOfSegment = options.startOfSegment,
	        isSyncRequest = options.isSyncRequest,
	        partIndex = options.partIndex,
	        forceTimestampOffset = options.forceTimestampOffset,
	        getMediaInfoForTime = options.getMediaInfoForTime;
	    var segment = playlist.segments[mediaIndex];
	    var part = typeof partIndex === 'number' && segment.parts[partIndex];
	    var segmentInfo = {
	      requestId: 'segment-loader-' + Math.random(),
	      // resolve the segment URL relative to the playlist
	      uri: part && part.resolvedUri || segment.resolvedUri,
	      // the segment's mediaIndex at the time it was requested
	      mediaIndex: mediaIndex,
	      partIndex: part ? partIndex : null,
	      // whether or not to update the SegmentLoader's state with this
	      // segment's mediaIndex
	      isSyncRequest: isSyncRequest,
	      startOfSegment: startOfSegment,
	      // the segment's playlist
	      playlist: playlist,
	      // unencrypted bytes of the segment
	      bytes: null,
	      // when a key is defined for this segment, the encrypted bytes
	      encryptedBytes: null,
	      // The target timestampOffset for this segment when we append it
	      // to the source buffer
	      timestampOffset: null,
	      // The timeline that the segment is in
	      timeline: segment.timeline,
	      // The expected duration of the segment in seconds
	      duration: part && part.duration || segment.duration,
	      // retain the segment in case the playlist updates while doing an async process
	      segment: segment,
	      part: part,
	      byteLength: 0,
	      transmuxer: this.transmuxer_,
	      // type of getMediaInfoForTime that was used to get this segment
	      getMediaInfoForTime: getMediaInfoForTime,
	      independent: independent
	    };
	    var overrideCheck = typeof forceTimestampOffset !== 'undefined' ? forceTimestampOffset : this.isPendingTimestampOffset_;
	    segmentInfo.timestampOffset = this.timestampOffsetForSegment_({
	      segmentTimeline: segment.timeline,
	      currentTimeline: this.currentTimeline_,
	      startOfSegment: startOfSegment,
	      buffered: this.buffered_(),
	      overrideCheck: overrideCheck
	    });
	    var audioBufferedEnd = lastBufferedEnd(this.sourceUpdater_.audioBuffered());
	
	    if (typeof audioBufferedEnd === 'number') {
	      // since the transmuxer is using the actual timing values, but the buffer is
	      // adjusted by the timestamp offset, we must adjust the value here
	      segmentInfo.audioAppendStart = audioBufferedEnd - this.sourceUpdater_.audioTimestampOffset();
	    }
	
	    if (this.sourceUpdater_.videoBuffered().length) {
	      segmentInfo.gopsToAlignWith = gopsSafeToAlignWith(this.gopBuffer_, // since the transmuxer is using the actual timing values, but the time is
	      // adjusted by the timestmap offset, we must adjust the value here
	      this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(), this.timeMapping_);
	    }
	
	    return segmentInfo;
	  } // get the timestampoffset for a segment,
	  // added so that vtt segment loader can override and prevent
	  // adding timestamp offsets.
	  ;
	
	  _proto.timestampOffsetForSegment_ = function timestampOffsetForSegment_(options) {
	    return timestampOffsetForSegment(options);
	  }
	  /**
	   * Determines if the network has enough bandwidth to complete the current segment
	   * request in a timely manner. If not, the request will be aborted early and bandwidth
	   * updated to trigger a playlist switch.
	   *
	   * @param {Object} stats
	   *        Object containing stats about the request timing and size
	   * @private
	   */
	  ;
	
	  _proto.earlyAbortWhenNeeded_ = function earlyAbortWhenNeeded_(stats) {
	    if (this.vhs_.tech_.paused() || // Don't abort if the current playlist is on the lowestEnabledRendition
	    // TODO: Replace using timeout with a boolean indicating whether this playlist is
	    //       the lowestEnabledRendition.
	    !this.xhrOptions_.timeout || // Don't abort if we have no bandwidth information to estimate segment sizes
	    !this.playlist_.attributes.BANDWIDTH) {
	      return;
	    } // Wait at least 1 second since the first byte of data has been received before
	    // using the calculated bandwidth from the progress event to allow the bitrate
	    // to stabilize
	
	
	    if (Date.now() - (stats.firstBytesReceivedAt || Date.now()) < 1000) {
	      return;
	    }
	
	    var currentTime = this.currentTime_();
	    var measuredBandwidth = stats.bandwidth;
	    var segmentDuration = this.pendingSegment_.duration;
	    var requestTimeRemaining = Playlist.estimateSegmentRequestTime(segmentDuration, measuredBandwidth, this.playlist_, stats.bytesReceived); // Subtract 1 from the timeUntilRebuffer so we still consider an early abort
	    // if we are only left with less than 1 second when the request completes.
	    // A negative timeUntilRebuffering indicates we are already rebuffering
	
	    var timeUntilRebuffer$1 = timeUntilRebuffer(this.buffered_(), currentTime, this.vhs_.tech_.playbackRate()) - 1; // Only consider aborting early if the estimated time to finish the download
	    // is larger than the estimated time until the player runs out of forward buffer
	
	    if (requestTimeRemaining <= timeUntilRebuffer$1) {
	      return;
	    }
	
	    var switchCandidate = minRebufferMaxBandwidthSelector({
	      master: this.vhs_.playlists.master,
	      currentTime: currentTime,
	      bandwidth: measuredBandwidth,
	      duration: this.duration_(),
	      segmentDuration: segmentDuration,
	      timeUntilRebuffer: timeUntilRebuffer$1,
	      currentTimeline: this.currentTimeline_,
	      syncController: this.syncController_
	    });
	
	    if (!switchCandidate) {
	      return;
	    }
	
	    var rebufferingImpact = requestTimeRemaining - timeUntilRebuffer$1;
	    var timeSavedBySwitching = rebufferingImpact - switchCandidate.rebufferingImpact;
	    var minimumTimeSaving = 0.5; // If we are already rebuffering, increase the amount of variance we add to the
	    // potential round trip time of the new request so that we are not too aggressive
	    // with switching to a playlist that might save us a fraction of a second.
	
	    if (timeUntilRebuffer$1 <= TIME_FUDGE_FACTOR) {
	      minimumTimeSaving = 1;
	    }
	
	    if (!switchCandidate.playlist || switchCandidate.playlist.uri === this.playlist_.uri || timeSavedBySwitching < minimumTimeSaving) {
	      return;
	    } // set the bandwidth to that of the desired playlist being sure to scale by
	    // BANDWIDTH_VARIANCE and add one so the playlist selector does not exclude it
	    // don't trigger a bandwidthupdate as the bandwidth is artifial
	
	
	    this.bandwidth = switchCandidate.playlist.attributes.BANDWIDTH * Config.BANDWIDTH_VARIANCE + 1;
	    this.trigger('earlyabort');
	  };
	
	  _proto.handleAbort_ = function handleAbort_(segmentInfo) {
	    this.logger_("Aborting " + segmentInfoString(segmentInfo));
	    this.mediaRequestsAborted += 1;
	  }
	  /**
	   * XHR `progress` event handler
	   *
	   * @param {Event}
	   *        The XHR `progress` event
	   * @param {Object} simpleSegment
	   *        A simplified segment object copy
	   * @private
	   */
	  ;
	
	  _proto.handleProgress_ = function handleProgress_(event, simpleSegment) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    }
	
	    this.trigger('progress');
	  };
	
	  _proto.handleTrackInfo_ = function handleTrackInfo_(simpleSegment, trackInfo) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    }
	
	    if (this.checkForIllegalMediaSwitch(trackInfo)) {
	      return;
	    }
	
	    trackInfo = trackInfo || {}; // When we have track info, determine what media types this loader is dealing with.
	    // Guard against cases where we're not getting track info at all until we are
	    // certain that all streams will provide it.
	
	    if (!shallowEqual(this.currentMediaInfo_, trackInfo)) {
	      this.appendInitSegment_ = {
	        audio: true,
	        video: true
	      };
	      this.startingMediaInfo_ = trackInfo;
	      this.currentMediaInfo_ = trackInfo;
	      this.logger_('trackinfo update', trackInfo);
	      this.trigger('trackinfo');
	    } // trackinfo may cause an abort if the trackinfo
	    // causes a codec change to an unsupported codec.
	
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    } // set trackinfo on the pending segment so that
	    // it can append.
	
	
	    this.pendingSegment_.trackInfo = trackInfo; // check if any calls were waiting on the track info
	
	    if (this.hasEnoughInfoToAppend_()) {
	      this.processCallQueue_();
	    }
	  };
	
	  _proto.handleTimingInfo_ = function handleTimingInfo_(simpleSegment, mediaType, timeType, time) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_;
	    var timingInfoProperty = timingInfoPropertyForMedia(mediaType);
	    segmentInfo[timingInfoProperty] = segmentInfo[timingInfoProperty] || {};
	    segmentInfo[timingInfoProperty][timeType] = time;
	    this.logger_("timinginfo: " + mediaType + " - " + timeType + " - " + time); // check if any calls were waiting on the timing info
	
	    if (this.hasEnoughInfoToAppend_()) {
	      this.processCallQueue_();
	    }
	  };
	
	  _proto.handleCaptions_ = function handleCaptions_(simpleSegment, captionData) {
	    var _this2 = this;
	
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    } // This could only happen with fmp4 segments, but
	    // should still not happen in general
	
	
	    if (captionData.length === 0) {
	      this.logger_('SegmentLoader received no captions from a caption event');
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // Wait until we have some video data so that caption timing
	    // can be adjusted by the timestamp offset
	
	    if (!segmentInfo.hasAppendedData_) {
	      this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, simpleSegment, captionData));
	      return;
	    }
	
	    var timestampOffset = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
	    var captionTracks = {}; // get total start/end and captions for each track/stream
	
	    captionData.forEach(function (caption) {
	      // caption.stream is actually a track name...
	      // set to the existing values in tracks or default values
	      captionTracks[caption.stream] = captionTracks[caption.stream] || {
	        // Infinity, as any other value will be less than this
	        startTime: Infinity,
	        captions: [],
	        // 0 as an other value will be more than this
	        endTime: 0
	      };
	      var captionTrack = captionTracks[caption.stream];
	      captionTrack.startTime = Math.min(captionTrack.startTime, caption.startTime + timestampOffset);
	      captionTrack.endTime = Math.max(captionTrack.endTime, caption.endTime + timestampOffset);
	      captionTrack.captions.push(caption);
	    });
	    Object.keys(captionTracks).forEach(function (trackName) {
	      var _captionTracks$trackN = captionTracks[trackName],
	          startTime = _captionTracks$trackN.startTime,
	          endTime = _captionTracks$trackN.endTime,
	          captions = _captionTracks$trackN.captions;
	      var inbandTextTracks = _this2.inbandTextTracks_;
	
	      _this2.logger_("adding cues from " + startTime + " -> " + endTime + " for " + trackName);
	
	      createCaptionsTrackIfNotExists(inbandTextTracks, _this2.vhs_.tech_, trackName); // clear out any cues that start and end at the same time period for the same track.
	      // We do this because a rendition change that also changes the timescale for captions
	      // will result in captions being re-parsed for certain segments. If we add them again
	      // without clearing we will have two of the same captions visible.
	
	      removeCuesFromTrack(startTime, endTime, inbandTextTracks[trackName]);
	      addCaptionData({
	        captionArray: captions,
	        inbandTextTracks: inbandTextTracks,
	        timestampOffset: timestampOffset
	      });
	    }); // Reset stored captions since we added parsed
	    // captions to a text track at this point
	
	    if (this.transmuxer_) {
	      this.transmuxer_.postMessage({
	        action: 'clearParsedMp4Captions'
	      });
	    }
	  };
	
	  _proto.handleId3_ = function handleId3_(simpleSegment, id3Frames, dispatchType) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // we need to have appended data in order for the timestamp offset to be set
	
	    if (!segmentInfo.hasAppendedData_) {
	      this.metadataQueue_.id3.push(this.handleId3_.bind(this, simpleSegment, id3Frames, dispatchType));
	      return;
	    }
	
	    var timestampOffset = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset(); // There's potentially an issue where we could double add metadata if there's a muxed
	    // audio/video source with a metadata track, and an alt audio with a metadata track.
	    // However, this probably won't happen, and if it does it can be handled then.
	
	    createMetadataTrackIfNotExists(this.inbandTextTracks_, dispatchType, this.vhs_.tech_);
	    addMetadata({
	      inbandTextTracks: this.inbandTextTracks_,
	      metadataArray: id3Frames,
	      timestampOffset: timestampOffset,
	      videoDuration: this.duration_()
	    });
	  };
	
	  _proto.processMetadataQueue_ = function processMetadataQueue_() {
	    this.metadataQueue_.id3.forEach(function (fn) {
	      return fn();
	    });
	    this.metadataQueue_.caption.forEach(function (fn) {
	      return fn();
	    });
	    this.metadataQueue_.id3 = [];
	    this.metadataQueue_.caption = [];
	  };
	
	  _proto.processCallQueue_ = function processCallQueue_() {
	    var callQueue = this.callQueue_; // Clear out the queue before the queued functions are run, since some of the
	    // functions may check the length of the load queue and default to pushing themselves
	    // back onto the queue.
	
	    this.callQueue_ = [];
	    callQueue.forEach(function (fun) {
	      return fun();
	    });
	  };
	
	  _proto.processLoadQueue_ = function processLoadQueue_() {
	    var loadQueue = this.loadQueue_; // Clear out the queue before the queued functions are run, since some of the
	    // functions may check the length of the load queue and default to pushing themselves
	    // back onto the queue.
	
	    this.loadQueue_ = [];
	    loadQueue.forEach(function (fun) {
	      return fun();
	    });
	  }
	  /**
	   * Determines whether the loader has enough info to load the next segment.
	   *
	   * @return {boolean}
	   *         Whether or not the loader has enough info to load the next segment
	   */
	  ;
	
	  _proto.hasEnoughInfoToLoad_ = function hasEnoughInfoToLoad_() {
	    // Since primary timing goes by video, only the audio loader potentially needs to wait
	    // to load.
	    if (this.loaderType_ !== 'audio') {
	      return true;
	    }
	
	    var segmentInfo = this.pendingSegment_; // A fill buffer must have already run to establish a pending segment before there's
	    // enough info to load.
	
	    if (!segmentInfo) {
	      return false;
	    } // The first segment can and should be loaded immediately so that source buffers are
	    // created together (before appending). Source buffer creation uses the presence of
	    // audio and video data to determine whether to create audio/video source buffers, and
	    // uses processed (transmuxed or parsed) media to determine the types required.
	
	
	    if (!this.getCurrentMediaInfo_()) {
	      return true;
	    }
	
	    if ( // Technically, instead of waiting to load a segment on timeline changes, a segment
	    // can be requested and downloaded and only wait before it is transmuxed or parsed.
	    // But in practice, there are a few reasons why it is better to wait until a loader
	    // is ready to append that segment before requesting and downloading:
	    //
	    // 1. Because audio and main loaders cross discontinuities together, if this loader
	    //    is waiting for the other to catch up, then instead of requesting another
	    //    segment and using up more bandwidth, by not yet loading, more bandwidth is
	    //    allotted to the loader currently behind.
	    // 2. media-segment-request doesn't have to have logic to consider whether a segment
	    // is ready to be processed or not, isolating the queueing behavior to the loader.
	    // 3. The audio loader bases some of its segment properties on timing information
	    //    provided by the main loader, meaning that, if the logic for waiting on
	    //    processing was in media-segment-request, then it would also need to know how
	    //    to re-generate the segment information after the main loader caught up.
	    shouldWaitForTimelineChange({
	      timelineChangeController: this.timelineChangeController_,
	      currentTimeline: this.currentTimeline_,
	      segmentTimeline: segmentInfo.timeline,
	      loaderType: this.loaderType_,
	      audioDisabled: this.audioDisabled_
	    })) {
	      return false;
	    }
	
	    return true;
	  };
	
	  _proto.getCurrentMediaInfo_ = function getCurrentMediaInfo_(segmentInfo) {
	    if (segmentInfo === void 0) {
	      segmentInfo = this.pendingSegment_;
	    }
	
	    return segmentInfo && segmentInfo.trackInfo || this.currentMediaInfo_;
	  };
	
	  _proto.getMediaInfo_ = function getMediaInfo_(segmentInfo) {
	    if (segmentInfo === void 0) {
	      segmentInfo = this.pendingSegment_;
	    }
	
	    return this.getCurrentMediaInfo_(segmentInfo) || this.startingMediaInfo_;
	  };
	
	  _proto.getPendingSegmentPlaylist = function getPendingSegmentPlaylist() {
	    return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
	  };
	
	  _proto.hasEnoughInfoToAppend_ = function hasEnoughInfoToAppend_() {
	    if (!this.sourceUpdater_.ready()) {
	      return false;
	    } // If content needs to be removed or the loader is waiting on an append reattempt,
	    // then no additional content should be appended until the prior append is resolved.
	
	
	    if (this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_) {
	      return false;
	    }
	
	    var segmentInfo = this.pendingSegment_;
	    var trackInfo = this.getCurrentMediaInfo_(); // no segment to append any data for or
	    // we do not have information on this specific
	    // segment yet
	
	    if (!segmentInfo || !trackInfo) {
	      return false;
	    }
	
	    var hasAudio = trackInfo.hasAudio,
	        hasVideo = trackInfo.hasVideo,
	        isMuxed = trackInfo.isMuxed;
	
	    if (hasVideo && !segmentInfo.videoTimingInfo) {
	      return false;
	    } // muxed content only relies on video timing information for now.
	
	
	    if (hasAudio && !this.audioDisabled_ && !isMuxed && !segmentInfo.audioTimingInfo) {
	      return false;
	    }
	
	    if (shouldWaitForTimelineChange({
	      timelineChangeController: this.timelineChangeController_,
	      currentTimeline: this.currentTimeline_,
	      segmentTimeline: segmentInfo.timeline,
	      loaderType: this.loaderType_,
	      audioDisabled: this.audioDisabled_
	    })) {
	      return false;
	    }
	
	    return true;
	  };
	
	  _proto.handleData_ = function handleData_(simpleSegment, result) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    } // If there's anything in the call queue, then this data came later and should be
	    // executed after the calls currently queued.
	
	
	    if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
	      this.callQueue_.push(this.handleData_.bind(this, simpleSegment, result));
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // update the time mapping so we can translate from display time to media time
	
	    this.setTimeMapping_(segmentInfo.timeline); // for tracking overall stats
	
	    this.updateMediaSecondsLoaded_(segmentInfo.part || segmentInfo.segment); // Note that the state isn't changed from loading to appending. This is because abort
	    // logic may change behavior depending on the state, and changing state too early may
	    // inflate our estimates of bandwidth. In the future this should be re-examined to
	    // note more granular states.
	    // don't process and append data if the mediaSource is closed
	
	    if (this.mediaSource_.readyState === 'closed') {
	      return;
	    } // if this request included an initialization segment, save that data
	    // to the initSegment cache
	
	
	    if (simpleSegment.map) {
	      simpleSegment.map = this.initSegmentForMap(simpleSegment.map, true); // move over init segment properties to media request
	
	      segmentInfo.segment.map = simpleSegment.map;
	    } // if this request included a segment key, save that data in the cache
	
	
	    if (simpleSegment.key) {
	      this.segmentKey(simpleSegment.key, true);
	    }
	
	    segmentInfo.isFmp4 = simpleSegment.isFmp4;
	    segmentInfo.timingInfo = segmentInfo.timingInfo || {};
	
	    if (segmentInfo.isFmp4) {
	      this.trigger('fmp4');
	      segmentInfo.timingInfo.start = segmentInfo[timingInfoPropertyForMedia(result.type)].start;
	    } else {
	      var trackInfo = this.getCurrentMediaInfo_();
	      var useVideoTimingInfo = this.loaderType_ === 'main' && trackInfo && trackInfo.hasVideo;
	      var firstVideoFrameTimeForData;
	
	      if (useVideoTimingInfo) {
	        firstVideoFrameTimeForData = segmentInfo.videoTimingInfo.start;
	      } // Segment loader knows more about segment timing than the transmuxer (in certain
	      // aspects), so make any changes required for a more accurate start time.
	      // Don't set the end time yet, as the segment may not be finished processing.
	
	
	      segmentInfo.timingInfo.start = this.trueSegmentStart_({
	        currentStart: segmentInfo.timingInfo.start,
	        playlist: segmentInfo.playlist,
	        mediaIndex: segmentInfo.mediaIndex,
	        currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
	        useVideoTimingInfo: useVideoTimingInfo,
	        firstVideoFrameTimeForData: firstVideoFrameTimeForData,
	        videoTimingInfo: segmentInfo.videoTimingInfo,
	        audioTimingInfo: segmentInfo.audioTimingInfo
	      });
	    } // Init segments for audio and video only need to be appended in certain cases. Now
	    // that data is about to be appended, we can check the final cases to determine
	    // whether we should append an init segment.
	
	
	    this.updateAppendInitSegmentStatus(segmentInfo, result.type); // Timestamp offset should be updated once we get new data and have its timing info,
	    // as we use the start of the segment to offset the best guess (playlist provided)
	    // timestamp offset.
	
	    this.updateSourceBufferTimestampOffset_(segmentInfo); // if this is a sync request we need to determine whether it should
	    // be appended or not.
	
	    if (segmentInfo.isSyncRequest) {
	      // first save/update our timing info for this segment.
	      // this is what allows us to choose an accurate segment
	      // and the main reason we make a sync request.
	      this.updateTimingInfoEnd_(segmentInfo);
	      this.syncController_.saveSegmentTimingInfo({
	        segmentInfo: segmentInfo,
	        shouldSaveTimelineMapping: this.loaderType_ === 'main'
	      });
	      var next = this.chooseNextRequest_(); // If the sync request isn't the segment that would be requested next
	      // after taking into account its timing info, do not append it.
	
	      if (next.mediaIndex !== segmentInfo.mediaIndex || next.partIndex !== segmentInfo.partIndex) {
	        this.logger_('sync segment was incorrect, not appending');
	        return;
	      } // otherwise append it like any other segment as our guess was correct.
	
	
	      this.logger_('sync segment was correct, appending');
	    } // Save some state so that in the future anything waiting on first append (and/or
	    // timestamp offset(s)) can process immediately. While the extra state isn't optimal,
	    // we need some notion of whether the timestamp offset or other relevant information
	    // has had a chance to be set.
	
	
	    segmentInfo.hasAppendedData_ = true; // Now that the timestamp offset should be set, we can append any waiting ID3 tags.
	
	    this.processMetadataQueue_();
	    this.appendData_(segmentInfo, result);
	  };
	
	  _proto.updateAppendInitSegmentStatus = function updateAppendInitSegmentStatus(segmentInfo, type) {
	    // alt audio doesn't manage timestamp offset
	    if (this.loaderType_ === 'main' && typeof segmentInfo.timestampOffset === 'number' && // in the case that we're handling partial data, we don't want to append an init
	    // segment for each chunk
	    !segmentInfo.changedTimestampOffset) {
	      // if the timestamp offset changed, the timeline may have changed, so we have to re-
	      // append init segments
	      this.appendInitSegment_ = {
	        audio: true,
	        video: true
	      };
	    }
	
	    if (this.playlistOfLastInitSegment_[type] !== segmentInfo.playlist) {
	      // make sure we append init segment on playlist changes, in case the media config
	      // changed
	      this.appendInitSegment_[type] = true;
	    }
	  };
	
	  _proto.getInitSegmentAndUpdateState_ = function getInitSegmentAndUpdateState_(_ref4) {
	    var type = _ref4.type,
	        initSegment = _ref4.initSegment,
	        map = _ref4.map,
	        playlist = _ref4.playlist; // "The EXT-X-MAP tag specifies how to obtain the Media Initialization Section
	    // (Section 3) required to parse the applicable Media Segments.  It applies to every
	    // Media Segment that appears after it in the Playlist until the next EXT-X-MAP tag
	    // or until the end of the playlist."
	    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.5
	
	    if (map) {
	      var id = initSegmentId(map);
	
	      if (this.activeInitSegmentId_ === id) {
	        // don't need to re-append the init segment if the ID matches
	        return null;
	      } // a map-specified init segment takes priority over any transmuxed (or otherwise
	      // obtained) init segment
	      //
	      // this also caches the init segment for later use
	
	
	      initSegment = this.initSegmentForMap(map, true).bytes;
	      this.activeInitSegmentId_ = id;
	    } // We used to always prepend init segments for video, however, that shouldn't be
	    // necessary. Instead, we should only append on changes, similar to what we've always
	    // done for audio. This is more important (though may not be that important) for
	    // frame-by-frame appending for LHLS, simply because of the increased quantity of
	    // appends.
	
	
	    if (initSegment && this.appendInitSegment_[type]) {
	      // Make sure we track the playlist that we last used for the init segment, so that
	      // we can re-append the init segment in the event that we get data from a new
	      // playlist. Discontinuities and track changes are handled in other sections.
	      this.playlistOfLastInitSegment_[type] = playlist; // Disable future init segment appends for this type. Until a change is necessary.
	
	      this.appendInitSegment_[type] = false; // we need to clear out the fmp4 active init segment id, since
	      // we are appending the muxer init segment
	
	      this.activeInitSegmentId_ = null;
	      return initSegment;
	    }
	
	    return null;
	  };
	
	  _proto.handleQuotaExceededError_ = function handleQuotaExceededError_(_ref5, error) {
	    var _this3 = this;
	
	    var segmentInfo = _ref5.segmentInfo,
	        type = _ref5.type,
	        bytes = _ref5.bytes;
	    var audioBuffered = this.sourceUpdater_.audioBuffered();
	    var videoBuffered = this.sourceUpdater_.videoBuffered(); // For now we're ignoring any notion of gaps in the buffer, but they, in theory,
	    // should be cleared out during the buffer removals. However, log in case it helps
	    // debug.
	
	    if (audioBuffered.length > 1) {
	      this.logger_('On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: ' + timeRangesToArray(audioBuffered).join(', '));
	    }
	
	    if (videoBuffered.length > 1) {
	      this.logger_('On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: ' + timeRangesToArray(videoBuffered).join(', '));
	    }
	
	    var audioBufferStart = audioBuffered.length ? audioBuffered.start(0) : 0;
	    var audioBufferEnd = audioBuffered.length ? audioBuffered.end(audioBuffered.length - 1) : 0;
	    var videoBufferStart = videoBuffered.length ? videoBuffered.start(0) : 0;
	    var videoBufferEnd = videoBuffered.length ? videoBuffered.end(videoBuffered.length - 1) : 0;
	
	    if (audioBufferEnd - audioBufferStart <= MIN_BACK_BUFFER && videoBufferEnd - videoBufferStart <= MIN_BACK_BUFFER) {
	      // Can't remove enough buffer to make room for new segment (or the browser doesn't
	      // allow for appends of segments this size). In the future, it may be possible to
	      // split up the segment and append in pieces, but for now, error out this playlist
	      // in an attempt to switch to a more manageable rendition.
	      this.logger_('On QUOTA_EXCEEDED_ERR, single segment too large to append to ' + 'buffer, triggering an error. ' + ("Appended byte length: " + bytes.byteLength + ", ") + ("audio buffer: " + timeRangesToArray(audioBuffered).join(', ') + ", ") + ("video buffer: " + timeRangesToArray(videoBuffered).join(', ') + ", "));
	      this.error({
	        message: 'Quota exceeded error with append of a single segment of content',
	        excludeUntil: Infinity
	      });
	      this.trigger('error');
	      return;
	    } // To try to resolve the quota exceeded error, clear back buffer and retry. This means
	    // that the segment-loader should block on future events until this one is handled, so
	    // that it doesn't keep moving onto further segments. Adding the call to the call
	    // queue will prevent further appends until waitingOnRemove_ and
	    // quotaExceededErrorRetryTimeout_ are cleared.
	    //
	    // Note that this will only block the current loader. In the case of demuxed content,
	    // the other load may keep filling as fast as possible. In practice, this should be
	    // OK, as it is a rare case when either audio has a high enough bitrate to fill up a
	    // source buffer, or video fills without enough room for audio to append (and without
	    // the availability of clearing out seconds of back buffer to make room for audio).
	    // But it might still be good to handle this case in the future as a TODO.
	
	
	    this.waitingOnRemove_ = true;
	    this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
	      segmentInfo: segmentInfo,
	      type: type,
	      bytes: bytes
	    }));
	    var currentTime = this.currentTime_(); // Try to remove as much audio and video as possible to make room for new content
	    // before retrying.
	
	    var timeToRemoveUntil = currentTime - MIN_BACK_BUFFER;
	    this.logger_("On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to " + timeToRemoveUntil);
	    this.remove(0, timeToRemoveUntil, function () {
	      _this3.logger_("On QUOTA_EXCEEDED_ERR, retrying append in " + MIN_BACK_BUFFER + "s");
	
	      _this3.waitingOnRemove_ = false; // wait the length of time alotted in the back buffer to prevent wasted
	      // attempts (since we can't clear less than the minimum)
	
	      _this3.quotaExceededErrorRetryTimeout_ = window__default['default'].setTimeout(function () {
	        _this3.logger_('On QUOTA_EXCEEDED_ERR, re-processing call queue');
	
	        _this3.quotaExceededErrorRetryTimeout_ = null;
	
	        _this3.processCallQueue_();
	      }, MIN_BACK_BUFFER * 1000);
	    }, true);
	  };
	
	  _proto.handleAppendError_ = function handleAppendError_(_ref6, error) {
	    var segmentInfo = _ref6.segmentInfo,
	        type = _ref6.type,
	        bytes = _ref6.bytes; // if there's no error, nothing to do
	
	    if (!error) {
	      return;
	    }
	
	    if (error.code === QUOTA_EXCEEDED_ERR) {
	      this.handleQuotaExceededError_({
	        segmentInfo: segmentInfo,
	        type: type,
	        bytes: bytes
	      }); // A quota exceeded error should be recoverable with a future re-append, so no need
	      // to trigger an append error.
	
	      return;
	    }
	
	    this.logger_('Received non QUOTA_EXCEEDED_ERR on append', error);
	    this.error(type + " append of " + bytes.length + "b failed for segment " + ("#" + segmentInfo.mediaIndex + " in playlist " + segmentInfo.playlist.id)); // If an append errors, we often can't recover.
	    // (see https://w3c.github.io/media-source/#sourcebuffer-append-error).
	    //
	    // Trigger a special error so that it can be handled separately from normal,
	    // recoverable errors.
	
	    this.trigger('appenderror');
	  };
	
	  _proto.appendToSourceBuffer_ = function appendToSourceBuffer_(_ref7) {
	    var segmentInfo = _ref7.segmentInfo,
	        type = _ref7.type,
	        initSegment = _ref7.initSegment,
	        data = _ref7.data,
	        bytes = _ref7.bytes; // If this is a re-append, bytes were already created and don't need to be recreated
	
	    if (!bytes) {
	      var segments = [data];
	      var byteLength = data.byteLength;
	
	      if (initSegment) {
	        // if the media initialization segment is changing, append it before the content
	        // segment
	        segments.unshift(initSegment);
	        byteLength += initSegment.byteLength;
	      } // Technically we should be OK appending the init segment separately, however, we
	      // haven't yet tested that, and prepending is how we have always done things.
	
	
	      bytes = concatSegments({
	        bytes: byteLength,
	        segments: segments
	      });
	    }
	
	    this.sourceUpdater_.appendBuffer({
	      segmentInfo: segmentInfo,
	      type: type,
	      bytes: bytes
	    }, this.handleAppendError_.bind(this, {
	      segmentInfo: segmentInfo,
	      type: type,
	      bytes: bytes
	    }));
	  };
	
	  _proto.handleSegmentTimingInfo_ = function handleSegmentTimingInfo_(type, requestId, segmentTimingInfo) {
	    if (!this.pendingSegment_ || requestId !== this.pendingSegment_.requestId) {
	      return;
	    }
	
	    var segment = this.pendingSegment_.segment;
	    var timingInfoProperty = type + "TimingInfo";
	
	    if (!segment[timingInfoProperty]) {
	      segment[timingInfoProperty] = {};
	    }
	
	    segment[timingInfoProperty].transmuxerPrependedSeconds = segmentTimingInfo.prependedContentDuration || 0;
	    segment[timingInfoProperty].transmuxedPresentationStart = segmentTimingInfo.start.presentation;
	    segment[timingInfoProperty].transmuxedDecodeStart = segmentTimingInfo.start.decode;
	    segment[timingInfoProperty].transmuxedPresentationEnd = segmentTimingInfo.end.presentation;
	    segment[timingInfoProperty].transmuxedDecodeEnd = segmentTimingInfo.end.decode; // mainly used as a reference for debugging
	
	    segment[timingInfoProperty].baseMediaDecodeTime = segmentTimingInfo.baseMediaDecodeTime;
	  };
	
	  _proto.appendData_ = function appendData_(segmentInfo, result) {
	    var type = result.type,
	        data = result.data;
	
	    if (!data || !data.byteLength) {
	      return;
	    }
	
	    if (type === 'audio' && this.audioDisabled_) {
	      return;
	    }
	
	    var initSegment = this.getInitSegmentAndUpdateState_({
	      type: type,
	      initSegment: result.initSegment,
	      playlist: segmentInfo.playlist,
	      map: segmentInfo.isFmp4 ? segmentInfo.segment.map : null
	    });
	    this.appendToSourceBuffer_({
	      segmentInfo: segmentInfo,
	      type: type,
	      initSegment: initSegment,
	      data: data
	    });
	  }
	  /**
	   * load a specific segment from a request into the buffer
	   *
	   * @private
	   */
	  ;
	
	  _proto.loadSegment_ = function loadSegment_(segmentInfo) {
	    var _this4 = this;
	
	    this.state = 'WAITING';
	    this.pendingSegment_ = segmentInfo;
	    this.trimBackBuffer_(segmentInfo);
	
	    if (typeof segmentInfo.timestampOffset === 'number') {
	      if (this.transmuxer_) {
	        this.transmuxer_.postMessage({
	          action: 'clearAllMp4Captions'
	        });
	      }
	    }
	
	    if (!this.hasEnoughInfoToLoad_()) {
	      this.loadQueue_.push(function () {
	        // regenerate the audioAppendStart, timestampOffset, etc as they
	        // may have changed since this function was added to the queue.
	        var options = _extends__default['default']({}, segmentInfo, {
	          forceTimestampOffset: true
	        });
	
	        _extends__default['default'](segmentInfo, _this4.generateSegmentInfo_(options));
	
	        _this4.isPendingTimestampOffset_ = false;
	
	        _this4.updateTransmuxerAndRequestSegment_(segmentInfo);
	      });
	      return;
	    }
	
	    this.updateTransmuxerAndRequestSegment_(segmentInfo);
	  };
	
	  _proto.updateTransmuxerAndRequestSegment_ = function updateTransmuxerAndRequestSegment_(segmentInfo) {
	    var _this5 = this; // We'll update the source buffer's timestamp offset once we have transmuxed data, but
	    // the transmuxer still needs to be updated before then.
	    //
	    // Even though keepOriginalTimestamps is set to true for the transmuxer, timestamp
	    // offset must be passed to the transmuxer for stream correcting adjustments.
	
	
	    if (this.shouldUpdateTransmuxerTimestampOffset_(segmentInfo.timestampOffset)) {
	      this.gopBuffer_.length = 0; // gopsToAlignWith was set before the GOP buffer was cleared
	
	      segmentInfo.gopsToAlignWith = [];
	      this.timeMapping_ = 0; // reset values in the transmuxer since a discontinuity should start fresh
	
	      this.transmuxer_.postMessage({
	        action: 'reset'
	      });
	      this.transmuxer_.postMessage({
	        action: 'setTimestampOffset',
	        timestampOffset: segmentInfo.timestampOffset
	      });
	    }
	
	    var simpleSegment = this.createSimplifiedSegmentObj_(segmentInfo);
	    var isEndOfStream = this.isEndOfStream_(segmentInfo.mediaIndex, segmentInfo.playlist, segmentInfo.partIndex);
	    var isWalkingForward = this.mediaIndex !== null;
	    var isDiscontinuity = segmentInfo.timeline !== this.currentTimeline_ && // currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
	    // the first timeline
	    segmentInfo.timeline > 0;
	    var isEndOfTimeline = isEndOfStream || isWalkingForward && isDiscontinuity;
	    this.logger_("Requesting " + segmentInfoString(segmentInfo)); // If there's an init segment associated with this segment, but it is not cached (identified by a lack of bytes),
	    // then this init segment has never been seen before and should be appended.
	    //
	    // At this point the content type (audio/video or both) is not yet known, but it should be safe to set
	    // both to true and leave the decision of whether to append the init segment to append time.
	
	    if (simpleSegment.map && !simpleSegment.map.bytes) {
	      this.logger_('going to request init segment.');
	      this.appendInitSegment_ = {
	        video: true,
	        audio: true
	      };
	    }
	
	    segmentInfo.abortRequests = mediaSegmentRequest({
	      xhr: this.vhs_.xhr,
	      xhrOptions: this.xhrOptions_,
	      decryptionWorker: this.decrypter_,
	      segment: simpleSegment,
	      abortFn: this.handleAbort_.bind(this, segmentInfo),
	      progressFn: this.handleProgress_.bind(this),
	      trackInfoFn: this.handleTrackInfo_.bind(this),
	      timingInfoFn: this.handleTimingInfo_.bind(this),
	      videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, 'video', segmentInfo.requestId),
	      audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, 'audio', segmentInfo.requestId),
	      captionsFn: this.handleCaptions_.bind(this),
	      isEndOfTimeline: isEndOfTimeline,
	      endedTimelineFn: function endedTimelineFn() {
	        _this5.logger_('received endedtimeline callback');
	      },
	      id3Fn: this.handleId3_.bind(this),
	      dataFn: this.handleData_.bind(this),
	      doneFn: this.segmentRequestFinished_.bind(this),
	      onTransmuxerLog: function onTransmuxerLog(_ref8) {
	        var message = _ref8.message,
	            level = _ref8.level,
	            stream = _ref8.stream;
	
	        _this5.logger_(segmentInfoString(segmentInfo) + " logged from transmuxer stream " + stream + " as a " + level + ": " + message);
	      }
	    });
	  }
	  /**
	   * trim the back buffer so that we don't have too much data
	   * in the source buffer
	   *
	   * @private
	   *
	   * @param {Object} segmentInfo - the current segment
	   */
	  ;
	
	  _proto.trimBackBuffer_ = function trimBackBuffer_(segmentInfo) {
	    var removeToTime = safeBackBufferTrimTime(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10); // Chrome has a hard limit of 150MB of
	    // buffer and a very conservative "garbage collector"
	    // We manually clear out the old buffer to ensure
	    // we don't trigger the QuotaExceeded error
	    // on the source buffer during subsequent appends
	
	    if (removeToTime > 0) {
	      this.remove(0, removeToTime);
	    }
	  }
	  /**
	   * created a simplified copy of the segment object with just the
	   * information necessary to perform the XHR and decryption
	   *
	   * @private
	   *
	   * @param {Object} segmentInfo - the current segment
	   * @return {Object} a simplified segment object copy
	   */
	  ;
	
	  _proto.createSimplifiedSegmentObj_ = function createSimplifiedSegmentObj_(segmentInfo) {
	    var segment = segmentInfo.segment;
	    var part = segmentInfo.part;
	    var simpleSegment = {
	      resolvedUri: part ? part.resolvedUri : segment.resolvedUri,
	      byterange: part ? part.byterange : segment.byterange,
	      requestId: segmentInfo.requestId,
	      transmuxer: segmentInfo.transmuxer,
	      audioAppendStart: segmentInfo.audioAppendStart,
	      gopsToAlignWith: segmentInfo.gopsToAlignWith,
	      part: segmentInfo.part
	    };
	    var previousSegment = segmentInfo.playlist.segments[segmentInfo.mediaIndex - 1];
	
	    if (previousSegment && previousSegment.timeline === segment.timeline) {
	      // The baseStartTime of a segment is used to handle rollover when probing the TS
	      // segment to retrieve timing information. Since the probe only looks at the media's
	      // times (e.g., PTS and DTS values of the segment), and doesn't consider the
	      // player's time (e.g., player.currentTime()), baseStartTime should reflect the
	      // media time as well. transmuxedDecodeEnd represents the end time of a segment, in
	      // seconds of media time, so should be used here. The previous segment is used since
	      // the end of the previous segment should represent the beginning of the current
	      // segment, so long as they are on the same timeline.
	      if (previousSegment.videoTimingInfo) {
	        simpleSegment.baseStartTime = previousSegment.videoTimingInfo.transmuxedDecodeEnd;
	      } else if (previousSegment.audioTimingInfo) {
	        simpleSegment.baseStartTime = previousSegment.audioTimingInfo.transmuxedDecodeEnd;
	      }
	    }
	
	    if (segment.key) {
	      // if the media sequence is greater than 2^32, the IV will be incorrect
	      // assuming 10s segments, that would be about 1300 years
	      var iv = segment.key.iv || new Uint32Array([0, 0, 0, segmentInfo.mediaIndex + segmentInfo.playlist.mediaSequence]);
	      simpleSegment.key = this.segmentKey(segment.key);
	      simpleSegment.key.iv = iv;
	    }
	
	    if (segment.map) {
	      simpleSegment.map = this.initSegmentForMap(segment.map);
	    }
	
	    return simpleSegment;
	  };
	
	  _proto.saveTransferStats_ = function saveTransferStats_(stats) {
	    // every request counts as a media request even if it has been aborted
	    // or canceled due to a timeout
	    this.mediaRequests += 1;
	
	    if (stats) {
	      this.mediaBytesTransferred += stats.bytesReceived;
	      this.mediaTransferDuration += stats.roundTripTime;
	    }
	  };
	
	  _proto.saveBandwidthRelatedStats_ = function saveBandwidthRelatedStats_(duration, stats) {
	    // byteLength will be used for throughput, and should be based on bytes receieved,
	    // which we only know at the end of the request and should reflect total bytes
	    // downloaded rather than just bytes processed from components of the segment
	    this.pendingSegment_.byteLength = stats.bytesReceived;
	
	    if (duration < MIN_SEGMENT_DURATION_TO_SAVE_STATS) {
	      this.logger_("Ignoring segment's bandwidth because its duration of " + duration + (" is less than the min to record " + MIN_SEGMENT_DURATION_TO_SAVE_STATS));
	      return;
	    }
	
	    this.bandwidth = stats.bandwidth;
	    this.roundTrip = stats.roundTripTime;
	  };
	
	  _proto.handleTimeout_ = function handleTimeout_() {
	    // although the VTT segment loader bandwidth isn't really used, it's good to
	    // maintain functinality between segment loaders
	    this.mediaRequestsTimedout += 1;
	    this.bandwidth = 1;
	    this.roundTrip = NaN;
	    this.trigger('bandwidthupdate');
	    this.trigger('timeout');
	  }
	  /**
	   * Handle the callback from the segmentRequest function and set the
	   * associated SegmentLoader state and errors if necessary
	   *
	   * @private
	   */
	  ;
	
	  _proto.segmentRequestFinished_ = function segmentRequestFinished_(error, simpleSegment, result) {
	    // TODO handle special cases, e.g., muxed audio/video but only audio in the segment
	    // check the call queue directly since this function doesn't need to deal with any
	    // data, and can continue even if the source buffers are not set up and we didn't get
	    // any data from the segment
	    if (this.callQueue_.length) {
	      this.callQueue_.push(this.segmentRequestFinished_.bind(this, error, simpleSegment, result));
	      return;
	    }
	
	    this.saveTransferStats_(simpleSegment.stats); // The request was aborted and the SegmentLoader has already been reset
	
	    if (!this.pendingSegment_) {
	      return;
	    } // the request was aborted and the SegmentLoader has already started
	    // another request. this can happen when the timeout for an aborted
	    // request triggers due to a limitation in the XHR library
	    // do not count this as any sort of request or we risk double-counting
	
	
	    if (simpleSegment.requestId !== this.pendingSegment_.requestId) {
	      return;
	    } // an error occurred from the active pendingSegment_ so reset everything
	
	
	    if (error) {
	      this.pendingSegment_ = null;
	      this.state = 'READY'; // aborts are not a true error condition and nothing corrective needs to be done
	
	      if (error.code === REQUEST_ERRORS.ABORTED) {
	        return;
	      }
	
	      this.pause(); // the error is really just that at least one of the requests timed-out
	      // set the bandwidth to a very low value and trigger an ABR switch to
	      // take emergency action
	
	      if (error.code === REQUEST_ERRORS.TIMEOUT) {
	        this.handleTimeout_();
	        return;
	      } // if control-flow has arrived here, then the error is real
	      // emit an error event to blacklist the current playlist
	
	
	      this.mediaRequestsErrored += 1;
	      this.error(error);
	      this.trigger('error');
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // the response was a success so set any bandwidth stats the request
	    // generated for ABR purposes
	
	    this.saveBandwidthRelatedStats_(segmentInfo.duration, simpleSegment.stats);
	    segmentInfo.endOfAllRequests = simpleSegment.endOfAllRequests;
	
	    if (result.gopInfo) {
	      this.gopBuffer_ = updateGopBuffer(this.gopBuffer_, result.gopInfo, this.safeAppend_);
	    } // Although we may have already started appending on progress, we shouldn't switch the
	    // state away from loading until we are officially done loading the segment data.
	
	
	    this.state = 'APPENDING'; // used for testing
	
	    this.trigger('appending');
	    this.waitForAppendsToComplete_(segmentInfo);
	  };
	
	  _proto.setTimeMapping_ = function setTimeMapping_(timeline) {
	    var timelineMapping = this.syncController_.mappingForTimeline(timeline);
	
	    if (timelineMapping !== null) {
	      this.timeMapping_ = timelineMapping;
	    }
	  };
	
	  _proto.updateMediaSecondsLoaded_ = function updateMediaSecondsLoaded_(segment) {
	    if (typeof segment.start === 'number' && typeof segment.end === 'number') {
	      this.mediaSecondsLoaded += segment.end - segment.start;
	    } else {
	      this.mediaSecondsLoaded += segment.duration;
	    }
	  };
	
	  _proto.shouldUpdateTransmuxerTimestampOffset_ = function shouldUpdateTransmuxerTimestampOffset_(timestampOffset) {
	    if (timestampOffset === null) {
	      return false;
	    } // note that we're potentially using the same timestamp offset for both video and
	    // audio
	
	
	    if (this.loaderType_ === 'main' && timestampOffset !== this.sourceUpdater_.videoTimestampOffset()) {
	      return true;
	    }
	
	    if (!this.audioDisabled_ && timestampOffset !== this.sourceUpdater_.audioTimestampOffset()) {
	      return true;
	    }
	
	    return false;
	  };
	
	  _proto.trueSegmentStart_ = function trueSegmentStart_(_ref9) {
	    var currentStart = _ref9.currentStart,
	        playlist = _ref9.playlist,
	        mediaIndex = _ref9.mediaIndex,
	        firstVideoFrameTimeForData = _ref9.firstVideoFrameTimeForData,
	        currentVideoTimestampOffset = _ref9.currentVideoTimestampOffset,
	        useVideoTimingInfo = _ref9.useVideoTimingInfo,
	        videoTimingInfo = _ref9.videoTimingInfo,
	        audioTimingInfo = _ref9.audioTimingInfo;
	
	    if (typeof currentStart !== 'undefined') {
	      // if start was set once, keep using it
	      return currentStart;
	    }
	
	    if (!useVideoTimingInfo) {
	      return audioTimingInfo.start;
	    }
	
	    var previousSegment = playlist.segments[mediaIndex - 1]; // The start of a segment should be the start of the first full frame contained
	    // within that segment. Since the transmuxer maintains a cache of incomplete data
	    // from and/or the last frame seen, the start time may reflect a frame that starts
	    // in the previous segment. Check for that case and ensure the start time is
	    // accurate for the segment.
	
	    if (mediaIndex === 0 || !previousSegment || typeof previousSegment.start === 'undefined' || previousSegment.end !== firstVideoFrameTimeForData + currentVideoTimestampOffset) {
	      return firstVideoFrameTimeForData;
	    }
	
	    return videoTimingInfo.start;
	  };
	
	  _proto.waitForAppendsToComplete_ = function waitForAppendsToComplete_(segmentInfo) {
	    var trackInfo = this.getCurrentMediaInfo_(segmentInfo);
	
	    if (!trackInfo) {
	      this.error({
	        message: 'No starting media returned, likely due to an unsupported media format.',
	        blacklistDuration: Infinity
	      });
	      this.trigger('error');
	      return;
	    } // Although transmuxing is done, appends may not yet be finished. Throw a marker
	    // on each queue this loader is responsible for to ensure that the appends are
	    // complete.
	
	
	    var hasAudio = trackInfo.hasAudio,
	        hasVideo = trackInfo.hasVideo,
	        isMuxed = trackInfo.isMuxed;
	    var waitForVideo = this.loaderType_ === 'main' && hasVideo;
	    var waitForAudio = !this.audioDisabled_ && hasAudio && !isMuxed;
	    segmentInfo.waitingOnAppends = 0; // segments with no data
	
	    if (!segmentInfo.hasAppendedData_) {
	      if (!segmentInfo.timingInfo && typeof segmentInfo.timestampOffset === 'number') {
	        // When there's no audio or video data in the segment, there's no audio or video
	        // timing information.
	        //
	        // If there's no audio or video timing information, then the timestamp offset
	        // can't be adjusted to the appropriate value for the transmuxer and source
	        // buffers.
	        //
	        // Therefore, the next segment should be used to set the timestamp offset.
	        this.isPendingTimestampOffset_ = true;
	      } // override settings for metadata only segments
	
	
	      segmentInfo.timingInfo = {
	        start: 0
	      };
	      segmentInfo.waitingOnAppends++;
	
	      if (!this.isPendingTimestampOffset_) {
	        // update the timestampoffset
	        this.updateSourceBufferTimestampOffset_(segmentInfo); // make sure the metadata queue is processed even though we have
	        // no video/audio data.
	
	        this.processMetadataQueue_();
	      } // append is "done" instantly with no data.
	
	
	      this.checkAppendsDone_(segmentInfo);
	      return;
	    } // Since source updater could call back synchronously, do the increments first.
	
	
	    if (waitForVideo) {
	      segmentInfo.waitingOnAppends++;
	    }
	
	    if (waitForAudio) {
	      segmentInfo.waitingOnAppends++;
	    }
	
	    if (waitForVideo) {
	      this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, segmentInfo));
	    }
	
	    if (waitForAudio) {
	      this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, segmentInfo));
	    }
	  };
	
	  _proto.checkAppendsDone_ = function checkAppendsDone_(segmentInfo) {
	    if (this.checkForAbort_(segmentInfo.requestId)) {
	      return;
	    }
	
	    segmentInfo.waitingOnAppends--;
	
	    if (segmentInfo.waitingOnAppends === 0) {
	      this.handleAppendsDone_();
	    }
	  };
	
	  _proto.checkForIllegalMediaSwitch = function checkForIllegalMediaSwitch(trackInfo) {
	    var illegalMediaSwitchError = illegalMediaSwitch(this.loaderType_, this.getCurrentMediaInfo_(), trackInfo);
	
	    if (illegalMediaSwitchError) {
	      this.error({
	        message: illegalMediaSwitchError,
	        blacklistDuration: Infinity
	      });
	      this.trigger('error');
	      return true;
	    }
	
	    return false;
	  };
	
	  _proto.updateSourceBufferTimestampOffset_ = function updateSourceBufferTimestampOffset_(segmentInfo) {
	    if (segmentInfo.timestampOffset === null || // we don't yet have the start for whatever media type (video or audio) has
	    // priority, timing-wise, so we must wait
	    typeof segmentInfo.timingInfo.start !== 'number' || // already updated the timestamp offset for this segment
	    segmentInfo.changedTimestampOffset || // the alt audio loader should not be responsible for setting the timestamp offset
	    this.loaderType_ !== 'main') {
	      return;
	    }
	
	    var didChange = false; // Primary timing goes by video, and audio is trimmed in the transmuxer, meaning that
	    // the timing info here comes from video. In the event that the audio is longer than
	    // the video, this will trim the start of the audio.
	    // This also trims any offset from 0 at the beginning of the media
	
	    segmentInfo.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
	      videoTimingInfo: segmentInfo.segment.videoTimingInfo,
	      audioTimingInfo: segmentInfo.segment.audioTimingInfo,
	      timingInfo: segmentInfo.timingInfo
	    }); // In the event that there are part segment downloads, each will try to update the
	    // timestamp offset. Retaining this bit of state prevents us from updating in the
	    // future (within the same segment), however, there may be a better way to handle it.
	
	    segmentInfo.changedTimestampOffset = true;
	
	    if (segmentInfo.timestampOffset !== this.sourceUpdater_.videoTimestampOffset()) {
	      this.sourceUpdater_.videoTimestampOffset(segmentInfo.timestampOffset);
	      didChange = true;
	    }
	
	    if (segmentInfo.timestampOffset !== this.sourceUpdater_.audioTimestampOffset()) {
	      this.sourceUpdater_.audioTimestampOffset(segmentInfo.timestampOffset);
	      didChange = true;
	    }
	
	    if (didChange) {
	      this.trigger('timestampoffset');
	    }
	  };
	
	  _proto.getSegmentStartTimeForTimestampOffsetCalculation_ = function getSegmentStartTimeForTimestampOffsetCalculation_(_ref10) {
	    var videoTimingInfo = _ref10.videoTimingInfo,
	        audioTimingInfo = _ref10.audioTimingInfo,
	        timingInfo = _ref10.timingInfo;
	
	    if (!this.useDtsForTimestampOffset_) {
	      return timingInfo.start;
	    }
	
	    if (videoTimingInfo && typeof videoTimingInfo.transmuxedDecodeStart === 'number') {
	      return videoTimingInfo.transmuxedDecodeStart;
	    } // handle audio only
	
	
	    if (audioTimingInfo && typeof audioTimingInfo.transmuxedDecodeStart === 'number') {
	      return audioTimingInfo.transmuxedDecodeStart;
	    } // handle content not transmuxed (e.g., MP4)
	
	
	    return timingInfo.start;
	  };
	
	  _proto.updateTimingInfoEnd_ = function updateTimingInfoEnd_(segmentInfo) {
	    segmentInfo.timingInfo = segmentInfo.timingInfo || {};
	    var trackInfo = this.getMediaInfo_();
	    var useVideoTimingInfo = this.loaderType_ === 'main' && trackInfo && trackInfo.hasVideo;
	    var prioritizedTimingInfo = useVideoTimingInfo && segmentInfo.videoTimingInfo ? segmentInfo.videoTimingInfo : segmentInfo.audioTimingInfo;
	
	    if (!prioritizedTimingInfo) {
	      return;
	    }
	
	    segmentInfo.timingInfo.end = typeof prioritizedTimingInfo.end === 'number' ? // End time may not exist in a case where we aren't parsing the full segment (one
	    // current example is the case of fmp4), so use the rough duration to calculate an
	    // end time.
	    prioritizedTimingInfo.end : prioritizedTimingInfo.start + segmentInfo.duration;
	  }
	  /**
	   * callback to run when appendBuffer is finished. detects if we are
	   * in a good state to do things with the data we got, or if we need
	   * to wait for more
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleAppendsDone_ = function handleAppendsDone_() {
	    // appendsdone can cause an abort
	    if (this.pendingSegment_) {
	      this.trigger('appendsdone');
	    }
	
	    if (!this.pendingSegment_) {
	      this.state = 'READY'; // TODO should this move into this.checkForAbort to speed up requests post abort in
	      // all appending cases?
	
	      if (!this.paused()) {
	        this.monitorBuffer_();
	      }
	
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // Now that the end of the segment has been reached, we can set the end time. It's
	    // best to wait until all appends are done so we're sure that the primary media is
	    // finished (and we have its end time).
	
	    this.updateTimingInfoEnd_(segmentInfo);
	
	    if (this.shouldSaveSegmentTimingInfo_) {
	      // Timeline mappings should only be saved for the main loader. This is for multiple
	      // reasons:
	      //
	      // 1) Only one mapping is saved per timeline, meaning that if both the audio loader
	      //    and the main loader try to save the timeline mapping, whichever comes later
	      //    will overwrite the first. In theory this is OK, as the mappings should be the
	      //    same, however, it breaks for (2)
	      // 2) In the event of a live stream, the initial live point will make for a somewhat
	      //    arbitrary mapping. If audio and video streams are not perfectly in-sync, then
	      //    the mapping will be off for one of the streams, dependent on which one was
	      //    first saved (see (1)).
	      // 3) Primary timing goes by video in VHS, so the mapping should be video.
	      //
	      // Since the audio loader will wait for the main loader to load the first segment,
	      // the main loader will save the first timeline mapping, and ensure that there won't
	      // be a case where audio loads two segments without saving a mapping (thus leading
	      // to missing segment timing info).
	      this.syncController_.saveSegmentTimingInfo({
	        segmentInfo: segmentInfo,
	        shouldSaveTimelineMapping: this.loaderType_ === 'main'
	      });
	    }
	
	    var segmentDurationMessage = getTroublesomeSegmentDurationMessage(segmentInfo, this.sourceType_);
	
	    if (segmentDurationMessage) {
	      if (segmentDurationMessage.severity === 'warn') {
	        videojs.log.warn(segmentDurationMessage.message);
	      } else {
	        this.logger_(segmentDurationMessage.message);
	      }
	    }
	
	    this.recordThroughput_(segmentInfo);
	    this.pendingSegment_ = null;
	    this.state = 'READY';
	
	    if (segmentInfo.isSyncRequest) {
	      this.trigger('syncinfoupdate'); // if the sync request was not appended
	      // then it was not the correct segment.
	      // throw it away and use the data it gave us
	      // to get the correct one.
	
	      if (!segmentInfo.hasAppendedData_) {
	        this.logger_("Throwing away un-appended sync request " + segmentInfoString(segmentInfo));
	        return;
	      }
	    }
	
	    this.logger_("Appended " + segmentInfoString(segmentInfo));
	    this.addSegmentMetadataCue_(segmentInfo);
	    this.fetchAtBuffer_ = true;
	
	    if (this.currentTimeline_ !== segmentInfo.timeline) {
	      this.timelineChangeController_.lastTimelineChange({
	        type: this.loaderType_,
	        from: this.currentTimeline_,
	        to: segmentInfo.timeline
	      }); // If audio is not disabled, the main segment loader is responsible for updating
	      // the audio timeline as well. If the content is video only, this won't have any
	      // impact.
	
	      if (this.loaderType_ === 'main' && !this.audioDisabled_) {
	        this.timelineChangeController_.lastTimelineChange({
	          type: 'audio',
	          from: this.currentTimeline_,
	          to: segmentInfo.timeline
	        });
	      }
	    }
	
	    this.currentTimeline_ = segmentInfo.timeline; // We must update the syncinfo to recalculate the seekable range before
	    // the following conditional otherwise it may consider this a bad "guess"
	    // and attempt to resync when the post-update seekable window and live
	    // point would mean that this was the perfect segment to fetch
	
	    this.trigger('syncinfoupdate');
	    var segment = segmentInfo.segment;
	    var part = segmentInfo.part;
	    var badSegmentGuess = segment.end && this.currentTime_() - segment.end > segmentInfo.playlist.targetDuration * 3;
	    var badPartGuess = part && part.end && this.currentTime_() - part.end > segmentInfo.playlist.partTargetDuration * 3; // If we previously appended a segment/part that ends more than 3 part/targetDurations before
	    // the currentTime_ that means that our conservative guess was too conservative.
	    // In that case, reset the loader state so that we try to use any information gained
	    // from the previous request to create a new, more accurate, sync-point.
	
	    if (badSegmentGuess || badPartGuess) {
	      this.logger_("bad " + (badSegmentGuess ? 'segment' : 'part') + " " + segmentInfoString(segmentInfo));
	      this.resetEverything();
	      return;
	    }
	
	    var isWalkingForward = this.mediaIndex !== null; // Don't do a rendition switch unless we have enough time to get a sync segment
	    // and conservatively guess
	
	    if (isWalkingForward) {
	      this.trigger('bandwidthupdate');
	    }
	
	    this.trigger('progress');
	    this.mediaIndex = segmentInfo.mediaIndex;
	    this.partIndex = segmentInfo.partIndex; // any time an update finishes and the last segment is in the
	    // buffer, end the stream. this ensures the "ended" event will
	    // fire if playback reaches that point.
	
	    if (this.isEndOfStream_(segmentInfo.mediaIndex, segmentInfo.playlist, segmentInfo.partIndex)) {
	      this.endOfStream();
	    } // used for testing
	
	
	    this.trigger('appended');
	
	    if (segmentInfo.hasAppendedData_) {
	      this.mediaAppends++;
	    }
	
	    if (!this.paused()) {
	      this.monitorBuffer_();
	    }
	  }
	  /**
	   * Records the current throughput of the decrypt, transmux, and append
	   * portion of the semgment pipeline. `throughput.rate` is a the cumulative
	   * moving average of the throughput. `throughput.count` is the number of
	   * data points in the average.
	   *
	   * @private
	   * @param {Object} segmentInfo the object returned by loadSegment
	   */
	  ;
	
	  _proto.recordThroughput_ = function recordThroughput_(segmentInfo) {
	    if (segmentInfo.duration < MIN_SEGMENT_DURATION_TO_SAVE_STATS) {
	      this.logger_("Ignoring segment's throughput because its duration of " + segmentInfo.duration + (" is less than the min to record " + MIN_SEGMENT_DURATION_TO_SAVE_STATS));
	      return;
	    }
	
	    var rate = this.throughput.rate; // Add one to the time to ensure that we don't accidentally attempt to divide
	    // by zero in the case where the throughput is ridiculously high
	
	    var segmentProcessingTime = Date.now() - segmentInfo.endOfAllRequests + 1; // Multiply by 8000 to convert from bytes/millisecond to bits/second
	
	    var segmentProcessingThroughput = Math.floor(segmentInfo.byteLength / segmentProcessingTime * 8 * 1000); // This is just a cumulative moving average calculation:
	    //   newAvg = oldAvg + (sample - oldAvg) / (sampleCount + 1)
	
	    this.throughput.rate += (segmentProcessingThroughput - rate) / ++this.throughput.count;
	  }
	  /**
	   * Adds a cue to the segment-metadata track with some metadata information about the
	   * segment
	   *
	   * @private
	   * @param {Object} segmentInfo
	   *        the object returned by loadSegment
	   * @method addSegmentMetadataCue_
	   */
	  ;
	
	  _proto.addSegmentMetadataCue_ = function addSegmentMetadataCue_(segmentInfo) {
	    if (!this.segmentMetadataTrack_) {
	      return;
	    }
	
	    var segment = segmentInfo.segment;
	    var start = segment.start;
	    var end = segment.end; // Do not try adding the cue if the start and end times are invalid.
	
	    if (!finite(start) || !finite(end)) {
	      return;
	    }
	
	    removeCuesFromTrack(start, end, this.segmentMetadataTrack_);
	    var Cue = window__default['default'].WebKitDataCue || window__default['default'].VTTCue;
	    var value = {
	      custom: segment.custom,
	      dateTimeObject: segment.dateTimeObject,
	      dateTimeString: segment.dateTimeString,
	      bandwidth: segmentInfo.playlist.attributes.BANDWIDTH,
	      resolution: segmentInfo.playlist.attributes.RESOLUTION,
	      codecs: segmentInfo.playlist.attributes.CODECS,
	      byteLength: segmentInfo.byteLength,
	      uri: segmentInfo.uri,
	      timeline: segmentInfo.timeline,
	      playlist: segmentInfo.playlist.id,
	      start: start,
	      end: end
	    };
	    var data = JSON.stringify(value);
	    var cue = new Cue(start, end, data); // Attach the metadata to the value property of the cue to keep consistency between
	    // the differences of WebKitDataCue in safari and VTTCue in other browsers
	
	    cue.value = value;
	    this.segmentMetadataTrack_.addCue(cue);
	  };
	
	  return SegmentLoader;
	}(videojs.EventTarget);
	
	function noop() {}
	
	var toTitleCase = function toTitleCase(string) {
	  if (typeof string !== 'string') {
	    return string;
	  }
	
	  return string.replace(/./, function (w) {
	    return w.toUpperCase();
	  });
	};
	
	var bufferTypes = ['video', 'audio'];
	
	var _updating = function updating(type, sourceUpdater) {
	  var sourceBuffer = sourceUpdater[type + "Buffer"];
	  return sourceBuffer && sourceBuffer.updating || sourceUpdater.queuePending[type];
	};
	
	var nextQueueIndexOfType = function nextQueueIndexOfType(type, queue) {
	  for (var i = 0; i < queue.length; i++) {
	    var queueEntry = queue[i];
	
	    if (queueEntry.type === 'mediaSource') {
	      // If the next entry is a media source entry (uses multiple source buffers), block
	      // processing to allow it to go through first.
	      return null;
	    }
	
	    if (queueEntry.type === type) {
	      return i;
	    }
	  }
	
	  return null;
	};
	
	var shiftQueue = function shiftQueue(type, sourceUpdater) {
	  if (sourceUpdater.queue.length === 0) {
	    return;
	  }
	
	  var queueIndex = 0;
	  var queueEntry = sourceUpdater.queue[queueIndex];
	
	  if (queueEntry.type === 'mediaSource') {
	    if (!sourceUpdater.updating() && sourceUpdater.mediaSource.readyState !== 'closed') {
	      sourceUpdater.queue.shift();
	      queueEntry.action(sourceUpdater);
	
	      if (queueEntry.doneFn) {
	        queueEntry.doneFn();
	      } // Only specific source buffer actions must wait for async updateend events. Media
	      // Source actions process synchronously. Therefore, both audio and video source
	      // buffers are now clear to process the next queue entries.
	
	
	      shiftQueue('audio', sourceUpdater);
	      shiftQueue('video', sourceUpdater);
	    } // Media Source actions require both source buffers, so if the media source action
	    // couldn't process yet (because one or both source buffers are busy), block other
	    // queue actions until both are available and the media source action can process.
	
	
	    return;
	  }
	
	  if (type === 'mediaSource') {
	    // If the queue was shifted by a media source action (this happens when pushing a
	    // media source action onto the queue), then it wasn't from an updateend event from an
	    // audio or video source buffer, so there's no change from previous state, and no
	    // processing should be done.
	    return;
	  } // Media source queue entries don't need to consider whether the source updater is
	  // started (i.e., source buffers are created) as they don't need the source buffers, but
	  // source buffer queue entries do.
	
	
	  if (!sourceUpdater.ready() || sourceUpdater.mediaSource.readyState === 'closed' || _updating(type, sourceUpdater)) {
	    return;
	  }
	
	  if (queueEntry.type !== type) {
	    queueIndex = nextQueueIndexOfType(type, sourceUpdater.queue);
	
	    if (queueIndex === null) {
	      // Either there's no queue entry that uses this source buffer type in the queue, or
	      // there's a media source queue entry before the next entry of this type, in which
	      // case wait for that action to process first.
	      return;
	    }
	
	    queueEntry = sourceUpdater.queue[queueIndex];
	  }
	
	  sourceUpdater.queue.splice(queueIndex, 1); // Keep a record that this source buffer type is in use.
	  //
	  // The queue pending operation must be set before the action is performed in the event
	  // that the action results in a synchronous event that is acted upon. For instance, if
	  // an exception is thrown that can be handled, it's possible that new actions will be
	  // appended to an empty queue and immediately executed, but would not have the correct
	  // pending information if this property was set after the action was performed.
	
	  sourceUpdater.queuePending[type] = queueEntry;
	  queueEntry.action(type, sourceUpdater);
	
	  if (!queueEntry.doneFn) {
	    // synchronous operation, process next entry
	    sourceUpdater.queuePending[type] = null;
	    shiftQueue(type, sourceUpdater);
	    return;
	  }
	};
	
	var cleanupBuffer = function cleanupBuffer(type, sourceUpdater) {
	  var buffer = sourceUpdater[type + "Buffer"];
	  var titleType = toTitleCase(type);
	
	  if (!buffer) {
	    return;
	  }
	
	  buffer.removeEventListener('updateend', sourceUpdater["on" + titleType + "UpdateEnd_"]);
	  buffer.removeEventListener('error', sourceUpdater["on" + titleType + "Error_"]);
	  sourceUpdater.codecs[type] = null;
	  sourceUpdater[type + "Buffer"] = null;
	};
	
	var inSourceBuffers = function inSourceBuffers(mediaSource, sourceBuffer) {
	  return mediaSource && sourceBuffer && Array.prototype.indexOf.call(mediaSource.sourceBuffers, sourceBuffer) !== -1;
	};
	
	var actions = {
	  appendBuffer: function appendBuffer(bytes, segmentInfo, onError) {
	    return function (type, sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"]; // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("Appending segment " + segmentInfo.mediaIndex + "'s " + bytes.length + " bytes to " + type + "Buffer");
	
	      try {
	        sourceBuffer.appendBuffer(bytes);
	      } catch (e) {
	        sourceUpdater.logger_("Error with code " + e.code + " " + (e.code === QUOTA_EXCEEDED_ERR ? '(QUOTA_EXCEEDED_ERR) ' : '') + ("when appending segment " + segmentInfo.mediaIndex + " to " + type + "Buffer"));
	        sourceUpdater.queuePending[type] = null;
	        onError(e);
	      }
	    };
	  },
	  remove: function remove(start, end) {
	    return function (type, sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"]; // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("Removing " + start + " to " + end + " from " + type + "Buffer");
	
	      try {
	        sourceBuffer.remove(start, end);
	      } catch (e) {
	        sourceUpdater.logger_("Remove " + start + " to " + end + " from " + type + "Buffer failed");
	      }
	    };
	  },
	  timestampOffset: function timestampOffset(offset) {
	    return function (type, sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"]; // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("Setting " + type + "timestampOffset to " + offset);
	      sourceBuffer.timestampOffset = offset;
	    };
	  },
	  callback: function callback(_callback) {
	    return function (type, sourceUpdater) {
	      _callback();
	    };
	  },
	  endOfStream: function endOfStream(error) {
	    return function (sourceUpdater) {
	      if (sourceUpdater.mediaSource.readyState !== 'open') {
	        return;
	      }
	
	      sourceUpdater.logger_("Calling mediaSource endOfStream(" + (error || '') + ")");
	
	      try {
	        sourceUpdater.mediaSource.endOfStream(error);
	      } catch (e) {
	        videojs.log.warn('Failed to call media source endOfStream', e);
	      }
	    };
	  },
	  duration: function duration(_duration) {
	    return function (sourceUpdater) {
	      sourceUpdater.logger_("Setting mediaSource duration to " + _duration);
	
	      try {
	        sourceUpdater.mediaSource.duration = _duration;
	      } catch (e) {
	        videojs.log.warn('Failed to set media source duration', e);
	      }
	    };
	  },
	  abort: function abort() {
	    return function (type, sourceUpdater) {
	      if (sourceUpdater.mediaSource.readyState !== 'open') {
	        return;
	      }
	
	      var sourceBuffer = sourceUpdater[type + "Buffer"]; // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("calling abort on " + type + "Buffer");
	
	      try {
	        sourceBuffer.abort();
	      } catch (e) {
	        videojs.log.warn("Failed to abort on " + type + "Buffer", e);
	      }
	    };
	  },
	  addSourceBuffer: function addSourceBuffer(type, codec) {
	    return function (sourceUpdater) {
	      var titleType = toTitleCase(type);
	      var mime = codecs_js.getMimeForCodec(codec);
	      sourceUpdater.logger_("Adding " + type + "Buffer with codec " + codec + " to mediaSource");
	      var sourceBuffer = sourceUpdater.mediaSource.addSourceBuffer(mime);
	      sourceBuffer.addEventListener('updateend', sourceUpdater["on" + titleType + "UpdateEnd_"]);
	      sourceBuffer.addEventListener('error', sourceUpdater["on" + titleType + "Error_"]);
	      sourceUpdater.codecs[type] = codec;
	      sourceUpdater[type + "Buffer"] = sourceBuffer;
	    };
	  },
	  removeSourceBuffer: function removeSourceBuffer(type) {
	    return function (sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"];
	      cleanupBuffer(type, sourceUpdater); // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("Removing " + type + "Buffer with codec " + sourceUpdater.codecs[type] + " from mediaSource");
	
	      try {
	        sourceUpdater.mediaSource.removeSourceBuffer(sourceBuffer);
	      } catch (e) {
	        videojs.log.warn("Failed to removeSourceBuffer " + type + "Buffer", e);
	      }
	    };
	  },
	  changeType: function changeType(codec) {
	    return function (type, sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"];
	      var mime = codecs_js.getMimeForCodec(codec); // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      } // do not update codec if we don't need to.
	
	
	      if (sourceUpdater.codecs[type] === codec) {
	        return;
	      }
	
	      sourceUpdater.logger_("changing " + type + "Buffer codec from " + sourceUpdater.codecs[type] + " to " + codec); // check if change to the provided type is supported
	
	      try {
	        sourceBuffer.changeType(mime);
	        sourceUpdater.codecs[type] = codec;
	      } catch (e) {
	        videojs.log.warn("Failed to changeType on " + type + "Buffer", e);
	      }
	    };
	  }
	};
	
	var pushQueue = function pushQueue(_ref) {
	  var type = _ref.type,
	      sourceUpdater = _ref.sourceUpdater,
	      action = _ref.action,
	      doneFn = _ref.doneFn,
	      name = _ref.name;
	  sourceUpdater.queue.push({
	    type: type,
	    action: action,
	    doneFn: doneFn,
	    name: name
	  });
	  shiftQueue(type, sourceUpdater);
	};
	
	var onUpdateend = function onUpdateend(type, sourceUpdater) {
	  return function (e) {
	    // Although there should, in theory, be a pending action for any updateend receieved,
	    // there are some actions that may trigger updateend events without set definitions in
	    // the w3c spec. For instance, setting the duration on the media source may trigger
	    // updateend events on source buffers. This does not appear to be in the spec. As such,
	    // if we encounter an updateend without a corresponding pending action from our queue
	    // for that source buffer type, process the next action.
	    if (sourceUpdater.queuePending[type]) {
	      var doneFn = sourceUpdater.queuePending[type].doneFn;
	      sourceUpdater.queuePending[type] = null;
	
	      if (doneFn) {
	        // if there's an error, report it
	        doneFn(sourceUpdater[type + "Error_"]);
	      }
	    }
	
	    shiftQueue(type, sourceUpdater);
	  };
	};
	/**
	 * A queue of callbacks to be serialized and applied when a
	 * MediaSource and its associated SourceBuffers are not in the
	 * updating state. It is used by the segment loader to update the
	 * underlying SourceBuffers when new data is loaded, for instance.
	 *
	 * @class SourceUpdater
	 * @param {MediaSource} mediaSource the MediaSource to create the SourceBuffer from
	 * @param {string} mimeType the desired MIME type of the underlying SourceBuffer
	 */
	
	
	var SourceUpdater = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](SourceUpdater, _videojs$EventTarget);
	
	  function SourceUpdater(mediaSource) {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this;
	    _this.mediaSource = mediaSource;
	
	    _this.sourceopenListener_ = function () {
	      return shiftQueue('mediaSource', _assertThisInitialized__default['default'](_this));
	    };
	
	    _this.mediaSource.addEventListener('sourceopen', _this.sourceopenListener_);
	
	    _this.logger_ = logger('SourceUpdater'); // initial timestamp offset is 0
	
	    _this.audioTimestampOffset_ = 0;
	    _this.videoTimestampOffset_ = 0;
	    _this.queue = [];
	    _this.queuePending = {
	      audio: null,
	      video: null
	    };
	    _this.delayedAudioAppendQueue_ = [];
	    _this.videoAppendQueued_ = false;
	    _this.codecs = {};
	    _this.onVideoUpdateEnd_ = onUpdateend('video', _assertThisInitialized__default['default'](_this));
	    _this.onAudioUpdateEnd_ = onUpdateend('audio', _assertThisInitialized__default['default'](_this));
	
	    _this.onVideoError_ = function (e) {
	      // used for debugging
	      _this.videoError_ = e;
	    };
	
	    _this.onAudioError_ = function (e) {
	      // used for debugging
	      _this.audioError_ = e;
	    };
	
	    _this.createdSourceBuffers_ = false;
	    _this.initializedEme_ = false;
	    _this.triggeredReady_ = false;
	    return _this;
	  }
	
	  var _proto = SourceUpdater.prototype;
	
	  _proto.initializedEme = function initializedEme() {
	    this.initializedEme_ = true;
	    this.triggerReady();
	  };
	
	  _proto.hasCreatedSourceBuffers = function hasCreatedSourceBuffers() {
	    // if false, likely waiting on one of the segment loaders to get enough data to create
	    // source buffers
	    return this.createdSourceBuffers_;
	  };
	
	  _proto.hasInitializedAnyEme = function hasInitializedAnyEme() {
	    return this.initializedEme_;
	  };
	
	  _proto.ready = function ready() {
	    return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
	  };
	
	  _proto.createSourceBuffers = function createSourceBuffers(codecs) {
	    if (this.hasCreatedSourceBuffers()) {
	      // already created them before
	      return;
	    } // the intial addOrChangeSourceBuffers will always be
	    // two add buffers.
	
	
	    this.addOrChangeSourceBuffers(codecs);
	    this.createdSourceBuffers_ = true;
	    this.trigger('createdsourcebuffers');
	    this.triggerReady();
	  };
	
	  _proto.triggerReady = function triggerReady() {
	    // only allow ready to be triggered once, this prevents the case
	    // where:
	    // 1. we trigger createdsourcebuffers
	    // 2. ie 11 synchronously initializates eme
	    // 3. the synchronous initialization causes us to trigger ready
	    // 4. We go back to the ready check in createSourceBuffers and ready is triggered again.
	    if (this.ready() && !this.triggeredReady_) {
	      this.triggeredReady_ = true;
	      this.trigger('ready');
	    }
	  }
	  /**
	   * Add a type of source buffer to the media source.
	   *
	   * @param {string} type
	   *        The type of source buffer to add.
	   *
	   * @param {string} codec
	   *        The codec to add the source buffer with.
	   */
	  ;
	
	  _proto.addSourceBuffer = function addSourceBuffer(type, codec) {
	    pushQueue({
	      type: 'mediaSource',
	      sourceUpdater: this,
	      action: actions.addSourceBuffer(type, codec),
	      name: 'addSourceBuffer'
	    });
	  }
	  /**
	   * call abort on a source buffer.
	   *
	   * @param {string} type
	   *        The type of source buffer to call abort on.
	   */
	  ;
	
	  _proto.abort = function abort(type) {
	    pushQueue({
	      type: type,
	      sourceUpdater: this,
	      action: actions.abort(type),
	      name: 'abort'
	    });
	  }
	  /**
	   * Call removeSourceBuffer and remove a specific type
	   * of source buffer on the mediaSource.
	   *
	   * @param {string} type
	   *        The type of source buffer to remove.
	   */
	  ;
	
	  _proto.removeSourceBuffer = function removeSourceBuffer(type) {
	    if (!this.canRemoveSourceBuffer()) {
	      videojs.log.error('removeSourceBuffer is not supported!');
	      return;
	    }
	
	    pushQueue({
	      type: 'mediaSource',
	      sourceUpdater: this,
	      action: actions.removeSourceBuffer(type),
	      name: 'removeSourceBuffer'
	    });
	  }
	  /**
	   * Whether or not the removeSourceBuffer function is supported
	   * on the mediaSource.
	   *
	   * @return {boolean}
	   *          if removeSourceBuffer can be called.
	   */
	  ;
	
	  _proto.canRemoveSourceBuffer = function canRemoveSourceBuffer() {
	    // IE reports that it supports removeSourceBuffer, but often throws
	    // errors when attempting to use the function. So we report that it
	    // does not support removeSourceBuffer. As of Firefox 83 removeSourceBuffer
	    // throws errors, so we report that it does not support this as well.
	    return !videojs.browser.IE_VERSION && !videojs.browser.IS_FIREFOX && window__default['default'].MediaSource && window__default['default'].MediaSource.prototype && typeof window__default['default'].MediaSource.prototype.removeSourceBuffer === 'function';
	  }
	  /**
	   * Whether or not the changeType function is supported
	   * on our SourceBuffers.
	   *
	   * @return {boolean}
	   *         if changeType can be called.
	   */
	  ;
	
	  SourceUpdater.canChangeType = function canChangeType() {
	    return window__default['default'].SourceBuffer && window__default['default'].SourceBuffer.prototype && typeof window__default['default'].SourceBuffer.prototype.changeType === 'function';
	  }
	  /**
	   * Whether or not the changeType function is supported
	   * on our SourceBuffers.
	   *
	   * @return {boolean}
	   *         if changeType can be called.
	   */
	  ;
	
	  _proto.canChangeType = function canChangeType() {
	    return this.constructor.canChangeType();
	  }
	  /**
	   * Call the changeType function on a source buffer, given the code and type.
	   *
	   * @param {string} type
	   *        The type of source buffer to call changeType on.
	   *
	   * @param {string} codec
	   *        The codec string to change type with on the source buffer.
	   */
	  ;
	
	  _proto.changeType = function changeType(type, codec) {
	    if (!this.canChangeType()) {
	      videojs.log.error('changeType is not supported!');
	      return;
	    }
	
	    pushQueue({
	      type: type,
	      sourceUpdater: this,
	      action: actions.changeType(codec),
	      name: 'changeType'
	    });
	  }
	  /**
	   * Add source buffers with a codec or, if they are already created,
	   * call changeType on source buffers using changeType.
	   *
	   * @param {Object} codecs
	   *        Codecs to switch to
	   */
	  ;
	
	  _proto.addOrChangeSourceBuffers = function addOrChangeSourceBuffers(codecs) {
	    var _this2 = this;
	
	    if (!codecs || typeof codecs !== 'object' || Object.keys(codecs).length === 0) {
	      throw new Error('Cannot addOrChangeSourceBuffers to undefined codecs');
	    }
	
	    Object.keys(codecs).forEach(function (type) {
	      var codec = codecs[type];
	
	      if (!_this2.hasCreatedSourceBuffers()) {
	        return _this2.addSourceBuffer(type, codec);
	      }
	
	      if (_this2.canChangeType()) {
	        _this2.changeType(type, codec);
	      }
	    });
	  }
	  /**
	   * Queue an update to append an ArrayBuffer.
	   *
	   * @param {MediaObject} object containing audioBytes and/or videoBytes
	   * @param {Function} done the function to call when done
	   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-appendBuffer-void-ArrayBuffer-data
	   */
	  ;
	
	  _proto.appendBuffer = function appendBuffer(options, doneFn) {
	    var _this3 = this;
	
	    var segmentInfo = options.segmentInfo,
	        type = options.type,
	        bytes = options.bytes;
	    this.processedAppend_ = true;
	
	    if (type === 'audio' && this.videoBuffer && !this.videoAppendQueued_) {
	      this.delayedAudioAppendQueue_.push([options, doneFn]);
	      this.logger_("delayed audio append of " + bytes.length + " until video append");
	      return;
	    } // In the case of certain errors, for instance, QUOTA_EXCEEDED_ERR, updateend will
	    // not be fired. This means that the queue will be blocked until the next action
	    // taken by the segment-loader. Provide a mechanism for segment-loader to handle
	    // these errors by calling the doneFn with the specific error.
	
	
	    var onError = doneFn;
	    pushQueue({
	      type: type,
	      sourceUpdater: this,
	      action: actions.appendBuffer(bytes, segmentInfo || {
	        mediaIndex: -1
	      }, onError),
	      doneFn: doneFn,
	      name: 'appendBuffer'
	    });
	
	    if (type === 'video') {
	      this.videoAppendQueued_ = true;
	
	      if (!this.delayedAudioAppendQueue_.length) {
	        return;
	      }
	
	      var queue = this.delayedAudioAppendQueue_.slice();
	      this.logger_("queuing delayed audio " + queue.length + " appendBuffers");
	      this.delayedAudioAppendQueue_.length = 0;
	      queue.forEach(function (que) {
	        _this3.appendBuffer.apply(_this3, que);
	      });
	    }
	  }
	  /**
	   * Get the audio buffer's buffered timerange.
	   *
	   * @return {TimeRange}
	   *         The audio buffer's buffered time range
	   */
	  ;
	
	  _proto.audioBuffered = function audioBuffered() {
	    // no media source/source buffer or it isn't in the media sources
	    // source buffer list
	    if (!inSourceBuffers(this.mediaSource, this.audioBuffer)) {
	      return videojs.createTimeRange();
	    }
	
	    return this.audioBuffer.buffered ? this.audioBuffer.buffered : videojs.createTimeRange();
	  }
	  /**
	   * Get the video buffer's buffered timerange.
	   *
	   * @return {TimeRange}
	   *         The video buffer's buffered time range
	   */
	  ;
	
	  _proto.videoBuffered = function videoBuffered() {
	    // no media source/source buffer or it isn't in the media sources
	    // source buffer list
	    if (!inSourceBuffers(this.mediaSource, this.videoBuffer)) {
	      return videojs.createTimeRange();
	    }
	
	    return this.videoBuffer.buffered ? this.videoBuffer.buffered : videojs.createTimeRange();
	  }
	  /**
	   * Get a combined video/audio buffer's buffered timerange.
	   *
	   * @return {TimeRange}
	   *         the combined time range
	   */
	  ;
	
	  _proto.buffered = function buffered() {
	    var video = inSourceBuffers(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null;
	    var audio = inSourceBuffers(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
	
	    if (audio && !video) {
	      return this.audioBuffered();
	    }
	
	    if (video && !audio) {
	      return this.videoBuffered();
	    }
	
	    return bufferIntersection(this.audioBuffered(), this.videoBuffered());
	  }
	  /**
	   * Add a callback to the queue that will set duration on the mediaSource.
	   *
	   * @param {number} duration
	   *        The duration to set
	   *
	   * @param {Function} [doneFn]
	   *        function to run after duration has been set.
	   */
	  ;
	
	  _proto.setDuration = function setDuration(duration, doneFn) {
	    if (doneFn === void 0) {
	      doneFn = noop;
	    } // In order to set the duration on the media source, it's necessary to wait for all
	    // source buffers to no longer be updating. "If the updating attribute equals true on
	    // any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
	    // abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
	
	
	    pushQueue({
	      type: 'mediaSource',
	      sourceUpdater: this,
	      action: actions.duration(duration),
	      name: 'duration',
	      doneFn: doneFn
	    });
	  }
	  /**
	   * Add a mediaSource endOfStream call to the queue
	   *
	   * @param {Error} [error]
	   *        Call endOfStream with an error
	   *
	   * @param {Function} [doneFn]
	   *        A function that should be called when the
	   *        endOfStream call has finished.
	   */
	  ;
	
	  _proto.endOfStream = function endOfStream(error, doneFn) {
	    if (error === void 0) {
	      error = null;
	    }
	
	    if (doneFn === void 0) {
	      doneFn = noop;
	    }
	
	    if (typeof error !== 'string') {
	      error = undefined;
	    } // In order to set the duration on the media source, it's necessary to wait for all
	    // source buffers to no longer be updating. "If the updating attribute equals true on
	    // any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
	    // abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
	
	
	    pushQueue({
	      type: 'mediaSource',
	      sourceUpdater: this,
	      action: actions.endOfStream(error),
	      name: 'endOfStream',
	      doneFn: doneFn
	    });
	  }
	  /**
	   * Queue an update to remove a time range from the buffer.
	   *
	   * @param {number} start where to start the removal
	   * @param {number} end where to end the removal
	   * @param {Function} [done=noop] optional callback to be executed when the remove
	   * operation is complete
	   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
	   */
	  ;
	
	  _proto.removeAudio = function removeAudio(start, end, done) {
	    if (done === void 0) {
	      done = noop;
	    }
	
	    if (!this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
	      done();
	      return;
	    }
	
	    pushQueue({
	      type: 'audio',
	      sourceUpdater: this,
	      action: actions.remove(start, end),
	      doneFn: done,
	      name: 'remove'
	    });
	  }
	  /**
	   * Queue an update to remove a time range from the buffer.
	   *
	   * @param {number} start where to start the removal
	   * @param {number} end where to end the removal
	   * @param {Function} [done=noop] optional callback to be executed when the remove
	   * operation is complete
	   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
	   */
	  ;
	
	  _proto.removeVideo = function removeVideo(start, end, done) {
	    if (done === void 0) {
	      done = noop;
	    }
	
	    if (!this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
	      done();
	      return;
	    }
	
	    pushQueue({
	      type: 'video',
	      sourceUpdater: this,
	      action: actions.remove(start, end),
	      doneFn: done,
	      name: 'remove'
	    });
	  }
	  /**
	   * Whether the underlying sourceBuffer is updating or not
	   *
	   * @return {boolean} the updating status of the SourceBuffer
	   */
	  ;
	
	  _proto.updating = function updating() {
	    // the audio/video source buffer is updating
	    if (_updating('audio', this) || _updating('video', this)) {
	      return true;
	    }
	
	    return false;
	  }
	  /**
	   * Set/get the timestampoffset on the audio SourceBuffer
	   *
	   * @return {number} the timestamp offset
	   */
	  ;
	
	  _proto.audioTimestampOffset = function audioTimestampOffset(offset) {
	    if (typeof offset !== 'undefined' && this.audioBuffer && // no point in updating if it's the same
	    this.audioTimestampOffset_ !== offset) {
	      pushQueue({
	        type: 'audio',
	        sourceUpdater: this,
	        action: actions.timestampOffset(offset),
	        name: 'timestampOffset'
	      });
	      this.audioTimestampOffset_ = offset;
	    }
	
	    return this.audioTimestampOffset_;
	  }
	  /**
	   * Set/get the timestampoffset on the video SourceBuffer
	   *
	   * @return {number} the timestamp offset
	   */
	  ;
	
	  _proto.videoTimestampOffset = function videoTimestampOffset(offset) {
	    if (typeof offset !== 'undefined' && this.videoBuffer && // no point in updating if it's the same
	    this.videoTimestampOffset !== offset) {
	      pushQueue({
	        type: 'video',
	        sourceUpdater: this,
	        action: actions.timestampOffset(offset),
	        name: 'timestampOffset'
	      });
	      this.videoTimestampOffset_ = offset;
	    }
	
	    return this.videoTimestampOffset_;
	  }
	  /**
	   * Add a function to the queue that will be called
	   * when it is its turn to run in the audio queue.
	   *
	   * @param {Function} callback
	   *        The callback to queue.
	   */
	  ;
	
	  _proto.audioQueueCallback = function audioQueueCallback(callback) {
	    if (!this.audioBuffer) {
	      return;
	    }
	
	    pushQueue({
	      type: 'audio',
	      sourceUpdater: this,
	      action: actions.callback(callback),
	      name: 'callback'
	    });
	  }
	  /**
	   * Add a function to the queue that will be called
	   * when it is its turn to run in the video queue.
	   *
	   * @param {Function} callback
	   *        The callback to queue.
	   */
	  ;
	
	  _proto.videoQueueCallback = function videoQueueCallback(callback) {
	    if (!this.videoBuffer) {
	      return;
	    }
	
	    pushQueue({
	      type: 'video',
	      sourceUpdater: this,
	      action: actions.callback(callback),
	      name: 'callback'
	    });
	  }
	  /**
	   * dispose of the source updater and the underlying sourceBuffer
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    var _this4 = this;
	
	    this.trigger('dispose');
	    bufferTypes.forEach(function (type) {
	      _this4.abort(type);
	
	      if (_this4.canRemoveSourceBuffer()) {
	        _this4.removeSourceBuffer(type);
	      } else {
	        _this4[type + "QueueCallback"](function () {
	          return cleanupBuffer(type, _this4);
	        });
	      }
	    });
	    this.videoAppendQueued_ = false;
	    this.delayedAudioAppendQueue_.length = 0;
	
	    if (this.sourceopenListener_) {
	      this.mediaSource.removeEventListener('sourceopen', this.sourceopenListener_);
	    }
	
	    this.off();
	  };
	
	  return SourceUpdater;
	}(videojs.EventTarget);
	
	var uint8ToUtf8 = function uint8ToUtf8(uintArray) {
	  return decodeURIComponent(escape(String.fromCharCode.apply(null, uintArray)));
	};
	
	var VTT_LINE_TERMINATORS = new Uint8Array('\n\n'.split('').map(function (_char3) {
	  return _char3.charCodeAt(0);
	}));
	
	var NoVttJsError = /*#__PURE__*/function (_Error) {
	  _inheritsLoose__default['default'](NoVttJsError, _Error);
	
	  function NoVttJsError() {
	    return _Error.call(this, 'Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.') || this;
	  }
	
	  return NoVttJsError;
	}( /*#__PURE__*/_wrapNativeSuper__default['default'](Error));
	/**
	 * An object that manages segment loading and appending.
	 *
	 * @class VTTSegmentLoader
	 * @param {Object} options required and optional options
	 * @extends videojs.EventTarget
	 */
	
	
	var VTTSegmentLoader = /*#__PURE__*/function (_SegmentLoader) {
	  _inheritsLoose__default['default'](VTTSegmentLoader, _SegmentLoader);
	
	  function VTTSegmentLoader(settings, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _SegmentLoader.call(this, settings, options) || this; // SegmentLoader requires a MediaSource be specified or it will throw an error;
	    // however, VTTSegmentLoader has no need of a media source, so delete the reference
	
	    _this.mediaSource_ = null;
	    _this.subtitlesTrack_ = null;
	    _this.loaderType_ = 'subtitle';
	    _this.featuresNativeTextTracks_ = settings.featuresNativeTextTracks;
	    _this.loadVttJs = settings.loadVttJs; // The VTT segment will have its own time mappings. Saving VTT segment timing info in
	    // the sync controller leads to improper behavior.
	
	    _this.shouldSaveSegmentTimingInfo_ = false;
	    return _this;
	  }
	
	  var _proto = VTTSegmentLoader.prototype;
	
	  _proto.createTransmuxer_ = function createTransmuxer_() {
	    // don't need to transmux any subtitles
	    return null;
	  }
	  /**
	   * Indicates which time ranges are buffered
	   *
	   * @return {TimeRange}
	   *         TimeRange object representing the current buffered ranges
	   */
	  ;
	
	  _proto.buffered_ = function buffered_() {
	    if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length) {
	      return videojs.createTimeRanges();
	    }
	
	    var cues = this.subtitlesTrack_.cues;
	    var start = cues[0].startTime;
	    var end = cues[cues.length - 1].startTime;
	    return videojs.createTimeRanges([[start, end]]);
	  }
	  /**
	   * Gets and sets init segment for the provided map
	   *
	   * @param {Object} map
	   *        The map object representing the init segment to get or set
	   * @param {boolean=} set
	   *        If true, the init segment for the provided map should be saved
	   * @return {Object}
	   *         map object for desired init segment
	   */
	  ;
	
	  _proto.initSegmentForMap = function initSegmentForMap(map, set) {
	    if (set === void 0) {
	      set = false;
	    }
	
	    if (!map) {
	      return null;
	    }
	
	    var id = initSegmentId(map);
	    var storedMap = this.initSegments_[id];
	
	    if (set && !storedMap && map.bytes) {
	      // append WebVTT line terminators to the media initialization segment if it exists
	      // to follow the WebVTT spec (https://w3c.github.io/webvtt/#file-structure) that
	      // requires two or more WebVTT line terminators between the WebVTT header and the
	      // rest of the file
	      var combinedByteLength = VTT_LINE_TERMINATORS.byteLength + map.bytes.byteLength;
	      var combinedSegment = new Uint8Array(combinedByteLength);
	      combinedSegment.set(map.bytes);
	      combinedSegment.set(VTT_LINE_TERMINATORS, map.bytes.byteLength);
	      this.initSegments_[id] = storedMap = {
	        resolvedUri: map.resolvedUri,
	        byterange: map.byterange,
	        bytes: combinedSegment
	      };
	    }
	
	    return storedMap || map;
	  }
	  /**
	   * Returns true if all configuration required for loading is present, otherwise false.
	   *
	   * @return {boolean} True if the all configuration is ready for loading
	   * @private
	   */
	  ;
	
	  _proto.couldBeginLoading_ = function couldBeginLoading_() {
	    return this.playlist_ && this.subtitlesTrack_ && !this.paused();
	  }
	  /**
	   * Once all the starting parameters have been specified, begin
	   * operation. This method should only be invoked from the INIT
	   * state.
	   *
	   * @private
	   */
	  ;
	
	  _proto.init_ = function init_() {
	    this.state = 'READY';
	    this.resetEverything();
	    return this.monitorBuffer_();
	  }
	  /**
	   * Set a subtitle track on the segment loader to add subtitles to
	   *
	   * @param {TextTrack=} track
	   *        The text track to add loaded subtitles to
	   * @return {TextTrack}
	   *        Returns the subtitles track
	   */
	  ;
	
	  _proto.track = function track(_track) {
	    if (typeof _track === 'undefined') {
	      return this.subtitlesTrack_;
	    }
	
	    this.subtitlesTrack_ = _track; // if we were unpaused but waiting for a sourceUpdater, start
	    // buffering now
	
	    if (this.state === 'INIT' && this.couldBeginLoading_()) {
	      this.init_();
	    }
	
	    return this.subtitlesTrack_;
	  }
	  /**
	   * Remove any data in the source buffer between start and end times
	   *
	   * @param {number} start - the start time of the region to remove from the buffer
	   * @param {number} end - the end time of the region to remove from the buffer
	   */
	  ;
	
	  _proto.remove = function remove(start, end) {
	    removeCuesFromTrack(start, end, this.subtitlesTrack_);
	  }
	  /**
	   * fill the buffer with segements unless the sourceBuffers are
	   * currently updating
	   *
	   * Note: this function should only ever be called by monitorBuffer_
	   * and never directly
	   *
	   * @private
	   */
	  ;
	
	  _proto.fillBuffer_ = function fillBuffer_() {
	    var _this2 = this; // see if we need to begin loading immediately
	
	
	    var segmentInfo = this.chooseNextRequest_();
	
	    if (!segmentInfo) {
	      return;
	    }
	
	    if (this.syncController_.timestampOffsetForTimeline(segmentInfo.timeline) === null) {
	      // We don't have the timestamp offset that we need to sync subtitles.
	      // Rerun on a timestamp offset or user interaction.
	      var checkTimestampOffset = function checkTimestampOffset() {
	        _this2.state = 'READY';
	
	        if (!_this2.paused()) {
	          // if not paused, queue a buffer check as soon as possible
	          _this2.monitorBuffer_();
	        }
	      };
	
	      this.syncController_.one('timestampoffset', checkTimestampOffset);
	      this.state = 'WAITING_ON_TIMELINE';
	      return;
	    }
	
	    this.loadSegment_(segmentInfo);
	  } // never set a timestamp offset for vtt segments.
	  ;
	
	  _proto.timestampOffsetForSegment_ = function timestampOffsetForSegment_() {
	    return null;
	  };
	
	  _proto.chooseNextRequest_ = function chooseNextRequest_() {
	    return this.skipEmptySegments_(_SegmentLoader.prototype.chooseNextRequest_.call(this));
	  }
	  /**
	   * Prevents the segment loader from requesting segments we know contain no subtitles
	   * by walking forward until we find the next segment that we don't know whether it is
	   * empty or not.
	   *
	   * @param {Object} segmentInfo
	   *        a segment info object that describes the current segment
	   * @return {Object}
	   *         a segment info object that describes the current segment
	   */
	  ;
	
	  _proto.skipEmptySegments_ = function skipEmptySegments_(segmentInfo) {
	    while (segmentInfo && segmentInfo.segment.empty) {
	      // stop at the last possible segmentInfo
	      if (segmentInfo.mediaIndex + 1 >= segmentInfo.playlist.segments.length) {
	        segmentInfo = null;
	        break;
	      }
	
	      segmentInfo = this.generateSegmentInfo_({
	        playlist: segmentInfo.playlist,
	        mediaIndex: segmentInfo.mediaIndex + 1,
	        startOfSegment: segmentInfo.startOfSegment + segmentInfo.duration,
	        isSyncRequest: segmentInfo.isSyncRequest
	      });
	    }
	
	    return segmentInfo;
	  };
	
	  _proto.stopForError = function stopForError(error) {
	    this.error(error);
	    this.state = 'READY';
	    this.pause();
	    this.trigger('error');
	  }
	  /**
	   * append a decrypted segement to the SourceBuffer through a SourceUpdater
	   *
	   * @private
	   */
	  ;
	
	  _proto.segmentRequestFinished_ = function segmentRequestFinished_(error, simpleSegment, result) {
	    var _this3 = this;
	
	    if (!this.subtitlesTrack_) {
	      this.state = 'READY';
	      return;
	    }
	
	    this.saveTransferStats_(simpleSegment.stats); // the request was aborted
	
	    if (!this.pendingSegment_) {
	      this.state = 'READY';
	      this.mediaRequestsAborted += 1;
	      return;
	    }
	
	    if (error) {
	      if (error.code === REQUEST_ERRORS.TIMEOUT) {
	        this.handleTimeout_();
	      }
	
	      if (error.code === REQUEST_ERRORS.ABORTED) {
	        this.mediaRequestsAborted += 1;
	      } else {
	        this.mediaRequestsErrored += 1;
	      }
	
	      this.stopForError(error);
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // although the VTT segment loader bandwidth isn't really used, it's good to
	    // maintain functionality between segment loaders
	
	    this.saveBandwidthRelatedStats_(segmentInfo.duration, simpleSegment.stats); // if this request included a segment key, save that data in the cache
	
	    if (simpleSegment.key) {
	      this.segmentKey(simpleSegment.key, true);
	    }
	
	    this.state = 'APPENDING'; // used for tests
	
	    this.trigger('appending');
	    var segment = segmentInfo.segment;
	
	    if (segment.map) {
	      segment.map.bytes = simpleSegment.map.bytes;
	    }
	
	    segmentInfo.bytes = simpleSegment.bytes; // Make sure that vttjs has loaded, otherwise, load it and wait till it finished loading
	
	    if (typeof window__default['default'].WebVTT !== 'function' && typeof this.loadVttJs === 'function') {
	      this.state = 'WAITING_ON_VTTJS'; // should be fine to call multiple times
	      // script will be loaded once but multiple listeners will be added to the queue, which is expected.
	
	      this.loadVttJs().then(function () {
	        return _this3.segmentRequestFinished_(error, simpleSegment, result);
	      }, function () {
	        return _this3.stopForError({
	          message: 'Error loading vtt.js'
	        });
	      });
	      return;
	    }
	
	    segment.requested = true;
	
	    try {
	      this.parseVTTCues_(segmentInfo);
	    } catch (e) {
	      this.stopForError({
	        message: e.message
	      });
	      return;
	    }
	
	    this.updateTimeMapping_(segmentInfo, this.syncController_.timelines[segmentInfo.timeline], this.playlist_);
	
	    if (segmentInfo.cues.length) {
	      segmentInfo.timingInfo = {
	        start: segmentInfo.cues[0].startTime,
	        end: segmentInfo.cues[segmentInfo.cues.length - 1].endTime
	      };
	    } else {
	      segmentInfo.timingInfo = {
	        start: segmentInfo.startOfSegment,
	        end: segmentInfo.startOfSegment + segmentInfo.duration
	      };
	    }
	
	    if (segmentInfo.isSyncRequest) {
	      this.trigger('syncinfoupdate');
	      this.pendingSegment_ = null;
	      this.state = 'READY';
	      return;
	    }
	
	    segmentInfo.byteLength = segmentInfo.bytes.byteLength;
	    this.mediaSecondsLoaded += segment.duration; // Create VTTCue instances for each cue in the new segment and add them to
	    // the subtitle track
	
	    segmentInfo.cues.forEach(function (cue) {
	      _this3.subtitlesTrack_.addCue(_this3.featuresNativeTextTracks_ ? new window__default['default'].VTTCue(cue.startTime, cue.endTime, cue.text) : cue);
	    }); // Remove any duplicate cues from the subtitle track. The WebVTT spec allows
	    // cues to have identical time-intervals, but if the text is also identical
	    // we can safely assume it is a duplicate that can be removed (ex. when a cue
	    // "overlaps" VTT segments)
	
	    removeDuplicateCuesFromTrack(this.subtitlesTrack_);
	    this.handleAppendsDone_();
	  };
	
	  _proto.handleData_ = function handleData_() {// noop as we shouldn't be getting video/audio data captions
	    // that we do not support here.
	  };
	
	  _proto.updateTimingInfoEnd_ = function updateTimingInfoEnd_() {// noop
	  }
	  /**
	   * Uses the WebVTT parser to parse the segment response
	   *
	   * @throws NoVttJsError
	   *
	   * @param {Object} segmentInfo
	   *        a segment info object that describes the current segment
	   * @private
	   */
	  ;
	
	  _proto.parseVTTCues_ = function parseVTTCues_(segmentInfo) {
	    var decoder;
	    var decodeBytesToString = false;
	
	    if (typeof window__default['default'].WebVTT !== 'function') {
	      // caller is responsible for exception handling.
	      throw new NoVttJsError();
	    }
	
	    if (typeof window__default['default'].TextDecoder === 'function') {
	      decoder = new window__default['default'].TextDecoder('utf8');
	    } else {
	      decoder = window__default['default'].WebVTT.StringDecoder();
	      decodeBytesToString = true;
	    }
	
	    var parser = new window__default['default'].WebVTT.Parser(window__default['default'], window__default['default'].vttjs, decoder);
	    segmentInfo.cues = [];
	    segmentInfo.timestampmap = {
	      MPEGTS: 0,
	      LOCAL: 0
	    };
	    parser.oncue = segmentInfo.cues.push.bind(segmentInfo.cues);
	
	    parser.ontimestampmap = function (map) {
	      segmentInfo.timestampmap = map;
	    };
	
	    parser.onparsingerror = function (error) {
	      videojs.log.warn('Error encountered when parsing cues: ' + error.message);
	    };
	
	    if (segmentInfo.segment.map) {
	      var mapData = segmentInfo.segment.map.bytes;
	
	      if (decodeBytesToString) {
	        mapData = uint8ToUtf8(mapData);
	      }
	
	      parser.parse(mapData);
	    }
	
	    var segmentData = segmentInfo.bytes;
	
	    if (decodeBytesToString) {
	      segmentData = uint8ToUtf8(segmentData);
	    }
	
	    parser.parse(segmentData);
	    parser.flush();
	  }
	  /**
	   * Updates the start and end times of any cues parsed by the WebVTT parser using
	   * the information parsed from the X-TIMESTAMP-MAP header and a TS to media time mapping
	   * from the SyncController
	   *
	   * @param {Object} segmentInfo
	   *        a segment info object that describes the current segment
	   * @param {Object} mappingObj
	   *        object containing a mapping from TS to media time
	   * @param {Object} playlist
	   *        the playlist object containing the segment
	   * @private
	   */
	  ;
	
	  _proto.updateTimeMapping_ = function updateTimeMapping_(segmentInfo, mappingObj, playlist) {
	    var segment = segmentInfo.segment;
	
	    if (!mappingObj) {
	      // If the sync controller does not have a mapping of TS to Media Time for the
	      // timeline, then we don't have enough information to update the cue
	      // start/end times
	      return;
	    }
	
	    if (!segmentInfo.cues.length) {
	      // If there are no cues, we also do not have enough information to figure out
	      // segment timing. Mark that the segment contains no cues so we don't re-request
	      // an empty segment.
	      segment.empty = true;
	      return;
	    }
	
	    var timestampmap = segmentInfo.timestampmap;
	    var diff = timestampmap.MPEGTS / clock.ONE_SECOND_IN_TS - timestampmap.LOCAL + mappingObj.mapping;
	    segmentInfo.cues.forEach(function (cue) {
	      // First convert cue time to TS time using the timestamp-map provided within the vtt
	      cue.startTime += diff;
	      cue.endTime += diff;
	    });
	
	    if (!playlist.syncInfo) {
	      var firstStart = segmentInfo.cues[0].startTime;
	      var lastStart = segmentInfo.cues[segmentInfo.cues.length - 1].startTime;
	      playlist.syncInfo = {
	        mediaSequence: playlist.mediaSequence + segmentInfo.mediaIndex,
	        time: Math.min(firstStart, lastStart - segment.duration)
	      };
	    }
	  };
	
	  return VTTSegmentLoader;
	}(SegmentLoader);
	/**
	 * @file ad-cue-tags.js
	 */
	
	/**
	 * Searches for an ad cue that overlaps with the given mediaTime
	 *
	 * @param {Object} track
	 *        the track to find the cue for
	 *
	 * @param {number} mediaTime
	 *        the time to find the cue at
	 *
	 * @return {Object|null}
	 *         the found cue or null
	 */
	
	
	var findAdCue = function findAdCue(track, mediaTime) {
	  var cues = track.cues;
	
	  for (var i = 0; i < cues.length; i++) {
	    var cue = cues[i];
	
	    if (mediaTime >= cue.adStartTime && mediaTime <= cue.adEndTime) {
	      return cue;
	    }
	  }
	
	  return null;
	};
	
	var updateAdCues = function updateAdCues(media, track, offset) {
	  if (offset === void 0) {
	    offset = 0;
	  }
	
	  if (!media.segments) {
	    return;
	  }
	
	  var mediaTime = offset;
	  var cue;
	
	  for (var i = 0; i < media.segments.length; i++) {
	    var segment = media.segments[i];
	
	    if (!cue) {
	      // Since the cues will span for at least the segment duration, adding a fudge
	      // factor of half segment duration will prevent duplicate cues from being
	      // created when timing info is not exact (e.g. cue start time initialized
	      // at 10.006677, but next call mediaTime is 10.003332 )
	      cue = findAdCue(track, mediaTime + segment.duration / 2);
	    }
	
	    if (cue) {
	      if ('cueIn' in segment) {
	        // Found a CUE-IN so end the cue
	        cue.endTime = mediaTime;
	        cue.adEndTime = mediaTime;
	        mediaTime += segment.duration;
	        cue = null;
	        continue;
	      }
	
	      if (mediaTime < cue.endTime) {
	        // Already processed this mediaTime for this cue
	        mediaTime += segment.duration;
	        continue;
	      } // otherwise extend cue until a CUE-IN is found
	
	
	      cue.endTime += segment.duration;
	    } else {
	      if ('cueOut' in segment) {
	        cue = new window__default['default'].VTTCue(mediaTime, mediaTime + segment.duration, segment.cueOut);
	        cue.adStartTime = mediaTime; // Assumes tag format to be
	        // #EXT-X-CUE-OUT:30
	
	        cue.adEndTime = mediaTime + parseFloat(segment.cueOut);
	        track.addCue(cue);
	      }
	
	      if ('cueOutCont' in segment) {
	        // Entered into the middle of an ad cue
	        // Assumes tag formate to be
	        // #EXT-X-CUE-OUT-CONT:10/30
	        var _segment$cueOutCont$s = segment.cueOutCont.split('/').map(parseFloat),
	            adOffset = _segment$cueOutCont$s[0],
	            adTotal = _segment$cueOutCont$s[1];
	
	        cue = new window__default['default'].VTTCue(mediaTime, mediaTime + segment.duration, '');
	        cue.adStartTime = mediaTime - adOffset;
	        cue.adEndTime = cue.adStartTime + adTotal;
	        track.addCue(cue);
	      }
	    }
	
	    mediaTime += segment.duration;
	  }
	}; // synchronize expired playlist segments.
	// the max media sequence diff is 48 hours of live stream
	// content with two second segments. Anything larger than that
	// will likely be invalid.
	
	
	var MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC = 86400;
	var syncPointStrategies = [// Stategy "VOD": Handle the VOD-case where the sync-point is *always*
	//                the equivalence display-time 0 === segment-index 0
	{
	  name: 'VOD',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    if (duration !== Infinity) {
	      var syncPoint = {
	        time: 0,
	        segmentIndex: 0,
	        partIndex: null
	      };
	      return syncPoint;
	    }
	
	    return null;
	  }
	}, // Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
	{
	  name: 'ProgramDateTime',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    if (!Object.keys(syncController.timelineToDatetimeMappings).length) {
	      return null;
	    }
	
	    var syncPoint = null;
	    var lastDistance = null;
	    var partsAndSegments = getPartsAndSegments(playlist);
	    currentTime = currentTime || 0;
	
	    for (var i = 0; i < partsAndSegments.length; i++) {
	      // start from the end and loop backwards for live
	      // or start from the front and loop forwards for non-live
	      var index = playlist.endList || currentTime === 0 ? i : partsAndSegments.length - (i + 1);
	      var partAndSegment = partsAndSegments[index];
	      var segment = partAndSegment.segment;
	      var datetimeMapping = syncController.timelineToDatetimeMappings[segment.timeline];
	
	      if (!datetimeMapping || !segment.dateTimeObject) {
	        continue;
	      }
	
	      var segmentTime = segment.dateTimeObject.getTime() / 1000;
	      var start = segmentTime + datetimeMapping; // take part duration into account.
	
	      if (segment.parts && typeof partAndSegment.partIndex === 'number') {
	        for (var z = 0; z < partAndSegment.partIndex; z++) {
	          start += segment.parts[z].duration;
	        }
	      }
	
	      var distance = Math.abs(currentTime - start); // Once the distance begins to increase, or if distance is 0, we have passed
	      // currentTime and can stop looking for better candidates
	
	      if (lastDistance !== null && (distance === 0 || lastDistance < distance)) {
	        break;
	      }
	
	      lastDistance = distance;
	      syncPoint = {
	        time: start,
	        segmentIndex: partAndSegment.segmentIndex,
	        partIndex: partAndSegment.partIndex
	      };
	    }
	
	    return syncPoint;
	  }
	}, // Stategy "Segment": We have a known time mapping for a timeline and a
	//                    segment in the current timeline with timing data
	{
	  name: 'Segment',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    var syncPoint = null;
	    var lastDistance = null;
	    currentTime = currentTime || 0;
	    var partsAndSegments = getPartsAndSegments(playlist);
	
	    for (var i = 0; i < partsAndSegments.length; i++) {
	      // start from the end and loop backwards for live
	      // or start from the front and loop forwards for non-live
	      var index = playlist.endList || currentTime === 0 ? i : partsAndSegments.length - (i + 1);
	      var partAndSegment = partsAndSegments[index];
	      var segment = partAndSegment.segment;
	      var start = partAndSegment.part && partAndSegment.part.start || segment && segment.start;
	
	      if (segment.timeline === currentTimeline && typeof start !== 'undefined') {
	        var distance = Math.abs(currentTime - start); // Once the distance begins to increase, we have passed
	        // currentTime and can stop looking for better candidates
	
	        if (lastDistance !== null && lastDistance < distance) {
	          break;
	        }
	
	        if (!syncPoint || lastDistance === null || lastDistance >= distance) {
	          lastDistance = distance;
	          syncPoint = {
	            time: start,
	            segmentIndex: partAndSegment.segmentIndex,
	            partIndex: partAndSegment.partIndex
	          };
	        }
	      }
	    }
	
	    return syncPoint;
	  }
	}, // Stategy "Discontinuity": We have a discontinuity with a known
	//                          display-time
	{
	  name: 'Discontinuity',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    var syncPoint = null;
	    currentTime = currentTime || 0;
	
	    if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) {
	      var lastDistance = null;
	
	      for (var i = 0; i < playlist.discontinuityStarts.length; i++) {
	        var segmentIndex = playlist.discontinuityStarts[i];
	        var discontinuity = playlist.discontinuitySequence + i + 1;
	        var discontinuitySync = syncController.discontinuities[discontinuity];
	
	        if (discontinuitySync) {
	          var distance = Math.abs(currentTime - discontinuitySync.time); // Once the distance begins to increase, we have passed
	          // currentTime and can stop looking for better candidates
	
	          if (lastDistance !== null && lastDistance < distance) {
	            break;
	          }
	
	          if (!syncPoint || lastDistance === null || lastDistance >= distance) {
	            lastDistance = distance;
	            syncPoint = {
	              time: discontinuitySync.time,
	              segmentIndex: segmentIndex,
	              partIndex: null
	            };
	          }
	        }
	      }
	    }
	
	    return syncPoint;
	  }
	}, // Stategy "Playlist": We have a playlist with a known mapping of
	//                     segment index to display time
	{
	  name: 'Playlist',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    if (playlist.syncInfo) {
	      var syncPoint = {
	        time: playlist.syncInfo.time,
	        segmentIndex: playlist.syncInfo.mediaSequence - playlist.mediaSequence,
	        partIndex: null
	      };
	      return syncPoint;
	    }
	
	    return null;
	  }
	}];
	
	var SyncController = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](SyncController, _videojs$EventTarget);
	
	  function SyncController(options) {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this; // ...for synching across variants
	
	    _this.timelines = [];
	    _this.discontinuities = [];
	    _this.timelineToDatetimeMappings = {};
	    _this.logger_ = logger('SyncController');
	    return _this;
	  }
	  /**
	   * Find a sync-point for the playlist specified
	   *
	   * A sync-point is defined as a known mapping from display-time to
	   * a segment-index in the current playlist.
	   *
	   * @param {Playlist} playlist
	   *        The playlist that needs a sync-point
	   * @param {number} duration
	   *        Duration of the MediaSource (Infinite if playing a live source)
	   * @param {number} currentTimeline
	   *        The last timeline from which a segment was loaded
	   * @return {Object}
	   *          A sync-point object
	   */
	
	
	  var _proto = SyncController.prototype;
	
	  _proto.getSyncPoint = function getSyncPoint(playlist, duration, currentTimeline, currentTime) {
	    var syncPoints = this.runStrategies_(playlist, duration, currentTimeline, currentTime);
	
	    if (!syncPoints.length) {
	      // Signal that we need to attempt to get a sync-point manually
	      // by fetching a segment in the playlist and constructing
	      // a sync-point from that information
	      return null;
	    } // Now find the sync-point that is closest to the currentTime because
	    // that should result in the most accurate guess about which segment
	    // to fetch
	
	
	    return this.selectSyncPoint_(syncPoints, {
	      key: 'time',
	      value: currentTime
	    });
	  }
	  /**
	   * Calculate the amount of time that has expired off the playlist during playback
	   *
	   * @param {Playlist} playlist
	   *        Playlist object to calculate expired from
	   * @param {number} duration
	   *        Duration of the MediaSource (Infinity if playling a live source)
	   * @return {number|null}
	   *          The amount of time that has expired off the playlist during playback. Null
	   *          if no sync-points for the playlist can be found.
	   */
	  ;
	
	  _proto.getExpiredTime = function getExpiredTime(playlist, duration) {
	    if (!playlist || !playlist.segments) {
	      return null;
	    }
	
	    var syncPoints = this.runStrategies_(playlist, duration, playlist.discontinuitySequence, 0); // Without sync-points, there is not enough information to determine the expired time
	
	    if (!syncPoints.length) {
	      return null;
	    }
	
	    var syncPoint = this.selectSyncPoint_(syncPoints, {
	      key: 'segmentIndex',
	      value: 0
	    }); // If the sync-point is beyond the start of the playlist, we want to subtract the
	    // duration from index 0 to syncPoint.segmentIndex instead of adding.
	
	    if (syncPoint.segmentIndex > 0) {
	      syncPoint.time *= -1;
	    }
	
	    return Math.abs(syncPoint.time + sumDurations({
	      defaultDuration: playlist.targetDuration,
	      durationList: playlist.segments,
	      startIndex: syncPoint.segmentIndex,
	      endIndex: 0
	    }));
	  }
	  /**
	   * Runs each sync-point strategy and returns a list of sync-points returned by the
	   * strategies
	   *
	   * @private
	   * @param {Playlist} playlist
	   *        The playlist that needs a sync-point
	   * @param {number} duration
	   *        Duration of the MediaSource (Infinity if playing a live source)
	   * @param {number} currentTimeline
	   *        The last timeline from which a segment was loaded
	   * @return {Array}
	   *          A list of sync-point objects
	   */
	  ;
	
	  _proto.runStrategies_ = function runStrategies_(playlist, duration, currentTimeline, currentTime) {
	    var syncPoints = []; // Try to find a sync-point in by utilizing various strategies...
	
	    for (var i = 0; i < syncPointStrategies.length; i++) {
	      var strategy = syncPointStrategies[i];
	      var syncPoint = strategy.run(this, playlist, duration, currentTimeline, currentTime);
	
	      if (syncPoint) {
	        syncPoint.strategy = strategy.name;
	        syncPoints.push({
	          strategy: strategy.name,
	          syncPoint: syncPoint
	        });
	      }
	    }
	
	    return syncPoints;
	  }
	  /**
	   * Selects the sync-point nearest the specified target
	   *
	   * @private
	   * @param {Array} syncPoints
	   *        List of sync-points to select from
	   * @param {Object} target
	   *        Object specifying the property and value we are targeting
	   * @param {string} target.key
	   *        Specifies the property to target. Must be either 'time' or 'segmentIndex'
	   * @param {number} target.value
	   *        The value to target for the specified key.
	   * @return {Object}
	   *          The sync-point nearest the target
	   */
	  ;
	
	  _proto.selectSyncPoint_ = function selectSyncPoint_(syncPoints, target) {
	    var bestSyncPoint = syncPoints[0].syncPoint;
	    var bestDistance = Math.abs(syncPoints[0].syncPoint[target.key] - target.value);
	    var bestStrategy = syncPoints[0].strategy;
	
	    for (var i = 1; i < syncPoints.length; i++) {
	      var newDistance = Math.abs(syncPoints[i].syncPoint[target.key] - target.value);
	
	      if (newDistance < bestDistance) {
	        bestDistance = newDistance;
	        bestSyncPoint = syncPoints[i].syncPoint;
	        bestStrategy = syncPoints[i].strategy;
	      }
	    }
	
	    this.logger_("syncPoint for [" + target.key + ": " + target.value + "] chosen with strategy" + (" [" + bestStrategy + "]: [time:" + bestSyncPoint.time + ",") + (" segmentIndex:" + bestSyncPoint.segmentIndex) + (typeof bestSyncPoint.partIndex === 'number' ? ",partIndex:" + bestSyncPoint.partIndex : '') + ']');
	    return bestSyncPoint;
	  }
	  /**
	   * Save any meta-data present on the segments when segments leave
	   * the live window to the playlist to allow for synchronization at the
	   * playlist level later.
	   *
	   * @param {Playlist} oldPlaylist - The previous active playlist
	   * @param {Playlist} newPlaylist - The updated and most current playlist
	   */
	  ;
	
	  _proto.saveExpiredSegmentInfo = function saveExpiredSegmentInfo(oldPlaylist, newPlaylist) {
	    var mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence; // Ignore large media sequence gaps
	
	    if (mediaSequenceDiff > MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC) {
	      videojs.log.warn("Not saving expired segment info. Media sequence gap " + mediaSequenceDiff + " is too large.");
	      return;
	    } // When a segment expires from the playlist and it has a start time
	    // save that information as a possible sync-point reference in future
	
	
	    for (var i = mediaSequenceDiff - 1; i >= 0; i--) {
	      var lastRemovedSegment = oldPlaylist.segments[i];
	
	      if (lastRemovedSegment && typeof lastRemovedSegment.start !== 'undefined') {
	        newPlaylist.syncInfo = {
	          mediaSequence: oldPlaylist.mediaSequence + i,
	          time: lastRemovedSegment.start
	        };
	        this.logger_("playlist refresh sync: [time:" + newPlaylist.syncInfo.time + "," + (" mediaSequence: " + newPlaylist.syncInfo.mediaSequence + "]"));
	        this.trigger('syncinfoupdate');
	        break;
	      }
	    }
	  }
	  /**
	   * Save the mapping from playlist's ProgramDateTime to display. This should only happen
	   * before segments start to load.
	   *
	   * @param {Playlist} playlist - The currently active playlist
	   */
	  ;
	
	  _proto.setDateTimeMappingForStart = function setDateTimeMappingForStart(playlist) {
	    // It's possible for the playlist to be updated before playback starts, meaning time
	    // zero is not yet set. If, during these playlist refreshes, a discontinuity is
	    // crossed, then the old time zero mapping (for the prior timeline) would be retained
	    // unless the mappings are cleared.
	    this.timelineToDatetimeMappings = {};
	
	    if (playlist.segments && playlist.segments.length && playlist.segments[0].dateTimeObject) {
	      var firstSegment = playlist.segments[0];
	      var playlistTimestamp = firstSegment.dateTimeObject.getTime() / 1000;
	      this.timelineToDatetimeMappings[firstSegment.timeline] = -playlistTimestamp;
	    }
	  }
	  /**
	   * Calculates and saves timeline mappings, playlist sync info, and segment timing values
	   * based on the latest timing information.
	   *
	   * @param {Object} options
	   *        Options object
	   * @param {SegmentInfo} options.segmentInfo
	   *        The current active request information
	   * @param {boolean} options.shouldSaveTimelineMapping
	   *        If there's a timeline change, determines if the timeline mapping should be
	   *        saved for timeline mapping and program date time mappings.
	   */
	  ;
	
	  _proto.saveSegmentTimingInfo = function saveSegmentTimingInfo(_ref) {
	    var segmentInfo = _ref.segmentInfo,
	        shouldSaveTimelineMapping = _ref.shouldSaveTimelineMapping;
	    var didCalculateSegmentTimeMapping = this.calculateSegmentTimeMapping_(segmentInfo, segmentInfo.timingInfo, shouldSaveTimelineMapping);
	    var segment = segmentInfo.segment;
	
	    if (didCalculateSegmentTimeMapping) {
	      this.saveDiscontinuitySyncInfo_(segmentInfo); // If the playlist does not have sync information yet, record that information
	      // now with segment timing information
	
	      if (!segmentInfo.playlist.syncInfo) {
	        segmentInfo.playlist.syncInfo = {
	          mediaSequence: segmentInfo.playlist.mediaSequence + segmentInfo.mediaIndex,
	          time: segment.start
	        };
	      }
	    }
	
	    var dateTime = segment.dateTimeObject;
	
	    if (segment.discontinuity && shouldSaveTimelineMapping && dateTime) {
	      this.timelineToDatetimeMappings[segment.timeline] = -(dateTime.getTime() / 1000);
	    }
	  };
	
	  _proto.timestampOffsetForTimeline = function timestampOffsetForTimeline(timeline) {
	    if (typeof this.timelines[timeline] === 'undefined') {
	      return null;
	    }
	
	    return this.timelines[timeline].time;
	  };
	
	  _proto.mappingForTimeline = function mappingForTimeline(timeline) {
	    if (typeof this.timelines[timeline] === 'undefined') {
	      return null;
	    }
	
	    return this.timelines[timeline].mapping;
	  }
	  /**
	   * Use the "media time" for a segment to generate a mapping to "display time" and
	   * save that display time to the segment.
	   *
	   * @private
	   * @param {SegmentInfo} segmentInfo
	   *        The current active request information
	   * @param {Object} timingInfo
	   *        The start and end time of the current segment in "media time"
	   * @param {boolean} shouldSaveTimelineMapping
	   *        If there's a timeline change, determines if the timeline mapping should be
	   *        saved in timelines.
	   * @return {boolean}
	   *          Returns false if segment time mapping could not be calculated
	   */
	  ;
	
	  _proto.calculateSegmentTimeMapping_ = function calculateSegmentTimeMapping_(segmentInfo, timingInfo, shouldSaveTimelineMapping) {
	    // TODO: remove side effects
	    var segment = segmentInfo.segment;
	    var part = segmentInfo.part;
	    var mappingObj = this.timelines[segmentInfo.timeline];
	    var start;
	    var end;
	
	    if (typeof segmentInfo.timestampOffset === 'number') {
	      mappingObj = {
	        time: segmentInfo.startOfSegment,
	        mapping: segmentInfo.startOfSegment - timingInfo.start
	      };
	
	      if (shouldSaveTimelineMapping) {
	        this.timelines[segmentInfo.timeline] = mappingObj;
	        this.trigger('timestampoffset');
	        this.logger_("time mapping for timeline " + segmentInfo.timeline + ": " + ("[time: " + mappingObj.time + "] [mapping: " + mappingObj.mapping + "]"));
	      }
	
	      start = segmentInfo.startOfSegment;
	      end = timingInfo.end + mappingObj.mapping;
	    } else if (mappingObj) {
	      start = timingInfo.start + mappingObj.mapping;
	      end = timingInfo.end + mappingObj.mapping;
	    } else {
	      return false;
	    }
	
	    if (part) {
	      part.start = start;
	      part.end = end;
	    } // If we don't have a segment start yet or the start value we got
	    // is less than our current segment.start value, save a new start value.
	    // We have to do this because parts will have segment timing info saved
	    // multiple times and we want segment start to be the earliest part start
	    // value for that segment.
	
	
	    if (!segment.start || start < segment.start) {
	      segment.start = start;
	    }
	
	    segment.end = end;
	    return true;
	  }
	  /**
	   * Each time we have discontinuity in the playlist, attempt to calculate the location
	   * in display of the start of the discontinuity and save that. We also save an accuracy
	   * value so that we save values with the most accuracy (closest to 0.)
	   *
	   * @private
	   * @param {SegmentInfo} segmentInfo - The current active request information
	   */
	  ;
	
	  _proto.saveDiscontinuitySyncInfo_ = function saveDiscontinuitySyncInfo_(segmentInfo) {
	    var playlist = segmentInfo.playlist;
	    var segment = segmentInfo.segment; // If the current segment is a discontinuity then we know exactly where
	    // the start of the range and it's accuracy is 0 (greater accuracy values
	    // mean more approximation)
	
	    if (segment.discontinuity) {
	      this.discontinuities[segment.timeline] = {
	        time: segment.start,
	        accuracy: 0
	      };
	    } else if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) {
	      // Search for future discontinuities that we can provide better timing
	      // information for and save that information for sync purposes
	      for (var i = 0; i < playlist.discontinuityStarts.length; i++) {
	        var segmentIndex = playlist.discontinuityStarts[i];
	        var discontinuity = playlist.discontinuitySequence + i + 1;
	        var mediaIndexDiff = segmentIndex - segmentInfo.mediaIndex;
	        var accuracy = Math.abs(mediaIndexDiff);
	
	        if (!this.discontinuities[discontinuity] || this.discontinuities[discontinuity].accuracy > accuracy) {
	          var time = void 0;
	
	          if (mediaIndexDiff < 0) {
	            time = segment.start - sumDurations({
	              defaultDuration: playlist.targetDuration,
	              durationList: playlist.segments,
	              startIndex: segmentInfo.mediaIndex,
	              endIndex: segmentIndex
	            });
	          } else {
	            time = segment.end + sumDurations({
	              defaultDuration: playlist.targetDuration,
	              durationList: playlist.segments,
	              startIndex: segmentInfo.mediaIndex + 1,
	              endIndex: segmentIndex
	            });
	          }
	
	          this.discontinuities[discontinuity] = {
	            time: time,
	            accuracy: accuracy
	          };
	        }
	      }
	    }
	  };
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.off();
	  };
	
	  return SyncController;
	}(videojs.EventTarget);
	/**
	 * The TimelineChangeController acts as a source for segment loaders to listen for and
	 * keep track of latest and pending timeline changes. This is useful to ensure proper
	 * sync, as each loader may need to make a consideration for what timeline the other
	 * loader is on before making changes which could impact the other loader's media.
	 *
	 * @class TimelineChangeController
	 * @extends videojs.EventTarget
	 */
	
	
	var TimelineChangeController = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](TimelineChangeController, _videojs$EventTarget);
	
	  function TimelineChangeController() {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this;
	    _this.pendingTimelineChanges_ = {};
	    _this.lastTimelineChanges_ = {};
	    return _this;
	  }
	
	  var _proto = TimelineChangeController.prototype;
	
	  _proto.clearPendingTimelineChange = function clearPendingTimelineChange(type) {
	    this.pendingTimelineChanges_[type] = null;
	    this.trigger('pendingtimelinechange');
	  };
	
	  _proto.pendingTimelineChange = function pendingTimelineChange(_ref) {
	    var type = _ref.type,
	        from = _ref.from,
	        to = _ref.to;
	
	    if (typeof from === 'number' && typeof to === 'number') {
	      this.pendingTimelineChanges_[type] = {
	        type: type,
	        from: from,
	        to: to
	      };
	      this.trigger('pendingtimelinechange');
	    }
	
	    return this.pendingTimelineChanges_[type];
	  };
	
	  _proto.lastTimelineChange = function lastTimelineChange(_ref2) {
	    var type = _ref2.type,
	        from = _ref2.from,
	        to = _ref2.to;
	
	    if (typeof from === 'number' && typeof to === 'number') {
	      this.lastTimelineChanges_[type] = {
	        type: type,
	        from: from,
	        to: to
	      };
	      delete this.pendingTimelineChanges_[type];
	      this.trigger('timelinechange');
	    }
	
	    return this.lastTimelineChanges_[type];
	  };
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.pendingTimelineChanges_ = {};
	    this.lastTimelineChanges_ = {};
	    this.off();
	  };
	
	  return TimelineChangeController;
	}(videojs.EventTarget);
	/* rollup-plugin-worker-factory start for worker!/home/runner/work/http-streaming/http-streaming/src/decrypter-worker.js */
	
	
	var workerCode = transform(getWorkerString(function () {
	  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	  function createCommonjsModule(fn, basedir, module) {
	    return module = {
	      path: basedir,
	      exports: {},
	      require: function require(path, base) {
	        return commonjsRequire(path, base === undefined || base === null ? module.path : base);
	      }
	    }, fn(module, module.exports), module.exports;
	  }
	
	  function commonjsRequire() {
	    throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
	  }
	
	  var createClass = createCommonjsModule(function (module) {
	    function _defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    function _createClass(Constructor, protoProps, staticProps) {
	      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) _defineProperties(Constructor, staticProps);
	      return Constructor;
	    }
	
	    module.exports = _createClass;
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  });
	  var setPrototypeOf = createCommonjsModule(function (module) {
	    function _setPrototypeOf(o, p) {
	      module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	        o.__proto__ = p;
	        return o;
	      };
	
	      module.exports["default"] = module.exports, module.exports.__esModule = true;
	      return _setPrototypeOf(o, p);
	    }
	
	    module.exports = _setPrototypeOf;
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  });
	  var inheritsLoose = createCommonjsModule(function (module) {
	    function _inheritsLoose(subClass, superClass) {
	      subClass.prototype = Object.create(superClass.prototype);
	      subClass.prototype.constructor = subClass;
	      setPrototypeOf(subClass, superClass);
	    }
	
	    module.exports = _inheritsLoose;
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  });
	  /**
	   * @file stream.js
	   */
	
	  /**
	   * A lightweight readable stream implemention that handles event dispatching.
	   *
	   * @class Stream
	   */
	
	  var Stream = /*#__PURE__*/function () {
	    function Stream() {
	      this.listeners = {};
	    }
	    /**
	     * Add a listener for a specified event type.
	     *
	     * @param {string} type the event name
	     * @param {Function} listener the callback to be invoked when an event of
	     * the specified type occurs
	     */
	
	
	    var _proto = Stream.prototype;
	
	    _proto.on = function on(type, listener) {
	      if (!this.listeners[type]) {
	        this.listeners[type] = [];
	      }
	
	      this.listeners[type].push(listener);
	    }
	    /**
	     * Remove a listener for a specified event type.
	     *
	     * @param {string} type the event name
	     * @param {Function} listener  a function previously registered for this
	     * type of event through `on`
	     * @return {boolean} if we could turn it off or not
	     */
	    ;
	
	    _proto.off = function off(type, listener) {
	      if (!this.listeners[type]) {
	        return false;
	      }
	
	      var index = this.listeners[type].indexOf(listener); // TODO: which is better?
	      // In Video.js we slice listener functions
	      // on trigger so that it does not mess up the order
	      // while we loop through.
	      //
	      // Here we slice on off so that the loop in trigger
	      // can continue using it's old reference to loop without
	      // messing up the order.
	
	      this.listeners[type] = this.listeners[type].slice(0);
	      this.listeners[type].splice(index, 1);
	      return index > -1;
	    }
	    /**
	     * Trigger an event of the specified type on this stream. Any additional
	     * arguments to this function are passed as parameters to event listeners.
	     *
	     * @param {string} type the event name
	     */
	    ;
	
	    _proto.trigger = function trigger(type) {
	      var callbacks = this.listeners[type];
	
	      if (!callbacks) {
	        return;
	      } // Slicing the arguments on every invocation of this method
	      // can add a significant amount of overhead. Avoid the
	      // intermediate object creation for the common case of a
	      // single callback argument
	
	
	      if (arguments.length === 2) {
	        var length = callbacks.length;
	
	        for (var i = 0; i < length; ++i) {
	          callbacks[i].call(this, arguments[1]);
	        }
	      } else {
	        var args = Array.prototype.slice.call(arguments, 1);
	        var _length = callbacks.length;
	
	        for (var _i = 0; _i < _length; ++_i) {
	          callbacks[_i].apply(this, args);
	        }
	      }
	    }
	    /**
	     * Destroys the stream and cleans up.
	     */
	    ;
	
	    _proto.dispose = function dispose() {
	      this.listeners = {};
	    }
	    /**
	     * Forwards all `data` events on this stream to the destination stream. The
	     * destination stream should provide a method `push` to receive the data
	     * events as they arrive.
	     *
	     * @param {Stream} destination the stream that will receive all `data` events
	     * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	     */
	    ;
	
	    _proto.pipe = function pipe(destination) {
	      this.on('data', function (data) {
	        destination.push(data);
	      });
	    };
	
	    return Stream;
	  }();
	  /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */
	
	  /**
	   * Returns the subarray of a Uint8Array without PKCS#7 padding.
	   *
	   * @param padded {Uint8Array} unencrypted bytes that have been padded
	   * @return {Uint8Array} the unpadded bytes
	   * @see http://tools.ietf.org/html/rfc5652
	   */
	
	
	  function unpad(padded) {
	    return padded.subarray(0, padded.byteLength - padded[padded.byteLength - 1]);
	  }
	  /*! @name aes-decrypter @version 3.1.3 @license Apache-2.0 */
	
	  /**
	   * @file aes.js
	   *
	   * This file contains an adaptation of the AES decryption algorithm
	   * from the Standford Javascript Cryptography Library. That work is
	   * covered by the following copyright and permissions notice:
	   *
	   * Copyright 2009-2010 Emily Stark, Mike Hamburg, Dan Boneh.
	   * All rights reserved.
	   *
	   * Redistribution and use in source and binary forms, with or without
	   * modification, are permitted provided that the following conditions are
	   * met:
	   *
	   * 1. Redistributions of source code must retain the above copyright
	   *    notice, this list of conditions and the following disclaimer.
	   *
	   * 2. Redistributions in binary form must reproduce the above
	   *    copyright notice, this list of conditions and the following
	   *    disclaimer in the documentation and/or other materials provided
	   *    with the distribution.
	   *
	   * THIS SOFTWARE IS PROVIDED BY THE AUTHORS ``AS IS'' AND ANY EXPRESS OR
	   * IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	   * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	   * DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> OR CONTRIBUTORS BE
	   * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
	   * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
	   * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
	   * BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	   * WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
	   * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN
	   * IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	   *
	   * The views and conclusions contained in the software and documentation
	   * are those of the authors and should not be interpreted as representing
	   * official policies, either expressed or implied, of the authors.
	   */
	
	  /**
	   * Expand the S-box tables.
	   *
	   * @private
	   */
	
	
	  var precompute = function precompute() {
	    var tables = [[[], [], [], [], []], [[], [], [], [], []]];
	    var encTable = tables[0];
	    var decTable = tables[1];
	    var sbox = encTable[4];
	    var sboxInv = decTable[4];
	    var i;
	    var x;
	    var xInv;
	    var d = [];
	    var th = [];
	    var x2;
	    var x4;
	    var x8;
	    var s;
	    var tEnc;
	    var tDec; // Compute double and third tables
	
	    for (i = 0; i < 256; i++) {
	      th[(d[i] = i << 1 ^ (i >> 7) * 283) ^ i] = i;
	    }
	
	    for (x = xInv = 0; !sbox[x]; x ^= x2 || 1, xInv = th[xInv] || 1) {
	      // Compute sbox
	      s = xInv ^ xInv << 1 ^ xInv << 2 ^ xInv << 3 ^ xInv << 4;
	      s = s >> 8 ^ s & 255 ^ 99;
	      sbox[x] = s;
	      sboxInv[s] = x; // Compute MixColumns
	
	      x8 = d[x4 = d[x2 = d[x]]];
	      tDec = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
	      tEnc = d[s] * 0x101 ^ s * 0x1010100;
	
	      for (i = 0; i < 4; i++) {
	        encTable[i][x] = tEnc = tEnc << 24 ^ tEnc >>> 8;
	        decTable[i][s] = tDec = tDec << 24 ^ tDec >>> 8;
	      }
	    } // Compactify. Considerable speedup on Firefox.
	
	
	    for (i = 0; i < 5; i++) {
	      encTable[i] = encTable[i].slice(0);
	      decTable[i] = decTable[i].slice(0);
	    }
	
	    return tables;
	  };
	
	  var aesTables = null;
	  /**
	   * Schedule out an AES key for both encryption and decryption. This
	   * is a low-level class. Use a cipher mode to do bulk encryption.
	   *
	   * @class AES
	   * @param key {Array} The key as an array of 4, 6 or 8 words.
	   */
	
	  var AES = /*#__PURE__*/function () {
	    function AES(key) {
	      /**
	      * The expanded S-box and inverse S-box tables. These will be computed
	      * on the client so that we don't have to send them down the wire.
	      *
	      * There are two tables, _tables[0] is for encryption and
	      * _tables[1] is for decryption.
	      *
	      * The first 4 sub-tables are the expanded S-box with MixColumns. The
	      * last (_tables[01][4]) is the S-box itself.
	      *
	      * @private
	      */
	      // if we have yet to precompute the S-box tables
	      // do so now
	      if (!aesTables) {
	        aesTables = precompute();
	      } // then make a copy of that object for use
	
	
	      this._tables = [[aesTables[0][0].slice(), aesTables[0][1].slice(), aesTables[0][2].slice(), aesTables[0][3].slice(), aesTables[0][4].slice()], [aesTables[1][0].slice(), aesTables[1][1].slice(), aesTables[1][2].slice(), aesTables[1][3].slice(), aesTables[1][4].slice()]];
	      var i;
	      var j;
	      var tmp;
	      var sbox = this._tables[0][4];
	      var decTable = this._tables[1];
	      var keyLen = key.length;
	      var rcon = 1;
	
	      if (keyLen !== 4 && keyLen !== 6 && keyLen !== 8) {
	        throw new Error('Invalid aes key size');
	      }
	
	      var encKey = key.slice(0);
	      var decKey = [];
	      this._key = [encKey, decKey]; // schedule encryption keys
	
	      for (i = keyLen; i < 4 * keyLen + 28; i++) {
	        tmp = encKey[i - 1]; // apply sbox
	
	        if (i % keyLen === 0 || keyLen === 8 && i % keyLen === 4) {
	          tmp = sbox[tmp >>> 24] << 24 ^ sbox[tmp >> 16 & 255] << 16 ^ sbox[tmp >> 8 & 255] << 8 ^ sbox[tmp & 255]; // shift rows and add rcon
	
	          if (i % keyLen === 0) {
	            tmp = tmp << 8 ^ tmp >>> 24 ^ rcon << 24;
	            rcon = rcon << 1 ^ (rcon >> 7) * 283;
	          }
	        }
	
	        encKey[i] = encKey[i - keyLen] ^ tmp;
	      } // schedule decryption keys
	
	
	      for (j = 0; i; j++, i--) {
	        tmp = encKey[j & 3 ? i : i - 4];
	
	        if (i <= 4 || j < 4) {
	          decKey[j] = tmp;
	        } else {
	          decKey[j] = decTable[0][sbox[tmp >>> 24]] ^ decTable[1][sbox[tmp >> 16 & 255]] ^ decTable[2][sbox[tmp >> 8 & 255]] ^ decTable[3][sbox[tmp & 255]];
	        }
	      }
	    }
	    /**
	     * Decrypt 16 bytes, specified as four 32-bit words.
	     *
	     * @param {number} encrypted0 the first word to decrypt
	     * @param {number} encrypted1 the second word to decrypt
	     * @param {number} encrypted2 the third word to decrypt
	     * @param {number} encrypted3 the fourth word to decrypt
	     * @param {Int32Array} out the array to write the decrypted words
	     * into
	     * @param {number} offset the offset into the output array to start
	     * writing results
	     * @return {Array} The plaintext.
	     */
	
	
	    var _proto = AES.prototype;
	
	    _proto.decrypt = function decrypt(encrypted0, encrypted1, encrypted2, encrypted3, out, offset) {
	      var key = this._key[1]; // state variables a,b,c,d are loaded with pre-whitened data
	
	      var a = encrypted0 ^ key[0];
	      var b = encrypted3 ^ key[1];
	      var c = encrypted2 ^ key[2];
	      var d = encrypted1 ^ key[3];
	      var a2;
	      var b2;
	      var c2; // key.length === 2 ?
	
	      var nInnerRounds = key.length / 4 - 2;
	      var i;
	      var kIndex = 4;
	      var table = this._tables[1]; // load up the tables
	
	      var table0 = table[0];
	      var table1 = table[1];
	      var table2 = table[2];
	      var table3 = table[3];
	      var sbox = table[4]; // Inner rounds. Cribbed from OpenSSL.
	
	      for (i = 0; i < nInnerRounds; i++) {
	        a2 = table0[a >>> 24] ^ table1[b >> 16 & 255] ^ table2[c >> 8 & 255] ^ table3[d & 255] ^ key[kIndex];
	        b2 = table0[b >>> 24] ^ table1[c >> 16 & 255] ^ table2[d >> 8 & 255] ^ table3[a & 255] ^ key[kIndex + 1];
	        c2 = table0[c >>> 24] ^ table1[d >> 16 & 255] ^ table2[a >> 8 & 255] ^ table3[b & 255] ^ key[kIndex + 2];
	        d = table0[d >>> 24] ^ table1[a >> 16 & 255] ^ table2[b >> 8 & 255] ^ table3[c & 255] ^ key[kIndex + 3];
	        kIndex += 4;
	        a = a2;
	        b = b2;
	        c = c2;
	      } // Last round.
	
	
	      for (i = 0; i < 4; i++) {
	        out[(3 & -i) + offset] = sbox[a >>> 24] << 24 ^ sbox[b >> 16 & 255] << 16 ^ sbox[c >> 8 & 255] << 8 ^ sbox[d & 255] ^ key[kIndex++];
	        a2 = a;
	        a = b;
	        b = c;
	        c = d;
	        d = a2;
	      }
	    };
	
	    return AES;
	  }();
	  /**
	   * A wrapper around the Stream class to use setTimeout
	   * and run stream "jobs" Asynchronously
	   *
	   * @class AsyncStream
	   * @extends Stream
	   */
	
	
	  var AsyncStream = /*#__PURE__*/function (_Stream) {
	    inheritsLoose(AsyncStream, _Stream);
	
	    function AsyncStream() {
	      var _this;
	
	      _this = _Stream.call(this, Stream) || this;
	      _this.jobs = [];
	      _this.delay = 1;
	      _this.timeout_ = null;
	      return _this;
	    }
	    /**
	     * process an async job
	     *
	     * @private
	     */
	
	
	    var _proto = AsyncStream.prototype;
	
	    _proto.processJob_ = function processJob_() {
	      this.jobs.shift()();
	
	      if (this.jobs.length) {
	        this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
	      } else {
	        this.timeout_ = null;
	      }
	    }
	    /**
	     * push a job into the stream
	     *
	     * @param {Function} job the job to push into the stream
	     */
	    ;
	
	    _proto.push = function push(job) {
	      this.jobs.push(job);
	
	      if (!this.timeout_) {
	        this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
	      }
	    };
	
	    return AsyncStream;
	  }(Stream);
	  /**
	   * Convert network-order (big-endian) bytes into their little-endian
	   * representation.
	   */
	
	
	  var ntoh = function ntoh(word) {
	    return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
	  };
	  /**
	   * Decrypt bytes using AES-128 with CBC and PKCS#7 padding.
	   *
	   * @param {Uint8Array} encrypted the encrypted bytes
	   * @param {Uint32Array} key the bytes of the decryption key
	   * @param {Uint32Array} initVector the initialization vector (IV) to
	   * use for the first round of CBC.
	   * @return {Uint8Array} the decrypted bytes
	   *
	   * @see http://en.wikipedia.org/wiki/Advanced_Encryption_Standard
	   * @see http://en.wikipedia.org/wiki/Block_cipher_mode_of_operation#Cipher_Block_Chaining_.28CBC.29
	   * @see https://tools.ietf.org/html/rfc2315
	   */
	
	
	  var decrypt = function decrypt(encrypted, key, initVector) {
	    // word-level access to the encrypted bytes
	    var encrypted32 = new Int32Array(encrypted.buffer, encrypted.byteOffset, encrypted.byteLength >> 2);
	    var decipher = new AES(Array.prototype.slice.call(key)); // byte and word-level access for the decrypted output
	
	    var decrypted = new Uint8Array(encrypted.byteLength);
	    var decrypted32 = new Int32Array(decrypted.buffer); // temporary variables for working with the IV, encrypted, and
	    // decrypted data
	
	    var init0;
	    var init1;
	    var init2;
	    var init3;
	    var encrypted0;
	    var encrypted1;
	    var encrypted2;
	    var encrypted3; // iteration variable
	
	    var wordIx; // pull out the words of the IV to ensure we don't modify the
	    // passed-in reference and easier access
	
	    init0 = initVector[0];
	    init1 = initVector[1];
	    init2 = initVector[2];
	    init3 = initVector[3]; // decrypt four word sequences, applying cipher-block chaining (CBC)
	    // to each decrypted block
	
	    for (wordIx = 0; wordIx < encrypted32.length; wordIx += 4) {
	      // convert big-endian (network order) words into little-endian
	      // (javascript order)
	      encrypted0 = ntoh(encrypted32[wordIx]);
	      encrypted1 = ntoh(encrypted32[wordIx + 1]);
	      encrypted2 = ntoh(encrypted32[wordIx + 2]);
	      encrypted3 = ntoh(encrypted32[wordIx + 3]); // decrypt the block
	
	      decipher.decrypt(encrypted0, encrypted1, encrypted2, encrypted3, decrypted32, wordIx); // XOR with the IV, and restore network byte-order to obtain the
	      // plaintext
	
	      decrypted32[wordIx] = ntoh(decrypted32[wordIx] ^ init0);
	      decrypted32[wordIx + 1] = ntoh(decrypted32[wordIx + 1] ^ init1);
	      decrypted32[wordIx + 2] = ntoh(decrypted32[wordIx + 2] ^ init2);
	      decrypted32[wordIx + 3] = ntoh(decrypted32[wordIx + 3] ^ init3); // setup the IV for the next round
	
	      init0 = encrypted0;
	      init1 = encrypted1;
	      init2 = encrypted2;
	      init3 = encrypted3;
	    }
	
	    return decrypted;
	  };
	  /**
	   * The `Decrypter` class that manages decryption of AES
	   * data through `AsyncStream` objects and the `decrypt`
	   * function
	   *
	   * @param {Uint8Array} encrypted the encrypted bytes
	   * @param {Uint32Array} key the bytes of the decryption key
	   * @param {Uint32Array} initVector the initialization vector (IV) to
	   * @param {Function} done the function to run when done
	   * @class Decrypter
	   */
	
	
	  var Decrypter = /*#__PURE__*/function () {
	    function Decrypter(encrypted, key, initVector, done) {
	      var step = Decrypter.STEP;
	      var encrypted32 = new Int32Array(encrypted.buffer);
	      var decrypted = new Uint8Array(encrypted.byteLength);
	      var i = 0;
	      this.asyncStream_ = new AsyncStream(); // split up the encryption job and do the individual chunks asynchronously
	
	      this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
	
	      for (i = step; i < encrypted32.length; i += step) {
	        initVector = new Uint32Array([ntoh(encrypted32[i - 4]), ntoh(encrypted32[i - 3]), ntoh(encrypted32[i - 2]), ntoh(encrypted32[i - 1])]);
	        this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
	      } // invoke the done() callback when everything is finished
	
	
	      this.asyncStream_.push(function () {
	        // remove pkcs#7 padding from the decrypted bytes
	        done(null, unpad(decrypted));
	      });
	    }
	    /**
	     * a getter for step the maximum number of bytes to process at one time
	     *
	     * @return {number} the value of step 32000
	     */
	
	
	    var _proto = Decrypter.prototype;
	    /**
	     * @private
	     */
	
	    _proto.decryptChunk_ = function decryptChunk_(encrypted, key, initVector, decrypted) {
	      return function () {
	        var bytes = decrypt(encrypted, key, initVector);
	        decrypted.set(bytes, encrypted.byteOffset);
	      };
	    };
	
	    createClass(Decrypter, null, [{
	      key: "STEP",
	      get: function get() {
	        // 4 * 8000;
	        return 32000;
	      }
	    }]);
	    return Decrypter;
	  }();
	
	  var win;
	
	  if (typeof window !== "undefined") {
	    win = window;
	  } else if (typeof commonjsGlobal !== "undefined") {
	    win = commonjsGlobal;
	  } else if (typeof self !== "undefined") {
	    win = self;
	  } else {
	    win = {};
	  }
	
	  var window_1 = win;
	
	  var isArrayBufferView = function isArrayBufferView(obj) {
	    if (ArrayBuffer.isView === 'function') {
	      return ArrayBuffer.isView(obj);
	    }
	
	    return obj && obj.buffer instanceof ArrayBuffer;
	  };
	
	  var BigInt = window_1.BigInt || Number;
	  [BigInt('0x1'), BigInt('0x100'), BigInt('0x10000'), BigInt('0x1000000'), BigInt('0x100000000'), BigInt('0x10000000000'), BigInt('0x1000000000000'), BigInt('0x100000000000000'), BigInt('0x10000000000000000')];
	  /**
	   * Creates an object for sending to a web worker modifying properties that are TypedArrays
	   * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
	   *
	   * @param {Object} message
	   *        Object of properties and values to send to the web worker
	   * @return {Object}
	   *         Modified message with TypedArray values expanded
	   * @function createTransferableMessage
	   */
	
	
	  var createTransferableMessage = function createTransferableMessage(message) {
	    var transferable = {};
	    Object.keys(message).forEach(function (key) {
	      var value = message[key];
	
	      if (isArrayBufferView(value)) {
	        transferable[key] = {
	          bytes: value.buffer,
	          byteOffset: value.byteOffset,
	          byteLength: value.byteLength
	        };
	      } else {
	        transferable[key] = value;
	      }
	    });
	    return transferable;
	  };
	  /* global self */
	
	  /**
	   * Our web worker interface so that things can talk to aes-decrypter
	   * that will be running in a web worker. the scope is passed to this by
	   * webworkify.
	   */
	
	
	  self.onmessage = function (event) {
	    var data = event.data;
	    var encrypted = new Uint8Array(data.encrypted.bytes, data.encrypted.byteOffset, data.encrypted.byteLength);
	    var key = new Uint32Array(data.key.bytes, data.key.byteOffset, data.key.byteLength / 4);
	    var iv = new Uint32Array(data.iv.bytes, data.iv.byteOffset, data.iv.byteLength / 4);
	    /* eslint-disable no-new, handle-callback-err */
	
	    new Decrypter(encrypted, key, iv, function (err, bytes) {
	      self.postMessage(createTransferableMessage({
	        source: data.source,
	        decrypted: bytes
	      }), [bytes.buffer]);
	    });
	    /* eslint-enable */
	  };
	}));
	var Decrypter = factory(workerCode);
	/* rollup-plugin-worker-factory end for worker!/home/runner/work/http-streaming/http-streaming/src/decrypter-worker.js */
	
	/**
	 * Convert the properties of an HLS track into an audioTrackKind.
	 *
	 * @private
	 */
	
	var audioTrackKind_ = function audioTrackKind_(properties) {
	  var kind = properties["default"] ? 'main' : 'alternative';
	
	  if (properties.characteristics && properties.characteristics.indexOf('public.accessibility.describes-video') >= 0) {
	    kind = 'main-desc';
	  }
	
	  return kind;
	};
	/**
	 * Pause provided segment loader and playlist loader if active
	 *
	 * @param {SegmentLoader} segmentLoader
	 *        SegmentLoader to pause
	 * @param {Object} mediaType
	 *        Active media type
	 * @function stopLoaders
	 */
	
	
	var stopLoaders = function stopLoaders(segmentLoader, mediaType) {
	  segmentLoader.abort();
	  segmentLoader.pause();
	
	  if (mediaType && mediaType.activePlaylistLoader) {
	    mediaType.activePlaylistLoader.pause();
	    mediaType.activePlaylistLoader = null;
	  }
	};
	/**
	 * Start loading provided segment loader and playlist loader
	 *
	 * @param {PlaylistLoader} playlistLoader
	 *        PlaylistLoader to start loading
	 * @param {Object} mediaType
	 *        Active media type
	 * @function startLoaders
	 */
	
	
	var startLoaders = function startLoaders(playlistLoader, mediaType) {
	  // Segment loader will be started after `loadedmetadata` or `loadedplaylist` from the
	  // playlist loader
	  mediaType.activePlaylistLoader = playlistLoader;
	  playlistLoader.load();
	};
	/**
	 * Returns a function to be called when the media group changes. It performs a
	 * non-destructive (preserve the buffer) resync of the SegmentLoader. This is because a
	 * change of group is merely a rendition switch of the same content at another encoding,
	 * rather than a change of content, such as switching audio from English to Spanish.
	 *
	 * @param {string} type
	 *        MediaGroup type
	 * @param {Object} settings
	 *        Object containing required information for media groups
	 * @return {Function}
	 *         Handler for a non-destructive resync of SegmentLoader when the active media
	 *         group changes.
	 * @function onGroupChanged
	 */
	
	
	var onGroupChanged = function onGroupChanged(type, settings) {
	  return function () {
	    var _settings$segmentLoad = settings.segmentLoaders,
	        segmentLoader = _settings$segmentLoad[type],
	        mainSegmentLoader = _settings$segmentLoad.main,
	        mediaType = settings.mediaTypes[type];
	    var activeTrack = mediaType.activeTrack();
	    var activeGroup = mediaType.getActiveGroup();
	    var previousActiveLoader = mediaType.activePlaylistLoader;
	    var lastGroup = mediaType.lastGroup_; // the group did not change do nothing
	
	    if (activeGroup && lastGroup && activeGroup.id === lastGroup.id) {
	      return;
	    }
	
	    mediaType.lastGroup_ = activeGroup;
	    mediaType.lastTrack_ = activeTrack;
	    stopLoaders(segmentLoader, mediaType);
	
	    if (!activeGroup || activeGroup.isMasterPlaylist) {
	      // there is no group active or active group is a main playlist and won't change
	      return;
	    }
	
	    if (!activeGroup.playlistLoader) {
	      if (previousActiveLoader) {
	        // The previous group had a playlist loader but the new active group does not
	        // this means we are switching from demuxed to muxed audio. In this case we want to
	        // do a destructive reset of the main segment loader and not restart the audio
	        // loaders.
	        mainSegmentLoader.resetEverything();
	      }
	
	      return;
	    } // Non-destructive resync
	
	
	    segmentLoader.resyncLoader();
	    startLoaders(activeGroup.playlistLoader, mediaType);
	  };
	};
	
	var onGroupChanging = function onGroupChanging(type, settings) {
	  return function () {
	    var segmentLoader = settings.segmentLoaders[type],
	        mediaType = settings.mediaTypes[type];
	    mediaType.lastGroup_ = null;
	    segmentLoader.abort();
	    segmentLoader.pause();
	  };
	};
	/**
	 * Returns a function to be called when the media track changes. It performs a
	 * destructive reset of the SegmentLoader to ensure we start loading as close to
	 * currentTime as possible.
	 *
	 * @param {string} type
	 *        MediaGroup type
	 * @param {Object} settings
	 *        Object containing required information for media groups
	 * @return {Function}
	 *         Handler for a destructive reset of SegmentLoader when the active media
	 *         track changes.
	 * @function onTrackChanged
	 */
	
	
	var onTrackChanged = function onTrackChanged(type, settings) {
	  return function () {
	    var masterPlaylistLoader = settings.masterPlaylistLoader,
	        _settings$segmentLoad2 = settings.segmentLoaders,
	        segmentLoader = _settings$segmentLoad2[type],
	        mainSegmentLoader = _settings$segmentLoad2.main,
	        mediaType = settings.mediaTypes[type];
	    var activeTrack = mediaType.activeTrack();
	    var activeGroup = mediaType.getActiveGroup();
	    var previousActiveLoader = mediaType.activePlaylistLoader;
	    var lastTrack = mediaType.lastTrack_; // track did not change, do nothing
	
	    if (lastTrack && activeTrack && lastTrack.id === activeTrack.id) {
	      return;
	    }
	
	    mediaType.lastGroup_ = activeGroup;
	    mediaType.lastTrack_ = activeTrack;
	    stopLoaders(segmentLoader, mediaType);
	
	    if (!activeGroup) {
	      // there is no group active so we do not want to restart loaders
	      return;
	    }
	
	    if (activeGroup.isMasterPlaylist) {
	      // track did not change, do nothing
	      if (!activeTrack || !lastTrack || activeTrack.id === lastTrack.id) {
	        return;
	      }
	
	      var mpc = settings.vhs.masterPlaylistController_;
	      var newPlaylist = mpc.selectPlaylist(); // media will not change do nothing
	
	      if (mpc.media() === newPlaylist) {
	        return;
	      }
	
	      mediaType.logger_("track change. Switching master audio from " + lastTrack.id + " to " + activeTrack.id);
	      masterPlaylistLoader.pause();
	      mainSegmentLoader.resetEverything();
	      mpc.fastQualityChange_(newPlaylist);
	      return;
	    }
	
	    if (type === 'AUDIO') {
	      if (!activeGroup.playlistLoader) {
	        // when switching from demuxed audio/video to muxed audio/video (noted by no
	        // playlist loader for the audio group), we want to do a destructive reset of the
	        // main segment loader and not restart the audio loaders
	        mainSegmentLoader.setAudio(true); // don't have to worry about disabling the audio of the audio segment loader since
	        // it should be stopped
	
	        mainSegmentLoader.resetEverything();
	        return;
	      } // although the segment loader is an audio segment loader, call the setAudio
	      // function to ensure it is prepared to re-append the init segment (or handle other
	      // config changes)
	
	
	      segmentLoader.setAudio(true);
	      mainSegmentLoader.setAudio(false);
	    }
	
	    if (previousActiveLoader === activeGroup.playlistLoader) {
	      // Nothing has actually changed. This can happen because track change events can fire
	      // multiple times for a "single" change. One for enabling the new active track, and
	      // one for disabling the track that was active
	      startLoaders(activeGroup.playlistLoader, mediaType);
	      return;
	    }
	
	    if (segmentLoader.track) {
	      // For WebVTT, set the new text track in the segmentloader
	      segmentLoader.track(activeTrack);
	    } // destructive reset
	
	
	    segmentLoader.resetEverything();
	    startLoaders(activeGroup.playlistLoader, mediaType);
	  };
	};
	
	var onError = {
	  /**
	   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
	   * an error.
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Error handler. Logs warning (or error if the playlist is blacklisted) to
	   *         console and switches back to default audio track.
	   * @function onError.AUDIO
	   */
	  AUDIO: function AUDIO(type, settings) {
	    return function () {
	      var segmentLoader = settings.segmentLoaders[type],
	          mediaType = settings.mediaTypes[type],
	          blacklistCurrentPlaylist = settings.blacklistCurrentPlaylist;
	      stopLoaders(segmentLoader, mediaType); // switch back to default audio track
	
	      var activeTrack = mediaType.activeTrack();
	      var activeGroup = mediaType.activeGroup();
	      var id = (activeGroup.filter(function (group) {
	        return group["default"];
	      })[0] || activeGroup[0]).id;
	      var defaultTrack = mediaType.tracks[id];
	
	      if (activeTrack === defaultTrack) {
	        // Default track encountered an error. All we can do now is blacklist the current
	        // rendition and hope another will switch audio groups
	        blacklistCurrentPlaylist({
	          message: 'Problem encountered loading the default audio track.'
	        });
	        return;
	      }
	
	      videojs.log.warn('Problem encountered loading the alternate audio track.' + 'Switching back to default.');
	
	      for (var trackId in mediaType.tracks) {
	        mediaType.tracks[trackId].enabled = mediaType.tracks[trackId] === defaultTrack;
	      }
	
	      mediaType.onTrackChanged();
	    };
	  },
	
	  /**
	   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
	   * an error.
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Error handler. Logs warning to console and disables the active subtitle track
	   * @function onError.SUBTITLES
	   */
	  SUBTITLES: function SUBTITLES(type, settings) {
	    return function () {
	      var segmentLoader = settings.segmentLoaders[type],
	          mediaType = settings.mediaTypes[type];
	      videojs.log.warn('Problem encountered loading the subtitle track.' + 'Disabling subtitle track.');
	      stopLoaders(segmentLoader, mediaType);
	      var track = mediaType.activeTrack();
	
	      if (track) {
	        track.mode = 'disabled';
	      }
	
	      mediaType.onTrackChanged();
	    };
	  }
	};
	var setupListeners = {
	  /**
	   * Setup event listeners for audio playlist loader
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {PlaylistLoader|null} playlistLoader
	   *        PlaylistLoader to register listeners on
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function setupListeners.AUDIO
	   */
	  AUDIO: function AUDIO(type, playlistLoader, settings) {
	    if (!playlistLoader) {
	      // no playlist loader means audio will be muxed with the video
	      return;
	    }
	
	    var tech = settings.tech,
	        requestOptions = settings.requestOptions,
	        segmentLoader = settings.segmentLoaders[type];
	    playlistLoader.on('loadedmetadata', function () {
	      var media = playlistLoader.media();
	      segmentLoader.playlist(media, requestOptions); // if the video is already playing, or if this isn't a live video and preload
	      // permits, start downloading segments
	
	      if (!tech.paused() || media.endList && tech.preload() !== 'none') {
	        segmentLoader.load();
	      }
	    });
	    playlistLoader.on('loadedplaylist', function () {
	      segmentLoader.playlist(playlistLoader.media(), requestOptions); // If the player isn't paused, ensure that the segment loader is running
	
	      if (!tech.paused()) {
	        segmentLoader.load();
	      }
	    });
	    playlistLoader.on('error', onError[type](type, settings));
	  },
	
	  /**
	   * Setup event listeners for subtitle playlist loader
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {PlaylistLoader|null} playlistLoader
	   *        PlaylistLoader to register listeners on
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function setupListeners.SUBTITLES
	   */
	  SUBTITLES: function SUBTITLES(type, playlistLoader, settings) {
	    var tech = settings.tech,
	        requestOptions = settings.requestOptions,
	        segmentLoader = settings.segmentLoaders[type],
	        mediaType = settings.mediaTypes[type];
	    playlistLoader.on('loadedmetadata', function () {
	      var media = playlistLoader.media();
	      segmentLoader.playlist(media, requestOptions);
	      segmentLoader.track(mediaType.activeTrack()); // if the video is already playing, or if this isn't a live video and preload
	      // permits, start downloading segments
	
	      if (!tech.paused() || media.endList && tech.preload() !== 'none') {
	        segmentLoader.load();
	      }
	    });
	    playlistLoader.on('loadedplaylist', function () {
	      segmentLoader.playlist(playlistLoader.media(), requestOptions); // If the player isn't paused, ensure that the segment loader is running
	
	      if (!tech.paused()) {
	        segmentLoader.load();
	      }
	    });
	    playlistLoader.on('error', onError[type](type, settings));
	  }
	};
	var initialize = {
	  /**
	   * Setup PlaylistLoaders and AudioTracks for the audio groups
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function initialize.AUDIO
	   */
	  'AUDIO': function AUDIO(type, settings) {
	    var vhs = settings.vhs,
	        sourceType = settings.sourceType,
	        segmentLoader = settings.segmentLoaders[type],
	        requestOptions = settings.requestOptions,
	        mediaGroups = settings.master.mediaGroups,
	        _settings$mediaTypes$ = settings.mediaTypes[type],
	        groups = _settings$mediaTypes$.groups,
	        tracks = _settings$mediaTypes$.tracks,
	        logger_ = _settings$mediaTypes$.logger_,
	        masterPlaylistLoader = settings.masterPlaylistLoader;
	    var audioOnlyMaster = isAudioOnly(masterPlaylistLoader.master); // force a default if we have none
	
	    if (!mediaGroups[type] || Object.keys(mediaGroups[type]).length === 0) {
	      mediaGroups[type] = {
	        main: {
	          "default": {
	            "default": true
	          }
	        }
	      };
	
	      if (audioOnlyMaster) {
	        mediaGroups[type].main["default"].playlists = masterPlaylistLoader.master.playlists;
	      }
	    }
	
	    for (var groupId in mediaGroups[type]) {
	      if (!groups[groupId]) {
	        groups[groupId] = [];
	      }
	
	      for (var variantLabel in mediaGroups[type][groupId]) {
	        var properties = mediaGroups[type][groupId][variantLabel];
	        var playlistLoader = void 0;
	
	        if (audioOnlyMaster) {
	          logger_("AUDIO group '" + groupId + "' label '" + variantLabel + "' is a master playlist");
	          properties.isMasterPlaylist = true;
	          playlistLoader = null; // if vhs-json was provided as the source, and the media playlist was resolved,
	          // use the resolved media playlist object
	        } else if (sourceType === 'vhs-json' && properties.playlists) {
	          playlistLoader = new PlaylistLoader(properties.playlists[0], vhs, requestOptions);
	        } else if (properties.resolvedUri) {
	          playlistLoader = new PlaylistLoader(properties.resolvedUri, vhs, requestOptions); // TODO: dash isn't the only type with properties.playlists
	          // should we even have properties.playlists in this check.
	        } else if (properties.playlists && sourceType === 'dash') {
	          playlistLoader = new DashPlaylistLoader(properties.playlists[0], vhs, requestOptions, masterPlaylistLoader);
	        } else {
	          // no resolvedUri means the audio is muxed with the video when using this
	          // audio track
	          playlistLoader = null;
	        }
	
	        properties = videojs.mergeOptions({
	          id: variantLabel,
	          playlistLoader: playlistLoader
	        }, properties);
	        setupListeners[type](type, properties.playlistLoader, settings);
	        groups[groupId].push(properties);
	
	        if (typeof tracks[variantLabel] === 'undefined') {
	          var track = new videojs.AudioTrack({
	            id: variantLabel,
	            kind: audioTrackKind_(properties),
	            enabled: false,
	            language: properties.language,
	            "default": properties["default"],
	            label: variantLabel
	          });
	          tracks[variantLabel] = track;
	        }
	      }
	    } // setup single error event handler for the segment loader
	
	
	    segmentLoader.on('error', onError[type](type, settings));
	  },
	
	  /**
	   * Setup PlaylistLoaders and TextTracks for the subtitle groups
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function initialize.SUBTITLES
	   */
	  'SUBTITLES': function SUBTITLES(type, settings) {
	    var tech = settings.tech,
	        vhs = settings.vhs,
	        sourceType = settings.sourceType,
	        segmentLoader = settings.segmentLoaders[type],
	        requestOptions = settings.requestOptions,
	        mediaGroups = settings.master.mediaGroups,
	        _settings$mediaTypes$2 = settings.mediaTypes[type],
	        groups = _settings$mediaTypes$2.groups,
	        tracks = _settings$mediaTypes$2.tracks,
	        masterPlaylistLoader = settings.masterPlaylistLoader;
	
	    for (var groupId in mediaGroups[type]) {
	      if (!groups[groupId]) {
	        groups[groupId] = [];
	      }
	
	      for (var variantLabel in mediaGroups[type][groupId]) {
	        if (mediaGroups[type][groupId][variantLabel].forced) {
	          // Subtitle playlists with the forced attribute are not selectable in Safari.
	          // According to Apple's HLS Authoring Specification:
	          //   If content has forced subtitles and regular subtitles in a given language,
	          //   the regular subtitles track in that language MUST contain both the forced
	          //   subtitles and the regular subtitles for that language.
	          // Because of this requirement and that Safari does not add forced subtitles,
	          // forced subtitles are skipped here to maintain consistent experience across
	          // all platforms
	          continue;
	        }
	
	        var properties = mediaGroups[type][groupId][variantLabel];
	        var playlistLoader = void 0;
	
	        if (sourceType === 'hls') {
	          playlistLoader = new PlaylistLoader(properties.resolvedUri, vhs, requestOptions);
	        } else if (sourceType === 'dash') {
	          var playlists = properties.playlists.filter(function (p) {
	            return p.excludeUntil !== Infinity;
	          });
	
	          if (!playlists.length) {
	            return;
	          }
	
	          playlistLoader = new DashPlaylistLoader(properties.playlists[0], vhs, requestOptions, masterPlaylistLoader);
	        } else if (sourceType === 'vhs-json') {
	          playlistLoader = new PlaylistLoader( // if the vhs-json object included the media playlist, use the media playlist
	          // as provided, otherwise use the resolved URI to load the playlist
	          properties.playlists ? properties.playlists[0] : properties.resolvedUri, vhs, requestOptions);
	        }
	
	        properties = videojs.mergeOptions({
	          id: variantLabel,
	          playlistLoader: playlistLoader
	        }, properties);
	        setupListeners[type](type, properties.playlistLoader, settings);
	        groups[groupId].push(properties);
	
	        if (typeof tracks[variantLabel] === 'undefined') {
	          var track = tech.addRemoteTextTrack({
	            id: variantLabel,
	            kind: 'subtitles',
	            "default": properties["default"] && properties.autoselect,
	            language: properties.language,
	            label: variantLabel
	          }, false).track;
	          tracks[variantLabel] = track;
	        }
	      }
	    } // setup single error event handler for the segment loader
	
	
	    segmentLoader.on('error', onError[type](type, settings));
	  },
	
	  /**
	   * Setup TextTracks for the closed-caption groups
	   *
	   * @param {String} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function initialize['CLOSED-CAPTIONS']
	   */
	  'CLOSED-CAPTIONS': function CLOSEDCAPTIONS(type, settings) {
	    var tech = settings.tech,
	        mediaGroups = settings.master.mediaGroups,
	        _settings$mediaTypes$3 = settings.mediaTypes[type],
	        groups = _settings$mediaTypes$3.groups,
	        tracks = _settings$mediaTypes$3.tracks;
	
	    for (var groupId in mediaGroups[type]) {
	      if (!groups[groupId]) {
	        groups[groupId] = [];
	      }
	
	      for (var variantLabel in mediaGroups[type][groupId]) {
	        var properties = mediaGroups[type][groupId][variantLabel]; // Look for either 608 (CCn) or 708 (SERVICEn) caption services
	
	        if (!/^(?:CC|SERVICE)/.test(properties.instreamId)) {
	          continue;
	        }
	
	        var captionServices = tech.options_.vhs && tech.options_.vhs.captionServices || {};
	        var newProps = {
	          label: variantLabel,
	          language: properties.language,
	          instreamId: properties.instreamId,
	          "default": properties["default"] && properties.autoselect
	        };
	
	        if (captionServices[newProps.instreamId]) {
	          newProps = videojs.mergeOptions(newProps, captionServices[newProps.instreamId]);
	        }
	
	        if (newProps["default"] === undefined) {
	          delete newProps["default"];
	        } // No PlaylistLoader is required for Closed-Captions because the captions are
	        // embedded within the video stream
	
	
	        groups[groupId].push(videojs.mergeOptions({
	          id: variantLabel
	        }, properties));
	
	        if (typeof tracks[variantLabel] === 'undefined') {
	          var track = tech.addRemoteTextTrack({
	            id: newProps.instreamId,
	            kind: 'captions',
	            "default": newProps["default"],
	            language: newProps.language,
	            label: newProps.label
	          }, false).track;
	          tracks[variantLabel] = track;
	        }
	      }
	    }
	  }
	};
	
	var groupMatch = function groupMatch(list, media) {
	  for (var i = 0; i < list.length; i++) {
	    if (playlistMatch(media, list[i])) {
	      return true;
	    }
	
	    if (list[i].playlists && groupMatch(list[i].playlists, media)) {
	      return true;
	    }
	  }
	
	  return false;
	};
	/**
	 * Returns a function used to get the active group of the provided type
	 *
	 * @param {string} type
	 *        MediaGroup type
	 * @param {Object} settings
	 *        Object containing required information for media groups
	 * @return {Function}
	 *         Function that returns the active media group for the provided type. Takes an
	 *         optional parameter {TextTrack} track. If no track is provided, a list of all
	 *         variants in the group, otherwise the variant corresponding to the provided
	 *         track is returned.
	 * @function activeGroup
	 */
	
	
	var activeGroup = function activeGroup(type, settings) {
	  return function (track) {
	    var masterPlaylistLoader = settings.masterPlaylistLoader,
	        groups = settings.mediaTypes[type].groups;
	    var media = masterPlaylistLoader.media();
	
	    if (!media) {
	      return null;
	    }
	
	    var variants = null; // set to variants to main media active group
	
	    if (media.attributes[type]) {
	      variants = groups[media.attributes[type]];
	    }
	
	    var groupKeys = Object.keys(groups);
	
	    if (!variants) {
	      // find the masterPlaylistLoader media
	      // that is in a media group if we are dealing
	      // with audio only
	      if (type === 'AUDIO' && groupKeys.length > 1 && isAudioOnly(settings.master)) {
	        for (var i = 0; i < groupKeys.length; i++) {
	          var groupPropertyList = groups[groupKeys[i]];
	
	          if (groupMatch(groupPropertyList, media)) {
	            variants = groupPropertyList;
	            break;
	          }
	        } // use the main group if it exists
	
	      } else if (groups.main) {
	        variants = groups.main; // only one group, use that one
	      } else if (groupKeys.length === 1) {
	        variants = groups[groupKeys[0]];
	      }
	    }
	
	    if (typeof track === 'undefined') {
	      return variants;
	    }
	
	    if (track === null || !variants) {
	      // An active track was specified so a corresponding group is expected. track === null
	      // means no track is currently active so there is no corresponding group
	      return null;
	    }
	
	    return variants.filter(function (props) {
	      return props.id === track.id;
	    })[0] || null;
	  };
	};
	
	var activeTrack = {
	  /**
	   * Returns a function used to get the active track of type provided
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Function that returns the active media track for the provided type. Returns
	   *         null if no track is active
	   * @function activeTrack.AUDIO
	   */
	  AUDIO: function AUDIO(type, settings) {
	    return function () {
	      var tracks = settings.mediaTypes[type].tracks;
	
	      for (var id in tracks) {
	        if (tracks[id].enabled) {
	          return tracks[id];
	        }
	      }
	
	      return null;
	    };
	  },
	
	  /**
	   * Returns a function used to get the active track of type provided
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Function that returns the active media track for the provided type. Returns
	   *         null if no track is active
	   * @function activeTrack.SUBTITLES
	   */
	  SUBTITLES: function SUBTITLES(type, settings) {
	    return function () {
	      var tracks = settings.mediaTypes[type].tracks;
	
	      for (var id in tracks) {
	        if (tracks[id].mode === 'showing' || tracks[id].mode === 'hidden') {
	          return tracks[id];
	        }
	      }
	
	      return null;
	    };
	  }
	};
	
	var getActiveGroup = function getActiveGroup(type, _ref) {
	  var mediaTypes = _ref.mediaTypes;
	  return function () {
	    var activeTrack_ = mediaTypes[type].activeTrack();
	
	    if (!activeTrack_) {
	      return null;
	    }
	
	    return mediaTypes[type].activeGroup(activeTrack_);
	  };
	};
	/**
	 * Setup PlaylistLoaders and Tracks for media groups (Audio, Subtitles,
	 * Closed-Captions) specified in the master manifest.
	 *
	 * @param {Object} settings
	 *        Object containing required information for setting up the media groups
	 * @param {Tech} settings.tech
	 *        The tech of the player
	 * @param {Object} settings.requestOptions
	 *        XHR request options used by the segment loaders
	 * @param {PlaylistLoader} settings.masterPlaylistLoader
	 *        PlaylistLoader for the master source
	 * @param {VhsHandler} settings.vhs
	 *        VHS SourceHandler
	 * @param {Object} settings.master
	 *        The parsed master manifest
	 * @param {Object} settings.mediaTypes
	 *        Object to store the loaders, tracks, and utility methods for each media type
	 * @param {Function} settings.blacklistCurrentPlaylist
	 *        Blacklists the current rendition and forces a rendition switch.
	 * @function setupMediaGroups
	 */
	
	
	var setupMediaGroups = function setupMediaGroups(settings) {
	  ['AUDIO', 'SUBTITLES', 'CLOSED-CAPTIONS'].forEach(function (type) {
	    initialize[type](type, settings);
	  });
	  var mediaTypes = settings.mediaTypes,
	      masterPlaylistLoader = settings.masterPlaylistLoader,
	      tech = settings.tech,
	      vhs = settings.vhs,
	      _settings$segmentLoad3 = settings.segmentLoaders,
	      audioSegmentLoader = _settings$segmentLoad3['AUDIO'],
	      mainSegmentLoader = _settings$segmentLoad3.main; // setup active group and track getters and change event handlers
	
	  ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	    mediaTypes[type].activeGroup = activeGroup(type, settings);
	    mediaTypes[type].activeTrack = activeTrack[type](type, settings);
	    mediaTypes[type].onGroupChanged = onGroupChanged(type, settings);
	    mediaTypes[type].onGroupChanging = onGroupChanging(type, settings);
	    mediaTypes[type].onTrackChanged = onTrackChanged(type, settings);
	    mediaTypes[type].getActiveGroup = getActiveGroup(type, settings);
	  }); // DO NOT enable the default subtitle or caption track.
	  // DO enable the default audio track
	
	  var audioGroup = mediaTypes.AUDIO.activeGroup();
	
	  if (audioGroup) {
	    var groupId = (audioGroup.filter(function (group) {
	      return group["default"];
	    })[0] || audioGroup[0]).id;
	    mediaTypes.AUDIO.tracks[groupId].enabled = true;
	    mediaTypes.AUDIO.onGroupChanged();
	    mediaTypes.AUDIO.onTrackChanged();
	    var activeAudioGroup = mediaTypes.AUDIO.getActiveGroup(); // a similar check for handling setAudio on each loader is run again each time the
	    // track is changed, but needs to be handled here since the track may not be considered
	    // changed on the first call to onTrackChanged
	
	    if (!activeAudioGroup.playlistLoader) {
	      // either audio is muxed with video or the stream is audio only
	      mainSegmentLoader.setAudio(true);
	    } else {
	      // audio is demuxed
	      mainSegmentLoader.setAudio(false);
	      audioSegmentLoader.setAudio(true);
	    }
	  }
	
	  masterPlaylistLoader.on('mediachange', function () {
	    ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	      return mediaTypes[type].onGroupChanged();
	    });
	  });
	  masterPlaylistLoader.on('mediachanging', function () {
	    ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	      return mediaTypes[type].onGroupChanging();
	    });
	  }); // custom audio track change event handler for usage event
	
	  var onAudioTrackChanged = function onAudioTrackChanged() {
	    mediaTypes.AUDIO.onTrackChanged();
	    tech.trigger({
	      type: 'usage',
	      name: 'vhs-audio-change'
	    });
	    tech.trigger({
	      type: 'usage',
	      name: 'hls-audio-change'
	    });
	  };
	
	  tech.audioTracks().addEventListener('change', onAudioTrackChanged);
	  tech.remoteTextTracks().addEventListener('change', mediaTypes.SUBTITLES.onTrackChanged);
	  vhs.on('dispose', function () {
	    tech.audioTracks().removeEventListener('change', onAudioTrackChanged);
	    tech.remoteTextTracks().removeEventListener('change', mediaTypes.SUBTITLES.onTrackChanged);
	  }); // clear existing audio tracks and add the ones we just created
	
	  tech.clearTracks('audio');
	
	  for (var id in mediaTypes.AUDIO.tracks) {
	    tech.audioTracks().addTrack(mediaTypes.AUDIO.tracks[id]);
	  }
	};
	/**
	 * Creates skeleton object used to store the loaders, tracks, and utility methods for each
	 * media type
	 *
	 * @return {Object}
	 *         Object to store the loaders, tracks, and utility methods for each media type
	 * @function createMediaTypes
	 */
	
	
	var createMediaTypes = function createMediaTypes() {
	  var mediaTypes = {};
	  ['AUDIO', 'SUBTITLES', 'CLOSED-CAPTIONS'].forEach(function (type) {
	    mediaTypes[type] = {
	      groups: {},
	      tracks: {},
	      activePlaylistLoader: null,
	      activeGroup: noop,
	      activeTrack: noop,
	      getActiveGroup: noop,
	      onGroupChanged: noop,
	      onTrackChanged: noop,
	      lastTrack_: null,
	      logger_: logger("MediaGroups[" + type + "]")
	    };
	  });
	  return mediaTypes;
	};
	
	var ABORT_EARLY_BLACKLIST_SECONDS = 60 * 2;
	var Vhs$1; // SegmentLoader stats that need to have each loader's
	// values summed to calculate the final value
	
	var loaderStats = ['mediaRequests', 'mediaRequestsAborted', 'mediaRequestsTimedout', 'mediaRequestsErrored', 'mediaTransferDuration', 'mediaBytesTransferred', 'mediaAppends'];
	
	var sumLoaderStat = function sumLoaderStat(stat) {
	  return this.audioSegmentLoader_[stat] + this.mainSegmentLoader_[stat];
	};
	
	var shouldSwitchToMedia = function shouldSwitchToMedia(_ref) {
	  var currentPlaylist = _ref.currentPlaylist,
	      buffered = _ref.buffered,
	      currentTime = _ref.currentTime,
	      nextPlaylist = _ref.nextPlaylist,
	      bufferLowWaterLine = _ref.bufferLowWaterLine,
	      bufferHighWaterLine = _ref.bufferHighWaterLine,
	      duration = _ref.duration,
	      experimentalBufferBasedABR = _ref.experimentalBufferBasedABR,
	      log = _ref.log; // we have no other playlist to switch to
	
	  if (!nextPlaylist) {
	    videojs.log.warn('We received no playlist to switch to. Please check your stream.');
	    return false;
	  }
	
	  var sharedLogLine = "allowing switch " + (currentPlaylist && currentPlaylist.id || 'null') + " -> " + nextPlaylist.id;
	
	  if (!currentPlaylist) {
	    log(sharedLogLine + " as current playlist is not set");
	    return true;
	  } // no need to switch if playlist is the same
	
	
	  if (nextPlaylist.id === currentPlaylist.id) {
	    return false;
	  } // determine if current time is in a buffered range.
	
	
	  var isBuffered = Boolean(findRange(buffered, currentTime).length); // If the playlist is live, then we want to not take low water line into account.
	  // This is because in LIVE, the player plays 3 segments from the end of the
	  // playlist, and if `BUFFER_LOW_WATER_LINE` is greater than the duration availble
	  // in those segments, a viewer will never experience a rendition upswitch.
	
	  if (!currentPlaylist.endList) {
	    // For LLHLS live streams, don't switch renditions before playback has started, as it almost
	    // doubles the time to first playback.
	    if (!isBuffered && typeof currentPlaylist.partTargetDuration === 'number') {
	      log("not " + sharedLogLine + " as current playlist is live llhls, but currentTime isn't in buffered.");
	      return false;
	    }
	
	    log(sharedLogLine + " as current playlist is live");
	    return true;
	  }
	
	  var forwardBuffer = timeAheadOf(buffered, currentTime);
	  var maxBufferLowWaterLine = experimentalBufferBasedABR ? Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : Config.MAX_BUFFER_LOW_WATER_LINE; // For the same reason as LIVE, we ignore the low water line when the VOD
	  // duration is below the max potential low water line
	
	  if (duration < maxBufferLowWaterLine) {
	    log(sharedLogLine + " as duration < max low water line (" + duration + " < " + maxBufferLowWaterLine + ")");
	    return true;
	  }
	
	  var nextBandwidth = nextPlaylist.attributes.BANDWIDTH;
	  var currBandwidth = currentPlaylist.attributes.BANDWIDTH; // when switching down, if our buffer is lower than the high water line,
	  // we can switch down
	
	  if (nextBandwidth < currBandwidth && (!experimentalBufferBasedABR || forwardBuffer < bufferHighWaterLine)) {
	    var logLine = sharedLogLine + " as next bandwidth < current bandwidth (" + nextBandwidth + " < " + currBandwidth + ")";
	
	    if (experimentalBufferBasedABR) {
	      logLine += " and forwardBuffer < bufferHighWaterLine (" + forwardBuffer + " < " + bufferHighWaterLine + ")";
	    }
	
	    log(logLine);
	    return true;
	  } // and if our buffer is higher than the low water line,
	  // we can switch up
	
	
	  if ((!experimentalBufferBasedABR || nextBandwidth > currBandwidth) && forwardBuffer >= bufferLowWaterLine) {
	    var _logLine = sharedLogLine + " as forwardBuffer >= bufferLowWaterLine (" + forwardBuffer + " >= " + bufferLowWaterLine + ")";
	
	    if (experimentalBufferBasedABR) {
	      _logLine += " and next bandwidth > current bandwidth (" + nextBandwidth + " > " + currBandwidth + ")";
	    }
	
	    log(_logLine);
	    return true;
	  }
	
	  log("not " + sharedLogLine + " as no switching criteria met");
	  return false;
	};
	/**
	 * the master playlist controller controller all interactons
	 * between playlists and segmentloaders. At this time this mainly
	 * involves a master playlist and a series of audio playlists
	 * if they are available
	 *
	 * @class MasterPlaylistController
	 * @extends videojs.EventTarget
	 */
	
	
	var MasterPlaylistController = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](MasterPlaylistController, _videojs$EventTarget);
	
	  function MasterPlaylistController(options) {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this;
	    var src = options.src,
	        handleManifestRedirects = options.handleManifestRedirects,
	        withCredentials = options.withCredentials,
	        tech = options.tech,
	        bandwidth = options.bandwidth,
	        externVhs = options.externVhs,
	        useCueTags = options.useCueTags,
	        blacklistDuration = options.blacklistDuration,
	        enableLowInitialPlaylist = options.enableLowInitialPlaylist,
	        sourceType = options.sourceType,
	        cacheEncryptionKeys = options.cacheEncryptionKeys,
	        experimentalBufferBasedABR = options.experimentalBufferBasedABR,
	        experimentalLeastPixelDiffSelector = options.experimentalLeastPixelDiffSelector,
	        captionServices = options.captionServices;
	
	    if (!src) {
	      throw new Error('A non-empty playlist URL or JSON manifest string is required');
	    }
	
	    var maxPlaylistRetries = options.maxPlaylistRetries;
	
	    if (maxPlaylistRetries === null || typeof maxPlaylistRetries === 'undefined') {
	      maxPlaylistRetries = Infinity;
	    }
	
	    Vhs$1 = externVhs;
	    _this.experimentalBufferBasedABR = Boolean(experimentalBufferBasedABR);
	    _this.experimentalLeastPixelDiffSelector = Boolean(experimentalLeastPixelDiffSelector);
	    _this.withCredentials = withCredentials;
	    _this.tech_ = tech;
	    _this.vhs_ = tech.vhs;
	    _this.sourceType_ = sourceType;
	    _this.useCueTags_ = useCueTags;
	    _this.blacklistDuration = blacklistDuration;
	    _this.maxPlaylistRetries = maxPlaylistRetries;
	    _this.enableLowInitialPlaylist = enableLowInitialPlaylist;
	
	    if (_this.useCueTags_) {
	      _this.cueTagsTrack_ = _this.tech_.addTextTrack('metadata', 'ad-cues');
	      _this.cueTagsTrack_.inBandMetadataTrackDispatchType = '';
	    }
	
	    _this.requestOptions_ = {
	      withCredentials: withCredentials,
	      handleManifestRedirects: handleManifestRedirects,
	      maxPlaylistRetries: maxPlaylistRetries,
	      timeout: null
	    };
	
	    _this.on('error', _this.pauseLoading);
	
	    _this.mediaTypes_ = createMediaTypes();
	    _this.mediaSource = new window__default['default'].MediaSource();
	    _this.handleDurationChange_ = _this.handleDurationChange_.bind(_assertThisInitialized__default['default'](_this));
	    _this.handleSourceOpen_ = _this.handleSourceOpen_.bind(_assertThisInitialized__default['default'](_this));
	    _this.handleSourceEnded_ = _this.handleSourceEnded_.bind(_assertThisInitialized__default['default'](_this));
	
	    _this.mediaSource.addEventListener('durationchange', _this.handleDurationChange_); // load the media source into the player
	
	
	    _this.mediaSource.addEventListener('sourceopen', _this.handleSourceOpen_);
	
	    _this.mediaSource.addEventListener('sourceended', _this.handleSourceEnded_); // we don't have to handle sourceclose since dispose will handle termination of
	    // everything, and the MediaSource should not be detached without a proper disposal
	
	
	    _this.seekable_ = videojs.createTimeRanges();
	    _this.hasPlayed_ = false;
	    _this.syncController_ = new SyncController(options);
	    _this.segmentMetadataTrack_ = tech.addRemoteTextTrack({
	      kind: 'metadata',
	      label: 'segment-metadata'
	    }, false).track;
	    _this.decrypter_ = new Decrypter();
	    _this.sourceUpdater_ = new SourceUpdater(_this.mediaSource);
	    _this.inbandTextTracks_ = {};
	    _this.timelineChangeController_ = new TimelineChangeController();
	    var segmentLoaderSettings = {
	      vhs: _this.vhs_,
	      parse708captions: options.parse708captions,
	      useDtsForTimestampOffset: options.useDtsForTimestampOffset,
	      captionServices: captionServices,
	      mediaSource: _this.mediaSource,
	      currentTime: _this.tech_.currentTime.bind(_this.tech_),
	      seekable: function seekable() {
	        return _this.seekable();
	      },
	      seeking: function seeking() {
	        return _this.tech_.seeking();
	      },
	      duration: function duration() {
	        return _this.duration();
	      },
	      hasPlayed: function hasPlayed() {
	        return _this.hasPlayed_;
	      },
	      goalBufferLength: function goalBufferLength() {
	        return _this.goalBufferLength();
	      },
	      bandwidth: bandwidth,
	      syncController: _this.syncController_,
	      decrypter: _this.decrypter_,
	      sourceType: _this.sourceType_,
	      inbandTextTracks: _this.inbandTextTracks_,
	      cacheEncryptionKeys: cacheEncryptionKeys,
	      sourceUpdater: _this.sourceUpdater_,
	      timelineChangeController: _this.timelineChangeController_,
	      experimentalExactManifestTimings: options.experimentalExactManifestTimings
	    }; // The source type check not only determines whether a special DASH playlist loader
	    // should be used, but also covers the case where the provided src is a vhs-json
	    // manifest object (instead of a URL). In the case of vhs-json, the default
	    // PlaylistLoader should be used.
	
	    _this.masterPlaylistLoader_ = _this.sourceType_ === 'dash' ? new DashPlaylistLoader(src, _this.vhs_, _this.requestOptions_) : new PlaylistLoader(src, _this.vhs_, _this.requestOptions_);
	
	    _this.setupMasterPlaylistLoaderListeners_(); // setup segment loaders
	    // combined audio/video or just video when alternate audio track is selected
	
	
	    _this.mainSegmentLoader_ = new SegmentLoader(videojs.mergeOptions(segmentLoaderSettings, {
	      segmentMetadataTrack: _this.segmentMetadataTrack_,
	      loaderType: 'main'
	    }), options); // alternate audio track
	
	    _this.audioSegmentLoader_ = new SegmentLoader(videojs.mergeOptions(segmentLoaderSettings, {
	      loaderType: 'audio'
	    }), options);
	    _this.subtitleSegmentLoader_ = new VTTSegmentLoader(videojs.mergeOptions(segmentLoaderSettings, {
	      loaderType: 'vtt',
	      featuresNativeTextTracks: _this.tech_.featuresNativeTextTracks,
	      loadVttJs: function loadVttJs() {
	        return new Promise(function (resolve, reject) {
	          function onLoad() {
	            tech.off('vttjserror', onError);
	            resolve();
	          }
	
	          function onError() {
	            tech.off('vttjsloaded', onLoad);
	            reject();
	          }
	
	          tech.one('vttjsloaded', onLoad);
	          tech.one('vttjserror', onError); // safe to call multiple times, script will be loaded only once:
	
	          tech.addWebVttScript_();
	        });
	      }
	    }), options);
	
	    _this.setupSegmentLoaderListeners_();
	
	    if (_this.experimentalBufferBasedABR) {
	      _this.masterPlaylistLoader_.one('loadedplaylist', function () {
	        return _this.startABRTimer_();
	      });
	
	      _this.tech_.on('pause', function () {
	        return _this.stopABRTimer_();
	      });
	
	      _this.tech_.on('play', function () {
	        return _this.startABRTimer_();
	      });
	    } // Create SegmentLoader stat-getters
	    // mediaRequests_
	    // mediaRequestsAborted_
	    // mediaRequestsTimedout_
	    // mediaRequestsErrored_
	    // mediaTransferDuration_
	    // mediaBytesTransferred_
	    // mediaAppends_
	
	
	    loaderStats.forEach(function (stat) {
	      _this[stat + '_'] = sumLoaderStat.bind(_assertThisInitialized__default['default'](_this), stat);
	    });
	    _this.logger_ = logger('MPC');
	    _this.triggeredFmp4Usage = false;
	
	    if (_this.tech_.preload() === 'none') {
	      _this.loadOnPlay_ = function () {
	        _this.loadOnPlay_ = null;
	
	        _this.masterPlaylistLoader_.load();
	      };
	
	      _this.tech_.one('play', _this.loadOnPlay_);
	    } else {
	      _this.masterPlaylistLoader_.load();
	    }
	
	    _this.timeToLoadedData__ = -1;
	    _this.mainAppendsToLoadedData__ = -1;
	    _this.audioAppendsToLoadedData__ = -1;
	    var event = _this.tech_.preload() === 'none' ? 'play' : 'loadstart'; // start the first frame timer on loadstart or play (for preload none)
	
	    _this.tech_.one(event, function () {
	      var timeToLoadedDataStart = Date.now();
	
	      _this.tech_.one('loadeddata', function () {
	        _this.timeToLoadedData__ = Date.now() - timeToLoadedDataStart;
	        _this.mainAppendsToLoadedData__ = _this.mainSegmentLoader_.mediaAppends;
	        _this.audioAppendsToLoadedData__ = _this.audioSegmentLoader_.mediaAppends;
	      });
	    });
	
	    return _this;
	  }
	
	  var _proto = MasterPlaylistController.prototype;
	
	  _proto.mainAppendsToLoadedData_ = function mainAppendsToLoadedData_() {
	    return this.mainAppendsToLoadedData__;
	  };
	
	  _proto.audioAppendsToLoadedData_ = function audioAppendsToLoadedData_() {
	    return this.audioAppendsToLoadedData__;
	  };
	
	  _proto.appendsToLoadedData_ = function appendsToLoadedData_() {
	    var main = this.mainAppendsToLoadedData_();
	    var audio = this.audioAppendsToLoadedData_();
	
	    if (main === -1 || audio === -1) {
	      return -1;
	    }
	
	    return main + audio;
	  };
	
	  _proto.timeToLoadedData_ = function timeToLoadedData_() {
	    return this.timeToLoadedData__;
	  }
	  /**
	   * Run selectPlaylist and switch to the new playlist if we should
	   *
	   * @param {string} [reason=abr] a reason for why the ABR check is made
	   * @private
	   */
	  ;
	
	  _proto.checkABR_ = function checkABR_(reason) {
	    if (reason === void 0) {
	      reason = 'abr';
	    }
	
	    var nextPlaylist = this.selectPlaylist();
	
	    if (nextPlaylist && this.shouldSwitchToMedia_(nextPlaylist)) {
	      this.switchMedia_(nextPlaylist, reason);
	    }
	  };
	
	  _proto.switchMedia_ = function switchMedia_(playlist, cause, delay) {
	    var oldMedia = this.media();
	    var oldId = oldMedia && (oldMedia.id || oldMedia.uri);
	    var newId = playlist.id || playlist.uri;
	
	    if (oldId && oldId !== newId) {
	      this.logger_("switch media " + oldId + " -> " + newId + " from " + cause);
	      this.tech_.trigger({
	        type: 'usage',
	        name: "vhs-rendition-change-" + cause
	      });
	    }
	
	    this.masterPlaylistLoader_.media(playlist, delay);
	  }
	  /**
	   * Start a timer that periodically calls checkABR_
	   *
	   * @private
	   */
	  ;
	
	  _proto.startABRTimer_ = function startABRTimer_() {
	    var _this2 = this;
	
	    this.stopABRTimer_();
	    this.abrTimer_ = window__default['default'].setInterval(function () {
	      return _this2.checkABR_();
	    }, 250);
	  }
	  /**
	   * Stop the timer that periodically calls checkABR_
	   *
	   * @private
	   */
	  ;
	
	  _proto.stopABRTimer_ = function stopABRTimer_() {
	    // if we're scrubbing, we don't need to pause.
	    // This getter will be added to Video.js in version 7.11.
	    if (this.tech_.scrubbing && this.tech_.scrubbing()) {
	      return;
	    }
	
	    window__default['default'].clearInterval(this.abrTimer_);
	    this.abrTimer_ = null;
	  }
	  /**
	   * Get a list of playlists for the currently selected audio playlist
	   *
	   * @return {Array} the array of audio playlists
	   */
	  ;
	
	  _proto.getAudioTrackPlaylists_ = function getAudioTrackPlaylists_() {
	    var master = this.master();
	    var defaultPlaylists = master && master.playlists || []; // if we don't have any audio groups then we can only
	    // assume that the audio tracks are contained in masters
	    // playlist array, use that or an empty array.
	
	    if (!master || !master.mediaGroups || !master.mediaGroups.AUDIO) {
	      return defaultPlaylists;
	    }
	
	    var AUDIO = master.mediaGroups.AUDIO;
	    var groupKeys = Object.keys(AUDIO);
	    var track; // get the current active track
	
	    if (Object.keys(this.mediaTypes_.AUDIO.groups).length) {
	      track = this.mediaTypes_.AUDIO.activeTrack(); // or get the default track from master if mediaTypes_ isn't setup yet
	    } else {
	      // default group is `main` or just the first group.
	      var defaultGroup = AUDIO.main || groupKeys.length && AUDIO[groupKeys[0]];
	
	      for (var label in defaultGroup) {
	        if (defaultGroup[label]["default"]) {
	          track = {
	            label: label
	          };
	          break;
	        }
	      }
	    } // no active track no playlists.
	
	
	    if (!track) {
	      return defaultPlaylists;
	    }
	
	    var playlists = []; // get all of the playlists that are possible for the
	    // active track.
	
	    for (var group in AUDIO) {
	      if (AUDIO[group][track.label]) {
	        var properties = AUDIO[group][track.label];
	
	        if (properties.playlists && properties.playlists.length) {
	          playlists.push.apply(playlists, properties.playlists);
	        } else if (properties.uri) {
	          playlists.push(properties);
	        } else if (master.playlists.length) {
	          // if an audio group does not have a uri
	          // see if we have main playlists that use it as a group.
	          // if we do then add those to the playlists list.
	          for (var i = 0; i < master.playlists.length; i++) {
	            var playlist = master.playlists[i];
	
	            if (playlist.attributes && playlist.attributes.AUDIO && playlist.attributes.AUDIO === group) {
	              playlists.push(playlist);
	            }
	          }
	        }
	      }
	    }
	
	    if (!playlists.length) {
	      return defaultPlaylists;
	    }
	
	    return playlists;
	  }
	  /**
	   * Register event handlers on the master playlist loader. A helper
	   * function for construction time.
	   *
	   * @private
	   */
	  ;
	
	  _proto.setupMasterPlaylistLoaderListeners_ = function setupMasterPlaylistLoaderListeners_() {
	    var _this3 = this;
	
	    this.masterPlaylistLoader_.on('loadedmetadata', function () {
	      var media = _this3.masterPlaylistLoader_.media();
	
	      var requestTimeout = media.targetDuration * 1.5 * 1000; // If we don't have any more available playlists, we don't want to
	      // timeout the request.
	
	      if (isLowestEnabledRendition(_this3.masterPlaylistLoader_.master, _this3.masterPlaylistLoader_.media())) {
	        _this3.requestOptions_.timeout = 0;
	      } else {
	        _this3.requestOptions_.timeout = requestTimeout;
	      } // if this isn't a live video and preload permits, start
	      // downloading segments
	
	
	      if (media.endList && _this3.tech_.preload() !== 'none') {
	        _this3.mainSegmentLoader_.playlist(media, _this3.requestOptions_);
	
	        _this3.mainSegmentLoader_.load();
	      }
	
	      setupMediaGroups({
	        sourceType: _this3.sourceType_,
	        segmentLoaders: {
	          AUDIO: _this3.audioSegmentLoader_,
	          SUBTITLES: _this3.subtitleSegmentLoader_,
	          main: _this3.mainSegmentLoader_
	        },
	        tech: _this3.tech_,
	        requestOptions: _this3.requestOptions_,
	        masterPlaylistLoader: _this3.masterPlaylistLoader_,
	        vhs: _this3.vhs_,
	        master: _this3.master(),
	        mediaTypes: _this3.mediaTypes_,
	        blacklistCurrentPlaylist: _this3.blacklistCurrentPlaylist.bind(_this3)
	      });
	
	      _this3.triggerPresenceUsage_(_this3.master(), media);
	
	      _this3.setupFirstPlay();
	
	      if (!_this3.mediaTypes_.AUDIO.activePlaylistLoader || _this3.mediaTypes_.AUDIO.activePlaylistLoader.media()) {
	        _this3.trigger('selectedinitialmedia');
	      } else {
	        // We must wait for the active audio playlist loader to
	        // finish setting up before triggering this event so the
	        // representations API and EME setup is correct
	        _this3.mediaTypes_.AUDIO.activePlaylistLoader.one('loadedmetadata', function () {
	          _this3.trigger('selectedinitialmedia');
	        });
	      }
	    });
	    this.masterPlaylistLoader_.on('loadedplaylist', function () {
	      if (_this3.loadOnPlay_) {
	        _this3.tech_.off('play', _this3.loadOnPlay_);
	      }
	
	      var updatedPlaylist = _this3.masterPlaylistLoader_.media();
	
	      if (!updatedPlaylist) {
	        // exclude any variants that are not supported by the browser before selecting
	        // an initial media as the playlist selectors do not consider browser support
	        _this3.excludeUnsupportedVariants_();
	
	        var selectedMedia;
	
	        if (_this3.enableLowInitialPlaylist) {
	          selectedMedia = _this3.selectInitialPlaylist();
	        }
	
	        if (!selectedMedia) {
	          selectedMedia = _this3.selectPlaylist();
	        }
	
	        if (!selectedMedia || !_this3.shouldSwitchToMedia_(selectedMedia)) {
	          return;
	        }
	
	        _this3.initialMedia_ = selectedMedia;
	
	        _this3.switchMedia_(_this3.initialMedia_, 'initial'); // Under the standard case where a source URL is provided, loadedplaylist will
	        // fire again since the playlist will be requested. In the case of vhs-json
	        // (where the manifest object is provided as the source), when the media
	        // playlist's `segments` list is already available, a media playlist won't be
	        // requested, and loadedplaylist won't fire again, so the playlist handler must be
	        // called on its own here.
	
	
	        var haveJsonSource = _this3.sourceType_ === 'vhs-json' && _this3.initialMedia_.segments;
	
	        if (!haveJsonSource) {
	          return;
	        }
	
	        updatedPlaylist = _this3.initialMedia_;
	      }
	
	      _this3.handleUpdatedMediaPlaylist(updatedPlaylist);
	    });
	    this.masterPlaylistLoader_.on('error', function () {
	      _this3.blacklistCurrentPlaylist(_this3.masterPlaylistLoader_.error);
	    });
	    this.masterPlaylistLoader_.on('mediachanging', function () {
	      _this3.mainSegmentLoader_.abort();
	
	      _this3.mainSegmentLoader_.pause();
	    });
	    this.masterPlaylistLoader_.on('mediachange', function () {
	      var media = _this3.masterPlaylistLoader_.media();
	
	      var requestTimeout = media.targetDuration * 1.5 * 1000; // If we don't have any more available playlists, we don't want to
	      // timeout the request.
	
	      if (isLowestEnabledRendition(_this3.masterPlaylistLoader_.master, _this3.masterPlaylistLoader_.media())) {
	        _this3.requestOptions_.timeout = 0;
	      } else {
	        _this3.requestOptions_.timeout = requestTimeout;
	      }
	
	      _this3.masterPlaylistLoader_.load(); // TODO: Create a new event on the PlaylistLoader that signals
	      // that the segments have changed in some way and use that to
	      // update the SegmentLoader instead of doing it twice here and
	      // on `loadedplaylist`
	
	
	      _this3.mainSegmentLoader_.playlist(media, _this3.requestOptions_);
	
	      _this3.mainSegmentLoader_.load();
	
	      _this3.tech_.trigger({
	        type: 'mediachange',
	        bubbles: true
	      });
	    });
	    this.masterPlaylistLoader_.on('playlistunchanged', function () {
	      var updatedPlaylist = _this3.masterPlaylistLoader_.media(); // ignore unchanged playlists that have already been
	      // excluded for not-changing. We likely just have a really slowly updating
	      // playlist.
	
	
	      if (updatedPlaylist.lastExcludeReason_ === 'playlist-unchanged') {
	        return;
	      }
	
	      var playlistOutdated = _this3.stuckAtPlaylistEnd_(updatedPlaylist);
	
	      if (playlistOutdated) {
	        // Playlist has stopped updating and we're stuck at its end. Try to
	        // blacklist it and switch to another playlist in the hope that that
	        // one is updating (and give the player a chance to re-adjust to the
	        // safe live point).
	        _this3.blacklistCurrentPlaylist({
	          message: 'Playlist no longer updating.',
	          reason: 'playlist-unchanged'
	        }); // useful for monitoring QoS
	
	
	        _this3.tech_.trigger('playliststuck');
	      }
	    });
	    this.masterPlaylistLoader_.on('renditiondisabled', function () {
	      _this3.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-rendition-disabled'
	      });
	
	      _this3.tech_.trigger({
	        type: 'usage',
	        name: 'hls-rendition-disabled'
	      });
	    });
	    this.masterPlaylistLoader_.on('renditionenabled', function () {
	      _this3.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-rendition-enabled'
	      });
	
	      _this3.tech_.trigger({
	        type: 'usage',
	        name: 'hls-rendition-enabled'
	      });
	    });
	  }
	  /**
	   * Given an updated media playlist (whether it was loaded for the first time, or
	   * refreshed for live playlists), update any relevant properties and state to reflect
	   * changes in the media that should be accounted for (e.g., cues and duration).
	   *
	   * @param {Object} updatedPlaylist the updated media playlist object
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleUpdatedMediaPlaylist = function handleUpdatedMediaPlaylist(updatedPlaylist) {
	    if (this.useCueTags_) {
	      this.updateAdCues_(updatedPlaylist);
	    } // TODO: Create a new event on the PlaylistLoader that signals
	    // that the segments have changed in some way and use that to
	    // update the SegmentLoader instead of doing it twice here and
	    // on `mediachange`
	
	
	    this.mainSegmentLoader_.playlist(updatedPlaylist, this.requestOptions_);
	    this.updateDuration(!updatedPlaylist.endList); // If the player isn't paused, ensure that the segment loader is running,
	    // as it is possible that it was temporarily stopped while waiting for
	    // a playlist (e.g., in case the playlist errored and we re-requested it).
	
	    if (!this.tech_.paused()) {
	      this.mainSegmentLoader_.load();
	
	      if (this.audioSegmentLoader_) {
	        this.audioSegmentLoader_.load();
	      }
	    }
	  }
	  /**
	   * A helper function for triggerring presence usage events once per source
	   *
	   * @private
	   */
	  ;
	
	  _proto.triggerPresenceUsage_ = function triggerPresenceUsage_(master, media) {
	    var mediaGroups = master.mediaGroups || {};
	    var defaultDemuxed = true;
	    var audioGroupKeys = Object.keys(mediaGroups.AUDIO);
	
	    for (var mediaGroup in mediaGroups.AUDIO) {
	      for (var label in mediaGroups.AUDIO[mediaGroup]) {
	        var properties = mediaGroups.AUDIO[mediaGroup][label];
	
	        if (!properties.uri) {
	          defaultDemuxed = false;
	        }
	      }
	    }
	
	    if (defaultDemuxed) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-demuxed'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-demuxed'
	      });
	    }
	
	    if (Object.keys(mediaGroups.SUBTITLES).length) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-webvtt'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-webvtt'
	      });
	    }
	
	    if (Vhs$1.Playlist.isAes(media)) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-aes'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-aes'
	      });
	    }
	
	    if (audioGroupKeys.length && Object.keys(mediaGroups.AUDIO[audioGroupKeys[0]]).length > 1) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-alternate-audio'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-alternate-audio'
	      });
	    }
	
	    if (this.useCueTags_) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-playlist-cue-tags'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-playlist-cue-tags'
	      });
	    }
	  };
	
	  _proto.shouldSwitchToMedia_ = function shouldSwitchToMedia_(nextPlaylist) {
	    var currentPlaylist = this.masterPlaylistLoader_.media() || this.masterPlaylistLoader_.pendingMedia_;
	    var currentTime = this.tech_.currentTime();
	    var bufferLowWaterLine = this.bufferLowWaterLine();
	    var bufferHighWaterLine = this.bufferHighWaterLine();
	    var buffered = this.tech_.buffered();
	    return shouldSwitchToMedia({
	      buffered: buffered,
	      currentTime: currentTime,
	      currentPlaylist: currentPlaylist,
	      nextPlaylist: nextPlaylist,
	      bufferLowWaterLine: bufferLowWaterLine,
	      bufferHighWaterLine: bufferHighWaterLine,
	      duration: this.duration(),
	      experimentalBufferBasedABR: this.experimentalBufferBasedABR,
	      log: this.logger_
	    });
	  }
	  /**
	   * Register event handlers on the segment loaders. A helper function
	   * for construction time.
	   *
	   * @private
	   */
	  ;
	
	  _proto.setupSegmentLoaderListeners_ = function setupSegmentLoaderListeners_() {
	    var _this4 = this;
	
	    this.mainSegmentLoader_.on('bandwidthupdate', function () {
	      // Whether or not buffer based ABR or another ABR is used, on a bandwidth change it's
	      // useful to check to see if a rendition switch should be made.
	      _this4.checkABR_('bandwidthupdate');
	
	      _this4.tech_.trigger('bandwidthupdate');
	    });
	    this.mainSegmentLoader_.on('timeout', function () {
	      if (_this4.experimentalBufferBasedABR) {
	        // If a rendition change is needed, then it would've be done on `bandwidthupdate`.
	        // Here the only consideration is that for buffer based ABR there's no guarantee
	        // of an immediate switch (since the bandwidth is averaged with a timeout
	        // bandwidth value of 1), so force a load on the segment loader to keep it going.
	        _this4.mainSegmentLoader_.load();
	      }
	    }); // `progress` events are not reliable enough of a bandwidth measure to trigger buffer
	    // based ABR.
	
	    if (!this.experimentalBufferBasedABR) {
	      this.mainSegmentLoader_.on('progress', function () {
	        _this4.trigger('progress');
	      });
	    }
	
	    this.mainSegmentLoader_.on('error', function () {
	      _this4.blacklistCurrentPlaylist(_this4.mainSegmentLoader_.error());
	    });
	    this.mainSegmentLoader_.on('appenderror', function () {
	      _this4.error = _this4.mainSegmentLoader_.error_;
	
	      _this4.trigger('error');
	    });
	    this.mainSegmentLoader_.on('syncinfoupdate', function () {
	      _this4.onSyncInfoUpdate_();
	    });
	    this.mainSegmentLoader_.on('timestampoffset', function () {
	      _this4.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-timestamp-offset'
	      });
	
	      _this4.tech_.trigger({
	        type: 'usage',
	        name: 'hls-timestamp-offset'
	      });
	    });
	    this.audioSegmentLoader_.on('syncinfoupdate', function () {
	      _this4.onSyncInfoUpdate_();
	    });
	    this.audioSegmentLoader_.on('appenderror', function () {
	      _this4.error = _this4.audioSegmentLoader_.error_;
	
	      _this4.trigger('error');
	    });
	    this.mainSegmentLoader_.on('ended', function () {
	      _this4.logger_('main segment loader ended');
	
	      _this4.onEndOfStream();
	    });
	    this.mainSegmentLoader_.on('earlyabort', function (event) {
	      // never try to early abort with the new ABR algorithm
	      if (_this4.experimentalBufferBasedABR) {
	        return;
	      }
	
	      _this4.delegateLoaders_('all', ['abort']);
	
	      _this4.blacklistCurrentPlaylist({
	        message: 'Aborted early because there isn\'t enough bandwidth to complete the ' + 'request without rebuffering.'
	      }, ABORT_EARLY_BLACKLIST_SECONDS);
	    });
	
	    var updateCodecs = function updateCodecs() {
	      if (!_this4.sourceUpdater_.hasCreatedSourceBuffers()) {
	        return _this4.tryToCreateSourceBuffers_();
	      }
	
	      var codecs = _this4.getCodecsOrExclude_(); // no codecs means that the playlist was excluded
	
	
	      if (!codecs) {
	        return;
	      }
	
	      _this4.sourceUpdater_.addOrChangeSourceBuffers(codecs);
	    };
	
	    this.mainSegmentLoader_.on('trackinfo', updateCodecs);
	    this.audioSegmentLoader_.on('trackinfo', updateCodecs);
	    this.mainSegmentLoader_.on('fmp4', function () {
	      if (!_this4.triggeredFmp4Usage) {
	        _this4.tech_.trigger({
	          type: 'usage',
	          name: 'vhs-fmp4'
	        });
	
	        _this4.tech_.trigger({
	          type: 'usage',
	          name: 'hls-fmp4'
	        });
	
	        _this4.triggeredFmp4Usage = true;
	      }
	    });
	    this.audioSegmentLoader_.on('fmp4', function () {
	      if (!_this4.triggeredFmp4Usage) {
	        _this4.tech_.trigger({
	          type: 'usage',
	          name: 'vhs-fmp4'
	        });
	
	        _this4.tech_.trigger({
	          type: 'usage',
	          name: 'hls-fmp4'
	        });
	
	        _this4.triggeredFmp4Usage = true;
	      }
	    });
	    this.audioSegmentLoader_.on('ended', function () {
	      _this4.logger_('audioSegmentLoader ended');
	
	      _this4.onEndOfStream();
	    });
	  };
	
	  _proto.mediaSecondsLoaded_ = function mediaSecondsLoaded_() {
	    return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
	  }
	  /**
	   * Call load on our SegmentLoaders
	   */
	  ;
	
	  _proto.load = function load() {
	    this.mainSegmentLoader_.load();
	
	    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	      this.audioSegmentLoader_.load();
	    }
	
	    if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
	      this.subtitleSegmentLoader_.load();
	    }
	  }
	  /**
	   * Re-tune playback quality level for the current player
	   * conditions without performing destructive actions, like
	   * removing already buffered content
	   *
	   * @private
	   * @deprecated
	   */
	  ;
	
	  _proto.smoothQualityChange_ = function smoothQualityChange_(media) {
	    if (media === void 0) {
	      media = this.selectPlaylist();
	    }
	
	    this.fastQualityChange_(media);
	  }
	  /**
	   * Re-tune playback quality level for the current player
	   * conditions. This method will perform destructive actions like removing
	   * already buffered content in order to readjust the currently active
	   * playlist quickly. This is good for manual quality changes
	   *
	   * @private
	   */
	  ;
	
	  _proto.fastQualityChange_ = function fastQualityChange_(media) {
	    var _this5 = this;
	
	    if (media === void 0) {
	      media = this.selectPlaylist();
	    }
	
	    if (media === this.masterPlaylistLoader_.media()) {
	      this.logger_('skipping fastQualityChange because new media is same as old');
	      return;
	    }
	
	    this.switchMedia_(media, 'fast-quality'); // Delete all buffered data to allow an immediate quality switch, then seek to give
	    // the browser a kick to remove any cached frames from the previous rendtion (.04 seconds
	    // ahead is roughly the minimum that will accomplish this across a variety of content
	    // in IE and Edge, but seeking in place is sufficient on all other browsers)
	    // Edge/IE bug: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/14600375/
	    // Chrome bug: https://bugs.chromium.org/p/chromium/issues/detail?id=651904
	
	    this.mainSegmentLoader_.resetEverything(function () {
	      // Since this is not a typical seek, we avoid the seekTo method which can cause segments
	      // from the previously enabled rendition to load before the new playlist has finished loading
	      if (videojs.browser.IE_VERSION || videojs.browser.IS_EDGE) {
	        _this5.tech_.setCurrentTime(_this5.tech_.currentTime() + 0.04);
	      } else {
	        _this5.tech_.setCurrentTime(_this5.tech_.currentTime());
	      }
	    }); // don't need to reset audio as it is reset when media changes
	  }
	  /**
	   * Begin playback.
	   */
	  ;
	
	  _proto.play = function play() {
	    if (this.setupFirstPlay()) {
	      return;
	    }
	
	    if (this.tech_.ended()) {
	      this.tech_.setCurrentTime(0);
	    }
	
	    if (this.hasPlayed_) {
	      this.load();
	    }
	
	    var seekable = this.tech_.seekable(); // if the viewer has paused and we fell out of the live window,
	    // seek forward to the live point
	
	    if (this.tech_.duration() === Infinity) {
	      if (this.tech_.currentTime() < seekable.start(0)) {
	        return this.tech_.setCurrentTime(seekable.end(seekable.length - 1));
	      }
	    }
	  }
	  /**
	   * Seek to the latest media position if this is a live video and the
	   * player and video are loaded and initialized.
	   */
	  ;
	
	  _proto.setupFirstPlay = function setupFirstPlay() {
	    var _this6 = this;
	
	    var media = this.masterPlaylistLoader_.media(); // Check that everything is ready to begin buffering for the first call to play
	    //  If 1) there is no active media
	    //     2) the player is paused
	    //     3) the first play has already been setup
	    // then exit early
	
	    if (!media || this.tech_.paused() || this.hasPlayed_) {
	      return false;
	    } // when the video is a live stream
	
	
	    if (!media.endList) {
	      var seekable = this.seekable();
	
	      if (!seekable.length) {
	        // without a seekable range, the player cannot seek to begin buffering at the live
	        // point
	        return false;
	      }
	
	      if (videojs.browser.IE_VERSION && this.tech_.readyState() === 0) {
	        // IE11 throws an InvalidStateError if you try to set currentTime while the
	        // readyState is 0, so it must be delayed until the tech fires loadedmetadata.
	        this.tech_.one('loadedmetadata', function () {
	          _this6.trigger('firstplay');
	
	          _this6.tech_.setCurrentTime(seekable.end(0));
	
	          _this6.hasPlayed_ = true;
	        });
	        return false;
	      } // trigger firstplay to inform the source handler to ignore the next seek event
	
	
	      this.trigger('firstplay'); // seek to the live point
	
	      this.tech_.setCurrentTime(seekable.end(0));
	    }
	
	    this.hasPlayed_ = true; // we can begin loading now that everything is ready
	
	    this.load();
	    return true;
	  }
	  /**
	   * handle the sourceopen event on the MediaSource
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleSourceOpen_ = function handleSourceOpen_() {
	    // Only attempt to create the source buffer if none already exist.
	    // handleSourceOpen is also called when we are "re-opening" a source buffer
	    // after `endOfStream` has been called (in response to a seek for instance)
	    this.tryToCreateSourceBuffers_(); // if autoplay is enabled, begin playback. This is duplicative of
	    // code in video.js but is required because play() must be invoked
	    // *after* the media source has opened.
	
	    if (this.tech_.autoplay()) {
	      var playPromise = this.tech_.play(); // Catch/silence error when a pause interrupts a play request
	      // on browsers which return a promise
	
	      if (typeof playPromise !== 'undefined' && typeof playPromise.then === 'function') {
	        playPromise.then(null, function (e) {});
	      }
	    }
	
	    this.trigger('sourceopen');
	  }
	  /**
	   * handle the sourceended event on the MediaSource
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleSourceEnded_ = function handleSourceEnded_() {
	    if (!this.inbandTextTracks_.metadataTrack_) {
	      return;
	    }
	
	    var cues = this.inbandTextTracks_.metadataTrack_.cues;
	
	    if (!cues || !cues.length) {
	      return;
	    }
	
	    var duration = this.duration();
	    cues[cues.length - 1].endTime = isNaN(duration) || Math.abs(duration) === Infinity ? Number.MAX_VALUE : duration;
	  }
	  /**
	   * handle the durationchange event on the MediaSource
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleDurationChange_ = function handleDurationChange_() {
	    this.tech_.trigger('durationchange');
	  }
	  /**
	   * Calls endOfStream on the media source when all active stream types have called
	   * endOfStream
	   *
	   * @param {string} streamType
	   *        Stream type of the segment loader that called endOfStream
	   * @private
	   */
	  ;
	
	  _proto.onEndOfStream = function onEndOfStream() {
	    var isEndOfStream = this.mainSegmentLoader_.ended_;
	
	    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	      var mainMediaInfo = this.mainSegmentLoader_.getCurrentMediaInfo_(); // if the audio playlist loader exists, then alternate audio is active
	
	      if (!mainMediaInfo || mainMediaInfo.hasVideo) {
	        // if we do not know if the main segment loader contains video yet or if we
	        // definitively know the main segment loader contains video, then we need to wait
	        // for both main and audio segment loaders to call endOfStream
	        isEndOfStream = isEndOfStream && this.audioSegmentLoader_.ended_;
	      } else {
	        // otherwise just rely on the audio loader
	        isEndOfStream = this.audioSegmentLoader_.ended_;
	      }
	    }
	
	    if (!isEndOfStream) {
	      return;
	    }
	
	    this.stopABRTimer_();
	    this.sourceUpdater_.endOfStream();
	  }
	  /**
	   * Check if a playlist has stopped being updated
	   *
	   * @param {Object} playlist the media playlist object
	   * @return {boolean} whether the playlist has stopped being updated or not
	   */
	  ;
	
	  _proto.stuckAtPlaylistEnd_ = function stuckAtPlaylistEnd_(playlist) {
	    var seekable = this.seekable();
	
	    if (!seekable.length) {
	      // playlist doesn't have enough information to determine whether we are stuck
	      return false;
	    }
	
	    var expired = this.syncController_.getExpiredTime(playlist, this.duration());
	
	    if (expired === null) {
	      return false;
	    } // does not use the safe live end to calculate playlist end, since we
	    // don't want to say we are stuck while there is still content
	
	
	    var absolutePlaylistEnd = Vhs$1.Playlist.playlistEnd(playlist, expired);
	    var currentTime = this.tech_.currentTime();
	    var buffered = this.tech_.buffered();
	
	    if (!buffered.length) {
	      // return true if the playhead reached the absolute end of the playlist
	      return absolutePlaylistEnd - currentTime <= SAFE_TIME_DELTA;
	    }
	
	    var bufferedEnd = buffered.end(buffered.length - 1); // return true if there is too little buffer left and buffer has reached absolute
	    // end of playlist
	
	    return bufferedEnd - currentTime <= SAFE_TIME_DELTA && absolutePlaylistEnd - bufferedEnd <= SAFE_TIME_DELTA;
	  }
	  /**
	   * Blacklists a playlist when an error occurs for a set amount of time
	   * making it unavailable for selection by the rendition selection algorithm
	   * and then forces a new playlist (rendition) selection.
	   *
	   * @param {Object=} error an optional error that may include the playlist
	   * to blacklist
	   * @param {number=} blacklistDuration an optional number of seconds to blacklist the
	   * playlist
	   */
	  ;
	
	  _proto.blacklistCurrentPlaylist = function blacklistCurrentPlaylist(error, blacklistDuration) {
	    if (error === void 0) {
	      error = {};
	    } // If the `error` was generated by the playlist loader, it will contain
	    // the playlist we were trying to load (but failed) and that should be
	    // blacklisted instead of the currently selected playlist which is likely
	    // out-of-date in this scenario
	
	
	    var currentPlaylist = error.playlist || this.masterPlaylistLoader_.media();
	    blacklistDuration = blacklistDuration || error.blacklistDuration || this.blacklistDuration; // If there is no current playlist, then an error occurred while we were
	    // trying to load the master OR while we were disposing of the tech
	
	    if (!currentPlaylist) {
	      this.error = error;
	
	      if (this.mediaSource.readyState !== 'open') {
	        this.trigger('error');
	      } else {
	        this.sourceUpdater_.endOfStream('network');
	      }
	
	      return;
	    }
	
	    currentPlaylist.playlistErrors_++;
	    var playlists = this.masterPlaylistLoader_.master.playlists;
	    var enabledPlaylists = playlists.filter(isEnabled);
	    var isFinalRendition = enabledPlaylists.length === 1 && enabledPlaylists[0] === currentPlaylist; // Don't blacklist the only playlist unless it was blacklisted
	    // forever
	
	    if (playlists.length === 1 && blacklistDuration !== Infinity) {
	      videojs.log.warn("Problem encountered with playlist " + currentPlaylist.id + ". " + 'Trying again since it is the only playlist.');
	      this.tech_.trigger('retryplaylist'); // if this is a final rendition, we should delay
	
	      return this.masterPlaylistLoader_.load(isFinalRendition);
	    }
	
	    if (isFinalRendition) {
	      // Since we're on the final non-blacklisted playlist, and we're about to blacklist
	      // it, instead of erring the player or retrying this playlist, clear out the current
	      // blacklist. This allows other playlists to be attempted in case any have been
	      // fixed.
	      var reincluded = false;
	      playlists.forEach(function (playlist) {
	        // skip current playlist which is about to be blacklisted
	        if (playlist === currentPlaylist) {
	          return;
	        }
	
	        var excludeUntil = playlist.excludeUntil; // a playlist cannot be reincluded if it wasn't excluded to begin with.
	
	        if (typeof excludeUntil !== 'undefined' && excludeUntil !== Infinity) {
	          reincluded = true;
	          delete playlist.excludeUntil;
	        }
	      });
	
	      if (reincluded) {
	        videojs.log.warn('Removing other playlists from the exclusion list because the last ' + 'rendition is about to be excluded.'); // Technically we are retrying a playlist, in that we are simply retrying a previous
	        // playlist. This is needed for users relying on the retryplaylist event to catch a
	        // case where the player might be stuck and looping through "dead" playlists.
	
	        this.tech_.trigger('retryplaylist');
	      }
	    } // Blacklist this playlist
	
	
	    var excludeUntil;
	
	    if (currentPlaylist.playlistErrors_ > this.maxPlaylistRetries) {
	      excludeUntil = Infinity;
	    } else {
	      excludeUntil = Date.now() + blacklistDuration * 1000;
	    }
	
	    currentPlaylist.excludeUntil = excludeUntil;
	
	    if (error.reason) {
	      currentPlaylist.lastExcludeReason_ = error.reason;
	    }
	
	    this.tech_.trigger('blacklistplaylist');
	    this.tech_.trigger({
	      type: 'usage',
	      name: 'vhs-rendition-blacklisted'
	    });
	    this.tech_.trigger({
	      type: 'usage',
	      name: 'hls-rendition-blacklisted'
	    }); // TODO: should we select a new playlist if this blacklist wasn't for the currentPlaylist?
	    // Would be something like media().id !=== currentPlaylist.id and we  would need something
	    // like `pendingMedia` in playlist loaders to check against that too. This will prevent us
	    // from loading a new playlist on any blacklist.
	    // Select a new playlist
	
	    var nextPlaylist = this.selectPlaylist();
	
	    if (!nextPlaylist) {
	      this.error = 'Playback cannot continue. No available working or supported playlists.';
	      this.trigger('error');
	      return;
	    }
	
	    var logFn = error.internal ? this.logger_ : videojs.log.warn;
	    var errorMessage = error.message ? ' ' + error.message : '';
	    logFn((error.internal ? 'Internal problem' : 'Problem') + " encountered with playlist " + currentPlaylist.id + "." + (errorMessage + " Switching to playlist " + nextPlaylist.id + ".")); // if audio group changed reset audio loaders
	
	    if (nextPlaylist.attributes.AUDIO !== currentPlaylist.attributes.AUDIO) {
	      this.delegateLoaders_('audio', ['abort', 'pause']);
	    } // if subtitle group changed reset subtitle loaders
	
	
	    if (nextPlaylist.attributes.SUBTITLES !== currentPlaylist.attributes.SUBTITLES) {
	      this.delegateLoaders_('subtitle', ['abort', 'pause']);
	    }
	
	    this.delegateLoaders_('main', ['abort', 'pause']);
	    var delayDuration = nextPlaylist.targetDuration / 2 * 1000 || 5 * 1000;
	    var shouldDelay = typeof nextPlaylist.lastRequest === 'number' && Date.now() - nextPlaylist.lastRequest <= delayDuration; // delay if it's a final rendition or if the last refresh is sooner than half targetDuration
	
	    return this.switchMedia_(nextPlaylist, 'exclude', isFinalRendition || shouldDelay);
	  }
	  /**
	   * Pause all segment/playlist loaders
	   */
	  ;
	
	  _proto.pauseLoading = function pauseLoading() {
	    this.delegateLoaders_('all', ['abort', 'pause']);
	    this.stopABRTimer_();
	  }
	  /**
	   * Call a set of functions in order on playlist loaders, segment loaders,
	   * or both types of loaders.
	   *
	   * @param {string} filter
	   *        Filter loaders that should call fnNames using a string. Can be:
	   *        * all - run on all loaders
	   *        * audio - run on all audio loaders
	   *        * subtitle - run on all subtitle loaders
	   *        * main - run on the main/master loaders
	   *
	   * @param {Array|string} fnNames
	   *        A string or array of function names to call.
	   */
	  ;
	
	  _proto.delegateLoaders_ = function delegateLoaders_(filter, fnNames) {
	    var _this7 = this;
	
	    var loaders = [];
	    var dontFilterPlaylist = filter === 'all';
	
	    if (dontFilterPlaylist || filter === 'main') {
	      loaders.push(this.masterPlaylistLoader_);
	    }
	
	    var mediaTypes = [];
	
	    if (dontFilterPlaylist || filter === 'audio') {
	      mediaTypes.push('AUDIO');
	    }
	
	    if (dontFilterPlaylist || filter === 'subtitle') {
	      mediaTypes.push('CLOSED-CAPTIONS');
	      mediaTypes.push('SUBTITLES');
	    }
	
	    mediaTypes.forEach(function (mediaType) {
	      var loader = _this7.mediaTypes_[mediaType] && _this7.mediaTypes_[mediaType].activePlaylistLoader;
	
	      if (loader) {
	        loaders.push(loader);
	      }
	    });
	    ['main', 'audio', 'subtitle'].forEach(function (name) {
	      var loader = _this7[name + "SegmentLoader_"];
	
	      if (loader && (filter === name || filter === 'all')) {
	        loaders.push(loader);
	      }
	    });
	    loaders.forEach(function (loader) {
	      return fnNames.forEach(function (fnName) {
	        if (typeof loader[fnName] === 'function') {
	          loader[fnName]();
	        }
	      });
	    });
	  }
	  /**
	   * set the current time on all segment loaders
	   *
	   * @param {TimeRange} currentTime the current time to set
	   * @return {TimeRange} the current time
	   */
	  ;
	
	  _proto.setCurrentTime = function setCurrentTime(currentTime) {
	    var buffered = findRange(this.tech_.buffered(), currentTime);
	
	    if (!(this.masterPlaylistLoader_ && this.masterPlaylistLoader_.media())) {
	      // return immediately if the metadata is not ready yet
	      return 0;
	    } // it's clearly an edge-case but don't thrown an error if asked to
	    // seek within an empty playlist
	
	
	    if (!this.masterPlaylistLoader_.media().segments) {
	      return 0;
	    } // if the seek location is already buffered, continue buffering as usual
	
	
	    if (buffered && buffered.length) {
	      return currentTime;
	    } // cancel outstanding requests so we begin buffering at the new
	    // location
	
	
	    this.mainSegmentLoader_.resetEverything();
	    this.mainSegmentLoader_.abort();
	
	    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	      this.audioSegmentLoader_.resetEverything();
	      this.audioSegmentLoader_.abort();
	    }
	
	    if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
	      this.subtitleSegmentLoader_.resetEverything();
	      this.subtitleSegmentLoader_.abort();
	    } // start segment loader loading in case they are paused
	
	
	    this.load();
	  }
	  /**
	   * get the current duration
	   *
	   * @return {TimeRange} the duration
	   */
	  ;
	
	  _proto.duration = function duration() {
	    if (!this.masterPlaylistLoader_) {
	      return 0;
	    }
	
	    var media = this.masterPlaylistLoader_.media();
	
	    if (!media) {
	      // no playlists loaded yet, so can't determine a duration
	      return 0;
	    } // Don't rely on the media source for duration in the case of a live playlist since
	    // setting the native MediaSource's duration to infinity ends up with consequences to
	    // seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
	    //
	    // This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
	    // however, few browsers have support for setLiveSeekableRange()
	    // https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
	    //
	    // Until a time when the duration of the media source can be set to infinity, and a
	    // seekable range specified across browsers, just return Infinity.
	
	
	    if (!media.endList) {
	      return Infinity;
	    } // Since this is a VOD video, it is safe to rely on the media source's duration (if
	    // available). If it's not available, fall back to a playlist-calculated estimate.
	
	
	    if (this.mediaSource) {
	      return this.mediaSource.duration;
	    }
	
	    return Vhs$1.Playlist.duration(media);
	  }
	  /**
	   * check the seekable range
	   *
	   * @return {TimeRange} the seekable range
	   */
	  ;
	
	  _proto.seekable = function seekable() {
	    return this.seekable_;
	  };
	
	  _proto.onSyncInfoUpdate_ = function onSyncInfoUpdate_() {
	    var audioSeekable; // TODO check for creation of both source buffers before updating seekable
	    //
	    // A fix was made to this function where a check for
	    // this.sourceUpdater_.hasCreatedSourceBuffers
	    // was added to ensure that both source buffers were created before seekable was
	    // updated. However, it originally had a bug where it was checking for a true and
	    // returning early instead of checking for false. Setting it to check for false to
	    // return early though created other issues. A call to play() would check for seekable
	    // end without verifying that a seekable range was present. In addition, even checking
	    // for that didn't solve some issues, as handleFirstPlay is sometimes worked around
	    // due to a media update calling load on the segment loaders, skipping a seek to live,
	    // thereby starting live streams at the beginning of the stream rather than at the end.
	    //
	    // This conditional should be fixed to wait for the creation of two source buffers at
	    // the same time as the other sections of code are fixed to properly seek to live and
	    // not throw an error due to checking for a seekable end when no seekable range exists.
	    //
	    // For now, fall back to the older behavior, with the understanding that the seekable
	    // range may not be completely correct, leading to a suboptimal initial live point.
	
	    if (!this.masterPlaylistLoader_) {
	      return;
	    }
	
	    var media = this.masterPlaylistLoader_.media();
	
	    if (!media) {
	      return;
	    }
	
	    var expired = this.syncController_.getExpiredTime(media, this.duration());
	
	    if (expired === null) {
	      // not enough information to update seekable
	      return;
	    }
	
	    var master = this.masterPlaylistLoader_.master;
	    var mainSeekable = Vhs$1.Playlist.seekable(media, expired, Vhs$1.Playlist.liveEdgeDelay(master, media));
	
	    if (mainSeekable.length === 0) {
	      return;
	    }
	
	    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	      media = this.mediaTypes_.AUDIO.activePlaylistLoader.media();
	      expired = this.syncController_.getExpiredTime(media, this.duration());
	
	      if (expired === null) {
	        return;
	      }
	
	      audioSeekable = Vhs$1.Playlist.seekable(media, expired, Vhs$1.Playlist.liveEdgeDelay(master, media));
	
	      if (audioSeekable.length === 0) {
	        return;
	      }
	    }
	
	    var oldEnd;
	    var oldStart;
	
	    if (this.seekable_ && this.seekable_.length) {
	      oldEnd = this.seekable_.end(0);
	      oldStart = this.seekable_.start(0);
	    }
	
	    if (!audioSeekable) {
	      // seekable has been calculated based on buffering video data so it
	      // can be returned directly
	      this.seekable_ = mainSeekable;
	    } else if (audioSeekable.start(0) > mainSeekable.end(0) || mainSeekable.start(0) > audioSeekable.end(0)) {
	      // seekables are pretty far off, rely on main
	      this.seekable_ = mainSeekable;
	    } else {
	      this.seekable_ = videojs.createTimeRanges([[audioSeekable.start(0) > mainSeekable.start(0) ? audioSeekable.start(0) : mainSeekable.start(0), audioSeekable.end(0) < mainSeekable.end(0) ? audioSeekable.end(0) : mainSeekable.end(0)]]);
	    } // seekable is the same as last time
	
	
	    if (this.seekable_ && this.seekable_.length) {
	      if (this.seekable_.end(0) === oldEnd && this.seekable_.start(0) === oldStart) {
	        return;
	      }
	    }
	
	    this.logger_("seekable updated [" + printableRange(this.seekable_) + "]");
	    this.tech_.trigger('seekablechanged');
	  }
	  /**
	   * Update the player duration
	   */
	  ;
	
	  _proto.updateDuration = function updateDuration(isLive) {
	    if (this.updateDuration_) {
	      this.mediaSource.removeEventListener('sourceopen', this.updateDuration_);
	      this.updateDuration_ = null;
	    }
	
	    if (this.mediaSource.readyState !== 'open') {
	      this.updateDuration_ = this.updateDuration.bind(this, isLive);
	      this.mediaSource.addEventListener('sourceopen', this.updateDuration_);
	      return;
	    }
	
	    if (isLive) {
	      var seekable = this.seekable();
	
	      if (!seekable.length) {
	        return;
	      } // Even in the case of a live playlist, the native MediaSource's duration should not
	      // be set to Infinity (even though this would be expected for a live playlist), since
	      // setting the native MediaSource's duration to infinity ends up with consequences to
	      // seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
	      //
	      // This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
	      // however, few browsers have support for setLiveSeekableRange()
	      // https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
	      //
	      // Until a time when the duration of the media source can be set to infinity, and a
	      // seekable range specified across browsers, the duration should be greater than or
	      // equal to the last possible seekable value.
	      // MediaSource duration starts as NaN
	      // It is possible (and probable) that this case will never be reached for many
	      // sources, since the MediaSource reports duration as the highest value without
	      // accounting for timestamp offset. For example, if the timestamp offset is -100 and
	      // we buffered times 0 to 100 with real times of 100 to 200, even though current
	      // time will be between 0 and 100, the native media source may report the duration
	      // as 200. However, since we report duration separate from the media source (as
	      // Infinity), and as long as the native media source duration value is greater than
	      // our reported seekable range, seeks will work as expected. The large number as
	      // duration for live is actually a strategy used by some players to work around the
	      // issue of live seekable ranges cited above.
	
	
	      if (isNaN(this.mediaSource.duration) || this.mediaSource.duration < seekable.end(seekable.length - 1)) {
	        this.sourceUpdater_.setDuration(seekable.end(seekable.length - 1));
	      }
	
	      return;
	    }
	
	    var buffered = this.tech_.buffered();
	    var duration = Vhs$1.Playlist.duration(this.masterPlaylistLoader_.media());
	
	    if (buffered.length > 0) {
	      duration = Math.max(duration, buffered.end(buffered.length - 1));
	    }
	
	    if (this.mediaSource.duration !== duration) {
	      this.sourceUpdater_.setDuration(duration);
	    }
	  }
	  /**
	   * dispose of the MasterPlaylistController and everything
	   * that it controls
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    var _this8 = this;
	
	    this.trigger('dispose');
	    this.decrypter_.terminate();
	    this.masterPlaylistLoader_.dispose();
	    this.mainSegmentLoader_.dispose();
	
	    if (this.loadOnPlay_) {
	      this.tech_.off('play', this.loadOnPlay_);
	    }
	
	    ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	      var groups = _this8.mediaTypes_[type].groups;
	
	      for (var id in groups) {
	        groups[id].forEach(function (group) {
	          if (group.playlistLoader) {
	            group.playlistLoader.dispose();
	          }
	        });
	      }
	    });
	    this.audioSegmentLoader_.dispose();
	    this.subtitleSegmentLoader_.dispose();
	    this.sourceUpdater_.dispose();
	    this.timelineChangeController_.dispose();
	    this.stopABRTimer_();
	
	    if (this.updateDuration_) {
	      this.mediaSource.removeEventListener('sourceopen', this.updateDuration_);
	    }
	
	    this.mediaSource.removeEventListener('durationchange', this.handleDurationChange_); // load the media source into the player
	
	    this.mediaSource.removeEventListener('sourceopen', this.handleSourceOpen_);
	    this.mediaSource.removeEventListener('sourceended', this.handleSourceEnded_);
	    this.off();
	  }
	  /**
	   * return the master playlist object if we have one
	   *
	   * @return {Object} the master playlist object that we parsed
	   */
	  ;
	
	  _proto.master = function master() {
	    return this.masterPlaylistLoader_.master;
	  }
	  /**
	   * return the currently selected playlist
	   *
	   * @return {Object} the currently selected playlist object that we parsed
	   */
	  ;
	
	  _proto.media = function media() {
	    // playlist loader will not return media if it has not been fully loaded
	    return this.masterPlaylistLoader_.media() || this.initialMedia_;
	  };
	
	  _proto.areMediaTypesKnown_ = function areMediaTypesKnown_() {
	    var usingAudioLoader = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
	    var hasMainMediaInfo = !!this.mainSegmentLoader_.getCurrentMediaInfo_(); // if we are not using an audio loader, then we have audio media info
	    // otherwise check on the segment loader.
	
	    var hasAudioMediaInfo = !usingAudioLoader ? true : !!this.audioSegmentLoader_.getCurrentMediaInfo_(); // one or both loaders has not loaded sufficently to get codecs
	
	    if (!hasMainMediaInfo || !hasAudioMediaInfo) {
	      return false;
	    }
	
	    return true;
	  };
	
	  _proto.getCodecsOrExclude_ = function getCodecsOrExclude_() {
	    var _this9 = this;
	
	    var media = {
	      main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
	      audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
	    };
	    var playlist = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media(); // set "main" media equal to video
	
	    media.video = media.main;
	    var playlistCodecs = codecsForPlaylist(this.master(), playlist);
	    var codecs = {};
	    var usingAudioLoader = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
	
	    if (media.main.hasVideo) {
	      codecs.video = playlistCodecs.video || media.main.videoCodec || codecs_js.DEFAULT_VIDEO_CODEC;
	    }
	
	    if (media.main.isMuxed) {
	      codecs.video += "," + (playlistCodecs.audio || media.main.audioCodec || codecs_js.DEFAULT_AUDIO_CODEC);
	    }
	
	    if (media.main.hasAudio && !media.main.isMuxed || media.audio.hasAudio || usingAudioLoader) {
	      codecs.audio = playlistCodecs.audio || media.main.audioCodec || media.audio.audioCodec || codecs_js.DEFAULT_AUDIO_CODEC; // set audio isFmp4 so we use the correct "supports" function below
	
	      media.audio.isFmp4 = media.main.hasAudio && !media.main.isMuxed ? media.main.isFmp4 : media.audio.isFmp4;
	    } // no codecs, no playback.
	
	
	    if (!codecs.audio && !codecs.video) {
	      this.blacklistCurrentPlaylist({
	        playlist: playlist,
	        message: 'Could not determine codecs for playlist.',
	        blacklistDuration: Infinity
	      });
	      return;
	    } // fmp4 relies on browser support, while ts relies on muxer support
	
	
	    var supportFunction = function supportFunction(isFmp4, codec) {
	      return isFmp4 ? codecs_js.browserSupportsCodec(codec) : codecs_js.muxerSupportsCodec(codec);
	    };
	
	    var unsupportedCodecs = {};
	    var unsupportedAudio;
	    ['video', 'audio'].forEach(function (type) {
	      if (codecs.hasOwnProperty(type) && !supportFunction(media[type].isFmp4, codecs[type])) {
	        var supporter = media[type].isFmp4 ? 'browser' : 'muxer';
	        unsupportedCodecs[supporter] = unsupportedCodecs[supporter] || [];
	        unsupportedCodecs[supporter].push(codecs[type]);
	
	        if (type === 'audio') {
	          unsupportedAudio = supporter;
	        }
	      }
	    });
	
	    if (usingAudioLoader && unsupportedAudio && playlist.attributes.AUDIO) {
	      var audioGroup = playlist.attributes.AUDIO;
	      this.master().playlists.forEach(function (variant) {
	        var variantAudioGroup = variant.attributes && variant.attributes.AUDIO;
	
	        if (variantAudioGroup === audioGroup && variant !== playlist) {
	          variant.excludeUntil = Infinity;
	        }
	      });
	      this.logger_("excluding audio group " + audioGroup + " as " + unsupportedAudio + " does not support codec(s): \"" + codecs.audio + "\"");
	    } // if we have any unsupported codecs blacklist this playlist.
	
	
	    if (Object.keys(unsupportedCodecs).length) {
	      var message = Object.keys(unsupportedCodecs).reduce(function (acc, supporter) {
	        if (acc) {
	          acc += ', ';
	        }
	
	        acc += supporter + " does not support codec(s): \"" + unsupportedCodecs[supporter].join(',') + "\"";
	        return acc;
	      }, '') + '.';
	      this.blacklistCurrentPlaylist({
	        playlist: playlist,
	        internal: true,
	        message: message,
	        blacklistDuration: Infinity
	      });
	      return;
	    } // check if codec switching is happening
	
	
	    if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
	      var switchMessages = [];
	      ['video', 'audio'].forEach(function (type) {
	        var newCodec = (codecs_js.parseCodecs(_this9.sourceUpdater_.codecs[type] || '')[0] || {}).type;
	        var oldCodec = (codecs_js.parseCodecs(codecs[type] || '')[0] || {}).type;
	
	        if (newCodec && oldCodec && newCodec.toLowerCase() !== oldCodec.toLowerCase()) {
	          switchMessages.push("\"" + _this9.sourceUpdater_.codecs[type] + "\" -> \"" + codecs[type] + "\"");
	        }
	      });
	
	      if (switchMessages.length) {
	        this.blacklistCurrentPlaylist({
	          playlist: playlist,
	          message: "Codec switching not supported: " + switchMessages.join(', ') + ".",
	          blacklistDuration: Infinity,
	          internal: true
	        });
	        return;
	      }
	    } // TODO: when using the muxer shouldn't we just return
	    // the codecs that the muxer outputs?
	
	
	    return codecs;
	  }
	  /**
	   * Create source buffers and exlude any incompatible renditions.
	   *
	   * @private
	   */
	  ;
	
	  _proto.tryToCreateSourceBuffers_ = function tryToCreateSourceBuffers_() {
	    // media source is not ready yet or sourceBuffers are already
	    // created.
	    if (this.mediaSource.readyState !== 'open' || this.sourceUpdater_.hasCreatedSourceBuffers()) {
	      return;
	    }
	
	    if (!this.areMediaTypesKnown_()) {
	      return;
	    }
	
	    var codecs = this.getCodecsOrExclude_(); // no codecs means that the playlist was excluded
	
	    if (!codecs) {
	      return;
	    }
	
	    this.sourceUpdater_.createSourceBuffers(codecs);
	    var codecString = [codecs.video, codecs.audio].filter(Boolean).join(',');
	    this.excludeIncompatibleVariants_(codecString);
	  }
	  /**
	   * Excludes playlists with codecs that are unsupported by the muxer and browser.
	   */
	  ;
	
	  _proto.excludeUnsupportedVariants_ = function excludeUnsupportedVariants_() {
	    var _this10 = this;
	
	    var playlists = this.master().playlists;
	    var ids = []; // TODO: why don't we have a property to loop through all
	    // playlist? Why did we ever mix indexes and keys?
	
	    Object.keys(playlists).forEach(function (key) {
	      var variant = playlists[key]; // check if we already processed this playlist.
	
	      if (ids.indexOf(variant.id) !== -1) {
	        return;
	      }
	
	      ids.push(variant.id);
	      var codecs = codecsForPlaylist(_this10.master, variant);
	      var unsupported = [];
	
	      if (codecs.audio && !codecs_js.muxerSupportsCodec(codecs.audio) && !codecs_js.browserSupportsCodec(codecs.audio)) {
	        unsupported.push("audio codec " + codecs.audio);
	      }
	
	      if (codecs.video && !codecs_js.muxerSupportsCodec(codecs.video) && !codecs_js.browserSupportsCodec(codecs.video)) {
	        unsupported.push("video codec " + codecs.video);
	      }
	
	      if (codecs.text && codecs.text === 'stpp.ttml.im1t') {
	        unsupported.push("text codec " + codecs.text);
	      }
	
	      if (unsupported.length) {
	        variant.excludeUntil = Infinity;
	
	        _this10.logger_("excluding " + variant.id + " for unsupported: " + unsupported.join(', '));
	      }
	    });
	  }
	  /**
	   * Blacklist playlists that are known to be codec or
	   * stream-incompatible with the SourceBuffer configuration. For
	   * instance, Media Source Extensions would cause the video element to
	   * stall waiting for video data if you switched from a variant with
	   * video and audio to an audio-only one.
	   *
	   * @param {Object} media a media playlist compatible with the current
	   * set of SourceBuffers. Variants in the current master playlist that
	   * do not appear to have compatible codec or stream configurations
	   * will be excluded from the default playlist selection algorithm
	   * indefinitely.
	   * @private
	   */
	  ;
	
	  _proto.excludeIncompatibleVariants_ = function excludeIncompatibleVariants_(codecString) {
	    var _this11 = this;
	
	    var ids = [];
	    var playlists = this.master().playlists;
	    var codecs = unwrapCodecList(codecs_js.parseCodecs(codecString));
	    var codecCount_ = codecCount(codecs);
	    var videoDetails = codecs.video && codecs_js.parseCodecs(codecs.video)[0] || null;
	    var audioDetails = codecs.audio && codecs_js.parseCodecs(codecs.audio)[0] || null;
	    Object.keys(playlists).forEach(function (key) {
	      var variant = playlists[key]; // check if we already processed this playlist.
	      // or it if it is already excluded forever.
	
	      if (ids.indexOf(variant.id) !== -1 || variant.excludeUntil === Infinity) {
	        return;
	      }
	
	      ids.push(variant.id);
	      var blacklistReasons = []; // get codecs from the playlist for this variant
	
	      var variantCodecs = codecsForPlaylist(_this11.masterPlaylistLoader_.master, variant);
	      var variantCodecCount = codecCount(variantCodecs); // if no codecs are listed, we cannot determine that this
	      // variant is incompatible. Wait for mux.js to probe
	
	      if (!variantCodecs.audio && !variantCodecs.video) {
	        return;
	      } // TODO: we can support this by removing the
	      // old media source and creating a new one, but it will take some work.
	      // The number of streams cannot change
	
	
	      if (variantCodecCount !== codecCount_) {
	        blacklistReasons.push("codec count \"" + variantCodecCount + "\" !== \"" + codecCount_ + "\"");
	      } // only exclude playlists by codec change, if codecs cannot switch
	      // during playback.
	
	
	      if (!_this11.sourceUpdater_.canChangeType()) {
	        var variantVideoDetails = variantCodecs.video && codecs_js.parseCodecs(variantCodecs.video)[0] || null;
	        var variantAudioDetails = variantCodecs.audio && codecs_js.parseCodecs(variantCodecs.audio)[0] || null; // the video codec cannot change
	
	        if (variantVideoDetails && videoDetails && variantVideoDetails.type.toLowerCase() !== videoDetails.type.toLowerCase()) {
	          blacklistReasons.push("video codec \"" + variantVideoDetails.type + "\" !== \"" + videoDetails.type + "\"");
	        } // the audio codec cannot change
	
	
	        if (variantAudioDetails && audioDetails && variantAudioDetails.type.toLowerCase() !== audioDetails.type.toLowerCase()) {
	          blacklistReasons.push("audio codec \"" + variantAudioDetails.type + "\" !== \"" + audioDetails.type + "\"");
	        }
	      }
	
	      if (blacklistReasons.length) {
	        variant.excludeUntil = Infinity;
	
	        _this11.logger_("blacklisting " + variant.id + ": " + blacklistReasons.join(' && '));
	      }
	    });
	  };
	
	  _proto.updateAdCues_ = function updateAdCues_(media) {
	    var offset = 0;
	    var seekable = this.seekable();
	
	    if (seekable.length) {
	      offset = seekable.start(0);
	    }
	
	    updateAdCues(media, this.cueTagsTrack_, offset);
	  }
	  /**
	   * Calculates the desired forward buffer length based on current time
	   *
	   * @return {number} Desired forward buffer length in seconds
	   */
	  ;
	
	  _proto.goalBufferLength = function goalBufferLength() {
	    var currentTime = this.tech_.currentTime();
	    var initial = Config.GOAL_BUFFER_LENGTH;
	    var rate = Config.GOAL_BUFFER_LENGTH_RATE;
	    var max = Math.max(initial, Config.MAX_GOAL_BUFFER_LENGTH);
	    return Math.min(initial + currentTime * rate, max);
	  }
	  /**
	   * Calculates the desired buffer low water line based on current time
	   *
	   * @return {number} Desired buffer low water line in seconds
	   */
	  ;
	
	  _proto.bufferLowWaterLine = function bufferLowWaterLine() {
	    var currentTime = this.tech_.currentTime();
	    var initial = Config.BUFFER_LOW_WATER_LINE;
	    var rate = Config.BUFFER_LOW_WATER_LINE_RATE;
	    var max = Math.max(initial, Config.MAX_BUFFER_LOW_WATER_LINE);
	    var newMax = Math.max(initial, Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
	    return Math.min(initial + currentTime * rate, this.experimentalBufferBasedABR ? newMax : max);
	  };
	
	  _proto.bufferHighWaterLine = function bufferHighWaterLine() {
	    return Config.BUFFER_HIGH_WATER_LINE;
	  };
	
	  return MasterPlaylistController;
	}(videojs.EventTarget);
	/**
	 * Returns a function that acts as the Enable/disable playlist function.
	 *
	 * @param {PlaylistLoader} loader - The master playlist loader
	 * @param {string} playlistID - id of the playlist
	 * @param {Function} changePlaylistFn - A function to be called after a
	 * playlist's enabled-state has been changed. Will NOT be called if a
	 * playlist's enabled-state is unchanged
	 * @param {boolean=} enable - Value to set the playlist enabled-state to
	 * or if undefined returns the current enabled-state for the playlist
	 * @return {Function} Function for setting/getting enabled
	 */
	
	
	var enableFunction = function enableFunction(loader, playlistID, changePlaylistFn) {
	  return function (enable) {
	    var playlist = loader.master.playlists[playlistID];
	    var incompatible = isIncompatible(playlist);
	    var currentlyEnabled = isEnabled(playlist);
	
	    if (typeof enable === 'undefined') {
	      return currentlyEnabled;
	    }
	
	    if (enable) {
	      delete playlist.disabled;
	    } else {
	      playlist.disabled = true;
	    }
	
	    if (enable !== currentlyEnabled && !incompatible) {
	      // Ensure the outside world knows about our changes
	      changePlaylistFn();
	
	      if (enable) {
	        loader.trigger('renditionenabled');
	      } else {
	        loader.trigger('renditiondisabled');
	      }
	    }
	
	    return enable;
	  };
	};
	/**
	 * The representation object encapsulates the publicly visible information
	 * in a media playlist along with a setter/getter-type function (enabled)
	 * for changing the enabled-state of a particular playlist entry
	 *
	 * @class Representation
	 */
	
	
	var Representation = function Representation(vhsHandler, playlist, id) {
	  var mpc = vhsHandler.masterPlaylistController_,
	      smoothQualityChange = vhsHandler.options_.smoothQualityChange; // Get a reference to a bound version of the quality change function
	
	  var changeType = smoothQualityChange ? 'smooth' : 'fast';
	  var qualityChangeFunction = mpc[changeType + "QualityChange_"].bind(mpc); // some playlist attributes are optional
	
	  if (playlist.attributes) {
	    var resolution = playlist.attributes.RESOLUTION;
	    this.width = resolution && resolution.width;
	    this.height = resolution && resolution.height;
	    this.bandwidth = playlist.attributes.BANDWIDTH;
	    this.frameRate = playlist.attributes['FRAME-RATE'];
	  }
	
	  this.codecs = codecsForPlaylist(mpc.master(), playlist);
	  this.playlist = playlist; // The id is simply the ordinality of the media playlist
	  // within the master playlist
	
	  this.id = id; // Partially-apply the enableFunction to create a playlist-
	  // specific variant
	
	  this.enabled = enableFunction(vhsHandler.playlists, playlist.id, qualityChangeFunction);
	};
	/**
	 * A mixin function that adds the `representations` api to an instance
	 * of the VhsHandler class
	 *
	 * @param {VhsHandler} vhsHandler - An instance of VhsHandler to add the
	 * representation API into
	 */
	
	
	var renditionSelectionMixin = function renditionSelectionMixin(vhsHandler) {
	  // Add a single API-specific function to the VhsHandler instance
	  vhsHandler.representations = function () {
	    var master = vhsHandler.masterPlaylistController_.master();
	    var playlists = isAudioOnly(master) ? vhsHandler.masterPlaylistController_.getAudioTrackPlaylists_() : master.playlists;
	
	    if (!playlists) {
	      return [];
	    }
	
	    return playlists.filter(function (media) {
	      return !isIncompatible(media);
	    }).map(function (e, i) {
	      return new Representation(vhsHandler, e, e.id);
	    });
	  };
	};
	/**
	 * @file playback-watcher.js
	 *
	 * Playback starts, and now my watch begins. It shall not end until my death. I shall
	 * take no wait, hold no uncleared timeouts, father no bad seeks. I shall wear no crowns
	 * and win no glory. I shall live and die at my post. I am the corrector of the underflow.
	 * I am the watcher of gaps. I am the shield that guards the realms of seekable. I pledge
	 * my life and honor to the Playback Watch, for this Player and all the Players to come.
	 */
	
	
	var timerCancelEvents = ['seeking', 'seeked', 'pause', 'playing', 'error'];
	/**
	 * @class PlaybackWatcher
	 */
	
	var PlaybackWatcher = /*#__PURE__*/function () {
	  /**
	   * Represents an PlaybackWatcher object.
	   *
	   * @class
	   * @param {Object} options an object that includes the tech and settings
	   */
	  function PlaybackWatcher(options) {
	    var _this = this;
	
	    this.masterPlaylistController_ = options.masterPlaylistController;
	    this.tech_ = options.tech;
	    this.seekable = options.seekable;
	    this.allowSeeksWithinUnsafeLiveWindow = options.allowSeeksWithinUnsafeLiveWindow;
	    this.liveRangeSafeTimeDelta = options.liveRangeSafeTimeDelta;
	    this.media = options.media;
	    this.consecutiveUpdates = 0;
	    this.lastRecordedTime = null;
	    this.timer_ = null;
	    this.checkCurrentTimeTimeout_ = null;
	    this.logger_ = logger('PlaybackWatcher');
	    this.logger_('initialize');
	
	    var playHandler = function playHandler() {
	      return _this.monitorCurrentTime_();
	    };
	
	    var canPlayHandler = function canPlayHandler() {
	      return _this.monitorCurrentTime_();
	    };
	
	    var waitingHandler = function waitingHandler() {
	      return _this.techWaiting_();
	    };
	
	    var cancelTimerHandler = function cancelTimerHandler() {
	      return _this.cancelTimer_();
	    };
	
	    var mpc = this.masterPlaylistController_;
	    var loaderTypes = ['main', 'subtitle', 'audio'];
	    var loaderChecks = {};
	    loaderTypes.forEach(function (type) {
	      loaderChecks[type] = {
	        reset: function reset() {
	          return _this.resetSegmentDownloads_(type);
	        },
	        updateend: function updateend() {
	          return _this.checkSegmentDownloads_(type);
	        }
	      };
	      mpc[type + "SegmentLoader_"].on('appendsdone', loaderChecks[type].updateend); // If a rendition switch happens during a playback stall where the buffer
	      // isn't changing we want to reset. We cannot assume that the new rendition
	      // will also be stalled, until after new appends.
	
	      mpc[type + "SegmentLoader_"].on('playlistupdate', loaderChecks[type].reset); // Playback stalls should not be detected right after seeking.
	      // This prevents one segment playlists (single vtt or single segment content)
	      // from being detected as stalling. As the buffer will not change in those cases, since
	      // the buffer is the entire video duration.
	
	      _this.tech_.on(['seeked', 'seeking'], loaderChecks[type].reset);
	    });
	    /**
	     * We check if a seek was into a gap through the following steps:
	     * 1. We get a seeking event and we do not get a seeked event. This means that
	     *    a seek was attempted but not completed.
	     * 2. We run `fixesBadSeeks_` on segment loader appends. This means that we already
	     *    removed everything from our buffer and appended a segment, and should be ready
	     *    to check for gaps.
	     */
	
	    var setSeekingHandlers = function setSeekingHandlers(fn) {
	      ['main', 'audio'].forEach(function (type) {
	        mpc[type + "SegmentLoader_"][fn]('appended', _this.seekingAppendCheck_);
	      });
	    };
	
	    this.seekingAppendCheck_ = function () {
	      if (_this.fixesBadSeeks_()) {
	        _this.consecutiveUpdates = 0;
	        _this.lastRecordedTime = _this.tech_.currentTime();
	        setSeekingHandlers('off');
	      }
	    };
	
	    this.clearSeekingAppendCheck_ = function () {
	      return setSeekingHandlers('off');
	    };
	
	    this.watchForBadSeeking_ = function () {
	      _this.clearSeekingAppendCheck_();
	
	      setSeekingHandlers('on');
	    };
	
	    this.tech_.on('seeked', this.clearSeekingAppendCheck_);
	    this.tech_.on('seeking', this.watchForBadSeeking_);
	    this.tech_.on('waiting', waitingHandler);
	    this.tech_.on(timerCancelEvents, cancelTimerHandler);
	    this.tech_.on('canplay', canPlayHandler);
	    /*
	      An edge case exists that results in gaps not being skipped when they exist at the beginning of a stream. This case
	      is surfaced in one of two ways:
	       1)  The `waiting` event is fired before the player has buffered content, making it impossible
	          to find or skip the gap. The `waiting` event is followed by a `play` event. On first play
	          we can check if playback is stalled due to a gap, and skip the gap if necessary.
	      2)  A source with a gap at the beginning of the stream is loaded programatically while the player
	          is in a playing state. To catch this case, it's important that our one-time play listener is setup
	          even if the player is in a playing state
	    */
	
	    this.tech_.one('play', playHandler); // Define the dispose function to clean up our events
	
	    this.dispose = function () {
	      _this.clearSeekingAppendCheck_();
	
	      _this.logger_('dispose');
	
	      _this.tech_.off('waiting', waitingHandler);
	
	      _this.tech_.off(timerCancelEvents, cancelTimerHandler);
	
	      _this.tech_.off('canplay', canPlayHandler);
	
	      _this.tech_.off('play', playHandler);
	
	      _this.tech_.off('seeking', _this.watchForBadSeeking_);
	
	      _this.tech_.off('seeked', _this.clearSeekingAppendCheck_);
	
	      loaderTypes.forEach(function (type) {
	        mpc[type + "SegmentLoader_"].off('appendsdone', loaderChecks[type].updateend);
	        mpc[type + "SegmentLoader_"].off('playlistupdate', loaderChecks[type].reset);
	
	        _this.tech_.off(['seeked', 'seeking'], loaderChecks[type].reset);
	      });
	
	      if (_this.checkCurrentTimeTimeout_) {
	        window__default['default'].clearTimeout(_this.checkCurrentTimeTimeout_);
	      }
	
	      _this.cancelTimer_();
	    };
	  }
	  /**
	   * Periodically check current time to see if playback stopped
	   *
	   * @private
	   */
	
	
	  var _proto = PlaybackWatcher.prototype;
	
	  _proto.monitorCurrentTime_ = function monitorCurrentTime_() {
	    this.checkCurrentTime_();
	
	    if (this.checkCurrentTimeTimeout_) {
	      window__default['default'].clearTimeout(this.checkCurrentTimeTimeout_);
	    } // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
	
	
	    this.checkCurrentTimeTimeout_ = window__default['default'].setTimeout(this.monitorCurrentTime_.bind(this), 250);
	  }
	  /**
	   * Reset stalled download stats for a specific type of loader
	   *
	   * @param {string} type
	   *        The segment loader type to check.
	   *
	   * @listens SegmentLoader#playlistupdate
	   * @listens Tech#seeking
	   * @listens Tech#seeked
	   */
	  ;
	
	  _proto.resetSegmentDownloads_ = function resetSegmentDownloads_(type) {
	    var loader = this.masterPlaylistController_[type + "SegmentLoader_"];
	
	    if (this[type + "StalledDownloads_"] > 0) {
	      this.logger_("resetting possible stalled download count for " + type + " loader");
	    }
	
	    this[type + "StalledDownloads_"] = 0;
	    this[type + "Buffered_"] = loader.buffered_();
	  }
	  /**
	   * Checks on every segment `appendsdone` to see
	   * if segment appends are making progress. If they are not
	   * and we are still downloading bytes. We blacklist the playlist.
	   *
	   * @param {string} type
	   *        The segment loader type to check.
	   *
	   * @listens SegmentLoader#appendsdone
	   */
	  ;
	
	  _proto.checkSegmentDownloads_ = function checkSegmentDownloads_(type) {
	    var mpc = this.masterPlaylistController_;
	    var loader = mpc[type + "SegmentLoader_"];
	    var buffered = loader.buffered_();
	    var isBufferedDifferent = isRangeDifferent(this[type + "Buffered_"], buffered);
	    this[type + "Buffered_"] = buffered; // if another watcher is going to fix the issue or
	    // the buffered value for this loader changed
	    // appends are working
	
	    if (isBufferedDifferent) {
	      this.resetSegmentDownloads_(type);
	      return;
	    }
	
	    this[type + "StalledDownloads_"]++;
	    this.logger_("found #" + this[type + "StalledDownloads_"] + " " + type + " appends that did not increase buffer (possible stalled download)", {
	      playlistId: loader.playlist_ && loader.playlist_.id,
	      buffered: timeRangesToArray(buffered)
	    }); // after 10 possibly stalled appends with no reset, exclude
	
	    if (this[type + "StalledDownloads_"] < 10) {
	      return;
	    }
	
	    this.logger_(type + " loader stalled download exclusion");
	    this.resetSegmentDownloads_(type);
	    this.tech_.trigger({
	      type: 'usage',
	      name: "vhs-" + type + "-download-exclusion"
	    });
	
	    if (type === 'subtitle') {
	      return;
	    } // TODO: should we exclude audio tracks rather than main tracks
	    // when type is audio?
	
	
	    mpc.blacklistCurrentPlaylist({
	      message: "Excessive " + type + " segment downloading detected."
	    }, Infinity);
	  }
	  /**
	   * The purpose of this function is to emulate the "waiting" event on
	   * browsers that do not emit it when they are waiting for more
	   * data to continue playback
	   *
	   * @private
	   */
	  ;
	
	  _proto.checkCurrentTime_ = function checkCurrentTime_() {
	    if (this.tech_.paused() || this.tech_.seeking()) {
	      return;
	    }
	
	    var currentTime = this.tech_.currentTime();
	    var buffered = this.tech_.buffered();
	
	    if (this.lastRecordedTime === currentTime && (!buffered.length || currentTime + SAFE_TIME_DELTA >= buffered.end(buffered.length - 1))) {
	      // If current time is at the end of the final buffered region, then any playback
	      // stall is most likely caused by buffering in a low bandwidth environment. The tech
	      // should fire a `waiting` event in this scenario, but due to browser and tech
	      // inconsistencies. Calling `techWaiting_` here allows us to simulate
	      // responding to a native `waiting` event when the tech fails to emit one.
	      return this.techWaiting_();
	    }
	
	    if (this.consecutiveUpdates >= 5 && currentTime === this.lastRecordedTime) {
	      this.consecutiveUpdates++;
	      this.waiting_();
	    } else if (currentTime === this.lastRecordedTime) {
	      this.consecutiveUpdates++;
	    } else {
	      this.consecutiveUpdates = 0;
	      this.lastRecordedTime = currentTime;
	    }
	  }
	  /**
	   * Cancels any pending timers and resets the 'timeupdate' mechanism
	   * designed to detect that we are stalled
	   *
	   * @private
	   */
	  ;
	
	  _proto.cancelTimer_ = function cancelTimer_() {
	    this.consecutiveUpdates = 0;
	
	    if (this.timer_) {
	      this.logger_('cancelTimer_');
	      clearTimeout(this.timer_);
	    }
	
	    this.timer_ = null;
	  }
	  /**
	   * Fixes situations where there's a bad seek
	   *
	   * @return {boolean} whether an action was taken to fix the seek
	   * @private
	   */
	  ;
	
	  _proto.fixesBadSeeks_ = function fixesBadSeeks_() {
	    var seeking = this.tech_.seeking();
	
	    if (!seeking) {
	      return false;
	    } // TODO: It's possible that these seekable checks should be moved out of this function
	    // and into a function that runs on seekablechange. It's also possible that we only need
	    // afterSeekableWindow as the buffered check at the bottom is good enough to handle before
	    // seekable range.
	
	
	    var seekable = this.seekable();
	    var currentTime = this.tech_.currentTime();
	    var isAfterSeekableRange = this.afterSeekableWindow_(seekable, currentTime, this.media(), this.allowSeeksWithinUnsafeLiveWindow);
	    var seekTo;
	
	    if (isAfterSeekableRange) {
	      var seekableEnd = seekable.end(seekable.length - 1); // sync to live point (if VOD, our seekable was updated and we're simply adjusting)
	
	      seekTo = seekableEnd;
	    }
	
	    if (this.beforeSeekableWindow_(seekable, currentTime)) {
	      var seekableStart = seekable.start(0); // sync to the beginning of the live window
	      // provide a buffer of .1 seconds to handle rounding/imprecise numbers
	
	      seekTo = seekableStart + ( // if the playlist is too short and the seekable range is an exact time (can
	      // happen in live with a 3 segment playlist), then don't use a time delta
	      seekableStart === seekable.end(0) ? 0 : SAFE_TIME_DELTA);
	    }
	
	    if (typeof seekTo !== 'undefined') {
	      this.logger_("Trying to seek outside of seekable at time " + currentTime + " with " + ("seekable range " + printableRange(seekable) + ". Seeking to ") + (seekTo + "."));
	      this.tech_.setCurrentTime(seekTo);
	      return true;
	    }
	
	    var sourceUpdater = this.masterPlaylistController_.sourceUpdater_;
	    var buffered = this.tech_.buffered();
	    var audioBuffered = sourceUpdater.audioBuffer ? sourceUpdater.audioBuffered() : null;
	    var videoBuffered = sourceUpdater.videoBuffer ? sourceUpdater.videoBuffered() : null;
	    var media = this.media(); // verify that at least two segment durations or one part duration have been
	    // appended before checking for a gap.
	
	    var minAppendedDuration = media.partTargetDuration ? media.partTargetDuration : (media.targetDuration - TIME_FUDGE_FACTOR) * 2; // verify that at least two segment durations have been
	    // appended before checking for a gap.
	
	    var bufferedToCheck = [audioBuffered, videoBuffered];
	
	    for (var i = 0; i < bufferedToCheck.length; i++) {
	      // skip null buffered
	      if (!bufferedToCheck[i]) {
	        continue;
	      }
	
	      var timeAhead = timeAheadOf(bufferedToCheck[i], currentTime); // if we are less than two video/audio segment durations or one part
	      // duration behind we haven't appended enough to call this a bad seek.
	
	      if (timeAhead < minAppendedDuration) {
	        return false;
	      }
	    }
	
	    var nextRange = findNextRange(buffered, currentTime); // we have appended enough content, but we don't have anything buffered
	    // to seek over the gap
	
	    if (nextRange.length === 0) {
	      return false;
	    }
	
	    seekTo = nextRange.start(0) + SAFE_TIME_DELTA;
	    this.logger_("Buffered region starts (" + nextRange.start(0) + ") " + (" just beyond seek point (" + currentTime + "). Seeking to " + seekTo + "."));
	    this.tech_.setCurrentTime(seekTo);
	    return true;
	  }
	  /**
	   * Handler for situations when we determine the player is waiting.
	   *
	   * @private
	   */
	  ;
	
	  _proto.waiting_ = function waiting_() {
	    if (this.techWaiting_()) {
	      return;
	    } // All tech waiting checks failed. Use last resort correction
	
	
	    var currentTime = this.tech_.currentTime();
	    var buffered = this.tech_.buffered();
	    var currentRange = findRange(buffered, currentTime); // Sometimes the player can stall for unknown reasons within a contiguous buffered
	    // region with no indication that anything is amiss (seen in Firefox). Seeking to
	    // currentTime is usually enough to kickstart the player. This checks that the player
	    // is currently within a buffered region before attempting a corrective seek.
	    // Chrome does not appear to continue `timeupdate` events after a `waiting` event
	    // until there is ~ 3 seconds of forward buffer available. PlaybackWatcher should also
	    // make sure there is ~3 seconds of forward buffer before taking any corrective action
	    // to avoid triggering an `unknownwaiting` event when the network is slow.
	
	    if (currentRange.length && currentTime + 3 <= currentRange.end(0)) {
	      this.cancelTimer_();
	      this.tech_.setCurrentTime(currentTime);
	      this.logger_("Stopped at " + currentTime + " while inside a buffered region " + ("[" + currentRange.start(0) + " -> " + currentRange.end(0) + "]. Attempting to resume ") + 'playback by seeking to the current time.'); // unknown waiting corrections may be useful for monitoring QoS
	
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-unknown-waiting'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-unknown-waiting'
	      });
	      return;
	    }
	  }
	  /**
	   * Handler for situations when the tech fires a `waiting` event
	   *
	   * @return {boolean}
	   *         True if an action (or none) was needed to correct the waiting. False if no
	   *         checks passed
	   * @private
	   */
	  ;
	
	  _proto.techWaiting_ = function techWaiting_() {
	    var seekable = this.seekable();
	    var currentTime = this.tech_.currentTime();
	
	    if (this.tech_.seeking() || this.timer_ !== null) {
	      // Tech is seeking or already waiting on another action, no action needed
	      return true;
	    }
	
	    if (this.beforeSeekableWindow_(seekable, currentTime)) {
	      var livePoint = seekable.end(seekable.length - 1);
	      this.logger_("Fell out of live window at time " + currentTime + ". Seeking to " + ("live point (seekable end) " + livePoint));
	      this.cancelTimer_();
	      this.tech_.setCurrentTime(livePoint); // live window resyncs may be useful for monitoring QoS
	
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-live-resync'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-live-resync'
	      });
	      return true;
	    }
	
	    var sourceUpdater = this.tech_.vhs.masterPlaylistController_.sourceUpdater_;
	    var buffered = this.tech_.buffered();
	    var videoUnderflow = this.videoUnderflow_({
	      audioBuffered: sourceUpdater.audioBuffered(),
	      videoBuffered: sourceUpdater.videoBuffered(),
	      currentTime: currentTime
	    });
	
	    if (videoUnderflow) {
	      // Even though the video underflowed and was stuck in a gap, the audio overplayed
	      // the gap, leading currentTime into a buffered range. Seeking to currentTime
	      // allows the video to catch up to the audio position without losing any audio
	      // (only suffering ~3 seconds of frozen video and a pause in audio playback).
	      this.cancelTimer_();
	      this.tech_.setCurrentTime(currentTime); // video underflow may be useful for monitoring QoS
	
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-video-underflow'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-video-underflow'
	      });
	      return true;
	    }
	
	    var nextRange = findNextRange(buffered, currentTime); // check for gap
	
	    if (nextRange.length > 0) {
	      var difference = nextRange.start(0) - currentTime;
	      this.logger_("Stopped at " + currentTime + ", setting timer for " + difference + ", seeking " + ("to " + nextRange.start(0)));
	      this.cancelTimer_();
	      this.timer_ = setTimeout(this.skipTheGap_.bind(this), difference * 1000, currentTime);
	      return true;
	    } // All checks failed. Returning false to indicate failure to correct waiting
	
	
	    return false;
	  };
	
	  _proto.afterSeekableWindow_ = function afterSeekableWindow_(seekable, currentTime, playlist, allowSeeksWithinUnsafeLiveWindow) {
	    if (allowSeeksWithinUnsafeLiveWindow === void 0) {
	      allowSeeksWithinUnsafeLiveWindow = false;
	    }
	
	    if (!seekable.length) {
	      // we can't make a solid case if there's no seekable, default to false
	      return false;
	    }
	
	    var allowedEnd = seekable.end(seekable.length - 1) + SAFE_TIME_DELTA;
	    var isLive = !playlist.endList;
	
	    if (isLive && allowSeeksWithinUnsafeLiveWindow) {
	      allowedEnd = seekable.end(seekable.length - 1) + playlist.targetDuration * 3;
	    }
	
	    if (currentTime > allowedEnd) {
	      return true;
	    }
	
	    return false;
	  };
	
	  _proto.beforeSeekableWindow_ = function beforeSeekableWindow_(seekable, currentTime) {
	    if (seekable.length && // can't fall before 0 and 0 seekable start identifies VOD stream
	    seekable.start(0) > 0 && currentTime < seekable.start(0) - this.liveRangeSafeTimeDelta) {
	      return true;
	    }
	
	    return false;
	  };
	
	  _proto.videoUnderflow_ = function videoUnderflow_(_ref) {
	    var videoBuffered = _ref.videoBuffered,
	        audioBuffered = _ref.audioBuffered,
	        currentTime = _ref.currentTime; // audio only content will not have video underflow :)
	
	    if (!videoBuffered) {
	      return;
	    }
	
	    var gap; // find a gap in demuxed content.
	
	    if (videoBuffered.length && audioBuffered.length) {
	      // in Chrome audio will continue to play for ~3s when we run out of video
	      // so we have to check that the video buffer did have some buffer in the
	      // past.
	      var lastVideoRange = findRange(videoBuffered, currentTime - 3);
	      var videoRange = findRange(videoBuffered, currentTime);
	      var audioRange = findRange(audioBuffered, currentTime);
	
	      if (audioRange.length && !videoRange.length && lastVideoRange.length) {
	        gap = {
	          start: lastVideoRange.end(0),
	          end: audioRange.end(0)
	        };
	      } // find a gap in muxed content.
	
	    } else {
	      var nextRange = findNextRange(videoBuffered, currentTime); // Even if there is no available next range, there is still a possibility we are
	      // stuck in a gap due to video underflow.
	
	      if (!nextRange.length) {
	        gap = this.gapFromVideoUnderflow_(videoBuffered, currentTime);
	      }
	    }
	
	    if (gap) {
	      this.logger_("Encountered a gap in video from " + gap.start + " to " + gap.end + ". " + ("Seeking to current time " + currentTime));
	      return true;
	    }
	
	    return false;
	  }
	  /**
	   * Timer callback. If playback still has not proceeded, then we seek
	   * to the start of the next buffered region.
	   *
	   * @private
	   */
	  ;
	
	  _proto.skipTheGap_ = function skipTheGap_(scheduledCurrentTime) {
	    var buffered = this.tech_.buffered();
	    var currentTime = this.tech_.currentTime();
	    var nextRange = findNextRange(buffered, currentTime);
	    this.cancelTimer_();
	
	    if (nextRange.length === 0 || currentTime !== scheduledCurrentTime) {
	      return;
	    }
	
	    this.logger_('skipTheGap_:', 'currentTime:', currentTime, 'scheduled currentTime:', scheduledCurrentTime, 'nextRange start:', nextRange.start(0)); // only seek if we still have not played
	
	    this.tech_.setCurrentTime(nextRange.start(0) + TIME_FUDGE_FACTOR);
	    this.tech_.trigger({
	      type: 'usage',
	      name: 'vhs-gap-skip'
	    });
	    this.tech_.trigger({
	      type: 'usage',
	      name: 'hls-gap-skip'
	    });
	  };
	
	  _proto.gapFromVideoUnderflow_ = function gapFromVideoUnderflow_(buffered, currentTime) {
	    // At least in Chrome, if there is a gap in the video buffer, the audio will continue
	    // playing for ~3 seconds after the video gap starts. This is done to account for
	    // video buffer underflow/underrun (note that this is not done when there is audio
	    // buffer underflow/underrun -- in that case the video will stop as soon as it
	    // encounters the gap, as audio stalls are more noticeable/jarring to a user than
	    // video stalls). The player's time will reflect the playthrough of audio, so the
	    // time will appear as if we are in a buffered region, even if we are stuck in a
	    // "gap."
	    //
	    // Example:
	    // video buffer:   0 => 10.1, 10.2 => 20
	    // audio buffer:   0 => 20
	    // overall buffer: 0 => 10.1, 10.2 => 20
	    // current time: 13
	    //
	    // Chrome's video froze at 10 seconds, where the video buffer encountered the gap,
	    // however, the audio continued playing until it reached ~3 seconds past the gap
	    // (13 seconds), at which point it stops as well. Since current time is past the
	    // gap, findNextRange will return no ranges.
	    //
	    // To check for this issue, we see if there is a gap that starts somewhere within
	    // a 3 second range (3 seconds +/- 1 second) back from our current time.
	    var gaps = findGaps(buffered);
	
	    for (var i = 0; i < gaps.length; i++) {
	      var start = gaps.start(i);
	      var end = gaps.end(i); // gap is starts no more than 4 seconds back
	
	      if (currentTime - start < 4 && currentTime - start > 2) {
	        return {
	          start: start,
	          end: end
	        };
	      }
	    }
	
	    return null;
	  };
	
	  return PlaybackWatcher;
	}();
	
	var defaultOptions = {
	  errorInterval: 30,
	  getSource: function getSource(next) {
	    var tech = this.tech({
	      IWillNotUseThisInPlugins: true
	    });
	    var sourceObj = tech.currentSource_ || this.currentSource();
	    return next(sourceObj);
	  }
	};
	/**
	 * Main entry point for the plugin
	 *
	 * @param {Player} player a reference to a videojs Player instance
	 * @param {Object} [options] an object with plugin options
	 * @private
	 */
	
	var initPlugin = function initPlugin(player, options) {
	  var lastCalled = 0;
	  var seekTo = 0;
	  var localOptions = videojs.mergeOptions(defaultOptions, options);
	  player.ready(function () {
	    player.trigger({
	      type: 'usage',
	      name: 'vhs-error-reload-initialized'
	    });
	    player.trigger({
	      type: 'usage',
	      name: 'hls-error-reload-initialized'
	    });
	  });
	  /**
	   * Player modifications to perform that must wait until `loadedmetadata`
	   * has been triggered
	   *
	   * @private
	   */
	
	  var loadedMetadataHandler = function loadedMetadataHandler() {
	    if (seekTo) {
	      player.currentTime(seekTo);
	    }
	  };
	  /**
	   * Set the source on the player element, play, and seek if necessary
	   *
	   * @param {Object} sourceObj An object specifying the source url and mime-type to play
	   * @private
	   */
	
	
	  var setSource = function setSource(sourceObj) {
	    if (sourceObj === null || sourceObj === undefined) {
	      return;
	    }
	
	    seekTo = player.duration() !== Infinity && player.currentTime() || 0;
	    player.one('loadedmetadata', loadedMetadataHandler);
	    player.src(sourceObj);
	    player.trigger({
	      type: 'usage',
	      name: 'vhs-error-reload'
	    });
	    player.trigger({
	      type: 'usage',
	      name: 'hls-error-reload'
	    });
	    player.play();
	  };
	  /**
	   * Attempt to get a source from either the built-in getSource function
	   * or a custom function provided via the options
	   *
	   * @private
	   */
	
	
	  var errorHandler = function errorHandler() {
	    // Do not attempt to reload the source if a source-reload occurred before
	    // 'errorInterval' time has elapsed since the last source-reload
	    if (Date.now() - lastCalled < localOptions.errorInterval * 1000) {
	      player.trigger({
	        type: 'usage',
	        name: 'vhs-error-reload-canceled'
	      });
	      player.trigger({
	        type: 'usage',
	        name: 'hls-error-reload-canceled'
	      });
	      return;
	    }
	
	    if (!localOptions.getSource || typeof localOptions.getSource !== 'function') {
	      videojs.log.error('ERROR: reloadSourceOnError - The option getSource must be a function!');
	      return;
	    }
	
	    lastCalled = Date.now();
	    return localOptions.getSource.call(player, setSource);
	  };
	  /**
	   * Unbind any event handlers that were bound by the plugin
	   *
	   * @private
	   */
	
	
	  var cleanupEvents = function cleanupEvents() {
	    player.off('loadedmetadata', loadedMetadataHandler);
	    player.off('error', errorHandler);
	    player.off('dispose', cleanupEvents);
	  };
	  /**
	   * Cleanup before re-initializing the plugin
	   *
	   * @param {Object} [newOptions] an object with plugin options
	   * @private
	   */
	
	
	  var reinitPlugin = function reinitPlugin(newOptions) {
	    cleanupEvents();
	    initPlugin(player, newOptions);
	  };
	
	  player.on('error', errorHandler);
	  player.on('dispose', cleanupEvents); // Overwrite the plugin function so that we can correctly cleanup before
	  // initializing the plugin
	
	  player.reloadSourceOnError = reinitPlugin;
	};
	/**
	 * Reload the source when an error is detected as long as there
	 * wasn't an error previously within the last 30 seconds
	 *
	 * @param {Object} [options] an object with plugin options
	 */
	
	
	var reloadSourceOnError = function reloadSourceOnError(options) {
	  initPlugin(this, options);
	};
	
	var version$4 = "2.16.3";
	var version$3 = "6.0.1";
	var version$2 = "0.22.1";
	var version$1 = "4.8.0";
	var version = "3.1.3";
	var Vhs = {
	  PlaylistLoader: PlaylistLoader,
	  Playlist: Playlist,
	  utils: utils,
	  STANDARD_PLAYLIST_SELECTOR: lastBandwidthSelector,
	  INITIAL_PLAYLIST_SELECTOR: lowestBitrateCompatibleVariantSelector,
	  lastBandwidthSelector: lastBandwidthSelector,
	  movingAverageBandwidthSelector: movingAverageBandwidthSelector,
	  comparePlaylistBandwidth: comparePlaylistBandwidth,
	  comparePlaylistResolution: comparePlaylistResolution,
	  xhr: xhrFactory()
	}; // Define getter/setters for config properties
	
	Object.keys(Config).forEach(function (prop) {
	  Object.defineProperty(Vhs, prop, {
	    get: function get() {
	      videojs.log.warn("using Vhs." + prop + " is UNSAFE be sure you know what you are doing");
	      return Config[prop];
	    },
	    set: function set(value) {
	      videojs.log.warn("using Vhs." + prop + " is UNSAFE be sure you know what you are doing");
	
	      if (typeof value !== 'number' || value < 0) {
	        videojs.log.warn("value of Vhs." + prop + " must be greater than or equal to 0");
	        return;
	      }
	
	      Config[prop] = value;
	    }
	  });
	});
	var LOCAL_STORAGE_KEY = 'videojs-vhs';
	/**
	 * Updates the selectedIndex of the QualityLevelList when a mediachange happens in vhs.
	 *
	 * @param {QualityLevelList} qualityLevels The QualityLevelList to update.
	 * @param {PlaylistLoader} playlistLoader PlaylistLoader containing the new media info.
	 * @function handleVhsMediaChange
	 */
	
	var handleVhsMediaChange = function handleVhsMediaChange(qualityLevels, playlistLoader) {
	  var newPlaylist = playlistLoader.media();
	  var selectedIndex = -1;
	
	  for (var i = 0; i < qualityLevels.length; i++) {
	    if (qualityLevels[i].id === newPlaylist.id) {
	      selectedIndex = i;
	      break;
	    }
	  }
	
	  qualityLevels.selectedIndex_ = selectedIndex;
	  qualityLevels.trigger({
	    selectedIndex: selectedIndex,
	    type: 'change'
	  });
	};
	/**
	 * Adds quality levels to list once playlist metadata is available
	 *
	 * @param {QualityLevelList} qualityLevels The QualityLevelList to attach events to.
	 * @param {Object} vhs Vhs object to listen to for media events.
	 * @function handleVhsLoadedMetadata
	 */
	
	
	var handleVhsLoadedMetadata = function handleVhsLoadedMetadata(qualityLevels, vhs) {
	  vhs.representations().forEach(function (rep) {
	    qualityLevels.addQualityLevel(rep);
	  });
	  handleVhsMediaChange(qualityLevels, vhs.playlists);
	}; // HLS is a source handler, not a tech. Make sure attempts to use it
	// as one do not cause exceptions.
	
	
	Vhs.canPlaySource = function () {
	  return videojs.log.warn('HLS is no longer a tech. Please remove it from ' + 'your player\'s techOrder.');
	};
	
	var emeKeySystems = function emeKeySystems(keySystemOptions, mainPlaylist, audioPlaylist) {
	  if (!keySystemOptions) {
	    return keySystemOptions;
	  }
	
	  var codecs = {};
	
	  if (mainPlaylist && mainPlaylist.attributes && mainPlaylist.attributes.CODECS) {
	    codecs = unwrapCodecList(codecs_js.parseCodecs(mainPlaylist.attributes.CODECS));
	  }
	
	  if (audioPlaylist && audioPlaylist.attributes && audioPlaylist.attributes.CODECS) {
	    codecs.audio = audioPlaylist.attributes.CODECS;
	  }
	
	  var videoContentType = codecs_js.getMimeForCodec(codecs.video);
	  var audioContentType = codecs_js.getMimeForCodec(codecs.audio); // upsert the content types based on the selected playlist
	
	  var keySystemContentTypes = {};
	
	  for (var keySystem in keySystemOptions) {
	    keySystemContentTypes[keySystem] = {};
	
	    if (audioContentType) {
	      keySystemContentTypes[keySystem].audioContentType = audioContentType;
	    }
	
	    if (videoContentType) {
	      keySystemContentTypes[keySystem].videoContentType = videoContentType;
	    } // Default to using the video playlist's PSSH even though they may be different, as
	    // videojs-contrib-eme will only accept one in the options.
	    //
	    // This shouldn't be an issue for most cases as early intialization will handle all
	    // unique PSSH values, and if they aren't, then encrypted events should have the
	    // specific information needed for the unique license.
	
	
	    if (mainPlaylist.contentProtection && mainPlaylist.contentProtection[keySystem] && mainPlaylist.contentProtection[keySystem].pssh) {
	      keySystemContentTypes[keySystem].pssh = mainPlaylist.contentProtection[keySystem].pssh;
	    } // videojs-contrib-eme accepts the option of specifying: 'com.some.cdm': 'url'
	    // so we need to prevent overwriting the URL entirely
	
	
	    if (typeof keySystemOptions[keySystem] === 'string') {
	      keySystemContentTypes[keySystem].url = keySystemOptions[keySystem];
	    }
	  }
	
	  return videojs.mergeOptions(keySystemOptions, keySystemContentTypes);
	};
	/**
	 * @typedef {Object} KeySystems
	 *
	 * keySystems configuration for https://github.com/videojs/videojs-contrib-eme
	 * Note: not all options are listed here.
	 *
	 * @property {Uint8Array} [pssh]
	 *           Protection System Specific Header
	 */
	
	/**
	 * Goes through all the playlists and collects an array of KeySystems options objects
	 * containing each playlist's keySystems and their pssh values, if available.
	 *
	 * @param {Object[]} playlists
	 *        The playlists to look through
	 * @param {string[]} keySystems
	 *        The keySystems to collect pssh values for
	 *
	 * @return {KeySystems[]}
	 *         An array of KeySystems objects containing available key systems and their
	 *         pssh values
	 */
	
	
	var getAllPsshKeySystemsOptions = function getAllPsshKeySystemsOptions(playlists, keySystems) {
	  return playlists.reduce(function (keySystemsArr, playlist) {
	    if (!playlist.contentProtection) {
	      return keySystemsArr;
	    }
	
	    var keySystemsOptions = keySystems.reduce(function (keySystemsObj, keySystem) {
	      var keySystemOptions = playlist.contentProtection[keySystem];
	
	      if (keySystemOptions && keySystemOptions.pssh) {
	        keySystemsObj[keySystem] = {
	          pssh: keySystemOptions.pssh
	        };
	      }
	
	      return keySystemsObj;
	    }, {});
	
	    if (Object.keys(keySystemsOptions).length) {
	      keySystemsArr.push(keySystemsOptions);
	    }
	
	    return keySystemsArr;
	  }, []);
	};
	/**
	 * Returns a promise that waits for the
	 * [eme plugin](https://github.com/videojs/videojs-contrib-eme) to create a key session.
	 *
	 * Works around https://bugs.chromium.org/p/chromium/issues/detail?id=895449 in non-IE11
	 * browsers.
	 *
	 * As per the above ticket, this is particularly important for Chrome, where, if
	 * unencrypted content is appended before encrypted content and the key session has not
	 * been created, a MEDIA_ERR_DECODE will be thrown once the encrypted content is reached
	 * during playback.
	 *
	 * @param {Object} player
	 *        The player instance
	 * @param {Object[]} sourceKeySystems
	 *        The key systems options from the player source
	 * @param {Object} [audioMedia]
	 *        The active audio media playlist (optional)
	 * @param {Object[]} mainPlaylists
	 *        The playlists found on the master playlist object
	 *
	 * @return {Object}
	 *         Promise that resolves when the key session has been created
	 */
	
	
	var waitForKeySessionCreation = function waitForKeySessionCreation(_ref) {
	  var player = _ref.player,
	      sourceKeySystems = _ref.sourceKeySystems,
	      audioMedia = _ref.audioMedia,
	      mainPlaylists = _ref.mainPlaylists;
	
	  if (!player.eme.initializeMediaKeys) {
	    return Promise.resolve();
	  } // TODO should all audio PSSH values be initialized for DRM?
	  //
	  // All unique video rendition pssh values are initialized for DRM, but here only
	  // the initial audio playlist license is initialized. In theory, an encrypted
	  // event should be fired if the user switches to an alternative audio playlist
	  // where a license is required, but this case hasn't yet been tested. In addition, there
	  // may be many alternate audio playlists unlikely to be used (e.g., multiple different
	  // languages).
	
	
	  var playlists = audioMedia ? mainPlaylists.concat([audioMedia]) : mainPlaylists;
	  var keySystemsOptionsArr = getAllPsshKeySystemsOptions(playlists, Object.keys(sourceKeySystems));
	  var initializationFinishedPromises = [];
	  var keySessionCreatedPromises = []; // Since PSSH values are interpreted as initData, EME will dedupe any duplicates. The
	  // only place where it should not be deduped is for ms-prefixed APIs, but the early
	  // return for IE11 above, and the existence of modern EME APIs in addition to
	  // ms-prefixed APIs on Edge should prevent this from being a concern.
	  // initializeMediaKeys also won't use the webkit-prefixed APIs.
	
	  keySystemsOptionsArr.forEach(function (keySystemsOptions) {
	    keySessionCreatedPromises.push(new Promise(function (resolve, reject) {
	      player.tech_.one('keysessioncreated', resolve);
	    }));
	    initializationFinishedPromises.push(new Promise(function (resolve, reject) {
	      player.eme.initializeMediaKeys({
	        keySystems: keySystemsOptions
	      }, function (err) {
	        if (err) {
	          reject(err);
	          return;
	        }
	
	        resolve();
	      });
	    }));
	  }); // The reasons Promise.race is chosen over Promise.any:
	  //
	  // * Promise.any is only available in Safari 14+.
	  // * None of these promises are expected to reject. If they do reject, it might be
	  //   better here for the race to surface the rejection, rather than mask it by using
	  //   Promise.any.
	
	  return Promise.race([// If a session was previously created, these will all finish resolving without
	  // creating a new session, otherwise it will take until the end of all license
	  // requests, which is why the key session check is used (to make setup much faster).
	  Promise.all(initializationFinishedPromises), // Once a single session is created, the browser knows DRM will be used.
	  Promise.race(keySessionCreatedPromises)]);
	};
	/**
	 * If the [eme](https://github.com/videojs/videojs-contrib-eme) plugin is available, and
	 * there are keySystems on the source, sets up source options to prepare the source for
	 * eme.
	 *
	 * @param {Object} player
	 *        The player instance
	 * @param {Object[]} sourceKeySystems
	 *        The key systems options from the player source
	 * @param {Object} media
	 *        The active media playlist
	 * @param {Object} [audioMedia]
	 *        The active audio media playlist (optional)
	 *
	 * @return {boolean}
	 *         Whether or not options were configured and EME is available
	 */
	
	
	var setupEmeOptions = function setupEmeOptions(_ref2) {
	  var player = _ref2.player,
	      sourceKeySystems = _ref2.sourceKeySystems,
	      media = _ref2.media,
	      audioMedia = _ref2.audioMedia;
	  var sourceOptions = emeKeySystems(sourceKeySystems, media, audioMedia);
	
	  if (!sourceOptions) {
	    return false;
	  }
	
	  player.currentSource().keySystems = sourceOptions; // eme handles the rest of the setup, so if it is missing
	  // do nothing.
	
	  if (sourceOptions && !player.eme) {
	    videojs.log.warn('DRM encrypted source cannot be decrypted without a DRM plugin');
	    return false;
	  }
	
	  return true;
	};
	
	var getVhsLocalStorage = function getVhsLocalStorage() {
	  if (!window__default['default'].localStorage) {
	    return null;
	  }
	
	  var storedObject = window__default['default'].localStorage.getItem(LOCAL_STORAGE_KEY);
	
	  if (!storedObject) {
	    return null;
	  }
	
	  try {
	    return JSON.parse(storedObject);
	  } catch (e) {
	    // someone may have tampered with the value
	    return null;
	  }
	};
	
	var updateVhsLocalStorage = function updateVhsLocalStorage(options) {
	  if (!window__default['default'].localStorage) {
	    return false;
	  }
	
	  var objectToStore = getVhsLocalStorage();
	  objectToStore = objectToStore ? videojs.mergeOptions(objectToStore, options) : options;
	
	  try {
	    window__default['default'].localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(objectToStore));
	  } catch (e) {
	    // Throws if storage is full (e.g., always on iOS 5+ Safari private mode, where
	    // storage is set to 0).
	    // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem#Exceptions
	    // No need to perform any operation.
	    return false;
	  }
	
	  return objectToStore;
	};
	/**
	 * Parses VHS-supported media types from data URIs. See
	 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
	 * for information on data URIs.
	 *
	 * @param {string} dataUri
	 *        The data URI
	 *
	 * @return {string|Object}
	 *         The parsed object/string, or the original string if no supported media type
	 *         was found
	 */
	
	
	var expandDataUri = function expandDataUri(dataUri) {
	  if (dataUri.toLowerCase().indexOf('data:application/vnd.videojs.vhs+json,') === 0) {
	    return JSON.parse(dataUri.substring(dataUri.indexOf(',') + 1));
	  } // no known case for this data URI, return the string as-is
	
	
	  return dataUri;
	};
	/**
	 * Whether the browser has built-in HLS support.
	 */
	
	
	Vhs.supportsNativeHls = function () {
	  if (!document__default['default'] || !document__default['default'].createElement) {
	    return false;
	  }
	
	  var video = document__default['default'].createElement('video'); // native HLS is definitely not supported if HTML5 video isn't
	
	  if (!videojs.getTech('Html5').isSupported()) {
	    return false;
	  } // HLS manifests can go by many mime-types
	
	
	  var canPlay = [// Apple santioned
	  'application/vnd.apple.mpegurl', // Apple sanctioned for backwards compatibility
	  'audio/mpegurl', // Very common
	  'audio/x-mpegurl', // Very common
	  'application/x-mpegurl', // Included for completeness
	  'video/x-mpegurl', 'video/mpegurl', 'application/mpegurl'];
	  return canPlay.some(function (canItPlay) {
	    return /maybe|probably/i.test(video.canPlayType(canItPlay));
	  });
	}();
	
	Vhs.supportsNativeDash = function () {
	  if (!document__default['default'] || !document__default['default'].createElement || !videojs.getTech('Html5').isSupported()) {
	    return false;
	  }
	
	  return /maybe|probably/i.test(document__default['default'].createElement('video').canPlayType('application/dash+xml'));
	}();
	
	Vhs.supportsTypeNatively = function (type) {
	  if (type === 'hls') {
	    return Vhs.supportsNativeHls;
	  }
	
	  if (type === 'dash') {
	    return Vhs.supportsNativeDash;
	  }
	
	  return false;
	};
	/**
	 * HLS is a source handler, not a tech. Make sure attempts to use it
	 * as one do not cause exceptions.
	 */
	
	
	Vhs.isSupported = function () {
	  return videojs.log.warn('HLS is no longer a tech. Please remove it from ' + 'your player\'s techOrder.');
	};
	
	var Component = videojs.getComponent('Component');
	/**
	 * The Vhs Handler object, where we orchestrate all of the parts
	 * of HLS to interact with video.js
	 *
	 * @class VhsHandler
	 * @extends videojs.Component
	 * @param {Object} source the soruce object
	 * @param {Tech} tech the parent tech object
	 * @param {Object} options optional and required options
	 */
	
	var VhsHandler = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VhsHandler, _Component);
	
	  function VhsHandler(source, tech, options) {
	    var _this;
	
	    _this = _Component.call(this, tech, videojs.mergeOptions(options.hls, options.vhs)) || this;
	
	    if (options.hls && Object.keys(options.hls).length) {
	      videojs.log.warn('Using hls options is deprecated. Please rename `hls` to `vhs` in your options object.');
	    } // if a tech level `initialBandwidth` option was passed
	    // use that over the VHS level `bandwidth` option
	
	
	    if (typeof options.initialBandwidth === 'number') {
	      _this.options_.bandwidth = options.initialBandwidth;
	    }
	
	    _this.logger_ = logger('VhsHandler'); // tech.player() is deprecated but setup a reference to HLS for
	    // backwards-compatibility
	
	    if (tech.options_ && tech.options_.playerId) {
	      var _player = videojs(tech.options_.playerId);
	
	      if (!_player.hasOwnProperty('hls')) {
	        Object.defineProperty(_player, 'hls', {
	          get: function get() {
	            videojs.log.warn('player.hls is deprecated. Use player.tech().vhs instead.');
	            tech.trigger({
	              type: 'usage',
	              name: 'hls-player-access'
	            });
	            return _assertThisInitialized__default['default'](_this);
	          },
	          configurable: true
	        });
	      }
	
	      if (!_player.hasOwnProperty('vhs')) {
	        Object.defineProperty(_player, 'vhs', {
	          get: function get() {
	            videojs.log.warn('player.vhs is deprecated. Use player.tech().vhs instead.');
	            tech.trigger({
	              type: 'usage',
	              name: 'vhs-player-access'
	            });
	            return _assertThisInitialized__default['default'](_this);
	          },
	          configurable: true
	        });
	      }
	
	      if (!_player.hasOwnProperty('dash')) {
	        Object.defineProperty(_player, 'dash', {
	          get: function get() {
	            videojs.log.warn('player.dash is deprecated. Use player.tech().vhs instead.');
	            return _assertThisInitialized__default['default'](_this);
	          },
	          configurable: true
	        });
	      }
	
	      _this.player_ = _player;
	    }
	
	    _this.tech_ = tech;
	    _this.source_ = source;
	    _this.stats = {};
	    _this.ignoreNextSeekingEvent_ = false;
	
	    _this.setOptions_();
	
	    if (_this.options_.overrideNative && tech.overrideNativeAudioTracks && tech.overrideNativeVideoTracks) {
	      tech.overrideNativeAudioTracks(true);
	      tech.overrideNativeVideoTracks(true);
	    } else if (_this.options_.overrideNative && (tech.featuresNativeVideoTracks || tech.featuresNativeAudioTracks)) {
	      // overriding native HLS only works if audio tracks have been emulated
	      // error early if we're misconfigured
	      throw new Error('Overriding native HLS requires emulated tracks. ' + 'See https://git.io/vMpjB');
	    } // listen for fullscreenchange events for this player so that we
	    // can adjust our quality selection quickly
	
	
	    _this.on(document__default['default'], ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'], function (event) {
	      var fullscreenElement = document__default['default'].fullscreenElement || document__default['default'].webkitFullscreenElement || document__default['default'].mozFullScreenElement || document__default['default'].msFullscreenElement;
	
	      if (fullscreenElement && fullscreenElement.contains(_this.tech_.el())) {
	        _this.masterPlaylistController_.fastQualityChange_();
	      } else {
	        // When leaving fullscreen, since the in page pixel dimensions should be smaller
	        // than full screen, see if there should be a rendition switch down to preserve
	        // bandwidth.
	        _this.masterPlaylistController_.checkABR_();
	      }
	    });
	
	    _this.on(_this.tech_, 'seeking', function () {
	      if (this.ignoreNextSeekingEvent_) {
	        this.ignoreNextSeekingEvent_ = false;
	        return;
	      }
	
	      this.setCurrentTime(this.tech_.currentTime());
	    });
	
	    _this.on(_this.tech_, 'error', function () {
	      // verify that the error was real and we are loaded
	      // enough to have mpc loaded.
	      if (this.tech_.error() && this.masterPlaylistController_) {
	        this.masterPlaylistController_.pauseLoading();
	      }
	    });
	
	    _this.on(_this.tech_, 'play', _this.play);
	
	    return _this;
	  }
	
	  var _proto = VhsHandler.prototype;
	
	  _proto.setOptions_ = function setOptions_() {
	    var _this2 = this; // defaults
	
	
	    this.options_.withCredentials = this.options_.withCredentials || false;
	    this.options_.handleManifestRedirects = this.options_.handleManifestRedirects === false ? false : true;
	    this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions === false ? false : true;
	    this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || false;
	    this.options_.smoothQualityChange = this.options_.smoothQualityChange || false;
	    this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage !== 'undefined' ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || false;
	    this.options_.useNetworkInformationApi = this.options_.useNetworkInformationApi || false;
	    this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || false;
	    this.options_.customTagParsers = this.options_.customTagParsers || [];
	    this.options_.customTagMappers = this.options_.customTagMappers || [];
	    this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || false;
	
	    if (typeof this.options_.blacklistDuration !== 'number') {
	      this.options_.blacklistDuration = 5 * 60;
	    }
	
	    if (typeof this.options_.bandwidth !== 'number') {
	      if (this.options_.useBandwidthFromLocalStorage) {
	        var storedObject = getVhsLocalStorage();
	
	        if (storedObject && storedObject.bandwidth) {
	          this.options_.bandwidth = storedObject.bandwidth;
	          this.tech_.trigger({
	            type: 'usage',
	            name: 'vhs-bandwidth-from-local-storage'
	          });
	          this.tech_.trigger({
	            type: 'usage',
	            name: 'hls-bandwidth-from-local-storage'
	          });
	        }
	
	        if (storedObject && storedObject.throughput) {
	          this.options_.throughput = storedObject.throughput;
	          this.tech_.trigger({
	            type: 'usage',
	            name: 'vhs-throughput-from-local-storage'
	          });
	          this.tech_.trigger({
	            type: 'usage',
	            name: 'hls-throughput-from-local-storage'
	          });
	        }
	      }
	    } // if bandwidth was not set by options or pulled from local storage, start playlist
	    // selection at a reasonable bandwidth
	
	
	    if (typeof this.options_.bandwidth !== 'number') {
	      this.options_.bandwidth = Config.INITIAL_BANDWIDTH;
	    } // If the bandwidth number is unchanged from the initial setting
	    // then this takes precedence over the enableLowInitialPlaylist option
	
	
	    this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === Config.INITIAL_BANDWIDTH; // grab options passed to player.src
	
	    ['withCredentials', 'useDevicePixelRatio', 'limitRenditionByPlayerDimensions', 'bandwidth', 'smoothQualityChange', 'customTagParsers', 'customTagMappers', 'handleManifestRedirects', 'cacheEncryptionKeys', 'playlistSelector', 'initialPlaylistSelector', 'experimentalBufferBasedABR', 'liveRangeSafeTimeDelta', 'experimentalLLHLS', 'useNetworkInformationApi', 'useDtsForTimestampOffset', 'experimentalExactManifestTimings', 'experimentalLeastPixelDiffSelector'].forEach(function (option) {
	      if (typeof _this2.source_[option] !== 'undefined') {
	        _this2.options_[option] = _this2.source_[option];
	      }
	    });
	    this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions;
	    this.useDevicePixelRatio = this.options_.useDevicePixelRatio;
	  }
	  /**
	   * called when player.src gets called, handle a new source
	   *
	   * @param {Object} src the source object to handle
	   */
	  ;
	
	  _proto.src = function src(_src, type) {
	    var _this3 = this; // do nothing if the src is falsey
	
	
	    if (!_src) {
	      return;
	    }
	
	    this.setOptions_(); // add master playlist controller options
	
	    this.options_.src = expandDataUri(this.source_.src);
	    this.options_.tech = this.tech_;
	    this.options_.externVhs = Vhs;
	    this.options_.sourceType = mediaTypes_js.simpleTypeFromSourceType(type); // Whenever we seek internally, we should update the tech
	
	    this.options_.seekTo = function (time) {
	      _this3.tech_.setCurrentTime(time);
	    };
	
	    if (this.options_.smoothQualityChange) {
	      videojs.log.warn('smoothQualityChange is deprecated and will be removed in the next major version');
	    }
	
	    this.masterPlaylistController_ = new MasterPlaylistController(this.options_);
	    var playbackWatcherOptions = videojs.mergeOptions({
	      liveRangeSafeTimeDelta: SAFE_TIME_DELTA
	    }, this.options_, {
	      seekable: function seekable() {
	        return _this3.seekable();
	      },
	      media: function media() {
	        return _this3.masterPlaylistController_.media();
	      },
	      masterPlaylistController: this.masterPlaylistController_
	    });
	    this.playbackWatcher_ = new PlaybackWatcher(playbackWatcherOptions);
	    this.masterPlaylistController_.on('error', function () {
	      var player = videojs.players[_this3.tech_.options_.playerId];
	      var error = _this3.masterPlaylistController_.error;
	
	      if (typeof error === 'object' && !error.code) {
	        error.code = 3;
	      } else if (typeof error === 'string') {
	        error = {
	          message: error,
	          code: 3
	        };
	      }
	
	      player.error(error);
	    });
	    var defaultSelector = this.options_.experimentalBufferBasedABR ? Vhs.movingAverageBandwidthSelector(0.55) : Vhs.STANDARD_PLAYLIST_SELECTOR; // `this` in selectPlaylist should be the VhsHandler for backwards
	    // compatibility with < v2
	
	    this.masterPlaylistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : defaultSelector.bind(this);
	    this.masterPlaylistController_.selectInitialPlaylist = Vhs.INITIAL_PLAYLIST_SELECTOR.bind(this); // re-expose some internal objects for backwards compatibility with < v2
	
	    this.playlists = this.masterPlaylistController_.masterPlaylistLoader_;
	    this.mediaSource = this.masterPlaylistController_.mediaSource; // Proxy assignment of some properties to the master playlist
	    // controller. Using a custom property for backwards compatibility
	    // with < v2
	
	    Object.defineProperties(this, {
	      selectPlaylist: {
	        get: function get() {
	          return this.masterPlaylistController_.selectPlaylist;
	        },
	        set: function set(selectPlaylist) {
	          this.masterPlaylistController_.selectPlaylist = selectPlaylist.bind(this);
	        }
	      },
	      throughput: {
	        get: function get() {
	          return this.masterPlaylistController_.mainSegmentLoader_.throughput.rate;
	        },
	        set: function set(throughput) {
	          this.masterPlaylistController_.mainSegmentLoader_.throughput.rate = throughput; // By setting `count` to 1 the throughput value becomes the starting value
	          // for the cumulative average
	
	          this.masterPlaylistController_.mainSegmentLoader_.throughput.count = 1;
	        }
	      },
	      bandwidth: {
	        get: function get() {
	          var playerBandwidthEst = this.masterPlaylistController_.mainSegmentLoader_.bandwidth;
	          var networkInformation = window__default['default'].navigator.connection || window__default['default'].navigator.mozConnection || window__default['default'].navigator.webkitConnection;
	          var tenMbpsAsBitsPerSecond = 10e6;
	
	          if (this.options_.useNetworkInformationApi && networkInformation) {
	            // downlink returns Mbps
	            // https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/downlink
	            var networkInfoBandwidthEstBitsPerSec = networkInformation.downlink * 1000 * 1000; // downlink maxes out at 10 Mbps. In the event that both networkInformationApi and the player
	            // estimate a bandwidth greater than 10 Mbps, use the larger of the two estimates to ensure that
	            // high quality streams are not filtered out.
	
	            if (networkInfoBandwidthEstBitsPerSec >= tenMbpsAsBitsPerSecond && playerBandwidthEst >= tenMbpsAsBitsPerSecond) {
	              playerBandwidthEst = Math.max(playerBandwidthEst, networkInfoBandwidthEstBitsPerSec);
	            } else {
	              playerBandwidthEst = networkInfoBandwidthEstBitsPerSec;
	            }
	          }
	
	          return playerBandwidthEst;
	        },
	        set: function set(bandwidth) {
	          this.masterPlaylistController_.mainSegmentLoader_.bandwidth = bandwidth; // setting the bandwidth manually resets the throughput counter
	          // `count` is set to zero that current value of `rate` isn't included
	          // in the cumulative average
	
	          this.masterPlaylistController_.mainSegmentLoader_.throughput = {
	            rate: 0,
	            count: 0
	          };
	        }
	      },
	
	      /**
	       * `systemBandwidth` is a combination of two serial processes bit-rates. The first
	       * is the network bitrate provided by `bandwidth` and the second is the bitrate of
	       * the entire process after that - decryption, transmuxing, and appending - provided
	       * by `throughput`.
	       *
	       * Since the two process are serial, the overall system bandwidth is given by:
	       *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
	       */
	      systemBandwidth: {
	        get: function get() {
	          var invBandwidth = 1 / (this.bandwidth || 1);
	          var invThroughput;
	
	          if (this.throughput > 0) {
	            invThroughput = 1 / this.throughput;
	          } else {
	            invThroughput = 0;
	          }
	
	          var systemBitrate = Math.floor(1 / (invBandwidth + invThroughput));
	          return systemBitrate;
	        },
	        set: function set() {
	          videojs.log.error('The "systemBandwidth" property is read-only');
	        }
	      }
	    });
	
	    if (this.options_.bandwidth) {
	      this.bandwidth = this.options_.bandwidth;
	    }
	
	    if (this.options_.throughput) {
	      this.throughput = this.options_.throughput;
	    }
	
	    Object.defineProperties(this.stats, {
	      bandwidth: {
	        get: function get() {
	          return _this3.bandwidth || 0;
	        },
	        enumerable: true
	      },
	      mediaRequests: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaRequests_() || 0;
	        },
	        enumerable: true
	      },
	      mediaRequestsAborted: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaRequestsAborted_() || 0;
	        },
	        enumerable: true
	      },
	      mediaRequestsTimedout: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaRequestsTimedout_() || 0;
	        },
	        enumerable: true
	      },
	      mediaRequestsErrored: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaRequestsErrored_() || 0;
	        },
	        enumerable: true
	      },
	      mediaTransferDuration: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaTransferDuration_() || 0;
	        },
	        enumerable: true
	      },
	      mediaBytesTransferred: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaBytesTransferred_() || 0;
	        },
	        enumerable: true
	      },
	      mediaSecondsLoaded: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaSecondsLoaded_() || 0;
	        },
	        enumerable: true
	      },
	      mediaAppends: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaAppends_() || 0;
	        },
	        enumerable: true
	      },
	      mainAppendsToLoadedData: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mainAppendsToLoadedData_() || 0;
	        },
	        enumerable: true
	      },
	      audioAppendsToLoadedData: {
	        get: function get() {
	          return _this3.masterPlaylistController_.audioAppendsToLoadedData_() || 0;
	        },
	        enumerable: true
	      },
	      appendsToLoadedData: {
	        get: function get() {
	          return _this3.masterPlaylistController_.appendsToLoadedData_() || 0;
	        },
	        enumerable: true
	      },
	      timeToLoadedData: {
	        get: function get() {
	          return _this3.masterPlaylistController_.timeToLoadedData_() || 0;
	        },
	        enumerable: true
	      },
	      buffered: {
	        get: function get() {
	          return timeRangesToArray(_this3.tech_.buffered());
	        },
	        enumerable: true
	      },
	      currentTime: {
	        get: function get() {
	          return _this3.tech_.currentTime();
	        },
	        enumerable: true
	      },
	      currentSource: {
	        get: function get() {
	          return _this3.tech_.currentSource_;
	        },
	        enumerable: true
	      },
	      currentTech: {
	        get: function get() {
	          return _this3.tech_.name_;
	        },
	        enumerable: true
	      },
	      duration: {
	        get: function get() {
	          return _this3.tech_.duration();
	        },
	        enumerable: true
	      },
	      master: {
	        get: function get() {
	          return _this3.playlists.master;
	        },
	        enumerable: true
	      },
	      playerDimensions: {
	        get: function get() {
	          return _this3.tech_.currentDimensions();
	        },
	        enumerable: true
	      },
	      seekable: {
	        get: function get() {
	          return timeRangesToArray(_this3.tech_.seekable());
	        },
	        enumerable: true
	      },
	      timestamp: {
	        get: function get() {
	          return Date.now();
	        },
	        enumerable: true
	      },
	      videoPlaybackQuality: {
	        get: function get() {
	          return _this3.tech_.getVideoPlaybackQuality();
	        },
	        enumerable: true
	      }
	    });
	    this.tech_.one('canplay', this.masterPlaylistController_.setupFirstPlay.bind(this.masterPlaylistController_));
	    this.tech_.on('bandwidthupdate', function () {
	      if (_this3.options_.useBandwidthFromLocalStorage) {
	        updateVhsLocalStorage({
	          bandwidth: _this3.bandwidth,
	          throughput: Math.round(_this3.throughput)
	        });
	      }
	    });
	    this.masterPlaylistController_.on('selectedinitialmedia', function () {
	      // Add the manual rendition mix-in to VhsHandler
	      renditionSelectionMixin(_this3);
	    });
	    this.masterPlaylistController_.sourceUpdater_.on('createdsourcebuffers', function () {
	      _this3.setupEme_();
	    }); // the bandwidth of the primary segment loader is our best
	    // estimate of overall bandwidth
	
	    this.on(this.masterPlaylistController_, 'progress', function () {
	      this.tech_.trigger('progress');
	    }); // In the live case, we need to ignore the very first `seeking` event since
	    // that will be the result of the seek-to-live behavior
	
	    this.on(this.masterPlaylistController_, 'firstplay', function () {
	      this.ignoreNextSeekingEvent_ = true;
	    });
	    this.setupQualityLevels_(); // do nothing if the tech has been disposed already
	    // this can occur if someone sets the src in player.ready(), for instance
	
	    if (!this.tech_.el()) {
	      return;
	    }
	
	    this.mediaSourceUrl_ = window__default['default'].URL.createObjectURL(this.masterPlaylistController_.mediaSource);
	    this.tech_.src(this.mediaSourceUrl_);
	  };
	
	  _proto.createKeySessions_ = function createKeySessions_() {
	    var _this4 = this;
	
	    var audioPlaylistLoader = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;
	    this.logger_('waiting for EME key session creation');
	    waitForKeySessionCreation({
	      player: this.player_,
	      sourceKeySystems: this.source_.keySystems,
	      audioMedia: audioPlaylistLoader && audioPlaylistLoader.media(),
	      mainPlaylists: this.playlists.master.playlists
	    }).then(function () {
	      _this4.logger_('created EME key session');
	
	      _this4.masterPlaylistController_.sourceUpdater_.initializedEme();
	    })["catch"](function (err) {
	      _this4.logger_('error while creating EME key session', err);
	
	      _this4.player_.error({
	        message: 'Failed to initialize media keys for EME',
	        code: 3
	      });
	    });
	  };
	
	  _proto.handleWaitingForKey_ = function handleWaitingForKey_() {
	    // If waitingforkey is fired, it's possible that the data that's necessary to retrieve
	    // the key is in the manifest. While this should've happened on initial source load, it
	    // may happen again in live streams where the keys change, and the manifest info
	    // reflects the update.
	    //
	    // Because videojs-contrib-eme compares the PSSH data we send to that of PSSH data it's
	    // already requested keys for, we don't have to worry about this generating extraneous
	    // requests.
	    this.logger_('waitingforkey fired, attempting to create any new key sessions');
	    this.createKeySessions_();
	  }
	  /**
	   * If necessary and EME is available, sets up EME options and waits for key session
	   * creation.
	   *
	   * This function also updates the source updater so taht it can be used, as for some
	   * browsers, EME must be configured before content is appended (if appending unencrypted
	   * content before encrypted content).
	   */
	  ;
	
	  _proto.setupEme_ = function setupEme_() {
	    var _this5 = this;
	
	    var audioPlaylistLoader = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;
	    var didSetupEmeOptions = setupEmeOptions({
	      player: this.player_,
	      sourceKeySystems: this.source_.keySystems,
	      media: this.playlists.media(),
	      audioMedia: audioPlaylistLoader && audioPlaylistLoader.media()
	    });
	    this.player_.tech_.on('keystatuschange', function (e) {
	      if (e.status !== 'output-restricted') {
	        return;
	      }
	
	      var masterPlaylist = _this5.masterPlaylistController_.master();
	
	      if (!masterPlaylist || !masterPlaylist.playlists) {
	        return;
	      }
	
	      var excludedHDPlaylists = []; // Assume all HD streams are unplayable and exclude them from ABR selection
	
	      masterPlaylist.playlists.forEach(function (playlist) {
	        if (playlist && playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height >= 720) {
	          if (!playlist.excludeUntil || playlist.excludeUntil < Infinity) {
	            playlist.excludeUntil = Infinity;
	            excludedHDPlaylists.push(playlist);
	          }
	        }
	      });
	
	      if (excludedHDPlaylists.length) {
	        var _videojs$log;
	
	        (_videojs$log = videojs.log).warn.apply(_videojs$log, ['DRM keystatus changed to "output-restricted." Removing the following HD playlists ' + 'that will most likely fail to play and clearing the buffer. ' + 'This may be due to HDCP restrictions on the stream and the capabilities of the current device.'].concat(excludedHDPlaylists)); // Clear the buffer before switching playlists, since it may already contain unplayable segments
	
	
	        _this5.masterPlaylistController_.fastQualityChange_();
	      }
	    });
	    this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this);
	    this.player_.tech_.on('waitingforkey', this.handleWaitingForKey_); // In IE11 this is too early to initialize media keys, and IE11 does not support
	    // promises.
	
	    if (videojs.browser.IE_VERSION === 11 || !didSetupEmeOptions) {
	      // If EME options were not set up, we've done all we could to initialize EME.
	      this.masterPlaylistController_.sourceUpdater_.initializedEme();
	      return;
	    }
	
	    this.createKeySessions_();
	  }
	  /**
	   * Initializes the quality levels and sets listeners to update them.
	   *
	   * @method setupQualityLevels_
	   * @private
	   */
	  ;
	
	  _proto.setupQualityLevels_ = function setupQualityLevels_() {
	    var _this6 = this;
	
	    var player = videojs.players[this.tech_.options_.playerId]; // if there isn't a player or there isn't a qualityLevels plugin
	    // or qualityLevels_ listeners have already been setup, do nothing.
	
	    if (!player || !player.qualityLevels || this.qualityLevels_) {
	      return;
	    }
	
	    this.qualityLevels_ = player.qualityLevels();
	    this.masterPlaylistController_.on('selectedinitialmedia', function () {
	      handleVhsLoadedMetadata(_this6.qualityLevels_, _this6);
	    });
	    this.playlists.on('mediachange', function () {
	      handleVhsMediaChange(_this6.qualityLevels_, _this6.playlists);
	    });
	  }
	  /**
	   * return the version
	   */
	  ;
	
	  VhsHandler.version = function version$5() {
	    return {
	      '@videojs/http-streaming': version$4,
	      'mux.js': version$3,
	      'mpd-parser': version$2,
	      'm3u8-parser': version$1,
	      'aes-decrypter': version
	    };
	  }
	  /**
	   * return the version
	   */
	  ;
	
	  _proto.version = function version() {
	    return this.constructor.version();
	  };
	
	  _proto.canChangeType = function canChangeType() {
	    return SourceUpdater.canChangeType();
	  }
	  /**
	   * Begin playing the video.
	   */
	  ;
	
	  _proto.play = function play() {
	    this.masterPlaylistController_.play();
	  }
	  /**
	   * a wrapper around the function in MasterPlaylistController
	   */
	  ;
	
	  _proto.setCurrentTime = function setCurrentTime(currentTime) {
	    this.masterPlaylistController_.setCurrentTime(currentTime);
	  }
	  /**
	   * a wrapper around the function in MasterPlaylistController
	   */
	  ;
	
	  _proto.duration = function duration() {
	    return this.masterPlaylistController_.duration();
	  }
	  /**
	   * a wrapper around the function in MasterPlaylistController
	   */
	  ;
	
	  _proto.seekable = function seekable() {
	    return this.masterPlaylistController_.seekable();
	  }
	  /**
	   * Abort all outstanding work and cleanup.
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    if (this.playbackWatcher_) {
	      this.playbackWatcher_.dispose();
	    }
	
	    if (this.masterPlaylistController_) {
	      this.masterPlaylistController_.dispose();
	    }
	
	    if (this.qualityLevels_) {
	      this.qualityLevels_.dispose();
	    }
	
	    if (this.player_) {
	      delete this.player_.vhs;
	      delete this.player_.dash;
	      delete this.player_.hls;
	    }
	
	    if (this.tech_ && this.tech_.vhs) {
	      delete this.tech_.vhs;
	    } // don't check this.tech_.hls as it will log a deprecated warning
	
	
	    if (this.tech_) {
	      delete this.tech_.hls;
	    }
	
	    if (this.mediaSourceUrl_ && window__default['default'].URL.revokeObjectURL) {
	      window__default['default'].URL.revokeObjectURL(this.mediaSourceUrl_);
	      this.mediaSourceUrl_ = null;
	    }
	
	    if (this.tech_) {
	      this.tech_.off('waitingforkey', this.handleWaitingForKey_);
	    }
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  _proto.convertToProgramTime = function convertToProgramTime(time, callback) {
	    return getProgramTime({
	      playlist: this.masterPlaylistController_.media(),
	      time: time,
	      callback: callback
	    });
	  } // the player must be playing before calling this
	  ;
	
	  _proto.seekToProgramTime = function seekToProgramTime$1(programTime, callback, pauseAfterSeek, retryCount) {
	    if (pauseAfterSeek === void 0) {
	      pauseAfterSeek = true;
	    }
	
	    if (retryCount === void 0) {
	      retryCount = 2;
	    }
	
	    return seekToProgramTime({
	      programTime: programTime,
	      playlist: this.masterPlaylistController_.media(),
	      retryCount: retryCount,
	      pauseAfterSeek: pauseAfterSeek,
	      seekTo: this.options_.seekTo,
	      tech: this.options_.tech,
	      callback: callback
	    });
	  };
	
	  return VhsHandler;
	}(Component);
	/**
	 * The Source Handler object, which informs video.js what additional
	 * MIME types are supported and sets up playback. It is registered
	 * automatically to the appropriate tech based on the capabilities of
	 * the browser it is running in. It is not necessary to use or modify
	 * this object in normal usage.
	 */
	
	
	var VhsSourceHandler = {
	  name: 'videojs-http-streaming',
	  VERSION: version$4,
	  canHandleSource: function canHandleSource(srcObj, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var localOptions = videojs.mergeOptions(videojs.options, options);
	    return VhsSourceHandler.canPlayType(srcObj.type, localOptions);
	  },
	  handleSource: function handleSource(source, tech, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var localOptions = videojs.mergeOptions(videojs.options, options);
	    tech.vhs = new VhsHandler(source, tech, localOptions);
	
	    if (!videojs.hasOwnProperty('hls')) {
	      Object.defineProperty(tech, 'hls', {
	        get: function get() {
	          videojs.log.warn('player.tech().hls is deprecated. Use player.tech().vhs instead.');
	          return tech.vhs;
	        },
	        configurable: true
	      });
	    }
	
	    tech.vhs.xhr = xhrFactory();
	    tech.vhs.src(source.src, source.type);
	    return tech.vhs;
	  },
	  canPlayType: function canPlayType(type, options) {
	    var simpleType = mediaTypes_js.simpleTypeFromSourceType(type);
	
	    if (!simpleType) {
	      return '';
	    }
	
	    var overrideNative = VhsSourceHandler.getOverrideNative(options);
	    var supportsTypeNatively = Vhs.supportsTypeNatively(simpleType);
	    var canUseMsePlayback = !supportsTypeNatively || overrideNative;
	    return canUseMsePlayback ? 'maybe' : '';
	  },
	  getOverrideNative: function getOverrideNative(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var _options = options,
	        _options$vhs = _options.vhs,
	        vhs = _options$vhs === void 0 ? {} : _options$vhs,
	        _options$hls = _options.hls,
	        hls = _options$hls === void 0 ? {} : _options$hls;
	    var defaultOverrideNative = !(videojs.browser.IS_ANY_SAFARI || videojs.browser.IS_IOS);
	    var _vhs$overrideNative = vhs.overrideNative,
	        overrideNative = _vhs$overrideNative === void 0 ? defaultOverrideNative : _vhs$overrideNative;
	    var _hls$overrideNative = hls.overrideNative,
	        legacyOverrideNative = _hls$overrideNative === void 0 ? false : _hls$overrideNative;
	    return legacyOverrideNative || overrideNative;
	  }
	};
	/**
	 * Check to see if the native MediaSource object exists and supports
	 * an MP4 container with both H.264 video and AAC-LC audio.
	 *
	 * @return {boolean} if  native media sources are supported
	 */
	
	var supportsNativeMediaSources = function supportsNativeMediaSources() {
	  return codecs_js.browserSupportsCodec('avc1.4d400d,mp4a.40.2');
	}; // register source handlers with the appropriate techs
	
	
	if (supportsNativeMediaSources()) {
	  videojs.getTech('Html5').registerSourceHandler(VhsSourceHandler, 0);
	}
	
	videojs.VhsHandler = VhsHandler;
	Object.defineProperty(videojs, 'HlsHandler', {
	  get: function get() {
	    videojs.log.warn('videojs.HlsHandler is deprecated. Use videojs.VhsHandler instead.');
	    return VhsHandler;
	  },
	  configurable: true
	});
	videojs.VhsSourceHandler = VhsSourceHandler;
	Object.defineProperty(videojs, 'HlsSourceHandler', {
	  get: function get() {
	    videojs.log.warn('videojs.HlsSourceHandler is deprecated. ' + 'Use videojs.VhsSourceHandler instead.');
	    return VhsSourceHandler;
	  },
	  configurable: true
	});
	videojs.Vhs = Vhs;
	Object.defineProperty(videojs, 'Hls', {
	  get: function get() {
	    videojs.log.warn('videojs.Hls is deprecated. Use videojs.Vhs instead.');
	    return Vhs;
	  },
	  configurable: true
	});
	
	if (!videojs.use) {
	  videojs.registerComponent('Hls', Vhs);
	  videojs.registerComponent('Vhs', Vhs);
	}
	
	videojs.options.vhs = videojs.options.vhs || {};
	videojs.options.hls = videojs.options.hls || {};
	
	if (!videojs.getPlugin || !videojs.getPlugin('reloadSourceOnError')) {
	  var registerPlugin = videojs.registerPlugin || videojs.plugin;
	  registerPlugin('reloadSourceOnError', reloadSourceOnError);
	}
	
	module.exports = videojs;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 305 */
[2126, 753],
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(1289)
	var ieee754 = __webpack_require__(1336)
	var customInspectSymbol =
	  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
	    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
	    : null
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	var K_MAX_LENGTH = 0x7fffffff
	exports.kMaxLength = K_MAX_LENGTH
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
	 *               implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * We report that the browser does not support typed arrays if the are not subclassable
	 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
	 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
	 * for __proto__ and has a buggy typed array implementation.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()
	
	if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
	    typeof console.error === 'function') {
	  console.error(
	    'This browser lacks typed array (Uint8Array) support which is required by ' +
	    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
	  )
	}
	
	function typedArraySupport () {
	  // Can typed array instances can be augmented?
	  try {
	    var arr = new Uint8Array(1)
	    var proto = { foo: function () { return 42 } }
	    Object.setPrototypeOf(proto, Uint8Array.prototype)
	    Object.setPrototypeOf(arr, proto)
	    return arr.foo() === 42
	  } catch (e) {
	    return false
	  }
	}
	
	Object.defineProperty(Buffer.prototype, 'parent', {
	  enumerable: true,
	  get: function () {
	    if (!Buffer.isBuffer(this)) return undefined
	    return this.buffer
	  }
	})
	
	Object.defineProperty(Buffer.prototype, 'offset', {
	  enumerable: true,
	  get: function () {
	    if (!Buffer.isBuffer(this)) return undefined
	    return this.byteOffset
	  }
	})
	
	function createBuffer (length) {
	  if (length > K_MAX_LENGTH) {
	    throw new RangeError('The value "' + length + '" is invalid for option "size"')
	  }
	  // Return an augmented `Uint8Array` instance
	  var buf = new Uint8Array(length)
	  Object.setPrototypeOf(buf, Buffer.prototype)
	  return buf
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new TypeError(
	        'The "string" argument must be of type string. Received type number'
	      )
	    }
	    return allocUnsafe(arg)
	  }
	  return from(arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	function from (value, encodingOrOffset, length) {
	  if (typeof value === 'string') {
	    return fromString(value, encodingOrOffset)
	  }
	
	  if (ArrayBuffer.isView(value)) {
	    return fromArrayView(value)
	  }
	
	  if (value == null) {
	    throw new TypeError(
	      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
	      'or Array-like Object. Received type ' + (typeof value)
	    )
	  }
	
	  if (isInstance(value, ArrayBuffer) ||
	      (value && isInstance(value.buffer, ArrayBuffer))) {
	    return fromArrayBuffer(value, encodingOrOffset, length)
	  }
	
	  if (typeof SharedArrayBuffer !== 'undefined' &&
	      (isInstance(value, SharedArrayBuffer) ||
	      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
	    return fromArrayBuffer(value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'number') {
	    throw new TypeError(
	      'The "value" argument must not be of type number. Received type number'
	    )
	  }
	
	  var valueOf = value.valueOf && value.valueOf()
	  if (valueOf != null && valueOf !== value) {
	    return Buffer.from(valueOf, encodingOrOffset, length)
	  }
	
	  var b = fromObject(value)
	  if (b) return b
	
	  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
	      typeof value[Symbol.toPrimitive] === 'function') {
	    return Buffer.from(
	      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
	    )
	  }
	
	  throw new TypeError(
	    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
	    'or Array-like Object. Received type ' + (typeof value)
	  )
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(value, encodingOrOffset, length)
	}
	
	// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
	// https://github.com/feross/buffer/pull/148
	Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
	Object.setPrototypeOf(Buffer, Uint8Array)
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be of type number')
	  } else if (size < 0) {
	    throw new RangeError('The value "' + size + '" is invalid for option "size"')
	  }
	}
	
	function alloc (size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpreted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(size).fill(fill, encoding)
	      : createBuffer(size).fill(fill)
	  }
	  return createBuffer(size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(size, fill, encoding)
	}
	
	function allocUnsafe (size) {
	  assertSize(size)
	  return createBuffer(size < 0 ? 0 : checked(size) | 0)
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(size)
	}
	
	function fromString (string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('Unknown encoding: ' + encoding)
	  }
	
	  var length = byteLength(string, encoding) | 0
	  var buf = createBuffer(length)
	
	  var actual = buf.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    buf = buf.slice(0, actual)
	  }
	
	  return buf
	}
	
	function fromArrayLike (array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  var buf = createBuffer(length)
	  for (var i = 0; i < length; i += 1) {
	    buf[i] = array[i] & 255
	  }
	  return buf
	}
	
	function fromArrayView (arrayView) {
	  if (isInstance(arrayView, Uint8Array)) {
	    var copy = new Uint8Array(arrayView)
	    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
	  }
	  return fromArrayLike(arrayView)
	}
	
	function fromArrayBuffer (array, byteOffset, length) {
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('"offset" is outside of buffer bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('"length" is outside of buffer bounds')
	  }
	
	  var buf
	  if (byteOffset === undefined && length === undefined) {
	    buf = new Uint8Array(array)
	  } else if (length === undefined) {
	    buf = new Uint8Array(array, byteOffset)
	  } else {
	    buf = new Uint8Array(array, byteOffset, length)
	  }
	
	  // Return an augmented `Uint8Array` instance
	  Object.setPrototypeOf(buf, Buffer.prototype)
	
	  return buf
	}
	
	function fromObject (obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    var buf = createBuffer(len)
	
	    if (buf.length === 0) {
	      return buf
	    }
	
	    obj.copy(buf, 0, 0, len)
	    return buf
	  }
	
	  if (obj.length !== undefined) {
	    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
	      return createBuffer(0)
	    }
	    return fromArrayLike(obj)
	  }
	
	  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
	    return fromArrayLike(obj.data)
	  }
	}
	
	function checked (length) {
	  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= K_MAX_LENGTH) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return b != null && b._isBuffer === true &&
	    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
	}
	
	Buffer.compare = function compare (a, b) {
	  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
	  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError(
	      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
	    )
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!Array.isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (isInstance(buf, Uint8Array)) {
	      if (pos + buf.length > buffer.length) {
	        Buffer.from(buf).copy(buffer, pos)
	      } else {
	        Uint8Array.prototype.set.call(
	          buffer,
	          buf,
	          pos
	        )
	      }
	    } else if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    } else {
	      buf.copy(buffer, pos)
	    }
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    throw new TypeError(
	      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
	      'Received type ' + typeof string
	    )
	  }
	
	  var len = string.length
	  var mustMatch = (arguments.length > 2 && arguments[2] === true)
	  if (!mustMatch && len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) {
	          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
	        }
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
	// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
	// reliably in a browserify context because there could be multiple different
	// copies of the 'buffer' package in use. This method works even for Buffer
	// instances that were created from another copy of the `buffer` package.
	// See: https://github.com/feross/buffer/issues/154
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.toLocaleString = Buffer.prototype.toString
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
	  if (this.length > max) str += ' ... '
	  return '<Buffer ' + str + '>'
	}
	if (customInspectSymbol) {
	  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (isInstance(target, Uint8Array)) {
	    target = Buffer.from(target, target.offset, target.byteLength)
	  }
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError(
	      'The "target" argument must be one of type Buffer or Uint8Array. ' +
	      'Received type ' + (typeof target)
	    )
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset // Coerce to Number.
	  if (numberIsNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  var strLen = string.length
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (numberIsNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset >>> 0
	    if (isFinite(length)) {
	      length = length >>> 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return asciiWrite(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF)
	      ? 4
	      : (firstByte > 0xDF)
	          ? 3
	          : (firstByte > 0xBF)
	              ? 2
	              : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += hexSliceLookupTable[buf[i]]
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
	  for (var i = 0; i < bytes.length - 1; i += 2) {
	    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf = this.subarray(start, end)
	  // Return an augmented `Uint8Array` instance
	  Object.setPrototypeOf(newBuf, Buffer.prototype)
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUintLE =
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUintBE =
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUint8 =
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUint16LE =
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUint16BE =
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUint32LE =
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUint32BE =
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  offset = offset >>> 0
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUintLE =
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUintBE =
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  byteLength = byteLength >>> 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUint8 =
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeUint16LE =
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  return offset + 2
	}
	
	Buffer.prototype.writeUint16BE =
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  this[offset] = (value >>> 8)
	  this[offset + 1] = (value & 0xff)
	  return offset + 2
	}
	
	Buffer.prototype.writeUint32LE =
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  this[offset + 3] = (value >>> 24)
	  this[offset + 2] = (value >>> 16)
	  this[offset + 1] = (value >>> 8)
	  this[offset] = (value & 0xff)
	  return offset + 4
	}
	
	Buffer.prototype.writeUint32BE =
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  this[offset] = (value >>> 24)
	  this[offset + 1] = (value >>> 16)
	  this[offset + 2] = (value >>> 8)
	  this[offset + 3] = (value & 0xff)
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    var limit = Math.pow(2, (8 * byteLength) - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    var limit = Math.pow(2, (8 * byteLength) - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  this[offset] = (value >>> 8)
	  this[offset + 1] = (value & 0xff)
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  this[offset] = (value & 0xff)
	  this[offset + 1] = (value >>> 8)
	  this[offset + 2] = (value >>> 16)
	  this[offset + 3] = (value >>> 24)
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  this[offset] = (value >>> 24)
	  this[offset + 1] = (value >>> 16)
	  this[offset + 2] = (value >>> 8)
	  this[offset + 3] = (value & 0xff)
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  value = +value
	  offset = offset >>> 0
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	
	  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
	    // Use built-in when available, missing from IE11
	    this.copyWithin(targetStart, start, end)
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, end),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if ((encoding === 'utf8' && code < 128) ||
	          encoding === 'latin1') {
	        // Fast path: If `val` fits into a single byte, use that numeric value.
	        val = code
	      }
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  } else if (typeof val === 'boolean') {
	    val = Number(val)
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : Buffer.from(val, encoding)
	    var len = bytes.length
	    if (len === 0) {
	      throw new TypeError('The value "' + val +
	        '" is invalid for argument "value"')
	    }
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node takes equal signs as end of the Base64 encoding
	  str = str.split('=')[0]
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = str.trim().replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
	// the `instanceof` check but they should be treated as of that type.
	// See: https://github.com/feross/buffer/issues/166
	function isInstance (obj, type) {
	  return obj instanceof type ||
	    (obj != null && obj.constructor != null && obj.constructor.name != null &&
	      obj.constructor.name === type.name)
	}
	function numberIsNaN (obj) {
	  // For IE11 support
	  return obj !== obj // eslint-disable-line no-self-compare
	}
	
	// Create lookup table for `toString('hex')`
	// See: https://github.com/feross/buffer/issues/219
	var hexSliceLookupTable = (function () {
	  var alphabet = '0123456789abcdef'
	  var table = new Array(256)
	  for (var i = 0; i < 16; ++i) {
	    var i16 = i * 16
	    for (var j = 0; j < 16; ++j) {
	      table[i16 + j] = alphabet[i] + alphabet[j]
	    }
	  }
	  return table
	})()
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(810).Buffer))

/***/ },
/* 340 */
[2110, 239],
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(56)
	  , core    = __webpack_require__(469)
	  , fails   = __webpack_require__(239);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	// add fake Function#toString
	// for correct work wrapped methods / constructors with methods like LoDash isNative
	var global    = __webpack_require__(220)
	  , hide      = __webpack_require__(374)
	  , SRC       = __webpack_require__(680)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(469).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  if(typeof val == 'function'){
	    val.hasOwnProperty(SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	    val.hasOwnProperty('name') || hide(val, 'name', key);
	  }
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe)delete O[key];
	    hide(O, key, val);
	  }
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 343 */
[2125, 927, 373],
/* 344 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(932).EventEmitter;
	var inherits = __webpack_require__(406);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(1869);
	Stream.Writable = __webpack_require__(1871);
	Stream.Duplex = __webpack_require__(1867);
	Stream.Transform = __webpack_require__(1870);
	Stream.PassThrough = __webpack_require__(1868);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 346 */,
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var DOM = __webpack_require__(477);
	
	function escapeRegExp(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	
	module.exports = {
	  // those methods are implemented differently
	  // depending on which build it is, using
	  // $... or angular... or Zepto... or require(...)
	  isArray: null,
	  isFunction: null,
	  isObject: null,
	  bind: null,
	  each: null,
	  map: null,
	  mixin: null,
	
	  isMsie: function(agentString) {
	    if (agentString === undefined) { agentString = navigator.userAgent; }
	    // from https://github.com/ded/bowser/blob/master/bowser.js
	    if ((/(msie|trident)/i).test(agentString)) {
	      var match = agentString.match(/(msie |rv:)(\d+(.\d+)?)/i);
	      if (match) { return match[2]; }
	    }
	    return false;
	  },
	
	  // http://stackoverflow.com/a/6969486
	  escapeRegExChars: function(str) {
	    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	  },
	
	  isNumber: function(obj) { return typeof obj === 'number'; },
	
	  toStr: function toStr(s) {
	    return s === undefined || s === null ? '' : s + '';
	  },
	
	  cloneDeep: function cloneDeep(obj) {
	    var clone = this.mixin({}, obj);
	    var self = this;
	    this.each(clone, function(value, key) {
	      if (value) {
	        if (self.isArray(value)) {
	          clone[key] = [].concat(value);
	        } else if (self.isObject(value)) {
	          clone[key] = self.cloneDeep(value);
	        }
	      }
	    });
	    return clone;
	  },
	
	  error: function(msg) {
	    throw new Error(msg);
	  },
	
	  every: function(obj, test) {
	    var result = true;
	    if (!obj) {
	      return result;
	    }
	    this.each(obj, function(val, key) {
	      if (result) {
	        result = test.call(null, val, key, obj) && result;
	      }
	    });
	    return !!result;
	  },
	
	  any: function(obj, test) {
	    var found = false;
	    if (!obj) {
	      return found;
	    }
	    this.each(obj, function(val, key) {
	      if (test.call(null, val, key, obj)) {
	        found = true;
	        return false;
	      }
	    });
	    return found;
	  },
	
	  getUniqueId: (function() {
	    var counter = 0;
	    return function() { return counter++; };
	  })(),
	
	  templatify: function templatify(obj) {
	    if (this.isFunction(obj)) {
	      return obj;
	    }
	    var $template = DOM.element(obj);
	    if ($template.prop('tagName') === 'SCRIPT') {
	      return function template() { return $template.text(); };
	    }
	    return function template() { return String(obj); };
	  },
	
	  defer: function(fn) { setTimeout(fn, 0); },
	
	  noop: function() {},
	
	  formatPrefix: function(prefix, noPrefix) {
	    return noPrefix ? '' : prefix + '-';
	  },
	
	  className: function(prefix, clazz, skipDot) {
	    return (skipDot ? '' : '.') + prefix + clazz;
	  },
	
	  escapeHighlightedString: function(str, highlightPreTag, highlightPostTag) {
	    highlightPreTag = highlightPreTag || '<em>';
	    var pre = document.createElement('div');
	    pre.appendChild(document.createTextNode(highlightPreTag));
	
	    highlightPostTag = highlightPostTag || '</em>';
	    var post = document.createElement('div');
	    post.appendChild(document.createTextNode(highlightPostTag));
	
	    var div = document.createElement('div');
	    div.appendChild(document.createTextNode(str));
	    return div.innerHTML
	      .replace(RegExp(escapeRegExp(pre.innerHTML), 'g'), highlightPreTag)
	      .replace(RegExp(escapeRegExp(post.innerHTML), 'g'), highlightPostTag);
	  }
	};


/***/ },
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	// Backbone.ComputedFields, v0.0.12
	// Copyright (c)2015 alexander.beletsky@gmail.com
	// Distributed under MIT license
	// https://github.com/alexanderbeletsky/backbone-computedfields
	
	(function (root, factory) {
	  if (true) {
	
	    var underscore = __webpack_require__(1);
	    var backbone = __webpack_require__(4);
	
	    module.exports = factory(underscore, backbone);
	
	  } else if (typeof define === 'function' && define.amd) {
	
	    define(['underscore', 'backbone'], factory);
	
	  }
	}(this, function (_, Backbone) {
	
	  Backbone.ComputedFields = (function(Backbone, _){
	  
	      var _isFunction = function(obj) {
	          // == instead of === and || false are optimizations
	          // to go around nasty bugs in IE11, Safari 8 and old v8
	          // see underscore#isFunction
	          /* jshint eqeqeq: false */
	          return typeof obj == 'function' || false;
	          /* jshint eqeqeq: true */
	      };
	  
	      var ComputedFields = function (model) {
	          this.model = model;
	          this._computedFields = [];
	  
	          this.initialize();
	      };
	  
	      _.extend(ComputedFields.prototype, {
	          initialize: function () {
	              _.bindAll(
	                  this,
	                  '_bindModelEvents',
	                  '_computeFieldValue',
	                  '_dependentFields',
	                  '_isModelInitialized',
	                  '_lookUpComputedFields',
	                  '_thenComputedChanges',
	                  '_thenDependentChanges',
	                  '_toJSON',
	                  '_wrapJSON',
	                  'initialize'
	              );
	  
	              this._lookUpComputedFields();
	              this._bindModelEvents();
	              this._wrapJSON();
	          },
	  
	          _lookUpComputedFields: function () {
	              var computed = _isFunction(this.model.computed) ? this.model.computed() : this.model.computed;
	  
	              for (var obj in computed) {
	                  var field = computed[obj];
	  
	                  if (field && (field.set || field.get)) {
	                      this._computedFields.push({name: obj, field: field});
	                  }
	              }
	          },
	  
	          _bindModelEvents: function () {
	              _.each(this._computedFields, function (computedField) {
	                  var fieldName = computedField.name;
	                  var field = computedField.field;
	  
	                  var updateComputed = _.bind(function () {
	                      var value = this._computeFieldValue(field);
	                      this.model.set(fieldName, value, { skipChangeEvent: true });
	                  }, this);
	  
	                  var updateDependent = _.bind(function (model, value, options) {
	                      if (options && options.skipChangeEvent) {
	                          return;
	                      }
	  
	                      if (field.set) {
	                          var fields = this._dependentFields(field.depends);
	                          value = value || this.model.get(fieldName);
	  
	                          field.set.call(this.model, value, fields);
	                          this.model.set(fields, options);
	                      }
	                  }, this);
	  
	                  this._thenDependentChanges(field.depends, updateComputed);
	                  this._thenComputedChanges(fieldName, updateDependent);
	  
	                  if (this._isModelInitialized()) {
	                      updateComputed();
	                  }
	              }, this);
	          },
	  
	          _isModelInitialized: function () {
	              return !_.isEmpty(this.model.attributes);
	          },
	  
	          _thenDependentChanges: function (depends, callback) {
	              _.each(depends, function (name) {
	                  if (typeof (name) === 'string') {
	                      this.model.on('change:' + name, callback);
	                  }
	  
	                  if (typeof (name) === 'function') {
	                      name.call(this.model, callback);
	                  }
	              }, this);
	          },
	  
	          _thenComputedChanges: function (fieldName, callback) {
	              this.model.on('change:' + fieldName, callback);
	          },
	  
	          _wrapJSON: function () {
	              this.model.toJSON = _.wrap(this.model.toJSON, this._toJSON);
	          },
	  
	          _toJSON: function (toJSON) {
	              var args = Array.prototype.slice.call(arguments, 1),
	                  attributes = toJSON.apply(this.model, args),
	                  strip = !!(args[0] || {}).computedFields;
	  
	              var stripped = strip ? {} : _.reduce(this._computedFields, function (memo, computed) {
	                  if (computed.field.toJSON === false) {
	                      memo.push(computed.name);
	                  }
	                  return memo;
	              },[]);
	  
	              return _.omit(attributes, stripped);
	          },
	  
	          _computeFieldValue: function (computedField) {
	              if (computedField && computedField.get) {
	                  var fields = this._dependentFields(computedField.depends);
	                  return computedField.get.call(this.model, fields);
	              }
	          },
	  
	          _dependentFields: function (depends) {
	              return _.reduce(depends, function (memo, field) {
	                  memo[field] = this.model.get(field);
	                  return memo;
	              }, {}, this);
	          }
	  
	      });
	  
	      return ComputedFields;
	  
	  })(Backbone, _);
	  return Backbone.ComputedFields;
	
	}));

/***/ },
/* 371 */
133,
/* 372 */
[2109, 678],
/* 373 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 374 */
[2112, 133, 514, 340],
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ },
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	var defaultToWhiteSpace = __webpack_require__(1135);
	var nativeTrim = String.prototype.trim;
	
	module.exports = function trim(str, characters) {
	  str = makeString(str);
	  if (!characters && nativeTrim) return nativeTrim.call(str);
	  characters = defaultToWhiteSpace(characters);
	  return str.replace(new RegExp('^' + characters + '+|' + characters + '+$', 'g'), '');
	};


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/**!
	 * urlencode - lib/urlencode.js
	 *
	 * MIT Licensed
	 *
	 * Authors:
	 *   fengmk2 <fengmk2@gmail.com> (http://fengmk2.com)
	 */
	
	"use strict";
	
	/**
	 * Module dependencies.
	 */
	
	var iconv = __webpack_require__(1790);
	
	function isUTF8(charset) {
	  if (!charset) {
	    return true;
	  }
	  charset = charset.toLowerCase();
	  return charset === 'utf8' || charset === 'utf-8';
	}
	
	function encode(str, charset) {
	  if (isUTF8(charset)) {
	    return encodeURIComponent(str);
	  }
	
	  var buf = iconv.encode(str, charset);
	  var encodeStr = '';
	  var ch = '';
	  for (var i = 0; i < buf.length; i++) {
	    ch = buf[i].toString('16');
	    if (ch.length === 1) {
	      ch = '0' + ch;
	    }
	    encodeStr += '%' + ch;
	  }
	  encodeStr = encodeStr.toUpperCase();
	  return encodeStr;
	}
	
	function decode(str, charset) {
	  if (isUTF8(charset)) {
	    return decodeURIComponent(str);
	  }
	
	  var bytes = [];
	  for (var i = 0; i < str.length; ) {
	    if (str[i] === '%') {
	      i++;
	      bytes.push(parseInt(str.substring(i, i + 2), 16));
	      i += 2;
	    } else {
	      bytes.push(str.charCodeAt(i));
	      i++;
	    }
	  }
	  var buf = new Buffer(bytes);
	  return iconv.decode(buf, charset);
	}
	
	function parse(qs, sep, eq, options) {
	  if (typeof sep === 'object') {
	    // parse(qs, options)
	    options = sep;
	    sep = null;
	  }
	
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  var charset = null;
	  if (options) {
	    if (typeof options.maxKeys === 'number') {
	      maxKeys = options.maxKeys;
	    }
	    if (typeof options.charset === 'string') {
	      charset = options.charset;
	    }
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20');
	    var idx = x.indexOf(eq);
	    var kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    if (kstr && kstr.indexOf('%') >= 0) {
	      try {
	        k = decode(kstr, charset);
	      } catch (e) {
	        k = kstr;
	      }
	    } else {
	      k = kstr;
	    }
	
	    if (vstr && vstr.indexOf('%') >= 0) {
	      try {
	        v = decode(vstr, charset);
	      } catch (e) {
	        v = vstr;
	      }
	    } else {
	      v = vstr;
	    }
	
	    if (!has(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	}
	
	function has(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	function isASCII(str) {
	  return (/^[\x00-\x7F]*$/).test(str);
	}
	
	function encodeComponent(item, charset) {
	  item = String(item);
	  if (isASCII(item)) {
	    item = encodeURIComponent(item);
	  } else {
	    item = encode(item, charset);
	  }
	  return item;
	}
	
	var stringify = function(obj, prefix, options) {
	  if (typeof prefix !== 'string') {
	    options = prefix || {};
	    prefix = null;
	  }
	  var charset = options.charset || 'utf-8';
	  if (Array.isArray(obj)) {
	    return stringifyArray(obj, prefix, options);
	  } else if ('[object Object]' === {}.toString.call(obj)) {
	    return stringifyObject(obj, prefix, options);
	  } else if ('string' === typeof obj) {
	    return stringifyString(obj, prefix, options);
	  } else {
	    return prefix + '=' + encodeComponent(String(obj), charset);
	  }
	};
	
	function stringifyString(str, prefix, options) {
	  if (!prefix) {
	    throw new TypeError('stringify expects an object');
	  }
	  var charset = options.charset;
	  return prefix + '=' + encodeComponent(str, charset);
	}
	
	function stringifyArray(arr, prefix, options) {
	  var ret = [];
	  if (!prefix) {
	    throw new TypeError('stringify expects an object');
	  }
	  for (var i = 0; i < arr.length; i++) {
	    ret.push(stringify(arr[i], prefix + '[' + i + ']', options));
	  }
	  return ret.join('&');
	}
	
	function stringifyObject(obj, prefix, options) {
	  var ret = [];
	  var keys = Object.keys(obj);
	  var key;
	
	  var charset = options.charset;
	  for (var i = 0, len = keys.length; i < len; ++i) {
	    key = keys[i];
	    if ('' === key) {
	      continue;
	    }
	    if (null === obj[key]) {
	      ret.push(encode(key, charset) + '=');
	    } else {
	      ret.push(stringify(
	        obj[key],
	        prefix ? prefix + '[' + encodeComponent(key, charset) + ']': encodeComponent(key, charset),
	        options));
	    }
	  }
	
	  return ret.join('&');
	}
	
	module.exports = encode;
	module.exports.encode = encode;
	module.exports.decode = decode;
	module.exports.parse = parse;
	module.exports.stringify = stringify;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(810).Buffer))

/***/ },
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1602), __esModule: true };

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$assign = __webpack_require__(1588)["default"];
	
	exports["default"] = _Object$assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ },
/* 466 */
/***/ function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 467 */
[2128, 1614, 1305, 921],
/* 468 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 469 */
466,
/* 470 */
[2127, 373],
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2012-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var defaultClient, mixin, responsePromise, client;
	
	defaultClient = __webpack_require__(1481);
	mixin = __webpack_require__(934);
	responsePromise = __webpack_require__(1061);
	client = __webpack_require__(1060);
	
	/**
	 * Interceptors have the ability to intercept the request and/org response
	 * objects.  They may augment, prune, transform or replace the
	 * request/response as needed.  Clients may be composed by wrapping
	 * together multiple interceptors.
	 *
	 * Configured interceptors are functional in nature.  Wrapping a client in
	 * an interceptor will not affect the client, merely the data that flows in
	 * and out of that client.  A common configuration can be created once and
	 * shared; specialization can be created by further wrapping that client
	 * with custom interceptors.
	 *
	 * @param {Client} [target] client to wrap
	 * @param {Object} [config] configuration for the interceptor, properties will be specific to the interceptor implementation
	 * @returns {Client} A client wrapped with the interceptor
	 *
	 * @class Interceptor
	 */
	
	function defaultInitHandler(config) {
		return config;
	}
	
	function defaultRequestHandler(request /*, config, meta */) {
		return request;
	}
	
	function defaultResponseHandler(response /*, config, meta */) {
		return response;
	}
	
	/**
	 * Alternate return type for the request handler that allows for more complex interactions.
	 *
	 * @param properties.request the traditional request return object
	 * @param {Promise} [properties.abort] promise that resolves if/when the request is aborted
	 * @param {Client} [properties.client] override the defined client with an alternate client
	 * @param [properties.response] response for the request, short circuit the request
	 */
	function ComplexRequest(properties) {
		if (!(this instanceof ComplexRequest)) {
			// in case users forget the 'new' don't mix into the interceptor
			return new ComplexRequest(properties);
		}
		mixin(this, properties);
	}
	
	/**
	 * Create a new interceptor for the provided handlers.
	 *
	 * @param {Function} [handlers.init] one time intialization, must return the config object
	 * @param {Function} [handlers.request] request handler
	 * @param {Function} [handlers.response] response handler regardless of error state
	 * @param {Function} [handlers.success] response handler when the request is not in error
	 * @param {Function} [handlers.error] response handler when the request is in error, may be used to 'unreject' an error state
	 * @param {Function} [handlers.client] the client to use if otherwise not specified, defaults to platform default client
	 *
	 * @returns {Interceptor}
	 */
	function interceptor(handlers) {
	
		var initHandler, requestHandler, successResponseHandler, errorResponseHandler;
	
		handlers = handlers || {};
	
		initHandler            = handlers.init    || defaultInitHandler;
		requestHandler         = handlers.request || defaultRequestHandler;
		successResponseHandler = handlers.success || handlers.response || defaultResponseHandler;
		errorResponseHandler   = handlers.error   || function () {
			// Propagate the rejection, with the result of the handler
			return Promise.resolve((handlers.response || defaultResponseHandler).apply(this, arguments))
				.then(Promise.reject.bind(Promise));
		};
	
		return function (target, config) {
	
			if (typeof target === 'object') {
				config = target;
			}
			if (typeof target !== 'function') {
				target = handlers.client || defaultClient;
			}
	
			config = initHandler(config || {});
	
			function interceptedClient(request) {
				var context, meta;
				context = {};
				meta = { 'arguments': Array.prototype.slice.call(arguments), client: interceptedClient };
				request = typeof request === 'string' ? { path: request } : request || {};
				request.originator = request.originator || interceptedClient;
				return responsePromise(
					requestHandler.call(context, request, config, meta),
					function (request) {
						var response, abort, next;
						next = target;
						if (request instanceof ComplexRequest) {
							// unpack request
							abort = request.abort;
							next = request.client || next;
							response = request.response;
							// normalize request, must be last
							request = request.request;
						}
						response = response || Promise.resolve(request).then(function (request) {
							return Promise.resolve(next(request)).then(
								function (response) {
									return successResponseHandler.call(context, response, config, meta);
								},
								function (response) {
									return errorResponseHandler.call(context, response, config, meta);
								}
							);
						});
						return abort ? Promise.race([response, abort]) : response;
					},
					function (error) {
						return Promise.reject({ request: request, error: error });
					}
				);
			}
	
			return client(interceptedClient, target);
		};
	}
	
	interceptor.ComplexRequest = ComplexRequest;
	
	module.exports = interceptor;


/***/ },
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(910);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reverseBytes = exports.sliceBytes = exports.bytesMatch = exports.concatTypedArrays = exports.stringToBytes = exports.bytesToString = exports.numberToBytes = exports.bytesToNumber = exports.IS_LITTLE_ENDIAN = exports.IS_BIG_ENDIAN = exports.ENDIANNESS = exports.toBinaryString = exports.toHexString = exports.toUint8 = exports.isTypedArray = exports.isArrayBufferView = exports.padStart = exports.countBytes = exports.countBits = void 0;
	
	var _window = _interopRequireDefault(__webpack_require__(344));
	
	// const log2 = Math.log2 ? Math.log2 : (x) => (Math.log(x) / Math.log(2));
	var repeat = function repeat(str, len) {
	  var acc = '';
	
	  while (len--) {
	    acc += str;
	  }
	
	  return acc;
	}; // count the number of bits it would take to represent a number
	// we used to do this with log2 but BigInt does not support builtin math
	// Math.ceil(log2(x));
	
	
	var countBits = function countBits(x) {
	  return x.toString(2).length;
	}; // count the number of whole bytes it would take to represent a number
	
	
	exports.countBits = countBits;
	
	var countBytes = function countBytes(x) {
	  return Math.ceil(countBits(x) / 8);
	};
	
	exports.countBytes = countBytes;
	
	var padStart = function padStart(b, len, str) {
	  if (str === void 0) {
	    str = ' ';
	  }
	
	  return (repeat(str, len) + b.toString()).slice(-len);
	};
	
	exports.padStart = padStart;
	
	var isArrayBufferView = function isArrayBufferView(obj) {
	  if (ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(obj);
	  }
	
	  return obj && obj.buffer instanceof ArrayBuffer;
	};
	
	exports.isArrayBufferView = isArrayBufferView;
	
	var isTypedArray = function isTypedArray(obj) {
	  return isArrayBufferView(obj);
	};
	
	exports.isTypedArray = isTypedArray;
	
	var toUint8 = function toUint8(bytes) {
	  if (bytes instanceof Uint8Array) {
	    return bytes;
	  }
	
	  if (!Array.isArray(bytes) && !isTypedArray(bytes) && !(bytes instanceof ArrayBuffer)) {
	    // any non-number or NaN leads to empty uint8array
	    // eslint-disable-next-line
	    if (typeof bytes !== 'number' || typeof bytes === 'number' && bytes !== bytes) {
	      bytes = 0;
	    } else {
	      bytes = [bytes];
	    }
	  }
	
	  return new Uint8Array(bytes && bytes.buffer || bytes, bytes && bytes.byteOffset || 0, bytes && bytes.byteLength || 0);
	};
	
	exports.toUint8 = toUint8;
	
	var toHexString = function toHexString(bytes) {
	  bytes = toUint8(bytes);
	  var str = '';
	
	  for (var i = 0; i < bytes.length; i++) {
	    str += padStart(bytes[i].toString(16), 2, '0');
	  }
	
	  return str;
	};
	
	exports.toHexString = toHexString;
	
	var toBinaryString = function toBinaryString(bytes) {
	  bytes = toUint8(bytes);
	  var str = '';
	
	  for (var i = 0; i < bytes.length; i++) {
	    str += padStart(bytes[i].toString(2), 8, '0');
	  }
	
	  return str;
	};
	
	exports.toBinaryString = toBinaryString;
	var BigInt = _window.default.BigInt || Number;
	var BYTE_TABLE = [BigInt('0x1'), BigInt('0x100'), BigInt('0x10000'), BigInt('0x1000000'), BigInt('0x100000000'), BigInt('0x10000000000'), BigInt('0x1000000000000'), BigInt('0x100000000000000'), BigInt('0x10000000000000000')];
	
	var ENDIANNESS = function () {
	  var a = new Uint16Array([0xFFCC]);
	  var b = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
	
	  if (b[0] === 0xFF) {
	    return 'big';
	  }
	
	  if (b[0] === 0xCC) {
	    return 'little';
	  }
	
	  return 'unknown';
	}();
	
	exports.ENDIANNESS = ENDIANNESS;
	var IS_BIG_ENDIAN = ENDIANNESS === 'big';
	exports.IS_BIG_ENDIAN = IS_BIG_ENDIAN;
	var IS_LITTLE_ENDIAN = ENDIANNESS === 'little';
	exports.IS_LITTLE_ENDIAN = IS_LITTLE_ENDIAN;
	
	var bytesToNumber = function bytesToNumber(bytes, _temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$signed = _ref.signed,
	      signed = _ref$signed === void 0 ? false : _ref$signed,
	      _ref$le = _ref.le,
	      le = _ref$le === void 0 ? false : _ref$le;
	
	  bytes = toUint8(bytes);
	  var fn = le ? 'reduce' : 'reduceRight';
	  var obj = bytes[fn] ? bytes[fn] : Array.prototype[fn];
	  var number = obj.call(bytes, function (total, byte, i) {
	    var exponent = le ? i : Math.abs(i + 1 - bytes.length);
	    return total + BigInt(byte) * BYTE_TABLE[exponent];
	  }, BigInt(0));
	
	  if (signed) {
	    var max = BYTE_TABLE[bytes.length] / BigInt(2) - BigInt(1);
	    number = BigInt(number);
	
	    if (number > max) {
	      number -= max;
	      number -= max;
	      number -= BigInt(2);
	    }
	  }
	
	  return Number(number);
	};
	
	exports.bytesToNumber = bytesToNumber;
	
	var numberToBytes = function numberToBytes(number, _temp2) {
	  var _ref2 = _temp2 === void 0 ? {} : _temp2,
	      _ref2$le = _ref2.le,
	      le = _ref2$le === void 0 ? false : _ref2$le;
	
	  // eslint-disable-next-line
	  if (typeof number !== 'bigint' && typeof number !== 'number' || typeof number === 'number' && number !== number) {
	    number = 0;
	  }
	
	  number = BigInt(number);
	  var byteCount = countBytes(number);
	  var bytes = new Uint8Array(new ArrayBuffer(byteCount));
	
	  for (var i = 0; i < byteCount; i++) {
	    var byteIndex = le ? i : Math.abs(i + 1 - bytes.length);
	    bytes[byteIndex] = Number(number / BYTE_TABLE[i] & BigInt(0xFF));
	
	    if (number < 0) {
	      bytes[byteIndex] = Math.abs(~bytes[byteIndex]);
	      bytes[byteIndex] -= i === 0 ? 1 : 2;
	    }
	  }
	
	  return bytes;
	};
	
	exports.numberToBytes = numberToBytes;
	
	var bytesToString = function bytesToString(bytes) {
	  if (!bytes) {
	    return '';
	  } // TODO: should toUint8 handle cases where we only have 8 bytes
	  // but report more since this is a Uint16+ Array?
	
	
	  bytes = Array.prototype.slice.call(bytes);
	  var string = String.fromCharCode.apply(null, toUint8(bytes));
	
	  try {
	    return decodeURIComponent(escape(string));
	  } catch (e) {// if decodeURIComponent/escape fails, we are dealing with partial
	    // or full non string data. Just return the potentially garbled string.
	  }
	
	  return string;
	};
	
	exports.bytesToString = bytesToString;
	
	var stringToBytes = function stringToBytes(string, stringIsBytes) {
	  if (typeof string !== 'string' && string && typeof string.toString === 'function') {
	    string = string.toString();
	  }
	
	  if (typeof string !== 'string') {
	    return new Uint8Array();
	  } // If the string already is bytes, we don't have to do this
	  // otherwise we do this so that we split multi length characters
	  // into individual bytes
	
	
	  if (!stringIsBytes) {
	    string = unescape(encodeURIComponent(string));
	  }
	
	  var view = new Uint8Array(string.length);
	
	  for (var i = 0; i < string.length; i++) {
	    view[i] = string.charCodeAt(i);
	  }
	
	  return view;
	};
	
	exports.stringToBytes = stringToBytes;
	
	var concatTypedArrays = function concatTypedArrays() {
	  for (var _len = arguments.length, buffers = new Array(_len), _key = 0; _key < _len; _key++) {
	    buffers[_key] = arguments[_key];
	  }
	
	  buffers = buffers.filter(function (b) {
	    return b && (b.byteLength || b.length) && typeof b !== 'string';
	  });
	
	  if (buffers.length <= 1) {
	    // for 0 length we will return empty uint8
	    // for 1 length we return the first uint8
	    return toUint8(buffers[0]);
	  }
	
	  var totalLen = buffers.reduce(function (total, buf, i) {
	    return total + (buf.byteLength || buf.length);
	  }, 0);
	  var tempBuffer = new Uint8Array(totalLen);
	  var offset = 0;
	  buffers.forEach(function (buf) {
	    buf = toUint8(buf);
	    tempBuffer.set(buf, offset);
	    offset += buf.byteLength;
	  });
	  return tempBuffer;
	};
	/**
	 * Check if the bytes "b" are contained within bytes "a".
	 *
	 * @param {Uint8Array|Array} a
	 *        Bytes to check in
	 *
	 * @param {Uint8Array|Array} b
	 *        Bytes to check for
	 *
	 * @param {Object} options
	 *        options
	 *
	 * @param {Array|Uint8Array} [offset=0]
	 *        offset to use when looking at bytes in a
	 *
	 * @param {Array|Uint8Array} [mask=[]]
	 *        mask to use on bytes before comparison.
	 *
	 * @return {boolean}
	 *         If all bytes in b are inside of a, taking into account
	 *         bit masks.
	 */
	
	
	exports.concatTypedArrays = concatTypedArrays;
	
	var bytesMatch = function bytesMatch(a, b, _temp3) {
	  var _ref3 = _temp3 === void 0 ? {} : _temp3,
	      _ref3$offset = _ref3.offset,
	      offset = _ref3$offset === void 0 ? 0 : _ref3$offset,
	      _ref3$mask = _ref3.mask,
	      mask = _ref3$mask === void 0 ? [] : _ref3$mask;
	
	  a = toUint8(a);
	  b = toUint8(b); // ie 11 does not support uint8 every
	
	  var fn = b.every ? b.every : Array.prototype.every;
	  return b.length && a.length - offset >= b.length && // ie 11 doesn't support every on uin8
	  fn.call(b, function (bByte, i) {
	    var aByte = mask[i] ? mask[i] & a[offset + i] : a[offset + i];
	    return bByte === aByte;
	  });
	};
	
	exports.bytesMatch = bytesMatch;
	
	var sliceBytes = function sliceBytes(src, start, end) {
	  if (Uint8Array.prototype.slice) {
	    return Uint8Array.prototype.slice.call(src, start, end);
	  }
	
	  return new Uint8Array(Array.prototype.slice.call(src, start, end));
	};
	
	exports.sliceBytes = sliceBytes;
	
	var reverseBytes = function reverseBytes(src) {
	  if (src.reverse) {
	    return src.reverse();
	  }
	
	  return Array.prototype.reverse.call(src);
	};
	
	exports.reverseBytes = reverseBytes;

/***/ },
/* 477 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  element: null
	};


/***/ },
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	/*</replacement>*/
	
	
	/*<replacement>*/
	var util = __webpack_require__(754);
	util.inherits = __webpack_require__(406);
	/*</replacement>*/
	
	var Readable = __webpack_require__(1490);
	var Writable = __webpack_require__(1064);
	
	util.inherits(Duplex, Readable);
	
	forEach(objectKeys(Writable.prototype), function(method) {
	  if (!Duplex.prototype[method])
	    Duplex.prototype[method] = Writable.prototype[method];
	});
	
	function Duplex(options) {
	  if (!(this instanceof Duplex))
	    return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false)
	    this.readable = false;
	
	  if (options && options.writable === false)
	    this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false)
	    this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended)
	    return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  process.nextTick(this.end.bind(this));
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(235)))

/***/ },
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var AlgoliaSearchCore = __webpack_require__(1539);
	var createAlgoliasearch = __webpack_require__(1541);
	
	module.exports = createAlgoliasearch(AlgoliaSearchCore, 'Browser (lite)');


/***/ },
/* 673 */
/***/ function(module, exports) {

	module.exports = function clone(obj) {
	  return JSON.parse(JSON.stringify(obj));
	};


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, process, global, module) {(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.async = global.async || {})));
	}(this, (function (exports) { 'use strict';
	
	function slice(arrayLike, start) {
	    start = start|0;
	    var newLen = Math.max(arrayLike.length - start, 0);
	    var newArr = Array(newLen);
	    for(var idx = 0; idx < newLen; idx++)  {
	        newArr[idx] = arrayLike[start + idx];
	    }
	    return newArr;
	}
	
	/**
	 * Creates a continuation function with some arguments already applied.
	 *
	 * Useful as a shorthand when combined with other control flow functions. Any
	 * arguments passed to the returned function are added to the arguments
	 * originally passed to apply.
	 *
	 * @name apply
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {Function} fn - The function you want to eventually apply all
	 * arguments to. Invokes with (arguments...).
	 * @param {...*} arguments... - Any number of arguments to automatically apply
	 * when the continuation is called.
	 * @returns {Function} the partially-applied function
	 * @example
	 *
	 * // using apply
	 * async.parallel([
	 *     async.apply(fs.writeFile, 'testfile1', 'test1'),
	 *     async.apply(fs.writeFile, 'testfile2', 'test2')
	 * ]);
	 *
	 *
	 * // the same process without using apply
	 * async.parallel([
	 *     function(callback) {
	 *         fs.writeFile('testfile1', 'test1', callback);
	 *     },
	 *     function(callback) {
	 *         fs.writeFile('testfile2', 'test2', callback);
	 *     }
	 * ]);
	 *
	 * // It's possible to pass any number of additional arguments when calling the
	 * // continuation:
	 *
	 * node> var fn = async.apply(sys.puts, 'one');
	 * node> fn('two', 'three');
	 * one
	 * two
	 * three
	 */
	var apply = function(fn/*, ...args*/) {
	    var args = slice(arguments, 1);
	    return function(/*callArgs*/) {
	        var callArgs = slice(arguments);
	        return fn.apply(null, args.concat(callArgs));
	    };
	};
	
	var initialParams = function (fn) {
	    return function (/*...args, callback*/) {
	        var args = slice(arguments);
	        var callback = args.pop();
	        fn.call(this, args, callback);
	    };
	};
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	var hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
	var hasNextTick = typeof process === 'object' && typeof process.nextTick === 'function';
	
	function fallback(fn) {
	    setTimeout(fn, 0);
	}
	
	function wrap(defer) {
	    return function (fn/*, ...args*/) {
	        var args = slice(arguments, 1);
	        defer(function () {
	            fn.apply(null, args);
	        });
	    };
	}
	
	var _defer;
	
	if (hasSetImmediate) {
	    _defer = setImmediate;
	} else if (hasNextTick) {
	    _defer = process.nextTick;
	} else {
	    _defer = fallback;
	}
	
	var setImmediate$1 = wrap(_defer);
	
	/**
	 * Take a sync function and make it async, passing its return value to a
	 * callback. This is useful for plugging sync functions into a waterfall,
	 * series, or other async functions. Any arguments passed to the generated
	 * function will be passed to the wrapped function (except for the final
	 * callback argument). Errors thrown will be passed to the callback.
	 *
	 * If the function passed to `asyncify` returns a Promise, that promises's
	 * resolved/rejected state will be used to call the callback, rather than simply
	 * the synchronous return value.
	 *
	 * This also means you can asyncify ES2017 `async` functions.
	 *
	 * @name asyncify
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @alias wrapSync
	 * @category Util
	 * @param {Function} func - The synchronous function, or Promise-returning
	 * function to convert to an {@link AsyncFunction}.
	 * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
	 * invoked with `(args..., callback)`.
	 * @example
	 *
	 * // passing a regular synchronous function
	 * async.waterfall([
	 *     async.apply(fs.readFile, filename, "utf8"),
	 *     async.asyncify(JSON.parse),
	 *     function (data, next) {
	 *         // data is the result of parsing the text.
	 *         // If there was a parsing error, it would have been caught.
	 *     }
	 * ], callback);
	 *
	 * // passing a function returning a promise
	 * async.waterfall([
	 *     async.apply(fs.readFile, filename, "utf8"),
	 *     async.asyncify(function (contents) {
	 *         return db.model.create(contents);
	 *     }),
	 *     function (model, next) {
	 *         // `model` is the instantiated model object.
	 *         // If there was an error, this function would be skipped.
	 *     }
	 * ], callback);
	 *
	 * // es2017 example, though `asyncify` is not needed if your JS environment
	 * // supports async functions out of the box
	 * var q = async.queue(async.asyncify(async function(file) {
	 *     var intermediateStep = await processFile(file);
	 *     return await somePromise(intermediateStep)
	 * }));
	 *
	 * q.push(files);
	 */
	function asyncify(func) {
	    return initialParams(function (args, callback) {
	        var result;
	        try {
	            result = func.apply(this, args);
	        } catch (e) {
	            return callback(e);
	        }
	        // if result is Promise object
	        if (isObject(result) && typeof result.then === 'function') {
	            result.then(function(value) {
	                invokeCallback(callback, null, value);
	            }, function(err) {
	                invokeCallback(callback, err.message ? err : new Error(err));
	            });
	        } else {
	            callback(null, result);
	        }
	    });
	}
	
	function invokeCallback(callback, error, value) {
	    try {
	        callback(error, value);
	    } catch (e) {
	        setImmediate$1(rethrow, e);
	    }
	}
	
	function rethrow(error) {
	    throw error;
	}
	
	var supportsSymbol = typeof Symbol === 'function';
	
	function isAsync(fn) {
	    return supportsSymbol && fn[Symbol.toStringTag] === 'AsyncFunction';
	}
	
	function wrapAsync(asyncFn) {
	    return isAsync(asyncFn) ? asyncify(asyncFn) : asyncFn;
	}
	
	function applyEach$1(eachfn) {
	    return function(fns/*, ...args*/) {
	        var args = slice(arguments, 1);
	        var go = initialParams(function(args, callback) {
	            var that = this;
	            return eachfn(fns, function (fn, cb) {
	                wrapAsync(fn).apply(that, args.concat(cb));
	            }, callback);
	        });
	        if (args.length) {
	            return go.apply(this, args);
	        }
	        else {
	            return go;
	        }
	    };
	}
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Built-in value references. */
	var Symbol$1 = root.Symbol;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
	      tag = value[symToStringTag$1];
	
	  try {
	    value[symToStringTag$1] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag$1] = tag;
	    } else {
	      delete value[symToStringTag$1];
	    }
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var objectProto$1 = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString$1 = objectProto$1.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString$1.call(value);
	}
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]';
	var undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]';
	var funcTag = '[object Function]';
	var genTag = '[object GeneratorFunction]';
	var proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	// A temporary value used to identify if the loop should be broken.
	// See #1064, #1293
	var breakLoop = {};
	
	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	function once(fn) {
	    return function () {
	        if (fn === null) return;
	        var callFn = fn;
	        fn = null;
	        callFn.apply(this, arguments);
	    };
	}
	
	var iteratorSymbol = typeof Symbol === 'function' && Symbol.iterator;
	
	var getIterator = function (coll) {
	    return iteratorSymbol && coll[iteratorSymbol] && coll[iteratorSymbol]();
	};
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/** Used for built-in method references. */
	var objectProto$3 = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty$2.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER$1 = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER$1 : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	/** `Object#toString` result references. */
	var argsTag$1 = '[object Arguments]';
	var arrayTag = '[object Array]';
	var boolTag = '[object Boolean]';
	var dateTag = '[object Date]';
	var errorTag = '[object Error]';
	var funcTag$1 = '[object Function]';
	var mapTag = '[object Map]';
	var numberTag = '[object Number]';
	var objectTag = '[object Object]';
	var regexpTag = '[object RegExp]';
	var setTag = '[object Set]';
	var stringTag = '[object String]';
	var weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]';
	var dataViewTag = '[object DataView]';
	var float32Tag = '[object Float32Array]';
	var float64Tag = '[object Float64Array]';
	var int8Tag = '[object Int8Array]';
	var int16Tag = '[object Int16Array]';
	var int32Tag = '[object Int32Array]';
	var uint8Tag = '[object Uint8Array]';
	var uint8ClampedTag = '[object Uint8ClampedArray]';
	var uint16Tag = '[object Uint16Array]';
	var uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/** Detect free variable `exports`. */
	var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports$1 && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/** Used for built-in method references. */
	var objectProto$2 = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty$1.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var objectProto$5 = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;
	
	  return value === proto;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/** Used for built-in method references. */
	var objectProto$4 = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty$3.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	function createArrayIterator(coll) {
	    var i = -1;
	    var len = coll.length;
	    return function next() {
	        return ++i < len ? {value: coll[i], key: i} : null;
	    }
	}
	
	function createES2015Iterator(iterator) {
	    var i = -1;
	    return function next() {
	        var item = iterator.next();
	        if (item.done)
	            return null;
	        i++;
	        return {value: item.value, key: i};
	    }
	}
	
	function createObjectIterator(obj) {
	    var okeys = keys(obj);
	    var i = -1;
	    var len = okeys.length;
	    return function next() {
	        var key = okeys[++i];
	        if (key === '__proto__') {
	            return next();
	        }
	        return i < len ? {value: obj[key], key: key} : null;
	    };
	}
	
	function iterator(coll) {
	    if (isArrayLike(coll)) {
	        return createArrayIterator(coll);
	    }
	
	    var iterator = getIterator(coll);
	    return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
	}
	
	function onlyOnce(fn) {
	    return function() {
	        if (fn === null) throw new Error("Callback was already called.");
	        var callFn = fn;
	        fn = null;
	        callFn.apply(this, arguments);
	    };
	}
	
	function _eachOfLimit(limit) {
	    return function (obj, iteratee, callback) {
	        callback = once(callback || noop);
	        if (limit <= 0 || !obj) {
	            return callback(null);
	        }
	        var nextElem = iterator(obj);
	        var done = false;
	        var running = 0;
	        var looping = false;
	
	        function iterateeCallback(err, value) {
	            running -= 1;
	            if (err) {
	                done = true;
	                callback(err);
	            }
	            else if (value === breakLoop || (done && running <= 0)) {
	                done = true;
	                return callback(null);
	            }
	            else if (!looping) {
	                replenish();
	            }
	        }
	
	        function replenish () {
	            looping = true;
	            while (running < limit && !done) {
	                var elem = nextElem();
	                if (elem === null) {
	                    done = true;
	                    if (running <= 0) {
	                        callback(null);
	                    }
	                    return;
	                }
	                running += 1;
	                iteratee(elem.value, elem.key, onlyOnce(iterateeCallback));
	            }
	            looping = false;
	        }
	
	        replenish();
	    };
	}
	
	/**
	 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name eachOfLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.eachOf]{@link module:Collections.eachOf}
	 * @alias forEachOfLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async function to apply to each
	 * item in `coll`. The `key` is the item's key, or index in the case of an
	 * array.
	 * Invoked with (item, key, callback).
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 */
	function eachOfLimit(coll, limit, iteratee, callback) {
	    _eachOfLimit(limit)(coll, wrapAsync(iteratee), callback);
	}
	
	function doLimit(fn, limit) {
	    return function (iterable, iteratee, callback) {
	        return fn(iterable, limit, iteratee, callback);
	    };
	}
	
	// eachOf implementation optimized for array-likes
	function eachOfArrayLike(coll, iteratee, callback) {
	    callback = once(callback || noop);
	    var index = 0,
	        completed = 0,
	        length = coll.length;
	    if (length === 0) {
	        callback(null);
	    }
	
	    function iteratorCallback(err, value) {
	        if (err) {
	            callback(err);
	        } else if ((++completed === length) || value === breakLoop) {
	            callback(null);
	        }
	    }
	
	    for (; index < length; index++) {
	        iteratee(coll[index], index, onlyOnce(iteratorCallback));
	    }
	}
	
	// a generic version of eachOf which can handle array, object, and iterator cases.
	var eachOfGeneric = doLimit(eachOfLimit, Infinity);
	
	/**
	 * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
	 * to the iteratee.
	 *
	 * @name eachOf
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias forEachOf
	 * @category Collection
	 * @see [async.each]{@link module:Collections.each}
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - A function to apply to each
	 * item in `coll`.
	 * The `key` is the item's key, or index in the case of an array.
	 * Invoked with (item, key, callback).
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 * @example
	 *
	 * var obj = {dev: "/dev.json", test: "/test.json", prod: "/prod.json"};
	 * var configs = {};
	 *
	 * async.forEachOf(obj, function (value, key, callback) {
	 *     fs.readFile(__dirname + value, "utf8", function (err, data) {
	 *         if (err) return callback(err);
	 *         try {
	 *             configs[key] = JSON.parse(data);
	 *         } catch (e) {
	 *             return callback(e);
	 *         }
	 *         callback();
	 *     });
	 * }, function (err) {
	 *     if (err) console.error(err.message);
	 *     // configs is now a map of JSON data
	 *     doSomethingWith(configs);
	 * });
	 */
	var eachOf = function(coll, iteratee, callback) {
	    var eachOfImplementation = isArrayLike(coll) ? eachOfArrayLike : eachOfGeneric;
	    eachOfImplementation(coll, wrapAsync(iteratee), callback);
	};
	
	function doParallel(fn) {
	    return function (obj, iteratee, callback) {
	        return fn(eachOf, obj, wrapAsync(iteratee), callback);
	    };
	}
	
	function _asyncMap(eachfn, arr, iteratee, callback) {
	    callback = callback || noop;
	    arr = arr || [];
	    var results = [];
	    var counter = 0;
	    var _iteratee = wrapAsync(iteratee);
	
	    eachfn(arr, function (value, _, callback) {
	        var index = counter++;
	        _iteratee(value, function (err, v) {
	            results[index] = v;
	            callback(err);
	        });
	    }, function (err) {
	        callback(err, results);
	    });
	}
	
	/**
	 * Produces a new collection of values by mapping each value in `coll` through
	 * the `iteratee` function. The `iteratee` is called with an item from `coll`
	 * and a callback for when it has finished processing. Each of these callback
	 * takes 2 arguments: an `error`, and the transformed item from `coll`. If
	 * `iteratee` passes an error to its callback, the main `callback` (for the
	 * `map` function) is immediately called with the error.
	 *
	 * Note, that since this function applies the `iteratee` to each item in
	 * parallel, there is no guarantee that the `iteratee` functions will complete
	 * in order. However, the results array will be in the same order as the
	 * original `coll`.
	 *
	 * If `map` is passed an Object, the results will be an Array.  The results
	 * will roughly be in the order of the original Objects' keys (but this can
	 * vary across JavaScript engines).
	 *
	 * @name map
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The iteratee should complete with the transformed item.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Results is an Array of the
	 * transformed items from the `coll`. Invoked with (err, results).
	 * @example
	 *
	 * async.map(['file1','file2','file3'], fs.stat, function(err, results) {
	 *     // results is now an array of stats for each file
	 * });
	 */
	var map = doParallel(_asyncMap);
	
	/**
	 * Applies the provided arguments to each function in the array, calling
	 * `callback` after all functions have completed. If you only provide the first
	 * argument, `fns`, then it will return a function which lets you pass in the
	 * arguments as if it were a single function call. If more arguments are
	 * provided, `callback` is required while `args` is still optional.
	 *
	 * @name applyEach
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array|Iterable|Object} fns - A collection of {@link AsyncFunction}s
	 * to all call with the same arguments
	 * @param {...*} [args] - any number of separate arguments to pass to the
	 * function.
	 * @param {Function} [callback] - the final argument should be the callback,
	 * called when all functions have completed processing.
	 * @returns {Function} - If only the first argument, `fns`, is provided, it will
	 * return a function which lets you pass in the arguments as if it were a single
	 * function call. The signature is `(..args, callback)`. If invoked with any
	 * arguments, `callback` is required.
	 * @example
	 *
	 * async.applyEach([enableSearch, updateSchema], 'bucket', callback);
	 *
	 * // partial application example:
	 * async.each(
	 *     buckets,
	 *     async.applyEach([enableSearch, updateSchema]),
	 *     callback
	 * );
	 */
	var applyEach = applyEach$1(map);
	
	function doParallelLimit(fn) {
	    return function (obj, limit, iteratee, callback) {
	        return fn(_eachOfLimit(limit), obj, wrapAsync(iteratee), callback);
	    };
	}
	
	/**
	 * The same as [`map`]{@link module:Collections.map} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name mapLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.map]{@link module:Collections.map}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The iteratee should complete with the transformed item.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Results is an array of the
	 * transformed items from the `coll`. Invoked with (err, results).
	 */
	var mapLimit = doParallelLimit(_asyncMap);
	
	/**
	 * The same as [`map`]{@link module:Collections.map} but runs only a single async operation at a time.
	 *
	 * @name mapSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.map]{@link module:Collections.map}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The iteratee should complete with the transformed item.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Results is an array of the
	 * transformed items from the `coll`. Invoked with (err, results).
	 */
	var mapSeries = doLimit(mapLimit, 1);
	
	/**
	 * The same as [`applyEach`]{@link module:ControlFlow.applyEach} but runs only a single async operation at a time.
	 *
	 * @name applyEachSeries
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.applyEach]{@link module:ControlFlow.applyEach}
	 * @category Control Flow
	 * @param {Array|Iterable|Object} fns - A collection of {@link AsyncFunction}s to all
	 * call with the same arguments
	 * @param {...*} [args] - any number of separate arguments to pass to the
	 * function.
	 * @param {Function} [callback] - the final argument should be the callback,
	 * called when all functions have completed processing.
	 * @returns {Function} - If only the first argument is provided, it will return
	 * a function which lets you pass in the arguments as if it were a single
	 * function call.
	 */
	var applyEachSeries = applyEach$1(mapSeries);
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	/**
	 * Determines the best order for running the {@link AsyncFunction}s in `tasks`, based on
	 * their requirements. Each function can optionally depend on other functions
	 * being completed first, and each function is run as soon as its requirements
	 * are satisfied.
	 *
	 * If any of the {@link AsyncFunction}s pass an error to their callback, the `auto` sequence
	 * will stop. Further tasks will not execute (so any other functions depending
	 * on it will not run), and the main `callback` is immediately called with the
	 * error.
	 *
	 * {@link AsyncFunction}s also receive an object containing the results of functions which
	 * have completed so far as the first argument, if they have dependencies. If a
	 * task function has no dependencies, it will only be passed a callback.
	 *
	 * @name auto
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Object} tasks - An object. Each of its properties is either a
	 * function or an array of requirements, with the {@link AsyncFunction} itself the last item
	 * in the array. The object's key of a property serves as the name of the task
	 * defined by that property, i.e. can be used when specifying requirements for
	 * other tasks. The function receives one or two arguments:
	 * * a `results` object, containing the results of the previously executed
	 *   functions, only passed if the task has any dependencies,
	 * * a `callback(err, result)` function, which must be called when finished,
	 *   passing an `error` (which can be `null`) and the result of the function's
	 *   execution.
	 * @param {number} [concurrency=Infinity] - An optional `integer` for
	 * determining the maximum number of tasks that can be run in parallel. By
	 * default, as many as possible.
	 * @param {Function} [callback] - An optional callback which is called when all
	 * the tasks have been completed. It receives the `err` argument if any `tasks`
	 * pass an error to their callback. Results are always returned; however, if an
	 * error occurs, no further `tasks` will be performed, and the results object
	 * will only contain partial results. Invoked with (err, results).
	 * @returns undefined
	 * @example
	 *
	 * async.auto({
	 *     // this function will just be passed a callback
	 *     readData: async.apply(fs.readFile, 'data.txt', 'utf-8'),
	 *     showData: ['readData', function(results, cb) {
	 *         // results.readData is the file's contents
	 *         // ...
	 *     }]
	 * }, callback);
	 *
	 * async.auto({
	 *     get_data: function(callback) {
	 *         console.log('in get_data');
	 *         // async code to get some data
	 *         callback(null, 'data', 'converted to array');
	 *     },
	 *     make_folder: function(callback) {
	 *         console.log('in make_folder');
	 *         // async code to create a directory to store a file in
	 *         // this is run at the same time as getting the data
	 *         callback(null, 'folder');
	 *     },
	 *     write_file: ['get_data', 'make_folder', function(results, callback) {
	 *         console.log('in write_file', JSON.stringify(results));
	 *         // once there is some data and the directory exists,
	 *         // write the data to a file in the directory
	 *         callback(null, 'filename');
	 *     }],
	 *     email_link: ['write_file', function(results, callback) {
	 *         console.log('in email_link', JSON.stringify(results));
	 *         // once the file is written let's email a link to it...
	 *         // results.write_file contains the filename returned by write_file.
	 *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
	 *     }]
	 * }, function(err, results) {
	 *     console.log('err = ', err);
	 *     console.log('results = ', results);
	 * });
	 */
	var auto = function (tasks, concurrency, callback) {
	    if (typeof concurrency === 'function') {
	        // concurrency is optional, shift the args.
	        callback = concurrency;
	        concurrency = null;
	    }
	    callback = once(callback || noop);
	    var keys$$1 = keys(tasks);
	    var numTasks = keys$$1.length;
	    if (!numTasks) {
	        return callback(null);
	    }
	    if (!concurrency) {
	        concurrency = numTasks;
	    }
	
	    var results = {};
	    var runningTasks = 0;
	    var hasError = false;
	
	    var listeners = Object.create(null);
	
	    var readyTasks = [];
	
	    // for cycle detection:
	    var readyToCheck = []; // tasks that have been identified as reachable
	    // without the possibility of returning to an ancestor task
	    var uncheckedDependencies = {};
	
	    baseForOwn(tasks, function (task, key) {
	        if (!isArray(task)) {
	            // no dependencies
	            enqueueTask(key, [task]);
	            readyToCheck.push(key);
	            return;
	        }
	
	        var dependencies = task.slice(0, task.length - 1);
	        var remainingDependencies = dependencies.length;
	        if (remainingDependencies === 0) {
	            enqueueTask(key, task);
	            readyToCheck.push(key);
	            return;
	        }
	        uncheckedDependencies[key] = remainingDependencies;
	
	        arrayEach(dependencies, function (dependencyName) {
	            if (!tasks[dependencyName]) {
	                throw new Error('async.auto task `' + key +
	                    '` has a non-existent dependency `' +
	                    dependencyName + '` in ' +
	                    dependencies.join(', '));
	            }
	            addListener(dependencyName, function () {
	                remainingDependencies--;
	                if (remainingDependencies === 0) {
	                    enqueueTask(key, task);
	                }
	            });
	        });
	    });
	
	    checkForDeadlocks();
	    processQueue();
	
	    function enqueueTask(key, task) {
	        readyTasks.push(function () {
	            runTask(key, task);
	        });
	    }
	
	    function processQueue() {
	        if (readyTasks.length === 0 && runningTasks === 0) {
	            return callback(null, results);
	        }
	        while(readyTasks.length && runningTasks < concurrency) {
	            var run = readyTasks.shift();
	            run();
	        }
	
	    }
	
	    function addListener(taskName, fn) {
	        var taskListeners = listeners[taskName];
	        if (!taskListeners) {
	            taskListeners = listeners[taskName] = [];
	        }
	
	        taskListeners.push(fn);
	    }
	
	    function taskComplete(taskName) {
	        var taskListeners = listeners[taskName] || [];
	        arrayEach(taskListeners, function (fn) {
	            fn();
	        });
	        processQueue();
	    }
	
	
	    function runTask(key, task) {
	        if (hasError) return;
	
	        var taskCallback = onlyOnce(function(err, result) {
	            runningTasks--;
	            if (arguments.length > 2) {
	                result = slice(arguments, 1);
	            }
	            if (err) {
	                var safeResults = {};
	                baseForOwn(results, function(val, rkey) {
	                    safeResults[rkey] = val;
	                });
	                safeResults[key] = result;
	                hasError = true;
	                listeners = Object.create(null);
	
	                callback(err, safeResults);
	            } else {
	                results[key] = result;
	                taskComplete(key);
	            }
	        });
	
	        runningTasks++;
	        var taskFn = wrapAsync(task[task.length - 1]);
	        if (task.length > 1) {
	            taskFn(results, taskCallback);
	        } else {
	            taskFn(taskCallback);
	        }
	    }
	
	    function checkForDeadlocks() {
	        // Kahn's algorithm
	        // https://en.wikipedia.org/wiki/Topological_sorting#Kahn.27s_algorithm
	        // http://connalle.blogspot.com/2013/10/topological-sortingkahn-algorithm.html
	        var currentTask;
	        var counter = 0;
	        while (readyToCheck.length) {
	            currentTask = readyToCheck.pop();
	            counter++;
	            arrayEach(getDependents(currentTask), function (dependent) {
	                if (--uncheckedDependencies[dependent] === 0) {
	                    readyToCheck.push(dependent);
	                }
	            });
	        }
	
	        if (counter !== numTasks) {
	            throw new Error(
	                'async.auto cannot execute tasks due to a recursive dependency'
	            );
	        }
	    }
	
	    function getDependents(taskName) {
	        var result = [];
	        baseForOwn(tasks, function (task, key) {
	            if (isArray(task) && baseIndexOf(task, taskName, 0) >= 0) {
	                result.push(key);
	            }
	        });
	        return result;
	    }
	};
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined;
	var symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the last unmatched string symbol.
	 */
	function charsEndIndex(strSymbols, chrSymbols) {
	  var index = strSymbols.length;
	
	  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	/**
	 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the first unmatched string symbol.
	 */
	function charsStartIndex(strSymbols, chrSymbols) {
	  var index = -1,
	      length = strSymbols.length;
	
	  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff';
	var rsComboMarksRange = '\\u0300-\\u036f';
	var reComboHalfMarksRange = '\\ufe20-\\ufe2f';
	var rsComboSymbolsRange = '\\u20d0-\\u20ff';
	var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	var rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	/** Used to compose unicode character classes. */
	var rsAstralRange$1 = '\\ud800-\\udfff';
	var rsComboMarksRange$1 = '\\u0300-\\u036f';
	var reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f';
	var rsComboSymbolsRange$1 = '\\u20d0-\\u20ff';
	var rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
	var rsVarRange$1 = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange$1 + ']';
	var rsCombo = '[' + rsComboRange$1 + ']';
	var rsFitz = '\\ud83c[\\udffb-\\udfff]';
	var rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')';
	var rsNonAstral = '[^' + rsAstralRange$1 + ']';
	var rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}';
	var rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]';
	var rsZWJ$1 = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?';
	var rsOptVar = '[' + rsVarRange$1 + ']?';
	var rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*';
	var rsSeq = rsOptVar + reOptMod + rsOptJoin;
	var rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/**
	 * Removes leading and trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trim('  abc  ');
	 * // => 'abc'
	 *
	 * _.trim('-_-abc-_-', '_-');
	 * // => 'abc'
	 *
	 * _.map(['  foo  ', '  bar  '], _.trim);
	 * // => ['foo', 'bar']
	 */
	function trim(string, chars, guard) {
	  string = toString(string);
	  if (string && (guard || chars === undefined)) {
	    return string.replace(reTrim, '');
	  }
	  if (!string || !(chars = baseToString(chars))) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      chrSymbols = stringToArray(chars),
	      start = charsStartIndex(strSymbols, chrSymbols),
	      end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	  return castSlice(strSymbols, start, end).join('');
	}
	
	var FN_ARGS = /^(?:async\s+)?(function)?\s*[^\(]*\(\s*([^\)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /(=.+)?(\s*)$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	
	function parseParams(func) {
	    func = func.toString().replace(STRIP_COMMENTS, '');
	    func = func.match(FN_ARGS)[2].replace(' ', '');
	    func = func ? func.split(FN_ARG_SPLIT) : [];
	    func = func.map(function (arg){
	        return trim(arg.replace(FN_ARG, ''));
	    });
	    return func;
	}
	
	/**
	 * A dependency-injected version of the [async.auto]{@link module:ControlFlow.auto} function. Dependent
	 * tasks are specified as parameters to the function, after the usual callback
	 * parameter, with the parameter names matching the names of the tasks it
	 * depends on. This can provide even more readable task graphs which can be
	 * easier to maintain.
	 *
	 * If a final callback is specified, the task results are similarly injected,
	 * specified as named parameters after the initial error parameter.
	 *
	 * The autoInject function is purely syntactic sugar and its semantics are
	 * otherwise equivalent to [async.auto]{@link module:ControlFlow.auto}.
	 *
	 * @name autoInject
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.auto]{@link module:ControlFlow.auto}
	 * @category Control Flow
	 * @param {Object} tasks - An object, each of whose properties is an {@link AsyncFunction} of
	 * the form 'func([dependencies...], callback). The object's key of a property
	 * serves as the name of the task defined by that property, i.e. can be used
	 * when specifying requirements for other tasks.
	 * * The `callback` parameter is a `callback(err, result)` which must be called
	 *   when finished, passing an `error` (which can be `null`) and the result of
	 *   the function's execution. The remaining parameters name other tasks on
	 *   which the task is dependent, and the results from those tasks are the
	 *   arguments of those parameters.
	 * @param {Function} [callback] - An optional callback which is called when all
	 * the tasks have been completed. It receives the `err` argument if any `tasks`
	 * pass an error to their callback, and a `results` object with any completed
	 * task results, similar to `auto`.
	 * @example
	 *
	 * //  The example from `auto` can be rewritten as follows:
	 * async.autoInject({
	 *     get_data: function(callback) {
	 *         // async code to get some data
	 *         callback(null, 'data', 'converted to array');
	 *     },
	 *     make_folder: function(callback) {
	 *         // async code to create a directory to store a file in
	 *         // this is run at the same time as getting the data
	 *         callback(null, 'folder');
	 *     },
	 *     write_file: function(get_data, make_folder, callback) {
	 *         // once there is some data and the directory exists,
	 *         // write the data to a file in the directory
	 *         callback(null, 'filename');
	 *     },
	 *     email_link: function(write_file, callback) {
	 *         // once the file is written let's email a link to it...
	 *         // write_file contains the filename returned by write_file.
	 *         callback(null, {'file':write_file, 'email':'user@example.com'});
	 *     }
	 * }, function(err, results) {
	 *     console.log('err = ', err);
	 *     console.log('email_link = ', results.email_link);
	 * });
	 *
	 * // If you are using a JS minifier that mangles parameter names, `autoInject`
	 * // will not work with plain functions, since the parameter names will be
	 * // collapsed to a single letter identifier.  To work around this, you can
	 * // explicitly specify the names of the parameters your task function needs
	 * // in an array, similar to Angular.js dependency injection.
	 *
	 * // This still has an advantage over plain `auto`, since the results a task
	 * // depends on are still spread into arguments.
	 * async.autoInject({
	 *     //...
	 *     write_file: ['get_data', 'make_folder', function(get_data, make_folder, callback) {
	 *         callback(null, 'filename');
	 *     }],
	 *     email_link: ['write_file', function(write_file, callback) {
	 *         callback(null, {'file':write_file, 'email':'user@example.com'});
	 *     }]
	 *     //...
	 * }, function(err, results) {
	 *     console.log('err = ', err);
	 *     console.log('email_link = ', results.email_link);
	 * });
	 */
	function autoInject(tasks, callback) {
	    var newTasks = {};
	
	    baseForOwn(tasks, function (taskFn, key) {
	        var params;
	        var fnIsAsync = isAsync(taskFn);
	        var hasNoDeps =
	            (!fnIsAsync && taskFn.length === 1) ||
	            (fnIsAsync && taskFn.length === 0);
	
	        if (isArray(taskFn)) {
	            params = taskFn.slice(0, -1);
	            taskFn = taskFn[taskFn.length - 1];
	
	            newTasks[key] = params.concat(params.length > 0 ? newTask : taskFn);
	        } else if (hasNoDeps) {
	            // no dependencies, use the function as-is
	            newTasks[key] = taskFn;
	        } else {
	            params = parseParams(taskFn);
	            if (taskFn.length === 0 && !fnIsAsync && params.length === 0) {
	                throw new Error("autoInject task functions require explicit parameters.");
	            }
	
	            // remove callback param
	            if (!fnIsAsync) params.pop();
	
	            newTasks[key] = params.concat(newTask);
	        }
	
	        function newTask(results, taskCb) {
	            var newArgs = arrayMap(params, function (name) {
	                return results[name];
	            });
	            newArgs.push(taskCb);
	            wrapAsync(taskFn).apply(null, newArgs);
	        }
	    });
	
	    auto(newTasks, callback);
	}
	
	// Simple doubly linked list (https://en.wikipedia.org/wiki/Doubly_linked_list) implementation
	// used for queues. This implementation assumes that the node provided by the user can be modified
	// to adjust the next and last properties. We implement only the minimal functionality
	// for queue support.
	function DLL() {
	    this.head = this.tail = null;
	    this.length = 0;
	}
	
	function setInitial(dll, node) {
	    dll.length = 1;
	    dll.head = dll.tail = node;
	}
	
	DLL.prototype.removeLink = function(node) {
	    if (node.prev) node.prev.next = node.next;
	    else this.head = node.next;
	    if (node.next) node.next.prev = node.prev;
	    else this.tail = node.prev;
	
	    node.prev = node.next = null;
	    this.length -= 1;
	    return node;
	};
	
	DLL.prototype.empty = function () {
	    while(this.head) this.shift();
	    return this;
	};
	
	DLL.prototype.insertAfter = function(node, newNode) {
	    newNode.prev = node;
	    newNode.next = node.next;
	    if (node.next) node.next.prev = newNode;
	    else this.tail = newNode;
	    node.next = newNode;
	    this.length += 1;
	};
	
	DLL.prototype.insertBefore = function(node, newNode) {
	    newNode.prev = node.prev;
	    newNode.next = node;
	    if (node.prev) node.prev.next = newNode;
	    else this.head = newNode;
	    node.prev = newNode;
	    this.length += 1;
	};
	
	DLL.prototype.unshift = function(node) {
	    if (this.head) this.insertBefore(this.head, node);
	    else setInitial(this, node);
	};
	
	DLL.prototype.push = function(node) {
	    if (this.tail) this.insertAfter(this.tail, node);
	    else setInitial(this, node);
	};
	
	DLL.prototype.shift = function() {
	    return this.head && this.removeLink(this.head);
	};
	
	DLL.prototype.pop = function() {
	    return this.tail && this.removeLink(this.tail);
	};
	
	DLL.prototype.toArray = function () {
	    var arr = Array(this.length);
	    var curr = this.head;
	    for(var idx = 0; idx < this.length; idx++) {
	        arr[idx] = curr.data;
	        curr = curr.next;
	    }
	    return arr;
	};
	
	DLL.prototype.remove = function (testFn) {
	    var curr = this.head;
	    while(!!curr) {
	        var next = curr.next;
	        if (testFn(curr)) {
	            this.removeLink(curr);
	        }
	        curr = next;
	    }
	    return this;
	};
	
	function queue(worker, concurrency, payload) {
	    if (concurrency == null) {
	        concurrency = 1;
	    }
	    else if(concurrency === 0) {
	        throw new Error('Concurrency must not be zero');
	    }
	
	    var _worker = wrapAsync(worker);
	    var numRunning = 0;
	    var workersList = [];
	
	    var processingScheduled = false;
	    function _insert(data, insertAtFront, callback) {
	        if (callback != null && typeof callback !== 'function') {
	            throw new Error('task callback must be a function');
	        }
	        q.started = true;
	        if (!isArray(data)) {
	            data = [data];
	        }
	        if (data.length === 0 && q.idle()) {
	            // call drain immediately if there are no tasks
	            return setImmediate$1(function() {
	                q.drain();
	            });
	        }
	
	        for (var i = 0, l = data.length; i < l; i++) {
	            var item = {
	                data: data[i],
	                callback: callback || noop
	            };
	
	            if (insertAtFront) {
	                q._tasks.unshift(item);
	            } else {
	                q._tasks.push(item);
	            }
	        }
	
	        if (!processingScheduled) {
	            processingScheduled = true;
	            setImmediate$1(function() {
	                processingScheduled = false;
	                q.process();
	            });
	        }
	    }
	
	    function _next(tasks) {
	        return function(err){
	            numRunning -= 1;
	
	            for (var i = 0, l = tasks.length; i < l; i++) {
	                var task = tasks[i];
	
	                var index = baseIndexOf(workersList, task, 0);
	                if (index === 0) {
	                    workersList.shift();
	                } else if (index > 0) {
	                    workersList.splice(index, 1);
	                }
	
	                task.callback.apply(task, arguments);
	
	                if (err != null) {
	                    q.error(err, task.data);
	                }
	            }
	
	            if (numRunning <= (q.concurrency - q.buffer) ) {
	                q.unsaturated();
	            }
	
	            if (q.idle()) {
	                q.drain();
	            }
	            q.process();
	        };
	    }
	
	    var isProcessing = false;
	    var q = {
	        _tasks: new DLL(),
	        concurrency: concurrency,
	        payload: payload,
	        saturated: noop,
	        unsaturated:noop,
	        buffer: concurrency / 4,
	        empty: noop,
	        drain: noop,
	        error: noop,
	        started: false,
	        paused: false,
	        push: function (data, callback) {
	            _insert(data, false, callback);
	        },
	        kill: function () {
	            q.drain = noop;
	            q._tasks.empty();
	        },
	        unshift: function (data, callback) {
	            _insert(data, true, callback);
	        },
	        remove: function (testFn) {
	            q._tasks.remove(testFn);
	        },
	        process: function () {
	            // Avoid trying to start too many processing operations. This can occur
	            // when callbacks resolve synchronously (#1267).
	            if (isProcessing) {
	                return;
	            }
	            isProcessing = true;
	            while(!q.paused && numRunning < q.concurrency && q._tasks.length){
	                var tasks = [], data = [];
	                var l = q._tasks.length;
	                if (q.payload) l = Math.min(l, q.payload);
	                for (var i = 0; i < l; i++) {
	                    var node = q._tasks.shift();
	                    tasks.push(node);
	                    workersList.push(node);
	                    data.push(node.data);
	                }
	
	                numRunning += 1;
	
	                if (q._tasks.length === 0) {
	                    q.empty();
	                }
	
	                if (numRunning === q.concurrency) {
	                    q.saturated();
	                }
	
	                var cb = onlyOnce(_next(tasks));
	                _worker(data, cb);
	            }
	            isProcessing = false;
	        },
	        length: function () {
	            return q._tasks.length;
	        },
	        running: function () {
	            return numRunning;
	        },
	        workersList: function () {
	            return workersList;
	        },
	        idle: function() {
	            return q._tasks.length + numRunning === 0;
	        },
	        pause: function () {
	            q.paused = true;
	        },
	        resume: function () {
	            if (q.paused === false) { return; }
	            q.paused = false;
	            setImmediate$1(q.process);
	        }
	    };
	    return q;
	}
	
	/**
	 * A cargo of tasks for the worker function to complete. Cargo inherits all of
	 * the same methods and event callbacks as [`queue`]{@link module:ControlFlow.queue}.
	 * @typedef {Object} CargoObject
	 * @memberOf module:ControlFlow
	 * @property {Function} length - A function returning the number of items
	 * waiting to be processed. Invoke like `cargo.length()`.
	 * @property {number} payload - An `integer` for determining how many tasks
	 * should be process per round. This property can be changed after a `cargo` is
	 * created to alter the payload on-the-fly.
	 * @property {Function} push - Adds `task` to the `queue`. The callback is
	 * called once the `worker` has finished processing the task. Instead of a
	 * single task, an array of `tasks` can be submitted. The respective callback is
	 * used for every task in the list. Invoke like `cargo.push(task, [callback])`.
	 * @property {Function} saturated - A callback that is called when the
	 * `queue.length()` hits the concurrency and further tasks will be queued.
	 * @property {Function} empty - A callback that is called when the last item
	 * from the `queue` is given to a `worker`.
	 * @property {Function} drain - A callback that is called when the last item
	 * from the `queue` has returned from the `worker`.
	 * @property {Function} idle - a function returning false if there are items
	 * waiting or being processed, or true if not. Invoke like `cargo.idle()`.
	 * @property {Function} pause - a function that pauses the processing of tasks
	 * until `resume()` is called. Invoke like `cargo.pause()`.
	 * @property {Function} resume - a function that resumes the processing of
	 * queued tasks when the queue is paused. Invoke like `cargo.resume()`.
	 * @property {Function} kill - a function that removes the `drain` callback and
	 * empties remaining tasks from the queue forcing it to go idle. Invoke like `cargo.kill()`.
	 */
	
	/**
	 * Creates a `cargo` object with the specified payload. Tasks added to the
	 * cargo will be processed altogether (up to the `payload` limit). If the
	 * `worker` is in progress, the task is queued until it becomes available. Once
	 * the `worker` has completed some tasks, each callback of those tasks is
	 * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
	 * for how `cargo` and `queue` work.
	 *
	 * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
	 * at a time, cargo passes an array of tasks to a single worker, repeating
	 * when the worker is finished.
	 *
	 * @name cargo
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.queue]{@link module:ControlFlow.queue}
	 * @category Control Flow
	 * @param {AsyncFunction} worker - An asynchronous function for processing an array
	 * of queued tasks. Invoked with `(tasks, callback)`.
	 * @param {number} [payload=Infinity] - An optional `integer` for determining
	 * how many tasks should be processed per round; if omitted, the default is
	 * unlimited.
	 * @returns {module:ControlFlow.CargoObject} A cargo object to manage the tasks. Callbacks can
	 * attached as certain properties to listen for specific events during the
	 * lifecycle of the cargo and inner queue.
	 * @example
	 *
	 * // create a cargo object with payload 2
	 * var cargo = async.cargo(function(tasks, callback) {
	 *     for (var i=0; i<tasks.length; i++) {
	 *         console.log('hello ' + tasks[i].name);
	 *     }
	 *     callback();
	 * }, 2);
	 *
	 * // add some items
	 * cargo.push({name: 'foo'}, function(err) {
	 *     console.log('finished processing foo');
	 * });
	 * cargo.push({name: 'bar'}, function(err) {
	 *     console.log('finished processing bar');
	 * });
	 * cargo.push({name: 'baz'}, function(err) {
	 *     console.log('finished processing baz');
	 * });
	 */
	function cargo(worker, payload) {
	    return queue(worker, 1, payload);
	}
	
	/**
	 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs only a single async operation at a time.
	 *
	 * @name eachOfSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.eachOf]{@link module:Collections.eachOf}
	 * @alias forEachOfSeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * Invoked with (item, key, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Invoked with (err).
	 */
	var eachOfSeries = doLimit(eachOfLimit, 1);
	
	/**
	 * Reduces `coll` into a single value using an async `iteratee` to return each
	 * successive step. `memo` is the initial state of the reduction. This function
	 * only operates in series.
	 *
	 * For performance reasons, it may make sense to split a call to this function
	 * into a parallel map, and then use the normal `Array.prototype.reduce` on the
	 * results. This function is for situations where each step in the reduction
	 * needs to be async; if you can get the data before reducing it, then it's
	 * probably a good idea to do so.
	 *
	 * @name reduce
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias inject
	 * @alias foldl
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {*} memo - The initial state of the reduction.
	 * @param {AsyncFunction} iteratee - A function applied to each item in the
	 * array to produce the next step in the reduction.
	 * The `iteratee` should complete with the next state of the reduction.
	 * If the iteratee complete with an error, the reduction is stopped and the
	 * main `callback` is immediately called with the error.
	 * Invoked with (memo, item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result is the reduced value. Invoked with
	 * (err, result).
	 * @example
	 *
	 * async.reduce([1,2,3], 0, function(memo, item, callback) {
	 *     // pointless async:
	 *     process.nextTick(function() {
	 *         callback(null, memo + item)
	 *     });
	 * }, function(err, result) {
	 *     // result is now equal to the last value of memo, which is 6
	 * });
	 */
	function reduce(coll, memo, iteratee, callback) {
	    callback = once(callback || noop);
	    var _iteratee = wrapAsync(iteratee);
	    eachOfSeries(coll, function(x, i, callback) {
	        _iteratee(memo, x, function(err, v) {
	            memo = v;
	            callback(err);
	        });
	    }, function(err) {
	        callback(err, memo);
	    });
	}
	
	/**
	 * Version of the compose function that is more natural to read. Each function
	 * consumes the return value of the previous function. It is the equivalent of
	 * [compose]{@link module:ControlFlow.compose} with the arguments reversed.
	 *
	 * Each function is executed with the `this` binding of the composed function.
	 *
	 * @name seq
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.compose]{@link module:ControlFlow.compose}
	 * @category Control Flow
	 * @param {...AsyncFunction} functions - the asynchronous functions to compose
	 * @returns {Function} a function that composes the `functions` in order
	 * @example
	 *
	 * // Requires lodash (or underscore), express3 and dresende's orm2.
	 * // Part of an app, that fetches cats of the logged user.
	 * // This example uses `seq` function to avoid overnesting and error
	 * // handling clutter.
	 * app.get('/cats', function(request, response) {
	 *     var User = request.models.User;
	 *     async.seq(
	 *         _.bind(User.get, User),  // 'User.get' has signature (id, callback(err, data))
	 *         function(user, fn) {
	 *             user.getCats(fn);      // 'getCats' has signature (callback(err, data))
	 *         }
	 *     )(req.session.user_id, function (err, cats) {
	 *         if (err) {
	 *             console.error(err);
	 *             response.json({ status: 'error', message: err.message });
	 *         } else {
	 *             response.json({ status: 'ok', message: 'Cats found', data: cats });
	 *         }
	 *     });
	 * });
	 */
	function seq(/*...functions*/) {
	    var _functions = arrayMap(arguments, wrapAsync);
	    return function(/*...args*/) {
	        var args = slice(arguments);
	        var that = this;
	
	        var cb = args[args.length - 1];
	        if (typeof cb == 'function') {
	            args.pop();
	        } else {
	            cb = noop;
	        }
	
	        reduce(_functions, args, function(newargs, fn, cb) {
	            fn.apply(that, newargs.concat(function(err/*, ...nextargs*/) {
	                var nextargs = slice(arguments, 1);
	                cb(err, nextargs);
	            }));
	        },
	        function(err, results) {
	            cb.apply(that, [err].concat(results));
	        });
	    };
	}
	
	/**
	 * Creates a function which is a composition of the passed asynchronous
	 * functions. Each function consumes the return value of the function that
	 * follows. Composing functions `f()`, `g()`, and `h()` would produce the result
	 * of `f(g(h()))`, only this version uses callbacks to obtain the return values.
	 *
	 * Each function is executed with the `this` binding of the composed function.
	 *
	 * @name compose
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {...AsyncFunction} functions - the asynchronous functions to compose
	 * @returns {Function} an asynchronous function that is the composed
	 * asynchronous `functions`
	 * @example
	 *
	 * function add1(n, callback) {
	 *     setTimeout(function () {
	 *         callback(null, n + 1);
	 *     }, 10);
	 * }
	 *
	 * function mul3(n, callback) {
	 *     setTimeout(function () {
	 *         callback(null, n * 3);
	 *     }, 10);
	 * }
	 *
	 * var add1mul3 = async.compose(mul3, add1);
	 * add1mul3(4, function (err, result) {
	 *     // result now equals 15
	 * });
	 */
	var compose = function(/*...args*/) {
	    return seq.apply(null, slice(arguments).reverse());
	};
	
	var _concat = Array.prototype.concat;
	
	/**
	 * The same as [`concat`]{@link module:Collections.concat} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name concatLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.concat]{@link module:Collections.concat}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
	 * which should use an array as its result. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished, or an error occurs. Results is an array
	 * containing the concatenated results of the `iteratee` function. Invoked with
	 * (err, results).
	 */
	var concatLimit = function(coll, limit, iteratee, callback) {
	    callback = callback || noop;
	    var _iteratee = wrapAsync(iteratee);
	    mapLimit(coll, limit, function(val, callback) {
	        _iteratee(val, function(err /*, ...args*/) {
	            if (err) return callback(err);
	            return callback(null, slice(arguments, 1));
	        });
	    }, function(err, mapResults) {
	        var result = [];
	        for (var i = 0; i < mapResults.length; i++) {
	            if (mapResults[i]) {
	                result = _concat.apply(result, mapResults[i]);
	            }
	        }
	
	        return callback(err, result);
	    });
	};
	
	/**
	 * Applies `iteratee` to each item in `coll`, concatenating the results. Returns
	 * the concatenated list. The `iteratee`s are called in parallel, and the
	 * results are concatenated as they return. There is no guarantee that the
	 * results array will be returned in the original order of `coll` passed to the
	 * `iteratee` function.
	 *
	 * @name concat
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
	 * which should use an array as its result. Invoked with (item, callback).
	 * @param {Function} [callback(err)] - A callback which is called after all the
	 * `iteratee` functions have finished, or an error occurs. Results is an array
	 * containing the concatenated results of the `iteratee` function. Invoked with
	 * (err, results).
	 * @example
	 *
	 * async.concat(['dir1','dir2','dir3'], fs.readdir, function(err, files) {
	 *     // files is now a list of filenames that exist in the 3 directories
	 * });
	 */
	var concat = doLimit(concatLimit, Infinity);
	
	/**
	 * The same as [`concat`]{@link module:Collections.concat} but runs only a single async operation at a time.
	 *
	 * @name concatSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.concat]{@link module:Collections.concat}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`.
	 * The iteratee should complete with an array an array of results.
	 * Invoked with (item, callback).
	 * @param {Function} [callback(err)] - A callback which is called after all the
	 * `iteratee` functions have finished, or an error occurs. Results is an array
	 * containing the concatenated results of the `iteratee` function. Invoked with
	 * (err, results).
	 */
	var concatSeries = doLimit(concatLimit, 1);
	
	/**
	 * Returns a function that when called, calls-back with the values provided.
	 * Useful as the first function in a [`waterfall`]{@link module:ControlFlow.waterfall}, or for plugging values in to
	 * [`auto`]{@link module:ControlFlow.auto}.
	 *
	 * @name constant
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {...*} arguments... - Any number of arguments to automatically invoke
	 * callback with.
	 * @returns {AsyncFunction} Returns a function that when invoked, automatically
	 * invokes the callback with the previous given arguments.
	 * @example
	 *
	 * async.waterfall([
	 *     async.constant(42),
	 *     function (value, next) {
	 *         // value === 42
	 *     },
	 *     //...
	 * ], callback);
	 *
	 * async.waterfall([
	 *     async.constant(filename, "utf8"),
	 *     fs.readFile,
	 *     function (fileData, next) {
	 *         //...
	 *     }
	 *     //...
	 * ], callback);
	 *
	 * async.auto({
	 *     hostname: async.constant("https://server.net/"),
	 *     port: findFreePort,
	 *     launchServer: ["hostname", "port", function (options, cb) {
	 *         startServer(options, cb);
	 *     }],
	 *     //...
	 * }, callback);
	 */
	var constant = function(/*...values*/) {
	    var values = slice(arguments);
	    var args = [null].concat(values);
	    return function (/*...ignoredArgs, callback*/) {
	        var callback = arguments[arguments.length - 1];
	        return callback.apply(this, args);
	    };
	};
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	function _createTester(check, getResult) {
	    return function(eachfn, arr, iteratee, cb) {
	        cb = cb || noop;
	        var testPassed = false;
	        var testResult;
	        eachfn(arr, function(value, _, callback) {
	            iteratee(value, function(err, result) {
	                if (err) {
	                    callback(err);
	                } else if (check(result) && !testResult) {
	                    testPassed = true;
	                    testResult = getResult(true, value);
	                    callback(null, breakLoop);
	                } else {
	                    callback();
	                }
	            });
	        }, function(err) {
	            if (err) {
	                cb(err);
	            } else {
	                cb(null, testPassed ? testResult : getResult(false));
	            }
	        });
	    };
	}
	
	function _findGetResult(v, x) {
	    return x;
	}
	
	/**
	 * Returns the first value in `coll` that passes an async truth test. The
	 * `iteratee` is applied in parallel, meaning the first iteratee to return
	 * `true` will fire the detect `callback` with that result. That means the
	 * result might not be the first item in the original `coll` (in terms of order)
	 * that passes the test.
	
	 * If order within the original `coll` is important, then look at
	 * [`detectSeries`]{@link module:Collections.detectSeries}.
	 *
	 * @name detect
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias find
	 * @category Collections
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
	 * The iteratee must complete with a boolean value as its result.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the `iteratee` functions have finished.
	 * Result will be the first item in the array that passes the truth test
	 * (iteratee) or the value `undefined` if none passed. Invoked with
	 * (err, result).
	 * @example
	 *
	 * async.detect(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, result) {
	 *     // result now equals the first file in the list that exists
	 * });
	 */
	var detect = doParallel(_createTester(identity, _findGetResult));
	
	/**
	 * The same as [`detect`]{@link module:Collections.detect} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name detectLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.detect]{@link module:Collections.detect}
	 * @alias findLimit
	 * @category Collections
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
	 * The iteratee must complete with a boolean value as its result.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the `iteratee` functions have finished.
	 * Result will be the first item in the array that passes the truth test
	 * (iteratee) or the value `undefined` if none passed. Invoked with
	 * (err, result).
	 */
	var detectLimit = doParallelLimit(_createTester(identity, _findGetResult));
	
	/**
	 * The same as [`detect`]{@link module:Collections.detect} but runs only a single async operation at a time.
	 *
	 * @name detectSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.detect]{@link module:Collections.detect}
	 * @alias findSeries
	 * @category Collections
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
	 * The iteratee must complete with a boolean value as its result.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the `iteratee` functions have finished.
	 * Result will be the first item in the array that passes the truth test
	 * (iteratee) or the value `undefined` if none passed. Invoked with
	 * (err, result).
	 */
	var detectSeries = doLimit(detectLimit, 1);
	
	function consoleFunc(name) {
	    return function (fn/*, ...args*/) {
	        var args = slice(arguments, 1);
	        args.push(function (err/*, ...args*/) {
	            var args = slice(arguments, 1);
	            if (typeof console === 'object') {
	                if (err) {
	                    if (console.error) {
	                        console.error(err);
	                    }
	                } else if (console[name]) {
	                    arrayEach(args, function (x) {
	                        console[name](x);
	                    });
	                }
	            }
	        });
	        wrapAsync(fn).apply(null, args);
	    };
	}
	
	/**
	 * Logs the result of an [`async` function]{@link AsyncFunction} to the
	 * `console` using `console.dir` to display the properties of the resulting object.
	 * Only works in Node.js or in browsers that support `console.dir` and
	 * `console.error` (such as FF and Chrome).
	 * If multiple arguments are returned from the async function,
	 * `console.dir` is called on each argument in order.
	 *
	 * @name dir
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {AsyncFunction} function - The function you want to eventually apply
	 * all arguments to.
	 * @param {...*} arguments... - Any number of arguments to apply to the function.
	 * @example
	 *
	 * // in a module
	 * var hello = function(name, callback) {
	 *     setTimeout(function() {
	 *         callback(null, {hello: name});
	 *     }, 1000);
	 * };
	 *
	 * // in the node repl
	 * node> async.dir(hello, 'world');
	 * {hello: 'world'}
	 */
	var dir = consoleFunc('dir');
	
	/**
	 * The post-check version of [`during`]{@link module:ControlFlow.during}. To reflect the difference in
	 * the order of operations, the arguments `test` and `fn` are switched.
	 *
	 * Also a version of [`doWhilst`]{@link module:ControlFlow.doWhilst} with asynchronous `test` function.
	 * @name doDuring
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.during]{@link module:ControlFlow.during}
	 * @category Control Flow
	 * @param {AsyncFunction} fn - An async function which is called each time
	 * `test` passes. Invoked with (callback).
	 * @param {AsyncFunction} test - asynchronous truth test to perform before each
	 * execution of `fn`. Invoked with (...args, callback), where `...args` are the
	 * non-error args from the previous callback of `fn`.
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has failed and repeated execution of `fn` has stopped. `callback`
	 * will be passed an error if one occurred, otherwise `null`.
	 */
	function doDuring(fn, test, callback) {
	    callback = onlyOnce(callback || noop);
	    var _fn = wrapAsync(fn);
	    var _test = wrapAsync(test);
	
	    function next(err/*, ...args*/) {
	        if (err) return callback(err);
	        var args = slice(arguments, 1);
	        args.push(check);
	        _test.apply(this, args);
	    }
	
	    function check(err, truth) {
	        if (err) return callback(err);
	        if (!truth) return callback(null);
	        _fn(next);
	    }
	
	    check(null, true);
	
	}
	
	/**
	 * The post-check version of [`whilst`]{@link module:ControlFlow.whilst}. To reflect the difference in
	 * the order of operations, the arguments `test` and `iteratee` are switched.
	 *
	 * `doWhilst` is to `whilst` as `do while` is to `while` in plain JavaScript.
	 *
	 * @name doWhilst
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.whilst]{@link module:ControlFlow.whilst}
	 * @category Control Flow
	 * @param {AsyncFunction} iteratee - A function which is called each time `test`
	 * passes. Invoked with (callback).
	 * @param {Function} test - synchronous truth test to perform after each
	 * execution of `iteratee`. Invoked with any non-error callback results of
	 * `iteratee`.
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has failed and repeated execution of `iteratee` has stopped.
	 * `callback` will be passed an error and any arguments passed to the final
	 * `iteratee`'s callback. Invoked with (err, [results]);
	 */
	function doWhilst(iteratee, test, callback) {
	    callback = onlyOnce(callback || noop);
	    var _iteratee = wrapAsync(iteratee);
	    var next = function(err/*, ...args*/) {
	        if (err) return callback(err);
	        var args = slice(arguments, 1);
	        if (test.apply(this, args)) return _iteratee(next);
	        callback.apply(null, [null].concat(args));
	    };
	    _iteratee(next);
	}
	
	/**
	 * Like ['doWhilst']{@link module:ControlFlow.doWhilst}, except the `test` is inverted. Note the
	 * argument ordering differs from `until`.
	 *
	 * @name doUntil
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.doWhilst]{@link module:ControlFlow.doWhilst}
	 * @category Control Flow
	 * @param {AsyncFunction} iteratee - An async function which is called each time
	 * `test` fails. Invoked with (callback).
	 * @param {Function} test - synchronous truth test to perform after each
	 * execution of `iteratee`. Invoked with any non-error callback results of
	 * `iteratee`.
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has passed and repeated execution of `iteratee` has stopped. `callback`
	 * will be passed an error and any arguments passed to the final `iteratee`'s
	 * callback. Invoked with (err, [results]);
	 */
	function doUntil(iteratee, test, callback) {
	    doWhilst(iteratee, function() {
	        return !test.apply(this, arguments);
	    }, callback);
	}
	
	/**
	 * Like [`whilst`]{@link module:ControlFlow.whilst}, except the `test` is an asynchronous function that
	 * is passed a callback in the form of `function (err, truth)`. If error is
	 * passed to `test` or `fn`, the main callback is immediately called with the
	 * value of the error.
	 *
	 * @name during
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.whilst]{@link module:ControlFlow.whilst}
	 * @category Control Flow
	 * @param {AsyncFunction} test - asynchronous truth test to perform before each
	 * execution of `fn`. Invoked with (callback).
	 * @param {AsyncFunction} fn - An async function which is called each time
	 * `test` passes. Invoked with (callback).
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has failed and repeated execution of `fn` has stopped. `callback`
	 * will be passed an error, if one occurred, otherwise `null`.
	 * @example
	 *
	 * var count = 0;
	 *
	 * async.during(
	 *     function (callback) {
	 *         return callback(null, count < 5);
	 *     },
	 *     function (callback) {
	 *         count++;
	 *         setTimeout(callback, 1000);
	 *     },
	 *     function (err) {
	 *         // 5 seconds have passed
	 *     }
	 * );
	 */
	function during(test, fn, callback) {
	    callback = onlyOnce(callback || noop);
	    var _fn = wrapAsync(fn);
	    var _test = wrapAsync(test);
	
	    function next(err) {
	        if (err) return callback(err);
	        _test(check);
	    }
	
	    function check(err, truth) {
	        if (err) return callback(err);
	        if (!truth) return callback(null);
	        _fn(next);
	    }
	
	    _test(check);
	}
	
	function _withoutIndex(iteratee) {
	    return function (value, index, callback) {
	        return iteratee(value, callback);
	    };
	}
	
	/**
	 * Applies the function `iteratee` to each item in `coll`, in parallel.
	 * The `iteratee` is called with an item from the list, and a callback for when
	 * it has finished. If the `iteratee` passes an error to its `callback`, the
	 * main `callback` (for the `each` function) is immediately called with the
	 * error.
	 *
	 * Note, that since this function applies `iteratee` to each item in parallel,
	 * there is no guarantee that the iteratee functions will complete in order.
	 *
	 * @name each
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias forEach
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to
	 * each item in `coll`. Invoked with (item, callback).
	 * The array index is not passed to the iteratee.
	 * If you need the index, use `eachOf`.
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 * @example
	 *
	 * // assuming openFiles is an array of file names and saveFile is a function
	 * // to save the modified contents of that file:
	 *
	 * async.each(openFiles, saveFile, function(err){
	 *   // if any of the saves produced an error, err would equal that error
	 * });
	 *
	 * // assuming openFiles is an array of file names
	 * async.each(openFiles, function(file, callback) {
	 *
	 *     // Perform operation on file here.
	 *     console.log('Processing file ' + file);
	 *
	 *     if( file.length > 32 ) {
	 *       console.log('This file name is too long');
	 *       callback('File name too long');
	 *     } else {
	 *       // Do work to process file here
	 *       console.log('File processed');
	 *       callback();
	 *     }
	 * }, function(err) {
	 *     // if any of the file processing produced an error, err would equal that error
	 *     if( err ) {
	 *       // One of the iterations produced an error.
	 *       // All processing will now stop.
	 *       console.log('A file failed to process');
	 *     } else {
	 *       console.log('All files have been processed successfully');
	 *     }
	 * });
	 */
	function eachLimit(coll, iteratee, callback) {
	    eachOf(coll, _withoutIndex(wrapAsync(iteratee)), callback);
	}
	
	/**
	 * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name eachLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.each]{@link module:Collections.each}
	 * @alias forEachLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The array index is not passed to the iteratee.
	 * If you need the index, use `eachOfLimit`.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 */
	function eachLimit$1(coll, limit, iteratee, callback) {
	    _eachOfLimit(limit)(coll, _withoutIndex(wrapAsync(iteratee)), callback);
	}
	
	/**
	 * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
	 *
	 * @name eachSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.each]{@link module:Collections.each}
	 * @alias forEachSeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to each
	 * item in `coll`.
	 * The array index is not passed to the iteratee.
	 * If you need the index, use `eachOfSeries`.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 */
	var eachSeries = doLimit(eachLimit$1, 1);
	
	/**
	 * Wrap an async function and ensure it calls its callback on a later tick of
	 * the event loop.  If the function already calls its callback on a next tick,
	 * no extra deferral is added. This is useful for preventing stack overflows
	 * (`RangeError: Maximum call stack size exceeded`) and generally keeping
	 * [Zalgo](http://blog.izs.me/post/59142742143/designing-apis-for-asynchrony)
	 * contained. ES2017 `async` functions are returned as-is -- they are immune
	 * to Zalgo's corrupting influences, as they always resolve on a later tick.
	 *
	 * @name ensureAsync
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {AsyncFunction} fn - an async function, one that expects a node-style
	 * callback as its last argument.
	 * @returns {AsyncFunction} Returns a wrapped function with the exact same call
	 * signature as the function passed in.
	 * @example
	 *
	 * function sometimesAsync(arg, callback) {
	 *     if (cache[arg]) {
	 *         return callback(null, cache[arg]); // this would be synchronous!!
	 *     } else {
	 *         doSomeIO(arg, callback); // this IO would be asynchronous
	 *     }
	 * }
	 *
	 * // this has a risk of stack overflows if many results are cached in a row
	 * async.mapSeries(args, sometimesAsync, done);
	 *
	 * // this will defer sometimesAsync's callback if necessary,
	 * // preventing stack overflows
	 * async.mapSeries(args, async.ensureAsync(sometimesAsync), done);
	 */
	function ensureAsync(fn) {
	    if (isAsync(fn)) return fn;
	    return initialParams(function (args, callback) {
	        var sync = true;
	        args.push(function () {
	            var innerArgs = arguments;
	            if (sync) {
	                setImmediate$1(function () {
	                    callback.apply(null, innerArgs);
	                });
	            } else {
	                callback.apply(null, innerArgs);
	            }
	        });
	        fn.apply(this, args);
	        sync = false;
	    });
	}
	
	function notId(v) {
	    return !v;
	}
	
	/**
	 * Returns `true` if every element in `coll` satisfies an async test. If any
	 * iteratee call returns `false`, the main `callback` is immediately called.
	 *
	 * @name every
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias all
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	 * in the collection in parallel.
	 * The iteratee must complete with a boolean result value.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result will be either `true` or `false`
	 * depending on the values of the async tests. Invoked with (err, result).
	 * @example
	 *
	 * async.every(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, result) {
	 *     // if result is true then every file exists
	 * });
	 */
	var every = doParallel(_createTester(notId, notId));
	
	/**
	 * The same as [`every`]{@link module:Collections.every} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name everyLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.every]{@link module:Collections.every}
	 * @alias allLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	 * in the collection in parallel.
	 * The iteratee must complete with a boolean result value.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result will be either `true` or `false`
	 * depending on the values of the async tests. Invoked with (err, result).
	 */
	var everyLimit = doParallelLimit(_createTester(notId, notId));
	
	/**
	 * The same as [`every`]{@link module:Collections.every} but runs only a single async operation at a time.
	 *
	 * @name everySeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.every]{@link module:Collections.every}
	 * @alias allSeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	 * in the collection in series.
	 * The iteratee must complete with a boolean result value.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result will be either `true` or `false`
	 * depending on the values of the async tests. Invoked with (err, result).
	 */
	var everySeries = doLimit(everyLimit, 1);
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	function filterArray(eachfn, arr, iteratee, callback) {
	    var truthValues = new Array(arr.length);
	    eachfn(arr, function (x, index, callback) {
	        iteratee(x, function (err, v) {
	            truthValues[index] = !!v;
	            callback(err);
	        });
	    }, function (err) {
	        if (err) return callback(err);
	        var results = [];
	        for (var i = 0; i < arr.length; i++) {
	            if (truthValues[i]) results.push(arr[i]);
	        }
	        callback(null, results);
	    });
	}
	
	function filterGeneric(eachfn, coll, iteratee, callback) {
	    var results = [];
	    eachfn(coll, function (x, index, callback) {
	        iteratee(x, function (err, v) {
	            if (err) {
	                callback(err);
	            } else {
	                if (v) {
	                    results.push({index: index, value: x});
	                }
	                callback();
	            }
	        });
	    }, function (err) {
	        if (err) {
	            callback(err);
	        } else {
	            callback(null, arrayMap(results.sort(function (a, b) {
	                return a.index - b.index;
	            }), baseProperty('value')));
	        }
	    });
	}
	
	function _filter(eachfn, coll, iteratee, callback) {
	    var filter = isArrayLike(coll) ? filterArray : filterGeneric;
	    filter(eachfn, coll, wrapAsync(iteratee), callback || noop);
	}
	
	/**
	 * Returns a new array of all the values in `coll` which pass an async truth
	 * test. This operation is performed in parallel, but the results array will be
	 * in the same order as the original.
	 *
	 * @name filter
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias select
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 * @example
	 *
	 * async.filter(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, results) {
	 *     // results now equals an array of the existing files
	 * });
	 */
	var filter = doParallel(_filter);
	
	/**
	 * The same as [`filter`]{@link module:Collections.filter} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name filterLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.filter]{@link module:Collections.filter}
	 * @alias selectLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 */
	var filterLimit = doParallelLimit(_filter);
	
	/**
	 * The same as [`filter`]{@link module:Collections.filter} but runs only a single async operation at a time.
	 *
	 * @name filterSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.filter]{@link module:Collections.filter}
	 * @alias selectSeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results)
	 */
	var filterSeries = doLimit(filterLimit, 1);
	
	/**
	 * Calls the asynchronous function `fn` with a callback parameter that allows it
	 * to call itself again, in series, indefinitely.
	
	 * If an error is passed to the callback then `errback` is called with the
	 * error, and execution stops, otherwise it will never be called.
	 *
	 * @name forever
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {AsyncFunction} fn - an async function to call repeatedly.
	 * Invoked with (next).
	 * @param {Function} [errback] - when `fn` passes an error to it's callback,
	 * this function will be called, and execution stops. Invoked with (err).
	 * @example
	 *
	 * async.forever(
	 *     function(next) {
	 *         // next is suitable for passing to things that need a callback(err [, whatever]);
	 *         // it will result in this function being called again.
	 *     },
	 *     function(err) {
	 *         // if next is called with a value in its first parameter, it will appear
	 *         // in here as 'err', and execution will stop.
	 *     }
	 * );
	 */
	function forever(fn, errback) {
	    var done = onlyOnce(errback || noop);
	    var task = wrapAsync(ensureAsync(fn));
	
	    function next(err) {
	        if (err) return done(err);
	        task(next);
	    }
	    next();
	}
	
	/**
	 * The same as [`groupBy`]{@link module:Collections.groupBy} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name groupByLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.groupBy]{@link module:Collections.groupBy}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The iteratee should complete with a `key` to group the value under.
	 * Invoked with (value, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Result is an `Object` whoses
	 * properties are arrays of values which returned the corresponding key.
	 */
	var groupByLimit = function(coll, limit, iteratee, callback) {
	    callback = callback || noop;
	    var _iteratee = wrapAsync(iteratee);
	    mapLimit(coll, limit, function(val, callback) {
	        _iteratee(val, function(err, key) {
	            if (err) return callback(err);
	            return callback(null, {key: key, val: val});
	        });
	    }, function(err, mapResults) {
	        var result = {};
	        // from MDN, handle object having an `hasOwnProperty` prop
	        var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	        for (var i = 0; i < mapResults.length; i++) {
	            if (mapResults[i]) {
	                var key = mapResults[i].key;
	                var val = mapResults[i].val;
	
	                if (hasOwnProperty.call(result, key)) {
	                    result[key].push(val);
	                } else {
	                    result[key] = [val];
	                }
	            }
	        }
	
	        return callback(err, result);
	    });
	};
	
	/**
	 * Returns a new object, where each value corresponds to an array of items, from
	 * `coll`, that returned the corresponding key. That is, the keys of the object
	 * correspond to the values passed to the `iteratee` callback.
	 *
	 * Note: Since this function applies the `iteratee` to each item in parallel,
	 * there is no guarantee that the `iteratee` functions will complete in order.
	 * However, the values for each key in the `result` will be in the same order as
	 * the original `coll`. For Objects, the values will roughly be in the order of
	 * the original Objects' keys (but this can vary across JavaScript engines).
	 *
	 * @name groupBy
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The iteratee should complete with a `key` to group the value under.
	 * Invoked with (value, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Result is an `Object` whoses
	 * properties are arrays of values which returned the corresponding key.
	 * @example
	 *
	 * async.groupBy(['userId1', 'userId2', 'userId3'], function(userId, callback) {
	 *     db.findById(userId, function(err, user) {
	 *         if (err) return callback(err);
	 *         return callback(null, user.age);
	 *     });
	 * }, function(err, result) {
	 *     // result is object containing the userIds grouped by age
	 *     // e.g. { 30: ['userId1', 'userId3'], 42: ['userId2']};
	 * });
	 */
	var groupBy = doLimit(groupByLimit, Infinity);
	
	/**
	 * The same as [`groupBy`]{@link module:Collections.groupBy} but runs only a single async operation at a time.
	 *
	 * @name groupBySeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.groupBy]{@link module:Collections.groupBy}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The iteratee should complete with a `key` to group the value under.
	 * Invoked with (value, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Result is an `Object` whoses
	 * properties are arrays of values which returned the corresponding key.
	 */
	var groupBySeries = doLimit(groupByLimit, 1);
	
	/**
	 * Logs the result of an `async` function to the `console`. Only works in
	 * Node.js or in browsers that support `console.log` and `console.error` (such
	 * as FF and Chrome). If multiple arguments are returned from the async
	 * function, `console.log` is called on each argument in order.
	 *
	 * @name log
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {AsyncFunction} function - The function you want to eventually apply
	 * all arguments to.
	 * @param {...*} arguments... - Any number of arguments to apply to the function.
	 * @example
	 *
	 * // in a module
	 * var hello = function(name, callback) {
	 *     setTimeout(function() {
	 *         callback(null, 'hello ' + name);
	 *     }, 1000);
	 * };
	 *
	 * // in the node repl
	 * node> async.log(hello, 'world');
	 * 'hello world'
	 */
	var log = consoleFunc('log');
	
	/**
	 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name mapValuesLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.mapValues]{@link module:Collections.mapValues}
	 * @category Collection
	 * @param {Object} obj - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - A function to apply to each value and key
	 * in `coll`.
	 * The iteratee should complete with the transformed value as its result.
	 * Invoked with (value, key, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. `result` is a new object consisting
	 * of each key from `obj`, with each transformed value on the right-hand side.
	 * Invoked with (err, result).
	 */
	function mapValuesLimit(obj, limit, iteratee, callback) {
	    callback = once(callback || noop);
	    var newObj = {};
	    var _iteratee = wrapAsync(iteratee);
	    eachOfLimit(obj, limit, function(val, key, next) {
	        _iteratee(val, key, function (err, result) {
	            if (err) return next(err);
	            newObj[key] = result;
	            next();
	        });
	    }, function (err) {
	        callback(err, newObj);
	    });
	}
	
	/**
	 * A relative of [`map`]{@link module:Collections.map}, designed for use with objects.
	 *
	 * Produces a new Object by mapping each value of `obj` through the `iteratee`
	 * function. The `iteratee` is called each `value` and `key` from `obj` and a
	 * callback for when it has finished processing. Each of these callbacks takes
	 * two arguments: an `error`, and the transformed item from `obj`. If `iteratee`
	 * passes an error to its callback, the main `callback` (for the `mapValues`
	 * function) is immediately called with the error.
	 *
	 * Note, the order of the keys in the result is not guaranteed.  The keys will
	 * be roughly in the order they complete, (but this is very engine-specific)
	 *
	 * @name mapValues
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Object} obj - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - A function to apply to each value and key
	 * in `coll`.
	 * The iteratee should complete with the transformed value as its result.
	 * Invoked with (value, key, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. `result` is a new object consisting
	 * of each key from `obj`, with each transformed value on the right-hand side.
	 * Invoked with (err, result).
	 * @example
	 *
	 * async.mapValues({
	 *     f1: 'file1',
	 *     f2: 'file2',
	 *     f3: 'file3'
	 * }, function (file, key, callback) {
	 *   fs.stat(file, callback);
	 * }, function(err, result) {
	 *     // result is now a map of stats for each file, e.g.
	 *     // {
	 *     //     f1: [stats for file1],
	 *     //     f2: [stats for file2],
	 *     //     f3: [stats for file3]
	 *     // }
	 * });
	 */
	
	var mapValues = doLimit(mapValuesLimit, Infinity);
	
	/**
	 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs only a single async operation at a time.
	 *
	 * @name mapValuesSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.mapValues]{@link module:Collections.mapValues}
	 * @category Collection
	 * @param {Object} obj - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - A function to apply to each value and key
	 * in `coll`.
	 * The iteratee should complete with the transformed value as its result.
	 * Invoked with (value, key, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. `result` is a new object consisting
	 * of each key from `obj`, with each transformed value on the right-hand side.
	 * Invoked with (err, result).
	 */
	var mapValuesSeries = doLimit(mapValuesLimit, 1);
	
	function has(obj, key) {
	    return key in obj;
	}
	
	/**
	 * Caches the results of an async function. When creating a hash to store
	 * function results against, the callback is omitted from the hash and an
	 * optional hash function can be used.
	 *
	 * If no hash function is specified, the first argument is used as a hash key,
	 * which may work reasonably if it is a string or a data type that converts to a
	 * distinct string. Note that objects and arrays will not behave reasonably.
	 * Neither will cases where the other arguments are significant. In such cases,
	 * specify your own hash function.
	 *
	 * The cache of results is exposed as the `memo` property of the function
	 * returned by `memoize`.
	 *
	 * @name memoize
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {AsyncFunction} fn - The async function to proxy and cache results from.
	 * @param {Function} hasher - An optional function for generating a custom hash
	 * for storing results. It has all the arguments applied to it apart from the
	 * callback, and must be synchronous.
	 * @returns {AsyncFunction} a memoized version of `fn`
	 * @example
	 *
	 * var slow_fn = function(name, callback) {
	 *     // do something
	 *     callback(null, result);
	 * };
	 * var fn = async.memoize(slow_fn);
	 *
	 * // fn can now be used as if it were slow_fn
	 * fn('some name', function() {
	 *     // callback
	 * });
	 */
	function memoize(fn, hasher) {
	    var memo = Object.create(null);
	    var queues = Object.create(null);
	    hasher = hasher || identity;
	    var _fn = wrapAsync(fn);
	    var memoized = initialParams(function memoized(args, callback) {
	        var key = hasher.apply(null, args);
	        if (has(memo, key)) {
	            setImmediate$1(function() {
	                callback.apply(null, memo[key]);
	            });
	        } else if (has(queues, key)) {
	            queues[key].push(callback);
	        } else {
	            queues[key] = [callback];
	            _fn.apply(null, args.concat(function(/*args*/) {
	                var args = slice(arguments);
	                memo[key] = args;
	                var q = queues[key];
	                delete queues[key];
	                for (var i = 0, l = q.length; i < l; i++) {
	                    q[i].apply(null, args);
	                }
	            }));
	        }
	    });
	    memoized.memo = memo;
	    memoized.unmemoized = fn;
	    return memoized;
	}
	
	/**
	 * Calls `callback` on a later loop around the event loop. In Node.js this just
	 * calls `process.nextTick`.  In the browser it will use `setImmediate` if
	 * available, otherwise `setTimeout(callback, 0)`, which means other higher
	 * priority events may precede the execution of `callback`.
	 *
	 * This is used internally for browser-compatibility purposes.
	 *
	 * @name nextTick
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @see [async.setImmediate]{@link module:Utils.setImmediate}
	 * @category Util
	 * @param {Function} callback - The function to call on a later loop around
	 * the event loop. Invoked with (args...).
	 * @param {...*} args... - any number of additional arguments to pass to the
	 * callback on the next tick.
	 * @example
	 *
	 * var call_order = [];
	 * async.nextTick(function() {
	 *     call_order.push('two');
	 *     // call_order now equals ['one','two']
	 * });
	 * call_order.push('one');
	 *
	 * async.setImmediate(function (a, b, c) {
	 *     // a, b, and c equal 1, 2, and 3
	 * }, 1, 2, 3);
	 */
	var _defer$1;
	
	if (hasNextTick) {
	    _defer$1 = process.nextTick;
	} else if (hasSetImmediate) {
	    _defer$1 = setImmediate;
	} else {
	    _defer$1 = fallback;
	}
	
	var nextTick = wrap(_defer$1);
	
	function _parallel(eachfn, tasks, callback) {
	    callback = callback || noop;
	    var results = isArrayLike(tasks) ? [] : {};
	
	    eachfn(tasks, function (task, key, callback) {
	        wrapAsync(task)(function (err, result) {
	            if (arguments.length > 2) {
	                result = slice(arguments, 1);
	            }
	            results[key] = result;
	            callback(err);
	        });
	    }, function (err) {
	        callback(err, results);
	    });
	}
	
	/**
	 * Run the `tasks` collection of functions in parallel, without waiting until
	 * the previous function has completed. If any of the functions pass an error to
	 * its callback, the main `callback` is immediately called with the value of the
	 * error. Once the `tasks` have completed, the results are passed to the final
	 * `callback` as an array.
	 *
	 * **Note:** `parallel` is about kicking-off I/O tasks in parallel, not about
	 * parallel execution of code.  If your tasks do not use any timers or perform
	 * any I/O, they will actually be executed in series.  Any synchronous setup
	 * sections for each task will happen one after the other.  JavaScript remains
	 * single-threaded.
	 *
	 * **Hint:** Use [`reflect`]{@link module:Utils.reflect} to continue the
	 * execution of other tasks when a task fails.
	 *
	 * It is also possible to use an object instead of an array. Each property will
	 * be run as a function and the results will be passed to the final `callback`
	 * as an object instead of an array. This can be a more readable way of handling
	 * results from {@link async.parallel}.
	 *
	 * @name parallel
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array|Iterable|Object} tasks - A collection of
	 * [async functions]{@link AsyncFunction} to run.
	 * Each async function can complete with any number of optional `result` values.
	 * @param {Function} [callback] - An optional callback to run once all the
	 * functions have completed successfully. This function gets a results array
	 * (or object) containing all the result arguments passed to the task callbacks.
	 * Invoked with (err, results).
	 *
	 * @example
	 * async.parallel([
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'one');
	 *         }, 200);
	 *     },
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'two');
	 *         }, 100);
	 *     }
	 * ],
	 * // optional callback
	 * function(err, results) {
	 *     // the results array will equal ['one','two'] even though
	 *     // the second function had a shorter timeout.
	 * });
	 *
	 * // an example using an object instead of an array
	 * async.parallel({
	 *     one: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 1);
	 *         }, 200);
	 *     },
	 *     two: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 2);
	 *         }, 100);
	 *     }
	 * }, function(err, results) {
	 *     // results is now equals to: {one: 1, two: 2}
	 * });
	 */
	function parallelLimit(tasks, callback) {
	    _parallel(eachOf, tasks, callback);
	}
	
	/**
	 * The same as [`parallel`]{@link module:ControlFlow.parallel} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name parallelLimit
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.parallel]{@link module:ControlFlow.parallel}
	 * @category Control Flow
	 * @param {Array|Iterable|Object} tasks - A collection of
	 * [async functions]{@link AsyncFunction} to run.
	 * Each async function can complete with any number of optional `result` values.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} [callback] - An optional callback to run once all the
	 * functions have completed successfully. This function gets a results array
	 * (or object) containing all the result arguments passed to the task callbacks.
	 * Invoked with (err, results).
	 */
	function parallelLimit$1(tasks, limit, callback) {
	    _parallel(_eachOfLimit(limit), tasks, callback);
	}
	
	/**
	 * A queue of tasks for the worker function to complete.
	 * @typedef {Object} QueueObject
	 * @memberOf module:ControlFlow
	 * @property {Function} length - a function returning the number of items
	 * waiting to be processed. Invoke with `queue.length()`.
	 * @property {boolean} started - a boolean indicating whether or not any
	 * items have been pushed and processed by the queue.
	 * @property {Function} running - a function returning the number of items
	 * currently being processed. Invoke with `queue.running()`.
	 * @property {Function} workersList - a function returning the array of items
	 * currently being processed. Invoke with `queue.workersList()`.
	 * @property {Function} idle - a function returning false if there are items
	 * waiting or being processed, or true if not. Invoke with `queue.idle()`.
	 * @property {number} concurrency - an integer for determining how many `worker`
	 * functions should be run in parallel. This property can be changed after a
	 * `queue` is created to alter the concurrency on-the-fly.
	 * @property {Function} push - add a new task to the `queue`. Calls `callback`
	 * once the `worker` has finished processing the task. Instead of a single task,
	 * a `tasks` array can be submitted. The respective callback is used for every
	 * task in the list. Invoke with `queue.push(task, [callback])`,
	 * @property {Function} unshift - add a new task to the front of the `queue`.
	 * Invoke with `queue.unshift(task, [callback])`.
	 * @property {Function} remove - remove items from the queue that match a test
	 * function.  The test function will be passed an object with a `data` property,
	 * and a `priority` property, if this is a
	 * [priorityQueue]{@link module:ControlFlow.priorityQueue} object.
	 * Invoked with `queue.remove(testFn)`, where `testFn` is of the form
	 * `function ({data, priority}) {}` and returns a Boolean.
	 * @property {Function} saturated - a callback that is called when the number of
	 * running workers hits the `concurrency` limit, and further tasks will be
	 * queued.
	 * @property {Function} unsaturated - a callback that is called when the number
	 * of running workers is less than the `concurrency` & `buffer` limits, and
	 * further tasks will not be queued.
	 * @property {number} buffer - A minimum threshold buffer in order to say that
	 * the `queue` is `unsaturated`.
	 * @property {Function} empty - a callback that is called when the last item
	 * from the `queue` is given to a `worker`.
	 * @property {Function} drain - a callback that is called when the last item
	 * from the `queue` has returned from the `worker`.
	 * @property {Function} error - a callback that is called when a task errors.
	 * Has the signature `function(error, task)`.
	 * @property {boolean} paused - a boolean for determining whether the queue is
	 * in a paused state.
	 * @property {Function} pause - a function that pauses the processing of tasks
	 * until `resume()` is called. Invoke with `queue.pause()`.
	 * @property {Function} resume - a function that resumes the processing of
	 * queued tasks when the queue is paused. Invoke with `queue.resume()`.
	 * @property {Function} kill - a function that removes the `drain` callback and
	 * empties remaining tasks from the queue forcing it to go idle. No more tasks
	 * should be pushed to the queue after calling this function. Invoke with `queue.kill()`.
	 */
	
	/**
	 * Creates a `queue` object with the specified `concurrency`. Tasks added to the
	 * `queue` are processed in parallel (up to the `concurrency` limit). If all
	 * `worker`s are in progress, the task is queued until one becomes available.
	 * Once a `worker` completes a `task`, that `task`'s callback is called.
	 *
	 * @name queue
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {AsyncFunction} worker - An async function for processing a queued task.
	 * If you want to handle errors from an individual task, pass a callback to
	 * `q.push()`. Invoked with (task, callback).
	 * @param {number} [concurrency=1] - An `integer` for determining how many
	 * `worker` functions should be run in parallel.  If omitted, the concurrency
	 * defaults to `1`.  If the concurrency is `0`, an error is thrown.
	 * @returns {module:ControlFlow.QueueObject} A queue object to manage the tasks. Callbacks can
	 * attached as certain properties to listen for specific events during the
	 * lifecycle of the queue.
	 * @example
	 *
	 * // create a queue object with concurrency 2
	 * var q = async.queue(function(task, callback) {
	 *     console.log('hello ' + task.name);
	 *     callback();
	 * }, 2);
	 *
	 * // assign a callback
	 * q.drain = function() {
	 *     console.log('all items have been processed');
	 * };
	 *
	 * // add some items to the queue
	 * q.push({name: 'foo'}, function(err) {
	 *     console.log('finished processing foo');
	 * });
	 * q.push({name: 'bar'}, function (err) {
	 *     console.log('finished processing bar');
	 * });
	 *
	 * // add some items to the queue (batch-wise)
	 * q.push([{name: 'baz'},{name: 'bay'},{name: 'bax'}], function(err) {
	 *     console.log('finished processing item');
	 * });
	 *
	 * // add some items to the front of the queue
	 * q.unshift({name: 'bar'}, function (err) {
	 *     console.log('finished processing bar');
	 * });
	 */
	var queue$1 = function (worker, concurrency) {
	    var _worker = wrapAsync(worker);
	    return queue(function (items, cb) {
	        _worker(items[0], cb);
	    }, concurrency, 1);
	};
	
	/**
	 * The same as [async.queue]{@link module:ControlFlow.queue} only tasks are assigned a priority and
	 * completed in ascending priority order.
	 *
	 * @name priorityQueue
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.queue]{@link module:ControlFlow.queue}
	 * @category Control Flow
	 * @param {AsyncFunction} worker - An async function for processing a queued task.
	 * If you want to handle errors from an individual task, pass a callback to
	 * `q.push()`.
	 * Invoked with (task, callback).
	 * @param {number} concurrency - An `integer` for determining how many `worker`
	 * functions should be run in parallel.  If omitted, the concurrency defaults to
	 * `1`.  If the concurrency is `0`, an error is thrown.
	 * @returns {module:ControlFlow.QueueObject} A priorityQueue object to manage the tasks. There are two
	 * differences between `queue` and `priorityQueue` objects:
	 * * `push(task, priority, [callback])` - `priority` should be a number. If an
	 *   array of `tasks` is given, all tasks will be assigned the same priority.
	 * * The `unshift` method was removed.
	 */
	var priorityQueue = function(worker, concurrency) {
	    // Start with a normal queue
	    var q = queue$1(worker, concurrency);
	
	    // Override push to accept second parameter representing priority
	    q.push = function(data, priority, callback) {
	        if (callback == null) callback = noop;
	        if (typeof callback !== 'function') {
	            throw new Error('task callback must be a function');
	        }
	        q.started = true;
	        if (!isArray(data)) {
	            data = [data];
	        }
	        if (data.length === 0) {
	            // call drain immediately if there are no tasks
	            return setImmediate$1(function() {
	                q.drain();
	            });
	        }
	
	        priority = priority || 0;
	        var nextNode = q._tasks.head;
	        while (nextNode && priority >= nextNode.priority) {
	            nextNode = nextNode.next;
	        }
	
	        for (var i = 0, l = data.length; i < l; i++) {
	            var item = {
	                data: data[i],
	                priority: priority,
	                callback: callback
	            };
	
	            if (nextNode) {
	                q._tasks.insertBefore(nextNode, item);
	            } else {
	                q._tasks.push(item);
	            }
	        }
	        setImmediate$1(q.process);
	    };
	
	    // Remove unshift function
	    delete q.unshift;
	
	    return q;
	};
	
	/**
	 * Runs the `tasks` array of functions in parallel, without waiting until the
	 * previous function has completed. Once any of the `tasks` complete or pass an
	 * error to its callback, the main `callback` is immediately called. It's
	 * equivalent to `Promise.race()`.
	 *
	 * @name race
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array} tasks - An array containing [async functions]{@link AsyncFunction}
	 * to run. Each function can complete with an optional `result` value.
	 * @param {Function} callback - A callback to run once any of the functions have
	 * completed. This function gets an error or result from the first function that
	 * completed. Invoked with (err, result).
	 * @returns undefined
	 * @example
	 *
	 * async.race([
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'one');
	 *         }, 200);
	 *     },
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'two');
	 *         }, 100);
	 *     }
	 * ],
	 * // main callback
	 * function(err, result) {
	 *     // the result will be equal to 'two' as it finishes earlier
	 * });
	 */
	function race(tasks, callback) {
	    callback = once(callback || noop);
	    if (!isArray(tasks)) return callback(new TypeError('First argument to race must be an array of functions'));
	    if (!tasks.length) return callback();
	    for (var i = 0, l = tasks.length; i < l; i++) {
	        wrapAsync(tasks[i])(callback);
	    }
	}
	
	/**
	 * Same as [`reduce`]{@link module:Collections.reduce}, only operates on `array` in reverse order.
	 *
	 * @name reduceRight
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.reduce]{@link module:Collections.reduce}
	 * @alias foldr
	 * @category Collection
	 * @param {Array} array - A collection to iterate over.
	 * @param {*} memo - The initial state of the reduction.
	 * @param {AsyncFunction} iteratee - A function applied to each item in the
	 * array to produce the next step in the reduction.
	 * The `iteratee` should complete with the next state of the reduction.
	 * If the iteratee complete with an error, the reduction is stopped and the
	 * main `callback` is immediately called with the error.
	 * Invoked with (memo, item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result is the reduced value. Invoked with
	 * (err, result).
	 */
	function reduceRight (array, memo, iteratee, callback) {
	    var reversed = slice(array).reverse();
	    reduce(reversed, memo, iteratee, callback);
	}
	
	/**
	 * Wraps the async function in another function that always completes with a
	 * result object, even when it errors.
	 *
	 * The result object has either the property `error` or `value`.
	 *
	 * @name reflect
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {AsyncFunction} fn - The async function you want to wrap
	 * @returns {Function} - A function that always passes null to it's callback as
	 * the error. The second argument to the callback will be an `object` with
	 * either an `error` or a `value` property.
	 * @example
	 *
	 * async.parallel([
	 *     async.reflect(function(callback) {
	 *         // do some stuff ...
	 *         callback(null, 'one');
	 *     }),
	 *     async.reflect(function(callback) {
	 *         // do some more stuff but error ...
	 *         callback('bad stuff happened');
	 *     }),
	 *     async.reflect(function(callback) {
	 *         // do some more stuff ...
	 *         callback(null, 'two');
	 *     })
	 * ],
	 * // optional callback
	 * function(err, results) {
	 *     // values
	 *     // results[0].value = 'one'
	 *     // results[1].error = 'bad stuff happened'
	 *     // results[2].value = 'two'
	 * });
	 */
	function reflect(fn) {
	    var _fn = wrapAsync(fn);
	    return initialParams(function reflectOn(args, reflectCallback) {
	        args.push(function callback(error, cbArg) {
	            if (error) {
	                reflectCallback(null, { error: error });
	            } else {
	                var value;
	                if (arguments.length <= 2) {
	                    value = cbArg;
	                } else {
	                    value = slice(arguments, 1);
	                }
	                reflectCallback(null, { value: value });
	            }
	        });
	
	        return _fn.apply(this, args);
	    });
	}
	
	/**
	 * A helper function that wraps an array or an object of functions with `reflect`.
	 *
	 * @name reflectAll
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @see [async.reflect]{@link module:Utils.reflect}
	 * @category Util
	 * @param {Array|Object|Iterable} tasks - The collection of
	 * [async functions]{@link AsyncFunction} to wrap in `async.reflect`.
	 * @returns {Array} Returns an array of async functions, each wrapped in
	 * `async.reflect`
	 * @example
	 *
	 * let tasks = [
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'one');
	 *         }, 200);
	 *     },
	 *     function(callback) {
	 *         // do some more stuff but error ...
	 *         callback(new Error('bad stuff happened'));
	 *     },
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'two');
	 *         }, 100);
	 *     }
	 * ];
	 *
	 * async.parallel(async.reflectAll(tasks),
	 * // optional callback
	 * function(err, results) {
	 *     // values
	 *     // results[0].value = 'one'
	 *     // results[1].error = Error('bad stuff happened')
	 *     // results[2].value = 'two'
	 * });
	 *
	 * // an example using an object instead of an array
	 * let tasks = {
	 *     one: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'one');
	 *         }, 200);
	 *     },
	 *     two: function(callback) {
	 *         callback('two');
	 *     },
	 *     three: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'three');
	 *         }, 100);
	 *     }
	 * };
	 *
	 * async.parallel(async.reflectAll(tasks),
	 * // optional callback
	 * function(err, results) {
	 *     // values
	 *     // results.one.value = 'one'
	 *     // results.two.error = 'two'
	 *     // results.three.value = 'three'
	 * });
	 */
	function reflectAll(tasks) {
	    var results;
	    if (isArray(tasks)) {
	        results = arrayMap(tasks, reflect);
	    } else {
	        results = {};
	        baseForOwn(tasks, function(task, key) {
	            results[key] = reflect.call(this, task);
	        });
	    }
	    return results;
	}
	
	function reject$1(eachfn, arr, iteratee, callback) {
	    _filter(eachfn, arr, function(value, cb) {
	        iteratee(value, function(err, v) {
	            cb(err, !v);
	        });
	    }, callback);
	}
	
	/**
	 * The opposite of [`filter`]{@link module:Collections.filter}. Removes values that pass an `async` truth test.
	 *
	 * @name reject
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.filter]{@link module:Collections.filter}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - An async truth test to apply to each item in
	 * `coll`.
	 * The should complete with a boolean value as its `result`.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 * @example
	 *
	 * async.reject(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, results) {
	 *     // results now equals an array of missing files
	 *     createFiles(results);
	 * });
	 */
	var reject = doParallel(reject$1);
	
	/**
	 * The same as [`reject`]{@link module:Collections.reject} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name rejectLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.reject]{@link module:Collections.reject}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - An async truth test to apply to each item in
	 * `coll`.
	 * The should complete with a boolean value as its `result`.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 */
	var rejectLimit = doParallelLimit(reject$1);
	
	/**
	 * The same as [`reject`]{@link module:Collections.reject} but runs only a single async operation at a time.
	 *
	 * @name rejectSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.reject]{@link module:Collections.reject}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - An async truth test to apply to each item in
	 * `coll`.
	 * The should complete with a boolean value as its `result`.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 */
	var rejectSeries = doLimit(rejectLimit, 1);
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant$1(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * Attempts to get a successful response from `task` no more than `times` times
	 * before returning an error. If the task is successful, the `callback` will be
	 * passed the result of the successful task. If all attempts fail, the callback
	 * will be passed the error and result (if any) of the final attempt.
	 *
	 * @name retry
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @see [async.retryable]{@link module:ControlFlow.retryable}
	 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - Can be either an
	 * object with `times` and `interval` or a number.
	 * * `times` - The number of attempts to make before giving up.  The default
	 *   is `5`.
	 * * `interval` - The time to wait between retries, in milliseconds.  The
	 *   default is `0`. The interval may also be specified as a function of the
	 *   retry count (see example).
	 * * `errorFilter` - An optional synchronous function that is invoked on
	 *   erroneous result. If it returns `true` the retry attempts will continue;
	 *   if the function returns `false` the retry flow is aborted with the current
	 *   attempt's error and result being returned to the final callback.
	 *   Invoked with (err).
	 * * If `opts` is a number, the number specifies the number of times to retry,
	 *   with the default interval of `0`.
	 * @param {AsyncFunction} task - An async function to retry.
	 * Invoked with (callback).
	 * @param {Function} [callback] - An optional callback which is called when the
	 * task has succeeded, or after the final failed attempt. It receives the `err`
	 * and `result` arguments of the last attempt at completing the `task`. Invoked
	 * with (err, results).
	 *
	 * @example
	 *
	 * // The `retry` function can be used as a stand-alone control flow by passing
	 * // a callback, as shown below:
	 *
	 * // try calling apiMethod 3 times
	 * async.retry(3, apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // try calling apiMethod 3 times, waiting 200 ms between each retry
	 * async.retry({times: 3, interval: 200}, apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // try calling apiMethod 10 times with exponential backoff
	 * // (i.e. intervals of 100, 200, 400, 800, 1600, ... milliseconds)
	 * async.retry({
	 *   times: 10,
	 *   interval: function(retryCount) {
	 *     return 50 * Math.pow(2, retryCount);
	 *   }
	 * }, apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // try calling apiMethod the default 5 times no delay between each retry
	 * async.retry(apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // try calling apiMethod only when error condition satisfies, all other
	 * // errors will abort the retry control flow and return to final callback
	 * async.retry({
	 *   errorFilter: function(err) {
	 *     return err.message === 'Temporary error'; // only retry on a specific error
	 *   }
	 * }, apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // to retry individual methods that are not as reliable within other
	 * // control flow functions, use the `retryable` wrapper:
	 * async.auto({
	 *     users: api.getUsers.bind(api),
	 *     payments: async.retryable(3, api.getPayments.bind(api))
	 * }, function(err, results) {
	 *     // do something with the results
	 * });
	 *
	 */
	function retry(opts, task, callback) {
	    var DEFAULT_TIMES = 5;
	    var DEFAULT_INTERVAL = 0;
	
	    var options = {
	        times: DEFAULT_TIMES,
	        intervalFunc: constant$1(DEFAULT_INTERVAL)
	    };
	
	    function parseTimes(acc, t) {
	        if (typeof t === 'object') {
	            acc.times = +t.times || DEFAULT_TIMES;
	
	            acc.intervalFunc = typeof t.interval === 'function' ?
	                t.interval :
	                constant$1(+t.interval || DEFAULT_INTERVAL);
	
	            acc.errorFilter = t.errorFilter;
	        } else if (typeof t === 'number' || typeof t === 'string') {
	            acc.times = +t || DEFAULT_TIMES;
	        } else {
	            throw new Error("Invalid arguments for async.retry");
	        }
	    }
	
	    if (arguments.length < 3 && typeof opts === 'function') {
	        callback = task || noop;
	        task = opts;
	    } else {
	        parseTimes(options, opts);
	        callback = callback || noop;
	    }
	
	    if (typeof task !== 'function') {
	        throw new Error("Invalid arguments for async.retry");
	    }
	
	    var _task = wrapAsync(task);
	
	    var attempt = 1;
	    function retryAttempt() {
	        _task(function(err) {
	            if (err && attempt++ < options.times &&
	                (typeof options.errorFilter != 'function' ||
	                    options.errorFilter(err))) {
	                setTimeout(retryAttempt, options.intervalFunc(attempt));
	            } else {
	                callback.apply(null, arguments);
	            }
	        });
	    }
	
	    retryAttempt();
	}
	
	/**
	 * A close relative of [`retry`]{@link module:ControlFlow.retry}.  This method
	 * wraps a task and makes it retryable, rather than immediately calling it
	 * with retries.
	 *
	 * @name retryable
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.retry]{@link module:ControlFlow.retry}
	 * @category Control Flow
	 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - optional
	 * options, exactly the same as from `retry`
	 * @param {AsyncFunction} task - the asynchronous function to wrap.
	 * This function will be passed any arguments passed to the returned wrapper.
	 * Invoked with (...args, callback).
	 * @returns {AsyncFunction} The wrapped function, which when invoked, will
	 * retry on an error, based on the parameters specified in `opts`.
	 * This function will accept the same parameters as `task`.
	 * @example
	 *
	 * async.auto({
	 *     dep1: async.retryable(3, getFromFlakyService),
	 *     process: ["dep1", async.retryable(3, function (results, cb) {
	 *         maybeProcessData(results.dep1, cb);
	 *     })]
	 * }, callback);
	 */
	var retryable = function (opts, task) {
	    if (!task) {
	        task = opts;
	        opts = null;
	    }
	    var _task = wrapAsync(task);
	    return initialParams(function (args, callback) {
	        function taskFn(cb) {
	            _task.apply(null, args.concat(cb));
	        }
	
	        if (opts) retry(opts, taskFn, callback);
	        else retry(taskFn, callback);
	
	    });
	};
	
	/**
	 * Run the functions in the `tasks` collection in series, each one running once
	 * the previous function has completed. If any functions in the series pass an
	 * error to its callback, no more functions are run, and `callback` is
	 * immediately called with the value of the error. Otherwise, `callback`
	 * receives an array of results when `tasks` have completed.
	 *
	 * It is also possible to use an object instead of an array. Each property will
	 * be run as a function, and the results will be passed to the final `callback`
	 * as an object instead of an array. This can be a more readable way of handling
	 *  results from {@link async.series}.
	 *
	 * **Note** that while many implementations preserve the order of object
	 * properties, the [ECMAScript Language Specification](http://www.ecma-international.org/ecma-262/5.1/#sec-8.6)
	 * explicitly states that
	 *
	 * > The mechanics and order of enumerating the properties is not specified.
	 *
	 * So if you rely on the order in which your series of functions are executed,
	 * and want this to work on all platforms, consider using an array.
	 *
	 * @name series
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array|Iterable|Object} tasks - A collection containing
	 * [async functions]{@link AsyncFunction} to run in series.
	 * Each function can complete with any number of optional `result` values.
	 * @param {Function} [callback] - An optional callback to run once all the
	 * functions have completed. This function gets a results array (or object)
	 * containing all the result arguments passed to the `task` callbacks. Invoked
	 * with (err, result).
	 * @example
	 * async.series([
	 *     function(callback) {
	 *         // do some stuff ...
	 *         callback(null, 'one');
	 *     },
	 *     function(callback) {
	 *         // do some more stuff ...
	 *         callback(null, 'two');
	 *     }
	 * ],
	 * // optional callback
	 * function(err, results) {
	 *     // results is now equal to ['one', 'two']
	 * });
	 *
	 * async.series({
	 *     one: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 1);
	 *         }, 200);
	 *     },
	 *     two: function(callback){
	 *         setTimeout(function() {
	 *             callback(null, 2);
	 *         }, 100);
	 *     }
	 * }, function(err, results) {
	 *     // results is now equal to: {one: 1, two: 2}
	 * });
	 */
	function series(tasks, callback) {
	    _parallel(eachOfSeries, tasks, callback);
	}
	
	/**
	 * Returns `true` if at least one element in the `coll` satisfies an async test.
	 * If any iteratee call returns `true`, the main `callback` is immediately
	 * called.
	 *
	 * @name some
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias any
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	 * in the collections in parallel.
	 * The iteratee should complete with a boolean `result` value.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the iteratee functions have finished.
	 * Result will be either `true` or `false` depending on the values of the async
	 * tests. Invoked with (err, result).
	 * @example
	 *
	 * async.some(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, result) {
	 *     // if result is true then at least one of the files exists
	 * });
	 */
	var some = doParallel(_createTester(Boolean, identity));
	
	/**
	 * The same as [`some`]{@link module:Collections.some} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name someLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.some]{@link module:Collections.some}
	 * @alias anyLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	 * in the collections in parallel.
	 * The iteratee should complete with a boolean `result` value.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the iteratee functions have finished.
	 * Result will be either `true` or `false` depending on the values of the async
	 * tests. Invoked with (err, result).
	 */
	var someLimit = doParallelLimit(_createTester(Boolean, identity));
	
	/**
	 * The same as [`some`]{@link module:Collections.some} but runs only a single async operation at a time.
	 *
	 * @name someSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.some]{@link module:Collections.some}
	 * @alias anySeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	 * in the collections in series.
	 * The iteratee should complete with a boolean `result` value.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the iteratee functions have finished.
	 * Result will be either `true` or `false` depending on the values of the async
	 * tests. Invoked with (err, result).
	 */
	var someSeries = doLimit(someLimit, 1);
	
	/**
	 * Sorts a list by the results of running each `coll` value through an async
	 * `iteratee`.
	 *
	 * @name sortBy
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The iteratee should complete with a value to use as the sort criteria as
	 * its `result`.
	 * Invoked with (item, callback).
	 * @param {Function} callback - A callback which is called after all the
	 * `iteratee` functions have finished, or an error occurs. Results is the items
	 * from the original `coll` sorted by the values returned by the `iteratee`
	 * calls. Invoked with (err, results).
	 * @example
	 *
	 * async.sortBy(['file1','file2','file3'], function(file, callback) {
	 *     fs.stat(file, function(err, stats) {
	 *         callback(err, stats.mtime);
	 *     });
	 * }, function(err, results) {
	 *     // results is now the original array of files sorted by
	 *     // modified date
	 * });
	 *
	 * // By modifying the callback parameter the
	 * // sorting order can be influenced:
	 *
	 * // ascending order
	 * async.sortBy([1,9,3,5], function(x, callback) {
	 *     callback(null, x);
	 * }, function(err,result) {
	 *     // result callback
	 * });
	 *
	 * // descending order
	 * async.sortBy([1,9,3,5], function(x, callback) {
	 *     callback(null, x*-1);    //<- x*-1 instead of x, turns the order around
	 * }, function(err,result) {
	 *     // result callback
	 * });
	 */
	function sortBy (coll, iteratee, callback) {
	    var _iteratee = wrapAsync(iteratee);
	    map(coll, function (x, callback) {
	        _iteratee(x, function (err, criteria) {
	            if (err) return callback(err);
	            callback(null, {value: x, criteria: criteria});
	        });
	    }, function (err, results) {
	        if (err) return callback(err);
	        callback(null, arrayMap(results.sort(comparator), baseProperty('value')));
	    });
	
	    function comparator(left, right) {
	        var a = left.criteria, b = right.criteria;
	        return a < b ? -1 : a > b ? 1 : 0;
	    }
	}
	
	/**
	 * Sets a time limit on an asynchronous function. If the function does not call
	 * its callback within the specified milliseconds, it will be called with a
	 * timeout error. The code property for the error object will be `'ETIMEDOUT'`.
	 *
	 * @name timeout
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {AsyncFunction} asyncFn - The async function to limit in time.
	 * @param {number} milliseconds - The specified time limit.
	 * @param {*} [info] - Any variable you want attached (`string`, `object`, etc)
	 * to timeout Error for more information..
	 * @returns {AsyncFunction} Returns a wrapped function that can be used with any
	 * of the control flow functions.
	 * Invoke this function with the same parameters as you would `asyncFunc`.
	 * @example
	 *
	 * function myFunction(foo, callback) {
	 *     doAsyncTask(foo, function(err, data) {
	 *         // handle errors
	 *         if (err) return callback(err);
	 *
	 *         // do some stuff ...
	 *
	 *         // return processed data
	 *         return callback(null, data);
	 *     });
	 * }
	 *
	 * var wrapped = async.timeout(myFunction, 1000);
	 *
	 * // call `wrapped` as you would `myFunction`
	 * wrapped({ bar: 'bar' }, function(err, data) {
	 *     // if `myFunction` takes < 1000 ms to execute, `err`
	 *     // and `data` will have their expected values
	 *
	 *     // else `err` will be an Error with the code 'ETIMEDOUT'
	 * });
	 */
	function timeout(asyncFn, milliseconds, info) {
	    var fn = wrapAsync(asyncFn);
	
	    return initialParams(function (args, callback) {
	        var timedOut = false;
	        var timer;
	
	        function timeoutCallback() {
	            var name = asyncFn.name || 'anonymous';
	            var error  = new Error('Callback function "' + name + '" timed out.');
	            error.code = 'ETIMEDOUT';
	            if (info) {
	                error.info = info;
	            }
	            timedOut = true;
	            callback(error);
	        }
	
	        args.push(function () {
	            if (!timedOut) {
	                callback.apply(null, arguments);
	                clearTimeout(timer);
	            }
	        });
	
	        // setup timer and call original function
	        timer = setTimeout(timeoutCallback, milliseconds);
	        fn.apply(null, args);
	    });
	}
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil;
	var nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	/**
	 * The same as [times]{@link module:ControlFlow.times} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name timesLimit
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.times]{@link module:ControlFlow.times}
	 * @category Control Flow
	 * @param {number} count - The number of times to run the function.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - The async function to call `n` times.
	 * Invoked with the iteration index and a callback: (n, next).
	 * @param {Function} callback - see [async.map]{@link module:Collections.map}.
	 */
	function timeLimit(count, limit, iteratee, callback) {
	    var _iteratee = wrapAsync(iteratee);
	    mapLimit(baseRange(0, count, 1), limit, _iteratee, callback);
	}
	
	/**
	 * Calls the `iteratee` function `n` times, and accumulates results in the same
	 * manner you would use with [map]{@link module:Collections.map}.
	 *
	 * @name times
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.map]{@link module:Collections.map}
	 * @category Control Flow
	 * @param {number} n - The number of times to run the function.
	 * @param {AsyncFunction} iteratee - The async function to call `n` times.
	 * Invoked with the iteration index and a callback: (n, next).
	 * @param {Function} callback - see {@link module:Collections.map}.
	 * @example
	 *
	 * // Pretend this is some complicated async factory
	 * var createUser = function(id, callback) {
	 *     callback(null, {
	 *         id: 'user' + id
	 *     });
	 * };
	 *
	 * // generate 5 users
	 * async.times(5, function(n, next) {
	 *     createUser(n, function(err, user) {
	 *         next(err, user);
	 *     });
	 * }, function(err, users) {
	 *     // we should now have 5 users
	 * });
	 */
	var times = doLimit(timeLimit, Infinity);
	
	/**
	 * The same as [times]{@link module:ControlFlow.times} but runs only a single async operation at a time.
	 *
	 * @name timesSeries
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.times]{@link module:ControlFlow.times}
	 * @category Control Flow
	 * @param {number} n - The number of times to run the function.
	 * @param {AsyncFunction} iteratee - The async function to call `n` times.
	 * Invoked with the iteration index and a callback: (n, next).
	 * @param {Function} callback - see {@link module:Collections.map}.
	 */
	var timesSeries = doLimit(timeLimit, 1);
	
	/**
	 * A relative of `reduce`.  Takes an Object or Array, and iterates over each
	 * element in series, each step potentially mutating an `accumulator` value.
	 * The type of the accumulator defaults to the type of collection passed in.
	 *
	 * @name transform
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {*} [accumulator] - The initial state of the transform.  If omitted,
	 * it will default to an empty Object or Array, depending on the type of `coll`
	 * @param {AsyncFunction} iteratee - A function applied to each item in the
	 * collection that potentially modifies the accumulator.
	 * Invoked with (accumulator, item, key, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result is the transformed accumulator.
	 * Invoked with (err, result).
	 * @example
	 *
	 * async.transform([1,2,3], function(acc, item, index, callback) {
	 *     // pointless async:
	 *     process.nextTick(function() {
	 *         acc.push(item * 2)
	 *         callback(null)
	 *     });
	 * }, function(err, result) {
	 *     // result is now equal to [2, 4, 6]
	 * });
	 *
	 * @example
	 *
	 * async.transform({a: 1, b: 2, c: 3}, function (obj, val, key, callback) {
	 *     setImmediate(function () {
	 *         obj[key] = val * 2;
	 *         callback();
	 *     })
	 * }, function (err, result) {
	 *     // result is equal to {a: 2, b: 4, c: 6}
	 * })
	 */
	function transform (coll, accumulator, iteratee, callback) {
	    if (arguments.length <= 3) {
	        callback = iteratee;
	        iteratee = accumulator;
	        accumulator = isArray(coll) ? [] : {};
	    }
	    callback = once(callback || noop);
	    var _iteratee = wrapAsync(iteratee);
	
	    eachOf(coll, function(v, k, cb) {
	        _iteratee(accumulator, v, k, cb);
	    }, function(err) {
	        callback(err, accumulator);
	    });
	}
	
	/**
	 * It runs each task in series but stops whenever any of the functions were
	 * successful. If one of the tasks were successful, the `callback` will be
	 * passed the result of the successful task. If all tasks fail, the callback
	 * will be passed the error and result (if any) of the final attempt.
	 *
	 * @name tryEach
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array|Iterable|Object} tasks - A collection containing functions to
	 * run, each function is passed a `callback(err, result)` it must call on
	 * completion with an error `err` (which can be `null`) and an optional `result`
	 * value.
	 * @param {Function} [callback] - An optional callback which is called when one
	 * of the tasks has succeeded, or all have failed. It receives the `err` and
	 * `result` arguments of the last attempt at completing the `task`. Invoked with
	 * (err, results).
	 * @example
	 * async.tryEach([
	 *     function getDataFromFirstWebsite(callback) {
	 *         // Try getting the data from the first website
	 *         callback(err, data);
	 *     },
	 *     function getDataFromSecondWebsite(callback) {
	 *         // First website failed,
	 *         // Try getting the data from the backup website
	 *         callback(err, data);
	 *     }
	 * ],
	 * // optional callback
	 * function(err, results) {
	 *     Now do something with the data.
	 * });
	 *
	 */
	function tryEach(tasks, callback) {
	    var error = null;
	    var result;
	    callback = callback || noop;
	    eachSeries(tasks, function(task, callback) {
	        wrapAsync(task)(function (err, res/*, ...args*/) {
	            if (arguments.length > 2) {
	                result = slice(arguments, 1);
	            } else {
	                result = res;
	            }
	            error = err;
	            callback(!err);
	        });
	    }, function () {
	        callback(error, result);
	    });
	}
	
	/**
	 * Undoes a [memoize]{@link module:Utils.memoize}d function, reverting it to the original,
	 * unmemoized form. Handy for testing.
	 *
	 * @name unmemoize
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @see [async.memoize]{@link module:Utils.memoize}
	 * @category Util
	 * @param {AsyncFunction} fn - the memoized function
	 * @returns {AsyncFunction} a function that calls the original unmemoized function
	 */
	function unmemoize(fn) {
	    return function () {
	        return (fn.unmemoized || fn).apply(null, arguments);
	    };
	}
	
	/**
	 * Repeatedly call `iteratee`, while `test` returns `true`. Calls `callback` when
	 * stopped, or an error occurs.
	 *
	 * @name whilst
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Function} test - synchronous truth test to perform before each
	 * execution of `iteratee`. Invoked with ().
	 * @param {AsyncFunction} iteratee - An async function which is called each time
	 * `test` passes. Invoked with (callback).
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has failed and repeated execution of `iteratee` has stopped. `callback`
	 * will be passed an error and any arguments passed to the final `iteratee`'s
	 * callback. Invoked with (err, [results]);
	 * @returns undefined
	 * @example
	 *
	 * var count = 0;
	 * async.whilst(
	 *     function() { return count < 5; },
	 *     function(callback) {
	 *         count++;
	 *         setTimeout(function() {
	 *             callback(null, count);
	 *         }, 1000);
	 *     },
	 *     function (err, n) {
	 *         // 5 seconds have passed, n = 5
	 *     }
	 * );
	 */
	function whilst(test, iteratee, callback) {
	    callback = onlyOnce(callback || noop);
	    var _iteratee = wrapAsync(iteratee);
	    if (!test()) return callback(null);
	    var next = function(err/*, ...args*/) {
	        if (err) return callback(err);
	        if (test()) return _iteratee(next);
	        var args = slice(arguments, 1);
	        callback.apply(null, [null].concat(args));
	    };
	    _iteratee(next);
	}
	
	/**
	 * Repeatedly call `iteratee` until `test` returns `true`. Calls `callback` when
	 * stopped, or an error occurs. `callback` will be passed an error and any
	 * arguments passed to the final `iteratee`'s callback.
	 *
	 * The inverse of [whilst]{@link module:ControlFlow.whilst}.
	 *
	 * @name until
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.whilst]{@link module:ControlFlow.whilst}
	 * @category Control Flow
	 * @param {Function} test - synchronous truth test to perform before each
	 * execution of `iteratee`. Invoked with ().
	 * @param {AsyncFunction} iteratee - An async function which is called each time
	 * `test` fails. Invoked with (callback).
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has passed and repeated execution of `iteratee` has stopped. `callback`
	 * will be passed an error and any arguments passed to the final `iteratee`'s
	 * callback. Invoked with (err, [results]);
	 */
	function until(test, iteratee, callback) {
	    whilst(function() {
	        return !test.apply(this, arguments);
	    }, iteratee, callback);
	}
	
	/**
	 * Runs the `tasks` array of functions in series, each passing their results to
	 * the next in the array. However, if any of the `tasks` pass an error to their
	 * own callback, the next function is not executed, and the main `callback` is
	 * immediately called with the error.
	 *
	 * @name waterfall
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array} tasks - An array of [async functions]{@link AsyncFunction}
	 * to run.
	 * Each function should complete with any number of `result` values.
	 * The `result` values will be passed as arguments, in order, to the next task.
	 * @param {Function} [callback] - An optional callback to run once all the
	 * functions have completed. This will be passed the results of the last task's
	 * callback. Invoked with (err, [results]).
	 * @returns undefined
	 * @example
	 *
	 * async.waterfall([
	 *     function(callback) {
	 *         callback(null, 'one', 'two');
	 *     },
	 *     function(arg1, arg2, callback) {
	 *         // arg1 now equals 'one' and arg2 now equals 'two'
	 *         callback(null, 'three');
	 *     },
	 *     function(arg1, callback) {
	 *         // arg1 now equals 'three'
	 *         callback(null, 'done');
	 *     }
	 * ], function (err, result) {
	 *     // result now equals 'done'
	 * });
	 *
	 * // Or, with named functions:
	 * async.waterfall([
	 *     myFirstFunction,
	 *     mySecondFunction,
	 *     myLastFunction,
	 * ], function (err, result) {
	 *     // result now equals 'done'
	 * });
	 * function myFirstFunction(callback) {
	 *     callback(null, 'one', 'two');
	 * }
	 * function mySecondFunction(arg1, arg2, callback) {
	 *     // arg1 now equals 'one' and arg2 now equals 'two'
	 *     callback(null, 'three');
	 * }
	 * function myLastFunction(arg1, callback) {
	 *     // arg1 now equals 'three'
	 *     callback(null, 'done');
	 * }
	 */
	var waterfall = function(tasks, callback) {
	    callback = once(callback || noop);
	    if (!isArray(tasks)) return callback(new Error('First argument to waterfall must be an array of functions'));
	    if (!tasks.length) return callback();
	    var taskIndex = 0;
	
	    function nextTask(args) {
	        var task = wrapAsync(tasks[taskIndex++]);
	        args.push(onlyOnce(next));
	        task.apply(null, args);
	    }
	
	    function next(err/*, ...args*/) {
	        if (err || taskIndex === tasks.length) {
	            return callback.apply(null, arguments);
	        }
	        nextTask(slice(arguments, 1));
	    }
	
	    nextTask([]);
	};
	
	/**
	 * An "async function" in the context of Async is an asynchronous function with
	 * a variable number of parameters, with the final parameter being a callback.
	 * (`function (arg1, arg2, ..., callback) {}`)
	 * The final callback is of the form `callback(err, results...)`, which must be
	 * called once the function is completed.  The callback should be called with a
	 * Error as its first argument to signal that an error occurred.
	 * Otherwise, if no error occurred, it should be called with `null` as the first
	 * argument, and any additional `result` arguments that may apply, to signal
	 * successful completion.
	 * The callback must be called exactly once, ideally on a later tick of the
	 * JavaScript event loop.
	 *
	 * This type of function is also referred to as a "Node-style async function",
	 * or a "continuation passing-style function" (CPS). Most of the methods of this
	 * library are themselves CPS/Node-style async functions, or functions that
	 * return CPS/Node-style async functions.
	 *
	 * Wherever we accept a Node-style async function, we also directly accept an
	 * [ES2017 `async` function]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function}.
	 * In this case, the `async` function will not be passed a final callback
	 * argument, and any thrown error will be used as the `err` argument of the
	 * implicit callback, and the return value will be used as the `result` value.
	 * (i.e. a `rejected` of the returned Promise becomes the `err` callback
	 * argument, and a `resolved` value becomes the `result`.)
	 *
	 * Note, due to JavaScript limitations, we can only detect native `async`
	 * functions and not transpilied implementations.
	 * Your environment must have `async`/`await` support for this to work.
	 * (e.g. Node > v7.6, or a recent version of a modern browser).
	 * If you are using `async` functions through a transpiler (e.g. Babel), you
	 * must still wrap the function with [asyncify]{@link module:Utils.asyncify},
	 * because the `async function` will be compiled to an ordinary function that
	 * returns a promise.
	 *
	 * @typedef {Function} AsyncFunction
	 * @static
	 */
	
	/**
	 * Async is a utility module which provides straight-forward, powerful functions
	 * for working with asynchronous JavaScript. Although originally designed for
	 * use with [Node.js](http://nodejs.org) and installable via
	 * `npm install --save async`, it can also be used directly in the browser.
	 * @module async
	 * @see AsyncFunction
	 */
	
	
	/**
	 * A collection of `async` functions for manipulating collections, such as
	 * arrays and objects.
	 * @module Collections
	 */
	
	/**
	 * A collection of `async` functions for controlling the flow through a script.
	 * @module ControlFlow
	 */
	
	/**
	 * A collection of `async` utility functions.
	 * @module Utils
	 */
	
	var index = {
	    apply: apply,
	    applyEach: applyEach,
	    applyEachSeries: applyEachSeries,
	    asyncify: asyncify,
	    auto: auto,
	    autoInject: autoInject,
	    cargo: cargo,
	    compose: compose,
	    concat: concat,
	    concatLimit: concatLimit,
	    concatSeries: concatSeries,
	    constant: constant,
	    detect: detect,
	    detectLimit: detectLimit,
	    detectSeries: detectSeries,
	    dir: dir,
	    doDuring: doDuring,
	    doUntil: doUntil,
	    doWhilst: doWhilst,
	    during: during,
	    each: eachLimit,
	    eachLimit: eachLimit$1,
	    eachOf: eachOf,
	    eachOfLimit: eachOfLimit,
	    eachOfSeries: eachOfSeries,
	    eachSeries: eachSeries,
	    ensureAsync: ensureAsync,
	    every: every,
	    everyLimit: everyLimit,
	    everySeries: everySeries,
	    filter: filter,
	    filterLimit: filterLimit,
	    filterSeries: filterSeries,
	    forever: forever,
	    groupBy: groupBy,
	    groupByLimit: groupByLimit,
	    groupBySeries: groupBySeries,
	    log: log,
	    map: map,
	    mapLimit: mapLimit,
	    mapSeries: mapSeries,
	    mapValues: mapValues,
	    mapValuesLimit: mapValuesLimit,
	    mapValuesSeries: mapValuesSeries,
	    memoize: memoize,
	    nextTick: nextTick,
	    parallel: parallelLimit,
	    parallelLimit: parallelLimit$1,
	    priorityQueue: priorityQueue,
	    queue: queue$1,
	    race: race,
	    reduce: reduce,
	    reduceRight: reduceRight,
	    reflect: reflect,
	    reflectAll: reflectAll,
	    reject: reject,
	    rejectLimit: rejectLimit,
	    rejectSeries: rejectSeries,
	    retry: retry,
	    retryable: retryable,
	    seq: seq,
	    series: series,
	    setImmediate: setImmediate$1,
	    some: some,
	    someLimit: someLimit,
	    someSeries: someSeries,
	    sortBy: sortBy,
	    timeout: timeout,
	    times: times,
	    timesLimit: timeLimit,
	    timesSeries: timesSeries,
	    transform: transform,
	    tryEach: tryEach,
	    unmemoize: unmemoize,
	    until: until,
	    waterfall: waterfall,
	    whilst: whilst,
	
	    // aliases
	    all: every,
	    allLimit: everyLimit,
	    allSeries: everySeries,
	    any: some,
	    anyLimit: someLimit,
	    anySeries: someSeries,
	    find: detect,
	    findLimit: detectLimit,
	    findSeries: detectSeries,
	    forEach: eachLimit,
	    forEachSeries: eachSeries,
	    forEachLimit: eachLimit$1,
	    forEachOf: eachOf,
	    forEachOfSeries: eachOfSeries,
	    forEachOfLimit: eachOfLimit,
	    inject: reduce,
	    foldl: reduce,
	    foldr: reduceRight,
	    select: filter,
	    selectLimit: filterLimit,
	    selectSeries: filterSeries,
	    wrapSync: asyncify
	};
	
	exports['default'] = index;
	exports.apply = apply;
	exports.applyEach = applyEach;
	exports.applyEachSeries = applyEachSeries;
	exports.asyncify = asyncify;
	exports.auto = auto;
	exports.autoInject = autoInject;
	exports.cargo = cargo;
	exports.compose = compose;
	exports.concat = concat;
	exports.concatLimit = concatLimit;
	exports.concatSeries = concatSeries;
	exports.constant = constant;
	exports.detect = detect;
	exports.detectLimit = detectLimit;
	exports.detectSeries = detectSeries;
	exports.dir = dir;
	exports.doDuring = doDuring;
	exports.doUntil = doUntil;
	exports.doWhilst = doWhilst;
	exports.during = during;
	exports.each = eachLimit;
	exports.eachLimit = eachLimit$1;
	exports.eachOf = eachOf;
	exports.eachOfLimit = eachOfLimit;
	exports.eachOfSeries = eachOfSeries;
	exports.eachSeries = eachSeries;
	exports.ensureAsync = ensureAsync;
	exports.every = every;
	exports.everyLimit = everyLimit;
	exports.everySeries = everySeries;
	exports.filter = filter;
	exports.filterLimit = filterLimit;
	exports.filterSeries = filterSeries;
	exports.forever = forever;
	exports.groupBy = groupBy;
	exports.groupByLimit = groupByLimit;
	exports.groupBySeries = groupBySeries;
	exports.log = log;
	exports.map = map;
	exports.mapLimit = mapLimit;
	exports.mapSeries = mapSeries;
	exports.mapValues = mapValues;
	exports.mapValuesLimit = mapValuesLimit;
	exports.mapValuesSeries = mapValuesSeries;
	exports.memoize = memoize;
	exports.nextTick = nextTick;
	exports.parallel = parallelLimit;
	exports.parallelLimit = parallelLimit$1;
	exports.priorityQueue = priorityQueue;
	exports.queue = queue$1;
	exports.race = race;
	exports.reduce = reduce;
	exports.reduceRight = reduceRight;
	exports.reflect = reflect;
	exports.reflectAll = reflectAll;
	exports.reject = reject;
	exports.rejectLimit = rejectLimit;
	exports.rejectSeries = rejectSeries;
	exports.retry = retry;
	exports.retryable = retryable;
	exports.seq = seq;
	exports.series = series;
	exports.setImmediate = setImmediate$1;
	exports.some = some;
	exports.someLimit = someLimit;
	exports.someSeries = someSeries;
	exports.sortBy = sortBy;
	exports.timeout = timeout;
	exports.times = times;
	exports.timesLimit = timeLimit;
	exports.timesSeries = timesSeries;
	exports.transform = transform;
	exports.tryEach = tryEach;
	exports.unmemoize = unmemoize;
	exports.until = until;
	exports.waterfall = waterfall;
	exports.whilst = whilst;
	exports.all = every;
	exports.allLimit = everyLimit;
	exports.allSeries = everySeries;
	exports.any = some;
	exports.anyLimit = someLimit;
	exports.anySeries = someSeries;
	exports.find = detect;
	exports.findLimit = detectLimit;
	exports.findSeries = detectSeries;
	exports.forEach = eachLimit;
	exports.forEachSeries = eachSeries;
	exports.forEachLimit = eachLimit$1;
	exports.forEachOf = eachOf;
	exports.forEachOfSeries = eachOfSeries;
	exports.forEachOfLimit = eachOfLimit;
	exports.inject = reduce;
	exports.foldl = reduce;
	exports.foldr = reduceRight;
	exports.select = filter;
	exports.selectLimit = filterLimit;
	exports.selectSeries = filterSeries;
	exports.wrapSync = asyncify;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1095).setImmediate, __webpack_require__(235), (function() { return this; }()), __webpack_require__(671)(module)))

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1558);


/***/ },
/* 676 */,
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(921)
	  , core      = __webpack_require__(466)
	  , ctx       = __webpack_require__(918)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ },
/* 678 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(216)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(374)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 680 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	* @version: 3.1
	* @author: Dan Grossman http://www.dangrossman.info/
	* @copyright: Copyright (c) 2012-2019 Dan Grossman. All rights reserved.
	* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
	* @website: http://www.daterangepicker.com/
	*/
	// Following the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
	(function (root, factory) {
	    if (true) {
	        // AMD. Make globaly available as well
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function (moment, jquery) {
	            if (!jquery.fn) jquery.fn = {}; // webpack server rendering
	            if (typeof moment !== 'function' && moment.hasOwnProperty('default')) moment = moment['default']
	            return factory(moment, jquery);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        // Node / Browserify
	        //isomorphic issue
	        var jQuery = (typeof window != 'undefined') ? window.jQuery : undefined;
	        if (!jQuery) {
	            jQuery = require('jquery');
	            if (!jQuery.fn) jQuery.fn = {};
	        }
	        var moment = (typeof window != 'undefined' && typeof window.moment != 'undefined') ? window.moment : require('moment');
	        module.exports = factory(moment, jQuery);
	    } else {
	        // Browser globals
	        root.daterangepicker = factory(root.moment, root.jQuery);
	    }
	}(this, function(moment, $) {
	    var DateRangePicker = function(element, options, cb) {
	
	        //default settings for options
	        this.parentEl = 'body';
	        this.element = $(element);
	        this.startDate = moment().startOf('day');
	        this.endDate = moment().endOf('day');
	        this.minDate = false;
	        this.maxDate = false;
	        this.maxSpan = false;
	        this.autoApply = false;
	        this.singleDatePicker = false;
	        this.showDropdowns = false;
	        this.minYear = moment().subtract(100, 'year').format('YYYY');
	        this.maxYear = moment().add(100, 'year').format('YYYY');
	        this.showWeekNumbers = false;
	        this.showISOWeekNumbers = false;
	        this.showCustomRangeLabel = true;
	        this.timePicker = false;
	        this.timePicker24Hour = false;
	        this.timePickerIncrement = 1;
	        this.timePickerSeconds = false;
	        this.linkedCalendars = true;
	        this.autoUpdateInput = true;
	        this.alwaysShowCalendars = false;
	        this.ranges = {};
	
	        this.opens = 'right';
	        if (this.element.hasClass('pull-right'))
	            this.opens = 'left';
	
	        this.drops = 'down';
	        if (this.element.hasClass('dropup'))
	            this.drops = 'up';
	
	        this.buttonClasses = 'btn btn-sm';
	        this.applyButtonClasses = 'btn-primary';
	        this.cancelButtonClasses = 'btn-default';
	
	        this.locale = {
	            direction: 'ltr',
	            format: moment.localeData().longDateFormat('L'),
	            separator: ' - ',
	            applyLabel: 'Apply',
	            cancelLabel: 'Cancel',
	            weekLabel: 'W',
	            customRangeLabel: 'Custom Range',
	            daysOfWeek: moment.weekdaysMin(),
	            monthNames: moment.monthsShort(),
	            firstDay: moment.localeData().firstDayOfWeek()
	        };
	
	        this.callback = function() { };
	
	        //some state information
	        this.isShowing = false;
	        this.leftCalendar = {};
	        this.rightCalendar = {};
	
	        //custom options from user
	        if (typeof options !== 'object' || options === null)
	            options = {};
	
	        //allow setting options with data attributes
	        //data-api options will be overwritten with custom javascript options
	        options = $.extend(this.element.data(), options);
	
	        //html template for the picker UI
	        if (typeof options.template !== 'string' && !(options.template instanceof $))
	            options.template =
	            '<div class="daterangepicker">' +
	                '<div class="ranges"></div>' +
	                '<div class="drp-calendar left">' +
	                    '<div class="calendar-table"></div>' +
	                    '<div class="calendar-time"></div>' +
	                '</div>' +
	                '<div class="drp-calendar right">' +
	                    '<div class="calendar-table"></div>' +
	                    '<div class="calendar-time"></div>' +
	                '</div>' +
	                '<div class="drp-buttons">' +
	                    '<span class="drp-selected"></span>' +
	                    '<button class="cancelBtn" type="button"></button>' +
	                    '<button class="applyBtn" disabled="disabled" type="button"></button> ' +
	                '</div>' +
	            '</div>';
	
	        this.parentEl = (options.parentEl && $(options.parentEl).length) ? $(options.parentEl) : $(this.parentEl);
	        this.container = $(options.template).appendTo(this.parentEl);
	
	        //
	        // handle all the possible options overriding defaults
	        //
	
	        if (typeof options.locale === 'object') {
	
	            if (typeof options.locale.direction === 'string')
	                this.locale.direction = options.locale.direction;
	
	            if (typeof options.locale.format === 'string')
	                this.locale.format = options.locale.format;
	
	            if (typeof options.locale.separator === 'string')
	                this.locale.separator = options.locale.separator;
	
	            if (typeof options.locale.daysOfWeek === 'object')
	                this.locale.daysOfWeek = options.locale.daysOfWeek.slice();
	
	            if (typeof options.locale.monthNames === 'object')
	              this.locale.monthNames = options.locale.monthNames.slice();
	
	            if (typeof options.locale.firstDay === 'number')
	              this.locale.firstDay = options.locale.firstDay;
	
	            if (typeof options.locale.applyLabel === 'string')
	              this.locale.applyLabel = options.locale.applyLabel;
	
	            if (typeof options.locale.cancelLabel === 'string')
	              this.locale.cancelLabel = options.locale.cancelLabel;
	
	            if (typeof options.locale.weekLabel === 'string')
	              this.locale.weekLabel = options.locale.weekLabel;
	
	            if (typeof options.locale.customRangeLabel === 'string'){
	                //Support unicode chars in the custom range name.
	                var elem = document.createElement('textarea');
	                elem.innerHTML = options.locale.customRangeLabel;
	                var rangeHtml = elem.value;
	                this.locale.customRangeLabel = rangeHtml;
	            }
	        }
	        this.container.addClass(this.locale.direction);
	
	        if (typeof options.startDate === 'string')
	            this.startDate = moment(options.startDate, this.locale.format);
	
	        if (typeof options.endDate === 'string')
	            this.endDate = moment(options.endDate, this.locale.format);
	
	        if (typeof options.minDate === 'string')
	            this.minDate = moment(options.minDate, this.locale.format);
	
	        if (typeof options.maxDate === 'string')
	            this.maxDate = moment(options.maxDate, this.locale.format);
	
	        if (typeof options.startDate === 'object')
	            this.startDate = moment(options.startDate);
	
	        if (typeof options.endDate === 'object')
	            this.endDate = moment(options.endDate);
	
	        if (typeof options.minDate === 'object')
	            this.minDate = moment(options.minDate);
	
	        if (typeof options.maxDate === 'object')
	            this.maxDate = moment(options.maxDate);
	
	        // sanity check for bad options
	        if (this.minDate && this.startDate.isBefore(this.minDate))
	            this.startDate = this.minDate.clone();
	
	        // sanity check for bad options
	        if (this.maxDate && this.endDate.isAfter(this.maxDate))
	            this.endDate = this.maxDate.clone();
	
	        if (typeof options.applyButtonClasses === 'string')
	            this.applyButtonClasses = options.applyButtonClasses;
	
	        if (typeof options.applyClass === 'string') //backwards compat
	            this.applyButtonClasses = options.applyClass;
	
	        if (typeof options.cancelButtonClasses === 'string')
	            this.cancelButtonClasses = options.cancelButtonClasses;
	
	        if (typeof options.cancelClass === 'string') //backwards compat
	            this.cancelButtonClasses = options.cancelClass;
	
	        if (typeof options.maxSpan === 'object')
	            this.maxSpan = options.maxSpan;
	
	        if (typeof options.dateLimit === 'object') //backwards compat
	            this.maxSpan = options.dateLimit;
	
	        if (typeof options.opens === 'string')
	            this.opens = options.opens;
	
	        if (typeof options.drops === 'string')
	            this.drops = options.drops;
	
	        if (typeof options.showWeekNumbers === 'boolean')
	            this.showWeekNumbers = options.showWeekNumbers;
	
	        if (typeof options.showISOWeekNumbers === 'boolean')
	            this.showISOWeekNumbers = options.showISOWeekNumbers;
	
	        if (typeof options.buttonClasses === 'string')
	            this.buttonClasses = options.buttonClasses;
	
	        if (typeof options.buttonClasses === 'object')
	            this.buttonClasses = options.buttonClasses.join(' ');
	
	        if (typeof options.showDropdowns === 'boolean')
	            this.showDropdowns = options.showDropdowns;
	
	        if (typeof options.minYear === 'number')
	            this.minYear = options.minYear;
	
	        if (typeof options.maxYear === 'number')
	            this.maxYear = options.maxYear;
	
	        if (typeof options.showCustomRangeLabel === 'boolean')
	            this.showCustomRangeLabel = options.showCustomRangeLabel;
	
	        if (typeof options.singleDatePicker === 'boolean') {
	            this.singleDatePicker = options.singleDatePicker;
	            if (this.singleDatePicker)
	                this.endDate = this.startDate.clone();
	        }
	
	        if (typeof options.timePicker === 'boolean')
	            this.timePicker = options.timePicker;
	
	        if (typeof options.timePickerSeconds === 'boolean')
	            this.timePickerSeconds = options.timePickerSeconds;
	
	        if (typeof options.timePickerIncrement === 'number')
	            this.timePickerIncrement = options.timePickerIncrement;
	
	        if (typeof options.timePicker24Hour === 'boolean')
	            this.timePicker24Hour = options.timePicker24Hour;
	
	        if (typeof options.autoApply === 'boolean')
	            this.autoApply = options.autoApply;
	
	        if (typeof options.autoUpdateInput === 'boolean')
	            this.autoUpdateInput = options.autoUpdateInput;
	
	        if (typeof options.linkedCalendars === 'boolean')
	            this.linkedCalendars = options.linkedCalendars;
	
	        if (typeof options.isInvalidDate === 'function')
	            this.isInvalidDate = options.isInvalidDate;
	
	        if (typeof options.isCustomDate === 'function')
	            this.isCustomDate = options.isCustomDate;
	
	        if (typeof options.alwaysShowCalendars === 'boolean')
	            this.alwaysShowCalendars = options.alwaysShowCalendars;
	
	        // update day names order to firstDay
	        if (this.locale.firstDay != 0) {
	            var iterator = this.locale.firstDay;
	            while (iterator > 0) {
	                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
	                iterator--;
	            }
	        }
	
	        var start, end, range;
	
	        //if no start/end dates set, check if an input element contains initial values
	        if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
	            if ($(this.element).is(':text')) {
	                var val = $(this.element).val(),
	                    split = val.split(this.locale.separator);
	
	                start = end = null;
	
	                if (split.length == 2) {
	                    start = moment(split[0], this.locale.format);
	                    end = moment(split[1], this.locale.format);
	                } else if (this.singleDatePicker && val !== "") {
	                    start = moment(val, this.locale.format);
	                    end = moment(val, this.locale.format);
	                }
	                if (start !== null && end !== null) {
	                    this.setStartDate(start);
	                    this.setEndDate(end);
	                }
	            }
	        }
	
	        if (typeof options.ranges === 'object') {
	            for (range in options.ranges) {
	
	                if (typeof options.ranges[range][0] === 'string')
	                    start = moment(options.ranges[range][0], this.locale.format);
	                else
	                    start = moment(options.ranges[range][0]);
	
	                if (typeof options.ranges[range][1] === 'string')
	                    end = moment(options.ranges[range][1], this.locale.format);
	                else
	                    end = moment(options.ranges[range][1]);
	
	                // If the start or end date exceed those allowed by the minDate or maxSpan
	                // options, shorten the range to the allowable period.
	                if (this.minDate && start.isBefore(this.minDate))
	                    start = this.minDate.clone();
	
	                var maxDate = this.maxDate;
	                if (this.maxSpan && maxDate && start.clone().add(this.maxSpan).isAfter(maxDate))
	                    maxDate = start.clone().add(this.maxSpan);
	                if (maxDate && end.isAfter(maxDate))
	                    end = maxDate.clone();
	
	                // If the end of the range is before the minimum or the start of the range is
	                // after the maximum, don't display this range option at all.
	                if ((this.minDate && end.isBefore(this.minDate, this.timepicker ? 'minute' : 'day'))
	                  || (maxDate && start.isAfter(maxDate, this.timepicker ? 'minute' : 'day')))
	                    continue;
	
	                //Support unicode chars in the range names.
	                var elem = document.createElement('textarea');
	                elem.innerHTML = range;
	                var rangeHtml = elem.value;
	
	                this.ranges[rangeHtml] = [start, end];
	            }
	
	            var list = '<ul>';
	            for (range in this.ranges) {
	                list += '<li data-range-key="' + range + '">' + range + '</li>';
	            }
	            if (this.showCustomRangeLabel) {
	                list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
	            }
	            list += '</ul>';
	            this.container.find('.ranges').prepend(list);
	        }
	
	        if (typeof cb === 'function') {
	            this.callback = cb;
	        }
	
	        if (!this.timePicker) {
	            this.startDate = this.startDate.startOf('day');
	            this.endDate = this.endDate.endOf('day');
	            this.container.find('.calendar-time').hide();
	        }
	
	        //can't be used together for now
	        if (this.timePicker && this.autoApply)
	            this.autoApply = false;
	
	        if (this.autoApply) {
	            this.container.addClass('auto-apply');
	        }
	
	        if (typeof options.ranges === 'object')
	            this.container.addClass('show-ranges');
	
	        if (this.singleDatePicker) {
	            this.container.addClass('single');
	            this.container.find('.drp-calendar.left').addClass('single');
	            this.container.find('.drp-calendar.left').show();
	            this.container.find('.drp-calendar.right').hide();
	            if (!this.timePicker && this.autoApply) {
	                this.container.addClass('auto-apply');
	            }
	        }
	
	        if ((typeof options.ranges === 'undefined' && !this.singleDatePicker) || this.alwaysShowCalendars) {
	            this.container.addClass('show-calendar');
	        }
	
	        this.container.addClass('opens' + this.opens);
	
	        //apply CSS classes and labels to buttons
	        this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
	        if (this.applyButtonClasses.length)
	            this.container.find('.applyBtn').addClass(this.applyButtonClasses);
	        if (this.cancelButtonClasses.length)
	            this.container.find('.cancelBtn').addClass(this.cancelButtonClasses);
	        this.container.find('.applyBtn').html(this.locale.applyLabel);
	        this.container.find('.cancelBtn').html(this.locale.cancelLabel);
	
	        //
	        // event listeners
	        //
	
	        this.container.find('.drp-calendar')
	            .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
	            .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
	            .on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
	            .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
	            .on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this))
	            .on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this))
	            .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this));
	
	        this.container.find('.ranges')
	            .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this));
	
	        this.container.find('.drp-buttons')
	            .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
	            .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this));
	
	        if (this.element.is('input') || this.element.is('button')) {
	            this.element.on({
	                'click.daterangepicker': $.proxy(this.show, this),
	                'focus.daterangepicker': $.proxy(this.show, this),
	                'keyup.daterangepicker': $.proxy(this.elementChanged, this),
	                'keydown.daterangepicker': $.proxy(this.keydown, this) //IE 11 compatibility
	            });
	        } else {
	            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
	            this.element.on('keydown.daterangepicker', $.proxy(this.toggle, this));
	        }
	
	        //
	        // if attached to a text input, set the initial value
	        //
	
	        this.updateElement();
	
	    };
	
	    DateRangePicker.prototype = {
	
	        constructor: DateRangePicker,
	
	        setStartDate: function(startDate) {
	            if (typeof startDate === 'string')
	                this.startDate = moment(startDate, this.locale.format);
	
	            if (typeof startDate === 'object')
	                this.startDate = moment(startDate);
	
	            if (!this.timePicker)
	                this.startDate = this.startDate.startOf('day');
	
	            if (this.timePicker && this.timePickerIncrement)
	                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	
	            if (this.minDate && this.startDate.isBefore(this.minDate)) {
	                this.startDate = this.minDate.clone();
	                if (this.timePicker && this.timePickerIncrement)
	                    this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	            }
	
	            if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
	                this.startDate = this.maxDate.clone();
	                if (this.timePicker && this.timePickerIncrement)
	                    this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	            }
	
	            if (!this.isShowing)
	                this.updateElement();
	
	            this.updateMonthsInView();
	        },
	
	        setEndDate: function(endDate) {
	            if (typeof endDate === 'string')
	                this.endDate = moment(endDate, this.locale.format);
	
	            if (typeof endDate === 'object')
	                this.endDate = moment(endDate);
	
	            if (!this.timePicker)
	                this.endDate = this.endDate.endOf('day');
	
	            if (this.timePicker && this.timePickerIncrement)
	                this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	
	            if (this.endDate.isBefore(this.startDate))
	                this.endDate = this.startDate.clone();
	
	            if (this.maxDate && this.endDate.isAfter(this.maxDate))
	                this.endDate = this.maxDate.clone();
	
	            if (this.maxSpan && this.startDate.clone().add(this.maxSpan).isBefore(this.endDate))
	                this.endDate = this.startDate.clone().add(this.maxSpan);
	
	            this.previousRightTime = this.endDate.clone();
	
	            this.container.find('.drp-selected').html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
	
	            if (!this.isShowing)
	                this.updateElement();
	
	            this.updateMonthsInView();
	        },
	
	        isInvalidDate: function() {
	            return false;
	        },
	
	        isCustomDate: function() {
	            return false;
	        },
	
	        updateView: function() {
	            if (this.timePicker) {
	                this.renderTimePicker('left');
	                this.renderTimePicker('right');
	                if (!this.endDate) {
	                    this.container.find('.right .calendar-time select').prop('disabled', true).addClass('disabled');
	                } else {
	                    this.container.find('.right .calendar-time select').prop('disabled', false).removeClass('disabled');
	                }
	            }
	            if (this.endDate)
	                this.container.find('.drp-selected').html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
	            this.updateMonthsInView();
	            this.updateCalendars();
	            this.updateFormInputs();
	        },
	
	        updateMonthsInView: function() {
	            if (this.endDate) {
	
	                //if both dates are visible already, do nothing
	                if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
	                    (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
	                    &&
	                    (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
	                    ) {
	                    return;
	                }
	
	                this.leftCalendar.month = this.startDate.clone().date(2);
	                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) {
	                    this.rightCalendar.month = this.endDate.clone().date(2);
	                } else {
	                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
	                }
	
	            } else {
	                if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
	                    this.leftCalendar.month = this.startDate.clone().date(2);
	                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
	                }
	            }
	            if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
	              this.rightCalendar.month = this.maxDate.clone().date(2);
	              this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
	            }
	        },
	
	        updateCalendars: function() {
	
	            if (this.timePicker) {
	                var hour, minute, second;
	                if (this.endDate) {
	                    hour = parseInt(this.container.find('.left .hourselect').val(), 10);
	                    minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
	                    if (isNaN(minute)) {
	                        minute = parseInt(this.container.find('.left .minuteselect option:last').val(), 10);
	                    }
	                    second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.left .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                } else {
	                    hour = parseInt(this.container.find('.right .hourselect').val(), 10);
	                    minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
	                    if (isNaN(minute)) {
	                        minute = parseInt(this.container.find('.right .minuteselect option:last').val(), 10);
	                    }
	                    second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.right .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                }
	                this.leftCalendar.month.hour(hour).minute(minute).second(second);
	                this.rightCalendar.month.hour(hour).minute(minute).second(second);
	            }
	
	            this.renderCalendar('left');
	            this.renderCalendar('right');
	
	            //highlight any predefined range matching the current start and end dates
	            this.container.find('.ranges li').removeClass('active');
	            if (this.endDate == null) return;
	
	            this.calculateChosenLabel();
	        },
	
	        renderCalendar: function(side) {
	
	            //
	            // Build the matrix of dates that will populate the calendar
	            //
	
	            var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
	            var month = calendar.month.month();
	            var year = calendar.month.year();
	            var hour = calendar.month.hour();
	            var minute = calendar.month.minute();
	            var second = calendar.month.second();
	            var daysInMonth = moment([year, month]).daysInMonth();
	            var firstDay = moment([year, month, 1]);
	            var lastDay = moment([year, month, daysInMonth]);
	            var lastMonth = moment(firstDay).subtract(1, 'month').month();
	            var lastYear = moment(firstDay).subtract(1, 'month').year();
	            var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
	            var dayOfWeek = firstDay.day();
	
	            //initialize a 6 rows x 7 columns array for the calendar
	            var calendar = [];
	            calendar.firstDay = firstDay;
	            calendar.lastDay = lastDay;
	
	            for (var i = 0; i < 6; i++) {
	                calendar[i] = [];
	            }
	
	            //populate the calendar with date objects
	            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
	            if (startDay > daysInLastMonth)
	                startDay -= 7;
	
	            if (dayOfWeek == this.locale.firstDay)
	                startDay = daysInLastMonth - 6;
	
	            var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);
	
	            var col, row;
	            for (var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
	                if (i > 0 && col % 7 === 0) {
	                    col = 0;
	                    row++;
	                }
	                calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
	                curDate.hour(12);
	
	                if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') {
	                    calendar[row][col] = this.minDate.clone();
	                }
	
	                if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') {
	                    calendar[row][col] = this.maxDate.clone();
	                }
	
	            }
	
	            //make the calendar object available to hoverDate/clickDate
	            if (side == 'left') {
	                this.leftCalendar.calendar = calendar;
	            } else {
	                this.rightCalendar.calendar = calendar;
	            }
	
	            //
	            // Display the calendar
	            //
	
	            var minDate = side == 'left' ? this.minDate : this.startDate;
	            var maxDate = this.maxDate;
	            var selected = side == 'left' ? this.startDate : this.endDate;
	            var arrow = this.locale.direction == 'ltr' ? {left: 'chevron-left', right: 'chevron-right'} : {left: 'chevron-right', right: 'chevron-left'};
	
	            var html = '<table class="table-condensed">';
	            html += '<thead>';
	            html += '<tr>';
	
	            // add empty cell for week number
	            if (this.showWeekNumbers || this.showISOWeekNumbers)
	                html += '<th></th>';
	
	            if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) {
	                html += '<th class="prev available"><span></span></th>';
	            } else {
	                html += '<th></th>';
	            }
	
	            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");
	
	            if (this.showDropdowns) {
	                var currentMonth = calendar[1][1].month();
	                var currentYear = calendar[1][1].year();
	                var maxYear = (maxDate && maxDate.year()) || (this.maxYear);
	                var minYear = (minDate && minDate.year()) || (this.minYear);
	                var inMinYear = currentYear == minYear;
	                var inMaxYear = currentYear == maxYear;
	
	                var monthHtml = '<select class="monthselect">';
	                for (var m = 0; m < 12; m++) {
	                    if ((!inMinYear || (minDate && m >= minDate.month())) && (!inMaxYear || (maxDate && m <= maxDate.month()))) {
	                        monthHtml += "<option value='" + m + "'" +
	                            (m === currentMonth ? " selected='selected'" : "") +
	                            ">" + this.locale.monthNames[m] + "</option>";
	                    } else {
	                        monthHtml += "<option value='" + m + "'" +
	                            (m === currentMonth ? " selected='selected'" : "") +
	                            " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
	                    }
	                }
	                monthHtml += "</select>";
	
	                var yearHtml = '<select class="yearselect">';
	                for (var y = minYear; y <= maxYear; y++) {
	                    yearHtml += '<option value="' + y + '"' +
	                        (y === currentYear ? ' selected="selected"' : '') +
	                        '>' + y + '</option>';
	                }
	                yearHtml += '</select>';
	
	                dateHtml = monthHtml + yearHtml;
	            }
	
	            html += '<th colspan="5" class="month">' + dateHtml + '</th>';
	            if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) {
	                html += '<th class="next available"><span></span></th>';
	            } else {
	                html += '<th></th>';
	            }
	
	            html += '</tr>';
	            html += '<tr>';
	
	            // add week number label
	            if (this.showWeekNumbers || this.showISOWeekNumbers)
	                html += '<th class="week">' + this.locale.weekLabel + '</th>';
	
	            $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
	                html += '<th>' + dayOfWeek + '</th>';
	            });
	
	            html += '</tr>';
	            html += '</thead>';
	            html += '<tbody>';
	
	            //adjust maxDate to reflect the maxSpan setting in order to
	            //grey out end dates beyond the maxSpan
	            if (this.endDate == null && this.maxSpan) {
	                var maxLimit = this.startDate.clone().add(this.maxSpan).endOf('day');
	                if (!maxDate || maxLimit.isBefore(maxDate)) {
	                    maxDate = maxLimit;
	                }
	            }
	
	            for (var row = 0; row < 6; row++) {
	                html += '<tr>';
	
	                // add week number
	                if (this.showWeekNumbers)
	                    html += '<td class="week">' + calendar[row][0].week() + '</td>';
	                else if (this.showISOWeekNumbers)
	                    html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';
	
	                for (var col = 0; col < 7; col++) {
	
	                    var classes = [];
	
	                    //highlight today's date
	                    if (calendar[row][col].isSame(new Date(), "day"))
	                        classes.push('today');
	
	                    //highlight weekends
	                    if (calendar[row][col].isoWeekday() > 5)
	                        classes.push('weekend');
	
	                    //grey out the dates in other months displayed at beginning and end of this calendar
	                    if (calendar[row][col].month() != calendar[1][1].month())
	                        classes.push('off', 'ends');
	
	                    //don't allow selection of dates before the minimum date
	                    if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day'))
	                        classes.push('off', 'disabled');
	
	                    //don't allow selection of dates after the maximum date
	                    if (maxDate && calendar[row][col].isAfter(maxDate, 'day'))
	                        classes.push('off', 'disabled');
	
	                    //don't allow selection of date if a custom function decides it's invalid
	                    if (this.isInvalidDate(calendar[row][col]))
	                        classes.push('off', 'disabled');
	
	                    //highlight the currently selected start date
	                    if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD'))
	                        classes.push('active', 'start-date');
	
	                    //highlight the currently selected end date
	                    if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD'))
	                        classes.push('active', 'end-date');
	
	                    //highlight dates in-between the selected dates
	                    if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate)
	                        classes.push('in-range');
	
	                    //apply custom classes for this date
	                    var isCustom = this.isCustomDate(calendar[row][col]);
	                    if (isCustom !== false) {
	                        if (typeof isCustom === 'string')
	                            classes.push(isCustom);
	                        else
	                            Array.prototype.push.apply(classes, isCustom);
	                    }
	
	                    var cname = '', disabled = false;
	                    for (var i = 0; i < classes.length; i++) {
	                        cname += classes[i] + ' ';
	                        if (classes[i] == 'disabled')
	                            disabled = true;
	                    }
	                    if (!disabled)
	                        cname += 'available';
	
	                    html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';
	
	                }
	                html += '</tr>';
	            }
	
	            html += '</tbody>';
	            html += '</table>';
	
	            this.container.find('.drp-calendar.' + side + ' .calendar-table').html(html);
	
	        },
	
	        renderTimePicker: function(side) {
	
	            // Don't bother updating the time picker if it's currently disabled
	            // because an end date hasn't been clicked yet
	            if (side == 'right' && !this.endDate) return;
	
	            var html, selected, minDate, maxDate = this.maxDate;
	
	            if (this.maxSpan && (!this.maxDate || this.startDate.clone().add(this.maxSpan).isBefore(this.maxDate)))
	                maxDate = this.startDate.clone().add(this.maxSpan);
	
	            if (side == 'left') {
	                selected = this.startDate.clone();
	                minDate = this.minDate;
	            } else if (side == 'right') {
	                selected = this.endDate.clone();
	                minDate = this.startDate;
	
	                //Preserve the time already selected
	                var timeSelector = this.container.find('.drp-calendar.right .calendar-time');
	                if (timeSelector.html() != '') {
	
	                    selected.hour(!isNaN(selected.hour()) ? selected.hour() : timeSelector.find('.hourselect option:selected').val());
	                    selected.minute(!isNaN(selected.minute()) ? selected.minute() : timeSelector.find('.minuteselect option:selected').val());
	                    selected.second(!isNaN(selected.second()) ? selected.second() : timeSelector.find('.secondselect option:selected').val());
	
	                    if (!this.timePicker24Hour) {
	                        var ampm = timeSelector.find('.ampmselect option:selected').val();
	                        if (ampm === 'PM' && selected.hour() < 12)
	                            selected.hour(selected.hour() + 12);
	                        if (ampm === 'AM' && selected.hour() === 12)
	                            selected.hour(0);
	                    }
	
	                }
	
	                if (selected.isBefore(this.startDate))
	                    selected = this.startDate.clone();
	
	                if (maxDate && selected.isAfter(maxDate))
	                    selected = maxDate.clone();
	
	            }
	
	            //
	            // hours
	            //
	
	            html = '<select class="hourselect">';
	
	            var start = this.timePicker24Hour ? 0 : 1;
	            var end = this.timePicker24Hour ? 23 : 12;
	
	            for (var i = start; i <= end; i++) {
	                var i_in_24 = i;
	                if (!this.timePicker24Hour)
	                    i_in_24 = selected.hour() >= 12 ? (i == 12 ? 12 : i + 12) : (i == 12 ? 0 : i);
	
	                var time = selected.clone().hour(i_in_24);
	                var disabled = false;
	                if (minDate && time.minute(59).isBefore(minDate))
	                    disabled = true;
	                if (maxDate && time.minute(0).isAfter(maxDate))
	                    disabled = true;
	
	                if (i_in_24 == selected.hour() && !disabled) {
	                    html += '<option value="' + i + '" selected="selected">' + i + '</option>';
	                } else if (disabled) {
	                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
	                } else {
	                    html += '<option value="' + i + '">' + i + '</option>';
	                }
	            }
	
	            html += '</select> ';
	
	            //
	            // minutes
	            //
	
	            html += ': <select class="minuteselect">';
	
	            for (var i = 0; i < 60; i += this.timePickerIncrement) {
	                var padded = i < 10 ? '0' + i : i;
	                var time = selected.clone().minute(i);
	
	                var disabled = false;
	                if (minDate && time.second(59).isBefore(minDate))
	                    disabled = true;
	                if (maxDate && time.second(0).isAfter(maxDate))
	                    disabled = true;
	
	                if (selected.minute() == i && !disabled) {
	                    html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
	                } else if (disabled) {
	                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
	                } else {
	                    html += '<option value="' + i + '">' + padded + '</option>';
	                }
	            }
	
	            html += '</select> ';
	
	            //
	            // seconds
	            //
	
	            if (this.timePickerSeconds) {
	                html += ': <select class="secondselect">';
	
	                for (var i = 0; i < 60; i++) {
	                    var padded = i < 10 ? '0' + i : i;
	                    var time = selected.clone().second(i);
	
	                    var disabled = false;
	                    if (minDate && time.isBefore(minDate))
	                        disabled = true;
	                    if (maxDate && time.isAfter(maxDate))
	                        disabled = true;
	
	                    if (selected.second() == i && !disabled) {
	                        html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
	                    } else if (disabled) {
	                        html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
	                    } else {
	                        html += '<option value="' + i + '">' + padded + '</option>';
	                    }
	                }
	
	                html += '</select> ';
	            }
	
	            //
	            // AM/PM
	            //
	
	            if (!this.timePicker24Hour) {
	                html += '<select class="ampmselect">';
	
	                var am_html = '';
	                var pm_html = '';
	
	                if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate))
	                    am_html = ' disabled="disabled" class="disabled"';
	
	                if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate))
	                    pm_html = ' disabled="disabled" class="disabled"';
	
	                if (selected.hour() >= 12) {
	                    html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
	                } else {
	                    html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
	                }
	
	                html += '</select>';
	            }
	
	            this.container.find('.drp-calendar.' + side + ' .calendar-time').html(html);
	
	        },
	
	        updateFormInputs: function() {
	
	            if (this.singleDatePicker || (this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate)))) {
	                this.container.find('button.applyBtn').prop('disabled', false);
	            } else {
	                this.container.find('button.applyBtn').prop('disabled', true);
	            }
	
	        },
	
	        move: function() {
	            var parentOffset = { top: 0, left: 0 },
	                containerTop,
	                drops = this.drops;
	
	            var parentRightEdge = $(window).width();
	            if (!this.parentEl.is('body')) {
	                parentOffset = {
	                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
	                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
	                };
	                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
	            }
	
	            switch (drops) {
	            case 'auto':
	                containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
	                if (containerTop + this.container.outerHeight() >= this.parentEl[0].scrollHeight) {
	                    containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
	                    drops = 'up';
	                }
	                break;
	            case 'up':
	                containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
	                break;
	            default:
	                containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
	                break;
	            }
	
	            // Force the container to it's actual width
	            this.container.css({
	              top: 0,
	              left: 0,
	              right: 'auto'
	            });
	            var containerWidth = this.container.outerWidth();
	
	            this.container.toggleClass('drop-up', drops == 'up');
	
	            if (this.opens == 'left') {
	                var containerRight = parentRightEdge - this.element.offset().left - this.element.outerWidth();
	                if (containerWidth + containerRight > $(window).width()) {
	                    this.container.css({
	                        top: containerTop,
	                        right: 'auto',
	                        left: 9
	                    });
	                } else {
	                    this.container.css({
	                        top: containerTop,
	                        right: containerRight,
	                        left: 'auto'
	                    });
	                }
	            } else if (this.opens == 'center') {
	                var containerLeft = this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2
	                                        - containerWidth / 2;
	                if (containerLeft < 0) {
	                    this.container.css({
	                        top: containerTop,
	                        right: 'auto',
	                        left: 9
	                    });
	                } else if (containerLeft + containerWidth > $(window).width()) {
	                    this.container.css({
	                        top: containerTop,
	                        left: 'auto',
	                        right: 0
	                    });
	                } else {
	                    this.container.css({
	                        top: containerTop,
	                        left: containerLeft,
	                        right: 'auto'
	                    });
	                }
	            } else {
	                var containerLeft = this.element.offset().left - parentOffset.left;
	                if (containerLeft + containerWidth > $(window).width()) {
	                    this.container.css({
	                        top: containerTop,
	                        left: 'auto',
	                        right: 0
	                    });
	                } else {
	                    this.container.css({
	                        top: containerTop,
	                        left: containerLeft,
	                        right: 'auto'
	                    });
	                }
	            }
	        },
	
	        show: function(e) {
	            if (this.isShowing) return;
	
	            // Create a click proxy that is private to this instance of datepicker, for unbinding
	            this._outsideClickProxy = $.proxy(function(e) { this.outsideClick(e); }, this);
	
	            // Bind global datepicker mousedown for hiding and
	            $(document)
	              .on('mousedown.daterangepicker', this._outsideClickProxy)
	              // also support mobile devices
	              .on('touchend.daterangepicker', this._outsideClickProxy)
	              // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
	              .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
	              // and also close when focus changes to outside the picker (eg. tabbing between controls)
	              .on('focusin.daterangepicker', this._outsideClickProxy);
	
	            // Reposition the picker if the window is resized while it's open
	            $(window).on('resize.daterangepicker', $.proxy(function(e) { this.move(e); }, this));
	
	            this.oldStartDate = this.startDate.clone();
	            this.oldEndDate = this.endDate.clone();
	            this.previousRightTime = this.endDate.clone();
	
	            this.updateView();
	            this.container.show();
	            this.move();
	            this.element.trigger('show.daterangepicker', this);
	            this.isShowing = true;
	        },
	
	        hide: function(e) {
	            if (!this.isShowing) return;
	
	            //incomplete date selection, revert to last values
	            if (!this.endDate) {
	                this.startDate = this.oldStartDate.clone();
	                this.endDate = this.oldEndDate.clone();
	            }
	
	            //if a new date range was selected, invoke the user callback function
	            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
	                this.callback(this.startDate.clone(), this.endDate.clone(), this.chosenLabel);
	
	            //if picker is attached to a text input, update it
	            this.updateElement();
	
	            $(document).off('.daterangepicker');
	            $(window).off('.daterangepicker');
	            this.container.hide();
	            this.element.trigger('hide.daterangepicker', this);
	            this.isShowing = false;
	        },
	
	        toggle: function(e) {
	            if (this.isShowing) {
	                this.hide();
	            } else {
	                this.show();
	            }
	        },
	
	        outsideClick: function(e) {
	            var target = $(e.target);
	            // if the page is clicked anywhere except within the daterangerpicker/button
	            // itself then call this.hide()
	            if (
	                // ie modal dialog fix
	                e.type == "focusin" ||
	                target.closest(this.element).length ||
	                target.closest(this.container).length ||
	                target.closest('.calendar-table').length
	                ) return;
	            this.hide();
	            this.element.trigger('outsideClick.daterangepicker', this);
	        },
	
	        showCalendars: function() {
	            this.container.addClass('show-calendar');
	            this.move();
	            this.element.trigger('showCalendar.daterangepicker', this);
	        },
	
	        hideCalendars: function() {
	            this.container.removeClass('show-calendar');
	            this.element.trigger('hideCalendar.daterangepicker', this);
	        },
	
	        clickRange: function(e) {
	            var label = e.target.getAttribute('data-range-key');
	            this.chosenLabel = label;
	            if (label == this.locale.customRangeLabel) {
	                this.showCalendars();
	            } else {
	                var dates = this.ranges[label];
	                this.startDate = dates[0];
	                this.endDate = dates[1];
	
	                if (!this.timePicker) {
	                    this.startDate.startOf('day');
	                    this.endDate.endOf('day');
	                }
	
	                if (!this.alwaysShowCalendars)
	                    this.hideCalendars();
	                this.clickApply();
	            }
	        },
	
	        clickPrev: function(e) {
	            var cal = $(e.target).parents('.drp-calendar');
	            if (cal.hasClass('left')) {
	                this.leftCalendar.month.subtract(1, 'month');
	                if (this.linkedCalendars)
	                    this.rightCalendar.month.subtract(1, 'month');
	            } else {
	                this.rightCalendar.month.subtract(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        clickNext: function(e) {
	            var cal = $(e.target).parents('.drp-calendar');
	            if (cal.hasClass('left')) {
	                this.leftCalendar.month.add(1, 'month');
	            } else {
	                this.rightCalendar.month.add(1, 'month');
	                if (this.linkedCalendars)
	                    this.leftCalendar.month.add(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        hoverDate: function(e) {
	
	            //ignore dates that can't be selected
	            if (!$(e.target).hasClass('available')) return;
	
	            var title = $(e.target).attr('data-title');
	            var row = title.substr(1, 1);
	            var col = title.substr(3, 1);
	            var cal = $(e.target).parents('.drp-calendar');
	            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
	
	            //highlight the dates between the start date and the date being hovered as a potential end date
	            var leftCalendar = this.leftCalendar;
	            var rightCalendar = this.rightCalendar;
	            var startDate = this.startDate;
	            if (!this.endDate) {
	                this.container.find('.drp-calendar tbody td').each(function(index, el) {
	
	                    //skip week numbers, only look at dates
	                    if ($(el).hasClass('week')) return;
	
	                    var title = $(el).attr('data-title');
	                    var row = title.substr(1, 1);
	                    var col = title.substr(3, 1);
	                    var cal = $(el).parents('.drp-calendar');
	                    var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];
	
	                    if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
	                        $(el).addClass('in-range');
	                    } else {
	                        $(el).removeClass('in-range');
	                    }
	
	                });
	            }
	
	        },
	
	        clickDate: function(e) {
	
	            if (!$(e.target).hasClass('available')) return;
	
	            var title = $(e.target).attr('data-title');
	            var row = title.substr(1, 1);
	            var col = title.substr(3, 1);
	            var cal = $(e.target).parents('.drp-calendar');
	            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
	
	            //
	            // this function needs to do a few things:
	            // * alternate between selecting a start and end date for the range,
	            // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
	            // * if autoapply is enabled, and an end date was chosen, apply the selection
	            // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
	            // * if one of the inputs above the calendars was focused, cancel that manual input
	            //
	
	            if (this.endDate || date.isBefore(this.startDate, 'day')) { //picking start
	                if (this.timePicker) {
	                    var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.left .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                    var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
	                    if (isNaN(minute)) {
	                        minute = parseInt(this.container.find('.left .minuteselect option:last').val(), 10);
	                    }
	                    var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
	                    date = date.clone().hour(hour).minute(minute).second(second);
	                }
	                this.endDate = null;
	                this.setStartDate(date.clone());
	            } else if (!this.endDate && date.isBefore(this.startDate)) {
	                //special case: clicking the same date for start/end,
	                //but the time of the end date is before the start date
	                this.setEndDate(this.startDate.clone());
	            } else { // picking end
	                if (this.timePicker) {
	                    var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.right .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                    var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
	                    if (isNaN(minute)) {
	                        minute = parseInt(this.container.find('.right .minuteselect option:last').val(), 10);
	                    }
	                    var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
	                    date = date.clone().hour(hour).minute(minute).second(second);
	                }
	                this.setEndDate(date.clone());
	                if (this.autoApply) {
	                  this.calculateChosenLabel();
	                  this.clickApply();
	                }
	            }
	
	            if (this.singleDatePicker) {
	                this.setEndDate(this.startDate);
	                if (!this.timePicker && this.autoApply)
	                    this.clickApply();
	            }
	
	            this.updateView();
	
	            //This is to cancel the blur event handler if the mouse was in one of the inputs
	            e.stopPropagation();
	
	        },
	
	        calculateChosenLabel: function () {
	            var customRange = true;
	            var i = 0;
	            for (var range in this.ranges) {
	              if (this.timePicker) {
	                    var format = this.timePickerSeconds ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";
	                    //ignore times when comparing dates if time picker seconds is not enabled
	                    if (this.startDate.format(format) == this.ranges[range][0].format(format) && this.endDate.format(format) == this.ranges[range][1].format(format)) {
	                        customRange = false;
	                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').attr('data-range-key');
	                        break;
	                    }
	                } else {
	                    //ignore times when comparing dates if time picker is not enabled
	                    if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
	                        customRange = false;
	                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').attr('data-range-key');
	                        break;
	                    }
	                }
	                i++;
	            }
	            if (customRange) {
	                if (this.showCustomRangeLabel) {
	                    this.chosenLabel = this.container.find('.ranges li:last').addClass('active').attr('data-range-key');
	                } else {
	                    this.chosenLabel = null;
	                }
	                this.showCalendars();
	            }
	        },
	
	        clickApply: function(e) {
	            this.hide();
	            this.element.trigger('apply.daterangepicker', this);
	        },
	
	        clickCancel: function(e) {
	            this.startDate = this.oldStartDate;
	            this.endDate = this.oldEndDate;
	            this.hide();
	            this.element.trigger('cancel.daterangepicker', this);
	        },
	
	        monthOrYearChanged: function(e) {
	            var isLeft = $(e.target).closest('.drp-calendar').hasClass('left'),
	                leftOrRight = isLeft ? 'left' : 'right',
	                cal = this.container.find('.drp-calendar.'+leftOrRight);
	
	            // Month must be Number for new moment versions
	            var month = parseInt(cal.find('.monthselect').val(), 10);
	            var year = cal.find('.yearselect').val();
	
	            if (!isLeft) {
	                if (year < this.startDate.year() || (year == this.startDate.year() && month < this.startDate.month())) {
	                    month = this.startDate.month();
	                    year = this.startDate.year();
	                }
	            }
	
	            if (this.minDate) {
	                if (year < this.minDate.year() || (year == this.minDate.year() && month < this.minDate.month())) {
	                    month = this.minDate.month();
	                    year = this.minDate.year();
	                }
	            }
	
	            if (this.maxDate) {
	                if (year > this.maxDate.year() || (year == this.maxDate.year() && month > this.maxDate.month())) {
	                    month = this.maxDate.month();
	                    year = this.maxDate.year();
	                }
	            }
	
	            if (isLeft) {
	                this.leftCalendar.month.month(month).year(year);
	                if (this.linkedCalendars)
	                    this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
	            } else {
	                this.rightCalendar.month.month(month).year(year);
	                if (this.linkedCalendars)
	                    this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        timeChanged: function(e) {
	
	            var cal = $(e.target).closest('.drp-calendar'),
	                isLeft = cal.hasClass('left');
	
	            var hour = parseInt(cal.find('.hourselect').val(), 10);
	            var minute = parseInt(cal.find('.minuteselect').val(), 10);
	            if (isNaN(minute)) {
	                minute = parseInt(cal.find('.minuteselect option:last').val(), 10);
	            }
	            var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;
	
	            if (!this.timePicker24Hour) {
	                var ampm = cal.find('.ampmselect').val();
	                if (ampm === 'PM' && hour < 12)
	                    hour += 12;
	                if (ampm === 'AM' && hour === 12)
	                    hour = 0;
	            }
	
	            if (isLeft) {
	                var start = this.startDate.clone();
	                start.hour(hour);
	                start.minute(minute);
	                start.second(second);
	                this.setStartDate(start);
	                if (this.singleDatePicker) {
	                    this.endDate = this.startDate.clone();
	                } else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
	                    this.setEndDate(start.clone());
	                }
	            } else if (this.endDate) {
	                var end = this.endDate.clone();
	                end.hour(hour);
	                end.minute(minute);
	                end.second(second);
	                this.setEndDate(end);
	            }
	
	            //update the calendars so all clickable dates reflect the new time component
	            this.updateCalendars();
	
	            //update the form inputs above the calendars with the new time
	            this.updateFormInputs();
	
	            //re-render the time pickers because changing one selection can affect what's enabled in another
	            this.renderTimePicker('left');
	            this.renderTimePicker('right');
	
	        },
	
	        elementChanged: function() {
	            if (!this.element.is('input')) return;
	            if (!this.element.val().length) return;
	
	            var dateString = this.element.val().split(this.locale.separator),
	                start = null,
	                end = null;
	
	            if (dateString.length === 2) {
	                start = moment(dateString[0], this.locale.format);
	                end = moment(dateString[1], this.locale.format);
	            }
	
	            if (this.singleDatePicker || start === null || end === null) {
	                start = moment(this.element.val(), this.locale.format);
	                end = start;
	            }
	
	            if (!start.isValid() || !end.isValid()) return;
	
	            this.setStartDate(start);
	            this.setEndDate(end);
	            this.updateView();
	        },
	
	        keydown: function(e) {
	            //hide on tab or enter
	            if ((e.keyCode === 9) || (e.keyCode === 13)) {
	                this.hide();
	            }
	
	            //hide on esc and prevent propagation
	            if (e.keyCode === 27) {
	                e.preventDefault();
	                e.stopPropagation();
	
	                this.hide();
	            }
	        },
	
	        updateElement: function() {
	            if (this.element.is('input') && this.autoUpdateInput) {
	                var newValue = this.startDate.format(this.locale.format);
	                if (!this.singleDatePicker) {
	                    newValue += this.locale.separator + this.endDate.format(this.locale.format);
	                }
	                if (newValue !== this.element.val()) {
	                    this.element.val(newValue).trigger('change');
	                }
	            }
	        },
	
	        remove: function() {
	            this.container.remove();
	            this.element.off('.daterangepicker');
	            this.element.removeData();
	        }
	
	    };
	
	    $.fn.daterangepicker = function(options, callback) {
	        var implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);
	        this.each(function() {
	            var el = $(this);
	            if (el.data('daterangepicker'))
	                el.data('daterangepicker').remove();
	            el.data('daterangepicker', new DateRangePicker(el, implementOptions, callback));
	        });
	        return this;
	    };
	
	    return DateRangePicker;
	
	}));


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// **Github:** https://github.com/teambition/expire-cache
	//
	// **License:** MIT
	
	/* global module, define */
	
	;(function (root, factory) {
	  'use strict'
	
	  if (typeof module === 'object' && typeof module.exports === 'object') {
	    module.exports = factory()
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  } else {
	    root.expireCache = factory()
	  }
	}(typeof window === 'object' ? window : this, function () {
	  'use strict'
	
	  var dataCache = {}
	  var indexCache = {}
	  var slice = Array.prototype.slice
	
	  function forEach (obj, iterator, context) {
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) iterator(obj[key], key, obj)
	    }
	  }
	
	  function removeKeys (keys, namespace) {
	    forEach(keys, function (key) {
	      if (key && typeof key === 'object') removeKeys(key, namespace)
	      delete dataCache[namespace + key]
	    })
	  }
	
	  function getValue (expireCache, key, value) {
	    value = value || dataCache[expireCache._ns + key]
	    if (!value) return
	    if (Date.now() <= value.e) return value.d
	    delete dataCache[expireCache._ns + key]
	  }
	
	  function expireCacheFactory (namespace, defaultExpire) {
	    var expireCache
	
	    namespace = (namespace || '') + ':'
	    defaultExpire = defaultExpire > 0 ? +defaultExpire : 60 * 5
	
	    expireCache = indexCache[namespace] || function (key, value, expire) {
	      if (arguments.length > 1 || (key && typeof key === 'object')) {
	        return expireCache.set(key, value, expire)
	      }
	      return expireCache.get(key)
	    }
	
	    expireCache._ns = namespace
	    expireCache._ex = defaultExpire
	    if (indexCache[namespace]) return expireCache
	
	    indexCache[namespace] = expireCache
	
	    expireCache.get = function (key) {
	      var result = {}
	      if (key != null) return getValue(expireCache, key)
	
	      forEach(dataCache, function (value, key) {
	        if (key.indexOf(expireCache._ns) !== 0) return
	        key = key.slice(expireCache._ns.length)
	        value = getValue(expireCache, key, value)
	        if (value) result[key] = value
	      })
	      return result
	    }
	
	    expireCache.set = function (key, value, expire) {
	      var object = {}
	      if (key && typeof key === 'object') {
	        object = key
	        expire = value
	      } else {
	        object[key] = value
	      }
	
	      var _expire = expire >= 0 ? expire : expireCache._ex
	      _expire = +_expire * 1000 + (+new Date())
	
	      forEach(object, function (value, key) {
	        key = expireCache._ns + key
	        dataCache[key] = dataCache[key] || {}
	        dataCache[key].d = value
	        // expire 为 `false` 时，将不会更新过期时间
	        if (expire !== false || !dataCache[key].e) dataCache[key].e = _expire
	      })
	      return expireCache
	    }
	
	    expireCache.remove = function (key) {
	      if (typeof key === 'undefined' || (key + '') === '') {
	        forEach(dataCache, function (value, key) {
	          if (key.indexOf(expireCache._ns) !== 0) return
	          delete dataCache[key]
	        })
	      } else {
	        removeKeys(slice.call(arguments), expireCache._ns)
	      }
	      return expireCache
	    }
	
	    expireCache.namespace = function (namespace, defaultExpire) {
	      if (namespace == null) return expireCache
	      namespace = expireCache._ns + namespace
	      defaultExpire = defaultExpire > 0 ? +defaultExpire : expireCache._ex
	      return expireCacheFactory(namespace, defaultExpire)
	    }
	
	    return expireCache
	  }
	
	  var expireCache = expireCacheFactory()
	
	  expireCache.NAME = 'expireCache'
	  expireCache.VERSION = 'v1.0.0'
	
	  expireCache._getCache = function () {
	    return {
	      cache: dataCache,
	      index: indexCache
	    }
	  }
	  return expireCache
	}))


/***/ },
/* 683 */,
/* 684 */,
/* 685 */
/***/ function(module, exports) {

	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	module.exports = function forEach (obj, fn, ctx) {
	    if (toString.call(fn) !== '[object Function]') {
	        throw new TypeError('iterator must be a function');
	    }
	    var l = obj.length;
	    if (l === +l) {
	        for (var i = 0; i < l; i++) {
	            fn.call(ctx, obj[i], i, obj);
	        }
	    } else {
	        for (var k in obj) {
	            if (hasOwn.call(obj, k)) {
	                fn.call(ctx, obj[k], k, obj);
	            }
	        }
	    }
	};
	


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/*! 4.37.0 / Consumer  */
	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.PubNub=t():e.PubNub=t()}(window,(function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var i=t[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)n.d(r,i,function(t){return e[t]}.bind(null,i));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=31)}([function(e,t){e.exports=function(e){return e&&e.__esModule?e:{default:e}},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default={PNTimeOperation:"PNTimeOperation",PNHistoryOperation:"PNHistoryOperation",PNDeleteMessagesOperation:"PNDeleteMessagesOperation",PNFetchMessagesOperation:"PNFetchMessagesOperation",PNMessageCounts:"PNMessageCountsOperation",PNSubscribeOperation:"PNSubscribeOperation",PNUnsubscribeOperation:"PNUnsubscribeOperation",PNPublishOperation:"PNPublishOperation",PNSignalOperation:"PNSignalOperation",PNAddMessageActionOperation:"PNAddActionOperation",PNRemoveMessageActionOperation:"PNRemoveMessageActionOperation",PNGetMessageActionsOperation:"PNGetMessageActionsOperation",PNCreateUserOperation:"PNCreateUserOperation",PNUpdateUserOperation:"PNUpdateUserOperation",PNDeleteUserOperation:"PNDeleteUserOperation",PNGetUserOperation:"PNGetUsersOperation",PNGetUsersOperation:"PNGetUsersOperation",PNCreateSpaceOperation:"PNCreateSpaceOperation",PNUpdateSpaceOperation:"PNUpdateSpaceOperation",PNDeleteSpaceOperation:"PNDeleteSpaceOperation",PNGetSpaceOperation:"PNGetSpacesOperation",PNGetSpacesOperation:"PNGetSpacesOperation",PNGetMembersOperation:"PNGetMembersOperation",PNUpdateMembersOperation:"PNUpdateMembersOperation",PNGetMembershipsOperation:"PNGetMembershipsOperation",PNUpdateMembershipsOperation:"PNUpdateMembershipsOperation",PNListFilesOperation:"PNListFilesOperation",PNGenerateUploadUrlOperation:"PNGenerateUploadUrlOperation",PNPublishFileOperation:"PNPublishFileOperation",PNGetFileUrlOperation:"PNGetFileUrlOperation",PNDownloadFileOperation:"PNDownloadFileOperation",PNGetAllUUIDMetadataOperation:"PNGetAllUUIDMetadataOperation",PNGetUUIDMetadataOperation:"PNGetUUIDMetadataOperation",PNSetUUIDMetadataOperation:"PNSetUUIDMetadataOperation",PNRemoveUUIDMetadataOperation:"PNRemoveUUIDMetadataOperation",PNGetAllChannelMetadataOperation:"PNGetAllChannelMetadataOperation",PNGetChannelMetadataOperation:"PNGetChannelMetadataOperation",PNSetChannelMetadataOperation:"PNSetChannelMetadataOperation",PNRemoveChannelMetadataOperation:"PNRemoveChannelMetadataOperation",PNSetMembersOperation:"PNSetMembersOperation",PNSetMembershipsOperation:"PNSetMembershipsOperation",PNPushNotificationEnabledChannelsOperation:"PNPushNotificationEnabledChannelsOperation",PNRemoveAllPushNotificationsOperation:"PNRemoveAllPushNotificationsOperation",PNWhereNowOperation:"PNWhereNowOperation",PNSetStateOperation:"PNSetStateOperation",PNHereNowOperation:"PNHereNowOperation",PNGetStateOperation:"PNGetStateOperation",PNHeartbeatOperation:"PNHeartbeatOperation",PNChannelGroupsOperation:"PNChannelGroupsOperation",PNRemoveGroupOperation:"PNRemoveGroupOperation",PNChannelsForGroupOperation:"PNChannelsForGroupOperation",PNAddChannelsToGroupOperation:"PNAddChannelsToGroupOperation",PNRemoveChannelsFromGroupOperation:"PNRemoveChannelsFromGroupOperation",PNAccessManagerGrant:"PNAccessManagerGrant",PNAccessManagerGrantToken:"PNAccessManagerGrantToken",PNAccessManagerAudit:"PNAccessManagerAudit",PNAccessManagerRevokeToken:"PNAccessManagerRevokeToken"},e.exports=t.default},function(e,t,n){"use strict";e.exports={}},function(e,t,n){"use strict";(function(t){function n(e){return encodeURIComponent(e).replace(/[!~*'()]/g,(function(e){return"%".concat(e.charCodeAt(0).toString(16).toUpperCase())}))}function r(e){return function(e){var t=[];return Object.keys(e).forEach((function(e){return t.push(e)})),t}(e).sort()}var i="The Objects v1 API has been deprecated.\nYou can learn more about Objects v2 API at https://www.pubnub.com/docs/web-javascript/api-reference-objects.\nIf you have questions about the Objects v2 API or require additional help with migrating to the new data model, please contact PubNub Support at support@pubnub.com.";e.exports={signPamFromParams:function(e){return r(e).map((function(t){return"".concat(t,"=").concat(n(e[t]))})).join("&")},endsWith:function(e,t){return-1!==e.indexOf(t,this.length-t.length)},createPromise:function(){var e,t;return{promise:new Promise((function(n,r){e=n,t=r})),reject:t,fulfill:e}},encodeString:n,deprecated:function(e){return function(){var n,r;void 0!==t&&("test"!==(null===(n=t)||void 0===n||null===(r=n.env)||void 0===r?void 0:"production")&&console.warn(i));return e.apply(void 0,arguments)}}}}).call(this,n(42))},function(e,t){e.exports=function(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t){e.exports=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t){function n(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}e.exports=function(e,t,r){return t&&n(e.prototype,t),r&&n(e,r),e},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t){function n(t){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?(e.exports=n=function(e){return typeof e},e.exports.default=e.exports,e.exports.__esModule=!0):(e.exports=n=function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports.default=e.exports,e.exports.__esModule=!0),n(t)}e.exports=n,e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(5)),o=r(n(6)),a=r(n(4)),u=r(n(17)),s=(n(2),function(){function e(t){var n,r,o=t.setup,s=t.db;if((0,i.default)(this,e),(0,a.default)(this,"_db",void 0),(0,a.default)(this,"subscribeKey",void 0),(0,a.default)(this,"publishKey",void 0),(0,a.default)(this,"secretKey",void 0),(0,a.default)(this,"cipherKey",void 0),(0,a.default)(this,"authKey",void 0),(0,a.default)(this,"UUID",void 0),(0,a.default)(this,"proxy",void 0),(0,a.default)(this,"instanceId",void 0),(0,a.default)(this,"sdkName",void 0),(0,a.default)(this,"sdkFamily",void 0),(0,a.default)(this,"partnerId",void 0),(0,a.default)(this,"filterExpression",void 0),(0,a.default)(this,"suppressLeaveEvents",void 0),(0,a.default)(this,"secure",void 0),(0,a.default)(this,"origin",void 0),(0,a.default)(this,"logVerbosity",void 0),(0,a.default)(this,"useInstanceId",void 0),(0,a.default)(this,"useRequestId",void 0),(0,a.default)(this,"keepAlive",void 0),(0,a.default)(this,"keepAliveSettings",void 0),(0,a.default)(this,"autoNetworkDetection",void 0),(0,a.default)(this,"announceSuccessfulHeartbeats",void 0),(0,a.default)(this,"announceFailedHeartbeats",void 0),(0,a.default)(this,"_presenceTimeout",void 0),(0,a.default)(this,"_heartbeatInterval",void 0),(0,a.default)(this,"_subscribeRequestTimeout",void 0),(0,a.default)(this,"_transactionalRequestTimeout",void 0),(0,a.default)(this,"_useSendBeacon",void 0),(0,a.default)(this,"_PNSDKSuffix",void 0),(0,a.default)(this,"requestMessageCountThreshold",void 0),(0,a.default)(this,"restore",void 0),(0,a.default)(this,"dedupeOnSubscribe",void 0),(0,a.default)(this,"maximumCacheSize",void 0),(0,a.default)(this,"customEncrypt",void 0),(0,a.default)(this,"customDecrypt",void 0),(0,a.default)(this,"fileUploadPublishRetryLimit",void 0),(0,a.default)(this,"useRandomIVs",void 0),this._PNSDKSuffix={},this._db=s,this.instanceId="pn-".concat(u.default.createUUID()),this.secretKey=o.secretKey||o.secret_key,this.subscribeKey=o.subscribeKey||o.subscribe_key,this.publishKey=o.publishKey||o.publish_key,this.sdkName=o.sdkName,this.sdkFamily=o.sdkFamily,this.partnerId=o.partnerId,this.setAuthKey(o.authKey),this.setCipherKey(o.cipherKey),this.setFilterExpression(o.filterExpression),"string"!=typeof o.origin&&!Array.isArray(o.origin)&&void 0!==o.origin)throw new Error("Origin must be either undefined, a string or a list of strings.");this.origin=o.origin||Array.from({length:20},(function(e,t){return"ps".concat(t+1,".pndsn.com")})),this.secure=o.ssl||!1,this.restore=o.restore||!1,this.proxy=o.proxy,this.keepAlive=o.keepAlive,this.keepAliveSettings=o.keepAliveSettings,this.autoNetworkDetection=o.autoNetworkDetection||!1,this.dedupeOnSubscribe=o.dedupeOnSubscribe||!1,this.maximumCacheSize=o.maximumCacheSize||100,this.customEncrypt=o.customEncrypt,this.customDecrypt=o.customDecrypt,this.fileUploadPublishRetryLimit=null!==(n=o.fileUploadPublishRetryLimit)&&void 0!==n?n:5,this.useRandomIVs=null===(r=o.useRandomIVs)||void 0===r||r,"undefined"!=typeof location&&"https:"===location.protocol&&(this.secure=!0),this.logVerbosity=o.logVerbosity||!1,this.suppressLeaveEvents=o.suppressLeaveEvents||!1,this.announceFailedHeartbeats=o.announceFailedHeartbeats||!0,this.announceSuccessfulHeartbeats=o.announceSuccessfulHeartbeats||!1,this.useInstanceId=o.useInstanceId||!1,this.useRequestId=o.useRequestId||!1,this.requestMessageCountThreshold=o.requestMessageCountThreshold,this.setTransactionTimeout(o.transactionalRequestTimeout||15e3),this.setSubscribeTimeout(o.subscribeRequestTimeout||31e4),this.setSendBeaconConfig(o.useSendBeacon||!0),o.presenceTimeout?this.setPresenceTimeout(o.presenceTimeout):this._presenceTimeout=300,null!=o.heartbeatInterval&&this.setHeartbeatInterval(o.heartbeatInterval),this.setUUID(this._decideUUID(o.uuid))}return(0,o.default)(e,[{key:"getAuthKey",value:function(){return this.authKey}},{key:"setAuthKey",value:function(e){return this.authKey=e,this}},{key:"setCipherKey",value:function(e){return this.cipherKey=e,this}},{key:"getUUID",value:function(){return this.UUID}},{key:"setUUID",value:function(e){return this._db&&this._db.set&&this._db.set("".concat(this.subscribeKey,"uuid"),e),this.UUID=e,this}},{key:"getFilterExpression",value:function(){return this.filterExpression}},{key:"setFilterExpression",value:function(e){return this.filterExpression=e,this}},{key:"getPresenceTimeout",value:function(){return this._presenceTimeout}},{key:"setPresenceTimeout",value:function(e){return e>=20?this._presenceTimeout=e:(this._presenceTimeout=20,console.log("WARNING: Presence timeout is less than the minimum. Using minimum value: ",this._presenceTimeout)),this.setHeartbeatInterval(this._presenceTimeout/2-1),this}},{key:"setProxy",value:function(e){this.proxy=e}},{key:"getHeartbeatInterval",value:function(){return this._heartbeatInterval}},{key:"setHeartbeatInterval",value:function(e){return this._heartbeatInterval=e,this}},{key:"getSubscribeTimeout",value:function(){return this._subscribeRequestTimeout}},{key:"setSubscribeTimeout",value:function(e){return this._subscribeRequestTimeout=e,this}},{key:"getTransactionTimeout",value:function(){return this._transactionalRequestTimeout}},{key:"setTransactionTimeout",value:function(e){return this._transactionalRequestTimeout=e,this}},{key:"isSendBeaconEnabled",value:function(){return this._useSendBeacon}},{key:"setSendBeaconConfig",value:function(e){return this._useSendBeacon=e,this}},{key:"getVersion",value:function(){return"4.37.0"}},{key:"_addPnsdkSuffix",value:function(e,t){this._PNSDKSuffix[e]=t}},{key:"_getPnsdkSuffix",value:function(e){var t=this;return Object.keys(this._PNSDKSuffix).reduce((function(n,r){return n+e+t._PNSDKSuffix[r]}),"")}},{key:"_decideUUID",value:function(e){return e||(this._db&&this._db.get&&this._db.get("".concat(this.subscribeKey,"uuid"))?this._db.get("".concat(this.subscribeKey,"uuid")):"pn-".concat(u.default.createUUID()))}}]),e}());t.default=s,e.exports=t.default},function(e,t,n){var r=n(80),i=n(81),o=n(82),a=n(84);e.exports=function(e,t){return r(e)||i(e,t)||o(e,t)||a()},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default={PNNetworkUpCategory:"PNNetworkUpCategory",PNNetworkDownCategory:"PNNetworkDownCategory",PNNetworkIssuesCategory:"PNNetworkIssuesCategory",PNTimeoutCategory:"PNTimeoutCategory",PNBadRequestCategory:"PNBadRequestCategory",PNAccessDeniedCategory:"PNAccessDeniedCategory",PNUnknownCategory:"PNUnknownCategory",PNReconnectedCategory:"PNReconnectedCategory",PNConnectedCategory:"PNConnectedCategory",PNRequestMessageCountExceededCategory:"PNRequestMessageCountExceededCategory"},e.exports=t.default},function(e,t,n){e.exports=n(75)},function(e,t){function n(e,t,n,r,i,o,a){try{var u=e[o](a),s=u.value}catch(e){return void n(e)}u.done?t(s):Promise.resolve(s).then(r,i)}e.exports=function(e){return function(){var t=this,r=arguments;return new Promise((function(i,o){var a=e.apply(t,r);function u(e){n(a,i,o,u,s,"next",e)}function s(e){n(a,i,o,u,s,"throw",e)}u(void 0)}))}},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t){function n(t){return e.exports=n=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)},e.exports.default=e.exports,e.exports.__esModule=!0,n(t)}e.exports=n,e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t,n){var r=n(15);e.exports=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&r(e,t)},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t){function n(t,r){return e.exports=n=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},e.exports.default=e.exports,e.exports.__esModule=!0,n(t,r)}e.exports=n,e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t,n){var r=n(7).default,i=n(22);e.exports=function(e,t){if(t&&("object"===r(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return i(e)},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(34)),o={createUUID:function(){return i.default.uuid?i.default.uuid():(0,i.default)()}};t.default=o,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.PubNubError=void 0,t.createValidationError=b,t.default=function(e,t){var n=e.networking,r=e.config,i=e.telemetryManager,o=e.tokenManager,a=l.default.createUUID(),u=null,s=null,c={};t.getOperation()===d.default.PNTimeOperation||t.getOperation()===d.default.PNChannelGroupsOperation?u=arguments.length<=2?void 0:arguments[2]:(c=arguments.length<=2?void 0:arguments[2],u=arguments.length<=3?void 0:arguments[3]);"undefined"==typeof Promise||u||(s=f.default.createPromise());var h=t.validateParams(e,c);if(h)return u?u(b(h)):s?(s.reject(new v("Validation failed, check status for details",b(h))),s.promise):void 0;var g,S=t.prepareParams(e,c),w=m(t,e,c),k={url:w,operation:t.getOperation(),timeout:t.getRequestTimeout(e),headers:t.getRequestHeaders?t.getRequestHeaders():{},ignoreBody:"function"==typeof t.ignoreBody&&t.ignoreBody(e),forceBuffered:"function"==typeof t.forceBuffered?t.forceBuffered(e,c):null};S.uuid=r.UUID,S.pnsdk=_(r);var T=i.operationsLatencyForRequest();Object.keys(T).length&&(S=y(y({},S),T));r.useInstanceId&&(S.instanceid=r.instanceId);r.useRequestId&&(S.requestid=a);if(t.isAuthSupported()){var x=o.getToken()||r.getAuthKey();x&&(S.auth=x)}r.secretKey&&O(e,w,S,c,t);var A=function(n,r){var o;if(n.error)return t.handleError&&t.handleError(e,c,n),void(u?u(n):s&&s.reject(new v("PubNub call failed, check status for details",n)));i.stopLatencyMeasure(t.getOperation(),a);var l=t.handleResponse(e,r,c);"function"!=typeof(null===(o=l)||void 0===o?void 0:o.then)&&(l=Promise.resolve(l)),l.then((function(e){u?u(n,e):s&&s.fulfill(e)})).catch((function(e){if(u){var n=e;t.getOperation()===d.default.PNSubscribeOperation&&(n={statusCode:400,error:!0,operation:t.getOperation(),errorData:e,category:p.default.PNUnknownCategory}),u(n,null)}else s&&s.reject(new v("PubNub call failed, check status for details",e))}))};if(i.startLatencyMeasure(t.getOperation(),a),"POST"===P(e,t,c)){var M=t.postPayload(e,c);g=n.POST(S,M,k,A)}else if("PATCH"===P(e,t,c)){var E=t.patchPayload(e,c);g=n.PATCH(S,E,k,A)}else g="DELETE"===P(e,t,c)?n.DELETE(S,k,A):"GETFILE"===P(e,t,c)?n.GETFILE(S,k,A):n.GET(S,k,A);if(t.getOperation()===d.default.PNSubscribeOperation)return g;if(s)return s.promise},t.generatePNSDK=_,t.signRequest=O;var i=r(n(4)),o=r(n(5)),a=r(n(14)),u=r(n(16)),s=r(n(13)),c=r(n(48)),l=r(n(17)),f=(n(2),r(n(3))),d=(r(n(8)),r(n(1))),p=r(n(10));function h(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function y(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?h(Object(n),!0).forEach((function(t){(0,i.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):h(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function g(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=(0,s.default)(e);if(t){var i=(0,s.default)(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return(0,u.default)(this,n)}}var v=function(e){(0,a.default)(n,e);var t=g(n);function n(e,r){var i;return(0,o.default)(this,n),(i=t.call(this,e)).name=i.constructor.name,i.status=r,i.message=e,i}return n}((0,c.default)(Error));function b(e){return(t={message:e}).type="validationError",t.error=!0,t;var t}function m(e,t,n){return e.usePost&&e.usePost(t,n)?e.postURL(t,n):e.usePatch&&e.usePatch(t,n)?e.patchURL(t,n):e.useGetFile&&e.useGetFile(t,n)?e.getFileURL(t,n):e.getURL(t,n)}function _(e){if(e.sdkName)return e.sdkName;var t="PubNub-JS-".concat(e.sdkFamily);e.partnerId&&(t+="-".concat(e.partnerId)),t+="/".concat(e.getVersion());var n=e._getPnsdkSuffix(" ");return n.length>0&&(t+=n),t}function P(e,t,n){return t.usePost&&t.usePost(e,n)?"POST":t.usePatch&&t.usePatch(e,n)?"PATCH":t.useDelete&&t.useDelete(e,n)?"DELETE":t.useGetFile&&t.useGetFile(e,n)?"GETFILE":"GET"}function O(e,t,n,r,i){var o=e.config,a=e.crypto,u=P(e,i,r);n.timestamp=Math.floor((new Date).getTime()/1e3),"PNPublishOperation"===i.getOperation()&&i.usePost&&i.usePost(e,r)&&(u="GET"),"GETFILE"===u&&(u="GET");var s="".concat(u,"\n").concat(o.publishKey,"\n").concat(t,"\n").concat(f.default.signPamFromParams(n),"\n");if("POST"===u){var c=i.postPayload(e,r);s+="string"==typeof c?c:JSON.stringify(c)}else if("PATCH"===u){var l=i.patchPayload(e,r);s+="string"==typeof l?l:JSON.stringify(l)}var d="v2.".concat(a.HMACSHA256(s));d=(d=(d=d.replace(/\+/g,"-")).replace(/\//g,"_")).replace(/=+$/,""),n.signature=d}t.PubNubError=v},function(e,t,n){"use strict";var r=SyntaxError,i=Function,o=TypeError,a=function(e){try{return i('"use strict"; return ('+e+").constructor;")()}catch(e){}},u=Object.getOwnPropertyDescriptor;if(u)try{u({},"")}catch(e){u=null}var s=function(){throw new o},c=u?function(){try{return s}catch(e){try{return u(arguments,"callee").get}catch(e){return s}}}():s,l=n(135)(),f=Object.getPrototypeOf||function(e){return e.__proto__},d={},p="undefined"==typeof Uint8Array?void 0:f(Uint8Array),h={"%AggregateError%":"undefined"==typeof AggregateError?void 0:AggregateError,"%Array%":Array,"%ArrayBuffer%":"undefined"==typeof ArrayBuffer?void 0:ArrayBuffer,"%ArrayIteratorPrototype%":l?f([][Symbol.iterator]()):void 0,"%AsyncFromSyncIteratorPrototype%":void 0,"%AsyncFunction%":d,"%AsyncGenerator%":d,"%AsyncGeneratorFunction%":d,"%AsyncIteratorPrototype%":d,"%Atomics%":"undefined"==typeof Atomics?void 0:Atomics,"%BigInt%":"undefined"==typeof BigInt?void 0:BigInt,"%Boolean%":Boolean,"%DataView%":"undefined"==typeof DataView?void 0:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":"undefined"==typeof Float32Array?void 0:Float32Array,"%Float64Array%":"undefined"==typeof Float64Array?void 0:Float64Array,"%FinalizationRegistry%":"undefined"==typeof FinalizationRegistry?void 0:FinalizationRegistry,"%Function%":i,"%GeneratorFunction%":d,"%Int8Array%":"undefined"==typeof Int8Array?void 0:Int8Array,"%Int16Array%":"undefined"==typeof Int16Array?void 0:Int16Array,"%Int32Array%":"undefined"==typeof Int32Array?void 0:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":l?f(f([][Symbol.iterator]())):void 0,"%JSON%":"object"==typeof JSON?JSON:void 0,"%Map%":"undefined"==typeof Map?void 0:Map,"%MapIteratorPrototype%":"undefined"!=typeof Map&&l?f((new Map)[Symbol.iterator]()):void 0,"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":"undefined"==typeof Promise?void 0:Promise,"%Proxy%":"undefined"==typeof Proxy?void 0:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":"undefined"==typeof Reflect?void 0:Reflect,"%RegExp%":RegExp,"%Set%":"undefined"==typeof Set?void 0:Set,"%SetIteratorPrototype%":"undefined"!=typeof Set&&l?f((new Set)[Symbol.iterator]()):void 0,"%SharedArrayBuffer%":"undefined"==typeof SharedArrayBuffer?void 0:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":l?f(""[Symbol.iterator]()):void 0,"%Symbol%":l?Symbol:void 0,"%SyntaxError%":r,"%ThrowTypeError%":c,"%TypedArray%":p,"%TypeError%":o,"%Uint8Array%":"undefined"==typeof Uint8Array?void 0:Uint8Array,"%Uint8ClampedArray%":"undefined"==typeof Uint8ClampedArray?void 0:Uint8ClampedArray,"%Uint16Array%":"undefined"==typeof Uint16Array?void 0:Uint16Array,"%Uint32Array%":"undefined"==typeof Uint32Array?void 0:Uint32Array,"%URIError%":URIError,"%WeakMap%":"undefined"==typeof WeakMap?void 0:WeakMap,"%WeakRef%":"undefined"==typeof WeakRef?void 0:WeakRef,"%WeakSet%":"undefined"==typeof WeakSet?void 0:WeakSet},y={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]},g=n(20),v=n(138),b=g.call(Function.call,Array.prototype.concat),m=g.call(Function.apply,Array.prototype.splice),_=g.call(Function.call,String.prototype.replace),P=g.call(Function.call,String.prototype.slice),O=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,S=/\\(\\)?/g,w=function(e){var t=P(e,0,1),n=P(e,-1);if("%"===t&&"%"!==n)throw new r("invalid intrinsic syntax, expected closing `%`");if("%"===n&&"%"!==t)throw new r("invalid intrinsic syntax, expected opening `%`");var i=[];return _(e,O,(function(e,t,n,r){i[i.length]=n?_(r,S,"$1"):t||e})),i},k=function(e,t){var n,i=e;if(v(y,i)&&(i="%"+(n=y[i])[0]+"%"),v(h,i)){var u=h[i];if(u===d&&(u=function e(t){var n;if("%AsyncFunction%"===t)n=a("async function () {}");else if("%GeneratorFunction%"===t)n=a("function* () {}");else if("%AsyncGeneratorFunction%"===t)n=a("async function* () {}");else if("%AsyncGenerator%"===t){var r=e("%AsyncGeneratorFunction%");r&&(n=r.prototype)}else if("%AsyncIteratorPrototype%"===t){var i=e("%AsyncGenerator%");i&&(n=f(i.prototype))}return h[t]=n,n}(i)),void 0===u&&!t)throw new o("intrinsic "+e+" exists, but is not available. Please file an issue!");return{alias:n,name:i,value:u}}throw new r("intrinsic "+e+" does not exist!")};e.exports=function(e,t){if("string"!=typeof e||0===e.length)throw new o("intrinsic name must be a non-empty string");if(arguments.length>1&&"boolean"!=typeof t)throw new o('"allowMissing" argument must be a boolean');var n=w(e),i=n.length>0?n[0]:"",a=k("%"+i+"%",t),s=a.name,c=a.value,l=!1,f=a.alias;f&&(i=f[0],m(n,b([0,1],f)));for(var d=1,p=!0;d<n.length;d+=1){var y=n[d],g=P(y,0,1),_=P(y,-1);if(('"'===g||"'"===g||"`"===g||'"'===_||"'"===_||"`"===_)&&g!==_)throw new r("property names with quotes must have matching quotes");if("constructor"!==y&&p||(l=!0),v(h,s="%"+(i+="."+y)+"%"))c=h[s];else if(null!=c){if(!(y in c)){if(!t)throw new o("base intrinsic for "+e+" exists, but the property is not available.");return}if(u&&d+1>=n.length){var O=u(c,y);c=(p=!!O)&&"get"in O&&!("originalValue"in O.get)?O.get:c[y]}else p=v(c,y),c=c[y];p&&!l&&(h[s]=c)}}return c}},function(e,t,n){"use strict";var r=n(137);e.exports=Function.prototype.bind||r},function(e,t,n){"use strict";var r=String.prototype.replace,i=/%20/g,o="RFC1738",a="RFC3986";e.exports={default:a,formatters:{RFC1738:function(e){return r.call(e,i,"+")},RFC3986:function(e){return String(e)}},RFC1738:o,RFC3986:a}},function(e,t){e.exports=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t,n){"use strict";(function(r){var i=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=i(n(5)),a=i(n(6)),u=i(n(4)),s=(i(n(8)),i(n(25)));function c(e){var t,n=[];for(t=0;t<e.length;t+=1)n[t/4|0]|=e[t]<<24-8*t;return s.default.lib.WordArray.create(n,e.length)}var l=function(){function e(t){var n=t.config;(0,o.default)(this,e),(0,u.default)(this,"_config",void 0),(0,u.default)(this,"_iv",void 0),(0,u.default)(this,"_allowedKeyEncodings",void 0),(0,u.default)(this,"_allowedKeyLengths",void 0),(0,u.default)(this,"_allowedModes",void 0),(0,u.default)(this,"_defaultOptions",void 0),this._config=n,this._iv="0123456789012345",this._allowedKeyEncodings=["hex","utf8","base64","binary"],this._allowedKeyLengths=[128,256],this._allowedModes=["ecb","cbc"],this._defaultOptions={encryptKey:!0,keyEncoding:"utf8",keyLength:256,mode:"cbc"}}return(0,a.default)(e,[{key:"HMACSHA256",value:function(e){return s.default.HmacSHA256(e,this._config.secretKey).toString(s.default.enc.Base64)}},{key:"SHA256",value:function(e){return s.default.SHA256(e).toString(s.default.enc.Hex)}},{key:"_parseOptions",value:function(e){var t=e||{};return t.hasOwnProperty("encryptKey")||(t.encryptKey=this._defaultOptions.encryptKey),t.hasOwnProperty("keyEncoding")||(t.keyEncoding=this._defaultOptions.keyEncoding),t.hasOwnProperty("keyLength")||(t.keyLength=this._defaultOptions.keyLength),t.hasOwnProperty("mode")||(t.mode=this._defaultOptions.mode),-1===this._allowedKeyEncodings.indexOf(t.keyEncoding.toLowerCase())&&(t.keyEncoding=this._defaultOptions.keyEncoding),-1===this._allowedKeyLengths.indexOf(parseInt(t.keyLength,10))&&(t.keyLength=this._defaultOptions.keyLength),-1===this._allowedModes.indexOf(t.mode.toLowerCase())&&(t.mode=this._defaultOptions.mode),t}},{key:"_decodeKey",value:function(e,t){return"base64"===t.keyEncoding?s.default.enc.Base64.parse(e):"hex"===t.keyEncoding?s.default.enc.Hex.parse(e):e}},{key:"_getPaddedKey",value:function(e,t){return e=this._decodeKey(e,t),t.encryptKey?s.default.enc.Utf8.parse(this.SHA256(e).slice(0,32)):e}},{key:"_getMode",value:function(e){return"ecb"===e.mode?s.default.mode.ECB:s.default.mode.CBC}},{key:"_getIV",value:function(e){return"cbc"===e.mode?s.default.enc.Utf8.parse(this._iv):null}},{key:"_getRandomIV",value:function(){return s.default.lib.WordArray.random(16)}},{key:"encrypt",value:function(e,t,n){return this._config.customEncrypt?this._config.customEncrypt(e):this.pnEncrypt(e,t,n)}},{key:"decrypt",value:function(e,t,n){return this._config.customDecrypt?this._config.customDecrypt(e):this.pnDecrypt(e,t,n)}},{key:"pnEncrypt",value:function(e,t,n){if(!t&&!this._config.cipherKey)return e;n=this._parseOptions(n);var r=this._getMode(n),i=this._getPaddedKey(t||this._config.cipherKey,n);if(this._config.useRandomIVs){var o=this._getRandomIV(),a=s.default.AES.encrypt(e,i,{iv:o,mode:r}).ciphertext;return o.clone().concat(a.clone()).toString(s.default.enc.Base64)}var u=this._getIV(n);return s.default.AES.encrypt(e,i,{iv:u,mode:r}).ciphertext.toString(s.default.enc.Base64)||e}},{key:"pnDecrypt",value:function(e,t,n){if(!t&&!this._config.cipherKey)return e;n=this._parseOptions(n);var i=this._getMode(n),o=this._getPaddedKey(t||this._config.cipherKey,n);if(this._config.useRandomIVs){var a=r.from(e,"base64"),u=c(a.slice(0,16)),l=c(a.slice(16));try{var f=s.default.AES.decrypt({ciphertext:l},o,{iv:u,mode:i}).toString(s.default.enc.Utf8);return JSON.parse(f)}catch(e){return null}}else{var d=this._getIV(n);try{var p=s.default.enc.Base64.parse(e),h=s.default.AES.decrypt({ciphertext:p},o,{iv:d,mode:i}).toString(s.default.enc.Utf8);return JSON.parse(h)}catch(e){return null}}}}]),e}();t.default=l,e.exports=t.default}).call(this,n(24).Buffer)},function(e,t,n){"use strict";(function(e){
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	var r=n(36),i=n(37),o=n(38);function a(){return s.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function u(e,t){if(a()<t)throw new RangeError("Invalid typed array length");return s.TYPED_ARRAY_SUPPORT?(e=new Uint8Array(t)).__proto__=s.prototype:(null===e&&(e=new s(t)),e.length=t),e}function s(e,t,n){if(!(s.TYPED_ARRAY_SUPPORT||this instanceof s))return new s(e,t,n);if("number"==typeof e){if("string"==typeof t)throw new Error("If encoding is specified then the first argument must be a string");return f(this,e)}return c(this,e,t,n)}function c(e,t,n,r){if("number"==typeof t)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&t instanceof ArrayBuffer?function(e,t,n,r){if(t.byteLength,n<0||t.byteLength<n)throw new RangeError("'offset' is out of bounds");if(t.byteLength<n+(r||0))throw new RangeError("'length' is out of bounds");t=void 0===n&&void 0===r?new Uint8Array(t):void 0===r?new Uint8Array(t,n):new Uint8Array(t,n,r);s.TYPED_ARRAY_SUPPORT?(e=t).__proto__=s.prototype:e=d(e,t);return e}(e,t,n,r):"string"==typeof t?function(e,t,n){"string"==typeof n&&""!==n||(n="utf8");if(!s.isEncoding(n))throw new TypeError('"encoding" must be a valid string encoding');var r=0|h(t,n),i=(e=u(e,r)).write(t,n);i!==r&&(e=e.slice(0,i));return e}(e,t,n):function(e,t){if(s.isBuffer(t)){var n=0|p(t.length);return 0===(e=u(e,n)).length||t.copy(e,0,0,n),e}if(t){if("undefined"!=typeof ArrayBuffer&&t.buffer instanceof ArrayBuffer||"length"in t)return"number"!=typeof t.length||(r=t.length)!=r?u(e,0):d(e,t);if("Buffer"===t.type&&o(t.data))return d(e,t.data)}var r;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(e,t)}function l(e){if("number"!=typeof e)throw new TypeError('"size" argument must be a number');if(e<0)throw new RangeError('"size" argument must not be negative')}function f(e,t){if(l(t),e=u(e,t<0?0:0|p(t)),!s.TYPED_ARRAY_SUPPORT)for(var n=0;n<t;++n)e[n]=0;return e}function d(e,t){var n=t.length<0?0:0|p(t.length);e=u(e,n);for(var r=0;r<n;r+=1)e[r]=255&t[r];return e}function p(e){if(e>=a())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+a().toString(16)+" bytes");return 0|e}function h(e,t){if(s.isBuffer(e))return e.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(e)||e instanceof ArrayBuffer))return e.byteLength;"string"!=typeof e&&(e=""+e);var n=e.length;if(0===n)return 0;for(var r=!1;;)switch(t){case"ascii":case"latin1":case"binary":return n;case"utf8":case"utf-8":case void 0:return K(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*n;case"hex":return n>>>1;case"base64":return B(e).length;default:if(r)return K(e).length;t=(""+t).toLowerCase(),r=!0}}function y(e,t,n){var r=!1;if((void 0===t||t<0)&&(t=0),t>this.length)return"";if((void 0===n||n>this.length)&&(n=this.length),n<=0)return"";if((n>>>=0)<=(t>>>=0))return"";for(e||(e="utf8");;)switch(e){case"hex":return M(this,t,n);case"utf8":case"utf-8":return T(this,t,n);case"ascii":return x(this,t,n);case"latin1":case"binary":return A(this,t,n);case"base64":return k(this,t,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return E(this,t,n);default:if(r)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase(),r=!0}}function g(e,t,n){var r=e[t];e[t]=e[n],e[n]=r}function v(e,t,n,r,i){if(0===e.length)return-1;if("string"==typeof n?(r=n,n=0):n>2147483647?n=2147483647:n<-2147483648&&(n=-2147483648),n=+n,isNaN(n)&&(n=i?0:e.length-1),n<0&&(n=e.length+n),n>=e.length){if(i)return-1;n=e.length-1}else if(n<0){if(!i)return-1;n=0}if("string"==typeof t&&(t=s.from(t,r)),s.isBuffer(t))return 0===t.length?-1:b(e,t,n,r,i);if("number"==typeof t)return t&=255,s.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(e,t,n):Uint8Array.prototype.lastIndexOf.call(e,t,n):b(e,[t],n,r,i);throw new TypeError("val must be string, number or Buffer")}function b(e,t,n,r,i){var o,a=1,u=e.length,s=t.length;if(void 0!==r&&("ucs2"===(r=String(r).toLowerCase())||"ucs-2"===r||"utf16le"===r||"utf-16le"===r)){if(e.length<2||t.length<2)return-1;a=2,u/=2,s/=2,n/=2}function c(e,t){return 1===a?e[t]:e.readUInt16BE(t*a)}if(i){var l=-1;for(o=n;o<u;o++)if(c(e,o)===c(t,-1===l?0:o-l)){if(-1===l&&(l=o),o-l+1===s)return l*a}else-1!==l&&(o-=o-l),l=-1}else for(n+s>u&&(n=u-s),o=n;o>=0;o--){for(var f=!0,d=0;d<s;d++)if(c(e,o+d)!==c(t,d)){f=!1;break}if(f)return o}return-1}function m(e,t,n,r){n=Number(n)||0;var i=e.length-n;r?(r=Number(r))>i&&(r=i):r=i;var o=t.length;if(o%2!=0)throw new TypeError("Invalid hex string");r>o/2&&(r=o/2);for(var a=0;a<r;++a){var u=parseInt(t.substr(2*a,2),16);if(isNaN(u))return a;e[n+a]=u}return a}function _(e,t,n,r){return G(K(t,e.length-n),e,n,r)}function P(e,t,n,r){return G(function(e){for(var t=[],n=0;n<e.length;++n)t.push(255&e.charCodeAt(n));return t}(t),e,n,r)}function O(e,t,n,r){return P(e,t,n,r)}function S(e,t,n,r){return G(B(t),e,n,r)}function w(e,t,n,r){return G(function(e,t){for(var n,r,i,o=[],a=0;a<e.length&&!((t-=2)<0);++a)n=e.charCodeAt(a),r=n>>8,i=n%256,o.push(i),o.push(r);return o}(t,e.length-n),e,n,r)}function k(e,t,n){return 0===t&&n===e.length?r.fromByteArray(e):r.fromByteArray(e.slice(t,n))}function T(e,t,n){n=Math.min(e.length,n);for(var r=[],i=t;i<n;){var o,a,u,s,c=e[i],l=null,f=c>239?4:c>223?3:c>191?2:1;if(i+f<=n)switch(f){case 1:c<128&&(l=c);break;case 2:128==(192&(o=e[i+1]))&&(s=(31&c)<<6|63&o)>127&&(l=s);break;case 3:o=e[i+1],a=e[i+2],128==(192&o)&&128==(192&a)&&(s=(15&c)<<12|(63&o)<<6|63&a)>2047&&(s<55296||s>57343)&&(l=s);break;case 4:o=e[i+1],a=e[i+2],u=e[i+3],128==(192&o)&&128==(192&a)&&128==(192&u)&&(s=(15&c)<<18|(63&o)<<12|(63&a)<<6|63&u)>65535&&s<1114112&&(l=s)}null===l?(l=65533,f=1):l>65535&&(l-=65536,r.push(l>>>10&1023|55296),l=56320|1023&l),r.push(l),i+=f}return function(e){var t=e.length;if(t<=4096)return String.fromCharCode.apply(String,e);var n="",r=0;for(;r<t;)n+=String.fromCharCode.apply(String,e.slice(r,r+=4096));return n}(r)}t.Buffer=s,t.SlowBuffer=function(e){+e!=e&&(e=0);return s.alloc(+e)},t.INSPECT_MAX_BYTES=50,s.TYPED_ARRAY_SUPPORT=void 0!==e.TYPED_ARRAY_SUPPORT?e.TYPED_ARRAY_SUPPORT:function(){try{var e=new Uint8Array(1);return e.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===e.foo()&&"function"==typeof e.subarray&&0===e.subarray(1,1).byteLength}catch(e){return!1}}(),t.kMaxLength=a(),s.poolSize=8192,s._augment=function(e){return e.__proto__=s.prototype,e},s.from=function(e,t,n){return c(null,e,t,n)},s.TYPED_ARRAY_SUPPORT&&(s.prototype.__proto__=Uint8Array.prototype,s.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&s[Symbol.species]===s&&Object.defineProperty(s,Symbol.species,{value:null,configurable:!0})),s.alloc=function(e,t,n){return function(e,t,n,r){return l(t),t<=0?u(e,t):void 0!==n?"string"==typeof r?u(e,t).fill(n,r):u(e,t).fill(n):u(e,t)}(null,e,t,n)},s.allocUnsafe=function(e){return f(null,e)},s.allocUnsafeSlow=function(e){return f(null,e)},s.isBuffer=function(e){return!(null==e||!e._isBuffer)},s.compare=function(e,t){if(!s.isBuffer(e)||!s.isBuffer(t))throw new TypeError("Arguments must be Buffers");if(e===t)return 0;for(var n=e.length,r=t.length,i=0,o=Math.min(n,r);i<o;++i)if(e[i]!==t[i]){n=e[i],r=t[i];break}return n<r?-1:r<n?1:0},s.isEncoding=function(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},s.concat=function(e,t){if(!o(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return s.alloc(0);var n;if(void 0===t)for(t=0,n=0;n<e.length;++n)t+=e[n].length;var r=s.allocUnsafe(t),i=0;for(n=0;n<e.length;++n){var a=e[n];if(!s.isBuffer(a))throw new TypeError('"list" argument must be an Array of Buffers');a.copy(r,i),i+=a.length}return r},s.byteLength=h,s.prototype._isBuffer=!0,s.prototype.swap16=function(){var e=this.length;if(e%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var t=0;t<e;t+=2)g(this,t,t+1);return this},s.prototype.swap32=function(){var e=this.length;if(e%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var t=0;t<e;t+=4)g(this,t,t+3),g(this,t+1,t+2);return this},s.prototype.swap64=function(){var e=this.length;if(e%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var t=0;t<e;t+=8)g(this,t,t+7),g(this,t+1,t+6),g(this,t+2,t+5),g(this,t+3,t+4);return this},s.prototype.toString=function(){var e=0|this.length;return 0===e?"":0===arguments.length?T(this,0,e):y.apply(this,arguments)},s.prototype.equals=function(e){if(!s.isBuffer(e))throw new TypeError("Argument must be a Buffer");return this===e||0===s.compare(this,e)},s.prototype.inspect=function(){var e="",n=t.INSPECT_MAX_BYTES;return this.length>0&&(e=this.toString("hex",0,n).match(/.{2}/g).join(" "),this.length>n&&(e+=" ... ")),"<Buffer "+e+">"},s.prototype.compare=function(e,t,n,r,i){if(!s.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(void 0===t&&(t=0),void 0===n&&(n=e?e.length:0),void 0===r&&(r=0),void 0===i&&(i=this.length),t<0||n>e.length||r<0||i>this.length)throw new RangeError("out of range index");if(r>=i&&t>=n)return 0;if(r>=i)return-1;if(t>=n)return 1;if(this===e)return 0;for(var o=(i>>>=0)-(r>>>=0),a=(n>>>=0)-(t>>>=0),u=Math.min(o,a),c=this.slice(r,i),l=e.slice(t,n),f=0;f<u;++f)if(c[f]!==l[f]){o=c[f],a=l[f];break}return o<a?-1:a<o?1:0},s.prototype.includes=function(e,t,n){return-1!==this.indexOf(e,t,n)},s.prototype.indexOf=function(e,t,n){return v(this,e,t,n,!0)},s.prototype.lastIndexOf=function(e,t,n){return v(this,e,t,n,!1)},s.prototype.write=function(e,t,n,r){if(void 0===t)r="utf8",n=this.length,t=0;else if(void 0===n&&"string"==typeof t)r=t,n=this.length,t=0;else{if(!isFinite(t))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");t|=0,isFinite(n)?(n|=0,void 0===r&&(r="utf8")):(r=n,n=void 0)}var i=this.length-t;if((void 0===n||n>i)&&(n=i),e.length>0&&(n<0||t<0)||t>this.length)throw new RangeError("Attempt to write outside buffer bounds");r||(r="utf8");for(var o=!1;;)switch(r){case"hex":return m(this,e,t,n);case"utf8":case"utf-8":return _(this,e,t,n);case"ascii":return P(this,e,t,n);case"latin1":case"binary":return O(this,e,t,n);case"base64":return S(this,e,t,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return w(this,e,t,n);default:if(o)throw new TypeError("Unknown encoding: "+r);r=(""+r).toLowerCase(),o=!0}},s.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function x(e,t,n){var r="";n=Math.min(e.length,n);for(var i=t;i<n;++i)r+=String.fromCharCode(127&e[i]);return r}function A(e,t,n){var r="";n=Math.min(e.length,n);for(var i=t;i<n;++i)r+=String.fromCharCode(e[i]);return r}function M(e,t,n){var r=e.length;(!t||t<0)&&(t=0),(!n||n<0||n>r)&&(n=r);for(var i="",o=t;o<n;++o)i+=L(e[o]);return i}function E(e,t,n){for(var r=e.slice(t,n),i="",o=0;o<r.length;o+=2)i+=String.fromCharCode(r[o]+256*r[o+1]);return i}function j(e,t,n){if(e%1!=0||e<0)throw new RangeError("offset is not uint");if(e+t>n)throw new RangeError("Trying to access beyond buffer length")}function R(e,t,n,r,i,o){if(!s.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(t>i||t<o)throw new RangeError('"value" argument is out of bounds');if(n+r>e.length)throw new RangeError("Index out of range")}function N(e,t,n,r){t<0&&(t=65535+t+1);for(var i=0,o=Math.min(e.length-n,2);i<o;++i)e[n+i]=(t&255<<8*(r?i:1-i))>>>8*(r?i:1-i)}function C(e,t,n,r){t<0&&(t=4294967295+t+1);for(var i=0,o=Math.min(e.length-n,4);i<o;++i)e[n+i]=t>>>8*(r?i:3-i)&255}function U(e,t,n,r,i,o){if(n+r>e.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("Index out of range")}function I(e,t,n,r,o){return o||U(e,0,n,4),i.write(e,t,n,r,23,4),n+4}function D(e,t,n,r,o){return o||U(e,0,n,8),i.write(e,t,n,r,52,8),n+8}s.prototype.slice=function(e,t){var n,r=this.length;if((e=~~e)<0?(e+=r)<0&&(e=0):e>r&&(e=r),(t=void 0===t?r:~~t)<0?(t+=r)<0&&(t=0):t>r&&(t=r),t<e&&(t=e),s.TYPED_ARRAY_SUPPORT)(n=this.subarray(e,t)).__proto__=s.prototype;else{var i=t-e;n=new s(i,void 0);for(var o=0;o<i;++o)n[o]=this[o+e]}return n},s.prototype.readUIntLE=function(e,t,n){e|=0,t|=0,n||j(e,t,this.length);for(var r=this[e],i=1,o=0;++o<t&&(i*=256);)r+=this[e+o]*i;return r},s.prototype.readUIntBE=function(e,t,n){e|=0,t|=0,n||j(e,t,this.length);for(var r=this[e+--t],i=1;t>0&&(i*=256);)r+=this[e+--t]*i;return r},s.prototype.readUInt8=function(e,t){return t||j(e,1,this.length),this[e]},s.prototype.readUInt16LE=function(e,t){return t||j(e,2,this.length),this[e]|this[e+1]<<8},s.prototype.readUInt16BE=function(e,t){return t||j(e,2,this.length),this[e]<<8|this[e+1]},s.prototype.readUInt32LE=function(e,t){return t||j(e,4,this.length),(this[e]|this[e+1]<<8|this[e+2]<<16)+16777216*this[e+3]},s.prototype.readUInt32BE=function(e,t){return t||j(e,4,this.length),16777216*this[e]+(this[e+1]<<16|this[e+2]<<8|this[e+3])},s.prototype.readIntLE=function(e,t,n){e|=0,t|=0,n||j(e,t,this.length);for(var r=this[e],i=1,o=0;++o<t&&(i*=256);)r+=this[e+o]*i;return r>=(i*=128)&&(r-=Math.pow(2,8*t)),r},s.prototype.readIntBE=function(e,t,n){e|=0,t|=0,n||j(e,t,this.length);for(var r=t,i=1,o=this[e+--r];r>0&&(i*=256);)o+=this[e+--r]*i;return o>=(i*=128)&&(o-=Math.pow(2,8*t)),o},s.prototype.readInt8=function(e,t){return t||j(e,1,this.length),128&this[e]?-1*(255-this[e]+1):this[e]},s.prototype.readInt16LE=function(e,t){t||j(e,2,this.length);var n=this[e]|this[e+1]<<8;return 32768&n?4294901760|n:n},s.prototype.readInt16BE=function(e,t){t||j(e,2,this.length);var n=this[e+1]|this[e]<<8;return 32768&n?4294901760|n:n},s.prototype.readInt32LE=function(e,t){return t||j(e,4,this.length),this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24},s.prototype.readInt32BE=function(e,t){return t||j(e,4,this.length),this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]},s.prototype.readFloatLE=function(e,t){return t||j(e,4,this.length),i.read(this,e,!0,23,4)},s.prototype.readFloatBE=function(e,t){return t||j(e,4,this.length),i.read(this,e,!1,23,4)},s.prototype.readDoubleLE=function(e,t){return t||j(e,8,this.length),i.read(this,e,!0,52,8)},s.prototype.readDoubleBE=function(e,t){return t||j(e,8,this.length),i.read(this,e,!1,52,8)},s.prototype.writeUIntLE=function(e,t,n,r){(e=+e,t|=0,n|=0,r)||R(this,e,t,n,Math.pow(2,8*n)-1,0);var i=1,o=0;for(this[t]=255&e;++o<n&&(i*=256);)this[t+o]=e/i&255;return t+n},s.prototype.writeUIntBE=function(e,t,n,r){(e=+e,t|=0,n|=0,r)||R(this,e,t,n,Math.pow(2,8*n)-1,0);var i=n-1,o=1;for(this[t+i]=255&e;--i>=0&&(o*=256);)this[t+i]=e/o&255;return t+n},s.prototype.writeUInt8=function(e,t,n){return e=+e,t|=0,n||R(this,e,t,1,255,0),s.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[t]=255&e,t+1},s.prototype.writeUInt16LE=function(e,t,n){return e=+e,t|=0,n||R(this,e,t,2,65535,0),s.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):N(this,e,t,!0),t+2},s.prototype.writeUInt16BE=function(e,t,n){return e=+e,t|=0,n||R(this,e,t,2,65535,0),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):N(this,e,t,!1),t+2},s.prototype.writeUInt32LE=function(e,t,n){return e=+e,t|=0,n||R(this,e,t,4,4294967295,0),s.TYPED_ARRAY_SUPPORT?(this[t+3]=e>>>24,this[t+2]=e>>>16,this[t+1]=e>>>8,this[t]=255&e):C(this,e,t,!0),t+4},s.prototype.writeUInt32BE=function(e,t,n){return e=+e,t|=0,n||R(this,e,t,4,4294967295,0),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):C(this,e,t,!1),t+4},s.prototype.writeIntLE=function(e,t,n,r){if(e=+e,t|=0,!r){var i=Math.pow(2,8*n-1);R(this,e,t,n,i-1,-i)}var o=0,a=1,u=0;for(this[t]=255&e;++o<n&&(a*=256);)e<0&&0===u&&0!==this[t+o-1]&&(u=1),this[t+o]=(e/a>>0)-u&255;return t+n},s.prototype.writeIntBE=function(e,t,n,r){if(e=+e,t|=0,!r){var i=Math.pow(2,8*n-1);R(this,e,t,n,i-1,-i)}var o=n-1,a=1,u=0;for(this[t+o]=255&e;--o>=0&&(a*=256);)e<0&&0===u&&0!==this[t+o+1]&&(u=1),this[t+o]=(e/a>>0)-u&255;return t+n},s.prototype.writeInt8=function(e,t,n){return e=+e,t|=0,n||R(this,e,t,1,127,-128),s.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),e<0&&(e=255+e+1),this[t]=255&e,t+1},s.prototype.writeInt16LE=function(e,t,n){return e=+e,t|=0,n||R(this,e,t,2,32767,-32768),s.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):N(this,e,t,!0),t+2},s.prototype.writeInt16BE=function(e,t,n){return e=+e,t|=0,n||R(this,e,t,2,32767,-32768),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):N(this,e,t,!1),t+2},s.prototype.writeInt32LE=function(e,t,n){return e=+e,t|=0,n||R(this,e,t,4,2147483647,-2147483648),s.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8,this[t+2]=e>>>16,this[t+3]=e>>>24):C(this,e,t,!0),t+4},s.prototype.writeInt32BE=function(e,t,n){return e=+e,t|=0,n||R(this,e,t,4,2147483647,-2147483648),e<0&&(e=4294967295+e+1),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):C(this,e,t,!1),t+4},s.prototype.writeFloatLE=function(e,t,n){return I(this,e,t,!0,n)},s.prototype.writeFloatBE=function(e,t,n){return I(this,e,t,!1,n)},s.prototype.writeDoubleLE=function(e,t,n){return D(this,e,t,!0,n)},s.prototype.writeDoubleBE=function(e,t,n){return D(this,e,t,!1,n)},s.prototype.copy=function(e,t,n,r){if(n||(n=0),r||0===r||(r=this.length),t>=e.length&&(t=e.length),t||(t=0),r>0&&r<n&&(r=n),r===n)return 0;if(0===e.length||0===this.length)return 0;if(t<0)throw new RangeError("targetStart out of bounds");if(n<0||n>=this.length)throw new RangeError("sourceStart out of bounds");if(r<0)throw new RangeError("sourceEnd out of bounds");r>this.length&&(r=this.length),e.length-t<r-n&&(r=e.length-t+n);var i,o=r-n;if(this===e&&n<t&&t<r)for(i=o-1;i>=0;--i)e[i+t]=this[i+n];else if(o<1e3||!s.TYPED_ARRAY_SUPPORT)for(i=0;i<o;++i)e[i+t]=this[i+n];else Uint8Array.prototype.set.call(e,this.subarray(n,n+o),t);return o},s.prototype.fill=function(e,t,n,r){if("string"==typeof e){if("string"==typeof t?(r=t,t=0,n=this.length):"string"==typeof n&&(r=n,n=this.length),1===e.length){var i=e.charCodeAt(0);i<256&&(e=i)}if(void 0!==r&&"string"!=typeof r)throw new TypeError("encoding must be a string");if("string"==typeof r&&!s.isEncoding(r))throw new TypeError("Unknown encoding: "+r)}else"number"==typeof e&&(e&=255);if(t<0||this.length<t||this.length<n)throw new RangeError("Out of range index");if(n<=t)return this;var o;if(t>>>=0,n=void 0===n?this.length:n>>>0,e||(e=0),"number"==typeof e)for(o=t;o<n;++o)this[o]=e;else{var a=s.isBuffer(e)?e:K(new s(e,r).toString()),u=a.length;for(o=0;o<n-t;++o)this[o+t]=a[o%u]}return this};var F=/[^+\/0-9A-Za-z-_]/g;function L(e){return e<16?"0"+e.toString(16):e.toString(16)}function K(e,t){var n;t=t||1/0;for(var r=e.length,i=null,o=[],a=0;a<r;++a){if((n=e.charCodeAt(a))>55295&&n<57344){if(!i){if(n>56319){(t-=3)>-1&&o.push(239,191,189);continue}if(a+1===r){(t-=3)>-1&&o.push(239,191,189);continue}i=n;continue}if(n<56320){(t-=3)>-1&&o.push(239,191,189),i=n;continue}n=65536+(i-55296<<10|n-56320)}else i&&(t-=3)>-1&&o.push(239,191,189);if(i=null,n<128){if((t-=1)<0)break;o.push(n)}else if(n<2048){if((t-=2)<0)break;o.push(n>>6|192,63&n|128)}else if(n<65536){if((t-=3)<0)break;o.push(n>>12|224,n>>6&63|128,63&n|128)}else{if(!(n<1114112))throw new Error("Invalid code point");if((t-=4)<0)break;o.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128)}}return o}function B(e){return r.toByteArray(function(e){if((e=function(e){return e.trim?e.trim():e.replace(/^\s+|\s+$/g,"")}(e).replace(F,"")).length<2)return"";for(;e.length%4!=0;)e+="=";return e}(e))}function G(e,t,n,r){for(var i=0;i<r&&!(i+n>=t.length||i>=e.length);++i)t[i+n]=e[i];return i}}).call(this,n(35))},function(e,t,n){"use strict";var r,i,o,a,u,s=s||function(e,t){var n={},r=n.lib={},i=function(){},o=r.Base={extend:function(e){i.prototype=this;var t=new i;return e&&t.mixIn(e),t.hasOwnProperty("init")||(t.init=function(){t.$super.init.apply(this,arguments)}),t.init.prototype=t,t.$super=this,t},create:function(){var e=this.extend();return e.init.apply(e,arguments),e},init:function(){},mixIn:function(e){for(var t in e)e.hasOwnProperty(t)&&(this[t]=e[t]);e.hasOwnProperty("toString")&&(this.toString=e.toString)},clone:function(){return this.init.prototype.extend(this)}},a=r.WordArray=o.extend({init:function(e,t){e=this.words=e||[],this.sigBytes=null!=t?t:4*e.length},toString:function(e){return(e||s).stringify(this)},concat:function(e){var t=this.words,n=e.words,r=this.sigBytes;if(e=e.sigBytes,this.clamp(),r%4)for(var i=0;i<e;i++)t[r+i>>>2]|=(n[i>>>2]>>>24-i%4*8&255)<<24-(r+i)%4*8;else if(65535<n.length)for(i=0;i<e;i+=4)t[r+i>>>2]=n[i>>>2];else t.push.apply(t,n);return this.sigBytes+=e,this},clamp:function(){var t=this.words,n=this.sigBytes;t[n>>>2]&=4294967295<<32-n%4*8,t.length=e.ceil(n/4)},clone:function(){var e=o.clone.call(this);return e.words=this.words.slice(0),e},random:function(t){for(var n=[],r=0;r<t;r+=4)n.push(4294967296*e.random()|0);return new a.init(n,t)}}),u=n.enc={},s=u.Hex={stringify:function(e){var t=e.words;e=e.sigBytes;for(var n=[],r=0;r<e;r++){var i=t[r>>>2]>>>24-r%4*8&255;n.push((i>>>4).toString(16)),n.push((15&i).toString(16))}return n.join("")},parse:function(e){for(var t=e.length,n=[],r=0;r<t;r+=2)n[r>>>3]|=parseInt(e.substr(r,2),16)<<24-r%8*4;return new a.init(n,t/2)}},c=u.Latin1={stringify:function(e){var t=e.words;e=e.sigBytes;for(var n=[],r=0;r<e;r++)n.push(String.fromCharCode(t[r>>>2]>>>24-r%4*8&255));return n.join("")},parse:function(e){for(var t=e.length,n=[],r=0;r<t;r++)n[r>>>2]|=(255&e.charCodeAt(r))<<24-r%4*8;return new a.init(n,t)}},l=u.Utf8={stringify:function(e){try{return decodeURIComponent(escape(c.stringify(e)))}catch(e){throw Error("Malformed UTF-8 data")}},parse:function(e){return c.parse(unescape(encodeURIComponent(e)))}},f=r.BufferedBlockAlgorithm=o.extend({reset:function(){this._data=new a.init,this._nDataBytes=0},_append:function(e){"string"==typeof e&&(e=l.parse(e)),this._data.concat(e),this._nDataBytes+=e.sigBytes},_process:function(t){var n=this._data,r=n.words,i=n.sigBytes,o=this.blockSize,u=i/(4*o);if(t=(u=t?e.ceil(u):e.max((0|u)-this._minBufferSize,0))*o,i=e.min(4*t,i),t){for(var s=0;s<t;s+=o)this._doProcessBlock(r,s);s=r.splice(0,t),n.sigBytes-=i}return new a.init(s,i)},clone:function(){var e=o.clone.call(this);return e._data=this._data.clone(),e},_minBufferSize:0});r.Hasher=f.extend({cfg:o.extend(),init:function(e){this.cfg=this.cfg.extend(e),this.reset()},reset:function(){f.reset.call(this),this._doReset()},update:function(e){return this._append(e),this._process(),this},finalize:function(e){return e&&this._append(e),this._doFinalize()},blockSize:16,_createHelper:function(e){return function(t,n){return new e.init(n).finalize(t)}},_createHmacHelper:function(e){return function(t,n){return new d.HMAC.init(e,n).finalize(t)}}});var d=n.algo={};return n}(Math);!function(e){for(var t=s,n=(i=t.lib).WordArray,r=i.Hasher,i=t.algo,o=[],a=[],u=function(e){return 4294967296*(e-(0|e))|0},c=2,l=0;64>l;){var f;e:{f=c;for(var d=e.sqrt(f),p=2;p<=d;p++)if(!(f%p)){f=!1;break e}f=!0}f&&(8>l&&(o[l]=u(e.pow(c,.5))),a[l]=u(e.pow(c,1/3)),l++),c++}var h=[];i=i.SHA256=r.extend({_doReset:function(){this._hash=new n.init(o.slice(0))},_doProcessBlock:function(e,t){for(var n=this._hash.words,r=n[0],i=n[1],o=n[2],u=n[3],s=n[4],c=n[5],l=n[6],f=n[7],d=0;64>d;d++){if(16>d)h[d]=0|e[t+d];else{var p=h[d-15],y=h[d-2];h[d]=((p<<25|p>>>7)^(p<<14|p>>>18)^p>>>3)+h[d-7]+((y<<15|y>>>17)^(y<<13|y>>>19)^y>>>10)+h[d-16]}p=f+((s<<26|s>>>6)^(s<<21|s>>>11)^(s<<7|s>>>25))+(s&c^~s&l)+a[d]+h[d],y=((r<<30|r>>>2)^(r<<19|r>>>13)^(r<<10|r>>>22))+(r&i^r&o^i&o),f=l,l=c,c=s,s=u+p|0,u=o,o=i,i=r,r=p+y|0}n[0]=n[0]+r|0,n[1]=n[1]+i|0,n[2]=n[2]+o|0,n[3]=n[3]+u|0,n[4]=n[4]+s|0,n[5]=n[5]+c|0,n[6]=n[6]+l|0,n[7]=n[7]+f|0},_doFinalize:function(){var t=this._data,n=t.words,r=8*this._nDataBytes,i=8*t.sigBytes;return n[i>>>5]|=128<<24-i%32,n[14+(i+64>>>9<<4)]=e.floor(r/4294967296),n[15+(i+64>>>9<<4)]=r,t.sigBytes=4*n.length,this._process(),this._hash},clone:function(){var e=r.clone.call(this);return e._hash=this._hash.clone(),e}});t.SHA256=r._createHelper(i),t.HmacSHA256=r._createHmacHelper(i)}(Math),i=(r=s).enc.Utf8,r.algo.HMAC=r.lib.Base.extend({init:function(e,t){e=this._hasher=new e.init,"string"==typeof t&&(t=i.parse(t));var n=e.blockSize,r=4*n;t.sigBytes>r&&(t=e.finalize(t)),t.clamp();for(var o=this._oKey=t.clone(),a=this._iKey=t.clone(),u=o.words,s=a.words,c=0;c<n;c++)u[c]^=1549556828,s[c]^=909522486;o.sigBytes=a.sigBytes=r,this.reset()},reset:function(){var e=this._hasher;e.reset(),e.update(this._iKey)},update:function(e){return this._hasher.update(e),this},finalize:function(e){var t=this._hasher;return e=t.finalize(e),t.reset(),t.finalize(this._oKey.clone().concat(e))}}),a=(o=s).lib.WordArray,o.enc.Base64={stringify:function(e){var t=e.words,n=e.sigBytes,r=this._map;e.clamp(),e=[];for(var i=0;i<n;i+=3)for(var o=(t[i>>>2]>>>24-i%4*8&255)<<16|(t[i+1>>>2]>>>24-(i+1)%4*8&255)<<8|t[i+2>>>2]>>>24-(i+2)%4*8&255,a=0;4>a&&i+.75*a<n;a++)e.push(r.charAt(o>>>6*(3-a)&63));if(t=r.charAt(64))for(;e.length%4;)e.push(t);return e.join("")},parse:function(e){var t=e.length,n=this._map;(r=n.charAt(64))&&-1!=(r=e.indexOf(r))&&(t=r);for(var r=[],i=0,o=0;o<t;o++)if(o%4){var u=n.indexOf(e.charAt(o-1))<<o%4*2,s=n.indexOf(e.charAt(o))>>>6-o%4*2;r[i>>>2]|=(u|s)<<24-i%4*8,i++}return a.create(r,i)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="},function(e){function t(e,t,n,r,i,o,a){return((e=e+(t&n|~t&r)+i+a)<<o|e>>>32-o)+t}function n(e,t,n,r,i,o,a){return((e=e+(t&r|n&~r)+i+a)<<o|e>>>32-o)+t}function r(e,t,n,r,i,o,a){return((e=e+(t^n^r)+i+a)<<o|e>>>32-o)+t}function i(e,t,n,r,i,o,a){return((e=e+(n^(t|~r))+i+a)<<o|e>>>32-o)+t}for(var o=s,a=(c=o.lib).WordArray,u=c.Hasher,c=o.algo,l=[],f=0;64>f;f++)l[f]=4294967296*e.abs(e.sin(f+1))|0;c=c.MD5=u.extend({_doReset:function(){this._hash=new a.init([1732584193,4023233417,2562383102,271733878])},_doProcessBlock:function(e,o){for(var a=0;16>a;a++){var u=e[s=o+a];e[s]=16711935&(u<<8|u>>>24)|4278255360&(u<<24|u>>>8)}a=this._hash.words;var s=e[o+0],c=(u=e[o+1],e[o+2]),f=e[o+3],d=e[o+4],p=e[o+5],h=e[o+6],y=e[o+7],g=e[o+8],v=e[o+9],b=e[o+10],m=e[o+11],_=e[o+12],P=e[o+13],O=e[o+14],S=e[o+15],w=t(w=a[0],x=a[1],T=a[2],k=a[3],s,7,l[0]),k=t(k,w,x,T,u,12,l[1]),T=t(T,k,w,x,c,17,l[2]),x=t(x,T,k,w,f,22,l[3]);w=t(w,x,T,k,d,7,l[4]),k=t(k,w,x,T,p,12,l[5]),T=t(T,k,w,x,h,17,l[6]),x=t(x,T,k,w,y,22,l[7]),w=t(w,x,T,k,g,7,l[8]),k=t(k,w,x,T,v,12,l[9]),T=t(T,k,w,x,b,17,l[10]),x=t(x,T,k,w,m,22,l[11]),w=t(w,x,T,k,_,7,l[12]),k=t(k,w,x,T,P,12,l[13]),T=t(T,k,w,x,O,17,l[14]),w=n(w,x=t(x,T,k,w,S,22,l[15]),T,k,u,5,l[16]),k=n(k,w,x,T,h,9,l[17]),T=n(T,k,w,x,m,14,l[18]),x=n(x,T,k,w,s,20,l[19]),w=n(w,x,T,k,p,5,l[20]),k=n(k,w,x,T,b,9,l[21]),T=n(T,k,w,x,S,14,l[22]),x=n(x,T,k,w,d,20,l[23]),w=n(w,x,T,k,v,5,l[24]),k=n(k,w,x,T,O,9,l[25]),T=n(T,k,w,x,f,14,l[26]),x=n(x,T,k,w,g,20,l[27]),w=n(w,x,T,k,P,5,l[28]),k=n(k,w,x,T,c,9,l[29]),T=n(T,k,w,x,y,14,l[30]),w=r(w,x=n(x,T,k,w,_,20,l[31]),T,k,p,4,l[32]),k=r(k,w,x,T,g,11,l[33]),T=r(T,k,w,x,m,16,l[34]),x=r(x,T,k,w,O,23,l[35]),w=r(w,x,T,k,u,4,l[36]),k=r(k,w,x,T,d,11,l[37]),T=r(T,k,w,x,y,16,l[38]),x=r(x,T,k,w,b,23,l[39]),w=r(w,x,T,k,P,4,l[40]),k=r(k,w,x,T,s,11,l[41]),T=r(T,k,w,x,f,16,l[42]),x=r(x,T,k,w,h,23,l[43]),w=r(w,x,T,k,v,4,l[44]),k=r(k,w,x,T,_,11,l[45]),T=r(T,k,w,x,S,16,l[46]),w=i(w,x=r(x,T,k,w,c,23,l[47]),T,k,s,6,l[48]),k=i(k,w,x,T,y,10,l[49]),T=i(T,k,w,x,O,15,l[50]),x=i(x,T,k,w,p,21,l[51]),w=i(w,x,T,k,_,6,l[52]),k=i(k,w,x,T,f,10,l[53]),T=i(T,k,w,x,b,15,l[54]),x=i(x,T,k,w,u,21,l[55]),w=i(w,x,T,k,g,6,l[56]),k=i(k,w,x,T,S,10,l[57]),T=i(T,k,w,x,h,15,l[58]),x=i(x,T,k,w,P,21,l[59]),w=i(w,x,T,k,d,6,l[60]),k=i(k,w,x,T,m,10,l[61]),T=i(T,k,w,x,c,15,l[62]),x=i(x,T,k,w,v,21,l[63]);a[0]=a[0]+w|0,a[1]=a[1]+x|0,a[2]=a[2]+T|0,a[3]=a[3]+k|0},_doFinalize:function(){var t=this._data,n=t.words,r=8*this._nDataBytes,i=8*t.sigBytes;n[i>>>5]|=128<<24-i%32;var o=e.floor(r/4294967296);for(n[15+(i+64>>>9<<4)]=16711935&(o<<8|o>>>24)|4278255360&(o<<24|o>>>8),n[14+(i+64>>>9<<4)]=16711935&(r<<8|r>>>24)|4278255360&(r<<24|r>>>8),t.sigBytes=4*(n.length+1),this._process(),n=(t=this._hash).words,r=0;4>r;r++)i=n[r],n[r]=16711935&(i<<8|i>>>24)|4278255360&(i<<24|i>>>8);return t},clone:function(){var e=u.clone.call(this);return e._hash=this._hash.clone(),e}}),o.MD5=u._createHelper(c),o.HmacMD5=u._createHmacHelper(c)}(Math),function(){var e,t=s,n=(e=t.lib).Base,r=e.WordArray,i=(e=t.algo).EvpKDF=n.extend({cfg:n.extend({keySize:4,hasher:e.MD5,iterations:1}),init:function(e){this.cfg=this.cfg.extend(e)},compute:function(e,t){for(var n=(u=this.cfg).hasher.create(),i=r.create(),o=i.words,a=u.keySize,u=u.iterations;o.length<a;){s&&n.update(s);var s=n.update(e).finalize(t);n.reset();for(var c=1;c<u;c++)s=n.finalize(s),n.reset();i.concat(s)}return i.sigBytes=4*a,i}});t.EvpKDF=function(e,t,n){return i.create(n).compute(e,t)}}(),s.lib.Cipher||function(e){var t=(h=s).lib,n=t.Base,r=t.WordArray,i=t.BufferedBlockAlgorithm,o=h.enc.Base64,a=h.algo.EvpKDF,u=t.Cipher=i.extend({cfg:n.extend(),createEncryptor:function(e,t){return this.create(this._ENC_XFORM_MODE,e,t)},createDecryptor:function(e,t){return this.create(this._DEC_XFORM_MODE,e,t)},init:function(e,t,n){this.cfg=this.cfg.extend(n),this._xformMode=e,this._key=t,this.reset()},reset:function(){i.reset.call(this),this._doReset()},process:function(e){return this._append(e),this._process()},finalize:function(e){return e&&this._append(e),this._doFinalize()},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(e){return{encrypt:function(t,n,r){return("string"==typeof n?y:p).encrypt(e,t,n,r)},decrypt:function(t,n,r){return("string"==typeof n?y:p).decrypt(e,t,n,r)}}}});t.StreamCipher=u.extend({_doFinalize:function(){return this._process(!0)},blockSize:1});var c=h.mode={},l=function(e,t,n){var r=this._iv;r?this._iv=void 0:r=this._prevBlock;for(var i=0;i<n;i++)e[t+i]^=r[i]},f=(t.BlockCipherMode=n.extend({createEncryptor:function(e,t){return this.Encryptor.create(e,t)},createDecryptor:function(e,t){return this.Decryptor.create(e,t)},init:function(e,t){this._cipher=e,this._iv=t}})).extend();f.Encryptor=f.extend({processBlock:function(e,t){var n=this._cipher,r=n.blockSize;l.call(this,e,t,r),n.encryptBlock(e,t),this._prevBlock=e.slice(t,t+r)}}),f.Decryptor=f.extend({processBlock:function(e,t){var n=this._cipher,r=n.blockSize,i=e.slice(t,t+r);n.decryptBlock(e,t),l.call(this,e,t,r),this._prevBlock=i}}),c=c.CBC=f,f=(h.pad={}).Pkcs7={pad:function(e,t){for(var n,i=(n=(n=4*t)-e.sigBytes%n)<<24|n<<16|n<<8|n,o=[],a=0;a<n;a+=4)o.push(i);n=r.create(o,n),e.concat(n)},unpad:function(e){e.sigBytes-=255&e.words[e.sigBytes-1>>>2]}},t.BlockCipher=u.extend({cfg:u.cfg.extend({mode:c,padding:f}),reset:function(){u.reset.call(this);var e=(t=this.cfg).iv,t=t.mode;if(this._xformMode==this._ENC_XFORM_MODE)var n=t.createEncryptor;else n=t.createDecryptor,this._minBufferSize=1;this._mode=n.call(t,this,e&&e.words)},_doProcessBlock:function(e,t){this._mode.processBlock(e,t)},_doFinalize:function(){var e=this.cfg.padding;if(this._xformMode==this._ENC_XFORM_MODE){e.pad(this._data,this.blockSize);var t=this._process(!0)}else t=this._process(!0),e.unpad(t);return t},blockSize:4});var d=t.CipherParams=n.extend({init:function(e){this.mixIn(e)},toString:function(e){return(e||this.formatter).stringify(this)}}),p=(c=(h.format={}).OpenSSL={stringify:function(e){var t=e.ciphertext;return((e=e.salt)?r.create([1398893684,1701076831]).concat(e).concat(t):t).toString(o)},parse:function(e){var t=(e=o.parse(e)).words;if(1398893684==t[0]&&1701076831==t[1]){var n=r.create(t.slice(2,4));t.splice(0,4),e.sigBytes-=16}return d.create({ciphertext:e,salt:n})}},t.SerializableCipher=n.extend({cfg:n.extend({format:c}),encrypt:function(e,t,n,r){r=this.cfg.extend(r);var i=e.createEncryptor(n,r);return t=i.finalize(t),i=i.cfg,d.create({ciphertext:t,key:n,iv:i.iv,algorithm:e,mode:i.mode,padding:i.padding,blockSize:e.blockSize,formatter:r.format})},decrypt:function(e,t,n,r){return r=this.cfg.extend(r),t=this._parse(t,r.format),e.createDecryptor(n,r).finalize(t.ciphertext)},_parse:function(e,t){return"string"==typeof e?t.parse(e,this):e}})),h=(h.kdf={}).OpenSSL={execute:function(e,t,n,i){return i||(i=r.random(8)),e=a.create({keySize:t+n}).compute(e,i),n=r.create(e.words.slice(t),4*n),e.sigBytes=4*t,d.create({key:e,iv:n,salt:i})}},y=t.PasswordBasedCipher=p.extend({cfg:p.cfg.extend({kdf:h}),encrypt:function(e,t,n,r){return n=(r=this.cfg.extend(r)).kdf.execute(n,e.keySize,e.ivSize),r.iv=n.iv,(e=p.encrypt.call(this,e,t,n.key,r)).mixIn(n),e},decrypt:function(e,t,n,r){return r=this.cfg.extend(r),t=this._parse(t,r.format),n=r.kdf.execute(n,e.keySize,e.ivSize,t.salt),r.iv=n.iv,p.decrypt.call(this,e,t,n.key,r)}})}(),function(){for(var e=s,t=e.lib.BlockCipher,n=e.algo,r=[],i=[],o=[],a=[],u=[],c=[],l=[],f=[],d=[],p=[],h=[],y=0;256>y;y++)h[y]=128>y?y<<1:y<<1^283;var g=0,v=0;for(y=0;256>y;y++){var b=(b=v^v<<1^v<<2^v<<3^v<<4)>>>8^255&b^99;r[g]=b,i[b]=g;var m=h[g],_=h[m],P=h[_],O=257*h[b]^16843008*b;o[g]=O<<24|O>>>8,a[g]=O<<16|O>>>16,u[g]=O<<8|O>>>24,c[g]=O,O=16843009*P^65537*_^257*m^16843008*g,l[b]=O<<24|O>>>8,f[b]=O<<16|O>>>16,d[b]=O<<8|O>>>24,p[b]=O,g?(g=m^h[h[h[P^m]]],v^=h[h[v]]):g=v=1}var S=[0,1,2,4,8,16,32,64,128,27,54];n=n.AES=t.extend({_doReset:function(){for(var e=(n=this._key).words,t=n.sigBytes/4,n=4*((this._nRounds=t+6)+1),i=this._keySchedule=[],o=0;o<n;o++)if(o<t)i[o]=e[o];else{var a=i[o-1];o%t?6<t&&4==o%t&&(a=r[a>>>24]<<24|r[a>>>16&255]<<16|r[a>>>8&255]<<8|r[255&a]):(a=r[(a=a<<8|a>>>24)>>>24]<<24|r[a>>>16&255]<<16|r[a>>>8&255]<<8|r[255&a],a^=S[o/t|0]<<24),i[o]=i[o-t]^a}for(e=this._invKeySchedule=[],t=0;t<n;t++)o=n-t,a=t%4?i[o]:i[o-4],e[t]=4>t||4>=o?a:l[r[a>>>24]]^f[r[a>>>16&255]]^d[r[a>>>8&255]]^p[r[255&a]]},encryptBlock:function(e,t){this._doCryptBlock(e,t,this._keySchedule,o,a,u,c,r)},decryptBlock:function(e,t){var n=e[t+1];e[t+1]=e[t+3],e[t+3]=n,this._doCryptBlock(e,t,this._invKeySchedule,l,f,d,p,i),n=e[t+1],e[t+1]=e[t+3],e[t+3]=n},_doCryptBlock:function(e,t,n,r,i,o,a,u){for(var s=this._nRounds,c=e[t]^n[0],l=e[t+1]^n[1],f=e[t+2]^n[2],d=e[t+3]^n[3],p=4,h=1;h<s;h++){var y=r[c>>>24]^i[l>>>16&255]^o[f>>>8&255]^a[255&d]^n[p++],g=r[l>>>24]^i[f>>>16&255]^o[d>>>8&255]^a[255&c]^n[p++],v=r[f>>>24]^i[d>>>16&255]^o[c>>>8&255]^a[255&l]^n[p++];d=r[d>>>24]^i[c>>>16&255]^o[l>>>8&255]^a[255&f]^n[p++],c=y,l=g,f=v}y=(u[c>>>24]<<24|u[l>>>16&255]<<16|u[f>>>8&255]<<8|u[255&d])^n[p++],g=(u[l>>>24]<<24|u[f>>>16&255]<<16|u[d>>>8&255]<<8|u[255&c])^n[p++],v=(u[f>>>24]<<24|u[d>>>16&255]<<16|u[c>>>8&255]<<8|u[255&l])^n[p++],d=(u[d>>>24]<<24|u[c>>>16&255]<<16|u[l>>>8&255]<<8|u[255&f])^n[p++],e[t]=y,e[t+1]=g,e[t+2]=v,e[t+3]=d},keySize:8});e.AES=t._createHelper(n)}(),s.mode.ECB=((u=s.lib.BlockCipherMode.extend()).Encryptor=u.extend({processBlock:function(e,t){this._cipher.encryptBlock(e,t)}}),u.Decryptor=u.extend({processBlock:function(e,t){this._cipher.decryptBlock(e,t)}}),u),e.exports=s},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(5)),o=r(n(6)),a=r(n(4)),u=(n(2),r(n(10))),s=function(){function e(){(0,i.default)(this,e),(0,a.default)(this,"_listeners",void 0),this._listeners=[]}return(0,o.default)(e,[{key:"addListener",value:function(e){this._listeners.push(e)}},{key:"removeListener",value:function(e){var t=[];this._listeners.forEach((function(n){n!==e&&t.push(n)})),this._listeners=t}},{key:"removeAllListeners",value:function(){this._listeners=[]}},{key:"announcePresence",value:function(e){this._listeners.forEach((function(t){t.presence&&t.presence(e)}))}},{key:"announceStatus",value:function(e){this._listeners.forEach((function(t){t.status&&t.status(e)}))}},{key:"announceMessage",value:function(e){this._listeners.forEach((function(t){t.message&&t.message(e)}))}},{key:"announceSignal",value:function(e){this._listeners.forEach((function(t){t.signal&&t.signal(e)}))}},{key:"announceMessageAction",value:function(e){this._listeners.forEach((function(t){t.messageAction&&t.messageAction(e)}))}},{key:"announceFile",value:function(e){this._listeners.forEach((function(t){t.file&&t.file(e)}))}},{key:"announceObjects",value:function(e){this._listeners.forEach((function(t){t.objects&&t.objects(e)}))}},{key:"announceUser",value:function(e){this._listeners.forEach((function(t){t.user&&t.user(e)}))}},{key:"announceSpace",value:function(e){this._listeners.forEach((function(t){t.space&&t.space(e)}))}},{key:"announceMembership",value:function(e){this._listeners.forEach((function(t){t.membership&&t.membership(e)}))}},{key:"announceNetworkUp",value:function(){var e={};e.category=u.default.PNNetworkUpCategory,this.announceStatus(e)}},{key:"announceNetworkDown",value:function(){var e={};e.category=u.default.PNNetworkDownCategory,this.announceStatus(e)}}]),e}();t.default=s,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNTimeOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(){return"/time/0"},t.handleResponse=function(e,t){return{timetoken:t[0]}},t.isAuthSupported=function(){return!1},t.prepareParams=function(){return{}},t.validateParams=function(){};n(2);var i=r(n(1))},function(e,t,n){},function(e,t,n){"use strict";var r=n(21),i=Object.prototype.hasOwnProperty,o=Array.isArray,a=function(){for(var e=[],t=0;t<256;++t)e.push("%"+((t<16?"0":"")+t.toString(16)).toUpperCase());return e}(),u=function(e,t){for(var n=t&&t.plainObjects?Object.create(null):{},r=0;r<e.length;++r)void 0!==e[r]&&(n[r]=e[r]);return n};e.exports={arrayToObject:u,assign:function(e,t){return Object.keys(t).reduce((function(e,n){return e[n]=t[n],e}),e)},combine:function(e,t){return[].concat(e,t)},compact:function(e){for(var t=[{obj:{o:e},prop:"o"}],n=[],r=0;r<t.length;++r)for(var i=t[r],a=i.obj[i.prop],u=Object.keys(a),s=0;s<u.length;++s){var c=u[s],l=a[c];"object"==typeof l&&null!==l&&-1===n.indexOf(l)&&(t.push({obj:a,prop:c}),n.push(l))}return function(e){for(;e.length>1;){var t=e.pop(),n=t.obj[t.prop];if(o(n)){for(var r=[],i=0;i<n.length;++i)void 0!==n[i]&&r.push(n[i]);t.obj[t.prop]=r}}}(t),e},decode:function(e,t,n){var r=e.replace(/\+/g," ");if("iso-8859-1"===n)return r.replace(/%[0-9a-f]{2}/gi,unescape);try{return decodeURIComponent(r)}catch(e){return r}},encode:function(e,t,n,i,o){if(0===e.length)return e;var u=e;if("symbol"==typeof e?u=Symbol.prototype.toString.call(e):"string"!=typeof e&&(u=String(e)),"iso-8859-1"===n)return escape(u).replace(/%u[0-9a-f]{4}/gi,(function(e){return"%26%23"+parseInt(e.slice(2),16)+"%3B"}));for(var s="",c=0;c<u.length;++c){var l=u.charCodeAt(c);45===l||46===l||95===l||126===l||l>=48&&l<=57||l>=65&&l<=90||l>=97&&l<=122||o===r.RFC1738&&(40===l||41===l)?s+=u.charAt(c):l<128?s+=a[l]:l<2048?s+=a[192|l>>6]+a[128|63&l]:l<55296||l>=57344?s+=a[224|l>>12]+a[128|l>>6&63]+a[128|63&l]:(c+=1,l=65536+((1023&l)<<10|1023&u.charCodeAt(c)),s+=a[240|l>>18]+a[128|l>>12&63]+a[128|l>>6&63]+a[128|63&l])}return s},isBuffer:function(e){return!(!e||"object"!=typeof e)&&!!(e.constructor&&e.constructor.isBuffer&&e.constructor.isBuffer(e))},isRegExp:function(e){return"[object RegExp]"===Object.prototype.toString.call(e)},maybeMap:function(e,t){if(o(e)){for(var n=[],r=0;r<e.length;r+=1)n.push(t(e[r]));return n}return t(e)},merge:function e(t,n,r){if(!n)return t;if("object"!=typeof n){if(o(t))t.push(n);else{if(!t||"object"!=typeof t)return[t,n];(r&&(r.plainObjects||r.allowPrototypes)||!i.call(Object.prototype,n))&&(t[n]=!0)}return t}if(!t||"object"!=typeof t)return[t].concat(n);var a=t;return o(t)&&!o(n)&&(a=u(t,r)),o(t)&&o(n)?(n.forEach((function(n,o){if(i.call(t,o)){var a=t[o];a&&"object"==typeof a&&n&&"object"==typeof n?t[o]=e(a,n,r):t.push(n)}else t[o]=n})),t):Object.keys(n).reduce((function(t,o){var a=n[o];return i.call(t,o)?t[o]=e(t[o],a,r):t[o]=a,t}),a)}}},function(e,t,n){"use strict";function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}e.exports=function(e){return null!==e&&"object"===r(e)}},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(5)),o=r(n(14)),a=r(n(16)),u=r(n(13)),s=r(n(7)),c=r(n(32)),l=r(n(33)),f=r(n(125)),d=r(n(25)),p=r(n(126)),h=r(n(127)),y=n(128),g=(n(2),r(n(148))),v=r(n(149));function b(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=(0,u.default)(e);if(t){var i=(0,u.default)(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return(0,a.default)(this,n)}}function m(e){if(!navigator||!navigator.sendBeacon)return!1;navigator.sendBeacon(e)}function _(e){for(var t=d.default.enc.Base64.parse(e).words,n=new ArrayBuffer(4*t.length),r=new Uint8Array(n),i=0,o=0,a=0;a<t.length;a+=1){var u=t[a];r[o=4*a]=(4278190080&u)>>24,r[o+1]=(16711680&u)>>16,r[o+2]=(65280&u)>>8,r[o+3]=255&u}for(var s=o+3;s>=o;s-=1)0===r[s]&&(i+=1);return i>0?r.buffer.slice(0,r.byteLength-i):r.buffer}function P(e){var t=function(e){return e&&"object"===(0,s.default)(e)&&e.constructor===Object};if(!t(e))return e;var n={};return Object.keys(e).forEach((function(r){var i=function(e){return"string"==typeof e||e instanceof String}(r),o=r,a=e[r];Array.isArray(r)||i&&r.indexOf(",")>=0?o=(i?r.split(","):r).reduce((function(e,t){return e+=String.fromCharCode(t)}),""):(function(e){return"number"==typeof e&&isFinite(e)}(r)||i&&!isNaN(r))&&(o=String.fromCharCode(i?parseInt(r,10):10));n[o]=t(a)?P(a):a})),n}var O=function(e){(0,o.default)(n,e);var t=b(n);function n(e){var r;(0,i.default)(this,n);var o=e.listenToBrowserNetworkEvents,a=void 0===o||o;return e.db=p.default,e.sdkFamily="Web",e.networking=new f.default({del:y.del,get:y.get,post:y.post,patch:y.patch,sendBeacon:m,getfile:y.getfile,postfile:y.postfile}),e.cbor=new h.default((function(e){return P(c.default.decode(e))}),_),e.PubNubFile=v.default,e.cryptography=new g.default,r=t.call(this,e),a&&(window.addEventListener("offline",(function(){r.networkDownDetected()})),window.addEventListener("online",(function(){r.networkUpDetected()}))),r}return n}(l.default);t.default=O,e.exports=t.default},function(e,t,n){var r,i;!function(o,a){"use strict";var u=Math.pow(2,-24),s=Math.pow(2,32),c=Math.pow(2,53);void 0===(i="function"==typeof(r={encode:function(e){var t,n=new ArrayBuffer(256),r=new DataView(n),i=0;function o(e){for(var o=n.byteLength,a=i+e;o<a;)o*=2;if(o!==n.byteLength){var u=r;n=new ArrayBuffer(o),r=new DataView(n);for(var s=i+3>>2,c=0;c<s;++c)r.setUint32(4*c,u.getUint32(4*c))}return t=e,r}function a(){i+=t}function u(e){a(o(1).setUint8(i,e))}function l(e){for(var t=o(e.length),n=0;n<e.length;++n)t.setUint8(i+n,e[n]);a()}function f(e,t){t<24?u(e<<5|t):t<256?(u(e<<5|24),u(t)):t<65536?(u(e<<5|25),function(e){a(o(2).setUint16(i,e))}(t)):t<4294967296?(u(e<<5|26),function(e){a(o(4).setUint32(i,e))}(t)):(u(e<<5|27),function(e){var t=e%s,n=(e-t)/s,r=o(8);r.setUint32(i,n),r.setUint32(i+4,t),a()}(t))}if(function e(t){var n;if(!1===t)return u(244);if(!0===t)return u(245);if(null===t)return u(246);if(void 0===t)return u(247);switch(typeof t){case"number":if(Math.floor(t)===t){if(0<=t&&t<=c)return f(0,t);if(-c<=t&&t<0)return f(1,-(t+1))}return u(251),function(e){a(o(8).setFloat64(i,e))}(t);case"string":var r=[];for(n=0;n<t.length;++n){var s=t.charCodeAt(n);s<128?r.push(s):s<2048?(r.push(192|s>>6),r.push(128|63&s)):s<55296?(r.push(224|s>>12),r.push(128|s>>6&63),r.push(128|63&s)):(s=(1023&s)<<10,s|=1023&t.charCodeAt(++n),s+=65536,r.push(240|s>>18),r.push(128|s>>12&63),r.push(128|s>>6&63),r.push(128|63&s))}return f(3,r.length),l(r);default:var d;if(Array.isArray(t))for(f(4,d=t.length),n=0;n<d;++n)e(t[n]);else if(t instanceof Uint8Array)f(2,t.length),l(t);else{var p=Object.keys(t);for(f(5,d=p.length),n=0;n<d;++n){var h=p[n];e(h),e(t[h])}}}}(e),"slice"in n)return n.slice(0,i);for(var d=new ArrayBuffer(i),p=new DataView(d),h=0;h<i;++h)p.setUint8(h,r.getUint8(h));return d},decode:function(e,t,n){var r=new DataView(e),i=0;function o(e,t){return i+=t,e}function a(t){return o(new Uint8Array(e,i,t),t)}function c(){return o(r.getUint8(i),1)}function l(){return o(r.getUint16(i),2)}function f(){return o(r.getUint32(i),4)}function d(){return 255===r.getUint8(i)&&(i+=1,!0)}function p(e){if(e<24)return e;if(24===e)return c();if(25===e)return l();if(26===e)return f();if(27===e)return f()*s+f();if(31===e)return-1;throw"Invalid length encoding"}function h(e){var t=c();if(255===t)return-1;var n=p(31&t);if(n<0||t>>5!==e)throw"Invalid indefinite length element";return n}function y(e,t){for(var n=0;n<t;++n){var r=c();128&r&&(r<224?(r=(31&r)<<6|63&c(),t-=1):r<240?(r=(15&r)<<12|(63&c())<<6|63&c(),t-=2):(r=(15&r)<<18|(63&c())<<12|(63&c())<<6|63&c(),t-=3)),r<65536?e.push(r):(r-=65536,e.push(55296|r>>10),e.push(56320|1023&r))}}"function"!=typeof t&&(t=function(e){return e}),"function"!=typeof n&&(n=function(){});var g=function e(){var s,f,g=c(),v=g>>5,b=31&g;if(7===v)switch(b){case 25:return function(){var e=new ArrayBuffer(4),t=new DataView(e),n=l(),r=32768&n,i=31744&n,o=1023&n;if(31744===i)i=261120;else if(0!==i)i+=114688;else if(0!==o)return o*u;return t.setUint32(0,r<<16|i<<13|o<<13),t.getFloat32(0)}();case 26:return o(r.getFloat32(i),4);case 27:return o(r.getFloat64(i),8)}if((f=p(b))<0&&(v<2||6<v))throw"Invalid length";switch(v){case 0:return f;case 1:return-1-f;case 2:if(f<0){for(var m=[],_=0;(f=h(v))>=0;)_+=f,m.push(a(f));var P=new Uint8Array(_),O=0;for(s=0;s<m.length;++s)P.set(m[s],O),O+=m[s].length;return P}return a(f);case 3:var S=[];if(f<0)for(;(f=h(v))>=0;)y(S,f);else y(S,f);return String.fromCharCode.apply(null,S);case 4:var w;if(f<0)for(w=[];!d();)w.push(e());else for(w=new Array(f),s=0;s<f;++s)w[s]=e();return w;case 5:var k={};for(s=0;s<f||f<0&&!d();++s){k[e()]=e()}return k;case 6:return t(e(),f);case 7:switch(f){case 20:return!1;case 21:return!0;case 22:return null;case 23:return;default:return n(f)}}}();if(i!==e.byteLength)throw"Remaining bytes";return g}})?r.call(t,n,t,e):r)||(e.exports=i)}()},function(e,t,n){"use strict";var r=n(0),i=n(7);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=r(n(5)),a=r(n(6)),u=r(n(4)),s=r(n(8)),c=r(n(23)),l=r(n(39)),f=r(n(43)),d=r(n(44)),p=r(n(26)),h=r(n(47)),y=r(n(18)),g=n(3),v=Ce(n(52)),b=Ce(n(53)),m=Ce(n(54)),_=Ce(n(55)),P=Ce(n(56)),O=Ce(n(57)),S=Ce(n(58)),w=Ce(n(59)),k=Ce(n(60)),T=Ce(n(61)),x=Ce(n(62)),A=Ce(n(63)),M=Ce(n(64)),E=Ce(n(65)),j=Ce(n(66)),R=Ce(n(67)),N=Ce(n(68)),C=Ce(n(69)),U=(n(28),Ce(n(70)),r(n(71))),I=r(n(72)),D=r(n(73)),F=r(n(74)),L=r(n(76)),K=r(n(77)),B=r(n(78)),G=r(n(79)),q=r(n(85)),H=r(n(86)),z=r(n(87)),W=r(n(88)),V=r(n(89)),Y=r(n(90)),J=r(n(91)),$=r(n(92)),X=r(n(93)),Q=r(n(94)),Z=r(n(95)),ee=Ce(n(96)),te=Ce(n(97)),ne=Ce(n(98)),re=Ce(n(99)),ie=Ce(n(100)),oe=Ce(n(101)),ae=Ce(n(102)),ue=Ce(n(103)),se=Ce(n(104)),ce=Ce(n(105)),le=Ce(n(106)),fe=Ce(n(107)),de=Ce(n(108)),pe=Ce(n(109)),he=Ce(n(110)),ye=Ce(n(111)),ge=Ce(n(112)),ve=Ce(n(113)),be=Ce(n(114)),me=Ce(n(115)),_e=Ce(n(116)),Pe=r(n(117)),Oe=Ce(n(118)),Se=Ce(n(119)),we=Ce(n(120)),ke=Ce(n(121)),Te=Ce(n(122)),xe=Ce(n(123)),Ae=Ce(n(27)),Me=Ce(n(124)),Ee=r(n(1)),je=r(n(10)),Re=(n(2),r(n(17)));function Ne(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,n=new WeakMap;return(Ne=function(e){return e?n:t})(e)}function Ce(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!==i(e)&&"function"!=typeof e)return{default:e};var n=Ne(t);if(n&&n.has(e))return n.get(e);var r={},o=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var a in e)if("default"!==a&&Object.prototype.hasOwnProperty.call(e,a)){var u=o?Object.getOwnPropertyDescriptor(e,a):null;u&&(u.get||u.set)?Object.defineProperty(r,a,u):r[a]=e[a]}return r.default=e,n&&n.set(e,r),r}function Ue(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Ie(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ue(Object(n),!0).forEach((function(t){(0,u.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ue(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var De=function(){function e(t){var n=this;(0,o.default)(this,e),(0,u.default)(this,"_config",void 0),(0,u.default)(this,"_telemetryManager",void 0),(0,u.default)(this,"_listenerManager",void 0),(0,u.default)(this,"_tokenManager",void 0),(0,u.default)(this,"time",void 0),(0,u.default)(this,"publish",void 0),(0,u.default)(this,"fire",void 0),(0,u.default)(this,"history",void 0),(0,u.default)(this,"deleteMessages",void 0),(0,u.default)(this,"messageCounts",void 0),(0,u.default)(this,"fetchMessages",void 0),(0,u.default)(this,"channelGroups",void 0),(0,u.default)(this,"push",void 0),(0,u.default)(this,"hereNow",void 0),(0,u.default)(this,"whereNow",void 0),(0,u.default)(this,"getState",void 0),(0,u.default)(this,"setState",void 0),(0,u.default)(this,"grant",void 0),(0,u.default)(this,"grantToken",void 0),(0,u.default)(this,"audit",void 0),(0,u.default)(this,"revokeToken",void 0),(0,u.default)(this,"subscribe",void 0),(0,u.default)(this,"signal",void 0),(0,u.default)(this,"presence",void 0),(0,u.default)(this,"unsubscribe",void 0),(0,u.default)(this,"unsubscribeAll",void 0),(0,u.default)(this,"addMessageAction",void 0),(0,u.default)(this,"removeMessageAction",void 0),(0,u.default)(this,"getMessageActions",void 0),(0,u.default)(this,"File",void 0),(0,u.default)(this,"encryptFile",void 0),(0,u.default)(this,"decryptFile",void 0),(0,u.default)(this,"listFiles",void 0),(0,u.default)(this,"sendFile",void 0),(0,u.default)(this,"downloadFile",void 0),(0,u.default)(this,"getFileUrl",void 0),(0,u.default)(this,"deleteFile",void 0),(0,u.default)(this,"publishFile",void 0),(0,u.default)(this,"objects",void 0),(0,u.default)(this,"createUser",void 0),(0,u.default)(this,"updateUser",void 0),(0,u.default)(this,"deleteUser",void 0),(0,u.default)(this,"getUser",void 0),(0,u.default)(this,"getUsers",void 0),(0,u.default)(this,"createSpace",void 0),(0,u.default)(this,"updateSpace",void 0),(0,u.default)(this,"deleteSpace",void 0),(0,u.default)(this,"getSpaces",void 0),(0,u.default)(this,"getSpace",void 0),(0,u.default)(this,"getMembers",void 0),(0,u.default)(this,"addMembers",void 0),(0,u.default)(this,"updateMembers",void 0),(0,u.default)(this,"removeMembers",void 0),(0,u.default)(this,"getMemberships",void 0),(0,u.default)(this,"joinSpaces",void 0),(0,u.default)(this,"updateMemberships",void 0),(0,u.default)(this,"leaveSpaces",void 0),(0,u.default)(this,"disconnect",void 0),(0,u.default)(this,"reconnect",void 0),(0,u.default)(this,"destroy",void 0),(0,u.default)(this,"stop",void 0),(0,u.default)(this,"getSubscribedChannels",void 0),(0,u.default)(this,"getSubscribedChannelGroups",void 0),(0,u.default)(this,"addListener",void 0),(0,u.default)(this,"removeListener",void 0),(0,u.default)(this,"removeAllListeners",void 0),(0,u.default)(this,"parseToken",void 0),(0,u.default)(this,"setToken",void 0),(0,u.default)(this,"getToken",void 0),(0,u.default)(this,"getAuthKey",void 0),(0,u.default)(this,"setAuthKey",void 0),(0,u.default)(this,"setCipherKey",void 0),(0,u.default)(this,"setUUID",void 0),(0,u.default)(this,"getUUID",void 0),(0,u.default)(this,"getFilterExpression",void 0),(0,u.default)(this,"setFilterExpression",void 0),(0,u.default)(this,"setHeartbeatInterval",void 0),(0,u.default)(this,"setProxy",void 0),(0,u.default)(this,"encrypt",void 0),(0,u.default)(this,"decrypt",void 0);var r=t.db,i=t.networking,a=t.cbor,d=this._config=new s.default({setup:t,db:r}),Ee=new c.default({config:d}),je=t.cryptography;i.init(d);var Re=this._tokenManager=new h.default(d,a),Ne=this._telemetryManager=new f.default({maximumSamplesCount:6e4}),Ce={config:d,networking:i,crypto:Ee,cryptography:je,tokenManager:Re,telemetryManager:Ne,PubNubFile:t.PubNubFile};this.File=t.PubNubFile,this.encryptFile=function(e,t){return je.encryptFile(e,t,n.File)},this.decryptFile=function(e,t){return je.decryptFile(e,t,n.File)};var Ue=y.default.bind(this,Ce,Ae),De=y.default.bind(this,Ce,T),Fe=y.default.bind(this,Ce,A),Le=y.default.bind(this,Ce,E),Ke=y.default.bind(this,Ce,Me),Be=this._listenerManager=new p.default,Ge=new l.default({timeEndpoint:Ue,leaveEndpoint:De,heartbeatEndpoint:Fe,setStateEndpoint:Le,subscribeEndpoint:Ke,crypto:Ce.crypto,config:Ce.config,listenerManager:Be,getFileUrl:function(e){return(0,L.default)(Ce,e)}});this.addListener=Be.addListener.bind(Be),this.removeListener=Be.removeListener.bind(Be),this.removeAllListeners=Be.removeAllListeners.bind(Be),this.parseToken=Re.parseToken.bind(Re),this.setToken=Re.setToken.bind(Re),this.getToken=Re.getToken.bind(Re),this.channelGroups={listGroups:y.default.bind(this,Ce,_),listChannels:y.default.bind(this,Ce,P),addChannels:y.default.bind(this,Ce,v),removeChannels:y.default.bind(this,Ce,b),deleteGroup:y.default.bind(this,Ce,m)},this.push={addChannels:y.default.bind(this,Ce,O),removeChannels:y.default.bind(this,Ce,S),deleteDevice:y.default.bind(this,Ce,k),listChannels:y.default.bind(this,Ce,w)},this.hereNow=y.default.bind(this,Ce,j),this.whereNow=y.default.bind(this,Ce,x),this.getState=y.default.bind(this,Ce,M),this.setState=Ge.adaptStateChange.bind(Ge),this.grant=y.default.bind(this,Ce,me),this.grantToken=y.default.bind(this,Ce,_e),this.audit=y.default.bind(this,Ce,be),this.revokeToken=y.default.bind(this,Ce,Pe.default),this.publish=y.default.bind(this,Ce,Oe),this.fire=function(e,t){return e.replicate=!1,e.storeInHistory=!1,n.publish(e,t)},this.signal=y.default.bind(this,Ce,Se),this.history=y.default.bind(this,Ce,we),this.deleteMessages=y.default.bind(this,Ce,ke),this.messageCounts=y.default.bind(this,Ce,Te),this.fetchMessages=y.default.bind(this,Ce,xe),this.addMessageAction=y.default.bind(this,Ce,R),this.removeMessageAction=y.default.bind(this,Ce,N),this.getMessageActions=y.default.bind(this,Ce,C),this.listFiles=y.default.bind(this,Ce,U.default);var qe=y.default.bind(this,Ce,I.default);this.publishFile=y.default.bind(this,Ce,D.default),this.sendFile=(0,F.default)({generateUploadUrl:qe,publishFile:this.publishFile,modules:Ce}),this.getFileUrl=function(e){return(0,L.default)(Ce,e)},this.downloadFile=y.default.bind(this,Ce,K.default),this.deleteFile=y.default.bind(this,Ce,B.default),this.objects={getAllUUIDMetadata:y.default.bind(this,Ce,G.default),getUUIDMetadata:y.default.bind(this,Ce,q.default),setUUIDMetadata:y.default.bind(this,Ce,H.default),removeUUIDMetadata:y.default.bind(this,Ce,z.default),getAllChannelMetadata:y.default.bind(this,Ce,W.default),getChannelMetadata:y.default.bind(this,Ce,V.default),setChannelMetadata:y.default.bind(this,Ce,Y.default),removeChannelMetadata:y.default.bind(this,Ce,J.default),getChannelMembers:y.default.bind(this,Ce,$.default),setChannelMembers:function(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),i=1;i<t;i++)r[i-1]=arguments[i];return y.default.call.apply(y.default,[n,Ce,X.default,Ie({type:"set"},e)].concat(r))},removeChannelMembers:function(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),i=1;i<t;i++)r[i-1]=arguments[i];return y.default.call.apply(y.default,[n,Ce,X.default,Ie({type:"delete"},e)].concat(r))},getMemberships:y.default.bind(this,Ce,Q.default),setMemberships:function(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),i=1;i<t;i++)r[i-1]=arguments[i];return y.default.call.apply(y.default,[n,Ce,Z.default,Ie({type:"set"},e)].concat(r))},removeMemberships:function(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),i=1;i<t;i++)r[i-1]=arguments[i];return y.default.call.apply(y.default,[n,Ce,Z.default,Ie({type:"delete"},e)].concat(r))}},this.createUser=(0,g.deprecated)(y.default.bind(this,Ce,ee)),this.updateUser=(0,g.deprecated)(y.default.bind(this,Ce,te)),this.deleteUser=(0,g.deprecated)(y.default.bind(this,Ce,ne)),this.getUser=(0,g.deprecated)(y.default.bind(this,Ce,re)),this.getUsers=(0,g.deprecated)(y.default.bind(this,Ce,ie)),this.createSpace=(0,g.deprecated)(y.default.bind(this,Ce,oe)),this.updateSpace=(0,g.deprecated)(y.default.bind(this,Ce,ae)),this.deleteSpace=(0,g.deprecated)(y.default.bind(this,Ce,ue)),this.getSpaces=(0,g.deprecated)(y.default.bind(this,Ce,se)),this.getSpace=(0,g.deprecated)(y.default.bind(this,Ce,ce)),this.addMembers=(0,g.deprecated)(y.default.bind(this,Ce,fe)),this.updateMembers=(0,g.deprecated)(y.default.bind(this,Ce,de)),this.removeMembers=(0,g.deprecated)(y.default.bind(this,Ce,pe)),this.getMembers=(0,g.deprecated)(y.default.bind(this,Ce,le)),this.getMemberships=(0,g.deprecated)(y.default.bind(this,Ce,he)),this.joinSpaces=(0,g.deprecated)(y.default.bind(this,Ce,ge)),this.updateMemberships=(0,g.deprecated)(y.default.bind(this,Ce,ye)),this.leaveSpaces=(0,g.deprecated)(y.default.bind(this,Ce,ve)),this.time=Ue,this.subscribe=Ge.adaptSubscribeChange.bind(Ge),this.presence=Ge.adaptPresenceChange.bind(Ge),this.unsubscribe=Ge.adaptUnsubscribeChange.bind(Ge),this.disconnect=Ge.disconnect.bind(Ge),this.reconnect=Ge.reconnect.bind(Ge),this.destroy=function(e){Ge.unsubscribeAll(e),Ge.disconnect()},this.stop=this.destroy,this.unsubscribeAll=Ge.unsubscribeAll.bind(Ge),this.getSubscribedChannels=Ge.getSubscribedChannels.bind(Ge),this.getSubscribedChannelGroups=Ge.getSubscribedChannelGroups.bind(Ge),this.encrypt=Ee.encrypt.bind(Ee),this.decrypt=Ee.decrypt.bind(Ee),this.getAuthKey=Ce.config.getAuthKey.bind(Ce.config),this.setAuthKey=Ce.config.setAuthKey.bind(Ce.config),this.setCipherKey=Ce.config.setCipherKey.bind(Ce.config),this.getUUID=Ce.config.getUUID.bind(Ce.config),this.setUUID=Ce.config.setUUID.bind(Ce.config),this.getFilterExpression=Ce.config.getFilterExpression.bind(Ce.config),this.setFilterExpression=Ce.config.setFilterExpression.bind(Ce.config),this.setHeartbeatInterval=Ce.config.setHeartbeatInterval.bind(Ce.config),i.hasModule("proxy")&&(this.setProxy=function(e){Ce.config.setProxy(e),n.reconnect()})}return(0,a.default)(e,[{key:"getVersion",value:function(){return this._config.getVersion()}},{key:"_addPnsdkSuffix",value:function(e,t){this._config._addPnsdkSuffix(e,t)}},{key:"networkDownDetected",value:function(){this._listenerManager.announceNetworkDown(),this._config.restore?this.disconnect():this.destroy(!0)}},{key:"networkUpDetected",value:function(){this._listenerManager.announceNetworkUp(),this.reconnect()}}],[{key:"notificationPayload",value:function(e,t){return new d.default(e,t)}},{key:"generateUUID",value:function(){return Re.default.createUUID()}}]),e}();t.default=De,(0,u.default)(De,"OPERATIONS",Ee.default),(0,u.default)(De,"CATEGORIES",je.default),e.exports=t.default},function(e,t,n){var r,i,o;/*! lil-uuid - v0.1 - MIT License - https://github.com/lil-js/uuid */i=[t],void 0===(o="function"==typeof(r=function(e){var t={3:/^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,4:/^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,5:/^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,all:/^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i};function n(){var e,t,n="";for(e=0;e<32;e++)t=16*Math.random()|0,8!==e&&12!==e&&16!==e&&20!==e||(n+="-"),n+=(12===e?4:16===e?3&t|8:t).toString(16);return n}function r(e,n){var r=t[n||"all"];return r&&r.test(e)||!1}n.isUUID=r,n.VERSION="0.1.0",e.uuid=n,e.isUUID=r})?r.apply(t,i):r)||(e.exports=o)},function(e,t){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";t.byteLength=function(e){var t=c(e),n=t[0],r=t[1];return 3*(n+r)/4-r},t.toByteArray=function(e){var t,n,r=c(e),a=r[0],u=r[1],s=new o(function(e,t,n){return 3*(t+n)/4-n}(0,a,u)),l=0,f=u>0?a-4:a;for(n=0;n<f;n+=4)t=i[e.charCodeAt(n)]<<18|i[e.charCodeAt(n+1)]<<12|i[e.charCodeAt(n+2)]<<6|i[e.charCodeAt(n+3)],s[l++]=t>>16&255,s[l++]=t>>8&255,s[l++]=255&t;2===u&&(t=i[e.charCodeAt(n)]<<2|i[e.charCodeAt(n+1)]>>4,s[l++]=255&t);1===u&&(t=i[e.charCodeAt(n)]<<10|i[e.charCodeAt(n+1)]<<4|i[e.charCodeAt(n+2)]>>2,s[l++]=t>>8&255,s[l++]=255&t);return s},t.fromByteArray=function(e){for(var t,n=e.length,i=n%3,o=[],a=0,u=n-i;a<u;a+=16383)o.push(l(e,a,a+16383>u?u:a+16383));1===i?(t=e[n-1],o.push(r[t>>2]+r[t<<4&63]+"==")):2===i&&(t=(e[n-2]<<8)+e[n-1],o.push(r[t>>10]+r[t>>4&63]+r[t<<2&63]+"="));return o.join("")};for(var r=[],i=[],o="undefined"!=typeof Uint8Array?Uint8Array:Array,a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",u=0,s=a.length;u<s;++u)r[u]=a[u],i[a.charCodeAt(u)]=u;function c(e){var t=e.length;if(t%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var n=e.indexOf("=");return-1===n&&(n=t),[n,n===t?0:4-n%4]}function l(e,t,n){for(var i,o,a=[],u=t;u<n;u+=3)i=(e[u]<<16&16711680)+(e[u+1]<<8&65280)+(255&e[u+2]),a.push(r[(o=i)>>18&63]+r[o>>12&63]+r[o>>6&63]+r[63&o]);return a.join("")}i["-".charCodeAt(0)]=62,i["_".charCodeAt(0)]=63},function(e,t){
	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	t.read=function(e,t,n,r,i){var o,a,u=8*i-r-1,s=(1<<u)-1,c=s>>1,l=-7,f=n?i-1:0,d=n?-1:1,p=e[t+f];for(f+=d,o=p&(1<<-l)-1,p>>=-l,l+=u;l>0;o=256*o+e[t+f],f+=d,l-=8);for(a=o&(1<<-l)-1,o>>=-l,l+=r;l>0;a=256*a+e[t+f],f+=d,l-=8);if(0===o)o=1-c;else{if(o===s)return a?NaN:1/0*(p?-1:1);a+=Math.pow(2,r),o-=c}return(p?-1:1)*a*Math.pow(2,o-r)},t.write=function(e,t,n,r,i,o){var a,u,s,c=8*o-i-1,l=(1<<c)-1,f=l>>1,d=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,p=r?0:o-1,h=r?1:-1,y=t<0||0===t&&1/t<0?1:0;for(t=Math.abs(t),isNaN(t)||t===1/0?(u=isNaN(t)?1:0,a=l):(a=Math.floor(Math.log(t)/Math.LN2),t*(s=Math.pow(2,-a))<1&&(a--,s*=2),(t+=a+f>=1?d/s:d*Math.pow(2,1-f))*s>=2&&(a++,s/=2),a+f>=l?(u=0,a=l):a+f>=1?(u=(t*s-1)*Math.pow(2,i),a+=f):(u=t*Math.pow(2,f-1)*Math.pow(2,i),a=0));i>=8;e[n+p]=255&u,p+=h,u/=256,i-=8);for(a=a<<i|u,c+=i;c>0;e[n+p]=255&a,p+=h,a/=256,c-=8);e[n+p-h]|=128*y}},function(e,t){var n={}.toString;e.exports=Array.isArray||function(e){return"[object Array]"==n.call(e)}},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(7)),o=r(n(5)),a=r(n(6)),u=r(n(4)),s=(r(n(23)),r(n(8)),r(n(26)),r(n(40))),c=r(n(41)),l=r(n(3)),f=(n(2),r(n(10))),d=function(){function e(t){var n=t.subscribeEndpoint,r=t.leaveEndpoint,i=t.heartbeatEndpoint,a=t.setStateEndpoint,l=t.timeEndpoint,f=t.getFileUrl,d=t.config,p=t.crypto,h=t.listenerManager;(0,o.default)(this,e),(0,u.default)(this,"_crypto",void 0),(0,u.default)(this,"_config",void 0),(0,u.default)(this,"_listenerManager",void 0),(0,u.default)(this,"_reconnectionManager",void 0),(0,u.default)(this,"_leaveEndpoint",void 0),(0,u.default)(this,"_heartbeatEndpoint",void 0),(0,u.default)(this,"_setStateEndpoint",void 0),(0,u.default)(this,"_subscribeEndpoint",void 0),(0,u.default)(this,"_getFileUrl",void 0),(0,u.default)(this,"_channels",void 0),(0,u.default)(this,"_presenceChannels",void 0),(0,u.default)(this,"_heartbeatChannels",void 0),(0,u.default)(this,"_heartbeatChannelGroups",void 0),(0,u.default)(this,"_channelGroups",void 0),(0,u.default)(this,"_presenceChannelGroups",void 0),(0,u.default)(this,"_currentTimetoken",void 0),(0,u.default)(this,"_lastTimetoken",void 0),(0,u.default)(this,"_storedTimetoken",void 0),(0,u.default)(this,"_region",void 0),(0,u.default)(this,"_subscribeCall",void 0),(0,u.default)(this,"_heartbeatTimer",void 0),(0,u.default)(this,"_subscriptionStatusAnnounced",void 0),(0,u.default)(this,"_autoNetworkDetection",void 0),(0,u.default)(this,"_isOnline",void 0),(0,u.default)(this,"_pendingChannelSubscriptions",void 0),(0,u.default)(this,"_pendingChannelGroupSubscriptions",void 0),(0,u.default)(this,"_dedupingManager",void 0),this._listenerManager=h,this._config=d,this._leaveEndpoint=r,this._heartbeatEndpoint=i,this._setStateEndpoint=a,this._subscribeEndpoint=n,this._getFileUrl=f,this._crypto=p,this._channels={},this._presenceChannels={},this._heartbeatChannels={},this._heartbeatChannelGroups={},this._channelGroups={},this._presenceChannelGroups={},this._pendingChannelSubscriptions=[],this._pendingChannelGroupSubscriptions=[],this._currentTimetoken=0,this._lastTimetoken=0,this._storedTimetoken=null,this._subscriptionStatusAnnounced=!1,this._isOnline=!0,this._reconnectionManager=new s.default({timeEndpoint:l}),this._dedupingManager=new c.default({config:d})}return(0,a.default)(e,[{key:"adaptStateChange",value:function(e,t){var n=this,r=e.state,i=e.channels,o=void 0===i?[]:i,a=e.channelGroups,u=void 0===a?[]:a;return o.forEach((function(e){e in n._channels&&(n._channels[e].state=r)})),u.forEach((function(e){e in n._channelGroups&&(n._channelGroups[e].state=r)})),this._setStateEndpoint({state:r,channels:o,channelGroups:u},t)}},{key:"adaptPresenceChange",value:function(e){var t=this,n=e.connected,r=e.channels,i=void 0===r?[]:r,o=e.channelGroups,a=void 0===o?[]:o;n?(i.forEach((function(e){t._heartbeatChannels[e]={state:{}}})),a.forEach((function(e){t._heartbeatChannelGroups[e]={state:{}}}))):(i.forEach((function(e){e in t._heartbeatChannels&&delete t._heartbeatChannels[e]})),a.forEach((function(e){e in t._heartbeatChannelGroups&&delete t._heartbeatChannelGroups[e]})),!1===this._config.suppressLeaveEvents&&this._leaveEndpoint({channels:i,channelGroups:a},(function(e){t._listenerManager.announceStatus(e)}))),this.reconnect()}},{key:"adaptSubscribeChange",value:function(e){var t=this,n=e.timetoken,r=e.channels,i=void 0===r?[]:r,o=e.channelGroups,a=void 0===o?[]:o,u=e.withPresence,s=void 0!==u&&u,c=e.withHeartbeats,l=void 0!==c&&c;this._config.subscribeKey&&""!==this._config.subscribeKey?(n&&(this._lastTimetoken=this._currentTimetoken,this._currentTimetoken=n),"0"!==this._currentTimetoken&&0!==this._currentTimetoken&&(this._storedTimetoken=this._currentTimetoken,this._currentTimetoken=0),i.forEach((function(e){t._channels[e]={state:{}},s&&(t._presenceChannels[e]={}),(l||t._config.getHeartbeatInterval())&&(t._heartbeatChannels[e]={}),t._pendingChannelSubscriptions.push(e)})),a.forEach((function(e){t._channelGroups[e]={state:{}},s&&(t._presenceChannelGroups[e]={}),(l||t._config.getHeartbeatInterval())&&(t._heartbeatChannelGroups[e]={}),t._pendingChannelGroupSubscriptions.push(e)})),this._subscriptionStatusAnnounced=!1,this.reconnect()):console&&console.log&&console.log("subscribe key missing; aborting subscribe")}},{key:"adaptUnsubscribeChange",value:function(e,t){var n=this,r=e.channels,i=void 0===r?[]:r,o=e.channelGroups,a=void 0===o?[]:o,u=[],s=[];i.forEach((function(e){e in n._channels&&(delete n._channels[e],u.push(e),e in n._heartbeatChannels&&delete n._heartbeatChannels[e]),e in n._presenceChannels&&(delete n._presenceChannels[e],u.push(e))})),a.forEach((function(e){e in n._channelGroups&&(delete n._channelGroups[e],s.push(e),e in n._heartbeatChannelGroups&&delete n._heartbeatChannelGroups[e]),e in n._presenceChannelGroups&&(delete n._channelGroups[e],s.push(e))})),0===u.length&&0===s.length||(!1!==this._config.suppressLeaveEvents||t||this._leaveEndpoint({channels:u,channelGroups:s},(function(e){e.affectedChannels=u,e.affectedChannelGroups=s,e.currentTimetoken=n._currentTimetoken,e.lastTimetoken=n._lastTimetoken,n._listenerManager.announceStatus(e)})),0===Object.keys(this._channels).length&&0===Object.keys(this._presenceChannels).length&&0===Object.keys(this._channelGroups).length&&0===Object.keys(this._presenceChannelGroups).length&&(this._lastTimetoken=0,this._currentTimetoken=0,this._storedTimetoken=null,this._region=null,this._reconnectionManager.stopPolling()),this.reconnect())}},{key:"unsubscribeAll",value:function(e){this.adaptUnsubscribeChange({channels:this.getSubscribedChannels(),channelGroups:this.getSubscribedChannelGroups()},e)}},{key:"getHeartbeatChannels",value:function(){return Object.keys(this._heartbeatChannels)}},{key:"getHeartbeatChannelGroups",value:function(){return Object.keys(this._heartbeatChannelGroups)}},{key:"getSubscribedChannels",value:function(){return Object.keys(this._channels)}},{key:"getSubscribedChannelGroups",value:function(){return Object.keys(this._channelGroups)}},{key:"reconnect",value:function(){this._startSubscribeLoop(),this._registerHeartbeatTimer()}},{key:"disconnect",value:function(){this._stopSubscribeLoop(),this._stopHeartbeatTimer(),this._reconnectionManager.stopPolling()}},{key:"_registerHeartbeatTimer",value:function(){this._stopHeartbeatTimer(),0!==this._config.getHeartbeatInterval()&&void 0!==this._config.getHeartbeatInterval()&&(this._performHeartbeatLoop(),this._heartbeatTimer=setInterval(this._performHeartbeatLoop.bind(this),1e3*this._config.getHeartbeatInterval()))}},{key:"_stopHeartbeatTimer",value:function(){this._heartbeatTimer&&(clearInterval(this._heartbeatTimer),this._heartbeatTimer=null)}},{key:"_performHeartbeatLoop",value:function(){var e=this,t=this.getHeartbeatChannels(),n=this.getHeartbeatChannelGroups(),r={};if(0!==t.length||0!==n.length){this.getSubscribedChannels().forEach((function(t){var n=e._channels[t].state;Object.keys(n).length&&(r[t]=n)})),this.getSubscribedChannelGroups().forEach((function(t){var n=e._channelGroups[t].state;Object.keys(n).length&&(r[t]=n)}));this._heartbeatEndpoint({channels:t,channelGroups:n,state:r},function(t){t.error&&e._config.announceFailedHeartbeats&&e._listenerManager.announceStatus(t),t.error&&e._config.autoNetworkDetection&&e._isOnline&&(e._isOnline=!1,e.disconnect(),e._listenerManager.announceNetworkDown(),e.reconnect()),!t.error&&e._config.announceSuccessfulHeartbeats&&e._listenerManager.announceStatus(t)}.bind(this))}}},{key:"_startSubscribeLoop",value:function(){var e=this;this._stopSubscribeLoop();var t={},n=[],r=[];if(Object.keys(this._channels).forEach((function(r){var i=e._channels[r].state;Object.keys(i).length&&(t[r]=i),n.push(r)})),Object.keys(this._presenceChannels).forEach((function(e){n.push("".concat(e,"-pnpres"))})),Object.keys(this._channelGroups).forEach((function(n){var i=e._channelGroups[n].state;Object.keys(i).length&&(t[n]=i),r.push(n)})),Object.keys(this._presenceChannelGroups).forEach((function(e){r.push("".concat(e,"-pnpres"))})),0!==n.length||0!==r.length){var i={channels:n,channelGroups:r,state:t,timetoken:this._currentTimetoken,filterExpression:this._config.filterExpression,region:this._region};this._subscribeCall=this._subscribeEndpoint(i,this._processSubscribeResponse.bind(this))}}},{key:"_processSubscribeResponse",value:function(e,t){var n=this;if(e.error)e.category===f.default.PNTimeoutCategory?this._startSubscribeLoop():e.category===f.default.PNNetworkIssuesCategory?(this.disconnect(),e.error&&this._config.autoNetworkDetection&&this._isOnline&&(this._isOnline=!1,this._listenerManager.announceNetworkDown()),this._reconnectionManager.onReconnection((function(){n._config.autoNetworkDetection&&!n._isOnline&&(n._isOnline=!0,n._listenerManager.announceNetworkUp()),n.reconnect(),n._subscriptionStatusAnnounced=!0;var t={category:f.default.PNReconnectedCategory,operation:e.operation,lastTimetoken:n._lastTimetoken,currentTimetoken:n._currentTimetoken};n._listenerManager.announceStatus(t)})),this._reconnectionManager.startPolling(),this._listenerManager.announceStatus(e)):e.category===f.default.PNBadRequestCategory?(this._stopHeartbeatTimer(),this._listenerManager.announceStatus(e)):this._listenerManager.announceStatus(e);else{if(this._storedTimetoken?(this._currentTimetoken=this._storedTimetoken,this._storedTimetoken=null):(this._lastTimetoken=this._currentTimetoken,this._currentTimetoken=t.metadata.timetoken),!this._subscriptionStatusAnnounced){var r={};r.category=f.default.PNConnectedCategory,r.operation=e.operation,r.affectedChannels=this._pendingChannelSubscriptions,r.subscribedChannels=this.getSubscribedChannels(),r.affectedChannelGroups=this._pendingChannelGroupSubscriptions,r.lastTimetoken=this._lastTimetoken,r.currentTimetoken=this._currentTimetoken,this._subscriptionStatusAnnounced=!0,this._listenerManager.announceStatus(r),this._pendingChannelSubscriptions=[],this._pendingChannelGroupSubscriptions=[]}var o=t.messages||[],a=this._config,u=a.requestMessageCountThreshold,s=a.dedupeOnSubscribe;if(u&&o.length>=u){var c={};c.category=f.default.PNRequestMessageCountExceededCategory,c.operation=e.operation,this._listenerManager.announceStatus(c)}o.forEach((function(e){var t=e.channel,r=e.subscriptionMatch,o=e.publishMetaData;if(t===r&&(r=null),s){if(n._dedupingManager.isDuplicate(e))return;n._dedupingManager.addEntry(e)}if(l.default.endsWith(e.channel,"-pnpres")){var a={channel:null,subscription:null};a.actualChannel=null!=r?t:null,a.subscribedChannel=null!=r?r:t,t&&(a.channel=t.substring(0,t.lastIndexOf("-pnpres"))),r&&(a.subscription=r.substring(0,r.lastIndexOf("-pnpres"))),a.action=e.payload.action,a.state=e.payload.data,a.timetoken=o.publishTimetoken,a.occupancy=e.payload.occupancy,a.uuid=e.payload.uuid,a.timestamp=e.payload.timestamp,e.payload.join&&(a.join=e.payload.join),e.payload.leave&&(a.leave=e.payload.leave),e.payload.timeout&&(a.timeout=e.payload.timeout),n._listenerManager.announcePresence(a)}else if(1===e.messageType){var u={channel:null,subscription:null};u.channel=t,u.subscription=r,u.timetoken=o.publishTimetoken,u.publisher=e.issuingClientId,e.userMetadata&&(u.userMetadata=e.userMetadata),u.message=e.payload,n._listenerManager.announceSignal(u)}else if(2===e.messageType){var c={channel:null,subscription:null};c.channel=t,c.subscription=r,c.timetoken=o.publishTimetoken,c.publisher=e.issuingClientId,e.userMetadata&&(c.userMetadata=e.userMetadata),c.message={event:e.payload.event,type:e.payload.type,data:e.payload.data},n._listenerManager.announceObjects(c),"user"===e.payload.type?n._listenerManager.announceUser(c):"space"===e.payload.type?n._listenerManager.announceSpace(c):"membership"===e.payload.type&&n._listenerManager.announceMembership(c)}else if(3===e.messageType){var f={};f.channel=t,f.subscription=r,f.timetoken=o.publishTimetoken,f.publisher=e.issuingClientId,f.data={messageTimetoken:e.payload.data.messageTimetoken,actionTimetoken:e.payload.data.actionTimetoken,type:e.payload.data.type,uuid:e.issuingClientId,value:e.payload.data.value},f.event=e.payload.event,n._listenerManager.announceMessageAction(f)}else if(4===e.messageType){var d={};d.channel=t,d.subscription=r,d.timetoken=o.publishTimetoken,d.publisher=e.issuingClientId;var p=e.payload;if(n._config.cipherKey){var h=n._crypto.decrypt(e.payload);"object"===(0,i.default)(h)&&null!==h&&(p=h)}e.userMetadata&&(d.userMetadata=e.userMetadata),d.message=p.message,d.file={id:p.file.id,name:p.file.name,url:n._getFileUrl({id:p.file.id,name:p.file.name,channel:t})},n._listenerManager.announceFile(d)}else{var y={channel:null,subscription:null};y.actualChannel=null!=r?t:null,y.subscribedChannel=null!=r?r:t,y.channel=t,y.subscription=r,y.timetoken=o.publishTimetoken,y.publisher=e.issuingClientId,e.userMetadata&&(y.userMetadata=e.userMetadata),n._config.cipherKey?y.message=n._crypto.decrypt(e.payload):y.message=e.payload,n._listenerManager.announceMessage(y)}})),this._region=t.metadata.region,this._startSubscribeLoop()}}},{key:"_stopSubscribeLoop",value:function(){this._subscribeCall&&("function"==typeof this._subscribeCall.abort&&this._subscribeCall.abort(),this._subscribeCall=null)}}]),e}();t.default=d,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(5)),o=r(n(6)),a=r(n(4)),u=(r(n(27)),n(2),function(){function e(t){var n=t.timeEndpoint;(0,i.default)(this,e),(0,a.default)(this,"_reconnectionCallback",void 0),(0,a.default)(this,"_timeEndpoint",void 0),(0,a.default)(this,"_timeTimer",void 0),this._timeEndpoint=n}return(0,o.default)(e,[{key:"onReconnection",value:function(e){this._reconnectionCallback=e}},{key:"startPolling",value:function(){this._timeTimer=setInterval(this._performTimeLoop.bind(this),3e3)}},{key:"stopPolling",value:function(){clearInterval(this._timeTimer)}},{key:"_performTimeLoop",value:function(){var e=this;this._timeEndpoint((function(t){t.error||(clearInterval(e._timeTimer),e._reconnectionCallback())}))}}]),e}());t.default=u,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(5)),o=r(n(6)),a=r(n(4)),u=(r(n(8)),n(2),function(){function e(t){var n=t.config;(0,i.default)(this,e),(0,a.default)(this,"_config",void 0),(0,a.default)(this,"hashHistory",void 0),this.hashHistory=[],this._config=n}return(0,o.default)(e,[{key:"getKey",value:function(e){var t=function(e){var t=0;if(0===e.length)return t;for(var n=0;n<e.length;n+=1){t=(t<<5)-t+e.charCodeAt(n),t&=t}return t}(JSON.stringify(e.payload)).toString(),n=e.publishMetaData.publishTimetoken;return"".concat(n,"-").concat(t)}},{key:"isDuplicate",value:function(e){return this.hashHistory.includes(this.getKey(e))}},{key:"addEntry",value:function(e){this.hashHistory.length>=this._config.maximumCacheSize&&this.hashHistory.shift(),this.hashHistory.push(this.getKey(e))}},{key:"clearHistory",value:function(){this.hashHistory=[]}}]),e}());t.default=u,e.exports=t.default},function(e,t){var n,r,i=e.exports={};function o(){throw new Error("setTimeout has not been defined")}function a(){throw new Error("clearTimeout has not been defined")}function u(e){if(n===setTimeout)return setTimeout(e,0);if((n===o||!n)&&setTimeout)return n=setTimeout,setTimeout(e,0);try{return n(e,0)}catch(t){try{return n.call(null,e,0)}catch(t){return n.call(this,e,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:o}catch(e){n=o}try{r="function"==typeof clearTimeout?clearTimeout:a}catch(e){r=a}}();var s,c=[],l=!1,f=-1;function d(){l&&s&&(l=!1,s.length?c=s.concat(c):f=-1,c.length&&p())}function p(){if(!l){var e=u(d);l=!0;for(var t=c.length;t;){for(s=c,c=[];++f<t;)s&&s[f].run();f=-1,t=c.length}s=null,l=!1,function(e){if(r===clearTimeout)return clearTimeout(e);if((r===a||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(e);try{r(e)}catch(t){try{return r.call(null,e)}catch(t){return r.call(this,e)}}}(e)}}function h(e,t){this.fun=e,this.array=t}function y(){}i.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];c.push(new h(e,t)),1!==c.length||l||u(p)},h.prototype.run=function(){this.fun.apply(null,this.array)},i.title="browser",i.browser=!0,i.env={},i.argv=[],i.version="",i.versions={},i.on=y,i.addListener=y,i.once=y,i.off=y,i.removeListener=y,i.removeAllListeners=y,i.emit=y,i.prependListener=y,i.prependOnceListener=y,i.listeners=function(e){return[]},i.binding=function(e){throw new Error("process.binding is not supported")},i.cwd=function(){return"/"},i.chdir=function(e){throw new Error("process.chdir is not supported")},i.umask=function(){return 0}},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(5)),o=r(n(6)),a=r(n(4)),u=r(n(1)),s=function(){function e(t){(0,i.default)(this,e),(0,a.default)(this,"_maximumSamplesCount",100),(0,a.default)(this,"_trackedLatencies",{}),(0,a.default)(this,"_latencies",{}),this._maximumSamplesCount=t.maximumSamplesCount||this._maximumSamplesCount}return(0,o.default)(e,[{key:"operationsLatencyForRequest",value:function(){var e=this,t={};return Object.keys(this._latencies).forEach((function(n){var r=e._latencies[n],i=e._averageLatency(r);i>0&&(t["l_".concat(n)]=i)})),t}},{key:"startLatencyMeasure",value:function(e,t){e!==u.default.PNSubscribeOperation&&t&&(this._trackedLatencies[t]=Date.now())}},{key:"stopLatencyMeasure",value:function(e,t){if(e!==u.default.PNSubscribeOperation&&t){var n=this._endpointName(e),r=this._latencies[n],i=this._trackedLatencies[t];r||(r=this._latencies[n]=[]),r.push(Date.now()-i),r.length>this._maximumSamplesCount&&r.splice(0,r.length-this._maximumSamplesCount),delete this._trackedLatencies[t]}}},{key:"_averageLatency",value:function(e){return Math.floor(e.reduce((function(e,t){return e+t}),0)/e.length)}},{key:"_endpointName",value:function(e){var t=null;switch(e){case u.default.PNPublishOperation:t="pub";break;case u.default.PNSignalOperation:t="sig";break;case u.default.PNHistoryOperation:case u.default.PNFetchMessagesOperation:case u.default.PNDeleteMessagesOperation:case u.default.PNMessageCounts:t="hist";break;case u.default.PNUnsubscribeOperation:case u.default.PNWhereNowOperation:case u.default.PNHereNowOperation:case u.default.PNHeartbeatOperation:case u.default.PNSetStateOperation:case u.default.PNGetStateOperation:t="pres";break;case u.default.PNAddChannelsToGroupOperation:case u.default.PNRemoveChannelsFromGroupOperation:case u.default.PNChannelGroupsOperation:case u.default.PNRemoveGroupOperation:case u.default.PNChannelsForGroupOperation:t="cg";break;case u.default.PNPushNotificationEnabledChannelsOperation:case u.default.PNRemoveAllPushNotificationsOperation:t="push";break;case u.default.PNCreateUserOperation:case u.default.PNUpdateUserOperation:case u.default.PNDeleteUserOperation:case u.default.PNGetUserOperation:case u.default.PNGetUsersOperation:case u.default.PNCreateSpaceOperation:case u.default.PNUpdateSpaceOperation:case u.default.PNDeleteSpaceOperation:case u.default.PNGetSpaceOperation:case u.default.PNGetSpacesOperation:case u.default.PNGetMembersOperation:case u.default.PNUpdateMembersOperation:case u.default.PNGetMembershipsOperation:case u.default.PNUpdateMembershipsOperation:t="obj";break;case u.default.PNAddMessageActionOperation:case u.default.PNRemoveMessageActionOperation:case u.default.PNGetMessageActionsOperation:t="msga";break;case u.default.PNAccessManagerGrant:case u.default.PNAccessManagerAudit:t="pam";break;case u.default.PNAccessManagerGrantToken:case u.default.PNAccessManagerRevokeToken:t="pamv3";break;default:t="time"}return t}}]),e}();t.default=s,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=t.MPNSNotificationPayload=t.FCMNotificationPayload=t.APNSNotificationPayload=void 0;var i=r(n(45)),o=r(n(22)),a=r(n(14)),u=r(n(16)),s=r(n(13)),c=r(n(5)),l=r(n(6)),f=r(n(4)),d=(n(2),["notification","data"]);function p(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function h(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?p(Object(n),!0).forEach((function(t){(0,f.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):p(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function y(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=(0,s.default)(e);if(t){var i=(0,s.default)(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return(0,u.default)(this,n)}}var g=function(){function e(t,n,r){(0,c.default)(this,e),(0,f.default)(this,"_subtitle",void 0),(0,f.default)(this,"_payload",void 0),(0,f.default)(this,"_badge",void 0),(0,f.default)(this,"_sound",void 0),(0,f.default)(this,"_title",void 0),(0,f.default)(this,"_body",void 0),this._payload=t,this._setDefaultPayloadStructure(),this.title=n,this.body=r}return(0,l.default)(e,[{key:"payload",get:function(){return this._payload}},{key:"title",set:function(e){this._title=e}},{key:"subtitle",set:function(e){this._subtitle=e}},{key:"body",set:function(e){this._body=e}},{key:"badge",set:function(e){this._badge=e}},{key:"sound",set:function(e){this._sound=e}},{key:"_setDefaultPayloadStructure",value:function(){}},{key:"toObject",value:function(){return{}}}]),e}(),v=function(e){(0,a.default)(n,e);var t=y(n);function n(){var e;(0,c.default)(this,n);for(var r=arguments.length,i=new Array(r),a=0;a<r;a++)i[a]=arguments[a];return e=t.call.apply(t,[this].concat(i)),(0,f.default)((0,o.default)(e),"_configurations",void 0),(0,f.default)((0,o.default)(e),"_apnsPushType",void 0),(0,f.default)((0,o.default)(e),"_isSilent",void 0),e}return(0,l.default)(n,[{key:"configurations",set:function(e){e&&e.length&&(this._configurations=e)}},{key:"notification",get:function(){return this._payload.aps}},{key:"title",get:function(){return this._title},set:function(e){e&&e.length&&(this._payload.aps.alert.title=e,this._title=e)}},{key:"subtitle",get:function(){return this._subtitle},set:function(e){e&&e.length&&(this._payload.aps.alert.subtitle=e,this._subtitle=e)}},{key:"body",get:function(){return this._body},set:function(e){e&&e.length&&(this._payload.aps.alert.body=e,this._body=e)}},{key:"badge",get:function(){return this._badge},set:function(e){null!=e&&(this._payload.aps.badge=e,this._badge=e)}},{key:"sound",get:function(){return this._sound},set:function(e){e&&e.length&&(this._payload.aps.sound=e,this._sound=e)}},{key:"silent",set:function(e){this._isSilent=e}},{key:"_setDefaultPayloadStructure",value:function(){this._payload.aps={alert:{}}}},{key:"toObject",value:function(){var e=this,t=h({},this._payload),n=t.aps,r=n.alert;if(this._isSilent&&(n["content-available"]=1),"apns2"===this._apnsPushType){if(!this._configurations||!this._configurations.length)throw new ReferenceError("APNS2 configuration is missing");var i=[];this._configurations.forEach((function(t){i.push(e._objectFromAPNS2Configuration(t))})),i.length&&(t.pn_push=i)}return r&&Object.keys(r).length||delete n.alert,this._isSilent&&(delete n.alert,delete n.badge,delete n.sound,r={}),this._isSilent||Object.keys(r).length?t:null}},{key:"_objectFromAPNS2Configuration",value:function(e){var t=this;if(!e.targets||!e.targets.length)throw new ReferenceError("At least one APNS2 target should be provided");var n=[];e.targets.forEach((function(e){n.push(t._objectFromAPNSTarget(e))}));var r=e.collapseId,i=e.expirationDate,o={auth_method:"token",targets:n,version:"v2"};return r&&r.length&&(o.collapse_id=r),i&&(o.expiration=i.toISOString()),o}},{key:"_objectFromAPNSTarget",value:function(e){if(!e.topic||!e.topic.length)throw new TypeError("Target 'topic' undefined.");var t=e.topic,n=e.environment,r=void 0===n?"development":n,i=e.excludedDevices,o=void 0===i?[]:i,a={topic:t,environment:r};return o.length&&(a.excluded_devices=o),a}}]),n}(g);t.APNSNotificationPayload=v;var b=function(e){(0,a.default)(n,e);var t=y(n);function n(){var e;(0,c.default)(this,n);for(var r=arguments.length,i=new Array(r),a=0;a<r;a++)i[a]=arguments[a];return e=t.call.apply(t,[this].concat(i)),(0,f.default)((0,o.default)(e),"_backContent",void 0),(0,f.default)((0,o.default)(e),"_backTitle",void 0),(0,f.default)((0,o.default)(e),"_count",void 0),(0,f.default)((0,o.default)(e),"_type",void 0),e}return(0,l.default)(n,[{key:"backContent",get:function(){return this._backContent},set:function(e){e&&e.length&&(this._payload.back_content=e,this._backContent=e)}},{key:"backTitle",get:function(){return this._backTitle},set:function(e){e&&e.length&&(this._payload.back_title=e,this._backTitle=e)}},{key:"count",get:function(){return this._count},set:function(e){null!=e&&(this._payload.count=e,this._count=e)}},{key:"title",get:function(){return this._title},set:function(e){e&&e.length&&(this._payload.title=e,this._title=e)}},{key:"type",get:function(){return this._type},set:function(e){e&&e.length&&(this._payload.type=e,this._type=e)}},{key:"subtitle",get:function(){return this.backTitle},set:function(e){this.backTitle=e}},{key:"body",get:function(){return this.backContent},set:function(e){this.backContent=e}},{key:"badge",get:function(){return this.count},set:function(e){this.count=e}},{key:"toObject",value:function(){return Object.keys(this._payload).length?h({},this._payload):null}}]),n}(g);t.MPNSNotificationPayload=b;var m=function(e){(0,a.default)(n,e);var t=y(n);function n(){var e;(0,c.default)(this,n);for(var r=arguments.length,i=new Array(r),a=0;a<r;a++)i[a]=arguments[a];return e=t.call.apply(t,[this].concat(i)),(0,f.default)((0,o.default)(e),"_isSilent",void 0),(0,f.default)((0,o.default)(e),"_icon",void 0),(0,f.default)((0,o.default)(e),"_tag",void 0),e}return(0,l.default)(n,[{key:"notification",get:function(){return this._payload.notification}},{key:"data",get:function(){return this._payload.data}},{key:"title",get:function(){return this._title},set:function(e){e&&e.length&&(this._payload.notification.title=e,this._title=e)}},{key:"body",get:function(){return this._body},set:function(e){e&&e.length&&(this._payload.notification.body=e,this._body=e)}},{key:"sound",get:function(){return this._sound},set:function(e){e&&e.length&&(this._payload.notification.sound=e,this._sound=e)}},{key:"icon",get:function(){return this._icon},set:function(e){e&&e.length&&(this._payload.notification.icon=e,this._icon=e)}},{key:"tag",get:function(){return this._tag},set:function(e){e&&e.length&&(this._payload.notification.tag=e,this._tag=e)}},{key:"silent",set:function(e){this._isSilent=e}},{key:"_setDefaultPayloadStructure",value:function(){this._payload.notification={},this._payload.data={}}},{key:"toObject",value:function(){var e=h({},this._payload.data),t=null,n={};if(Object.keys(this._payload).length>2){var r=this._payload,o=(r.notification,r.data,(0,i.default)(r,d));e=h(h({},e),o)}return this._isSilent?e.notification=this._payload.notification:t=this._payload.notification,Object.keys(e).length&&(n.data=e),t&&Object.keys(t).length&&(n.notification=t),Object.keys(n).length?n:null}}]),n}(g);t.FCMNotificationPayload=m;var _=function(){function e(t,n){(0,c.default)(this,e),(0,f.default)(this,"_payload",void 0),(0,f.default)(this,"_debugging",void 0),(0,f.default)(this,"_subtitle",void 0),(0,f.default)(this,"_badge",void 0),(0,f.default)(this,"_sound",void 0),(0,f.default)(this,"_title",void 0),(0,f.default)(this,"_body",void 0),(0,f.default)(this,"apns",void 0),(0,f.default)(this,"mpns",void 0),(0,f.default)(this,"fcm",void 0),this._payload={apns:{},mpns:{},fcm:{}},this._title=t,this._body=n,this.apns=new v(this._payload.apns,t,n),this.mpns=new b(this._payload.mpns,t,n),this.fcm=new m(this._payload.fcm,t,n)}return(0,l.default)(e,[{key:"debugging",set:function(e){this._debugging=e}},{key:"title",get:function(){return this._title}},{key:"body",get:function(){return this._body}},{key:"subtitle",get:function(){return this._subtitle},set:function(e){this._subtitle=e,this.apns.subtitle=e,this.mpns.subtitle=e,this.fcm.subtitle=e}},{key:"badge",get:function(){return this._badge},set:function(e){this._badge=e,this.apns.badge=e,this.mpns.badge=e,this.fcm.badge=e}},{key:"sound",get:function(){return this._sound},set:function(e){this._sound=e,this.apns.sound=e,this.mpns.sound=e,this.fcm.sound=e}},{key:"buildPayload",value:function(e){var t={};if(e.includes("apns")||e.includes("apns2")){this.apns._apnsPushType=e.includes("apns")?"apns":"apns2";var n=this.apns.toObject();n&&Object.keys(n).length&&(t.pn_apns=n)}if(e.includes("mpns")){var r=this.mpns.toObject();r&&Object.keys(r).length&&(t.pn_mpns=r)}if(e.includes("fcm")){var i=this.fcm.toObject();i&&Object.keys(i).length&&(t.pn_gcm=i)}return Object.keys(t).length&&this._debugging&&(t.pn_debug=!0),t}}]),e}();t.default=_},function(e,t,n){var r=n(46);e.exports=function(e,t){if(null==e)return{};var n,i,o=r(e,t);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);for(i=0;i<a.length;i++)n=a[i],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t){e.exports=function(e,t){if(null==e)return{};var n,r,i={},o=Object.keys(e);for(r=0;r<o.length;r++)n=o[r],t.indexOf(n)>=0||(i[n]=e[n]);return i},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(5)),o=r(n(6)),a=r(n(4)),u=(r(n(8)),n(2),function(){function e(t,n){(0,i.default)(this,e),(0,a.default)(this,"_config",void 0),(0,a.default)(this,"_cbor",void 0),(0,a.default)(this,"_token",void 0),this._config=t,this._cbor=n}return(0,o.default)(e,[{key:"setToken",value:function(e){e&&e.length>0?this._token=e:this._token=void 0}},{key:"getToken",value:function(){return this._token}},{key:"extractPermissions",value:function(e){var t={read:!1,write:!1,manage:!1,delete:!1,get:!1,update:!1,join:!1};return 128==(128&e)&&(t.join=!0),64==(64&e)&&(t.update=!0),32==(32&e)&&(t.get=!0),8==(8&e)&&(t.delete=!0),4==(4&e)&&(t.manage=!0),2==(2&e)&&(t.write=!0),1==(1&e)&&(t.read=!0),t}},{key:"parseToken",value:function(e){var t=this,n=this._cbor.decodeToken(e);if(void 0!==n){var r=n.res.uuid?Object.keys(n.res.uuid):[],i=Object.keys(n.res.chan),o=Object.keys(n.res.grp),a=n.pat.uuid?Object.keys(n.pat.uuid):[],u=Object.keys(n.pat.chan),s=Object.keys(n.pat.grp),c={version:n.v,timestamp:n.t,ttl:n.ttl,authorized_uuid:n.uuid},l=r.length>0,f=i.length>0,d=o.length>0;(l||f||d)&&(c.resources={},l&&(c.resources.uuids={},r.forEach((function(e){c.resources.uuids[e]=t.extractPermissions(n.res.uuid[e])}))),f&&(c.resources.channels={},i.forEach((function(e){c.resources.channels[e]=t.extractPermissions(n.res.chan[e])}))),d&&(c.resources.groups={},o.forEach((function(e){c.resources.groups[e]=t.extractPermissions(n.res.grp[e])}))));var p=a.length>0,h=u.length>0,y=s.length>0;return(p||h||y)&&(c.patterns={},p&&(c.patterns.uuids={},a.forEach((function(e){c.patterns.uuids[e]=t.extractPermissions(n.pat.uuid[e])}))),h&&(c.patterns.channels={},u.forEach((function(e){c.patterns.channels[e]=t.extractPermissions(n.pat.chan[e])}))),y&&(c.patterns.groups={},s.forEach((function(e){c.patterns.groups[e]=t.extractPermissions(n.pat.grp[e])})))),Object.keys(n.meta).length>0&&(c.meta=n.meta),c.signature=n.sig,c}}}]),e}());t.default=u,e.exports=t.default},function(e,t,n){var r=n(13),i=n(15),o=n(49),a=n(50);function u(t){var n="function"==typeof Map?new Map:void 0;return e.exports=u=function(e){if(null===e||!o(e))return e;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==n){if(n.has(e))return n.get(e);n.set(e,t)}function t(){return a(e,arguments,r(this).constructor)}return t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),i(t,e)},e.exports.default=e.exports,e.exports.__esModule=!0,u(t)}e.exports=u,e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t){e.exports=function(e){return-1!==Function.toString.call(e).indexOf("[native code]")},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t,n){var r=n(15),i=n(51);function o(t,n,a){return i()?(e.exports=o=Reflect.construct,e.exports.default=e.exports,e.exports.__esModule=!0):(e.exports=o=function(e,t,n){var i=[null];i.push.apply(i,t);var o=new(Function.bind.apply(e,i));return n&&r(o,n.prototype),o},e.exports.default=e.exports,e.exports.__esModule=!0),o.apply(null,arguments)}e.exports=o,e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t){e.exports=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNAddChannelsToGroupOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=t.channelGroup,r=e.config;return"/v1/channel-registration/sub-key/".concat(r.subscribeKey,"/channel-group/").concat(o.default.encodeString(n))},t.handleResponse=function(){return{}},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.channels;return{add:(void 0===n?[]:n).join(",")}},t.validateParams=function(e,t){var n=t.channels,r=t.channelGroup,i=e.config;if(!r)return"Missing Channel Group";if(!n||0===n.length)return"Missing Channels";if(!i.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNRemoveChannelsFromGroupOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=t.channelGroup,r=e.config;return"/v1/channel-registration/sub-key/".concat(r.subscribeKey,"/channel-group/").concat(o.default.encodeString(n))},t.handleResponse=function(){return{}},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.channels;return{remove:(void 0===n?[]:n).join(",")}},t.validateParams=function(e,t){var n=t.channels,r=t.channelGroup,i=e.config;if(!r)return"Missing Channel Group";if(!n||0===n.length)return"Missing Channels";if(!i.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNRemoveGroupOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=t.channelGroup,r=e.config;return"/v1/channel-registration/sub-key/".concat(r.subscribeKey,"/channel-group/").concat(o.default.encodeString(n),"/remove")},t.handleResponse=function(){return{}},t.isAuthSupported=function(){return!0},t.prepareParams=function(){return{}},t.validateParams=function(e,t){var n=t.channelGroup,r=e.config;if(!n)return"Missing Channel Group";if(!r.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNChannelGroupsOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e){var t=e.config;return"/v1/channel-registration/sub-key/".concat(t.subscribeKey,"/channel-group")},t.handleResponse=function(e,t){return{groups:t.payload.groups}},t.isAuthSupported=function(){return!0},t.prepareParams=function(){return{}},t.validateParams=function(e){if(!e.config.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNChannelsForGroupOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=t.channelGroup,r=e.config;return"/v1/channel-registration/sub-key/".concat(r.subscribeKey,"/channel-group/").concat(o.default.encodeString(n))},t.handleResponse=function(e,t){return{channels:t.payload.channels}},t.isAuthSupported=function(){return!0},t.prepareParams=function(){return{}},t.validateParams=function(e,t){var n=t.channelGroup,r=e.config;if(!n)return"Missing Channel Group";if(!r.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNPushNotificationEnabledChannelsOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=t.device,r=t.pushGateway,i=e.config;if("apns2"===r)return"/v2/push/sub-key/".concat(i.subscribeKey,"/devices-apns2/").concat(n);return"/v1/push/sub-key/".concat(i.subscribeKey,"/devices/").concat(n)},t.handleResponse=function(){return{}},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.pushGateway,r=t.channels,i=void 0===r?[]:r,o=t.environment,a=void 0===o?"development":o,u=t.topic,s={type:n,add:i.join(",")};"apns2"===n&&delete(s=Object.assign({},s,{environment:a,topic:u})).type;return s},t.validateParams=function(e,t){var n=t.device,r=t.pushGateway,i=t.channels,o=t.topic,a=e.config;if(!n)return"Missing Device ID (device)";if(!r)return"Missing GW Type (pushGateway: gcm, apns or apns2)";if("apns2"===r&&!o)return"Missing APNS2 topic";if(!i||0===i.length)return"Missing Channels";if(!a.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNPushNotificationEnabledChannelsOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=t.device,r=t.pushGateway,i=e.config;if("apns2"===r)return"/v2/push/sub-key/".concat(i.subscribeKey,"/devices-apns2/").concat(n);return"/v1/push/sub-key/".concat(i.subscribeKey,"/devices/").concat(n)},t.handleResponse=function(){return{}},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.pushGateway,r=t.channels,i=void 0===r?[]:r,o=t.environment,a=void 0===o?"development":o,u=t.topic,s={type:n,remove:i.join(",")};"apns2"===n&&delete(s=Object.assign({},s,{environment:a,topic:u})).type;return s},t.validateParams=function(e,t){var n=t.device,r=t.pushGateway,i=t.channels,o=t.topic,a=e.config;if(!n)return"Missing Device ID (device)";if(!r)return"Missing GW Type (pushGateway: gcm, apns or apns2)";if("apns2"===r&&!o)return"Missing APNS2 topic";if(!i||0===i.length)return"Missing Channels";if(!a.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNPushNotificationEnabledChannelsOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=t.device,r=t.pushGateway,i=e.config;if("apns2"===r)return"/v2/push/sub-key/".concat(i.subscribeKey,"/devices-apns2/").concat(n);return"/v1/push/sub-key/".concat(i.subscribeKey,"/devices/").concat(n)},t.handleResponse=function(e,t){return{channels:t}},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.pushGateway,r=t.environment,i=void 0===r?"development":r,o=t.topic,a={type:n};"apns2"===n&&delete(a=Object.assign({},a,{environment:i,topic:o})).type;return a},t.validateParams=function(e,t){var n=t.device,r=t.pushGateway,i=t.topic,o=e.config;if(!n)return"Missing Device ID (device)";if(!r)return"Missing GW Type (pushGateway: gcm, apns or apns2)";if("apns2"===r&&!i)return"Missing APNS2 topic";if(!o.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNRemoveAllPushNotificationsOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=t.device,r=t.pushGateway,i=e.config;if("apns2"===r)return"/v2/push/sub-key/".concat(i.subscribeKey,"/devices-apns2/").concat(n,"/remove");return"/v1/push/sub-key/".concat(i.subscribeKey,"/devices/").concat(n,"/remove")},t.handleResponse=function(){return{}},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.pushGateway,r=t.environment,i=void 0===r?"development":r,o=t.topic,a={type:n};"apns2"===n&&delete(a=Object.assign({},a,{environment:i,topic:o})).type;return a},t.validateParams=function(e,t){var n=t.device,r=t.pushGateway,i=t.topic,o=e.config;if(!n)return"Missing Device ID (device)";if(!r)return"Missing GW Type (pushGateway: gcm, apns or apns2)";if("apns2"===r&&!i)return"Missing APNS2 topic";if(!o.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNUnsubscribeOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config,r=t.channels,i=void 0===r?[]:r,a=i.length>0?i.join(","):",";return"/v2/presence/sub-key/".concat(n.subscribeKey,"/channel/").concat(o.default.encodeString(a),"/leave")},t.handleResponse=function(){return{}},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.channelGroups,r=void 0===n?[]:n,i={};r.length>0&&(i["channel-group"]=r.join(","));return i},t.validateParams=function(e){if(!e.config.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNWhereNowOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config,r=t.uuid,i=void 0===r?n.UUID:r;return"/v2/presence/sub-key/".concat(n.subscribeKey,"/uuid/").concat(o.default.encodeString(i))},t.handleResponse=function(e,t){if(!t.payload)return{channels:[]};return{channels:t.payload.channels}},t.isAuthSupported=function(){return!0},t.prepareParams=function(){return{}},t.validateParams=function(e){if(!e.config.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNHeartbeatOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config,r=t.channels,i=void 0===r?[]:r,a=i.length>0?i.join(","):",";return"/v2/presence/sub-key/".concat(n.subscribeKey,"/channel/").concat(o.default.encodeString(a),"/heartbeat")},t.handleResponse=function(){return{}},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.channelGroups,r=void 0===n?[]:n,i=t.state,o=void 0===i?{}:i,a=e.config,u={};r.length>0&&(u["channel-group"]=r.join(","));return u.state=JSON.stringify(o),u.heartbeat=a.getPresenceTimeout(),u},t.validateParams=function(e){if(!e.config.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNGetStateOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config,r=t.uuid,i=void 0===r?n.UUID:r,a=t.channels,u=void 0===a?[]:a,s=u.length>0?u.join(","):",";return"/v2/presence/sub-key/".concat(n.subscribeKey,"/channel/").concat(o.default.encodeString(s),"/uuid/").concat(i)},t.handleResponse=function(e,t,n){var r=n.channels,i=void 0===r?[]:r,o=n.channelGroups,a=void 0===o?[]:o,u={};1===i.length&&0===a.length?u[i[0]]=t.payload:u=t.payload;return{channels:u}},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.channelGroups,r=void 0===n?[]:n,i={};r.length>0&&(i["channel-group"]=r.join(","));return i},t.validateParams=function(e){if(!e.config.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNSetStateOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config,r=t.channels,i=void 0===r?[]:r,a=i.length>0?i.join(","):",";return"/v2/presence/sub-key/".concat(n.subscribeKey,"/channel/").concat(o.default.encodeString(a),"/uuid/").concat(o.default.encodeString(n.UUID),"/data")},t.handleResponse=function(e,t){return{state:t.payload}},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.state,r=t.channelGroups,i=void 0===r?[]:r,o={};o.state=JSON.stringify(n),i.length>0&&(o["channel-group"]=i.join(","));return o},t.validateParams=function(e,t){var n=e.config,r=t.state,i=t.channels,o=void 0===i?[]:i,a=t.channelGroups,u=void 0===a?[]:a;if(!r)return"Missing State";if(!n.subscribeKey)return"Missing Subscribe Key";if(0===o.length&&0===u.length)return"Please provide a list of channels and/or channel-groups"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return o.default.PNHereNowOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config,r=t.channels,i=void 0===r?[]:r,o=t.channelGroups,u=void 0===o?[]:o,s="/v2/presence/sub-key/".concat(n.subscribeKey);if(i.length>0||u.length>0){var c=i.length>0?i.join(","):",";s+="/channel/".concat(a.default.encodeString(c))}return s},t.handleError=function(e,t,n){402!==n.statusCode||this.getURL(e,t).includes("channel")||(n.errorData.message="You have tried to perform a Global Here Now operation, your keyset configuration does not support that. Please provide a channel, or enable the Global Here Now feature from the Portal.")},t.handleResponse=function(e,t,n){var r,i=n.channels,o=void 0===i?[]:i,a=n.channelGroups,u=void 0===a?[]:a,s=n.includeUUIDs,c=void 0===s||s,l=n.includeState,f=void 0!==l&&l;r=o.length>1||u.length>0||0===u.length&&0===o.length?function(){var e={};return e.totalChannels=t.payload.total_channels,e.totalOccupancy=t.payload.total_occupancy,e.channels={},Object.keys(t.payload.channels).forEach((function(n){var r=t.payload.channels[n],i=[];return e.channels[n]={occupants:i,name:n,occupancy:r.occupancy},c&&r.uuids.forEach((function(e){f?i.push({state:e.state,uuid:e.uuid}):i.push({state:null,uuid:e})})),e})),e}():function(){var e={},n=[];return e.totalChannels=1,e.totalOccupancy=t.occupancy,e.channels={},e.channels[o[0]]={occupants:n,name:o[0],occupancy:t.occupancy},c&&t.uuids&&t.uuids.forEach((function(e){f?n.push({state:e.state,uuid:e.uuid}):n.push({state:null,uuid:e})})),e}();return r},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.channelGroups,r=void 0===n?[]:n,i=t.includeUUIDs,o=void 0===i||i,a=t.includeState,u=void 0!==a&&a,c=t.queryParameters,l=void 0===c?{}:c,f={};o||(f.disable_uuids=1);u&&(f.state=1);r.length>0&&(f["channel-group"]=r.join(","));return f=s(s({},f),l)},t.validateParams=function(e){if(!e.config.subscribeKey)return"Missing Subscribe Key"};var i=r(n(4)),o=(n(2),r(n(1))),a=r(n(3));function u(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function s(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?u(Object(n),!0).forEach((function(t){(0,i.default)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):u(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNAddMessageActionOperation},t.getRequestHeaders=function(){return{"Content-Type":"application/json"}},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.handleResponse=function(e,t){return{data:t.data}},t.isAuthSupported=function(){return!0},t.postPayload=function(e,t){return t.action},t.postURL=function(e,t){var n=e.config,r=t.channel,i=t.messageTimetoken;return"/v1/message-actions/".concat(n.subscribeKey,"/channel/").concat(o.default.encodeString(r),"/message/").concat(i)},t.prepareParams=function(){return{}},t.usePost=function(){return!0},t.validateParams=function(e,t){var n=e.config,r=t.action,i=t.channel;if(!t.messageTimetoken)return"Missing message timetoken";if(!n.subscribeKey)return"Missing Subscribe Key";if(!i)return"Missing message channel";if(!r)return"Missing Action";if(!r.value)return"Missing Action.value";if(!r.type)return"Missing Action.type";if(r.type.length>15)return"Action.type value exceed maximum length of 15"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNRemoveMessageActionOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config,r=t.channel,i=t.actionTimetoken,a=t.messageTimetoken;return"/v1/message-actions/".concat(n.subscribeKey,"/channel/").concat(o.default.encodeString(r),"/message/").concat(a,"/action/").concat(i)},t.handleResponse=function(e,t){return{data:t.data}},t.isAuthSupported=function(){return!0},t.prepareParams=function(){return{}},t.useDelete=function(){return!0},t.validateParams=function(e,t){var n=e.config,r=t.channel,i=t.actionTimetoken;if(!t.messageTimetoken)return"Missing message timetoken";if(!i)return"Missing action timetoken";if(!n.subscribeKey)return"Missing Subscribe Key";if(!r)return"Missing message channel"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNGetMessageActionsOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config,r=t.channel;return"/v1/message-actions/".concat(n.subscribeKey,"/channel/").concat(o.default.encodeString(r))},t.handleResponse=function(e,t){var n={data:t.data,start:null,end:null};n.data.length&&(n.end=n.data[n.data.length-1].actionTimetoken,n.start=n.data[0].actionTimetoken);return n},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.limit,r=t.start,i=t.end,o={};n&&(o.limit=n);r&&(o.start=r);i&&(o.end=i);return o},t.validateParams=function(e,t){var n=e.config,r=t.channel;if(!n.subscribeKey)return"Missing Subscribe Key";if(!r)return"Missing message channel"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(1)),o=r(n(3)),a={getOperation:function(){return i.default.PNListFilesOperation},validateParams:function(e,t){if(null==t||!t.channel)return"channel can't be empty"},getURL:function(e,t){var n=e.config;return"/v1/files/".concat(n.subscribeKey,"/channels/").concat(o.default.encodeString(t.channel),"/files")},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(e,t){var n={};return t.limit&&(n.limit=t.limit),t.next&&(n.next=t.next),n},handleResponse:function(e,t){return{status:t.status,data:t.data,next:t.next,count:t.count}}};t.default=a,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(1)),o=r(n(3)),a={getOperation:function(){return i.default.PNGenerateUploadUrlOperation},validateParams:function(e,t){return null!=t&&t.channel?null!=t&&t.name?void 0:"name can't be empty":"channel can't be empty"},usePost:function(){return!0},postURL:function(e,t){var n=e.config;return"/v1/files/".concat(n.subscribeKey,"/channels/").concat(o.default.encodeString(t.channel),"/generate-upload-url")},postPayload:function(e,t){return{name:t.name}},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(){return{}},handleResponse:function(e,t){return{status:t.status,data:t.data,file_upload_request:t.file_upload_request}}};t.default=a,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(7)),o=r(n(1)),a=r(n(3)),u={getOperation:function(){return o.default.PNPublishFileOperation},validateParams:function(e,t){return null!=t&&t.channel?null!=t&&t.fileId?null!=t&&t.fileName?void 0:"file name can't be empty":"file id can't be empty":"channel can't be empty"},getURL:function(e,t){var n=e.config,r=n.publishKey,i=n.subscribeKey,o=function(e,t){var n=e.crypto,r=e.config,i=JSON.stringify(t);return r.cipherKey&&(i=n.encrypt(i),i=JSON.stringify(i)),i||""}(e,{message:t.message,file:{name:t.fileName,id:t.fileId}});return"/v1/files/publish-file/".concat(r,"/").concat(i,"/0/").concat(a.default.encodeString(t.channel),"/0/").concat(a.default.encodeString(o))},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(e,t){var n={};return t.ttl&&(n.ttl=t.ttl),void 0!==t.storeInHistory&&(n.store=t.storeInHistory?"1":"0"),t.meta&&"object"===(0,i.default)(t.meta)&&(n.meta=JSON.stringify(t.meta)),n},handleResponse:function(e,t){return{timetoken:t[2]}}};t.default=u,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(11)),o=r(n(12)),a=n(18),u=function(e){return new Promise((function(t){var n="";e.on("data",(function(e){n+=e.toString("utf8")})),e.on("end",(function(){t(n)}))}))};t.default=function(e){var t,n,r,s,c,l,f,d,p,h=(r=(t=e).generateUploadUrl,s=t.publishFile,c=t.modules,l=c.PubNubFile,f=c.config,d=c.cryptography,p=c.networking,n=(0,o.default)(i.default.mark((function e(t){var n,o,c,h,y,g,v,b,m,_,P,O,S,w,k,T,x,A,M,E,j,R;return i.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=t.channel,o=t.file,c=t.message,h=t.cipherKey,y=t.meta,g=t.ttl,v=t.storeInHistory,n){e.next=3;break}throw new a.PubNubError("Validation failed, check status for details",(0,a.createValidationError)("channel can't be empty"));case 3:if(o){e.next=5;break}throw new a.PubNubError("Validation failed, check status for details",(0,a.createValidationError)("file can't be empty"));case 5:return b=l.create(o),e.next=8,r({channel:n,name:b.name});case 8:if(m=e.sent,_=m.file_upload_request,P=_.url,O=_.form_fields,S=m.data,w=S.id,k=S.name,!l.supportsEncryptFile||!(null!=h?h:f.cipherKey)){e.next=19;break}return e.next=18,d.encryptFile(null!=h?h:f.cipherKey,b,l);case 18:b=e.sent;case 19:if(T=O,b.mimeType&&(T=O.map((function(e){return"Content-Type"===e.key?{key:e.key,value:b.mimeType}:e}))),e.prev=21,!l.supportsFileUri||!o.uri){e.next=34;break}return e.t0=p,e.t1=P,e.t2=T,e.next=28,b.toFileUri();case 28:return e.t3=e.sent,e.next=31,e.t0.POSTFILE.call(e.t0,e.t1,e.t2,e.t3);case 31:x=e.sent,e.next=71;break;case 34:if(!l.supportsFile){e.next=46;break}return e.t4=p,e.t5=P,e.t6=T,e.next=40,b.toFile();case 40:return e.t7=e.sent,e.next=43,e.t4.POSTFILE.call(e.t4,e.t5,e.t6,e.t7);case 43:x=e.sent,e.next=71;break;case 46:if(!l.supportsBuffer){e.next=58;break}return e.t8=p,e.t9=P,e.t10=T,e.next=52,b.toBuffer();case 52:return e.t11=e.sent,e.next=55,e.t8.POSTFILE.call(e.t8,e.t9,e.t10,e.t11);case 55:x=e.sent,e.next=71;break;case 58:if(!l.supportsBlob){e.next=70;break}return e.t12=p,e.t13=P,e.t14=T,e.next=64,b.toBlob();case 64:return e.t15=e.sent,e.next=67,e.t12.POSTFILE.call(e.t12,e.t13,e.t14,e.t15);case 67:x=e.sent,e.next=71;break;case 70:throw new Error("Unsupported environment");case 71:e.next=80;break;case 73:return e.prev=73,e.t16=e.catch(21),e.next=77,u(e.t16.response);case 77:throw A=e.sent,M=/<Message>(.*)<\/Message>/gi.exec(A),new a.PubNubError(M?"Upload to bucket failed: ".concat(M[1]):"Upload to bucket failed.",e.t16);case 80:if(204===x.status){e.next=82;break}throw new a.PubNubError("Upload to bucket was unsuccessful",x);case 82:E=f.fileUploadPublishRetryLimit,j=!1,R={timetoken:"0"};case 85:return e.prev=85,e.next=88,s({channel:n,message:c,fileId:w,fileName:k,meta:y,storeInHistory:v,ttl:g});case 88:R=e.sent,j=!0,e.next=95;break;case 92:e.prev=92,e.t17=e.catch(85),E-=1;case 95:if(!j&&E>0){e.next=85;break}case 96:if(j){e.next=100;break}throw new a.PubNubError("Publish failed. You may want to execute that operation manually using pubnub.publishFile",{channel:n,id:w,name:k});case 100:return e.abrupt("return",{timetoken:R.timetoken,id:w,name:k});case 101:case"end":return e.stop()}}),e,null,[[21,73],[85,92]])}))),function(e){return n.apply(this,arguments)});return function(e,t){var n=h(e);return"function"==typeof t?(n.then((function(e){return t(null,e)})).catch((function(e){return t(e,null)})),n):n}},e.exports=t.default},function(e,t,n){var r=function(e){"use strict";var t=Object.prototype,n=t.hasOwnProperty,r="function"==typeof Symbol?Symbol:{},i=r.iterator||"@@iterator",o=r.asyncIterator||"@@asyncIterator",a=r.toStringTag||"@@toStringTag";function u(e,t,n){return Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}),e[t]}try{u({},"")}catch(e){u=function(e,t,n){return e[t]=n}}function s(e,t,n,r){var i=t&&t.prototype instanceof f?t:f,o=Object.create(i.prototype),a=new S(r||[]);return o._invoke=function(e,t,n){var r="suspendedStart";return function(i,o){if("executing"===r)throw new Error("Generator is already running");if("completed"===r){if("throw"===i)throw o;return k()}for(n.method=i,n.arg=o;;){var a=n.delegate;if(a){var u=_(a,n);if(u){if(u===l)continue;return u}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if("suspendedStart"===r)throw r="completed",n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);r="executing";var s=c(e,t,n);if("normal"===s.type){if(r=n.done?"completed":"suspendedYield",s.arg===l)continue;return{value:s.arg,done:n.done}}"throw"===s.type&&(r="completed",n.method="throw",n.arg=s.arg)}}}(e,n,a),o}function c(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}e.wrap=s;var l={};function f(){}function d(){}function p(){}var h={};u(h,i,(function(){return this}));var y=Object.getPrototypeOf,g=y&&y(y(w([])));g&&g!==t&&n.call(g,i)&&(h=g);var v=p.prototype=f.prototype=Object.create(h);function b(e){["next","throw","return"].forEach((function(t){u(e,t,(function(e){return this._invoke(t,e)}))}))}function m(e,t){var r;this._invoke=function(i,o){function a(){return new t((function(r,a){!function r(i,o,a,u){var s=c(e[i],e,o);if("throw"!==s.type){var l=s.arg,f=l.value;return f&&"object"==typeof f&&n.call(f,"__await")?t.resolve(f.__await).then((function(e){r("next",e,a,u)}),(function(e){r("throw",e,a,u)})):t.resolve(f).then((function(e){l.value=e,a(l)}),(function(e){return r("throw",e,a,u)}))}u(s.arg)}(i,o,r,a)}))}return r=r?r.then(a,a):a()}}function _(e,t){var n=e.iterator[t.method];if(void 0===n){if(t.delegate=null,"throw"===t.method){if(e.iterator.return&&(t.method="return",t.arg=void 0,_(e,t),"throw"===t.method))return l;t.method="throw",t.arg=new TypeError("The iterator does not provide a 'throw' method")}return l}var r=c(n,e.iterator,t.arg);if("throw"===r.type)return t.method="throw",t.arg=r.arg,t.delegate=null,l;var i=r.arg;return i?i.done?(t[e.resultName]=i.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=void 0),t.delegate=null,l):i:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,l)}function P(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function O(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function S(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(P,this),this.reset(!0)}function w(e){if(e){var t=e[i];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var r=-1,o=function t(){for(;++r<e.length;)if(n.call(e,r))return t.value=e[r],t.done=!1,t;return t.value=void 0,t.done=!0,t};return o.next=o}}return{next:k}}function k(){return{value:void 0,done:!0}}return d.prototype=p,u(v,"constructor",p),u(p,"constructor",d),d.displayName=u(p,a,"GeneratorFunction"),e.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===d||"GeneratorFunction"===(t.displayName||t.name))},e.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,p):(e.__proto__=p,u(e,a,"GeneratorFunction")),e.prototype=Object.create(v),e},e.awrap=function(e){return{__await:e}},b(m.prototype),u(m.prototype,o,(function(){return this})),e.AsyncIterator=m,e.async=function(t,n,r,i,o){void 0===o&&(o=Promise);var a=new m(s(t,n,r,i),o);return e.isGeneratorFunction(n)?a:a.next().then((function(e){return e.done?e.value:a.next()}))},b(v),u(v,a,"Generator"),u(v,i,(function(){return this})),u(v,"toString",(function(){return"[object Generator]"})),e.keys=function(e){var t=[];for(var n in e)t.push(n);return t.reverse(),function n(){for(;t.length;){var r=t.pop();if(r in e)return n.value=r,n.done=!1,n}return n.done=!0,n}},e.values=w,S.prototype={constructor:S,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(O),!e)for(var t in this)"t"===t.charAt(0)&&n.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=void 0)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var t=this;function r(n,r){return a.type="throw",a.arg=e,t.next=n,r&&(t.method="next",t.arg=void 0),!!r}for(var i=this.tryEntries.length-1;i>=0;--i){var o=this.tryEntries[i],a=o.completion;if("root"===o.tryLoc)return r("end");if(o.tryLoc<=this.prev){var u=n.call(o,"catchLoc"),s=n.call(o,"finallyLoc");if(u&&s){if(this.prev<o.catchLoc)return r(o.catchLoc,!0);if(this.prev<o.finallyLoc)return r(o.finallyLoc)}else if(u){if(this.prev<o.catchLoc)return r(o.catchLoc,!0)}else{if(!s)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return r(o.finallyLoc)}}}},abrupt:function(e,t){for(var r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r];if(i.tryLoc<=this.prev&&n.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var o=i;break}}o&&("break"===e||"continue"===e)&&o.tryLoc<=t&&t<=o.finallyLoc&&(o=null);var a=o?o.completion:{};return a.type=e,a.arg=t,o?(this.method="next",this.next=o.finallyLoc,l):this.complete(a)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),l},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),O(n),l}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r=n.completion;if("throw"===r.type){var i=r.arg;O(n)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,n){return this.delegate={iterator:w(e),resultName:t,nextLoc:n},"next"===this.method&&(this.arg=void 0),l}},e}(e.exports);try{regeneratorRuntime=r}catch(e){"object"==typeof globalThis?globalThis.regeneratorRuntime=r:Function("r","regeneratorRuntime = r")(r)}},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=n(18),o=r(n(3));t.default=function(e,t){var n=t.channel,r=t.id,a=t.name,u=e.config,s=e.networking;if(!n)throw new i.PubNubError("Validation failed, check status for details",(0,i.createValidationError)("channel can't be empty"));if(!r)throw new i.PubNubError("Validation failed, check status for details",(0,i.createValidationError)("file id can't be empty"));if(!a)throw new i.PubNubError("Validation failed, check status for details",(0,i.createValidationError)("file name can't be empty"));var c="/v1/files/".concat(u.subscribeKey,"/channels/").concat(o.default.encodeString(n),"/files/").concat(r,"/").concat(a),l={};l.uuid=u.getUUID(),l.pnsdk=(0,i.generatePNSDK)(u),u.getAuthKey()&&(l.auth=u.getAuthKey()),u.secretKey&&(0,i.signRequest)(e,c,l,{},{getOperation:function(){return"PubNubGetFileUrlOperation"}});var f=Object.keys(l).map((function(e){return"".concat(encodeURIComponent(e),"=").concat(encodeURIComponent(l[e]))})).join("&");return""!==f?"".concat(s.getStandardOrigin()).concat(c,"?").concat(f):"".concat(s.getStandardOrigin()).concat(c)},e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i,o=r(n(11)),a=r(n(12)),u=r(n(1)),s=r(n(3)),c={getOperation:function(){return u.default.PNDownloadFileOperation},validateParams:function(e,t){return null!=t&&t.channel?null!=t&&t.name?null!=t&&t.id?void 0:"id can't be empty":"name can't be empty":"channel can't be empty"},useGetFile:function(){return!0},getFileURL:function(e,t){var n=e.config;return"/v1/files/".concat(n.subscribeKey,"/channels/").concat(s.default.encodeString(t.channel),"/files/").concat(t.id,"/").concat(t.name)},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},ignoreBody:function(){return!0},forceBuffered:function(){return!0},prepareParams:function(){return{}},handleResponse:(i=(0,a.default)(o.default.mark((function e(t,n,r){var i,a,u,s,c,l,f;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(u=t.PubNubFile,s=t.config,c=t.cryptography,l=n.response.body,!u.supportsEncryptFile||!(null!==(i=r.cipherKey)&&void 0!==i?i:s.cipherKey)){e.next=6;break}return e.next=5,c.decrypt(null!==(f=r.cipherKey)&&void 0!==f?f:s.cipherKey,l);case 5:l=e.sent;case 6:return e.abrupt("return",u.create({data:l,name:null!==(a=n.response.name)&&void 0!==a?a:r.name,mimeType:n.response.type}));case 7:case"end":return e.stop()}}),e)}))),function(e,t,n){return i.apply(this,arguments)})};t.default=c,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(1)),o=r(n(3)),a={getOperation:function(){return i.default.PNListFilesOperation},validateParams:function(e,t){return null!=t&&t.channel?null!=t&&t.id?null!=t&&t.name?void 0:"file name can't be empty":"file id can't be empty":"channel can't be empty"},useDelete:function(){return!0},getURL:function(e,t){var n=e.config;return"/v1/files/".concat(n.subscribeKey,"/channels/").concat(o.default.encodeString(t.channel),"/files/").concat(t.id,"/").concat(t.name)},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(){return{}},handleResponse:function(e,t){return{status:t.status}}};t.default=a,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(9)),o=r(n(1)),a={getOperation:function(){return o.default.PNGetAllUUIDMetadataOperation},validateParams:function(){},getURL:function(e){var t=e.config;return"/v2/objects/".concat(t.subscribeKey,"/uuids")},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(e,t){var n,r,o,a,u,s,c,l,f,d={};(null!=t&&null!==(n=t.include)&&void 0!==n&&n.customFields&&(d.include="custom"),null!=t&&null!==(r=t.include)&&void 0!==r&&r.totalCount)&&(d.count=null===(s=t.include)||void 0===s?void 0:s.totalCount);null!=t&&null!==(o=t.page)&&void 0!==o&&o.next&&(d.start=null===(c=t.page)||void 0===c?void 0:c.next);null!=t&&null!==(a=t.page)&&void 0!==a&&a.prev&&(d.end=null===(l=t.page)||void 0===l?void 0:l.prev);(null!=t&&t.filter&&(d.filter=t.filter),d.limit=null!==(u=null==t?void 0:t.limit)&&void 0!==u?u:100,null!=t&&t.sort)&&(d.sort=Object.entries(null!==(f=t.sort)&&void 0!==f?f:{}).map((function(e){var t=(0,i.default)(e,2),n=t[0],r=t[1];return"asc"===r||"desc"===r?"".concat(n,":").concat(r):n})));return d},handleResponse:function(e,t){return{status:t.status,data:t.data,totalCount:t.totalCount,next:t.next,prev:t.prev}}};t.default=a,e.exports=t.default},function(e,t){e.exports=function(e){if(Array.isArray(e))return e},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t){e.exports=function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=n){var r,i,o=[],a=!0,u=!1;try{for(n=n.call(e);!(a=(r=n.next()).done)&&(o.push(r.value),!t||o.length!==t);a=!0);}catch(e){u=!0,i=e}finally{try{a||null==n.return||n.return()}finally{if(u)throw i}}return o}},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t,n){var r=n(83);e.exports=function(e,t){if(e){if("string"==typeof e)return r(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?r(e,t):void 0}},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t){e.exports=function(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t){e.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},e.exports.default=e.exports,e.exports.__esModule=!0},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(1)),o=r(n(3)),a={getOperation:function(){return i.default.PNGetUUIDMetadataOperation},validateParams:function(){},getURL:function(e,t){var n,r=e.config;return"/v2/objects/".concat(r.subscribeKey,"/uuids/").concat(o.default.encodeString(null!==(n=null==t?void 0:t.uuid)&&void 0!==n?n:r.getUUID()))},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(e,t){var n,r,i,o=e.config;return{uuid:null!==(n=null==t?void 0:t.uuid)&&void 0!==n?n:o.getUUID(),include:(null===(r=null==t||null===(i=t.include)||void 0===i?void 0:i.customFields)||void 0===r||r)&&"custom"}},handleResponse:function(e,t){return{status:t.status,data:t.data}}};t.default=a,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(1)),o=r(n(3)),a={getOperation:function(){return i.default.PNSetUUIDMetadataOperation},validateParams:function(e,t){if(null==t||!t.data)return"Data cannot be empty"},usePatch:function(){return!0},patchURL:function(e,t){var n,r=e.config;return"/v2/objects/".concat(r.subscribeKey,"/uuids/").concat(o.default.encodeString(null!==(n=t.uuid)&&void 0!==n?n:r.getUUID()))},patchPayload:function(e,t){return t.data},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(e,t){var n,r,i,o=e.config;return{uuid:null!==(n=null==t?void 0:t.uuid)&&void 0!==n?n:o.getUUID(),include:(null===(r=null==t||null===(i=t.include)||void 0===i?void 0:i.customFields)||void 0===r||r)&&"custom"}},handleResponse:function(e,t){return{status:t.status,data:t.data}}};t.default=a,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(1)),o=r(n(3)),a={getOperation:function(){return i.default.PNRemoveUUIDMetadataOperation},validateParams:function(){},getURL:function(e,t){var n,r=e.config;return"/v2/objects/".concat(r.subscribeKey,"/uuids/").concat(o.default.encodeString(null!==(n=null==t?void 0:t.uuid)&&void 0!==n?n:r.getUUID()))},useDelete:function(){return!0},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(e,t){var n,r=e.config;return{uuid:null!==(n=null==t?void 0:t.uuid)&&void 0!==n?n:r.getUUID()}},handleResponse:function(e,t){return{status:t.status,data:t.data}}};t.default=a,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(9)),o=r(n(1)),a={getOperation:function(){return o.default.PNGetAllChannelMetadataOperation},validateParams:function(){},getURL:function(e){var t=e.config;return"/v2/objects/".concat(t.subscribeKey,"/channels")},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(e,t){var n,r,o,a,u,s,c,l,f,d={};(null!=t&&null!==(n=t.include)&&void 0!==n&&n.customFields&&(d.include="custom"),null!=t&&null!==(r=t.include)&&void 0!==r&&r.totalCount)&&(d.count=null===(s=t.include)||void 0===s?void 0:s.totalCount);null!=t&&null!==(o=t.page)&&void 0!==o&&o.next&&(d.start=null===(c=t.page)||void 0===c?void 0:c.next);null!=t&&null!==(a=t.page)&&void 0!==a&&a.prev&&(d.end=null===(l=t.page)||void 0===l?void 0:l.prev);(null!=t&&t.filter&&(d.filter=t.filter),d.limit=null!==(u=null==t?void 0:t.limit)&&void 0!==u?u:100,null!=t&&t.sort)&&(d.sort=Object.entries(null!==(f=t.sort)&&void 0!==f?f:{}).map((function(e){var t=(0,i.default)(e,2),n=t[0],r=t[1];return"asc"===r||"desc"===r?"".concat(n,":").concat(r):n})));return d},handleResponse:function(e,t){return{status:t.status,data:t.data,totalCount:t.totalCount,prev:t.prev,next:t.next}}};t.default=a,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(1)),o=r(n(3)),a={getOperation:function(){return i.default.PNGetChannelMetadataOperation},validateParams:function(e,t){if(null==t||!t.channel)return"Channel cannot be empty"},getURL:function(e,t){var n=e.config;return"/v2/objects/".concat(n.subscribeKey,"/channels/").concat(o.default.encodeString(t.channel))},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(e,t){var n,r;return{include:(null===(n=null==t||null===(r=t.include)||void 0===r?void 0:r.customFields)||void 0===n||n)&&"custom"}},handleResponse:function(e,t){return{status:t.status,data:t.data}}};t.default=a,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(1)),o=r(n(3)),a={getOperation:function(){return i.default.PNSetChannelMetadataOperation},validateParams:function(e,t){return null!=t&&t.channel?null!=t&&t.data?void 0:"Data cannot be empty":"Channel cannot be empty"},usePatch:function(){return!0},patchURL:function(e,t){var n=e.config;return"/v2/objects/".concat(n.subscribeKey,"/channels/").concat(o.default.encodeString(t.channel))},patchPayload:function(e,t){return t.data},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(e,t){var n,r;return{include:(null===(n=null==t||null===(r=t.include)||void 0===r?void 0:r.customFields)||void 0===n||n)&&"custom"}},handleResponse:function(e,t){return{status:t.status,data:t.data}}};t.default=a,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(1)),o=r(n(3)),a={getOperation:function(){return i.default.PNRemoveChannelMetadataOperation},validateParams:function(e,t){if(null==t||!t.channel)return"Channel cannot be empty"},getURL:function(e,t){var n=e.config;return"/v2/objects/".concat(n.subscribeKey,"/channels/").concat(o.default.encodeString(t.channel))},useDelete:function(){return!0},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(){return{}},handleResponse:function(e,t){return{status:t.status,data:t.data}}};t.default=a,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(9)),o=r(n(1)),a=r(n(3)),u={getOperation:function(){return o.default.PNGetMembersOperation},validateParams:function(e,t){if(null==t||!t.channel)return"UUID cannot be empty"},getURL:function(e,t){var n=e.config;return"/v2/objects/".concat(n.subscribeKey,"/channels/").concat(a.default.encodeString(t.channel),"/uuids")},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(e,t){var n,r,o,a,u,s,c,l,f,d,p,h,y={};null!=t&&t.include&&(y.include=[],null!==(u=t.include)&&void 0!==u&&u.customFields&&y.include.push("custom"),null!==(s=t.include)&&void 0!==s&&s.customUUIDFields&&y.include.push("uuid.custom"),(null===(c=null===(l=t.include)||void 0===l?void 0:l.UUIDFields)||void 0===c||c)&&y.include.push("uuid"),y.include=y.include.join(","));null!=t&&null!==(n=t.include)&&void 0!==n&&n.totalCount&&(y.count=null===(f=t.include)||void 0===f?void 0:f.totalCount);null!=t&&null!==(r=t.page)&&void 0!==r&&r.next&&(y.start=null===(d=t.page)||void 0===d?void 0:d.next);null!=t&&null!==(o=t.page)&&void 0!==o&&o.prev&&(y.end=null===(p=t.page)||void 0===p?void 0:p.prev);(null!=t&&t.filter&&(y.filter=t.filter),y.limit=null!==(a=null==t?void 0:t.limit)&&void 0!==a?a:100,null!=t&&t.sort)&&(y.sort=Object.entries(null!==(h=t.sort)&&void 0!==h?h:{}).map((function(e){var t=(0,i.default)(e,2),n=t[0],r=t[1];return"asc"===r||"desc"===r?"".concat(n,":").concat(r):n})));return y},handleResponse:function(e,t){return{status:t.status,data:t.data,totalCount:t.totalCount,prev:t.prev,next:t.next}}};t.default=u,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(9)),o=r(n(4)),a=r(n(1)),u=r(n(3)),s={getOperation:function(){return a.default.PNSetMembersOperation},validateParams:function(e,t){return null!=t&&t.channel?null!=t&&t.uuids&&0!==(null==t?void 0:t.uuids.length)?void 0:"UUIDs cannot be empty":"Channel cannot be empty"},usePatch:function(){return!0},patchURL:function(e,t){var n=e.config;return"/v2/objects/".concat(n.subscribeKey,"/channels/").concat(u.default.encodeString(t.channel),"/uuids")},patchPayload:function(e,t){return(0,o.default)({set:[],remove:[]},t.type,t.uuids.map((function(e){return"string"==typeof e?{uuid:{id:e}}:{uuid:{id:e.id},custom:e.custom}})))},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(e,t){var n,r,o,a,u,s,c,l,f,d={};null!=t&&t.include&&(d.include=[],null!==(a=t.include)&&void 0!==a&&a.customFields&&d.include.push("custom"),null!==(u=t.include)&&void 0!==u&&u.customUUIDFields&&d.include.push("uuid.custom"),null!==(s=t.include)&&void 0!==s&&s.UUIDFields&&d.include.push("uuid"),d.include=d.include.join(","));(null!=t&&null!==(n=t.include)&&void 0!==n&&n.totalCount&&(d.count=!0),null!=t&&null!==(r=t.page)&&void 0!==r&&r.next)&&(d.start=null===(c=t.page)||void 0===c?void 0:c.next);null!=t&&null!==(o=t.page)&&void 0!==o&&o.prev&&(d.end=null===(l=t.page)||void 0===l?void 0:l.prev);(null!=t&&t.filter&&(d.filter=t.filter),null!=t&&t.limit&&(d.limit=t.limit),null!=t&&t.sort)&&(d.sort=Object.entries(null!==(f=t.sort)&&void 0!==f?f:{}).map((function(e){var t=(0,i.default)(e,2),n=t[0],r=t[1];return"asc"===r||"desc"===r?"".concat(n,":").concat(r):n})));return d},handleResponse:function(e,t){return{status:t.status,data:t.data,totalCount:t.totalCount,prev:t.prev,next:t.next}}};t.default=s,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(9)),o=r(n(1)),a=r(n(3)),u={getOperation:function(){return o.default.PNGetMembershipsOperation},validateParams:function(){},getURL:function(e,t){var n,r=e.config;return"/v2/objects/".concat(r.subscribeKey,"/uuids/").concat(a.default.encodeString(null!==(n=null==t?void 0:t.uuid)&&void 0!==n?n:r.getUUID()),"/channels")},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(e,t){var n,r,o,a,u,s,c,l,f,d,p,h={};null!=t&&t.include&&(h.include=[],null!==(u=t.include)&&void 0!==u&&u.customFields&&h.include.push("custom"),null!==(s=t.include)&&void 0!==s&&s.customChannelFields&&h.include.push("channel.custom"),null!==(c=t.include)&&void 0!==c&&c.channelFields&&h.include.push("channel"),h.include=h.include.join(","));null!=t&&null!==(n=t.include)&&void 0!==n&&n.totalCount&&(h.count=null===(l=t.include)||void 0===l?void 0:l.totalCount);null!=t&&null!==(r=t.page)&&void 0!==r&&r.next&&(h.start=null===(f=t.page)||void 0===f?void 0:f.next);null!=t&&null!==(o=t.page)&&void 0!==o&&o.prev&&(h.end=null===(d=t.page)||void 0===d?void 0:d.prev);(null!=t&&t.filter&&(h.filter=t.filter),h.limit=null!==(a=null==t?void 0:t.limit)&&void 0!==a?a:100,null!=t&&t.sort)&&(h.sort=Object.entries(null!==(p=t.sort)&&void 0!==p?p:{}).map((function(e){var t=(0,i.default)(e,2),n=t[0],r=t[1];return"asc"===r||"desc"===r?"".concat(n,":").concat(r):n})));return h},handleResponse:function(e,t){return{status:t.status,data:t.data,totalCount:t.totalCount,prev:t.prev,next:t.next}}};t.default=u,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(9)),o=r(n(4)),a=r(n(1)),u=r(n(3)),s={getOperation:function(){return a.default.PNSetMembershipsOperation},validateParams:function(e,t){if(null==t||!t.channels||0===(null==t?void 0:t.channels.length))return"Channels cannot be empty"},usePatch:function(){return!0},patchURL:function(e,t){var n,r=e.config;return"/v2/objects/".concat(r.subscribeKey,"/uuids/").concat(u.default.encodeString(null!==(n=t.uuid)&&void 0!==n?n:r.getUUID()),"/channels")},patchPayload:function(e,t){return(0,o.default)({set:[],remove:[]},t.type,t.channels.map((function(e){return"string"==typeof e?{channel:{id:e}}:{channel:{id:e.id},custom:e.custom}})))},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!0},prepareParams:function(e,t){var n,r,o,a,u,s,c,l,f,d={};null!=t&&t.include&&(d.include=[],null!==(a=t.include)&&void 0!==a&&a.customFields&&d.include.push("custom"),null!==(u=t.include)&&void 0!==u&&u.customChannelFields&&d.include.push("channel.custom"),null!==(s=t.include)&&void 0!==s&&s.channelFields&&d.include.push("channel"),d.include=d.include.join(","));(null!=t&&null!==(n=t.include)&&void 0!==n&&n.totalCount&&(d.count=!0),null!=t&&null!==(r=t.page)&&void 0!==r&&r.next)&&(d.start=null===(c=t.page)||void 0===c?void 0:c.next);null!=t&&null!==(o=t.page)&&void 0!==o&&o.prev&&(d.end=null===(l=t.page)||void 0===l?void 0:l.prev);(null!=t&&t.filter&&(d.filter=t.filter),null!=t&&t.limit&&(d.limit=t.limit),null!=t&&t.sort)&&(d.sort=Object.entries(null!==(f=t.sort)&&void 0!==f?f:{}).map((function(e){var t=(0,i.default)(e,2),n=t[0],r=t[1];return"asc"===r||"desc"===r?"".concat(n,":").concat(r):n})));return d},handleResponse:function(e,t){return{status:t.status,data:t.data,totalCount:t.totalCount,prev:t.prev,next:t.next}}};t.default=s,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNCreateUserOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e){var t=e.config;return"/v1/objects/".concat(t.subscribeKey,"/users")},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.postPayload=function(e,t){return function(e,t){return t}(0,t)},t.postURL=function(e){var t=e.config;return"/v1/objects/".concat(t.subscribeKey,"/users")},t.prepareParams=function(e,t){var n=t.include,r={};n?void 0===n.customFields&&(n.customFields=!0):n={customFields:!0};if(n){var i=[];n.customFields&&i.push("custom");var o=i.join(",");o.length>0&&(r.include=o)}return r},t.usePost=function(){return!0},t.validateParams=function(e,t){var n=e.config,r=t.id,i=t.name,o=t.custom;if(!r)return"Missing User.id";if(!i)return"Missing User.name";if(!n.subscribeKey)return"Missing Subscribe Key";if(o&&!Object.values(o).every((function(e){return"string"==typeof e||"number"==typeof e||"boolean"==typeof e})))return"Invalid custom type, only string, number and boolean values are allowed."};n(2);var i=r(n(1))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNUpdateUserOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config,r=t.id;return"/v1/objects/".concat(n.subscribeKey,"/users/").concat(o.default.encodeString(r))},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.patchPayload=function(e,t){return function(e,t){return t}(0,t)},t.patchURL=function(e,t){var n=e.config,r=t.id;return"/v1/objects/".concat(n.subscribeKey,"/users/").concat(o.default.encodeString(r))},t.prepareParams=function(e,t){var n=t.include,r={};n?void 0===n.customFields&&(n.customFields=!0):n={customFields:!0};if(n){var i=[];n.customFields&&i.push("custom");var o=i.join(",");o.length>0&&(r.include=o)}return r},t.usePatch=function(){return!0},t.validateParams=function(e,t){var n=e.config,r=t.id,i=t.name,o=t.custom;if(!r)return"Missing User.id";if(!i)return"Missing User.name";if(!n.subscribeKey)return"Missing Subscribe Key";if(o&&!Object.values(o).every((function(e){return"string"==typeof e||"number"==typeof e||"boolean"==typeof e})))return"Invalid custom type, only string, number and boolean values are allowed."};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNDeleteUserOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/users/").concat(o.default.encodeString(t))},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.prepareParams=function(){return{}},t.useDelete=function(){return!0},t.validateParams=function(e,t){var n=e.config;if(!t)return"Missing UserId";if(!n.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNGetUserOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/users/").concat(o.default.encodeString(t.userId))},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.include,r={};n?void 0===n.customFields&&(n.customFields=!0):n={customFields:!0};if(n){var i=[];n.customFields&&i.push("custom");var o=i.join(",");o.length>0&&(r.include=o)}return r},t.validateParams=function(e,t){if(!t.userId)return"Missing userId"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNGetUsersOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e){var t=e.config;return"/v1/objects/".concat(t.subscribeKey,"/users")},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.include,r=t.limit,i=t.page,o=t.filter,a={};r&&(a.limit=r);if(n){var u=[];n.totalCount&&(a.count=!0),n.customFields&&u.push("custom");var s=u.join(",");s.length>0&&(a.include=s)}i&&(i.next&&(a.start=i.next),i.prev&&(a.end=i.prev));o&&(a.filter=o);return a},t.validateParams=function(){};n(2);var i=r(n(1))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNCreateSpaceOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e){var t=e.config;return"/v1/objects/".concat(t.subscribeKey,"/spaces")},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.postPayload=function(e,t){return function(e,t){return t}(0,t)},t.postURL=function(e){var t=e.config;return"/v1/objects/".concat(t.subscribeKey,"/spaces")},t.prepareParams=function(e,t){var n=t.include,r={};n?void 0===n.customFields&&(n.customFields=!0):n={customFields:!0};if(n){var i=[];n.customFields&&i.push("custom");var o=i.join(",");o.length>0&&(r.include=o)}return r},t.usePost=function(){return!0},t.validateParams=function(e,t){var n=e.config,r=t.id,i=t.name,o=t.custom;if(!r)return"Missing Space.id";if(!i)return"Missing Space.name";if(!n.subscribeKey)return"Missing Subscribe Key";if(o&&!Object.values(o).every((function(e){return"string"==typeof e||"number"==typeof e||"boolean"==typeof e})))return"Invalid custom type, only string, number and boolean values are allowed."};n(2);var i=r(n(1))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNUpdateSpaceOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config,r=t.id;return"/v1/objects/".concat(n.subscribeKey,"/spaces/").concat(o.default.encodeString(r))},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.patchPayload=function(e,t){return function(e,t){return t}(0,t)},t.patchURL=function(e,t){var n=e.config,r=t.id;return"/v1/objects/".concat(n.subscribeKey,"/spaces/").concat(o.default.encodeString(r))},t.prepareParams=function(e,t){var n=t.include,r={};n?void 0===n.customFields&&(n.customFields=!0):n={customFields:!0};if(n){var i=[];n.customFields&&i.push("custom");var o=i.join(",");o.length>0&&(r.include=o)}return r},t.usePatch=function(){return!0},t.validateParams=function(e,t){var n=e.config,r=t.id,i=t.name,o=t.custom;if(!r)return"Missing Space.id";if(!i)return"Missing Space.name";if(!n.subscribeKey)return"Missing Subscribe Key";if(o&&!Object.values(o).every((function(e){return"string"==typeof e||"number"==typeof e||"boolean"==typeof e})))return"Invalid custom type, only string, number and boolean values are allowed."};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNDeleteSpaceOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/spaces/").concat(o.default.encodeString(t))},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.prepareParams=function(){return{}},t.useDelete=function(){return!0},t.validateParams=function(e,t){var n=e.config;if(!t)return"Missing SpaceId";if(!n.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNGetSpacesOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e){var t=e.config;return"/v1/objects/".concat(t.subscribeKey,"/spaces")},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.include,r=t.limit,i=t.page,o=t.filter,a={};r&&(a.limit=r);if(n){var u=[];n.totalCount&&(a.count=!0),n.customFields&&u.push("custom");var s=u.join(",");s.length>0&&(a.include=s)}i&&(i.next&&(a.start=i.next),i.prev&&(a.end=i.prev));o&&(a.filter=o);return a},t.validateParams=function(){};n(2);var i=r(n(1))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNGetSpaceOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/spaces/").concat(o.default.encodeString(t.spaceId))},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.include,r={};n?void 0===n.customFields&&(n.customFields=!0):n={customFields:!0};if(n){var i=[];n.customFields&&i.push("custom");var o=i.join(",");o.length>0&&(r.include=o)}return r},t.validateParams=function(e,t){if(!t.spaceId)return"Missing spaceId"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNGetMembersOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/spaces/").concat(o.default.encodeString(t.spaceId),"/users")},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.include,r=t.limit,i=t.page,o=t.filter,a={};r&&(a.limit=r);if(n){var u=[];n.totalCount&&(a.count=!0),n.customFields&&u.push("custom"),n.userFields&&u.push("user"),n.customUserFields&&u.push("user.custom");var s=u.join(",");s.length>0&&(a.include=s)}i&&(i.next&&(a.start=i.next),i.prev&&(a.end=i.prev));o&&(a.filter=o);return a},t.validateParams=function(e,t){if(!t.spaceId)return"Missing spaceId"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNUpdateMembersOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/spaces/").concat(o.default.encodeString(t.spaceId),"/users")},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.patchPayload=function(e,t){return function(e,t){var n=t.users,r={};n&&n.length>0&&(r.add=[],n.forEach((function(e){var t={id:e.id};e.custom&&(t.custom=e.custom),r.add.push(t)})));return r}(0,t)},t.patchURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/spaces/").concat(o.default.encodeString(t.spaceId),"/users")},t.prepareParams=function(e,t){var n=t.include,r=t.limit,i=t.page,o={};r&&(o.limit=r);if(n){var a=[];n.totalCount&&(o.count=!0),n.customFields&&a.push("custom"),n.spaceFields&&a.push("space"),n.customSpaceFields&&a.push("space.custom");var u=a.join(",");u.length>0&&(o.include=u)}i&&(i.next&&(o.start=i.next),i.prev&&(o.end=i.prev));return o},t.usePatch=function(){return!0},t.validateParams=function(e,t){var n=t.spaceId,r=t.users;if(!n)return"Missing spaceId";if(!r)return"Missing users"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNUpdateMembersOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/spaces/").concat(o.default.encodeString(t.spaceId),"/users")},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.patchPayload=function(e,t){return function(e,t){var n=t.addMembers,r=t.updateMembers,i=t.removeMembers,o=t.users,a={};n&&n.length>0&&(a.add=[],n.forEach((function(e){var t={id:e.id};e.custom&&(t.custom=e.custom),a.add.push(t)})));r&&r.length>0&&(a.update=[],r.forEach((function(e){var t={id:e.id};e.custom&&(t.custom=e.custom),a.update.push(t)})));o&&o.length>0&&(a.update=a.update||[],o.forEach((function(e){var t={id:e.id};e.custom&&(t.custom=e.custom),a.update.push(t)})));i&&i.length>0&&(a.remove=[],i.forEach((function(e){a.remove.push({id:e})})));return a}(0,t)},t.patchURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/spaces/").concat(o.default.encodeString(t.spaceId),"/users")},t.prepareParams=function(e,t){var n=t.include,r=t.limit,i=t.page,o={};r&&(o.limit=r);if(n){var a=[];n.totalCount&&(o.count=!0),n.customFields&&a.push("custom"),n.spaceFields&&a.push("space"),n.customSpaceFields&&a.push("space.custom");var u=a.join(",");u.length>0&&(o.include=u)}i&&(i.next&&(o.start=i.next),i.prev&&(o.end=i.prev));return o},t.usePatch=function(){return!0},t.validateParams=function(e,t){var n=t.spaceId,r=t.users;if(!n)return"Missing spaceId";if(!r)return"Missing users"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNUpdateMembersOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/spaces/").concat(o.default.encodeString(t.spaceId),"/users")},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.patchPayload=function(e,t){return function(e,t){var n=t.users,r={};n&&n.length>0&&(r.remove=[],n.forEach((function(e){r.remove.push({id:e})})));return r}(0,t)},t.patchURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/spaces/").concat(o.default.encodeString(t.spaceId),"/users")},t.prepareParams=function(e,t){var n=t.include,r=t.limit,i=t.page,o={};r&&(o.limit=r);if(n){var a=[];n.totalCount&&(o.count=!0),n.customFields&&a.push("custom"),n.spaceFields&&a.push("space"),n.customSpaceFields&&a.push("space.custom");var u=a.join(",");u.length>0&&(o.include=u)}i&&(i.next&&(o.start=i.next),i.prev&&(o.end=i.prev));return o},t.usePatch=function(){return!0},t.validateParams=function(e,t){var n=t.spaceId,r=t.users;if(!n)return"Missing spaceId";if(!r)return"Missing users"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNGetMembershipsOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/users/").concat(o.default.encodeString(t.userId),"/spaces")},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.include,r=t.limit,i=t.page,o=t.filter,a={};r&&(a.limit=r);if(n){var u=[];n.totalCount&&(a.count=!0),n.customFields&&u.push("custom"),n.spaceFields&&u.push("space"),n.customSpaceFields&&u.push("space.custom");var s=u.join(",");s.length>0&&(a.include=s)}i&&(i.next&&(a.start=i.next),i.prev&&(a.end=i.prev));o&&(a.filter=o);return a},t.validateParams=function(e,t){if(!t.userId)return"Missing userId"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNUpdateMembershipsOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/users/").concat(o.default.encodeString(t.userId),"/spaces")},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.patchPayload=function(e,t){return function(e,t){var n=t.addMemberships,r=t.updateMemberships,i=t.removeMemberships,o=t.spaces,a={};n&&n.length>0&&(a.add=[],n.forEach((function(e){var t={id:e.id};e.custom&&(t.custom=e.custom),a.add.push(t)})));r&&r.length>0&&(a.update=[],r.forEach((function(e){var t={id:e.id};e.custom&&(t.custom=e.custom),a.update.push(t)})));o&&o.length>0&&(a.update=a.update||[],o.forEach((function(e){var t={id:e.id};e.custom&&(t.custom=e.custom),a.update.push(t)})));i&&i.length>0&&(a.remove=[],i.forEach((function(e){a.remove.push({id:e})})));return a}(0,t)},t.patchURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/users/").concat(o.default.encodeString(t.userId),"/spaces")},t.prepareParams=function(e,t){var n=t.include,r=t.limit,i=t.page,o={};r&&(o.limit=r);if(n){var a=[];n.totalCount&&(o.count=!0),n.customFields&&a.push("custom"),n.spaceFields&&a.push("space"),n.customSpaceFields&&a.push("space.custom");var u=a.join(",");u.length>0&&(o.include=u)}i&&(i.next&&(o.start=i.next),i.prev&&(o.end=i.prev));return o},t.usePatch=function(){return!0},t.validateParams=function(e,t){var n=t.userId,r=t.spaces;if(!n)return"Missing userId";if(!r)return"Missing spaces"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNUpdateMembershipsOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/users/").concat(o.default.encodeString(t.userId),"/spaces")},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.patchPayload=function(e,t){return function(e,t){var n=t.spaces,r={};n&&n.length>0&&(r.add=[],n.forEach((function(e){var t={id:e.id};e.custom&&(t.custom=e.custom),r.add.push(t)})));return r}(0,t)},t.patchURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/users/").concat(o.default.encodeString(t.userId),"/spaces")},t.prepareParams=function(e,t){var n=t.include,r=t.limit,i=t.page,o={};r&&(o.limit=r);if(n){var a=[];n.totalCount&&(o.count=!0),n.customFields&&a.push("custom"),n.spaceFields&&a.push("space"),n.customSpaceFields&&a.push("space.custom");var u=a.join(",");u.length>0&&(o.include=u)}i&&(i.next&&(o.start=i.next),i.prev&&(o.end=i.prev));return o},t.usePatch=function(){return!0},t.validateParams=function(e,t){var n=t.userId,r=t.spaces;if(!n)return"Missing userId";if(!r)return"Missing spaces"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNUpdateMembershipsOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/users/").concat(o.default.encodeString(t.userId),"/spaces")},t.handleResponse=function(e,t){return t},t.isAuthSupported=function(){return!0},t.patchPayload=function(e,t){return function(e,t){var n=t.spaces,r={};n&&n.length>0&&(r.remove=[],n.forEach((function(e){r.remove.push({id:e})})));return r}(0,t)},t.patchURL=function(e,t){var n=e.config;return"/v1/objects/".concat(n.subscribeKey,"/users/").concat(o.default.encodeString(t.userId),"/spaces")},t.prepareParams=function(e,t){var n=t.include,r=t.limit,i=t.page,o={};r&&(o.limit=r);if(n){var a=[];n.totalCount&&(o.count=!0),n.customFields&&a.push("custom"),n.spaceFields&&a.push("space"),n.customSpaceFields&&a.push("space.custom");var u=a.join(",");u.length>0&&(o.include=u)}i&&(i.next&&(o.start=i.next),i.prev&&(o.end=i.prev));return o},t.usePatch=function(){return!0},t.validateParams=function(e,t){var n=t.userId,r=t.spaces;if(!n)return"Missing userId";if(!r)return"Missing spaces"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNAccessManagerAudit},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e){var t=e.config;return"/v2/auth/audit/sub-key/".concat(t.subscribeKey)},t.handleResponse=function(e,t){return t.payload},t.isAuthSupported=function(){return!1},t.prepareParams=function(e,t){var n=t.channel,r=t.channelGroup,i=t.authKeys,o=void 0===i?[]:i,a={};n&&(a.channel=n);r&&(a["channel-group"]=r);o.length>0&&(a.auth=o.join(","));return a},t.validateParams=function(e){if(!e.config.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNAccessManagerGrant},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e){var t=e.config;return"/v2/auth/grant/sub-key/".concat(t.subscribeKey)},t.handleResponse=function(){return{}},t.isAuthSupported=function(){return!1},t.prepareParams=function(e,t){var n=t.channels,r=void 0===n?[]:n,i=t.channelGroups,o=void 0===i?[]:i,a=t.uuids,u=void 0===a?[]:a,s=t.ttl,c=t.read,l=void 0!==c&&c,f=t.write,d=void 0!==f&&f,p=t.manage,h=void 0!==p&&p,y=t.get,g=void 0!==y&&y,v=t.join,b=void 0!==v&&v,m=t.update,_=void 0!==m&&m,P=t.authKeys,O=void 0===P?[]:P,S=t.delete,w={};w.r=l?"1":"0",w.w=d?"1":"0",w.m=h?"1":"0",w.d=S?"1":"0",w.g=g?"1":"0",w.j=b?"1":"0",w.u=_?"1":"0",r.length>0&&(w.channel=r.join(","));o.length>0&&(w["channel-group"]=o.join(","));O.length>0&&(w.auth=O.join(","));u.length>0&&(w["target-uuid"]=u.join(","));(s||0===s)&&(w.ttl=s);return w},t.validateParams=function(e,t){var n=e.config;if(!n.subscribeKey)return"Missing Subscribe Key";if(!n.publishKey)return"Missing Publish Key";if(!n.secretKey)return"Missing Secret Key";if(null!=t.uuids&&!t.authKeys)return"authKeys are required for grant request on uuids";if(null!=t.uuids&&(null!=t.channels||null!=t.channelGroups))return"Both channel/channelgroup and uuid cannot be used in the same request"};n(2);var i=r(n(1))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.extractPermissions=o,t.getOperation=function(){return i.default.PNAccessManagerGrantToken},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.handleResponse=function(e,t){return t.data.token},t.isAuthSupported=function(){return!1},t.postPayload=function(e,t){return function(e,t){var n=t.ttl,r=t.resources,i=t.patterns,a=t.meta,u=t.authorized_uuid,s={ttl:0,permissions:{resources:{channels:{},groups:{},uuids:{},users:{},spaces:{}},patterns:{channels:{},groups:{},uuids:{},users:{},spaces:{}},meta:{}}};if(r){var c=r.uuids,l=r.channels,f=r.groups;c&&Object.keys(c).forEach((function(e){s.permissions.resources.uuids[e]=o(c[e])})),l&&Object.keys(l).forEach((function(e){s.permissions.resources.channels[e]=o(l[e])})),f&&Object.keys(f).forEach((function(e){s.permissions.resources.groups[e]=o(f[e])}))}if(i){var d=i.uuids,p=i.channels,h=i.groups;d&&Object.keys(d).forEach((function(e){s.permissions.patterns.uuids[e]=o(d[e])})),p&&Object.keys(p).forEach((function(e){s.permissions.patterns.channels[e]=o(p[e])})),h&&Object.keys(h).forEach((function(e){s.permissions.patterns.groups[e]=o(h[e])}))}(n||0===n)&&(s.ttl=n);a&&(s.permissions.meta=a);u&&(s.permissions.uuid="".concat(u));return s}(0,t)},t.postURL=function(e){var t=e.config;return"/v3/pam/".concat(t.subscribeKey,"/grant")},t.prepareParams=function(){return{}},t.usePost=function(){return!0},t.validateParams=function(e,t){var n=e.config;if(!n.subscribeKey)return"Missing Subscribe Key";if(!n.publishKey)return"Missing Publish Key";if(!n.secretKey)return"Missing Secret Key";if(!t.resources&&!t.patterns)return"Missing either Resources or Patterns.";if(t.resources&&(!t.resources.uuids||0===Object.keys(t.resources.uuids).length)&&(!t.resources.channels||0===Object.keys(t.resources.channels).length)&&(!t.resources.groups||0===Object.keys(t.resources.groups).length)||t.patterns&&(!t.patterns.uuids||0===Object.keys(t.patterns.uuids).length)&&(!t.patterns.channels||0===Object.keys(t.patterns.channels).length)&&(!t.patterns.groups||0===Object.keys(t.patterns.groups).length))return"Missing values for either Resources or Patterns."};n(2);var i=r(n(1));function o(e){var t=0;return e.join&&(t|=128),e.update&&(t|=64),e.get&&(t|=32),e.delete&&(t|=8),e.manage&&(t|=4),e.write&&(t|=2),e.read&&(t|=1),t}},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(1)),o=r(n(3)),a={getOperation:function(){return i.default.PNAccessManagerRevokeToken},validateParams:function(e,t){return e.config.secretKey?t?void 0:"token can't be empty":"Missing Secret Key"},getURL:function(e,t){var n=e.config;return"/v3/pam/".concat(n.subscribeKey,"/grant/").concat(o.default.encodeString(t))},useDelete:function(){return!0},getRequestTimeout:function(e){return e.config.getTransactionTimeout()},isAuthSupported:function(){return!1},prepareParams:function(e){return{uuid:e.config.getUUID()}},handleResponse:function(e,t){return{status:t.status,data:t.data}}};t.default=a,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return o.default.PNPublishOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config,r=t.channel,i=t.message,o=u(e,i);return"/publish/".concat(n.publishKey,"/").concat(n.subscribeKey,"/0/").concat(a.default.encodeString(r),"/0/").concat(a.default.encodeString(o))},t.handleResponse=function(e,t){return{timetoken:t[2]}},t.isAuthSupported=function(){return!0},t.postPayload=function(e,t){var n=t.message;return u(e,n)},t.postURL=function(e,t){var n=e.config,r=t.channel;return"/publish/".concat(n.publishKey,"/").concat(n.subscribeKey,"/0/").concat(a.default.encodeString(r),"/0")},t.prepareParams=function(e,t){var n=t.meta,r=t.replicate,o=void 0===r||r,a=t.storeInHistory,u=t.ttl,s={};null!=a&&(s.store=a?"1":"0");u&&(s.ttl=u);!1===o&&(s.norep="true");n&&"object"===(0,i.default)(n)&&(s.meta=JSON.stringify(n));return s},t.usePost=function(e,t){var n=t.sendByPost;return void 0!==n&&n},t.validateParams=function(e,t){var n=e.config,r=t.message;if(!t.channel)return"Missing Channel";if(!r)return"Missing Message";if(!n.subscribeKey)return"Missing Subscribe Key"};var i=r(n(7)),o=(n(2),r(n(1))),a=r(n(3));function u(e,t){var n=e.crypto,r=e.config,i=JSON.stringify(t);return r.cipherKey&&(i=n.encrypt(i),i=JSON.stringify(i)),i}},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNSignalOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=e.config,r=t.channel,i=t.message,a=(u=i,JSON.stringify(u));var u;return"/signal/".concat(n.publishKey,"/").concat(n.subscribeKey,"/0/").concat(o.default.encodeString(r),"/0/").concat(o.default.encodeString(a))},t.handleResponse=function(e,t){return{timetoken:t[2]}},t.isAuthSupported=function(){return!0},t.prepareParams=function(){return{}},t.validateParams=function(e,t){var n=e.config,r=t.message;if(!t.channel)return"Missing Channel";if(!r)return"Missing Message";if(!n.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNHistoryOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=t.channel,r=e.config;return"/v2/history/sub-key/".concat(r.subscribeKey,"/channel/").concat(o.default.encodeString(n))},t.handleResponse=function(e,t){var n={messages:[],startTimeToken:t[1],endTimeToken:t[2]};Array.isArray(t[0])&&t[0].forEach((function(t){var r={timetoken:t.timetoken,entry:a(e,t.message)};t.meta&&(r.meta=t.meta),n.messages.push(r)}));return n},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.start,r=t.end,i=t.reverse,o=t.count,a=void 0===o?100:o,u=t.stringifiedTimeToken,s=void 0!==u&&u,c=t.includeMeta,l=void 0!==c&&c,f={include_token:"true"};f.count=a,n&&(f.start=n);r&&(f.end=r);s&&(f.string_message_token="true");null!=i&&(f.reverse=i.toString());l&&(f.include_meta="true");return f},t.validateParams=function(e,t){var n=t.channel,r=e.config;if(!n)return"Missing channel";if(!r.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1)),o=r(n(3));function a(e,t){var n=e.config,r=e.crypto;if(!n.cipherKey)return t;try{return r.decrypt(t)}catch(e){return t}}},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNDeleteMessagesOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=t.channel,r=e.config;return"/v3/history/sub-key/".concat(r.subscribeKey,"/channel/").concat(o.default.encodeString(n))},t.handleResponse=function(e,t){return t.payload},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.start,r=t.end,i={};n&&(i.start=n);r&&(i.end=r);return i},t.useDelete=function(){return!0},t.validateParams=function(e,t){var n=t.channel,r=e.config;if(!n)return"Missing channel";if(!r.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return o.default.PNMessageCounts},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=t.channels,r=e.config,i=n.join(",");return"/v3/history/sub-key/".concat(r.subscribeKey,"/message-counts/").concat(a.default.encodeString(i))},t.handleResponse=function(e,t){return{channels:t.channels}},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.timetoken,r=t.channelTimetokens,o={};if(r&&1===r.length){var a=(0,i.default)(r,1)[0];o.timetoken=a}else r?o.channelsTimetoken=r.join(","):n&&(o.timetoken=n);return o},t.validateParams=function(e,t){var n=t.channels,r=t.timetoken,i=t.channelTimetokens,o=e.config;if(!n)return"Missing channel";if(r&&i)return"timetoken and channelTimetokens are incompatible together";if(r&&i&&i.length>1&&n.length!==i.length)return"Length of channelTimetokens and channels do not match";if(!o.subscribeKey)return"Missing Subscribe Key"};var i=r(n(9)),o=r(n(1)),a=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNFetchMessagesOperation},t.getRequestTimeout=function(e){return e.config.getTransactionTimeout()},t.getURL=function(e,t){var n=t.channels,r=void 0===n?[]:n,i=t.includeMessageActions,a=void 0!==i&&i,u=e.config,s=a?"history-with-actions":"history",c=r.length>0?r.join(","):",";return"/v3/".concat(s,"/sub-key/").concat(u.subscribeKey,"/channel/").concat(o.default.encodeString(c))},t.handleResponse=function(e,t){var n={channels:{}};Object.keys(t.channels||{}).forEach((function(r){n.channels[r]=[],(t.channels[r]||[]).forEach((function(t){var i={};i.channel=r,i.timetoken=t.timetoken,i.message=function(e,t){var n=e.config,r=e.crypto;if(!n.cipherKey)return t;try{return r.decrypt(t)}catch(e){return t}}(e,t.message),i.messageType=t.message_type,i.uuid=t.uuid,t.actions&&(i.actions=t.actions,i.data=t.actions),t.meta&&(i.meta=t.meta),n.channels[r].push(i)}))})),t.more&&(n.more=t.more);return n},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=t.channels,r=t.start,i=t.end,o=t.includeMessageActions,a=t.count,u=t.stringifiedTimeToken,s=void 0!==u&&u,c=t.includeMeta,l=void 0!==c&&c,f=t.includeUuid,d=t.includeUUID,p=void 0===d||d,h=t.includeMessageType,y=void 0===h||h,g={};g.max=a||(n.length>1||!0===o?25:100);r&&(g.start=r);i&&(g.end=i);s&&(g.string_message_token="true");l&&(g.include_meta="true");p&&!1!==f&&(g.include_uuid="true");y&&(g.include_message_type="true");return g},t.validateParams=function(e,t){var n=t.channels,r=t.includeMessageActions,i=void 0!==r&&r,o=e.config;if(!n||0===n.length)return"Missing channels";if(!o.subscribeKey)return"Missing Subscribe Key";if(i&&n.length>1)throw new TypeError("History can return actions data for a single channel only. Either pass a single channel or disable the includeMessageActions flag.")};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.getOperation=function(){return i.default.PNSubscribeOperation},t.getRequestTimeout=function(e){return e.config.getSubscribeTimeout()},t.getURL=function(e,t){var n=e.config,r=t.channels,i=void 0===r?[]:r,a=i.length>0?i.join(","):",";return"/v2/subscribe/".concat(n.subscribeKey,"/").concat(o.default.encodeString(a),"/0")},t.handleResponse=function(e,t){var n=[];t.m.forEach((function(e){var t={publishTimetoken:e.p.t,region:e.p.r},r={shard:parseInt(e.a,10),subscriptionMatch:e.b,channel:e.c,messageType:e.e,payload:e.d,flags:e.f,issuingClientId:e.i,subscribeKey:e.k,originationTimetoken:e.o,userMetadata:e.u,publishMetaData:t};n.push(r)}));var r={timetoken:t.t.t,region:t.t.r};return{messages:n,metadata:r}},t.isAuthSupported=function(){return!0},t.prepareParams=function(e,t){var n=e.config,r=t.state,i=t.channelGroups,o=void 0===i?[]:i,a=t.timetoken,u=t.filterExpression,s=t.region,c={heartbeat:n.getPresenceTimeout()};o.length>0&&(c["channel-group"]=o.join(","));u&&u.length>0&&(c["filter-expr"]=u);Object.keys(r).length&&(c.state=JSON.stringify(r));a&&(c.tt=a);s&&(c.tr=s);return c},t.validateParams=function(e){if(!e.config.subscribeKey)return"Missing Subscribe Key"};n(2);var i=r(n(1)),o=r(n(3))},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(5)),o=r(n(6)),a=r(n(4)),u=(r(n(8)),r(n(10))),s=(n(2),function(){function e(t){var n=this;(0,i.default)(this,e),(0,a.default)(this,"_modules",void 0),(0,a.default)(this,"_config",void 0),(0,a.default)(this,"_currentSubDomain",void 0),(0,a.default)(this,"_standardOrigin",void 0),(0,a.default)(this,"_subscribeOrigin",void 0),(0,a.default)(this,"_requestTimeout",void 0),(0,a.default)(this,"_coreParams",void 0),this._modules={},Object.keys(t).forEach((function(e){n._modules[e]=t[e].bind(n)}))}return(0,o.default)(e,[{key:"init",value:function(e){this._config=e,Array.isArray(this._config.origin)?this._currentSubDomain=Math.floor(Math.random()*this._config.origin.length):this._currentSubDomain=0,this._coreParams={},this.shiftStandardOrigin()}},{key:"nextOrigin",value:function(){var e=this._config.secure?"https://":"http://";if("string"==typeof this._config.origin)return"".concat(e).concat(this._config.origin);this._currentSubDomain+=1,this._currentSubDomain>=this._config.origin.length&&(this._currentSubDomain=0);var t=this._config.origin[this._currentSubDomain];return"".concat(e).concat(t)}},{key:"hasModule",value:function(e){return e in this._modules}},{key:"shiftStandardOrigin",value:function(){return this._standardOrigin=this.nextOrigin(),this._standardOrigin}},{key:"getStandardOrigin",value:function(){return this._standardOrigin}},{key:"POSTFILE",value:function(e,t,n){return this._modules.postfile(e,t,n)}},{key:"GETFILE",value:function(e,t,n){return this._modules.getfile(e,t,n)}},{key:"POST",value:function(e,t,n,r){return this._modules.post(e,t,n,r)}},{key:"PATCH",value:function(e,t,n,r){return this._modules.patch(e,t,n,r)}},{key:"GET",value:function(e,t,n){return this._modules.get(e,t,n)}},{key:"DELETE",value:function(e,t,n){return this._modules.del(e,t,n)}},{key:"_detectErrorCategory",value:function(e){if("ENOTFOUND"===e.code)return u.default.PNNetworkIssuesCategory;if("ECONNREFUSED"===e.code)return u.default.PNNetworkIssuesCategory;if("ECONNRESET"===e.code)return u.default.PNNetworkIssuesCategory;if("EAI_AGAIN"===e.code)return u.default.PNNetworkIssuesCategory;if(0===e.status||e.hasOwnProperty("status")&&void 0===e.status)return u.default.PNNetworkIssuesCategory;if(e.timeout)return u.default.PNTimeoutCategory;if("ETIMEDOUT"===e.code)return u.default.PNNetworkIssuesCategory;if(e.response){if(e.response.badRequest)return u.default.PNBadRequestCategory;if(e.response.forbidden)return u.default.PNAccessDeniedCategory}return u.default.PNUnknownCategory}}]),e}());t.default=s,e.exports=t.default},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r={get:function(e){try{return localStorage.getItem(e)}catch(e){return null}},set:function(e,t){try{return localStorage.setItem(e,t)}catch(e){return null}}};t.default=r,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=r(n(7)),o=r(n(5)),a=r(n(6)),u=r(n(4)),s=function(){function e(t,n){(0,o.default)(this,e),(0,u.default)(this,"_base64ToBinary",void 0),(0,u.default)(this,"_cborReader",void 0),this._base64ToBinary=n,this._decode=t}return(0,a.default)(e,[{key:"decodeToken",value:function(e){var t="";e.length%4==3?t="=":e.length%4==2&&(t="==");var n=e.replace(/-/gi,"+").replace(/_/gi,"/")+t,r=this._decode(this._base64ToBinary(n));if("object"===(0,i.default)(r))return r}}]),e}();t.default=s,e.exports=t.default},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.del=function(e,t,n){var r=a.default.delete(this.getStandardOrigin()+t.url).set(t.headers).query(e);return s.call(this,r,t,n)},t.get=function(e,t,n){var r=a.default.get(this.getStandardOrigin()+t.url).set(t.headers).query(e);return s.call(this,r,t,n)},t.getfile=function(e,t,n){var r=a.default.get(this.getStandardOrigin()+t.url).set(t.headers).query(e);return s.call(this,r,t,n)},t.patch=function(e,t,n,r){var i=a.default.patch(this.getStandardOrigin()+n.url).query(e).set(n.headers).send(t);return s.call(this,i,n,r)},t.post=function(e,t,n,r){var i=a.default.post(this.getStandardOrigin()+n.url).query(e).set(n.headers).send(t);return s.call(this,i,n,r)},t.postfile=function(e,t,n){return c.apply(this,arguments)};var i=r(n(11)),o=r(n(12)),a=r(n(129));n(2);function u(e){var t=(new Date).getTime(),n=(new Date).toISOString(),r=console&&console.log?console:window&&window.console&&window.console.log?window.console:console;r.log("<<<<<"),r.log("[".concat(n,"]"),"\n",e.url,"\n",e.qs),r.log("-----"),e.on("response",(function(n){var i=(new Date).getTime()-t,o=(new Date).toISOString();r.log(">>>>>>"),r.log("[".concat(o," / ").concat(i,"]"),"\n",e.url,"\n",e.qs,"\n",n.text),r.log("-----")}))}function s(e,t,n){var r=this;this._config.logVerbosity&&(e=e.use(u)),this._config.proxy&&this._modules.proxy&&(e=this._modules.proxy.call(this,e)),this._config.keepAlive&&this._modules.keepAlive&&(e=this._modules.keepAlive(e));var i=e;return!0===t.forceBuffered?i="undefined"==typeof Blob?i.buffer().responseType("arraybuffer"):i.responseType("arraybuffer"):!1===t.forceBuffered&&(i=i.buffer(!1)),(i=i.timeout(t.timeout)).end((function(e,i){var o,a={};if(a.error=null!==e,a.operation=t.operation,i&&i.status&&(a.statusCode=i.status),e){if(e.response&&e.response.text&&!r._config.logVerbosity)try{a.errorData=JSON.parse(e.response.text)}catch(t){a.errorData=e}else a.errorData=e;return a.category=r._detectErrorCategory(e),n(a,null)}if(t.ignoreBody)o={headers:i.headers,redirects:i.redirects,response:i};else try{o=JSON.parse(i.text)}catch(e){return a.errorData=i,a.error=!0,n(a,null)}return o.error&&1===o.error&&o.status&&o.message&&o.service?(a.errorData=o,a.statusCode=o.status,a.error=!0,a.category=r._detectErrorCategory(a),n(a,null)):(o.error&&o.error.message&&(a.errorData=o.error),n(a,o))})),i}function c(){return(c=(0,o.default)(i.default.mark((function e(t,n,r){var o,u;return i.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=a.default.post(t),n.forEach((function(e){var t=e.key,n=e.value;o=o.field(t,n)})),o.attach("file",r,{contentType:"application/octet-stream"}),e.next=5,o;case 5:return u=e.sent,e.abrupt("return",u);case 7:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},function(e,t,n){"use strict";function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var i;"undefined"!=typeof window?i=window:"undefined"==typeof self?(console.warn("Using browser-only version of superagent in non-browser environment"),i=void 0):i=self;var o=n(130),a=n(131),u=n(132),s=n(144),c=n(30),l=n(145),f=n(147);function d(){}e.exports=function(e,n){return"function"==typeof n?new t.Request("GET",e).end(n):1===arguments.length?new t.Request("GET",e):new t.Request(e,n)};var p=t=e.exports;t.Request=_,p.getXHR=function(){if(i.XMLHttpRequest&&(!i.location||"file:"!==i.location.protocol||!i.ActiveXObject))return new XMLHttpRequest;try{return new ActiveXObject("Microsoft.XMLHTTP")}catch(e){}try{return new ActiveXObject("Msxml2.XMLHTTP.6.0")}catch(e){}try{return new ActiveXObject("Msxml2.XMLHTTP.3.0")}catch(e){}try{return new ActiveXObject("Msxml2.XMLHTTP")}catch(e){}throw new Error("Browser-only version of superagent could not find XHR")};var h="".trim?function(e){return e.trim()}:function(e){return e.replace(/(^\s*|\s*$)/g,"")};function y(e){if(!c(e))return e;var t=[];for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&g(t,n,e[n]);return t.join("&")}function g(e,t,n){if(void 0!==n)if(null!==n)if(Array.isArray(n))n.forEach((function(n){g(e,t,n)}));else if(c(n))for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&g(e,"".concat(t,"[").concat(r,"]"),n[r]);else e.push(encodeURI(t)+"="+encodeURIComponent(n));else e.push(encodeURI(t))}function v(e){for(var t,n,r={},i=e.split("&"),o=0,a=i.length;o<a;++o)-1===(n=(t=i[o]).indexOf("="))?r[decodeURIComponent(t)]="":r[decodeURIComponent(t.slice(0,n))]=decodeURIComponent(t.slice(n+1));return r}function b(e){return/[/+]json($|[^-\w])/i.test(e)}function m(e){this.req=e,this.xhr=this.req.xhr,this.text="HEAD"!==this.req.method&&(""===this.xhr.responseType||"text"===this.xhr.responseType)||void 0===this.xhr.responseType?this.xhr.responseText:null,this.statusText=this.req.xhr.statusText;var t=this.xhr.status;1223===t&&(t=204),this._setStatusProperties(t),this.headers=function(e){for(var t,n,r,i,o=e.split(/\r?\n/),a={},u=0,s=o.length;u<s;++u)-1!==(t=(n=o[u]).indexOf(":"))&&(r=n.slice(0,t).toLowerCase(),i=h(n.slice(t+1)),a[r]=i);return a}(this.xhr.getAllResponseHeaders()),this.header=this.headers,this.header["content-type"]=this.xhr.getResponseHeader("content-type"),this._setHeaderProperties(this.header),null===this.text&&e._responseType?this.body=this.xhr.response:this.body="HEAD"===this.req.method?null:this._parseBody(this.text?this.text:this.xhr.response)}function _(e,t){var n=this;this._query=this._query||[],this.method=e,this.url=t,this.header={},this._header={},this.on("end",(function(){var e,t=null,r=null;try{r=new m(n)}catch(e){return(t=new Error("Parser is unable to parse the response")).parse=!0,t.original=e,n.xhr?(t.rawResponse=void 0===n.xhr.responseType?n.xhr.responseText:n.xhr.response,t.status=n.xhr.status?n.xhr.status:null,t.statusCode=t.status):(t.rawResponse=null,t.status=null),n.callback(t)}n.emit("response",r);try{n._isResponseOK(r)||(e=new Error(r.statusText||r.text||"Unsuccessful HTTP response"))}catch(t){e=t}e?(e.original=t,e.response=r,e.status=r.status,n.callback(e,r)):n.callback(null,r)}))}function P(e,t,n){var r=p("DELETE",e);return"function"==typeof t&&(n=t,t=null),t&&r.send(t),n&&r.end(n),r}p.serializeObject=y,p.parseString=v,p.types={html:"text/html",json:"application/json",xml:"text/xml",urlencoded:"application/x-www-form-urlencoded",form:"application/x-www-form-urlencoded","form-data":"application/x-www-form-urlencoded"},p.serialize={"application/x-www-form-urlencoded":u.stringify,"application/json":a},p.parse={"application/x-www-form-urlencoded":v,"application/json":JSON.parse},l(m.prototype),m.prototype._parseBody=function(e){var t=p.parse[this.type];return this.req._parser?this.req._parser(this,e):(!t&&b(this.type)&&(t=p.parse["application/json"]),t&&e&&(e.length>0||e instanceof Object)?t(e):null)},m.prototype.toError=function(){var e=this.req,t=e.method,n=e.url,r="cannot ".concat(t," ").concat(n," (").concat(this.status,")"),i=new Error(r);return i.status=this.status,i.method=t,i.url=n,i},p.Response=m,o(_.prototype),s(_.prototype),_.prototype.type=function(e){return this.set("Content-Type",p.types[e]||e),this},_.prototype.accept=function(e){return this.set("Accept",p.types[e]||e),this},_.prototype.auth=function(e,t,n){1===arguments.length&&(t=""),"object"===r(t)&&null!==t&&(n=t,t=""),n||(n={type:"function"==typeof btoa?"basic":"auto"});var i=function(e){if("function"==typeof btoa)return btoa(e);throw new Error("Cannot use basic auth, btoa is not a function")};return this._auth(e,t,n,i)},_.prototype.query=function(e){return"string"!=typeof e&&(e=y(e)),e&&this._query.push(e),this},_.prototype.attach=function(e,t,n){if(t){if(this._data)throw new Error("superagent can't mix .send() and .attach()");this._getFormData().append(e,t,n||t.name)}return this},_.prototype._getFormData=function(){return this._formData||(this._formData=new i.FormData),this._formData},_.prototype.callback=function(e,t){if(this._shouldRetry(e,t))return this._retry();var n=this._callback;this.clearTimeout(),e&&(this._maxRetries&&(e.retries=this._retries-1),this.emit("error",e)),n(e,t)},_.prototype.crossDomainError=function(){var e=new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.");e.crossDomain=!0,e.status=this.status,e.method=this.method,e.url=this.url,this.callback(e)},_.prototype.agent=function(){return console.warn("This is not supported in browser version of superagent"),this},_.prototype.ca=_.prototype.agent,_.prototype.buffer=_.prototype.ca,_.prototype.write=function(){throw new Error("Streaming is not supported in browser version of superagent")},_.prototype.pipe=_.prototype.write,_.prototype._isHost=function(e){return e&&"object"===r(e)&&!Array.isArray(e)&&"[object Object]"!==Object.prototype.toString.call(e)},_.prototype.end=function(e){this._endCalled&&console.warn("Warning: .end() was called twice. This is not supported in superagent"),this._endCalled=!0,this._callback=e||d,this._finalizeQueryString(),this._end()},_.prototype._setUploadTimeout=function(){var e=this;this._uploadTimeout&&!this._uploadTimeoutTimer&&(this._uploadTimeoutTimer=setTimeout((function(){e._timeoutError("Upload timeout of ",e._uploadTimeout,"ETIMEDOUT")}),this._uploadTimeout))},_.prototype._end=function(){if(this._aborted)return this.callback(new Error("The request has been aborted even before .end() was called"));var e=this;this.xhr=p.getXHR();var t=this.xhr,n=this._formData||this._data;this._setTimeouts(),t.onreadystatechange=function(){var n=t.readyState;if(n>=2&&e._responseTimeoutTimer&&clearTimeout(e._responseTimeoutTimer),4===n){var r;try{r=t.status}catch(e){r=0}if(!r){if(e.timedout||e._aborted)return;return e.crossDomainError()}e.emit("end")}};var r=function(t,n){n.total>0&&(n.percent=n.loaded/n.total*100,100===n.percent&&clearTimeout(e._uploadTimeoutTimer)),n.direction=t,e.emit("progress",n)};if(this.hasListeners("progress"))try{t.addEventListener("progress",r.bind(null,"download")),t.upload&&t.upload.addEventListener("progress",r.bind(null,"upload"))}catch(e){}t.upload&&this._setUploadTimeout();try{this.username&&this.password?t.open(this.method,this.url,!0,this.username,this.password):t.open(this.method,this.url,!0)}catch(e){return this.callback(e)}if(this._withCredentials&&(t.withCredentials=!0),!this._formData&&"GET"!==this.method&&"HEAD"!==this.method&&"string"!=typeof n&&!this._isHost(n)){var i=this._header["content-type"],o=this._serializer||p.serialize[i?i.split(";")[0]:""];!o&&b(i)&&(o=p.serialize["application/json"]),o&&(n=o(n))}for(var a in this.header)null!==this.header[a]&&Object.prototype.hasOwnProperty.call(this.header,a)&&t.setRequestHeader(a,this.header[a]);this._responseType&&(t.responseType=this._responseType),this.emit("request",this),t.send(void 0===n?null:n)},p.agent=function(){return new f},["GET","POST","OPTIONS","PATCH","PUT","DELETE"].forEach((function(e){f.prototype[e.toLowerCase()]=function(t,n){var r=new p.Request(e,t);return this._setDefaults(r),n&&r.end(n),r}})),f.prototype.del=f.prototype.delete,p.get=function(e,t,n){var r=p("GET",e);return"function"==typeof t&&(n=t,t=null),t&&r.query(t),n&&r.end(n),r},p.head=function(e,t,n){var r=p("HEAD",e);return"function"==typeof t&&(n=t,t=null),t&&r.query(t),n&&r.end(n),r},p.options=function(e,t,n){var r=p("OPTIONS",e);return"function"==typeof t&&(n=t,t=null),t&&r.send(t),n&&r.end(n),r},p.del=P,p.delete=P,p.patch=function(e,t,n){var r=p("PATCH",e);return"function"==typeof t&&(n=t,t=null),t&&r.send(t),n&&r.end(n),r},p.post=function(e,t,n){var r=p("POST",e);return"function"==typeof t&&(n=t,t=null),t&&r.send(t),n&&r.end(n),r},p.put=function(e,t,n){var r=p("PUT",e);return"function"==typeof t&&(n=t,t=null),t&&r.send(t),n&&r.end(n),r}},function(e,t,n){function r(e){if(e)return function(e){for(var t in r.prototype)e[t]=r.prototype[t];return e}(e)}e.exports=r,r.prototype.on=r.prototype.addEventListener=function(e,t){return this._callbacks=this._callbacks||{},(this._callbacks["$"+e]=this._callbacks["$"+e]||[]).push(t),this},r.prototype.once=function(e,t){function n(){this.off(e,n),t.apply(this,arguments)}return n.fn=t,this.on(e,n),this},r.prototype.off=r.prototype.removeListener=r.prototype.removeAllListeners=r.prototype.removeEventListener=function(e,t){if(this._callbacks=this._callbacks||{},0==arguments.length)return this._callbacks={},this;var n,r=this._callbacks["$"+e];if(!r)return this;if(1==arguments.length)return delete this._callbacks["$"+e],this;for(var i=0;i<r.length;i++)if((n=r[i])===t||n.fn===t){r.splice(i,1);break}return 0===r.length&&delete this._callbacks["$"+e],this},r.prototype.emit=function(e){this._callbacks=this._callbacks||{};for(var t=new Array(arguments.length-1),n=this._callbacks["$"+e],r=1;r<arguments.length;r++)t[r-1]=arguments[r];if(n){r=0;for(var i=(n=n.slice(0)).length;r<i;++r)n[r].apply(this,t)}return this},r.prototype.listeners=function(e){return this._callbacks=this._callbacks||{},this._callbacks["$"+e]||[]},r.prototype.hasListeners=function(e){return!!this.listeners(e).length}},function(e,t){e.exports=o,o.default=o,o.stable=s,o.stableStringify=s;var n=[],r=[];function i(){return{depthLimit:Number.MAX_SAFE_INTEGER,edgesLimit:Number.MAX_SAFE_INTEGER}}function o(e,t,o,u){var s;void 0===u&&(u=i()),function e(t,n,r,i,o,u,s){var c;if(u+=1,"object"==typeof t&&null!==t){for(c=0;c<i.length;c++)if(i[c]===t)return void a("[Circular]",t,n,o);if(void 0!==s.depthLimit&&u>s.depthLimit)return void a("[...]",t,n,o);if(void 0!==s.edgesLimit&&r+1>s.edgesLimit)return void a("[...]",t,n,o);if(i.push(t),Array.isArray(t))for(c=0;c<t.length;c++)e(t[c],c,c,i,t,u,s);else{var l=Object.keys(t);for(c=0;c<l.length;c++){var f=l[c];e(t[f],f,c,i,t,u,s)}}i.pop()}}(e,"",0,[],void 0,0,u);try{s=0===r.length?JSON.stringify(e,t,o):JSON.stringify(e,c(t),o)}catch(e){return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]")}finally{for(;0!==n.length;){var l=n.pop();4===l.length?Object.defineProperty(l[0],l[1],l[3]):l[0][l[1]]=l[2]}}return s}function a(e,t,i,o){var a=Object.getOwnPropertyDescriptor(o,i);void 0!==a.get?a.configurable?(Object.defineProperty(o,i,{value:e}),n.push([o,i,t,a])):r.push([t,i,e]):(o[i]=e,n.push([o,i,t]))}function u(e,t){return e<t?-1:e>t?1:0}function s(e,t,o,s){void 0===s&&(s=i());var l,f=function e(t,r,i,o,s,c,l){var f;if(c+=1,"object"==typeof t&&null!==t){for(f=0;f<o.length;f++)if(o[f]===t)return void a("[Circular]",t,r,s);try{if("function"==typeof t.toJSON)return}catch(e){return}if(void 0!==l.depthLimit&&c>l.depthLimit)return void a("[...]",t,r,s);if(void 0!==l.edgesLimit&&i+1>l.edgesLimit)return void a("[...]",t,r,s);if(o.push(t),Array.isArray(t))for(f=0;f<t.length;f++)e(t[f],f,f,o,t,c,l);else{var d={},p=Object.keys(t).sort(u);for(f=0;f<p.length;f++){var h=p[f];e(t[h],h,f,o,t,c,l),d[h]=t[h]}if(void 0===s)return d;n.push([s,r,t]),s[r]=d}o.pop()}}(e,"",0,[],void 0,0,s)||e;try{l=0===r.length?JSON.stringify(f,t,o):JSON.stringify(f,c(t),o)}catch(e){return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]")}finally{for(;0!==n.length;){var d=n.pop();4===d.length?Object.defineProperty(d[0],d[1],d[3]):d[0][d[1]]=d[2]}}return l}function c(e){return e=void 0!==e?e:function(e,t){return t},function(t,n){if(r.length>0)for(var i=0;i<r.length;i++){var o=r[i];if(o[1]===t&&o[0]===n){n=o[2],r.splice(i,1);break}}return e.call(this,t,n)}}},function(e,t,n){"use strict";var r=n(133),i=n(143),o=n(21);e.exports={formats:o,parse:i,stringify:r}},function(e,t,n){"use strict";var r=n(134),i=n(29),o=n(21),a=Object.prototype.hasOwnProperty,u={brackets:function(e){return e+"[]"},comma:"comma",indices:function(e,t){return e+"["+t+"]"},repeat:function(e){return e}},s=Array.isArray,c=String.prototype.split,l=Array.prototype.push,f=function(e,t){l.apply(e,s(t)?t:[t])},d=Date.prototype.toISOString,p=o.default,h={addQueryPrefix:!1,allowDots:!1,charset:"utf-8",charsetSentinel:!1,delimiter:"&",encode:!0,encoder:i.encode,encodeValuesOnly:!1,format:p,formatter:o.formatters[p],indices:!1,serializeDate:function(e){return d.call(e)},skipNulls:!1,strictNullHandling:!1},y={},g=function e(t,n,o,a,u,l,d,p,g,v,b,m,_,P,O){for(var S,w=t,k=O,T=0,x=!1;void 0!==(k=k.get(y))&&!x;){var A=k.get(t);if(T+=1,void 0!==A){if(A===T)throw new RangeError("Cyclic object value");x=!0}void 0===k.get(y)&&(T=0)}if("function"==typeof d?w=d(n,w):w instanceof Date?w=v(w):"comma"===o&&s(w)&&(w=i.maybeMap(w,(function(e){return e instanceof Date?v(e):e}))),null===w){if(a)return l&&!_?l(n,h.encoder,P,"key",b):n;w=""}if("string"==typeof(S=w)||"number"==typeof S||"boolean"==typeof S||"symbol"==typeof S||"bigint"==typeof S||i.isBuffer(w)){if(l){var M=_?n:l(n,h.encoder,P,"key",b);if("comma"===o&&_){for(var E=c.call(String(w),","),j="",R=0;R<E.length;++R)j+=(0===R?"":",")+m(l(E[R],h.encoder,P,"value",b));return[m(M)+"="+j]}return[m(M)+"="+m(l(w,h.encoder,P,"value",b))]}return[m(n)+"="+m(String(w))]}var N,C=[];if(void 0===w)return C;if("comma"===o&&s(w))N=[{value:w.length>0?w.join(",")||null:void 0}];else if(s(d))N=d;else{var U=Object.keys(w);N=p?U.sort(p):U}for(var I=0;I<N.length;++I){var D=N[I],F="object"==typeof D&&void 0!==D.value?D.value:w[D];if(!u||null!==F){var L=s(w)?"function"==typeof o?o(n,D):n:n+(g?"."+D:"["+D+"]");O.set(t,T);var K=r();K.set(y,O),f(C,e(F,L,o,a,u,l,d,p,g,v,b,m,_,P,K))}}return C};e.exports=function(e,t){var n,i=e,c=function(e){if(!e)return h;if(null!==e.encoder&&void 0!==e.encoder&&"function"!=typeof e.encoder)throw new TypeError("Encoder has to be a function.");var t=e.charset||h.charset;if(void 0!==e.charset&&"utf-8"!==e.charset&&"iso-8859-1"!==e.charset)throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");var n=o.default;if(void 0!==e.format){if(!a.call(o.formatters,e.format))throw new TypeError("Unknown format option provided.");n=e.format}var r=o.formatters[n],i=h.filter;return("function"==typeof e.filter||s(e.filter))&&(i=e.filter),{addQueryPrefix:"boolean"==typeof e.addQueryPrefix?e.addQueryPrefix:h.addQueryPrefix,allowDots:void 0===e.allowDots?h.allowDots:!!e.allowDots,charset:t,charsetSentinel:"boolean"==typeof e.charsetSentinel?e.charsetSentinel:h.charsetSentinel,delimiter:void 0===e.delimiter?h.delimiter:e.delimiter,encode:"boolean"==typeof e.encode?e.encode:h.encode,encoder:"function"==typeof e.encoder?e.encoder:h.encoder,encodeValuesOnly:"boolean"==typeof e.encodeValuesOnly?e.encodeValuesOnly:h.encodeValuesOnly,filter:i,format:n,formatter:r,serializeDate:"function"==typeof e.serializeDate?e.serializeDate:h.serializeDate,skipNulls:"boolean"==typeof e.skipNulls?e.skipNulls:h.skipNulls,sort:"function"==typeof e.sort?e.sort:null,strictNullHandling:"boolean"==typeof e.strictNullHandling?e.strictNullHandling:h.strictNullHandling}}(t);"function"==typeof c.filter?i=(0,c.filter)("",i):s(c.filter)&&(n=c.filter);var l,d=[];if("object"!=typeof i||null===i)return"";l=t&&t.arrayFormat in u?t.arrayFormat:t&&"indices"in t?t.indices?"indices":"repeat":"indices";var p=u[l];n||(n=Object.keys(i)),c.sort&&n.sort(c.sort);for(var y=r(),v=0;v<n.length;++v){var b=n[v];c.skipNulls&&null===i[b]||f(d,g(i[b],b,p,c.strictNullHandling,c.skipNulls,c.encode?c.encoder:null,c.filter,c.sort,c.allowDots,c.serializeDate,c.format,c.formatter,c.encodeValuesOnly,c.charset,y))}var m=d.join(c.delimiter),_=!0===c.addQueryPrefix?"?":"";return c.charsetSentinel&&("iso-8859-1"===c.charset?_+="utf8=%26%2310003%3B&":_+="utf8=%E2%9C%93&"),m.length>0?_+m:""}},function(e,t,n){"use strict";var r=n(19),i=n(139),o=n(141),a=r("%TypeError%"),u=r("%WeakMap%",!0),s=r("%Map%",!0),c=i("WeakMap.prototype.get",!0),l=i("WeakMap.prototype.set",!0),f=i("WeakMap.prototype.has",!0),d=i("Map.prototype.get",!0),p=i("Map.prototype.set",!0),h=i("Map.prototype.has",!0),y=function(e,t){for(var n,r=e;null!==(n=r.next);r=n)if(n.key===t)return r.next=n.next,n.next=e.next,e.next=n,n};e.exports=function(){var e,t,n,r={assert:function(e){if(!r.has(e))throw new a("Side channel does not contain "+o(e))},get:function(r){if(u&&r&&("object"==typeof r||"function"==typeof r)){if(e)return c(e,r)}else if(s){if(t)return d(t,r)}else if(n)return function(e,t){var n=y(e,t);return n&&n.value}(n,r)},has:function(r){if(u&&r&&("object"==typeof r||"function"==typeof r)){if(e)return f(e,r)}else if(s){if(t)return h(t,r)}else if(n)return function(e,t){return!!y(e,t)}(n,r);return!1},set:function(r,i){u&&r&&("object"==typeof r||"function"==typeof r)?(e||(e=new u),l(e,r,i)):s?(t||(t=new s),p(t,r,i)):(n||(n={key:{},next:null}),function(e,t,n){var r=y(e,t);r?r.value=n:e.next={key:t,next:e.next,value:n}}(n,r,i))}};return r}},function(e,t,n){"use strict";var r="undefined"!=typeof Symbol&&Symbol,i=n(136);e.exports=function(){return"function"==typeof r&&("function"==typeof Symbol&&("symbol"==typeof r("foo")&&("symbol"==typeof Symbol("bar")&&i())))}},function(e,t,n){"use strict";e.exports=function(){if("function"!=typeof Symbol||"function"!=typeof Object.getOwnPropertySymbols)return!1;if("symbol"==typeof Symbol.iterator)return!0;var e={},t=Symbol("test"),n=Object(t);if("string"==typeof t)return!1;if("[object Symbol]"!==Object.prototype.toString.call(t))return!1;if("[object Symbol]"!==Object.prototype.toString.call(n))return!1;for(t in e[t]=42,e)return!1;if("function"==typeof Object.keys&&0!==Object.keys(e).length)return!1;if("function"==typeof Object.getOwnPropertyNames&&0!==Object.getOwnPropertyNames(e).length)return!1;var r=Object.getOwnPropertySymbols(e);if(1!==r.length||r[0]!==t)return!1;if(!Object.prototype.propertyIsEnumerable.call(e,t))return!1;if("function"==typeof Object.getOwnPropertyDescriptor){var i=Object.getOwnPropertyDescriptor(e,t);if(42!==i.value||!0!==i.enumerable)return!1}return!0}},function(e,t,n){"use strict";var r="Function.prototype.bind called on incompatible ",i=Array.prototype.slice,o=Object.prototype.toString;e.exports=function(e){var t=this;if("function"!=typeof t||"[object Function]"!==o.call(t))throw new TypeError(r+t);for(var n,a=i.call(arguments,1),u=function(){if(this instanceof n){var r=t.apply(this,a.concat(i.call(arguments)));return Object(r)===r?r:this}return t.apply(e,a.concat(i.call(arguments)))},s=Math.max(0,t.length-a.length),c=[],l=0;l<s;l++)c.push("$"+l);if(n=Function("binder","return function ("+c.join(",")+"){ return binder.apply(this,arguments); }")(u),t.prototype){var f=function(){};f.prototype=t.prototype,n.prototype=new f,f.prototype=null}return n}},function(e,t,n){"use strict";var r=n(20);e.exports=r.call(Function.call,Object.prototype.hasOwnProperty)},function(e,t,n){"use strict";var r=n(19),i=n(140),o=i(r("String.prototype.indexOf"));e.exports=function(e,t){var n=r(e,!!t);return"function"==typeof n&&o(e,".prototype.")>-1?i(n):n}},function(e,t,n){"use strict";var r=n(20),i=n(19),o=i("%Function.prototype.apply%"),a=i("%Function.prototype.call%"),u=i("%Reflect.apply%",!0)||r.call(a,o),s=i("%Object.getOwnPropertyDescriptor%",!0),c=i("%Object.defineProperty%",!0),l=i("%Math.max%");if(c)try{c({},"a",{value:1})}catch(e){c=null}e.exports=function(e){var t=u(r,a,arguments);if(s&&c){var n=s(t,"length");n.configurable&&c(t,"length",{value:1+l(0,e.length-(arguments.length-1))})}return t};var f=function(){return u(r,o,arguments)};c?c(e.exports,"apply",{value:f}):e.exports.apply=f},function(e,t,n){var r="function"==typeof Map&&Map.prototype,i=Object.getOwnPropertyDescriptor&&r?Object.getOwnPropertyDescriptor(Map.prototype,"size"):null,o=r&&i&&"function"==typeof i.get?i.get:null,a=r&&Map.prototype.forEach,u="function"==typeof Set&&Set.prototype,s=Object.getOwnPropertyDescriptor&&u?Object.getOwnPropertyDescriptor(Set.prototype,"size"):null,c=u&&s&&"function"==typeof s.get?s.get:null,l=u&&Set.prototype.forEach,f="function"==typeof WeakMap&&WeakMap.prototype?WeakMap.prototype.has:null,d="function"==typeof WeakSet&&WeakSet.prototype?WeakSet.prototype.has:null,p="function"==typeof WeakRef&&WeakRef.prototype?WeakRef.prototype.deref:null,h=Boolean.prototype.valueOf,y=Object.prototype.toString,g=Function.prototype.toString,v=String.prototype.match,b="function"==typeof BigInt?BigInt.prototype.valueOf:null,m=Object.getOwnPropertySymbols,_="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?Symbol.prototype.toString:null,P="function"==typeof Symbol&&"object"==typeof Symbol.iterator,O="function"==typeof Symbol&&Symbol.toStringTag&&(typeof Symbol.toStringTag===P||"symbol")?Symbol.toStringTag:null,S=Object.prototype.propertyIsEnumerable,w=("function"==typeof Reflect?Reflect.getPrototypeOf:Object.getPrototypeOf)||([].__proto__===Array.prototype?function(e){return e.__proto__}:null),k=n(142).custom,T=k&&E(k)?k:null;function x(e,t,n){var r="double"===(n.quoteStyle||t)?'"':"'";return r+e+r}function A(e){return String(e).replace(/"/g,"&quot;")}function M(e){return!("[object Array]"!==N(e)||O&&"object"==typeof e&&O in e)}function E(e){if(P)return e&&"object"==typeof e&&e instanceof Symbol;if("symbol"==typeof e)return!0;if(!e||"object"!=typeof e||!_)return!1;try{return _.call(e),!0}catch(e){}return!1}e.exports=function e(t,n,r,i){var u=n||{};if(R(u,"quoteStyle")&&"single"!==u.quoteStyle&&"double"!==u.quoteStyle)throw new TypeError('option "quoteStyle" must be "single" or "double"');if(R(u,"maxStringLength")&&("number"==typeof u.maxStringLength?u.maxStringLength<0&&u.maxStringLength!==1/0:null!==u.maxStringLength))throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');var s=!R(u,"customInspect")||u.customInspect;if("boolean"!=typeof s&&"symbol"!==s)throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");if(R(u,"indent")&&null!==u.indent&&"\t"!==u.indent&&!(parseInt(u.indent,10)===u.indent&&u.indent>0))throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');if(void 0===t)return"undefined";if(null===t)return"null";if("boolean"==typeof t)return t?"true":"false";if("string"==typeof t)return function e(t,n){if(t.length>n.maxStringLength){var r=t.length-n.maxStringLength,i="... "+r+" more character"+(r>1?"s":"");return e(t.slice(0,n.maxStringLength),n)+i}return x(t.replace(/(['\\])/g,"\\$1").replace(/[\x00-\x1f]/g,U),"single",n)}(t,u);if("number"==typeof t)return 0===t?1/0/t>0?"0":"-0":String(t);if("bigint"==typeof t)return String(t)+"n";var y=void 0===u.depth?5:u.depth;if(void 0===r&&(r=0),r>=y&&y>0&&"object"==typeof t)return M(t)?"[Array]":"[Object]";var m=function(e,t){var n;if("\t"===e.indent)n="\t";else{if(!("number"==typeof e.indent&&e.indent>0))return null;n=Array(e.indent+1).join(" ")}return{base:n,prev:Array(t+1).join(n)}}(u,r);if(void 0===i)i=[];else if(C(i,t)>=0)return"[Circular]";function S(t,n,o){if(n&&(i=i.slice()).push(n),o){var a={depth:u.depth};return R(u,"quoteStyle")&&(a.quoteStyle=u.quoteStyle),e(t,a,r+1,i)}return e(t,u,r+1,i)}if("function"==typeof t){var k=function(e){if(e.name)return e.name;var t=v.call(g.call(e),/^function\s*([\w$]+)/);if(t)return t[1];return null}(t),j=K(t,S);return"[Function"+(k?": "+k:" (anonymous)")+"]"+(j.length>0?" { "+j.join(", ")+" }":"")}if(E(t)){var B=P?String(t).replace(/^(Symbol\(.*\))_[^)]*$/,"$1"):_.call(t);return"object"!=typeof t||P?B:I(B)}if(function(e){if(!e||"object"!=typeof e)return!1;if("undefined"!=typeof HTMLElement&&e instanceof HTMLElement)return!0;return"string"==typeof e.nodeName&&"function"==typeof e.getAttribute}(t)){for(var G="<"+String(t.nodeName).toLowerCase(),q=t.attributes||[],H=0;H<q.length;H++)G+=" "+q[H].name+"="+x(A(q[H].value),"double",u);return G+=">",t.childNodes&&t.childNodes.length&&(G+="..."),G+="</"+String(t.nodeName).toLowerCase()+">"}if(M(t)){if(0===t.length)return"[]";var z=K(t,S);return m&&!function(e){for(var t=0;t<e.length;t++)if(C(e[t],"\n")>=0)return!1;return!0}(z)?"["+L(z,m)+"]":"[ "+z.join(", ")+" ]"}if(function(e){return!("[object Error]"!==N(e)||O&&"object"==typeof e&&O in e)}(t)){var W=K(t,S);return 0===W.length?"["+String(t)+"]":"{ ["+String(t)+"] "+W.join(", ")+" }"}if("object"==typeof t&&s){if(T&&"function"==typeof t[T])return t[T]();if("symbol"!==s&&"function"==typeof t.inspect)return t.inspect()}if(function(e){if(!o||!e||"object"!=typeof e)return!1;try{o.call(e);try{c.call(e)}catch(e){return!0}return e instanceof Map}catch(e){}return!1}(t)){var V=[];return a.call(t,(function(e,n){V.push(S(n,t,!0)+" => "+S(e,t))})),F("Map",o.call(t),V,m)}if(function(e){if(!c||!e||"object"!=typeof e)return!1;try{c.call(e);try{o.call(e)}catch(e){return!0}return e instanceof Set}catch(e){}return!1}(t)){var Y=[];return l.call(t,(function(e){Y.push(S(e,t))})),F("Set",c.call(t),Y,m)}if(function(e){if(!f||!e||"object"!=typeof e)return!1;try{f.call(e,f);try{d.call(e,d)}catch(e){return!0}return e instanceof WeakMap}catch(e){}return!1}(t))return D("WeakMap");if(function(e){if(!d||!e||"object"!=typeof e)return!1;try{d.call(e,d);try{f.call(e,f)}catch(e){return!0}return e instanceof WeakSet}catch(e){}return!1}(t))return D("WeakSet");if(function(e){if(!p||!e||"object"!=typeof e)return!1;try{return p.call(e),!0}catch(e){}return!1}(t))return D("WeakRef");if(function(e){return!("[object Number]"!==N(e)||O&&"object"==typeof e&&O in e)}(t))return I(S(Number(t)));if(function(e){if(!e||"object"!=typeof e||!b)return!1;try{return b.call(e),!0}catch(e){}return!1}(t))return I(S(b.call(t)));if(function(e){return!("[object Boolean]"!==N(e)||O&&"object"==typeof e&&O in e)}(t))return I(h.call(t));if(function(e){return!("[object String]"!==N(e)||O&&"object"==typeof e&&O in e)}(t))return I(S(String(t)));if(!function(e){return!("[object Date]"!==N(e)||O&&"object"==typeof e&&O in e)}(t)&&!function(e){return!("[object RegExp]"!==N(e)||O&&"object"==typeof e&&O in e)}(t)){var J=K(t,S),$=w?w(t)===Object.prototype:t instanceof Object||t.constructor===Object,X=t instanceof Object?"":"null prototype",Q=!$&&O&&Object(t)===t&&O in t?N(t).slice(8,-1):X?"Object":"",Z=($||"function"!=typeof t.constructor?"":t.constructor.name?t.constructor.name+" ":"")+(Q||X?"["+[].concat(Q||[],X||[]).join(": ")+"] ":"");return 0===J.length?Z+"{}":m?Z+"{"+L(J,m)+"}":Z+"{ "+J.join(", ")+" }"}return String(t)};var j=Object.prototype.hasOwnProperty||function(e){return e in this};function R(e,t){return j.call(e,t)}function N(e){return y.call(e)}function C(e,t){if(e.indexOf)return e.indexOf(t);for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1}function U(e){var t=e.charCodeAt(0),n={8:"b",9:"t",10:"n",12:"f",13:"r"}[t];return n?"\\"+n:"\\x"+(t<16?"0":"")+t.toString(16).toUpperCase()}function I(e){return"Object("+e+")"}function D(e){return e+" { ? }"}function F(e,t,n,r){return e+" ("+t+") {"+(r?L(n,r):n.join(", "))+"}"}function L(e,t){if(0===e.length)return"";var n="\n"+t.prev+t.base;return n+e.join(","+n)+"\n"+t.prev}function K(e,t){var n=M(e),r=[];if(n){r.length=e.length;for(var i=0;i<e.length;i++)r[i]=R(e,i)?t(e[i],e):""}var o,a="function"==typeof m?m(e):[];if(P){o={};for(var u=0;u<a.length;u++)o["$"+a[u]]=a[u]}for(var s in e)R(e,s)&&(n&&String(Number(s))===s&&s<e.length||P&&o["$"+s]instanceof Symbol||(/[^\w$]/.test(s)?r.push(t(s,e)+": "+t(e[s],e)):r.push(s+": "+t(e[s],e))));if("function"==typeof m)for(var c=0;c<a.length;c++)S.call(e,a[c])&&r.push("["+t(a[c])+"]: "+t(e[a[c]],e));return r}},function(e,t){},function(e,t,n){"use strict";var r=n(29),i=Object.prototype.hasOwnProperty,o=Array.isArray,a={allowDots:!1,allowPrototypes:!1,allowSparse:!1,arrayLimit:20,charset:"utf-8",charsetSentinel:!1,comma:!1,decoder:r.decode,delimiter:"&",depth:5,ignoreQueryPrefix:!1,interpretNumericEntities:!1,parameterLimit:1e3,parseArrays:!0,plainObjects:!1,strictNullHandling:!1},u=function(e){return e.replace(/&#(\d+);/g,(function(e,t){return String.fromCharCode(parseInt(t,10))}))},s=function(e,t){return e&&"string"==typeof e&&t.comma&&e.indexOf(",")>-1?e.split(","):e},c=function(e,t,n,r){if(e){var o=n.allowDots?e.replace(/\.([^.[]+)/g,"[$1]"):e,a=/(\[[^[\]]*])/g,u=n.depth>0&&/(\[[^[\]]*])/.exec(o),c=u?o.slice(0,u.index):o,l=[];if(c){if(!n.plainObjects&&i.call(Object.prototype,c)&&!n.allowPrototypes)return;l.push(c)}for(var f=0;n.depth>0&&null!==(u=a.exec(o))&&f<n.depth;){if(f+=1,!n.plainObjects&&i.call(Object.prototype,u[1].slice(1,-1))&&!n.allowPrototypes)return;l.push(u[1])}return u&&l.push("["+o.slice(u.index)+"]"),function(e,t,n,r){for(var i=r?t:s(t,n),o=e.length-1;o>=0;--o){var a,u=e[o];if("[]"===u&&n.parseArrays)a=[].concat(i);else{a=n.plainObjects?Object.create(null):{};var c="["===u.charAt(0)&&"]"===u.charAt(u.length-1)?u.slice(1,-1):u,l=parseInt(c,10);n.parseArrays||""!==c?!isNaN(l)&&u!==c&&String(l)===c&&l>=0&&n.parseArrays&&l<=n.arrayLimit?(a=[])[l]=i:a[c]=i:a={0:i}}i=a}return i}(l,t,n,r)}};e.exports=function(e,t){var n=function(e){if(!e)return a;if(null!==e.decoder&&void 0!==e.decoder&&"function"!=typeof e.decoder)throw new TypeError("Decoder has to be a function.");if(void 0!==e.charset&&"utf-8"!==e.charset&&"iso-8859-1"!==e.charset)throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");var t=void 0===e.charset?a.charset:e.charset;return{allowDots:void 0===e.allowDots?a.allowDots:!!e.allowDots,allowPrototypes:"boolean"==typeof e.allowPrototypes?e.allowPrototypes:a.allowPrototypes,allowSparse:"boolean"==typeof e.allowSparse?e.allowSparse:a.allowSparse,arrayLimit:"number"==typeof e.arrayLimit?e.arrayLimit:a.arrayLimit,charset:t,charsetSentinel:"boolean"==typeof e.charsetSentinel?e.charsetSentinel:a.charsetSentinel,comma:"boolean"==typeof e.comma?e.comma:a.comma,decoder:"function"==typeof e.decoder?e.decoder:a.decoder,delimiter:"string"==typeof e.delimiter||r.isRegExp(e.delimiter)?e.delimiter:a.delimiter,depth:"number"==typeof e.depth||!1===e.depth?+e.depth:a.depth,ignoreQueryPrefix:!0===e.ignoreQueryPrefix,interpretNumericEntities:"boolean"==typeof e.interpretNumericEntities?e.interpretNumericEntities:a.interpretNumericEntities,parameterLimit:"number"==typeof e.parameterLimit?e.parameterLimit:a.parameterLimit,parseArrays:!1!==e.parseArrays,plainObjects:"boolean"==typeof e.plainObjects?e.plainObjects:a.plainObjects,strictNullHandling:"boolean"==typeof e.strictNullHandling?e.strictNullHandling:a.strictNullHandling}}(t);if(""===e||null==e)return n.plainObjects?Object.create(null):{};for(var l="string"==typeof e?function(e,t){var n,c={},l=t.ignoreQueryPrefix?e.replace(/^\?/,""):e,f=t.parameterLimit===1/0?void 0:t.parameterLimit,d=l.split(t.delimiter,f),p=-1,h=t.charset;if(t.charsetSentinel)for(n=0;n<d.length;++n)0===d[n].indexOf("utf8=")&&("utf8=%E2%9C%93"===d[n]?h="utf-8":"utf8=%26%2310003%3B"===d[n]&&(h="iso-8859-1"),p=n,n=d.length);for(n=0;n<d.length;++n)if(n!==p){var y,g,v=d[n],b=v.indexOf("]="),m=-1===b?v.indexOf("="):b+1;-1===m?(y=t.decoder(v,a.decoder,h,"key"),g=t.strictNullHandling?null:""):(y=t.decoder(v.slice(0,m),a.decoder,h,"key"),g=r.maybeMap(s(v.slice(m+1),t),(function(e){return t.decoder(e,a.decoder,h,"value")}))),g&&t.interpretNumericEntities&&"iso-8859-1"===h&&(g=u(g)),v.indexOf("[]=")>-1&&(g=o(g)?[g]:g),i.call(c,y)?c[y]=r.combine(c[y],g):c[y]=g}return c}(e,n):e,f=n.plainObjects?Object.create(null):{},d=Object.keys(l),p=0;p<d.length;++p){var h=d[p],y=c(h,l[h],n,"string"==typeof e);f=r.merge(f,y,n)}return!0===n.allowSparse?f:r.compact(f)}},function(e,t,n){"use strict";function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var i=n(30);function o(e){if(e)return function(e){for(var t in o.prototype)Object.prototype.hasOwnProperty.call(o.prototype,t)&&(e[t]=o.prototype[t]);return e}(e)}e.exports=o,o.prototype.clearTimeout=function(){return clearTimeout(this._timer),clearTimeout(this._responseTimeoutTimer),clearTimeout(this._uploadTimeoutTimer),delete this._timer,delete this._responseTimeoutTimer,delete this._uploadTimeoutTimer,this},o.prototype.parse=function(e){return this._parser=e,this},o.prototype.responseType=function(e){return this._responseType=e,this},o.prototype.serialize=function(e){return this._serializer=e,this},o.prototype.timeout=function(e){if(!e||"object"!==r(e))return this._timeout=e,this._responseTimeout=0,this._uploadTimeout=0,this;for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t))switch(t){case"deadline":this._timeout=e.deadline;break;case"response":this._responseTimeout=e.response;break;case"upload":this._uploadTimeout=e.upload;break;default:console.warn("Unknown timeout option",t)}return this},o.prototype.retry=function(e,t){return 0!==arguments.length&&!0!==e||(e=1),e<=0&&(e=0),this._maxRetries=e,this._retries=0,this._retryCallback=t,this};var a=new Set(["ETIMEDOUT","ECONNRESET","EADDRINUSE","ECONNREFUSED","EPIPE","ENOTFOUND","ENETUNREACH","EAI_AGAIN"]),u=new Set([408,413,429,500,502,503,504,521,522,524]);o.prototype._shouldRetry=function(e,t){if(!this._maxRetries||this._retries++>=this._maxRetries)return!1;if(this._retryCallback)try{var n=this._retryCallback(e,t);if(!0===n)return!0;if(!1===n)return!1}catch(e){console.error(e)}if(t&&t.status&&u.has(t.status))return!0;if(e){if(e.code&&a.has(e.code))return!0;if(e.timeout&&"ECONNABORTED"===e.code)return!0;if(e.crossDomain)return!0}return!1},o.prototype._retry=function(){return this.clearTimeout(),this.req&&(this.req=null,this.req=this.request()),this._aborted=!1,this.timedout=!1,this.timedoutError=null,this._end()},o.prototype.then=function(e,t){var n=this;if(!this._fullfilledPromise){var r=this;this._endCalled&&console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises"),this._fullfilledPromise=new Promise((function(e,t){r.on("abort",(function(){if(!(n._maxRetries&&n._maxRetries>n._retries))if(n.timedout&&n.timedoutError)t(n.timedoutError);else{var e=new Error("Aborted");e.code="ABORTED",e.status=n.status,e.method=n.method,e.url=n.url,t(e)}})),r.end((function(n,r){n?t(n):e(r)}))}))}return this._fullfilledPromise.then(e,t)},o.prototype.catch=function(e){return this.then(void 0,e)},o.prototype.use=function(e){return e(this),this},o.prototype.ok=function(e){if("function"!=typeof e)throw new Error("Callback required");return this._okCallback=e,this},o.prototype._isResponseOK=function(e){return!!e&&(this._okCallback?this._okCallback(e):e.status>=200&&e.status<300)},o.prototype.get=function(e){return this._header[e.toLowerCase()]},o.prototype.getHeader=o.prototype.get,o.prototype.set=function(e,t){if(i(e)){for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&this.set(n,e[n]);return this}return this._header[e.toLowerCase()]=t,this.header[e]=t,this},o.prototype.unset=function(e){return delete this._header[e.toLowerCase()],delete this.header[e],this},o.prototype.field=function(e,t){if(null==e)throw new Error(".field(name, val) name can not be empty");if(this._data)throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");if(i(e)){for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&this.field(n,e[n]);return this}if(Array.isArray(t)){for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&this.field(e,t[r]);return this}if(null==t)throw new Error(".field(name, val) val can not be empty");return"boolean"==typeof t&&(t=String(t)),this._getFormData().append(e,t),this},o.prototype.abort=function(){return this._aborted||(this._aborted=!0,this.xhr&&this.xhr.abort(),this.req&&this.req.abort(),this.clearTimeout(),this.emit("abort")),this},o.prototype._auth=function(e,t,n,r){switch(n.type){case"basic":this.set("Authorization","Basic ".concat(r("".concat(e,":").concat(t))));break;case"auto":this.username=e,this.password=t;break;case"bearer":this.set("Authorization","Bearer ".concat(e))}return this},o.prototype.withCredentials=function(e){return void 0===e&&(e=!0),this._withCredentials=e,this},o.prototype.redirects=function(e){return this._maxRedirects=e,this},o.prototype.maxResponseSize=function(e){if("number"!=typeof e)throw new TypeError("Invalid argument");return this._maxResponseSize=e,this},o.prototype.toJSON=function(){return{method:this.method,url:this.url,data:this._data,headers:this._header}},o.prototype.send=function(e){var t=i(e),n=this._header["content-type"];if(this._formData)throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");if(t&&!this._data)Array.isArray(e)?this._data=[]:this._isHost(e)||(this._data={});else if(e&&this._data&&this._isHost(this._data))throw new Error("Can't merge these send calls");if(t&&i(this._data))for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(this._data[r]=e[r]);else"string"==typeof e?(n||this.type("form"),(n=this._header["content-type"])&&(n=n.toLowerCase().trim()),this._data="application/x-www-form-urlencoded"===n?this._data?"".concat(this._data,"&").concat(e):e:(this._data||"")+e):this._data=e;return!t||this._isHost(e)||n||this.type("json"),this},o.prototype.sortQuery=function(e){return this._sort=void 0===e||e,this},o.prototype._finalizeQueryString=function(){var e=this._query.join("&");if(e&&(this.url+=(this.url.includes("?")?"&":"?")+e),this._query.length=0,this._sort){var t=this.url.indexOf("?");if(t>=0){var n=this.url.slice(t+1).split("&");"function"==typeof this._sort?n.sort(this._sort):n.sort(),this.url=this.url.slice(0,t)+"?"+n.join("&")}}},o.prototype._appendQueryString=function(){console.warn("Unsupported")},o.prototype._timeoutError=function(e,t,n){if(!this._aborted){var r=new Error("".concat(e+t,"ms exceeded"));r.timeout=t,r.code="ECONNABORTED",r.errno=n,this.timedout=!0,this.timedoutError=r,this.abort(),this.callback(r)}},o.prototype._setTimeouts=function(){var e=this;this._timeout&&!this._timer&&(this._timer=setTimeout((function(){e._timeoutError("Timeout of ",e._timeout,"ETIME")}),this._timeout)),this._responseTimeout&&!this._responseTimeoutTimer&&(this._responseTimeoutTimer=setTimeout((function(){e._timeoutError("Response timeout of ",e._responseTimeout,"ETIMEDOUT")}),this._responseTimeout))}},function(e,t,n){"use strict";var r=n(146);function i(e){if(e)return function(e){for(var t in i.prototype)Object.prototype.hasOwnProperty.call(i.prototype,t)&&(e[t]=i.prototype[t]);return e}(e)}e.exports=i,i.prototype.get=function(e){return this.header[e.toLowerCase()]},i.prototype._setHeaderProperties=function(e){var t=e["content-type"]||"";this.type=r.type(t);var n=r.params(t);for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(this[i]=n[i]);this.links={};try{e.link&&(this.links=r.parseLinks(e.link))}catch(e){}},i.prototype._setStatusProperties=function(e){var t=e/100|0;this.statusCode=e,this.status=this.statusCode,this.statusType=t,this.info=1===t,this.ok=2===t,this.redirect=3===t,this.clientError=4===t,this.serverError=5===t,this.error=(4===t||5===t)&&this.toError(),this.created=201===e,this.accepted=202===e,this.noContent=204===e,this.badRequest=400===e,this.unauthorized=401===e,this.notAcceptable=406===e,this.forbidden=403===e,this.notFound=404===e,this.unprocessableEntity=422===e}},function(e,t,n){"use strict";function r(e,t){var n;if("undefined"==typeof Symbol||null==e[Symbol.iterator]){if(Array.isArray(e)||(n=function(e,t){if(!e)return;if("string"==typeof e)return i(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return i(e,t)}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,u=!0,s=!1;return{s:function(){n=e[Symbol.iterator]()},n:function(){var e=n.next();return u=e.done,e},e:function(e){s=!0,a=e},f:function(){try{u||null==n.return||n.return()}finally{if(s)throw a}}}}function i(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}t.type=function(e){return e.split(/ *; */).shift()},t.params=function(e){var t,n={},i=r(e.split(/ *; */));try{for(i.s();!(t=i.n()).done;){var o=t.value.split(/ *= */),a=o.shift(),u=o.shift();a&&u&&(n[a]=u)}}catch(e){i.e(e)}finally{i.f()}return n},t.parseLinks=function(e){var t,n={},i=r(e.split(/ *, */));try{for(i.s();!(t=i.n()).done;){var o=t.value.split(/ *; */),a=o[0].slice(1,-1);n[o[1].split(/ *= */)[1].slice(1,-1)]=a}}catch(e){i.e(e)}finally{i.f()}return n},t.cleanHeader=function(e,t){return delete e["content-type"],delete e["content-length"],delete e["transfer-encoding"],delete e.host,t&&(delete e.authorization,delete e.cookie),e}},function(e,t,n){"use strict";function r(e){return function(e){if(Array.isArray(e))return i(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return i(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return i(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function i(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function o(){this._defaults=[]}["use","on","once","set","query","type","accept","auth","withCredentials","sortQuery","retry","ok","redirects","timeout","buffer","serialize","parse","ca","key","pfx","cert","disableTLSCerts"].forEach((function(e){o.prototype[e]=function(){for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];return this._defaults.push({fn:e,args:n}),this}})),o.prototype._setDefaults=function(e){this._defaults.forEach((function(t){e[t.fn].apply(e,r(t.args))}))},e.exports=o},function(e,t,n){"use strict";(function(r){var i=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=i(n(11)),a=i(n(12)),u=i(n(5)),s=i(n(6)),c=i(n(4));function l(e,t){var n=new Uint8Array(e.byteLength+t.byteLength);return n.set(new Uint8Array(e),0),n.set(new Uint8Array(t),e.byteLength),n.buffer}var f=function(){function e(){(0,u.default)(this,e)}var t,n,i,c,f,d,p,h,y;return(0,s.default)(e,[{key:"algo",get:function(){return"aes-256-cbc"}},{key:"encrypt",value:(y=(0,a.default)(o.default.mark((function e(t,n){var r;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.getKey(t);case 2:if(r=e.sent,!(n instanceof ArrayBuffer)){e.next=7;break}return e.abrupt("return",this.encryptArrayBuffer(r,n));case 7:if("string"!=typeof n){e.next=11;break}return e.abrupt("return",this.encryptString(r,n));case 11:throw new Error("Cannot encrypt this file. In browsers file encryption supports only string or ArrayBuffer");case 12:case"end":return e.stop()}}),e,this)}))),function(e,t){return y.apply(this,arguments)})},{key:"decrypt",value:(h=(0,a.default)(o.default.mark((function e(t,n){var r;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.getKey(t);case 2:if(r=e.sent,!(n instanceof ArrayBuffer)){e.next=7;break}return e.abrupt("return",this.decryptArrayBuffer(r,n));case 7:if("string"!=typeof n){e.next=11;break}return e.abrupt("return",this.decryptString(r,n));case 11:throw new Error("Cannot decrypt this file. In browsers file decryption supports only string or ArrayBuffer");case 12:case"end":return e.stop()}}),e,this)}))),function(e,t){return h.apply(this,arguments)})},{key:"encryptFile",value:(p=(0,a.default)(o.default.mark((function e(t,n,r){var i,a,u;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.getKey(t);case 2:return i=e.sent,e.next=5,n.toArrayBuffer();case 5:return a=e.sent,e.next=8,this.encryptArrayBuffer(i,a);case 8:return u=e.sent,e.abrupt("return",r.create({name:n.name,mimeType:"application/octet-stream",data:u}));case 10:case"end":return e.stop()}}),e,this)}))),function(e,t,n){return p.apply(this,arguments)})},{key:"decryptFile",value:(d=(0,a.default)(o.default.mark((function e(t,n,r){var i,a,u;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.getKey(t);case 2:return i=e.sent,e.next=5,n.toArrayBuffer();case 5:return a=e.sent,e.next=8,this.decryptArrayBuffer(i,a);case 8:return u=e.sent,e.abrupt("return",r.create({name:n.name,data:u}));case 10:case"end":return e.stop()}}),e,this)}))),function(e,t,n){return d.apply(this,arguments)})},{key:"getKey",value:(f=(0,a.default)(o.default.mark((function e(t){var n,i,a;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=r.from(t),e.next=3,crypto.subtle.digest("SHA-256",n.buffer);case 3:return i=e.sent,a=r.from(r.from(i).toString("hex").slice(0,32),"utf8").buffer,e.abrupt("return",crypto.subtle.importKey("raw",a,"AES-CBC",!0,["encrypt","decrypt"]));case 6:case"end":return e.stop()}}),e)}))),function(e){return f.apply(this,arguments)})},{key:"encryptArrayBuffer",value:(c=(0,a.default)(o.default.mark((function e(t,n){var r;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=crypto.getRandomValues(new Uint8Array(16)),e.t0=l,e.t1=r.buffer,e.next=5,crypto.subtle.encrypt({name:"AES-CBC",iv:r},t,n);case 5:return e.t2=e.sent,e.abrupt("return",(0,e.t0)(e.t1,e.t2));case 7:case"end":return e.stop()}}),e)}))),function(e,t){return c.apply(this,arguments)})},{key:"decryptArrayBuffer",value:(i=(0,a.default)(o.default.mark((function e(t,n){var r;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=n.slice(0,16),e.abrupt("return",crypto.subtle.decrypt({name:"AES-CBC",iv:r},t,n.slice(16)));case 2:case"end":return e.stop()}}),e)}))),function(e,t){return i.apply(this,arguments)})},{key:"encryptString",value:(n=(0,a.default)(o.default.mark((function e(t,n){var i,a,u,s;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return i=crypto.getRandomValues(new Uint8Array(16)),a=r.from(n).buffer,e.next=4,crypto.subtle.encrypt({name:"AES-CBC",iv:i},t,a);case 4:return u=e.sent,s=l(i.buffer,u),e.abrupt("return",r.from(s).toString("utf8"));case 7:case"end":return e.stop()}}),e)}))),function(e,t){return n.apply(this,arguments)})},{key:"decryptString",value:(t=(0,a.default)(o.default.mark((function e(t,n){var i,a,u,s;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return i=r.from(n),a=i.slice(0,16),u=i.slice(16),e.next=5,crypto.subtle.decrypt({name:"AES-CBC",iv:a},t,u);case 5:return s=e.sent,e.abrupt("return",r.from(s).toString("utf8"));case 7:case"end":return e.stop()}}),e)}))),function(e,n){return t.apply(this,arguments)})}]),e}();t.default=f,(0,c.default)(f,"IV_LENGTH",16),e.exports=t.default}).call(this,n(24).Buffer)},function(e,t,n){"use strict";var r=n(0);Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i,o,a=r(n(11)),u=r(n(12)),s=r(n(5)),c=r(n(6)),l=r(n(4)),f=(n(28),o=i=function(){function e(t){if((0,s.default)(this,e),(0,l.default)(this,"data",void 0),(0,l.default)(this,"name",void 0),(0,l.default)(this,"mimeType",void 0),t instanceof File)this.data=t,this.name=this.data.name,this.mimeType=this.data.type;else if(t.data){var n=t.data;this.data=new File([n],t.name,{type:t.mimeType}),this.name=t.name,t.mimeType&&(this.mimeType=t.mimeType)}if(void 0===this.data)throw new Error("Couldn't construct a file out of supplied options.");if(void 0===this.name)throw new Error("Couldn't guess filename out of the options. Please provide one.")}var t,n,r,i,o,f,d;return(0,c.default)(e,[{key:"toBuffer",value:(d=(0,u.default)(a.default.mark((function e(){return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:throw new Error("This feature is only supported in Node.js environments.");case 1:case"end":return e.stop()}}),e)}))),function(){return d.apply(this,arguments)})},{key:"toStream",value:(f=(0,u.default)(a.default.mark((function e(){return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:throw new Error("This feature is only supported in Node.js environments.");case 1:case"end":return e.stop()}}),e)}))),function(){return f.apply(this,arguments)})},{key:"toFileUri",value:(o=(0,u.default)(a.default.mark((function e(){return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:throw new Error("This feature is only supported in react native environments.");case 1:case"end":return e.stop()}}),e)}))),function(){return o.apply(this,arguments)})},{key:"toBlob",value:(i=(0,u.default)(a.default.mark((function e(){return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.data);case 1:case"end":return e.stop()}}),e,this)}))),function(){return i.apply(this,arguments)})},{key:"toArrayBuffer",value:(r=(0,u.default)(a.default.mark((function e(){var t=this;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",new Promise((function(e,n){var r=new FileReader;r.addEventListener("load",(function(){if(r.result instanceof ArrayBuffer)return e(r.result)})),r.addEventListener("error",(function(){n(r.error)})),r.readAsArrayBuffer(t.data)})));case 1:case"end":return e.stop()}}),e)}))),function(){return r.apply(this,arguments)})},{key:"toString",value:(n=(0,u.default)(a.default.mark((function e(){var t=this;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",new Promise((function(e,n){var r=new FileReader;r.addEventListener("load",(function(){if("string"==typeof r.result)return e(r.result)})),r.addEventListener("error",(function(){n(r.error)})),r.readAsBinaryString(t.data)})));case 1:case"end":return e.stop()}}),e)}))),function(){return n.apply(this,arguments)})},{key:"toFile",value:(t=(0,u.default)(a.default.mark((function e(){return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.data);case 1:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})}],[{key:"create",value:function(e){return new this(e)}}]),e}(),(0,l.default)(i,"supportsFile","undefined"!=typeof File),(0,l.default)(i,"supportsBlob","undefined"!=typeof Blob),(0,l.default)(i,"supportsArrayBuffer","undefined"!=typeof ArrayBuffer),(0,l.default)(i,"supportsBuffer",!1),(0,l.default)(i,"supportsStream",!1),(0,l.default)(i,"supportsString",!0),(0,l.default)(i,"supportsEncryptFile",!0),(0,l.default)(i,"supportsFileUri",!1),o);t.default=f,e.exports=t.default}])}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/* eslint-disable node/no-deprecated-api */
	
	'use strict'
	
	var buffer = __webpack_require__(339)
	var Buffer = buffer.Buffer
	
	var safer = {}
	
	var key
	
	for (key in buffer) {
	  if (!buffer.hasOwnProperty(key)) continue
	  if (key === 'SlowBuffer' || key === 'Buffer') continue
	  safer[key] = buffer[key]
	}
	
	var Safer = safer.Buffer = {}
	for (key in Buffer) {
	  if (!Buffer.hasOwnProperty(key)) continue
	  if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue
	  Safer[key] = Buffer[key]
	}
	
	safer.Buffer.prototype = Buffer.prototype
	
	if (!Safer.from || Safer.from === Uint8Array.from) {
	  Safer.from = function (value, encodingOrOffset, length) {
	    if (typeof value === 'number') {
	      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value)
	    }
	    if (value && typeof value.length === 'undefined') {
	      throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value)
	    }
	    return Buffer(value, encodingOrOffset, length)
	  }
	}
	
	if (!Safer.alloc) {
	  Safer.alloc = function (size, fill, encoding) {
	    if (typeof size !== 'number') {
	      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size)
	    }
	    if (size < 0 || size >= 2 * (1 << 30)) {
	      throw new RangeError('The value "' + size + '" is invalid for option "size"')
	    }
	    var buf = Buffer(size)
	    if (!fill || fill.length === 0) {
	      buf.fill(0)
	    } else if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	    return buf
	  }
	}
	
	if (!safer.kStringMaxLength) {
	  try {
	    safer.kStringMaxLength = process.binding('buffer').kStringMaxLength
	  } catch (e) {
	    // we can't determine kStringMaxLength in environments where process.binding
	    // is unsupported, so let's not set it
	  }
	}
	
	if (!safer.constants) {
	  safer.constants = {
	    MAX_LENGTH: safer.kMaxLength
	  }
	  if (safer.kStringMaxLength) {
	    safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength
	  }
	}
	
	module.exports = safer
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(235)))

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1755);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!../sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./daterangepicker.css", function() {
				var newContent = require("!!../css-loader/index.js!../sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./daterangepicker.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */
[2112, 371, 1297, 920],
/* 748 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 749 */
[2111, 372, 1319, 1316, 201, 305, 1330],
/* 750 */
748,
/* 751 */
[2122, 133, 304, 216],
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(753)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 753 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(339).Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


/***/ },
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(1760);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = process.env.DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(235)))

/***/ },
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * FullCalendar v3.10.5
	 * Docs & License: https://fullcalendar.io/
	 * (c) 2019 Adam Shaw
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(8), __webpack_require__(11));
		else if(typeof define === 'function' && define.amd)
			define(["moment", "jquery"], factory);
		else if(typeof exports === 'object')
			exports["FullCalendar"] = factory(require("moment"), require("jquery"));
		else
			root["FullCalendar"] = factory(root["moment"], root["jQuery"]);
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 256);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
	
	/***/ }),
	/* 1 */,
	/* 2 */
	/***/ (function(module, exports) {
	
	/*
	derived from:
	https://github.com/Microsoft/tslib/blob/v1.6.0/tslib.js
	
	only include the helpers we need, to keep down filesize
	*/
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p]; };
	exports.__extends = function (d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(0);
	var $ = __webpack_require__(3);
	/* FullCalendar-specific DOM Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	// Given the scrollbar widths of some other container, create borders/margins on rowEls in order to match the left
	// and right space that was offset by the scrollbars. A 1-pixel border first, then margin beyond that.
	function compensateScroll(rowEls, scrollbarWidths) {
	    if (scrollbarWidths.left) {
	        rowEls.css({
	            'border-left-width': 1,
	            'margin-left': scrollbarWidths.left - 1
	        });
	    }
	    if (scrollbarWidths.right) {
	        rowEls.css({
	            'border-right-width': 1,
	            'margin-right': scrollbarWidths.right - 1
	        });
	    }
	}
	exports.compensateScroll = compensateScroll;
	// Undoes compensateScroll and restores all borders/margins
	function uncompensateScroll(rowEls) {
	    rowEls.css({
	        'margin-left': '',
	        'margin-right': '',
	        'border-left-width': '',
	        'border-right-width': ''
	    });
	}
	exports.uncompensateScroll = uncompensateScroll;
	// Make the mouse cursor express that an event is not allowed in the current area
	function disableCursor() {
	    $('body').addClass('fc-not-allowed');
	}
	exports.disableCursor = disableCursor;
	// Returns the mouse cursor to its original look
	function enableCursor() {
	    $('body').removeClass('fc-not-allowed');
	}
	exports.enableCursor = enableCursor;
	// Given a total available height to fill, have `els` (essentially child rows) expand to accomodate.
	// By default, all elements that are shorter than the recommended height are expanded uniformly, not considering
	// any other els that are already too tall. if `shouldRedistribute` is on, it considers these tall rows and
	// reduces the available height.
	function distributeHeight(els, availableHeight, shouldRedistribute) {
	    // *FLOORING NOTE*: we floor in certain places because zoom can give inaccurate floating-point dimensions,
	    // and it is better to be shorter than taller, to avoid creating unnecessary scrollbars.
	    var minOffset1 = Math.floor(availableHeight / els.length); // for non-last element
	    var minOffset2 = Math.floor(availableHeight - minOffset1 * (els.length - 1)); // for last element *FLOORING NOTE*
	    var flexEls = []; // elements that are allowed to expand. array of DOM nodes
	    var flexOffsets = []; // amount of vertical space it takes up
	    var flexHeights = []; // actual css height
	    var usedHeight = 0;
	    undistributeHeight(els); // give all elements their natural height
	    // find elements that are below the recommended height (expandable).
	    // important to query for heights in a single first pass (to avoid reflow oscillation).
	    els.each(function (i, el) {
	        var minOffset = i === els.length - 1 ? minOffset2 : minOffset1;
	        var naturalOffset = $(el).outerHeight(true);
	        if (naturalOffset < minOffset) {
	            flexEls.push(el);
	            flexOffsets.push(naturalOffset);
	            flexHeights.push($(el).height());
	        }
	        else {
	            // this element stretches past recommended height (non-expandable). mark the space as occupied.
	            usedHeight += naturalOffset;
	        }
	    });
	    // readjust the recommended height to only consider the height available to non-maxed-out rows.
	    if (shouldRedistribute) {
	        availableHeight -= usedHeight;
	        minOffset1 = Math.floor(availableHeight / flexEls.length);
	        minOffset2 = Math.floor(availableHeight - minOffset1 * (flexEls.length - 1)); // *FLOORING NOTE*
	    }
	    // assign heights to all expandable elements
	    $(flexEls).each(function (i, el) {
	        var minOffset = i === flexEls.length - 1 ? minOffset2 : minOffset1;
	        var naturalOffset = flexOffsets[i];
	        var naturalHeight = flexHeights[i];
	        var newHeight = minOffset - (naturalOffset - naturalHeight); // subtract the margin/padding
	        if (naturalOffset < minOffset) { // we check this again because redistribution might have changed things
	            $(el).height(newHeight);
	        }
	    });
	}
	exports.distributeHeight = distributeHeight;
	// Undoes distrubuteHeight, restoring all els to their natural height
	function undistributeHeight(els) {
	    els.height('');
	}
	exports.undistributeHeight = undistributeHeight;
	// Given `els`, a jQuery set of <td> cells, find the cell with the largest natural width and set the widths of all the
	// cells to be that width.
	// PREREQUISITE: if you want a cell to take up width, it needs to have a single inner element w/ display:inline
	function matchCellWidths(els) {
	    var maxInnerWidth = 0;
	    els.find('> *').each(function (i, innerEl) {
	        var innerWidth = $(innerEl).outerWidth();
	        if (innerWidth > maxInnerWidth) {
	            maxInnerWidth = innerWidth;
	        }
	    });
	    maxInnerWidth++; // sometimes not accurate of width the text needs to stay on one line. insurance
	    els.width(maxInnerWidth);
	    return maxInnerWidth;
	}
	exports.matchCellWidths = matchCellWidths;
	// Given one element that resides inside another,
	// Subtracts the height of the inner element from the outer element.
	function subtractInnerElHeight(outerEl, innerEl) {
	    var both = outerEl.add(innerEl);
	    var diff;
	    // effin' IE8/9/10/11 sometimes returns 0 for dimensions. this weird hack was the only thing that worked
	    both.css({
	        position: 'relative',
	        left: -1 // ensure reflow in case the el was already relative. negative is less likely to cause new scroll
	    });
	    diff = outerEl.outerHeight() - innerEl.outerHeight(); // grab the dimensions
	    both.css({ position: '', left: '' }); // undo hack
	    return diff;
	}
	exports.subtractInnerElHeight = subtractInnerElHeight;
	/* Element Geom Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	// borrowed from https://github.com/jquery/jquery-ui/blob/1.11.0/ui/core.js#L51
	function getScrollParent(el) {
	    var position = el.css('position');
	    var scrollParent = el.parents().filter(function () {
	        var parent = $(this);
	        return (/(auto|scroll)/).test(parent.css('overflow') + parent.css('overflow-y') + parent.css('overflow-x'));
	    }).eq(0);
	    return position === 'fixed' || !scrollParent.length ? $(el[0].ownerDocument || document) : scrollParent;
	}
	exports.getScrollParent = getScrollParent;
	// Queries the outer bounding area of a jQuery element.
	// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
	// Origin is optional.
	function getOuterRect(el, origin) {
	    var offset = el.offset();
	    var left = offset.left - (origin ? origin.left : 0);
	    var top = offset.top - (origin ? origin.top : 0);
	    return {
	        left: left,
	        right: left + el.outerWidth(),
	        top: top,
	        bottom: top + el.outerHeight()
	    };
	}
	exports.getOuterRect = getOuterRect;
	// Queries the area within the margin/border/scrollbars of a jQuery element. Does not go within the padding.
	// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
	// Origin is optional.
	// WARNING: given element can't have borders
	// NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
	function getClientRect(el, origin) {
	    var offset = el.offset();
	    var scrollbarWidths = getScrollbarWidths(el);
	    var left = offset.left + getCssFloat(el, 'border-left-width') + scrollbarWidths.left - (origin ? origin.left : 0);
	    var top = offset.top + getCssFloat(el, 'border-top-width') + scrollbarWidths.top - (origin ? origin.top : 0);
	    return {
	        left: left,
	        right: left + el[0].clientWidth,
	        top: top,
	        bottom: top + el[0].clientHeight // clientHeight includes padding but NOT scrollbars
	    };
	}
	exports.getClientRect = getClientRect;
	// Queries the area within the margin/border/padding of a jQuery element. Assumed not to have scrollbars.
	// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
	// Origin is optional.
	function getContentRect(el, origin) {
	    var offset = el.offset(); // just outside of border, margin not included
	    var left = offset.left + getCssFloat(el, 'border-left-width') + getCssFloat(el, 'padding-left') -
	        (origin ? origin.left : 0);
	    var top = offset.top + getCssFloat(el, 'border-top-width') + getCssFloat(el, 'padding-top') -
	        (origin ? origin.top : 0);
	    return {
	        left: left,
	        right: left + el.width(),
	        top: top,
	        bottom: top + el.height()
	    };
	}
	exports.getContentRect = getContentRect;
	// Returns the computed left/right/top/bottom scrollbar widths for the given jQuery element.
	// WARNING: given element can't have borders (which will cause offsetWidth/offsetHeight to be larger).
	// NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
	function getScrollbarWidths(el) {
	    var leftRightWidth = el[0].offsetWidth - el[0].clientWidth;
	    var bottomWidth = el[0].offsetHeight - el[0].clientHeight;
	    var widths;
	    leftRightWidth = sanitizeScrollbarWidth(leftRightWidth);
	    bottomWidth = sanitizeScrollbarWidth(bottomWidth);
	    widths = { left: 0, right: 0, top: 0, bottom: bottomWidth };
	    if (getIsLeftRtlScrollbars() && el.css('direction') === 'rtl') { // is the scrollbar on the left side?
	        widths.left = leftRightWidth;
	    }
	    else {
	        widths.right = leftRightWidth;
	    }
	    return widths;
	}
	exports.getScrollbarWidths = getScrollbarWidths;
	// The scrollbar width computations in getScrollbarWidths are sometimes flawed when it comes to
	// retina displays, rounding, and IE11. Massage them into a usable value.
	function sanitizeScrollbarWidth(width) {
	    width = Math.max(0, width); // no negatives
	    width = Math.round(width);
	    return width;
	}
	// Logic for determining if, when the element is right-to-left, the scrollbar appears on the left side
	var _isLeftRtlScrollbars = null;
	function getIsLeftRtlScrollbars() {
	    if (_isLeftRtlScrollbars === null) {
	        _isLeftRtlScrollbars = computeIsLeftRtlScrollbars();
	    }
	    return _isLeftRtlScrollbars;
	}
	function computeIsLeftRtlScrollbars() {
	    var el = $('<div><div></div></div>')
	        .css({
	        position: 'absolute',
	        top: -1000,
	        left: 0,
	        border: 0,
	        padding: 0,
	        overflow: 'scroll',
	        direction: 'rtl'
	    })
	        .appendTo('body');
	    var innerEl = el.children();
	    var res = innerEl.offset().left > el.offset().left; // is the inner div shifted to accommodate a left scrollbar?
	    el.remove();
	    return res;
	}
	// Retrieves a jQuery element's computed CSS value as a floating-point number.
	// If the queried value is non-numeric (ex: IE can return "medium" for border width), will just return zero.
	function getCssFloat(el, prop) {
	    return parseFloat(el.css(prop)) || 0;
	}
	/* Mouse / Touch Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
	function isPrimaryMouseButton(ev) {
	    return ev.which === 1 && !ev.ctrlKey;
	}
	exports.isPrimaryMouseButton = isPrimaryMouseButton;
	function getEvX(ev) {
	    var touches = ev.originalEvent.touches;
	    // on mobile FF, pageX for touch events is present, but incorrect,
	    // so, look at touch coordinates first.
	    if (touches && touches.length) {
	        return touches[0].pageX;
	    }
	    return ev.pageX;
	}
	exports.getEvX = getEvX;
	function getEvY(ev) {
	    var touches = ev.originalEvent.touches;
	    // on mobile FF, pageX for touch events is present, but incorrect,
	    // so, look at touch coordinates first.
	    if (touches && touches.length) {
	        return touches[0].pageY;
	    }
	    return ev.pageY;
	}
	exports.getEvY = getEvY;
	function getEvIsTouch(ev) {
	    return /^touch/.test(ev.type);
	}
	exports.getEvIsTouch = getEvIsTouch;
	function preventSelection(el) {
	    el.addClass('fc-unselectable')
	        .on('selectstart', preventDefault);
	}
	exports.preventSelection = preventSelection;
	function allowSelection(el) {
	    el.removeClass('fc-unselectable')
	        .off('selectstart', preventDefault);
	}
	exports.allowSelection = allowSelection;
	// Stops a mouse/touch event from doing it's native browser action
	function preventDefault(ev) {
	    ev.preventDefault();
	}
	exports.preventDefault = preventDefault;
	/* General Geometry Utils
	----------------------------------------------------------------------------------------------------------------------*/
	// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
	function intersectRects(rect1, rect2) {
	    var res = {
	        left: Math.max(rect1.left, rect2.left),
	        right: Math.min(rect1.right, rect2.right),
	        top: Math.max(rect1.top, rect2.top),
	        bottom: Math.min(rect1.bottom, rect2.bottom)
	    };
	    if (res.left < res.right && res.top < res.bottom) {
	        return res;
	    }
	    return false;
	}
	exports.intersectRects = intersectRects;
	// Returns a new point that will have been moved to reside within the given rectangle
	function constrainPoint(point, rect) {
	    return {
	        left: Math.min(Math.max(point.left, rect.left), rect.right),
	        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
	    };
	}
	exports.constrainPoint = constrainPoint;
	// Returns a point that is the center of the given rectangle
	function getRectCenter(rect) {
	    return {
	        left: (rect.left + rect.right) / 2,
	        top: (rect.top + rect.bottom) / 2
	    };
	}
	exports.getRectCenter = getRectCenter;
	// Subtracts point2's coordinates from point1's coordinates, returning a delta
	function diffPoints(point1, point2) {
	    return {
	        left: point1.left - point2.left,
	        top: point1.top - point2.top
	    };
	}
	exports.diffPoints = diffPoints;
	/* Object Ordering by Field
	----------------------------------------------------------------------------------------------------------------------*/
	function parseFieldSpecs(input) {
	    var specs = [];
	    var tokens = [];
	    var i;
	    var token;
	    if (typeof input === 'string') {
	        tokens = input.split(/\s*,\s*/);
	    }
	    else if (typeof input === 'function') {
	        tokens = [input];
	    }
	    else if ($.isArray(input)) {
	        tokens = input;
	    }
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        if (typeof token === 'string') {
	            specs.push(token.charAt(0) === '-' ?
	                { field: token.substring(1), order: -1 } :
	                { field: token, order: 1 });
	        }
	        else if (typeof token === 'function') {
	            specs.push({ func: token });
	        }
	    }
	    return specs;
	}
	exports.parseFieldSpecs = parseFieldSpecs;
	function compareByFieldSpecs(obj1, obj2, fieldSpecs, obj1fallback, obj2fallback) {
	    var i;
	    var cmp;
	    for (i = 0; i < fieldSpecs.length; i++) {
	        cmp = compareByFieldSpec(obj1, obj2, fieldSpecs[i], obj1fallback, obj2fallback);
	        if (cmp) {
	            return cmp;
	        }
	    }
	    return 0;
	}
	exports.compareByFieldSpecs = compareByFieldSpecs;
	function compareByFieldSpec(obj1, obj2, fieldSpec, obj1fallback, obj2fallback) {
	    if (fieldSpec.func) {
	        return fieldSpec.func(obj1, obj2);
	    }
	    var val1 = obj1[fieldSpec.field];
	    var val2 = obj2[fieldSpec.field];
	    if (val1 == null && obj1fallback) {
	        val1 = obj1fallback[fieldSpec.field];
	    }
	    if (val2 == null && obj2fallback) {
	        val2 = obj2fallback[fieldSpec.field];
	    }
	    return flexibleCompare(val1, val2) * (fieldSpec.order || 1);
	}
	exports.compareByFieldSpec = compareByFieldSpec;
	function flexibleCompare(a, b) {
	    if (!a && !b) {
	        return 0;
	    }
	    if (b == null) {
	        return -1;
	    }
	    if (a == null) {
	        return 1;
	    }
	    if ($.type(a) === 'string' || $.type(b) === 'string') {
	        return String(a).localeCompare(String(b));
	    }
	    return a - b;
	}
	exports.flexibleCompare = flexibleCompare;
	/* Date Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	exports.dayIDs = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
	exports.unitsDesc = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond']; // descending
	// Diffs the two moments into a Duration where full-days are recorded first, then the remaining time.
	// Moments will have their timezones normalized.
	function diffDayTime(a, b) {
	    return moment.duration({
	        days: a.clone().stripTime().diff(b.clone().stripTime(), 'days'),
	        ms: a.time() - b.time() // time-of-day from day start. disregards timezone
	    });
	}
	exports.diffDayTime = diffDayTime;
	// Diffs the two moments via their start-of-day (regardless of timezone). Produces whole-day durations.
	function diffDay(a, b) {
	    return moment.duration({
	        days: a.clone().stripTime().diff(b.clone().stripTime(), 'days')
	    });
	}
	exports.diffDay = diffDay;
	// Diffs two moments, producing a duration, made of a whole-unit-increment of the given unit. Uses rounding.
	function diffByUnit(a, b, unit) {
	    return moment.duration(Math.round(a.diff(b, unit, true)), // returnFloat=true
	    unit);
	}
	exports.diffByUnit = diffByUnit;
	// Computes the unit name of the largest whole-unit period of time.
	// For example, 48 hours will be "days" whereas 49 hours will be "hours".
	// Accepts start/end, a range object, or an original duration object.
	function computeGreatestUnit(start, end) {
	    var i;
	    var unit;
	    var val;
	    for (i = 0; i < exports.unitsDesc.length; i++) {
	        unit = exports.unitsDesc[i];
	        val = computeRangeAs(unit, start, end);
	        if (val >= 1 && isInt(val)) {
	            break;
	        }
	    }
	    return unit; // will be "milliseconds" if nothing else matches
	}
	exports.computeGreatestUnit = computeGreatestUnit;
	// like computeGreatestUnit, but has special abilities to interpret the source input for clues
	function computeDurationGreatestUnit(duration, durationInput) {
	    var unit = computeGreatestUnit(duration);
	    // prevent days:7 from being interpreted as a week
	    if (unit === 'week' && typeof durationInput === 'object' && durationInput.days) {
	        unit = 'day';
	    }
	    return unit;
	}
	exports.computeDurationGreatestUnit = computeDurationGreatestUnit;
	// Computes the number of units (like "hours") in the given range.
	// Range can be a {start,end} object, separate start/end args, or a Duration.
	// Results are based on Moment's .as() and .diff() methods, so results can depend on internal handling
	// of month-diffing logic (which tends to vary from version to version).
	function computeRangeAs(unit, start, end) {
	    if (end != null) { // given start, end
	        return end.diff(start, unit, true);
	    }
	    else if (moment.isDuration(start)) { // given duration
	        return start.as(unit);
	    }
	    else { // given { start, end } range object
	        return start.end.diff(start.start, unit, true);
	    }
	}
	// Intelligently divides a range (specified by a start/end params) by a duration
	function divideRangeByDuration(start, end, dur) {
	    var months;
	    if (durationHasTime(dur)) {
	        return (end - start) / dur;
	    }
	    months = dur.asMonths();
	    if (Math.abs(months) >= 1 && isInt(months)) {
	        return end.diff(start, 'months', true) / months;
	    }
	    return end.diff(start, 'days', true) / dur.asDays();
	}
	exports.divideRangeByDuration = divideRangeByDuration;
	// Intelligently divides one duration by another
	function divideDurationByDuration(dur1, dur2) {
	    var months1;
	    var months2;
	    if (durationHasTime(dur1) || durationHasTime(dur2)) {
	        return dur1 / dur2;
	    }
	    months1 = dur1.asMonths();
	    months2 = dur2.asMonths();
	    if (Math.abs(months1) >= 1 && isInt(months1) &&
	        Math.abs(months2) >= 1 && isInt(months2)) {
	        return months1 / months2;
	    }
	    return dur1.asDays() / dur2.asDays();
	}
	exports.divideDurationByDuration = divideDurationByDuration;
	// Intelligently multiplies a duration by a number
	function multiplyDuration(dur, n) {
	    var months;
	    if (durationHasTime(dur)) {
	        return moment.duration(dur * n);
	    }
	    months = dur.asMonths();
	    if (Math.abs(months) >= 1 && isInt(months)) {
	        return moment.duration({ months: months * n });
	    }
	    return moment.duration({ days: dur.asDays() * n });
	}
	exports.multiplyDuration = multiplyDuration;
	// Returns a boolean about whether the given duration has any time parts (hours/minutes/seconds/ms)
	function durationHasTime(dur) {
	    return Boolean(dur.hours() || dur.minutes() || dur.seconds() || dur.milliseconds());
	}
	exports.durationHasTime = durationHasTime;
	function isNativeDate(input) {
	    return Object.prototype.toString.call(input) === '[object Date]' || input instanceof Date;
	}
	exports.isNativeDate = isNativeDate;
	// Returns a boolean about whether the given input is a time string, like "06:40:00" or "06:00"
	function isTimeString(str) {
	    return typeof str === 'string' &&
	        /^\d+\:\d+(?:\:\d+\.?(?:\d{3})?)?$/.test(str);
	}
	exports.isTimeString = isTimeString;
	/* Logging and Debug
	----------------------------------------------------------------------------------------------------------------------*/
	function log() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var console = window.console;
	    if (console && console.log) {
	        return console.log.apply(console, args);
	    }
	}
	exports.log = log;
	function warn() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var console = window.console;
	    if (console && console.warn) {
	        return console.warn.apply(console, args);
	    }
	    else {
	        return log.apply(null, args);
	    }
	}
	exports.warn = warn;
	/* General Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	var hasOwnPropMethod = {}.hasOwnProperty;
	// Merges an array of objects into a single object.
	// The second argument allows for an array of property names who's object values will be merged together.
	function mergeProps(propObjs, complexProps) {
	    var dest = {};
	    var i;
	    var name;
	    var complexObjs;
	    var j;
	    var val;
	    var props;
	    if (complexProps) {
	        for (i = 0; i < complexProps.length; i++) {
	            name = complexProps[i];
	            complexObjs = [];
	            // collect the trailing object values, stopping when a non-object is discovered
	            for (j = propObjs.length - 1; j >= 0; j--) {
	                val = propObjs[j][name];
	                if (typeof val === 'object') {
	                    complexObjs.unshift(val);
	                }
	                else if (val !== undefined) {
	                    dest[name] = val; // if there were no objects, this value will be used
	                    break;
	                }
	            }
	            // if the trailing values were objects, use the merged value
	            if (complexObjs.length) {
	                dest[name] = mergeProps(complexObjs);
	            }
	        }
	    }
	    // copy values into the destination, going from last to first
	    for (i = propObjs.length - 1; i >= 0; i--) {
	        props = propObjs[i];
	        for (name in props) {
	            if (!(name in dest)) { // if already assigned by previous props or complex props, don't reassign
	                dest[name] = props[name];
	            }
	        }
	    }
	    return dest;
	}
	exports.mergeProps = mergeProps;
	function copyOwnProps(src, dest) {
	    for (var name_1 in src) {
	        if (hasOwnProp(src, name_1)) {
	            dest[name_1] = src[name_1];
	        }
	    }
	}
	exports.copyOwnProps = copyOwnProps;
	function hasOwnProp(obj, name) {
	    return hasOwnPropMethod.call(obj, name);
	}
	exports.hasOwnProp = hasOwnProp;
	function applyAll(functions, thisObj, args) {
	    if ($.isFunction(functions)) {
	        functions = [functions];
	    }
	    if (functions) {
	        var i = void 0;
	        var ret = void 0;
	        for (i = 0; i < functions.length; i++) {
	            ret = functions[i].apply(thisObj, args) || ret;
	        }
	        return ret;
	    }
	}
	exports.applyAll = applyAll;
	function removeMatching(array, testFunc) {
	    var removeCnt = 0;
	    var i = 0;
	    while (i < array.length) {
	        if (testFunc(array[i])) { // truthy value means *remove*
	            array.splice(i, 1);
	            removeCnt++;
	        }
	        else {
	            i++;
	        }
	    }
	    return removeCnt;
	}
	exports.removeMatching = removeMatching;
	function removeExact(array, exactVal) {
	    var removeCnt = 0;
	    var i = 0;
	    while (i < array.length) {
	        if (array[i] === exactVal) {
	            array.splice(i, 1);
	            removeCnt++;
	        }
	        else {
	            i++;
	        }
	    }
	    return removeCnt;
	}
	exports.removeExact = removeExact;
	function isArraysEqual(a0, a1) {
	    var len = a0.length;
	    var i;
	    if (len == null || len !== a1.length) { // not array? or not same length?
	        return false;
	    }
	    for (i = 0; i < len; i++) {
	        if (a0[i] !== a1[i]) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.isArraysEqual = isArraysEqual;
	function firstDefined() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    for (var i = 0; i < args.length; i++) {
	        if (args[i] !== undefined) {
	            return args[i];
	        }
	    }
	}
	exports.firstDefined = firstDefined;
	function htmlEscape(s) {
	    return (s + '').replace(/&/g, '&amp;')
	        .replace(/</g, '&lt;')
	        .replace(/>/g, '&gt;')
	        .replace(/'/g, '&#039;')
	        .replace(/"/g, '&quot;')
	        .replace(/\n/g, '<br>');
	}
	exports.htmlEscape = htmlEscape;
	function stripHtmlEntities(text) {
	    return text.replace(/&.*?;/g, '');
	}
	exports.stripHtmlEntities = stripHtmlEntities;
	// Given a hash of CSS properties, returns a string of CSS.
	// Uses property names as-is (no camel-case conversion). Will not make statements for null/undefined values.
	function cssToStr(cssProps) {
	    var statements = [];
	    $.each(cssProps, function (name, val) {
	        if (val != null) {
	            statements.push(name + ':' + val);
	        }
	    });
	    return statements.join(';');
	}
	exports.cssToStr = cssToStr;
	// Given an object hash of HTML attribute names to values,
	// generates a string that can be injected between < > in HTML
	function attrsToStr(attrs) {
	    var parts = [];
	    $.each(attrs, function (name, val) {
	        if (val != null) {
	            parts.push(name + '="' + htmlEscape(val) + '"');
	        }
	    });
	    return parts.join(' ');
	}
	exports.attrsToStr = attrsToStr;
	function capitaliseFirstLetter(str) {
	    return str.charAt(0).toUpperCase() + str.slice(1);
	}
	exports.capitaliseFirstLetter = capitaliseFirstLetter;
	function compareNumbers(a, b) {
	    return a - b;
	}
	exports.compareNumbers = compareNumbers;
	function isInt(n) {
	    return n % 1 === 0;
	}
	exports.isInt = isInt;
	// Returns a method bound to the given object context.
	// Just like one of the jQuery.proxy signatures, but without the undesired behavior of treating the same method with
	// different contexts as identical when binding/unbinding events.
	function proxy(obj, methodName) {
	    var method = obj[methodName];
	    return function () {
	        return method.apply(obj, arguments);
	    };
	}
	exports.proxy = proxy;
	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	// https://github.com/jashkenas/underscore/blob/1.6.0/underscore.js#L714
	function debounce(func, wait, immediate) {
	    if (immediate === void 0) { immediate = false; }
	    var timeout;
	    var args;
	    var context;
	    var timestamp;
	    var result;
	    var later = function () {
	        var last = +new Date() - timestamp;
	        if (last < wait) {
	            timeout = setTimeout(later, wait - last);
	        }
	        else {
	            timeout = null;
	            if (!immediate) {
	                result = func.apply(context, args);
	                context = args = null;
	            }
	        }
	    };
	    return function () {
	        context = this;
	        args = arguments;
	        timestamp = +new Date();
	        var callNow = immediate && !timeout;
	        if (!timeout) {
	            timeout = setTimeout(later, wait);
	        }
	        if (callNow) {
	            result = func.apply(context, args);
	            context = args = null;
	        }
	        return result;
	    };
	}
	exports.debounce = debounce;
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(0);
	var moment_ext_1 = __webpack_require__(11);
	var UnzonedRange = /** @class */ (function () {
	    function UnzonedRange(startInput, endInput) {
	        // TODO: move these into footprint.
	        // Especially, doesn't make sense for null startMs/endMs.
	        this.isStart = true;
	        this.isEnd = true;
	        if (moment.isMoment(startInput)) {
	            startInput = startInput.clone().stripZone();
	        }
	        if (moment.isMoment(endInput)) {
	            endInput = endInput.clone().stripZone();
	        }
	        if (startInput) {
	            this.startMs = startInput.valueOf();
	        }
	        if (endInput) {
	            this.endMs = endInput.valueOf();
	        }
	    }
	    /*
	    SIDEEFFECT: will mutate eventRanges.
	    Will return a new array result.
	    Only works for non-open-ended ranges.
	    */
	    UnzonedRange.invertRanges = function (ranges, constraintRange) {
	        var invertedRanges = [];
	        var startMs = constraintRange.startMs; // the end of the previous range. the start of the new range
	        var i;
	        var dateRange;
	        // ranges need to be in order. required for our date-walking algorithm
	        ranges.sort(compareUnzonedRanges);
	        for (i = 0; i < ranges.length; i++) {
	            dateRange = ranges[i];
	            // add the span of time before the event (if there is any)
	            if (dateRange.startMs > startMs) { // compare millisecond time (skip any ambig logic)
	                invertedRanges.push(new UnzonedRange(startMs, dateRange.startMs));
	            }
	            if (dateRange.endMs > startMs) {
	                startMs = dateRange.endMs;
	            }
	        }
	        // add the span of time after the last event (if there is any)
	        if (startMs < constraintRange.endMs) { // compare millisecond time (skip any ambig logic)
	            invertedRanges.push(new UnzonedRange(startMs, constraintRange.endMs));
	        }
	        return invertedRanges;
	    };
	    UnzonedRange.prototype.intersect = function (otherRange) {
	        var startMs = this.startMs;
	        var endMs = this.endMs;
	        var newRange = null;
	        if (otherRange.startMs != null) {
	            if (startMs == null) {
	                startMs = otherRange.startMs;
	            }
	            else {
	                startMs = Math.max(startMs, otherRange.startMs);
	            }
	        }
	        if (otherRange.endMs != null) {
	            if (endMs == null) {
	                endMs = otherRange.endMs;
	            }
	            else {
	                endMs = Math.min(endMs, otherRange.endMs);
	            }
	        }
	        if (startMs == null || endMs == null || startMs < endMs) {
	            newRange = new UnzonedRange(startMs, endMs);
	            newRange.isStart = this.isStart && startMs === this.startMs;
	            newRange.isEnd = this.isEnd && endMs === this.endMs;
	        }
	        return newRange;
	    };
	    UnzonedRange.prototype.intersectsWith = function (otherRange) {
	        return (this.endMs == null || otherRange.startMs == null || this.endMs > otherRange.startMs) &&
	            (this.startMs == null || otherRange.endMs == null || this.startMs < otherRange.endMs);
	    };
	    UnzonedRange.prototype.containsRange = function (innerRange) {
	        return (this.startMs == null || (innerRange.startMs != null && innerRange.startMs >= this.startMs)) &&
	            (this.endMs == null || (innerRange.endMs != null && innerRange.endMs <= this.endMs));
	    };
	    // `date` can be a moment, a Date, or a millisecond time.
	    UnzonedRange.prototype.containsDate = function (date) {
	        var ms = date.valueOf();
	        return (this.startMs == null || ms >= this.startMs) &&
	            (this.endMs == null || ms < this.endMs);
	    };
	    // If the given date is not within the given range, move it inside.
	    // (If it's past the end, make it one millisecond before the end).
	    // `date` can be a moment, a Date, or a millisecond time.
	    // Returns a MS-time.
	    UnzonedRange.prototype.constrainDate = function (date) {
	        var ms = date.valueOf();
	        if (this.startMs != null && ms < this.startMs) {
	            ms = this.startMs;
	        }
	        if (this.endMs != null && ms >= this.endMs) {
	            ms = this.endMs - 1;
	        }
	        return ms;
	    };
	    UnzonedRange.prototype.equals = function (otherRange) {
	        return this.startMs === otherRange.startMs && this.endMs === otherRange.endMs;
	    };
	    UnzonedRange.prototype.clone = function () {
	        var range = new UnzonedRange(this.startMs, this.endMs);
	        range.isStart = this.isStart;
	        range.isEnd = this.isEnd;
	        return range;
	    };
	    // Returns an ambig-zoned moment from startMs.
	    // BEWARE: returned moment is not localized.
	    // Formatting and start-of-week will be default.
	    UnzonedRange.prototype.getStart = function () {
	        if (this.startMs != null) {
	            return moment_ext_1.default.utc(this.startMs).stripZone();
	        }
	        return null;
	    };
	    // Returns an ambig-zoned moment from startMs.
	    // BEWARE: returned moment is not localized.
	    // Formatting and start-of-week will be default.
	    UnzonedRange.prototype.getEnd = function () {
	        if (this.endMs != null) {
	            return moment_ext_1.default.utc(this.endMs).stripZone();
	        }
	        return null;
	    };
	    UnzonedRange.prototype.as = function (unit) {
	        return moment.utc(this.endMs).diff(moment.utc(this.startMs), unit, true);
	    };
	    return UnzonedRange;
	}());
	exports.default = UnzonedRange;
	/*
	Only works for non-open-ended ranges.
	*/
	function compareUnzonedRanges(range1, range2) {
	    return range1.startMs - range2.startMs; // earlier ranges go first
	}
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var ParsableModelMixin_1 = __webpack_require__(52);
	var Class_1 = __webpack_require__(35);
	var EventDefParser_1 = __webpack_require__(36);
	var EventSource = /** @class */ (function (_super) {
	    tslib_1.__extends(EventSource, _super);
	    // can we do away with calendar? at least for the abstract?
	    // useful for buildEventDef
	    function EventSource(calendar) {
	        var _this = _super.call(this) || this;
	        _this.calendar = calendar;
	        _this.className = [];
	        _this.uid = String(EventSource.uuid++);
	        return _this;
	    }
	    /*
	    rawInput can be any data type!
	    */
	    EventSource.parse = function (rawInput, calendar) {
	        var source = new this(calendar);
	        if (typeof rawInput === 'object') {
	            if (source.applyProps(rawInput)) {
	                return source;
	            }
	        }
	        return false;
	    };
	    EventSource.normalizeId = function (id) {
	        if (id) {
	            return String(id);
	        }
	        return null;
	    };
	    EventSource.prototype.fetch = function (start, end, timezone) {
	        // subclasses must implement. must return a promise.
	    };
	    EventSource.prototype.removeEventDefsById = function (eventDefId) {
	        // optional for subclasses to implement
	    };
	    EventSource.prototype.removeAllEventDefs = function () {
	        // optional for subclasses to implement
	    };
	    /*
	    For compairing/matching
	    */
	    EventSource.prototype.getPrimitive = function (otherSource) {
	        // subclasses must implement
	    };
	    EventSource.prototype.parseEventDefs = function (rawEventDefs) {
	        var i;
	        var eventDef;
	        var eventDefs = [];
	        for (i = 0; i < rawEventDefs.length; i++) {
	            eventDef = this.parseEventDef(rawEventDefs[i]);
	            if (eventDef) {
	                eventDefs.push(eventDef);
	            }
	        }
	        return eventDefs;
	    };
	    EventSource.prototype.parseEventDef = function (rawInput) {
	        var calendarTransform = this.calendar.opt('eventDataTransform');
	        var sourceTransform = this.eventDataTransform;
	        if (calendarTransform) {
	            rawInput = calendarTransform(rawInput, this.calendar);
	        }
	        if (sourceTransform) {
	            rawInput = sourceTransform(rawInput, this.calendar);
	        }
	        return EventDefParser_1.default.parse(rawInput, this);
	    };
	    EventSource.prototype.applyManualStandardProps = function (rawProps) {
	        if (rawProps.id != null) {
	            this.id = EventSource.normalizeId(rawProps.id);
	        }
	        // TODO: converge with EventDef
	        if ($.isArray(rawProps.className)) {
	            this.className = rawProps.className;
	        }
	        else if (typeof rawProps.className === 'string') {
	            this.className = rawProps.className.split(/\s+/);
	        }
	        return true;
	    };
	    EventSource.uuid = 0;
	    EventSource.defineStandardProps = ParsableModelMixin_1.default.defineStandardProps;
	    EventSource.copyVerbatimStandardProps = ParsableModelMixin_1.default.copyVerbatimStandardProps;
	    return EventSource;
	}(Class_1.default));
	exports.default = EventSource;
	ParsableModelMixin_1.default.mixInto(EventSource);
	// Parsing
	// ---------------------------------------------------------------------------------------------------------------------
	EventSource.defineStandardProps({
	    // manually process...
	    id: false,
	    className: false,
	    // automatically transfer...
	    color: true,
	    backgroundColor: true,
	    borderColor: true,
	    textColor: true,
	    editable: true,
	    startEditable: true,
	    durationEditable: true,
	    rendering: true,
	    overlap: true,
	    constraint: true,
	    allDayDefault: true,
	    eventDataTransform: true
	});
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/*
	Utility methods for easily listening to events on another object,
	and more importantly, easily unlistening from them.
	
	USAGE:
	  import { default as ListenerMixin, ListenerInterface } from './ListenerMixin'
	in class:
	  listenTo: ListenerInterface['listenTo']
	  stopListeningTo: ListenerInterface['stopListeningTo']
	after class:
	  ListenerMixin.mixInto(TheClass)
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var Mixin_1 = __webpack_require__(15);
	var guid = 0;
	var ListenerMixin = /** @class */ (function (_super) {
	    tslib_1.__extends(ListenerMixin, _super);
	    function ListenerMixin() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /*
	    Given an `other` object that has on/off methods, bind the given `callback` to an event by the given name.
	    The `callback` will be called with the `this` context of the object that .listenTo is being called on.
	    Can be called:
	      .listenTo(other, eventName, callback)
	    OR
	      .listenTo(other, {
	        eventName1: callback1,
	        eventName2: callback2
	      })
	    */
	    ListenerMixin.prototype.listenTo = function (other, arg, callback) {
	        if (typeof arg === 'object') { // given dictionary of callbacks
	            for (var eventName in arg) {
	                if (arg.hasOwnProperty(eventName)) {
	                    this.listenTo(other, eventName, arg[eventName]);
	                }
	            }
	        }
	        else if (typeof arg === 'string') {
	            other.on(arg + '.' + this.getListenerNamespace(), // use event namespacing to identify this object
	            $.proxy(callback, this) // always use `this` context
	            // the usually-undesired jQuery guid behavior doesn't matter,
	            // because we always unbind via namespace
	            );
	        }
	    };
	    /*
	    Causes the current object to stop listening to events on the `other` object.
	    `eventName` is optional. If omitted, will stop listening to ALL events on `other`.
	    */
	    ListenerMixin.prototype.stopListeningTo = function (other, eventName) {
	        other.off((eventName || '') + '.' + this.getListenerNamespace());
	    };
	    /*
	    Returns a string, unique to this object, to be used for event namespacing
	    */
	    ListenerMixin.prototype.getListenerNamespace = function () {
	        if (this.listenerId == null) {
	            this.listenerId = guid++;
	        }
	        return '_listener' + this.listenerId;
	    };
	    return ListenerMixin;
	}(Mixin_1.default));
	exports.default = ListenerMixin;
	
	
	/***/ }),
	/* 8 */,
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var EventDef_1 = __webpack_require__(37);
	var EventInstance_1 = __webpack_require__(53);
	var EventDateProfile_1 = __webpack_require__(16);
	var SingleEventDef = /** @class */ (function (_super) {
	    tslib_1.__extends(SingleEventDef, _super);
	    function SingleEventDef() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /*
	    Will receive start/end params, but will be ignored.
	    */
	    SingleEventDef.prototype.buildInstances = function () {
	        return [this.buildInstance()];
	    };
	    SingleEventDef.prototype.buildInstance = function () {
	        return new EventInstance_1.default(this, // definition
	        this.dateProfile);
	    };
	    SingleEventDef.prototype.isAllDay = function () {
	        return this.dateProfile.isAllDay();
	    };
	    SingleEventDef.prototype.clone = function () {
	        var def = _super.prototype.clone.call(this);
	        def.dateProfile = this.dateProfile;
	        return def;
	    };
	    SingleEventDef.prototype.rezone = function () {
	        var calendar = this.source.calendar;
	        var dateProfile = this.dateProfile;
	        this.dateProfile = new EventDateProfile_1.default(calendar.moment(dateProfile.start), dateProfile.end ? calendar.moment(dateProfile.end) : null, calendar);
	    };
	    /*
	    NOTE: if super-method fails, should still attempt to apply
	    */
	    SingleEventDef.prototype.applyManualStandardProps = function (rawProps) {
	        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
	        var dateProfile = EventDateProfile_1.default.parse(rawProps, this.source); // returns null on failure
	        if (dateProfile) {
	            this.dateProfile = dateProfile;
	            // make sure `date` shows up in the legacy event objects as-is
	            if (rawProps.date != null) {
	                this.miscProps.date = rawProps.date;
	            }
	            return superSuccess;
	        }
	        else {
	            return false;
	        }
	    };
	    return SingleEventDef;
	}(EventDef_1.default));
	exports.default = SingleEventDef;
	// Parsing
	// ---------------------------------------------------------------------------------------------------------------------
	SingleEventDef.defineStandardProps({
	    start: false,
	    date: false,
	    end: false,
	    allDay: false
	});
	
	
	/***/ }),
	/* 10 */,
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(0);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var ambigDateOfMonthRegex = /^\s*\d{4}-\d\d$/;
	var ambigTimeOrZoneRegex = /^\s*\d{4}-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?)?$/;
	var newMomentProto = moment.fn; // where we will attach our new methods
	exports.newMomentProto = newMomentProto;
	var oldMomentProto = $.extend({}, newMomentProto); // copy of original moment methods
	exports.oldMomentProto = oldMomentProto;
	// tell momentjs to transfer these properties upon clone
	var momentProperties = moment.momentProperties;
	momentProperties.push('_fullCalendar');
	momentProperties.push('_ambigTime');
	momentProperties.push('_ambigZone');
	/*
	Call this if you want Moment's original format method to be used
	*/
	function oldMomentFormat(mom, formatStr) {
	    return oldMomentProto.format.call(mom, formatStr); // oldMomentProto defined in moment-ext.js
	}
	exports.oldMomentFormat = oldMomentFormat;
	// Creating
	// -------------------------------------------------------------------------------------------------
	// Creates a new moment, similar to the vanilla moment(...) constructor, but with
	// extra features (ambiguous time, enhanced formatting). When given an existing moment,
	// it will function as a clone (and retain the zone of the moment). Anything else will
	// result in a moment in the local zone.
	var momentExt = function () {
	    return makeMoment(arguments);
	};
	exports.default = momentExt;
	// Sames as momentExt, but forces the resulting moment to be in the UTC timezone.
	momentExt.utc = function () {
	    var mom = makeMoment(arguments, true);
	    // Force it into UTC because makeMoment doesn't guarantee it
	    // (if given a pre-existing moment for example)
	    if (mom.hasTime()) { // don't give ambiguously-timed moments a UTC zone
	        mom.utc();
	    }
	    return mom;
	};
	// Same as momentExt, but when given an ISO8601 string, the timezone offset is preserved.
	// ISO8601 strings with no timezone offset will become ambiguously zoned.
	momentExt.parseZone = function () {
	    return makeMoment(arguments, true, true);
	};
	// Builds an enhanced moment from args. When given an existing moment, it clones. When given a
	// native Date, or called with no arguments (the current time), the resulting moment will be local.
	// Anything else needs to be "parsed" (a string or an array), and will be affected by:
	//    parseAsUTC - if there is no zone information, should we parse the input in UTC?
	//    parseZone - if there is zone information, should we force the zone of the moment?
	function makeMoment(args, parseAsUTC, parseZone) {
	    if (parseAsUTC === void 0) { parseAsUTC = false; }
	    if (parseZone === void 0) { parseZone = false; }
	    var input = args[0];
	    var isSingleString = args.length === 1 && typeof input === 'string';
	    var isAmbigTime;
	    var isAmbigZone;
	    var ambigMatch;
	    var mom;
	    if (moment.isMoment(input) || util_1.isNativeDate(input) || input === undefined) {
	        mom = moment.apply(null, args);
	    }
	    else { // "parsing" is required
	        isAmbigTime = false;
	        isAmbigZone = false;
	        if (isSingleString) {
	            if (ambigDateOfMonthRegex.test(input)) {
	                // accept strings like '2014-05', but convert to the first of the month
	                input += '-01';
	                args = [input]; // for when we pass it on to moment's constructor
	                isAmbigTime = true;
	                isAmbigZone = true;
	            }
	            else if ((ambigMatch = ambigTimeOrZoneRegex.exec(input))) {
	                isAmbigTime = !ambigMatch[5]; // no time part?
	                isAmbigZone = true;
	            }
	        }
	        else if ($.isArray(input)) {
	            // arrays have no timezone information, so assume ambiguous zone
	            isAmbigZone = true;
	        }
	        // otherwise, probably a string with a format
	        if (parseAsUTC || isAmbigTime) {
	            mom = moment.utc.apply(moment, args);
	        }
	        else {
	            mom = moment.apply(null, args);
	        }
	        if (isAmbigTime) {
	            mom._ambigTime = true;
	            mom._ambigZone = true; // ambiguous time always means ambiguous zone
	        }
	        else if (parseZone) { // let's record the inputted zone somehow
	            if (isAmbigZone) {
	                mom._ambigZone = true;
	            }
	            else if (isSingleString) {
	                mom.utcOffset(input); // if not a valid zone, will assign UTC
	            }
	        }
	    }
	    mom._fullCalendar = true; // flag for extended functionality
	    return mom;
	}
	// Week Number
	// -------------------------------------------------------------------------------------------------
	// Returns the week number, considering the locale's custom week number calcuation
	// `weeks` is an alias for `week`
	newMomentProto.week = newMomentProto.weeks = function (input) {
	    var weekCalc = this._locale._fullCalendar_weekCalc;
	    if (input == null && typeof weekCalc === 'function') { // custom function only works for getter
	        return weekCalc(this);
	    }
	    else if (weekCalc === 'ISO') {
	        return oldMomentProto.isoWeek.apply(this, arguments); // ISO getter/setter
	    }
	    return oldMomentProto.week.apply(this, arguments); // local getter/setter
	};
	// Time-of-day
	// -------------------------------------------------------------------------------------------------
	// GETTER
	// Returns a Duration with the hours/minutes/seconds/ms values of the moment.
	// If the moment has an ambiguous time, a duration of 00:00 will be returned.
	//
	// SETTER
	// You can supply a Duration, a Moment, or a Duration-like argument.
	// When setting the time, and the moment has an ambiguous time, it then becomes unambiguous.
	newMomentProto.time = function (time) {
	    // Fallback to the original method (if there is one) if this moment wasn't created via FullCalendar.
	    // `time` is a generic enough method name where this precaution is necessary to avoid collisions w/ other plugins.
	    if (!this._fullCalendar) {
	        return oldMomentProto.time.apply(this, arguments);
	    }
	    if (time == null) { // getter
	        return moment.duration({
	            hours: this.hours(),
	            minutes: this.minutes(),
	            seconds: this.seconds(),
	            milliseconds: this.milliseconds()
	        });
	    }
	    else { // setter
	        this._ambigTime = false; // mark that the moment now has a time
	        if (!moment.isDuration(time) && !moment.isMoment(time)) {
	            time = moment.duration(time);
	        }
	        // The day value should cause overflow (so 24 hours becomes 00:00:00 of next day).
	        // Only for Duration times, not Moment times.
	        var dayHours = 0;
	        if (moment.isDuration(time)) {
	            dayHours = Math.floor(time.asDays()) * 24;
	        }
	        // We need to set the individual fields.
	        // Can't use startOf('day') then add duration. In case of DST at start of day.
	        return this.hours(dayHours + time.hours())
	            .minutes(time.minutes())
	            .seconds(time.seconds())
	            .milliseconds(time.milliseconds());
	    }
	};
	// Converts the moment to UTC, stripping out its time-of-day and timezone offset,
	// but preserving its YMD. A moment with a stripped time will display no time
	// nor timezone offset when .format() is called.
	newMomentProto.stripTime = function () {
	    if (!this._ambigTime) {
	        this.utc(true); // keepLocalTime=true (for keeping *date* value)
	        // set time to zero
	        this.set({
	            hours: 0,
	            minutes: 0,
	            seconds: 0,
	            ms: 0
	        });
	        // Mark the time as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
	        // which clears all ambig flags.
	        this._ambigTime = true;
	        this._ambigZone = true; // if ambiguous time, also ambiguous timezone offset
	    }
	    return this; // for chaining
	};
	// Returns if the moment has a non-ambiguous time (boolean)
	newMomentProto.hasTime = function () {
	    return !this._ambigTime;
	};
	// Timezone
	// -------------------------------------------------------------------------------------------------
	// Converts the moment to UTC, stripping out its timezone offset, but preserving its
	// YMD and time-of-day. A moment with a stripped timezone offset will display no
	// timezone offset when .format() is called.
	newMomentProto.stripZone = function () {
	    var wasAmbigTime;
	    if (!this._ambigZone) {
	        wasAmbigTime = this._ambigTime;
	        this.utc(true); // keepLocalTime=true (for keeping date and time values)
	        // the above call to .utc()/.utcOffset() unfortunately might clear the ambig flags, so restore
	        this._ambigTime = wasAmbigTime || false;
	        // Mark the zone as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
	        // which clears the ambig flags.
	        this._ambigZone = true;
	    }
	    return this; // for chaining
	};
	// Returns of the moment has a non-ambiguous timezone offset (boolean)
	newMomentProto.hasZone = function () {
	    return !this._ambigZone;
	};
	// implicitly marks a zone
	newMomentProto.local = function (keepLocalTime) {
	    // for when converting from ambiguously-zoned to local,
	    // keep the time values when converting from UTC -> local
	    oldMomentProto.local.call(this, this._ambigZone || keepLocalTime);
	    // ensure non-ambiguous
	    // this probably already happened via local() -> utcOffset(), but don't rely on Moment's internals
	    this._ambigTime = false;
	    this._ambigZone = false;
	    return this; // for chaining
	};
	// implicitly marks a zone
	newMomentProto.utc = function (keepLocalTime) {
	    oldMomentProto.utc.call(this, keepLocalTime);
	    // ensure non-ambiguous
	    // this probably already happened via utc() -> utcOffset(), but don't rely on Moment's internals
	    this._ambigTime = false;
	    this._ambigZone = false;
	    return this;
	};
	// implicitly marks a zone (will probably get called upon .utc() and .local())
	newMomentProto.utcOffset = function (tzo) {
	    if (tzo != null) { // setter
	        // these assignments needs to happen before the original zone method is called.
	        // I forget why, something to do with a browser crash.
	        this._ambigTime = false;
	        this._ambigZone = false;
	    }
	    return oldMomentProto.utcOffset.apply(this, arguments);
	};
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	Meant to be immutable
	*/
	var ComponentFootprint = /** @class */ (function () {
	    function ComponentFootprint(unzonedRange, isAllDay) {
	        this.isAllDay = false; // component can choose to ignore this
	        this.unzonedRange = unzonedRange;
	        this.isAllDay = isAllDay;
	    }
	    /*
	    Only works for non-open-ended ranges.
	    */
	    ComponentFootprint.prototype.toLegacy = function (calendar) {
	        return {
	            start: calendar.msToMoment(this.unzonedRange.startMs, this.isAllDay),
	            end: calendar.msToMoment(this.unzonedRange.endMs, this.isAllDay)
	        };
	    };
	    return ComponentFootprint;
	}());
	exports.default = ComponentFootprint;
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/*
	USAGE:
	  import { default as EmitterMixin, EmitterInterface } from './EmitterMixin'
	in class:
	  on: EmitterInterface['on']
	  one: EmitterInterface['one']
	  off: EmitterInterface['off']
	  trigger: EmitterInterface['trigger']
	  triggerWith: EmitterInterface['triggerWith']
	  hasHandlers: EmitterInterface['hasHandlers']
	after class:
	  EmitterMixin.mixInto(TheClass)
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var Mixin_1 = __webpack_require__(15);
	var EmitterMixin = /** @class */ (function (_super) {
	    tslib_1.__extends(EmitterMixin, _super);
	    function EmitterMixin() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // jQuery-ification via $(this) allows a non-DOM object to have
	    // the same event handling capabilities (including namespaces).
	    EmitterMixin.prototype.on = function (types, handler) {
	        $(this).on(types, this._prepareIntercept(handler));
	        return this; // for chaining
	    };
	    EmitterMixin.prototype.one = function (types, handler) {
	        $(this).one(types, this._prepareIntercept(handler));
	        return this; // for chaining
	    };
	    EmitterMixin.prototype._prepareIntercept = function (handler) {
	        // handlers are always called with an "event" object as their first param.
	        // sneak the `this` context and arguments into the extra parameter object
	        // and forward them on to the original handler.
	        var intercept = function (ev, extra) {
	            return handler.apply(extra.context || this, extra.args || []);
	        };
	        // mimick jQuery's internal "proxy" system (risky, I know)
	        // causing all functions with the same .guid to appear to be the same.
	        // https://github.com/jquery/jquery/blob/2.2.4/src/core.js#L448
	        // this is needed for calling .off with the original non-intercept handler.
	        if (!handler.guid) {
	            handler.guid = $.guid++;
	        }
	        intercept.guid = handler.guid;
	        return intercept;
	    };
	    EmitterMixin.prototype.off = function (types, handler) {
	        $(this).off(types, handler);
	        return this; // for chaining
	    };
	    EmitterMixin.prototype.trigger = function (types) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        // pass in "extra" info to the intercept
	        $(this).triggerHandler(types, { args: args });
	        return this; // for chaining
	    };
	    EmitterMixin.prototype.triggerWith = function (types, context, args) {
	        // `triggerHandler` is less reliant on the DOM compared to `trigger`.
	        // pass in "extra" info to the intercept.
	        $(this).triggerHandler(types, { context: context, args: args });
	        return this; // for chaining
	    };
	    EmitterMixin.prototype.hasHandlers = function (type) {
	        var hash = $._data(this, 'events'); // http://blog.jquery.com/2012/08/09/jquery-1-8-released/
	        return hash && hash[type] && hash[type].length > 0;
	    };
	    return EmitterMixin;
	}(Mixin_1.default));
	exports.default = EmitterMixin;
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Interaction = /** @class */ (function () {
	    function Interaction(component) {
	        this.view = component._getView();
	        this.component = component;
	    }
	    Interaction.prototype.opt = function (name) {
	        return this.view.opt(name);
	    };
	    Interaction.prototype.end = function () {
	        // subclasses can implement
	    };
	    return Interaction;
	}());
	exports.default = Interaction;
	
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Mixin = /** @class */ (function () {
	    function Mixin() {
	    }
	    Mixin.mixInto = function (destClass) {
	        var _this = this;
	        Object.getOwnPropertyNames(this.prototype).forEach(function (name) {
	            if (!destClass.prototype[name]) { // if destination class doesn't already define it
	                destClass.prototype[name] = _this.prototype[name];
	            }
	        });
	    };
	    /*
	    will override existing methods
	    TODO: remove! not used anymore
	    */
	    Mixin.mixOver = function (destClass) {
	        var _this = this;
	        Object.getOwnPropertyNames(this.prototype).forEach(function (name) {
	            destClass.prototype[name] = _this.prototype[name];
	        });
	    };
	    return Mixin;
	}());
	exports.default = Mixin;
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var UnzonedRange_1 = __webpack_require__(5);
	/*
	Meant to be immutable
	*/
	var EventDateProfile = /** @class */ (function () {
	    function EventDateProfile(start, end, calendar) {
	        this.start = start;
	        this.end = end || null;
	        this.unzonedRange = this.buildUnzonedRange(calendar);
	    }
	    /*
	    Needs an EventSource object
	    */
	    EventDateProfile.parse = function (rawProps, source) {
	        var startInput = rawProps.start || rawProps.date;
	        var endInput = rawProps.end;
	        if (!startInput) {
	            return false;
	        }
	        var calendar = source.calendar;
	        var start = calendar.moment(startInput);
	        var end = endInput ? calendar.moment(endInput) : null;
	        var forcedAllDay = rawProps.allDay;
	        var forceEventDuration = calendar.opt('forceEventDuration');
	        if (!start.isValid()) {
	            return false;
	        }
	        if (forcedAllDay == null) {
	            forcedAllDay = source.allDayDefault;
	            if (forcedAllDay == null) {
	                forcedAllDay = calendar.opt('allDayDefault');
	            }
	        }
	        if (forcedAllDay === true) {
	            start.stripTime();
	            if (end) {
	                end.stripTime();
	            }
	        }
	        else if (forcedAllDay === false) {
	            if (!start.hasTime()) {
	                start.time(0);
	            }
	            if (end && !end.hasTime()) {
	                end.time(0);
	            }
	        }
	        if (end && (!end.isValid() || !end.isAfter(start))) {
	            end = null;
	        }
	        if (!end && forceEventDuration) {
	            end = calendar.getDefaultEventEnd(!start.hasTime(), start);
	        }
	        return new EventDateProfile(start, end, calendar);
	    };
	    EventDateProfile.isStandardProp = function (propName) {
	        return propName === 'start' || propName === 'date' || propName === 'end' || propName === 'allDay';
	    };
	    EventDateProfile.prototype.isAllDay = function () {
	        return !(this.start.hasTime() || (this.end && this.end.hasTime()));
	    };
	    /*
	    Needs a Calendar object
	    */
	    EventDateProfile.prototype.buildUnzonedRange = function (calendar) {
	        var startMs = this.start.clone().stripZone().valueOf();
	        var endMs = this.getEnd(calendar).stripZone().valueOf();
	        return new UnzonedRange_1.default(startMs, endMs);
	    };
	    /*
	    Needs a Calendar object
	    */
	    EventDateProfile.prototype.getEnd = function (calendar) {
	        return this.end ?
	            this.end.clone() :
	            // derive the end from the start and allDay. compute allDay if necessary
	            calendar.getDefaultEventEnd(this.isAllDay(), this.start);
	    };
	    return EventDateProfile;
	}());
	exports.default = EventDateProfile;
	
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	var DragListener_1 = __webpack_require__(59);
	/* Tracks mouse movements over a component and raises events about which hit the mouse is over.
	------------------------------------------------------------------------------------------------------------------------
	options:
	- subjectEl
	- subjectCenter
	*/
	var HitDragListener = /** @class */ (function (_super) {
	    tslib_1.__extends(HitDragListener, _super);
	    function HitDragListener(component, options) {
	        var _this = _super.call(this, options) || this;
	        _this.component = component;
	        return _this;
	    }
	    // Called when drag listening starts (but a real drag has not necessarily began).
	    // ev might be undefined if dragging was started manually.
	    HitDragListener.prototype.handleInteractionStart = function (ev) {
	        var subjectEl = this.subjectEl;
	        var subjectRect;
	        var origPoint;
	        var point;
	        this.component.hitsNeeded();
	        this.computeScrollBounds(); // for autoscroll
	        if (ev) {
	            origPoint = { left: util_1.getEvX(ev), top: util_1.getEvY(ev) };
	            point = origPoint;
	            // constrain the point to bounds of the element being dragged
	            if (subjectEl) {
	                subjectRect = util_1.getOuterRect(subjectEl); // used for centering as well
	                point = util_1.constrainPoint(point, subjectRect);
	            }
	            this.origHit = this.queryHit(point.left, point.top);
	            // treat the center of the subject as the collision point?
	            if (subjectEl && this.options.subjectCenter) {
	                // only consider the area the subject overlaps the hit. best for large subjects.
	                // TODO: skip this if hit didn't supply left/right/top/bottom
	                if (this.origHit) {
	                    subjectRect = util_1.intersectRects(this.origHit, subjectRect) ||
	                        subjectRect; // in case there is no intersection
	                }
	                point = util_1.getRectCenter(subjectRect);
	            }
	            this.coordAdjust = util_1.diffPoints(point, origPoint); // point - origPoint
	        }
	        else {
	            this.origHit = null;
	            this.coordAdjust = null;
	        }
	        // call the super-method. do it after origHit has been computed
	        _super.prototype.handleInteractionStart.call(this, ev);
	    };
	    // Called when the actual drag has started
	    HitDragListener.prototype.handleDragStart = function (ev) {
	        var hit;
	        _super.prototype.handleDragStart.call(this, ev);
	        // might be different from this.origHit if the min-distance is large
	        hit = this.queryHit(util_1.getEvX(ev), util_1.getEvY(ev));
	        // report the initial hit the mouse is over
	        // especially important if no min-distance and drag starts immediately
	        if (hit) {
	            this.handleHitOver(hit);
	        }
	    };
	    // Called when the drag moves
	    HitDragListener.prototype.handleDrag = function (dx, dy, ev) {
	        var hit;
	        _super.prototype.handleDrag.call(this, dx, dy, ev);
	        hit = this.queryHit(util_1.getEvX(ev), util_1.getEvY(ev));
	        if (!isHitsEqual(hit, this.hit)) { // a different hit than before?
	            if (this.hit) {
	                this.handleHitOut();
	            }
	            if (hit) {
	                this.handleHitOver(hit);
	            }
	        }
	    };
	    // Called when dragging has been stopped
	    HitDragListener.prototype.handleDragEnd = function (ev) {
	        this.handleHitDone();
	        _super.prototype.handleDragEnd.call(this, ev);
	    };
	    // Called when a the mouse has just moved over a new hit
	    HitDragListener.prototype.handleHitOver = function (hit) {
	        var isOrig = isHitsEqual(hit, this.origHit);
	        this.hit = hit;
	        this.trigger('hitOver', this.hit, isOrig, this.origHit);
	    };
	    // Called when the mouse has just moved out of a hit
	    HitDragListener.prototype.handleHitOut = function () {
	        if (this.hit) {
	            this.trigger('hitOut', this.hit);
	            this.handleHitDone();
	            this.hit = null;
	        }
	    };
	    // Called after a hitOut. Also called before a dragStop
	    HitDragListener.prototype.handleHitDone = function () {
	        if (this.hit) {
	            this.trigger('hitDone', this.hit);
	        }
	    };
	    // Called when the interaction ends, whether there was a real drag or not
	    HitDragListener.prototype.handleInteractionEnd = function (ev, isCancelled) {
	        _super.prototype.handleInteractionEnd.call(this, ev, isCancelled);
	        this.origHit = null;
	        this.hit = null;
	        this.component.hitsNotNeeded();
	    };
	    // Called when scrolling has stopped, whether through auto scroll, or the user scrolling
	    HitDragListener.prototype.handleScrollEnd = function () {
	        _super.prototype.handleScrollEnd.call(this);
	        // hits' absolute positions will be in new places after a user's scroll.
	        // HACK for recomputing.
	        if (this.isDragging) {
	            this.component.releaseHits();
	            this.component.prepareHits();
	        }
	    };
	    // Gets the hit underneath the coordinates for the given mouse event
	    HitDragListener.prototype.queryHit = function (left, top) {
	        if (this.coordAdjust) {
	            left += this.coordAdjust.left;
	            top += this.coordAdjust.top;
	        }
	        return this.component.queryHit(left, top);
	    };
	    return HitDragListener;
	}(DragListener_1.default));
	exports.default = HitDragListener;
	// Returns `true` if the hits are identically equal. `false` otherwise. Must be from the same component.
	// Two null values will be considered equal, as two "out of the component" states are the same.
	function isHitsEqual(hit0, hit1) {
	    if (!hit0 && !hit1) {
	        return true;
	    }
	    if (hit0 && hit1) {
	        return hit0.component === hit1.component &&
	            isHitPropsWithin(hit0, hit1) &&
	            isHitPropsWithin(hit1, hit0); // ensures all props are identical
	    }
	    return false;
	}
	// Returns true if all of subHit's non-standard properties are within superHit
	function isHitPropsWithin(subHit, superHit) {
	    for (var propName in subHit) {
	        if (!/^(component|left|right|top|bottom)$/.test(propName)) {
	            if (subHit[propName] !== superHit[propName]) {
	                return false;
	            }
	        }
	    }
	    return true;
	}
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.version = '3.10.5';
	// When introducing internal API incompatibilities (where fullcalendar plugins would break),
	// the minor version of the calendar should be upped (ex: 2.7.2 -> 2.8.0)
	// and the below integer should be incremented.
	exports.internalApiVersion = 12;
	var util_1 = __webpack_require__(4);
	exports.applyAll = util_1.applyAll;
	exports.debounce = util_1.debounce;
	exports.isInt = util_1.isInt;
	exports.htmlEscape = util_1.htmlEscape;
	exports.cssToStr = util_1.cssToStr;
	exports.proxy = util_1.proxy;
	exports.capitaliseFirstLetter = util_1.capitaliseFirstLetter;
	exports.getOuterRect = util_1.getOuterRect;
	exports.getClientRect = util_1.getClientRect;
	exports.getContentRect = util_1.getContentRect;
	exports.getScrollbarWidths = util_1.getScrollbarWidths;
	exports.preventDefault = util_1.preventDefault;
	exports.parseFieldSpecs = util_1.parseFieldSpecs;
	exports.compareByFieldSpecs = util_1.compareByFieldSpecs;
	exports.compareByFieldSpec = util_1.compareByFieldSpec;
	exports.flexibleCompare = util_1.flexibleCompare;
	exports.computeGreatestUnit = util_1.computeGreatestUnit;
	exports.divideRangeByDuration = util_1.divideRangeByDuration;
	exports.divideDurationByDuration = util_1.divideDurationByDuration;
	exports.multiplyDuration = util_1.multiplyDuration;
	exports.durationHasTime = util_1.durationHasTime;
	exports.log = util_1.log;
	exports.warn = util_1.warn;
	exports.removeExact = util_1.removeExact;
	exports.intersectRects = util_1.intersectRects;
	exports.allowSelection = util_1.allowSelection;
	exports.attrsToStr = util_1.attrsToStr;
	exports.compareNumbers = util_1.compareNumbers;
	exports.compensateScroll = util_1.compensateScroll;
	exports.computeDurationGreatestUnit = util_1.computeDurationGreatestUnit;
	exports.constrainPoint = util_1.constrainPoint;
	exports.copyOwnProps = util_1.copyOwnProps;
	exports.diffByUnit = util_1.diffByUnit;
	exports.diffDay = util_1.diffDay;
	exports.diffDayTime = util_1.diffDayTime;
	exports.diffPoints = util_1.diffPoints;
	exports.disableCursor = util_1.disableCursor;
	exports.distributeHeight = util_1.distributeHeight;
	exports.enableCursor = util_1.enableCursor;
	exports.firstDefined = util_1.firstDefined;
	exports.getEvIsTouch = util_1.getEvIsTouch;
	exports.getEvX = util_1.getEvX;
	exports.getEvY = util_1.getEvY;
	exports.getRectCenter = util_1.getRectCenter;
	exports.getScrollParent = util_1.getScrollParent;
	exports.hasOwnProp = util_1.hasOwnProp;
	exports.isArraysEqual = util_1.isArraysEqual;
	exports.isNativeDate = util_1.isNativeDate;
	exports.isPrimaryMouseButton = util_1.isPrimaryMouseButton;
	exports.isTimeString = util_1.isTimeString;
	exports.matchCellWidths = util_1.matchCellWidths;
	exports.mergeProps = util_1.mergeProps;
	exports.preventSelection = util_1.preventSelection;
	exports.removeMatching = util_1.removeMatching;
	exports.stripHtmlEntities = util_1.stripHtmlEntities;
	exports.subtractInnerElHeight = util_1.subtractInnerElHeight;
	exports.uncompensateScroll = util_1.uncompensateScroll;
	exports.undistributeHeight = util_1.undistributeHeight;
	exports.dayIDs = util_1.dayIDs;
	exports.unitsDesc = util_1.unitsDesc;
	var date_formatting_1 = __webpack_require__(49);
	exports.formatDate = date_formatting_1.formatDate;
	exports.formatRange = date_formatting_1.formatRange;
	exports.queryMostGranularFormatUnit = date_formatting_1.queryMostGranularFormatUnit;
	var locale_1 = __webpack_require__(32);
	exports.datepickerLocale = locale_1.datepickerLocale;
	exports.locale = locale_1.locale;
	exports.getMomentLocaleData = locale_1.getMomentLocaleData;
	exports.populateInstanceComputableOptions = locale_1.populateInstanceComputableOptions;
	var util_2 = __webpack_require__(19);
	exports.eventDefsToEventInstances = util_2.eventDefsToEventInstances;
	exports.eventFootprintToComponentFootprint = util_2.eventFootprintToComponentFootprint;
	exports.eventInstanceToEventRange = util_2.eventInstanceToEventRange;
	exports.eventInstanceToUnzonedRange = util_2.eventInstanceToUnzonedRange;
	exports.eventRangeToEventFootprint = util_2.eventRangeToEventFootprint;
	var moment_ext_1 = __webpack_require__(11);
	exports.moment = moment_ext_1.default;
	var EmitterMixin_1 = __webpack_require__(13);
	exports.EmitterMixin = EmitterMixin_1.default;
	var ListenerMixin_1 = __webpack_require__(7);
	exports.ListenerMixin = ListenerMixin_1.default;
	var Model_1 = __webpack_require__(51);
	exports.Model = Model_1.default;
	var Constraints_1 = __webpack_require__(217);
	exports.Constraints = Constraints_1.default;
	var DateProfileGenerator_1 = __webpack_require__(55);
	exports.DateProfileGenerator = DateProfileGenerator_1.default;
	var UnzonedRange_1 = __webpack_require__(5);
	exports.UnzonedRange = UnzonedRange_1.default;
	var ComponentFootprint_1 = __webpack_require__(12);
	exports.ComponentFootprint = ComponentFootprint_1.default;
	var BusinessHourGenerator_1 = __webpack_require__(218);
	exports.BusinessHourGenerator = BusinessHourGenerator_1.default;
	var EventPeriod_1 = __webpack_require__(219);
	exports.EventPeriod = EventPeriod_1.default;
	var EventManager_1 = __webpack_require__(220);
	exports.EventManager = EventManager_1.default;
	var EventDef_1 = __webpack_require__(37);
	exports.EventDef = EventDef_1.default;
	var EventDefMutation_1 = __webpack_require__(39);
	exports.EventDefMutation = EventDefMutation_1.default;
	var EventDefParser_1 = __webpack_require__(36);
	exports.EventDefParser = EventDefParser_1.default;
	var EventInstance_1 = __webpack_require__(53);
	exports.EventInstance = EventInstance_1.default;
	var EventRange_1 = __webpack_require__(50);
	exports.EventRange = EventRange_1.default;
	var RecurringEventDef_1 = __webpack_require__(54);
	exports.RecurringEventDef = RecurringEventDef_1.default;
	var SingleEventDef_1 = __webpack_require__(9);
	exports.SingleEventDef = SingleEventDef_1.default;
	var EventDefDateMutation_1 = __webpack_require__(40);
	exports.EventDefDateMutation = EventDefDateMutation_1.default;
	var EventDateProfile_1 = __webpack_require__(16);
	exports.EventDateProfile = EventDateProfile_1.default;
	var EventSourceParser_1 = __webpack_require__(38);
	exports.EventSourceParser = EventSourceParser_1.default;
	var EventSource_1 = __webpack_require__(6);
	exports.EventSource = EventSource_1.default;
	var ThemeRegistry_1 = __webpack_require__(57);
	exports.defineThemeSystem = ThemeRegistry_1.defineThemeSystem;
	exports.getThemeSystemClass = ThemeRegistry_1.getThemeSystemClass;
	var EventInstanceGroup_1 = __webpack_require__(20);
	exports.EventInstanceGroup = EventInstanceGroup_1.default;
	var ArrayEventSource_1 = __webpack_require__(56);
	exports.ArrayEventSource = ArrayEventSource_1.default;
	var FuncEventSource_1 = __webpack_require__(223);
	exports.FuncEventSource = FuncEventSource_1.default;
	var JsonFeedEventSource_1 = __webpack_require__(224);
	exports.JsonFeedEventSource = JsonFeedEventSource_1.default;
	var EventFootprint_1 = __webpack_require__(34);
	exports.EventFootprint = EventFootprint_1.default;
	var Class_1 = __webpack_require__(35);
	exports.Class = Class_1.default;
	var Mixin_1 = __webpack_require__(15);
	exports.Mixin = Mixin_1.default;
	var CoordCache_1 = __webpack_require__(58);
	exports.CoordCache = CoordCache_1.default;
	var Iterator_1 = __webpack_require__(225);
	exports.Iterator = Iterator_1.default;
	var DragListener_1 = __webpack_require__(59);
	exports.DragListener = DragListener_1.default;
	var HitDragListener_1 = __webpack_require__(17);
	exports.HitDragListener = HitDragListener_1.default;
	var MouseFollower_1 = __webpack_require__(226);
	exports.MouseFollower = MouseFollower_1.default;
	var ParsableModelMixin_1 = __webpack_require__(52);
	exports.ParsableModelMixin = ParsableModelMixin_1.default;
	var Popover_1 = __webpack_require__(227);
	exports.Popover = Popover_1.default;
	var Promise_1 = __webpack_require__(21);
	exports.Promise = Promise_1.default;
	var TaskQueue_1 = __webpack_require__(228);
	exports.TaskQueue = TaskQueue_1.default;
	var RenderQueue_1 = __webpack_require__(229);
	exports.RenderQueue = RenderQueue_1.default;
	var Scroller_1 = __webpack_require__(41);
	exports.Scroller = Scroller_1.default;
	var Theme_1 = __webpack_require__(22);
	exports.Theme = Theme_1.default;
	var Component_1 = __webpack_require__(230);
	exports.Component = Component_1.default;
	var DateComponent_1 = __webpack_require__(231);
	exports.DateComponent = DateComponent_1.default;
	var InteractiveDateComponent_1 = __webpack_require__(42);
	exports.InteractiveDateComponent = InteractiveDateComponent_1.default;
	var Calendar_1 = __webpack_require__(232);
	exports.Calendar = Calendar_1.default;
	var View_1 = __webpack_require__(43);
	exports.View = View_1.default;
	var ViewRegistry_1 = __webpack_require__(24);
	exports.defineView = ViewRegistry_1.defineView;
	exports.getViewConfig = ViewRegistry_1.getViewConfig;
	var DayTableMixin_1 = __webpack_require__(60);
	exports.DayTableMixin = DayTableMixin_1.default;
	var BusinessHourRenderer_1 = __webpack_require__(61);
	exports.BusinessHourRenderer = BusinessHourRenderer_1.default;
	var EventRenderer_1 = __webpack_require__(44);
	exports.EventRenderer = EventRenderer_1.default;
	var FillRenderer_1 = __webpack_require__(62);
	exports.FillRenderer = FillRenderer_1.default;
	var HelperRenderer_1 = __webpack_require__(63);
	exports.HelperRenderer = HelperRenderer_1.default;
	var ExternalDropping_1 = __webpack_require__(233);
	exports.ExternalDropping = ExternalDropping_1.default;
	var EventResizing_1 = __webpack_require__(234);
	exports.EventResizing = EventResizing_1.default;
	var EventPointing_1 = __webpack_require__(64);
	exports.EventPointing = EventPointing_1.default;
	var EventDragging_1 = __webpack_require__(235);
	exports.EventDragging = EventDragging_1.default;
	var DateSelecting_1 = __webpack_require__(236);
	exports.DateSelecting = DateSelecting_1.default;
	var DateClicking_1 = __webpack_require__(237);
	exports.DateClicking = DateClicking_1.default;
	var Interaction_1 = __webpack_require__(14);
	exports.Interaction = Interaction_1.default;
	var StandardInteractionsMixin_1 = __webpack_require__(65);
	exports.StandardInteractionsMixin = StandardInteractionsMixin_1.default;
	var AgendaView_1 = __webpack_require__(238);
	exports.AgendaView = AgendaView_1.default;
	var TimeGrid_1 = __webpack_require__(239);
	exports.TimeGrid = TimeGrid_1.default;
	var TimeGridEventRenderer_1 = __webpack_require__(240);
	exports.TimeGridEventRenderer = TimeGridEventRenderer_1.default;
	var TimeGridFillRenderer_1 = __webpack_require__(242);
	exports.TimeGridFillRenderer = TimeGridFillRenderer_1.default;
	var TimeGridHelperRenderer_1 = __webpack_require__(241);
	exports.TimeGridHelperRenderer = TimeGridHelperRenderer_1.default;
	var DayGrid_1 = __webpack_require__(66);
	exports.DayGrid = DayGrid_1.default;
	var DayGridEventRenderer_1 = __webpack_require__(243);
	exports.DayGridEventRenderer = DayGridEventRenderer_1.default;
	var DayGridFillRenderer_1 = __webpack_require__(245);
	exports.DayGridFillRenderer = DayGridFillRenderer_1.default;
	var DayGridHelperRenderer_1 = __webpack_require__(244);
	exports.DayGridHelperRenderer = DayGridHelperRenderer_1.default;
	var BasicView_1 = __webpack_require__(67);
	exports.BasicView = BasicView_1.default;
	var BasicViewDateProfileGenerator_1 = __webpack_require__(68);
	exports.BasicViewDateProfileGenerator = BasicViewDateProfileGenerator_1.default;
	var MonthView_1 = __webpack_require__(246);
	exports.MonthView = MonthView_1.default;
	var MonthViewDateProfileGenerator_1 = __webpack_require__(247);
	exports.MonthViewDateProfileGenerator = MonthViewDateProfileGenerator_1.default;
	var ListView_1 = __webpack_require__(248);
	exports.ListView = ListView_1.default;
	var ListEventPointing_1 = __webpack_require__(250);
	exports.ListEventPointing = ListEventPointing_1.default;
	var ListEventRenderer_1 = __webpack_require__(249);
	exports.ListEventRenderer = ListEventRenderer_1.default;
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventRange_1 = __webpack_require__(50);
	var EventFootprint_1 = __webpack_require__(34);
	var ComponentFootprint_1 = __webpack_require__(12);
	function eventDefsToEventInstances(eventDefs, unzonedRange) {
	    var eventInstances = [];
	    var i;
	    for (i = 0; i < eventDefs.length; i++) {
	        eventInstances.push.apply(eventInstances, // append
	        eventDefs[i].buildInstances(unzonedRange));
	    }
	    return eventInstances;
	}
	exports.eventDefsToEventInstances = eventDefsToEventInstances;
	function eventInstanceToEventRange(eventInstance) {
	    return new EventRange_1.default(eventInstance.dateProfile.unzonedRange, eventInstance.def, eventInstance);
	}
	exports.eventInstanceToEventRange = eventInstanceToEventRange;
	function eventRangeToEventFootprint(eventRange) {
	    return new EventFootprint_1.default(new ComponentFootprint_1.default(eventRange.unzonedRange, eventRange.eventDef.isAllDay()), eventRange.eventDef, eventRange.eventInstance // might not exist
	    );
	}
	exports.eventRangeToEventFootprint = eventRangeToEventFootprint;
	function eventInstanceToUnzonedRange(eventInstance) {
	    return eventInstance.dateProfile.unzonedRange;
	}
	exports.eventInstanceToUnzonedRange = eventInstanceToUnzonedRange;
	function eventFootprintToComponentFootprint(eventFootprint) {
	    return eventFootprint.componentFootprint;
	}
	exports.eventFootprintToComponentFootprint = eventFootprintToComponentFootprint;
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var UnzonedRange_1 = __webpack_require__(5);
	var util_1 = __webpack_require__(19);
	var EventRange_1 = __webpack_require__(50);
	/*
	It's expected that there will be at least one EventInstance,
	OR that an explicitEventDef is assigned.
	*/
	var EventInstanceGroup = /** @class */ (function () {
	    function EventInstanceGroup(eventInstances) {
	        this.eventInstances = eventInstances || [];
	    }
	    EventInstanceGroup.prototype.getAllEventRanges = function (constraintRange) {
	        if (constraintRange) {
	            return this.sliceNormalRenderRanges(constraintRange);
	        }
	        else {
	            return this.eventInstances.map(util_1.eventInstanceToEventRange);
	        }
	    };
	    EventInstanceGroup.prototype.sliceRenderRanges = function (constraintRange) {
	        if (this.isInverse()) {
	            return this.sliceInverseRenderRanges(constraintRange);
	        }
	        else {
	            return this.sliceNormalRenderRanges(constraintRange);
	        }
	    };
	    EventInstanceGroup.prototype.sliceNormalRenderRanges = function (constraintRange) {
	        var eventInstances = this.eventInstances;
	        var i;
	        var eventInstance;
	        var slicedRange;
	        var slicedEventRanges = [];
	        for (i = 0; i < eventInstances.length; i++) {
	            eventInstance = eventInstances[i];
	            slicedRange = eventInstance.dateProfile.unzonedRange.intersect(constraintRange);
	            if (slicedRange) {
	                slicedEventRanges.push(new EventRange_1.default(slicedRange, eventInstance.def, eventInstance));
	            }
	        }
	        return slicedEventRanges;
	    };
	    EventInstanceGroup.prototype.sliceInverseRenderRanges = function (constraintRange) {
	        var unzonedRanges = this.eventInstances.map(util_1.eventInstanceToUnzonedRange);
	        var ownerDef = this.getEventDef();
	        unzonedRanges = UnzonedRange_1.default.invertRanges(unzonedRanges, constraintRange);
	        return unzonedRanges.map(function (unzonedRange) {
	            return new EventRange_1.default(unzonedRange, ownerDef); // don't give an EventInstance
	        });
	    };
	    EventInstanceGroup.prototype.isInverse = function () {
	        return this.getEventDef().hasInverseRendering();
	    };
	    EventInstanceGroup.prototype.getEventDef = function () {
	        return this.explicitEventDef || this.eventInstances[0].def;
	    };
	    return EventInstanceGroup;
	}());
	exports.default = EventInstanceGroup;
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var PromiseStub = {
	    construct: function (executor) {
	        var deferred = $.Deferred();
	        var promise = deferred.promise();
	        if (typeof executor === 'function') {
	            executor(function (val) {
	                deferred.resolve(val);
	                attachImmediatelyResolvingThen(promise, val);
	            }, function () {
	                deferred.reject();
	                attachImmediatelyRejectingThen(promise);
	            });
	        }
	        return promise;
	    },
	    resolve: function (val) {
	        var deferred = $.Deferred().resolve(val);
	        var promise = deferred.promise();
	        attachImmediatelyResolvingThen(promise, val);
	        return promise;
	    },
	    reject: function () {
	        var deferred = $.Deferred().reject();
	        var promise = deferred.promise();
	        attachImmediatelyRejectingThen(promise);
	        return promise;
	    }
	};
	exports.default = PromiseStub;
	function attachImmediatelyResolvingThen(promise, val) {
	    promise.then = function (onResolve) {
	        if (typeof onResolve === 'function') {
	            return PromiseStub.resolve(onResolve(val));
	        }
	        return promise;
	    };
	}
	function attachImmediatelyRejectingThen(promise) {
	    promise.then = function (onResolve, onReject) {
	        if (typeof onReject === 'function') {
	            onReject();
	        }
	        return promise;
	    };
	}
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var Theme = /** @class */ (function () {
	    function Theme(optionsManager) {
	        this.optionsManager = optionsManager;
	        this.processIconOverride();
	    }
	    Theme.prototype.processIconOverride = function () {
	        if (this.iconOverrideOption) {
	            this.setIconOverride(this.optionsManager.get(this.iconOverrideOption));
	        }
	    };
	    Theme.prototype.setIconOverride = function (iconOverrideHash) {
	        var iconClassesCopy;
	        var buttonName;
	        if ($.isPlainObject(iconOverrideHash)) {
	            iconClassesCopy = $.extend({}, this.iconClasses);
	            for (buttonName in iconOverrideHash) {
	                iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
	            }
	            this.iconClasses = iconClassesCopy;
	        }
	        else if (iconOverrideHash === false) {
	            this.iconClasses = {};
	        }
	    };
	    Theme.prototype.applyIconOverridePrefix = function (className) {
	        var prefix = this.iconOverridePrefix;
	        if (prefix && className.indexOf(prefix) !== 0) { // if not already present
	            className = prefix + className;
	        }
	        return className;
	    };
	    Theme.prototype.getClass = function (key) {
	        return this.classes[key] || '';
	    };
	    Theme.prototype.getIconClass = function (buttonName) {
	        var className = this.iconClasses[buttonName];
	        if (className) {
	            return this.baseIconClass + ' ' + className;
	        }
	        return '';
	    };
	    Theme.prototype.getCustomButtonIconClass = function (customButtonProps) {
	        var className;
	        if (this.iconOverrideCustomButtonOption) {
	            className = customButtonProps[this.iconOverrideCustomButtonOption];
	            if (className) {
	                return this.baseIconClass + ' ' + this.applyIconOverridePrefix(className);
	            }
	        }
	        return '';
	    };
	    return Theme;
	}());
	exports.default = Theme;
	Theme.prototype.classes = {};
	Theme.prototype.iconClasses = {};
	Theme.prototype.baseIconClass = '';
	Theme.prototype.iconOverridePrefix = '';
	
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var exportHooks = __webpack_require__(18);
	var EmitterMixin_1 = __webpack_require__(13);
	var ListenerMixin_1 = __webpack_require__(7);
	exportHooks.touchMouseIgnoreWait = 500;
	var globalEmitter = null;
	var neededCount = 0;
	/*
	Listens to document and window-level user-interaction events, like touch events and mouse events,
	and fires these events as-is to whoever is observing a GlobalEmitter.
	Best when used as a singleton via GlobalEmitter.get()
	
	Normalizes mouse/touch events. For examples:
	- ignores the the simulated mouse events that happen after a quick tap: mousemove+mousedown+mouseup+click
	- compensates for various buggy scenarios where a touchend does not fire
	*/
	var GlobalEmitter = /** @class */ (function () {
	    function GlobalEmitter() {
	        this.isTouching = false;
	        this.mouseIgnoreDepth = 0;
	    }
	    // gets the singleton
	    GlobalEmitter.get = function () {
	        if (!globalEmitter) {
	            globalEmitter = new GlobalEmitter();
	            globalEmitter.bind();
	        }
	        return globalEmitter;
	    };
	    // called when an object knows it will need a GlobalEmitter in the near future.
	    GlobalEmitter.needed = function () {
	        GlobalEmitter.get(); // ensures globalEmitter
	        neededCount++;
	    };
	    // called when the object that originally called needed() doesn't need a GlobalEmitter anymore.
	    GlobalEmitter.unneeded = function () {
	        neededCount--;
	        if (!neededCount) { // nobody else needs it
	            globalEmitter.unbind();
	            globalEmitter = null;
	        }
	    };
	    GlobalEmitter.prototype.bind = function () {
	        var _this = this;
	        this.listenTo($(document), {
	            touchstart: this.handleTouchStart,
	            touchcancel: this.handleTouchCancel,
	            touchend: this.handleTouchEnd,
	            mousedown: this.handleMouseDown,
	            mousemove: this.handleMouseMove,
	            mouseup: this.handleMouseUp,
	            click: this.handleClick,
	            selectstart: this.handleSelectStart,
	            contextmenu: this.handleContextMenu
	        });
	        // because we need to call preventDefault
	        // because https://www.chromestatus.com/features/5093566007214080
	        // TODO: investigate performance because this is a global handler
	        window.addEventListener('touchmove', this.handleTouchMoveProxy = function (ev) {
	            _this.handleTouchMove($.Event(ev));
	        }, { passive: false } // allows preventDefault()
	        );
	        // attach a handler to get called when ANY scroll action happens on the page.
	        // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
	        // http://stackoverflow.com/a/32954565/96342
	        window.addEventListener('scroll', this.handleScrollProxy = function (ev) {
	            _this.handleScroll($.Event(ev));
	        }, true // useCapture
	        );
	    };
	    GlobalEmitter.prototype.unbind = function () {
	        this.stopListeningTo($(document));
	        window.removeEventListener('touchmove', this.handleTouchMoveProxy, { passive: false } // use same options as addEventListener
	        );
	        window.removeEventListener('scroll', this.handleScrollProxy, true // useCapture
	        );
	    };
	    // Touch Handlers
	    // -----------------------------------------------------------------------------------------------------------------
	    GlobalEmitter.prototype.handleTouchStart = function (ev) {
	        // if a previous touch interaction never ended with a touchend, then implicitly end it,
	        // but since a new touch interaction is about to begin, don't start the mouse ignore period.
	        this.stopTouch(ev, true); // skipMouseIgnore=true
	        this.isTouching = true;
	        this.trigger('touchstart', ev);
	    };
	    GlobalEmitter.prototype.handleTouchMove = function (ev) {
	        if (this.isTouching) {
	            this.trigger('touchmove', ev);
	        }
	    };
	    GlobalEmitter.prototype.handleTouchCancel = function (ev) {
	        if (this.isTouching) {
	            this.trigger('touchcancel', ev);
	            // Have touchcancel fire an artificial touchend. That way, handlers won't need to listen to both.
	            // If touchend fires later, it won't have any effect b/c isTouching will be false.
	            this.stopTouch(ev);
	        }
	    };
	    GlobalEmitter.prototype.handleTouchEnd = function (ev) {
	        this.stopTouch(ev);
	    };
	    // Mouse Handlers
	    // -----------------------------------------------------------------------------------------------------------------
	    GlobalEmitter.prototype.handleMouseDown = function (ev) {
	        if (!this.shouldIgnoreMouse()) {
	            this.trigger('mousedown', ev);
	        }
	    };
	    GlobalEmitter.prototype.handleMouseMove = function (ev) {
	        if (!this.shouldIgnoreMouse()) {
	            this.trigger('mousemove', ev);
	        }
	    };
	    GlobalEmitter.prototype.handleMouseUp = function (ev) {
	        if (!this.shouldIgnoreMouse()) {
	            this.trigger('mouseup', ev);
	        }
	    };
	    GlobalEmitter.prototype.handleClick = function (ev) {
	        if (!this.shouldIgnoreMouse()) {
	            this.trigger('click', ev);
	        }
	    };
	    // Misc Handlers
	    // -----------------------------------------------------------------------------------------------------------------
	    GlobalEmitter.prototype.handleSelectStart = function (ev) {
	        this.trigger('selectstart', ev);
	    };
	    GlobalEmitter.prototype.handleContextMenu = function (ev) {
	        this.trigger('contextmenu', ev);
	    };
	    GlobalEmitter.prototype.handleScroll = function (ev) {
	        this.trigger('scroll', ev);
	    };
	    // Utils
	    // -----------------------------------------------------------------------------------------------------------------
	    GlobalEmitter.prototype.stopTouch = function (ev, skipMouseIgnore) {
	        if (skipMouseIgnore === void 0) { skipMouseIgnore = false; }
	        if (this.isTouching) {
	            this.isTouching = false;
	            this.trigger('touchend', ev);
	            if (!skipMouseIgnore) {
	                this.startTouchMouseIgnore();
	            }
	        }
	    };
	    GlobalEmitter.prototype.startTouchMouseIgnore = function () {
	        var _this = this;
	        var wait = exportHooks.touchMouseIgnoreWait;
	        if (wait) {
	            this.mouseIgnoreDepth++;
	            setTimeout(function () {
	                _this.mouseIgnoreDepth--;
	            }, wait);
	        }
	    };
	    GlobalEmitter.prototype.shouldIgnoreMouse = function () {
	        return this.isTouching || Boolean(this.mouseIgnoreDepth);
	    };
	    return GlobalEmitter;
	}());
	exports.default = GlobalEmitter;
	ListenerMixin_1.default.mixInto(GlobalEmitter);
	EmitterMixin_1.default.mixInto(GlobalEmitter);
	
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var exportHooks = __webpack_require__(18);
	exports.viewHash = {};
	exportHooks.views = exports.viewHash;
	function defineView(viewName, viewConfig) {
	    exports.viewHash[viewName] = viewConfig;
	}
	exports.defineView = defineView;
	function getViewConfig(viewName) {
	    return exports.viewHash[viewName];
	}
	exports.getViewConfig = getViewConfig;
	
	
	/***/ }),
	/* 25 */,
	/* 26 */,
	/* 27 */,
	/* 28 */,
	/* 29 */,
	/* 30 */,
	/* 31 */,
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var moment = __webpack_require__(0);
	var exportHooks = __webpack_require__(18);
	var options_1 = __webpack_require__(33);
	var util_1 = __webpack_require__(4);
	exports.localeOptionHash = {};
	exportHooks.locales = exports.localeOptionHash;
	// NOTE: can't guarantee any of these computations will run because not every locale has datepicker
	// configs, so make sure there are English fallbacks for these in the defaults file.
	var dpComputableOptions = {
	    buttonText: function (dpOptions) {
	        return {
	            // the translations sometimes wrongly contain HTML entities
	            prev: util_1.stripHtmlEntities(dpOptions.prevText),
	            next: util_1.stripHtmlEntities(dpOptions.nextText),
	            today: util_1.stripHtmlEntities(dpOptions.currentText)
	        };
	    },
	    // Produces format strings like "MMMM YYYY" -> "September 2014"
	    monthYearFormat: function (dpOptions) {
	        return dpOptions.showMonthAfterYear ?
	            'YYYY[' + dpOptions.yearSuffix + '] MMMM' :
	            'MMMM YYYY[' + dpOptions.yearSuffix + ']';
	    }
	};
	var momComputableOptions = {
	    // Produces format strings like "ddd M/D" -> "Fri 9/15"
	    dayOfMonthFormat: function (momOptions, fcOptions) {
	        var format = momOptions.longDateFormat('l'); // for the format like "M/D/YYYY"
	        // strip the year off the edge, as well as other misc non-whitespace chars
	        format = format.replace(/^Y+[^\w\s]*|[^\w\s]*Y+$/g, '');
	        if (fcOptions.isRTL) {
	            format += ' ddd'; // for RTL, add day-of-week to end
	        }
	        else {
	            format = 'ddd ' + format; // for LTR, add day-of-week to beginning
	        }
	        return format;
	    },
	    // Produces format strings like "h:mma" -> "6:00pm"
	    mediumTimeFormat: function (momOptions) {
	        return momOptions.longDateFormat('LT')
	            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
	    },
	    // Produces format strings like "h(:mm)a" -> "6pm" / "6:30pm"
	    smallTimeFormat: function (momOptions) {
	        return momOptions.longDateFormat('LT')
	            .replace(':mm', '(:mm)')
	            .replace(/(\Wmm)$/, '($1)') // like above, but for foreign locales
	            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
	    },
	    // Produces format strings like "h(:mm)t" -> "6p" / "6:30p"
	    extraSmallTimeFormat: function (momOptions) {
	        return momOptions.longDateFormat('LT')
	            .replace(':mm', '(:mm)')
	            .replace(/(\Wmm)$/, '($1)') // like above, but for foreign locales
	            .replace(/\s*a$/i, 't'); // convert to AM/PM/am/pm to lowercase one-letter. remove any spaces beforehand
	    },
	    // Produces format strings like "ha" / "H" -> "6pm" / "18"
	    hourFormat: function (momOptions) {
	        return momOptions.longDateFormat('LT')
	            .replace(':mm', '')
	            .replace(/(\Wmm)$/, '') // like above, but for foreign locales
	            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
	    },
	    // Produces format strings like "h:mm" -> "6:30" (with no AM/PM)
	    noMeridiemTimeFormat: function (momOptions) {
	        return momOptions.longDateFormat('LT')
	            .replace(/\s*a$/i, ''); // remove trailing AM/PM
	    }
	};
	// options that should be computed off live calendar options (considers override options)
	// TODO: best place for this? related to locale?
	// TODO: flipping text based on isRTL is a bad idea because the CSS `direction` might want to handle it
	var instanceComputableOptions = {
	    // Produces format strings for results like "Mo 16"
	    smallDayDateFormat: function (options) {
	        return options.isRTL ?
	            'D dd' :
	            'dd D';
	    },
	    // Produces format strings for results like "Wk 5"
	    weekFormat: function (options) {
	        return options.isRTL ?
	            'w[ ' + options.weekNumberTitle + ']' :
	            '[' + options.weekNumberTitle + ' ]w';
	    },
	    // Produces format strings for results like "Wk5"
	    smallWeekFormat: function (options) {
	        return options.isRTL ?
	            'w[' + options.weekNumberTitle + ']' :
	            '[' + options.weekNumberTitle + ']w';
	    }
	};
	// TODO: make these computable properties in optionsManager
	function populateInstanceComputableOptions(options) {
	    $.each(instanceComputableOptions, function (name, func) {
	        if (options[name] == null) {
	            options[name] = func(options);
	        }
	    });
	}
	exports.populateInstanceComputableOptions = populateInstanceComputableOptions;
	// Initialize jQuery UI datepicker translations while using some of the translations
	// Will set this as the default locales for datepicker.
	function datepickerLocale(localeCode, dpLocaleCode, dpOptions) {
	    // get the FullCalendar internal option hash for this locale. create if necessary
	    var fcOptions = exports.localeOptionHash[localeCode] || (exports.localeOptionHash[localeCode] = {});
	    // transfer some simple options from datepicker to fc
	    fcOptions.isRTL = dpOptions.isRTL;
	    fcOptions.weekNumberTitle = dpOptions.weekHeader;
	    // compute some more complex options from datepicker
	    $.each(dpComputableOptions, function (name, func) {
	        fcOptions[name] = func(dpOptions);
	    });
	    var jqDatePicker = $.datepicker;
	    // is jQuery UI Datepicker is on the page?
	    if (jqDatePicker) {
	        // Register the locale data.
	        // FullCalendar and MomentJS use locale codes like "pt-br" but Datepicker
	        // does it like "pt-BR" or if it doesn't have the locale, maybe just "pt".
	        // Make an alias so the locale can be referenced either way.
	        jqDatePicker.regional[dpLocaleCode] =
	            jqDatePicker.regional[localeCode] = // alias
	                dpOptions;
	        // Alias 'en' to the default locale data. Do this every time.
	        jqDatePicker.regional.en = jqDatePicker.regional[''];
	        // Set as Datepicker's global defaults.
	        jqDatePicker.setDefaults(dpOptions);
	    }
	}
	exports.datepickerLocale = datepickerLocale;
	// Sets FullCalendar-specific translations. Will set the locales as the global default.
	function locale(localeCode, newFcOptions) {
	    var fcOptions;
	    var momOptions;
	    // get the FullCalendar internal option hash for this locale. create if necessary
	    fcOptions = exports.localeOptionHash[localeCode] || (exports.localeOptionHash[localeCode] = {});
	    // provided new options for this locales? merge them in
	    if (newFcOptions) {
	        fcOptions = exports.localeOptionHash[localeCode] = options_1.mergeOptions([fcOptions, newFcOptions]);
	    }
	    // compute locale options that weren't defined.
	    // always do this. newFcOptions can be undefined when initializing from i18n file,
	    // so no way to tell if this is an initialization or a default-setting.
	    momOptions = getMomentLocaleData(localeCode); // will fall back to en
	    $.each(momComputableOptions, function (name, func) {
	        if (fcOptions[name] == null) {
	            fcOptions[name] = (func)(momOptions, fcOptions);
	        }
	    });
	    // set it as the default locale for FullCalendar
	    options_1.globalDefaults.locale = localeCode;
	}
	exports.locale = locale;
	// Returns moment's internal locale data. If doesn't exist, returns English.
	function getMomentLocaleData(localeCode) {
	    return moment.localeData(localeCode) || moment.localeData('en');
	}
	exports.getMomentLocaleData = getMomentLocaleData;
	// Initialize English by forcing computation of moment-derived options.
	// Also, sets it as the default.
	locale('en', options_1.englishDefaults);
	
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(4);
	exports.globalDefaults = {
	    titleRangeSeparator: ' \u2013 ',
	    monthYearFormat: 'MMMM YYYY',
	    defaultTimedEventDuration: '02:00:00',
	    defaultAllDayEventDuration: { days: 1 },
	    forceEventDuration: false,
	    nextDayThreshold: '09:00:00',
	    // display
	    columnHeader: true,
	    defaultView: 'month',
	    aspectRatio: 1.35,
	    header: {
	        left: 'title',
	        center: '',
	        right: 'today prev,next'
	    },
	    weekends: true,
	    weekNumbers: false,
	    weekNumberTitle: 'W',
	    weekNumberCalculation: 'local',
	    // editable: false,
	    // nowIndicator: false,
	    scrollTime: '06:00:00',
	    minTime: '00:00:00',
	    maxTime: '24:00:00',
	    showNonCurrentDates: true,
	    // event ajax
	    lazyFetching: true,
	    startParam: 'start',
	    endParam: 'end',
	    timezoneParam: 'timezone',
	    timezone: false,
	    // allDayDefault: undefined,
	    // locale
	    locale: null,
	    isRTL: false,
	    buttonText: {
	        prev: 'prev',
	        next: 'next',
	        prevYear: 'prev year',
	        nextYear: 'next year',
	        year: 'year',
	        today: 'today',
	        month: 'month',
	        week: 'week',
	        day: 'day'
	    },
	    // buttonIcons: null,
	    allDayText: 'all-day',
	    // allows setting a min-height to the event segment to prevent short events overlapping each other
	    agendaEventMinHeight: 0,
	    // jquery-ui theming
	    theme: false,
	    // themeButtonIcons: null,
	    // eventResizableFromStart: false,
	    dragOpacity: .75,
	    dragRevertDuration: 500,
	    dragScroll: true,
	    // selectable: false,
	    unselectAuto: true,
	    // selectMinDistance: 0,
	    dropAccept: '*',
	    eventOrder: 'title',
	    // eventRenderWait: null,
	    eventLimit: false,
	    eventLimitText: 'more',
	    eventLimitClick: 'popover',
	    dayPopoverFormat: 'LL',
	    handleWindowResize: true,
	    windowResizeDelay: 100,
	    longPressDelay: 1000
	};
	exports.englishDefaults = {
	    dayPopoverFormat: 'dddd, MMMM D'
	};
	exports.rtlDefaults = {
	    header: {
	        left: 'next,prev today',
	        center: '',
	        right: 'title'
	    },
	    buttonIcons: {
	        prev: 'right-single-arrow',
	        next: 'left-single-arrow',
	        prevYear: 'right-double-arrow',
	        nextYear: 'left-double-arrow'
	    },
	    themeButtonIcons: {
	        prev: 'circle-triangle-e',
	        next: 'circle-triangle-w',
	        nextYear: 'seek-prev',
	        prevYear: 'seek-next'
	    }
	};
	var complexOptions = [
	    'header',
	    'footer',
	    'buttonText',
	    'buttonIcons',
	    'themeButtonIcons'
	];
	// Merges an array of option objects into a single object
	function mergeOptions(optionObjs) {
	    return util_1.mergeProps(optionObjs, complexOptions);
	}
	exports.mergeOptions = mergeOptions;
	
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventFootprint = /** @class */ (function () {
	    function EventFootprint(componentFootprint, eventDef, eventInstance) {
	        this.componentFootprint = componentFootprint;
	        this.eventDef = eventDef;
	        if (eventInstance) {
	            this.eventInstance = eventInstance;
	        }
	    }
	    EventFootprint.prototype.getEventLegacy = function () {
	        return (this.eventInstance || this.eventDef).toLegacy();
	    };
	    return EventFootprint;
	}());
	exports.default = EventFootprint;
	
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	// Class that all other classes will inherit from
	var Class = /** @class */ (function () {
	    function Class() {
	    }
	    // Called on a class to create a subclass.
	    // LIMITATION: cannot provide a constructor!
	    Class.extend = function (members) {
	        var SubClass = /** @class */ (function (_super) {
	            tslib_1.__extends(SubClass, _super);
	            function SubClass() {
	                return _super !== null && _super.apply(this, arguments) || this;
	            }
	            return SubClass;
	        }(this));
	        util_1.copyOwnProps(members, SubClass.prototype);
	        return SubClass;
	    };
	    // Adds new member variables/methods to the class's prototype.
	    // Can be called with another class, or a plain object hash containing new members.
	    Class.mixin = function (members) {
	        util_1.copyOwnProps(members, this.prototype);
	    };
	    return Class;
	}());
	exports.default = Class;
	
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(0);
	var util_1 = __webpack_require__(4);
	var SingleEventDef_1 = __webpack_require__(9);
	var RecurringEventDef_1 = __webpack_require__(54);
	exports.default = {
	    parse: function (eventInput, source) {
	        if (util_1.isTimeString(eventInput.start) || moment.isDuration(eventInput.start) ||
	            util_1.isTimeString(eventInput.end) || moment.isDuration(eventInput.end)) {
	            return RecurringEventDef_1.default.parse(eventInput, source);
	        }
	        else {
	            return SingleEventDef_1.default.parse(eventInput, source);
	        }
	    }
	};
	
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var ParsableModelMixin_1 = __webpack_require__(52);
	var EventDef = /** @class */ (function () {
	    function EventDef(source) {
	        this.source = source;
	        this.className = [];
	        this.miscProps = {};
	    }
	    EventDef.parse = function (rawInput, source) {
	        var def = new this(source);
	        if (def.applyProps(rawInput)) {
	            return def;
	        }
	        return false;
	    };
	    EventDef.normalizeId = function (id) {
	        return String(id);
	    };
	    EventDef.generateId = function () {
	        return '_fc' + (EventDef.uuid++);
	    };
	    EventDef.prototype.clone = function () {
	        var copy = new this.constructor(this.source);
	        copy.id = this.id;
	        copy.rawId = this.rawId;
	        copy.uid = this.uid; // not really unique anymore :(
	        EventDef.copyVerbatimStandardProps(this, copy);
	        copy.className = this.className.slice(); // copy
	        copy.miscProps = $.extend({}, this.miscProps);
	        return copy;
	    };
	    EventDef.prototype.hasInverseRendering = function () {
	        return this.getRendering() === 'inverse-background';
	    };
	    EventDef.prototype.hasBgRendering = function () {
	        var rendering = this.getRendering();
	        return rendering === 'inverse-background' || rendering === 'background';
	    };
	    EventDef.prototype.getRendering = function () {
	        if (this.rendering != null) {
	            return this.rendering;
	        }
	        return this.source.rendering;
	    };
	    EventDef.prototype.getConstraint = function () {
	        if (this.constraint != null) {
	            return this.constraint;
	        }
	        if (this.source.constraint != null) {
	            return this.source.constraint;
	        }
	        return this.source.calendar.opt('eventConstraint'); // what about View option?
	    };
	    EventDef.prototype.getOverlap = function () {
	        if (this.overlap != null) {
	            return this.overlap;
	        }
	        if (this.source.overlap != null) {
	            return this.source.overlap;
	        }
	        return this.source.calendar.opt('eventOverlap'); // what about View option?
	    };
	    EventDef.prototype.isStartExplicitlyEditable = function () {
	        if (this.startEditable != null) {
	            return this.startEditable;
	        }
	        return this.source.startEditable;
	    };
	    EventDef.prototype.isDurationExplicitlyEditable = function () {
	        if (this.durationEditable != null) {
	            return this.durationEditable;
	        }
	        return this.source.durationEditable;
	    };
	    EventDef.prototype.isExplicitlyEditable = function () {
	        if (this.editable != null) {
	            return this.editable;
	        }
	        return this.source.editable;
	    };
	    EventDef.prototype.toLegacy = function () {
	        var obj = $.extend({}, this.miscProps);
	        obj._id = this.uid;
	        obj.source = this.source;
	        obj.className = this.className.slice(); // copy
	        obj.allDay = this.isAllDay();
	        if (this.rawId != null) {
	            obj.id = this.rawId;
	        }
	        EventDef.copyVerbatimStandardProps(this, obj);
	        return obj;
	    };
	    EventDef.prototype.applyManualStandardProps = function (rawProps) {
	        if (rawProps.id != null) {
	            this.id = EventDef.normalizeId((this.rawId = rawProps.id));
	        }
	        else {
	            this.id = EventDef.generateId();
	        }
	        if (rawProps._id != null) { // accept this prop, even tho somewhat internal
	            this.uid = String(rawProps._id);
	        }
	        else {
	            this.uid = EventDef.generateId();
	        }
	        // TODO: converge with EventSource
	        if ($.isArray(rawProps.className)) {
	            this.className = rawProps.className;
	        }
	        if (typeof rawProps.className === 'string') {
	            this.className = rawProps.className.split(/\s+/);
	        }
	        return true;
	    };
	    EventDef.prototype.applyMiscProps = function (rawProps) {
	        $.extend(this.miscProps, rawProps);
	    };
	    EventDef.uuid = 0;
	    EventDef.defineStandardProps = ParsableModelMixin_1.default.defineStandardProps;
	    EventDef.copyVerbatimStandardProps = ParsableModelMixin_1.default.copyVerbatimStandardProps;
	    return EventDef;
	}());
	exports.default = EventDef;
	ParsableModelMixin_1.default.mixInto(EventDef);
	EventDef.defineStandardProps({
	    // not automatically assigned (`false`)
	    _id: false,
	    id: false,
	    className: false,
	    source: false,
	    // automatically assigned (`true`)
	    title: true,
	    url: true,
	    rendering: true,
	    constraint: true,
	    overlap: true,
	    editable: true,
	    startEditable: true,
	    durationEditable: true,
	    color: true,
	    backgroundColor: true,
	    borderColor: true,
	    textColor: true
	});
	
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    sourceClasses: [],
	    registerClass: function (EventSourceClass) {
	        this.sourceClasses.unshift(EventSourceClass); // give highest priority
	    },
	    parse: function (rawInput, calendar) {
	        var sourceClasses = this.sourceClasses;
	        var i;
	        var eventSource;
	        for (i = 0; i < sourceClasses.length; i++) {
	            eventSource = sourceClasses[i].parse(rawInput, calendar);
	            if (eventSource) {
	                return eventSource;
	            }
	        }
	    }
	};
	
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(4);
	var EventDateProfile_1 = __webpack_require__(16);
	var EventDef_1 = __webpack_require__(37);
	var EventDefDateMutation_1 = __webpack_require__(40);
	var SingleEventDef_1 = __webpack_require__(9);
	var EventDefMutation = /** @class */ (function () {
	    function EventDefMutation() {
	    }
	    EventDefMutation.createFromRawProps = function (eventInstance, rawProps, largeUnit) {
	        var eventDef = eventInstance.def;
	        var dateProps = {};
	        var standardProps = {};
	        var miscProps = {};
	        var verbatimStandardProps = {};
	        var eventDefId = null;
	        var className = null;
	        var propName;
	        var dateProfile;
	        var dateMutation;
	        var defMutation;
	        for (propName in rawProps) {
	            if (EventDateProfile_1.default.isStandardProp(propName)) {
	                dateProps[propName] = rawProps[propName];
	            }
	            else if (eventDef.isStandardProp(propName)) {
	                standardProps[propName] = rawProps[propName];
	            }
	            else if (eventDef.miscProps[propName] !== rawProps[propName]) { // only if changed
	                miscProps[propName] = rawProps[propName];
	            }
	        }
	        dateProfile = EventDateProfile_1.default.parse(dateProps, eventDef.source);
	        if (dateProfile) { // no failure?
	            dateMutation = EventDefDateMutation_1.default.createFromDiff(eventInstance.dateProfile, dateProfile, largeUnit);
	        }
	        if (standardProps.id !== eventDef.id) {
	            eventDefId = standardProps.id; // only apply if there's a change
	        }
	        if (!util_1.isArraysEqual(standardProps.className, eventDef.className)) {
	            className = standardProps.className; // only apply if there's a change
	        }
	        EventDef_1.default.copyVerbatimStandardProps(standardProps, // src
	        verbatimStandardProps // dest
	        );
	        defMutation = new EventDefMutation();
	        defMutation.eventDefId = eventDefId;
	        defMutation.className = className;
	        defMutation.verbatimStandardProps = verbatimStandardProps;
	        defMutation.miscProps = miscProps;
	        if (dateMutation) {
	            defMutation.dateMutation = dateMutation;
	        }
	        return defMutation;
	    };
	    /*
	    eventDef assumed to be a SingleEventDef.
	    returns an undo function.
	    */
	    EventDefMutation.prototype.mutateSingle = function (eventDef) {
	        var origDateProfile;
	        if (this.dateMutation) {
	            origDateProfile = eventDef.dateProfile;
	            eventDef.dateProfile = this.dateMutation.buildNewDateProfile(origDateProfile, eventDef.source.calendar);
	        }
	        // can't undo
	        // TODO: more DRY with EventDef::applyManualStandardProps
	        if (this.eventDefId != null) {
	            eventDef.id = EventDef_1.default.normalizeId((eventDef.rawId = this.eventDefId));
	        }
	        // can't undo
	        // TODO: more DRY with EventDef::applyManualStandardProps
	        if (this.className) {
	            eventDef.className = this.className;
	        }
	        // can't undo
	        if (this.verbatimStandardProps) {
	            SingleEventDef_1.default.copyVerbatimStandardProps(this.verbatimStandardProps, // src
	            eventDef // dest
	            );
	        }
	        // can't undo
	        if (this.miscProps) {
	            eventDef.applyMiscProps(this.miscProps);
	        }
	        if (origDateProfile) {
	            return function () {
	                eventDef.dateProfile = origDateProfile;
	            };
	        }
	        else {
	            return function () { };
	        }
	    };
	    EventDefMutation.prototype.setDateMutation = function (dateMutation) {
	        if (dateMutation && !dateMutation.isEmpty()) {
	            this.dateMutation = dateMutation;
	        }
	        else {
	            this.dateMutation = null;
	        }
	    };
	    EventDefMutation.prototype.isEmpty = function () {
	        return !this.dateMutation;
	    };
	    return EventDefMutation;
	}());
	exports.default = EventDefMutation;
	
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(4);
	var EventDateProfile_1 = __webpack_require__(16);
	var EventDefDateMutation = /** @class */ (function () {
	    function EventDefDateMutation() {
	        this.clearEnd = false;
	        this.forceTimed = false;
	        this.forceAllDay = false;
	    }
	    EventDefDateMutation.createFromDiff = function (dateProfile0, dateProfile1, largeUnit) {
	        var clearEnd = dateProfile0.end && !dateProfile1.end;
	        var forceTimed = dateProfile0.isAllDay() && !dateProfile1.isAllDay();
	        var forceAllDay = !dateProfile0.isAllDay() && dateProfile1.isAllDay();
	        var dateDelta;
	        var endDiff;
	        var endDelta;
	        var mutation;
	        // subtracts the dates in the appropriate way, returning a duration
	        function subtractDates(date1, date0) {
	            if (largeUnit) {
	                return util_1.diffByUnit(date1, date0, largeUnit); // poorly named
	            }
	            else if (dateProfile1.isAllDay()) {
	                return util_1.diffDay(date1, date0); // poorly named
	            }
	            else {
	                return util_1.diffDayTime(date1, date0); // poorly named
	            }
	        }
	        dateDelta = subtractDates(dateProfile1.start, dateProfile0.start);
	        if (dateProfile1.end) {
	            // use unzonedRanges because dateProfile0.end might be null
	            endDiff = subtractDates(dateProfile1.unzonedRange.getEnd(), dateProfile0.unzonedRange.getEnd());
	            endDelta = endDiff.subtract(dateDelta);
	        }
	        mutation = new EventDefDateMutation();
	        mutation.clearEnd = clearEnd;
	        mutation.forceTimed = forceTimed;
	        mutation.forceAllDay = forceAllDay;
	        mutation.setDateDelta(dateDelta);
	        mutation.setEndDelta(endDelta);
	        return mutation;
	    };
	    /*
	    returns an undo function.
	    */
	    EventDefDateMutation.prototype.buildNewDateProfile = function (eventDateProfile, calendar) {
	        var start = eventDateProfile.start.clone();
	        var end = null;
	        var shouldRezone = false;
	        if (eventDateProfile.end && !this.clearEnd) {
	            end = eventDateProfile.end.clone();
	        }
	        else if (this.endDelta && !end) {
	            end = calendar.getDefaultEventEnd(eventDateProfile.isAllDay(), start);
	        }
	        if (this.forceTimed) {
	            shouldRezone = true;
	            if (!start.hasTime()) {
	                start.time(0);
	            }
	            if (end && !end.hasTime()) {
	                end.time(0);
	            }
	        }
	        else if (this.forceAllDay) {
	            if (start.hasTime()) {
	                start.stripTime();
	            }
	            if (end && end.hasTime()) {
	                end.stripTime();
	            }
	        }
	        if (this.dateDelta) {
	            shouldRezone = true;
	            start.add(this.dateDelta);
	            if (end) {
	                end.add(this.dateDelta);
	            }
	        }
	        // do this before adding startDelta to start, so we can work off of start
	        if (this.endDelta) {
	            shouldRezone = true;
	            end.add(this.endDelta);
	        }
	        if (this.startDelta) {
	            shouldRezone = true;
	            start.add(this.startDelta);
	        }
	        if (shouldRezone) {
	            start = calendar.applyTimezone(start);
	            if (end) {
	                end = calendar.applyTimezone(end);
	            }
	        }
	        // TODO: okay to access calendar option?
	        if (!end && calendar.opt('forceEventDuration')) {
	            end = calendar.getDefaultEventEnd(eventDateProfile.isAllDay(), start);
	        }
	        return new EventDateProfile_1.default(start, end, calendar);
	    };
	    EventDefDateMutation.prototype.setDateDelta = function (dateDelta) {
	        if (dateDelta && dateDelta.valueOf()) {
	            this.dateDelta = dateDelta;
	        }
	        else {
	            this.dateDelta = null;
	        }
	    };
	    EventDefDateMutation.prototype.setStartDelta = function (startDelta) {
	        if (startDelta && startDelta.valueOf()) {
	            this.startDelta = startDelta;
	        }
	        else {
	            this.startDelta = null;
	        }
	    };
	    EventDefDateMutation.prototype.setEndDelta = function (endDelta) {
	        if (endDelta && endDelta.valueOf()) {
	            this.endDelta = endDelta;
	        }
	        else {
	            this.endDelta = null;
	        }
	    };
	    EventDefDateMutation.prototype.isEmpty = function () {
	        return !this.clearEnd && !this.forceTimed && !this.forceAllDay &&
	            !this.dateDelta && !this.startDelta && !this.endDelta;
	    };
	    return EventDefDateMutation;
	}());
	exports.default = EventDefDateMutation;
	
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var Class_1 = __webpack_require__(35);
	/*
	Embodies a div that has potential scrollbars
	*/
	var Scroller = /** @class */ (function (_super) {
	    tslib_1.__extends(Scroller, _super);
	    function Scroller(options) {
	        var _this = _super.call(this) || this;
	        options = options || {};
	        _this.overflowX = options.overflowX || options.overflow || 'auto';
	        _this.overflowY = options.overflowY || options.overflow || 'auto';
	        return _this;
	    }
	    Scroller.prototype.render = function () {
	        this.el = this.renderEl();
	        this.applyOverflow();
	    };
	    Scroller.prototype.renderEl = function () {
	        return (this.scrollEl = $('<div class="fc-scroller"></div>'));
	    };
	    // sets to natural height, unlocks overflow
	    Scroller.prototype.clear = function () {
	        this.setHeight('auto');
	        this.applyOverflow();
	    };
	    Scroller.prototype.destroy = function () {
	        this.el.remove();
	    };
	    // Overflow
	    // -----------------------------------------------------------------------------------------------------------------
	    Scroller.prototype.applyOverflow = function () {
	        this.scrollEl.css({
	            'overflow-x': this.overflowX,
	            'overflow-y': this.overflowY
	        });
	    };
	    // Causes any 'auto' overflow values to resolves to 'scroll' or 'hidden'.
	    // Useful for preserving scrollbar widths regardless of future resizes.
	    // Can pass in scrollbarWidths for optimization.
	    Scroller.prototype.lockOverflow = function (scrollbarWidths) {
	        var overflowX = this.overflowX;
	        var overflowY = this.overflowY;
	        scrollbarWidths = scrollbarWidths || this.getScrollbarWidths();
	        if (overflowX === 'auto') {
	            overflowX = (scrollbarWidths.top || scrollbarWidths.bottom || // horizontal scrollbars?
	                // OR scrolling pane with massless scrollbars?
	                this.scrollEl[0].scrollWidth - 1 > this.scrollEl[0].clientWidth
	            // subtract 1 because of IE off-by-one issue
	            ) ? 'scroll' : 'hidden';
	        }
	        if (overflowY === 'auto') {
	            overflowY = (scrollbarWidths.left || scrollbarWidths.right || // vertical scrollbars?
	                // OR scrolling pane with massless scrollbars?
	                this.scrollEl[0].scrollHeight - 1 > this.scrollEl[0].clientHeight
	            // subtract 1 because of IE off-by-one issue
	            ) ? 'scroll' : 'hidden';
	        }
	        this.scrollEl.css({ 'overflow-x': overflowX, 'overflow-y': overflowY });
	    };
	    // Getters / Setters
	    // -----------------------------------------------------------------------------------------------------------------
	    Scroller.prototype.setHeight = function (height) {
	        this.scrollEl.height(height);
	    };
	    Scroller.prototype.getScrollTop = function () {
	        return this.scrollEl.scrollTop();
	    };
	    Scroller.prototype.setScrollTop = function (top) {
	        this.scrollEl.scrollTop(top);
	    };
	    Scroller.prototype.getClientWidth = function () {
	        return this.scrollEl[0].clientWidth;
	    };
	    Scroller.prototype.getClientHeight = function () {
	        return this.scrollEl[0].clientHeight;
	    };
	    Scroller.prototype.getScrollbarWidths = function () {
	        return util_1.getScrollbarWidths(this.scrollEl);
	    };
	    return Scroller;
	}(Class_1.default));
	exports.default = Scroller;
	
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var DateComponent_1 = __webpack_require__(231);
	var GlobalEmitter_1 = __webpack_require__(23);
	var InteractiveDateComponent = /** @class */ (function (_super) {
	    tslib_1.__extends(InteractiveDateComponent, _super);
	    function InteractiveDateComponent(_view, _options) {
	        var _this = _super.call(this, _view, _options) || this;
	        // self-config, overridable by subclasses
	        _this.segSelector = '.fc-event-container > *'; // what constitutes an event element?
	        if (_this.dateSelectingClass) {
	            _this.dateClicking = new _this.dateClickingClass(_this);
	        }
	        if (_this.dateSelectingClass) {
	            _this.dateSelecting = new _this.dateSelectingClass(_this);
	        }
	        if (_this.eventPointingClass) {
	            _this.eventPointing = new _this.eventPointingClass(_this);
	        }
	        if (_this.eventDraggingClass && _this.eventPointing) {
	            _this.eventDragging = new _this.eventDraggingClass(_this, _this.eventPointing);
	        }
	        if (_this.eventResizingClass && _this.eventPointing) {
	            _this.eventResizing = new _this.eventResizingClass(_this, _this.eventPointing);
	        }
	        if (_this.externalDroppingClass) {
	            _this.externalDropping = new _this.externalDroppingClass(_this);
	        }
	        return _this;
	    }
	    // Sets the container element that the view should render inside of, does global DOM-related initializations,
	    // and renders all the non-date-related content inside.
	    InteractiveDateComponent.prototype.setElement = function (el) {
	        _super.prototype.setElement.call(this, el);
	        if (this.dateClicking) {
	            this.dateClicking.bindToEl(el);
	        }
	        if (this.dateSelecting) {
	            this.dateSelecting.bindToEl(el);
	        }
	        this.bindAllSegHandlersToEl(el);
	    };
	    InteractiveDateComponent.prototype.removeElement = function () {
	        this.endInteractions();
	        _super.prototype.removeElement.call(this);
	    };
	    InteractiveDateComponent.prototype.executeEventUnrender = function () {
	        this.endInteractions();
	        _super.prototype.executeEventUnrender.call(this);
	    };
	    InteractiveDateComponent.prototype.bindGlobalHandlers = function () {
	        _super.prototype.bindGlobalHandlers.call(this);
	        if (this.externalDropping) {
	            this.externalDropping.bindToDocument();
	        }
	    };
	    InteractiveDateComponent.prototype.unbindGlobalHandlers = function () {
	        _super.prototype.unbindGlobalHandlers.call(this);
	        if (this.externalDropping) {
	            this.externalDropping.unbindFromDocument();
	        }
	    };
	    InteractiveDateComponent.prototype.bindDateHandlerToEl = function (el, name, handler) {
	        var _this = this;
	        // attach a handler to the grid's root element.
	        // jQuery will take care of unregistering them when removeElement gets called.
	        this.el.on(name, function (ev) {
	            if (!$(ev.target).is(_this.segSelector + ':not(.fc-helper),' + // directly on an event element
	                _this.segSelector + ':not(.fc-helper) *,' + // within an event element
	                '.fc-more,' + // a "more.." link
	                'a[data-goto]' // a clickable nav link
	            )) {
	                return handler.call(_this, ev);
	            }
	        });
	    };
	    InteractiveDateComponent.prototype.bindAllSegHandlersToEl = function (el) {
	        [
	            this.eventPointing,
	            this.eventDragging,
	            this.eventResizing
	        ].forEach(function (eventInteraction) {
	            if (eventInteraction) {
	                eventInteraction.bindToEl(el);
	            }
	        });
	    };
	    InteractiveDateComponent.prototype.bindSegHandlerToEl = function (el, name, handler) {
	        var _this = this;
	        el.on(name, this.segSelector, function (ev) {
	            var segEl = $(ev.currentTarget);
	            if (!segEl.is('.fc-helper')) {
	                var seg = segEl.data('fc-seg'); // grab segment data. put there by View::renderEventsPayload
	                if (seg && !_this.shouldIgnoreEventPointing()) {
	                    return handler.call(_this, seg, ev); // context will be the Grid
	                }
	            }
	        });
	    };
	    InteractiveDateComponent.prototype.shouldIgnoreMouse = function () {
	        // HACK
	        // This will still work even though bindDateHandlerToEl doesn't use GlobalEmitter.
	        return GlobalEmitter_1.default.get().shouldIgnoreMouse();
	    };
	    InteractiveDateComponent.prototype.shouldIgnoreTouch = function () {
	        var view = this._getView();
	        // On iOS (and Android?) when a new selection is initiated overtop another selection,
	        // the touchend never fires because the elements gets removed mid-touch-interaction (my theory).
	        // HACK: simply don't allow this to happen.
	        // ALSO: prevent selection when an *event* is already raised.
	        return view.isSelected || view.selectedEvent;
	    };
	    InteractiveDateComponent.prototype.shouldIgnoreEventPointing = function () {
	        // only call the handlers if there is not a drag/resize in progress
	        return (this.eventDragging && this.eventDragging.isDragging) ||
	            (this.eventResizing && this.eventResizing.isResizing);
	    };
	    InteractiveDateComponent.prototype.canStartSelection = function (seg, ev) {
	        return util_1.getEvIsTouch(ev) &&
	            !this.canStartResize(seg, ev) &&
	            (this.isEventDefDraggable(seg.footprint.eventDef) ||
	                this.isEventDefResizable(seg.footprint.eventDef));
	    };
	    InteractiveDateComponent.prototype.canStartDrag = function (seg, ev) {
	        return !this.canStartResize(seg, ev) &&
	            this.isEventDefDraggable(seg.footprint.eventDef);
	    };
	    InteractiveDateComponent.prototype.canStartResize = function (seg, ev) {
	        var view = this._getView();
	        var eventDef = seg.footprint.eventDef;
	        return (!util_1.getEvIsTouch(ev) || view.isEventDefSelected(eventDef)) &&
	            this.isEventDefResizable(eventDef) &&
	            $(ev.target).is('.fc-resizer');
	    };
	    // Kills all in-progress dragging.
	    // Useful for when public API methods that result in re-rendering are invoked during a drag.
	    // Also useful for when touch devices misbehave and don't fire their touchend.
	    InteractiveDateComponent.prototype.endInteractions = function () {
	        [
	            this.dateClicking,
	            this.dateSelecting,
	            this.eventPointing,
	            this.eventDragging,
	            this.eventResizing
	        ].forEach(function (interaction) {
	            if (interaction) {
	                interaction.end();
	            }
	        });
	    };
	    // Event Drag-n-Drop
	    // ---------------------------------------------------------------------------------------------------------------
	    // Computes if the given event is allowed to be dragged by the user
	    InteractiveDateComponent.prototype.isEventDefDraggable = function (eventDef) {
	        return this.isEventDefStartEditable(eventDef);
	    };
	    InteractiveDateComponent.prototype.isEventDefStartEditable = function (eventDef) {
	        var isEditable = eventDef.isStartExplicitlyEditable();
	        if (isEditable == null) {
	            isEditable = this.opt('eventStartEditable');
	            if (isEditable == null) {
	                isEditable = this.isEventDefGenerallyEditable(eventDef);
	            }
	        }
	        return isEditable;
	    };
	    InteractiveDateComponent.prototype.isEventDefGenerallyEditable = function (eventDef) {
	        var isEditable = eventDef.isExplicitlyEditable();
	        if (isEditable == null) {
	            isEditable = this.opt('editable');
	        }
	        return isEditable;
	    };
	    // Event Resizing
	    // ---------------------------------------------------------------------------------------------------------------
	    // Computes if the given event is allowed to be resized from its starting edge
	    InteractiveDateComponent.prototype.isEventDefResizableFromStart = function (eventDef) {
	        return this.opt('eventResizableFromStart') && this.isEventDefResizable(eventDef);
	    };
	    // Computes if the given event is allowed to be resized from its ending edge
	    InteractiveDateComponent.prototype.isEventDefResizableFromEnd = function (eventDef) {
	        return this.isEventDefResizable(eventDef);
	    };
	    // Computes if the given event is allowed to be resized by the user at all
	    InteractiveDateComponent.prototype.isEventDefResizable = function (eventDef) {
	        var isResizable = eventDef.isDurationExplicitlyEditable();
	        if (isResizable == null) {
	            isResizable = this.opt('eventDurationEditable');
	            if (isResizable == null) {
	                isResizable = this.isEventDefGenerallyEditable(eventDef);
	            }
	        }
	        return isResizable;
	    };
	    // Event Mutation / Constraints
	    // ---------------------------------------------------------------------------------------------------------------
	    // Diffs the two dates, returning a duration, based on granularity of the grid
	    // TODO: port isTimeScale into this system?
	    InteractiveDateComponent.prototype.diffDates = function (a, b) {
	        if (this.largeUnit) {
	            return util_1.diffByUnit(a, b, this.largeUnit);
	        }
	        else {
	            return util_1.diffDayTime(a, b);
	        }
	    };
	    // is it allowed, in relation to the view's validRange?
	    // NOTE: very similar to isExternalInstanceGroupAllowed
	    InteractiveDateComponent.prototype.isEventInstanceGroupAllowed = function (eventInstanceGroup) {
	        var view = this._getView();
	        var dateProfile = this.dateProfile;
	        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
	        var i;
	        for (i = 0; i < eventFootprints.length; i++) {
	            // TODO: just use getAllEventRanges directly
	            if (!dateProfile.validUnzonedRange.containsRange(eventFootprints[i].componentFootprint.unzonedRange)) {
	                return false;
	            }
	        }
	        return view.calendar.constraints.isEventInstanceGroupAllowed(eventInstanceGroup);
	    };
	    // NOTE: very similar to isEventInstanceGroupAllowed
	    // when it's a completely anonymous external drag, no event.
	    InteractiveDateComponent.prototype.isExternalInstanceGroupAllowed = function (eventInstanceGroup) {
	        var view = this._getView();
	        var dateProfile = this.dateProfile;
	        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
	        var i;
	        for (i = 0; i < eventFootprints.length; i++) {
	            if (!dateProfile.validUnzonedRange.containsRange(eventFootprints[i].componentFootprint.unzonedRange)) {
	                return false;
	            }
	        }
	        for (i = 0; i < eventFootprints.length; i++) {
	            // treat it as a selection
	            // TODO: pass in eventInstanceGroup instead
	            //  because we don't want calendar's constraint system to depend on a component's
	            //  determination of footprints.
	            if (!view.calendar.constraints.isSelectionFootprintAllowed(eventFootprints[i].componentFootprint)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    return InteractiveDateComponent;
	}(DateComponent_1.default));
	exports.default = InteractiveDateComponent;
	
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var moment = __webpack_require__(0);
	var util_1 = __webpack_require__(4);
	var RenderQueue_1 = __webpack_require__(229);
	var DateProfileGenerator_1 = __webpack_require__(55);
	var InteractiveDateComponent_1 = __webpack_require__(42);
	var GlobalEmitter_1 = __webpack_require__(23);
	var UnzonedRange_1 = __webpack_require__(5);
	/* An abstract class from which other views inherit from
	----------------------------------------------------------------------------------------------------------------------*/
	var View = /** @class */ (function (_super) {
	    tslib_1.__extends(View, _super);
	    function View(calendar, viewSpec) {
	        var _this = _super.call(this, null, viewSpec.options) || this;
	        _this.batchRenderDepth = 0;
	        _this.isSelected = false; // boolean whether a range of time is user-selected or not
	        _this.calendar = calendar;
	        _this.viewSpec = viewSpec;
	        // shortcuts
	        _this.type = viewSpec.type;
	        // .name is deprecated
	        _this.name = _this.type;
	        _this.initRenderQueue();
	        _this.initHiddenDays();
	        _this.dateProfileGenerator = new _this.dateProfileGeneratorClass(_this);
	        _this.bindBaseRenderHandlers();
	        _this.eventOrderSpecs = util_1.parseFieldSpecs(_this.opt('eventOrder'));
	        // legacy
	        if (_this['initialize']) {
	            _this['initialize']();
	        }
	        return _this;
	    }
	    View.prototype._getView = function () {
	        return this;
	    };
	    // Retrieves an option with the given name
	    View.prototype.opt = function (name) {
	        return this.options[name];
	    };
	    /* Render Queue
	    ------------------------------------------------------------------------------------------------------------------*/
	    View.prototype.initRenderQueue = function () {
	        this.renderQueue = new RenderQueue_1.default({
	            event: this.opt('eventRenderWait')
	        });
	        this.renderQueue.on('start', this.onRenderQueueStart.bind(this));
	        this.renderQueue.on('stop', this.onRenderQueueStop.bind(this));
	        this.on('before:change', this.startBatchRender);
	        this.on('change', this.stopBatchRender);
	    };
	    View.prototype.onRenderQueueStart = function () {
	        this.calendar.freezeContentHeight();
	        this.addScroll(this.queryScroll());
	    };
	    View.prototype.onRenderQueueStop = function () {
	        if (this.calendar.updateViewSize()) { // success?
	            this.popScroll();
	        }
	        this.calendar.thawContentHeight();
	    };
	    View.prototype.startBatchRender = function () {
	        if (!(this.batchRenderDepth++)) {
	            this.renderQueue.pause();
	        }
	    };
	    View.prototype.stopBatchRender = function () {
	        if (!(--this.batchRenderDepth)) {
	            this.renderQueue.resume();
	        }
	    };
	    View.prototype.requestRender = function (func, namespace, actionType) {
	        this.renderQueue.queue(func, namespace, actionType);
	    };
	    // given func will auto-bind to `this`
	    View.prototype.whenSizeUpdated = function (func) {
	        if (this.renderQueue.isRunning) {
	            this.renderQueue.one('stop', func.bind(this));
	        }
	        else {
	            func.call(this);
	        }
	    };
	    /* Title and Date Formatting
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Computes what the title at the top of the calendar should be for this view
	    View.prototype.computeTitle = function (dateProfile) {
	        var unzonedRange;
	        // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
	        if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) {
	            unzonedRange = dateProfile.currentUnzonedRange;
	        }
	        else { // for day units or smaller, use the actual day range
	            unzonedRange = dateProfile.activeUnzonedRange;
	        }
	        return this.formatRange({
	            start: this.calendar.msToMoment(unzonedRange.startMs, dateProfile.isRangeAllDay),
	            end: this.calendar.msToMoment(unzonedRange.endMs, dateProfile.isRangeAllDay)
	        }, dateProfile.isRangeAllDay, this.opt('titleFormat') || this.computeTitleFormat(dateProfile), this.opt('titleRangeSeparator'));
	    };
	    // Generates the format string that should be used to generate the title for the current date range.
	    // Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
	    View.prototype.computeTitleFormat = function (dateProfile) {
	        var currentRangeUnit = dateProfile.currentRangeUnit;
	        if (currentRangeUnit === 'year') {
	            return 'YYYY';
	        }
	        else if (currentRangeUnit === 'month') {
	            return this.opt('monthYearFormat'); // like "September 2014"
	        }
	        else if (dateProfile.currentUnzonedRange.as('days') > 1) {
	            return 'll'; // multi-day range. shorter, like "Sep 9 - 10 2014"
	        }
	        else {
	            return 'LL'; // one day. longer, like "September 9 2014"
	        }
	    };
	    // Date Setting/Unsetting
	    // -----------------------------------------------------------------------------------------------------------------
	    View.prototype.setDate = function (date) {
	        var currentDateProfile = this.get('dateProfile');
	        var newDateProfile = this.dateProfileGenerator.build(date, undefined, true); // forceToValid=true
	        if (!currentDateProfile ||
	            !currentDateProfile.activeUnzonedRange.equals(newDateProfile.activeUnzonedRange)) {
	            this.set('dateProfile', newDateProfile);
	        }
	    };
	    View.prototype.unsetDate = function () {
	        this.unset('dateProfile');
	    };
	    // Event Data
	    // -----------------------------------------------------------------------------------------------------------------
	    View.prototype.fetchInitialEvents = function (dateProfile) {
	        var calendar = this.calendar;
	        var forceAllDay = dateProfile.isRangeAllDay && !this.usesMinMaxTime;
	        return calendar.requestEvents(calendar.msToMoment(dateProfile.activeUnzonedRange.startMs, forceAllDay), calendar.msToMoment(dateProfile.activeUnzonedRange.endMs, forceAllDay));
	    };
	    View.prototype.bindEventChanges = function () {
	        this.listenTo(this.calendar, 'eventsReset', this.resetEvents); // TODO: make this a real event
	    };
	    View.prototype.unbindEventChanges = function () {
	        this.stopListeningTo(this.calendar, 'eventsReset');
	    };
	    View.prototype.setEvents = function (eventsPayload) {
	        this.set('currentEvents', eventsPayload);
	        this.set('hasEvents', true);
	    };
	    View.prototype.unsetEvents = function () {
	        this.unset('currentEvents');
	        this.unset('hasEvents');
	    };
	    View.prototype.resetEvents = function (eventsPayload) {
	        this.startBatchRender();
	        this.unsetEvents();
	        this.setEvents(eventsPayload);
	        this.stopBatchRender();
	    };
	    // Date High-level Rendering
	    // -----------------------------------------------------------------------------------------------------------------
	    View.prototype.requestDateRender = function (dateProfile) {
	        var _this = this;
	        this.requestRender(function () {
	            _this.executeDateRender(dateProfile);
	        }, 'date', 'init');
	    };
	    View.prototype.requestDateUnrender = function () {
	        var _this = this;
	        this.requestRender(function () {
	            _this.executeDateUnrender();
	        }, 'date', 'destroy');
	    };
	    // if dateProfile not specified, uses current
	    View.prototype.executeDateRender = function (dateProfile) {
	        _super.prototype.executeDateRender.call(this, dateProfile);
	        if (this['render']) {
	            this['render'](); // TODO: deprecate
	        }
	        this.trigger('datesRendered');
	        this.addScroll({ isDateInit: true });
	        this.startNowIndicator(); // shouldn't render yet because updateSize will be called soon
	    };
	    View.prototype.executeDateUnrender = function () {
	        this.unselect();
	        this.stopNowIndicator();
	        this.trigger('before:datesUnrendered');
	        if (this['destroy']) {
	            this['destroy'](); // TODO: deprecate
	        }
	        _super.prototype.executeDateUnrender.call(this);
	    };
	    // "Base" rendering
	    // -----------------------------------------------------------------------------------------------------------------
	    View.prototype.bindBaseRenderHandlers = function () {
	        var _this = this;
	        this.on('datesRendered', function () {
	            _this.whenSizeUpdated(_this.triggerViewRender);
	        });
	        this.on('before:datesUnrendered', function () {
	            _this.triggerViewDestroy();
	        });
	    };
	    View.prototype.triggerViewRender = function () {
	        this.publiclyTrigger('viewRender', {
	            context: this,
	            args: [this, this.el]
	        });
	    };
	    View.prototype.triggerViewDestroy = function () {
	        this.publiclyTrigger('viewDestroy', {
	            context: this,
	            args: [this, this.el]
	        });
	    };
	    // Event High-level Rendering
	    // -----------------------------------------------------------------------------------------------------------------
	    View.prototype.requestEventsRender = function (eventsPayload) {
	        var _this = this;
	        this.requestRender(function () {
	            _this.executeEventRender(eventsPayload);
	            _this.whenSizeUpdated(_this.triggerAfterEventsRendered);
	        }, 'event', 'init');
	    };
	    View.prototype.requestEventsUnrender = function () {
	        var _this = this;
	        this.requestRender(function () {
	            _this.triggerBeforeEventsDestroyed();
	            _this.executeEventUnrender();
	        }, 'event', 'destroy');
	    };
	    // Business Hour High-level Rendering
	    // -----------------------------------------------------------------------------------------------------------------
	    View.prototype.requestBusinessHoursRender = function (businessHourGenerator) {
	        var _this = this;
	        this.requestRender(function () {
	            _this.renderBusinessHours(businessHourGenerator);
	        }, 'businessHours', 'init');
	    };
	    View.prototype.requestBusinessHoursUnrender = function () {
	        var _this = this;
	        this.requestRender(function () {
	            _this.unrenderBusinessHours();
	        }, 'businessHours', 'destroy');
	    };
	    // Misc view rendering utils
	    // -----------------------------------------------------------------------------------------------------------------
	    // Binds DOM handlers to elements that reside outside the view container, such as the document
	    View.prototype.bindGlobalHandlers = function () {
	        _super.prototype.bindGlobalHandlers.call(this);
	        this.listenTo(GlobalEmitter_1.default.get(), {
	            touchstart: this.processUnselect,
	            mousedown: this.handleDocumentMousedown
	        });
	    };
	    // Unbinds DOM handlers from elements that reside outside the view container
	    View.prototype.unbindGlobalHandlers = function () {
	        _super.prototype.unbindGlobalHandlers.call(this);
	        this.stopListeningTo(GlobalEmitter_1.default.get());
	    };
	    /* Now Indicator
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Immediately render the current time indicator and begins re-rendering it at an interval,
	    // which is defined by this.getNowIndicatorUnit().
	    // TODO: somehow do this for the current whole day's background too
	    View.prototype.startNowIndicator = function () {
	        var _this = this;
	        var unit;
	        var update;
	        var delay; // ms wait value
	        if (this.opt('nowIndicator')) {
	            unit = this.getNowIndicatorUnit();
	            if (unit) {
	                update = util_1.proxy(this, 'updateNowIndicator'); // bind to `this`
	                this.initialNowDate = this.calendar.getNow();
	                this.initialNowQueriedMs = new Date().valueOf();
	                // wait until the beginning of the next interval
	                delay = this.initialNowDate.clone().startOf(unit).add(1, unit).valueOf() - this.initialNowDate.valueOf();
	                this.nowIndicatorTimeoutID = setTimeout(function () {
	                    _this.nowIndicatorTimeoutID = null;
	                    update();
	                    delay = +moment.duration(1, unit);
	                    delay = Math.max(100, delay); // prevent too frequent
	                    _this.nowIndicatorIntervalID = setInterval(update, delay); // update every interval
	                }, delay);
	            }
	            // rendering will be initiated in updateSize
	        }
	    };
	    // rerenders the now indicator, computing the new current time from the amount of time that has passed
	    // since the initial getNow call.
	    View.prototype.updateNowIndicator = function () {
	        if (this.isDatesRendered &&
	            this.initialNowDate // activated before?
	        ) {
	            this.unrenderNowIndicator(); // won't unrender if unnecessary
	            this.renderNowIndicator(this.initialNowDate.clone().add(new Date().valueOf() - this.initialNowQueriedMs) // add ms
	            );
	            this.isNowIndicatorRendered = true;
	        }
	    };
	    // Immediately unrenders the view's current time indicator and stops any re-rendering timers.
	    // Won't cause side effects if indicator isn't rendered.
	    View.prototype.stopNowIndicator = function () {
	        if (this.isNowIndicatorRendered) {
	            if (this.nowIndicatorTimeoutID) {
	                clearTimeout(this.nowIndicatorTimeoutID);
	                this.nowIndicatorTimeoutID = null;
	            }
	            if (this.nowIndicatorIntervalID) {
	                clearInterval(this.nowIndicatorIntervalID);
	                this.nowIndicatorIntervalID = null;
	            }
	            this.unrenderNowIndicator();
	            this.isNowIndicatorRendered = false;
	        }
	    };
	    /* Dimensions
	    ------------------------------------------------------------------------------------------------------------------*/
	    View.prototype.updateSize = function (totalHeight, isAuto, isResize) {
	        if (this['setHeight']) { // for legacy API
	            this['setHeight'](totalHeight, isAuto);
	        }
	        else {
	            _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
	        }
	        this.updateNowIndicator();
	    };
	    /* Scroller
	    ------------------------------------------------------------------------------------------------------------------*/
	    View.prototype.addScroll = function (scroll) {
	        var queuedScroll = this.queuedScroll || (this.queuedScroll = {});
	        $.extend(queuedScroll, scroll);
	    };
	    View.prototype.popScroll = function () {
	        this.applyQueuedScroll();
	        this.queuedScroll = null;
	    };
	    View.prototype.applyQueuedScroll = function () {
	        if (this.queuedScroll) {
	            this.applyScroll(this.queuedScroll);
	        }
	    };
	    View.prototype.queryScroll = function () {
	        var scroll = {};
	        if (this.isDatesRendered) {
	            $.extend(scroll, this.queryDateScroll());
	        }
	        return scroll;
	    };
	    View.prototype.applyScroll = function (scroll) {
	        if (scroll.isDateInit && this.isDatesRendered) {
	            $.extend(scroll, this.computeInitialDateScroll());
	        }
	        if (this.isDatesRendered) {
	            this.applyDateScroll(scroll);
	        }
	    };
	    View.prototype.computeInitialDateScroll = function () {
	        return {}; // subclasses must implement
	    };
	    View.prototype.queryDateScroll = function () {
	        return {}; // subclasses must implement
	    };
	    View.prototype.applyDateScroll = function (scroll) {
	        // subclasses must implement
	    };
	    /* Event Drag-n-Drop
	    ------------------------------------------------------------------------------------------------------------------*/
	    View.prototype.reportEventDrop = function (eventInstance, eventMutation, el, ev) {
	        var eventManager = this.calendar.eventManager;
	        var undoFunc = eventManager.mutateEventsWithId(eventInstance.def.id, eventMutation);
	        var dateMutation = eventMutation.dateMutation;
	        // update the EventInstance, for handlers
	        if (dateMutation) {
	            eventInstance.dateProfile = dateMutation.buildNewDateProfile(eventInstance.dateProfile, this.calendar);
	        }
	        this.triggerEventDrop(eventInstance, 
	        // a drop doesn't necessarily mean a date mutation (ex: resource change)
	        (dateMutation && dateMutation.dateDelta) || moment.duration(), undoFunc, el, ev);
	    };
	    // Triggers event-drop handlers that have subscribed via the API
	    View.prototype.triggerEventDrop = function (eventInstance, dateDelta, undoFunc, el, ev) {
	        this.publiclyTrigger('eventDrop', {
	            context: el[0],
	            args: [
	                eventInstance.toLegacy(),
	                dateDelta,
	                undoFunc,
	                ev,
	                {},
	                this
	            ]
	        });
	    };
	    /* External Element Drag-n-Drop
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Must be called when an external element, via jQuery UI, has been dropped onto the calendar.
	    // `meta` is the parsed data that has been embedded into the dragging event.
	    // `dropLocation` is an object that contains the new zoned start/end/allDay values for the event.
	    View.prototype.reportExternalDrop = function (singleEventDef, isEvent, isSticky, el, ev, ui) {
	        if (isEvent) {
	            this.calendar.eventManager.addEventDef(singleEventDef, isSticky);
	        }
	        this.triggerExternalDrop(singleEventDef, isEvent, el, ev, ui);
	    };
	    // Triggers external-drop handlers that have subscribed via the API
	    View.prototype.triggerExternalDrop = function (singleEventDef, isEvent, el, ev, ui) {
	        // trigger 'drop' regardless of whether element represents an event
	        this.publiclyTrigger('drop', {
	            context: el[0],
	            args: [
	                singleEventDef.dateProfile.start.clone(),
	                ev,
	                ui,
	                this
	            ]
	        });
	        if (isEvent) {
	            // signal an external event landed
	            this.publiclyTrigger('eventReceive', {
	                context: this,
	                args: [
	                    singleEventDef.buildInstance().toLegacy(),
	                    this
	                ]
	            });
	        }
	    };
	    /* Event Resizing
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Must be called when an event in the view has been resized to a new length
	    View.prototype.reportEventResize = function (eventInstance, eventMutation, el, ev) {
	        var eventManager = this.calendar.eventManager;
	        var undoFunc = eventManager.mutateEventsWithId(eventInstance.def.id, eventMutation);
	        // update the EventInstance, for handlers
	        eventInstance.dateProfile = eventMutation.dateMutation.buildNewDateProfile(eventInstance.dateProfile, this.calendar);
	        var resizeDelta = eventMutation.dateMutation.endDelta || eventMutation.dateMutation.startDelta;
	        this.triggerEventResize(eventInstance, resizeDelta, undoFunc, el, ev);
	    };
	    // Triggers event-resize handlers that have subscribed via the API
	    View.prototype.triggerEventResize = function (eventInstance, resizeDelta, undoFunc, el, ev) {
	        this.publiclyTrigger('eventResize', {
	            context: el[0],
	            args: [
	                eventInstance.toLegacy(),
	                resizeDelta,
	                undoFunc,
	                ev,
	                {},
	                this
	            ]
	        });
	    };
	    /* Selection (time range)
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Selects a date span on the view. `start` and `end` are both Moments.
	    // `ev` is the native mouse event that begin the interaction.
	    View.prototype.select = function (footprint, ev) {
	        this.unselect(ev);
	        this.renderSelectionFootprint(footprint);
	        this.reportSelection(footprint, ev);
	    };
	    View.prototype.renderSelectionFootprint = function (footprint) {
	        if (this['renderSelection']) { // legacy method in custom view classes
	            this['renderSelection'](footprint.toLegacy(this.calendar));
	        }
	        else {
	            _super.prototype.renderSelectionFootprint.call(this, footprint);
	        }
	    };
	    // Called when a new selection is made. Updates internal state and triggers handlers.
	    View.prototype.reportSelection = function (footprint, ev) {
	        this.isSelected = true;
	        this.triggerSelect(footprint, ev);
	    };
	    // Triggers handlers to 'select'
	    View.prototype.triggerSelect = function (footprint, ev) {
	        var dateProfile = this.calendar.footprintToDateProfile(footprint); // abuse of "Event"DateProfile?
	        this.publiclyTrigger('select', {
	            context: this,
	            args: [
	                dateProfile.start,
	                dateProfile.end,
	                ev,
	                this
	            ]
	        });
	    };
	    // Undoes a selection. updates in the internal state and triggers handlers.
	    // `ev` is the native mouse event that began the interaction.
	    View.prototype.unselect = function (ev) {
	        if (this.isSelected) {
	            this.isSelected = false;
	            if (this['destroySelection']) {
	                this['destroySelection'](); // TODO: deprecate
	            }
	            this.unrenderSelection();
	            this.publiclyTrigger('unselect', {
	                context: this,
	                args: [ev, this]
	            });
	        }
	    };
	    /* Event Selection
	    ------------------------------------------------------------------------------------------------------------------*/
	    View.prototype.selectEventInstance = function (eventInstance) {
	        if (!this.selectedEventInstance ||
	            this.selectedEventInstance !== eventInstance) {
	            this.unselectEventInstance();
	            this.getEventSegs().forEach(function (seg) {
	                if (seg.footprint.eventInstance === eventInstance &&
	                    seg.el // necessary?
	                ) {
	                    seg.el.addClass('fc-selected');
	                }
	            });
	            this.selectedEventInstance = eventInstance;
	        }
	    };
	    View.prototype.unselectEventInstance = function () {
	        if (this.selectedEventInstance) {
	            this.getEventSegs().forEach(function (seg) {
	                if (seg.el) { // necessary?
	                    seg.el.removeClass('fc-selected');
	                }
	            });
	            this.selectedEventInstance = null;
	        }
	    };
	    View.prototype.isEventDefSelected = function (eventDef) {
	        // event references might change on refetchEvents(), while selectedEventInstance doesn't,
	        // so compare IDs
	        return this.selectedEventInstance && this.selectedEventInstance.def.id === eventDef.id;
	    };
	    /* Mouse / Touch Unselecting (time range & event unselection)
	    ------------------------------------------------------------------------------------------------------------------*/
	    // TODO: move consistently to down/start or up/end?
	    // TODO: don't kill previous selection if touch scrolling
	    View.prototype.handleDocumentMousedown = function (ev) {
	        if (util_1.isPrimaryMouseButton(ev)) {
	            this.processUnselect(ev);
	        }
	    };
	    View.prototype.processUnselect = function (ev) {
	        this.processRangeUnselect(ev);
	        this.processEventUnselect(ev);
	    };
	    View.prototype.processRangeUnselect = function (ev) {
	        var ignore;
	        // is there a time-range selection?
	        if (this.isSelected && this.opt('unselectAuto')) {
	            // only unselect if the clicked element is not identical to or inside of an 'unselectCancel' element
	            ignore = this.opt('unselectCancel');
	            if (!ignore || !$(ev.target).closest(ignore).length) {
	                this.unselect(ev);
	            }
	        }
	    };
	    View.prototype.processEventUnselect = function (ev) {
	        if (this.selectedEventInstance) {
	            if (!$(ev.target).closest('.fc-selected').length) {
	                this.unselectEventInstance();
	            }
	        }
	    };
	    /* Triggers
	    ------------------------------------------------------------------------------------------------------------------*/
	    View.prototype.triggerBaseRendered = function () {
	        this.publiclyTrigger('viewRender', {
	            context: this,
	            args: [this, this.el]
	        });
	    };
	    View.prototype.triggerBaseUnrendered = function () {
	        this.publiclyTrigger('viewDestroy', {
	            context: this,
	            args: [this, this.el]
	        });
	    };
	    // Triggers handlers to 'dayClick'
	    // Span has start/end of the clicked area. Only the start is useful.
	    View.prototype.triggerDayClick = function (footprint, dayEl, ev) {
	        var dateProfile = this.calendar.footprintToDateProfile(footprint); // abuse of "Event"DateProfile?
	        this.publiclyTrigger('dayClick', {
	            context: dayEl,
	            args: [dateProfile.start, ev, this]
	        });
	    };
	    /* Date Utils
	    ------------------------------------------------------------------------------------------------------------------*/
	    // For DateComponent::getDayClasses
	    View.prototype.isDateInOtherMonth = function (date, dateProfile) {
	        return false;
	    };
	    // Arguments after name will be forwarded to a hypothetical function value
	    // WARNING: passed-in arguments will be given to generator functions as-is and can cause side-effects.
	    // Always clone your objects if you fear mutation.
	    View.prototype.getUnzonedRangeOption = function (name) {
	        var val = this.opt(name);
	        if (typeof val === 'function') {
	            val = val.apply(null, Array.prototype.slice.call(arguments, 1));
	        }
	        if (val) {
	            return this.calendar.parseUnzonedRange(val);
	        }
	    };
	    /* Hidden Days
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Initializes internal variables related to calculating hidden days-of-week
	    View.prototype.initHiddenDays = function () {
	        var hiddenDays = this.opt('hiddenDays') || []; // array of day-of-week indices that are hidden
	        var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
	        var dayCnt = 0;
	        var i;
	        if (this.opt('weekends') === false) {
	            hiddenDays.push(0, 6); // 0=sunday, 6=saturday
	        }
	        for (i = 0; i < 7; i++) {
	            if (!(isHiddenDayHash[i] = $.inArray(i, hiddenDays) !== -1)) {
	                dayCnt++;
	            }
	        }
	        if (!dayCnt) {
	            throw new Error('invalid hiddenDays'); // all days were hidden? bad.
	        }
	        this.isHiddenDayHash = isHiddenDayHash;
	    };
	    // Remove days from the beginning and end of the range that are computed as hidden.
	    // If the whole range is trimmed off, returns null
	    View.prototype.trimHiddenDays = function (inputUnzonedRange) {
	        var start = inputUnzonedRange.getStart();
	        var end = inputUnzonedRange.getEnd();
	        if (start) {
	            start = this.skipHiddenDays(start);
	        }
	        if (end) {
	            end = this.skipHiddenDays(end, -1, true);
	        }
	        if (start === null || end === null || start < end) {
	            return new UnzonedRange_1.default(start, end);
	        }
	        return null;
	    };
	    // Is the current day hidden?
	    // `day` is a day-of-week index (0-6), or a Moment
	    View.prototype.isHiddenDay = function (day) {
	        if (moment.isMoment(day)) {
	            day = day.day();
	        }
	        return this.isHiddenDayHash[day];
	    };
	    // Incrementing the current day until it is no longer a hidden day, returning a copy.
	    // DOES NOT CONSIDER validUnzonedRange!
	    // If the initial value of `date` is not a hidden day, don't do anything.
	    // Pass `isExclusive` as `true` if you are dealing with an end date.
	    // `inc` defaults to `1` (increment one day forward each time)
	    View.prototype.skipHiddenDays = function (date, inc, isExclusive) {
	        if (inc === void 0) { inc = 1; }
	        if (isExclusive === void 0) { isExclusive = false; }
	        var out = date.clone();
	        while (this.isHiddenDayHash[(out.day() + (isExclusive ? inc : 0) + 7) % 7]) {
	            out.add(inc, 'days');
	        }
	        return out;
	    };
	    return View;
	}(InteractiveDateComponent_1.default));
	exports.default = View;
	View.prototype.usesMinMaxTime = false;
	View.prototype.dateProfileGeneratorClass = DateProfileGenerator_1.default;
	View.watch('displayingDates', ['isInDom', 'dateProfile'], function (deps) {
	    this.requestDateRender(deps.dateProfile);
	}, function () {
	    this.requestDateUnrender();
	});
	View.watch('displayingBusinessHours', ['displayingDates', 'businessHourGenerator'], function (deps) {
	    this.requestBusinessHoursRender(deps.businessHourGenerator);
	}, function () {
	    this.requestBusinessHoursUnrender();
	});
	View.watch('initialEvents', ['dateProfile'], function (deps) {
	    return this.fetchInitialEvents(deps.dateProfile);
	});
	View.watch('bindingEvents', ['initialEvents'], function (deps) {
	    this.setEvents(deps.initialEvents);
	    this.bindEventChanges();
	}, function () {
	    this.unbindEventChanges();
	    this.unsetEvents();
	});
	View.watch('displayingEvents', ['displayingDates', 'hasEvents'], function () {
	    this.requestEventsRender(this.get('currentEvents'));
	}, function () {
	    this.requestEventsUnrender();
	});
	View.watch('title', ['dateProfile'], function (deps) {
	    return (this.title = this.computeTitle(deps.dateProfile)); // assign to View for legacy reasons
	});
	View.watch('legacyDateProps', ['dateProfile'], function (deps) {
	    var calendar = this.calendar;
	    var dateProfile = deps.dateProfile;
	    // DEPRECATED, but we need to keep it updated...
	    this.start = calendar.msToMoment(dateProfile.activeUnzonedRange.startMs, dateProfile.isRangeAllDay);
	    this.end = calendar.msToMoment(dateProfile.activeUnzonedRange.endMs, dateProfile.isRangeAllDay);
	    this.intervalStart = calendar.msToMoment(dateProfile.currentUnzonedRange.startMs, dateProfile.isRangeAllDay);
	    this.intervalEnd = calendar.msToMoment(dateProfile.currentUnzonedRange.endMs, dateProfile.isRangeAllDay);
	});
	
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var EventRenderer = /** @class */ (function () {
	    function EventRenderer(component, fillRenderer) {
	        this.view = component._getView();
	        this.component = component;
	        this.fillRenderer = fillRenderer;
	    }
	    EventRenderer.prototype.opt = function (name) {
	        return this.view.opt(name);
	    };
	    // Updates values that rely on options and also relate to range
	    EventRenderer.prototype.rangeUpdated = function () {
	        var displayEventTime;
	        var displayEventEnd;
	        this.eventTimeFormat =
	            this.opt('eventTimeFormat') ||
	                this.opt('timeFormat') || // deprecated
	                this.computeEventTimeFormat();
	        displayEventTime = this.opt('displayEventTime');
	        if (displayEventTime == null) {
	            displayEventTime = this.computeDisplayEventTime(); // might be based off of range
	        }
	        displayEventEnd = this.opt('displayEventEnd');
	        if (displayEventEnd == null) {
	            displayEventEnd = this.computeDisplayEventEnd(); // might be based off of range
	        }
	        this.displayEventTime = displayEventTime;
	        this.displayEventEnd = displayEventEnd;
	    };
	    EventRenderer.prototype.render = function (eventsPayload) {
	        var dateProfile = this.component._getDateProfile();
	        var eventDefId;
	        var instanceGroup;
	        var eventRanges;
	        var bgRanges = [];
	        var fgRanges = [];
	        for (eventDefId in eventsPayload) {
	            instanceGroup = eventsPayload[eventDefId];
	            eventRanges = instanceGroup.sliceRenderRanges(dateProfile.activeUnzonedRange);
	            if (instanceGroup.getEventDef().hasBgRendering()) {
	                bgRanges.push.apply(bgRanges, eventRanges);
	            }
	            else {
	                fgRanges.push.apply(fgRanges, eventRanges);
	            }
	        }
	        this.renderBgRanges(bgRanges);
	        this.renderFgRanges(fgRanges);
	    };
	    EventRenderer.prototype.unrender = function () {
	        this.unrenderBgRanges();
	        this.unrenderFgRanges();
	    };
	    EventRenderer.prototype.renderFgRanges = function (eventRanges) {
	        var eventFootprints = this.component.eventRangesToEventFootprints(eventRanges);
	        var segs = this.component.eventFootprintsToSegs(eventFootprints);
	        // render an `.el` on each seg
	        // returns a subset of the segs. segs that were actually rendered
	        segs = this.renderFgSegEls(segs);
	        if (this.renderFgSegs(segs) !== false) { // no failure?
	            this.fgSegs = segs;
	        }
	    };
	    EventRenderer.prototype.unrenderFgRanges = function () {
	        this.unrenderFgSegs(this.fgSegs || []);
	        this.fgSegs = null;
	    };
	    EventRenderer.prototype.renderBgRanges = function (eventRanges) {
	        var eventFootprints = this.component.eventRangesToEventFootprints(eventRanges);
	        var segs = this.component.eventFootprintsToSegs(eventFootprints);
	        if (this.renderBgSegs(segs) !== false) { // no failure?
	            this.bgSegs = segs;
	        }
	    };
	    EventRenderer.prototype.unrenderBgRanges = function () {
	        this.unrenderBgSegs();
	        this.bgSegs = null;
	    };
	    EventRenderer.prototype.getSegs = function () {
	        return (this.bgSegs || []).concat(this.fgSegs || []);
	    };
	    // Renders foreground event segments onto the grid
	    EventRenderer.prototype.renderFgSegs = function (segs) {
	        // subclasses must implement
	        // segs already has rendered els, and has been filtered.
	        return false; // signal failure if not implemented
	    };
	    // Unrenders all currently rendered foreground segments
	    EventRenderer.prototype.unrenderFgSegs = function (segs) {
	        // subclasses must implement
	    };
	    EventRenderer.prototype.renderBgSegs = function (segs) {
	        var _this = this;
	        if (this.fillRenderer) {
	            this.fillRenderer.renderSegs('bgEvent', segs, {
	                getClasses: function (seg) {
	                    return _this.getBgClasses(seg.footprint.eventDef);
	                },
	                getCss: function (seg) {
	                    return {
	                        'background-color': _this.getBgColor(seg.footprint.eventDef)
	                    };
	                },
	                filterEl: function (seg, el) {
	                    return _this.filterEventRenderEl(seg.footprint, el);
	                }
	            });
	        }
	        else {
	            return false; // signal failure if no fillRenderer
	        }
	    };
	    EventRenderer.prototype.unrenderBgSegs = function () {
	        if (this.fillRenderer) {
	            this.fillRenderer.unrender('bgEvent');
	        }
	    };
	    // Renders and assigns an `el` property for each foreground event segment.
	    // Only returns segments that successfully rendered.
	    EventRenderer.prototype.renderFgSegEls = function (segs, disableResizing) {
	        var _this = this;
	        if (disableResizing === void 0) { disableResizing = false; }
	        var hasEventRenderHandlers = this.view.hasPublicHandlers('eventRender');
	        var html = '';
	        var renderedSegs = [];
	        var i;
	        if (segs.length) { // don't build an empty html string
	            // build a large concatenation of event segment HTML
	            for (i = 0; i < segs.length; i++) {
	                this.beforeFgSegHtml(segs[i]);
	                html += this.fgSegHtml(segs[i], disableResizing);
	            }
	            // Grab individual elements from the combined HTML string. Use each as the default rendering.
	            // Then, compute the 'el' for each segment. An el might be null if the eventRender callback returned false.
	            $(html).each(function (i, node) {
	                var seg = segs[i];
	                var el = $(node);
	                if (hasEventRenderHandlers) { // optimization
	                    el = _this.filterEventRenderEl(seg.footprint, el);
	                }
	                if (el) {
	                    el.data('fc-seg', seg); // used by handlers
	                    seg.el = el;
	                    renderedSegs.push(seg);
	                }
	            });
	        }
	        return renderedSegs;
	    };
	    EventRenderer.prototype.beforeFgSegHtml = function (seg) {
	    };
	    // Generates the HTML for the default rendering of a foreground event segment. Used by renderFgSegEls()
	    EventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
	        // subclasses should implement
	    };
	    // Generic utility for generating the HTML classNames for an event segment's element
	    EventRenderer.prototype.getSegClasses = function (seg, isDraggable, isResizable) {
	        var classes = [
	            'fc-event',
	            seg.isStart ? 'fc-start' : 'fc-not-start',
	            seg.isEnd ? 'fc-end' : 'fc-not-end'
	        ].concat(this.getClasses(seg.footprint.eventDef));
	        if (isDraggable) {
	            classes.push('fc-draggable');
	        }
	        if (isResizable) {
	            classes.push('fc-resizable');
	        }
	        // event is currently selected? attach a className.
	        if (this.view.isEventDefSelected(seg.footprint.eventDef)) {
	            classes.push('fc-selected');
	        }
	        return classes;
	    };
	    // Given an event and the default element used for rendering, returns the element that should actually be used.
	    // Basically runs events and elements through the eventRender hook.
	    EventRenderer.prototype.filterEventRenderEl = function (eventFootprint, el) {
	        var legacy = eventFootprint.getEventLegacy();
	        var custom = this.view.publiclyTrigger('eventRender', {
	            context: legacy,
	            args: [legacy, el, this.view]
	        });
	        if (custom === false) { // means don't render at all
	            el = null;
	        }
	        else if (custom && custom !== true) {
	            el = $(custom);
	        }
	        return el;
	    };
	    // Compute the text that should be displayed on an event's element.
	    // `range` can be the Event object itself, or something range-like, with at least a `start`.
	    // If event times are disabled, or the event has no time, will return a blank string.
	    // If not specified, formatStr will default to the eventTimeFormat setting,
	    // and displayEnd will default to the displayEventEnd setting.
	    EventRenderer.prototype.getTimeText = function (eventFootprint, formatStr, displayEnd) {
	        return this._getTimeText(eventFootprint.eventInstance.dateProfile.start, eventFootprint.eventInstance.dateProfile.end, eventFootprint.componentFootprint.isAllDay, formatStr, displayEnd);
	    };
	    EventRenderer.prototype._getTimeText = function (start, end, isAllDay, formatStr, displayEnd) {
	        if (formatStr == null) {
	            formatStr = this.eventTimeFormat;
	        }
	        if (displayEnd == null) {
	            displayEnd = this.displayEventEnd;
	        }
	        if (this.displayEventTime && !isAllDay) {
	            if (displayEnd && end) {
	                return this.view.formatRange({ start: start, end: end }, false, // allDay
	                formatStr);
	            }
	            else {
	                return start.format(formatStr);
	            }
	        }
	        return '';
	    };
	    EventRenderer.prototype.computeEventTimeFormat = function () {
	        return this.opt('smallTimeFormat');
	    };
	    EventRenderer.prototype.computeDisplayEventTime = function () {
	        return true;
	    };
	    EventRenderer.prototype.computeDisplayEventEnd = function () {
	        return true;
	    };
	    EventRenderer.prototype.getBgClasses = function (eventDef) {
	        var classNames = this.getClasses(eventDef);
	        classNames.push('fc-bgevent');
	        return classNames;
	    };
	    EventRenderer.prototype.getClasses = function (eventDef) {
	        var objs = this.getStylingObjs(eventDef);
	        var i;
	        var classNames = [];
	        for (i = 0; i < objs.length; i++) {
	            classNames.push.apply(// append
	            classNames, objs[i].eventClassName || objs[i].className || []);
	        }
	        return classNames;
	    };
	    // Utility for generating event skin-related CSS properties
	    EventRenderer.prototype.getSkinCss = function (eventDef) {
	        return {
	            'background-color': this.getBgColor(eventDef),
	            'border-color': this.getBorderColor(eventDef),
	            color: this.getTextColor(eventDef)
	        };
	    };
	    // Queries for caller-specified color, then falls back to default
	    EventRenderer.prototype.getBgColor = function (eventDef) {
	        var objs = this.getStylingObjs(eventDef);
	        var i;
	        var val;
	        for (i = 0; i < objs.length && !val; i++) {
	            val = objs[i].eventBackgroundColor || objs[i].eventColor ||
	                objs[i].backgroundColor || objs[i].color;
	        }
	        if (!val) {
	            val = this.opt('eventBackgroundColor') || this.opt('eventColor');
	        }
	        return val;
	    };
	    // Queries for caller-specified color, then falls back to default
	    EventRenderer.prototype.getBorderColor = function (eventDef) {
	        var objs = this.getStylingObjs(eventDef);
	        var i;
	        var val;
	        for (i = 0; i < objs.length && !val; i++) {
	            val = objs[i].eventBorderColor || objs[i].eventColor ||
	                objs[i].borderColor || objs[i].color;
	        }
	        if (!val) {
	            val = this.opt('eventBorderColor') || this.opt('eventColor');
	        }
	        return val;
	    };
	    // Queries for caller-specified color, then falls back to default
	    EventRenderer.prototype.getTextColor = function (eventDef) {
	        var objs = this.getStylingObjs(eventDef);
	        var i;
	        var val;
	        for (i = 0; i < objs.length && !val; i++) {
	            val = objs[i].eventTextColor ||
	                objs[i].textColor;
	        }
	        if (!val) {
	            val = this.opt('eventTextColor');
	        }
	        return val;
	    };
	    EventRenderer.prototype.getStylingObjs = function (eventDef) {
	        var objs = this.getFallbackStylingObjs(eventDef);
	        objs.unshift(eventDef);
	        return objs;
	    };
	    EventRenderer.prototype.getFallbackStylingObjs = function (eventDef) {
	        return [eventDef.source];
	    };
	    EventRenderer.prototype.sortEventSegs = function (segs) {
	        segs.sort(util_1.proxy(this, 'compareEventSegs'));
	    };
	    // A cmp function for determining which segments should take visual priority
	    EventRenderer.prototype.compareEventSegs = function (seg1, seg2) {
	        var f1 = seg1.footprint;
	        var f2 = seg2.footprint;
	        var cf1 = f1.componentFootprint;
	        var cf2 = f2.componentFootprint;
	        var r1 = cf1.unzonedRange;
	        var r2 = cf2.unzonedRange;
	        return r1.startMs - r2.startMs || // earlier events go first
	            (r2.endMs - r2.startMs) - (r1.endMs - r1.startMs) || // tie? longer events go first
	            cf2.isAllDay - cf1.isAllDay || // tie? put all-day events first (booleans cast to 0/1)
	            util_1.compareByFieldSpecs(f1.eventDef, f2.eventDef, this.view.eventOrderSpecs, f1.eventDef.miscProps, f2.eventDef.miscProps);
	    };
	    return EventRenderer;
	}());
	exports.default = EventRenderer;
	
	
	/***/ }),
	/* 45 */,
	/* 46 */,
	/* 47 */,
	/* 48 */,
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment_ext_1 = __webpack_require__(11);
	// Plugin
	// -------------------------------------------------------------------------------------------------
	moment_ext_1.newMomentProto.format = function () {
	    if (this._fullCalendar && arguments[0]) { // an enhanced moment? and a format string provided?
	        return formatDate(this, arguments[0]); // our extended formatting
	    }
	    if (this._ambigTime) {
	        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD');
	    }
	    if (this._ambigZone) {
	        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD[T]HH:mm:ss');
	    }
	    if (this._fullCalendar) { // enhanced non-ambig moment?
	        // moment.format() doesn't ensure english, but we want to.
	        return moment_ext_1.oldMomentFormat(englishMoment(this));
	    }
	    return moment_ext_1.oldMomentProto.format.apply(this, arguments);
	};
	moment_ext_1.newMomentProto.toISOString = function () {
	    if (this._ambigTime) {
	        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD');
	    }
	    if (this._ambigZone) {
	        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD[T]HH:mm:ss');
	    }
	    if (this._fullCalendar) { // enhanced non-ambig moment?
	        // depending on browser, moment might not output english. ensure english.
	        // https://github.com/moment/moment/blob/2.18.1/src/lib/moment/format.js#L22
	        return moment_ext_1.oldMomentProto.toISOString.apply(englishMoment(this), arguments);
	    }
	    return moment_ext_1.oldMomentProto.toISOString.apply(this, arguments);
	};
	function englishMoment(mom) {
	    if (mom.locale() !== 'en') {
	        return mom.clone().locale('en');
	    }
	    return mom;
	}
	// Config
	// ---------------------------------------------------------------------------------------------------------------------
	/*
	Inserted between chunks in the fake ("intermediate") formatting string.
	Important that it passes as whitespace (\s) because moment often identifies non-standalone months
	via a regexp with an \s.
	*/
	var PART_SEPARATOR = '\u000b'; // vertical tab
	/*
	Inserted as the first character of a literal-text chunk to indicate that the literal text is not actually literal text,
	but rather, a "special" token that has custom rendering (see specialTokens map).
	*/
	var SPECIAL_TOKEN_MARKER = '\u001f'; // information separator 1
	/*
	Inserted at the beginning and end of a span of text that must have non-zero numeric characters.
	Handling of these markers is done in a post-processing step at the very end of text rendering.
	*/
	var MAYBE_MARKER = '\u001e'; // information separator 2
	var MAYBE_REGEXP = new RegExp(MAYBE_MARKER + '([^' + MAYBE_MARKER + ']*)' + MAYBE_MARKER, 'g'); // must be global
	/*
	Addition formatting tokens we want recognized
	*/
	var specialTokens = {
	    t: function (date) {
	        return moment_ext_1.oldMomentFormat(date, 'a').charAt(0);
	    },
	    T: function (date) {
	        return moment_ext_1.oldMomentFormat(date, 'A').charAt(0);
	    }
	};
	/*
	The first characters of formatting tokens for units that are 1 day or larger.
	`value` is for ranking relative size (lower means bigger).
	`unit` is a normalized unit, used for comparing moments.
	*/
	var largeTokenMap = {
	    Y: { value: 1, unit: 'year' },
	    M: { value: 2, unit: 'month' },
	    W: { value: 3, unit: 'week' },
	    w: { value: 3, unit: 'week' },
	    D: { value: 4, unit: 'day' },
	    d: { value: 4, unit: 'day' } // day of week
	};
	// Single Date Formatting
	// ---------------------------------------------------------------------------------------------------------------------
	/*
	Formats `date` with a Moment formatting string, but allow our non-zero areas and special token
	*/
	function formatDate(date, formatStr) {
	    return renderFakeFormatString(getParsedFormatString(formatStr).fakeFormatString, date);
	}
	exports.formatDate = formatDate;
	// Date Range Formatting
	// -------------------------------------------------------------------------------------------------
	// TODO: make it work with timezone offset
	/*
	Using a formatting string meant for a single date, generate a range string, like
	"Sep 2 - 9 2013", that intelligently inserts a separator where the dates differ.
	If the dates are the same as far as the format string is concerned, just return a single
	rendering of one date, without any separator.
	*/
	function formatRange(date1, date2, formatStr, separator, isRTL) {
	    var localeData;
	    date1 = moment_ext_1.default.parseZone(date1);
	    date2 = moment_ext_1.default.parseZone(date2);
	    localeData = date1.localeData();
	    // Expand localized format strings, like "LL" -> "MMMM D YYYY".
	    // BTW, this is not important for `formatDate` because it is impossible to put custom tokens
	    // or non-zero areas in Moment's localized format strings.
	    formatStr = localeData.longDateFormat(formatStr) || formatStr;
	    return renderParsedFormat(getParsedFormatString(formatStr), date1, date2, separator || ' - ', isRTL);
	}
	exports.formatRange = formatRange;
	/*
	Renders a range with an already-parsed format string.
	*/
	function renderParsedFormat(parsedFormat, date1, date2, separator, isRTL) {
	    var sameUnits = parsedFormat.sameUnits;
	    var unzonedDate1 = date1.clone().stripZone(); // for same-unit comparisons
	    var unzonedDate2 = date2.clone().stripZone(); // "
	    var renderedParts1 = renderFakeFormatStringParts(parsedFormat.fakeFormatString, date1);
	    var renderedParts2 = renderFakeFormatStringParts(parsedFormat.fakeFormatString, date2);
	    var leftI;
	    var leftStr = '';
	    var rightI;
	    var rightStr = '';
	    var middleI;
	    var middleStr1 = '';
	    var middleStr2 = '';
	    var middleStr = '';
	    // Start at the leftmost side of the formatting string and continue until you hit a token
	    // that is not the same between dates.
	    for (leftI = 0; leftI < sameUnits.length && (!sameUnits[leftI] || unzonedDate1.isSame(unzonedDate2, sameUnits[leftI])); leftI++) {
	        leftStr += renderedParts1[leftI];
	    }
	    // Similarly, start at the rightmost side of the formatting string and move left
	    for (rightI = sameUnits.length - 1; rightI > leftI && (!sameUnits[rightI] || unzonedDate1.isSame(unzonedDate2, sameUnits[rightI])); rightI--) {
	        // If current chunk is on the boundary of unique date-content, and is a special-case
	        // date-formatting postfix character, then don't consume it. Consider it unique date-content.
	        // TODO: make configurable
	        if (rightI - 1 === leftI && renderedParts1[rightI] === '.') {
	            break;
	        }
	        rightStr = renderedParts1[rightI] + rightStr;
	    }
	    // The area in the middle is different for both of the dates.
	    // Collect them distinctly so we can jam them together later.
	    for (middleI = leftI; middleI <= rightI; middleI++) {
	        middleStr1 += renderedParts1[middleI];
	        middleStr2 += renderedParts2[middleI];
	    }
	    if (middleStr1 || middleStr2) {
	        if (isRTL) {
	            middleStr = middleStr2 + separator + middleStr1;
	        }
	        else {
	            middleStr = middleStr1 + separator + middleStr2;
	        }
	    }
	    return processMaybeMarkers(leftStr + middleStr + rightStr);
	}
	// Format String Parsing
	// ---------------------------------------------------------------------------------------------------------------------
	var parsedFormatStrCache = {};
	/*
	Returns a parsed format string, leveraging a cache.
	*/
	function getParsedFormatString(formatStr) {
	    return parsedFormatStrCache[formatStr] ||
	        (parsedFormatStrCache[formatStr] = parseFormatString(formatStr));
	}
	/*
	Parses a format string into the following:
	- fakeFormatString: a momentJS formatting string, littered with special control characters that get post-processed.
	- sameUnits: for every part in fakeFormatString, if the part is a token, the value will be a unit string (like "day"),
	  that indicates how similar a range's start & end must be in order to share the same formatted text.
	  If not a token, then the value is null.
	  Always a flat array (not nested liked "chunks").
	*/
	function parseFormatString(formatStr) {
	    var chunks = chunkFormatString(formatStr);
	    return {
	        fakeFormatString: buildFakeFormatString(chunks),
	        sameUnits: buildSameUnits(chunks)
	    };
	}
	/*
	Break the formatting string into an array of chunks.
	A 'maybe' chunk will have nested chunks.
	*/
	function chunkFormatString(formatStr) {
	    var chunks = [];
	    var match;
	    // TODO: more descrimination
	    // \4 is a backreference to the first character of a multi-character set.
	    var chunker = /\[([^\]]*)\]|\(([^\)]*)\)|(LTS|LT|(\w)\4*o?)|([^\w\[\(]+)/g;
	    while ((match = chunker.exec(formatStr))) {
	        if (match[1]) { // a literal string inside [ ... ]
	            chunks.push.apply(chunks, // append
	            splitStringLiteral(match[1]));
	        }
	        else if (match[2]) { // non-zero formatting inside ( ... )
	            chunks.push({ maybe: chunkFormatString(match[2]) });
	        }
	        else if (match[3]) { // a formatting token
	            chunks.push({ token: match[3] });
	        }
	        else if (match[5]) { // an unenclosed literal string
	            chunks.push.apply(chunks, // append
	            splitStringLiteral(match[5]));
	        }
	    }
	    return chunks;
	}
	/*
	Potentially splits a literal-text string into multiple parts. For special cases.
	*/
	function splitStringLiteral(s) {
	    if (s === '. ') {
	        return ['.', ' ']; // for locales with periods bound to the end of each year/month/date
	    }
	    else {
	        return [s];
	    }
	}
	/*
	Given chunks parsed from a real format string, generate a fake (aka "intermediate") format string with special control
	characters that will eventually be given to moment for formatting, and then post-processed.
	*/
	function buildFakeFormatString(chunks) {
	    var parts = [];
	    var i;
	    var chunk;
	    for (i = 0; i < chunks.length; i++) {
	        chunk = chunks[i];
	        if (typeof chunk === 'string') {
	            parts.push('[' + chunk + ']');
	        }
	        else if (chunk.token) {
	            if (chunk.token in specialTokens) {
	                parts.push(SPECIAL_TOKEN_MARKER + // useful during post-processing
	                    '[' + chunk.token + ']' // preserve as literal text
	                );
	            }
	            else {
	                parts.push(chunk.token); // unprotected text implies a format string
	            }
	        }
	        else if (chunk.maybe) {
	            parts.push(MAYBE_MARKER + // useful during post-processing
	                buildFakeFormatString(chunk.maybe) +
	                MAYBE_MARKER);
	        }
	    }
	    return parts.join(PART_SEPARATOR);
	}
	/*
	Given parsed chunks from a real formatting string, generates an array of unit strings (like "day") that indicate
	in which regard two dates must be similar in order to share range formatting text.
	The `chunks` can be nested (because of "maybe" chunks), however, the returned array will be flat.
	*/
	function buildSameUnits(chunks) {
	    var units = [];
	    var i;
	    var chunk;
	    var tokenInfo;
	    for (i = 0; i < chunks.length; i++) {
	        chunk = chunks[i];
	        if (chunk.token) {
	            tokenInfo = largeTokenMap[chunk.token.charAt(0)];
	            units.push(tokenInfo ? tokenInfo.unit : 'second'); // default to a very strict same-second
	        }
	        else if (chunk.maybe) {
	            units.push.apply(units, // append
	            buildSameUnits(chunk.maybe));
	        }
	        else {
	            units.push(null);
	        }
	    }
	    return units;
	}
	// Rendering to text
	// ---------------------------------------------------------------------------------------------------------------------
	/*
	Formats a date with a fake format string, post-processes the control characters, then returns.
	*/
	function renderFakeFormatString(fakeFormatString, date) {
	    return processMaybeMarkers(renderFakeFormatStringParts(fakeFormatString, date).join(''));
	}
	/*
	Formats a date into parts that will have been post-processed, EXCEPT for the "maybe" markers.
	*/
	function renderFakeFormatStringParts(fakeFormatString, date) {
	    var parts = [];
	    var fakeRender = moment_ext_1.oldMomentFormat(date, fakeFormatString);
	    var fakeParts = fakeRender.split(PART_SEPARATOR);
	    var i;
	    var fakePart;
	    for (i = 0; i < fakeParts.length; i++) {
	        fakePart = fakeParts[i];
	        if (fakePart.charAt(0) === SPECIAL_TOKEN_MARKER) {
	            parts.push(
	            // the literal string IS the token's name.
	            // call special token's registered function.
	            specialTokens[fakePart.substring(1)](date));
	        }
	        else {
	            parts.push(fakePart);
	        }
	    }
	    return parts;
	}
	/*
	Accepts an almost-finally-formatted string and processes the "maybe" control characters, returning a new string.
	*/
	function processMaybeMarkers(s) {
	    return s.replace(MAYBE_REGEXP, function (m0, m1) {
	        if (m1.match(/[1-9]/)) { // any non-zero numeric characters?
	            return m1;
	        }
	        else {
	            return '';
	        }
	    });
	}
	// Misc Utils
	// -------------------------------------------------------------------------------------------------
	/*
	Returns a unit string, either 'year', 'month', 'day', or null for the most granular formatting token in the string.
	*/
	function queryMostGranularFormatUnit(formatStr) {
	    var chunks = chunkFormatString(formatStr);
	    var i;
	    var chunk;
	    var candidate;
	    var best;
	    for (i = 0; i < chunks.length; i++) {
	        chunk = chunks[i];
	        if (chunk.token) {
	            candidate = largeTokenMap[chunk.token.charAt(0)];
	            if (candidate) {
	                if (!best || candidate.value > best.value) {
	                    best = candidate;
	                }
	            }
	        }
	    }
	    if (best) {
	        return best.unit;
	    }
	    return null;
	}
	exports.queryMostGranularFormatUnit = queryMostGranularFormatUnit;
	
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventRange = /** @class */ (function () {
	    function EventRange(unzonedRange, eventDef, eventInstance) {
	        this.unzonedRange = unzonedRange;
	        this.eventDef = eventDef;
	        if (eventInstance) {
	            this.eventInstance = eventInstance;
	        }
	    }
	    return EventRange;
	}());
	exports.default = EventRange;
	
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var Class_1 = __webpack_require__(35);
	var EmitterMixin_1 = __webpack_require__(13);
	var ListenerMixin_1 = __webpack_require__(7);
	var Model = /** @class */ (function (_super) {
	    tslib_1.__extends(Model, _super);
	    function Model() {
	        var _this = _super.call(this) || this;
	        _this._watchers = {};
	        _this._props = {};
	        _this.applyGlobalWatchers();
	        _this.constructed();
	        return _this;
	    }
	    Model.watch = function (name) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        // subclasses should make a masked-copy of the superclass's map
	        // TODO: write test
	        if (!this.prototype.hasOwnProperty('_globalWatchArgs')) {
	            this.prototype._globalWatchArgs = Object.create(this.prototype._globalWatchArgs);
	        }
	        this.prototype._globalWatchArgs[name] = args;
	    };
	    Model.prototype.constructed = function () {
	        // useful for monkeypatching. TODO: BaseClass?
	    };
	    Model.prototype.applyGlobalWatchers = function () {
	        var map = this._globalWatchArgs;
	        var name;
	        for (name in map) {
	            this.watch.apply(this, [name].concat(map[name]));
	        }
	    };
	    Model.prototype.has = function (name) {
	        return name in this._props;
	    };
	    Model.prototype.get = function (name) {
	        if (name === undefined) {
	            return this._props;
	        }
	        return this._props[name];
	    };
	    Model.prototype.set = function (name, val) {
	        var newProps;
	        if (typeof name === 'string') {
	            newProps = {};
	            newProps[name] = val === undefined ? null : val;
	        }
	        else {
	            newProps = name;
	        }
	        this.setProps(newProps);
	    };
	    Model.prototype.reset = function (newProps) {
	        var oldProps = this._props;
	        var changeset = {}; // will have undefined's to signal unsets
	        var name;
	        for (name in oldProps) {
	            changeset[name] = undefined;
	        }
	        for (name in newProps) {
	            changeset[name] = newProps[name];
	        }
	        this.setProps(changeset);
	    };
	    Model.prototype.unset = function (name) {
	        var newProps = {};
	        var names;
	        var i;
	        if (typeof name === 'string') {
	            names = [name];
	        }
	        else {
	            names = name;
	        }
	        for (i = 0; i < names.length; i++) {
	            newProps[names[i]] = undefined;
	        }
	        this.setProps(newProps);
	    };
	    Model.prototype.setProps = function (newProps) {
	        var changedProps = {};
	        var changedCnt = 0;
	        var name;
	        var val;
	        for (name in newProps) {
	            val = newProps[name];
	            // a change in value?
	            // if an object, don't check equality, because might have been mutated internally.
	            // TODO: eventually enforce immutability.
	            if (typeof val === 'object' ||
	                val !== this._props[name]) {
	                changedProps[name] = val;
	                changedCnt++;
	            }
	        }
	        if (changedCnt) {
	            this.trigger('before:batchChange', changedProps);
	            for (name in changedProps) {
	                val = changedProps[name];
	                this.trigger('before:change', name, val);
	                this.trigger('before:change:' + name, val);
	            }
	            for (name in changedProps) {
	                val = changedProps[name];
	                if (val === undefined) {
	                    delete this._props[name];
	                }
	                else {
	                    this._props[name] = val;
	                }
	                this.trigger('change:' + name, val);
	                this.trigger('change', name, val);
	            }
	            this.trigger('batchChange', changedProps);
	        }
	    };
	    Model.prototype.watch = function (name, depList, startFunc, stopFunc) {
	        var _this = this;
	        this.unwatch(name);
	        this._watchers[name] = this._watchDeps(depList, function (deps) {
	            var res = startFunc.call(_this, deps);
	            if (res && res.then) {
	                _this.unset(name); // put in an unset state while resolving
	                res.then(function (val) {
	                    _this.set(name, val);
	                });
	            }
	            else {
	                _this.set(name, res);
	            }
	        }, function (deps) {
	            _this.unset(name);
	            if (stopFunc) {
	                stopFunc.call(_this, deps);
	            }
	        });
	    };
	    Model.prototype.unwatch = function (name) {
	        var watcher = this._watchers[name];
	        if (watcher) {
	            delete this._watchers[name];
	            watcher.teardown();
	        }
	    };
	    Model.prototype._watchDeps = function (depList, startFunc, stopFunc) {
	        var _this = this;
	        var queuedChangeCnt = 0;
	        var depCnt = depList.length;
	        var satisfyCnt = 0;
	        var values = {}; // what's passed as the `deps` arguments
	        var bindTuples = []; // array of [ eventName, handlerFunc ] arrays
	        var isCallingStop = false;
	        var onBeforeDepChange = function (depName, val, isOptional) {
	            queuedChangeCnt++;
	            if (queuedChangeCnt === 1) { // first change to cause a "stop" ?
	                if (satisfyCnt === depCnt) { // all deps previously satisfied?
	                    isCallingStop = true;
	                    stopFunc(values);
	                    isCallingStop = false;
	                }
	            }
	        };
	        var onDepChange = function (depName, val, isOptional) {
	            if (val === undefined) { // unsetting a value?
	                // required dependency that was previously set?
	                if (!isOptional && values[depName] !== undefined) {
	                    satisfyCnt--;
	                }
	                delete values[depName];
	            }
	            else { // setting a value?
	                // required dependency that was previously unset?
	                if (!isOptional && values[depName] === undefined) {
	                    satisfyCnt++;
	                }
	                values[depName] = val;
	            }
	            queuedChangeCnt--;
	            if (!queuedChangeCnt) { // last change to cause a "start"?
	                // now finally satisfied or satisfied all along?
	                if (satisfyCnt === depCnt) {
	                    // if the stopFunc initiated another value change, ignore it.
	                    // it will be processed by another change event anyway.
	                    if (!isCallingStop) {
	                        startFunc(values);
	                    }
	                }
	            }
	        };
	        // intercept for .on() that remembers handlers
	        var bind = function (eventName, handler) {
	            _this.on(eventName, handler);
	            bindTuples.push([eventName, handler]);
	        };
	        // listen to dependency changes
	        depList.forEach(function (depName) {
	            var isOptional = false;
	            if (depName.charAt(0) === '?') { // TODO: more DRY
	                depName = depName.substring(1);
	                isOptional = true;
	            }
	            bind('before:change:' + depName, function (val) {
	                onBeforeDepChange(depName, val, isOptional);
	            });
	            bind('change:' + depName, function (val) {
	                onDepChange(depName, val, isOptional);
	            });
	        });
	        // process current dependency values
	        depList.forEach(function (depName) {
	            var isOptional = false;
	            if (depName.charAt(0) === '?') { // TODO: more DRY
	                depName = depName.substring(1);
	                isOptional = true;
	            }
	            if (_this.has(depName)) {
	                values[depName] = _this.get(depName);
	                satisfyCnt++;
	            }
	            else if (isOptional) {
	                satisfyCnt++;
	            }
	        });
	        // initially satisfied
	        if (satisfyCnt === depCnt) {
	            startFunc(values);
	        }
	        return {
	            teardown: function () {
	                // remove all handlers
	                for (var i = 0; i < bindTuples.length; i++) {
	                    _this.off(bindTuples[i][0], bindTuples[i][1]);
	                }
	                bindTuples = null;
	                // was satisfied, so call stopFunc
	                if (satisfyCnt === depCnt) {
	                    stopFunc();
	                }
	            },
	            flash: function () {
	                if (satisfyCnt === depCnt) {
	                    stopFunc();
	                    startFunc(values);
	                }
	            }
	        };
	    };
	    Model.prototype.flash = function (name) {
	        var watcher = this._watchers[name];
	        if (watcher) {
	            watcher.flash();
	        }
	    };
	    return Model;
	}(Class_1.default));
	exports.default = Model;
	Model.prototype._globalWatchArgs = {}; // mutation protection in Model.watch
	EmitterMixin_1.default.mixInto(Model);
	ListenerMixin_1.default.mixInto(Model);
	
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/*
	USAGE:
	  import { default as ParsableModelMixin, ParsableModelInterface } from './ParsableModelMixin'
	in class:
	  applyProps: ParsableModelInterface['applyProps']
	  applyManualStandardProps: ParsableModelInterface['applyManualStandardProps']
	  applyMiscProps: ParsableModelInterface['applyMiscProps']
	  isStandardProp: ParsableModelInterface['isStandardProp']
	  static defineStandardProps = ParsableModelMixin.defineStandardProps
	  static copyVerbatimStandardProps = ParsableModelMixin.copyVerbatimStandardProps
	after class:
	  ParsableModelMixin.mixInto(TheClass)
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	var Mixin_1 = __webpack_require__(15);
	var ParsableModelMixin = /** @class */ (function (_super) {
	    tslib_1.__extends(ParsableModelMixin, _super);
	    function ParsableModelMixin() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ParsableModelMixin.defineStandardProps = function (propDefs) {
	        var proto = this.prototype;
	        if (!proto.hasOwnProperty('standardPropMap')) {
	            proto.standardPropMap = Object.create(proto.standardPropMap);
	        }
	        util_1.copyOwnProps(propDefs, proto.standardPropMap);
	    };
	    ParsableModelMixin.copyVerbatimStandardProps = function (src, dest) {
	        var map = this.prototype.standardPropMap;
	        var propName;
	        for (propName in map) {
	            if (src[propName] != null && // in the src object?
	                map[propName] === true // false means "copy verbatim"
	            ) {
	                dest[propName] = src[propName];
	            }
	        }
	    };
	    /*
	    Returns true/false for success.
	    Meant to be only called ONCE, at object creation.
	    */
	    ParsableModelMixin.prototype.applyProps = function (rawProps) {
	        var standardPropMap = this.standardPropMap;
	        var manualProps = {};
	        var miscProps = {};
	        var propName;
	        for (propName in rawProps) {
	            if (standardPropMap[propName] === true) { // copy verbatim
	                this[propName] = rawProps[propName];
	            }
	            else if (standardPropMap[propName] === false) {
	                manualProps[propName] = rawProps[propName];
	            }
	            else {
	                miscProps[propName] = rawProps[propName];
	            }
	        }
	        this.applyMiscProps(miscProps);
	        return this.applyManualStandardProps(manualProps);
	    };
	    /*
	    If subclasses override, they must call this supermethod and return the boolean response.
	    Meant to be only called ONCE, at object creation.
	    */
	    ParsableModelMixin.prototype.applyManualStandardProps = function (rawProps) {
	        return true;
	    };
	    /*
	    Can be called even after initial object creation.
	    */
	    ParsableModelMixin.prototype.applyMiscProps = function (rawProps) {
	        // subclasses can implement
	    };
	    /*
	    TODO: why is this a method when defineStandardProps is static
	    */
	    ParsableModelMixin.prototype.isStandardProp = function (propName) {
	        return propName in this.standardPropMap;
	    };
	    return ParsableModelMixin;
	}(Mixin_1.default));
	exports.default = ParsableModelMixin;
	ParsableModelMixin.prototype.standardPropMap = {}; // will be cloned by defineStandardProps
	
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventInstance = /** @class */ (function () {
	    function EventInstance(def, dateProfile) {
	        this.def = def;
	        this.dateProfile = dateProfile;
	    }
	    EventInstance.prototype.toLegacy = function () {
	        var dateProfile = this.dateProfile;
	        var obj = this.def.toLegacy();
	        obj.start = dateProfile.start.clone();
	        obj.end = dateProfile.end ? dateProfile.end.clone() : null;
	        return obj;
	    };
	    return EventInstance;
	}());
	exports.default = EventInstance;
	
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var moment = __webpack_require__(0);
	var EventDef_1 = __webpack_require__(37);
	var EventInstance_1 = __webpack_require__(53);
	var EventDateProfile_1 = __webpack_require__(16);
	var RecurringEventDef = /** @class */ (function (_super) {
	    tslib_1.__extends(RecurringEventDef, _super);
	    function RecurringEventDef() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    RecurringEventDef.prototype.isAllDay = function () {
	        return !this.startTime && !this.endTime;
	    };
	    RecurringEventDef.prototype.buildInstances = function (unzonedRange) {
	        var calendar = this.source.calendar;
	        var unzonedDate = unzonedRange.getStart();
	        var unzonedEnd = unzonedRange.getEnd();
	        var zonedDayStart;
	        var instanceStart;
	        var instanceEnd;
	        var instances = [];
	        while (unzonedDate.isBefore(unzonedEnd)) {
	            // if everyday, or this particular day-of-week
	            if (!this.dowHash || this.dowHash[unzonedDate.day()]) {
	                zonedDayStart = calendar.applyTimezone(unzonedDate);
	                instanceStart = zonedDayStart.clone();
	                instanceEnd = null;
	                if (this.startTime) {
	                    instanceStart.time(this.startTime);
	                }
	                else {
	                    instanceStart.stripTime();
	                }
	                if (this.endTime) {
	                    instanceEnd = zonedDayStart.clone().time(this.endTime);
	                }
	                instances.push(new EventInstance_1.default(this, // definition
	                new EventDateProfile_1.default(instanceStart, instanceEnd, calendar)));
	            }
	            unzonedDate.add(1, 'days');
	        }
	        return instances;
	    };
	    RecurringEventDef.prototype.setDow = function (dowNumbers) {
	        if (!this.dowHash) {
	            this.dowHash = {};
	        }
	        for (var i = 0; i < dowNumbers.length; i++) {
	            this.dowHash[dowNumbers[i]] = true;
	        }
	    };
	    RecurringEventDef.prototype.clone = function () {
	        var def = _super.prototype.clone.call(this);
	        if (def.startTime) {
	            def.startTime = moment.duration(this.startTime);
	        }
	        if (def.endTime) {
	            def.endTime = moment.duration(this.endTime);
	        }
	        if (this.dowHash) {
	            def.dowHash = $.extend({}, this.dowHash);
	        }
	        return def;
	    };
	    return RecurringEventDef;
	}(EventDef_1.default));
	exports.default = RecurringEventDef;
	/*
	HACK to work with TypeScript mixins
	NOTE: if super-method fails, should still attempt to apply
	*/
	RecurringEventDef.prototype.applyProps = function (rawProps) {
	    var superSuccess = EventDef_1.default.prototype.applyProps.call(this, rawProps);
	    if (rawProps.start) {
	        this.startTime = moment.duration(rawProps.start);
	    }
	    if (rawProps.end) {
	        this.endTime = moment.duration(rawProps.end);
	    }
	    if (rawProps.dow) {
	        this.setDow(rawProps.dow);
	    }
	    return superSuccess;
	};
	// Parsing
	// ---------------------------------------------------------------------------------------------------------------------
	RecurringEventDef.defineStandardProps({
	    start: false,
	    end: false,
	    dow: false
	});
	
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(0);
	var util_1 = __webpack_require__(4);
	var UnzonedRange_1 = __webpack_require__(5);
	var DateProfileGenerator = /** @class */ (function () {
	    function DateProfileGenerator(_view) {
	        this._view = _view;
	    }
	    DateProfileGenerator.prototype.opt = function (name) {
	        return this._view.opt(name);
	    };
	    DateProfileGenerator.prototype.trimHiddenDays = function (unzonedRange) {
	        return this._view.trimHiddenDays(unzonedRange);
	    };
	    DateProfileGenerator.prototype.msToUtcMoment = function (ms, forceAllDay) {
	        return this._view.calendar.msToUtcMoment(ms, forceAllDay);
	    };
	    /* Date Range Computation
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Builds a structure with info about what the dates/ranges will be for the "prev" view.
	    DateProfileGenerator.prototype.buildPrev = function (currentDateProfile) {
	        var prevDate = currentDateProfile.date.clone()
	            .startOf(currentDateProfile.currentRangeUnit)
	            .subtract(currentDateProfile.dateIncrement);
	        return this.build(prevDate, -1);
	    };
	    // Builds a structure with info about what the dates/ranges will be for the "next" view.
	    DateProfileGenerator.prototype.buildNext = function (currentDateProfile) {
	        var nextDate = currentDateProfile.date.clone()
	            .startOf(currentDateProfile.currentRangeUnit)
	            .add(currentDateProfile.dateIncrement);
	        return this.build(nextDate, 1);
	    };
	    // Builds a structure holding dates/ranges for rendering around the given date.
	    // Optional direction param indicates whether the date is being incremented/decremented
	    // from its previous value. decremented = -1, incremented = 1 (default).
	    DateProfileGenerator.prototype.build = function (date, direction, forceToValid) {
	        if (forceToValid === void 0) { forceToValid = false; }
	        var isDateAllDay = !date.hasTime();
	        var validUnzonedRange;
	        var minTime = null;
	        var maxTime = null;
	        var currentInfo;
	        var isRangeAllDay;
	        var renderUnzonedRange;
	        var activeUnzonedRange;
	        var isValid;
	        validUnzonedRange = this.buildValidRange();
	        validUnzonedRange = this.trimHiddenDays(validUnzonedRange);
	        if (forceToValid) {
	            date = this.msToUtcMoment(validUnzonedRange.constrainDate(date), // returns MS
	            isDateAllDay);
	        }
	        currentInfo = this.buildCurrentRangeInfo(date, direction);
	        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
	        renderUnzonedRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.unzonedRange), currentInfo.unit, isRangeAllDay);
	        renderUnzonedRange = this.trimHiddenDays(renderUnzonedRange);
	        activeUnzonedRange = renderUnzonedRange.clone();
	        if (!this.opt('showNonCurrentDates')) {
	            activeUnzonedRange = activeUnzonedRange.intersect(currentInfo.unzonedRange);
	        }
	        minTime = moment.duration(this.opt('minTime'));
	        maxTime = moment.duration(this.opt('maxTime'));
	        activeUnzonedRange = this.adjustActiveRange(activeUnzonedRange, minTime, maxTime);
	        activeUnzonedRange = activeUnzonedRange.intersect(validUnzonedRange); // might return null
	        if (activeUnzonedRange) {
	            date = this.msToUtcMoment(activeUnzonedRange.constrainDate(date), // returns MS
	            isDateAllDay);
	        }
	        // it's invalid if the originally requested date is not contained,
	        // or if the range is completely outside of the valid range.
	        isValid = currentInfo.unzonedRange.intersectsWith(validUnzonedRange);
	        return {
	            // constraint for where prev/next operations can go and where events can be dragged/resized to.
	            // an object with optional start and end properties.
	            validUnzonedRange: validUnzonedRange,
	            // range the view is formally responsible for.
	            // for example, a month view might have 1st-31st, excluding padded dates
	            currentUnzonedRange: currentInfo.unzonedRange,
	            // name of largest unit being displayed, like "month" or "week"
	            currentRangeUnit: currentInfo.unit,
	            isRangeAllDay: isRangeAllDay,
	            // dates that display events and accept drag-n-drop
	            // will be `null` if no dates accept events
	            activeUnzonedRange: activeUnzonedRange,
	            // date range with a rendered skeleton
	            // includes not-active days that need some sort of DOM
	            renderUnzonedRange: renderUnzonedRange,
	            // Duration object that denotes the first visible time of any given day
	            minTime: minTime,
	            // Duration object that denotes the exclusive visible end time of any given day
	            maxTime: maxTime,
	            isValid: isValid,
	            date: date,
	            // how far the current date will move for a prev/next operation
	            dateIncrement: this.buildDateIncrement(currentInfo.duration)
	            // pass a fallback (might be null) ^
	        };
	    };
	    // Builds an object with optional start/end properties.
	    // Indicates the minimum/maximum dates to display.
	    // not responsible for trimming hidden days.
	    DateProfileGenerator.prototype.buildValidRange = function () {
	        return this._view.getUnzonedRangeOption('validRange', this._view.calendar.getNow()) ||
	            new UnzonedRange_1.default(); // completely open-ended
	    };
	    // Builds a structure with info about the "current" range, the range that is
	    // highlighted as being the current month for example.
	    // See build() for a description of `direction`.
	    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
	    // TODO: accept a MS-time instead of a moment `date`?
	    DateProfileGenerator.prototype.buildCurrentRangeInfo = function (date, direction) {
	        var viewSpec = this._view.viewSpec;
	        var duration = null;
	        var unit = null;
	        var unzonedRange = null;
	        var dayCount;
	        if (viewSpec.duration) {
	            duration = viewSpec.duration;
	            unit = viewSpec.durationUnit;
	            unzonedRange = this.buildRangeFromDuration(date, direction, duration, unit);
	        }
	        else if ((dayCount = this.opt('dayCount'))) {
	            unit = 'day';
	            unzonedRange = this.buildRangeFromDayCount(date, direction, dayCount);
	        }
	        else if ((unzonedRange = this.buildCustomVisibleRange(date))) {
	            unit = util_1.computeGreatestUnit(unzonedRange.getStart(), unzonedRange.getEnd());
	        }
	        else {
	            duration = this.getFallbackDuration();
	            unit = util_1.computeGreatestUnit(duration);
	            unzonedRange = this.buildRangeFromDuration(date, direction, duration, unit);
	        }
	        return { duration: duration, unit: unit, unzonedRange: unzonedRange };
	    };
	    DateProfileGenerator.prototype.getFallbackDuration = function () {
	        return moment.duration({ days: 1 });
	    };
	    // Returns a new activeUnzonedRange to have time values (un-ambiguate)
	    // minTime or maxTime causes the range to expand.
	    DateProfileGenerator.prototype.adjustActiveRange = function (unzonedRange, minTime, maxTime) {
	        var start = unzonedRange.getStart();
	        var end = unzonedRange.getEnd();
	        if (this._view.usesMinMaxTime) {
	            if (minTime < 0) {
	                start.time(0).add(minTime);
	            }
	            if (maxTime > 24 * 60 * 60 * 1000) { // beyond 24 hours?
	                end.time(maxTime - (24 * 60 * 60 * 1000));
	            }
	        }
	        return new UnzonedRange_1.default(start, end);
	    };
	    // Builds the "current" range when it is specified as an explicit duration.
	    // `unit` is the already-computed computeGreatestUnit value of duration.
	    // TODO: accept a MS-time instead of a moment `date`?
	    DateProfileGenerator.prototype.buildRangeFromDuration = function (date, direction, duration, unit) {
	        var alignment = this.opt('dateAlignment');
	        var dateIncrementInput;
	        var dateIncrementDuration;
	        var start;
	        var end;
	        var res;
	        // compute what the alignment should be
	        if (!alignment) {
	            dateIncrementInput = this.opt('dateIncrement');
	            if (dateIncrementInput) {
	                dateIncrementDuration = moment.duration(dateIncrementInput);
	                // use the smaller of the two units
	                if (dateIncrementDuration < duration) {
	                    alignment = util_1.computeDurationGreatestUnit(dateIncrementDuration, dateIncrementInput);
	                }
	                else {
	                    alignment = unit;
	                }
	            }
	            else {
	                alignment = unit;
	            }
	        }
	        // if the view displays a single day or smaller
	        if (duration.as('days') <= 1) {
	            if (this._view.isHiddenDay(start)) {
	                start = this._view.skipHiddenDays(start, direction);
	                start.startOf('day');
	            }
	        }
	        function computeRes() {
	            start = date.clone().startOf(alignment);
	            end = start.clone().add(duration);
	            res = new UnzonedRange_1.default(start, end);
	        }
	        computeRes();
	        // if range is completely enveloped by hidden days, go past the hidden days
	        if (!this.trimHiddenDays(res)) {
	            date = this._view.skipHiddenDays(date, direction);
	            computeRes();
	        }
	        return res;
	    };
	    // Builds the "current" range when a dayCount is specified.
	    // TODO: accept a MS-time instead of a moment `date`?
	    DateProfileGenerator.prototype.buildRangeFromDayCount = function (date, direction, dayCount) {
	        var customAlignment = this.opt('dateAlignment');
	        var runningCount = 0;
	        var start;
	        var end;
	        if (customAlignment || direction !== -1) {
	            start = date.clone();
	            if (customAlignment) {
	                start.startOf(customAlignment);
	            }
	            start.startOf('day');
	            start = this._view.skipHiddenDays(start);
	            end = start.clone();
	            do {
	                end.add(1, 'day');
	                if (!this._view.isHiddenDay(end)) {
	                    runningCount++;
	                }
	            } while (runningCount < dayCount);
	        }
	        else {
	            end = date.clone().startOf('day').add(1, 'day');
	            end = this._view.skipHiddenDays(end, -1, true);
	            start = end.clone();
	            do {
	                start.add(-1, 'day');
	                if (!this._view.isHiddenDay(start)) {
	                    runningCount++;
	                }
	            } while (runningCount < dayCount);
	        }
	        return new UnzonedRange_1.default(start, end);
	    };
	    // Builds a normalized range object for the "visible" range,
	    // which is a way to define the currentUnzonedRange and activeUnzonedRange at the same time.
	    // TODO: accept a MS-time instead of a moment `date`?
	    DateProfileGenerator.prototype.buildCustomVisibleRange = function (date) {
	        var visibleUnzonedRange = this._view.getUnzonedRangeOption('visibleRange', this._view.calendar.applyTimezone(date) // correct zone. also generates new obj that avoids mutations
	        );
	        if (visibleUnzonedRange && (visibleUnzonedRange.startMs == null || visibleUnzonedRange.endMs == null)) {
	            return null;
	        }
	        return visibleUnzonedRange;
	    };
	    // Computes the range that will represent the element/cells for *rendering*,
	    // but which may have voided days/times.
	    // not responsible for trimming hidden days.
	    DateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
	        return currentUnzonedRange.clone();
	    };
	    // Compute the duration value that should be added/substracted to the current date
	    // when a prev/next operation happens.
	    DateProfileGenerator.prototype.buildDateIncrement = function (fallback) {
	        var dateIncrementInput = this.opt('dateIncrement');
	        var customAlignment;
	        if (dateIncrementInput) {
	            return moment.duration(dateIncrementInput);
	        }
	        else if ((customAlignment = this.opt('dateAlignment'))) {
	            return moment.duration(1, customAlignment);
	        }
	        else if (fallback) {
	            return fallback;
	        }
	        else {
	            return moment.duration({ days: 1 });
	        }
	    };
	    return DateProfileGenerator;
	}());
	exports.default = DateProfileGenerator;
	
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var Promise_1 = __webpack_require__(21);
	var EventSource_1 = __webpack_require__(6);
	var SingleEventDef_1 = __webpack_require__(9);
	var ArrayEventSource = /** @class */ (function (_super) {
	    tslib_1.__extends(ArrayEventSource, _super);
	    function ArrayEventSource(calendar) {
	        var _this = _super.call(this, calendar) || this;
	        _this.eventDefs = []; // for if setRawEventDefs is never called
	        return _this;
	    }
	    ArrayEventSource.parse = function (rawInput, calendar) {
	        var rawProps;
	        // normalize raw input
	        if ($.isArray(rawInput.events)) { // extended form
	            rawProps = rawInput;
	        }
	        else if ($.isArray(rawInput)) { // short form
	            rawProps = { events: rawInput };
	        }
	        if (rawProps) {
	            return EventSource_1.default.parse.call(this, rawProps, calendar);
	        }
	        return false;
	    };
	    ArrayEventSource.prototype.setRawEventDefs = function (rawEventDefs) {
	        this.rawEventDefs = rawEventDefs;
	        this.eventDefs = this.parseEventDefs(rawEventDefs);
	    };
	    ArrayEventSource.prototype.fetch = function (start, end, timezone) {
	        var eventDefs = this.eventDefs;
	        var i;
	        if (this.currentTimezone != null &&
	            this.currentTimezone !== timezone) {
	            for (i = 0; i < eventDefs.length; i++) {
	                if (eventDefs[i] instanceof SingleEventDef_1.default) {
	                    eventDefs[i].rezone();
	                }
	            }
	        }
	        this.currentTimezone = timezone;
	        return Promise_1.default.resolve(eventDefs);
	    };
	    ArrayEventSource.prototype.addEventDef = function (eventDef) {
	        this.eventDefs.push(eventDef);
	    };
	    /*
	    eventDefId already normalized to a string
	    */
	    ArrayEventSource.prototype.removeEventDefsById = function (eventDefId) {
	        return util_1.removeMatching(this.eventDefs, function (eventDef) {
	            return eventDef.id === eventDefId;
	        });
	    };
	    ArrayEventSource.prototype.removeAllEventDefs = function () {
	        this.eventDefs = [];
	    };
	    ArrayEventSource.prototype.getPrimitive = function () {
	        return this.rawEventDefs;
	    };
	    ArrayEventSource.prototype.applyManualStandardProps = function (rawProps) {
	        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
	        this.setRawEventDefs(rawProps.events);
	        return superSuccess;
	    };
	    return ArrayEventSource;
	}(EventSource_1.default));
	exports.default = ArrayEventSource;
	ArrayEventSource.defineStandardProps({
	    events: false // don't automatically transfer
	});
	
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var StandardTheme_1 = __webpack_require__(221);
	var JqueryUiTheme_1 = __webpack_require__(222);
	var themeClassHash = {};
	function defineThemeSystem(themeName, themeClass) {
	    themeClassHash[themeName] = themeClass;
	}
	exports.defineThemeSystem = defineThemeSystem;
	function getThemeSystemClass(themeSetting) {
	    if (!themeSetting) {
	        return StandardTheme_1.default;
	    }
	    else if (themeSetting === true) {
	        return JqueryUiTheme_1.default;
	    }
	    else {
	        return themeClassHash[themeSetting];
	    }
	}
	exports.getThemeSystemClass = getThemeSystemClass;
	
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	/*
	A cache for the left/right/top/bottom/width/height values for one or more elements.
	Works with both offset (from topleft document) and position (from offsetParent).
	
	options:
	- els
	- isHorizontal
	- isVertical
	*/
	var CoordCache = /** @class */ (function () {
	    function CoordCache(options) {
	        this.isHorizontal = false; // whether to query for left/right/width
	        this.isVertical = false; // whether to query for top/bottom/height
	        this.els = $(options.els);
	        this.isHorizontal = options.isHorizontal;
	        this.isVertical = options.isVertical;
	        this.forcedOffsetParentEl = options.offsetParent ? $(options.offsetParent) : null;
	    }
	    // Queries the els for coordinates and stores them.
	    // Call this method before using and of the get* methods below.
	    CoordCache.prototype.build = function () {
	        var offsetParentEl = this.forcedOffsetParentEl;
	        if (!offsetParentEl && this.els.length > 0) {
	            offsetParentEl = this.els.eq(0).offsetParent();
	        }
	        this.origin = offsetParentEl ?
	            offsetParentEl.offset() :
	            null;
	        this.boundingRect = this.queryBoundingRect();
	        if (this.isHorizontal) {
	            this.buildElHorizontals();
	        }
	        if (this.isVertical) {
	            this.buildElVerticals();
	        }
	    };
	    // Destroys all internal data about coordinates, freeing memory
	    CoordCache.prototype.clear = function () {
	        this.origin = null;
	        this.boundingRect = null;
	        this.lefts = null;
	        this.rights = null;
	        this.tops = null;
	        this.bottoms = null;
	    };
	    // When called, if coord caches aren't built, builds them
	    CoordCache.prototype.ensureBuilt = function () {
	        if (!this.origin) {
	            this.build();
	        }
	    };
	    // Populates the left/right internal coordinate arrays
	    CoordCache.prototype.buildElHorizontals = function () {
	        var lefts = [];
	        var rights = [];
	        this.els.each(function (i, node) {
	            var el = $(node);
	            var left = el.offset().left;
	            var width = el.outerWidth();
	            lefts.push(left);
	            rights.push(left + width);
	        });
	        this.lefts = lefts;
	        this.rights = rights;
	    };
	    // Populates the top/bottom internal coordinate arrays
	    CoordCache.prototype.buildElVerticals = function () {
	        var tops = [];
	        var bottoms = [];
	        this.els.each(function (i, node) {
	            var el = $(node);
	            var top = el.offset().top;
	            var height = el.outerHeight();
	            tops.push(top);
	            bottoms.push(top + height);
	        });
	        this.tops = tops;
	        this.bottoms = bottoms;
	    };
	    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
	    // If no intersection is made, returns undefined.
	    CoordCache.prototype.getHorizontalIndex = function (leftOffset) {
	        this.ensureBuilt();
	        var lefts = this.lefts;
	        var rights = this.rights;
	        var len = lefts.length;
	        var i;
	        for (i = 0; i < len; i++) {
	            if (leftOffset >= lefts[i] && leftOffset < rights[i]) {
	                return i;
	            }
	        }
	    };
	    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
	    // If no intersection is made, returns undefined.
	    CoordCache.prototype.getVerticalIndex = function (topOffset) {
	        this.ensureBuilt();
	        var tops = this.tops;
	        var bottoms = this.bottoms;
	        var len = tops.length;
	        var i;
	        for (i = 0; i < len; i++) {
	            if (topOffset >= tops[i] && topOffset < bottoms[i]) {
	                return i;
	            }
	        }
	    };
	    // Gets the left offset (from document left) of the element at the given index
	    CoordCache.prototype.getLeftOffset = function (leftIndex) {
	        this.ensureBuilt();
	        return this.lefts[leftIndex];
	    };
	    // Gets the left position (from offsetParent left) of the element at the given index
	    CoordCache.prototype.getLeftPosition = function (leftIndex) {
	        this.ensureBuilt();
	        return this.lefts[leftIndex] - this.origin.left;
	    };
	    // Gets the right offset (from document left) of the element at the given index.
	    // This value is NOT relative to the document's right edge, like the CSS concept of "right" would be.
	    CoordCache.prototype.getRightOffset = function (leftIndex) {
	        this.ensureBuilt();
	        return this.rights[leftIndex];
	    };
	    // Gets the right position (from offsetParent left) of the element at the given index.
	    // This value is NOT relative to the offsetParent's right edge, like the CSS concept of "right" would be.
	    CoordCache.prototype.getRightPosition = function (leftIndex) {
	        this.ensureBuilt();
	        return this.rights[leftIndex] - this.origin.left;
	    };
	    // Gets the width of the element at the given index
	    CoordCache.prototype.getWidth = function (leftIndex) {
	        this.ensureBuilt();
	        return this.rights[leftIndex] - this.lefts[leftIndex];
	    };
	    // Gets the top offset (from document top) of the element at the given index
	    CoordCache.prototype.getTopOffset = function (topIndex) {
	        this.ensureBuilt();
	        return this.tops[topIndex];
	    };
	    // Gets the top position (from offsetParent top) of the element at the given position
	    CoordCache.prototype.getTopPosition = function (topIndex) {
	        this.ensureBuilt();
	        return this.tops[topIndex] - this.origin.top;
	    };
	    // Gets the bottom offset (from the document top) of the element at the given index.
	    // This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
	    CoordCache.prototype.getBottomOffset = function (topIndex) {
	        this.ensureBuilt();
	        return this.bottoms[topIndex];
	    };
	    // Gets the bottom position (from the offsetParent top) of the element at the given index.
	    // This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
	    CoordCache.prototype.getBottomPosition = function (topIndex) {
	        this.ensureBuilt();
	        return this.bottoms[topIndex] - this.origin.top;
	    };
	    // Gets the height of the element at the given index
	    CoordCache.prototype.getHeight = function (topIndex) {
	        this.ensureBuilt();
	        return this.bottoms[topIndex] - this.tops[topIndex];
	    };
	    // Bounding Rect
	    // TODO: decouple this from CoordCache
	    // Compute and return what the elements' bounding rectangle is, from the user's perspective.
	    // Right now, only returns a rectangle if constrained by an overflow:scroll element.
	    // Returns null if there are no elements
	    CoordCache.prototype.queryBoundingRect = function () {
	        var scrollParentEl;
	        if (this.els.length > 0) {
	            scrollParentEl = util_1.getScrollParent(this.els.eq(0));
	            if (!scrollParentEl.is(document) &&
	                !scrollParentEl.is('html,body') // don't consider these bounding rects. solves issue 3615
	            ) {
	                return util_1.getClientRect(scrollParentEl);
	            }
	        }
	        return null;
	    };
	    CoordCache.prototype.isPointInBounds = function (leftOffset, topOffset) {
	        return this.isLeftInBounds(leftOffset) && this.isTopInBounds(topOffset);
	    };
	    CoordCache.prototype.isLeftInBounds = function (leftOffset) {
	        return !this.boundingRect || (leftOffset >= this.boundingRect.left && leftOffset < this.boundingRect.right);
	    };
	    CoordCache.prototype.isTopInBounds = function (topOffset) {
	        return !this.boundingRect || (topOffset >= this.boundingRect.top && topOffset < this.boundingRect.bottom);
	    };
	    return CoordCache;
	}());
	exports.default = CoordCache;
	
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var ListenerMixin_1 = __webpack_require__(7);
	var GlobalEmitter_1 = __webpack_require__(23);
	/* Tracks a drag's mouse movement, firing various handlers
	----------------------------------------------------------------------------------------------------------------------*/
	// TODO: use Emitter
	var DragListener = /** @class */ (function () {
	    function DragListener(options) {
	        this.isInteracting = false;
	        this.isDistanceSurpassed = false;
	        this.isDelayEnded = false;
	        this.isDragging = false;
	        this.isTouch = false;
	        this.isGeneric = false; // initiated by 'dragstart' (jqui)
	        this.shouldCancelTouchScroll = true;
	        this.scrollAlwaysKills = false;
	        this.isAutoScroll = false;
	        // defaults
	        this.scrollSensitivity = 30; // pixels from edge for scrolling to start
	        this.scrollSpeed = 200; // pixels per second, at maximum speed
	        this.scrollIntervalMs = 50; // millisecond wait between scroll increment
	        this.options = options || {};
	    }
	    // Interaction (high-level)
	    // -----------------------------------------------------------------------------------------------------------------
	    DragListener.prototype.startInteraction = function (ev, extraOptions) {
	        if (extraOptions === void 0) { extraOptions = {}; }
	        if (ev.type === 'mousedown') {
	            if (GlobalEmitter_1.default.get().shouldIgnoreMouse()) {
	                return;
	            }
	            else if (!util_1.isPrimaryMouseButton(ev)) {
	                return;
	            }
	            else {
	                ev.preventDefault(); // prevents native selection in most browsers
	            }
	        }
	        if (!this.isInteracting) {
	            // process options
	            this.delay = util_1.firstDefined(extraOptions.delay, this.options.delay, 0);
	            this.minDistance = util_1.firstDefined(extraOptions.distance, this.options.distance, 0);
	            this.subjectEl = this.options.subjectEl;
	            util_1.preventSelection($('body'));
	            this.isInteracting = true;
	            this.isTouch = util_1.getEvIsTouch(ev);
	            this.isGeneric = ev.type === 'dragstart';
	            this.isDelayEnded = false;
	            this.isDistanceSurpassed = false;
	            this.originX = util_1.getEvX(ev);
	            this.originY = util_1.getEvY(ev);
	            this.scrollEl = util_1.getScrollParent($(ev.target));
	            this.bindHandlers();
	            this.initAutoScroll();
	            this.handleInteractionStart(ev);
	            this.startDelay(ev);
	            if (!this.minDistance) {
	                this.handleDistanceSurpassed(ev);
	            }
	        }
	    };
	    DragListener.prototype.handleInteractionStart = function (ev) {
	        this.trigger('interactionStart', ev);
	    };
	    DragListener.prototype.endInteraction = function (ev, isCancelled) {
	        if (this.isInteracting) {
	            this.endDrag(ev);
	            if (this.delayTimeoutId) {
	                clearTimeout(this.delayTimeoutId);
	                this.delayTimeoutId = null;
	            }
	            this.destroyAutoScroll();
	            this.unbindHandlers();
	            this.isInteracting = false;
	            this.handleInteractionEnd(ev, isCancelled);
	            util_1.allowSelection($('body'));
	        }
	    };
	    DragListener.prototype.handleInteractionEnd = function (ev, isCancelled) {
	        this.trigger('interactionEnd', ev, isCancelled || false);
	    };
	    // Binding To DOM
	    // -----------------------------------------------------------------------------------------------------------------
	    DragListener.prototype.bindHandlers = function () {
	        // some browsers (Safari in iOS 10) don't allow preventDefault on touch events that are bound after touchstart,
	        // so listen to the GlobalEmitter singleton, which is always bound, instead of the document directly.
	        var globalEmitter = GlobalEmitter_1.default.get();
	        if (this.isGeneric) {
	            this.listenTo($(document), {
	                drag: this.handleMove,
	                dragstop: this.endInteraction
	            });
	        }
	        else if (this.isTouch) {
	            this.listenTo(globalEmitter, {
	                touchmove: this.handleTouchMove,
	                touchend: this.endInteraction,
	                scroll: this.handleTouchScroll
	            });
	        }
	        else {
	            this.listenTo(globalEmitter, {
	                mousemove: this.handleMouseMove,
	                mouseup: this.endInteraction
	            });
	        }
	        this.listenTo(globalEmitter, {
	            selectstart: util_1.preventDefault,
	            contextmenu: util_1.preventDefault // long taps would open menu on Chrome dev tools
	        });
	    };
	    DragListener.prototype.unbindHandlers = function () {
	        this.stopListeningTo(GlobalEmitter_1.default.get());
	        this.stopListeningTo($(document)); // for isGeneric
	    };
	    // Drag (high-level)
	    // -----------------------------------------------------------------------------------------------------------------
	    // extraOptions ignored if drag already started
	    DragListener.prototype.startDrag = function (ev, extraOptions) {
	        this.startInteraction(ev, extraOptions); // ensure interaction began
	        if (!this.isDragging) {
	            this.isDragging = true;
	            this.handleDragStart(ev);
	        }
	    };
	    DragListener.prototype.handleDragStart = function (ev) {
	        this.trigger('dragStart', ev);
	    };
	    DragListener.prototype.handleMove = function (ev) {
	        var dx = util_1.getEvX(ev) - this.originX;
	        var dy = util_1.getEvY(ev) - this.originY;
	        var minDistance = this.minDistance;
	        var distanceSq; // current distance from the origin, squared
	        if (!this.isDistanceSurpassed) {
	            distanceSq = dx * dx + dy * dy;
	            if (distanceSq >= minDistance * minDistance) { // use pythagorean theorem
	                this.handleDistanceSurpassed(ev);
	            }
	        }
	        if (this.isDragging) {
	            this.handleDrag(dx, dy, ev);
	        }
	    };
	    // Called while the mouse is being moved and when we know a legitimate drag is taking place
	    DragListener.prototype.handleDrag = function (dx, dy, ev) {
	        this.trigger('drag', dx, dy, ev);
	        this.updateAutoScroll(ev); // will possibly cause scrolling
	    };
	    DragListener.prototype.endDrag = function (ev) {
	        if (this.isDragging) {
	            this.isDragging = false;
	            this.handleDragEnd(ev);
	        }
	    };
	    DragListener.prototype.handleDragEnd = function (ev) {
	        this.trigger('dragEnd', ev);
	    };
	    // Delay
	    // -----------------------------------------------------------------------------------------------------------------
	    DragListener.prototype.startDelay = function (initialEv) {
	        var _this = this;
	        if (this.delay) {
	            this.delayTimeoutId = setTimeout(function () {
	                _this.handleDelayEnd(initialEv);
	            }, this.delay);
	        }
	        else {
	            this.handleDelayEnd(initialEv);
	        }
	    };
	    DragListener.prototype.handleDelayEnd = function (initialEv) {
	        this.isDelayEnded = true;
	        if (this.isDistanceSurpassed) {
	            this.startDrag(initialEv);
	        }
	    };
	    // Distance
	    // -----------------------------------------------------------------------------------------------------------------
	    DragListener.prototype.handleDistanceSurpassed = function (ev) {
	        this.isDistanceSurpassed = true;
	        if (this.isDelayEnded) {
	            this.startDrag(ev);
	        }
	    };
	    // Mouse / Touch
	    // -----------------------------------------------------------------------------------------------------------------
	    DragListener.prototype.handleTouchMove = function (ev) {
	        // prevent inertia and touchmove-scrolling while dragging
	        if (this.isDragging && this.shouldCancelTouchScroll) {
	            ev.preventDefault();
	        }
	        this.handleMove(ev);
	    };
	    DragListener.prototype.handleMouseMove = function (ev) {
	        this.handleMove(ev);
	    };
	    // Scrolling (unrelated to auto-scroll)
	    // -----------------------------------------------------------------------------------------------------------------
	    DragListener.prototype.handleTouchScroll = function (ev) {
	        // if the drag is being initiated by touch, but a scroll happens before
	        // the drag-initiating delay is over, cancel the drag
	        if (!this.isDragging || this.scrollAlwaysKills) {
	            this.endInteraction(ev, true); // isCancelled=true
	        }
	    };
	    // Utils
	    // -----------------------------------------------------------------------------------------------------------------
	    // Triggers a callback. Calls a function in the option hash of the same name.
	    // Arguments beyond the first `name` are forwarded on.
	    DragListener.prototype.trigger = function (name) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        if (this.options[name]) {
	            this.options[name].apply(this, args);
	        }
	        // makes _methods callable by event name. TODO: kill this
	        if (this['_' + name]) {
	            this['_' + name].apply(this, args);
	        }
	    };
	    // Auto-scroll
	    // -----------------------------------------------------------------------------------------------------------------
	    DragListener.prototype.initAutoScroll = function () {
	        var scrollEl = this.scrollEl;
	        this.isAutoScroll =
	            this.options.scroll &&
	                scrollEl &&
	                !scrollEl.is(window) &&
	                !scrollEl.is(document);
	        if (this.isAutoScroll) {
	            // debounce makes sure rapid calls don't happen
	            this.listenTo(scrollEl, 'scroll', util_1.debounce(this.handleDebouncedScroll, 100));
	        }
	    };
	    DragListener.prototype.destroyAutoScroll = function () {
	        this.endAutoScroll(); // kill any animation loop
	        // remove the scroll handler if there is a scrollEl
	        if (this.isAutoScroll) {
	            this.stopListeningTo(this.scrollEl, 'scroll'); // will probably get removed by unbindHandlers too :(
	        }
	    };
	    // Computes and stores the bounding rectangle of scrollEl
	    DragListener.prototype.computeScrollBounds = function () {
	        if (this.isAutoScroll) {
	            this.scrollBounds = util_1.getOuterRect(this.scrollEl);
	            // TODO: use getClientRect in future. but prevents auto scrolling when on top of scrollbars
	        }
	    };
	    // Called when the dragging is in progress and scrolling should be updated
	    DragListener.prototype.updateAutoScroll = function (ev) {
	        var sensitivity = this.scrollSensitivity;
	        var bounds = this.scrollBounds;
	        var topCloseness;
	        var bottomCloseness;
	        var leftCloseness;
	        var rightCloseness;
	        var topVel = 0;
	        var leftVel = 0;
	        if (bounds) { // only scroll if scrollEl exists
	            // compute closeness to edges. valid range is from 0.0 - 1.0
	            topCloseness = (sensitivity - (util_1.getEvY(ev) - bounds.top)) / sensitivity;
	            bottomCloseness = (sensitivity - (bounds.bottom - util_1.getEvY(ev))) / sensitivity;
	            leftCloseness = (sensitivity - (util_1.getEvX(ev) - bounds.left)) / sensitivity;
	            rightCloseness = (sensitivity - (bounds.right - util_1.getEvX(ev))) / sensitivity;
	            // translate vertical closeness into velocity.
	            // mouse must be completely in bounds for velocity to happen.
	            if (topCloseness >= 0 && topCloseness <= 1) {
	                topVel = topCloseness * this.scrollSpeed * -1; // negative. for scrolling up
	            }
	            else if (bottomCloseness >= 0 && bottomCloseness <= 1) {
	                topVel = bottomCloseness * this.scrollSpeed;
	            }
	            // translate horizontal closeness into velocity
	            if (leftCloseness >= 0 && leftCloseness <= 1) {
	                leftVel = leftCloseness * this.scrollSpeed * -1; // negative. for scrolling left
	            }
	            else if (rightCloseness >= 0 && rightCloseness <= 1) {
	                leftVel = rightCloseness * this.scrollSpeed;
	            }
	        }
	        this.setScrollVel(topVel, leftVel);
	    };
	    // Sets the speed-of-scrolling for the scrollEl
	    DragListener.prototype.setScrollVel = function (topVel, leftVel) {
	        this.scrollTopVel = topVel;
	        this.scrollLeftVel = leftVel;
	        this.constrainScrollVel(); // massages into realistic values
	        // if there is non-zero velocity, and an animation loop hasn't already started, then START
	        if ((this.scrollTopVel || this.scrollLeftVel) && !this.scrollIntervalId) {
	            this.scrollIntervalId = setInterval(util_1.proxy(this, 'scrollIntervalFunc'), // scope to `this`
	            this.scrollIntervalMs);
	        }
	    };
	    // Forces scrollTopVel and scrollLeftVel to be zero if scrolling has already gone all the way
	    DragListener.prototype.constrainScrollVel = function () {
	        var el = this.scrollEl;
	        if (this.scrollTopVel < 0) { // scrolling up?
	            if (el.scrollTop() <= 0) { // already scrolled all the way up?
	                this.scrollTopVel = 0;
	            }
	        }
	        else if (this.scrollTopVel > 0) { // scrolling down?
	            if (el.scrollTop() + el[0].clientHeight >= el[0].scrollHeight) { // already scrolled all the way down?
	                this.scrollTopVel = 0;
	            }
	        }
	        if (this.scrollLeftVel < 0) { // scrolling left?
	            if (el.scrollLeft() <= 0) { // already scrolled all the left?
	                this.scrollLeftVel = 0;
	            }
	        }
	        else if (this.scrollLeftVel > 0) { // scrolling right?
	            if (el.scrollLeft() + el[0].clientWidth >= el[0].scrollWidth) { // already scrolled all the way right?
	                this.scrollLeftVel = 0;
	            }
	        }
	    };
	    // This function gets called during every iteration of the scrolling animation loop
	    DragListener.prototype.scrollIntervalFunc = function () {
	        var el = this.scrollEl;
	        var frac = this.scrollIntervalMs / 1000; // considering animation frequency, what the vel should be mult'd by
	        // change the value of scrollEl's scroll
	        if (this.scrollTopVel) {
	            el.scrollTop(el.scrollTop() + this.scrollTopVel * frac);
	        }
	        if (this.scrollLeftVel) {
	            el.scrollLeft(el.scrollLeft() + this.scrollLeftVel * frac);
	        }
	        this.constrainScrollVel(); // since the scroll values changed, recompute the velocities
	        // if scrolled all the way, which causes the vels to be zero, stop the animation loop
	        if (!this.scrollTopVel && !this.scrollLeftVel) {
	            this.endAutoScroll();
	        }
	    };
	    // Kills any existing scrolling animation loop
	    DragListener.prototype.endAutoScroll = function () {
	        if (this.scrollIntervalId) {
	            clearInterval(this.scrollIntervalId);
	            this.scrollIntervalId = null;
	            this.handleScrollEnd();
	        }
	    };
	    // Get called when the scrollEl is scrolled (NOTE: this is delayed via debounce)
	    DragListener.prototype.handleDebouncedScroll = function () {
	        // recompute all coordinates, but *only* if this is *not* part of our scrolling animation
	        if (!this.scrollIntervalId) {
	            this.handleScrollEnd();
	        }
	    };
	    DragListener.prototype.handleScrollEnd = function () {
	        // Called when scrolling has stopped, whether through auto scroll, or the user scrolling
	    };
	    return DragListener;
	}());
	exports.default = DragListener;
	ListenerMixin_1.default.mixInto(DragListener);
	
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	var Mixin_1 = __webpack_require__(15);
	/*
	A set of rendering and date-related methods for a visual component comprised of one or more rows of day columns.
	Prerequisite: the object being mixed into needs to be a *Grid*
	*/
	var DayTableMixin = /** @class */ (function (_super) {
	    tslib_1.__extends(DayTableMixin, _super);
	    function DayTableMixin() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // Populates internal variables used for date calculation and rendering
	    DayTableMixin.prototype.updateDayTable = function () {
	        var t = this;
	        var view = t.view;
	        var calendar = view.calendar;
	        var date = calendar.msToUtcMoment(t.dateProfile.renderUnzonedRange.startMs, true);
	        var end = calendar.msToUtcMoment(t.dateProfile.renderUnzonedRange.endMs, true);
	        var dayIndex = -1;
	        var dayIndices = [];
	        var dayDates = [];
	        var daysPerRow;
	        var firstDay;
	        var rowCnt;
	        while (date.isBefore(end)) { // loop each day from start to end
	            if (view.isHiddenDay(date)) {
	                dayIndices.push(dayIndex + 0.5); // mark that it's between indices
	            }
	            else {
	                dayIndex++;
	                dayIndices.push(dayIndex);
	                dayDates.push(date.clone());
	            }
	            date.add(1, 'days');
	        }
	        if (this.breakOnWeeks) {
	            // count columns until the day-of-week repeats
	            firstDay = dayDates[0].day();
	            for (daysPerRow = 1; daysPerRow < dayDates.length; daysPerRow++) {
	                if (dayDates[daysPerRow].day() === firstDay) {
	                    break;
	                }
	            }
	            rowCnt = Math.ceil(dayDates.length / daysPerRow);
	        }
	        else {
	            rowCnt = 1;
	            daysPerRow = dayDates.length;
	        }
	        this.dayDates = dayDates;
	        this.dayIndices = dayIndices;
	        this.daysPerRow = daysPerRow;
	        this.rowCnt = rowCnt;
	        this.updateDayTableCols();
	    };
	    // Computes and assigned the colCnt property and updates any options that may be computed from it
	    DayTableMixin.prototype.updateDayTableCols = function () {
	        this.colCnt = this.computeColCnt();
	        this.colHeadFormat =
	            this.opt('columnHeaderFormat') ||
	                this.opt('columnFormat') || // deprecated
	                this.computeColHeadFormat();
	    };
	    // Determines how many columns there should be in the table
	    DayTableMixin.prototype.computeColCnt = function () {
	        return this.daysPerRow;
	    };
	    // Computes the ambiguously-timed moment for the given cell
	    DayTableMixin.prototype.getCellDate = function (row, col) {
	        return this.dayDates[this.getCellDayIndex(row, col)].clone();
	    };
	    // Computes the ambiguously-timed date range for the given cell
	    DayTableMixin.prototype.getCellRange = function (row, col) {
	        var start = this.getCellDate(row, col);
	        var end = start.clone().add(1, 'days');
	        return { start: start, end: end };
	    };
	    // Returns the number of day cells, chronologically, from the first of the grid (0-based)
	    DayTableMixin.prototype.getCellDayIndex = function (row, col) {
	        return row * this.daysPerRow + this.getColDayIndex(col);
	    };
	    // Returns the numner of day cells, chronologically, from the first cell in *any given row*
	    DayTableMixin.prototype.getColDayIndex = function (col) {
	        if (this.isRTL) {
	            return this.colCnt - 1 - col;
	        }
	        else {
	            return col;
	        }
	    };
	    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
	    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
	    // If before the first offset, returns a negative number.
	    // If after the last offset, returns an offset past the last cell offset.
	    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
	    DayTableMixin.prototype.getDateDayIndex = function (date) {
	        var dayIndices = this.dayIndices;
	        var dayOffset = date.diff(this.dayDates[0], 'days');
	        if (dayOffset < 0) {
	            return dayIndices[0] - 1;
	        }
	        else if (dayOffset >= dayIndices.length) {
	            return dayIndices[dayIndices.length - 1] + 1;
	        }
	        else {
	            return dayIndices[dayOffset];
	        }
	    };
	    /* Options
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Computes a default column header formatting string if `colFormat` is not explicitly defined
	    DayTableMixin.prototype.computeColHeadFormat = function () {
	        // if more than one week row, or if there are a lot of columns with not much space,
	        // put just the day numbers will be in each cell
	        if (this.rowCnt > 1 || this.colCnt > 10) {
	            return 'ddd'; // "Sat"
	        }
	        else if (this.colCnt > 1) {
	            return this.opt('dayOfMonthFormat'); // "Sat 12/10"
	        }
	        else {
	            return 'dddd'; // "Saturday"
	        }
	    };
	    /* Slicing
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Slices up a date range into a segment for every week-row it intersects with
	    DayTableMixin.prototype.sliceRangeByRow = function (unzonedRange) {
	        var daysPerRow = this.daysPerRow;
	        var normalRange = this.view.computeDayRange(unzonedRange); // make whole-day range, considering nextDayThreshold
	        var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
	        var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
	        var segs = [];
	        var row;
	        var rowFirst;
	        var rowLast; // inclusive day-index range for current row
	        var segFirst;
	        var segLast; // inclusive day-index range for segment
	        for (row = 0; row < this.rowCnt; row++) {
	            rowFirst = row * daysPerRow;
	            rowLast = rowFirst + daysPerRow - 1;
	            // intersect segment's offset range with the row's
	            segFirst = Math.max(rangeFirst, rowFirst);
	            segLast = Math.min(rangeLast, rowLast);
	            // deal with in-between indices
	            segFirst = Math.ceil(segFirst); // in-between starts round to next cell
	            segLast = Math.floor(segLast); // in-between ends round to prev cell
	            if (segFirst <= segLast) { // was there any intersection with the current row?
	                segs.push({
	                    row: row,
	                    // normalize to start of row
	                    firstRowDayIndex: segFirst - rowFirst,
	                    lastRowDayIndex: segLast - rowFirst,
	                    // must be matching integers to be the segment's start/end
	                    isStart: segFirst === rangeFirst,
	                    isEnd: segLast === rangeLast
	                });
	            }
	        }
	        return segs;
	    };
	    // Slices up a date range into a segment for every day-cell it intersects with.
	    // TODO: make more DRY with sliceRangeByRow somehow.
	    DayTableMixin.prototype.sliceRangeByDay = function (unzonedRange) {
	        var daysPerRow = this.daysPerRow;
	        var normalRange = this.view.computeDayRange(unzonedRange); // make whole-day range, considering nextDayThreshold
	        var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
	        var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
	        var segs = [];
	        var row;
	        var rowFirst;
	        var rowLast; // inclusive day-index range for current row
	        var i;
	        var segFirst;
	        var segLast; // inclusive day-index range for segment
	        for (row = 0; row < this.rowCnt; row++) {
	            rowFirst = row * daysPerRow;
	            rowLast = rowFirst + daysPerRow - 1;
	            for (i = rowFirst; i <= rowLast; i++) {
	                // intersect segment's offset range with the row's
	                segFirst = Math.max(rangeFirst, i);
	                segLast = Math.min(rangeLast, i);
	                // deal with in-between indices
	                segFirst = Math.ceil(segFirst); // in-between starts round to next cell
	                segLast = Math.floor(segLast); // in-between ends round to prev cell
	                if (segFirst <= segLast) { // was there any intersection with the current row?
	                    segs.push({
	                        row: row,
	                        // normalize to start of row
	                        firstRowDayIndex: segFirst - rowFirst,
	                        lastRowDayIndex: segLast - rowFirst,
	                        // must be matching integers to be the segment's start/end
	                        isStart: segFirst === rangeFirst,
	                        isEnd: segLast === rangeLast
	                    });
	                }
	            }
	        }
	        return segs;
	    };
	    /* Header Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    DayTableMixin.prototype.renderHeadHtml = function () {
	        var theme = this.view.calendar.theme;
	        return '' +
	            '<div class="fc-row ' + theme.getClass('headerRow') + '">' +
	            '<table class="' + theme.getClass('tableGrid') + '">' +
	            '<thead>' +
	            this.renderHeadTrHtml() +
	            '</thead>' +
	            '</table>' +
	            '</div>';
	    };
	    DayTableMixin.prototype.renderHeadIntroHtml = function () {
	        return this.renderIntroHtml(); // fall back to generic
	    };
	    DayTableMixin.prototype.renderHeadTrHtml = function () {
	        return '' +
	            '<tr>' +
	            (this.isRTL ? '' : this.renderHeadIntroHtml()) +
	            this.renderHeadDateCellsHtml() +
	            (this.isRTL ? this.renderHeadIntroHtml() : '') +
	            '</tr>';
	    };
	    DayTableMixin.prototype.renderHeadDateCellsHtml = function () {
	        var htmls = [];
	        var col;
	        var date;
	        for (col = 0; col < this.colCnt; col++) {
	            date = this.getCellDate(0, col);
	            htmls.push(this.renderHeadDateCellHtml(date));
	        }
	        return htmls.join('');
	    };
	    // TODO: when internalApiVersion, accept an object for HTML attributes
	    // (colspan should be no different)
	    DayTableMixin.prototype.renderHeadDateCellHtml = function (date, colspan, otherAttrs) {
	        var t = this;
	        var view = t.view;
	        var isDateValid = t.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
	        var classNames = [
	            'fc-day-header',
	            view.calendar.theme.getClass('widgetHeader')
	        ];
	        var innerHtml;
	        if (typeof t.opt('columnHeaderHtml') === 'function') {
	            innerHtml = t.opt('columnHeaderHtml')(date);
	        }
	        else if (typeof t.opt('columnHeaderText') === 'function') {
	            innerHtml = util_1.htmlEscape(t.opt('columnHeaderText')(date));
	        }
	        else {
	            innerHtml = util_1.htmlEscape(date.format(t.colHeadFormat));
	        }
	        // if only one row of days, the classNames on the header can represent the specific days beneath
	        if (t.rowCnt === 1) {
	            classNames = classNames.concat(
	            // includes the day-of-week class
	            // noThemeHighlight=true (don't highlight the header)
	            t.getDayClasses(date, true));
	        }
	        else {
	            classNames.push('fc-' + util_1.dayIDs[date.day()]); // only add the day-of-week class
	        }
	        return '' +
	            '<th class="' + classNames.join(' ') + '"' +
	            ((isDateValid && t.rowCnt) === 1 ?
	                ' data-date="' + date.format('YYYY-MM-DD') + '"' :
	                '') +
	            (colspan > 1 ?
	                ' colspan="' + colspan + '"' :
	                '') +
	            (otherAttrs ?
	                ' ' + otherAttrs :
	                '') +
	            '>' +
	            (isDateValid ?
	                // don't make a link if the heading could represent multiple days, or if there's only one day (forceOff)
	                view.buildGotoAnchorHtml({ date: date, forceOff: t.rowCnt > 1 || t.colCnt === 1 }, innerHtml) :
	                // if not valid, display text, but no link
	                innerHtml) +
	            '</th>';
	    };
	    /* Background Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    DayTableMixin.prototype.renderBgTrHtml = function (row) {
	        return '' +
	            '<tr>' +
	            (this.isRTL ? '' : this.renderBgIntroHtml(row)) +
	            this.renderBgCellsHtml(row) +
	            (this.isRTL ? this.renderBgIntroHtml(row) : '') +
	            '</tr>';
	    };
	    DayTableMixin.prototype.renderBgIntroHtml = function (row) {
	        return this.renderIntroHtml(); // fall back to generic
	    };
	    DayTableMixin.prototype.renderBgCellsHtml = function (row) {
	        var htmls = [];
	        var col;
	        var date;
	        for (col = 0; col < this.colCnt; col++) {
	            date = this.getCellDate(row, col);
	            htmls.push(this.renderBgCellHtml(date));
	        }
	        return htmls.join('');
	    };
	    DayTableMixin.prototype.renderBgCellHtml = function (date, otherAttrs) {
	        var t = this;
	        var view = t.view;
	        var isDateValid = t.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
	        var classes = t.getDayClasses(date);
	        classes.unshift('fc-day', view.calendar.theme.getClass('widgetContent'));
	        return '<td class="' + classes.join(' ') + '"' +
	            (isDateValid ?
	                ' data-date="' + date.format('YYYY-MM-DD') + '"' : // if date has a time, won't format it
	                '') +
	            (otherAttrs ?
	                ' ' + otherAttrs :
	                '') +
	            '></td>';
	    };
	    /* Generic
	    ------------------------------------------------------------------------------------------------------------------*/
	    DayTableMixin.prototype.renderIntroHtml = function () {
	        // Generates the default HTML intro for any row. User classes should override
	    };
	    // TODO: a generic method for dealing with <tr>, RTL, intro
	    // when increment internalApiVersion
	    // wrapTr (scheduler)
	    /* Utils
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Applies the generic "intro" and "outro" HTML to the given cells.
	    // Intro means the leftmost cell when the calendar is LTR and the rightmost cell when RTL. Vice-versa for outro.
	    DayTableMixin.prototype.bookendCells = function (trEl) {
	        var introHtml = this.renderIntroHtml();
	        if (introHtml) {
	            if (this.isRTL) {
	                trEl.append(introHtml);
	            }
	            else {
	                trEl.prepend(introHtml);
	            }
	        }
	    };
	    return DayTableMixin;
	}(Mixin_1.default));
	exports.default = DayTableMixin;
	
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var BusinessHourRenderer = /** @class */ (function () {
	    /*
	    component implements:
	      - eventRangesToEventFootprints
	      - eventFootprintsToSegs
	    */
	    function BusinessHourRenderer(component, fillRenderer) {
	        this.component = component;
	        this.fillRenderer = fillRenderer;
	    }
	    BusinessHourRenderer.prototype.render = function (businessHourGenerator) {
	        var component = this.component;
	        var unzonedRange = component._getDateProfile().activeUnzonedRange;
	        var eventInstanceGroup = businessHourGenerator.buildEventInstanceGroup(component.hasAllDayBusinessHours, unzonedRange);
	        var eventFootprints = eventInstanceGroup ?
	            component.eventRangesToEventFootprints(eventInstanceGroup.sliceRenderRanges(unzonedRange)) :
	            [];
	        this.renderEventFootprints(eventFootprints);
	    };
	    BusinessHourRenderer.prototype.renderEventFootprints = function (eventFootprints) {
	        var segs = this.component.eventFootprintsToSegs(eventFootprints);
	        this.renderSegs(segs);
	        this.segs = segs;
	    };
	    BusinessHourRenderer.prototype.renderSegs = function (segs) {
	        if (this.fillRenderer) {
	            this.fillRenderer.renderSegs('businessHours', segs, {
	                getClasses: function (seg) {
	                    return ['fc-nonbusiness', 'fc-bgevent'];
	                }
	            });
	        }
	    };
	    BusinessHourRenderer.prototype.unrender = function () {
	        if (this.fillRenderer) {
	            this.fillRenderer.unrender('businessHours');
	        }
	        this.segs = null;
	    };
	    BusinessHourRenderer.prototype.getSegs = function () {
	        return this.segs || [];
	    };
	    return BusinessHourRenderer;
	}());
	exports.default = BusinessHourRenderer;
	
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var FillRenderer = /** @class */ (function () {
	    function FillRenderer(component) {
	        this.fillSegTag = 'div';
	        this.component = component;
	        this.elsByFill = {};
	    }
	    FillRenderer.prototype.renderFootprint = function (type, componentFootprint, props) {
	        this.renderSegs(type, this.component.componentFootprintToSegs(componentFootprint), props);
	    };
	    FillRenderer.prototype.renderSegs = function (type, segs, props) {
	        var els;
	        segs = this.buildSegEls(type, segs, props); // assignes `.el` to each seg. returns successfully rendered segs
	        els = this.attachSegEls(type, segs);
	        if (els) {
	            this.reportEls(type, els);
	        }
	        return segs;
	    };
	    // Unrenders a specific type of fill that is currently rendered on the grid
	    FillRenderer.prototype.unrender = function (type) {
	        var el = this.elsByFill[type];
	        if (el) {
	            el.remove();
	            delete this.elsByFill[type];
	        }
	    };
	    // Renders and assigns an `el` property for each fill segment. Generic enough to work with different types.
	    // Only returns segments that successfully rendered.
	    FillRenderer.prototype.buildSegEls = function (type, segs, props) {
	        var _this = this;
	        var html = '';
	        var renderedSegs = [];
	        var i;
	        if (segs.length) {
	            // build a large concatenation of segment HTML
	            for (i = 0; i < segs.length; i++) {
	                html += this.buildSegHtml(type, segs[i], props);
	            }
	            // Grab individual elements from the combined HTML string. Use each as the default rendering.
	            // Then, compute the 'el' for each segment.
	            $(html).each(function (i, node) {
	                var seg = segs[i];
	                var el = $(node);
	                // allow custom filter methods per-type
	                if (props.filterEl) {
	                    el = props.filterEl(seg, el);
	                }
	                if (el) { // custom filters did not cancel the render
	                    el = $(el); // allow custom filter to return raw DOM node
	                    // correct element type? (would be bad if a non-TD were inserted into a table for example)
	                    if (el.is(_this.fillSegTag)) {
	                        seg.el = el;
	                        renderedSegs.push(seg);
	                    }
	                }
	            });
	        }
	        return renderedSegs;
	    };
	    // Builds the HTML needed for one fill segment. Generic enough to work with different types.
	    FillRenderer.prototype.buildSegHtml = function (type, seg, props) {
	        // custom hooks per-type
	        var classes = props.getClasses ? props.getClasses(seg) : [];
	        var css = util_1.cssToStr(props.getCss ? props.getCss(seg) : {});
	        return '<' + this.fillSegTag +
	            (classes.length ? ' class="' + classes.join(' ') + '"' : '') +
	            (css ? ' style="' + css + '"' : '') +
	            '></' + this.fillSegTag + '>';
	    };
	    // Should return wrapping DOM structure
	    FillRenderer.prototype.attachSegEls = function (type, segs) {
	        // subclasses must implement
	    };
	    FillRenderer.prototype.reportEls = function (type, nodes) {
	        if (this.elsByFill[type]) {
	            this.elsByFill[type] = this.elsByFill[type].add(nodes);
	        }
	        else {
	            this.elsByFill[type] = $(nodes);
	        }
	    };
	    return FillRenderer;
	}());
	exports.default = FillRenderer;
	
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var SingleEventDef_1 = __webpack_require__(9);
	var EventFootprint_1 = __webpack_require__(34);
	var EventSource_1 = __webpack_require__(6);
	var HelperRenderer = /** @class */ (function () {
	    function HelperRenderer(component, eventRenderer) {
	        this.view = component._getView();
	        this.component = component;
	        this.eventRenderer = eventRenderer;
	    }
	    HelperRenderer.prototype.renderComponentFootprint = function (componentFootprint) {
	        this.renderEventFootprints([
	            this.fabricateEventFootprint(componentFootprint)
	        ]);
	    };
	    HelperRenderer.prototype.renderEventDraggingFootprints = function (eventFootprints, sourceSeg, isTouch) {
	        this.renderEventFootprints(eventFootprints, sourceSeg, 'fc-dragging', isTouch ? null : this.view.opt('dragOpacity'));
	    };
	    HelperRenderer.prototype.renderEventResizingFootprints = function (eventFootprints, sourceSeg, isTouch) {
	        this.renderEventFootprints(eventFootprints, sourceSeg, 'fc-resizing');
	    };
	    HelperRenderer.prototype.renderEventFootprints = function (eventFootprints, sourceSeg, extraClassNames, opacity) {
	        var segs = this.component.eventFootprintsToSegs(eventFootprints);
	        var classNames = 'fc-helper ' + (extraClassNames || '');
	        var i;
	        // assigns each seg's el and returns a subset of segs that were rendered
	        segs = this.eventRenderer.renderFgSegEls(segs);
	        for (i = 0; i < segs.length; i++) {
	            segs[i].el.addClass(classNames);
	        }
	        if (opacity != null) {
	            for (i = 0; i < segs.length; i++) {
	                segs[i].el.css('opacity', opacity);
	            }
	        }
	        this.helperEls = this.renderSegs(segs, sourceSeg);
	    };
	    /*
	    Must return all mock event elements
	    */
	    HelperRenderer.prototype.renderSegs = function (segs, sourceSeg) {
	        // Subclasses must implement
	    };
	    HelperRenderer.prototype.unrender = function () {
	        if (this.helperEls) {
	            this.helperEls.remove();
	            this.helperEls = null;
	        }
	    };
	    HelperRenderer.prototype.fabricateEventFootprint = function (componentFootprint) {
	        var calendar = this.view.calendar;
	        var eventDateProfile = calendar.footprintToDateProfile(componentFootprint);
	        var dummyEvent = new SingleEventDef_1.default(new EventSource_1.default(calendar));
	        var dummyInstance;
	        dummyEvent.dateProfile = eventDateProfile;
	        dummyInstance = dummyEvent.buildInstance();
	        return new EventFootprint_1.default(componentFootprint, dummyEvent, dummyInstance);
	    };
	    return HelperRenderer;
	}());
	exports.default = HelperRenderer;
	
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var GlobalEmitter_1 = __webpack_require__(23);
	var Interaction_1 = __webpack_require__(14);
	var EventPointing = /** @class */ (function (_super) {
	    tslib_1.__extends(EventPointing, _super);
	    function EventPointing() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /*
	    component must implement:
	      - publiclyTrigger
	    */
	    EventPointing.prototype.bindToEl = function (el) {
	        var component = this.component;
	        component.bindSegHandlerToEl(el, 'click', this.handleClick.bind(this));
	        component.bindSegHandlerToEl(el, 'mouseenter', this.handleMouseover.bind(this));
	        component.bindSegHandlerToEl(el, 'mouseleave', this.handleMouseout.bind(this));
	    };
	    EventPointing.prototype.handleClick = function (seg, ev) {
	        var res = this.component.publiclyTrigger('eventClick', {
	            context: seg.el[0],
	            args: [seg.footprint.getEventLegacy(), ev, this.view]
	        });
	        if (res === false) {
	            ev.preventDefault();
	        }
	    };
	    // Updates internal state and triggers handlers for when an event element is moused over
	    EventPointing.prototype.handleMouseover = function (seg, ev) {
	        if (!GlobalEmitter_1.default.get().shouldIgnoreMouse() &&
	            !this.mousedOverSeg) {
	            this.mousedOverSeg = seg;
	            // TODO: move to EventSelecting's responsibility
	            if (this.view.isEventDefResizable(seg.footprint.eventDef)) {
	                seg.el.addClass('fc-allow-mouse-resize');
	            }
	            this.component.publiclyTrigger('eventMouseover', {
	                context: seg.el[0],
	                args: [seg.footprint.getEventLegacy(), ev, this.view]
	            });
	        }
	    };
	    // Updates internal state and triggers handlers for when an event element is moused out.
	    // Can be given no arguments, in which case it will mouseout the segment that was previously moused over.
	    EventPointing.prototype.handleMouseout = function (seg, ev) {
	        if (this.mousedOverSeg) {
	            this.mousedOverSeg = null;
	            // TODO: move to EventSelecting's responsibility
	            if (this.view.isEventDefResizable(seg.footprint.eventDef)) {
	                seg.el.removeClass('fc-allow-mouse-resize');
	            }
	            this.component.publiclyTrigger('eventMouseout', {
	                context: seg.el[0],
	                args: [
	                    seg.footprint.getEventLegacy(),
	                    ev || {},
	                    this.view
	                ]
	            });
	        }
	    };
	    EventPointing.prototype.end = function () {
	        if (this.mousedOverSeg) {
	            this.handleMouseout(this.mousedOverSeg);
	        }
	    };
	    return EventPointing;
	}(Interaction_1.default));
	exports.default = EventPointing;
	
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var Mixin_1 = __webpack_require__(15);
	var DateClicking_1 = __webpack_require__(237);
	var DateSelecting_1 = __webpack_require__(236);
	var EventPointing_1 = __webpack_require__(64);
	var EventDragging_1 = __webpack_require__(235);
	var EventResizing_1 = __webpack_require__(234);
	var ExternalDropping_1 = __webpack_require__(233);
	var StandardInteractionsMixin = /** @class */ (function (_super) {
	    tslib_1.__extends(StandardInteractionsMixin, _super);
	    function StandardInteractionsMixin() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return StandardInteractionsMixin;
	}(Mixin_1.default));
	exports.default = StandardInteractionsMixin;
	StandardInteractionsMixin.prototype.dateClickingClass = DateClicking_1.default;
	StandardInteractionsMixin.prototype.dateSelectingClass = DateSelecting_1.default;
	StandardInteractionsMixin.prototype.eventPointingClass = EventPointing_1.default;
	StandardInteractionsMixin.prototype.eventDraggingClass = EventDragging_1.default;
	StandardInteractionsMixin.prototype.eventResizingClass = EventResizing_1.default;
	StandardInteractionsMixin.prototype.externalDroppingClass = ExternalDropping_1.default;
	
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var CoordCache_1 = __webpack_require__(58);
	var Popover_1 = __webpack_require__(227);
	var UnzonedRange_1 = __webpack_require__(5);
	var ComponentFootprint_1 = __webpack_require__(12);
	var EventFootprint_1 = __webpack_require__(34);
	var BusinessHourRenderer_1 = __webpack_require__(61);
	var StandardInteractionsMixin_1 = __webpack_require__(65);
	var InteractiveDateComponent_1 = __webpack_require__(42);
	var DayTableMixin_1 = __webpack_require__(60);
	var DayGridEventRenderer_1 = __webpack_require__(243);
	var DayGridHelperRenderer_1 = __webpack_require__(244);
	var DayGridFillRenderer_1 = __webpack_require__(245);
	/* A component that renders a grid of whole-days that runs horizontally. There can be multiple rows, one per week.
	----------------------------------------------------------------------------------------------------------------------*/
	var DayGrid = /** @class */ (function (_super) {
	    tslib_1.__extends(DayGrid, _super);
	    function DayGrid(view) {
	        var _this = _super.call(this, view) || this;
	        _this.cellWeekNumbersVisible = false; // display week numbers in day cell?
	        _this.bottomCoordPadding = 0; // hack for extending the hit area for the last row of the coordinate grid
	        // isRigid determines whether the individual rows should ignore the contents and be a constant height.
	        // Relies on the view's colCnt and rowCnt. In the future, this component should probably be self-sufficient.
	        _this.isRigid = false;
	        _this.hasAllDayBusinessHours = true;
	        return _this;
	    }
	    // Slices up the given span (unzoned start/end with other misc data) into an array of segments
	    DayGrid.prototype.componentFootprintToSegs = function (componentFootprint) {
	        var segs = this.sliceRangeByRow(componentFootprint.unzonedRange);
	        var i;
	        var seg;
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            if (this.isRTL) {
	                seg.leftCol = this.daysPerRow - 1 - seg.lastRowDayIndex;
	                seg.rightCol = this.daysPerRow - 1 - seg.firstRowDayIndex;
	            }
	            else {
	                seg.leftCol = seg.firstRowDayIndex;
	                seg.rightCol = seg.lastRowDayIndex;
	            }
	        }
	        return segs;
	    };
	    /* Date Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    DayGrid.prototype.renderDates = function (dateProfile) {
	        this.dateProfile = dateProfile;
	        this.updateDayTable();
	        this.renderGrid();
	    };
	    DayGrid.prototype.unrenderDates = function () {
	        this.removeSegPopover();
	    };
	    // Renders the rows and columns into the component's `this.el`, which should already be assigned.
	    DayGrid.prototype.renderGrid = function () {
	        var view = this.view;
	        var rowCnt = this.rowCnt;
	        var colCnt = this.colCnt;
	        var html = '';
	        var row;
	        var col;
	        if (this.headContainerEl) {
	            this.headContainerEl.html(this.renderHeadHtml());
	        }
	        for (row = 0; row < rowCnt; row++) {
	            html += this.renderDayRowHtml(row, this.isRigid);
	        }
	        this.el.html(html);
	        this.rowEls = this.el.find('.fc-row');
	        this.cellEls = this.el.find('.fc-day, .fc-disabled-day');
	        this.rowCoordCache = new CoordCache_1.default({
	            els: this.rowEls,
	            isVertical: true
	        });
	        this.colCoordCache = new CoordCache_1.default({
	            els: this.cellEls.slice(0, this.colCnt),
	            isHorizontal: true
	        });
	        // trigger dayRender with each cell's element
	        for (row = 0; row < rowCnt; row++) {
	            for (col = 0; col < colCnt; col++) {
	                this.publiclyTrigger('dayRender', {
	                    context: view,
	                    args: [
	                        this.getCellDate(row, col),
	                        this.getCellEl(row, col),
	                        view
	                    ]
	                });
	            }
	        }
	    };
	    // Generates the HTML for a single row, which is a div that wraps a table.
	    // `row` is the row number.
	    DayGrid.prototype.renderDayRowHtml = function (row, isRigid) {
	        var theme = this.view.calendar.theme;
	        var classes = ['fc-row', 'fc-week', theme.getClass('dayRow')];
	        if (isRigid) {
	            classes.push('fc-rigid');
	        }
	        return '' +
	            '<div class="' + classes.join(' ') + '">' +
	            '<div class="fc-bg">' +
	            '<table class="' + theme.getClass('tableGrid') + '">' +
	            this.renderBgTrHtml(row) +
	            '</table>' +
	            '</div>' +
	            '<div class="fc-content-skeleton">' +
	            '<table>' +
	            (this.getIsNumbersVisible() ?
	                '<thead>' +
	                    this.renderNumberTrHtml(row) +
	                    '</thead>' :
	                '') +
	            '</table>' +
	            '</div>' +
	            '</div>';
	    };
	    DayGrid.prototype.getIsNumbersVisible = function () {
	        return this.getIsDayNumbersVisible() || this.cellWeekNumbersVisible;
	    };
	    DayGrid.prototype.getIsDayNumbersVisible = function () {
	        return this.rowCnt > 1;
	    };
	    /* Grid Number Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    DayGrid.prototype.renderNumberTrHtml = function (row) {
	        return '' +
	            '<tr>' +
	            (this.isRTL ? '' : this.renderNumberIntroHtml(row)) +
	            this.renderNumberCellsHtml(row) +
	            (this.isRTL ? this.renderNumberIntroHtml(row) : '') +
	            '</tr>';
	    };
	    DayGrid.prototype.renderNumberIntroHtml = function (row) {
	        return this.renderIntroHtml();
	    };
	    DayGrid.prototype.renderNumberCellsHtml = function (row) {
	        var htmls = [];
	        var col;
	        var date;
	        for (col = 0; col < this.colCnt; col++) {
	            date = this.getCellDate(row, col);
	            htmls.push(this.renderNumberCellHtml(date));
	        }
	        return htmls.join('');
	    };
	    // Generates the HTML for the <td>s of the "number" row in the DayGrid's content skeleton.
	    // The number row will only exist if either day numbers or week numbers are turned on.
	    DayGrid.prototype.renderNumberCellHtml = function (date) {
	        var view = this.view;
	        var html = '';
	        var isDateValid = this.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
	        var isDayNumberVisible = this.getIsDayNumbersVisible() && isDateValid;
	        var classes;
	        var weekCalcFirstDoW;
	        if (!isDayNumberVisible && !this.cellWeekNumbersVisible) {
	            // no numbers in day cell (week number must be along the side)
	            return '<td></td>'; //  will create an empty space above events :(
	        }
	        classes = this.getDayClasses(date);
	        classes.unshift('fc-day-top');
	        if (this.cellWeekNumbersVisible) {
	            // To determine the day of week number change under ISO, we cannot
	            // rely on moment.js methods such as firstDayOfWeek() or weekday(),
	            // because they rely on the locale's dow (possibly overridden by
	            // our firstDay option), which may not be Monday. We cannot change
	            // dow, because that would affect the calendar start day as well.
	            if (date._locale._fullCalendar_weekCalc === 'ISO') {
	                weekCalcFirstDoW = 1; // Monday by ISO 8601 definition
	            }
	            else {
	                weekCalcFirstDoW = date._locale.firstDayOfWeek();
	            }
	        }
	        html += '<td class="' + classes.join(' ') + '"' +
	            (isDateValid ?
	                ' data-date="' + date.format() + '"' :
	                '') +
	            '>';
	        if (this.cellWeekNumbersVisible && (date.day() === weekCalcFirstDoW)) {
	            html += view.buildGotoAnchorHtml({ date: date, type: 'week' }, { 'class': 'fc-week-number' }, date.format('w') // inner HTML
	            );
	        }
	        if (isDayNumberVisible) {
	            html += view.buildGotoAnchorHtml(date, { 'class': 'fc-day-number' }, date.format('D') // inner HTML
	            );
	        }
	        html += '</td>';
	        return html;
	    };
	    /* Hit System
	    ------------------------------------------------------------------------------------------------------------------*/
	    DayGrid.prototype.prepareHits = function () {
	        this.colCoordCache.build();
	        this.rowCoordCache.build();
	        this.rowCoordCache.bottoms[this.rowCnt - 1] += this.bottomCoordPadding; // hack
	    };
	    DayGrid.prototype.releaseHits = function () {
	        this.colCoordCache.clear();
	        this.rowCoordCache.clear();
	    };
	    DayGrid.prototype.queryHit = function (leftOffset, topOffset) {
	        if (this.colCoordCache.isLeftInBounds(leftOffset) && this.rowCoordCache.isTopInBounds(topOffset)) {
	            var col = this.colCoordCache.getHorizontalIndex(leftOffset);
	            var row = this.rowCoordCache.getVerticalIndex(topOffset);
	            if (row != null && col != null) {
	                return this.getCellHit(row, col);
	            }
	        }
	    };
	    DayGrid.prototype.getHitFootprint = function (hit) {
	        var range = this.getCellRange(hit.row, hit.col);
	        return new ComponentFootprint_1.default(new UnzonedRange_1.default(range.start, range.end), true // all-day?
	        );
	    };
	    DayGrid.prototype.getHitEl = function (hit) {
	        return this.getCellEl(hit.row, hit.col);
	    };
	    /* Cell System
	    ------------------------------------------------------------------------------------------------------------------*/
	    // FYI: the first column is the leftmost column, regardless of date
	    DayGrid.prototype.getCellHit = function (row, col) {
	        return {
	            row: row,
	            col: col,
	            component: this,
	            left: this.colCoordCache.getLeftOffset(col),
	            right: this.colCoordCache.getRightOffset(col),
	            top: this.rowCoordCache.getTopOffset(row),
	            bottom: this.rowCoordCache.getBottomOffset(row)
	        };
	    };
	    DayGrid.prototype.getCellEl = function (row, col) {
	        return this.cellEls.eq(row * this.colCnt + col);
	    };
	    /* Event Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Unrenders all events currently rendered on the grid
	    DayGrid.prototype.executeEventUnrender = function () {
	        this.removeSegPopover(); // removes the "more.." events popover
	        _super.prototype.executeEventUnrender.call(this);
	    };
	    // Retrieves all rendered segment objects currently rendered on the grid
	    DayGrid.prototype.getOwnEventSegs = function () {
	        // append the segments from the "more..." popover
	        return _super.prototype.getOwnEventSegs.call(this).concat(this.popoverSegs || []);
	    };
	    /* Event Drag Visualization
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Renders a visual indication of an event or external element being dragged.
	    // `eventLocation` has zoned start and end (optional)
	    DayGrid.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
	        var i;
	        for (i = 0; i < eventFootprints.length; i++) {
	            this.renderHighlight(eventFootprints[i].componentFootprint);
	        }
	        // render drags from OTHER components as helpers
	        if (eventFootprints.length && seg && seg.component !== this) {
	            this.helperRenderer.renderEventDraggingFootprints(eventFootprints, seg, isTouch);
	            return true; // signal helpers rendered
	        }
	    };
	    // Unrenders any visual indication of a hovering event
	    DayGrid.prototype.unrenderDrag = function () {
	        this.unrenderHighlight();
	        this.helperRenderer.unrender();
	    };
	    /* Event Resize Visualization
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Renders a visual indication of an event being resized
	    DayGrid.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
	        var i;
	        for (i = 0; i < eventFootprints.length; i++) {
	            this.renderHighlight(eventFootprints[i].componentFootprint);
	        }
	        this.helperRenderer.renderEventResizingFootprints(eventFootprints, seg, isTouch);
	    };
	    // Unrenders a visual indication of an event being resized
	    DayGrid.prototype.unrenderEventResize = function () {
	        this.unrenderHighlight();
	        this.helperRenderer.unrender();
	    };
	    /* More+ Link Popover
	    ------------------------------------------------------------------------------------------------------------------*/
	    DayGrid.prototype.removeSegPopover = function () {
	        if (this.segPopover) {
	            this.segPopover.hide(); // in handler, will call segPopover's removeElement
	        }
	    };
	    // Limits the number of "levels" (vertically stacking layers of events) for each row of the grid.
	    // `levelLimit` can be false (don't limit), a number, or true (should be computed).
	    DayGrid.prototype.limitRows = function (levelLimit) {
	        var rowStructs = this.eventRenderer.rowStructs || [];
	        var row; // row #
	        var rowLevelLimit;
	        for (row = 0; row < rowStructs.length; row++) {
	            this.unlimitRow(row);
	            if (!levelLimit) {
	                rowLevelLimit = false;
	            }
	            else if (typeof levelLimit === 'number') {
	                rowLevelLimit = levelLimit;
	            }
	            else {
	                rowLevelLimit = this.computeRowLevelLimit(row);
	            }
	            if (rowLevelLimit !== false) {
	                this.limitRow(row, rowLevelLimit);
	            }
	        }
	    };
	    // Computes the number of levels a row will accomodate without going outside its bounds.
	    // Assumes the row is "rigid" (maintains a constant height regardless of what is inside).
	    // `row` is the row number.
	    DayGrid.prototype.computeRowLevelLimit = function (row) {
	        var rowEl = this.rowEls.eq(row); // the containing "fake" row div
	        var rowHeight = rowEl.height(); // TODO: cache somehow?
	        var trEls = this.eventRenderer.rowStructs[row].tbodyEl.children();
	        var i;
	        var trEl;
	        var trHeight;
	        function iterInnerHeights(i, childNode) {
	            trHeight = Math.max(trHeight, $(childNode).outerHeight());
	        }
	        // Reveal one level <tr> at a time and stop when we find one out of bounds
	        for (i = 0; i < trEls.length; i++) {
	            trEl = trEls.eq(i).removeClass('fc-limited'); // reset to original state (reveal)
	            // with rowspans>1 and IE8, trEl.outerHeight() would return the height of the largest cell,
	            // so instead, find the tallest inner content element.
	            trHeight = 0;
	            trEl.find('> td > :first-child').each(iterInnerHeights);
	            if (trEl.position().top + trHeight > rowHeight) {
	                return i;
	            }
	        }
	        return false; // should not limit at all
	    };
	    // Limits the given grid row to the maximum number of levels and injects "more" links if necessary.
	    // `row` is the row number.
	    // `levelLimit` is a number for the maximum (inclusive) number of levels allowed.
	    DayGrid.prototype.limitRow = function (row, levelLimit) {
	        var _this = this;
	        var rowStruct = this.eventRenderer.rowStructs[row];
	        var moreNodes = []; // array of "more" <a> links and <td> DOM nodes
	        var col = 0; // col #, left-to-right (not chronologically)
	        var levelSegs; // array of segment objects in the last allowable level, ordered left-to-right
	        var cellMatrix; // a matrix (by level, then column) of all <td> jQuery elements in the row
	        var limitedNodes; // array of temporarily hidden level <tr> and segment <td> DOM nodes
	        var i;
	        var seg;
	        var segsBelow; // array of segment objects below `seg` in the current `col`
	        var totalSegsBelow; // total number of segments below `seg` in any of the columns `seg` occupies
	        var colSegsBelow; // array of segment arrays, below seg, one for each column (offset from segs's first column)
	        var td;
	        var rowspan;
	        var segMoreNodes; // array of "more" <td> cells that will stand-in for the current seg's cell
	        var j;
	        var moreTd;
	        var moreWrap;
	        var moreLink;
	        // Iterates through empty level cells and places "more" links inside if need be
	        var emptyCellsUntil = function (endCol) {
	            while (col < endCol) {
	                segsBelow = _this.getCellSegs(row, col, levelLimit);
	                if (segsBelow.length) {
	                    td = cellMatrix[levelLimit - 1][col];
	                    moreLink = _this.renderMoreLink(row, col, segsBelow);
	                    moreWrap = $('<div>').append(moreLink);
	                    td.append(moreWrap);
	                    moreNodes.push(moreWrap[0]);
	                }
	                col++;
	            }
	        };
	        if (levelLimit && levelLimit < rowStruct.segLevels.length) { // is it actually over the limit?
	            levelSegs = rowStruct.segLevels[levelLimit - 1];
	            cellMatrix = rowStruct.cellMatrix;
	            limitedNodes = rowStruct.tbodyEl.children().slice(levelLimit) // get level <tr> elements past the limit
	                .addClass('fc-limited').get(); // hide elements and get a simple DOM-nodes array
	            // iterate though segments in the last allowable level
	            for (i = 0; i < levelSegs.length; i++) {
	                seg = levelSegs[i];
	                emptyCellsUntil(seg.leftCol); // process empty cells before the segment
	                // determine *all* segments below `seg` that occupy the same columns
	                colSegsBelow = [];
	                totalSegsBelow = 0;
	                while (col <= seg.rightCol) {
	                    segsBelow = this.getCellSegs(row, col, levelLimit);
	                    colSegsBelow.push(segsBelow);
	                    totalSegsBelow += segsBelow.length;
	                    col++;
	                }
	                if (totalSegsBelow) { // do we need to replace this segment with one or many "more" links?
	                    td = cellMatrix[levelLimit - 1][seg.leftCol]; // the segment's parent cell
	                    rowspan = td.attr('rowspan') || 1;
	                    segMoreNodes = [];
	                    // make a replacement <td> for each column the segment occupies. will be one for each colspan
	                    for (j = 0; j < colSegsBelow.length; j++) {
	                        moreTd = $('<td class="fc-more-cell">').attr('rowspan', rowspan);
	                        segsBelow = colSegsBelow[j];
	                        moreLink = this.renderMoreLink(row, seg.leftCol + j, [seg].concat(segsBelow) // count seg as hidden too
	                        );
	                        moreWrap = $('<div>').append(moreLink);
	                        moreTd.append(moreWrap);
	                        segMoreNodes.push(moreTd[0]);
	                        moreNodes.push(moreTd[0]);
	                    }
	                    td.addClass('fc-limited').after($(segMoreNodes)); // hide original <td> and inject replacements
	                    limitedNodes.push(td[0]);
	                }
	            }
	            emptyCellsUntil(this.colCnt); // finish off the level
	            rowStruct.moreEls = $(moreNodes); // for easy undoing later
	            rowStruct.limitedEls = $(limitedNodes); // for easy undoing later
	        }
	    };
	    // Reveals all levels and removes all "more"-related elements for a grid's row.
	    // `row` is a row number.
	    DayGrid.prototype.unlimitRow = function (row) {
	        var rowStruct = this.eventRenderer.rowStructs[row];
	        if (rowStruct.moreEls) {
	            rowStruct.moreEls.remove();
	            rowStruct.moreEls = null;
	        }
	        if (rowStruct.limitedEls) {
	            rowStruct.limitedEls.removeClass('fc-limited');
	            rowStruct.limitedEls = null;
	        }
	    };
	    // Renders an <a> element that represents hidden event element for a cell.
	    // Responsible for attaching click handler as well.
	    DayGrid.prototype.renderMoreLink = function (row, col, hiddenSegs) {
	        var _this = this;
	        var view = this.view;
	        return $('<a class="fc-more">')
	            .text(this.getMoreLinkText(hiddenSegs.length))
	            .on('click', function (ev) {
	            var clickOption = _this.opt('eventLimitClick');
	            var date = _this.getCellDate(row, col);
	            var moreEl = $(ev.currentTarget);
	            var dayEl = _this.getCellEl(row, col);
	            var allSegs = _this.getCellSegs(row, col);
	            // rescope the segments to be within the cell's date
	            var reslicedAllSegs = _this.resliceDaySegs(allSegs, date);
	            var reslicedHiddenSegs = _this.resliceDaySegs(hiddenSegs, date);
	            if (typeof clickOption === 'function') {
	                // the returned value can be an atomic option
	                clickOption = _this.publiclyTrigger('eventLimitClick', {
	                    context: view,
	                    args: [
	                        {
	                            date: date.clone(),
	                            dayEl: dayEl,
	                            moreEl: moreEl,
	                            segs: reslicedAllSegs,
	                            hiddenSegs: reslicedHiddenSegs
	                        },
	                        ev,
	                        view
	                    ]
	                });
	            }
	            if (clickOption === 'popover') {
	                _this.showSegPopover(row, col, moreEl, reslicedAllSegs);
	            }
	            else if (typeof clickOption === 'string') { // a view name
	                view.calendar.zoomTo(date, clickOption);
	            }
	        });
	    };
	    // Reveals the popover that displays all events within a cell
	    DayGrid.prototype.showSegPopover = function (row, col, moreLink, segs) {
	        var _this = this;
	        var view = this.view;
	        var moreWrap = moreLink.parent(); // the <div> wrapper around the <a>
	        var topEl; // the element we want to match the top coordinate of
	        var options;
	        if (this.rowCnt === 1) {
	            topEl = view.el; // will cause the popover to cover any sort of header
	        }
	        else {
	            topEl = this.rowEls.eq(row); // will align with top of row
	        }
	        options = {
	            className: 'fc-more-popover ' + view.calendar.theme.getClass('popover'),
	            content: this.renderSegPopoverContent(row, col, segs),
	            parentEl: view.el,
	            top: topEl.offset().top,
	            autoHide: true,
	            viewportConstrain: this.opt('popoverViewportConstrain'),
	            hide: function () {
	                // kill everything when the popover is hidden
	                // notify events to be removed
	                if (_this.popoverSegs) {
	                    _this.triggerBeforeEventSegsDestroyed(_this.popoverSegs);
	                }
	                _this.segPopover.removeElement();
	                _this.segPopover = null;
	                _this.popoverSegs = null;
	            }
	        };
	        // Determine horizontal coordinate.
	        // We use the moreWrap instead of the <td> to avoid border confusion.
	        if (this.isRTL) {
	            options.right = moreWrap.offset().left + moreWrap.outerWidth() + 1; // +1 to be over cell border
	        }
	        else {
	            options.left = moreWrap.offset().left - 1; // -1 to be over cell border
	        }
	        this.segPopover = new Popover_1.default(options);
	        this.segPopover.show();
	        // the popover doesn't live within the grid's container element, and thus won't get the event
	        // delegated-handlers for free. attach event-related handlers to the popover.
	        this.bindAllSegHandlersToEl(this.segPopover.el);
	        this.triggerAfterEventSegsRendered(segs);
	    };
	    // Builds the inner DOM contents of the segment popover
	    DayGrid.prototype.renderSegPopoverContent = function (row, col, segs) {
	        var view = this.view;
	        var theme = view.calendar.theme;
	        var title = this.getCellDate(row, col).format(this.opt('dayPopoverFormat'));
	        var content = $('<div class="fc-header ' + theme.getClass('popoverHeader') + '">' +
	            '<span class="fc-close ' + theme.getIconClass('close') + '"></span>' +
	            '<span class="fc-title">' +
	            util_1.htmlEscape(title) +
	            '</span>' +
	            '<div class="fc-clear"></div>' +
	            '</div>' +
	            '<div class="fc-body ' + theme.getClass('popoverContent') + '">' +
	            '<div class="fc-event-container"></div>' +
	            '</div>');
	        var segContainer = content.find('.fc-event-container');
	        var i;
	        // render each seg's `el` and only return the visible segs
	        segs = this.eventRenderer.renderFgSegEls(segs, true); // disableResizing=true
	        this.popoverSegs = segs;
	        for (i = 0; i < segs.length; i++) {
	            // because segments in the popover are not part of a grid coordinate system, provide a hint to any
	            // grids that want to do drag-n-drop about which cell it came from
	            this.hitsNeeded();
	            segs[i].hit = this.getCellHit(row, col);
	            this.hitsNotNeeded();
	            segContainer.append(segs[i].el);
	        }
	        return content;
	    };
	    // Given the events within an array of segment objects, reslice them to be in a single day
	    DayGrid.prototype.resliceDaySegs = function (segs, dayDate) {
	        var dayStart = dayDate.clone();
	        var dayEnd = dayStart.clone().add(1, 'days');
	        var dayRange = new UnzonedRange_1.default(dayStart, dayEnd);
	        var newSegs = [];
	        var i;
	        var seg;
	        var slicedRange;
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            slicedRange = seg.footprint.componentFootprint.unzonedRange.intersect(dayRange);
	            if (slicedRange) {
	                newSegs.push($.extend({}, seg, {
	                    footprint: new EventFootprint_1.default(new ComponentFootprint_1.default(slicedRange, seg.footprint.componentFootprint.isAllDay), seg.footprint.eventDef, seg.footprint.eventInstance),
	                    isStart: seg.isStart && slicedRange.isStart,
	                    isEnd: seg.isEnd && slicedRange.isEnd
	                }));
	            }
	        }
	        // force an order because eventsToSegs doesn't guarantee one
	        // TODO: research if still needed
	        this.eventRenderer.sortEventSegs(newSegs);
	        return newSegs;
	    };
	    // Generates the text that should be inside a "more" link, given the number of events it represents
	    DayGrid.prototype.getMoreLinkText = function (num) {
	        var opt = this.opt('eventLimitText');
	        if (typeof opt === 'function') {
	            return opt(num);
	        }
	        else {
	            return '+' + num + ' ' + opt;
	        }
	    };
	    // Returns segments within a given cell.
	    // If `startLevel` is specified, returns only events including and below that level. Otherwise returns all segs.
	    DayGrid.prototype.getCellSegs = function (row, col, startLevel) {
	        var segMatrix = this.eventRenderer.rowStructs[row].segMatrix;
	        var level = startLevel || 0;
	        var segs = [];
	        var seg;
	        while (level < segMatrix.length) {
	            seg = segMatrix[level][col];
	            if (seg) {
	                segs.push(seg);
	            }
	            level++;
	        }
	        return segs;
	    };
	    return DayGrid;
	}(InteractiveDateComponent_1.default));
	exports.default = DayGrid;
	DayGrid.prototype.eventRendererClass = DayGridEventRenderer_1.default;
	DayGrid.prototype.businessHourRendererClass = BusinessHourRenderer_1.default;
	DayGrid.prototype.helperRendererClass = DayGridHelperRenderer_1.default;
	DayGrid.prototype.fillRendererClass = DayGridFillRenderer_1.default;
	StandardInteractionsMixin_1.default.mixInto(DayGrid);
	DayTableMixin_1.default.mixInto(DayGrid);
	
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var Scroller_1 = __webpack_require__(41);
	var View_1 = __webpack_require__(43);
	var BasicViewDateProfileGenerator_1 = __webpack_require__(68);
	var DayGrid_1 = __webpack_require__(66);
	/* An abstract class for the "basic" views, as well as month view. Renders one or more rows of day cells.
	----------------------------------------------------------------------------------------------------------------------*/
	// It is a manager for a DayGrid subcomponent, which does most of the heavy lifting.
	// It is responsible for managing width/height.
	var BasicView = /** @class */ (function (_super) {
	    tslib_1.__extends(BasicView, _super);
	    function BasicView(calendar, viewSpec) {
	        var _this = _super.call(this, calendar, viewSpec) || this;
	        _this.dayGrid = _this.instantiateDayGrid();
	        _this.dayGrid.isRigid = _this.hasRigidRows();
	        if (_this.opt('weekNumbers')) {
	            if (_this.opt('weekNumbersWithinDays')) {
	                _this.dayGrid.cellWeekNumbersVisible = true;
	                _this.dayGrid.colWeekNumbersVisible = false;
	            }
	            else {
	                _this.dayGrid.cellWeekNumbersVisible = false;
	                _this.dayGrid.colWeekNumbersVisible = true;
	            }
	        }
	        _this.addChild(_this.dayGrid);
	        _this.scroller = new Scroller_1.default({
	            overflowX: 'hidden',
	            overflowY: 'auto'
	        });
	        return _this;
	    }
	    // Generates the DayGrid object this view needs. Draws from this.dayGridClass
	    BasicView.prototype.instantiateDayGrid = function () {
	        // generate a subclass on the fly with BasicView-specific behavior
	        // TODO: cache this subclass
	        var subclass = makeDayGridSubclass(this.dayGridClass);
	        return new subclass(this);
	    };
	    BasicView.prototype.executeDateRender = function (dateProfile) {
	        this.dayGrid.breakOnWeeks = /year|month|week/.test(dateProfile.currentRangeUnit);
	        _super.prototype.executeDateRender.call(this, dateProfile);
	    };
	    BasicView.prototype.renderSkeleton = function () {
	        var dayGridContainerEl;
	        var dayGridEl;
	        this.el.addClass('fc-basic-view').html(this.renderSkeletonHtml());
	        this.scroller.render();
	        dayGridContainerEl = this.scroller.el.addClass('fc-day-grid-container');
	        dayGridEl = $('<div class="fc-day-grid">').appendTo(dayGridContainerEl);
	        this.el.find('.fc-body > tr > td').append(dayGridContainerEl);
	        this.dayGrid.headContainerEl = this.el.find('.fc-head-container');
	        this.dayGrid.setElement(dayGridEl);
	    };
	    BasicView.prototype.unrenderSkeleton = function () {
	        this.dayGrid.removeElement();
	        this.scroller.destroy();
	    };
	    // Builds the HTML skeleton for the view.
	    // The day-grid component will render inside of a container defined by this HTML.
	    BasicView.prototype.renderSkeletonHtml = function () {
	        var theme = this.calendar.theme;
	        return '' +
	            '<table class="' + theme.getClass('tableGrid') + '">' +
	            (this.opt('columnHeader') ?
	                '<thead class="fc-head">' +
	                    '<tr>' +
	                    '<td class="fc-head-container ' + theme.getClass('widgetHeader') + '">&nbsp;</td>' +
	                    '</tr>' +
	                    '</thead>' :
	                '') +
	            '<tbody class="fc-body">' +
	            '<tr>' +
	            '<td class="' + theme.getClass('widgetContent') + '"></td>' +
	            '</tr>' +
	            '</tbody>' +
	            '</table>';
	    };
	    // Generates an HTML attribute string for setting the width of the week number column, if it is known
	    BasicView.prototype.weekNumberStyleAttr = function () {
	        if (this.weekNumberWidth != null) {
	            return 'style="width:' + this.weekNumberWidth + 'px"';
	        }
	        return '';
	    };
	    // Determines whether each row should have a constant height
	    BasicView.prototype.hasRigidRows = function () {
	        var eventLimit = this.opt('eventLimit');
	        return eventLimit && typeof eventLimit !== 'number';
	    };
	    /* Dimensions
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Refreshes the horizontal dimensions of the view
	    BasicView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
	        var eventLimit = this.opt('eventLimit');
	        var headRowEl = this.dayGrid.headContainerEl.find('.fc-row');
	        var scrollerHeight;
	        var scrollbarWidths;
	        // hack to give the view some height prior to dayGrid's columns being rendered
	        // TODO: separate setting height from scroller VS dayGrid.
	        if (!this.dayGrid.rowEls) {
	            if (!isAuto) {
	                scrollerHeight = this.computeScrollerHeight(totalHeight);
	                this.scroller.setHeight(scrollerHeight);
	            }
	            return;
	        }
	        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
	        if (this.dayGrid.colWeekNumbersVisible) {
	            // Make sure all week number cells running down the side have the same width.
	            // Record the width for cells created later.
	            this.weekNumberWidth = util_1.matchCellWidths(this.el.find('.fc-week-number'));
	        }
	        // reset all heights to be natural
	        this.scroller.clear();
	        util_1.uncompensateScroll(headRowEl);
	        this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed
	        // is the event limit a constant level number?
	        if (eventLimit && typeof eventLimit === 'number') {
	            this.dayGrid.limitRows(eventLimit); // limit the levels first so the height can redistribute after
	        }
	        // distribute the height to the rows
	        // (totalHeight is a "recommended" value if isAuto)
	        scrollerHeight = this.computeScrollerHeight(totalHeight);
	        this.setGridHeight(scrollerHeight, isAuto);
	        // is the event limit dynamically calculated?
	        if (eventLimit && typeof eventLimit !== 'number') {
	            this.dayGrid.limitRows(eventLimit); // limit the levels after the grid's row heights have been set
	        }
	        if (!isAuto) { // should we force dimensions of the scroll container?
	            this.scroller.setHeight(scrollerHeight);
	            scrollbarWidths = this.scroller.getScrollbarWidths();
	            if (scrollbarWidths.left || scrollbarWidths.right) { // using scrollbars?
	                util_1.compensateScroll(headRowEl, scrollbarWidths);
	                // doing the scrollbar compensation might have created text overflow which created more height. redo
	                scrollerHeight = this.computeScrollerHeight(totalHeight);
	                this.scroller.setHeight(scrollerHeight);
	            }
	            // guarantees the same scrollbar widths
	            this.scroller.lockOverflow(scrollbarWidths);
	        }
	    };
	    // given a desired total height of the view, returns what the height of the scroller should be
	    BasicView.prototype.computeScrollerHeight = function (totalHeight) {
	        return totalHeight -
	            util_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
	    };
	    // Sets the height of just the DayGrid component in this view
	    BasicView.prototype.setGridHeight = function (height, isAuto) {
	        if (isAuto) {
	            util_1.undistributeHeight(this.dayGrid.rowEls); // let the rows be their natural height with no expanding
	        }
	        else {
	            util_1.distributeHeight(this.dayGrid.rowEls, height, true); // true = compensate for height-hogging rows
	        }
	    };
	    /* Scroll
	    ------------------------------------------------------------------------------------------------------------------*/
	    BasicView.prototype.computeInitialDateScroll = function () {
	        return { top: 0 };
	    };
	    BasicView.prototype.queryDateScroll = function () {
	        return { top: this.scroller.getScrollTop() };
	    };
	    BasicView.prototype.applyDateScroll = function (scroll) {
	        if (scroll.top !== undefined) {
	            this.scroller.setScrollTop(scroll.top);
	        }
	    };
	    return BasicView;
	}(View_1.default));
	exports.default = BasicView;
	BasicView.prototype.dateProfileGeneratorClass = BasicViewDateProfileGenerator_1.default;
	BasicView.prototype.dayGridClass = DayGrid_1.default;
	// customize the rendering behavior of BasicView's dayGrid
	function makeDayGridSubclass(SuperClass) {
	    return /** @class */ (function (_super) {
	        tslib_1.__extends(SubClass, _super);
	        function SubClass() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	            _this.colWeekNumbersVisible = false; // display week numbers along the side?
	            return _this;
	        }
	        // Generates the HTML that will go before the day-of week header cells
	        SubClass.prototype.renderHeadIntroHtml = function () {
	            var view = this.view;
	            if (this.colWeekNumbersVisible) {
	                return '' +
	                    '<th class="fc-week-number ' + view.calendar.theme.getClass('widgetHeader') + '" ' + view.weekNumberStyleAttr() + '>' +
	                    '<span>' + // needed for matchCellWidths
	                    util_1.htmlEscape(this.opt('weekNumberTitle')) +
	                    '</span>' +
	                    '</th>';
	            }
	            return '';
	        };
	        // Generates the HTML that will go before content-skeleton cells that display the day/week numbers
	        SubClass.prototype.renderNumberIntroHtml = function (row) {
	            var view = this.view;
	            var weekStart = this.getCellDate(row, 0);
	            if (this.colWeekNumbersVisible) {
	                return '' +
	                    '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '>' +
	                    view.buildGotoAnchorHtml(// aside from link, important for matchCellWidths
	                    { date: weekStart, type: 'week', forceOff: this.colCnt === 1 }, weekStart.format('w') // inner HTML
	                    ) +
	                    '</td>';
	            }
	            return '';
	        };
	        // Generates the HTML that goes before the day bg cells for each day-row
	        SubClass.prototype.renderBgIntroHtml = function () {
	            var view = this.view;
	            if (this.colWeekNumbersVisible) {
	                return '<td class="fc-week-number ' + view.calendar.theme.getClass('widgetContent') + '" ' +
	                    view.weekNumberStyleAttr() + '></td>';
	            }
	            return '';
	        };
	        // Generates the HTML that goes before every other type of row generated by DayGrid.
	        // Affects helper-skeleton and highlight-skeleton rows.
	        SubClass.prototype.renderIntroHtml = function () {
	            var view = this.view;
	            if (this.colWeekNumbersVisible) {
	                return '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '></td>';
	            }
	            return '';
	        };
	        SubClass.prototype.getIsNumbersVisible = function () {
	            return DayGrid_1.default.prototype.getIsNumbersVisible.apply(this, arguments) || this.colWeekNumbersVisible;
	        };
	        return SubClass;
	    }(SuperClass));
	}
	
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var UnzonedRange_1 = __webpack_require__(5);
	var DateProfileGenerator_1 = __webpack_require__(55);
	var BasicViewDateProfileGenerator = /** @class */ (function (_super) {
	    tslib_1.__extends(BasicViewDateProfileGenerator, _super);
	    function BasicViewDateProfileGenerator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // Computes the date range that will be rendered.
	    BasicViewDateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
	        var renderUnzonedRange = _super.prototype.buildRenderRange.call(this, currentUnzonedRange, currentRangeUnit, isRangeAllDay); // an UnzonedRange
	        var start = this.msToUtcMoment(renderUnzonedRange.startMs, isRangeAllDay);
	        var end = this.msToUtcMoment(renderUnzonedRange.endMs, isRangeAllDay);
	        // year and month views should be aligned with weeks. this is already done for week
	        if (/^(year|month)$/.test(currentRangeUnit)) {
	            start.startOf('week');
	            // make end-of-week if not already
	            if (end.weekday()) {
	                end.add(1, 'week').startOf('week'); // exclusively move backwards
	            }
	        }
	        return new UnzonedRange_1.default(start, end);
	    };
	    return BasicViewDateProfileGenerator;
	}(DateProfileGenerator_1.default));
	exports.default = BasicViewDateProfileGenerator;
	
	
	/***/ }),
	/* 69 */,
	/* 70 */,
	/* 71 */,
	/* 72 */,
	/* 73 */,
	/* 74 */,
	/* 75 */,
	/* 76 */,
	/* 77 */,
	/* 78 */,
	/* 79 */,
	/* 80 */,
	/* 81 */,
	/* 82 */,
	/* 83 */,
	/* 84 */,
	/* 85 */,
	/* 86 */,
	/* 87 */,
	/* 88 */,
	/* 89 */,
	/* 90 */,
	/* 91 */,
	/* 92 */,
	/* 93 */,
	/* 94 */,
	/* 95 */,
	/* 96 */,
	/* 97 */,
	/* 98 */,
	/* 99 */,
	/* 100 */,
	/* 101 */,
	/* 102 */,
	/* 103 */,
	/* 104 */,
	/* 105 */,
	/* 106 */,
	/* 107 */,
	/* 108 */,
	/* 109 */,
	/* 110 */,
	/* 111 */,
	/* 112 */,
	/* 113 */,
	/* 114 */,
	/* 115 */,
	/* 116 */,
	/* 117 */,
	/* 118 */,
	/* 119 */,
	/* 120 */,
	/* 121 */,
	/* 122 */,
	/* 123 */,
	/* 124 */,
	/* 125 */,
	/* 126 */,
	/* 127 */,
	/* 128 */,
	/* 129 */,
	/* 130 */,
	/* 131 */,
	/* 132 */,
	/* 133 */,
	/* 134 */,
	/* 135 */,
	/* 136 */,
	/* 137 */,
	/* 138 */,
	/* 139 */,
	/* 140 */,
	/* 141 */,
	/* 142 */,
	/* 143 */,
	/* 144 */,
	/* 145 */,
	/* 146 */,
	/* 147 */,
	/* 148 */,
	/* 149 */,
	/* 150 */,
	/* 151 */,
	/* 152 */,
	/* 153 */,
	/* 154 */,
	/* 155 */,
	/* 156 */,
	/* 157 */,
	/* 158 */,
	/* 159 */,
	/* 160 */,
	/* 161 */,
	/* 162 */,
	/* 163 */,
	/* 164 */,
	/* 165 */,
	/* 166 */,
	/* 167 */,
	/* 168 */,
	/* 169 */,
	/* 170 */,
	/* 171 */,
	/* 172 */,
	/* 173 */,
	/* 174 */,
	/* 175 */,
	/* 176 */,
	/* 177 */,
	/* 178 */,
	/* 179 */,
	/* 180 */,
	/* 181 */,
	/* 182 */,
	/* 183 */,
	/* 184 */,
	/* 185 */,
	/* 186 */,
	/* 187 */,
	/* 188 */,
	/* 189 */,
	/* 190 */,
	/* 191 */,
	/* 192 */,
	/* 193 */,
	/* 194 */,
	/* 195 */,
	/* 196 */,
	/* 197 */,
	/* 198 */,
	/* 199 */,
	/* 200 */,
	/* 201 */,
	/* 202 */,
	/* 203 */,
	/* 204 */,
	/* 205 */,
	/* 206 */,
	/* 207 */,
	/* 208 */,
	/* 209 */,
	/* 210 */,
	/* 211 */,
	/* 212 */,
	/* 213 */,
	/* 214 */,
	/* 215 */,
	/* 216 */,
	/* 217 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var UnzonedRange_1 = __webpack_require__(5);
	var ComponentFootprint_1 = __webpack_require__(12);
	var EventDefParser_1 = __webpack_require__(36);
	var EventSource_1 = __webpack_require__(6);
	var util_1 = __webpack_require__(19);
	var Constraints = /** @class */ (function () {
	    function Constraints(eventManager, _calendar) {
	        this.eventManager = eventManager;
	        this._calendar = _calendar;
	    }
	    Constraints.prototype.opt = function (name) {
	        return this._calendar.opt(name);
	    };
	    /*
	    determines if eventInstanceGroup is allowed,
	    in relation to other EVENTS and business hours.
	    */
	    Constraints.prototype.isEventInstanceGroupAllowed = function (eventInstanceGroup) {
	        var eventDef = eventInstanceGroup.getEventDef();
	        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
	        var i;
	        var peerEventInstances = this.getPeerEventInstances(eventDef);
	        var peerEventRanges = peerEventInstances.map(util_1.eventInstanceToEventRange);
	        var peerEventFootprints = this.eventRangesToEventFootprints(peerEventRanges);
	        var constraintVal = eventDef.getConstraint();
	        var overlapVal = eventDef.getOverlap();
	        var eventAllowFunc = this.opt('eventAllow');
	        for (i = 0; i < eventFootprints.length; i++) {
	            if (!this.isFootprintAllowed(eventFootprints[i].componentFootprint, peerEventFootprints, constraintVal, overlapVal, eventFootprints[i].eventInstance)) {
	                return false;
	            }
	        }
	        if (eventAllowFunc) {
	            for (i = 0; i < eventFootprints.length; i++) {
	                if (eventAllowFunc(eventFootprints[i].componentFootprint.toLegacy(this._calendar), eventFootprints[i].getEventLegacy()) === false) {
	                    return false;
	                }
	            }
	        }
	        return true;
	    };
	    Constraints.prototype.getPeerEventInstances = function (eventDef) {
	        return this.eventManager.getEventInstancesWithoutId(eventDef.id);
	    };
	    Constraints.prototype.isSelectionFootprintAllowed = function (componentFootprint) {
	        var peerEventInstances = this.eventManager.getEventInstances();
	        var peerEventRanges = peerEventInstances.map(util_1.eventInstanceToEventRange);
	        var peerEventFootprints = this.eventRangesToEventFootprints(peerEventRanges);
	        var selectAllowFunc;
	        if (this.isFootprintAllowed(componentFootprint, peerEventFootprints, this.opt('selectConstraint'), this.opt('selectOverlap'))) {
	            selectAllowFunc = this.opt('selectAllow');
	            if (selectAllowFunc) {
	                return selectAllowFunc(componentFootprint.toLegacy(this._calendar)) !== false;
	            }
	            else {
	                return true;
	            }
	        }
	        return false;
	    };
	    Constraints.prototype.isFootprintAllowed = function (componentFootprint, peerEventFootprints, constraintVal, overlapVal, subjectEventInstance // optional
	    ) {
	        var constraintFootprints; // ComponentFootprint[]
	        var overlapEventFootprints; // EventFootprint[]
	        if (constraintVal != null) {
	            constraintFootprints = this.constraintValToFootprints(constraintVal, componentFootprint.isAllDay);
	            if (!this.isFootprintWithinConstraints(componentFootprint, constraintFootprints)) {
	                return false;
	            }
	        }
	        overlapEventFootprints = this.collectOverlapEventFootprints(peerEventFootprints, componentFootprint);
	        if (overlapVal === false) {
	            if (overlapEventFootprints.length) {
	                return false;
	            }
	        }
	        else if (typeof overlapVal === 'function') {
	            if (!isOverlapsAllowedByFunc(overlapEventFootprints, overlapVal, subjectEventInstance)) {
	                return false;
	            }
	        }
	        if (subjectEventInstance) {
	            if (!isOverlapEventInstancesAllowed(overlapEventFootprints, subjectEventInstance)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    // Constraint
	    // ------------------------------------------------------------------------------------------------
	    Constraints.prototype.isFootprintWithinConstraints = function (componentFootprint, constraintFootprints) {
	        var i;
	        for (i = 0; i < constraintFootprints.length; i++) {
	            if (this.footprintContainsFootprint(constraintFootprints[i], componentFootprint)) {
	                return true;
	            }
	        }
	        return false;
	    };
	    Constraints.prototype.constraintValToFootprints = function (constraintVal, isAllDay) {
	        var eventInstances;
	        if (constraintVal === 'businessHours') {
	            return this.buildCurrentBusinessFootprints(isAllDay);
	        }
	        else if (typeof constraintVal === 'object') {
	            eventInstances = this.parseEventDefToInstances(constraintVal); // handles recurring events
	            if (!eventInstances) { // invalid input. fallback to parsing footprint directly
	                return this.parseFootprints(constraintVal);
	            }
	            else {
	                return this.eventInstancesToFootprints(eventInstances);
	            }
	        }
	        else if (constraintVal != null) { // an ID
	            eventInstances = this.eventManager.getEventInstancesWithId(constraintVal);
	            return this.eventInstancesToFootprints(eventInstances);
	        }
	    };
	    // returns ComponentFootprint[]
	    // uses current view's range
	    Constraints.prototype.buildCurrentBusinessFootprints = function (isAllDay) {
	        var view = this._calendar.view;
	        var businessHourGenerator = view.get('businessHourGenerator');
	        var unzonedRange = view.dateProfile.activeUnzonedRange;
	        var eventInstanceGroup = businessHourGenerator.buildEventInstanceGroup(isAllDay, unzonedRange);
	        if (eventInstanceGroup) {
	            return this.eventInstancesToFootprints(eventInstanceGroup.eventInstances);
	        }
	        else {
	            return [];
	        }
	    };
	    // conversion util
	    Constraints.prototype.eventInstancesToFootprints = function (eventInstances) {
	        var eventRanges = eventInstances.map(util_1.eventInstanceToEventRange);
	        var eventFootprints = this.eventRangesToEventFootprints(eventRanges);
	        return eventFootprints.map(util_1.eventFootprintToComponentFootprint);
	    };
	    // Overlap
	    // ------------------------------------------------------------------------------------------------
	    Constraints.prototype.collectOverlapEventFootprints = function (peerEventFootprints, targetFootprint) {
	        var overlapEventFootprints = [];
	        var i;
	        for (i = 0; i < peerEventFootprints.length; i++) {
	            if (this.footprintsIntersect(targetFootprint, peerEventFootprints[i].componentFootprint)) {
	                overlapEventFootprints.push(peerEventFootprints[i]);
	            }
	        }
	        return overlapEventFootprints;
	    };
	    // Conversion: eventDefs -> eventInstances -> eventRanges -> eventFootprints -> componentFootprints
	    // ------------------------------------------------------------------------------------------------
	    // NOTE: this might seem like repetitive code with the Grid class, however, this code is related to
	    // constraints whereas the Grid code is related to rendering. Each approach might want to convert
	    // eventRanges -> eventFootprints in a different way. Regardless, there are opportunities to make
	    // this more DRY.
	    /*
	    Returns false on invalid input.
	    */
	    Constraints.prototype.parseEventDefToInstances = function (eventInput) {
	        var eventManager = this.eventManager;
	        var eventDef = EventDefParser_1.default.parse(eventInput, new EventSource_1.default(this._calendar));
	        if (!eventDef) { // invalid
	            return false;
	        }
	        return eventDef.buildInstances(eventManager.currentPeriod.unzonedRange);
	    };
	    Constraints.prototype.eventRangesToEventFootprints = function (eventRanges) {
	        var i;
	        var eventFootprints = [];
	        for (i = 0; i < eventRanges.length; i++) {
	            eventFootprints.push.apply(// footprints
	            eventFootprints, this.eventRangeToEventFootprints(eventRanges[i]));
	        }
	        return eventFootprints;
	    };
	    Constraints.prototype.eventRangeToEventFootprints = function (eventRange) {
	        return [util_1.eventRangeToEventFootprint(eventRange)];
	    };
	    /*
	    Parses footprints directly.
	    Very similar to EventDateProfile::parse :(
	    */
	    Constraints.prototype.parseFootprints = function (rawInput) {
	        var start;
	        var end;
	        if (rawInput.start) {
	            start = this._calendar.moment(rawInput.start);
	            if (!start.isValid()) {
	                start = null;
	            }
	        }
	        if (rawInput.end) {
	            end = this._calendar.moment(rawInput.end);
	            if (!end.isValid()) {
	                end = null;
	            }
	        }
	        return [
	            new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), (start && !start.hasTime()) || (end && !end.hasTime()) // isAllDay
	            )
	        ];
	    };
	    // Footprint Utils
	    // ----------------------------------------------------------------------------------------
	    Constraints.prototype.footprintContainsFootprint = function (outerFootprint, innerFootprint) {
	        return outerFootprint.unzonedRange.containsRange(innerFootprint.unzonedRange);
	    };
	    Constraints.prototype.footprintsIntersect = function (footprint0, footprint1) {
	        return footprint0.unzonedRange.intersectsWith(footprint1.unzonedRange);
	    };
	    return Constraints;
	}());
	exports.default = Constraints;
	// optional subjectEventInstance
	function isOverlapsAllowedByFunc(overlapEventFootprints, overlapFunc, subjectEventInstance) {
	    var i;
	    for (i = 0; i < overlapEventFootprints.length; i++) {
	        if (!overlapFunc(overlapEventFootprints[i].eventInstance.toLegacy(), subjectEventInstance ? subjectEventInstance.toLegacy() : null)) {
	            return false;
	        }
	    }
	    return true;
	}
	function isOverlapEventInstancesAllowed(overlapEventFootprints, subjectEventInstance) {
	    var subjectLegacyInstance = subjectEventInstance.toLegacy();
	    var i;
	    var overlapEventInstance;
	    var overlapEventDef;
	    var overlapVal;
	    for (i = 0; i < overlapEventFootprints.length; i++) {
	        overlapEventInstance = overlapEventFootprints[i].eventInstance;
	        overlapEventDef = overlapEventInstance.def;
	        // don't need to pass in calendar, because don't want to consider global eventOverlap property,
	        // because we already considered that earlier in the process.
	        overlapVal = overlapEventDef.getOverlap();
	        if (overlapVal === false) {
	            return false;
	        }
	        else if (typeof overlapVal === 'function') {
	            if (!overlapVal(overlapEventInstance.toLegacy(), subjectLegacyInstance)) {
	                return false;
	            }
	        }
	    }
	    return true;
	}
	
	
	/***/ }),
	/* 218 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(19);
	var EventInstanceGroup_1 = __webpack_require__(20);
	var RecurringEventDef_1 = __webpack_require__(54);
	var EventSource_1 = __webpack_require__(6);
	var BUSINESS_HOUR_EVENT_DEFAULTS = {
	    start: '09:00',
	    end: '17:00',
	    dow: [1, 2, 3, 4, 5],
	    rendering: 'inverse-background'
	    // classNames are defined in businessHoursSegClasses
	};
	var BusinessHourGenerator = /** @class */ (function () {
	    function BusinessHourGenerator(rawComplexDef, calendar) {
	        this.rawComplexDef = rawComplexDef;
	        this.calendar = calendar;
	    }
	    BusinessHourGenerator.prototype.buildEventInstanceGroup = function (isAllDay, unzonedRange) {
	        var eventDefs = this.buildEventDefs(isAllDay);
	        var eventInstanceGroup;
	        if (eventDefs.length) {
	            eventInstanceGroup = new EventInstanceGroup_1.default(util_1.eventDefsToEventInstances(eventDefs, unzonedRange));
	            // so that inverse-background rendering can happen even when no eventRanges in view
	            eventInstanceGroup.explicitEventDef = eventDefs[0];
	            return eventInstanceGroup;
	        }
	    };
	    BusinessHourGenerator.prototype.buildEventDefs = function (isAllDay) {
	        var rawComplexDef = this.rawComplexDef;
	        var rawDefs = [];
	        var requireDow = false;
	        var i;
	        var defs = [];
	        if (rawComplexDef === true) {
	            rawDefs = [{}]; // will get BUSINESS_HOUR_EVENT_DEFAULTS verbatim
	        }
	        else if ($.isPlainObject(rawComplexDef)) {
	            rawDefs = [rawComplexDef];
	        }
	        else if ($.isArray(rawComplexDef)) {
	            rawDefs = rawComplexDef;
	            requireDow = true; // every sub-definition NEEDS a day-of-week
	        }
	        for (i = 0; i < rawDefs.length; i++) {
	            if (!requireDow || rawDefs[i].dow) {
	                defs.push(this.buildEventDef(isAllDay, rawDefs[i]));
	            }
	        }
	        return defs;
	    };
	    BusinessHourGenerator.prototype.buildEventDef = function (isAllDay, rawDef) {
	        var fullRawDef = $.extend({}, BUSINESS_HOUR_EVENT_DEFAULTS, rawDef);
	        if (isAllDay) {
	            fullRawDef.start = null;
	            fullRawDef.end = null;
	        }
	        return RecurringEventDef_1.default.parse(fullRawDef, new EventSource_1.default(this.calendar) // dummy source
	        );
	    };
	    return BusinessHourGenerator;
	}());
	exports.default = BusinessHourGenerator;
	
	
	/***/ }),
	/* 219 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var Promise_1 = __webpack_require__(21);
	var EmitterMixin_1 = __webpack_require__(13);
	var UnzonedRange_1 = __webpack_require__(5);
	var EventInstanceGroup_1 = __webpack_require__(20);
	var EventPeriod = /** @class */ (function () {
	    function EventPeriod(start, end, timezone) {
	        this.pendingCnt = 0;
	        this.freezeDepth = 0;
	        this.stuntedReleaseCnt = 0;
	        this.releaseCnt = 0;
	        this.start = start;
	        this.end = end;
	        this.timezone = timezone;
	        this.unzonedRange = new UnzonedRange_1.default(start.clone().stripZone(), end.clone().stripZone());
	        this.requestsByUid = {};
	        this.eventDefsByUid = {};
	        this.eventDefsById = {};
	        this.eventInstanceGroupsById = {};
	    }
	    EventPeriod.prototype.isWithinRange = function (start, end) {
	        // TODO: use a range util function?
	        return !start.isBefore(this.start) && !end.isAfter(this.end);
	    };
	    // Requesting and Purging
	    // -----------------------------------------------------------------------------------------------------------------
	    EventPeriod.prototype.requestSources = function (sources) {
	        this.freeze();
	        for (var i = 0; i < sources.length; i++) {
	            this.requestSource(sources[i]);
	        }
	        this.thaw();
	    };
	    EventPeriod.prototype.requestSource = function (source) {
	        var _this = this;
	        var request = { source: source, status: 'pending', eventDefs: null };
	        this.requestsByUid[source.uid] = request;
	        this.pendingCnt += 1;
	        source.fetch(this.start, this.end, this.timezone).then(function (eventDefs) {
	            if (request.status !== 'cancelled') {
	                request.status = 'completed';
	                request.eventDefs = eventDefs;
	                _this.addEventDefs(eventDefs);
	                _this.pendingCnt--;
	                _this.tryRelease();
	            }
	        }, function () {
	            if (request.status !== 'cancelled') {
	                request.status = 'failed';
	                _this.pendingCnt--;
	                _this.tryRelease();
	            }
	        });
	    };
	    EventPeriod.prototype.purgeSource = function (source) {
	        var request = this.requestsByUid[source.uid];
	        if (request) {
	            delete this.requestsByUid[source.uid];
	            if (request.status === 'pending') {
	                request.status = 'cancelled';
	                this.pendingCnt--;
	                this.tryRelease();
	            }
	            else if (request.status === 'completed') {
	                request.eventDefs.forEach(this.removeEventDef.bind(this));
	            }
	        }
	    };
	    EventPeriod.prototype.purgeAllSources = function () {
	        var requestsByUid = this.requestsByUid;
	        var uid;
	        var request;
	        var completedCnt = 0;
	        for (uid in requestsByUid) {
	            request = requestsByUid[uid];
	            if (request.status === 'pending') {
	                request.status = 'cancelled';
	            }
	            else if (request.status === 'completed') {
	                completedCnt++;
	            }
	        }
	        this.requestsByUid = {};
	        this.pendingCnt = 0;
	        if (completedCnt) {
	            this.removeAllEventDefs(); // might release
	        }
	    };
	    // Event Definitions
	    // -----------------------------------------------------------------------------------------------------------------
	    EventPeriod.prototype.getEventDefByUid = function (eventDefUid) {
	        return this.eventDefsByUid[eventDefUid];
	    };
	    EventPeriod.prototype.getEventDefsById = function (eventDefId) {
	        var a = this.eventDefsById[eventDefId];
	        if (a) {
	            return a.slice(); // clone
	        }
	        return [];
	    };
	    EventPeriod.prototype.addEventDefs = function (eventDefs) {
	        for (var i = 0; i < eventDefs.length; i++) {
	            this.addEventDef(eventDefs[i]);
	        }
	    };
	    EventPeriod.prototype.addEventDef = function (eventDef) {
	        var eventDefsById = this.eventDefsById;
	        var eventDefId = eventDef.id;
	        var eventDefs = eventDefsById[eventDefId] || (eventDefsById[eventDefId] = []);
	        var eventInstances = eventDef.buildInstances(this.unzonedRange);
	        var i;
	        eventDefs.push(eventDef);
	        this.eventDefsByUid[eventDef.uid] = eventDef;
	        for (i = 0; i < eventInstances.length; i++) {
	            this.addEventInstance(eventInstances[i], eventDefId);
	        }
	    };
	    EventPeriod.prototype.removeEventDefsById = function (eventDefId) {
	        var _this = this;
	        this.getEventDefsById(eventDefId).forEach(function (eventDef) {
	            _this.removeEventDef(eventDef);
	        });
	    };
	    EventPeriod.prototype.removeAllEventDefs = function () {
	        var isEmpty = $.isEmptyObject(this.eventDefsByUid);
	        this.eventDefsByUid = {};
	        this.eventDefsById = {};
	        this.eventInstanceGroupsById = {};
	        if (!isEmpty) {
	            this.tryRelease();
	        }
	    };
	    EventPeriod.prototype.removeEventDef = function (eventDef) {
	        var eventDefsById = this.eventDefsById;
	        var eventDefs = eventDefsById[eventDef.id];
	        delete this.eventDefsByUid[eventDef.uid];
	        if (eventDefs) {
	            util_1.removeExact(eventDefs, eventDef);
	            if (!eventDefs.length) {
	                delete eventDefsById[eventDef.id];
	            }
	            this.removeEventInstancesForDef(eventDef);
	        }
	    };
	    // Event Instances
	    // -----------------------------------------------------------------------------------------------------------------
	    EventPeriod.prototype.getEventInstances = function () {
	        var eventInstanceGroupsById = this.eventInstanceGroupsById;
	        var eventInstances = [];
	        var id;
	        for (id in eventInstanceGroupsById) {
	            eventInstances.push.apply(eventInstances, // append
	            eventInstanceGroupsById[id].eventInstances);
	        }
	        return eventInstances;
	    };
	    EventPeriod.prototype.getEventInstancesWithId = function (eventDefId) {
	        var eventInstanceGroup = this.eventInstanceGroupsById[eventDefId];
	        if (eventInstanceGroup) {
	            return eventInstanceGroup.eventInstances.slice(); // clone
	        }
	        return [];
	    };
	    EventPeriod.prototype.getEventInstancesWithoutId = function (eventDefId) {
	        var eventInstanceGroupsById = this.eventInstanceGroupsById;
	        var matchingInstances = [];
	        var id;
	        for (id in eventInstanceGroupsById) {
	            if (id !== eventDefId) {
	                matchingInstances.push.apply(matchingInstances, // append
	                eventInstanceGroupsById[id].eventInstances);
	            }
	        }
	        return matchingInstances;
	    };
	    EventPeriod.prototype.addEventInstance = function (eventInstance, eventDefId) {
	        var eventInstanceGroupsById = this.eventInstanceGroupsById;
	        var eventInstanceGroup = eventInstanceGroupsById[eventDefId] ||
	            (eventInstanceGroupsById[eventDefId] = new EventInstanceGroup_1.default());
	        eventInstanceGroup.eventInstances.push(eventInstance);
	        this.tryRelease();
	    };
	    EventPeriod.prototype.removeEventInstancesForDef = function (eventDef) {
	        var eventInstanceGroupsById = this.eventInstanceGroupsById;
	        var eventInstanceGroup = eventInstanceGroupsById[eventDef.id];
	        var removeCnt;
	        if (eventInstanceGroup) {
	            removeCnt = util_1.removeMatching(eventInstanceGroup.eventInstances, function (currentEventInstance) {
	                return currentEventInstance.def === eventDef;
	            });
	            if (!eventInstanceGroup.eventInstances.length) {
	                delete eventInstanceGroupsById[eventDef.id];
	            }
	            if (removeCnt) {
	                this.tryRelease();
	            }
	        }
	    };
	    // Releasing and Freezing
	    // -----------------------------------------------------------------------------------------------------------------
	    EventPeriod.prototype.tryRelease = function () {
	        if (!this.pendingCnt) {
	            if (!this.freezeDepth) {
	                this.release();
	            }
	            else {
	                this.stuntedReleaseCnt++;
	            }
	        }
	    };
	    EventPeriod.prototype.release = function () {
	        this.releaseCnt++;
	        this.trigger('release', this.eventInstanceGroupsById);
	    };
	    EventPeriod.prototype.whenReleased = function () {
	        var _this = this;
	        if (this.releaseCnt) {
	            return Promise_1.default.resolve(this.eventInstanceGroupsById);
	        }
	        else {
	            return Promise_1.default.construct(function (onResolve) {
	                _this.one('release', onResolve);
	            });
	        }
	    };
	    EventPeriod.prototype.freeze = function () {
	        if (!(this.freezeDepth++)) {
	            this.stuntedReleaseCnt = 0;
	        }
	    };
	    EventPeriod.prototype.thaw = function () {
	        if (!(--this.freezeDepth) && this.stuntedReleaseCnt && !this.pendingCnt) {
	            this.release();
	        }
	    };
	    return EventPeriod;
	}());
	exports.default = EventPeriod;
	EmitterMixin_1.default.mixInto(EventPeriod);
	
	
	/***/ }),
	/* 220 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var EventPeriod_1 = __webpack_require__(219);
	var ArrayEventSource_1 = __webpack_require__(56);
	var EventSource_1 = __webpack_require__(6);
	var EventSourceParser_1 = __webpack_require__(38);
	var SingleEventDef_1 = __webpack_require__(9);
	var EventInstanceGroup_1 = __webpack_require__(20);
	var EmitterMixin_1 = __webpack_require__(13);
	var ListenerMixin_1 = __webpack_require__(7);
	var EventManager = /** @class */ (function () {
	    function EventManager(calendar) {
	        this.calendar = calendar;
	        this.stickySource = new ArrayEventSource_1.default(calendar);
	        this.otherSources = [];
	    }
	    EventManager.prototype.requestEvents = function (start, end, timezone, force) {
	        if (force ||
	            !this.currentPeriod ||
	            !this.currentPeriod.isWithinRange(start, end) ||
	            timezone !== this.currentPeriod.timezone) {
	            this.setPeriod(// will change this.currentPeriod
	            new EventPeriod_1.default(start, end, timezone));
	        }
	        return this.currentPeriod.whenReleased();
	    };
	    // Source Adding/Removing
	    // -----------------------------------------------------------------------------------------------------------------
	    EventManager.prototype.addSource = function (eventSource) {
	        this.otherSources.push(eventSource);
	        if (this.currentPeriod) {
	            this.currentPeriod.requestSource(eventSource); // might release
	        }
	    };
	    EventManager.prototype.removeSource = function (doomedSource) {
	        util_1.removeExact(this.otherSources, doomedSource);
	        if (this.currentPeriod) {
	            this.currentPeriod.purgeSource(doomedSource); // might release
	        }
	    };
	    EventManager.prototype.removeAllSources = function () {
	        this.otherSources = [];
	        if (this.currentPeriod) {
	            this.currentPeriod.purgeAllSources(); // might release
	        }
	    };
	    // Source Refetching
	    // -----------------------------------------------------------------------------------------------------------------
	    EventManager.prototype.refetchSource = function (eventSource) {
	        var currentPeriod = this.currentPeriod;
	        if (currentPeriod) {
	            currentPeriod.freeze();
	            currentPeriod.purgeSource(eventSource);
	            currentPeriod.requestSource(eventSource);
	            currentPeriod.thaw();
	        }
	    };
	    EventManager.prototype.refetchAllSources = function () {
	        var currentPeriod = this.currentPeriod;
	        if (currentPeriod) {
	            currentPeriod.freeze();
	            currentPeriod.purgeAllSources();
	            currentPeriod.requestSources(this.getSources());
	            currentPeriod.thaw();
	        }
	    };
	    // Source Querying
	    // -----------------------------------------------------------------------------------------------------------------
	    EventManager.prototype.getSources = function () {
	        return [this.stickySource].concat(this.otherSources);
	    };
	    // like querySources, but accepts multple match criteria (like multiple IDs)
	    EventManager.prototype.multiQuerySources = function (matchInputs) {
	        // coerce into an array
	        if (!matchInputs) {
	            matchInputs = [];
	        }
	        else if (!$.isArray(matchInputs)) {
	            matchInputs = [matchInputs];
	        }
	        var matchingSources = [];
	        var i;
	        // resolve raw inputs to real event source objects
	        for (i = 0; i < matchInputs.length; i++) {
	            matchingSources.push.apply(// append
	            matchingSources, this.querySources(matchInputs[i]));
	        }
	        return matchingSources;
	    };
	    // matchInput can either by a real event source object, an ID, or the function/URL for the source.
	    // returns an array of matching source objects.
	    EventManager.prototype.querySources = function (matchInput) {
	        var sources = this.otherSources;
	        var i;
	        var source;
	        // given a proper event source object
	        for (i = 0; i < sources.length; i++) {
	            source = sources[i];
	            if (source === matchInput) {
	                return [source];
	            }
	        }
	        // an ID match
	        source = this.getSourceById(EventSource_1.default.normalizeId(matchInput));
	        if (source) {
	            return [source];
	        }
	        // parse as an event source
	        matchInput = EventSourceParser_1.default.parse(matchInput, this.calendar);
	        if (matchInput) {
	            return $.grep(sources, function (source) {
	                return isSourcesEquivalent(matchInput, source);
	            });
	        }
	    };
	    /*
	    ID assumed to already be normalized
	    */
	    EventManager.prototype.getSourceById = function (id) {
	        return $.grep(this.otherSources, function (source) {
	            return source.id && source.id === id;
	        })[0];
	    };
	    // Event-Period
	    // -----------------------------------------------------------------------------------------------------------------
	    EventManager.prototype.setPeriod = function (eventPeriod) {
	        if (this.currentPeriod) {
	            this.unbindPeriod(this.currentPeriod);
	            this.currentPeriod = null;
	        }
	        this.currentPeriod = eventPeriod;
	        this.bindPeriod(eventPeriod);
	        eventPeriod.requestSources(this.getSources());
	    };
	    EventManager.prototype.bindPeriod = function (eventPeriod) {
	        this.listenTo(eventPeriod, 'release', function (eventsPayload) {
	            this.trigger('release', eventsPayload);
	        });
	    };
	    EventManager.prototype.unbindPeriod = function (eventPeriod) {
	        this.stopListeningTo(eventPeriod);
	    };
	    // Event Getting/Adding/Removing
	    // -----------------------------------------------------------------------------------------------------------------
	    EventManager.prototype.getEventDefByUid = function (uid) {
	        if (this.currentPeriod) {
	            return this.currentPeriod.getEventDefByUid(uid);
	        }
	    };
	    EventManager.prototype.addEventDef = function (eventDef, isSticky) {
	        if (isSticky) {
	            this.stickySource.addEventDef(eventDef);
	        }
	        if (this.currentPeriod) {
	            this.currentPeriod.addEventDef(eventDef); // might release
	        }
	    };
	    EventManager.prototype.removeEventDefsById = function (eventId) {
	        this.getSources().forEach(function (eventSource) {
	            eventSource.removeEventDefsById(eventId);
	        });
	        if (this.currentPeriod) {
	            this.currentPeriod.removeEventDefsById(eventId); // might release
	        }
	    };
	    EventManager.prototype.removeAllEventDefs = function () {
	        this.getSources().forEach(function (eventSource) {
	            eventSource.removeAllEventDefs();
	        });
	        if (this.currentPeriod) {
	            this.currentPeriod.removeAllEventDefs();
	        }
	    };
	    // Event Mutating
	    // -----------------------------------------------------------------------------------------------------------------
	    /*
	    Returns an undo function.
	    */
	    EventManager.prototype.mutateEventsWithId = function (eventDefId, eventDefMutation) {
	        var currentPeriod = this.currentPeriod;
	        var eventDefs;
	        var undoFuncs = [];
	        if (currentPeriod) {
	            currentPeriod.freeze();
	            eventDefs = currentPeriod.getEventDefsById(eventDefId);
	            eventDefs.forEach(function (eventDef) {
	                // add/remove esp because id might change
	                currentPeriod.removeEventDef(eventDef);
	                undoFuncs.push(eventDefMutation.mutateSingle(eventDef));
	                currentPeriod.addEventDef(eventDef);
	            });
	            currentPeriod.thaw();
	            return function () {
	                currentPeriod.freeze();
	                for (var i = 0; i < eventDefs.length; i++) {
	                    currentPeriod.removeEventDef(eventDefs[i]);
	                    undoFuncs[i]();
	                    currentPeriod.addEventDef(eventDefs[i]);
	                }
	                currentPeriod.thaw();
	            };
	        }
	        return function () { };
	    };
	    /*
	    copies and then mutates
	    */
	    EventManager.prototype.buildMutatedEventInstanceGroup = function (eventDefId, eventDefMutation) {
	        var eventDefs = this.getEventDefsById(eventDefId);
	        var i;
	        var defCopy;
	        var allInstances = [];
	        for (i = 0; i < eventDefs.length; i++) {
	            defCopy = eventDefs[i].clone();
	            if (defCopy instanceof SingleEventDef_1.default) {
	                eventDefMutation.mutateSingle(defCopy);
	                allInstances.push.apply(allInstances, // append
	                defCopy.buildInstances());
	            }
	        }
	        return new EventInstanceGroup_1.default(allInstances);
	    };
	    // Freezing
	    // -----------------------------------------------------------------------------------------------------------------
	    EventManager.prototype.freeze = function () {
	        if (this.currentPeriod) {
	            this.currentPeriod.freeze();
	        }
	    };
	    EventManager.prototype.thaw = function () {
	        if (this.currentPeriod) {
	            this.currentPeriod.thaw();
	        }
	    };
	    // methods that simply forward to EventPeriod
	    EventManager.prototype.getEventDefsById = function (eventDefId) {
	        return this.currentPeriod.getEventDefsById(eventDefId);
	    };
	    EventManager.prototype.getEventInstances = function () {
	        return this.currentPeriod.getEventInstances();
	    };
	    EventManager.prototype.getEventInstancesWithId = function (eventDefId) {
	        return this.currentPeriod.getEventInstancesWithId(eventDefId);
	    };
	    EventManager.prototype.getEventInstancesWithoutId = function (eventDefId) {
	        return this.currentPeriod.getEventInstancesWithoutId(eventDefId);
	    };
	    return EventManager;
	}());
	exports.default = EventManager;
	EmitterMixin_1.default.mixInto(EventManager);
	ListenerMixin_1.default.mixInto(EventManager);
	function isSourcesEquivalent(source0, source1) {
	    return source0.getPrimitive() === source1.getPrimitive();
	}
	
	
	/***/ }),
	/* 221 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var Theme_1 = __webpack_require__(22);
	var StandardTheme = /** @class */ (function (_super) {
	    tslib_1.__extends(StandardTheme, _super);
	    function StandardTheme() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return StandardTheme;
	}(Theme_1.default));
	exports.default = StandardTheme;
	StandardTheme.prototype.classes = {
	    widget: 'fc-unthemed',
	    widgetHeader: 'fc-widget-header',
	    widgetContent: 'fc-widget-content',
	    buttonGroup: 'fc-button-group',
	    button: 'fc-button',
	    cornerLeft: 'fc-corner-left',
	    cornerRight: 'fc-corner-right',
	    stateDefault: 'fc-state-default',
	    stateActive: 'fc-state-active',
	    stateDisabled: 'fc-state-disabled',
	    stateHover: 'fc-state-hover',
	    stateDown: 'fc-state-down',
	    popoverHeader: 'fc-widget-header',
	    popoverContent: 'fc-widget-content',
	    // day grid
	    headerRow: 'fc-widget-header',
	    dayRow: 'fc-widget-content',
	    // list view
	    listView: 'fc-widget-content'
	};
	StandardTheme.prototype.baseIconClass = 'fc-icon';
	StandardTheme.prototype.iconClasses = {
	    close: 'fc-icon-x',
	    prev: 'fc-icon-left-single-arrow',
	    next: 'fc-icon-right-single-arrow',
	    prevYear: 'fc-icon-left-double-arrow',
	    nextYear: 'fc-icon-right-double-arrow'
	};
	StandardTheme.prototype.iconOverrideOption = 'buttonIcons';
	StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
	StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';
	
	
	/***/ }),
	/* 222 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var Theme_1 = __webpack_require__(22);
	var JqueryUiTheme = /** @class */ (function (_super) {
	    tslib_1.__extends(JqueryUiTheme, _super);
	    function JqueryUiTheme() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return JqueryUiTheme;
	}(Theme_1.default));
	exports.default = JqueryUiTheme;
	JqueryUiTheme.prototype.classes = {
	    widget: 'ui-widget',
	    widgetHeader: 'ui-widget-header',
	    widgetContent: 'ui-widget-content',
	    buttonGroup: 'fc-button-group',
	    button: 'ui-button',
	    cornerLeft: 'ui-corner-left',
	    cornerRight: 'ui-corner-right',
	    stateDefault: 'ui-state-default',
	    stateActive: 'ui-state-active',
	    stateDisabled: 'ui-state-disabled',
	    stateHover: 'ui-state-hover',
	    stateDown: 'ui-state-down',
	    today: 'ui-state-highlight',
	    popoverHeader: 'ui-widget-header',
	    popoverContent: 'ui-widget-content',
	    // day grid
	    headerRow: 'ui-widget-header',
	    dayRow: 'ui-widget-content',
	    // list view
	    listView: 'ui-widget-content'
	};
	JqueryUiTheme.prototype.baseIconClass = 'ui-icon';
	JqueryUiTheme.prototype.iconClasses = {
	    close: 'ui-icon-closethick',
	    prev: 'ui-icon-circle-triangle-w',
	    next: 'ui-icon-circle-triangle-e',
	    prevYear: 'ui-icon-seek-prev',
	    nextYear: 'ui-icon-seek-next'
	};
	JqueryUiTheme.prototype.iconOverrideOption = 'themeButtonIcons';
	JqueryUiTheme.prototype.iconOverrideCustomButtonOption = 'themeIcon';
	JqueryUiTheme.prototype.iconOverridePrefix = 'ui-icon-';
	
	
	/***/ }),
	/* 223 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var Promise_1 = __webpack_require__(21);
	var EventSource_1 = __webpack_require__(6);
	var FuncEventSource = /** @class */ (function (_super) {
	    tslib_1.__extends(FuncEventSource, _super);
	    function FuncEventSource() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FuncEventSource.parse = function (rawInput, calendar) {
	        var rawProps;
	        // normalize raw input
	        if ($.isFunction(rawInput.events)) { // extended form
	            rawProps = rawInput;
	        }
	        else if ($.isFunction(rawInput)) { // short form
	            rawProps = { events: rawInput };
	        }
	        if (rawProps) {
	            return EventSource_1.default.parse.call(this, rawProps, calendar);
	        }
	        return false;
	    };
	    FuncEventSource.prototype.fetch = function (start, end, timezone) {
	        var _this = this;
	        this.calendar.pushLoading();
	        return Promise_1.default.construct(function (onResolve) {
	            _this.func.call(_this.calendar, start.clone(), end.clone(), timezone, function (rawEventDefs) {
	                _this.calendar.popLoading();
	                onResolve(_this.parseEventDefs(rawEventDefs));
	            });
	        });
	    };
	    FuncEventSource.prototype.getPrimitive = function () {
	        return this.func;
	    };
	    FuncEventSource.prototype.applyManualStandardProps = function (rawProps) {
	        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
	        this.func = rawProps.events;
	        return superSuccess;
	    };
	    return FuncEventSource;
	}(EventSource_1.default));
	exports.default = FuncEventSource;
	FuncEventSource.defineStandardProps({
	    events: false // don't automatically transfer
	});
	
	
	/***/ }),
	/* 224 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var Promise_1 = __webpack_require__(21);
	var EventSource_1 = __webpack_require__(6);
	var JsonFeedEventSource = /** @class */ (function (_super) {
	    tslib_1.__extends(JsonFeedEventSource, _super);
	    function JsonFeedEventSource() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    JsonFeedEventSource.parse = function (rawInput, calendar) {
	        var rawProps;
	        // normalize raw input
	        if (typeof rawInput.url === 'string') { // extended form
	            rawProps = rawInput;
	        }
	        else if (typeof rawInput === 'string') { // short form
	            rawProps = { url: rawInput };
	        }
	        if (rawProps) {
	            return EventSource_1.default.parse.call(this, rawProps, calendar);
	        }
	        return false;
	    };
	    JsonFeedEventSource.prototype.fetch = function (start, end, timezone) {
	        var _this = this;
	        var ajaxSettings = this.ajaxSettings;
	        var onSuccess = ajaxSettings.success;
	        var onError = ajaxSettings.error;
	        var requestParams = this.buildRequestParams(start, end, timezone);
	        // todo: eventually handle the promise's then,
	        // don't intercept success/error
	        // tho will be a breaking API change
	        this.calendar.pushLoading();
	        return Promise_1.default.construct(function (onResolve, onReject) {
	            $.ajax($.extend({}, // destination
	            JsonFeedEventSource.AJAX_DEFAULTS, ajaxSettings, {
	                url: _this.url,
	                data: requestParams,
	                success: function (rawEventDefs, status, xhr) {
	                    var callbackRes;
	                    _this.calendar.popLoading();
	                    if (rawEventDefs) {
	                        callbackRes = util_1.applyAll(onSuccess, _this, [rawEventDefs, status, xhr]); // redirect `this`
	                        if ($.isArray(callbackRes)) {
	                            rawEventDefs = callbackRes;
	                        }
	                        onResolve(_this.parseEventDefs(rawEventDefs));
	                    }
	                    else {
	                        onReject();
	                    }
	                },
	                error: function (xhr, statusText, errorThrown) {
	                    _this.calendar.popLoading();
	                    util_1.applyAll(onError, _this, [xhr, statusText, errorThrown]); // redirect `this`
	                    onReject();
	                }
	            }));
	        });
	    };
	    JsonFeedEventSource.prototype.buildRequestParams = function (start, end, timezone) {
	        var calendar = this.calendar;
	        var ajaxSettings = this.ajaxSettings;
	        var startParam;
	        var endParam;
	        var timezoneParam;
	        var customRequestParams;
	        var params = {};
	        startParam = this.startParam;
	        if (startParam == null) {
	            startParam = calendar.opt('startParam');
	        }
	        endParam = this.endParam;
	        if (endParam == null) {
	            endParam = calendar.opt('endParam');
	        }
	        timezoneParam = this.timezoneParam;
	        if (timezoneParam == null) {
	            timezoneParam = calendar.opt('timezoneParam');
	        }
	        // retrieve any outbound GET/POST $.ajax data from the options
	        if ($.isFunction(ajaxSettings.data)) {
	            // supplied as a function that returns a key/value object
	            customRequestParams = ajaxSettings.data();
	        }
	        else {
	            // probably supplied as a straight key/value object
	            customRequestParams = ajaxSettings.data || {};
	        }
	        $.extend(params, customRequestParams);
	        params[startParam] = start.format();
	        params[endParam] = end.format();
	        if (timezone && timezone !== 'local') {
	            params[timezoneParam] = timezone;
	        }
	        return params;
	    };
	    JsonFeedEventSource.prototype.getPrimitive = function () {
	        return this.url;
	    };
	    JsonFeedEventSource.prototype.applyMiscProps = function (rawProps) {
	        this.ajaxSettings = rawProps;
	    };
	    JsonFeedEventSource.AJAX_DEFAULTS = {
	        dataType: 'json',
	        cache: false
	    };
	    return JsonFeedEventSource;
	}(EventSource_1.default));
	exports.default = JsonFeedEventSource;
	JsonFeedEventSource.defineStandardProps({
	    // automatically transfer (true)...
	    url: true,
	    startParam: true,
	    endParam: true,
	    timezoneParam: true
	});
	
	
	/***/ }),
	/* 225 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Iterator = /** @class */ (function () {
	    function Iterator(items) {
	        this.items = items || [];
	    }
	    /* Calls a method on every item passing the arguments through */
	    Iterator.prototype.proxyCall = function (methodName) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var results = [];
	        this.items.forEach(function (item) {
	            results.push(item[methodName].apply(item, args));
	        });
	        return results;
	    };
	    return Iterator;
	}());
	exports.default = Iterator;
	
	
	/***/ }),
	/* 226 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var ListenerMixin_1 = __webpack_require__(7);
	/* Creates a clone of an element and lets it track the mouse as it moves
	----------------------------------------------------------------------------------------------------------------------*/
	var MouseFollower = /** @class */ (function () {
	    function MouseFollower(sourceEl, options) {
	        this.isFollowing = false;
	        this.isHidden = false;
	        this.isAnimating = false; // doing the revert animation?
	        this.options = options = options || {};
	        this.sourceEl = sourceEl;
	        this.parentEl = options.parentEl ? $(options.parentEl) : sourceEl.parent(); // default to sourceEl's parent
	    }
	    // Causes the element to start following the mouse
	    MouseFollower.prototype.start = function (ev) {
	        if (!this.isFollowing) {
	            this.isFollowing = true;
	            this.y0 = util_1.getEvY(ev);
	            this.x0 = util_1.getEvX(ev);
	            this.topDelta = 0;
	            this.leftDelta = 0;
	            if (!this.isHidden) {
	                this.updatePosition();
	            }
	            if (util_1.getEvIsTouch(ev)) {
	                this.listenTo($(document), 'touchmove', this.handleMove);
	            }
	            else {
	                this.listenTo($(document), 'mousemove', this.handleMove);
	            }
	        }
	    };
	    // Causes the element to stop following the mouse. If shouldRevert is true, will animate back to original position.
	    // `callback` gets invoked when the animation is complete. If no animation, it is invoked immediately.
	    MouseFollower.prototype.stop = function (shouldRevert, callback) {
	        var _this = this;
	        var revertDuration = this.options.revertDuration;
	        var complete = function () {
	            _this.isAnimating = false;
	            _this.removeElement();
	            _this.top0 = _this.left0 = null; // reset state for future updatePosition calls
	            if (callback) {
	                callback();
	            }
	        };
	        if (this.isFollowing && !this.isAnimating) { // disallow more than one stop animation at a time
	            this.isFollowing = false;
	            this.stopListeningTo($(document));
	            if (shouldRevert && revertDuration && !this.isHidden) { // do a revert animation?
	                this.isAnimating = true;
	                this.el.animate({
	                    top: this.top0,
	                    left: this.left0
	                }, {
	                    duration: revertDuration,
	                    complete: complete
	                });
	            }
	            else {
	                complete();
	            }
	        }
	    };
	    // Gets the tracking element. Create it if necessary
	    MouseFollower.prototype.getEl = function () {
	        var el = this.el;
	        if (!el) {
	            el = this.el = this.sourceEl.clone()
	                .addClass(this.options.additionalClass || '')
	                .css({
	                position: 'absolute',
	                visibility: '',
	                display: this.isHidden ? 'none' : '',
	                margin: 0,
	                right: 'auto',
	                bottom: 'auto',
	                width: this.sourceEl.width(),
	                height: this.sourceEl.height(),
	                opacity: this.options.opacity || '',
	                zIndex: this.options.zIndex
	            });
	            // we don't want long taps or any mouse interaction causing selection/menus.
	            // would use preventSelection(), but that prevents selectstart, causing problems.
	            el.addClass('fc-unselectable');
	            el.appendTo(this.parentEl);
	        }
	        return el;
	    };
	    // Removes the tracking element if it has already been created
	    MouseFollower.prototype.removeElement = function () {
	        if (this.el) {
	            this.el.remove();
	            this.el = null;
	        }
	    };
	    // Update the CSS position of the tracking element
	    MouseFollower.prototype.updatePosition = function () {
	        var sourceOffset;
	        var origin;
	        this.getEl(); // ensure this.el
	        // make sure origin info was computed
	        if (this.top0 == null) {
	            sourceOffset = this.sourceEl.offset();
	            origin = this.el.offsetParent().offset();
	            this.top0 = sourceOffset.top - origin.top;
	            this.left0 = sourceOffset.left - origin.left;
	        }
	        this.el.css({
	            top: this.top0 + this.topDelta,
	            left: this.left0 + this.leftDelta
	        });
	    };
	    // Gets called when the user moves the mouse
	    MouseFollower.prototype.handleMove = function (ev) {
	        this.topDelta = util_1.getEvY(ev) - this.y0;
	        this.leftDelta = util_1.getEvX(ev) - this.x0;
	        if (!this.isHidden) {
	            this.updatePosition();
	        }
	    };
	    // Temporarily makes the tracking element invisible. Can be called before following starts
	    MouseFollower.prototype.hide = function () {
	        if (!this.isHidden) {
	            this.isHidden = true;
	            if (this.el) {
	                this.el.hide();
	            }
	        }
	    };
	    // Show the tracking element after it has been temporarily hidden
	    MouseFollower.prototype.show = function () {
	        if (this.isHidden) {
	            this.isHidden = false;
	            this.updatePosition();
	            this.getEl().show();
	        }
	    };
	    return MouseFollower;
	}());
	exports.default = MouseFollower;
	ListenerMixin_1.default.mixInto(MouseFollower);
	
	
	/***/ }),
	/* 227 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* A rectangular panel that is absolutely positioned over other content
	------------------------------------------------------------------------------------------------------------------------
	Options:
	  - className (string)
	  - content (HTML string or jQuery element set)
	  - parentEl
	  - top
	  - left
	  - right (the x coord of where the right edge should be. not a "CSS" right)
	  - autoHide (boolean)
	  - show (callback)
	  - hide (callback)
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var ListenerMixin_1 = __webpack_require__(7);
	var Popover = /** @class */ (function () {
	    function Popover(options) {
	        this.isHidden = true;
	        this.margin = 10; // the space required between the popover and the edges of the scroll container
	        this.options = options || {};
	    }
	    // Shows the popover on the specified position. Renders it if not already
	    Popover.prototype.show = function () {
	        if (this.isHidden) {
	            if (!this.el) {
	                this.render();
	            }
	            this.el.show();
	            this.position();
	            this.isHidden = false;
	            this.trigger('show');
	        }
	    };
	    // Hides the popover, through CSS, but does not remove it from the DOM
	    Popover.prototype.hide = function () {
	        if (!this.isHidden) {
	            this.el.hide();
	            this.isHidden = true;
	            this.trigger('hide');
	        }
	    };
	    // Creates `this.el` and renders content inside of it
	    Popover.prototype.render = function () {
	        var _this = this;
	        var options = this.options;
	        this.el = $('<div class="fc-popover">')
	            .addClass(options.className || '')
	            .css({
	            // position initially to the top left to avoid creating scrollbars
	            top: 0,
	            left: 0
	        })
	            .append(options.content)
	            .appendTo(options.parentEl);
	        // when a click happens on anything inside with a 'fc-close' className, hide the popover
	        this.el.on('click', '.fc-close', function () {
	            _this.hide();
	        });
	        if (options.autoHide) {
	            this.listenTo($(document), 'mousedown', this.documentMousedown);
	        }
	    };
	    // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
	    Popover.prototype.documentMousedown = function (ev) {
	        // only hide the popover if the click happened outside the popover
	        if (this.el && !$(ev.target).closest(this.el).length) {
	            this.hide();
	        }
	    };
	    // Hides and unregisters any handlers
	    Popover.prototype.removeElement = function () {
	        this.hide();
	        if (this.el) {
	            this.el.remove();
	            this.el = null;
	        }
	        this.stopListeningTo($(document), 'mousedown');
	    };
	    // Positions the popover optimally, using the top/left/right options
	    Popover.prototype.position = function () {
	        var options = this.options;
	        var origin = this.el.offsetParent().offset();
	        var width = this.el.outerWidth();
	        var height = this.el.outerHeight();
	        var windowEl = $(window);
	        var viewportEl = util_1.getScrollParent(this.el);
	        var viewportTop;
	        var viewportLeft;
	        var viewportOffset;
	        var top; // the "position" (not "offset") values for the popover
	        var left; //
	        // compute top and left
	        top = options.top || 0;
	        if (options.left !== undefined) {
	            left = options.left;
	        }
	        else if (options.right !== undefined) {
	            left = options.right - width; // derive the left value from the right value
	        }
	        else {
	            left = 0;
	        }
	        if (viewportEl.is(window) || viewportEl.is(document)) { // normalize getScrollParent's result
	            viewportEl = windowEl;
	            viewportTop = 0; // the window is always at the top left
	            viewportLeft = 0; // (and .offset() won't work if called here)
	        }
	        else {
	            viewportOffset = viewportEl.offset();
	            viewportTop = viewportOffset.top;
	            viewportLeft = viewportOffset.left;
	        }
	        // if the window is scrolled, it causes the visible area to be further down
	        viewportTop += windowEl.scrollTop();
	        viewportLeft += windowEl.scrollLeft();
	        // constrain to the view port. if constrained by two edges, give precedence to top/left
	        if (options.viewportConstrain !== false) {
	            top = Math.min(top, viewportTop + viewportEl.outerHeight() - height - this.margin);
	            top = Math.max(top, viewportTop + this.margin);
	            left = Math.min(left, viewportLeft + viewportEl.outerWidth() - width - this.margin);
	            left = Math.max(left, viewportLeft + this.margin);
	        }
	        this.el.css({
	            top: top - origin.top,
	            left: left - origin.left
	        });
	    };
	    // Triggers a callback. Calls a function in the option hash of the same name.
	    // Arguments beyond the first `name` are forwarded on.
	    // TODO: better code reuse for this. Repeat code
	    Popover.prototype.trigger = function (name) {
	        if (this.options[name]) {
	            this.options[name].apply(this, Array.prototype.slice.call(arguments, 1));
	        }
	    };
	    return Popover;
	}());
	exports.default = Popover;
	ListenerMixin_1.default.mixInto(Popover);
	
	
	/***/ }),
	/* 228 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var EmitterMixin_1 = __webpack_require__(13);
	var TaskQueue = /** @class */ (function () {
	    function TaskQueue() {
	        this.q = [];
	        this.isPaused = false;
	        this.isRunning = false;
	    }
	    TaskQueue.prototype.queue = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this.q.push.apply(this.q, args); // append
	        this.tryStart();
	    };
	    TaskQueue.prototype.pause = function () {
	        this.isPaused = true;
	    };
	    TaskQueue.prototype.resume = function () {
	        this.isPaused = false;
	        this.tryStart();
	    };
	    TaskQueue.prototype.getIsIdle = function () {
	        return !this.isRunning && !this.isPaused;
	    };
	    TaskQueue.prototype.tryStart = function () {
	        if (!this.isRunning && this.canRunNext()) {
	            this.isRunning = true;
	            this.trigger('start');
	            this.runRemaining();
	        }
	    };
	    TaskQueue.prototype.canRunNext = function () {
	        return !this.isPaused && this.q.length;
	    };
	    TaskQueue.prototype.runRemaining = function () {
	        var _this = this;
	        var task;
	        var res;
	        do {
	            task = this.q.shift(); // always freshly reference q. might have been reassigned.
	            res = this.runTask(task);
	            if (res && res.then) {
	                res.then(function () {
	                    if (_this.canRunNext()) {
	                        _this.runRemaining();
	                    }
	                });
	                return; // prevent marking as stopped
	            }
	        } while (this.canRunNext());
	        this.trigger('stop'); // not really a 'stop' ... more of a 'drained'
	        this.isRunning = false;
	        // if 'stop' handler added more tasks.... TODO: write test for this
	        this.tryStart();
	    };
	    TaskQueue.prototype.runTask = function (task) {
	        return task(); // task *is* the function, but subclasses can change the format of a task
	    };
	    return TaskQueue;
	}());
	exports.default = TaskQueue;
	EmitterMixin_1.default.mixInto(TaskQueue);
	
	
	/***/ }),
	/* 229 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var TaskQueue_1 = __webpack_require__(228);
	var RenderQueue = /** @class */ (function (_super) {
	    tslib_1.__extends(RenderQueue, _super);
	    function RenderQueue(waitsByNamespace) {
	        var _this = _super.call(this) || this;
	        _this.waitsByNamespace = waitsByNamespace || {};
	        return _this;
	    }
	    RenderQueue.prototype.queue = function (taskFunc, namespace, type) {
	        var task = {
	            func: taskFunc,
	            namespace: namespace,
	            type: type
	        };
	        var waitMs;
	        if (namespace) {
	            waitMs = this.waitsByNamespace[namespace];
	        }
	        if (this.waitNamespace) {
	            if (namespace === this.waitNamespace && waitMs != null) {
	                this.delayWait(waitMs);
	            }
	            else {
	                this.clearWait();
	                this.tryStart();
	            }
	        }
	        if (this.compoundTask(task)) { // appended to queue?
	            if (!this.waitNamespace && waitMs != null) {
	                this.startWait(namespace, waitMs);
	            }
	            else {
	                this.tryStart();
	            }
	        }
	    };
	    RenderQueue.prototype.startWait = function (namespace, waitMs) {
	        this.waitNamespace = namespace;
	        this.spawnWait(waitMs);
	    };
	    RenderQueue.prototype.delayWait = function (waitMs) {
	        clearTimeout(this.waitId);
	        this.spawnWait(waitMs);
	    };
	    RenderQueue.prototype.spawnWait = function (waitMs) {
	        var _this = this;
	        this.waitId = setTimeout(function () {
	            _this.waitNamespace = null;
	            _this.tryStart();
	        }, waitMs);
	    };
	    RenderQueue.prototype.clearWait = function () {
	        if (this.waitNamespace) {
	            clearTimeout(this.waitId);
	            this.waitId = null;
	            this.waitNamespace = null;
	        }
	    };
	    RenderQueue.prototype.canRunNext = function () {
	        if (!_super.prototype.canRunNext.call(this)) {
	            return false;
	        }
	        // waiting for a certain namespace to stop receiving tasks?
	        if (this.waitNamespace) {
	            var q = this.q;
	            // if there was a different namespace task in the meantime,
	            // that forces all previously-waiting tasks to suddenly execute.
	            // TODO: find a way to do this in constant time.
	            for (var i = 0; i < q.length; i++) {
	                if (q[i].namespace !== this.waitNamespace) {
	                    return true; // allow execution
	                }
	            }
	            return false;
	        }
	        return true;
	    };
	    RenderQueue.prototype.runTask = function (task) {
	        task.func();
	    };
	    RenderQueue.prototype.compoundTask = function (newTask) {
	        var q = this.q;
	        var shouldAppend = true;
	        var i;
	        var task;
	        if (newTask.namespace && newTask.type === 'destroy') {
	            // remove all init/add/remove ops with same namespace, regardless of order
	            for (i = q.length - 1; i >= 0; i--) {
	                task = q[i];
	                if (task.namespace === newTask.namespace) {
	                    switch (task.type) {
	                        case 'init':
	                            shouldAppend = false;
	                        // the latest destroy is cancelled out by not doing the init
	                        /* falls through */
	                        case 'add':
	                        /* falls through */
	                        case 'remove':
	                            q.splice(i, 1); // remove task
	                    }
	                }
	            }
	        }
	        if (shouldAppend) {
	            q.push(newTask);
	        }
	        return shouldAppend;
	    };
	    return RenderQueue;
	}(TaskQueue_1.default));
	exports.default = RenderQueue;
	
	
	/***/ }),
	/* 230 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var Model_1 = __webpack_require__(51);
	var Component = /** @class */ (function (_super) {
	    tslib_1.__extends(Component, _super);
	    function Component() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Component.prototype.setElement = function (el) {
	        this.el = el;
	        this.bindGlobalHandlers();
	        this.renderSkeleton();
	        this.set('isInDom', true);
	    };
	    Component.prototype.removeElement = function () {
	        this.unset('isInDom');
	        this.unrenderSkeleton();
	        this.unbindGlobalHandlers();
	        this.el.remove();
	        // NOTE: don't null-out this.el in case the View was destroyed within an API callback.
	        // We don't null-out the View's other jQuery element references upon destroy,
	        //  so we shouldn't kill this.el either.
	    };
	    Component.prototype.bindGlobalHandlers = function () {
	        // subclasses can override
	    };
	    Component.prototype.unbindGlobalHandlers = function () {
	        // subclasses can override
	    };
	    /*
	    NOTE: Can't have a `render` method. Read the deprecation notice in View::executeDateRender
	    */
	    // Renders the basic structure of the view before any content is rendered
	    Component.prototype.renderSkeleton = function () {
	        // subclasses should implement
	    };
	    // Unrenders the basic structure of the view
	    Component.prototype.unrenderSkeleton = function () {
	        // subclasses should implement
	    };
	    return Component;
	}(Model_1.default));
	exports.default = Component;
	
	
	/***/ }),
	/* 231 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var moment = __webpack_require__(0);
	var util_1 = __webpack_require__(4);
	var moment_ext_1 = __webpack_require__(11);
	var date_formatting_1 = __webpack_require__(49);
	var Component_1 = __webpack_require__(230);
	var util_2 = __webpack_require__(19);
	var DateComponent = /** @class */ (function (_super) {
	    tslib_1.__extends(DateComponent, _super);
	    function DateComponent(_view, _options) {
	        var _this = _super.call(this) || this;
	        _this.isRTL = false; // frequently accessed options
	        _this.hitsNeededDepth = 0; // necessary because multiple callers might need the same hits
	        _this.hasAllDayBusinessHours = false; // TODO: unify with largeUnit and isTimeScale?
	        _this.isDatesRendered = false;
	        // hack to set options prior to the this.opt calls
	        if (_view) {
	            _this['view'] = _view;
	        }
	        if (_options) {
	            _this['options'] = _options;
	        }
	        _this.uid = String(DateComponent.guid++);
	        _this.childrenByUid = {};
	        _this.nextDayThreshold = moment.duration(_this.opt('nextDayThreshold'));
	        _this.isRTL = _this.opt('isRTL');
	        if (_this.fillRendererClass) {
	            _this.fillRenderer = new _this.fillRendererClass(_this);
	        }
	        if (_this.eventRendererClass) { // fillRenderer is optional -----v
	            _this.eventRenderer = new _this.eventRendererClass(_this, _this.fillRenderer);
	        }
	        if (_this.helperRendererClass && _this.eventRenderer) {
	            _this.helperRenderer = new _this.helperRendererClass(_this, _this.eventRenderer);
	        }
	        if (_this.businessHourRendererClass && _this.fillRenderer) {
	            _this.businessHourRenderer = new _this.businessHourRendererClass(_this, _this.fillRenderer);
	        }
	        return _this;
	    }
	    DateComponent.prototype.addChild = function (child) {
	        if (!this.childrenByUid[child.uid]) {
	            this.childrenByUid[child.uid] = child;
	            return true;
	        }
	        return false;
	    };
	    DateComponent.prototype.removeChild = function (child) {
	        if (this.childrenByUid[child.uid]) {
	            delete this.childrenByUid[child.uid];
	            return true;
	        }
	        return false;
	    };
	    // TODO: only do if isInDom?
	    // TODO: make part of Component, along with children/batch-render system?
	    DateComponent.prototype.updateSize = function (totalHeight, isAuto, isResize) {
	        this.callChildren('updateSize', arguments);
	    };
	    // Options
	    // -----------------------------------------------------------------------------------------------------------------
	    DateComponent.prototype.opt = function (name) {
	        return this._getView().opt(name); // default implementation
	    };
	    DateComponent.prototype.publiclyTrigger = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var calendar = this._getCalendar();
	        return calendar.publiclyTrigger.apply(calendar, args);
	    };
	    DateComponent.prototype.hasPublicHandlers = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var calendar = this._getCalendar();
	        return calendar.hasPublicHandlers.apply(calendar, args);
	    };
	    // Date
	    // -----------------------------------------------------------------------------------------------------------------
	    DateComponent.prototype.executeDateRender = function (dateProfile) {
	        this.dateProfile = dateProfile; // for rendering
	        this.renderDates(dateProfile);
	        this.isDatesRendered = true;
	        this.callChildren('executeDateRender', arguments);
	    };
	    DateComponent.prototype.executeDateUnrender = function () {
	        this.callChildren('executeDateUnrender', arguments);
	        this.dateProfile = null;
	        this.unrenderDates();
	        this.isDatesRendered = false;
	    };
	    // date-cell content only
	    DateComponent.prototype.renderDates = function (dateProfile) {
	        // subclasses should implement
	    };
	    // date-cell content only
	    DateComponent.prototype.unrenderDates = function () {
	        // subclasses should override
	    };
	    // Now-Indicator
	    // -----------------------------------------------------------------------------------------------------------------
	    // Returns a string unit, like 'second' or 'minute' that defined how often the current time indicator
	    // should be refreshed. If something falsy is returned, no time indicator is rendered at all.
	    DateComponent.prototype.getNowIndicatorUnit = function () {
	        // subclasses should implement
	    };
	    // Renders a current time indicator at the given datetime
	    DateComponent.prototype.renderNowIndicator = function (date) {
	        this.callChildren('renderNowIndicator', arguments);
	    };
	    // Undoes the rendering actions from renderNowIndicator
	    DateComponent.prototype.unrenderNowIndicator = function () {
	        this.callChildren('unrenderNowIndicator', arguments);
	    };
	    // Business Hours
	    // ---------------------------------------------------------------------------------------------------------------
	    DateComponent.prototype.renderBusinessHours = function (businessHourGenerator) {
	        if (this.businessHourRenderer) {
	            this.businessHourRenderer.render(businessHourGenerator);
	        }
	        this.callChildren('renderBusinessHours', arguments);
	    };
	    // Unrenders previously-rendered business-hours
	    DateComponent.prototype.unrenderBusinessHours = function () {
	        this.callChildren('unrenderBusinessHours', arguments);
	        if (this.businessHourRenderer) {
	            this.businessHourRenderer.unrender();
	        }
	    };
	    // Event Displaying
	    // -----------------------------------------------------------------------------------------------------------------
	    DateComponent.prototype.executeEventRender = function (eventsPayload) {
	        if (this.eventRenderer) {
	            this.eventRenderer.rangeUpdated(); // poorly named now
	            this.eventRenderer.render(eventsPayload);
	        }
	        else if (this['renderEvents']) { // legacy
	            this['renderEvents'](convertEventsPayloadToLegacyArray(eventsPayload));
	        }
	        this.callChildren('executeEventRender', arguments);
	    };
	    DateComponent.prototype.executeEventUnrender = function () {
	        this.callChildren('executeEventUnrender', arguments);
	        if (this.eventRenderer) {
	            this.eventRenderer.unrender();
	        }
	        else if (this['destroyEvents']) { // legacy
	            this['destroyEvents']();
	        }
	    };
	    DateComponent.prototype.getBusinessHourSegs = function () {
	        var segs = this.getOwnBusinessHourSegs();
	        this.iterChildren(function (child) {
	            segs.push.apply(segs, child.getBusinessHourSegs());
	        });
	        return segs;
	    };
	    DateComponent.prototype.getOwnBusinessHourSegs = function () {
	        if (this.businessHourRenderer) {
	            return this.businessHourRenderer.getSegs();
	        }
	        return [];
	    };
	    DateComponent.prototype.getEventSegs = function () {
	        var segs = this.getOwnEventSegs();
	        this.iterChildren(function (child) {
	            segs.push.apply(segs, child.getEventSegs());
	        });
	        return segs;
	    };
	    DateComponent.prototype.getOwnEventSegs = function () {
	        if (this.eventRenderer) {
	            return this.eventRenderer.getSegs();
	        }
	        return [];
	    };
	    // Event Rendering Triggering
	    // -----------------------------------------------------------------------------------------------------------------
	    DateComponent.prototype.triggerAfterEventsRendered = function () {
	        this.triggerAfterEventSegsRendered(this.getEventSegs());
	        this.publiclyTrigger('eventAfterAllRender', {
	            context: this,
	            args: [this]
	        });
	    };
	    DateComponent.prototype.triggerAfterEventSegsRendered = function (segs) {
	        var _this = this;
	        // an optimization, because getEventLegacy is expensive
	        if (this.hasPublicHandlers('eventAfterRender')) {
	            segs.forEach(function (seg) {
	                var legacy;
	                if (seg.el) { // necessary?
	                    legacy = seg.footprint.getEventLegacy();
	                    _this.publiclyTrigger('eventAfterRender', {
	                        context: legacy,
	                        args: [legacy, seg.el, _this]
	                    });
	                }
	            });
	        }
	    };
	    DateComponent.prototype.triggerBeforeEventsDestroyed = function () {
	        this.triggerBeforeEventSegsDestroyed(this.getEventSegs());
	    };
	    DateComponent.prototype.triggerBeforeEventSegsDestroyed = function (segs) {
	        var _this = this;
	        if (this.hasPublicHandlers('eventDestroy')) {
	            segs.forEach(function (seg) {
	                var legacy;
	                if (seg.el) { // necessary?
	                    legacy = seg.footprint.getEventLegacy();
	                    _this.publiclyTrigger('eventDestroy', {
	                        context: legacy,
	                        args: [legacy, seg.el, _this]
	                    });
	                }
	            });
	        }
	    };
	    // Event Rendering Utils
	    // -----------------------------------------------------------------------------------------------------------------
	    // Hides all rendered event segments linked to the given event
	    // RECURSIVE with subcomponents
	    DateComponent.prototype.showEventsWithId = function (eventDefId) {
	        this.getEventSegs().forEach(function (seg) {
	            if (seg.footprint.eventDef.id === eventDefId &&
	                seg.el // necessary?
	            ) {
	                seg.el.css('visibility', '');
	            }
	        });
	        this.callChildren('showEventsWithId', arguments);
	    };
	    // Shows all rendered event segments linked to the given event
	    // RECURSIVE with subcomponents
	    DateComponent.prototype.hideEventsWithId = function (eventDefId) {
	        this.getEventSegs().forEach(function (seg) {
	            if (seg.footprint.eventDef.id === eventDefId &&
	                seg.el // necessary?
	            ) {
	                seg.el.css('visibility', 'hidden');
	            }
	        });
	        this.callChildren('hideEventsWithId', arguments);
	    };
	    // Drag-n-Drop Rendering (for both events and external elements)
	    // ---------------------------------------------------------------------------------------------------------------
	    // Renders a visual indication of a event or external-element drag over the given drop zone.
	    // If an external-element, seg will be `null`.
	    // Must return elements used for any mock events.
	    DateComponent.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
	        var renderedHelper = false;
	        this.iterChildren(function (child) {
	            if (child.renderDrag(eventFootprints, seg, isTouch)) {
	                renderedHelper = true;
	            }
	        });
	        return renderedHelper;
	    };
	    // Unrenders a visual indication of an event or external-element being dragged.
	    DateComponent.prototype.unrenderDrag = function () {
	        this.callChildren('unrenderDrag', arguments);
	    };
	    // Event Resizing
	    // ---------------------------------------------------------------------------------------------------------------
	    // Renders a visual indication of an event being resized.
	    DateComponent.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
	        this.callChildren('renderEventResize', arguments);
	    };
	    // Unrenders a visual indication of an event being resized.
	    DateComponent.prototype.unrenderEventResize = function () {
	        this.callChildren('unrenderEventResize', arguments);
	    };
	    // Selection
	    // ---------------------------------------------------------------------------------------------------------------
	    // Renders a visual indication of the selection
	    // TODO: rename to `renderSelection` after legacy is gone
	    DateComponent.prototype.renderSelectionFootprint = function (componentFootprint) {
	        this.renderHighlight(componentFootprint);
	        this.callChildren('renderSelectionFootprint', arguments);
	    };
	    // Unrenders a visual indication of selection
	    DateComponent.prototype.unrenderSelection = function () {
	        this.unrenderHighlight();
	        this.callChildren('unrenderSelection', arguments);
	    };
	    // Highlight
	    // ---------------------------------------------------------------------------------------------------------------
	    // Renders an emphasis on the given date range. Given a span (unzoned start/end and other misc data)
	    DateComponent.prototype.renderHighlight = function (componentFootprint) {
	        if (this.fillRenderer) {
	            this.fillRenderer.renderFootprint('highlight', componentFootprint, {
	                getClasses: function () {
	                    return ['fc-highlight'];
	                }
	            });
	        }
	        this.callChildren('renderHighlight', arguments);
	    };
	    // Unrenders the emphasis on a date range
	    DateComponent.prototype.unrenderHighlight = function () {
	        if (this.fillRenderer) {
	            this.fillRenderer.unrender('highlight');
	        }
	        this.callChildren('unrenderHighlight', arguments);
	    };
	    // Hit Areas
	    // ---------------------------------------------------------------------------------------------------------------
	    // just because all DateComponents support this interface
	    // doesn't mean they need to have their own internal coord system. they can defer to sub-components.
	    DateComponent.prototype.hitsNeeded = function () {
	        if (!(this.hitsNeededDepth++)) {
	            this.prepareHits();
	        }
	        this.callChildren('hitsNeeded', arguments);
	    };
	    DateComponent.prototype.hitsNotNeeded = function () {
	        if (this.hitsNeededDepth && !(--this.hitsNeededDepth)) {
	            this.releaseHits();
	        }
	        this.callChildren('hitsNotNeeded', arguments);
	    };
	    DateComponent.prototype.prepareHits = function () {
	        // subclasses can implement
	    };
	    DateComponent.prototype.releaseHits = function () {
	        // subclasses can implement
	    };
	    // Given coordinates from the topleft of the document, return data about the date-related area underneath.
	    // Can return an object with arbitrary properties (although top/right/left/bottom are encouraged).
	    // Must have a `grid` property, a reference to this current grid. TODO: avoid this
	    // The returned object will be processed by getHitFootprint and getHitEl.
	    DateComponent.prototype.queryHit = function (leftOffset, topOffset) {
	        var childrenByUid = this.childrenByUid;
	        var uid;
	        var hit;
	        for (uid in childrenByUid) {
	            hit = childrenByUid[uid].queryHit(leftOffset, topOffset);
	            if (hit) {
	                break;
	            }
	        }
	        return hit;
	    };
	    DateComponent.prototype.getSafeHitFootprint = function (hit) {
	        var footprint = this.getHitFootprint(hit);
	        if (!this.dateProfile.activeUnzonedRange.containsRange(footprint.unzonedRange)) {
	            return null;
	        }
	        return footprint;
	    };
	    DateComponent.prototype.getHitFootprint = function (hit) {
	        // what about being abstract!?
	    };
	    // Given position-level information about a date-related area within the grid,
	    // should return a jQuery element that best represents it. passed to dayClick callback.
	    DateComponent.prototype.getHitEl = function (hit) {
	        // what about being abstract!?
	    };
	    /* Converting eventRange -> eventFootprint
	    ------------------------------------------------------------------------------------------------------------------*/
	    DateComponent.prototype.eventRangesToEventFootprints = function (eventRanges) {
	        var eventFootprints = [];
	        var i;
	        for (i = 0; i < eventRanges.length; i++) {
	            eventFootprints.push.apply(// append
	            eventFootprints, this.eventRangeToEventFootprints(eventRanges[i]));
	        }
	        return eventFootprints;
	    };
	    DateComponent.prototype.eventRangeToEventFootprints = function (eventRange) {
	        return [util_2.eventRangeToEventFootprint(eventRange)];
	    };
	    /* Converting componentFootprint/eventFootprint -> segs
	    ------------------------------------------------------------------------------------------------------------------*/
	    DateComponent.prototype.eventFootprintsToSegs = function (eventFootprints) {
	        var segs = [];
	        var i;
	        for (i = 0; i < eventFootprints.length; i++) {
	            segs.push.apply(segs, this.eventFootprintToSegs(eventFootprints[i]));
	        }
	        return segs;
	    };
	    // Given an event's span (unzoned start/end and other misc data), and the event itself,
	    // slices into segments and attaches event-derived properties to them.
	    // eventSpan - { start, end, isStart, isEnd, otherthings... }
	    DateComponent.prototype.eventFootprintToSegs = function (eventFootprint) {
	        var unzonedRange = eventFootprint.componentFootprint.unzonedRange;
	        var segs;
	        var i;
	        var seg;
	        segs = this.componentFootprintToSegs(eventFootprint.componentFootprint);
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            if (!unzonedRange.isStart) {
	                seg.isStart = false;
	            }
	            if (!unzonedRange.isEnd) {
	                seg.isEnd = false;
	            }
	            seg.footprint = eventFootprint;
	            // TODO: rename to seg.eventFootprint
	        }
	        return segs;
	    };
	    DateComponent.prototype.componentFootprintToSegs = function (componentFootprint) {
	        return [];
	    };
	    // Utils
	    // ---------------------------------------------------------------------------------------------------------------
	    DateComponent.prototype.callChildren = function (methodName, args) {
	        this.iterChildren(function (child) {
	            child[methodName].apply(child, args);
	        });
	    };
	    DateComponent.prototype.iterChildren = function (func) {
	        var childrenByUid = this.childrenByUid;
	        var uid;
	        for (uid in childrenByUid) {
	            func(childrenByUid[uid]);
	        }
	    };
	    DateComponent.prototype._getCalendar = function () {
	        var t = this;
	        return t.calendar || t.view.calendar;
	    };
	    DateComponent.prototype._getView = function () {
	        return this.view;
	    };
	    DateComponent.prototype._getDateProfile = function () {
	        return this._getView().get('dateProfile');
	    };
	    // Generates HTML for an anchor to another view into the calendar.
	    // Will either generate an <a> tag or a non-clickable <span> tag, depending on enabled settings.
	    // `gotoOptions` can either be a moment input, or an object with the form:
	    // { date, type, forceOff }
	    // `type` is a view-type like "day" or "week". default value is "day".
	    // `attrs` and `innerHtml` are use to generate the rest of the HTML tag.
	    DateComponent.prototype.buildGotoAnchorHtml = function (gotoOptions, attrs, innerHtml) {
	        var date;
	        var type;
	        var forceOff;
	        var finalOptions;
	        if ($.isPlainObject(gotoOptions)) {
	            date = gotoOptions.date;
	            type = gotoOptions.type;
	            forceOff = gotoOptions.forceOff;
	        }
	        else {
	            date = gotoOptions; // a single moment input
	        }
	        date = moment_ext_1.default(date); // if a string, parse it
	        finalOptions = {
	            date: date.format('YYYY-MM-DD'),
	            type: type || 'day'
	        };
	        if (typeof attrs === 'string') {
	            innerHtml = attrs;
	            attrs = null;
	        }
	        attrs = attrs ? ' ' + util_1.attrsToStr(attrs) : ''; // will have a leading space
	        innerHtml = innerHtml || '';
	        if (!forceOff && this.opt('navLinks')) {
	            return '<a' + attrs +
	                ' data-goto="' + util_1.htmlEscape(JSON.stringify(finalOptions)) + '">' +
	                innerHtml +
	                '</a>';
	        }
	        else {
	            return '<span' + attrs + '>' +
	                innerHtml +
	                '</span>';
	        }
	    };
	    DateComponent.prototype.getAllDayHtml = function () {
	        return this.opt('allDayHtml') || util_1.htmlEscape(this.opt('allDayText'));
	    };
	    // Computes HTML classNames for a single-day element
	    DateComponent.prototype.getDayClasses = function (date, noThemeHighlight) {
	        var view = this._getView();
	        var classes = [];
	        var today;
	        if (!this.dateProfile.activeUnzonedRange.containsDate(date)) {
	            classes.push('fc-disabled-day'); // TODO: jQuery UI theme?
	        }
	        else {
	            classes.push('fc-' + util_1.dayIDs[date.day()]);
	            if (view.isDateInOtherMonth(date, this.dateProfile)) { // TODO: use DateComponent subclass somehow
	                classes.push('fc-other-month');
	            }
	            today = view.calendar.getNow();
	            if (date.isSame(today, 'day')) {
	                classes.push('fc-today');
	                if (noThemeHighlight !== true) {
	                    classes.push(view.calendar.theme.getClass('today'));
	                }
	            }
	            else if (date < today) {
	                classes.push('fc-past');
	            }
	            else {
	                classes.push('fc-future');
	            }
	        }
	        return classes;
	    };
	    // Utility for formatting a range. Accepts a range object, formatting string, and optional separator.
	    // Displays all-day ranges naturally, with an inclusive end. Takes the current isRTL into account.
	    // The timezones of the dates within `range` will be respected.
	    DateComponent.prototype.formatRange = function (range, isAllDay, formatStr, separator) {
	        var end = range.end;
	        if (isAllDay) {
	            end = end.clone().subtract(1); // convert to inclusive. last ms of previous day
	        }
	        return date_formatting_1.formatRange(range.start, end, formatStr, separator, this.isRTL);
	    };
	    // Compute the number of the give units in the "current" range.
	    // Will return a floating-point number. Won't round.
	    DateComponent.prototype.currentRangeAs = function (unit) {
	        return this._getDateProfile().currentUnzonedRange.as(unit);
	    };
	    // Returns the date range of the full days the given range visually appears to occupy.
	    // Returns a plain object with start/end, NOT an UnzonedRange!
	    DateComponent.prototype.computeDayRange = function (unzonedRange) {
	        var calendar = this._getCalendar();
	        var startDay = calendar.msToUtcMoment(unzonedRange.startMs, true); // the beginning of the day the range starts
	        var end = calendar.msToUtcMoment(unzonedRange.endMs);
	        var endTimeMS = +end.time(); // # of milliseconds into `endDay`
	        var endDay = end.clone().stripTime(); // the beginning of the day the range exclusively ends
	        // If the end time is actually inclusively part of the next day and is equal to or
	        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
	        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
	        if (endTimeMS && endTimeMS >= this.nextDayThreshold) {
	            endDay.add(1, 'days');
	        }
	        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
	        if (endDay <= startDay) {
	            endDay = startDay.clone().add(1, 'days');
	        }
	        return { start: startDay, end: endDay };
	    };
	    // Does the given range visually appear to occupy more than one day?
	    DateComponent.prototype.isMultiDayRange = function (unzonedRange) {
	        var dayRange = this.computeDayRange(unzonedRange);
	        return dayRange.end.diff(dayRange.start, 'days') > 1;
	    };
	    DateComponent.guid = 0; // TODO: better system for this?
	    return DateComponent;
	}(Component_1.default));
	exports.default = DateComponent;
	// legacy
	function convertEventsPayloadToLegacyArray(eventsPayload) {
	    var eventDefId;
	    var eventInstances;
	    var legacyEvents = [];
	    var i;
	    for (eventDefId in eventsPayload) {
	        eventInstances = eventsPayload[eventDefId].eventInstances;
	        for (i = 0; i < eventInstances.length; i++) {
	            legacyEvents.push(eventInstances[i].toLegacy());
	        }
	    }
	    return legacyEvents;
	}
	
	
	/***/ }),
	/* 232 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var moment = __webpack_require__(0);
	var util_1 = __webpack_require__(4);
	var options_1 = __webpack_require__(33);
	var Iterator_1 = __webpack_require__(225);
	var GlobalEmitter_1 = __webpack_require__(23);
	var EmitterMixin_1 = __webpack_require__(13);
	var ListenerMixin_1 = __webpack_require__(7);
	var Toolbar_1 = __webpack_require__(257);
	var OptionsManager_1 = __webpack_require__(258);
	var ViewSpecManager_1 = __webpack_require__(259);
	var Constraints_1 = __webpack_require__(217);
	var locale_1 = __webpack_require__(32);
	var moment_ext_1 = __webpack_require__(11);
	var UnzonedRange_1 = __webpack_require__(5);
	var ComponentFootprint_1 = __webpack_require__(12);
	var EventDateProfile_1 = __webpack_require__(16);
	var EventManager_1 = __webpack_require__(220);
	var BusinessHourGenerator_1 = __webpack_require__(218);
	var EventSourceParser_1 = __webpack_require__(38);
	var EventDefParser_1 = __webpack_require__(36);
	var SingleEventDef_1 = __webpack_require__(9);
	var EventDefMutation_1 = __webpack_require__(39);
	var EventSource_1 = __webpack_require__(6);
	var ThemeRegistry_1 = __webpack_require__(57);
	var Calendar = /** @class */ (function () {
	    function Calendar(el, overrides) {
	        this.loadingLevel = 0; // number of simultaneous loading tasks
	        this.ignoreUpdateViewSize = 0;
	        this.freezeContentHeightDepth = 0;
	        // declare the current calendar instance relies on GlobalEmitter. needed for garbage collection.
	        // unneeded() is called in destroy.
	        GlobalEmitter_1.default.needed();
	        this.el = el;
	        this.viewsByType = {};
	        this.optionsManager = new OptionsManager_1.default(this, overrides);
	        this.viewSpecManager = new ViewSpecManager_1.default(this.optionsManager, this);
	        this.initMomentInternals(); // needs to happen after options hash initialized
	        this.initCurrentDate();
	        this.initEventManager();
	        this.constraints = new Constraints_1.default(this.eventManager, this);
	        this.constructed();
	    }
	    Calendar.prototype.constructed = function () {
	        // useful for monkeypatching. used?
	    };
	    Calendar.prototype.getView = function () {
	        return this.view;
	    };
	    Calendar.prototype.publiclyTrigger = function (name, triggerInfo) {
	        var optHandler = this.opt(name);
	        var context;
	        var args;
	        if ($.isPlainObject(triggerInfo)) {
	            context = triggerInfo.context;
	            args = triggerInfo.args;
	        }
	        else if ($.isArray(triggerInfo)) {
	            args = triggerInfo;
	        }
	        if (context == null) {
	            context = this.el[0]; // fallback context
	        }
	        if (!args) {
	            args = [];
	        }
	        this.triggerWith(name, context, args); // Emitter's method
	        if (optHandler) {
	            return optHandler.apply(context, args);
	        }
	    };
	    Calendar.prototype.hasPublicHandlers = function (name) {
	        return this.hasHandlers(name) ||
	            this.opt(name); // handler specified in options
	    };
	    // Options Public API
	    // -----------------------------------------------------------------------------------------------------------------
	    // public getter/setter
	    Calendar.prototype.option = function (name, value) {
	        var newOptionHash;
	        if (typeof name === 'string') {
	            if (value === undefined) { // getter
	                return this.optionsManager.get(name);
	            }
	            else { // setter for individual option
	                newOptionHash = {};
	                newOptionHash[name] = value;
	                this.optionsManager.add(newOptionHash);
	            }
	        }
	        else if (typeof name === 'object') { // compound setter with object input
	            this.optionsManager.add(name);
	        }
	    };
	    // private getter
	    Calendar.prototype.opt = function (name) {
	        return this.optionsManager.get(name);
	    };
	    // View
	    // -----------------------------------------------------------------------------------------------------------------
	    // Given a view name for a custom view or a standard view, creates a ready-to-go View object
	    Calendar.prototype.instantiateView = function (viewType) {
	        var spec = this.viewSpecManager.getViewSpec(viewType);
	        if (!spec) {
	            throw new Error("View type \"" + viewType + "\" is not valid");
	        }
	        return new spec['class'](this, spec);
	    };
	    // Returns a boolean about whether the view is okay to instantiate at some point
	    Calendar.prototype.isValidViewType = function (viewType) {
	        return Boolean(this.viewSpecManager.getViewSpec(viewType));
	    };
	    Calendar.prototype.changeView = function (viewName, dateOrRange) {
	        if (dateOrRange) {
	            if (dateOrRange.start && dateOrRange.end) { // a range
	                this.optionsManager.recordOverrides({
	                    visibleRange: dateOrRange
	                });
	            }
	            else { // a date
	                this.currentDate = this.moment(dateOrRange).stripZone(); // just like gotoDate
	            }
	        }
	        this.renderView(viewName);
	    };
	    // Forces navigation to a view for the given date.
	    // `viewType` can be a specific view name or a generic one like "week" or "day".
	    Calendar.prototype.zoomTo = function (newDate, viewType) {
	        var spec;
	        viewType = viewType || 'day'; // day is default zoom
	        spec = this.viewSpecManager.getViewSpec(viewType) ||
	            this.viewSpecManager.getUnitViewSpec(viewType);
	        this.currentDate = newDate.clone();
	        this.renderView(spec ? spec.type : null);
	    };
	    // Current Date
	    // -----------------------------------------------------------------------------------------------------------------
	    Calendar.prototype.initCurrentDate = function () {
	        var defaultDateInput = this.opt('defaultDate');
	        // compute the initial ambig-timezone date
	        if (defaultDateInput != null) {
	            this.currentDate = this.moment(defaultDateInput).stripZone();
	        }
	        else {
	            this.currentDate = this.getNow(); // getNow already returns unzoned
	        }
	    };
	    Calendar.prototype.prev = function () {
	        var view = this.view;
	        var prevInfo = view.dateProfileGenerator.buildPrev(view.get('dateProfile'));
	        if (prevInfo.isValid) {
	            this.currentDate = prevInfo.date;
	            this.renderView();
	        }
	    };
	    Calendar.prototype.next = function () {
	        var view = this.view;
	        var nextInfo = view.dateProfileGenerator.buildNext(view.get('dateProfile'));
	        if (nextInfo.isValid) {
	            this.currentDate = nextInfo.date;
	            this.renderView();
	        }
	    };
	    Calendar.prototype.prevYear = function () {
	        this.currentDate.add(-1, 'years');
	        this.renderView();
	    };
	    Calendar.prototype.nextYear = function () {
	        this.currentDate.add(1, 'years');
	        this.renderView();
	    };
	    Calendar.prototype.today = function () {
	        this.currentDate = this.getNow(); // should deny like prev/next?
	        this.renderView();
	    };
	    Calendar.prototype.gotoDate = function (zonedDateInput) {
	        this.currentDate = this.moment(zonedDateInput).stripZone();
	        this.renderView();
	    };
	    Calendar.prototype.incrementDate = function (delta) {
	        this.currentDate.add(moment.duration(delta));
	        this.renderView();
	    };
	    // for external API
	    Calendar.prototype.getDate = function () {
	        return this.applyTimezone(this.currentDate); // infuse the calendar's timezone
	    };
	    // Loading Triggering
	    // -----------------------------------------------------------------------------------------------------------------
	    // Should be called when any type of async data fetching begins
	    Calendar.prototype.pushLoading = function () {
	        if (!(this.loadingLevel++)) {
	            this.publiclyTrigger('loading', [true, this.view]);
	        }
	    };
	    // Should be called when any type of async data fetching completes
	    Calendar.prototype.popLoading = function () {
	        if (!(--this.loadingLevel)) {
	            this.publiclyTrigger('loading', [false, this.view]);
	        }
	    };
	    // High-level Rendering
	    // -----------------------------------------------------------------------------------
	    Calendar.prototype.render = function () {
	        if (!this.contentEl) {
	            this.initialRender();
	        }
	        else if (this.elementVisible()) {
	            // mainly for the public API
	            this.calcSize();
	            this.updateViewSize();
	        }
	    };
	    Calendar.prototype.initialRender = function () {
	        var _this = this;
	        var el = this.el;
	        el.addClass('fc');
	        // event delegation for nav links
	        el.on('click.fc', 'a[data-goto]', function (ev) {
	            var anchorEl = $(ev.currentTarget);
	            var gotoOptions = anchorEl.data('goto'); // will automatically parse JSON
	            var date = _this.moment(gotoOptions.date);
	            var viewType = gotoOptions.type;
	            // property like "navLinkDayClick". might be a string or a function
	            var customAction = _this.view.opt('navLink' + util_1.capitaliseFirstLetter(viewType) + 'Click');
	            if (typeof customAction === 'function') {
	                customAction(date, ev);
	            }
	            else {
	                if (typeof customAction === 'string') {
	                    viewType = customAction;
	                }
	                _this.zoomTo(date, viewType);
	            }
	        });
	        // called immediately, and upon option change
	        this.optionsManager.watch('settingTheme', ['?theme', '?themeSystem'], function (opts) {
	            var themeClass = ThemeRegistry_1.getThemeSystemClass(opts.themeSystem || opts.theme);
	            var theme = new themeClass(_this.optionsManager);
	            var widgetClass = theme.getClass('widget');
	            _this.theme = theme;
	            if (widgetClass) {
	                el.addClass(widgetClass);
	            }
	        }, function () {
	            var widgetClass = _this.theme.getClass('widget');
	            _this.theme = null;
	            if (widgetClass) {
	                el.removeClass(widgetClass);
	            }
	        });
	        this.optionsManager.watch('settingBusinessHourGenerator', ['?businessHours'], function (deps) {
	            _this.businessHourGenerator = new BusinessHourGenerator_1.default(deps.businessHours, _this);
	            if (_this.view) {
	                _this.view.set('businessHourGenerator', _this.businessHourGenerator);
	            }
	        }, function () {
	            _this.businessHourGenerator = null;
	        });
	        // called immediately, and upon option change.
	        // HACK: locale often affects isRTL, so we explicitly listen to that too.
	        this.optionsManager.watch('applyingDirClasses', ['?isRTL', '?locale'], function (opts) {
	            el.toggleClass('fc-ltr', !opts.isRTL);
	            el.toggleClass('fc-rtl', opts.isRTL);
	        });
	        this.contentEl = $("<div class='fc-view-container'>").prependTo(el);
	        this.initToolbars();
	        this.renderHeader();
	        this.renderFooter();
	        this.renderView(this.opt('defaultView'));
	        if (this.opt('handleWindowResize')) {
	            $(window).resize(this.windowResizeProxy = util_1.debounce(// prevents rapid calls
	            this.windowResize.bind(this), this.opt('windowResizeDelay')));
	        }
	    };
	    Calendar.prototype.destroy = function () {
	        if (this.view) {
	            this.clearView();
	        }
	        this.toolbarsManager.proxyCall('removeElement');
	        this.contentEl.remove();
	        this.el.removeClass('fc fc-ltr fc-rtl');
	        // removes theme-related root className
	        this.optionsManager.unwatch('settingTheme');
	        this.optionsManager.unwatch('settingBusinessHourGenerator');
	        this.el.off('.fc'); // unbind nav link handlers
	        if (this.windowResizeProxy) {
	            $(window).unbind('resize', this.windowResizeProxy);
	            this.windowResizeProxy = null;
	        }
	        GlobalEmitter_1.default.unneeded();
	    };
	    Calendar.prototype.elementVisible = function () {
	        return this.el.is(':visible');
	    };
	    // Render Queue
	    // -----------------------------------------------------------------------------------------------------------------
	    Calendar.prototype.bindViewHandlers = function (view) {
	        var _this = this;
	        view.watch('titleForCalendar', ['title'], function (deps) {
	            if (view === _this.view) { // hack
	                _this.setToolbarsTitle(deps.title);
	            }
	        });
	        view.watch('dateProfileForCalendar', ['dateProfile'], function (deps) {
	            if (view === _this.view) { // hack
	                _this.currentDate = deps.dateProfile.date; // might have been constrained by view dates
	                _this.updateToolbarButtons(deps.dateProfile);
	            }
	        });
	    };
	    Calendar.prototype.unbindViewHandlers = function (view) {
	        view.unwatch('titleForCalendar');
	        view.unwatch('dateProfileForCalendar');
	    };
	    // View Rendering
	    // -----------------------------------------------------------------------------------
	    // Renders a view because of a date change, view-type change, or for the first time.
	    // If not given a viewType, keep the current view but render different dates.
	    // Accepts an optional scroll state to restore to.
	    Calendar.prototype.renderView = function (viewType) {
	        var oldView = this.view;
	        var newView;
	        this.freezeContentHeight();
	        if (oldView && viewType && oldView.type !== viewType) {
	            this.clearView();
	        }
	        // if viewType changed, or the view was never created, create a fresh view
	        if (!this.view && viewType) {
	            newView = this.view =
	                this.viewsByType[viewType] ||
	                    (this.viewsByType[viewType] = this.instantiateView(viewType));
	            this.bindViewHandlers(newView);
	            newView.startBatchRender(); // so that setElement+setDate rendering are joined
	            newView.setElement($("<div class='fc-view fc-" + viewType + "-view'>").appendTo(this.contentEl));
	            this.toolbarsManager.proxyCall('activateButton', viewType);
	        }
	        if (this.view) {
	            // prevent unnecessary change firing
	            if (this.view.get('businessHourGenerator') !== this.businessHourGenerator) {
	                this.view.set('businessHourGenerator', this.businessHourGenerator);
	            }
	            this.view.setDate(this.currentDate);
	            if (newView) {
	                newView.stopBatchRender();
	            }
	        }
	        this.thawContentHeight();
	    };
	    // Unrenders the current view and reflects this change in the Header.
	    // Unregsiters the `view`, but does not remove from viewByType hash.
	    Calendar.prototype.clearView = function () {
	        var currentView = this.view;
	        this.toolbarsManager.proxyCall('deactivateButton', currentView.type);
	        this.unbindViewHandlers(currentView);
	        currentView.removeElement();
	        currentView.unsetDate(); // so bindViewHandlers doesn't fire with old values next time
	        this.view = null;
	    };
	    // Destroys the view, including the view object. Then, re-instantiates it and renders it.
	    // Maintains the same scroll state.
	    // TODO: maintain any other user-manipulated state.
	    Calendar.prototype.reinitView = function () {
	        var oldView = this.view;
	        var scroll = oldView.queryScroll(); // wouldn't be so complicated if Calendar owned the scroll
	        this.freezeContentHeight();
	        this.clearView();
	        this.calcSize();
	        this.renderView(oldView.type); // needs the type to freshly render
	        this.view.applyScroll(scroll);
	        this.thawContentHeight();
	    };
	    // Resizing
	    // -----------------------------------------------------------------------------------
	    Calendar.prototype.getSuggestedViewHeight = function () {
	        if (this.suggestedViewHeight == null) {
	            this.calcSize();
	        }
	        return this.suggestedViewHeight;
	    };
	    Calendar.prototype.isHeightAuto = function () {
	        return this.opt('contentHeight') === 'auto' || this.opt('height') === 'auto';
	    };
	    Calendar.prototype.updateViewSize = function (isResize) {
	        if (isResize === void 0) { isResize = false; }
	        var view = this.view;
	        var scroll;
	        if (!this.ignoreUpdateViewSize && view) {
	            if (isResize) {
	                this.calcSize();
	                scroll = view.queryScroll();
	            }
	            this.ignoreUpdateViewSize++;
	            view.updateSize(this.getSuggestedViewHeight(), this.isHeightAuto(), isResize);
	            this.ignoreUpdateViewSize--;
	            if (isResize) {
	                view.applyScroll(scroll);
	            }
	            return true; // signal success
	        }
	    };
	    Calendar.prototype.calcSize = function () {
	        if (this.elementVisible()) {
	            this._calcSize();
	        }
	    };
	    Calendar.prototype._calcSize = function () {
	        var contentHeightInput = this.opt('contentHeight');
	        var heightInput = this.opt('height');
	        if (typeof contentHeightInput === 'number') { // exists and not 'auto'
	            this.suggestedViewHeight = contentHeightInput;
	        }
	        else if (typeof contentHeightInput === 'function') { // exists and is a function
	            this.suggestedViewHeight = contentHeightInput();
	        }
	        else if (typeof heightInput === 'number') { // exists and not 'auto'
	            this.suggestedViewHeight = heightInput - this.queryToolbarsHeight();
	        }
	        else if (typeof heightInput === 'function') { // exists and is a function
	            this.suggestedViewHeight = heightInput() - this.queryToolbarsHeight();
	        }
	        else if (heightInput === 'parent') { // set to height of parent element
	            this.suggestedViewHeight = this.el.parent().height() - this.queryToolbarsHeight();
	        }
	        else {
	            this.suggestedViewHeight = Math.round(this.contentEl.width() /
	                Math.max(this.opt('aspectRatio'), .5));
	        }
	    };
	    Calendar.prototype.windowResize = function (ev) {
	        if (
	        // the purpose: so we don't process jqui "resize" events that have bubbled up
	        // cast to any because .target, which is Element, can't be compared to window for some reason.
	        ev.target === window &&
	            this.view &&
	            this.view.isDatesRendered) {
	            if (this.updateViewSize(true)) { // isResize=true, returns true on success
	                this.publiclyTrigger('windowResize', [this.view]);
	            }
	        }
	    };
	    /* Height "Freezing"
	    -----------------------------------------------------------------------------*/
	    Calendar.prototype.freezeContentHeight = function () {
	        if (!(this.freezeContentHeightDepth++)) {
	            this.forceFreezeContentHeight();
	        }
	    };
	    Calendar.prototype.forceFreezeContentHeight = function () {
	        this.contentEl.css({
	            width: '100%',
	            height: this.contentEl.height(),
	            overflow: 'hidden'
	        });
	    };
	    Calendar.prototype.thawContentHeight = function () {
	        this.freezeContentHeightDepth--;
	        // always bring back to natural height
	        this.contentEl.css({
	            width: '',
	            height: '',
	            overflow: ''
	        });
	        // but if there are future thaws, re-freeze
	        if (this.freezeContentHeightDepth) {
	            this.forceFreezeContentHeight();
	        }
	    };
	    // Toolbar
	    // -----------------------------------------------------------------------------------------------------------------
	    Calendar.prototype.initToolbars = function () {
	        this.header = new Toolbar_1.default(this, this.computeHeaderOptions());
	        this.footer = new Toolbar_1.default(this, this.computeFooterOptions());
	        this.toolbarsManager = new Iterator_1.default([this.header, this.footer]);
	    };
	    Calendar.prototype.computeHeaderOptions = function () {
	        return {
	            extraClasses: 'fc-header-toolbar',
	            layout: this.opt('header')
	        };
	    };
	    Calendar.prototype.computeFooterOptions = function () {
	        return {
	            extraClasses: 'fc-footer-toolbar',
	            layout: this.opt('footer')
	        };
	    };
	    // can be called repeatedly and Header will rerender
	    Calendar.prototype.renderHeader = function () {
	        var header = this.header;
	        header.setToolbarOptions(this.computeHeaderOptions());
	        header.render();
	        if (header.el) {
	            this.el.prepend(header.el);
	        }
	    };
	    // can be called repeatedly and Footer will rerender
	    Calendar.prototype.renderFooter = function () {
	        var footer = this.footer;
	        footer.setToolbarOptions(this.computeFooterOptions());
	        footer.render();
	        if (footer.el) {
	            this.el.append(footer.el);
	        }
	    };
	    Calendar.prototype.setToolbarsTitle = function (title) {
	        this.toolbarsManager.proxyCall('updateTitle', title);
	    };
	    Calendar.prototype.updateToolbarButtons = function (dateProfile) {
	        var now = this.getNow();
	        var view = this.view;
	        var todayInfo = view.dateProfileGenerator.build(now);
	        var prevInfo = view.dateProfileGenerator.buildPrev(view.get('dateProfile'));
	        var nextInfo = view.dateProfileGenerator.buildNext(view.get('dateProfile'));
	        this.toolbarsManager.proxyCall((todayInfo.isValid && !dateProfile.currentUnzonedRange.containsDate(now)) ?
	            'enableButton' :
	            'disableButton', 'today');
	        this.toolbarsManager.proxyCall(prevInfo.isValid ?
	            'enableButton' :
	            'disableButton', 'prev');
	        this.toolbarsManager.proxyCall(nextInfo.isValid ?
	            'enableButton' :
	            'disableButton', 'next');
	    };
	    Calendar.prototype.queryToolbarsHeight = function () {
	        return this.toolbarsManager.items.reduce(function (accumulator, toolbar) {
	            var toolbarHeight = toolbar.el ? toolbar.el.outerHeight(true) : 0; // includes margin
	            return accumulator + toolbarHeight;
	        }, 0);
	    };
	    // Selection
	    // -----------------------------------------------------------------------------------------------------------------
	    // this public method receives start/end dates in any format, with any timezone
	    Calendar.prototype.select = function (zonedStartInput, zonedEndInput) {
	        this.view.select(this.buildSelectFootprint.apply(this, arguments));
	    };
	    Calendar.prototype.unselect = function () {
	        if (this.view) {
	            this.view.unselect();
	        }
	    };
	    // Given arguments to the select method in the API, returns a span (unzoned start/end and other info)
	    Calendar.prototype.buildSelectFootprint = function (zonedStartInput, zonedEndInput) {
	        var start = this.moment(zonedStartInput).stripZone();
	        var end;
	        if (zonedEndInput) {
	            end = this.moment(zonedEndInput).stripZone();
	        }
	        else if (start.hasTime()) {
	            end = start.clone().add(this.defaultTimedEventDuration);
	        }
	        else {
	            end = start.clone().add(this.defaultAllDayEventDuration);
	        }
	        return new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), !start.hasTime());
	    };
	    // Date Utils
	    // -----------------------------------------------------------------------------------------------------------------
	    Calendar.prototype.initMomentInternals = function () {
	        var _this = this;
	        this.defaultAllDayEventDuration = moment.duration(this.opt('defaultAllDayEventDuration'));
	        this.defaultTimedEventDuration = moment.duration(this.opt('defaultTimedEventDuration'));
	        // Called immediately, and when any of the options change.
	        // Happens before any internal objects rebuild or rerender, because this is very core.
	        this.optionsManager.watch('buildingMomentLocale', [
	            '?locale', '?monthNames', '?monthNamesShort', '?dayNames', '?dayNamesShort',
	            '?firstDay', '?weekNumberCalculation'
	        ], function (opts) {
	            var weekNumberCalculation = opts.weekNumberCalculation;
	            var firstDay = opts.firstDay;
	            var _week;
	            // normalize
	            if (weekNumberCalculation === 'iso') {
	                weekNumberCalculation = 'ISO'; // normalize
	            }
	            var localeData = Object.create(// make a cheap copy
	            locale_1.getMomentLocaleData(opts.locale) // will fall back to en
	            );
	            if (opts.monthNames) {
	                localeData._months = opts.monthNames;
	            }
	            if (opts.monthNamesShort) {
	                localeData._monthsShort = opts.monthNamesShort;
	            }
	            if (opts.dayNames) {
	                localeData._weekdays = opts.dayNames;
	            }
	            if (opts.dayNamesShort) {
	                localeData._weekdaysShort = opts.dayNamesShort;
	            }
	            if (firstDay == null && weekNumberCalculation === 'ISO') {
	                firstDay = 1;
	            }
	            if (firstDay != null) {
	                _week = Object.create(localeData._week); // _week: { dow: # }
	                _week.dow = firstDay;
	                localeData._week = _week;
	            }
	            if ( // whitelist certain kinds of input
	            weekNumberCalculation === 'ISO' ||
	                weekNumberCalculation === 'local' ||
	                typeof weekNumberCalculation === 'function') {
	                localeData._fullCalendar_weekCalc = weekNumberCalculation; // moment-ext will know what to do with it
	            }
	            _this.localeData = localeData;
	            // If the internal current date object already exists, move to new locale.
	            // We do NOT need to do this technique for event dates, because this happens when converting to "segments".
	            if (_this.currentDate) {
	                _this.localizeMoment(_this.currentDate); // sets to localeData
	            }
	        });
	    };
	    // Builds a moment using the settings of the current calendar: timezone and locale.
	    // Accepts anything the vanilla moment() constructor accepts.
	    Calendar.prototype.moment = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var mom;
	        if (this.opt('timezone') === 'local') {
	            mom = moment_ext_1.default.apply(null, args);
	            // Force the moment to be local, because momentExt doesn't guarantee it.
	            if (mom.hasTime()) { // don't give ambiguously-timed moments a local zone
	                mom.local();
	            }
	        }
	        else if (this.opt('timezone') === 'UTC') {
	            mom = moment_ext_1.default.utc.apply(null, args); // process as UTC
	        }
	        else {
	            mom = moment_ext_1.default.parseZone.apply(null, args); // let the input decide the zone
	        }
	        this.localizeMoment(mom); // TODO
	        return mom;
	    };
	    Calendar.prototype.msToMoment = function (ms, forceAllDay) {
	        var mom = moment_ext_1.default.utc(ms); // TODO: optimize by using Date.UTC
	        if (forceAllDay) {
	            mom.stripTime();
	        }
	        else {
	            mom = this.applyTimezone(mom); // may or may not apply locale
	        }
	        this.localizeMoment(mom);
	        return mom;
	    };
	    Calendar.prototype.msToUtcMoment = function (ms, forceAllDay) {
	        var mom = moment_ext_1.default.utc(ms); // TODO: optimize by using Date.UTC
	        if (forceAllDay) {
	            mom.stripTime();
	        }
	        this.localizeMoment(mom);
	        return mom;
	    };
	    // Updates the given moment's locale settings to the current calendar locale settings.
	    Calendar.prototype.localizeMoment = function (mom) {
	        mom._locale = this.localeData;
	    };
	    // Returns a boolean about whether or not the calendar knows how to calculate
	    // the timezone offset of arbitrary dates in the current timezone.
	    Calendar.prototype.getIsAmbigTimezone = function () {
	        return this.opt('timezone') !== 'local' && this.opt('timezone') !== 'UTC';
	    };
	    // Returns a copy of the given date in the current timezone. Has no effect on dates without times.
	    Calendar.prototype.applyTimezone = function (date) {
	        if (!date.hasTime()) {
	            return date.clone();
	        }
	        var zonedDate = this.moment(date.toArray());
	        var timeAdjust = date.time().asMilliseconds() - zonedDate.time().asMilliseconds();
	        var adjustedZonedDate;
	        // Safari sometimes has problems with this coersion when near DST. Adjust if necessary. (bug #2396)
	        if (timeAdjust) { // is the time result different than expected?
	            adjustedZonedDate = zonedDate.clone().add(timeAdjust); // add milliseconds
	            if (date.time().asMilliseconds() - adjustedZonedDate.time().asMilliseconds() === 0) { // does it match perfectly now?
	                zonedDate = adjustedZonedDate;
	            }
	        }
	        return zonedDate;
	    };
	    /*
	    Assumes the footprint is non-open-ended.
	    */
	    Calendar.prototype.footprintToDateProfile = function (componentFootprint, ignoreEnd) {
	        if (ignoreEnd === void 0) { ignoreEnd = false; }
	        var start = moment_ext_1.default.utc(componentFootprint.unzonedRange.startMs);
	        var end;
	        if (!ignoreEnd) {
	            end = moment_ext_1.default.utc(componentFootprint.unzonedRange.endMs);
	        }
	        if (componentFootprint.isAllDay) {
	            start.stripTime();
	            if (end) {
	                end.stripTime();
	            }
	        }
	        else {
	            start = this.applyTimezone(start);
	            if (end) {
	                end = this.applyTimezone(end);
	            }
	        }
	        this.localizeMoment(start);
	        if (end) {
	            this.localizeMoment(end);
	        }
	        return new EventDateProfile_1.default(start, end, this);
	    };
	    // Returns a moment for the current date, as defined by the client's computer or from the `now` option.
	    // Will return an moment with an ambiguous timezone.
	    Calendar.prototype.getNow = function () {
	        var now = this.opt('now');
	        if (typeof now === 'function') {
	            now = now();
	        }
	        return this.moment(now).stripZone();
	    };
	    // Produces a human-readable string for the given duration.
	    // Side-effect: changes the locale of the given duration.
	    Calendar.prototype.humanizeDuration = function (duration) {
	        return duration.locale(this.opt('locale')).humanize();
	    };
	    // will return `null` if invalid range
	    Calendar.prototype.parseUnzonedRange = function (rangeInput) {
	        var start = null;
	        var end = null;
	        if (rangeInput.start) {
	            start = this.moment(rangeInput.start).stripZone();
	        }
	        if (rangeInput.end) {
	            end = this.moment(rangeInput.end).stripZone();
	        }
	        if (!start && !end) {
	            return null;
	        }
	        if (start && end && end.isBefore(start)) {
	            return null;
	        }
	        return new UnzonedRange_1.default(start, end);
	    };
	    // Event-Date Utilities
	    // -----------------------------------------------------------------------------------------------------------------
	    Calendar.prototype.initEventManager = function () {
	        var _this = this;
	        var eventManager = new EventManager_1.default(this);
	        var rawSources = this.opt('eventSources') || [];
	        var singleRawSource = this.opt('events');
	        this.eventManager = eventManager;
	        if (singleRawSource) {
	            rawSources.unshift(singleRawSource);
	        }
	        eventManager.on('release', function (eventsPayload) {
	            _this.trigger('eventsReset', eventsPayload);
	        });
	        eventManager.freeze();
	        rawSources.forEach(function (rawSource) {
	            var source = EventSourceParser_1.default.parse(rawSource, _this);
	            if (source) {
	                eventManager.addSource(source);
	            }
	        });
	        eventManager.thaw();
	    };
	    Calendar.prototype.requestEvents = function (start, end) {
	        return this.eventManager.requestEvents(start, end, this.opt('timezone'), !this.opt('lazyFetching'));
	    };
	    // Get an event's normalized end date. If not present, calculate it from the defaults.
	    Calendar.prototype.getEventEnd = function (event) {
	        if (event.end) {
	            return event.end.clone();
	        }
	        else {
	            return this.getDefaultEventEnd(event.allDay, event.start);
	        }
	    };
	    // Given an event's allDay status and start date, return what its fallback end date should be.
	    // TODO: rename to computeDefaultEventEnd
	    Calendar.prototype.getDefaultEventEnd = function (allDay, zonedStart) {
	        var end = zonedStart.clone();
	        if (allDay) {
	            end.stripTime().add(this.defaultAllDayEventDuration);
	        }
	        else {
	            end.add(this.defaultTimedEventDuration);
	        }
	        if (this.getIsAmbigTimezone()) {
	            end.stripZone(); // we don't know what the tzo should be
	        }
	        return end;
	    };
	    // Public Events API
	    // -----------------------------------------------------------------------------------------------------------------
	    Calendar.prototype.rerenderEvents = function () {
	        this.view.flash('displayingEvents');
	    };
	    Calendar.prototype.refetchEvents = function () {
	        this.eventManager.refetchAllSources();
	    };
	    Calendar.prototype.renderEvents = function (eventInputs, isSticky) {
	        this.eventManager.freeze();
	        for (var i = 0; i < eventInputs.length; i++) {
	            this.renderEvent(eventInputs[i], isSticky);
	        }
	        this.eventManager.thaw();
	    };
	    Calendar.prototype.renderEvent = function (eventInput, isSticky) {
	        if (isSticky === void 0) { isSticky = false; }
	        var eventManager = this.eventManager;
	        var eventDef = EventDefParser_1.default.parse(eventInput, eventInput.source || eventManager.stickySource);
	        if (eventDef) {
	            eventManager.addEventDef(eventDef, isSticky);
	        }
	    };
	    // legacyQuery operates on legacy event instance objects
	    Calendar.prototype.removeEvents = function (legacyQuery) {
	        var eventManager = this.eventManager;
	        var legacyInstances = [];
	        var idMap = {};
	        var eventDef;
	        var i;
	        if (legacyQuery == null) { // shortcut for removing all
	            eventManager.removeAllEventDefs(); // persist=true
	        }
	        else {
	            eventManager.getEventInstances().forEach(function (eventInstance) {
	                legacyInstances.push(eventInstance.toLegacy());
	            });
	            legacyInstances = filterLegacyEventInstances(legacyInstances, legacyQuery);
	            // compute unique IDs
	            for (i = 0; i < legacyInstances.length; i++) {
	                eventDef = this.eventManager.getEventDefByUid(legacyInstances[i]._id);
	                idMap[eventDef.id] = true;
	            }
	            eventManager.freeze();
	            for (i in idMap) { // reuse `i` as an "id"
	                eventManager.removeEventDefsById(i); // persist=true
	            }
	            eventManager.thaw();
	        }
	    };
	    // legacyQuery operates on legacy event instance objects
	    Calendar.prototype.clientEvents = function (legacyQuery) {
	        var legacyEventInstances = [];
	        this.eventManager.getEventInstances().forEach(function (eventInstance) {
	            legacyEventInstances.push(eventInstance.toLegacy());
	        });
	        return filterLegacyEventInstances(legacyEventInstances, legacyQuery);
	    };
	    Calendar.prototype.updateEvents = function (eventPropsArray) {
	        this.eventManager.freeze();
	        for (var i = 0; i < eventPropsArray.length; i++) {
	            this.updateEvent(eventPropsArray[i]);
	        }
	        this.eventManager.thaw();
	    };
	    Calendar.prototype.updateEvent = function (eventProps) {
	        var eventDef = this.eventManager.getEventDefByUid(eventProps._id);
	        var eventInstance;
	        var eventDefMutation;
	        if (eventDef instanceof SingleEventDef_1.default) {
	            eventInstance = eventDef.buildInstance();
	            eventDefMutation = EventDefMutation_1.default.createFromRawProps(eventInstance, eventProps, // raw props
	            null // largeUnit -- who uses it?
	            );
	            this.eventManager.mutateEventsWithId(eventDef.id, eventDefMutation); // will release
	        }
	    };
	    // Public Event Sources API
	    // ------------------------------------------------------------------------------------
	    Calendar.prototype.getEventSources = function () {
	        return this.eventManager.otherSources.slice(); // clone
	    };
	    Calendar.prototype.getEventSourceById = function (id) {
	        return this.eventManager.getSourceById(EventSource_1.default.normalizeId(id));
	    };
	    Calendar.prototype.addEventSource = function (sourceInput) {
	        var source = EventSourceParser_1.default.parse(sourceInput, this);
	        if (source) {
	            this.eventManager.addSource(source);
	        }
	    };
	    Calendar.prototype.removeEventSources = function (sourceMultiQuery) {
	        var eventManager = this.eventManager;
	        var sources;
	        var i;
	        if (sourceMultiQuery == null) {
	            this.eventManager.removeAllSources();
	        }
	        else {
	            sources = eventManager.multiQuerySources(sourceMultiQuery);
	            eventManager.freeze();
	            for (i = 0; i < sources.length; i++) {
	                eventManager.removeSource(sources[i]);
	            }
	            eventManager.thaw();
	        }
	    };
	    Calendar.prototype.removeEventSource = function (sourceQuery) {
	        var eventManager = this.eventManager;
	        var sources = eventManager.querySources(sourceQuery);
	        var i;
	        eventManager.freeze();
	        for (i = 0; i < sources.length; i++) {
	            eventManager.removeSource(sources[i]);
	        }
	        eventManager.thaw();
	    };
	    Calendar.prototype.refetchEventSources = function (sourceMultiQuery) {
	        var eventManager = this.eventManager;
	        var sources = eventManager.multiQuerySources(sourceMultiQuery);
	        var i;
	        eventManager.freeze();
	        for (i = 0; i < sources.length; i++) {
	            eventManager.refetchSource(sources[i]);
	        }
	        eventManager.thaw();
	    };
	    // not for internal use. use options module directly instead.
	    Calendar.defaults = options_1.globalDefaults;
	    Calendar.englishDefaults = options_1.englishDefaults;
	    Calendar.rtlDefaults = options_1.rtlDefaults;
	    return Calendar;
	}());
	exports.default = Calendar;
	EmitterMixin_1.default.mixInto(Calendar);
	ListenerMixin_1.default.mixInto(Calendar);
	function filterLegacyEventInstances(legacyEventInstances, legacyQuery) {
	    if (legacyQuery == null) {
	        return legacyEventInstances;
	    }
	    else if ($.isFunction(legacyQuery)) {
	        return legacyEventInstances.filter(legacyQuery);
	    }
	    else { // an event ID
	        legacyQuery += ''; // normalize to string
	        return legacyEventInstances.filter(function (legacyEventInstance) {
	            // soft comparison because id not be normalized to string
	            // tslint:disable-next-line
	            return legacyEventInstance.id == legacyQuery ||
	                legacyEventInstance._id === legacyQuery; // can specify internal id, but must exactly match
	        });
	    }
	}
	
	
	/***/ }),
	/* 233 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var moment = __webpack_require__(0);
	var exportHooks = __webpack_require__(18);
	var util_1 = __webpack_require__(4);
	var moment_ext_1 = __webpack_require__(11);
	var ListenerMixin_1 = __webpack_require__(7);
	var HitDragListener_1 = __webpack_require__(17);
	var SingleEventDef_1 = __webpack_require__(9);
	var EventInstanceGroup_1 = __webpack_require__(20);
	var EventSource_1 = __webpack_require__(6);
	var Interaction_1 = __webpack_require__(14);
	var ExternalDropping = /** @class */ (function (_super) {
	    tslib_1.__extends(ExternalDropping, _super);
	    function ExternalDropping() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.isDragging = false; // jqui-dragging an external element? boolean
	        return _this;
	    }
	    /*
	    component impements:
	      - eventRangesToEventFootprints
	      - isEventInstanceGroupAllowed
	      - isExternalInstanceGroupAllowed
	      - renderDrag
	      - unrenderDrag
	    */
	    ExternalDropping.prototype.end = function () {
	        if (this.dragListener) {
	            this.dragListener.endInteraction();
	        }
	    };
	    ExternalDropping.prototype.bindToDocument = function () {
	        this.listenTo($(document), {
	            dragstart: this.handleDragStart,
	            sortstart: this.handleDragStart // jqui
	        });
	    };
	    ExternalDropping.prototype.unbindFromDocument = function () {
	        this.stopListeningTo($(document));
	    };
	    // Called when a jQuery UI drag is initiated anywhere in the DOM
	    ExternalDropping.prototype.handleDragStart = function (ev, ui) {
	        var el;
	        var accept;
	        if (this.opt('droppable')) { // only listen if this setting is on
	            el = $((ui ? ui.item : null) || ev.target);
	            // Test that the dragged element passes the dropAccept selector or filter function.
	            // FYI, the default is "*" (matches all)
	            accept = this.opt('dropAccept');
	            if ($.isFunction(accept) ? accept.call(el[0], el) : el.is(accept)) {
	                if (!this.isDragging) { // prevent double-listening if fired twice
	                    this.listenToExternalDrag(el, ev, ui);
	                }
	            }
	        }
	    };
	    // Called when a jQuery UI drag starts and it needs to be monitored for dropping
	    ExternalDropping.prototype.listenToExternalDrag = function (el, ev, ui) {
	        var _this = this;
	        var component = this.component;
	        var view = this.view;
	        var meta = getDraggedElMeta(el); // extra data about event drop, including possible event to create
	        var singleEventDef; // a null value signals an unsuccessful drag
	        // listener that tracks mouse movement over date-associated pixel regions
	        var dragListener = this.dragListener = new HitDragListener_1.default(component, {
	            interactionStart: function () {
	                _this.isDragging = true;
	            },
	            hitOver: function (hit) {
	                var isAllowed = true;
	                var hitFootprint = hit.component.getSafeHitFootprint(hit); // hit might not belong to this grid
	                var mutatedEventInstanceGroup;
	                if (hitFootprint) {
	                    singleEventDef = _this.computeExternalDrop(hitFootprint, meta);
	                    if (singleEventDef) {
	                        mutatedEventInstanceGroup = new EventInstanceGroup_1.default(singleEventDef.buildInstances());
	                        isAllowed = meta.eventProps ? // isEvent?
	                            component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup) :
	                            component.isExternalInstanceGroupAllowed(mutatedEventInstanceGroup);
	                    }
	                    else {
	                        isAllowed = false;
	                    }
	                }
	                else {
	                    isAllowed = false;
	                }
	                if (!isAllowed) {
	                    singleEventDef = null;
	                    util_1.disableCursor();
	                }
	                if (singleEventDef) {
	                    component.renderDrag(// called without a seg parameter
	                    component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, view.calendar)));
	                }
	            },
	            hitOut: function () {
	                singleEventDef = null; // signal unsuccessful
	            },
	            hitDone: function () {
	                util_1.enableCursor();
	                component.unrenderDrag();
	            },
	            interactionEnd: function (ev) {
	                if (singleEventDef) { // element was dropped on a valid hit
	                    view.reportExternalDrop(singleEventDef, Boolean(meta.eventProps), // isEvent
	                    Boolean(meta.stick), // isSticky
	                    el, ev, ui);
	                }
	                _this.isDragging = false;
	                _this.dragListener = null;
	            }
	        });
	        dragListener.startDrag(ev); // start listening immediately
	    };
	    // Given a hit to be dropped upon, and misc data associated with the jqui drag (guaranteed to be a plain object),
	    // returns the zoned start/end dates for the event that would result from the hypothetical drop. end might be null.
	    // Returning a null value signals an invalid drop hit.
	    // DOES NOT consider overlap/constraint.
	    // Assumes both footprints are non-open-ended.
	    ExternalDropping.prototype.computeExternalDrop = function (componentFootprint, meta) {
	        var calendar = this.view.calendar;
	        var start = moment_ext_1.default.utc(componentFootprint.unzonedRange.startMs).stripZone();
	        var end;
	        var eventDef;
	        if (componentFootprint.isAllDay) {
	            // if dropped on an all-day span, and element's metadata specified a time, set it
	            if (meta.startTime) {
	                start.time(meta.startTime);
	            }
	            else {
	                start.stripTime();
	            }
	        }
	        if (meta.duration) {
	            end = start.clone().add(meta.duration);
	        }
	        start = calendar.applyTimezone(start);
	        if (end) {
	            end = calendar.applyTimezone(end);
	        }
	        eventDef = SingleEventDef_1.default.parse($.extend({}, meta.eventProps, {
	            start: start,
	            end: end
	        }), new EventSource_1.default(calendar));
	        return eventDef;
	    };
	    return ExternalDropping;
	}(Interaction_1.default));
	exports.default = ExternalDropping;
	ListenerMixin_1.default.mixInto(ExternalDropping);
	/* External-Dragging-Element Data
	----------------------------------------------------------------------------------------------------------------------*/
	// Require all HTML5 data-* attributes used by FullCalendar to have this prefix.
	// A value of '' will query attributes like data-event. A value of 'fc' will query attributes like data-fc-event.
	exportHooks.dataAttrPrefix = '';
	// Given a jQuery element that might represent a dragged FullCalendar event, returns an intermediate data structure
	// to be used for Event Object creation.
	// A defined `.eventProps`, even when empty, indicates that an event should be created.
	function getDraggedElMeta(el) {
	    var prefix = exportHooks.dataAttrPrefix;
	    var eventProps; // properties for creating the event, not related to date/time
	    var startTime; // a Duration
	    var duration;
	    var stick;
	    if (prefix) {
	        prefix += '-';
	    }
	    eventProps = el.data(prefix + 'event') || null;
	    if (eventProps) {
	        if (typeof eventProps === 'object') {
	            eventProps = $.extend({}, eventProps); // make a copy
	        }
	        else { // something like 1 or true. still signal event creation
	            eventProps = {};
	        }
	        // pluck special-cased date/time properties
	        startTime = eventProps.start;
	        if (startTime == null) {
	            startTime = eventProps.time;
	        } // accept 'time' as well
	        duration = eventProps.duration;
	        stick = eventProps.stick;
	        delete eventProps.start;
	        delete eventProps.time;
	        delete eventProps.duration;
	        delete eventProps.stick;
	    }
	    // fallback to standalone attribute values for each of the date/time properties
	    if (startTime == null) {
	        startTime = el.data(prefix + 'start');
	    }
	    if (startTime == null) {
	        startTime = el.data(prefix + 'time');
	    } // accept 'time' as well
	    if (duration == null) {
	        duration = el.data(prefix + 'duration');
	    }
	    if (stick == null) {
	        stick = el.data(prefix + 'stick');
	    }
	    // massage into correct data types
	    startTime = startTime != null ? moment.duration(startTime) : null;
	    duration = duration != null ? moment.duration(duration) : null;
	    stick = Boolean(stick);
	    return { eventProps: eventProps, startTime: startTime, duration: duration, stick: stick };
	}
	
	
	/***/ }),
	/* 234 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var EventDefMutation_1 = __webpack_require__(39);
	var EventDefDateMutation_1 = __webpack_require__(40);
	var HitDragListener_1 = __webpack_require__(17);
	var Interaction_1 = __webpack_require__(14);
	var EventResizing = /** @class */ (function (_super) {
	    tslib_1.__extends(EventResizing, _super);
	    /*
	    component impements:
	      - bindSegHandlerToEl
	      - publiclyTrigger
	      - diffDates
	      - eventRangesToEventFootprints
	      - isEventInstanceGroupAllowed
	      - getSafeHitFootprint
	    */
	    function EventResizing(component, eventPointing) {
	        var _this = _super.call(this, component) || this;
	        _this.isResizing = false;
	        _this.eventPointing = eventPointing;
	        return _this;
	    }
	    EventResizing.prototype.end = function () {
	        if (this.dragListener) {
	            this.dragListener.endInteraction();
	        }
	    };
	    EventResizing.prototype.bindToEl = function (el) {
	        var component = this.component;
	        component.bindSegHandlerToEl(el, 'mousedown', this.handleMouseDown.bind(this));
	        component.bindSegHandlerToEl(el, 'touchstart', this.handleTouchStart.bind(this));
	    };
	    EventResizing.prototype.handleMouseDown = function (seg, ev) {
	        if (this.component.canStartResize(seg, ev)) {
	            this.buildDragListener(seg, $(ev.target).is('.fc-start-resizer'))
	                .startInteraction(ev, { distance: 5 });
	        }
	    };
	    EventResizing.prototype.handleTouchStart = function (seg, ev) {
	        if (this.component.canStartResize(seg, ev)) {
	            this.buildDragListener(seg, $(ev.target).is('.fc-start-resizer'))
	                .startInteraction(ev);
	        }
	    };
	    // Creates a listener that tracks the user as they resize an event segment.
	    // Generic enough to work with any type of Grid.
	    EventResizing.prototype.buildDragListener = function (seg, isStart) {
	        var _this = this;
	        var component = this.component;
	        var view = this.view;
	        var calendar = view.calendar;
	        var eventManager = calendar.eventManager;
	        var el = seg.el;
	        var eventDef = seg.footprint.eventDef;
	        var eventInstance = seg.footprint.eventInstance;
	        var isDragging;
	        var resizeMutation; // zoned event date properties. falsy if invalid resize
	        // Tracks mouse movement over the *grid's* coordinate map
	        var dragListener = this.dragListener = new HitDragListener_1.default(component, {
	            scroll: this.opt('dragScroll'),
	            subjectEl: el,
	            interactionStart: function () {
	                isDragging = false;
	            },
	            dragStart: function (ev) {
	                isDragging = true;
	                // ensure a mouseout on the manipulated event has been reported
	                _this.eventPointing.handleMouseout(seg, ev);
	                _this.segResizeStart(seg, ev);
	            },
	            hitOver: function (hit, isOrig, origHit) {
	                var isAllowed = true;
	                var origHitFootprint = component.getSafeHitFootprint(origHit);
	                var hitFootprint = component.getSafeHitFootprint(hit);
	                var mutatedEventInstanceGroup;
	                if (origHitFootprint && hitFootprint) {
	                    resizeMutation = isStart ?
	                        _this.computeEventStartResizeMutation(origHitFootprint, hitFootprint, seg.footprint) :
	                        _this.computeEventEndResizeMutation(origHitFootprint, hitFootprint, seg.footprint);
	                    if (resizeMutation) {
	                        mutatedEventInstanceGroup = eventManager.buildMutatedEventInstanceGroup(eventDef.id, resizeMutation);
	                        isAllowed = component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup);
	                    }
	                    else {
	                        isAllowed = false;
	                    }
	                }
	                else {
	                    isAllowed = false;
	                }
	                if (!isAllowed) {
	                    resizeMutation = null;
	                    util_1.disableCursor();
	                }
	                else if (resizeMutation.isEmpty()) {
	                    // no change. (FYI, event dates might have zones)
	                    resizeMutation = null;
	                }
	                if (resizeMutation) {
	                    view.hideEventsWithId(seg.footprint.eventDef.id);
	                    view.renderEventResize(component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, calendar)), seg);
	                }
	            },
	            hitOut: function () {
	                resizeMutation = null;
	            },
	            hitDone: function () {
	                view.unrenderEventResize(seg);
	                view.showEventsWithId(seg.footprint.eventDef.id);
	                util_1.enableCursor();
	            },
	            interactionEnd: function (ev) {
	                if (isDragging) {
	                    _this.segResizeStop(seg, ev);
	                }
	                if (resizeMutation) { // valid date to resize to?
	                    // no need to re-show original, will rerender all anyways. esp important if eventRenderWait
	                    view.reportEventResize(eventInstance, resizeMutation, el, ev);
	                }
	                _this.dragListener = null;
	            }
	        });
	        return dragListener;
	    };
	    // Called before event segment resizing starts
	    EventResizing.prototype.segResizeStart = function (seg, ev) {
	        this.isResizing = true;
	        this.component.publiclyTrigger('eventResizeStart', {
	            context: seg.el[0],
	            args: [
	                seg.footprint.getEventLegacy(),
	                ev,
	                {},
	                this.view
	            ]
	        });
	    };
	    // Called after event segment resizing stops
	    EventResizing.prototype.segResizeStop = function (seg, ev) {
	        this.isResizing = false;
	        this.component.publiclyTrigger('eventResizeStop', {
	            context: seg.el[0],
	            args: [
	                seg.footprint.getEventLegacy(),
	                ev,
	                {},
	                this.view
	            ]
	        });
	    };
	    // Returns new date-information for an event segment being resized from its start
	    EventResizing.prototype.computeEventStartResizeMutation = function (startFootprint, endFootprint, origEventFootprint) {
	        var origRange = origEventFootprint.componentFootprint.unzonedRange;
	        var startDelta = this.component.diffDates(endFootprint.unzonedRange.getStart(), startFootprint.unzonedRange.getStart());
	        var dateMutation;
	        var eventDefMutation;
	        if (origRange.getStart().add(startDelta) < origRange.getEnd()) {
	            dateMutation = new EventDefDateMutation_1.default();
	            dateMutation.setStartDelta(startDelta);
	            eventDefMutation = new EventDefMutation_1.default();
	            eventDefMutation.setDateMutation(dateMutation);
	            return eventDefMutation;
	        }
	        return false;
	    };
	    // Returns new date-information for an event segment being resized from its end
	    EventResizing.prototype.computeEventEndResizeMutation = function (startFootprint, endFootprint, origEventFootprint) {
	        var origRange = origEventFootprint.componentFootprint.unzonedRange;
	        var endDelta = this.component.diffDates(endFootprint.unzonedRange.getEnd(), startFootprint.unzonedRange.getEnd());
	        var dateMutation;
	        var eventDefMutation;
	        if (origRange.getEnd().add(endDelta) > origRange.getStart()) {
	            dateMutation = new EventDefDateMutation_1.default();
	            dateMutation.setEndDelta(endDelta);
	            eventDefMutation = new EventDefMutation_1.default();
	            eventDefMutation.setDateMutation(dateMutation);
	            return eventDefMutation;
	        }
	        return false;
	    };
	    return EventResizing;
	}(Interaction_1.default));
	exports.default = EventResizing;
	
	
	/***/ }),
	/* 235 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	var EventDefMutation_1 = __webpack_require__(39);
	var EventDefDateMutation_1 = __webpack_require__(40);
	var DragListener_1 = __webpack_require__(59);
	var HitDragListener_1 = __webpack_require__(17);
	var MouseFollower_1 = __webpack_require__(226);
	var Interaction_1 = __webpack_require__(14);
	var EventDragging = /** @class */ (function (_super) {
	    tslib_1.__extends(EventDragging, _super);
	    /*
	    component implements:
	      - bindSegHandlerToEl
	      - publiclyTrigger
	      - diffDates
	      - eventRangesToEventFootprints
	      - isEventInstanceGroupAllowed
	    */
	    function EventDragging(component, eventPointing) {
	        var _this = _super.call(this, component) || this;
	        _this.isDragging = false;
	        _this.eventPointing = eventPointing;
	        return _this;
	    }
	    EventDragging.prototype.end = function () {
	        if (this.dragListener) {
	            this.dragListener.endInteraction();
	        }
	    };
	    EventDragging.prototype.getSelectionDelay = function () {
	        var delay = this.opt('eventLongPressDelay');
	        if (delay == null) {
	            delay = this.opt('longPressDelay'); // fallback
	        }
	        return delay;
	    };
	    EventDragging.prototype.bindToEl = function (el) {
	        var component = this.component;
	        component.bindSegHandlerToEl(el, 'mousedown', this.handleMousedown.bind(this));
	        component.bindSegHandlerToEl(el, 'touchstart', this.handleTouchStart.bind(this));
	    };
	    EventDragging.prototype.handleMousedown = function (seg, ev) {
	        if (!this.component.shouldIgnoreMouse() &&
	            this.component.canStartDrag(seg, ev)) {
	            this.buildDragListener(seg).startInteraction(ev, { distance: 5 });
	        }
	    };
	    EventDragging.prototype.handleTouchStart = function (seg, ev) {
	        var component = this.component;
	        var settings = {
	            delay: this.view.isEventDefSelected(seg.footprint.eventDef) ? // already selected?
	                0 : this.getSelectionDelay()
	        };
	        if (component.canStartDrag(seg, ev)) {
	            this.buildDragListener(seg).startInteraction(ev, settings);
	        }
	        else if (component.canStartSelection(seg, ev)) {
	            this.buildSelectListener(seg).startInteraction(ev, settings);
	        }
	    };
	    // seg isn't draggable, but let's use a generic DragListener
	    // simply for the delay, so it can be selected.
	    // Has side effect of setting/unsetting `dragListener`
	    EventDragging.prototype.buildSelectListener = function (seg) {
	        var _this = this;
	        var view = this.view;
	        var eventDef = seg.footprint.eventDef;
	        var eventInstance = seg.footprint.eventInstance; // null for inverse-background events
	        if (this.dragListener) {
	            return this.dragListener;
	        }
	        var dragListener = this.dragListener = new DragListener_1.default({
	            dragStart: function (ev) {
	                if (dragListener.isTouch &&
	                    !view.isEventDefSelected(eventDef) &&
	                    eventInstance) {
	                    // if not previously selected, will fire after a delay. then, select the event
	                    view.selectEventInstance(eventInstance);
	                }
	            },
	            interactionEnd: function (ev) {
	                _this.dragListener = null;
	            }
	        });
	        return dragListener;
	    };
	    // Builds a listener that will track user-dragging on an event segment.
	    // Generic enough to work with any type of Grid.
	    // Has side effect of setting/unsetting `dragListener`
	    EventDragging.prototype.buildDragListener = function (seg) {
	        var _this = this;
	        var component = this.component;
	        var view = this.view;
	        var calendar = view.calendar;
	        var eventManager = calendar.eventManager;
	        var el = seg.el;
	        var eventDef = seg.footprint.eventDef;
	        var eventInstance = seg.footprint.eventInstance; // null for inverse-background events
	        var isDragging;
	        var mouseFollower; // A clone of the original element that will move with the mouse
	        var eventDefMutation;
	        if (this.dragListener) {
	            return this.dragListener;
	        }
	        // Tracks mouse movement over the *view's* coordinate map. Allows dragging and dropping between subcomponents
	        // of the view.
	        var dragListener = this.dragListener = new HitDragListener_1.default(view, {
	            scroll: this.opt('dragScroll'),
	            subjectEl: el,
	            subjectCenter: true,
	            interactionStart: function (ev) {
	                seg.component = component; // for renderDrag
	                isDragging = false;
	                mouseFollower = new MouseFollower_1.default(seg.el, {
	                    additionalClass: 'fc-dragging',
	                    parentEl: view.el,
	                    opacity: dragListener.isTouch ? null : _this.opt('dragOpacity'),
	                    revertDuration: _this.opt('dragRevertDuration'),
	                    zIndex: 2 // one above the .fc-view
	                });
	                mouseFollower.hide(); // don't show until we know this is a real drag
	                mouseFollower.start(ev);
	            },
	            dragStart: function (ev) {
	                if (dragListener.isTouch &&
	                    !view.isEventDefSelected(eventDef) &&
	                    eventInstance) {
	                    // if not previously selected, will fire after a delay. then, select the event
	                    view.selectEventInstance(eventInstance);
	                }
	                isDragging = true;
	                // ensure a mouseout on the manipulated event has been reported
	                _this.eventPointing.handleMouseout(seg, ev);
	                _this.segDragStart(seg, ev);
	                view.hideEventsWithId(seg.footprint.eventDef.id);
	            },
	            hitOver: function (hit, isOrig, origHit) {
	                var isAllowed = true;
	                var origFootprint;
	                var footprint;
	                var mutatedEventInstanceGroup;
	                // starting hit could be forced (DayGrid.limit)
	                if (seg.hit) {
	                    origHit = seg.hit;
	                }
	                // hit might not belong to this grid, so query origin grid
	                origFootprint = origHit.component.getSafeHitFootprint(origHit);
	                footprint = hit.component.getSafeHitFootprint(hit);
	                if (origFootprint && footprint) {
	                    eventDefMutation = _this.computeEventDropMutation(origFootprint, footprint, eventDef);
	                    if (eventDefMutation) {
	                        mutatedEventInstanceGroup = eventManager.buildMutatedEventInstanceGroup(eventDef.id, eventDefMutation);
	                        isAllowed = component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup);
	                    }
	                    else {
	                        isAllowed = false;
	                    }
	                }
	                else {
	                    isAllowed = false;
	                }
	                if (!isAllowed) {
	                    eventDefMutation = null;
	                    util_1.disableCursor();
	                }
	                // if a valid drop location, have the subclass render a visual indication
	                if (eventDefMutation &&
	                    view.renderDrag(// truthy if rendered something
	                    component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, calendar)), seg, dragListener.isTouch)) {
	                    mouseFollower.hide(); // if the subclass is already using a mock event "helper", hide our own
	                }
	                else {
	                    mouseFollower.show(); // otherwise, have the helper follow the mouse (no snapping)
	                }
	                if (isOrig) {
	                    // needs to have moved hits to be a valid drop
	                    eventDefMutation = null;
	                }
	            },
	            hitOut: function () {
	                view.unrenderDrag(seg); // unrender whatever was done in renderDrag
	                mouseFollower.show(); // show in case we are moving out of all hits
	                eventDefMutation = null;
	            },
	            hitDone: function () {
	                util_1.enableCursor();
	            },
	            interactionEnd: function (ev) {
	                delete seg.component; // prevent side effects
	                // do revert animation if hasn't changed. calls a callback when finished (whether animation or not)
	                mouseFollower.stop(!eventDefMutation, function () {
	                    if (isDragging) {
	                        view.unrenderDrag(seg);
	                        _this.segDragStop(seg, ev);
	                    }
	                    view.showEventsWithId(seg.footprint.eventDef.id);
	                    if (eventDefMutation) {
	                        // no need to re-show original, will rerender all anyways. esp important if eventRenderWait
	                        view.reportEventDrop(eventInstance, eventDefMutation, el, ev);
	                    }
	                });
	                _this.dragListener = null;
	            }
	        });
	        return dragListener;
	    };
	    // Called before event segment dragging starts
	    EventDragging.prototype.segDragStart = function (seg, ev) {
	        this.isDragging = true;
	        this.component.publiclyTrigger('eventDragStart', {
	            context: seg.el[0],
	            args: [
	                seg.footprint.getEventLegacy(),
	                ev,
	                {},
	                this.view
	            ]
	        });
	    };
	    // Called after event segment dragging stops
	    EventDragging.prototype.segDragStop = function (seg, ev) {
	        this.isDragging = false;
	        this.component.publiclyTrigger('eventDragStop', {
	            context: seg.el[0],
	            args: [
	                seg.footprint.getEventLegacy(),
	                ev,
	                {},
	                this.view
	            ]
	        });
	    };
	    // DOES NOT consider overlap/constraint
	    EventDragging.prototype.computeEventDropMutation = function (startFootprint, endFootprint, eventDef) {
	        var eventDefMutation = new EventDefMutation_1.default();
	        eventDefMutation.setDateMutation(this.computeEventDateMutation(startFootprint, endFootprint));
	        return eventDefMutation;
	    };
	    EventDragging.prototype.computeEventDateMutation = function (startFootprint, endFootprint) {
	        var date0 = startFootprint.unzonedRange.getStart();
	        var date1 = endFootprint.unzonedRange.getStart();
	        var clearEnd = false;
	        var forceTimed = false;
	        var forceAllDay = false;
	        var dateDelta;
	        var dateMutation;
	        if (startFootprint.isAllDay !== endFootprint.isAllDay) {
	            clearEnd = true;
	            if (endFootprint.isAllDay) {
	                forceAllDay = true;
	                date0.stripTime();
	            }
	            else {
	                forceTimed = true;
	            }
	        }
	        dateDelta = this.component.diffDates(date1, date0);
	        dateMutation = new EventDefDateMutation_1.default();
	        dateMutation.clearEnd = clearEnd;
	        dateMutation.forceTimed = forceTimed;
	        dateMutation.forceAllDay = forceAllDay;
	        dateMutation.setDateDelta(dateDelta);
	        return dateMutation;
	    };
	    return EventDragging;
	}(Interaction_1.default));
	exports.default = EventDragging;
	
	
	/***/ }),
	/* 236 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	var HitDragListener_1 = __webpack_require__(17);
	var ComponentFootprint_1 = __webpack_require__(12);
	var UnzonedRange_1 = __webpack_require__(5);
	var Interaction_1 = __webpack_require__(14);
	var DateSelecting = /** @class */ (function (_super) {
	    tslib_1.__extends(DateSelecting, _super);
	    /*
	    component must implement:
	      - bindDateHandlerToEl
	      - getSafeHitFootprint
	      - renderHighlight
	      - unrenderHighlight
	    */
	    function DateSelecting(component) {
	        var _this = _super.call(this, component) || this;
	        _this.dragListener = _this.buildDragListener();
	        return _this;
	    }
	    DateSelecting.prototype.end = function () {
	        this.dragListener.endInteraction();
	    };
	    DateSelecting.prototype.getDelay = function () {
	        var delay = this.opt('selectLongPressDelay');
	        if (delay == null) {
	            delay = this.opt('longPressDelay'); // fallback
	        }
	        return delay;
	    };
	    DateSelecting.prototype.bindToEl = function (el) {
	        var _this = this;
	        var component = this.component;
	        var dragListener = this.dragListener;
	        component.bindDateHandlerToEl(el, 'mousedown', function (ev) {
	            if (_this.opt('selectable') && !component.shouldIgnoreMouse()) {
	                dragListener.startInteraction(ev, {
	                    distance: _this.opt('selectMinDistance')
	                });
	            }
	        });
	        component.bindDateHandlerToEl(el, 'touchstart', function (ev) {
	            if (_this.opt('selectable') && !component.shouldIgnoreTouch()) {
	                dragListener.startInteraction(ev, {
	                    delay: _this.getDelay()
	                });
	            }
	        });
	        util_1.preventSelection(el);
	    };
	    // Creates a listener that tracks the user's drag across day elements, for day selecting.
	    DateSelecting.prototype.buildDragListener = function () {
	        var _this = this;
	        var component = this.component;
	        var selectionFootprint; // null if invalid selection
	        var dragListener = new HitDragListener_1.default(component, {
	            scroll: this.opt('dragScroll'),
	            interactionStart: function () {
	                selectionFootprint = null;
	            },
	            dragStart: function (ev) {
	                _this.view.unselect(ev); // since we could be rendering a new selection, we want to clear any old one
	            },
	            hitOver: function (hit, isOrig, origHit) {
	                var origHitFootprint;
	                var hitFootprint;
	                if (origHit) { // click needs to have started on a hit
	                    origHitFootprint = component.getSafeHitFootprint(origHit);
	                    hitFootprint = component.getSafeHitFootprint(hit);
	                    if (origHitFootprint && hitFootprint) {
	                        selectionFootprint = _this.computeSelection(origHitFootprint, hitFootprint);
	                    }
	                    else {
	                        selectionFootprint = null;
	                    }
	                    if (selectionFootprint) {
	                        component.renderSelectionFootprint(selectionFootprint);
	                    }
	                    else if (selectionFootprint === false) {
	                        util_1.disableCursor();
	                    }
	                }
	            },
	            hitOut: function () {
	                selectionFootprint = null;
	                component.unrenderSelection();
	            },
	            hitDone: function () {
	                util_1.enableCursor();
	            },
	            interactionEnd: function (ev, isCancelled) {
	                if (!isCancelled && selectionFootprint) {
	                    // the selection will already have been rendered. just report it
	                    _this.view.reportSelection(selectionFootprint, ev);
	                }
	            }
	        });
	        return dragListener;
	    };
	    // Given the first and last date-spans of a selection, returns another date-span object.
	    // Subclasses can override and provide additional data in the span object. Will be passed to renderSelectionFootprint().
	    // Will return false if the selection is invalid and this should be indicated to the user.
	    // Will return null/undefined if a selection invalid but no error should be reported.
	    DateSelecting.prototype.computeSelection = function (footprint0, footprint1) {
	        var wholeFootprint = this.computeSelectionFootprint(footprint0, footprint1);
	        if (wholeFootprint && !this.isSelectionFootprintAllowed(wholeFootprint)) {
	            return false;
	        }
	        return wholeFootprint;
	    };
	    // Given two spans, must return the combination of the two.
	    // TODO: do this separation of concerns (combining VS validation) for event dnd/resize too.
	    // Assumes both footprints are non-open-ended.
	    DateSelecting.prototype.computeSelectionFootprint = function (footprint0, footprint1) {
	        var ms = [
	            footprint0.unzonedRange.startMs,
	            footprint0.unzonedRange.endMs,
	            footprint1.unzonedRange.startMs,
	            footprint1.unzonedRange.endMs
	        ];
	        ms.sort(util_1.compareNumbers);
	        return new ComponentFootprint_1.default(new UnzonedRange_1.default(ms[0], ms[3]), footprint0.isAllDay);
	    };
	    DateSelecting.prototype.isSelectionFootprintAllowed = function (componentFootprint) {
	        return this.component.dateProfile.validUnzonedRange.containsRange(componentFootprint.unzonedRange) &&
	            this.view.calendar.constraints.isSelectionFootprintAllowed(componentFootprint);
	    };
	    return DateSelecting;
	}(Interaction_1.default));
	exports.default = DateSelecting;
	
	
	/***/ }),
	/* 237 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var HitDragListener_1 = __webpack_require__(17);
	var Interaction_1 = __webpack_require__(14);
	var DateClicking = /** @class */ (function (_super) {
	    tslib_1.__extends(DateClicking, _super);
	    /*
	    component must implement:
	      - bindDateHandlerToEl
	      - getSafeHitFootprint
	      - getHitEl
	    */
	    function DateClicking(component) {
	        var _this = _super.call(this, component) || this;
	        _this.dragListener = _this.buildDragListener();
	        return _this;
	    }
	    DateClicking.prototype.end = function () {
	        this.dragListener.endInteraction();
	    };
	    DateClicking.prototype.bindToEl = function (el) {
	        var component = this.component;
	        var dragListener = this.dragListener;
	        component.bindDateHandlerToEl(el, 'mousedown', function (ev) {
	            if (!component.shouldIgnoreMouse()) {
	                dragListener.startInteraction(ev);
	            }
	        });
	        component.bindDateHandlerToEl(el, 'touchstart', function (ev) {
	            if (!component.shouldIgnoreTouch()) {
	                dragListener.startInteraction(ev);
	            }
	        });
	    };
	    // Creates a listener that tracks the user's drag across day elements, for day clicking.
	    DateClicking.prototype.buildDragListener = function () {
	        var _this = this;
	        var component = this.component;
	        var dayClickHit; // null if invalid dayClick
	        var dragListener = new HitDragListener_1.default(component, {
	            scroll: this.opt('dragScroll'),
	            interactionStart: function () {
	                dayClickHit = dragListener.origHit;
	            },
	            hitOver: function (hit, isOrig, origHit) {
	                // if user dragged to another cell at any point, it can no longer be a dayClick
	                if (!isOrig) {
	                    dayClickHit = null;
	                }
	            },
	            hitOut: function () {
	                dayClickHit = null;
	            },
	            interactionEnd: function (ev, isCancelled) {
	                var componentFootprint;
	                if (!isCancelled && dayClickHit) {
	                    componentFootprint = component.getSafeHitFootprint(dayClickHit);
	                    if (componentFootprint) {
	                        _this.view.triggerDayClick(componentFootprint, component.getHitEl(dayClickHit), ev);
	                    }
	                }
	            }
	        });
	        // because dragListener won't be called with any time delay, "dragging" will begin immediately,
	        // which will kill any touchmoving/scrolling. Prevent this.
	        dragListener.shouldCancelTouchScroll = false;
	        dragListener.scrollAlwaysKills = true;
	        return dragListener;
	    };
	    return DateClicking;
	}(Interaction_1.default));
	exports.default = DateClicking;
	
	
	/***/ }),
	/* 238 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var moment = __webpack_require__(0);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var Scroller_1 = __webpack_require__(41);
	var View_1 = __webpack_require__(43);
	var TimeGrid_1 = __webpack_require__(239);
	var DayGrid_1 = __webpack_require__(66);
	var AGENDA_ALL_DAY_EVENT_LIMIT = 5;
	var agendaTimeGridMethods;
	var agendaDayGridMethods;
	/* An abstract class for all agenda-related views. Displays one more columns with time slots running vertically.
	----------------------------------------------------------------------------------------------------------------------*/
	// Is a manager for the TimeGrid subcomponent and possibly the DayGrid subcomponent (if allDaySlot is on).
	// Responsible for managing width/height.
	var AgendaView = /** @class */ (function (_super) {
	    tslib_1.__extends(AgendaView, _super);
	    function AgendaView(calendar, viewSpec) {
	        var _this = _super.call(this, calendar, viewSpec) || this;
	        _this.usesMinMaxTime = true; // indicates that minTime/maxTime affects rendering
	        _this.timeGrid = _this.instantiateTimeGrid();
	        _this.addChild(_this.timeGrid);
	        if (_this.opt('allDaySlot')) { // should we display the "all-day" area?
	            _this.dayGrid = _this.instantiateDayGrid(); // the all-day subcomponent of this view
	            _this.addChild(_this.dayGrid);
	        }
	        _this.scroller = new Scroller_1.default({
	            overflowX: 'hidden',
	            overflowY: 'auto'
	        });
	        return _this;
	    }
	    // Instantiates the TimeGrid object this view needs. Draws from this.timeGridClass
	    AgendaView.prototype.instantiateTimeGrid = function () {
	        var timeGrid = new this.timeGridClass(this);
	        util_1.copyOwnProps(agendaTimeGridMethods, timeGrid);
	        return timeGrid;
	    };
	    // Instantiates the DayGrid object this view might need. Draws from this.dayGridClass
	    AgendaView.prototype.instantiateDayGrid = function () {
	        var dayGrid = new this.dayGridClass(this);
	        util_1.copyOwnProps(agendaDayGridMethods, dayGrid);
	        return dayGrid;
	    };
	    /* Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    AgendaView.prototype.renderSkeleton = function () {
	        var timeGridWrapEl;
	        var timeGridEl;
	        this.el.addClass('fc-agenda-view').html(this.renderSkeletonHtml());
	        this.scroller.render();
	        timeGridWrapEl = this.scroller.el.addClass('fc-time-grid-container');
	        timeGridEl = $('<div class="fc-time-grid">').appendTo(timeGridWrapEl);
	        this.el.find('.fc-body > tr > td').append(timeGridWrapEl);
	        this.timeGrid.headContainerEl = this.el.find('.fc-head-container');
	        this.timeGrid.setElement(timeGridEl);
	        if (this.dayGrid) {
	            this.dayGrid.setElement(this.el.find('.fc-day-grid'));
	            // have the day-grid extend it's coordinate area over the <hr> dividing the two grids
	            this.dayGrid.bottomCoordPadding = this.dayGrid.el.next('hr').outerHeight();
	        }
	    };
	    AgendaView.prototype.unrenderSkeleton = function () {
	        this.timeGrid.removeElement();
	        if (this.dayGrid) {
	            this.dayGrid.removeElement();
	        }
	        this.scroller.destroy();
	    };
	    // Builds the HTML skeleton for the view.
	    // The day-grid and time-grid components will render inside containers defined by this HTML.
	    AgendaView.prototype.renderSkeletonHtml = function () {
	        var theme = this.calendar.theme;
	        return '' +
	            '<table class="' + theme.getClass('tableGrid') + '">' +
	            (this.opt('columnHeader') ?
	                '<thead class="fc-head">' +
	                    '<tr>' +
	                    '<td class="fc-head-container ' + theme.getClass('widgetHeader') + '">&nbsp;</td>' +
	                    '</tr>' +
	                    '</thead>' :
	                '') +
	            '<tbody class="fc-body">' +
	            '<tr>' +
	            '<td class="' + theme.getClass('widgetContent') + '">' +
	            (this.dayGrid ?
	                '<div class="fc-day-grid"></div>' +
	                    '<hr class="fc-divider ' + theme.getClass('widgetHeader') + '"></hr>' :
	                '') +
	            '</td>' +
	            '</tr>' +
	            '</tbody>' +
	            '</table>';
	    };
	    // Generates an HTML attribute string for setting the width of the axis, if it is known
	    AgendaView.prototype.axisStyleAttr = function () {
	        if (this.axisWidth != null) {
	            return 'style="width:' + this.axisWidth + 'px"';
	        }
	        return '';
	    };
	    /* Now Indicator
	    ------------------------------------------------------------------------------------------------------------------*/
	    AgendaView.prototype.getNowIndicatorUnit = function () {
	        return this.timeGrid.getNowIndicatorUnit();
	    };
	    /* Dimensions
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Adjusts the vertical dimensions of the view to the specified values
	    AgendaView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
	        var eventLimit;
	        var scrollerHeight;
	        var scrollbarWidths;
	        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
	        // make all axis cells line up, and record the width so newly created axis cells will have it
	        this.axisWidth = util_1.matchCellWidths(this.el.find('.fc-axis'));
	        // hack to give the view some height prior to timeGrid's columns being rendered
	        // TODO: separate setting height from scroller VS timeGrid.
	        if (!this.timeGrid.colEls) {
	            if (!isAuto) {
	                scrollerHeight = this.computeScrollerHeight(totalHeight);
	                this.scroller.setHeight(scrollerHeight);
	            }
	            return;
	        }
	        // set of fake row elements that must compensate when scroller has scrollbars
	        var noScrollRowEls = this.el.find('.fc-row:not(.fc-scroller *)');
	        // reset all dimensions back to the original state
	        this.timeGrid.bottomRuleEl.hide(); // .show() will be called later if this <hr> is necessary
	        this.scroller.clear(); // sets height to 'auto' and clears overflow
	        util_1.uncompensateScroll(noScrollRowEls);
	        // limit number of events in the all-day area
	        if (this.dayGrid) {
	            this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed
	            eventLimit = this.opt('eventLimit');
	            if (eventLimit && typeof eventLimit !== 'number') {
	                eventLimit = AGENDA_ALL_DAY_EVENT_LIMIT; // make sure "auto" goes to a real number
	            }
	            if (eventLimit) {
	                this.dayGrid.limitRows(eventLimit);
	            }
	        }
	        if (!isAuto) { // should we force dimensions of the scroll container?
	            scrollerHeight = this.computeScrollerHeight(totalHeight);
	            this.scroller.setHeight(scrollerHeight);
	            scrollbarWidths = this.scroller.getScrollbarWidths();
	            if (scrollbarWidths.left || scrollbarWidths.right) { // using scrollbars?
	                // make the all-day and header rows lines up
	                util_1.compensateScroll(noScrollRowEls, scrollbarWidths);
	                // the scrollbar compensation might have changed text flow, which might affect height, so recalculate
	                // and reapply the desired height to the scroller.
	                scrollerHeight = this.computeScrollerHeight(totalHeight);
	                this.scroller.setHeight(scrollerHeight);
	            }
	            // guarantees the same scrollbar widths
	            this.scroller.lockOverflow(scrollbarWidths);
	            // if there's any space below the slats, show the horizontal rule.
	            // this won't cause any new overflow, because lockOverflow already called.
	            if (this.timeGrid.getTotalSlatHeight() < scrollerHeight) {
	                this.timeGrid.bottomRuleEl.show();
	            }
	        }
	    };
	    // given a desired total height of the view, returns what the height of the scroller should be
	    AgendaView.prototype.computeScrollerHeight = function (totalHeight) {
	        return totalHeight -
	            util_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
	    };
	    /* Scroll
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Computes the initial pre-configured scroll state prior to allowing the user to change it
	    AgendaView.prototype.computeInitialDateScroll = function () {
	        var scrollTime = moment.duration(this.opt('scrollTime'));
	        var top = this.timeGrid.computeTimeTop(scrollTime);
	        // zoom can give weird floating-point values. rather scroll a little bit further
	        top = Math.ceil(top);
	        if (top) {
	            top++; // to overcome top border that slots beyond the first have. looks better
	        }
	        return { top: top };
	    };
	    AgendaView.prototype.queryDateScroll = function () {
	        return { top: this.scroller.getScrollTop() };
	    };
	    AgendaView.prototype.applyDateScroll = function (scroll) {
	        if (scroll.top !== undefined) {
	            this.scroller.setScrollTop(scroll.top);
	        }
	    };
	    /* Hit Areas
	    ------------------------------------------------------------------------------------------------------------------*/
	    // forward all hit-related method calls to the grids (dayGrid might not be defined)
	    AgendaView.prototype.getHitFootprint = function (hit) {
	        // TODO: hit.component is set as a hack to identify where the hit came from
	        return hit.component.getHitFootprint(hit);
	    };
	    AgendaView.prototype.getHitEl = function (hit) {
	        // TODO: hit.component is set as a hack to identify where the hit came from
	        return hit.component.getHitEl(hit);
	    };
	    /* Event Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    AgendaView.prototype.executeEventRender = function (eventsPayload) {
	        var dayEventsPayload = {};
	        var timedEventsPayload = {};
	        var id;
	        var eventInstanceGroup;
	        // separate the events into all-day and timed
	        for (id in eventsPayload) {
	            eventInstanceGroup = eventsPayload[id];
	            if (eventInstanceGroup.getEventDef().isAllDay()) {
	                dayEventsPayload[id] = eventInstanceGroup;
	            }
	            else {
	                timedEventsPayload[id] = eventInstanceGroup;
	            }
	        }
	        this.timeGrid.executeEventRender(timedEventsPayload);
	        if (this.dayGrid) {
	            this.dayGrid.executeEventRender(dayEventsPayload);
	        }
	    };
	    /* Dragging/Resizing Routing
	    ------------------------------------------------------------------------------------------------------------------*/
	    // A returned value of `true` signals that a mock "helper" event has been rendered.
	    AgendaView.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
	        var groups = groupEventFootprintsByAllDay(eventFootprints);
	        var renderedHelper = false;
	        renderedHelper = this.timeGrid.renderDrag(groups.timed, seg, isTouch);
	        if (this.dayGrid) {
	            renderedHelper = this.dayGrid.renderDrag(groups.allDay, seg, isTouch) || renderedHelper;
	        }
	        return renderedHelper;
	    };
	    AgendaView.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
	        var groups = groupEventFootprintsByAllDay(eventFootprints);
	        this.timeGrid.renderEventResize(groups.timed, seg, isTouch);
	        if (this.dayGrid) {
	            this.dayGrid.renderEventResize(groups.allDay, seg, isTouch);
	        }
	    };
	    /* Selection
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Renders a visual indication of a selection
	    AgendaView.prototype.renderSelectionFootprint = function (componentFootprint) {
	        if (!componentFootprint.isAllDay) {
	            this.timeGrid.renderSelectionFootprint(componentFootprint);
	        }
	        else if (this.dayGrid) {
	            this.dayGrid.renderSelectionFootprint(componentFootprint);
	        }
	    };
	    return AgendaView;
	}(View_1.default));
	exports.default = AgendaView;
	AgendaView.prototype.timeGridClass = TimeGrid_1.default;
	AgendaView.prototype.dayGridClass = DayGrid_1.default;
	// Will customize the rendering behavior of the AgendaView's timeGrid
	agendaTimeGridMethods = {
	    // Generates the HTML that will go before the day-of week header cells
	    renderHeadIntroHtml: function () {
	        var view = this.view;
	        var calendar = view.calendar;
	        var weekStart = calendar.msToUtcMoment(this.dateProfile.renderUnzonedRange.startMs, true);
	        var weekText;
	        if (this.opt('weekNumbers')) {
	            weekText = weekStart.format(this.opt('smallWeekFormat'));
	            return '' +
	                '<th class="fc-axis fc-week-number ' + calendar.theme.getClass('widgetHeader') + '" ' + view.axisStyleAttr() + '>' +
	                view.buildGotoAnchorHtml(// aside from link, important for matchCellWidths
	                { date: weekStart, type: 'week', forceOff: this.colCnt > 1 }, util_1.htmlEscape(weekText) // inner HTML
	                ) +
	                '</th>';
	        }
	        else {
	            return '<th class="fc-axis ' + calendar.theme.getClass('widgetHeader') + '" ' + view.axisStyleAttr() + '></th>';
	        }
	    },
	    // Generates the HTML that goes before the bg of the TimeGrid slot area. Long vertical column.
	    renderBgIntroHtml: function () {
	        var view = this.view;
	        return '<td class="fc-axis ' + view.calendar.theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '></td>';
	    },
	    // Generates the HTML that goes before all other types of cells.
	    // Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
	    renderIntroHtml: function () {
	        var view = this.view;
	        return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
	    }
	};
	// Will customize the rendering behavior of the AgendaView's dayGrid
	agendaDayGridMethods = {
	    // Generates the HTML that goes before the all-day cells
	    renderBgIntroHtml: function () {
	        var view = this.view;
	        return '' +
	            '<td class="fc-axis ' + view.calendar.theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '>' +
	            '<span>' + // needed for matchCellWidths
	            view.getAllDayHtml() +
	            '</span>' +
	            '</td>';
	    },
	    // Generates the HTML that goes before all other types of cells.
	    // Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
	    renderIntroHtml: function () {
	        var view = this.view;
	        return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
	    }
	};
	function groupEventFootprintsByAllDay(eventFootprints) {
	    var allDay = [];
	    var timed = [];
	    var i;
	    for (i = 0; i < eventFootprints.length; i++) {
	        if (eventFootprints[i].componentFootprint.isAllDay) {
	            allDay.push(eventFootprints[i]);
	        }
	        else {
	            timed.push(eventFootprints[i]);
	        }
	    }
	    return { allDay: allDay, timed: timed };
	}
	
	
	/***/ }),
	/* 239 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var moment = __webpack_require__(0);
	var util_1 = __webpack_require__(4);
	var InteractiveDateComponent_1 = __webpack_require__(42);
	var BusinessHourRenderer_1 = __webpack_require__(61);
	var StandardInteractionsMixin_1 = __webpack_require__(65);
	var DayTableMixin_1 = __webpack_require__(60);
	var CoordCache_1 = __webpack_require__(58);
	var UnzonedRange_1 = __webpack_require__(5);
	var ComponentFootprint_1 = __webpack_require__(12);
	var TimeGridEventRenderer_1 = __webpack_require__(240);
	var TimeGridHelperRenderer_1 = __webpack_require__(241);
	var TimeGridFillRenderer_1 = __webpack_require__(242);
	/* A component that renders one or more columns of vertical time slots
	----------------------------------------------------------------------------------------------------------------------*/
	// We mixin DayTable, even though there is only a single row of days
	// potential nice values for the slot-duration and interval-duration
	// from largest to smallest
	var AGENDA_STOCK_SUB_DURATIONS = [
	    { hours: 1 },
	    { minutes: 30 },
	    { minutes: 15 },
	    { seconds: 30 },
	    { seconds: 15 }
	];
	var TimeGrid = /** @class */ (function (_super) {
	    tslib_1.__extends(TimeGrid, _super);
	    function TimeGrid(view) {
	        var _this = _super.call(this, view) || this;
	        _this.processOptions();
	        return _this;
	    }
	    // Slices up the given span (unzoned start/end with other misc data) into an array of segments
	    TimeGrid.prototype.componentFootprintToSegs = function (componentFootprint) {
	        var segs = this.sliceRangeByTimes(componentFootprint.unzonedRange);
	        var i;
	        for (i = 0; i < segs.length; i++) {
	            if (this.isRTL) {
	                segs[i].col = this.daysPerRow - 1 - segs[i].dayIndex;
	            }
	            else {
	                segs[i].col = segs[i].dayIndex;
	            }
	        }
	        return segs;
	    };
	    /* Date Handling
	    ------------------------------------------------------------------------------------------------------------------*/
	    TimeGrid.prototype.sliceRangeByTimes = function (unzonedRange) {
	        var segs = [];
	        var segRange;
	        var dayIndex;
	        for (dayIndex = 0; dayIndex < this.daysPerRow; dayIndex++) {
	            segRange = unzonedRange.intersect(this.dayRanges[dayIndex]);
	            if (segRange) {
	                segs.push({
	                    startMs: segRange.startMs,
	                    endMs: segRange.endMs,
	                    isStart: segRange.isStart,
	                    isEnd: segRange.isEnd,
	                    dayIndex: dayIndex
	                });
	            }
	        }
	        return segs;
	    };
	    /* Options
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Parses various options into properties of this object
	    TimeGrid.prototype.processOptions = function () {
	        var slotDuration = this.opt('slotDuration');
	        var snapDuration = this.opt('snapDuration');
	        var input;
	        slotDuration = moment.duration(slotDuration);
	        snapDuration = snapDuration ? moment.duration(snapDuration) : slotDuration;
	        this.slotDuration = slotDuration;
	        this.snapDuration = snapDuration;
	        this.snapsPerSlot = slotDuration / snapDuration; // TODO: ensure an integer multiple?
	        // might be an array value (for TimelineView).
	        // if so, getting the most granular entry (the last one probably).
	        input = this.opt('slotLabelFormat');
	        if ($.isArray(input)) {
	            input = input[input.length - 1];
	        }
	        this.labelFormat = input ||
	            this.opt('smallTimeFormat'); // the computed default
	        input = this.opt('slotLabelInterval');
	        this.labelInterval = input ?
	            moment.duration(input) :
	            this.computeLabelInterval(slotDuration);
	    };
	    // Computes an automatic value for slotLabelInterval
	    TimeGrid.prototype.computeLabelInterval = function (slotDuration) {
	        var i;
	        var labelInterval;
	        var slotsPerLabel;
	        // find the smallest stock label interval that results in more than one slots-per-label
	        for (i = AGENDA_STOCK_SUB_DURATIONS.length - 1; i >= 0; i--) {
	            labelInterval = moment.duration(AGENDA_STOCK_SUB_DURATIONS[i]);
	            slotsPerLabel = util_1.divideDurationByDuration(labelInterval, slotDuration);
	            if (util_1.isInt(slotsPerLabel) && slotsPerLabel > 1) {
	                return labelInterval;
	            }
	        }
	        return moment.duration(slotDuration); // fall back. clone
	    };
	    /* Date Rendering
	    ------------------------------------------------------------------------------------------------------------------*/
	    TimeGrid.prototype.renderDates = function (dateProfile) {
	        this.dateProfile = dateProfile;
	        this.updateDayTable();
	        this.renderSlats();
	        this.renderColumns();
	    };
	    TimeGrid.prototype.unrenderDates = function () {
	        // this.unrenderSlats(); // don't need this because repeated .html() calls clear
	        this.unrenderColumns();
	    };
	    TimeGrid.prototype.renderSkeleton = function () {
	        var theme = this.view.calendar.theme;
	        this.el.html('<div class="fc-bg"></div>' +
	            '<div class="fc-slats"></div>' +
	            '<hr class="fc-divider ' + theme.getClass('widgetHeader') + '" style="display:none"></hr>');
	        this.bottomRuleEl = this.el.find('hr');
	    };
	    TimeGrid.prototype.renderSlats = function () {
	        var theme = this.view.calendar.theme;
	        this.slatContainerEl = this.el.find('> .fc-slats')
	            .html(// avoids needing ::unrenderSlats()
	        '<table class="' + theme.getClass('tableGrid') + '">' +
	            this.renderSlatRowHtml() +
	            '</table>');
	        this.slatEls = this.slatContainerEl.find('tr');
	        this.slatCoordCache = new CoordCache_1.default({
	            els: this.slatEls,
	            isVertical: true
	        });
	    };
	    // Generates the HTML for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
	    TimeGrid.prototype.renderSlatRowHtml = function () {
	        var view = this.view;
	        var calendar = view.calendar;
	        var theme = calendar.theme;
	        var isRTL = this.isRTL;
	        var dateProfile = this.dateProfile;
	        var html = '';
	        var slotTime = moment.duration(+dateProfile.minTime); // wish there was .clone() for durations
	        var slotIterator = moment.duration(0);
	        var slotDate; // will be on the view's first day, but we only care about its time
	        var isLabeled;
	        var axisHtml;
	        // Calculate the time for each slot
	        while (slotTime < dateProfile.maxTime) {
	            slotDate = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.startMs).time(slotTime);
	            isLabeled = util_1.isInt(util_1.divideDurationByDuration(slotIterator, this.labelInterval));
	            axisHtml =
	                '<td class="fc-axis fc-time ' + theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '>' +
	                    (isLabeled ?
	                        '<span>' + // for matchCellWidths
	                            util_1.htmlEscape(slotDate.format(this.labelFormat)) +
	                            '</span>' :
	                        '') +
	                    '</td>';
	            html +=
	                '<tr data-time="' + slotDate.format('HH:mm:ss') + '"' +
	                    (isLabeled ? '' : ' class="fc-minor"') +
	                    '>' +
	                    (!isRTL ? axisHtml : '') +
	                    '<td class="' + theme.getClass('widgetContent') + '"></td>' +
	                    (isRTL ? axisHtml : '') +
	                    '</tr>';
	            slotTime.add(this.slotDuration);
	            slotIterator.add(this.slotDuration);
	        }
	        return html;
	    };
	    TimeGrid.prototype.renderColumns = function () {
	        var dateProfile = this.dateProfile;
	        var theme = this.view.calendar.theme;
	        this.dayRanges = this.dayDates.map(function (dayDate) {
	            return new UnzonedRange_1.default(dayDate.clone().add(dateProfile.minTime), dayDate.clone().add(dateProfile.maxTime));
	        });
	        if (this.headContainerEl) {
	            this.headContainerEl.html(this.renderHeadHtml());
	        }
	        this.el.find('> .fc-bg').html('<table class="' + theme.getClass('tableGrid') + '">' +
	            this.renderBgTrHtml(0) + // row=0
	            '</table>');
	        this.colEls = this.el.find('.fc-day, .fc-disabled-day');
	        this.colCoordCache = new CoordCache_1.default({
	            els: this.colEls,
	            isHorizontal: true
	        });
	        this.renderContentSkeleton();
	    };
	    TimeGrid.prototype.unrenderColumns = function () {
	        this.unrenderContentSkeleton();
	    };
	    /* Content Skeleton
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Renders the DOM that the view's content will live in
	    TimeGrid.prototype.renderContentSkeleton = function () {
	        var cellHtml = '';
	        var i;
	        var skeletonEl;
	        for (i = 0; i < this.colCnt; i++) {
	            cellHtml +=
	                '<td>' +
	                    '<div class="fc-content-col">' +
	                    '<div class="fc-event-container fc-helper-container"></div>' +
	                    '<div class="fc-event-container"></div>' +
	                    '<div class="fc-highlight-container"></div>' +
	                    '<div class="fc-bgevent-container"></div>' +
	                    '<div class="fc-business-container"></div>' +
	                    '</div>' +
	                    '</td>';
	        }
	        skeletonEl = this.contentSkeletonEl = $('<div class="fc-content-skeleton">' +
	            '<table>' +
	            '<tr>' + cellHtml + '</tr>' +
	            '</table>' +
	            '</div>');
	        this.colContainerEls = skeletonEl.find('.fc-content-col');
	        this.helperContainerEls = skeletonEl.find('.fc-helper-container');
	        this.fgContainerEls = skeletonEl.find('.fc-event-container:not(.fc-helper-container)');
	        this.bgContainerEls = skeletonEl.find('.fc-bgevent-container');
	        this.highlightContainerEls = skeletonEl.find('.fc-highlight-container');
	        this.businessContainerEls = skeletonEl.find('.fc-business-container');
	        this.bookendCells(skeletonEl.find('tr')); // TODO: do this on string level
	        this.el.append(skeletonEl);
	    };
	    TimeGrid.prototype.unrenderContentSkeleton = function () {
	        if (this.contentSkeletonEl) { // defensive :(
	            this.contentSkeletonEl.remove();
	            this.contentSkeletonEl = null;
	            this.colContainerEls = null;
	            this.helperContainerEls = null;
	            this.fgContainerEls = null;
	            this.bgContainerEls = null;
	            this.highlightContainerEls = null;
	            this.businessContainerEls = null;
	        }
	    };
	    // Given a flat array of segments, return an array of sub-arrays, grouped by each segment's col
	    TimeGrid.prototype.groupSegsByCol = function (segs) {
	        var segsByCol = [];
	        var i;
	        for (i = 0; i < this.colCnt; i++) {
	            segsByCol.push([]);
	        }
	        for (i = 0; i < segs.length; i++) {
	            segsByCol[segs[i].col].push(segs[i]);
	        }
	        return segsByCol;
	    };
	    // Given segments grouped by column, insert the segments' elements into a parallel array of container
	    // elements, each living within a column.
	    TimeGrid.prototype.attachSegsByCol = function (segsByCol, containerEls) {
	        var col;
	        var segs;
	        var i;
	        for (col = 0; col < this.colCnt; col++) { // iterate each column grouping
	            segs = segsByCol[col];
	            for (i = 0; i < segs.length; i++) {
	                containerEls.eq(col).append(segs[i].el);
	            }
	        }
	    };
	    /* Now Indicator
	    ------------------------------------------------------------------------------------------------------------------*/
	    TimeGrid.prototype.getNowIndicatorUnit = function () {
	        return 'minute'; // will refresh on the minute
	    };
	    TimeGrid.prototype.renderNowIndicator = function (date) {
	        // HACK: if date columns not ready for some reason (scheduler)
	        if (!this.colContainerEls) {
	            return;
	        }
	        // seg system might be overkill, but it handles scenario where line needs to be rendered
	        //  more than once because of columns with the same date (resources columns for example)
	        var segs = this.componentFootprintToSegs(new ComponentFootprint_1.default(new UnzonedRange_1.default(date, date.valueOf() + 1), // protect against null range
	        false // all-day
	        ));
	        var top = this.computeDateTop(date, date);
	        var nodes = [];
	        var i;
	        // render lines within the columns
	        for (i = 0; i < segs.length; i++) {
	            nodes.push($('<div class="fc-now-indicator fc-now-indicator-line"></div>')
	                .css('top', top)
	                .appendTo(this.colContainerEls.eq(segs[i].col))[0]);
	        }
	        // render an arrow over the axis
	        if (segs.length > 0) { // is the current time in view?
	            nodes.push($('<div class="fc-now-indicator fc-now-indicator-arrow"></div>')
	                .css('top', top)
	                .appendTo(this.el.find('.fc-content-skeleton'))[0]);
	        }
	        this.nowIndicatorEls = $(nodes);
	    };
	    TimeGrid.prototype.unrenderNowIndicator = function () {
	        if (this.nowIndicatorEls) {
	            this.nowIndicatorEls.remove();
	            this.nowIndicatorEls = null;
	        }
	    };
	    /* Coordinates
	    ------------------------------------------------------------------------------------------------------------------*/
	    TimeGrid.prototype.updateSize = function (totalHeight, isAuto, isResize) {
	        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
	        this.slatCoordCache.build();
	        if (isResize) {
	            this.updateSegVerticals([].concat(this.eventRenderer.getSegs(), this.businessSegs || []));
	        }
	    };
	    TimeGrid.prototype.getTotalSlatHeight = function () {
	        return this.slatContainerEl.outerHeight();
	    };
	    // Computes the top coordinate, relative to the bounds of the grid, of the given date.
	    // `ms` can be a millisecond UTC time OR a UTC moment.
	    // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
	    TimeGrid.prototype.computeDateTop = function (ms, startOfDayDate) {
	        return this.computeTimeTop(moment.duration(ms - startOfDayDate.clone().stripTime()));
	    };
	    // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
	    TimeGrid.prototype.computeTimeTop = function (time) {
	        var len = this.slatEls.length;
	        var dateProfile = this.dateProfile;
	        var slatCoverage = (time - dateProfile.minTime) / this.slotDuration; // floating-point value of # of slots covered
	        var slatIndex;
	        var slatRemainder;
	        // compute a floating-point number for how many slats should be progressed through.
	        // from 0 to number of slats (inclusive)
	        // constrained because minTime/maxTime might be customized.
	        slatCoverage = Math.max(0, slatCoverage);
	        slatCoverage = Math.min(len, slatCoverage);
	        // an integer index of the furthest whole slat
	        // from 0 to number slats (*exclusive*, so len-1)
	        slatIndex = Math.floor(slatCoverage);
	        slatIndex = Math.min(slatIndex, len - 1);
	        // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
	        // could be 1.0 if slatCoverage is covering *all* the slots
	        slatRemainder = slatCoverage - slatIndex;
	        return this.slatCoordCache.getTopPosition(slatIndex) +
	            this.slatCoordCache.getHeight(slatIndex) * slatRemainder;
	    };
	    // Refreshes the CSS top/bottom coordinates for each segment element.
	    // Works when called after initial render, after a window resize/zoom for example.
	    TimeGrid.prototype.updateSegVerticals = function (segs) {
	        this.computeSegVerticals(segs);
	        this.assignSegVerticals(segs);
	    };
	    // For each segment in an array, computes and assigns its top and bottom properties
	    TimeGrid.prototype.computeSegVerticals = function (segs) {
	        var eventMinHeight = this.opt('agendaEventMinHeight');
	        var i;
	        var seg;
	        var dayDate;
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            dayDate = this.dayDates[seg.dayIndex];
	            seg.top = this.computeDateTop(seg.startMs, dayDate);
	            seg.bottom = Math.max(seg.top + eventMinHeight, this.computeDateTop(seg.endMs, dayDate));
	        }
	    };
	    // Given segments that already have their top/bottom properties computed, applies those values to
	    // the segments' elements.
	    TimeGrid.prototype.assignSegVerticals = function (segs) {
	        var i;
	        var seg;
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            seg.el.css(this.generateSegVerticalCss(seg));
	        }
	    };
	    // Generates an object with CSS properties for the top/bottom coordinates of a segment element
	    TimeGrid.prototype.generateSegVerticalCss = function (seg) {
	        return {
	            top: seg.top,
	            bottom: -seg.bottom // flipped because needs to be space beyond bottom edge of event container
	        };
	    };
	    /* Hit System
	    ------------------------------------------------------------------------------------------------------------------*/
	    TimeGrid.prototype.prepareHits = function () {
	        this.colCoordCache.build();
	        this.slatCoordCache.build();
	    };
	    TimeGrid.prototype.releaseHits = function () {
	        this.colCoordCache.clear();
	        // NOTE: don't clear slatCoordCache because we rely on it for computeTimeTop
	    };
	    TimeGrid.prototype.queryHit = function (leftOffset, topOffset) {
	        var snapsPerSlot = this.snapsPerSlot;
	        var colCoordCache = this.colCoordCache;
	        var slatCoordCache = this.slatCoordCache;
	        if (colCoordCache.isLeftInBounds(leftOffset) && slatCoordCache.isTopInBounds(topOffset)) {
	            var colIndex = colCoordCache.getHorizontalIndex(leftOffset);
	            var slatIndex = slatCoordCache.getVerticalIndex(topOffset);
	            if (colIndex != null && slatIndex != null) {
	                var slatTop = slatCoordCache.getTopOffset(slatIndex);
	                var slatHeight = slatCoordCache.getHeight(slatIndex);
	                var partial = (topOffset - slatTop) / slatHeight; // floating point number between 0 and 1
	                var localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
	                var snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
	                var snapTop = slatTop + (localSnapIndex / snapsPerSlot) * slatHeight;
	                var snapBottom = slatTop + ((localSnapIndex + 1) / snapsPerSlot) * slatHeight;
	                return {
	                    col: colIndex,
	                    snap: snapIndex,
	                    component: this,
	                    left: colCoordCache.getLeftOffset(colIndex),
	                    right: colCoordCache.getRightOffset(colIndex),
	                    top: snapTop,
	                    bottom: snapBottom
	                };
	            }
	        }
	    };
	    TimeGrid.prototype.getHitFootprint = function (hit) {
	        var start = this.getCellDate(0, hit.col); // row=0
	        var time = this.computeSnapTime(hit.snap); // pass in the snap-index
	        var end;
	        start.time(time);
	        end = start.clone().add(this.snapDuration);
	        return new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), false // all-day?
	        );
	    };
	    // Given a row number of the grid, representing a "snap", returns a time (Duration) from its start-of-day
	    TimeGrid.prototype.computeSnapTime = function (snapIndex) {
	        return moment.duration(this.dateProfile.minTime + this.snapDuration * snapIndex);
	    };
	    TimeGrid.prototype.getHitEl = function (hit) {
	        return this.colEls.eq(hit.col);
	    };
	    /* Event Drag Visualization
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Renders a visual indication of an event being dragged over the specified date(s).
	    // A returned value of `true` signals that a mock "helper" event has been rendered.
	    TimeGrid.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
	        var i;
	        if (seg) { // if there is event information for this drag, render a helper event
	            if (eventFootprints.length) {
	                this.helperRenderer.renderEventDraggingFootprints(eventFootprints, seg, isTouch);
	                // signal that a helper has been rendered
	                return true;
	            }
	        }
	        else { // otherwise, just render a highlight
	            for (i = 0; i < eventFootprints.length; i++) {
	                this.renderHighlight(eventFootprints[i].componentFootprint);
	            }
	        }
	    };
	    // Unrenders any visual indication of an event being dragged
	    TimeGrid.prototype.unrenderDrag = function () {
	        this.unrenderHighlight();
	        this.helperRenderer.unrender();
	    };
	    /* Event Resize Visualization
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Renders a visual indication of an event being resized
	    TimeGrid.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
	        this.helperRenderer.renderEventResizingFootprints(eventFootprints, seg, isTouch);
	    };
	    // Unrenders any visual indication of an event being resized
	    TimeGrid.prototype.unrenderEventResize = function () {
	        this.helperRenderer.unrender();
	    };
	    /* Selection
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Renders a visual indication of a selection. Overrides the default, which was to simply render a highlight.
	    TimeGrid.prototype.renderSelectionFootprint = function (componentFootprint) {
	        if (this.opt('selectHelper')) { // this setting signals that a mock helper event should be rendered
	            this.helperRenderer.renderComponentFootprint(componentFootprint);
	        }
	        else {
	            this.renderHighlight(componentFootprint);
	        }
	    };
	    // Unrenders any visual indication of a selection
	    TimeGrid.prototype.unrenderSelection = function () {
	        this.helperRenderer.unrender();
	        this.unrenderHighlight();
	    };
	    return TimeGrid;
	}(InteractiveDateComponent_1.default));
	exports.default = TimeGrid;
	TimeGrid.prototype.eventRendererClass = TimeGridEventRenderer_1.default;
	TimeGrid.prototype.businessHourRendererClass = BusinessHourRenderer_1.default;
	TimeGrid.prototype.helperRendererClass = TimeGridHelperRenderer_1.default;
	TimeGrid.prototype.fillRendererClass = TimeGridFillRenderer_1.default;
	StandardInteractionsMixin_1.default.mixInto(TimeGrid);
	DayTableMixin_1.default.mixInto(TimeGrid);
	
	
	/***/ }),
	/* 240 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	var EventRenderer_1 = __webpack_require__(44);
	/*
	Only handles foreground segs.
	Does not own rendering. Use for low-level util methods by TimeGrid.
	*/
	var TimeGridEventRenderer = /** @class */ (function (_super) {
	    tslib_1.__extends(TimeGridEventRenderer, _super);
	    function TimeGridEventRenderer(timeGrid, fillRenderer) {
	        var _this = _super.call(this, timeGrid, fillRenderer) || this;
	        _this.timeGrid = timeGrid;
	        return _this;
	    }
	    TimeGridEventRenderer.prototype.renderFgSegs = function (segs) {
	        this.renderFgSegsIntoContainers(segs, this.timeGrid.fgContainerEls);
	    };
	    // Given an array of foreground segments, render a DOM element for each, computes position,
	    // and attaches to the column inner-container elements.
	    TimeGridEventRenderer.prototype.renderFgSegsIntoContainers = function (segs, containerEls) {
	        var segsByCol;
	        var col;
	        segsByCol = this.timeGrid.groupSegsByCol(segs);
	        for (col = 0; col < this.timeGrid.colCnt; col++) {
	            this.updateFgSegCoords(segsByCol[col]);
	        }
	        this.timeGrid.attachSegsByCol(segsByCol, containerEls);
	    };
	    TimeGridEventRenderer.prototype.unrenderFgSegs = function () {
	        if (this.fgSegs) { // hack
	            this.fgSegs.forEach(function (seg) {
	                seg.el.remove();
	            });
	        }
	    };
	    // Computes a default event time formatting string if `timeFormat` is not explicitly defined
	    TimeGridEventRenderer.prototype.computeEventTimeFormat = function () {
	        return this.opt('noMeridiemTimeFormat'); // like "6:30" (no AM/PM)
	    };
	    // Computes a default `displayEventEnd` value if one is not expliclty defined
	    TimeGridEventRenderer.prototype.computeDisplayEventEnd = function () {
	        return true;
	    };
	    // Renders the HTML for a single event segment's default rendering
	    TimeGridEventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
	        var view = this.view;
	        var calendar = view.calendar;
	        var componentFootprint = seg.footprint.componentFootprint;
	        var isAllDay = componentFootprint.isAllDay;
	        var eventDef = seg.footprint.eventDef;
	        var isDraggable = view.isEventDefDraggable(eventDef);
	        var isResizableFromStart = !disableResizing && seg.isStart && view.isEventDefResizableFromStart(eventDef);
	        var isResizableFromEnd = !disableResizing && seg.isEnd && view.isEventDefResizableFromEnd(eventDef);
	        var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
	        var skinCss = util_1.cssToStr(this.getSkinCss(eventDef));
	        var timeText;
	        var fullTimeText; // more verbose time text. for the print stylesheet
	        var startTimeText; // just the start time text
	        classes.unshift('fc-time-grid-event', 'fc-v-event');
	        // if the event appears to span more than one day...
	        if (view.isMultiDayRange(componentFootprint.unzonedRange)) {
	            // Don't display time text on segments that run entirely through a day.
	            // That would appear as midnight-midnight and would look dumb.
	            // Otherwise, display the time text for the *segment's* times (like 6pm-midnight or midnight-10am)
	            if (seg.isStart || seg.isEnd) {
	                var zonedStart = calendar.msToMoment(seg.startMs);
	                var zonedEnd = calendar.msToMoment(seg.endMs);
	                timeText = this._getTimeText(zonedStart, zonedEnd, isAllDay);
	                fullTimeText = this._getTimeText(zonedStart, zonedEnd, isAllDay, 'LT');
	                startTimeText = this._getTimeText(zonedStart, zonedEnd, isAllDay, null, false); // displayEnd=false
	            }
	        }
	        else {
	            // Display the normal time text for the *event's* times
	            timeText = this.getTimeText(seg.footprint);
	            fullTimeText = this.getTimeText(seg.footprint, 'LT');
	            startTimeText = this.getTimeText(seg.footprint, null, false); // displayEnd=false
	        }
	        return '<a class="' + classes.join(' ') + '"' +
	            (eventDef.url ?
	                ' href="' + util_1.htmlEscape(eventDef.url) + '"' :
	                '') +
	            (skinCss ?
	                ' style="' + skinCss + '"' :
	                '') +
	            '>' +
	            '<div class="fc-content">' +
	            (timeText ?
	                '<div class="fc-time"' +
	                    ' data-start="' + util_1.htmlEscape(startTimeText) + '"' +
	                    ' data-full="' + util_1.htmlEscape(fullTimeText) + '"' +
	                    '>' +
	                    '<span>' + util_1.htmlEscape(timeText) + '</span>' +
	                    '</div>' :
	                '') +
	            (eventDef.title ?
	                '<div class="fc-title">' +
	                    util_1.htmlEscape(eventDef.title) +
	                    '</div>' :
	                '') +
	            '</div>' +
	            '<div class="fc-bg"></div>' +
	            /* TODO: write CSS for this
	            (isResizableFromStart ?
	              '<div class="fc-resizer fc-start-resizer"></div>' :
	              ''
	              ) +
	            */
	            (isResizableFromEnd ?
	                '<div class="fc-resizer fc-end-resizer"></div>' :
	                '') +
	            '</a>';
	    };
	    // Given segments that are assumed to all live in the *same column*,
	    // compute their verical/horizontal coordinates and assign to their elements.
	    TimeGridEventRenderer.prototype.updateFgSegCoords = function (segs) {
	        this.timeGrid.computeSegVerticals(segs); // horizontals relies on this
	        this.computeFgSegHorizontals(segs); // compute horizontal coordinates, z-index's, and reorder the array
	        this.timeGrid.assignSegVerticals(segs);
	        this.assignFgSegHorizontals(segs);
	    };
	    // Given an array of segments that are all in the same column, sets the backwardCoord and forwardCoord on each.
	    // NOTE: Also reorders the given array by date!
	    TimeGridEventRenderer.prototype.computeFgSegHorizontals = function (segs) {
	        var levels;
	        var level0;
	        var i;
	        this.sortEventSegs(segs); // order by certain criteria
	        levels = buildSlotSegLevels(segs);
	        computeForwardSlotSegs(levels);
	        if ((level0 = levels[0])) {
	            for (i = 0; i < level0.length; i++) {
	                computeSlotSegPressures(level0[i]);
	            }
	            for (i = 0; i < level0.length; i++) {
	                this.computeFgSegForwardBack(level0[i], 0, 0);
	            }
	        }
	    };
	    // Calculate seg.forwardCoord and seg.backwardCoord for the segment, where both values range
	    // from 0 to 1. If the calendar is left-to-right, the seg.backwardCoord maps to "left" and
	    // seg.forwardCoord maps to "right" (via percentage). Vice-versa if the calendar is right-to-left.
	    //
	    // The segment might be part of a "series", which means consecutive segments with the same pressure
	    // who's width is unknown until an edge has been hit. `seriesBackwardPressure` is the number of
	    // segments behind this one in the current series, and `seriesBackwardCoord` is the starting
	    // coordinate of the first segment in the series.
	    TimeGridEventRenderer.prototype.computeFgSegForwardBack = function (seg, seriesBackwardPressure, seriesBackwardCoord) {
	        var forwardSegs = seg.forwardSegs;
	        var i;
	        if (seg.forwardCoord === undefined) { // not already computed
	            if (!forwardSegs.length) {
	                // if there are no forward segments, this segment should butt up against the edge
	                seg.forwardCoord = 1;
	            }
	            else {
	                // sort highest pressure first
	                this.sortForwardSegs(forwardSegs);
	                // this segment's forwardCoord will be calculated from the backwardCoord of the
	                // highest-pressure forward segment.
	                this.computeFgSegForwardBack(forwardSegs[0], seriesBackwardPressure + 1, seriesBackwardCoord);
	                seg.forwardCoord = forwardSegs[0].backwardCoord;
	            }
	            // calculate the backwardCoord from the forwardCoord. consider the series
	            seg.backwardCoord = seg.forwardCoord -
	                (seg.forwardCoord - seriesBackwardCoord) / // available width for series
	                    (seriesBackwardPressure + 1); // # of segments in the series
	            // use this segment's coordinates to computed the coordinates of the less-pressurized
	            // forward segments
	            for (i = 0; i < forwardSegs.length; i++) {
	                this.computeFgSegForwardBack(forwardSegs[i], 0, seg.forwardCoord);
	            }
	        }
	    };
	    TimeGridEventRenderer.prototype.sortForwardSegs = function (forwardSegs) {
	        forwardSegs.sort(util_1.proxy(this, 'compareForwardSegs'));
	    };
	    // A cmp function for determining which forward segment to rely on more when computing coordinates.
	    TimeGridEventRenderer.prototype.compareForwardSegs = function (seg1, seg2) {
	        // put higher-pressure first
	        return seg2.forwardPressure - seg1.forwardPressure ||
	            // put segments that are closer to initial edge first (and favor ones with no coords yet)
	            (seg1.backwardCoord || 0) - (seg2.backwardCoord || 0) ||
	            // do normal sorting...
	            this.compareEventSegs(seg1, seg2);
	    };
	    // Given foreground event segments that have already had their position coordinates computed,
	    // assigns position-related CSS values to their elements.
	    TimeGridEventRenderer.prototype.assignFgSegHorizontals = function (segs) {
	        var i;
	        var seg;
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            seg.el.css(this.generateFgSegHorizontalCss(seg));
	            // if the event is short that the title will be cut off,
	            // attach a className that condenses the title into the time area.
	            if (seg.footprint.eventDef.title && seg.bottom - seg.top < 30) {
	                seg.el.addClass('fc-short'); // TODO: "condensed" is a better name
	            }
	        }
	    };
	    // Generates an object with CSS properties/values that should be applied to an event segment element.
	    // Contains important positioning-related properties that should be applied to any event element, customized or not.
	    TimeGridEventRenderer.prototype.generateFgSegHorizontalCss = function (seg) {
	        var shouldOverlap = this.opt('slotEventOverlap');
	        var backwardCoord = seg.backwardCoord; // the left side if LTR. the right side if RTL. floating-point
	        var forwardCoord = seg.forwardCoord; // the right side if LTR. the left side if RTL. floating-point
	        var props = this.timeGrid.generateSegVerticalCss(seg); // get top/bottom first
	        var isRTL = this.timeGrid.isRTL;
	        var left; // amount of space from left edge, a fraction of the total width
	        var right; // amount of space from right edge, a fraction of the total width
	        if (shouldOverlap) {
	            // double the width, but don't go beyond the maximum forward coordinate (1.0)
	            forwardCoord = Math.min(1, backwardCoord + (forwardCoord - backwardCoord) * 2);
	        }
	        if (isRTL) {
	            left = 1 - forwardCoord;
	            right = backwardCoord;
	        }
	        else {
	            left = backwardCoord;
	            right = 1 - forwardCoord;
	        }
	        props.zIndex = seg.level + 1; // convert from 0-base to 1-based
	        props.left = left * 100 + '%';
	        props.right = right * 100 + '%';
	        if (shouldOverlap && seg.forwardPressure) {
	            // add padding to the edge so that forward stacked events don't cover the resizer's icon
	            props[isRTL ? 'marginLeft' : 'marginRight'] = 10 * 2; // 10 is a guesstimate of the icon's width
	        }
	        return props;
	    };
	    return TimeGridEventRenderer;
	}(EventRenderer_1.default));
	exports.default = TimeGridEventRenderer;
	// Builds an array of segments "levels". The first level will be the leftmost tier of segments if the calendar is
	// left-to-right, or the rightmost if the calendar is right-to-left. Assumes the segments are already ordered by date.
	function buildSlotSegLevels(segs) {
	    var levels = [];
	    var i;
	    var seg;
	    var j;
	    for (i = 0; i < segs.length; i++) {
	        seg = segs[i];
	        // go through all the levels and stop on the first level where there are no collisions
	        for (j = 0; j < levels.length; j++) {
	            if (!computeSlotSegCollisions(seg, levels[j]).length) {
	                break;
	            }
	        }
	        seg.level = j;
	        (levels[j] || (levels[j] = [])).push(seg);
	    }
	    return levels;
	}
	// For every segment, figure out the other segments that are in subsequent
	// levels that also occupy the same vertical space. Accumulate in seg.forwardSegs
	function computeForwardSlotSegs(levels) {
	    var i;
	    var level;
	    var j;
	    var seg;
	    var k;
	    for (i = 0; i < levels.length; i++) {
	        level = levels[i];
	        for (j = 0; j < level.length; j++) {
	            seg = level[j];
	            seg.forwardSegs = [];
	            for (k = i + 1; k < levels.length; k++) {
	                computeSlotSegCollisions(seg, levels[k], seg.forwardSegs);
	            }
	        }
	    }
	}
	// Figure out which path forward (via seg.forwardSegs) results in the longest path until
	// the furthest edge is reached. The number of segments in this path will be seg.forwardPressure
	function computeSlotSegPressures(seg) {
	    var forwardSegs = seg.forwardSegs;
	    var forwardPressure = 0;
	    var i;
	    var forwardSeg;
	    if (seg.forwardPressure === undefined) { // not already computed
	        for (i = 0; i < forwardSegs.length; i++) {
	            forwardSeg = forwardSegs[i];
	            // figure out the child's maximum forward path
	            computeSlotSegPressures(forwardSeg);
	            // either use the existing maximum, or use the child's forward pressure
	            // plus one (for the forwardSeg itself)
	            forwardPressure = Math.max(forwardPressure, 1 + forwardSeg.forwardPressure);
	        }
	        seg.forwardPressure = forwardPressure;
	    }
	}
	// Find all the segments in `otherSegs` that vertically collide with `seg`.
	// Append into an optionally-supplied `results` array and return.
	function computeSlotSegCollisions(seg, otherSegs, results) {
	    if (results === void 0) { results = []; }
	    for (var i = 0; i < otherSegs.length; i++) {
	        if (isSlotSegCollision(seg, otherSegs[i])) {
	            results.push(otherSegs[i]);
	        }
	    }
	    return results;
	}
	// Do these segments occupy the same vertical space?
	function isSlotSegCollision(seg1, seg2) {
	    return seg1.bottom > seg2.top && seg1.top < seg2.bottom;
	}
	
	
	/***/ }),
	/* 241 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var HelperRenderer_1 = __webpack_require__(63);
	var TimeGridHelperRenderer = /** @class */ (function (_super) {
	    tslib_1.__extends(TimeGridHelperRenderer, _super);
	    function TimeGridHelperRenderer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TimeGridHelperRenderer.prototype.renderSegs = function (segs, sourceSeg) {
	        var helperNodes = [];
	        var i;
	        var seg;
	        var sourceEl;
	        // TODO: not good to call eventRenderer this way
	        this.eventRenderer.renderFgSegsIntoContainers(segs, this.component.helperContainerEls);
	        // Try to make the segment that is in the same row as sourceSeg look the same
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            if (sourceSeg && sourceSeg.col === seg.col) {
	                sourceEl = sourceSeg.el;
	                seg.el.css({
	                    left: sourceEl.css('left'),
	                    right: sourceEl.css('right'),
	                    'margin-left': sourceEl.css('margin-left'),
	                    'margin-right': sourceEl.css('margin-right')
	                });
	            }
	            helperNodes.push(seg.el[0]);
	        }
	        return $(helperNodes); // must return the elements rendered
	    };
	    return TimeGridHelperRenderer;
	}(HelperRenderer_1.default));
	exports.default = TimeGridHelperRenderer;
	
	
	/***/ }),
	/* 242 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var FillRenderer_1 = __webpack_require__(62);
	var TimeGridFillRenderer = /** @class */ (function (_super) {
	    tslib_1.__extends(TimeGridFillRenderer, _super);
	    function TimeGridFillRenderer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TimeGridFillRenderer.prototype.attachSegEls = function (type, segs) {
	        var timeGrid = this.component;
	        var containerEls;
	        // TODO: more efficient lookup
	        if (type === 'bgEvent') {
	            containerEls = timeGrid.bgContainerEls;
	        }
	        else if (type === 'businessHours') {
	            containerEls = timeGrid.businessContainerEls;
	        }
	        else if (type === 'highlight') {
	            containerEls = timeGrid.highlightContainerEls;
	        }
	        timeGrid.updateSegVerticals(segs);
	        timeGrid.attachSegsByCol(timeGrid.groupSegsByCol(segs), containerEls);
	        return segs.map(function (seg) {
	            return seg.el[0];
	        });
	    };
	    return TimeGridFillRenderer;
	}(FillRenderer_1.default));
	exports.default = TimeGridFillRenderer;
	
	
	/***/ }),
	/* 243 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var EventRenderer_1 = __webpack_require__(44);
	/* Event-rendering methods for the DayGrid class
	----------------------------------------------------------------------------------------------------------------------*/
	var DayGridEventRenderer = /** @class */ (function (_super) {
	    tslib_1.__extends(DayGridEventRenderer, _super);
	    function DayGridEventRenderer(dayGrid, fillRenderer) {
	        var _this = _super.call(this, dayGrid, fillRenderer) || this;
	        _this.dayGrid = dayGrid;
	        return _this;
	    }
	    DayGridEventRenderer.prototype.renderBgRanges = function (eventRanges) {
	        // don't render timed background events
	        eventRanges = $.grep(eventRanges, function (eventRange) {
	            return eventRange.eventDef.isAllDay();
	        });
	        _super.prototype.renderBgRanges.call(this, eventRanges);
	    };
	    // Renders the given foreground event segments onto the grid
	    DayGridEventRenderer.prototype.renderFgSegs = function (segs) {
	        var rowStructs = this.rowStructs = this.renderSegRows(segs);
	        // append to each row's content skeleton
	        this.dayGrid.rowEls.each(function (i, rowNode) {
	            $(rowNode).find('.fc-content-skeleton > table').append(rowStructs[i].tbodyEl);
	        });
	    };
	    // Unrenders all currently rendered foreground event segments
	    DayGridEventRenderer.prototype.unrenderFgSegs = function () {
	        var rowStructs = this.rowStructs || [];
	        var rowStruct;
	        while ((rowStruct = rowStructs.pop())) {
	            rowStruct.tbodyEl.remove();
	        }
	        this.rowStructs = null;
	    };
	    // Uses the given events array to generate <tbody> elements that should be appended to each row's content skeleton.
	    // Returns an array of rowStruct objects (see the bottom of `renderSegRow`).
	    // PRECONDITION: each segment shoud already have a rendered and assigned `.el`
	    DayGridEventRenderer.prototype.renderSegRows = function (segs) {
	        var rowStructs = [];
	        var segRows;
	        var row;
	        segRows = this.groupSegRows(segs); // group into nested arrays
	        // iterate each row of segment groupings
	        for (row = 0; row < segRows.length; row++) {
	            rowStructs.push(this.renderSegRow(row, segRows[row]));
	        }
	        return rowStructs;
	    };
	    // Given a row # and an array of segments all in the same row, render a <tbody> element, a skeleton that contains
	    // the segments. Returns object with a bunch of internal data about how the render was calculated.
	    // NOTE: modifies rowSegs
	    DayGridEventRenderer.prototype.renderSegRow = function (row, rowSegs) {
	        var colCnt = this.dayGrid.colCnt;
	        var segLevels = this.buildSegLevels(rowSegs); // group into sub-arrays of levels
	        var levelCnt = Math.max(1, segLevels.length); // ensure at least one level
	        var tbody = $('<tbody>');
	        var segMatrix = []; // lookup for which segments are rendered into which level+col cells
	        var cellMatrix = []; // lookup for all <td> elements of the level+col matrix
	        var loneCellMatrix = []; // lookup for <td> elements that only take up a single column
	        var i;
	        var levelSegs;
	        var col;
	        var tr;
	        var j;
	        var seg;
	        var td;
	        // populates empty cells from the current column (`col`) to `endCol`
	        function emptyCellsUntil(endCol) {
	            while (col < endCol) {
	                // try to grab a cell from the level above and extend its rowspan. otherwise, create a fresh cell
	                td = (loneCellMatrix[i - 1] || [])[col];
	                if (td) {
	                    td.attr('rowspan', parseInt(td.attr('rowspan') || 1, 10) + 1);
	                }
	                else {
	                    td = $('<td>');
	                    tr.append(td);
	                }
	                cellMatrix[i][col] = td;
	                loneCellMatrix[i][col] = td;
	                col++;
	            }
	        }
	        for (i = 0; i < levelCnt; i++) { // iterate through all levels
	            levelSegs = segLevels[i];
	            col = 0;
	            tr = $('<tr>');
	            segMatrix.push([]);
	            cellMatrix.push([]);
	            loneCellMatrix.push([]);
	            // levelCnt might be 1 even though there are no actual levels. protect against this.
	            // this single empty row is useful for styling.
	            if (levelSegs) {
	                for (j = 0; j < levelSegs.length; j++) { // iterate through segments in level
	                    seg = levelSegs[j];
	                    emptyCellsUntil(seg.leftCol);
	                    // create a container that occupies or more columns. append the event element.
	                    td = $('<td class="fc-event-container">').append(seg.el);
	                    if (seg.leftCol !== seg.rightCol) {
	                        td.attr('colspan', seg.rightCol - seg.leftCol + 1);
	                    }
	                    else { // a single-column segment
	                        loneCellMatrix[i][col] = td;
	                    }
	                    while (col <= seg.rightCol) {
	                        cellMatrix[i][col] = td;
	                        segMatrix[i][col] = seg;
	                        col++;
	                    }
	                    tr.append(td);
	                }
	            }
	            emptyCellsUntil(colCnt); // finish off the row
	            this.dayGrid.bookendCells(tr);
	            tbody.append(tr);
	        }
	        return {
	            row: row,
	            tbodyEl: tbody,
	            cellMatrix: cellMatrix,
	            segMatrix: segMatrix,
	            segLevels: segLevels,
	            segs: rowSegs
	        };
	    };
	    // Stacks a flat array of segments, which are all assumed to be in the same row, into subarrays of vertical levels.
	    // NOTE: modifies segs
	    DayGridEventRenderer.prototype.buildSegLevels = function (segs) {
	        var levels = [];
	        var i;
	        var seg;
	        var j;
	        // Give preference to elements with certain criteria, so they have
	        // a chance to be closer to the top.
	        this.sortEventSegs(segs);
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            // loop through levels, starting with the topmost, until the segment doesn't collide with other segments
	            for (j = 0; j < levels.length; j++) {
	                if (!isDaySegCollision(seg, levels[j])) {
	                    break;
	                }
	            }
	            // `j` now holds the desired subrow index
	            seg.level = j;
	            // create new level array if needed and append segment
	            (levels[j] || (levels[j] = [])).push(seg);
	        }
	        // order segments left-to-right. very important if calendar is RTL
	        for (j = 0; j < levels.length; j++) {
	            levels[j].sort(compareDaySegCols);
	        }
	        return levels;
	    };
	    // Given a flat array of segments, return an array of sub-arrays, grouped by each segment's row
	    DayGridEventRenderer.prototype.groupSegRows = function (segs) {
	        var segRows = [];
	        var i;
	        for (i = 0; i < this.dayGrid.rowCnt; i++) {
	            segRows.push([]);
	        }
	        for (i = 0; i < segs.length; i++) {
	            segRows[segs[i].row].push(segs[i]);
	        }
	        return segRows;
	    };
	    // Computes a default event time formatting string if `timeFormat` is not explicitly defined
	    DayGridEventRenderer.prototype.computeEventTimeFormat = function () {
	        return this.opt('extraSmallTimeFormat'); // like "6p" or "6:30p"
	    };
	    // Computes a default `displayEventEnd` value if one is not expliclty defined
	    DayGridEventRenderer.prototype.computeDisplayEventEnd = function () {
	        return this.dayGrid.colCnt === 1; // we'll likely have space if there's only one day
	    };
	    // Builds the HTML to be used for the default element for an individual segment
	    DayGridEventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
	        var view = this.view;
	        var eventDef = seg.footprint.eventDef;
	        var isAllDay = seg.footprint.componentFootprint.isAllDay;
	        var isDraggable = view.isEventDefDraggable(eventDef);
	        var isResizableFromStart = !disableResizing && isAllDay &&
	            seg.isStart && view.isEventDefResizableFromStart(eventDef);
	        var isResizableFromEnd = !disableResizing && isAllDay &&
	            seg.isEnd && view.isEventDefResizableFromEnd(eventDef);
	        var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
	        var skinCss = util_1.cssToStr(this.getSkinCss(eventDef));
	        var timeHtml = '';
	        var timeText;
	        var titleHtml;
	        classes.unshift('fc-day-grid-event', 'fc-h-event');
	        // Only display a timed events time if it is the starting segment
	        if (seg.isStart) {
	            timeText = this.getTimeText(seg.footprint);
	            if (timeText) {
	                timeHtml = '<span class="fc-time">' + util_1.htmlEscape(timeText) + '</span>';
	            }
	        }
	        titleHtml =
	            '<span class="fc-title">' +
	                (util_1.htmlEscape(eventDef.title || '') || '&nbsp;') + // we always want one line of height
	                '</span>';
	        return '<a class="' + classes.join(' ') + '"' +
	            (eventDef.url ?
	                ' href="' + util_1.htmlEscape(eventDef.url) + '"' :
	                '') +
	            (skinCss ?
	                ' style="' + skinCss + '"' :
	                '') +
	            '>' +
	            '<div class="fc-content">' +
	            (this.dayGrid.isRTL ?
	                titleHtml + ' ' + timeHtml : // put a natural space in between
	                timeHtml + ' ' + titleHtml //
	            ) +
	            '</div>' +
	            (isResizableFromStart ?
	                '<div class="fc-resizer fc-start-resizer"></div>' :
	                '') +
	            (isResizableFromEnd ?
	                '<div class="fc-resizer fc-end-resizer"></div>' :
	                '') +
	            '</a>';
	    };
	    return DayGridEventRenderer;
	}(EventRenderer_1.default));
	exports.default = DayGridEventRenderer;
	// Computes whether two segments' columns collide. They are assumed to be in the same row.
	function isDaySegCollision(seg, otherSegs) {
	    var i;
	    var otherSeg;
	    for (i = 0; i < otherSegs.length; i++) {
	        otherSeg = otherSegs[i];
	        if (otherSeg.leftCol <= seg.rightCol &&
	            otherSeg.rightCol >= seg.leftCol) {
	            return true;
	        }
	    }
	    return false;
	}
	// A cmp function for determining the leftmost event
	function compareDaySegCols(a, b) {
	    return a.leftCol - b.leftCol;
	}
	
	
	/***/ }),
	/* 244 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var HelperRenderer_1 = __webpack_require__(63);
	var DayGridHelperRenderer = /** @class */ (function (_super) {
	    tslib_1.__extends(DayGridHelperRenderer, _super);
	    function DayGridHelperRenderer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // Renders a mock "helper" event. `sourceSeg` is the associated internal segment object. It can be null.
	    DayGridHelperRenderer.prototype.renderSegs = function (segs, sourceSeg) {
	        var helperNodes = [];
	        var rowStructs;
	        // TODO: not good to call eventRenderer this way
	        rowStructs = this.eventRenderer.renderSegRows(segs);
	        // inject each new event skeleton into each associated row
	        this.component.rowEls.each(function (row, rowNode) {
	            var rowEl = $(rowNode); // the .fc-row
	            var skeletonEl = $('<div class="fc-helper-skeleton"><table></table></div>'); // will be absolutely positioned
	            var skeletonTopEl;
	            var skeletonTop;
	            // If there is an original segment, match the top position. Otherwise, put it at the row's top level
	            if (sourceSeg && sourceSeg.row === row) {
	                skeletonTop = sourceSeg.el.position().top;
	            }
	            else {
	                skeletonTopEl = rowEl.find('.fc-content-skeleton tbody');
	                if (!skeletonTopEl.length) { // when no events
	                    skeletonTopEl = rowEl.find('.fc-content-skeleton table');
	                }
	                skeletonTop = skeletonTopEl.position().top;
	            }
	            skeletonEl.css('top', skeletonTop)
	                .find('table')
	                .append(rowStructs[row].tbodyEl);
	            rowEl.append(skeletonEl);
	            helperNodes.push(skeletonEl[0]);
	        });
	        return $(helperNodes); // must return the elements rendered
	    };
	    return DayGridHelperRenderer;
	}(HelperRenderer_1.default));
	exports.default = DayGridHelperRenderer;
	
	
	/***/ }),
	/* 245 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var FillRenderer_1 = __webpack_require__(62);
	var DayGridFillRenderer = /** @class */ (function (_super) {
	    tslib_1.__extends(DayGridFillRenderer, _super);
	    function DayGridFillRenderer() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.fillSegTag = 'td'; // override the default tag name
	        return _this;
	    }
	    DayGridFillRenderer.prototype.attachSegEls = function (type, segs) {
	        var nodes = [];
	        var i;
	        var seg;
	        var skeletonEl;
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            skeletonEl = this.renderFillRow(type, seg);
	            this.component.rowEls.eq(seg.row).append(skeletonEl);
	            nodes.push(skeletonEl[0]);
	        }
	        return nodes;
	    };
	    // Generates the HTML needed for one row of a fill. Requires the seg's el to be rendered.
	    DayGridFillRenderer.prototype.renderFillRow = function (type, seg) {
	        var colCnt = this.component.colCnt;
	        var startCol = seg.leftCol;
	        var endCol = seg.rightCol + 1;
	        var className;
	        var skeletonEl;
	        var trEl;
	        if (type === 'businessHours') {
	            className = 'bgevent';
	        }
	        else {
	            className = type.toLowerCase();
	        }
	        skeletonEl = $('<div class="fc-' + className + '-skeleton">' +
	            '<table><tr></tr></table>' +
	            '</div>');
	        trEl = skeletonEl.find('tr');
	        if (startCol > 0) {
	            trEl.append(
	            // will create (startCol + 1) td's
	            new Array(startCol + 1).join('<td></td>'));
	        }
	        trEl.append(seg.el.attr('colspan', endCol - startCol));
	        if (endCol < colCnt) {
	            trEl.append(
	            // will create (colCnt - endCol) td's
	            new Array(colCnt - endCol + 1).join('<td></td>'));
	        }
	        this.component.bookendCells(trEl);
	        return skeletonEl;
	    };
	    return DayGridFillRenderer;
	}(FillRenderer_1.default));
	exports.default = DayGridFillRenderer;
	
	
	/***/ }),
	/* 246 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var moment = __webpack_require__(0);
	var util_1 = __webpack_require__(4);
	var BasicView_1 = __webpack_require__(67);
	var MonthViewDateProfileGenerator_1 = __webpack_require__(247);
	/* A month view with day cells running in rows (one-per-week) and columns
	----------------------------------------------------------------------------------------------------------------------*/
	var MonthView = /** @class */ (function (_super) {
	    tslib_1.__extends(MonthView, _super);
	    function MonthView() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // Overrides the default BasicView behavior to have special multi-week auto-height logic
	    MonthView.prototype.setGridHeight = function (height, isAuto) {
	        // if auto, make the height of each row the height that it would be if there were 6 weeks
	        if (isAuto) {
	            height *= this.dayGrid.rowCnt / 6;
	        }
	        util_1.distributeHeight(this.dayGrid.rowEls, height, !isAuto); // if auto, don't compensate for height-hogging rows
	    };
	    MonthView.prototype.isDateInOtherMonth = function (date, dateProfile) {
	        return date.month() !== moment.utc(dateProfile.currentUnzonedRange.startMs).month(); // TODO: optimize
	    };
	    return MonthView;
	}(BasicView_1.default));
	exports.default = MonthView;
	MonthView.prototype.dateProfileGeneratorClass = MonthViewDateProfileGenerator_1.default;
	
	
	/***/ }),
	/* 247 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var BasicViewDateProfileGenerator_1 = __webpack_require__(68);
	var UnzonedRange_1 = __webpack_require__(5);
	var MonthViewDateProfileGenerator = /** @class */ (function (_super) {
	    tslib_1.__extends(MonthViewDateProfileGenerator, _super);
	    function MonthViewDateProfileGenerator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // Computes the date range that will be rendered.
	    MonthViewDateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
	        var renderUnzonedRange = _super.prototype.buildRenderRange.call(this, currentUnzonedRange, currentRangeUnit, isRangeAllDay);
	        var start = this.msToUtcMoment(renderUnzonedRange.startMs, isRangeAllDay);
	        var end = this.msToUtcMoment(renderUnzonedRange.endMs, isRangeAllDay);
	        var rowCnt;
	        // ensure 6 weeks
	        if (this.opt('fixedWeekCount')) {
	            rowCnt = Math.ceil(// could be partial weeks due to hiddenDays
	            end.diff(start, 'weeks', true) // dontRound=true
	            );
	            end.add(6 - rowCnt, 'weeks');
	        }
	        return new UnzonedRange_1.default(start, end);
	    };
	    return MonthViewDateProfileGenerator;
	}(BasicViewDateProfileGenerator_1.default));
	exports.default = MonthViewDateProfileGenerator;
	
	
	/***/ }),
	/* 248 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var UnzonedRange_1 = __webpack_require__(5);
	var View_1 = __webpack_require__(43);
	var Scroller_1 = __webpack_require__(41);
	var ListEventRenderer_1 = __webpack_require__(249);
	var ListEventPointing_1 = __webpack_require__(250);
	/*
	Responsible for the scroller, and forwarding event-related actions into the "grid".
	*/
	var ListView = /** @class */ (function (_super) {
	    tslib_1.__extends(ListView, _super);
	    function ListView(calendar, viewSpec) {
	        var _this = _super.call(this, calendar, viewSpec) || this;
	        _this.segSelector = '.fc-list-item'; // which elements accept event actions
	        _this.scroller = new Scroller_1.default({
	            overflowX: 'hidden',
	            overflowY: 'auto'
	        });
	        return _this;
	    }
	    ListView.prototype.renderSkeleton = function () {
	        this.el.addClass('fc-list-view ' +
	            this.calendar.theme.getClass('listView'));
	        this.scroller.render();
	        this.scroller.el.appendTo(this.el);
	        this.contentEl = this.scroller.scrollEl; // shortcut
	    };
	    ListView.prototype.unrenderSkeleton = function () {
	        this.scroller.destroy(); // will remove the Grid too
	    };
	    ListView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
	        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
	        this.scroller.clear(); // sets height to 'auto' and clears overflow
	        if (!isAuto) {
	            this.scroller.setHeight(this.computeScrollerHeight(totalHeight));
	        }
	    };
	    ListView.prototype.computeScrollerHeight = function (totalHeight) {
	        return totalHeight -
	            util_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
	    };
	    ListView.prototype.renderDates = function (dateProfile) {
	        var calendar = this.calendar;
	        var dayStart = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.startMs, true);
	        var viewEnd = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.endMs, true);
	        var dayDates = [];
	        var dayRanges = [];
	        while (dayStart < viewEnd) {
	            dayDates.push(dayStart.clone());
	            dayRanges.push(new UnzonedRange_1.default(dayStart, dayStart.clone().add(1, 'day')));
	            dayStart.add(1, 'day');
	        }
	        this.dayDates = dayDates;
	        this.dayRanges = dayRanges;
	        // all real rendering happens in EventRenderer
	    };
	    // slices by day
	    ListView.prototype.componentFootprintToSegs = function (footprint) {
	        var dayRanges = this.dayRanges;
	        var dayIndex;
	        var segRange;
	        var seg;
	        var segs = [];
	        for (dayIndex = 0; dayIndex < dayRanges.length; dayIndex++) {
	            segRange = footprint.unzonedRange.intersect(dayRanges[dayIndex]);
	            if (segRange) {
	                seg = {
	                    startMs: segRange.startMs,
	                    endMs: segRange.endMs,
	                    isStart: segRange.isStart,
	                    isEnd: segRange.isEnd,
	                    dayIndex: dayIndex
	                };
	                segs.push(seg);
	                // detect when footprint won't go fully into the next day,
	                // and mutate the latest seg to the be the end.
	                if (!seg.isEnd && !footprint.isAllDay &&
	                    dayIndex + 1 < dayRanges.length &&
	                    footprint.unzonedRange.endMs < dayRanges[dayIndex + 1].startMs + this.nextDayThreshold) {
	                    seg.endMs = footprint.unzonedRange.endMs;
	                    seg.isEnd = true;
	                    break;
	                }
	            }
	        }
	        return segs;
	    };
	    ListView.prototype.renderEmptyMessage = function () {
	        this.contentEl.html('<div class="fc-list-empty-wrap2">' + // TODO: try less wraps
	            '<div class="fc-list-empty-wrap1">' +
	            '<div class="fc-list-empty">' +
	            util_1.htmlEscape(this.opt('noEventsMessage')) +
	            '</div>' +
	            '</div>' +
	            '</div>');
	    };
	    // render the event segments in the view
	    ListView.prototype.renderSegList = function (allSegs) {
	        var segsByDay = this.groupSegsByDay(allSegs); // sparse array
	        var dayIndex;
	        var daySegs;
	        var i;
	        var tableEl = $('<table class="fc-list-table ' + this.calendar.theme.getClass('tableList') + '"><tbody></tbody></table>');
	        var tbodyEl = tableEl.find('tbody');
	        for (dayIndex = 0; dayIndex < segsByDay.length; dayIndex++) {
	            daySegs = segsByDay[dayIndex];
	            if (daySegs) { // sparse array, so might be undefined
	                // append a day header
	                tbodyEl.append(this.dayHeaderHtml(this.dayDates[dayIndex]));
	                this.eventRenderer.sortEventSegs(daySegs);
	                for (i = 0; i < daySegs.length; i++) {
	                    tbodyEl.append(daySegs[i].el); // append event row
	                }
	            }
	        }
	        this.contentEl.empty().append(tableEl);
	    };
	    // Returns a sparse array of arrays, segs grouped by their dayIndex
	    ListView.prototype.groupSegsByDay = function (segs) {
	        var segsByDay = []; // sparse array
	        var i;
	        var seg;
	        for (i = 0; i < segs.length; i++) {
	            seg = segs[i];
	            (segsByDay[seg.dayIndex] || (segsByDay[seg.dayIndex] = []))
	                .push(seg);
	        }
	        return segsByDay;
	    };
	    // generates the HTML for the day headers that live amongst the event rows
	    ListView.prototype.dayHeaderHtml = function (dayDate) {
	        var mainFormat = this.opt('listDayFormat');
	        var altFormat = this.opt('listDayAltFormat');
	        return '<tr class="fc-list-heading" data-date="' + dayDate.format('YYYY-MM-DD') + '">' +
	            '<td class="' + (this.calendar.theme.getClass('tableListHeading') ||
	            this.calendar.theme.getClass('widgetHeader')) + '" colspan="3">' +
	            (mainFormat ?
	                this.buildGotoAnchorHtml(dayDate, { 'class': 'fc-list-heading-main' }, util_1.htmlEscape(dayDate.format(mainFormat)) // inner HTML
	                ) :
	                '') +
	            (altFormat ?
	                this.buildGotoAnchorHtml(dayDate, { 'class': 'fc-list-heading-alt' }, util_1.htmlEscape(dayDate.format(altFormat)) // inner HTML
	                ) :
	                '') +
	            '</td>' +
	            '</tr>';
	    };
	    return ListView;
	}(View_1.default));
	exports.default = ListView;
	ListView.prototype.eventRendererClass = ListEventRenderer_1.default;
	ListView.prototype.eventPointingClass = ListEventPointing_1.default;
	
	
	/***/ }),
	/* 249 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var util_1 = __webpack_require__(4);
	var EventRenderer_1 = __webpack_require__(44);
	var ListEventRenderer = /** @class */ (function (_super) {
	    tslib_1.__extends(ListEventRenderer, _super);
	    function ListEventRenderer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ListEventRenderer.prototype.renderFgSegs = function (segs) {
	        if (!segs.length) {
	            this.component.renderEmptyMessage();
	        }
	        else {
	            this.component.renderSegList(segs);
	        }
	    };
	    // generates the HTML for a single event row
	    ListEventRenderer.prototype.fgSegHtml = function (seg) {
	        var view = this.view;
	        var calendar = view.calendar;
	        var theme = calendar.theme;
	        var eventFootprint = seg.footprint;
	        var eventDef = eventFootprint.eventDef;
	        var componentFootprint = eventFootprint.componentFootprint;
	        var url = eventDef.url;
	        var classes = ['fc-list-item'].concat(this.getClasses(eventDef));
	        var bgColor = this.getBgColor(eventDef);
	        var timeHtml;
	        if (componentFootprint.isAllDay) {
	            timeHtml = view.getAllDayHtml();
	        }
	        else if (view.isMultiDayRange(componentFootprint.unzonedRange)) {
	            if (seg.isStart || seg.isEnd) { // outer segment that probably lasts part of the day
	                timeHtml = util_1.htmlEscape(this._getTimeText(calendar.msToMoment(seg.startMs), calendar.msToMoment(seg.endMs), componentFootprint.isAllDay));
	            }
	            else { // inner segment that lasts the whole day
	                timeHtml = view.getAllDayHtml();
	            }
	        }
	        else {
	            // Display the normal time text for the *event's* times
	            timeHtml = util_1.htmlEscape(this.getTimeText(eventFootprint));
	        }
	        if (url) {
	            classes.push('fc-has-url');
	        }
	        return '<tr class="' + classes.join(' ') + '">' +
	            (this.displayEventTime ?
	                '<td class="fc-list-item-time ' + theme.getClass('widgetContent') + '">' +
	                    (timeHtml || '') +
	                    '</td>' :
	                '') +
	            '<td class="fc-list-item-marker ' + theme.getClass('widgetContent') + '">' +
	            '<span class="fc-event-dot"' +
	            (bgColor ?
	                ' style="background-color:' + bgColor + '"' :
	                '') +
	            '></span>' +
	            '</td>' +
	            '<td class="fc-list-item-title ' + theme.getClass('widgetContent') + '">' +
	            '<a' + (url ? ' href="' + util_1.htmlEscape(url) + '"' : '') + '>' +
	            util_1.htmlEscape(eventDef.title || '') +
	            '</a>' +
	            '</td>' +
	            '</tr>';
	    };
	    // like "4:00am"
	    ListEventRenderer.prototype.computeEventTimeFormat = function () {
	        return this.opt('mediumTimeFormat');
	    };
	    return ListEventRenderer;
	}(EventRenderer_1.default));
	exports.default = ListEventRenderer;
	
	
	/***/ }),
	/* 250 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var EventPointing_1 = __webpack_require__(64);
	var ListEventPointing = /** @class */ (function (_super) {
	    tslib_1.__extends(ListEventPointing, _super);
	    function ListEventPointing() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    // for events with a url, the whole <tr> should be clickable,
	    // but it's impossible to wrap with an <a> tag. simulate this.
	    ListEventPointing.prototype.handleClick = function (seg, ev) {
	        var url;
	        _super.prototype.handleClick.call(this, seg, ev); // might prevent the default action
	        // not clicking on or within an <a> with an href
	        if (!$(ev.target).closest('a[href]').length) {
	            url = seg.footprint.eventDef.url;
	            if (url && !ev.isDefaultPrevented()) { // jsEvent not cancelled in handler
	                window.location.href = url; // simulate link click
	            }
	        }
	    };
	    return ListEventPointing;
	}(EventPointing_1.default));
	exports.default = ListEventPointing;
	
	
	/***/ }),
	/* 251 */,
	/* 252 */,
	/* 253 */,
	/* 254 */,
	/* 255 */,
	/* 256 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var $ = __webpack_require__(3);
	var exportHooks = __webpack_require__(18);
	var util_1 = __webpack_require__(4);
	var Calendar_1 = __webpack_require__(232);
	// for intentional side-effects
	__webpack_require__(11);
	__webpack_require__(49);
	__webpack_require__(260);
	__webpack_require__(261);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(267);
	$.fullCalendar = exportHooks;
	$.fn.fullCalendar = function (options) {
	    var args = Array.prototype.slice.call(arguments, 1); // for a possible method call
	    var res = this; // what this function will return (this jQuery object by default)
	    this.each(function (i, _element) {
	        var element = $(_element);
	        var calendar = element.data('fullCalendar'); // get the existing calendar object (if any)
	        var singleRes; // the returned value of this single method call
	        // a method call
	        if (typeof options === 'string') {
	            if (options === 'getCalendar') {
	                if (!i) { // first element only
	                    res = calendar;
	                }
	            }
	            else if (options === 'destroy') { // don't warn if no calendar object
	                if (calendar) {
	                    calendar.destroy();
	                    element.removeData('fullCalendar');
	                }
	            }
	            else if (!calendar) {
	                util_1.warn('Attempting to call a FullCalendar method on an element with no calendar.');
	            }
	            else if ($.isFunction(calendar[options])) {
	                singleRes = calendar[options].apply(calendar, args);
	                if (!i) {
	                    res = singleRes; // record the first method call result
	                }
	                if (options === 'destroy') { // for the destroy method, must remove Calendar object data
	                    element.removeData('fullCalendar');
	                }
	            }
	            else {
	                util_1.warn("'" + options + "' is an unknown FullCalendar method.");
	            }
	        }
	        else if (!calendar) { // don't initialize twice
	            calendar = new Calendar_1.default(element, options);
	            element.data('fullCalendar', calendar);
	            calendar.render();
	        }
	    });
	    return res;
	};
	module.exports = exportHooks;
	
	
	/***/ }),
	/* 257 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	/* Toolbar with buttons and title
	----------------------------------------------------------------------------------------------------------------------*/
	var Toolbar = /** @class */ (function () {
	    function Toolbar(calendar, toolbarOptions) {
	        this.el = null; // mirrors local `el`
	        this.viewsWithButtons = [];
	        this.calendar = calendar;
	        this.toolbarOptions = toolbarOptions;
	    }
	    // method to update toolbar-specific options, not calendar-wide options
	    Toolbar.prototype.setToolbarOptions = function (newToolbarOptions) {
	        this.toolbarOptions = newToolbarOptions;
	    };
	    // can be called repeatedly and will rerender
	    Toolbar.prototype.render = function () {
	        var sections = this.toolbarOptions.layout;
	        var el = this.el;
	        if (sections) {
	            if (!el) {
	                el = this.el = $("<div class='fc-toolbar " + this.toolbarOptions.extraClasses + "'>");
	            }
	            else {
	                el.empty();
	            }
	            el.append(this.renderSection('left'))
	                .append(this.renderSection('right'))
	                .append(this.renderSection('center'))
	                .append('<div class="fc-clear"></div>');
	        }
	        else {
	            this.removeElement();
	        }
	    };
	    Toolbar.prototype.removeElement = function () {
	        if (this.el) {
	            this.el.remove();
	            this.el = null;
	        }
	    };
	    Toolbar.prototype.renderSection = function (position) {
	        var _this = this;
	        var calendar = this.calendar;
	        var theme = calendar.theme;
	        var optionsManager = calendar.optionsManager;
	        var viewSpecManager = calendar.viewSpecManager;
	        var sectionEl = $('<div class="fc-' + position + '">');
	        var buttonStr = this.toolbarOptions.layout[position];
	        var calendarCustomButtons = optionsManager.get('customButtons') || {};
	        var calendarButtonTextOverrides = optionsManager.overrides.buttonText || {};
	        var calendarButtonText = optionsManager.get('buttonText') || {};
	        if (buttonStr) {
	            $.each(buttonStr.split(' '), function (i, buttonGroupStr) {
	                var groupChildren = $();
	                var isOnlyButtons = true;
	                var groupEl;
	                $.each(buttonGroupStr.split(','), function (j, buttonName) {
	                    var customButtonProps;
	                    var viewSpec;
	                    var buttonClick;
	                    var buttonIcon; // only one of these will be set
	                    var buttonText; // "
	                    var buttonInnerHtml;
	                    var buttonClasses;
	                    var buttonEl;
	                    var buttonAriaAttr;
	                    if (buttonName === 'title') {
	                        groupChildren = groupChildren.add($('<h2>&nbsp;</h2>')); // we always want it to take up height
	                        isOnlyButtons = false;
	                    }
	                    else {
	                        if ((customButtonProps = calendarCustomButtons[buttonName])) {
	                            buttonClick = function (ev) {
	                                if (customButtonProps.click) {
	                                    customButtonProps.click.call(buttonEl[0], ev);
	                                }
	                            };
	                            (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) ||
	                                (buttonIcon = theme.getIconClass(buttonName)) ||
	                                (buttonText = customButtonProps.text);
	                        }
	                        else if ((viewSpec = viewSpecManager.getViewSpec(buttonName))) {
	                            _this.viewsWithButtons.push(buttonName);
	                            buttonClick = function () {
	                                calendar.changeView(buttonName);
	                            };
	                            (buttonText = viewSpec.buttonTextOverride) ||
	                                (buttonIcon = theme.getIconClass(buttonName)) ||
	                                (buttonText = viewSpec.buttonTextDefault);
	                        }
	                        else if (calendar[buttonName]) { // a calendar method
	                            buttonClick = function () {
	                                calendar[buttonName]();
	                            };
	                            (buttonText = calendarButtonTextOverrides[buttonName]) ||
	                                (buttonIcon = theme.getIconClass(buttonName)) ||
	                                (buttonText = calendarButtonText[buttonName]);
	                            //            ^ everything else is considered default
	                        }
	                        if (buttonClick) {
	                            buttonClasses = [
	                                'fc-' + buttonName + '-button',
	                                theme.getClass('button'),
	                                theme.getClass('stateDefault')
	                            ];
	                            if (buttonText) {
	                                buttonInnerHtml = util_1.htmlEscape(buttonText);
	                                buttonAriaAttr = '';
	                            }
	                            else if (buttonIcon) {
	                                buttonInnerHtml = "<span class='" + buttonIcon + "'></span>";
	                                buttonAriaAttr = ' aria-label="' + buttonName + '"';
	                            }
	                            buttonEl = $(// type="button" so that it doesn't submit a form
	                            '<button type="button" class="' + buttonClasses.join(' ') + '"' +
	                                buttonAriaAttr +
	                                '>' + buttonInnerHtml + '</button>')
	                                .click(function (ev) {
	                                // don't process clicks for disabled buttons
	                                if (!buttonEl.hasClass(theme.getClass('stateDisabled'))) {
	                                    buttonClick(ev);
	                                    // after the click action, if the button becomes the "active" tab, or disabled,
	                                    // it should never have a hover class, so remove it now.
	                                    if (buttonEl.hasClass(theme.getClass('stateActive')) ||
	                                        buttonEl.hasClass(theme.getClass('stateDisabled'))) {
	                                        buttonEl.removeClass(theme.getClass('stateHover'));
	                                    }
	                                }
	                            })
	                                .mousedown(function () {
	                                // the *down* effect (mouse pressed in).
	                                // only on buttons that are not the "active" tab, or disabled
	                                buttonEl
	                                    .not('.' + theme.getClass('stateActive'))
	                                    .not('.' + theme.getClass('stateDisabled'))
	                                    .addClass(theme.getClass('stateDown'));
	                            })
	                                .mouseup(function () {
	                                // undo the *down* effect
	                                buttonEl.removeClass(theme.getClass('stateDown'));
	                            })
	                                .hover(function () {
	                                // the *hover* effect.
	                                // only on buttons that are not the "active" tab, or disabled
	                                buttonEl
	                                    .not('.' + theme.getClass('stateActive'))
	                                    .not('.' + theme.getClass('stateDisabled'))
	                                    .addClass(theme.getClass('stateHover'));
	                            }, function () {
	                                // undo the *hover* effect
	                                buttonEl
	                                    .removeClass(theme.getClass('stateHover'))
	                                    .removeClass(theme.getClass('stateDown')); // if mouseleave happens before mouseup
	                            });
	                            groupChildren = groupChildren.add(buttonEl);
	                        }
	                    }
	                });
	                if (isOnlyButtons) {
	                    groupChildren
	                        .first().addClass(theme.getClass('cornerLeft')).end()
	                        .last().addClass(theme.getClass('cornerRight')).end();
	                }
	                if (groupChildren.length > 1) {
	                    groupEl = $('<div>');
	                    if (isOnlyButtons) {
	                        groupEl.addClass(theme.getClass('buttonGroup'));
	                    }
	                    groupEl.append(groupChildren);
	                    sectionEl.append(groupEl);
	                }
	                else {
	                    sectionEl.append(groupChildren); // 1 or 0 children
	                }
	            });
	        }
	        return sectionEl;
	    };
	    Toolbar.prototype.updateTitle = function (text) {
	        if (this.el) {
	            this.el.find('h2').text(text);
	        }
	    };
	    Toolbar.prototype.activateButton = function (buttonName) {
	        if (this.el) {
	            this.el.find('.fc-' + buttonName + '-button')
	                .addClass(this.calendar.theme.getClass('stateActive'));
	        }
	    };
	    Toolbar.prototype.deactivateButton = function (buttonName) {
	        if (this.el) {
	            this.el.find('.fc-' + buttonName + '-button')
	                .removeClass(this.calendar.theme.getClass('stateActive'));
	        }
	    };
	    Toolbar.prototype.disableButton = function (buttonName) {
	        if (this.el) {
	            this.el.find('.fc-' + buttonName + '-button')
	                .prop('disabled', true)
	                .addClass(this.calendar.theme.getClass('stateDisabled'));
	        }
	    };
	    Toolbar.prototype.enableButton = function (buttonName) {
	        if (this.el) {
	            this.el.find('.fc-' + buttonName + '-button')
	                .prop('disabled', false)
	                .removeClass(this.calendar.theme.getClass('stateDisabled'));
	        }
	    };
	    Toolbar.prototype.getViewsWithButtons = function () {
	        return this.viewsWithButtons;
	    };
	    return Toolbar;
	}());
	exports.default = Toolbar;
	
	
	/***/ }),
	/* 258 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var $ = __webpack_require__(3);
	var util_1 = __webpack_require__(4);
	var options_1 = __webpack_require__(33);
	var locale_1 = __webpack_require__(32);
	var Model_1 = __webpack_require__(51);
	var OptionsManager = /** @class */ (function (_super) {
	    tslib_1.__extends(OptionsManager, _super);
	    function OptionsManager(_calendar, overrides) {
	        var _this = _super.call(this) || this;
	        _this._calendar = _calendar;
	        _this.overrides = $.extend({}, overrides); // make a copy
	        _this.dynamicOverrides = {};
	        _this.compute();
	        return _this;
	    }
	    OptionsManager.prototype.add = function (newOptionHash) {
	        var optionCnt = 0;
	        var optionName;
	        this.recordOverrides(newOptionHash); // will trigger this model's watchers
	        for (optionName in newOptionHash) {
	            optionCnt++;
	        }
	        // special-case handling of single option change.
	        // if only one option change, `optionName` will be its name.
	        if (optionCnt === 1) {
	            if (optionName === 'height' || optionName === 'contentHeight' || optionName === 'aspectRatio') {
	                this._calendar.updateViewSize(true); // isResize=true
	                return;
	            }
	            else if (optionName === 'defaultDate') {
	                return; // can't change date this way. use gotoDate instead
	            }
	            else if (optionName === 'businessHours') {
	                return; // this model already reacts to this
	            }
	            else if (/^(event|select)(Overlap|Constraint|Allow)$/.test(optionName)) {
	                return; // doesn't affect rendering. only interactions.
	            }
	            else if (optionName === 'timezone') {
	                this._calendar.view.flash('initialEvents');
	                return;
	            }
	        }
	        // catch-all. rerender the header and footer and rebuild/rerender the current view
	        this._calendar.renderHeader();
	        this._calendar.renderFooter();
	        // even non-current views will be affected by this option change. do before rerender
	        // TODO: detangle
	        this._calendar.viewsByType = {};
	        this._calendar.reinitView();
	    };
	    // Computes the flattened options hash for the calendar and assigns to `this.options`.
	    // Assumes this.overrides and this.dynamicOverrides have already been initialized.
	    OptionsManager.prototype.compute = function () {
	        var locale;
	        var localeDefaults;
	        var isRTL;
	        var dirDefaults;
	        var rawOptions;
	        locale = util_1.firstDefined(// explicit locale option given?
	        this.dynamicOverrides.locale, this.overrides.locale);
	        localeDefaults = locale_1.localeOptionHash[locale];
	        if (!localeDefaults) { // explicit locale option not given or invalid?
	            locale = options_1.globalDefaults.locale;
	            localeDefaults = locale_1.localeOptionHash[locale] || {};
	        }
	        isRTL = util_1.firstDefined(// based on options computed so far, is direction RTL?
	        this.dynamicOverrides.isRTL, this.overrides.isRTL, localeDefaults.isRTL, options_1.globalDefaults.isRTL);
	        dirDefaults = isRTL ? options_1.rtlDefaults : {};
	        this.dirDefaults = dirDefaults;
	        this.localeDefaults = localeDefaults;
	        rawOptions = options_1.mergeOptions([
	            options_1.globalDefaults,
	            dirDefaults,
	            localeDefaults,
	            this.overrides,
	            this.dynamicOverrides
	        ]);
	        locale_1.populateInstanceComputableOptions(rawOptions); // fill in gaps with computed options
	        this.reset(rawOptions);
	    };
	    // stores the new options internally, but does not rerender anything.
	    OptionsManager.prototype.recordOverrides = function (newOptionHash) {
	        var optionName;
	        for (optionName in newOptionHash) {
	            this.dynamicOverrides[optionName] = newOptionHash[optionName];
	        }
	        this._calendar.viewSpecManager.clearCache(); // the dynamic override invalidates the options in this cache, so just clear it
	        this.compute(); // this.options needs to be recomputed after the dynamic override
	    };
	    return OptionsManager;
	}(Model_1.default));
	exports.default = OptionsManager;
	
	
	/***/ }),
	/* 259 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(0);
	var $ = __webpack_require__(3);
	var ViewRegistry_1 = __webpack_require__(24);
	var util_1 = __webpack_require__(4);
	var options_1 = __webpack_require__(33);
	var locale_1 = __webpack_require__(32);
	var ViewSpecManager = /** @class */ (function () {
	    function ViewSpecManager(optionsManager, _calendar) {
	        this.optionsManager = optionsManager;
	        this._calendar = _calendar;
	        this.clearCache();
	    }
	    ViewSpecManager.prototype.clearCache = function () {
	        this.viewSpecCache = {};
	    };
	    // Gets information about how to create a view. Will use a cache.
	    ViewSpecManager.prototype.getViewSpec = function (viewType) {
	        var cache = this.viewSpecCache;
	        return cache[viewType] || (cache[viewType] = this.buildViewSpec(viewType));
	    };
	    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
	    // Preference is given to views that have corresponding buttons.
	    ViewSpecManager.prototype.getUnitViewSpec = function (unit) {
	        var viewTypes;
	        var i;
	        var spec;
	        if ($.inArray(unit, util_1.unitsDesc) !== -1) {
	            // put views that have buttons first. there will be duplicates, but oh well
	            viewTypes = this._calendar.header.getViewsWithButtons(); // TODO: include footer as well?
	            $.each(ViewRegistry_1.viewHash, function (viewType) {
	                viewTypes.push(viewType);
	            });
	            for (i = 0; i < viewTypes.length; i++) {
	                spec = this.getViewSpec(viewTypes[i]);
	                if (spec) {
	                    if (spec.singleUnit === unit) {
	                        return spec;
	                    }
	                }
	            }
	        }
	    };
	    // Builds an object with information on how to create a given view
	    ViewSpecManager.prototype.buildViewSpec = function (requestedViewType) {
	        var viewOverrides = this.optionsManager.overrides.views || {};
	        var specChain = []; // for the view. lowest to highest priority
	        var defaultsChain = []; // for the view. lowest to highest priority
	        var overridesChain = []; // for the view. lowest to highest priority
	        var viewType = requestedViewType;
	        var spec; // for the view
	        var overrides; // for the view
	        var durationInput;
	        var duration;
	        var unit;
	        // iterate from the specific view definition to a more general one until we hit an actual View class
	        while (viewType) {
	            spec = ViewRegistry_1.viewHash[viewType];
	            overrides = viewOverrides[viewType];
	            viewType = null; // clear. might repopulate for another iteration
	            if (typeof spec === 'function') { // TODO: deprecate
	                spec = { 'class': spec };
	            }
	            if (spec) {
	                specChain.unshift(spec);
	                defaultsChain.unshift(spec.defaults || {});
	                durationInput = durationInput || spec.duration;
	                viewType = viewType || spec.type;
	            }
	            if (overrides) {
	                overridesChain.unshift(overrides); // view-specific option hashes have options at zero-level
	                durationInput = durationInput || overrides.duration;
	                viewType = viewType || overrides.type;
	            }
	        }
	        spec = util_1.mergeProps(specChain);
	        spec.type = requestedViewType;
	        if (!spec['class']) {
	            return false;
	        }
	        // fall back to top-level `duration` option
	        durationInput = durationInput ||
	            this.optionsManager.dynamicOverrides.duration ||
	            this.optionsManager.overrides.duration;
	        if (durationInput) {
	            duration = moment.duration(durationInput);
	            if (duration.valueOf()) { // valid?
	                unit = util_1.computeDurationGreatestUnit(duration, durationInput);
	                spec.duration = duration;
	                spec.durationUnit = unit;
	                // view is a single-unit duration, like "week" or "day"
	                // incorporate options for this. lowest priority
	                if (duration.as(unit) === 1) {
	                    spec.singleUnit = unit;
	                    overridesChain.unshift(viewOverrides[unit] || {});
	                }
	            }
	        }
	        spec.defaults = options_1.mergeOptions(defaultsChain);
	        spec.overrides = options_1.mergeOptions(overridesChain);
	        this.buildViewSpecOptions(spec);
	        this.buildViewSpecButtonText(spec, requestedViewType);
	        return spec;
	    };
	    // Builds and assigns a view spec's options object from its already-assigned defaults and overrides
	    ViewSpecManager.prototype.buildViewSpecOptions = function (spec) {
	        var optionsManager = this.optionsManager;
	        spec.options = options_1.mergeOptions([
	            options_1.globalDefaults,
	            spec.defaults,
	            optionsManager.dirDefaults,
	            optionsManager.localeDefaults,
	            optionsManager.overrides,
	            spec.overrides,
	            optionsManager.dynamicOverrides // dynamically set via setter. highest precedence
	        ]);
	        locale_1.populateInstanceComputableOptions(spec.options);
	    };
	    // Computes and assigns a view spec's buttonText-related options
	    ViewSpecManager.prototype.buildViewSpecButtonText = function (spec, requestedViewType) {
	        var optionsManager = this.optionsManager;
	        // given an options object with a possible `buttonText` hash, lookup the buttonText for the
	        // requested view, falling back to a generic unit entry like "week" or "day"
	        function queryButtonText(options) {
	            var buttonText = options.buttonText || {};
	            return buttonText[requestedViewType] ||
	                // view can decide to look up a certain key
	                (spec.buttonTextKey ? buttonText[spec.buttonTextKey] : null) ||
	                // a key like "month"
	                (spec.singleUnit ? buttonText[spec.singleUnit] : null);
	        }
	        // highest to lowest priority
	        spec.buttonTextOverride =
	            queryButtonText(optionsManager.dynamicOverrides) ||
	                queryButtonText(optionsManager.overrides) || // constructor-specified buttonText lookup hash takes precedence
	                spec.overrides.buttonText; // `buttonText` for view-specific options is a string
	        // highest to lowest priority. mirrors buildViewSpecOptions
	        spec.buttonTextDefault =
	            queryButtonText(optionsManager.localeDefaults) ||
	                queryButtonText(optionsManager.dirDefaults) ||
	                spec.defaults.buttonText || // a single string. from ViewSubclass.defaults
	                queryButtonText(options_1.globalDefaults) ||
	                (spec.duration ? this._calendar.humanizeDuration(spec.duration) : null) || // like "3 days"
	                requestedViewType; // fall back to given view name
	    };
	    return ViewSpecManager;
	}());
	exports.default = ViewSpecManager;
	
	
	/***/ }),
	/* 260 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventSourceParser_1 = __webpack_require__(38);
	var ArrayEventSource_1 = __webpack_require__(56);
	var FuncEventSource_1 = __webpack_require__(223);
	var JsonFeedEventSource_1 = __webpack_require__(224);
	EventSourceParser_1.default.registerClass(ArrayEventSource_1.default);
	EventSourceParser_1.default.registerClass(FuncEventSource_1.default);
	EventSourceParser_1.default.registerClass(JsonFeedEventSource_1.default);
	
	
	/***/ }),
	/* 261 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var ThemeRegistry_1 = __webpack_require__(57);
	var StandardTheme_1 = __webpack_require__(221);
	var JqueryUiTheme_1 = __webpack_require__(222);
	var Bootstrap3Theme_1 = __webpack_require__(262);
	var Bootstrap4Theme_1 = __webpack_require__(263);
	ThemeRegistry_1.defineThemeSystem('standard', StandardTheme_1.default);
	ThemeRegistry_1.defineThemeSystem('jquery-ui', JqueryUiTheme_1.default);
	ThemeRegistry_1.defineThemeSystem('bootstrap3', Bootstrap3Theme_1.default);
	ThemeRegistry_1.defineThemeSystem('bootstrap4', Bootstrap4Theme_1.default);
	
	
	/***/ }),
	/* 262 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var Theme_1 = __webpack_require__(22);
	var Bootstrap3Theme = /** @class */ (function (_super) {
	    tslib_1.__extends(Bootstrap3Theme, _super);
	    function Bootstrap3Theme() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return Bootstrap3Theme;
	}(Theme_1.default));
	exports.default = Bootstrap3Theme;
	Bootstrap3Theme.prototype.classes = {
	    widget: 'fc-bootstrap3',
	    tableGrid: 'table-bordered',
	    tableList: 'table',
	    tableListHeading: 'active',
	    buttonGroup: 'btn-group',
	    button: 'btn btn-default',
	    stateActive: 'active',
	    stateDisabled: 'disabled',
	    today: 'alert alert-info',
	    popover: 'panel panel-default',
	    popoverHeader: 'panel-heading',
	    popoverContent: 'panel-body',
	    // day grid
	    // for left/right border color when border is inset from edges (all-day in agenda view)
	    // avoid `panel` class b/c don't want margins/radius. only border color.
	    headerRow: 'panel-default',
	    dayRow: 'panel-default',
	    // list view
	    listView: 'panel panel-default'
	};
	Bootstrap3Theme.prototype.baseIconClass = 'glyphicon';
	Bootstrap3Theme.prototype.iconClasses = {
	    close: 'glyphicon-remove',
	    prev: 'glyphicon-chevron-left',
	    next: 'glyphicon-chevron-right',
	    prevYear: 'glyphicon-backward',
	    nextYear: 'glyphicon-forward'
	};
	Bootstrap3Theme.prototype.iconOverrideOption = 'bootstrapGlyphicons';
	Bootstrap3Theme.prototype.iconOverrideCustomButtonOption = 'bootstrapGlyphicon';
	Bootstrap3Theme.prototype.iconOverridePrefix = 'glyphicon-';
	
	
	/***/ }),
	/* 263 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var Theme_1 = __webpack_require__(22);
	var Bootstrap4Theme = /** @class */ (function (_super) {
	    tslib_1.__extends(Bootstrap4Theme, _super);
	    function Bootstrap4Theme() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return Bootstrap4Theme;
	}(Theme_1.default));
	exports.default = Bootstrap4Theme;
	Bootstrap4Theme.prototype.classes = {
	    widget: 'fc-bootstrap4',
	    tableGrid: 'table-bordered',
	    tableList: 'table',
	    tableListHeading: 'table-active',
	    buttonGroup: 'btn-group',
	    button: 'btn btn-primary',
	    stateActive: 'active',
	    stateDisabled: 'disabled',
	    today: 'alert alert-info',
	    popover: 'card card-primary',
	    popoverHeader: 'card-header',
	    popoverContent: 'card-body',
	    // day grid
	    // for left/right border color when border is inset from edges (all-day in agenda view)
	    // avoid `table` class b/c don't want margins/padding/structure. only border color.
	    headerRow: 'table-bordered',
	    dayRow: 'table-bordered',
	    // list view
	    listView: 'card card-primary'
	};
	Bootstrap4Theme.prototype.baseIconClass = 'fa';
	Bootstrap4Theme.prototype.iconClasses = {
	    close: 'fa-times',
	    prev: 'fa-chevron-left',
	    next: 'fa-chevron-right',
	    prevYear: 'fa-angle-double-left',
	    nextYear: 'fa-angle-double-right'
	};
	Bootstrap4Theme.prototype.iconOverrideOption = 'bootstrapFontAwesome';
	Bootstrap4Theme.prototype.iconOverrideCustomButtonOption = 'bootstrapFontAwesome';
	Bootstrap4Theme.prototype.iconOverridePrefix = 'fa-';
	
	
	/***/ }),
	/* 264 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var ViewRegistry_1 = __webpack_require__(24);
	var BasicView_1 = __webpack_require__(67);
	var MonthView_1 = __webpack_require__(246);
	ViewRegistry_1.defineView('basic', {
	    'class': BasicView_1.default
	});
	ViewRegistry_1.defineView('basicDay', {
	    type: 'basic',
	    duration: { days: 1 }
	});
	ViewRegistry_1.defineView('basicWeek', {
	    type: 'basic',
	    duration: { weeks: 1 }
	});
	ViewRegistry_1.defineView('month', {
	    'class': MonthView_1.default,
	    duration: { months: 1 },
	    defaults: {
	        fixedWeekCount: true
	    }
	});
	
	
	/***/ }),
	/* 265 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var ViewRegistry_1 = __webpack_require__(24);
	var AgendaView_1 = __webpack_require__(238);
	ViewRegistry_1.defineView('agenda', {
	    'class': AgendaView_1.default,
	    defaults: {
	        allDaySlot: true,
	        slotDuration: '00:30:00',
	        slotEventOverlap: true // a bad name. confused with overlap/constraint system
	    }
	});
	ViewRegistry_1.defineView('agendaDay', {
	    type: 'agenda',
	    duration: { days: 1 }
	});
	ViewRegistry_1.defineView('agendaWeek', {
	    type: 'agenda',
	    duration: { weeks: 1 }
	});
	
	
	/***/ }),
	/* 266 */
	/***/ (function(module, exports, __webpack_require__) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var ViewRegistry_1 = __webpack_require__(24);
	var ListView_1 = __webpack_require__(248);
	ViewRegistry_1.defineView('list', {
	    'class': ListView_1.default,
	    buttonTextKey: 'list',
	    defaults: {
	        buttonText: 'list',
	        listDayFormat: 'LL',
	        noEventsMessage: 'No events to display'
	    }
	});
	ViewRegistry_1.defineView('listDay', {
	    type: 'list',
	    duration: { days: 1 },
	    defaults: {
	        listDayFormat: 'dddd' // day-of-week is all we need. full date is probably in header
	    }
	});
	ViewRegistry_1.defineView('listWeek', {
	    type: 'list',
	    duration: { weeks: 1 },
	    defaults: {
	        listDayFormat: 'dddd',
	        listDayAltFormat: 'LL'
	    }
	});
	ViewRegistry_1.defineView('listMonth', {
	    type: 'list',
	    duration: { month: 1 },
	    defaults: {
	        listDayAltFormat: 'dddd' // day-of-week is nice-to-have
	    }
	});
	ViewRegistry_1.defineView('listYear', {
	    type: 'list',
	    duration: { year: 1 },
	    defaults: {
	        listDayAltFormat: 'dddd' // day-of-week is nice-to-have
	    }
	});
	
	
	/***/ }),
	/* 267 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports, "__esModule", { value: true });
	
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/he v1.2.0 by @mathias | MIT license */
	;(function(root) {
	
		// Detect free variables `exports`.
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`.
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`.
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		// All astral symbols.
		var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
		// All ASCII symbols (not just printable ASCII) except those listed in the
		// first column of the overrides table.
		// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
		var regexAsciiWhitelist = /[\x01-\x7F]/g;
		// All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
		// code points listed in the first column of the overrides table on
		// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
		var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
	
		var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
		var encodeMap = {'\xAD':'shy','\u200C':'zwnj','\u200D':'zwj','\u200E':'lrm','\u2063':'ic','\u2062':'it','\u2061':'af','\u200F':'rlm','\u200B':'ZeroWidthSpace','\u2060':'NoBreak','\u0311':'DownBreve','\u20DB':'tdot','\u20DC':'DotDot','\t':'Tab','\n':'NewLine','\u2008':'puncsp','\u205F':'MediumSpace','\u2009':'thinsp','\u200A':'hairsp','\u2004':'emsp13','\u2002':'ensp','\u2005':'emsp14','\u2003':'emsp','\u2007':'numsp','\xA0':'nbsp','\u205F\u200A':'ThickSpace','\u203E':'oline','_':'lowbar','\u2010':'dash','\u2013':'ndash','\u2014':'mdash','\u2015':'horbar',',':'comma',';':'semi','\u204F':'bsemi',':':'colon','\u2A74':'Colone','!':'excl','\xA1':'iexcl','?':'quest','\xBF':'iquest','.':'period','\u2025':'nldr','\u2026':'mldr','\xB7':'middot','\'':'apos','\u2018':'lsquo','\u2019':'rsquo','\u201A':'sbquo','\u2039':'lsaquo','\u203A':'rsaquo','"':'quot','\u201C':'ldquo','\u201D':'rdquo','\u201E':'bdquo','\xAB':'laquo','\xBB':'raquo','(':'lpar',')':'rpar','[':'lsqb',']':'rsqb','{':'lcub','}':'rcub','\u2308':'lceil','\u2309':'rceil','\u230A':'lfloor','\u230B':'rfloor','\u2985':'lopar','\u2986':'ropar','\u298B':'lbrke','\u298C':'rbrke','\u298D':'lbrkslu','\u298E':'rbrksld','\u298F':'lbrksld','\u2990':'rbrkslu','\u2991':'langd','\u2992':'rangd','\u2993':'lparlt','\u2994':'rpargt','\u2995':'gtlPar','\u2996':'ltrPar','\u27E6':'lobrk','\u27E7':'robrk','\u27E8':'lang','\u27E9':'rang','\u27EA':'Lang','\u27EB':'Rang','\u27EC':'loang','\u27ED':'roang','\u2772':'lbbrk','\u2773':'rbbrk','\u2016':'Vert','\xA7':'sect','\xB6':'para','@':'commat','*':'ast','/':'sol','undefined':null,'&':'amp','#':'num','%':'percnt','\u2030':'permil','\u2031':'pertenk','\u2020':'dagger','\u2021':'Dagger','\u2022':'bull','\u2043':'hybull','\u2032':'prime','\u2033':'Prime','\u2034':'tprime','\u2057':'qprime','\u2035':'bprime','\u2041':'caret','`':'grave','\xB4':'acute','\u02DC':'tilde','^':'Hat','\xAF':'macr','\u02D8':'breve','\u02D9':'dot','\xA8':'die','\u02DA':'ring','\u02DD':'dblac','\xB8':'cedil','\u02DB':'ogon','\u02C6':'circ','\u02C7':'caron','\xB0':'deg','\xA9':'copy','\xAE':'reg','\u2117':'copysr','\u2118':'wp','\u211E':'rx','\u2127':'mho','\u2129':'iiota','\u2190':'larr','\u219A':'nlarr','\u2192':'rarr','\u219B':'nrarr','\u2191':'uarr','\u2193':'darr','\u2194':'harr','\u21AE':'nharr','\u2195':'varr','\u2196':'nwarr','\u2197':'nearr','\u2198':'searr','\u2199':'swarr','\u219D':'rarrw','\u219D\u0338':'nrarrw','\u219E':'Larr','\u219F':'Uarr','\u21A0':'Rarr','\u21A1':'Darr','\u21A2':'larrtl','\u21A3':'rarrtl','\u21A4':'mapstoleft','\u21A5':'mapstoup','\u21A6':'map','\u21A7':'mapstodown','\u21A9':'larrhk','\u21AA':'rarrhk','\u21AB':'larrlp','\u21AC':'rarrlp','\u21AD':'harrw','\u21B0':'lsh','\u21B1':'rsh','\u21B2':'ldsh','\u21B3':'rdsh','\u21B5':'crarr','\u21B6':'cularr','\u21B7':'curarr','\u21BA':'olarr','\u21BB':'orarr','\u21BC':'lharu','\u21BD':'lhard','\u21BE':'uharr','\u21BF':'uharl','\u21C0':'rharu','\u21C1':'rhard','\u21C2':'dharr','\u21C3':'dharl','\u21C4':'rlarr','\u21C5':'udarr','\u21C6':'lrarr','\u21C7':'llarr','\u21C8':'uuarr','\u21C9':'rrarr','\u21CA':'ddarr','\u21CB':'lrhar','\u21CC':'rlhar','\u21D0':'lArr','\u21CD':'nlArr','\u21D1':'uArr','\u21D2':'rArr','\u21CF':'nrArr','\u21D3':'dArr','\u21D4':'iff','\u21CE':'nhArr','\u21D5':'vArr','\u21D6':'nwArr','\u21D7':'neArr','\u21D8':'seArr','\u21D9':'swArr','\u21DA':'lAarr','\u21DB':'rAarr','\u21DD':'zigrarr','\u21E4':'larrb','\u21E5':'rarrb','\u21F5':'duarr','\u21FD':'loarr','\u21FE':'roarr','\u21FF':'hoarr','\u2200':'forall','\u2201':'comp','\u2202':'part','\u2202\u0338':'npart','\u2203':'exist','\u2204':'nexist','\u2205':'empty','\u2207':'Del','\u2208':'in','\u2209':'notin','\u220B':'ni','\u220C':'notni','\u03F6':'bepsi','\u220F':'prod','\u2210':'coprod','\u2211':'sum','+':'plus','\xB1':'pm','\xF7':'div','\xD7':'times','<':'lt','\u226E':'nlt','<\u20D2':'nvlt','=':'equals','\u2260':'ne','=\u20E5':'bne','\u2A75':'Equal','>':'gt','\u226F':'ngt','>\u20D2':'nvgt','\xAC':'not','|':'vert','\xA6':'brvbar','\u2212':'minus','\u2213':'mp','\u2214':'plusdo','\u2044':'frasl','\u2216':'setmn','\u2217':'lowast','\u2218':'compfn','\u221A':'Sqrt','\u221D':'prop','\u221E':'infin','\u221F':'angrt','\u2220':'ang','\u2220\u20D2':'nang','\u2221':'angmsd','\u2222':'angsph','\u2223':'mid','\u2224':'nmid','\u2225':'par','\u2226':'npar','\u2227':'and','\u2228':'or','\u2229':'cap','\u2229\uFE00':'caps','\u222A':'cup','\u222A\uFE00':'cups','\u222B':'int','\u222C':'Int','\u222D':'tint','\u2A0C':'qint','\u222E':'oint','\u222F':'Conint','\u2230':'Cconint','\u2231':'cwint','\u2232':'cwconint','\u2233':'awconint','\u2234':'there4','\u2235':'becaus','\u2236':'ratio','\u2237':'Colon','\u2238':'minusd','\u223A':'mDDot','\u223B':'homtht','\u223C':'sim','\u2241':'nsim','\u223C\u20D2':'nvsim','\u223D':'bsim','\u223D\u0331':'race','\u223E':'ac','\u223E\u0333':'acE','\u223F':'acd','\u2240':'wr','\u2242':'esim','\u2242\u0338':'nesim','\u2243':'sime','\u2244':'nsime','\u2245':'cong','\u2247':'ncong','\u2246':'simne','\u2248':'ap','\u2249':'nap','\u224A':'ape','\u224B':'apid','\u224B\u0338':'napid','\u224C':'bcong','\u224D':'CupCap','\u226D':'NotCupCap','\u224D\u20D2':'nvap','\u224E':'bump','\u224E\u0338':'nbump','\u224F':'bumpe','\u224F\u0338':'nbumpe','\u2250':'doteq','\u2250\u0338':'nedot','\u2251':'eDot','\u2252':'efDot','\u2253':'erDot','\u2254':'colone','\u2255':'ecolon','\u2256':'ecir','\u2257':'cire','\u2259':'wedgeq','\u225A':'veeeq','\u225C':'trie','\u225F':'equest','\u2261':'equiv','\u2262':'nequiv','\u2261\u20E5':'bnequiv','\u2264':'le','\u2270':'nle','\u2264\u20D2':'nvle','\u2265':'ge','\u2271':'nge','\u2265\u20D2':'nvge','\u2266':'lE','\u2266\u0338':'nlE','\u2267':'gE','\u2267\u0338':'ngE','\u2268\uFE00':'lvnE','\u2268':'lnE','\u2269':'gnE','\u2269\uFE00':'gvnE','\u226A':'ll','\u226A\u0338':'nLtv','\u226A\u20D2':'nLt','\u226B':'gg','\u226B\u0338':'nGtv','\u226B\u20D2':'nGt','\u226C':'twixt','\u2272':'lsim','\u2274':'nlsim','\u2273':'gsim','\u2275':'ngsim','\u2276':'lg','\u2278':'ntlg','\u2277':'gl','\u2279':'ntgl','\u227A':'pr','\u2280':'npr','\u227B':'sc','\u2281':'nsc','\u227C':'prcue','\u22E0':'nprcue','\u227D':'sccue','\u22E1':'nsccue','\u227E':'prsim','\u227F':'scsim','\u227F\u0338':'NotSucceedsTilde','\u2282':'sub','\u2284':'nsub','\u2282\u20D2':'vnsub','\u2283':'sup','\u2285':'nsup','\u2283\u20D2':'vnsup','\u2286':'sube','\u2288':'nsube','\u2287':'supe','\u2289':'nsupe','\u228A\uFE00':'vsubne','\u228A':'subne','\u228B\uFE00':'vsupne','\u228B':'supne','\u228D':'cupdot','\u228E':'uplus','\u228F':'sqsub','\u228F\u0338':'NotSquareSubset','\u2290':'sqsup','\u2290\u0338':'NotSquareSuperset','\u2291':'sqsube','\u22E2':'nsqsube','\u2292':'sqsupe','\u22E3':'nsqsupe','\u2293':'sqcap','\u2293\uFE00':'sqcaps','\u2294':'sqcup','\u2294\uFE00':'sqcups','\u2295':'oplus','\u2296':'ominus','\u2297':'otimes','\u2298':'osol','\u2299':'odot','\u229A':'ocir','\u229B':'oast','\u229D':'odash','\u229E':'plusb','\u229F':'minusb','\u22A0':'timesb','\u22A1':'sdotb','\u22A2':'vdash','\u22AC':'nvdash','\u22A3':'dashv','\u22A4':'top','\u22A5':'bot','\u22A7':'models','\u22A8':'vDash','\u22AD':'nvDash','\u22A9':'Vdash','\u22AE':'nVdash','\u22AA':'Vvdash','\u22AB':'VDash','\u22AF':'nVDash','\u22B0':'prurel','\u22B2':'vltri','\u22EA':'nltri','\u22B3':'vrtri','\u22EB':'nrtri','\u22B4':'ltrie','\u22EC':'nltrie','\u22B4\u20D2':'nvltrie','\u22B5':'rtrie','\u22ED':'nrtrie','\u22B5\u20D2':'nvrtrie','\u22B6':'origof','\u22B7':'imof','\u22B8':'mumap','\u22B9':'hercon','\u22BA':'intcal','\u22BB':'veebar','\u22BD':'barvee','\u22BE':'angrtvb','\u22BF':'lrtri','\u22C0':'Wedge','\u22C1':'Vee','\u22C2':'xcap','\u22C3':'xcup','\u22C4':'diam','\u22C5':'sdot','\u22C6':'Star','\u22C7':'divonx','\u22C8':'bowtie','\u22C9':'ltimes','\u22CA':'rtimes','\u22CB':'lthree','\u22CC':'rthree','\u22CD':'bsime','\u22CE':'cuvee','\u22CF':'cuwed','\u22D0':'Sub','\u22D1':'Sup','\u22D2':'Cap','\u22D3':'Cup','\u22D4':'fork','\u22D5':'epar','\u22D6':'ltdot','\u22D7':'gtdot','\u22D8':'Ll','\u22D8\u0338':'nLl','\u22D9':'Gg','\u22D9\u0338':'nGg','\u22DA\uFE00':'lesg','\u22DA':'leg','\u22DB':'gel','\u22DB\uFE00':'gesl','\u22DE':'cuepr','\u22DF':'cuesc','\u22E6':'lnsim','\u22E7':'gnsim','\u22E8':'prnsim','\u22E9':'scnsim','\u22EE':'vellip','\u22EF':'ctdot','\u22F0':'utdot','\u22F1':'dtdot','\u22F2':'disin','\u22F3':'isinsv','\u22F4':'isins','\u22F5':'isindot','\u22F5\u0338':'notindot','\u22F6':'notinvc','\u22F7':'notinvb','\u22F9':'isinE','\u22F9\u0338':'notinE','\u22FA':'nisd','\u22FB':'xnis','\u22FC':'nis','\u22FD':'notnivc','\u22FE':'notnivb','\u2305':'barwed','\u2306':'Barwed','\u230C':'drcrop','\u230D':'dlcrop','\u230E':'urcrop','\u230F':'ulcrop','\u2310':'bnot','\u2312':'profline','\u2313':'profsurf','\u2315':'telrec','\u2316':'target','\u231C':'ulcorn','\u231D':'urcorn','\u231E':'dlcorn','\u231F':'drcorn','\u2322':'frown','\u2323':'smile','\u232D':'cylcty','\u232E':'profalar','\u2336':'topbot','\u233D':'ovbar','\u233F':'solbar','\u237C':'angzarr','\u23B0':'lmoust','\u23B1':'rmoust','\u23B4':'tbrk','\u23B5':'bbrk','\u23B6':'bbrktbrk','\u23DC':'OverParenthesis','\u23DD':'UnderParenthesis','\u23DE':'OverBrace','\u23DF':'UnderBrace','\u23E2':'trpezium','\u23E7':'elinters','\u2423':'blank','\u2500':'boxh','\u2502':'boxv','\u250C':'boxdr','\u2510':'boxdl','\u2514':'boxur','\u2518':'boxul','\u251C':'boxvr','\u2524':'boxvl','\u252C':'boxhd','\u2534':'boxhu','\u253C':'boxvh','\u2550':'boxH','\u2551':'boxV','\u2552':'boxdR','\u2553':'boxDr','\u2554':'boxDR','\u2555':'boxdL','\u2556':'boxDl','\u2557':'boxDL','\u2558':'boxuR','\u2559':'boxUr','\u255A':'boxUR','\u255B':'boxuL','\u255C':'boxUl','\u255D':'boxUL','\u255E':'boxvR','\u255F':'boxVr','\u2560':'boxVR','\u2561':'boxvL','\u2562':'boxVl','\u2563':'boxVL','\u2564':'boxHd','\u2565':'boxhD','\u2566':'boxHD','\u2567':'boxHu','\u2568':'boxhU','\u2569':'boxHU','\u256A':'boxvH','\u256B':'boxVh','\u256C':'boxVH','\u2580':'uhblk','\u2584':'lhblk','\u2588':'block','\u2591':'blk14','\u2592':'blk12','\u2593':'blk34','\u25A1':'squ','\u25AA':'squf','\u25AB':'EmptyVerySmallSquare','\u25AD':'rect','\u25AE':'marker','\u25B1':'fltns','\u25B3':'xutri','\u25B4':'utrif','\u25B5':'utri','\u25B8':'rtrif','\u25B9':'rtri','\u25BD':'xdtri','\u25BE':'dtrif','\u25BF':'dtri','\u25C2':'ltrif','\u25C3':'ltri','\u25CA':'loz','\u25CB':'cir','\u25EC':'tridot','\u25EF':'xcirc','\u25F8':'ultri','\u25F9':'urtri','\u25FA':'lltri','\u25FB':'EmptySmallSquare','\u25FC':'FilledSmallSquare','\u2605':'starf','\u2606':'star','\u260E':'phone','\u2640':'female','\u2642':'male','\u2660':'spades','\u2663':'clubs','\u2665':'hearts','\u2666':'diams','\u266A':'sung','\u2713':'check','\u2717':'cross','\u2720':'malt','\u2736':'sext','\u2758':'VerticalSeparator','\u27C8':'bsolhsub','\u27C9':'suphsol','\u27F5':'xlarr','\u27F6':'xrarr','\u27F7':'xharr','\u27F8':'xlArr','\u27F9':'xrArr','\u27FA':'xhArr','\u27FC':'xmap','\u27FF':'dzigrarr','\u2902':'nvlArr','\u2903':'nvrArr','\u2904':'nvHarr','\u2905':'Map','\u290C':'lbarr','\u290D':'rbarr','\u290E':'lBarr','\u290F':'rBarr','\u2910':'RBarr','\u2911':'DDotrahd','\u2912':'UpArrowBar','\u2913':'DownArrowBar','\u2916':'Rarrtl','\u2919':'latail','\u291A':'ratail','\u291B':'lAtail','\u291C':'rAtail','\u291D':'larrfs','\u291E':'rarrfs','\u291F':'larrbfs','\u2920':'rarrbfs','\u2923':'nwarhk','\u2924':'nearhk','\u2925':'searhk','\u2926':'swarhk','\u2927':'nwnear','\u2928':'toea','\u2929':'tosa','\u292A':'swnwar','\u2933':'rarrc','\u2933\u0338':'nrarrc','\u2935':'cudarrr','\u2936':'ldca','\u2937':'rdca','\u2938':'cudarrl','\u2939':'larrpl','\u293C':'curarrm','\u293D':'cularrp','\u2945':'rarrpl','\u2948':'harrcir','\u2949':'Uarrocir','\u294A':'lurdshar','\u294B':'ldrushar','\u294E':'LeftRightVector','\u294F':'RightUpDownVector','\u2950':'DownLeftRightVector','\u2951':'LeftUpDownVector','\u2952':'LeftVectorBar','\u2953':'RightVectorBar','\u2954':'RightUpVectorBar','\u2955':'RightDownVectorBar','\u2956':'DownLeftVectorBar','\u2957':'DownRightVectorBar','\u2958':'LeftUpVectorBar','\u2959':'LeftDownVectorBar','\u295A':'LeftTeeVector','\u295B':'RightTeeVector','\u295C':'RightUpTeeVector','\u295D':'RightDownTeeVector','\u295E':'DownLeftTeeVector','\u295F':'DownRightTeeVector','\u2960':'LeftUpTeeVector','\u2961':'LeftDownTeeVector','\u2962':'lHar','\u2963':'uHar','\u2964':'rHar','\u2965':'dHar','\u2966':'luruhar','\u2967':'ldrdhar','\u2968':'ruluhar','\u2969':'rdldhar','\u296A':'lharul','\u296B':'llhard','\u296C':'rharul','\u296D':'lrhard','\u296E':'udhar','\u296F':'duhar','\u2970':'RoundImplies','\u2971':'erarr','\u2972':'simrarr','\u2973':'larrsim','\u2974':'rarrsim','\u2975':'rarrap','\u2976':'ltlarr','\u2978':'gtrarr','\u2979':'subrarr','\u297B':'suplarr','\u297C':'lfisht','\u297D':'rfisht','\u297E':'ufisht','\u297F':'dfisht','\u299A':'vzigzag','\u299C':'vangrt','\u299D':'angrtvbd','\u29A4':'ange','\u29A5':'range','\u29A6':'dwangle','\u29A7':'uwangle','\u29A8':'angmsdaa','\u29A9':'angmsdab','\u29AA':'angmsdac','\u29AB':'angmsdad','\u29AC':'angmsdae','\u29AD':'angmsdaf','\u29AE':'angmsdag','\u29AF':'angmsdah','\u29B0':'bemptyv','\u29B1':'demptyv','\u29B2':'cemptyv','\u29B3':'raemptyv','\u29B4':'laemptyv','\u29B5':'ohbar','\u29B6':'omid','\u29B7':'opar','\u29B9':'operp','\u29BB':'olcross','\u29BC':'odsold','\u29BE':'olcir','\u29BF':'ofcir','\u29C0':'olt','\u29C1':'ogt','\u29C2':'cirscir','\u29C3':'cirE','\u29C4':'solb','\u29C5':'bsolb','\u29C9':'boxbox','\u29CD':'trisb','\u29CE':'rtriltri','\u29CF':'LeftTriangleBar','\u29CF\u0338':'NotLeftTriangleBar','\u29D0':'RightTriangleBar','\u29D0\u0338':'NotRightTriangleBar','\u29DC':'iinfin','\u29DD':'infintie','\u29DE':'nvinfin','\u29E3':'eparsl','\u29E4':'smeparsl','\u29E5':'eqvparsl','\u29EB':'lozf','\u29F4':'RuleDelayed','\u29F6':'dsol','\u2A00':'xodot','\u2A01':'xoplus','\u2A02':'xotime','\u2A04':'xuplus','\u2A06':'xsqcup','\u2A0D':'fpartint','\u2A10':'cirfnint','\u2A11':'awint','\u2A12':'rppolint','\u2A13':'scpolint','\u2A14':'npolint','\u2A15':'pointint','\u2A16':'quatint','\u2A17':'intlarhk','\u2A22':'pluscir','\u2A23':'plusacir','\u2A24':'simplus','\u2A25':'plusdu','\u2A26':'plussim','\u2A27':'plustwo','\u2A29':'mcomma','\u2A2A':'minusdu','\u2A2D':'loplus','\u2A2E':'roplus','\u2A2F':'Cross','\u2A30':'timesd','\u2A31':'timesbar','\u2A33':'smashp','\u2A34':'lotimes','\u2A35':'rotimes','\u2A36':'otimesas','\u2A37':'Otimes','\u2A38':'odiv','\u2A39':'triplus','\u2A3A':'triminus','\u2A3B':'tritime','\u2A3C':'iprod','\u2A3F':'amalg','\u2A40':'capdot','\u2A42':'ncup','\u2A43':'ncap','\u2A44':'capand','\u2A45':'cupor','\u2A46':'cupcap','\u2A47':'capcup','\u2A48':'cupbrcap','\u2A49':'capbrcup','\u2A4A':'cupcup','\u2A4B':'capcap','\u2A4C':'ccups','\u2A4D':'ccaps','\u2A50':'ccupssm','\u2A53':'And','\u2A54':'Or','\u2A55':'andand','\u2A56':'oror','\u2A57':'orslope','\u2A58':'andslope','\u2A5A':'andv','\u2A5B':'orv','\u2A5C':'andd','\u2A5D':'ord','\u2A5F':'wedbar','\u2A66':'sdote','\u2A6A':'simdot','\u2A6D':'congdot','\u2A6D\u0338':'ncongdot','\u2A6E':'easter','\u2A6F':'apacir','\u2A70':'apE','\u2A70\u0338':'napE','\u2A71':'eplus','\u2A72':'pluse','\u2A73':'Esim','\u2A77':'eDDot','\u2A78':'equivDD','\u2A79':'ltcir','\u2A7A':'gtcir','\u2A7B':'ltquest','\u2A7C':'gtquest','\u2A7D':'les','\u2A7D\u0338':'nles','\u2A7E':'ges','\u2A7E\u0338':'nges','\u2A7F':'lesdot','\u2A80':'gesdot','\u2A81':'lesdoto','\u2A82':'gesdoto','\u2A83':'lesdotor','\u2A84':'gesdotol','\u2A85':'lap','\u2A86':'gap','\u2A87':'lne','\u2A88':'gne','\u2A89':'lnap','\u2A8A':'gnap','\u2A8B':'lEg','\u2A8C':'gEl','\u2A8D':'lsime','\u2A8E':'gsime','\u2A8F':'lsimg','\u2A90':'gsiml','\u2A91':'lgE','\u2A92':'glE','\u2A93':'lesges','\u2A94':'gesles','\u2A95':'els','\u2A96':'egs','\u2A97':'elsdot','\u2A98':'egsdot','\u2A99':'el','\u2A9A':'eg','\u2A9D':'siml','\u2A9E':'simg','\u2A9F':'simlE','\u2AA0':'simgE','\u2AA1':'LessLess','\u2AA1\u0338':'NotNestedLessLess','\u2AA2':'GreaterGreater','\u2AA2\u0338':'NotNestedGreaterGreater','\u2AA4':'glj','\u2AA5':'gla','\u2AA6':'ltcc','\u2AA7':'gtcc','\u2AA8':'lescc','\u2AA9':'gescc','\u2AAA':'smt','\u2AAB':'lat','\u2AAC':'smte','\u2AAC\uFE00':'smtes','\u2AAD':'late','\u2AAD\uFE00':'lates','\u2AAE':'bumpE','\u2AAF':'pre','\u2AAF\u0338':'npre','\u2AB0':'sce','\u2AB0\u0338':'nsce','\u2AB3':'prE','\u2AB4':'scE','\u2AB5':'prnE','\u2AB6':'scnE','\u2AB7':'prap','\u2AB8':'scap','\u2AB9':'prnap','\u2ABA':'scnap','\u2ABB':'Pr','\u2ABC':'Sc','\u2ABD':'subdot','\u2ABE':'supdot','\u2ABF':'subplus','\u2AC0':'supplus','\u2AC1':'submult','\u2AC2':'supmult','\u2AC3':'subedot','\u2AC4':'supedot','\u2AC5':'subE','\u2AC5\u0338':'nsubE','\u2AC6':'supE','\u2AC6\u0338':'nsupE','\u2AC7':'subsim','\u2AC8':'supsim','\u2ACB\uFE00':'vsubnE','\u2ACB':'subnE','\u2ACC\uFE00':'vsupnE','\u2ACC':'supnE','\u2ACF':'csub','\u2AD0':'csup','\u2AD1':'csube','\u2AD2':'csupe','\u2AD3':'subsup','\u2AD4':'supsub','\u2AD5':'subsub','\u2AD6':'supsup','\u2AD7':'suphsub','\u2AD8':'supdsub','\u2AD9':'forkv','\u2ADA':'topfork','\u2ADB':'mlcp','\u2AE4':'Dashv','\u2AE6':'Vdashl','\u2AE7':'Barv','\u2AE8':'vBar','\u2AE9':'vBarv','\u2AEB':'Vbar','\u2AEC':'Not','\u2AED':'bNot','\u2AEE':'rnmid','\u2AEF':'cirmid','\u2AF0':'midcir','\u2AF1':'topcir','\u2AF2':'nhpar','\u2AF3':'parsim','\u2AFD':'parsl','\u2AFD\u20E5':'nparsl','\u266D':'flat','\u266E':'natur','\u266F':'sharp','\xA4':'curren','\xA2':'cent','$':'dollar','\xA3':'pound','\xA5':'yen','\u20AC':'euro','\xB9':'sup1','\xBD':'half','\u2153':'frac13','\xBC':'frac14','\u2155':'frac15','\u2159':'frac16','\u215B':'frac18','\xB2':'sup2','\u2154':'frac23','\u2156':'frac25','\xB3':'sup3','\xBE':'frac34','\u2157':'frac35','\u215C':'frac38','\u2158':'frac45','\u215A':'frac56','\u215D':'frac58','\u215E':'frac78','\uD835\uDCB6':'ascr','\uD835\uDD52':'aopf','\uD835\uDD1E':'afr','\uD835\uDD38':'Aopf','\uD835\uDD04':'Afr','\uD835\uDC9C':'Ascr','\xAA':'ordf','\xE1':'aacute','\xC1':'Aacute','\xE0':'agrave','\xC0':'Agrave','\u0103':'abreve','\u0102':'Abreve','\xE2':'acirc','\xC2':'Acirc','\xE5':'aring','\xC5':'angst','\xE4':'auml','\xC4':'Auml','\xE3':'atilde','\xC3':'Atilde','\u0105':'aogon','\u0104':'Aogon','\u0101':'amacr','\u0100':'Amacr','\xE6':'aelig','\xC6':'AElig','\uD835\uDCB7':'bscr','\uD835\uDD53':'bopf','\uD835\uDD1F':'bfr','\uD835\uDD39':'Bopf','\u212C':'Bscr','\uD835\uDD05':'Bfr','\uD835\uDD20':'cfr','\uD835\uDCB8':'cscr','\uD835\uDD54':'copf','\u212D':'Cfr','\uD835\uDC9E':'Cscr','\u2102':'Copf','\u0107':'cacute','\u0106':'Cacute','\u0109':'ccirc','\u0108':'Ccirc','\u010D':'ccaron','\u010C':'Ccaron','\u010B':'cdot','\u010A':'Cdot','\xE7':'ccedil','\xC7':'Ccedil','\u2105':'incare','\uD835\uDD21':'dfr','\u2146':'dd','\uD835\uDD55':'dopf','\uD835\uDCB9':'dscr','\uD835\uDC9F':'Dscr','\uD835\uDD07':'Dfr','\u2145':'DD','\uD835\uDD3B':'Dopf','\u010F':'dcaron','\u010E':'Dcaron','\u0111':'dstrok','\u0110':'Dstrok','\xF0':'eth','\xD0':'ETH','\u2147':'ee','\u212F':'escr','\uD835\uDD22':'efr','\uD835\uDD56':'eopf','\u2130':'Escr','\uD835\uDD08':'Efr','\uD835\uDD3C':'Eopf','\xE9':'eacute','\xC9':'Eacute','\xE8':'egrave','\xC8':'Egrave','\xEA':'ecirc','\xCA':'Ecirc','\u011B':'ecaron','\u011A':'Ecaron','\xEB':'euml','\xCB':'Euml','\u0117':'edot','\u0116':'Edot','\u0119':'eogon','\u0118':'Eogon','\u0113':'emacr','\u0112':'Emacr','\uD835\uDD23':'ffr','\uD835\uDD57':'fopf','\uD835\uDCBB':'fscr','\uD835\uDD09':'Ffr','\uD835\uDD3D':'Fopf','\u2131':'Fscr','\uFB00':'fflig','\uFB03':'ffilig','\uFB04':'ffllig','\uFB01':'filig','fj':'fjlig','\uFB02':'fllig','\u0192':'fnof','\u210A':'gscr','\uD835\uDD58':'gopf','\uD835\uDD24':'gfr','\uD835\uDCA2':'Gscr','\uD835\uDD3E':'Gopf','\uD835\uDD0A':'Gfr','\u01F5':'gacute','\u011F':'gbreve','\u011E':'Gbreve','\u011D':'gcirc','\u011C':'Gcirc','\u0121':'gdot','\u0120':'Gdot','\u0122':'Gcedil','\uD835\uDD25':'hfr','\u210E':'planckh','\uD835\uDCBD':'hscr','\uD835\uDD59':'hopf','\u210B':'Hscr','\u210C':'Hfr','\u210D':'Hopf','\u0125':'hcirc','\u0124':'Hcirc','\u210F':'hbar','\u0127':'hstrok','\u0126':'Hstrok','\uD835\uDD5A':'iopf','\uD835\uDD26':'ifr','\uD835\uDCBE':'iscr','\u2148':'ii','\uD835\uDD40':'Iopf','\u2110':'Iscr','\u2111':'Im','\xED':'iacute','\xCD':'Iacute','\xEC':'igrave','\xCC':'Igrave','\xEE':'icirc','\xCE':'Icirc','\xEF':'iuml','\xCF':'Iuml','\u0129':'itilde','\u0128':'Itilde','\u0130':'Idot','\u012F':'iogon','\u012E':'Iogon','\u012B':'imacr','\u012A':'Imacr','\u0133':'ijlig','\u0132':'IJlig','\u0131':'imath','\uD835\uDCBF':'jscr','\uD835\uDD5B':'jopf','\uD835\uDD27':'jfr','\uD835\uDCA5':'Jscr','\uD835\uDD0D':'Jfr','\uD835\uDD41':'Jopf','\u0135':'jcirc','\u0134':'Jcirc','\u0237':'jmath','\uD835\uDD5C':'kopf','\uD835\uDCC0':'kscr','\uD835\uDD28':'kfr','\uD835\uDCA6':'Kscr','\uD835\uDD42':'Kopf','\uD835\uDD0E':'Kfr','\u0137':'kcedil','\u0136':'Kcedil','\uD835\uDD29':'lfr','\uD835\uDCC1':'lscr','\u2113':'ell','\uD835\uDD5D':'lopf','\u2112':'Lscr','\uD835\uDD0F':'Lfr','\uD835\uDD43':'Lopf','\u013A':'lacute','\u0139':'Lacute','\u013E':'lcaron','\u013D':'Lcaron','\u013C':'lcedil','\u013B':'Lcedil','\u0142':'lstrok','\u0141':'Lstrok','\u0140':'lmidot','\u013F':'Lmidot','\uD835\uDD2A':'mfr','\uD835\uDD5E':'mopf','\uD835\uDCC2':'mscr','\uD835\uDD10':'Mfr','\uD835\uDD44':'Mopf','\u2133':'Mscr','\uD835\uDD2B':'nfr','\uD835\uDD5F':'nopf','\uD835\uDCC3':'nscr','\u2115':'Nopf','\uD835\uDCA9':'Nscr','\uD835\uDD11':'Nfr','\u0144':'nacute','\u0143':'Nacute','\u0148':'ncaron','\u0147':'Ncaron','\xF1':'ntilde','\xD1':'Ntilde','\u0146':'ncedil','\u0145':'Ncedil','\u2116':'numero','\u014B':'eng','\u014A':'ENG','\uD835\uDD60':'oopf','\uD835\uDD2C':'ofr','\u2134':'oscr','\uD835\uDCAA':'Oscr','\uD835\uDD12':'Ofr','\uD835\uDD46':'Oopf','\xBA':'ordm','\xF3':'oacute','\xD3':'Oacute','\xF2':'ograve','\xD2':'Ograve','\xF4':'ocirc','\xD4':'Ocirc','\xF6':'ouml','\xD6':'Ouml','\u0151':'odblac','\u0150':'Odblac','\xF5':'otilde','\xD5':'Otilde','\xF8':'oslash','\xD8':'Oslash','\u014D':'omacr','\u014C':'Omacr','\u0153':'oelig','\u0152':'OElig','\uD835\uDD2D':'pfr','\uD835\uDCC5':'pscr','\uD835\uDD61':'popf','\u2119':'Popf','\uD835\uDD13':'Pfr','\uD835\uDCAB':'Pscr','\uD835\uDD62':'qopf','\uD835\uDD2E':'qfr','\uD835\uDCC6':'qscr','\uD835\uDCAC':'Qscr','\uD835\uDD14':'Qfr','\u211A':'Qopf','\u0138':'kgreen','\uD835\uDD2F':'rfr','\uD835\uDD63':'ropf','\uD835\uDCC7':'rscr','\u211B':'Rscr','\u211C':'Re','\u211D':'Ropf','\u0155':'racute','\u0154':'Racute','\u0159':'rcaron','\u0158':'Rcaron','\u0157':'rcedil','\u0156':'Rcedil','\uD835\uDD64':'sopf','\uD835\uDCC8':'sscr','\uD835\uDD30':'sfr','\uD835\uDD4A':'Sopf','\uD835\uDD16':'Sfr','\uD835\uDCAE':'Sscr','\u24C8':'oS','\u015B':'sacute','\u015A':'Sacute','\u015D':'scirc','\u015C':'Scirc','\u0161':'scaron','\u0160':'Scaron','\u015F':'scedil','\u015E':'Scedil','\xDF':'szlig','\uD835\uDD31':'tfr','\uD835\uDCC9':'tscr','\uD835\uDD65':'topf','\uD835\uDCAF':'Tscr','\uD835\uDD17':'Tfr','\uD835\uDD4B':'Topf','\u0165':'tcaron','\u0164':'Tcaron','\u0163':'tcedil','\u0162':'Tcedil','\u2122':'trade','\u0167':'tstrok','\u0166':'Tstrok','\uD835\uDCCA':'uscr','\uD835\uDD66':'uopf','\uD835\uDD32':'ufr','\uD835\uDD4C':'Uopf','\uD835\uDD18':'Ufr','\uD835\uDCB0':'Uscr','\xFA':'uacute','\xDA':'Uacute','\xF9':'ugrave','\xD9':'Ugrave','\u016D':'ubreve','\u016C':'Ubreve','\xFB':'ucirc','\xDB':'Ucirc','\u016F':'uring','\u016E':'Uring','\xFC':'uuml','\xDC':'Uuml','\u0171':'udblac','\u0170':'Udblac','\u0169':'utilde','\u0168':'Utilde','\u0173':'uogon','\u0172':'Uogon','\u016B':'umacr','\u016A':'Umacr','\uD835\uDD33':'vfr','\uD835\uDD67':'vopf','\uD835\uDCCB':'vscr','\uD835\uDD19':'Vfr','\uD835\uDD4D':'Vopf','\uD835\uDCB1':'Vscr','\uD835\uDD68':'wopf','\uD835\uDCCC':'wscr','\uD835\uDD34':'wfr','\uD835\uDCB2':'Wscr','\uD835\uDD4E':'Wopf','\uD835\uDD1A':'Wfr','\u0175':'wcirc','\u0174':'Wcirc','\uD835\uDD35':'xfr','\uD835\uDCCD':'xscr','\uD835\uDD69':'xopf','\uD835\uDD4F':'Xopf','\uD835\uDD1B':'Xfr','\uD835\uDCB3':'Xscr','\uD835\uDD36':'yfr','\uD835\uDCCE':'yscr','\uD835\uDD6A':'yopf','\uD835\uDCB4':'Yscr','\uD835\uDD1C':'Yfr','\uD835\uDD50':'Yopf','\xFD':'yacute','\xDD':'Yacute','\u0177':'ycirc','\u0176':'Ycirc','\xFF':'yuml','\u0178':'Yuml','\uD835\uDCCF':'zscr','\uD835\uDD37':'zfr','\uD835\uDD6B':'zopf','\u2128':'Zfr','\u2124':'Zopf','\uD835\uDCB5':'Zscr','\u017A':'zacute','\u0179':'Zacute','\u017E':'zcaron','\u017D':'Zcaron','\u017C':'zdot','\u017B':'Zdot','\u01B5':'imped','\xFE':'thorn','\xDE':'THORN','\u0149':'napos','\u03B1':'alpha','\u0391':'Alpha','\u03B2':'beta','\u0392':'Beta','\u03B3':'gamma','\u0393':'Gamma','\u03B4':'delta','\u0394':'Delta','\u03B5':'epsi','\u03F5':'epsiv','\u0395':'Epsilon','\u03DD':'gammad','\u03DC':'Gammad','\u03B6':'zeta','\u0396':'Zeta','\u03B7':'eta','\u0397':'Eta','\u03B8':'theta','\u03D1':'thetav','\u0398':'Theta','\u03B9':'iota','\u0399':'Iota','\u03BA':'kappa','\u03F0':'kappav','\u039A':'Kappa','\u03BB':'lambda','\u039B':'Lambda','\u03BC':'mu','\xB5':'micro','\u039C':'Mu','\u03BD':'nu','\u039D':'Nu','\u03BE':'xi','\u039E':'Xi','\u03BF':'omicron','\u039F':'Omicron','\u03C0':'pi','\u03D6':'piv','\u03A0':'Pi','\u03C1':'rho','\u03F1':'rhov','\u03A1':'Rho','\u03C3':'sigma','\u03A3':'Sigma','\u03C2':'sigmaf','\u03C4':'tau','\u03A4':'Tau','\u03C5':'upsi','\u03A5':'Upsilon','\u03D2':'Upsi','\u03C6':'phi','\u03D5':'phiv','\u03A6':'Phi','\u03C7':'chi','\u03A7':'Chi','\u03C8':'psi','\u03A8':'Psi','\u03C9':'omega','\u03A9':'ohm','\u0430':'acy','\u0410':'Acy','\u0431':'bcy','\u0411':'Bcy','\u0432':'vcy','\u0412':'Vcy','\u0433':'gcy','\u0413':'Gcy','\u0453':'gjcy','\u0403':'GJcy','\u0434':'dcy','\u0414':'Dcy','\u0452':'djcy','\u0402':'DJcy','\u0435':'iecy','\u0415':'IEcy','\u0451':'iocy','\u0401':'IOcy','\u0454':'jukcy','\u0404':'Jukcy','\u0436':'zhcy','\u0416':'ZHcy','\u0437':'zcy','\u0417':'Zcy','\u0455':'dscy','\u0405':'DScy','\u0438':'icy','\u0418':'Icy','\u0456':'iukcy','\u0406':'Iukcy','\u0457':'yicy','\u0407':'YIcy','\u0439':'jcy','\u0419':'Jcy','\u0458':'jsercy','\u0408':'Jsercy','\u043A':'kcy','\u041A':'Kcy','\u045C':'kjcy','\u040C':'KJcy','\u043B':'lcy','\u041B':'Lcy','\u0459':'ljcy','\u0409':'LJcy','\u043C':'mcy','\u041C':'Mcy','\u043D':'ncy','\u041D':'Ncy','\u045A':'njcy','\u040A':'NJcy','\u043E':'ocy','\u041E':'Ocy','\u043F':'pcy','\u041F':'Pcy','\u0440':'rcy','\u0420':'Rcy','\u0441':'scy','\u0421':'Scy','\u0442':'tcy','\u0422':'Tcy','\u045B':'tshcy','\u040B':'TSHcy','\u0443':'ucy','\u0423':'Ucy','\u045E':'ubrcy','\u040E':'Ubrcy','\u0444':'fcy','\u0424':'Fcy','\u0445':'khcy','\u0425':'KHcy','\u0446':'tscy','\u0426':'TScy','\u0447':'chcy','\u0427':'CHcy','\u045F':'dzcy','\u040F':'DZcy','\u0448':'shcy','\u0428':'SHcy','\u0449':'shchcy','\u0429':'SHCHcy','\u044A':'hardcy','\u042A':'HARDcy','\u044B':'ycy','\u042B':'Ycy','\u044C':'softcy','\u042C':'SOFTcy','\u044D':'ecy','\u042D':'Ecy','\u044E':'yucy','\u042E':'YUcy','\u044F':'yacy','\u042F':'YAcy','\u2135':'aleph','\u2136':'beth','\u2137':'gimel','\u2138':'daleth'};
	
		var regexEscape = /["&'<>`]/g;
		var escapeMap = {
			'"': '&quot;',
			'&': '&amp;',
			'\'': '&#x27;',
			'<': '&lt;',
			// See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
			// following is not strictly necessary unless it’s part of a tag or an
			// unquoted attribute value. We’re only escaping it to support those
			// situations, and for XML support.
			'>': '&gt;',
			// In Internet Explorer ≤ 8, the backtick character can be used
			// to break out of (un)quoted attribute values or HTML comments.
			// See http://html5sec.org/#102, http://html5sec.org/#108, and
			// http://html5sec.org/#133.
			'`': '&#x60;'
		};
	
		var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
		var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
		var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
		var decodeMap = {'aacute':'\xE1','Aacute':'\xC1','abreve':'\u0103','Abreve':'\u0102','ac':'\u223E','acd':'\u223F','acE':'\u223E\u0333','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','acy':'\u0430','Acy':'\u0410','aelig':'\xE6','AElig':'\xC6','af':'\u2061','afr':'\uD835\uDD1E','Afr':'\uD835\uDD04','agrave':'\xE0','Agrave':'\xC0','alefsym':'\u2135','aleph':'\u2135','alpha':'\u03B1','Alpha':'\u0391','amacr':'\u0101','Amacr':'\u0100','amalg':'\u2A3F','amp':'&','AMP':'&','and':'\u2227','And':'\u2A53','andand':'\u2A55','andd':'\u2A5C','andslope':'\u2A58','andv':'\u2A5A','ang':'\u2220','ange':'\u29A4','angle':'\u2220','angmsd':'\u2221','angmsdaa':'\u29A8','angmsdab':'\u29A9','angmsdac':'\u29AA','angmsdad':'\u29AB','angmsdae':'\u29AC','angmsdaf':'\u29AD','angmsdag':'\u29AE','angmsdah':'\u29AF','angrt':'\u221F','angrtvb':'\u22BE','angrtvbd':'\u299D','angsph':'\u2222','angst':'\xC5','angzarr':'\u237C','aogon':'\u0105','Aogon':'\u0104','aopf':'\uD835\uDD52','Aopf':'\uD835\uDD38','ap':'\u2248','apacir':'\u2A6F','ape':'\u224A','apE':'\u2A70','apid':'\u224B','apos':'\'','ApplyFunction':'\u2061','approx':'\u2248','approxeq':'\u224A','aring':'\xE5','Aring':'\xC5','ascr':'\uD835\uDCB6','Ascr':'\uD835\uDC9C','Assign':'\u2254','ast':'*','asymp':'\u2248','asympeq':'\u224D','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','awconint':'\u2233','awint':'\u2A11','backcong':'\u224C','backepsilon':'\u03F6','backprime':'\u2035','backsim':'\u223D','backsimeq':'\u22CD','Backslash':'\u2216','Barv':'\u2AE7','barvee':'\u22BD','barwed':'\u2305','Barwed':'\u2306','barwedge':'\u2305','bbrk':'\u23B5','bbrktbrk':'\u23B6','bcong':'\u224C','bcy':'\u0431','Bcy':'\u0411','bdquo':'\u201E','becaus':'\u2235','because':'\u2235','Because':'\u2235','bemptyv':'\u29B0','bepsi':'\u03F6','bernou':'\u212C','Bernoullis':'\u212C','beta':'\u03B2','Beta':'\u0392','beth':'\u2136','between':'\u226C','bfr':'\uD835\uDD1F','Bfr':'\uD835\uDD05','bigcap':'\u22C2','bigcirc':'\u25EF','bigcup':'\u22C3','bigodot':'\u2A00','bigoplus':'\u2A01','bigotimes':'\u2A02','bigsqcup':'\u2A06','bigstar':'\u2605','bigtriangledown':'\u25BD','bigtriangleup':'\u25B3','biguplus':'\u2A04','bigvee':'\u22C1','bigwedge':'\u22C0','bkarow':'\u290D','blacklozenge':'\u29EB','blacksquare':'\u25AA','blacktriangle':'\u25B4','blacktriangledown':'\u25BE','blacktriangleleft':'\u25C2','blacktriangleright':'\u25B8','blank':'\u2423','blk12':'\u2592','blk14':'\u2591','blk34':'\u2593','block':'\u2588','bne':'=\u20E5','bnequiv':'\u2261\u20E5','bnot':'\u2310','bNot':'\u2AED','bopf':'\uD835\uDD53','Bopf':'\uD835\uDD39','bot':'\u22A5','bottom':'\u22A5','bowtie':'\u22C8','boxbox':'\u29C9','boxdl':'\u2510','boxdL':'\u2555','boxDl':'\u2556','boxDL':'\u2557','boxdr':'\u250C','boxdR':'\u2552','boxDr':'\u2553','boxDR':'\u2554','boxh':'\u2500','boxH':'\u2550','boxhd':'\u252C','boxhD':'\u2565','boxHd':'\u2564','boxHD':'\u2566','boxhu':'\u2534','boxhU':'\u2568','boxHu':'\u2567','boxHU':'\u2569','boxminus':'\u229F','boxplus':'\u229E','boxtimes':'\u22A0','boxul':'\u2518','boxuL':'\u255B','boxUl':'\u255C','boxUL':'\u255D','boxur':'\u2514','boxuR':'\u2558','boxUr':'\u2559','boxUR':'\u255A','boxv':'\u2502','boxV':'\u2551','boxvh':'\u253C','boxvH':'\u256A','boxVh':'\u256B','boxVH':'\u256C','boxvl':'\u2524','boxvL':'\u2561','boxVl':'\u2562','boxVL':'\u2563','boxvr':'\u251C','boxvR':'\u255E','boxVr':'\u255F','boxVR':'\u2560','bprime':'\u2035','breve':'\u02D8','Breve':'\u02D8','brvbar':'\xA6','bscr':'\uD835\uDCB7','Bscr':'\u212C','bsemi':'\u204F','bsim':'\u223D','bsime':'\u22CD','bsol':'\\','bsolb':'\u29C5','bsolhsub':'\u27C8','bull':'\u2022','bullet':'\u2022','bump':'\u224E','bumpe':'\u224F','bumpE':'\u2AAE','bumpeq':'\u224F','Bumpeq':'\u224E','cacute':'\u0107','Cacute':'\u0106','cap':'\u2229','Cap':'\u22D2','capand':'\u2A44','capbrcup':'\u2A49','capcap':'\u2A4B','capcup':'\u2A47','capdot':'\u2A40','CapitalDifferentialD':'\u2145','caps':'\u2229\uFE00','caret':'\u2041','caron':'\u02C7','Cayleys':'\u212D','ccaps':'\u2A4D','ccaron':'\u010D','Ccaron':'\u010C','ccedil':'\xE7','Ccedil':'\xC7','ccirc':'\u0109','Ccirc':'\u0108','Cconint':'\u2230','ccups':'\u2A4C','ccupssm':'\u2A50','cdot':'\u010B','Cdot':'\u010A','cedil':'\xB8','Cedilla':'\xB8','cemptyv':'\u29B2','cent':'\xA2','centerdot':'\xB7','CenterDot':'\xB7','cfr':'\uD835\uDD20','Cfr':'\u212D','chcy':'\u0447','CHcy':'\u0427','check':'\u2713','checkmark':'\u2713','chi':'\u03C7','Chi':'\u03A7','cir':'\u25CB','circ':'\u02C6','circeq':'\u2257','circlearrowleft':'\u21BA','circlearrowright':'\u21BB','circledast':'\u229B','circledcirc':'\u229A','circleddash':'\u229D','CircleDot':'\u2299','circledR':'\xAE','circledS':'\u24C8','CircleMinus':'\u2296','CirclePlus':'\u2295','CircleTimes':'\u2297','cire':'\u2257','cirE':'\u29C3','cirfnint':'\u2A10','cirmid':'\u2AEF','cirscir':'\u29C2','ClockwiseContourIntegral':'\u2232','CloseCurlyDoubleQuote':'\u201D','CloseCurlyQuote':'\u2019','clubs':'\u2663','clubsuit':'\u2663','colon':':','Colon':'\u2237','colone':'\u2254','Colone':'\u2A74','coloneq':'\u2254','comma':',','commat':'@','comp':'\u2201','compfn':'\u2218','complement':'\u2201','complexes':'\u2102','cong':'\u2245','congdot':'\u2A6D','Congruent':'\u2261','conint':'\u222E','Conint':'\u222F','ContourIntegral':'\u222E','copf':'\uD835\uDD54','Copf':'\u2102','coprod':'\u2210','Coproduct':'\u2210','copy':'\xA9','COPY':'\xA9','copysr':'\u2117','CounterClockwiseContourIntegral':'\u2233','crarr':'\u21B5','cross':'\u2717','Cross':'\u2A2F','cscr':'\uD835\uDCB8','Cscr':'\uD835\uDC9E','csub':'\u2ACF','csube':'\u2AD1','csup':'\u2AD0','csupe':'\u2AD2','ctdot':'\u22EF','cudarrl':'\u2938','cudarrr':'\u2935','cuepr':'\u22DE','cuesc':'\u22DF','cularr':'\u21B6','cularrp':'\u293D','cup':'\u222A','Cup':'\u22D3','cupbrcap':'\u2A48','cupcap':'\u2A46','CupCap':'\u224D','cupcup':'\u2A4A','cupdot':'\u228D','cupor':'\u2A45','cups':'\u222A\uFE00','curarr':'\u21B7','curarrm':'\u293C','curlyeqprec':'\u22DE','curlyeqsucc':'\u22DF','curlyvee':'\u22CE','curlywedge':'\u22CF','curren':'\xA4','curvearrowleft':'\u21B6','curvearrowright':'\u21B7','cuvee':'\u22CE','cuwed':'\u22CF','cwconint':'\u2232','cwint':'\u2231','cylcty':'\u232D','dagger':'\u2020','Dagger':'\u2021','daleth':'\u2138','darr':'\u2193','dArr':'\u21D3','Darr':'\u21A1','dash':'\u2010','dashv':'\u22A3','Dashv':'\u2AE4','dbkarow':'\u290F','dblac':'\u02DD','dcaron':'\u010F','Dcaron':'\u010E','dcy':'\u0434','Dcy':'\u0414','dd':'\u2146','DD':'\u2145','ddagger':'\u2021','ddarr':'\u21CA','DDotrahd':'\u2911','ddotseq':'\u2A77','deg':'\xB0','Del':'\u2207','delta':'\u03B4','Delta':'\u0394','demptyv':'\u29B1','dfisht':'\u297F','dfr':'\uD835\uDD21','Dfr':'\uD835\uDD07','dHar':'\u2965','dharl':'\u21C3','dharr':'\u21C2','DiacriticalAcute':'\xB4','DiacriticalDot':'\u02D9','DiacriticalDoubleAcute':'\u02DD','DiacriticalGrave':'`','DiacriticalTilde':'\u02DC','diam':'\u22C4','diamond':'\u22C4','Diamond':'\u22C4','diamondsuit':'\u2666','diams':'\u2666','die':'\xA8','DifferentialD':'\u2146','digamma':'\u03DD','disin':'\u22F2','div':'\xF7','divide':'\xF7','divideontimes':'\u22C7','divonx':'\u22C7','djcy':'\u0452','DJcy':'\u0402','dlcorn':'\u231E','dlcrop':'\u230D','dollar':'$','dopf':'\uD835\uDD55','Dopf':'\uD835\uDD3B','dot':'\u02D9','Dot':'\xA8','DotDot':'\u20DC','doteq':'\u2250','doteqdot':'\u2251','DotEqual':'\u2250','dotminus':'\u2238','dotplus':'\u2214','dotsquare':'\u22A1','doublebarwedge':'\u2306','DoubleContourIntegral':'\u222F','DoubleDot':'\xA8','DoubleDownArrow':'\u21D3','DoubleLeftArrow':'\u21D0','DoubleLeftRightArrow':'\u21D4','DoubleLeftTee':'\u2AE4','DoubleLongLeftArrow':'\u27F8','DoubleLongLeftRightArrow':'\u27FA','DoubleLongRightArrow':'\u27F9','DoubleRightArrow':'\u21D2','DoubleRightTee':'\u22A8','DoubleUpArrow':'\u21D1','DoubleUpDownArrow':'\u21D5','DoubleVerticalBar':'\u2225','downarrow':'\u2193','Downarrow':'\u21D3','DownArrow':'\u2193','DownArrowBar':'\u2913','DownArrowUpArrow':'\u21F5','DownBreve':'\u0311','downdownarrows':'\u21CA','downharpoonleft':'\u21C3','downharpoonright':'\u21C2','DownLeftRightVector':'\u2950','DownLeftTeeVector':'\u295E','DownLeftVector':'\u21BD','DownLeftVectorBar':'\u2956','DownRightTeeVector':'\u295F','DownRightVector':'\u21C1','DownRightVectorBar':'\u2957','DownTee':'\u22A4','DownTeeArrow':'\u21A7','drbkarow':'\u2910','drcorn':'\u231F','drcrop':'\u230C','dscr':'\uD835\uDCB9','Dscr':'\uD835\uDC9F','dscy':'\u0455','DScy':'\u0405','dsol':'\u29F6','dstrok':'\u0111','Dstrok':'\u0110','dtdot':'\u22F1','dtri':'\u25BF','dtrif':'\u25BE','duarr':'\u21F5','duhar':'\u296F','dwangle':'\u29A6','dzcy':'\u045F','DZcy':'\u040F','dzigrarr':'\u27FF','eacute':'\xE9','Eacute':'\xC9','easter':'\u2A6E','ecaron':'\u011B','Ecaron':'\u011A','ecir':'\u2256','ecirc':'\xEA','Ecirc':'\xCA','ecolon':'\u2255','ecy':'\u044D','Ecy':'\u042D','eDDot':'\u2A77','edot':'\u0117','eDot':'\u2251','Edot':'\u0116','ee':'\u2147','efDot':'\u2252','efr':'\uD835\uDD22','Efr':'\uD835\uDD08','eg':'\u2A9A','egrave':'\xE8','Egrave':'\xC8','egs':'\u2A96','egsdot':'\u2A98','el':'\u2A99','Element':'\u2208','elinters':'\u23E7','ell':'\u2113','els':'\u2A95','elsdot':'\u2A97','emacr':'\u0113','Emacr':'\u0112','empty':'\u2205','emptyset':'\u2205','EmptySmallSquare':'\u25FB','emptyv':'\u2205','EmptyVerySmallSquare':'\u25AB','emsp':'\u2003','emsp13':'\u2004','emsp14':'\u2005','eng':'\u014B','ENG':'\u014A','ensp':'\u2002','eogon':'\u0119','Eogon':'\u0118','eopf':'\uD835\uDD56','Eopf':'\uD835\uDD3C','epar':'\u22D5','eparsl':'\u29E3','eplus':'\u2A71','epsi':'\u03B5','epsilon':'\u03B5','Epsilon':'\u0395','epsiv':'\u03F5','eqcirc':'\u2256','eqcolon':'\u2255','eqsim':'\u2242','eqslantgtr':'\u2A96','eqslantless':'\u2A95','Equal':'\u2A75','equals':'=','EqualTilde':'\u2242','equest':'\u225F','Equilibrium':'\u21CC','equiv':'\u2261','equivDD':'\u2A78','eqvparsl':'\u29E5','erarr':'\u2971','erDot':'\u2253','escr':'\u212F','Escr':'\u2130','esdot':'\u2250','esim':'\u2242','Esim':'\u2A73','eta':'\u03B7','Eta':'\u0397','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','euro':'\u20AC','excl':'!','exist':'\u2203','Exists':'\u2203','expectation':'\u2130','exponentiale':'\u2147','ExponentialE':'\u2147','fallingdotseq':'\u2252','fcy':'\u0444','Fcy':'\u0424','female':'\u2640','ffilig':'\uFB03','fflig':'\uFB00','ffllig':'\uFB04','ffr':'\uD835\uDD23','Ffr':'\uD835\uDD09','filig':'\uFB01','FilledSmallSquare':'\u25FC','FilledVerySmallSquare':'\u25AA','fjlig':'fj','flat':'\u266D','fllig':'\uFB02','fltns':'\u25B1','fnof':'\u0192','fopf':'\uD835\uDD57','Fopf':'\uD835\uDD3D','forall':'\u2200','ForAll':'\u2200','fork':'\u22D4','forkv':'\u2AD9','Fouriertrf':'\u2131','fpartint':'\u2A0D','frac12':'\xBD','frac13':'\u2153','frac14':'\xBC','frac15':'\u2155','frac16':'\u2159','frac18':'\u215B','frac23':'\u2154','frac25':'\u2156','frac34':'\xBE','frac35':'\u2157','frac38':'\u215C','frac45':'\u2158','frac56':'\u215A','frac58':'\u215D','frac78':'\u215E','frasl':'\u2044','frown':'\u2322','fscr':'\uD835\uDCBB','Fscr':'\u2131','gacute':'\u01F5','gamma':'\u03B3','Gamma':'\u0393','gammad':'\u03DD','Gammad':'\u03DC','gap':'\u2A86','gbreve':'\u011F','Gbreve':'\u011E','Gcedil':'\u0122','gcirc':'\u011D','Gcirc':'\u011C','gcy':'\u0433','Gcy':'\u0413','gdot':'\u0121','Gdot':'\u0120','ge':'\u2265','gE':'\u2267','gel':'\u22DB','gEl':'\u2A8C','geq':'\u2265','geqq':'\u2267','geqslant':'\u2A7E','ges':'\u2A7E','gescc':'\u2AA9','gesdot':'\u2A80','gesdoto':'\u2A82','gesdotol':'\u2A84','gesl':'\u22DB\uFE00','gesles':'\u2A94','gfr':'\uD835\uDD24','Gfr':'\uD835\uDD0A','gg':'\u226B','Gg':'\u22D9','ggg':'\u22D9','gimel':'\u2137','gjcy':'\u0453','GJcy':'\u0403','gl':'\u2277','gla':'\u2AA5','glE':'\u2A92','glj':'\u2AA4','gnap':'\u2A8A','gnapprox':'\u2A8A','gne':'\u2A88','gnE':'\u2269','gneq':'\u2A88','gneqq':'\u2269','gnsim':'\u22E7','gopf':'\uD835\uDD58','Gopf':'\uD835\uDD3E','grave':'`','GreaterEqual':'\u2265','GreaterEqualLess':'\u22DB','GreaterFullEqual':'\u2267','GreaterGreater':'\u2AA2','GreaterLess':'\u2277','GreaterSlantEqual':'\u2A7E','GreaterTilde':'\u2273','gscr':'\u210A','Gscr':'\uD835\uDCA2','gsim':'\u2273','gsime':'\u2A8E','gsiml':'\u2A90','gt':'>','Gt':'\u226B','GT':'>','gtcc':'\u2AA7','gtcir':'\u2A7A','gtdot':'\u22D7','gtlPar':'\u2995','gtquest':'\u2A7C','gtrapprox':'\u2A86','gtrarr':'\u2978','gtrdot':'\u22D7','gtreqless':'\u22DB','gtreqqless':'\u2A8C','gtrless':'\u2277','gtrsim':'\u2273','gvertneqq':'\u2269\uFE00','gvnE':'\u2269\uFE00','Hacek':'\u02C7','hairsp':'\u200A','half':'\xBD','hamilt':'\u210B','hardcy':'\u044A','HARDcy':'\u042A','harr':'\u2194','hArr':'\u21D4','harrcir':'\u2948','harrw':'\u21AD','Hat':'^','hbar':'\u210F','hcirc':'\u0125','Hcirc':'\u0124','hearts':'\u2665','heartsuit':'\u2665','hellip':'\u2026','hercon':'\u22B9','hfr':'\uD835\uDD25','Hfr':'\u210C','HilbertSpace':'\u210B','hksearow':'\u2925','hkswarow':'\u2926','hoarr':'\u21FF','homtht':'\u223B','hookleftarrow':'\u21A9','hookrightarrow':'\u21AA','hopf':'\uD835\uDD59','Hopf':'\u210D','horbar':'\u2015','HorizontalLine':'\u2500','hscr':'\uD835\uDCBD','Hscr':'\u210B','hslash':'\u210F','hstrok':'\u0127','Hstrok':'\u0126','HumpDownHump':'\u224E','HumpEqual':'\u224F','hybull':'\u2043','hyphen':'\u2010','iacute':'\xED','Iacute':'\xCD','ic':'\u2063','icirc':'\xEE','Icirc':'\xCE','icy':'\u0438','Icy':'\u0418','Idot':'\u0130','iecy':'\u0435','IEcy':'\u0415','iexcl':'\xA1','iff':'\u21D4','ifr':'\uD835\uDD26','Ifr':'\u2111','igrave':'\xEC','Igrave':'\xCC','ii':'\u2148','iiiint':'\u2A0C','iiint':'\u222D','iinfin':'\u29DC','iiota':'\u2129','ijlig':'\u0133','IJlig':'\u0132','Im':'\u2111','imacr':'\u012B','Imacr':'\u012A','image':'\u2111','ImaginaryI':'\u2148','imagline':'\u2110','imagpart':'\u2111','imath':'\u0131','imof':'\u22B7','imped':'\u01B5','Implies':'\u21D2','in':'\u2208','incare':'\u2105','infin':'\u221E','infintie':'\u29DD','inodot':'\u0131','int':'\u222B','Int':'\u222C','intcal':'\u22BA','integers':'\u2124','Integral':'\u222B','intercal':'\u22BA','Intersection':'\u22C2','intlarhk':'\u2A17','intprod':'\u2A3C','InvisibleComma':'\u2063','InvisibleTimes':'\u2062','iocy':'\u0451','IOcy':'\u0401','iogon':'\u012F','Iogon':'\u012E','iopf':'\uD835\uDD5A','Iopf':'\uD835\uDD40','iota':'\u03B9','Iota':'\u0399','iprod':'\u2A3C','iquest':'\xBF','iscr':'\uD835\uDCBE','Iscr':'\u2110','isin':'\u2208','isindot':'\u22F5','isinE':'\u22F9','isins':'\u22F4','isinsv':'\u22F3','isinv':'\u2208','it':'\u2062','itilde':'\u0129','Itilde':'\u0128','iukcy':'\u0456','Iukcy':'\u0406','iuml':'\xEF','Iuml':'\xCF','jcirc':'\u0135','Jcirc':'\u0134','jcy':'\u0439','Jcy':'\u0419','jfr':'\uD835\uDD27','Jfr':'\uD835\uDD0D','jmath':'\u0237','jopf':'\uD835\uDD5B','Jopf':'\uD835\uDD41','jscr':'\uD835\uDCBF','Jscr':'\uD835\uDCA5','jsercy':'\u0458','Jsercy':'\u0408','jukcy':'\u0454','Jukcy':'\u0404','kappa':'\u03BA','Kappa':'\u039A','kappav':'\u03F0','kcedil':'\u0137','Kcedil':'\u0136','kcy':'\u043A','Kcy':'\u041A','kfr':'\uD835\uDD28','Kfr':'\uD835\uDD0E','kgreen':'\u0138','khcy':'\u0445','KHcy':'\u0425','kjcy':'\u045C','KJcy':'\u040C','kopf':'\uD835\uDD5C','Kopf':'\uD835\uDD42','kscr':'\uD835\uDCC0','Kscr':'\uD835\uDCA6','lAarr':'\u21DA','lacute':'\u013A','Lacute':'\u0139','laemptyv':'\u29B4','lagran':'\u2112','lambda':'\u03BB','Lambda':'\u039B','lang':'\u27E8','Lang':'\u27EA','langd':'\u2991','langle':'\u27E8','lap':'\u2A85','Laplacetrf':'\u2112','laquo':'\xAB','larr':'\u2190','lArr':'\u21D0','Larr':'\u219E','larrb':'\u21E4','larrbfs':'\u291F','larrfs':'\u291D','larrhk':'\u21A9','larrlp':'\u21AB','larrpl':'\u2939','larrsim':'\u2973','larrtl':'\u21A2','lat':'\u2AAB','latail':'\u2919','lAtail':'\u291B','late':'\u2AAD','lates':'\u2AAD\uFE00','lbarr':'\u290C','lBarr':'\u290E','lbbrk':'\u2772','lbrace':'{','lbrack':'[','lbrke':'\u298B','lbrksld':'\u298F','lbrkslu':'\u298D','lcaron':'\u013E','Lcaron':'\u013D','lcedil':'\u013C','Lcedil':'\u013B','lceil':'\u2308','lcub':'{','lcy':'\u043B','Lcy':'\u041B','ldca':'\u2936','ldquo':'\u201C','ldquor':'\u201E','ldrdhar':'\u2967','ldrushar':'\u294B','ldsh':'\u21B2','le':'\u2264','lE':'\u2266','LeftAngleBracket':'\u27E8','leftarrow':'\u2190','Leftarrow':'\u21D0','LeftArrow':'\u2190','LeftArrowBar':'\u21E4','LeftArrowRightArrow':'\u21C6','leftarrowtail':'\u21A2','LeftCeiling':'\u2308','LeftDoubleBracket':'\u27E6','LeftDownTeeVector':'\u2961','LeftDownVector':'\u21C3','LeftDownVectorBar':'\u2959','LeftFloor':'\u230A','leftharpoondown':'\u21BD','leftharpoonup':'\u21BC','leftleftarrows':'\u21C7','leftrightarrow':'\u2194','Leftrightarrow':'\u21D4','LeftRightArrow':'\u2194','leftrightarrows':'\u21C6','leftrightharpoons':'\u21CB','leftrightsquigarrow':'\u21AD','LeftRightVector':'\u294E','LeftTee':'\u22A3','LeftTeeArrow':'\u21A4','LeftTeeVector':'\u295A','leftthreetimes':'\u22CB','LeftTriangle':'\u22B2','LeftTriangleBar':'\u29CF','LeftTriangleEqual':'\u22B4','LeftUpDownVector':'\u2951','LeftUpTeeVector':'\u2960','LeftUpVector':'\u21BF','LeftUpVectorBar':'\u2958','LeftVector':'\u21BC','LeftVectorBar':'\u2952','leg':'\u22DA','lEg':'\u2A8B','leq':'\u2264','leqq':'\u2266','leqslant':'\u2A7D','les':'\u2A7D','lescc':'\u2AA8','lesdot':'\u2A7F','lesdoto':'\u2A81','lesdotor':'\u2A83','lesg':'\u22DA\uFE00','lesges':'\u2A93','lessapprox':'\u2A85','lessdot':'\u22D6','lesseqgtr':'\u22DA','lesseqqgtr':'\u2A8B','LessEqualGreater':'\u22DA','LessFullEqual':'\u2266','LessGreater':'\u2276','lessgtr':'\u2276','LessLess':'\u2AA1','lesssim':'\u2272','LessSlantEqual':'\u2A7D','LessTilde':'\u2272','lfisht':'\u297C','lfloor':'\u230A','lfr':'\uD835\uDD29','Lfr':'\uD835\uDD0F','lg':'\u2276','lgE':'\u2A91','lHar':'\u2962','lhard':'\u21BD','lharu':'\u21BC','lharul':'\u296A','lhblk':'\u2584','ljcy':'\u0459','LJcy':'\u0409','ll':'\u226A','Ll':'\u22D8','llarr':'\u21C7','llcorner':'\u231E','Lleftarrow':'\u21DA','llhard':'\u296B','lltri':'\u25FA','lmidot':'\u0140','Lmidot':'\u013F','lmoust':'\u23B0','lmoustache':'\u23B0','lnap':'\u2A89','lnapprox':'\u2A89','lne':'\u2A87','lnE':'\u2268','lneq':'\u2A87','lneqq':'\u2268','lnsim':'\u22E6','loang':'\u27EC','loarr':'\u21FD','lobrk':'\u27E6','longleftarrow':'\u27F5','Longleftarrow':'\u27F8','LongLeftArrow':'\u27F5','longleftrightarrow':'\u27F7','Longleftrightarrow':'\u27FA','LongLeftRightArrow':'\u27F7','longmapsto':'\u27FC','longrightarrow':'\u27F6','Longrightarrow':'\u27F9','LongRightArrow':'\u27F6','looparrowleft':'\u21AB','looparrowright':'\u21AC','lopar':'\u2985','lopf':'\uD835\uDD5D','Lopf':'\uD835\uDD43','loplus':'\u2A2D','lotimes':'\u2A34','lowast':'\u2217','lowbar':'_','LowerLeftArrow':'\u2199','LowerRightArrow':'\u2198','loz':'\u25CA','lozenge':'\u25CA','lozf':'\u29EB','lpar':'(','lparlt':'\u2993','lrarr':'\u21C6','lrcorner':'\u231F','lrhar':'\u21CB','lrhard':'\u296D','lrm':'\u200E','lrtri':'\u22BF','lsaquo':'\u2039','lscr':'\uD835\uDCC1','Lscr':'\u2112','lsh':'\u21B0','Lsh':'\u21B0','lsim':'\u2272','lsime':'\u2A8D','lsimg':'\u2A8F','lsqb':'[','lsquo':'\u2018','lsquor':'\u201A','lstrok':'\u0142','Lstrok':'\u0141','lt':'<','Lt':'\u226A','LT':'<','ltcc':'\u2AA6','ltcir':'\u2A79','ltdot':'\u22D6','lthree':'\u22CB','ltimes':'\u22C9','ltlarr':'\u2976','ltquest':'\u2A7B','ltri':'\u25C3','ltrie':'\u22B4','ltrif':'\u25C2','ltrPar':'\u2996','lurdshar':'\u294A','luruhar':'\u2966','lvertneqq':'\u2268\uFE00','lvnE':'\u2268\uFE00','macr':'\xAF','male':'\u2642','malt':'\u2720','maltese':'\u2720','map':'\u21A6','Map':'\u2905','mapsto':'\u21A6','mapstodown':'\u21A7','mapstoleft':'\u21A4','mapstoup':'\u21A5','marker':'\u25AE','mcomma':'\u2A29','mcy':'\u043C','Mcy':'\u041C','mdash':'\u2014','mDDot':'\u223A','measuredangle':'\u2221','MediumSpace':'\u205F','Mellintrf':'\u2133','mfr':'\uD835\uDD2A','Mfr':'\uD835\uDD10','mho':'\u2127','micro':'\xB5','mid':'\u2223','midast':'*','midcir':'\u2AF0','middot':'\xB7','minus':'\u2212','minusb':'\u229F','minusd':'\u2238','minusdu':'\u2A2A','MinusPlus':'\u2213','mlcp':'\u2ADB','mldr':'\u2026','mnplus':'\u2213','models':'\u22A7','mopf':'\uD835\uDD5E','Mopf':'\uD835\uDD44','mp':'\u2213','mscr':'\uD835\uDCC2','Mscr':'\u2133','mstpos':'\u223E','mu':'\u03BC','Mu':'\u039C','multimap':'\u22B8','mumap':'\u22B8','nabla':'\u2207','nacute':'\u0144','Nacute':'\u0143','nang':'\u2220\u20D2','nap':'\u2249','napE':'\u2A70\u0338','napid':'\u224B\u0338','napos':'\u0149','napprox':'\u2249','natur':'\u266E','natural':'\u266E','naturals':'\u2115','nbsp':'\xA0','nbump':'\u224E\u0338','nbumpe':'\u224F\u0338','ncap':'\u2A43','ncaron':'\u0148','Ncaron':'\u0147','ncedil':'\u0146','Ncedil':'\u0145','ncong':'\u2247','ncongdot':'\u2A6D\u0338','ncup':'\u2A42','ncy':'\u043D','Ncy':'\u041D','ndash':'\u2013','ne':'\u2260','nearhk':'\u2924','nearr':'\u2197','neArr':'\u21D7','nearrow':'\u2197','nedot':'\u2250\u0338','NegativeMediumSpace':'\u200B','NegativeThickSpace':'\u200B','NegativeThinSpace':'\u200B','NegativeVeryThinSpace':'\u200B','nequiv':'\u2262','nesear':'\u2928','nesim':'\u2242\u0338','NestedGreaterGreater':'\u226B','NestedLessLess':'\u226A','NewLine':'\n','nexist':'\u2204','nexists':'\u2204','nfr':'\uD835\uDD2B','Nfr':'\uD835\uDD11','nge':'\u2271','ngE':'\u2267\u0338','ngeq':'\u2271','ngeqq':'\u2267\u0338','ngeqslant':'\u2A7E\u0338','nges':'\u2A7E\u0338','nGg':'\u22D9\u0338','ngsim':'\u2275','ngt':'\u226F','nGt':'\u226B\u20D2','ngtr':'\u226F','nGtv':'\u226B\u0338','nharr':'\u21AE','nhArr':'\u21CE','nhpar':'\u2AF2','ni':'\u220B','nis':'\u22FC','nisd':'\u22FA','niv':'\u220B','njcy':'\u045A','NJcy':'\u040A','nlarr':'\u219A','nlArr':'\u21CD','nldr':'\u2025','nle':'\u2270','nlE':'\u2266\u0338','nleftarrow':'\u219A','nLeftarrow':'\u21CD','nleftrightarrow':'\u21AE','nLeftrightarrow':'\u21CE','nleq':'\u2270','nleqq':'\u2266\u0338','nleqslant':'\u2A7D\u0338','nles':'\u2A7D\u0338','nless':'\u226E','nLl':'\u22D8\u0338','nlsim':'\u2274','nlt':'\u226E','nLt':'\u226A\u20D2','nltri':'\u22EA','nltrie':'\u22EC','nLtv':'\u226A\u0338','nmid':'\u2224','NoBreak':'\u2060','NonBreakingSpace':'\xA0','nopf':'\uD835\uDD5F','Nopf':'\u2115','not':'\xAC','Not':'\u2AEC','NotCongruent':'\u2262','NotCupCap':'\u226D','NotDoubleVerticalBar':'\u2226','NotElement':'\u2209','NotEqual':'\u2260','NotEqualTilde':'\u2242\u0338','NotExists':'\u2204','NotGreater':'\u226F','NotGreaterEqual':'\u2271','NotGreaterFullEqual':'\u2267\u0338','NotGreaterGreater':'\u226B\u0338','NotGreaterLess':'\u2279','NotGreaterSlantEqual':'\u2A7E\u0338','NotGreaterTilde':'\u2275','NotHumpDownHump':'\u224E\u0338','NotHumpEqual':'\u224F\u0338','notin':'\u2209','notindot':'\u22F5\u0338','notinE':'\u22F9\u0338','notinva':'\u2209','notinvb':'\u22F7','notinvc':'\u22F6','NotLeftTriangle':'\u22EA','NotLeftTriangleBar':'\u29CF\u0338','NotLeftTriangleEqual':'\u22EC','NotLess':'\u226E','NotLessEqual':'\u2270','NotLessGreater':'\u2278','NotLessLess':'\u226A\u0338','NotLessSlantEqual':'\u2A7D\u0338','NotLessTilde':'\u2274','NotNestedGreaterGreater':'\u2AA2\u0338','NotNestedLessLess':'\u2AA1\u0338','notni':'\u220C','notniva':'\u220C','notnivb':'\u22FE','notnivc':'\u22FD','NotPrecedes':'\u2280','NotPrecedesEqual':'\u2AAF\u0338','NotPrecedesSlantEqual':'\u22E0','NotReverseElement':'\u220C','NotRightTriangle':'\u22EB','NotRightTriangleBar':'\u29D0\u0338','NotRightTriangleEqual':'\u22ED','NotSquareSubset':'\u228F\u0338','NotSquareSubsetEqual':'\u22E2','NotSquareSuperset':'\u2290\u0338','NotSquareSupersetEqual':'\u22E3','NotSubset':'\u2282\u20D2','NotSubsetEqual':'\u2288','NotSucceeds':'\u2281','NotSucceedsEqual':'\u2AB0\u0338','NotSucceedsSlantEqual':'\u22E1','NotSucceedsTilde':'\u227F\u0338','NotSuperset':'\u2283\u20D2','NotSupersetEqual':'\u2289','NotTilde':'\u2241','NotTildeEqual':'\u2244','NotTildeFullEqual':'\u2247','NotTildeTilde':'\u2249','NotVerticalBar':'\u2224','npar':'\u2226','nparallel':'\u2226','nparsl':'\u2AFD\u20E5','npart':'\u2202\u0338','npolint':'\u2A14','npr':'\u2280','nprcue':'\u22E0','npre':'\u2AAF\u0338','nprec':'\u2280','npreceq':'\u2AAF\u0338','nrarr':'\u219B','nrArr':'\u21CF','nrarrc':'\u2933\u0338','nrarrw':'\u219D\u0338','nrightarrow':'\u219B','nRightarrow':'\u21CF','nrtri':'\u22EB','nrtrie':'\u22ED','nsc':'\u2281','nsccue':'\u22E1','nsce':'\u2AB0\u0338','nscr':'\uD835\uDCC3','Nscr':'\uD835\uDCA9','nshortmid':'\u2224','nshortparallel':'\u2226','nsim':'\u2241','nsime':'\u2244','nsimeq':'\u2244','nsmid':'\u2224','nspar':'\u2226','nsqsube':'\u22E2','nsqsupe':'\u22E3','nsub':'\u2284','nsube':'\u2288','nsubE':'\u2AC5\u0338','nsubset':'\u2282\u20D2','nsubseteq':'\u2288','nsubseteqq':'\u2AC5\u0338','nsucc':'\u2281','nsucceq':'\u2AB0\u0338','nsup':'\u2285','nsupe':'\u2289','nsupE':'\u2AC6\u0338','nsupset':'\u2283\u20D2','nsupseteq':'\u2289','nsupseteqq':'\u2AC6\u0338','ntgl':'\u2279','ntilde':'\xF1','Ntilde':'\xD1','ntlg':'\u2278','ntriangleleft':'\u22EA','ntrianglelefteq':'\u22EC','ntriangleright':'\u22EB','ntrianglerighteq':'\u22ED','nu':'\u03BD','Nu':'\u039D','num':'#','numero':'\u2116','numsp':'\u2007','nvap':'\u224D\u20D2','nvdash':'\u22AC','nvDash':'\u22AD','nVdash':'\u22AE','nVDash':'\u22AF','nvge':'\u2265\u20D2','nvgt':'>\u20D2','nvHarr':'\u2904','nvinfin':'\u29DE','nvlArr':'\u2902','nvle':'\u2264\u20D2','nvlt':'<\u20D2','nvltrie':'\u22B4\u20D2','nvrArr':'\u2903','nvrtrie':'\u22B5\u20D2','nvsim':'\u223C\u20D2','nwarhk':'\u2923','nwarr':'\u2196','nwArr':'\u21D6','nwarrow':'\u2196','nwnear':'\u2927','oacute':'\xF3','Oacute':'\xD3','oast':'\u229B','ocir':'\u229A','ocirc':'\xF4','Ocirc':'\xD4','ocy':'\u043E','Ocy':'\u041E','odash':'\u229D','odblac':'\u0151','Odblac':'\u0150','odiv':'\u2A38','odot':'\u2299','odsold':'\u29BC','oelig':'\u0153','OElig':'\u0152','ofcir':'\u29BF','ofr':'\uD835\uDD2C','Ofr':'\uD835\uDD12','ogon':'\u02DB','ograve':'\xF2','Ograve':'\xD2','ogt':'\u29C1','ohbar':'\u29B5','ohm':'\u03A9','oint':'\u222E','olarr':'\u21BA','olcir':'\u29BE','olcross':'\u29BB','oline':'\u203E','olt':'\u29C0','omacr':'\u014D','Omacr':'\u014C','omega':'\u03C9','Omega':'\u03A9','omicron':'\u03BF','Omicron':'\u039F','omid':'\u29B6','ominus':'\u2296','oopf':'\uD835\uDD60','Oopf':'\uD835\uDD46','opar':'\u29B7','OpenCurlyDoubleQuote':'\u201C','OpenCurlyQuote':'\u2018','operp':'\u29B9','oplus':'\u2295','or':'\u2228','Or':'\u2A54','orarr':'\u21BB','ord':'\u2A5D','order':'\u2134','orderof':'\u2134','ordf':'\xAA','ordm':'\xBA','origof':'\u22B6','oror':'\u2A56','orslope':'\u2A57','orv':'\u2A5B','oS':'\u24C8','oscr':'\u2134','Oscr':'\uD835\uDCAA','oslash':'\xF8','Oslash':'\xD8','osol':'\u2298','otilde':'\xF5','Otilde':'\xD5','otimes':'\u2297','Otimes':'\u2A37','otimesas':'\u2A36','ouml':'\xF6','Ouml':'\xD6','ovbar':'\u233D','OverBar':'\u203E','OverBrace':'\u23DE','OverBracket':'\u23B4','OverParenthesis':'\u23DC','par':'\u2225','para':'\xB6','parallel':'\u2225','parsim':'\u2AF3','parsl':'\u2AFD','part':'\u2202','PartialD':'\u2202','pcy':'\u043F','Pcy':'\u041F','percnt':'%','period':'.','permil':'\u2030','perp':'\u22A5','pertenk':'\u2031','pfr':'\uD835\uDD2D','Pfr':'\uD835\uDD13','phi':'\u03C6','Phi':'\u03A6','phiv':'\u03D5','phmmat':'\u2133','phone':'\u260E','pi':'\u03C0','Pi':'\u03A0','pitchfork':'\u22D4','piv':'\u03D6','planck':'\u210F','planckh':'\u210E','plankv':'\u210F','plus':'+','plusacir':'\u2A23','plusb':'\u229E','pluscir':'\u2A22','plusdo':'\u2214','plusdu':'\u2A25','pluse':'\u2A72','PlusMinus':'\xB1','plusmn':'\xB1','plussim':'\u2A26','plustwo':'\u2A27','pm':'\xB1','Poincareplane':'\u210C','pointint':'\u2A15','popf':'\uD835\uDD61','Popf':'\u2119','pound':'\xA3','pr':'\u227A','Pr':'\u2ABB','prap':'\u2AB7','prcue':'\u227C','pre':'\u2AAF','prE':'\u2AB3','prec':'\u227A','precapprox':'\u2AB7','preccurlyeq':'\u227C','Precedes':'\u227A','PrecedesEqual':'\u2AAF','PrecedesSlantEqual':'\u227C','PrecedesTilde':'\u227E','preceq':'\u2AAF','precnapprox':'\u2AB9','precneqq':'\u2AB5','precnsim':'\u22E8','precsim':'\u227E','prime':'\u2032','Prime':'\u2033','primes':'\u2119','prnap':'\u2AB9','prnE':'\u2AB5','prnsim':'\u22E8','prod':'\u220F','Product':'\u220F','profalar':'\u232E','profline':'\u2312','profsurf':'\u2313','prop':'\u221D','Proportion':'\u2237','Proportional':'\u221D','propto':'\u221D','prsim':'\u227E','prurel':'\u22B0','pscr':'\uD835\uDCC5','Pscr':'\uD835\uDCAB','psi':'\u03C8','Psi':'\u03A8','puncsp':'\u2008','qfr':'\uD835\uDD2E','Qfr':'\uD835\uDD14','qint':'\u2A0C','qopf':'\uD835\uDD62','Qopf':'\u211A','qprime':'\u2057','qscr':'\uD835\uDCC6','Qscr':'\uD835\uDCAC','quaternions':'\u210D','quatint':'\u2A16','quest':'?','questeq':'\u225F','quot':'"','QUOT':'"','rAarr':'\u21DB','race':'\u223D\u0331','racute':'\u0155','Racute':'\u0154','radic':'\u221A','raemptyv':'\u29B3','rang':'\u27E9','Rang':'\u27EB','rangd':'\u2992','range':'\u29A5','rangle':'\u27E9','raquo':'\xBB','rarr':'\u2192','rArr':'\u21D2','Rarr':'\u21A0','rarrap':'\u2975','rarrb':'\u21E5','rarrbfs':'\u2920','rarrc':'\u2933','rarrfs':'\u291E','rarrhk':'\u21AA','rarrlp':'\u21AC','rarrpl':'\u2945','rarrsim':'\u2974','rarrtl':'\u21A3','Rarrtl':'\u2916','rarrw':'\u219D','ratail':'\u291A','rAtail':'\u291C','ratio':'\u2236','rationals':'\u211A','rbarr':'\u290D','rBarr':'\u290F','RBarr':'\u2910','rbbrk':'\u2773','rbrace':'}','rbrack':']','rbrke':'\u298C','rbrksld':'\u298E','rbrkslu':'\u2990','rcaron':'\u0159','Rcaron':'\u0158','rcedil':'\u0157','Rcedil':'\u0156','rceil':'\u2309','rcub':'}','rcy':'\u0440','Rcy':'\u0420','rdca':'\u2937','rdldhar':'\u2969','rdquo':'\u201D','rdquor':'\u201D','rdsh':'\u21B3','Re':'\u211C','real':'\u211C','realine':'\u211B','realpart':'\u211C','reals':'\u211D','rect':'\u25AD','reg':'\xAE','REG':'\xAE','ReverseElement':'\u220B','ReverseEquilibrium':'\u21CB','ReverseUpEquilibrium':'\u296F','rfisht':'\u297D','rfloor':'\u230B','rfr':'\uD835\uDD2F','Rfr':'\u211C','rHar':'\u2964','rhard':'\u21C1','rharu':'\u21C0','rharul':'\u296C','rho':'\u03C1','Rho':'\u03A1','rhov':'\u03F1','RightAngleBracket':'\u27E9','rightarrow':'\u2192','Rightarrow':'\u21D2','RightArrow':'\u2192','RightArrowBar':'\u21E5','RightArrowLeftArrow':'\u21C4','rightarrowtail':'\u21A3','RightCeiling':'\u2309','RightDoubleBracket':'\u27E7','RightDownTeeVector':'\u295D','RightDownVector':'\u21C2','RightDownVectorBar':'\u2955','RightFloor':'\u230B','rightharpoondown':'\u21C1','rightharpoonup':'\u21C0','rightleftarrows':'\u21C4','rightleftharpoons':'\u21CC','rightrightarrows':'\u21C9','rightsquigarrow':'\u219D','RightTee':'\u22A2','RightTeeArrow':'\u21A6','RightTeeVector':'\u295B','rightthreetimes':'\u22CC','RightTriangle':'\u22B3','RightTriangleBar':'\u29D0','RightTriangleEqual':'\u22B5','RightUpDownVector':'\u294F','RightUpTeeVector':'\u295C','RightUpVector':'\u21BE','RightUpVectorBar':'\u2954','RightVector':'\u21C0','RightVectorBar':'\u2953','ring':'\u02DA','risingdotseq':'\u2253','rlarr':'\u21C4','rlhar':'\u21CC','rlm':'\u200F','rmoust':'\u23B1','rmoustache':'\u23B1','rnmid':'\u2AEE','roang':'\u27ED','roarr':'\u21FE','robrk':'\u27E7','ropar':'\u2986','ropf':'\uD835\uDD63','Ropf':'\u211D','roplus':'\u2A2E','rotimes':'\u2A35','RoundImplies':'\u2970','rpar':')','rpargt':'\u2994','rppolint':'\u2A12','rrarr':'\u21C9','Rrightarrow':'\u21DB','rsaquo':'\u203A','rscr':'\uD835\uDCC7','Rscr':'\u211B','rsh':'\u21B1','Rsh':'\u21B1','rsqb':']','rsquo':'\u2019','rsquor':'\u2019','rthree':'\u22CC','rtimes':'\u22CA','rtri':'\u25B9','rtrie':'\u22B5','rtrif':'\u25B8','rtriltri':'\u29CE','RuleDelayed':'\u29F4','ruluhar':'\u2968','rx':'\u211E','sacute':'\u015B','Sacute':'\u015A','sbquo':'\u201A','sc':'\u227B','Sc':'\u2ABC','scap':'\u2AB8','scaron':'\u0161','Scaron':'\u0160','sccue':'\u227D','sce':'\u2AB0','scE':'\u2AB4','scedil':'\u015F','Scedil':'\u015E','scirc':'\u015D','Scirc':'\u015C','scnap':'\u2ABA','scnE':'\u2AB6','scnsim':'\u22E9','scpolint':'\u2A13','scsim':'\u227F','scy':'\u0441','Scy':'\u0421','sdot':'\u22C5','sdotb':'\u22A1','sdote':'\u2A66','searhk':'\u2925','searr':'\u2198','seArr':'\u21D8','searrow':'\u2198','sect':'\xA7','semi':';','seswar':'\u2929','setminus':'\u2216','setmn':'\u2216','sext':'\u2736','sfr':'\uD835\uDD30','Sfr':'\uD835\uDD16','sfrown':'\u2322','sharp':'\u266F','shchcy':'\u0449','SHCHcy':'\u0429','shcy':'\u0448','SHcy':'\u0428','ShortDownArrow':'\u2193','ShortLeftArrow':'\u2190','shortmid':'\u2223','shortparallel':'\u2225','ShortRightArrow':'\u2192','ShortUpArrow':'\u2191','shy':'\xAD','sigma':'\u03C3','Sigma':'\u03A3','sigmaf':'\u03C2','sigmav':'\u03C2','sim':'\u223C','simdot':'\u2A6A','sime':'\u2243','simeq':'\u2243','simg':'\u2A9E','simgE':'\u2AA0','siml':'\u2A9D','simlE':'\u2A9F','simne':'\u2246','simplus':'\u2A24','simrarr':'\u2972','slarr':'\u2190','SmallCircle':'\u2218','smallsetminus':'\u2216','smashp':'\u2A33','smeparsl':'\u29E4','smid':'\u2223','smile':'\u2323','smt':'\u2AAA','smte':'\u2AAC','smtes':'\u2AAC\uFE00','softcy':'\u044C','SOFTcy':'\u042C','sol':'/','solb':'\u29C4','solbar':'\u233F','sopf':'\uD835\uDD64','Sopf':'\uD835\uDD4A','spades':'\u2660','spadesuit':'\u2660','spar':'\u2225','sqcap':'\u2293','sqcaps':'\u2293\uFE00','sqcup':'\u2294','sqcups':'\u2294\uFE00','Sqrt':'\u221A','sqsub':'\u228F','sqsube':'\u2291','sqsubset':'\u228F','sqsubseteq':'\u2291','sqsup':'\u2290','sqsupe':'\u2292','sqsupset':'\u2290','sqsupseteq':'\u2292','squ':'\u25A1','square':'\u25A1','Square':'\u25A1','SquareIntersection':'\u2293','SquareSubset':'\u228F','SquareSubsetEqual':'\u2291','SquareSuperset':'\u2290','SquareSupersetEqual':'\u2292','SquareUnion':'\u2294','squarf':'\u25AA','squf':'\u25AA','srarr':'\u2192','sscr':'\uD835\uDCC8','Sscr':'\uD835\uDCAE','ssetmn':'\u2216','ssmile':'\u2323','sstarf':'\u22C6','star':'\u2606','Star':'\u22C6','starf':'\u2605','straightepsilon':'\u03F5','straightphi':'\u03D5','strns':'\xAF','sub':'\u2282','Sub':'\u22D0','subdot':'\u2ABD','sube':'\u2286','subE':'\u2AC5','subedot':'\u2AC3','submult':'\u2AC1','subne':'\u228A','subnE':'\u2ACB','subplus':'\u2ABF','subrarr':'\u2979','subset':'\u2282','Subset':'\u22D0','subseteq':'\u2286','subseteqq':'\u2AC5','SubsetEqual':'\u2286','subsetneq':'\u228A','subsetneqq':'\u2ACB','subsim':'\u2AC7','subsub':'\u2AD5','subsup':'\u2AD3','succ':'\u227B','succapprox':'\u2AB8','succcurlyeq':'\u227D','Succeeds':'\u227B','SucceedsEqual':'\u2AB0','SucceedsSlantEqual':'\u227D','SucceedsTilde':'\u227F','succeq':'\u2AB0','succnapprox':'\u2ABA','succneqq':'\u2AB6','succnsim':'\u22E9','succsim':'\u227F','SuchThat':'\u220B','sum':'\u2211','Sum':'\u2211','sung':'\u266A','sup':'\u2283','Sup':'\u22D1','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','supdot':'\u2ABE','supdsub':'\u2AD8','supe':'\u2287','supE':'\u2AC6','supedot':'\u2AC4','Superset':'\u2283','SupersetEqual':'\u2287','suphsol':'\u27C9','suphsub':'\u2AD7','suplarr':'\u297B','supmult':'\u2AC2','supne':'\u228B','supnE':'\u2ACC','supplus':'\u2AC0','supset':'\u2283','Supset':'\u22D1','supseteq':'\u2287','supseteqq':'\u2AC6','supsetneq':'\u228B','supsetneqq':'\u2ACC','supsim':'\u2AC8','supsub':'\u2AD4','supsup':'\u2AD6','swarhk':'\u2926','swarr':'\u2199','swArr':'\u21D9','swarrow':'\u2199','swnwar':'\u292A','szlig':'\xDF','Tab':'\t','target':'\u2316','tau':'\u03C4','Tau':'\u03A4','tbrk':'\u23B4','tcaron':'\u0165','Tcaron':'\u0164','tcedil':'\u0163','Tcedil':'\u0162','tcy':'\u0442','Tcy':'\u0422','tdot':'\u20DB','telrec':'\u2315','tfr':'\uD835\uDD31','Tfr':'\uD835\uDD17','there4':'\u2234','therefore':'\u2234','Therefore':'\u2234','theta':'\u03B8','Theta':'\u0398','thetasym':'\u03D1','thetav':'\u03D1','thickapprox':'\u2248','thicksim':'\u223C','ThickSpace':'\u205F\u200A','thinsp':'\u2009','ThinSpace':'\u2009','thkap':'\u2248','thksim':'\u223C','thorn':'\xFE','THORN':'\xDE','tilde':'\u02DC','Tilde':'\u223C','TildeEqual':'\u2243','TildeFullEqual':'\u2245','TildeTilde':'\u2248','times':'\xD7','timesb':'\u22A0','timesbar':'\u2A31','timesd':'\u2A30','tint':'\u222D','toea':'\u2928','top':'\u22A4','topbot':'\u2336','topcir':'\u2AF1','topf':'\uD835\uDD65','Topf':'\uD835\uDD4B','topfork':'\u2ADA','tosa':'\u2929','tprime':'\u2034','trade':'\u2122','TRADE':'\u2122','triangle':'\u25B5','triangledown':'\u25BF','triangleleft':'\u25C3','trianglelefteq':'\u22B4','triangleq':'\u225C','triangleright':'\u25B9','trianglerighteq':'\u22B5','tridot':'\u25EC','trie':'\u225C','triminus':'\u2A3A','TripleDot':'\u20DB','triplus':'\u2A39','trisb':'\u29CD','tritime':'\u2A3B','trpezium':'\u23E2','tscr':'\uD835\uDCC9','Tscr':'\uD835\uDCAF','tscy':'\u0446','TScy':'\u0426','tshcy':'\u045B','TSHcy':'\u040B','tstrok':'\u0167','Tstrok':'\u0166','twixt':'\u226C','twoheadleftarrow':'\u219E','twoheadrightarrow':'\u21A0','uacute':'\xFA','Uacute':'\xDA','uarr':'\u2191','uArr':'\u21D1','Uarr':'\u219F','Uarrocir':'\u2949','ubrcy':'\u045E','Ubrcy':'\u040E','ubreve':'\u016D','Ubreve':'\u016C','ucirc':'\xFB','Ucirc':'\xDB','ucy':'\u0443','Ucy':'\u0423','udarr':'\u21C5','udblac':'\u0171','Udblac':'\u0170','udhar':'\u296E','ufisht':'\u297E','ufr':'\uD835\uDD32','Ufr':'\uD835\uDD18','ugrave':'\xF9','Ugrave':'\xD9','uHar':'\u2963','uharl':'\u21BF','uharr':'\u21BE','uhblk':'\u2580','ulcorn':'\u231C','ulcorner':'\u231C','ulcrop':'\u230F','ultri':'\u25F8','umacr':'\u016B','Umacr':'\u016A','uml':'\xA8','UnderBar':'_','UnderBrace':'\u23DF','UnderBracket':'\u23B5','UnderParenthesis':'\u23DD','Union':'\u22C3','UnionPlus':'\u228E','uogon':'\u0173','Uogon':'\u0172','uopf':'\uD835\uDD66','Uopf':'\uD835\uDD4C','uparrow':'\u2191','Uparrow':'\u21D1','UpArrow':'\u2191','UpArrowBar':'\u2912','UpArrowDownArrow':'\u21C5','updownarrow':'\u2195','Updownarrow':'\u21D5','UpDownArrow':'\u2195','UpEquilibrium':'\u296E','upharpoonleft':'\u21BF','upharpoonright':'\u21BE','uplus':'\u228E','UpperLeftArrow':'\u2196','UpperRightArrow':'\u2197','upsi':'\u03C5','Upsi':'\u03D2','upsih':'\u03D2','upsilon':'\u03C5','Upsilon':'\u03A5','UpTee':'\u22A5','UpTeeArrow':'\u21A5','upuparrows':'\u21C8','urcorn':'\u231D','urcorner':'\u231D','urcrop':'\u230E','uring':'\u016F','Uring':'\u016E','urtri':'\u25F9','uscr':'\uD835\uDCCA','Uscr':'\uD835\uDCB0','utdot':'\u22F0','utilde':'\u0169','Utilde':'\u0168','utri':'\u25B5','utrif':'\u25B4','uuarr':'\u21C8','uuml':'\xFC','Uuml':'\xDC','uwangle':'\u29A7','vangrt':'\u299C','varepsilon':'\u03F5','varkappa':'\u03F0','varnothing':'\u2205','varphi':'\u03D5','varpi':'\u03D6','varpropto':'\u221D','varr':'\u2195','vArr':'\u21D5','varrho':'\u03F1','varsigma':'\u03C2','varsubsetneq':'\u228A\uFE00','varsubsetneqq':'\u2ACB\uFE00','varsupsetneq':'\u228B\uFE00','varsupsetneqq':'\u2ACC\uFE00','vartheta':'\u03D1','vartriangleleft':'\u22B2','vartriangleright':'\u22B3','vBar':'\u2AE8','Vbar':'\u2AEB','vBarv':'\u2AE9','vcy':'\u0432','Vcy':'\u0412','vdash':'\u22A2','vDash':'\u22A8','Vdash':'\u22A9','VDash':'\u22AB','Vdashl':'\u2AE6','vee':'\u2228','Vee':'\u22C1','veebar':'\u22BB','veeeq':'\u225A','vellip':'\u22EE','verbar':'|','Verbar':'\u2016','vert':'|','Vert':'\u2016','VerticalBar':'\u2223','VerticalLine':'|','VerticalSeparator':'\u2758','VerticalTilde':'\u2240','VeryThinSpace':'\u200A','vfr':'\uD835\uDD33','Vfr':'\uD835\uDD19','vltri':'\u22B2','vnsub':'\u2282\u20D2','vnsup':'\u2283\u20D2','vopf':'\uD835\uDD67','Vopf':'\uD835\uDD4D','vprop':'\u221D','vrtri':'\u22B3','vscr':'\uD835\uDCCB','Vscr':'\uD835\uDCB1','vsubne':'\u228A\uFE00','vsubnE':'\u2ACB\uFE00','vsupne':'\u228B\uFE00','vsupnE':'\u2ACC\uFE00','Vvdash':'\u22AA','vzigzag':'\u299A','wcirc':'\u0175','Wcirc':'\u0174','wedbar':'\u2A5F','wedge':'\u2227','Wedge':'\u22C0','wedgeq':'\u2259','weierp':'\u2118','wfr':'\uD835\uDD34','Wfr':'\uD835\uDD1A','wopf':'\uD835\uDD68','Wopf':'\uD835\uDD4E','wp':'\u2118','wr':'\u2240','wreath':'\u2240','wscr':'\uD835\uDCCC','Wscr':'\uD835\uDCB2','xcap':'\u22C2','xcirc':'\u25EF','xcup':'\u22C3','xdtri':'\u25BD','xfr':'\uD835\uDD35','Xfr':'\uD835\uDD1B','xharr':'\u27F7','xhArr':'\u27FA','xi':'\u03BE','Xi':'\u039E','xlarr':'\u27F5','xlArr':'\u27F8','xmap':'\u27FC','xnis':'\u22FB','xodot':'\u2A00','xopf':'\uD835\uDD69','Xopf':'\uD835\uDD4F','xoplus':'\u2A01','xotime':'\u2A02','xrarr':'\u27F6','xrArr':'\u27F9','xscr':'\uD835\uDCCD','Xscr':'\uD835\uDCB3','xsqcup':'\u2A06','xuplus':'\u2A04','xutri':'\u25B3','xvee':'\u22C1','xwedge':'\u22C0','yacute':'\xFD','Yacute':'\xDD','yacy':'\u044F','YAcy':'\u042F','ycirc':'\u0177','Ycirc':'\u0176','ycy':'\u044B','Ycy':'\u042B','yen':'\xA5','yfr':'\uD835\uDD36','Yfr':'\uD835\uDD1C','yicy':'\u0457','YIcy':'\u0407','yopf':'\uD835\uDD6A','Yopf':'\uD835\uDD50','yscr':'\uD835\uDCCE','Yscr':'\uD835\uDCB4','yucy':'\u044E','YUcy':'\u042E','yuml':'\xFF','Yuml':'\u0178','zacute':'\u017A','Zacute':'\u0179','zcaron':'\u017E','Zcaron':'\u017D','zcy':'\u0437','Zcy':'\u0417','zdot':'\u017C','Zdot':'\u017B','zeetrf':'\u2128','ZeroWidthSpace':'\u200B','zeta':'\u03B6','Zeta':'\u0396','zfr':'\uD835\uDD37','Zfr':'\u2128','zhcy':'\u0436','ZHcy':'\u0416','zigrarr':'\u21DD','zopf':'\uD835\uDD6B','Zopf':'\u2124','zscr':'\uD835\uDCCF','Zscr':'\uD835\uDCB5','zwj':'\u200D','zwnj':'\u200C'};
		var decodeMapLegacy = {'aacute':'\xE1','Aacute':'\xC1','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','aelig':'\xE6','AElig':'\xC6','agrave':'\xE0','Agrave':'\xC0','amp':'&','AMP':'&','aring':'\xE5','Aring':'\xC5','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','brvbar':'\xA6','ccedil':'\xE7','Ccedil':'\xC7','cedil':'\xB8','cent':'\xA2','copy':'\xA9','COPY':'\xA9','curren':'\xA4','deg':'\xB0','divide':'\xF7','eacute':'\xE9','Eacute':'\xC9','ecirc':'\xEA','Ecirc':'\xCA','egrave':'\xE8','Egrave':'\xC8','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','frac12':'\xBD','frac14':'\xBC','frac34':'\xBE','gt':'>','GT':'>','iacute':'\xED','Iacute':'\xCD','icirc':'\xEE','Icirc':'\xCE','iexcl':'\xA1','igrave':'\xEC','Igrave':'\xCC','iquest':'\xBF','iuml':'\xEF','Iuml':'\xCF','laquo':'\xAB','lt':'<','LT':'<','macr':'\xAF','micro':'\xB5','middot':'\xB7','nbsp':'\xA0','not':'\xAC','ntilde':'\xF1','Ntilde':'\xD1','oacute':'\xF3','Oacute':'\xD3','ocirc':'\xF4','Ocirc':'\xD4','ograve':'\xF2','Ograve':'\xD2','ordf':'\xAA','ordm':'\xBA','oslash':'\xF8','Oslash':'\xD8','otilde':'\xF5','Otilde':'\xD5','ouml':'\xF6','Ouml':'\xD6','para':'\xB6','plusmn':'\xB1','pound':'\xA3','quot':'"','QUOT':'"','raquo':'\xBB','reg':'\xAE','REG':'\xAE','sect':'\xA7','shy':'\xAD','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','szlig':'\xDF','thorn':'\xFE','THORN':'\xDE','times':'\xD7','uacute':'\xFA','Uacute':'\xDA','ucirc':'\xFB','Ucirc':'\xDB','ugrave':'\xF9','Ugrave':'\xD9','uml':'\xA8','uuml':'\xFC','Uuml':'\xDC','yacute':'\xFD','Yacute':'\xDD','yen':'\xA5','yuml':'\xFF'};
		var decodeMapNumeric = {'0':'\uFFFD','128':'\u20AC','130':'\u201A','131':'\u0192','132':'\u201E','133':'\u2026','134':'\u2020','135':'\u2021','136':'\u02C6','137':'\u2030','138':'\u0160','139':'\u2039','140':'\u0152','142':'\u017D','145':'\u2018','146':'\u2019','147':'\u201C','148':'\u201D','149':'\u2022','150':'\u2013','151':'\u2014','152':'\u02DC','153':'\u2122','154':'\u0161','155':'\u203A','156':'\u0153','158':'\u017E','159':'\u0178'};
		var invalidReferenceCodePoints = [1,2,3,4,5,6,7,8,11,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,64976,64977,64978,64979,64980,64981,64982,64983,64984,64985,64986,64987,64988,64989,64990,64991,64992,64993,64994,64995,64996,64997,64998,64999,65000,65001,65002,65003,65004,65005,65006,65007,65534,65535,131070,131071,196606,196607,262142,262143,327678,327679,393214,393215,458750,458751,524286,524287,589822,589823,655358,655359,720894,720895,786430,786431,851966,851967,917502,917503,983038,983039,1048574,1048575,1114110,1114111];
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		var object = {};
		var hasOwnProperty = object.hasOwnProperty;
		var has = function(object, propertyName) {
			return hasOwnProperty.call(object, propertyName);
		};
	
		var contains = function(array, value) {
			var index = -1;
			var length = array.length;
			while (++index < length) {
				if (array[index] == value) {
					return true;
				}
			}
			return false;
		};
	
		var merge = function(options, defaults) {
			if (!options) {
				return defaults;
			}
			var result = {};
			var key;
			for (key in defaults) {
				// A `hasOwnProperty` check is not needed here, since only recognized
				// option names are used anyway. Any others are ignored.
				result[key] = has(options, key) ? options[key] : defaults[key];
			}
			return result;
		};
	
		// Modified version of `ucs2encode`; see https://mths.be/punycode.
		var codePointToSymbol = function(codePoint, strict) {
			var output = '';
			if ((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF) {
				// See issue #4:
				// “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
				// greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
				// REPLACEMENT CHARACTER.”
				if (strict) {
					parseError('character reference outside the permissible Unicode range');
				}
				return '\uFFFD';
			}
			if (has(decodeMapNumeric, codePoint)) {
				if (strict) {
					parseError('disallowed character reference');
				}
				return decodeMapNumeric[codePoint];
			}
			if (strict && contains(invalidReferenceCodePoints, codePoint)) {
				parseError('disallowed character reference');
			}
			if (codePoint > 0xFFFF) {
				codePoint -= 0x10000;
				output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
				codePoint = 0xDC00 | codePoint & 0x3FF;
			}
			output += stringFromCharCode(codePoint);
			return output;
		};
	
		var hexEscape = function(codePoint) {
			return '&#x' + codePoint.toString(16).toUpperCase() + ';';
		};
	
		var decEscape = function(codePoint) {
			return '&#' + codePoint + ';';
		};
	
		var parseError = function(message) {
			throw Error('Parse error: ' + message);
		};
	
		/*--------------------------------------------------------------------------*/
	
		var encode = function(string, options) {
			options = merge(options, encode.options);
			var strict = options.strict;
			if (strict && regexInvalidRawCodePoint.test(string)) {
				parseError('forbidden code point');
			}
			var encodeEverything = options.encodeEverything;
			var useNamedReferences = options.useNamedReferences;
			var allowUnsafeSymbols = options.allowUnsafeSymbols;
			var escapeCodePoint = options.decimal ? decEscape : hexEscape;
	
			var escapeBmpSymbol = function(symbol) {
				return escapeCodePoint(symbol.charCodeAt(0));
			};
	
			if (encodeEverything) {
				// Encode ASCII symbols.
				string = string.replace(regexAsciiWhitelist, function(symbol) {
					// Use named references if requested & possible.
					if (useNamedReferences && has(encodeMap, symbol)) {
						return '&' + encodeMap[symbol] + ';';
					}
					return escapeBmpSymbol(symbol);
				});
				// Shorten a few escapes that represent two symbols, of which at least one
				// is within the ASCII range.
				if (useNamedReferences) {
					string = string
						.replace(/&gt;\u20D2/g, '&nvgt;')
						.replace(/&lt;\u20D2/g, '&nvlt;')
						.replace(/&#x66;&#x6A;/g, '&fjlig;');
				}
				// Encode non-ASCII symbols.
				if (useNamedReferences) {
					// Encode non-ASCII symbols that can be replaced with a named reference.
					string = string.replace(regexEncodeNonAscii, function(string) {
						// Note: there is no need to check `has(encodeMap, string)` here.
						return '&' + encodeMap[string] + ';';
					});
				}
				// Note: any remaining non-ASCII symbols are handled outside of the `if`.
			} else if (useNamedReferences) {
				// Apply named character references.
				// Encode `<>"'&` using named character references.
				if (!allowUnsafeSymbols) {
					string = string.replace(regexEscape, function(string) {
						return '&' + encodeMap[string] + ';'; // no need to check `has()` here
					});
				}
				// Shorten escapes that represent two symbols, of which at least one is
				// `<>"'&`.
				string = string
					.replace(/&gt;\u20D2/g, '&nvgt;')
					.replace(/&lt;\u20D2/g, '&nvlt;');
				// Encode non-ASCII symbols that can be replaced with a named reference.
				string = string.replace(regexEncodeNonAscii, function(string) {
					// Note: there is no need to check `has(encodeMap, string)` here.
					return '&' + encodeMap[string] + ';';
				});
			} else if (!allowUnsafeSymbols) {
				// Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
				// using named character references.
				string = string.replace(regexEscape, escapeBmpSymbol);
			}
			return string
				// Encode astral symbols.
				.replace(regexAstralSymbols, function($0) {
					// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
					var high = $0.charCodeAt(0);
					var low = $0.charCodeAt(1);
					var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
					return escapeCodePoint(codePoint);
				})
				// Encode any remaining BMP symbols that are not printable ASCII symbols
				// using a hexadecimal escape.
				.replace(regexBmpWhitelist, escapeBmpSymbol);
		};
		// Expose default options (so they can be overridden globally).
		encode.options = {
			'allowUnsafeSymbols': false,
			'encodeEverything': false,
			'strict': false,
			'useNamedReferences': false,
			'decimal' : false
		};
	
		var decode = function(html, options) {
			options = merge(options, decode.options);
			var strict = options.strict;
			if (strict && regexInvalidEntity.test(html)) {
				parseError('malformed character reference');
			}
			return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
				var codePoint;
				var semicolon;
				var decDigits;
				var hexDigits;
				var reference;
				var next;
	
				if ($1) {
					reference = $1;
					// Note: there is no need to check `has(decodeMap, reference)`.
					return decodeMap[reference];
				}
	
				if ($2) {
					// Decode named character references without trailing `;`, e.g. `&amp`.
					// This is only a parse error if it gets converted to `&`, or if it is
					// followed by `=` in an attribute context.
					reference = $2;
					next = $3;
					if (next && options.isAttributeValue) {
						if (strict && next == '=') {
							parseError('`&` did not start a character reference');
						}
						return $0;
					} else {
						if (strict) {
							parseError(
								'named character reference was not terminated by a semicolon'
							);
						}
						// Note: there is no need to check `has(decodeMapLegacy, reference)`.
						return decodeMapLegacy[reference] + (next || '');
					}
				}
	
				if ($4) {
					// Decode decimal escapes, e.g. `&#119558;`.
					decDigits = $4;
					semicolon = $5;
					if (strict && !semicolon) {
						parseError('character reference was not terminated by a semicolon');
					}
					codePoint = parseInt(decDigits, 10);
					return codePointToSymbol(codePoint, strict);
				}
	
				if ($6) {
					// Decode hexadecimal escapes, e.g. `&#x1D306;`.
					hexDigits = $6;
					semicolon = $7;
					if (strict && !semicolon) {
						parseError('character reference was not terminated by a semicolon');
					}
					codePoint = parseInt(hexDigits, 16);
					return codePointToSymbol(codePoint, strict);
				}
	
				// If we’re still here, `if ($7)` is implied; it’s an ambiguous
				// ampersand for sure. https://mths.be/notes/ambiguous-ampersands
				if (strict) {
					parseError(
						'named character reference was not terminated by a semicolon'
					);
				}
				return $0;
			});
		};
		// Expose default options (so they can be overridden globally).
		decode.options = {
			'isAttributeValue': false,
			'strict': false
		};
	
		var escape = function(string) {
			return string.replace(regexEscape, function($0) {
				// Note: there is no need to check `has(escapeMap, $0)` here.
				return escapeMap[$0];
			});
		};
	
		/*--------------------------------------------------------------------------*/
	
		var he = {
			'version': '1.2.0',
			'encode': encode,
			'decode': decode,
			'escape': escape,
			'unescape': decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return he;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js, io.js, or RingoJS v0.8.0+
				freeModule.exports = he;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (var key in he) {
					has(he, key) && (freeExports[key] = he[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.he = he;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(671)(module), (function() { return this; }())))

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(1289)
	var ieee754 = __webpack_require__(1336)
	var isArray = __webpack_require__(1839)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(810).Buffer, (function() { return this; }())))

/***/ },
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1756);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!../../sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./fullcalendar.css", function() {
				var newContent = require("!!../../css-loader/index.js!../../sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./fullcalendar.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */
/***/ function(module, exports) {

	function _interopRequireDefault(e) {
	  return e && e.__esModule ? e : {
	    "default": e
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 911 */
/***/ function(module, exports) {

	function _setPrototypeOf(t, e) {
	  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
	    return t.__proto__ = e, t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 912 */
/***/ function(module, exports) {

	'use strict'
	
	/**
	 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
	 *
	 * Works with anything that has a `length` property and index access properties, including NodeList.
	 *
	 * @template {unknown} T
	 * @param {Array<T> | ({length:number, [number]: T})} list
	 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
	 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
	 * 				allows injecting a custom implementation in tests
	 * @returns {T | undefined}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
	 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
	 */
	function find(list, predicate, ac) {
		if (ac === undefined) {
			ac = Array.prototype;
		}
		if (list && typeof ac.find === 'function') {
			return ac.find.call(list, predicate);
		}
		for (var i = 0; i < list.length; i++) {
			if (Object.prototype.hasOwnProperty.call(list, i)) {
				var item = list[i];
				if (predicate.call(undefined, item, i, list)) {
					return item;
				}
			}
		}
	}
	
	/**
	 * "Shallow freezes" an object to render it immutable.
	 * Uses `Object.freeze` if available,
	 * otherwise the immutability is only in the type.
	 *
	 * Is used to create "enum like" objects.
	 *
	 * @template T
	 * @param {T} object the object to freeze
	 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
	 * 				allows to inject custom object constructor for tests
	 * @returns {Readonly<T>}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
	 */
	function freeze(object, oc) {
		if (oc === undefined) {
			oc = Object
		}
		return oc && typeof oc.freeze === 'function' ? oc.freeze(object) : object
	}
	
	/**
	 * Since we can not rely on `Object.assign` we provide a simplified version
	 * that is sufficient for our needs.
	 *
	 * @param {Object} target
	 * @param {Object | null | undefined} source
	 *
	 * @returns {Object} target
	 * @throws TypeError if target is not an object
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
	 */
	function assign(target, source) {
		if (target === null || typeof target !== 'object') {
			throw new TypeError('target is not an object')
		}
		for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key]
			}
		}
		return target
	}
	
	/**
	 * All mime types that are allowed as input to `DOMParser.parseFromString`
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
	 * @see DOMParser.prototype.parseFromString
	 */
	var MIME_TYPE = freeze({
		/**
		 * `text/html`, the only mime type that triggers treating an XML document as HTML.
		 *
		 * @see DOMParser.SupportedType.isHTML
		 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
		 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
		 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
		 */
		HTML: 'text/html',
	
		/**
		 * Helper method to check a mime type if it indicates an HTML document
		 *
		 * @param {string} [value]
		 * @returns {boolean}
		 *
		 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
		 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
		 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
		isHTML: function (value) {
			return value === MIME_TYPE.HTML
		},
	
		/**
		 * `application/xml`, the standard mime type for XML documents.
		 *
		 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
		 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
		 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
		 */
		XML_APPLICATION: 'application/xml',
	
		/**
		 * `text/html`, an alias for `application/xml`.
		 *
		 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
		 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
		 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
		 */
		XML_TEXT: 'text/xml',
	
		/**
		 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
		 * but is parsed as an XML document.
		 *
		 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
		 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
		 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
		 */
		XML_XHTML_APPLICATION: 'application/xhtml+xml',
	
		/**
		 * `image/svg+xml`,
		 *
		 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
		 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
		 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
		 */
		XML_SVG_IMAGE: 'image/svg+xml',
	})
	
	/**
	 * Namespaces that are used in this code base.
	 *
	 * @see http://www.w3.org/TR/REC-xml-names
	 */
	var NAMESPACE = freeze({
		/**
		 * The XHTML namespace.
		 *
		 * @see http://www.w3.org/1999/xhtml
		 */
		HTML: 'http://www.w3.org/1999/xhtml',
	
		/**
		 * Checks if `uri` equals `NAMESPACE.HTML`.
		 *
		 * @param {string} [uri]
		 *
		 * @see NAMESPACE.HTML
		 */
		isHTML: function (uri) {
			return uri === NAMESPACE.HTML
		},
	
		/**
		 * The SVG namespace.
		 *
		 * @see http://www.w3.org/2000/svg
		 */
		SVG: 'http://www.w3.org/2000/svg',
	
		/**
		 * The `xml:` namespace.
		 *
		 * @see http://www.w3.org/XML/1998/namespace
		 */
		XML: 'http://www.w3.org/XML/1998/namespace',
	
		/**
		 * The `xmlns:` namespace
		 *
		 * @see https://www.w3.org/2000/xmlns/
		 */
		XMLNS: 'http://www.w3.org/2000/xmlns/',
	})
	
	exports.assign = assign;
	exports.find = find;
	exports.freeze = freeze;
	exports.MIME_TYPE = MIME_TYPE;
	exports.NAMESPACE = NAMESPACE;


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// This file hosts our error definitions
	// We use custom error "types" so that we can act on them when we need it
	// e.g.: if error instanceof errors.UnparsableJSON then..
	
	var inherits = __webpack_require__(406);
	
	function AlgoliaSearchError(message, extraProperties) {
	  var forEach = __webpack_require__(685);
	
	  var error = this;
	
	  // try to get a stacktrace
	  if (typeof Error.captureStackTrace === 'function') {
	    Error.captureStackTrace(this, this.constructor);
	  } else {
	    error.stack = (new Error()).stack || 'Cannot get a stacktrace, browser is too old';
	  }
	
	  this.name = 'AlgoliaSearchError';
	  this.message = message || 'Unknown error';
	
	  if (extraProperties) {
	    forEach(extraProperties, function addToErrorObject(value, key) {
	      error[key] = value;
	    });
	  }
	}
	
	inherits(AlgoliaSearchError, Error);
	
	function createCustomError(name, message) {
	  function AlgoliaSearchCustomError() {
	    var args = Array.prototype.slice.call(arguments, 0);
	
	    // custom message not set, use default
	    if (typeof args[0] !== 'string') {
	      args.unshift(message);
	    }
	
	    AlgoliaSearchError.apply(this, args);
	    this.name = 'AlgoliaSearch' + name + 'Error';
	  }
	
	  inherits(AlgoliaSearchCustomError, AlgoliaSearchError);
	
	  return AlgoliaSearchCustomError;
	}
	
	// late exports to let various fn defs and inherits take place
	module.exports = {
	  AlgoliaSearchError: AlgoliaSearchError,
	  UnparsableJSON: createCustomError(
	    'UnparsableJSON',
	    'Could not parse the incoming response as JSON, see err.more for details'
	  ),
	  RequestTimeout: createCustomError(
	    'RequestTimeout',
	    'Request timed out before getting a response'
	  ),
	  Network: createCustomError(
	    'Network',
	    'Network issue, see err.more for details'
	  ),
	  JSONPScriptFail: createCustomError(
	    'JSONPScriptFail',
	    '<script> was loaded but did not call our provided callback'
	  ),
	  ValidUntilNotFound: createCustomError(
	    'ValidUntilNotFound',
	    'The SecuredAPIKey does not have a validUntil parameter.'
	  ),
	  JSONPScriptError: createCustomError(
	    'JSONPScriptError',
	    '<script> unable to load due to an `error` event on it'
	  ),
	  ObjectNotFound: createCustomError(
	    'ObjectNotFound',
	    'Object not found'
	  ),
	  Unknown: createCustomError(
	    'Unknown',
	    'Unknown error occured'
	  )
	};


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	var foreach = __webpack_require__(685);
	
	module.exports = function map(arr, fn) {
	  var newArr = [];
	  foreach(arr, function(item, itemIndex) {
	    newArr.push(fn(item, itemIndex, arr));
	  });
	  return newArr;
	};


/***/ },
/* 915 */,
/* 916 */,
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	
	var _ = __webpack_require__(1);
	var Backbone = __webpack_require__(4);
	
	// Methods in the collection prototype that we won't expose
	var blacklistedMethods = [
	  "_onModelEvent", "_prepareModel", "_removeReference", "_reset", "add",
	  "initialize", "sync", "remove", "reset", "set", "push", "pop", "unshift",
	  "shift", "sort", "parse", "fetch", "create", "model", "off", "on",
	  "listenTo", "listenToOnce", "bind", "trigger", "once", "stopListening"
	];
	
	var eventWhiteList = [
	  'add', 'remove', 'reset', 'sort', 'destroy', 'sync', 'request', 'error'
	];
	
	function proxyCollection(from, target) {
	
	  function updateLength() {
	    target.length = from.length;
	  }
	
	  function pipeEvents(eventName) {
	    var args = _.toArray(arguments);
	    var isChangeEvent = eventName === 'change' ||
	                        eventName.slice(0, 7) === 'change:';
	
	    // In the case of a `reset` event, the Collection.models reference
	    // is updated to a new array, so we need to update our reference.
	    if (eventName === 'reset') {
	      target.models = from.models;
	    }
	
	    if (_.contains(eventWhiteList, eventName)) {
	      if (_.contains(['add', 'remove', 'destroy'], eventName)) {
	        args[2] = target;
	      } else if (_.contains(['reset', 'sort'], eventName)) {
	        args[1] = target;
	      }
	      target.trigger.apply(this, args);
	    } else if (isChangeEvent) {
	      // In some cases I was seeing change events fired after the model
	      // had already been removed from the collection.
	      if (target.contains(args[1])) {
	        target.trigger.apply(this, args);
	      }
	    }
	  }
	
	  var methods = {};
	
	  _.each(_.functions(Backbone.Collection.prototype), function(method) {
	    if (!_.contains(blacklistedMethods, method)) {
	      methods[method] = function() {
	        return from[method].apply(from, arguments);
	      };
	    }
	  });
	
	  _.extend(target, Backbone.Events, methods);
	
	  target.listenTo(from, 'all', updateLength);
	  target.listenTo(from, 'all', pipeEvents);
	  target.models = from.models;
	
	  updateLength();
	  return target;
	}
	
	module.exports = proxyCollection;
	


/***/ },
/* 918 */
[2109, 1603],
/* 919 */
373,
/* 920 */
[2110, 987],
/* 921 */
220,
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(372)
	  , IObject  = __webpack_require__(927)
	  , toObject = __webpack_require__(470)
	  , toLength = __webpack_require__(305)
	  , asc      = __webpack_require__(1626);
	module.exports = function(TYPE){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? asc($this, length) : IS_FILTER ? asc($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 923 */
[2106, 468, 216],
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(220)
	  , $export        = __webpack_require__(56)
	  , redefine       = __webpack_require__(342)
	  , redefineAll    = __webpack_require__(928)
	  , forOf          = __webpack_require__(749)
	  , strictNew      = __webpack_require__(930)
	  , isObject       = __webpack_require__(184)
	  , fails          = __webpack_require__(239)
	  , $iterDetect    = __webpack_require__(996)
	  , setToStringTag = __webpack_require__(751);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO;
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        strictNew(target, C, NAME);
	        var that = new Base;
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    IS_WEAK || instance.forEach(function(val, key){
	      BUGGY_ZERO = 1 / key === -Infinity;
	    });
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(374)
	  , redefine = __webpack_require__(342)
	  , fails    = __webpack_require__(239)
	  , defined  = __webpack_require__(373)
	  , wks      = __webpack_require__(216);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , original = ''[KEY];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, exec(defined, SYMBOL, original));
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return original.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return original.call(string, this); }
	    );
	  }
	};

/***/ },
/* 926 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 927 */
[2113, 468],
/* 928 */
[2121, 342],
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(220)
	  , $           = __webpack_require__(133)
	  , DESCRIPTORS = __webpack_require__(340)
	  , SPECIES     = __webpack_require__(216)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 930 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(56)
	  , defined = __webpack_require__(373)
	  , fails   = __webpack_require__(239)
	  , spaces  = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	      '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF'
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec){
	  var exp  = {};
	  exp[KEY] = exec(trim);
	  $export($export.P + $export.F * fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  }), 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },
/* 932 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 933 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 934 */
/***/ function(module, exports) {

	/*
	 * Copyright 2012-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var empty = {};
	
	/**
	 * Mix the properties from the source object into the destination object.
	 * When the same property occurs in more then one object, the right most
	 * value wins.
	 *
	 * @param {Object} dest the object to copy properties to
	 * @param {Object} sources the objects to copy properties from.  May be 1 to N arguments, but not an Array.
	 * @return {Object} the destination object
	 */
	function mixin(dest /*, sources... */) {
		var i, l, source, name;
	
		if (!dest) { dest = {}; }
		for (i = 1, l = arguments.length; i < l; i += 1) {
			source = arguments[i];
			for (name in source) {
				if (!(name in dest) || (dest[name] !== source[name] && (!(name in empty) || empty[name] !== source[name]))) {
					dest[name] = source[name];
				}
			}
		}
	
		return dest; // Object
	}
	
	module.exports = mixin;


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1757);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!../sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./jquery.timepicker.css", function() {
				var newContent = require("!!../css-loader/index.js!../sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./jquery.timepicker.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($, module) {!function(){"use strict";function e(t){return e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e(t)}function t(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function n(e,t,i){return t in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}function r(e,t){var i=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),i.push.apply(i,n)}return i}function s(e){for(var t=1;t<arguments.length;t++){var i=null!=arguments[t]?arguments[t]:{};t%2?r(Object(i),!0).forEach((function(t){n(e,t,i[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(i)):r(Object(i)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(i,t))}))}return e}function a(e,t){(null==t||t>e.length)&&(t=e.length);for(var i=0,n=new Array(t);i<t;i++)n[i]=e[i];return n}function l(e,t){var i;if("undefined"==typeof Symbol||null==e[Symbol.iterator]){if(Array.isArray(e)||(i=function(e,t){if(e){if("string"==typeof e)return a(e,t);var i=Object.prototype.toString.call(e).slice(8,-1);return"Object"===i&&e.constructor&&(i=e.constructor.name),"Map"===i||"Set"===i?Array.from(e):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?a(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){i&&(e=i);var n=0,r=function(){};return{s:r,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:r}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var s,l=!0,o=!1;return{s:function(){i=e[Symbol.iterator]()},n:function(){var e=i.next();return l=e.done,e},e:function(e){o=!0,s=e},f:function(){try{l||null==i.return||i.return()}finally{if(o)throw s}}}}var o=86400,u={bubbles:!0,cancelable:!1,detail:null};function c(e,t){return e==o&&t.show2400?e:e%o}var m,d={appendTo:"body",className:null,closeOnWindow:!1,closeOnScroll:!1,disableTextInput:!1,disableTimeRanges:[],disableTouchKeyboard:!1,durationTime:null,forceRoundTime:!1,lang:{},listWidth:null,maxTime:null,minTime:null,noneOption:!1,orientation:"l",roundingFunction:function(e,t){if(null===e)return null;for(var i=0,n=0;n<e;)i++,n+=60*t.step(i);var r=n-60*t.step(i-1);return c(e-r<n-e?r:n,t)},scrollDefault:null,selectOnBlur:!1,show2400:!1,showDuration:!1,showOn:["click","focus"],step:30,stopScrollPropagation:!1,timeFormat:"g:ia",typeaheadHighlight:!0,useSelect:!1,wrapHours:!0},f={am:"am",pm:"pm",AM:"AM",PM:"PM",decimal:".",mins:"mins",hr:"hr",hrs:"hrs"},p=function(){function n(e){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};t(this,n),this._handleFormatValue=this._handleFormatValue.bind(this),this._handleKeyUp=this._handleKeyUp.bind(this),this.targetEl=e;var r=n.extractAttrOptions(e,Object.keys(d));this.settings=this.parseSettings(s(s(s({},d),i),r))}var r,a,c;return r=n,c=[{key:"extractAttrOptions",value:function(e,t){var i,n={},r=l(t);try{for(r.s();!(i=r.n()).done;){var s=i.value;s in e.dataset&&(n[s]=e.dataset[s])}}catch(e){r.e(e)}finally{r.f()}return n}},{key:"isVisible",value:function(e){var t=e[0];return t.offsetWidth>0&&t.offsetHeight>0}},{key:"hideAll",value:function(){var e,t=l(document.getElementsByClassName("ui-timepicker-input"));try{for(t.s();!(e=t.n()).done;){var i=e.value.timepickerObj;i&&i.hideMe()}}catch(e){t.e(e)}finally{t.f()}}}],(a=[{key:"hideMe",value:function(){if(this.settings.useSelect)this.targetEl.blur();else if(this.list&&n.isVisible(this.list)){this.settings.selectOnBlur&&this._selectValue(),this.list.hide();var e=new CustomEvent("hideTimepicker",u);this.targetEl.dispatchEvent(e)}}},{key:"_findRow",value:function(e){if(!e&&0!==e)return!1;var t=!1;return e=this.settings.roundingFunction(e,this.settings),!!this.list&&(this.list.find("li").each((function(i,n){var r=parseInt(n.dataset.time);if(!isNaN(r))return r==e?(t=n,!1):void 0})),t)}},{key:"_hideKeyboard",value:function(){return(window.navigator.msMaxTouchPoints||"ontouchstart"in document)&&this.settings.disableTouchKeyboard}},{key:"_setTimeValue",value:function(e,t){if("INPUT"===this.targetEl.nodeName){null===e&&""==this.targetEl.value||(this.targetEl.value=e);var i=this;i.settings.useSelect&&"select"!=t&&i.list&&i.list.val(i._roundAndFormatTime(i.anytime2int(e)))}var n=new CustomEvent("selectTime",u);if(this.selectedValue!=e){this.selectedValue=e;var r=new CustomEvent("changeTime",u),s=new CustomEvent("change",Object.assign(u,{detail:"timepicker"}));return"select"==t?(this.targetEl.dispatchEvent(n),this.targetEl.dispatchEvent(r),this.targetEl.dispatchEvent(s)):-1==["error","initial"].indexOf(t)&&this.targetEl.dispatchEvent(r),!0}return-1==["error","initial"].indexOf(t)&&this.targetEl.dispatchEvent(n),!1}},{key:"_getTimeValue",value:function(){return"INPUT"===this.targetEl.nodeName?this.targetEl.value:this.selectedValue}},{key:"_selectValue",value:function(){var e=this;e.settings;var t=e.list.find(".ui-timepicker-selected");if(t.hasClass("ui-timepicker-disabled"))return!1;if(!t.length)return!0;var i=t.get(0).dataset.time;if(i){var n=parseInt(i);isNaN(n)||(i=n)}return null!==i&&("string"!=typeof i&&(i=e._int2time(i)),e._setTimeValue(i,"select")),!0}},{key:"anytime2int",value:function(t){return"number"==typeof t?t:"string"==typeof t?this.time2int(t):"object"===e(t)&&t instanceof Date?3600*t.getHours()+60*t.getMinutes()+t.getSeconds():"function"==typeof t?t():null}},{key:"time2int",value:function(e){if(""===e||null==e)return null;if("now"===e)return this.anytime2int(new Date);if("string"!=typeof e)return e;e=e.toLowerCase().replace(/[\s\.]/g,""),"am"!==this.settings.lang.am||"a"!=e.slice(-1)&&"p"!=e.slice(-1)||(e+="m");var t=/^(([^0-9]*))?([0-9]?[0-9])(([0-5][0-9]))?(([0-5][0-9]))?(([^0-9]*))$/;e.match(/\W/)&&(t=/^(([^0-9]*))?([0-9]?[0-9])(\W+([0-5][0-9]?))?(\W+([0-5][0-9]))?(([^0-9]*))$/);var i=e.match(t);if(!i)return null;var n=parseInt(1*i[3],10),r=i[2]||i[9],s=this.parseMinuteString(i[5]),a=1*i[7]||0;r||2!=i[3].length||"0"!=i[3][0]||(r="am"),n>24&&!s&&(n=1*i[3][0],s=this.parseMinuteString(i[3][1]));var l=n;if(n<=12&&r){var u=(r=r.trim())==this.settings.lang.pm||r==this.settings.lang.PM;l=12==n?u?12:0:n+(u?12:0)}else if(3600*n+60*s+a>=o+(this.settings.show2400?1:0)){if(!1===this.settings.wrapHours)return null;l=n%24}var c=3600*l+60*s+a;if(n<12&&!r&&this.settings._twelveHourTime&&this.settings.scrollDefault()){var m=c-this.settings.scrollDefault();m<0&&m>=-43200&&(c=(c+43200)%o)}return c}},{key:"parseMinuteString",value:function(e){e||(e=0);var t=1;return 1==e.length&&(t=10),parseInt(e)*t||0}},{key:"intStringDateOrFunc2func",value:function(e){var t=this;return null==e?function(){return null}:"function"==typeof e?function(){return t.anytime2int(e())}:function(){return t.anytime2int(e)}}},{key:"parseSettings",value:function(e){if(e.lang=s(s({},f),e.lang),this.settings=e,e.listWidth&&(e.listWidth=this.anytime2int(e.listWidth)),e.minTime=this.intStringDateOrFunc2func(e.minTime),e.maxTime=this.intStringDateOrFunc2func(e.maxTime),e.durationTime=this.intStringDateOrFunc2func(e.durationTime),e.scrollDefault?e.scrollDefault=this.intStringDateOrFunc2func(e.scrollDefault):e.scrollDefault=e.minTime,"string"==typeof e.timeFormat&&e.timeFormat.match(/[gh]/)&&(e._twelveHourTime=!0),"function"!=typeof e.step){var t=e.step;e.step=function(){return t}}return e.disableTimeRanges=this._parseDisableTimeRanges(e.disableTimeRanges),e.closeOnWindowScroll&&!e.closeOnScroll&&(e.closeOnScroll=e.closeOnWindowScroll),!0===e.closeOnScroll&&(e.closeOnScroll=window.document),e}},{key:"_parseDisableTimeRanges",value:function(e){if(!e||0==e.length)return[];for(var t in e)e[t]=[this.anytime2int(e[t][0]),this.anytime2int(e[t][1])];for(t=(e=e.sort((function(e,t){return e[0]-t[0]}))).length-1;t>0;t--)e[t][0]<=e[t-1][1]&&(e[t-1]=[Math.min(e[t][0],e[t-1][0]),Math.max(e[t][1],e[t-1][1])],e.splice(t,1));return e}},{key:"_disableTextInputHandler",value:function(e){switch(e.keyCode){case 13:case 9:return;default:e.preventDefault()}}},{key:"_int2duration",value:function(e,t){e=Math.abs(e);var i,n,r=Math.round(e/60),s=[];return r<60?s=[r,this.settings.lang.mins]:(i=Math.floor(r/60),n=r%60,30==t&&30==n&&(i+=this.settings.lang.decimal+5),s.push(i),s.push(1==i?this.settings.lang.hr:this.settings.lang.hrs),30!=t&&n&&(s.push(n),s.push(this.settings.lang.mins))),s.join(" ")}},{key:"_roundAndFormatTime",value:function(e){if(null!==(e=this.settings.roundingFunction(e,this.settings)))return this._int2time(e)}},{key:"_int2time",value:function(e){if("number"!=typeof e)return null;var t=parseInt(e%60),i=parseInt(e/60%60),n=parseInt(e/3600%24),r=new Date(1970,0,2,n,i,t,0);if(isNaN(r.getTime()))return null;if("function"==typeof this.settings.timeFormat)return this.settings.timeFormat(r);for(var s,a,l="",u=0;u<this.settings.timeFormat.length;u++)switch(a=this.settings.timeFormat.charAt(u)){case"a":l+=r.getHours()>11?this.settings.lang.pm:this.settings.lang.am;break;case"A":l+=r.getHours()>11?this.settings.lang.PM:this.settings.lang.AM;break;case"g":l+=0==(s=r.getHours()%12)?"12":s;break;case"G":s=r.getHours(),e===o&&(s=this.settings.show2400?24:0),l+=s;break;case"h":0!=(s=r.getHours()%12)&&s<10&&(s="0"+s),l+=0===s?"12":s;break;case"H":s=r.getHours(),e===o&&(s=this.settings.show2400?24:0),l+=s>9?s:"0"+s;break;case"i":l+=(i=r.getMinutes())>9?i:"0"+i;break;case"s":l+=(t=r.getSeconds())>9?t:"0"+t;break;case"\\":u++,l+=this.settings.timeFormat.charAt(u);break;default:l+=a}return l}},{key:"_setSelected",value:function(){var e=this.list;e.find("li").removeClass("ui-timepicker-selected");var t=this.anytime2int(this._getTimeValue());if(null!==t){var i=this._findRow(t);if(i){var n=i.getBoundingClientRect(),r=e.get(0).getBoundingClientRect(),s=n.top-r.top;if(s+n.height>r.height||s<0){var a=e.scrollTop()+(n.top-r.top)-n.height;e.scrollTop(a)}var l=parseInt(i.dataset.time);(this.settings.forceRoundTime||l===t)&&i.classList.add("ui-timepicker-selected")}}}},{key:"_isFocused",value:function(e){return e===document.activeElement}},{key:"_handleFormatValue",value:function(e){e&&"timepicker"==e.detail||this._formatValue(e)}},{key:"_formatValue",value:function(e,t){if(""!==this.targetEl.value){if(!this._isFocused(this.targetEl)||e&&"change"==e.type){var i=this.settings,n=this.anytime2int(this.targetEl.value);if(null!==n){var r=this._isTimeRangeError(n,i);if(i.forceRoundTime){var s=i.roundingFunction(n,i);s!=n&&(n=s,t=null)}var a=this._int2time(n);if(r){this._setTimeValue(a);var l=new CustomEvent("timeRangeError",u);this.targetEl.dispatchEvent(l)}else this._setTimeValue(a,t)}else{var o=new CustomEvent("timeFormatError",u);this.targetEl.dispatchEvent(o)}}}else this._setTimeValue(null,t)}},{key:"_isTimeRangeError",value:function(e,t){if(null!==t.minTime&&null!==t.maxTime&&(e<t.minTime()||e>t.maxTime()))return!0;var i,n=l(t.disableTimeRanges);try{for(n.s();!(i=n.n()).done;){var r=i.value;if(e>=r[0]&&e<r[1])return!0}}catch(e){n.e(e)}finally{n.f()}return!1}},{key:"_generateNoneElement",value:function(t,i){var n,r,s,a;return"object"==e(t)?(n=t.label,r=t.className,s=t.value):"string"==typeof t?(n=t,s=""):$.error("Invalid noneOption value"),i?(a=document.createElement("option")).value=s:(a=document.createElement("li")).dataset.time=String(s),a.innerText=n,a.classList.add(r),a}},{key:"_handleKeyUp",value:function(e){var t=this;if(!this.list||!n.isVisible(this.list)||this.settings.disableTextInput)return!0;if("paste"!==e.type&&"cut"!==e.type)switch(e.keyCode){case 96:case 97:case 98:case 99:case 100:case 101:case 102:case 103:case 104:case 105:case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:case 65:case 77:case 80:case 186:case 8:case 46:this.settings.typeaheadHighlight?this._setSelected():this.list.hide()}else setTimeout((function(){t.settings.typeaheadHighlight?t._setSelected():t.list.hide()}),0)}}])&&i(r.prototype,a),c&&i(r,c),n}();function h(t){return Array.isArray(t)?t.map(h):!0===t?{label:"None",value:""}:"object"===e(t)?t:{label:t,value:""}}function g(e){var t=document.createElement("option");return t.value=e.value||e.label,e.duration?t.appendChild(document.createTextNode(e.label+" ("+e.duration+")")):t.appendChild(document.createTextNode(e.label)),e.disabled&&(t.disabled=!0),t}function v(e){var t=document.createElement("li");if(t.dataset.time=e.value,e.className&&t.classList.add(e.className),t.className=e.className,t.appendChild(document.createTextNode(e.label)),e.duration){var i=document.createElement("span");i.appendChild(document.createTextNode("("+e.duration+")")),i.classList.add("ui-timepicker-duration"),t.appendChild(i)}return e.disabled&&t.classList.add("ui-timepicker-disabled"),t}function y(e){var t,i=[].concat(function(e){if(!e.noneOption)return[];var t=h(e.noneOption);return Array.isArray(e.noneOption)?t:[t]}(e.settings),function(e){var t,i,n=e.settings,r=null!==(t=n.minTime())&&void 0!==t?t:0,s=null!==(i=n.maxTime())&&void 0!==i?i:r+o-1;s<r&&(s+=o),86399===s&&"string"==typeof n.timeFormat&&n.show2400&&(s=o);for(var a=[],u=r,m=0;u<=s;m++,u+=60*n.step(m)){var d=u,f=e._int2time(d),p=d%o<43200?"ui-timepicker-am":"ui-timepicker-pm",h={label:f,value:c(d,n),className:p};if((null!==n.minTime()||null!==n.durationTime())&&n.showDuration){var g,v=null!==(g=n.durationTime())&&void 0!==g?g:n.minTime();v>u&&(v-=o);var y=e._int2duration(u-v,n.step());h.duration=y}var b,k=l(n.disableTimeRanges);try{for(k.s();!(b=k.n()).done;){var T=b.value;if(d%o>=T[0]&&d%o<T[1]){h.disabled=!0;break}}}catch(e){k.e(e)}finally{k.f()}a.push(h)}return a}(e));if(t=e.settings.useSelect?function(e,t){var i=document.createElement("select");i.classList.add("ui-timepicker-select"),t&&(i.name="ui-timepicker-"+t);var n,r=l(e);try{for(r.s();!(n=r.n()).done;){var s=g(n.value);i.appendChild(s)}}catch(e){r.e(e)}finally{r.f()}return i}(i,e.targetEl.name):function(e){var t=document.createElement("ul");t.classList.add("ui-timepicker-list");var i,n=l(e);try{for(n.s();!(i=n.n()).done;){var r=v(i.value);t.appendChild(r)}}catch(e){n.e(e)}finally{n.f()}var s=document.createElement("div");return s.classList.add("ui-timepicker-wrapper"),s.tabIndex=-1,s.style.display="none",s.style.position="absolute",s.appendChild(t),s}(i),e.settings.className){var n,r=l(e.settings.className.split(" "));try{for(r.s();!(n=r.n()).done;){var s=n.value;t.classList.add(s)}}catch(e){r.e(e)}finally{r.f()}}return!e.settings.showDuration||null===e.settings.minTime&&null===e.settings.durationTime||(t.classList.add("ui-timepicker-with-duration"),t.classList.add("ui-timepicker-step-"+e.settings.step())),t}!function(){if("function"==typeof window.CustomEvent)return!1;window.CustomEvent=function(e,t){t||(t={}),t=Object.assign(u,t);var i=document.createEvent("CustomEvent");return i.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),i}}(),m=function(t){var i={init:function(e){return this.each((function(){var r=t(this),a=new p(this,e),l=a.settings;if(l.lang,this.timepickerObj=a,r.addClass("ui-timepicker-input"),l.useSelect)n(r);else{if(r.prop("autocomplete","off"),l.showOn)for(var o in l.showOn)r.on(l.showOn[o]+".timepicker",i.show);r.on("change.timepicker",a._handleFormatValue),r.on("keydown.timepicker",s),r.on("keyup.timepicker",a._handleKeyUp),l.disableTextInput&&r.on("keydown.timepicker",a._disableTextInputHandler),r.on("cut.timepicker",a._handleKeyUp),r.on("paste.timepicker",a._handleKeyUp),a._formatValue(null,"initial")}}))},show:function(e){var i=t(this),s=i[0].timepickerObj,a=s.settings;if(e&&e.preventDefault(),a.useSelect)s.list.trigger("focus");else{s._hideKeyboard()&&i.trigger("blur");var l=s.list;if(!i.prop("readonly")&&(n(i),l=s.list,!p.isVisible(l))){i.is("input")&&(s.selectedValue=i.val()),s._setSelected(),p.hideAll(),"number"==typeof a.listWidth&&l.width(i.outerWidth()*a.listWidth),l.show();var o={};a.orientation.match(/r/)?o.left=i.offset().left+i.outerWidth()-l.outerWidth()+parseInt(l.css("marginLeft").replace("px",""),10):a.orientation.match(/l/)?o.left=i.offset().left+parseInt(l.css("marginLeft").replace("px",""),10):a.orientation.match(/c/)&&(o.left=i.offset().left+(i.outerWidth()-l.outerWidth())/2+parseInt(l.css("marginLeft").replace("px",""),10)),"t"==(a.orientation.match(/t/)?"t":a.orientation.match(/b/)?"b":i.offset().top+i.outerHeight(!0)+l.outerHeight()>t(window).height()+t(window).scrollTop()?"t":"b")?(l.addClass("ui-timepicker-positioned-top"),o.top=i.offset().top-l.outerHeight()+parseInt(l.css("marginTop").replace("px",""),10)):(l.removeClass("ui-timepicker-positioned-top"),o.top=i.offset().top+i.outerHeight()+parseInt(l.css("marginTop").replace("px",""),10)),l.offset(o);var u=l.find(".ui-timepicker-selected");if(!u.length){var c=s.anytime2int(s._getTimeValue());null!==c?u=t(s._findRow(c)):a.scrollDefault()&&(u=t(s._findRow(a.scrollDefault())))}if(u.length&&!u.hasClass("ui-timepicker-disabled")||(u=l.find("li:not(.ui-timepicker-disabled):first")),u&&u.length){var m=l.scrollTop()+u.position().top-u.outerHeight();l.scrollTop(m)}else l.scrollTop(0);return a.stopScrollPropagation&&t(document).on("wheel.ui-timepicker",".ui-timepicker-wrapper",(function(e){e.preventDefault();var i=t(this).scrollTop();t(this).scrollTop(i+e.originalEvent.deltaY)})),t(document).on("mousedown.ui-timepicker",r),window.addEventListener("resize",r),a.closeOnScroll&&t(a.closeOnScroll).on("scroll.ui-timepicker",r),i.trigger("showTimepicker"),this}}},hide:function(e){var t=this[0].timepickerObj;return t&&t.hideMe(),p.hideAll(),this},option:function(i,r){return"string"==typeof i&&void 0===r?this[0].timepickerObj.settings[i]:this.each((function(){var s=t(this),a=s[0].timepickerObj,l=a.settings,o=a.list;"object"==e(i)?l=t.extend(l,i):"string"==typeof i&&(l[i]=r),l=a.parseSettings(l),a.settings=l,a._formatValue({type:"change"},"initial"),o&&(o.remove(),a.list=null),l.useSelect&&n(s)}))},getSecondsFromMidnight:function(){var e=this[0].timepickerObj;return e.anytime2int(e._getTimeValue())},getTime:function(e){var t=this[0].timepickerObj,i=t._getTimeValue();if(!i)return null;var n=t.anytime2int(i);if(null===n)return null;e||(e=new Date);var r=new Date(e);return r.setHours(n/3600),r.setMinutes(n%3600/60),r.setSeconds(n%60),r.setMilliseconds(0),r},isVisible:function(){var e=this[0].timepickerObj;return!!(e&&e.list&&p.isVisible(e.list))},setTime:function(e){var t=this[0].timepickerObj,i=t.settings,n=t.anytime2int(e);if(t._isTimeRangeError(n,i)){var r=new CustomEvent("timeRangeError",u);t.targetEl.dispatchEvent(r)}if(i.forceRoundTime)var s=t._roundAndFormatTime(n);else s=t._int2time(n);return e&&null===s&&i.noneOption&&(s=e),t._setTimeValue(s,"initial"),t._formatValue({type:"change"},"initial"),t&&t.list&&t._setSelected(),this},remove:function(){var e=this;if(e.hasClass("ui-timepicker-input")){var t=e[0].timepickerObj,i=t.settings;return e.removeAttr("autocomplete","off"),e.removeClass("ui-timepicker-input"),e.removeData("timepicker-obj"),e.off(".timepicker"),t.list&&t.list.remove(),i.useSelect&&e.show(),t.list=null,this}}};function n(e){var n=e[0].timepickerObj,r=n.list,s=n.settings;r&&r.length&&(r.remove(),n.list=null);var a=t(y(n));if(r=s.useSelect?a:a.children("ul"),a.data("timepicker-input",e),n.list=a,s.useSelect)e.val()&&r.val(n._roundAndFormatTime(n.anytime2int(e.val()))),r.on("focus",(function(){t(this).data("timepicker-input").trigger("showTimepicker")})),r.on("blur",(function(){t(this).data("timepicker-input").trigger("hideTimepicker")})),r.on("change",(function(){n._setTimeValue(t(this).val(),"select")})),n._setTimeValue(r.val(),"initial"),e.hide().after(r);else{var l=s.appendTo;"string"==typeof l?l=t(l):"function"==typeof l&&(l=l(e)),l.append(a),n._setSelected(),r.on("mousedown click","li",(function(s){e.off("focus.timepicker"),e.on("focus.timepicker-ie-hack",(function(){e.off("focus.timepicker-ie-hack"),e.on("focus.timepicker",i.show)})),n._hideKeyboard()||e[0].focus(),r.find("li").removeClass("ui-timepicker-selected"),t(this).addClass("ui-timepicker-selected"),n._selectValue()&&(e.trigger("hideTimepicker"),r.on("mouseup.timepicker click.timepicker","li",(function(e){r.off("mouseup.timepicker click.timepicker"),a.hide()})))}))}}function r(e){if("focus"!=e.type||e.target!=window){var i=t(e.target);i.closest(".ui-timepicker-input").length||i.closest(".ui-timepicker-wrapper").length||(p.hideAll(),t(document).off(".ui-timepicker"),t(window).off(".ui-timepicker"))}}function s(e){var n=t(this),r=n[0].timepickerObj,s=r.list;if(!s||!p.isVisible(s)){if(40!=e.keyCode)return!0;i.show.call(n.get(0)),s=r.list,r._hideKeyboard()||n.trigger("focus")}switch(e.keyCode){case 13:return r._selectValue()&&(r._formatValue({type:"change"}),r.hideMe()),e.preventDefault(),!1;case 38:var a=s.find(".ui-timepicker-selected");return a.length?a.is(":first-child")||(a.removeClass("ui-timepicker-selected"),a.prev().addClass("ui-timepicker-selected"),a.prev().position().top<a.outerHeight()&&s.scrollTop(s.scrollTop()-a.outerHeight())):(s.find("li").each((function(e,i){if(t(i).position().top>0)return a=t(i),!1})),a.addClass("ui-timepicker-selected")),!1;case 40:return 0===(a=s.find(".ui-timepicker-selected")).length?(s.find("li").each((function(e,i){if(t(i).position().top>0)return a=t(i),!1})),a.addClass("ui-timepicker-selected")):a.is(":last-child")||(a.removeClass("ui-timepicker-selected"),a.next().addClass("ui-timepicker-selected"),a.next().position().top+2*a.outerHeight()>s.outerHeight()&&s.scrollTop(s.scrollTop()+a.outerHeight())),!1;case 27:s.find("li").removeClass("ui-timepicker-selected"),r.hideMe();break;case 9:r.hideMe();break;default:return!0}}t.fn.timepicker=function(n){return this.length?i[n]?this.hasClass("ui-timepicker-input")?i[n].apply(this,Array.prototype.slice.call(arguments,1)):this:"object"!==e(n)&&n?void t.error("Method "+n+" does not exist on jQuery.timepicker"):i.init.apply(this,arguments):this},t.fn.timepicker.defaults=d},"object"===( false?"undefined":e(exports))&&exports&&"object"===( false?"undefined":e(module))&&module&&module.exports===exports?m(__webpack_require__(11)): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (m), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):m(jQuery)}();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(671)(module)))

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	var strRepeat = __webpack_require__(1498);
	
	module.exports = function pad(str, length, padStr, type) {
	  str = makeString(str);
	  length = ~~length;
	
	  var padlen = 0;
	
	  if (!padStr)
	    padStr = ' ';
	  else if (padStr.length > 1)
	    padStr = padStr.charAt(0);
	
	  switch (type) {
	  case 'right':
	    padlen = length - str.length;
	    return str + strRepeat(padStr, padlen);
	  case 'both':
	    padlen = length - str.length;
	    return strRepeat(padStr, Math.ceil(padlen / 2)) + str + strRepeat(padStr, Math.floor(padlen / 2));
	  default: // 'left'
	    padlen = length - str.length;
	    return strRepeat(padStr, padlen) + str;
	  }
	};


/***/ },
/* 938 */
[1956, 7, 16],
/* 939 */
/***/ function(module, exports) {

	/*!
	 * Bootstrap v3.4.1 (https://getbootstrap.com/)
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery')
	}
	
	+function ($) {
	  'use strict';
	  var version = $.fn.jquery.split(' ')[0].split('.')
	  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
	  }
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // https://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.4.1'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    selector    = selector === '#' ? [] : selector
	    var $parent = $(document).find(selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.4.1'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.4.1'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      if (typeof $next === 'object' && $next.length) {
	        $next[0].offsetWidth // force reflow
	      }
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    if (href) {
	      href = href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	    }
	
	    var target  = $this.attr('data-target') || href
	    var $target = $(document).find(target)
	
	    if (!$target.hasClass('carousel')) return
	
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.4.1'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(document).find(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(document).find(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.4.1'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector !== '#' ? $(document).find(selector) : null
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options = options
	    this.$body = $(document.body)
	    this.$element = $(element)
	    this.$dialog = this.$element.find('.modal-dialog')
	    this.$backdrop = null
	    this.isShown = null
	    this.originalBodyPad = null
	    this.scrollbarWidth = 0
	    this.ignoreBackdropClick = false
	    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION = '3.4.1'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	          this.$element[0] !== e.target &&
	          !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    var scrollbarWidth = this.scrollbarWidth
	    if (this.bodyIsOverflowing) {
	      this.$body.css('padding-right', bodyPad + scrollbarWidth)
	      $(this.fixedContent).each(function (index, element) {
	        var actualPadding = element.style.paddingRight
	        var calculatedPadding = $(element).css('padding-right')
	        $(element)
	          .data('padding-right', actualPadding)
	          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
	      })
	    }
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	    $(this.fixedContent).each(function (index, element) {
	      var padding = $(element).data('padding-right')
	      $(element).removeData('padding-right')
	      element.style.paddingRight = padding ? padding : ''
	    })
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this = $(this)
	      var data = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this = $(this)
	    var href = $this.attr('href')
	    var target = $this.attr('data-target') ||
	      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	
	    var $target = $(document).find(target)
	    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn']
	
	  var uriAttrs = [
	    'background',
	    'cite',
	    'href',
	    'itemtype',
	    'longdesc',
	    'poster',
	    'src',
	    'xlink:href'
	  ]
	
	  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i
	
	  var DefaultWhitelist = {
	    // Global attributes allowed on any supplied element below.
	    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
	    a: ['target', 'href', 'title', 'rel'],
	    area: [],
	    b: [],
	    br: [],
	    col: [],
	    code: [],
	    div: [],
	    em: [],
	    hr: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    i: [],
	    img: ['src', 'alt', 'title', 'width', 'height'],
	    li: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    small: [],
	    span: [],
	    sub: [],
	    sup: [],
	    strong: [],
	    u: [],
	    ul: []
	  }
	
	  /**
	   * A pattern that recognizes a commonly useful subset of URLs that are safe.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi
	
	  /**
	   * A pattern that matches safe data URLs. Only matches image, video and audio types.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i
	
	  function allowedAttribute(attr, allowedAttributeList) {
	    var attrName = attr.nodeName.toLowerCase()
	
	    if ($.inArray(attrName, allowedAttributeList) !== -1) {
	      if ($.inArray(attrName, uriAttrs) !== -1) {
	        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
	      }
	
	      return true
	    }
	
	    var regExp = $(allowedAttributeList).filter(function (index, value) {
	      return value instanceof RegExp
	    })
	
	    // Check if a regular expression validates the attribute.
	    for (var i = 0, l = regExp.length; i < l; i++) {
	      if (attrName.match(regExp[i])) {
	        return true
	      }
	    }
	
	    return false
	  }
	
	  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
	    if (unsafeHtml.length === 0) {
	      return unsafeHtml
	    }
	
	    if (sanitizeFn && typeof sanitizeFn === 'function') {
	      return sanitizeFn(unsafeHtml)
	    }
	
	    // IE 8 and below don't support createHTMLDocument
	    if (!document.implementation || !document.implementation.createHTMLDocument) {
	      return unsafeHtml
	    }
	
	    var createdDocument = document.implementation.createHTMLDocument('sanitization')
	    createdDocument.body.innerHTML = unsafeHtml
	
	    var whitelistKeys = $.map(whiteList, function (el, i) { return i })
	    var elements = $(createdDocument.body).find('*')
	
	    for (var i = 0, len = elements.length; i < len; i++) {
	      var el = elements[i]
	      var elName = el.nodeName.toLowerCase()
	
	      if ($.inArray(elName, whitelistKeys) === -1) {
	        el.parentNode.removeChild(el)
	
	        continue
	      }
	
	      var attributeList = $.map(el.attributes, function (el) { return el })
	      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || [])
	
	      for (var j = 0, len2 = attributeList.length; j < len2; j++) {
	        if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
	          el.removeAttribute(attributeList[j].nodeName)
	        }
	      }
	    }
	
	    return createdDocument.body.innerHTML
	  }
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.4.1'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    },
	    sanitize : true,
	    sanitizeFn : null,
	    whiteList : DefaultWhitelist
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    var dataAttributes = this.$element.data()
	
	    for (var dataAttr in dataAttributes) {
	      if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
	        delete dataAttributes[dataAttr]
	      }
	    }
	
	    options = $.extend({}, this.getDefaults(), dataAttributes, options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    if (options.sanitize) {
	      options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn)
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    if (this.options.html) {
	      if (this.options.sanitize) {
	        title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn)
	      }
	
	      $tip.find('.tooltip-inner').html(title)
	    } else {
	      $tip.find('.tooltip-inner').text(title)
	    }
	
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	  Tooltip.prototype.sanitizeHtml = function (unsafeHtml) {
	    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn)
	  }
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.4.1'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    if (this.options.html) {
	      var typeContent = typeof content
	
	      if (this.options.sanitize) {
	        title = this.sanitizeHtml(title)
	
	        if (typeContent === 'string') {
	          content = this.sanitizeHtml(content)
	        }
	      }
	
	      $tip.find('.popover-title').html(title)
	      $tip.find('.popover-content').children().detach().end()[
	        typeContent === 'string' ? 'html' : 'append'
	      ](content)
	    } else {
	      $tip.find('.popover-title').text(title)
	      $tip.find('.popover-content').children().detach().end().text(content)
	    }
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	        o.content.call($e[0]) :
	        o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.4.1'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.4.1'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(document).find(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	        .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	          .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    var target = this.options.target === Affix.DEFAULTS.target ? $(this.options.target) : $(document).find(this.options.target)
	
	    this.$target = target
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.4.1'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);


/***/ },
/* 940 */
/***/ function(module, exports) {

	function _extends() {
	  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
	    for (var e = 1; e < arguments.length; e++) {
	      var t = arguments[e];
	      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
	    }
	    return n;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(347);
	
	var css = {
	  wrapper: {
	    position: 'relative',
	    display: 'inline-block'
	  },
	  hint: {
	    position: 'absolute',
	    top: '0',
	    left: '0',
	    borderColor: 'transparent',
	    boxShadow: 'none',
	    // #741: fix hint opacity issue on iOS
	    opacity: '1'
	  },
	  input: {
	    position: 'relative',
	    verticalAlign: 'top',
	    backgroundColor: 'transparent'
	  },
	  inputWithNoHint: {
	    position: 'relative',
	    verticalAlign: 'top'
	  },
	  dropdown: {
	    position: 'absolute',
	    top: '100%',
	    left: '0',
	    zIndex: '100',
	    display: 'none'
	  },
	  suggestions: {
	    display: 'block'
	  },
	  suggestion: {
	    whiteSpace: 'nowrap',
	    cursor: 'pointer'
	  },
	  suggestionChild: {
	    whiteSpace: 'normal'
	  },
	  ltr: {
	    left: '0',
	    right: 'auto'
	  },
	  rtl: {
	    left: 'auto',
	    right: '0'
	  },
	  defaultClasses: {
	    root: 'algolia-autocomplete',
	    prefix: 'aa',
	    noPrefix: false,
	    dropdownMenu: 'dropdown-menu',
	    input: 'input',
	    hint: 'hint',
	    suggestions: 'suggestions',
	    suggestion: 'suggestion',
	    cursor: 'cursor',
	    dataset: 'dataset',
	    empty: 'empty'
	  },
	  // will be merged with the default ones if appendTo is used
	  appendTo: {
	    wrapper: {
	      position: 'absolute',
	      zIndex: '100',
	      display: 'none'
	    },
	    input: {},
	    inputWithNoHint: {},
	    dropdown: {
	      display: 'block'
	    }
	  }
	};
	
	// ie specific styling
	if (_.isMsie()) {
	  // ie6-8 (and 9?) doesn't fire hover and click events for elements with
	  // transparent backgrounds, for a workaround, use 1x1 transparent gif
	  _.mixin(css.input, {
	    backgroundImage: 'url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)'
	  });
	}
	
	// ie7 and under specific styling
	if (_.isMsie() && _.isMsie() <= 7) {
	  // if someone can tell me why this is necessary to align
	  // the hint with the query in ie7, i'll send you $5 - @JakeHarding
	  _.mixin(css.input, {marginTop: '-1px'});
	}
	
	module.exports = css;


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var immediate = __webpack_require__(1792);
	var splitter = /\s+/;
	
	module.exports = {
	  onSync: onSync,
	  onAsync: onAsync,
	  off: off,
	  trigger: trigger
	};
	
	function on(method, types, cb, context) {
	  var type;
	
	  if (!cb) {
	    return this;
	  }
	
	  types = types.split(splitter);
	  cb = context ? bindContext(cb, context) : cb;
	
	  this._callbacks = this._callbacks || {};
	
	  while (type = types.shift()) {
	    this._callbacks[type] = this._callbacks[type] || {sync: [], async: []};
	    this._callbacks[type][method].push(cb);
	  }
	
	  return this;
	}
	
	function onAsync(types, cb, context) {
	  return on.call(this, 'async', types, cb, context);
	}
	
	function onSync(types, cb, context) {
	  return on.call(this, 'sync', types, cb, context);
	}
	
	function off(types) {
	  var type;
	
	  if (!this._callbacks) {
	    return this;
	  }
	
	  types = types.split(splitter);
	
	  while (type = types.shift()) {
	    delete this._callbacks[type];
	  }
	
	  return this;
	}
	
	function trigger(types) {
	  var type;
	  var callbacks;
	  var args;
	  var syncFlush;
	  var asyncFlush;
	
	  if (!this._callbacks) {
	    return this;
	  }
	
	  types = types.split(splitter);
	  args = [].slice.call(arguments, 1);
	
	  while ((type = types.shift()) && (callbacks = this._callbacks[type])) { // eslint-disable-line
	    syncFlush = getFlush(callbacks.sync, this, [type].concat(args));
	    asyncFlush = getFlush(callbacks.async, this, [type].concat(args));
	
	    if (syncFlush()) {
	      immediate(asyncFlush);
	    }
	  }
	
	  return this;
	}
	
	function getFlush(callbacks, context, args) {
	  return flush;
	
	  function flush() {
	    var cancelled;
	
	    for (var i = 0, len = callbacks.length; !cancelled && i < len; i += 1) {
	      // only cancel if the callback explicitly returns false
	      cancelled = callbacks[i].apply(context, args) === false;
	    }
	
	    return !cancelled;
	  }
	}
	
	function bindContext(fn, context) {
	  return fn.bind ?
	    fn.bind(context) :
	    function() { fn.apply(context, [].slice.call(arguments, 0)); };
	}


/***/ },
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1600), __esModule: true };

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(21);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 987 */
239,
/* 988 */
[2111, 918, 1295, 1294, 1290, 1303, 1306],
/* 989 */
304,
/* 990 */
184,
/* 991 */
[2117, 1610, 677, 1299, 747, 989, 748, 1608, 992, 371, 467],
/* 992 */
[2122, 371, 989, 467],
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(216)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(468);
	module.exports = Array.isArray || function(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 995 */
[2117, 997, 56, 342, 374, 304, 750, 1320, 751, 133, 216],
/* 996 */
[2118, 216],
/* 997 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 998 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	module.exports = Math.expm1 || function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	};

/***/ },
/* 999 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(133).getDesc
	  , isObject = __webpack_require__(184)
	  , anObject = __webpack_require__(201);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(372)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 1001 */
[2124, 753, 373],
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(1318)
	  , defined  = __webpack_require__(373);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Geolocator.js https://github.com/onury/geolocator
	 * @license MIT. © 2019, Onur Yıldırım
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("geolocator", [], factory);
		else if(typeof exports === 'object')
			exports["geolocator"] = factory();
		else
			root["geolocator"] = factory();
	})(window, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.js");
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ "./src/core/enums.js":
	/*!***************************!*\
	  !*** ./src/core/enums.js ***!
	  \***************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	var GOOGLE_MAPS_API_BASE = '//maps.googleapis.com/maps/api';
	
	/**
	 * This file only includes partial documentation about `geolocator` enumerations.
	 * Note that these enumerations are mostly an aggregation of
	 * {@link https://developers.google.com/maps/documentation/javascript|Google Maps API} constants.
	 *
	 * @private
	 * @readonly
	 */
	var enums = Object.freeze({
	  /**
	   * Enumerates API endpoints used within Geolocator core.
	   *
	   * @enum {String}
	   * @readonly
	   * @private
	   */
	  URL: {
	    /**
	     *  Public IP retrieval (free) service.
	     *  @type {String}
	     *  @private
	     */
	    IP: '//api.ipify.org',
	    /**
	     *  Country SVG flags.
	     *  e.g. <url>/tr.svg for Turkey flag.
	     *  @type {String}
	     *  @private
	     */
	    FLAG: '//cdnjs.cloudflare.com/ajax/libs/flag-icon-css/2.3.1/flags/4x3/',
	    /**
	     * Google Maps API bootstrap endpoint that loads all of the main
	     * Javascript objects and symbols for use in the Maps API.
	     * Some Maps API features are also available in self-contained
	     * libraries which are not loaded unless you specifically request them.
	     * See {@link https://developers.google.com/maps/documentation/javascript/libraries|details}.
	     * @type {String}
	     * @private
	     */
	    GOOGLE_MAPS_API: GOOGLE_MAPS_API_BASE + '/js',
	    /**
	     * Google Maps API Static Map endpoint.
	     * @type {String}
	     * @private
	     */
	    GOOGLE_SATATIC_MAP: GOOGLE_MAPS_API_BASE + '/staticmap',
	    /**
	     * Google Geolocation API endpoint.
	     * @type {String}
	     * @private
	     */
	    GOOGLE_GEOLOCATION: '//www.googleapis.com/geolocation/v1/geolocate',
	    /**
	     * Google Geocode API endpoint.
	     * @type {String}
	     * @private
	     */
	    GOOGLE_GEOCODE: '//maps.googleapis.com/maps/api/geocode/json',
	    /**
	     * Google TimeZone API endpoint.
	     * @type {String}
	     * @private
	     */
	    GOOGLE_TIMEZONE: '//maps.googleapis.com/maps/api/timezone/json',
	    /**
	     * Google Distance Matrix API endpoint.
	     * @type {String}
	     * @private
	     */
	    GOOGLE_DISTANCE_MATRIX: '//maps.googleapis.com/maps/api/distancematrix/json'
	  },
	  /**
	   * Enumerates Google map types.
	   * @memberof! geolocator
	   *
	   * @enum {String}
	   * @readonly
	   */
	  MapTypeId: {
	    /**
	     * Map type that displays a transparent layer of major streets on
	     * satellite images.
	     * @type {String}
	     */
	    HYBRID: 'hybrid',
	    /**
	     * Map type that displays a normal street map.
	     * @type {String}
	     */
	    ROADMAP: 'roadmap',
	    /**
	     * Map type that displays satellite images.
	     * @type {String}
	     */
	    SATELLITE: 'satellite',
	    /**
	     * Map type displays maps with physical features such as terrain and
	     * vegetation.
	     * @type {String}
	     */
	    TERRAIN: 'terrain'
	  },
	  /**
	   * Enumerates Google location types.
	   * @memberof! geolocator
	   *
	   * @enum {String}
	   * @readonly
	   */
	  LocationType: {
	    /**
	     * Indicates that the returned result is a precise geocode for which
	     * we have location information accurate down to street address
	     * precision.
	     * @type {String}
	     */
	    ROOFTOP: 'ROOFTOP',
	    /**
	     * Indicates that the returned result reflects an approximation
	     * (usually on a road) interpolated between two precise points (such as
	     * intersections). Interpolated results are generally returned when
	     * rooftop geocodes are unavailable for a street address.
	     * @type {String}
	     */
	    RANGE_INTERPOLATED: 'RANGE_INTERPOLATED',
	    /**
	     * Indicates that the returned result is the geometric center of a
	     * result such as a polyline (for example, a street) or polygon
	     * (region).
	     * @type {String}
	     */
	    GEOMETRIC_CENTER: 'GEOMETRIC_CENTER',
	    /**
	     * Indicates that the returned result is approximate.
	     * @type {String}
	     */
	    APPROXIMATE: 'APPROXIMATE'
	  },
	  /**
	   * Enumerates Google travel modes.
	   * @memberof! geolocator
	   *
	   * @enum {String}
	   * @readonly
	   */
	  TravelMode: {
	    /**
	     * Indicates distance calculation using the road network.
	     * @type {String}
	     */
	    DRIVING: 'DRIVING',
	    /**
	     * Requests distance calculation for walking via pedestrian paths &
	     * sidewalks (where available).
	     * @type {String}
	     */
	    WALKING: 'WALKING',
	    /**
	     * Requests distance calculation for bicycling via bicycle paths &
	     * preferred streets (where available).
	     * @type {String}
	     */
	    BICYCLING: 'BICYCLING',
	    /**
	     * Requests distance calculation via public transit routes (where
	     * available). This value may only be specified if the request includes
	     * an API key or a Google Maps APIs Premium Plan client ID. If you set
	     * the mode to transit you can optionally specify either a
	     * `departureTime` or an `arrivalTime`. If neither time is specified,
	     * the `departureTime` defaults to now (that is, the departure time defaults
	     * to the current time). You can also optionally include a `transitMode`
	     * and/or a `transitRoutingPreference`.
	     * @type {String}
	     */
	    TRANSIT: 'TRANSIT'
	  },
	  // /**
	  //  * Enumerates Google route restrictions.
	  //  * @memberof! geolocator
	  //  *
	  //  * @enum {String}
	  //  * @readonly
	  //  */
	  // RouteRestriction: {
	  //     TOLLS: 'tolls',
	  //     HIGHWAYS: 'highways',
	  //     FERRIES: 'ferries',
	  //     INDOOR: 'indoor'
	  // },
	  /**
	   * Enumerates Google unit systems.
	   * @memberof! geolocator
	   *
	   * @enum {Number}
	   * @readonly
	   */
	  UnitSystem: {
	    /**
	     * Distances in kilometers and meters.
	     * @type {Number}
	     */
	    METRIC: 0,
	    /**
	     * Distances defined in miles and feet.
	     * @type {Number}
	     */
	    IMPERIAL: 1
	  },
	  /**
	   * Enumerates mobile radio types.
	   * @memberof! geolocator
	   *
	   * @enum {String}
	   * @readonly
	   */
	  RadioType: {
	    /**
	     * LTE (Long-Term Evolution) mobile radio type.
	     * @type {String}
	     */
	    LTE: 'lte',
	    /**
	     * GSM (Global System for Mobile Communications) mobile radio type.
	     * @type {String}
	     */
	    GSM: 'gsm',
	    /**
	     * CDMA (Code division multiple access) mobile radio access technology.
	     * @type {String}
	     */
	    CDMA: 'cdma',
	    /**
	     * Wideband CDMA mobile radio access technology.
	     * @type {String}
	     */
	    WCDMA: 'wcdma'
	  },
	  /**
	   * Enumerates formulas/algorithms for calculating the distance between two
	   * lat/lng points.
	   * @memberof! geolocator
	   *
	   * @readonly
	   * @enum {String}
	   *
	   * @todo {@link https://en.wikipedia.org/wiki/Vincenty%27s_formulae|Vincenty's Formula}
	   */
	  DistanceFormula: {
	    /**
	     * Haversine formula for calculating the distance between two lat/lng points
	     * by relating the sides and angles of spherical triangles.
	     * @see {@link http://en.wikipedia.org/wiki/Haversine_formula|Haversine_formula}.
	     * @type {String}
	     */
	    HAVERSINE: 'haversine',
	    /**
	     * Formula based on the Pythagoras Theorem for calculating the
	     * distance between two lat/lng points on a Equirectangular projection
	     * to account for curvature of the longitude lines.
	     * @see {@link https://en.wikipedia.org/wiki/Pythagorean_theorem|Pythagorean_theorem}
	     * @type {String}
	     */
	    PYTHAGOREAN: 'pythagorean'
	  },
	  /**
	   *  Enumerates the image formats used for getting static Google Map images.
	   *  @memberof! geolocator
	   *
	   *  @readonly
	   *  @enum {String}
	   */
	  ImageFormat: {
	    /**
	     *  Specifies the PNG image format.
	     *  Same as `PNG_8`.
	     *  @type {String}
	     */
	    PNG: 'png',
	    /**
	     *  Specifies the 8-bit PNG image format.
	     *  Same as `PNG`.
	     *  @type {String}
	     */
	    PNG_8: 'png8',
	    /**
	     *  Specifies the 32-bit PNG image format.
	     *  @type {String}
	     */
	    PNG_32: 'png32',
	    /**
	     *  Specifies the GIF image format.
	     *  @type {String}
	     */
	    GIF: 'gif',
	    /**
	     *  Specifies the JPEG compressed image format.
	     *  @type {String}
	     */
	    JPG: 'jpg',
	    /**
	     *  Specifies a non-progressive JPEG compression image format.
	     *  @type {String}
	     */
	    JPG_BASELINE: 'jpg-baseline'
	  }
	});
	
	/* harmony default export */ __webpack_exports__["default"] = (enums);
	
	/***/ }),
	
	/***/ "./src/core/geo.error.js":
	/*!*******************************!*\
	  !*** ./src/core/geo.error.js ***!
	  \*******************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../lib/utils */ "./src/lib/utils.js");
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	/**
	 * Geolocator Error class that provides a common type of error object for the
	 * various APIs implemented in Geolocator. All callbacks of Geolocator will
	 * include an instance of this object as the first argument; if the
	 * corresponding operation fails. Also all thrown errors will be an instance of
	 * this object.
	 *
	 * This object can be publicly accessed via `geolocator.Error`.
	 *
	 * @extends Error
	 */
	
	var GeoError = function () {
	    // extends Error (doesn't work with transpilers)
	
	    /**
	     * Costructs a new instance of `GeoError`.
	     *
	     * @param {String} [code="UNKNOWN_ERROR"]
	     *        Any valid Geolocator Error code.
	     *        See {@link #GeoError.Code|`GeoError.Code` enumeration} for
	     *        possible values.
	     * @param {String} [message]
	     *        Error message. If omitted, this will be set to `code`.
	     *
	     * @returns {GeoError}
	     *
	     * @example
	     * var GeoError = geolocator.Error,
	     *     error = new GeoError(GeoError.Code.GEOLOCATION_NOT_SUPPORTED);
	     * console.log(error.code); // "GEOLOCATION_NOT_SUPPORTED"
	     * console.log(error instanceof GeoError); // true
	     */
	    function GeoError() {
	        var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : GeoError.Code.UNKNOWN_ERROR;
	        var message = arguments[1];
	
	        _classCallCheck(this, GeoError);
	
	        message = message || String(code);
	
	        /**
	         *  Gets the name of the Error object.
	         *  This always returns `"GeoError"`.
	         *  @name GeoError#name
	         *  @type {String}
	         */
	        Object.defineProperty(this, 'name', {
	            enumerable: false,
	            writable: false,
	            value: 'GeoError' // this.constructor.name
	        });
	
	        /**
	         *  Gets the error code set for this instance.
	         *  This will return one of
	         *  {@link #GeoError.Code|`GeoError.Code` enumeration}.
	         *  @name GeoError#code
	         *  @type {String}
	         */
	        Object.defineProperty(this, 'code', {
	            enumerable: false,
	            writable: true,
	            value: code
	        });
	
	        /**
	         *  Gets the error message set for this instance.
	         *  If no message is set, this will return the error code value.
	         *  @name GeoError#message
	         *  @type {String}
	         */
	        Object.defineProperty(this, 'message', {
	            enumerable: false,
	            writable: true,
	            value: message
	        });
	
	        if (Error.hasOwnProperty('captureStackTrace')) {
	            // V8
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            /**
	             *  Gets the error stack for this instance.
	             *  @name GeoError#stack
	             *  @type {String}
	             */
	            Object.defineProperty(this, 'stack', {
	                enumerable: false,
	                writable: false,
	                value: new Error(message).stack
	            });
	        }
	    }
	
	    /**
	     * Creates a new instance of `GeoError` from the given value.
	     *
	     * @param {*} [err]
	     *        Value to be transformed. This is used to determine the proper
	     *        error code for the created instance. If an `Error` or `Object` is
	     *        passed, its `message` property is checked if it matches any of the
	     *        valid error codes. If omitted or no match is found, error code
	     *        `GeoError.Code.UNKNOWN_ERROR` will be used as default.
	     *
	     * @returns {GeoError}
	     *
	     * @example
	     * var GeoError = geolocator.Error,
	     * 	   error = GeoError.create();
	     * console.log(error.code); // "UNKNOWN_ERROR"
	     * error = GeoError.create(GeoError.Code.GEOLOCATION_NOT_SUPPORTED);
	     * console.log(error.code); // "GEOLOCATION_NOT_SUPPORTED"
	     */
	
	
	    _createClass(GeoError, null, [{
	        key: 'create',
	        value: function create(err) {
	            if (err instanceof GeoError) {
	                return err;
	            }
	
	            var code = void 0,
	                msg = void 0;
	
	            if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPositionError(err) && err.code) {
	                switch (err.code) {
	                    case 1:
	                        code = GeoError.Code.PERMISSION_DENIED;
	                        break;
	                    case 2:
	                        code = GeoError.Code.POSITION_UNAVAILABLE;
	                        break;
	                    case 3:
	                        code = GeoError.Code.TIMEOUT;
	                        break;
	                    default:
	                        code = GeoError.Code.UNKNOWN_ERROR;
	                        break;
	                }
	                return new GeoError(code, err.message || '');
	            }
	
	            if (typeof err === 'string') {
	                code = msg = err;
	            } else if ((typeof err === 'undefined' ? 'undefined' : _typeof(err)) === 'object') {
	                code = err.code || err.message;
	                msg = err.message || err.code;
	            }
	            if (code && GeoError.isValidErrorCode(code)) {
	                return new GeoError(code, msg);
	            }
	
	            return new GeoError(GeoError.Code.UNKNOWN_ERROR, msg);
	        }
	
	        /**
	         * Creates a new instance of `GeoError` from the given response object.
	         * Since Geolocator implements various Google APIs, we might receive
	         * responses if different structures. For example, some APIs return a
	         * response object with a `status:String` property (such as the TimeZone
	         * API) and some return responses with an `error:Object` property. This
	         * method will determine the correct reason or message and return a
	         * consistent error object.
	         *
	         * @param {Object|String} response
	         *        Response (Object) or status (String) to be transformed.
	         * @param {String} [message=null]
	         *        Error message.
	         *
	         * @returns {GeoError}
	         *          `GeoError` instance if response contains an error. Otherwise,
	         *          returns `null`.
	         *
	         * @example
	         * var error = geolocator.Error.fromResponse(googleResponse);
	         * console.log(error.code); // "GOOGLE_KEY_INVALID"
	         */
	
	    }, {
	        key: 'fromResponse',
	        value: function fromResponse(response) {
	            var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	            // example Google Geolocation API response:
	            // https://developers.google.com/maps/documentation/geolocation/intro#errors
	            // {
	            //      "error": {
	            //          "errors": [
	            //              {
	            //                  "domain": "global",
	            //                  "reason": "parseError",
	            //                  "message": "Parse Error",
	            //              }
	            //          ],
	            //      "code": 400,
	            //      "message": "Parse Error"
	            //      }
	            // }
	            // example Google TimeZone API response:
	            // {
	            //     "status": "REQUEST_DENIED"
	            // }
	
	            if (!response) return new GeoError(GeoError.Code.INVALID_RESPONSE);
	
	            var errCode = void 0;
	
	            if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(response)) {
	                errCode = errorCodeFromStatus(response);
	                if (errCode) return new GeoError(errCode, message || response);
	            }
	
	            if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(response)) return null;
	
	            var errMsg = response.error_message || response.errorMessage || response.error && response.error.message || '' || '';
	
	            if (response.status) {
	                errCode = errorCodeFromStatus(response.status);
	                if (errCode) return new GeoError(errCode, errMsg || message || response.status);
	            }
	
	            if (response.error) {
	                var reason = response.reason || response.error.reason;
	                if (!reason) {
	                    var errors = response.error.errors;
	                    if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(errors) && errors.length > 0) {
	                        reason = errors[0].reason; // get the first reason only
	                        errMsg = errMsg || errors[0].message; // update errMsg
	                    }
	                }
	                errCode = errorCodeFromReason(reason) || GeoError.Code.UNKNOWN_ERROR;
	                return new GeoError(errCode, errMsg || reason || message);
	            }
	
	            if (errMsg) {
	                errCode = errorCodeFromStatus(errMsg) || GeoError.Code.UNKNOWN_ERROR;
	                return new GeoError(errCode, errMsg || message);
	            }
	
	            return null;
	        }
	
	        /**
	         *  Checks whether the given value is an instance of `GeoError`.
	         *
	         *  @param {*} err - Object to be checked.
	         *
	         *  @returns {Boolean}
	         */
	
	    }, {
	        key: 'isGeoError',
	        value: function isGeoError(err) {
	            return err instanceof GeoError;
	        }
	
	        /**
	         *  Checks whether the given value is a valid Geolocator Error code.
	         *
	         *  @param {String} errorCode - Error code to be checked.
	         *
	         *  @returns {Boolean}
	         */
	
	    }, {
	        key: 'isValidErrorCode',
	        value: function isValidErrorCode(errorCode) {
	            var prop = void 0;
	            for (prop in GeoError.Code) {
	                if (GeoError.Code.hasOwnProperty(prop) && errorCode === GeoError.Code[prop]) {
	                    return true;
	                }
	            }
	            return false;
	        }
	    }]);
	
	    return GeoError;
	}();
	
	/**
	 *  Gets the string representation of the error instance.
	 *
	 *  @returns {String}
	 */
	
	
	GeoError.prototype.toString = function () {
	    var msg = this.code !== this.message ? ' (' + this.message + ')' : '';
	    return this.name + ': ' + this.code + msg;
	};
	
	// `class x extends Error` doesn't work when using an ES6 transpiler, such as
	// Babel, since subclasses must extend a class. With Babel 6, we need
	// transform-builtin-extend plugin for this to work. So we're extending from
	// Error the old way. Now, `err instanceof Error` also returns `true`.
	if (typeof Object.setPrototypeOf === 'function') {
	    Object.setPrototypeOf(GeoError.prototype, Error.prototype);
	} else {
	    GeoError.prototype = Object.create(Error.prototype);
	}
	
	// ---------------------------
	// ERROR CODES
	// ---------------------------
	
	/**
	 *  Enumerates Geolocator error codes.
	 *  This enumeration combines Google API status (error) codes, HTML5 Geolocation
	 *  position error codes and other Geolocator-specific error codes.
	 *  @enum {String}
	 */
	GeoError.Code = {
	    /**
	     *  Indicates that HTML5 Geolocation API is not supported by the browser.
	     *  @type {String}
	     */
	    GEOLOCATION_NOT_SUPPORTED: 'GEOLOCATION_NOT_SUPPORTED',
	    /**
	     *  Indicates that Geolocation-IP source is not set or invalid.
	     *  @type {String}
	     */
	    INVALID_GEO_IP_SOURCE: 'INVALID_GEO_IP_SOURCE',
	    /**
	     *  The acquisition of the geolocation information failed because the
	     *  page didn't have the permission to do it.
	     *  @type {String}
	     */
	    PERMISSION_DENIED: 'PERMISSION_DENIED',
	    /**
	     *  The acquisition of the geolocation failed because at least one
	     *  internal source of position returned an internal error.
	     *  @type {String}
	     */
	    POSITION_UNAVAILABLE: 'POSITION_UNAVAILABLE',
	    /**
	     *  The time allowed to acquire the geolocation, defined by
	     *  PositionOptions.timeout information was reached before
	     *  the information was obtained.
	     *  @type {String}
	     */
	    TIMEOUT: 'TIMEOUT',
	    /**
	     * Indicates that the request had one or more invalid parameters.
	     * @type {String}
	     */
	    INVALID_PARAMETERS: 'INVALID_PARAMETERS',
	    /**
	     * Indicates that the service returned invalid response.
	     * @type {String}
	     */
	    INVALID_RESPONSE: 'INVALID_RESPONSE',
	    /**
	     * Generally indicates that the query (address, components or latlng)
	     * is missing.
	     * @type {String}
	     */
	    INVALID_REQUEST: 'INVALID_REQUEST',
	    /**
	     * Indicates that the request was denied by the service.
	     * This will generally occur because of a missing API key or because the request
	     * is sent over HTTP instead of HTTPS.
	     * @type {String}
	     */
	    REQUEST_DENIED: 'REQUEST_DENIED',
	    /**
	     * Indicates that the request has failed.
	     * This will generally occur because of an XHR error.
	     * @type {String}
	     */
	    REQUEST_FAILED: 'REQUEST_FAILED',
	    /**
	     * Indicates that Google API could not be loaded.
	     * @type {String}
	     */
	    GOOGLE_API_FAILED: 'GOOGLE_API_FAILED',
	    /**
	     * Indicates that you are over your Google API quota.
	     * @type {String}
	     */
	    OVER_QUERY_LIMIT: 'OVER_QUERY_LIMIT',
	    /**
	     * Indicates that you've exceeded the requests per second per user limit that
	     * you configured in the Google Developers Console. This limit should be
	     * configured to prevent a single or small group of users from exhausting your
	     * daily quota, while still allowing reasonable access to all users.
	     * @type {String}
	     */
	    USER_RATE_LIMIT_EXCEEDED: 'USER_RATE_LIMIT_EXCEEDED',
	    /**
	     * Indicates that you've exceeded your daily limit for Google API(s).
	     * @type {String}
	     */
	    DAILY_LIMIT_EXCEEDED: 'DAILY_LIMIT_EXCEEDED',
	    /**
	     * Indicates that your Google API key is not valid. Please ensure that you've
	     * included the entire key, and that you've either purchased the API or have
	     * enabled billing and activated the API to obtain the free quota.
	     * @type {String}
	     */
	    GOOGLE_KEY_INVALID: 'GOOGLE_KEY_INVALID',
	    /**
	     * Indicates that maximum number of elements limit is exceeded. For
	     * example, for the Distance Matrix API; occurs when the product of
	     * origins and destinations exceeds the per-query limit.
	     * @type {String}
	     */
	    MAX_ELEMENTS_EXCEEDED: 'MAX_ELEMENTS_EXCEEDED',
	    /**
	     * Indicates that the request contained more than 25 origins,
	     * or more than 25 destinations.
	     * @type {String}
	     */
	    MAX_DIMENSIONS_EXCEEDED: 'MAX_DIMENSIONS_EXCEEDED',
	    /**
	     * Indicates that the request contained more than allowed waypoints.
	     * @type {String}
	     */
	    MAX_WAYPOINTS_EXCEEDED: 'MAX_WAYPOINTS_EXCEEDED',
	    /**
	     * Indicates that the request body is not valid JSON.
	     * @type {String}
	     */
	    PARSE_ERROR: 'PARSE_ERROR',
	    /**
	     * Indicates that the requested resource could not be found.
	     * Note that this also covers `ZERO_RESULTS`.
	     * @type {String}
	     */
	    NOT_FOUND: 'NOT_FOUND',
	    /**
	     * Indicates that an internal error (such as XHR cross-domain, etc) has occured.
	     * @type {String}
	     */
	    INTERNAL_ERROR: 'INTERNAL_ERROR',
	    /**
	     * Indicates that an unknown error has occured.
	     * @type {String}
	     */
	    UNKNOWN_ERROR: 'UNKNOWN_ERROR'
	};
	
	// ---------------------------
	// HELPER METHODS
	// ---------------------------
	
	/**
	 *  @private
	 */
	function errorCodeFromStatus(status) {
	    if (!status) return GeoError.Code.INVALID_RESPONSE;
	    if (status === 'OK') return null;
	    if (status === 'ZERO_RESULTS') return GeoError.Code.NOT_FOUND;
	    if (GeoError.Code.hasOwnProperty(status)) return status;
	    return null;
	}
	
	/**
	 *  Gets `GeoError.Code` from the given response error reason.
	 *  @private
	 *
	 *  @param {String} reason
	 *         Google response error reason.
	 *
	 *  @returns {String}
	 */
	function errorCodeFromReason(reason) {
	    switch (reason) {
	        case 'invalid':
	            return GeoError.Code.INVALID_REQUEST;
	        case 'dailyLimitExceeded':
	            return GeoError.Code.DAILY_LIMIT_EXCEEDED;
	        case 'keyInvalid':
	            return GeoError.Code.GOOGLE_KEY_INVALID;
	        case 'userRateLimitExceeded':
	            return GeoError.Code.USER_RATE_LIMIT_EXCEEDED;
	        case 'notFound':
	            return GeoError.Code.NOT_FOUND;
	        case 'parseError':
	            return GeoError.Code.PARSE_ERROR;
	        default:
	            return null;
	    }
	}
	
	// ---------------------------
	// EXPORT
	// ---------------------------
	
	/* harmony default export */ __webpack_exports__["default"] = (GeoError);
	
	/***/ }),
	
	/***/ "./src/core/geo.helper.js":
	/*!********************************!*\
	  !*** ./src/core/geo.helper.js ***!
	  \********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../lib/utils */ "./src/lib/utils.js");
	/* harmony import */ var _lib_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../lib/fetch */ "./src/lib/fetch.js");
	/* harmony import */ var _enums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./enums */ "./src/core/enums.js");
	/* harmony import */ var _geo_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./geo.error */ "./src/core/geo.error.js");
	
	
	
	
	
	/**
	 *  Helper methods.
	 *  @type {Object}
	 *  @private
	 */
	var geoHelper = {
	    toGoogleCoords: function toGoogleCoords(coords) {
	        return {
	            lat: coords.lat || coords.latitude,
	            lng: coords.lng || coords.longitude
	        };
	    },
	    fromGoogleCoords: function fromGoogleCoords(coords) {
	        return {
	            latitude: coords.latitude || coords.lat,
	            longitude: coords.longitude || coords.lng
	        };
	    },
	
	
	    // used for distance matrix origins and destinations
	    toPointList: function toPointList(arr) {
	        arr = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(arr) ? arr : [arr];
	        return arr.map(function (o) {
	            return _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(o) ? o : geoHelper.toGoogleCoords(o);
	        });
	    },
	    getGeocodeComps: function getGeocodeComps(comp) {
	        return {
	            route: comp.route,
	            locality: comp.locality,
	            administrative_area: comp.administrativeArea, // eslint-disable-line camelcase
	            postal_code: comp.postalCode, // eslint-disable-line camelcase
	            country: comp.country,
	            region: comp.region
	        };
	    },
	
	
	    // Geocode examples:
	    // address=1600+Amphitheatre+Parkway,+Mountain+View,+CA&key=API_KEY
	    // address=Winnetka&bounds=34.172684,-118.604794|34.236144,-118.500938&key=API_KEY
	    // address=santa+cruz&components=country:ES&key=API_KEY
	    // components=administrative_area:TX|country:US&key=API_KEY
	    // Reverse Geocode examples:
	    // latlng=40.714224,-73.961452&key=API_KEY
	    // place_id=ChIJd8BlQ2BZwokRAFUEcm_qrcA&key=API_KEY
	    buildGeocodeParams: function buildGeocodeParams(options, reverse) {
	        var params = [],
	            e = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].encodeURI;
	
	        if (reverse) {
	            if (options.placeId) {
	                params.push('place_id=' + options.placeId);
	            } else if (options.latitude && options.longitude) {
	                params.push('latlng=' + options.latitude + ',' + options.longitude);
	            }
	        } else {
	            if (options.address) {
	                params.push('address=' + e(options.address));
	            }
	
	            var geoComps = geoHelper.getGeocodeComps(options);
	            geoComps = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].params(geoComps, { operator: ':', separator: '|' });
	            params.push('components=' + geoComps);
	
	            var b = options.bounds;
	            if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(b) && b.length === 4) {
	                params.push('bounds=' + b[0] + ',' + b[1] + '|' + b[2] + ',' + b[3]);
	            } else if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(b) && Object.keys(b).length === 4) {
	                params.push('bounds=' + b.southwestLat + ',' + b.southwestLng + '|' + b.northeastLat + ',' + b.northeastLng);
	            }
	        }
	
	        params.push('language=' + options.language);
	        params.push('key=' + options.key);
	        return params.join('&');
	    },
	
	
	    // See https://developers.google.com/maps/documentation/geocoding/intro
	    formatGeocodeResults: function formatGeocodeResults(results) {
	        if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(results) || results.length <= 0) {
	            return {
	                location: null,
	                address: null,
	                formattedAddress: '',
	                type: null, // locationType
	                placeId: ''
	            };
	        }
	
	        var i = void 0,
	            c = void 0,
	            o = {},
	            data = results[0],
	            comps = data.address_components;
	
	        for (i = 0; i < comps.length; i += 1) {
	            c = comps[i];
	            if (c.types && c.types.length > 0) {
	                o[c.types[0]] = c.long_name;
	                o[c.types[0] + '_s'] = c.short_name;
	            }
	        }
	
	        var geometry = data.geometry;
	        return {
	            coords: geometry && geometry.location ? {
	                latitude: geometry.location.lat,
	                longitude: geometry.location.lng
	            } : null,
	            address: {
	                commonName: o.point_of_interest || o.premise || o.subpremise || o.colloquial_area || '',
	                streetNumber: o.street_number || '',
	                street: o.administrative_area_level_4 || o.administrative_area_level_3 || o.route || '',
	                route: o.route || '',
	                neighborhood: o.neighborhood || o.administrative_area_level_5 || o.administrative_area_level_4 || '',
	                town: o.sublocality || o.administrative_area_level_2 || '',
	                city: o.locality || o.administrative_area_level_1 || '',
	                region: o.administrative_area_level_2 || o.administrative_area_level_1 || '',
	                postalCode: o.postal_code || '',
	                state: o.administrative_area_level_1 || '',
	                stateCode: o.administrative_area_level_1_s || '',
	                country: o.country || '',
	                countryCode: o.country_s || ''
	            },
	            formattedAddress: data.formatted_address,
	            type: geometry.location_type || '',
	            placeId: data.place_id,
	            timestamp: _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].time()
	        };
	    },
	    geocode: function geocode(reverse, conf, options, callback) {
	        var opts = {};
	        if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(options)) {
	            opts = {};
	            var prop = reverse ? 'placeId' : 'address';
	            opts[prop] = options;
	        } else if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(options)) {
	            opts = options;
	        } else {
	            throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.INVALID_PARAMETERS);
	        }
	
	        if (reverse) {
	            var coordsSet = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isNumber(options.latitude) && _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isNumber(options.longitude);
	            if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(options.placeId) && !coordsSet) {
	                throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.INVALID_PARAMETERS);
	            }
	        }
	
	        opts = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	            key: conf.google.key || '',
	            language: conf.language || 'en',
	            raw: false
	        }, opts);
	
	        var query = geoHelper.buildGeocodeParams(opts, reverse),
	            url = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].setProtocol(_enums__WEBPACK_IMPORTED_MODULE_2__["default"].URL.GOOGLE_GEOCODE, conf.https),
	            xhrOpts = {
	            url: url + '?' + query
	        };
	
	        _lib_fetch__WEBPACK_IMPORTED_MODULE_1__["default"].xhr(xhrOpts, function (err, xhr) {
	            if (err) return callback(_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].create(err), null);
	
	            var response = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].safeJsonParse(xhr.responseText),
	                gErr = _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].fromResponse(response);
	
	            if (gErr) return callback(gErr, null);
	
	            response = options.raw ? response : geoHelper.formatGeocodeResults(response.results);
	            callback(null, response);
	        });
	    },
	
	
	    // See https://developers.google.com/maps/documentation/distance-matrix/intro
	    // Raw Result Example:
	    // {
	    //    "destination_addresses" : [ "San Francisco, CA, USA", "Victoria, BC, Canada" ],
	    //    "origin_addresses" : [ "Vancouver, BC, Canada", "Seattle, WA, USA" ],
	    //    "rows" : [
	    //       {
	    //          "elements" : [
	    //             {
	    //                "distance" : { "text" : "1,704 km", "value" : 1704324 },
	    //                "duration" : { "text" : "3 days 19 hours", "value" : 327061
	    //                },
	    //                "status" : "OK"
	    //             },
	    //             {
	    //                "distance" : { "text" : "138 km", "value" : 138295 },
	    //                "duration" : { "text" : "6 hours 44 mins", "value" : 24236 },
	    //                "status" : "OK"
	    //             }
	    //          ]
	    //       },
	    //       {
	    //          "elements" : [
	    //             {
	    //                "distance" : { "text" : "1,452 km", "value" : 1451623 },
	    //                "duration" : { "text" : "3 days 4 hours", "value" : 275062 },
	    //                "status" : "OK"
	    //             },
	    //             {
	    //                "distance" : { "text" : "146 km", "value" : 146496 },
	    //                "duration" : { "text" : "2 hours 52 mins", "value" : 10324 },
	    //                "status" : "OK"
	    //             }
	    //          ]
	    //       }
	    //    ],
	    //    "status" : "OK"
	    // }
	    // Formatted to:
	
	    formatDistanceResults: function formatDistanceResults(results) {
	        if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(results)) {
	            return null;
	        }
	
	        var arr = [],
	            origins = results.originAddresses,
	            dests = results.destinationAddresses,
	            rows = results.rows;
	
	        // [
	        //     {
	        //          from: 'Vancouver, BC, Canada',
	        //          to: 'San Francisco, CA, USA',
	        //          distance: { value: 1704107, text: "1,704 km" },
	        //          duration: { value: 327025, text: "3 days 19 hours" },
	        //          fare: { currency: "USD", value: 6, text: "$6.00" }
	        //     },
	        //     ...
	        // ]
	
	        var e = void 0;
	        origins.forEach(function (origin, oIndex) {
	            dests.forEach(function (dest, dIndex) {
	                e = rows[oIndex].elements[dIndex];
	                arr.push({
	                    from: origin,
	                    to: dest,
	                    distance: e.distance,
	                    duration: e.duration,
	                    fare: e.fare,
	                    timestamp: _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].time()
	                });
	            });
	        });
	
	        return arr;
	    },
	
	
	    // Converts a map-styles object in to static map styles (formatted query-string params).
	    // See https://developers.google.com/maps/documentation/static-maps/styling
	    mapStylesToParams: function mapStylesToParams(styles) {
	        if (!styles) return '';
	        if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(styles)) styles = [styles];
	        var result = [];
	        styles.forEach(function (v, i, a) {
	            var style = '';
	            if (v.stylers) {
	                // only if there is a styler object
	                if (v.stylers.length > 0) {
	                    // Needs to have a style rule to be valid.
	                    style += (v.hasOwnProperty('featureType') ? 'feature:' + v.featureType : 'feature:all') + '|';
	                    style += (v.hasOwnProperty('elementType') ? 'element:' + v.elementType : 'element:all') + '|';
	                    v.stylers.forEach(function (val, i, a) {
	                        var propName = Object.keys(val)[0],
	                            propVal = val[propName].toString().replace('#', '0x');
	                        style += propName + ':' + propVal + '|';
	                    });
	                }
	            }
	            result.push('style=' + encodeURIComponent(style));
	        });
	        return result.join('&');
	    }
	};
	
	/* harmony default export */ __webpack_exports__["default"] = (geoHelper);
	
	/***/ }),
	
	/***/ "./src/core/geo.watcher.js":
	/*!*********************************!*\
	  !*** ./src/core/geo.watcher.js ***!
	  \*********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../lib/utils */ "./src/lib/utils.js");
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	var GeoWatcher = function () {
	    function GeoWatcher(onChange, onError) {
	        var _this = this;
	
	        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	        _classCallCheck(this, GeoWatcher);
	
	        this.isCleared = false;
	        this.cycle = 0;
	        this._timer = null;
	        this.id = navigator.geolocation.watchPosition(function (pos) {
	            _this.cycle++;
	            if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(onChange)) onChange(pos);
	        }, function (err) {
	            _this.cycle++;
	            if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(onError)) onError(err);
	            if (options.clearOnError) {
	                _this.clear();
	            }
	        }, options);
	    }
	
	    _createClass(GeoWatcher, [{
	        key: '_clear',
	        value: function _clear() {
	            navigator.geolocation.clearWatch(this.id);
	            this.isCleared = true;
	            this._timer = null;
	        }
	    }, {
	        key: 'clear',
	        value: function clear(delay, callback) {
	            var _this2 = this;
	
	            var d = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isNumber(delay) ? delay : 0,
	                cb = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(callback) ? callback : _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(delay) ? delay : null;
	            // clear any previous timeout
	            if (this._timer) {
	                clearTimeout(this._timer);
	                this._timer = null;
	            }
	            // check if watcher is not cleared
	            if (!this.isCleared) {
	                if (d === 0) {
	                    this._clear();
	                    if (cb) cb();
	                    return;
	                }
	                this._timer = setTimeout(function () {
	                    _this2._clear();
	                    if (cb) cb();
	                }, d);
	            }
	        }
	    }]);
	
	    return GeoWatcher;
	}();
	
	// ---------------------------
	// EXPORT
	// ---------------------------
	
	/* harmony default export */ __webpack_exports__["default"] = (GeoWatcher);
	
	/***/ }),
	
	/***/ "./src/core/geolocator.js":
	/*!********************************!*\
	  !*** ./src/core/geolocator.js ***!
	  \********************************/
	/*! exports provided: geolocator */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "geolocator", function() { return geolocator; });
	/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../lib/utils */ "./src/lib/utils.js");
	/* harmony import */ var _lib_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../lib/fetch */ "./src/lib/fetch.js");
	/* harmony import */ var _geo_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./geo.helper */ "./src/core/geo.helper.js");
	/* harmony import */ var _geo_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./geo.error */ "./src/core/geo.error.js");
	/* harmony import */ var _geo_watcher__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./geo.watcher */ "./src/core/geo.watcher.js");
	/* harmony import */ var _enums__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./enums */ "./src/core/enums.js");
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	
	
	
	
	/**
	 *  Radius of earth in kilometers.
	 *  @private
	 *  @type {Number}
	 */
	var EARTH_RADIUS_KM = 6371;
	
	/**
	 *  Radius of earth in miles.
	 *  @private
	 *  @type {Number}
	 */
	var EARTH_RADIUS_MI = 3959;
	
	/**
	 *  Storage for Geolocator default configuration.
	 *
	 *  @readonly
	 *  @private
	 */
	var defaultConfig = {
	    language: 'en',
	    https: true,
	    google: {
	        version: '3', // latest 3.x
	        key: '',
	        styles: null
	    }
	};
	
	/**
	 *  Geolocator library that provides methods for getting geo-location information,
	 *  geocoding, address look-ups, distance & durations, timezone information and more...
	 *  This library makes use of HTML5 position feautures, implements Google APIs
	 *  and other services.
	 *
	 *  <b>Important Notes:</b>
	 *
	 *  Although some calls might work without a key, it is generally required by
	 *  most {@link https://developers.google.com/maps/faq#using-google-maps-apis|Goolge APIs}
	 *  (such as Time Zone API). To get a free (or premium) key,
	 *  {@link https://developers.google.com/maps/documentation/javascript/|click here}.
	 *  After getting a key, you can enable multiple APIs for it. Make sure you
	 *  {@link https://console.developers.google.com|enable}
	 *  all the APIs supported by Geolocator.
	 *
	 *  Note that browser API keys cannot have referer restrictions when used
	 *  with some Google APIs.
	 *
	 *  Make sure your doctype is HTML5 and you're calling Geolocation APIs from an
	 *  HTTPS page. Geolocation API is removed from unsecured origins in Chrome 50.
	 *  Other browsers are expected to follow.
	 *
	 *  @license MIT
	 *  @copyright 2019, Onur Yıldırım <onur@cutepilot.com>
	 */
	
	var geolocator = function () {
	    function geolocator() {
	        _classCallCheck(this, geolocator);
	    }
	
	    _createClass(geolocator, null, [{
	        key: 'config',
	
	
	        // ---------------------------
	        // STATIC METHODS
	        // ---------------------------
	
	        /**
	         *  Sets or gets the geolocator configuration object.
	         *  Make sure you configure Geolocator before calling other methods that
	         *  require a Google API key.
	         *
	         *  @param {Object} [options]
	         *         Configuration object. If omitted, this method returns the current
	         *         configuration.
	         *      @param {String} [options.language="en"]
	         *             Language to be used for API requests that supports language
	         *             configurations. This is generally used for Google APIs.
	         *             See {@link https://developers.google.com/maps/faq#languagesupport|supported languages}.
	         *      @param {Boolean} [options.https=true]
	         *             As Google recommends; using HTTPS encryption makes your site
	         *             more secure, and more resistant to snooping or tampering.
	         *             If set to `true`, the API calls are made over HTTPS, at all
	         *             times. Setting to `false` will switch to HTTP (even if the
	         *             page is on HTTPS). And if set to `null`, current protocol will
	         *             be used. Note that some APIs might not work with HTTP such as
	         *             Google Maps TimeZone API.
	         *      @param {Object} [options.google]
	         *             Google specific options.
	         *          @param {String} [options.google.version="3"]
	         *                 Google Maps API version to be used (with
	         *                 `geolocator.createMap()`) method. The default version
	         *                 value is tested and works with Geolocator. You can set a
	         *                 greater value or the latest version number and it should
	         *                 work; but it's not guaranteed. Find out the
	         *                 {@link https://developers.google.com/maps/documentation/javascript/versions|latest version here}.
	         *          @param {String} [options.google.key=""]
	         *                 API key to be used with Google API calls. Although some
	         *                 calls might work without a key, it is generally required
	         *                 by most Goolge APIs. To get a free (or premium) key,
	         *                 {@link https://developers.google.com/maps/documentation/javascript/|click here}.
	         *          @param {Array} [options.google.styles]
	         *                 An array of objects to customize the presentation of the
	         *                 Google base maps, changing the visual display of such
	         *                 elements as roads, parks, and built-up areas.
	         *                 See {@link https://developers.google.com/maps/documentation/javascript/styling|Styling Maps}.
	         *
	         *  @returns {Object} - Returns the current or updated configuration object.
	         *
	         *  @example
	         *  geolocator.config({
	         *      language: "en",
	         *      google: {
	         *          version: "3",
	         *          key: "YOUR-GOOGLE-API-KEY"
	         *      }
	         *  });
	         */
	        value: function config(options) {
	            if (options) {
	                geolocator._.config = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend(defaultConfig, options);
	            }
	            return geolocator._.config;
	        }
	
	        /**
	         *  Gets a static map image URL which can be embeded via an `<img />` tag
	         *  on the page.
	         *
	         *  Note that, if `options.center` is set to an address (instead of
	         *  coordinates) and `options.marker` is also set; we will need to geocode
	         *  that address to get center coordinates for the marker.
	         *  In this case, you must use the `callback` parameter to get the async
	         *  result. Otherwise, this method will directly return a `String`.
	         *
	         *  Make sure you have enabled Static Maps API (and Geocoding API if
	         *  `marker` is enabled) in your Google Developers console.
	         *
	         *  For interactive map, see {@link #geolocator.createMap|`geolocator.createMap()` method}.
	         *
	         *  @see {@link https://developers.google.com/maps/documentation/static-maps/intro|Static Maps}
	         *  @see {@link https://developers.google.com/maps/documentation/static-maps/usage-limits|Usage Limits}
	         *
	         *  @param {Object} options
	         *         Static map options.
	         *         @param {String|Object} options.center
	         *                Defines the center of the map and the location.
	         *                Either an address `String` or an coordinates `Object` with
	         *                `latitude:Number` and `longitude:Number` properties.
	         *         @param {String} [options.mapTypeId="roadmap"]
	         *                Type of the map to be created.
	         *                See {@link #geolocator.MapTypeId|`geolocator.MapTypeId` enumeration}
	         *                for possible values.
	         *         @param {String|Object} [options.size="600x300"]
	         *                Defines the size (in pixels) of the returned image.
	         *                Either a string in `widthxheight` format or an Object
	         *                with `width:Number` and `height:Number` properties.
	         *         @param {Number} [options.scale=1]
	         *                Affects the number of pixels that are returned. scale=2
	         *                returns twice as many pixels as scale=1 while retaining
	         *                the same coverage area and level of detail (i.e. the
	         *                contents of the map don't change). Accepted values are 1,
	         *                2 and 4 (4 is only available to Google Maps APIs Premium
	         *                Plan customers.)
	         *         @param {Number} [options.zoom=9]
	         *                Zoom level to be set for the map.
	         *         @param {String} [options.format=png]
	         *                Defines the format of the resulting image.
	         *                See {@link #geolocator.ImageFormat|`geolocator.ImageFormat` enumeration}
	         *                for possible values.
	         *         @param {Boolean|String} [options.marker=true]
	         *                Specifies whether to add a marker to the center of the map.
	         *                You can define the color of the marker by passing a color
	         *                `String` instead of a `Boolean`. Color can be a predefined
	         *                color from the set `red` (default), `black`, `brown`,
	         *                `green`, `purple`, `yellow`, `blue`, `gray`, `orange` and
	         *                `white`; or a HEX 24-bit color (e.g. `"0xFF0000"`).
	         *                Note that marker will not be visible if `center` is set to
	         *                a `String` address and you don't use the callback.
	         *         @param {String} [options.region]
	         *                Defines the appropriate borders to display, based on
	         *                geo-political sensitivities. Accepts a region code
	         *                specified as a two-character ccTLD (top-level domain)
	         *                value. e.g. `"us"`.
	         *         @param {Array} [options.styles]
	         *                An array of objects to customize the presentation of the
	         *                Google base maps, changing the visual display of such
	         *                elements as roads, parks, and built-up areas.
	         *                This will default to the global styles set via
	         *                {@link #geolocator.config|`geolocator.config()` method}, if any.
	         *                See {@link https://developers.google.com/maps/documentation/javascript/styling|Styling Maps}.
	         *
	         *  @param {Function} [callback]
	         *         Callback function to be executed when the static map URL is built.
	         *         This takes 2 arguments: `function (err, url) { ... }`.
	         *         If omitted, this method will directly return the static map
	         *         image URL; but (if enabled) the marker will not be visible if
	         *         `options.center` is set to an address `String` instead of a
	         *         coordinates `Object`.
	         *
	         *  @returns {String|void}
	         *           If a callback is passed, this will return `void`.
	         *           Otherwise, a `String` that represents the URL of the static map.
	         *
	         *  @example
	         *  // Async example (with address and marker)
	         *  var options = {
	         *      center: "Los Angles, CA, US",
	         *      mapTypeId: geolocator.MapTypeId.ROADMAP,
	         *      size: "600x300",
	         *      scale: 1,
	         *      zoom: 5,
	         *      marker: "0xFFCC00",
	         *      format: geolocator.ImageFormat.PNG
	         *  };
	         *  geolocator.getStaticMap(options, function (err, url) {
	         *      if (!err) {
	         *          document.getElementById('my-img').src = url;
	         *      }
	         *  });
	         *
	         *  @example
	         *  // Sync example (with coordinates)
	         *  var options = {
	         *      center: {
	         *          longitude: 34.0522342,
	         *          latitude: -118.2436849
	         *      },
	         *      mapTypeId: geolocator.MapTypeId.ROADMAP,
	         *      size: "600x300",
	         *      scale: 1,
	         *      zoom: 5,
	         *      marker: "0xFFCC00",
	         *      format: geolocator.ImageFormat.PNG
	         *  };
	         *  document.getElementById('my-img').src = geolocator.getStaticMap(options);
	         */
	
	    }, {
	        key: 'getStaticMap',
	        value: function getStaticMap(options, callback) {
	            if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(options) || !options.center) {
	                throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.INVALID_PARAMETERS, 'A center address or coordinates are required.');
	            }
	
	            if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(options.center)) {
	                return geolocator.geocode(options.center, function (err, location) {
	                    if (err) callback(err);
	                    options.center = location.coords;
	                    callback(null, geolocator.getStaticMap(options));
	                });
	            }
	
	            var conf = geolocator._.config;
	            var opts = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	                mapTypeId: _enums__WEBPACK_IMPORTED_MODULE_5__["default"].MapTypeId.ROADMAP,
	                size: {
	                    width: 600,
	                    height: 300
	                },
	                scale: 1, // 1 | 2 | (4 for business customers of google maps)
	                zoom: 9,
	                marker: 'red',
	                format: _enums__WEBPACK_IMPORTED_MODULE_5__["default"].ImageFormat.PNG,
	                language: conf.language || 'en',
	                region: null
	            }, options);
	
	            var center = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(opts.center) ? opts.center.latitude + ',' + opts.center.longitude : String(opts.center);
	
	            var size = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(opts.size) ? opts.size.width + 'x' + opts.size.height : String(opts.size);
	
	            var url = _enums__WEBPACK_IMPORTED_MODULE_5__["default"].URL.GOOGLE_SATATIC_MAP // not using utils.setProtocol() here
	            + ('?center=' + center + '&maptype=' + opts.mapTypeId) + ('&size=' + size + '&scale=' + opts.scale + '&zoom=' + opts.zoom) + ('&format=' + opts.format + '&language=' + opts.language);
	
	            if (opts.marker) {
	                var color = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(opts.marker) ? opts.marker : 'red';
	                url += '&markers=' + encodeURIComponent('color:' + color + '|' + center);
	            }
	            if (opts.region) url += '&region=' + opts.region;
	            if (conf.google.key) url += '&key=' + conf.google.key;
	
	            var styles = getStyles(opts);
	            if (styles) url += '&' + _geo_helper__WEBPACK_IMPORTED_MODULE_2__["default"].mapStylesToParams(styles);
	
	            if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(callback)) return callback(null, url);
	            return url;
	        }
	
	        /**
	         *  Creates an interactive Google Map within the given element.
	         *  Make sure you have enabled Google Static Maps API in your Google Developers console.
	         *  For static map, see {@link #geolocator.getStaticMap|`geolocator.getStaticMap()` method}.
	         *  @see {@link https://developers.google.com/maps/documentation/javascript/reference|Google Maps JavaScript API}
	         *  @see {@link https://developers.google.com/maps/documentation/javascript/usage|Usage Limits}
	         *
	         *  @param {Object|String|HTMLElement|Map} options
	         *         Either map options object with the following properties or; the ID
	         *         of a DOM element, or element itself which the map will be
	         *         created within; or a previously created `google.maps.Map` instance.
	         *         If a map instance is set, this only will apply the options without
	         *         re-creating it.
	         *      @param {String|HTMLElement|Map} options.element
	         *             Either the ID of a DOM element or the element itself;
	         *             which the map will be created within; or a previously created
	         *             `google.maps.Map` instance. If a map instance is set, this
	         *             only will apply the options without re-creating it.
	         *      @param {Object} options.center
	         *             Center coordinates for the map to be created.
	         *          @param {Number} options.center.latitude
	         *                 Latitude of the center point coordinates.
	         *          @param {Number} options.center.longitude
	         *                 Longitude of the center point coordinates.
	         *      @param {String} [options.mapTypeId="roadmap"]
	         *             Type of the map to be created.
	         *             See {@link #geolocator.MapTypeId|`geolocator.MapTypeId` enumeration}
	         *             for possible values.
	         *      @param {String} [options.title]
	         *             Title text to be displayed within an `InfoWindow`, when the
	         *             marker is clicked. This only take effect if `marker` is
	         *             enabled.
	         *      @param {Boolean} [options.marker=true]
	         *             Whether to place a marker at the given coordinates.
	         *             If `title` is set, an `InfoWindow` will be opened when the
	         *             marker is clicked.
	         *      @param {Number} [options.zoom=9]
	         *             Zoom level to be set for the map.
	         *      @param {Array} [options.styles]
	         *             An array of objects to customize the presentation of the
	         *             Google base maps, changing the visual display of such
	         *             elements as roads, parks, and built-up areas.
	         *             This will default to the global styles set via
	         *             {@link #geolocator.config|`geolocator.config` method}`, if any.
	         *             See {@link https://developers.google.com/maps/documentation/javascript/styling|Styling Maps}.
	         *
	         *  @param {Function} callback
	         *         Callback function to be executed when the map is created.
	         *         This takes 2 arguments: `function (err, map) { ... }`.
	         *         See {@link #geolocator~MapData|`geolocator~MapData` type} for details.
	         *
	         *  @returns {void}
	         *
	         *  @example
	         *  var options = {
	         *      element: "my-map",
	         *      center: {
	         *          latitude: 48.8534100,
	         *          longitude: 2.3488000
	         *  	},
	         *  	marker: true,
	         *  	title: "Paris, France",
	         *  	zoom: 12
	         *  };
	         *  geolocator.createMap(options, function (err, map) {
	         *      if (map && map.infoWindow) {
	         *          map.infoWindow.open(map.instance, map.marker);
	         *      }
	         *  });
	         */
	
	    }, {
	        key: 'createMap',
	        value: function createMap(options, callback) {
	            // if options is not a plain object, consider element ID, `HTMLElement`,
	            // `jQuery` instance or `google.maps.Map` instance.
	            if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(options)) {
	                options = { element: options };
	            }
	
	            options = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	                element: null,
	                mapTypeId: _enums__WEBPACK_IMPORTED_MODULE_5__["default"].MapTypeId.ROADMAP,
	                title: undefined,
	                marker: true,
	                zoom: 9
	            }, options);
	
	            var e = options.element,
	                elem = void 0;
	            if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(e)) {
	                elem = document.getElementById(e);
	            } else if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isJQueryObject(e)) {
	                elem = e[0];
	            } else if (geolocator.isGoogleLoaded() && e instanceof google.maps.Map) {
	                elem = e.getDiv();
	            }
	
	            if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isElement(elem) && !_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isNode(elem)) {
	                throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.INVALID_PARAMETERS, 'A valid DOM element or element ID is required to create a map.');
	            }
	
	            if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(options.center) || !_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isNumber(options.center.latitude) || !_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isNumber(options.center.longitude)) {
	                throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.INVALID_PARAMETERS, 'Center coordinates are required to create a map.');
	            }
	
	            options.element = elem;
	
	            var conf = geolocator._.config,
	                key = conf.google.key;
	            options.styles = getStyles(options);
	
	            geolocator.ensureGoogleLoaded(key, function (err) {
	                if (err) {
	                    throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.GOOGLE_API_FAILED, String(err.message || err));
	                }
	
	                var mapData = configCreateMap(options);
	                callback(null, mapData);
	            });
	        }
	
	        /**
	         *  Locates the user's location via HTML5 geolocation. This may
	         *  require/prompt for user's permission. If the permission is granted we'll
	         *  get the most accurate location information. Otherwise, we'll fallback to
	         *  locating via user's IP (if enabled).
	         *
	         *  For better accuracy, Geolocator implements a different approach than the
	         *  `getCurrentPosition` API; which generally triggers before the device's
	         *  GPS hardware can provide anything accurate. Thanks to
	         *  {@link https://github.com/gwilson/getAccurateCurrentPosition#background|Greg Wilson}
	         *  for the idea.
	         *
	         *  Also note that HTML5 Geolocation feature no more allows insecure origins.
	         *  See {@link https://goo.gl/rStTGz|this} for more details.
	         *  This means if you don't call this method from an HTTPS page, it will
	         *  fail. And if `options.fallbackToIP` is enabled, this will locate by IP.
	         *
	         *  @param {Object} [options]
	         *         HTML5 geo-location settings with some additional options.
	         *      @param {Boolean} [options.enableHighAccuracy=true]
	         *             Specifies whether the device should provide the most accurate
	         *             position it can. Note that setting this to `true` might
	         *             consume more CPU and/or battery power; and result in slower
	         *             response times.
	         *      @param {Number} [options.desiredAccuracy=30]
	         *             Minimum accuracy desired, in meters. Position will not be
	         *             returned until this is met, before the timeout. This only
	         *             takes effect if `enableHighAccuracy` is set to `true`.
	         *      @param {Number} [options.timeout=5000]
	         *             HTML5 position timeout setting in milliseconds. Setting this
	         *             to `Infinity` means that Geolocator won't return until the
	         *             position is available.
	         *      @param {Number} [options.maximumWait=10000]
	         *             Maximum time to wait (in milliseconds) for the desired
	         *             accuracy (which should be greater than `timeout`).
	         *             This only takes effect if `enableHighAccuracy` is set to
	         *             `true`.
	         *      @param {Number} [options.maximumAge=0]
	         *             HTML5 position maximum age. Indicates the maximum age in
	         *             milliseconds of a possible cached position that is acceptable
	         *             to return. `0` means, the device cannot use a cached position
	         *             and must attempt to retrieve the real current position. If set
	         *             to `Infinity` the device must return a cached position
	         *             regardless of its age. Note that if `enableHighAccuracy` is
	         *             set to `true`, `maximumAge` will be forced to `0`.
	         *      @param {Function} [options.onProgress]
	         *             If `enableHighAccuracy` is set to `true`, you can use this
	         *             callback to check the progress of the location accuracy;
	         *             while waiting for the final, best accurate location.
	         *      @param {Boolean} [options.fallbackToIP=false]
	         *             Specifies whether to fallback to IP geolocation if the HTML5
	         *             geolocation fails (e.g. user rejection).
	         *      @param {Boolean} [options.addressLookup=false]
	         *             Specifies whether to run a reverse-geocode operation for the
	         *             fetched coordinates to retrieve detailed address information.
	         *             Note that this means an additional request which requires a
	         *             Google API key to be set in the Geolocator configuration.
	         *             See {@link #geolocator.config|`geolocator.config()`}.
	         *      @param {Boolean} [options.timezone=false]
	         *             Specifies whether to also fetch the time zone information for
	         *             the receieved coordinates. Note that this means an additional
	         *             request which requires a Google API key to be set in the
	         *             Geolocator configuration.
	         *             See {@link #geolocator.config|`geolocator.config()`}.
	         *      @param {String|MapOptions} [options.map]
	         *             In order to create an interactive map from the fetched
	         *             location coordinates; either set this to a
	         *             {@link #geolocator~MapOptions|`MapOptions` object}
	         *             or; the ID of a DOM element or DOM element itself which the
	         *             map will be created within.
	         *      @param {Boolean|Object} [options.staticMap=false]
	         *             Set to `true` to get a static Google Map image URL (with
	         *             default options); or pass a static map options object.
	         *
	         *  @param {Function} callback
	         *         Callback function to be executed when the request completes.
	         *         This takes 2 arguments: `function (err, location) { ... }`.
	         *         See {@link #geolocator~Location|`geolocator~Location` type} for details.
	         *
	         *  @returns {void}
	         *
	         *  @example
	         *  var options = {
	         *      enableHighAccuracy: true,
	         *      desiredAccuracy: 30,
	         *      timeout: 5000,
	         *      maximumWait: 10000,
	         *      maximumAge: 0,
	         *      fallbackToIP: true,
	         *      addressLookup: true,
	         *      timezone: true,
	         *      map: "my-map",
	         *      staticMap: true
	         *  };
	         *  geolocator.locate(options, function (err, location) {
	         *      console.log(err || location);
	         *  });
	         *
	         * @example
	         *  // location result:
	         *  {
	         *      coords: {
	         *          latitude: 37.4224764,
	         *          longitude: -122.0842499,
	         *          accuracy: 30,
	         *          altitude: null,
	         *          altitudeAccuracy: null,
	         *          heading: null,
	         *          speed: null
	         *      },
	         *      address: {
	         *          commonName: "",
	         *          street: "Amphitheatre Pkwy",
	         *          route: "Amphitheatre Pkwy",
	         *          streetNumber: "1600",
	         *          neighborhood: "",
	         *          town: "",
	         *          city: "Mountain View",
	         *          region: "Santa Clara County",
	         *          state: "California",
	         *          stateCode: "CA",
	         *          postalCode: "94043",
	         *          country: "United States",
	         *          countryCode: "US"
	         *      },
	         *      formattedAddress: "1600 Amphitheatre Parkway, Mountain View, CA 94043, USA",
	         *      type: "ROOFTOP",
	         *      placeId: "ChIJ2eUgeAK6j4ARbn5u_wAGqWA",
	         *      timezone: {
	         *          id: "America/Los_Angeles",
	         *          name: "Pacific Standard Time",
	         *          abbr: "PST",
	         *          dstOffset: 0,
	         *          rawOffset: -28800
	         *      },
	         *      flag: "//cdnjs.cloudflare.com/ajax/libs/flag-icon-css/2.3.1/flags/4x3/us.svg",
	         *      map: {
	         *          element: HTMLElement,
	         *          instance: Object, // google.maps.Map
	         *          marker: Object, // google.maps.Marker
	         *          infoWindow: Object, // google.maps.InfoWindow
	         *          options: Object // map options
	         *      },
	         *      staticMap: "//maps.googleapis.com/maps/api/staticmap?center=37.4224764,-122.0842499&maptype=roadmap&size=600x300&scale=1&zoom=9&format=png&language=en&markers=color%3Ared%7C37.4224764%2C2-122.0842499&key=YOUR-GOOGLE-API-KEY",
	         *      timestamp: 1456795956380
	         *  }
	         */
	
	    }, {
	        key: 'locate',
	        value: function locate(options, callback) {
	            options = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	                enableHighAccuracy: true,
	                timeout: 6000,
	                maximumWait: 10000,
	                maximumAge: 0,
	                desiredAccuracy: 30,
	                onProgress: _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].noop,
	                fallbackToIP: false,
	                addressLookup: false,
	                timezone: false,
	                map: undefined,
	                staticMap: false
	            }, options);
	
	            // force disable cache if high-accuracy is enabled
	            if (options.enableHighAccuracy) options.maximumAge = 0;
	            // set a min value for timeout
	            if (options.timeout < 1000) options.timeout = 1000;
	            // max wait should not be less than timeout
	            if (options.maximumWait < options.timeout) options.maximumWait = options.timeout;
	
	            // check options and Google key
	            checkGoogleKey(options);
	
	            var cb = callbackMap(options, callback);
	
	            function fallbackToIP(error) {
	                if (options.fallbackToIP) {
	                    return geolocator.locateByIP(options, function (err, location) {
	                        if (err) return cb(err, null);
	                        return cb(null, location);
	                    });
	                }
	                cb(error, null);
	            }
	            function onPositionReceived(location) {
	                fetchAddressAndTimezone(location, options, cb);
	            }
	            function onPositionError(err) {
	                err = _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].create(err);
	                fallbackToIP(err);
	            }
	
	            if (geolocator.isGeolocationSupported()) {
	                if (options.enableHighAccuracy) {
	                    locateAccurate(options, onPositionReceived, onPositionError);
	                } else {
	                    navigator.geolocation.getCurrentPosition(onPositionReceived, onPositionError, options);
	                }
	            } else {
	                var err = new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.GEOLOCATION_NOT_SUPPORTED);
	                fallbackToIP(err);
	            }
	        }
	
	        /**
	         *  Returns a location and accuracy radius based on information about cell
	         *  towers and WiFi nodes that the mobile client can detect; via the Google
	         *  Maps Geolocation API.
	         *  @see {@link https://developers.google.com/maps/documentation/geolocation/intro|Google Maps Geolocation API}
	         *  @see {@link https://developers.google.com/maps/documentation/geolocation/usage-limits|Usage Limits}
	         *
	         *  @param {Object} [options]
	         *         Geolocation options.
	         *      @param {Number} [options.homeMobileCountryCode]
	         *             The mobile country code (MCC) for the device's home network.
	         *      @param {Number} [options.homeMobileNetworkCode]
	         *             The mobile network code (MNC) for the device's home network.
	         *      @param {String} [options.radioType]
	         *             The mobile radio type.
	         *             See {@link #geolocator.RadioType|`geolocator.RadioType` enumeration}
	         *             for possible values. While this field is optional, it should
	         *             be included if a value is available, for more accurate results.
	         *      @param {string} [options.carrier]
	         *             The carrier name. e.g. "Vodafone"
	         *      @param {Boolean} [options.fallbackToIP=false]
	         *             Specifies whether to fallback to IP geolocation if wifi and
	         *             cell tower signals are not available. Note that the IP address
	         *             in the request header may not be the IP of the device. Set
	         *             `fallbackToIP` to `false` to disable fall back.
	         *      @param {Array} [options.cellTowers]
	         *             An array of cell tower objects.
	         *             See {@link https://developers.google.com/maps/documentation/geolocation/intro#cell_tower_object|Cell tower objects} for details.
	         *      @param {Array} [options.wifiAccessPoints]
	         *             An array of WiFi access point objects.
	         *             See {@link https://developers.google.com/maps/documentation/geolocation/intro#wifi_access_point_object|WiFi access point objects} for details.
	         *      @param {Boolean} [options.addressLookup=false]
	         *             Specifies whether to run a reverse-geocode operation for the
	         *             fetched coordinates to retrieve detailed address information.
	         *             Note that this means an additional request which requires a
	         *             Google API key to be set in the Geolocator configuration.
	         *             See {@link #geolocator.config|`geolocator.config()`}.
	         *      @param {Boolean} [options.timezone=false]
	         *             Specifies whether to also fetch the time zone information for
	         *             the receieved coordinates. Note that this means an additional
	         *             request which requires a Google API key to be set in the
	         *             Geolocator configuration.
	         *             See {@link #geolocator.config|`geolocator.config()`}.
	         *      @param {String|MapOptions} [options.map]
	         *             In order to create an interactive map from the fetched
	         *             location coordinates; either set this to a
	         *             {@link #geolocator~MapOptions|`MapOptions` object}
	         *             or; the ID of a DOM element or DOM element itself which the
	         *             map will be created within.
	         *      @param {Boolean|Object} [options.staticMap=false]
	         *             Set to `true` to get a static Google Map image URL (with
	         *             default options); or pass a static map options object.
	         *      @param {Boolean} [options.raw=false]
	         *      	      Whether to return the raw Google API result.
	         *  @param {Function} callback
	         *         Callback function to be executed when the request completes.
	         *         This takes 2 arguments: `function (err, location) { ... }`.
	         *         See {@link #geolocator~Location|`geolocator~Location` type} for details.
	         *
	         *  @returns {void}
	         *
	         *  @example
	         *  var options = {
	         *      homeMobileCountryCode: 310,
	         *      homeMobileNetworkCode: 410,
	         *      carrier: 'Vodafone',
	         *      radioType: geolocator.RadioType.GSM,
	         *      fallbackToIP: true,
	         *      addressLookup: false,
	         *      timezone: false,
	         *      map: "my-map",
	         *      staticMap: false
	         *  };
	         *  geolocator.locateByMobile(options, function (err, location) {
	         *      console.log(err || location);
	         *  });
	         */
	
	    }, {
	        key: 'locateByMobile',
	        value: function locateByMobile(options, callback) {
	            if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(options)) {
	                throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.INVALID_PARAMETERS);
	            }
	
	            var cb = callbackMap(options, callback);
	
	            options = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	                homeMobileCountryCode: undefined,
	                homeMobileNetworkCode: undefined,
	                radioType: undefined,
	                carrier: undefined,
	                fallbackToIP: false,
	                cellTowers: undefined,
	                wifiAccessPoints: undefined,
	                addressLookup: false,
	                timezone: false,
	                map: undefined,
	                raw: false
	            }, options);
	
	            options.considerIp = options.fallbackToIP;
	            // check Google key
	            checkGoogleKey();
	
	            var conf = geolocator._.config,
	                key = conf.google.key || '',
	                url = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].setProtocol(_enums__WEBPACK_IMPORTED_MODULE_5__["default"].URL.GOOGLE_GEOLOCATION, conf.https),
	                xhrOpts = {
	                url: url + '?key=' + key,
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                data: JSON.stringify(options)
	            };
	            // console.log(xhrOpts.data);
	
	            _lib_fetch__WEBPACK_IMPORTED_MODULE_1__["default"].post(xhrOpts, function (err, xhr) {
	                var response = getXHRResponse(err, xhr);
	                if (_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].isGeoError(response)) return cb(response, null);
	
	                response = options.raw ? response : {
	                    coords: {
	                        latitude: response.location.lat,
	                        longitude: response.location.lng,
	                        accuracy: response.accuracy
	                    },
	                    timestamp: _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].time()
	                };
	
	                fetchAddressAndTimezone(response, options, cb);
	
	                // e.g. raw response
	                // {
	                //     "location": {
	                //         "lat": 51.0,
	                //         "lng": -0.1
	                //     },
	                //     "accuracy": 1200.4
	                // }
	            });
	        }
	
	        /**
	         *  Locates the user's location by the client's IP.
	         *
	         *  This method uses a free lookup service, by default.
	         *  In order to change the source provider, you can use
	         *  {@link #geolocator.setGeoIPSource|`geolocator.setGeoIPSource()` method}.
	         *
	         *  @param {Object} [options]
	         *         Locate options.
	         *      @param {Boolean} [options.addressLookup=false]
	         *             Specifies whether to run a reverse-geocode operation for the
	         *             fetched coordinates to retrieve detailed address information.
	         *             Since no precise address can be fetched from an IP addres; you
	         *             should only enable this if the Geo-IP Source returns no useful
	         *             address information other than coordinates. Also, note that
	         *             this means an additional request which requires a Google API
	         *             key to be set in the Geolocator configuration.
	         *             See {@link #geolocator.config|`geolocator.config()`}.
	         *      @param {Boolean} [options.timezone=false]
	         *             Specifies whether to also fetch the time zone information for
	         *             the receieved coordinates. Note that this means an additional
	         *             request which requires a Google API key to be set in the
	         *             Geolocator configuration.
	         *             See {@link #geolocator.config|`geolocator.config()`}.
	         *      @param {String|MapOptions} [options.map]
	         *             In order to create an interactive map from the fetched
	         *             location coordinates; either set this to a
	         *             {@link #geolocator~MapOptions|`MapOptions` object}
	         *             or; the ID of a DOM element or DOM element itself which the
	         *             map will be created within.
	         *      @param {Boolean|Object} [options.staticMap=false]
	         *             Set to `true` to get a static Google Map image URL (with
	         *             default options); or pass a static map options object.
	         *  @param {Function} callback
	         *         Callback function to be executed when the request completes.
	         *         This takes 2 arguments: `function (err, location) { ... }`.
	         *         See {@link #geolocator~Location|`geolocator~Location` type} for details.
	         *
	         *  @returns {void}
	         *
	         *  @example
	         *  var options = {
	         *  	addressLookup: true,
	         *  	timezone: true,
	         *  	map: "my-map",
	         *  	staticMap: true
	         *  };
	         *  geolocator.locateByIP(options, function (err, location) {
	         *  	console.log(err || location);
	         *  });
	         *
	         *  @example
	         *  // location result:
	         *  {
	         *      coords: {
	         *          latitude: 41.0214,
	         *          longitude: 28.9948,
	         *      },
	         *      address: {
	         *          city: "Istanbul",
	         *          region: "34",
	         *          state: "34",
	         *          country: "Turkey",
	         *          countryCode: "TR"
	         *      },
	         *      formattedAddress: "Demirtaş, Tesviyeci Sk. No:7, 34134 Fatih/İstanbul, Turkey",
	         *      type: "ROOFTOP",
	         *      placeId: "ChIJ-ZRLfO25yhQRBi5YJxX80Q0",
	         *      timezone: {
	         *          id: "Europe/Istanbul",
	         *          name: "Eastern European Summer Time",
	         *          abbr: "EEST",
	         *          dstOffset: 3600,
	         *          rawOffset: 7200
	         *      },
	         *      flag: "//cdnjs.cloudflare.com/ajax/libs/flag-icon-css/2.3.1/flags/4x3/tr.svg",
	         *      map: {
	         *          element: HTMLElement,
	         *          instance: Object, // google.maps.Map
	         *          marker: Object, // google.maps.Marker
	         *          infoWindow: Object, // google.maps.InfoWindow
	         *          options: Object // map options
	         *      },
	         *      staticMap: "//maps.googleapis.com/maps/api/staticmap?center=41.0214,28.9948&maptype=roadmap&size=600x300&scale=1&zoom=9&format=png&language=en&markers=color%3Ared%7C41.0214%2C228.9948&key=YOUR-GOOGLE-API-KEY",
	         *      provider: "geobytes",
	         *      timestamp: 1466216325223
	         *  }
	         */
	
	    }, {
	        key: 'locateByIP',
	        value: function locateByIP(options, callback) {
	            // passed source can be a string or object
	            var source = geolocator._.geoIpSource;
	
	            if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(source)) {
	                throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.INVALID_GEO_IP_SOURCE, 'Please set a valid Geo-IP Source via geolocator.setGeoIPSource(options).');
	            }
	
	            // check options and Google key
	            checkGoogleKey(options || {});
	
	            function updateResponse(response) {
	                if (!response) {
	                    var err = new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.INVALID_RESPONSE);
	                    return callback(err, null);
	                }
	                if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(source.schema)) {
	                    response = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].mapToSchema(response, source.schema);
	                } else if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(source.schema)) {
	                    response = source.schema(response);
	                }
	                response.provider = source.provider || 'unknown';
	                setLocationURLs(response, options);
	                if (response.coords) {
	                    response.coords.latitude = Number(response.coords.latitude);
	                    response.coords.longitude = Number(response.coords.longitude);
	                }
	                var cb = callbackMap(options, callback);
	                fetchAddressAndTimezone(response, options, cb);
	            }
	
	            if (source.xhr) {
	                var opts = {
	                    url: source.url,
	                    async: true
	                };
	                return _lib_fetch__WEBPACK_IMPORTED_MODULE_1__["default"].get(opts, function (err, xhr) {
	                    var response = xhr.responseText ? JSON.parse(xhr.responseText) : null;
	                    if (err) return callback(_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].create(err), null);
	                    updateResponse(response);
	                });
	            }
	
	            if (source.callbackParam || source.globalVar) {
	                var jsonpOpts = {
	                    url: source.url,
	                    async: true,
	                    clean: true
	                    // params: {}
	                };
	                if (source.callbackParam) {
	                    jsonpOpts.callbackParam = source.callbackParam;
	                    jsonpOpts.rootName = 'geolocator._.cb';
	                }
	                return _lib_fetch__WEBPACK_IMPORTED_MODULE_1__["default"].jsonp(jsonpOpts, function (err, response) {
	                    if (err) return callback(_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].create(err), null);
	                    if (source.globalVar) {
	                        if (window[source.globalVar]) {
	                            response = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].clone(window[source.globalVar]);
	                            delete window[source.globalVar];
	                        } else {
	                            response = null;
	                        }
	                    }
	                    updateResponse(response);
	                });
	            }
	
	            throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.INVALID_GEO_IP_SOURCE, 'Either xhr, callbackParam or globalVar should be set for Geo-IP source.');
	        }
	
	        /**
	         *  Sets the Geo-IP source to be used for fetching location information
	         *  by user's IP; which is internally used by
	         *  {@link #geolocator.locateByIP|`geolocator.locateByIP()` method}.
	         *
	         *  By default, Geolocator uses a free Geo-IP source provider.
	         *  You can use this method to change this; or you can choose from
	         *  ready-to-use
	         *  {@link https://github.com/onury/geolocator/tree/master/src/geo-ip-sources|Geo-IP sources}.
	         *
	         *  @param {Object} options
	         *         Geo-IP Source options.
	         *      @param {String} [options.provider]
	         *             Source or service provider's name.
	         *      @param {String} options.url
	         *             Source URL without the callback query parameter. The callback
	         *             name (if supported) should be set via `options.callbackParam`.
	         *             Also, make sure the service supports the protocol you use in
	         *             the enums.URL. If it supports both HTTP and HTTPS, you can omit the
	         *             protocol. In this case, it will be determined via Geolocator
	         *             configuration.
	         *             See {@link #geolocator.config|`geolocator.config()`}.
	         *             NOTE: Do not forget to include your API key in the query
	         *             parameters of the URL, if you have one.
	         *      @param {String} [options.callbackParam]
	         *             If JSON callback is supported, pass the name of the callback
	         *             parameter, defined by the provider.
	         *      @param {Object} [options.globalVar]
	         *             Set this instead of `options.callbackParam` if the service
	         *             does not support JSON callbacks, but weirdly set a global
	         *             variable in the document. For example, if the response is
	         *             `Geo = { lat, lng }`, you should set this to `"Geo"`.
	         *      @param {Object} [options.schema]
	         *             Schema object to be used to re-structure the response returned
	         *             from the service. Set the response object's keys as values of
	         *             a custom object to map the format to the `location` object.
	         *             For example; if the service returns a response like
	         *             `{ lat: 40.112233, lng: 10.112233, otherProp: 'hello' }`.
	         *             Then you should set the following schema:
	         *             `{ coords: { latitude: 'lat', longitude: 'lng' } }`.
	         *
	         *  @return {geolocator}
	         */
	
	    }, {
	        key: 'setGeoIPSource',
	        value: function setGeoIPSource(options) {
	            if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(options)) {
	                throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.INVALID_PARAMETERS, 'Geo-IP source options is invalid.');
	            }
	            if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isStringSet(options.url)) {
	                throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.INVALID_PARAMETERS, 'Geo-IP source should have a valid URI.');
	            }
	            // if (!utils.isStringSet(options.callbackParam) && !utils.isStringSet(options.globalVar)) {
	            //     throw new GeoError(GeoError.Code.INVALID_PARAMETERS, 'No \'callbackParam\' or \'globalVar\' is provided for the Geo-IP Source options.');
	            // }
	            geolocator._.geoIpSource = Object.freeze(options);
	        }
	
	        /**
	         *  Registers a handler for watching the user's location via HTML5
	         *  geolocation; that is triggered each time the position of the device
	         *  changes. This may require/prompt for user's permission.
	         *
	         *  @param {Object} [options]
	         *         HTML5 geo-location settings.
	         *      @param {Boolean} [options.enableHighAccuracy=true]
	         *             Specifies whether the device should provide the most accurate
	         *             position it can. Note that setting this to `true` might consume
	         *             more CPU and/or battery power; and result in slower response
	         *             times.
	         *      @param {Number} [options.timeout=6000]
	         *             HTML5 position timeout setting in milliseconds. Setting this
	         *             to `Infinity` means that Geolocator won't return until the
	         *             position is available.
	         *      @param {Number} [options.maximumAge=0]
	         *             HTML5 position maximum age. Indicates the maximum age in
	         *             milliseconds of a possible cached position that is acceptable
	         *             to return. `0` means, the device cannot use a cached position
	         *             and must attempt to retrieve the real current position. If set
	         *             to `Infinity` the device must return a cached position
	         *             regardless of its age.
	         *      @param {Boolean} [options.clearOnError=false]
	         *             Specifies whether to clear the watcher on first error so that
	         *             it does not execute any more callbacks.
	         *      @param {Object} [options.target]
	         *             Object that defines the target location and settings; that
	         *             when the location is reached, the watcher will auto-clear
	         *             itself and invoke the callback.
	         *      @param {Number} options.target.latitude
	         *             The `latitude` of the target location.
	         *      @param {Number} options.target.longitude
	         *             The `longitude` of the target location.
	         *      @param {Number} [options.target.radius=0.5]
	         *             The radius, in other words; the minimum distance (in
	         *             kilometers or miles) to the target point that should be
	         *             reached.
	         *      @param {Number} [options.target.unitSystem=0]
	         *             Unit system to be used for target radius.
	         *             See {@link #geolocator.UnitSystem|`geolocator.UnitSystem` enumeration}
	         *             for possible values.
	         *  @param {Function} callback
	         *         Callback function to be executed when the request completes.
	         *         This takes 2 arguments: `function (err, location) { ... }`.
	         *         If `options.target` is set, `location` will also
	         *         include a `targetReached:Boolean` property.
	         *         See {@link #geolocator~Location|`geolocator~Location` type} for details.
	         *
	         *  @returns {GeoWatcher} - A watcher object that provides a
	         *  `.clear(delay:Number, callback:Function)` method to clear the watcher
	         *  when needed. Optional `delay` argument can be set (in milliseconds) to
	         *  clear in a later time. Omitting this argument will clear the watcher
	         *  immediately. You should always call this method, except if you've set up
	         *  a target; which will auto-clear the watcher when reached.
	         *
	         *  @example
	         *  // Watch my position for 5 minutes.
	         *  var options = { enableHighAccuracy: true, timeout: 6000, maximumAge: 0 };
	         *  var watcher = geolocator.watch(options, function (err, location) {
	         *      console.log(err || location);
	         *  });
	         *  console.log(watcher.id); // ID of the watcher
	         *  watcher.clear(300000); // clear after 5 minutes.
	         *
	         *  @example
	         *  // Watch my position until I'm 350 meters near Disneyland Park.
	         *  options.target = {
	         *      latitude: 33.8120918,
	         *      longitude: -117.9233569,
	         *      radius: 0.35,
	         *      unitSystem: geolocator.UnitSystem.METRIC
	         *  };
	         *  watcher = geolocator.watch(options, function (err, location) {
	         *      if (err) {
	         *          console.log(err);
	         *          return;
	         *      }
	         *      if (location.targetReached) {
	         *          console.log(watcher.isCleared); // true
	         *          console.log(watcher.cycle); // 15 — target reached after 15 cycles
	         *      } else {
	         *          console.log(watcher.isCleared); // false — watcher is active.
	         *      }
	         *  });
	         */
	
	    }, {
	        key: 'watch',
	        value: function watch(options, callback) {
	            if (!geolocator.isGeolocationSupported()) {
	                callback(new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.GEOLOCATION_NOT_SUPPORTED), null);
	                return {};
	            }
	
	            var watcher = void 0,
	                target = void 0;
	
	            options = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	                enableHighAccuracy: true,
	                timeout: 6000,
	                maximumAge: 0,
	                clearOnError: false
	            }, options);
	
	            if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(options.target)) {
	                target = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	                    radius: 0.5,
	                    unitSystem: geolocator.UnitSystem.METRIC
	                }, options.target);
	            }
	
	            function onPositionChanged(location) {
	                var pos = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].clone(location, { own: false });
	                if (target) {
	                    var distance = geolocator.calcDistance({
	                        from: location.coords,
	                        to: target,
	                        formula: geolocator.DistanceFormula.HAVERSINE,
	                        unitSystem: target.unitSystem
	                    });
	                    pos.targetReached = distance <= target.radius;
	                    if (watcher && pos.targetReached) {
	                        watcher.clear(function () {
	                            return callback(null, pos);
	                        });
	                    }
	                }
	                return callback(null, pos);
	            }
	            function onPositionError(err) {
	                callback(_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].create(err), null);
	            }
	            return new _geo_watcher__WEBPACK_IMPORTED_MODULE_4__["default"](onPositionChanged, onPositionError, options);
	        }
	
	        /**
	         *  Converts a given address (or address components) into geographic
	         *  coordinates (i.e. latitude, longitude); and gets detailed address
	         *  information.
	         *  @see {@link https://developers.google.com/maps/documentation/geocoding/intro|Google Maps Geocoding API}
	         *  @see {@link https://developers.google.com/maps/documentation/geocoding/usage-limits|Usage Limits}
	         *
	         *  @param {String|Object} options
	         *         Either the address to geocode or geocoding options with the
	         *         following properties.
	         *      @param {String} options.address
	         *             The street address to geocode, in the format used by the
	         *             national postal service of the country concerned. Additional
	         *             address elements such as business names and unit, suite or
	         *             floor numbers should be avoided. Note that any address
	         *             component (route, locality, administrativeArea, postalCode and
	         *             country) should be specified either in address or the
	         *             corresponding property - not both. Doing so may result in
	         *             `ZERO_RESULTS`.
	         *      @param {String} [options.route]
	         *      	      Long or short name of a route.
	         *      @param {String} [options.locality]
	         *      	      Locality and sublocality of the location.
	         *      @param {String} [options.administrativeArea]
	         *      	      Administrative area of the location.
	         *      @param {String} [options.postalCode]
	         *      	      Postal code of the location.
	         *      @param {String} [options.country]
	         *      	      A country name or a two letter ISO 3166-1 country code.
	         *      @param {String} [options.region]
	         *      	      The region code, specified as a ccTLD ("top-level domain")
	         *      	      two-character value. e.g.: `"fr"` for France.
	         *      @param {Array|Object} [options.bounds]
	         *      	      The bounding box of the viewport within which to bias geocode
	         *      	      results more prominently. e.g.:
	         *      	      `[ southwestLat:Number, southwestLng:Number, northeastLat:Number, northeastLng:Number ]`
	         *      @param {String|MapOptions} [options.map]
	         *             In order to create an interactive map from the fetched
	         *             location coordinates; either set this to a
	         *             {@link #geolocator~MapOptions|`MapOptions` object}
	         *             or; the ID of a DOM element or DOM element itself which the
	         *             map will be created within.
	         *      @param {Boolean|Object} [options.staticMap=false]
	         *             Set to `true` to get a static Google Map image URL (with
	         *             default options); or pass a static map options object.
	         *      @param {Boolean} [options.raw=false]
	         *      	      Whether to return the raw Google API result.
	         *  @param {Function} callback
	         *         Callback function to be executed when the request completes.
	         *         This takes 2 arguments: `function (err, location) { ... }`.
	         *         See {@link #geolocator~Location|`geolocator~Location` type} for details.
	         *
	         *  @returns {void}
	         *
	         *  @example
	         *  var address = '1600 Amphitheatre Parkway, CA';
	         *  geolocator.geocode(address, function (err, location) {
	         *      console.log(err || location);
	         *  });
	         *
	         *  @example
	         *  // location result:
	         *  {
	         *      coords: {
	         *          latitude: 37.4224764,
	         *          longitude: -122.0842499
	         *      },
	         *      address: {
	         *          commonName: "",
	         *          street: "Amphitheatre Pkwy",
	         *          route: "Amphitheatre Pkwy",
	         *          streetNumber: "1600",
	         *          neighborhood: "",
	         *          town: "",
	         *          city: "Mountain View",
	         *          region: "Santa Clara County",
	         *          state: "California",
	         *          stateCode: "CA",
	         *          postalCode: "94043",
	         *          country: "United States",
	         *          countryCode: "US"
	         *      },
	         *      formattedAddress: "1600 Amphitheatre Parkway, Mountain View, CA 94043, USA",
	         *      type: "ROOFTOP",
	         *      placeId: "ChIJ2eUgeAK6j4ARbn5u_wAGqWA",
	         *      flag: "//cdnjs.cloudflare.com/ajax/libs/flag-icon-css/2.3.1/flags/4x3/us.svg",
	         *      map: {
	         *          element: HTMLElement,
	         *          instance: Object, // google.maps.Map
	         *          marker: Object, // google.maps.Marker
	         *          infoWindow: Object, // google.maps.InfoWindow
	         *          options: Object // map options
	         *      },
	         *      timestamp: 1456795956380
	         *  }
	         */
	
	    }, {
	        key: 'geocode',
	        value: function geocode(options, callback) {
	            _geocode(false, options, callback);
	        }
	
	        /**
	         *  Converts the given geographic coordinates into a human-readable address
	         *  information.
	         *  @see {@link https://developers.google.com/maps/documentation/geocoding/intro#ReverseGeocoding|Google Maps (Reverse) Geocoding API}
	         *  @see {@link https://developers.google.com/maps/documentation/geocoding/usage-limits|Usage Limits}
	         *  @alias geolocator.addressLookup
	         *
	         *  @param {Object|String} options
	         *         Either the `placeId` of the location or Reverse Geocoding options
	         *         with the following properties.
	         *      @param {Number} options.latitude
	         *      Latitude of the target location.
	         *      @param {Number} options.longitude
	         *      Longitude of the target location.
	         *      @param {String} [options.placeId]
	         *             Required if `latitude` and `longitude` are omitted. The place
	         *             ID of the place for which you wish to obtain the
	         *             human-readable address. The place ID is a unique identifier
	         *             that can be used with other Google APIs. Note that if
	         *             `placeId` is set, `latitude` and `longitude` are ignored.
	         *      @param {String|MapOptions} [options.map]
	         *             In order to create an interactive map from the fetched
	         *             location coordinates; either set this to a
	         *             {@link #geolocator~MapOptions|`MapOptions` object}
	         *             or; the ID of a DOM element or DOM element itself which the
	         *             map will be created within.
	         *      @param {Boolean|Object} [options.staticMap=false]
	         *             Set to `true` to get a static Google Map image URL (with
	         *             default options); or pass a static map options object.
	         *      @param {Boolean} [options.raw=false]
	         *             Whether to return the raw Google API result.
	         *  @param {Function} callback
	         *         Callback function to be executed when the request completes.
	         *         This takes 2 arguments: `function (err, location) { ... }`
	         *         See {@link #geolocator~Location|`geolocator~Location` type} for details.
	         *
	         *  @returns {void}
	         *
	         *  @example
	         *  var coords = {
	         *      latitude: 37.4224764,
	         *      longitude: -122.0842499
	         *  };
	         *
	         *  geolocator.reverseGeocode(coords, function (err, location) {
	         *      console.log(err || location);
	         *  });
	         *
	         *  @example
	         *  // location result:
	         *  {
	         *      coords: {
	         *          latitude: 37.4224764,
	         *          longitude: -122.0842499
	         *      },
	         *      address: {
	         *          commonName: "",
	         *          street: "Amphitheatre Pkwy",
	         *          route: "Amphitheatre Pkwy",
	         *          streetNumber: "1600",
	         *          neighborhood: "",
	         *          town: "",
	         *          city: "Mountain View",
	         *          region: "Santa Clara County",
	         *          state: "California",
	         *          stateCode: "CA",
	         *          postalCode: "94043",
	         *          country: "United States",
	         *          countryCode: "US"
	         *      },
	         *      formattedAddress: "1600 Amphitheatre Parkway, Mountain View, CA 94043, USA",
	         *      type: "ROOFTOP",
	         *      placeId: "ChIJ2eUgeAK6j4ARbn5u_wAGqWA",
	         *      flag: "//cdnjs.cloudflare.com/ajax/libs/flag-icon-css/2.3.1/flags/4x3/us.svg",
	         *      map: {
	         *          element: HTMLElement,
	         *          instance: Object, // google.maps.Map
	         *          marker: Object, // google.maps.Marker
	         *          infoWindow: Object, // google.maps.InfoWindow
	         *          options: Object // map options
	         *      },
	         *      timestamp: 1456795956380
	         *  }
	         */
	
	    }, {
	        key: 'reverseGeocode',
	        value: function reverseGeocode(options, callback) {
	            _geocode(true, options, callback);
	        }
	
	        /**
	         *  Alias for `geolocator.reverseGeocode`
	         *  @private
	         */
	
	    }, {
	        key: 'addressLookup',
	        value: function addressLookup(options, callback) {
	            geolocator.reverseGeocode(options, callback);
	        }
	
	        /**
	         *  Gets timezone information for the given coordinates.
	         *  Note: Google Browser API keys cannot have referer restrictions when used with this API.
	         *  @see {@link https://developers.google.com/maps/documentation/timezone/intro|Google Maps TimeZone API}
	         *  @see {@link https://developers.google.com/maps/documentation/timezone/usage-limits|Usage Limits}
	         *
	         *  @param {Object} options
	         *         Time zone options.
	         *      @param {Number} options.latitude
	         *             Latitude of location.
	         *      @param {Number} options.longitude
	         *             Longitude of location.
	         *      @param {Number} [options.timestamp=Date.now()]
	         *             Specifies the desired time as seconds since midnight, January
	         *             1, 1970 UTC. This is used to determine whether or not Daylight
	         *             Savings should be applied.
	         *      @param {Boolean} [options.raw=false]
	         *             Whether to return the raw Google API result.
	         *  @param {Function} callback
	         *         Callback function to be executed when the request completes, in
	         *         the following signature: `function (err, timezone) { ... }`.
	         *         See {@link #geolocator~TimeZone|`geolocator~TimeZone` type} for
	         *         details.
	         *
	         *  @returns {void}
	         *
	         *  @example
	         *  var options = {
	         *      latitude: 48.8534100,
	         *      longitude: 2.3488000
	         *  };
	         *  geolocator.getTimeZone(options, function (err, timezone) {
	         *      console.log(err || timezone);
	         *  });
	         *
	         *  @example
	         *  // timezone result:
	         *  {
	         *      id: "Europe/Paris",
	         *      name: "Central European Standard Time",
	         *      abbr: "CEST",
	         *      dstOffset: 0,
	         *      rawOffset: 3600,
	         *      timestamp: 1455733120
	         *  }
	         */
	
	    }, {
	        key: 'getTimeZone',
	        value: function getTimeZone(options, callback) {
	            if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(options) || !_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isNumber(options.latitude) || !_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isNumber(options.longitude)) {
	                throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.INVALID_PARAMETERS);
	            }
	
	            checkGoogleKey();
	
	            var conf = geolocator._.config;
	            options = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	                key: conf.google.key || '',
	                language: conf.language || 'en',
	                timestamp: _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].time(true),
	                raw: false
	            }, options);
	
	            var url = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].setProtocol(_enums__WEBPACK_IMPORTED_MODULE_5__["default"].URL.GOOGLE_TIMEZONE, conf.https),
	                xhrOpts = {
	                url: url + '?location=' + options.latitude + ',' + options.longitude + '&timestamp=' + options.timestamp + '&language=' + options.language + '&key=' + options.key
	            };
	
	            _lib_fetch__WEBPACK_IMPORTED_MODULE_1__["default"].xhr(xhrOpts, function (err, xhr) {
	                var response = getXHRResponse(err, xhr);
	                if (_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].isGeoError(response)) return callback(response, null);
	
	                response = options.raw ? response : {
	                    id: response.timeZoneId,
	                    name: response.timeZoneName,
	                    abbr: _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].abbr(response.timeZoneName, { dots: false }),
	                    dstOffset: response.dstOffset,
	                    rawOffset: response.rawOffset,
	                    timestamp: options.timestamp
	                };
	                callback(err, response);
	            });
	        }
	
	        /**
	         *  Gets the distance and duration values based on the recommended route
	         *  between start and end points.
	         *  @see {@link https://developers.google.com/maps/documentation/distance-matrix/intro|Google Maps Distance Matrix API}
	         *  @see {@link https://developers.google.com/maps/documentation/distance-matrix/usage-limits|Usage Limits}
	         *
	         *  @param {Object} options
	         *         Distance matrix options.
	         *      @param {String|Object|Array} options.origins
	         *             One or more addresses and/or an object of latitude/longitude
	         *             values, from which to calculate distance and time. If you pass
	         *             an address as a string, the service will geocode the string
	         *             and convert it to a latitude/longitude coordinate to calculate
	         *             distances. Following are valid examples:
	         *  <pre><code>options.origins = 'London';
	         *  options.origins = ['London', 'Paris'];
	         *  options.origins = { latitude: 51.5085300, longitude: -0.1257400 };
	         *  options.origins = [
	         *      { latitude: 51.5085300, longitude: -0.1257400 },
	         *      { latitude: 48.8534100, longitude: 2.3488000 }
	         *  ];
	         *  </code></pre>
	         *      @param {String|Object|Array} options.destinations
	         *             One or more addresses and/or an object of latitude/longitude
	         *             values, from which to calculate distance and time. If you pass
	         *             an address as a string, the service will geocode the string
	         *             and convert it to a latitude/longitude coordinate to calculate
	         *             distances.
	         *      @param {String} [options.travelMode="DRIVING"]
	         *             Type of routing requested.
	         *             See {@link #geolocator.TravelMode|`geolocator.TravelMode` enumeration}
	         *             for possible values.
	         *      @param {Boolean} [options.avoidFerries]
	         *             If true, instructs the Distance Matrix service to avoid
	         *             ferries where possible.
	         *      @param {Boolean} [options.avoidHighways]
	         *             If true, instructs the Distance Matrix service to avoid
	         *             highways where possible.
	         *      @param {Boolean} [options.avoidTolls]
	         *             If true, instructs the Distance Matrix service to avoid toll
	         *             roads where possible.
	         *      @param {Number} [options.unitSystem=0]
	         *             Preferred unit system to use when displaying distance.
	         *             See {@link #geolocator.UnitSystem|`geolocator.UnitSystem` enumeration}
	         *             for possible values.
	         *      @param {String} [options.region]
	         *             Region code used as a bias for geocoding requests.
	         *  @param {Boolean} [options.raw=false]
	         *         Whether to return the raw Google API result.
	         *  @param {Function} callback
	         *         Callback function to be executed when the request completes,
	         *         in the following signature: `function (err, result) { ... }`
	         *
	         *  @returns {void}
	         *
	         *  @example
	         *  var options = {
	         *      origins: [{ latitude: 51.5085300, longitude: -0.1257400 }],
	         *      destinations: [{ latitude: 48.8534100, longitude: 2.3488000 }],
	         *      travelMode: geolocator.TravelMode.DRIVING,
	         *      unitSystem: geolocator.UnitSystem.METRIC
	         *  };
	         *  geolocator.getDistanceMatrix(options, function (err, result) {
	         *      console.log(err || result);
	         *  });
	         *
	         *  @example
	         *  // result:
	         *  [
	         *  	{
	         *  		from: "449 Duncannon St, London WC2R 0DZ, UK",
	         *  		to: "1 Parvis Notre-Dame - Pl. Jean-Paul II, 75004 Paris-4E-Arrondissement, France",
	         *  		distance: {
	         *  			value: 475104,
	         *  			text: "475 km"
	         *  		},
	         *  		duration: {
	         *  			value: 20193,
	         *  			text: "5 hours 37 mins"
	         *  		},
	         *  		fare: undefined,
	         *  		timestamp: 1456795956380
	         *  	}
	         *  ]
	         */
	
	    }, {
	        key: 'getDistanceMatrix',
	        value: function getDistanceMatrix(options, callback) {
	            checkGoogleKey();
	
	            var key = geolocator._.config.google.key;
	            geolocator.ensureGoogleLoaded(key, function (err) {
	                if (err) {
	                    throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.GOOGLE_API_FAILED, String(err.message || err));
	                }
	
	                var o = options.origins || options.origin || options.from,
	                    d = options.destinations || options.destination || options.to;
	                if (!_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(options) || invalidOriginOrDest(o) || invalidOriginOrDest(d)) {
	                    throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.INVALID_PARAMETERS);
	                }
	                options.origins = _geo_helper__WEBPACK_IMPORTED_MODULE_2__["default"].toPointList(o);
	                options.destinations = _geo_helper__WEBPACK_IMPORTED_MODULE_2__["default"].toPointList(d);
	
	                options = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	                    travelMode: google.maps.TravelMode.DRIVING,
	                    avoidFerries: undefined,
	                    avoidHighways: undefined,
	                    avoidTolls: undefined,
	                    unitSystem: google.maps.UnitSystem.METRIC
	                }, options);
	
	                var service = new google.maps.DistanceMatrixService();
	                service.getDistanceMatrix(options, function (response, status) {
	                    var err = null;
	                    if (status !== google.maps.DistanceMatrixStatus.OK) {
	                        err = _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].fromResponse(status) || _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].fromResponse(response);
	                        response = null;
	                    } else {
	                        response = options.raw ? response : _geo_helper__WEBPACK_IMPORTED_MODULE_2__["default"].formatDistanceResults(response);
	                    }
	                    callback(err, response);
	                });
	            });
	        }
	
	        /**
	         *  Calculates the distance between two geographic points.
	         *
	         *  @param {Object} options
	         *         Calculation and display options.
	         *      @param {Object} options.from
	         *             Object containing the `latitude` and `longitude` of original
	         *             location.
	         *      @param {Object} options.to
	         *             Object containing the `latitude` and `longitude` of destination.
	         *      @param {String} [options.formula="haversine"]
	         *             The algorithm or formula to calculate the distance.
	         *             See {@link #geolocator.DistanceFormula|`geolocator.DistanceFormula` enumeration}.
	         *      @param {Number} [options.unitSystem=0]
	         *             Preferred unit system to use when displaying distance.
	         *             See {@link #geolocator.UnitSystem|`geolocator.UnitSystem` enumeration}.
	         *
	         *  @returns {Number} - The calculated distance.
	         *
	         *  @example
	         *  // Calculate distance from London to Paris.
	         *  var result = geolocator.calcDistance({
	         *      from: {
	         *          latitude: 51.5085300,
	         *          longitude: -0.1257400
	         *      },
	         *      to: {
	         *          latitude: 48.8534100,
	         *          longitude: 2.3488000
	         *      },
	         *      formula: geolocator.DistanceFormula.HAVERSINE,
	         *      unitSystem: geolocator.UnitSystem.METRIC
	         *  });
	         *  // result: 366.41656039126093 (kilometers)
	         */
	
	    }, {
	        key: 'calcDistance',
	        value: function calcDistance(options) {
	            options = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	                formula: geolocator.DistanceFormula.HAVERSINE,
	                unitSystem: geolocator.UnitSystem.METRIC
	            }, options);
	
	            var from = options.from,
	                to = options.to,
	                radius = options.unitSystem === geolocator.UnitSystem.METRIC ? EARTH_RADIUS_KM : EARTH_RADIUS_MI;
	
	            if (options.formula === geolocator.DistanceFormula.HAVERSINE) {
	                var dLat = geolocator.degToRad(to.latitude - from.latitude),
	                    dLng = geolocator.degToRad(to.longitude - from.longitude),
	                    a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(geolocator.degToRad(from.latitude)) * Math.cos(geolocator.degToRad(to.longitude)) * Math.sin(dLng / 2) * Math.sin(dLng / 2),
	                    c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	                return radius * c;
	            }
	            // geolocator.DistanceFormula.PYTHAGOREAN
	            var latA = geolocator.degToRad(from.latitude),
	                latB = geolocator.degToRad(to.latitude),
	                lngA = geolocator.degToRad(from.longitude),
	                lngB = geolocator.degToRad(to.longitude),
	                x = (lngB - lngA) * Math.cos((latA + latB) / 2),
	                y = latB - latA;
	            return Math.sqrt(x * x + y * y) * radius;
	        }
	
	        /**
	         *  Gets the current public IP of the client.
	         *
	         *  @param {Function} callback
	         *         Callback function to be executed when the request completes, in
	         *         the following signature: `function (err, result) { ... }`
	         *
	         *  @returns {void}
	         *
	         *  @example
	         *  geolocator.getIP(function (err, result) {
	         *      console.log(err || result);
	         *  });
	         *
	         *  @example
	         *  // result:
	         *  {
	         *      ip: "176.232.71.155",
	         *      timestamp: 1457573683427
	         *  }
	         */
	
	    }, {
	        key: 'getIP',
	        value: function getIP(callback) {
	            var conf = geolocator._.config;
	
	            // ipify.org supports CORS, so we'll use XMLHttpRequest instead of a
	            // JSONP request.
	            var opts = {
	                url: _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].setProtocol(_enums__WEBPACK_IMPORTED_MODULE_5__["default"].URL.IP, conf.https),
	                async: true
	            };
	            return _lib_fetch__WEBPACK_IMPORTED_MODULE_1__["default"].get(opts, function (err, xhr) {
	                var response = xhr.responseText;
	                if (err) {
	                    return callback(_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].create(err), null);
	                }
	                if (!response) {
	                    err = new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.INVALID_RESPONSE);
	                    return callback(err, null);
	                }
	                callback(null, {
	                    ip: response,
	                    timestamp: _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].time()
	                });
	            });
	            // let jsonpOpts = {
	            //     url: utils.setProtocol(enums.URL.IP, conf.https),
	            //     async: true,
	            //     clean: true,
	            //     params: {
	            //         format: 'jsonp'
	            //     },
	            //     callbackParam: 'callback',
	            //     rootName: 'geolocator._.cb'
	            // };
	            // return fetch.jsonp(jsonpOpts, (err, response) => {
	            //     if (err) {
	            //         return callback(GeoError.create(err), null);
	            //     }
	            //     if (!response) {
	            //         err = new GeoError(GeoError.Code.INVALID_RESPONSE);
	            //         return callback(err, null);
	            //     }
	            //     if (typeof response === 'object') response.timestamp = utils.time();
	            //     callback(null, response);
	            // });
	        }
	
	        /**
	         *  Ensures Google Maps API is loaded. If not, this will load all of the
	         *  main Javascript objects and symbols for use in the Maps API.
	         *
	         *  Note that, Google Maps API is loaded only when needed. For example,
	         *  the DistanceMatrix API does not support Web Service requests and
	         *  requires this API to be loaded. However, the TimeZone API requests are
	         *  made throught the Web Service without requiring a `google` object
	         *  within DOM.
	         *
	         *  Also note that this will not re-load the API if `google.maps` object
	         *  already exists. In this case, the `callback` is still executed and
	         *  no errors are passed.
	         *
	         *  You can use the following overload to omit the `key` argument altogether:
	         *
	         *  `geolocator.ensureGoogleLoaded(callback)`
	         *
	         *  @param {String} [key]
	         *         Google API key.
	         *  @param {Function} callback
	         *         Callback function to be executed when the operation ends.
	         *
	         *  @returns {void}
	         *
	         *  @example
	         *  geolocator.ensureGoogleLoaded(function (err) {
	         *      if (err) return;
	         *      console.log('google' in window); // true
	         *  });
	         */
	
	    }, {
	        key: 'ensureGoogleLoaded',
	        value: function ensureGoogleLoaded(key, callback) {
	            var k = void 0;
	            if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(key)) {
	                callback = key;
	            } else {
	                k = key;
	            }
	            if (!geolocator.isGoogleLoaded()) {
	                var jsonpOpts = {
	                    url: _enums__WEBPACK_IMPORTED_MODULE_5__["default"].URL.GOOGLE_MAPS_API,
	                    async: true,
	                    callbackParam: 'callback',
	                    params: {
	                        key: k || ''
	                        // callback: ''
	                    },
	                    rootName: 'geolocator._.cb'
	                };
	                return _lib_fetch__WEBPACK_IMPORTED_MODULE_1__["default"].jsonp(jsonpOpts, callback);
	            }
	            callback();
	        }
	
	        /**
	         *  Checks whether the Google Maps API is loaded.
	         *
	         *  @returns {Boolean} - Returns `true` if already loaded.
	         */
	
	    }, {
	        key: 'isGoogleLoaded',
	        value: function isGoogleLoaded() {
	            return 'google' in window && google.maps;
	        }
	
	        /**
	         *  Checks whether the type of the given object is an HTML5 `PositionError`.
	         *
	         *  @param {*} obj - Object to be checked.
	         *  @return {Boolean}
	         */
	
	    }, {
	        key: 'isPositionError',
	        value: function isPositionError(obj) {
	            return _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPositionError(obj);
	        }
	
	        /**
	         *  Checks whether the given value is an instance of `GeoError`.
	         *
	         *  @param {*} obj - Object to be checked.
	         *  @return {Boolean}
	         */
	
	    }, {
	        key: 'isGeoError',
	        value: function isGeoError(obj) {
	            return _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].isGeoError(obj);
	        }
	
	        /**
	         *  Checks whether HTML5 Geolocation API is supported.
	         *
	         *  @return {Boolean}
	         */
	
	    }, {
	        key: 'isGeolocationSupported',
	        value: function isGeolocationSupported() {
	            return navigator && 'geolocation' in navigator;
	        }
	
	        /**
	         *  Converts kilometers to miles.
	         *
	         *  @param {Number} km - Kilometers to be converted.
	         *  @returns {Number} - Miles.
	         */
	
	    }, {
	        key: 'kmToMi',
	        value: function kmToMi(km) {
	            return km * 0.621371;
	        }
	
	        /**
	         *  Converts miles to kilometers.
	         *
	         *  @param {Number} mi - Miles to be converted.
	         *  @returns {Number} - Kilometers.
	         */
	
	    }, {
	        key: 'miToKm',
	        value: function miToKm(mi) {
	            return mi / 0.621371;
	        }
	
	        /**
	         *  Converts degrees to radians.
	         *
	         *  @param {Number} deg - Degrees to be converted.
	         *  @returns {Number} - Radians.
	         */
	
	    }, {
	        key: 'degToRad',
	        value: function degToRad(degrees) {
	            return degrees * (Math.PI / 180);
	        }
	
	        /**
	         *  Converts radians to degrees.
	         *
	         *  @param {Number} rad - Radians to be converted.
	         *  @returns {Number} - Degrees.
	         */
	
	    }, {
	        key: 'radToDeg',
	        value: function radToDeg(radians) {
	            return radians * (180 / Math.PI);
	        }
	
	        /**
	         *  Converts decimal coordinates (either lat or lng) to degrees, minutes, seconds.
	         *
	         *  @param {Number} dec
	         *         Decimals to be converted.
	         *  @param {Boolean} [isLng=false]
	         *         Indicates whether the given decimals is longitude.
	         *
	         *  @returns {String} - Degrees, minutes, seconds.
	         */
	
	    }, {
	        key: 'decToDegMinSec',
	        value: function decToDegMinSec(dec) {
	            var isLng = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            // Degrees Latitude must be in the range of -90. to 90.
	            // Degrees Longitude must be in the range of -180 to 180.
	            // +Latitude is North, -Latitude is South
	            // +Longitude is East, -Longitude is West
	            var sign = dec < 0 ? -1 : 1,
	                sn = dec < 0 ? 'S' : 'N',
	                we = dec < 0 ? 'W' : 'E',
	                nsew = !isLng ? sn : we,
	                absValue = Math.abs(Math.round(dec * 1000000.0));
	            return Math.floor(absValue / 1000000) * sign + '° ' + Math.floor((absValue / 1000000 - Math.floor(absValue / 1000000)) * 60) + '\' ' + Math.floor(((absValue / 1000000 - Math.floor(absValue / 1000000)) * 60 - Math.floor((absValue / 1000000 - Math.floor(absValue / 1000000)) * 60)) * 100000) * 60 / 100000 + '" ' + nsew;
	        }
	    }, {
	        key: 'Error',
	
	
	        // ---------------------------
	        // PROPERTIES
	        // ---------------------------
	
	        /**
	         *  Geolocator Error class that provides a common type of error object for
	         *  the various APIs implemented in Geolocator. All callbacks of Geolocator
	         *  will include an instance of this object as the first argument; if the
	         *  corresponding operation fails. Also all thrown errors will be an instance
	         *  of this object.
	         *
	         *  This object also enumerates
	         *  {@link ?api=geolocator-error#GeoError.Code|Geolocator Error codes}.
	         *
	         *  @see {@link ?api=geolocator-error|`GeoError` documentation}
	         *  @type {GeoError}
	         *  @readonly
	         */
	        get: function get() {
	            return _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"];
	        }
	
	        /**
	         *  Documented separately in enums.js
	         *  @private
	         */
	
	    }, {
	        key: 'MapTypeId',
	        get: function get() {
	            return _enums__WEBPACK_IMPORTED_MODULE_5__["default"].MapTypeId;
	        }
	
	        /**
	         *  Documented separately in enums.js
	         *  @private
	         */
	
	    }, {
	        key: 'LocationType',
	        get: function get() {
	            return _enums__WEBPACK_IMPORTED_MODULE_5__["default"].LocationType;
	        }
	
	        /**
	         *  Documented separately in enums.js
	         *  @private
	         */
	
	    }, {
	        key: 'TravelMode',
	        get: function get() {
	            return _enums__WEBPACK_IMPORTED_MODULE_5__["default"].TravelMode;
	        }
	
	        /**
	         *  Documented separately in enums.js
	         *  @private
	         */
	
	    }, {
	        key: 'UnitSystem',
	        get: function get() {
	            return _enums__WEBPACK_IMPORTED_MODULE_5__["default"].UnitSystem;
	        }
	
	        /**
	         *  Documented separately in enums.js
	         *  @private
	         */
	
	    }, {
	        key: 'RadioType',
	        get: function get() {
	            return _enums__WEBPACK_IMPORTED_MODULE_5__["default"].RadioType;
	        }
	
	        /**
	         *  Documented separately in enums.js
	         *  @private
	         */
	
	    }, {
	        key: 'DistanceFormula',
	        get: function get() {
	            return _enums__WEBPACK_IMPORTED_MODULE_5__["default"].DistanceFormula;
	        }
	
	        /**
	         *  Documented separately in enums.js
	         *  @private
	         */
	
	    }, {
	        key: 'ImageFormat',
	        get: function get() {
	            return _enums__WEBPACK_IMPORTED_MODULE_5__["default"].ImageFormat;
	        }
	    }]);
	
	    return geolocator;
	}();
	
	// ---------------------------
	// HELPER METHODS
	// ---------------------------
	
	/**
	 *  Used with distance matrix calls.
	 *  @private
	 */
	
	
	function invalidOriginOrDest(value) {
	    return !_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(value) && !_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(value) && !_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(value);
	}
	
	/**
	 *  Check if XHR response is an error response and returns a `GeoError`.
	 *  If not, returns the parsed response.
	 *  @private
	 *
	 *  @param {Error} err
	 *         XHR error.
	 *  @param {Object} xhr
	 *         XHR object to be checked.
	 *
	 *  @returns {GeoError|Object}
	 */
	function getXHRResponse(err, xhr) {
	    if (err) return _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].create(err);
	    if (!xhr) return new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.REQUEST_FAILED);
	    var response = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].safeJsonParse(xhr.responseText);
	    // Check if XHR response is an error response.
	    // return response if not.
	    return _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].fromResponse(response) || response;
	}
	
	/**
	 *  Checks the given options and determines if Google key is required.
	 *  Throws if key is required but not set or valid.
	 *  @private
	 *
	 *  @param {Object} [options]
	 *         Options to be checked. If `undefined`, directly checks Googke key.
	 */
	function checkGoogleKey(options) {
	    if (!options || options.addressLookup || options.timezone || options.map || options.staticMap) {
	        if (!geolocator._.config.google.key) {
	            throw new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.GOOGLE_KEY_INVALID, 'A Google API key is required but it\'s not set or valid.');
	        }
	    }
	}
	
	/**
	 *  Checks and adds necessary properties to map options from the given location
	 *  result object. This is used with methods that support `map` option; to
	 *  create a map from the result coordinates; such as locate() method.
	 *  @private
	 *
	 *  @param {Object|String} options
	 *         Original options object.
	 *  @param {Object} location
	 *         Location result object.
	 *
	 *  @returns {Object} - Final map options object.
	 */
	function getMapOpts(mapOptions, location) {
	    if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(mapOptions)) {
	        mapOptions.center = location.coords;
	    } else {
	        mapOptions = {
	            element: mapOptions,
	            center: location.coords
	        };
	    }
	    // this will enable infoWindow
	    if (location.formattedAddress) {
	        mapOptions.title = location.formattedAddress;
	    }
	    // if location has accuracy, (and zoom is not set) we can zoom in a bit more
	    if (!mapOptions.zoom && location.coords && _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isNumber(location.coords.accuracy) && location.coords.accuracy < 1500) {
	        mapOptions.zoom = 15;
	    }
	    return mapOptions;
	}
	
	/**
	 *  Checks the HTMLElement to see whether a previous map and related objects
	 *  (marker, infoWindow) are created for it; by checking our private property
	 *  `_geolocatorMapData`. If there is a map, this does not re-create it (which
	 *  will break the map) but only re-adjust center, zoom and re-create the marker
	 *  if needed. We use this approach bec. Google maps has no feature to destroy
	 *  a map. This is considered a bug by Google developers.
	 *  @private
	 *
	 *  @param {Object} options
	 *         Options for creating a map.
	 */
	function configCreateMap(options) {
	    var elem = options.element,
	
	    // when geolocator creates a map, it will set a `_geolocatorMapData`
	    // property on the element. So we can use this map instance later,
	    // when the same HTMLElement is passed to create a map. So check if
	    // we have it here.
	    mapData = elem._geolocatorMapData,
	        map = mapData && mapData.instance || null,
	        marker = mapData && mapData.marker || null,
	        infoWindow = mapData && mapData.infoWindow || null,
	        center = new google.maps.LatLng(options.center.latitude, options.center.longitude),
	        mapOptions = {
	        mapTypeId: options.mapTypeId,
	        center: center,
	        zoom: options.zoom,
	        styles: options.styles || null
	    };
	
	    // if we have a map, we'll just configure it. otherwise, we'll create
	    // one.
	    if (map) {
	        map.setOptions(mapOptions);
	    } else {
	        map = new google.maps.Map(options.element, mapOptions);
	    }
	
	    // destroy marker and infoWindow if previously created for this element.
	    if (infoWindow) infoWindow = null;
	    if (marker && marker instanceof google.maps.Marker) {
	        google.maps.event.clearInstanceListeners(marker);
	        marker.setMap(null);
	        marker = null;
	    }
	
	    // check the new options to see if we need to re-create a marker for
	    // this.
	    if (options.marker) {
	        marker = new google.maps.Marker({
	            position: mapOptions.center,
	            map: map
	        });
	        if (options.title) {
	            infoWindow = new google.maps.InfoWindow();
	            infoWindow.setContent(options.title);
	            // infoWindow.open(map, marker);
	            google.maps.event.addListener(marker, 'click', function () {
	                infoWindow.open(map, marker);
	            });
	        }
	    }
	
	    mapData = {
	        element: elem,
	        instance: map,
	        marker: marker,
	        infoWindow: infoWindow,
	        options: mapOptions
	    };
	    // set the reference on the element for later use, if needed.
	    elem._geolocatorMapData = mapData;
	    return mapData;
	}
	
	/**
	 *  Sets the `flag` and `staticMap` (if enabled) property of the given location.
	 *  @private
	 *
	 *  @param {Object} location - Fetched location result.
	 *  @param {Object} options - initial options.
	 */
	function setLocationURLs(location, options) {
	    if (!location || !location.address) return;
	    var cc = void 0,
	        address = location.address;
	    if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(address.countryCode) && address.countryCode.length === 2) {
	        cc = address.countryCode;
	    } else if (_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(address.country) && address.country.length === 2) {
	        cc = address.country;
	    }
	    if (!cc) return;
	    location.flag = _enums__WEBPACK_IMPORTED_MODULE_5__["default"].URL.FLAG + cc.toLowerCase() + '.svg';
	    if (options.staticMap) {
	        var opts = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(options.staticMap) ? _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].clone(options.staticMap) : {};
	        opts.center = location.coords;
	        location.staticMap = geolocator.getStaticMap(opts);
	    }
	}
	
	/**
	 *  Nests `createMap` callback within the given callback.
	 *  @private
	 *
	 *  @param {Object} options
	 *         Method options.
	 *  @param {Function} callback
	 *         Parent callback.
	 *
	 *  @returns {Function} - Nested callback.
	 */
	function callbackMap(options, callback) {
	    return function cb(err, location) {
	        if (err) return callback(_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].create(err), null);
	        setLocationURLs(location, options);
	        if (!options.map) return callback(null, location);
	        options.map = getMapOpts(options.map, location);
	        geolocator.createMap(options.map, function (error, map) {
	            if (error) return callback(error, null);
	            location.map = map;
	            return callback(null, location);
	        });
	    };
	}
	
	/**
	 *  Sends a geocode or reverse-geocode request with the given options.
	 *  @private
	 *
	 *  @param {Boolean} reverse
	 *         Whether to send reverse-geocode request.
	 *  @param {Object} options
	 *         Geocode options.
	 *  @param {Function} callback
	 *         Callback to be nested and executed with map callback.
	 */
	function _geocode(reverse, options, callback) {
	    checkGoogleKey();
	    _geo_helper__WEBPACK_IMPORTED_MODULE_2__["default"].geocode(reverse, geolocator._.config, options, callbackMap(options, callback));
	}
	
	/**
	 *  Runs both an address and a timezone look-up for the given location.
	 *  @private
	 *
	 *  @param {Object} location
	 *         Location object.
	 *  @param {Object} options
	 *         Method options.
	 *  @param {Function} callback
	 *         Parent callback.
	 */
	function fetchAddressAndTimezone(location, options, callback) {
	    var loc = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].clone(location, { own: false });
	    if (!options.addressLookup && !options.timezone) {
	        return callback(null, loc);
	    }
	    function getTZ(cb) {
	        geolocator.getTimeZone(loc.coords, function (err, timezone) {
	            if (err) {
	                return cb(err, null);
	            }
	            delete timezone.timestamp;
	            loc.timezone = timezone;
	            loc.timestamp = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].time(); // update timestamp
	            cb(null, loc);
	        });
	    }
	    if (options.addressLookup) {
	        geolocator.reverseGeocode(loc.coords, function (err, result) {
	            if (err) return callback(err, null);
	            loc = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend({}, result, loc);
	            loc.address = result.address;
	            loc.timestamp = _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].time(); // update timestamp
	            if (!options.timezone) {
	                callback(err, loc);
	            } else {
	                getTZ(callback);
	            }
	        });
	    } else if (options.timezone) {
	        getTZ(callback);
	    } else {
	        callback(null, loc);
	    }
	}
	
	/**
	 *  Gets the position with better accuracy.
	 *  See https://github.com/gwilson/getAccurateCurrentPosition#background
	 *  @private
	 *
	 *  @param {Object} options
	 *         Locate options.
	 *  @param {Function} onPositionReceived
	 *         Success callback.
	 *  @param {Function} onPositionError
	 *         Error callback.
	 */
	function locateAccurate(options, onPositionReceived, onPositionError) {
	    var loc = void 0,
	        watcher = void 0,
	        onProgress = !_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(options.onProgress) ? _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].noop : options.onProgress;
	
	    function complete() {
	        watcher = null;
	        if (!loc) {
	            onPositionError(new _geo_error__WEBPACK_IMPORTED_MODULE_3__["default"](_geo_error__WEBPACK_IMPORTED_MODULE_3__["default"].Code.POSITION_UNAVAILABLE));
	        } else {
	            onPositionReceived(loc);
	        }
	    }
	
	    watcher = geolocator.watch(options, function (err, location) {
	        if (!watcher) return;
	        if (err) {
	            return watcher.clear(function () {
	                onPositionError(err);
	            });
	        }
	        loc = location;
	        // ignore the first event if not the only result; for more accuracy.
	        if (watcher.cycle > 1 && loc.coords.accuracy <= options.desiredAccuracy) {
	            watcher.clear(complete);
	        } else {
	            onProgress(loc);
	        }
	    });
	    if (watcher) watcher.clear(options.maximumWait + 100, complete);
	}
	
	function getStyles(options) {
	    var conf = geolocator._.config;
	    return !_lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isFilledArray(options.styles) ? _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isFilledArray(conf.google.styles) ? conf.google.styles : null : options.styles;
	}
	
	// ---------------------------
	// INITIALIZE
	// ---------------------------
	
	/**
	 *  @private
	 *  @type {Object}
	 */
	geolocator._ = {
	    config: _lib_utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend({}, defaultConfig),
	    // Storage for global callbacks.
	    cb: {}
	};
	
	// setting default Geo-IP source
	
	geolocator.setGeoIPSource({
	    provider: 'geojs.io',
	    url: 'https://get.geojs.io/v1/ip/geo.json',
	    xhr: true,
	    schema: {
	        ip: 'ip',
	        coords: {
	            latitude: 'latitude',
	            longitude: 'longitude'
	        },
	        address: {
	            city: 'city',
	            state: 'region',
	            stateCode: '',
	            postalCode: '',
	            countryCode: 'country_code',
	            country: 'country',
	            region: 'region'
	        },
	        timezone: {
	            id: 'timezone'
	        }
	    }
	});
	
	// ---------------------------
	// EXPORT
	// ---------------------------
	
	
	
	// ---------------------------
	// ADDITIONAL DOCUMENTATION
	// ---------------------------
	
	/**
	 *  `Coordinates` inner type that specifies the geographic position of the
	 *  device. The position is expressed as a set of geographic coordinates
	 *  together with information about heading and speed.
	 *
	 *  This is generally returned as part of the
	 *  {@link ?api=geolocator#geolocator~Location|`Location` result object}.
	 *
	 *  @typedef geolocator~Coordinates
	 *  @type Object
	 *
	 *  @property {Number} latitude
	 *         Specifies the latitude estimate in decimal degrees. The value
	 *         range is [-90.00, +90.00].
	 *  @property {Number} longitude
	 *         Specifies the longitude estimate in decimal degrees. The value
	 *         range is [-180.00, +180.00].
	 *  @property {Number} altitude
	 *         Specifies the altitude estimate in meters above the WGS 84
	 *         ellipsoid.
	 *  @property {Number} accuracy
	 *         Specifies the accuracy of the latitude and longitude estimates in
	 *         meters.
	 *  @property {Number} altitudeAccuracy
	 *         Specifies the accuracy of the altitude estimate in meters.
	 *  @property {Number} heading
	 *         Specifies the device's current direction of movement in degrees
	 *         counting clockwise relative to true north.
	 *  @property {Number} speed
	 *         Specifies the device's current ground speed in meters per second.
	 */
	
	/**
	 *	`Address` inner type that specifies the address of the fetched location.
	 *	The address is expressed as a set of political and locality components.
	 *
	 *  This is generally returned as part of the
	 *  {@link ?api=geolocator#geolocator~Location|`Location` result object}.
	 *
	 *  @typedef geolocator~Address
	 *  @type Object
	 *
	 *  @property {String} commonName
	 *         Indicates a point of interest, a premise or colloquial area name for
	 *         the fetched location, if any.
	 *  @property {String} streetNumber
	 *         Indicates the precise street number of the fetched location, if any.
	 *  @property {String} street
	 *         Indicates the street name of the fetched location, if any.
	 *  @property {String} route
	 *         Indicates the route name of the fetched location, if any.
	 *  @property {String} neighborhood
	 *         Indicates the neighborhood name of the fetched location, if any.
	 *  @property {String} town
	 *         Indictes the town of the fetched location, if any.
	 *  @property {String} city
	 *         Indicates the city of the fetched location.
	 *  @property {String} region
	 *         Indicates the political region name of the fetched location, if any.
	 *  @property {String} postalCode
	 *         Indicates the postal code of the fetched location, if any.
	 *  @property {String} state
	 *         Indicates the state of the fetched location, if any.
	 *  @property {String} stateCode
	 *         Indicates the state code of the fetched location, if any.
	 *  @property {String} country
	 *         Indicates the national political entity of the fetched location.
	 *  @property {String} countryCode
	 *         Indicates the ISO alpha-2 country code of the fetched location.
	 */
	
	/**
	 *	`TimeZone` inner type that specifies time offset data for the fetched
	 *	location on the surface of the earth.
	 *
	 *  This is generally returned as part of the
	 *  {@link ?api=geolocator#geolocator~Location|`Location` result object}.
	 *
	 *  @typedef geolocator~TimeZone
	 *  @type Object
	 *
	 *  @property {String} id
	 *         The ID of the time zone, such as `"America/Los_Angeles"` or
	 *         `"Australia/Sydney"`. These IDs are defined in the
	 *         {@link http://www.iana.org/time-zones|IANA Time Zone Database},
	 *         which is also available in searchable format in Wikipedia's
	 *         {@link http://en.wikipedia.org/wiki/List_of_tz_database_time_zones|List of tz database time zones}.
	 *  @property {String} name
	 *         The long form name of the time zone. This field will be localized if
	 *         the Geolocator `language` is configured. e.g. `"Pacific Daylight Time"`
	 *         or `"Australian Eastern Daylight Time"`.
	 *  @property {String} abbr
	 *         The abbreviation of the time zone.
	 *  @property {Number} dstOffset
	 *         The offset for daylight-savings time in seconds. This will be zero
	 *         if the time zone is not in Daylight Savings Time during the specified
	 *         timestamp.
	 *  @property {Number} rawOffset
	 *         The offset from UTC (in seconds) for the given location. This does
	 *         not take into effect daylight savings.
	 */
	
	/**
	 *	`MapData` inner type that provides references to the components of a
	 *	created Google Maps `Map` and the containing DOM element.
	 *
	 *  This is generally returned as part of the
	 *  {@link ?api=geolocator#geolocator~Location|`Location` result object}.
	 *
	 *  @typedef geolocator~MapData
	 *  @type Object
	 *
	 *  @property {HTMLElement} element
	 *         DOM element which a (Google) map is created within.
	 *  @property {google.maps.Map} instance
	 *         Instance of a Google Maps `Map` object.
	 *  @property {google.maps.Marker} marker
	 *         Instance of a Google Maps `Marker` object, if any.
	 *  @property {google.maps.InfoWindow} infoWindow
	 *         Instance of a Google Maps `InfoWindow` object, if any.
	 *  @property {Object} options
	 *         Arbitrary object of applied map options.
	 */
	
	/**
	 *	`Location` inner type that specifies geographic coordinates, address and
	 *	time zone information for the fetched location.
	 *
	 *  This result object is passed to the callbacks of the corresponding
	 *  asynchronous Geolocator methods (such as `.locate()` method), as the second
	 *  argument. The contents of this object will differ for various  Geolocator
	 *  methods, depending on the configured method options.
	 *
	 *  @typedef geolocator~Location
	 *  @type Object
	 *
	 *  @property {Coordinates} coords
	 *         Specifies the geographic location of the device. The location is
	 *         expressed as a set of geographic coordinates together with
	 *         information about heading and speed.
	 *         See {@link #geolocator~Coordinates|`geolocator~Coordinates` type}
	 *         for details.
	 *  @property {Address} address
	 *         Specifies the address of the fetched location. The address is
	 *         expressed as a set of political and locality components.
	 *         This property might be `undefined` if `addressLookup` option is not
	 *         enabled for the corresponding method.
	 *         See {@link #geolocator~Address|`geolocator~Address` type}
	 *         for details.
	 *  @property {String} formattedAddress
	 *         The human-readable address of this location. Often this address is
	 *         equivalent to the "postal address," which sometimes differs from
	 *         country to country.
	 *  @property {Boolean} targetReached
	 *         Specifies whether the defined target coordinates is reached.
	 *         This property is only available for
	 *         {@link #geolocator.watch|`geolocator.watch()`} method when `target`
	 *         option is defined.
	 *  @property {String} type
	 *         Type of the location. See
	 *         {@link #geolcoator.LocationType|`geolcoator.LocationType` enumeration}
	 *         for details.
	 *  @property {String} placeId
	 *         A unique identifier that can be used with other Google APIs.
	 *  @property {String} flag
	 *         URL of the country flag image, in SVG format. This property exists
	 *         only if address information is available.
	 *  @property {TimeZone} timezone
	 *         Specifies time offset data for the fetched location on the surface of
	 *         the earth. See {@link #geolocator~TimeZone|`geolocator~TimeZone` type}
	 *         for details.
	 *  @property {MapData} map
	 *         Provides references to the components of a created Google Maps `Map`
	 *         and the containing DOM element. See
	 *         {@link #geolocator~MapData|`geolocator~MapData` type} for details.
	 *  @property {String} staticMap
	 *         URL of a static Google map image, for the location.
	 *  @property {Number} timestamp
	 *         Specifies the time when the location information was retrieved and
	 *         the `Location` object created.
	 */
	
	/**
	 *  `MapOptions` inner type that specifies options for the map to be created.
	 *
	 *  @typedef geolocator~MapOptions
	 *  @type Object
	 *
	 *  @property {String|HTMLElement|Map} element
	 *         Either the ID of a DOM element or the element itself;
	 *         which the map will be created within; or a previously created
	 *         `google.maps.Map` instance. If a map instance is set, this
	 *         only will apply the options without re-creating it.
	 *  @property {Object} center
	 *         Center coordinates for the map to be created.
	 *      @property {Number} center.latitude
	 *             Latitude of the center point coordinates.
	 *      @property {Number} center.longitude
	 *             Longitude of the center point coordinates.
	 *  @property {String} mapTypeId
	 *         Type of the map to be created.
	 *         See {@link #geolocator.MapTypeId|`geolocator.MapTypeId` enumeration}
	 *         for possible values.
	 *  @property {String} title
	 *         Title text to be displayed within an `InfoWindow`, when the
	 *         marker is clicked. This only take effect if `marker` is
	 *         enabled.
	 *  @property {Boolean} marker
	 *         Whether to place a marker at the given coordinates.
	 *         If `title` is set, an `InfoWindow` will be opened when the
	 *         marker is clicked.
	 *  @property {Number} zoom
	 *             Zoom level to be set for the map.
	 */
	
	/***/ }),
	
	/***/ "./src/index.js":
	/*!**********************!*\
	  !*** ./src/index.js ***!
	  \**********************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// we don't mix import and module.exports in same file, so using require here.
	var geolocator = __webpack_require__(/*! ./core/geolocator */ "./src/core/geolocator.js").geolocator;
	
	// See https://github.com/onury/geolocator/issues/42
	if (typeof window !== 'undefined' && typeof window.geolocator === 'undefined') {
	        window.geolocator = geolocator;
	}
	
	// export default geolocator;
	// http://stackoverflow.com/a/33683495/112731
	module.exports = geolocator;
	
	/***/ }),
	
	/***/ "./src/lib/fetch.js":
	/*!**************************!*\
	  !*** ./src/lib/fetch.js ***!
	  \**************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils */ "./src/lib/utils.js");
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	/**
	 * Utility for making `XMLHttpRequest` and `JSONP` requests.
	 * @copyright 2019, Onur Yıldırım <onur@cutepilot.com>
	 */
	
	var fetch = function () {
	    function fetch() {
	        _classCallCheck(this, fetch);
	    }
	
	    _createClass(fetch, null, [{
	        key: 'jsonp',
	
	
	        // https://html.spec.whatwg.org/multipage/scripting.html#script
	
	        /**
	         * Makes a JSONP (GET) request by injecting a script tag in the browser.
	         * Note that using JSONP has some security implications. As JSONP is really
	         * javascript, it can do everything else javascript can do, so you need to
	         * trust the provider of the JSONP data.
	         * @see https://en.wikipedia.org/wiki/JSONP
	         * @memberof fetch
	         *
	         * @param {Object|String} options - Required. Either the URL string which
	         *     will set other options to defaults or an options object with the
	         *     following properties.
	         *     @param {String} options.url
	         *            Source URL to be called.
	         *     @param {String} [options.type]
	         *            The MIME type that identifies the scripting language of the
	         *            code referenced within the script element.
	         *            e.g. `"text/javascript"`
	         *     @param {String} [options.charset]
	         *            Indicates the character encoding of the external resource.
	         *            e.g. `"utf-8"`.
	         *     @param {Boolean} [options.async=true]
	         *            Indicates whether or not to perform the operation
	         *            asynchronously. See {@link http://caniuse.com/#feat=script-async|browser support}.
	         *     @param {Boolean} [options.defer=false]
	         *            Indicates whether the script should be executed when the page
	         *            has finished parsing. See {@link http://caniuse.com/#feat=script-defer|browser support}.
	         *     @param {String} [options.crossorigin]
	         *            Indicates the CORS setting for the script element being
	         *            injected. Note that this attribute is not widely supported.
	         *            Valid values: `"anonymous"`, `"use-credentials"`.
	         *            See {@link https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes|CORS settings}.
	         *     @param {Number} [options.timeout=0]
	         *            The number of milliseconds a request can take before
	         *            automatically being terminated. `0` disables timeout.
	         *     @param {Boolean} [options.clean=false]
	         *            Whether to remove the loaded script from DOM when the
	         *            operation ends. Note that the initial source might load
	         *            additional sources which are not deteceted or removed. Only
	         *            the initial source is removed.
	         *     @param {Object} [options.params]
	         *            Optional query parameters to be appended at the end of the URL.
	         *            e.g. `{ key: "MY-KEY" }`
	         *            You can also include the JSONP callback name parameter here
	         *            but if you want the object to be passed to the callback
	         *            argument of this method, use `options.callbackParam` to set
	         *            the callback parameter.
	         *     @param {String} [options.callbackParam]
	         *            If the endpoint supports JSONP callbacks, you can set the
	         *            callback parameter with this setting. This will enable a
	         *            second `obj` argument in the callback of this method which is
	         *            useful if the JSONP source invokes the callback with an
	         *            argument.
	         *     @param {String} [options.rootName]
	         *            The name (or notation) of the object that the generated JSONP
	         *            callback function should be assigned to. By default, this is
	         *            the `window` object but you can set this to a custom object
	         *            notation; for example, to prevent global namespace polution.
	         *            Note that this root object has to be globally accessible for
	         *            this to work. e.g. `"window.myObject"` (as string)
	         * @param {Function} [callback]
	         *        The callback function that will be executed when the script is
	         *        loaded. This callback has the following signature:
	         *        `function (err, obj) { ... }`. Note that the second argument
	         *        `obj` will always be `undefined` if the source endpoint does not
	         *        support JSONP callbacks or a callback param is not set explicitly
	         *        via `options.callbackParam` (or if the source does not invoke the
	         *        jsonp with an argument). However, the function will always execute
	         *        when the script loads or an error occurs.
	         *
	         * @returns {void}
	         *
	         * @example
	         * var opts1 = {
	         * 	   url: 'some/api',
	         * 	   callbackParam: 'jsonCallback',
	         * 	   params: { key: 'MY-KEY' }
	         * };
	         * // This will load the following source:
	         * // some/api?jsonCallback={auto-generated-fn-name}&key=MY-KEY
	         * fetch.jsonp(opts1, function (err, obj) {
	         * 	   console.log(obj); // some object
	         * });
	         *
	         * var opts2 = {
	         * 	   url: 'some/api',
	         * 	   params: {
	         * 		   key: 'MY-KEY',
	         * 		   jsonCallback: 'my-fn-name'
	         * 	   }
	         * };
	         * // This will load the following source:
	         * // some/api?jsonCallback=my-fn-name&key=MY-KEY
	         * fetch.jsonp(options, function (err, obj) {
	         * 	   console.log(obj); // undefined
	         * 	   // still executes, catch errors here
	         * });
	         * // JSON callback should be explicitly set.
	         * window['my-fn-name'] = function (obj) {
	         * 	   console.log(obj); // some object
	         * };
	         */
	        value: function jsonp(options, callback) {
	            var timeout = void 0;
	
	            callback = _utils__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(callback) ? callback : _utils__WEBPACK_IMPORTED_MODULE_0__["default"].noop;
	
	            if (_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(options)) {
	                options = { url: options };
	            }
	
	            if (_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(options)) {
	                options = _utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	                    // type: undefined,
	                    async: true,
	                    defer: false,
	                    // crossorigin: undefined,
	                    timeout: 0,
	                    params: {},
	                    // callbackParam: undefined,
	                    // rootName: undefined,
	                    clean: true
	                }, options);
	            } else {
	                return callback(new Error('No options or target URL is provided.'));
	            }
	
	            if (_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(options.url) === false || options.url.trim() === '') {
	                return callback(new Error('No target URL is provided.'));
	            }
	
	            var script = document.createElement('script'),
	                cbParamSet = _utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(options.callbackParam) && options.callbackParam.trim() !== '',
	                cbFnName = void 0,
	                root = void 0,
	                rootNameSet = _utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(options.rootName) && options.rootName !== 'window' && options.rootName !== 'document' && options.rootName.trim() !== '';
	
	            if (cbParamSet) {
	                cbFnName = '_jsonp_' + _utils__WEBPACK_IMPORTED_MODULE_0__["default"].randomString(10);
	                options.params[options.callbackParam] = rootNameSet ? options.rootName + '.' + cbFnName : cbFnName;
	            }
	            var query = _utils__WEBPACK_IMPORTED_MODULE_0__["default"].params(options.params) || '',
	                qMark = options.url.indexOf('?') >= 0 ? '&' : '?',
	                url = query ? '' + options.url + qMark + query : options.url;
	            // console.log(url);
	
	            function execCb(err, timeUp, obj) {
	                if (timeout) {
	                    clearTimeout(timeout);
	                    timeout = null;
	                }
	                if ((timeUp || options.clean) && script.parentNode) {
	                    script.parentNode.removeChild(script);
	                }
	                // delete the jsonp callback function
	                if (rootNameSet) {
	                    delete root[cbFnName];
	                }
	                callback(err, obj);
	            }
	
	            if (cbFnName) {
	                var fn = function fn(obj) {
	                    execCb(null, false, obj);
	                };
	                root = rootNameSet
	                // ? window[options.rootName][cbFnName] = fn;
	                ? _utils__WEBPACK_IMPORTED_MODULE_0__["default"].notateGlobalObj(options.rootName) // if rootName is dot-notation.
	                : window;
	                root[cbFnName] = fn;
	            } else if (script.readyState) {
	                // IE < 11
	                script.onreadystatechange = function () {
	                    if (script.readyState === 'loaded' || script.readyState === 'complete') {
	                        script.onreadystatechange = null;
	                        execCb(null);
	                    }
	                };
	            } else {
	                // IE 11+
	                script.onload = function () {
	                    execCb(null);
	                };
	            }
	
	            script.onerror = function (error) {
	                var errMsg = 'Could not load source at ' + _utils__WEBPACK_IMPORTED_MODULE_0__["default"].removeQuery(options.url);
	                if (error) {
	                    errMsg += '\n' + (error.message || error);
	                }
	                execCb(new Error(errMsg));
	            };
	
	            if (options.type) {
	                script.type = options.type;
	            }
	            if (options.charset) {
	                script.charset = options.charset;
	            }
	            if (options.async) {
	                script.async = true;
	            }
	            if (options.defer) {
	                script.defer = true;
	            }
	            if (options.crossorigin) {
	                script.crossorigin = options.crossorigin;
	            }
	
	            script.src = url;
	            document.getElementsByTagName('head')[0].appendChild(script);
	
	            // Timeout
	            if (_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isNumber(options.timeout) && options.timeout > 0) {
	                timeout = setTimeout(function () {
	                    script.src = '';
	                    execCb(new Error('Operation timed out.'), true);
	                }, options.timeout);
	            }
	        }
	
	        /**
	         * Makes an XMLHttpRequest with the given parameters.
	         * Note that `"Access-Control-Allow-Origin"` header should be present on
	         * the requested resource. Otherwise, the request will not be allowed.
	         * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest|XMLHttpRequest}.
	         * @memberof fetch
	         *
	         * @param {Object|String} options
	         *        Either the URL string which will set other options to defaults or
	         *        the full options object.
	         *     @param {String} options.url
	         *            Target URL to be called.
	         *     @param {String} [options.method="GET"]
	         *            HTTP method.
	         *     @param {*} [options.data]
	         *            Data to be sent with the request.
	         *     @param {Number} [options.timeout]
	         *            The number of milliseconds a request can take before
	         *            automatically being terminated. `0` disables timeout.
	         *     @param {Boolean} [options.withCredentials=false]
	         *            Indicates whether or not cross-site Access-Control requests
	         *            should be made using credentials such as cookies or
	         *            authorization headers.
	         *     @param {Boolean} [options.async=true]
	         *            Indicating whether or not to perform the operation
	         *            asynchronously. If this value is false, the `send()` method
	         *            does not return until the response is received. If `true`,
	         *            notification of a completed transaction is provided using
	         *            event listeners. This must be `true` if the multipart
	         *            attribute is `true`, or an exception will be thrown.
	         *     @param {String} [options.mimeType]
	         *            If set, overrides the MIME type returned by the server. This
	         *            may be used, for example, to force a stream to be treated and
	         *            parsed as `text/xml`, even if the server does not report it as
	         *            such.
	         *     @param {Object} [options.headers]
	         *            Sets the HTTP request headers. Each key should be a header
	         *            name with a value. e.g. `{ 'Content-Length': 50 }`. For
	         *            security reasons, some headers cannot be set and can only be
	         *            controlled by the user agent.
	         *     @param {String} [options.username=""]
	         *            User name to use for authentication purposes.
	         *     @param {String} [options.password=""]
	         *            Password to use for authentication purposes.
	         * @param {Function} [callback]
	         *        The callback function in the following signature:
	         *        `function (err, xhr) { ... }`
	         *        Note that `xhr` object is always passed regardless of an error.
	         *
	         * @returns {void}
	         */
	
	    }, {
	        key: 'xhr',
	        value: function xhr(options, callback) {
	            var xhr = void 0,
	                err = void 0;
	            var isXDR = false;
	
	            if ('XMLHttpRequest' in window) {
	                xhr = new XMLHttpRequest();
	            } else if ('XDomainRequest' in window) {
	                // IE9
	                xhr = new XDomainRequest();
	                isXDR = true;
	            } else {
	                throw new Error('XMLHttpRequest is not supported!');
	            }
	
	            var hasCallback = _utils__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(callback);
	            callback = hasCallback ? callback : _utils__WEBPACK_IMPORTED_MODULE_0__["default"].noop;
	
	            if (_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(options)) options = { url: options };
	            if (_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(options)) {
	                options = _utils__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	                    method: 'GET',
	                    data: undefined,
	                    async: true,
	                    timeout: 0, // no timeout
	                    withCredentials: false,
	                    mimeType: undefined,
	                    username: '',
	                    password: ''
	                }, options);
	            } else {
	                callback(new Error('No options or target URL is provided.'));
	            }
	
	            if (_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(options.url) === false) {
	                callback(new Error('No target URL is provided.'));
	            }
	
	            options.username = String(options.username);
	            options.password = String(options.password);
	            options.method = options.method.toUpperCase();
	            if (options.method !== 'POST' && options.method !== 'PUT') {
	                options.data = undefined;
	            }
	            // console.log(JSON.stringify(options));
	
	            function xError() {
	                var crossDomain = xhr.status === 0 ? '. Make sure you have permission if this is a cross-domain request.' : '';
	                err = new Error('The request returned status: ' + xhr.status + crossDomain);
	                // console.log(xhr);
	                callback(err, xhr);
	            }
	
	            if (hasCallback) {
	                if (isXDR) {
	                    // IE9
	                    xhr.onload = function () {
	                        callback(null, xhr);
	                    };
	                    xhr.onerror = xError;
	                } else {
	                    xhr.onreadystatechange = function () {
	                        if (xhr.readyState === fetch.XHR_READY_STATE.DONE) {
	                            if (xhr.status === 200) {
	                                callback(null, xhr);
	                            } else {
	                                xError();
	                            }
	                        }
	                    };
	                }
	
	                if (_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isNumber(options.timeout) && options.timeout > 0) {
	                    xhr.timeout = options.timeout;
	                    xhr.ontimeout = function () {
	                        // xhr.abort();
	                        err = new Error('The request had timed out.');
	                        callback(err, xhr);
	                    };
	                }
	            }
	            // console.log(options);
	            xhr.open(options.method, options.url, options.async, options.username, options.password);
	
	            // if this is XDomainRequest, it doesn't support setting custom headers;
	            // or overriding the mime type.
	            if (!isXDR) {
	                if (_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(options.headers)) {
	                    // xhr.setRequestHeader() method should be called after open(), but
	                    // before send().
	                    Object.keys(options.headers).forEach(function (key) {
	                        var value = options.headers[key];
	                        xhr.setRequestHeader(key, value);
	                    });
	                }
	
	                // xhr.overrideMimeType() method must be called before send().
	                if (options.mimeType) {
	                    xhr.overrideMimeType(options.mimeType);
	                }
	            }
	
	            xhr.send(options.data);
	        }
	
	        /**
	         * Alias of `fetch.xhr()` with request method set to `"GET"` by default.
	         * @memberof fetch
	         *
	         * @param {Object} options
	         *        Either the URL string which will set other options to defaults or
	         *        the full options object. See `fetch.xhr()` method options for
	         *        details.
	         * @param {Function} [callback]
	         *        The callback function in the following signature:
	         *        `function (err, xhr) { ... }`
	         *        Note that `xhr` object is always passed regardless of an error.
	         * @returns {void}
	         */
	
	    }, {
	        key: 'get',
	        value: function get(options, callback) {
	            return fetch.xhr(options, callback);
	        }
	
	        /**
	         * Alias of `fetch.xhr()` with request method set to `"POST"` by default.
	         * @memberof fetch
	         *
	         * @param {Object} options
	         *        Either the URL string which will set other options to defaults or
	         *        the full options object. See `fetch.xhr()` method options for
	         *        details.
	         * @param {Function} [callback]
	         *        The callback function in the following signature:
	         *        `function (err, xhr) { ... }`
	         *        Note that `xhr` object is always passed regardless of an error.
	         * @returns {void}
	         */
	
	    }, {
	        key: 'post',
	        value: function post(options, callback) {
	            return _xhr('POST', options, callback);
	        }
	
	        /**
	         * Alias of `fetch.xhr()` with request method set to `"PUT"` by default.
	         * @memberof fetch
	         *
	         * @param {Object} options
	         *        Either the URL string which will set other options to defaults or
	         *        the full options object. See `fetch.xhr()` method options for
	         *        details.
	         * @param {Function} [callback]
	         *        The callback function in the following signature:
	         *        `function (err, xhr) { ... }`
	         *        Note that `xhr` object is always passed regardless of an error.
	         * @returns {void}
	         */
	
	    }, {
	        key: 'put',
	        value: function put(options, callback) {
	            return _xhr('PUT', options, callback);
	        }
	
	        /**
	         * Alias of `fetch.xhr()` with request method set to `"DELETE"` by default.
	         * @memberof fetch
	         *
	         * @param {Object} options
	         *        Either the URL string which will set other options to defaults or
	         *        the full options object. See `fetch.xhr()` method options for
	         *        details.
	         * @param {Function} [callback]
	         *        The callback function in the following signature:
	         *        `function (err, xhr) { ... }`
	         *        Note that `xhr` object is always passed regardless of an error.
	         * @returns {void}
	         */
	
	    }, {
	        key: 'delete',
	        value: function _delete(options, callback) {
	            return _xhr('DELETE', options, callback);
	        }
	    }]);
	
	    return fetch;
	}();
	
	/**
	 *  @private
	 */
	
	
	function _xhr(method, options, callback) {
	    options = _utils__WEBPACK_IMPORTED_MODULE_0__["default"].isString(options) ? { url: options } : options || {};
	    options.method = method;
	    return fetch.xhr(options, callback);
	}
	
	/**
	 * Enumerates `XMLHttpRequest` ready states.
	 * Not to be confused with `script.readyState`.
	 * @memberof fetch
	 *
	 * @enum {Number}
	 */
	fetch.XHR_READY_STATE = {
	    /**
	     * `xhr.open()` has not been called yet.
	     * @type {Number}
	     */
	    UNSENT: 0,
	    /**
	     * `xhr.send()` has been called.
	     * @type {Number}
	     */
	    OPENED: 1,
	    /**
	     * `xhr.send()` has been called, and headers and status are available.
	     * @type {Number}
	     */
	    HEADERS_RECEIVED: 2,
	    /**
	     * Downloading; responseText holds partial data.
	     * @type {Number}
	     */
	    LOADING: 3,
	    /**
	     * The operation is complete.
	     * @type {Number}
	     */
	    DONE: 4
	};
	
	/* harmony default export */ __webpack_exports__["default"] = (fetch);
	
	/***/ }),
	
	/***/ "./src/lib/utils.js":
	/*!**************************!*\
	  !*** ./src/lib/utils.js ***!
	  \**************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _toString = Object.prototype.toString;
	
	/**
	 * Simple utility methods; internally used within Geolocator core;
	 * made publically accessible.
	 * @type {Object}
	 * @readonly
	 */
	var utils = {
	    noop: function noop() {},
	
	
	    // ---------------------------
	    // Validation
	    // ---------------------------
	
	    /**
	     * Checks if the type of the given value is `String`.
	     * @memberof utils
	     *
	     * @param {*} value - Value to be checked.
	     * @returns {Boolean}
	     */
	    isString: function isString(value) {
	        return typeof value === 'string';
	    },
	    isStringSet: function isStringSet(value) {
	        return typeof value === 'string' && value.trim().length > 0;
	    },
	
	
	    /**
	     * Checks if the type of the given value is `Number`.
	     * @memberof utils
	     *
	     * @param {*} value - Value to be checked.
	     * @returns {Boolean}
	     */
	    isNumber: function isNumber(value) {
	        return typeof value === 'number';
	    },
	
	
	    /**
	     * Checks if the type of the given value is an `Object` or `Function`.
	     * @memberof utils
	     *
	     * @param {*} value - Value to be checked.
	     * @returns {Boolean}
	     */
	    isObject: function isObject(value) {
	        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	        return Boolean(value) && (type === 'object' || type === 'function');
	    },
	
	
	    /**
	     * Checks if the type of the given value is `Function`.
	     * @memberof utils
	     *
	     * @param {*} value - Value to be checked.
	     * @returns {Boolean}
	     */
	    isFunction: function isFunction(value) {
	        return typeof value === 'function';
	    },
	
	
	    /**
	     * Checks if the type of the given value is `Array`.
	     * @memberof utils
	     *
	     * @param {*} value - Value to be checked.
	     * @returns {Boolean}
	     */
	    isArray: function isArray(value) {
	        return Boolean(value) && _toString.call(value) === '[object Array]';
	    },
	
	
	    /**
	     * Checks if the given object is a non-empty `Array`.
	     * @memberof utils
	     *
	     * @param {*} array - Object to be checked.
	     * @returns {Boolean}
	     */
	    isFilledArray: function isFilledArray(array) {
	        return utils.isArray(array) && array.length > 0;
	    },
	
	
	    /**
	     * Checks if the given value is a plain `Object`.
	     * @memberof utils
	     *
	     * @param {*} value - Value to be checked.
	     * @returns {Boolean}
	     */
	    isPlainObject: function isPlainObject(value) {
	        return Boolean(value) && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && _toString.call(value) === '[object Object]';
	    },
	
	
	    /**
	     * Checks if the given value is a `Date`.
	     * @memberof utils
	     *
	     * @param {*} value - Value to be checked.
	     * @returns {Boolean}
	     */
	    isDate: function isDate(value) {
	        return Boolean(value) && _toString.call(value) === '[object Date]';
	    },
	
	
	    /**
	     * Checks if the given object is a DOM element.
	     * @memberof utils
	     *
	     * @param {Object} object - Object to be checked.
	     * @returns {Boolean}
	     */
	    isElement: function isElement(object) {
	        if (!object) return false;
	        return object instanceof HTMLElement || (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object.nodeType === 1;
	    },
	
	
	    /**
	     * Checks if the given object is a DOM node.
	     * @memberof utils
	     *
	     * @param {Object} object - Object to be checked.
	     * @returns {Boolean}
	     */
	    isNode: function isNode(object) {
	        if (!object) return false;
	        return object instanceof Node || (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && typeof object.nodeType === 'number';
	    },
	
	
	    /**
	     * Checks if the given object is a jQuery instance.
	     * This will still return `false` if the jQuery instance has no items.
	     * @memberof utils
	     *
	     * @param {Object} object - Object to be checked.
	     * @returns {Boolean}
	     */
	    isJQueryObject: function isJQueryObject(object) {
	        if (!object) return false;
	        return 'jQuery' in window && object instanceof window.jQuery && Boolean(object[0]);
	        // http://api.jquery.com/jquery-2/
	        // || (typeof object === 'object' && Boolean(object.jquery));
	    },
	
	
	    /**
	     * Checks if the type of the given value is an HTML5 `PositionError`.
	     * @memberof utils
	     *
	     * @param {*} value - Value to be checked.
	     * @returns {Boolean}
	     */
	    isPositionError: function isPositionError(value) {
	        return Boolean(value) && _toString.call(value) === '[object PositionError]';
	    },
	
	
	    /**
	     * Checks if the given value is an instance of `Error` or HTML5 `PositionError`.
	     * @memberof utils
	     *
	     * @param {*} value - Value to be checked.
	     * @returns {Boolean}
	     */
	    isError: function isError(value) {
	        return value instanceof Error || utils.isPositionError(value);
	    },
	
	
	    // ---------------------------
	    // String
	    // ---------------------------
	
	    /**
	     * Removes the query string portion from the given URL string.
	     * @memberof utils
	     *
	     * @param {String} str - String to be processed.
	     * @returns {String} - Returns the rest of the string.
	     */
	    removeQuery: function removeQuery(str) {
	        return str.replace(/\?.*$/, '');
	    },
	
	
	    /**
	     * Removes the protocol portion from the given URL string.
	     * @memberof utils
	     *
	     * @param {String} str - String to be processed.
	     * @returns {String} - Returns the rest of the string.
	     */
	    removeProtocol: function removeProtocol(str) {
	        return str.replace(/^(.*:)?\/\//, '');
	    },
	
	
	    /**
	     * Sets the protocol of the given URL.
	     * @memberof utils
	     *
	     * @param {String} url
	     *        The URL to be modified.
	     * @param {Boolean} [https]
	     *        Specifies whether to set the protocol to HTTPS.
	     *        If omitted, current page protocol will be used.
	     *
	     * @returns {String} - The modified URL string.
	     */
	    setProtocol: function setProtocol(url, https) {
	        var p = void 0;
	        if (https === undefined || https === null) {
	            p = window.location.protocol;
	        } else {
	            p = https ? 'https:' : 'http:';
	        }
	        url = utils.removeProtocol(url);
	        return p + '//' + url;
	    },
	
	
	    /**
	     * Removes both the leading and trailing dots from the given string.
	     * @memberof utils
	     *
	     * @param {String} str - String to be processed.
	     * @returns {String} - Returns the rest of the string.
	     */
	    trimDots: function trimDots(str) {
	        return str.replace(/^\.+?(.*?)\.+?$/g, '$1');
	    },
	
	
	    /**
	     * URL-Encodes the given string. Note that the encoding is done Google's
	     * way; that is, spaces are replaced with `+` instead of `%20`.
	     * @memberof utils
	     *
	     * @param {String} str - String to be processed.
	     * @returns {String} - Returns the encoded string.
	     */
	    encodeURI: function encodeURI(str) {
	        return encodeURIComponent(str).replace(/%20/g, '+');
	    },
	
	
	    /**
	     * URL-Decodes the given string. This is the reverse of `utils.encodeURI()`;
	     * so pluses (`+`) are replaced with spaces.
	     * @memberof utils
	     *
	     * @param {String} str - String to be processed.
	     * @returns {String} - Returns the decoded string.
	     */
	    decodeURI: function decodeURI(str) {
	        return decodeURIComponent(str.replace(/\+/g, '%20'));
	    },
	
	
	    /**
	     * Converts the given value to string.
	     * `null` and `undefined` converts to empty string.
	     * If value is a function, it's native `toString()` method is used.
	     * Otherwise, value is coerced.
	     * @memberof utils
	     *
	     * @param {*} value - String to be converted.
	     * @returns {String} - Returns the result string.
	     */
	    toString: function toString(value) {
	        if (value === null || value === undefined) return '';
	        if (value.toString && utils.isFunction(value.toString)) {
	            return value.toString();
	        }
	        return String(value);
	    },
	
	
	    /**
	     * Generates a random string with the number of characters.
	     * @memberof utils
	     *
	     * @param {Number} [len=1] - Length of the string.
	     * @returns {String} - Returns a random string.
	     */
	    randomString: function randomString(len) {
	        if (!len || !utils.isNumber(len)) len = 1;
	        len = -Math.abs(len);
	        return Math.random().toString(36).slice(len);
	    },
	
	
	    /**
	     * Gets the abbreviation of the given phrase.
	     * @memberof utils
	     *
	     * @param {String} str
	     *        String to abbreviate.
	     * @param {Object} [options]
	     *        Abbreviation options.
	     *     @param {Boolean} [options.upper=true]
	     *            Whether to convert to upper-case.
	     *     @param {Boolean} [options.dots=true]
	     *            Whether to add dots after each abbreviation.
	     *
	     * @returns {String} - Returns the abbreviation of the given phrase.
	     */
	    abbr: function abbr(str, options) {
	        options = utils.extend({
	            upper: true,
	            dots: true
	        }, options);
	        var d = options.dots ? '.' : '',
	            s = str.match(/(\b\w)/gi).join(d) + d;
	        return options.upper ? s.toUpperCase() : s;
	    },
	
	
	    /**
	     * Builds URI parameters from the given object.
	     * Note: This does not iterate deep objects.
	     * @memberof utils
	     *
	     * @param {Object} obj - Object to be processed.
	     * @param {Object} options - Parameterize options.
	     *     @param {Boolean} [options.encode=true]
	     *            Whether to encode URI components.
	     *     @param {String} [options.operator="="]
	     *     @param {String} [options.separator="&"]
	     *     @param {Array} [options.include]
	     *            Keys to be included in the output params. If defined,
	     *            `options.exclude` is ignored.
	     *     @param {Array} [options.exclude]
	     *            Keys to be excluded from the output params.
	     *
	     * @returns {String} - URI parameters string.
	     */
	    params: function params(obj, options) {
	        if (!utils.isPlainObject(obj) || Object.keys(obj).length === 0) {
	            return '';
	        }
	
	        options = utils.extend({
	            encode: true,
	            operator: '=',
	            separator: '&',
	            include: undefined,
	            exclude: undefined
	        }, options);
	
	        var params = [],
	            inc = utils.isArray(options.include) ? options.include : null,
	            exc = !inc && utils.isArray(options.exclude) ? options.exclude : null;
	        utils.forIn(obj, function (value, key) {
	            if ((!inc || inc.indexOf(key) >= 0) && (!exc || exc.indexOf(key) < 0)) {
	                var v = utils.toString(value);
	                v = options.encode ? utils.encodeURI(v) : v;
	                var k = options.encode ? utils.encodeURI(key) : key;
	                params.push(k + options.operator + v);
	            }
	        });
	
	        return params.join(options.separator);
	    },
	
	
	    /**
	     * Gets the object from the given object notation string.
	     * @private
	     *
	     * @param {String} notation - Object notation.
	     * @returns {*} - Any existing object.
	     */
	    notateGlobalObj: function notateGlobalObj(notation) {
	        notation = utils.trimDots(notation);
	        var levels = notation.split('.'),
	            o = window;
	        if (levels[0] === 'window' || levels[0] === 'document') {
	            levels.shift();
	        }
	        levels.forEach(function (note) {
	            o = o[note];
	        });
	        return o;
	    },
	
	
	    // ---------------------------
	    // Object
	    // ---------------------------
	
	    /**
	     * Iterates over own properties of an object invoking a callback for each
	     * property.
	     * @memberof utils
	     *
	     * @param {Object} obj
	     *        Object to be processed.
	     * @param {Function} callback
	     *        Callback function with the following signature:
	     *        `function (value, key, object) { ... }`.
	     *        Explicitly returning `false` will exit the iteration early.
	     * @returns {void}
	     */
	    forIn: function forIn(obj, callback) {
	        var k = void 0;
	        for (k in obj) {
	            // if (obj.hasOwnProperty(k)) {} // Do this inside callback if needed.
	            if (callback(obj[k], k, obj) === false) break;
	        }
	    },
	
	
	    /**
	     * Extends the given object with the specified sources.
	     * Right most source overwrites the previous.
	     * NOTE: This is not a full implementation. Use with caution.
	     * @memberof utils
	     *
	     * @param {Object} destination
	     *        Destionation Object that will be extended and holds the default
	     *        values.
	     * @param {...Object} sources
	     *        Source objects to be merged.
	     *
	     * @returns {Object} - Returns the extended object.
	     */
	    extend: function extend(destination) {
	        if (!utils.isObject(destination)) return {};
	        var key = void 0,
	            value = void 0;
	
	        for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            sources[_key - 1] = arguments[_key];
	        }
	
	        sources.forEach(function (source) {
	            for (key in source) {
	                // eslint-disable-line
	                value = source[key];
	                if (utils.isArray(value)) {
	                    destination[key] = value.concat();
	                } else if (utils.isDate(value)) {
	                    destination[key] = new Date(value);
	                } else if (utils.isFunction(value)) {
	                    // should be before object
	                    destination[key] = value;
	                } else if (utils.isObject(value)) {
	                    destination[key] = utils.extend({}, value);
	                } else {
	                    destination[key] = value;
	                }
	            }
	        });
	        return destination;
	    },
	
	
	    /**
	     * Clones the given object.
	     * NOTE: This is not a full implementation. Use with caution.
	     * @memberof utils
	     *
	     * @param {Object} obj
	     *        Target Object to be cloned.
	     * @param {Object|Array} [options]
	     *        Clone options or array of keys to be cloned.
	     *     @param {Array} [options.keys]
	     *            Keys of the properties to be cloned.
	     *     @param {Boolean} [options.own=true]
	     *            Whether to clone own properties only. This is only effective
	     *            if `keys` is not defined.
	     *
	     * @returns {Object} - Returns the cloned object.
	     */
	    clone: function clone(obj, options) {
	        if (!obj) return {};
	
	        if (utils.isArray(options)) {
	            options = { keys: options };
	        }
	        options = utils.extend({
	            keys: null,
	            own: true
	        }, options);
	
	        var include = void 0,
	            cloned = {};
	
	        utils.forIn(obj, function (value, key) {
	            include = options.keys ? options.keys.indexOf(key) >= 0 : options.own && obj.hasOwnProperty(key) || !options.own;
	            if (include) {
	                if (utils.isObject(value)) {
	                    cloned[key] = utils.clone(value, options);
	                } else {
	                    cloned[key] = value;
	                }
	            }
	        });
	        return cloned;
	    },
	
	
	    /**
	     *  Maps the values of the given object to a schema to re-structure a new
	     *  object.
	     *  @memberof utils
	     *
	     *  @param {Object} obj
	     *         Original object to be mapped.
	     *  @param {Object} schema
	     *         Schema to be used to map the object.
	     *
	     *  @returns {Object} - Mapped object.
	     */
	    mapToSchema: function mapToSchema(obj, schema) {
	        var mapped = {};
	        utils.forIn(schema, function (value, key) {
	            if (utils.isPlainObject(value)) {
	                mapped[key] = utils.mapToSchema(obj, value);
	            } else {
	                mapped[key] = obj[value];
	            }
	        });
	        return mapped;
	    },
	
	
	    // ---------------------------
	    // Misc
	    // ---------------------------
	
	    /**
	     * Safely parses the given JSON `String` into an `Object`.
	     * The only difference from `JSON.parse()` is that this method does not
	     * throw for invalid input. Instead, returns `null`.
	     * @memberof utils
	     *
	     * @param {String} str - JSON string to be parsed
	     * @returns {Object|null} - Returns the parsed `Object` or `null` if the
	     * input is invalid.
	     */
	    safeJsonParse: function safeJsonParse(str) {
	        var o = null;
	        try {
	            o = JSON.parse(str);
	        } catch (e) {}
	        return o;
	    },
	
	
	    /**
	     * Gets a timestamp that is seconds or milliseconds since midnight,
	     * January 1, 1970 UTC.
	     * @memberof utils
	     *
	     * @param {Boolean} [seconds=false]
	     *        Specifies whether seconds should be returned instead of
	     *        milliseconds.
	     *
	     * @returns {Number} - Returns seconds or milliseconds since midnight,
	     * January 1, 1970 UTC.
	     */
	    time: function time(seconds) {
	        var ts = Date.now();
	        return seconds ? parseInt(ts / 1000, 10) : ts;
	    }
	};
	
	/* harmony default export */ __webpack_exports__["default"] = (utils);
	
	/***/ })
	
	/******/ });
	});
	//# sourceMappingURL=geolocator.js.map

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * The Final Countdown for jQuery v2.2.0 (http://hilios.github.io/jQuery.countdown/)
	 * Copyright (c) 2016 Edson Hilios
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of
	 * this software and associated documentation files (the "Software"), to deal in
	 * the Software without restriction, including without limitation the rights to
	 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
	 * the Software, and to permit persons to whom the Software is furnished to do so,
	 * subject to the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
	 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
	 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
	 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	(function(factory) {
	    "use strict";
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(11) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        factory(jQuery);
	    }
	})(function($) {
	    "use strict";
	    var instances = [], matchers = [], defaultOptions = {
	        precision: 100,
	        elapse: false,
	        defer: false
	    };
	    matchers.push(/^[0-9]*$/.source);
	    matchers.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);
	    matchers.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);
	    matchers = new RegExp(matchers.join("|"));
	    function parseDateString(dateString) {
	        if (dateString instanceof Date) {
	            return dateString;
	        }
	        if (String(dateString).match(matchers)) {
	            if (String(dateString).match(/^[0-9]*$/)) {
	                dateString = Number(dateString);
	            }
	            if (String(dateString).match(/\-/)) {
	                dateString = String(dateString).replace(/\-/g, "/");
	            }
	            return new Date(dateString);
	        } else {
	            throw new Error("Couldn't cast `" + dateString + "` to a date object.");
	        }
	    }
	    var DIRECTIVE_KEY_MAP = {
	        Y: "years",
	        m: "months",
	        n: "daysToMonth",
	        d: "daysToWeek",
	        w: "weeks",
	        W: "weeksToMonth",
	        H: "hours",
	        M: "minutes",
	        S: "seconds",
	        D: "totalDays",
	        I: "totalHours",
	        N: "totalMinutes",
	        T: "totalSeconds"
	    };
	    function escapedRegExp(str) {
	        var sanitize = str.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
	        return new RegExp(sanitize);
	    }
	    function strftime(offsetObject) {
	        return function(format) {
	            var directives = format.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
	            if (directives) {
	                for (var i = 0, len = directives.length; i < len; ++i) {
	                    var directive = directives[i].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/), regexp = escapedRegExp(directive[0]), modifier = directive[1] || "", plural = directive[3] || "", value = null;
	                    directive = directive[2];
	                    if (DIRECTIVE_KEY_MAP.hasOwnProperty(directive)) {
	                        value = DIRECTIVE_KEY_MAP[directive];
	                        value = Number(offsetObject[value]);
	                    }
	                    if (value !== null) {
	                        if (modifier === "!") {
	                            value = pluralize(plural, value);
	                        }
	                        if (modifier === "") {
	                            if (value < 10) {
	                                value = "0" + value.toString();
	                            }
	                        }
	                        format = format.replace(regexp, value.toString());
	                    }
	                }
	            }
	            format = format.replace(/%%/, "%");
	            return format;
	        };
	    }
	    function pluralize(format, count) {
	        var plural = "s", singular = "";
	        if (format) {
	            format = format.replace(/(:|;|\s)/gi, "").split(/\,/);
	            if (format.length === 1) {
	                plural = format[0];
	            } else {
	                singular = format[0];
	                plural = format[1];
	            }
	        }
	        if (Math.abs(count) > 1) {
	            return plural;
	        } else {
	            return singular;
	        }
	    }
	    var Countdown = function(el, finalDate, options) {
	        this.el = el;
	        this.$el = $(el);
	        this.interval = null;
	        this.offset = {};
	        this.options = $.extend({}, defaultOptions);
	        this.instanceNumber = instances.length;
	        instances.push(this);
	        this.$el.data("countdown-instance", this.instanceNumber);
	        if (options) {
	            if (typeof options === "function") {
	                this.$el.on("update.countdown", options);
	                this.$el.on("stoped.countdown", options);
	                this.$el.on("finish.countdown", options);
	            } else {
	                this.options = $.extend({}, defaultOptions, options);
	            }
	        }
	        this.setFinalDate(finalDate);
	        if (this.options.defer === false) {
	            this.start();
	        }
	    };
	    $.extend(Countdown.prototype, {
	        start: function() {
	            if (this.interval !== null) {
	                clearInterval(this.interval);
	            }
	            var self = this;
	            this.update();
	            this.interval = setInterval(function() {
	                self.update.call(self);
	            }, this.options.precision);
	        },
	        stop: function() {
	            clearInterval(this.interval);
	            this.interval = null;
	            this.dispatchEvent("stoped");
	        },
	        toggle: function() {
	            if (this.interval) {
	                this.stop();
	            } else {
	                this.start();
	            }
	        },
	        pause: function() {
	            this.stop();
	        },
	        resume: function() {
	            this.start();
	        },
	        remove: function() {
	            this.stop.call(this);
	            instances[this.instanceNumber] = null;
	            delete this.$el.data().countdownInstance;
	        },
	        setFinalDate: function(value) {
	            this.finalDate = parseDateString(value);
	        },
	        update: function() {
	            if (this.$el.closest("html").length === 0) {
	                this.remove();
	                return;
	            }
	            var hasEventsAttached = $._data(this.el, "events") !== undefined, now = new Date(), newTotalSecsLeft;
	            newTotalSecsLeft = this.finalDate.getTime() - now.getTime();
	            newTotalSecsLeft = Math.ceil(newTotalSecsLeft / 1e3);
	            newTotalSecsLeft = !this.options.elapse && newTotalSecsLeft < 0 ? 0 : Math.abs(newTotalSecsLeft);
	            if (this.totalSecsLeft === newTotalSecsLeft || !hasEventsAttached) {
	                return;
	            } else {
	                this.totalSecsLeft = newTotalSecsLeft;
	            }
	            this.elapsed = now >= this.finalDate;
	            this.offset = {
	                seconds: this.totalSecsLeft % 60,
	                minutes: Math.floor(this.totalSecsLeft / 60) % 60,
	                hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
	                days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
	                daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
	                daysToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 % 30.4368),
	                weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
	                weeksToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7) % 4,
	                months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
	                years: Math.abs(this.finalDate.getFullYear() - now.getFullYear()),
	                totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
	                totalHours: Math.floor(this.totalSecsLeft / 60 / 60),
	                totalMinutes: Math.floor(this.totalSecsLeft / 60),
	                totalSeconds: this.totalSecsLeft
	            };
	            if (!this.options.elapse && this.totalSecsLeft === 0) {
	                this.stop();
	                this.dispatchEvent("finish");
	            } else {
	                this.dispatchEvent("update");
	            }
	        },
	        dispatchEvent: function(eventName) {
	            var event = $.Event(eventName + ".countdown");
	            event.finalDate = this.finalDate;
	            event.elapsed = this.elapsed;
	            event.offset = $.extend({}, this.offset);
	            event.strftime = strftime(this.offset);
	            this.$el.trigger(event);
	        }
	    });
	    $.fn.countdown = function() {
	        var argumentsArray = Array.prototype.slice.call(arguments, 0);
	        return this.each(function() {
	            var instanceNumber = $(this).data("countdown-instance");
	            if (instanceNumber !== undefined) {
	                var instance = instances[instanceNumber], method = argumentsArray[0];
	                if (Countdown.prototype.hasOwnProperty(method)) {
	                    instance[method].apply(instance, argumentsArray.slice(1));
	                } else if (String(method).match(/^[$A-Z_][0-9A-Z_$]*$/i) === null) {
	                    instance.setFinalDate.call(instance, method);
	                    instance.start();
	                } else {
	                    $.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi, method));
	                }
	            } else {
	                new Countdown(this, argumentsArray[0], argumentsArray[1]);
	            }
	        });
	    };
	});

/***/ },
/* 1055 */
/***/ function(module, exports) {

	module.exports = [["0","\u0000",127,"€"],["8140","丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪",5,"乲乴",9,"乿",6,"亇亊"],["8180","亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂",6,"伋伌伒",4,"伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾",4,"佄佅佇",5,"佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢"],["8240","侤侫侭侰",4,"侶",8,"俀俁係俆俇俈俉俋俌俍俒",4,"俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿",11],["8280","個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯",10,"倻倽倿偀偁偂偄偅偆偉偊偋偍偐",4,"偖偗偘偙偛偝",7,"偦",5,"偭",8,"偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎",20,"傤傦傪傫傭",4,"傳",6,"傼"],["8340","傽",17,"僐",5,"僗僘僙僛",10,"僨僩僪僫僯僰僱僲僴僶",4,"僼",9,"儈"],["8380","儉儊儌",5,"儓",13,"儢",28,"兂兇兊兌兎兏児兒兓兗兘兙兛兝",4,"兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦",4,"冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒",5],["8440","凘凙凚凜凞凟凢凣凥",5,"凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄",5,"剋剎剏剒剓剕剗剘"],["8480","剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳",9,"剾劀劃",4,"劉",6,"劑劒劔",6,"劜劤劥劦劧劮劯劰労",9,"勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務",5,"勠勡勢勣勥",10,"勱",7,"勻勼勽匁匂匃匄匇匉匊匋匌匎"],["8540","匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯",9,"匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏"],["8580","厐",4,"厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯",6,"厷厸厹厺厼厽厾叀參",4,"収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝",4,"呣呥呧呩",7,"呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡"],["8640","咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠",4,"哫哬哯哰哱哴",5,"哻哾唀唂唃唄唅唈唊",4,"唒唓唕",5,"唜唝唞唟唡唥唦"],["8680","唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋",4,"啑啒啓啔啗",4,"啝啞啟啠啢啣啨啩啫啯",5,"啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠",6,"喨",8,"喲喴営喸喺喼喿",4,"嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗",4,"嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸",4,"嗿嘂嘃嘄嘅"],["8740","嘆嘇嘊嘋嘍嘐",7,"嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀",11,"噏",4,"噕噖噚噛噝",4],["8780","噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽",7,"嚇",6,"嚐嚑嚒嚔",14,"嚤",10,"嚰",6,"嚸嚹嚺嚻嚽",12,"囋",8,"囕囖囘囙囜団囥",5,"囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國",6],["8840","園",9,"圝圞圠圡圢圤圥圦圧圫圱圲圴",4,"圼圽圿坁坃坄坅坆坈坉坋坒",4,"坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀"],["8880","垁垇垈垉垊垍",4,"垔",6,"垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹",8,"埄",6,"埌埍埐埑埓埖埗埛埜埞埡埢埣埥",7,"埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥",4,"堫",4,"報堲堳場堶",7],["8940","堾",5,"塅",6,"塎塏塐塒塓塕塖塗塙",4,"塟",5,"塦",4,"塭",16,"塿墂墄墆墇墈墊墋墌"],["8980","墍",4,"墔",4,"墛墜墝墠",7,"墪",17,"墽墾墿壀壂壃壄壆",10,"壒壓壔壖",13,"壥",5,"壭壯壱売壴壵壷壸壺",7,"夃夅夆夈",4,"夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻"],["8a40","夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛",4,"奡奣奤奦",12,"奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦"],["8a80","妧妬妭妰妱妳",5,"妺妼妽妿",6,"姇姈姉姌姍姎姏姕姖姙姛姞",4,"姤姦姧姩姪姫姭",11,"姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪",6,"娳娵娷",4,"娽娾娿婁",4,"婇婈婋",9,"婖婗婘婙婛",5],["8b40","婡婣婤婥婦婨婩婫",8,"婸婹婻婼婽婾媀",17,"媓",6,"媜",13,"媫媬"],["8b80","媭",4,"媴媶媷媹",4,"媿嫀嫃",5,"嫊嫋嫍",4,"嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬",4,"嫲",22,"嬊",11,"嬘",25,"嬳嬵嬶嬸",7,"孁",6],["8c40","孈",7,"孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏"],["8c80","寑寔",8,"寠寢寣實寧審",4,"寯寱",6,"寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧",6,"屰屲",6,"屻屼屽屾岀岃",4,"岉岊岋岎岏岒岓岕岝",4,"岤",4],["8d40","岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅",5,"峌",5,"峓",5,"峚",6,"峢峣峧峩峫峬峮峯峱",9,"峼",4],["8d80","崁崄崅崈",5,"崏",4,"崕崗崘崙崚崜崝崟",4,"崥崨崪崫崬崯",4,"崵",7,"崿",7,"嵈嵉嵍",10,"嵙嵚嵜嵞",10,"嵪嵭嵮嵰嵱嵲嵳嵵",12,"嶃",21,"嶚嶛嶜嶞嶟嶠"],["8e40","嶡",21,"嶸",12,"巆",6,"巎",12,"巜巟巠巣巤巪巬巭"],["8e80","巰巵巶巸",4,"巿帀帄帇帉帊帋帍帎帒帓帗帞",7,"帨",4,"帯帰帲",4,"帹帺帾帿幀幁幃幆",5,"幍",6,"幖",4,"幜幝幟幠幣",14,"幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨",4,"庮",4,"庴庺庻庼庽庿",6],["8f40","廆廇廈廋",5,"廔廕廗廘廙廚廜",11,"廩廫",8,"廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤"],["8f80","弨弫弬弮弰弲",6,"弻弽弾弿彁",14,"彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢",5,"復徫徬徯",5,"徶徸徹徺徻徾",4,"忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇"],["9040","怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰",4,"怶",4,"怽怾恀恄",6,"恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀"],["9080","悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽",7,"惇惈惉惌",4,"惒惓惔惖惗惙惛惞惡",4,"惪惱惲惵惷惸惻",4,"愂愃愄愅愇愊愋愌愐",4,"愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬",18,"慀",6],["9140","慇慉態慍慏慐慒慓慔慖",6,"慞慟慠慡慣慤慥慦慩",6,"慱慲慳慴慶慸",18,"憌憍憏",4,"憕"],["9180","憖",6,"憞",8,"憪憫憭",9,"憸",5,"憿懀懁懃",4,"應懌",4,"懓懕",16,"懧",13,"懶",8,"戀",5,"戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸",4,"扂扄扅扆扊"],["9240","扏扐払扖扗扙扚扜",6,"扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋",5,"抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁"],["9280","拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳",5,"挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖",7,"捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙",6,"採掤掦掫掯掱掲掵掶掹掻掽掿揀"],["9340","揁揂揃揅揇揈揊揋揌揑揓揔揕揗",6,"揟揢揤",4,"揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆",4,"損搎搑搒搕",5,"搝搟搢搣搤"],["9380","搥搧搨搩搫搮",5,"搵",4,"搻搼搾摀摂摃摉摋",6,"摓摕摖摗摙",4,"摟",7,"摨摪摫摬摮",9,"摻",6,"撃撆撈",8,"撓撔撗撘撚撛撜撝撟",4,"撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆",6,"擏擑擓擔擕擖擙據"],["9440","擛擜擝擟擠擡擣擥擧",24,"攁",7,"攊",7,"攓",4,"攙",8],["9480","攢攣攤攦",4,"攬攭攰攱攲攳攷攺攼攽敀",4,"敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數",14,"斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱",7,"斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘",7,"旡旣旤旪旫"],["9540","旲旳旴旵旸旹旻",4,"昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷",4,"昽昿晀時晄",6,"晍晎晐晑晘"],["9580","晙晛晜晝晞晠晢晣晥晧晩",4,"晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘",4,"暞",8,"暩",4,"暯",4,"暵暶暷暸暺暻暼暽暿",25,"曚曞",7,"曧曨曪",5,"曱曵曶書曺曻曽朁朂會"],["9640","朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠",5,"朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗",4,"杝杢杣杤杦杧杫杬杮東杴杶"],["9680","杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹",7,"柂柅",9,"柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵",7,"柾栁栂栃栄栆栍栐栒栔栕栘",4,"栞栟栠栢",6,"栫",6,"栴栵栶栺栻栿桇桋桍桏桒桖",5],["9740","桜桝桞桟桪桬",7,"桵桸",8,"梂梄梇",7,"梐梑梒梔梕梖梘",9,"梣梤梥梩梪梫梬梮梱梲梴梶梷梸"],["9780","梹",6,"棁棃",5,"棊棌棎棏棐棑棓棔棖棗棙棛",4,"棡棢棤",9,"棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆",4,"椌椏椑椓",11,"椡椢椣椥",7,"椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃",16,"楕楖楘楙楛楜楟"],["9840","楡楢楤楥楧楨楩楪楬業楯楰楲",4,"楺楻楽楾楿榁榃榅榊榋榌榎",5,"榖榗榙榚榝",9,"榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽"],["9880","榾榿槀槂",7,"構槍槏槑槒槓槕",5,"槜槝槞槡",11,"槮槯槰槱槳",9,"槾樀",9,"樋",11,"標",5,"樠樢",5,"権樫樬樭樮樰樲樳樴樶",6,"樿",4,"橅橆橈",7,"橑",6,"橚"],["9940","橜",4,"橢橣橤橦",10,"橲",6,"橺橻橽橾橿檁檂檃檅",8,"檏檒",4,"檘",7,"檡",5],["9980","檧檨檪檭",114,"欥欦欨",6],["9a40","欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍",11,"歚",7,"歨歩歫",13,"歺歽歾歿殀殅殈"],["9a80","殌殎殏殐殑殔殕殗殘殙殜",4,"殢",7,"殫",7,"殶殸",6,"毀毃毄毆",4,"毌毎毐毑毘毚毜",4,"毢",7,"毬毭毮毰毱毲毴毶毷毸毺毻毼毾",6,"氈",4,"氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋",4,"汑汒汓汖汘"],["9b40","汙汚汢汣汥汦汧汫",4,"汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘"],["9b80","泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟",5,"洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽",4,"涃涄涆涇涊涋涍涏涐涒涖",4,"涜涢涥涬涭涰涱涳涴涶涷涹",5,"淁淂淃淈淉淊"],["9c40","淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽",7,"渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵"],["9c80","渶渷渹渻",7,"湅",7,"湏湐湑湒湕湗湙湚湜湝湞湠",10,"湬湭湯",14,"満溁溂溄溇溈溊",4,"溑",6,"溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪",5],["9d40","滰滱滲滳滵滶滷滸滺",7,"漃漄漅漇漈漊",4,"漐漑漒漖",9,"漡漢漣漥漦漧漨漬漮漰漲漴漵漷",6,"漿潀潁潂"],["9d80","潃潄潅潈潉潊潌潎",9,"潙潚潛潝潟潠潡潣潤潥潧",5,"潯潰潱潳潵潶潷潹潻潽",6,"澅澆澇澊澋澏",12,"澝澞澟澠澢",4,"澨",10,"澴澵澷澸澺",5,"濁濃",5,"濊",6,"濓",10,"濟濢濣濤濥"],["9e40","濦",7,"濰",32,"瀒",7,"瀜",6,"瀤",6],["9e80","瀫",9,"瀶瀷瀸瀺",17,"灍灎灐",13,"灟",11,"灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞",12,"炰炲炴炵炶為炾炿烄烅烆烇烉烋",12,"烚"],["9f40","烜烝烞烠烡烢烣烥烪烮烰",6,"烸烺烻烼烾",10,"焋",4,"焑焒焔焗焛",10,"焧",7,"焲焳焴"],["9f80","焵焷",13,"煆煇煈煉煋煍煏",12,"煝煟",4,"煥煩",4,"煯煰煱煴煵煶煷煹煻煼煾",5,"熅",4,"熋熌熍熎熐熑熒熓熕熖熗熚",4,"熡",6,"熩熪熫熭",5,"熴熶熷熸熺",8,"燄",9,"燏",4],["a040","燖",9,"燡燢燣燤燦燨",5,"燯",9,"燺",11,"爇",19],["a080","爛爜爞",9,"爩爫爭爮爯爲爳爴爺爼爾牀",6,"牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅",4,"犌犎犐犑犓",11,"犠",11,"犮犱犲犳犵犺",6,"狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛"],["a1a1","　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈",7,"〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓"],["a2a1","ⅰ",9],["a2b1","⒈",19,"⑴",19,"①",9],["a2e5","㈠",9],["a2f1","Ⅰ",11],["a3a1","！＂＃￥％",88,"￣"],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a6e0","︵︶︹︺︿﹀︽︾﹁﹂﹃﹄"],["a6ee","︻︼︷︸︱"],["a6f4","︳︴"],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a840","ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═",35,"▁",6],["a880","█",7,"▓▔▕▼▽◢◣◤◥☉⊕〒〝〞"],["a8a1","āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ"],["a8bd","ńň"],["a8c0","ɡ"],["a8c5","ㄅ",36],["a940","〡",8,"㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤"],["a959","℡㈱"],["a95c","‐"],["a960","ー゛゜ヽヾ〆ゝゞ﹉",9,"﹔﹕﹖﹗﹙",8],["a980","﹢",4,"﹨﹩﹪﹫"],["a996","〇"],["a9a4","─",75],["aa40","狜狝狟狢",5,"狪狫狵狶狹狽狾狿猀猂猄",5,"猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀",8],["aa80","獉獊獋獌獎獏獑獓獔獕獖獘",7,"獡",10,"獮獰獱"],["ab40","獲",11,"獿",4,"玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣",5,"玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃",4],["ab80","珋珌珎珒",6,"珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳",4],["ac40","珸",10,"琄琇琈琋琌琍琎琑",8,"琜",5,"琣琤琧琩琫琭琯琱琲琷",4,"琽琾琿瑀瑂",11],["ac80","瑎",6,"瑖瑘瑝瑠",12,"瑮瑯瑱",4,"瑸瑹瑺"],["ad40","瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑",10,"璝璟",7,"璪",15,"璻",12],["ad80","瓈",9,"瓓",8,"瓝瓟瓡瓥瓧",6,"瓰瓱瓲"],["ae40","瓳瓵瓸",6,"甀甁甂甃甅",7,"甎甐甒甔甕甖甗甛甝甞甠",4,"甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘"],["ae80","畝",7,"畧畨畩畫",6,"畳畵當畷畺",4,"疀疁疂疄疅疇"],["af40","疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦",4,"疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇"],["af80","瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄"],["b040","癅",6,"癎",5,"癕癗",4,"癝癟癠癡癢癤",6,"癬癭癮癰",7,"癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛"],["b080","皜",7,"皥",8,"皯皰皳皵",9,"盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥"],["b140","盄盇盉盋盌盓盕盙盚盜盝盞盠",4,"盦",7,"盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎",10,"眛眜眝眞眡眣眤眥眧眪眫"],["b180","眬眮眰",4,"眹眻眽眾眿睂睄睅睆睈",7,"睒",7,"睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳"],["b240","睝睞睟睠睤睧睩睪睭",11,"睺睻睼瞁瞂瞃瞆",5,"瞏瞐瞓",11,"瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶",4],["b280","瞼瞾矀",12,"矎",8,"矘矙矚矝",4,"矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖"],["b340","矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃",5,"砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚"],["b380","硛硜硞",11,"硯",7,"硸硹硺硻硽",6,"场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚"],["b440","碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨",7,"碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚",9],["b480","磤磥磦磧磩磪磫磭",4,"磳磵磶磸磹磻",5,"礂礃礄礆",6,"础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮"],["b540","礍",5,"礔",9,"礟",4,"礥",14,"礵",4,"礽礿祂祃祄祅祇祊",8,"祔祕祘祙祡祣"],["b580","祤祦祩祪祫祬祮祰",6,"祹祻",4,"禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠"],["b640","禓",6,"禛",11,"禨",10,"禴",4,"禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙",5,"秠秡秢秥秨秪"],["b680","秬秮秱",6,"秹秺秼秾秿稁稄稅稇稈稉稊稌稏",4,"稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二"],["b740","稝稟稡稢稤",14,"稴稵稶稸稺稾穀",5,"穇",9,"穒",4,"穘",16],["b780","穩",6,"穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服"],["b840","窣窤窧窩窪窫窮",4,"窴",10,"竀",10,"竌",9,"竗竘竚竛竜竝竡竢竤竧",5,"竮竰竱竲竳"],["b880","竴",4,"竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹"],["b940","笯笰笲笴笵笶笷笹笻笽笿",5,"筆筈筊筍筎筓筕筗筙筜筞筟筡筣",10,"筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆",6,"箎箏"],["b980","箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹",7,"篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈"],["ba40","篅篈築篊篋篍篎篏篐篒篔",4,"篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲",4,"篸篹篺篻篽篿",7,"簈簉簊簍簎簐",5,"簗簘簙"],["ba80","簚",4,"簠",5,"簨簩簫",12,"簹",5,"籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖"],["bb40","籃",9,"籎",36,"籵",5,"籾",9],["bb80","粈粊",6,"粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴",4,"粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕"],["bc40","粿糀糂糃糄糆糉糋糎",6,"糘糚糛糝糞糡",6,"糩",5,"糰",7,"糹糺糼",13,"紋",5],["bc80","紑",14,"紡紣紤紥紦紨紩紪紬紭紮細",6,"肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件"],["bd40","紷",54,"絯",7],["bd80","絸",32,"健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸"],["be40","継",12,"綧",6,"綯",42],["be80","線",32,"尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻"],["bf40","緻",62],["bf80","縺縼",4,"繂",4,"繈",21,"俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀"],["c040","繞",35,"纃",23,"纜纝纞"],["c080","纮纴纻纼绖绤绬绹缊缐缞缷缹缻",6,"罃罆",9,"罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐"],["c140","罖罙罛罜罝罞罠罣",4,"罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂",7,"羋羍羏",4,"羕",4,"羛羜羠羢羣羥羦羨",6,"羱"],["c180","羳",4,"羺羻羾翀翂翃翄翆翇翈翉翋翍翏",4,"翖翗翙",5,"翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿"],["c240","翤翧翨翪翫翬翭翯翲翴",6,"翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫",5,"耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗"],["c280","聙聛",13,"聫",5,"聲",11,"隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫"],["c340","聾肁肂肅肈肊肍",5,"肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇",4,"胏",6,"胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋"],["c380","脌脕脗脙脛脜脝脟",12,"脭脮脰脳脴脵脷脹",4,"脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸"],["c440","腀",5,"腇腉腍腎腏腒腖腗腘腛",4,"腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃",4,"膉膋膌膍膎膐膒",5,"膙膚膞",4,"膤膥"],["c480","膧膩膫",7,"膴",5,"膼膽膾膿臄臅臇臈臉臋臍",6,"摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁"],["c540","臔",14,"臤臥臦臨臩臫臮",4,"臵",5,"臽臿舃與",4,"舎舏舑舓舕",5,"舝舠舤舥舦舧舩舮舲舺舼舽舿"],["c580","艀艁艂艃艅艆艈艊艌艍艎艐",7,"艙艛艜艝艞艠",7,"艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗"],["c640","艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸"],["c680","苺苼",4,"茊茋茍茐茒茓茖茘茙茝",9,"茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐"],["c740","茾茿荁荂荄荅荈荊",4,"荓荕",4,"荝荢荰",6,"荹荺荾",6,"莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡",6,"莬莭莮"],["c780","莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠"],["c840","菮華菳",4,"菺菻菼菾菿萀萂萅萇萈萉萊萐萒",5,"萙萚萛萞",5,"萩",7,"萲",5,"萹萺萻萾",7,"葇葈葉"],["c880","葊",6,"葒",4,"葘葝葞葟葠葢葤",4,"葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁"],["c940","葽",4,"蒃蒄蒅蒆蒊蒍蒏",7,"蒘蒚蒛蒝蒞蒟蒠蒢",12,"蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗"],["c980","蓘",4,"蓞蓡蓢蓤蓧",4,"蓭蓮蓯蓱",10,"蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳"],["ca40","蔃",8,"蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢",8,"蔭",9,"蔾",4,"蕄蕅蕆蕇蕋",10],["ca80","蕗蕘蕚蕛蕜蕝蕟",4,"蕥蕦蕧蕩",8,"蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱"],["cb40","薂薃薆薈",6,"薐",10,"薝",6,"薥薦薧薩薫薬薭薱",5,"薸薺",6,"藂",6,"藊",4,"藑藒"],["cb80","藔藖",5,"藝",6,"藥藦藧藨藪",14,"恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔"],["cc40","藹藺藼藽藾蘀",4,"蘆",10,"蘒蘓蘔蘕蘗",15,"蘨蘪",13,"蘹蘺蘻蘽蘾蘿虀"],["cc80","虁",11,"虒虓處",4,"虛虜虝號虠虡虣",7,"獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃"],["cd40","虭虯虰虲",6,"蚃",6,"蚎",4,"蚔蚖",5,"蚞",4,"蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻",4,"蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜"],["cd80","蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威"],["ce40","蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀",6,"蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚",5,"蝡蝢蝦",7,"蝯蝱蝲蝳蝵"],["ce80","蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎",4,"螔螕螖螘",6,"螠",4,"巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺"],["cf40","螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁",4,"蟇蟈蟉蟌",4,"蟔",6,"蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯",9],["cf80","蟺蟻蟼蟽蟿蠀蠁蠂蠄",5,"蠋",7,"蠔蠗蠘蠙蠚蠜",4,"蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓"],["d040","蠤",13,"蠳",5,"蠺蠻蠽蠾蠿衁衂衃衆",5,"衎",5,"衕衖衘衚",6,"衦衧衪衭衯衱衳衴衵衶衸衹衺"],["d080","衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗",4,"袝",4,"袣袥",5,"小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄"],["d140","袬袮袯袰袲",4,"袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚",4,"裠裡裦裧裩",6,"裲裵裶裷裺裻製裿褀褁褃",5],["d180","褉褋",4,"褑褔",4,"褜",4,"褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶"],["d240","褸",8,"襂襃襅",24,"襠",5,"襧",19,"襼"],["d280","襽襾覀覂覄覅覇",26,"摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐"],["d340","覢",30,"觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴",6],["d380","觻",4,"訁",5,"計",21,"印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉"],["d440","訞",31,"訿",8,"詉",21],["d480","詟",25,"詺",6,"浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧"],["d540","誁",7,"誋",7,"誔",46],["d580","諃",32,"铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政"],["d640","諤",34,"謈",27],["d680","謤謥謧",30,"帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑"],["d740","譆",31,"譧",4,"譭",25],["d780","讇",24,"讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座"],["d840","谸",8,"豂豃豄豅豈豊豋豍",7,"豖豗豘豙豛",5,"豣",6,"豬",6,"豴豵豶豷豻",6,"貃貄貆貇"],["d880","貈貋貍",6,"貕貖貗貙",20,"亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝"],["d940","貮",62],["d980","賭",32,"佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼"],["da40","贎",14,"贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸",8,"趂趃趆趇趈趉趌",4,"趒趓趕",9,"趠趡"],["da80","趢趤",12,"趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺"],["db40","跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾",6,"踆踇踈踋踍踎踐踑踒踓踕",7,"踠踡踤",4,"踫踭踰踲踳踴踶踷踸踻踼踾"],["db80","踿蹃蹅蹆蹌",4,"蹓",5,"蹚",11,"蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝"],["dc40","蹳蹵蹷",4,"蹽蹾躀躂躃躄躆躈",6,"躑躒躓躕",6,"躝躟",11,"躭躮躰躱躳",6,"躻",7],["dc80","軃",10,"軏",21,"堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥"],["dd40","軥",62],["dd80","輤",32,"荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺"],["de40","轅",32,"轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆"],["de80","迉",4,"迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖"],["df40","這逜連逤逥逧",5,"逰",4,"逷逹逺逽逿遀遃遅遆遈",4,"過達違遖遙遚遜",5,"遤遦遧適遪遫遬遯",4,"遶",6,"遾邁"],["df80","還邅邆邇邉邊邌",4,"邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼"],["e040","郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅",19,"鄚鄛鄜"],["e080","鄝鄟鄠鄡鄤",10,"鄰鄲",6,"鄺",8,"酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼"],["e140","酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀",4,"醆醈醊醎醏醓",6,"醜",5,"醤",5,"醫醬醰醱醲醳醶醷醸醹醻"],["e180","醼",10,"釈釋釐釒",9,"針",8,"帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺"],["e240","釦",62],["e280","鈥",32,"狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧",5,"饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂"],["e340","鉆",45,"鉵",16],["e380","銆",7,"銏",24,"恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾"],["e440","銨",5,"銯",24,"鋉",31],["e480","鋩",32,"洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑"],["e540","錊",51,"錿",10],["e580","鍊",31,"鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣"],["e640","鍬",34,"鎐",27],["e680","鎬",29,"鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩"],["e740","鏎",7,"鏗",54],["e780","鐎",32,"纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡",6,"缪缫缬缭缯",4,"缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬"],["e840","鐯",14,"鐿",43,"鑬鑭鑮鑯"],["e880","鑰",20,"钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹"],["e940","锧锳锽镃镈镋镕镚镠镮镴镵長",7,"門",42],["e980","閫",32,"椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋"],["ea40","闌",27,"闬闿阇阓阘阛阞阠阣",6,"阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗"],["ea80","陘陙陚陜陝陞陠陣陥陦陫陭",4,"陳陸",12,"隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰"],["eb40","隌階隑隒隓隕隖隚際隝",9,"隨",7,"隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖",9,"雡",6,"雫"],["eb80","雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗",4,"霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻"],["ec40","霡",8,"霫霬霮霯霱霳",4,"霺霻霼霽霿",18,"靔靕靗靘靚靜靝靟靣靤靦靧靨靪",7],["ec80","靲靵靷",4,"靽",7,"鞆",4,"鞌鞎鞏鞐鞓鞕鞖鞗鞙",4,"臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐"],["ed40","鞞鞟鞡鞢鞤",6,"鞬鞮鞰鞱鞳鞵",46],["ed80","韤韥韨韮",4,"韴韷",23,"怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨"],["ee40","頏",62],["ee80","顎",32,"睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶",4,"钼钽钿铄铈",6,"铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪"],["ef40","顯",5,"颋颎颒颕颙颣風",37,"飏飐飔飖飗飛飜飝飠",4],["ef80","飥飦飩",30,"铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒",4,"锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤",8,"镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔"],["f040","餈",4,"餎餏餑",28,"餯",26],["f080","饊",9,"饖",12,"饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨",4,"鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦",6,"鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙"],["f140","馌馎馚",10,"馦馧馩",47],["f180","駙",32,"瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃"],["f240","駺",62],["f280","騹",32,"颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒"],["f340","驚",17,"驲骃骉骍骎骔骕骙骦骩",6,"骲骳骴骵骹骻骽骾骿髃髄髆",4,"髍髎髏髐髒體髕髖髗髙髚髛髜"],["f380","髝髞髠髢髣髤髥髧髨髩髪髬髮髰",8,"髺髼",6,"鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋"],["f440","鬇鬉",5,"鬐鬑鬒鬔",10,"鬠鬡鬢鬤",10,"鬰鬱鬳",7,"鬽鬾鬿魀魆魊魋魌魎魐魒魓魕",5],["f480","魛",32,"簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤"],["f540","魼",62],["f580","鮻",32,"酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜"],["f640","鯜",62],["f680","鰛",32,"觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅",5,"龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞",5,"鲥",4,"鲫鲭鲮鲰",7,"鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋"],["f740","鰼",62],["f780","鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾",4,"鳈鳉鳑鳒鳚鳛鳠鳡鳌",4,"鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄"],["f840","鳣",62],["f880","鴢",32],["f940","鵃",62],["f980","鶂",32],["fa40","鶣",62],["fa80","鷢",32],["fb40","鸃",27,"鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴",9,"麀"],["fb80","麁麃麄麅麆麉麊麌",5,"麔",8,"麞麠",5,"麧麨麩麪"],["fc40","麫",8,"麵麶麷麹麺麼麿",4,"黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰",8,"黺黽黿",6],["fc80","鼆",4,"鼌鼏鼑鼒鼔鼕鼖鼘鼚",5,"鼡鼣",8,"鼭鼮鼰鼱"],["fd40","鼲",4,"鼸鼺鼼鼿",4,"齅",10,"齒",38],["fd80","齹",5,"龁龂龍",11,"龜龝龞龡",4,"郎凉秊裏隣"],["fe40","兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩"]]

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariantLocation = __webpack_require__(1057);
	
	/**
	 * Format waypionts in a way that's friendly to the directions and surface
	 * API: comma-separated latitude, longitude pairs with semicolons between
	 * them.
	 * @private
	 * @param {Array<Object>} waypoints array of objects with latitude and longitude
	 * properties
	 * @returns {string} formatted points
	 * @throws {Error} if the input is invalid
	 */
	function formatPoints(waypoints) {
	  return waypoints.map(function(location) {
	    invariantLocation(location);
	    return location.longitude + ',' + location.latitude;
	  }).join(';');
	}
	
	module.exports = formatPoints;


/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(245);
	
	/**
	 * Given an object that should be a location, ensure that it has
	 * valid numeric longitude & latitude properties
	 *
	 * @param {Object} location object with longitude and latitude values
	 * @throws {AssertError} if the object is not a valid location
	 * @returns {undefined} nothing
	 * @private
	 */
	function invariantLocation(location) {
	  invariant(typeof location.latitude === 'number' &&
	    typeof location.longitude === 'number',
	    'location must be an object with numeric latitude & longitude properties');
	  if (location.zoom !== undefined) {
	    invariant(typeof location.zoom === 'number', 'zoom must be numeric');
	  }
	}
	
	module.exports = invariantLocation;


/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	// Installs ES6 Promise polyfill if a native Promise is not available
	
	if (typeof Promise === 'undefined') {
	  __webpack_require__(1332).polyfill();
	}
	
	module.export = Promise;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(671)(module)))

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = pointer
	
	pointer.available = available
	
	var EE = __webpack_require__(932).EventEmitter
	  , Stream = __webpack_require__(345).Stream
	
	function available() {
	  return !!shim(document.body)
	}
	
	function pointer(el) {
	  var ael = el.addEventListener || el.attachEvent
	    , rel = el.removeEventListener || el.detachEvent
	    , doc = el.ownerDocument
	    , body = doc.body
	    , rpl = shim(el) 
	    , out = {dx: 0, dy: 0, dt: 0}
	    , ee = new EE
	    , stream = null
	    , lastPageX, lastPageY
	    , needsFullscreen = false
	    , mouseDownMS
	
	  ael.call(el, 'mousedown', onmousedown, false)
	  ael.call(el, 'mouseup', onmouseup, false)
	  ael.call(body, 'mousemove', onmove, false)
	
	  var vendors = ['', 'webkit', 'moz', 'ms', 'o']
	
	  for(var i = 0, len = vendors.length; i < len; ++i) {
	    ael.call(doc, vendors[i]+'pointerlockchange', onpointerlockchange)
	    ael.call(doc, vendors[i]+'pointerlockerror', onpointerlockerror)
	  }
	
	  ee.release = release
	  ee.target = pointerlockelement
	  ee.request = onmousedown
	  ee.destroy = function() {
	    rel.call(el, 'mouseup', onmouseup, false)
	    rel.call(el, 'mousedown', onmousedown, false)
	    rel.call(el, 'mousemove', onmove, false)
	  }
	
	  if(!shim) {
	    setTimeout(function() {
	      ee.emit('error', new Error('pointer lock is not supported'))
	    }, 0)
	  }
	  return ee
	
	  function onmousedown(ev) {
	    if(pointerlockelement()) {
	      return
	    }
	    mouseDownMS = +new Date
	    rpl.call(el)
	  }
	
	  function onmouseup(ev) {
	    if(!needsFullscreen) {
	      return
	    }
	
	    ee.emit('needs-fullscreen')
	    needsFullscreen = false
	  }
	
	  function onpointerlockchange(ev) {
	    if(!pointerlockelement()) {
	      if(stream) release()
	      return
	    }
	
	    stream = new Stream
	    stream.readable = true
	    stream.initial = {x: lastPageX, y: lastPageY, t: Date.now()}
	
	    ee.emit('attain', stream)
	  }
	
	  function onpointerlockerror(ev) {
	    var dt = +(new Date) - mouseDownMS
	    if(dt < 100) {
	      // we errored immediately, we need to do fullscreen first.
	      needsFullscreen = true
	      return
	    }
	
	    ee.emit('error')
	    if(stream) {
	      stream.emit('error', ev)
	    }
	    stream = null
	  }
	
	  function release() {
	    ee.emit('release')
	
	    if(stream) {
	      stream.emit('end')
	      stream.readable = false
	      stream.emit('close')
	      stream = null
	    }
	
	    var pel = pointerlockelement()
	    if(!pel) {
	      return
	    }
	
	    (doc.exitPointerLock ||
	    doc.mozExitPointerLock ||
	    doc.webkitExitPointerLock ||
	    doc.msExitPointerLock ||
	    doc.oExitPointerLock).call(doc)
	  }
	
	  function onmove(ev) {
	    lastPageX = ev.pageX
	    lastPageY = ev.pageY
	
	    if(!stream) return
	
	    // we're reusing a single object
	    // because I'd like to avoid piling up
	    // a ton of objects for the garbage
	    // collector.
	    out.dx =
	      ev.movementX || ev.webkitMovementX ||
	      ev.mozMovementX || ev.msMovementX ||
	      ev.oMovementX || 0
	
	    out.dy = 
	      ev.movementY || ev.webkitMovementY ||
	      ev.mozMovementY || ev.msMovementY ||
	      ev.oMovementY || 0
	
	    out.dt = Date.now() - stream.initial.t
	
	    ee.emit('data', out)
	    stream.emit('data', out)
	  }
	
	  function pointerlockelement() {
	    return 0 ||
	      doc.pointerLockElement ||
	      doc.mozPointerLockElement ||
	      doc.webkitPointerLockElement ||
	      doc.msPointerLockElement ||
	      doc.oPointerLockElement ||
	      null
	  }
	}
	
	function shim(el) {
	  return el.requestPointerLock ||
	    el.webkitRequestPointerLock ||
	    el.mozRequestPointerLock ||
	    el.msRequestPointerLock ||
	    el.oRequestPointerLock ||
	    null
	}


/***/ },
/* 1060 */
/***/ function(module, exports) {

	/*
	 * Copyright 2014-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	/**
	 * Add common helper methods to a client impl
	 *
	 * @param {function} impl the client implementation
	 * @param {Client} [target] target of this client, used when wrapping other clients
	 * @returns {Client} the client impl with additional methods
	 */
	module.exports = function client(impl, target) {
	
		if (target) {
	
			/**
			 * @returns {Client} the target client
			 */
			impl.skip = function skip() {
				return target;
			};
	
		}
	
		/**
		 * Allow a client to easily be wrapped by an interceptor
		 *
		 * @param {Interceptor} interceptor the interceptor to wrap this client with
		 * @param [config] configuration for the interceptor
		 * @returns {Client} the newly wrapped client
		 */
		impl.wrap = function wrap(interceptor, config) {
			return interceptor(impl, config);
		};
	
		/**
		 * @deprecated
		 */
		impl.chain = function chain() {
			if (typeof console !== 'undefined') {
				console.log('rest.js: client.chain() is deprecated, use client.wrap() instead');
			}
	
			return impl.wrap.apply(this, arguments);
		};
	
		return impl;
	
	};


/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2014-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	/*jshint latedef: nofunc */
	
	var normalizeHeaderName = __webpack_require__(1487);
	
	function property(promise, name) {
		return promise.then(
			function (value) {
				return value && value[name];
			},
			function (value) {
				return Promise.reject(value && value[name]);
			}
		);
	}
	
	/**
	 * Obtain the response entity
	 *
	 * @returns {Promise} for the response entity
	 */
	function entity() {
		/*jshint validthis:true */
		return property(this, 'entity');
	}
	
	/**
	 * Obtain the response status
	 *
	 * @returns {Promise} for the response status
	 */
	function status() {
		/*jshint validthis:true */
		return property(property(this, 'status'), 'code');
	}
	
	/**
	 * Obtain the response headers map
	 *
	 * @returns {Promise} for the response headers map
	 */
	function headers() {
		/*jshint validthis:true */
		return property(this, 'headers');
	}
	
	/**
	 * Obtain a specific response header
	 *
	 * @param {String} headerName the header to retrieve
	 * @returns {Promise} for the response header's value
	 */
	function header(headerName) {
		/*jshint validthis:true */
		headerName = normalizeHeaderName(headerName);
		return property(this.headers(), headerName);
	}
	
	/**
	 * Follow a related resource
	 *
	 * The relationship to follow may be define as a plain string, an object
	 * with the rel and params, or an array containing one or more entries
	 * with the previous forms.
	 *
	 * Examples:
	 *   response.follow('next')
	 *
	 *   response.follow({ rel: 'next', params: { pageSize: 100 } })
	 *
	 *   response.follow([
	 *       { rel: 'items', params: { projection: 'noImages' } },
	 *       'search',
	 *       { rel: 'findByGalleryIsNull', params: { projection: 'noImages' } },
	 *       'items'
	 *   ])
	 *
	 * @param {String|Object|Array} rels one, or more, relationships to follow
	 * @returns ResponsePromise<Response> related resource
	 */
	function follow(rels) {
		/*jshint validthis:true */
		rels = [].concat(rels);
	
		return make(rels.reduce(function (response, rel) {
			return response.then(function (response) {
				if (typeof rel === 'string') {
					rel = { rel: rel };
				}
				if (typeof response.entity.clientFor !== 'function') {
					throw new Error('Hypermedia response expected');
				}
				var client = response.entity.clientFor(rel.rel);
				return client({ params: rel.params });
			});
		}, this));
	}
	
	/**
	 * Wrap a Promise as an ResponsePromise
	 *
	 * @param {Promise<Response>} promise the promise for an HTTP Response
	 * @returns {ResponsePromise<Response>} wrapped promise for Response with additional helper methods
	 */
	function make(promise) {
		promise.status = status;
		promise.headers = headers;
		promise.header = header;
		promise.entity = entity;
		promise.follow = follow;
		return promise;
	}
	
	function responsePromise(obj, callback, errback) {
		return make(Promise.resolve(obj).then(callback, errback));
	}
	
	responsePromise.make = make;
	responsePromise.reject = function (val) {
		return make(Promise.reject(val));
	};
	responsePromise.promise = function (func) {
		return make(new Promise(func));
	};
	
	module.exports = responsePromise;


/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2015-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var uriEncoder, operations, prefixRE;
	
	uriEncoder = __webpack_require__(1863);
	
	prefixRE = /^([^:]*):([0-9]+)$/;
	operations = {
		'':  { first: '',  separator: ',', named: false, empty: '',  encoder: uriEncoder.encode },
		'+': { first: '',  separator: ',', named: false, empty: '',  encoder: uriEncoder.encodeURL },
		'#': { first: '#', separator: ',', named: false, empty: '',  encoder: uriEncoder.encodeURL },
		'.': { first: '.', separator: '.', named: false, empty: '',  encoder: uriEncoder.encode },
		'/': { first: '/', separator: '/', named: false, empty: '',  encoder: uriEncoder.encode },
		';': { first: ';', separator: ';', named: true,  empty: '',  encoder: uriEncoder.encode },
		'?': { first: '?', separator: '&', named: true,  empty: '=', encoder: uriEncoder.encode },
		'&': { first: '&', separator: '&', named: true,  empty: '=', encoder: uriEncoder.encode },
		'=': { reserved: true },
		',': { reserved: true },
		'!': { reserved: true },
		'@': { reserved: true },
		'|': { reserved: true }
	};
	
	function apply(operation, expression, params) {
		/*jshint maxcomplexity:11 */
		return expression.split(',').reduce(function (result, variable) {
			var opts, value;
	
			opts = {};
			if (variable.slice(-1) === '*') {
				variable = variable.slice(0, -1);
				opts.explode = true;
			}
			if (prefixRE.test(variable)) {
				var prefix = prefixRE.exec(variable);
				variable = prefix[1];
				opts.maxLength = parseInt(prefix[2]);
			}
	
			variable = uriEncoder.decode(variable);
			value = params[variable];
	
			if (value === void 0 || value === null) {
				return result;
			}
			if (Array.isArray(value)) {
				result = value.reduce(function (result, value) {
					if (result.length) {
						result += opts.explode ? operation.separator : ',';
						if (operation.named && opts.explode) {
							result += operation.encoder(variable);
							result += value.length ? '=' : operation.empty;
						}
					}
					else {
						result += operation.first;
						if (operation.named) {
							result += operation.encoder(variable);
							result += value.length ? '=' : operation.empty;
						}
					}
					result += operation.encoder(value);
					return result;
				}, result);
			}
			else if (typeof value === 'object') {
				result = Object.keys(value).reduce(function (result, name) {
					if (result.length) {
						result += opts.explode ? operation.separator : ',';
					}
					else {
						result += operation.first;
						if (operation.named && !opts.explode) {
							result += operation.encoder(variable);
							result += value[name].length ? '=' : operation.empty;
						}
					}
					result += operation.encoder(name);
					result += opts.explode ? '=' : ',';
					result += operation.encoder(value[name]);
					return result;
				}, result);
			}
			else {
				value = String(value);
				if (opts.maxLength) {
					value = value.slice(0, opts.maxLength);
				}
				result += result.length ? operation.separator : operation.first;
				if (operation.named) {
					result += operation.encoder(variable);
					result += value.length ? '=' : operation.empty;
				}
				result += operation.encoder(value);
			}
	
			return result;
		}, '');
	}
	
	function expandExpression(expression, params) {
		var operation;
	
		operation = operations[expression.slice(0,1)];
		if (operation) {
			expression = expression.slice(1);
		}
		else {
			operation = operations[''];
		}
	
		if (operation.reserved) {
			throw new Error('Reserved expression operations are not supported');
		}
	
		return apply(operation, expression, params);
	}
	
	function expandTemplate(template, params) {
		var start, end, uri;
	
		uri = '';
		end = 0;
		while (true) {
			start = template.indexOf('{', end);
			if (start === -1) {
				// no more expressions
				uri += template.slice(end);
				break;
			}
			uri += template.slice(end, start);
			end = template.indexOf('}', start) + 1;
			uri += expandExpression(template.slice(start + 1, end - 1), params);
		}
	
		return uri;
	}
	
	module.exports = {
	
		/**
		 * Expand a URI Template with parameters to form a URI.
		 *
		 * Full implementation (level 4) of rfc6570.
		 * @see https://tools.ietf.org/html/rfc6570
		 *
		 * @param {string} template URI template
		 * @param {Object} [params] params to apply to the template durring expantion
		 * @returns {string} expanded URI
		 */
		expand: expandTemplate
	
	};


/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(586);
	
	/*<replacement>*/
	var util = __webpack_require__(754);
	util.inherits = __webpack_require__(406);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	
	function TransformState(options, stream) {
	  this.afterTransform = function(er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb)
	    return stream.emit('error', new Error('no writecb in Transform class'));
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (!util.isNullOrUndefined(data))
	    stream.push(data);
	
	  if (cb)
	    cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	
	function Transform(options) {
	  if (!(this instanceof Transform))
	    return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(options, this);
	
	  // when the writable side finishes, then flush out anything remaining.
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  this.once('prefinish', function() {
	    if (util.isFunction(this._flush))
	      this._flush(function(er) {
	        done(stream, er);
	      });
	    else
	      done(stream);
	  });
	}
	
	Transform.prototype.push = function(chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function(chunk, encoding, cb) {
	  throw new Error('not implemented');
	};
	
	Transform.prototype._write = function(chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform ||
	        rs.needReadable ||
	        rs.length < rs.highWaterMark)
	      this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function(n) {
	  var ts = this._transformState;
	
	  if (!util.isNull(ts.writechunk) && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	
	function done(stream, er) {
	  if (er)
	    return stream.emit('error', er);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length)
	    throw new Error('calling transform done when ws.length != 0');
	
	  if (ts.transforming)
	    throw new Error('calling transform done when still transforming');
	
	  return stream.push(null);
	}


/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, cb), and it'll handle all
	// the drain event emission and buffering.
	
	module.exports = Writable;
	
	/*<replacement>*/
	var Buffer = __webpack_require__(339).Buffer;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	
	/*<replacement>*/
	var util = __webpack_require__(754);
	util.inherits = __webpack_require__(406);
	/*</replacement>*/
	
	var Stream = __webpack_require__(345);
	
	util.inherits(Writable, Stream);
	
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	}
	
	function WritableState(options, stream) {
	  var Duplex = __webpack_require__(586);
	
	  options = options || {};
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function(er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.buffer = [];
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	}
	
	function Writable(options) {
	  var Duplex = __webpack_require__(586);
	
	  // Writable ctor is applied to Duplexes, though they're not
	  // instanceof Writable, they're instanceof Readable.
	  if (!(this instanceof Writable) && !(this instanceof Duplex))
	    return new Writable(options);
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function() {
	  this.emit('error', new Error('Cannot pipe. Not readable.'));
	};
	
	
	function writeAfterEnd(stream, state, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  process.nextTick(function() {
	    cb(er);
	  });
	}
	
	// If we get something that is not a buffer, string, null, or undefined,
	// and we're not in objectMode, then that's an error.
	// Otherwise stream chunks are all considered to be of length=1, and the
	// watermarks determine how many objects to keep in the buffer, rather than
	// how many bytes or characters.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    var er = new TypeError('Invalid non-string/buffer chunk');
	    stream.emit('error', er);
	    process.nextTick(function() {
	      cb(er);
	    });
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function(chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	
	  if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  else if (!encoding)
	    encoding = state.defaultEncoding;
	
	  if (!util.isFunction(cb))
	    cb = function() {};
	
	  if (state.ended)
	    writeAfterEnd(this, state, cb);
	  else if (validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function() {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function() {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing &&
	        !state.corked &&
	        !state.finished &&
	        !state.bufferProcessing &&
	        state.buffer.length)
	      clearBuffer(this, state);
	  }
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode &&
	      state.decodeStrings !== false &&
	      util.isString(chunk)) {
	    chunk = new Buffer(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, chunk, encoding, cb) {
	  chunk = decodeChunk(state, chunk, encoding);
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret)
	    state.needDrain = true;
	
	  if (state.writing || state.corked)
	    state.buffer.push(new WriteReq(chunk, encoding, cb));
	  else
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev)
	    stream._writev(chunk, state.onwrite);
	  else
	    stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  if (sync)
	    process.nextTick(function() {
	      state.pendingcb--;
	      cb(er);
	    });
	  else {
	    state.pendingcb--;
	    cb(er);
	  }
	
	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er)
	    onwriteError(stream, state, sync, er, cb);
	  else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(stream, state);
	
	    if (!finished &&
	        !state.corked &&
	        !state.bufferProcessing &&
	        state.buffer.length) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      process.nextTick(function() {
	        afterWrite(stream, state, finished, cb);
	      });
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished)
	    onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	
	  if (stream._writev && state.buffer.length > 1) {
	    // Fast case, write everything using _writev()
	    var cbs = [];
	    for (var c = 0; c < state.buffer.length; c++)
	      cbs.push(state.buffer[c].callback);
	
	    // count the one we are adding, as well.
	    // TODO(isaacs) clean this up
	    state.pendingcb++;
	    doWrite(stream, state, true, state.length, state.buffer, '', function(err) {
	      for (var i = 0; i < cbs.length; i++) {
	        state.pendingcb--;
	        cbs[i](err);
	      }
	    });
	
	    // Clear buffer
	    state.buffer = [];
	  } else {
	    // Slow case, write chunks one-by-one
	    for (var c = 0; c < state.buffer.length; c++) {
	      var entry = state.buffer[c];
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        c++;
	        break;
	      }
	    }
	
	    if (c < state.buffer.length)
	      state.buffer = state.buffer.slice(c);
	    else
	      state.buffer.length = 0;
	  }
	
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function(chunk, encoding, cb) {
	  cb(new Error('not implemented'));
	
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function(chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (util.isFunction(chunk)) {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (!util.isNullOrUndefined(chunk))
	    this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished)
	    endWritable(this, state, cb);
	};
	
	
	function needFinish(stream, state) {
	  return (state.ending &&
	          state.length === 0 &&
	          !state.finished &&
	          !state.writing);
	}
	
	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(stream, state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else
	      prefinish(stream, state);
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished)
	      process.nextTick(cb);
	    else
	      stream.once('finish', cb);
	  }
	  state.ended = true;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(235)))

/***/ },
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1758);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./swiper.css", function() {
				var newContent = require("!!../../css-loader/index.js!./swiper.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Swiper 5.4.5
	 * Most modern mobile touch slider and framework with hardware accelerated transitions
	 * http://swiperjs.com
	 *
	 * Copyright 2014-2020 Vladimir Kharlampidi
	 *
	 * Released under the MIT License
	 *
	 * Released on: June 16, 2020
	 */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global = global || self, global.Swiper = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * SSR Window 2.0.0
	     * Better handling for window object in SSR environment
	     * https://github.com/nolimits4web/ssr-window
	     *
	     * Copyright 2020, Vladimir Kharlampidi
	     *
	     * Licensed under MIT
	     *
	     * Released on: May 12, 2020
	     */
	    /* eslint-disable no-param-reassign */
	    function isObject(obj) {
	        return (obj !== null &&
	            typeof obj === 'object' &&
	            'constructor' in obj &&
	            obj.constructor === Object);
	    }
	    function extend(target, src) {
	        if (target === void 0) { target = {}; }
	        if (src === void 0) { src = {}; }
	        Object.keys(src).forEach(function (key) {
	            if (typeof target[key] === 'undefined')
	                { target[key] = src[key]; }
	            else if (isObject(src[key]) &&
	                isObject(target[key]) &&
	                Object.keys(src[key]).length > 0) {
	                extend(target[key], src[key]);
	            }
	        });
	    }
	
	    var doc = typeof document !== 'undefined' ? document : {};
	    var ssrDocument = {
	        body: {},
	        addEventListener: function () { },
	        removeEventListener: function () { },
	        activeElement: {
	            blur: function () { },
	            nodeName: '',
	        },
	        querySelector: function () {
	            return null;
	        },
	        querySelectorAll: function () {
	            return [];
	        },
	        getElementById: function () {
	            return null;
	        },
	        createEvent: function () {
	            return {
	                initEvent: function () { },
	            };
	        },
	        createElement: function () {
	            return {
	                children: [],
	                childNodes: [],
	                style: {},
	                setAttribute: function () { },
	                getElementsByTagName: function () {
	                    return [];
	                },
	            };
	        },
	        createElementNS: function () {
	            return {};
	        },
	        importNode: function () {
	            return null;
	        },
	        location: {
	            hash: '',
	            host: '',
	            hostname: '',
	            href: '',
	            origin: '',
	            pathname: '',
	            protocol: '',
	            search: '',
	        },
	    };
	    extend(doc, ssrDocument);
	
	    var win = typeof window !== 'undefined' ? window : {};
	    var ssrWindow = {
	        document: ssrDocument,
	        navigator: {
	            userAgent: '',
	        },
	        location: {
	            hash: '',
	            host: '',
	            hostname: '',
	            href: '',
	            origin: '',
	            pathname: '',
	            protocol: '',
	            search: '',
	        },
	        history: {
	            replaceState: function () { },
	            pushState: function () { },
	            go: function () { },
	            back: function () { },
	        },
	        CustomEvent: function CustomEvent() {
	            return this;
	        },
	        addEventListener: function () { },
	        removeEventListener: function () { },
	        getComputedStyle: function () {
	            return {
	                getPropertyValue: function () {
	                    return '';
	                },
	            };
	        },
	        Image: function () { },
	        Date: function () { },
	        screen: {},
	        setTimeout: function () { },
	        clearTimeout: function () { },
	        matchMedia: function () {
	            return {};
	        },
	    };
	    extend(win, ssrWindow);
	
	    /**
	     * Dom7 2.1.5
	     * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
	     * http://framework7.io/docs/dom.html
	     *
	     * Copyright 2020, Vladimir Kharlampidi
	     * The iDangero.us
	     * http://www.idangero.us/
	     *
	     * Licensed under MIT
	     *
	     * Released on: May 15, 2020
	     */
	
	    var Dom7 = function Dom7(arr) {
	      var self = this;
	      // Create array-like object
	      for (var i = 0; i < arr.length; i += 1) {
	        self[i] = arr[i];
	      }
	      self.length = arr.length;
	      // Return collection with methods
	      return this;
	    };
	
	    function $(selector, context) {
	      var arr = [];
	      var i = 0;
	      if (selector && !context) {
	        if (selector instanceof Dom7) {
	          return selector;
	        }
	      }
	      if (selector) {
	          // String
	        if (typeof selector === 'string') {
	          var els;
	          var tempParent;
	          var html = selector.trim();
	          if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	            var toCreate = 'div';
	            if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
	            if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
	            if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
	            if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
	            if (html.indexOf('<option') === 0) { toCreate = 'select'; }
	            tempParent = doc.createElement(toCreate);
	            tempParent.innerHTML = html;
	            for (i = 0; i < tempParent.childNodes.length; i += 1) {
	              arr.push(tempParent.childNodes[i]);
	            }
	          } else {
	            if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
	              // Pure ID selector
	              els = [doc.getElementById(selector.trim().split('#')[1])];
	            } else {
	              // Other selectors
	              els = (context || doc).querySelectorAll(selector.trim());
	            }
	            for (i = 0; i < els.length; i += 1) {
	              if (els[i]) { arr.push(els[i]); }
	            }
	          }
	        } else if (selector.nodeType || selector === win || selector === doc) {
	          // Node/element
	          arr.push(selector);
	        } else if (selector.length > 0 && selector[0].nodeType) {
	          // Array of elements or instance of Dom
	          for (i = 0; i < selector.length; i += 1) {
	            arr.push(selector[i]);
	          }
	        }
	      }
	      return new Dom7(arr);
	    }
	
	    $.fn = Dom7.prototype;
	    $.Class = Dom7;
	    $.Dom7 = Dom7;
	
	    function unique(arr) {
	      var uniqueArray = [];
	      for (var i = 0; i < arr.length; i += 1) {
	        if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
	      }
	      return uniqueArray;
	    }
	
	    // Classes and attributes
	    function addClass(className) {
	      if (typeof className === 'undefined') {
	        return this;
	      }
	      var classes = className.split(' ');
	      for (var i = 0; i < classes.length; i += 1) {
	        for (var j = 0; j < this.length; j += 1) {
	          if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.add(classes[i]); }
	        }
	      }
	      return this;
	    }
	    function removeClass(className) {
	      var classes = className.split(' ');
	      for (var i = 0; i < classes.length; i += 1) {
	        for (var j = 0; j < this.length; j += 1) {
	          if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.remove(classes[i]); }
	        }
	      }
	      return this;
	    }
	    function hasClass(className) {
	      if (!this[0]) { return false; }
	      return this[0].classList.contains(className);
	    }
	    function toggleClass(className) {
	      var classes = className.split(' ');
	      for (var i = 0; i < classes.length; i += 1) {
	        for (var j = 0; j < this.length; j += 1) {
	          if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.toggle(classes[i]); }
	        }
	      }
	      return this;
	    }
	    function attr(attrs, value) {
	      var arguments$1 = arguments;
	
	      if (arguments.length === 1 && typeof attrs === 'string') {
	        // Get attr
	        if (this[0]) { return this[0].getAttribute(attrs); }
	        return undefined;
	      }
	
	      // Set attrs
	      for (var i = 0; i < this.length; i += 1) {
	        if (arguments$1.length === 2) {
	          // String
	          this[i].setAttribute(attrs, value);
	        } else {
	          // Object
	          // eslint-disable-next-line
	          for (var attrName in attrs) {
	            this[i][attrName] = attrs[attrName];
	            this[i].setAttribute(attrName, attrs[attrName]);
	          }
	        }
	      }
	      return this;
	    }
	    // eslint-disable-next-line
	    function removeAttr(attr) {
	      for (var i = 0; i < this.length; i += 1) {
	        this[i].removeAttribute(attr);
	      }
	      return this;
	    }
	    function data(key, value) {
	      var el;
	      if (typeof value === 'undefined') {
	        el = this[0];
	        // Get value
	        if (el) {
	          if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
	            return el.dom7ElementDataStorage[key];
	          }
	
	          var dataKey = el.getAttribute(("data-" + key));
	          if (dataKey) {
	            return dataKey;
	          }
	          return undefined;
	        }
	        return undefined;
	      }
	
	      // Set value
	      for (var i = 0; i < this.length; i += 1) {
	        el = this[i];
	        if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
	        el.dom7ElementDataStorage[key] = value;
	      }
	      return this;
	    }
	    // Transforms
	    // eslint-disable-next-line
	    function transform(transform) {
	      for (var i = 0; i < this.length; i += 1) {
	        var elStyle = this[i].style;
	        elStyle.webkitTransform = transform;
	        elStyle.transform = transform;
	      }
	      return this;
	    }
	    function transition(duration) {
	      if (typeof duration !== 'string') {
	        duration = duration + "ms"; // eslint-disable-line
	      }
	      for (var i = 0; i < this.length; i += 1) {
	        var elStyle = this[i].style;
	        elStyle.webkitTransitionDuration = duration;
	        elStyle.transitionDuration = duration;
	      }
	      return this;
	    }
	    // Events
	    function on() {
	      var assign;
	
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	      var eventType = args[0];
	      var targetSelector = args[1];
	      var listener = args[2];
	      var capture = args[3];
	      if (typeof args[1] === 'function') {
	        (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
	        targetSelector = undefined;
	      }
	      if (!capture) { capture = false; }
	
	      function handleLiveEvent(e) {
	        var target = e.target;
	        if (!target) { return; }
	        var eventData = e.target.dom7EventData || [];
	        if (eventData.indexOf(e) < 0) {
	          eventData.unshift(e);
	        }
	        if ($(target).is(targetSelector)) { listener.apply(target, eventData); }
	        else {
	          var parents = $(target).parents(); // eslint-disable-line
	          for (var k = 0; k < parents.length; k += 1) {
	            if ($(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
	          }
	        }
	      }
	      function handleEvent(e) {
	        var eventData = e && e.target ? e.target.dom7EventData || [] : [];
	        if (eventData.indexOf(e) < 0) {
	          eventData.unshift(e);
	        }
	        listener.apply(this, eventData);
	      }
	      var events = eventType.split(' ');
	      var j;
	      for (var i = 0; i < this.length; i += 1) {
	        var el = this[i];
	        if (!targetSelector) {
	          for (j = 0; j < events.length; j += 1) {
	            var event = events[j];
	            if (!el.dom7Listeners) { el.dom7Listeners = {}; }
	            if (!el.dom7Listeners[event]) { el.dom7Listeners[event] = []; }
	            el.dom7Listeners[event].push({
	              listener: listener,
	              proxyListener: handleEvent,
	            });
	            el.addEventListener(event, handleEvent, capture);
	          }
	        } else {
	          // Live events
	          for (j = 0; j < events.length; j += 1) {
	            var event$1 = events[j];
	            if (!el.dom7LiveListeners) { el.dom7LiveListeners = {}; }
	            if (!el.dom7LiveListeners[event$1]) { el.dom7LiveListeners[event$1] = []; }
	            el.dom7LiveListeners[event$1].push({
	              listener: listener,
	              proxyListener: handleLiveEvent,
	            });
	            el.addEventListener(event$1, handleLiveEvent, capture);
	          }
	        }
	      }
	      return this;
	    }
	    function off() {
	      var assign;
	
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	      var eventType = args[0];
	      var targetSelector = args[1];
	      var listener = args[2];
	      var capture = args[3];
	      if (typeof args[1] === 'function') {
	        (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
	        targetSelector = undefined;
	      }
	      if (!capture) { capture = false; }
	
	      var events = eventType.split(' ');
	      for (var i = 0; i < events.length; i += 1) {
	        var event = events[i];
	        for (var j = 0; j < this.length; j += 1) {
	          var el = this[j];
	          var handlers = (void 0);
	          if (!targetSelector && el.dom7Listeners) {
	            handlers = el.dom7Listeners[event];
	          } else if (targetSelector && el.dom7LiveListeners) {
	            handlers = el.dom7LiveListeners[event];
	          }
	          if (handlers && handlers.length) {
	            for (var k = handlers.length - 1; k >= 0; k -= 1) {
	              var handler = handlers[k];
	              if (listener && handler.listener === listener) {
	                el.removeEventListener(event, handler.proxyListener, capture);
	                handlers.splice(k, 1);
	              } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
	                el.removeEventListener(event, handler.proxyListener, capture);
	                handlers.splice(k, 1);
	              } else if (!listener) {
	                el.removeEventListener(event, handler.proxyListener, capture);
	                handlers.splice(k, 1);
	              }
	            }
	          }
	        }
	      }
	      return this;
	    }
	    function trigger() {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var events = args[0].split(' ');
	      var eventData = args[1];
	      for (var i = 0; i < events.length; i += 1) {
	        var event = events[i];
	        for (var j = 0; j < this.length; j += 1) {
	          var el = this[j];
	          var evt = (void 0);
	          try {
	            evt = new win.CustomEvent(event, {
	              detail: eventData,
	              bubbles: true,
	              cancelable: true,
	            });
	          } catch (e) {
	            evt = doc.createEvent('Event');
	            evt.initEvent(event, true, true);
	            evt.detail = eventData;
	          }
	          // eslint-disable-next-line
	          el.dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
	          el.dispatchEvent(evt);
	          el.dom7EventData = [];
	          delete el.dom7EventData;
	        }
	      }
	      return this;
	    }
	    function transitionEnd(callback) {
	      var events = ['webkitTransitionEnd', 'transitionend'];
	      var dom = this;
	      var i;
	      function fireCallBack(e) {
	        /* jshint validthis:true */
	        if (e.target !== this) { return; }
	        callback.call(this, e);
	        for (i = 0; i < events.length; i += 1) {
	          dom.off(events[i], fireCallBack);
	        }
	      }
	      if (callback) {
	        for (i = 0; i < events.length; i += 1) {
	          dom.on(events[i], fireCallBack);
	        }
	      }
	      return this;
	    }
	    function outerWidth(includeMargins) {
	      if (this.length > 0) {
	        if (includeMargins) {
	          // eslint-disable-next-line
	          var styles = this.styles();
	          return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
	        }
	        return this[0].offsetWidth;
	      }
	      return null;
	    }
	    function outerHeight(includeMargins) {
	      if (this.length > 0) {
	        if (includeMargins) {
	          // eslint-disable-next-line
	          var styles = this.styles();
	          return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
	        }
	        return this[0].offsetHeight;
	      }
	      return null;
	    }
	    function offset() {
	      if (this.length > 0) {
	        var el = this[0];
	        var box = el.getBoundingClientRect();
	        var body = doc.body;
	        var clientTop = el.clientTop || body.clientTop || 0;
	        var clientLeft = el.clientLeft || body.clientLeft || 0;
	        var scrollTop = el === win ? win.scrollY : el.scrollTop;
	        var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
	        return {
	          top: (box.top + scrollTop) - clientTop,
	          left: (box.left + scrollLeft) - clientLeft,
	        };
	      }
	
	      return null;
	    }
	    function styles() {
	      if (this[0]) { return win.getComputedStyle(this[0], null); }
	      return {};
	    }
	    function css(props, value) {
	      var i;
	      if (arguments.length === 1) {
	        if (typeof props === 'string') {
	          if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
	        } else {
	          for (i = 0; i < this.length; i += 1) {
	            // eslint-disable-next-line
	            for (var prop in props) {
	              this[i].style[prop] = props[prop];
	            }
	          }
	          return this;
	        }
	      }
	      if (arguments.length === 2 && typeof props === 'string') {
	        for (i = 0; i < this.length; i += 1) {
	          this[i].style[props] = value;
	        }
	        return this;
	      }
	      return this;
	    }
	    // Iterate over the collection passing elements to `callback`
	    function each(callback) {
	      // Don't bother continuing without a callback
	      if (!callback) { return this; }
	      // Iterate over the current collection
	      for (var i = 0; i < this.length; i += 1) {
	        // If the callback returns false
	        if (callback.call(this[i], i, this[i]) === false) {
	          // End the loop early
	          return this;
	        }
	      }
	      // Return `this` to allow chained DOM operations
	      return this;
	    }
	    function filter(callback) {
	      var matchedItems = [];
	      var dom = this;
	      for (var i = 0; i < dom.length; i += 1) {
	        if (callback.call(dom[i], i, dom[i])) { matchedItems.push(dom[i]); }
	      }
	      return new Dom7(matchedItems);
	    }
	    // eslint-disable-next-line
	    function html(html) {
	      if (typeof html === 'undefined') {
	        return this[0] ? this[0].innerHTML : undefined;
	      }
	
	      for (var i = 0; i < this.length; i += 1) {
	        this[i].innerHTML = html;
	      }
	      return this;
	    }
	    // eslint-disable-next-line
	    function text(text) {
	      if (typeof text === 'undefined') {
	        if (this[0]) {
	          return this[0].textContent.trim();
	        }
	        return null;
	      }
	
	      for (var i = 0; i < this.length; i += 1) {
	        this[i].textContent = text;
	      }
	      return this;
	    }
	    function is(selector) {
	      var el = this[0];
	      var compareWith;
	      var i;
	      if (!el || typeof selector === 'undefined') { return false; }
	      if (typeof selector === 'string') {
	        if (el.matches) { return el.matches(selector); }
	        else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
	        else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }
	
	        compareWith = $(selector);
	        for (i = 0; i < compareWith.length; i += 1) {
	          if (compareWith[i] === el) { return true; }
	        }
	        return false;
	      } else if (selector === doc) { return el === doc; }
	      else if (selector === win) { return el === win; }
	
	      if (selector.nodeType || selector instanceof Dom7) {
	        compareWith = selector.nodeType ? [selector] : selector;
	        for (i = 0; i < compareWith.length; i += 1) {
	          if (compareWith[i] === el) { return true; }
	        }
	        return false;
	      }
	      return false;
	    }
	    function index() {
	      var child = this[0];
	      var i;
	      if (child) {
	        i = 0;
	        // eslint-disable-next-line
	        while ((child = child.previousSibling) !== null) {
	          if (child.nodeType === 1) { i += 1; }
	        }
	        return i;
	      }
	      return undefined;
	    }
	    // eslint-disable-next-line
	    function eq(index) {
	      if (typeof index === 'undefined') { return this; }
	      var length = this.length;
	      var returnIndex;
	      if (index > length - 1) {
	        return new Dom7([]);
	      }
	      if (index < 0) {
	        returnIndex = length + index;
	        if (returnIndex < 0) { return new Dom7([]); }
	        return new Dom7([this[returnIndex]]);
	      }
	      return new Dom7([this[index]]);
	    }
	    function append() {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var newChild;
	
	      for (var k = 0; k < args.length; k += 1) {
	        newChild = args[k];
	        for (var i = 0; i < this.length; i += 1) {
	          if (typeof newChild === 'string') {
	            var tempDiv = doc.createElement('div');
	            tempDiv.innerHTML = newChild;
	            while (tempDiv.firstChild) {
	              this[i].appendChild(tempDiv.firstChild);
	            }
	          } else if (newChild instanceof Dom7) {
	            for (var j = 0; j < newChild.length; j += 1) {
	              this[i].appendChild(newChild[j]);
	            }
	          } else {
	            this[i].appendChild(newChild);
	          }
	        }
	      }
	
	      return this;
	    }
	    function prepend(newChild) {
	      var i;
	      var j;
	      for (i = 0; i < this.length; i += 1) {
	        if (typeof newChild === 'string') {
	          var tempDiv = doc.createElement('div');
	          tempDiv.innerHTML = newChild;
	          for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
	            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
	          }
	        } else if (newChild instanceof Dom7) {
	          for (j = 0; j < newChild.length; j += 1) {
	            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
	          }
	        } else {
	          this[i].insertBefore(newChild, this[i].childNodes[0]);
	        }
	      }
	      return this;
	    }
	    function next(selector) {
	      if (this.length > 0) {
	        if (selector) {
	          if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
	            return new Dom7([this[0].nextElementSibling]);
	          }
	          return new Dom7([]);
	        }
	
	        if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
	        return new Dom7([]);
	      }
	      return new Dom7([]);
	    }
	    function nextAll(selector) {
	      var nextEls = [];
	      var el = this[0];
	      if (!el) { return new Dom7([]); }
	      while (el.nextElementSibling) {
	        var next = el.nextElementSibling; // eslint-disable-line
	        if (selector) {
	          if ($(next).is(selector)) { nextEls.push(next); }
	        } else { nextEls.push(next); }
	        el = next;
	      }
	      return new Dom7(nextEls);
	    }
	    function prev(selector) {
	      if (this.length > 0) {
	        var el = this[0];
	        if (selector) {
	          if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
	            return new Dom7([el.previousElementSibling]);
	          }
	          return new Dom7([]);
	        }
	
	        if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
	        return new Dom7([]);
	      }
	      return new Dom7([]);
	    }
	    function prevAll(selector) {
	      var prevEls = [];
	      var el = this[0];
	      if (!el) { return new Dom7([]); }
	      while (el.previousElementSibling) {
	        var prev = el.previousElementSibling; // eslint-disable-line
	        if (selector) {
	          if ($(prev).is(selector)) { prevEls.push(prev); }
	        } else { prevEls.push(prev); }
	        el = prev;
	      }
	      return new Dom7(prevEls);
	    }
	    function parent(selector) {
	      var parents = []; // eslint-disable-line
	      for (var i = 0; i < this.length; i += 1) {
	        if (this[i].parentNode !== null) {
	          if (selector) {
	            if ($(this[i].parentNode).is(selector)) { parents.push(this[i].parentNode); }
	          } else {
	            parents.push(this[i].parentNode);
	          }
	        }
	      }
	      return $(unique(parents));
	    }
	    function parents(selector) {
	      var parents = []; // eslint-disable-line
	      for (var i = 0; i < this.length; i += 1) {
	        var parent = this[i].parentNode; // eslint-disable-line
	        while (parent) {
	          if (selector) {
	            if ($(parent).is(selector)) { parents.push(parent); }
	          } else {
	            parents.push(parent);
	          }
	          parent = parent.parentNode;
	        }
	      }
	      return $(unique(parents));
	    }
	    function closest(selector) {
	      var closest = this; // eslint-disable-line
	      if (typeof selector === 'undefined') {
	        return new Dom7([]);
	      }
	      if (!closest.is(selector)) {
	        closest = closest.parents(selector).eq(0);
	      }
	      return closest;
	    }
	    function find(selector) {
	      var foundElements = [];
	      for (var i = 0; i < this.length; i += 1) {
	        var found = this[i].querySelectorAll(selector);
	        for (var j = 0; j < found.length; j += 1) {
	          foundElements.push(found[j]);
	        }
	      }
	      return new Dom7(foundElements);
	    }
	    function children(selector) {
	      var children = []; // eslint-disable-line
	      for (var i = 0; i < this.length; i += 1) {
	        var childNodes = this[i].childNodes;
	
	        for (var j = 0; j < childNodes.length; j += 1) {
	          if (!selector) {
	            if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
	          } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
	            children.push(childNodes[j]);
	          }
	        }
	      }
	      return new Dom7(unique(children));
	    }
	    function remove() {
	      for (var i = 0; i < this.length; i += 1) {
	        if (this[i].parentNode) { this[i].parentNode.removeChild(this[i]); }
	      }
	      return this;
	    }
	    function add() {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var dom = this;
	      var i;
	      var j;
	      for (i = 0; i < args.length; i += 1) {
	        var toAdd = $(args[i]);
	        for (j = 0; j < toAdd.length; j += 1) {
	          dom[dom.length] = toAdd[j];
	          dom.length += 1;
	        }
	      }
	      return dom;
	    }
	
	    var Methods = {
	      addClass: addClass,
	      removeClass: removeClass,
	      hasClass: hasClass,
	      toggleClass: toggleClass,
	      attr: attr,
	      removeAttr: removeAttr,
	      data: data,
	      transform: transform,
	      transition: transition,
	      on: on,
	      off: off,
	      trigger: trigger,
	      transitionEnd: transitionEnd,
	      outerWidth: outerWidth,
	      outerHeight: outerHeight,
	      offset: offset,
	      css: css,
	      each: each,
	      html: html,
	      text: text,
	      is: is,
	      index: index,
	      eq: eq,
	      append: append,
	      prepend: prepend,
	      next: next,
	      nextAll: nextAll,
	      prev: prev,
	      prevAll: prevAll,
	      parent: parent,
	      parents: parents,
	      closest: closest,
	      find: find,
	      children: children,
	      filter: filter,
	      remove: remove,
	      add: add,
	      styles: styles,
	    };
	
	    Object.keys(Methods).forEach(function (methodName) {
	      $.fn[methodName] = $.fn[methodName] || Methods[methodName];
	    });
	
	    var Utils = {
	      deleteProps: function deleteProps(obj) {
	        var object = obj;
	        Object.keys(object).forEach(function (key) {
	          try {
	            object[key] = null;
	          } catch (e) {
	            // no getter for object
	          }
	          try {
	            delete object[key];
	          } catch (e) {
	            // something got wrong
	          }
	        });
	      },
	      nextTick: function nextTick(callback, delay) {
	        if ( delay === void 0 ) delay = 0;
	
	        return setTimeout(callback, delay);
	      },
	      now: function now() {
	        return Date.now();
	      },
	      getTranslate: function getTranslate(el, axis) {
	        if ( axis === void 0 ) axis = 'x';
	
	        var matrix;
	        var curTransform;
	        var transformMatrix;
	
	        var curStyle = win.getComputedStyle(el, null);
	
	        if (win.WebKitCSSMatrix) {
	          curTransform = curStyle.transform || curStyle.webkitTransform;
	          if (curTransform.split(',').length > 6) {
	            curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
	          }
	          // Some old versions of Webkit choke when 'none' is passed; pass
	          // empty string instead in this case
	          transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	        } else {
	          transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	          matrix = transformMatrix.toString().split(',');
	        }
	
	        if (axis === 'x') {
	          // Latest Chrome and webkits Fix
	          if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
	          // Crazy IE10 Matrix
	          else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
	          // Normal Browsers
	          else { curTransform = parseFloat(matrix[4]); }
	        }
	        if (axis === 'y') {
	          // Latest Chrome and webkits Fix
	          if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
	          // Crazy IE10 Matrix
	          else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
	          // Normal Browsers
	          else { curTransform = parseFloat(matrix[5]); }
	        }
	        return curTransform || 0;
	      },
	      parseUrlQuery: function parseUrlQuery(url) {
	        var query = {};
	        var urlToParse = url || win.location.href;
	        var i;
	        var params;
	        var param;
	        var length;
	        if (typeof urlToParse === 'string' && urlToParse.length) {
	          urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
	          params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
	          length = params.length;
	
	          for (i = 0; i < length; i += 1) {
	            param = params[i].replace(/#\S+/g, '').split('=');
	            query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
	          }
	        }
	        return query;
	      },
	      isObject: function isObject(o) {
	        return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
	      },
	      extend: function extend() {
	        var args = [], len$1 = arguments.length;
	        while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];
	
	        var to = Object(args[0]);
	        for (var i = 1; i < args.length; i += 1) {
	          var nextSource = args[i];
	          if (nextSource !== undefined && nextSource !== null) {
	            var keysArray = Object.keys(Object(nextSource));
	            for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	              var nextKey = keysArray[nextIndex];
	              var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	              if (desc !== undefined && desc.enumerable) {
	                if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
	                  Utils.extend(to[nextKey], nextSource[nextKey]);
	                } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
	                  to[nextKey] = {};
	                  Utils.extend(to[nextKey], nextSource[nextKey]);
	                } else {
	                  to[nextKey] = nextSource[nextKey];
	                }
	              }
	            }
	          }
	        }
	        return to;
	      },
	    };
	
	    var Support = (function Support() {
	      return {
	        touch: !!(('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch)),
	
	        pointerEvents: !!win.PointerEvent && ('maxTouchPoints' in win.navigator) && win.navigator.maxTouchPoints >= 0,
	
	        observer: (function checkObserver() {
	          return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
	        }()),
	
	        passiveListener: (function checkPassiveListener() {
	          var supportsPassive = false;
	          try {
	            var opts = Object.defineProperty({}, 'passive', {
	              // eslint-disable-next-line
	              get: function get() {
	                supportsPassive = true;
	              },
	            });
	            win.addEventListener('testPassiveListener', null, opts);
	          } catch (e) {
	            // No support
	          }
	          return supportsPassive;
	        }()),
	
	        gestures: (function checkGestures() {
	          return 'ongesturestart' in win;
	        }()),
	      };
	    }());
	
	    var SwiperClass = function SwiperClass(params) {
	      if ( params === void 0 ) params = {};
	
	      var self = this;
	      self.params = params;
	
	      // Events
	      self.eventsListeners = {};
	
	      if (self.params && self.params.on) {
	        Object.keys(self.params.on).forEach(function (eventName) {
	          self.on(eventName, self.params.on[eventName]);
	        });
	      }
	    };
	
	    var staticAccessors = { components: { configurable: true } };
	
	    SwiperClass.prototype.on = function on (events, handler, priority) {
	      var self = this;
	      if (typeof handler !== 'function') { return self; }
	      var method = priority ? 'unshift' : 'push';
	      events.split(' ').forEach(function (event) {
	        if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
	        self.eventsListeners[event][method](handler);
	      });
	      return self;
	    };
	
	    SwiperClass.prototype.once = function once (events, handler, priority) {
	      var self = this;
	      if (typeof handler !== 'function') { return self; }
	      function onceHandler() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];
	
	        self.off(events, onceHandler);
	        if (onceHandler.f7proxy) {
	          delete onceHandler.f7proxy;
	        }
	        handler.apply(self, args);
	      }
	      onceHandler.f7proxy = handler;
	      return self.on(events, onceHandler, priority);
	    };
	
	    SwiperClass.prototype.off = function off (events, handler) {
	      var self = this;
	      if (!self.eventsListeners) { return self; }
	      events.split(' ').forEach(function (event) {
	        if (typeof handler === 'undefined') {
	          self.eventsListeners[event] = [];
	        } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
	          self.eventsListeners[event].forEach(function (eventHandler, index) {
	            if (eventHandler === handler || (eventHandler.f7proxy && eventHandler.f7proxy === handler)) {
	              self.eventsListeners[event].splice(index, 1);
	            }
	          });
	        }
	      });
	      return self;
	    };
	
	    SwiperClass.prototype.emit = function emit () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	      var self = this;
	      if (!self.eventsListeners) { return self; }
	      var events;
	      var data;
	      var context;
	      if (typeof args[0] === 'string' || Array.isArray(args[0])) {
	        events = args[0];
	        data = args.slice(1, args.length);
	        context = self;
	      } else {
	        events = args[0].events;
	        data = args[0].data;
	        context = args[0].context || self;
	      }
	      var eventsArray = Array.isArray(events) ? events : events.split(' ');
	      eventsArray.forEach(function (event) {
	        if (self.eventsListeners && self.eventsListeners[event]) {
	          var handlers = [];
	          self.eventsListeners[event].forEach(function (eventHandler) {
	            handlers.push(eventHandler);
	          });
	          handlers.forEach(function (eventHandler) {
	            eventHandler.apply(context, data);
	          });
	        }
	      });
	      return self;
	    };
	
	    SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
	      var instance = this;
	      if (!instance.modules) { return; }
	      Object.keys(instance.modules).forEach(function (moduleName) {
	        var module = instance.modules[moduleName];
	        // Extend params
	        if (module.params) {
	          Utils.extend(instanceParams, module.params);
	        }
	      });
	    };
	
	    SwiperClass.prototype.useModules = function useModules (modulesParams) {
	        if ( modulesParams === void 0 ) modulesParams = {};
	
	      var instance = this;
	      if (!instance.modules) { return; }
	      Object.keys(instance.modules).forEach(function (moduleName) {
	        var module = instance.modules[moduleName];
	        var moduleParams = modulesParams[moduleName] || {};
	        // Extend instance methods and props
	        if (module.instance) {
	          Object.keys(module.instance).forEach(function (modulePropName) {
	            var moduleProp = module.instance[modulePropName];
	            if (typeof moduleProp === 'function') {
	              instance[modulePropName] = moduleProp.bind(instance);
	            } else {
	              instance[modulePropName] = moduleProp;
	            }
	          });
	        }
	        // Add event listeners
	        if (module.on && instance.on) {
	          Object.keys(module.on).forEach(function (moduleEventName) {
	            instance.on(moduleEventName, module.on[moduleEventName]);
	          });
	        }
	
	        // Module create callback
	        if (module.create) {
	          module.create.bind(instance)(moduleParams);
	        }
	      });
	    };
	
	    staticAccessors.components.set = function (components) {
	      var Class = this;
	      if (!Class.use) { return; }
	      Class.use(components);
	    };
	
	    SwiperClass.installModule = function installModule (module) {
	        var params = [], len = arguments.length - 1;
	        while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];
	
	      var Class = this;
	      if (!Class.prototype.modules) { Class.prototype.modules = {}; }
	      var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
	      Class.prototype.modules[name] = module;
	      // Prototype
	      if (module.proto) {
	        Object.keys(module.proto).forEach(function (key) {
	          Class.prototype[key] = module.proto[key];
	        });
	      }
	      // Class
	      if (module.static) {
	        Object.keys(module.static).forEach(function (key) {
	          Class[key] = module.static[key];
	        });
	      }
	      // Callback
	      if (module.install) {
	        module.install.apply(Class, params);
	      }
	      return Class;
	    };
	
	    SwiperClass.use = function use (module) {
	        var params = [], len = arguments.length - 1;
	        while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];
	
	      var Class = this;
	      if (Array.isArray(module)) {
	        module.forEach(function (m) { return Class.installModule(m); });
	        return Class;
	      }
	      return Class.installModule.apply(Class, [ module ].concat( params ));
	    };
	
	    Object.defineProperties( SwiperClass, staticAccessors );
	
	    function updateSize () {
	      var swiper = this;
	      var width;
	      var height;
	      var $el = swiper.$el;
	      if (typeof swiper.params.width !== 'undefined') {
	        width = swiper.params.width;
	      } else {
	        width = $el[0].clientWidth;
	      }
	      if (typeof swiper.params.height !== 'undefined') {
	        height = swiper.params.height;
	      } else {
	        height = $el[0].clientHeight;
	      }
	      if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
	        return;
	      }
	
	      // Subtract paddings
	      width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
	      height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);
	
	      Utils.extend(swiper, {
	        width: width,
	        height: height,
	        size: swiper.isHorizontal() ? width : height,
	      });
	    }
	
	    function updateSlides () {
	      var swiper = this;
	      var params = swiper.params;
	
	      var $wrapperEl = swiper.$wrapperEl;
	      var swiperSize = swiper.size;
	      var rtl = swiper.rtlTranslate;
	      var wrongRTL = swiper.wrongRTL;
	      var isVirtual = swiper.virtual && params.virtual.enabled;
	      var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
	      var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
	      var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
	      var snapGrid = [];
	      var slidesGrid = [];
	      var slidesSizesGrid = [];
	
	      function slidesForMargin(slideIndex) {
	        if (!params.cssMode) { return true; }
	        if (slideIndex === slides.length - 1) {
	          return false;
	        }
	        return true;
	      }
	
	      var offsetBefore = params.slidesOffsetBefore;
	      if (typeof offsetBefore === 'function') {
	        offsetBefore = params.slidesOffsetBefore.call(swiper);
	      }
	
	      var offsetAfter = params.slidesOffsetAfter;
	      if (typeof offsetAfter === 'function') {
	        offsetAfter = params.slidesOffsetAfter.call(swiper);
	      }
	
	      var previousSnapGridLength = swiper.snapGrid.length;
	      var previousSlidesGridLength = swiper.snapGrid.length;
	
	      var spaceBetween = params.spaceBetween;
	      var slidePosition = -offsetBefore;
	      var prevSlideSize = 0;
	      var index = 0;
	      if (typeof swiperSize === 'undefined') {
	        return;
	      }
	      if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	        spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
	      }
	
	      swiper.virtualSize = -spaceBetween;
	
	      // reset margins
	      if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
	      else { slides.css({ marginRight: '', marginBottom: '' }); }
	
	      var slidesNumberEvenToRows;
	      if (params.slidesPerColumn > 1) {
	        if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
	          slidesNumberEvenToRows = slidesLength;
	        } else {
	          slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
	        }
	        if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
	          slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
	        }
	      }
	
	      // Calc slides
	      var slideSize;
	      var slidesPerColumn = params.slidesPerColumn;
	      var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
	      var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
	      for (var i = 0; i < slidesLength; i += 1) {
	        slideSize = 0;
	        var slide = slides.eq(i);
	        if (params.slidesPerColumn > 1) {
	          // Set slides order
	          var newSlideOrderIndex = (void 0);
	          var column = (void 0);
	          var row = (void 0);
	          if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
	            var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
	            var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
	            var columnsInGroup = groupIndex === 0
	              ? params.slidesPerGroup
	              : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
	            row = Math.floor(slideIndexInGroup / columnsInGroup);
	            column = (slideIndexInGroup - row * columnsInGroup) + groupIndex * params.slidesPerGroup;
	
	            newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
	            slide
	              .css({
	                '-webkit-box-ordinal-group': newSlideOrderIndex,
	                '-moz-box-ordinal-group': newSlideOrderIndex,
	                '-ms-flex-order': newSlideOrderIndex,
	                '-webkit-order': newSlideOrderIndex,
	                order: newSlideOrderIndex,
	              });
	          } else if (params.slidesPerColumnFill === 'column') {
	            column = Math.floor(i / slidesPerColumn);
	            row = i - (column * slidesPerColumn);
	            if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
	              row += 1;
	              if (row >= slidesPerColumn) {
	                row = 0;
	                column += 1;
	              }
	            }
	          } else {
	            row = Math.floor(i / slidesPerRow);
	            column = i - (row * slidesPerRow);
	          }
	          slide.css(
	            ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
	            (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
	          );
	        }
	        if (slide.css('display') === 'none') { continue; } // eslint-disable-line
	
	        if (params.slidesPerView === 'auto') {
	          var slideStyles = win.getComputedStyle(slide[0], null);
	          var currentTransform = slide[0].style.transform;
	          var currentWebKitTransform = slide[0].style.webkitTransform;
	          if (currentTransform) {
	            slide[0].style.transform = 'none';
	          }
	          if (currentWebKitTransform) {
	            slide[0].style.webkitTransform = 'none';
	          }
	          if (params.roundLengths) {
	            slideSize = swiper.isHorizontal()
	              ? slide.outerWidth(true)
	              : slide.outerHeight(true);
	          } else {
	            // eslint-disable-next-line
	            if (swiper.isHorizontal()) {
	              var width = parseFloat(slideStyles.getPropertyValue('width'));
	              var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
	              var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
	              var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
	              var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
	              var boxSizing = slideStyles.getPropertyValue('box-sizing');
	              if (boxSizing && boxSizing === 'border-box') {
	                slideSize = width + marginLeft + marginRight;
	              } else {
	                slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
	              }
	            } else {
	              var height = parseFloat(slideStyles.getPropertyValue('height'));
	              var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
	              var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
	              var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
	              var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
	              var boxSizing$1 = slideStyles.getPropertyValue('box-sizing');
	              if (boxSizing$1 && boxSizing$1 === 'border-box') {
	                slideSize = height + marginTop + marginBottom;
	              } else {
	                slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
	              }
	            }
	          }
	          if (currentTransform) {
	            slide[0].style.transform = currentTransform;
	          }
	          if (currentWebKitTransform) {
	            slide[0].style.webkitTransform = currentWebKitTransform;
	          }
	          if (params.roundLengths) { slideSize = Math.floor(slideSize); }
	        } else {
	          slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
	          if (params.roundLengths) { slideSize = Math.floor(slideSize); }
	
	          if (slides[i]) {
	            if (swiper.isHorizontal()) {
	              slides[i].style.width = slideSize + "px";
	            } else {
	              slides[i].style.height = slideSize + "px";
	            }
	          }
	        }
	        if (slides[i]) {
	          slides[i].swiperSlideSize = slideSize;
	        }
	        slidesSizesGrid.push(slideSize);
	
	
	        if (params.centeredSlides) {
	          slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
	          if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
	          if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
	          if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
	          if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
	          if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
	          slidesGrid.push(slidePosition);
	        } else {
	          if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
	          if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
	          slidesGrid.push(slidePosition);
	          slidePosition = slidePosition + slideSize + spaceBetween;
	        }
	
	        swiper.virtualSize += slideSize + spaceBetween;
	
	        prevSlideSize = slideSize;
	
	        index += 1;
	      }
	      swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
	      var newSlidesGrid;
	
	      if (
	        rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
	        $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
	      }
	      if (params.setWrapperSize) {
	        if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	        else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	      }
	
	      if (params.slidesPerColumn > 1) {
	        swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
	        swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
	        if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	        else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	        if (params.centeredSlides) {
	          newSlidesGrid = [];
	          for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
	            var slidesGridItem = snapGrid[i$1];
	            if (params.roundLengths) { slidesGridItem = Math.floor(slidesGridItem); }
	            if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(slidesGridItem); }
	          }
	          snapGrid = newSlidesGrid;
	        }
	      }
	
	      // Remove last grid elements depending on width
	      if (!params.centeredSlides) {
	        newSlidesGrid = [];
	        for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
	          var slidesGridItem$1 = snapGrid[i$2];
	          if (params.roundLengths) { slidesGridItem$1 = Math.floor(slidesGridItem$1); }
	          if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
	            newSlidesGrid.push(slidesGridItem$1);
	          }
	        }
	        snapGrid = newSlidesGrid;
	        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
	          snapGrid.push(swiper.virtualSize - swiperSize);
	        }
	      }
	      if (snapGrid.length === 0) { snapGrid = [0]; }
	
	      if (params.spaceBetween !== 0) {
	        if (swiper.isHorizontal()) {
	          if (rtl) { slides.filter(slidesForMargin).css({ marginLeft: (spaceBetween + "px") }); }
	          else { slides.filter(slidesForMargin).css({ marginRight: (spaceBetween + "px") }); }
	        } else { slides.filter(slidesForMargin).css({ marginBottom: (spaceBetween + "px") }); }
	      }
	
	      if (params.centeredSlides && params.centeredSlidesBounds) {
	        var allSlidesSize = 0;
	        slidesSizesGrid.forEach(function (slideSizeValue) {
	          allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
	        });
	        allSlidesSize -= params.spaceBetween;
	        var maxSnap = allSlidesSize - swiperSize;
	        snapGrid = snapGrid.map(function (snap) {
	          if (snap < 0) { return -offsetBefore; }
	          if (snap > maxSnap) { return maxSnap + offsetAfter; }
	          return snap;
	        });
	      }
	
	      if (params.centerInsufficientSlides) {
	        var allSlidesSize$1 = 0;
	        slidesSizesGrid.forEach(function (slideSizeValue) {
	          allSlidesSize$1 += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
	        });
	        allSlidesSize$1 -= params.spaceBetween;
	        if (allSlidesSize$1 < swiperSize) {
	          var allSlidesOffset = (swiperSize - allSlidesSize$1) / 2;
	          snapGrid.forEach(function (snap, snapIndex) {
	            snapGrid[snapIndex] = snap - allSlidesOffset;
	          });
	          slidesGrid.forEach(function (snap, snapIndex) {
	            slidesGrid[snapIndex] = snap + allSlidesOffset;
	          });
	        }
	      }
	
	      Utils.extend(swiper, {
	        slides: slides,
	        snapGrid: snapGrid,
	        slidesGrid: slidesGrid,
	        slidesSizesGrid: slidesSizesGrid,
	      });
	
	      if (slidesLength !== previousSlidesLength) {
	        swiper.emit('slidesLengthChange');
	      }
	      if (snapGrid.length !== previousSnapGridLength) {
	        if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
	        swiper.emit('snapGridLengthChange');
	      }
	      if (slidesGrid.length !== previousSlidesGridLength) {
	        swiper.emit('slidesGridLengthChange');
	      }
	
	      if (params.watchSlidesProgress || params.watchSlidesVisibility) {
	        swiper.updateSlidesOffset();
	      }
	    }
	
	    function updateAutoHeight (speed) {
	      var swiper = this;
	      var activeSlides = [];
	      var newHeight = 0;
	      var i;
	      if (typeof speed === 'number') {
	        swiper.setTransition(speed);
	      } else if (speed === true) {
	        swiper.setTransition(swiper.params.speed);
	      }
	      // Find slides currently in view
	      if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
	        if (swiper.params.centeredSlides) {
	          swiper.visibleSlides.each(function (index, slide) {
	            activeSlides.push(slide);
	          });
	        } else {
	          for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
	            var index = swiper.activeIndex + i;
	            if (index > swiper.slides.length) { break; }
	            activeSlides.push(swiper.slides.eq(index)[0]);
	          }
	        }
	      } else {
	        activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
	      }
	
	      // Find new height from highest slide in view
	      for (i = 0; i < activeSlides.length; i += 1) {
	        if (typeof activeSlides[i] !== 'undefined') {
	          var height = activeSlides[i].offsetHeight;
	          newHeight = height > newHeight ? height : newHeight;
	        }
	      }
	
	      // Update Height
	      if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
	    }
	
	    function updateSlidesOffset () {
	      var swiper = this;
	      var slides = swiper.slides;
	      for (var i = 0; i < slides.length; i += 1) {
	        slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
	      }
	    }
	
	    function updateSlidesProgress (translate) {
	      if ( translate === void 0 ) translate = (this && this.translate) || 0;
	
	      var swiper = this;
	      var params = swiper.params;
	
	      var slides = swiper.slides;
	      var rtl = swiper.rtlTranslate;
	
	      if (slides.length === 0) { return; }
	      if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }
	
	      var offsetCenter = -translate;
	      if (rtl) { offsetCenter = translate; }
	
	      // Visible Slides
	      slides.removeClass(params.slideVisibleClass);
	
	      swiper.visibleSlidesIndexes = [];
	      swiper.visibleSlides = [];
	
	      for (var i = 0; i < slides.length; i += 1) {
	        var slide = slides[i];
	        var slideProgress = (
	          (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
	        ) / (slide.swiperSlideSize + params.spaceBetween);
	        if (params.watchSlidesVisibility || (params.centeredSlides && params.autoHeight)) {
	          var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
	          var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
	          var isVisible = (slideBefore >= 0 && slideBefore < swiper.size - 1)
	                    || (slideAfter > 1 && slideAfter <= swiper.size)
	                    || (slideBefore <= 0 && slideAfter >= swiper.size);
	          if (isVisible) {
	            swiper.visibleSlides.push(slide);
	            swiper.visibleSlidesIndexes.push(i);
	            slides.eq(i).addClass(params.slideVisibleClass);
	          }
	        }
	        slide.progress = rtl ? -slideProgress : slideProgress;
	      }
	      swiper.visibleSlides = $(swiper.visibleSlides);
	    }
	
	    function updateProgress (translate) {
	      var swiper = this;
	      if (typeof translate === 'undefined') {
	        var multiplier = swiper.rtlTranslate ? -1 : 1;
	        // eslint-disable-next-line
	        translate = (swiper && swiper.translate && (swiper.translate * multiplier)) || 0;
	      }
	      var params = swiper.params;
	      var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	      var progress = swiper.progress;
	      var isBeginning = swiper.isBeginning;
	      var isEnd = swiper.isEnd;
	      var wasBeginning = isBeginning;
	      var wasEnd = isEnd;
	      if (translatesDiff === 0) {
	        progress = 0;
	        isBeginning = true;
	        isEnd = true;
	      } else {
	        progress = (translate - swiper.minTranslate()) / (translatesDiff);
	        isBeginning = progress <= 0;
	        isEnd = progress >= 1;
	      }
	      Utils.extend(swiper, {
	        progress: progress,
	        isBeginning: isBeginning,
	        isEnd: isEnd,
	      });
	
	      if (params.watchSlidesProgress || params.watchSlidesVisibility || (params.centeredSlides && params.autoHeight)) { swiper.updateSlidesProgress(translate); }
	
	      if (isBeginning && !wasBeginning) {
	        swiper.emit('reachBeginning toEdge');
	      }
	      if (isEnd && !wasEnd) {
	        swiper.emit('reachEnd toEdge');
	      }
	      if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
	        swiper.emit('fromEdge');
	      }
	
	      swiper.emit('progress', progress);
	    }
	
	    function updateSlidesClasses () {
	      var swiper = this;
	
	      var slides = swiper.slides;
	      var params = swiper.params;
	      var $wrapperEl = swiper.$wrapperEl;
	      var activeIndex = swiper.activeIndex;
	      var realIndex = swiper.realIndex;
	      var isVirtual = swiper.virtual && params.virtual.enabled;
	
	      slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));
	
	      var activeSlide;
	      if (isVirtual) {
	        activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
	      } else {
	        activeSlide = slides.eq(activeIndex);
	      }
	
	      // Active classes
	      activeSlide.addClass(params.slideActiveClass);
	
	      if (params.loop) {
	        // Duplicate to all looped slides
	        if (activeSlide.hasClass(params.slideDuplicateClass)) {
	          $wrapperEl
	            .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
	            .addClass(params.slideDuplicateActiveClass);
	        } else {
	          $wrapperEl
	            .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
	            .addClass(params.slideDuplicateActiveClass);
	        }
	      }
	      // Next Slide
	      var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
	      if (params.loop && nextSlide.length === 0) {
	        nextSlide = slides.eq(0);
	        nextSlide.addClass(params.slideNextClass);
	      }
	      // Prev Slide
	      var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
	      if (params.loop && prevSlide.length === 0) {
	        prevSlide = slides.eq(-1);
	        prevSlide.addClass(params.slidePrevClass);
	      }
	      if (params.loop) {
	        // Duplicate to all looped slides
	        if (nextSlide.hasClass(params.slideDuplicateClass)) {
	          $wrapperEl
	            .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
	            .addClass(params.slideDuplicateNextClass);
	        } else {
	          $wrapperEl
	            .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
	            .addClass(params.slideDuplicateNextClass);
	        }
	        if (prevSlide.hasClass(params.slideDuplicateClass)) {
	          $wrapperEl
	            .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
	            .addClass(params.slideDuplicatePrevClass);
	        } else {
	          $wrapperEl
	            .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
	            .addClass(params.slideDuplicatePrevClass);
	        }
	      }
	    }
	
	    function updateActiveIndex (newActiveIndex) {
	      var swiper = this;
	      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	      var slidesGrid = swiper.slidesGrid;
	      var snapGrid = swiper.snapGrid;
	      var params = swiper.params;
	      var previousIndex = swiper.activeIndex;
	      var previousRealIndex = swiper.realIndex;
	      var previousSnapIndex = swiper.snapIndex;
	      var activeIndex = newActiveIndex;
	      var snapIndex;
	      if (typeof activeIndex === 'undefined') {
	        for (var i = 0; i < slidesGrid.length; i += 1) {
	          if (typeof slidesGrid[i + 1] !== 'undefined') {
	            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
	              activeIndex = i;
	            } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
	              activeIndex = i + 1;
	            }
	          } else if (translate >= slidesGrid[i]) {
	            activeIndex = i;
	          }
	        }
	        // Normalize slideIndex
	        if (params.normalizeSlideIndex) {
	          if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
	        }
	      }
	      if (snapGrid.indexOf(translate) >= 0) {
	        snapIndex = snapGrid.indexOf(translate);
	      } else {
	        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
	        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
	      }
	      if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
	      if (activeIndex === previousIndex) {
	        if (snapIndex !== previousSnapIndex) {
	          swiper.snapIndex = snapIndex;
	          swiper.emit('snapIndexChange');
	        }
	        return;
	      }
	
	      // Get real index
	      var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
	
	      Utils.extend(swiper, {
	        snapIndex: snapIndex,
	        realIndex: realIndex,
	        previousIndex: previousIndex,
	        activeIndex: activeIndex,
	      });
	      swiper.emit('activeIndexChange');
	      swiper.emit('snapIndexChange');
	      if (previousRealIndex !== realIndex) {
	        swiper.emit('realIndexChange');
	      }
	      if (swiper.initialized || swiper.params.runCallbacksOnInit) {
	        swiper.emit('slideChange');
	      }
	    }
	
	    function updateClickedSlide (e) {
	      var swiper = this;
	      var params = swiper.params;
	      var slide = $(e.target).closest(("." + (params.slideClass)))[0];
	      var slideFound = false;
	      if (slide) {
	        for (var i = 0; i < swiper.slides.length; i += 1) {
	          if (swiper.slides[i] === slide) { slideFound = true; }
	        }
	      }
	
	      if (slide && slideFound) {
	        swiper.clickedSlide = slide;
	        if (swiper.virtual && swiper.params.virtual.enabled) {
	          swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
	        } else {
	          swiper.clickedIndex = $(slide).index();
	        }
	      } else {
	        swiper.clickedSlide = undefined;
	        swiper.clickedIndex = undefined;
	        return;
	      }
	      if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
	        swiper.slideToClickedSlide();
	      }
	    }
	
	    var update = {
	      updateSize: updateSize,
	      updateSlides: updateSlides,
	      updateAutoHeight: updateAutoHeight,
	      updateSlidesOffset: updateSlidesOffset,
	      updateSlidesProgress: updateSlidesProgress,
	      updateProgress: updateProgress,
	      updateSlidesClasses: updateSlidesClasses,
	      updateActiveIndex: updateActiveIndex,
	      updateClickedSlide: updateClickedSlide,
	    };
	
	    function getTranslate (axis) {
	      if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';
	
	      var swiper = this;
	
	      var params = swiper.params;
	      var rtl = swiper.rtlTranslate;
	      var translate = swiper.translate;
	      var $wrapperEl = swiper.$wrapperEl;
	
	      if (params.virtualTranslate) {
	        return rtl ? -translate : translate;
	      }
	      if (params.cssMode) {
	        return translate;
	      }
	
	      var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
	      if (rtl) { currentTranslate = -currentTranslate; }
	
	      return currentTranslate || 0;
	    }
	
	    function setTranslate (translate, byController) {
	      var swiper = this;
	      var rtl = swiper.rtlTranslate;
	      var params = swiper.params;
	      var $wrapperEl = swiper.$wrapperEl;
	      var wrapperEl = swiper.wrapperEl;
	      var progress = swiper.progress;
	      var x = 0;
	      var y = 0;
	      var z = 0;
	
	      if (swiper.isHorizontal()) {
	        x = rtl ? -translate : translate;
	      } else {
	        y = translate;
	      }
	
	      if (params.roundLengths) {
	        x = Math.floor(x);
	        y = Math.floor(y);
	      }
	
	      if (params.cssMode) {
	        wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
	      } else if (!params.virtualTranslate) {
	        $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)"));
	      }
	      swiper.previousTranslate = swiper.translate;
	      swiper.translate = swiper.isHorizontal() ? x : y;
	
	      // Check if we need to update progress
	      var newProgress;
	      var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	      if (translatesDiff === 0) {
	        newProgress = 0;
	      } else {
	        newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
	      }
	      if (newProgress !== progress) {
	        swiper.updateProgress(translate);
	      }
	
	      swiper.emit('setTranslate', swiper.translate, byController);
	    }
	
	    function minTranslate () {
	      return (-this.snapGrid[0]);
	    }
	
	    function maxTranslate () {
	      return (-this.snapGrid[this.snapGrid.length - 1]);
	    }
	
	    function translateTo (translate, speed, runCallbacks, translateBounds, internal) {
	      var obj;
	
	      if ( translate === void 0 ) translate = 0;
	      if ( speed === void 0 ) speed = this.params.speed;
	      if ( runCallbacks === void 0 ) runCallbacks = true;
	      if ( translateBounds === void 0 ) translateBounds = true;
	      var swiper = this;
	
	      var params = swiper.params;
	      var wrapperEl = swiper.wrapperEl;
	
	      if (swiper.animating && params.preventInteractionOnTransition) {
	        return false;
	      }
	
	      var minTranslate = swiper.minTranslate();
	      var maxTranslate = swiper.maxTranslate();
	      var newTranslate;
	      if (translateBounds && translate > minTranslate) { newTranslate = minTranslate; }
	      else if (translateBounds && translate < maxTranslate) { newTranslate = maxTranslate; }
	      else { newTranslate = translate; }
	
	      // Update progress
	      swiper.updateProgress(newTranslate);
	
	      if (params.cssMode) {
	        var isH = swiper.isHorizontal();
	        if (speed === 0) {
	          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
	        } else {
	          // eslint-disable-next-line
	          if (wrapperEl.scrollTo) {
	            wrapperEl.scrollTo(( obj = {}, obj[isH ? 'left' : 'top'] = -newTranslate, obj.behavior = 'smooth', obj ));
	          } else {
	            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
	          }
	        }
	        return true;
	      }
	
	      if (speed === 0) {
	        swiper.setTransition(0);
	        swiper.setTranslate(newTranslate);
	        if (runCallbacks) {
	          swiper.emit('beforeTransitionStart', speed, internal);
	          swiper.emit('transitionEnd');
	        }
	      } else {
	        swiper.setTransition(speed);
	        swiper.setTranslate(newTranslate);
	        if (runCallbacks) {
	          swiper.emit('beforeTransitionStart', speed, internal);
	          swiper.emit('transitionStart');
	        }
	        if (!swiper.animating) {
	          swiper.animating = true;
	          if (!swiper.onTranslateToWrapperTransitionEnd) {
	            swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
	              if (!swiper || swiper.destroyed) { return; }
	              if (e.target !== this) { return; }
	              swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
	              swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
	              swiper.onTranslateToWrapperTransitionEnd = null;
	              delete swiper.onTranslateToWrapperTransitionEnd;
	              if (runCallbacks) {
	                swiper.emit('transitionEnd');
	              }
	            };
	          }
	          swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
	          swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
	        }
	      }
	
	      return true;
	    }
	
	    var translate = {
	      getTranslate: getTranslate,
	      setTranslate: setTranslate,
	      minTranslate: minTranslate,
	      maxTranslate: maxTranslate,
	      translateTo: translateTo,
	    };
	
	    function setTransition (duration, byController) {
	      var swiper = this;
	
	      if (!swiper.params.cssMode) {
	        swiper.$wrapperEl.transition(duration);
	      }
	
	      swiper.emit('setTransition', duration, byController);
	    }
	
	    function transitionStart (runCallbacks, direction) {
	      if ( runCallbacks === void 0 ) runCallbacks = true;
	
	      var swiper = this;
	      var activeIndex = swiper.activeIndex;
	      var params = swiper.params;
	      var previousIndex = swiper.previousIndex;
	      if (params.cssMode) { return; }
	      if (params.autoHeight) {
	        swiper.updateAutoHeight();
	      }
	
	      var dir = direction;
	      if (!dir) {
	        if (activeIndex > previousIndex) { dir = 'next'; }
	        else if (activeIndex < previousIndex) { dir = 'prev'; }
	        else { dir = 'reset'; }
	      }
	
	      swiper.emit('transitionStart');
	
	      if (runCallbacks && activeIndex !== previousIndex) {
	        if (dir === 'reset') {
	          swiper.emit('slideResetTransitionStart');
	          return;
	        }
	        swiper.emit('slideChangeTransitionStart');
	        if (dir === 'next') {
	          swiper.emit('slideNextTransitionStart');
	        } else {
	          swiper.emit('slidePrevTransitionStart');
	        }
	      }
	    }
	
	    function transitionEnd$1 (runCallbacks, direction) {
	      if ( runCallbacks === void 0 ) runCallbacks = true;
	
	      var swiper = this;
	      var activeIndex = swiper.activeIndex;
	      var previousIndex = swiper.previousIndex;
	      var params = swiper.params;
	      swiper.animating = false;
	      if (params.cssMode) { return; }
	      swiper.setTransition(0);
	
	      var dir = direction;
	      if (!dir) {
	        if (activeIndex > previousIndex) { dir = 'next'; }
	        else if (activeIndex < previousIndex) { dir = 'prev'; }
	        else { dir = 'reset'; }
	      }
	
	      swiper.emit('transitionEnd');
	
	      if (runCallbacks && activeIndex !== previousIndex) {
	        if (dir === 'reset') {
	          swiper.emit('slideResetTransitionEnd');
	          return;
	        }
	        swiper.emit('slideChangeTransitionEnd');
	        if (dir === 'next') {
	          swiper.emit('slideNextTransitionEnd');
	        } else {
	          swiper.emit('slidePrevTransitionEnd');
	        }
	      }
	    }
	
	    var transition$1 = {
	      setTransition: setTransition,
	      transitionStart: transitionStart,
	      transitionEnd: transitionEnd$1,
	    };
	
	    function slideTo (index, speed, runCallbacks, internal) {
	      var obj;
	
	      if ( index === void 0 ) index = 0;
	      if ( speed === void 0 ) speed = this.params.speed;
	      if ( runCallbacks === void 0 ) runCallbacks = true;
	      var swiper = this;
	      var slideIndex = index;
	      if (slideIndex < 0) { slideIndex = 0; }
	
	      var params = swiper.params;
	      var snapGrid = swiper.snapGrid;
	      var slidesGrid = swiper.slidesGrid;
	      var previousIndex = swiper.previousIndex;
	      var activeIndex = swiper.activeIndex;
	      var rtl = swiper.rtlTranslate;
	      var wrapperEl = swiper.wrapperEl;
	      if (swiper.animating && params.preventInteractionOnTransition) {
	        return false;
	      }
	
	      var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
	      var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
	      if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
	
	      if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
	        swiper.emit('beforeSlideChangeStart');
	      }
	
	      var translate = -snapGrid[snapIndex];
	
	      // Update progress
	      swiper.updateProgress(translate);
	
	      // Normalize slideIndex
	      if (params.normalizeSlideIndex) {
	        for (var i = 0; i < slidesGrid.length; i += 1) {
	          if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
	            slideIndex = i;
	          }
	        }
	      }
	      // Directions locks
	      if (swiper.initialized && slideIndex !== activeIndex) {
	        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
	          return false;
	        }
	        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
	          if ((activeIndex || 0) !== slideIndex) { return false; }
	        }
	      }
	
	      var direction;
	      if (slideIndex > activeIndex) { direction = 'next'; }
	      else if (slideIndex < activeIndex) { direction = 'prev'; }
	      else { direction = 'reset'; }
	
	
	      // Update Index
	      if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
	        swiper.updateActiveIndex(slideIndex);
	        // Update Height
	        if (params.autoHeight) {
	          swiper.updateAutoHeight();
	        }
	        swiper.updateSlidesClasses();
	        if (params.effect !== 'slide') {
	          swiper.setTranslate(translate);
	        }
	        if (direction !== 'reset') {
	          swiper.transitionStart(runCallbacks, direction);
	          swiper.transitionEnd(runCallbacks, direction);
	        }
	        return false;
	      }
	      if (params.cssMode) {
	        var isH = swiper.isHorizontal();
	        var t = -translate;
	        if (rtl) {
	          t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
	        }
	        if (speed === 0) {
	          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
	        } else {
	          // eslint-disable-next-line
	          if (wrapperEl.scrollTo) {
	            wrapperEl.scrollTo(( obj = {}, obj[isH ? 'left' : 'top'] = t, obj.behavior = 'smooth', obj ));
	          } else {
	            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
	          }
	        }
	        return true;
	      }
	
	      if (speed === 0) {
	        swiper.setTransition(0);
	        swiper.setTranslate(translate);
	        swiper.updateActiveIndex(slideIndex);
	        swiper.updateSlidesClasses();
	        swiper.emit('beforeTransitionStart', speed, internal);
	        swiper.transitionStart(runCallbacks, direction);
	        swiper.transitionEnd(runCallbacks, direction);
	      } else {
	        swiper.setTransition(speed);
	        swiper.setTranslate(translate);
	        swiper.updateActiveIndex(slideIndex);
	        swiper.updateSlidesClasses();
	        swiper.emit('beforeTransitionStart', speed, internal);
	        swiper.transitionStart(runCallbacks, direction);
	        if (!swiper.animating) {
	          swiper.animating = true;
	          if (!swiper.onSlideToWrapperTransitionEnd) {
	            swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
	              if (!swiper || swiper.destroyed) { return; }
	              if (e.target !== this) { return; }
	              swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	              swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	              swiper.onSlideToWrapperTransitionEnd = null;
	              delete swiper.onSlideToWrapperTransitionEnd;
	              swiper.transitionEnd(runCallbacks, direction);
	            };
	          }
	          swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	          swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	        }
	      }
	
	      return true;
	    }
	
	    function slideToLoop (index, speed, runCallbacks, internal) {
	      if ( index === void 0 ) index = 0;
	      if ( speed === void 0 ) speed = this.params.speed;
	      if ( runCallbacks === void 0 ) runCallbacks = true;
	
	      var swiper = this;
	      var newIndex = index;
	      if (swiper.params.loop) {
	        newIndex += swiper.loopedSlides;
	      }
	
	      return swiper.slideTo(newIndex, speed, runCallbacks, internal);
	    }
	
	    /* eslint no-unused-vars: "off" */
	    function slideNext (speed, runCallbacks, internal) {
	      if ( speed === void 0 ) speed = this.params.speed;
	      if ( runCallbacks === void 0 ) runCallbacks = true;
	
	      var swiper = this;
	      var params = swiper.params;
	      var animating = swiper.animating;
	      var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;
	      if (params.loop) {
	        if (animating) { return false; }
	        swiper.loopFix();
	        // eslint-disable-next-line
	        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	      }
	      return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
	    }
	
	    /* eslint no-unused-vars: "off" */
	    function slidePrev (speed, runCallbacks, internal) {
	      if ( speed === void 0 ) speed = this.params.speed;
	      if ( runCallbacks === void 0 ) runCallbacks = true;
	
	      var swiper = this;
	      var params = swiper.params;
	      var animating = swiper.animating;
	      var snapGrid = swiper.snapGrid;
	      var slidesGrid = swiper.slidesGrid;
	      var rtlTranslate = swiper.rtlTranslate;
	
	      if (params.loop) {
	        if (animating) { return false; }
	        swiper.loopFix();
	        // eslint-disable-next-line
	        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	      }
	      var translate = rtlTranslate ? swiper.translate : -swiper.translate;
	      function normalize(val) {
	        if (val < 0) { return -Math.floor(Math.abs(val)); }
	        return Math.floor(val);
	      }
	      var normalizedTranslate = normalize(translate);
	      var normalizedSnapGrid = snapGrid.map(function (val) { return normalize(val); });
	      var normalizedSlidesGrid = slidesGrid.map(function (val) { return normalize(val); });
	
	      var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
	      var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
	      if (typeof prevSnap === 'undefined' && params.cssMode) {
	        snapGrid.forEach(function (snap) {
	          if (!prevSnap && normalizedTranslate >= snap) { prevSnap = snap; }
	        });
	      }
	      var prevIndex;
	      if (typeof prevSnap !== 'undefined') {
	        prevIndex = slidesGrid.indexOf(prevSnap);
	        if (prevIndex < 0) { prevIndex = swiper.activeIndex - 1; }
	      }
	      return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
	    }
	
	    /* eslint no-unused-vars: "off" */
	    function slideReset (speed, runCallbacks, internal) {
	      if ( speed === void 0 ) speed = this.params.speed;
	      if ( runCallbacks === void 0 ) runCallbacks = true;
	
	      var swiper = this;
	      return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
	    }
	
	    /* eslint no-unused-vars: "off" */
	    function slideToClosest (speed, runCallbacks, internal, threshold) {
	      if ( speed === void 0 ) speed = this.params.speed;
	      if ( runCallbacks === void 0 ) runCallbacks = true;
	      if ( threshold === void 0 ) threshold = 0.5;
	
	      var swiper = this;
	      var index = swiper.activeIndex;
	      var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
	      var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
	
	      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	
	      if (translate >= swiper.snapGrid[snapIndex]) {
	        // The current translate is on or after the current snap index, so the choice
	        // is between the current index and the one after it.
	        var currentSnap = swiper.snapGrid[snapIndex];
	        var nextSnap = swiper.snapGrid[snapIndex + 1];
	        if ((translate - currentSnap) > (nextSnap - currentSnap) * threshold) {
	          index += swiper.params.slidesPerGroup;
	        }
	      } else {
	        // The current translate is before the current snap index, so the choice
	        // is between the current index and the one before it.
	        var prevSnap = swiper.snapGrid[snapIndex - 1];
	        var currentSnap$1 = swiper.snapGrid[snapIndex];
	        if ((translate - prevSnap) <= (currentSnap$1 - prevSnap) * threshold) {
	          index -= swiper.params.slidesPerGroup;
	        }
	      }
	      index = Math.max(index, 0);
	      index = Math.min(index, swiper.slidesGrid.length - 1);
	
	      return swiper.slideTo(index, speed, runCallbacks, internal);
	    }
	
	    function slideToClickedSlide () {
	      var swiper = this;
	      var params = swiper.params;
	      var $wrapperEl = swiper.$wrapperEl;
	
	      var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
	      var slideToIndex = swiper.clickedIndex;
	      var realIndex;
	      if (params.loop) {
	        if (swiper.animating) { return; }
	        realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	        if (params.centeredSlides) {
	          if (
	            (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
	            || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
	          ) {
	            swiper.loopFix();
	            slideToIndex = $wrapperEl
	              .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
	              .eq(0)
	              .index();
	
	            Utils.nextTick(function () {
	              swiper.slideTo(slideToIndex);
	            });
	          } else {
	            swiper.slideTo(slideToIndex);
	          }
	        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
	          swiper.loopFix();
	          slideToIndex = $wrapperEl
	            .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
	            .eq(0)
	            .index();
	
	          Utils.nextTick(function () {
	            swiper.slideTo(slideToIndex);
	          });
	        } else {
	          swiper.slideTo(slideToIndex);
	        }
	      } else {
	        swiper.slideTo(slideToIndex);
	      }
	    }
	
	    var slide = {
	      slideTo: slideTo,
	      slideToLoop: slideToLoop,
	      slideNext: slideNext,
	      slidePrev: slidePrev,
	      slideReset: slideReset,
	      slideToClosest: slideToClosest,
	      slideToClickedSlide: slideToClickedSlide,
	    };
	
	    function loopCreate () {
	      var swiper = this;
	      var params = swiper.params;
	      var $wrapperEl = swiper.$wrapperEl;
	      // Remove duplicated slides
	      $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();
	
	      var slides = $wrapperEl.children(("." + (params.slideClass)));
	
	      if (params.loopFillGroupWithBlank) {
	        var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
	        if (blankSlidesNum !== params.slidesPerGroup) {
	          for (var i = 0; i < blankSlidesNum; i += 1) {
	            var blankNode = $(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
	            $wrapperEl.append(blankNode);
	          }
	          slides = $wrapperEl.children(("." + (params.slideClass)));
	        }
	      }
	
	      if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }
	
	      swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
	      swiper.loopedSlides += params.loopAdditionalSlides;
	      if (swiper.loopedSlides > slides.length) {
	        swiper.loopedSlides = slides.length;
	      }
	
	      var prependSlides = [];
	      var appendSlides = [];
	      slides.each(function (index, el) {
	        var slide = $(el);
	        if (index < swiper.loopedSlides) { appendSlides.push(el); }
	        if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
	        slide.attr('data-swiper-slide-index', index);
	      });
	      for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
	        $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
	      }
	      for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
	        $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
	      }
	    }
	
	    function loopFix () {
	      var swiper = this;
	
	      swiper.emit('beforeLoopFix');
	
	      var activeIndex = swiper.activeIndex;
	      var slides = swiper.slides;
	      var loopedSlides = swiper.loopedSlides;
	      var allowSlidePrev = swiper.allowSlidePrev;
	      var allowSlideNext = swiper.allowSlideNext;
	      var snapGrid = swiper.snapGrid;
	      var rtl = swiper.rtlTranslate;
	      var newIndex;
	      swiper.allowSlidePrev = true;
	      swiper.allowSlideNext = true;
	
	      var snapTranslate = -snapGrid[activeIndex];
	      var diff = snapTranslate - swiper.getTranslate();
	
	      // Fix For Negative Oversliding
	      if (activeIndex < loopedSlides) {
	        newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
	        newIndex += loopedSlides;
	        var slideChanged = swiper.slideTo(newIndex, 0, false, true);
	        if (slideChanged && diff !== 0) {
	          swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	        }
	      } else if (activeIndex >= slides.length - loopedSlides) {
	        // Fix For Positive Oversliding
	        newIndex = -slides.length + activeIndex + loopedSlides;
	        newIndex += loopedSlides;
	        var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
	        if (slideChanged$1 && diff !== 0) {
	          swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	        }
	      }
	      swiper.allowSlidePrev = allowSlidePrev;
	      swiper.allowSlideNext = allowSlideNext;
	
	      swiper.emit('loopFix');
	    }
	
	    function loopDestroy () {
	      var swiper = this;
	      var $wrapperEl = swiper.$wrapperEl;
	      var params = swiper.params;
	      var slides = swiper.slides;
	      $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + ",." + (params.slideClass) + "." + (params.slideBlankClass))).remove();
	      slides.removeAttr('data-swiper-slide-index');
	    }
	
	    var loop = {
	      loopCreate: loopCreate,
	      loopFix: loopFix,
	      loopDestroy: loopDestroy,
	    };
	
	    function setGrabCursor (moving) {
	      var swiper = this;
	      if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked) || swiper.params.cssMode) { return; }
	      var el = swiper.el;
	      el.style.cursor = 'move';
	      el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
	      el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
	      el.style.cursor = moving ? 'grabbing' : 'grab';
	    }
	
	    function unsetGrabCursor () {
	      var swiper = this;
	      if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked) || swiper.params.cssMode) { return; }
	      swiper.el.style.cursor = '';
	    }
	
	    var grabCursor = {
	      setGrabCursor: setGrabCursor,
	      unsetGrabCursor: unsetGrabCursor,
	    };
	
	    function appendSlide (slides) {
	      var swiper = this;
	      var $wrapperEl = swiper.$wrapperEl;
	      var params = swiper.params;
	      if (params.loop) {
	        swiper.loopDestroy();
	      }
	      if (typeof slides === 'object' && 'length' in slides) {
	        for (var i = 0; i < slides.length; i += 1) {
	          if (slides[i]) { $wrapperEl.append(slides[i]); }
	        }
	      } else {
	        $wrapperEl.append(slides);
	      }
	      if (params.loop) {
	        swiper.loopCreate();
	      }
	      if (!(params.observer && Support.observer)) {
	        swiper.update();
	      }
	    }
	
	    function prependSlide (slides) {
	      var swiper = this;
	      var params = swiper.params;
	      var $wrapperEl = swiper.$wrapperEl;
	      var activeIndex = swiper.activeIndex;
	
	      if (params.loop) {
	        swiper.loopDestroy();
	      }
	      var newActiveIndex = activeIndex + 1;
	      if (typeof slides === 'object' && 'length' in slides) {
	        for (var i = 0; i < slides.length; i += 1) {
	          if (slides[i]) { $wrapperEl.prepend(slides[i]); }
	        }
	        newActiveIndex = activeIndex + slides.length;
	      } else {
	        $wrapperEl.prepend(slides);
	      }
	      if (params.loop) {
	        swiper.loopCreate();
	      }
	      if (!(params.observer && Support.observer)) {
	        swiper.update();
	      }
	      swiper.slideTo(newActiveIndex, 0, false);
	    }
	
	    function addSlide (index, slides) {
	      var swiper = this;
	      var $wrapperEl = swiper.$wrapperEl;
	      var params = swiper.params;
	      var activeIndex = swiper.activeIndex;
	      var activeIndexBuffer = activeIndex;
	      if (params.loop) {
	        activeIndexBuffer -= swiper.loopedSlides;
	        swiper.loopDestroy();
	        swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
	      }
	      var baseLength = swiper.slides.length;
	      if (index <= 0) {
	        swiper.prependSlide(slides);
	        return;
	      }
	      if (index >= baseLength) {
	        swiper.appendSlide(slides);
	        return;
	      }
	      var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
	
	      var slidesBuffer = [];
	      for (var i = baseLength - 1; i >= index; i -= 1) {
	        var currentSlide = swiper.slides.eq(i);
	        currentSlide.remove();
	        slidesBuffer.unshift(currentSlide);
	      }
	
	      if (typeof slides === 'object' && 'length' in slides) {
	        for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
	          if (slides[i$1]) { $wrapperEl.append(slides[i$1]); }
	        }
	        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
	      } else {
	        $wrapperEl.append(slides);
	      }
	
	      for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
	        $wrapperEl.append(slidesBuffer[i$2]);
	      }
	
	      if (params.loop) {
	        swiper.loopCreate();
	      }
	      if (!(params.observer && Support.observer)) {
	        swiper.update();
	      }
	      if (params.loop) {
	        swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	      } else {
	        swiper.slideTo(newActiveIndex, 0, false);
	      }
	    }
	
	    function removeSlide (slidesIndexes) {
	      var swiper = this;
	      var params = swiper.params;
	      var $wrapperEl = swiper.$wrapperEl;
	      var activeIndex = swiper.activeIndex;
	
	      var activeIndexBuffer = activeIndex;
	      if (params.loop) {
	        activeIndexBuffer -= swiper.loopedSlides;
	        swiper.loopDestroy();
	        swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
	      }
	      var newActiveIndex = activeIndexBuffer;
	      var indexToRemove;
	
	      if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
	        for (var i = 0; i < slidesIndexes.length; i += 1) {
	          indexToRemove = slidesIndexes[i];
	          if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
	          if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
	        }
	        newActiveIndex = Math.max(newActiveIndex, 0);
	      } else {
	        indexToRemove = slidesIndexes;
	        if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
	        if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
	        newActiveIndex = Math.max(newActiveIndex, 0);
	      }
	
	      if (params.loop) {
	        swiper.loopCreate();
	      }
	
	      if (!(params.observer && Support.observer)) {
	        swiper.update();
	      }
	      if (params.loop) {
	        swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	      } else {
	        swiper.slideTo(newActiveIndex, 0, false);
	      }
	    }
	
	    function removeAllSlides () {
	      var swiper = this;
	
	      var slidesIndexes = [];
	      for (var i = 0; i < swiper.slides.length; i += 1) {
	        slidesIndexes.push(i);
	      }
	      swiper.removeSlide(slidesIndexes);
	    }
	
	    var manipulation = {
	      appendSlide: appendSlide,
	      prependSlide: prependSlide,
	      addSlide: addSlide,
	      removeSlide: removeSlide,
	      removeAllSlides: removeAllSlides,
	    };
	
	    var Device = (function Device() {
	      var platform = win.navigator.platform;
	      var ua = win.navigator.userAgent;
	
	      var device = {
	        ios: false,
	        android: false,
	        androidChrome: false,
	        desktop: false,
	        iphone: false,
	        ipod: false,
	        ipad: false,
	        edge: false,
	        ie: false,
	        firefox: false,
	        macos: false,
	        windows: false,
	        cordova: !!(win.cordova || win.phonegap),
	        phonegap: !!(win.cordova || win.phonegap),
	        electron: false,
	      };
	
	      var screenWidth = win.screen.width;
	      var screenHeight = win.screen.height;
	
	      var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	      var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	      var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	      var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	      var ie = ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
	      var edge = ua.indexOf('Edge/') >= 0;
	      var firefox = ua.indexOf('Gecko/') >= 0 && ua.indexOf('Firefox/') >= 0;
	      var windows = platform === 'Win32';
	      var electron = ua.toLowerCase().indexOf('electron') >= 0;
	      var macos = platform === 'MacIntel';
	
	      // iPadOs 13 fix
	      if (!ipad
	        && macos
	        && Support.touch
	        && (
	          (screenWidth === 1024 && screenHeight === 1366) // Pro 12.9
	          || (screenWidth === 834 && screenHeight === 1194) // Pro 11
	          || (screenWidth === 834 && screenHeight === 1112) // Pro 10.5
	          || (screenWidth === 768 && screenHeight === 1024) // other
	        )
	      ) {
	        ipad = ua.match(/(Version)\/([\d.]+)/);
	        macos = false;
	      }
	
	      device.ie = ie;
	      device.edge = edge;
	      device.firefox = firefox;
	
	      // Android
	      if (android && !windows) {
	        device.os = 'android';
	        device.osVersion = android[2];
	        device.android = true;
	        device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
	      }
	      if (ipad || iphone || ipod) {
	        device.os = 'ios';
	        device.ios = true;
	      }
	      // iOS
	      if (iphone && !ipod) {
	        device.osVersion = iphone[2].replace(/_/g, '.');
	        device.iphone = true;
	      }
	      if (ipad) {
	        device.osVersion = ipad[2].replace(/_/g, '.');
	        device.ipad = true;
	      }
	      if (ipod) {
	        device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	        device.ipod = true;
	      }
	      // iOS 8+ changed UA
	      if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
	        if (device.osVersion.split('.')[0] === '10') {
	          device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
	        }
	      }
	
	      // Webview
	      device.webView = !!((iphone || ipad || ipod) && (ua.match(/.*AppleWebKit(?!.*Safari)/i) || win.navigator.standalone))
	        || (win.matchMedia && win.matchMedia('(display-mode: standalone)').matches);
	      device.webview = device.webView;
	      device.standalone = device.webView;
	
	      // Desktop
	      device.desktop = !(device.ios || device.android) || electron;
	      if (device.desktop) {
	        device.electron = electron;
	        device.macos = macos;
	        device.windows = windows;
	        if (device.macos) {
	          device.os = 'macos';
	        }
	        if (device.windows) {
	          device.os = 'windows';
	        }
	      }
	
	      // Pixel Ratio
	      device.pixelRatio = win.devicePixelRatio || 1;
	
	      // Export object
	      return device;
	    }());
	
	    function onTouchStart (event) {
	      var swiper = this;
	      var data = swiper.touchEventsData;
	      var params = swiper.params;
	      var touches = swiper.touches;
	
	      if (swiper.animating && params.preventInteractionOnTransition) {
	        return;
	      }
	      var e = event;
	      if (e.originalEvent) { e = e.originalEvent; }
	      var $targetEl = $(e.target);
	
	      if (params.touchEventsTarget === 'wrapper') {
	        if (!$targetEl.closest(swiper.wrapperEl).length) { return; }
	      }
	      data.isTouchEvent = e.type === 'touchstart';
	      if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
	      if (!data.isTouchEvent && 'button' in e && e.button > 0) { return; }
	      if (data.isTouched && data.isMoved) { return; }
	      if (params.noSwiping && $targetEl.closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
	        swiper.allowClick = true;
	        return;
	      }
	      if (params.swipeHandler) {
	        if (!$targetEl.closest(params.swipeHandler)[0]) { return; }
	      }
	
	      touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	      touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	      var startX = touches.currentX;
	      var startY = touches.currentY;
	
	      // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
	
	      var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
	      var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
	      if (
	        edgeSwipeDetection
	        && ((startX <= edgeSwipeThreshold)
	        || (startX >= win.screen.width - edgeSwipeThreshold))
	      ) {
	        return;
	      }
	
	      Utils.extend(data, {
	        isTouched: true,
	        isMoved: false,
	        allowTouchCallbacks: true,
	        isScrolling: undefined,
	        startMoving: undefined,
	      });
	
	      touches.startX = startX;
	      touches.startY = startY;
	      data.touchStartTime = Utils.now();
	      swiper.allowClick = true;
	      swiper.updateSize();
	      swiper.swipeDirection = undefined;
	      if (params.threshold > 0) { data.allowThresholdMove = false; }
	      if (e.type !== 'touchstart') {
	        var preventDefault = true;
	        if ($targetEl.is(data.formElements)) { preventDefault = false; }
	        if (
	          doc.activeElement
	          && $(doc.activeElement).is(data.formElements)
	          && doc.activeElement !== $targetEl[0]
	        ) {
	          doc.activeElement.blur();
	        }
	
	        var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
	        if (params.touchStartForcePreventDefault || shouldPreventDefault) {
	          e.preventDefault();
	        }
	      }
	      swiper.emit('touchStart', e);
	    }
	
	    function onTouchMove (event) {
	      var swiper = this;
	      var data = swiper.touchEventsData;
	      var params = swiper.params;
	      var touches = swiper.touches;
	      var rtl = swiper.rtlTranslate;
	      var e = event;
	      if (e.originalEvent) { e = e.originalEvent; }
	      if (!data.isTouched) {
	        if (data.startMoving && data.isScrolling) {
	          swiper.emit('touchMoveOpposite', e);
	        }
	        return;
	      }
	      if (data.isTouchEvent && e.type !== 'touchmove') { return; }
	      var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
	      var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
	      var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
	      if (e.preventedByNestedSwiper) {
	        touches.startX = pageX;
	        touches.startY = pageY;
	        return;
	      }
	      if (!swiper.allowTouchMove) {
	        // isMoved = true;
	        swiper.allowClick = false;
	        if (data.isTouched) {
	          Utils.extend(touches, {
	            startX: pageX,
	            startY: pageY,
	            currentX: pageX,
	            currentY: pageY,
	          });
	          data.touchStartTime = Utils.now();
	        }
	        return;
	      }
	      if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
	        if (swiper.isVertical()) {
	          // Vertical
	          if (
	            (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
	            || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
	          ) {
	            data.isTouched = false;
	            data.isMoved = false;
	            return;
	          }
	        } else if (
	          (pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
	          || (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
	        ) {
	          return;
	        }
	      }
	      if (data.isTouchEvent && doc.activeElement) {
	        if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
	          data.isMoved = true;
	          swiper.allowClick = false;
	          return;
	        }
	      }
	      if (data.allowTouchCallbacks) {
	        swiper.emit('touchMove', e);
	      }
	      if (e.targetTouches && e.targetTouches.length > 1) { return; }
	
	      touches.currentX = pageX;
	      touches.currentY = pageY;
	
	      var diffX = touches.currentX - touches.startX;
	      var diffY = touches.currentY - touches.startY;
	      if (swiper.params.threshold && Math.sqrt((Math.pow( diffX, 2 )) + (Math.pow( diffY, 2 ))) < swiper.params.threshold) { return; }
	
	      if (typeof data.isScrolling === 'undefined') {
	        var touchAngle;
	        if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
	          data.isScrolling = false;
	        } else {
	          // eslint-disable-next-line
	          if ((diffX * diffX) + (diffY * diffY) >= 25) {
	            touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
	            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
	          }
	        }
	      }
	      if (data.isScrolling) {
	        swiper.emit('touchMoveOpposite', e);
	      }
	      if (typeof data.startMoving === 'undefined') {
	        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
	          data.startMoving = true;
	        }
	      }
	      if (data.isScrolling) {
	        data.isTouched = false;
	        return;
	      }
	      if (!data.startMoving) {
	        return;
	      }
	      swiper.allowClick = false;
	      if (!params.cssMode && e.cancelable) {
	        e.preventDefault();
	      }
	      if (params.touchMoveStopPropagation && !params.nested) {
	        e.stopPropagation();
	      }
	
	      if (!data.isMoved) {
	        if (params.loop) {
	          swiper.loopFix();
	        }
	        data.startTranslate = swiper.getTranslate();
	        swiper.setTransition(0);
	        if (swiper.animating) {
	          swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
	        }
	        data.allowMomentumBounce = false;
	        // Grab Cursor
	        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	          swiper.setGrabCursor(true);
	        }
	        swiper.emit('sliderFirstMove', e);
	      }
	      swiper.emit('sliderMove', e);
	      data.isMoved = true;
	
	      var diff = swiper.isHorizontal() ? diffX : diffY;
	      touches.diff = diff;
	
	      diff *= params.touchRatio;
	      if (rtl) { diff = -diff; }
	
	      swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
	      data.currentTranslate = diff + data.startTranslate;
	
	      var disableParentSwiper = true;
	      var resistanceRatio = params.resistanceRatio;
	      if (params.touchReleaseOnEdges) {
	        resistanceRatio = 0;
	      }
	      if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
	        disableParentSwiper = false;
	        if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
	      } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
	        disableParentSwiper = false;
	        if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
	      }
	
	      if (disableParentSwiper) {
	        e.preventedByNestedSwiper = true;
	      }
	
	      // Directions locks
	      if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
	        data.currentTranslate = data.startTranslate;
	      }
	      if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
	        data.currentTranslate = data.startTranslate;
	      }
	
	
	      // Threshold
	      if (params.threshold > 0) {
	        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
	          if (!data.allowThresholdMove) {
	            data.allowThresholdMove = true;
	            touches.startX = touches.currentX;
	            touches.startY = touches.currentY;
	            data.currentTranslate = data.startTranslate;
	            touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
	            return;
	          }
	        } else {
	          data.currentTranslate = data.startTranslate;
	          return;
	        }
	      }
	
	      if (!params.followFinger || params.cssMode) { return; }
	
	      // Update active index in free mode
	      if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
	        swiper.updateActiveIndex();
	        swiper.updateSlidesClasses();
	      }
	      if (params.freeMode) {
	        // Velocity
	        if (data.velocities.length === 0) {
	          data.velocities.push({
	            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
	            time: data.touchStartTime,
	          });
	        }
	        data.velocities.push({
	          position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
	          time: Utils.now(),
	        });
	      }
	      // Update progress
	      swiper.updateProgress(data.currentTranslate);
	      // Update translate
	      swiper.setTranslate(data.currentTranslate);
	    }
	
	    function onTouchEnd (event) {
	      var swiper = this;
	      var data = swiper.touchEventsData;
	
	      var params = swiper.params;
	      var touches = swiper.touches;
	      var rtl = swiper.rtlTranslate;
	      var $wrapperEl = swiper.$wrapperEl;
	      var slidesGrid = swiper.slidesGrid;
	      var snapGrid = swiper.snapGrid;
	      var e = event;
	      if (e.originalEvent) { e = e.originalEvent; }
	      if (data.allowTouchCallbacks) {
	        swiper.emit('touchEnd', e);
	      }
	      data.allowTouchCallbacks = false;
	      if (!data.isTouched) {
	        if (data.isMoved && params.grabCursor) {
	          swiper.setGrabCursor(false);
	        }
	        data.isMoved = false;
	        data.startMoving = false;
	        return;
	      }
	      // Return Grab Cursor
	      if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	        swiper.setGrabCursor(false);
	      }
	
	      // Time diff
	      var touchEndTime = Utils.now();
	      var timeDiff = touchEndTime - data.touchStartTime;
	
	      // Tap, doubleTap, Click
	      if (swiper.allowClick) {
	        swiper.updateClickedSlide(e);
	        swiper.emit('tap click', e);
	        if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
	          swiper.emit('doubleTap doubleClick', e);
	        }
	      }
	
	      data.lastClickTime = Utils.now();
	      Utils.nextTick(function () {
	        if (!swiper.destroyed) { swiper.allowClick = true; }
	      });
	
	      if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
	        data.isTouched = false;
	        data.isMoved = false;
	        data.startMoving = false;
	        return;
	      }
	      data.isTouched = false;
	      data.isMoved = false;
	      data.startMoving = false;
	
	      var currentPos;
	      if (params.followFinger) {
	        currentPos = rtl ? swiper.translate : -swiper.translate;
	      } else {
	        currentPos = -data.currentTranslate;
	      }
	
	      if (params.cssMode) {
	        return;
	      }
	
	      if (params.freeMode) {
	        if (currentPos < -swiper.minTranslate()) {
	          swiper.slideTo(swiper.activeIndex);
	          return;
	        }
	        if (currentPos > -swiper.maxTranslate()) {
	          if (swiper.slides.length < snapGrid.length) {
	            swiper.slideTo(snapGrid.length - 1);
	          } else {
	            swiper.slideTo(swiper.slides.length - 1);
	          }
	          return;
	        }
	
	        if (params.freeModeMomentum) {
	          if (data.velocities.length > 1) {
	            var lastMoveEvent = data.velocities.pop();
	            var velocityEvent = data.velocities.pop();
	
	            var distance = lastMoveEvent.position - velocityEvent.position;
	            var time = lastMoveEvent.time - velocityEvent.time;
	            swiper.velocity = distance / time;
	            swiper.velocity /= 2;
	            if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
	              swiper.velocity = 0;
	            }
	            // this implies that the user stopped moving a finger then released.
	            // There would be no events with distance zero, so the last event is stale.
	            if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
	              swiper.velocity = 0;
	            }
	          } else {
	            swiper.velocity = 0;
	          }
	          swiper.velocity *= params.freeModeMomentumVelocityRatio;
	
	          data.velocities.length = 0;
	          var momentumDuration = 1000 * params.freeModeMomentumRatio;
	          var momentumDistance = swiper.velocity * momentumDuration;
	
	          var newPosition = swiper.translate + momentumDistance;
	          if (rtl) { newPosition = -newPosition; }
	
	          var doBounce = false;
	          var afterBouncePosition;
	          var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
	          var needsLoopFix;
	          if (newPosition < swiper.maxTranslate()) {
	            if (params.freeModeMomentumBounce) {
	              if (newPosition + swiper.maxTranslate() < -bounceAmount) {
	                newPosition = swiper.maxTranslate() - bounceAmount;
	              }
	              afterBouncePosition = swiper.maxTranslate();
	              doBounce = true;
	              data.allowMomentumBounce = true;
	            } else {
	              newPosition = swiper.maxTranslate();
	            }
	            if (params.loop && params.centeredSlides) { needsLoopFix = true; }
	          } else if (newPosition > swiper.minTranslate()) {
	            if (params.freeModeMomentumBounce) {
	              if (newPosition - swiper.minTranslate() > bounceAmount) {
	                newPosition = swiper.minTranslate() + bounceAmount;
	              }
	              afterBouncePosition = swiper.minTranslate();
	              doBounce = true;
	              data.allowMomentumBounce = true;
	            } else {
	              newPosition = swiper.minTranslate();
	            }
	            if (params.loop && params.centeredSlides) { needsLoopFix = true; }
	          } else if (params.freeModeSticky) {
	            var nextSlide;
	            for (var j = 0; j < snapGrid.length; j += 1) {
	              if (snapGrid[j] > -newPosition) {
	                nextSlide = j;
	                break;
	              }
	            }
	
	            if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
	              newPosition = snapGrid[nextSlide];
	            } else {
	              newPosition = snapGrid[nextSlide - 1];
	            }
	            newPosition = -newPosition;
	          }
	          if (needsLoopFix) {
	            swiper.once('transitionEnd', function () {
	              swiper.loopFix();
	            });
	          }
	          // Fix duration
	          if (swiper.velocity !== 0) {
	            if (rtl) {
	              momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
	            } else {
	              momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
	            }
	            if (params.freeModeSticky) {
	              // If freeModeSticky is active and the user ends a swipe with a slow-velocity
	              // event, then durations can be 20+ seconds to slide one (or zero!) slides.
	              // It's easy to see this when simulating touch with mouse events. To fix this,
	              // limit single-slide swipes to the default slide duration. This also has the
	              // nice side effect of matching slide speed if the user stopped moving before
	              // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
	              // For faster swipes, also apply limits (albeit higher ones).
	              var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
	              var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
	              if (moveDistance < currentSlideSize) {
	                momentumDuration = params.speed;
	              } else if (moveDistance < 2 * currentSlideSize) {
	                momentumDuration = params.speed * 1.5;
	              } else {
	                momentumDuration = params.speed * 2.5;
	              }
	            }
	          } else if (params.freeModeSticky) {
	            swiper.slideToClosest();
	            return;
	          }
	
	          if (params.freeModeMomentumBounce && doBounce) {
	            swiper.updateProgress(afterBouncePosition);
	            swiper.setTransition(momentumDuration);
	            swiper.setTranslate(newPosition);
	            swiper.transitionStart(true, swiper.swipeDirection);
	            swiper.animating = true;
	            $wrapperEl.transitionEnd(function () {
	              if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
	              swiper.emit('momentumBounce');
	              swiper.setTransition(params.speed);
	              setTimeout(function () {
	                swiper.setTranslate(afterBouncePosition);
	                $wrapperEl.transitionEnd(function () {
	                  if (!swiper || swiper.destroyed) { return; }
	                  swiper.transitionEnd();
	                });
	              }, 0);
	            });
	          } else if (swiper.velocity) {
	            swiper.updateProgress(newPosition);
	            swiper.setTransition(momentumDuration);
	            swiper.setTranslate(newPosition);
	            swiper.transitionStart(true, swiper.swipeDirection);
	            if (!swiper.animating) {
	              swiper.animating = true;
	              $wrapperEl.transitionEnd(function () {
	                if (!swiper || swiper.destroyed) { return; }
	                swiper.transitionEnd();
	              });
	            }
	          } else {
	            swiper.updateProgress(newPosition);
	          }
	
	          swiper.updateActiveIndex();
	          swiper.updateSlidesClasses();
	        } else if (params.freeModeSticky) {
	          swiper.slideToClosest();
	          return;
	        }
	
	        if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
	          swiper.updateProgress();
	          swiper.updateActiveIndex();
	          swiper.updateSlidesClasses();
	        }
	        return;
	      }
	
	      // Find current slide
	      var stopIndex = 0;
	      var groupSize = swiper.slidesSizesGrid[0];
	      for (var i = 0; i < slidesGrid.length; i += (i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup)) {
	        var increment$1 = (i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup);
	        if (typeof slidesGrid[i + increment$1] !== 'undefined') {
	          if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment$1]) {
	            stopIndex = i;
	            groupSize = slidesGrid[i + increment$1] - slidesGrid[i];
	          }
	        } else if (currentPos >= slidesGrid[i]) {
	          stopIndex = i;
	          groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
	        }
	      }
	
	      // Find current slide size
	      var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
	      var increment = (stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup);
	
	      if (timeDiff > params.longSwipesMs) {
	        // Long touches
	        if (!params.longSwipes) {
	          swiper.slideTo(swiper.activeIndex);
	          return;
	        }
	        if (swiper.swipeDirection === 'next') {
	          if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + increment); }
	          else { swiper.slideTo(stopIndex); }
	        }
	        if (swiper.swipeDirection === 'prev') {
	          if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + increment); }
	          else { swiper.slideTo(stopIndex); }
	        }
	      } else {
	        // Short swipes
	        if (!params.shortSwipes) {
	          swiper.slideTo(swiper.activeIndex);
	          return;
	        }
	        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
	        if (!isNavButtonTarget) {
	          if (swiper.swipeDirection === 'next') {
	            swiper.slideTo(stopIndex + increment);
	          }
	          if (swiper.swipeDirection === 'prev') {
	            swiper.slideTo(stopIndex);
	          }
	        } else if (e.target === swiper.navigation.nextEl) {
	          swiper.slideTo(stopIndex + increment);
	        } else {
	          swiper.slideTo(stopIndex);
	        }
	      }
	    }
	
	    function onResize () {
	      var swiper = this;
	
	      var params = swiper.params;
	      var el = swiper.el;
	
	      if (el && el.offsetWidth === 0) { return; }
	
	      // Breakpoints
	      if (params.breakpoints) {
	        swiper.setBreakpoint();
	      }
	
	      // Save locks
	      var allowSlideNext = swiper.allowSlideNext;
	      var allowSlidePrev = swiper.allowSlidePrev;
	      var snapGrid = swiper.snapGrid;
	
	      // Disable locks on resize
	      swiper.allowSlideNext = true;
	      swiper.allowSlidePrev = true;
	
	      swiper.updateSize();
	      swiper.updateSlides();
	
	      swiper.updateSlidesClasses();
	      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
	        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	      } else {
	        swiper.slideTo(swiper.activeIndex, 0, false, true);
	      }
	
	      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
	        swiper.autoplay.run();
	      }
	      // Return locks after resize
	      swiper.allowSlidePrev = allowSlidePrev;
	      swiper.allowSlideNext = allowSlideNext;
	
	      if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
	        swiper.checkOverflow();
	      }
	    }
	
	    function onClick (e) {
	      var swiper = this;
	      if (!swiper.allowClick) {
	        if (swiper.params.preventClicks) { e.preventDefault(); }
	        if (swiper.params.preventClicksPropagation && swiper.animating) {
	          e.stopPropagation();
	          e.stopImmediatePropagation();
	        }
	      }
	    }
	
	    function onScroll () {
	      var swiper = this;
	      var wrapperEl = swiper.wrapperEl;
	      var rtlTranslate = swiper.rtlTranslate;
	      swiper.previousTranslate = swiper.translate;
	      if (swiper.isHorizontal()) {
	        if (rtlTranslate) {
	          swiper.translate = ((wrapperEl.scrollWidth - wrapperEl.offsetWidth) - wrapperEl.scrollLeft);
	        } else {
	          swiper.translate = -wrapperEl.scrollLeft;
	        }
	      } else {
	        swiper.translate = -wrapperEl.scrollTop;
	      }
	      // eslint-disable-next-line
	      if (swiper.translate === -0) { swiper.translate = 0; }
	
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	
	      var newProgress;
	      var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	      if (translatesDiff === 0) {
	        newProgress = 0;
	      } else {
	        newProgress = (swiper.translate - swiper.minTranslate()) / (translatesDiff);
	      }
	      if (newProgress !== swiper.progress) {
	        swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
	      }
	
	      swiper.emit('setTranslate', swiper.translate, false);
	    }
	
	    var dummyEventAttached = false;
	    function dummyEventListener() {}
	
	    function attachEvents() {
	      var swiper = this;
	      var params = swiper.params;
	      var touchEvents = swiper.touchEvents;
	      var el = swiper.el;
	      var wrapperEl = swiper.wrapperEl;
	
	      swiper.onTouchStart = onTouchStart.bind(swiper);
	      swiper.onTouchMove = onTouchMove.bind(swiper);
	      swiper.onTouchEnd = onTouchEnd.bind(swiper);
	      if (params.cssMode) {
	        swiper.onScroll = onScroll.bind(swiper);
	      }
	
	      swiper.onClick = onClick.bind(swiper);
	
	      var capture = !!params.nested;
	
	      // Touch Events
	      if (!Support.touch && Support.pointerEvents) {
	        el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
	        doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
	        doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
	      } else {
	        if (Support.touch) {
	          var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	          el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	          el.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
	          el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	          if (touchEvents.cancel) {
	            el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
	          }
	          if (!dummyEventAttached) {
	            doc.addEventListener('touchstart', dummyEventListener);
	            dummyEventAttached = true;
	          }
	        }
	        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	          el.addEventListener('mousedown', swiper.onTouchStart, false);
	          doc.addEventListener('mousemove', swiper.onTouchMove, capture);
	          doc.addEventListener('mouseup', swiper.onTouchEnd, false);
	        }
	      }
	      // Prevent Links Clicks
	      if (params.preventClicks || params.preventClicksPropagation) {
	        el.addEventListener('click', swiper.onClick, true);
	      }
	      if (params.cssMode) {
	        wrapperEl.addEventListener('scroll', swiper.onScroll);
	      }
	
	      // Resize handler
	      if (params.updateOnWindowResize) {
	        swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
	      } else {
	        swiper.on('observerUpdate', onResize, true);
	      }
	    }
	
	    function detachEvents() {
	      var swiper = this;
	
	      var params = swiper.params;
	      var touchEvents = swiper.touchEvents;
	      var el = swiper.el;
	      var wrapperEl = swiper.wrapperEl;
	
	      var capture = !!params.nested;
	
	      // Touch Events
	      if (!Support.touch && Support.pointerEvents) {
	        el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
	        doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	        doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
	      } else {
	        if (Support.touch) {
	          var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	          el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	          el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	          el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	          if (touchEvents.cancel) {
	            el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
	          }
	        }
	        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	          el.removeEventListener('mousedown', swiper.onTouchStart, false);
	          doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
	          doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
	        }
	      }
	      // Prevent Links Clicks
	      if (params.preventClicks || params.preventClicksPropagation) {
	        el.removeEventListener('click', swiper.onClick, true);
	      }
	
	      if (params.cssMode) {
	        wrapperEl.removeEventListener('scroll', swiper.onScroll);
	      }
	
	      // Resize handler
	      swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
	    }
	
	    var events = {
	      attachEvents: attachEvents,
	      detachEvents: detachEvents,
	    };
	
	    function setBreakpoint () {
	      var swiper = this;
	      var activeIndex = swiper.activeIndex;
	      var initialized = swiper.initialized;
	      var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
	      var params = swiper.params;
	      var $el = swiper.$el;
	      var breakpoints = params.breakpoints;
	      if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }
	
	      // Get breakpoint for window width and update parameters
	      var breakpoint = swiper.getBreakpoint(breakpoints);
	
	      if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
	        var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
	        if (breakpointOnlyParams) {
	          ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
	            var paramValue = breakpointOnlyParams[param];
	            if (typeof paramValue === 'undefined') { return; }
	            if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
	              breakpointOnlyParams[param] = 'auto';
	            } else if (param === 'slidesPerView') {
	              breakpointOnlyParams[param] = parseFloat(paramValue);
	            } else {
	              breakpointOnlyParams[param] = parseInt(paramValue, 10);
	            }
	          });
	        }
	
	        var breakpointParams = breakpointOnlyParams || swiper.originalParams;
	        var wasMultiRow = params.slidesPerColumn > 1;
	        var isMultiRow = breakpointParams.slidesPerColumn > 1;
	        if (wasMultiRow && !isMultiRow) {
	          $el.removeClass(((params.containerModifierClass) + "multirow " + (params.containerModifierClass) + "multirow-column"));
	        } else if (!wasMultiRow && isMultiRow) {
	          $el.addClass(((params.containerModifierClass) + "multirow"));
	          if (breakpointParams.slidesPerColumnFill === 'column') {
	            $el.addClass(((params.containerModifierClass) + "multirow-column"));
	          }
	        }
	
	        var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
	        var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
	
	        if (directionChanged && initialized) {
	          swiper.changeDirection();
	        }
	
	        Utils.extend(swiper.params, breakpointParams);
	
	        Utils.extend(swiper, {
	          allowTouchMove: swiper.params.allowTouchMove,
	          allowSlideNext: swiper.params.allowSlideNext,
	          allowSlidePrev: swiper.params.allowSlidePrev,
	        });
	
	        swiper.currentBreakpoint = breakpoint;
	
	        if (needsReLoop && initialized) {
	          swiper.loopDestroy();
	          swiper.loopCreate();
	          swiper.updateSlides();
	          swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
	        }
	
	        swiper.emit('breakpoint', breakpointParams);
	      }
	    }
	
	    function getBreakpoint (breakpoints) {
	      // Get breakpoint for window width
	      if (!breakpoints) { return undefined; }
	      var breakpoint = false;
	
	      var points = Object.keys(breakpoints).map(function (point) {
	        if (typeof point === 'string' && point.indexOf('@') === 0) {
	          var minRatio = parseFloat(point.substr(1));
	          var value = win.innerHeight * minRatio;
	          return { value: value, point: point };
	        }
	        return { value: point, point: point };
	      });
	
	      points.sort(function (a, b) { return parseInt(a.value, 10) - parseInt(b.value, 10); });
	      for (var i = 0; i < points.length; i += 1) {
	        var ref = points[i];
	        var point = ref.point;
	        var value = ref.value;
	        if (value <= win.innerWidth) {
	          breakpoint = point;
	        }
	      }
	      return breakpoint || 'max';
	    }
	
	    var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };
	
	    function addClasses () {
	      var swiper = this;
	      var classNames = swiper.classNames;
	      var params = swiper.params;
	      var rtl = swiper.rtl;
	      var $el = swiper.$el;
	      var suffixes = [];
	
	      suffixes.push('initialized');
	      suffixes.push(params.direction);
	
	      if (params.freeMode) {
	        suffixes.push('free-mode');
	      }
	      if (params.autoHeight) {
	        suffixes.push('autoheight');
	      }
	      if (rtl) {
	        suffixes.push('rtl');
	      }
	      if (params.slidesPerColumn > 1) {
	        suffixes.push('multirow');
	        if (params.slidesPerColumnFill === 'column') {
	          suffixes.push('multirow-column');
	        }
	      }
	      if (Device.android) {
	        suffixes.push('android');
	      }
	      if (Device.ios) {
	        suffixes.push('ios');
	      }
	
	      if (params.cssMode) {
	        suffixes.push('css-mode');
	      }
	
	      suffixes.forEach(function (suffix) {
	        classNames.push(params.containerModifierClass + suffix);
	      });
	
	      $el.addClass(classNames.join(' '));
	    }
	
	    function removeClasses () {
	      var swiper = this;
	      var $el = swiper.$el;
	      var classNames = swiper.classNames;
	
	      $el.removeClass(classNames.join(' '));
	    }
	
	    var classes = { addClasses: addClasses, removeClasses: removeClasses };
	
	    function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
	      var image;
	      function onReady() {
	        if (callback) { callback(); }
	      }
	      var isPicture = $(imageEl).parent('picture')[0];
	
	      if (!isPicture && (!imageEl.complete || !checkForComplete)) {
	        if (src) {
	          image = new win.Image();
	          image.onload = onReady;
	          image.onerror = onReady;
	          if (sizes) {
	            image.sizes = sizes;
	          }
	          if (srcset) {
	            image.srcset = srcset;
	          }
	          if (src) {
	            image.src = src;
	          }
	        } else {
	          onReady();
	        }
	      } else {
	        // image already loaded...
	        onReady();
	      }
	    }
	
	    function preloadImages () {
	      var swiper = this;
	      swiper.imagesToLoad = swiper.$el.find('img');
	      function onReady() {
	        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
	        if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
	        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
	          if (swiper.params.updateOnImagesReady) { swiper.update(); }
	          swiper.emit('imagesReady');
	        }
	      }
	      for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
	        var imageEl = swiper.imagesToLoad[i];
	        swiper.loadImage(
	          imageEl,
	          imageEl.currentSrc || imageEl.getAttribute('src'),
	          imageEl.srcset || imageEl.getAttribute('srcset'),
	          imageEl.sizes || imageEl.getAttribute('sizes'),
	          true,
	          onReady
	        );
	      }
	    }
	
	    var images = {
	      loadImage: loadImage,
	      preloadImages: preloadImages,
	    };
	
	    function checkOverflow() {
	      var swiper = this;
	      var params = swiper.params;
	      var wasLocked = swiper.isLocked;
	      var lastSlidePosition = swiper.slides.length > 0 && (params.slidesOffsetBefore + (params.spaceBetween * (swiper.slides.length - 1)) + ((swiper.slides[0]).offsetWidth) * swiper.slides.length);
	
	      if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
	        swiper.isLocked = lastSlidePosition <= swiper.size;
	      } else {
	        swiper.isLocked = swiper.snapGrid.length === 1;
	      }
	
	      swiper.allowSlideNext = !swiper.isLocked;
	      swiper.allowSlidePrev = !swiper.isLocked;
	
	      // events
	      if (wasLocked !== swiper.isLocked) { swiper.emit(swiper.isLocked ? 'lock' : 'unlock'); }
	
	      if (wasLocked && wasLocked !== swiper.isLocked) {
	        swiper.isEnd = false;
	        if (swiper.navigation) { swiper.navigation.update(); }
	      }
	    }
	
	    var checkOverflow$1 = { checkOverflow: checkOverflow };
	
	    var defaults = {
	      init: true,
	      direction: 'horizontal',
	      touchEventsTarget: 'container',
	      initialSlide: 0,
	      speed: 300,
	      cssMode: false,
	      updateOnWindowResize: true,
	      //
	      preventInteractionOnTransition: false,
	
	      // To support iOS's swipe-to-go-back gesture (when being used in-app).
	      edgeSwipeDetection: false,
	      edgeSwipeThreshold: 20,
	
	      // Free mode
	      freeMode: false,
	      freeModeMomentum: true,
	      freeModeMomentumRatio: 1,
	      freeModeMomentumBounce: true,
	      freeModeMomentumBounceRatio: 1,
	      freeModeMomentumVelocityRatio: 1,
	      freeModeSticky: false,
	      freeModeMinimumVelocity: 0.02,
	
	      // Autoheight
	      autoHeight: false,
	
	      // Set wrapper width
	      setWrapperSize: false,
	
	      // Virtual Translate
	      virtualTranslate: false,
	
	      // Effects
	      effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
	
	      // Breakpoints
	      breakpoints: undefined,
	
	      // Slides grid
	      spaceBetween: 0,
	      slidesPerView: 1,
	      slidesPerColumn: 1,
	      slidesPerColumnFill: 'column',
	      slidesPerGroup: 1,
	      slidesPerGroupSkip: 0,
	      centeredSlides: false,
	      centeredSlidesBounds: false,
	      slidesOffsetBefore: 0, // in px
	      slidesOffsetAfter: 0, // in px
	      normalizeSlideIndex: true,
	      centerInsufficientSlides: false,
	
	      // Disable swiper and hide navigation when container not overflow
	      watchOverflow: false,
	
	      // Round length
	      roundLengths: false,
	
	      // Touches
	      touchRatio: 1,
	      touchAngle: 45,
	      simulateTouch: true,
	      shortSwipes: true,
	      longSwipes: true,
	      longSwipesRatio: 0.5,
	      longSwipesMs: 300,
	      followFinger: true,
	      allowTouchMove: true,
	      threshold: 0,
	      touchMoveStopPropagation: false,
	      touchStartPreventDefault: true,
	      touchStartForcePreventDefault: false,
	      touchReleaseOnEdges: false,
	
	      // Unique Navigation Elements
	      uniqueNavElements: true,
	
	      // Resistance
	      resistance: true,
	      resistanceRatio: 0.85,
	
	      // Progress
	      watchSlidesProgress: false,
	      watchSlidesVisibility: false,
	
	      // Cursor
	      grabCursor: false,
	
	      // Clicks
	      preventClicks: true,
	      preventClicksPropagation: true,
	      slideToClickedSlide: false,
	
	      // Images
	      preloadImages: true,
	      updateOnImagesReady: true,
	
	      // loop
	      loop: false,
	      loopAdditionalSlides: 0,
	      loopedSlides: null,
	      loopFillGroupWithBlank: false,
	
	      // Swiping/no swiping
	      allowSlidePrev: true,
	      allowSlideNext: true,
	      swipeHandler: null, // '.swipe-handler',
	      noSwiping: true,
	      noSwipingClass: 'swiper-no-swiping',
	      noSwipingSelector: null,
	
	      // Passive Listeners
	      passiveListeners: true,
	
	      // NS
	      containerModifierClass: 'swiper-container-', // NEW
	      slideClass: 'swiper-slide',
	      slideBlankClass: 'swiper-slide-invisible-blank',
	      slideActiveClass: 'swiper-slide-active',
	      slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	      slideVisibleClass: 'swiper-slide-visible',
	      slideDuplicateClass: 'swiper-slide-duplicate',
	      slideNextClass: 'swiper-slide-next',
	      slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	      slidePrevClass: 'swiper-slide-prev',
	      slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	      wrapperClass: 'swiper-wrapper',
	
	      // Callbacks
	      runCallbacksOnInit: true,
	    };
	
	    /* eslint no-param-reassign: "off" */
	
	    var prototypes = {
	      update: update,
	      translate: translate,
	      transition: transition$1,
	      slide: slide,
	      loop: loop,
	      grabCursor: grabCursor,
	      manipulation: manipulation,
	      events: events,
	      breakpoints: breakpoints,
	      checkOverflow: checkOverflow$1,
	      classes: classes,
	      images: images,
	    };
	
	    var extendedDefaults = {};
	
	    var Swiper = /*@__PURE__*/(function (SwiperClass) {
	      function Swiper() {
	        var assign;
	
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	        var el;
	        var params;
	        if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
	          params = args[0];
	        } else {
	          (assign = args, el = assign[0], params = assign[1]);
	        }
	        if (!params) { params = {}; }
	
	        params = Utils.extend({}, params);
	        if (el && !params.el) { params.el = el; }
	
	        SwiperClass.call(this, params);
	
	        Object.keys(prototypes).forEach(function (prototypeGroup) {
	          Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
	            if (!Swiper.prototype[protoMethod]) {
	              Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
	            }
	          });
	        });
	
	        // Swiper Instance
	        var swiper = this;
	        if (typeof swiper.modules === 'undefined') {
	          swiper.modules = {};
	        }
	        Object.keys(swiper.modules).forEach(function (moduleName) {
	          var module = swiper.modules[moduleName];
	          if (module.params) {
	            var moduleParamName = Object.keys(module.params)[0];
	            var moduleParams = module.params[moduleParamName];
	            if (typeof moduleParams !== 'object' || moduleParams === null) { return; }
	            if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
	            if (params[moduleParamName] === true) {
	              params[moduleParamName] = { enabled: true };
	            }
	            if (
	              typeof params[moduleParamName] === 'object'
	              && !('enabled' in params[moduleParamName])
	            ) {
	              params[moduleParamName].enabled = true;
	            }
	            if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
	          }
	        });
	
	        // Extend defaults with modules params
	        var swiperParams = Utils.extend({}, defaults);
	        swiper.useModulesParams(swiperParams);
	
	        // Extend defaults with passed params
	        swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
	        swiper.originalParams = Utils.extend({}, swiper.params);
	        swiper.passedParams = Utils.extend({}, params);
	
	        // Save Dom lib
	        swiper.$ = $;
	
	        // Find el
	        var $el = $(swiper.params.el);
	        el = $el[0];
	
	        if (!el) {
	          return undefined;
	        }
	
	        if ($el.length > 1) {
	          var swipers = [];
	          $el.each(function (index, containerEl) {
	            var newParams = Utils.extend({}, params, { el: containerEl });
	            swipers.push(new Swiper(newParams));
	          });
	          return swipers;
	        }
	
	        el.swiper = swiper;
	        $el.data('swiper', swiper);
	
	        // Find Wrapper
	        var $wrapperEl;
	        if (el && el.shadowRoot && el.shadowRoot.querySelector) {
	          $wrapperEl = $(el.shadowRoot.querySelector(("." + (swiper.params.wrapperClass))));
	          // Children needs to return slot items
	          $wrapperEl.children = function (options) { return $el.children(options); };
	        } else {
	          $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));
	        }
	        // Extend Swiper
	        Utils.extend(swiper, {
	          $el: $el,
	          el: el,
	          $wrapperEl: $wrapperEl,
	          wrapperEl: $wrapperEl[0],
	
	          // Classes
	          classNames: [],
	
	          // Slides
	          slides: $(),
	          slidesGrid: [],
	          snapGrid: [],
	          slidesSizesGrid: [],
	
	          // isDirection
	          isHorizontal: function isHorizontal() {
	            return swiper.params.direction === 'horizontal';
	          },
	          isVertical: function isVertical() {
	            return swiper.params.direction === 'vertical';
	          },
	          // RTL
	          rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	          rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	          wrongRTL: $wrapperEl.css('display') === '-webkit-box',
	
	          // Indexes
	          activeIndex: 0,
	          realIndex: 0,
	
	          //
	          isBeginning: true,
	          isEnd: false,
	
	          // Props
	          translate: 0,
	          previousTranslate: 0,
	          progress: 0,
	          velocity: 0,
	          animating: false,
	
	          // Locks
	          allowSlideNext: swiper.params.allowSlideNext,
	          allowSlidePrev: swiper.params.allowSlidePrev,
	
	          // Touch Events
	          touchEvents: (function touchEvents() {
	            var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
	            var desktop = ['mousedown', 'mousemove', 'mouseup'];
	            if (Support.pointerEvents) {
	              desktop = ['pointerdown', 'pointermove', 'pointerup'];
	            }
	            swiper.touchEventsTouch = {
	              start: touch[0],
	              move: touch[1],
	              end: touch[2],
	              cancel: touch[3],
	            };
	            swiper.touchEventsDesktop = {
	              start: desktop[0],
	              move: desktop[1],
	              end: desktop[2],
	            };
	            return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
	          }()),
	          touchEventsData: {
	            isTouched: undefined,
	            isMoved: undefined,
	            allowTouchCallbacks: undefined,
	            touchStartTime: undefined,
	            isScrolling: undefined,
	            currentTranslate: undefined,
	            startTranslate: undefined,
	            allowThresholdMove: undefined,
	            // Form elements to match
	            formElements: 'input, select, option, textarea, button, video, label',
	            // Last click time
	            lastClickTime: Utils.now(),
	            clickTimeout: undefined,
	            // Velocities
	            velocities: [],
	            allowMomentumBounce: undefined,
	            isTouchEvent: undefined,
	            startMoving: undefined,
	          },
	
	          // Clicks
	          allowClick: true,
	
	          // Touches
	          allowTouchMove: swiper.params.allowTouchMove,
	
	          touches: {
	            startX: 0,
	            startY: 0,
	            currentX: 0,
	            currentY: 0,
	            diff: 0,
	          },
	
	          // Images
	          imagesToLoad: [],
	          imagesLoaded: 0,
	
	        });
	
	        // Install Modules
	        swiper.useModules();
	
	        // Init
	        if (swiper.params.init) {
	          swiper.init();
	        }
	
	        // Return app instance
	        return swiper;
	      }
	
	      if ( SwiperClass ) Swiper.__proto__ = SwiperClass;
	      Swiper.prototype = Object.create( SwiperClass && SwiperClass.prototype );
	      Swiper.prototype.constructor = Swiper;
	
	      var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };
	
	      Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
	        var swiper = this;
	        var params = swiper.params;
	        var slides = swiper.slides;
	        var slidesGrid = swiper.slidesGrid;
	        var swiperSize = swiper.size;
	        var activeIndex = swiper.activeIndex;
	        var spv = 1;
	        if (params.centeredSlides) {
	          var slideSize = slides[activeIndex].swiperSlideSize;
	          var breakLoop;
	          for (var i = activeIndex + 1; i < slides.length; i += 1) {
	            if (slides[i] && !breakLoop) {
	              slideSize += slides[i].swiperSlideSize;
	              spv += 1;
	              if (slideSize > swiperSize) { breakLoop = true; }
	            }
	          }
	          for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
	            if (slides[i$1] && !breakLoop) {
	              slideSize += slides[i$1].swiperSlideSize;
	              spv += 1;
	              if (slideSize > swiperSize) { breakLoop = true; }
	            }
	          }
	        } else {
	          for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
	            if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
	              spv += 1;
	            }
	          }
	        }
	        return spv;
	      };
	
	      Swiper.prototype.update = function update () {
	        var swiper = this;
	        if (!swiper || swiper.destroyed) { return; }
	        var snapGrid = swiper.snapGrid;
	        var params = swiper.params;
	        // Breakpoints
	        if (params.breakpoints) {
	          swiper.setBreakpoint();
	        }
	        swiper.updateSize();
	        swiper.updateSlides();
	        swiper.updateProgress();
	        swiper.updateSlidesClasses();
	
	        function setTranslate() {
	          var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
	          var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
	          swiper.setTranslate(newTranslate);
	          swiper.updateActiveIndex();
	          swiper.updateSlidesClasses();
	        }
	        var translated;
	        if (swiper.params.freeMode) {
	          setTranslate();
	          if (swiper.params.autoHeight) {
	            swiper.updateAutoHeight();
	          }
	        } else {
	          if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	            translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	          } else {
	            translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
	          }
	          if (!translated) {
	            setTranslate();
	          }
	        }
	        if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
	          swiper.checkOverflow();
	        }
	        swiper.emit('update');
	      };
	
	      Swiper.prototype.changeDirection = function changeDirection (newDirection, needUpdate) {
	        if ( needUpdate === void 0 ) needUpdate = true;
	
	        var swiper = this;
	        var currentDirection = swiper.params.direction;
	        if (!newDirection) {
	          // eslint-disable-next-line
	          newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
	        }
	        if ((newDirection === currentDirection) || (newDirection !== 'horizontal' && newDirection !== 'vertical')) {
	          return swiper;
	        }
	
	        swiper.$el
	          .removeClass(("" + (swiper.params.containerModifierClass) + currentDirection))
	          .addClass(("" + (swiper.params.containerModifierClass) + newDirection));
	
	        swiper.params.direction = newDirection;
	
	        swiper.slides.each(function (slideIndex, slideEl) {
	          if (newDirection === 'vertical') {
	            slideEl.style.width = '';
	          } else {
	            slideEl.style.height = '';
	          }
	        });
	
	        swiper.emit('changeDirection');
	        if (needUpdate) { swiper.update(); }
	
	        return swiper;
	      };
	
	      Swiper.prototype.init = function init () {
	        var swiper = this;
	        if (swiper.initialized) { return; }
	
	        swiper.emit('beforeInit');
	
	        // Set breakpoint
	        if (swiper.params.breakpoints) {
	          swiper.setBreakpoint();
	        }
	
	        // Add Classes
	        swiper.addClasses();
	
	        // Create loop
	        if (swiper.params.loop) {
	          swiper.loopCreate();
	        }
	
	        // Update size
	        swiper.updateSize();
	
	        // Update slides
	        swiper.updateSlides();
	
	        if (swiper.params.watchOverflow) {
	          swiper.checkOverflow();
	        }
	
	        // Set Grab Cursor
	        if (swiper.params.grabCursor) {
	          swiper.setGrabCursor();
	        }
	
	        if (swiper.params.preloadImages) {
	          swiper.preloadImages();
	        }
	
	        // Slide To Initial Slide
	        if (swiper.params.loop) {
	          swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
	        } else {
	          swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
	        }
	
	        // Attach events
	        swiper.attachEvents();
	
	        // Init Flag
	        swiper.initialized = true;
	
	        // Emit
	        swiper.emit('init');
	      };
	
	      Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
	        if ( deleteInstance === void 0 ) deleteInstance = true;
	        if ( cleanStyles === void 0 ) cleanStyles = true;
	
	        var swiper = this;
	        var params = swiper.params;
	        var $el = swiper.$el;
	        var $wrapperEl = swiper.$wrapperEl;
	        var slides = swiper.slides;
	
	        if (typeof swiper.params === 'undefined' || swiper.destroyed) {
	          return null;
	        }
	
	        swiper.emit('beforeDestroy');
	
	        // Init Flag
	        swiper.initialized = false;
	
	        // Detach events
	        swiper.detachEvents();
	
	        // Destroy loop
	        if (params.loop) {
	          swiper.loopDestroy();
	        }
	
	        // Cleanup styles
	        if (cleanStyles) {
	          swiper.removeClasses();
	          $el.removeAttr('style');
	          $wrapperEl.removeAttr('style');
	          if (slides && slides.length) {
	            slides
	              .removeClass([
	                params.slideVisibleClass,
	                params.slideActiveClass,
	                params.slideNextClass,
	                params.slidePrevClass ].join(' '))
	              .removeAttr('style')
	              .removeAttr('data-swiper-slide-index');
	          }
	        }
	
	        swiper.emit('destroy');
	
	        // Detach emitter events
	        Object.keys(swiper.eventsListeners).forEach(function (eventName) {
	          swiper.off(eventName);
	        });
	
	        if (deleteInstance !== false) {
	          swiper.$el[0].swiper = null;
	          swiper.$el.data('swiper', null);
	          Utils.deleteProps(swiper);
	        }
	        swiper.destroyed = true;
	
	        return null;
	      };
	
	      Swiper.extendDefaults = function extendDefaults (newDefaults) {
	        Utils.extend(extendedDefaults, newDefaults);
	      };
	
	      staticAccessors.extendedDefaults.get = function () {
	        return extendedDefaults;
	      };
	
	      staticAccessors.defaults.get = function () {
	        return defaults;
	      };
	
	      staticAccessors.Class.get = function () {
	        return SwiperClass;
	      };
	
	      staticAccessors.$.get = function () {
	        return $;
	      };
	
	      Object.defineProperties( Swiper, staticAccessors );
	
	      return Swiper;
	    }(SwiperClass));
	
	    var Device$1 = {
	      name: 'device',
	      proto: {
	        device: Device,
	      },
	      static: {
	        device: Device,
	      },
	    };
	
	    var Support$1 = {
	      name: 'support',
	      proto: {
	        support: Support,
	      },
	      static: {
	        support: Support,
	      },
	    };
	
	    var Browser = (function Browser() {
	      function isSafari() {
	        var ua = win.navigator.userAgent.toLowerCase();
	        return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
	      }
	      return {
	        isEdge: !!win.navigator.userAgent.match(/Edge/g),
	        isSafari: isSafari(),
	        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
	      };
	    }());
	
	    var Browser$1 = {
	      name: 'browser',
	      proto: {
	        browser: Browser,
	      },
	      static: {
	        browser: Browser,
	      },
	    };
	
	    var Resize = {
	      name: 'resize',
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          resize: {
	            resizeHandler: function resizeHandler() {
	              if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
	              swiper.emit('beforeResize');
	              swiper.emit('resize');
	            },
	            orientationChangeHandler: function orientationChangeHandler() {
	              if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
	              swiper.emit('orientationchange');
	            },
	          },
	        });
	      },
	      on: {
	        init: function init() {
	          var swiper = this;
	          // Emit resize
	          win.addEventListener('resize', swiper.resize.resizeHandler);
	
	          // Emit orientationchange
	          win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	        },
	        destroy: function destroy() {
	          var swiper = this;
	          win.removeEventListener('resize', swiper.resize.resizeHandler);
	          win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	        },
	      },
	    };
	
	    var Observer = {
	      func: win.MutationObserver || win.WebkitMutationObserver,
	      attach: function attach(target, options) {
	        if ( options === void 0 ) options = {};
	
	        var swiper = this;
	
	        var ObserverFunc = Observer.func;
	        var observer = new ObserverFunc(function (mutations) {
	          // The observerUpdate event should only be triggered
	          // once despite the number of mutations.  Additional
	          // triggers are redundant and are very costly
	          if (mutations.length === 1) {
	            swiper.emit('observerUpdate', mutations[0]);
	            return;
	          }
	          var observerUpdate = function observerUpdate() {
	            swiper.emit('observerUpdate', mutations[0]);
	          };
	
	          if (win.requestAnimationFrame) {
	            win.requestAnimationFrame(observerUpdate);
	          } else {
	            win.setTimeout(observerUpdate, 0);
	          }
	        });
	
	        observer.observe(target, {
	          attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	          childList: typeof options.childList === 'undefined' ? true : options.childList,
	          characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
	        });
	
	        swiper.observer.observers.push(observer);
	      },
	      init: function init() {
	        var swiper = this;
	        if (!Support.observer || !swiper.params.observer) { return; }
	        if (swiper.params.observeParents) {
	          var containerParents = swiper.$el.parents();
	          for (var i = 0; i < containerParents.length; i += 1) {
	            swiper.observer.attach(containerParents[i]);
	          }
	        }
	        // Observe container
	        swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });
	
	        // Observe wrapper
	        swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        swiper.observer.observers.forEach(function (observer) {
	          observer.disconnect();
	        });
	        swiper.observer.observers = [];
	      },
	    };
	
	    var Observer$1 = {
	      name: 'observer',
	      params: {
	        observer: false,
	        observeParents: false,
	        observeSlideChildren: false,
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          observer: {
	            init: Observer.init.bind(swiper),
	            attach: Observer.attach.bind(swiper),
	            destroy: Observer.destroy.bind(swiper),
	            observers: [],
	          },
	        });
	      },
	      on: {
	        init: function init() {
	          var swiper = this;
	          swiper.observer.init();
	        },
	        destroy: function destroy() {
	          var swiper = this;
	          swiper.observer.destroy();
	        },
	      },
	    };
	
	    var Virtual = {
	      update: function update(force) {
	        var swiper = this;
	        var ref = swiper.params;
	        var slidesPerView = ref.slidesPerView;
	        var slidesPerGroup = ref.slidesPerGroup;
	        var centeredSlides = ref.centeredSlides;
	        var ref$1 = swiper.params.virtual;
	        var addSlidesBefore = ref$1.addSlidesBefore;
	        var addSlidesAfter = ref$1.addSlidesAfter;
	        var ref$2 = swiper.virtual;
	        var previousFrom = ref$2.from;
	        var previousTo = ref$2.to;
	        var slides = ref$2.slides;
	        var previousSlidesGrid = ref$2.slidesGrid;
	        var renderSlide = ref$2.renderSlide;
	        var previousOffset = ref$2.offset;
	        swiper.updateActiveIndex();
	        var activeIndex = swiper.activeIndex || 0;
	
	        var offsetProp;
	        if (swiper.rtlTranslate) { offsetProp = 'right'; }
	        else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }
	
	        var slidesAfter;
	        var slidesBefore;
	        if (centeredSlides) {
	          slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
	          slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
	        } else {
	          slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
	          slidesBefore = slidesPerGroup + addSlidesAfter;
	        }
	        var from = Math.max((activeIndex || 0) - slidesBefore, 0);
	        var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
	        var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
	
	        Utils.extend(swiper.virtual, {
	          from: from,
	          to: to,
	          offset: offset,
	          slidesGrid: swiper.slidesGrid,
	        });
	
	        function onRendered() {
	          swiper.updateSlides();
	          swiper.updateProgress();
	          swiper.updateSlidesClasses();
	          if (swiper.lazy && swiper.params.lazy.enabled) {
	            swiper.lazy.load();
	          }
	        }
	
	        if (previousFrom === from && previousTo === to && !force) {
	          if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
	            swiper.slides.css(offsetProp, (offset + "px"));
	          }
	          swiper.updateProgress();
	          return;
	        }
	        if (swiper.params.virtual.renderExternal) {
	          swiper.params.virtual.renderExternal.call(swiper, {
	            offset: offset,
	            from: from,
	            to: to,
	            slides: (function getSlides() {
	              var slidesToRender = [];
	              for (var i = from; i <= to; i += 1) {
	                slidesToRender.push(slides[i]);
	              }
	              return slidesToRender;
	            }()),
	          });
	          onRendered();
	          return;
	        }
	        var prependIndexes = [];
	        var appendIndexes = [];
	        if (force) {
	          swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
	        } else {
	          for (var i = previousFrom; i <= previousTo; i += 1) {
	            if (i < from || i > to) {
	              swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
	            }
	          }
	        }
	        for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
	          if (i$1 >= from && i$1 <= to) {
	            if (typeof previousTo === 'undefined' || force) {
	              appendIndexes.push(i$1);
	            } else {
	              if (i$1 > previousTo) { appendIndexes.push(i$1); }
	              if (i$1 < previousFrom) { prependIndexes.push(i$1); }
	            }
	          }
	        }
	        appendIndexes.forEach(function (index) {
	          swiper.$wrapperEl.append(renderSlide(slides[index], index));
	        });
	        prependIndexes.sort(function (a, b) { return b - a; }).forEach(function (index) {
	          swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
	        });
	        swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
	        onRendered();
	      },
	      renderSlide: function renderSlide(slide, index) {
	        var swiper = this;
	        var params = swiper.params.virtual;
	        if (params.cache && swiper.virtual.cache[index]) {
	          return swiper.virtual.cache[index];
	        }
	        var $slideEl = params.renderSlide
	          ? $(params.renderSlide.call(swiper, slide, index))
	          : $(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
	        if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
	        if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
	        return $slideEl;
	      },
	      appendSlide: function appendSlide(slides) {
	        var swiper = this;
	        if (typeof slides === 'object' && 'length' in slides) {
	          for (var i = 0; i < slides.length; i += 1) {
	            if (slides[i]) { swiper.virtual.slides.push(slides[i]); }
	          }
	        } else {
	          swiper.virtual.slides.push(slides);
	        }
	        swiper.virtual.update(true);
	      },
	      prependSlide: function prependSlide(slides) {
	        var swiper = this;
	        var activeIndex = swiper.activeIndex;
	        var newActiveIndex = activeIndex + 1;
	        var numberOfNewSlides = 1;
	
	        if (Array.isArray(slides)) {
	          for (var i = 0; i < slides.length; i += 1) {
	            if (slides[i]) { swiper.virtual.slides.unshift(slides[i]); }
	          }
	          newActiveIndex = activeIndex + slides.length;
	          numberOfNewSlides = slides.length;
	        } else {
	          swiper.virtual.slides.unshift(slides);
	        }
	        if (swiper.params.virtual.cache) {
	          var cache = swiper.virtual.cache;
	          var newCache = {};
	          Object.keys(cache).forEach(function (cachedIndex) {
	            var $cachedEl = cache[cachedIndex];
	            var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
	            if (cachedElIndex) {
	              $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
	            }
	            newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
	          });
	          swiper.virtual.cache = newCache;
	        }
	        swiper.virtual.update(true);
	        swiper.slideTo(newActiveIndex, 0);
	      },
	      removeSlide: function removeSlide(slidesIndexes) {
	        var swiper = this;
	        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) { return; }
	        var activeIndex = swiper.activeIndex;
	        if (Array.isArray(slidesIndexes)) {
	          for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
	            swiper.virtual.slides.splice(slidesIndexes[i], 1);
	            if (swiper.params.virtual.cache) {
	              delete swiper.virtual.cache[slidesIndexes[i]];
	            }
	            if (slidesIndexes[i] < activeIndex) { activeIndex -= 1; }
	            activeIndex = Math.max(activeIndex, 0);
	          }
	        } else {
	          swiper.virtual.slides.splice(slidesIndexes, 1);
	          if (swiper.params.virtual.cache) {
	            delete swiper.virtual.cache[slidesIndexes];
	          }
	          if (slidesIndexes < activeIndex) { activeIndex -= 1; }
	          activeIndex = Math.max(activeIndex, 0);
	        }
	        swiper.virtual.update(true);
	        swiper.slideTo(activeIndex, 0);
	      },
	      removeAllSlides: function removeAllSlides() {
	        var swiper = this;
	        swiper.virtual.slides = [];
	        if (swiper.params.virtual.cache) {
	          swiper.virtual.cache = {};
	        }
	        swiper.virtual.update(true);
	        swiper.slideTo(0, 0);
	      },
	    };
	
	    var Virtual$1 = {
	      name: 'virtual',
	      params: {
	        virtual: {
	          enabled: false,
	          slides: [],
	          cache: true,
	          renderSlide: null,
	          renderExternal: null,
	          addSlidesBefore: 0,
	          addSlidesAfter: 0,
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          virtual: {
	            update: Virtual.update.bind(swiper),
	            appendSlide: Virtual.appendSlide.bind(swiper),
	            prependSlide: Virtual.prependSlide.bind(swiper),
	            removeSlide: Virtual.removeSlide.bind(swiper),
	            removeAllSlides: Virtual.removeAllSlides.bind(swiper),
	            renderSlide: Virtual.renderSlide.bind(swiper),
	            slides: swiper.params.virtual.slides,
	            cache: {},
	          },
	        });
	      },
	      on: {
	        beforeInit: function beforeInit() {
	          var swiper = this;
	          if (!swiper.params.virtual.enabled) { return; }
	          swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
	          var overwriteParams = {
	            watchSlidesProgress: true,
	          };
	          Utils.extend(swiper.params, overwriteParams);
	          Utils.extend(swiper.originalParams, overwriteParams);
	
	          if (!swiper.params.initialSlide) {
	            swiper.virtual.update();
	          }
	        },
	        setTranslate: function setTranslate() {
	          var swiper = this;
	          if (!swiper.params.virtual.enabled) { return; }
	          swiper.virtual.update();
	        },
	      },
	    };
	
	    var Keyboard = {
	      handle: function handle(event) {
	        var swiper = this;
	        var rtl = swiper.rtlTranslate;
	        var e = event;
	        if (e.originalEvent) { e = e.originalEvent; } // jquery fix
	        var kc = e.keyCode || e.charCode;
	        var pageUpDown = swiper.params.keyboard.pageUpDown;
	        var isPageUp = pageUpDown && kc === 33;
	        var isPageDown = pageUpDown && kc === 34;
	        var isArrowLeft = kc === 37;
	        var isArrowRight = kc === 39;
	        var isArrowUp = kc === 38;
	        var isArrowDown = kc === 40;
	        // Directions locks
	        if (!swiper.allowSlideNext && ((swiper.isHorizontal() && isArrowRight) || (swiper.isVertical() && isArrowDown) || isPageDown)) {
	          return false;
	        }
	        if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && isArrowLeft) || (swiper.isVertical() && isArrowUp) || isPageUp)) {
	          return false;
	        }
	        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
	          return undefined;
	        }
	        if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
	          return undefined;
	        }
	        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
	          var inView = false;
	          // Check that swiper should be inside of visible area of window
	          if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
	            return undefined;
	          }
	          var windowWidth = win.innerWidth;
	          var windowHeight = win.innerHeight;
	          var swiperOffset = swiper.$el.offset();
	          if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
	          var swiperCoord = [
	            [swiperOffset.left, swiperOffset.top],
	            [swiperOffset.left + swiper.width, swiperOffset.top],
	            [swiperOffset.left, swiperOffset.top + swiper.height],
	            [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
	          for (var i = 0; i < swiperCoord.length; i += 1) {
	            var point = swiperCoord[i];
	            if (
	              point[0] >= 0 && point[0] <= windowWidth
	              && point[1] >= 0 && point[1] <= windowHeight
	            ) {
	              inView = true;
	            }
	          }
	          if (!inView) { return undefined; }
	        }
	        if (swiper.isHorizontal()) {
	          if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
	            if (e.preventDefault) { e.preventDefault(); }
	            else { e.returnValue = false; }
	          }
	          if (((isPageDown || isArrowRight) && !rtl) || ((isPageUp || isArrowLeft) && rtl)) { swiper.slideNext(); }
	          if (((isPageUp || isArrowLeft) && !rtl) || ((isPageDown || isArrowRight) && rtl)) { swiper.slidePrev(); }
	        } else {
	          if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
	            if (e.preventDefault) { e.preventDefault(); }
	            else { e.returnValue = false; }
	          }
	          if (isPageDown || isArrowDown) { swiper.slideNext(); }
	          if (isPageUp || isArrowUp) { swiper.slidePrev(); }
	        }
	        swiper.emit('keyPress', kc);
	        return undefined;
	      },
	      enable: function enable() {
	        var swiper = this;
	        if (swiper.keyboard.enabled) { return; }
	        $(doc).on('keydown', swiper.keyboard.handle);
	        swiper.keyboard.enabled = true;
	      },
	      disable: function disable() {
	        var swiper = this;
	        if (!swiper.keyboard.enabled) { return; }
	        $(doc).off('keydown', swiper.keyboard.handle);
	        swiper.keyboard.enabled = false;
	      },
	    };
	
	    var Keyboard$1 = {
	      name: 'keyboard',
	      params: {
	        keyboard: {
	          enabled: false,
	          onlyInViewport: true,
	          pageUpDown: true,
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          keyboard: {
	            enabled: false,
	            enable: Keyboard.enable.bind(swiper),
	            disable: Keyboard.disable.bind(swiper),
	            handle: Keyboard.handle.bind(swiper),
	          },
	        });
	      },
	      on: {
	        init: function init() {
	          var swiper = this;
	          if (swiper.params.keyboard.enabled) {
	            swiper.keyboard.enable();
	          }
	        },
	        destroy: function destroy() {
	          var swiper = this;
	          if (swiper.keyboard.enabled) {
	            swiper.keyboard.disable();
	          }
	        },
	      },
	    };
	
	    function isEventSupported() {
	      var eventName = 'onwheel';
	      var isSupported = eventName in doc;
	
	      if (!isSupported) {
	        var element = doc.createElement('div');
	        element.setAttribute(eventName, 'return;');
	        isSupported = typeof element[eventName] === 'function';
	      }
	
	      if (!isSupported
	        && doc.implementation
	        && doc.implementation.hasFeature
	        // always returns true in newer browsers as per the standard.
	        // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	        && doc.implementation.hasFeature('', '') !== true
	      ) {
	        // This is the only way to test support for the `wheel` event in IE9+.
	        isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
	      }
	
	      return isSupported;
	    }
	    var Mousewheel = {
	      lastScrollTime: Utils.now(),
	      lastEventBeforeSnap: undefined,
	      recentWheelEvents: [],
	      event: function event() {
	        if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
	        return isEventSupported() ? 'wheel' : 'mousewheel';
	      },
	      normalize: function normalize(e) {
	        // Reasonable defaults
	        var PIXEL_STEP = 10;
	        var LINE_HEIGHT = 40;
	        var PAGE_HEIGHT = 800;
	
	        var sX = 0;
	        var sY = 0; // spinX, spinY
	        var pX = 0;
	        var pY = 0; // pixelX, pixelY
	
	        // Legacy
	        if ('detail' in e) {
	          sY = e.detail;
	        }
	        if ('wheelDelta' in e) {
	          sY = -e.wheelDelta / 120;
	        }
	        if ('wheelDeltaY' in e) {
	          sY = -e.wheelDeltaY / 120;
	        }
	        if ('wheelDeltaX' in e) {
	          sX = -e.wheelDeltaX / 120;
	        }
	
	        // side scrolling on FF with DOMMouseScroll
	        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
	          sX = sY;
	          sY = 0;
	        }
	
	        pX = sX * PIXEL_STEP;
	        pY = sY * PIXEL_STEP;
	
	        if ('deltaY' in e) {
	          pY = e.deltaY;
	        }
	        if ('deltaX' in e) {
	          pX = e.deltaX;
	        }
	
	        if (e.shiftKey && !pX) { // if user scrolls with shift he wants horizontal scroll
	          pX = pY;
	          pY = 0;
	        }
	
	        if ((pX || pY) && e.deltaMode) {
	          if (e.deltaMode === 1) { // delta in LINE units
	            pX *= LINE_HEIGHT;
	            pY *= LINE_HEIGHT;
	          } else { // delta in PAGE units
	            pX *= PAGE_HEIGHT;
	            pY *= PAGE_HEIGHT;
	          }
	        }
	
	        // Fall-back if spin cannot be determined
	        if (pX && !sX) {
	          sX = (pX < 1) ? -1 : 1;
	        }
	        if (pY && !sY) {
	          sY = (pY < 1) ? -1 : 1;
	        }
	
	        return {
	          spinX: sX,
	          spinY: sY,
	          pixelX: pX,
	          pixelY: pY,
	        };
	      },
	      handleMouseEnter: function handleMouseEnter() {
	        var swiper = this;
	        swiper.mouseEntered = true;
	      },
	      handleMouseLeave: function handleMouseLeave() {
	        var swiper = this;
	        swiper.mouseEntered = false;
	      },
	      handle: function handle(event) {
	        var e = event;
	        var swiper = this;
	        var params = swiper.params.mousewheel;
	
	        if (swiper.params.cssMode) {
	          e.preventDefault();
	        }
	
	        var target = swiper.$el;
	        if (swiper.params.mousewheel.eventsTarged !== 'container') {
	          target = $(swiper.params.mousewheel.eventsTarged);
	        }
	        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) { return true; }
	
	        if (e.originalEvent) { e = e.originalEvent; } // jquery fix
	        var delta = 0;
	        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
	
	        var data = Mousewheel.normalize(e);
	
	        if (params.forceToAxis) {
	          if (swiper.isHorizontal()) {
	            if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = -data.pixelX * rtlFactor; }
	            else { return true; }
	          } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = -data.pixelY; }
	          else { return true; }
	        } else {
	          delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
	        }
	
	        if (delta === 0) { return true; }
	
	        if (params.invert) { delta = -delta; }
	
	        if (!swiper.params.freeMode) {
	          // Register the new event in a variable which stores the relevant data
	          var newEvent = {
	            time: Utils.now(),
	            delta: Math.abs(delta),
	            direction: Math.sign(delta),
	            raw: event,
	          };
	
	          // Keep the most recent events
	          var recentWheelEvents = swiper.mousewheel.recentWheelEvents;
	          if (recentWheelEvents.length >= 2) {
	            recentWheelEvents.shift(); // only store the last N events
	          }
	          var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
	          recentWheelEvents.push(newEvent);
	
	          // If there is at least one previous recorded event:
	          //   If direction has changed or
	          //   if the scroll is quicker than the previous one:
	          //     Animate the slider.
	          // Else (this is the first time the wheel is moved):
	          //     Animate the slider.
	          if (prevEvent) {
	            if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
	              swiper.mousewheel.animateSlider(newEvent);
	            }
	          } else {
	            swiper.mousewheel.animateSlider(newEvent);
	          }
	
	          // If it's time to release the scroll:
	          //   Return now so you don't hit the preventDefault.
	          if (swiper.mousewheel.releaseScroll(newEvent)) {
	            return true;
	          }
	        } else {
	          // Freemode or scrollContainer:
	
	          // If we recently snapped after a momentum scroll, then ignore wheel events
	          // to give time for the deceleration to finish. Stop ignoring after 500 msecs
	          // or if it's a new scroll (larger delta or inverse sign as last event before
	          // an end-of-momentum snap).
	          var newEvent$1 = { time: Utils.now(), delta: Math.abs(delta), direction: Math.sign(delta) };
	          var ref = swiper.mousewheel;
	          var lastEventBeforeSnap = ref.lastEventBeforeSnap;
	          var ignoreWheelEvents = lastEventBeforeSnap
	            && newEvent$1.time < lastEventBeforeSnap.time + 500
	            && newEvent$1.delta <= lastEventBeforeSnap.delta
	            && newEvent$1.direction === lastEventBeforeSnap.direction;
	          if (!ignoreWheelEvents) {
	            swiper.mousewheel.lastEventBeforeSnap = undefined;
	
	            if (swiper.params.loop) {
	              swiper.loopFix();
	            }
	            var position = swiper.getTranslate() + (delta * params.sensitivity);
	            var wasBeginning = swiper.isBeginning;
	            var wasEnd = swiper.isEnd;
	
	            if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
	            if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }
	
	            swiper.setTransition(0);
	            swiper.setTranslate(position);
	            swiper.updateProgress();
	            swiper.updateActiveIndex();
	            swiper.updateSlidesClasses();
	
	            if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
	              swiper.updateSlidesClasses();
	            }
	
	            if (swiper.params.freeModeSticky) {
	              // When wheel scrolling starts with sticky (aka snap) enabled, then detect
	              // the end of a momentum scroll by storing recent (N=15?) wheel events.
	              // 1. do all N events have decreasing or same (absolute value) delta?
	              // 2. did all N events arrive in the last M (M=500?) msecs?
	              // 3. does the earliest event have an (absolute value) delta that's
	              //    at least P (P=1?) larger than the most recent event's delta?
	              // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
	              // If 1-4 are "yes" then we're near the end of a momuntum scroll deceleration.
	              // Snap immediately and ignore remaining wheel events in this scroll.
	              // See comment above for "remaining wheel events in this scroll" determination.
	              // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
	              clearTimeout(swiper.mousewheel.timeout);
	              swiper.mousewheel.timeout = undefined;
	              var recentWheelEvents$1 = swiper.mousewheel.recentWheelEvents;
	              if (recentWheelEvents$1.length >= 15) {
	                recentWheelEvents$1.shift(); // only store the last N events
	              }
	              var prevEvent$1 = recentWheelEvents$1.length ? recentWheelEvents$1[recentWheelEvents$1.length - 1] : undefined;
	              var firstEvent = recentWheelEvents$1[0];
	              recentWheelEvents$1.push(newEvent$1);
	              if (prevEvent$1 && (newEvent$1.delta > prevEvent$1.delta || newEvent$1.direction !== prevEvent$1.direction)) {
	                // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
	                recentWheelEvents$1.splice(0);
	              } else if (recentWheelEvents$1.length >= 15
	                  && newEvent$1.time - firstEvent.time < 500
	                  && firstEvent.delta - newEvent$1.delta >= 1
	                  && newEvent$1.delta <= 6
	              ) {
	                // We're at the end of the deceleration of a momentum scroll, so there's no need
	                // to wait for more events. Snap ASAP on the next tick.
	                // Also, because there's some remaining momentum we'll bias the snap in the
	                // direction of the ongoing scroll because it's better UX for the scroll to snap
	                // in the same direction as the scroll instead of reversing to snap.  Therefore,
	                // if it's already scrolled more than 20% in the current direction, keep going.
	                var snapToThreshold = delta > 0 ? 0.8 : 0.2;
	                swiper.mousewheel.lastEventBeforeSnap = newEvent$1;
	                recentWheelEvents$1.splice(0);
	                swiper.mousewheel.timeout = Utils.nextTick(function () {
	                  swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
	                }, 0); // no delay; move on next tick
	              }
	              if (!swiper.mousewheel.timeout) {
	                // if we get here, then we haven't detected the end of a momentum scroll, so
	                // we'll consider a scroll "complete" when there haven't been any wheel events
	                // for 500ms.
	                swiper.mousewheel.timeout = Utils.nextTick(function () {
	                  var snapToThreshold = 0.5;
	                  swiper.mousewheel.lastEventBeforeSnap = newEvent$1;
	                  recentWheelEvents$1.splice(0);
	                  swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
	                }, 500);
	              }
	            }
	
	            // Emit event
	            if (!ignoreWheelEvents) { swiper.emit('scroll', e); }
	
	            // Stop autoplay
	            if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.autoplay.stop(); }
	            // Return page scroll on edge positions
	            if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
	          }
	        }
	
	        if (e.preventDefault) { e.preventDefault(); }
	        else { e.returnValue = false; }
	        return false;
	      },
	      animateSlider: function animateSlider(newEvent) {
	        var swiper = this;
	        // If the movement is NOT big enough and
	        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
	        //   Don't go any further (avoid insignificant scroll movement).
	        if (newEvent.delta >= 6 && Utils.now() - swiper.mousewheel.lastScrollTime < 60) {
	          // Return false as a default
	          return true;
	        }
	        // If user is scrolling towards the end:
	        //   If the slider hasn't hit the latest slide or
	        //   if the slider is a loop and
	        //   if the slider isn't moving right now:
	        //     Go to next slide and
	        //     emit a scroll event.
	        // Else (the user is scrolling towards the beginning) and
	        // if the slider hasn't hit the first slide or
	        // if the slider is a loop and
	        // if the slider isn't moving right now:
	        //   Go to prev slide and
	        //   emit a scroll event.
	        if (newEvent.direction < 0) {
	          if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
	            swiper.slideNext();
	            swiper.emit('scroll', newEvent.raw);
	          }
	        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
	          swiper.slidePrev();
	          swiper.emit('scroll', newEvent.raw);
	        }
	        // If you got here is because an animation has been triggered so store the current time
	        swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
	        // Return false as a default
	        return false;
	      },
	      releaseScroll: function releaseScroll(newEvent) {
	        var swiper = this;
	        var params = swiper.params.mousewheel;
	        if (newEvent.direction < 0) {
	          if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
	            // Return true to animate scroll on edges
	            return true;
	          }
	        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
	          // Return true to animate scroll on edges
	          return true;
	        }
	        return false;
	      },
	      enable: function enable() {
	        var swiper = this;
	        var event = Mousewheel.event();
	        if (swiper.params.cssMode) {
	          swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
	          return true;
	        }
	        if (!event) { return false; }
	        if (swiper.mousewheel.enabled) { return false; }
	        var target = swiper.$el;
	        if (swiper.params.mousewheel.eventsTarged !== 'container') {
	          target = $(swiper.params.mousewheel.eventsTarged);
	        }
	        target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
	        target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
	        target.on(event, swiper.mousewheel.handle);
	        swiper.mousewheel.enabled = true;
	        return true;
	      },
	      disable: function disable() {
	        var swiper = this;
	        var event = Mousewheel.event();
	        if (swiper.params.cssMode) {
	          swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
	          return true;
	        }
	        if (!event) { return false; }
	        if (!swiper.mousewheel.enabled) { return false; }
	        var target = swiper.$el;
	        if (swiper.params.mousewheel.eventsTarged !== 'container') {
	          target = $(swiper.params.mousewheel.eventsTarged);
	        }
	        target.off(event, swiper.mousewheel.handle);
	        swiper.mousewheel.enabled = false;
	        return true;
	      },
	    };
	
	    var Mousewheel$1 = {
	      name: 'mousewheel',
	      params: {
	        mousewheel: {
	          enabled: false,
	          releaseOnEdges: false,
	          invert: false,
	          forceToAxis: false,
	          sensitivity: 1,
	          eventsTarged: 'container',
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          mousewheel: {
	            enabled: false,
	            enable: Mousewheel.enable.bind(swiper),
	            disable: Mousewheel.disable.bind(swiper),
	            handle: Mousewheel.handle.bind(swiper),
	            handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
	            handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
	            animateSlider: Mousewheel.animateSlider.bind(swiper),
	            releaseScroll: Mousewheel.releaseScroll.bind(swiper),
	            lastScrollTime: Utils.now(),
	            lastEventBeforeSnap: undefined,
	            recentWheelEvents: [],
	          },
	        });
	      },
	      on: {
	        init: function init() {
	          var swiper = this;
	          if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
	            swiper.mousewheel.disable();
	          }
	          if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
	        },
	        destroy: function destroy() {
	          var swiper = this;
	          if (swiper.params.cssMode) {
	            swiper.mousewheel.enable();
	          }
	          if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
	        },
	      },
	    };
	
	    var Navigation = {
	      update: function update() {
	        // Update Navigation Buttons
	        var swiper = this;
	        var params = swiper.params.navigation;
	
	        if (swiper.params.loop) { return; }
	        var ref = swiper.navigation;
	        var $nextEl = ref.$nextEl;
	        var $prevEl = ref.$prevEl;
	
	        if ($prevEl && $prevEl.length > 0) {
	          if (swiper.isBeginning) {
	            $prevEl.addClass(params.disabledClass);
	          } else {
	            $prevEl.removeClass(params.disabledClass);
	          }
	          $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	        }
	        if ($nextEl && $nextEl.length > 0) {
	          if (swiper.isEnd) {
	            $nextEl.addClass(params.disabledClass);
	          } else {
	            $nextEl.removeClass(params.disabledClass);
	          }
	          $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	        }
	      },
	      onPrevClick: function onPrevClick(e) {
	        var swiper = this;
	        e.preventDefault();
	        if (swiper.isBeginning && !swiper.params.loop) { return; }
	        swiper.slidePrev();
	      },
	      onNextClick: function onNextClick(e) {
	        var swiper = this;
	        e.preventDefault();
	        if (swiper.isEnd && !swiper.params.loop) { return; }
	        swiper.slideNext();
	      },
	      init: function init() {
	        var swiper = this;
	        var params = swiper.params.navigation;
	        if (!(params.nextEl || params.prevEl)) { return; }
	
	        var $nextEl;
	        var $prevEl;
	        if (params.nextEl) {
	          $nextEl = $(params.nextEl);
	          if (
	            swiper.params.uniqueNavElements
	            && typeof params.nextEl === 'string'
	            && $nextEl.length > 1
	            && swiper.$el.find(params.nextEl).length === 1
	          ) {
	            $nextEl = swiper.$el.find(params.nextEl);
	          }
	        }
	        if (params.prevEl) {
	          $prevEl = $(params.prevEl);
	          if (
	            swiper.params.uniqueNavElements
	            && typeof params.prevEl === 'string'
	            && $prevEl.length > 1
	            && swiper.$el.find(params.prevEl).length === 1
	          ) {
	            $prevEl = swiper.$el.find(params.prevEl);
	          }
	        }
	
	        if ($nextEl && $nextEl.length > 0) {
	          $nextEl.on('click', swiper.navigation.onNextClick);
	        }
	        if ($prevEl && $prevEl.length > 0) {
	          $prevEl.on('click', swiper.navigation.onPrevClick);
	        }
	
	        Utils.extend(swiper.navigation, {
	          $nextEl: $nextEl,
	          nextEl: $nextEl && $nextEl[0],
	          $prevEl: $prevEl,
	          prevEl: $prevEl && $prevEl[0],
	        });
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        var ref = swiper.navigation;
	        var $nextEl = ref.$nextEl;
	        var $prevEl = ref.$prevEl;
	        if ($nextEl && $nextEl.length) {
	          $nextEl.off('click', swiper.navigation.onNextClick);
	          $nextEl.removeClass(swiper.params.navigation.disabledClass);
	        }
	        if ($prevEl && $prevEl.length) {
	          $prevEl.off('click', swiper.navigation.onPrevClick);
	          $prevEl.removeClass(swiper.params.navigation.disabledClass);
	        }
	      },
	    };
	
	    var Navigation$1 = {
	      name: 'navigation',
	      params: {
	        navigation: {
	          nextEl: null,
	          prevEl: null,
	
	          hideOnClick: false,
	          disabledClass: 'swiper-button-disabled',
	          hiddenClass: 'swiper-button-hidden',
	          lockClass: 'swiper-button-lock',
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          navigation: {
	            init: Navigation.init.bind(swiper),
	            update: Navigation.update.bind(swiper),
	            destroy: Navigation.destroy.bind(swiper),
	            onNextClick: Navigation.onNextClick.bind(swiper),
	            onPrevClick: Navigation.onPrevClick.bind(swiper),
	          },
	        });
	      },
	      on: {
	        init: function init() {
	          var swiper = this;
	          swiper.navigation.init();
	          swiper.navigation.update();
	        },
	        toEdge: function toEdge() {
	          var swiper = this;
	          swiper.navigation.update();
	        },
	        fromEdge: function fromEdge() {
	          var swiper = this;
	          swiper.navigation.update();
	        },
	        destroy: function destroy() {
	          var swiper = this;
	          swiper.navigation.destroy();
	        },
	        click: function click(e) {
	          var swiper = this;
	          var ref = swiper.navigation;
	          var $nextEl = ref.$nextEl;
	          var $prevEl = ref.$prevEl;
	          if (
	            swiper.params.navigation.hideOnClick
	            && !$(e.target).is($prevEl)
	            && !$(e.target).is($nextEl)
	          ) {
	            var isHidden;
	            if ($nextEl) {
	              isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
	            } else if ($prevEl) {
	              isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
	            }
	            if (isHidden === true) {
	              swiper.emit('navigationShow', swiper);
	            } else {
	              swiper.emit('navigationHide', swiper);
	            }
	            if ($nextEl) {
	              $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
	            }
	            if ($prevEl) {
	              $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
	            }
	          }
	        },
	      },
	    };
	
	    var Pagination = {
	      update: function update() {
	        // Render || Update Pagination bullets/items
	        var swiper = this;
	        var rtl = swiper.rtl;
	        var params = swiper.params.pagination;
	        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	        var $el = swiper.pagination.$el;
	        // Current/Total
	        var current;
	        var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	        if (swiper.params.loop) {
	          current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
	          if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
	            current -= (slidesLength - (swiper.loopedSlides * 2));
	          }
	          if (current > total - 1) { current -= total; }
	          if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
	        } else if (typeof swiper.snapIndex !== 'undefined') {
	          current = swiper.snapIndex;
	        } else {
	          current = swiper.activeIndex || 0;
	        }
	        // Types
	        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
	          var bullets = swiper.pagination.bullets;
	          var firstIndex;
	          var lastIndex;
	          var midIndex;
	          if (params.dynamicBullets) {
	            swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
	            $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
	            if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
	              swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
	              if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
	                swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
	              } else if (swiper.pagination.dynamicBulletIndex < 0) {
	                swiper.pagination.dynamicBulletIndex = 0;
	              }
	            }
	            firstIndex = current - swiper.pagination.dynamicBulletIndex;
	            lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
	            midIndex = (lastIndex + firstIndex) / 2;
	          }
	          bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
	          if ($el.length > 1) {
	            bullets.each(function (index, bullet) {
	              var $bullet = $(bullet);
	              var bulletIndex = $bullet.index();
	              if (bulletIndex === current) {
	                $bullet.addClass(params.bulletActiveClass);
	              }
	              if (params.dynamicBullets) {
	                if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
	                  $bullet.addClass(((params.bulletActiveClass) + "-main"));
	                }
	                if (bulletIndex === firstIndex) {
	                  $bullet
	                    .prev()
	                    .addClass(((params.bulletActiveClass) + "-prev"))
	                    .prev()
	                    .addClass(((params.bulletActiveClass) + "-prev-prev"));
	                }
	                if (bulletIndex === lastIndex) {
	                  $bullet
	                    .next()
	                    .addClass(((params.bulletActiveClass) + "-next"))
	                    .next()
	                    .addClass(((params.bulletActiveClass) + "-next-next"));
	                }
	              }
	            });
	          } else {
	            var $bullet = bullets.eq(current);
	            var bulletIndex = $bullet.index();
	            $bullet.addClass(params.bulletActiveClass);
	            if (params.dynamicBullets) {
	              var $firstDisplayedBullet = bullets.eq(firstIndex);
	              var $lastDisplayedBullet = bullets.eq(lastIndex);
	              for (var i = firstIndex; i <= lastIndex; i += 1) {
	                bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
	              }
	              if (swiper.params.loop) {
	                if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
	                  for (var i$1 = params.dynamicMainBullets; i$1 >= 0; i$1 -= 1) {
	                    bullets.eq(bullets.length - i$1).addClass(((params.bulletActiveClass) + "-main"));
	                  }
	                  bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(((params.bulletActiveClass) + "-prev"));
	                } else {
	                  $firstDisplayedBullet
	                    .prev()
	                    .addClass(((params.bulletActiveClass) + "-prev"))
	                    .prev()
	                    .addClass(((params.bulletActiveClass) + "-prev-prev"));
	                  $lastDisplayedBullet
	                    .next()
	                    .addClass(((params.bulletActiveClass) + "-next"))
	                    .next()
	                    .addClass(((params.bulletActiveClass) + "-next-next"));
	                }
	              } else {
	                $firstDisplayedBullet
	                  .prev()
	                  .addClass(((params.bulletActiveClass) + "-prev"))
	                  .prev()
	                  .addClass(((params.bulletActiveClass) + "-prev-prev"));
	                $lastDisplayedBullet
	                  .next()
	                  .addClass(((params.bulletActiveClass) + "-next"))
	                  .next()
	                  .addClass(((params.bulletActiveClass) + "-next-next"));
	              }
	            }
	          }
	          if (params.dynamicBullets) {
	            var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
	            var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
	            var offsetProp = rtl ? 'right' : 'left';
	            bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
	          }
	        }
	        if (params.type === 'fraction') {
	          $el.find(("." + (params.currentClass))).text(params.formatFractionCurrent(current + 1));
	          $el.find(("." + (params.totalClass))).text(params.formatFractionTotal(total));
	        }
	        if (params.type === 'progressbar') {
	          var progressbarDirection;
	          if (params.progressbarOpposite) {
	            progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
	          } else {
	            progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
	          }
	          var scale = (current + 1) / total;
	          var scaleX = 1;
	          var scaleY = 1;
	          if (progressbarDirection === 'horizontal') {
	            scaleX = scale;
	          } else {
	            scaleY = scale;
	          }
	          $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
	        }
	        if (params.type === 'custom' && params.renderCustom) {
	          $el.html(params.renderCustom(swiper, current + 1, total));
	          swiper.emit('paginationRender', swiper, $el[0]);
	        } else {
	          swiper.emit('paginationUpdate', swiper, $el[0]);
	        }
	        $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	      },
	      render: function render() {
	        // Render Container
	        var swiper = this;
	        var params = swiper.params.pagination;
	        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	
	        var $el = swiper.pagination.$el;
	        var paginationHTML = '';
	        if (params.type === 'bullets') {
	          var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	          for (var i = 0; i < numberOfBullets; i += 1) {
	            if (params.renderBullet) {
	              paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
	            } else {
	              paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
	            }
	          }
	          $el.html(paginationHTML);
	          swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
	        }
	        if (params.type === 'fraction') {
	          if (params.renderFraction) {
	            paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
	          } else {
	            paginationHTML = "<span class=\"" + (params.currentClass) + "\"></span>"
	            + ' / '
	            + "<span class=\"" + (params.totalClass) + "\"></span>";
	          }
	          $el.html(paginationHTML);
	        }
	        if (params.type === 'progressbar') {
	          if (params.renderProgressbar) {
	            paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
	          } else {
	            paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
	          }
	          $el.html(paginationHTML);
	        }
	        if (params.type !== 'custom') {
	          swiper.emit('paginationRender', swiper.pagination.$el[0]);
	        }
	      },
	      init: function init() {
	        var swiper = this;
	        var params = swiper.params.pagination;
	        if (!params.el) { return; }
	
	        var $el = $(params.el);
	        if ($el.length === 0) { return; }
	
	        if (
	          swiper.params.uniqueNavElements
	          && typeof params.el === 'string'
	          && $el.length > 1
	        ) {
	          $el = swiper.$el.find(params.el);
	        }
	
	        if (params.type === 'bullets' && params.clickable) {
	          $el.addClass(params.clickableClass);
	        }
	
	        $el.addClass(params.modifierClass + params.type);
	
	        if (params.type === 'bullets' && params.dynamicBullets) {
	          $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
	          swiper.pagination.dynamicBulletIndex = 0;
	          if (params.dynamicMainBullets < 1) {
	            params.dynamicMainBullets = 1;
	          }
	        }
	        if (params.type === 'progressbar' && params.progressbarOpposite) {
	          $el.addClass(params.progressbarOppositeClass);
	        }
	
	        if (params.clickable) {
	          $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
	            e.preventDefault();
	            var index = $(this).index() * swiper.params.slidesPerGroup;
	            if (swiper.params.loop) { index += swiper.loopedSlides; }
	            swiper.slideTo(index);
	          });
	        }
	
	        Utils.extend(swiper.pagination, {
	          $el: $el,
	          el: $el[0],
	        });
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        var params = swiper.params.pagination;
	        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	        var $el = swiper.pagination.$el;
	
	        $el.removeClass(params.hiddenClass);
	        $el.removeClass(params.modifierClass + params.type);
	        if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
	        if (params.clickable) {
	          $el.off('click', ("." + (params.bulletClass)));
	        }
	      },
	    };
	
	    var Pagination$1 = {
	      name: 'pagination',
	      params: {
	        pagination: {
	          el: null,
	          bulletElement: 'span',
	          clickable: false,
	          hideOnClick: false,
	          renderBullet: null,
	          renderProgressbar: null,
	          renderFraction: null,
	          renderCustom: null,
	          progressbarOpposite: false,
	          type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
	          dynamicBullets: false,
	          dynamicMainBullets: 1,
	          formatFractionCurrent: function (number) { return number; },
	          formatFractionTotal: function (number) { return number; },
	          bulletClass: 'swiper-pagination-bullet',
	          bulletActiveClass: 'swiper-pagination-bullet-active',
	          modifierClass: 'swiper-pagination-', // NEW
	          currentClass: 'swiper-pagination-current',
	          totalClass: 'swiper-pagination-total',
	          hiddenClass: 'swiper-pagination-hidden',
	          progressbarFillClass: 'swiper-pagination-progressbar-fill',
	          progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
	          clickableClass: 'swiper-pagination-clickable', // NEW
	          lockClass: 'swiper-pagination-lock',
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          pagination: {
	            init: Pagination.init.bind(swiper),
	            render: Pagination.render.bind(swiper),
	            update: Pagination.update.bind(swiper),
	            destroy: Pagination.destroy.bind(swiper),
	            dynamicBulletIndex: 0,
	          },
	        });
	      },
	      on: {
	        init: function init() {
	          var swiper = this;
	          swiper.pagination.init();
	          swiper.pagination.render();
	          swiper.pagination.update();
	        },
	        activeIndexChange: function activeIndexChange() {
	          var swiper = this;
	          if (swiper.params.loop) {
	            swiper.pagination.update();
	          } else if (typeof swiper.snapIndex === 'undefined') {
	            swiper.pagination.update();
	          }
	        },
	        snapIndexChange: function snapIndexChange() {
	          var swiper = this;
	          if (!swiper.params.loop) {
	            swiper.pagination.update();
	          }
	        },
	        slidesLengthChange: function slidesLengthChange() {
	          var swiper = this;
	          if (swiper.params.loop) {
	            swiper.pagination.render();
	            swiper.pagination.update();
	          }
	        },
	        snapGridLengthChange: function snapGridLengthChange() {
	          var swiper = this;
	          if (!swiper.params.loop) {
	            swiper.pagination.render();
	            swiper.pagination.update();
	          }
	        },
	        destroy: function destroy() {
	          var swiper = this;
	          swiper.pagination.destroy();
	        },
	        click: function click(e) {
	          var swiper = this;
	          if (
	            swiper.params.pagination.el
	            && swiper.params.pagination.hideOnClick
	            && swiper.pagination.$el.length > 0
	            && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
	          ) {
	            var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
	            if (isHidden === true) {
	              swiper.emit('paginationShow', swiper);
	            } else {
	              swiper.emit('paginationHide', swiper);
	            }
	            swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
	          }
	        },
	      },
	    };
	
	    var Scrollbar = {
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	        var scrollbar = swiper.scrollbar;
	        var rtl = swiper.rtlTranslate;
	        var progress = swiper.progress;
	        var dragSize = scrollbar.dragSize;
	        var trackSize = scrollbar.trackSize;
	        var $dragEl = scrollbar.$dragEl;
	        var $el = scrollbar.$el;
	        var params = swiper.params.scrollbar;
	
	        var newSize = dragSize;
	        var newPos = (trackSize - dragSize) * progress;
	        if (rtl) {
	          newPos = -newPos;
	          if (newPos > 0) {
	            newSize = dragSize - newPos;
	            newPos = 0;
	          } else if (-newPos + dragSize > trackSize) {
	            newSize = trackSize + newPos;
	          }
	        } else if (newPos < 0) {
	          newSize = dragSize + newPos;
	          newPos = 0;
	        } else if (newPos + dragSize > trackSize) {
	          newSize = trackSize - newPos;
	        }
	        if (swiper.isHorizontal()) {
	          $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
	          $dragEl[0].style.width = newSize + "px";
	        } else {
	          $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
	          $dragEl[0].style.height = newSize + "px";
	        }
	        if (params.hide) {
	          clearTimeout(swiper.scrollbar.timeout);
	          $el[0].style.opacity = 1;
	          swiper.scrollbar.timeout = setTimeout(function () {
	            $el[0].style.opacity = 0;
	            $el.transition(400);
	          }, 1000);
	        }
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	        swiper.scrollbar.$dragEl.transition(duration);
	      },
	      updateSize: function updateSize() {
	        var swiper = this;
	        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	
	        var scrollbar = swiper.scrollbar;
	        var $dragEl = scrollbar.$dragEl;
	        var $el = scrollbar.$el;
	
	        $dragEl[0].style.width = '';
	        $dragEl[0].style.height = '';
	        var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
	
	        var divider = swiper.size / swiper.virtualSize;
	        var moveDivider = divider * (trackSize / swiper.size);
	        var dragSize;
	        if (swiper.params.scrollbar.dragSize === 'auto') {
	          dragSize = trackSize * divider;
	        } else {
	          dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
	        }
	
	        if (swiper.isHorizontal()) {
	          $dragEl[0].style.width = dragSize + "px";
	        } else {
	          $dragEl[0].style.height = dragSize + "px";
	        }
	
	        if (divider >= 1) {
	          $el[0].style.display = 'none';
	        } else {
	          $el[0].style.display = '';
	        }
	        if (swiper.params.scrollbar.hide) {
	          $el[0].style.opacity = 0;
	        }
	        Utils.extend(scrollbar, {
	          trackSize: trackSize,
	          divider: divider,
	          moveDivider: moveDivider,
	          dragSize: dragSize,
	        });
	        scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
	      },
	      getPointerPosition: function getPointerPosition(e) {
	        var swiper = this;
	        if (swiper.isHorizontal()) {
	          return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].clientX : e.clientX);
	        }
	        return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].clientY : e.clientY);
	      },
	      setDragPosition: function setDragPosition(e) {
	        var swiper = this;
	        var scrollbar = swiper.scrollbar;
	        var rtl = swiper.rtlTranslate;
	        var $el = scrollbar.$el;
	        var dragSize = scrollbar.dragSize;
	        var trackSize = scrollbar.trackSize;
	        var dragStartPos = scrollbar.dragStartPos;
	
	        var positionRatio;
	        positionRatio = ((scrollbar.getPointerPosition(e)) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top']
	          - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
	        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
	        if (rtl) {
	          positionRatio = 1 - positionRatio;
	        }
	
	        var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);
	
	        swiper.updateProgress(position);
	        swiper.setTranslate(position);
	        swiper.updateActiveIndex();
	        swiper.updateSlidesClasses();
	      },
	      onDragStart: function onDragStart(e) {
	        var swiper = this;
	        var params = swiper.params.scrollbar;
	        var scrollbar = swiper.scrollbar;
	        var $wrapperEl = swiper.$wrapperEl;
	        var $el = scrollbar.$el;
	        var $dragEl = scrollbar.$dragEl;
	        swiper.scrollbar.isTouched = true;
	        swiper.scrollbar.dragStartPos = (e.target === $dragEl[0] || e.target === $dragEl)
	          ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
	        e.preventDefault();
	        e.stopPropagation();
	
	        $wrapperEl.transition(100);
	        $dragEl.transition(100);
	        scrollbar.setDragPosition(e);
	
	        clearTimeout(swiper.scrollbar.dragTimeout);
	
	        $el.transition(0);
	        if (params.hide) {
	          $el.css('opacity', 1);
	        }
	        if (swiper.params.cssMode) {
	          swiper.$wrapperEl.css('scroll-snap-type', 'none');
	        }
	        swiper.emit('scrollbarDragStart', e);
	      },
	      onDragMove: function onDragMove(e) {
	        var swiper = this;
	        var scrollbar = swiper.scrollbar;
	        var $wrapperEl = swiper.$wrapperEl;
	        var $el = scrollbar.$el;
	        var $dragEl = scrollbar.$dragEl;
	
	        if (!swiper.scrollbar.isTouched) { return; }
	        if (e.preventDefault) { e.preventDefault(); }
	        else { e.returnValue = false; }
	        scrollbar.setDragPosition(e);
	        $wrapperEl.transition(0);
	        $el.transition(0);
	        $dragEl.transition(0);
	        swiper.emit('scrollbarDragMove', e);
	      },
	      onDragEnd: function onDragEnd(e) {
	        var swiper = this;
	
	        var params = swiper.params.scrollbar;
	        var scrollbar = swiper.scrollbar;
	        var $wrapperEl = swiper.$wrapperEl;
	        var $el = scrollbar.$el;
	
	        if (!swiper.scrollbar.isTouched) { return; }
	        swiper.scrollbar.isTouched = false;
	        if (swiper.params.cssMode) {
	          swiper.$wrapperEl.css('scroll-snap-type', '');
	          $wrapperEl.transition('');
	        }
	        if (params.hide) {
	          clearTimeout(swiper.scrollbar.dragTimeout);
	          swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
	            $el.css('opacity', 0);
	            $el.transition(400);
	          }, 1000);
	        }
	        swiper.emit('scrollbarDragEnd', e);
	        if (params.snapOnRelease) {
	          swiper.slideToClosest();
	        }
	      },
	      enableDraggable: function enableDraggable() {
	        var swiper = this;
	        if (!swiper.params.scrollbar.el) { return; }
	        var scrollbar = swiper.scrollbar;
	        var touchEventsTouch = swiper.touchEventsTouch;
	        var touchEventsDesktop = swiper.touchEventsDesktop;
	        var params = swiper.params;
	        var $el = scrollbar.$el;
	        var target = $el[0];
	        var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
	        var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	        if (!Support.touch) {
	          target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
	          doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
	          doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
	        } else {
	          target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
	          target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
	          target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
	        }
	      },
	      disableDraggable: function disableDraggable() {
	        var swiper = this;
	        if (!swiper.params.scrollbar.el) { return; }
	        var scrollbar = swiper.scrollbar;
	        var touchEventsTouch = swiper.touchEventsTouch;
	        var touchEventsDesktop = swiper.touchEventsDesktop;
	        var params = swiper.params;
	        var $el = scrollbar.$el;
	        var target = $el[0];
	        var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
	        var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	        if (!Support.touch) {
	          target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
	          doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
	          doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
	        } else {
	          target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
	          target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
	          target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
	        }
	      },
	      init: function init() {
	        var swiper = this;
	        if (!swiper.params.scrollbar.el) { return; }
	        var scrollbar = swiper.scrollbar;
	        var $swiperEl = swiper.$el;
	        var params = swiper.params.scrollbar;
	
	        var $el = $(params.el);
	        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
	          $el = $swiperEl.find(params.el);
	        }
	
	        var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
	        if ($dragEl.length === 0) {
	          $dragEl = $(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
	          $el.append($dragEl);
	        }
	
	        Utils.extend(scrollbar, {
	          $el: $el,
	          el: $el[0],
	          $dragEl: $dragEl,
	          dragEl: $dragEl[0],
	        });
	
	        if (params.draggable) {
	          scrollbar.enableDraggable();
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        swiper.scrollbar.disableDraggable();
	      },
	    };
	
	    var Scrollbar$1 = {
	      name: 'scrollbar',
	      params: {
	        scrollbar: {
	          el: null,
	          dragSize: 'auto',
	          hide: false,
	          draggable: false,
	          snapOnRelease: true,
	          lockClass: 'swiper-scrollbar-lock',
	          dragClass: 'swiper-scrollbar-drag',
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          scrollbar: {
	            init: Scrollbar.init.bind(swiper),
	            destroy: Scrollbar.destroy.bind(swiper),
	            updateSize: Scrollbar.updateSize.bind(swiper),
	            setTranslate: Scrollbar.setTranslate.bind(swiper),
	            setTransition: Scrollbar.setTransition.bind(swiper),
	            enableDraggable: Scrollbar.enableDraggable.bind(swiper),
	            disableDraggable: Scrollbar.disableDraggable.bind(swiper),
	            setDragPosition: Scrollbar.setDragPosition.bind(swiper),
	            getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
	            onDragStart: Scrollbar.onDragStart.bind(swiper),
	            onDragMove: Scrollbar.onDragMove.bind(swiper),
	            onDragEnd: Scrollbar.onDragEnd.bind(swiper),
	            isTouched: false,
	            timeout: null,
	            dragTimeout: null,
	          },
	        });
	      },
	      on: {
	        init: function init() {
	          var swiper = this;
	          swiper.scrollbar.init();
	          swiper.scrollbar.updateSize();
	          swiper.scrollbar.setTranslate();
	        },
	        update: function update() {
	          var swiper = this;
	          swiper.scrollbar.updateSize();
	        },
	        resize: function resize() {
	          var swiper = this;
	          swiper.scrollbar.updateSize();
	        },
	        observerUpdate: function observerUpdate() {
	          var swiper = this;
	          swiper.scrollbar.updateSize();
	        },
	        setTranslate: function setTranslate() {
	          var swiper = this;
	          swiper.scrollbar.setTranslate();
	        },
	        setTransition: function setTransition(duration) {
	          var swiper = this;
	          swiper.scrollbar.setTransition(duration);
	        },
	        destroy: function destroy() {
	          var swiper = this;
	          swiper.scrollbar.destroy();
	        },
	      },
	    };
	
	    var Parallax = {
	      setTransform: function setTransform(el, progress) {
	        var swiper = this;
	        var rtl = swiper.rtl;
	
	        var $el = $(el);
	        var rtlFactor = rtl ? -1 : 1;
	
	        var p = $el.attr('data-swiper-parallax') || '0';
	        var x = $el.attr('data-swiper-parallax-x');
	        var y = $el.attr('data-swiper-parallax-y');
	        var scale = $el.attr('data-swiper-parallax-scale');
	        var opacity = $el.attr('data-swiper-parallax-opacity');
	
	        if (x || y) {
	          x = x || '0';
	          y = y || '0';
	        } else if (swiper.isHorizontal()) {
	          x = p;
	          y = '0';
	        } else {
	          y = p;
	          x = '0';
	        }
	
	        if ((x).indexOf('%') >= 0) {
	          x = (parseInt(x, 10) * progress * rtlFactor) + "%";
	        } else {
	          x = (x * progress * rtlFactor) + "px";
	        }
	        if ((y).indexOf('%') >= 0) {
	          y = (parseInt(y, 10) * progress) + "%";
	        } else {
	          y = (y * progress) + "px";
	        }
	
	        if (typeof opacity !== 'undefined' && opacity !== null) {
	          var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
	          $el[0].style.opacity = currentOpacity;
	        }
	        if (typeof scale === 'undefined' || scale === null) {
	          $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
	        } else {
	          var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
	          $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
	        }
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        var $el = swiper.$el;
	        var slides = swiper.slides;
	        var progress = swiper.progress;
	        var snapGrid = swiper.snapGrid;
	        $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
	          .each(function (index, el) {
	            swiper.parallax.setTransform(el, progress);
	          });
	        slides.each(function (slideIndex, slideEl) {
	          var slideProgress = slideEl.progress;
	          if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
	            slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
	          }
	          slideProgress = Math.min(Math.max(slideProgress, -1), 1);
	          $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
	            .each(function (index, el) {
	              swiper.parallax.setTransform(el, slideProgress);
	            });
	        });
	      },
	      setTransition: function setTransition(duration) {
	        if ( duration === void 0 ) duration = this.params.speed;
	
	        var swiper = this;
	        var $el = swiper.$el;
	        $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
	          .each(function (index, parallaxEl) {
	            var $parallaxEl = $(parallaxEl);
	            var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
	            if (duration === 0) { parallaxDuration = 0; }
	            $parallaxEl.transition(parallaxDuration);
	          });
	      },
	    };
	
	    var Parallax$1 = {
	      name: 'parallax',
	      params: {
	        parallax: {
	          enabled: false,
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          parallax: {
	            setTransform: Parallax.setTransform.bind(swiper),
	            setTranslate: Parallax.setTranslate.bind(swiper),
	            setTransition: Parallax.setTransition.bind(swiper),
	          },
	        });
	      },
	      on: {
	        beforeInit: function beforeInit() {
	          var swiper = this;
	          if (!swiper.params.parallax.enabled) { return; }
	          swiper.params.watchSlidesProgress = true;
	          swiper.originalParams.watchSlidesProgress = true;
	        },
	        init: function init() {
	          var swiper = this;
	          if (!swiper.params.parallax.enabled) { return; }
	          swiper.parallax.setTranslate();
	        },
	        setTranslate: function setTranslate() {
	          var swiper = this;
	          if (!swiper.params.parallax.enabled) { return; }
	          swiper.parallax.setTranslate();
	        },
	        setTransition: function setTransition(duration) {
	          var swiper = this;
	          if (!swiper.params.parallax.enabled) { return; }
	          swiper.parallax.setTransition(duration);
	        },
	      },
	    };
	
	    var Zoom = {
	      // Calc Scale From Multi-touches
	      getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
	        if (e.targetTouches.length < 2) { return 1; }
	        var x1 = e.targetTouches[0].pageX;
	        var y1 = e.targetTouches[0].pageY;
	        var x2 = e.targetTouches[1].pageX;
	        var y2 = e.targetTouches[1].pageY;
	        var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
	        return distance;
	      },
	      // Events
	      onGestureStart: function onGestureStart(e) {
	        var swiper = this;
	        var params = swiper.params.zoom;
	        var zoom = swiper.zoom;
	        var gesture = zoom.gesture;
	        zoom.fakeGestureTouched = false;
	        zoom.fakeGestureMoved = false;
	        if (!Support.gestures) {
	          if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
	            return;
	          }
	          zoom.fakeGestureTouched = true;
	          gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
	        }
	        if (!gesture.$slideEl || !gesture.$slideEl.length) {
	          gesture.$slideEl = $(e.target).closest(("." + (swiper.params.slideClass)));
	          if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
	          gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
	          gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	          gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	          if (gesture.$imageWrapEl.length === 0) {
	            gesture.$imageEl = undefined;
	            return;
	          }
	        }
	        if (gesture.$imageEl) {
	          gesture.$imageEl.transition(0);
	        }
	        swiper.zoom.isScaling = true;
	      },
	      onGestureChange: function onGestureChange(e) {
	        var swiper = this;
	        var params = swiper.params.zoom;
	        var zoom = swiper.zoom;
	        var gesture = zoom.gesture;
	        if (!Support.gestures) {
	          if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
	            return;
	          }
	          zoom.fakeGestureMoved = true;
	          gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
	        }
	        if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	        if (Support.gestures) {
	          zoom.scale = e.scale * zoom.currentScale;
	        } else {
	          zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
	        }
	        if (zoom.scale > gesture.maxRatio) {
	          zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
	        }
	        if (zoom.scale < params.minRatio) {
	          zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
	        }
	        gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	      },
	      onGestureEnd: function onGestureEnd(e) {
	        var swiper = this;
	        var params = swiper.params.zoom;
	        var zoom = swiper.zoom;
	        var gesture = zoom.gesture;
	        if (!Support.gestures) {
	          if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
	            return;
	          }
	          if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
	            return;
	          }
	          zoom.fakeGestureTouched = false;
	          zoom.fakeGestureMoved = false;
	        }
	        if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
	        gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	        zoom.currentScale = zoom.scale;
	        zoom.isScaling = false;
	        if (zoom.scale === 1) { gesture.$slideEl = undefined; }
	      },
	      onTouchStart: function onTouchStart(e) {
	        var swiper = this;
	        var zoom = swiper.zoom;
	        var gesture = zoom.gesture;
	        var image = zoom.image;
	        if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	        if (image.isTouched) { return; }
	        if (Device.android && e.cancelable) { e.preventDefault(); }
	        image.isTouched = true;
	        image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	        image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	      },
	      onTouchMove: function onTouchMove(e) {
	        var swiper = this;
	        var zoom = swiper.zoom;
	        var gesture = zoom.gesture;
	        var image = zoom.image;
	        var velocity = zoom.velocity;
	        if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	        swiper.allowClick = false;
	        if (!image.isTouched || !gesture.$slideEl) { return; }
	
	        if (!image.isMoved) {
	          image.width = gesture.$imageEl[0].offsetWidth;
	          image.height = gesture.$imageEl[0].offsetHeight;
	          image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
	          image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
	          gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
	          gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
	          gesture.$imageWrapEl.transition(0);
	          if (swiper.rtl) {
	            image.startX = -image.startX;
	            image.startY = -image.startY;
	          }
	        }
	        // Define if we need image drag
	        var scaledWidth = image.width * zoom.scale;
	        var scaledHeight = image.height * zoom.scale;
	
	        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }
	
	        image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
	        image.maxX = -image.minX;
	        image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
	        image.maxY = -image.minY;
	
	        image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	        image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	
	        if (!image.isMoved && !zoom.isScaling) {
	          if (
	            swiper.isHorizontal()
	            && (
	              (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
	              || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
	            )
	          ) {
	            image.isTouched = false;
	            return;
	          } if (
	            !swiper.isHorizontal()
	            && (
	              (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
	              || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
	            )
	          ) {
	            image.isTouched = false;
	            return;
	          }
	        }
	        if (e.cancelable) {
	          e.preventDefault();
	        }
	        e.stopPropagation();
	
	        image.isMoved = true;
	        image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
	        image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;
	
	        if (image.currentX < image.minX) {
	          image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
	        }
	        if (image.currentX > image.maxX) {
	          image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
	        }
	
	        if (image.currentY < image.minY) {
	          image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
	        }
	        if (image.currentY > image.maxY) {
	          image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
	        }
	
	        // Velocity
	        if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
	        if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
	        if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
	        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
	        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
	        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
	        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
	        velocity.prevPositionX = image.touchesCurrent.x;
	        velocity.prevPositionY = image.touchesCurrent.y;
	        velocity.prevTime = Date.now();
	
	        gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
	      },
	      onTouchEnd: function onTouchEnd() {
	        var swiper = this;
	        var zoom = swiper.zoom;
	        var gesture = zoom.gesture;
	        var image = zoom.image;
	        var velocity = zoom.velocity;
	        if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	        if (!image.isTouched || !image.isMoved) {
	          image.isTouched = false;
	          image.isMoved = false;
	          return;
	        }
	        image.isTouched = false;
	        image.isMoved = false;
	        var momentumDurationX = 300;
	        var momentumDurationY = 300;
	        var momentumDistanceX = velocity.x * momentumDurationX;
	        var newPositionX = image.currentX + momentumDistanceX;
	        var momentumDistanceY = velocity.y * momentumDurationY;
	        var newPositionY = image.currentY + momentumDistanceY;
	
	        // Fix duration
	        if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
	        if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
	        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
	
	        image.currentX = newPositionX;
	        image.currentY = newPositionY;
	
	        // Define if we need image drag
	        var scaledWidth = image.width * zoom.scale;
	        var scaledHeight = image.height * zoom.scale;
	        image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
	        image.maxX = -image.minX;
	        image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
	        image.maxY = -image.minY;
	        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
	        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
	
	        gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
	      },
	      onTransitionEnd: function onTransitionEnd() {
	        var swiper = this;
	        var zoom = swiper.zoom;
	        var gesture = zoom.gesture;
	        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
	          if (gesture.$imageEl) {
	            gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
	          }
	          if (gesture.$imageWrapEl) {
	            gesture.$imageWrapEl.transform('translate3d(0,0,0)');
	          }
	
	          zoom.scale = 1;
	          zoom.currentScale = 1;
	
	          gesture.$slideEl = undefined;
	          gesture.$imageEl = undefined;
	          gesture.$imageWrapEl = undefined;
	        }
	      },
	      // Toggle Zoom
	      toggle: function toggle(e) {
	        var swiper = this;
	        var zoom = swiper.zoom;
	
	        if (zoom.scale && zoom.scale !== 1) {
	          // Zoom Out
	          zoom.out();
	        } else {
	          // Zoom In
	          zoom.in(e);
	        }
	      },
	      in: function in$1(e) {
	        var swiper = this;
	
	        var zoom = swiper.zoom;
	        var params = swiper.params.zoom;
	        var gesture = zoom.gesture;
	        var image = zoom.image;
	
	        if (!gesture.$slideEl) {
	          if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
	            gesture.$slideEl = swiper.$wrapperEl.children(("." + (swiper.params.slideActiveClass)));
	          } else {
	            gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
	          }
	          gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
	          gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	        }
	        if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	
	        gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));
	
	        var touchX;
	        var touchY;
	        var offsetX;
	        var offsetY;
	        var diffX;
	        var diffY;
	        var translateX;
	        var translateY;
	        var imageWidth;
	        var imageHeight;
	        var scaledWidth;
	        var scaledHeight;
	        var translateMinX;
	        var translateMinY;
	        var translateMaxX;
	        var translateMaxY;
	        var slideWidth;
	        var slideHeight;
	
	        if (typeof image.touchesStart.x === 'undefined' && e) {
	          touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
	          touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
	        } else {
	          touchX = image.touchesStart.x;
	          touchY = image.touchesStart.y;
	        }
	
	        zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	        zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	        if (e) {
	          slideWidth = gesture.$slideEl[0].offsetWidth;
	          slideHeight = gesture.$slideEl[0].offsetHeight;
	          offsetX = gesture.$slideEl.offset().left;
	          offsetY = gesture.$slideEl.offset().top;
	          diffX = (offsetX + (slideWidth / 2)) - touchX;
	          diffY = (offsetY + (slideHeight / 2)) - touchY;
	
	          imageWidth = gesture.$imageEl[0].offsetWidth;
	          imageHeight = gesture.$imageEl[0].offsetHeight;
	          scaledWidth = imageWidth * zoom.scale;
	          scaledHeight = imageHeight * zoom.scale;
	
	          translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
	          translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
	          translateMaxX = -translateMinX;
	          translateMaxY = -translateMinY;
	
	          translateX = diffX * zoom.scale;
	          translateY = diffY * zoom.scale;
	
	          if (translateX < translateMinX) {
	            translateX = translateMinX;
	          }
	          if (translateX > translateMaxX) {
	            translateX = translateMaxX;
	          }
	
	          if (translateY < translateMinY) {
	            translateY = translateMinY;
	          }
	          if (translateY > translateMaxY) {
	            translateY = translateMaxY;
	          }
	        } else {
	          translateX = 0;
	          translateY = 0;
	        }
	        gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
	        gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	      },
	      out: function out() {
	        var swiper = this;
	
	        var zoom = swiper.zoom;
	        var params = swiper.params.zoom;
	        var gesture = zoom.gesture;
	
	        if (!gesture.$slideEl) {
	          if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
	            gesture.$slideEl = swiper.$wrapperEl.children(("." + (swiper.params.slideActiveClass)));
	          } else {
	            gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
	          }
	          gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
	          gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	        }
	        if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	
	        zoom.scale = 1;
	        zoom.currentScale = 1;
	        gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
	        gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
	        gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
	        gesture.$slideEl = undefined;
	      },
	      // Attach/Detach Events
	      enable: function enable() {
	        var swiper = this;
	        var zoom = swiper.zoom;
	        if (zoom.enabled) { return; }
	        zoom.enabled = true;
	
	        var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
	        var activeListenerWithCapture = Support.passiveListener ? { passive: false, capture: true } : true;
	
	        var slideSelector = "." + (swiper.params.slideClass);
	
	        // Scale image
	        if (Support.gestures) {
	          swiper.$wrapperEl.on('gesturestart', slideSelector, zoom.onGestureStart, passiveListener);
	          swiper.$wrapperEl.on('gesturechange', slideSelector, zoom.onGestureChange, passiveListener);
	          swiper.$wrapperEl.on('gestureend', slideSelector, zoom.onGestureEnd, passiveListener);
	        } else if (swiper.touchEvents.start === 'touchstart') {
	          swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
	          swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
	          swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
	          if (swiper.touchEvents.cancel) {
	            swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
	          }
	        }
	
	        // Move image
	        swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove, activeListenerWithCapture);
	      },
	      disable: function disable() {
	        var swiper = this;
	        var zoom = swiper.zoom;
	        if (!zoom.enabled) { return; }
	
	        swiper.zoom.enabled = false;
	
	        var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
	        var activeListenerWithCapture = Support.passiveListener ? { passive: false, capture: true } : true;
	
	        var slideSelector = "." + (swiper.params.slideClass);
	
	        // Scale image
	        if (Support.gestures) {
	          swiper.$wrapperEl.off('gesturestart', slideSelector, zoom.onGestureStart, passiveListener);
	          swiper.$wrapperEl.off('gesturechange', slideSelector, zoom.onGestureChange, passiveListener);
	          swiper.$wrapperEl.off('gestureend', slideSelector, zoom.onGestureEnd, passiveListener);
	        } else if (swiper.touchEvents.start === 'touchstart') {
	          swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
	          swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
	          swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
	          if (swiper.touchEvents.cancel) {
	            swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
	          }
	        }
	
	        // Move image
	        swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove, activeListenerWithCapture);
	      },
	    };
	
	    var Zoom$1 = {
	      name: 'zoom',
	      params: {
	        zoom: {
	          enabled: false,
	          maxRatio: 3,
	          minRatio: 1,
	          toggle: true,
	          containerClass: 'swiper-zoom-container',
	          zoomedSlideClass: 'swiper-slide-zoomed',
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        var zoom = {
	          enabled: false,
	          scale: 1,
	          currentScale: 1,
	          isScaling: false,
	          gesture: {
	            $slideEl: undefined,
	            slideWidth: undefined,
	            slideHeight: undefined,
	            $imageEl: undefined,
	            $imageWrapEl: undefined,
	            maxRatio: 3,
	          },
	          image: {
	            isTouched: undefined,
	            isMoved: undefined,
	            currentX: undefined,
	            currentY: undefined,
	            minX: undefined,
	            minY: undefined,
	            maxX: undefined,
	            maxY: undefined,
	            width: undefined,
	            height: undefined,
	            startX: undefined,
	            startY: undefined,
	            touchesStart: {},
	            touchesCurrent: {},
	          },
	          velocity: {
	            x: undefined,
	            y: undefined,
	            prevPositionX: undefined,
	            prevPositionY: undefined,
	            prevTime: undefined,
	          },
	        };
	
	        ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
	          zoom[methodName] = Zoom[methodName].bind(swiper);
	        });
	        Utils.extend(swiper, {
	          zoom: zoom,
	        });
	
	        var scale = 1;
	        Object.defineProperty(swiper.zoom, 'scale', {
	          get: function get() {
	            return scale;
	          },
	          set: function set(value) {
	            if (scale !== value) {
	              var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
	              var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
	              swiper.emit('zoomChange', value, imageEl, slideEl);
	            }
	            scale = value;
	          },
	        });
	      },
	      on: {
	        init: function init() {
	          var swiper = this;
	          if (swiper.params.zoom.enabled) {
	            swiper.zoom.enable();
	          }
	        },
	        destroy: function destroy() {
	          var swiper = this;
	          swiper.zoom.disable();
	        },
	        touchStart: function touchStart(e) {
	          var swiper = this;
	          if (!swiper.zoom.enabled) { return; }
	          swiper.zoom.onTouchStart(e);
	        },
	        touchEnd: function touchEnd(e) {
	          var swiper = this;
	          if (!swiper.zoom.enabled) { return; }
	          swiper.zoom.onTouchEnd(e);
	        },
	        doubleTap: function doubleTap(e) {
	          var swiper = this;
	          if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
	            swiper.zoom.toggle(e);
	          }
	        },
	        transitionEnd: function transitionEnd() {
	          var swiper = this;
	          if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
	            swiper.zoom.onTransitionEnd();
	          }
	        },
	        slideChange: function slideChange() {
	          var swiper = this;
	          if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
	            swiper.zoom.onTransitionEnd();
	          }
	        },
	      },
	    };
	
	    var Lazy = {
	      loadInSlide: function loadInSlide(index, loadInDuplicate) {
	        if ( loadInDuplicate === void 0 ) loadInDuplicate = true;
	
	        var swiper = this;
	        var params = swiper.params.lazy;
	        if (typeof index === 'undefined') { return; }
	        if (swiper.slides.length === 0) { return; }
	        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	
	        var $slideEl = isVirtual
	          ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
	          : swiper.slides.eq(index);
	
	        var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
	        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
	          $images = $images.add($slideEl[0]);
	        }
	        if ($images.length === 0) { return; }
	
	        $images.each(function (imageIndex, imageEl) {
	          var $imageEl = $(imageEl);
	          $imageEl.addClass(params.loadingClass);
	
	          var background = $imageEl.attr('data-background');
	          var src = $imageEl.attr('data-src');
	          var srcset = $imageEl.attr('data-srcset');
	          var sizes = $imageEl.attr('data-sizes');
	          var $pictureEl = $imageEl.parent('picture');
	
	          swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
	            if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
	            if (background) {
	              $imageEl.css('background-image', ("url(\"" + background + "\")"));
	              $imageEl.removeAttr('data-background');
	            } else {
	              if (srcset) {
	                $imageEl.attr('srcset', srcset);
	                $imageEl.removeAttr('data-srcset');
	              }
	              if (sizes) {
	                $imageEl.attr('sizes', sizes);
	                $imageEl.removeAttr('data-sizes');
	              }
	              if ($pictureEl.length) {
	                $pictureEl.children('source').each(function (sourceIndex, sourceEl) {
	                  var $source = $(sourceEl);
	
	                  if ($source.attr('data-srcset')) {
	                    $source.attr('srcset', $source.attr('data-srcset'));
	                    $source.removeAttr('data-srcset');
	                  }
	                });
	              }
	              if (src) {
	                $imageEl.attr('src', src);
	                $imageEl.removeAttr('data-src');
	              }
	            }
	
	            $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
	            $slideEl.find(("." + (params.preloaderClass))).remove();
	            if (swiper.params.loop && loadInDuplicate) {
	              var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
	              if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
	                var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
	                swiper.lazy.loadInSlide(originalSlide.index(), false);
	              } else {
	                var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
	                swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
	              }
	            }
	            swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
	            if (swiper.params.autoHeight) {
	              swiper.updateAutoHeight();
	            }
	          });
	
	          swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
	        });
	      },
	      load: function load() {
	        var swiper = this;
	        var $wrapperEl = swiper.$wrapperEl;
	        var swiperParams = swiper.params;
	        var slides = swiper.slides;
	        var activeIndex = swiper.activeIndex;
	        var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
	        var params = swiperParams.lazy;
	
	        var slidesPerView = swiperParams.slidesPerView;
	        if (slidesPerView === 'auto') {
	          slidesPerView = 0;
	        }
	
	        function slideExist(index) {
	          if (isVirtual) {
	            if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
	              return true;
	            }
	          } else if (slides[index]) { return true; }
	          return false;
	        }
	
	        function slideIndex(slideEl) {
	          if (isVirtual) {
	            return $(slideEl).attr('data-swiper-slide-index');
	          }
	          return $(slideEl).index();
	        }
	
	        if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
	        if (swiper.params.watchSlidesVisibility) {
	          $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
	            var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
	            swiper.lazy.loadInSlide(index);
	          });
	        } else if (slidesPerView > 1) {
	          for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
	            if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
	          }
	        } else {
	          swiper.lazy.loadInSlide(activeIndex);
	        }
	        if (params.loadPrevNext) {
	          if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
	            var amount = params.loadPrevNextAmount;
	            var spv = slidesPerView;
	            var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
	            var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
	            // Next Slides
	            for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
	              if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
	            }
	            // Prev Slides
	            for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
	              if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
	            }
	          } else {
	            var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
	            if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }
	
	            var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
	            if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
	          }
	        }
	      },
	    };
	
	    var Lazy$1 = {
	      name: 'lazy',
	      params: {
	        lazy: {
	          enabled: false,
	          loadPrevNext: false,
	          loadPrevNextAmount: 1,
	          loadOnTransitionStart: false,
	
	          elementClass: 'swiper-lazy',
	          loadingClass: 'swiper-lazy-loading',
	          loadedClass: 'swiper-lazy-loaded',
	          preloaderClass: 'swiper-lazy-preloader',
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          lazy: {
	            initialImageLoaded: false,
	            load: Lazy.load.bind(swiper),
	            loadInSlide: Lazy.loadInSlide.bind(swiper),
	          },
	        });
	      },
	      on: {
	        beforeInit: function beforeInit() {
	          var swiper = this;
	          if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
	            swiper.params.preloadImages = false;
	          }
	        },
	        init: function init() {
	          var swiper = this;
	          if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
	            swiper.lazy.load();
	          }
	        },
	        scroll: function scroll() {
	          var swiper = this;
	          if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
	            swiper.lazy.load();
	          }
	        },
	        resize: function resize() {
	          var swiper = this;
	          if (swiper.params.lazy.enabled) {
	            swiper.lazy.load();
	          }
	        },
	        scrollbarDragMove: function scrollbarDragMove() {
	          var swiper = this;
	          if (swiper.params.lazy.enabled) {
	            swiper.lazy.load();
	          }
	        },
	        transitionStart: function transitionStart() {
	          var swiper = this;
	          if (swiper.params.lazy.enabled) {
	            if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
	              swiper.lazy.load();
	            }
	          }
	        },
	        transitionEnd: function transitionEnd() {
	          var swiper = this;
	          if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
	            swiper.lazy.load();
	          }
	        },
	        slideChange: function slideChange() {
	          var swiper = this;
	          if (swiper.params.lazy.enabled && swiper.params.cssMode) {
	            swiper.lazy.load();
	          }
	        },
	      },
	    };
	
	    /* eslint no-bitwise: ["error", { "allow": [">>"] }] */
	
	    var Controller = {
	      LinearSpline: function LinearSpline(x, y) {
	        var binarySearch = (function search() {
	          var maxIndex;
	          var minIndex;
	          var guess;
	          return function (array, val) {
	            minIndex = -1;
	            maxIndex = array.length;
	            while (maxIndex - minIndex > 1) {
	              guess = maxIndex + minIndex >> 1;
	              if (array[guess] <= val) {
	                minIndex = guess;
	              } else {
	                maxIndex = guess;
	              }
	            }
	            return maxIndex;
	          };
	        }());
	        this.x = x;
	        this.y = y;
	        this.lastIndex = x.length - 1;
	        // Given an x value (x2), return the expected y2 value:
	        // (x1,y1) is the known point before given value,
	        // (x3,y3) is the known point after given value.
	        var i1;
	        var i3;
	
	        this.interpolate = function interpolate(x2) {
	          if (!x2) { return 0; }
	
	          // Get the indexes of x1 and x3 (the array indexes before and after given x2):
	          i3 = binarySearch(this.x, x2);
	          i1 = i3 - 1;
	
	          // We have our indexes i1 & i3, so we can calculate already:
	          // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
	          return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
	        };
	        return this;
	      },
	      // xxx: for now i will just save one spline function to to
	      getInterpolateFunction: function getInterpolateFunction(c) {
	        var swiper = this;
	        if (!swiper.controller.spline) {
	          swiper.controller.spline = swiper.params.loop
	            ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
	            : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
	        }
	      },
	      setTranslate: function setTranslate(setTranslate$1, byController) {
	        var swiper = this;
	        var controlled = swiper.controller.control;
	        var multiplier;
	        var controlledTranslate;
	        function setControlledTranslate(c) {
	          // this will create an Interpolate function based on the snapGrids
	          // x is the Grid of the scrolled scroller and y will be the controlled scroller
	          // it makes sense to create this only once and recall it for the interpolation
	          // the function does a lot of value caching for performance
	          var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
	          if (swiper.params.controller.by === 'slide') {
	            swiper.controller.getInterpolateFunction(c);
	            // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
	            // but it did not work out
	            controlledTranslate = -swiper.controller.spline.interpolate(-translate);
	          }
	
	          if (!controlledTranslate || swiper.params.controller.by === 'container') {
	            multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
	            controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
	          }
	
	          if (swiper.params.controller.inverse) {
	            controlledTranslate = c.maxTranslate() - controlledTranslate;
	          }
	          c.updateProgress(controlledTranslate);
	          c.setTranslate(controlledTranslate, swiper);
	          c.updateActiveIndex();
	          c.updateSlidesClasses();
	        }
	        if (Array.isArray(controlled)) {
	          for (var i = 0; i < controlled.length; i += 1) {
	            if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	              setControlledTranslate(controlled[i]);
	            }
	          }
	        } else if (controlled instanceof Swiper && byController !== controlled) {
	          setControlledTranslate(controlled);
	        }
	      },
	      setTransition: function setTransition(duration, byController) {
	        var swiper = this;
	        var controlled = swiper.controller.control;
	        var i;
	        function setControlledTransition(c) {
	          c.setTransition(duration, swiper);
	          if (duration !== 0) {
	            c.transitionStart();
	            if (c.params.autoHeight) {
	              Utils.nextTick(function () {
	                c.updateAutoHeight();
	              });
	            }
	            c.$wrapperEl.transitionEnd(function () {
	              if (!controlled) { return; }
	              if (c.params.loop && swiper.params.controller.by === 'slide') {
	                c.loopFix();
	              }
	              c.transitionEnd();
	            });
	          }
	        }
	        if (Array.isArray(controlled)) {
	          for (i = 0; i < controlled.length; i += 1) {
	            if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	              setControlledTransition(controlled[i]);
	            }
	          }
	        } else if (controlled instanceof Swiper && byController !== controlled) {
	          setControlledTransition(controlled);
	        }
	      },
	    };
	    var Controller$1 = {
	      name: 'controller',
	      params: {
	        controller: {
	          control: undefined,
	          inverse: false,
	          by: 'slide', // or 'container'
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          controller: {
	            control: swiper.params.controller.control,
	            getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
	            setTranslate: Controller.setTranslate.bind(swiper),
	            setTransition: Controller.setTransition.bind(swiper),
	          },
	        });
	      },
	      on: {
	        update: function update() {
	          var swiper = this;
	          if (!swiper.controller.control) { return; }
	          if (swiper.controller.spline) {
	            swiper.controller.spline = undefined;
	            delete swiper.controller.spline;
	          }
	        },
	        resize: function resize() {
	          var swiper = this;
	          if (!swiper.controller.control) { return; }
	          if (swiper.controller.spline) {
	            swiper.controller.spline = undefined;
	            delete swiper.controller.spline;
	          }
	        },
	        observerUpdate: function observerUpdate() {
	          var swiper = this;
	          if (!swiper.controller.control) { return; }
	          if (swiper.controller.spline) {
	            swiper.controller.spline = undefined;
	            delete swiper.controller.spline;
	          }
	        },
	        setTranslate: function setTranslate(translate, byController) {
	          var swiper = this;
	          if (!swiper.controller.control) { return; }
	          swiper.controller.setTranslate(translate, byController);
	        },
	        setTransition: function setTransition(duration, byController) {
	          var swiper = this;
	          if (!swiper.controller.control) { return; }
	          swiper.controller.setTransition(duration, byController);
	        },
	      },
	    };
	
	    var a11y = {
	      makeElFocusable: function makeElFocusable($el) {
	        $el.attr('tabIndex', '0');
	        return $el;
	      },
	      makeElNotFocusable: function makeElNotFocusable($el) {
	        $el.attr('tabIndex', '-1');
	        return $el;
	      },
	      addElRole: function addElRole($el, role) {
	        $el.attr('role', role);
	        return $el;
	      },
	      addElLabel: function addElLabel($el, label) {
	        $el.attr('aria-label', label);
	        return $el;
	      },
	      disableEl: function disableEl($el) {
	        $el.attr('aria-disabled', true);
	        return $el;
	      },
	      enableEl: function enableEl($el) {
	        $el.attr('aria-disabled', false);
	        return $el;
	      },
	      onEnterKey: function onEnterKey(e) {
	        var swiper = this;
	        var params = swiper.params.a11y;
	        if (e.keyCode !== 13) { return; }
	        var $targetEl = $(e.target);
	        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
	          if (!(swiper.isEnd && !swiper.params.loop)) {
	            swiper.slideNext();
	          }
	          if (swiper.isEnd) {
	            swiper.a11y.notify(params.lastSlideMessage);
	          } else {
	            swiper.a11y.notify(params.nextSlideMessage);
	          }
	        }
	        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
	          if (!(swiper.isBeginning && !swiper.params.loop)) {
	            swiper.slidePrev();
	          }
	          if (swiper.isBeginning) {
	            swiper.a11y.notify(params.firstSlideMessage);
	          } else {
	            swiper.a11y.notify(params.prevSlideMessage);
	          }
	        }
	        if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
	          $targetEl[0].click();
	        }
	      },
	      notify: function notify(message) {
	        var swiper = this;
	        var notification = swiper.a11y.liveRegion;
	        if (notification.length === 0) { return; }
	        notification.html('');
	        notification.html(message);
	      },
	      updateNavigation: function updateNavigation() {
	        var swiper = this;
	
	        if (swiper.params.loop || !swiper.navigation) { return; }
	        var ref = swiper.navigation;
	        var $nextEl = ref.$nextEl;
	        var $prevEl = ref.$prevEl;
	
	        if ($prevEl && $prevEl.length > 0) {
	          if (swiper.isBeginning) {
	            swiper.a11y.disableEl($prevEl);
	            swiper.a11y.makeElNotFocusable($prevEl);
	          } else {
	            swiper.a11y.enableEl($prevEl);
	            swiper.a11y.makeElFocusable($prevEl);
	          }
	        }
	        if ($nextEl && $nextEl.length > 0) {
	          if (swiper.isEnd) {
	            swiper.a11y.disableEl($nextEl);
	            swiper.a11y.makeElNotFocusable($nextEl);
	          } else {
	            swiper.a11y.enableEl($nextEl);
	            swiper.a11y.makeElFocusable($nextEl);
	          }
	        }
	      },
	      updatePagination: function updatePagination() {
	        var swiper = this;
	        var params = swiper.params.a11y;
	        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	          swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
	            var $bulletEl = $(bulletEl);
	            swiper.a11y.makeElFocusable($bulletEl);
	            swiper.a11y.addElRole($bulletEl, 'button');
	            swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
	          });
	        }
	      },
	      init: function init() {
	        var swiper = this;
	
	        swiper.$el.append(swiper.a11y.liveRegion);
	
	        // Navigation
	        var params = swiper.params.a11y;
	        var $nextEl;
	        var $prevEl;
	        if (swiper.navigation && swiper.navigation.$nextEl) {
	          $nextEl = swiper.navigation.$nextEl;
	        }
	        if (swiper.navigation && swiper.navigation.$prevEl) {
	          $prevEl = swiper.navigation.$prevEl;
	        }
	        if ($nextEl) {
	          swiper.a11y.makeElFocusable($nextEl);
	          swiper.a11y.addElRole($nextEl, 'button');
	          swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
	          $nextEl.on('keydown', swiper.a11y.onEnterKey);
	        }
	        if ($prevEl) {
	          swiper.a11y.makeElFocusable($prevEl);
	          swiper.a11y.addElRole($prevEl, 'button');
	          swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
	          $prevEl.on('keydown', swiper.a11y.onEnterKey);
	        }
	
	        // Pagination
	        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	          swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }
	
	        var $nextEl;
	        var $prevEl;
	        if (swiper.navigation && swiper.navigation.$nextEl) {
	          $nextEl = swiper.navigation.$nextEl;
	        }
	        if (swiper.navigation && swiper.navigation.$prevEl) {
	          $prevEl = swiper.navigation.$prevEl;
	        }
	        if ($nextEl) {
	          $nextEl.off('keydown', swiper.a11y.onEnterKey);
	        }
	        if ($prevEl) {
	          $prevEl.off('keydown', swiper.a11y.onEnterKey);
	        }
	
	        // Pagination
	        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	          swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
	        }
	      },
	    };
	    var A11y = {
	      name: 'a11y',
	      params: {
	        a11y: {
	          enabled: true,
	          notificationClass: 'swiper-notification',
	          prevSlideMessage: 'Previous slide',
	          nextSlideMessage: 'Next slide',
	          firstSlideMessage: 'This is the first slide',
	          lastSlideMessage: 'This is the last slide',
	          paginationBulletMessage: 'Go to slide {{index}}',
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          a11y: {
	            liveRegion: $(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
	          },
	        });
	        Object.keys(a11y).forEach(function (methodName) {
	          swiper.a11y[methodName] = a11y[methodName].bind(swiper);
	        });
	      },
	      on: {
	        init: function init() {
	          var swiper = this;
	          if (!swiper.params.a11y.enabled) { return; }
	          swiper.a11y.init();
	          swiper.a11y.updateNavigation();
	        },
	        toEdge: function toEdge() {
	          var swiper = this;
	          if (!swiper.params.a11y.enabled) { return; }
	          swiper.a11y.updateNavigation();
	        },
	        fromEdge: function fromEdge() {
	          var swiper = this;
	          if (!swiper.params.a11y.enabled) { return; }
	          swiper.a11y.updateNavigation();
	        },
	        paginationUpdate: function paginationUpdate() {
	          var swiper = this;
	          if (!swiper.params.a11y.enabled) { return; }
	          swiper.a11y.updatePagination();
	        },
	        destroy: function destroy() {
	          var swiper = this;
	          if (!swiper.params.a11y.enabled) { return; }
	          swiper.a11y.destroy();
	        },
	      },
	    };
	
	    var History = {
	      init: function init() {
	        var swiper = this;
	        if (!swiper.params.history) { return; }
	        if (!win.history || !win.history.pushState) {
	          swiper.params.history.enabled = false;
	          swiper.params.hashNavigation.enabled = true;
	          return;
	        }
	        var history = swiper.history;
	        history.initialized = true;
	        history.paths = History.getPathValues();
	        if (!history.paths.key && !history.paths.value) { return; }
	        history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
	        if (!swiper.params.history.replaceState) {
	          win.addEventListener('popstate', swiper.history.setHistoryPopState);
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (!swiper.params.history.replaceState) {
	          win.removeEventListener('popstate', swiper.history.setHistoryPopState);
	        }
	      },
	      setHistoryPopState: function setHistoryPopState() {
	        var swiper = this;
	        swiper.history.paths = History.getPathValues();
	        swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
	      },
	      getPathValues: function getPathValues() {
	        var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
	        var total = pathArray.length;
	        var key = pathArray[total - 2];
	        var value = pathArray[total - 1];
	        return { key: key, value: value };
	      },
	      setHistory: function setHistory(key, index) {
	        var swiper = this;
	        if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
	        var slide = swiper.slides.eq(index);
	        var value = History.slugify(slide.attr('data-history'));
	        if (!win.location.pathname.includes(key)) {
	          value = key + "/" + value;
	        }
	        var currentState = win.history.state;
	        if (currentState && currentState.value === value) {
	          return;
	        }
	        if (swiper.params.history.replaceState) {
	          win.history.replaceState({ value: value }, null, value);
	        } else {
	          win.history.pushState({ value: value }, null, value);
	        }
	      },
	      slugify: function slugify(text) {
	        return text.toString()
	          .replace(/\s+/g, '-')
	          .replace(/[^\w-]+/g, '')
	          .replace(/--+/g, '-')
	          .replace(/^-+/, '')
	          .replace(/-+$/, '');
	      },
	      scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
	        var swiper = this;
	        if (value) {
	          for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
	            var slide = swiper.slides.eq(i);
	            var slideHistory = History.slugify(slide.attr('data-history'));
	            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
	              var index = slide.index();
	              swiper.slideTo(index, speed, runCallbacks);
	            }
	          }
	        } else {
	          swiper.slideTo(0, speed, runCallbacks);
	        }
	      },
	    };
	
	    var History$1 = {
	      name: 'history',
	      params: {
	        history: {
	          enabled: false,
	          replaceState: false,
	          key: 'slides',
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          history: {
	            init: History.init.bind(swiper),
	            setHistory: History.setHistory.bind(swiper),
	            setHistoryPopState: History.setHistoryPopState.bind(swiper),
	            scrollToSlide: History.scrollToSlide.bind(swiper),
	            destroy: History.destroy.bind(swiper),
	          },
	        });
	      },
	      on: {
	        init: function init() {
	          var swiper = this;
	          if (swiper.params.history.enabled) {
	            swiper.history.init();
	          }
	        },
	        destroy: function destroy() {
	          var swiper = this;
	          if (swiper.params.history.enabled) {
	            swiper.history.destroy();
	          }
	        },
	        transitionEnd: function transitionEnd() {
	          var swiper = this;
	          if (swiper.history.initialized) {
	            swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
	          }
	        },
	        slideChange: function slideChange() {
	          var swiper = this;
	          if (swiper.history.initialized && swiper.params.cssMode) {
	            swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
	          }
	        },
	      },
	    };
	
	    var HashNavigation = {
	      onHashCange: function onHashCange() {
	        var swiper = this;
	        swiper.emit('hashChange');
	        var newHash = doc.location.hash.replace('#', '');
	        var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
	        if (newHash !== activeSlideHash) {
	          var newIndex = swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index();
	          if (typeof newIndex === 'undefined') { return; }
	          swiper.slideTo(newIndex);
	        }
	      },
	      setHash: function setHash() {
	        var swiper = this;
	        if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
	        if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
	          win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
	          swiper.emit('hashSet');
	        } else {
	          var slide = swiper.slides.eq(swiper.activeIndex);
	          var hash = slide.attr('data-hash') || slide.attr('data-history');
	          doc.location.hash = hash || '';
	          swiper.emit('hashSet');
	        }
	      },
	      init: function init() {
	        var swiper = this;
	        if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
	        swiper.hashNavigation.initialized = true;
	        var hash = doc.location.hash.replace('#', '');
	        if (hash) {
	          var speed = 0;
	          for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
	            var slide = swiper.slides.eq(i);
	            var slideHash = slide.attr('data-hash') || slide.attr('data-history');
	            if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
	              var index = slide.index();
	              swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
	            }
	          }
	        }
	        if (swiper.params.hashNavigation.watchState) {
	          $(win).on('hashchange', swiper.hashNavigation.onHashCange);
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (swiper.params.hashNavigation.watchState) {
	          $(win).off('hashchange', swiper.hashNavigation.onHashCange);
	        }
	      },
	    };
	    var HashNavigation$1 = {
	      name: 'hash-navigation',
	      params: {
	        hashNavigation: {
	          enabled: false,
	          replaceState: false,
	          watchState: false,
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          hashNavigation: {
	            initialized: false,
	            init: HashNavigation.init.bind(swiper),
	            destroy: HashNavigation.destroy.bind(swiper),
	            setHash: HashNavigation.setHash.bind(swiper),
	            onHashCange: HashNavigation.onHashCange.bind(swiper),
	          },
	        });
	      },
	      on: {
	        init: function init() {
	          var swiper = this;
	          if (swiper.params.hashNavigation.enabled) {
	            swiper.hashNavigation.init();
	          }
	        },
	        destroy: function destroy() {
	          var swiper = this;
	          if (swiper.params.hashNavigation.enabled) {
	            swiper.hashNavigation.destroy();
	          }
	        },
	        transitionEnd: function transitionEnd() {
	          var swiper = this;
	          if (swiper.hashNavigation.initialized) {
	            swiper.hashNavigation.setHash();
	          }
	        },
	        slideChange: function slideChange() {
	          var swiper = this;
	          if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
	            swiper.hashNavigation.setHash();
	          }
	        },
	      },
	    };
	
	    /* eslint no-underscore-dangle: "off" */
	
	    var Autoplay = {
	      run: function run() {
	        var swiper = this;
	        var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
	        var delay = swiper.params.autoplay.delay;
	        if ($activeSlideEl.attr('data-swiper-autoplay')) {
	          delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
	        }
	        clearTimeout(swiper.autoplay.timeout);
	        swiper.autoplay.timeout = Utils.nextTick(function () {
	          if (swiper.params.autoplay.reverseDirection) {
	            if (swiper.params.loop) {
	              swiper.loopFix();
	              swiper.slidePrev(swiper.params.speed, true, true);
	              swiper.emit('autoplay');
	            } else if (!swiper.isBeginning) {
	              swiper.slidePrev(swiper.params.speed, true, true);
	              swiper.emit('autoplay');
	            } else if (!swiper.params.autoplay.stopOnLastSlide) {
	              swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
	              swiper.emit('autoplay');
	            } else {
	              swiper.autoplay.stop();
	            }
	          } else if (swiper.params.loop) {
	            swiper.loopFix();
	            swiper.slideNext(swiper.params.speed, true, true);
	            swiper.emit('autoplay');
	          } else if (!swiper.isEnd) {
	            swiper.slideNext(swiper.params.speed, true, true);
	            swiper.emit('autoplay');
	          } else if (!swiper.params.autoplay.stopOnLastSlide) {
	            swiper.slideTo(0, swiper.params.speed, true, true);
	            swiper.emit('autoplay');
	          } else {
	            swiper.autoplay.stop();
	          }
	          if (swiper.params.cssMode && swiper.autoplay.running) { swiper.autoplay.run(); }
	        }, delay);
	      },
	      start: function start() {
	        var swiper = this;
	        if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
	        if (swiper.autoplay.running) { return false; }
	        swiper.autoplay.running = true;
	        swiper.emit('autoplayStart');
	        swiper.autoplay.run();
	        return true;
	      },
	      stop: function stop() {
	        var swiper = this;
	        if (!swiper.autoplay.running) { return false; }
	        if (typeof swiper.autoplay.timeout === 'undefined') { return false; }
	
	        if (swiper.autoplay.timeout) {
	          clearTimeout(swiper.autoplay.timeout);
	          swiper.autoplay.timeout = undefined;
	        }
	        swiper.autoplay.running = false;
	        swiper.emit('autoplayStop');
	        return true;
	      },
	      pause: function pause(speed) {
	        var swiper = this;
	        if (!swiper.autoplay.running) { return; }
	        if (swiper.autoplay.paused) { return; }
	        if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
	        swiper.autoplay.paused = true;
	        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
	          swiper.autoplay.paused = false;
	          swiper.autoplay.run();
	        } else {
	          swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
	          swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
	        }
	      },
	    };
	
	    var Autoplay$1 = {
	      name: 'autoplay',
	      params: {
	        autoplay: {
	          enabled: false,
	          delay: 3000,
	          waitForTransition: true,
	          disableOnInteraction: true,
	          stopOnLastSlide: false,
	          reverseDirection: false,
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          autoplay: {
	            running: false,
	            paused: false,
	            run: Autoplay.run.bind(swiper),
	            start: Autoplay.start.bind(swiper),
	            stop: Autoplay.stop.bind(swiper),
	            pause: Autoplay.pause.bind(swiper),
	            onVisibilityChange: function onVisibilityChange() {
	              if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
	                swiper.autoplay.pause();
	              }
	              if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
	                swiper.autoplay.run();
	                swiper.autoplay.paused = false;
	              }
	            },
	            onTransitionEnd: function onTransitionEnd(e) {
	              if (!swiper || swiper.destroyed || !swiper.$wrapperEl) { return; }
	              if (e.target !== this) { return; }
	              swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
	              swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
	              swiper.autoplay.paused = false;
	              if (!swiper.autoplay.running) {
	                swiper.autoplay.stop();
	              } else {
	                swiper.autoplay.run();
	              }
	            },
	          },
	        });
	      },
	      on: {
	        init: function init() {
	          var swiper = this;
	          if (swiper.params.autoplay.enabled) {
	            swiper.autoplay.start();
	            document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
	          }
	        },
	        beforeTransitionStart: function beforeTransitionStart(speed, internal) {
	          var swiper = this;
	          if (swiper.autoplay.running) {
	            if (internal || !swiper.params.autoplay.disableOnInteraction) {
	              swiper.autoplay.pause(speed);
	            } else {
	              swiper.autoplay.stop();
	            }
	          }
	        },
	        sliderFirstMove: function sliderFirstMove() {
	          var swiper = this;
	          if (swiper.autoplay.running) {
	            if (swiper.params.autoplay.disableOnInteraction) {
	              swiper.autoplay.stop();
	            } else {
	              swiper.autoplay.pause();
	            }
	          }
	        },
	        touchEnd: function touchEnd() {
	          var swiper = this;
	          if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
	            swiper.autoplay.run();
	          }
	        },
	        destroy: function destroy() {
	          var swiper = this;
	          if (swiper.autoplay.running) {
	            swiper.autoplay.stop();
	          }
	          document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
	        },
	      },
	    };
	
	    var Fade = {
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        var slides = swiper.slides;
	        for (var i = 0; i < slides.length; i += 1) {
	          var $slideEl = swiper.slides.eq(i);
	          var offset = $slideEl[0].swiperSlideOffset;
	          var tx = -offset;
	          if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
	          var ty = 0;
	          if (!swiper.isHorizontal()) {
	            ty = tx;
	            tx = 0;
	          }
	          var slideOpacity = swiper.params.fadeEffect.crossFade
	            ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
	            : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
	          $slideEl
	            .css({
	              opacity: slideOpacity,
	            })
	            .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
	        }
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        var slides = swiper.slides;
	        var $wrapperEl = swiper.$wrapperEl;
	        slides.transition(duration);
	        if (swiper.params.virtualTranslate && duration !== 0) {
	          var eventTriggered = false;
	          slides.transitionEnd(function () {
	            if (eventTriggered) { return; }
	            if (!swiper || swiper.destroyed) { return; }
	            eventTriggered = true;
	            swiper.animating = false;
	            var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	            for (var i = 0; i < triggerEvents.length; i += 1) {
	              $wrapperEl.trigger(triggerEvents[i]);
	            }
	          });
	        }
	      },
	    };
	
	    var EffectFade = {
	      name: 'effect-fade',
	      params: {
	        fadeEffect: {
	          crossFade: false,
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          fadeEffect: {
	            setTranslate: Fade.setTranslate.bind(swiper),
	            setTransition: Fade.setTransition.bind(swiper),
	          },
	        });
	      },
	      on: {
	        beforeInit: function beforeInit() {
	          var swiper = this;
	          if (swiper.params.effect !== 'fade') { return; }
	          swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
	          var overwriteParams = {
	            slidesPerView: 1,
	            slidesPerColumn: 1,
	            slidesPerGroup: 1,
	            watchSlidesProgress: true,
	            spaceBetween: 0,
	            virtualTranslate: true,
	          };
	          Utils.extend(swiper.params, overwriteParams);
	          Utils.extend(swiper.originalParams, overwriteParams);
	        },
	        setTranslate: function setTranslate() {
	          var swiper = this;
	          if (swiper.params.effect !== 'fade') { return; }
	          swiper.fadeEffect.setTranslate();
	        },
	        setTransition: function setTransition(duration) {
	          var swiper = this;
	          if (swiper.params.effect !== 'fade') { return; }
	          swiper.fadeEffect.setTransition(duration);
	        },
	      },
	    };
	
	    var Cube = {
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        var $el = swiper.$el;
	        var $wrapperEl = swiper.$wrapperEl;
	        var slides = swiper.slides;
	        var swiperWidth = swiper.width;
	        var swiperHeight = swiper.height;
	        var rtl = swiper.rtlTranslate;
	        var swiperSize = swiper.size;
	        var params = swiper.params.cubeEffect;
	        var isHorizontal = swiper.isHorizontal();
	        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	        var wrapperRotate = 0;
	        var $cubeShadowEl;
	        if (params.shadow) {
	          if (isHorizontal) {
	            $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
	            if ($cubeShadowEl.length === 0) {
	              $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
	              $wrapperEl.append($cubeShadowEl);
	            }
	            $cubeShadowEl.css({ height: (swiperWidth + "px") });
	          } else {
	            $cubeShadowEl = $el.find('.swiper-cube-shadow');
	            if ($cubeShadowEl.length === 0) {
	              $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
	              $el.append($cubeShadowEl);
	            }
	          }
	        }
	        for (var i = 0; i < slides.length; i += 1) {
	          var $slideEl = slides.eq(i);
	          var slideIndex = i;
	          if (isVirtual) {
	            slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
	          }
	          var slideAngle = slideIndex * 90;
	          var round = Math.floor(slideAngle / 360);
	          if (rtl) {
	            slideAngle = -slideAngle;
	            round = Math.floor(-slideAngle / 360);
	          }
	          var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	          var tx = 0;
	          var ty = 0;
	          var tz = 0;
	          if (slideIndex % 4 === 0) {
	            tx = -round * 4 * swiperSize;
	            tz = 0;
	          } else if ((slideIndex - 1) % 4 === 0) {
	            tx = 0;
	            tz = -round * 4 * swiperSize;
	          } else if ((slideIndex - 2) % 4 === 0) {
	            tx = swiperSize + (round * 4 * swiperSize);
	            tz = swiperSize;
	          } else if ((slideIndex - 3) % 4 === 0) {
	            tx = -swiperSize;
	            tz = (3 * swiperSize) + (swiperSize * 4 * round);
	          }
	          if (rtl) {
	            tx = -tx;
	          }
	
	          if (!isHorizontal) {
	            ty = tx;
	            tx = 0;
	          }
	
	          var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
	          if (progress <= 1 && progress > -1) {
	            wrapperRotate = (slideIndex * 90) + (progress * 90);
	            if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
	          }
	          $slideEl.transform(transform);
	          if (params.slideShadows) {
	            // Set shadows
	            var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	            var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	            if (shadowBefore.length === 0) {
	              shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
	              $slideEl.append(shadowBefore);
	            }
	            if (shadowAfter.length === 0) {
	              shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
	              $slideEl.append(shadowAfter);
	            }
	            if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
	            if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
	          }
	        }
	        $wrapperEl.css({
	          '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	          '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	          '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	          'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	        });
	
	        if (params.shadow) {
	          if (isHorizontal) {
	            $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
	          } else {
	            var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
	            var multiplier = 1.5 - (
	              (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
	              + (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
	            );
	            var scale1 = params.shadowScale;
	            var scale2 = params.shadowScale / multiplier;
	            var offset = params.shadowOffset;
	            $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
	          }
	        }
	        var zFactor = (Browser.isSafari || Browser.isWebView) ? (-swiperSize / 2) : 0;
	        $wrapperEl
	          .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        var $el = swiper.$el;
	        var slides = swiper.slides;
	        slides
	          .transition(duration)
	          .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	          .transition(duration);
	        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
	          $el.find('.swiper-cube-shadow').transition(duration);
	        }
	      },
	    };
	
	    var EffectCube = {
	      name: 'effect-cube',
	      params: {
	        cubeEffect: {
	          slideShadows: true,
	          shadow: true,
	          shadowOffset: 20,
	          shadowScale: 0.94,
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          cubeEffect: {
	            setTranslate: Cube.setTranslate.bind(swiper),
	            setTransition: Cube.setTransition.bind(swiper),
	          },
	        });
	      },
	      on: {
	        beforeInit: function beforeInit() {
	          var swiper = this;
	          if (swiper.params.effect !== 'cube') { return; }
	          swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
	          swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	          var overwriteParams = {
	            slidesPerView: 1,
	            slidesPerColumn: 1,
	            slidesPerGroup: 1,
	            watchSlidesProgress: true,
	            resistanceRatio: 0,
	            spaceBetween: 0,
	            centeredSlides: false,
	            virtualTranslate: true,
	          };
	          Utils.extend(swiper.params, overwriteParams);
	          Utils.extend(swiper.originalParams, overwriteParams);
	        },
	        setTranslate: function setTranslate() {
	          var swiper = this;
	          if (swiper.params.effect !== 'cube') { return; }
	          swiper.cubeEffect.setTranslate();
	        },
	        setTransition: function setTransition(duration) {
	          var swiper = this;
	          if (swiper.params.effect !== 'cube') { return; }
	          swiper.cubeEffect.setTransition(duration);
	        },
	      },
	    };
	
	    var Flip = {
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        var slides = swiper.slides;
	        var rtl = swiper.rtlTranslate;
	        for (var i = 0; i < slides.length; i += 1) {
	          var $slideEl = slides.eq(i);
	          var progress = $slideEl[0].progress;
	          if (swiper.params.flipEffect.limitRotation) {
	            progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	          }
	          var offset = $slideEl[0].swiperSlideOffset;
	          var rotate = -180 * progress;
	          var rotateY = rotate;
	          var rotateX = 0;
	          var tx = -offset;
	          var ty = 0;
	          if (!swiper.isHorizontal()) {
	            ty = tx;
	            tx = 0;
	            rotateX = -rotateY;
	            rotateY = 0;
	          } else if (rtl) {
	            rotateY = -rotateY;
	          }
	
	          $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
	
	          if (swiper.params.flipEffect.slideShadows) {
	            // Set shadows
	            var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	            var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	            if (shadowBefore.length === 0) {
	              shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
	              $slideEl.append(shadowBefore);
	            }
	            if (shadowAfter.length === 0) {
	              shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
	              $slideEl.append(shadowAfter);
	            }
	            if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
	            if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
	          }
	          $slideEl
	            .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
	        }
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        var slides = swiper.slides;
	        var activeIndex = swiper.activeIndex;
	        var $wrapperEl = swiper.$wrapperEl;
	        slides
	          .transition(duration)
	          .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	          .transition(duration);
	        if (swiper.params.virtualTranslate && duration !== 0) {
	          var eventTriggered = false;
	          // eslint-disable-next-line
	          slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
	            if (eventTriggered) { return; }
	            if (!swiper || swiper.destroyed) { return; }
	            // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
	            eventTriggered = true;
	            swiper.animating = false;
	            var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	            for (var i = 0; i < triggerEvents.length; i += 1) {
	              $wrapperEl.trigger(triggerEvents[i]);
	            }
	          });
	        }
	      },
	    };
	
	    var EffectFlip = {
	      name: 'effect-flip',
	      params: {
	        flipEffect: {
	          slideShadows: true,
	          limitRotation: true,
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          flipEffect: {
	            setTranslate: Flip.setTranslate.bind(swiper),
	            setTransition: Flip.setTransition.bind(swiper),
	          },
	        });
	      },
	      on: {
	        beforeInit: function beforeInit() {
	          var swiper = this;
	          if (swiper.params.effect !== 'flip') { return; }
	          swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
	          swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	          var overwriteParams = {
	            slidesPerView: 1,
	            slidesPerColumn: 1,
	            slidesPerGroup: 1,
	            watchSlidesProgress: true,
	            spaceBetween: 0,
	            virtualTranslate: true,
	          };
	          Utils.extend(swiper.params, overwriteParams);
	          Utils.extend(swiper.originalParams, overwriteParams);
	        },
	        setTranslate: function setTranslate() {
	          var swiper = this;
	          if (swiper.params.effect !== 'flip') { return; }
	          swiper.flipEffect.setTranslate();
	        },
	        setTransition: function setTransition(duration) {
	          var swiper = this;
	          if (swiper.params.effect !== 'flip') { return; }
	          swiper.flipEffect.setTransition(duration);
	        },
	      },
	    };
	
	    var Coverflow = {
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        var swiperWidth = swiper.width;
	        var swiperHeight = swiper.height;
	        var slides = swiper.slides;
	        var $wrapperEl = swiper.$wrapperEl;
	        var slidesSizesGrid = swiper.slidesSizesGrid;
	        var params = swiper.params.coverflowEffect;
	        var isHorizontal = swiper.isHorizontal();
	        var transform = swiper.translate;
	        var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
	        var rotate = isHorizontal ? params.rotate : -params.rotate;
	        var translate = params.depth;
	        // Each slide offset from center
	        for (var i = 0, length = slides.length; i < length; i += 1) {
	          var $slideEl = slides.eq(i);
	          var slideSize = slidesSizesGrid[i];
	          var slideOffset = $slideEl[0].swiperSlideOffset;
	          var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;
	
	          var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
	          var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
	          // var rotateZ = 0
	          var translateZ = -translate * Math.abs(offsetMultiplier);
	
	          var stretch = params.stretch;
	          // Allow percentage to make a relative stretch for responsive sliders
	          if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
	            stretch = ((parseFloat(params.stretch) / 100) * slideSize);
	          }
	          var translateY = isHorizontal ? 0 : stretch * (offsetMultiplier);
	          var translateX = isHorizontal ? stretch * (offsetMultiplier) : 0;
	
	          var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
	
	          // Fix for ultra small values
	          if (Math.abs(translateX) < 0.001) { translateX = 0; }
	          if (Math.abs(translateY) < 0.001) { translateY = 0; }
	          if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
	          if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
	          if (Math.abs(rotateX) < 0.001) { rotateX = 0; }
	          if (Math.abs(scale) < 0.001) { scale = 0; }
	
	          var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg) scale(" + scale + ")";
	
	          $slideEl.transform(slideTransform);
	          $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
	          if (params.slideShadows) {
	            // Set shadows
	            var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	            var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	            if ($shadowBeforeEl.length === 0) {
	              $shadowBeforeEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
	              $slideEl.append($shadowBeforeEl);
	            }
	            if ($shadowAfterEl.length === 0) {
	              $shadowAfterEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
	              $slideEl.append($shadowAfterEl);
	            }
	            if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
	            if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
	          }
	        }
	
	        // Set correct perspective for IE10
	        if (Support.pointerEvents || Support.prefixedPointerEvents) {
	          var ws = $wrapperEl[0].style;
	          ws.perspectiveOrigin = center + "px 50%";
	        }
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        swiper.slides
	          .transition(duration)
	          .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	          .transition(duration);
	      },
	    };
	
	    var EffectCoverflow = {
	      name: 'effect-coverflow',
	      params: {
	        coverflowEffect: {
	          rotate: 50,
	          stretch: 0,
	          depth: 100,
	          scale: 1,
	          modifier: 1,
	          slideShadows: true,
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          coverflowEffect: {
	            setTranslate: Coverflow.setTranslate.bind(swiper),
	            setTransition: Coverflow.setTransition.bind(swiper),
	          },
	        });
	      },
	      on: {
	        beforeInit: function beforeInit() {
	          var swiper = this;
	          if (swiper.params.effect !== 'coverflow') { return; }
	
	          swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
	          swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	
	          swiper.params.watchSlidesProgress = true;
	          swiper.originalParams.watchSlidesProgress = true;
	        },
	        setTranslate: function setTranslate() {
	          var swiper = this;
	          if (swiper.params.effect !== 'coverflow') { return; }
	          swiper.coverflowEffect.setTranslate();
	        },
	        setTransition: function setTransition(duration) {
	          var swiper = this;
	          if (swiper.params.effect !== 'coverflow') { return; }
	          swiper.coverflowEffect.setTransition(duration);
	        },
	      },
	    };
	
	    var Thumbs = {
	      init: function init() {
	        var swiper = this;
	        var ref = swiper.params;
	        var thumbsParams = ref.thumbs;
	        var SwiperClass = swiper.constructor;
	        if (thumbsParams.swiper instanceof SwiperClass) {
	          swiper.thumbs.swiper = thumbsParams.swiper;
	          Utils.extend(swiper.thumbs.swiper.originalParams, {
	            watchSlidesProgress: true,
	            slideToClickedSlide: false,
	          });
	          Utils.extend(swiper.thumbs.swiper.params, {
	            watchSlidesProgress: true,
	            slideToClickedSlide: false,
	          });
	        } else if (Utils.isObject(thumbsParams.swiper)) {
	          swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
	            watchSlidesVisibility: true,
	            watchSlidesProgress: true,
	            slideToClickedSlide: false,
	          }));
	          swiper.thumbs.swiperCreated = true;
	        }
	        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
	        swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
	      },
	      onThumbClick: function onThumbClick() {
	        var swiper = this;
	        var thumbsSwiper = swiper.thumbs.swiper;
	        if (!thumbsSwiper) { return; }
	        var clickedIndex = thumbsSwiper.clickedIndex;
	        var clickedSlide = thumbsSwiper.clickedSlide;
	        if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) { return; }
	        if (typeof clickedIndex === 'undefined' || clickedIndex === null) { return; }
	        var slideToIndex;
	        if (thumbsSwiper.params.loop) {
	          slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	        } else {
	          slideToIndex = clickedIndex;
	        }
	        if (swiper.params.loop) {
	          var currentIndex = swiper.activeIndex;
	          if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
	            swiper.loopFix();
	            // eslint-disable-next-line
	            swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	            currentIndex = swiper.activeIndex;
	          }
	          var prevIndex = swiper.slides.eq(currentIndex).prevAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
	          var nextIndex = swiper.slides.eq(currentIndex).nextAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
	          if (typeof prevIndex === 'undefined') { slideToIndex = nextIndex; }
	          else if (typeof nextIndex === 'undefined') { slideToIndex = prevIndex; }
	          else if (nextIndex - currentIndex < currentIndex - prevIndex) { slideToIndex = nextIndex; }
	          else { slideToIndex = prevIndex; }
	        }
	        swiper.slideTo(slideToIndex);
	      },
	      update: function update(initial) {
	        var swiper = this;
	        var thumbsSwiper = swiper.thumbs.swiper;
	        if (!thumbsSwiper) { return; }
	
	        var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
	          ? thumbsSwiper.slidesPerViewDynamic()
	          : thumbsSwiper.params.slidesPerView;
	
	        var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
	        var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
	        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
	          var currentThumbsIndex = thumbsSwiper.activeIndex;
	          var newThumbsIndex;
	          var direction;
	          if (thumbsSwiper.params.loop) {
	            if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
	              thumbsSwiper.loopFix();
	              // eslint-disable-next-line
	              thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
	              currentThumbsIndex = thumbsSwiper.activeIndex;
	            }
	            // Find actual thumbs index to slide to
	            var prevThumbsIndex = thumbsSwiper.slides
	              .eq(currentThumbsIndex)
	              .prevAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0)
	              .index();
	            var nextThumbsIndex = thumbsSwiper.slides
	              .eq(currentThumbsIndex)
	              .nextAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0)
	              .index();
	            if (typeof prevThumbsIndex === 'undefined') { newThumbsIndex = nextThumbsIndex; }
	            else if (typeof nextThumbsIndex === 'undefined') { newThumbsIndex = prevThumbsIndex; }
	            else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = currentThumbsIndex; }
	            else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = nextThumbsIndex; }
	            else { newThumbsIndex = prevThumbsIndex; }
	            direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
	          } else {
	            newThumbsIndex = swiper.realIndex;
	            direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
	          }
	          if (useOffset) {
	            newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
	          }
	
	          if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
	            if (thumbsSwiper.params.centeredSlides) {
	              if (newThumbsIndex > currentThumbsIndex) {
	                newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
	              } else {
	                newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
	              }
	            } else if (newThumbsIndex > currentThumbsIndex) {
	              newThumbsIndex = newThumbsIndex - slidesPerView + 1;
	            }
	            thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
	          }
	        }
	
	        // Activate thumbs
	        var thumbsToActivate = 1;
	        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
	
	        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
	          thumbsToActivate = swiper.params.slidesPerView;
	        }
	
	        if (!swiper.params.thumbs.multipleActiveThumbs) {
	          thumbsToActivate = 1;
	        }
	
	        thumbsToActivate = Math.floor(thumbsToActivate);
	
	        thumbsSwiper.slides.removeClass(thumbActiveClass);
	        if (thumbsSwiper.params.loop || (thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled)) {
	          for (var i = 0; i < thumbsToActivate; i += 1) {
	            thumbsSwiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]")).addClass(thumbActiveClass);
	          }
	        } else {
	          for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
	            thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
	          }
	        }
	      },
	    };
	    var Thumbs$1 = {
	      name: 'thumbs',
	      params: {
	        thumbs: {
	          swiper: null,
	          multipleActiveThumbs: true,
	          autoScrollOffset: 0,
	          slideThumbActiveClass: 'swiper-slide-thumb-active',
	          thumbsContainerClass: 'swiper-container-thumbs',
	        },
	      },
	      create: function create() {
	        var swiper = this;
	        Utils.extend(swiper, {
	          thumbs: {
	            swiper: null,
	            init: Thumbs.init.bind(swiper),
	            update: Thumbs.update.bind(swiper),
	            onThumbClick: Thumbs.onThumbClick.bind(swiper),
	          },
	        });
	      },
	      on: {
	        beforeInit: function beforeInit() {
	          var swiper = this;
	          var ref = swiper.params;
	          var thumbs = ref.thumbs;
	          if (!thumbs || !thumbs.swiper) { return; }
	          swiper.thumbs.init();
	          swiper.thumbs.update(true);
	        },
	        slideChange: function slideChange() {
	          var swiper = this;
	          if (!swiper.thumbs.swiper) { return; }
	          swiper.thumbs.update();
	        },
	        update: function update() {
	          var swiper = this;
	          if (!swiper.thumbs.swiper) { return; }
	          swiper.thumbs.update();
	        },
	        resize: function resize() {
	          var swiper = this;
	          if (!swiper.thumbs.swiper) { return; }
	          swiper.thumbs.update();
	        },
	        observerUpdate: function observerUpdate() {
	          var swiper = this;
	          if (!swiper.thumbs.swiper) { return; }
	          swiper.thumbs.update();
	        },
	        setTransition: function setTransition(duration) {
	          var swiper = this;
	          var thumbsSwiper = swiper.thumbs.swiper;
	          if (!thumbsSwiper) { return; }
	          thumbsSwiper.setTransition(duration);
	        },
	        beforeDestroy: function beforeDestroy() {
	          var swiper = this;
	          var thumbsSwiper = swiper.thumbs.swiper;
	          if (!thumbsSwiper) { return; }
	          if (swiper.thumbs.swiperCreated && thumbsSwiper) {
	            thumbsSwiper.destroy();
	          }
	        },
	      },
	    };
	
	    // Swiper Class
	
	    var components = [
	      Device$1,
	      Support$1,
	      Browser$1,
	      Resize,
	      Observer$1,
	      Virtual$1,
	      Keyboard$1,
	      Mousewheel$1,
	      Navigation$1,
	      Pagination$1,
	      Scrollbar$1,
	      Parallax$1,
	      Zoom$1,
	      Lazy$1,
	      Controller$1,
	      A11y,
	      History$1,
	      HashNavigation$1,
	      Autoplay$1,
	      EffectFade,
	      EffectCube,
	      EffectFlip,
	      EffectCoverflow,
	      Thumbs$1
	    ];
	
	    if (typeof Swiper.use === 'undefined') {
	      Swiper.use = Swiper.Class.use;
	      Swiper.installModule = Swiper.Class.installModule;
	    }
	
	    Swiper.use(components);
	
	    return Swiper;
	
	})));
	//# sourceMappingURL=swiper.js.map


/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(235).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1095).setImmediate, __webpack_require__(1095).clearImmediate))

/***/ },
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function capitalize(str, lowercaseRest) {
	  str = makeString(str);
	  var remainingChars = !lowercaseRest ? str.slice(1) : str.slice(1).toLowerCase();
	
	  return str.charAt(0).toUpperCase() + remainingChars;
	};


/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function chars(str) {
	  return makeString(str).split('');
	};


/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	var escapeRegExp = __webpack_require__(1497);
	
	module.exports = function defaultToWhiteSpace(characters) {
	  if (characters == null)
	    return '\\s';
	  else if (characters.source)
	    return characters.source;
	  else
	    return '[' + escapeRegExp(characters) + ']';
	};


/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	var defaultToWhiteSpace = __webpack_require__(1135);
	var nativeTrimRight = String.prototype.trimRight;
	
	module.exports = function rtrim(str, characters) {
	  str = makeString(str);
	  if (!characters && nativeTrimRight) return nativeTrimRight.call(str);
	  characters = defaultToWhiteSpace(characters);
	  return str.replace(new RegExp(characters + '+$'), '');
	};


/***/ },
/* 1137 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	Copyright (C) 2015-2017 Andrea Giammarchi - @WebReflection
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	
	*/
	'use strict';
	
	function URLSearchParams(query) {
	  var
	    index, key, value,
	    pairs, i, length,
	    dict = Object.create(null)
	  ;
	  this[secret] = dict;
	  if (!query) return;
	  if (typeof query === 'string') {
	    if (query.charAt(0) === '?') {
	      query = query.slice(1);
	    }
	    for (
	      pairs = query.split('&'),
	      i = 0,
	      length = pairs.length; i < length; i++
	    ) {
	      value = pairs[i];
	      index = value.indexOf('=');
	      if (-1 < index) {
	        appendTo(
	          dict,
	          decode(value.slice(0, index)),
	          decode(value.slice(index + 1))
	        );
	      } else if (value.length){
	        appendTo(
	          dict,
	          decode(value),
	          ''
	        );
	      }
	    }
	  } else {
	    if (isArray(query)) {
	      for (
	        i = 0,
	        length = query.length; i < length; i++
	      ) {
	        value = query[i];
	        appendTo(dict, value[0], value[1]);
	      }
	    } else {
	      for (key in query) {
	         appendTo(dict, key, query[key]);
	      }
	    }
	  }
	}
	
	var
	  isArray = Array.isArray,
	  URLSearchParamsProto = URLSearchParams.prototype,
	  find = /[!'\(\)~]|%20|%00/g,
	  plus = /\+/g,
	  replace = {
	    '!': '%21',
	    "'": '%27',
	    '(': '%28',
	    ')': '%29',
	    '~': '%7E',
	    '%20': '+',
	    '%00': '\x00'
	  },
	  replacer = function (match) {
	    return replace[match];
	  },
	  secret = '__URLSearchParams__:' + Math.random()
	;
	
	function appendTo(dict, name, value) {
	  if (name in dict) {
	    dict[name].push('' + value);
	  } else {
	    dict[name] = isArray(value) ? value : ['' + value];
	  }
	}
	
	function decode(str) {
	  return decodeURIComponent(str.replace(plus, ' '));
	}
	
	function encode(str) {
	  return encodeURIComponent(str).replace(find, replacer);
	}
	
	URLSearchParamsProto.append = function append(name, value) {
	  appendTo(this[secret], name, value);
	};
	
	URLSearchParamsProto.delete = function del(name) {
	  delete this[secret][name];
	};
	
	URLSearchParamsProto.get = function get(name) {
	  var dict = this[secret];
	  return name in dict ? dict[name][0] : null;
	};
	
	URLSearchParamsProto.getAll = function getAll(name) {
	  var dict = this[secret];
	  return name in dict ? dict[name].slice(0) : [];
	};
	
	URLSearchParamsProto.has = function has(name) {
	  return name in this[secret];
	};
	
	URLSearchParamsProto.set = function set(name, value) {
	  this[secret][name] = ['' + value];
	};
	
	URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
	  var dict = this[secret];
	  Object.getOwnPropertyNames(dict).forEach(function(name) {
	    dict[name].forEach(function(value) {
	      callback.call(thisArg, value, name, this);
	    }, this);
	  }, this);
	};
	
	/*
	URLSearchParamsProto.toBody = function() {
	  return new Blob(
	    [this.toString()],
	    {type: 'application/x-www-form-urlencoded'}
	  );
	};
	*/
	
	URLSearchParamsProto.toJSON = function toJSON() {
	  return {};
	};
	
	URLSearchParamsProto.toString = function toString() {
	  var dict = this[secret], query = [], i, key, name, value;
	  for (key in dict) {
	    name = encode(key);
	    for (
	      i = 0,
	      value = dict[key];
	      i < value.length; i++
	    ) {
	      query.push(name + '=' + encode(value[i]));
	    }
	  }
	  return query.join('&');
	};
	
	URLSearchParams = (module.exports = global.URLSearchParams || URLSearchParams);
	
	(function (URLSearchParamsProto) {
	
	  var iterable = (function () {
	    try {
	      return !!Symbol.iterator;
	    } catch(error) {
	      return false;
	    }
	  }());
	
	  // mostly related to issue #24
	  if (!('forEach' in URLSearchParamsProto)) {
	    URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
	      var names = Object.create(null);
	      this.toString()
	          .replace(/=[\s\S]*?(?:&|$)/g, '=')
	          .split('=')
	          .forEach(function (name) {
	            if (!name.length || name in names) return;
	            (names[name] = this.getAll(name)).forEach(function(value) {
	              callback.call(thisArg, value, name, this);
	            }, this);
	          }, this);
	    };
	  }
	
	  if (!('keys' in URLSearchParamsProto)) {
	    URLSearchParamsProto.keys = function keys() {
	      var items = [];
	      this.forEach(function(value, name) { items.push(name); });
	      var iterator = {
	        next: function() {
	          var value = items.shift();
	          return {done: value === undefined, value: value};
	        }
	      };
	
	      if (iterable) {
	        iterator[Symbol.iterator] = function() {
	          return iterator;
	        };
	      }
	
	      return iterator;
	    };
	  }
	
	  if (!('values' in URLSearchParamsProto)) {
	    URLSearchParamsProto.values = function values() {
	      var items = [];
	      this.forEach(function(value) { items.push(value); });
	      var iterator = {
	        next: function() {
	          var value = items.shift();
	          return {done: value === undefined, value: value};
	        }
	      };
	
	      if (iterable) {
	        iterator[Symbol.iterator] = function() {
	          return iterator;
	        };
	      }
	
	      return iterator;
	    };
	  }
	
	  if (!('entries' in URLSearchParamsProto)) {
	    URLSearchParamsProto.entries = function entries() {
	      var items = [];
	      this.forEach(function(value, name) { items.push([name, value]); });
	      var iterator = {
	        next: function() {
	          var value = items.shift();
	          return {done: value === undefined, value: value};
	        }
	      };
	
	      if (iterable) {
	        iterator[Symbol.iterator] = function() {
	          return iterator;
	        };
	      }
	
	      return iterator;
	    };
	  }
	
	  if (iterable && !(Symbol.iterator in URLSearchParamsProto)) {
	    URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
	  }
	
	  if (!('sort' in URLSearchParamsProto)) {
	    URLSearchParamsProto.sort = function sort() {
	      var
	        entries = this.entries(),
	        entry = entries.next(),
	        done = entry.done,
	        keys = [],
	        values = Object.create(null),
	        i, key, value
	      ;
	      while (!done) {
	        value = entry.value;
	        key = value[0];
	        keys.push(key);
	        if (!(key in values)) {
	          values[key] = [];
	        }
	        values[key].push(value[1]);
	        entry = entries.next();
	        done = entry.done;
	      }
	      // not the champion in efficiency
	      // but these two bits just do the job
	      keys.sort();
	      for (i = 0; i < keys.length; i++) {
	        this.delete(keys[i]);
	      }
	      for (i = 0; i < keys.length; i++) {
	        key = keys[i];
	        this.append(key, values[key].shift());
	      }
	    };
	  }
	
	}(URLSearchParams.prototype));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1138 */
[1961, 30],
/* 1139 */
[1962, 30],
/* 1140 */
[1963, 30],
/* 1141 */
[1964, 30],
/* 1142 */
[1965, 30],
/* 1143 */
[1966, 30],
/* 1144 */
[1967, 30],
/* 1145 */
[1968, 30],
/* 1146 */
[1969, 30],
/* 1147 */
[1970, 30],
/* 1148 */
[1971, 30],
/* 1149 */
[1972, 30],
/* 1150 */
[1973, 30],
/* 1151 */
[1974, 30],
/* 1152 */
[1975, 30],
/* 1153 */
[1976, 30],
/* 1154 */
[1977, 30],
/* 1155 */
[1978, 30],
/* 1156 */
[1979, 30],
/* 1157 */
[1980, 30],
/* 1158 */
[1981, 30],
/* 1159 */
[1982, 30],
/* 1160 */
[1983, 30],
/* 1161 */
[1984, 30],
/* 1162 */
[1985, 30],
/* 1163 */
[1986, 30],
/* 1164 */
[1987, 30],
/* 1165 */
[1988, 30],
/* 1166 */
[1989, 30],
/* 1167 */
[1990, 30],
/* 1168 */
[1991, 30],
/* 1169 */
[1992, 30],
/* 1170 */
[1993, 30],
/* 1171 */
[1994, 30],
/* 1172 */
[1995, 30],
/* 1173 */
[1996, 30],
/* 1174 */
[1997, 30],
/* 1175 */
[1998, 30],
/* 1176 */
[1999, 30],
/* 1177 */
[2000, 30],
/* 1178 */
[2001, 30],
/* 1179 */
[2002, 30],
/* 1180 */
[2003, 30],
/* 1181 */
[2004, 30],
/* 1182 */
[2005, 30],
/* 1183 */
[2006, 30],
/* 1184 */
[2007, 30],
/* 1185 */
[2008, 30],
/* 1186 */
[2009, 30],
/* 1187 */
[2010, 30],
/* 1188 */
[2011, 30],
/* 1189 */
[2012, 30],
/* 1190 */
[2013, 30],
/* 1191 */
[2014, 30],
/* 1192 */
[2015, 30],
/* 1193 */
[2016, 30],
/* 1194 */
[2017, 30],
/* 1195 */
[2018, 30],
/* 1196 */
[2019, 30],
/* 1197 */
[2020, 30],
/* 1198 */
[2021, 30],
/* 1199 */
[2022, 30],
/* 1200 */
[2023, 30],
/* 1201 */
[2024, 30],
/* 1202 */
[2025, 30],
/* 1203 */
[2026, 30],
/* 1204 */
[2027, 30],
/* 1205 */
[2028, 30],
/* 1206 */
[2029, 30],
/* 1207 */
[2030, 30],
/* 1208 */
[2031, 30],
/* 1209 */
[2032, 30],
/* 1210 */
[2033, 30],
/* 1211 */
[2034, 30],
/* 1212 */
[2035, 30],
/* 1213 */
[2036, 30],
/* 1214 */
[2037, 30],
/* 1215 */
[2038, 30],
/* 1216 */
[2039, 30],
/* 1217 */
[2040, 30],
/* 1218 */
[2041, 30],
/* 1219 */
[2042, 30],
/* 1220 */
[2043, 30],
/* 1221 */
[2044, 30],
/* 1222 */
[2045, 30],
/* 1223 */
[2046, 30],
/* 1224 */
[2047, 30],
/* 1225 */
[2048, 30],
/* 1226 */
[2049, 30],
/* 1227 */
[2050, 30],
/* 1228 */
[2051, 30],
/* 1229 */
[2052, 30],
/* 1230 */
[2053, 30],
/* 1231 */
[2054, 30],
/* 1232 */
[2055, 30],
/* 1233 */
[2056, 30],
/* 1234 */
[2057, 30],
/* 1235 */
[2058, 30],
/* 1236 */
[2059, 30],
/* 1237 */
[2060, 30],
/* 1238 */
[2061, 30],
/* 1239 */
[2062, 30],
/* 1240 */
[2063, 30],
/* 1241 */
[2064, 30],
/* 1242 */
[2065, 30],
/* 1243 */
[2066, 30],
/* 1244 */
[2067, 30],
/* 1245 */
[2068, 30],
/* 1246 */
[2069, 30],
/* 1247 */
[2070, 30],
/* 1248 */
[2071, 30],
/* 1249 */
[2072, 30],
/* 1250 */
[2073, 30],
/* 1251 */
[2074, 30],
/* 1252 */
[2075, 30],
/* 1253 */
[2076, 30],
/* 1254 */
[2077, 30],
/* 1255 */
[2078, 30],
/* 1256 */
[2079, 30],
/* 1257 */
[2080, 30],
/* 1258 */
[2081, 30],
/* 1259 */
[2082, 30],
/* 1260 */
[2083, 30],
/* 1261 */
[2084, 30],
/* 1262 */
[2085, 30],
/* 1263 */
[2086, 30],
/* 1264 */
[2087, 30],
/* 1265 */
[2088, 30],
/* 1266 */
[2089, 30],
/* 1267 */
[2090, 30],
/* 1268 */
[2091, 30],
/* 1269 */
[2092, 30],
/* 1270 */
[2093, 30],
/* 1271 */
[2094, 30],
/* 1272 */
[2095, 30],
/* 1273 */
[2096, 30],
/* 1274 */
[2097, 30],
/* 1275 */
/***/ function(module, exports) {

	function _assertThisInitialized(e) {
	  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  return e;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	var isNativeReflectConstruct = __webpack_require__(1521);
	var setPrototypeOf = __webpack_require__(911);
	function _construct(t, e, r) {
	  if (isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
	  var o = [null];
	  o.push.apply(o, e);
	  var p = new (t.bind.apply(t, o))();
	  return r && setPrototypeOf(p, r.prototype), p;
	}
	module.exports = _construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(911);
	function _inheritsLoose(t, o) {
	  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHvcCodec = exports.getAvcCodec = exports.getAv1Codec = void 0;
	
	var _byteHelpers = __webpack_require__(476);
	
	// https://aomediacodec.github.io/av1-isobmff/#av1codecconfigurationbox-syntax
	// https://developer.mozilla.org/en-US/docs/Web/Media/Formats/codecs_parameter#AV1
	var getAv1Codec = function getAv1Codec(bytes) {
	  var codec = '';
	  var profile = bytes[1] >>> 3;
	  var level = bytes[1] & 0x1F;
	  var tier = bytes[2] >>> 7;
	  var highBitDepth = (bytes[2] & 0x40) >> 6;
	  var twelveBit = (bytes[2] & 0x20) >> 5;
	  var monochrome = (bytes[2] & 0x10) >> 4;
	  var chromaSubsamplingX = (bytes[2] & 0x08) >> 3;
	  var chromaSubsamplingY = (bytes[2] & 0x04) >> 2;
	  var chromaSamplePosition = bytes[2] & 0x03;
	  codec += profile + "." + (0, _byteHelpers.padStart)(level, 2, '0');
	
	  if (tier === 0) {
	    codec += 'M';
	  } else if (tier === 1) {
	    codec += 'H';
	  }
	
	  var bitDepth;
	
	  if (profile === 2 && highBitDepth) {
	    bitDepth = twelveBit ? 12 : 10;
	  } else {
	    bitDepth = highBitDepth ? 10 : 8;
	  }
	
	  codec += "." + (0, _byteHelpers.padStart)(bitDepth, 2, '0'); // TODO: can we parse color range??
	
	  codec += "." + monochrome;
	  codec += "." + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition;
	  return codec;
	};
	
	exports.getAv1Codec = getAv1Codec;
	
	var getAvcCodec = function getAvcCodec(bytes) {
	  var profileId = (0, _byteHelpers.toHexString)(bytes[1]);
	  var constraintFlags = (0, _byteHelpers.toHexString)(bytes[2] & 0xFC);
	  var levelId = (0, _byteHelpers.toHexString)(bytes[3]);
	  return "" + profileId + constraintFlags + levelId;
	};
	
	exports.getAvcCodec = getAvcCodec;
	
	var getHvcCodec = function getHvcCodec(bytes) {
	  var codec = '';
	  var profileSpace = bytes[1] >> 6;
	  var profileId = bytes[1] & 0x1F;
	  var tierFlag = (bytes[1] & 0x20) >> 5;
	  var profileCompat = bytes.subarray(2, 6);
	  var constraintIds = bytes.subarray(6, 12);
	  var levelId = bytes[12];
	
	  if (profileSpace === 1) {
	    codec += 'A';
	  } else if (profileSpace === 2) {
	    codec += 'B';
	  } else if (profileSpace === 3) {
	    codec += 'C';
	  }
	
	  codec += profileId + "."; // ffmpeg does this in big endian
	
	  var profileCompatVal = parseInt((0, _byteHelpers.toBinaryString)(profileCompat).split('').reverse().join(''), 2); // apple does this in little endian...
	
	  if (profileCompatVal > 255) {
	    profileCompatVal = parseInt((0, _byteHelpers.toBinaryString)(profileCompat), 2);
	  }
	
	  codec += profileCompatVal.toString(16) + ".";
	
	  if (tierFlag === 0) {
	    codec += 'L';
	  } else {
	    codec += 'H';
	  }
	
	  codec += levelId;
	  var constraints = '';
	
	  for (var i = 0; i < constraintIds.length; i++) {
	    var v = constraintIds[i];
	
	    if (v) {
	      if (constraints) {
	        constraints += '.';
	      }
	
	      constraints += v.toString(16);
	    }
	  }
	
	  if (constraints) {
	    codec += "." + constraints;
	  }
	
	  return codec;
	};
	
	exports.getHvcCodec = getHvcCodec;

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	var _interopRequireDefault = __webpack_require__(910);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = decodeB64ToUint8Array;
	
	var _window = _interopRequireDefault(__webpack_require__(344));
	
	var atob = function atob(s) {
	  return _window.default.atob ? _window.default.atob(s) : Buffer.from(s, 'base64').toString('binary');
	};
	
	function decodeB64ToUint8Array(b64Text) {
	  var decodedString = atob(b64Text);
	  var array = new Uint8Array(decodedString.length);
	
	  for (var i = 0; i < decodedString.length; i++) {
	    array[i] = decodedString.charCodeAt(i);
	  }
	
	  return array;
	}
	
	module.exports = exports.default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(810).Buffer))

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getId3Offset = exports.getId3Size = void 0;
	
	var _byteHelpers = __webpack_require__(476);
	
	var ID3 = (0, _byteHelpers.toUint8)([0x49, 0x44, 0x33]);
	
	var getId3Size = function getId3Size(bytes, offset) {
	  if (offset === void 0) {
	    offset = 0;
	  }
	
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var flags = bytes[offset + 5];
	  var returnSize = bytes[offset + 6] << 21 | bytes[offset + 7] << 14 | bytes[offset + 8] << 7 | bytes[offset + 9];
	  var footerPresent = (flags & 16) >> 4;
	
	  if (footerPresent) {
	    return returnSize + 20;
	  }
	
	  return returnSize + 10;
	};
	
	exports.getId3Size = getId3Size;
	
	var getId3Offset = function getId3Offset(bytes, offset) {
	  if (offset === void 0) {
	    offset = 0;
	  }
	
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	
	  if (bytes.length - offset < 10 || !(0, _byteHelpers.bytesMatch)(bytes, ID3, {
	    offset: offset
	  })) {
	    return offset;
	  }
	
	  offset += getId3Size(bytes, offset); // recursive check for id3 tags as some files
	  // have multiple ID3 tag sections even though
	  // they should not.
	
	  return getId3Offset(bytes, offset);
	};
	
	exports.getId3Offset = getId3Offset;

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(910);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _urlToolkit = _interopRequireDefault(__webpack_require__(1943));
	
	var _window = _interopRequireDefault(__webpack_require__(344));
	
	var DEFAULT_LOCATION = 'http://example.com';
	
	var resolveUrl = function resolveUrl(baseUrl, relativeUrl) {
	  // return early if we don't need to resolve
	  if (/^[a-z]+:/i.test(relativeUrl)) {
	    return relativeUrl;
	  } // if baseUrl is a data URI, ignore it and resolve everything relative to window.location
	
	
	  if (/^data:/.test(baseUrl)) {
	    baseUrl = _window.default.location && _window.default.location.href || '';
	  } // IE11 supports URL but not the URL constructor
	  // feature detect the behavior we want
	
	
	  var nativeURL = typeof _window.default.URL === 'function';
	  var protocolLess = /^\/\//.test(baseUrl); // remove location if window.location isn't available (i.e. we're in node)
	  // and if baseUrl isn't an absolute url
	
	  var removeLocation = !_window.default.location && !/\/\//i.test(baseUrl); // if the base URL is relative then combine with the current location
	
	  if (nativeURL) {
	    baseUrl = new _window.default.URL(baseUrl, _window.default.location || DEFAULT_LOCATION);
	  } else if (!/\/\//i.test(baseUrl)) {
	    baseUrl = _urlToolkit.default.buildAbsoluteURL(_window.default.location && _window.default.location.href || '', baseUrl);
	  }
	
	  if (nativeURL) {
	    var newUrl = new URL(relativeUrl, baseUrl); // if we're a protocol-less url, remove the protocol
	    // and if we're location-less, remove the location
	    // otherwise, return the url unmodified
	
	    if (removeLocation) {
	      return newUrl.href.slice(DEFAULT_LOCATION.length);
	    } else if (protocolLess) {
	      return newUrl.href.slice(newUrl.protocol.length);
	    }
	
	    return newUrl.href;
	  }
	
	  return _urlToolkit.default.buildAbsoluteURL(baseUrl, relativeUrl);
	};
	
	var _default = resolveUrl;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	var conventions = __webpack_require__(912);
	
	var find = conventions.find;
	var NAMESPACE = conventions.NAMESPACE;
	
	/**
	 * A prerequisite for `[].filter`, to drop elements that are empty
	 * @param {string} input
	 * @returns {boolean}
	 */
	function notEmptyString (input) {
		return input !== ''
	}
	/**
	 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
	 * @see https://infra.spec.whatwg.org/#ascii-whitespace
	 *
	 * @param {string} input
	 * @returns {string[]} (can be empty)
	 */
	function splitOnASCIIWhitespace(input) {
		// U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
		return input ? input.split(/[\t\n\f\r ]+/).filter(notEmptyString) : []
	}
	
	/**
	 * Adds element as a key to current if it is not already present.
	 *
	 * @param {Record<string, boolean | undefined>} current
	 * @param {string} element
	 * @returns {Record<string, boolean | undefined>}
	 */
	function orderedSetReducer (current, element) {
		if (!current.hasOwnProperty(element)) {
			current[element] = true;
		}
		return current;
	}
	
	/**
	 * @see https://infra.spec.whatwg.org/#ordered-set
	 * @param {string} input
	 * @returns {string[]}
	 */
	function toOrderedSet(input) {
		if (!input) return [];
		var list = splitOnASCIIWhitespace(input);
		return Object.keys(list.reduce(orderedSetReducer, {}))
	}
	
	/**
	 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
	 * which we can not rely on being available.
	 *
	 * @param {any[]} list
	 * @returns {function(any): boolean}
	 */
	function arrayIncludes (list) {
		return function(element) {
			return list && list.indexOf(element) !== -1;
		}
	}
	
	function copy(src,dest){
		for(var p in src){
			if (Object.prototype.hasOwnProperty.call(src, p)) {
				dest[p] = src[p];
			}
		}
	}
	
	/**
	^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
	^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
	 */
	function _extends(Class,Super){
		var pt = Class.prototype;
		if(!(pt instanceof Super)){
			function t(){};
			t.prototype = Super.prototype;
			t = new t();
			copy(pt,t);
			Class.prototype = pt = t;
		}
		if(pt.constructor != Class){
			if(typeof Class != 'function'){
				console.error("unknown Class:"+Class)
			}
			pt.constructor = Class
		}
	}
	
	// Node Types
	var NodeType = {}
	var ELEMENT_NODE                = NodeType.ELEMENT_NODE                = 1;
	var ATTRIBUTE_NODE              = NodeType.ATTRIBUTE_NODE              = 2;
	var TEXT_NODE                   = NodeType.TEXT_NODE                   = 3;
	var CDATA_SECTION_NODE          = NodeType.CDATA_SECTION_NODE          = 4;
	var ENTITY_REFERENCE_NODE       = NodeType.ENTITY_REFERENCE_NODE       = 5;
	var ENTITY_NODE                 = NodeType.ENTITY_NODE                 = 6;
	var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
	var COMMENT_NODE                = NodeType.COMMENT_NODE                = 8;
	var DOCUMENT_NODE               = NodeType.DOCUMENT_NODE               = 9;
	var DOCUMENT_TYPE_NODE          = NodeType.DOCUMENT_TYPE_NODE          = 10;
	var DOCUMENT_FRAGMENT_NODE      = NodeType.DOCUMENT_FRAGMENT_NODE      = 11;
	var NOTATION_NODE               = NodeType.NOTATION_NODE               = 12;
	
	// ExceptionCode
	var ExceptionCode = {}
	var ExceptionMessage = {};
	var INDEX_SIZE_ERR              = ExceptionCode.INDEX_SIZE_ERR              = ((ExceptionMessage[1]="Index size error"),1);
	var DOMSTRING_SIZE_ERR          = ExceptionCode.DOMSTRING_SIZE_ERR          = ((ExceptionMessage[2]="DOMString size error"),2);
	var HIERARCHY_REQUEST_ERR       = ExceptionCode.HIERARCHY_REQUEST_ERR       = ((ExceptionMessage[3]="Hierarchy request error"),3);
	var WRONG_DOCUMENT_ERR          = ExceptionCode.WRONG_DOCUMENT_ERR          = ((ExceptionMessage[4]="Wrong document"),4);
	var INVALID_CHARACTER_ERR       = ExceptionCode.INVALID_CHARACTER_ERR       = ((ExceptionMessage[5]="Invalid character"),5);
	var NO_DATA_ALLOWED_ERR         = ExceptionCode.NO_DATA_ALLOWED_ERR         = ((ExceptionMessage[6]="No data allowed"),6);
	var NO_MODIFICATION_ALLOWED_ERR = ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ((ExceptionMessage[7]="No modification allowed"),7);
	var NOT_FOUND_ERR               = ExceptionCode.NOT_FOUND_ERR               = ((ExceptionMessage[8]="Not found"),8);
	var NOT_SUPPORTED_ERR           = ExceptionCode.NOT_SUPPORTED_ERR           = ((ExceptionMessage[9]="Not supported"),9);
	var INUSE_ATTRIBUTE_ERR         = ExceptionCode.INUSE_ATTRIBUTE_ERR         = ((ExceptionMessage[10]="Attribute in use"),10);
	//level2
	var INVALID_STATE_ERR        	= ExceptionCode.INVALID_STATE_ERR        	= ((ExceptionMessage[11]="Invalid state"),11);
	var SYNTAX_ERR               	= ExceptionCode.SYNTAX_ERR               	= ((ExceptionMessage[12]="Syntax error"),12);
	var INVALID_MODIFICATION_ERR 	= ExceptionCode.INVALID_MODIFICATION_ERR 	= ((ExceptionMessage[13]="Invalid modification"),13);
	var NAMESPACE_ERR            	= ExceptionCode.NAMESPACE_ERR           	= ((ExceptionMessage[14]="Invalid namespace"),14);
	var INVALID_ACCESS_ERR       	= ExceptionCode.INVALID_ACCESS_ERR      	= ((ExceptionMessage[15]="Invalid access"),15);
	
	/**
	 * DOM Level 2
	 * Object DOMException
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
	 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
	 */
	function DOMException(code, message) {
		if(message instanceof Error){
			var error = message;
		}else{
			error = this;
			Error.call(this, ExceptionMessage[code]);
			this.message = ExceptionMessage[code];
			if(Error.captureStackTrace) Error.captureStackTrace(this, DOMException);
		}
		error.code = code;
		if(message) this.message = this.message + ": " + message;
		return error;
	};
	DOMException.prototype = Error.prototype;
	copy(ExceptionCode,DOMException)
	
	/**
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
	 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
	 * The items in the NodeList are accessible via an integral index, starting from 0.
	 */
	function NodeList() {
	};
	NodeList.prototype = {
		/**
		 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
		 * @standard level1
		 */
		length:0,
		/**
		 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
		 * @standard level1
		 * @param index  unsigned long
		 *   Index into the collection.
		 * @return Node
		 * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
		 */
		item: function(index) {
			return index >= 0 && index < this.length ? this[index] : null;
		},
		toString:function(isHTML,nodeFilter){
			for(var buf = [], i = 0;i<this.length;i++){
				serializeToString(this[i],buf,isHTML,nodeFilter);
			}
			return buf.join('');
		},
		/**
		 * @private
		 * @param {function (Node):boolean} predicate
		 * @returns {Node[]}
		 */
		filter: function (predicate) {
			return Array.prototype.filter.call(this, predicate);
		},
		/**
		 * @private
		 * @param {Node} item
		 * @returns {number}
		 */
		indexOf: function (item) {
			return Array.prototype.indexOf.call(this, item);
		},
	};
	
	function LiveNodeList(node,refresh){
		this._node = node;
		this._refresh = refresh
		_updateLiveList(this);
	}
	function _updateLiveList(list){
		var inc = list._node._inc || list._node.ownerDocument._inc;
		if (list._inc !== inc) {
			var ls = list._refresh(list._node);
			__set__(list,'length',ls.length);
			if (!list.$$length || ls.length < list.$$length) {
				for (var i = ls.length; i in list; i++) {
					if (Object.prototype.hasOwnProperty.call(list, i)) {
						delete list[i];
					}
				}
			}
			copy(ls,list);
			list._inc = inc;
		}
	}
	LiveNodeList.prototype.item = function(i){
		_updateLiveList(this);
		return this[i] || null;
	}
	
	_extends(LiveNodeList,NodeList);
	
	/**
	 * Objects implementing the NamedNodeMap interface are used
	 * to represent collections of nodes that can be accessed by name.
	 * Note that NamedNodeMap does not inherit from NodeList;
	 * NamedNodeMaps are not maintained in any particular order.
	 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
	 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
	 * and does not imply that the DOM specifies an order to these Nodes.
	 * NamedNodeMap objects in the DOM are live.
	 * used for attributes or DocumentType entities
	 */
	function NamedNodeMap() {
	};
	
	function _findNodeIndex(list,node){
		var i = list.length;
		while(i--){
			if(list[i] === node){return i}
		}
	}
	
	function _addNamedNode(el,list,newAttr,oldAttr){
		if(oldAttr){
			list[_findNodeIndex(list,oldAttr)] = newAttr;
		}else{
			list[list.length++] = newAttr;
		}
		if(el){
			newAttr.ownerElement = el;
			var doc = el.ownerDocument;
			if(doc){
				oldAttr && _onRemoveAttribute(doc,el,oldAttr);
				_onAddAttribute(doc,el,newAttr);
			}
		}
	}
	function _removeNamedNode(el,list,attr){
		//console.log('remove attr:'+attr)
		var i = _findNodeIndex(list,attr);
		if(i>=0){
			var lastIndex = list.length-1
			while(i<lastIndex){
				list[i] = list[++i]
			}
			list.length = lastIndex;
			if(el){
				var doc = el.ownerDocument;
				if(doc){
					_onRemoveAttribute(doc,el,attr);
					attr.ownerElement = null;
				}
			}
		}else{
			throw new DOMException(NOT_FOUND_ERR,new Error(el.tagName+'@'+attr))
		}
	}
	NamedNodeMap.prototype = {
		length:0,
		item:NodeList.prototype.item,
		getNamedItem: function(key) {
	//		if(key.indexOf(':')>0 || key == 'xmlns'){
	//			return null;
	//		}
			//console.log()
			var i = this.length;
			while(i--){
				var attr = this[i];
				//console.log(attr.nodeName,key)
				if(attr.nodeName == key){
					return attr;
				}
			}
		},
		setNamedItem: function(attr) {
			var el = attr.ownerElement;
			if(el && el!=this._ownerElement){
				throw new DOMException(INUSE_ATTRIBUTE_ERR);
			}
			var oldAttr = this.getNamedItem(attr.nodeName);
			_addNamedNode(this._ownerElement,this,attr,oldAttr);
			return oldAttr;
		},
		/* returns Node */
		setNamedItemNS: function(attr) {// raises: WRONG_DOCUMENT_ERR,NO_MODIFICATION_ALLOWED_ERR,INUSE_ATTRIBUTE_ERR
			var el = attr.ownerElement, oldAttr;
			if(el && el!=this._ownerElement){
				throw new DOMException(INUSE_ATTRIBUTE_ERR);
			}
			oldAttr = this.getNamedItemNS(attr.namespaceURI,attr.localName);
			_addNamedNode(this._ownerElement,this,attr,oldAttr);
			return oldAttr;
		},
	
		/* returns Node */
		removeNamedItem: function(key) {
			var attr = this.getNamedItem(key);
			_removeNamedNode(this._ownerElement,this,attr);
			return attr;
	
	
		},// raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
	
		//for level2
		removeNamedItemNS:function(namespaceURI,localName){
			var attr = this.getNamedItemNS(namespaceURI,localName);
			_removeNamedNode(this._ownerElement,this,attr);
			return attr;
		},
		getNamedItemNS: function(namespaceURI, localName) {
			var i = this.length;
			while(i--){
				var node = this[i];
				if(node.localName == localName && node.namespaceURI == namespaceURI){
					return node;
				}
			}
			return null;
		}
	};
	
	/**
	 * The DOMImplementation interface represents an object providing methods
	 * which are not dependent on any particular document.
	 * Such an object is returned by the `Document.implementation` property.
	 *
	 * __The individual methods describe the differences compared to the specs.__
	 *
	 * @constructor
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
	 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
	 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
	 */
	function DOMImplementation() {
	}
	
	DOMImplementation.prototype = {
		/**
		 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
		 * The different implementations fairly diverged in what kind of features were reported.
		 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
		 *
		 * @deprecated It is deprecated and modern browsers return true in all cases.
		 *
		 * @param {string} feature
		 * @param {string} [version]
		 * @returns {boolean} always true
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
		 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
		 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
		 */
		hasFeature: function(feature, version) {
				return true;
		},
		/**
		 * Creates an XML Document object of the specified type with its document element.
		 *
		 * __It behaves slightly different from the description in the living standard__:
		 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
		 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
		 * - this implementation is not validating names or qualified names
		 *   (when parsing XML strings, the SAX parser takes care of that)
		 *
		 * @param {string|null} namespaceURI
		 * @param {string} qualifiedName
		 * @param {DocumentType=null} doctype
		 * @returns {Document}
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
		 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
		 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
		 *
		 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
		 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
		 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
		 */
		createDocument: function(namespaceURI,  qualifiedName, doctype){
			var doc = new Document();
			doc.implementation = this;
			doc.childNodes = new NodeList();
			doc.doctype = doctype || null;
			if (doctype){
				doc.appendChild(doctype);
			}
			if (qualifiedName){
				var root = doc.createElementNS(namespaceURI, qualifiedName);
				doc.appendChild(root);
			}
			return doc;
		},
		/**
		 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
		 *
		 * __This behavior is slightly different from the in the specs__:
		 * - this implementation is not validating names or qualified names
		 *   (when parsing XML strings, the SAX parser takes care of that)
		 *
		 * @param {string} qualifiedName
		 * @param {string} [publicId]
		 * @param {string} [systemId]
		 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
		 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
		 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
		 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
		 *
		 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
		 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
		 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
		 */
		createDocumentType: function(qualifiedName, publicId, systemId){
			var node = new DocumentType();
			node.name = qualifiedName;
			node.nodeName = qualifiedName;
			node.publicId = publicId || '';
			node.systemId = systemId || '';
	
			return node;
		}
	};
	
	
	/**
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
	 */
	
	function Node() {
	};
	
	Node.prototype = {
		firstChild : null,
		lastChild : null,
		previousSibling : null,
		nextSibling : null,
		attributes : null,
		parentNode : null,
		childNodes : null,
		ownerDocument : null,
		nodeValue : null,
		namespaceURI : null,
		prefix : null,
		localName : null,
		// Modified in DOM Level 2:
		insertBefore:function(newChild, refChild){//raises
			return _insertBefore(this,newChild,refChild);
		},
		replaceChild:function(newChild, oldChild){//raises
			_insertBefore(this, newChild,oldChild, assertPreReplacementValidityInDocument);
			if(oldChild){
				this.removeChild(oldChild);
			}
		},
		removeChild:function(oldChild){
			return _removeChild(this,oldChild);
		},
		appendChild:function(newChild){
			return this.insertBefore(newChild,null);
		},
		hasChildNodes:function(){
			return this.firstChild != null;
		},
		cloneNode:function(deep){
			return cloneNode(this.ownerDocument||this,this,deep);
		},
		// Modified in DOM Level 2:
		normalize:function(){
			var child = this.firstChild;
			while(child){
				var next = child.nextSibling;
				if(next && next.nodeType == TEXT_NODE && child.nodeType == TEXT_NODE){
					this.removeChild(next);
					child.appendData(next.data);
				}else{
					child.normalize();
					child = next;
				}
			}
		},
	  	// Introduced in DOM Level 2:
		isSupported:function(feature, version){
			return this.ownerDocument.implementation.hasFeature(feature,version);
		},
	    // Introduced in DOM Level 2:
	    hasAttributes:function(){
	    	return this.attributes.length>0;
	    },
		/**
		 * Look up the prefix associated to the given namespace URI, starting from this node.
		 * **The default namespace declarations are ignored by this method.**
		 * See Namespace Prefix Lookup for details on the algorithm used by this method.
		 *
		 * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
		 *
		 * @param {string | null} namespaceURI
		 * @returns {string | null}
		 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
		 * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
		 * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
		 * @see https://github.com/xmldom/xmldom/issues/322
		 */
	    lookupPrefix:function(namespaceURI){
	    	var el = this;
	    	while(el){
	    		var map = el._nsMap;
	    		//console.dir(map)
	    		if(map){
	    			for(var n in map){
							if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) {
								return n;
							}
	    			}
	    		}
	    		el = el.nodeType == ATTRIBUTE_NODE?el.ownerDocument : el.parentNode;
	    	}
	    	return null;
	    },
	    // Introduced in DOM Level 3:
	    lookupNamespaceURI:function(prefix){
	    	var el = this;
	    	while(el){
	    		var map = el._nsMap;
	    		//console.dir(map)
	    		if(map){
	    			if(Object.prototype.hasOwnProperty.call(map, prefix)){
	    				return map[prefix] ;
	    			}
	    		}
	    		el = el.nodeType == ATTRIBUTE_NODE?el.ownerDocument : el.parentNode;
	    	}
	    	return null;
	    },
	    // Introduced in DOM Level 3:
	    isDefaultNamespace:function(namespaceURI){
	    	var prefix = this.lookupPrefix(namespaceURI);
	    	return prefix == null;
	    }
	};
	
	
	function _xmlEncoder(c){
		return c == '<' && '&lt;' ||
	         c == '>' && '&gt;' ||
	         c == '&' && '&amp;' ||
	         c == '"' && '&quot;' ||
	         '&#'+c.charCodeAt()+';'
	}
	
	
	copy(NodeType,Node);
	copy(NodeType,Node.prototype);
	
	/**
	 * @param callback return true for continue,false for break
	 * @return boolean true: break visit;
	 */
	function _visitNode(node,callback){
		if(callback(node)){
			return true;
		}
		if(node = node.firstChild){
			do{
				if(_visitNode(node,callback)){return true}
	        }while(node=node.nextSibling)
	    }
	}
	
	
	
	function Document(){
		this.ownerDocument = this;
	}
	
	function _onAddAttribute(doc,el,newAttr){
		doc && doc._inc++;
		var ns = newAttr.namespaceURI ;
		if(ns === NAMESPACE.XMLNS){
			//update namespace
			el._nsMap[newAttr.prefix?newAttr.localName:''] = newAttr.value
		}
	}
	
	function _onRemoveAttribute(doc,el,newAttr,remove){
		doc && doc._inc++;
		var ns = newAttr.namespaceURI ;
		if(ns === NAMESPACE.XMLNS){
			//update namespace
			delete el._nsMap[newAttr.prefix?newAttr.localName:'']
		}
	}
	
	/**
	 * Updates `el.childNodes`, updating the indexed items and it's `length`.
	 * Passing `newChild` means it will be appended.
	 * Otherwise it's assumed that an item has been removed,
	 * and `el.firstNode` and it's `.nextSibling` are used
	 * to walk the current list of child nodes.
	 *
	 * @param {Document} doc
	 * @param {Node} el
	 * @param {Node} [newChild]
	 * @private
	 */
	function _onUpdateChild (doc, el, newChild) {
		if(doc && doc._inc){
			doc._inc++;
			//update childNodes
			var cs = el.childNodes;
			if (newChild) {
				cs[cs.length++] = newChild;
			} else {
				var child = el.firstChild;
				var i = 0;
				while (child) {
					cs[i++] = child;
					child = child.nextSibling;
				}
				cs.length = i;
				delete cs[cs.length];
			}
		}
	}
	
	/**
	 * Removes the connections between `parentNode` and `child`
	 * and any existing `child.previousSibling` or `child.nextSibling`.
	 *
	 * @see https://github.com/xmldom/xmldom/issues/135
	 * @see https://github.com/xmldom/xmldom/issues/145
	 *
	 * @param {Node} parentNode
	 * @param {Node} child
	 * @returns {Node} the child that was removed.
	 * @private
	 */
	function _removeChild (parentNode, child) {
		var previous = child.previousSibling;
		var next = child.nextSibling;
		if (previous) {
			previous.nextSibling = next;
		} else {
			parentNode.firstChild = next;
		}
		if (next) {
			next.previousSibling = previous;
		} else {
			parentNode.lastChild = previous;
		}
		child.parentNode = null;
		child.previousSibling = null;
		child.nextSibling = null;
		_onUpdateChild(parentNode.ownerDocument, parentNode);
		return child;
	}
	
	/**
	 * Returns `true` if `node` can be a parent for insertion.
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function hasValidParentNodeType(node) {
		return (
			node &&
			(node.nodeType === Node.DOCUMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === Node.ELEMENT_NODE)
		);
	}
	
	/**
	 * Returns `true` if `node` can be inserted according to it's `nodeType`.
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function hasInsertableNodeType(node) {
		return (
			node &&
			(isElementNode(node) ||
				isTextNode(node) ||
				isDocTypeNode(node) ||
				node.nodeType === Node.DOCUMENT_FRAGMENT_NODE ||
				node.nodeType === Node.COMMENT_NODE ||
				node.nodeType === Node.PROCESSING_INSTRUCTION_NODE)
		);
	}
	
	/**
	 * Returns true if `node` is a DOCTYPE node
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function isDocTypeNode(node) {
		return node && node.nodeType === Node.DOCUMENT_TYPE_NODE;
	}
	
	/**
	 * Returns true if the node is an element
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function isElementNode(node) {
		return node && node.nodeType === Node.ELEMENT_NODE;
	}
	/**
	 * Returns true if `node` is a text node
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function isTextNode(node) {
		return node && node.nodeType === Node.TEXT_NODE;
	}
	
	/**
	 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
	 * according to the presence and position of a doctype node on the same level.
	 *
	 * @param {Document} doc The document node
	 * @param {Node} child the node that would become the nextSibling if the element would be inserted
	 * @returns {boolean} `true` if an element can be inserted before child
	 * @private
	 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 */
	function isElementInsertionPossible(doc, child) {
		var parentChildNodes = doc.childNodes || [];
		if (find(parentChildNodes, isElementNode) || isDocTypeNode(child)) {
			return false;
		}
		var docTypeNode = find(parentChildNodes, isDocTypeNode);
		return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
	}
	
	/**
	 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
	 * according to the presence and position of a doctype node on the same level.
	 *
	 * @param {Node} doc The document node
	 * @param {Node} child the node that would become the nextSibling if the element would be inserted
	 * @returns {boolean} `true` if an element can be inserted before child
	 * @private
	 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 */
	function isElementReplacementPossible(doc, child) {
		var parentChildNodes = doc.childNodes || [];
	
		function hasElementChildThatIsNotChild(node) {
			return isElementNode(node) && node !== child;
		}
	
		if (find(parentChildNodes, hasElementChildThatIsNotChild)) {
			return false;
		}
		var docTypeNode = find(parentChildNodes, isDocTypeNode);
		return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
	}
	
	/**
	 * @private
	 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
	 *
	 * @param {Node} parent the parent node to insert `node` into
	 * @param {Node} node the node to insert
	 * @param {Node=} child the node that should become the `nextSibling` of `node`
	 * @returns {Node}
	 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
	 * @throws DOMException if `child` is provided but is not a child of `parent`.
	 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 * @see https://dom.spec.whatwg.org/#concept-node-replace
	 */
	function assertPreInsertionValidity1to5(parent, node, child) {
		// 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
		if (!hasValidParentNodeType(parent)) {
			throw new DOMException(HIERARCHY_REQUEST_ERR, 'Unexpected parent node type ' + parent.nodeType);
		}
		// 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
		// not implemented!
		// 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
		if (child && child.parentNode !== parent) {
			throw new DOMException(NOT_FOUND_ERR, 'child not in parent');
		}
		if (
			// 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
			!hasInsertableNodeType(node) ||
			// 5. If either `node` is a Text node and `parent` is a document,
			// the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
			// || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
			// or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
			(isDocTypeNode(node) && parent.nodeType !== Node.DOCUMENT_NODE)
		) {
			throw new DOMException(
				HIERARCHY_REQUEST_ERR,
				'Unexpected node type ' + node.nodeType + ' for parent node type ' + parent.nodeType
			);
		}
	}
	
	/**
	 * @private
	 * Step 6 of the checks before inserting and before replacing a child are different.
	 *
	 * @param {Document} parent the parent node to insert `node` into
	 * @param {Node} node the node to insert
	 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
	 * @returns {Node}
	 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
	 * @throws DOMException if `child` is provided but is not a child of `parent`.
	 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 * @see https://dom.spec.whatwg.org/#concept-node-replace
	 */
	function assertPreInsertionValidityInDocument(parent, node, child) {
		var parentChildNodes = parent.childNodes || [];
		var nodeChildNodes = node.childNodes || [];
	
		// DocumentFragment
		if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
			var nodeChildElements = nodeChildNodes.filter(isElementNode);
			// If node has more than one element child or has a Text node child.
			if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
			}
			// Otherwise, if `node` has one element child and either `parent` has an element child,
			// `child` is a doctype, or `child` is non-null and a doctype is following `child`.
			if (nodeChildElements.length === 1 && !isElementInsertionPossible(parent, child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
			}
		}
		// Element
		if (isElementNode(node)) {
			// `parent` has an element child, `child` is a doctype,
			// or `child` is non-null and a doctype is following `child`.
			if (!isElementInsertionPossible(parent, child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
			}
		}
		// DocumentType
		if (isDocTypeNode(node)) {
			// `parent` has a doctype child,
			if (find(parentChildNodes, isDocTypeNode)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
			}
			var parentElementChild = find(parentChildNodes, isElementNode);
			// `child` is non-null and an element is preceding `child`,
			if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
			}
			// or `child` is null and `parent` has an element child.
			if (!child && parentElementChild) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can not be appended since element is present');
			}
		}
	}
	
	/**
	 * @private
	 * Step 6 of the checks before inserting and before replacing a child are different.
	 *
	 * @param {Document} parent the parent node to insert `node` into
	 * @param {Node} node the node to insert
	 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
	 * @returns {Node}
	 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
	 * @throws DOMException if `child` is provided but is not a child of `parent`.
	 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 * @see https://dom.spec.whatwg.org/#concept-node-replace
	 */
	function assertPreReplacementValidityInDocument(parent, node, child) {
		var parentChildNodes = parent.childNodes || [];
		var nodeChildNodes = node.childNodes || [];
	
		// DocumentFragment
		if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
			var nodeChildElements = nodeChildNodes.filter(isElementNode);
			// If `node` has more than one element child or has a Text node child.
			if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
			}
			// Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
			if (nodeChildElements.length === 1 && !isElementReplacementPossible(parent, child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
			}
		}
		// Element
		if (isElementNode(node)) {
			// `parent` has an element child that is not `child` or a doctype is following `child`.
			if (!isElementReplacementPossible(parent, child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
			}
		}
		// DocumentType
		if (isDocTypeNode(node)) {
			function hasDoctypeChildThatIsNotChild(node) {
				return isDocTypeNode(node) && node !== child;
			}
	
			// `parent` has a doctype child that is not `child`,
			if (find(parentChildNodes, hasDoctypeChildThatIsNotChild)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
			}
			var parentElementChild = find(parentChildNodes, isElementNode);
			// or an element is preceding `child`.
			if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
			}
		}
	}
	
	/**
	 * @private
	 * @param {Node} parent the parent node to insert `node` into
	 * @param {Node} node the node to insert
	 * @param {Node=} child the node that should become the `nextSibling` of `node`
	 * @returns {Node}
	 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
	 * @throws DOMException if `child` is provided but is not a child of `parent`.
	 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 */
	function _insertBefore(parent, node, child, _inDocumentAssertion) {
		// To ensure pre-insertion validity of a node into a parent before a child, run these steps:
		assertPreInsertionValidity1to5(parent, node, child);
	
		// If parent is a document, and any of the statements below, switched on the interface node implements,
		// are true, then throw a "HierarchyRequestError" DOMException.
		if (parent.nodeType === Node.DOCUMENT_NODE) {
			(_inDocumentAssertion || assertPreInsertionValidityInDocument)(parent, node, child);
		}
	
		var cp = node.parentNode;
		if(cp){
			cp.removeChild(node);//remove and update
		}
		if(node.nodeType === DOCUMENT_FRAGMENT_NODE){
			var newFirst = node.firstChild;
			if (newFirst == null) {
				return node;
			}
			var newLast = node.lastChild;
		}else{
			newFirst = newLast = node;
		}
		var pre = child ? child.previousSibling : parent.lastChild;
	
		newFirst.previousSibling = pre;
		newLast.nextSibling = child;
	
	
		if(pre){
			pre.nextSibling = newFirst;
		}else{
			parent.firstChild = newFirst;
		}
		if(child == null){
			parent.lastChild = newLast;
		}else{
			child.previousSibling = newLast;
		}
		do{
			newFirst.parentNode = parent;
		}while(newFirst !== newLast && (newFirst= newFirst.nextSibling))
		_onUpdateChild(parent.ownerDocument||parent, parent);
		//console.log(parent.lastChild.nextSibling == null)
		if (node.nodeType == DOCUMENT_FRAGMENT_NODE) {
			node.firstChild = node.lastChild = null;
		}
		return node;
	}
	
	/**
	 * Appends `newChild` to `parentNode`.
	 * If `newChild` is already connected to a `parentNode` it is first removed from it.
	 *
	 * @see https://github.com/xmldom/xmldom/issues/135
	 * @see https://github.com/xmldom/xmldom/issues/145
	 * @param {Node} parentNode
	 * @param {Node} newChild
	 * @returns {Node}
	 * @private
	 */
	function _appendSingleChild (parentNode, newChild) {
		if (newChild.parentNode) {
			newChild.parentNode.removeChild(newChild);
		}
		newChild.parentNode = parentNode;
		newChild.previousSibling = parentNode.lastChild;
		newChild.nextSibling = null;
		if (newChild.previousSibling) {
			newChild.previousSibling.nextSibling = newChild;
		} else {
			parentNode.firstChild = newChild;
		}
		parentNode.lastChild = newChild;
		_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
		return newChild;
	}
	
	Document.prototype = {
		//implementation : null,
		nodeName :  '#document',
		nodeType :  DOCUMENT_NODE,
		/**
		 * The DocumentType node of the document.
		 *
		 * @readonly
		 * @type DocumentType
		 */
		doctype :  null,
		documentElement :  null,
		_inc : 1,
	
		insertBefore :  function(newChild, refChild){//raises
			if(newChild.nodeType == DOCUMENT_FRAGMENT_NODE){
				var child = newChild.firstChild;
				while(child){
					var next = child.nextSibling;
					this.insertBefore(child,refChild);
					child = next;
				}
				return newChild;
			}
			_insertBefore(this, newChild, refChild);
			newChild.ownerDocument = this;
			if (this.documentElement === null && newChild.nodeType === ELEMENT_NODE) {
				this.documentElement = newChild;
			}
	
			return newChild;
		},
		removeChild :  function(oldChild){
			if(this.documentElement == oldChild){
				this.documentElement = null;
			}
			return _removeChild(this,oldChild);
		},
		replaceChild: function (newChild, oldChild) {
			//raises
			_insertBefore(this, newChild, oldChild, assertPreReplacementValidityInDocument);
			newChild.ownerDocument = this;
			if (oldChild) {
				this.removeChild(oldChild);
			}
			if (isElementNode(newChild)) {
				this.documentElement = newChild;
			}
		},
		// Introduced in DOM Level 2:
		importNode : function(importedNode,deep){
			return importNode(this,importedNode,deep);
		},
		// Introduced in DOM Level 2:
		getElementById :	function(id){
			var rtv = null;
			_visitNode(this.documentElement,function(node){
				if(node.nodeType == ELEMENT_NODE){
					if(node.getAttribute('id') == id){
						rtv = node;
						return true;
					}
				}
			})
			return rtv;
		},
	
		/**
		 * The `getElementsByClassName` method of `Document` interface returns an array-like object
		 * of all child elements which have **all** of the given class name(s).
		 *
		 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
		 *
		 *
		 * Warning: This is a live LiveNodeList.
		 * Changes in the DOM will reflect in the array as the changes occur.
		 * If an element selected by this array no longer qualifies for the selector,
		 * it will automatically be removed. Be aware of this for iteration purposes.
		 *
		 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
		 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
		 */
		getElementsByClassName: function(classNames) {
			var classNamesSet = toOrderedSet(classNames)
			return new LiveNodeList(this, function(base) {
				var ls = [];
				if (classNamesSet.length > 0) {
					_visitNode(base.documentElement, function(node) {
						if(node !== base && node.nodeType === ELEMENT_NODE) {
							var nodeClassNames = node.getAttribute('class')
							// can be null if the attribute does not exist
							if (nodeClassNames) {
								// before splitting and iterating just compare them for the most common case
								var matches = classNames === nodeClassNames;
								if (!matches) {
									var nodeClassNamesSet = toOrderedSet(nodeClassNames)
									matches = classNamesSet.every(arrayIncludes(nodeClassNamesSet))
								}
								if(matches) {
									ls.push(node);
								}
							}
						}
					});
				}
				return ls;
			});
		},
	
		//document factory method:
		createElement :	function(tagName){
			var node = new Element();
			node.ownerDocument = this;
			node.nodeName = tagName;
			node.tagName = tagName;
			node.localName = tagName;
			node.childNodes = new NodeList();
			var attrs	= node.attributes = new NamedNodeMap();
			attrs._ownerElement = node;
			return node;
		},
		createDocumentFragment :	function(){
			var node = new DocumentFragment();
			node.ownerDocument = this;
			node.childNodes = new NodeList();
			return node;
		},
		createTextNode :	function(data){
			var node = new Text();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createComment :	function(data){
			var node = new Comment();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createCDATASection :	function(data){
			var node = new CDATASection();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createProcessingInstruction :	function(target,data){
			var node = new ProcessingInstruction();
			node.ownerDocument = this;
			node.tagName = node.nodeName = node.target = target;
			node.nodeValue = node.data = data;
			return node;
		},
		createAttribute :	function(name){
			var node = new Attr();
			node.ownerDocument	= this;
			node.name = name;
			node.nodeName	= name;
			node.localName = name;
			node.specified = true;
			return node;
		},
		createEntityReference :	function(name){
			var node = new EntityReference();
			node.ownerDocument	= this;
			node.nodeName	= name;
			return node;
		},
		// Introduced in DOM Level 2:
		createElementNS :	function(namespaceURI,qualifiedName){
			var node = new Element();
			var pl = qualifiedName.split(':');
			var attrs	= node.attributes = new NamedNodeMap();
			node.childNodes = new NodeList();
			node.ownerDocument = this;
			node.nodeName = qualifiedName;
			node.tagName = qualifiedName;
			node.namespaceURI = namespaceURI;
			if(pl.length == 2){
				node.prefix = pl[0];
				node.localName = pl[1];
			}else{
				//el.prefix = null;
				node.localName = qualifiedName;
			}
			attrs._ownerElement = node;
			return node;
		},
		// Introduced in DOM Level 2:
		createAttributeNS :	function(namespaceURI,qualifiedName){
			var node = new Attr();
			var pl = qualifiedName.split(':');
			node.ownerDocument = this;
			node.nodeName = qualifiedName;
			node.name = qualifiedName;
			node.namespaceURI = namespaceURI;
			node.specified = true;
			if(pl.length == 2){
				node.prefix = pl[0];
				node.localName = pl[1];
			}else{
				//el.prefix = null;
				node.localName = qualifiedName;
			}
			return node;
		}
	};
	_extends(Document,Node);
	
	
	function Element() {
		this._nsMap = {};
	};
	Element.prototype = {
		nodeType : ELEMENT_NODE,
		hasAttribute : function(name){
			return this.getAttributeNode(name)!=null;
		},
		getAttribute : function(name){
			var attr = this.getAttributeNode(name);
			return attr && attr.value || '';
		},
		getAttributeNode : function(name){
			return this.attributes.getNamedItem(name);
		},
		setAttribute : function(name, value){
			var attr = this.ownerDocument.createAttribute(name);
			attr.value = attr.nodeValue = "" + value;
			this.setAttributeNode(attr)
		},
		removeAttribute : function(name){
			var attr = this.getAttributeNode(name)
			attr && this.removeAttributeNode(attr);
		},
	
		//four real opeartion method
		appendChild:function(newChild){
			if(newChild.nodeType === DOCUMENT_FRAGMENT_NODE){
				return this.insertBefore(newChild,null);
			}else{
				return _appendSingleChild(this,newChild);
			}
		},
		setAttributeNode : function(newAttr){
			return this.attributes.setNamedItem(newAttr);
		},
		setAttributeNodeNS : function(newAttr){
			return this.attributes.setNamedItemNS(newAttr);
		},
		removeAttributeNode : function(oldAttr){
			//console.log(this == oldAttr.ownerElement)
			return this.attributes.removeNamedItem(oldAttr.nodeName);
		},
		//get real attribute name,and remove it by removeAttributeNode
		removeAttributeNS : function(namespaceURI, localName){
			var old = this.getAttributeNodeNS(namespaceURI, localName);
			old && this.removeAttributeNode(old);
		},
	
		hasAttributeNS : function(namespaceURI, localName){
			return this.getAttributeNodeNS(namespaceURI, localName)!=null;
		},
		getAttributeNS : function(namespaceURI, localName){
			var attr = this.getAttributeNodeNS(namespaceURI, localName);
			return attr && attr.value || '';
		},
		setAttributeNS : function(namespaceURI, qualifiedName, value){
			var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
			attr.value = attr.nodeValue = "" + value;
			this.setAttributeNode(attr)
		},
		getAttributeNodeNS : function(namespaceURI, localName){
			return this.attributes.getNamedItemNS(namespaceURI, localName);
		},
	
		getElementsByTagName : function(tagName){
			return new LiveNodeList(this,function(base){
				var ls = [];
				_visitNode(base,function(node){
					if(node !== base && node.nodeType == ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)){
						ls.push(node);
					}
				});
				return ls;
			});
		},
		getElementsByTagNameNS : function(namespaceURI, localName){
			return new LiveNodeList(this,function(base){
				var ls = [];
				_visitNode(base,function(node){
					if(node !== base && node.nodeType === ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)){
						ls.push(node);
					}
				});
				return ls;
	
			});
		}
	};
	Document.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
	Document.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;
	
	
	_extends(Element,Node);
	function Attr() {
	};
	Attr.prototype.nodeType = ATTRIBUTE_NODE;
	_extends(Attr,Node);
	
	
	function CharacterData() {
	};
	CharacterData.prototype = {
		data : '',
		substringData : function(offset, count) {
			return this.data.substring(offset, offset+count);
		},
		appendData: function(text) {
			text = this.data+text;
			this.nodeValue = this.data = text;
			this.length = text.length;
		},
		insertData: function(offset,text) {
			this.replaceData(offset,0,text);
	
		},
		appendChild:function(newChild){
			throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR])
		},
		deleteData: function(offset, count) {
			this.replaceData(offset,count,"");
		},
		replaceData: function(offset, count, text) {
			var start = this.data.substring(0,offset);
			var end = this.data.substring(offset+count);
			text = start + text + end;
			this.nodeValue = this.data = text;
			this.length = text.length;
		}
	}
	_extends(CharacterData,Node);
	function Text() {
	};
	Text.prototype = {
		nodeName : "#text",
		nodeType : TEXT_NODE,
		splitText : function(offset) {
			var text = this.data;
			var newText = text.substring(offset);
			text = text.substring(0, offset);
			this.data = this.nodeValue = text;
			this.length = text.length;
			var newNode = this.ownerDocument.createTextNode(newText);
			if(this.parentNode){
				this.parentNode.insertBefore(newNode, this.nextSibling);
			}
			return newNode;
		}
	}
	_extends(Text,CharacterData);
	function Comment() {
	};
	Comment.prototype = {
		nodeName : "#comment",
		nodeType : COMMENT_NODE
	}
	_extends(Comment,CharacterData);
	
	function CDATASection() {
	};
	CDATASection.prototype = {
		nodeName : "#cdata-section",
		nodeType : CDATA_SECTION_NODE
	}
	_extends(CDATASection,CharacterData);
	
	
	function DocumentType() {
	};
	DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
	_extends(DocumentType,Node);
	
	function Notation() {
	};
	Notation.prototype.nodeType = NOTATION_NODE;
	_extends(Notation,Node);
	
	function Entity() {
	};
	Entity.prototype.nodeType = ENTITY_NODE;
	_extends(Entity,Node);
	
	function EntityReference() {
	};
	EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
	_extends(EntityReference,Node);
	
	function DocumentFragment() {
	};
	DocumentFragment.prototype.nodeName =	"#document-fragment";
	DocumentFragment.prototype.nodeType =	DOCUMENT_FRAGMENT_NODE;
	_extends(DocumentFragment,Node);
	
	
	function ProcessingInstruction() {
	}
	ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
	_extends(ProcessingInstruction,Node);
	function XMLSerializer(){}
	XMLSerializer.prototype.serializeToString = function(node,isHtml,nodeFilter){
		return nodeSerializeToString.call(node,isHtml,nodeFilter);
	}
	Node.prototype.toString = nodeSerializeToString;
	function nodeSerializeToString(isHtml,nodeFilter){
		var buf = [];
		var refNode = this.nodeType == 9 && this.documentElement || this;
		var prefix = refNode.prefix;
		var uri = refNode.namespaceURI;
	
		if(uri && prefix == null){
			//console.log(prefix)
			var prefix = refNode.lookupPrefix(uri);
			if(prefix == null){
				//isHTML = true;
				var visibleNamespaces=[
				{namespace:uri,prefix:null}
				//{namespace:uri,prefix:''}
				]
			}
		}
		serializeToString(this,buf,isHtml,nodeFilter,visibleNamespaces);
		//console.log('###',this.nodeType,uri,prefix,buf.join(''))
		return buf.join('');
	}
	
	function needNamespaceDefine(node, isHTML, visibleNamespaces) {
		var prefix = node.prefix || '';
		var uri = node.namespaceURI;
		// According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
		// and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
		// > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
		// in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
		// and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
		// > [...] Furthermore, the attribute value [...] must not be an empty string.
		// so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
		if (!uri) {
			return false;
		}
		if (prefix === "xml" && uri === NAMESPACE.XML || uri === NAMESPACE.XMLNS) {
			return false;
		}
	
		var i = visibleNamespaces.length
		while (i--) {
			var ns = visibleNamespaces[i];
			// get namespace prefix
			if (ns.prefix === prefix) {
				return ns.namespace !== uri;
			}
		}
		return true;
	}
	/**
	 * Well-formed constraint: No < in Attribute Values
	 * > The replacement text of any entity referred to directly or indirectly
	 * > in an attribute value must not contain a <.
	 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
	 * @see https://www.w3.org/TR/xml11/#NT-AttValue
	 *
	 * Literal whitespace other than space that appear in attribute values
	 * are serialized as their entity references, so they will be preserved.
	 * (In contrast to whitespace literals in the input which are normalized to spaces)
	 * @see https://www.w3.org/TR/xml11/#AVNormalize
	 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
	 */
	function addSerializedAttribute(buf, qualifiedName, value) {
		buf.push(' ', qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, _xmlEncoder), '"')
	}
	
	function serializeToString(node,buf,isHTML,nodeFilter,visibleNamespaces){
		if (!visibleNamespaces) {
			visibleNamespaces = [];
		}
	
		if(nodeFilter){
			node = nodeFilter(node);
			if(node){
				if(typeof node == 'string'){
					buf.push(node);
					return;
				}
			}else{
				return;
			}
			//buf.sort.apply(attrs, attributeSorter);
		}
	
		switch(node.nodeType){
		case ELEMENT_NODE:
			var attrs = node.attributes;
			var len = attrs.length;
			var child = node.firstChild;
			var nodeName = node.tagName;
	
			isHTML = NAMESPACE.isHTML(node.namespaceURI) || isHTML
	
			var prefixedNodeName = nodeName
			if (!isHTML && !node.prefix && node.namespaceURI) {
				var defaultNS
				// lookup current default ns from `xmlns` attribute
				for (var ai = 0; ai < attrs.length; ai++) {
					if (attrs.item(ai).name === 'xmlns') {
						defaultNS = attrs.item(ai).value
						break
					}
				}
				if (!defaultNS) {
					// lookup current default ns in visibleNamespaces
					for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
						var namespace = visibleNamespaces[nsi]
						if (namespace.prefix === '' && namespace.namespace === node.namespaceURI) {
							defaultNS = namespace.namespace
							break
						}
					}
				}
				if (defaultNS !== node.namespaceURI) {
					for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
						var namespace = visibleNamespaces[nsi]
						if (namespace.namespace === node.namespaceURI) {
							if (namespace.prefix) {
								prefixedNodeName = namespace.prefix + ':' + nodeName
							}
							break
						}
					}
				}
			}
	
			buf.push('<', prefixedNodeName);
	
			for(var i=0;i<len;i++){
				// add namespaces for attributes
				var attr = attrs.item(i);
				if (attr.prefix == 'xmlns') {
					visibleNamespaces.push({ prefix: attr.localName, namespace: attr.value });
				}else if(attr.nodeName == 'xmlns'){
					visibleNamespaces.push({ prefix: '', namespace: attr.value });
				}
			}
	
			for(var i=0;i<len;i++){
				var attr = attrs.item(i);
				if (needNamespaceDefine(attr,isHTML, visibleNamespaces)) {
					var prefix = attr.prefix||'';
					var uri = attr.namespaceURI;
					addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
					visibleNamespaces.push({ prefix: prefix, namespace:uri });
				}
				serializeToString(attr,buf,isHTML,nodeFilter,visibleNamespaces);
			}
	
			// add namespace for current node
			if (nodeName === prefixedNodeName && needNamespaceDefine(node, isHTML, visibleNamespaces)) {
				var prefix = node.prefix||'';
				var uri = node.namespaceURI;
				addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
				visibleNamespaces.push({ prefix: prefix, namespace:uri });
			}
	
			if(child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)){
				buf.push('>');
				//if is cdata child node
				if(isHTML && /^script$/i.test(nodeName)){
					while(child){
						if(child.data){
							buf.push(child.data);
						}else{
							serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
						}
						child = child.nextSibling;
					}
				}else
				{
					while(child){
						serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
						child = child.nextSibling;
					}
				}
				buf.push('</',prefixedNodeName,'>');
			}else{
				buf.push('/>');
			}
			// remove added visible namespaces
			//visibleNamespaces.length = startVisibleNamespaces;
			return;
		case DOCUMENT_NODE:
		case DOCUMENT_FRAGMENT_NODE:
			var child = node.firstChild;
			while(child){
				serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
				child = child.nextSibling;
			}
			return;
		case ATTRIBUTE_NODE:
			return addSerializedAttribute(buf, node.name, node.value);
		case TEXT_NODE:
			/**
			 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
			 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
			 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
			 * `&amp;` and `&lt;` respectively.
			 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
			 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
			 * when that string is not marking the end of a CDATA section.
			 *
			 * In the content of elements, character data is any string of characters
			 * which does not contain the start-delimiter of any markup
			 * and does not include the CDATA-section-close delimiter, `]]>`.
			 *
			 * @see https://www.w3.org/TR/xml/#NT-CharData
			 * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
			 */
			return buf.push(node.data
				.replace(/[<&>]/g,_xmlEncoder)
			);
		case CDATA_SECTION_NODE:
			return buf.push( '<![CDATA[',node.data,']]>');
		case COMMENT_NODE:
			return buf.push( "<!--",node.data,"-->");
		case DOCUMENT_TYPE_NODE:
			var pubid = node.publicId;
			var sysid = node.systemId;
			buf.push('<!DOCTYPE ',node.name);
			if(pubid){
				buf.push(' PUBLIC ', pubid);
				if (sysid && sysid!='.') {
					buf.push(' ', sysid);
				}
				buf.push('>');
			}else if(sysid && sysid!='.'){
				buf.push(' SYSTEM ', sysid, '>');
			}else{
				var sub = node.internalSubset;
				if(sub){
					buf.push(" [",sub,"]");
				}
				buf.push(">");
			}
			return;
		case PROCESSING_INSTRUCTION_NODE:
			return buf.push( "<?",node.target," ",node.data,"?>");
		case ENTITY_REFERENCE_NODE:
			return buf.push( '&',node.nodeName,';');
		//case ENTITY_NODE:
		//case NOTATION_NODE:
		default:
			buf.push('??',node.nodeName);
		}
	}
	function importNode(doc,node,deep){
		var node2;
		switch (node.nodeType) {
		case ELEMENT_NODE:
			node2 = node.cloneNode(false);
			node2.ownerDocument = doc;
			//var attrs = node2.attributes;
			//var len = attrs.length;
			//for(var i=0;i<len;i++){
				//node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
			//}
		case DOCUMENT_FRAGMENT_NODE:
			break;
		case ATTRIBUTE_NODE:
			deep = true;
			break;
		//case ENTITY_REFERENCE_NODE:
		//case PROCESSING_INSTRUCTION_NODE:
		////case TEXT_NODE:
		//case CDATA_SECTION_NODE:
		//case COMMENT_NODE:
		//	deep = false;
		//	break;
		//case DOCUMENT_NODE:
		//case DOCUMENT_TYPE_NODE:
		//cannot be imported.
		//case ENTITY_NODE:
		//case NOTATION_NODE：
		//can not hit in level3
		//default:throw e;
		}
		if(!node2){
			node2 = node.cloneNode(false);//false
		}
		node2.ownerDocument = doc;
		node2.parentNode = null;
		if(deep){
			var child = node.firstChild;
			while(child){
				node2.appendChild(importNode(doc,child,deep));
				child = child.nextSibling;
			}
		}
		return node2;
	}
	//
	//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
	//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
	function cloneNode(doc,node,deep){
		var node2 = new node.constructor();
		for (var n in node) {
			if (Object.prototype.hasOwnProperty.call(node, n)) {
				var v = node[n];
				if (typeof v != "object") {
					if (v != node2[n]) {
						node2[n] = v;
					}
				}
			}
		}
		if(node.childNodes){
			node2.childNodes = new NodeList();
		}
		node2.ownerDocument = doc;
		switch (node2.nodeType) {
		case ELEMENT_NODE:
			var attrs	= node.attributes;
			var attrs2	= node2.attributes = new NamedNodeMap();
			var len = attrs.length
			attrs2._ownerElement = node2;
			for(var i=0;i<len;i++){
				node2.setAttributeNode(cloneNode(doc,attrs.item(i),true));
			}
			break;;
		case ATTRIBUTE_NODE:
			deep = true;
		}
		if(deep){
			var child = node.firstChild;
			while(child){
				node2.appendChild(cloneNode(doc,child,deep));
				child = child.nextSibling;
			}
		}
		return node2;
	}
	
	function __set__(object,key,value){
		object[key] = value
	}
	//do dynamic
	try{
		if(Object.defineProperty){
			Object.defineProperty(LiveNodeList.prototype,'length',{
				get:function(){
					_updateLiveList(this);
					return this.$$length;
				}
			});
	
			Object.defineProperty(Node.prototype,'textContent',{
				get:function(){
					return getTextContent(this);
				},
	
				set:function(data){
					switch(this.nodeType){
					case ELEMENT_NODE:
					case DOCUMENT_FRAGMENT_NODE:
						while(this.firstChild){
							this.removeChild(this.firstChild);
						}
						if(data || String(data)){
							this.appendChild(this.ownerDocument.createTextNode(data));
						}
						break;
	
					default:
						this.data = data;
						this.value = data;
						this.nodeValue = data;
					}
				}
			})
	
			function getTextContent(node){
				switch(node.nodeType){
				case ELEMENT_NODE:
				case DOCUMENT_FRAGMENT_NODE:
					var buf = [];
					node = node.firstChild;
					while(node){
						if(node.nodeType!==7 && node.nodeType !==8){
							buf.push(getTextContent(node));
						}
						node = node.nextSibling;
					}
					return buf.join('');
				default:
					return node.nodeValue;
				}
			}
	
			__set__ = function(object,key,value){
				//console.log(value)
				object['$$'+key] = value
			}
		}
	}catch(e){//ie8
	}
	
	//if(typeof require == 'function'){
		exports.DocumentType = DocumentType;
		exports.DOMException = DOMException;
		exports.DOMImplementation = DOMImplementation;
		exports.Element = Element;
		exports.Node = Node;
		exports.NodeList = NodeList;
		exports.XMLSerializer = XMLSerializer;
	//}


/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = buildSearchMethod;
	
	var errors = __webpack_require__(913);
	
	/**
	 * Creates a search method to be used in clients
	 * @param {string} queryParam the name of the attribute used for the query
	 * @param {string} url the url
	 * @return {function} the search method
	 */
	function buildSearchMethod(queryParam, url) {
	  /**
	   * The search method. Prepares the data and send the query to Algolia.
	   * @param {string} query the string used for query search
	   * @param {object} args additional parameters to send with the search
	   * @param {function} [callback] the callback to be called with the client gets the answer
	   * @return {undefined|Promise} If the callback is not provided then this methods returns a Promise
	   */
	  return function search(query, args, callback) {
	    // warn V2 users on how to search
	    if (typeof query === 'function' && typeof args === 'object' ||
	      typeof callback === 'object') {
	      // .search(query, params, cb)
	      // .search(cb, params)
	      throw new errors.AlgoliaSearchError('index.search usage is index.search(query, params, cb)');
	    }
	
	    // Normalizing the function signature
	    if (arguments.length === 0 || typeof query === 'function') {
	      // Usage : .search(), .search(cb)
	      callback = query;
	      query = '';
	    } else if (arguments.length === 1 || typeof args === 'function') {
	      // Usage : .search(query/args), .search(query, cb)
	      callback = args;
	      args = undefined;
	    }
	    // At this point we have 3 arguments with values
	
	    // Usage : .search(args) // careful: typeof null === 'object'
	    if (typeof query === 'object' && query !== null) {
	      args = query;
	      query = undefined;
	    } else if (query === undefined || query === null) { // .search(undefined/null)
	      query = '';
	    }
	
	    var params = '';
	
	    if (query !== undefined) {
	      params += queryParam + '=' + encodeURIComponent(query);
	    }
	
	    var additionalUA;
	    if (args !== undefined) {
	      if (args.additionalUA) {
	        additionalUA = args.additionalUA;
	        delete args.additionalUA;
	      }
	      // `_getSearchParams` will augment params, do not be fooled by the = versus += from previous if
	      params = this.as._getSearchParams(args, params);
	    }
	
	
	    return this._search(params, url, callback, additionalUA);
	  };
	}


/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function omit(obj, test) {
	  var keys = __webpack_require__(1841);
	  var foreach = __webpack_require__(685);
	
	  var filtered = {};
	
	  foreach(keys(obj), function doFilter(keyName) {
	    if (test(keyName) !== true) {
	      filtered[keyName] = obj[keyName];
	    }
	  });
	
	  return filtered;
	};


/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var namespace = 'autocomplete:';
	
	var _ = __webpack_require__(347);
	var DOM = __webpack_require__(477);
	
	// constructor
	// -----------
	
	function EventBus(o) {
	  if (!o || !o.el) {
	    _.error('EventBus initialized without el');
	  }
	
	  this.$el = DOM.element(o.el);
	}
	
	// instance methods
	// ----------------
	
	_.mixin(EventBus.prototype, {
	
	  // ### public
	
	  trigger: function(type, suggestion, dataset, context) {
	    var event = _.Event(namespace + type);
	    this.$el.trigger(event, [suggestion, dataset, context]);
	    return event;
	  }
	});
	
	module.exports = EventBus;


/***/ },
/* 1286 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  wrapper: '<span class="%ROOT%"></span>',
	  dropdown: '<span class="%PREFIX%%DROPDOWN_MENU%"></span>',
	  dataset: '<div class="%PREFIX%%DATASET%-%CLASS%"></div>',
	  suggestions: '<span class="%PREFIX%%SUGGESTIONS%"></span>',
	  suggestion: '<div class="%PREFIX%%SUGGESTION%"></div>'
	};


/***/ },
/* 1287 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function parseAlgoliaClientVersion(agent) {
	  var parsed =
	    // User agent for algoliasearch >= 3.33.0
	    agent.match(/Algolia for JavaScript \((\d+\.)(\d+\.)(\d+)\)/) ||
	    // User agent for algoliasearch < 3.33.0
	    agent.match(/Algolia for vanilla JavaScript (\d+\.)(\d+\.)(\d+)/);
	
	  if (parsed) {
	    return [parsed[1], parsed[2], parsed[3]];
	  }
	
	  return undefined;
	};


/***/ },
/* 1288 */
/***/ function(module, exports) {

	module.exports = "0.37.1";


/***/ },
/* 1289 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 1290 */
[2105, 990],
/* 1291 */
[2106, 1292, 467],
/* 1292 */
468,
/* 1293 */
[2113, 1292],
/* 1294 */
[2114, 748, 467],
/* 1295 */
[2115, 1290],
/* 1296 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 1297 */
514,
/* 1298 */
[2121, 1299],
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(747);

/***/ },
/* 1300 */
930,
/* 1301 */
753,
/* 1302 */
[2125, 1293, 919],
/* 1303 */
[2126, 1301],
/* 1304 */
[2127, 919],
/* 1305 */
680,
/* 1306 */
[2129, 1291, 467, 748, 466],
/* 1307 */
[2134, 1615, 991],
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(343)
	  , toLength  = __webpack_require__(305)
	  , toIndex   = __webpack_require__(752);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 1309 */
[2107, 133, 374, 928, 372, 930, 373, 749, 995, 1321, 680, 304, 184, 929, 340],
/* 1310 */
[2108, 749, 923],
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide              = __webpack_require__(374)
	  , redefineAll       = __webpack_require__(928)
	  , anObject          = __webpack_require__(201)
	  , isObject          = __webpack_require__(184)
	  , strictNew         = __webpack_require__(930)
	  , forOf             = __webpack_require__(749)
	  , createArrayMethod = __webpack_require__(922)
	  , $has              = __webpack_require__(304)
	  , WEAK              = __webpack_require__(680)('weak')
	  , isExtensible      = Object.isExtensible || isObject
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for frozen keys
	var frozenStore = function(that){
	  return that._l || (that._l = new FrozenStore);
	};
	var FrozenStore = function(){
	  this.a = [];
	};
	var findFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	FrozenStore.prototype = {
	  get: function(key){
	    var entry = findFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      strictNew(that, C, NAME);
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        if(!isExtensible(key))return frozenStore(this)['delete'](key);
	        return $has(key, WEAK) && $has(key[WEAK], this._i) && delete key[WEAK][this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        if(!isExtensible(key))return frozenStore(this).has(key);
	        return $has(key, WEAK) && $has(key[WEAK], this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    if(!isExtensible(anObject(key))){
	      frozenStore(that).set(key, value);
	    } else {
	      $has(key, WEAK) || hide(key, WEAK, {});
	      key[WEAK][that._i] = value;
	    } return that;
	  },
	  frozenStore: frozenStore,
	  WEAK: WEAK
	};

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(184)
	  , document = __webpack_require__(220).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(201);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(343)
	  , getNames  = __webpack_require__(133).getNames
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.get = function getOwnPropertyNames(it){
	  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
	  return getNames(toIObject(it));
	};

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(220).document && document.documentElement;

/***/ },
/* 1316 */
[2114, 750, 216],
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(184)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(184)
	  , cof      = __webpack_require__(468)
	  , MATCH    = __webpack_require__(216)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 1319 */
[2115, 201],
/* 1320 */
[2116, 133, 514, 751, 374, 216],
/* 1321 */
1296,
/* 1322 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 1323 */
[2120, 133, 343],
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var $        = __webpack_require__(133)
	  , anObject = __webpack_require__(201)
	  , Reflect  = __webpack_require__(220).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = $.getNames(anObject(it))
	    , getSymbols = $.getSymbols;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 1325 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 1326 */
[2123, 220],
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-string-pad-left-right
	var toLength = __webpack_require__(305)
	  , repeat   = __webpack_require__(1328)
	  , defined  = __webpack_require__(373);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength)return S;
	  if(fillStr == '')fillStr = ' ';
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(753)
	  , defined   = __webpack_require__(373);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(372)
	  , invoke             = __webpack_require__(926)
	  , html               = __webpack_require__(1315)
	  , cel                = __webpack_require__(1312)
	  , global             = __webpack_require__(220)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listner = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(468)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listner;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listner, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 1330 */
[2129, 923, 216, 750, 469],
/* 1331 */
[2131, 679, 1321, 750, 343, 995],
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   v4.2.8+1e68dce6
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  var type = typeof x;
	  return x !== null && (type === 'object' || type === 'function');
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	
	
	var _isArray = void 0;
	if (Array.isArray) {
	  _isArray = Array.isArray;
	} else {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = void 0;
	var customSchedulerFn = void 0;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  if (typeof vertxNext !== 'undefined') {
	    return function () {
	      vertxNext(flush);
	    };
	  }
	
	  return useSetTimeout();
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var vertx = Function('return this')().require('vertx');
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = void 0;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	
	  if (_state) {
	    var callback = arguments[_state - 1];
	    asap(function () {
	      return invokeCallback(_state, child, callback, parent._result);
	    });
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve$1(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(2);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then$$1.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then$$1) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then$$1, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return resolve(promise, value);
	    }, function (reason) {
	      return reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$1) {
	  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$1 === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$1)) {
	      handleForeignThenable(promise, maybeThenable, then$$1);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function resolve(promise, value) {
	  if (promise === value) {
	    reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    var then$$1 = void 0;
	    try {
	      then$$1 = value.then;
	    } catch (error) {
	      reject(promise, error);
	      return;
	    }
	    handleMaybeThenable(promise, value, then$$1);
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = void 0,
	      callback = void 0,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = void 0,
	      error = void 0,
	      succeeded = true;
	
	  if (hasCallback) {
	    try {
	      value = callback(detail);
	    } catch (e) {
	      succeeded = false;
	      error = e;
	    }
	
	    if (promise === value) {
	      reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	    resolve(promise, value);
	  } else if (succeeded === false) {
	    reject(promise, error);
	  } else if (settled === FULFILLED) {
	    fulfill(promise, value);
	  } else if (settled === REJECTED) {
	    reject(promise, value);
	  }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      resolve(promise, value);
	    }, function rejectPromise(reason) {
	      reject(promise, reason);
	    });
	  } catch (e) {
	    reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	}
	
	var Enumerator = function () {
	  function Enumerator(Constructor, input) {
	    this._instanceConstructor = Constructor;
	    this.promise = new Constructor(noop);
	
	    if (!this.promise[PROMISE_ID]) {
	      makePromise(this.promise);
	    }
	
	    if (isArray(input)) {
	      this.length = input.length;
	      this._remaining = input.length;
	
	      this._result = new Array(this.length);
	
	      if (this.length === 0) {
	        fulfill(this.promise, this._result);
	      } else {
	        this.length = this.length || 0;
	        this._enumerate(input);
	        if (this._remaining === 0) {
	          fulfill(this.promise, this._result);
	        }
	      }
	    } else {
	      reject(this.promise, validationError());
	    }
	  }
	
	  Enumerator.prototype._enumerate = function _enumerate(input) {
	    for (var i = 0; this._state === PENDING && i < input.length; i++) {
	      this._eachEntry(input[i], i);
	    }
	  };
	
	  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
	    var c = this._instanceConstructor;
	    var resolve$$1 = c.resolve;
	
	
	    if (resolve$$1 === resolve$1) {
	      var _then = void 0;
	      var error = void 0;
	      var didError = false;
	      try {
	        _then = entry.then;
	      } catch (e) {
	        didError = true;
	        error = e;
	      }
	
	      if (_then === then && entry._state !== PENDING) {
	        this._settledAt(entry._state, i, entry._result);
	      } else if (typeof _then !== 'function') {
	        this._remaining--;
	        this._result[i] = entry;
	      } else if (c === Promise$1) {
	        var promise = new c(noop);
	        if (didError) {
	          reject(promise, error);
	        } else {
	          handleMaybeThenable(promise, entry, _then);
	        }
	        this._willSettleAt(promise, i);
	      } else {
	        this._willSettleAt(new c(function (resolve$$1) {
	          return resolve$$1(entry);
	        }), i);
	      }
	    } else {
	      this._willSettleAt(resolve$$1(entry), i);
	    }
	  };
	
	  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
	    var promise = this.promise;
	
	
	    if (promise._state === PENDING) {
	      this._remaining--;
	
	      if (state === REJECTED) {
	        reject(promise, value);
	      } else {
	        this._result[i] = value;
	      }
	    }
	
	    if (this._remaining === 0) {
	      fulfill(promise, this._result);
	    }
	  };
	
	  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
	    var enumerator = this;
	
	    subscribe(promise, undefined, function (value) {
	      return enumerator._settledAt(FULFILLED, i, value);
	    }, function (reason) {
	      return enumerator._settledAt(REJECTED, i, reason);
	    });
	  };
	
	  return Enumerator;
	}();
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject$1(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {Function} resolver
	  Useful for tooling.
	  @constructor
	*/
	
	var Promise$1 = function () {
	  function Promise(resolver) {
	    this[PROMISE_ID] = nextId();
	    this._result = this._state = undefined;
	    this._subscribers = [];
	
	    if (noop !== resolver) {
	      typeof resolver !== 'function' && needsResolver();
	      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	    }
	  }
	
	  /**
	  The primary way of interacting with a promise is through its `then` method,
	  which registers callbacks to receive either a promise's eventual value or the
	  reason why the promise cannot be fulfilled.
	   ```js
	  findUser().then(function(user){
	    // user is available
	  }, function(reason){
	    // user is unavailable, and you are given the reason why
	  });
	  ```
	   Chaining
	  --------
	   The return value of `then` is itself a promise.  This second, 'downstream'
	  promise is resolved with the return value of the first promise's fulfillment
	  or rejection handler, or rejected if the handler throws an exception.
	   ```js
	  findUser().then(function (user) {
	    return user.name;
	  }, function (reason) {
	    return 'default name';
	  }).then(function (userName) {
	    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	    // will be `'default name'`
	  });
	   findUser().then(function (user) {
	    throw new Error('Found user, but still unhappy');
	  }, function (reason) {
	    throw new Error('`findUser` rejected and we're unhappy');
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	  });
	  ```
	  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	   ```js
	  findUser().then(function (user) {
	    throw new PedagogicalException('Upstream error');
	  }).then(function (value) {
	    // never reached
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // The `PedgagocialException` is propagated all the way down to here
	  });
	  ```
	   Assimilation
	  ------------
	   Sometimes the value you want to propagate to a downstream promise can only be
	  retrieved asynchronously. This can be achieved by returning a promise in the
	  fulfillment or rejection handler. The downstream promise will then be pending
	  until the returned promise is settled. This is called *assimilation*.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // The user's comments are now available
	  });
	  ```
	   If the assimliated promise rejects, then the downstream promise will also reject.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // If `findCommentsByAuthor` fulfills, we'll have the value here
	  }, function (reason) {
	    // If `findCommentsByAuthor` rejects, we'll have the reason here
	  });
	  ```
	   Simple Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let result;
	   try {
	    result = findResult();
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	  findResult(function(result, err){
	    if (err) {
	      // failure
	    } else {
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findResult().then(function(result){
	    // success
	  }, function(reason){
	    // failure
	  });
	  ```
	   Advanced Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let author, books;
	   try {
	    author = findAuthor();
	    books  = findBooksByAuthor(author);
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	   function foundBooks(books) {
	   }
	   function failure(reason) {
	   }
	   findAuthor(function(author, err){
	    if (err) {
	      failure(err);
	      // failure
	    } else {
	      try {
	        findBoooksByAuthor(author, function(books, err) {
	          if (err) {
	            failure(err);
	          } else {
	            try {
	              foundBooks(books);
	            } catch(reason) {
	              failure(reason);
	            }
	          }
	        });
	      } catch(error) {
	        failure(err);
	      }
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findAuthor().
	    then(findBooksByAuthor).
	    then(function(books){
	      // found books
	  }).catch(function(reason){
	    // something went wrong
	  });
	  ```
	   @method then
	  @param {Function} onFulfilled
	  @param {Function} onRejected
	  Useful for tooling.
	  @return {Promise}
	  */
	
	  /**
	  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	  as the catch block of a try/catch statement.
	  ```js
	  function findAuthor(){
	  throw new Error('couldn't find that author');
	  }
	  // synchronous
	  try {
	  findAuthor();
	  } catch(reason) {
	  // something went wrong
	  }
	  // async with promises
	  findAuthor().catch(function(reason){
	  // something went wrong
	  });
	  ```
	  @method catch
	  @param {Function} onRejection
	  Useful for tooling.
	  @return {Promise}
	  */
	
	
	  Promise.prototype.catch = function _catch(onRejection) {
	    return this.then(null, onRejection);
	  };
	
	  /**
	    `finally` will be invoked regardless of the promise's fate just as native
	    try/catch/finally behaves
	  
	    Synchronous example:
	  
	    ```js
	    findAuthor() {
	      if (Math.random() > 0.5) {
	        throw new Error();
	      }
	      return new Author();
	    }
	  
	    try {
	      return findAuthor(); // succeed or fail
	    } catch(error) {
	      return findOtherAuther();
	    } finally {
	      // always runs
	      // doesn't affect the return value
	    }
	    ```
	  
	    Asynchronous example:
	  
	    ```js
	    findAuthor().catch(function(reason){
	      return findOtherAuther();
	    }).finally(function(){
	      // author was either found, or not
	    });
	    ```
	  
	    @method finally
	    @param {Function} callback
	    @return {Promise}
	  */
	
	
	  Promise.prototype.finally = function _finally(callback) {
	    var promise = this;
	    var constructor = promise.constructor;
	
	    if (isFunction(callback)) {
	      return promise.then(function (value) {
	        return constructor.resolve(callback()).then(function () {
	          return value;
	        });
	      }, function (reason) {
	        return constructor.resolve(callback()).then(function () {
	          throw reason;
	        });
	      });
	    }
	
	    return promise.then(callback, callback);
	  };
	
	  return Promise;
	}();
	
	Promise$1.prototype.then = then;
	Promise$1.all = all;
	Promise$1.race = race;
	Promise$1.resolve = resolve$1;
	Promise$1.reject = reject$1;
	Promise$1._setScheduler = setScheduler;
	Promise$1._setAsap = setAsap;
	Promise$1._asap = asap;
	
	/*global self*/
	function polyfill() {
	  var local = void 0;
	
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	
	  var P = local.Promise;
	
	  if (P) {
	    var promiseToString = null;
	    try {
	      promiseToString = Object.prototype.toString.call(P.resolve());
	    } catch (e) {
	      // silently ignored
	    }
	
	    if (promiseToString === '[object Promise]' && !P.cast) {
	      return;
	    }
	  }
	
	  local.Promise = Promise$1;
	}
	
	// Strange compat..
	Promise$1.polyfill = polyfill;
	Promise$1.Promise = Promise$1;
	
	return Promise$1;
	
	})));
	
	
	
	//# sourceMappingURL=es6-promise.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(235), (function() { return this; }())))

/***/ },
/* 1333 */,
/* 1334 */,
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var topLevel = typeof global !== 'undefined' ? global :
	    typeof window !== 'undefined' ? window : {}
	var minDoc = __webpack_require__(290);
	
	var doccy;
	
	if (typeof document !== 'undefined') {
	    doccy = document;
	} else {
	    doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];
	
	    if (!doccy) {
	        doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDoc;
	    }
	}
	
	module.exports = doccy;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1336 */
/***/ function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 1337 */
/***/ function(module, exports) {

	module.exports = [["0","\u0000",127],["a140","　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚"],["a1a1","﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢",4,"～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／"],["a240","＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁",7,"▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭"],["a2a1","╮╰╯═╞╪╡◢◣◥◤╱╲╳０",9,"Ⅰ",9,"〡",8,"十卄卅Ａ",25,"ａ",21],["a340","ｗｘｙｚΑ",16,"Σ",6,"α",16,"σ",6,"ㄅ",10],["a3a1","ㄐ",25,"˙ˉˊˇˋ"],["a3e1","€"],["a440","一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才"],["a4a1","丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙"],["a540","世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外"],["a5a1","央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全"],["a640","共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年"],["a6a1","式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣"],["a740","作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍"],["a7a1","均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠"],["a840","杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒"],["a8a1","芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵"],["a940","咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居"],["a9a1","屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊"],["aa40","昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠"],["aaa1","炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附"],["ab40","陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品"],["aba1","哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷"],["ac40","拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗"],["aca1","活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄"],["ad40","耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥"],["ada1","迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪"],["ae40","哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙"],["aea1","恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓"],["af40","浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷"],["afa1","砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃"],["b040","虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡"],["b0a1","陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀"],["b140","娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽"],["b1a1","情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺"],["b240","毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶"],["b2a1","瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼"],["b340","莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途"],["b3a1","部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠"],["b440","婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍"],["b4a1","插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋"],["b540","溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘"],["b5a1","窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁"],["b640","詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑"],["b6a1","間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼"],["b740","媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業"],["b7a1","楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督"],["b840","睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫"],["b8a1","腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊"],["b940","辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴"],["b9a1","飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇"],["ba40","愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢"],["baa1","滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬"],["bb40","罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤"],["bba1","說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜"],["bc40","劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂"],["bca1","慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃"],["bd40","瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯"],["bda1","翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞"],["be40","輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉"],["bea1","鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡"],["bf40","濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊"],["bfa1","縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚"],["c040","錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇"],["c0a1","嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬"],["c140","瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪"],["c1a1","薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁"],["c240","駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘"],["c2a1","癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦"],["c340","鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸"],["c3a1","獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類"],["c440","願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼"],["c4a1","纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴"],["c540","護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬"],["c5a1","禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒"],["c640","讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲"],["c940","乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕"],["c9a1","氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋"],["ca40","汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘"],["caa1","吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇"],["cb40","杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓"],["cba1","芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢"],["cc40","坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋"],["cca1","怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲"],["cd40","泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺"],["cda1","矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏"],["ce40","哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛"],["cea1","峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺"],["cf40","柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂"],["cfa1","洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀"],["d040","穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪"],["d0a1","苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱"],["d140","唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧"],["d1a1","恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤"],["d240","毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸"],["d2a1","牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐"],["d340","笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢"],["d3a1","荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐"],["d440","酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅"],["d4a1","唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏"],["d540","崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟"],["d5a1","捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉"],["d640","淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏"],["d6a1","痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟"],["d740","耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷"],["d7a1","蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪"],["d840","釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷"],["d8a1","堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔"],["d940","惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒"],["d9a1","晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞"],["da40","湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖"],["daa1","琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥"],["db40","罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳"],["dba1","菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺"],["dc40","軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈"],["dca1","隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆"],["dd40","媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤"],["dda1","搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼"],["de40","毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓"],["dea1","煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓"],["df40","稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯"],["dfa1","腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤"],["e040","觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿"],["e0a1","遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠"],["e140","凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠"],["e1a1","寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉"],["e240","榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊"],["e2a1","漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓"],["e340","禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞"],["e3a1","耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻"],["e440","裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍"],["e4a1","銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘"],["e540","噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉"],["e5a1","憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒"],["e640","澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙"],["e6a1","獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟"],["e740","膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢"],["e7a1","蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧"],["e840","踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓"],["e8a1","銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮"],["e940","噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺"],["e9a1","憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸"],["ea40","澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙"],["eaa1","瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘"],["eb40","蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠"],["eba1","諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌"],["ec40","錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕"],["eca1","魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎"],["ed40","檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶"],["eda1","瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞"],["ee40","蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞"],["eea1","謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜"],["ef40","鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰"],["efa1","鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶"],["f040","璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒"],["f0a1","臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧"],["f140","蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪"],["f1a1","鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰"],["f240","徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛"],["f2a1","礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕"],["f340","譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦"],["f3a1","鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲"],["f440","嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩"],["f4a1","禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿"],["f540","鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛"],["f5a1","鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥"],["f640","蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺"],["f6a1","騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚"],["f740","糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊"],["f7a1","驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾"],["f840","讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏"],["f8a1","齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚"],["f940","纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊"],["f9a1","龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓"]]

/***/ },
/* 1338 */
/***/ function(module, exports) {

	module.exports = [["a140","",62],["a180","",32],["a240","",62],["a280","",32],["a2ab","",5],["a2e3","€"],["a2ef",""],["a2fd",""],["a340","",62],["a380","",31,"　"],["a440","",62],["a480","",32],["a4f4","",10],["a540","",62],["a580","",32],["a5f7","",7],["a640","",62],["a680","",32],["a6b9","",7],["a6d9","",6],["a6ec",""],["a6f3",""],["a6f6","",8],["a740","",62],["a780","",32],["a7c2","",14],["a7f2","",12],["a896","",10],["a8bc",""],["a8bf","ǹ"],["a8c1",""],["a8ea","",20],["a958",""],["a95b",""],["a95d",""],["a989","〾⿰",11],["a997","",12],["a9f0","",14],["aaa1","",93],["aba1","",93],["aca1","",93],["ada1","",93],["aea1","",93],["afa1","",93],["d7fa","",4],["f8a1","",93],["f9a1","",93],["faa1","",93],["fba1","",93],["fca1","",93],["fda1","",93],["fe50","⺁⺄㑳㑇⺈⺋㖞㘚㘎⺌⺗㥮㤘㧏㧟㩳㧐㭎㱮㳠⺧⺪䁖䅟⺮䌷⺳⺶⺷䎱䎬⺻䏝䓖䙡䙌"],["fe80","䜣䜩䝼䞍⻊䥇䥺䥽䦂䦃䦅䦆䦟䦛䦷䦶䲣䲟䲠䲡䱷䲢䴓",6,"䶮",93]]

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var b64 = __webpack_require__(1860);
	
	/**
	 * Access tokens actually are data, and using them we can derive
	 * a user's username. This method attempts to do just that,
	 * decoding the part of the token after the first `.` into
	 * a username.
	 *
	 * @private
	 * @param {string} token an access token
	 * @return {string} username
	 */
	function getUser(token) {
	  var data = token.split('.')[1];
	  if (!data) return null;
	  data = data.replace(/-/g, '+').replace(/_/g, '/');
	
	  var mod = data.length % 4;
	  if (mod === 2) data += '==';
	  if (mod === 3) data += '=';
	  if (mod === 1 || mod > 3) return null;
	
	  try {
	    return JSON.parse(b64.decode(data)).u;
	  } catch(err) {
	    return null;
	  }
	}
	
	module.exports = getUser;


/***/ },
/* 1340 */
/***/ function(module, exports) {

	/*
	 * xtend by Jake Verbaten
	 *
	 * Licensed under MIT
	 * https://github.com/Raynos/xtend
	 */
	module.exports.extendMutable = extendMutable
	module.exports.extend = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extendMutable(target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}
	
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 1341 */
[1961, 8],
/* 1342 */
[1962, 8],
/* 1343 */
[1963, 8],
/* 1344 */
[1964, 8],
/* 1345 */
[1965, 8],
/* 1346 */
[1966, 8],
/* 1347 */
[1967, 8],
/* 1348 */
[1968, 8],
/* 1349 */
[1969, 8],
/* 1350 */
[1970, 8],
/* 1351 */
[1971, 8],
/* 1352 */
[1972, 8],
/* 1353 */
[1973, 8],
/* 1354 */
[1974, 8],
/* 1355 */
[1975, 8],
/* 1356 */
[1976, 8],
/* 1357 */
[1977, 8],
/* 1358 */
[1978, 8],
/* 1359 */
[1979, 8],
/* 1360 */
[1980, 8],
/* 1361 */
[1981, 8],
/* 1362 */
[1982, 8],
/* 1363 */
[1983, 8],
/* 1364 */
[1984, 8],
/* 1365 */
[1985, 8],
/* 1366 */
[1986, 8],
/* 1367 */
[1987, 8],
/* 1368 */
[1988, 8],
/* 1369 */
[1989, 8],
/* 1370 */
[1990, 8],
/* 1371 */
[1991, 8],
/* 1372 */
[1992, 8],
/* 1373 */
[1993, 8],
/* 1374 */
[1994, 8],
/* 1375 */
[1995, 8],
/* 1376 */
[1996, 8],
/* 1377 */
[1997, 8],
/* 1378 */
[1998, 8],
/* 1379 */
[1999, 8],
/* 1380 */
[2000, 8],
/* 1381 */
[2001, 8],
/* 1382 */
[2002, 8],
/* 1383 */
[2003, 8],
/* 1384 */
[2004, 8],
/* 1385 */
[2005, 8],
/* 1386 */
[2006, 8],
/* 1387 */
[2007, 8],
/* 1388 */
[2008, 8],
/* 1389 */
[2009, 8],
/* 1390 */
[2010, 8],
/* 1391 */
[2011, 8],
/* 1392 */
[2012, 8],
/* 1393 */
[2013, 8],
/* 1394 */
[2014, 8],
/* 1395 */
[2015, 8],
/* 1396 */
[2016, 8],
/* 1397 */
[2017, 8],
/* 1398 */
[2018, 8],
/* 1399 */
[2019, 8],
/* 1400 */
[2020, 8],
/* 1401 */
[2021, 8],
/* 1402 */
[2022, 8],
/* 1403 */
[2023, 8],
/* 1404 */
[2024, 8],
/* 1405 */
[2025, 8],
/* 1406 */
[2026, 8],
/* 1407 */
[2027, 8],
/* 1408 */
[2028, 8],
/* 1409 */
[2029, 8],
/* 1410 */
[2030, 8],
/* 1411 */
[2031, 8],
/* 1412 */
[2032, 8],
/* 1413 */
[2033, 8],
/* 1414 */
[2034, 8],
/* 1415 */
[2035, 8],
/* 1416 */
[2036, 8],
/* 1417 */
[2037, 8],
/* 1418 */
[2038, 8],
/* 1419 */
[2039, 8],
/* 1420 */
[2040, 8],
/* 1421 */
[2041, 8],
/* 1422 */
[2042, 8],
/* 1423 */
[2043, 8],
/* 1424 */
[2044, 8],
/* 1425 */
[2045, 8],
/* 1426 */
[2046, 8],
/* 1427 */
[2047, 8],
/* 1428 */
[2048, 8],
/* 1429 */
[2049, 8],
/* 1430 */
[2050, 8],
/* 1431 */
[2051, 8],
/* 1432 */
[2052, 8],
/* 1433 */
[2053, 8],
/* 1434 */
[2054, 8],
/* 1435 */
[2055, 8],
/* 1436 */
[2056, 8],
/* 1437 */
[2057, 8],
/* 1438 */
[2058, 8],
/* 1439 */
[2059, 8],
/* 1440 */
[2060, 8],
/* 1441 */
[2061, 8],
/* 1442 */
[2062, 8],
/* 1443 */
[2063, 8],
/* 1444 */
[2064, 8],
/* 1445 */
[2065, 8],
/* 1446 */
[2066, 8],
/* 1447 */
[2067, 8],
/* 1448 */
[2068, 8],
/* 1449 */
[2069, 8],
/* 1450 */
[2070, 8],
/* 1451 */
[2071, 8],
/* 1452 */
[2072, 8],
/* 1453 */
[2073, 8],
/* 1454 */
[2074, 8],
/* 1455 */
[2075, 8],
/* 1456 */
[2076, 8],
/* 1457 */
[2077, 8],
/* 1458 */
[2078, 8],
/* 1459 */
[2079, 8],
/* 1460 */
[2080, 8],
/* 1461 */
[2081, 8],
/* 1462 */
[2082, 8],
/* 1463 */
[2083, 8],
/* 1464 */
[2084, 8],
/* 1465 */
[2085, 8],
/* 1466 */
[2086, 8],
/* 1467 */
[2087, 8],
/* 1468 */
[2088, 8],
/* 1469 */
[2089, 8],
/* 1470 */
[2090, 8],
/* 1471 */
[2091, 8],
/* 1472 */
[2092, 8],
/* 1473 */
[2093, 8],
/* 1474 */
[2094, 8],
/* 1475 */
[2095, 8],
/* 1476 */
[2096, 8],
/* 1477 */
[2097, 8],
/* 1478 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 1479 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return map(objectKeys(obj), function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (isArray(obj[k])) {
	        return map(obj[k], function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	function map (xs, f) {
	  if (xs.map) return xs.map(f);
	  var res = [];
	  for (var i = 0; i < xs.length; i++) {
	    res.push(f(xs[i], i));
	  }
	  return res;
	}
	
	var objectKeys = Object.keys || function (obj) {
	  var res = [];
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
	  }
	  return res;
	};


/***/ },
/* 1480 */
[2137, 1845, 1846],
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2014-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	/**
	 * Plain JS Object containing properties that represent an HTTP request.
	 *
	 * Depending on the capabilities of the underlying client, a request
	 * may be cancelable. If a request may be canceled, the client will add
	 * a canceled flag and cancel function to the request object. Canceling
	 * the request will put the response into an error state.
	 *
	 * @field {string} [method='GET'] HTTP method, commonly GET, POST, PUT, DELETE or HEAD
	 * @field {string|UrlBuilder} [path=''] path template with optional path variables
	 * @field {Object} [params] parameters for the path template and query string
	 * @field {Object} [headers] custom HTTP headers to send, in addition to the clients default headers
	 * @field [entity] the HTTP entity, common for POST or PUT requests
	 * @field {boolean} [canceled] true if the request has been canceled, set by the client
	 * @field {Function} [cancel] cancels the request if invoked, provided by the client
	 * @field {Client} [originator] the client that first handled this request, provided by the interceptor
	 *
	 * @class Request
	 */
	
	/**
	 * Plain JS Object containing properties that represent an HTTP response
	 *
	 * @field {Object} [request] the request object as received by the root client
	 * @field {Object} [raw] the underlying request object, like XmlHttpRequest in a browser
	 * @field {number} [status.code] status code of the response (i.e. 200, 404)
	 * @field {string} [status.text] status phrase of the response
	 * @field {Object] [headers] response headers hash of normalized name, value pairs
	 * @field [entity] the response body
	 *
	 * @class Response
	 */
	
	/**
	 * HTTP client particularly suited for RESTful operations.
	 *
	 * @field {function} wrap wraps this client with a new interceptor returning the wrapped client
	 *
	 * @param {Request} the HTTP request
	 * @returns {ResponsePromise<Response>} a promise the resolves to the HTTP response
	 *
	 * @class Client
	 */
	
	 /**
	  * Extended when.js Promises/A+ promise with HTTP specific helpers
	  *q
	  * @method entity promise for the HTTP entity
	  * @method status promise for the HTTP status code
	  * @method headers promise for the HTTP response headers
	  * @method header promise for a specific HTTP response header
	  *
	  * @class ResponsePromise
	  * @extends Promise
	  */
	
	var client, target, platformDefault;
	
	client = __webpack_require__(1060);
	
	if (typeof Promise !== 'function' && console && console.log) {
		console.log('An ES6 Promise implementation is required to use rest.js. See https://github.com/cujojs/when/blob/master/docs/es6-promise-shim.md for using when.js as a Promise polyfill.');
	}
	
	/**
	 * Make a request with the default client
	 * @param {Request} the HTTP request
	 * @returns {Promise<Response>} a promise the resolves to the HTTP response
	 */
	function defaultClient() {
		return target.apply(void 0, arguments);
	}
	
	/**
	 * Change the default client
	 * @param {Client} client the new default client
	 */
	defaultClient.setDefaultClient = function setDefaultClient(client) {
		target = client;
	};
	
	/**
	 * Obtain a direct reference to the current default client
	 * @returns {Client} the default client
	 */
	defaultClient.getDefaultClient = function getDefaultClient() {
		return target;
	};
	
	/**
	 * Reset the default client to the platform default
	 */
	defaultClient.resetDefaultClient = function resetDefaultClient() {
		target = platformDefault;
	};
	
	/**
	 * @private
	 */
	defaultClient.setPlatformDefaultClient = function setPlatformDefaultClient(client) {
		if (platformDefault) {
			throw new Error('Unable to redefine platformDefaultClient');
		}
		target = platformDefault = client;
	};
	
	module.exports = client(defaultClient);


/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2012-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var interceptor, UrlBuilder;
	
	interceptor = __webpack_require__(471);
	UrlBuilder = __webpack_require__(1848);
	
	function startsWith(str, prefix) {
		return str.indexOf(prefix) === 0;
	}
	
	function endsWith(str, suffix) {
		return str.lastIndexOf(suffix) + suffix.length === str.length;
	}
	
	/**
	 * Prefixes the request path with a common value.
	 *
	 * @param {Client} [client] client to wrap
	 * @param {number} [config.prefix] path prefix
	 *
	 * @returns {Client}
	 */
	module.exports = interceptor({
		request: function (request, config) {
			var path;
	
			if (config.prefix && !(new UrlBuilder(request.path).isFullyQualified())) {
				path = config.prefix;
				if (request.path) {
					if (!endsWith(path, '/') && !startsWith(request.path, '/')) {
						// add missing '/' between path sections
						path += '/';
					}
					path += request.path;
				}
				request.path = path;
			}
	
			return request;
		}
	});


/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2015-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var interceptor, uriTemplate, mixin;
	
	interceptor = __webpack_require__(471);
	uriTemplate = __webpack_require__(1062);
	mixin = __webpack_require__(934);
	
	/**
	 * Applies request params to the path as a URI Template
	 *
	 * Params are removed from the request object, as they have been consumed.
	 *
	 * @see https://tools.ietf.org/html/rfc6570
	 *
	 * @param {Client} [client] client to wrap
	 * @param {Object} [config.params] default param values
	 * @param {string} [config.template] default template
	 *
	 * @returns {Client}
	 */
	module.exports = interceptor({
		init: function (config) {
			config.params = config.params || {};
			config.template = config.template || '';
			return config;
		},
		request: function (request, config) {
			var template, params;
	
			template = request.path || config.template;
			params = mixin({}, request.params, config.params);
	
			request.path = uriTemplate.expand(template, params);
			delete request.params;
	
			return request;
		}
	});


/***/ },
/* 1484 */
/***/ function(module, exports) {

	/*
	* Copyright 2014-2016 the original author or authors
	* @license MIT, see LICENSE.txt for details
	*
	* @author Scott Andrews
	*/
	
	'use strict';
	
	/**
	 * Parse a MIME type into it's constituent parts
	 *
	 * @param {string} mime MIME type to parse
	 * @return {{
	 *   {string} raw the original MIME type
	 *   {string} type the type and subtype
	 *   {string} [suffix] mime suffix, including the plus, if any
	 *   {Object} params key/value pair of attributes
	 * }}
	 */
	function parse(mime) {
		var params, type;
	
		params = mime.split(';');
		type = params[0].trim().split('+');
	
		return {
			raw: mime,
			type: type[0],
			suffix: type[1] ? '+' + type[1] : '',
			params: params.slice(1).reduce(function (params, pair) {
				pair = pair.split('=');
				params[pair[0].trim()] = pair[1] ? pair[1].trim() : void 0;
				return params;
			}, {})
		};
	}
	
	module.exports = {
		parse: parse
	};


/***/ },
/* 1485 */
/***/ function(module, exports) {

	/*
	 * Copyright 2012-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var encodedSpaceRE, urlEncodedSpaceRE;
	
	encodedSpaceRE = /%20/g;
	urlEncodedSpaceRE = /\+/g;
	
	function urlEncode(str) {
		str = encodeURIComponent(str);
		// spec says space should be encoded as '+'
		return str.replace(encodedSpaceRE, '+');
	}
	
	function urlDecode(str) {
		// spec says space should be encoded as '+'
		str = str.replace(urlEncodedSpaceRE, ' ');
		return decodeURIComponent(str);
	}
	
	function append(str, name, value) {
		if (Array.isArray(value)) {
			value.forEach(function (value) {
				str = append(str, name, value);
			});
		}
		else {
			if (str.length > 0) {
				str += '&';
			}
			str += urlEncode(name);
			if (value !== undefined && value !== null) {
				str += '=' + urlEncode(value);
			}
		}
		return str;
	}
	
	module.exports = {
	
		read: function (str) {
			var obj = {};
			str.split('&').forEach(function (entry) {
				var pair, name, value;
				pair = entry.split('=');
				name = urlDecode(pair[0]);
				if (pair.length === 2) {
					value = urlDecode(pair[1]);
				}
				else {
					value = null;
				}
				if (name in obj) {
					if (!Array.isArray(obj[name])) {
						// convert to an array, perserving currnent value
						obj[name] = [obj[name]];
					}
					obj[name].push(value);
				}
				else {
					obj[name] = value;
				}
			});
			return obj;
		},
	
		write: function (obj) {
			var str = '';
			Object.keys(obj).forEach(function (name) {
				str = append(str, name, obj[name]);
			});
			return str;
		}
	
	};


/***/ },
/* 1486 */
/***/ function(module, exports) {

	/*
	 * Copyright 2015-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	/**
	 * Attempt to invoke a function capturing the resulting value as a Promise
	 *
	 * If the method throws, the caught value used to reject the Promise.
	 *
	 * @param {function} work function to invoke
	 * @returns {Promise} Promise for the output of the work function
	 */
	function attempt(work) {
		try {
			return Promise.resolve(work());
		}
		catch (e) {
			return Promise.reject(e);
		}
	}
	
	module.exports = attempt;


/***/ },
/* 1487 */
/***/ function(module, exports) {

	/*
	 * Copyright 2012-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	/**
	 * Normalize HTTP header names using the pseudo camel case.
	 *
	 * For example:
	 *   content-type         -> Content-Type
	 *   accepts              -> Accepts
	 *   x-custom-header-name -> X-Custom-Header-Name
	 *
	 * @param {string} name the raw header name
	 * @return {string} the normalized header name
	 */
	function normalizeHeaderName(name) {
		return name.toLowerCase()
			.split('-')
			.map(function (chunk) { return chunk.charAt(0).toUpperCase() + chunk.slice(1); })
			.join('-');
	}
	
	module.exports = normalizeHeaderName;


/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* global window, exports, define */
	
	!function() {
	    'use strict'
	
	    var re = {
	        not_string: /[^s]/,
	        not_bool: /[^t]/,
	        not_type: /[^T]/,
	        not_primitive: /[^v]/,
	        number: /[diefg]/,
	        numeric_arg: /[bcdiefguxX]/,
	        json: /[j]/,
	        not_json: /[^j]/,
	        text: /^[^\x25]+/,
	        modulo: /^\x25{2}/,
	        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
	        key: /^([a-z_][a-z_\d]*)/i,
	        key_access: /^\.([a-z_][a-z_\d]*)/i,
	        index_access: /^\[(\d+)\]/,
	        sign: /^[+-]/
	    }
	
	    function sprintf(key) {
	        // `arguments` is not an array, but should be fine for this call
	        return sprintf_format(sprintf_parse(key), arguments)
	    }
	
	    function vsprintf(fmt, argv) {
	        return sprintf.apply(null, [fmt].concat(argv || []))
	    }
	
	    function sprintf_format(parse_tree, argv) {
	        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign
	        for (i = 0; i < tree_length; i++) {
	            if (typeof parse_tree[i] === 'string') {
	                output += parse_tree[i]
	            }
	            else if (typeof parse_tree[i] === 'object') {
	                ph = parse_tree[i] // convenience purposes only
	                if (ph.keys) { // keyword argument
	                    arg = argv[cursor]
	                    for (k = 0; k < ph.keys.length; k++) {
	                        if (arg == undefined) {
	                            throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
	                        }
	                        arg = arg[ph.keys[k]]
	                    }
	                }
	                else if (ph.param_no) { // positional argument (explicit)
	                    arg = argv[ph.param_no]
	                }
	                else { // positional argument (implicit)
	                    arg = argv[cursor++]
	                }
	
	                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
	                    arg = arg()
	                }
	
	                if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
	                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
	                }
	
	                if (re.number.test(ph.type)) {
	                    is_positive = arg >= 0
	                }
	
	                switch (ph.type) {
	                    case 'b':
	                        arg = parseInt(arg, 10).toString(2)
	                        break
	                    case 'c':
	                        arg = String.fromCharCode(parseInt(arg, 10))
	                        break
	                    case 'd':
	                    case 'i':
	                        arg = parseInt(arg, 10)
	                        break
	                    case 'j':
	                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0)
	                        break
	                    case 'e':
	                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential()
	                        break
	                    case 'f':
	                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg)
	                        break
	                    case 'g':
	                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg)
	                        break
	                    case 'o':
	                        arg = (parseInt(arg, 10) >>> 0).toString(8)
	                        break
	                    case 's':
	                        arg = String(arg)
	                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
	                        break
	                    case 't':
	                        arg = String(!!arg)
	                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
	                        break
	                    case 'T':
	                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
	                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
	                        break
	                    case 'u':
	                        arg = parseInt(arg, 10) >>> 0
	                        break
	                    case 'v':
	                        arg = arg.valueOf()
	                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
	                        break
	                    case 'x':
	                        arg = (parseInt(arg, 10) >>> 0).toString(16)
	                        break
	                    case 'X':
	                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
	                        break
	                }
	                if (re.json.test(ph.type)) {
	                    output += arg
	                }
	                else {
	                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
	                        sign = is_positive ? '+' : '-'
	                        arg = arg.toString().replace(re.sign, '')
	                    }
	                    else {
	                        sign = ''
	                    }
	                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' '
	                    pad_length = ph.width - (sign + arg).length
	                    pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
	                    output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
	                }
	            }
	        }
	        return output
	    }
	
	    var sprintf_cache = Object.create(null)
	
	    function sprintf_parse(fmt) {
	        if (sprintf_cache[fmt]) {
	            return sprintf_cache[fmt]
	        }
	
	        var _fmt = fmt, match, parse_tree = [], arg_names = 0
	        while (_fmt) {
	            if ((match = re.text.exec(_fmt)) !== null) {
	                parse_tree.push(match[0])
	            }
	            else if ((match = re.modulo.exec(_fmt)) !== null) {
	                parse_tree.push('%')
	            }
	            else if ((match = re.placeholder.exec(_fmt)) !== null) {
	                if (match[2]) {
	                    arg_names |= 1
	                    var field_list = [], replacement_field = match[2], field_match = []
	                    if ((field_match = re.key.exec(replacement_field)) !== null) {
	                        field_list.push(field_match[1])
	                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
	                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
	                                field_list.push(field_match[1])
	                            }
	                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
	                                field_list.push(field_match[1])
	                            }
	                            else {
	                                throw new SyntaxError('[sprintf] failed to parse named argument key')
	                            }
	                        }
	                    }
	                    else {
	                        throw new SyntaxError('[sprintf] failed to parse named argument key')
	                    }
	                    match[2] = field_list
	                }
	                else {
	                    arg_names |= 2
	                }
	                if (arg_names === 3) {
	                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
	                }
	
	                parse_tree.push(
	                    {
	                        placeholder: match[0],
	                        param_no:    match[1],
	                        keys:        match[2],
	                        sign:        match[3],
	                        pad_char:    match[4],
	                        align:       match[5],
	                        width:       match[6],
	                        precision:   match[7],
	                        type:        match[8]
	                    }
	                )
	            }
	            else {
	                throw new SyntaxError('[sprintf] unexpected placeholder')
	            }
	            _fmt = _fmt.substring(match[0].length)
	        }
	        return sprintf_cache[fmt] = parse_tree
	    }
	
	    /**
	     * export to either browser or node.js
	     */
	    /* eslint-disable quote-props */
	    if (true) {
	        exports['sprintf'] = sprintf
	        exports['vsprintf'] = vsprintf
	    }
	    if (typeof window !== 'undefined') {
	        window['sprintf'] = sprintf
	        window['vsprintf'] = vsprintf
	
	        if ("function" === 'function' && __webpack_require__(1507)['amd']) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	                return {
	                    'sprintf': sprintf,
	                    'vsprintf': vsprintf
	                }
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	        }
	    }
	    /* eslint-enable quote-props */
	}(); // eslint-disable-line


/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(1063);
	
	/*<replacement>*/
	var util = __webpack_require__(754);
	util.inherits = __webpack_require__(406);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough))
	    return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function(chunk, encoding, cb) {
	  cb(null, chunk);
	};


/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(1866);
	/*</replacement>*/
	
	
	/*<replacement>*/
	var Buffer = __webpack_require__(339).Buffer;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	var EE = __webpack_require__(932).EventEmitter;
	
	/*<replacement>*/
	if (!EE.listenerCount) EE.listenerCount = function(emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	var Stream = __webpack_require__(345);
	
	/*<replacement>*/
	var util = __webpack_require__(754);
	util.inherits = __webpack_require__(406);
	/*</replacement>*/
	
	var StringDecoder;
	
	
	/*<replacement>*/
	var debug = __webpack_require__(457);
	if (debug && debug.debuglog) {
	  debug = debug.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	
	util.inherits(Readable, Stream);
	
	function ReadableState(options, stream) {
	  var Duplex = __webpack_require__(586);
	
	  options = options || {};
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.buffer = [];
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder)
	      StringDecoder = __webpack_require__(1491).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  var Duplex = __webpack_require__(586);
	
	  if (!(this instanceof Readable))
	    return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  Stream.call(this);
	}
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function(chunk, encoding) {
	  var state = this._readableState;
	
	  if (util.isString(chunk) && !state.objectMode) {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = new Buffer(chunk, encoding);
	      encoding = '';
	    }
	  }
	
	  return readableAddChunk(this, state, chunk, encoding, false);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function(chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};
	
	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (util.isNullOrUndefined(chunk)) {
	    state.reading = false;
	    if (!state.ended)
	      onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var e = new Error('stream.unshift() after end event');
	      stream.emit('error', e);
	    } else {
	      if (state.decoder && !addToFront && !encoding)
	        chunk = state.decoder.write(chunk);
	
	      if (!addToFront)
	        state.reading = false;
	
	      // if we want the data now, just emit it.
	      if (state.flowing && state.length === 0 && !state.sync) {
	        stream.emit('data', chunk);
	        stream.read(0);
	      } else {
	        // update the buffer info.
	        state.length += state.objectMode ? 1 : chunk.length;
	        if (addToFront)
	          state.buffer.unshift(chunk);
	        else
	          state.buffer.push(chunk);
	
	        if (state.needReadable)
	          emitReadable(stream);
	      }
	
	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }
	
	  return needMoreData(state);
	}
	
	
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended &&
	         (state.needReadable ||
	          state.length < state.highWaterMark ||
	          state.length === 0);
	}
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function(enc) {
	  if (!StringDecoder)
	    StringDecoder = __webpack_require__(1491).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 128MB
	var MAX_HWM = 0x800000;
	function roundUpToNextPowerOf2(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2
	    n--;
	    for (var p = 1; p < 32; p <<= 1) n |= n >> p;
	    n++;
	  }
	  return n;
	}
	
	function howMuchToRead(n, state) {
	  if (state.length === 0 && state.ended)
	    return 0;
	
	  if (state.objectMode)
	    return n === 0 ? 0 : 1;
	
	  if (isNaN(n) || util.isNull(n)) {
	    // only flow one buffer at a time
	    if (state.flowing && state.buffer.length)
	      return state.buffer[0].length;
	    else
	      return state.length;
	  }
	
	  if (n <= 0)
	    return 0;
	
	  // If we're asking for more than the target buffer level,
	  // then raise the water mark.  Bump up to the next highest
	  // power of 2, to prevent increasing it excessively in tiny
	  // amounts.
	  if (n > state.highWaterMark)
	    state.highWaterMark = roundUpToNextPowerOf2(n);
	
	  // don't have that much.  return null, unless we've ended.
	  if (n > state.length) {
	    if (!state.ended) {
	      state.needReadable = true;
	      return 0;
	    } else
	      return state.length;
	  }
	
	  return n;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function(n) {
	  debug('read', n);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (!util.isNumber(n) || n > 0)
	    state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 &&
	      state.needReadable &&
	      (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended)
	      endReadable(this);
	    else
	      emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0)
	      endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  }
	
	  if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0)
	      state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	  }
	
	  // If _read pushed data synchronously, then `reading` will be false,
	  // and we need to re-evaluate how much data we can return to the user.
	  if (doRead && !state.reading)
	    n = howMuchToRead(nOrig, state);
	
	  var ret;
	  if (n > 0)
	    ret = fromList(n, state);
	  else
	    ret = null;
	
	  if (util.isNull(ret)) {
	    state.needReadable = true;
	    n = 0;
	  }
	
	  state.length -= n;
	
	  // If we have nothing in the buffer, then we want to know
	  // as soon as we *do* get something into the buffer.
	  if (state.length === 0 && !state.ended)
	    state.needReadable = true;
	
	  // If we tried to read() past the EOF, then emit end on the next tick.
	  if (nOrig !== n && state.ended && state.length === 0)
	    endReadable(this);
	
	  if (!util.isNull(ret))
	    this.emit('data', ret);
	
	  return ret;
	};
	
	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	
	function onEofChunk(stream, state) {
	  if (state.decoder && !state.ended) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync)
	      process.nextTick(function() {
	        emitReadable_(stream);
	      });
	    else
	      emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    process.nextTick(function() {
	      maybeReadMore_(stream, state);
	    });
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended &&
	         state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;
	    else
	      len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function(n) {
	  this.emit('error', new Error('not implemented'));
	};
	
	Readable.prototype.pipe = function(dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) &&
	              dest !== process.stdout &&
	              dest !== process.stderr;
	
	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted)
	    process.nextTick(endFn);
	  else
	    src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain &&
	        (!dest._writableState || dest._writableState.needDrain))
	      ondrain();
	  }
	
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    var ret = dest.write(chunk);
	    if (false === ret) {
	      debug('false write response, pause',
	            src._readableState.awaitDrain);
	      src._readableState.awaitDrain++;
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EE.listenerCount(dest, 'error') === 0)
	      dest.emit('error', er);
	  }
	  // This is a brutally ugly hack to make sure that our error handler
	  // is attached before any userland ones.  NEVER DO THIS.
	  if (!dest._events || !dest._events.error)
	    dest.on('error', onerror);
	  else if (isArray(dest._events.error))
	    dest._events.error.unshift(onerror);
	  else
	    dest._events.error = [onerror, dest._events.error];
	
	
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function() {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain)
	      state.awaitDrain--;
	    if (state.awaitDrain === 0 && EE.listenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	
	Readable.prototype.unpipe = function(dest) {
	  var state = this._readableState;
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0)
	    return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes)
	      return this;
	
	    if (!dest)
	      dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest)
	      dest.emit('unpipe', this);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++)
	      dests[i].emit('unpipe', this);
	    return this;
	  }
	
	  // try to find the right one.
	  var i = indexOf(state.pipes, dest);
	  if (i === -1)
	    return this;
	
	  state.pipes.splice(i, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1)
	    state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function(ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  // If listening to data, and it has not explicitly been paused,
	  // then call resume to start the flow of data on the next tick.
	  if (ev === 'data' && false !== this._readableState.flowing) {
	    this.resume();
	  }
	
	  if (ev === 'readable' && this.readable) {
	    var state = this._readableState;
	    if (!state.readableListening) {
	      state.readableListening = true;
	      state.emittedReadable = false;
	      state.needReadable = true;
	      if (!state.reading) {
	        var self = this;
	        process.nextTick(function() {
	          debug('readable nexttick read 0');
	          self.read(0);
	        });
	      } else if (state.length) {
	        emitReadable(this, state);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function() {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    if (!state.reading) {
	      debug('resume read 0');
	      this.read(0);
	    }
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    process.nextTick(function() {
	      resume_(stream, state);
	    });
	  }
	}
	
	function resume_(stream, state) {
	  state.resumeScheduled = false;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading)
	    stream.read(0);
	}
	
	Readable.prototype.pause = function() {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  if (state.flowing) {
	    do {
	      var chunk = stream.read();
	    } while (null !== chunk && state.flowing);
	  }
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function(stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function() {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length)
	        self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function(chunk) {
	    debug('wrapped data');
	    if (state.decoder)
	      chunk = state.decoder.write(chunk);
	    if (!chunk || !state.objectMode && !chunk.length)
	      return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (util.isFunction(stream[i]) && util.isUndefined(this[i])) {
	      this[i] = function(method) { return function() {
	        return stream[method].apply(stream, arguments);
	      }}(i);
	    }
	  }
	
	  // proxy certain important events.
	  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
	  forEach(events, function(ev) {
	    stream.on(ev, self.emit.bind(self, ev));
	  });
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function(n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	function fromList(n, state) {
	  var list = state.buffer;
	  var length = state.length;
	  var stringMode = !!state.decoder;
	  var objectMode = !!state.objectMode;
	  var ret;
	
	  // nothing in the list, definitely empty.
	  if (list.length === 0)
	    return null;
	
	  if (length === 0)
	    ret = null;
	  else if (objectMode)
	    ret = list.shift();
	  else if (!n || n >= length) {
	    // read it all, truncate the array.
	    if (stringMode)
	      ret = list.join('');
	    else
	      ret = Buffer.concat(list, length);
	    list.length = 0;
	  } else {
	    // read just some of it.
	    if (n < list[0].length) {
	      // just take a part of the first list item.
	      // slice is the same for buffers and strings.
	      var buf = list[0];
	      ret = buf.slice(0, n);
	      list[0] = buf.slice(n);
	    } else if (n === list[0].length) {
	      // first list is a perfect match
	      ret = list.shift();
	    } else {
	      // complex case.
	      // we have enough to cover it, but it spans past the first buffer.
	      if (stringMode)
	        ret = '';
	      else
	        ret = new Buffer(n);
	
	      var c = 0;
	      for (var i = 0, l = list.length; i < l && c < n; i++) {
	        var buf = list[0];
	        var cpy = Math.min(n - c, buf.length);
	
	        if (stringMode)
	          ret += buf.slice(0, cpy);
	        else
	          buf.copy(ret, c, 0, cpy);
	
	        if (cpy < buf.length)
	          list[0] = buf.slice(cpy);
	        else
	          list.shift();
	
	        c += cpy;
	      }
	    }
	  }
	
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0)
	    throw new Error('endReadable called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    process.nextTick(function() {
	      // Check that we didn't get one last unshift.
	      if (!state.endEmitted && state.length === 0) {
	        state.endEmitted = true;
	        stream.readable = false;
	        stream.emit('end');
	      }
	    });
	  }
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf (xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(235)))

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(339).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding
	  || function(encoding) {
	       switch (encoding && encoding.toLowerCase()) {
	         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	         default: return false;
	       }
	     }
	
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function(encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function(buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = (buffer.length >= this.charLength - this.charReceived) ?
	        this.charLength - this.charReceived :
	        buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = (buffer.length >= 3) ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function(buffer) {
	  var res = '';
	  if (buffer && buffer.length)
	    res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}


/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(455);
	var decap = __webpack_require__(1495);
	
	module.exports = function camelize(str, decapitalize) {
	  str = trim(str).replace(/[-_\s]+(.)?/g, function(match, c) {
	    return c ? c.toUpperCase() : '';
	  });
	
	  if (decapitalize === true) {
	    return decap(str);
	  } else {
	    return str;
	  }
	};


/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	
	var makeString = __webpack_require__(124);
	
	var from  = 'ąàáäâãåæăćčĉęèéëêĝĥìíïîĵłľńňòóöőôõðøśșşšŝťțţŭùúüűûñÿýçżźž',
	  to    = 'aaaaaaaaaccceeeeeghiiiijllnnoooooooossssstttuuuuuunyyczzz';
	
	from += from.toUpperCase();
	to += to.toUpperCase();
	
	to = to.split('');
	
	// for tokens requireing multitoken output
	from += 'ß';
	to.push('ss');
	
	
	module.exports = function cleanDiacritics(str) {
	  return makeString(str).replace(/.{1}/g, function(c){
	    var index = from.indexOf(c);
	    return index === -1 ? c : to[index];
	  });
	};


/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(455);
	
	module.exports = function dasherize(str) {
	  return trim(str).replace(/([A-Z])/g, '-$1').replace(/[-_\s]+/g, '-').toLowerCase();
	};


/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function decapitalize(str) {
	  str = makeString(str);
	  return str.charAt(0).toLowerCase() + str.slice(1);
	};


/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function adjacent(str, direction) {
	  str = makeString(str);
	  if (str.length === 0) {
	    return '';
	  }
	  return str.slice(0, -1) + String.fromCharCode(str.charCodeAt(str.length - 1) + direction);
	};


/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function escapeRegExp(str) {
	  return makeString(str).replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
	};


/***/ },
/* 1498 */
/***/ function(module, exports) {

	module.exports = function strRepeat(str, qty){
	  if (qty < 1) return '';
	  var result = '';
	  while (qty > 0) {
	    if (qty & 1) result += str;
	    qty >>= 1, str += str;
	  }
	  return result;
	};


/***/ },
/* 1499 */
/***/ function(module, exports) {

	module.exports = function toPositive(number) {
	  return number < 0 ? 0 : (+number || 0);
	};


/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function isBlank(str) {
	  return (/^\s*$/).test(makeString(str));
	};


/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	var chars = __webpack_require__(1134);
	
	module.exports = function splice(str, i, howmany, substr) {
	  var arr = chars(str);
	  arr.splice(~~i, ~~howmany, substr);
	  return arr.join('');
	};


/***/ },
/* 1502 */
/***/ function(module, exports) {

	module.exports = function surround(str, wrapper) {
	  return [wrapper, str, wrapper].join('');
	};


/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	var rtrim = __webpack_require__(1136);
	
	module.exports = function toSentence(array, separator, lastSeparator, serial) {
	  separator = separator || ', ';
	  lastSeparator = lastSeparator || ' and ';
	  var a = array.slice(),
	    lastMember = a.pop();
	
	  if (array.length > 2 && serial) lastSeparator = rtrim(separator) + lastSeparator;
	
	  return a.length ? a.join(separator) + lastSeparator + lastMember : lastMember;
	};


/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(455);
	
	module.exports = function underscored(str) {
	  return trim(str).replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase();
	};


/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var punycode = __webpack_require__(1944);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(1480);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a puny coded representation of "domain".
	      // It only converts the part of the domain name that
	      // has non ASCII characters. I.e. it dosent matter if
	      // you call it with a domain that already is in ASCII.
	      var domainArray = this.hostname.split('.');
	      var newOut = [];
	      for (var i = 0; i < domainArray.length; ++i) {
	        var s = domainArray[i];
	        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
	            'xn--' + punycode.encode(s) : s);
	      }
	      this.hostname = newOut.join('.');
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  Object.keys(this).forEach(function(k) {
	    result[k] = this[k];
	  }, this);
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    Object.keys(relative).forEach(function(k) {
	      if (k !== 'protocol')
	        result[k] = relative[k];
	    });
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      Object.keys(relative).forEach(function(k) {
	        result[k] = relative[k];
	      });
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especialy happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull(result.pathname) || !isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host) && (last === '.' || last === '..') ||
	      last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last == '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especialy happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!isNull(result.pathname) || !isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};
	
	function isString(arg) {
	  return typeof arg === "string";
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isNull(arg) {
	  return arg === null;
	}
	function isNullOrUndefined(arg) {
	  return  arg == null;
	}


/***/ },
/* 1506 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1507 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 1508 */
[1953, 16, 1509],
/* 1509 */
1,
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.6.0
	//     http://underscorejs.org
	//     (c) 2009-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Establish the object that gets returned to break out of a loop iteration.
	  var breaker = {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    concat           = ArrayProto.concat,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeForEach      = ArrayProto.forEach,
	    nativeMap          = ArrayProto.map,
	    nativeReduce       = ArrayProto.reduce,
	    nativeReduceRight  = ArrayProto.reduceRight,
	    nativeFilter       = ArrayProto.filter,
	    nativeEvery        = ArrayProto.every,
	    nativeSome         = ArrayProto.some,
	    nativeIndexOf      = ArrayProto.indexOf,
	    nativeLastIndexOf  = ArrayProto.lastIndexOf,
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind;
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object via a string identifier,
	  // for Closure Compiler "advanced" mode.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.6.0';
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles objects with the built-in `forEach`, arrays, and raw objects.
	  // Delegates to **ECMAScript 5**'s native `forEach` if available.
	  var each = _.each = _.forEach = function(obj, iterator, context) {
	    if (obj == null) return obj;
	    if (nativeForEach && obj.forEach === nativeForEach) {
	      obj.forEach(iterator, context);
	    } else if (obj.length === +obj.length) {
	      for (var i = 0, length = obj.length; i < length; i++) {
	        if (iterator.call(context, obj[i], i, obj) === breaker) return;
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (var i = 0, length = keys.length; i < length; i++) {
	        if (iterator.call(context, obj[keys[i]], keys[i], obj) === breaker) return;
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iterator to each element.
	  // Delegates to **ECMAScript 5**'s native `map` if available.
	  _.map = _.collect = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	    each(obj, function(value, index, list) {
	      results.push(iterator.call(context, value, index, list));
	    });
	    return results;
	  };
	
	  var reduceError = 'Reduce of empty array with no initial value';
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.
	  _.reduce = _.foldl = _.inject = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduce && obj.reduce === nativeReduce) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
	    }
	    each(obj, function(value, index, list) {
	      if (!initial) {
	        memo = value;
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, value, index, list);
	      }
	    });
	    if (!initial) throw new TypeError(reduceError);
	    return memo;
	  };
	
	  // The right-associative version of reduce, also known as `foldr`.
	  // Delegates to **ECMAScript 5**'s native `reduceRight` if available.
	  _.reduceRight = _.foldr = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
	    }
	    var length = obj.length;
	    if (length !== +length) {
	      var keys = _.keys(obj);
	      length = keys.length;
	    }
	    each(obj, function(value, index, list) {
	      index = keys ? keys[--length] : --length;
	      if (!initial) {
	        memo = obj[index];
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, obj[index], index, list);
	      }
	    });
	    if (!initial) throw new TypeError(reduceError);
	    return memo;
	  };
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var result;
	    any(obj, function(value, index, list) {
	      if (predicate.call(context, value, index, list)) {
	        result = value;
	        return true;
	      }
	    });
	    return result;
	  };
	
	  // Return all the elements that pass a truth test.
	  // Delegates to **ECMAScript 5**'s native `filter` if available.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeFilter && obj.filter === nativeFilter) return obj.filter(predicate, context);
	    each(obj, function(value, index, list) {
	      if (predicate.call(context, value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, function(value, index, list) {
	      return !predicate.call(context, value, index, list);
	    }, context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Delegates to **ECMAScript 5**'s native `every` if available.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate || (predicate = _.identity);
	    var result = true;
	    if (obj == null) return result;
	    if (nativeEvery && obj.every === nativeEvery) return obj.every(predicate, context);
	    each(obj, function(value, index, list) {
	      if (!(result = result && predicate.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Delegates to **ECMAScript 5**'s native `some` if available.
	  // Aliased as `any`.
	  var any = _.some = _.any = function(obj, predicate, context) {
	    predicate || (predicate = _.identity);
	    var result = false;
	    if (obj == null) return result;
	    if (nativeSome && obj.some === nativeSome) return obj.some(predicate, context);
	    each(obj, function(value, index, list) {
	      if (result || (result = predicate.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };
	
	  // Determine if the array or object contains a given value (using `===`).
	  // Aliased as `include`.
	  _.contains = _.include = function(obj, target) {
	    if (obj == null) return false;
	    if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
	    return any(obj, function(value) {
	      return value === target;
	    });
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      return (isFunc ? method : value[method]).apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matches(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matches(attrs));
	  };
	
	  // Return the maximum element or (element-based computation).
	  // Can't optimize arrays of integers longer than 65,535 elements.
	  // See [WebKit Bug 80797](https://bugs.webkit.org/show_bug.cgi?id=80797)
	  _.max = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.max.apply(Math, obj);
	    }
	    var result = -Infinity, lastComputed = -Infinity;
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      if (computed > lastComputed) {
	        result = value;
	        lastComputed = computed;
	      }
	    });
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.min.apply(Math, obj);
	    }
	    var result = Infinity, lastComputed = Infinity;
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      if (computed < lastComputed) {
	        result = value;
	        lastComputed = computed;
	      }
	    });
	    return result;
	  };
	
	  // Shuffle an array, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var rand;
	    var index = 0;
	    var shuffled = [];
	    each(obj, function(value) {
	      rand = _.random(index++);
	      shuffled[index - 1] = shuffled[rand];
	      shuffled[rand] = value;
	    });
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (obj.length !== +obj.length) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // An internal function to generate lookup iterators.
	  var lookupIterator = function(value) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return value;
	    return _.property(value);
	  };
	
	  // Sort the object's values by a criterion produced by an iterator.
	  _.sortBy = function(obj, iterator, context) {
	    iterator = lookupIterator(iterator);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iterator.call(context, value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iterator, context) {
	      var result = {};
	      iterator = lookupIterator(iterator);
	      each(obj, function(value, index) {
	        var key = iterator.call(context, value, index, obj);
	        behavior(result, key, value);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, key, value) {
	    _.has(result, key) ? result[key].push(value) : result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, key, value) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, key) {
	    _.has(result, key) ? result[key]++ : result[key] = 1;
	  });
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iterator, context) {
	    iterator = lookupIterator(iterator);
	    var value = iterator.call(context, obj);
	    var low = 0, high = array.length;
	    while (low < high) {
	      var mid = (low + high) >>> 1;
	      iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
	    }
	    return low;
	  };
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (obj.length === +obj.length) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return (obj.length === +obj.length) ? obj.length : _.keys(obj).length;
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if ((n == null) || guard) return array[0];
	    if (n < 0) return [];
	    return slice.call(array, 0, n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N. The **guard** check allows it to work with
	  // `_.map`.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, array.length - ((n == null) || guard ? 1 : n));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if ((n == null) || guard) return array[array.length - 1];
	    return slice.call(array, Math.max(array.length - n, 0));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array. The **guard**
	  // check allows it to work with `_.map`.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, (n == null) || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, output) {
	    if (shallow && _.every(input, _.isArray)) {
	      return concat.apply(output, input);
	    }
	    each(input, function(value) {
	      if (_.isArray(value) || _.isArguments(value)) {
	        shallow ? push.apply(output, value) : flatten(value, shallow, output);
	      } else {
	        output.push(value);
	      }
	    });
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, []);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Split an array into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(array, predicate) {
	    var pass = [], fail = [];
	    each(array, function(elem) {
	      (predicate(elem) ? pass : fail).push(elem);
	    });
	    return [pass, fail];
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iterator, context) {
	    if (_.isFunction(isSorted)) {
	      context = iterator;
	      iterator = isSorted;
	      isSorted = false;
	    }
	    var initial = iterator ? _.map(array, iterator, context) : array;
	    var results = [];
	    var seen = [];
	    each(initial, function(value, index) {
	      if (isSorted ? (!index || seen[seen.length - 1] !== value) : !_.contains(seen, value)) {
	        seen.push(value);
	        results.push(array[index]);
	      }
	    });
	    return results;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(_.flatten(arguments, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var rest = slice.call(arguments, 1);
	    return _.filter(_.uniq(array), function(item) {
	      return _.every(rest, function(other) {
	        return _.contains(other, item);
	      });
	    });
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
	    return _.filter(array, function(value){ return !_.contains(rest, value); });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    var length = _.max(_.pluck(arguments, 'length').concat(0));
	    var results = new Array(length);
	    for (var i = 0; i < length; i++) {
	      results[i] = _.pluck(arguments, '' + i);
	    }
	    return results;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    if (list == null) return {};
	    var result = {};
	    for (var i = 0, length = list.length; i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),
	  // we need this function. Return the position of the first occurrence of an
	  // item in an array, or -1 if the item is not included in the array.
	  // Delegates to **ECMAScript 5**'s native `indexOf` if available.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = function(array, item, isSorted) {
	    if (array == null) return -1;
	    var i = 0, length = array.length;
	    if (isSorted) {
	      if (typeof isSorted == 'number') {
	        i = (isSorted < 0 ? Math.max(0, length + isSorted) : isSorted);
	      } else {
	        i = _.sortedIndex(array, item);
	        return array[i] === item ? i : -1;
	      }
	    }
	    if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);
	    for (; i < length; i++) if (array[i] === item) return i;
	    return -1;
	  };
	
	  // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.
	  _.lastIndexOf = function(array, item, from) {
	    if (array == null) return -1;
	    var hasIndex = from != null;
	    if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
	      return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
	    }
	    var i = (hasIndex ? from : array.length);
	    while (i--) if (array[i] === item) return i;
	    return -1;
	  };
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (arguments.length <= 1) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = arguments[2] || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var idx = 0;
	    var range = new Array(length);
	
	    while(idx < length) {
	      range[idx++] = start;
	      start += step;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Reusable constructor function for prototype setting.
	  var ctor = function(){};
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    var args, bound;
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError;
	    args = slice.call(arguments, 2);
	    return bound = function() {
	      if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
	      ctor.prototype = func.prototype;
	      var self = new ctor;
	      ctor.prototype = null;
	      var result = func.apply(self, args.concat(slice.call(arguments)));
	      if (Object(result) === result) return result;
	      return self;
	    };
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    return function() {
	      var position = 0;
	      var args = boundArgs.slice();
	      for (var i = 0, length = args.length; i < length; i++) {
	        if (args[i] === _) args[i] = arguments[position++];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return func.apply(this, args);
	    };
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var funcs = slice.call(arguments, 1);
	    if (funcs.length === 0) throw new Error('bindAll must be passed function names');
	    each(funcs, function(f) { obj[f] = _.bind(obj[f], obj); });
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memo = {};
	    hasher || (hasher = _.identity);
	    return function() {
	      var key = hasher.apply(this, arguments);
	      return _.has(memo, key) ? memo[key] : (memo[key] = func.apply(this, arguments));
	    };
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){ return func.apply(null, args); }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = function(func) {
	    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
	  };
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    options || (options = {});
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0) {
	        clearTimeout(timeout);
	        timeout = null;
	        previous = now;
	        result = func.apply(context, args);
	        context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	      if (last < wait) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) {
	        timeout = setTimeout(later, wait);
	      }
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = function(func) {
	    var ran = false, memo;
	    return function() {
	      if (ran) return memo;
	      ran = true;
	      memo = func.apply(this, arguments);
	      func = null;
	      return memo;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var funcs = arguments;
	    return function() {
	      var args = arguments;
	      for (var i = funcs.length - 1; i >= 0; i--) {
	        args = [funcs[i].apply(this, args)];
	      }
	      return args[0];
	    };
	  };
	
	  // Returns a function that will only be executed after being called N times.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Object Functions
	  // ----------------
	
	  // Retrieve the names of an object's properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = new Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = new Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      if (source) {
	        for (var prop in source) {
	          obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    each(keys, function(key) {
	      if (key in obj) copy[key] = obj[key];
	    });
	    return copy;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    for (var key in obj) {
	      if (!_.contains(keys, key)) copy[key] = obj[key];
	    }
	    return copy;
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      if (source) {
	        for (var prop in source) {
	          if (obj[prop] === void 0) obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a == 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className != toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, dates, and booleans are compared by value.
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return a == String(b);
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for
	        // other numeric values.
	        return a != +a ? b != +b : (a == 0 ? 1 / a == 1 / b : a == +b);
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a == +b;
	      // RegExps are compared by their source patterns and flags.
	      case '[object RegExp]':
	        return a.source == b.source &&
	               a.global == b.global &&
	               a.multiline == b.multiline &&
	               a.ignoreCase == b.ignoreCase;
	    }
	    if (typeof a != 'object' || typeof b != 'object') return false;
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] == a) return bStack[length] == b;
	    }
	    // Objects with different constructors are not equivalent, but `Object`s
	    // from different frames are.
	    var aCtor = a.constructor, bCtor = b.constructor;
	    if (aCtor !== bCtor && !(_.isFunction(aCtor) && (aCtor instanceof aCtor) &&
	                             _.isFunction(bCtor) && (bCtor instanceof bCtor))
	                        && ('constructor' in a && 'constructor' in b)) {
	      return false;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    var size = 0, result = true;
	    // Recursively compare objects and arrays.
	    if (className == '[object Array]') {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      size = a.length;
	      result = size == b.length;
	      if (result) {
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (size--) {
	          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
	        }
	      }
	    } else {
	      // Deep compare objects.
	      for (var key in a) {
	        if (_.has(a, key)) {
	          // Count the expected number of properties.
	          size++;
	          // Deep compare each member.
	          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
	        }
	      }
	      // Ensure that both objects contain the same number of properties.
	      if (result) {
	        for (key in b) {
	          if (_.has(b, key) && !(size--)) break;
	        }
	        result = !size;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return result;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b, [], []);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;
	    for (var key in obj) if (_.has(obj, key)) return false;
	    return true;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    return obj === Object(obj);
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
	  each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) == '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return !!(obj && _.has(obj, 'callee'));
	    };
	  }
	
	  // Optimize `isFunction` if appropriate.
	  if (true) {
	    _.isFunction = function(obj) {
	      return typeof obj === 'function';
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj != +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) == '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iterators.
	  _.identity = function(value) {
	    return value;
	  };
	
	  _.constant = function(value) {
	    return function () {
	      return value;
	    };
	  };
	
	  _.property = function(key) {
	    return function(obj) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of `key:value` pairs.
	  _.matches = function(attrs) {
	    return function(obj) {
	      if (obj === attrs) return true; //avoid comparing an object to itself.
	      for (var key in attrs) {
	        if (attrs[key] !== obj[key])
	          return false;
	      }
	      return true;
	    }
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iterator, context) {
	    var accum = Array(Math.max(0, n));
	    for (var i = 0; i < n; i++) accum[i] = iterator.call(context, i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() { return new Date().getTime(); };
	
	  // List of HTML entities for escaping.
	  var entityMap = {
	    escape: {
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      "'": '&#x27;'
	    }
	  };
	  entityMap.unescape = _.invert(entityMap.escape);
	
	  // Regexes containing the keys and values listed immediately above.
	  var entityRegexes = {
	    escape:   new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),
	    unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')
	  };
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  _.each(['escape', 'unescape'], function(method) {
	    _[method] = function(string) {
	      if (string == null) return '';
	      return ('' + string).replace(entityRegexes[method], function(match) {
	        return entityMap[method][match];
	      });
	    };
	  });
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property) {
	    if (object == null) return void 0;
	    var value = object[property];
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result.call(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\t':     't',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  _.template = function(text, data, settings) {
	    var render;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = new RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset)
	        .replace(escaper, function(match) { return '\\' + escapes[match]; });
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      }
	      if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      }
	      if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	      index = offset + match.length;
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + "return __p;\n";
	
	    try {
	      render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    if (data) return render(data, _);
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled function source as a convenience for precompilation.
	    template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function, which will delegate to the wrapper.
	  _.chain = function(obj) {
	    return _(obj).chain();
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(obj) {
	    return this._chain ? _(obj).chain() : obj;
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name == 'shift' || name == 'splice') && obj.length === 0) delete obj[0];
	      return result.call(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result.call(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  _.extend(_.prototype, {
	
	    // Start chaining a wrapped Underscore object.
	    chain: function() {
	      this._chain = true;
	      return this;
	    },
	
	    // Extracts the result from a wrapped and chained object.
	    value: function() {
	      return this._wrapped;
	    }
	
	  });
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);


/***/ },
/* 1511 */
[1955, 7, 16],
/* 1512 */
[1958, 16, 1513],
/* 1513 */
1,
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.4.1
	//! author : Tim Wood
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else if (typeof exports === 'object') {
			module.exports = factory(require('moment')); // Node
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Do not load moment-timezone a second time.
		if (moment.tz !== undefined) {
			logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
			return moment;
		}
	
		var VERSION = "0.4.1",
			zones = {},
			links = {},
			names = {},
	
			momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name    : data[0],
				abbrs   : mapIndices(data[1].split(' '), indices),
				offsets : mapIndices(offsets, indices),
				untils  : untils
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name    = unpacked.name;
				this.abbrs   = unpacked.abbrs;
				this.untils  = unpacked.untils;
				this.offsets = unpacked.offsets;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				name = packed[i].split('|')[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
			}
		}
	
		function getZone (name, caller) {
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			return !!(m._a && (m._tzm === undefined));
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.offset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					mom.utcOffset(-offset, keepTime);
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name) {
			if (name) {
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName = abbrWrap(fn.zoneName);
		fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
		fn.utc      = resetZoneWrap(fn.utc);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 1138,
		"./af.js": 1138,
		"./ar": 1146,
		"./ar-dz": 1139,
		"./ar-dz.js": 1139,
		"./ar-kw": 1140,
		"./ar-kw.js": 1140,
		"./ar-ly": 1141,
		"./ar-ly.js": 1141,
		"./ar-ma": 1142,
		"./ar-ma.js": 1142,
		"./ar-ps": 1143,
		"./ar-ps.js": 1143,
		"./ar-sa": 1144,
		"./ar-sa.js": 1144,
		"./ar-tn": 1145,
		"./ar-tn.js": 1145,
		"./ar.js": 1146,
		"./az": 1147,
		"./az.js": 1147,
		"./be": 1148,
		"./be.js": 1148,
		"./bg": 1149,
		"./bg.js": 1149,
		"./bm": 1150,
		"./bm.js": 1150,
		"./bn": 1152,
		"./bn-bd": 1151,
		"./bn-bd.js": 1151,
		"./bn.js": 1152,
		"./bo": 1153,
		"./bo.js": 1153,
		"./br": 1154,
		"./br.js": 1154,
		"./bs": 1155,
		"./bs.js": 1155,
		"./ca": 1156,
		"./ca.js": 1156,
		"./cs": 1157,
		"./cs.js": 1157,
		"./cv": 1158,
		"./cv.js": 1158,
		"./cy": 1159,
		"./cy.js": 1159,
		"./da": 1160,
		"./da.js": 1160,
		"./de": 1163,
		"./de-at": 1161,
		"./de-at.js": 1161,
		"./de-ch": 1162,
		"./de-ch.js": 1162,
		"./de.js": 1163,
		"./dv": 1164,
		"./dv.js": 1164,
		"./el": 1165,
		"./el.js": 1165,
		"./en-au": 1166,
		"./en-au.js": 1166,
		"./en-ca": 1167,
		"./en-ca.js": 1167,
		"./en-gb": 1168,
		"./en-gb.js": 1168,
		"./en-ie": 1169,
		"./en-ie.js": 1169,
		"./en-il": 1170,
		"./en-il.js": 1170,
		"./en-in": 1171,
		"./en-in.js": 1171,
		"./en-nz": 1172,
		"./en-nz.js": 1172,
		"./en-sg": 1173,
		"./en-sg.js": 1173,
		"./eo": 1174,
		"./eo.js": 1174,
		"./es": 1178,
		"./es-do": 1175,
		"./es-do.js": 1175,
		"./es-mx": 1176,
		"./es-mx.js": 1176,
		"./es-us": 1177,
		"./es-us.js": 1177,
		"./es.js": 1178,
		"./et": 1179,
		"./et.js": 1179,
		"./eu": 1180,
		"./eu.js": 1180,
		"./fa": 1181,
		"./fa.js": 1181,
		"./fi": 1182,
		"./fi.js": 1182,
		"./fil": 1183,
		"./fil.js": 1183,
		"./fo": 1184,
		"./fo.js": 1184,
		"./fr": 1187,
		"./fr-ca": 1185,
		"./fr-ca.js": 1185,
		"./fr-ch": 1186,
		"./fr-ch.js": 1186,
		"./fr.js": 1187,
		"./fy": 1188,
		"./fy.js": 1188,
		"./ga": 1189,
		"./ga.js": 1189,
		"./gd": 1190,
		"./gd.js": 1190,
		"./gl": 1191,
		"./gl.js": 1191,
		"./gom-deva": 1192,
		"./gom-deva.js": 1192,
		"./gom-latn": 1193,
		"./gom-latn.js": 1193,
		"./gu": 1194,
		"./gu.js": 1194,
		"./he": 1195,
		"./he.js": 1195,
		"./hi": 1196,
		"./hi.js": 1196,
		"./hr": 1197,
		"./hr.js": 1197,
		"./hu": 1198,
		"./hu.js": 1198,
		"./hy-am": 1199,
		"./hy-am.js": 1199,
		"./id": 1200,
		"./id.js": 1200,
		"./is": 1201,
		"./is.js": 1201,
		"./it": 1203,
		"./it-ch": 1202,
		"./it-ch.js": 1202,
		"./it.js": 1203,
		"./ja": 1204,
		"./ja.js": 1204,
		"./jv": 1205,
		"./jv.js": 1205,
		"./ka": 1206,
		"./ka.js": 1206,
		"./kk": 1207,
		"./kk.js": 1207,
		"./km": 1208,
		"./km.js": 1208,
		"./kn": 1209,
		"./kn.js": 1209,
		"./ko": 1210,
		"./ko.js": 1210,
		"./ku": 1212,
		"./ku-kmr": 1211,
		"./ku-kmr.js": 1211,
		"./ku.js": 1212,
		"./ky": 1213,
		"./ky.js": 1213,
		"./lb": 1214,
		"./lb.js": 1214,
		"./lo": 1215,
		"./lo.js": 1215,
		"./lt": 1216,
		"./lt.js": 1216,
		"./lv": 1217,
		"./lv.js": 1217,
		"./me": 1218,
		"./me.js": 1218,
		"./mi": 1219,
		"./mi.js": 1219,
		"./mk": 1220,
		"./mk.js": 1220,
		"./ml": 1221,
		"./ml.js": 1221,
		"./mn": 1222,
		"./mn.js": 1222,
		"./mr": 1223,
		"./mr.js": 1223,
		"./ms": 1225,
		"./ms-my": 1224,
		"./ms-my.js": 1224,
		"./ms.js": 1225,
		"./mt": 1226,
		"./mt.js": 1226,
		"./my": 1227,
		"./my.js": 1227,
		"./nb": 1228,
		"./nb.js": 1228,
		"./ne": 1229,
		"./ne.js": 1229,
		"./nl": 1231,
		"./nl-be": 1230,
		"./nl-be.js": 1230,
		"./nl.js": 1231,
		"./nn": 1232,
		"./nn.js": 1232,
		"./oc-lnc": 1233,
		"./oc-lnc.js": 1233,
		"./pa-in": 1234,
		"./pa-in.js": 1234,
		"./pl": 1235,
		"./pl.js": 1235,
		"./pt": 1237,
		"./pt-br": 1236,
		"./pt-br.js": 1236,
		"./pt.js": 1237,
		"./ro": 1238,
		"./ro.js": 1238,
		"./ru": 1239,
		"./ru.js": 1239,
		"./sd": 1240,
		"./sd.js": 1240,
		"./se": 1241,
		"./se.js": 1241,
		"./si": 1242,
		"./si.js": 1242,
		"./sk": 1243,
		"./sk.js": 1243,
		"./sl": 1244,
		"./sl.js": 1244,
		"./sq": 1245,
		"./sq.js": 1245,
		"./sr": 1247,
		"./sr-cyrl": 1246,
		"./sr-cyrl.js": 1246,
		"./sr.js": 1247,
		"./ss": 1248,
		"./ss.js": 1248,
		"./sv": 1249,
		"./sv.js": 1249,
		"./sw": 1250,
		"./sw.js": 1250,
		"./ta": 1251,
		"./ta.js": 1251,
		"./te": 1252,
		"./te.js": 1252,
		"./tet": 1253,
		"./tet.js": 1253,
		"./tg": 1254,
		"./tg.js": 1254,
		"./th": 1255,
		"./th.js": 1255,
		"./tk": 1256,
		"./tk.js": 1256,
		"./tl-ph": 1257,
		"./tl-ph.js": 1257,
		"./tlh": 1258,
		"./tlh.js": 1258,
		"./tr": 1259,
		"./tr.js": 1259,
		"./tzl": 1260,
		"./tzl.js": 1260,
		"./tzm": 1262,
		"./tzm-latn": 1261,
		"./tzm-latn.js": 1261,
		"./tzm.js": 1262,
		"./ug-cn": 1263,
		"./ug-cn.js": 1263,
		"./uk": 1264,
		"./uk.js": 1264,
		"./ur": 1265,
		"./ur.js": 1265,
		"./uz": 1267,
		"./uz-latn": 1266,
		"./uz-latn.js": 1266,
		"./uz.js": 1267,
		"./vi": 1268,
		"./vi.js": 1268,
		"./x-pseudo": 1269,
		"./x-pseudo.js": 1269,
		"./yo": 1270,
		"./yo.js": 1270,
		"./zh-cn": 1271,
		"./zh-cn.js": 1271,
		"./zh-hk": 1272,
		"./zh-hk.js": 1272,
		"./zh-mo": 1273,
		"./zh-mo.js": 1273,
		"./zh-tw": 1274,
		"./zh-tw.js": 1274
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1515;


/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Toastr
	 * Copyright 2012-2015
	 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
	 * All Rights Reserved.
	 * Use, reproduction, distribution, and modification of this code is subject to the terms and
	 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
	 *
	 * ARIA Support: Greta Krafsig
	 *
	 * Project: https://github.com/CodeSeven/toastr
	 */
	/* global define */
	(function (define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(18)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	        return (function () {
	            var $container;
	            var listener;
	            var toastId = 0;
	            var toastType = {
	                error: 'error',
	                info: 'info',
	                success: 'success',
	                warning: 'warning'
	            };
	
	            var toastr = {
	                clear: clear,
	                remove: remove,
	                error: error,
	                getContainer: getContainer,
	                info: info,
	                options: {},
	                subscribe: subscribe,
	                success: success,
	                version: '2.1.4',
	                warning: warning
	            };
	
	            var previousToast;
	
	            return toastr;
	
	            ////////////////
	
	            function error(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.error,
	                    iconClass: getOptions().iconClasses.error,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function getContainer(options, create) {
	                if (!options) { options = getOptions(); }
	                $container = $('#' + options.containerId);
	                if ($container.length) {
	                    return $container;
	                }
	                if (create) {
	                    $container = createContainer(options);
	                }
	                return $container;
	            }
	
	            function info(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.info,
	                    iconClass: getOptions().iconClasses.info,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function subscribe(callback) {
	                listener = callback;
	            }
	
	            function success(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.success,
	                    iconClass: getOptions().iconClasses.success,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function warning(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.warning,
	                    iconClass: getOptions().iconClasses.warning,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function clear($toastElement, clearOptions) {
	                var options = getOptions();
	                if (!$container) { getContainer(options); }
	                if (!clearToast($toastElement, options, clearOptions)) {
	                    clearContainer(options);
	                }
	            }
	
	            function remove($toastElement) {
	                var options = getOptions();
	                if (!$container) { getContainer(options); }
	                if ($toastElement && $(':focus', $toastElement).length === 0) {
	                    removeToast($toastElement);
	                    return;
	                }
	                if ($container.children().length) {
	                    $container.remove();
	                }
	            }
	
	            // internal functions
	
	            function clearContainer (options) {
	                var toastsToClear = $container.children();
	                for (var i = toastsToClear.length - 1; i >= 0; i--) {
	                    clearToast($(toastsToClear[i]), options);
	                }
	            }
	
	            function clearToast ($toastElement, options, clearOptions) {
	                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
	                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
	                    $toastElement[options.hideMethod]({
	                        duration: options.hideDuration,
	                        easing: options.hideEasing,
	                        complete: function () { removeToast($toastElement); }
	                    });
	                    return true;
	                }
	                return false;
	            }
	
	            function createContainer(options) {
	                $container = $('<div/>')
	                    .attr('id', options.containerId)
	                    .addClass(options.positionClass);
	
	                $container.appendTo($(options.target));
	                return $container;
	            }
	
	            function getDefaults() {
	                return {
	                    tapToDismiss: true,
	                    toastClass: 'toast',
	                    containerId: 'toast-container',
	                    debug: false,
	
	                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
	                    showDuration: 300,
	                    showEasing: 'swing', //swing and linear are built into jQuery
	                    onShown: undefined,
	                    hideMethod: 'fadeOut',
	                    hideDuration: 1000,
	                    hideEasing: 'swing',
	                    onHidden: undefined,
	                    closeMethod: false,
	                    closeDuration: false,
	                    closeEasing: false,
	                    closeOnHover: true,
	
	                    extendedTimeOut: 1000,
	                    iconClasses: {
	                        error: 'toast-error',
	                        info: 'toast-info',
	                        success: 'toast-success',
	                        warning: 'toast-warning'
	                    },
	                    iconClass: 'toast-info',
	                    positionClass: 'toast-top-right',
	                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
	                    titleClass: 'toast-title',
	                    messageClass: 'toast-message',
	                    escapeHtml: false,
	                    target: 'body',
	                    closeHtml: '<button type="button">&times;</button>',
	                    closeClass: 'toast-close-button',
	                    newestOnTop: true,
	                    preventDuplicates: false,
	                    progressBar: false,
	                    progressClass: 'toast-progress',
	                    rtl: false
	                };
	            }
	
	            function publish(args) {
	                if (!listener) { return; }
	                listener(args);
	            }
	
	            function notify(map) {
	                var options = getOptions();
	                var iconClass = map.iconClass || options.iconClass;
	
	                if (typeof (map.optionsOverride) !== 'undefined') {
	                    options = $.extend(options, map.optionsOverride);
	                    iconClass = map.optionsOverride.iconClass || iconClass;
	                }
	
	                if (shouldExit(options, map)) { return; }
	
	                toastId++;
	
	                $container = getContainer(options, true);
	
	                var intervalId = null;
	                var $toastElement = $('<div/>');
	                var $titleElement = $('<div/>');
	                var $messageElement = $('<div/>');
	                var $progressElement = $('<div/>');
	                var $closeElement = $(options.closeHtml);
	                var progressBar = {
	                    intervalId: null,
	                    hideEta: null,
	                    maxHideTime: null
	                };
	                var response = {
	                    toastId: toastId,
	                    state: 'visible',
	                    startTime: new Date(),
	                    options: options,
	                    map: map
	                };
	
	                personalizeToast();
	
	                displayToast();
	
	                handleEvents();
	
	                publish(response);
	
	                if (options.debug && console) {
	                    console.log(response);
	                }
	
	                return $toastElement;
	
	                function escapeHtml(source) {
	                    if (source == null) {
	                        source = '';
	                    }
	
	                    return source
	                        .replace(/&/g, '&amp;')
	                        .replace(/"/g, '&quot;')
	                        .replace(/'/g, '&#39;')
	                        .replace(/</g, '&lt;')
	                        .replace(/>/g, '&gt;');
	                }
	
	                function personalizeToast() {
	                    setIcon();
	                    setTitle();
	                    setMessage();
	                    setCloseButton();
	                    setProgressBar();
	                    setRTL();
	                    setSequence();
	                    setAria();
	                }
	
	                function setAria() {
	                    var ariaValue = '';
	                    switch (map.iconClass) {
	                        case 'toast-success':
	                        case 'toast-info':
	                            ariaValue =  'polite';
	                            break;
	                        default:
	                            ariaValue = 'assertive';
	                    }
	                    $toastElement.attr('aria-live', ariaValue);
	                }
	
	                function handleEvents() {
	                    if (options.closeOnHover) {
	                        $toastElement.hover(stickAround, delayedHideToast);
	                    }
	
	                    if (!options.onclick && options.tapToDismiss) {
	                        $toastElement.click(hideToast);
	                    }
	
	                    if (options.closeButton && $closeElement) {
	                        $closeElement.click(function (event) {
	                            if (event.stopPropagation) {
	                                event.stopPropagation();
	                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
	                                event.cancelBubble = true;
	                            }
	
	                            if (options.onCloseClick) {
	                                options.onCloseClick(event);
	                            }
	
	                            hideToast(true);
	                        });
	                    }
	
	                    if (options.onclick) {
	                        $toastElement.click(function (event) {
	                            options.onclick(event);
	                            hideToast();
	                        });
	                    }
	                }
	
	                function displayToast() {
	                    $toastElement.hide();
	
	                    $toastElement[options.showMethod](
	                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
	                    );
	
	                    if (options.timeOut > 0) {
	                        intervalId = setTimeout(hideToast, options.timeOut);
	                        progressBar.maxHideTime = parseFloat(options.timeOut);
	                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
	                        if (options.progressBar) {
	                            progressBar.intervalId = setInterval(updateProgress, 10);
	                        }
	                    }
	                }
	
	                function setIcon() {
	                    if (map.iconClass) {
	                        $toastElement.addClass(options.toastClass).addClass(iconClass);
	                    }
	                }
	
	                function setSequence() {
	                    if (options.newestOnTop) {
	                        $container.prepend($toastElement);
	                    } else {
	                        $container.append($toastElement);
	                    }
	                }
	
	                function setTitle() {
	                    if (map.title) {
	                        var suffix = map.title;
	                        if (options.escapeHtml) {
	                            suffix = escapeHtml(map.title);
	                        }
	                        $titleElement.append(suffix).addClass(options.titleClass);
	                        $toastElement.append($titleElement);
	                    }
	                }
	
	                function setMessage() {
	                    if (map.message) {
	                        var suffix = map.message;
	                        if (options.escapeHtml) {
	                            suffix = escapeHtml(map.message);
	                        }
	                        $messageElement.append(suffix).addClass(options.messageClass);
	                        $toastElement.append($messageElement);
	                    }
	                }
	
	                function setCloseButton() {
	                    if (options.closeButton) {
	                        $closeElement.addClass(options.closeClass).attr('role', 'button');
	                        $toastElement.prepend($closeElement);
	                    }
	                }
	
	                function setProgressBar() {
	                    if (options.progressBar) {
	                        $progressElement.addClass(options.progressClass);
	                        $toastElement.prepend($progressElement);
	                    }
	                }
	
	                function setRTL() {
	                    if (options.rtl) {
	                        $toastElement.addClass('rtl');
	                    }
	                }
	
	                function shouldExit(options, map) {
	                    if (options.preventDuplicates) {
	                        if (map.message === previousToast) {
	                            return true;
	                        } else {
	                            previousToast = map.message;
	                        }
	                    }
	                    return false;
	                }
	
	                function hideToast(override) {
	                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
	                    var duration = override && options.closeDuration !== false ?
	                        options.closeDuration : options.hideDuration;
	                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
	                    if ($(':focus', $toastElement).length && !override) {
	                        return;
	                    }
	                    clearTimeout(progressBar.intervalId);
	                    return $toastElement[method]({
	                        duration: duration,
	                        easing: easing,
	                        complete: function () {
	                            removeToast($toastElement);
	                            clearTimeout(intervalId);
	                            if (options.onHidden && response.state !== 'hidden') {
	                                options.onHidden();
	                            }
	                            response.state = 'hidden';
	                            response.endTime = new Date();
	                            publish(response);
	                        }
	                    });
	                }
	
	                function delayedHideToast() {
	                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
	                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
	                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
	                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
	                    }
	                }
	
	                function stickAround() {
	                    clearTimeout(intervalId);
	                    progressBar.hideEta = 0;
	                    $toastElement.stop(true, true)[options.showMethod](
	                        {duration: options.showDuration, easing: options.showEasing}
	                    );
	                }
	
	                function updateProgress() {
	                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
	                    $progressElement.width(percentage + '%');
	                }
	            }
	
	            function getOptions() {
	                return $.extend({}, getDefaults(), toastr.options);
	            }
	
	            function removeToast($toastElement) {
	                if (!$container) { $container = getContainer(); }
	                if ($toastElement.is(':visible')) {
	                    return;
	                }
	                $toastElement.remove();
	                $toastElement = null;
	                if ($container.children().length === 0) {
	                    $container.remove();
	                    previousToast = undefined;
	                }
	            }
	
	        })();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(1507)));


/***/ },
/* 1517 */,
/* 1518 */
/***/ function(module, exports) {

	function _getPrototypeOf(t) {
	  return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
	    return t.__proto__ || Object.getPrototypeOf(t);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
	}
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(911);
	function _inherits(t, e) {
	  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
	  t.prototype = Object.create(e && e.prototype, {
	    constructor: {
	      value: t,
	      writable: !0,
	      configurable: !0
	    }
	  }), Object.defineProperty(t, "prototype", {
	    writable: !1
	  }), e && setPrototypeOf(t, e);
	}
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1520 */
/***/ function(module, exports) {

	function _isNativeFunction(t) {
	  try {
	    return -1 !== Function.toString.call(t).indexOf("[native code]");
	  } catch (n) {
	    return "function" == typeof t;
	  }
	}
	module.exports = _isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1521 */
/***/ function(module, exports) {

	function _isNativeReflectConstruct() {
	  try {
	    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	  } catch (t) {}
	  return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {
	    return !!t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
	}
	module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototypeOf = __webpack_require__(1518);
	var setPrototypeOf = __webpack_require__(911);
	var isNativeFunction = __webpack_require__(1520);
	var construct = __webpack_require__(1276);
	function _wrapNativeSuper(t) {
	  var r = "function" == typeof Map ? new Map() : void 0;
	  return module.exports = _wrapNativeSuper = function _wrapNativeSuper(t) {
	    if (null === t || !isNativeFunction(t)) return t;
	    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
	    if (void 0 !== r) {
	      if (r.has(t)) return r.get(t);
	      r.set(t, Wrapper);
	    }
	    function Wrapper() {
	      return construct(t, arguments, getPrototypeOf(this).constructor);
	    }
	    return Wrapper.prototype = Object.create(t.prototype, {
	      constructor: {
	        value: Wrapper,
	        enumerable: !1,
	        writable: !0,
	        configurable: !0
	      }
	    }), setPrototypeOf(Wrapper, t);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _wrapNativeSuper(t);
	}
	module.exports = _wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(910);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_VIDEO_CODEC = exports.DEFAULT_AUDIO_CODEC = exports.muxerSupportsCodec = exports.browserSupportsCodec = exports.getMimeForCodec = exports.isTextCodec = exports.isAudioCodec = exports.isVideoCodec = exports.codecsFromDefault = exports.parseCodecs = exports.mapLegacyAvcCodecs = exports.translateLegacyCodecs = exports.translateLegacyCodec = void 0;
	
	var _window = _interopRequireDefault(__webpack_require__(344));
	
	var regexs = {
	  // to determine mime types
	  mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
	  webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
	  ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
	  // to determine if a codec is audio or video
	  video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
	  audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
	  text: /^(stpp.ttml.im1t)/,
	  // mux.js support regex
	  muxerVideo: /^(avc0?1)/,
	  muxerAudio: /^(mp4a)/,
	  // match nothing as muxer does not support text right now.
	  // there cannot never be a character before the start of a string
	  // so this matches nothing.
	  muxerText: /a^/
	};
	var mediaTypes = ['video', 'audio', 'text'];
	var upperMediaTypes = ['Video', 'Audio', 'Text'];
	/**
	 * Replace the old apple-style `avc1.<dd>.<dd>` codec string with the standard
	 * `avc1.<hhhhhh>`
	 *
	 * @param {string} codec
	 *        Codec string to translate
	 * @return {string}
	 *         The translated codec string
	 */
	
	var translateLegacyCodec = function translateLegacyCodec(codec) {
	  if (!codec) {
	    return codec;
	  }
	
	  return codec.replace(/avc1\.(\d+)\.(\d+)/i, function (orig, profile, avcLevel) {
	    var profileHex = ('00' + Number(profile).toString(16)).slice(-2);
	    var avcLevelHex = ('00' + Number(avcLevel).toString(16)).slice(-2);
	    return 'avc1.' + profileHex + '00' + avcLevelHex;
	  });
	};
	/**
	 * Replace the old apple-style `avc1.<dd>.<dd>` codec strings with the standard
	 * `avc1.<hhhhhh>`
	 *
	 * @param {string[]} codecs
	 *        An array of codec strings to translate
	 * @return {string[]}
	 *         The translated array of codec strings
	 */
	
	
	exports.translateLegacyCodec = translateLegacyCodec;
	
	var translateLegacyCodecs = function translateLegacyCodecs(codecs) {
	  return codecs.map(translateLegacyCodec);
	};
	/**
	 * Replace codecs in the codec string with the old apple-style `avc1.<dd>.<dd>` to the
	 * standard `avc1.<hhhhhh>`.
	 *
	 * @param {string} codecString
	 *        The codec string
	 * @return {string}
	 *         The codec string with old apple-style codecs replaced
	 *
	 * @private
	 */
	
	
	exports.translateLegacyCodecs = translateLegacyCodecs;
	
	var mapLegacyAvcCodecs = function mapLegacyAvcCodecs(codecString) {
	  return codecString.replace(/avc1\.(\d+)\.(\d+)/i, function (match) {
	    return translateLegacyCodecs([match])[0];
	  });
	};
	/**
	 * @typedef {Object} ParsedCodecInfo
	 * @property {number} codecCount
	 *           Number of codecs parsed
	 * @property {string} [videoCodec]
	 *           Parsed video codec (if found)
	 * @property {string} [videoObjectTypeIndicator]
	 *           Video object type indicator (if found)
	 * @property {string|null} audioProfile
	 *           Audio profile
	 */
	
	/**
	 * Parses a codec string to retrieve the number of codecs specified, the video codec and
	 * object type indicator, and the audio profile.
	 *
	 * @param {string} [codecString]
	 *        The codec string to parse
	 * @return {ParsedCodecInfo}
	 *         Parsed codec info
	 */
	
	
	exports.mapLegacyAvcCodecs = mapLegacyAvcCodecs;
	
	var parseCodecs = function parseCodecs(codecString) {
	  if (codecString === void 0) {
	    codecString = '';
	  }
	
	  var codecs = codecString.split(',');
	  var result = [];
	  codecs.forEach(function (codec) {
	    codec = codec.trim();
	    var codecType;
	    mediaTypes.forEach(function (name) {
	      var match = regexs[name].exec(codec.toLowerCase());
	
	      if (!match || match.length <= 1) {
	        return;
	      }
	
	      codecType = name; // maintain codec case
	
	      var type = codec.substring(0, match[1].length);
	      var details = codec.replace(type, '');
	      result.push({
	        type: type,
	        details: details,
	        mediaType: name
	      });
	    });
	
	    if (!codecType) {
	      result.push({
	        type: codec,
	        details: '',
	        mediaType: 'unknown'
	      });
	    }
	  });
	  return result;
	};
	/**
	 * Returns a ParsedCodecInfo object for the default alternate audio playlist if there is
	 * a default alternate audio playlist for the provided audio group.
	 *
	 * @param {Object} master
	 *        The master playlist
	 * @param {string} audioGroupId
	 *        ID of the audio group for which to find the default codec info
	 * @return {ParsedCodecInfo}
	 *         Parsed codec info
	 */
	
	
	exports.parseCodecs = parseCodecs;
	
	var codecsFromDefault = function codecsFromDefault(master, audioGroupId) {
	  if (!master.mediaGroups.AUDIO || !audioGroupId) {
	    return null;
	  }
	
	  var audioGroup = master.mediaGroups.AUDIO[audioGroupId];
	
	  if (!audioGroup) {
	    return null;
	  }
	
	  for (var name in audioGroup) {
	    var audioType = audioGroup[name];
	
	    if (audioType.default && audioType.playlists) {
	      // codec should be the same for all playlists within the audio type
	      return parseCodecs(audioType.playlists[0].attributes.CODECS);
	    }
	  }
	
	  return null;
	};
	
	exports.codecsFromDefault = codecsFromDefault;
	
	var isVideoCodec = function isVideoCodec(codec) {
	  if (codec === void 0) {
	    codec = '';
	  }
	
	  return regexs.video.test(codec.trim().toLowerCase());
	};
	
	exports.isVideoCodec = isVideoCodec;
	
	var isAudioCodec = function isAudioCodec(codec) {
	  if (codec === void 0) {
	    codec = '';
	  }
	
	  return regexs.audio.test(codec.trim().toLowerCase());
	};
	
	exports.isAudioCodec = isAudioCodec;
	
	var isTextCodec = function isTextCodec(codec) {
	  if (codec === void 0) {
	    codec = '';
	  }
	
	  return regexs.text.test(codec.trim().toLowerCase());
	};
	
	exports.isTextCodec = isTextCodec;
	
	var getMimeForCodec = function getMimeForCodec(codecString) {
	  if (!codecString || typeof codecString !== 'string') {
	    return;
	  }
	
	  var codecs = codecString.toLowerCase().split(',').map(function (c) {
	    return translateLegacyCodec(c.trim());
	  }); // default to video type
	
	  var type = 'video'; // only change to audio type if the only codec we have is
	  // audio
	
	  if (codecs.length === 1 && isAudioCodec(codecs[0])) {
	    type = 'audio';
	  } else if (codecs.length === 1 && isTextCodec(codecs[0])) {
	    // text uses application/<container> for now
	    type = 'application';
	  } // default the container to mp4
	
	
	  var container = 'mp4'; // every codec must be able to go into the container
	  // for that container to be the correct one
	
	  if (codecs.every(function (c) {
	    return regexs.mp4.test(c);
	  })) {
	    container = 'mp4';
	  } else if (codecs.every(function (c) {
	    return regexs.webm.test(c);
	  })) {
	    container = 'webm';
	  } else if (codecs.every(function (c) {
	    return regexs.ogg.test(c);
	  })) {
	    container = 'ogg';
	  }
	
	  return type + "/" + container + ";codecs=\"" + codecString + "\"";
	};
	
	exports.getMimeForCodec = getMimeForCodec;
	
	var browserSupportsCodec = function browserSupportsCodec(codecString) {
	  if (codecString === void 0) {
	    codecString = '';
	  }
	
	  return _window.default.MediaSource && _window.default.MediaSource.isTypeSupported && _window.default.MediaSource.isTypeSupported(getMimeForCodec(codecString)) || false;
	};
	
	exports.browserSupportsCodec = browserSupportsCodec;
	
	var muxerSupportsCodec = function muxerSupportsCodec(codecString) {
	  if (codecString === void 0) {
	    codecString = '';
	  }
	
	  return codecString.toLowerCase().split(',').every(function (codec) {
	    codec = codec.trim(); // any match is supported.
	
	    for (var i = 0; i < upperMediaTypes.length; i++) {
	      var type = upperMediaTypes[i];
	
	      if (regexs["muxer" + type].test(codec)) {
	        return true;
	      }
	    }
	
	    return false;
	  });
	};
	
	exports.muxerSupportsCodec = muxerSupportsCodec;
	var DEFAULT_AUDIO_CODEC = 'mp4a.40.2';
	exports.DEFAULT_AUDIO_CODEC = DEFAULT_AUDIO_CODEC;
	var DEFAULT_VIDEO_CODEC = 'avc1.4d400d';
	exports.DEFAULT_VIDEO_CODEC = DEFAULT_VIDEO_CODEC;

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isLikelyFmp4MediaSegment = exports.detectContainerForBytes = exports.isLikely = void 0;
	
	var _byteHelpers = __webpack_require__(476);
	
	var _mp4Helpers = __webpack_require__(1528);
	
	var _ebmlHelpers = __webpack_require__(1525);
	
	var _id3Helpers = __webpack_require__(1280);
	
	var _nalHelpers = __webpack_require__(1529);
	
	var CONSTANTS = {
	  // "webm" string literal in hex
	  'webm': (0, _byteHelpers.toUint8)([0x77, 0x65, 0x62, 0x6d]),
	  // "matroska" string literal in hex
	  'matroska': (0, _byteHelpers.toUint8)([0x6d, 0x61, 0x74, 0x72, 0x6f, 0x73, 0x6b, 0x61]),
	  // "fLaC" string literal in hex
	  'flac': (0, _byteHelpers.toUint8)([0x66, 0x4c, 0x61, 0x43]),
	  // "OggS" string literal in hex
	  'ogg': (0, _byteHelpers.toUint8)([0x4f, 0x67, 0x67, 0x53]),
	  // ac-3 sync byte, also works for ec-3 as that is simply a codec
	  // of ac-3
	  'ac3': (0, _byteHelpers.toUint8)([0x0b, 0x77]),
	  // "RIFF" string literal in hex used for wav and avi
	  'riff': (0, _byteHelpers.toUint8)([0x52, 0x49, 0x46, 0x46]),
	  // "AVI" string literal in hex
	  'avi': (0, _byteHelpers.toUint8)([0x41, 0x56, 0x49]),
	  // "WAVE" string literal in hex
	  'wav': (0, _byteHelpers.toUint8)([0x57, 0x41, 0x56, 0x45]),
	  // "ftyp3g" string literal in hex
	  '3gp': (0, _byteHelpers.toUint8)([0x66, 0x74, 0x79, 0x70, 0x33, 0x67]),
	  // "ftyp" string literal in hex
	  'mp4': (0, _byteHelpers.toUint8)([0x66, 0x74, 0x79, 0x70]),
	  // "styp" string literal in hex
	  'fmp4': (0, _byteHelpers.toUint8)([0x73, 0x74, 0x79, 0x70]),
	  // "ftypqt" string literal in hex
	  'mov': (0, _byteHelpers.toUint8)([0x66, 0x74, 0x79, 0x70, 0x71, 0x74]),
	  // moov string literal in hex
	  'moov': (0, _byteHelpers.toUint8)([0x6D, 0x6F, 0x6F, 0x76]),
	  // moof string literal in hex
	  'moof': (0, _byteHelpers.toUint8)([0x6D, 0x6F, 0x6F, 0x66])
	};
	var _isLikely = {
	  aac: function aac(bytes) {
	    var offset = (0, _id3Helpers.getId3Offset)(bytes);
	    return (0, _byteHelpers.bytesMatch)(bytes, [0xFF, 0x10], {
	      offset: offset,
	      mask: [0xFF, 0x16]
	    });
	  },
	  mp3: function mp3(bytes) {
	    var offset = (0, _id3Helpers.getId3Offset)(bytes);
	    return (0, _byteHelpers.bytesMatch)(bytes, [0xFF, 0x02], {
	      offset: offset,
	      mask: [0xFF, 0x06]
	    });
	  },
	  webm: function webm(bytes) {
	    var docType = (0, _ebmlHelpers.findEbml)(bytes, [_ebmlHelpers.EBML_TAGS.EBML, _ebmlHelpers.EBML_TAGS.DocType])[0]; // check if DocType EBML tag is webm
	
	    return (0, _byteHelpers.bytesMatch)(docType, CONSTANTS.webm);
	  },
	  mkv: function mkv(bytes) {
	    var docType = (0, _ebmlHelpers.findEbml)(bytes, [_ebmlHelpers.EBML_TAGS.EBML, _ebmlHelpers.EBML_TAGS.DocType])[0]; // check if DocType EBML tag is matroska
	
	    return (0, _byteHelpers.bytesMatch)(docType, CONSTANTS.matroska);
	  },
	  mp4: function mp4(bytes) {
	    // if this file is another base media file format, it is not mp4
	    if (_isLikely['3gp'](bytes) || _isLikely.mov(bytes)) {
	      return false;
	    } // if this file starts with a ftyp or styp box its mp4
	
	
	    if ((0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.mp4, {
	      offset: 4
	    }) || (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.fmp4, {
	      offset: 4
	    })) {
	      return true;
	    } // if this file starts with a moof/moov box its mp4
	
	
	    if ((0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.moof, {
	      offset: 4
	    }) || (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.moov, {
	      offset: 4
	    })) {
	      return true;
	    }
	  },
	  mov: function mov(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.mov, {
	      offset: 4
	    });
	  },
	  '3gp': function gp(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS['3gp'], {
	      offset: 4
	    });
	  },
	  ac3: function ac3(bytes) {
	    var offset = (0, _id3Helpers.getId3Offset)(bytes);
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.ac3, {
	      offset: offset
	    });
	  },
	  ts: function ts(bytes) {
	    if (bytes.length < 189 && bytes.length >= 1) {
	      return bytes[0] === 0x47;
	    }
	
	    var i = 0; // check the first 376 bytes for two matching sync bytes
	
	    while (i + 188 < bytes.length && i < 188) {
	      if (bytes[i] === 0x47 && bytes[i + 188] === 0x47) {
	        return true;
	      }
	
	      i += 1;
	    }
	
	    return false;
	  },
	  flac: function flac(bytes) {
	    var offset = (0, _id3Helpers.getId3Offset)(bytes);
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.flac, {
	      offset: offset
	    });
	  },
	  ogg: function ogg(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.ogg);
	  },
	  avi: function avi(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.riff) && (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.avi, {
	      offset: 8
	    });
	  },
	  wav: function wav(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.riff) && (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.wav, {
	      offset: 8
	    });
	  },
	  'h264': function h264(bytes) {
	    // find seq_parameter_set_rbsp
	    return (0, _nalHelpers.findH264Nal)(bytes, 7, 3).length;
	  },
	  'h265': function h265(bytes) {
	    // find video_parameter_set_rbsp or seq_parameter_set_rbsp
	    return (0, _nalHelpers.findH265Nal)(bytes, [32, 33], 3).length;
	  }
	}; // get all the isLikely functions
	// but make sure 'ts' is above h264 and h265
	// but below everything else as it is the least specific
	
	var isLikelyTypes = Object.keys(_isLikely) // remove ts, h264, h265
	.filter(function (t) {
	  return t !== 'ts' && t !== 'h264' && t !== 'h265';
	}) // add it back to the bottom
	.concat(['ts', 'h264', 'h265']); // make sure we are dealing with uint8 data.
	
	isLikelyTypes.forEach(function (type) {
	  var isLikelyFn = _isLikely[type];
	
	  _isLikely[type] = function (bytes) {
	    return isLikelyFn((0, _byteHelpers.toUint8)(bytes));
	  };
	}); // export after wrapping
	
	var isLikely = _isLikely; // A useful list of file signatures can be found here
	// https://en.wikipedia.org/wiki/List_of_file_signatures
	
	exports.isLikely = isLikely;
	
	var detectContainerForBytes = function detectContainerForBytes(bytes) {
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	
	  for (var i = 0; i < isLikelyTypes.length; i++) {
	    var type = isLikelyTypes[i];
	
	    if (isLikely[type](bytes)) {
	      return type;
	    }
	  }
	
	  return '';
	}; // fmp4 is not a container
	
	
	exports.detectContainerForBytes = detectContainerForBytes;
	
	var isLikelyFmp4MediaSegment = function isLikelyFmp4MediaSegment(bytes) {
	  return (0, _mp4Helpers.findBox)(bytes, ['moof']).length > 0;
	};
	
	exports.isLikelyFmp4MediaSegment = isLikelyFmp4MediaSegment;

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseData = exports.parseTracks = exports.decodeBlock = exports.findEbml = exports.EBML_TAGS = void 0;
	
	var _byteHelpers = __webpack_require__(476);
	
	var _codecHelpers = __webpack_require__(1278);
	
	// relevant specs for this parser:
	// https://matroska-org.github.io/libebml/specs.html
	// https://www.matroska.org/technical/elements.html
	// https://www.webmproject.org/docs/container/
	var EBML_TAGS = {
	  EBML: (0, _byteHelpers.toUint8)([0x1A, 0x45, 0xDF, 0xA3]),
	  DocType: (0, _byteHelpers.toUint8)([0x42, 0x82]),
	  Segment: (0, _byteHelpers.toUint8)([0x18, 0x53, 0x80, 0x67]),
	  SegmentInfo: (0, _byteHelpers.toUint8)([0x15, 0x49, 0xA9, 0x66]),
	  Tracks: (0, _byteHelpers.toUint8)([0x16, 0x54, 0xAE, 0x6B]),
	  Track: (0, _byteHelpers.toUint8)([0xAE]),
	  TrackNumber: (0, _byteHelpers.toUint8)([0xd7]),
	  DefaultDuration: (0, _byteHelpers.toUint8)([0x23, 0xe3, 0x83]),
	  TrackEntry: (0, _byteHelpers.toUint8)([0xAE]),
	  TrackType: (0, _byteHelpers.toUint8)([0x83]),
	  FlagDefault: (0, _byteHelpers.toUint8)([0x88]),
	  CodecID: (0, _byteHelpers.toUint8)([0x86]),
	  CodecPrivate: (0, _byteHelpers.toUint8)([0x63, 0xA2]),
	  VideoTrack: (0, _byteHelpers.toUint8)([0xe0]),
	  AudioTrack: (0, _byteHelpers.toUint8)([0xe1]),
	  // Not used yet, but will be used for live webm/mkv
	  // see https://www.matroska.org/technical/basics.html#block-structure
	  // see https://www.matroska.org/technical/basics.html#simpleblock-structure
	  Cluster: (0, _byteHelpers.toUint8)([0x1F, 0x43, 0xB6, 0x75]),
	  Timestamp: (0, _byteHelpers.toUint8)([0xE7]),
	  TimestampScale: (0, _byteHelpers.toUint8)([0x2A, 0xD7, 0xB1]),
	  BlockGroup: (0, _byteHelpers.toUint8)([0xA0]),
	  BlockDuration: (0, _byteHelpers.toUint8)([0x9B]),
	  Block: (0, _byteHelpers.toUint8)([0xA1]),
	  SimpleBlock: (0, _byteHelpers.toUint8)([0xA3])
	};
	/**
	 * This is a simple table to determine the length
	 * of things in ebml. The length is one based (starts at 1,
	 * rather than zero) and for every zero bit before a one bit
	 * we add one to length. We also need this table because in some
	 * case we have to xor all the length bits from another value.
	 */
	
	exports.EBML_TAGS = EBML_TAGS;
	var LENGTH_TABLE = [128, 64, 32, 16, 8, 4, 2, 1];
	
	var getLength = function getLength(byte) {
	  var len = 1;
	
	  for (var i = 0; i < LENGTH_TABLE.length; i++) {
	    if (byte & LENGTH_TABLE[i]) {
	      break;
	    }
	
	    len++;
	  }
	
	  return len;
	}; // length in ebml is stored in the first 4 to 8 bits
	// of the first byte. 4 for the id length and 8 for the
	// data size length. Length is measured by converting the number to binary
	// then 1 + the number of zeros before a 1 is encountered starting
	// from the left.
	
	
	var getvint = function getvint(bytes, offset, removeLength, signed) {
	  if (removeLength === void 0) {
	    removeLength = true;
	  }
	
	  if (signed === void 0) {
	    signed = false;
	  }
	
	  var length = getLength(bytes[offset]);
	  var valueBytes = bytes.subarray(offset, offset + length); // NOTE that we do **not** subarray here because we need to copy these bytes
	  // as they will be modified below to remove the dataSizeLen bits and we do not
	  // want to modify the original data. normally we could just call slice on
	  // uint8array but ie 11 does not support that...
	
	  if (removeLength) {
	    valueBytes = Array.prototype.slice.call(bytes, offset, offset + length);
	    valueBytes[0] ^= LENGTH_TABLE[length - 1];
	  }
	
	  return {
	    length: length,
	    value: (0, _byteHelpers.bytesToNumber)(valueBytes, {
	      signed: signed
	    }),
	    bytes: valueBytes
	  };
	};
	
	var normalizePath = function normalizePath(path) {
	  if (typeof path === 'string') {
	    return path.match(/.{1,2}/g).map(function (p) {
	      return normalizePath(p);
	    });
	  }
	
	  if (typeof path === 'number') {
	    return (0, _byteHelpers.numberToBytes)(path);
	  }
	
	  return path;
	};
	
	var normalizePaths = function normalizePaths(paths) {
	  if (!Array.isArray(paths)) {
	    return [normalizePath(paths)];
	  }
	
	  return paths.map(function (p) {
	    return normalizePath(p);
	  });
	};
	
	var getInfinityDataSize = function getInfinityDataSize(id, bytes, offset) {
	  if (offset >= bytes.length) {
	    return bytes.length;
	  }
	
	  var innerid = getvint(bytes, offset, false);
	
	  if ((0, _byteHelpers.bytesMatch)(id.bytes, innerid.bytes)) {
	    return offset;
	  }
	
	  var dataHeader = getvint(bytes, offset + innerid.length);
	  return getInfinityDataSize(id, bytes, offset + dataHeader.length + dataHeader.value + innerid.length);
	};
	/**
	 * Notes on the EBLM format.
	 *
	 * EBLM uses "vints" tags. Every vint tag contains
	 * two parts
	 *
	 * 1. The length from the first byte. You get this by
	 *    converting the byte to binary and counting the zeros
	 *    before a 1. Then you add 1 to that. Examples
	 *    00011111 = length 4 because there are 3 zeros before a 1.
	 *    00100000 = length 3 because there are 2 zeros before a 1.
	 *    00000011 = length 7 because there are 6 zeros before a 1.
	 *
	 * 2. The bits used for length are removed from the first byte
	 *    Then all the bytes are merged into a value. NOTE: this
	 *    is not the case for id ebml tags as there id includes
	 *    length bits.
	 *
	 */
	
	
	var findEbml = function findEbml(bytes, paths) {
	  paths = normalizePaths(paths);
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var results = [];
	
	  if (!paths.length) {
	    return results;
	  }
	
	  var i = 0;
	
	  while (i < bytes.length) {
	    var id = getvint(bytes, i, false);
	    var dataHeader = getvint(bytes, i + id.length);
	    var dataStart = i + id.length + dataHeader.length; // dataSize is unknown or this is a live stream
	
	    if (dataHeader.value === 0x7f) {
	      dataHeader.value = getInfinityDataSize(id, bytes, dataStart);
	
	      if (dataHeader.value !== bytes.length) {
	        dataHeader.value -= dataStart;
	      }
	    }
	
	    var dataEnd = dataStart + dataHeader.value > bytes.length ? bytes.length : dataStart + dataHeader.value;
	    var data = bytes.subarray(dataStart, dataEnd);
	
	    if ((0, _byteHelpers.bytesMatch)(paths[0], id.bytes)) {
	      if (paths.length === 1) {
	        // this is the end of the paths and we've found the tag we were
	        // looking for
	        results.push(data);
	      } else {
	        // recursively search for the next tag inside of the data
	        // of this one
	        results = results.concat(findEbml(data, paths.slice(1)));
	      }
	    }
	
	    var totalLength = id.length + dataHeader.length + data.length; // move past this tag entirely, we are not looking for it
	
	    i += totalLength;
	  }
	
	  return results;
	}; // see https://www.matroska.org/technical/basics.html#block-structure
	
	
	exports.findEbml = findEbml;
	
	var decodeBlock = function decodeBlock(block, type, timestampScale, clusterTimestamp) {
	  var duration;
	
	  if (type === 'group') {
	    duration = findEbml(block, [EBML_TAGS.BlockDuration])[0];
	
	    if (duration) {
	      duration = (0, _byteHelpers.bytesToNumber)(duration);
	      duration = 1 / timestampScale * duration * timestampScale / 1000;
	    }
	
	    block = findEbml(block, [EBML_TAGS.Block])[0];
	    type = 'block'; // treat data as a block after this point
	  }
	
	  var dv = new DataView(block.buffer, block.byteOffset, block.byteLength);
	  var trackNumber = getvint(block, 0);
	  var timestamp = dv.getInt16(trackNumber.length, false);
	  var flags = block[trackNumber.length + 2];
	  var data = block.subarray(trackNumber.length + 3); // pts/dts in seconds
	
	  var ptsdts = 1 / timestampScale * (clusterTimestamp + timestamp) * timestampScale / 1000; // return the frame
	
	  var parsed = {
	    duration: duration,
	    trackNumber: trackNumber.value,
	    keyframe: type === 'simple' && flags >> 7 === 1,
	    invisible: (flags & 0x08) >> 3 === 1,
	    lacing: (flags & 0x06) >> 1,
	    discardable: type === 'simple' && (flags & 0x01) === 1,
	    frames: [],
	    pts: ptsdts,
	    dts: ptsdts,
	    timestamp: timestamp
	  };
	
	  if (!parsed.lacing) {
	    parsed.frames.push(data);
	    return parsed;
	  }
	
	  var numberOfFrames = data[0] + 1;
	  var frameSizes = [];
	  var offset = 1; // Fixed
	
	  if (parsed.lacing === 2) {
	    var sizeOfFrame = (data.length - offset) / numberOfFrames;
	
	    for (var i = 0; i < numberOfFrames; i++) {
	      frameSizes.push(sizeOfFrame);
	    }
	  } // xiph
	
	
	  if (parsed.lacing === 1) {
	    for (var _i = 0; _i < numberOfFrames - 1; _i++) {
	      var size = 0;
	
	      do {
	        size += data[offset];
	        offset++;
	      } while (data[offset - 1] === 0xFF);
	
	      frameSizes.push(size);
	    }
	  } // ebml
	
	
	  if (parsed.lacing === 3) {
	    // first vint is unsinged
	    // after that vints are singed and
	    // based on a compounding size
	    var _size = 0;
	
	    for (var _i2 = 0; _i2 < numberOfFrames - 1; _i2++) {
	      var vint = _i2 === 0 ? getvint(data, offset) : getvint(data, offset, true, true);
	      _size += vint.value;
	      frameSizes.push(_size);
	      offset += vint.length;
	    }
	  }
	
	  frameSizes.forEach(function (size) {
	    parsed.frames.push(data.subarray(offset, offset + size));
	    offset += size;
	  });
	  return parsed;
	}; // VP9 Codec Feature Metadata (CodecPrivate)
	// https://www.webmproject.org/docs/container/
	
	
	exports.decodeBlock = decodeBlock;
	
	var parseVp9Private = function parseVp9Private(bytes) {
	  var i = 0;
	  var params = {};
	
	  while (i < bytes.length) {
	    var id = bytes[i] & 0x7f;
	    var len = bytes[i + 1];
	    var val = void 0;
	
	    if (len === 1) {
	      val = bytes[i + 2];
	    } else {
	      val = bytes.subarray(i + 2, i + 2 + len);
	    }
	
	    if (id === 1) {
	      params.profile = val;
	    } else if (id === 2) {
	      params.level = val;
	    } else if (id === 3) {
	      params.bitDepth = val;
	    } else if (id === 4) {
	      params.chromaSubsampling = val;
	    } else {
	      params[id] = val;
	    }
	
	    i += 2 + len;
	  }
	
	  return params;
	};
	
	var parseTracks = function parseTracks(bytes) {
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var decodedTracks = [];
	  var tracks = findEbml(bytes, [EBML_TAGS.Segment, EBML_TAGS.Tracks, EBML_TAGS.Track]);
	
	  if (!tracks.length) {
	    tracks = findEbml(bytes, [EBML_TAGS.Tracks, EBML_TAGS.Track]);
	  }
	
	  if (!tracks.length) {
	    tracks = findEbml(bytes, [EBML_TAGS.Track]);
	  }
	
	  if (!tracks.length) {
	    return decodedTracks;
	  }
	
	  tracks.forEach(function (track) {
	    var trackType = findEbml(track, EBML_TAGS.TrackType)[0];
	
	    if (!trackType || !trackType.length) {
	      return;
	    } // 1 is video, 2 is audio, 17 is subtitle
	    // other values are unimportant in this context
	
	
	    if (trackType[0] === 1) {
	      trackType = 'video';
	    } else if (trackType[0] === 2) {
	      trackType = 'audio';
	    } else if (trackType[0] === 17) {
	      trackType = 'subtitle';
	    } else {
	      return;
	    } // todo parse language
	
	
	    var decodedTrack = {
	      rawCodec: (0, _byteHelpers.bytesToString)(findEbml(track, [EBML_TAGS.CodecID])[0]),
	      type: trackType,
	      codecPrivate: findEbml(track, [EBML_TAGS.CodecPrivate])[0],
	      number: (0, _byteHelpers.bytesToNumber)(findEbml(track, [EBML_TAGS.TrackNumber])[0]),
	      defaultDuration: (0, _byteHelpers.bytesToNumber)(findEbml(track, [EBML_TAGS.DefaultDuration])[0]),
	      default: findEbml(track, [EBML_TAGS.FlagDefault])[0],
	      rawData: track
	    };
	    var codec = '';
	
	    if (/V_MPEG4\/ISO\/AVC/.test(decodedTrack.rawCodec)) {
	      codec = "avc1." + (0, _codecHelpers.getAvcCodec)(decodedTrack.codecPrivate);
	    } else if (/V_MPEGH\/ISO\/HEVC/.test(decodedTrack.rawCodec)) {
	      codec = "hev1." + (0, _codecHelpers.getHvcCodec)(decodedTrack.codecPrivate);
	    } else if (/V_MPEG4\/ISO\/ASP/.test(decodedTrack.rawCodec)) {
	      if (decodedTrack.codecPrivate) {
	        codec = 'mp4v.20.' + decodedTrack.codecPrivate[4].toString();
	      } else {
	        codec = 'mp4v.20.9';
	      }
	    } else if (/^V_THEORA/.test(decodedTrack.rawCodec)) {
	      codec = 'theora';
	    } else if (/^V_VP8/.test(decodedTrack.rawCodec)) {
	      codec = 'vp8';
	    } else if (/^V_VP9/.test(decodedTrack.rawCodec)) {
	      if (decodedTrack.codecPrivate) {
	        var _parseVp9Private = parseVp9Private(decodedTrack.codecPrivate),
	            profile = _parseVp9Private.profile,
	            level = _parseVp9Private.level,
	            bitDepth = _parseVp9Private.bitDepth,
	            chromaSubsampling = _parseVp9Private.chromaSubsampling;
	
	        codec = 'vp09.';
	        codec += (0, _byteHelpers.padStart)(profile, 2, '0') + ".";
	        codec += (0, _byteHelpers.padStart)(level, 2, '0') + ".";
	        codec += (0, _byteHelpers.padStart)(bitDepth, 2, '0') + ".";
	        codec += "" + (0, _byteHelpers.padStart)(chromaSubsampling, 2, '0'); // Video -> Colour -> Ebml name
	
	        var matrixCoefficients = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xB1]])[0] || [];
	        var videoFullRangeFlag = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xB9]])[0] || [];
	        var transferCharacteristics = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xBA]])[0] || [];
	        var colourPrimaries = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xBB]])[0] || []; // if we find any optional codec parameter specify them all.
	
	        if (matrixCoefficients.length || videoFullRangeFlag.length || transferCharacteristics.length || colourPrimaries.length) {
	          codec += "." + (0, _byteHelpers.padStart)(colourPrimaries[0], 2, '0');
	          codec += "." + (0, _byteHelpers.padStart)(transferCharacteristics[0], 2, '0');
	          codec += "." + (0, _byteHelpers.padStart)(matrixCoefficients[0], 2, '0');
	          codec += "." + (0, _byteHelpers.padStart)(videoFullRangeFlag[0], 2, '0');
	        }
	      } else {
	        codec = 'vp9';
	      }
	    } else if (/^V_AV1/.test(decodedTrack.rawCodec)) {
	      codec = "av01." + (0, _codecHelpers.getAv1Codec)(decodedTrack.codecPrivate);
	    } else if (/A_ALAC/.test(decodedTrack.rawCodec)) {
	      codec = 'alac';
	    } else if (/A_MPEG\/L2/.test(decodedTrack.rawCodec)) {
	      codec = 'mp2';
	    } else if (/A_MPEG\/L3/.test(decodedTrack.rawCodec)) {
	      codec = 'mp3';
	    } else if (/^A_AAC/.test(decodedTrack.rawCodec)) {
	      if (decodedTrack.codecPrivate) {
	        codec = 'mp4a.40.' + (decodedTrack.codecPrivate[0] >>> 3).toString();
	      } else {
	        codec = 'mp4a.40.2';
	      }
	    } else if (/^A_AC3/.test(decodedTrack.rawCodec)) {
	      codec = 'ac-3';
	    } else if (/^A_PCM/.test(decodedTrack.rawCodec)) {
	      codec = 'pcm';
	    } else if (/^A_MS\/ACM/.test(decodedTrack.rawCodec)) {
	      codec = 'speex';
	    } else if (/^A_EAC3/.test(decodedTrack.rawCodec)) {
	      codec = 'ec-3';
	    } else if (/^A_VORBIS/.test(decodedTrack.rawCodec)) {
	      codec = 'vorbis';
	    } else if (/^A_FLAC/.test(decodedTrack.rawCodec)) {
	      codec = 'flac';
	    } else if (/^A_OPUS/.test(decodedTrack.rawCodec)) {
	      codec = 'opus';
	    }
	
	    decodedTrack.codec = codec;
	    decodedTracks.push(decodedTrack);
	  });
	  return decodedTracks.sort(function (a, b) {
	    return a.number - b.number;
	  });
	};
	
	exports.parseTracks = parseTracks;
	
	var parseData = function parseData(data, tracks) {
	  var allBlocks = [];
	  var segment = findEbml(data, [EBML_TAGS.Segment])[0];
	  var timestampScale = findEbml(segment, [EBML_TAGS.SegmentInfo, EBML_TAGS.TimestampScale])[0]; // in nanoseconds, defaults to 1ms
	
	  if (timestampScale && timestampScale.length) {
	    timestampScale = (0, _byteHelpers.bytesToNumber)(timestampScale);
	  } else {
	    timestampScale = 1000000;
	  }
	
	  var clusters = findEbml(segment, [EBML_TAGS.Cluster]);
	
	  if (!tracks) {
	    tracks = parseTracks(segment);
	  }
	
	  clusters.forEach(function (cluster, ci) {
	    var simpleBlocks = findEbml(cluster, [EBML_TAGS.SimpleBlock]).map(function (b) {
	      return {
	        type: 'simple',
	        data: b
	      };
	    });
	    var blockGroups = findEbml(cluster, [EBML_TAGS.BlockGroup]).map(function (b) {
	      return {
	        type: 'group',
	        data: b
	      };
	    });
	    var timestamp = findEbml(cluster, [EBML_TAGS.Timestamp])[0] || 0;
	
	    if (timestamp && timestamp.length) {
	      timestamp = (0, _byteHelpers.bytesToNumber)(timestamp);
	    } // get all blocks then sort them into the correct order
	
	
	    var blocks = simpleBlocks.concat(blockGroups).sort(function (a, b) {
	      return a.data.byteOffset - b.data.byteOffset;
	    });
	    blocks.forEach(function (block, bi) {
	      var decoded = decodeBlock(block.data, block.type, timestampScale, timestamp);
	      allBlocks.push(decoded);
	    });
	  });
	  return {
	    tracks: tracks,
	    blocks: allBlocks
	  };
	};
	
	exports.parseData = parseData;

/***/ },
/* 1526 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forEachMediaGroup = void 0;
	
	/**
	 * Loops through all supported media groups in master and calls the provided
	 * callback for each group
	 *
	 * @param {Object} master
	 *        The parsed master manifest object
	 * @param {string[]} groups
	 *        The media groups to call the callback for
	 * @param {Function} callback
	 *        Callback to call for each media group
	 */
	var forEachMediaGroup = function forEachMediaGroup(master, groups, callback) {
	  groups.forEach(function (mediaType) {
	    for (var groupKey in master.mediaGroups[mediaType]) {
	      for (var labelKey in master.mediaGroups[mediaType][groupKey]) {
	        var mediaProperties = master.mediaGroups[mediaType][groupKey][labelKey];
	        callback(mediaProperties, mediaType, groupKey, labelKey);
	      }
	    }
	  });
	};
	
	exports.forEachMediaGroup = forEachMediaGroup;

/***/ },
/* 1527 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.simpleTypeFromSourceType = void 0;
	var MPEGURL_REGEX = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i;
	var DASH_REGEX = /^application\/dash\+xml/i;
	/**
	 * Returns a string that describes the type of source based on a video source object's
	 * media type.
	 *
	 * @see {@link https://dev.w3.org/html5/pf-summary/video.html#dom-source-type|Source Type}
	 *
	 * @param {string} type
	 *        Video source object media type
	 * @return {('hls'|'dash'|'vhs-json'|null)}
	 *         VHS source type string
	 */
	
	var simpleTypeFromSourceType = function simpleTypeFromSourceType(type) {
	  if (MPEGURL_REGEX.test(type)) {
	    return 'hls';
	  }
	
	  if (DASH_REGEX.test(type)) {
	    return 'dash';
	  } // Denotes the special case of a manifest object passed to http-streaming instead of a
	  // source URL.
	  //
	  // See https://en.wikipedia.org/wiki/Media_type for details on specifying media types.
	  //
	  // In this case, vnd stands for vendor, video.js for the organization, VHS for this
	  // project, and the +json suffix identifies the structure of the media type.
	
	
	  if (type === 'application/vnd.videojs.vhs+json') {
	    return 'vhs-json';
	  }
	
	  return null;
	};
	
	exports.simpleTypeFromSourceType = simpleTypeFromSourceType;

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseMediaInfo = exports.parseTracks = exports.addSampleDescription = exports.buildFrameTable = exports.findNamedBox = exports.findBox = exports.parseDescriptors = void 0;
	
	var _byteHelpers = __webpack_require__(476);
	
	var _codecHelpers = __webpack_require__(1278);
	
	var _opusHelpers = __webpack_require__(1530);
	
	var normalizePath = function normalizePath(path) {
	  if (typeof path === 'string') {
	    return (0, _byteHelpers.stringToBytes)(path);
	  }
	
	  if (typeof path === 'number') {
	    return path;
	  }
	
	  return path;
	};
	
	var normalizePaths = function normalizePaths(paths) {
	  if (!Array.isArray(paths)) {
	    return [normalizePath(paths)];
	  }
	
	  return paths.map(function (p) {
	    return normalizePath(p);
	  });
	};
	
	var DESCRIPTORS;
	
	var parseDescriptors = function parseDescriptors(bytes) {
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var results = [];
	  var i = 0;
	
	  while (bytes.length > i) {
	    var tag = bytes[i];
	    var size = 0;
	    var headerSize = 0; // tag
	
	    headerSize++;
	    var byte = bytes[headerSize]; // first byte
	
	    headerSize++;
	
	    while (byte & 0x80) {
	      size = (byte & 0x7F) << 7;
	      byte = bytes[headerSize];
	      headerSize++;
	    }
	
	    size += byte & 0x7F;
	
	    for (var z = 0; z < DESCRIPTORS.length; z++) {
	      var _DESCRIPTORS$z = DESCRIPTORS[z],
	          id = _DESCRIPTORS$z.id,
	          parser = _DESCRIPTORS$z.parser;
	
	      if (tag === id) {
	        results.push(parser(bytes.subarray(headerSize, headerSize + size)));
	        break;
	      }
	    }
	
	    i += size + headerSize;
	  }
	
	  return results;
	};
	
	exports.parseDescriptors = parseDescriptors;
	DESCRIPTORS = [{
	  id: 0x03,
	  parser: function parser(bytes) {
	    var desc = {
	      tag: 0x03,
	      id: bytes[0] << 8 | bytes[1],
	      flags: bytes[2],
	      size: 3,
	      dependsOnEsId: 0,
	      ocrEsId: 0,
	      descriptors: [],
	      url: ''
	    }; // depends on es id
	
	    if (desc.flags & 0x80) {
	      desc.dependsOnEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
	      desc.size += 2;
	    } // url
	
	
	    if (desc.flags & 0x40) {
	      var len = bytes[desc.size];
	      desc.url = (0, _byteHelpers.bytesToString)(bytes.subarray(desc.size + 1, desc.size + 1 + len));
	      desc.size += len;
	    } // ocr es id
	
	
	    if (desc.flags & 0x20) {
	      desc.ocrEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
	      desc.size += 2;
	    }
	
	    desc.descriptors = parseDescriptors(bytes.subarray(desc.size)) || [];
	    return desc;
	  }
	}, {
	  id: 0x04,
	  parser: function parser(bytes) {
	    // DecoderConfigDescriptor
	    var desc = {
	      tag: 0x04,
	      oti: bytes[0],
	      streamType: bytes[1],
	      bufferSize: bytes[2] << 16 | bytes[3] << 8 | bytes[4],
	      maxBitrate: bytes[5] << 24 | bytes[6] << 16 | bytes[7] << 8 | bytes[8],
	      avgBitrate: bytes[9] << 24 | bytes[10] << 16 | bytes[11] << 8 | bytes[12],
	      descriptors: parseDescriptors(bytes.subarray(13))
	    };
	    return desc;
	  }
	}, {
	  id: 0x05,
	  parser: function parser(bytes) {
	    // DecoderSpecificInfo
	    return {
	      tag: 0x05,
	      bytes: bytes
	    };
	  }
	}, {
	  id: 0x06,
	  parser: function parser(bytes) {
	    // SLConfigDescriptor
	    return {
	      tag: 0x06,
	      bytes: bytes
	    };
	  }
	}];
	/**
	 * find any number of boxes by name given a path to it in an iso bmff
	 * such as mp4.
	 *
	 * @param {TypedArray} bytes
	 *        bytes for the iso bmff to search for boxes in
	 *
	 * @param {Uint8Array[]|string[]|string|Uint8Array} name
	 *        An array of paths or a single path representing the name
	 *        of boxes to search through in bytes. Paths may be
	 *        uint8 (character codes) or strings.
	 *
	 * @param {boolean} [complete=false]
	 *        Should we search only for complete boxes on the final path.
	 *        This is very useful when you do not want to get back partial boxes
	 *        in the case of streaming files.
	 *
	 * @return {Uint8Array[]}
	 *         An array of the end paths that we found.
	 */
	
	var findBox = function findBox(bytes, paths, complete) {
	  if (complete === void 0) {
	    complete = false;
	  }
	
	  paths = normalizePaths(paths);
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var results = [];
	
	  if (!paths.length) {
	    // short-circuit the search for empty paths
	    return results;
	  }
	
	  var i = 0;
	
	  while (i < bytes.length) {
	    var size = (bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]) >>> 0;
	    var type = bytes.subarray(i + 4, i + 8); // invalid box format.
	
	    if (size === 0) {
	      break;
	    }
	
	    var end = i + size;
	
	    if (end > bytes.length) {
	      // this box is bigger than the number of bytes we have
	      // and complete is set, we cannot find any more boxes.
	      if (complete) {
	        break;
	      }
	
	      end = bytes.length;
	    }
	
	    var data = bytes.subarray(i + 8, end);
	
	    if ((0, _byteHelpers.bytesMatch)(type, paths[0])) {
	      if (paths.length === 1) {
	        // this is the end of the path and we've found the box we were
	        // looking for
	        results.push(data);
	      } else {
	        // recursively search for the next box along the path
	        results.push.apply(results, findBox(data, paths.slice(1), complete));
	      }
	    }
	
	    i = end;
	  } // we've finished searching all of bytes
	
	
	  return results;
	};
	/**
	 * Search for a single matching box by name in an iso bmff format like
	 * mp4. This function is useful for finding codec boxes which
	 * can be placed arbitrarily in sample descriptions depending
	 * on the version of the file or file type.
	 *
	 * @param {TypedArray} bytes
	 *        bytes for the iso bmff to search for boxes in
	 *
	 * @param {string|Uint8Array} name
	 *        The name of the box to find.
	 *
	 * @return {Uint8Array[]}
	 *         a subarray of bytes representing the name boxed we found.
	 */
	
	
	exports.findBox = findBox;
	
	var findNamedBox = function findNamedBox(bytes, name) {
	  name = normalizePath(name);
	
	  if (!name.length) {
	    // short-circuit the search for empty paths
	    return bytes.subarray(bytes.length);
	  }
	
	  var i = 0;
	
	  while (i < bytes.length) {
	    if ((0, _byteHelpers.bytesMatch)(bytes.subarray(i, i + name.length), name)) {
	      var size = (bytes[i - 4] << 24 | bytes[i - 3] << 16 | bytes[i - 2] << 8 | bytes[i - 1]) >>> 0;
	      var end = size > 1 ? i + size : bytes.byteLength;
	      return bytes.subarray(i + 4, end);
	    }
	
	    i++;
	  } // we've finished searching all of bytes
	
	
	  return bytes.subarray(bytes.length);
	};
	
	exports.findNamedBox = findNamedBox;
	
	var parseSamples = function parseSamples(data, entrySize, parseEntry) {
	  if (entrySize === void 0) {
	    entrySize = 4;
	  }
	
	  if (parseEntry === void 0) {
	    parseEntry = function parseEntry(d) {
	      return (0, _byteHelpers.bytesToNumber)(d);
	    };
	  }
	
	  var entries = [];
	
	  if (!data || !data.length) {
	    return entries;
	  }
	
	  var entryCount = (0, _byteHelpers.bytesToNumber)(data.subarray(4, 8));
	
	  for (var i = 8; entryCount; i += entrySize, entryCount--) {
	    entries.push(parseEntry(data.subarray(i, i + entrySize)));
	  }
	
	  return entries;
	};
	
	var buildFrameTable = function buildFrameTable(stbl, timescale) {
	  var keySamples = parseSamples(findBox(stbl, ['stss'])[0]);
	  var chunkOffsets = parseSamples(findBox(stbl, ['stco'])[0]);
	  var timeToSamples = parseSamples(findBox(stbl, ['stts'])[0], 8, function (entry) {
	    return {
	      sampleCount: (0, _byteHelpers.bytesToNumber)(entry.subarray(0, 4)),
	      sampleDelta: (0, _byteHelpers.bytesToNumber)(entry.subarray(4, 8))
	    };
	  });
	  var samplesToChunks = parseSamples(findBox(stbl, ['stsc'])[0], 12, function (entry) {
	    return {
	      firstChunk: (0, _byteHelpers.bytesToNumber)(entry.subarray(0, 4)),
	      samplesPerChunk: (0, _byteHelpers.bytesToNumber)(entry.subarray(4, 8)),
	      sampleDescriptionIndex: (0, _byteHelpers.bytesToNumber)(entry.subarray(8, 12))
	    };
	  });
	  var stsz = findBox(stbl, ['stsz'])[0]; // stsz starts with a 4 byte sampleSize which we don't need
	
	  var sampleSizes = parseSamples(stsz && stsz.length && stsz.subarray(4) || null);
	  var frames = [];
	
	  for (var chunkIndex = 0; chunkIndex < chunkOffsets.length; chunkIndex++) {
	    var samplesInChunk = void 0;
	
	    for (var i = 0; i < samplesToChunks.length; i++) {
	      var sampleToChunk = samplesToChunks[i];
	      var isThisOne = chunkIndex + 1 >= sampleToChunk.firstChunk && (i + 1 >= samplesToChunks.length || chunkIndex + 1 < samplesToChunks[i + 1].firstChunk);
	
	      if (isThisOne) {
	        samplesInChunk = sampleToChunk.samplesPerChunk;
	        break;
	      }
	    }
	
	    var chunkOffset = chunkOffsets[chunkIndex];
	
	    for (var _i = 0; _i < samplesInChunk; _i++) {
	      var frameEnd = sampleSizes[frames.length]; // if we don't have key samples every frame is a keyframe
	
	      var keyframe = !keySamples.length;
	
	      if (keySamples.length && keySamples.indexOf(frames.length + 1) !== -1) {
	        keyframe = true;
	      }
	
	      var frame = {
	        keyframe: keyframe,
	        start: chunkOffset,
	        end: chunkOffset + frameEnd
	      };
	
	      for (var k = 0; k < timeToSamples.length; k++) {
	        var _timeToSamples$k = timeToSamples[k],
	            sampleCount = _timeToSamples$k.sampleCount,
	            sampleDelta = _timeToSamples$k.sampleDelta;
	
	        if (frames.length <= sampleCount) {
	          // ms to ns
	          var lastTimestamp = frames.length ? frames[frames.length - 1].timestamp : 0;
	          frame.timestamp = lastTimestamp + sampleDelta / timescale * 1000;
	          frame.duration = sampleDelta;
	          break;
	        }
	      }
	
	      frames.push(frame);
	      chunkOffset += frameEnd;
	    }
	  }
	
	  return frames;
	};
	
	exports.buildFrameTable = buildFrameTable;
	
	var addSampleDescription = function addSampleDescription(track, bytes) {
	  var codec = (0, _byteHelpers.bytesToString)(bytes.subarray(0, 4));
	
	  if (track.type === 'video') {
	    track.info = track.info || {};
	    track.info.width = bytes[28] << 8 | bytes[29];
	    track.info.height = bytes[30] << 8 | bytes[31];
	  } else if (track.type === 'audio') {
	    track.info = track.info || {};
	    track.info.channels = bytes[20] << 8 | bytes[21];
	    track.info.bitDepth = bytes[22] << 8 | bytes[23];
	    track.info.sampleRate = bytes[28] << 8 | bytes[29];
	  }
	
	  if (codec === 'avc1') {
	    var avcC = findNamedBox(bytes, 'avcC'); // AVCDecoderConfigurationRecord
	
	    codec += "." + (0, _codecHelpers.getAvcCodec)(avcC);
	    track.info.avcC = avcC; // TODO: do we need to parse all this?
	
	    /* {
	      configurationVersion: avcC[0],
	      profile: avcC[1],
	      profileCompatibility: avcC[2],
	      level: avcC[3],
	      lengthSizeMinusOne: avcC[4] & 0x3
	    };
	     let spsNalUnitCount = avcC[5] & 0x1F;
	    const spsNalUnits = track.info.avc.spsNalUnits = [];
	     // past spsNalUnitCount
	    let offset = 6;
	     while (spsNalUnitCount--) {
	      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
	       spsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
	       offset += nalLen + 2;
	    }
	    let ppsNalUnitCount = avcC[offset];
	    const ppsNalUnits = track.info.avc.ppsNalUnits = [];
	     // past ppsNalUnitCount
	    offset += 1;
	     while (ppsNalUnitCount--) {
	      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
	       ppsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
	       offset += nalLen + 2;
	    }*/
	    // HEVCDecoderConfigurationRecord
	  } else if (codec === 'hvc1' || codec === 'hev1') {
	    codec += "." + (0, _codecHelpers.getHvcCodec)(findNamedBox(bytes, 'hvcC'));
	  } else if (codec === 'mp4a' || codec === 'mp4v') {
	    var esds = findNamedBox(bytes, 'esds');
	    var esDescriptor = parseDescriptors(esds.subarray(4))[0];
	    var decoderConfig = esDescriptor && esDescriptor.descriptors.filter(function (_ref) {
	      var tag = _ref.tag;
	      return tag === 0x04;
	    })[0];
	
	    if (decoderConfig) {
	      // most codecs do not have a further '.'
	      // such as 0xa5 for ac-3 and 0xa6 for e-ac-3
	      codec += '.' + (0, _byteHelpers.toHexString)(decoderConfig.oti);
	
	      if (decoderConfig.oti === 0x40) {
	        codec += '.' + (decoderConfig.descriptors[0].bytes[0] >> 3).toString();
	      } else if (decoderConfig.oti === 0x20) {
	        codec += '.' + decoderConfig.descriptors[0].bytes[4].toString();
	      } else if (decoderConfig.oti === 0xdd) {
	        codec = 'vorbis';
	      }
	    } else if (track.type === 'audio') {
	      codec += '.40.2';
	    } else {
	      codec += '.20.9';
	    }
	  } else if (codec === 'av01') {
	    // AV1DecoderConfigurationRecord
	    codec += "." + (0, _codecHelpers.getAv1Codec)(findNamedBox(bytes, 'av1C'));
	  } else if (codec === 'vp09') {
	    // VPCodecConfigurationRecord
	    var vpcC = findNamedBox(bytes, 'vpcC'); // https://www.webmproject.org/vp9/mp4/
	
	    var profile = vpcC[0];
	    var level = vpcC[1];
	    var bitDepth = vpcC[2] >> 4;
	    var chromaSubsampling = (vpcC[2] & 0x0F) >> 1;
	    var videoFullRangeFlag = (vpcC[2] & 0x0F) >> 3;
	    var colourPrimaries = vpcC[3];
	    var transferCharacteristics = vpcC[4];
	    var matrixCoefficients = vpcC[5];
	    codec += "." + (0, _byteHelpers.padStart)(profile, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(level, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(bitDepth, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(chromaSubsampling, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(colourPrimaries, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(transferCharacteristics, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(matrixCoefficients, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(videoFullRangeFlag, 2, '0');
	  } else if (codec === 'theo') {
	    codec = 'theora';
	  } else if (codec === 'spex') {
	    codec = 'speex';
	  } else if (codec === '.mp3') {
	    codec = 'mp4a.40.34';
	  } else if (codec === 'msVo') {
	    codec = 'vorbis';
	  } else if (codec === 'Opus') {
	    codec = 'opus';
	    var dOps = findNamedBox(bytes, 'dOps');
	    track.info.opus = (0, _opusHelpers.parseOpusHead)(dOps); // TODO: should this go into the webm code??
	    // Firefox requires a codecDelay for opus playback
	    // see https://bugzilla.mozilla.org/show_bug.cgi?id=1276238
	
	    track.info.codecDelay = 6500000;
	  } else {
	    codec = codec.toLowerCase();
	  }
	  /* eslint-enable */
	  // flac, ac-3, ec-3, opus
	
	
	  track.codec = codec;
	};
	
	exports.addSampleDescription = addSampleDescription;
	
	var parseTracks = function parseTracks(bytes, frameTable) {
	  if (frameTable === void 0) {
	    frameTable = true;
	  }
	
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var traks = findBox(bytes, ['moov', 'trak'], true);
	  var tracks = [];
	  traks.forEach(function (trak) {
	    var track = {
	      bytes: trak
	    };
	    var mdia = findBox(trak, ['mdia'])[0];
	    var hdlr = findBox(mdia, ['hdlr'])[0];
	    var trakType = (0, _byteHelpers.bytesToString)(hdlr.subarray(8, 12));
	
	    if (trakType === 'soun') {
	      track.type = 'audio';
	    } else if (trakType === 'vide') {
	      track.type = 'video';
	    } else {
	      track.type = trakType;
	    }
	
	    var tkhd = findBox(trak, ['tkhd'])[0];
	
	    if (tkhd) {
	      var view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
	      var tkhdVersion = view.getUint8(0);
	      track.number = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
	    }
	
	    var mdhd = findBox(mdia, ['mdhd'])[0];
	
	    if (mdhd) {
	      // mdhd is a FullBox, meaning it will have its own version as the first byte
	      var version = mdhd[0];
	      var index = version === 0 ? 12 : 20;
	      track.timescale = (mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]) >>> 0;
	    }
	
	    var stbl = findBox(mdia, ['minf', 'stbl'])[0];
	    var stsd = findBox(stbl, ['stsd'])[0];
	    var descriptionCount = (0, _byteHelpers.bytesToNumber)(stsd.subarray(4, 8));
	    var offset = 8; // add codec and codec info
	
	    while (descriptionCount--) {
	      var len = (0, _byteHelpers.bytesToNumber)(stsd.subarray(offset, offset + 4));
	      var sampleDescriptor = stsd.subarray(offset + 4, offset + 4 + len);
	      addSampleDescription(track, sampleDescriptor);
	      offset += 4 + len;
	    }
	
	    if (frameTable) {
	      track.frameTable = buildFrameTable(stbl, track.timescale);
	    } // codec has no sub parameters
	
	
	    tracks.push(track);
	  });
	  return tracks;
	};
	
	exports.parseTracks = parseTracks;
	
	var parseMediaInfo = function parseMediaInfo(bytes) {
	  var mvhd = findBox(bytes, ['moov', 'mvhd'], true)[0];
	
	  if (!mvhd || !mvhd.length) {
	    return;
	  }
	
	  var info = {}; // ms to ns
	  // mvhd v1 has 8 byte duration and other fields too
	
	  if (mvhd[0] === 1) {
	    info.timestampScale = (0, _byteHelpers.bytesToNumber)(mvhd.subarray(20, 24));
	    info.duration = (0, _byteHelpers.bytesToNumber)(mvhd.subarray(24, 32));
	  } else {
	    info.timestampScale = (0, _byteHelpers.bytesToNumber)(mvhd.subarray(12, 16));
	    info.duration = (0, _byteHelpers.bytesToNumber)(mvhd.subarray(16, 20));
	  }
	
	  info.bytes = mvhd;
	  return info;
	};
	
	exports.parseMediaInfo = parseMediaInfo;

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findH265Nal = exports.findH264Nal = exports.findNal = exports.discardEmulationPreventionBytes = exports.EMULATION_PREVENTION = exports.NAL_TYPE_TWO = exports.NAL_TYPE_ONE = void 0;
	
	var _byteHelpers = __webpack_require__(476);
	
	var NAL_TYPE_ONE = (0, _byteHelpers.toUint8)([0x00, 0x00, 0x00, 0x01]);
	exports.NAL_TYPE_ONE = NAL_TYPE_ONE;
	var NAL_TYPE_TWO = (0, _byteHelpers.toUint8)([0x00, 0x00, 0x01]);
	exports.NAL_TYPE_TWO = NAL_TYPE_TWO;
	var EMULATION_PREVENTION = (0, _byteHelpers.toUint8)([0x00, 0x00, 0x03]);
	/**
	 * Expunge any "Emulation Prevention" bytes from a "Raw Byte
	 * Sequence Payload"
	 *
	 * @param data {Uint8Array} the bytes of a RBSP from a NAL
	 * unit
	 * @return {Uint8Array} the RBSP without any Emulation
	 * Prevention Bytes
	 */
	
	exports.EMULATION_PREVENTION = EMULATION_PREVENTION;
	
	var discardEmulationPreventionBytes = function discardEmulationPreventionBytes(bytes) {
	  var positions = [];
	  var i = 1; // Find all `Emulation Prevention Bytes`
	
	  while (i < bytes.length - 2) {
	    if ((0, _byteHelpers.bytesMatch)(bytes.subarray(i, i + 3), EMULATION_PREVENTION)) {
	      positions.push(i + 2);
	      i++;
	    }
	
	    i++;
	  } // If no Emulation Prevention Bytes were found just return the original
	  // array
	
	
	  if (positions.length === 0) {
	    return bytes;
	  } // Create a new array to hold the NAL unit data
	
	
	  var newLength = bytes.length - positions.length;
	  var newData = new Uint8Array(newLength);
	  var sourceIndex = 0;
	
	  for (i = 0; i < newLength; sourceIndex++, i++) {
	    if (sourceIndex === positions[0]) {
	      // Skip this byte
	      sourceIndex++; // Remove this position index
	
	      positions.shift();
	    }
	
	    newData[i] = bytes[sourceIndex];
	  }
	
	  return newData;
	};
	
	exports.discardEmulationPreventionBytes = discardEmulationPreventionBytes;
	
	var findNal = function findNal(bytes, dataType, types, nalLimit) {
	  if (nalLimit === void 0) {
	    nalLimit = Infinity;
	  }
	
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  types = [].concat(types);
	  var i = 0;
	  var nalStart;
	  var nalsFound = 0; // keep searching until:
	  // we reach the end of bytes
	  // we reach the maximum number of nals they want to seach
	  // NOTE: that we disregard nalLimit when we have found the start
	  // of the nal we want so that we can find the end of the nal we want.
	
	  while (i < bytes.length && (nalsFound < nalLimit || nalStart)) {
	    var nalOffset = void 0;
	
	    if ((0, _byteHelpers.bytesMatch)(bytes.subarray(i), NAL_TYPE_ONE)) {
	      nalOffset = 4;
	    } else if ((0, _byteHelpers.bytesMatch)(bytes.subarray(i), NAL_TYPE_TWO)) {
	      nalOffset = 3;
	    } // we are unsynced,
	    // find the next nal unit
	
	
	    if (!nalOffset) {
	      i++;
	      continue;
	    }
	
	    nalsFound++;
	
	    if (nalStart) {
	      return discardEmulationPreventionBytes(bytes.subarray(nalStart, i));
	    }
	
	    var nalType = void 0;
	
	    if (dataType === 'h264') {
	      nalType = bytes[i + nalOffset] & 0x1f;
	    } else if (dataType === 'h265') {
	      nalType = bytes[i + nalOffset] >> 1 & 0x3f;
	    }
	
	    if (types.indexOf(nalType) !== -1) {
	      nalStart = i + nalOffset;
	    } // nal header is 1 length for h264, and 2 for h265
	
	
	    i += nalOffset + (dataType === 'h264' ? 1 : 2);
	  }
	
	  return bytes.subarray(0, 0);
	};
	
	exports.findNal = findNal;
	
	var findH264Nal = function findH264Nal(bytes, type, nalLimit) {
	  return findNal(bytes, 'h264', type, nalLimit);
	};
	
	exports.findH264Nal = findH264Nal;
	
	var findH265Nal = function findH265Nal(bytes, type, nalLimit) {
	  return findNal(bytes, 'h265', type, nalLimit);
	};
	
	exports.findH265Nal = findH265Nal;

/***/ },
/* 1530 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setOpusHead = exports.parseOpusHead = exports.OPUS_HEAD = void 0;
	var OPUS_HEAD = new Uint8Array([// O, p, u, s
	0x4f, 0x70, 0x75, 0x73, // H, e, a, d
	0x48, 0x65, 0x61, 0x64]); // https://wiki.xiph.org/OggOpus
	// https://vfrmaniac.fushizen.eu/contents/opus_in_isobmff.html
	// https://opus-codec.org/docs/opusfile_api-0.7/structOpusHead.html
	
	exports.OPUS_HEAD = OPUS_HEAD;
	
	var parseOpusHead = function parseOpusHead(bytes) {
	  var view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
	  var version = view.getUint8(0); // version 0, from mp4, does not use littleEndian.
	
	  var littleEndian = version !== 0;
	  var config = {
	    version: version,
	    channels: view.getUint8(1),
	    preSkip: view.getUint16(2, littleEndian),
	    sampleRate: view.getUint32(4, littleEndian),
	    outputGain: view.getUint16(8, littleEndian),
	    channelMappingFamily: view.getUint8(10)
	  };
	
	  if (config.channelMappingFamily > 0 && bytes.length > 10) {
	    config.streamCount = view.getUint8(11);
	    config.twoChannelStreamCount = view.getUint8(12);
	    config.channelMapping = [];
	
	    for (var c = 0; c < config.channels; c++) {
	      config.channelMapping.push(view.getUint8(13 + c));
	    }
	  }
	
	  return config;
	};
	
	exports.parseOpusHead = parseOpusHead;
	
	var setOpusHead = function setOpusHead(config) {
	  var size = config.channelMappingFamily <= 0 ? 11 : 12 + config.channels;
	  var view = new DataView(new ArrayBuffer(size));
	  var littleEndian = config.version !== 0;
	  view.setUint8(0, config.version);
	  view.setUint8(1, config.channels);
	  view.setUint16(2, config.preSkip, littleEndian);
	  view.setUint32(4, config.sampleRate, littleEndian);
	  view.setUint16(8, config.outputGain, littleEndian);
	  view.setUint8(10, config.channelMappingFamily);
	
	  if (config.channelMappingFamily > 0) {
	    view.setUint8(11, config.streamCount);
	    config.channelMapping.foreach(function (cm, i) {
	      view.setUint8(12 + i, cm);
	    });
	  }
	
	  return new Uint8Array(view.buffer);
	};
	
	exports.setOpusHead = setOpusHead;

/***/ },
/* 1531 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * @file stream.js
	 */
	
	/**
	 * A lightweight readable stream implemention that handles event dispatching.
	 *
	 * @class Stream
	 */
	var Stream = /*#__PURE__*/function () {
	  function Stream() {
	    this.listeners = {};
	  }
	  /**
	   * Add a listener for a specified event type.
	   *
	   * @param {string} type the event name
	   * @param {Function} listener the callback to be invoked when an event of
	   * the specified type occurs
	   */
	
	
	  var _proto = Stream.prototype;
	
	  _proto.on = function on(type, listener) {
	    if (!this.listeners[type]) {
	      this.listeners[type] = [];
	    }
	
	    this.listeners[type].push(listener);
	  }
	  /**
	   * Remove a listener for a specified event type.
	   *
	   * @param {string} type the event name
	   * @param {Function} listener  a function previously registered for this
	   * type of event through `on`
	   * @return {boolean} if we could turn it off or not
	   */
	  ;
	
	  _proto.off = function off(type, listener) {
	    if (!this.listeners[type]) {
	      return false;
	    }
	
	    var index = this.listeners[type].indexOf(listener); // TODO: which is better?
	    // In Video.js we slice listener functions
	    // on trigger so that it does not mess up the order
	    // while we loop through.
	    //
	    // Here we slice on off so that the loop in trigger
	    // can continue using it's old reference to loop without
	    // messing up the order.
	
	    this.listeners[type] = this.listeners[type].slice(0);
	    this.listeners[type].splice(index, 1);
	    return index > -1;
	  }
	  /**
	   * Trigger an event of the specified type on this stream. Any additional
	   * arguments to this function are passed as parameters to event listeners.
	   *
	   * @param {string} type the event name
	   */
	  ;
	
	  _proto.trigger = function trigger(type) {
	    var callbacks = this.listeners[type];
	
	    if (!callbacks) {
	      return;
	    } // Slicing the arguments on every invocation of this method
	    // can add a significant amount of overhead. Avoid the
	    // intermediate object creation for the common case of a
	    // single callback argument
	
	
	    if (arguments.length === 2) {
	      var length = callbacks.length;
	
	      for (var i = 0; i < length; ++i) {
	        callbacks[i].call(this, arguments[1]);
	      }
	    } else {
	      var args = Array.prototype.slice.call(arguments, 1);
	      var _length = callbacks.length;
	
	      for (var _i = 0; _i < _length; ++_i) {
	        callbacks[_i].apply(this, args);
	      }
	    }
	  }
	  /**
	   * Destroys the stream and cleans up.
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.listeners = {};
	  }
	  /**
	   * Forwards all `data` events on this stream to the destination stream. The
	   * destination stream should provide a method `push` to receive the data
	   * events as they arrive.
	   *
	   * @param {Stream} destination the stream that will receive all `data` events
	   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	   */
	  ;
	
	  _proto.pipe = function pipe(destination) {
	    this.on('data', function (data) {
	      destination.push(data);
	    });
	  };
	
	  return Stream;
	}();
	
	exports.default = Stream;
	module.exports = exports.default;

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var window = __webpack_require__(344);
	
	var httpResponseHandler = function httpResponseHandler(callback, decodeResponseBody) {
	  if (decodeResponseBody === void 0) {
	    decodeResponseBody = false;
	  }
	
	  return function (err, response, responseBody) {
	    // if the XHR failed, return that error
	    if (err) {
	      callback(err);
	      return;
	    } // if the HTTP status code is 4xx or 5xx, the request also failed
	
	
	    if (response.statusCode >= 400 && response.statusCode <= 599) {
	      var cause = responseBody;
	
	      if (decodeResponseBody) {
	        if (window.TextDecoder) {
	          var charset = getCharset(response.headers && response.headers['content-type']);
	
	          try {
	            cause = new TextDecoder(charset).decode(responseBody);
	          } catch (e) {}
	        } else {
	          cause = String.fromCharCode.apply(null, new Uint8Array(responseBody));
	        }
	      }
	
	      callback({
	        cause: cause
	      });
	      return;
	    } // otherwise, request succeeded
	
	
	    callback(null, responseBody);
	  };
	};
	
	function getCharset(contentTypeHeader) {
	  if (contentTypeHeader === void 0) {
	    contentTypeHeader = '';
	  }
	
	  return contentTypeHeader.toLowerCase().split(';').reduce(function (charset, contentType) {
	    var _contentType$split = contentType.split('='),
	        type = _contentType$split[0],
	        value = _contentType$split[1];
	
	    if (type.trim() === 'charset') {
	      return value.trim();
	    }
	
	    return charset;
	  }, 'utf-8');
	}
	
	module.exports = httpResponseHandler;

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var window = __webpack_require__(344);
	
	var _extends = __webpack_require__(940);
	
	var isFunction = __webpack_require__(1799);
	
	createXHR.httpHandler = __webpack_require__(1532);
	/**
	 * @license
	 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
	 * Copyright (c) 2014 David Björklund
	 * Available under the MIT license
	 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
	 */
	
	var parseHeaders = function parseHeaders(headers) {
	  var result = {};
	
	  if (!headers) {
	    return result;
	  }
	
	  headers.trim().split('\n').forEach(function (row) {
	    var index = row.indexOf(':');
	    var key = row.slice(0, index).trim().toLowerCase();
	    var value = row.slice(index + 1).trim();
	
	    if (typeof result[key] === 'undefined') {
	      result[key] = value;
	    } else if (Array.isArray(result[key])) {
	      result[key].push(value);
	    } else {
	      result[key] = [result[key], value];
	    }
	  });
	  return result;
	};
	
	module.exports = createXHR; // Allow use of default import syntax in TypeScript
	
	module.exports.default = createXHR;
	createXHR.XMLHttpRequest = window.XMLHttpRequest || noop;
	createXHR.XDomainRequest = "withCredentials" in new createXHR.XMLHttpRequest() ? createXHR.XMLHttpRequest : window.XDomainRequest;
	forEachArray(["get", "put", "post", "patch", "head", "delete"], function (method) {
	  createXHR[method === "delete" ? "del" : method] = function (uri, options, callback) {
	    options = initParams(uri, options, callback);
	    options.method = method.toUpperCase();
	    return _createXHR(options);
	  };
	});
	
	function forEachArray(array, iterator) {
	  for (var i = 0; i < array.length; i++) {
	    iterator(array[i]);
	  }
	}
	
	function isEmpty(obj) {
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) return false;
	  }
	
	  return true;
	}
	
	function initParams(uri, options, callback) {
	  var params = uri;
	
	  if (isFunction(options)) {
	    callback = options;
	
	    if (typeof uri === "string") {
	      params = {
	        uri: uri
	      };
	    }
	  } else {
	    params = _extends({}, options, {
	      uri: uri
	    });
	  }
	
	  params.callback = callback;
	  return params;
	}
	
	function createXHR(uri, options, callback) {
	  options = initParams(uri, options, callback);
	  return _createXHR(options);
	}
	
	function _createXHR(options) {
	  if (typeof options.callback === "undefined") {
	    throw new Error("callback argument missing");
	  }
	
	  var called = false;
	
	  var callback = function cbOnce(err, response, body) {
	    if (!called) {
	      called = true;
	      options.callback(err, response, body);
	    }
	  };
	
	  function readystatechange() {
	    if (xhr.readyState === 4) {
	      setTimeout(loadFunc, 0);
	    }
	  }
	
	  function getBody() {
	    // Chrome with requestType=blob throws errors arround when even testing access to responseText
	    var body = undefined;
	
	    if (xhr.response) {
	      body = xhr.response;
	    } else {
	      body = xhr.responseText || getXml(xhr);
	    }
	
	    if (isJson) {
	      try {
	        body = JSON.parse(body);
	      } catch (e) {}
	    }
	
	    return body;
	  }
	
	  function errorFunc(evt) {
	    clearTimeout(timeoutTimer);
	
	    if (!(evt instanceof Error)) {
	      evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
	    }
	
	    evt.statusCode = 0;
	    return callback(evt, failureResponse);
	  } // will load the data & process the response in a special response object
	
	
	  function loadFunc() {
	    if (aborted) return;
	    var status;
	    clearTimeout(timeoutTimer);
	
	    if (options.useXDR && xhr.status === undefined) {
	      //IE8 CORS GET successful response doesn't have a status field, but body is fine
	      status = 200;
	    } else {
	      status = xhr.status === 1223 ? 204 : xhr.status;
	    }
	
	    var response = failureResponse;
	    var err = null;
	
	    if (status !== 0) {
	      response = {
	        body: getBody(),
	        statusCode: status,
	        method: method,
	        headers: {},
	        url: uri,
	        rawRequest: xhr
	      };
	
	      if (xhr.getAllResponseHeaders) {
	        //remember xhr can in fact be XDR for CORS in IE
	        response.headers = parseHeaders(xhr.getAllResponseHeaders());
	      }
	    } else {
	      err = new Error("Internal XMLHttpRequest Error");
	    }
	
	    return callback(err, response, response.body);
	  }
	
	  var xhr = options.xhr || null;
	
	  if (!xhr) {
	    if (options.cors || options.useXDR) {
	      xhr = new createXHR.XDomainRequest();
	    } else {
	      xhr = new createXHR.XMLHttpRequest();
	    }
	  }
	
	  var key;
	  var aborted;
	  var uri = xhr.url = options.uri || options.url;
	  var method = xhr.method = options.method || "GET";
	  var body = options.body || options.data;
	  var headers = xhr.headers = options.headers || {};
	  var sync = !!options.sync;
	  var isJson = false;
	  var timeoutTimer;
	  var failureResponse = {
	    body: undefined,
	    headers: {},
	    statusCode: 0,
	    method: method,
	    url: uri,
	    rawRequest: xhr
	  };
	
	  if ("json" in options && options.json !== false) {
	    isJson = true;
	    headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json"); //Don't override existing accept header declared by user
	
	    if (method !== "GET" && method !== "HEAD") {
	      headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json"); //Don't override existing accept header declared by user
	
	      body = JSON.stringify(options.json === true ? body : options.json);
	    }
	  }
	
	  xhr.onreadystatechange = readystatechange;
	  xhr.onload = loadFunc;
	  xhr.onerror = errorFunc; // IE9 must have onprogress be set to a unique function.
	
	  xhr.onprogress = function () {// IE must die
	  };
	
	  xhr.onabort = function () {
	    aborted = true;
	  };
	
	  xhr.ontimeout = errorFunc;
	  xhr.open(method, uri, !sync, options.username, options.password); //has to be after open
	
	  if (!sync) {
	    xhr.withCredentials = !!options.withCredentials;
	  } // Cannot set timeout with sync request
	  // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
	  // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
	
	
	  if (!sync && options.timeout > 0) {
	    timeoutTimer = setTimeout(function () {
	      if (aborted) return;
	      aborted = true; //IE9 may still call readystatechange
	
	      xhr.abort("timeout");
	      var e = new Error("XMLHttpRequest timeout");
	      e.code = "ETIMEDOUT";
	      errorFunc(e);
	    }, options.timeout);
	  }
	
	  if (xhr.setRequestHeader) {
	    for (key in headers) {
	      if (headers.hasOwnProperty(key)) {
	        xhr.setRequestHeader(key, headers[key]);
	      }
	    }
	  } else if (options.headers && !isEmpty(options.headers)) {
	    throw new Error("Headers cannot be set on an XDomainRequest object");
	  }
	
	  if ("responseType" in options) {
	    xhr.responseType = options.responseType;
	  }
	
	  if ("beforeSend" in options && typeof options.beforeSend === "function") {
	    options.beforeSend(xhr);
	  } // Microsoft Edge browser sends "undefined" when send is called with undefined value.
	  // XMLHttpRequest spec says to pass null as body to indicate no body
	  // See https://github.com/naugtur/xhr/issues/100.
	
	
	  xhr.send(body || null);
	  return xhr;
	}
	
	function getXml(xhr) {
	  // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
	  // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
	  try {
	    if (xhr.responseType === "document") {
	      return xhr.responseXML;
	    }
	
	    var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
	
	    if (xhr.responseType === "" && !firefoxBugTakenEffect) {
	      return xhr.responseXML;
	    }
	  } catch (e) {}
	
	  return null;
	}
	
	function noop() {}

/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	var conventions = __webpack_require__(912);
	var dom = __webpack_require__(1282)
	var entities = __webpack_require__(1535);
	var sax = __webpack_require__(1537);
	
	var DOMImplementation = dom.DOMImplementation;
	
	var NAMESPACE = conventions.NAMESPACE;
	
	var ParseError = sax.ParseError;
	var XMLReader = sax.XMLReader;
	
	/**
	 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
	 *
	 * > XML parsed entities are often stored in computer files which,
	 * > for editing convenience, are organized into lines.
	 * > These lines are typically separated by some combination
	 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
	 * >
	 * > To simplify the tasks of applications, the XML processor must behave
	 * > as if it normalized all line breaks in external parsed entities (including the document entity)
	 * > on input, before parsing, by translating all of the following to a single #xA character:
	 * >
	 * > 1. the two-character sequence #xD #xA
	 * > 2. the two-character sequence #xD #x85
	 * > 3. the single character #x85
	 * > 4. the single character #x2028
	 * > 5. any #xD character that is not immediately followed by #xA or #x85.
	 *
	 * @param {string} input
	 * @returns {string}
	 */
	function normalizeLineEndings(input) {
		return input
			.replace(/\r[\n\u0085]/g, '\n')
			.replace(/[\r\u0085\u2028]/g, '\n')
	}
	
	/**
	 * @typedef Locator
	 * @property {number} [columnNumber]
	 * @property {number} [lineNumber]
	 */
	
	/**
	 * @typedef DOMParserOptions
	 * @property {DOMHandler} [domBuilder]
	 * @property {Function} [errorHandler]
	 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
	 * 						defaults to `normalizeLineEndings`
	 * @property {Locator} [locator]
	 * @property {Record<string, string>} [xmlns]
	 *
	 * @see normalizeLineEndings
	 */
	
	/**
	 * The DOMParser interface provides the ability to parse XML or HTML source code
	 * from a string into a DOM `Document`.
	 *
	 * _xmldom is different from the spec in that it allows an `options` parameter,
	 * to override the default behavior._
	 *
	 * @param {DOMParserOptions} [options]
	 * @constructor
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
	 */
	function DOMParser(options){
		this.options = options ||{locator:{}};
	}
	
	DOMParser.prototype.parseFromString = function(source,mimeType){
		var options = this.options;
		var sax =  new XMLReader();
		var domBuilder = options.domBuilder || new DOMHandler();//contentHandler and LexicalHandler
		var errorHandler = options.errorHandler;
		var locator = options.locator;
		var defaultNSMap = options.xmlns||{};
		var isHTML = /\/x?html?$/.test(mimeType);//mimeType.toLowerCase().indexOf('html') > -1;
	  	var entityMap = isHTML ? entities.HTML_ENTITIES : entities.XML_ENTITIES;
		if(locator){
			domBuilder.setDocumentLocator(locator)
		}
	
		sax.errorHandler = buildErrorHandler(errorHandler,domBuilder,locator);
		sax.domBuilder = options.domBuilder || domBuilder;
		if(isHTML){
			defaultNSMap[''] = NAMESPACE.HTML;
		}
		defaultNSMap.xml = defaultNSMap.xml || NAMESPACE.XML;
		var normalize = options.normalizeLineEndings || normalizeLineEndings;
		if (source && typeof source === 'string') {
			sax.parse(
				normalize(source),
				defaultNSMap,
				entityMap
			)
		} else {
			sax.errorHandler.error('invalid doc source')
		}
		return domBuilder.doc;
	}
	function buildErrorHandler(errorImpl,domBuilder,locator){
		if(!errorImpl){
			if(domBuilder instanceof DOMHandler){
				return domBuilder;
			}
			errorImpl = domBuilder ;
		}
		var errorHandler = {}
		var isCallback = errorImpl instanceof Function;
		locator = locator||{}
		function build(key){
			var fn = errorImpl[key];
			if(!fn && isCallback){
				fn = errorImpl.length == 2?function(msg){errorImpl(key,msg)}:errorImpl;
			}
			errorHandler[key] = fn && function(msg){
				fn('[xmldom '+key+']\t'+msg+_locator(locator));
			}||function(){};
		}
		build('warning');
		build('error');
		build('fatalError');
		return errorHandler;
	}
	
	//console.log('#\n\n\n\n\n\n\n####')
	/**
	 * +ContentHandler+ErrorHandler
	 * +LexicalHandler+EntityResolver2
	 * -DeclHandler-DTDHandler
	 *
	 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
	 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
	 */
	function DOMHandler() {
	    this.cdata = false;
	}
	function position(locator,node){
		node.lineNumber = locator.lineNumber;
		node.columnNumber = locator.columnNumber;
	}
	/**
	 * @see org.xml.sax.ContentHandler#startDocument
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
	 */
	DOMHandler.prototype = {
		startDocument : function() {
	    	this.doc = new DOMImplementation().createDocument(null, null, null);
	    	if (this.locator) {
	        	this.doc.documentURI = this.locator.systemId;
	    	}
		},
		startElement:function(namespaceURI, localName, qName, attrs) {
			var doc = this.doc;
		    var el = doc.createElementNS(namespaceURI, qName||localName);
		    var len = attrs.length;
		    appendElement(this, el);
		    this.currentElement = el;
	
			this.locator && position(this.locator,el)
		    for (var i = 0 ; i < len; i++) {
		        var namespaceURI = attrs.getURI(i);
		        var value = attrs.getValue(i);
		        var qName = attrs.getQName(i);
				var attr = doc.createAttributeNS(namespaceURI, qName);
				this.locator &&position(attrs.getLocator(i),attr);
				attr.value = attr.nodeValue = value;
				el.setAttributeNode(attr)
		    }
		},
		endElement:function(namespaceURI, localName, qName) {
			var current = this.currentElement
			var tagName = current.tagName;
			this.currentElement = current.parentNode;
		},
		startPrefixMapping:function(prefix, uri) {
		},
		endPrefixMapping:function(prefix) {
		},
		processingInstruction:function(target, data) {
		    var ins = this.doc.createProcessingInstruction(target, data);
		    this.locator && position(this.locator,ins)
		    appendElement(this, ins);
		},
		ignorableWhitespace:function(ch, start, length) {
		},
		characters:function(chars, start, length) {
			chars = _toString.apply(this,arguments)
			//console.log(chars)
			if(chars){
				if (this.cdata) {
					var charNode = this.doc.createCDATASection(chars);
				} else {
					var charNode = this.doc.createTextNode(chars);
				}
				if(this.currentElement){
					this.currentElement.appendChild(charNode);
				}else if(/^\s*$/.test(chars)){
					this.doc.appendChild(charNode);
					//process xml
				}
				this.locator && position(this.locator,charNode)
			}
		},
		skippedEntity:function(name) {
		},
		endDocument:function() {
			this.doc.normalize();
		},
		setDocumentLocator:function (locator) {
		    if(this.locator = locator){// && !('lineNumber' in locator)){
		    	locator.lineNumber = 0;
		    }
		},
		//LexicalHandler
		comment:function(chars, start, length) {
			chars = _toString.apply(this,arguments)
		    var comm = this.doc.createComment(chars);
		    this.locator && position(this.locator,comm)
		    appendElement(this, comm);
		},
	
		startCDATA:function() {
		    //used in characters() methods
		    this.cdata = true;
		},
		endCDATA:function() {
		    this.cdata = false;
		},
	
		startDTD:function(name, publicId, systemId) {
			var impl = this.doc.implementation;
		    if (impl && impl.createDocumentType) {
		        var dt = impl.createDocumentType(name, publicId, systemId);
		        this.locator && position(this.locator,dt)
		        appendElement(this, dt);
						this.doc.doctype = dt;
		    }
		},
		/**
		 * @see org.xml.sax.ErrorHandler
		 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
		 */
		warning:function(error) {
			console.warn('[xmldom warning]\t'+error,_locator(this.locator));
		},
		error:function(error) {
			console.error('[xmldom error]\t'+error,_locator(this.locator));
		},
		fatalError:function(error) {
			throw new ParseError(error, this.locator);
		}
	}
	function _locator(l){
		if(l){
			return '\n@'+(l.systemId ||'')+'#[line:'+l.lineNumber+',col:'+l.columnNumber+']'
		}
	}
	function _toString(chars,start,length){
		if(typeof chars == 'string'){
			return chars.substr(start,length)
		}else{//java sax connect width xmldom on rhino(what about: "? && !(chars instanceof String)")
			if(chars.length >= start+length || start){
				return new java.lang.String(chars,start,length)+'';
			}
			return chars;
		}
	}
	
	/*
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
	 * used method of org.xml.sax.ext.LexicalHandler:
	 *  #comment(chars, start, length)
	 *  #startCDATA()
	 *  #endCDATA()
	 *  #startDTD(name, publicId, systemId)
	 *
	 *
	 * IGNORED method of org.xml.sax.ext.LexicalHandler:
	 *  #endDTD()
	 *  #startEntity(name)
	 *  #endEntity(name)
	 *
	 *
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
	 * IGNORED method of org.xml.sax.ext.DeclHandler
	 * 	#attributeDecl(eName, aName, type, mode, value)
	 *  #elementDecl(name, model)
	 *  #externalEntityDecl(name, publicId, systemId)
	 *  #internalEntityDecl(name, value)
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
	 * IGNORED method of org.xml.sax.EntityResolver2
	 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
	 *  #resolveEntity(publicId, systemId)
	 *  #getExternalSubset(name, baseURI)
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
	 * IGNORED method of org.xml.sax.DTDHandler
	 *  #notationDecl(name, publicId, systemId) {};
	 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
	 */
	"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g,function(key){
		DOMHandler.prototype[key] = function(){return null}
	})
	
	/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */
	function appendElement (hander,node) {
	    if (!hander.currentElement) {
	        hander.doc.appendChild(node);
	    } else {
	        hander.currentElement.appendChild(node);
	    }
	}//appendChild and setAttributeNS are preformance key
	
	exports.__DOMHandler = DOMHandler;
	exports.normalizeLineEndings = normalizeLineEndings;
	exports.DOMParser = DOMParser;


/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var freeze = __webpack_require__(912).freeze;
	
	/**
	 * The entities that are predefined in every XML document.
	 *
	 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
	 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
	 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
	 */
	exports.XML_ENTITIES = freeze({
		amp: '&',
		apos: "'",
		gt: '>',
		lt: '<',
		quot: '"',
	});
	
	/**
	 * A map of all entities that are detected in an HTML document.
	 * They contain all entries from `XML_ENTITIES`.
	 *
	 * @see XML_ENTITIES
	 * @see DOMParser.parseFromString
	 * @see DOMImplementation.prototype.createHTMLDocument
	 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
	 * @see https://html.spec.whatwg.org/entities.json JSON
	 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
	 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
	 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
	 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
	 */
	exports.HTML_ENTITIES = freeze({
		Aacute: '\u00C1',
		aacute: '\u00E1',
		Abreve: '\u0102',
		abreve: '\u0103',
		ac: '\u223E',
		acd: '\u223F',
		acE: '\u223E\u0333',
		Acirc: '\u00C2',
		acirc: '\u00E2',
		acute: '\u00B4',
		Acy: '\u0410',
		acy: '\u0430',
		AElig: '\u00C6',
		aelig: '\u00E6',
		af: '\u2061',
		Afr: '\uD835\uDD04',
		afr: '\uD835\uDD1E',
		Agrave: '\u00C0',
		agrave: '\u00E0',
		alefsym: '\u2135',
		aleph: '\u2135',
		Alpha: '\u0391',
		alpha: '\u03B1',
		Amacr: '\u0100',
		amacr: '\u0101',
		amalg: '\u2A3F',
		AMP: '\u0026',
		amp: '\u0026',
		And: '\u2A53',
		and: '\u2227',
		andand: '\u2A55',
		andd: '\u2A5C',
		andslope: '\u2A58',
		andv: '\u2A5A',
		ang: '\u2220',
		ange: '\u29A4',
		angle: '\u2220',
		angmsd: '\u2221',
		angmsdaa: '\u29A8',
		angmsdab: '\u29A9',
		angmsdac: '\u29AA',
		angmsdad: '\u29AB',
		angmsdae: '\u29AC',
		angmsdaf: '\u29AD',
		angmsdag: '\u29AE',
		angmsdah: '\u29AF',
		angrt: '\u221F',
		angrtvb: '\u22BE',
		angrtvbd: '\u299D',
		angsph: '\u2222',
		angst: '\u00C5',
		angzarr: '\u237C',
		Aogon: '\u0104',
		aogon: '\u0105',
		Aopf: '\uD835\uDD38',
		aopf: '\uD835\uDD52',
		ap: '\u2248',
		apacir: '\u2A6F',
		apE: '\u2A70',
		ape: '\u224A',
		apid: '\u224B',
		apos: '\u0027',
		ApplyFunction: '\u2061',
		approx: '\u2248',
		approxeq: '\u224A',
		Aring: '\u00C5',
		aring: '\u00E5',
		Ascr: '\uD835\uDC9C',
		ascr: '\uD835\uDCB6',
		Assign: '\u2254',
		ast: '\u002A',
		asymp: '\u2248',
		asympeq: '\u224D',
		Atilde: '\u00C3',
		atilde: '\u00E3',
		Auml: '\u00C4',
		auml: '\u00E4',
		awconint: '\u2233',
		awint: '\u2A11',
		backcong: '\u224C',
		backepsilon: '\u03F6',
		backprime: '\u2035',
		backsim: '\u223D',
		backsimeq: '\u22CD',
		Backslash: '\u2216',
		Barv: '\u2AE7',
		barvee: '\u22BD',
		Barwed: '\u2306',
		barwed: '\u2305',
		barwedge: '\u2305',
		bbrk: '\u23B5',
		bbrktbrk: '\u23B6',
		bcong: '\u224C',
		Bcy: '\u0411',
		bcy: '\u0431',
		bdquo: '\u201E',
		becaus: '\u2235',
		Because: '\u2235',
		because: '\u2235',
		bemptyv: '\u29B0',
		bepsi: '\u03F6',
		bernou: '\u212C',
		Bernoullis: '\u212C',
		Beta: '\u0392',
		beta: '\u03B2',
		beth: '\u2136',
		between: '\u226C',
		Bfr: '\uD835\uDD05',
		bfr: '\uD835\uDD1F',
		bigcap: '\u22C2',
		bigcirc: '\u25EF',
		bigcup: '\u22C3',
		bigodot: '\u2A00',
		bigoplus: '\u2A01',
		bigotimes: '\u2A02',
		bigsqcup: '\u2A06',
		bigstar: '\u2605',
		bigtriangledown: '\u25BD',
		bigtriangleup: '\u25B3',
		biguplus: '\u2A04',
		bigvee: '\u22C1',
		bigwedge: '\u22C0',
		bkarow: '\u290D',
		blacklozenge: '\u29EB',
		blacksquare: '\u25AA',
		blacktriangle: '\u25B4',
		blacktriangledown: '\u25BE',
		blacktriangleleft: '\u25C2',
		blacktriangleright: '\u25B8',
		blank: '\u2423',
		blk12: '\u2592',
		blk14: '\u2591',
		blk34: '\u2593',
		block: '\u2588',
		bne: '\u003D\u20E5',
		bnequiv: '\u2261\u20E5',
		bNot: '\u2AED',
		bnot: '\u2310',
		Bopf: '\uD835\uDD39',
		bopf: '\uD835\uDD53',
		bot: '\u22A5',
		bottom: '\u22A5',
		bowtie: '\u22C8',
		boxbox: '\u29C9',
		boxDL: '\u2557',
		boxDl: '\u2556',
		boxdL: '\u2555',
		boxdl: '\u2510',
		boxDR: '\u2554',
		boxDr: '\u2553',
		boxdR: '\u2552',
		boxdr: '\u250C',
		boxH: '\u2550',
		boxh: '\u2500',
		boxHD: '\u2566',
		boxHd: '\u2564',
		boxhD: '\u2565',
		boxhd: '\u252C',
		boxHU: '\u2569',
		boxHu: '\u2567',
		boxhU: '\u2568',
		boxhu: '\u2534',
		boxminus: '\u229F',
		boxplus: '\u229E',
		boxtimes: '\u22A0',
		boxUL: '\u255D',
		boxUl: '\u255C',
		boxuL: '\u255B',
		boxul: '\u2518',
		boxUR: '\u255A',
		boxUr: '\u2559',
		boxuR: '\u2558',
		boxur: '\u2514',
		boxV: '\u2551',
		boxv: '\u2502',
		boxVH: '\u256C',
		boxVh: '\u256B',
		boxvH: '\u256A',
		boxvh: '\u253C',
		boxVL: '\u2563',
		boxVl: '\u2562',
		boxvL: '\u2561',
		boxvl: '\u2524',
		boxVR: '\u2560',
		boxVr: '\u255F',
		boxvR: '\u255E',
		boxvr: '\u251C',
		bprime: '\u2035',
		Breve: '\u02D8',
		breve: '\u02D8',
		brvbar: '\u00A6',
		Bscr: '\u212C',
		bscr: '\uD835\uDCB7',
		bsemi: '\u204F',
		bsim: '\u223D',
		bsime: '\u22CD',
		bsol: '\u005C',
		bsolb: '\u29C5',
		bsolhsub: '\u27C8',
		bull: '\u2022',
		bullet: '\u2022',
		bump: '\u224E',
		bumpE: '\u2AAE',
		bumpe: '\u224F',
		Bumpeq: '\u224E',
		bumpeq: '\u224F',
		Cacute: '\u0106',
		cacute: '\u0107',
		Cap: '\u22D2',
		cap: '\u2229',
		capand: '\u2A44',
		capbrcup: '\u2A49',
		capcap: '\u2A4B',
		capcup: '\u2A47',
		capdot: '\u2A40',
		CapitalDifferentialD: '\u2145',
		caps: '\u2229\uFE00',
		caret: '\u2041',
		caron: '\u02C7',
		Cayleys: '\u212D',
		ccaps: '\u2A4D',
		Ccaron: '\u010C',
		ccaron: '\u010D',
		Ccedil: '\u00C7',
		ccedil: '\u00E7',
		Ccirc: '\u0108',
		ccirc: '\u0109',
		Cconint: '\u2230',
		ccups: '\u2A4C',
		ccupssm: '\u2A50',
		Cdot: '\u010A',
		cdot: '\u010B',
		cedil: '\u00B8',
		Cedilla: '\u00B8',
		cemptyv: '\u29B2',
		cent: '\u00A2',
		CenterDot: '\u00B7',
		centerdot: '\u00B7',
		Cfr: '\u212D',
		cfr: '\uD835\uDD20',
		CHcy: '\u0427',
		chcy: '\u0447',
		check: '\u2713',
		checkmark: '\u2713',
		Chi: '\u03A7',
		chi: '\u03C7',
		cir: '\u25CB',
		circ: '\u02C6',
		circeq: '\u2257',
		circlearrowleft: '\u21BA',
		circlearrowright: '\u21BB',
		circledast: '\u229B',
		circledcirc: '\u229A',
		circleddash: '\u229D',
		CircleDot: '\u2299',
		circledR: '\u00AE',
		circledS: '\u24C8',
		CircleMinus: '\u2296',
		CirclePlus: '\u2295',
		CircleTimes: '\u2297',
		cirE: '\u29C3',
		cire: '\u2257',
		cirfnint: '\u2A10',
		cirmid: '\u2AEF',
		cirscir: '\u29C2',
		ClockwiseContourIntegral: '\u2232',
		CloseCurlyDoubleQuote: '\u201D',
		CloseCurlyQuote: '\u2019',
		clubs: '\u2663',
		clubsuit: '\u2663',
		Colon: '\u2237',
		colon: '\u003A',
		Colone: '\u2A74',
		colone: '\u2254',
		coloneq: '\u2254',
		comma: '\u002C',
		commat: '\u0040',
		comp: '\u2201',
		compfn: '\u2218',
		complement: '\u2201',
		complexes: '\u2102',
		cong: '\u2245',
		congdot: '\u2A6D',
		Congruent: '\u2261',
		Conint: '\u222F',
		conint: '\u222E',
		ContourIntegral: '\u222E',
		Copf: '\u2102',
		copf: '\uD835\uDD54',
		coprod: '\u2210',
		Coproduct: '\u2210',
		COPY: '\u00A9',
		copy: '\u00A9',
		copysr: '\u2117',
		CounterClockwiseContourIntegral: '\u2233',
		crarr: '\u21B5',
		Cross: '\u2A2F',
		cross: '\u2717',
		Cscr: '\uD835\uDC9E',
		cscr: '\uD835\uDCB8',
		csub: '\u2ACF',
		csube: '\u2AD1',
		csup: '\u2AD0',
		csupe: '\u2AD2',
		ctdot: '\u22EF',
		cudarrl: '\u2938',
		cudarrr: '\u2935',
		cuepr: '\u22DE',
		cuesc: '\u22DF',
		cularr: '\u21B6',
		cularrp: '\u293D',
		Cup: '\u22D3',
		cup: '\u222A',
		cupbrcap: '\u2A48',
		CupCap: '\u224D',
		cupcap: '\u2A46',
		cupcup: '\u2A4A',
		cupdot: '\u228D',
		cupor: '\u2A45',
		cups: '\u222A\uFE00',
		curarr: '\u21B7',
		curarrm: '\u293C',
		curlyeqprec: '\u22DE',
		curlyeqsucc: '\u22DF',
		curlyvee: '\u22CE',
		curlywedge: '\u22CF',
		curren: '\u00A4',
		curvearrowleft: '\u21B6',
		curvearrowright: '\u21B7',
		cuvee: '\u22CE',
		cuwed: '\u22CF',
		cwconint: '\u2232',
		cwint: '\u2231',
		cylcty: '\u232D',
		Dagger: '\u2021',
		dagger: '\u2020',
		daleth: '\u2138',
		Darr: '\u21A1',
		dArr: '\u21D3',
		darr: '\u2193',
		dash: '\u2010',
		Dashv: '\u2AE4',
		dashv: '\u22A3',
		dbkarow: '\u290F',
		dblac: '\u02DD',
		Dcaron: '\u010E',
		dcaron: '\u010F',
		Dcy: '\u0414',
		dcy: '\u0434',
		DD: '\u2145',
		dd: '\u2146',
		ddagger: '\u2021',
		ddarr: '\u21CA',
		DDotrahd: '\u2911',
		ddotseq: '\u2A77',
		deg: '\u00B0',
		Del: '\u2207',
		Delta: '\u0394',
		delta: '\u03B4',
		demptyv: '\u29B1',
		dfisht: '\u297F',
		Dfr: '\uD835\uDD07',
		dfr: '\uD835\uDD21',
		dHar: '\u2965',
		dharl: '\u21C3',
		dharr: '\u21C2',
		DiacriticalAcute: '\u00B4',
		DiacriticalDot: '\u02D9',
		DiacriticalDoubleAcute: '\u02DD',
		DiacriticalGrave: '\u0060',
		DiacriticalTilde: '\u02DC',
		diam: '\u22C4',
		Diamond: '\u22C4',
		diamond: '\u22C4',
		diamondsuit: '\u2666',
		diams: '\u2666',
		die: '\u00A8',
		DifferentialD: '\u2146',
		digamma: '\u03DD',
		disin: '\u22F2',
		div: '\u00F7',
		divide: '\u00F7',
		divideontimes: '\u22C7',
		divonx: '\u22C7',
		DJcy: '\u0402',
		djcy: '\u0452',
		dlcorn: '\u231E',
		dlcrop: '\u230D',
		dollar: '\u0024',
		Dopf: '\uD835\uDD3B',
		dopf: '\uD835\uDD55',
		Dot: '\u00A8',
		dot: '\u02D9',
		DotDot: '\u20DC',
		doteq: '\u2250',
		doteqdot: '\u2251',
		DotEqual: '\u2250',
		dotminus: '\u2238',
		dotplus: '\u2214',
		dotsquare: '\u22A1',
		doublebarwedge: '\u2306',
		DoubleContourIntegral: '\u222F',
		DoubleDot: '\u00A8',
		DoubleDownArrow: '\u21D3',
		DoubleLeftArrow: '\u21D0',
		DoubleLeftRightArrow: '\u21D4',
		DoubleLeftTee: '\u2AE4',
		DoubleLongLeftArrow: '\u27F8',
		DoubleLongLeftRightArrow: '\u27FA',
		DoubleLongRightArrow: '\u27F9',
		DoubleRightArrow: '\u21D2',
		DoubleRightTee: '\u22A8',
		DoubleUpArrow: '\u21D1',
		DoubleUpDownArrow: '\u21D5',
		DoubleVerticalBar: '\u2225',
		DownArrow: '\u2193',
		Downarrow: '\u21D3',
		downarrow: '\u2193',
		DownArrowBar: '\u2913',
		DownArrowUpArrow: '\u21F5',
		DownBreve: '\u0311',
		downdownarrows: '\u21CA',
		downharpoonleft: '\u21C3',
		downharpoonright: '\u21C2',
		DownLeftRightVector: '\u2950',
		DownLeftTeeVector: '\u295E',
		DownLeftVector: '\u21BD',
		DownLeftVectorBar: '\u2956',
		DownRightTeeVector: '\u295F',
		DownRightVector: '\u21C1',
		DownRightVectorBar: '\u2957',
		DownTee: '\u22A4',
		DownTeeArrow: '\u21A7',
		drbkarow: '\u2910',
		drcorn: '\u231F',
		drcrop: '\u230C',
		Dscr: '\uD835\uDC9F',
		dscr: '\uD835\uDCB9',
		DScy: '\u0405',
		dscy: '\u0455',
		dsol: '\u29F6',
		Dstrok: '\u0110',
		dstrok: '\u0111',
		dtdot: '\u22F1',
		dtri: '\u25BF',
		dtrif: '\u25BE',
		duarr: '\u21F5',
		duhar: '\u296F',
		dwangle: '\u29A6',
		DZcy: '\u040F',
		dzcy: '\u045F',
		dzigrarr: '\u27FF',
		Eacute: '\u00C9',
		eacute: '\u00E9',
		easter: '\u2A6E',
		Ecaron: '\u011A',
		ecaron: '\u011B',
		ecir: '\u2256',
		Ecirc: '\u00CA',
		ecirc: '\u00EA',
		ecolon: '\u2255',
		Ecy: '\u042D',
		ecy: '\u044D',
		eDDot: '\u2A77',
		Edot: '\u0116',
		eDot: '\u2251',
		edot: '\u0117',
		ee: '\u2147',
		efDot: '\u2252',
		Efr: '\uD835\uDD08',
		efr: '\uD835\uDD22',
		eg: '\u2A9A',
		Egrave: '\u00C8',
		egrave: '\u00E8',
		egs: '\u2A96',
		egsdot: '\u2A98',
		el: '\u2A99',
		Element: '\u2208',
		elinters: '\u23E7',
		ell: '\u2113',
		els: '\u2A95',
		elsdot: '\u2A97',
		Emacr: '\u0112',
		emacr: '\u0113',
		empty: '\u2205',
		emptyset: '\u2205',
		EmptySmallSquare: '\u25FB',
		emptyv: '\u2205',
		EmptyVerySmallSquare: '\u25AB',
		emsp: '\u2003',
		emsp13: '\u2004',
		emsp14: '\u2005',
		ENG: '\u014A',
		eng: '\u014B',
		ensp: '\u2002',
		Eogon: '\u0118',
		eogon: '\u0119',
		Eopf: '\uD835\uDD3C',
		eopf: '\uD835\uDD56',
		epar: '\u22D5',
		eparsl: '\u29E3',
		eplus: '\u2A71',
		epsi: '\u03B5',
		Epsilon: '\u0395',
		epsilon: '\u03B5',
		epsiv: '\u03F5',
		eqcirc: '\u2256',
		eqcolon: '\u2255',
		eqsim: '\u2242',
		eqslantgtr: '\u2A96',
		eqslantless: '\u2A95',
		Equal: '\u2A75',
		equals: '\u003D',
		EqualTilde: '\u2242',
		equest: '\u225F',
		Equilibrium: '\u21CC',
		equiv: '\u2261',
		equivDD: '\u2A78',
		eqvparsl: '\u29E5',
		erarr: '\u2971',
		erDot: '\u2253',
		Escr: '\u2130',
		escr: '\u212F',
		esdot: '\u2250',
		Esim: '\u2A73',
		esim: '\u2242',
		Eta: '\u0397',
		eta: '\u03B7',
		ETH: '\u00D0',
		eth: '\u00F0',
		Euml: '\u00CB',
		euml: '\u00EB',
		euro: '\u20AC',
		excl: '\u0021',
		exist: '\u2203',
		Exists: '\u2203',
		expectation: '\u2130',
		ExponentialE: '\u2147',
		exponentiale: '\u2147',
		fallingdotseq: '\u2252',
		Fcy: '\u0424',
		fcy: '\u0444',
		female: '\u2640',
		ffilig: '\uFB03',
		fflig: '\uFB00',
		ffllig: '\uFB04',
		Ffr: '\uD835\uDD09',
		ffr: '\uD835\uDD23',
		filig: '\uFB01',
		FilledSmallSquare: '\u25FC',
		FilledVerySmallSquare: '\u25AA',
		fjlig: '\u0066\u006A',
		flat: '\u266D',
		fllig: '\uFB02',
		fltns: '\u25B1',
		fnof: '\u0192',
		Fopf: '\uD835\uDD3D',
		fopf: '\uD835\uDD57',
		ForAll: '\u2200',
		forall: '\u2200',
		fork: '\u22D4',
		forkv: '\u2AD9',
		Fouriertrf: '\u2131',
		fpartint: '\u2A0D',
		frac12: '\u00BD',
		frac13: '\u2153',
		frac14: '\u00BC',
		frac15: '\u2155',
		frac16: '\u2159',
		frac18: '\u215B',
		frac23: '\u2154',
		frac25: '\u2156',
		frac34: '\u00BE',
		frac35: '\u2157',
		frac38: '\u215C',
		frac45: '\u2158',
		frac56: '\u215A',
		frac58: '\u215D',
		frac78: '\u215E',
		frasl: '\u2044',
		frown: '\u2322',
		Fscr: '\u2131',
		fscr: '\uD835\uDCBB',
		gacute: '\u01F5',
		Gamma: '\u0393',
		gamma: '\u03B3',
		Gammad: '\u03DC',
		gammad: '\u03DD',
		gap: '\u2A86',
		Gbreve: '\u011E',
		gbreve: '\u011F',
		Gcedil: '\u0122',
		Gcirc: '\u011C',
		gcirc: '\u011D',
		Gcy: '\u0413',
		gcy: '\u0433',
		Gdot: '\u0120',
		gdot: '\u0121',
		gE: '\u2267',
		ge: '\u2265',
		gEl: '\u2A8C',
		gel: '\u22DB',
		geq: '\u2265',
		geqq: '\u2267',
		geqslant: '\u2A7E',
		ges: '\u2A7E',
		gescc: '\u2AA9',
		gesdot: '\u2A80',
		gesdoto: '\u2A82',
		gesdotol: '\u2A84',
		gesl: '\u22DB\uFE00',
		gesles: '\u2A94',
		Gfr: '\uD835\uDD0A',
		gfr: '\uD835\uDD24',
		Gg: '\u22D9',
		gg: '\u226B',
		ggg: '\u22D9',
		gimel: '\u2137',
		GJcy: '\u0403',
		gjcy: '\u0453',
		gl: '\u2277',
		gla: '\u2AA5',
		glE: '\u2A92',
		glj: '\u2AA4',
		gnap: '\u2A8A',
		gnapprox: '\u2A8A',
		gnE: '\u2269',
		gne: '\u2A88',
		gneq: '\u2A88',
		gneqq: '\u2269',
		gnsim: '\u22E7',
		Gopf: '\uD835\uDD3E',
		gopf: '\uD835\uDD58',
		grave: '\u0060',
		GreaterEqual: '\u2265',
		GreaterEqualLess: '\u22DB',
		GreaterFullEqual: '\u2267',
		GreaterGreater: '\u2AA2',
		GreaterLess: '\u2277',
		GreaterSlantEqual: '\u2A7E',
		GreaterTilde: '\u2273',
		Gscr: '\uD835\uDCA2',
		gscr: '\u210A',
		gsim: '\u2273',
		gsime: '\u2A8E',
		gsiml: '\u2A90',
		Gt: '\u226B',
		GT: '\u003E',
		gt: '\u003E',
		gtcc: '\u2AA7',
		gtcir: '\u2A7A',
		gtdot: '\u22D7',
		gtlPar: '\u2995',
		gtquest: '\u2A7C',
		gtrapprox: '\u2A86',
		gtrarr: '\u2978',
		gtrdot: '\u22D7',
		gtreqless: '\u22DB',
		gtreqqless: '\u2A8C',
		gtrless: '\u2277',
		gtrsim: '\u2273',
		gvertneqq: '\u2269\uFE00',
		gvnE: '\u2269\uFE00',
		Hacek: '\u02C7',
		hairsp: '\u200A',
		half: '\u00BD',
		hamilt: '\u210B',
		HARDcy: '\u042A',
		hardcy: '\u044A',
		hArr: '\u21D4',
		harr: '\u2194',
		harrcir: '\u2948',
		harrw: '\u21AD',
		Hat: '\u005E',
		hbar: '\u210F',
		Hcirc: '\u0124',
		hcirc: '\u0125',
		hearts: '\u2665',
		heartsuit: '\u2665',
		hellip: '\u2026',
		hercon: '\u22B9',
		Hfr: '\u210C',
		hfr: '\uD835\uDD25',
		HilbertSpace: '\u210B',
		hksearow: '\u2925',
		hkswarow: '\u2926',
		hoarr: '\u21FF',
		homtht: '\u223B',
		hookleftarrow: '\u21A9',
		hookrightarrow: '\u21AA',
		Hopf: '\u210D',
		hopf: '\uD835\uDD59',
		horbar: '\u2015',
		HorizontalLine: '\u2500',
		Hscr: '\u210B',
		hscr: '\uD835\uDCBD',
		hslash: '\u210F',
		Hstrok: '\u0126',
		hstrok: '\u0127',
		HumpDownHump: '\u224E',
		HumpEqual: '\u224F',
		hybull: '\u2043',
		hyphen: '\u2010',
		Iacute: '\u00CD',
		iacute: '\u00ED',
		ic: '\u2063',
		Icirc: '\u00CE',
		icirc: '\u00EE',
		Icy: '\u0418',
		icy: '\u0438',
		Idot: '\u0130',
		IEcy: '\u0415',
		iecy: '\u0435',
		iexcl: '\u00A1',
		iff: '\u21D4',
		Ifr: '\u2111',
		ifr: '\uD835\uDD26',
		Igrave: '\u00CC',
		igrave: '\u00EC',
		ii: '\u2148',
		iiiint: '\u2A0C',
		iiint: '\u222D',
		iinfin: '\u29DC',
		iiota: '\u2129',
		IJlig: '\u0132',
		ijlig: '\u0133',
		Im: '\u2111',
		Imacr: '\u012A',
		imacr: '\u012B',
		image: '\u2111',
		ImaginaryI: '\u2148',
		imagline: '\u2110',
		imagpart: '\u2111',
		imath: '\u0131',
		imof: '\u22B7',
		imped: '\u01B5',
		Implies: '\u21D2',
		in: '\u2208',
		incare: '\u2105',
		infin: '\u221E',
		infintie: '\u29DD',
		inodot: '\u0131',
		Int: '\u222C',
		int: '\u222B',
		intcal: '\u22BA',
		integers: '\u2124',
		Integral: '\u222B',
		intercal: '\u22BA',
		Intersection: '\u22C2',
		intlarhk: '\u2A17',
		intprod: '\u2A3C',
		InvisibleComma: '\u2063',
		InvisibleTimes: '\u2062',
		IOcy: '\u0401',
		iocy: '\u0451',
		Iogon: '\u012E',
		iogon: '\u012F',
		Iopf: '\uD835\uDD40',
		iopf: '\uD835\uDD5A',
		Iota: '\u0399',
		iota: '\u03B9',
		iprod: '\u2A3C',
		iquest: '\u00BF',
		Iscr: '\u2110',
		iscr: '\uD835\uDCBE',
		isin: '\u2208',
		isindot: '\u22F5',
		isinE: '\u22F9',
		isins: '\u22F4',
		isinsv: '\u22F3',
		isinv: '\u2208',
		it: '\u2062',
		Itilde: '\u0128',
		itilde: '\u0129',
		Iukcy: '\u0406',
		iukcy: '\u0456',
		Iuml: '\u00CF',
		iuml: '\u00EF',
		Jcirc: '\u0134',
		jcirc: '\u0135',
		Jcy: '\u0419',
		jcy: '\u0439',
		Jfr: '\uD835\uDD0D',
		jfr: '\uD835\uDD27',
		jmath: '\u0237',
		Jopf: '\uD835\uDD41',
		jopf: '\uD835\uDD5B',
		Jscr: '\uD835\uDCA5',
		jscr: '\uD835\uDCBF',
		Jsercy: '\u0408',
		jsercy: '\u0458',
		Jukcy: '\u0404',
		jukcy: '\u0454',
		Kappa: '\u039A',
		kappa: '\u03BA',
		kappav: '\u03F0',
		Kcedil: '\u0136',
		kcedil: '\u0137',
		Kcy: '\u041A',
		kcy: '\u043A',
		Kfr: '\uD835\uDD0E',
		kfr: '\uD835\uDD28',
		kgreen: '\u0138',
		KHcy: '\u0425',
		khcy: '\u0445',
		KJcy: '\u040C',
		kjcy: '\u045C',
		Kopf: '\uD835\uDD42',
		kopf: '\uD835\uDD5C',
		Kscr: '\uD835\uDCA6',
		kscr: '\uD835\uDCC0',
		lAarr: '\u21DA',
		Lacute: '\u0139',
		lacute: '\u013A',
		laemptyv: '\u29B4',
		lagran: '\u2112',
		Lambda: '\u039B',
		lambda: '\u03BB',
		Lang: '\u27EA',
		lang: '\u27E8',
		langd: '\u2991',
		langle: '\u27E8',
		lap: '\u2A85',
		Laplacetrf: '\u2112',
		laquo: '\u00AB',
		Larr: '\u219E',
		lArr: '\u21D0',
		larr: '\u2190',
		larrb: '\u21E4',
		larrbfs: '\u291F',
		larrfs: '\u291D',
		larrhk: '\u21A9',
		larrlp: '\u21AB',
		larrpl: '\u2939',
		larrsim: '\u2973',
		larrtl: '\u21A2',
		lat: '\u2AAB',
		lAtail: '\u291B',
		latail: '\u2919',
		late: '\u2AAD',
		lates: '\u2AAD\uFE00',
		lBarr: '\u290E',
		lbarr: '\u290C',
		lbbrk: '\u2772',
		lbrace: '\u007B',
		lbrack: '\u005B',
		lbrke: '\u298B',
		lbrksld: '\u298F',
		lbrkslu: '\u298D',
		Lcaron: '\u013D',
		lcaron: '\u013E',
		Lcedil: '\u013B',
		lcedil: '\u013C',
		lceil: '\u2308',
		lcub: '\u007B',
		Lcy: '\u041B',
		lcy: '\u043B',
		ldca: '\u2936',
		ldquo: '\u201C',
		ldquor: '\u201E',
		ldrdhar: '\u2967',
		ldrushar: '\u294B',
		ldsh: '\u21B2',
		lE: '\u2266',
		le: '\u2264',
		LeftAngleBracket: '\u27E8',
		LeftArrow: '\u2190',
		Leftarrow: '\u21D0',
		leftarrow: '\u2190',
		LeftArrowBar: '\u21E4',
		LeftArrowRightArrow: '\u21C6',
		leftarrowtail: '\u21A2',
		LeftCeiling: '\u2308',
		LeftDoubleBracket: '\u27E6',
		LeftDownTeeVector: '\u2961',
		LeftDownVector: '\u21C3',
		LeftDownVectorBar: '\u2959',
		LeftFloor: '\u230A',
		leftharpoondown: '\u21BD',
		leftharpoonup: '\u21BC',
		leftleftarrows: '\u21C7',
		LeftRightArrow: '\u2194',
		Leftrightarrow: '\u21D4',
		leftrightarrow: '\u2194',
		leftrightarrows: '\u21C6',
		leftrightharpoons: '\u21CB',
		leftrightsquigarrow: '\u21AD',
		LeftRightVector: '\u294E',
		LeftTee: '\u22A3',
		LeftTeeArrow: '\u21A4',
		LeftTeeVector: '\u295A',
		leftthreetimes: '\u22CB',
		LeftTriangle: '\u22B2',
		LeftTriangleBar: '\u29CF',
		LeftTriangleEqual: '\u22B4',
		LeftUpDownVector: '\u2951',
		LeftUpTeeVector: '\u2960',
		LeftUpVector: '\u21BF',
		LeftUpVectorBar: '\u2958',
		LeftVector: '\u21BC',
		LeftVectorBar: '\u2952',
		lEg: '\u2A8B',
		leg: '\u22DA',
		leq: '\u2264',
		leqq: '\u2266',
		leqslant: '\u2A7D',
		les: '\u2A7D',
		lescc: '\u2AA8',
		lesdot: '\u2A7F',
		lesdoto: '\u2A81',
		lesdotor: '\u2A83',
		lesg: '\u22DA\uFE00',
		lesges: '\u2A93',
		lessapprox: '\u2A85',
		lessdot: '\u22D6',
		lesseqgtr: '\u22DA',
		lesseqqgtr: '\u2A8B',
		LessEqualGreater: '\u22DA',
		LessFullEqual: '\u2266',
		LessGreater: '\u2276',
		lessgtr: '\u2276',
		LessLess: '\u2AA1',
		lesssim: '\u2272',
		LessSlantEqual: '\u2A7D',
		LessTilde: '\u2272',
		lfisht: '\u297C',
		lfloor: '\u230A',
		Lfr: '\uD835\uDD0F',
		lfr: '\uD835\uDD29',
		lg: '\u2276',
		lgE: '\u2A91',
		lHar: '\u2962',
		lhard: '\u21BD',
		lharu: '\u21BC',
		lharul: '\u296A',
		lhblk: '\u2584',
		LJcy: '\u0409',
		ljcy: '\u0459',
		Ll: '\u22D8',
		ll: '\u226A',
		llarr: '\u21C7',
		llcorner: '\u231E',
		Lleftarrow: '\u21DA',
		llhard: '\u296B',
		lltri: '\u25FA',
		Lmidot: '\u013F',
		lmidot: '\u0140',
		lmoust: '\u23B0',
		lmoustache: '\u23B0',
		lnap: '\u2A89',
		lnapprox: '\u2A89',
		lnE: '\u2268',
		lne: '\u2A87',
		lneq: '\u2A87',
		lneqq: '\u2268',
		lnsim: '\u22E6',
		loang: '\u27EC',
		loarr: '\u21FD',
		lobrk: '\u27E6',
		LongLeftArrow: '\u27F5',
		Longleftarrow: '\u27F8',
		longleftarrow: '\u27F5',
		LongLeftRightArrow: '\u27F7',
		Longleftrightarrow: '\u27FA',
		longleftrightarrow: '\u27F7',
		longmapsto: '\u27FC',
		LongRightArrow: '\u27F6',
		Longrightarrow: '\u27F9',
		longrightarrow: '\u27F6',
		looparrowleft: '\u21AB',
		looparrowright: '\u21AC',
		lopar: '\u2985',
		Lopf: '\uD835\uDD43',
		lopf: '\uD835\uDD5D',
		loplus: '\u2A2D',
		lotimes: '\u2A34',
		lowast: '\u2217',
		lowbar: '\u005F',
		LowerLeftArrow: '\u2199',
		LowerRightArrow: '\u2198',
		loz: '\u25CA',
		lozenge: '\u25CA',
		lozf: '\u29EB',
		lpar: '\u0028',
		lparlt: '\u2993',
		lrarr: '\u21C6',
		lrcorner: '\u231F',
		lrhar: '\u21CB',
		lrhard: '\u296D',
		lrm: '\u200E',
		lrtri: '\u22BF',
		lsaquo: '\u2039',
		Lscr: '\u2112',
		lscr: '\uD835\uDCC1',
		Lsh: '\u21B0',
		lsh: '\u21B0',
		lsim: '\u2272',
		lsime: '\u2A8D',
		lsimg: '\u2A8F',
		lsqb: '\u005B',
		lsquo: '\u2018',
		lsquor: '\u201A',
		Lstrok: '\u0141',
		lstrok: '\u0142',
		Lt: '\u226A',
		LT: '\u003C',
		lt: '\u003C',
		ltcc: '\u2AA6',
		ltcir: '\u2A79',
		ltdot: '\u22D6',
		lthree: '\u22CB',
		ltimes: '\u22C9',
		ltlarr: '\u2976',
		ltquest: '\u2A7B',
		ltri: '\u25C3',
		ltrie: '\u22B4',
		ltrif: '\u25C2',
		ltrPar: '\u2996',
		lurdshar: '\u294A',
		luruhar: '\u2966',
		lvertneqq: '\u2268\uFE00',
		lvnE: '\u2268\uFE00',
		macr: '\u00AF',
		male: '\u2642',
		malt: '\u2720',
		maltese: '\u2720',
		Map: '\u2905',
		map: '\u21A6',
		mapsto: '\u21A6',
		mapstodown: '\u21A7',
		mapstoleft: '\u21A4',
		mapstoup: '\u21A5',
		marker: '\u25AE',
		mcomma: '\u2A29',
		Mcy: '\u041C',
		mcy: '\u043C',
		mdash: '\u2014',
		mDDot: '\u223A',
		measuredangle: '\u2221',
		MediumSpace: '\u205F',
		Mellintrf: '\u2133',
		Mfr: '\uD835\uDD10',
		mfr: '\uD835\uDD2A',
		mho: '\u2127',
		micro: '\u00B5',
		mid: '\u2223',
		midast: '\u002A',
		midcir: '\u2AF0',
		middot: '\u00B7',
		minus: '\u2212',
		minusb: '\u229F',
		minusd: '\u2238',
		minusdu: '\u2A2A',
		MinusPlus: '\u2213',
		mlcp: '\u2ADB',
		mldr: '\u2026',
		mnplus: '\u2213',
		models: '\u22A7',
		Mopf: '\uD835\uDD44',
		mopf: '\uD835\uDD5E',
		mp: '\u2213',
		Mscr: '\u2133',
		mscr: '\uD835\uDCC2',
		mstpos: '\u223E',
		Mu: '\u039C',
		mu: '\u03BC',
		multimap: '\u22B8',
		mumap: '\u22B8',
		nabla: '\u2207',
		Nacute: '\u0143',
		nacute: '\u0144',
		nang: '\u2220\u20D2',
		nap: '\u2249',
		napE: '\u2A70\u0338',
		napid: '\u224B\u0338',
		napos: '\u0149',
		napprox: '\u2249',
		natur: '\u266E',
		natural: '\u266E',
		naturals: '\u2115',
		nbsp: '\u00A0',
		nbump: '\u224E\u0338',
		nbumpe: '\u224F\u0338',
		ncap: '\u2A43',
		Ncaron: '\u0147',
		ncaron: '\u0148',
		Ncedil: '\u0145',
		ncedil: '\u0146',
		ncong: '\u2247',
		ncongdot: '\u2A6D\u0338',
		ncup: '\u2A42',
		Ncy: '\u041D',
		ncy: '\u043D',
		ndash: '\u2013',
		ne: '\u2260',
		nearhk: '\u2924',
		neArr: '\u21D7',
		nearr: '\u2197',
		nearrow: '\u2197',
		nedot: '\u2250\u0338',
		NegativeMediumSpace: '\u200B',
		NegativeThickSpace: '\u200B',
		NegativeThinSpace: '\u200B',
		NegativeVeryThinSpace: '\u200B',
		nequiv: '\u2262',
		nesear: '\u2928',
		nesim: '\u2242\u0338',
		NestedGreaterGreater: '\u226B',
		NestedLessLess: '\u226A',
		NewLine: '\u000A',
		nexist: '\u2204',
		nexists: '\u2204',
		Nfr: '\uD835\uDD11',
		nfr: '\uD835\uDD2B',
		ngE: '\u2267\u0338',
		nge: '\u2271',
		ngeq: '\u2271',
		ngeqq: '\u2267\u0338',
		ngeqslant: '\u2A7E\u0338',
		nges: '\u2A7E\u0338',
		nGg: '\u22D9\u0338',
		ngsim: '\u2275',
		nGt: '\u226B\u20D2',
		ngt: '\u226F',
		ngtr: '\u226F',
		nGtv: '\u226B\u0338',
		nhArr: '\u21CE',
		nharr: '\u21AE',
		nhpar: '\u2AF2',
		ni: '\u220B',
		nis: '\u22FC',
		nisd: '\u22FA',
		niv: '\u220B',
		NJcy: '\u040A',
		njcy: '\u045A',
		nlArr: '\u21CD',
		nlarr: '\u219A',
		nldr: '\u2025',
		nlE: '\u2266\u0338',
		nle: '\u2270',
		nLeftarrow: '\u21CD',
		nleftarrow: '\u219A',
		nLeftrightarrow: '\u21CE',
		nleftrightarrow: '\u21AE',
		nleq: '\u2270',
		nleqq: '\u2266\u0338',
		nleqslant: '\u2A7D\u0338',
		nles: '\u2A7D\u0338',
		nless: '\u226E',
		nLl: '\u22D8\u0338',
		nlsim: '\u2274',
		nLt: '\u226A\u20D2',
		nlt: '\u226E',
		nltri: '\u22EA',
		nltrie: '\u22EC',
		nLtv: '\u226A\u0338',
		nmid: '\u2224',
		NoBreak: '\u2060',
		NonBreakingSpace: '\u00A0',
		Nopf: '\u2115',
		nopf: '\uD835\uDD5F',
		Not: '\u2AEC',
		not: '\u00AC',
		NotCongruent: '\u2262',
		NotCupCap: '\u226D',
		NotDoubleVerticalBar: '\u2226',
		NotElement: '\u2209',
		NotEqual: '\u2260',
		NotEqualTilde: '\u2242\u0338',
		NotExists: '\u2204',
		NotGreater: '\u226F',
		NotGreaterEqual: '\u2271',
		NotGreaterFullEqual: '\u2267\u0338',
		NotGreaterGreater: '\u226B\u0338',
		NotGreaterLess: '\u2279',
		NotGreaterSlantEqual: '\u2A7E\u0338',
		NotGreaterTilde: '\u2275',
		NotHumpDownHump: '\u224E\u0338',
		NotHumpEqual: '\u224F\u0338',
		notin: '\u2209',
		notindot: '\u22F5\u0338',
		notinE: '\u22F9\u0338',
		notinva: '\u2209',
		notinvb: '\u22F7',
		notinvc: '\u22F6',
		NotLeftTriangle: '\u22EA',
		NotLeftTriangleBar: '\u29CF\u0338',
		NotLeftTriangleEqual: '\u22EC',
		NotLess: '\u226E',
		NotLessEqual: '\u2270',
		NotLessGreater: '\u2278',
		NotLessLess: '\u226A\u0338',
		NotLessSlantEqual: '\u2A7D\u0338',
		NotLessTilde: '\u2274',
		NotNestedGreaterGreater: '\u2AA2\u0338',
		NotNestedLessLess: '\u2AA1\u0338',
		notni: '\u220C',
		notniva: '\u220C',
		notnivb: '\u22FE',
		notnivc: '\u22FD',
		NotPrecedes: '\u2280',
		NotPrecedesEqual: '\u2AAF\u0338',
		NotPrecedesSlantEqual: '\u22E0',
		NotReverseElement: '\u220C',
		NotRightTriangle: '\u22EB',
		NotRightTriangleBar: '\u29D0\u0338',
		NotRightTriangleEqual: '\u22ED',
		NotSquareSubset: '\u228F\u0338',
		NotSquareSubsetEqual: '\u22E2',
		NotSquareSuperset: '\u2290\u0338',
		NotSquareSupersetEqual: '\u22E3',
		NotSubset: '\u2282\u20D2',
		NotSubsetEqual: '\u2288',
		NotSucceeds: '\u2281',
		NotSucceedsEqual: '\u2AB0\u0338',
		NotSucceedsSlantEqual: '\u22E1',
		NotSucceedsTilde: '\u227F\u0338',
		NotSuperset: '\u2283\u20D2',
		NotSupersetEqual: '\u2289',
		NotTilde: '\u2241',
		NotTildeEqual: '\u2244',
		NotTildeFullEqual: '\u2247',
		NotTildeTilde: '\u2249',
		NotVerticalBar: '\u2224',
		npar: '\u2226',
		nparallel: '\u2226',
		nparsl: '\u2AFD\u20E5',
		npart: '\u2202\u0338',
		npolint: '\u2A14',
		npr: '\u2280',
		nprcue: '\u22E0',
		npre: '\u2AAF\u0338',
		nprec: '\u2280',
		npreceq: '\u2AAF\u0338',
		nrArr: '\u21CF',
		nrarr: '\u219B',
		nrarrc: '\u2933\u0338',
		nrarrw: '\u219D\u0338',
		nRightarrow: '\u21CF',
		nrightarrow: '\u219B',
		nrtri: '\u22EB',
		nrtrie: '\u22ED',
		nsc: '\u2281',
		nsccue: '\u22E1',
		nsce: '\u2AB0\u0338',
		Nscr: '\uD835\uDCA9',
		nscr: '\uD835\uDCC3',
		nshortmid: '\u2224',
		nshortparallel: '\u2226',
		nsim: '\u2241',
		nsime: '\u2244',
		nsimeq: '\u2244',
		nsmid: '\u2224',
		nspar: '\u2226',
		nsqsube: '\u22E2',
		nsqsupe: '\u22E3',
		nsub: '\u2284',
		nsubE: '\u2AC5\u0338',
		nsube: '\u2288',
		nsubset: '\u2282\u20D2',
		nsubseteq: '\u2288',
		nsubseteqq: '\u2AC5\u0338',
		nsucc: '\u2281',
		nsucceq: '\u2AB0\u0338',
		nsup: '\u2285',
		nsupE: '\u2AC6\u0338',
		nsupe: '\u2289',
		nsupset: '\u2283\u20D2',
		nsupseteq: '\u2289',
		nsupseteqq: '\u2AC6\u0338',
		ntgl: '\u2279',
		Ntilde: '\u00D1',
		ntilde: '\u00F1',
		ntlg: '\u2278',
		ntriangleleft: '\u22EA',
		ntrianglelefteq: '\u22EC',
		ntriangleright: '\u22EB',
		ntrianglerighteq: '\u22ED',
		Nu: '\u039D',
		nu: '\u03BD',
		num: '\u0023',
		numero: '\u2116',
		numsp: '\u2007',
		nvap: '\u224D\u20D2',
		nVDash: '\u22AF',
		nVdash: '\u22AE',
		nvDash: '\u22AD',
		nvdash: '\u22AC',
		nvge: '\u2265\u20D2',
		nvgt: '\u003E\u20D2',
		nvHarr: '\u2904',
		nvinfin: '\u29DE',
		nvlArr: '\u2902',
		nvle: '\u2264\u20D2',
		nvlt: '\u003C\u20D2',
		nvltrie: '\u22B4\u20D2',
		nvrArr: '\u2903',
		nvrtrie: '\u22B5\u20D2',
		nvsim: '\u223C\u20D2',
		nwarhk: '\u2923',
		nwArr: '\u21D6',
		nwarr: '\u2196',
		nwarrow: '\u2196',
		nwnear: '\u2927',
		Oacute: '\u00D3',
		oacute: '\u00F3',
		oast: '\u229B',
		ocir: '\u229A',
		Ocirc: '\u00D4',
		ocirc: '\u00F4',
		Ocy: '\u041E',
		ocy: '\u043E',
		odash: '\u229D',
		Odblac: '\u0150',
		odblac: '\u0151',
		odiv: '\u2A38',
		odot: '\u2299',
		odsold: '\u29BC',
		OElig: '\u0152',
		oelig: '\u0153',
		ofcir: '\u29BF',
		Ofr: '\uD835\uDD12',
		ofr: '\uD835\uDD2C',
		ogon: '\u02DB',
		Ograve: '\u00D2',
		ograve: '\u00F2',
		ogt: '\u29C1',
		ohbar: '\u29B5',
		ohm: '\u03A9',
		oint: '\u222E',
		olarr: '\u21BA',
		olcir: '\u29BE',
		olcross: '\u29BB',
		oline: '\u203E',
		olt: '\u29C0',
		Omacr: '\u014C',
		omacr: '\u014D',
		Omega: '\u03A9',
		omega: '\u03C9',
		Omicron: '\u039F',
		omicron: '\u03BF',
		omid: '\u29B6',
		ominus: '\u2296',
		Oopf: '\uD835\uDD46',
		oopf: '\uD835\uDD60',
		opar: '\u29B7',
		OpenCurlyDoubleQuote: '\u201C',
		OpenCurlyQuote: '\u2018',
		operp: '\u29B9',
		oplus: '\u2295',
		Or: '\u2A54',
		or: '\u2228',
		orarr: '\u21BB',
		ord: '\u2A5D',
		order: '\u2134',
		orderof: '\u2134',
		ordf: '\u00AA',
		ordm: '\u00BA',
		origof: '\u22B6',
		oror: '\u2A56',
		orslope: '\u2A57',
		orv: '\u2A5B',
		oS: '\u24C8',
		Oscr: '\uD835\uDCAA',
		oscr: '\u2134',
		Oslash: '\u00D8',
		oslash: '\u00F8',
		osol: '\u2298',
		Otilde: '\u00D5',
		otilde: '\u00F5',
		Otimes: '\u2A37',
		otimes: '\u2297',
		otimesas: '\u2A36',
		Ouml: '\u00D6',
		ouml: '\u00F6',
		ovbar: '\u233D',
		OverBar: '\u203E',
		OverBrace: '\u23DE',
		OverBracket: '\u23B4',
		OverParenthesis: '\u23DC',
		par: '\u2225',
		para: '\u00B6',
		parallel: '\u2225',
		parsim: '\u2AF3',
		parsl: '\u2AFD',
		part: '\u2202',
		PartialD: '\u2202',
		Pcy: '\u041F',
		pcy: '\u043F',
		percnt: '\u0025',
		period: '\u002E',
		permil: '\u2030',
		perp: '\u22A5',
		pertenk: '\u2031',
		Pfr: '\uD835\uDD13',
		pfr: '\uD835\uDD2D',
		Phi: '\u03A6',
		phi: '\u03C6',
		phiv: '\u03D5',
		phmmat: '\u2133',
		phone: '\u260E',
		Pi: '\u03A0',
		pi: '\u03C0',
		pitchfork: '\u22D4',
		piv: '\u03D6',
		planck: '\u210F',
		planckh: '\u210E',
		plankv: '\u210F',
		plus: '\u002B',
		plusacir: '\u2A23',
		plusb: '\u229E',
		pluscir: '\u2A22',
		plusdo: '\u2214',
		plusdu: '\u2A25',
		pluse: '\u2A72',
		PlusMinus: '\u00B1',
		plusmn: '\u00B1',
		plussim: '\u2A26',
		plustwo: '\u2A27',
		pm: '\u00B1',
		Poincareplane: '\u210C',
		pointint: '\u2A15',
		Popf: '\u2119',
		popf: '\uD835\uDD61',
		pound: '\u00A3',
		Pr: '\u2ABB',
		pr: '\u227A',
		prap: '\u2AB7',
		prcue: '\u227C',
		prE: '\u2AB3',
		pre: '\u2AAF',
		prec: '\u227A',
		precapprox: '\u2AB7',
		preccurlyeq: '\u227C',
		Precedes: '\u227A',
		PrecedesEqual: '\u2AAF',
		PrecedesSlantEqual: '\u227C',
		PrecedesTilde: '\u227E',
		preceq: '\u2AAF',
		precnapprox: '\u2AB9',
		precneqq: '\u2AB5',
		precnsim: '\u22E8',
		precsim: '\u227E',
		Prime: '\u2033',
		prime: '\u2032',
		primes: '\u2119',
		prnap: '\u2AB9',
		prnE: '\u2AB5',
		prnsim: '\u22E8',
		prod: '\u220F',
		Product: '\u220F',
		profalar: '\u232E',
		profline: '\u2312',
		profsurf: '\u2313',
		prop: '\u221D',
		Proportion: '\u2237',
		Proportional: '\u221D',
		propto: '\u221D',
		prsim: '\u227E',
		prurel: '\u22B0',
		Pscr: '\uD835\uDCAB',
		pscr: '\uD835\uDCC5',
		Psi: '\u03A8',
		psi: '\u03C8',
		puncsp: '\u2008',
		Qfr: '\uD835\uDD14',
		qfr: '\uD835\uDD2E',
		qint: '\u2A0C',
		Qopf: '\u211A',
		qopf: '\uD835\uDD62',
		qprime: '\u2057',
		Qscr: '\uD835\uDCAC',
		qscr: '\uD835\uDCC6',
		quaternions: '\u210D',
		quatint: '\u2A16',
		quest: '\u003F',
		questeq: '\u225F',
		QUOT: '\u0022',
		quot: '\u0022',
		rAarr: '\u21DB',
		race: '\u223D\u0331',
		Racute: '\u0154',
		racute: '\u0155',
		radic: '\u221A',
		raemptyv: '\u29B3',
		Rang: '\u27EB',
		rang: '\u27E9',
		rangd: '\u2992',
		range: '\u29A5',
		rangle: '\u27E9',
		raquo: '\u00BB',
		Rarr: '\u21A0',
		rArr: '\u21D2',
		rarr: '\u2192',
		rarrap: '\u2975',
		rarrb: '\u21E5',
		rarrbfs: '\u2920',
		rarrc: '\u2933',
		rarrfs: '\u291E',
		rarrhk: '\u21AA',
		rarrlp: '\u21AC',
		rarrpl: '\u2945',
		rarrsim: '\u2974',
		Rarrtl: '\u2916',
		rarrtl: '\u21A3',
		rarrw: '\u219D',
		rAtail: '\u291C',
		ratail: '\u291A',
		ratio: '\u2236',
		rationals: '\u211A',
		RBarr: '\u2910',
		rBarr: '\u290F',
		rbarr: '\u290D',
		rbbrk: '\u2773',
		rbrace: '\u007D',
		rbrack: '\u005D',
		rbrke: '\u298C',
		rbrksld: '\u298E',
		rbrkslu: '\u2990',
		Rcaron: '\u0158',
		rcaron: '\u0159',
		Rcedil: '\u0156',
		rcedil: '\u0157',
		rceil: '\u2309',
		rcub: '\u007D',
		Rcy: '\u0420',
		rcy: '\u0440',
		rdca: '\u2937',
		rdldhar: '\u2969',
		rdquo: '\u201D',
		rdquor: '\u201D',
		rdsh: '\u21B3',
		Re: '\u211C',
		real: '\u211C',
		realine: '\u211B',
		realpart: '\u211C',
		reals: '\u211D',
		rect: '\u25AD',
		REG: '\u00AE',
		reg: '\u00AE',
		ReverseElement: '\u220B',
		ReverseEquilibrium: '\u21CB',
		ReverseUpEquilibrium: '\u296F',
		rfisht: '\u297D',
		rfloor: '\u230B',
		Rfr: '\u211C',
		rfr: '\uD835\uDD2F',
		rHar: '\u2964',
		rhard: '\u21C1',
		rharu: '\u21C0',
		rharul: '\u296C',
		Rho: '\u03A1',
		rho: '\u03C1',
		rhov: '\u03F1',
		RightAngleBracket: '\u27E9',
		RightArrow: '\u2192',
		Rightarrow: '\u21D2',
		rightarrow: '\u2192',
		RightArrowBar: '\u21E5',
		RightArrowLeftArrow: '\u21C4',
		rightarrowtail: '\u21A3',
		RightCeiling: '\u2309',
		RightDoubleBracket: '\u27E7',
		RightDownTeeVector: '\u295D',
		RightDownVector: '\u21C2',
		RightDownVectorBar: '\u2955',
		RightFloor: '\u230B',
		rightharpoondown: '\u21C1',
		rightharpoonup: '\u21C0',
		rightleftarrows: '\u21C4',
		rightleftharpoons: '\u21CC',
		rightrightarrows: '\u21C9',
		rightsquigarrow: '\u219D',
		RightTee: '\u22A2',
		RightTeeArrow: '\u21A6',
		RightTeeVector: '\u295B',
		rightthreetimes: '\u22CC',
		RightTriangle: '\u22B3',
		RightTriangleBar: '\u29D0',
		RightTriangleEqual: '\u22B5',
		RightUpDownVector: '\u294F',
		RightUpTeeVector: '\u295C',
		RightUpVector: '\u21BE',
		RightUpVectorBar: '\u2954',
		RightVector: '\u21C0',
		RightVectorBar: '\u2953',
		ring: '\u02DA',
		risingdotseq: '\u2253',
		rlarr: '\u21C4',
		rlhar: '\u21CC',
		rlm: '\u200F',
		rmoust: '\u23B1',
		rmoustache: '\u23B1',
		rnmid: '\u2AEE',
		roang: '\u27ED',
		roarr: '\u21FE',
		robrk: '\u27E7',
		ropar: '\u2986',
		Ropf: '\u211D',
		ropf: '\uD835\uDD63',
		roplus: '\u2A2E',
		rotimes: '\u2A35',
		RoundImplies: '\u2970',
		rpar: '\u0029',
		rpargt: '\u2994',
		rppolint: '\u2A12',
		rrarr: '\u21C9',
		Rrightarrow: '\u21DB',
		rsaquo: '\u203A',
		Rscr: '\u211B',
		rscr: '\uD835\uDCC7',
		Rsh: '\u21B1',
		rsh: '\u21B1',
		rsqb: '\u005D',
		rsquo: '\u2019',
		rsquor: '\u2019',
		rthree: '\u22CC',
		rtimes: '\u22CA',
		rtri: '\u25B9',
		rtrie: '\u22B5',
		rtrif: '\u25B8',
		rtriltri: '\u29CE',
		RuleDelayed: '\u29F4',
		ruluhar: '\u2968',
		rx: '\u211E',
		Sacute: '\u015A',
		sacute: '\u015B',
		sbquo: '\u201A',
		Sc: '\u2ABC',
		sc: '\u227B',
		scap: '\u2AB8',
		Scaron: '\u0160',
		scaron: '\u0161',
		sccue: '\u227D',
		scE: '\u2AB4',
		sce: '\u2AB0',
		Scedil: '\u015E',
		scedil: '\u015F',
		Scirc: '\u015C',
		scirc: '\u015D',
		scnap: '\u2ABA',
		scnE: '\u2AB6',
		scnsim: '\u22E9',
		scpolint: '\u2A13',
		scsim: '\u227F',
		Scy: '\u0421',
		scy: '\u0441',
		sdot: '\u22C5',
		sdotb: '\u22A1',
		sdote: '\u2A66',
		searhk: '\u2925',
		seArr: '\u21D8',
		searr: '\u2198',
		searrow: '\u2198',
		sect: '\u00A7',
		semi: '\u003B',
		seswar: '\u2929',
		setminus: '\u2216',
		setmn: '\u2216',
		sext: '\u2736',
		Sfr: '\uD835\uDD16',
		sfr: '\uD835\uDD30',
		sfrown: '\u2322',
		sharp: '\u266F',
		SHCHcy: '\u0429',
		shchcy: '\u0449',
		SHcy: '\u0428',
		shcy: '\u0448',
		ShortDownArrow: '\u2193',
		ShortLeftArrow: '\u2190',
		shortmid: '\u2223',
		shortparallel: '\u2225',
		ShortRightArrow: '\u2192',
		ShortUpArrow: '\u2191',
		shy: '\u00AD',
		Sigma: '\u03A3',
		sigma: '\u03C3',
		sigmaf: '\u03C2',
		sigmav: '\u03C2',
		sim: '\u223C',
		simdot: '\u2A6A',
		sime: '\u2243',
		simeq: '\u2243',
		simg: '\u2A9E',
		simgE: '\u2AA0',
		siml: '\u2A9D',
		simlE: '\u2A9F',
		simne: '\u2246',
		simplus: '\u2A24',
		simrarr: '\u2972',
		slarr: '\u2190',
		SmallCircle: '\u2218',
		smallsetminus: '\u2216',
		smashp: '\u2A33',
		smeparsl: '\u29E4',
		smid: '\u2223',
		smile: '\u2323',
		smt: '\u2AAA',
		smte: '\u2AAC',
		smtes: '\u2AAC\uFE00',
		SOFTcy: '\u042C',
		softcy: '\u044C',
		sol: '\u002F',
		solb: '\u29C4',
		solbar: '\u233F',
		Sopf: '\uD835\uDD4A',
		sopf: '\uD835\uDD64',
		spades: '\u2660',
		spadesuit: '\u2660',
		spar: '\u2225',
		sqcap: '\u2293',
		sqcaps: '\u2293\uFE00',
		sqcup: '\u2294',
		sqcups: '\u2294\uFE00',
		Sqrt: '\u221A',
		sqsub: '\u228F',
		sqsube: '\u2291',
		sqsubset: '\u228F',
		sqsubseteq: '\u2291',
		sqsup: '\u2290',
		sqsupe: '\u2292',
		sqsupset: '\u2290',
		sqsupseteq: '\u2292',
		squ: '\u25A1',
		Square: '\u25A1',
		square: '\u25A1',
		SquareIntersection: '\u2293',
		SquareSubset: '\u228F',
		SquareSubsetEqual: '\u2291',
		SquareSuperset: '\u2290',
		SquareSupersetEqual: '\u2292',
		SquareUnion: '\u2294',
		squarf: '\u25AA',
		squf: '\u25AA',
		srarr: '\u2192',
		Sscr: '\uD835\uDCAE',
		sscr: '\uD835\uDCC8',
		ssetmn: '\u2216',
		ssmile: '\u2323',
		sstarf: '\u22C6',
		Star: '\u22C6',
		star: '\u2606',
		starf: '\u2605',
		straightepsilon: '\u03F5',
		straightphi: '\u03D5',
		strns: '\u00AF',
		Sub: '\u22D0',
		sub: '\u2282',
		subdot: '\u2ABD',
		subE: '\u2AC5',
		sube: '\u2286',
		subedot: '\u2AC3',
		submult: '\u2AC1',
		subnE: '\u2ACB',
		subne: '\u228A',
		subplus: '\u2ABF',
		subrarr: '\u2979',
		Subset: '\u22D0',
		subset: '\u2282',
		subseteq: '\u2286',
		subseteqq: '\u2AC5',
		SubsetEqual: '\u2286',
		subsetneq: '\u228A',
		subsetneqq: '\u2ACB',
		subsim: '\u2AC7',
		subsub: '\u2AD5',
		subsup: '\u2AD3',
		succ: '\u227B',
		succapprox: '\u2AB8',
		succcurlyeq: '\u227D',
		Succeeds: '\u227B',
		SucceedsEqual: '\u2AB0',
		SucceedsSlantEqual: '\u227D',
		SucceedsTilde: '\u227F',
		succeq: '\u2AB0',
		succnapprox: '\u2ABA',
		succneqq: '\u2AB6',
		succnsim: '\u22E9',
		succsim: '\u227F',
		SuchThat: '\u220B',
		Sum: '\u2211',
		sum: '\u2211',
		sung: '\u266A',
		Sup: '\u22D1',
		sup: '\u2283',
		sup1: '\u00B9',
		sup2: '\u00B2',
		sup3: '\u00B3',
		supdot: '\u2ABE',
		supdsub: '\u2AD8',
		supE: '\u2AC6',
		supe: '\u2287',
		supedot: '\u2AC4',
		Superset: '\u2283',
		SupersetEqual: '\u2287',
		suphsol: '\u27C9',
		suphsub: '\u2AD7',
		suplarr: '\u297B',
		supmult: '\u2AC2',
		supnE: '\u2ACC',
		supne: '\u228B',
		supplus: '\u2AC0',
		Supset: '\u22D1',
		supset: '\u2283',
		supseteq: '\u2287',
		supseteqq: '\u2AC6',
		supsetneq: '\u228B',
		supsetneqq: '\u2ACC',
		supsim: '\u2AC8',
		supsub: '\u2AD4',
		supsup: '\u2AD6',
		swarhk: '\u2926',
		swArr: '\u21D9',
		swarr: '\u2199',
		swarrow: '\u2199',
		swnwar: '\u292A',
		szlig: '\u00DF',
		Tab: '\u0009',
		target: '\u2316',
		Tau: '\u03A4',
		tau: '\u03C4',
		tbrk: '\u23B4',
		Tcaron: '\u0164',
		tcaron: '\u0165',
		Tcedil: '\u0162',
		tcedil: '\u0163',
		Tcy: '\u0422',
		tcy: '\u0442',
		tdot: '\u20DB',
		telrec: '\u2315',
		Tfr: '\uD835\uDD17',
		tfr: '\uD835\uDD31',
		there4: '\u2234',
		Therefore: '\u2234',
		therefore: '\u2234',
		Theta: '\u0398',
		theta: '\u03B8',
		thetasym: '\u03D1',
		thetav: '\u03D1',
		thickapprox: '\u2248',
		thicksim: '\u223C',
		ThickSpace: '\u205F\u200A',
		thinsp: '\u2009',
		ThinSpace: '\u2009',
		thkap: '\u2248',
		thksim: '\u223C',
		THORN: '\u00DE',
		thorn: '\u00FE',
		Tilde: '\u223C',
		tilde: '\u02DC',
		TildeEqual: '\u2243',
		TildeFullEqual: '\u2245',
		TildeTilde: '\u2248',
		times: '\u00D7',
		timesb: '\u22A0',
		timesbar: '\u2A31',
		timesd: '\u2A30',
		tint: '\u222D',
		toea: '\u2928',
		top: '\u22A4',
		topbot: '\u2336',
		topcir: '\u2AF1',
		Topf: '\uD835\uDD4B',
		topf: '\uD835\uDD65',
		topfork: '\u2ADA',
		tosa: '\u2929',
		tprime: '\u2034',
		TRADE: '\u2122',
		trade: '\u2122',
		triangle: '\u25B5',
		triangledown: '\u25BF',
		triangleleft: '\u25C3',
		trianglelefteq: '\u22B4',
		triangleq: '\u225C',
		triangleright: '\u25B9',
		trianglerighteq: '\u22B5',
		tridot: '\u25EC',
		trie: '\u225C',
		triminus: '\u2A3A',
		TripleDot: '\u20DB',
		triplus: '\u2A39',
		trisb: '\u29CD',
		tritime: '\u2A3B',
		trpezium: '\u23E2',
		Tscr: '\uD835\uDCAF',
		tscr: '\uD835\uDCC9',
		TScy: '\u0426',
		tscy: '\u0446',
		TSHcy: '\u040B',
		tshcy: '\u045B',
		Tstrok: '\u0166',
		tstrok: '\u0167',
		twixt: '\u226C',
		twoheadleftarrow: '\u219E',
		twoheadrightarrow: '\u21A0',
		Uacute: '\u00DA',
		uacute: '\u00FA',
		Uarr: '\u219F',
		uArr: '\u21D1',
		uarr: '\u2191',
		Uarrocir: '\u2949',
		Ubrcy: '\u040E',
		ubrcy: '\u045E',
		Ubreve: '\u016C',
		ubreve: '\u016D',
		Ucirc: '\u00DB',
		ucirc: '\u00FB',
		Ucy: '\u0423',
		ucy: '\u0443',
		udarr: '\u21C5',
		Udblac: '\u0170',
		udblac: '\u0171',
		udhar: '\u296E',
		ufisht: '\u297E',
		Ufr: '\uD835\uDD18',
		ufr: '\uD835\uDD32',
		Ugrave: '\u00D9',
		ugrave: '\u00F9',
		uHar: '\u2963',
		uharl: '\u21BF',
		uharr: '\u21BE',
		uhblk: '\u2580',
		ulcorn: '\u231C',
		ulcorner: '\u231C',
		ulcrop: '\u230F',
		ultri: '\u25F8',
		Umacr: '\u016A',
		umacr: '\u016B',
		uml: '\u00A8',
		UnderBar: '\u005F',
		UnderBrace: '\u23DF',
		UnderBracket: '\u23B5',
		UnderParenthesis: '\u23DD',
		Union: '\u22C3',
		UnionPlus: '\u228E',
		Uogon: '\u0172',
		uogon: '\u0173',
		Uopf: '\uD835\uDD4C',
		uopf: '\uD835\uDD66',
		UpArrow: '\u2191',
		Uparrow: '\u21D1',
		uparrow: '\u2191',
		UpArrowBar: '\u2912',
		UpArrowDownArrow: '\u21C5',
		UpDownArrow: '\u2195',
		Updownarrow: '\u21D5',
		updownarrow: '\u2195',
		UpEquilibrium: '\u296E',
		upharpoonleft: '\u21BF',
		upharpoonright: '\u21BE',
		uplus: '\u228E',
		UpperLeftArrow: '\u2196',
		UpperRightArrow: '\u2197',
		Upsi: '\u03D2',
		upsi: '\u03C5',
		upsih: '\u03D2',
		Upsilon: '\u03A5',
		upsilon: '\u03C5',
		UpTee: '\u22A5',
		UpTeeArrow: '\u21A5',
		upuparrows: '\u21C8',
		urcorn: '\u231D',
		urcorner: '\u231D',
		urcrop: '\u230E',
		Uring: '\u016E',
		uring: '\u016F',
		urtri: '\u25F9',
		Uscr: '\uD835\uDCB0',
		uscr: '\uD835\uDCCA',
		utdot: '\u22F0',
		Utilde: '\u0168',
		utilde: '\u0169',
		utri: '\u25B5',
		utrif: '\u25B4',
		uuarr: '\u21C8',
		Uuml: '\u00DC',
		uuml: '\u00FC',
		uwangle: '\u29A7',
		vangrt: '\u299C',
		varepsilon: '\u03F5',
		varkappa: '\u03F0',
		varnothing: '\u2205',
		varphi: '\u03D5',
		varpi: '\u03D6',
		varpropto: '\u221D',
		vArr: '\u21D5',
		varr: '\u2195',
		varrho: '\u03F1',
		varsigma: '\u03C2',
		varsubsetneq: '\u228A\uFE00',
		varsubsetneqq: '\u2ACB\uFE00',
		varsupsetneq: '\u228B\uFE00',
		varsupsetneqq: '\u2ACC\uFE00',
		vartheta: '\u03D1',
		vartriangleleft: '\u22B2',
		vartriangleright: '\u22B3',
		Vbar: '\u2AEB',
		vBar: '\u2AE8',
		vBarv: '\u2AE9',
		Vcy: '\u0412',
		vcy: '\u0432',
		VDash: '\u22AB',
		Vdash: '\u22A9',
		vDash: '\u22A8',
		vdash: '\u22A2',
		Vdashl: '\u2AE6',
		Vee: '\u22C1',
		vee: '\u2228',
		veebar: '\u22BB',
		veeeq: '\u225A',
		vellip: '\u22EE',
		Verbar: '\u2016',
		verbar: '\u007C',
		Vert: '\u2016',
		vert: '\u007C',
		VerticalBar: '\u2223',
		VerticalLine: '\u007C',
		VerticalSeparator: '\u2758',
		VerticalTilde: '\u2240',
		VeryThinSpace: '\u200A',
		Vfr: '\uD835\uDD19',
		vfr: '\uD835\uDD33',
		vltri: '\u22B2',
		vnsub: '\u2282\u20D2',
		vnsup: '\u2283\u20D2',
		Vopf: '\uD835\uDD4D',
		vopf: '\uD835\uDD67',
		vprop: '\u221D',
		vrtri: '\u22B3',
		Vscr: '\uD835\uDCB1',
		vscr: '\uD835\uDCCB',
		vsubnE: '\u2ACB\uFE00',
		vsubne: '\u228A\uFE00',
		vsupnE: '\u2ACC\uFE00',
		vsupne: '\u228B\uFE00',
		Vvdash: '\u22AA',
		vzigzag: '\u299A',
		Wcirc: '\u0174',
		wcirc: '\u0175',
		wedbar: '\u2A5F',
		Wedge: '\u22C0',
		wedge: '\u2227',
		wedgeq: '\u2259',
		weierp: '\u2118',
		Wfr: '\uD835\uDD1A',
		wfr: '\uD835\uDD34',
		Wopf: '\uD835\uDD4E',
		wopf: '\uD835\uDD68',
		wp: '\u2118',
		wr: '\u2240',
		wreath: '\u2240',
		Wscr: '\uD835\uDCB2',
		wscr: '\uD835\uDCCC',
		xcap: '\u22C2',
		xcirc: '\u25EF',
		xcup: '\u22C3',
		xdtri: '\u25BD',
		Xfr: '\uD835\uDD1B',
		xfr: '\uD835\uDD35',
		xhArr: '\u27FA',
		xharr: '\u27F7',
		Xi: '\u039E',
		xi: '\u03BE',
		xlArr: '\u27F8',
		xlarr: '\u27F5',
		xmap: '\u27FC',
		xnis: '\u22FB',
		xodot: '\u2A00',
		Xopf: '\uD835\uDD4F',
		xopf: '\uD835\uDD69',
		xoplus: '\u2A01',
		xotime: '\u2A02',
		xrArr: '\u27F9',
		xrarr: '\u27F6',
		Xscr: '\uD835\uDCB3',
		xscr: '\uD835\uDCCD',
		xsqcup: '\u2A06',
		xuplus: '\u2A04',
		xutri: '\u25B3',
		xvee: '\u22C1',
		xwedge: '\u22C0',
		Yacute: '\u00DD',
		yacute: '\u00FD',
		YAcy: '\u042F',
		yacy: '\u044F',
		Ycirc: '\u0176',
		ycirc: '\u0177',
		Ycy: '\u042B',
		ycy: '\u044B',
		yen: '\u00A5',
		Yfr: '\uD835\uDD1C',
		yfr: '\uD835\uDD36',
		YIcy: '\u0407',
		yicy: '\u0457',
		Yopf: '\uD835\uDD50',
		yopf: '\uD835\uDD6A',
		Yscr: '\uD835\uDCB4',
		yscr: '\uD835\uDCCE',
		YUcy: '\u042E',
		yucy: '\u044E',
		Yuml: '\u0178',
		yuml: '\u00FF',
		Zacute: '\u0179',
		zacute: '\u017A',
		Zcaron: '\u017D',
		zcaron: '\u017E',
		Zcy: '\u0417',
		zcy: '\u0437',
		Zdot: '\u017B',
		zdot: '\u017C',
		zeetrf: '\u2128',
		ZeroWidthSpace: '\u200B',
		Zeta: '\u0396',
		zeta: '\u03B6',
		Zfr: '\u2128',
		zfr: '\uD835\uDD37',
		ZHcy: '\u0416',
		zhcy: '\u0436',
		zigrarr: '\u21DD',
		Zopf: '\u2124',
		zopf: '\uD835\uDD6B',
		Zscr: '\uD835\uDCB5',
		zscr: '\uD835\uDCCF',
		zwj: '\u200D',
		zwnj: '\u200C',
	});
	
	/**
	 * @deprecated use `HTML_ENTITIES` instead
	 * @see HTML_ENTITIES
	 */
	exports.entityMap = exports.HTML_ENTITIES;


/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	var dom = __webpack_require__(1282)
	exports.DOMImplementation = dom.DOMImplementation
	exports.XMLSerializer = dom.XMLSerializer
	exports.DOMParser = __webpack_require__(1534).DOMParser


/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	var NAMESPACE = __webpack_require__(912).NAMESPACE;
	
	//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
	//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
	//[5]   	Name	   ::=   	NameStartChar (NameChar)*
	var nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]///\u10000-\uEFFFF
	var nameChar = new RegExp("[\\-\\.0-9"+nameStartChar.source.slice(1,-1)+"\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
	var tagNamePattern = new RegExp('^'+nameStartChar.source+nameChar.source+'*(?:\:'+nameStartChar.source+nameChar.source+'*)?$');
	//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
	//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')
	
	//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
	//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
	var S_TAG = 0;//tag name offerring
	var S_ATTR = 1;//attr name offerring
	var S_ATTR_SPACE=2;//attr name end and space offer
	var S_EQ = 3;//=space?
	var S_ATTR_NOQUOT_VALUE = 4;//attr value(no quot value only)
	var S_ATTR_END = 5;//attr value end and no space(quot end)
	var S_TAG_SPACE = 6;//(attr value end || tag end ) && (space offer)
	var S_TAG_CLOSE = 7;//closed el<el />
	
	/**
	 * Creates an error that will not be caught by XMLReader aka the SAX parser.
	 *
	 * @param {string} message
	 * @param {any?} locator Optional, can provide details about the location in the source
	 * @constructor
	 */
	function ParseError(message, locator) {
		this.message = message
		this.locator = locator
		if(Error.captureStackTrace) Error.captureStackTrace(this, ParseError);
	}
	ParseError.prototype = new Error();
	ParseError.prototype.name = ParseError.name
	
	function XMLReader(){
	
	}
	
	XMLReader.prototype = {
		parse:function(source,defaultNSMap,entityMap){
			var domBuilder = this.domBuilder;
			domBuilder.startDocument();
			_copy(defaultNSMap ,defaultNSMap = {})
			parse(source,defaultNSMap,entityMap,
					domBuilder,this.errorHandler);
			domBuilder.endDocument();
		}
	}
	function parse(source,defaultNSMapCopy,entityMap,domBuilder,errorHandler){
		function fixedFromCharCode(code) {
			// String.prototype.fromCharCode does not supports
			// > 2 bytes unicode chars directly
			if (code > 0xffff) {
				code -= 0x10000;
				var surrogate1 = 0xd800 + (code >> 10)
					, surrogate2 = 0xdc00 + (code & 0x3ff);
	
				return String.fromCharCode(surrogate1, surrogate2);
			} else {
				return String.fromCharCode(code);
			}
		}
		function entityReplacer(a){
			var k = a.slice(1,-1);
			if (Object.hasOwnProperty.call(entityMap, k)) {
				return entityMap[k];
			}else if(k.charAt(0) === '#'){
				return fixedFromCharCode(parseInt(k.substr(1).replace('x','0x')))
			}else{
				errorHandler.error('entity not found:'+a);
				return a;
			}
		}
		function appendText(end){//has some bugs
			if(end>start){
				var xt = source.substring(start,end).replace(/&#?\w+;/g,entityReplacer);
				locator&&position(start);
				domBuilder.characters(xt,0,end-start);
				start = end
			}
		}
		function position(p,m){
			while(p>=lineEnd && (m = linePattern.exec(source))){
				lineStart = m.index;
				lineEnd = lineStart + m[0].length;
				locator.lineNumber++;
				//console.log('line++:',locator,startPos,endPos)
			}
			locator.columnNumber = p-lineStart+1;
		}
		var lineStart = 0;
		var lineEnd = 0;
		var linePattern = /.*(?:\r\n?|\n)|.*$/g
		var locator = domBuilder.locator;
	
		var parseStack = [{currentNSMap:defaultNSMapCopy}]
		var closeMap = {};
		var start = 0;
		while(true){
			try{
				var tagStart = source.indexOf('<',start);
				if(tagStart<0){
					if(!source.substr(start).match(/^\s*$/)){
						var doc = domBuilder.doc;
		    			var text = doc.createTextNode(source.substr(start));
		    			doc.appendChild(text);
		    			domBuilder.currentElement = text;
					}
					return;
				}
				if(tagStart>start){
					appendText(tagStart);
				}
				switch(source.charAt(tagStart+1)){
				case '/':
					var end = source.indexOf('>',tagStart+3);
					var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, '');
					var config = parseStack.pop();
					if(end<0){
	
		        		tagName = source.substring(tagStart+2).replace(/[\s<].*/,'');
		        		errorHandler.error("end tag name: "+tagName+' is not complete:'+config.tagName);
		        		end = tagStart+1+tagName.length;
		        	}else if(tagName.match(/\s</)){
		        		tagName = tagName.replace(/[\s<].*/,'');
		        		errorHandler.error("end tag name: "+tagName+' maybe not complete');
		        		end = tagStart+1+tagName.length;
					}
					var localNSMap = config.localNSMap;
					var endMatch = config.tagName == tagName;
					var endIgnoreCaseMach = endMatch || config.tagName&&config.tagName.toLowerCase() == tagName.toLowerCase()
			        if(endIgnoreCaseMach){
			        	domBuilder.endElement(config.uri,config.localName,tagName);
						if(localNSMap){
							for (var prefix in localNSMap) {
								if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
									domBuilder.endPrefixMapping(prefix);
								}
							}
						}
						if(!endMatch){
			            	errorHandler.fatalError("end tag name: "+tagName+' is not match the current start tagName:'+config.tagName ); // No known test case
						}
			        }else{
			        	parseStack.push(config)
			        }
	
					end++;
					break;
					// end elment
				case '?':// <?...?>
					locator&&position(tagStart);
					end = parseInstruction(source,tagStart,domBuilder);
					break;
				case '!':// <!doctype,<![CDATA,<!--
					locator&&position(tagStart);
					end = parseDCC(source,tagStart,domBuilder,errorHandler);
					break;
				default:
					locator&&position(tagStart);
					var el = new ElementAttributes();
					var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
					//elStartEnd
					var end = parseElementStartPart(source,tagStart,el,currentNSMap,entityReplacer,errorHandler);
					var len = el.length;
	
	
					if(!el.closed && fixSelfClosed(source,end,el.tagName,closeMap)){
						el.closed = true;
						if(!entityMap.nbsp){
							errorHandler.warning('unclosed xml attribute');
						}
					}
					if(locator && len){
						var locator2 = copyLocator(locator,{});
						//try{//attribute position fixed
						for(var i = 0;i<len;i++){
							var a = el[i];
							position(a.offset);
							a.locator = copyLocator(locator,{});
						}
						domBuilder.locator = locator2
						if(appendElement(el,domBuilder,currentNSMap)){
							parseStack.push(el)
						}
						domBuilder.locator = locator;
					}else{
						if(appendElement(el,domBuilder,currentNSMap)){
							parseStack.push(el)
						}
					}
	
					if (NAMESPACE.isHTML(el.uri) && !el.closed) {
						end = parseHtmlSpecialContent(source,end,el.tagName,entityReplacer,domBuilder)
					} else {
						end++;
					}
				}
			}catch(e){
				if (e instanceof ParseError) {
					throw e;
				}
				errorHandler.error('element parse error: '+e)
				end = -1;
			}
			if(end>start){
				start = end;
			}else{
				//TODO: 这里有可能sax回退，有位置错误风险
				appendText(Math.max(tagStart,start)+1);
			}
		}
	}
	function copyLocator(f,t){
		t.lineNumber = f.lineNumber;
		t.columnNumber = f.columnNumber;
		return t;
	}
	
	/**
	 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
	 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
	 */
	function parseElementStartPart(source,start,el,currentNSMap,entityReplacer,errorHandler){
	
		/**
		 * @param {string} qname
		 * @param {string} value
		 * @param {number} startIndex
		 */
		function addAttribute(qname, value, startIndex) {
			if (el.attributeNames.hasOwnProperty(qname)) {
				errorHandler.fatalError('Attribute ' + qname + ' redefined')
			}
			el.addValue(
				qname,
				// @see https://www.w3.org/TR/xml/#AVNormalize
				// since the xmldom sax parser does not "interpret" DTD the following is not implemented:
				// - recursive replacement of (DTD) entity references
				// - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
				value.replace(/[\t\n\r]/g, ' ').replace(/&#?\w+;/g, entityReplacer),
				startIndex
			)
		}
		var attrName;
		var value;
		var p = ++start;
		var s = S_TAG;//status
		while(true){
			var c = source.charAt(p);
			switch(c){
			case '=':
				if(s === S_ATTR){//attrName
					attrName = source.slice(start,p);
					s = S_EQ;
				}else if(s === S_ATTR_SPACE){
					s = S_EQ;
				}else{
					//fatalError: equal must after attrName or space after attrName
					throw new Error('attribute equal must after attrName'); // No known test case
				}
				break;
			case '\'':
			case '"':
				if(s === S_EQ || s === S_ATTR //|| s == S_ATTR_SPACE
					){//equal
					if(s === S_ATTR){
						errorHandler.warning('attribute value must after "="')
						attrName = source.slice(start,p)
					}
					start = p+1;
					p = source.indexOf(c,start)
					if(p>0){
						value = source.slice(start, p);
						addAttribute(attrName, value, start-1);
						s = S_ATTR_END;
					}else{
						//fatalError: no end quot match
						throw new Error('attribute value no end \''+c+'\' match');
					}
				}else if(s == S_ATTR_NOQUOT_VALUE){
					value = source.slice(start, p);
					addAttribute(attrName, value, start);
					errorHandler.warning('attribute "'+attrName+'" missed start quot('+c+')!!');
					start = p+1;
					s = S_ATTR_END
				}else{
					//fatalError: no equal before
					throw new Error('attribute value must after "="'); // No known test case
				}
				break;
			case '/':
				switch(s){
				case S_TAG:
					el.setTagName(source.slice(start,p));
				case S_ATTR_END:
				case S_TAG_SPACE:
				case S_TAG_CLOSE:
					s =S_TAG_CLOSE;
					el.closed = true;
				case S_ATTR_NOQUOT_VALUE:
				case S_ATTR:
					break;
					case S_ATTR_SPACE:
						el.closed = true;
					break;
				//case S_EQ:
				default:
					throw new Error("attribute invalid close char('/')") // No known test case
				}
				break;
			case ''://end document
				errorHandler.error('unexpected end of input');
				if(s == S_TAG){
					el.setTagName(source.slice(start,p));
				}
				return p;
			case '>':
				switch(s){
				case S_TAG:
					el.setTagName(source.slice(start,p));
				case S_ATTR_END:
				case S_TAG_SPACE:
				case S_TAG_CLOSE:
					break;//normal
				case S_ATTR_NOQUOT_VALUE://Compatible state
				case S_ATTR:
					value = source.slice(start,p);
					if(value.slice(-1) === '/'){
						el.closed  = true;
						value = value.slice(0,-1)
					}
				case S_ATTR_SPACE:
					if(s === S_ATTR_SPACE){
						value = attrName;
					}
					if(s == S_ATTR_NOQUOT_VALUE){
						errorHandler.warning('attribute "'+value+'" missed quot(")!');
						addAttribute(attrName, value, start)
					}else{
						if(!NAMESPACE.isHTML(currentNSMap['']) || !value.match(/^(?:disabled|checked|selected)$/i)){
							errorHandler.warning('attribute "'+value+'" missed value!! "'+value+'" instead!!')
						}
						addAttribute(value, value, start)
					}
					break;
				case S_EQ:
					throw new Error('attribute value missed!!');
				}
	//			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
				return p;
			/*xml space '\x20' | #x9 | #xD | #xA; */
			case '\u0080':
				c = ' ';
			default:
				if(c<= ' '){//space
					switch(s){
					case S_TAG:
						el.setTagName(source.slice(start,p));//tagName
						s = S_TAG_SPACE;
						break;
					case S_ATTR:
						attrName = source.slice(start,p)
						s = S_ATTR_SPACE;
						break;
					case S_ATTR_NOQUOT_VALUE:
						var value = source.slice(start, p);
						errorHandler.warning('attribute "'+value+'" missed quot(")!!');
						addAttribute(attrName, value, start)
					case S_ATTR_END:
						s = S_TAG_SPACE;
						break;
					//case S_TAG_SPACE:
					//case S_EQ:
					//case S_ATTR_SPACE:
					//	void();break;
					//case S_TAG_CLOSE:
						//ignore warning
					}
				}else{//not space
	//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
	//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
					switch(s){
					//case S_TAG:void();break;
					//case S_ATTR:void();break;
					//case S_ATTR_NOQUOT_VALUE:void();break;
					case S_ATTR_SPACE:
						var tagName =  el.tagName;
						if (!NAMESPACE.isHTML(currentNSMap['']) || !attrName.match(/^(?:disabled|checked|selected)$/i)) {
							errorHandler.warning('attribute "'+attrName+'" missed value!! "'+attrName+'" instead2!!')
						}
						addAttribute(attrName, attrName, start);
						start = p;
						s = S_ATTR;
						break;
					case S_ATTR_END:
						errorHandler.warning('attribute space is required"'+attrName+'"!!')
					case S_TAG_SPACE:
						s = S_ATTR;
						start = p;
						break;
					case S_EQ:
						s = S_ATTR_NOQUOT_VALUE;
						start = p;
						break;
					case S_TAG_CLOSE:
						throw new Error("elements closed character '/' and '>' must be connected to");
					}
				}
			}//end outer switch
			//console.log('p++',p)
			p++;
		}
	}
	/**
	 * @return true if has new namespace define
	 */
	function appendElement(el,domBuilder,currentNSMap){
		var tagName = el.tagName;
		var localNSMap = null;
		//var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
		var i = el.length;
		while(i--){
			var a = el[i];
			var qName = a.qName;
			var value = a.value;
			var nsp = qName.indexOf(':');
			if(nsp>0){
				var prefix = a.prefix = qName.slice(0,nsp);
				var localName = qName.slice(nsp+1);
				var nsPrefix = prefix === 'xmlns' && localName
			}else{
				localName = qName;
				prefix = null
				nsPrefix = qName === 'xmlns' && ''
			}
			//can not set prefix,because prefix !== ''
			a.localName = localName ;
			//prefix == null for no ns prefix attribute
			if(nsPrefix !== false){//hack!!
				if(localNSMap == null){
					localNSMap = {}
					//console.log(currentNSMap,0)
					_copy(currentNSMap,currentNSMap={})
					//console.log(currentNSMap,1)
				}
				currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
				a.uri = NAMESPACE.XMLNS
				domBuilder.startPrefixMapping(nsPrefix, value)
			}
		}
		var i = el.length;
		while(i--){
			a = el[i];
			var prefix = a.prefix;
			if(prefix){//no prefix attribute has no namespace
				if(prefix === 'xml'){
					a.uri = NAMESPACE.XML;
				}if(prefix !== 'xmlns'){
					a.uri = currentNSMap[prefix || '']
	
					//{console.log('###'+a.qName,domBuilder.locator.systemId+'',currentNSMap,a.uri)}
				}
			}
		}
		var nsp = tagName.indexOf(':');
		if(nsp>0){
			prefix = el.prefix = tagName.slice(0,nsp);
			localName = el.localName = tagName.slice(nsp+1);
		}else{
			prefix = null;//important!!
			localName = el.localName = tagName;
		}
		//no prefix element has default namespace
		var ns = el.uri = currentNSMap[prefix || ''];
		domBuilder.startElement(ns,localName,tagName,el);
		//endPrefixMapping and startPrefixMapping have not any help for dom builder
		//localNSMap = null
		if(el.closed){
			domBuilder.endElement(ns,localName,tagName);
			if(localNSMap){
				for (prefix in localNSMap) {
					if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
						domBuilder.endPrefixMapping(prefix);
					}
				}
			}
		}else{
			el.currentNSMap = currentNSMap;
			el.localNSMap = localNSMap;
			//parseStack.push(el);
			return true;
		}
	}
	function parseHtmlSpecialContent(source,elStartEnd,tagName,entityReplacer,domBuilder){
		if(/^(?:script|textarea)$/i.test(tagName)){
			var elEndStart =  source.indexOf('</'+tagName+'>',elStartEnd);
			var text = source.substring(elStartEnd+1,elEndStart);
			if(/[&<]/.test(text)){
				if(/^script$/i.test(tagName)){
					//if(!/\]\]>/.test(text)){
						//lexHandler.startCDATA();
						domBuilder.characters(text,0,text.length);
						//lexHandler.endCDATA();
						return elEndStart;
					//}
				}//}else{//text area
					text = text.replace(/&#?\w+;/g,entityReplacer);
					domBuilder.characters(text,0,text.length);
					return elEndStart;
				//}
	
			}
		}
		return elStartEnd+1;
	}
	function fixSelfClosed(source,elStartEnd,tagName,closeMap){
		//if(tagName in closeMap){
		var pos = closeMap[tagName];
		if(pos == null){
			//console.log(tagName)
			pos =  source.lastIndexOf('</'+tagName+'>')
			if(pos<elStartEnd){//忘记闭合
				pos = source.lastIndexOf('</'+tagName)
			}
			closeMap[tagName] =pos
		}
		return pos<elStartEnd;
		//}
	}
	
	function _copy (source, target) {
		for (var n in source) {
			if (Object.prototype.hasOwnProperty.call(source, n)) {
				target[n] = source[n];
			}
		}
	}
	
	function parseDCC(source,start,domBuilder,errorHandler){//sure start with '<!'
		var next= source.charAt(start+2)
		switch(next){
		case '-':
			if(source.charAt(start + 3) === '-'){
				var end = source.indexOf('-->',start+4);
				//append comment source.substring(4,end)//<!--
				if(end>start){
					domBuilder.comment(source,start+4,end-start-4);
					return end+3;
				}else{
					errorHandler.error("Unclosed comment");
					return -1;
				}
			}else{
				//error
				return -1;
			}
		default:
			if(source.substr(start+3,6) == 'CDATA['){
				var end = source.indexOf(']]>',start+9);
				domBuilder.startCDATA();
				domBuilder.characters(source,start+9,end-start-9);
				domBuilder.endCDATA()
				return end+3;
			}
			//<!DOCTYPE
			//startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
			var matchs = split(source,start);
			var len = matchs.length;
			if(len>1 && /!doctype/i.test(matchs[0][0])){
				var name = matchs[1][0];
				var pubid = false;
				var sysid = false;
				if(len>3){
					if(/^public$/i.test(matchs[2][0])){
						pubid = matchs[3][0];
						sysid = len>4 && matchs[4][0];
					}else if(/^system$/i.test(matchs[2][0])){
						sysid = matchs[3][0];
					}
				}
				var lastMatch = matchs[len-1]
				domBuilder.startDTD(name, pubid, sysid);
				domBuilder.endDTD();
	
				return lastMatch.index+lastMatch[0].length
			}
		}
		return -1;
	}
	
	
	
	function parseInstruction(source,start,domBuilder){
		var end = source.indexOf('?>',start);
		if(end){
			var match = source.substring(start,end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
			if(match){
				var len = match[0].length;
				domBuilder.processingInstruction(match[1], match[2]) ;
				return end+2;
			}else{//error
				return -1;
			}
		}
		return -1;
	}
	
	function ElementAttributes(){
		this.attributeNames = {}
	}
	ElementAttributes.prototype = {
		setTagName:function(tagName){
			if(!tagNamePattern.test(tagName)){
				throw new Error('invalid tagName:'+tagName)
			}
			this.tagName = tagName
		},
		addValue:function(qName, value, offset) {
			if(!tagNamePattern.test(qName)){
				throw new Error('invalid attribute:'+qName)
			}
			this.attributeNames[qName] = this.length;
			this[this.length++] = {qName:qName,value:value,offset:offset}
		},
		length:0,
		getLocalName:function(i){return this[i].localName},
		getLocator:function(i){return this[i].locator},
		getQName:function(i){return this[i].qName},
		getURI:function(i){return this[i].uri},
		getValue:function(i){return this[i].value}
	//	,getIndex:function(uri, localName)){
	//		if(localName){
	//
	//		}else{
	//			var qName = uri
	//		}
	//	},
	//	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
	//	getType:function(uri,localName){}
	//	getType:function(i){},
	}
	
	
	
	function split(source,start){
		var match;
		var buf = [];
		var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
		reg.lastIndex = start;
		reg.exec(source);//skip <
		while(match = reg.exec(source)){
			buf.push(match);
			if(match[1])return buf;
		}
	}
	
	exports.XMLReader = XMLReader;
	exports.ParseError = ParseError;


/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	;(function () {
	
	  var object =  true ? exports : this; // #8: web workers
	  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	  function InvalidCharacterError(message) {
	    this.message = message;
	  }
	  InvalidCharacterError.prototype = new Error;
	  InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	  // encoder
	  // [https://gist.github.com/999166] by [https://github.com/nignag]
	  object.btoa || (
	  object.btoa = function (input) {
	    for (
	      // initialize result and counter
	      var block, charCode, idx = 0, map = chars, output = '';
	      // if the next input index does not exist:
	      //   change the mapping table to "="
	      //   check if d has no fractional digits
	      input.charAt(idx | 0) || (map = '=', idx % 1);
	      // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	      output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	    ) {
	      charCode = input.charCodeAt(idx += 3/4);
	      if (charCode > 0xFF) {
	        throw new InvalidCharacterError("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
	      }
	      block = block << 8 | charCode;
	    }
	    return output;
	  });
	
	  // decoder
	  // [https://gist.github.com/1020396] by [https://github.com/atk]
	  object.atob || (
	  object.atob = function (input) {
	    input = input.replace(/=+$/, '');
	    if (input.length % 4 == 1) {
	      throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
	    }
	    for (
	      // initialize result and counters
	      var bc = 0, bs, buffer, idx = 0, output = '';
	      // get next character
	      buffer = input.charAt(idx++);
	      // character found in table? initialize bit storage and add its ascii value;
	      ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
	        // and if not first of each 4 characters,
	        // convert the first 8 bits to one ascii character
	        bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
	    ) {
	      // try to find character in table (0-63, not found => -1)
	      buffer = chars.indexOf(buffer);
	    }
	    return output;
	  });
	
	}());


/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {module.exports = AlgoliaSearchCore;
	
	var errors = __webpack_require__(913);
	var exitPromise = __webpack_require__(1546);
	var IndexCore = __webpack_require__(1540);
	var store = __webpack_require__(1549);
	
	// We will always put the API KEY in the JSON body in case of too long API KEY,
	// to avoid query string being too long and failing in various conditions (our server limit, browser limit,
	// proxies limit)
	var MAX_API_KEY_LENGTH = 500;
	var RESET_APP_DATA_TIMER =
	  process.env.RESET_APP_DATA_TIMER && parseInt(process.env.RESET_APP_DATA_TIMER, 10) ||
	  60 * 2 * 1000; // after 2 minutes reset to first host
	
	/*
	 * Algolia Search library initialization
	 * https://www.algolia.com/
	 *
	 * @param {string} applicationID - Your applicationID, found in your dashboard
	 * @param {string} apiKey - Your API key, found in your dashboard
	 * @param {Object} [opts]
	 * @param {number} [opts.timeout=2000] - The request timeout set in milliseconds,
	 * another request will be issued after this timeout
	 * @param {string} [opts.protocol='https:'] - The protocol used to query Algolia Search API.
	 *                                        Set to 'http:' to force using http.
	 * @param {Object|Array} [opts.hosts={
	 *           read: [this.applicationID + '-dsn.algolia.net'].concat([
	 *             this.applicationID + '-1.algolianet.com',
	 *             this.applicationID + '-2.algolianet.com',
	 *             this.applicationID + '-3.algolianet.com']
	 *           ]),
	 *           write: [this.applicationID + '.algolia.net'].concat([
	 *             this.applicationID + '-1.algolianet.com',
	 *             this.applicationID + '-2.algolianet.com',
	 *             this.applicationID + '-3.algolianet.com']
	 *           ]) - The hosts to use for Algolia Search API.
	 *           If you provide them, you will less benefit from our HA implementation
	 */
	function AlgoliaSearchCore(applicationID, apiKey, opts) {
	  var debug = __webpack_require__(802)('algoliasearch');
	
	  var clone = __webpack_require__(673);
	  var isArray = __webpack_require__(933);
	  var map = __webpack_require__(914);
	
	  var usage = 'Usage: algoliasearch(applicationID, apiKey, opts)';
	
	  if (opts._allowEmptyCredentials !== true && !applicationID) {
	    throw new errors.AlgoliaSearchError('Please provide an application ID. ' + usage);
	  }
	
	  if (opts._allowEmptyCredentials !== true && !apiKey) {
	    throw new errors.AlgoliaSearchError('Please provide an API key. ' + usage);
	  }
	
	  this.applicationID = applicationID;
	  this.apiKey = apiKey;
	
	  this.hosts = {
	    read: [],
	    write: []
	  };
	
	  opts = opts || {};
	
	  this._timeouts = opts.timeouts || {
	    connect: 1 * 1000, // 500ms connect is GPRS latency
	    read: 2 * 1000,
	    write: 30 * 1000
	  };
	
	  // backward compat, if opts.timeout is passed, we use it to configure all timeouts like before
	  if (opts.timeout) {
	    this._timeouts.connect = this._timeouts.read = this._timeouts.write = opts.timeout;
	  }
	
	  var protocol = opts.protocol || 'https:';
	  // while we advocate for colon-at-the-end values: 'http:' for `opts.protocol`
	  // we also accept `http` and `https`. It's a common error.
	  if (!/:$/.test(protocol)) {
	    protocol = protocol + ':';
	  }
	
	  if (protocol !== 'http:' && protocol !== 'https:') {
	    throw new errors.AlgoliaSearchError('protocol must be `http:` or `https:` (was `' + opts.protocol + '`)');
	  }
	
	  this._checkAppIdData();
	
	  if (!opts.hosts) {
	    var defaultHosts = map(this._shuffleResult, function(hostNumber) {
	      return applicationID + '-' + hostNumber + '.algolianet.com';
	    });
	
	    // no hosts given, compute defaults
	    var mainSuffix = (opts.dsn === false ? '' : '-dsn') + '.algolia.net';
	    this.hosts.read = [this.applicationID + mainSuffix].concat(defaultHosts);
	    this.hosts.write = [this.applicationID + '.algolia.net'].concat(defaultHosts);
	  } else if (isArray(opts.hosts)) {
	    // when passing custom hosts, we need to have a different host index if the number
	    // of write/read hosts are different.
	    this.hosts.read = clone(opts.hosts);
	    this.hosts.write = clone(opts.hosts);
	  } else {
	    this.hosts.read = clone(opts.hosts.read);
	    this.hosts.write = clone(opts.hosts.write);
	  }
	
	  // add protocol and lowercase hosts
	  this.hosts.read = map(this.hosts.read, prepareHost(protocol));
	  this.hosts.write = map(this.hosts.write, prepareHost(protocol));
	
	  this.extraHeaders = {};
	
	  // In some situations you might want to warm the cache
	  this.cache = opts._cache || {};
	
	  this._ua = opts._ua;
	  this._useCache = opts._useCache === undefined || opts._cache ? true : opts._useCache;
	  this._useRequestCache = this._useCache && opts._useRequestCache;
	  this._useFallback = opts.useFallback === undefined ? true : opts.useFallback;
	
	  this._setTimeout = opts._setTimeout;
	
	  debug('init done, %j', this);
	}
	
	/*
	 * Get the index object initialized
	 *
	 * @param indexName the name of index
	 * @param callback the result callback with one argument (the Index instance)
	 */
	AlgoliaSearchCore.prototype.initIndex = function(indexName) {
	  return new IndexCore(this, indexName);
	};
	
	/**
	* Add an extra field to the HTTP request
	*
	* @param name the header field name
	* @param value the header field value
	*/
	AlgoliaSearchCore.prototype.setExtraHeader = function(name, value) {
	  this.extraHeaders[name.toLowerCase()] = value;
	};
	
	/**
	* Get the value of an extra HTTP header
	*
	* @param name the header field name
	*/
	AlgoliaSearchCore.prototype.getExtraHeader = function(name) {
	  return this.extraHeaders[name.toLowerCase()];
	};
	
	/**
	* Remove an extra field from the HTTP request
	*
	* @param name the header field name
	*/
	AlgoliaSearchCore.prototype.unsetExtraHeader = function(name) {
	  delete this.extraHeaders[name.toLowerCase()];
	};
	
	/**
	* Augment sent x-algolia-agent with more data, each agent part
	* is automatically separated from the others by a semicolon;
	*
	* @param algoliaAgent the agent to add
	*/
	AlgoliaSearchCore.prototype.addAlgoliaAgent = function(algoliaAgent) {
	  var algoliaAgentWithDelimiter = '; ' + algoliaAgent;
	
	  if (this._ua.indexOf(algoliaAgentWithDelimiter) === -1) {
	    this._ua += algoliaAgentWithDelimiter;
	  }
	};
	
	/*
	 * Wrapper that try all hosts to maximize the quality of service
	 */
	AlgoliaSearchCore.prototype._jsonRequest = function(initialOpts) {
	  this._checkAppIdData();
	
	  var requestDebug = __webpack_require__(802)('algoliasearch:' + initialOpts.url);
	
	
	  var body;
	  var cacheID;
	  var additionalUA = initialOpts.additionalUA || '';
	  var cache = initialOpts.cache;
	  var client = this;
	  var tries = 0;
	  var usingFallback = false;
	  var hasFallback = client._useFallback && client._request.fallback && initialOpts.fallback;
	  var headers;
	
	  if (
	    this.apiKey.length > MAX_API_KEY_LENGTH &&
	    initialOpts.body !== undefined &&
	    (initialOpts.body.params !== undefined || // index.search()
	    initialOpts.body.requests !== undefined) // client.search()
	  ) {
	    initialOpts.body.apiKey = this.apiKey;
	    headers = this._computeRequestHeaders({
	      additionalUA: additionalUA,
	      withApiKey: false,
	      headers: initialOpts.headers
	    });
	  } else {
	    headers = this._computeRequestHeaders({
	      additionalUA: additionalUA,
	      headers: initialOpts.headers
	    });
	  }
	
	  if (initialOpts.body !== undefined) {
	    body = safeJSONStringify(initialOpts.body);
	  }
	
	  requestDebug('request start');
	  var debugData = [];
	
	
	  function doRequest(requester, reqOpts) {
	    client._checkAppIdData();
	
	    var startTime = new Date();
	
	    if (client._useCache && !client._useRequestCache) {
	      cacheID = initialOpts.url;
	    }
	
	    // as we sometime use POST requests to pass parameters (like query='aa'),
	    // the cacheID must also include the body to be different between calls
	    if (client._useCache && !client._useRequestCache && body) {
	      cacheID += '_body_' + reqOpts.body;
	    }
	
	    // handle cache existence
	    if (isCacheValidWithCurrentID(!client._useRequestCache, cache, cacheID)) {
	      requestDebug('serving response from cache');
	
	      var responseText = cache[cacheID];
	
	      // Cache response must match the type of the original one
	      return client._promise.resolve({
	        body: JSON.parse(responseText),
	        responseText: responseText
	      });
	    }
	
	    // if we reached max tries
	    if (tries >= client.hosts[initialOpts.hostType].length) {
	      if (!hasFallback || usingFallback) {
	        requestDebug('could not get any response');
	        // then stop
	        return client._promise.reject(new errors.AlgoliaSearchError(
	          'Cannot connect to the AlgoliaSearch API.' +
	          ' Send an email to support@algolia.com to report and resolve the issue.' +
	          ' Application id was: ' + client.applicationID, {debugData: debugData}
	        ));
	      }
	
	      requestDebug('switching to fallback');
	
	      // let's try the fallback starting from here
	      tries = 0;
	
	      // method, url and body are fallback dependent
	      reqOpts.method = initialOpts.fallback.method;
	      reqOpts.url = initialOpts.fallback.url;
	      reqOpts.jsonBody = initialOpts.fallback.body;
	      if (reqOpts.jsonBody) {
	        reqOpts.body = safeJSONStringify(reqOpts.jsonBody);
	      }
	      // re-compute headers, they could be omitting the API KEY
	      headers = client._computeRequestHeaders({
	        additionalUA: additionalUA,
	        headers: initialOpts.headers
	      });
	
	      reqOpts.timeouts = client._getTimeoutsForRequest(initialOpts.hostType);
	      client._setHostIndexByType(0, initialOpts.hostType);
	      usingFallback = true; // the current request is now using fallback
	      return doRequest(client._request.fallback, reqOpts);
	    }
	
	    var currentHost = client._getHostByType(initialOpts.hostType);
	
	    var url = currentHost + reqOpts.url;
	    var options = {
	      body: reqOpts.body,
	      jsonBody: reqOpts.jsonBody,
	      method: reqOpts.method,
	      headers: headers,
	      timeouts: reqOpts.timeouts,
	      debug: requestDebug,
	      forceAuthHeaders: reqOpts.forceAuthHeaders
	    };
	
	    requestDebug('method: %s, url: %s, headers: %j, timeouts: %d',
	      options.method, url, options.headers, options.timeouts);
	
	    if (requester === client._request.fallback) {
	      requestDebug('using fallback');
	    }
	
	    // `requester` is any of this._request or this._request.fallback
	    // thus it needs to be called using the client as context
	    return requester.call(client, url, options).then(success, tryFallback);
	
	    function success(httpResponse) {
	      // compute the status of the response,
	      //
	      // When in browser mode, using XDR or JSONP, we have no statusCode available
	      // So we rely on our API response `status` property.
	      // But `waitTask` can set a `status` property which is not the statusCode (it's the task status)
	      // So we check if there's a `message` along `status` and it means it's an error
	      //
	      // That's the only case where we have a response.status that's not the http statusCode
	      var status = httpResponse && httpResponse.body && httpResponse.body.message && httpResponse.body.status ||
	
	        // this is important to check the request statusCode AFTER the body eventual
	        // statusCode because some implementations (jQuery XDomainRequest transport) may
	        // send statusCode 200 while we had an error
	        httpResponse.statusCode ||
	
	        // When in browser mode, using XDR or JSONP
	        // we default to success when no error (no response.status && response.message)
	        // If there was a JSON.parse() error then body is null and it fails
	        httpResponse && httpResponse.body && 200;
	
	      requestDebug('received response: statusCode: %s, computed statusCode: %d, headers: %j',
	        httpResponse.statusCode, status, httpResponse.headers);
	
	      var httpResponseOk = Math.floor(status / 100) === 2;
	
	      var endTime = new Date();
	      debugData.push({
	        currentHost: currentHost,
	        headers: removeCredentials(headers),
	        content: body || null,
	        contentLength: body !== undefined ? body.length : null,
	        method: reqOpts.method,
	        timeouts: reqOpts.timeouts,
	        url: reqOpts.url,
	        startTime: startTime,
	        endTime: endTime,
	        duration: endTime - startTime,
	        statusCode: status
	      });
	
	      if (httpResponseOk) {
	        if (client._useCache && !client._useRequestCache && cache) {
	          cache[cacheID] = httpResponse.responseText;
	        }
	
	        return {
	          responseText: httpResponse.responseText,
	          body: httpResponse.body
	        };
	      }
	
	      var shouldRetry = Math.floor(status / 100) !== 4;
	
	      if (shouldRetry) {
	        tries += 1;
	        return retryRequest();
	      }
	
	      requestDebug('unrecoverable error');
	
	      // no success and no retry => fail
	      var unrecoverableError = new errors.AlgoliaSearchError(
	        httpResponse.body && httpResponse.body.message, {debugData: debugData, statusCode: status}
	      );
	
	      return client._promise.reject(unrecoverableError);
	    }
	
	    function tryFallback(err) {
	      // error cases:
	      //  While not in fallback mode:
	      //    - CORS not supported
	      //    - network error
	      //  While in fallback mode:
	      //    - timeout
	      //    - network error
	      //    - badly formatted JSONP (script loaded, did not call our callback)
	      //  In both cases:
	      //    - uncaught exception occurs (TypeError)
	      requestDebug('error: %s, stack: %s', err.message, err.stack);
	
	      var endTime = new Date();
	      debugData.push({
	        currentHost: currentHost,
	        headers: removeCredentials(headers),
	        content: body || null,
	        contentLength: body !== undefined ? body.length : null,
	        method: reqOpts.method,
	        timeouts: reqOpts.timeouts,
	        url: reqOpts.url,
	        startTime: startTime,
	        endTime: endTime,
	        duration: endTime - startTime
	      });
	
	      if (!(err instanceof errors.AlgoliaSearchError)) {
	        err = new errors.Unknown(err && err.message, err);
	      }
	
	      tries += 1;
	
	      // stop the request implementation when:
	      if (
	        // we did not generate this error,
	        // it comes from a throw in some other piece of code
	        err instanceof errors.Unknown ||
	
	        // server sent unparsable JSON
	        err instanceof errors.UnparsableJSON ||
	
	        // max tries and already using fallback or no fallback
	        tries >= client.hosts[initialOpts.hostType].length &&
	        (usingFallback || !hasFallback)) {
	        // stop request implementation for this command
	        err.debugData = debugData;
	        return client._promise.reject(err);
	      }
	
	      // When a timeout occurred, retry by raising timeout
	      if (err instanceof errors.RequestTimeout) {
	        return retryRequestWithHigherTimeout();
	      }
	
	      return retryRequest();
	    }
	
	    function retryRequest() {
	      requestDebug('retrying request');
	      client._incrementHostIndex(initialOpts.hostType);
	      return doRequest(requester, reqOpts);
	    }
	
	    function retryRequestWithHigherTimeout() {
	      requestDebug('retrying request with higher timeout');
	      client._incrementHostIndex(initialOpts.hostType);
	      client._incrementTimeoutMultipler();
	      reqOpts.timeouts = client._getTimeoutsForRequest(initialOpts.hostType);
	      return doRequest(requester, reqOpts);
	    }
	  }
	
	  function isCacheValidWithCurrentID(
	    useRequestCache,
	    currentCache,
	    currentCacheID
	  ) {
	    return (
	      client._useCache &&
	      useRequestCache &&
	      currentCache &&
	      currentCache[currentCacheID] !== undefined
	    );
	  }
	
	
	  function interopCallbackReturn(request, callback) {
	    if (isCacheValidWithCurrentID(client._useRequestCache, cache, cacheID)) {
	      request.catch(function() {
	        // Release the cache on error
	        delete cache[cacheID];
	      });
	    }
	
	    if (typeof initialOpts.callback === 'function') {
	      // either we have a callback
	      request.then(function okCb(content) {
	        exitPromise(function() {
	          initialOpts.callback(null, callback(content));
	        }, client._setTimeout || setTimeout);
	      }, function nookCb(err) {
	        exitPromise(function() {
	          initialOpts.callback(err);
	        }, client._setTimeout || setTimeout);
	      });
	    } else {
	      // either we are using promises
	      return request.then(callback);
	    }
	  }
	
	  if (client._useCache && client._useRequestCache) {
	    cacheID = initialOpts.url;
	  }
	
	  // as we sometime use POST requests to pass parameters (like query='aa'),
	  // the cacheID must also include the body to be different between calls
	  if (client._useCache && client._useRequestCache && body) {
	    cacheID += '_body_' + body;
	  }
	
	  if (isCacheValidWithCurrentID(client._useRequestCache, cache, cacheID)) {
	    requestDebug('serving request from cache');
	
	    var maybePromiseForCache = cache[cacheID];
	
	    // In case the cache is warmup with value that is not a promise
	    var promiseForCache = typeof maybePromiseForCache.then !== 'function'
	      ? client._promise.resolve({responseText: maybePromiseForCache})
	      : maybePromiseForCache;
	
	    return interopCallbackReturn(promiseForCache, function(content) {
	      // In case of the cache request, return the original value
	      return JSON.parse(content.responseText);
	    });
	  }
	
	  var request = doRequest(
	    client._request, {
	      url: initialOpts.url,
	      method: initialOpts.method,
	      body: body,
	      jsonBody: initialOpts.body,
	      timeouts: client._getTimeoutsForRequest(initialOpts.hostType),
	      forceAuthHeaders: initialOpts.forceAuthHeaders
	    }
	  );
	
	  if (client._useCache && client._useRequestCache && cache) {
	    cache[cacheID] = request;
	  }
	
	  return interopCallbackReturn(request, function(content) {
	    // In case of the first request, return the JSON value
	    return content.body;
	  });
	};
	
	/*
	* Transform search param object in query string
	* @param {object} args arguments to add to the current query string
	* @param {string} params current query string
	* @return {string} the final query string
	*/
	AlgoliaSearchCore.prototype._getSearchParams = function(args, params) {
	  if (args === undefined || args === null) {
	    return params;
	  }
	  for (var key in args) {
	    if (key !== null && args[key] !== undefined && args.hasOwnProperty(key)) {
	      params += params === '' ? '' : '&';
	      params += key + '=' + encodeURIComponent(Object.prototype.toString.call(args[key]) === '[object Array]' ? safeJSONStringify(args[key]) : args[key]);
	    }
	  }
	  return params;
	};
	
	/**
	 * Compute the headers for a request
	 *
	 * @param [string] options.additionalUA semi-colon separated string with other user agents to add
	 * @param [boolean=true] options.withApiKey Send the api key as a header
	 * @param [Object] options.headers Extra headers to send
	 */
	AlgoliaSearchCore.prototype._computeRequestHeaders = function(options) {
	  var forEach = __webpack_require__(685);
	
	  var ua = options.additionalUA ?
	    this._ua + '; ' + options.additionalUA :
	    this._ua;
	
	  var requestHeaders = {
	    'x-algolia-agent': ua,
	    'x-algolia-application-id': this.applicationID
	  };
	
	  // browser will inline headers in the url, node.js will use http headers
	  // but in some situations, the API KEY will be too long (big secured API keys)
	  // so if the request is a POST and the KEY is very long, we will be asked to not put
	  // it into headers but in the JSON body
	  if (options.withApiKey !== false) {
	    requestHeaders['x-algolia-api-key'] = this.apiKey;
	  }
	
	  if (this.userToken) {
	    requestHeaders['x-algolia-usertoken'] = this.userToken;
	  }
	
	  if (this.securityTags) {
	    requestHeaders['x-algolia-tagfilters'] = this.securityTags;
	  }
	
	  forEach(this.extraHeaders, function addToRequestHeaders(value, key) {
	    requestHeaders[key] = value;
	  });
	
	  if (options.headers) {
	    forEach(options.headers, function addToRequestHeaders(value, key) {
	      requestHeaders[key] = value;
	    });
	  }
	
	  return requestHeaders;
	};
	
	/**
	 * Search through multiple indices at the same time
	 * @param  {Object[]}   queries  An array of queries you want to run.
	 * @param {string} queries[].indexName The index name you want to target
	 * @param {string} [queries[].query] The query to issue on this index. Can also be passed into `params`
	 * @param {Object} queries[].params Any search param like hitsPerPage, ..
	 * @param  {Function} callback Callback to be called
	 * @return {Promise|undefined} Returns a promise if no callback given
	 */
	AlgoliaSearchCore.prototype.search = function(queries, opts, callback) {
	  var isArray = __webpack_require__(933);
	  var map = __webpack_require__(914);
	
	  var usage = 'Usage: client.search(arrayOfQueries[, callback])';
	
	  if (!isArray(queries)) {
	    throw new Error(usage);
	  }
	
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  var client = this;
	
	  var postObj = {
	    requests: map(queries, function prepareRequest(query) {
	      var params = '';
	
	      // allow query.query
	      // so we are mimicing the index.search(query, params) method
	      // {indexName:, query:, params:}
	      if (query.query !== undefined) {
	        params += 'query=' + encodeURIComponent(query.query);
	      }
	
	      return {
	        indexName: query.indexName,
	        params: client._getSearchParams(query.params, params)
	      };
	    })
	  };
	
	  var JSONPParams = map(postObj.requests, function prepareJSONPParams(request, requestId) {
	    return requestId + '=' +
	      encodeURIComponent(
	        '/1/indexes/' + encodeURIComponent(request.indexName) + '?' +
	        request.params
	      );
	  }).join('&');
	
	  var url = '/1/indexes/*/queries';
	
	  if (opts.strategy !== undefined) {
	    postObj.strategy = opts.strategy;
	  }
	
	  return this._jsonRequest({
	    cache: this.cache,
	    method: 'POST',
	    url: url,
	    body: postObj,
	    hostType: 'read',
	    fallback: {
	      method: 'GET',
	      url: '/1/indexes/*',
	      body: {
	        params: JSONPParams
	      }
	    },
	    callback: callback
	  });
	};
	
	/**
	* Search for facet values
	* https://www.algolia.com/doc/rest-api/search#search-for-facet-values
	* This is the top-level API for SFFV.
	*
	* @param {object[]} queries An array of queries to run.
	* @param {string} queries[].indexName Index name, name of the index to search.
	* @param {object} queries[].params Query parameters.
	* @param {string} queries[].params.facetName Facet name, name of the attribute to search for values in.
	* Must be declared as a facet
	* @param {string} queries[].params.facetQuery Query for the facet search
	* @param {string} [queries[].params.*] Any search parameter of Algolia,
	* see https://www.algolia.com/doc/api-client/javascript/search#search-parameters
	* Pagination is not supported. The page and hitsPerPage parameters will be ignored.
	*/
	AlgoliaSearchCore.prototype.searchForFacetValues = function(queries) {
	  var isArray = __webpack_require__(933);
	  var map = __webpack_require__(914);
	
	  var usage = 'Usage: client.searchForFacetValues([{indexName, params: {facetName, facetQuery, ...params}}, ...queries])'; // eslint-disable-line max-len
	
	  if (!isArray(queries)) {
	    throw new Error(usage);
	  }
	
	  var client = this;
	
	  return client._promise.all(map(queries, function performQuery(query) {
	    if (
	      !query ||
	      query.indexName === undefined ||
	      query.params.facetName === undefined ||
	      query.params.facetQuery === undefined
	    ) {
	      throw new Error(usage);
	    }
	
	    var clone = __webpack_require__(673);
	    var omit = __webpack_require__(1284);
	
	    var indexName = query.indexName;
	    var params = query.params;
	
	    var facetName = params.facetName;
	    var filteredParams = omit(clone(params), function(keyName) {
	      return keyName === 'facetName';
	    });
	    var searchParameters = client._getSearchParams(filteredParams, '');
	
	    return client._jsonRequest({
	      cache: client.cache,
	      method: 'POST',
	      url:
	        '/1/indexes/' +
	        encodeURIComponent(indexName) +
	        '/facets/' +
	        encodeURIComponent(facetName) +
	        '/query',
	      hostType: 'read',
	      body: {params: searchParameters}
	    });
	  }));
	};
	
	/**
	 * Set the extra security tagFilters header
	 * @param {string|array} tags The list of tags defining the current security filters
	 */
	AlgoliaSearchCore.prototype.setSecurityTags = function(tags) {
	  if (Object.prototype.toString.call(tags) === '[object Array]') {
	    var strTags = [];
	    for (var i = 0; i < tags.length; ++i) {
	      if (Object.prototype.toString.call(tags[i]) === '[object Array]') {
	        var oredTags = [];
	        for (var j = 0; j < tags[i].length; ++j) {
	          oredTags.push(tags[i][j]);
	        }
	        strTags.push('(' + oredTags.join(',') + ')');
	      } else {
	        strTags.push(tags[i]);
	      }
	    }
	    tags = strTags.join(',');
	  }
	
	  this.securityTags = tags;
	};
	
	/**
	 * Set the extra user token header
	 * @param {string} userToken The token identifying a uniq user (used to apply rate limits)
	 */
	AlgoliaSearchCore.prototype.setUserToken = function(userToken) {
	  this.userToken = userToken;
	};
	
	/**
	 * Clear all queries in client's cache
	 * @return undefined
	 */
	AlgoliaSearchCore.prototype.clearCache = function() {
	  this.cache = {};
	};
	
	/**
	* Set the number of milliseconds a request can take before automatically being terminated.
	* @deprecated
	* @param {Number} milliseconds
	*/
	AlgoliaSearchCore.prototype.setRequestTimeout = function(milliseconds) {
	  if (milliseconds) {
	    this._timeouts.connect = this._timeouts.read = this._timeouts.write = milliseconds;
	  }
	};
	
	/**
	* Set the three different (connect, read, write) timeouts to be used when requesting
	* @param {Object} timeouts
	*/
	AlgoliaSearchCore.prototype.setTimeouts = function(timeouts) {
	  this._timeouts = timeouts;
	};
	
	/**
	* Get the three different (connect, read, write) timeouts to be used when requesting
	* @param {Object} timeouts
	*/
	AlgoliaSearchCore.prototype.getTimeouts = function() {
	  return this._timeouts;
	};
	
	AlgoliaSearchCore.prototype._getAppIdData = function() {
	  var data = store.get(this.applicationID);
	  if (data !== null) this._cacheAppIdData(data);
	  return data;
	};
	
	AlgoliaSearchCore.prototype._setAppIdData = function(data) {
	  data.lastChange = (new Date()).getTime();
	  this._cacheAppIdData(data);
	  return store.set(this.applicationID, data);
	};
	
	AlgoliaSearchCore.prototype._checkAppIdData = function() {
	  var data = this._getAppIdData();
	  var now = (new Date()).getTime();
	  if (data === null || now - data.lastChange > RESET_APP_DATA_TIMER) {
	    return this._resetInitialAppIdData(data);
	  }
	
	  return data;
	};
	
	AlgoliaSearchCore.prototype._resetInitialAppIdData = function(data) {
	  var newData = data || {};
	  newData.hostIndexes = {read: 0, write: 0};
	  newData.timeoutMultiplier = 1;
	  newData.shuffleResult = newData.shuffleResult || shuffle([1, 2, 3]);
	  return this._setAppIdData(newData);
	};
	
	AlgoliaSearchCore.prototype._cacheAppIdData = function(data) {
	  this._hostIndexes = data.hostIndexes;
	  this._timeoutMultiplier = data.timeoutMultiplier;
	  this._shuffleResult = data.shuffleResult;
	};
	
	AlgoliaSearchCore.prototype._partialAppIdDataUpdate = function(newData) {
	  var foreach = __webpack_require__(685);
	  var currentData = this._getAppIdData();
	  foreach(newData, function(value, key) {
	    currentData[key] = value;
	  });
	
	  return this._setAppIdData(currentData);
	};
	
	AlgoliaSearchCore.prototype._getHostByType = function(hostType) {
	  return this.hosts[hostType][this._getHostIndexByType(hostType)];
	};
	
	AlgoliaSearchCore.prototype._getTimeoutMultiplier = function() {
	  return this._timeoutMultiplier;
	};
	
	AlgoliaSearchCore.prototype._getHostIndexByType = function(hostType) {
	  return this._hostIndexes[hostType];
	};
	
	AlgoliaSearchCore.prototype._setHostIndexByType = function(hostIndex, hostType) {
	  var clone = __webpack_require__(673);
	  var newHostIndexes = clone(this._hostIndexes);
	  newHostIndexes[hostType] = hostIndex;
	  this._partialAppIdDataUpdate({hostIndexes: newHostIndexes});
	  return hostIndex;
	};
	
	AlgoliaSearchCore.prototype._incrementHostIndex = function(hostType) {
	  return this._setHostIndexByType(
	    (this._getHostIndexByType(hostType) + 1) % this.hosts[hostType].length, hostType
	  );
	};
	
	AlgoliaSearchCore.prototype._incrementTimeoutMultipler = function() {
	  var timeoutMultiplier = Math.max(this._timeoutMultiplier + 1, 4);
	  return this._partialAppIdDataUpdate({timeoutMultiplier: timeoutMultiplier});
	};
	
	AlgoliaSearchCore.prototype._getTimeoutsForRequest = function(hostType) {
	  return {
	    connect: this._timeouts.connect * this._timeoutMultiplier,
	    complete: this._timeouts[hostType] * this._timeoutMultiplier
	  };
	};
	
	function prepareHost(protocol) {
	  return function prepare(host) {
	    return protocol + '//' + host.toLowerCase();
	  };
	}
	
	// Prototype.js < 1.7, a widely used library, defines a weird
	// Array.prototype.toJSON function that will fail to stringify our content
	// appropriately
	// refs:
	//   - https://groups.google.com/forum/#!topic/prototype-core/E-SAVvV_V9Q
	//   - https://github.com/sstephenson/prototype/commit/038a2985a70593c1a86c230fadbdfe2e4898a48c
	//   - http://stackoverflow.com/a/3148441/147079
	function safeJSONStringify(obj) {
	  /* eslint no-extend-native:0 */
	
	  if (Array.prototype.toJSON === undefined) {
	    return JSON.stringify(obj);
	  }
	
	  var toJSON = Array.prototype.toJSON;
	  delete Array.prototype.toJSON;
	  var out = JSON.stringify(obj);
	  Array.prototype.toJSON = toJSON;
	
	  return out;
	}
	
	function shuffle(array) {
	  var currentIndex = array.length;
	  var temporaryValue;
	  var randomIndex;
	
	  // While there remain elements to shuffle...
	  while (currentIndex !== 0) {
	    // Pick a remaining element...
	    randomIndex = Math.floor(Math.random() * currentIndex);
	    currentIndex -= 1;
	
	    // And swap it with the current element.
	    temporaryValue = array[currentIndex];
	    array[currentIndex] = array[randomIndex];
	    array[randomIndex] = temporaryValue;
	  }
	
	  return array;
	}
	
	function removeCredentials(headers) {
	  var newHeaders = {};
	
	  for (var headerName in headers) {
	    if (Object.prototype.hasOwnProperty.call(headers, headerName)) {
	      var value;
	
	      if (headerName === 'x-algolia-api-key' || headerName === 'x-algolia-application-id') {
	        value = '**hidden for security purposes**';
	      } else {
	        value = headers[headerName];
	      }
	
	      newHeaders[headerName] = value;
	    }
	  }
	
	  return newHeaders;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(235)))

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	var buildSearchMethod = __webpack_require__(1283);
	var deprecate = __webpack_require__(1544);
	var deprecatedMessage = __webpack_require__(1545);
	
	module.exports = IndexCore;
	
	/*
	* Index class constructor.
	* You should not use this method directly but use initIndex() function
	*/
	function IndexCore(algoliasearch, indexName) {
	  this.indexName = indexName;
	  this.as = algoliasearch;
	  this.typeAheadArgs = null;
	  this.typeAheadValueOption = null;
	
	  // make sure every index instance has it's own cache
	  this.cache = {};
	}
	
	/*
	* Clear all queries in cache
	*/
	IndexCore.prototype.clearCache = function() {
	  this.cache = {};
	};
	
	/*
	* Search inside the index using XMLHttpRequest request (Using a POST query to
	* minimize number of OPTIONS queries: Cross-Origin Resource Sharing).
	*
	* @param {string} [query] the full text query
	* @param {object} [args] (optional) if set, contains an object with query parameters:
	* - page: (integer) Pagination parameter used to select the page to retrieve.
	*                   Page is zero-based and defaults to 0. Thus,
	*                   to retrieve the 10th page you need to set page=9
	* - hitsPerPage: (integer) Pagination parameter used to select the number of hits per page. Defaults to 20.
	* - attributesToRetrieve: a string that contains the list of object attributes
	* you want to retrieve (let you minimize the answer size).
	*   Attributes are separated with a comma (for example "name,address").
	*   You can also use an array (for example ["name","address"]).
	*   By default, all attributes are retrieved. You can also use '*' to retrieve all
	*   values when an attributesToRetrieve setting is specified for your index.
	* - attributesToHighlight: a string that contains the list of attributes you
	*   want to highlight according to the query.
	*   Attributes are separated by a comma. You can also use an array (for example ["name","address"]).
	*   If an attribute has no match for the query, the raw value is returned.
	*   By default all indexed text attributes are highlighted.
	*   You can use `*` if you want to highlight all textual attributes.
	*   Numerical attributes are not highlighted.
	*   A matchLevel is returned for each highlighted attribute and can contain:
	*      - full: if all the query terms were found in the attribute,
	*      - partial: if only some of the query terms were found,
	*      - none: if none of the query terms were found.
	* - attributesToSnippet: a string that contains the list of attributes to snippet alongside
	* the number of words to return (syntax is `attributeName:nbWords`).
	*    Attributes are separated by a comma (Example: attributesToSnippet=name:10,content:10).
	*    You can also use an array (Example: attributesToSnippet: ['name:10','content:10']).
	*    By default no snippet is computed.
	* - minWordSizefor1Typo: the minimum number of characters in a query word to accept one typo in this word.
	* Defaults to 3.
	* - minWordSizefor2Typos: the minimum number of characters in a query word
	* to accept two typos in this word. Defaults to 7.
	* - getRankingInfo: if set to 1, the result hits will contain ranking
	* information in _rankingInfo attribute.
	* - aroundLatLng: search for entries around a given
	* latitude/longitude (specified as two floats separated by a comma).
	*   For example aroundLatLng=47.316669,5.016670).
	*   You can specify the maximum distance in meters with the aroundRadius parameter (in meters)
	*   and the precision for ranking with aroundPrecision
	*   (for example if you set aroundPrecision=100, two objects that are distant of
	*   less than 100m will be considered as identical for "geo" ranking parameter).
	*   At indexing, you should specify geoloc of an object with the _geoloc attribute
	*   (in the form {"_geoloc":{"lat":48.853409, "lng":2.348800}})
	* - insideBoundingBox: search entries inside a given area defined by the two extreme points
	* of a rectangle (defined by 4 floats: p1Lat,p1Lng,p2Lat,p2Lng).
	*   For example insideBoundingBox=47.3165,4.9665,47.3424,5.0201).
	*   At indexing, you should specify geoloc of an object with the _geoloc attribute
	*   (in the form {"_geoloc":{"lat":48.853409, "lng":2.348800}})
	* - numericFilters: a string that contains the list of numeric filters you want to
	* apply separated by a comma.
	*   The syntax of one filter is `attributeName` followed by `operand` followed by `value`.
	*   Supported operands are `<`, `<=`, `=`, `>` and `>=`.
	*   You can have multiple conditions on one attribute like for example numericFilters=price>100,price<1000.
	*   You can also use an array (for example numericFilters: ["price>100","price<1000"]).
	* - tagFilters: filter the query by a set of tags. You can AND tags by separating them by commas.
	*   To OR tags, you must add parentheses. For example, tags=tag1,(tag2,tag3) means tag1 AND (tag2 OR tag3).
	*   You can also use an array, for example tagFilters: ["tag1",["tag2","tag3"]]
	*   means tag1 AND (tag2 OR tag3).
	*   At indexing, tags should be added in the _tags** attribute
	*   of objects (for example {"_tags":["tag1","tag2"]}).
	* - facetFilters: filter the query by a list of facets.
	*   Facets are separated by commas and each facet is encoded as `attributeName:value`.
	*   For example: `facetFilters=category:Book,author:John%20Doe`.
	*   You can also use an array (for example `["category:Book","author:John%20Doe"]`).
	* - facets: List of object attributes that you want to use for faceting.
	*   Comma separated list: `"category,author"` or array `['category','author']`
	*   Only attributes that have been added in **attributesForFaceting** index setting
	*   can be used in this parameter.
	*   You can also use `*` to perform faceting on all attributes specified in **attributesForFaceting**.
	* - queryType: select how the query words are interpreted, it can be one of the following value:
	*    - prefixAll: all query words are interpreted as prefixes,
	*    - prefixLast: only the last word is interpreted as a prefix (default behavior),
	*    - prefixNone: no query word is interpreted as a prefix. This option is not recommended.
	* - optionalWords: a string that contains the list of words that should
	* be considered as optional when found in the query.
	*   Comma separated and array are accepted.
	* - distinct: If set to 1, enable the distinct feature (disabled by default)
	* if the attributeForDistinct index setting is set.
	*   This feature is similar to the SQL "distinct" keyword: when enabled
	*   in a query with the distinct=1 parameter,
	*   all hits containing a duplicate value for the attributeForDistinct attribute are removed from results.
	*   For example, if the chosen attribute is show_name and several hits have
	*   the same value for show_name, then only the best
	*   one is kept and others are removed.
	* - restrictSearchableAttributes: List of attributes you want to use for
	* textual search (must be a subset of the attributesToIndex index setting)
	* either comma separated or as an array
	* @param {function} [callback] the result callback called with two arguments:
	*  error: null or Error('message'). If false, the content contains the error.
	*  content: the server answer that contains the list of results.
	*/
	IndexCore.prototype.search = buildSearchMethod('query');
	
	/*
	* -- BETA --
	* Search a record similar to the query inside the index using XMLHttpRequest request (Using a POST query to
	* minimize number of OPTIONS queries: Cross-Origin Resource Sharing).
	*
	* @param {string} [query] the similar query
	* @param {object} [args] (optional) if set, contains an object with query parameters.
	*   All search parameters are supported (see search function), restrictSearchableAttributes and facetFilters
	*   are the two most useful to restrict the similar results and get more relevant content
	*/
	IndexCore.prototype.similarSearch = deprecate(
	  buildSearchMethod('similarQuery'),
	  deprecatedMessage(
	    'index.similarSearch(query[, callback])',
	    'index.search({ similarQuery: query }[, callback])'
	  )
	);
	
	/*
	* Browse index content. The response content will have a `cursor` property that you can use
	* to browse subsequent pages for this query. Use `index.browseFrom(cursor)` when you want.
	*
	* @param {string} query - The full text query
	* @param {Object} [queryParameters] - Any search query parameter
	* @param {Function} [callback] - The result callback called with two arguments
	*   error: null or Error('message')
	*   content: the server answer with the browse result
	* @return {Promise|undefined} Returns a promise if no callback given
	* @example
	* index.browse('cool songs', {
	*   tagFilters: 'public,comments',
	*   hitsPerPage: 500
	* }, callback);
	* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
	*/
	IndexCore.prototype.browse = function(query, queryParameters, callback) {
	  var merge = __webpack_require__(1547);
	
	  var indexObj = this;
	
	  var page;
	  var hitsPerPage;
	
	  // we check variadic calls that are not the one defined
	  // .browse()/.browse(fn)
	  // => page = 0
	  if (arguments.length === 0 || arguments.length === 1 && typeof arguments[0] === 'function') {
	    page = 0;
	    callback = arguments[0];
	    query = undefined;
	  } else if (typeof arguments[0] === 'number') {
	    // .browse(2)/.browse(2, 10)/.browse(2, fn)/.browse(2, 10, fn)
	    page = arguments[0];
	    if (typeof arguments[1] === 'number') {
	      hitsPerPage = arguments[1];
	    } else if (typeof arguments[1] === 'function') {
	      callback = arguments[1];
	      hitsPerPage = undefined;
	    }
	    query = undefined;
	    queryParameters = undefined;
	  } else if (typeof arguments[0] === 'object') {
	    // .browse(queryParameters)/.browse(queryParameters, cb)
	    if (typeof arguments[1] === 'function') {
	      callback = arguments[1];
	    }
	    queryParameters = arguments[0];
	    query = undefined;
	  } else if (typeof arguments[0] === 'string' && typeof arguments[1] === 'function') {
	    // .browse(query, cb)
	    callback = arguments[1];
	    queryParameters = undefined;
	  }
	
	  // otherwise it's a .browse(query)/.browse(query, queryParameters)/.browse(query, queryParameters, cb)
	
	  // get search query parameters combining various possible calls
	  // to .browse();
	  queryParameters = merge({}, queryParameters || {}, {
	    page: page,
	    hitsPerPage: hitsPerPage,
	    query: query
	  });
	
	  var params = this.as._getSearchParams(queryParameters, '');
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/browse',
	    body: {params: params},
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	* Continue browsing from a previous position (cursor), obtained via a call to `.browse()`.
	*
	* @param {string} query - The full text query
	* @param {Object} [queryParameters] - Any search query parameter
	* @param {Function} [callback] - The result callback called with two arguments
	*   error: null or Error('message')
	*   content: the server answer with the browse result
	* @return {Promise|undefined} Returns a promise if no callback given
	* @example
	* index.browseFrom('14lkfsakl32', callback);
	* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
	*/
	IndexCore.prototype.browseFrom = function(cursor, callback) {
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/browse',
	    body: {cursor: cursor},
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	* Search for facet values
	* https://www.algolia.com/doc/rest-api/search#search-for-facet-values
	*
	* @param {string} params.facetName Facet name, name of the attribute to search for values in.
	* Must be declared as a facet
	* @param {string} params.facetQuery Query for the facet search
	* @param {string} [params.*] Any search parameter of Algolia,
	* see https://www.algolia.com/doc/api-client/javascript/search#search-parameters
	* Pagination is not supported. The page and hitsPerPage parameters will be ignored.
	* @param callback (optional)
	*/
	IndexCore.prototype.searchForFacetValues = function(params, callback) {
	  var clone = __webpack_require__(673);
	  var omit = __webpack_require__(1284);
	  var usage = 'Usage: index.searchForFacetValues({facetName, facetQuery, ...params}[, callback])';
	
	  if (params.facetName === undefined || params.facetQuery === undefined) {
	    throw new Error(usage);
	  }
	
	  var facetName = params.facetName;
	  var filteredParams = omit(clone(params), function(keyName) {
	    return keyName === 'facetName';
	  });
	  var searchParameters = this.as._getSearchParams(filteredParams, '');
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' +
	      encodeURIComponent(this.indexName) + '/facets/' + encodeURIComponent(facetName) + '/query',
	    hostType: 'read',
	    body: {params: searchParameters},
	    callback: callback
	  });
	};
	
	IndexCore.prototype.searchFacet = deprecate(function(params, callback) {
	  return this.searchForFacetValues(params, callback);
	}, deprecatedMessage(
	  'index.searchFacet(params[, callback])',
	  'index.searchForFacetValues(params[, callback])'
	));
	
	IndexCore.prototype._search = function(params, url, callback, additionalUA) {
	  return this.as._jsonRequest({
	    cache: this.cache,
	    method: 'POST',
	    url: url || '/1/indexes/' + encodeURIComponent(this.indexName) + '/query',
	    body: {params: params},
	    hostType: 'read',
	    fallback: {
	      method: 'GET',
	      url: '/1/indexes/' + encodeURIComponent(this.indexName),
	      body: {params: params}
	    },
	    callback: callback,
	    additionalUA: additionalUA
	  });
	};
	
	/*
	* Get an object from this index
	*
	* @param objectID the unique identifier of the object to retrieve
	* @param attrs (optional) if set, contains the array of attribute names to retrieve
	* @param callback (optional) the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the object to retrieve or the error message if a failure occurred
	*/
	IndexCore.prototype.getObject = function(objectID, attrs, callback) {
	  var indexObj = this;
	
	  if (arguments.length === 1 || typeof attrs === 'function') {
	    callback = attrs;
	    attrs = undefined;
	  }
	
	  var params = '';
	  if (attrs !== undefined) {
	    params = '?attributes=';
	    for (var i = 0; i < attrs.length; ++i) {
	      if (i !== 0) {
	        params += ',';
	      }
	      params += attrs[i];
	    }
	  }
	
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(objectID) + params,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	* Get several objects from this index
	*
	* @param objectIDs the array of unique identifier of objects to retrieve
	*/
	IndexCore.prototype.getObjects = function(objectIDs, attributesToRetrieve, callback) {
	  var isArray = __webpack_require__(933);
	  var map = __webpack_require__(914);
	
	  var usage = 'Usage: index.getObjects(arrayOfObjectIDs[, callback])';
	
	  if (!isArray(objectIDs)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	
	  if (arguments.length === 1 || typeof attributesToRetrieve === 'function') {
	    callback = attributesToRetrieve;
	    attributesToRetrieve = undefined;
	  }
	
	  var body = {
	    requests: map(objectIDs, function prepareRequest(objectID) {
	      var request = {
	        indexName: indexObj.indexName,
	        objectID: objectID
	      };
	
	      if (attributesToRetrieve) {
	        request.attributesToRetrieve = attributesToRetrieve.join(',');
	      }
	
	      return request;
	    })
	  };
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/*/objects',
	    hostType: 'read',
	    body: body,
	    callback: callback
	  });
	};
	
	IndexCore.prototype.as = null;
	IndexCore.prototype.indexName = null;
	IndexCore.prototype.typeAheadArgs = null;
	IndexCore.prototype.typeAheadValueOption = null;


/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var global = __webpack_require__(344);
	var Promise = global.Promise || __webpack_require__(1332).Promise;
	
	// This is the standalone browser build entry point
	// Browser implementation of the Algolia Search JavaScript client,
	// using XMLHttpRequest, XDomainRequest and JSONP as fallback
	module.exports = function createAlgoliasearch(AlgoliaSearch, uaSuffix) {
	  var inherits = __webpack_require__(406);
	  var errors = __webpack_require__(913);
	  var inlineHeaders = __webpack_require__(1542);
	  var jsonpRequest = __webpack_require__(1543);
	  var places = __webpack_require__(1548);
	  uaSuffix = uaSuffix || '';
	
	  if (process.env.NODE_ENV === 'debug') {
	    __webpack_require__(802).enable('algoliasearch*');
	  }
	
	  function algoliasearch(applicationID, apiKey, opts) {
	    var cloneDeep = __webpack_require__(673);
	
	    opts = cloneDeep(opts || {});
	
	    opts._ua = opts._ua || algoliasearch.ua;
	
	    return new AlgoliaSearchBrowser(applicationID, apiKey, opts);
	  }
	
	  algoliasearch.version = __webpack_require__(1550);
	
	  algoliasearch.ua =
	    'Algolia for JavaScript (' + algoliasearch.version + '); ' + uaSuffix;
	
	  algoliasearch.initPlaces = places(algoliasearch);
	
	  // we expose into window no matter how we are used, this will allow
	  // us to easily debug any website running algolia
	  global.__algolia = {
	    debug: __webpack_require__(802),
	    algoliasearch: algoliasearch
	  };
	
	  var support = {
	    hasXMLHttpRequest: 'XMLHttpRequest' in global,
	    hasXDomainRequest: 'XDomainRequest' in global
	  };
	
	  if (support.hasXMLHttpRequest) {
	    support.cors = 'withCredentials' in new XMLHttpRequest();
	  }
	
	  function AlgoliaSearchBrowser() {
	    // call AlgoliaSearch constructor
	    AlgoliaSearch.apply(this, arguments);
	  }
	
	  inherits(AlgoliaSearchBrowser, AlgoliaSearch);
	
	  AlgoliaSearchBrowser.prototype._request = function request(url, opts) {
	    return new Promise(function wrapRequest(resolve, reject) {
	      // no cors or XDomainRequest, no request
	      if (!support.cors && !support.hasXDomainRequest) {
	        // very old browser, not supported
	        reject(new errors.Network('CORS not supported'));
	        return;
	      }
	
	      url = inlineHeaders(url, opts.headers);
	
	      var body = opts.body;
	      var req = support.cors ? new XMLHttpRequest() : new XDomainRequest();
	      var reqTimeout;
	      var timedOut;
	      var connected = false;
	
	      reqTimeout = setTimeout(onTimeout, opts.timeouts.connect);
	      // we set an empty onprogress listener
	      // so that XDomainRequest on IE9 is not aborted
	      // refs:
	      //  - https://github.com/algolia/algoliasearch-client-js/issues/76
	      //  - https://social.msdn.microsoft.com/Forums/ie/en-US/30ef3add-767c-4436-b8a9-f1ca19b4812e/ie9-rtm-xdomainrequest-issued-requests-may-abort-if-all-event-handlers-not-specified?forum=iewebdevelopment
	      req.onprogress = onProgress;
	      if ('onreadystatechange' in req) req.onreadystatechange = onReadyStateChange;
	      req.onload = onLoad;
	      req.onerror = onError;
	
	      // do not rely on default XHR async flag, as some analytics code like hotjar
	      // breaks it and set it to false by default
	      if (req instanceof XMLHttpRequest) {
	        req.open(opts.method, url, true);
	
	        // The Analytics API never accepts Auth headers as query string
	        // this option exists specifically for them.
	        if (opts.forceAuthHeaders) {
	          req.setRequestHeader(
	            'x-algolia-application-id',
	            opts.headers['x-algolia-application-id']
	          );
	          req.setRequestHeader(
	            'x-algolia-api-key',
	            opts.headers['x-algolia-api-key']
	          );
	        }
	      } else {
	        req.open(opts.method, url);
	      }
	
	      // headers are meant to be sent after open
	      if (support.cors) {
	        if (body) {
	          if (opts.method === 'POST') {
	            // https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS#Simple_requests
	            req.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
	          } else {
	            req.setRequestHeader('content-type', 'application/json');
	          }
	        }
	        req.setRequestHeader('accept', 'application/json');
	      }
	
	      if (body) {
	        req.send(body);
	      } else {
	        req.send();
	      }
	
	      // event object not received in IE8, at least
	      // but we do not use it, still important to note
	      function onLoad(/* event */) {
	        // When browser does not supports req.timeout, we can
	        // have both a load and timeout event, since handled by a dumb setTimeout
	        if (timedOut) {
	          return;
	        }
	
	        clearTimeout(reqTimeout);
	
	        var out;
	
	        try {
	          out = {
	            body: JSON.parse(req.responseText),
	            responseText: req.responseText,
	            statusCode: req.status,
	            // XDomainRequest does not have any response headers
	            headers: req.getAllResponseHeaders && req.getAllResponseHeaders() || {}
	          };
	        } catch (e) {
	          out = new errors.UnparsableJSON({
	            more: req.responseText
	          });
	        }
	
	        if (out instanceof errors.UnparsableJSON) {
	          reject(out);
	        } else {
	          resolve(out);
	        }
	      }
	
	      function onError(event) {
	        if (timedOut) {
	          return;
	        }
	
	        clearTimeout(reqTimeout);
	
	        // error event is trigerred both with XDR/XHR on:
	        //   - DNS error
	        //   - unallowed cross domain request
	        reject(
	          new errors.Network({
	            more: event
	          })
	        );
	      }
	
	      function onTimeout() {
	        timedOut = true;
	        req.abort();
	
	        reject(new errors.RequestTimeout());
	      }
	
	      function onConnect() {
	        connected = true;
	        clearTimeout(reqTimeout);
	        reqTimeout = setTimeout(onTimeout, opts.timeouts.complete);
	      }
	
	      function onProgress() {
	        if (!connected) onConnect();
	      }
	
	      function onReadyStateChange() {
	        if (!connected && req.readyState > 1) onConnect();
	      }
	    });
	  };
	
	  AlgoliaSearchBrowser.prototype._request.fallback = function requestFallback(url, opts) {
	    url = inlineHeaders(url, opts.headers);
	
	    return new Promise(function wrapJsonpRequest(resolve, reject) {
	      jsonpRequest(url, opts, function jsonpRequestDone(err, content) {
	        if (err) {
	          reject(err);
	          return;
	        }
	
	        resolve(content);
	      });
	    });
	  };
	
	  AlgoliaSearchBrowser.prototype._promise = {
	    reject: function rejectPromise(val) {
	      return Promise.reject(val);
	    },
	    resolve: function resolvePromise(val) {
	      return Promise.resolve(val);
	    },
	    delay: function delayPromise(ms) {
	      return new Promise(function resolveOnTimeout(resolve/* , reject*/) {
	        setTimeout(resolve, ms);
	      });
	    },
	    all: function all(promises) {
	      return Promise.all(promises);
	    }
	  };
	
	  return algoliasearch;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(235)))

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = inlineHeaders;
	
	var encode = __webpack_require__(1479);
	
	function inlineHeaders(url, headers) {
	  if (/\?/.test(url)) {
	    url += '&';
	  } else {
	    url += '?';
	  }
	
	  return url + encode(headers);
	}


/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = jsonpRequest;
	
	var errors = __webpack_require__(913);
	
	var JSONPCounter = 0;
	
	function jsonpRequest(url, opts, cb) {
	  if (opts.method !== 'GET') {
	    cb(new Error('Method ' + opts.method + ' ' + url + ' is not supported by JSONP.'));
	    return;
	  }
	
	  opts.debug('JSONP: start');
	
	  var cbCalled = false;
	  var timedOut = false;
	
	  JSONPCounter += 1;
	  var head = document.getElementsByTagName('head')[0];
	  var script = document.createElement('script');
	  var cbName = 'algoliaJSONP_' + JSONPCounter;
	  var done = false;
	
	  window[cbName] = function(data) {
	    removeGlobals();
	
	    if (timedOut) {
	      opts.debug('JSONP: Late answer, ignoring');
	      return;
	    }
	
	    cbCalled = true;
	
	    clean();
	
	    cb(null, {
	      body: data,
	      responseText: JSON.stringify(data)/* ,
	      // We do not send the statusCode, there's no statusCode in JSONP, it will be
	      // computed using data.status && data.message like with XDR
	      statusCode*/
	    });
	  };
	
	  // add callback by hand
	  url += '&callback=' + cbName;
	
	  // add body params manually
	  if (opts.jsonBody && opts.jsonBody.params) {
	    url += '&' + opts.jsonBody.params;
	  }
	
	  var ontimeout = setTimeout(timeout, opts.timeouts.complete);
	
	  // script onreadystatechange needed only for
	  // <= IE8
	  // https://github.com/angular/angular.js/issues/4523
	  script.onreadystatechange = readystatechange;
	  script.onload = success;
	  script.onerror = error;
	
	  script.async = true;
	  script.defer = true;
	  script.src = url;
	  head.appendChild(script);
	
	  function success() {
	    opts.debug('JSONP: success');
	
	    if (done || timedOut) {
	      return;
	    }
	
	    done = true;
	
	    // script loaded but did not call the fn => script loading error
	    if (!cbCalled) {
	      opts.debug('JSONP: Fail. Script loaded but did not call the callback');
	      clean();
	      cb(new errors.JSONPScriptFail());
	    }
	  }
	
	  function readystatechange() {
	    if (this.readyState === 'loaded' || this.readyState === 'complete') {
	      success();
	    }
	  }
	
	  function clean() {
	    clearTimeout(ontimeout);
	    script.onload = null;
	    script.onreadystatechange = null;
	    script.onerror = null;
	    head.removeChild(script);
	  }
	
	  function removeGlobals() {
	    try {
	      delete window[cbName];
	      delete window[cbName + '_loaded'];
	    } catch (e) {
	      window[cbName] = window[cbName + '_loaded'] = undefined;
	    }
	  }
	
	  function timeout() {
	    opts.debug('JSONP: Script timeout');
	    timedOut = true;
	    clean();
	    cb(new errors.RequestTimeout());
	  }
	
	  function error() {
	    opts.debug('JSONP: Script error');
	
	    if (done || timedOut) {
	      return;
	    }
	
	    clean();
	    cb(new errors.JSONPScriptError());
	  }
	}


/***/ },
/* 1544 */
/***/ function(module, exports) {

	module.exports = function deprecate(fn, message) {
	  var warned = false;
	
	  function deprecated() {
	    if (!warned) {
	      /* eslint no-console:0 */
	      console.warn(message);
	      warned = true;
	    }
	
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};


/***/ },
/* 1545 */
/***/ function(module, exports) {

	module.exports = function deprecatedMessage(previousUsage, newUsage) {
	  var githubAnchorLink = previousUsage.toLowerCase()
	    .replace(/[\.\(\)]/g, '');
	
	  return 'algoliasearch: `' + previousUsage + '` was replaced by `' + newUsage +
	    '`. Please see https://github.com/algolia/algoliasearch-client-javascript/wiki/Deprecated#' + githubAnchorLink;
	};


/***/ },
/* 1546 */
/***/ function(module, exports) {

	// Parse cloud does not supports setTimeout
	// We do not store a setTimeout reference in the client everytime
	// We only fallback to a fake setTimeout when not available
	// setTimeout cannot be override globally sadly
	module.exports = function exitPromise(fn, _setTimeout) {
	  _setTimeout(fn, 0);
	};


/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	var foreach = __webpack_require__(685);
	
	module.exports = function merge(destination/* , sources */) {
	  var sources = Array.prototype.slice.call(arguments);
	
	  foreach(sources, function(source) {
	    for (var keyName in source) {
	      if (source.hasOwnProperty(keyName)) {
	        if (typeof destination[keyName] === 'object' && typeof source[keyName] === 'object') {
	          destination[keyName] = merge({}, destination[keyName], source[keyName]);
	        } else if (source[keyName] !== undefined) {
	          destination[keyName] = source[keyName];
	        }
	      }
	    }
	  });
	
	  return destination;
	};


/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = createPlacesClient;
	
	var qs3 = __webpack_require__(1844);
	var buildSearchMethod = __webpack_require__(1283);
	
	function createPlacesClient(algoliasearch) {
	  return function places(appID, apiKey, opts) {
	    var cloneDeep = __webpack_require__(673);
	
	    opts = opts && cloneDeep(opts) || {};
	    opts.hosts = opts.hosts || [
	      'places-dsn.algolia.net',
	      'places-1.algolianet.com',
	      'places-2.algolianet.com',
	      'places-3.algolianet.com'
	    ];
	
	    // allow initPlaces() no arguments => community rate limited
	    if (arguments.length === 0 || typeof appID === 'object' || appID === undefined) {
	      appID = '';
	      apiKey = '';
	      opts._allowEmptyCredentials = true;
	    }
	
	    var client = algoliasearch(appID, apiKey, opts);
	    var index = client.initIndex('places');
	    index.search = buildSearchMethod('query', '/1/places/query');
	    index.reverse = function(options, callback) {
	      var encoded = qs3.encode(options);
	
	      return this.as._jsonRequest({
	        method: 'GET',
	        url: '/1/places/reverse?' + encoded,
	        hostType: 'read',
	        callback: callback
	      });
	    };
	
	    index.getObject = function(objectID, callback) {
	      return this.as._jsonRequest({
	        method: 'GET',
	        url: '/1/places/' + encodeURIComponent(objectID),
	        hostType: 'read',
	        callback: callback
	      });
	    };
	    return index;
	  };
	}


/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var debug = __webpack_require__(802)('algoliasearch:src/hostIndexState.js');
	var localStorageNamespace = 'algoliasearch-client-js';
	
	var store;
	var moduleStore = {
	  state: {},
	  set: function(key, data) {
	    this.state[key] = data;
	    return this.state[key];
	  },
	  get: function(key) {
	    return this.state[key] || null;
	  }
	};
	
	var localStorageStore = {
	  set: function(key, data) {
	    moduleStore.set(key, data); // always replicate localStorageStore to moduleStore in case of failure
	
	    try {
	      var namespace = JSON.parse(global.localStorage[localStorageNamespace]);
	      namespace[key] = data;
	      global.localStorage[localStorageNamespace] = JSON.stringify(namespace);
	      return namespace[key];
	    } catch (e) {
	      return localStorageFailure(key, e);
	    }
	  },
	  get: function(key) {
	    try {
	      return JSON.parse(global.localStorage[localStorageNamespace])[key] || null;
	    } catch (e) {
	      return localStorageFailure(key, e);
	    }
	  }
	};
	
	function localStorageFailure(key, e) {
	  debug('localStorage failed with', e);
	  cleanup();
	  store = moduleStore;
	  return store.get(key);
	}
	
	store = supportsLocalStorage() ? localStorageStore : moduleStore;
	
	module.exports = {
	  get: getOrSet,
	  set: getOrSet,
	  supportsLocalStorage: supportsLocalStorage
	};
	
	function getOrSet(key, data) {
	  if (arguments.length === 1) {
	    return store.get(key);
	  }
	
	  return store.set(key, data);
	}
	
	function supportsLocalStorage() {
	  try {
	    if ('localStorage' in global &&
	      global.localStorage !== null) {
	      if (!global.localStorage[localStorageNamespace]) {
	        // actual creation of the namespace
	        global.localStorage.setItem(localStorageNamespace, JSON.stringify({}));
	      }
	      return true;
	    }
	
	    return false;
	  } catch (_) {
	    return false;
	  }
	}
	
	// In case of any error on localStorage, we clean our own namespace, this should handle
	// quota errors when a lot of keys + data are used
	function cleanup() {
	  try {
	    global.localStorage.removeItem(localStorageNamespace);
	  } catch (_) {
	    // nothing to do
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1550 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = '3.35.1';


/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var datasetKey = 'aaDataset';
	var valueKey = 'aaValue';
	var datumKey = 'aaDatum';
	
	var _ = __webpack_require__(347);
	var DOM = __webpack_require__(477);
	var html = __webpack_require__(1286);
	var css = __webpack_require__(941);
	var EventEmitter = __webpack_require__(942);
	
	// constructor
	// -----------
	
	function Dataset(o) {
	  o = o || {};
	  o.templates = o.templates || {};
	
	  if (!o.source) {
	    _.error('missing source');
	  }
	
	  if (o.name && !isValidName(o.name)) {
	    _.error('invalid dataset name: ' + o.name);
	  }
	
	  // tracks the last query the dataset was updated for
	  this.query = null;
	  this._isEmpty = true;
	
	  this.highlight = !!o.highlight;
	  this.name = typeof o.name === 'undefined' || o.name === null ? _.getUniqueId() : o.name;
	
	  this.source = o.source;
	  this.displayFn = getDisplayFn(o.display || o.displayKey);
	
	  this.debounce = o.debounce;
	
	  this.cache = o.cache !== false;
	
	  this.templates = getTemplates(o.templates, this.displayFn);
	
	  this.css = _.mixin({}, css, o.appendTo ? css.appendTo : {});
	  this.cssClasses = o.cssClasses = _.mixin({}, css.defaultClasses, o.cssClasses || {});
	  this.cssClasses.prefix =
	    o.cssClasses.formattedPrefix || _.formatPrefix(this.cssClasses.prefix, this.cssClasses.noPrefix);
	
	  var clazz = _.className(this.cssClasses.prefix, this.cssClasses.dataset);
	  this.$el = o.$menu && o.$menu.find(clazz + '-' + this.name).length > 0 ?
	    DOM.element(o.$menu.find(clazz + '-' + this.name)[0]) :
	    DOM.element(
	      html.dataset.replace('%CLASS%', this.name)
	        .replace('%PREFIX%', this.cssClasses.prefix)
	        .replace('%DATASET%', this.cssClasses.dataset)
	    );
	
	  this.$menu = o.$menu;
	  this.clearCachedSuggestions();
	}
	
	// static methods
	// --------------
	
	Dataset.extractDatasetName = function extractDatasetName(el) {
	  return DOM.element(el).data(datasetKey);
	};
	
	Dataset.extractValue = function extractValue(el) {
	  return DOM.element(el).data(valueKey);
	};
	
	Dataset.extractDatum = function extractDatum(el) {
	  var datum = DOM.element(el).data(datumKey);
	  if (typeof datum === 'string') {
	    // Zepto has an automatic deserialization of the
	    // JSON encoded data attribute
	    datum = JSON.parse(datum);
	  }
	  return datum;
	};
	
	// instance methods
	// ----------------
	
	_.mixin(Dataset.prototype, EventEmitter, {
	
	  // ### private
	
	  _render: function render(query, suggestions) {
	    if (!this.$el) {
	      return;
	    }
	    var that = this;
	
	    var hasSuggestions;
	    var renderArgs = [].slice.call(arguments, 2);
	    this.$el.empty();
	
	    hasSuggestions = suggestions && suggestions.length;
	    this._isEmpty = !hasSuggestions;
	
	    if (!hasSuggestions && this.templates.empty) {
	      this.$el
	        .html(getEmptyHtml.apply(this, renderArgs))
	        .prepend(that.templates.header ? getHeaderHtml.apply(this, renderArgs) : null)
	        .append(that.templates.footer ? getFooterHtml.apply(this, renderArgs) : null);
	    } else if (hasSuggestions) {
	      this.$el
	        .html(getSuggestionsHtml.apply(this, renderArgs))
	        .prepend(that.templates.header ? getHeaderHtml.apply(this, renderArgs) : null)
	        .append(that.templates.footer ? getFooterHtml.apply(this, renderArgs) : null);
	    } else if (suggestions && !Array.isArray(suggestions)) {
	      throw new TypeError('suggestions must be an array');
	    }
	
	    if (this.$menu) {
	      this.$menu.addClass(
	        this.cssClasses.prefix + (hasSuggestions ? 'with' : 'without') + '-' + this.name
	      ).removeClass(
	        this.cssClasses.prefix + (hasSuggestions ? 'without' : 'with') + '-' + this.name
	      );
	    }
	
	    this.trigger('rendered', query);
	
	    function getEmptyHtml() {
	      var args = [].slice.call(arguments, 0);
	      args = [{query: query, isEmpty: true}].concat(args);
	      return that.templates.empty.apply(this, args);
	    }
	
	    function getSuggestionsHtml() {
	      var args = [].slice.call(arguments, 0);
	      var $suggestions;
	      var nodes;
	      var self = this;
	
	      var suggestionsHtml = html.suggestions.
	        replace('%PREFIX%', this.cssClasses.prefix).
	        replace('%SUGGESTIONS%', this.cssClasses.suggestions);
	      $suggestions = DOM
	        .element(suggestionsHtml)
	        .css(this.css.suggestions);
	
	      // jQuery#append doesn't support arrays as the first argument
	      // until version 1.8, see http://bugs.jquery.com/ticket/11231
	      nodes = _.map(suggestions, getSuggestionNode);
	      $suggestions.append.apply($suggestions, nodes);
	
	      return $suggestions;
	
	      function getSuggestionNode(suggestion) {
	        var $el;
	
	        var suggestionHtml = html.suggestion.
	          replace('%PREFIX%', self.cssClasses.prefix).
	          replace('%SUGGESTION%', self.cssClasses.suggestion);
	        $el = DOM.element(suggestionHtml)
	          .attr({
	            role: 'option',
	            id: ['option', Math.floor(Math.random() * 100000000)].join('-')
	          })
	          .append(that.templates.suggestion.apply(this, [suggestion].concat(args)));
	
	        $el.data(datasetKey, that.name);
	        $el.data(valueKey, that.displayFn(suggestion) || undefined); // this led to undefined return value
	        $el.data(datumKey, JSON.stringify(suggestion));
	        $el.children().each(function() { DOM.element(this).css(self.css.suggestionChild); });
	
	        return $el;
	      }
	    }
	
	    function getHeaderHtml() {
	      var args = [].slice.call(arguments, 0);
	      args = [{query: query, isEmpty: !hasSuggestions}].concat(args);
	      return that.templates.header.apply(this, args);
	    }
	
	    function getFooterHtml() {
	      var args = [].slice.call(arguments, 0);
	      args = [{query: query, isEmpty: !hasSuggestions}].concat(args);
	      return that.templates.footer.apply(this, args);
	    }
	  },
	
	  // ### public
	
	  getRoot: function getRoot() {
	    return this.$el;
	  },
	
	  update: function update(query) {
	    function handleSuggestions(suggestions) {
	      // if the update has been canceled or if the query has changed
	      // do not render the suggestions as they've become outdated
	      if (!this.canceled && query === this.query) {
	        // concat all the other arguments that could have been passed
	        // to the render function, and forward them to _render
	        var extraArgs = [].slice.call(arguments, 1);
	        this.cacheSuggestions(query, suggestions, extraArgs);
	        this._render.apply(this, [query, suggestions].concat(extraArgs));
	      }
	    }
	
	    this.query = query;
	    this.canceled = false;
	
	    if (this.shouldFetchFromCache(query)) {
	      handleSuggestions.apply(this, [this.cachedSuggestions].concat(this.cachedRenderExtraArgs));
	    } else {
	      var that = this;
	      var execSource = function() {
	        // When the call is debounced the condition avoid to do a useless
	        // request with the last character when the input has been cleared
	        if (!that.canceled) {
	          that.source(query, handleSuggestions.bind(that));
	        }
	      };
	
	      if (this.debounce) {
	        var later = function() {
	          that.debounceTimeout = null;
	          execSource();
	        };
	        clearTimeout(this.debounceTimeout);
	        this.debounceTimeout = setTimeout(later, this.debounce);
	      } else {
	        execSource();
	      }
	    }
	  },
	
	  cacheSuggestions: function cacheSuggestions(query, suggestions, extraArgs) {
	    this.cachedQuery = query;
	    this.cachedSuggestions = suggestions;
	    this.cachedRenderExtraArgs = extraArgs;
	  },
	
	  shouldFetchFromCache: function shouldFetchFromCache(query) {
	    return this.cache &&
	      this.cachedQuery === query &&
	      this.cachedSuggestions &&
	      this.cachedSuggestions.length;
	  },
	
	  clearCachedSuggestions: function clearCachedSuggestions() {
	    delete this.cachedQuery;
	    delete this.cachedSuggestions;
	    delete this.cachedRenderExtraArgs;
	  },
	
	  cancel: function cancel() {
	    this.canceled = true;
	  },
	
	  clear: function clear() {
	    if (this.$el) {
	      this.cancel();
	      this.$el.empty();
	      this.trigger('rendered', '');
	    }
	  },
	
	  isEmpty: function isEmpty() {
	    return this._isEmpty;
	  },
	
	  destroy: function destroy() {
	    this.clearCachedSuggestions();
	    this.$el = null;
	  }
	});
	
	// helper functions
	// ----------------
	
	function getDisplayFn(display) {
	  display = display || 'value';
	
	  return _.isFunction(display) ? display : displayFn;
	
	  function displayFn(obj) {
	    return obj[display];
	  }
	}
	
	function getTemplates(templates, displayFn) {
	  return {
	    empty: templates.empty && _.templatify(templates.empty),
	    header: templates.header && _.templatify(templates.header),
	    footer: templates.footer && _.templatify(templates.footer),
	    suggestion: templates.suggestion || suggestionTemplate
	  };
	
	  function suggestionTemplate(context) {
	    return '<p>' + displayFn(context) + '</p>';
	  }
	}
	
	function isValidName(str) {
	  // dashes, underscores, letters, and numbers
	  return (/^[_a-zA-Z0-9-]+$/).test(str);
	}
	
	module.exports = Dataset;


/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(347);
	var DOM = __webpack_require__(477);
	var EventEmitter = __webpack_require__(942);
	var Dataset = __webpack_require__(1551);
	var css = __webpack_require__(941);
	
	// constructor
	// -----------
	
	function Dropdown(o) {
	  var that = this;
	  var onSuggestionClick;
	  var onSuggestionMouseEnter;
	  var onSuggestionMouseLeave;
	
	  o = o || {};
	
	  if (!o.menu) {
	    _.error('menu is required');
	  }
	
	  if (!_.isArray(o.datasets) && !_.isObject(o.datasets)) {
	    _.error('1 or more datasets required');
	  }
	  if (!o.datasets) {
	    _.error('datasets is required');
	  }
	
	  this.isOpen = false;
	  this.isEmpty = true;
	  this.minLength = o.minLength || 0;
	  this.templates = {};
	  this.appendTo = o.appendTo || false;
	  this.css = _.mixin({}, css, o.appendTo ? css.appendTo : {});
	  this.cssClasses = o.cssClasses = _.mixin({}, css.defaultClasses, o.cssClasses || {});
	  this.cssClasses.prefix =
	    o.cssClasses.formattedPrefix || _.formatPrefix(this.cssClasses.prefix, this.cssClasses.noPrefix);
	
	  // bound functions
	  onSuggestionClick = _.bind(this._onSuggestionClick, this);
	  onSuggestionMouseEnter = _.bind(this._onSuggestionMouseEnter, this);
	  onSuggestionMouseLeave = _.bind(this._onSuggestionMouseLeave, this);
	
	  var cssClass = _.className(this.cssClasses.prefix, this.cssClasses.suggestion);
	  this.$menu = DOM.element(o.menu)
	    .on('mouseenter.aa', cssClass, onSuggestionMouseEnter)
	    .on('mouseleave.aa', cssClass, onSuggestionMouseLeave)
	    .on('click.aa', cssClass, onSuggestionClick);
	
	  this.$container = o.appendTo ? o.wrapper : this.$menu;
	
	  if (o.templates && o.templates.header) {
	    this.templates.header = _.templatify(o.templates.header);
	    this.$menu.prepend(this.templates.header());
	  }
	
	  if (o.templates && o.templates.empty) {
	    this.templates.empty = _.templatify(o.templates.empty);
	    this.$empty = DOM.element('<div class="' +
	      _.className(this.cssClasses.prefix, this.cssClasses.empty, true) + '">' +
	      '</div>');
	    this.$menu.append(this.$empty);
	    this.$empty.hide();
	  }
	
	  this.datasets = _.map(o.datasets, function(oDataset) {
	    return initializeDataset(that.$menu, oDataset, o.cssClasses);
	  });
	  _.each(this.datasets, function(dataset) {
	    var root = dataset.getRoot();
	    if (root && root.parent().length === 0) {
	      that.$menu.append(root);
	    }
	    dataset.onSync('rendered', that._onRendered, that);
	  });
	
	  if (o.templates && o.templates.footer) {
	    this.templates.footer = _.templatify(o.templates.footer);
	    this.$menu.append(this.templates.footer());
	  }
	
	  var self = this;
	  DOM.element(window).resize(function() {
	    self._redraw();
	  });
	}
	
	// instance methods
	// ----------------
	
	_.mixin(Dropdown.prototype, EventEmitter, {
	
	  // ### private
	
	  _onSuggestionClick: function onSuggestionClick($e) {
	    this.trigger('suggestionClicked', DOM.element($e.currentTarget));
	  },
	
	  _onSuggestionMouseEnter: function onSuggestionMouseEnter($e) {
	    var elt = DOM.element($e.currentTarget);
	    if (elt.hasClass(_.className(this.cssClasses.prefix, this.cssClasses.cursor, true))) {
	      // we're already on the cursor
	      // => we're probably entering it again after leaving it for a nested div
	      return;
	    }
	    this._removeCursor();
	
	    // Fixes iOS double tap behaviour, by modifying the DOM right before the
	    // native href clicks happens, iOS will requires another tap to follow
	    // a suggestion that has an <a href> element inside
	    // https://www.google.com/search?q=ios+double+tap+bug+href
	    var suggestion = this;
	    setTimeout(function() {
	      // this exact line, when inside the main loop, will trigger a double tap bug
	      // on iOS devices
	      suggestion._setCursor(elt, false);
	    }, 0);
	  },
	
	  _onSuggestionMouseLeave: function onSuggestionMouseLeave($e) {
	    // $e.relatedTarget is the `EventTarget` the pointing device entered to
	    if ($e.relatedTarget) {
	      var elt = DOM.element($e.relatedTarget);
	      if (elt.closest('.' + _.className(this.cssClasses.prefix, this.cssClasses.cursor, true)).length > 0) {
	        // our father is a cursor
	        // => it means we're just leaving the suggestion for a nested div
	        return;
	      }
	    }
	    this._removeCursor();
	    this.trigger('cursorRemoved');
	  },
	
	  _onRendered: function onRendered(e, query) {
	    this.isEmpty = _.every(this.datasets, isDatasetEmpty);
	
	    if (this.isEmpty) {
	      if (query.length >= this.minLength) {
	        this.trigger('empty');
	      }
	
	      if (this.$empty) {
	        if (query.length < this.minLength) {
	          this._hide();
	        } else {
	          var html = this.templates.empty({
	            query: this.datasets[0] && this.datasets[0].query
	          });
	          this.$empty.html(html);
	          this.$empty.show();
	          this._show();
	        }
	      } else if (_.any(this.datasets, hasEmptyTemplate)) {
	        if (query.length < this.minLength) {
	          this._hide();
	        } else {
	          this._show();
	        }
	      } else {
	        this._hide();
	      }
	    } else if (this.isOpen) {
	      if (this.$empty) {
	        this.$empty.empty();
	        this.$empty.hide();
	      }
	
	      if (query.length >= this.minLength) {
	        this._show();
	      } else {
	        this._hide();
	      }
	    }
	
	    this.trigger('datasetRendered');
	
	    function isDatasetEmpty(dataset) {
	      return dataset.isEmpty();
	    }
	
	    function hasEmptyTemplate(dataset) {
	      return dataset.templates && dataset.templates.empty;
	    }
	  },
	
	  _hide: function() {
	    this.$container.hide();
	  },
	
	  _show: function() {
	    // can't use jQuery#show because $menu is a span element we want
	    // display: block; not dislay: inline;
	    this.$container.css('display', 'block');
	
	    this._redraw();
	
	    this.trigger('shown');
	  },
	
	  _redraw: function redraw() {
	    if (!this.isOpen || !this.appendTo) return;
	
	    this.trigger('redrawn');
	  },
	
	  _getSuggestions: function getSuggestions() {
	    return this.$menu.find(_.className(this.cssClasses.prefix, this.cssClasses.suggestion));
	  },
	
	  _getCursor: function getCursor() {
	    return this.$menu.find(_.className(this.cssClasses.prefix, this.cssClasses.cursor)).first();
	  },
	
	  _setCursor: function setCursor($el, updateInput) {
	    $el.first()
	      .addClass(_.className(this.cssClasses.prefix, this.cssClasses.cursor, true))
	      .attr('aria-selected', 'true');
	    this.trigger('cursorMoved', updateInput);
	  },
	
	  _removeCursor: function removeCursor() {
	    this._getCursor()
	      .removeClass(_.className(this.cssClasses.prefix, this.cssClasses.cursor, true))
	      .removeAttr('aria-selected');
	  },
	
	  _moveCursor: function moveCursor(increment) {
	    var $suggestions;
	    var $oldCursor;
	    var newCursorIndex;
	    var $newCursor;
	
	    if (!this.isOpen) {
	      return;
	    }
	
	    $oldCursor = this._getCursor();
	    $suggestions = this._getSuggestions();
	
	    this._removeCursor();
	
	    // shifting before and after modulo to deal with -1 index
	    newCursorIndex = $suggestions.index($oldCursor) + increment;
	    newCursorIndex = (newCursorIndex + 1) % ($suggestions.length + 1) - 1;
	
	    if (newCursorIndex === -1) {
	      this.trigger('cursorRemoved');
	
	      return;
	    } else if (newCursorIndex < -1) {
	      newCursorIndex = $suggestions.length - 1;
	    }
	
	    this._setCursor($newCursor = $suggestions.eq(newCursorIndex), true);
	
	    // in the case of scrollable overflow
	    // make sure the cursor is visible in the menu
	    this._ensureVisible($newCursor);
	  },
	
	  _ensureVisible: function ensureVisible($el) {
	    var elTop;
	    var elBottom;
	    var menuScrollTop;
	    var menuHeight;
	
	    elTop = $el.position().top;
	    elBottom = elTop + $el.height() +
	      parseInt($el.css('margin-top'), 10) +
	      parseInt($el.css('margin-bottom'), 10);
	    menuScrollTop = this.$menu.scrollTop();
	    menuHeight = this.$menu.height() +
	      parseInt(this.$menu.css('padding-top'), 10) +
	      parseInt(this.$menu.css('padding-bottom'), 10);
	
	    if (elTop < 0) {
	      this.$menu.scrollTop(menuScrollTop + elTop);
	    } else if (menuHeight < elBottom) {
	      this.$menu.scrollTop(menuScrollTop + (elBottom - menuHeight));
	    }
	  },
	
	  // ### public
	
	  close: function close() {
	    if (this.isOpen) {
	      this.isOpen = false;
	
	      this._removeCursor();
	      this._hide();
	
	      this.trigger('closed');
	    }
	  },
	
	  open: function open() {
	    if (!this.isOpen) {
	      this.isOpen = true;
	
	      if (!this.isEmpty) {
	        this._show();
	      }
	
	      this.trigger('opened');
	    }
	  },
	
	  setLanguageDirection: function setLanguageDirection(dir) {
	    this.$menu.css(dir === 'ltr' ? this.css.ltr : this.css.rtl);
	  },
	
	  moveCursorUp: function moveCursorUp() {
	    this._moveCursor(-1);
	  },
	
	  moveCursorDown: function moveCursorDown() {
	    this._moveCursor(+1);
	  },
	
	  getDatumForSuggestion: function getDatumForSuggestion($el) {
	    var datum = null;
	
	    if ($el.length) {
	      datum = {
	        raw: Dataset.extractDatum($el),
	        value: Dataset.extractValue($el),
	        datasetName: Dataset.extractDatasetName($el)
	      };
	    }
	
	    return datum;
	  },
	
	  getCurrentCursor: function getCurrentCursor() {
	    return this._getCursor().first();
	  },
	
	  getDatumForCursor: function getDatumForCursor() {
	    return this.getDatumForSuggestion(this._getCursor().first());
	  },
	
	  getDatumForTopSuggestion: function getDatumForTopSuggestion() {
	    return this.getDatumForSuggestion(this._getSuggestions().first());
	  },
	
	  cursorTopSuggestion: function cursorTopSuggestion() {
	    this._setCursor(this._getSuggestions().first(), false);
	  },
	
	  update: function update(query) {
	    _.each(this.datasets, updateDataset);
	
	    function updateDataset(dataset) {
	      dataset.update(query);
	    }
	  },
	
	  empty: function empty() {
	    _.each(this.datasets, clearDataset);
	    this.isEmpty = true;
	
	    function clearDataset(dataset) {
	      dataset.clear();
	    }
	  },
	
	  isVisible: function isVisible() {
	    return this.isOpen && !this.isEmpty;
	  },
	
	  destroy: function destroy() {
	    this.$menu.off('.aa');
	
	    this.$menu = null;
	
	    _.each(this.datasets, destroyDataset);
	
	    function destroyDataset(dataset) {
	      dataset.destroy();
	    }
	  }
	});
	
	// helper functions
	// ----------------
	Dropdown.Dataset = Dataset;
	
	function initializeDataset($menu, oDataset, cssClasses) {
	  return new Dropdown.Dataset(_.mixin({$menu: $menu, cssClasses: cssClasses}, oDataset));
	}
	
	module.exports = Dropdown;


/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var specialKeyCodeMap;
	
	specialKeyCodeMap = {
	  9: 'tab',
	  27: 'esc',
	  37: 'left',
	  39: 'right',
	  13: 'enter',
	  38: 'up',
	  40: 'down'
	};
	
	var _ = __webpack_require__(347);
	var DOM = __webpack_require__(477);
	var EventEmitter = __webpack_require__(942);
	
	// constructor
	// -----------
	
	function Input(o) {
	  var that = this;
	  var onBlur;
	  var onFocus;
	  var onKeydown;
	  var onInput;
	
	  o = o || {};
	
	  if (!o.input) {
	    _.error('input is missing');
	  }
	
	  // bound functions
	  onBlur = _.bind(this._onBlur, this);
	  onFocus = _.bind(this._onFocus, this);
	  onKeydown = _.bind(this._onKeydown, this);
	  onInput = _.bind(this._onInput, this);
	
	  this.$hint = DOM.element(o.hint);
	  this.$input = DOM.element(o.input)
	    .on('blur.aa', onBlur)
	    .on('focus.aa', onFocus)
	    .on('keydown.aa', onKeydown);
	
	  // if no hint, noop all the hint related functions
	  if (this.$hint.length === 0) {
	    this.setHint = this.getHint = this.clearHint = this.clearHintIfInvalid = _.noop;
	  }
	
	  // ie7 and ie8 don't support the input event
	  // ie9 doesn't fire the input event when characters are removed
	  // not sure if ie10 is compatible
	  if (!_.isMsie()) {
	    this.$input.on('input.aa', onInput);
	  } else {
	    this.$input.on('keydown.aa keypress.aa cut.aa paste.aa', function($e) {
	      // if a special key triggered this, ignore it
	      if (specialKeyCodeMap[$e.which || $e.keyCode]) {
	        return;
	      }
	
	      // give the browser a chance to update the value of the input
	      // before checking to see if the query changed
	      _.defer(_.bind(that._onInput, that, $e));
	    });
	  }
	
	  // the query defaults to whatever the value of the input is
	  // on initialization, it'll most likely be an empty string
	  this.query = this.$input.val();
	
	  // helps with calculating the width of the input's value
	  this.$overflowHelper = buildOverflowHelper(this.$input);
	}
	
	// static methods
	// --------------
	
	Input.normalizeQuery = function(str) {
	  // strips leading whitespace and condenses all whitespace
	  return (str || '').replace(/^\s*/g, '').replace(/\s{2,}/g, ' ');
	};
	
	// instance methods
	// ----------------
	
	_.mixin(Input.prototype, EventEmitter, {
	
	  // ### private
	
	  _onBlur: function onBlur() {
	    this.resetInputValue();
	    this.$input.removeAttr('aria-activedescendant');
	    this.trigger('blurred');
	  },
	
	  _onFocus: function onFocus() {
	    this.trigger('focused');
	  },
	
	  _onKeydown: function onKeydown($e) {
	    // which is normalized and consistent (but not for ie)
	    var keyName = specialKeyCodeMap[$e.which || $e.keyCode];
	
	    this._managePreventDefault(keyName, $e);
	    if (keyName && this._shouldTrigger(keyName, $e)) {
	      this.trigger(keyName + 'Keyed', $e);
	    }
	  },
	
	  _onInput: function onInput() {
	    this._checkInputValue();
	  },
	
	  _managePreventDefault: function managePreventDefault(keyName, $e) {
	    var preventDefault;
	    var hintValue;
	    var inputValue;
	
	    switch (keyName) {
	    case 'tab':
	      hintValue = this.getHint();
	      inputValue = this.getInputValue();
	
	      preventDefault = hintValue &&
	        hintValue !== inputValue &&
	        !withModifier($e);
	      break;
	
	    case 'up':
	    case 'down':
	      preventDefault = !withModifier($e);
	      break;
	
	    default:
	      preventDefault = false;
	    }
	
	    if (preventDefault) {
	      $e.preventDefault();
	    }
	  },
	
	  _shouldTrigger: function shouldTrigger(keyName, $e) {
	    var trigger;
	
	    switch (keyName) {
	    case 'tab':
	      trigger = !withModifier($e);
	      break;
	
	    default:
	      trigger = true;
	    }
	
	    return trigger;
	  },
	
	  _checkInputValue: function checkInputValue() {
	    var inputValue;
	    var areEquivalent;
	    var hasDifferentWhitespace;
	
	    inputValue = this.getInputValue();
	    areEquivalent = areQueriesEquivalent(inputValue, this.query);
	    hasDifferentWhitespace = areEquivalent && this.query ?
	      this.query.length !== inputValue.length : false;
	
	    this.query = inputValue;
	
	    if (!areEquivalent) {
	      this.trigger('queryChanged', this.query);
	    } else if (hasDifferentWhitespace) {
	      this.trigger('whitespaceChanged', this.query);
	    }
	  },
	
	  // ### public
	
	  focus: function focus() {
	    this.$input.focus();
	  },
	
	  blur: function blur() {
	    this.$input.blur();
	  },
	
	  getQuery: function getQuery() {
	    return this.query;
	  },
	
	  setQuery: function setQuery(query) {
	    this.query = query;
	  },
	
	  getInputValue: function getInputValue() {
	    return this.$input.val();
	  },
	
	  setInputValue: function setInputValue(value, silent) {
	    if (typeof value === 'undefined') {
	      value = this.query;
	    }
	    this.$input.val(value);
	
	    // silent prevents any additional events from being triggered
	    if (silent) {
	      this.clearHint();
	    } else {
	      this._checkInputValue();
	    }
	  },
	
	  expand: function expand() {
	    this.$input.attr('aria-expanded', 'true');
	  },
	
	  collapse: function collapse() {
	    this.$input.attr('aria-expanded', 'false');
	  },
	
	  setActiveDescendant: function setActiveDescendant(activedescendantId) {
	    this.$input.attr('aria-activedescendant', activedescendantId);
	  },
	
	  removeActiveDescendant: function removeActiveDescendant() {
	    this.$input.removeAttr('aria-activedescendant');
	  },
	
	  resetInputValue: function resetInputValue() {
	    this.setInputValue(this.query, true);
	  },
	
	  getHint: function getHint() {
	    return this.$hint.val();
	  },
	
	  setHint: function setHint(value) {
	    this.$hint.val(value);
	  },
	
	  clearHint: function clearHint() {
	    this.setHint('');
	  },
	
	  clearHintIfInvalid: function clearHintIfInvalid() {
	    var val;
	    var hint;
	    var valIsPrefixOfHint;
	    var isValid;
	
	    val = this.getInputValue();
	    hint = this.getHint();
	    valIsPrefixOfHint = val !== hint && hint.indexOf(val) === 0;
	    isValid = val !== '' && valIsPrefixOfHint && !this.hasOverflow();
	
	    if (!isValid) {
	      this.clearHint();
	    }
	  },
	
	  getLanguageDirection: function getLanguageDirection() {
	    return (this.$input.css('direction') || 'ltr').toLowerCase();
	  },
	
	  hasOverflow: function hasOverflow() {
	    // 2 is arbitrary, just picking a small number to handle edge cases
	    var constraint = this.$input.width() - 2;
	
	    this.$overflowHelper.text(this.getInputValue());
	
	    return this.$overflowHelper.width() >= constraint;
	  },
	
	  isCursorAtEnd: function() {
	    var valueLength;
	    var selectionStart;
	    var range;
	
	    valueLength = this.$input.val().length;
	    selectionStart = this.$input[0].selectionStart;
	
	    if (_.isNumber(selectionStart)) {
	      return selectionStart === valueLength;
	    } else if (document.selection) {
	      // NOTE: this won't work unless the input has focus, the good news
	      // is this code should only get called when the input has focus
	      range = document.selection.createRange();
	      range.moveStart('character', -valueLength);
	
	      return valueLength === range.text.length;
	    }
	
	    return true;
	  },
	
	  destroy: function destroy() {
	    this.$hint.off('.aa');
	    this.$input.off('.aa');
	
	    this.$hint = this.$input = this.$overflowHelper = null;
	  }
	});
	
	// helper functions
	// ----------------
	
	function buildOverflowHelper($input) {
	  return DOM.element('<pre aria-hidden="true"></pre>')
	    .css({
	      // position helper off-screen
	      position: 'absolute',
	      visibility: 'hidden',
	      // avoid line breaks and whitespace collapsing
	      whiteSpace: 'pre',
	      // use same font css as input to calculate accurate width
	      fontFamily: $input.css('font-family'),
	      fontSize: $input.css('font-size'),
	      fontStyle: $input.css('font-style'),
	      fontVariant: $input.css('font-variant'),
	      fontWeight: $input.css('font-weight'),
	      wordSpacing: $input.css('word-spacing'),
	      letterSpacing: $input.css('letter-spacing'),
	      textIndent: $input.css('text-indent'),
	      textRendering: $input.css('text-rendering'),
	      textTransform: $input.css('text-transform')
	    })
	    .insertAfter($input);
	}
	
	function areQueriesEquivalent(a, b) {
	  return Input.normalizeQuery(a) === Input.normalizeQuery(b);
	}
	
	function withModifier($e) {
	  return $e.altKey || $e.ctrlKey || $e.metaKey || $e.shiftKey;
	}
	
	module.exports = Input;


/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var attrsKey = 'aaAttrs';
	
	var _ = __webpack_require__(347);
	var DOM = __webpack_require__(477);
	var EventBus = __webpack_require__(1285);
	var Input = __webpack_require__(1553);
	var Dropdown = __webpack_require__(1552);
	var html = __webpack_require__(1286);
	var css = __webpack_require__(941);
	
	// constructor
	// -----------
	
	// THOUGHT: what if datasets could dynamically be added/removed?
	function Typeahead(o) {
	  var $menu;
	  var $hint;
	
	  o = o || {};
	
	  if (!o.input) {
	    _.error('missing input');
	  }
	
	  this.isActivated = false;
	  this.debug = !!o.debug;
	  this.autoselect = !!o.autoselect;
	  this.autoselectOnBlur = !!o.autoselectOnBlur;
	  this.openOnFocus = !!o.openOnFocus;
	  this.minLength = _.isNumber(o.minLength) ? o.minLength : 1;
	  this.autoWidth = (o.autoWidth === undefined) ? true : !!o.autoWidth;
	  this.clearOnSelected = !!o.clearOnSelected;
	  this.tabAutocomplete = (o.tabAutocomplete === undefined) ? true : !!o.tabAutocomplete;
	
	  o.hint = !!o.hint;
	
	  if (o.hint && o.appendTo) {
	    throw new Error('[autocomplete.js] hint and appendTo options can\'t be used at the same time');
	  }
	
	  this.css = o.css = _.mixin({}, css, o.appendTo ? css.appendTo : {});
	  this.cssClasses = o.cssClasses = _.mixin({}, css.defaultClasses, o.cssClasses || {});
	  this.cssClasses.prefix =
	    o.cssClasses.formattedPrefix = _.formatPrefix(this.cssClasses.prefix, this.cssClasses.noPrefix);
	  this.listboxId = o.listboxId = [this.cssClasses.root, 'listbox', _.getUniqueId()].join('-');
	
	  var domElts = buildDom(o);
	
	  this.$node = domElts.wrapper;
	  var $input = this.$input = domElts.input;
	  $menu = domElts.menu;
	  $hint = domElts.hint;
	
	  if (o.dropdownMenuContainer) {
	    DOM.element(o.dropdownMenuContainer)
	      .css('position', 'relative') // ensure the container has a relative position
	      .append($menu.css('top', '0')); // override the top: 100%
	  }
	
	  // #705: if there's scrollable overflow, ie doesn't support
	  // blur cancellations when the scrollbar is clicked
	  //
	  // #351: preventDefault won't cancel blurs in ie <= 8
	  $input.on('blur.aa', function($e) {
	    var active = document.activeElement;
	    if (_.isMsie() && ($menu[0] === active || $menu[0].contains(active))) {
	      $e.preventDefault();
	      // stop immediate in order to prevent Input#_onBlur from
	      // getting exectued
	      $e.stopImmediatePropagation();
	      _.defer(function() { $input.focus(); });
	    }
	  });
	
	  // #351: prevents input blur due to clicks within dropdown menu
	  $menu.on('mousedown.aa', function($e) { $e.preventDefault(); });
	
	  this.eventBus = o.eventBus || new EventBus({el: $input});
	
	  this.dropdown = new Typeahead.Dropdown({
	    appendTo: o.appendTo,
	    wrapper: this.$node,
	    menu: $menu,
	    datasets: o.datasets,
	    templates: o.templates,
	    cssClasses: o.cssClasses,
	    minLength: this.minLength
	  })
	    .onSync('suggestionClicked', this._onSuggestionClicked, this)
	    .onSync('cursorMoved', this._onCursorMoved, this)
	    .onSync('cursorRemoved', this._onCursorRemoved, this)
	    .onSync('opened', this._onOpened, this)
	    .onSync('closed', this._onClosed, this)
	    .onSync('shown', this._onShown, this)
	    .onSync('empty', this._onEmpty, this)
	    .onSync('redrawn', this._onRedrawn, this)
	    .onAsync('datasetRendered', this._onDatasetRendered, this);
	
	  this.input = new Typeahead.Input({input: $input, hint: $hint})
	    .onSync('focused', this._onFocused, this)
	    .onSync('blurred', this._onBlurred, this)
	    .onSync('enterKeyed', this._onEnterKeyed, this)
	    .onSync('tabKeyed', this._onTabKeyed, this)
	    .onSync('escKeyed', this._onEscKeyed, this)
	    .onSync('upKeyed', this._onUpKeyed, this)
	    .onSync('downKeyed', this._onDownKeyed, this)
	    .onSync('leftKeyed', this._onLeftKeyed, this)
	    .onSync('rightKeyed', this._onRightKeyed, this)
	    .onSync('queryChanged', this._onQueryChanged, this)
	    .onSync('whitespaceChanged', this._onWhitespaceChanged, this);
	
	  this._bindKeyboardShortcuts(o);
	
	  this._setLanguageDirection();
	}
	
	// instance methods
	// ----------------
	
	_.mixin(Typeahead.prototype, {
	  // ### private
	
	  _bindKeyboardShortcuts: function(options) {
	    if (!options.keyboardShortcuts) {
	      return;
	    }
	    var $input = this.$input;
	    var keyboardShortcuts = [];
	    _.each(options.keyboardShortcuts, function(key) {
	      if (typeof key === 'string') {
	        key = key.toUpperCase().charCodeAt(0);
	      }
	      keyboardShortcuts.push(key);
	    });
	    DOM.element(document).keydown(function(event) {
	      var elt = (event.target || event.srcElement);
	      var tagName = elt.tagName;
	      if (elt.isContentEditable || tagName === 'INPUT' || tagName === 'SELECT' || tagName === 'TEXTAREA') {
	        // already in an input
	        return;
	      }
	
	      var which = event.which || event.keyCode;
	      if (keyboardShortcuts.indexOf(which) === -1) {
	        // not the right shortcut
	        return;
	      }
	
	      $input.focus();
	      event.stopPropagation();
	      event.preventDefault();
	    });
	  },
	
	  _onSuggestionClicked: function onSuggestionClicked(type, $el) {
	    var datum;
	    var context = {selectionMethod: 'click'};
	
	    if (datum = this.dropdown.getDatumForSuggestion($el)) {
	      this._select(datum, context);
	    }
	  },
	
	  _onCursorMoved: function onCursorMoved(event, updateInput) {
	    var datum = this.dropdown.getDatumForCursor();
	    var currentCursorId = this.dropdown.getCurrentCursor().attr('id');
	    this.input.setActiveDescendant(currentCursorId);
	
	    if (datum) {
	      if (updateInput) {
	        this.input.setInputValue(datum.value, true);
	      }
	
	      this.eventBus.trigger('cursorchanged', datum.raw, datum.datasetName);
	    }
	  },
	
	  _onCursorRemoved: function onCursorRemoved() {
	    this.input.resetInputValue();
	    this._updateHint();
	    this.eventBus.trigger('cursorremoved');
	  },
	
	  _onDatasetRendered: function onDatasetRendered() {
	    this._updateHint();
	
	    this.eventBus.trigger('updated');
	  },
	
	  _onOpened: function onOpened() {
	    this._updateHint();
	    this.input.expand();
	
	    this.eventBus.trigger('opened');
	  },
	
	  _onEmpty: function onEmpty() {
	    this.eventBus.trigger('empty');
	  },
	
	  _onRedrawn: function onRedrawn() {
	    this.$node.css('top', 0 + 'px');
	    this.$node.css('left', 0 + 'px');
	
	    var inputRect = this.$input[0].getBoundingClientRect();
	
	    if (this.autoWidth) {
	      this.$node.css('width', inputRect.width + 'px');
	    }
	
	    var wrapperRect = this.$node[0].getBoundingClientRect();
	
	    var top = inputRect.bottom - wrapperRect.top;
	    this.$node.css('top', top + 'px');
	    var left = inputRect.left - wrapperRect.left;
	    this.$node.css('left', left + 'px');
	
	    this.eventBus.trigger('redrawn');
	  },
	
	  _onShown: function onShown() {
	    this.eventBus.trigger('shown');
	    if (this.autoselect) {
	      this.dropdown.cursorTopSuggestion();
	    }
	  },
	
	  _onClosed: function onClosed() {
	    this.input.clearHint();
	    this.input.removeActiveDescendant();
	    this.input.collapse();
	
	    this.eventBus.trigger('closed');
	  },
	
	  _onFocused: function onFocused() {
	    this.isActivated = true;
	
	    if (this.openOnFocus) {
	      var query = this.input.getQuery();
	      if (query.length >= this.minLength) {
	        this.dropdown.update(query);
	      } else {
	        this.dropdown.empty();
	      }
	
	      this.dropdown.open();
	    }
	  },
	
	  _onBlurred: function onBlurred() {
	    var cursorDatum;
	    var topSuggestionDatum;
	
	    cursorDatum = this.dropdown.getDatumForCursor();
	    topSuggestionDatum = this.dropdown.getDatumForTopSuggestion();
	    var context = {selectionMethod: 'blur'};
	
	    if (!this.debug) {
	      if (this.autoselectOnBlur && cursorDatum) {
	        this._select(cursorDatum, context);
	      } else if (this.autoselectOnBlur && topSuggestionDatum) {
	        this._select(topSuggestionDatum, context);
	      } else {
	        this.isActivated = false;
	        this.dropdown.empty();
	        this.dropdown.close();
	      }
	    }
	  },
	
	  _onEnterKeyed: function onEnterKeyed(type, $e) {
	    var cursorDatum;
	    var topSuggestionDatum;
	
	    cursorDatum = this.dropdown.getDatumForCursor();
	    topSuggestionDatum = this.dropdown.getDatumForTopSuggestion();
	    var context = {selectionMethod: 'enterKey'};
	
	    if (cursorDatum) {
	      this._select(cursorDatum, context);
	      $e.preventDefault();
	    } else if (this.autoselect && topSuggestionDatum) {
	      this._select(topSuggestionDatum, context);
	      $e.preventDefault();
	    }
	  },
	
	  _onTabKeyed: function onTabKeyed(type, $e) {
	    if (!this.tabAutocomplete) {
	      // Closing the dropdown enables further tabbing
	      this.dropdown.close();
	      return;
	    }
	
	    var datum;
	    var context = {selectionMethod: 'tabKey'};
	
	    if (datum = this.dropdown.getDatumForCursor()) {
	      this._select(datum, context);
	      $e.preventDefault();
	    } else {
	      this._autocomplete(true);
	    }
	  },
	
	  _onEscKeyed: function onEscKeyed() {
	    this.dropdown.close();
	    this.input.resetInputValue();
	  },
	
	  _onUpKeyed: function onUpKeyed() {
	    var query = this.input.getQuery();
	
	    if (this.dropdown.isEmpty && query.length >= this.minLength) {
	      this.dropdown.update(query);
	    } else {
	      this.dropdown.moveCursorUp();
	    }
	
	    this.dropdown.open();
	  },
	
	  _onDownKeyed: function onDownKeyed() {
	    var query = this.input.getQuery();
	
	    if (this.dropdown.isEmpty && query.length >= this.minLength) {
	      this.dropdown.update(query);
	    } else {
	      this.dropdown.moveCursorDown();
	    }
	
	    this.dropdown.open();
	  },
	
	  _onLeftKeyed: function onLeftKeyed() {
	    if (this.dir === 'rtl') {
	      this._autocomplete();
	    }
	  },
	
	  _onRightKeyed: function onRightKeyed() {
	    if (this.dir === 'ltr') {
	      this._autocomplete();
	    }
	  },
	
	  _onQueryChanged: function onQueryChanged(e, query) {
	    this.input.clearHintIfInvalid();
	
	    if (query.length >= this.minLength) {
	      this.dropdown.update(query);
	    } else {
	      this.dropdown.empty();
	    }
	
	    this.dropdown.open();
	    this._setLanguageDirection();
	  },
	
	  _onWhitespaceChanged: function onWhitespaceChanged() {
	    this._updateHint();
	    this.dropdown.open();
	  },
	
	  _setLanguageDirection: function setLanguageDirection() {
	    var dir = this.input.getLanguageDirection();
	
	    if (this.dir !== dir) {
	      this.dir = dir;
	      this.$node.css('direction', dir);
	      this.dropdown.setLanguageDirection(dir);
	    }
	  },
	
	  _updateHint: function updateHint() {
	    var datum;
	    var val;
	    var query;
	    var escapedQuery;
	    var frontMatchRegEx;
	    var match;
	
	    datum = this.dropdown.getDatumForTopSuggestion();
	
	    if (datum && this.dropdown.isVisible() && !this.input.hasOverflow()) {
	      val = this.input.getInputValue();
	      query = Input.normalizeQuery(val);
	      escapedQuery = _.escapeRegExChars(query);
	
	      // match input value, then capture trailing text
	      frontMatchRegEx = new RegExp('^(?:' + escapedQuery + ')(.+$)', 'i');
	      match = frontMatchRegEx.exec(datum.value);
	
	      // clear hint if there's no trailing text
	      if (match) {
	        this.input.setHint(val + match[1]);
	      } else {
	        this.input.clearHint();
	      }
	    } else {
	      this.input.clearHint();
	    }
	  },
	
	  _autocomplete: function autocomplete(laxCursor) {
	    var hint;
	    var query;
	    var isCursorAtEnd;
	    var datum;
	
	    hint = this.input.getHint();
	    query = this.input.getQuery();
	    isCursorAtEnd = laxCursor || this.input.isCursorAtEnd();
	
	    if (hint && query !== hint && isCursorAtEnd) {
	      datum = this.dropdown.getDatumForTopSuggestion();
	      if (datum) {
	        this.input.setInputValue(datum.value);
	      }
	
	      this.eventBus.trigger('autocompleted', datum.raw, datum.datasetName);
	    }
	  },
	
	  _select: function select(datum, context) {
	    if (typeof datum.value !== 'undefined') {
	      this.input.setQuery(datum.value);
	    }
	    if (this.clearOnSelected) {
	      this.setVal('');
	    } else {
	      this.input.setInputValue(datum.value, true);
	    }
	
	    this._setLanguageDirection();
	
	    var event = this.eventBus.trigger('selected', datum.raw, datum.datasetName, context);
	    if (event.isDefaultPrevented() === false) {
	      this.dropdown.close();
	
	      // #118: allow click event to bubble up to the body before removing
	      // the suggestions otherwise we break event delegation
	      _.defer(_.bind(this.dropdown.empty, this.dropdown));
	    }
	  },
	
	  // ### public
	
	  open: function open() {
	    // if the menu is not activated yet, we need to update
	    // the underlying dropdown menu to trigger the search
	    // otherwise we're not gonna see anything
	    if (!this.isActivated) {
	      var query = this.input.getInputValue();
	      if (query.length >= this.minLength) {
	        this.dropdown.update(query);
	      } else {
	        this.dropdown.empty();
	      }
	    }
	    this.dropdown.open();
	  },
	
	  close: function close() {
	    this.dropdown.close();
	  },
	
	  setVal: function setVal(val) {
	    // expect val to be a string, so be safe, and coerce
	    val = _.toStr(val);
	
	    if (this.isActivated) {
	      this.input.setInputValue(val);
	    } else {
	      this.input.setQuery(val);
	      this.input.setInputValue(val, true);
	    }
	
	    this._setLanguageDirection();
	  },
	
	  getVal: function getVal() {
	    return this.input.getQuery();
	  },
	
	  destroy: function destroy() {
	    this.input.destroy();
	    this.dropdown.destroy();
	
	    destroyDomStructure(this.$node, this.cssClasses);
	
	    this.$node = null;
	  },
	
	  getWrapper: function getWrapper() {
	    return this.dropdown.$container[0];
	  }
	});
	
	function buildDom(options) {
	  var $input;
	  var $wrapper;
	  var $dropdown;
	  var $hint;
	
	  $input = DOM.element(options.input);
	  $wrapper = DOM
	    .element(html.wrapper.replace('%ROOT%', options.cssClasses.root))
	    .css(options.css.wrapper);
	
	  // override the display property with the table-cell value
	  // if the parent element is a table and the original input was a block
	  //  -> https://github.com/algolia/autocomplete.js/issues/16
	  if (!options.appendTo && $input.css('display') === 'block' && $input.parent().css('display') === 'table') {
	    $wrapper.css('display', 'table-cell');
	  }
	  var dropdownHtml = html.dropdown.
	    replace('%PREFIX%', options.cssClasses.prefix).
	    replace('%DROPDOWN_MENU%', options.cssClasses.dropdownMenu);
	  $dropdown = DOM.element(dropdownHtml)
	    .css(options.css.dropdown)
	    .attr({
	      role: 'listbox',
	      id: options.listboxId
	    });
	  if (options.templates && options.templates.dropdownMenu) {
	    $dropdown.html(_.templatify(options.templates.dropdownMenu)());
	  }
	  $hint = $input.clone().css(options.css.hint).css(getBackgroundStyles($input));
	
	  $hint
	    .val('')
	    .addClass(_.className(options.cssClasses.prefix, options.cssClasses.hint, true))
	    .removeAttr('id name placeholder required')
	    .prop('readonly', true)
	    .attr({
	      'aria-hidden': 'true',
	      autocomplete: 'off',
	      spellcheck: 'false',
	      tabindex: -1
	    });
	  if ($hint.removeData) {
	    $hint.removeData();
	  }
	
	  // store the original values of the attrs that get modified
	  // so modifications can be reverted on destroy
	  $input.data(attrsKey, {
	    'aria-autocomplete': $input.attr('aria-autocomplete'),
	    'aria-expanded': $input.attr('aria-expanded'),
	    'aria-owns': $input.attr('aria-owns'),
	    autocomplete: $input.attr('autocomplete'),
	    dir: $input.attr('dir'),
	    role: $input.attr('role'),
	    spellcheck: $input.attr('spellcheck'),
	    style: $input.attr('style'),
	    type: $input.attr('type')
	  });
	
	  $input
	    .addClass(_.className(options.cssClasses.prefix, options.cssClasses.input, true))
	    .attr({
	      autocomplete: 'off',
	      spellcheck: false,
	
	      // Accessibility features
	      // Give the field a presentation of a "select".
	      // Combobox is the combined presentation of a single line textfield
	      // with a listbox popup.
	      // https://www.w3.org/WAI/PF/aria/roles#combobox
	      role: 'combobox',
	      // Let the screen reader know the field has an autocomplete
	      // feature to it.
	      'aria-autocomplete': (options.datasets &&
	        options.datasets[0] && options.datasets[0].displayKey ? 'both' : 'list'),
	      // Indicates whether the dropdown it controls is currently expanded or collapsed
	      'aria-expanded': 'false',
	      'aria-label': options.ariaLabel,
	      // Explicitly point to the listbox,
	      // which is a list of suggestions (aka options)
	      'aria-owns': options.listboxId
	    })
	    .css(options.hint ? options.css.input : options.css.inputWithNoHint);
	
	  // ie7 does not like it when dir is set to auto
	  try {
	    if (!$input.attr('dir')) {
	      $input.attr('dir', 'auto');
	    }
	  } catch (e) {
	    // ignore
	  }
	
	  $wrapper = options.appendTo
	    ? $wrapper.appendTo(DOM.element(options.appendTo).eq(0)).eq(0)
	    : $input.wrap($wrapper).parent();
	
	  $wrapper
	    .prepend(options.hint ? $hint : null)
	    .append($dropdown);
	
	  return {
	    wrapper: $wrapper,
	    input: $input,
	    hint: $hint,
	    menu: $dropdown
	  };
	}
	
	function getBackgroundStyles($el) {
	  return {
	    backgroundAttachment: $el.css('background-attachment'),
	    backgroundClip: $el.css('background-clip'),
	    backgroundColor: $el.css('background-color'),
	    backgroundImage: $el.css('background-image'),
	    backgroundOrigin: $el.css('background-origin'),
	    backgroundPosition: $el.css('background-position'),
	    backgroundRepeat: $el.css('background-repeat'),
	    backgroundSize: $el.css('background-size')
	  };
	}
	
	function destroyDomStructure($node, cssClasses) {
	  var $input = $node.find(_.className(cssClasses.prefix, cssClasses.input));
	
	  // need to remove attrs that weren't previously defined and
	  // revert attrs that originally had a value
	  _.each($input.data(attrsKey), function(val, key) {
	    if (val === undefined) {
	      $input.removeAttr(key);
	    } else {
	      $input.attr(key, val);
	    }
	  });
	
	  $input
	    .detach()
	    .removeClass(_.className(cssClasses.prefix, cssClasses.input, true))
	    .insertAfter($node);
	  if ($input.removeData) {
	    $input.removeData(attrsKey);
	  }
	
	  $node.remove();
	}
	
	Typeahead.Dropdown = Dropdown;
	Typeahead.Input = Input;
	Typeahead.sources = __webpack_require__(1556);
	
	module.exports = Typeahead;


/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(347);
	var version = __webpack_require__(1288);
	var parseAlgoliaClientVersion = __webpack_require__(1287);
	
	module.exports = function search(index, params) {
	  var algoliaVersion = parseAlgoliaClientVersion(index.as._ua);
	  if (algoliaVersion && algoliaVersion[0] >= 3 && algoliaVersion[1] > 20) {
	    params = params || {};
	    params.additionalUA = 'autocomplete.js ' + version;
	  }
	  return sourceFn;
	
	  function sourceFn(query, cb) {
	    index.search(query, params, function(error, content) {
	      if (error) {
	        _.error(error.message);
	        return;
	      }
	      cb(content.hits, content);
	    });
	  }
	};


/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  hits: __webpack_require__(1555),
	  popularIn: __webpack_require__(1557)
	};


/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(347);
	var version = __webpack_require__(1288);
	var parseAlgoliaClientVersion = __webpack_require__(1287);
	
	module.exports = function popularIn(index, params, details, options) {
	  var algoliaVersion = parseAlgoliaClientVersion(index.as._ua);
	  if (algoliaVersion && algoliaVersion[0] >= 3 && algoliaVersion[1] > 20) {
	    params = params || {};
	    params.additionalUA = 'autocomplete.js ' + version;
	  }
	  if (!details.source) {
	    return _.error("Missing 'source' key");
	  }
	  var source = _.isFunction(details.source) ? details.source : function(hit) { return hit[details.source]; };
	
	  if (!details.index) {
	    return _.error("Missing 'index' key");
	  }
	  var detailsIndex = details.index;
	
	  options = options || {};
	
	  return sourceFn;
	
	  function sourceFn(query, cb) {
	    index.search(query, params, function(error, content) {
	      if (error) {
	        _.error(error.message);
	        return;
	      }
	
	      if (content.hits.length > 0) {
	        var first = content.hits[0];
	
	        var detailsParams = _.mixin({hitsPerPage: 0}, details);
	        delete detailsParams.source; // not a query parameter
	        delete detailsParams.index; // not a query parameter
	
	        var detailsAlgoliaVersion = parseAlgoliaClientVersion(detailsIndex.as._ua);
	        if (detailsAlgoliaVersion && detailsAlgoliaVersion[0] >= 3 && detailsAlgoliaVersion[1] > 20) {
	          params.additionalUA = 'autocomplete.js ' + version;
	        }
	
	        detailsIndex.search(source(first), detailsParams, function(error2, content2) {
	          if (error2) {
	            _.error(error2.message);
	            return;
	          }
	
	          var suggestions = [];
	
	          // add the 'all department' entry before others
	          if (options.includeAll) {
	            var label = options.allTitle || 'All departments';
	            suggestions.push(_.mixin({
	              facet: {value: label, count: content2.nbHits}
	            }, _.cloneDeep(first)));
	          }
	
	          // enrich the first hit iterating over the facets
	          _.each(content2.facets, function(values, facet) {
	            _.each(values, function(count, value) {
	              suggestions.push(_.mixin({
	                facet: {facet: facet, value: value, count: count}
	              }, _.cloneDeep(first)));
	            });
	          });
	
	          // append all other hits
	          for (var i = 1; i < content.hits.length; ++i) {
	            suggestions.push(content.hits[i]);
	          }
	
	          cb(suggestions, content);
	        });
	
	        return;
	      }
	
	      cb([]);
	    });
	  }
	};


/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// this will inject Zepto in window, unfortunately no easy commonJS zepto build
	var zepto = __webpack_require__(1559);
	
	// setup DOM element
	var DOM = __webpack_require__(477);
	DOM.element = zepto;
	
	// setup utils functions
	var _ = __webpack_require__(347);
	_.isArray = zepto.isArray;
	_.isFunction = zepto.isFunction;
	_.isObject = zepto.isPlainObject;
	_.bind = zepto.proxy;
	_.each = function(collection, cb) {
	  // stupid argument order for jQuery.each
	  zepto.each(collection, reverseArgs);
	  function reverseArgs(index, value) {
	    return cb(value, index);
	  }
	};
	_.map = zepto.map;
	_.mixin = zepto.extend;
	_.Event = zepto.Event;
	
	var typeaheadKey = 'aaAutocomplete';
	var Typeahead = __webpack_require__(1554);
	var EventBus = __webpack_require__(1285);
	
	function autocomplete(selector, options, datasets, typeaheadObject) {
	  datasets = _.isArray(datasets) ? datasets : [].slice.call(arguments, 2);
	
	  var inputs = zepto(selector).each(function(i, input) {
	    var $input = zepto(input);
	    var eventBus = new EventBus({el: $input});
	    var typeahead = typeaheadObject || new Typeahead({
	      input: $input,
	      eventBus: eventBus,
	      dropdownMenuContainer: options.dropdownMenuContainer,
	      hint: options.hint === undefined ? true : !!options.hint,
	      minLength: options.minLength,
	      autoselect: options.autoselect,
	      autoselectOnBlur: options.autoselectOnBlur,
	      tabAutocomplete: options.tabAutocomplete,
	      openOnFocus: options.openOnFocus,
	      templates: options.templates,
	      debug: options.debug,
	      clearOnSelected: options.clearOnSelected,
	      cssClasses: options.cssClasses,
	      datasets: datasets,
	      keyboardShortcuts: options.keyboardShortcuts,
	      appendTo: options.appendTo,
	      autoWidth: options.autoWidth,
	      ariaLabel: options.ariaLabel || input.getAttribute('aria-label')
	    });
	    $input.data(typeaheadKey, typeahead);
	  });
	
	  // expose all methods in the `autocomplete` attribute
	  inputs.autocomplete = {};
	  _.each(['open', 'close', 'getVal', 'setVal', 'destroy', 'getWrapper'], function(method) {
	    inputs.autocomplete[method] = function() {
	      var methodArguments = arguments;
	      var result;
	      inputs.each(function(j, input) {
	        var typeahead = zepto(input).data(typeaheadKey);
	        result = typeahead[method].apply(typeahead, methodArguments);
	      });
	      return result;
	    };
	  });
	
	  return inputs;
	}
	
	autocomplete.sources = Typeahead.sources;
	autocomplete.escapeHighlightedString = _.escapeHighlightedString;
	
	var wasAutocompleteSet = 'autocomplete' in window;
	var oldAutocomplete = window.autocomplete;
	autocomplete.noConflict = function noConflict() {
	  if (wasAutocompleteSet) {
	    window.autocomplete = oldAutocomplete;
	  } else {
	    delete window.autocomplete;
	  }
	  return autocomplete;
	};
	
	module.exports = autocomplete;


/***/ },
/* 1559 */
/***/ function(module, exports) {

	/* istanbul ignore next */
	/* Zepto v1.2.0 - zepto event assets data - zeptojs.com/license */
	(function(global, factory) {
	  module.exports = factory(global);
	}(/* this ##### UPDATED: here we want to use window/global instead of this which is the current file context ##### */ window, function(window) {
	  var Zepto = (function() {
	  var undefined, key, $, classList, emptyArray = [], concat = emptyArray.concat, filter = emptyArray.filter, slice = emptyArray.slice,
	    document = window.document,
	    elementDisplay = {}, classCache = {},
	    cssNumber = { 'column-count': 1, 'columns': 1, 'font-weight': 1, 'line-height': 1,'opacity': 1, 'z-index': 1, 'zoom': 1 },
	    fragmentRE = /^\s*<(\w+|!)[^>]*>/,
	    singleTagRE = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
	    tagExpanderRE = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig,
	    rootNodeRE = /^(?:body|html)$/i,
	    capitalRE = /([A-Z])/g,
	
	    // special attributes that should be get/set via method calls
	    methodAttributes = ['val', 'css', 'html', 'text', 'data', 'width', 'height', 'offset'],
	
	    adjacencyOperators = [ 'after', 'prepend', 'before', 'append' ],
	    table = document.createElement('table'),
	    tableRow = document.createElement('tr'),
	    containers = {
	      'tr': document.createElement('tbody'),
	      'tbody': table, 'thead': table, 'tfoot': table,
	      'td': tableRow, 'th': tableRow,
	      '*': document.createElement('div')
	    },
	    readyRE = /complete|loaded|interactive/,
	    simpleSelectorRE = /^[\w-]*$/,
	    class2type = {},
	    toString = class2type.toString,
	    zepto = {},
	    camelize, uniq,
	    tempParent = document.createElement('div'),
	    propMap = {
	      'tabindex': 'tabIndex',
	      'readonly': 'readOnly',
	      'for': 'htmlFor',
	      'class': 'className',
	      'maxlength': 'maxLength',
	      'cellspacing': 'cellSpacing',
	      'cellpadding': 'cellPadding',
	      'rowspan': 'rowSpan',
	      'colspan': 'colSpan',
	      'usemap': 'useMap',
	      'frameborder': 'frameBorder',
	      'contenteditable': 'contentEditable'
	    },
	    isArray = Array.isArray ||
	      function(object){ return object instanceof Array }
	
	  zepto.matches = function(element, selector) {
	    if (!selector || !element || element.nodeType !== 1) return false
	    var matchesSelector = element.matches || element.webkitMatchesSelector ||
	                          element.mozMatchesSelector || element.oMatchesSelector ||
	                          element.matchesSelector
	    if (matchesSelector) return matchesSelector.call(element, selector)
	    // fall back to performing a selector:
	    var match, parent = element.parentNode, temp = !parent
	    if (temp) (parent = tempParent).appendChild(element)
	    match = ~zepto.qsa(parent, selector).indexOf(element)
	    temp && tempParent.removeChild(element)
	    return match
	  }
	
	  function type(obj) {
	    return obj == null ? String(obj) :
	      class2type[toString.call(obj)] || "object"
	  }
	
	  function isFunction(value) { return type(value) == "function" }
	  function isWindow(obj)     { return obj != null && obj == obj.window }
	  function isDocument(obj)   { return obj != null && obj.nodeType == obj.DOCUMENT_NODE }
	  function isObject(obj)     { return type(obj) == "object" }
	  function isPlainObject(obj) {
	    return isObject(obj) && !isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype
	  }
	
	  function likeArray(obj) {
	    var length = !!obj && 'length' in obj && obj.length,
	      type = $.type(obj)
	
	    return 'function' != type && !isWindow(obj) && (
	      'array' == type || length === 0 ||
	        (typeof length == 'number' && length > 0 && (length - 1) in obj)
	    )
	  }
	
	  function compact(array) { return filter.call(array, function(item){ return item != null }) }
	  function flatten(array) { return array.length > 0 ? $.fn.concat.apply([], array) : array }
	  camelize = function(str){ return str.replace(/-+(.)?/g, function(match, chr){ return chr ? chr.toUpperCase() : '' }) }
	  function dasherize(str) {
	    return str.replace(/::/g, '/')
	           .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
	           .replace(/([a-z\d])([A-Z])/g, '$1_$2')
	           .replace(/_/g, '-')
	           .toLowerCase()
	  }
	  uniq = function(array){ return filter.call(array, function(item, idx){ return array.indexOf(item) == idx }) }
	
	  function classRE(name) {
	    return name in classCache ?
	      classCache[name] : (classCache[name] = new RegExp('(^|\\s)' + name + '(\\s|$)'))
	  }
	
	  function maybeAddPx(name, value) {
	    return (typeof value == "number" && !cssNumber[dasherize(name)]) ? value + "px" : value
	  }
	
	  function defaultDisplay(nodeName) {
	    var element, display
	    if (!elementDisplay[nodeName]) {
	      element = document.createElement(nodeName)
	      document.body.appendChild(element)
	      display = getComputedStyle(element, '').getPropertyValue("display")
	      element.parentNode.removeChild(element)
	      display == "none" && (display = "block")
	      elementDisplay[nodeName] = display
	    }
	    return elementDisplay[nodeName]
	  }
	
	  function children(element) {
	    return 'children' in element ?
	      slice.call(element.children) :
	      $.map(element.childNodes, function(node){ if (node.nodeType == 1) return node })
	  }
	
	  function Z(dom, selector) {
	    var i, len = dom ? dom.length : 0
	    for (i = 0; i < len; i++) this[i] = dom[i]
	    this.length = len
	    this.selector = selector || ''
	  }
	
	  // `$.zepto.fragment` takes a html string and an optional tag name
	  // to generate DOM nodes from the given html string.
	  // The generated DOM nodes are returned as an array.
	  // This function can be overridden in plugins for example to make
	  // it compatible with browsers that don't support the DOM fully.
	  zepto.fragment = function(html, name, properties) {
	    var dom, nodes, container
	
	    // A special case optimization for a single tag
	    if (singleTagRE.test(html)) dom = $(document.createElement(RegExp.$1))
	
	    if (!dom) {
	      if (html.replace) html = html.replace(tagExpanderRE, "<$1></$2>")
	      if (name === undefined) name = fragmentRE.test(html) && RegExp.$1
	      if (!(name in containers)) name = '*'
	
	      container = containers[name]
	      container.innerHTML = '' + html
	      dom = $.each(slice.call(container.childNodes), function(){
	        container.removeChild(this)
	      })
	    }
	
	    if (isPlainObject(properties)) {
	      nodes = $(dom)
	      $.each(properties, function(key, value) {
	        if (methodAttributes.indexOf(key) > -1) nodes[key](value)
	        else nodes.attr(key, value)
	      })
	    }
	
	    return dom
	  }
	
	  // `$.zepto.Z` swaps out the prototype of the given `dom` array
	  // of nodes with `$.fn` and thus supplying all the Zepto functions
	  // to the array. This method can be overridden in plugins.
	  zepto.Z = function(dom, selector) {
	    return new Z(dom, selector)
	  }
	
	  // `$.zepto.isZ` should return `true` if the given object is a Zepto
	  // collection. This method can be overridden in plugins.
	  zepto.isZ = function(object) {
	    return object instanceof zepto.Z
	  }
	
	  // `$.zepto.init` is Zepto's counterpart to jQuery's `$.fn.init` and
	  // takes a CSS selector and an optional context (and handles various
	  // special cases).
	  // This method can be overridden in plugins.
	  zepto.init = function(selector, context) {
	    var dom
	    // If nothing given, return an empty Zepto collection
	    if (!selector) return zepto.Z()
	    // Optimize for string selectors
	    else if (typeof selector == 'string') {
	      selector = selector.trim()
	      // If it's a html fragment, create nodes from it
	      // Note: In both Chrome 21 and Firefox 15, DOM error 12
	      // is thrown if the fragment doesn't begin with <
	      if (selector[0] == '<' && fragmentRE.test(selector))
	        dom = zepto.fragment(selector, RegExp.$1, context), selector = null
	      // If there's a context, create a collection on that context first, and select
	      // nodes from there
	      else if (context !== undefined) return $(context).find(selector)
	      // If it's a CSS selector, use it to select nodes.
	      else dom = zepto.qsa(document, selector)
	    }
	    // If a function is given, call it when the DOM is ready
	    else if (isFunction(selector)) return $(document).ready(selector)
	    // If a Zepto collection is given, just return it
	    else if (zepto.isZ(selector)) return selector
	    else {
	      // normalize array if an array of nodes is given
	      if (isArray(selector)) dom = compact(selector)
	      // Wrap DOM nodes.
	      else if (isObject(selector))
	        dom = [selector], selector = null
	      // If it's a html fragment, create nodes from it
	      else if (fragmentRE.test(selector))
	        dom = zepto.fragment(selector.trim(), RegExp.$1, context), selector = null
	      // If there's a context, create a collection on that context first, and select
	      // nodes from there
	      else if (context !== undefined) return $(context).find(selector)
	      // And last but no least, if it's a CSS selector, use it to select nodes.
	      else dom = zepto.qsa(document, selector)
	    }
	    // create a new Zepto collection from the nodes found
	    return zepto.Z(dom, selector)
	  }
	
	  // `$` will be the base `Zepto` object. When calling this
	  // function just call `$.zepto.init, which makes the implementation
	  // details of selecting nodes and creating Zepto collections
	  // patchable in plugins.
	  $ = function(selector, context){
	    return zepto.init(selector, context)
	  }
	
	  function extend(target, source, deep) {
	    for (key in source)
	      if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	        if (isPlainObject(source[key]) && !isPlainObject(target[key]))
	          target[key] = {}
	        if (isArray(source[key]) && !isArray(target[key]))
	          target[key] = []
	        extend(target[key], source[key], deep)
	      }
	      else if (source[key] !== undefined) target[key] = source[key]
	  }
	
	  // Copy all but undefined properties from one or more
	  // objects to the `target` object.
	  $.extend = function(target){
	    var deep, args = slice.call(arguments, 1)
	    if (typeof target == 'boolean') {
	      deep = target
	      target = args.shift()
	    }
	    args.forEach(function(arg){ extend(target, arg, deep) })
	    return target
	  }
	
	  // `$.zepto.qsa` is Zepto's CSS selector implementation which
	  // uses `document.querySelectorAll` and optimizes for some special cases, like `#id`.
	  // This method can be overridden in plugins.
	  zepto.qsa = function(element, selector){
	    var found,
	        maybeID = selector[0] == '#',
	        maybeClass = !maybeID && selector[0] == '.',
	        nameOnly = maybeID || maybeClass ? selector.slice(1) : selector, // Ensure that a 1 char tag name still gets checked
	        isSimple = simpleSelectorRE.test(nameOnly)
	    return (element.getElementById && isSimple && maybeID) ? // Safari DocumentFragment doesn't have getElementById
	      ( (found = element.getElementById(nameOnly)) ? [found] : [] ) :
	      (element.nodeType !== 1 && element.nodeType !== 9 && element.nodeType !== 11) ? [] :
	      slice.call(
	        isSimple && !maybeID && element.getElementsByClassName ? // DocumentFragment doesn't have getElementsByClassName/TagName
	          maybeClass ? element.getElementsByClassName(nameOnly) : // If it's simple, it could be a class
	          element.getElementsByTagName(selector) : // Or a tag
	          element.querySelectorAll(selector) // Or it's not simple, and we need to query all
	      )
	  }
	
	  function filtered(nodes, selector) {
	    return selector == null ? $(nodes) : $(nodes).filter(selector)
	  }
	
	  $.contains = document.documentElement.contains ?
	    function(parent, node) {
	      return parent !== node && parent.contains(node)
	    } :
	    function(parent, node) {
	      while (node && (node = node.parentNode))
	        if (node === parent) return true
	      return false
	    }
	
	  function funcArg(context, arg, idx, payload) {
	    return isFunction(arg) ? arg.call(context, idx, payload) : arg
	  }
	
	  function setAttribute(node, name, value) {
	    value == null ? node.removeAttribute(name) : node.setAttribute(name, value)
	  }
	
	  // access className property while respecting SVGAnimatedString
	  function className(node, value){
	    var klass = node.className || '',
	        svg   = klass && klass.baseVal !== undefined
	
	    if (value === undefined) return svg ? klass.baseVal : klass
	    svg ? (klass.baseVal = value) : (node.className = value)
	  }
	
	  // "true"  => true
	  // "false" => false
	  // "null"  => null
	  // "42"    => 42
	  // "42.5"  => 42.5
	  // "08"    => "08"
	  // JSON    => parse if valid
	  // String  => self
	  function deserializeValue(value) {
	    try {
	      return value ?
	        value == "true" ||
	        ( value == "false" ? false :
	          value == "null" ? null :
	          +value + "" == value ? +value :
	          /^[\[\{]/.test(value) ? $.parseJSON(value) :
	          value )
	        : value
	    } catch(e) {
	      return value
	    }
	  }
	
	  $.type = type
	  $.isFunction = isFunction
	  $.isWindow = isWindow
	  $.isArray = isArray
	  $.isPlainObject = isPlainObject
	
	  $.isEmptyObject = function(obj) {
	    var name
	    for (name in obj) return false
	    return true
	  }
	
	  $.isNumeric = function(val) {
	    var num = Number(val), type = typeof val
	    return val != null && type != 'boolean' &&
	      (type != 'string' || val.length) &&
	      !isNaN(num) && isFinite(num) || false
	  }
	
	  $.inArray = function(elem, array, i){
	    return emptyArray.indexOf.call(array, elem, i)
	  }
	
	  $.camelCase = camelize
	  $.trim = function(str) {
	    return str == null ? "" : String.prototype.trim.call(str)
	  }
	
	  // plugin compatibility
	  $.uuid = 0
	  $.support = { }
	  $.expr = { }
	  $.noop = function() {}
	
	  $.map = function(elements, callback){
	    var value, values = [], i, key
	    if (likeArray(elements))
	      for (i = 0; i < elements.length; i++) {
	        value = callback(elements[i], i)
	        if (value != null) values.push(value)
	      }
	    else
	      for (key in elements) {
	        value = callback(elements[key], key)
	        if (value != null) values.push(value)
	      }
	    return flatten(values)
	  }
	
	  $.each = function(elements, callback){
	    var i, key
	    if (likeArray(elements)) {
	      for (i = 0; i < elements.length; i++)
	        if (callback.call(elements[i], i, elements[i]) === false) return elements
	    } else {
	      for (key in elements)
	        if (callback.call(elements[key], key, elements[key]) === false) return elements
	    }
	
	    return elements
	  }
	
	  $.grep = function(elements, callback){
	    return filter.call(elements, callback)
	  }
	
	  if (window.JSON) $.parseJSON = JSON.parse
	
	  // Populate the class2type map
	  $.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
	    class2type[ "[object " + name + "]" ] = name.toLowerCase()
	  })
	
	  // Define methods that will be available on all
	  // Zepto collections
	  $.fn = {
	    constructor: zepto.Z,
	    length: 0,
	
	    // Because a collection acts like an array
	    // copy over these useful array functions.
	    forEach: emptyArray.forEach,
	    reduce: emptyArray.reduce,
	    push: emptyArray.push,
	    sort: emptyArray.sort,
	    splice: emptyArray.splice,
	    indexOf: emptyArray.indexOf,
	    concat: function(){
	      var i, value, args = []
	      for (i = 0; i < arguments.length; i++) {
	        value = arguments[i]
	        args[i] = zepto.isZ(value) ? value.toArray() : value
	      }
	      return concat.apply(zepto.isZ(this) ? this.toArray() : this, args)
	    },
	
	    // `map` and `slice` in the jQuery API work differently
	    // from their array counterparts
	    map: function(fn){
	      return $($.map(this, function(el, i){ return fn.call(el, i, el) }))
	    },
	    slice: function(){
	      return $(slice.apply(this, arguments))
	    },
	
	    ready: function(callback){
	      // need to check if document.body exists for IE as that browser reports
	      // document ready when it hasn't yet created the body element
	      if (readyRE.test(document.readyState) && document.body) callback($)
	      else document.addEventListener('DOMContentLoaded', function(){ callback($) }, false)
	      return this
	    },
	    get: function(idx){
	      return idx === undefined ? slice.call(this) : this[idx >= 0 ? idx : idx + this.length]
	    },
	    toArray: function(){ return this.get() },
	    size: function(){
	      return this.length
	    },
	    remove: function(){
	      return this.each(function(){
	        if (this.parentNode != null)
	          this.parentNode.removeChild(this)
	      })
	    },
	    each: function(callback){
	      emptyArray.every.call(this, function(el, idx){
	        return callback.call(el, idx, el) !== false
	      })
	      return this
	    },
	    filter: function(selector){
	      if (isFunction(selector)) return this.not(this.not(selector))
	      return $(filter.call(this, function(element){
	        return zepto.matches(element, selector)
	      }))
	    },
	    add: function(selector,context){
	      return $(uniq(this.concat($(selector,context))))
	    },
	    is: function(selector){
	      return this.length > 0 && zepto.matches(this[0], selector)
	    },
	    not: function(selector){
	      var nodes=[]
	      if (isFunction(selector) && selector.call !== undefined)
	        this.each(function(idx){
	          if (!selector.call(this,idx)) nodes.push(this)
	        })
	      else {
	        var excludes = typeof selector == 'string' ? this.filter(selector) :
	          (likeArray(selector) && isFunction(selector.item)) ? slice.call(selector) : $(selector)
	        this.forEach(function(el){
	          if (excludes.indexOf(el) < 0) nodes.push(el)
	        })
	      }
	      return $(nodes)
	    },
	    has: function(selector){
	      return this.filter(function(){
	        return isObject(selector) ?
	          $.contains(this, selector) :
	          $(this).find(selector).size()
	      })
	    },
	    eq: function(idx){
	      return idx === -1 ? this.slice(idx) : this.slice(idx, + idx + 1)
	    },
	    first: function(){
	      var el = this[0]
	      return el && !isObject(el) ? el : $(el)
	    },
	    last: function(){
	      var el = this[this.length - 1]
	      return el && !isObject(el) ? el : $(el)
	    },
	    find: function(selector){
	      var result, $this = this
	      if (!selector) result = $()
	      else if (typeof selector == 'object')
	        result = $(selector).filter(function(){
	          var node = this
	          return emptyArray.some.call($this, function(parent){
	            return $.contains(parent, node)
	          })
	        })
	      else if (this.length == 1) result = $(zepto.qsa(this[0], selector))
	      else result = this.map(function(){ return zepto.qsa(this, selector) })
	      return result
	    },
	    closest: function(selector, context){
	      var nodes = [], collection = typeof selector == 'object' && $(selector)
	      this.each(function(_, node){
	        while (node && !(collection ? collection.indexOf(node) >= 0 : zepto.matches(node, selector)))
	          node = node !== context && !isDocument(node) && node.parentNode
	        if (node && nodes.indexOf(node) < 0) nodes.push(node)
	      })
	      return $(nodes)
	    },
	    parents: function(selector){
	      var ancestors = [], nodes = this
	      while (nodes.length > 0)
	        nodes = $.map(nodes, function(node){
	          if ((node = node.parentNode) && !isDocument(node) && ancestors.indexOf(node) < 0) {
	            ancestors.push(node)
	            return node
	          }
	        })
	      return filtered(ancestors, selector)
	    },
	    parent: function(selector){
	      return filtered(uniq(this.pluck('parentNode')), selector)
	    },
	    children: function(selector){
	      return filtered(this.map(function(){ return children(this) }), selector)
	    },
	    contents: function() {
	      return this.map(function() { return this.contentDocument || slice.call(this.childNodes) })
	    },
	    siblings: function(selector){
	      return filtered(this.map(function(i, el){
	        return filter.call(children(el.parentNode), function(child){ return child!==el })
	      }), selector)
	    },
	    empty: function(){
	      return this.each(function(){ this.innerHTML = '' })
	    },
	    // `pluck` is borrowed from Prototype.js
	    pluck: function(property){
	      return $.map(this, function(el){ return el[property] })
	    },
	    show: function(){
	      return this.each(function(){
	        this.style.display == "none" && (this.style.display = '')
	        if (getComputedStyle(this, '').getPropertyValue("display") == "none")
	          this.style.display = defaultDisplay(this.nodeName)
	      })
	    },
	    replaceWith: function(newContent){
	      return this.before(newContent).remove()
	    },
	    wrap: function(structure){
	      var func = isFunction(structure)
	      if (this[0] && !func)
	        var dom   = $(structure).get(0),
	            clone = dom.parentNode || this.length > 1
	
	      return this.each(function(index){
	        $(this).wrapAll(
	          func ? structure.call(this, index) :
	            clone ? dom.cloneNode(true) : dom
	        )
	      })
	    },
	    wrapAll: function(structure){
	      if (this[0]) {
	        $(this[0]).before(structure = $(structure))
	        var children
	        // drill down to the inmost element
	        while ((children = structure.children()).length) structure = children.first()
	        $(structure).append(this)
	      }
	      return this
	    },
	    wrapInner: function(structure){
	      var func = isFunction(structure)
	      return this.each(function(index){
	        var self = $(this), contents = self.contents(),
	            dom  = func ? structure.call(this, index) : structure
	        contents.length ? contents.wrapAll(dom) : self.append(dom)
	      })
	    },
	    unwrap: function(){
	      this.parent().each(function(){
	        $(this).replaceWith($(this).children())
	      })
	      return this
	    },
	    clone: function(){
	      return this.map(function(){ return this.cloneNode(true) })
	    },
	    hide: function(){
	      return this.css("display", "none")
	    },
	    toggle: function(setting){
	      return this.each(function(){
	        var el = $(this)
	        ;(setting === undefined ? el.css("display") == "none" : setting) ? el.show() : el.hide()
	      })
	    },
	    prev: function(selector){ return $(this.pluck('previousElementSibling')).filter(selector || '*') },
	    next: function(selector){ return $(this.pluck('nextElementSibling')).filter(selector || '*') },
	    html: function(html){
	      return 0 in arguments ?
	        this.each(function(idx){
	          var originHtml = this.innerHTML
	          $(this).empty().append( funcArg(this, html, idx, originHtml) )
	        }) :
	        (0 in this ? this[0].innerHTML : null)
	    },
	    text: function(text){
	      return 0 in arguments ?
	        this.each(function(idx){
	          var newText = funcArg(this, text, idx, this.textContent)
	          this.textContent = newText == null ? '' : ''+newText
	        }) :
	        (0 in this ? this.pluck('textContent').join("") : null)
	    },
	    attr: function(name, value){
	      var result
	      return (typeof name == 'string' && !(1 in arguments)) ?
	        (0 in this && this[0].nodeType == 1 && (result = this[0].getAttribute(name)) != null ? result : undefined) :
	        this.each(function(idx){
	          if (this.nodeType !== 1) return
	          if (isObject(name)) for (key in name) setAttribute(this, key, name[key])
	          else setAttribute(this, name, funcArg(this, value, idx, this.getAttribute(name)))
	        })
	    },
	    removeAttr: function(name){
	      return this.each(function(){ this.nodeType === 1 && name.split(' ').forEach(function(attribute){
	        setAttribute(this, attribute)
	      }, this)})
	    },
	    prop: function(name, value){
	      name = propMap[name] || name
	      return (1 in arguments) ?
	        this.each(function(idx){
	          this[name] = funcArg(this, value, idx, this[name])
	        }) :
	        (this[0] && this[0][name])
	    },
	    removeProp: function(name){
	      name = propMap[name] || name
	      return this.each(function(){ delete this[name] })
	    },
	    data: function(name, value){
	      var attrName = 'data-' + name.replace(capitalRE, '-$1').toLowerCase()
	
	      var data = (1 in arguments) ?
	        this.attr(attrName, value) :
	        this.attr(attrName)
	
	      return data !== null ? deserializeValue(data) : undefined
	    },
	    val: function(value){
	      if (0 in arguments) {
	        if (value == null) value = ""
	        return this.each(function(idx){
	          this.value = funcArg(this, value, idx, this.value)
	        })
	      } else {
	        return this[0] && (this[0].multiple ?
	           $(this[0]).find('option').filter(function(){ return this.selected }).pluck('value') :
	           this[0].value)
	      }
	    },
	    offset: function(coordinates){
	      if (coordinates) return this.each(function(index){
	        var $this = $(this),
	            coords = funcArg(this, coordinates, index, $this.offset()),
	            parentOffset = $this.offsetParent().offset(),
	            props = {
	              top:  coords.top  - parentOffset.top,
	              left: coords.left - parentOffset.left
	            }
	
	        if ($this.css('position') == 'static') props['position'] = 'relative'
	        $this.css(props)
	      })
	      if (!this.length) return null
	      if (document.documentElement !== this[0] && !$.contains(document.documentElement, this[0]))
	        return {top: 0, left: 0}
	      var obj = this[0].getBoundingClientRect()
	      return {
	        left: obj.left + window.pageXOffset,
	        top: obj.top + window.pageYOffset,
	        width: Math.round(obj.width),
	        height: Math.round(obj.height)
	      }
	    },
	    css: function(property, value){
	      if (arguments.length < 2) {
	        var element = this[0]
	        if (typeof property == 'string') {
	          if (!element) return
	          return element.style[camelize(property)] || getComputedStyle(element, '').getPropertyValue(property)
	        } else if (isArray(property)) {
	          if (!element) return
	          var props = {}
	          var computedStyle = getComputedStyle(element, '')
	          $.each(property, function(_, prop){
	            props[prop] = (element.style[camelize(prop)] || computedStyle.getPropertyValue(prop))
	          })
	          return props
	        }
	      }
	
	      var css = ''
	      if (type(property) == 'string') {
	        if (!value && value !== 0)
	          this.each(function(){ this.style.removeProperty(dasherize(property)) })
	        else
	          css = dasherize(property) + ":" + maybeAddPx(property, value)
	      } else {
	        for (key in property)
	          if (!property[key] && property[key] !== 0)
	            this.each(function(){ this.style.removeProperty(dasherize(key)) })
	          else
	            css += dasherize(key) + ':' + maybeAddPx(key, property[key]) + ';'
	      }
	
	      return this.each(function(){ this.style.cssText += ';' + css })
	    },
	    index: function(element){
	      return element ? this.indexOf($(element)[0]) : this.parent().children().indexOf(this[0])
	    },
	    hasClass: function(name){
	      if (!name) return false
	      return emptyArray.some.call(this, function(el){
	        return this.test(className(el))
	      }, classRE(name))
	    },
	    addClass: function(name){
	      if (!name) return this
	      return this.each(function(idx){
	        if (!('className' in this)) return
	        classList = []
	        var cls = className(this), newName = funcArg(this, name, idx, cls)
	        newName.split(/\s+/g).forEach(function(klass){
	          if (!$(this).hasClass(klass)) classList.push(klass)
	        }, this)
	        classList.length && className(this, cls + (cls ? " " : "") + classList.join(" "))
	      })
	    },
	    removeClass: function(name){
	      return this.each(function(idx){
	        if (!('className' in this)) return
	        if (name === undefined) return className(this, '')
	        classList = className(this)
	        funcArg(this, name, idx, classList).split(/\s+/g).forEach(function(klass){
	          classList = classList.replace(classRE(klass), " ")
	        })
	        className(this, classList.trim())
	      })
	    },
	    toggleClass: function(name, when){
	      if (!name) return this
	      return this.each(function(idx){
	        var $this = $(this), names = funcArg(this, name, idx, className(this))
	        names.split(/\s+/g).forEach(function(klass){
	          (when === undefined ? !$this.hasClass(klass) : when) ?
	            $this.addClass(klass) : $this.removeClass(klass)
	        })
	      })
	    },
	    scrollTop: function(value){
	      if (!this.length) return
	      var hasScrollTop = 'scrollTop' in this[0]
	      if (value === undefined) return hasScrollTop ? this[0].scrollTop : this[0].pageYOffset
	      return this.each(hasScrollTop ?
	        function(){ this.scrollTop = value } :
	        function(){ this.scrollTo(this.scrollX, value) })
	    },
	    scrollLeft: function(value){
	      if (!this.length) return
	      var hasScrollLeft = 'scrollLeft' in this[0]
	      if (value === undefined) return hasScrollLeft ? this[0].scrollLeft : this[0].pageXOffset
	      return this.each(hasScrollLeft ?
	        function(){ this.scrollLeft = value } :
	        function(){ this.scrollTo(value, this.scrollY) })
	    },
	    position: function() {
	      if (!this.length) return
	
	      var elem = this[0],
	        // Get *real* offsetParent
	        offsetParent = this.offsetParent(),
	        // Get correct offsets
	        offset       = this.offset(),
	        parentOffset = rootNodeRE.test(offsetParent[0].nodeName) ? { top: 0, left: 0 } : offsetParent.offset()
	
	      // Subtract element margins
	      // note: when an element has margin: auto the offsetLeft and marginLeft
	      // are the same in Safari causing offset.left to incorrectly be 0
	      offset.top  -= parseFloat( $(elem).css('margin-top') ) || 0
	      offset.left -= parseFloat( $(elem).css('margin-left') ) || 0
	
	      // Add offsetParent borders
	      parentOffset.top  += parseFloat( $(offsetParent[0]).css('border-top-width') ) || 0
	      parentOffset.left += parseFloat( $(offsetParent[0]).css('border-left-width') ) || 0
	
	      // Subtract the two offsets
	      return {
	        top:  offset.top  - parentOffset.top,
	        left: offset.left - parentOffset.left
	      }
	    },
	    offsetParent: function() {
	      return this.map(function(){
	        var parent = this.offsetParent || document.body
	        while (parent && !rootNodeRE.test(parent.nodeName) && $(parent).css("position") == "static")
	          parent = parent.offsetParent
	        return parent
	      })
	    }
	  }
	
	  // for now
	  $.fn.detach = $.fn.remove
	
	  // Generate the `width` and `height` functions
	  ;['width', 'height'].forEach(function(dimension){
	    var dimensionProperty =
	      dimension.replace(/./, function(m){ return m[0].toUpperCase() })
	
	    $.fn[dimension] = function(value){
	      var offset, el = this[0]
	      if (value === undefined) return isWindow(el) ? el['inner' + dimensionProperty] :
	        isDocument(el) ? el.documentElement['scroll' + dimensionProperty] :
	        (offset = this.offset()) && offset[dimension]
	      else return this.each(function(idx){
	        el = $(this)
	        el.css(dimension, funcArg(this, value, idx, el[dimension]()))
	      })
	    }
	  })
	
	  function traverseNode(node, fun) {
	    fun(node)
	    for (var i = 0, len = node.childNodes.length; i < len; i++)
	      traverseNode(node.childNodes[i], fun)
	  }
	
	  // Generate the `after`, `prepend`, `before`, `append`,
	  // `insertAfter`, `insertBefore`, `appendTo`, and `prependTo` methods.
	  adjacencyOperators.forEach(function(operator, operatorIndex) {
	    var inside = operatorIndex % 2 //=> prepend, append
	
	    $.fn[operator] = function(){
	      // arguments can be nodes, arrays of nodes, Zepto objects and HTML strings
	      var argType, nodes = $.map(arguments, function(arg) {
	            var arr = []
	            argType = type(arg)
	            if (argType == "array") {
	              arg.forEach(function(el) {
	                if (el.nodeType !== undefined) return arr.push(el)
	                else if ($.zepto.isZ(el)) return arr = arr.concat(el.get())
	                arr = arr.concat(zepto.fragment(el))
	              })
	              return arr
	            }
	            return argType == "object" || arg == null ?
	              arg : zepto.fragment(arg)
	          }),
	          parent, copyByClone = this.length > 1
	      if (nodes.length < 1) return this
	
	      return this.each(function(_, target){
	        parent = inside ? target : target.parentNode
	
	        // convert all methods to a "before" operation
	        target = operatorIndex == 0 ? target.nextSibling :
	                 operatorIndex == 1 ? target.firstChild :
	                 operatorIndex == 2 ? target :
	                 null
	
	        var parentInDocument = $.contains(document.documentElement, parent)
	
	        nodes.forEach(function(node){
	          if (copyByClone) node = node.cloneNode(true)
	          else if (!parent) return $(node).remove()
	
	          parent.insertBefore(node, target)
	          if (parentInDocument) traverseNode(node, function(el){
	            if (el.nodeName != null && el.nodeName.toUpperCase() === 'SCRIPT' &&
	               (!el.type || el.type === 'text/javascript') && !el.src){
	              var target = el.ownerDocument ? el.ownerDocument.defaultView : window
	              target['eval'].call(target, el.innerHTML)
	            }
	          })
	        })
	      })
	    }
	
	    // after    => insertAfter
	    // prepend  => prependTo
	    // before   => insertBefore
	    // append   => appendTo
	    $.fn[inside ? operator+'To' : 'insert'+(operatorIndex ? 'Before' : 'After')] = function(html){
	      $(html)[operator](this)
	      return this
	    }
	  })
	
	  zepto.Z.prototype = Z.prototype = $.fn
	
	  // Export internal API functions in the `$.zepto` namespace
	  zepto.uniq = uniq
	  zepto.deserializeValue = deserializeValue
	  $.zepto = zepto
	
	  return $
	})()
	
	;(function($){
	  var _zid = 1, undefined,
	      slice = Array.prototype.slice,
	      isFunction = $.isFunction,
	      isString = function(obj){ return typeof obj == 'string' },
	      handlers = {},
	      specialEvents={},
	      focusinSupported = 'onfocusin' in window,
	      focus = { focus: 'focusin', blur: 'focusout' },
	      hover = { mouseenter: 'mouseover', mouseleave: 'mouseout' }
	
	  specialEvents.click = specialEvents.mousedown = specialEvents.mouseup = specialEvents.mousemove = 'MouseEvents'
	
	  function zid(element) {
	    return element._zid || (element._zid = _zid++)
	  }
	  function findHandlers(element, event, fn, selector) {
	    event = parse(event)
	    if (event.ns) var matcher = matcherFor(event.ns)
	    return (handlers[zid(element)] || []).filter(function(handler) {
	      return handler
	        && (!event.e  || handler.e == event.e)
	        && (!event.ns || matcher.test(handler.ns))
	        && (!fn       || zid(handler.fn) === zid(fn))
	        && (!selector || handler.sel == selector)
	    })
	  }
	  function parse(event) {
	    var parts = ('' + event).split('.')
	    return {e: parts[0], ns: parts.slice(1).sort().join(' ')}
	  }
	  function matcherFor(ns) {
	    return new RegExp('(?:^| )' + ns.replace(' ', ' .* ?') + '(?: |$)')
	  }
	
	  function eventCapture(handler, captureSetting) {
	    return handler.del &&
	      (!focusinSupported && (handler.e in focus)) ||
	      !!captureSetting
	  }
	
	  function realEvent(type) {
	    return hover[type] || (focusinSupported && focus[type]) || type
	  }
	
	  function add(element, events, fn, data, selector, delegator, capture){
	    var id = zid(element), set = (handlers[id] || (handlers[id] = []))
	    events.split(/\s/).forEach(function(event){
	      if (event == 'ready') return $(document).ready(fn)
	      var handler   = parse(event)
	      handler.fn    = fn
	      handler.sel   = selector
	      // emulate mouseenter, mouseleave
	      if (handler.e in hover) fn = function(e){
	        var related = e.relatedTarget
	        if (!related || (related !== this && !$.contains(this, related)))
	          return handler.fn.apply(this, arguments)
	      }
	      handler.del   = delegator
	      var callback  = delegator || fn
	      handler.proxy = function(e){
	        e = compatible(e)
	        if (e.isImmediatePropagationStopped()) return
	        try {
	          var dataPropDescriptor = Object.getOwnPropertyDescriptor(e, 'data')
	          if (!dataPropDescriptor || dataPropDescriptor.writable)
	            e.data = data
	        } catch (e) {} // when using strict mode dataPropDescriptor will be undefined when e is InputEvent (even though data property exists). So we surround with try/catch
	        var result = callback.apply(element, e._args == undefined ? [e] : [e].concat(e._args))
	        if (result === false) e.preventDefault(), e.stopPropagation()
	        return result
	      }
	      handler.i = set.length
	      set.push(handler)
	      if ('addEventListener' in element)
	        element.addEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture))
	    })
	  }
	  function remove(element, events, fn, selector, capture){
	    var id = zid(element)
	    ;(events || '').split(/\s/).forEach(function(event){
	      findHandlers(element, event, fn, selector).forEach(function(handler){
	        delete handlers[id][handler.i]
	      if ('removeEventListener' in element)
	        element.removeEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture))
	      })
	    })
	  }
	
	  $.event = { add: add, remove: remove }
	
	  $.proxy = function(fn, context) {
	    var args = (2 in arguments) && slice.call(arguments, 2)
	    if (isFunction(fn)) {
	      var proxyFn = function(){ return fn.apply(context, args ? args.concat(slice.call(arguments)) : arguments) }
	      proxyFn._zid = zid(fn)
	      return proxyFn
	    } else if (isString(context)) {
	      if (args) {
	        args.unshift(fn[context], fn)
	        return $.proxy.apply(null, args)
	      } else {
	        return $.proxy(fn[context], fn)
	      }
	    } else {
	      throw new TypeError("expected function")
	    }
	  }
	
	  $.fn.bind = function(event, data, callback){
	    return this.on(event, data, callback)
	  }
	  $.fn.unbind = function(event, callback){
	    return this.off(event, callback)
	  }
	  $.fn.one = function(event, selector, data, callback){
	    return this.on(event, selector, data, callback, 1)
	  }
	
	  var returnTrue = function(){return true},
	      returnFalse = function(){return false},
	      ignoreProperties = /^([A-Z]|returnValue$|layer[XY]$|webkitMovement[XY]$)/,
	      eventMethods = {
	        preventDefault: 'isDefaultPrevented',
	        stopImmediatePropagation: 'isImmediatePropagationStopped',
	        stopPropagation: 'isPropagationStopped'
	      }
	
	  function compatible(event, source) {
	    if (source || !event.isDefaultPrevented) {
	      source || (source = event)
	
	      $.each(eventMethods, function(name, predicate) {
	        var sourceMethod = source[name]
	        event[name] = function(){
	          this[predicate] = returnTrue
	          return sourceMethod && sourceMethod.apply(source, arguments)
	        }
	        event[predicate] = returnFalse
	      })
	
	      try {
	        event.timeStamp || (event.timeStamp = Date.now())
	      } catch (ignored) { }
	
	      if (source.defaultPrevented !== undefined ? source.defaultPrevented :
	          'returnValue' in source ? source.returnValue === false :
	          source.getPreventDefault && source.getPreventDefault())
	        event.isDefaultPrevented = returnTrue
	    }
	    return event
	  }
	
	  function createProxy(event) {
	    var key, proxy = { originalEvent: event }
	    for (key in event)
	      if (!ignoreProperties.test(key) && event[key] !== undefined) proxy[key] = event[key]
	
	    return compatible(proxy, event)
	  }
	
	  $.fn.delegate = function(selector, event, callback){
	    return this.on(event, selector, callback)
	  }
	  $.fn.undelegate = function(selector, event, callback){
	    return this.off(event, selector, callback)
	  }
	
	  $.fn.live = function(event, callback){
	    $(document.body).delegate(this.selector, event, callback)
	    return this
	  }
	  $.fn.die = function(event, callback){
	    $(document.body).undelegate(this.selector, event, callback)
	    return this
	  }
	
	  $.fn.on = function(event, selector, data, callback, one){
	    var autoRemove, delegator, $this = this
	    if (event && !isString(event)) {
	      $.each(event, function(type, fn){
	        $this.on(type, selector, data, fn, one)
	      })
	      return $this
	    }
	
	    if (!isString(selector) && !isFunction(callback) && callback !== false)
	      callback = data, data = selector, selector = undefined
	    if (callback === undefined || data === false)
	      callback = data, data = undefined
	
	    if (callback === false) callback = returnFalse
	
	    return $this.each(function(_, element){
	      if (one) autoRemove = function(e){
	        remove(element, e.type, callback)
	        return callback.apply(this, arguments)
	      }
	
	      if (selector) delegator = function(e){
	        var evt, match = $(e.target).closest(selector, element).get(0)
	        if (match && match !== element) {
	          evt = $.extend(createProxy(e), {currentTarget: match, liveFired: element})
	          return (autoRemove || callback).apply(match, [evt].concat(slice.call(arguments, 1)))
	        }
	      }
	
	      add(element, event, callback, data, selector, delegator || autoRemove)
	    })
	  }
	  $.fn.off = function(event, selector, callback){
	    var $this = this
	    if (event && !isString(event)) {
	      $.each(event, function(type, fn){
	        $this.off(type, selector, fn)
	      })
	      return $this
	    }
	
	    if (!isString(selector) && !isFunction(callback) && callback !== false)
	      callback = selector, selector = undefined
	
	    if (callback === false) callback = returnFalse
	
	    return $this.each(function(){
	      remove(this, event, callback, selector)
	    })
	  }
	
	  $.fn.trigger = function(event, args){
	    event = (isString(event) || $.isPlainObject(event)) ? $.Event(event) : compatible(event)
	    event._args = args
	    return this.each(function(){
	      // handle focus(), blur() by calling them directly
	      if (event.type in focus && typeof this[event.type] == "function") this[event.type]()
	      // items in the collection might not be DOM elements
	      else if ('dispatchEvent' in this) this.dispatchEvent(event)
	      else $(this).triggerHandler(event, args)
	    })
	  }
	
	  // triggers event handlers on current element just as if an event occurred,
	  // doesn't trigger an actual event, doesn't bubble
	  $.fn.triggerHandler = function(event, args){
	    var e, result
	    this.each(function(i, element){
	      e = createProxy(isString(event) ? $.Event(event) : event)
	      e._args = args
	      e.target = element
	      $.each(findHandlers(element, event.type || event), function(i, handler){
	        result = handler.proxy(e)
	        if (e.isImmediatePropagationStopped()) return false
	      })
	    })
	    return result
	  }
	
	  // shortcut methods for `.bind(event, fn)` for each event type
	  ;('focusin focusout focus blur load resize scroll unload click dblclick '+
	  'mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave '+
	  'change select keydown keypress keyup error').split(' ').forEach(function(event) {
	    $.fn[event] = function(callback) {
	      return (0 in arguments) ?
	        this.bind(event, callback) :
	        this.trigger(event)
	    }
	  })
	
	  $.Event = function(type, props) {
	    if (!isString(type)) props = type, type = props.type
	    var event = document.createEvent(specialEvents[type] || 'Events'), bubbles = true
	    if (props) for (var name in props) (name == 'bubbles') ? (bubbles = !!props[name]) : (event[name] = props[name])
	    event.initEvent(type, bubbles, true)
	    return compatible(event)
	  }
	
	})(Zepto)
	
	;(function($){
	  var cache = [], timeout
	
	  $.fn.remove = function(){
	    return this.each(function(){
	      if(this.parentNode){
	        if(this.tagName === 'IMG'){
	          cache.push(this)
	          this.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
	          if (timeout) clearTimeout(timeout)
	          timeout = setTimeout(function(){ cache = [] }, 60000)
	        }
	        this.parentNode.removeChild(this)
	      }
	    })
	  }
	})(Zepto)
	
	;(function($){
	  var data = {}, dataAttr = $.fn.data, camelize = $.camelCase,
	    exp = $.expando = 'Zepto' + (+new Date()), emptyArray = []
	
	  // Get value from node:
	  // 1. first try key as given,
	  // 2. then try camelized key,
	  // 3. fall back to reading "data-*" attribute.
	  function getData(node, name) {
	    var id = node[exp], store = id && data[id]
	    if (name === undefined) return store || setData(node)
	    else {
	      if (store) {
	        if (name in store) return store[name]
	        var camelName = camelize(name)
	        if (camelName in store) return store[camelName]
	      }
	      return dataAttr.call($(node), name)
	    }
	  }
	
	  // Store value under camelized key on node
	  function setData(node, name, value) {
	    var id = node[exp] || (node[exp] = ++$.uuid),
	      store = data[id] || (data[id] = attributeData(node))
	    if (name !== undefined) store[camelize(name)] = value
	    return store
	  }
	
	  // Read all "data-*" attributes from a node
	  function attributeData(node) {
	    var store = {}
	    $.each(node.attributes || emptyArray, function(i, attr){
	      if (attr.name.indexOf('data-') == 0)
	        store[camelize(attr.name.replace('data-', ''))] =
	          $.zepto.deserializeValue(attr.value)
	    })
	    return store
	  }
	
	  $.fn.data = function(name, value) {
	    return value === undefined ?
	      // set multiple values via object
	      $.isPlainObject(name) ?
	        this.each(function(i, node){
	          $.each(name, function(key, value){ setData(node, key, value) })
	        }) :
	        // get value from first element
	        (0 in this ? getData(this[0], name) : undefined) :
	      // set value on all elements
	      this.each(function(){ setData(this, name, value) })
	  }
	
	  $.data = function(elem, name, value) {
	    return $(elem).data(name, value)
	  }
	
	  $.hasData = function(elem) {
	    var id = elem[exp], store = id && data[id]
	    return store ? !$.isEmptyObject(store) : false
	  }
	
	  $.fn.removeData = function(names) {
	    if (typeof names == 'string') names = names.split(/\s+/)
	    return this.each(function(){
	      var id = this[exp], store = id && data[id]
	      if (store) $.each(names || store, function(key){
	        delete store[names ? camelize(this) : key]
	      })
	    })
	  }
	
	  // Generate extended `remove` and `empty` functions
	  ;['remove', 'empty'].forEach(function(methodName){
	    var origFn = $.fn[methodName]
	    $.fn[methodName] = function() {
	      var elements = this.find('*')
	      if (methodName === 'remove') elements = elements.add(this)
	      elements.removeData()
	      return origFn.call(this)
	    }
	  })
	})(Zepto)
	  return Zepto
	}))


/***/ },
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(1738);
	
	__webpack_require__(1587);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var iteratorSymbol =
	    typeof Symbol === "function" && Symbol.iterator || "@@iterator";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    // This invoke function is written in a style that assumes some
	    // calling function (or Promise) will handle exceptions.
	    function invoke(method, arg) {
	      var result = generator[method](arg);
	      var value = result.value;
	      return value instanceof AwaitArgument
	        ? Promise.resolve(value.arg).then(invokeNext, invokeThrow)
	        : Promise.resolve(value).then(function(unwrapped) {
	            // When a yielded Promise is resolved, its final value becomes
	            // the .value of the Promise<{value,done}> result for the
	            // current iteration. If the Promise is rejected, however, the
	            // result for this iteration will be rejected with the same
	            // reason. Note that rejections of yielded Promises are not
	            // thrown back into the generator function, as is the case
	            // when an awaited Promise is rejected. This difference in
	            // behavior between yield and await is important, because it
	            // allows the consumer to decide what to do with the yielded
	            // rejection (swallow it and continue, manually .throw it back
	            // into the generator, abandon iteration, whatever). With
	            // await, by contrast, there is no opportunity to examine the
	            // rejection reason outside the generator function, so the
	            // only option is to throw it from the await expression, and
	            // let the generator function handle the exception.
	            result.value = unwrapped;
	            return result;
	          });
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var invokeNext = invoke.bind(generator, "next");
	    var invokeThrow = invoke.bind(generator, "throw");
	    var invokeReturn = invoke.bind(generator, "return");
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return invoke(method, arg);
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : new Promise(function (resolve) {
	          resolve(callInvokeWithMethodAndArg());
	        });
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          context._sent = arg;
	
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(235)))

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1601), __esModule: true };

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(1);
	var Backbone = __webpack_require__(4);
	var proxyCollection = __webpack_require__(917);
	var createFilter = __webpack_require__(1590);
	
	// Beware of `this`
	// All of the following functions are meant to be called in the context
	// of the FilteredCollection object, but are not public functions.
	
	function invalidateCache() {
	  this._filterResultCache = {};
	}
	
	function invalidateCacheForFilter(filterName) {
	  for (var cid in this._filterResultCache) {
	    if (this._filterResultCache.hasOwnProperty(cid)) {
	      delete this._filterResultCache[cid][filterName];
	    }
	  }
	}
	
	function addFilter(filterName, filterObj) {
	  // If we've already had a filter of this name, we need to invalidate
	  // any and all of the cached results
	  if (this._filters[filterName]) {
	    invalidateCacheForFilter.call(this, filterName);
	  }
	
	  this._filters[filterName] = filterObj;
	  this.trigger('filtered:add', filterName);
	}
	
	function removeFilter(filterName) {
	  delete this._filters[filterName];
	  invalidateCacheForFilter.call(this, filterName);
	  this.trigger('filtered:remove', filterName);
	}
	
	function execFilterOnModel(model) {
	  if (!this._filterResultCache[model.cid]) {
	    this._filterResultCache[model.cid] = {};
	  }
	
	  var cache = this._filterResultCache[model.cid];
	
	  for (var filterName in this._filters) {
	    if (this._filters.hasOwnProperty(filterName)) {
	      // if we haven't already calculated this, calculate it and cache
	      if (!cache.hasOwnProperty(filterName)) {
	        cache[filterName] = this._filters[filterName].fn(model);
	      }
	      if (!cache[filterName]) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	function execFilter() {
	  var filtered = [];
	
	  // Filter the collection
	  if (this._superset) {
	    filtered = this._superset.filter(_.bind(execFilterOnModel, this));
	  }
	
	  this._collection.reset(filtered);
	  this.length = this._collection.length;
	}
	
	function onAddChange(model) {
	  // reset the cached results
	  this._filterResultCache[model.cid] = {};
	
	  if (execFilterOnModel.call(this, model)) {
	    if (!this._collection.get(model.cid)) {
	      var index = this.superset().indexOf(model);
	
	      // Find the index at which to insert the model in the
	      // filtered collection by finding the index of the
	      // previous non-filtered model in the filtered collection
	      var filteredIndex = null;
	      for (var i = index - 1; i >= 0; i -= 1) {
	        if (this.contains(this.superset().at(i))) {
	          filteredIndex = this.indexOf(this.superset().at(i)) + 1;
	          break;
	        }
	      }
	      filteredIndex = filteredIndex || 0;
	
	      this._collection.add(model, { at: filteredIndex });
	    }
	  } else {
	    if (this._collection.get(model.cid)) {
	      this._collection.remove(model);
	    }
	  }
	  this.length = this._collection.length;
	}
	
	// This fires on 'change:[attribute]' events. We only want to
	// remove this model if it fails the test, but not add it if
	// it does. If we remove it, it will prevent the 'change'
	// events from being forwarded, and if we add it, it will cause
	// an unneccesary 'change' event to be forwarded without the
	// 'change:[attribute]' that goes along with it.
	function onModelAttributeChange(model) {
	  // reset the cached results
	  this._filterResultCache[model.cid] = {};
	
	  if (!execFilterOnModel.call(this, model)) {
	    if (this._collection.get(model.cid)) {
	      this._collection.remove(model);
	    }
	  }
	}
	
	function onAll(eventName, model, value) {
	  if (eventName.slice(0, 7) === "change:") {
	    onModelAttributeChange.call(this, arguments[1]);
	  }
	}
	
	function onModelRemove(model) {
	  if (this.contains(model)) {
	    this._collection.remove(model);
	  }
	  this.length = this._collection.length;
	}
	
	function Filtered(superset) {
	  // Save a reference to the original collection
	  this._superset = superset;
	
	  // The idea is to keep an internal backbone collection with the filtered
	  // set, and expose limited functionality.
	  this._collection = new Backbone.Collection(superset.toArray());
	  proxyCollection(this._collection, this);
	
	  // Set up the filter data structures
	  this.resetFilters();
	
	  this.listenTo(this._superset, 'reset sort', execFilter);
	  this.listenTo(this._superset, 'add change', onAddChange);
	  this.listenTo(this._superset, 'remove', onModelRemove);
	  this.listenTo(this._superset, 'all', onAll);
	}
	
	var methods = {
	
	  defaultFilterName: '__default',
	
	  filterBy: function(filterName, filter) {
	    // Allow the user to skip the filter name if they're only using one filter
	    if (!filter) {
	      filter = filterName;
	      filterName = this.defaultFilterName;
	    }
	
	    addFilter.call(this, filterName, createFilter(filter));
	
	    execFilter.call(this);
	    return this;
	  },
	
	  removeFilter: function(filterName) {
	    if (!filterName) {
	      filterName = this.defaultFilterName;
	    }
	
	    removeFilter.call(this, filterName);
	
	    execFilter.call(this);
	    return this;
	  },
	
	  resetFilters: function() {
	    this._filters = {};
	    invalidateCache.call(this);
	
	    this.trigger('filtered:reset');
	
	    execFilter.call(this);
	    return this;
	  },
	
	  superset: function() {
	    return this._superset;
	  },
	
	  refilter: function(arg) {
	    if (typeof arg === "object" && arg.cid) {
	      // is backbone model, refilter that one
	      onAddChange.call(this, arg);
	    } else {
	      // refilter everything
	      invalidateCache.call(this);
	      execFilter.call(this);
	    }
	
	    return this;
	  },
	
	  getFilters: function() {
	    return  _.keys(this._filters);
	  },
	
	  hasFilter: function(name) {
	    return _.contains(this.getFilters(), name);
	  },
	
	  destroy: function() {
	    this.stopListening();
	    this._collection.reset([]);
	    this._superset = this._collection;
	    this.length = 0;
	
	    this.trigger('filtered:destroy');
	  }
	
	};
	
	// Build up the prototype
	_.extend(Filtered.prototype, methods, Backbone.Events);
	
	module.exports = Filtered;
	


/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(1);
	
	// Converts a key and value into a function that accepts a model
	// and returns a boolean.
	function convertKeyValueToFunction(key, value) {
	  return function(model) {
	    return model.get(key) === value;
	  };
	}
	
	// Converts a key and an associated filter function into a function
	// that accepts a model and returns a boolean.
	function convertKeyFunctionToFunction(key, fn) {
	  return function(model) {
	    return fn(model.get(key));
	  };
	}
	
	function createFilterObject(filterFunction, keys) {
	  // Make sure the keys value is either an array or null
	  if (!_.isArray(keys)) {
	    keys = null;
	  }
	  return { fn: filterFunction, keys: keys };
	}
	
	// Accepts an object in the form of:
	//
	//   {
	//     key: value,
	//     key: function(val) { ... }
	//   }
	//
	// and turns it into a function that accepts a model an returns a
	// boolean + a list of the keys that the function depends on.
	function createFilterFromObject(filterObj) {
	  var keys = _.keys(filterObj);
	
	  var filterFunctions = _.map(keys, function(key) {
	    var val = filterObj[key];
	    if (_.isFunction(val)) {
	      return convertKeyFunctionToFunction(key, val);
	    }
	    return convertKeyValueToFunction(key, val);
	  });
	
	  // Iterate through each of the generated filter functions. If any
	  // are false, kill the computation and return false. The function
	  // is only true if all of the subfunctions are true.
	  var filterFunction = function(model) {
	    for (var i = 0; i < filterFunctions.length; i++) {
	      if (!filterFunctions[i](model)) {
	        return false;
	      }
	    }
	    return true;
	  };
	
	  return createFilterObject(filterFunction, keys);
	}
	
	// Expects one of the following:
	//
	//   - A filter function that accepts a model + (optional) array of
	//     keys to listen to changes for or null)
	//   - An object describing a filter
	function createFilter(filter, keys) {
	  // This must go first because _.isObject(fn) === true
	  if (_.isFunction(filter)) {
	    return createFilterObject(filter, keys);
	  }
	
	  // If the filter is an object describing a filter, generate the
	  // appropriate function.
	  if (_.isObject(filter)) {
	    return createFilterFromObject(filter);
	  }
	}
	
	module.exports = createFilter;
	


/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	
	var _ = __webpack_require__(1);
	var Backbone = __webpack_require__(4);
	var proxyCollection = __webpack_require__(917);
	
	function getPageLimits() {
	  var start = this.getPage() * this.getPerPage();
	  var end = start + this.getPerPage();
	  return [start, end];
	}
	
	function updatePagination() {
	  var pages = getPageLimits.call(this);
	  this._collection.reset(this.superset().slice(pages[0], pages[1]));
	}
	
	function updateNumPages() {
	  var currentNumPages = this._totalPages;
	  var length = this.superset().length;
	  var perPage = this.getPerPage();
	
	  // If the # of objects can be exactly divided by the number
	  // of pages, it would leave an empty last page if we took
	  // the floor.
	  var totalPages = length % perPage === 0 ?
	    (length / perPage) : Math.floor(length / perPage) + 1;
	
	  var numPagesChanged = this._totalPages !== totalPages;
	  this._totalPages = totalPages;
	
	  if (numPagesChanged) {
	    this.trigger('paginated:change:numPages', { numPages: totalPages });
	  }
	
	  // Test to see if we are past the last page, and if so,
	  // move back. Return true so that we can test to see if
	  // this happened.
	  if (this.getPage() >= totalPages) {
	    this.setPage(totalPages - 1);
	    return true;
	  }
	}
	
	function recalculatePagination() {
	  if (updateNumPages.call(this)) { return; }
	  updatePagination.call(this);
	}
	
	// Given two arrays of backbone models, with at most one model added
	// and one model removed from each, return the model in arrayA that
	// is not in arrayB or undefined.
	function difference(arrayA, arrayB) {
	  var maxLength = _.max([ arrayA.length, arrayB.length ]);
	
	  for (var i = 0, j = 0; i < maxLength; i += 1, j += 1) {
	    if (arrayA[i] !== arrayB[j]) {
	      if (arrayB[i-1] === arrayA[i]) {
	        j -= 1;
	      } else if (arrayB[i+1] === arrayA[i]) {
	        j += 1;
	      } else {
	        return arrayA[i];
	      }
	    }
	  }
	}
	
	function onAddRemove(model, collection, options) {
	  if (updateNumPages.call(this)) { return; }
	
	  var pages = getPageLimits.call(this);
	  var start = pages[0], end = pages[1];
	
	  // We are only adding and removing at most one model at a time,
	  // so we can find just those two models. We could probably rewrite
	  // `collectionDifference` to only make on pass instead of two. This
	  // is a bottleneck on the total size of collections. I was getting
	  // slow unit tests around 30,000 models / page in Firefox.
	  var toAdd = difference(this.superset().slice(start, end), this._collection.toArray());
	  var toRemove = difference(this._collection.toArray(), this.superset().slice(start, end));
	
	  if (toRemove) {
	    this._collection.remove(toRemove);
	  }
	
	  if (toAdd) {
	    this._collection.add(toAdd, {
	      at: this.superset().indexOf(toAdd) - start
	    });
	  }
	}
	
	function Paginated(superset, options) {
	  // Save a reference to the original collection
	  this._superset = superset;
	
	  // The idea is to keep an internal backbone collection with the paginated
	  // set, and expose limited functionality.
	  this._collection = new Backbone.Collection(superset.toArray());
	  this._page = 0;
	  this.setPerPage((options && options.perPage) ? options.perPage : null);
	
	  proxyCollection(this._collection, this);
	
	  this.listenTo(this._superset, 'add remove', onAddRemove);
	  this.listenTo(this._superset, 'reset sort', recalculatePagination);
	}
	
	var methods = {
	
	  removePagination: function() {
	    this.setPerPage(null);
	    return this;
	  },
	
	  setPerPage: function(perPage) {
	    this._perPage = perPage;
	    recalculatePagination.call(this);
	    this.setPage(0);
	
	    this.trigger('paginated:change:perPage', {
	      perPage: perPage,
	      numPages: this.getNumPages()
	    });
	
	    return this;
	  },
	
	  setPage: function(page) {
	    // The lowest page we could set
	    var lowerLimit = 0;
	    // The highest page we could set
	    var upperLimit = this.getNumPages() - 1;
	
	    // If the page is higher or lower than these limits,
	    // set it to the limit.
	    page = page > lowerLimit ? page : lowerLimit;
	    page = page < upperLimit ? page : upperLimit;
	    page = page < 0 ? 0 : page;
	
	    this._page = page;
	    updatePagination.call(this);
	
	    this.trigger('paginated:change:page', { page: page });
	    return this;
	  },
	
	  getPerPage: function() {
	    return this._perPage || this.superset().length || 1;
	  },
	
	  getNumPages: function() {
	    return this._totalPages;
	  },
	
	  getPage: function() {
	    return this._page;
	  },
	
	  hasNextPage: function() {
	    return this.getPage() < this.getNumPages() - 1;
	  },
	
	  hasPrevPage: function() {
	    return this.getPage() > 0;
	  },
	
	  nextPage: function() {
	    this.movePage(1);
	    return this;
	  },
	
	  prevPage: function() {
	    this.movePage(-1);
	    return this;
	  },
	
	  firstPage: function() {
	    this.setPage(0);
	  },
	
	  lastPage: function() {
	    this.setPage(this.getNumPages() - 1);
	  },
	
	  movePage: function(delta) {
	    this.setPage(this.getPage() + delta);
	    return this;
	  },
	
	  superset: function() {
	    return this._superset;
	  },
	
	  destroy: function() {
	    this.stopListening();
	    this._collection.reset([]);
	    this._superset = this._collection;
	    this._page = 0;
	    this._totalPages = 0;
	    this.length = 0;
	
	    this.trigger('paginated:destroy');
	  }
	
	};
	
	// Build up the prototype
	_.extend(Paginated.prototype, methods, Backbone.Events);
	
	module.exports =  Paginated;
	


/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	
	var _ = __webpack_require__(1);
	var Backbone =__webpack_require__(4);
	var proxyCollection = __webpack_require__(917);
	var reverseSortedIndex = __webpack_require__(1593);
	
	function lookupIterator(value) {
	  return _.isFunction(value) ? value : function(obj){ return obj.get(value); };
	}
	
	function modelInsertIndex(model) {
	  if (!this._comparator) {
	    return this._superset.indexOf(model);
	  } else {
	    if (!this._reverse) {
	      return _.sortedIndex(this._collection.toArray(), model, lookupIterator(this._comparator));
	    } else {
	      return reverseSortedIndex(this._collection.toArray(), model, lookupIterator(this._comparator));
	    }
	  }
	}
	
	function onAdd(model) {
	  var index = modelInsertIndex.call(this, model);
	  this._collection.add(model, { at: index });
	}
	
	function onRemove(model) {
	  if (this.contains(model)) {
	    this._collection.remove(model);
	  }
	}
	
	function onChange(model) {
	  if (this.contains(model) && this._collection.indexOf(model) !== modelInsertIndex.call(this, model)) {
	    this._collection.remove(model);
	    onAdd.call(this, model);
	  }
	}
	
	function sort() {
	  if (!this._comparator) {
	    this._collection.reset(this._superset.toArray());
	    return;
	  }
	
	  var newOrder = this._superset.sortBy(this._comparator);
	  this._collection.reset(this._reverse ? newOrder.reverse() : newOrder);
	}
	
	function Sorted(superset) {
	  // Save a reference to the original collection
	  this._superset = superset;
	  this._reverse = false;
	  this._comparator = null;
	
	  // The idea is to keep an internal backbone collection with the paginated
	  // set, and expose limited functionality.
	  this._collection = new Backbone.Collection(superset.toArray());
	  proxyCollection(this._collection, this);
	
	  this.listenTo(this._superset, 'add', onAdd);
	  this.listenTo(this._superset, 'remove', onRemove);
	  this.listenTo(this._superset, 'change', onChange);
	  this.listenTo(this._superset, 'reset', sort);
	}
	
	var methods = {
	
	  setSort: function(comparator, direction) {
	    this._reverse = direction === 'desc' ? true : false;
	    this._comparator = comparator;
	
	    sort.call(this);
	
	    if (!comparator) {
	      this.trigger('sorted:remove');
	    } else {
	      this.trigger('sorted:add');
	    }
	
	    return this;
	  },
	
	  reverseSort: function() {
	    this._reverse = !this._reverse;
	    sort.call(this);
	
	    return this;
	  },
	
	  removeSort: function() {
	    this.setSort();
	    return this;
	  },
	
	  superset: function() {
	    return this._superset;
	  },
	
	  destroy: function() {
	    this.stopListening();
	    this._collection.reset([]);
	    this._superset = this._collection;
	    this.length = 0;
	
	    this.trigger('sorted:destroy');
	  }
	
	};
	
	// Build up the prototype
	_.extend(Sorted.prototype, methods, Backbone.Events);
	
	module.exports = Sorted;
	


/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	
	var _ = __webpack_require__(1);
	
	// Underscore provides a .sortedIndex function that works
	// when sorting ascending based on a function or a key, but there's no
	// way to do the same thing when sorting descending. This is a slight
	// modification of the underscore / backbone code to do the same thing
	// but descending.
	
	function lookupIterator(value) {
	  return _.isFunction(value) ? value : function(obj){ return obj[value]; };
	}
	
	function reverseSortedIndex(array, obj, iterator, context) {
	  iterator = iterator == null ? _.identity : lookupIterator(iterator);
	  var value = iterator.call(context, obj);
	  var low = 0, high = array.length;
	  while (low < high) {
	    var mid = (low + high) >>> 1;
	    iterator.call(context, array[mid]) < value ? high = mid : low = mid + 1;
	  }
	  return low;
	}
	
	module.exports = reverseSortedIndex;


/***/ },
/* 1594 */
[1953, 4, 1],
/* 1595 */
1510,
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(1);
	
	function proxyEvents(from, eventNames) {
	  _.each(eventNames, function(eventName) {
	    this.listenTo(from, eventName, function() {
	      var args = _.toArray(arguments);
	      args.unshift(eventName);
	      this.trigger.apply(this, args);
	    });
	  }, this);
	}
	
	module.exports = proxyEvents;


/***/ },
/* 1597 */
[1958, 4, 1],
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1307);
	__webpack_require__(1616);
	module.exports = __webpack_require__(466).Array.from;

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(466);
	module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
	  return (core.JSON && core.JSON.stringify || JSON.stringify).apply(JSON, arguments);
	};

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1620);
	__webpack_require__(1307);
	__webpack_require__(1623);
	__webpack_require__(1618);
	__webpack_require__(1621);
	module.exports = __webpack_require__(466).Map;

/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1619);
	module.exports = __webpack_require__(466).Object.assign;

/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1622);
	module.exports = __webpack_require__(466).Object.values;

/***/ },
/* 1603 */
678,
/* 1604 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 1605 */
[2107, 371, 747, 1298, 918, 1300, 919, 988, 991, 1296, 1305, 989, 990, 1613, 920],
/* 1606 */
[2108, 988, 1291],
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(371)
	  , global         = __webpack_require__(921)
	  , $export        = __webpack_require__(677)
	  , fails          = __webpack_require__(987)
	  , hide           = __webpack_require__(747)
	  , redefineAll    = __webpack_require__(1298)
	  , forOf          = __webpack_require__(988)
	  , strictNew      = __webpack_require__(1300)
	  , isObject       = __webpack_require__(990)
	  , setToStringTag = __webpack_require__(992)
	  , DESCRIPTORS    = __webpack_require__(920);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	  } else {
	    C = wrapper(function(target, iterable){
	      strictNew(target, C, NAME);
	      target._c = new Base;
	      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    $.each.call('add,clear,delete,forEach,get,has,set,keys,values,entries'.split(','),function(KEY){
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
	        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    if('size' in proto)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 1608 */
[2116, 371, 1297, 992, 747, 467],
/* 1609 */
[2118, 467],
/* 1610 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 1611 */
[2119, 371, 1304, 1293, 987],
/* 1612 */
[2120, 371, 1302],
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var core        = __webpack_require__(466)
	  , $           = __webpack_require__(371)
	  , DESCRIPTORS = __webpack_require__(920)
	  , SPECIES     = __webpack_require__(467)('species');
	
	module.exports = function(KEY){
	  var C = core[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 1614 */
[2123, 921],
/* 1615 */
[2124, 1301, 919],
/* 1616 */
[2130, 918, 677, 1304, 1295, 1294, 1303, 1306, 1609],
/* 1617 */
[2131, 1604, 1296, 748, 1302, 991],
/* 1618 */
[2132, 1605, 1607],
/* 1619 */
[2133, 677, 1611],
/* 1620 */
/***/ function(module, exports) {



/***/ },
/* 1621 */
[2135, 677, 1606],
/* 1622 */
[2136, 677, 1612],
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1617);
	var Iterators = __webpack_require__(748);
	Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(470)
	  , toIndex  = __webpack_require__(752)
	  , toLength = __webpack_require__(305);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , $$    = arguments
	    , end   = $$.length > 2 ? $$[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(470)
	  , toIndex  = __webpack_require__(752)
	  , toLength = __webpack_require__(305);
	module.exports = [].fill || function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , $$     = arguments
	    , $$len  = $$.length
	    , index  = toIndex($$len > 1 ? $$[1] : undefined, length)
	    , end    = $$len > 2 ? $$[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var isObject = __webpack_require__(184)
	  , isArray  = __webpack_require__(994)
	  , SPECIES  = __webpack_require__(216)('species');
	module.exports = function(original, length){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return new (C === undefined ? Array : C)(length);
	};

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(133);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(133)
	  , toIObject = __webpack_require__(343);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(220)
	  , macrotask = __webpack_require__(1329).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(468)(process) == 'process'
	  , head, last, notify;
	
	var flush = function(){
	  var parent, domain, fn;
	  if(isNode && (parent = process.domain)){
	    process.domain = null;
	    parent.exit();
	  }
	  while(head){
	    domain = head.domain;
	    fn     = head.fn;
	    if(domain)domain.enter();
	    fn(); // <- currently we use it only for Promise - try / catch not required
	    if(domain)domain.exit();
	    head = head.next;
	  } last = undefined;
	  if(parent)parent.enter();
	};
	
	// Node.js
	if(isNode){
	  notify = function(){
	    process.nextTick(flush);
	  };
	// browsers with MutationObserver
	} else if(Observer){
	  var toggle = 1
	    , node   = document.createTextNode('');
	  new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	  notify = function(){
	    node.data = toggle = -toggle;
	  };
	// environments with maybe non-completely correct, but existent Promise
	} else if(Promise && Promise.resolve){
	  notify = function(){
	    Promise.resolve().then(flush);
	  };
	// for other environments - macrotask based on:
	// - setImmediate
	// - MessageChannel
	// - window.postMessag
	// - onreadystatechange
	// - setTimeout
	} else {
	  notify = function(){
	    // strange IE + webpack dev server bug - use .call(global)
	    macrotask.call(global, flush);
	  };
	}
	
	module.exports = function asap(fn){
	  var task = {fn: fn, next: undefined, domain: isNode && process.domain};
	  if(last)last.next = task;
	  if(!head){
	    head = task;
	    notify();
	  } last = task;
	};

/***/ },
/* 1630 */
[2119, 133, 470, 927, 239],
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(1632)
	  , invoke    = __webpack_require__(926)
	  , aFunction = __webpack_require__(678);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that  = this
	      , $$    = arguments
	      , $$len = $$.length
	      , j = 0, k = 0, args;
	    if(!holder && !$$len)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = $$[k++];
	    while($$len > k)args.push($$[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(220);

/***/ },
/* 1633 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(201)
	  , aFunction = __webpack_require__(678)
	  , SPECIES   = __webpack_require__(216)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(184);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $                 = __webpack_require__(133)
	  , $export           = __webpack_require__(56)
	  , DESCRIPTORS       = __webpack_require__(340)
	  , createDesc        = __webpack_require__(514)
	  , html              = __webpack_require__(1315)
	  , cel               = __webpack_require__(1312)
	  , has               = __webpack_require__(304)
	  , cof               = __webpack_require__(468)
	  , invoke            = __webpack_require__(926)
	  , fails             = __webpack_require__(239)
	  , anObject          = __webpack_require__(201)
	  , aFunction         = __webpack_require__(678)
	  , isObject          = __webpack_require__(184)
	  , toObject          = __webpack_require__(470)
	  , toIObject         = __webpack_require__(343)
	  , toInteger         = __webpack_require__(753)
	  , toIndex           = __webpack_require__(752)
	  , toLength          = __webpack_require__(305)
	  , IObject           = __webpack_require__(927)
	  , IE_PROTO          = __webpack_require__(680)('__proto__')
	  , createArrayMethod = __webpack_require__(922)
	  , arrayIndexOf      = __webpack_require__(1308)(false)
	  , ObjectProto       = Object.prototype
	  , ArrayProto        = Array.prototype
	  , arraySlice        = ArrayProto.slice
	  , arrayJoin         = ArrayProto.join
	  , defineProperty    = $.setDesc
	  , getOwnDescriptor  = $.getDesc
	  , defineProperties  = $.setDescs
	  , factories         = {}
	  , IE8_DOM_DEFINE;
	
	if(!DESCRIPTORS){
	  IE8_DOM_DEFINE = !fails(function(){
	    return defineProperty(cel('div'), 'a', {get: function(){ return 7; }}).a != 7;
	  });
	  $.setDesc = function(O, P, Attributes){
	    if(IE8_DOM_DEFINE)try {
	      return defineProperty(O, P, Attributes);
	    } catch(e){ /* empty */ }
	    if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	    if('value' in Attributes)anObject(O)[P] = Attributes.value;
	    return O;
	  };
	  $.getDesc = function(O, P){
	    if(IE8_DOM_DEFINE)try {
	      return getOwnDescriptor(O, P);
	    } catch(e){ /* empty */ }
	    if(has(O, P))return createDesc(!ObjectProto.propertyIsEnumerable.call(O, P), O[P]);
	  };
	  $.setDescs = defineProperties = function(O, Properties){
	    anObject(O);
	    var keys   = $.getKeys(Properties)
	      , length = keys.length
	      , i = 0
	      , P;
	    while(length > i)$.setDesc(O, P = keys[i++], Properties[P]);
	    return O;
	  };
	}
	$export($export.S + $export.F * !DESCRIPTORS, 'Object', {
	  // 19.1.2.6 / 15.2.3.3 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $.getDesc,
	  // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	  defineProperty: $.setDesc,
	  // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	  defineProperties: defineProperties
	});
	
	  // IE 8- don't enum bug keys
	var keys1 = ('constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,' +
	            'toLocaleString,toString,valueOf').split(',')
	  // Additional keys for getOwnPropertyNames
	  , keys2 = keys1.concat('length', 'prototype')
	  , keysLen1 = keys1.length;
	
	// Create object with `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = cel('iframe')
	    , i      = keysLen1
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write('<script>document.F=Object</script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict.prototype[keys1[i]];
	  return createDict();
	};
	var createGetKeys = function(names, length){
	  return function(object){
	    var O      = toIObject(object)
	      , i      = 0
	      , result = []
	      , key;
	    for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	    // Don't enum bug & hidden keys
	    while(length > i)if(has(O, key = names[i++])){
	      ~arrayIndexOf(result, key) || result.push(key);
	    }
	    return result;
	  };
	};
	var Empty = function(){};
	$export($export.S, 'Object', {
	  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	  getPrototypeOf: $.getProto = $.getProto || function(O){
	    O = toObject(O);
	    if(has(O, IE_PROTO))return O[IE_PROTO];
	    if(typeof O.constructor == 'function' && O instanceof O.constructor){
	      return O.constructor.prototype;
	    } return O instanceof Object ? ObjectProto : null;
	  },
	  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $.getNames = $.getNames || createGetKeys(keys2, keys2.length, true),
	  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	  create: $.create = $.create || function(O, /*?*/Properties){
	    var result;
	    if(O !== null){
	      Empty.prototype = anObject(O);
	      result = new Empty();
	      Empty.prototype = null;
	      // add "__proto__" for Object.getPrototypeOf shim
	      result[IE_PROTO] = O;
	    } else result = createDict();
	    return Properties === undefined ? result : defineProperties(result, Properties);
	  },
	  // 19.1.2.14 / 15.2.3.14 Object.keys(O)
	  keys: $.getKeys = $.getKeys || createGetKeys(keys1, keysLen1, false)
	});
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  }
	  return factories[len](F, args);
	};
	
	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	$export($export.P, 'Function', {
	  bind: function bind(that /*, args... */){
	    var fn       = aFunction(this)
	      , partArgs = arraySlice.call(arguments, 1);
	    var bound = function(/* args... */){
	      var args = partArgs.concat(arraySlice.call(arguments));
	      return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	    };
	    if(isObject(fn.prototype))bound.prototype = fn.prototype;
	    return bound;
	  }
	});
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * fails(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});
	$export($export.P + $export.F * (IObject != Object), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(IObject(this), separator === undefined ? ',' : separator);
	  }
	});
	
	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	$export($export.S, 'Array', {isArray: __webpack_require__(994)});
	
	var createArrayReduce = function(isRight){
	  return function(callbackfn, memo){
	    aFunction(callbackfn);
	    var O      = IObject(this)
	      , length = toLength(O.length)
	      , index  = isRight ? length - 1 : 0
	      , i      = isRight ? -1 : 1;
	    if(arguments.length < 2)for(;;){
	      if(index in O){
	        memo = O[index];
	        index += i;
	        break;
	      }
	      index += i;
	      if(isRight ? index < 0 : length <= index){
	        throw TypeError('Reduce of empty array with no initial value');
	      }
	    }
	    for(;isRight ? index >= 0 : length > index; index += i)if(index in O){
	      memo = callbackfn(memo, O[index], index, this);
	    }
	    return memo;
	  };
	};
	
	var methodize = function($fn){
	  return function(arg1/*, arg2 = undefined */){
	    return $fn(this, arg1, arguments[1]);
	  };
	};
	
	$export($export.P, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: $.each = $.each || methodize(createArrayMethod(0)),
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: methodize(createArrayMethod(1)),
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: methodize(createArrayMethod(2)),
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: methodize(createArrayMethod(3)),
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: methodize(createArrayMethod(4)),
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: createArrayReduce(false),
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: createArrayReduce(true),
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: methodize(arrayIndexOf),
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function(el, fromIndex /* = @[*-1] */){
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(fromIndex));
	    if(index < 0)index = toLength(length + index);
	    for(;index >= 0; index--)if(index in O)if(O[index] === el)return index;
	    return -1;
	  }
	});
	
	// 20.3.3.1 / 15.9.4.4 Date.now()
	$export($export.S, 'Date', {now: function(){ return +new Date; }});
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(this))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(56);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(1624)});
	
	__webpack_require__(679)('copyWithin');

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(56);
	
	$export($export.P, 'Array', {fill: __webpack_require__(1625)});
	
	__webpack_require__(679)('fill');

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(56)
	  , $find   = __webpack_require__(922)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(679)(KEY);

/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(56)
	  , $find   = __webpack_require__(922)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(679)(KEY);

/***/ },
/* 1641 */
[2130, 372, 56, 470, 1319, 1316, 305, 1330, 996],
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(56);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(239)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , $$     = arguments
	      , $$len  = $$.length
	      , result = new (typeof this == 'function' ? this : Array)($$len);
	    while($$len > index)result[index] = $$[index++];
	    result.length = $$len;
	    return result;
	  }
	});

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(929)('Array');

/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $             = __webpack_require__(133)
	  , isObject      = __webpack_require__(184)
	  , HAS_INSTANCE  = __webpack_require__(216)('hasInstance')
	  , FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))$.setDesc(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = $.getProto(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	var setDesc    = __webpack_require__(133).setDesc
	  , createDesc = __webpack_require__(514)
	  , has        = __webpack_require__(304)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(340) && setDesc(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    var match = ('' + this).match(nameRE)
	      , name  = match ? match[1] : '';
	    has(this, NAME) || setDesc(this, NAME, createDesc(5, name));
	    return name;
	  }
	});

/***/ },
/* 1646 */
[2132, 1309, 924],
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(56)
	  , log1p   = __webpack_require__(1322)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	// V8 bug https://code.google.com/p/v8/issues/detail?id=3509
	$export($export.S + $export.F * !($acosh && Math.floor($acosh(Number.MAX_VALUE)) == 710), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(56);
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	$export($export.S, 'Math', {asinh: asinh});

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(56)
	  , sign    = __webpack_require__(999);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(56)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Math', {expm1: __webpack_require__(998)});

/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(56)
	  , sign      = __webpack_require__(999)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(56)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum   = 0
	      , i     = 0
	      , $$    = arguments
	      , $$len = $$.length
	      , larg  = 0
	      , arg, div;
	    while(i < $$len){
	      arg = abs($$[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(56)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(239)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(1322)});

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Math', {sign: __webpack_require__(999)});

/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(56)
	  , expm1   = __webpack_require__(998)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(239)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(56)
	  , expm1   = __webpack_require__(998)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $           = __webpack_require__(133)
	  , global      = __webpack_require__(220)
	  , has         = __webpack_require__(304)
	  , cof         = __webpack_require__(468)
	  , toPrimitive = __webpack_require__(1635)
	  , fails       = __webpack_require__(239)
	  , $trim       = __webpack_require__(931).trim
	  , NUMBER      = 'Number'
	  , $Number     = global[NUMBER]
	  , Base        = $Number
	  , proto       = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF  = cof($.create(proto)) == NUMBER
	  , TRIM        = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? new Base(toNumber(it)) : toNumber(it);
	  };
	  $.each.call(__webpack_require__(340) ? $.getNames(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), function(key){
	    if(has(Base, key) && !has($Number, key)){
	      $.setDesc($Number, key, $.getDesc(Base, key));
	    }
	  });
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(342)(global, NUMBER, $Number);
	}

/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(56)
	  , _isFinite = __webpack_require__(220).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(1317)});

/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(56)
	  , isInteger = __webpack_require__(1317)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.12 Number.parseFloat(string)
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Number', {parseFloat: parseFloat});

/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.13 Number.parseInt(string, radix)
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Number', {parseInt: parseInt});

/***/ },
/* 1674 */
[2133, 56, 1630],
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(184);
	
	__webpack_require__(341)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(it) : it;
	  };
	});

/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(343);
	
	__webpack_require__(341)('getOwnPropertyDescriptor', function($getOwnPropertyDescriptor){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(341)('getOwnPropertyNames', function(){
	  return __webpack_require__(1314).get;
	});

/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(470);
	
	__webpack_require__(341)('getPrototypeOf', function($getPrototypeOf){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(184);
	
	__webpack_require__(341)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(184);
	
	__webpack_require__(341)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(184);
	
	__webpack_require__(341)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(56);
	$export($export.S, 'Object', {is: __webpack_require__(1325)});

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(470);
	
	__webpack_require__(341)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(184);
	
	__webpack_require__(341)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(it) : it;
	  };
	});

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(184);
	
	__webpack_require__(341)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(it) : it;
	  };
	});

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(56);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(1000).set});

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(923)
	  , test    = {};
	test[__webpack_require__(216)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(342)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $          = __webpack_require__(133)
	  , LIBRARY    = __webpack_require__(997)
	  , global     = __webpack_require__(220)
	  , ctx        = __webpack_require__(372)
	  , classof    = __webpack_require__(923)
	  , $export    = __webpack_require__(56)
	  , isObject   = __webpack_require__(184)
	  , anObject   = __webpack_require__(201)
	  , aFunction  = __webpack_require__(678)
	  , strictNew  = __webpack_require__(930)
	  , forOf      = __webpack_require__(749)
	  , setProto   = __webpack_require__(1000).set
	  , same       = __webpack_require__(1325)
	  , SPECIES    = __webpack_require__(216)('species')
	  , speciesConstructor = __webpack_require__(1634)
	  , asap       = __webpack_require__(1629)
	  , PROMISE    = 'Promise'
	  , process    = global.process
	  , isNode     = classof(process) == 'process'
	  , P          = global[PROMISE]
	  , empty      = function(){ /* empty */ }
	  , Wrapper;
	
	var testResolve = function(sub){
	  var test = new P(empty), promise;
	  if(sub)test.constructor = function(exec){
	    exec(empty, empty);
	  };
	  (promise = P.resolve(test))['catch'](empty);
	  return promise === test;
	};
	
	var USE_NATIVE = function(){
	  var works = false;
	  function P2(x){
	    var self = new P(x);
	    setProto(self, P2.prototype);
	    return self;
	  }
	  try {
	    works = P && P.resolve && testResolve();
	    setProto(P2, P);
	    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
	    // actual Firefox has broken subclass support, test that
	    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
	      works = false;
	    }
	    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
	    if(works && __webpack_require__(340)){
	      var thenableThenGotten = false;
	      P.resolve($.setDesc({}, 'then', {
	        get: function(){ thenableThenGotten = true; }
	      }));
	      works = thenableThenGotten;
	    }
	  } catch(e){ works = false; }
	  return works;
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // library wrapper special case
	  if(LIBRARY && a === P && b === Wrapper)return true;
	  return same(a, b);
	};
	var getConstructor = function(C){
	  var S = anObject(C)[SPECIES];
	  return S != undefined ? S : C;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var PromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve),
	  this.reject  = aFunction(reject)
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(record, isReject){
	  if(record.n)return;
	  record.n = true;
	  var chain = record.c;
	  asap(function(){
	    var value = record.v
	      , ok    = record.s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , result, then;
	      try {
	        if(handler){
	          if(!ok)record.h = true;
	          result = handler === true ? value : handler(value);
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    chain.length = 0;
	    record.n = false;
	    if(isReject)setTimeout(function(){
	      var promise = record.p
	        , handler, console;
	      if(isUnhandled(promise)){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      } record.a = undefined;
	    }, 1);
	  });
	};
	var isUnhandled = function(promise){
	  var record = promise._d
	    , chain  = record.a || record.c
	    , i      = 0
	    , reaction;
	  if(record.h)return false;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var $reject = function(value){
	  var record = this;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  record.v = value;
	  record.s = 2;
	  record.a = record.c.slice();
	  notify(record, true);
	};
	var $resolve = function(value){
	  var record = this
	    , then;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  try {
	    if(record.p === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      asap(function(){
	        var wrapper = {r: record, d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      record.v = value;
	      record.s = 1;
	      notify(record, false);
	    }
	  } catch(e){
	    $reject.call({r: record, d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  P = function Promise(executor){
	    aFunction(executor);
	    var record = this._d = {
	      p: strictNew(this, P, PROMISE),         // <- promise
	      c: [],                                  // <- awaiting reactions
	      a: undefined,                           // <- checked in isUnhandled reactions
	      s: 0,                                   // <- state
	      d: false,                               // <- done
	      v: undefined,                           // <- value
	      h: false,                               // <- handled rejection
	      n: false                                // <- notify
	    };
	    try {
	      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
	    } catch(err){
	      $reject.call(record, err);
	    }
	  };
	  __webpack_require__(928)(P.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction = new PromiseCapability(speciesConstructor(this, P))
	        , promise  = reaction.promise
	        , record   = this._d;
	      reaction.ok   = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      record.c.push(reaction);
	      if(record.a)record.a.push(reaction);
	      if(record.s)notify(record, false);
	      return promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
	__webpack_require__(751)(P, PROMISE);
	__webpack_require__(929)(PROMISE);
	Wrapper = __webpack_require__(469)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = new PromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof P && sameConstructor(x.constructor, this))return x;
	    var capability = new PromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(996)(function(iter){
	  P.all(iter)['catch'](function(){});
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject
	      , values     = [];
	    var abrupt = perform(function(){
	      forOf(iterable, false, values.push, values);
	      var remaining = values.length
	        , results   = Array(remaining);
	      if(remaining)$.each.call(values, function(promise, index){
	        var alreadyCalled = false;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled = true;
	          results[index] = value;
	          --remaining || resolve(results);
	        }, reject);
	      });
	      else resolve(results);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export  = __webpack_require__(56)
	  , _apply   = Function.apply
	  , anObject = __webpack_require__(201);
	
	$export($export.S, 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    return _apply.call(target, thisArgument, anObject(argumentsList));
	  }
	});

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $         = __webpack_require__(133)
	  , $export   = __webpack_require__(56)
	  , aFunction = __webpack_require__(678)
	  , anObject  = __webpack_require__(201)
	  , isObject  = __webpack_require__(184)
	  , bind      = Function.bind || __webpack_require__(469).Function.prototype.bind;
	
	// MS Edge supports only 2 arguments
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	$export($export.S + $export.F * __webpack_require__(239)(function(){
	  function F(){}
	  return !(Reflect.construct(function(){}, [], F) instanceof F);
	}), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = $.create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var $        = __webpack_require__(133)
	  , $export  = __webpack_require__(56)
	  , anObject = __webpack_require__(201);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(239)(function(){
	  Reflect.defineProperty($.setDesc({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    try {
	      $.setDesc(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(56)
	  , getDesc  = __webpack_require__(133).getDesc
	  , anObject = __webpack_require__(201);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = getDesc(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(56)
	  , anObject = __webpack_require__(201);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(1320)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var $        = __webpack_require__(133)
	  , $export  = __webpack_require__(56)
	  , anObject = __webpack_require__(201);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return $.getDesc(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(56)
	  , getProto = __webpack_require__(133).getProto
	  , anObject = __webpack_require__(201);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var $        = __webpack_require__(133)
	  , has      = __webpack_require__(304)
	  , $export  = __webpack_require__(56)
	  , isObject = __webpack_require__(184)
	  , anObject = __webpack_require__(201);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = $.getDesc(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = $.getProto(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(56)
	  , anObject      = __webpack_require__(201)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(56);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(1324)});

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(56)
	  , anObject           = __webpack_require__(201)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(56)
	  , setProto = __webpack_require__(1000);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var $          = __webpack_require__(133)
	  , has        = __webpack_require__(304)
	  , $export    = __webpack_require__(56)
	  , createDesc = __webpack_require__(514)
	  , anObject   = __webpack_require__(201)
	  , isObject   = __webpack_require__(184);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = $.getDesc(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = $.getProto(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = $.getDesc(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    $.setDesc(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	var $        = __webpack_require__(133)
	  , global   = __webpack_require__(220)
	  , isRegExp = __webpack_require__(1318)
	  , $flags   = __webpack_require__(1313)
	  , $RegExp  = global.RegExp
	  , Base     = $RegExp
	  , proto    = $RegExp.prototype
	  , re1      = /a/g
	  , re2      = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(340) && (!CORRECT_NEW || __webpack_require__(239)(function(){
	  re2[__webpack_require__(216)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !(this instanceof $RegExp) && piRE && p.constructor === $RegExp && fiU ? p
	      : CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f);
	  };
	  $.each.call($.getNames(Base), function(key){
	    key in $RegExp || $.setDesc($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  });
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(342)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(929)('RegExp');

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	var $ = __webpack_require__(133);
	if(__webpack_require__(340) && /./g.flags != 'g')$.setDesc(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(1313)
	});

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(925)('match', 1, function(defined, MATCH){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  };
	});

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(925)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  };
	});

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(925)('search', 1, function(defined, SEARCH){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  };
	});

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(925)('split', 2, function(defined, SPLIT, $split){
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return function split(separator, limit){
	    'use strict';
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined
	      ? fn.call(separator, O, limit)
	      : $split.call(String(O), separator, limit);
	  };
	});

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(1309);
	
	// 23.2 Set Objects
	__webpack_require__(924)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(56)
	  , $at     = __webpack_require__(1001)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(56)
	  , toLength  = __webpack_require__(305)
	  , context   = __webpack_require__(1002)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(993)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , $$   = arguments
	      , endPosition = $$.length > 1 ? $$[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(56)
	  , toIndex        = __webpack_require__(752)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res   = []
	      , $$    = arguments
	      , $$len = $$.length
	      , i     = 0
	      , code;
	    while($$len > i){
	      code = +$$[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(56)
	  , context  = __webpack_require__(1002)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(993)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 1714 */
[2134, 1001, 995],
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(56)
	  , toIObject = __webpack_require__(343)
	  , toLength  = __webpack_require__(305);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl   = toIObject(callSite.raw)
	      , len   = toLength(tpl.length)
	      , $$    = arguments
	      , $$len = $$.length
	      , res   = []
	      , i     = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < $$len)res.push(String($$[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(56);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(1328)
	});

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(56)
	  , toLength    = __webpack_require__(305)
	  , context     = __webpack_require__(1002)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(993)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , $$     = arguments
	      , index  = toLength(Math.min($$.length > 1 ? $$[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(931)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var $              = __webpack_require__(133)
	  , global         = __webpack_require__(220)
	  , has            = __webpack_require__(304)
	  , DESCRIPTORS    = __webpack_require__(340)
	  , $export        = __webpack_require__(56)
	  , redefine       = __webpack_require__(342)
	  , $fails         = __webpack_require__(239)
	  , shared         = __webpack_require__(1326)
	  , setToStringTag = __webpack_require__(751)
	  , uid            = __webpack_require__(680)
	  , wks            = __webpack_require__(216)
	  , keyOf          = __webpack_require__(1628)
	  , $names         = __webpack_require__(1314)
	  , enumKeys       = __webpack_require__(1627)
	  , isArray        = __webpack_require__(994)
	  , anObject       = __webpack_require__(201)
	  , toIObject      = __webpack_require__(343)
	  , createDesc     = __webpack_require__(514)
	  , getDesc        = $.getDesc
	  , setDesc        = $.setDesc
	  , _create        = $.create
	  , getNames       = $names.get
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , setter         = false
	  , HIDDEN         = wks('_hidden')
	  , isEnum         = $.isEnum
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , useNative      = typeof $Symbol == 'function'
	  , ObjectProto    = Object.prototype;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(setDesc({}, 'a', {
	    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = getDesc(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  setDesc(it, key, D);
	  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	} : setDesc;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol.prototype);
	  sym._k = tag;
	  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    }
	  });
	  return sym;
	};
	
	var isSymbol = function(it){
	  return typeof it == 'symbol';
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toIObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
	  return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	};
	var $stringify = function stringify(it){
	  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	  var args = [it]
	    , i    = 1
	    , $$   = arguments
	    , replacer, $replacer;
	  while($$.length > i)args.push($$[i++]);
	  replacer = args[1];
	  if(typeof replacer == 'function')$replacer = replacer;
	  if($replacer || !isArray(replacer))replacer = function(key, value){
	    if($replacer)value = $replacer.call(this, key, value);
	    if(!isSymbol(value))return value;
	  };
	  args[1] = replacer;
	  return _stringify.apply($JSON, args);
	};
	var buggyJSON = $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	});
	
	// 19.4.1.1 Symbol([description])
	if(!useNative){
	  $Symbol = function Symbol(){
	    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
	  };
	  redefine($Symbol.prototype, 'toString', function toString(){
	    return this._k;
	  });
	
	  isSymbol = function(it){
	    return it instanceof $Symbol;
	  };
	
	  $.create     = $create;
	  $.isEnum     = $propertyIsEnumerable;
	  $.getDesc    = $getOwnPropertyDescriptor;
	  $.setDesc    = $defineProperty;
	  $.setDescs   = $defineProperties;
	  $.getNames   = $names.get = $getOwnPropertyNames;
	  $.getSymbols = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(997)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	}
	
	var symbolStatics = {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	};
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	  'species,split,toPrimitive,toStringTag,unscopables'
	).split(','), function(it){
	  var sym = wks(it);
	  symbolStatics[it] = useNative ? sym : wrap(sym);
	});
	
	setter = true;
	
	$export($export.G + $export.W, {Symbol: $Symbol});
	
	$export($export.S, 'Symbol', symbolStatics);
	
	$export($export.S + $export.F * !useNative, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});
	
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $            = __webpack_require__(133)
	  , redefine     = __webpack_require__(342)
	  , weak         = __webpack_require__(1311)
	  , isObject     = __webpack_require__(184)
	  , has          = __webpack_require__(304)
	  , frozenStore  = weak.frozenStore
	  , WEAK         = weak.WEAK
	  , isExtensible = Object.isExtensible || isObject
	  , tmp          = {};
	
	// 23.3 WeakMap Objects
	var $WeakMap = __webpack_require__(924)('WeakMap', function(get){
	  return function WeakMap(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      if(!isExtensible(key))return frozenStore(this).get(key);
	      if(has(key, WEAK))return key[WEAK][this._i];
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	}, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  $.each.call(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on leaky map
	      if(isObject(a) && !isExtensible(a)){
	        var result = frozenStore(this)[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(1311);
	
	// 23.4 WeakSet Objects
	__webpack_require__(924)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(56)
	  , $includes = __webpack_require__(1308)(true);
	
	$export($export.P, 'Array', {
	  // https://github.com/domenic/Array.prototype.includes
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(679)('includes');

/***/ },
/* 1723 */
[2135, 56, 1310],
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	// http://goo.gl/XkBrjD
	var $export  = __webpack_require__(56)
	  , $entries = __webpack_require__(1323)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/WebReflection/9353781
	var $          = __webpack_require__(133)
	  , $export    = __webpack_require__(56)
	  , ownKeys    = __webpack_require__(1324)
	  , toIObject  = __webpack_require__(343)
	  , createDesc = __webpack_require__(514);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , setDesc = $.setDesc
	      , getDesc = $.getDesc
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key, D;
	    while(keys.length > i){
	      D = getDesc(O, key = keys[i++]);
	      if(key in result)setDesc(result, key, createDesc(0, D));
	      else result[key] = D;
	    } return result;
	  }
	});

/***/ },
/* 1726 */
[2136, 56, 1323],
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(56)
	  , $re     = __webpack_require__(1633)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(56);
	
	$export($export.P, 'Set', {toJSON: __webpack_require__(1310)('Set')});

/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(56)
	  , $at     = __webpack_require__(1001)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(56)
	  , $pad    = __webpack_require__(1327);
	
	$export($export.P, 'String', {
	  padLeft: function padLeft(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(56)
	  , $pad    = __webpack_require__(1327);
	
	$export($export.P, 'String', {
	  padRight: function padRight(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(931)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	});

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(931)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	});

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	// JavaScript 1.6 / Strawman array statics shim
	var $       = __webpack_require__(133)
	  , $export = __webpack_require__(56)
	  , $ctx    = __webpack_require__(372)
	  , $Array  = __webpack_require__(469).Array || Array
	  , statics = {};
	var setStatics = function(keys, length){
	  $.each.call(keys.split(','), function(key){
	    if(length == undefined && key in $Array)statics[key] = $Array[key];
	    else if(key in [])statics[key] = $ctx(Function.call, [][key], length);
	  });
	};
	setStatics('pop,reverse,shift,keys,values,entries', 1);
	setStatics('indexOf,every,some,forEach,map,filter,find,findIndex,includes', 3);
	setStatics('join,slice,concat,push,splice,unshift,sort,lastIndexOf,' +
	           'reduce,reduceRight,copyWithin,fill');
	$export($export.S, 'Array', statics);

/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1331);
	var global      = __webpack_require__(220)
	  , hide        = __webpack_require__(374)
	  , Iterators   = __webpack_require__(750)
	  , ITERATOR    = __webpack_require__(216)('iterator')
	  , NL          = global.NodeList
	  , HTC         = global.HTMLCollection
	  , NLProto     = NL && NL.prototype
	  , HTCProto    = HTC && HTC.prototype
	  , ArrayValues = Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;
	if(NLProto && !NLProto[ITERATOR])hide(NLProto, ITERATOR, ArrayValues);
	if(HTCProto && !HTCProto[ITERATOR])hide(HTCProto, ITERATOR, ArrayValues);

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(56)
	  , $task   = __webpack_require__(1329);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(220)
	  , $export    = __webpack_require__(56)
	  , invoke     = __webpack_require__(926)
	  , partial    = __webpack_require__(1631)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1636);
	__webpack_require__(1719);
	__webpack_require__(1674);
	__webpack_require__(1682);
	__webpack_require__(1686);
	__webpack_require__(1687);
	__webpack_require__(1675);
	__webpack_require__(1685);
	__webpack_require__(1684);
	__webpack_require__(1680);
	__webpack_require__(1681);
	__webpack_require__(1679);
	__webpack_require__(1676);
	__webpack_require__(1678);
	__webpack_require__(1683);
	__webpack_require__(1677);
	__webpack_require__(1645);
	__webpack_require__(1644);
	__webpack_require__(1664);
	__webpack_require__(1665);
	__webpack_require__(1666);
	__webpack_require__(1667);
	__webpack_require__(1668);
	__webpack_require__(1669);
	__webpack_require__(1670);
	__webpack_require__(1671);
	__webpack_require__(1672);
	__webpack_require__(1673);
	__webpack_require__(1647);
	__webpack_require__(1648);
	__webpack_require__(1649);
	__webpack_require__(1650);
	__webpack_require__(1651);
	__webpack_require__(1652);
	__webpack_require__(1653);
	__webpack_require__(1654);
	__webpack_require__(1655);
	__webpack_require__(1656);
	__webpack_require__(1657);
	__webpack_require__(1658);
	__webpack_require__(1659);
	__webpack_require__(1660);
	__webpack_require__(1661);
	__webpack_require__(1662);
	__webpack_require__(1663);
	__webpack_require__(1712);
	__webpack_require__(1715);
	__webpack_require__(1718);
	__webpack_require__(1714);
	__webpack_require__(1710);
	__webpack_require__(1711);
	__webpack_require__(1713);
	__webpack_require__(1716);
	__webpack_require__(1717);
	__webpack_require__(1641);
	__webpack_require__(1642);
	__webpack_require__(1331);
	__webpack_require__(1643);
	__webpack_require__(1637);
	__webpack_require__(1638);
	__webpack_require__(1640);
	__webpack_require__(1639);
	__webpack_require__(1703);
	__webpack_require__(1704);
	__webpack_require__(1705);
	__webpack_require__(1706);
	__webpack_require__(1707);
	__webpack_require__(1708);
	__webpack_require__(1688);
	__webpack_require__(1646);
	__webpack_require__(1709);
	__webpack_require__(1720);
	__webpack_require__(1721);
	__webpack_require__(1689);
	__webpack_require__(1690);
	__webpack_require__(1691);
	__webpack_require__(1692);
	__webpack_require__(1693);
	__webpack_require__(1696);
	__webpack_require__(1694);
	__webpack_require__(1695);
	__webpack_require__(1697);
	__webpack_require__(1698);
	__webpack_require__(1699);
	__webpack_require__(1700);
	__webpack_require__(1702);
	__webpack_require__(1701);
	__webpack_require__(1722);
	__webpack_require__(1729);
	__webpack_require__(1730);
	__webpack_require__(1731);
	__webpack_require__(1732);
	__webpack_require__(1733);
	__webpack_require__(1727);
	__webpack_require__(1725);
	__webpack_require__(1726);
	__webpack_require__(1724);
	__webpack_require__(1723);
	__webpack_require__(1728);
	__webpack_require__(1734);
	__webpack_require__(1737);
	__webpack_require__(1736);
	__webpack_require__(1735);
	module.exports = __webpack_require__(469);

/***/ },
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*\n  backgrid-paginator\n  http://github.com/wyuenho/backgrid\n\n  Copyright (c) 2013 Jimmy Yuen Ho Wong and contributors\n  Licensed under the MIT license.\n*/\n.backgrid-paginator {\n  text-align: center;\n  border-top: none;\n  -webkit-border-radius: 0 0 4px 4px;\n  -moz-border-radius: 0 0 4px 4px;\n  border-radius: 0 0 4px 4px;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box; }\n\n.backgrid-paginator ul {\n  display: inline-block;\n  *display: inline;\n  margin: 5px 0;\n  *zoom: 1; }\n\n.backgrid-paginator ul > li {\n  display: inline; }\n\n.backgrid-paginator ul > li > a,\n.backgrid-paginator ul > li > span {\n  float: left;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  line-height: 30px;\n  text-decoration: none; }\n\n.backgrid-paginator ul > li > a:hover,\n.backgrid-paginator ul > .active > a,\n.backgrid-paginator ul > .active > span {\n  background-color: #f5f5f5; }\n\n.backgrid-paginator ul > .active > a,\n.backgrid-paginator ul > .active > span {\n  color: #999999;\n  cursor: default; }\n\n.backgrid-paginator ul > .disabled > span,\n.backgrid-paginator ul > .disabled > a,\n.backgrid-paginator ul > .disabled > a:hover {\n  color: #999999;\n  cursor: default; }\n", ""]);
	
	// exports


/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*\n  backgrid\n  http://github.com/cloudflare/backgrid\n\n  Copyright (c) 2013-present Cloudflare, Inc. and contributors\n  Licensed under the MIT license.\n*/\n.backgrid-container {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 465px;\n  padding: 0;\n  overflow: auto;\n  border: 0; }\n\n.backgrid {\n  width: 100%;\n  max-width: 100%;\n  background-color: transparent;\n  border-collapse: collapse;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px; }\n\n.backgrid th,\n.backgrid td {\n  display: none;\n  height: 20px;\n  max-width: 250px;\n  padding: 4px 5px;\n  overflow: hidden;\n  line-height: 20px;\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: middle;\n  border-bottom: 1px solid #DDD; }\n\n.backgrid th.renderable,\n.backgrid td.renderable {\n  display: table-cell; }\n\n.backgrid th {\n  font-weight: bold;\n  text-align: center; }\n\n.backgrid th.sortable a {\n  white-space: nowrap;\n  cursor: pointer;\n  text-decoration: none; }\n\n.backgrid thead th {\n  vertical-align: bottom;\n  background-color: #f9f9f9; }\n\n.backgrid thead th button {\n  display: block;\n  border: none;\n  background: none;\n  padding: 0; }\n\n.backgrid.backgrid-striped tbody tr:nth-child(even) {\n  background-color: #f9f9f9; }\n\n.backgrid tbody tr.empty {\n  font-style: italic;\n  color: gray; }\n\n.backgrid tbody tr.empty td {\n  display: table-cell;\n  text-align: center; }\n\n.backgrid td.editor {\n  padding: 0; }\n\n.backgrid td.editor,\n.backgrid tbody tr:nth-child(odd) td.editor {\n  background-color: rgba(82, 168, 236, 0.1);\n  outline: 1px solid rgba(82, 168, 236, 0.8);\n  outline-offset: -1px;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-transition-duration: 200ms;\n  -moz-transition-duration: 200ms;\n  -o-transition-duration: 200ms;\n  transition-duration: 200ms;\n  -webkit-transition-property: width, outline, background-color;\n  -moz-transition-property: width, outline, background-color;\n  -o-transition-property: width, outline, background-color;\n  transition-property: width, outline, background-color;\n  -webkit-transition-timing-function: ease-in-out;\n  -moz-transition-timing-function: ease-in-out;\n  -o-transition-timing-function: ease-in-out;\n  transition-timing-function: ease-in-out; }\n\n.backgrid td.editor input[type=text] {\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 0 5px;\n  margin: 0;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  -moz-appearance: none; }\n\n.backgrid td.editor input[type=text]::-ms-clear {\n  display: none; }\n\n.backgrid td.error,\n.backgrid tbody tr:nth-child(odd) td.error {\n  background-color: rgba(255, 210, 77, 0.1);\n  outline: 1px solid #ffd24d; }\n\n.backgrid td.editor :focus,\n.backgrid th.editor :focus {\n  outline: 0; }\n\n.backgrid .sort-caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.3em;\n  border: 0;\n  content: \"\"; }\n\n.backgrid .ascending .sort-caret {\n  vertical-align: baseline;\n  border-top: none;\n  border-right: 4px solid transparent;\n  border-bottom: 4px solid #000000;\n  border-left: 4px solid transparent; }\n\n.backgrid .descending .sort-caret {\n  vertical-align: super;\n  border-top: 4px solid #000000;\n  border-right: 4px solid transparent;\n  border-bottom: none;\n  border-left: 4px solid transparent; }\n\n.backgrid .string-cell,\n.backgrid .uri-cell,\n.backgrid .email-cell,\n.backgrid .string-cell.editor input[type=text],\n.backgrid .uri-cell.editor input[type=text],\n.backgrid .email-cell.editor input[type=text] {\n  text-align: left; }\n\n.backgrid .date-cell,\n.backgrid .time-cell,\n.backgrid .datetime-cell,\n.backgrid .number-cell,\n.backgrid .integer-cell,\n.backgrid .percent-cell,\n.backgrid .date-cell.editor input[type=text],\n.backgrid .time-cell.editor input[type=text],\n.backgrid .datetime-cell.editor input[type=text],\n.backgrid .number-cell.editor input[type=text],\n.backgrid .integer-cell.editor input[type=text],\n.backgrid .percent-cell.editor input[type=text] {\n  text-align: right; }\n\n.backgrid .boolean-cell,\n.backgrid .boolean-cell.editor input[type=checkbox] {\n  text-align: center; }\n\n.backgrid .select-cell {\n  text-align: center; }\n\n.backgrid .select-cell.editor {\n  padding: 0; }\n\n.backgrid .select-cell.editor select {\n  display: block;\n  width: 100%;\n  height: 28px;\n  padding: 4px 5px;\n  margin: 0;\n  line-height: 28px;\n  vertical-align: middle;\n  background-color: white;\n  border: 0;\n  outline: 0;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box; }\n\n.backgrid .select-cell.editor select[multiple] {\n  height: auto; }\n\n.backgrid .select-cell.editor :focus {\n  border: 0;\n  outline: 0; }\n\n.backgrid .select-cell.editor select::-moz-focus-inner,\n.backgrid .select-cell.editor optgroup::-moz-focus-inner,\n.backgrid .select-cell.editor option::-moz-focus-inner,\n.backgrid .select-cell.editor select::-o-focus-inner,\n.backgrid .select-cell.editor optgroup::-o-focus-inner,\n.backgrid .select-cell.editor option::-o-focus-inner {\n  border: 0; }\n", ""]);
	
	// exports


/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*! ========================================================================\n * Bootstrap Toggle: bootstrap-toggle.css v2.2.0\n * http://www.bootstraptoggle.com\n * ========================================================================\n * Copyright 2014 Min Hur, The New York Times Company\n * Licensed under MIT\n * ======================================================================== */\n.checkbox label .toggle,\n.checkbox-inline .toggle {\n  margin-left: -20px;\n  margin-right: 5px; }\n\n.toggle {\n  position: relative;\n  overflow: hidden; }\n\n.toggle input[type=\"checkbox\"] {\n  display: none; }\n\n.toggle-group {\n  position: absolute;\n  width: 200%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  transition: left 0.35s;\n  -webkit-transition: left 0.35s;\n  -moz-user-select: none;\n  -webkit-user-select: none; }\n\n.toggle.off .toggle-group {\n  left: -100%; }\n\n.toggle-on {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 50%;\n  margin: 0;\n  border: 0;\n  border-radius: 0; }\n\n.toggle-off {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 50%;\n  right: 0;\n  margin: 0;\n  border: 0;\n  border-radius: 0; }\n\n.toggle-handle {\n  position: relative;\n  margin: 0 auto;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  height: 100%;\n  width: 0px;\n  border-width: 0 1px; }\n\n.toggle.btn {\n  min-width: 59px;\n  min-height: 34px; }\n\n.toggle-on.btn {\n  padding-right: 24px; }\n\n.toggle-off.btn {\n  padding-left: 24px; }\n\n.toggle.btn-lg {\n  min-width: 79px;\n  min-height: 45px; }\n\n.toggle-on.btn-lg {\n  padding-right: 31px; }\n\n.toggle-off.btn-lg {\n  padding-left: 31px; }\n\n.toggle-handle.btn-lg {\n  width: 40px; }\n\n.toggle.btn-sm {\n  min-width: 50px;\n  min-height: 30px; }\n\n.toggle-on.btn-sm {\n  padding-right: 20px; }\n\n.toggle-off.btn-sm {\n  padding-left: 20px; }\n\n.toggle.btn-xs {\n  min-width: 35px;\n  min-height: 22px; }\n\n.toggle-on.btn-xs {\n  padding-right: 12px; }\n\n.toggle-off.btn-xs {\n  padding-left: 12px; }\n", ""]);
	
	// exports


/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".select2-container {\n  box-sizing: border-box;\n  display: inline-block;\n  margin: 0;\n  position: relative;\n  vertical-align: middle; }\n  .select2-container .select2-selection--single {\n    box-sizing: border-box;\n    cursor: pointer;\n    display: block;\n    height: 28px;\n    user-select: none;\n    -webkit-user-select: none; }\n    .select2-container .select2-selection--single .select2-selection__rendered {\n      display: block;\n      padding-left: 8px;\n      padding-right: 20px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap; }\n    .select2-container .select2-selection--single .select2-selection__clear {\n      position: relative; }\n  .select2-container[dir=\"rtl\"] .select2-selection--single .select2-selection__rendered {\n    padding-right: 8px;\n    padding-left: 20px; }\n  .select2-container .select2-selection--multiple {\n    box-sizing: border-box;\n    cursor: pointer;\n    display: block;\n    min-height: 32px;\n    user-select: none;\n    -webkit-user-select: none; }\n    .select2-container .select2-selection--multiple .select2-selection__rendered {\n      display: inline-block;\n      overflow: hidden;\n      padding-left: 8px;\n      text-overflow: ellipsis;\n      white-space: nowrap; }\n  .select2-container .select2-search--inline {\n    float: left; }\n    .select2-container .select2-search--inline .select2-search__field {\n      box-sizing: border-box;\n      border: none;\n      font-size: 100%;\n      margin-top: 5px;\n      padding: 0; }\n      .select2-container .select2-search--inline .select2-search__field::-webkit-search-cancel-button {\n        -webkit-appearance: none; }\n\n.select2-dropdown {\n  background-color: white;\n  border: 1px solid #aaa;\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  left: -100000px;\n  width: 100%;\n  z-index: 1051; }\n\n.select2-results {\n  display: block; }\n\n.select2-results__options {\n  list-style: none;\n  margin: 0;\n  padding: 0; }\n\n.select2-results__option {\n  padding: 6px;\n  user-select: none;\n  -webkit-user-select: none; }\n  .select2-results__option[aria-selected] {\n    cursor: pointer; }\n\n.select2-container--open .select2-dropdown {\n  left: 0; }\n\n.select2-container--open .select2-dropdown--above {\n  border-bottom: none;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0; }\n\n.select2-container--open .select2-dropdown--below {\n  border-top: none;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0; }\n\n.select2-search--dropdown {\n  display: block;\n  padding: 4px; }\n  .select2-search--dropdown .select2-search__field {\n    padding: 4px;\n    width: 100%;\n    box-sizing: border-box; }\n    .select2-search--dropdown .select2-search__field::-webkit-search-cancel-button {\n      -webkit-appearance: none; }\n  .select2-search--dropdown.select2-search--hide {\n    display: none; }\n\n.select2-close-mask {\n  border: 0;\n  margin: 0;\n  padding: 0;\n  display: block;\n  position: fixed;\n  left: 0;\n  top: 0;\n  min-height: 100%;\n  min-width: 100%;\n  height: auto;\n  width: auto;\n  opacity: 0;\n  z-index: 99;\n  background-color: #fff;\n  filter: alpha(opacity=0); }\n\n.select2-hidden-accessible {\n  border: 0 !important;\n  clip: rect(0 0 0 0) !important;\n  -webkit-clip-path: inset(50%) !important;\n  clip-path: inset(50%) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important; }\n\n.select2-container--default .select2-selection--single {\n  background-color: #fff;\n  border: 1px solid #aaa;\n  border-radius: 4px; }\n  .select2-container--default .select2-selection--single .select2-selection__rendered {\n    color: #444;\n    line-height: 28px; }\n  .select2-container--default .select2-selection--single .select2-selection__clear {\n    cursor: pointer;\n    float: right;\n    font-weight: bold; }\n  .select2-container--default .select2-selection--single .select2-selection__placeholder {\n    color: #999; }\n  .select2-container--default .select2-selection--single .select2-selection__arrow {\n    height: 26px;\n    position: absolute;\n    top: 1px;\n    right: 1px;\n    width: 20px; }\n    .select2-container--default .select2-selection--single .select2-selection__arrow b {\n      border-color: #888 transparent transparent transparent;\n      border-style: solid;\n      border-width: 5px 4px 0 4px;\n      height: 0;\n      left: 50%;\n      margin-left: -4px;\n      margin-top: -2px;\n      position: absolute;\n      top: 50%;\n      width: 0; }\n\n.select2-container--default[dir=\"rtl\"] .select2-selection--single .select2-selection__clear {\n  float: left; }\n\n.select2-container--default[dir=\"rtl\"] .select2-selection--single .select2-selection__arrow {\n  left: 1px;\n  right: auto; }\n\n.select2-container--default.select2-container--disabled .select2-selection--single {\n  background-color: #eee;\n  cursor: default; }\n  .select2-container--default.select2-container--disabled .select2-selection--single .select2-selection__clear {\n    display: none; }\n\n.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {\n  border-color: transparent transparent #888 transparent;\n  border-width: 0 4px 5px 4px; }\n\n.select2-container--default .select2-selection--multiple {\n  background-color: white;\n  border: 1px solid #aaa;\n  border-radius: 4px;\n  cursor: text; }\n  .select2-container--default .select2-selection--multiple .select2-selection__rendered {\n    box-sizing: border-box;\n    list-style: none;\n    margin: 0;\n    padding: 0 5px;\n    width: 100%; }\n    .select2-container--default .select2-selection--multiple .select2-selection__rendered li {\n      list-style: none; }\n  .select2-container--default .select2-selection--multiple .select2-selection__clear {\n    cursor: pointer;\n    float: right;\n    font-weight: bold;\n    margin-top: 5px;\n    margin-right: 10px;\n    padding: 1px; }\n  .select2-container--default .select2-selection--multiple .select2-selection__choice {\n    background-color: #e4e4e4;\n    border: 1px solid #aaa;\n    border-radius: 4px;\n    cursor: default;\n    float: left;\n    margin-right: 5px;\n    margin-top: 5px;\n    padding: 0 5px; }\n  .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\n    color: #999;\n    cursor: pointer;\n    display: inline-block;\n    font-weight: bold;\n    margin-right: 2px; }\n    .select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover {\n      color: #333; }\n\n.select2-container--default[dir=\"rtl\"] .select2-selection--multiple .select2-selection__choice, .select2-container--default[dir=\"rtl\"] .select2-selection--multiple .select2-search--inline {\n  float: right; }\n\n.select2-container--default[dir=\"rtl\"] .select2-selection--multiple .select2-selection__choice {\n  margin-left: 5px;\n  margin-right: auto; }\n\n.select2-container--default[dir=\"rtl\"] .select2-selection--multiple .select2-selection__choice__remove {\n  margin-left: 2px;\n  margin-right: auto; }\n\n.select2-container--default.select2-container--focus .select2-selection--multiple {\n  border: solid black 1px;\n  outline: 0; }\n\n.select2-container--default.select2-container--disabled .select2-selection--multiple {\n  background-color: #eee;\n  cursor: default; }\n\n.select2-container--default.select2-container--disabled .select2-selection__choice__remove {\n  display: none; }\n\n.select2-container--default.select2-container--open.select2-container--above .select2-selection--single, .select2-container--default.select2-container--open.select2-container--above .select2-selection--multiple {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0; }\n\n.select2-container--default.select2-container--open.select2-container--below .select2-selection--single, .select2-container--default.select2-container--open.select2-container--below .select2-selection--multiple {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0; }\n\n.select2-container--default .select2-search--dropdown .select2-search__field {\n  border: 1px solid #aaa; }\n\n.select2-container--default .select2-search--inline .select2-search__field {\n  background: transparent;\n  border: none;\n  outline: 0;\n  box-shadow: none;\n  -webkit-appearance: textfield; }\n\n.select2-container--default .select2-results > .select2-results__options {\n  max-height: 200px;\n  overflow-y: auto; }\n\n.select2-container--default .select2-results__option[role=group] {\n  padding: 0; }\n\n.select2-container--default .select2-results__option[aria-disabled=true] {\n  color: #999; }\n\n.select2-container--default .select2-results__option[aria-selected=true] {\n  background-color: #ddd; }\n\n.select2-container--default .select2-results__option .select2-results__option {\n  padding-left: 1em; }\n  .select2-container--default .select2-results__option .select2-results__option .select2-results__group {\n    padding-left: 0; }\n  .select2-container--default .select2-results__option .select2-results__option .select2-results__option {\n    margin-left: -1em;\n    padding-left: 2em; }\n    .select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option {\n      margin-left: -2em;\n      padding-left: 3em; }\n      .select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option {\n        margin-left: -3em;\n        padding-left: 4em; }\n        .select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option {\n          margin-left: -4em;\n          padding-left: 5em; }\n          .select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option {\n            margin-left: -5em;\n            padding-left: 6em; }\n\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #5897fb;\n  color: white; }\n\n.select2-container--default .select2-results__group {\n  cursor: default;\n  display: block;\n  padding: 6px; }\n\n.select2-container--classic .select2-selection--single {\n  background-color: #f7f7f7;\n  border: 1px solid #aaa;\n  border-radius: 4px;\n  outline: 0;\n  background-image: -webkit-linear-gradient(top, white 50%, #eeeeee 100%);\n  background-image: -o-linear-gradient(top, white 50%, #eeeeee 100%);\n  background-image: linear-gradient(to bottom, white 50%, #eeeeee 100%);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#FFFFFFFF', endColorstr='#FFEEEEEE', GradientType=0); }\n  .select2-container--classic .select2-selection--single:focus {\n    border: 1px solid #5897fb; }\n  .select2-container--classic .select2-selection--single .select2-selection__rendered {\n    color: #444;\n    line-height: 28px; }\n  .select2-container--classic .select2-selection--single .select2-selection__clear {\n    cursor: pointer;\n    float: right;\n    font-weight: bold;\n    margin-right: 10px; }\n  .select2-container--classic .select2-selection--single .select2-selection__placeholder {\n    color: #999; }\n  .select2-container--classic .select2-selection--single .select2-selection__arrow {\n    background-color: #ddd;\n    border: none;\n    border-left: 1px solid #aaa;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    height: 26px;\n    position: absolute;\n    top: 1px;\n    right: 1px;\n    width: 20px;\n    background-image: -webkit-linear-gradient(top, #eeeeee 50%, #cccccc 100%);\n    background-image: -o-linear-gradient(top, #eeeeee 50%, #cccccc 100%);\n    background-image: linear-gradient(to bottom, #eeeeee 50%, #cccccc 100%);\n    background-repeat: repeat-x;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#FFEEEEEE', endColorstr='#FFCCCCCC', GradientType=0); }\n    .select2-container--classic .select2-selection--single .select2-selection__arrow b {\n      border-color: #888 transparent transparent transparent;\n      border-style: solid;\n      border-width: 5px 4px 0 4px;\n      height: 0;\n      left: 50%;\n      margin-left: -4px;\n      margin-top: -2px;\n      position: absolute;\n      top: 50%;\n      width: 0; }\n\n.select2-container--classic[dir=\"rtl\"] .select2-selection--single .select2-selection__clear {\n  float: left; }\n\n.select2-container--classic[dir=\"rtl\"] .select2-selection--single .select2-selection__arrow {\n  border: none;\n  border-right: 1px solid #aaa;\n  border-radius: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  left: 1px;\n  right: auto; }\n\n.select2-container--classic.select2-container--open .select2-selection--single {\n  border: 1px solid #5897fb; }\n  .select2-container--classic.select2-container--open .select2-selection--single .select2-selection__arrow {\n    background: transparent;\n    border: none; }\n    .select2-container--classic.select2-container--open .select2-selection--single .select2-selection__arrow b {\n      border-color: transparent transparent #888 transparent;\n      border-width: 0 4px 5px 4px; }\n\n.select2-container--classic.select2-container--open.select2-container--above .select2-selection--single {\n  border-top: none;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  background-image: -webkit-linear-gradient(top, white 0%, #eeeeee 50%);\n  background-image: -o-linear-gradient(top, white 0%, #eeeeee 50%);\n  background-image: linear-gradient(to bottom, white 0%, #eeeeee 50%);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#FFFFFFFF', endColorstr='#FFEEEEEE', GradientType=0); }\n\n.select2-container--classic.select2-container--open.select2-container--below .select2-selection--single {\n  border-bottom: none;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  background-image: -webkit-linear-gradient(top, #eeeeee 50%, white 100%);\n  background-image: -o-linear-gradient(top, #eeeeee 50%, white 100%);\n  background-image: linear-gradient(to bottom, #eeeeee 50%, white 100%);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#FFEEEEEE', endColorstr='#FFFFFFFF', GradientType=0); }\n\n.select2-container--classic .select2-selection--multiple {\n  background-color: white;\n  border: 1px solid #aaa;\n  border-radius: 4px;\n  cursor: text;\n  outline: 0; }\n  .select2-container--classic .select2-selection--multiple:focus {\n    border: 1px solid #5897fb; }\n  .select2-container--classic .select2-selection--multiple .select2-selection__rendered {\n    list-style: none;\n    margin: 0;\n    padding: 0 5px; }\n  .select2-container--classic .select2-selection--multiple .select2-selection__clear {\n    display: none; }\n  .select2-container--classic .select2-selection--multiple .select2-selection__choice {\n    background-color: #e4e4e4;\n    border: 1px solid #aaa;\n    border-radius: 4px;\n    cursor: default;\n    float: left;\n    margin-right: 5px;\n    margin-top: 5px;\n    padding: 0 5px; }\n  .select2-container--classic .select2-selection--multiple .select2-selection__choice__remove {\n    color: #888;\n    cursor: pointer;\n    display: inline-block;\n    font-weight: bold;\n    margin-right: 2px; }\n    .select2-container--classic .select2-selection--multiple .select2-selection__choice__remove:hover {\n      color: #555; }\n\n.select2-container--classic[dir=\"rtl\"] .select2-selection--multiple .select2-selection__choice {\n  float: right;\n  margin-left: 5px;\n  margin-right: auto; }\n\n.select2-container--classic[dir=\"rtl\"] .select2-selection--multiple .select2-selection__choice__remove {\n  margin-left: 2px;\n  margin-right: auto; }\n\n.select2-container--classic.select2-container--open .select2-selection--multiple {\n  border: 1px solid #5897fb; }\n\n.select2-container--classic.select2-container--open.select2-container--above .select2-selection--multiple {\n  border-top: none;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0; }\n\n.select2-container--classic.select2-container--open.select2-container--below .select2-selection--multiple {\n  border-bottom: none;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0; }\n\n.select2-container--classic .select2-search--dropdown .select2-search__field {\n  border: 1px solid #aaa;\n  outline: 0; }\n\n.select2-container--classic .select2-search--inline .select2-search__field {\n  outline: 0;\n  box-shadow: none; }\n\n.select2-container--classic .select2-dropdown {\n  background-color: white;\n  border: 1px solid transparent; }\n\n.select2-container--classic .select2-dropdown--above {\n  border-bottom: none; }\n\n.select2-container--classic .select2-dropdown--below {\n  border-top: none; }\n\n.select2-container--classic .select2-results > .select2-results__options {\n  max-height: 200px;\n  overflow-y: auto; }\n\n.select2-container--classic .select2-results__option[role=group] {\n  padding: 0; }\n\n.select2-container--classic .select2-results__option[aria-disabled=true] {\n  color: grey; }\n\n.select2-container--classic .select2-results__option--highlighted[aria-selected] {\n  background-color: #3875d7;\n  color: white; }\n\n.select2-container--classic .select2-results__group {\n  cursor: default;\n  display: block;\n  padding: 6px; }\n\n.select2-container--classic.select2-container--open .select2-dropdown {\n  border-color: #5897fb; }\n", ""]);
	
	// exports


/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".toast-title {\n  font-weight: bold; }\n\n.toast-message {\n  -ms-word-wrap: break-word;\n  word-wrap: break-word; }\n\n.toast-message a,\n.toast-message label {\n  color: #FFFFFF; }\n\n.toast-message a:hover {\n  color: #CCCCCC;\n  text-decoration: none; }\n\n.toast-close-button {\n  position: relative;\n  right: -0.3em;\n  top: -0.3em;\n  float: right;\n  font-size: 20px;\n  font-weight: bold;\n  color: #FFFFFF;\n  -webkit-text-shadow: 0 1px 0 #ffffff;\n  text-shadow: 0 1px 0 #ffffff;\n  opacity: 0.8;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);\n  filter: alpha(opacity=80);\n  line-height: 1; }\n\n.toast-close-button:hover,\n.toast-close-button:focus {\n  color: #000000;\n  text-decoration: none;\n  cursor: pointer;\n  opacity: 0.4;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=40);\n  filter: alpha(opacity=40); }\n\n.rtl .toast-close-button {\n  left: -0.3em;\n  float: left;\n  right: 0.3em; }\n\n/*Additional properties for button version\n iOS requires the button element instead of an anchor tag.\n If you want the anchor version, it requires `href=\"#\"`.*/\nbutton.toast-close-button {\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  -webkit-appearance: none; }\n\n.toast-top-center {\n  top: 0;\n  right: 0;\n  width: 100%; }\n\n.toast-bottom-center {\n  bottom: 0;\n  right: 0;\n  width: 100%; }\n\n.toast-top-full-width {\n  top: 0;\n  right: 0;\n  width: 100%; }\n\n.toast-bottom-full-width {\n  bottom: 0;\n  right: 0;\n  width: 100%; }\n\n.toast-top-left {\n  top: 12px;\n  left: 12px; }\n\n.toast-top-right {\n  top: 12px;\n  right: 12px; }\n\n.toast-bottom-right {\n  right: 12px;\n  bottom: 12px; }\n\n.toast-bottom-left {\n  bottom: 12px;\n  left: 12px; }\n\n#toast-container {\n  position: fixed;\n  z-index: 999999;\n  pointer-events: none;\n  /*overrides*/ }\n\n#toast-container * {\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box; }\n\n#toast-container > div {\n  position: relative;\n  pointer-events: auto;\n  overflow: hidden;\n  margin: 0 0 6px;\n  padding: 15px 15px 15px 50px;\n  width: 300px;\n  -moz-border-radius: 3px 3px 3px 3px;\n  -webkit-border-radius: 3px 3px 3px 3px;\n  border-radius: 3px 3px 3px 3px;\n  background-position: 15px center;\n  background-repeat: no-repeat;\n  -moz-box-shadow: 0 0 12px #999999;\n  -webkit-box-shadow: 0 0 12px #999999;\n  box-shadow: 0 0 12px #999999;\n  color: #FFFFFF;\n  opacity: 0.8;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);\n  filter: alpha(opacity=80); }\n\n#toast-container > div.rtl {\n  direction: rtl;\n  padding: 15px 50px 15px 15px;\n  background-position: right 15px center; }\n\n#toast-container > div:hover {\n  -moz-box-shadow: 0 0 12px #000000;\n  -webkit-box-shadow: 0 0 12px #000000;\n  box-shadow: 0 0 12px #000000;\n  opacity: 1;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);\n  filter: alpha(opacity=100);\n  cursor: pointer; }\n\n#toast-container > .toast-info {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=\") !important; }\n\n#toast-container > .toast-error {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=\") !important; }\n\n#toast-container > .toast-success {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==\") !important; }\n\n#toast-container > .toast-warning {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=\") !important; }\n\n#toast-container.toast-top-center > div,\n#toast-container.toast-bottom-center > div {\n  width: 300px;\n  margin-left: auto;\n  margin-right: auto; }\n\n#toast-container.toast-top-full-width > div,\n#toast-container.toast-bottom-full-width > div {\n  width: 96%;\n  margin-left: auto;\n  margin-right: auto; }\n\n.toast {\n  background-color: #030303; }\n\n.toast-success {\n  background-color: #51A351; }\n\n.toast-error {\n  background-color: #BD362F; }\n\n.toast-info {\n  background-color: #2F96B4; }\n\n.toast-warning {\n  background-color: #F89406; }\n\n.toast-progress {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 4px;\n  background-color: #000000;\n  opacity: 0.4;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=40);\n  filter: alpha(opacity=40); }\n\n/*Responsive Design*/\n@media all and (max-width: 240px) {\n  #toast-container > div {\n    padding: 8px 8px 8px 50px;\n    width: 11em; }\n  #toast-container > div.rtl {\n    padding: 8px 50px 8px 8px; }\n  #toast-container .toast-close-button {\n    right: -0.2em;\n    top: -0.2em; }\n  #toast-container .rtl .toast-close-button {\n    left: -0.2em;\n    right: 0.2em; } }\n\n@media all and (min-width: 241px) and (max-width: 480px) {\n  #toast-container > div {\n    padding: 8px 8px 8px 50px;\n    width: 18em; }\n  #toast-container > div.rtl {\n    padding: 8px 50px 8px 8px; }\n  #toast-container .toast-close-button {\n    right: -0.2em;\n    top: -0.2em; }\n  #toast-container .rtl .toast-close-button {\n    left: -0.2em;\n    right: 0.2em; } }\n\n@media all and (min-width: 481px) and (max-width: 768px) {\n  #toast-container > div {\n    padding: 15px 15px 15px 50px;\n    width: 25em; }\n  #toast-container > div.rtl {\n    padding: 15px 50px 15px 15px; } }\n", ""]);
	
	// exports


/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".daterangepicker {\n  position: absolute;\n  color: inherit;\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n  width: 278px;\n  max-width: none;\n  padding: 0;\n  margin-top: 7px;\n  top: 100px;\n  left: 20px;\n  z-index: 3001;\n  display: none;\n  font-family: arial;\n  font-size: 15px;\n  line-height: 1em; }\n\n.daterangepicker:before, .daterangepicker:after {\n  position: absolute;\n  display: inline-block;\n  border-bottom-color: rgba(0, 0, 0, 0.2);\n  content: ''; }\n\n.daterangepicker:before {\n  top: -7px;\n  border-right: 7px solid transparent;\n  border-left: 7px solid transparent;\n  border-bottom: 7px solid #ccc; }\n\n.daterangepicker:after {\n  top: -6px;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid #fff;\n  border-left: 6px solid transparent; }\n\n.daterangepicker.opensleft:before {\n  right: 9px; }\n\n.daterangepicker.opensleft:after {\n  right: 10px; }\n\n.daterangepicker.openscenter:before {\n  left: 0;\n  right: 0;\n  width: 0;\n  margin-left: auto;\n  margin-right: auto; }\n\n.daterangepicker.openscenter:after {\n  left: 0;\n  right: 0;\n  width: 0;\n  margin-left: auto;\n  margin-right: auto; }\n\n.daterangepicker.opensright:before {\n  left: 9px; }\n\n.daterangepicker.opensright:after {\n  left: 10px; }\n\n.daterangepicker.drop-up {\n  margin-top: -7px; }\n\n.daterangepicker.drop-up:before {\n  top: initial;\n  bottom: -7px;\n  border-bottom: initial;\n  border-top: 7px solid #ccc; }\n\n.daterangepicker.drop-up:after {\n  top: initial;\n  bottom: -6px;\n  border-bottom: initial;\n  border-top: 6px solid #fff; }\n\n.daterangepicker.single .daterangepicker .ranges, .daterangepicker.single .drp-calendar {\n  float: none; }\n\n.daterangepicker.single .drp-selected {\n  display: none; }\n\n.daterangepicker.show-calendar .drp-calendar {\n  display: block; }\n\n.daterangepicker.show-calendar .drp-buttons {\n  display: block; }\n\n.daterangepicker.auto-apply .drp-buttons {\n  display: none; }\n\n.daterangepicker .drp-calendar {\n  display: none;\n  max-width: 270px; }\n\n.daterangepicker .drp-calendar.left {\n  padding: 8px 0 8px 8px; }\n\n.daterangepicker .drp-calendar.right {\n  padding: 8px; }\n\n.daterangepicker .drp-calendar.single .calendar-table {\n  border: none; }\n\n.daterangepicker .calendar-table .next span, .daterangepicker .calendar-table .prev span {\n  color: #fff;\n  border: solid black;\n  border-width: 0 2px 2px 0;\n  border-radius: 0;\n  display: inline-block;\n  padding: 3px; }\n\n.daterangepicker .calendar-table .next span {\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg); }\n\n.daterangepicker .calendar-table .prev span {\n  transform: rotate(135deg);\n  -webkit-transform: rotate(135deg); }\n\n.daterangepicker .calendar-table th, .daterangepicker .calendar-table td {\n  white-space: nowrap;\n  text-align: center;\n  vertical-align: middle;\n  min-width: 32px;\n  width: 32px;\n  height: 24px;\n  line-height: 24px;\n  font-size: 12px;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  cursor: pointer; }\n\n.daterangepicker .calendar-table {\n  border: 1px solid #fff;\n  border-radius: 4px;\n  background-color: #fff; }\n\n.daterangepicker .calendar-table table {\n  width: 100%;\n  margin: 0;\n  border-spacing: 0;\n  border-collapse: collapse; }\n\n.daterangepicker td.available:hover, .daterangepicker th.available:hover {\n  background-color: #eee;\n  border-color: transparent;\n  color: inherit; }\n\n.daterangepicker td.week, .daterangepicker th.week {\n  font-size: 80%;\n  color: #ccc; }\n\n.daterangepicker td.off, .daterangepicker td.off.in-range, .daterangepicker td.off.start-date, .daterangepicker td.off.end-date {\n  background-color: #fff;\n  border-color: transparent;\n  color: #999; }\n\n.daterangepicker td.in-range {\n  background-color: #ebf4f8;\n  border-color: transparent;\n  color: #000;\n  border-radius: 0; }\n\n.daterangepicker td.start-date {\n  border-radius: 4px 0 0 4px; }\n\n.daterangepicker td.end-date {\n  border-radius: 0 4px 4px 0; }\n\n.daterangepicker td.start-date.end-date {\n  border-radius: 4px; }\n\n.daterangepicker td.active, .daterangepicker td.active:hover {\n  background-color: #357ebd;\n  border-color: transparent;\n  color: #fff; }\n\n.daterangepicker th.month {\n  width: auto; }\n\n.daterangepicker td.disabled, .daterangepicker option.disabled {\n  color: #999;\n  cursor: not-allowed;\n  text-decoration: line-through; }\n\n.daterangepicker select.monthselect, .daterangepicker select.yearselect {\n  font-size: 12px;\n  padding: 1px;\n  height: auto;\n  margin: 0;\n  cursor: default; }\n\n.daterangepicker select.monthselect {\n  margin-right: 2%;\n  width: 56%; }\n\n.daterangepicker select.yearselect {\n  width: 40%; }\n\n.daterangepicker select.hourselect, .daterangepicker select.minuteselect, .daterangepicker select.secondselect, .daterangepicker select.ampmselect {\n  width: 50px;\n  margin: 0 auto;\n  background: #eee;\n  border: 1px solid #eee;\n  padding: 2px;\n  outline: 0;\n  font-size: 12px; }\n\n.daterangepicker .calendar-time {\n  text-align: center;\n  margin: 4px auto 0 auto;\n  line-height: 30px;\n  position: relative; }\n\n.daterangepicker .calendar-time select.disabled {\n  color: #ccc;\n  cursor: not-allowed; }\n\n.daterangepicker .drp-buttons {\n  clear: both;\n  text-align: right;\n  padding: 8px;\n  border-top: 1px solid #ddd;\n  display: none;\n  line-height: 12px;\n  vertical-align: middle; }\n\n.daterangepicker .drp-selected {\n  display: inline-block;\n  font-size: 12px;\n  padding-right: 8px; }\n\n.daterangepicker .drp-buttons .btn {\n  margin-left: 8px;\n  font-size: 12px;\n  font-weight: bold;\n  padding: 4px 8px; }\n\n.daterangepicker.show-ranges.single.rtl .drp-calendar.left {\n  border-right: 1px solid #ddd; }\n\n.daterangepicker.show-ranges.single.ltr .drp-calendar.left {\n  border-left: 1px solid #ddd; }\n\n.daterangepicker.show-ranges.rtl .drp-calendar.right {\n  border-right: 1px solid #ddd; }\n\n.daterangepicker.show-ranges.ltr .drp-calendar.left {\n  border-left: 1px solid #ddd; }\n\n.daterangepicker .ranges {\n  float: none;\n  text-align: left;\n  margin: 0; }\n\n.daterangepicker.show-calendar .ranges {\n  margin-top: 8px; }\n\n.daterangepicker .ranges ul {\n  list-style: none;\n  margin: 0 auto;\n  padding: 0;\n  width: 100%; }\n\n.daterangepicker .ranges li {\n  font-size: 12px;\n  padding: 8px 12px;\n  cursor: pointer; }\n\n.daterangepicker .ranges li:hover {\n  background-color: #eee; }\n\n.daterangepicker .ranges li.active {\n  background-color: #08c;\n  color: #fff; }\n\n/*  Larger Screen Styling */\n@media (min-width: 564px) {\n  .daterangepicker {\n    width: auto; }\n  .daterangepicker .ranges ul {\n    width: 140px; }\n  .daterangepicker.single .ranges ul {\n    width: 100%; }\n  .daterangepicker.single .drp-calendar.left {\n    clear: none; }\n  .daterangepicker.single .ranges, .daterangepicker.single .drp-calendar {\n    float: left; }\n  .daterangepicker {\n    direction: ltr;\n    text-align: left; }\n  .daterangepicker .drp-calendar.left {\n    clear: left;\n    margin-right: 0; }\n  .daterangepicker .drp-calendar.left .calendar-table {\n    border-right: none;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0; }\n  .daterangepicker .drp-calendar.right {\n    margin-left: 0; }\n  .daterangepicker .drp-calendar.right .calendar-table {\n    border-left: none;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0; }\n  .daterangepicker .drp-calendar.left .calendar-table {\n    padding-right: 8px; }\n  .daterangepicker .ranges, .daterangepicker .drp-calendar {\n    float: left; } }\n\n@media (min-width: 730px) {\n  .daterangepicker .ranges {\n    width: auto; }\n  .daterangepicker .ranges {\n    float: left; }\n  .daterangepicker.rtl .ranges {\n    float: right; }\n  .daterangepicker .drp-calendar.left {\n    clear: none !important; } }\n", ""]);
	
	// exports


/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * FullCalendar v3.10.5\n * Docs & License: https://fullcalendar.io/\n * (c) 2019 Adam Shaw\n */\n.fc {\n  direction: ltr;\n  text-align: left; }\n\n.fc-rtl {\n  text-align: right; }\n\nbody .fc {\n  /* extra precedence to overcome jqui */\n  font-size: 1em; }\n\n/* Colors\n--------------------------------------------------------------------------------------------------*/\n.fc-highlight {\n  /* when user is selecting cells */\n  background: #bce8f1;\n  opacity: .3; }\n\n.fc-bgevent {\n  /* default look for background events */\n  background: #8fdf82;\n  opacity: .3; }\n\n.fc-nonbusiness {\n  /* default look for non-business-hours areas */\n  /* will inherit .fc-bgevent's styles */\n  background: #d7d7d7; }\n\n/* Buttons (styled <button> tags, normalized to work cross-browser)\n--------------------------------------------------------------------------------------------------*/\n.fc button {\n  /* force height to include the border and padding */\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  /* dimensions */\n  margin: 0;\n  height: 2.1em;\n  padding: 0 .6em;\n  /* text & cursor */\n  font-size: 1em;\n  /* normalize */\n  white-space: nowrap;\n  cursor: pointer; }\n\n/* Firefox has an annoying inner border */\n.fc button::-moz-focus-inner {\n  margin: 0;\n  padding: 0; }\n\n.fc-state-default {\n  /* non-theme */\n  border: 1px solid; }\n\n.fc-state-default.fc-corner-left {\n  /* non-theme */\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px; }\n\n.fc-state-default.fc-corner-right {\n  /* non-theme */\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px; }\n\n/* icons in buttons */\n.fc button .fc-icon {\n  /* non-theme */\n  position: relative;\n  top: -0.05em;\n  /* seems to be a good adjustment across browsers */\n  margin: 0 .2em;\n  vertical-align: middle; }\n\n/*\n  button states\n  borrowed from twitter bootstrap (http://twitter.github.com/bootstrap/)\n*/\n.fc-state-default {\n  background-color: #f5f5f5;\n  background-image: -moz-linear-gradient(top, #ffffff, #e6e6e6);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#ffffff), to(#e6e6e6));\n  background-image: -webkit-linear-gradient(top, #ffffff, #e6e6e6);\n  background-image: -o-linear-gradient(top, #ffffff, #e6e6e6);\n  background-image: linear-gradient(to bottom, #ffffff, #e6e6e6);\n  background-repeat: repeat-x;\n  border-color: #e6e6e6 #e6e6e6 #bfbfbf;\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n  color: #333;\n  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05); }\n\n.fc-state-hover,\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n  color: #333333;\n  background-color: #e6e6e6; }\n\n.fc-state-hover {\n  color: #333333;\n  text-decoration: none;\n  background-position: 0 -15px;\n  -webkit-transition: background-position 0.1s linear;\n  -moz-transition: background-position 0.1s linear;\n  -o-transition: background-position 0.1s linear;\n  transition: background-position 0.1s linear; }\n\n.fc-state-down,\n.fc-state-active {\n  background-color: #cccccc;\n  background-image: none;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05); }\n\n.fc-state-disabled {\n  cursor: default;\n  background-image: none;\n  opacity: 0.65;\n  box-shadow: none; }\n\n/* Buttons Groups\n--------------------------------------------------------------------------------------------------*/\n.fc-button-group {\n  display: inline-block; }\n\n/*\nevery button that is not first in a button group should scootch over one pixel and cover the\nprevious button's border...\n*/\n.fc .fc-button-group > * {\n  /* extra precedence b/c buttons have margin set to zero */\n  float: left;\n  margin: 0 0 0 -1px; }\n\n.fc .fc-button-group > :first-child {\n  /* same */\n  margin-left: 0; }\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n.fc-popover {\n  position: absolute;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15); }\n\n.fc-popover .fc-header {\n  /* TODO: be more consistent with fc-head/fc-body */\n  padding: 2px 4px; }\n\n.fc-popover .fc-header .fc-title {\n  margin: 0 2px; }\n\n.fc-popover .fc-header .fc-close {\n  cursor: pointer; }\n\n.fc-ltr .fc-popover .fc-header .fc-title,\n.fc-rtl .fc-popover .fc-header .fc-close {\n  float: left; }\n\n.fc-rtl .fc-popover .fc-header .fc-title,\n.fc-ltr .fc-popover .fc-header .fc-close {\n  float: right; }\n\n/* Misc Reusable Components\n--------------------------------------------------------------------------------------------------*/\n.fc-divider {\n  border-style: solid;\n  border-width: 1px; }\n\nhr.fc-divider {\n  height: 0;\n  margin: 0;\n  padding: 0 0 2px;\n  /* height is unreliable across browsers, so use padding */\n  border-width: 1px 0; }\n\n.fc-clear {\n  clear: both; }\n\n.fc-bg,\n.fc-bgevent-skeleton,\n.fc-highlight-skeleton,\n.fc-helper-skeleton {\n  /* these element should always cling to top-left/right corners */\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0; }\n\n.fc-bg {\n  bottom: 0;\n  /* strech bg to bottom edge */ }\n\n.fc-bg table {\n  height: 100%;\n  /* strech bg to bottom edge */ }\n\n/* Tables\n--------------------------------------------------------------------------------------------------*/\n.fc table {\n  width: 100%;\n  box-sizing: border-box;\n  /* fix scrollbar issue in firefox */\n  table-layout: fixed;\n  border-collapse: collapse;\n  border-spacing: 0;\n  font-size: 1em;\n  /* normalize cross-browser */ }\n\n.fc th {\n  text-align: center; }\n\n.fc th,\n.fc td {\n  border-style: solid;\n  border-width: 1px;\n  padding: 0;\n  vertical-align: top; }\n\n.fc td.fc-today {\n  border-style: double;\n  /* overcome neighboring borders */ }\n\n/* Internal Nav Links\n--------------------------------------------------------------------------------------------------*/\na[data-goto] {\n  cursor: pointer; }\n\na[data-goto]:hover {\n  text-decoration: underline; }\n\n/* Fake Table Rows\n--------------------------------------------------------------------------------------------------*/\n.fc .fc-row {\n  /* extra precedence to overcome themes w/ .ui-widget-content forcing a 1px border */\n  /* no visible border by default. but make available if need be (scrollbar width compensation) */\n  border-style: solid;\n  border-width: 0; }\n\n.fc-row table {\n  /* don't put left/right border on anything within a fake row.\n     the outer tbody will worry about this */\n  border-left: 0 hidden transparent;\n  border-right: 0 hidden transparent;\n  /* no bottom borders on rows */\n  border-bottom: 0 hidden transparent; }\n\n.fc-row:first-child table {\n  border-top: 0 hidden transparent;\n  /* no top border on first row */ }\n\n/* Day Row (used within the header and the DayGrid)\n--------------------------------------------------------------------------------------------------*/\n.fc-row {\n  position: relative; }\n\n.fc-row .fc-bg {\n  z-index: 1; }\n\n/* highlighting cells & background event skeleton */\n.fc-row .fc-bgevent-skeleton,\n.fc-row .fc-highlight-skeleton {\n  bottom: 0;\n  /* stretch skeleton to bottom of row */ }\n\n.fc-row .fc-bgevent-skeleton table,\n.fc-row .fc-highlight-skeleton table {\n  height: 100%;\n  /* stretch skeleton to bottom of row */ }\n\n.fc-row .fc-highlight-skeleton td,\n.fc-row .fc-bgevent-skeleton td {\n  border-color: transparent; }\n\n.fc-row .fc-bgevent-skeleton {\n  z-index: 2; }\n\n.fc-row .fc-highlight-skeleton {\n  z-index: 3; }\n\n/*\nrow content (which contains day/week numbers and events) as well as \"helper\" (which contains\ntemporary rendered events).\n*/\n.fc-row .fc-content-skeleton {\n  position: relative;\n  z-index: 4;\n  padding-bottom: 2px;\n  /* matches the space above the events */ }\n\n.fc-row .fc-helper-skeleton {\n  z-index: 5; }\n\n.fc .fc-row .fc-content-skeleton table,\n.fc .fc-row .fc-content-skeleton td,\n.fc .fc-row .fc-helper-skeleton td {\n  /* see-through to the background below */\n  /* extra precedence to prevent theme-provided backgrounds */\n  background: none;\n  /* in case <td>s are globally styled */\n  border-color: transparent; }\n\n.fc-row .fc-content-skeleton td,\n.fc-row .fc-helper-skeleton td {\n  /* don't put a border between events and/or the day number */\n  border-bottom: 0; }\n\n.fc-row .fc-content-skeleton tbody td,\n.fc-row .fc-helper-skeleton tbody td {\n  /* don't put a border between event cells */\n  border-top: 0; }\n\n/* Scrolling Container\n--------------------------------------------------------------------------------------------------*/\n.fc-scroller {\n  -webkit-overflow-scrolling: touch; }\n\n/* TODO: move to agenda/basic */\n.fc-scroller > .fc-day-grid,\n.fc-scroller > .fc-time-grid {\n  position: relative;\n  /* re-scope all positions */\n  width: 100%;\n  /* hack to force re-sizing this inner element when scrollbars appear/disappear */ }\n\n/* Global Event Styles\n--------------------------------------------------------------------------------------------------*/\n.fc-event {\n  position: relative;\n  /* for resize handle and other inner positioning */\n  display: block;\n  /* make the <a> tag block */\n  font-size: .85em;\n  line-height: 1.3;\n  border-radius: 3px;\n  border: 1px solid #3a87ad;\n  /* default BORDER color */ }\n\n.fc-event,\n.fc-event-dot {\n  background-color: #3a87ad;\n  /* default BACKGROUND color */ }\n\n.fc-event,\n.fc-event:hover {\n  color: #fff;\n  /* default TEXT color */\n  text-decoration: none;\n  /* if <a> has an href */ }\n\n.fc-event[href],\n.fc-event.fc-draggable {\n  cursor: pointer;\n  /* give events with links and draggable events a hand mouse pointer */ }\n\n.fc-not-allowed,\n.fc-not-allowed .fc-event {\n  /* to override an event's custom cursor */\n  cursor: not-allowed; }\n\n.fc-event .fc-bg {\n  /* the generic .fc-bg already does position */\n  z-index: 1;\n  background: #fff;\n  opacity: .25; }\n\n.fc-event .fc-content {\n  position: relative;\n  z-index: 2; }\n\n/* resizer (cursor AND touch devices) */\n.fc-event .fc-resizer {\n  position: absolute;\n  z-index: 4; }\n\n/* resizer (touch devices) */\n.fc-event .fc-resizer {\n  display: none; }\n\n.fc-event.fc-allow-mouse-resize .fc-resizer,\n.fc-event.fc-selected .fc-resizer {\n  /* only show when hovering or selected (with touch) */\n  display: block; }\n\n/* hit area */\n.fc-event.fc-selected .fc-resizer:before {\n  /* 40x40 touch area */\n  content: \"\";\n  position: absolute;\n  z-index: 9999;\n  /* user of this util can scope within a lower z-index */\n  top: 50%;\n  left: 50%;\n  width: 40px;\n  height: 40px;\n  margin-left: -20px;\n  margin-top: -20px; }\n\n/* Event Selection (only for touch devices)\n--------------------------------------------------------------------------------------------------*/\n.fc-event.fc-selected {\n  z-index: 9999 !important;\n  /* overcomes inline z-index */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); }\n\n.fc-event.fc-selected.fc-dragging {\n  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.3); }\n\n/* Horizontal Events\n--------------------------------------------------------------------------------------------------*/\n/* bigger touch area when selected */\n.fc-h-event.fc-selected:before {\n  content: \"\";\n  position: absolute;\n  z-index: 3;\n  /* below resizers */\n  top: -10px;\n  bottom: -10px;\n  left: 0;\n  right: 0; }\n\n/* events that are continuing to/from another week. kill rounded corners and butt up against edge */\n.fc-ltr .fc-h-event.fc-not-start,\n.fc-rtl .fc-h-event.fc-not-end {\n  margin-left: 0;\n  border-left-width: 0;\n  padding-left: 1px;\n  /* replace the border with padding */\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.fc-ltr .fc-h-event.fc-not-end,\n.fc-rtl .fc-h-event.fc-not-start {\n  margin-right: 0;\n  border-right-width: 0;\n  padding-right: 1px;\n  /* replace the border with padding */\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0; }\n\n/* resizer (cursor AND touch devices) */\n/* left resizer  */\n.fc-ltr .fc-h-event .fc-start-resizer,\n.fc-rtl .fc-h-event .fc-end-resizer {\n  cursor: w-resize;\n  left: -1px;\n  /* overcome border */ }\n\n/* right resizer */\n.fc-ltr .fc-h-event .fc-end-resizer,\n.fc-rtl .fc-h-event .fc-start-resizer {\n  cursor: e-resize;\n  right: -1px;\n  /* overcome border */ }\n\n/* resizer (mouse devices) */\n.fc-h-event.fc-allow-mouse-resize .fc-resizer {\n  width: 7px;\n  top: -1px;\n  /* overcome top border */\n  bottom: -1px;\n  /* overcome bottom border */ }\n\n/* resizer (touch devices) */\n.fc-h-event.fc-selected .fc-resizer {\n  /* 8x8 little dot */\n  border-radius: 4px;\n  border-width: 1px;\n  width: 6px;\n  height: 6px;\n  border-style: solid;\n  border-color: inherit;\n  background: #fff;\n  /* vertically center */\n  top: 50%;\n  margin-top: -4px; }\n\n/* left resizer  */\n.fc-ltr .fc-h-event.fc-selected .fc-start-resizer,\n.fc-rtl .fc-h-event.fc-selected .fc-end-resizer {\n  margin-left: -4px;\n  /* centers the 8x8 dot on the left edge */ }\n\n/* right resizer */\n.fc-ltr .fc-h-event.fc-selected .fc-end-resizer,\n.fc-rtl .fc-h-event.fc-selected .fc-start-resizer {\n  margin-right: -4px;\n  /* centers the 8x8 dot on the right edge */ }\n\n/* DayGrid events\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-day-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n.fc-day-grid-event {\n  margin: 1px 2px 0;\n  /* spacing between events and edges */\n  padding: 0 1px; }\n\ntr:first-child > td > .fc-day-grid-event {\n  margin-top: 2px;\n  /* a little bit more space before the first event */ }\n\n.fc-day-grid-event.fc-selected:after {\n  content: \"\";\n  position: absolute;\n  z-index: 1;\n  /* same z-index as fc-bg, behind text */\n  /* overcome the borders */\n  top: -1px;\n  right: -1px;\n  bottom: -1px;\n  left: -1px;\n  /* darkening effect */\n  background: #000;\n  opacity: .25; }\n\n.fc-day-grid-event .fc-content {\n  /* force events to be one-line tall */\n  white-space: nowrap;\n  overflow: hidden; }\n\n.fc-day-grid-event .fc-time {\n  font-weight: bold; }\n\n/* resizer (cursor devices) */\n/* left resizer  */\n.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer,\n.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer {\n  margin-left: -2px;\n  /* to the day cell's edge */ }\n\n/* right resizer */\n.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer,\n.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer {\n  margin-right: -2px;\n  /* to the day cell's edge */ }\n\n/* Event Limiting\n--------------------------------------------------------------------------------------------------*/\n/* \"more\" link that represents hidden events */\na.fc-more {\n  margin: 1px 3px;\n  font-size: .85em;\n  cursor: pointer;\n  text-decoration: none; }\n\na.fc-more:hover {\n  text-decoration: underline; }\n\n.fc-limited {\n  /* rows and cells that are hidden because of a \"more\" link */\n  display: none; }\n\n/* popover that appears when \"more\" link is clicked */\n.fc-day-grid .fc-row {\n  z-index: 1;\n  /* make the \"more\" popover one higher than this */ }\n\n.fc-more-popover {\n  z-index: 2;\n  width: 220px; }\n\n.fc-more-popover .fc-event-container {\n  padding: 10px; }\n\n/* Now Indicator\n--------------------------------------------------------------------------------------------------*/\n.fc-now-indicator {\n  position: absolute;\n  border: 0 solid red; }\n\n/* Utilities\n--------------------------------------------------------------------------------------------------*/\n.fc-unselectable {\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent; }\n\n/*\nTODO: more distinction between this file and common.css\n*/\n/* Colors\n--------------------------------------------------------------------------------------------------*/\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-content,\n.fc-unthemed .fc-popover,\n.fc-unthemed .fc-list-view,\n.fc-unthemed .fc-list-heading td {\n  border-color: #ddd; }\n\n.fc-unthemed .fc-popover {\n  background-color: #fff; }\n\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-popover .fc-header,\n.fc-unthemed .fc-list-heading td {\n  background: #eee; }\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n  color: #666; }\n\n.fc-unthemed td.fc-today {\n  background: #fcf8e3; }\n\n.fc-unthemed .fc-disabled-day {\n  background: #d7d7d7;\n  opacity: .3; }\n\n/* Icons (inline elements with styled text that mock arrow icons)\n--------------------------------------------------------------------------------------------------*/\n.fc-icon {\n  display: inline-block;\n  height: 1em;\n  line-height: 1em;\n  font-size: 1em;\n  text-align: center;\n  overflow: hidden;\n  font-family: \"Courier New\", Courier, monospace;\n  /* don't allow browser text-selection */\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n/*\nAcceptable font-family overrides for individual icons:\n  \"Arial\", sans-serif\n  \"Times New Roman\", serif\n\nNOTE: use percentage font sizes or else old IE chokes\n*/\n.fc-icon:after {\n  position: relative; }\n\n.fc-icon-left-single-arrow:after {\n  content: \"\\2039\";\n  font-weight: bold;\n  font-size: 200%;\n  top: -7%; }\n\n.fc-icon-right-single-arrow:after {\n  content: \"\\203A\";\n  font-weight: bold;\n  font-size: 200%;\n  top: -7%; }\n\n.fc-icon-left-double-arrow:after {\n  content: \"\\AB\";\n  font-size: 160%;\n  top: -7%; }\n\n.fc-icon-right-double-arrow:after {\n  content: \"\\BB\";\n  font-size: 160%;\n  top: -7%; }\n\n.fc-icon-left-triangle:after {\n  content: \"\\25C4\";\n  font-size: 125%;\n  top: 3%; }\n\n.fc-icon-right-triangle:after {\n  content: \"\\25BA\";\n  font-size: 125%;\n  top: 3%; }\n\n.fc-icon-down-triangle:after {\n  content: \"\\25BC\";\n  font-size: 125%;\n  top: 2%; }\n\n.fc-icon-x:after {\n  content: \"\\D7\";\n  font-size: 200%;\n  top: 6%; }\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n.fc-unthemed .fc-popover {\n  border-width: 1px;\n  border-style: solid; }\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n  font-size: .9em;\n  margin-top: 2px; }\n\n/* List View\n--------------------------------------------------------------------------------------------------*/\n.fc-unthemed .fc-list-item:hover td {\n  background-color: #f5f5f5; }\n\n/* Colors\n--------------------------------------------------------------------------------------------------*/\n.ui-widget .fc-disabled-day {\n  background-image: none; }\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n.fc-popover > .ui-widget-header + .ui-widget-content {\n  border-top: 0;\n  /* where they meet, let the header have the border */ }\n\n/* Global Event Styles\n--------------------------------------------------------------------------------------------------*/\n.ui-widget .fc-event {\n  /* overpower jqui's styles on <a> tags. TODO: more DRY */\n  color: #fff;\n  /* default TEXT color */\n  text-decoration: none;\n  /* if <a> has an href */\n  /* undo ui-widget-header bold */\n  font-weight: normal; }\n\n/* TimeGrid axis running down the side (for both the all-day area and the slot area)\n--------------------------------------------------------------------------------------------------*/\n.ui-widget td.fc-axis {\n  font-weight: normal;\n  /* overcome bold */ }\n\n/* TimeGrid Slats (lines that run horizontally)\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-slats .ui-widget-content {\n  background: none;\n  /* see through to fc-bg */ }\n\n.fc.fc-bootstrap3 a {\n  text-decoration: none; }\n\n.fc.fc-bootstrap3 a[data-goto]:hover {\n  text-decoration: underline; }\n\n.fc-bootstrap3 hr.fc-divider {\n  border-color: inherit; }\n\n.fc-bootstrap3 .fc-today.alert {\n  border-radius: 0; }\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n.fc-bootstrap3 .fc-popover .panel-body {\n  padding: 0; }\n\n/* TimeGrid Slats (lines that run horizontally)\n--------------------------------------------------------------------------------------------------*/\n.fc-bootstrap3 .fc-time-grid .fc-slats table {\n  /* some themes have background color. see through to slats */\n  background: none; }\n\n.fc.fc-bootstrap4 a {\n  text-decoration: none; }\n\n.fc.fc-bootstrap4 a[data-goto]:hover {\n  text-decoration: underline; }\n\n.fc-bootstrap4 hr.fc-divider {\n  border-color: inherit; }\n\n.fc-bootstrap4 .fc-today.alert {\n  border-radius: 0; }\n\n.fc-bootstrap4 a.fc-event:not([href]):not([tabindex]) {\n  color: #fff; }\n\n.fc-bootstrap4 .fc-popover.card {\n  position: absolute; }\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n.fc-bootstrap4 .fc-popover .card-body {\n  padding: 0; }\n\n/* TimeGrid Slats (lines that run horizontally)\n--------------------------------------------------------------------------------------------------*/\n.fc-bootstrap4 .fc-time-grid .fc-slats table {\n  /* some themes have background color. see through to slats */\n  background: none; }\n\n/* Toolbar\n--------------------------------------------------------------------------------------------------*/\n.fc-toolbar {\n  text-align: center; }\n\n.fc-toolbar.fc-header-toolbar {\n  margin-bottom: 1em; }\n\n.fc-toolbar.fc-footer-toolbar {\n  margin-top: 1em; }\n\n.fc-toolbar .fc-left {\n  float: left; }\n\n.fc-toolbar .fc-right {\n  float: right; }\n\n.fc-toolbar .fc-center {\n  display: inline-block; }\n\n/* the things within each left/right/center section */\n.fc .fc-toolbar > * > * {\n  /* extra precedence to override button border margins */\n  float: left;\n  margin-left: .75em; }\n\n/* the first thing within each left/center/right section */\n.fc .fc-toolbar > * > :first-child {\n  /* extra precedence to override button border margins */\n  margin-left: 0; }\n\n/* title text */\n.fc-toolbar h2 {\n  margin: 0; }\n\n/* button layering (for border precedence) */\n.fc-toolbar button {\n  position: relative; }\n\n.fc-toolbar .fc-state-hover,\n.fc-toolbar .ui-state-hover {\n  z-index: 2; }\n\n.fc-toolbar .fc-state-down {\n  z-index: 3; }\n\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active {\n  z-index: 4; }\n\n.fc-toolbar button:focus {\n  z-index: 5; }\n\n/* View Structure\n--------------------------------------------------------------------------------------------------*/\n/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */\n/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */\n.fc-view-container *,\n.fc-view-container *:before,\n.fc-view-container *:after {\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box; }\n\n.fc-view,\n.fc-view > table {\n  /* so dragged elements can be above the view's main element */\n  position: relative;\n  z-index: 1; }\n\n/* BasicView\n--------------------------------------------------------------------------------------------------*/\n/* day row structure */\n.fc-basicWeek-view .fc-content-skeleton,\n.fc-basicDay-view .fc-content-skeleton {\n  /* there may be week numbers in these views, so no padding-top */\n  padding-bottom: 1em;\n  /* ensure a space at bottom of cell for user selecting/clicking */ }\n\n.fc-basic-view .fc-body .fc-row {\n  min-height: 4em;\n  /* ensure that all rows are at least this tall */ }\n\n/* a \"rigid\" row will take up a constant amount of height because content-skeleton is absolute */\n.fc-row.fc-rigid {\n  overflow: hidden; }\n\n.fc-row.fc-rigid .fc-content-skeleton {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0; }\n\n/* week and day number styling */\n.fc-day-top.fc-other-month {\n  opacity: 0.3; }\n\n.fc-basic-view .fc-week-number,\n.fc-basic-view .fc-day-number {\n  padding: 2px; }\n\n.fc-basic-view th.fc-week-number,\n.fc-basic-view th.fc-day-number {\n  padding: 0 2px;\n  /* column headers can't have as much v space */ }\n\n.fc-ltr .fc-basic-view .fc-day-top .fc-day-number {\n  float: right; }\n\n.fc-rtl .fc-basic-view .fc-day-top .fc-day-number {\n  float: left; }\n\n.fc-ltr .fc-basic-view .fc-day-top .fc-week-number {\n  float: left;\n  border-radius: 0 0 3px 0; }\n\n.fc-rtl .fc-basic-view .fc-day-top .fc-week-number {\n  float: right;\n  border-radius: 0 0 0 3px; }\n\n.fc-basic-view .fc-day-top .fc-week-number {\n  min-width: 1.5em;\n  text-align: center;\n  background-color: #f2f2f2;\n  color: #808080; }\n\n/* when week/day number have own column */\n.fc-basic-view td.fc-week-number {\n  text-align: center; }\n\n.fc-basic-view td.fc-week-number > * {\n  /* work around the way we do column resizing and ensure a minimum width */\n  display: inline-block;\n  min-width: 1.25em; }\n\n/* AgendaView all-day area\n--------------------------------------------------------------------------------------------------*/\n.fc-agenda-view .fc-day-grid {\n  position: relative;\n  z-index: 2;\n  /* so the \"more..\" popover will be over the time grid */ }\n\n.fc-agenda-view .fc-day-grid .fc-row {\n  min-height: 3em;\n  /* all-day section will never get shorter than this */ }\n\n.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton {\n  padding-bottom: 1em;\n  /* give space underneath events for clicking/selecting days */ }\n\n/* TimeGrid axis running down the side (for both the all-day area and the slot area)\n--------------------------------------------------------------------------------------------------*/\n.fc .fc-axis {\n  /* .fc to overcome default cell styles */\n  vertical-align: middle;\n  padding: 0 4px;\n  white-space: nowrap; }\n\n.fc-ltr .fc-axis {\n  text-align: right; }\n\n.fc-rtl .fc-axis {\n  text-align: left; }\n\n/* TimeGrid Structure\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid-container,\n.fc-time-grid {\n  /* so slats/bg/content/etc positions get scoped within here */\n  position: relative;\n  z-index: 1; }\n\n.fc-time-grid {\n  min-height: 100%;\n  /* so if height setting is 'auto', .fc-bg stretches to fill height */ }\n\n.fc-time-grid table {\n  /* don't put outer borders on slats/bg/content/etc */\n  border: 0 hidden transparent; }\n\n.fc-time-grid > .fc-bg {\n  z-index: 1; }\n\n.fc-time-grid .fc-slats,\n.fc-time-grid > hr {\n  /* the <hr> AgendaView injects when grid is shorter than scroller */\n  position: relative;\n  z-index: 2; }\n\n.fc-time-grid .fc-content-col {\n  position: relative;\n  /* because now-indicator lives directly inside */ }\n\n.fc-time-grid .fc-content-skeleton {\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  right: 0; }\n\n/* divs within a cell within the fc-content-skeleton */\n.fc-time-grid .fc-business-container {\n  position: relative;\n  z-index: 1; }\n\n.fc-time-grid .fc-bgevent-container {\n  position: relative;\n  z-index: 2; }\n\n.fc-time-grid .fc-highlight-container {\n  position: relative;\n  z-index: 3; }\n\n.fc-time-grid .fc-event-container {\n  position: relative;\n  z-index: 4; }\n\n.fc-time-grid .fc-now-indicator-line {\n  z-index: 5; }\n\n.fc-time-grid .fc-helper-container {\n  /* also is fc-event-container */\n  position: relative;\n  z-index: 6; }\n\n/* TimeGrid Slats (lines that run horizontally)\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-slats td {\n  height: 1.5em;\n  border-bottom: 0;\n  /* each cell is responsible for its top border */ }\n\n.fc-time-grid .fc-slats .fc-minor td {\n  border-top-style: dotted; }\n\n/* TimeGrid Highlighting Slots\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-highlight-container {\n  /* a div within a cell within the fc-highlight-skeleton */\n  position: relative;\n  /* scopes the left/right of the fc-highlight to be in the column */ }\n\n.fc-time-grid .fc-highlight {\n  position: absolute;\n  left: 0;\n  right: 0;\n  /* top and bottom will be in by JS */ }\n\n/* TimeGrid Event Containment\n--------------------------------------------------------------------------------------------------*/\n.fc-ltr .fc-time-grid .fc-event-container {\n  /* space on the sides of events for LTR (default) */\n  margin: 0 2.5% 0 2px; }\n\n.fc-rtl .fc-time-grid .fc-event-container {\n  /* space on the sides of events for RTL */\n  margin: 0 2px 0 2.5%; }\n\n.fc-time-grid .fc-event,\n.fc-time-grid .fc-bgevent {\n  position: absolute;\n  z-index: 1;\n  /* scope inner z-index's */ }\n\n.fc-time-grid .fc-bgevent {\n  /* background events always span full width */\n  left: 0;\n  right: 0; }\n\n/* Generic Vertical Event\n--------------------------------------------------------------------------------------------------*/\n.fc-v-event.fc-not-start {\n  /* events that are continuing from another day */\n  /* replace space made by the top border with padding */\n  border-top-width: 0;\n  padding-top: 1px;\n  /* remove top rounded corners */\n  border-top-left-radius: 0;\n  border-top-right-radius: 0; }\n\n.fc-v-event.fc-not-end {\n  /* replace space made by the top border with padding */\n  border-bottom-width: 0;\n  padding-bottom: 1px;\n  /* remove bottom rounded corners */\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0; }\n\n/* TimeGrid Event Styling\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-time-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n.fc-time-grid-event {\n  overflow: hidden;\n  /* don't let the bg flow over rounded corners */ }\n\n.fc-time-grid-event.fc-selected {\n  /* need to allow touch resizers to extend outside event's bounding box */\n  /* common fc-selected styles hide the fc-bg, so don't need this anyway */\n  overflow: visible; }\n\n.fc-time-grid-event.fc-selected .fc-bg {\n  display: none;\n  /* hide semi-white background, to appear darker */ }\n\n.fc-time-grid-event .fc-content {\n  overflow: hidden;\n  /* for when .fc-selected */ }\n\n.fc-time-grid-event .fc-time,\n.fc-time-grid-event .fc-title {\n  padding: 0 1px; }\n\n.fc-time-grid-event .fc-time {\n  font-size: .85em;\n  white-space: nowrap; }\n\n/* short mode, where time and title are on the same line */\n.fc-time-grid-event.fc-short .fc-content {\n  /* don't wrap to second line (now that contents will be inline) */\n  white-space: nowrap; }\n\n.fc-time-grid-event.fc-short .fc-time,\n.fc-time-grid-event.fc-short .fc-title {\n  /* put the time and title on the same line */\n  display: inline-block;\n  vertical-align: top; }\n\n.fc-time-grid-event.fc-short .fc-time span {\n  display: none;\n  /* don't display the full time text... */ }\n\n.fc-time-grid-event.fc-short .fc-time:before {\n  content: attr(data-start);\n  /* ...instead, display only the start time */ }\n\n.fc-time-grid-event.fc-short .fc-time:after {\n  content: \"\\A0-\\A0\";\n  /* seperate with a dash, wrapped in nbsp's */ }\n\n.fc-time-grid-event.fc-short .fc-title {\n  font-size: .85em;\n  /* make the title text the same size as the time */\n  padding: 0;\n  /* undo padding from above */ }\n\n/* resizer (cursor device) */\n.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer {\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 8px;\n  overflow: hidden;\n  line-height: 8px;\n  font-size: 11px;\n  font-family: monospace;\n  text-align: center;\n  cursor: s-resize; }\n\n.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer:after {\n  content: \"=\"; }\n\n/* resizer (touch device) */\n.fc-time-grid-event.fc-selected .fc-resizer {\n  /* 10x10 dot */\n  border-radius: 5px;\n  border-width: 1px;\n  width: 8px;\n  height: 8px;\n  border-style: solid;\n  border-color: inherit;\n  background: #fff;\n  /* horizontally center */\n  left: 50%;\n  margin-left: -5px;\n  /* center on the bottom edge */\n  bottom: -5px; }\n\n/* Now Indicator\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-now-indicator-line {\n  border-top-width: 1px;\n  left: 0;\n  right: 0; }\n\n/* arrow on axis */\n.fc-time-grid .fc-now-indicator-arrow {\n  margin-top: -5px;\n  /* vertically center on top coordinate */ }\n\n.fc-ltr .fc-time-grid .fc-now-indicator-arrow {\n  left: 0;\n  /* triangle pointing right... */\n  border-width: 5px 0 5px 6px;\n  border-top-color: transparent;\n  border-bottom-color: transparent; }\n\n.fc-rtl .fc-time-grid .fc-now-indicator-arrow {\n  right: 0;\n  /* triangle pointing left... */\n  border-width: 5px 6px 5px 0;\n  border-top-color: transparent;\n  border-bottom-color: transparent; }\n\n/* List View\n--------------------------------------------------------------------------------------------------*/\n/* possibly reusable */\n.fc-event-dot {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 5px; }\n\n/* view wrapper */\n.fc-rtl .fc-list-view {\n  direction: rtl;\n  /* unlike core views, leverage browser RTL */ }\n\n.fc-list-view {\n  border-width: 1px;\n  border-style: solid; }\n\n/* table resets */\n.fc .fc-list-table {\n  table-layout: auto;\n  /* for shrinkwrapping cell content */ }\n\n.fc-list-table td {\n  border-width: 1px 0 0;\n  padding: 8px 14px; }\n\n.fc-list-table tr:first-child td {\n  border-top-width: 0; }\n\n/* day headings with the list */\n.fc-list-heading {\n  border-bottom-width: 1px; }\n\n.fc-list-heading td {\n  font-weight: bold; }\n\n.fc-ltr .fc-list-heading-main {\n  float: left; }\n\n.fc-ltr .fc-list-heading-alt {\n  float: right; }\n\n.fc-rtl .fc-list-heading-main {\n  float: right; }\n\n.fc-rtl .fc-list-heading-alt {\n  float: left; }\n\n/* event list items */\n.fc-list-item.fc-has-url {\n  cursor: pointer;\n  /* whole row will be clickable */ }\n\n.fc-list-item-marker,\n.fc-list-item-time {\n  white-space: nowrap;\n  width: 1px; }\n\n/* make the dot closer to the event title */\n.fc-ltr .fc-list-item-marker {\n  padding-right: 0; }\n\n.fc-rtl .fc-list-item-marker {\n  padding-left: 0; }\n\n.fc-list-item-title a {\n  /* every event title cell has an <a> tag */\n  text-decoration: none;\n  color: inherit; }\n\n.fc-list-item-title a[href]:hover {\n  /* hover effect only on titles with hrefs */\n  text-decoration: underline; }\n\n/* message when no events */\n.fc-list-empty-wrap2 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n\n.fc-list-empty-wrap1 {\n  width: 100%;\n  height: 100%;\n  display: table; }\n\n.fc-list-empty {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center; }\n\n.fc-unthemed .fc-list-empty {\n  /* theme will provide own background */\n  background-color: #eee; }\n", ""]);
	
	// exports


/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".ui-timepicker-wrapper {\n  overflow-y: auto;\n  max-height: 150px;\n  width: auto;\n  background: #fff;\n  border: 1px solid #ddd;\n  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  outline: none;\n  z-index: 10052;\n  margin: 0; }\n\n.ui-timepicker-wrapper .ui-timepicker-list li {\n  padding-right: 20px; }\n\n.ui-timepicker-list {\n  margin: 0;\n  padding: 0;\n  list-style: none; }\n\n.ui-timepicker-duration {\n  margin-left: 5px;\n  color: #888; }\n\n.ui-timepicker-list:hover .ui-timepicker-duration {\n  color: #888; }\n\n.ui-timepicker-list li {\n  padding: 3px 0 3px 5px;\n  cursor: pointer;\n  white-space: nowrap;\n  color: #000;\n  list-style: none;\n  margin: 0; }\n\n.ui-timepicker-list:hover .ui-timepicker-selected {\n  background: #fff;\n  color: #000; }\n\nli.ui-timepicker-selected,\n.ui-timepicker-list li:hover,\n.ui-timepicker-list .ui-timepicker-selected:hover {\n  background: #1980EC;\n  color: #fff; }\n\nli.ui-timepicker-selected .ui-timepicker-duration,\n.ui-timepicker-list li:hover .ui-timepicker-duration {\n  color: #ccc; }\n\n.ui-timepicker-list li.ui-timepicker-disabled,\n.ui-timepicker-list li.ui-timepicker-disabled:hover,\n.ui-timepicker-list li.ui-timepicker-selected.ui-timepicker-disabled {\n  color: #888;\n  cursor: default; }\n\n.ui-timepicker-list li.ui-timepicker-disabled:hover,\n.ui-timepicker-list li.ui-timepicker-selected.ui-timepicker-disabled {\n  background: #f2f2f2; }\n", ""]);
	
	// exports


/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/**\n * Swiper 5.4.5\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * http://swiperjs.com\n *\n * Copyright 2014-2020 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: June 16, 2020\n */\n\n@font-face {\n  font-family: 'swiper-icons';\n  src: url(\"data:application/font-woff;charset=utf-8;base64, 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\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n}\n:root {\n  --swiper-theme-color: #007aff;\n}\n.swiper-container {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n}\n.swiper-container-vertical > .swiper-wrapper {\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  box-sizing: content-box;\n}\n.swiper-container-android .swiper-slide,\n.swiper-wrapper {\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-container-multirow > .swiper-wrapper {\n  flex-wrap: wrap;\n}\n.swiper-container-multirow-column > .swiper-wrapper {\n  flex-wrap: wrap;\n  flex-direction: column;\n}\n.swiper-container-free-mode > .swiper-wrapper {\n  transition-timing-function: ease-out;\n  margin: 0 auto;\n}\n.swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-container-autoheight,\n.swiper-container-autoheight .swiper-slide {\n  height: auto;\n}\n.swiper-container-autoheight .swiper-wrapper {\n  align-items: flex-start;\n  transition-property: transform, height;\n}\n/* 3D Effects */\n.swiper-container-3d {\n  perspective: 1200px;\n}\n.swiper-container-3d .swiper-wrapper,\n.swiper-container-3d .swiper-slide,\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom,\n.swiper-container-3d .swiper-cube-shadow {\n  transform-style: preserve-3d;\n}\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n.swiper-container-3d .swiper-slide-shadow-left {\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-right {\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-top {\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n/* CSS Mode */\n.swiper-container-css-mode > .swiper-wrapper {\n  overflow: auto;\n  scrollbar-width: none;\n  /* For Firefox */\n  -ms-overflow-style: none;\n  /* For Internet Explorer and Edge */\n}\n.swiper-container-css-mode > .swiper-wrapper::-webkit-scrollbar {\n  display: none;\n}\n.swiper-container-css-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: start start;\n}\n.swiper-container-horizontal.swiper-container-css-mode > .swiper-wrapper {\n  scroll-snap-type: x mandatory;\n}\n.swiper-container-vertical.swiper-container-css-mode > .swiper-wrapper {\n  scroll-snap-type: y mandatory;\n}\n:root {\n  --swiper-navigation-size: 44px;\n  /*\n  --swiper-navigation-color: var(--swiper-theme-color);\n  */\n}\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: 50%;\n  width: calc(var(--swiper-navigation-size) / 44 * 27);\n  height: var(--swiper-navigation-size);\n  margin-top: calc(-1 * var(--swiper-navigation-size) / 2);\n  z-index: 10;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--swiper-navigation-color, var(--swiper-theme-color));\n}\n.swiper-button-prev.swiper-button-disabled,\n.swiper-button-next.swiper-button-disabled {\n  opacity: 0.35;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-button-prev:after,\n.swiper-button-next:after {\n  font-family: swiper-icons;\n  font-size: var(--swiper-navigation-size);\n  text-transform: none !important;\n  letter-spacing: 0;\n  text-transform: none;\n  font-variant: initial;\n  line-height: 1;\n}\n.swiper-button-prev,\n.swiper-container-rtl .swiper-button-next {\n  left: 10px;\n  right: auto;\n}\n.swiper-button-prev:after,\n.swiper-container-rtl .swiper-button-next:after {\n  content: 'prev';\n}\n.swiper-button-next,\n.swiper-container-rtl .swiper-button-prev {\n  right: 10px;\n  left: auto;\n}\n.swiper-button-next:after,\n.swiper-container-rtl .swiper-button-prev:after {\n  content: 'next';\n}\n.swiper-button-prev.swiper-button-white,\n.swiper-button-next.swiper-button-white {\n  --swiper-navigation-color: #ffffff;\n}\n.swiper-button-prev.swiper-button-black,\n.swiper-button-next.swiper-button-black {\n  --swiper-navigation-color: #000000;\n}\n.swiper-button-lock {\n  display: none;\n}\n:root {\n  /*\n  --swiper-pagination-color: var(--swiper-theme-color);\n  */\n}\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  transition: 300ms opacity;\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n}\n.swiper-pagination.swiper-pagination-hidden {\n  opacity: 0;\n}\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-container-horizontal > .swiper-pagination-bullets {\n  bottom: 10px;\n  left: 0;\n  width: 100%;\n}\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transform: scale(0.33);\n  position: relative;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n  transform: scale(0.33);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n  transform: scale(0.33);\n}\n.swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  border-radius: 100%;\n  background: #000;\n  opacity: 0.2;\n}\nbutton.swiper-pagination-bullet {\n  border: none;\n  margin: 0;\n  padding: 0;\n  box-shadow: none;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n.swiper-pagination-clickable .swiper-pagination-bullet {\n  cursor: pointer;\n}\n.swiper-pagination-bullet-active {\n  opacity: 1;\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n}\n.swiper-container-vertical > .swiper-pagination-bullets {\n  right: 10px;\n  top: 50%;\n  transform: translate3d(0px, -50%, 0);\n}\n.swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 6px 0;\n  display: block;\n}\n.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8px;\n}\n.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  display: inline-block;\n  transition: 200ms transform, 200ms top;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 0 4px;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform, 200ms left;\n}\n.swiper-container-horizontal.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform, 200ms right;\n}\n/* Progress */\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute;\n}\n.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transform: scale(0);\n  transform-origin: left top;\n}\n.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  transform-origin: right top;\n}\n.swiper-container-horizontal > .swiper-pagination-progressbar,\n.swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 100%;\n  height: 4px;\n  left: 0;\n  top: 0;\n}\n.swiper-container-vertical > .swiper-pagination-progressbar,\n.swiper-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 4px;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n.swiper-pagination-white {\n  --swiper-pagination-color: #ffffff;\n}\n.swiper-pagination-black {\n  --swiper-pagination-color: #000000;\n}\n.swiper-pagination-lock {\n  display: none;\n}\n/* Scrollbar */\n.swiper-scrollbar {\n  border-radius: 10px;\n  position: relative;\n  -ms-touch-action: none;\n  background: rgba(0, 0, 0, 0.1);\n}\n.swiper-container-horizontal > .swiper-scrollbar {\n  position: absolute;\n  left: 1%;\n  bottom: 3px;\n  z-index: 50;\n  height: 5px;\n  width: 98%;\n}\n.swiper-container-vertical > .swiper-scrollbar {\n  position: absolute;\n  right: 3px;\n  top: 1%;\n  z-index: 50;\n  width: 5px;\n  height: 98%;\n}\n.swiper-scrollbar-drag {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 10px;\n  left: 0;\n  top: 0;\n}\n.swiper-scrollbar-cursor-drag {\n  cursor: move;\n}\n.swiper-scrollbar-lock {\n  display: none;\n}\n.swiper-zoom-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n.swiper-zoom-container > img,\n.swiper-zoom-container > svg,\n.swiper-zoom-container > canvas {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n.swiper-slide-zoomed {\n  cursor: move;\n}\n/* Preloader */\n:root {\n  /*\n  --swiper-preloader-color: var(--swiper-theme-color);\n  */\n}\n.swiper-lazy-preloader {\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -21px;\n  margin-top: -21px;\n  z-index: 10;\n  transform-origin: 50%;\n  animation: swiper-preloader-spin 1s infinite linear;\n  box-sizing: border-box;\n  border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));\n  border-radius: 50%;\n  border-top-color: transparent;\n}\n.swiper-lazy-preloader-white {\n  --swiper-preloader-color: #fff;\n}\n.swiper-lazy-preloader-black {\n  --swiper-preloader-color: #000;\n}\n@keyframes swiper-preloader-spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/* a11y */\n.swiper-container .swiper-notification {\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  opacity: 0;\n  z-index: -1000;\n}\n.swiper-container-fade.swiper-container-free-mode .swiper-slide {\n  transition-timing-function: ease-out;\n}\n.swiper-container-fade .swiper-slide {\n  pointer-events: none;\n  transition-property: opacity;\n}\n.swiper-container-fade .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-fade .swiper-slide-active,\n.swiper-container-fade .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-cube {\n  overflow: visible;\n}\n.swiper-container-cube .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  z-index: 1;\n  visibility: hidden;\n  transform-origin: 0 0;\n  width: 100%;\n  height: 100%;\n}\n.swiper-container-cube .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-cube.swiper-container-rtl .swiper-slide {\n  transform-origin: 100% 0;\n}\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-next,\n.swiper-container-cube .swiper-slide-prev,\n.swiper-container-cube .swiper-slide-next + .swiper-slide {\n  pointer-events: auto;\n  visibility: visible;\n}\n.swiper-container-cube .swiper-slide-shadow-top,\n.swiper-container-cube .swiper-slide-shadow-bottom,\n.swiper-container-cube .swiper-slide-shadow-left,\n.swiper-container-cube .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n.swiper-container-cube .swiper-cube-shadow {\n  position: absolute;\n  left: 0;\n  bottom: 0px;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0.6;\n  -webkit-filter: blur(50px);\n  filter: blur(50px);\n  z-index: 0;\n}\n.swiper-container-flip {\n  overflow: visible;\n}\n.swiper-container-flip .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  z-index: 1;\n}\n.swiper-container-flip .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-flip .swiper-slide-active,\n.swiper-container-flip .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-flip .swiper-slide-shadow-top,\n.swiper-container-flip .swiper-slide-shadow-bottom,\n.swiper-container-flip .swiper-slide-shadow-left,\n.swiper-container-flip .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n", ""]);
	
	// exports


/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@charset \"UTF-8\";\n.vjs-modal-dialog .vjs-modal-dialog-content, .video-js .vjs-modal-dialog, .vjs-button > .vjs-icon-placeholder:before, .video-js .vjs-big-play-button .vjs-icon-placeholder:before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.vjs-button > .vjs-icon-placeholder:before, .video-js .vjs-big-play-button .vjs-icon-placeholder:before {\n  text-align: center;\n}\n\n@font-face {\n  font-family: VideoJS;\n  src: url(data:application/font-woff;charset=utf-8;base64,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) format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-play, .video-js .vjs-play-control .vjs-icon-placeholder, .video-js .vjs-big-play-button .vjs-icon-placeholder:before {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-play:before, .video-js .vjs-play-control .vjs-icon-placeholder:before, .video-js .vjs-big-play-button .vjs-icon-placeholder:before {\n  content: \"\\F101\";\n}\n\n.vjs-icon-play-circle {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-play-circle:before {\n  content: \"\\F102\";\n}\n\n.vjs-icon-pause, .video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-pause:before, .video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder:before {\n  content: \"\\F103\";\n}\n\n.vjs-icon-volume-mute, .video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-volume-mute:before, .video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder:before {\n  content: \"\\F104\";\n}\n\n.vjs-icon-volume-low, .video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-volume-low:before, .video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder:before {\n  content: \"\\F105\";\n}\n\n.vjs-icon-volume-mid, .video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-volume-mid:before, .video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder:before {\n  content: \"\\F106\";\n}\n\n.vjs-icon-volume-high, .video-js .vjs-mute-control .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-volume-high:before, .video-js .vjs-mute-control .vjs-icon-placeholder:before {\n  content: \"\\F107\";\n}\n\n.vjs-icon-fullscreen-enter, .video-js .vjs-fullscreen-control .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-fullscreen-enter:before, .video-js .vjs-fullscreen-control .vjs-icon-placeholder:before {\n  content: \"\\F108\";\n}\n\n.vjs-icon-fullscreen-exit, .video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-fullscreen-exit:before, .video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder:before {\n  content: \"\\F109\";\n}\n\n.vjs-icon-square {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-square:before {\n  content: \"\\F10A\";\n}\n\n.vjs-icon-spinner {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-spinner:before {\n  content: \"\\F10B\";\n}\n\n.vjs-icon-subtitles, .video-js .vjs-subs-caps-button .vjs-icon-placeholder,\n.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder,\n.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder,\n.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder,\n.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder, .video-js .vjs-subtitles-button .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-subtitles:before, .video-js .vjs-subs-caps-button .vjs-icon-placeholder:before,\n.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder:before,\n.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder:before,\n.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder:before,\n.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder:before, .video-js .vjs-subtitles-button .vjs-icon-placeholder:before {\n  content: \"\\F10C\";\n}\n\n.vjs-icon-captions, .video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder,\n.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder, .video-js .vjs-captions-button .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-captions:before, .video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder:before,\n.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder:before, .video-js .vjs-captions-button .vjs-icon-placeholder:before {\n  content: \"\\F10D\";\n}\n\n.vjs-icon-chapters, .video-js .vjs-chapters-button .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-chapters:before, .video-js .vjs-chapters-button .vjs-icon-placeholder:before {\n  content: \"\\F10E\";\n}\n\n.vjs-icon-share {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-share:before {\n  content: \"\\F10F\";\n}\n\n.vjs-icon-cog {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-cog:before {\n  content: \"\\F110\";\n}\n\n.vjs-icon-circle, .vjs-seek-to-live-control .vjs-icon-placeholder, .video-js .vjs-volume-level, .video-js .vjs-play-progress {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-circle:before, .vjs-seek-to-live-control .vjs-icon-placeholder:before, .video-js .vjs-volume-level:before, .video-js .vjs-play-progress:before {\n  content: \"\\F111\";\n}\n\n.vjs-icon-circle-outline {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-circle-outline:before {\n  content: \"\\F112\";\n}\n\n.vjs-icon-circle-inner-circle {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-circle-inner-circle:before {\n  content: \"\\F113\";\n}\n\n.vjs-icon-hd {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-hd:before {\n  content: \"\\F114\";\n}\n\n.vjs-icon-cancel, .video-js .vjs-control.vjs-close-button .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-cancel:before, .video-js .vjs-control.vjs-close-button .vjs-icon-placeholder:before {\n  content: \"\\F115\";\n}\n\n.vjs-icon-replay, .video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-replay:before, .video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder:before {\n  content: \"\\F116\";\n}\n\n.vjs-icon-facebook {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-facebook:before {\n  content: \"\\F117\";\n}\n\n.vjs-icon-gplus {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-gplus:before {\n  content: \"\\F118\";\n}\n\n.vjs-icon-linkedin {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-linkedin:before {\n  content: \"\\F119\";\n}\n\n.vjs-icon-twitter {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-twitter:before {\n  content: \"\\F11A\";\n}\n\n.vjs-icon-tumblr {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-tumblr:before {\n  content: \"\\F11B\";\n}\n\n.vjs-icon-pinterest {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-pinterest:before {\n  content: \"\\F11C\";\n}\n\n.vjs-icon-audio-description, .video-js .vjs-descriptions-button .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-audio-description:before, .video-js .vjs-descriptions-button .vjs-icon-placeholder:before {\n  content: \"\\F11D\";\n}\n\n.vjs-icon-audio, .video-js .vjs-audio-button .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-audio:before, .video-js .vjs-audio-button .vjs-icon-placeholder:before {\n  content: \"\\F11E\";\n}\n\n.vjs-icon-next-item {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-next-item:before {\n  content: \"\\F11F\";\n}\n\n.vjs-icon-previous-item {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-previous-item:before {\n  content: \"\\F120\";\n}\n\n.vjs-icon-picture-in-picture-enter, .video-js .vjs-picture-in-picture-control .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-picture-in-picture-enter:before, .video-js .vjs-picture-in-picture-control .vjs-icon-placeholder:before {\n  content: \"\\F121\";\n}\n\n.vjs-icon-picture-in-picture-exit, .video-js.vjs-picture-in-picture .vjs-picture-in-picture-control .vjs-icon-placeholder {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n.vjs-icon-picture-in-picture-exit:before, .video-js.vjs-picture-in-picture .vjs-picture-in-picture-control .vjs-icon-placeholder:before {\n  content: \"\\F122\";\n}\n\n.video-js {\n  display: block;\n  vertical-align: top;\n  box-sizing: border-box;\n  color: #fff;\n  background-color: #000;\n  position: relative;\n  padding: 0;\n  font-size: 10px;\n  line-height: 1;\n  font-weight: normal;\n  font-style: normal;\n  font-family: Arial, Helvetica, sans-serif;\n  word-break: initial;\n}\n.video-js:-moz-full-screen {\n  position: absolute;\n}\n.video-js:-webkit-full-screen {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.video-js[tabindex=\"-1\"] {\n  outline: none;\n}\n\n.video-js *,\n.video-js *:before,\n.video-js *:after {\n  box-sizing: inherit;\n}\n\n.video-js ul {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  list-style-position: outside;\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.video-js.vjs-fluid,\n.video-js.vjs-16-9,\n.video-js.vjs-4-3,\n.video-js.vjs-9-16,\n.video-js.vjs-1-1 {\n  width: 100%;\n  max-width: 100%;\n}\n\n.video-js.vjs-fluid:not(.vjs-audio-only-mode),\n.video-js.vjs-16-9:not(.vjs-audio-only-mode),\n.video-js.vjs-4-3:not(.vjs-audio-only-mode),\n.video-js.vjs-9-16:not(.vjs-audio-only-mode),\n.video-js.vjs-1-1:not(.vjs-audio-only-mode) {\n  height: 0;\n}\n\n.video-js.vjs-16-9:not(.vjs-audio-only-mode) {\n  padding-top: 56.25%;\n}\n\n.video-js.vjs-4-3:not(.vjs-audio-only-mode) {\n  padding-top: 75%;\n}\n\n.video-js.vjs-9-16:not(.vjs-audio-only-mode) {\n  padding-top: 177.7777777778%;\n}\n\n.video-js.vjs-1-1:not(.vjs-audio-only-mode) {\n  padding-top: 100%;\n}\n\n.video-js.vjs-fill:not(.vjs-audio-only-mode) {\n  width: 100%;\n  height: 100%;\n}\n\n.video-js .vjs-tech {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.video-js.vjs-audio-only-mode .vjs-tech {\n  display: none;\n}\n\nbody.vjs-full-window {\n  padding: 0;\n  margin: 0;\n  height: 100%;\n}\n\n.vjs-full-window .video-js.vjs-fullscreen {\n  position: fixed;\n  overflow: hidden;\n  z-index: 1000;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.video-js.vjs-fullscreen:not(.vjs-ios-native-fs) {\n  width: 100% !important;\n  height: 100% !important;\n  padding-top: 0 !important;\n}\n\n.video-js.vjs-fullscreen.vjs-user-inactive {\n  cursor: none;\n}\n\n.vjs-hidden {\n  display: none !important;\n}\n\n.vjs-disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.video-js .vjs-offscreen {\n  height: 1px;\n  left: -9999px;\n  position: absolute;\n  top: 0;\n  width: 1px;\n}\n\n.vjs-lock-showing {\n  display: block !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n\n.vjs-no-js {\n  padding: 20px;\n  color: #fff;\n  background-color: #000;\n  font-size: 18px;\n  font-family: Arial, Helvetica, sans-serif;\n  text-align: center;\n  width: 300px;\n  height: 150px;\n  margin: 0px auto;\n}\n\n.vjs-no-js a,\n.vjs-no-js a:visited {\n  color: #66A8CC;\n}\n\n.video-js .vjs-big-play-button {\n  font-size: 3em;\n  line-height: 1.5em;\n  height: 1.63332em;\n  width: 3em;\n  display: block;\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  padding: 0;\n  cursor: pointer;\n  opacity: 1;\n  border: 0.06666em solid #fff;\n  background-color: #2B333F;\n  background-color: rgba(43, 51, 63, 0.7);\n  border-radius: 0.3em;\n  transition: all 0.4s;\n}\n.vjs-big-play-centered .vjs-big-play-button {\n  top: 50%;\n  left: 50%;\n  margin-top: -0.81666em;\n  margin-left: -1.5em;\n}\n\n.video-js:hover .vjs-big-play-button,\n.video-js .vjs-big-play-button:focus {\n  border-color: #fff;\n  background-color: #73859f;\n  background-color: rgba(115, 133, 159, 0.5);\n  transition: all 0s;\n}\n\n.vjs-controls-disabled .vjs-big-play-button,\n.vjs-has-started .vjs-big-play-button,\n.vjs-using-native-controls .vjs-big-play-button,\n.vjs-error .vjs-big-play-button {\n  display: none;\n}\n\n.vjs-has-started.vjs-paused.vjs-show-big-play-button-on-pause .vjs-big-play-button {\n  display: block;\n}\n\n.video-js button {\n  background: none;\n  border: none;\n  color: inherit;\n  display: inline-block;\n  font-size: inherit;\n  line-height: inherit;\n  text-transform: none;\n  text-decoration: none;\n  transition: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.vjs-control .vjs-button {\n  width: 100%;\n  height: 100%;\n}\n\n.video-js .vjs-control.vjs-close-button {\n  cursor: pointer;\n  height: 3em;\n  position: absolute;\n  right: 0;\n  top: 0.5em;\n  z-index: 2;\n}\n.video-js .vjs-modal-dialog {\n  background: rgba(0, 0, 0, 0.8);\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.8), rgba(255, 255, 255, 0));\n  overflow: auto;\n}\n\n.video-js .vjs-modal-dialog > * {\n  box-sizing: border-box;\n}\n\n.vjs-modal-dialog .vjs-modal-dialog-content {\n  font-size: 1.2em;\n  line-height: 1.5;\n  padding: 20px 24px;\n  z-index: 1;\n}\n\n.vjs-menu-button {\n  cursor: pointer;\n}\n\n.vjs-menu-button.vjs-disabled {\n  cursor: default;\n}\n\n.vjs-workinghover .vjs-menu-button.vjs-disabled:hover .vjs-menu {\n  display: none;\n}\n\n.vjs-menu .vjs-menu-content {\n  display: block;\n  padding: 0;\n  margin: 0;\n  font-family: Arial, Helvetica, sans-serif;\n  overflow: auto;\n}\n\n.vjs-menu .vjs-menu-content > * {\n  box-sizing: border-box;\n}\n\n.vjs-scrubbing .vjs-control.vjs-menu-button:hover .vjs-menu {\n  display: none;\n}\n\n.vjs-menu li {\n  list-style: none;\n  margin: 0;\n  padding: 0.2em 0;\n  line-height: 1.4em;\n  font-size: 1.2em;\n  text-align: center;\n  text-transform: lowercase;\n}\n\n.vjs-menu li.vjs-menu-item:focus,\n.vjs-menu li.vjs-menu-item:hover,\n.js-focus-visible .vjs-menu li.vjs-menu-item:hover {\n  background-color: #73859f;\n  background-color: rgba(115, 133, 159, 0.5);\n}\n\n.vjs-menu li.vjs-selected,\n.vjs-menu li.vjs-selected:focus,\n.vjs-menu li.vjs-selected:hover,\n.js-focus-visible .vjs-menu li.vjs-selected:hover {\n  background-color: #fff;\n  color: #2B333F;\n}\n\n.video-js .vjs-menu *:not(.vjs-selected):focus:not(:focus-visible),\n.js-focus-visible .vjs-menu *:not(.vjs-selected):focus:not(.focus-visible) {\n  background: none;\n}\n\n.vjs-menu li.vjs-menu-title {\n  text-align: center;\n  text-transform: uppercase;\n  font-size: 1em;\n  line-height: 2em;\n  padding: 0;\n  margin: 0 0 0.3em 0;\n  font-weight: bold;\n  cursor: default;\n}\n\n.vjs-menu-button-popup .vjs-menu {\n  display: none;\n  position: absolute;\n  bottom: 0;\n  width: 10em;\n  left: -3em;\n  height: 0em;\n  margin-bottom: 1.5em;\n  border-top-color: rgba(43, 51, 63, 0.7);\n}\n\n.vjs-menu-button-popup .vjs-menu .vjs-menu-content {\n  background-color: #2B333F;\n  background-color: rgba(43, 51, 63, 0.7);\n  position: absolute;\n  width: 100%;\n  bottom: 1.5em;\n  max-height: 15em;\n}\n\n.vjs-layout-tiny .vjs-menu-button-popup .vjs-menu .vjs-menu-content,\n.vjs-layout-x-small .vjs-menu-button-popup .vjs-menu .vjs-menu-content {\n  max-height: 5em;\n}\n\n.vjs-layout-small .vjs-menu-button-popup .vjs-menu .vjs-menu-content {\n  max-height: 10em;\n}\n\n.vjs-layout-medium .vjs-menu-button-popup .vjs-menu .vjs-menu-content {\n  max-height: 14em;\n}\n\n.vjs-layout-large .vjs-menu-button-popup .vjs-menu .vjs-menu-content,\n.vjs-layout-x-large .vjs-menu-button-popup .vjs-menu .vjs-menu-content,\n.vjs-layout-huge .vjs-menu-button-popup .vjs-menu .vjs-menu-content {\n  max-height: 25em;\n}\n\n.vjs-workinghover .vjs-menu-button-popup.vjs-hover .vjs-menu,\n.vjs-menu-button-popup .vjs-menu.vjs-lock-showing {\n  display: block;\n}\n\n.video-js .vjs-menu-button-inline {\n  transition: all 0.4s;\n  overflow: hidden;\n}\n\n.video-js .vjs-menu-button-inline:before {\n  width: 2.222222222em;\n}\n\n.video-js .vjs-menu-button-inline:hover,\n.video-js .vjs-menu-button-inline:focus,\n.video-js .vjs-menu-button-inline.vjs-slider-active,\n.video-js.vjs-no-flex .vjs-menu-button-inline {\n  width: 12em;\n}\n\n.vjs-menu-button-inline .vjs-menu {\n  opacity: 0;\n  height: 100%;\n  width: auto;\n  position: absolute;\n  left: 4em;\n  top: 0;\n  padding: 0;\n  margin: 0;\n  transition: all 0.4s;\n}\n\n.vjs-menu-button-inline:hover .vjs-menu,\n.vjs-menu-button-inline:focus .vjs-menu,\n.vjs-menu-button-inline.vjs-slider-active .vjs-menu {\n  display: block;\n  opacity: 1;\n}\n\n.vjs-no-flex .vjs-menu-button-inline .vjs-menu {\n  display: block;\n  opacity: 1;\n  position: relative;\n  width: auto;\n}\n\n.vjs-no-flex .vjs-menu-button-inline:hover .vjs-menu,\n.vjs-no-flex .vjs-menu-button-inline:focus .vjs-menu,\n.vjs-no-flex .vjs-menu-button-inline.vjs-slider-active .vjs-menu {\n  width: auto;\n}\n\n.vjs-menu-button-inline .vjs-menu-content {\n  width: auto;\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n}\n\n.video-js .vjs-control-bar {\n  display: none;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 3em;\n  background-color: #2B333F;\n  background-color: rgba(43, 51, 63, 0.7);\n}\n\n.vjs-has-started .vjs-control-bar,\n.vjs-audio-only-mode .vjs-control-bar {\n  display: flex;\n  visibility: visible;\n  opacity: 1;\n  transition: visibility 0.1s, opacity 0.1s;\n}\n\n.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {\n  visibility: visible;\n  opacity: 0;\n  pointer-events: none;\n  transition: visibility 1s, opacity 1s;\n}\n\n.vjs-controls-disabled .vjs-control-bar,\n.vjs-using-native-controls .vjs-control-bar,\n.vjs-error .vjs-control-bar {\n  display: none !important;\n}\n\n.vjs-audio.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar,\n.vjs-audio-only-mode.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.vjs-has-started.vjs-no-flex .vjs-control-bar {\n  display: table;\n}\n\n.video-js .vjs-control {\n  position: relative;\n  text-align: center;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 4em;\n  flex: none;\n}\n\n.video-js .vjs-control.vjs-visible-text {\n  width: auto;\n  padding-left: 1em;\n  padding-right: 1em;\n}\n\n.vjs-button > .vjs-icon-placeholder:before {\n  font-size: 1.8em;\n  line-height: 1.67;\n}\n\n.vjs-button > .vjs-icon-placeholder {\n  display: block;\n}\n\n.video-js .vjs-control:focus:before,\n.video-js .vjs-control:hover:before,\n.video-js .vjs-control:focus {\n  text-shadow: 0em 0em 1em white;\n}\n\n.video-js *:not(.vjs-visible-text) > .vjs-control-text {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.vjs-no-flex .vjs-control {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.video-js .vjs-custom-control-spacer {\n  display: none;\n}\n\n.video-js .vjs-progress-control {\n  cursor: pointer;\n  flex: auto;\n  display: flex;\n  align-items: center;\n  min-width: 4em;\n  touch-action: none;\n}\n\n.video-js .vjs-progress-control.disabled {\n  cursor: default;\n}\n\n.vjs-live .vjs-progress-control {\n  display: none;\n}\n\n.vjs-liveui .vjs-progress-control {\n  display: flex;\n  align-items: center;\n}\n\n.vjs-no-flex .vjs-progress-control {\n  width: auto;\n}\n\n.video-js .vjs-progress-holder {\n  flex: auto;\n  transition: all 0.2s;\n  height: 0.3em;\n}\n\n.video-js .vjs-progress-control .vjs-progress-holder {\n  margin: 0 10px;\n}\n\n.video-js .vjs-progress-control:hover .vjs-progress-holder {\n  font-size: 1.6666666667em;\n}\n\n.video-js .vjs-progress-control:hover .vjs-progress-holder.disabled {\n  font-size: 1em;\n}\n\n.video-js .vjs-progress-holder .vjs-play-progress,\n.video-js .vjs-progress-holder .vjs-load-progress,\n.video-js .vjs-progress-holder .vjs-load-progress div {\n  position: absolute;\n  display: block;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  width: 0;\n}\n\n.video-js .vjs-play-progress {\n  background-color: #fff;\n}\n.video-js .vjs-play-progress:before {\n  font-size: 0.9em;\n  position: absolute;\n  right: -0.5em;\n  top: -0.3333333333em;\n  z-index: 1;\n}\n\n.video-js .vjs-load-progress {\n  background: rgba(115, 133, 159, 0.5);\n}\n\n.video-js .vjs-load-progress div {\n  background: rgba(115, 133, 159, 0.75);\n}\n\n.video-js .vjs-time-tooltip {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.8);\n  border-radius: 0.3em;\n  color: #000;\n  float: right;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 1em;\n  padding: 6px 8px 8px 8px;\n  pointer-events: none;\n  position: absolute;\n  top: -3.4em;\n  visibility: hidden;\n  z-index: 1;\n}\n\n.video-js .vjs-progress-holder:focus .vjs-time-tooltip {\n  display: none;\n}\n\n.video-js .vjs-progress-control:hover .vjs-time-tooltip,\n.video-js .vjs-progress-control:hover .vjs-progress-holder:focus .vjs-time-tooltip {\n  display: block;\n  font-size: 0.6em;\n  visibility: visible;\n}\n\n.video-js .vjs-progress-control.disabled:hover .vjs-time-tooltip {\n  font-size: 1em;\n}\n\n.video-js .vjs-progress-control .vjs-mouse-display {\n  display: none;\n  position: absolute;\n  width: 1px;\n  height: 100%;\n  background-color: #000;\n  z-index: 1;\n}\n\n.vjs-no-flex .vjs-progress-control .vjs-mouse-display {\n  z-index: 0;\n}\n\n.video-js .vjs-progress-control:hover .vjs-mouse-display {\n  display: block;\n}\n\n.video-js.vjs-user-inactive .vjs-progress-control .vjs-mouse-display {\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 1s, opacity 1s;\n}\n\n.video-js.vjs-user-inactive.vjs-no-flex .vjs-progress-control .vjs-mouse-display {\n  display: none;\n}\n\n.vjs-mouse-display .vjs-time-tooltip {\n  color: #fff;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.video-js .vjs-slider {\n  position: relative;\n  cursor: pointer;\n  padding: 0;\n  margin: 0 0.45em 0 0.45em;\n  /* iOS Safari */\n  -webkit-touch-callout: none;\n  /* Safari */\n  -webkit-user-select: none;\n  /* Konqueror HTML */\n  /* Firefox */\n  -moz-user-select: none;\n  /* Internet Explorer/Edge */\n  -ms-user-select: none;\n  /* Non-prefixed version, currently supported by Chrome and Opera */\n  user-select: none;\n  background-color: #73859f;\n  background-color: rgba(115, 133, 159, 0.5);\n}\n\n.video-js .vjs-slider.disabled {\n  cursor: default;\n}\n\n.video-js .vjs-slider:focus {\n  text-shadow: 0em 0em 1em white;\n  box-shadow: 0 0 1em #fff;\n}\n\n.video-js .vjs-mute-control {\n  cursor: pointer;\n  flex: none;\n}\n.video-js .vjs-volume-control {\n  cursor: pointer;\n  margin-right: 1em;\n  display: flex;\n}\n\n.video-js .vjs-volume-control.vjs-volume-horizontal {\n  width: 5em;\n}\n\n.video-js .vjs-volume-panel .vjs-volume-control {\n  visibility: visible;\n  opacity: 0;\n  width: 1px;\n  height: 1px;\n  margin-left: -1px;\n}\n\n.video-js .vjs-volume-panel {\n  transition: width 1s;\n}\n.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control, .video-js .vjs-volume-panel:active .vjs-volume-control, .video-js .vjs-volume-panel:focus .vjs-volume-control, .video-js .vjs-volume-panel .vjs-volume-control:active, .video-js .vjs-volume-panel.vjs-hover .vjs-mute-control ~ .vjs-volume-control, .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active {\n  visibility: visible;\n  opacity: 1;\n  position: relative;\n  transition: visibility 0.1s, opacity 0.1s, height 0.1s, width 0.1s, left 0s, top 0s;\n}\n.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-horizontal, .video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-horizontal, .video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-horizontal, .video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-horizontal, .video-js .vjs-volume-panel.vjs-hover .vjs-mute-control ~ .vjs-volume-control.vjs-volume-horizontal, .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-horizontal {\n  width: 5em;\n  height: 3em;\n  margin-right: 0;\n}\n.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-vertical, .video-js .vjs-volume-panel.vjs-hover .vjs-mute-control ~ .vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-vertical {\n  left: -3.5em;\n  transition: left 0s;\n}\n.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover, .video-js .vjs-volume-panel.vjs-volume-panel-horizontal:active, .video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active {\n  width: 10em;\n  transition: width 0.1s;\n}\n.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-mute-toggle-only {\n  width: 4em;\n}\n\n.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical {\n  height: 8em;\n  width: 3em;\n  left: -3000em;\n  transition: visibility 1s, opacity 1s, height 1s 1s, width 1s 1s, left 1s 1s, top 1s 1s;\n}\n\n.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal {\n  transition: visibility 1s, opacity 1s, height 1s 1s, width 1s, left 1s 1s, top 1s 1s;\n}\n\n.video-js.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal {\n  width: 5em;\n  height: 3em;\n  visibility: visible;\n  opacity: 1;\n  position: relative;\n  transition: none;\n}\n\n.video-js.vjs-no-flex .vjs-volume-control.vjs-volume-vertical,\n.video-js.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical {\n  position: absolute;\n  bottom: 3em;\n  left: 0.5em;\n}\n\n.video-js .vjs-volume-panel {\n  display: flex;\n}\n\n.video-js .vjs-volume-bar {\n  margin: 1.35em 0.45em;\n}\n\n.vjs-volume-bar.vjs-slider-horizontal {\n  width: 5em;\n  height: 0.3em;\n}\n\n.vjs-volume-bar.vjs-slider-vertical {\n  width: 0.3em;\n  height: 5em;\n  margin: 1.35em auto;\n}\n\n.video-js .vjs-volume-level {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  background-color: #fff;\n}\n.video-js .vjs-volume-level:before {\n  position: absolute;\n  font-size: 0.9em;\n  z-index: 1;\n}\n\n.vjs-slider-vertical .vjs-volume-level {\n  width: 0.3em;\n}\n.vjs-slider-vertical .vjs-volume-level:before {\n  top: -0.5em;\n  left: -0.3em;\n  z-index: 1;\n}\n\n.vjs-slider-horizontal .vjs-volume-level {\n  height: 0.3em;\n}\n.vjs-slider-horizontal .vjs-volume-level:before {\n  top: -0.3em;\n  right: -0.5em;\n}\n\n.video-js .vjs-volume-panel.vjs-volume-panel-vertical {\n  width: 4em;\n}\n\n.vjs-volume-bar.vjs-slider-vertical .vjs-volume-level {\n  height: 100%;\n}\n\n.vjs-volume-bar.vjs-slider-horizontal .vjs-volume-level {\n  width: 100%;\n}\n\n.video-js .vjs-volume-vertical {\n  width: 3em;\n  height: 8em;\n  bottom: 8em;\n  background-color: #2B333F;\n  background-color: rgba(43, 51, 63, 0.7);\n}\n\n.video-js .vjs-volume-horizontal .vjs-menu {\n  left: -2em;\n}\n\n.video-js .vjs-volume-tooltip {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.8);\n  border-radius: 0.3em;\n  color: #000;\n  float: right;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 1em;\n  padding: 6px 8px 8px 8px;\n  pointer-events: none;\n  position: absolute;\n  top: -3.4em;\n  visibility: hidden;\n  z-index: 1;\n}\n\n.video-js .vjs-volume-control:hover .vjs-volume-tooltip,\n.video-js .vjs-volume-control:hover .vjs-progress-holder:focus .vjs-volume-tooltip {\n  display: block;\n  font-size: 1em;\n  visibility: visible;\n}\n\n.video-js .vjs-volume-vertical:hover .vjs-volume-tooltip,\n.video-js .vjs-volume-vertical:hover .vjs-progress-holder:focus .vjs-volume-tooltip {\n  left: 1em;\n  top: -12px;\n}\n\n.video-js .vjs-volume-control.disabled:hover .vjs-volume-tooltip {\n  font-size: 1em;\n}\n\n.video-js .vjs-volume-control .vjs-mouse-display {\n  display: none;\n  position: absolute;\n  width: 100%;\n  height: 1px;\n  background-color: #000;\n  z-index: 1;\n}\n\n.video-js .vjs-volume-horizontal .vjs-mouse-display {\n  width: 1px;\n  height: 100%;\n}\n\n.vjs-no-flex .vjs-volume-control .vjs-mouse-display {\n  z-index: 0;\n}\n\n.video-js .vjs-volume-control:hover .vjs-mouse-display {\n  display: block;\n}\n\n.video-js.vjs-user-inactive .vjs-volume-control .vjs-mouse-display {\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 1s, opacity 1s;\n}\n\n.video-js.vjs-user-inactive.vjs-no-flex .vjs-volume-control .vjs-mouse-display {\n  display: none;\n}\n\n.vjs-mouse-display .vjs-volume-tooltip {\n  color: #fff;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.vjs-poster {\n  display: inline-block;\n  vertical-align: middle;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  background-size: contain;\n  background-color: #000000;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 100%;\n}\n\n.vjs-has-started .vjs-poster,\n.vjs-using-native-controls .vjs-poster {\n  display: none;\n}\n\n.vjs-audio.vjs-has-started .vjs-poster,\n.vjs-has-started.vjs-audio-poster-mode .vjs-poster {\n  display: block;\n}\n\n.video-js .vjs-live-control {\n  display: flex;\n  align-items: flex-start;\n  flex: auto;\n  font-size: 1em;\n  line-height: 3em;\n}\n\n.vjs-no-flex .vjs-live-control {\n  display: table-cell;\n  width: auto;\n  text-align: left;\n}\n\n.video-js:not(.vjs-live) .vjs-live-control,\n.video-js.vjs-liveui .vjs-live-control {\n  display: none;\n}\n\n.video-js .vjs-seek-to-live-control {\n  align-items: center;\n  cursor: pointer;\n  flex: none;\n  display: inline-flex;\n  height: 100%;\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n  font-size: 1em;\n  line-height: 3em;\n  width: auto;\n  min-width: 4em;\n}\n\n.vjs-no-flex .vjs-seek-to-live-control {\n  display: table-cell;\n  width: auto;\n  text-align: left;\n}\n\n.video-js.vjs-live:not(.vjs-liveui) .vjs-seek-to-live-control,\n.video-js:not(.vjs-live) .vjs-seek-to-live-control {\n  display: none;\n}\n\n.vjs-seek-to-live-control.vjs-control.vjs-at-live-edge {\n  cursor: auto;\n}\n\n.vjs-seek-to-live-control .vjs-icon-placeholder {\n  margin-right: 0.5em;\n  color: #888;\n}\n\n.vjs-seek-to-live-control.vjs-control.vjs-at-live-edge .vjs-icon-placeholder {\n  color: red;\n}\n\n.video-js .vjs-time-control {\n  flex: none;\n  font-size: 1em;\n  line-height: 3em;\n  min-width: 2em;\n  width: auto;\n  padding-left: 1em;\n  padding-right: 1em;\n}\n\n.vjs-live .vjs-time-control {\n  display: none;\n}\n\n.video-js .vjs-current-time,\n.vjs-no-flex .vjs-current-time {\n  display: none;\n}\n\n.video-js .vjs-duration,\n.vjs-no-flex .vjs-duration {\n  display: none;\n}\n\n.vjs-time-divider {\n  display: none;\n  line-height: 3em;\n}\n\n.vjs-live .vjs-time-divider {\n  display: none;\n}\n\n.video-js .vjs-play-control {\n  cursor: pointer;\n}\n\n.video-js .vjs-play-control .vjs-icon-placeholder {\n  flex: none;\n}\n\n.vjs-text-track-display {\n  position: absolute;\n  bottom: 3em;\n  left: 0;\n  right: 0;\n  top: 0;\n  pointer-events: none;\n}\n\n.video-js.vjs-controls-disabled .vjs-text-track-display,\n.video-js.vjs-user-inactive.vjs-playing .vjs-text-track-display {\n  bottom: 1em;\n}\n\n.video-js .vjs-text-track {\n  font-size: 1.4em;\n  text-align: center;\n  margin-bottom: 0.1em;\n}\n\n.vjs-subtitles {\n  color: #fff;\n}\n\n.vjs-captions {\n  color: #fc6;\n}\n\n.vjs-tt-cue {\n  display: block;\n}\n\nvideo::-webkit-media-text-track-display {\n  transform: translateY(-3em);\n}\n\n.video-js.vjs-controls-disabled video::-webkit-media-text-track-display,\n.video-js.vjs-user-inactive.vjs-playing video::-webkit-media-text-track-display {\n  transform: translateY(-1.5em);\n}\n\n.video-js .vjs-picture-in-picture-control {\n  cursor: pointer;\n  flex: none;\n}\n.video-js.vjs-audio-only-mode .vjs-picture-in-picture-control {\n  display: none;\n}\n\n.video-js .vjs-fullscreen-control {\n  cursor: pointer;\n  flex: none;\n}\n.video-js.vjs-audio-only-mode .vjs-fullscreen-control {\n  display: none;\n}\n\n.vjs-playback-rate > .vjs-menu-button,\n.vjs-playback-rate .vjs-playback-rate-value {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.vjs-playback-rate .vjs-playback-rate-value {\n  pointer-events: none;\n  font-size: 1.5em;\n  line-height: 2;\n  text-align: center;\n}\n\n.vjs-playback-rate .vjs-menu {\n  width: 4em;\n  left: 0em;\n}\n\n.vjs-error .vjs-error-display .vjs-modal-dialog-content {\n  font-size: 1.4em;\n  text-align: center;\n}\n\n.vjs-error .vjs-error-display:before {\n  color: #fff;\n  content: \"X\";\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 4em;\n  left: 0;\n  line-height: 1;\n  margin-top: -0.5em;\n  position: absolute;\n  text-shadow: 0.05em 0.05em 0.1em #000;\n  text-align: center;\n  top: 50%;\n  vertical-align: middle;\n  width: 100%;\n}\n\n.vjs-loading-spinner {\n  display: none;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -25px 0 0 -25px;\n  opacity: 0.85;\n  text-align: left;\n  border: 6px solid rgba(43, 51, 63, 0.7);\n  box-sizing: border-box;\n  background-clip: padding-box;\n  width: 50px;\n  height: 50px;\n  border-radius: 25px;\n  visibility: hidden;\n}\n\n.vjs-seeking .vjs-loading-spinner,\n.vjs-waiting .vjs-loading-spinner {\n  display: block;\n  -webkit-animation: vjs-spinner-show 0s linear 0.3s forwards;\n          animation: vjs-spinner-show 0s linear 0.3s forwards;\n}\n\n.vjs-loading-spinner:before,\n.vjs-loading-spinner:after {\n  content: \"\";\n  position: absolute;\n  margin: -6px;\n  box-sizing: inherit;\n  width: inherit;\n  height: inherit;\n  border-radius: inherit;\n  opacity: 1;\n  border: inherit;\n  border-color: transparent;\n  border-top-color: white;\n}\n\n.vjs-seeking .vjs-loading-spinner:before,\n.vjs-seeking .vjs-loading-spinner:after,\n.vjs-waiting .vjs-loading-spinner:before,\n.vjs-waiting .vjs-loading-spinner:after {\n  -webkit-animation: vjs-spinner-spin 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite, vjs-spinner-fade 1.1s linear infinite;\n  animation: vjs-spinner-spin 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite, vjs-spinner-fade 1.1s linear infinite;\n}\n\n.vjs-seeking .vjs-loading-spinner:before,\n.vjs-waiting .vjs-loading-spinner:before {\n  border-top-color: white;\n}\n\n.vjs-seeking .vjs-loading-spinner:after,\n.vjs-waiting .vjs-loading-spinner:after {\n  border-top-color: white;\n  -webkit-animation-delay: 0.44s;\n  animation-delay: 0.44s;\n}\n\n@keyframes vjs-spinner-show {\n  to {\n    visibility: visible;\n  }\n}\n@-webkit-keyframes vjs-spinner-show {\n  to {\n    visibility: visible;\n  }\n}\n@keyframes vjs-spinner-spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes vjs-spinner-spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes vjs-spinner-fade {\n  0% {\n    border-top-color: #73859f;\n  }\n  20% {\n    border-top-color: #73859f;\n  }\n  35% {\n    border-top-color: white;\n  }\n  60% {\n    border-top-color: #73859f;\n  }\n  100% {\n    border-top-color: #73859f;\n  }\n}\n@-webkit-keyframes vjs-spinner-fade {\n  0% {\n    border-top-color: #73859f;\n  }\n  20% {\n    border-top-color: #73859f;\n  }\n  35% {\n    border-top-color: white;\n  }\n  60% {\n    border-top-color: #73859f;\n  }\n  100% {\n    border-top-color: #73859f;\n  }\n}\n.video-js.vjs-audio-only-mode .vjs-captions-button {\n  display: none;\n}\n\n.vjs-chapters-button .vjs-menu ul {\n  width: 24em;\n}\n\n.video-js.vjs-audio-only-mode .vjs-descriptions-button {\n  display: none;\n}\n\n.video-js .vjs-subs-caps-button + .vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder {\n  vertical-align: middle;\n  display: inline-block;\n  margin-bottom: -0.1em;\n}\n\n.video-js .vjs-subs-caps-button + .vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before {\n  font-family: VideoJS;\n  content: \"\\F10D\";\n  font-size: 1.5em;\n  line-height: inherit;\n}\n\n.video-js.vjs-audio-only-mode .vjs-subs-caps-button {\n  display: none;\n}\n\n.video-js .vjs-audio-button + .vjs-menu .vjs-main-desc-menu-item .vjs-menu-item-text .vjs-icon-placeholder {\n  vertical-align: middle;\n  display: inline-block;\n  margin-bottom: -0.1em;\n}\n\n.video-js .vjs-audio-button + .vjs-menu .vjs-main-desc-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before {\n  font-family: VideoJS;\n  content: \" \\F11D\";\n  font-size: 1.5em;\n  line-height: inherit;\n}\n\n.video-js.vjs-layout-small .vjs-current-time,\n.video-js.vjs-layout-small .vjs-time-divider,\n.video-js.vjs-layout-small .vjs-duration,\n.video-js.vjs-layout-small .vjs-remaining-time,\n.video-js.vjs-layout-small .vjs-playback-rate,\n.video-js.vjs-layout-small .vjs-volume-control, .video-js.vjs-layout-x-small .vjs-current-time,\n.video-js.vjs-layout-x-small .vjs-time-divider,\n.video-js.vjs-layout-x-small .vjs-duration,\n.video-js.vjs-layout-x-small .vjs-remaining-time,\n.video-js.vjs-layout-x-small .vjs-playback-rate,\n.video-js.vjs-layout-x-small .vjs-volume-control, .video-js.vjs-layout-tiny .vjs-current-time,\n.video-js.vjs-layout-tiny .vjs-time-divider,\n.video-js.vjs-layout-tiny .vjs-duration,\n.video-js.vjs-layout-tiny .vjs-remaining-time,\n.video-js.vjs-layout-tiny .vjs-playback-rate,\n.video-js.vjs-layout-tiny .vjs-volume-control {\n  display: none;\n}\n.video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal:hover, .video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal:active, .video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active, .video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover, .video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal:hover, .video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal:active, .video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active, .video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover, .video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal:hover, .video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal:active, .video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active, .video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover {\n  width: auto;\n  width: initial;\n}\n.video-js.vjs-layout-x-small .vjs-progress-control, .video-js.vjs-layout-tiny .vjs-progress-control {\n  display: none;\n}\n.video-js.vjs-layout-x-small .vjs-custom-control-spacer {\n  flex: auto;\n  display: block;\n}\n.video-js.vjs-layout-x-small.vjs-no-flex .vjs-custom-control-spacer {\n  width: auto;\n}\n\n.vjs-modal-dialog.vjs-text-track-settings {\n  background-color: #2B333F;\n  background-color: rgba(43, 51, 63, 0.75);\n  color: #fff;\n  height: 70%;\n}\n\n.vjs-text-track-settings .vjs-modal-dialog-content {\n  display: table;\n}\n\n.vjs-text-track-settings .vjs-track-settings-colors,\n.vjs-text-track-settings .vjs-track-settings-font,\n.vjs-text-track-settings .vjs-track-settings-controls {\n  display: table-cell;\n}\n\n.vjs-text-track-settings .vjs-track-settings-controls {\n  text-align: right;\n  vertical-align: bottom;\n}\n\n@supports (display: grid) {\n  .vjs-text-track-settings .vjs-modal-dialog-content {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr;\n    padding: 20px 24px 0px 24px;\n  }\n\n  .vjs-track-settings-controls .vjs-default-button {\n    margin-bottom: 20px;\n  }\n\n  .vjs-text-track-settings .vjs-track-settings-controls {\n    grid-column: 1/-1;\n  }\n\n  .vjs-layout-small .vjs-text-track-settings .vjs-modal-dialog-content,\n.vjs-layout-x-small .vjs-text-track-settings .vjs-modal-dialog-content,\n.vjs-layout-tiny .vjs-text-track-settings .vjs-modal-dialog-content {\n    grid-template-columns: 1fr;\n  }\n}\n.vjs-track-setting > select {\n  margin-right: 1em;\n  margin-bottom: 0.5em;\n}\n\n.vjs-text-track-settings fieldset {\n  margin: 5px;\n  padding: 3px;\n  border: none;\n}\n\n.vjs-text-track-settings fieldset span {\n  display: inline-block;\n}\n\n.vjs-text-track-settings fieldset span > select {\n  max-width: 7.3em;\n}\n\n.vjs-text-track-settings legend {\n  color: #fff;\n  margin: 0 0 5px 0;\n}\n\n.vjs-text-track-settings .vjs-label {\n  position: absolute;\n  clip: rect(1px 1px 1px 1px);\n  clip: rect(1px, 1px, 1px, 1px);\n  display: block;\n  margin: 0 0 5px 0;\n  padding: 0;\n  border: 0;\n  height: 1px;\n  width: 1px;\n  overflow: hidden;\n}\n\n.vjs-track-settings-controls button:focus,\n.vjs-track-settings-controls button:active {\n  outline-style: solid;\n  outline-width: medium;\n  background-image: linear-gradient(0deg, #fff 88%, #73859f 100%);\n}\n\n.vjs-track-settings-controls button:hover {\n  color: rgba(43, 51, 63, 0.75);\n}\n\n.vjs-track-settings-controls button {\n  background-color: #fff;\n  background-image: linear-gradient(-180deg, #fff 88%, #73859f 100%);\n  color: #2B333F;\n  cursor: pointer;\n  border-radius: 2px;\n}\n\n.vjs-track-settings-controls .vjs-default-button {\n  margin-right: 1em;\n}\n\n@media print {\n  .video-js > *:not(.vjs-tech):not(.vjs-poster) {\n    visibility: hidden;\n  }\n}\n.vjs-resize-manager {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  z-index: -1000;\n}\n\n.js-focus-visible .video-js *:focus:not(.focus-visible) {\n  outline: none;\n}\n\n.video-js *:focus:not(:focus-visible) {\n  outline: none;\n}\n", ""]);
	
	// exports


/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(1835);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 1761 */
/***/ function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  fn._off = on;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var i = callbacks.indexOf(fn._off || fn);
	  if (~i) callbacks.splice(i, 1);
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1775);


/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(1)
	
	  , request = __webpack_require__(1886)
	
	  , apiUrl = 'https://maps.googleapis.com/maps/api/geocode/json'
	;
	
	
	function GeoPlace(res){
	
	  Object
	  .defineProperty(
	    this,
	    'googleResponse', {
	      value : res,
	      writable : false,
	      enumerable : false,
	      configurable : true
	    });
	
	  Object
	  .defineProperty(
	    this,
	    'city', {
	      enumerable : true,
	      get: function(){
	        switch(this.country.short_name){
	          case 'CA':
	          case 'US':
	            return this.locality||this.sublocality;
	        }
	        return undefined;
	      }
	    });
	
	
	  Object
	  .defineProperty(
	    this,
	    'province_state', {
	      enumerable : true,
	      get: function(){
	        switch(this.country.short_name){
	          case 'CA':
	          case 'US':
	            return this.administrative_area_level_1;
	        }
	        return undefined;
	      }
	    });
	
	
	  this.googleResponse = res;
	  this._parseResult( res);
	
	}
	
	GeoPlace.prototype._normalizeAddressComponents = function(res){
	  var components = {};
	  res.address_components.forEach(function(item){
	    components[ item.types[0]] = {
	      long_name: item.long_name,
	      short_name: item.short_name
	    };
	  });
	  return components;
	};
	
	GeoPlace.prototype._parseResult = function(res){
	
	  var norm = this._normalizeAddressComponents( res);
	  _.extend(this, norm);
	
	  this.formatted_address = res.formatted_address;
	
	  var geo = res.geometry;
	  this.location = geo.location;
	  this.location_type = geo.location_type;
	
	  if( geo.bounds) this.location_bounds = geo.bounds;
	
	  return norm;
	};
	
	GeoPlace.parseAddressResults = function(results){
	  var places = [];
	  results.forEach(function(res){
	    places.push( new GeoPlace(res));
	  });
	  return places;
	};
	
	
	function GeoCoder(apiKey){
	
	  this.queryData = {
	    key: apiKey,
	    sensor: false
	  };
	
	  this.lastResults = null;
	};
	
	
	GeoCoder.prototype.find = function(place, cb){
	  var coder = this;
	  request
	  .get(apiUrl)
	  .query(_.extend({
	    address: place
	  }, this.queryData))
	  .end(function(res){
	    switch( res.body.status){
	      case 'OK':
	      case 'ZERO_RESULTS':
	        coder.lastResults = res.body;
	        cb&&cb(null,
	          GeoPlace.parseAddressResults( res.body.results),
	          res.body
	        );
	      break;
	      default:
	        cb&&cb(res.body);
	    }
	  });
	};
	
	GeoCoder.prototype.reverseFind = function(lat, lng, cb){
	  var coder = this;
	  request
	  .get(apiUrl)
	  .query(_.extend({
	    latlng: lat+','+lng
	  }, this.queryData))
	  .end(function(res){
	    switch( res.body.status){
	      case 'OK':
	      case 'ZERO_RESULTS':
	        coder.lastResults = res.body;
	        cb&&cb(null,
	          GeoPlace.parseAddressResults( res.body.results),
	          res.body
	        );
	      break;
	      default:
	        cb&&cb(res.body);
	    }
	  });
	}
	
	
	module.exports = function(options){
	
	  if( !options || !options.hasOwnProperty('key')){
	    throw new Error('Property `key` required. Please register your app with google api and the api key here.');
	  }
	
	  return new GeoCoder(options.key);
	};
	
	module.exports.GeoCoder = GeoCoder;
	module.exports.GeoPlace = GeoPlace;


/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	var http = module.exports;
	var EventEmitter = __webpack_require__(932).EventEmitter;
	var Request = __webpack_require__(1777);
	var url = __webpack_require__(1505)
	
	http.request = function (params, cb) {
	    if (typeof params === 'string') {
	        params = url.parse(params)
	    }
	    if (!params) params = {};
	    if (!params.host && !params.port) {
	        params.port = parseInt(window.location.port, 10);
	    }
	    if (!params.host && params.hostname) {
	        params.host = params.hostname;
	    }
	
	    if (!params.protocol) {
	        if (params.scheme) {
	            params.protocol = params.scheme + ':';
	        } else {
	            params.protocol = window.location.protocol;
	        }
	    }
	
	    if (!params.host) {
	        params.host = window.location.hostname || window.location.host;
	    }
	    if (/:/.test(params.host)) {
	        if (!params.port) {
	            params.port = params.host.split(':')[1];
	        }
	        params.host = params.host.split(':')[0];
	    }
	    if (!params.port) params.port = params.protocol == 'https:' ? 443 : 80;
	    
	    var req = new Request(new xhrHttp, params);
	    if (cb) req.on('response', cb);
	    return req;
	};
	
	http.get = function (params, cb) {
	    params.method = 'GET';
	    var req = http.request(params, cb);
	    req.end();
	    return req;
	};
	
	http.Agent = function () {};
	http.Agent.defaultMaxSockets = 4;
	
	var xhrHttp = (function () {
	    if (typeof window === 'undefined') {
	        throw new Error('no window object present');
	    }
	    else if (window.XMLHttpRequest) {
	        return window.XMLHttpRequest;
	    }
	    else if (window.ActiveXObject) {
	        var axs = [
	            'Msxml2.XMLHTTP.6.0',
	            'Msxml2.XMLHTTP.3.0',
	            'Microsoft.XMLHTTP'
	        ];
	        for (var i = 0; i < axs.length; i++) {
	            try {
	                var ax = new(window.ActiveXObject)(axs[i]);
	                return function () {
	                    if (ax) {
	                        var ax_ = ax;
	                        ax = null;
	                        return ax_;
	                    }
	                    else {
	                        return new(window.ActiveXObject)(axs[i]);
	                    }
	                };
	            }
	            catch (e) {}
	        }
	        throw new Error('ajax not supported in this browser')
	    }
	    else {
	        throw new Error('ajax not supported in this browser');
	    }
	})();
	
	http.STATUS_CODES = {
	    100 : 'Continue',
	    101 : 'Switching Protocols',
	    102 : 'Processing',                 // RFC 2518, obsoleted by RFC 4918
	    200 : 'OK',
	    201 : 'Created',
	    202 : 'Accepted',
	    203 : 'Non-Authoritative Information',
	    204 : 'No Content',
	    205 : 'Reset Content',
	    206 : 'Partial Content',
	    207 : 'Multi-Status',               // RFC 4918
	    300 : 'Multiple Choices',
	    301 : 'Moved Permanently',
	    302 : 'Moved Temporarily',
	    303 : 'See Other',
	    304 : 'Not Modified',
	    305 : 'Use Proxy',
	    307 : 'Temporary Redirect',
	    400 : 'Bad Request',
	    401 : 'Unauthorized',
	    402 : 'Payment Required',
	    403 : 'Forbidden',
	    404 : 'Not Found',
	    405 : 'Method Not Allowed',
	    406 : 'Not Acceptable',
	    407 : 'Proxy Authentication Required',
	    408 : 'Request Time-out',
	    409 : 'Conflict',
	    410 : 'Gone',
	    411 : 'Length Required',
	    412 : 'Precondition Failed',
	    413 : 'Request Entity Too Large',
	    414 : 'Request-URI Too Large',
	    415 : 'Unsupported Media Type',
	    416 : 'Requested Range Not Satisfiable',
	    417 : 'Expectation Failed',
	    418 : 'I\'m a teapot',              // RFC 2324
	    422 : 'Unprocessable Entity',       // RFC 4918
	    423 : 'Locked',                     // RFC 4918
	    424 : 'Failed Dependency',          // RFC 4918
	    425 : 'Unordered Collection',       // RFC 4918
	    426 : 'Upgrade Required',           // RFC 2817
	    428 : 'Precondition Required',      // RFC 6585
	    429 : 'Too Many Requests',          // RFC 6585
	    431 : 'Request Header Fields Too Large',// RFC 6585
	    500 : 'Internal Server Error',
	    501 : 'Not Implemented',
	    502 : 'Bad Gateway',
	    503 : 'Service Unavailable',
	    504 : 'Gateway Time-out',
	    505 : 'HTTP Version Not Supported',
	    506 : 'Variant Also Negotiates',    // RFC 2295
	    507 : 'Insufficient Storage',       // RFC 4918
	    509 : 'Bandwidth Limit Exceeded',
	    510 : 'Not Extended',               // RFC 2774
	    511 : 'Network Authentication Required' // RFC 6585
	};

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	var Stream = __webpack_require__(345);
	var Response = __webpack_require__(1778);
	var Base64 = __webpack_require__(1538);
	var inherits = __webpack_require__(406);
	
	var Request = module.exports = function (xhr, params) {
	    var self = this;
	    self.writable = true;
	    self.xhr = xhr;
	    self.body = [];
	    
	    self.uri = (params.protocol || 'http:') + '//'
	        + params.host
	        + (params.port ? ':' + params.port : '')
	        + (params.path || '/')
	    ;
	    
	    if (typeof params.withCredentials === 'undefined') {
	        params.withCredentials = true;
	    }
	
	    try { xhr.withCredentials = params.withCredentials }
	    catch (e) {}
	    
	    if (params.responseType) try { xhr.responseType = params.responseType }
	    catch (e) {}
	    
	    xhr.open(
	        params.method || 'GET',
	        self.uri,
	        true
	    );
	
	    xhr.onerror = function(event) {
	        self.emit('error', new Error('Network error'));
	    };
	
	    self._headers = {};
	    
	    if (params.headers) {
	        var keys = objectKeys(params.headers);
	        for (var i = 0; i < keys.length; i++) {
	            var key = keys[i];
	            if (!self.isSafeRequestHeader(key)) continue;
	            var value = params.headers[key];
	            self.setHeader(key, value);
	        }
	    }
	    
	    if (params.auth) {
	        //basic auth
	        this.setHeader('Authorization', 'Basic ' + Base64.btoa(params.auth));
	    }
	
	    var res = new Response;
	    res.on('close', function () {
	        self.emit('close');
	    });
	    
	    res.on('ready', function () {
	        self.emit('response', res);
	    });
	
	    res.on('error', function (err) {
	        self.emit('error', err);
	    });
	    
	    xhr.onreadystatechange = function () {
	        // Fix for IE9 bug
	        // SCRIPT575: Could not complete the operation due to error c00c023f
	        // It happens when a request is aborted, calling the success callback anyway with readyState === 4
	        if (xhr.__aborted) return;
	        res.handle(xhr);
	    };
	};
	
	inherits(Request, Stream);
	
	Request.prototype.setHeader = function (key, value) {
	    this._headers[key.toLowerCase()] = value
	};
	
	Request.prototype.getHeader = function (key) {
	    return this._headers[key.toLowerCase()]
	};
	
	Request.prototype.removeHeader = function (key) {
	    delete this._headers[key.toLowerCase()]
	};
	
	Request.prototype.write = function (s) {
	    this.body.push(s);
	};
	
	Request.prototype.destroy = function (s) {
	    this.xhr.__aborted = true;
	    this.xhr.abort();
	    this.emit('close');
	};
	
	Request.prototype.end = function (s) {
	    if (s !== undefined) this.body.push(s);
	
	    var keys = objectKeys(this._headers);
	    for (var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        var value = this._headers[key];
	        if (isArray(value)) {
	            for (var j = 0; j < value.length; j++) {
	                this.xhr.setRequestHeader(key, value[j]);
	            }
	        }
	        else this.xhr.setRequestHeader(key, value)
	    }
	
	    if (this.body.length === 0) {
	        this.xhr.send('');
	    }
	    else if (typeof this.body[0] === 'string') {
	        this.xhr.send(this.body.join(''));
	    }
	    else if (isArray(this.body[0])) {
	        var body = [];
	        for (var i = 0; i < this.body.length; i++) {
	            body.push.apply(body, this.body[i]);
	        }
	        this.xhr.send(body);
	    }
	    else if (/Array/.test(Object.prototype.toString.call(this.body[0]))) {
	        var len = 0;
	        for (var i = 0; i < this.body.length; i++) {
	            len += this.body[i].length;
	        }
	        var body = new(this.body[0].constructor)(len);
	        var k = 0;
	        
	        for (var i = 0; i < this.body.length; i++) {
	            var b = this.body[i];
	            for (var j = 0; j < b.length; j++) {
	                body[k++] = b[j];
	            }
	        }
	        this.xhr.send(body);
	    }
	    else if (isXHR2Compatible(this.body[0])) {
	        this.xhr.send(this.body[0]);
	    }
	    else {
	        var body = '';
	        for (var i = 0; i < this.body.length; i++) {
	            body += this.body[i].toString();
	        }
	        this.xhr.send(body);
	    }
	};
	
	// Taken from http://dxr.mozilla.org/mozilla/mozilla-central/content/base/src/nsXMLHttpRequest.cpp.html
	Request.unsafeHeaders = [
	    "accept-charset",
	    "accept-encoding",
	    "access-control-request-headers",
	    "access-control-request-method",
	    "connection",
	    "content-length",
	    "cookie",
	    "cookie2",
	    "content-transfer-encoding",
	    "date",
	    "expect",
	    "host",
	    "keep-alive",
	    "origin",
	    "referer",
	    "te",
	    "trailer",
	    "transfer-encoding",
	    "upgrade",
	    "user-agent",
	    "via"
	];
	
	Request.prototype.isSafeRequestHeader = function (headerName) {
	    if (!headerName) return false;
	    return indexOf(Request.unsafeHeaders, headerName.toLowerCase()) === -1;
	};
	
	var objectKeys = Object.keys || function (obj) {
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    return keys;
	};
	
	var isArray = Array.isArray || function (xs) {
	    return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	var indexOf = function (xs, x) {
	    if (xs.indexOf) return xs.indexOf(x);
	    for (var i = 0; i < xs.length; i++) {
	        if (xs[i] === x) return i;
	    }
	    return -1;
	};
	
	var isXHR2Compatible = function (obj) {
	    if (typeof Blob !== 'undefined' && obj instanceof Blob) return true;
	    if (typeof ArrayBuffer !== 'undefined' && obj instanceof ArrayBuffer) return true;
	    if (typeof FormData !== 'undefined' && obj instanceof FormData) return true;
	};


/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	var Stream = __webpack_require__(345);
	var util = __webpack_require__(1947);
	
	var Response = module.exports = function (res) {
	    this.offset = 0;
	    this.readable = true;
	};
	
	util.inherits(Response, Stream);
	
	var capable = {
	    streaming : true,
	    status2 : true
	};
	
	function parseHeaders (res) {
	    var lines = res.getAllResponseHeaders().split(/\r?\n/);
	    var headers = {};
	    for (var i = 0; i < lines.length; i++) {
	        var line = lines[i];
	        if (line === '') continue;
	        
	        var m = line.match(/^([^:]+):\s*(.*)/);
	        if (m) {
	            var key = m[1].toLowerCase(), value = m[2];
	            
	            if (headers[key] !== undefined) {
	            
	                if (isArray(headers[key])) {
	                    headers[key].push(value);
	                }
	                else {
	                    headers[key] = [ headers[key], value ];
	                }
	            }
	            else {
	                headers[key] = value;
	            }
	        }
	        else {
	            headers[line] = true;
	        }
	    }
	    return headers;
	}
	
	Response.prototype.getResponse = function (xhr) {
	    var respType = String(xhr.responseType).toLowerCase();
	    if (respType === 'blob') return xhr.responseBlob || xhr.response;
	    if (respType === 'arraybuffer') return xhr.response;
	    return xhr.responseText;
	}
	
	Response.prototype.getHeader = function (key) {
	    return this.headers[key.toLowerCase()];
	};
	
	Response.prototype.handle = function (res) {
	    if (res.readyState === 2 && capable.status2) {
	        try {
	            this.statusCode = res.status;
	            this.headers = parseHeaders(res);
	        }
	        catch (err) {
	            capable.status2 = false;
	        }
	        
	        if (capable.status2) {
	            this.emit('ready');
	        }
	    }
	    else if (capable.streaming && res.readyState === 3) {
	        try {
	            if (!this.statusCode) {
	                this.statusCode = res.status;
	                this.headers = parseHeaders(res);
	                this.emit('ready');
	            }
	        }
	        catch (err) {}
	        
	        try {
	            this._emitData(res);
	        }
	        catch (err) {
	            capable.streaming = false;
	        }
	    }
	    else if (res.readyState === 4) {
	        if (!this.statusCode) {
	            this.statusCode = res.status;
	            this.emit('ready');
	        }
	        this._emitData(res);
	        
	        if (res.error) {
	            this.emit('error', this.getResponse(res));
	        }
	        else this.emit('end');
	        
	        this.emit('close');
	    }
	};
	
	Response.prototype._emitData = function (res) {
	    var respBody = this.getResponse(res);
	    if (respBody.toString().match(/ArrayBuffer/)) {
	        this.emit('data', new Uint8Array(respBody, this.offset));
	        this.offset = respBody.byteLength;
	        return;
	    }
	    if (respBody.length > this.offset) {
	        this.emit('data', respBody.slice(this.offset));
	        this.offset = respBody.length;
	    }
	};
	
	var isArray = Array.isArray || function (xs) {
	    return Object.prototype.toString.call(xs) === '[object Array]';
	};


/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Buffer = __webpack_require__(687).Buffer;
	
	// Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
	// Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
	// To save memory and loading time, we read table files only when requested.
	
	exports._dbcs = DBCSCodec;
	
	var UNASSIGNED = -1,
	    GB18030_CODE = -2,
	    SEQ_START  = -10,
	    NODE_START = -1000,
	    UNASSIGNED_NODE = new Array(0x100),
	    DEF_CHAR = -1;
	
	for (var i = 0; i < 0x100; i++)
	    UNASSIGNED_NODE[i] = UNASSIGNED;
	
	
	// Class DBCSCodec reads and initializes mapping tables.
	function DBCSCodec(codecOptions, iconv) {
	    this.encodingName = codecOptions.encodingName;
	    if (!codecOptions)
	        throw new Error("DBCS codec is called without the data.")
	    if (!codecOptions.table)
	        throw new Error("Encoding '" + this.encodingName + "' has no data.");
	
	    // Load tables.
	    var mappingTable = codecOptions.table();
	
	
	    // Decode tables: MBCS -> Unicode.
	
	    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
	    // Trie root is decodeTables[0].
	    // Values: >=  0 -> unicode character code. can be > 0xFFFF
	    //         == UNASSIGNED -> unknown/unassigned sequence.
	    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
	    //         <= NODE_START -> index of the next node in our trie to process next byte.
	    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
	    this.decodeTables = [];
	    this.decodeTables[0] = UNASSIGNED_NODE.slice(0); // Create root node.
	
	    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here. 
	    this.decodeTableSeq = [];
	
	    // Actual mapping tables consist of chunks. Use them to fill up decode tables.
	    for (var i = 0; i < mappingTable.length; i++)
	        this._addDecodeChunk(mappingTable[i]);
	
	    this.defaultCharUnicode = iconv.defaultCharUnicode;
	
	    
	    // Encode tables: Unicode -> DBCS.
	
	    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
	    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
	    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
	    //         == UNASSIGNED -> no conversion found. Output a default char.
	    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
	    this.encodeTable = [];
	    
	    // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
	    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
	    // means end of sequence (needed when one sequence is a strict subsequence of another).
	    // Objects are kept separately from encodeTable to increase performance.
	    this.encodeTableSeq = [];
	
	    // Some chars can be decoded, but need not be encoded.
	    var skipEncodeChars = {};
	    if (codecOptions.encodeSkipVals)
	        for (var i = 0; i < codecOptions.encodeSkipVals.length; i++) {
	            var val = codecOptions.encodeSkipVals[i];
	            if (typeof val === 'number')
	                skipEncodeChars[val] = true;
	            else
	                for (var j = val.from; j <= val.to; j++)
	                    skipEncodeChars[j] = true;
	        }
	        
	    // Use decode trie to recursively fill out encode tables.
	    this._fillEncodeTable(0, 0, skipEncodeChars);
	
	    // Add more encoding pairs when needed.
	    if (codecOptions.encodeAdd) {
	        for (var uChar in codecOptions.encodeAdd)
	            if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar))
	                this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
	    }
	
	    this.defCharSB  = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
	    if (this.defCharSB === UNASSIGNED) this.defCharSB = this.encodeTable[0]['?'];
	    if (this.defCharSB === UNASSIGNED) this.defCharSB = "?".charCodeAt(0);
	
	
	    // Load & create GB18030 tables when needed.
	    if (typeof codecOptions.gb18030 === 'function') {
	        this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.
	
	        // Add GB18030 decode tables.
	        var thirdByteNodeIdx = this.decodeTables.length;
	        var thirdByteNode = this.decodeTables[thirdByteNodeIdx] = UNASSIGNED_NODE.slice(0);
	
	        var fourthByteNodeIdx = this.decodeTables.length;
	        var fourthByteNode = this.decodeTables[fourthByteNodeIdx] = UNASSIGNED_NODE.slice(0);
	
	        for (var i = 0x81; i <= 0xFE; i++) {
	            var secondByteNodeIdx = NODE_START - this.decodeTables[0][i];
	            var secondByteNode = this.decodeTables[secondByteNodeIdx];
	            for (var j = 0x30; j <= 0x39; j++)
	                secondByteNode[j] = NODE_START - thirdByteNodeIdx;
	        }
	        for (var i = 0x81; i <= 0xFE; i++)
	            thirdByteNode[i] = NODE_START - fourthByteNodeIdx;
	        for (var i = 0x30; i <= 0x39; i++)
	            fourthByteNode[i] = GB18030_CODE
	    }        
	}
	
	DBCSCodec.prototype.encoder = DBCSEncoder;
	DBCSCodec.prototype.decoder = DBCSDecoder;
	
	// Decoder helpers
	DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
	    var bytes = [];
	    for (; addr > 0; addr >>= 8)
	        bytes.push(addr & 0xFF);
	    if (bytes.length == 0)
	        bytes.push(0);
	
	    var node = this.decodeTables[0];
	    for (var i = bytes.length-1; i > 0; i--) { // Traverse nodes deeper into the trie.
	        var val = node[bytes[i]];
	
	        if (val == UNASSIGNED) { // Create new node.
	            node[bytes[i]] = NODE_START - this.decodeTables.length;
	            this.decodeTables.push(node = UNASSIGNED_NODE.slice(0));
	        }
	        else if (val <= NODE_START) { // Existing node.
	            node = this.decodeTables[NODE_START - val];
	        }
	        else
	            throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
	    }
	    return node;
	}
	
	
	DBCSCodec.prototype._addDecodeChunk = function(chunk) {
	    // First element of chunk is the hex mbcs code where we start.
	    var curAddr = parseInt(chunk[0], 16);
	
	    // Choose the decoding node where we'll write our chars.
	    var writeTable = this._getDecodeTrieNode(curAddr);
	    curAddr = curAddr & 0xFF;
	
	    // Write all other elements of the chunk to the table.
	    for (var k = 1; k < chunk.length; k++) {
	        var part = chunk[k];
	        if (typeof part === "string") { // String, write as-is.
	            for (var l = 0; l < part.length;) {
	                var code = part.charCodeAt(l++);
	                if (0xD800 <= code && code < 0xDC00) { // Decode surrogate
	                    var codeTrail = part.charCodeAt(l++);
	                    if (0xDC00 <= codeTrail && codeTrail < 0xE000)
	                        writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
	                    else
	                        throw new Error("Incorrect surrogate pair in "  + this.encodingName + " at chunk " + chunk[0]);
	                }
	                else if (0x0FF0 < code && code <= 0x0FFF) { // Character sequence (our own encoding used)
	                    var len = 0xFFF - code + 2;
	                    var seq = [];
	                    for (var m = 0; m < len; m++)
	                        seq.push(part.charCodeAt(l++)); // Simple variation: don't support surrogates or subsequences in seq.
	
	                    writeTable[curAddr++] = SEQ_START - this.decodeTableSeq.length;
	                    this.decodeTableSeq.push(seq);
	                }
	                else
	                    writeTable[curAddr++] = code; // Basic char
	            }
	        } 
	        else if (typeof part === "number") { // Integer, meaning increasing sequence starting with prev character.
	            var charCode = writeTable[curAddr - 1] + 1;
	            for (var l = 0; l < part; l++)
	                writeTable[curAddr++] = charCode++;
	        }
	        else
	            throw new Error("Incorrect type '" + typeof part + "' given in "  + this.encodingName + " at chunk " + chunk[0]);
	    }
	    if (curAddr > 0xFF)
	        throw new Error("Incorrect chunk in "  + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
	}
	
	// Encoder helpers
	DBCSCodec.prototype._getEncodeBucket = function(uCode) {
	    var high = uCode >> 8; // This could be > 0xFF because of astral characters.
	    if (this.encodeTable[high] === undefined)
	        this.encodeTable[high] = UNASSIGNED_NODE.slice(0); // Create bucket on demand.
	    return this.encodeTable[high];
	}
	
	DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
	    var bucket = this._getEncodeBucket(uCode);
	    var low = uCode & 0xFF;
	    if (bucket[low] <= SEQ_START)
	        this.encodeTableSeq[SEQ_START-bucket[low]][DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
	    else if (bucket[low] == UNASSIGNED)
	        bucket[low] = dbcsCode;
	}
	
	DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
	    
	    // Get the root of character tree according to first character of the sequence.
	    var uCode = seq[0];
	    var bucket = this._getEncodeBucket(uCode);
	    var low = uCode & 0xFF;
	
	    var node;
	    if (bucket[low] <= SEQ_START) {
	        // There's already a sequence with  - use it.
	        node = this.encodeTableSeq[SEQ_START-bucket[low]];
	    }
	    else {
	        // There was no sequence object - allocate a new one.
	        node = {};
	        if (bucket[low] !== UNASSIGNED) node[DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
	        bucket[low] = SEQ_START - this.encodeTableSeq.length;
	        this.encodeTableSeq.push(node);
	    }
	
	    // Traverse the character tree, allocating new nodes as needed.
	    for (var j = 1; j < seq.length-1; j++) {
	        var oldVal = node[uCode];
	        if (typeof oldVal === 'object')
	            node = oldVal;
	        else {
	            node = node[uCode] = {}
	            if (oldVal !== undefined)
	                node[DEF_CHAR] = oldVal
	        }
	    }
	
	    // Set the leaf to given dbcsCode.
	    uCode = seq[seq.length-1];
	    node[uCode] = dbcsCode;
	}
	
	DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
	    var node = this.decodeTables[nodeIdx];
	    for (var i = 0; i < 0x100; i++) {
	        var uCode = node[i];
	        var mbCode = prefix + i;
	        if (skipEncodeChars[mbCode])
	            continue;
	
	        if (uCode >= 0)
	            this._setEncodeChar(uCode, mbCode);
	        else if (uCode <= NODE_START)
	            this._fillEncodeTable(NODE_START - uCode, mbCode << 8, skipEncodeChars);
	        else if (uCode <= SEQ_START)
	            this._setEncodeSequence(this.decodeTableSeq[SEQ_START - uCode], mbCode);
	    }
	}
	
	
	
	// == Encoder ==================================================================
	
	function DBCSEncoder(options, codec) {
	    // Encoder state
	    this.leadSurrogate = -1;
	    this.seqObj = undefined;
	    
	    // Static data
	    this.encodeTable = codec.encodeTable;
	    this.encodeTableSeq = codec.encodeTableSeq;
	    this.defaultCharSingleByte = codec.defCharSB;
	    this.gb18030 = codec.gb18030;
	}
	
	DBCSEncoder.prototype.write = function(str) {
	    var newBuf = Buffer.alloc(str.length * (this.gb18030 ? 4 : 3)),
	        leadSurrogate = this.leadSurrogate,
	        seqObj = this.seqObj, nextChar = -1,
	        i = 0, j = 0;
	
	    while (true) {
	        // 0. Get next character.
	        if (nextChar === -1) {
	            if (i == str.length) break;
	            var uCode = str.charCodeAt(i++);
	        }
	        else {
	            var uCode = nextChar;
	            nextChar = -1;    
	        }
	
	        // 1. Handle surrogates.
	        if (0xD800 <= uCode && uCode < 0xE000) { // Char is one of surrogates.
	            if (uCode < 0xDC00) { // We've got lead surrogate.
	                if (leadSurrogate === -1) {
	                    leadSurrogate = uCode;
	                    continue;
	                } else {
	                    leadSurrogate = uCode;
	                    // Double lead surrogate found.
	                    uCode = UNASSIGNED;
	                }
	            } else { // We've got trail surrogate.
	                if (leadSurrogate !== -1) {
	                    uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
	                    leadSurrogate = -1;
	                } else {
	                    // Incomplete surrogate pair - only trail surrogate found.
	                    uCode = UNASSIGNED;
	                }
	                
	            }
	        }
	        else if (leadSurrogate !== -1) {
	            // Incomplete surrogate pair - only lead surrogate found.
	            nextChar = uCode; uCode = UNASSIGNED; // Write an error, then current char.
	            leadSurrogate = -1;
	        }
	
	        // 2. Convert uCode character.
	        var dbcsCode = UNASSIGNED;
	        if (seqObj !== undefined && uCode != UNASSIGNED) { // We are in the middle of the sequence
	            var resCode = seqObj[uCode];
	            if (typeof resCode === 'object') { // Sequence continues.
	                seqObj = resCode;
	                continue;
	
	            } else if (typeof resCode == 'number') { // Sequence finished. Write it.
	                dbcsCode = resCode;
	
	            } else if (resCode == undefined) { // Current character is not part of the sequence.
	
	                // Try default character for this sequence
	                resCode = seqObj[DEF_CHAR];
	                if (resCode !== undefined) {
	                    dbcsCode = resCode; // Found. Write it.
	                    nextChar = uCode; // Current character will be written too in the next iteration.
	
	                } else {
	                    // TODO: What if we have no default? (resCode == undefined)
	                    // Then, we should write first char of the sequence as-is and try the rest recursively.
	                    // Didn't do it for now because no encoding has this situation yet.
	                    // Currently, just skip the sequence and write current char.
	                }
	            }
	            seqObj = undefined;
	        }
	        else if (uCode >= 0) {  // Regular character
	            var subtable = this.encodeTable[uCode >> 8];
	            if (subtable !== undefined)
	                dbcsCode = subtable[uCode & 0xFF];
	            
	            if (dbcsCode <= SEQ_START) { // Sequence start
	                seqObj = this.encodeTableSeq[SEQ_START-dbcsCode];
	                continue;
	            }
	
	            if (dbcsCode == UNASSIGNED && this.gb18030) {
	                // Use GB18030 algorithm to find character(s) to write.
	                var idx = findIdx(this.gb18030.uChars, uCode);
	                if (idx != -1) {
	                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
	                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600); dbcsCode = dbcsCode % 12600;
	                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260); dbcsCode = dbcsCode % 1260;
	                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10); dbcsCode = dbcsCode % 10;
	                    newBuf[j++] = 0x30 + dbcsCode;
	                    continue;
	                }
	            }
	        }
	
	        // 3. Write dbcsCode character.
	        if (dbcsCode === UNASSIGNED)
	            dbcsCode = this.defaultCharSingleByte;
	        
	        if (dbcsCode < 0x100) {
	            newBuf[j++] = dbcsCode;
	        }
	        else if (dbcsCode < 0x10000) {
	            newBuf[j++] = dbcsCode >> 8;   // high byte
	            newBuf[j++] = dbcsCode & 0xFF; // low byte
	        }
	        else {
	            newBuf[j++] = dbcsCode >> 16;
	            newBuf[j++] = (dbcsCode >> 8) & 0xFF;
	            newBuf[j++] = dbcsCode & 0xFF;
	        }
	    }
	
	    this.seqObj = seqObj;
	    this.leadSurrogate = leadSurrogate;
	    return newBuf.slice(0, j);
	}
	
	DBCSEncoder.prototype.end = function() {
	    if (this.leadSurrogate === -1 && this.seqObj === undefined)
	        return; // All clean. Most often case.
	
	    var newBuf = Buffer.alloc(10), j = 0;
	
	    if (this.seqObj) { // We're in the sequence.
	        var dbcsCode = this.seqObj[DEF_CHAR];
	        if (dbcsCode !== undefined) { // Write beginning of the sequence.
	            if (dbcsCode < 0x100) {
	                newBuf[j++] = dbcsCode;
	            }
	            else {
	                newBuf[j++] = dbcsCode >> 8;   // high byte
	                newBuf[j++] = dbcsCode & 0xFF; // low byte
	            }
	        } else {
	            // See todo above.
	        }
	        this.seqObj = undefined;
	    }
	
	    if (this.leadSurrogate !== -1) {
	        // Incomplete surrogate pair - only lead surrogate found.
	        newBuf[j++] = this.defaultCharSingleByte;
	        this.leadSurrogate = -1;
	    }
	    
	    return newBuf.slice(0, j);
	}
	
	// Export for testing
	DBCSEncoder.prototype.findIdx = findIdx;
	
	
	// == Decoder ==================================================================
	
	function DBCSDecoder(options, codec) {
	    // Decoder state
	    this.nodeIdx = 0;
	    this.prevBuf = Buffer.alloc(0);
	
	    // Static data
	    this.decodeTables = codec.decodeTables;
	    this.decodeTableSeq = codec.decodeTableSeq;
	    this.defaultCharUnicode = codec.defaultCharUnicode;
	    this.gb18030 = codec.gb18030;
	}
	
	DBCSDecoder.prototype.write = function(buf) {
	    var newBuf = Buffer.alloc(buf.length*2),
	        nodeIdx = this.nodeIdx, 
	        prevBuf = this.prevBuf, prevBufOffset = this.prevBuf.length,
	        seqStart = -this.prevBuf.length, // idx of the start of current parsed sequence.
	        uCode;
	
	    if (prevBufOffset > 0) // Make prev buf overlap a little to make it easier to slice later.
	        prevBuf = Buffer.concat([prevBuf, buf.slice(0, 10)]);
	    
	    for (var i = 0, j = 0; i < buf.length; i++) {
	        var curByte = (i >= 0) ? buf[i] : prevBuf[i + prevBufOffset];
	
	        // Lookup in current trie node.
	        var uCode = this.decodeTables[nodeIdx][curByte];
	
	        if (uCode >= 0) { 
	            // Normal character, just use it.
	        }
	        else if (uCode === UNASSIGNED) { // Unknown char.
	            // TODO: Callback with seq.
	            //var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
	            i = seqStart; // Try to parse again, after skipping first byte of the sequence ('i' will be incremented by 'for' cycle).
	            uCode = this.defaultCharUnicode.charCodeAt(0);
	        }
	        else if (uCode === GB18030_CODE) {
	            var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
	            var ptr = (curSeq[0]-0x81)*12600 + (curSeq[1]-0x30)*1260 + (curSeq[2]-0x81)*10 + (curSeq[3]-0x30);
	            var idx = findIdx(this.gb18030.gbChars, ptr);
	            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
	        }
	        else if (uCode <= NODE_START) { // Go to next trie node.
	            nodeIdx = NODE_START - uCode;
	            continue;
	        }
	        else if (uCode <= SEQ_START) { // Output a sequence of chars.
	            var seq = this.decodeTableSeq[SEQ_START - uCode];
	            for (var k = 0; k < seq.length - 1; k++) {
	                uCode = seq[k];
	                newBuf[j++] = uCode & 0xFF;
	                newBuf[j++] = uCode >> 8;
	            }
	            uCode = seq[seq.length-1];
	        }
	        else
	            throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte);
	
	        // Write the character to buffer, handling higher planes using surrogate pair.
	        if (uCode > 0xFFFF) { 
	            uCode -= 0x10000;
	            var uCodeLead = 0xD800 + Math.floor(uCode / 0x400);
	            newBuf[j++] = uCodeLead & 0xFF;
	            newBuf[j++] = uCodeLead >> 8;
	
	            uCode = 0xDC00 + uCode % 0x400;
	        }
	        newBuf[j++] = uCode & 0xFF;
	        newBuf[j++] = uCode >> 8;
	
	        // Reset trie node.
	        nodeIdx = 0; seqStart = i+1;
	    }
	
	    this.nodeIdx = nodeIdx;
	    this.prevBuf = (seqStart >= 0) ? buf.slice(seqStart) : prevBuf.slice(seqStart + prevBufOffset);
	    return newBuf.slice(0, j).toString('ucs2');
	}
	
	DBCSDecoder.prototype.end = function() {
	    var ret = '';
	
	    // Try to parse all remaining chars.
	    while (this.prevBuf.length > 0) {
	        // Skip 1 character in the buffer.
	        ret += this.defaultCharUnicode;
	        var buf = this.prevBuf.slice(1);
	
	        // Parse remaining as usual.
	        this.prevBuf = Buffer.alloc(0);
	        this.nodeIdx = 0;
	        if (buf.length > 0)
	            ret += this.write(buf);
	    }
	
	    this.nodeIdx = 0;
	    return ret;
	}
	
	// Binary search for GB18030. Returns largest i such that table[i] <= val.
	function findIdx(table, val) {
	    if (table[0] > val)
	        return -1;
	
	    var l = 0, r = table.length;
	    while (l < r-1) { // always table[l] <= val < table[r]
	        var mid = l + Math.floor((r-l+1)/2);
	        if (table[mid] <= val)
	            l = mid;
	        else
	            r = mid;
	    }
	    return l;
	}
	


/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	// Description of supported double byte encodings and aliases.
	// Tables are not require()-d until they are needed to speed up library load.
	// require()-s are direct to support Browserify.
	
	module.exports = {
	    
	    // == Japanese/ShiftJIS ====================================================
	    // All japanese encodings are based on JIS X set of standards:
	    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
	    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
	    //              Has several variations in 1978, 1983, 1990 and 1997.
	    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
	    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
	    //              2 planes, first is superset of 0208, second - revised 0212.
	    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)
	
	    // Byte encodings are:
	    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
	    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
	    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
	    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
	    //               0x00-0x7F       - lower part of 0201
	    //               0x8E, 0xA1-0xDF - upper part of 0201
	    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
	    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
	    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
	    //               Used as-is in ISO2022 family.
	    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
	    //                0201-1976 Roman, 0208-1978, 0208-1983.
	    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
	    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
	    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
	    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
	    //
	    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
	    //
	    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html
	
	    'shiftjis': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(1805) },
	        encodeAdd: {'\u00a5': 0x5C, '\u203E': 0x7E},
	        encodeSkipVals: [{from: 0xED40, to: 0xF940}],
	    },
	    'csshiftjis': 'shiftjis',
	    'mskanji': 'shiftjis',
	    'sjis': 'shiftjis',
	    'windows31j': 'shiftjis',
	    'ms31j': 'shiftjis',
	    'xsjis': 'shiftjis',
	    'windows932': 'shiftjis',
	    'ms932': 'shiftjis',
	    '932': 'shiftjis',
	    'cp932': 'shiftjis',
	
	    'eucjp': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(1803) },
	        encodeAdd: {'\u00a5': 0x5C, '\u203E': 0x7E},
	    },
	
	    // TODO: KDDI extension to Shift_JIS
	    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
	    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.
	
	
	    // == Chinese/GBK ==========================================================
	    // http://en.wikipedia.org/wiki/GBK
	    // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder
	
	    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
	    'gb2312': 'cp936',
	    'gb231280': 'cp936',
	    'gb23121980': 'cp936',
	    'csgb2312': 'cp936',
	    'csiso58gb231280': 'cp936',
	    'euccn': 'cp936',
	
	    // Microsoft's CP936 is a subset and approximation of GBK.
	    'windows936': 'cp936',
	    'ms936': 'cp936',
	    '936': 'cp936',
	    'cp936': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(1055) },
	    },
	
	    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
	    'gbk': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(1055).concat(__webpack_require__(1338)) },
	    },
	    'xgbk': 'gbk',
	    'isoir58': 'gbk',
	
	    // GB18030 is an algorithmic extension of GBK.
	    // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
	    // http://icu-project.org/docs/papers/gb18030.html
	    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
	    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
	    'gb18030': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(1055).concat(__webpack_require__(1338)) },
	        gb18030: function() { return __webpack_require__(1804) },
	        encodeSkipVals: [0x80],
	        encodeAdd: {'€': 0xA2E3},
	    },
	
	    'chinese': 'gb18030',
	
	
	    // == Korean ===============================================================
	    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
	    'windows949': 'cp949',
	    'ms949': 'cp949',
	    '949': 'cp949',
	    'cp949': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(1802) },
	    },
	
	    'cseuckr': 'cp949',
	    'csksc56011987': 'cp949',
	    'euckr': 'cp949',
	    'isoir149': 'cp949',
	    'korean': 'cp949',
	    'ksc56011987': 'cp949',
	    'ksc56011989': 'cp949',
	    'ksc5601': 'cp949',
	
	
	    // == Big5/Taiwan/Hong Kong ================================================
	    // There are lots of tables for Big5 and cp950. Please see the following links for history:
	    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
	    // Variations, in roughly number of defined chars:
	    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
	    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
	    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
	    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
	    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
	    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
	    //    Plus, it has 4 combining sequences.
	    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
	    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
	    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
	    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
	    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
	    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
	    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
	    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
	    // 
	    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
	    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.
	
	    'windows950': 'cp950',
	    'ms950': 'cp950',
	    '950': 'cp950',
	    'cp950': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(1337) },
	    },
	
	    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
	    'big5': 'big5hkscs',
	    'big5hkscs': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(1337).concat(__webpack_require__(1801)) },
	        encodeSkipVals: [0xa2cc],
	    },
	
	    'cnbig5': 'big5hkscs',
	    'csbig5': 'big5hkscs',
	    'xxbig5': 'big5hkscs',
	};


/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	// Update this array if you add/rename/remove files in this directory.
	// We support Browserify by skipping automatic module discovery and requiring modules directly.
	var modules = [
	    __webpack_require__(1782),
	    __webpack_require__(1786),
	    __webpack_require__(1787),
	    __webpack_require__(1783),
	    __webpack_require__(1785),
	    __webpack_require__(1784),
	    __webpack_require__(1779),
	    __webpack_require__(1780),
	];
	
	// Put all encoding/alias/codec definitions to single object and export it. 
	for (var i = 0; i < modules.length; i++) {
	    var module = modules[i];
	    for (var enc in module)
	        if (Object.prototype.hasOwnProperty.call(module, enc))
	            exports[enc] = module[enc];
	}


/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Buffer = __webpack_require__(687).Buffer;
	
	// Export Node.js internal encodings.
	
	module.exports = {
	    // Encodings
	    utf8:   { type: "_internal", bomAware: true},
	    cesu8:  { type: "_internal", bomAware: true},
	    unicode11utf8: "utf8",
	
	    ucs2:   { type: "_internal", bomAware: true},
	    utf16le: "ucs2",
	
	    binary: { type: "_internal" },
	    base64: { type: "_internal" },
	    hex:    { type: "_internal" },
	
	    // Codec.
	    _internal: InternalCodec,
	};
	
	//------------------------------------------------------------------------------
	
	function InternalCodec(codecOptions, iconv) {
	    this.enc = codecOptions.encodingName;
	    this.bomAware = codecOptions.bomAware;
	
	    if (this.enc === "base64")
	        this.encoder = InternalEncoderBase64;
	    else if (this.enc === "cesu8") {
	        this.enc = "utf8"; // Use utf8 for decoding.
	        this.encoder = InternalEncoderCesu8;
	
	        // Add decoder for versions of Node not supporting CESU-8
	        if (Buffer.from('eda0bdedb2a9', 'hex').toString() !== '💩') {
	            this.decoder = InternalDecoderCesu8;
	            this.defaultCharUnicode = iconv.defaultCharUnicode;
	        }
	    }
	}
	
	InternalCodec.prototype.encoder = InternalEncoder;
	InternalCodec.prototype.decoder = InternalDecoder;
	
	//------------------------------------------------------------------------------
	
	// We use node.js internal decoder. Its signature is the same as ours.
	var StringDecoder = __webpack_require__(1872).StringDecoder;
	
	if (!StringDecoder.prototype.end) // Node v0.8 doesn't have this method.
	    StringDecoder.prototype.end = function() {};
	
	
	function InternalDecoder(options, codec) {
	    StringDecoder.call(this, codec.enc);
	}
	
	InternalDecoder.prototype = StringDecoder.prototype;
	
	
	//------------------------------------------------------------------------------
	// Encoder is mostly trivial
	
	function InternalEncoder(options, codec) {
	    this.enc = codec.enc;
	}
	
	InternalEncoder.prototype.write = function(str) {
	    return Buffer.from(str, this.enc);
	}
	
	InternalEncoder.prototype.end = function() {
	}
	
	
	//------------------------------------------------------------------------------
	// Except base64 encoder, which must keep its state.
	
	function InternalEncoderBase64(options, codec) {
	    this.prevStr = '';
	}
	
	InternalEncoderBase64.prototype.write = function(str) {
	    str = this.prevStr + str;
	    var completeQuads = str.length - (str.length % 4);
	    this.prevStr = str.slice(completeQuads);
	    str = str.slice(0, completeQuads);
	
	    return Buffer.from(str, "base64");
	}
	
	InternalEncoderBase64.prototype.end = function() {
	    return Buffer.from(this.prevStr, "base64");
	}
	
	
	//------------------------------------------------------------------------------
	// CESU-8 encoder is also special.
	
	function InternalEncoderCesu8(options, codec) {
	}
	
	InternalEncoderCesu8.prototype.write = function(str) {
	    var buf = Buffer.alloc(str.length * 3), bufIdx = 0;
	    for (var i = 0; i < str.length; i++) {
	        var charCode = str.charCodeAt(i);
	        // Naive implementation, but it works because CESU-8 is especially easy
	        // to convert from UTF-16 (which all JS strings are encoded in).
	        if (charCode < 0x80)
	            buf[bufIdx++] = charCode;
	        else if (charCode < 0x800) {
	            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
	            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
	        }
	        else { // charCode will always be < 0x10000 in javascript.
	            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
	            buf[bufIdx++] = 0x80 + ((charCode >>> 6) & 0x3f);
	            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
	        }
	    }
	    return buf.slice(0, bufIdx);
	}
	
	InternalEncoderCesu8.prototype.end = function() {
	}
	
	//------------------------------------------------------------------------------
	// CESU-8 decoder is not implemented in Node v4.0+
	
	function InternalDecoderCesu8(options, codec) {
	    this.acc = 0;
	    this.contBytes = 0;
	    this.accBytes = 0;
	    this.defaultCharUnicode = codec.defaultCharUnicode;
	}
	
	InternalDecoderCesu8.prototype.write = function(buf) {
	    var acc = this.acc, contBytes = this.contBytes, accBytes = this.accBytes, 
	        res = '';
	    for (var i = 0; i < buf.length; i++) {
	        var curByte = buf[i];
	        if ((curByte & 0xC0) !== 0x80) { // Leading byte
	            if (contBytes > 0) { // Previous code is invalid
	                res += this.defaultCharUnicode;
	                contBytes = 0;
	            }
	
	            if (curByte < 0x80) { // Single-byte code
	                res += String.fromCharCode(curByte);
	            } else if (curByte < 0xE0) { // Two-byte code
	                acc = curByte & 0x1F;
	                contBytes = 1; accBytes = 1;
	            } else if (curByte < 0xF0) { // Three-byte code
	                acc = curByte & 0x0F;
	                contBytes = 2; accBytes = 1;
	            } else { // Four or more are not supported for CESU-8.
	                res += this.defaultCharUnicode;
	            }
	        } else { // Continuation byte
	            if (contBytes > 0) { // We're waiting for it.
	                acc = (acc << 6) | (curByte & 0x3f);
	                contBytes--; accBytes++;
	                if (contBytes === 0) {
	                    // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
	                    if (accBytes === 2 && acc < 0x80 && acc > 0)
	                        res += this.defaultCharUnicode;
	                    else if (accBytes === 3 && acc < 0x800)
	                        res += this.defaultCharUnicode;
	                    else
	                        // Actually add character.
	                        res += String.fromCharCode(acc);
	                }
	            } else { // Unexpected continuation byte
	                res += this.defaultCharUnicode;
	            }
	        }
	    }
	    this.acc = acc; this.contBytes = contBytes; this.accBytes = accBytes;
	    return res;
	}
	
	InternalDecoderCesu8.prototype.end = function() {
	    var res = 0;
	    if (this.contBytes > 0)
	        res += this.defaultCharUnicode;
	    return res;
	}


/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Buffer = __webpack_require__(687).Buffer;
	
	// Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
	// correspond to encoded bytes (if 128 - then lower half is ASCII). 
	
	exports._sbcs = SBCSCodec;
	function SBCSCodec(codecOptions, iconv) {
	    if (!codecOptions)
	        throw new Error("SBCS codec is called without the data.")
	    
	    // Prepare char buffer for decoding.
	    if (!codecOptions.chars || (codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256))
	        throw new Error("Encoding '"+codecOptions.type+"' has incorrect 'chars' (must be of len 128 or 256)");
	    
	    if (codecOptions.chars.length === 128) {
	        var asciiString = "";
	        for (var i = 0; i < 128; i++)
	            asciiString += String.fromCharCode(i);
	        codecOptions.chars = asciiString + codecOptions.chars;
	    }
	
	    this.decodeBuf = Buffer.from(codecOptions.chars, 'ucs2');
	    
	    // Encoding buffer.
	    var encodeBuf = Buffer.alloc(65536, iconv.defaultCharSingleByte.charCodeAt(0));
	
	    for (var i = 0; i < codecOptions.chars.length; i++)
	        encodeBuf[codecOptions.chars.charCodeAt(i)] = i;
	
	    this.encodeBuf = encodeBuf;
	}
	
	SBCSCodec.prototype.encoder = SBCSEncoder;
	SBCSCodec.prototype.decoder = SBCSDecoder;
	
	
	function SBCSEncoder(options, codec) {
	    this.encodeBuf = codec.encodeBuf;
	}
	
	SBCSEncoder.prototype.write = function(str) {
	    var buf = Buffer.alloc(str.length);
	    for (var i = 0; i < str.length; i++)
	        buf[i] = this.encodeBuf[str.charCodeAt(i)];
	    
	    return buf;
	}
	
	SBCSEncoder.prototype.end = function() {
	}
	
	
	function SBCSDecoder(options, codec) {
	    this.decodeBuf = codec.decodeBuf;
	}
	
	SBCSDecoder.prototype.write = function(buf) {
	    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
	    var decodeBuf = this.decodeBuf;
	    var newBuf = Buffer.alloc(buf.length*2);
	    var idx1 = 0, idx2 = 0;
	    for (var i = 0; i < buf.length; i++) {
	        idx1 = buf[i]*2; idx2 = i*2;
	        newBuf[idx2] = decodeBuf[idx1];
	        newBuf[idx2+1] = decodeBuf[idx1+1];
	    }
	    return newBuf.toString('ucs2');
	}
	
	SBCSDecoder.prototype.end = function() {
	}


/***/ },
/* 1784 */
/***/ function(module, exports) {

	"use strict";
	
	// Generated data for sbcs codec. Don't edit manually. Regenerate using generation/gen-sbcs.js script.
	module.exports = {
	  "437": "cp437",
	  "737": "cp737",
	  "775": "cp775",
	  "850": "cp850",
	  "852": "cp852",
	  "855": "cp855",
	  "856": "cp856",
	  "857": "cp857",
	  "858": "cp858",
	  "860": "cp860",
	  "861": "cp861",
	  "862": "cp862",
	  "863": "cp863",
	  "864": "cp864",
	  "865": "cp865",
	  "866": "cp866",
	  "869": "cp869",
	  "874": "windows874",
	  "922": "cp922",
	  "1046": "cp1046",
	  "1124": "cp1124",
	  "1125": "cp1125",
	  "1129": "cp1129",
	  "1133": "cp1133",
	  "1161": "cp1161",
	  "1162": "cp1162",
	  "1163": "cp1163",
	  "1250": "windows1250",
	  "1251": "windows1251",
	  "1252": "windows1252",
	  "1253": "windows1253",
	  "1254": "windows1254",
	  "1255": "windows1255",
	  "1256": "windows1256",
	  "1257": "windows1257",
	  "1258": "windows1258",
	  "28591": "iso88591",
	  "28592": "iso88592",
	  "28593": "iso88593",
	  "28594": "iso88594",
	  "28595": "iso88595",
	  "28596": "iso88596",
	  "28597": "iso88597",
	  "28598": "iso88598",
	  "28599": "iso88599",
	  "28600": "iso885910",
	  "28601": "iso885911",
	  "28603": "iso885913",
	  "28604": "iso885914",
	  "28605": "iso885915",
	  "28606": "iso885916",
	  "windows874": {
	    "type": "_sbcs",
	    "chars": "€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  },
	  "win874": "windows874",
	  "cp874": "windows874",
	  "windows1250": {
	    "type": "_sbcs",
	    "chars": "€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙"
	  },
	  "win1250": "windows1250",
	  "cp1250": "windows1250",
	  "windows1251": {
	    "type": "_sbcs",
	    "chars": "ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
	  },
	  "win1251": "windows1251",
	  "cp1251": "windows1251",
	  "windows1252": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "win1252": "windows1252",
	  "cp1252": "windows1252",
	  "windows1253": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
	  },
	  "win1253": "windows1253",
	  "cp1253": "windows1253",
	  "windows1254": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ"
	  },
	  "win1254": "windows1254",
	  "cp1254": "windows1254",
	  "windows1255": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹֺֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
	  },
	  "win1255": "windows1255",
	  "cp1255": "windows1255",
	  "windows1256": {
	    "type": "_sbcs",
	    "chars": "€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے"
	  },
	  "win1256": "windows1256",
	  "cp1256": "windows1256",
	  "windows1257": {
	    "type": "_sbcs",
	    "chars": "€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙"
	  },
	  "win1257": "windows1257",
	  "cp1257": "windows1257",
	  "windows1258": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
	  },
	  "win1258": "windows1258",
	  "cp1258": "windows1258",
	  "iso88591": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "cp28591": "iso88591",
	  "iso88592": {
	    "type": "_sbcs",
	    "chars": " Ą˘Ł¤ĽŚ§¨ŠŞŤŹ­ŽŻ°ą˛ł´ľśˇ¸šşťź˝žżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙"
	  },
	  "cp28592": "iso88592",
	  "iso88593": {
	    "type": "_sbcs",
	    "chars": " Ħ˘£¤�Ĥ§¨İŞĞĴ­�Ż°ħ²³´µĥ·¸ışğĵ½�żÀÁÂ�ÄĊĈÇÈÉÊËÌÍÎÏ�ÑÒÓÔĠÖ×ĜÙÚÛÜŬŜßàáâ�äċĉçèéêëìíîï�ñòóôġö÷ĝùúûüŭŝ˙"
	  },
	  "cp28593": "iso88593",
	  "iso88594": {
	    "type": "_sbcs",
	    "chars": " ĄĸŖ¤ĨĻ§¨ŠĒĢŦ­Ž¯°ą˛ŗ´ĩļˇ¸šēģŧŊžŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎĪĐŅŌĶÔÕÖ×ØŲÚÛÜŨŪßāáâãäåæįčéęëėíîīđņōķôõö÷øųúûüũū˙"
	  },
	  "cp28594": "iso88594",
	  "iso88595": {
	    "type": "_sbcs",
	    "chars": " ЁЂЃЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђѓєѕіїјљњћќ§ўџ"
	  },
	  "cp28595": "iso88595",
	  "iso88596": {
	    "type": "_sbcs",
	    "chars": " ���¤�������،­�������������؛���؟�ءآأؤإئابةتثجحخدذرزسشصضطظعغ�����ـفقكلمنهوىيًٌٍَُِّْ�������������"
	  },
	  "cp28596": "iso88596",
	  "iso88597": {
	    "type": "_sbcs",
	    "chars": " ‘’£€₯¦§¨©ͺ«¬­�―°±²³΄΅Ά·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
	  },
	  "cp28597": "iso88597",
	  "iso88598": {
	    "type": "_sbcs",
	    "chars": " �¢£¤¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾��������������������������������‗אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
	  },
	  "cp28598": "iso88598",
	  "iso88599": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ"
	  },
	  "cp28599": "iso88599",
	  "iso885910": {
	    "type": "_sbcs",
	    "chars": " ĄĒĢĪĨĶ§ĻĐŠŦŽ­ŪŊ°ąēģīĩķ·ļđšŧž―ūŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎÏÐŅŌÓÔÕÖŨØŲÚÛÜÝÞßāáâãäåæįčéęëėíîïðņōóôõöũøųúûüýþĸ"
	  },
	  "cp28600": "iso885910",
	  "iso885911": {
	    "type": "_sbcs",
	    "chars": " กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  },
	  "cp28601": "iso885911",
	  "iso885913": {
	    "type": "_sbcs",
	    "chars": " ”¢£¤„¦§Ø©Ŗ«¬­®Æ°±²³“µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž’"
	  },
	  "cp28603": "iso885913",
	  "iso885914": {
	    "type": "_sbcs",
	    "chars": " Ḃḃ£ĊċḊ§Ẁ©ẂḋỲ­®ŸḞḟĠġṀṁ¶ṖẁṗẃṠỳẄẅṡÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŴÑÒÓÔÕÖṪØÙÚÛÜÝŶßàáâãäåæçèéêëìíîïŵñòóôõöṫøùúûüýŷÿ"
	  },
	  "cp28604": "iso885914",
	  "iso885915": {
	    "type": "_sbcs",
	    "chars": " ¡¢£€¥Š§š©ª«¬­®¯°±²³Žµ¶·ž¹º»ŒœŸ¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "cp28605": "iso885915",
	  "iso885916": {
	    "type": "_sbcs",
	    "chars": " ĄąŁ€„Š§š©Ș«Ź­źŻ°±ČłŽ”¶·žčș»ŒœŸżÀÁÂĂÄĆÆÇÈÉÊËÌÍÎÏĐŃÒÓÔŐÖŚŰÙÚÛÜĘȚßàáâăäćæçèéêëìíîïđńòóôőöśűùúûüęțÿ"
	  },
	  "cp28606": "iso885916",
	  "cp437": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm437": "cp437",
	  "csibm437": "cp437",
	  "cp737": {
	    "type": "_sbcs",
	    "chars": "ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ "
	  },
	  "ibm737": "cp737",
	  "csibm737": "cp737",
	  "cp775": {
	    "type": "_sbcs",
	    "chars": "ĆüéāäģåćłēŖŗīŹÄÅÉæÆōöĢ¢ŚśÖÜø£Ø×¤ĀĪóŻżź”¦©®¬½¼Ł«»░▒▓│┤ĄČĘĖ╣║╗╝ĮŠ┐└┴┬├─┼ŲŪ╚╔╩╦╠═╬Žąčęėįšųūž┘┌█▄▌▐▀ÓßŌŃõÕµńĶķĻļņĒŅ’­±“¾¶§÷„°∙·¹³²■ "
	  },
	  "ibm775": "cp775",
	  "csibm775": "cp775",
	  "cp850": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm850": "cp850",
	  "csibm850": "cp850",
	  "cp852": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ "
	  },
	  "ibm852": "cp852",
	  "csibm852": "cp852",
	  "cp855": {
	    "type": "_sbcs",
	    "chars": "ђЂѓЃёЁєЄѕЅіІїЇјЈљЉњЊћЋќЌўЎџЏюЮъЪаАбБцЦдДеЕфФгГ«»░▒▓│┤хХиИ╣║╗╝йЙ┐└┴┬├─┼кК╚╔╩╦╠═╬¤лЛмМнНоОп┘┌█▄Пя▀ЯрРсСтТуУжЖвВьЬ№­ыЫзЗшШэЭщЩчЧ§■ "
	  },
	  "ibm855": "cp855",
	  "csibm855": "cp855",
	  "cp856": {
	    "type": "_sbcs",
	    "chars": "אבגדהוזחטיךכלםמןנסעףפץצקרשת�£�×����������®¬½¼�«»░▒▓│┤���©╣║╗╝¢¥┐└┴┬├─┼��╚╔╩╦╠═╬¤���������┘┌█▄¦�▀������µ�������¯´­±‗¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm856": "cp856",
	  "csibm856": "cp856",
	  "cp857": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm857": "cp857",
	  "csibm857": "cp857",
	  "cp858": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈ€ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm858": "cp858",
	  "csibm858": "cp858",
	  "cp860": {
	    "type": "_sbcs",
	    "chars": "ÇüéâãàÁçêÊèÍÔìÃÂÉÀÈôõòÚùÌÕÜ¢£Ù₧ÓáíóúñÑªº¿Ò¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm860": "cp860",
	  "csibm860": "cp860",
	  "cp861": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm861": "cp861",
	  "csibm861": "cp861",
	  "cp862": {
	    "type": "_sbcs",
	    "chars": "אבגדהוזחטיךכלםמןנסעףפץצקרשת¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm862": "cp862",
	  "csibm862": "cp862",
	  "cp863": {
	    "type": "_sbcs",
	    "chars": "ÇüéâÂà¶çêëèïî‗À§ÉÈÊôËÏûù¤ÔÜ¢£ÙÛƒ¦´óú¨¸³¯Î⌐¬½¼¾«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm863": "cp863",
	  "csibm863": "cp863",
	  "cp864": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$٪&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~°·∙√▒─│┼┤┬├┴┐┌└┘β∞φ±½¼≈«»ﻷﻸ��ﻻﻼ� ­ﺂ£¤ﺄ��ﺎﺏﺕﺙ،ﺝﺡﺥ٠١٢٣٤٥٦٧٨٩ﻑ؛ﺱﺵﺹ؟¢ﺀﺁﺃﺅﻊﺋﺍﺑﺓﺗﺛﺟﺣﺧﺩﺫﺭﺯﺳﺷﺻﺿﻁﻅﻋﻏ¦¬÷×ﻉـﻓﻗﻛﻟﻣﻧﻫﻭﻯﻳﺽﻌﻎﻍﻡﹽّﻥﻩﻬﻰﻲﻐﻕﻵﻶﻝﻙﻱ■�"
	  },
	  "ibm864": "cp864",
	  "csibm864": "cp864",
	  "cp865": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm865": "cp865",
	  "csibm865": "cp865",
	  "cp866": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ "
	  },
	  "ibm866": "cp866",
	  "csibm866": "cp866",
	  "cp869": {
	    "type": "_sbcs",
	    "chars": "������Ά�·¬¦‘’Έ―ΉΊΪΌ��ΎΫ©Ώ²³ά£έήίϊΐόύΑΒΓΔΕΖΗ½ΘΙ«»░▒▓│┤ΚΛΜΝ╣║╗╝ΞΟ┐└┴┬├─┼ΠΡ╚╔╩╦╠═╬ΣΤΥΦΧΨΩαβγ┘┌█▄δε▀ζηθικλμνξοπρσςτ΄­±υφχ§ψ΅°¨ωϋΰώ■ "
	  },
	  "ibm869": "cp869",
	  "csibm869": "cp869",
	  "cp922": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§¨©ª«¬­®‾°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŠÑÒÓÔÕÖ×ØÙÚÛÜÝŽßàáâãäåæçèéêëìíîïšñòóôõö÷øùúûüýžÿ"
	  },
	  "ibm922": "cp922",
	  "csibm922": "cp922",
	  "cp1046": {
	    "type": "_sbcs",
	    "chars": "ﺈ×÷ﹱ■│─┐┌└┘ﹹﹻﹽﹿﹷﺊﻰﻳﻲﻎﻏﻐﻶﻸﻺﻼ ¤ﺋﺑﺗﺛﺟﺣ،­ﺧﺳ٠١٢٣٤٥٦٧٨٩ﺷ؛ﺻﺿﻊ؟ﻋءآأؤإئابةتثجحخدذرزسشصضطﻇعغﻌﺂﺄﺎﻓـفقكلمنهوىيًٌٍَُِّْﻗﻛﻟﻵﻷﻹﻻﻣﻧﻬﻩ�"
	  },
	  "ibm1046": "cp1046",
	  "csibm1046": "cp1046",
	  "cp1124": {
	    "type": "_sbcs",
	    "chars": " ЁЂҐЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђґєѕіїјљњћќ§ўџ"
	  },
	  "ibm1124": "cp1124",
	  "csibm1124": "cp1124",
	  "cp1125": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёҐґЄєІіЇї·√№¤■ "
	  },
	  "ibm1125": "cp1125",
	  "csibm1125": "cp1125",
	  "cp1129": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
	  },
	  "ibm1129": "cp1129",
	  "csibm1129": "cp1129",
	  "cp1133": {
	    "type": "_sbcs",
	    "chars": " ກຂຄງຈສຊຍດຕຖທນບປຜຝພຟມຢຣລວຫອຮ���ຯະາຳິີຶືຸູຼັົຽ���ເແໂໃໄ່້໊໋໌ໍໆ�ໜໝ₭����������������໐໑໒໓໔໕໖໗໘໙��¢¬¦�"
	  },
	  "ibm1133": "cp1133",
	  "csibm1133": "cp1133",
	  "cp1161": {
	    "type": "_sbcs",
	    "chars": "��������������������������������่กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู้๊๋€฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛¢¬¦ "
	  },
	  "ibm1161": "cp1161",
	  "csibm1161": "cp1161",
	  "cp1162": {
	    "type": "_sbcs",
	    "chars": "€…‘’“”•–— กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  },
	  "ibm1162": "cp1162",
	  "csibm1162": "cp1162",
	  "cp1163": {
	    "type": "_sbcs",
	    "chars": " ¡¢£€¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
	  },
	  "ibm1163": "cp1163",
	  "csibm1163": "cp1163",
	  "maccroatian": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊�©⁄¤‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ"
	  },
	  "maccyrillic": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤"
	  },
	  "macgreek": {
	    "type": "_sbcs",
	    "chars": "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�"
	  },
	  "maciceland": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macroman": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macromania": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂŞ∞±≤≥¥µ∂∑∏π∫ªºΩăş¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›Ţţ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macthai": {
	    "type": "_sbcs",
	    "chars": "«»…“”�•‘’� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู﻿​–—฿เแโใไๅๆ็่้๊๋์ํ™๏๐๑๒๓๔๕๖๗๘๙®©����"
	  },
	  "macturkish": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macukraine": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤"
	  },
	  "koi8r": {
	    "type": "_sbcs",
	    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ё╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡Ё╢╣╤╥╦╧╨╩╪╫╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "koi8u": {
	    "type": "_sbcs",
	    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґ╝╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪Ґ╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "koi8ru": {
	    "type": "_sbcs",
	    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґў╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪ҐЎ©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "koi8t": {
	    "type": "_sbcs",
	    "chars": "қғ‚Ғ„…†‡�‰ҳ‹ҲҷҶ�Қ‘’“”•–—�™�›�����ӯӮё¤ӣ¦§���«¬­®�°±²Ё�Ӣ¶·�№�»���©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "armscii8": {
	    "type": "_sbcs",
	    "chars": " �և։)(»«—.՝,-֊…՜՛՞ԱաԲբԳգԴդԵեԶզԷէԸըԹթԺժԻիԼլԽխԾծԿկՀհՁձՂղՃճՄմՅյՆնՇշՈոՉչՊպՋջՌռՍսՎվՏտՐրՑցՒւՓփՔքՕօՖֆ՚�"
	  },
	  "rk1048": {
	    "type": "_sbcs",
	    "chars": "ЂЃ‚ѓ„…†‡€‰Љ‹ЊҚҺЏђ‘’“”•–—�™љ›њқһџ ҰұӘ¤Ө¦§Ё©Ғ«¬­®Ү°±Ііөµ¶·ё№ғ»әҢңүАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
	  },
	  "tcvn": {
	    "type": "_sbcs",
	    "chars": "\u0000ÚỤ\u0003ỪỬỮ\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010ỨỰỲỶỸÝỴ\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÀẢÃÁẠẶẬÈẺẼÉẸỆÌỈĨÍỊÒỎÕÓỌỘỜỞỠỚỢÙỦŨ ĂÂÊÔƠƯĐăâêôơưđẶ̀̀̉̃́àảãáạẲằẳẵắẴẮẦẨẪẤỀặầẩẫấậèỂẻẽéẹềểễếệìỉỄẾỒĩíịòỔỏõóọồổỗốộờởỡớợùỖủũúụừửữứựỳỷỹýỵỐ"
	  },
	  "georgianacademy": {
	    "type": "_sbcs",
	    "chars": "‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰჱჲჳჴჵჶçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "georgianps": {
	    "type": "_sbcs",
	    "chars": "‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზჱთიკლმნჲოპჟრსტჳუფქღყშჩცძწჭხჴჯჰჵæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "pt154": {
	    "type": "_sbcs",
	    "chars": "ҖҒӮғ„…ҶҮҲүҠӢҢҚҺҸҗ‘’“”•–—ҳҷҡӣңқһҹ ЎўЈӨҘҰ§Ё©Ә«¬ӯ®Ҝ°ұІіҙө¶·ё№ә»јҪҫҝАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
	  },
	  "viscii": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001Ẳ\u0003\u0004ẴẪ\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013Ỷ\u0015\u0016\u0017\u0018Ỹ\u001a\u001b\u001c\u001dỴ\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ẠẮẰẶẤẦẨẬẼẸẾỀỂỄỆỐỒỔỖỘỢỚỜỞỊỎỌỈỦŨỤỲÕắằặấầẩậẽẹếềểễệốồổỗỠƠộờởịỰỨỪỬơớƯÀÁÂÃẢĂẳẵÈÉÊẺÌÍĨỳĐứÒÓÔạỷừửÙÚỹỵÝỡưàáâãảăữẫèéêẻìíĩỉđựòóôõỏọụùúũủýợỮ"
	  },
	  "iso646cn": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#¥%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������"
	  },
	  "iso646jp": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[¥]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������"
	  },
	  "hproman8": {
	    "type": "_sbcs",
	    "chars": " ÀÂÈÊËÎÏ´ˋˆ¨˜ÙÛ₤¯Ýý°ÇçÑñ¡¿¤£¥§ƒ¢âêôûáéóúàèòùäëöüÅîØÆåíøæÄìÖÜÉïßÔÁÃãÐðÍÌÓÒÕõŠšÚŸÿÞþ·µ¶¾—¼½ªº«■»±�"
	  },
	  "macintosh": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "ascii": {
	    "type": "_sbcs",
	    "chars": "��������������������������������������������������������������������������������������������������������������������������������"
	  },
	  "tis620": {
	    "type": "_sbcs",
	    "chars": "���������������������������������กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  }
	}

/***/ },
/* 1785 */
/***/ function(module, exports) {

	"use strict";
	
	// Manually added data to be used by sbcs codec in addition to generated one.
	
	module.exports = {
	    // Not supported by iconv, not sure why.
	    "10029": "maccenteuro",
	    "maccenteuro": {
	        "type": "_sbcs",
	        "chars": "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ"
	    },
	
	    "808": "cp808",
	    "ibm808": "cp808",
	    "cp808": {
	        "type": "_sbcs",
	        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№€■ "
	    },
	
	    "mik": {
	        "type": "_sbcs",
	        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя└┴┬├─┼╣║╚╔╩╦╠═╬┐░▒▓│┤№§╗╝┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	    },
	
	    // Aliases of generated encodings.
	    "ascii8bit": "ascii",
	    "usascii": "ascii",
	    "ansix34": "ascii",
	    "ansix341968": "ascii",
	    "ansix341986": "ascii",
	    "csascii": "ascii",
	    "cp367": "ascii",
	    "ibm367": "ascii",
	    "isoir6": "ascii",
	    "iso646us": "ascii",
	    "iso646irv": "ascii",
	    "us": "ascii",
	
	    "latin1": "iso88591",
	    "latin2": "iso88592",
	    "latin3": "iso88593",
	    "latin4": "iso88594",
	    "latin5": "iso88599",
	    "latin6": "iso885910",
	    "latin7": "iso885913",
	    "latin8": "iso885914",
	    "latin9": "iso885915",
	    "latin10": "iso885916",
	
	    "csisolatin1": "iso88591",
	    "csisolatin2": "iso88592",
	    "csisolatin3": "iso88593",
	    "csisolatin4": "iso88594",
	    "csisolatincyrillic": "iso88595",
	    "csisolatinarabic": "iso88596",
	    "csisolatingreek" : "iso88597",
	    "csisolatinhebrew": "iso88598",
	    "csisolatin5": "iso88599",
	    "csisolatin6": "iso885910",
	
	    "l1": "iso88591",
	    "l2": "iso88592",
	    "l3": "iso88593",
	    "l4": "iso88594",
	    "l5": "iso88599",
	    "l6": "iso885910",
	    "l7": "iso885913",
	    "l8": "iso885914",
	    "l9": "iso885915",
	    "l10": "iso885916",
	
	    "isoir14": "iso646jp",
	    "isoir57": "iso646cn",
	    "isoir100": "iso88591",
	    "isoir101": "iso88592",
	    "isoir109": "iso88593",
	    "isoir110": "iso88594",
	    "isoir144": "iso88595",
	    "isoir127": "iso88596",
	    "isoir126": "iso88597",
	    "isoir138": "iso88598",
	    "isoir148": "iso88599",
	    "isoir157": "iso885910",
	    "isoir166": "tis620",
	    "isoir179": "iso885913",
	    "isoir199": "iso885914",
	    "isoir203": "iso885915",
	    "isoir226": "iso885916",
	
	    "cp819": "iso88591",
	    "ibm819": "iso88591",
	
	    "cyrillic": "iso88595",
	
	    "arabic": "iso88596",
	    "arabic8": "iso88596",
	    "ecma114": "iso88596",
	    "asmo708": "iso88596",
	
	    "greek" : "iso88597",
	    "greek8" : "iso88597",
	    "ecma118" : "iso88597",
	    "elot928" : "iso88597",
	
	    "hebrew": "iso88598",
	    "hebrew8": "iso88598",
	
	    "turkish": "iso88599",
	    "turkish8": "iso88599",
	
	    "thai": "iso885911",
	    "thai8": "iso885911",
	
	    "celtic": "iso885914",
	    "celtic8": "iso885914",
	    "isoceltic": "iso885914",
	
	    "tis6200": "tis620",
	    "tis62025291": "tis620",
	    "tis62025330": "tis620",
	
	    "10000": "macroman",
	    "10006": "macgreek",
	    "10007": "maccyrillic",
	    "10079": "maciceland",
	    "10081": "macturkish",
	
	    "cspc8codepage437": "cp437",
	    "cspc775baltic": "cp775",
	    "cspc850multilingual": "cp850",
	    "cspcp852": "cp852",
	    "cspc862latinhebrew": "cp862",
	    "cpgr": "cp869",
	
	    "msee": "cp1250",
	    "mscyrl": "cp1251",
	    "msansi": "cp1252",
	    "msgreek": "cp1253",
	    "msturk": "cp1254",
	    "mshebr": "cp1255",
	    "msarab": "cp1256",
	    "winbaltrim": "cp1257",
	
	    "cp20866": "koi8r",
	    "20866": "koi8r",
	    "ibm878": "koi8r",
	    "cskoi8r": "koi8r",
	
	    "cp21866": "koi8u",
	    "21866": "koi8u",
	    "ibm1168": "koi8u",
	
	    "strk10482002": "rk1048",
	
	    "tcvn5712": "tcvn",
	    "tcvn57121": "tcvn",
	
	    "gb198880": "iso646cn",
	    "cn": "iso646cn",
	
	    "csiso14jisc6220ro": "iso646jp",
	    "jisc62201969ro": "iso646jp",
	    "jp": "iso646jp",
	
	    "cshproman8": "hproman8",
	    "r8": "hproman8",
	    "roman8": "hproman8",
	    "xroman8": "hproman8",
	    "ibm1051": "hproman8",
	
	    "mac": "macintosh",
	    "csmacintosh": "macintosh",
	};
	


/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Buffer = __webpack_require__(687).Buffer;
	
	// Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js
	
	// == UTF16-BE codec. ==========================================================
	
	exports.utf16be = Utf16BECodec;
	function Utf16BECodec() {
	}
	
	Utf16BECodec.prototype.encoder = Utf16BEEncoder;
	Utf16BECodec.prototype.decoder = Utf16BEDecoder;
	Utf16BECodec.prototype.bomAware = true;
	
	
	// -- Encoding
	
	function Utf16BEEncoder() {
	}
	
	Utf16BEEncoder.prototype.write = function(str) {
	    var buf = Buffer.from(str, 'ucs2');
	    for (var i = 0; i < buf.length; i += 2) {
	        var tmp = buf[i]; buf[i] = buf[i+1]; buf[i+1] = tmp;
	    }
	    return buf;
	}
	
	Utf16BEEncoder.prototype.end = function() {
	}
	
	
	// -- Decoding
	
	function Utf16BEDecoder() {
	    this.overflowByte = -1;
	}
	
	Utf16BEDecoder.prototype.write = function(buf) {
	    if (buf.length == 0)
	        return '';
	
	    var buf2 = Buffer.alloc(buf.length + 1),
	        i = 0, j = 0;
	
	    if (this.overflowByte !== -1) {
	        buf2[0] = buf[0];
	        buf2[1] = this.overflowByte;
	        i = 1; j = 2;
	    }
	
	    for (; i < buf.length-1; i += 2, j+= 2) {
	        buf2[j] = buf[i+1];
	        buf2[j+1] = buf[i];
	    }
	
	    this.overflowByte = (i == buf.length-1) ? buf[buf.length-1] : -1;
	
	    return buf2.slice(0, j).toString('ucs2');
	}
	
	Utf16BEDecoder.prototype.end = function() {
	}
	
	
	// == UTF-16 codec =============================================================
	// Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
	// Defaults to UTF-16LE, as it's prevalent and default in Node.
	// http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
	// Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});
	
	// Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).
	
	exports.utf16 = Utf16Codec;
	function Utf16Codec(codecOptions, iconv) {
	    this.iconv = iconv;
	}
	
	Utf16Codec.prototype.encoder = Utf16Encoder;
	Utf16Codec.prototype.decoder = Utf16Decoder;
	
	
	// -- Encoding (pass-through)
	
	function Utf16Encoder(options, codec) {
	    options = options || {};
	    if (options.addBOM === undefined)
	        options.addBOM = true;
	    this.encoder = codec.iconv.getEncoder('utf-16le', options);
	}
	
	Utf16Encoder.prototype.write = function(str) {
	    return this.encoder.write(str);
	}
	
	Utf16Encoder.prototype.end = function() {
	    return this.encoder.end();
	}
	
	
	// -- Decoding
	
	function Utf16Decoder(options, codec) {
	    this.decoder = null;
	    this.initialBytes = [];
	    this.initialBytesLen = 0;
	
	    this.options = options || {};
	    this.iconv = codec.iconv;
	}
	
	Utf16Decoder.prototype.write = function(buf) {
	    if (!this.decoder) {
	        // Codec is not chosen yet. Accumulate initial bytes.
	        this.initialBytes.push(buf);
	        this.initialBytesLen += buf.length;
	        
	        if (this.initialBytesLen < 16) // We need more bytes to use space heuristic (see below)
	            return '';
	
	        // We have enough bytes -> detect endianness.
	        var buf = Buffer.concat(this.initialBytes),
	            encoding = detectEncoding(buf, this.options.defaultEncoding);
	        this.decoder = this.iconv.getDecoder(encoding, this.options);
	        this.initialBytes.length = this.initialBytesLen = 0;
	    }
	
	    return this.decoder.write(buf);
	}
	
	Utf16Decoder.prototype.end = function() {
	    if (!this.decoder) {
	        var buf = Buffer.concat(this.initialBytes),
	            encoding = detectEncoding(buf, this.options.defaultEncoding);
	        this.decoder = this.iconv.getDecoder(encoding, this.options);
	
	        var res = this.decoder.write(buf),
	            trail = this.decoder.end();
	
	        return trail ? (res + trail) : res;
	    }
	    return this.decoder.end();
	}
	
	function detectEncoding(buf, defaultEncoding) {
	    var enc = defaultEncoding || 'utf-16le';
	
	    if (buf.length >= 2) {
	        // Check BOM.
	        if (buf[0] == 0xFE && buf[1] == 0xFF) // UTF-16BE BOM
	            enc = 'utf-16be';
	        else if (buf[0] == 0xFF && buf[1] == 0xFE) // UTF-16LE BOM
	            enc = 'utf-16le';
	        else {
	            // No BOM found. Try to deduce encoding from initial content.
	            // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
	            // So, we count ASCII as if it was LE or BE, and decide from that.
	            var asciiCharsLE = 0, asciiCharsBE = 0, // Counts of chars in both positions
	                _len = Math.min(buf.length - (buf.length % 2), 64); // Len is always even.
	
	            for (var i = 0; i < _len; i += 2) {
	                if (buf[i] === 0 && buf[i+1] !== 0) asciiCharsBE++;
	                if (buf[i] !== 0 && buf[i+1] === 0) asciiCharsLE++;
	            }
	
	            if (asciiCharsBE > asciiCharsLE)
	                enc = 'utf-16be';
	            else if (asciiCharsBE < asciiCharsLE)
	                enc = 'utf-16le';
	        }
	    }
	
	    return enc;
	}
	
	


/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Buffer = __webpack_require__(687).Buffer;
	
	// UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
	// See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3
	
	exports.utf7 = Utf7Codec;
	exports.unicode11utf7 = 'utf7'; // Alias UNICODE-1-1-UTF-7
	function Utf7Codec(codecOptions, iconv) {
	    this.iconv = iconv;
	};
	
	Utf7Codec.prototype.encoder = Utf7Encoder;
	Utf7Codec.prototype.decoder = Utf7Decoder;
	Utf7Codec.prototype.bomAware = true;
	
	
	// -- Encoding
	
	var nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;
	
	function Utf7Encoder(options, codec) {
	    this.iconv = codec.iconv;
	}
	
	Utf7Encoder.prototype.write = function(str) {
	    // Naive implementation.
	    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
	    return Buffer.from(str.replace(nonDirectChars, function(chunk) {
	        return "+" + (chunk === '+' ? '' : 
	            this.iconv.encode(chunk, 'utf16-be').toString('base64').replace(/=+$/, '')) 
	            + "-";
	    }.bind(this)));
	}
	
	Utf7Encoder.prototype.end = function() {
	}
	
	
	// -- Decoding
	
	function Utf7Decoder(options, codec) {
	    this.iconv = codec.iconv;
	    this.inBase64 = false;
	    this.base64Accum = '';
	}
	
	var base64Regex = /[A-Za-z0-9\/+]/;
	var base64Chars = [];
	for (var i = 0; i < 256; i++)
	    base64Chars[i] = base64Regex.test(String.fromCharCode(i));
	
	var plusChar = '+'.charCodeAt(0), 
	    minusChar = '-'.charCodeAt(0),
	    andChar = '&'.charCodeAt(0);
	
	Utf7Decoder.prototype.write = function(buf) {
	    var res = "", lastI = 0,
	        inBase64 = this.inBase64,
	        base64Accum = this.base64Accum;
	
	    // The decoder is more involved as we must handle chunks in stream.
	
	    for (var i = 0; i < buf.length; i++) {
	        if (!inBase64) { // We're in direct mode.
	            // Write direct chars until '+'
	            if (buf[i] == plusChar) {
	                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
	                lastI = i+1;
	                inBase64 = true;
	            }
	        } else { // We decode base64.
	            if (!base64Chars[buf[i]]) { // Base64 ended.
	                if (i == lastI && buf[i] == minusChar) {// "+-" -> "+"
	                    res += "+";
	                } else {
	                    var b64str = base64Accum + buf.slice(lastI, i).toString();
	                    res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
	                }
	
	                if (buf[i] != minusChar) // Minus is absorbed after base64.
	                    i--;
	
	                lastI = i+1;
	                inBase64 = false;
	                base64Accum = '';
	            }
	        }
	    }
	
	    if (!inBase64) {
	        res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
	    } else {
	        var b64str = base64Accum + buf.slice(lastI).toString();
	
	        var canBeDecoded = b64str.length - (b64str.length % 8); // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
	        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
	        b64str = b64str.slice(0, canBeDecoded);
	
	        res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
	    }
	
	    this.inBase64 = inBase64;
	    this.base64Accum = base64Accum;
	
	    return res;
	}
	
	Utf7Decoder.prototype.end = function() {
	    var res = "";
	    if (this.inBase64 && this.base64Accum.length > 0)
	        res = this.iconv.decode(Buffer.from(this.base64Accum, 'base64'), "utf16-be");
	
	    this.inBase64 = false;
	    this.base64Accum = '';
	    return res;
	}
	
	
	// UTF-7-IMAP codec.
	// RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
	// Differences:
	//  * Base64 part is started by "&" instead of "+"
	//  * Direct characters are 0x20-0x7E, except "&" (0x26)
	//  * In Base64, "," is used instead of "/"
	//  * Base64 must not be used to represent direct characters.
	//  * No implicit shift back from Base64 (should always end with '-')
	//  * String must end in non-shifted position.
	//  * "-&" while in base64 is not allowed.
	
	
	exports.utf7imap = Utf7IMAPCodec;
	function Utf7IMAPCodec(codecOptions, iconv) {
	    this.iconv = iconv;
	};
	
	Utf7IMAPCodec.prototype.encoder = Utf7IMAPEncoder;
	Utf7IMAPCodec.prototype.decoder = Utf7IMAPDecoder;
	Utf7IMAPCodec.prototype.bomAware = true;
	
	
	// -- Encoding
	
	function Utf7IMAPEncoder(options, codec) {
	    this.iconv = codec.iconv;
	    this.inBase64 = false;
	    this.base64Accum = Buffer.alloc(6);
	    this.base64AccumIdx = 0;
	}
	
	Utf7IMAPEncoder.prototype.write = function(str) {
	    var inBase64 = this.inBase64,
	        base64Accum = this.base64Accum,
	        base64AccumIdx = this.base64AccumIdx,
	        buf = Buffer.alloc(str.length*5 + 10), bufIdx = 0;
	
	    for (var i = 0; i < str.length; i++) {
	        var uChar = str.charCodeAt(i);
	        if (0x20 <= uChar && uChar <= 0x7E) { // Direct character or '&'.
	            if (inBase64) {
	                if (base64AccumIdx > 0) {
	                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
	                    base64AccumIdx = 0;
	                }
	
	                buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
	                inBase64 = false;
	            }
	
	            if (!inBase64) {
	                buf[bufIdx++] = uChar; // Write direct character
	
	                if (uChar === andChar)  // Ampersand -> '&-'
	                    buf[bufIdx++] = minusChar;
	            }
	
	        } else { // Non-direct character
	            if (!inBase64) {
	                buf[bufIdx++] = andChar; // Write '&', then go to base64 mode.
	                inBase64 = true;
	            }
	            if (inBase64) {
	                base64Accum[base64AccumIdx++] = uChar >> 8;
	                base64Accum[base64AccumIdx++] = uChar & 0xFF;
	
	                if (base64AccumIdx == base64Accum.length) {
	                    bufIdx += buf.write(base64Accum.toString('base64').replace(/\//g, ','), bufIdx);
	                    base64AccumIdx = 0;
	                }
	            }
	        }
	    }
	
	    this.inBase64 = inBase64;
	    this.base64AccumIdx = base64AccumIdx;
	
	    return buf.slice(0, bufIdx);
	}
	
	Utf7IMAPEncoder.prototype.end = function() {
	    var buf = Buffer.alloc(10), bufIdx = 0;
	    if (this.inBase64) {
	        if (this.base64AccumIdx > 0) {
	            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
	            this.base64AccumIdx = 0;
	        }
	
	        buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
	        this.inBase64 = false;
	    }
	
	    return buf.slice(0, bufIdx);
	}
	
	
	// -- Decoding
	
	function Utf7IMAPDecoder(options, codec) {
	    this.iconv = codec.iconv;
	    this.inBase64 = false;
	    this.base64Accum = '';
	}
	
	var base64IMAPChars = base64Chars.slice();
	base64IMAPChars[','.charCodeAt(0)] = true;
	
	Utf7IMAPDecoder.prototype.write = function(buf) {
	    var res = "", lastI = 0,
	        inBase64 = this.inBase64,
	        base64Accum = this.base64Accum;
	
	    // The decoder is more involved as we must handle chunks in stream.
	    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).
	
	    for (var i = 0; i < buf.length; i++) {
	        if (!inBase64) { // We're in direct mode.
	            // Write direct chars until '&'
	            if (buf[i] == andChar) {
	                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
	                lastI = i+1;
	                inBase64 = true;
	            }
	        } else { // We decode base64.
	            if (!base64IMAPChars[buf[i]]) { // Base64 ended.
	                if (i == lastI && buf[i] == minusChar) { // "&-" -> "&"
	                    res += "&";
	                } else {
	                    var b64str = base64Accum + buf.slice(lastI, i).toString().replace(/,/g, '/');
	                    res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
	                }
	
	                if (buf[i] != minusChar) // Minus may be absorbed after base64.
	                    i--;
	
	                lastI = i+1;
	                inBase64 = false;
	                base64Accum = '';
	            }
	        }
	    }
	
	    if (!inBase64) {
	        res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
	    } else {
	        var b64str = base64Accum + buf.slice(lastI).toString().replace(/,/g, '/');
	
	        var canBeDecoded = b64str.length - (b64str.length % 8); // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
	        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
	        b64str = b64str.slice(0, canBeDecoded);
	
	        res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
	    }
	
	    this.inBase64 = inBase64;
	    this.base64Accum = base64Accum;
	
	    return res;
	}
	
	Utf7IMAPDecoder.prototype.end = function() {
	    var res = "";
	    if (this.inBase64 && this.base64Accum.length > 0)
	        res = this.iconv.decode(Buffer.from(this.base64Accum, 'base64'), "utf16-be");
	
	    this.inBase64 = false;
	    this.base64Accum = '';
	    return res;
	}
	
	


/***/ },
/* 1788 */
/***/ function(module, exports) {

	"use strict";
	
	var BOMChar = '\uFEFF';
	
	exports.PrependBOM = PrependBOMWrapper
	function PrependBOMWrapper(encoder, options) {
	    this.encoder = encoder;
	    this.addBOM = true;
	}
	
	PrependBOMWrapper.prototype.write = function(str) {
	    if (this.addBOM) {
	        str = BOMChar + str;
	        this.addBOM = false;
	    }
	
	    return this.encoder.write(str);
	}
	
	PrependBOMWrapper.prototype.end = function() {
	    return this.encoder.end();
	}
	
	
	//------------------------------------------------------------------------------
	
	exports.StripBOM = StripBOMWrapper;
	function StripBOMWrapper(decoder, options) {
	    this.decoder = decoder;
	    this.pass = false;
	    this.options = options || {};
	}
	
	StripBOMWrapper.prototype.write = function(buf) {
	    var res = this.decoder.write(buf);
	    if (this.pass || !res)
	        return res;
	
	    if (res[0] === BOMChar) {
	        res = res.slice(1);
	        if (typeof this.options.stripBOM === 'function')
	            this.options.stripBOM();
	    }
	
	    this.pass = true;
	    return res;
	}
	
	StripBOMWrapper.prototype.end = function() {
	    return this.decoder.end();
	}
	


/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Buffer = __webpack_require__(339).Buffer;
	// Note: not polyfilled with safer-buffer on a purpose, as overrides Buffer
	
	// == Extend Node primitives to use iconv-lite =================================
	
	module.exports = function (iconv) {
	    var original = undefined; // Place to keep original methods.
	
	    // Node authors rewrote Buffer internals to make it compatible with
	    // Uint8Array and we cannot patch key functions since then.
	    // Note: this does use older Buffer API on a purpose
	    iconv.supportsNodeEncodingsExtension = !(Buffer.from || new Buffer(0) instanceof Uint8Array);
	
	    iconv.extendNodeEncodings = function extendNodeEncodings() {
	        if (original) return;
	        original = {};
	
	        if (!iconv.supportsNodeEncodingsExtension) {
	            console.error("ACTION NEEDED: require('iconv-lite').extendNodeEncodings() is not supported in your version of Node");
	            console.error("See more info at https://github.com/ashtuchkin/iconv-lite/wiki/Node-v4-compatibility");
	            return;
	        }
	
	        var nodeNativeEncodings = {
	            'hex': true, 'utf8': true, 'utf-8': true, 'ascii': true, 'binary': true, 
	            'base64': true, 'ucs2': true, 'ucs-2': true, 'utf16le': true, 'utf-16le': true,
	        };
	
	        Buffer.isNativeEncoding = function(enc) {
	            return enc && nodeNativeEncodings[enc.toLowerCase()];
	        }
	
	        // -- SlowBuffer -----------------------------------------------------------
	        var SlowBuffer = __webpack_require__(339).SlowBuffer;
	
	        original.SlowBufferToString = SlowBuffer.prototype.toString;
	        SlowBuffer.prototype.toString = function(encoding, start, end) {
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.SlowBufferToString.call(this, encoding, start, end);
	
	            // Otherwise, use our decoding method.
	            if (typeof start == 'undefined') start = 0;
	            if (typeof end == 'undefined') end = this.length;
	            return iconv.decode(this.slice(start, end), encoding);
	        }
	
	        original.SlowBufferWrite = SlowBuffer.prototype.write;
	        SlowBuffer.prototype.write = function(string, offset, length, encoding) {
	            // Support both (string, offset, length, encoding)
	            // and the legacy (string, encoding, offset, length)
	            if (isFinite(offset)) {
	                if (!isFinite(length)) {
	                    encoding = length;
	                    length = undefined;
	                }
	            } else {  // legacy
	                var swap = encoding;
	                encoding = offset;
	                offset = length;
	                length = swap;
	            }
	
	            offset = +offset || 0;
	            var remaining = this.length - offset;
	            if (!length) {
	                length = remaining;
	            } else {
	                length = +length;
	                if (length > remaining) {
	                    length = remaining;
	                }
	            }
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.SlowBufferWrite.call(this, string, offset, length, encoding);
	
	            if (string.length > 0 && (length < 0 || offset < 0))
	                throw new RangeError('attempt to write beyond buffer bounds');
	
	            // Otherwise, use our encoding method.
	            var buf = iconv.encode(string, encoding);
	            if (buf.length < length) length = buf.length;
	            buf.copy(this, offset, 0, length);
	            return length;
	        }
	
	        // -- Buffer ---------------------------------------------------------------
	
	        original.BufferIsEncoding = Buffer.isEncoding;
	        Buffer.isEncoding = function(encoding) {
	            return Buffer.isNativeEncoding(encoding) || iconv.encodingExists(encoding);
	        }
	
	        original.BufferByteLength = Buffer.byteLength;
	        Buffer.byteLength = SlowBuffer.byteLength = function(str, encoding) {
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.BufferByteLength.call(this, str, encoding);
	
	            // Slow, I know, but we don't have a better way yet.
	            return iconv.encode(str, encoding).length;
	        }
	
	        original.BufferToString = Buffer.prototype.toString;
	        Buffer.prototype.toString = function(encoding, start, end) {
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.BufferToString.call(this, encoding, start, end);
	
	            // Otherwise, use our decoding method.
	            if (typeof start == 'undefined') start = 0;
	            if (typeof end == 'undefined') end = this.length;
	            return iconv.decode(this.slice(start, end), encoding);
	        }
	
	        original.BufferWrite = Buffer.prototype.write;
	        Buffer.prototype.write = function(string, offset, length, encoding) {
	            var _offset = offset, _length = length, _encoding = encoding;
	            // Support both (string, offset, length, encoding)
	            // and the legacy (string, encoding, offset, length)
	            if (isFinite(offset)) {
	                if (!isFinite(length)) {
	                    encoding = length;
	                    length = undefined;
	                }
	            } else {  // legacy
	                var swap = encoding;
	                encoding = offset;
	                offset = length;
	                length = swap;
	            }
	
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.BufferWrite.call(this, string, _offset, _length, _encoding);
	
	            offset = +offset || 0;
	            var remaining = this.length - offset;
	            if (!length) {
	                length = remaining;
	            } else {
	                length = +length;
	                if (length > remaining) {
	                    length = remaining;
	                }
	            }
	
	            if (string.length > 0 && (length < 0 || offset < 0))
	                throw new RangeError('attempt to write beyond buffer bounds');
	
	            // Otherwise, use our encoding method.
	            var buf = iconv.encode(string, encoding);
	            if (buf.length < length) length = buf.length;
	            buf.copy(this, offset, 0, length);
	            return length;
	
	            // TODO: Set _charsWritten.
	        }
	
	
	        // -- Readable -------------------------------------------------------------
	        if (iconv.supportsStreams) {
	            var Readable = __webpack_require__(345).Readable;
	
	            original.ReadableSetEncoding = Readable.prototype.setEncoding;
	            Readable.prototype.setEncoding = function setEncoding(enc, options) {
	                // Use our own decoder, it has the same interface.
	                // We cannot use original function as it doesn't handle BOM-s.
	                this._readableState.decoder = iconv.getDecoder(enc, options);
	                this._readableState.encoding = enc;
	            }
	
	            Readable.prototype.collect = iconv._collect;
	        }
	    }
	
	    // Remove iconv-lite Node primitive extensions.
	    iconv.undoExtendNodeEncodings = function undoExtendNodeEncodings() {
	        if (!iconv.supportsNodeEncodingsExtension)
	            return;
	        if (!original)
	            throw new Error("require('iconv-lite').undoExtendNodeEncodings(): Nothing to undo; extendNodeEncodings() is not called.")
	
	        delete Buffer.isNativeEncoding;
	
	        var SlowBuffer = __webpack_require__(339).SlowBuffer;
	
	        SlowBuffer.prototype.toString = original.SlowBufferToString;
	        SlowBuffer.prototype.write = original.SlowBufferWrite;
	
	        Buffer.isEncoding = original.BufferIsEncoding;
	        Buffer.byteLength = original.BufferByteLength;
	        Buffer.prototype.toString = original.BufferToString;
	        Buffer.prototype.write = original.BufferWrite;
	
	        if (iconv.supportsStreams) {
	            var Readable = __webpack_require__(345).Readable;
	
	            Readable.prototype.setEncoding = original.ReadableSetEncoding;
	            delete Readable.prototype.collect;
	        }
	
	        original = undefined;
	    }
	}


/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	// Some environments don't have global Buffer (e.g. React Native).
	// Solution would be installing npm modules "buffer" and "stream" explicitly.
	var Buffer = __webpack_require__(687).Buffer;
	
	var bomHandling = __webpack_require__(1788),
	    iconv = module.exports;
	
	// All codecs and aliases are kept here, keyed by encoding name/alias.
	// They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
	iconv.encodings = null;
	
	// Characters emitted in case of error.
	iconv.defaultCharUnicode = '�';
	iconv.defaultCharSingleByte = '?';
	
	// Public API.
	iconv.encode = function encode(str, encoding, options) {
	    str = "" + (str || ""); // Ensure string.
	
	    var encoder = iconv.getEncoder(encoding, options);
	
	    var res = encoder.write(str);
	    var trail = encoder.end();
	    
	    return (trail && trail.length > 0) ? Buffer.concat([res, trail]) : res;
	}
	
	iconv.decode = function decode(buf, encoding, options) {
	    if (typeof buf === 'string') {
	        if (!iconv.skipDecodeWarning) {
	            console.error('Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding');
	            iconv.skipDecodeWarning = true;
	        }
	
	        buf = Buffer.from("" + (buf || ""), "binary"); // Ensure buffer.
	    }
	
	    var decoder = iconv.getDecoder(encoding, options);
	
	    var res = decoder.write(buf);
	    var trail = decoder.end();
	
	    return trail ? (res + trail) : res;
	}
	
	iconv.encodingExists = function encodingExists(enc) {
	    try {
	        iconv.getCodec(enc);
	        return true;
	    } catch (e) {
	        return false;
	    }
	}
	
	// Legacy aliases to convert functions
	iconv.toEncoding = iconv.encode;
	iconv.fromEncoding = iconv.decode;
	
	// Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
	iconv._codecDataCache = {};
	iconv.getCodec = function getCodec(encoding) {
	    if (!iconv.encodings)
	        iconv.encodings = __webpack_require__(1781); // Lazy load all encoding definitions.
	    
	    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
	    var enc = iconv._canonicalizeEncoding(encoding);
	
	    // Traverse iconv.encodings to find actual codec.
	    var codecOptions = {};
	    while (true) {
	        var codec = iconv._codecDataCache[enc];
	        if (codec)
	            return codec;
	
	        var codecDef = iconv.encodings[enc];
	
	        switch (typeof codecDef) {
	            case "string": // Direct alias to other encoding.
	                enc = codecDef;
	                break;
	
	            case "object": // Alias with options. Can be layered.
	                for (var key in codecDef)
	                    codecOptions[key] = codecDef[key];
	
	                if (!codecOptions.encodingName)
	                    codecOptions.encodingName = enc;
	                
	                enc = codecDef.type;
	                break;
	
	            case "function": // Codec itself.
	                if (!codecOptions.encodingName)
	                    codecOptions.encodingName = enc;
	
	                // The codec function must load all tables and return object with .encoder and .decoder methods.
	                // It'll be called only once (for each different options object).
	                codec = new codecDef(codecOptions, iconv);
	
	                iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
	                return codec;
	
	            default:
	                throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '"+enc+"')");
	        }
	    }
	}
	
	iconv._canonicalizeEncoding = function(encoding) {
	    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
	    return (''+encoding).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, "");
	}
	
	iconv.getEncoder = function getEncoder(encoding, options) {
	    var codec = iconv.getCodec(encoding),
	        encoder = new codec.encoder(options, codec);
	
	    if (codec.bomAware && options && options.addBOM)
	        encoder = new bomHandling.PrependBOM(encoder, options);
	
	    return encoder;
	}
	
	iconv.getDecoder = function getDecoder(encoding, options) {
	    var codec = iconv.getCodec(encoding),
	        decoder = new codec.decoder(options, codec);
	
	    if (codec.bomAware && !(options && options.stripBOM === false))
	        decoder = new bomHandling.StripBOM(decoder, options);
	
	    return decoder;
	}
	
	
	// Load extensions in Node. All of them are omitted in Browserify build via 'browser' field in package.json.
	var nodeVer = typeof process !== 'undefined' && process.versions && process.versions.node;
	if (nodeVer) {
	
	    // Load streaming support in Node v0.10+
	    var nodeVerArr = nodeVer.split(".").map(Number);
	    if (nodeVerArr[0] > 0 || nodeVerArr[1] >= 10) {
	        __webpack_require__(1791)(iconv);
	    }
	
	    // Load Node primitive extensions.
	    __webpack_require__(1789)(iconv);
	}
	
	if (false) {
	    console.error("iconv-lite warning: javascript files use encoding different from utf-8. See https://github.com/ashtuchkin/iconv-lite/wiki/Javascript-source-file-encodings for more info.");
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(235)))

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Buffer = __webpack_require__(339).Buffer,
	    Transform = __webpack_require__(345).Transform;
	
	
	// == Exports ==================================================================
	module.exports = function(iconv) {
	    
	    // Additional Public API.
	    iconv.encodeStream = function encodeStream(encoding, options) {
	        return new IconvLiteEncoderStream(iconv.getEncoder(encoding, options), options);
	    }
	
	    iconv.decodeStream = function decodeStream(encoding, options) {
	        return new IconvLiteDecoderStream(iconv.getDecoder(encoding, options), options);
	    }
	
	    iconv.supportsStreams = true;
	
	
	    // Not published yet.
	    iconv.IconvLiteEncoderStream = IconvLiteEncoderStream;
	    iconv.IconvLiteDecoderStream = IconvLiteDecoderStream;
	    iconv._collect = IconvLiteDecoderStream.prototype.collect;
	};
	
	
	// == Encoder stream =======================================================
	function IconvLiteEncoderStream(conv, options) {
	    this.conv = conv;
	    options = options || {};
	    options.decodeStrings = false; // We accept only strings, so we don't need to decode them.
	    Transform.call(this, options);
	}
	
	IconvLiteEncoderStream.prototype = Object.create(Transform.prototype, {
	    constructor: { value: IconvLiteEncoderStream }
	});
	
	IconvLiteEncoderStream.prototype._transform = function(chunk, encoding, done) {
	    if (typeof chunk != 'string')
	        return done(new Error("Iconv encoding stream needs strings as its input."));
	    try {
	        var res = this.conv.write(chunk);
	        if (res && res.length) this.push(res);
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}
	
	IconvLiteEncoderStream.prototype._flush = function(done) {
	    try {
	        var res = this.conv.end();
	        if (res && res.length) this.push(res);
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}
	
	IconvLiteEncoderStream.prototype.collect = function(cb) {
	    var chunks = [];
	    this.on('error', cb);
	    this.on('data', function(chunk) { chunks.push(chunk); });
	    this.on('end', function() {
	        cb(null, Buffer.concat(chunks));
	    });
	    return this;
	}
	
	
	// == Decoder stream =======================================================
	function IconvLiteDecoderStream(conv, options) {
	    this.conv = conv;
	    options = options || {};
	    options.encoding = this.encoding = 'utf8'; // We output strings.
	    Transform.call(this, options);
	}
	
	IconvLiteDecoderStream.prototype = Object.create(Transform.prototype, {
	    constructor: { value: IconvLiteDecoderStream }
	});
	
	IconvLiteDecoderStream.prototype._transform = function(chunk, encoding, done) {
	    if (!Buffer.isBuffer(chunk))
	        return done(new Error("Iconv decoding stream needs buffers as its input."));
	    try {
	        var res = this.conv.write(chunk);
	        if (res && res.length) this.push(res, this.encoding);
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}
	
	IconvLiteDecoderStream.prototype._flush = function(done) {
	    try {
	        var res = this.conv.end();
	        if (res && res.length) this.push(res, this.encoding);                
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}
	
	IconvLiteDecoderStream.prototype.collect = function(cb) {
	    var res = '';
	    this.on('error', cb);
	    this.on('data', function(chunk) { res += chunk; });
	    this.on('end', function() {
	        cb(null, res);
	    });
	    return this;
	}
	


/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var types = [
	  __webpack_require__(1795),
	  __webpack_require__(1796),
	  __webpack_require__(1794),
	  __webpack_require__(1793),
	  __webpack_require__(1797),
	  __webpack_require__(1798)
	];
	var draining;
	var currentQueue;
	var queueIndex = -1;
	var queue = [];
	var scheduled = false;
	function cleanUpNextTick() {
	  if (!draining || !currentQueue) {
	    return;
	  }
	  draining = false;
	  if (currentQueue.length) {
	    queue = currentQueue.concat(queue);
	  } else {
	    queueIndex = -1;
	  }
	  if (queue.length) {
	    nextTick();
	  }
	}
	
	//named nextTick for less confusing stack traces
	function nextTick() {
	  if (draining) {
	    return;
	  }
	  scheduled = false;
	  draining = true;
	  var len = queue.length;
	  var timeout = setTimeout(cleanUpNextTick);
	  while (len) {
	    currentQueue = queue;
	    queue = [];
	    while (currentQueue && ++queueIndex < len) {
	      currentQueue[queueIndex].run();
	    }
	    queueIndex = -1;
	    len = queue.length;
	  }
	  currentQueue = null;
	  queueIndex = -1;
	  draining = false;
	  clearTimeout(timeout);
	}
	var scheduleDrain;
	var i = -1;
	var len = types.length;
	while (++i < len) {
	  if (types[i] && types[i].test && types[i].test()) {
	    scheduleDrain = types[i].install(nextTick);
	    break;
	  }
	}
	// v8 likes predictible objects
	function Item(fun, array) {
	  this.fun = fun;
	  this.array = array;
	}
	Item.prototype.run = function () {
	  var fun = this.fun;
	  var array = this.array;
	  switch (array.length) {
	  case 0:
	    return fun();
	  case 1:
	    return fun(array[0]);
	  case 2:
	    return fun(array[0], array[1]);
	  case 3:
	    return fun(array[0], array[1], array[2]);
	  default:
	    return fun.apply(null, array);
	  }
	
	};
	module.exports = immediate;
	function immediate(task) {
	  var args = new Array(arguments.length - 1);
	  if (arguments.length > 1) {
	    for (var i = 1; i < arguments.length; i++) {
	      args[i - 1] = arguments[i];
	    }
	  }
	  queue.push(new Item(task, args));
	  if (!scheduled && !draining) {
	    scheduled = true;
	    scheduleDrain();
	  }
	}


/***/ },
/* 1793 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.test = function () {
	  if (global.setImmediate) {
	    // we can only get here in IE10
	    // which doesn't handel postMessage well
	    return false;
	  }
	  return typeof global.MessageChannel !== 'undefined';
	};
	
	exports.install = function (func) {
	  var channel = new global.MessageChannel();
	  channel.port1.onmessage = func;
	  return function () {
	    channel.port2.postMessage(0);
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1794 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	//based off rsvp https://github.com/tildeio/rsvp.js
	//license https://github.com/tildeio/rsvp.js/blob/master/LICENSE
	//https://github.com/tildeio/rsvp.js/blob/master/lib/rsvp/asap.js
	
	var Mutation = global.MutationObserver || global.WebKitMutationObserver;
	
	exports.test = function () {
	  return Mutation;
	};
	
	exports.install = function (handle) {
	  var called = 0;
	  var observer = new Mutation(handle);
	  var element = global.document.createTextNode('');
	  observer.observe(element, {
	    characterData: true
	  });
	  return function () {
	    element.data = (called = ++called % 2);
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	exports.test = function () {
	  // Don't get fooled by e.g. browserify environments.
	  return (typeof process !== 'undefined') && !process.browser;
	};
	
	exports.install = function (func) {
	  return function () {
	    process.nextTick(func);
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(235)))

/***/ },
/* 1796 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	exports.test = function () {
	  return typeof global.queueMicrotask === 'function';
	};
	
	exports.install = function (func) {
	  return function () {
	    global.queueMicrotask(func);
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1797 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.test = function () {
	  return 'document' in global && 'onreadystatechange' in global.document.createElement('script');
	};
	
	exports.install = function (handle) {
	  return function () {
	
	    // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	    // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	    var scriptEl = global.document.createElement('script');
	    scriptEl.onreadystatechange = function () {
	      handle();
	
	      scriptEl.onreadystatechange = null;
	      scriptEl.parentNode.removeChild(scriptEl);
	      scriptEl = null;
	    };
	    global.document.documentElement.appendChild(scriptEl);
	
	    return handle;
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1798 */
/***/ function(module, exports) {

	'use strict';
	exports.test = function () {
	  return true;
	};
	
	exports.install = function (t) {
	  return function () {
	    setTimeout(t, 0);
	  };
	};

/***/ },
/* 1799 */
/***/ function(module, exports) {

	module.exports = isFunction
	
	var toString = Object.prototype.toString
	
	function isFunction (fn) {
	  if (!fn) {
	    return false
	  }
	  var string = toString.call(fn)
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	};


/***/ },
/* 1800 */
/***/ function(module, exports) {

	module.exports = {"version":"2015g","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q","Africa/Accra|LMT GMT GHST|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE","Africa/Addis_Ababa|LMT EAT BEAT BEAUT|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0","Africa/Bangui|LMT WAT|-d.A -10|01|-22y0d.A","Africa/Bissau|LMT WAT GMT|12.k 10 0|012|-2ldWV.E 2xonV.E","Africa/Blantyre|LMT CAT|-2a.k -20|01|-2GJea.k","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1y7p0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Africa/El_Aaiun|LMT WAT WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0","Africa/Juba|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Monrovia|MMT LRT GMT|H.8 I.u 0|012|-23Lzg.Q 29s01.m","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00","Africa/Windhoek|SWAT SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Anchorage|CAT CAWT CAPT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Anguilla|LMT AST|46.4 40|01|-2kNvR.U","America/Araguaina|LMT BRT BRST|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0","America/Argentina/Buenos_Aires|CMT ART ARST ART ARST|4g.M 40 30 30 20|0121212121212121212121212121212121212121213434343434343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 g0p0 10M0 j3c0 uL0","America/Argentina/La_Rioja|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|0121212121212121212121212121212121212121213434345656543235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 g0p0 10M0 agM0 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0","America/Argentina/Salta|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0","America/Argentina/San_Juan|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ak00 m10 8lb0 uL0","America/Argentina/San_Luis|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456536353465653|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 kin0 10M0 ak00 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|012121212121212121212121212121212121212121343434345434323534343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ajA0 8p0 8zb0 uL0","America/Aruba|LMT ANT AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d","America/Asuncion|AMT PYT PYT PYST|3O.E 40 30 30|012131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0","America/Bahia|LMT BRT BRST|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0","America/Belem|LMT BRT BRST|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0","America/Belize|LMT CST CHDT CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0","America/Boa_Vista|LMT AMT AMST|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0","America/Bogota|BMT COT COST|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Cambridge_Bay|zzz MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Campo_Grande|LMT AMT AMST|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0","America/Caracas|CMT VET VET|4r.E 4u 40|0121|-2kV7w.k 28KM2.k 1IwOu","America/Cayenne|LMT GFT GFT|3t.k 40 30|012|-2mrwu.E 2gWou.E","America/Cayman|KMT EST EDT|57.b 50 40|0121212121212121212121212121212121212121212121|-2l1uQ.N 4duNQ.N 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0","America/Creston|MST PST|70 80|010|-29DR0 43B0","America/Cuiaba|LMT AMT AMST|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0","America/Danmarkshavn|LMT WGT WGST GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Eirunepe|LMT ACT ACST AMT|4D.s 50 40 40|0121212121212121212121212121212131|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0","America/Ensenada|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOP0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT BRT BRST|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Godthab|LMT WGT WGST|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0","America/Guayaquil|QMT ECT|5e 50|01|-1yVSK","America/Guyana|LMT GBGT GYT GYT GYT|3Q.E 3J 3J 30 40|01234|-2dvU7.k 24JzQ.k mlc0 Bxbf","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|zzz PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Iqaluit|zzz EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BOST BOT|4w.A 3w.A 40|012|-1x37r.o 13b0","America/Lima|LMT PET PEST|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp0 1Vb0 3dB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Maceio|LMT BRT BRST|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0","America/Manaus|LMT AMT AMST|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Metlakatla|PST PWT PPT PDT|80 70 70 70|0120303030303030303030303030303030|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Miquelon|LMT AST PMST PMDT|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Montevideo|MMT UYT UYHST UYST UYT UYHST|3I.I 3u 30 20 30 2u|012121212121212121212121213434343434345454543453434343434343434343434343434343434343434|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0","America/Montreal|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Noronha|LMT FNT FNST|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Panama|CMT EST|5j.A 50|01|-2uduE.o","America/Pangnirtung|zzz AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Paramaribo|LMT PMT PMT NEGT SRT SRT|3E.E 3E.Q 3E.A 3u 3u 30|012345|-2nDUj.k Wqo0.c qanX.I 1dmLN.o lzc0","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0","America/Port-au-Prince|PPMT EST EDT|4N 50 40|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Porto_Acre|LMT ACT ACST AMT|4v.c 50 40 40|01212121212121212121212121212131|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0","America/Porto_Velho|LMT AMT AMST|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Rankin_Inlet|zzz CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Recife|LMT BRT BRST|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0","America/Resolute|zzz CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Santa_Isabel|LMT MST PST PDT PWT PPT|7D.s 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOP0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Santarem|LMT AMT AMST BRT|3C.M 40 30 30|0121212121212121212121212121213|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0","America/Santiago|SMT CLT CLT CLST CLST CLT|4G.K 50 40 40 30 30|01020313131313121242124242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424245|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 1wn0","America/Santo_Domingo|SDMT EST EDT EHDT AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00","America/Sao_Paulo|LMT BRT BRST|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0","America/Scoresbysund|LMT CGT CGST EGST EGT|1r.Q 20 10 0 10|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Yellowknife|zzz MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Antarctica/Casey|zzz AWST CAST|0 -80 -b0|012121|-2q00 1DjS0 T90 40P0 KL0","Antarctica/Davis|zzz DAVT DAVT|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0","Antarctica/DumontDUrville|zzz PMT DDUT|0 -a0 -a0|0102|-U0o0 cfq0 bFm0","Antarctica/Macquarie|AEST AEDT zzz MIST|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0","Antarctica/Mawson|zzz MAWT MAWT|0 -60 -50|012|-CEo0 2fyk0","Antarctica/McMurdo|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00","Antarctica/Palmer|zzz ARST ART ART ARST CLT CLST CLT|0 30 40 30 20 40 30 30|012121212123435656565656565656565656565656565656565656565656565656565656565656567|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 1wn0","Antarctica/Rothera|zzz ROTT|0 30|01|gOo0","Antarctica/Syowa|zzz SYOT|0 -30|01|-vs00","Antarctica/Troll|zzz UTC CEST|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Antarctica/Vostok|zzz VOST|0 -60|01|-tjA0","Arctic/Longyearbyen|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Aden|LMT AST|-36.Q -30|01|-TvD6.Q","Asia/Almaty|LMT ALMT ALMT ALMST|-57.M -50 -60 -70|0123232323232323232323232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3Cl0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0","Asia/Anadyr|LMT ANAT ANAT ANAST ANAST ANAST ANAT|-bN.U -c0 -d0 -e0 -d0 -c0 -b0|01232414141414141414141561414141414141414141414141414141414141561|-1PcbN.U eUnN.U 23CL0 1db0 1cN0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0","Asia/Aqtau|LMT FORT FORT SHET SHET SHEST AQTT AQTST AQTST AQTT|-3l.4 -40 -50 -50 -60 -60 -50 -60 -50 -40|012345353535353535353536767676898989898989898989896|-1Pc3l.4 eUnl.4 1jcL0 JDc0 1cL0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2UK0 Fz0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cN0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 RW0","Asia/Aqtobe|LMT AKTT AKTT AKTST AKTT AQTT AQTST|-3M.E -40 -50 -60 -60 -50 -60|01234323232323232323232565656565656565656565656565|-1Pc3M.E eUnM.E 23CL0 1db0 1cM0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2UK0 Fz0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0","Asia/Ashgabat|LMT ASHT ASHT ASHST ASHST TMT TMT|-3R.w -40 -50 -60 -50 -40 -50|012323232323232323232324156|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 ba0 xC0","Asia/Baghdad|BMT AST ADT|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0","Asia/Bahrain|LMT GST AST|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8","Asia/Baku|LMT BAKT BAKT BAKST BAKST AZST AZT AZT AZST|-3j.o -30 -40 -50 -40 -40 -30 -40 -50|0123232323232323232323245657878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 10K0 c30 1cJ0 1cL0 8wu0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Bangkok|BMT ICT|-6G.4 -70|01|-218SG.4","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0","Asia/Bishkek|LMT FRUT FRUT FRUST FRUST KGT KGST KGT|-4W.o -50 -60 -70 -60 -50 -60 -60|01232323232323232323232456565656565656565656565656567|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 11c0 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 T8u","Asia/Brunei|LMT BNT BNT|-7D.E -7u -80|012|-1KITD.E gDc9.E","Asia/Calcutta|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0","Asia/Chita|LMT YAKT YAKT YAKST YAKST YAKT IRKT|-7x.Q -80 -90 -a0 -90 -a0 -80|012323232323232323232324123232323232323232323232323232323232323256|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0","Asia/Choibalsan|LMT ULAT ULAT CHOST CHOT CHOT CHOST|-7C -70 -80 -a0 -90 -80 -90|0123434343434343434343434343434343434343434343456565656565656565656565656565656565656565656565|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0","Asia/Chongqing|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0","Asia/Colombo|MMT IST IHST IST LKT LKT|-5j.w -5u -60 -6u -6u -60|01231451|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu","Asia/Dacca|HMT BURT IST DACT BDT BDST|-5R.k -6u -5u -60 -60 -70|01213454|-18LFR.k 1unn.k HB0 m6n0 LqMu 1x6n0 1i00","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0","Asia/Dili|LMT TLT JST TLT WITA|-8m.k -80 -90 -90 -80|012343|-2le8m.k 1dnXm.k 8HA0 1ew00 Xld0","Asia/Dubai|LMT GST|-3F.c -40|01|-21JfF.c","Asia/Dushanbe|LMT DUST DUST DUSST DUSST TJT|-4z.c -50 -60 -70 -60 -50|0123232323232323232323245|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 14N0","Asia/Gaza|EET EET EEST IST IDT|-20 -30 -30 -20 -30|010101010102020202020202020202023434343434343434343434343430202020202020202020202020202020202020202020202020202020202020202020202020202020202020|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0","Asia/Hebron|EET EET EEST IST IDT|-20 -30 -30 -20 -30|01010101010202020202020202020202343434343434343434343434343020202020202020202020202020202020202020202020202020202020202020202020202020202020202020|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0","Asia/Ho_Chi_Minh|LMT PLMT ICT IDT JST|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0","Asia/Hovd|LMT HOVT HOVT HOVST|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0","Asia/Irkutsk|IMT IRKT IRKT IRKST IRKST IRKT|-6V.5 -70 -80 -90 -80 -90|012323232323232323232324123232323232323232323232323232323232323252|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0","Asia/Istanbul|IMT EET EEST TRST TRT|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1df0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Jakarta|BMT JAVT WIB JST WIB WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu","Asia/Jayapura|LMT WIT ACST|-9m.M -90 -9u|0121|-1uu9m.M sMMm.M L4nu","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0","Asia/Kabul|AFT AFT|-40 -4u|01|-10Qs0","Asia/Kamchatka|LMT PETT PETT PETST PETST|-ay.A -b0 -c0 -d0 -c0|01232323232323232323232412323232323232323232323232323232323232412|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0","Asia/Karachi|LMT IST IST KART PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy01 1cL0 dK0X 11b0 1610 1jX0","Asia/Kashgar|LMT XJT|-5O.k -60|01|-1GgtO.k","Asia/Kathmandu|LMT IST NPT|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g","Asia/Khandyga|LMT YAKT YAKT YAKST YAKST VLAT VLAST VLAT YAKT|-92.d -80 -90 -a0 -90 -a0 -b0 -b0 -a0|01232323232323232323232412323232323232323232323232565656565656565782|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0","Asia/Krasnoyarsk|LMT KRAT KRAT KRAST KRAST KRAT|-6b.q -60 -70 -80 -70 -80|012323232323232323232324123232323232323232323232323232323232323252|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0","Asia/Kuala_Lumpur|SMT MALT MALST MALT MALT JST MYT|-6T.p -70 -7k -7k -7u -90 -80|01234546|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu 1so1u","Asia/Kuching|LMT BORT BORT BORTST JST MYT|-7l.k -7u -80 -8k -90 -80|01232323232323232425|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0 1so10","Asia/Macao|LMT MOT MOST CST|-7y.k -80 -90 -80|0121212121212121212121212121212121212121213|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0 KEp0","Asia/Magadan|LMT MAGT MAGT MAGST MAGST MAGT|-a3.c -a0 -b0 -c0 -b0 -c0|012323232323232323232324123232323232323232323232323232323232323251|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0","Asia/Makassar|LMT MMT WITA JST|-7V.A -7V.A -80 -90|01232|-21JjV.A vfc0 myLV.A 8ML0","Asia/Manila|PHT PHST JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Novokuznetsk|LMT KRAT KRAT KRAST KRAST NOVST NOVT NOVT|-5M.M -60 -70 -80 -70 -70 -60 -70|012323232323232323232324123232323232323232323232323232323232325672|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0 8Hz0","Asia/Novosibirsk|LMT NOVT NOVT NOVST NOVST|-5v.E -60 -70 -80 -70|0123232323232323232323241232341414141414141414141414141414141414121|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0","Asia/Omsk|LMT OMST OMST OMSST OMSST OMST|-4R.u -50 -60 -70 -60 -70|012323232323232323232324123232323232323232323232323232323232323252|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0","Asia/Oral|LMT URAT URAT URAST URAT URAST ORAT ORAST ORAT|-3p.o -40 -50 -60 -60 -50 -40 -50 -50|012343232323232323251516767676767676767676767676768|-1Pc3p.o eUnp.o 23CL0 1db0 1cM0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 2UK0 Fz0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 RW0","Asia/Pontianak|LMT PMT WIB JST WIB WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu","Asia/Pyongyang|LMT KST JCST JST KST|-8n -8u -90 -90 -90|012341|-2um8n 97XR 12FXu jdA0 2Onc0","Asia/Qyzylorda|LMT KIZT KIZT KIZST KIZT QYZT QYZT QYZST|-4l.Q -40 -50 -60 -60 -50 -60 -70|012343232323232323232325676767676767676767676767676|-1Pc4l.Q eUol.Q 23CL0 1db0 1cM0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2UK0 dC0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0","Asia/Rangoon|RMT BURT JST MMT|-6o.E -6u -90 -6u|0123|-21Jio.E SmnS.E 7j9u","Asia/Sakhalin|LMT JCST JST SAKT SAKST SAKST SAKT|-9u.M -90 -90 -b0 -c0 -b0 -a0|0123434343434343434343435634343434343565656565656565656565656565636|-2AGVu.M 1iaMu.M je00 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o10 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0","Asia/Samarkand|LMT SAMT SAMT SAMST TAST UZST UZT|-4r.R -40 -50 -60 -60 -60 -50|01234323232323232323232356|-1Pc4r.R eUor.R 23CL0 1db0 1cM0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 11x0 bf0","Asia/Seoul|LMT KST JCST JST KST KDT KDT|-8r.Q -8u -90 -90 -90 -9u -a0|01234151515151515146464|-2um8r.Q 97XV.Q 12FXu jjA0 kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0","Asia/Singapore|SMT MALT MALST MALT MALT JST SGT SGT|-6T.p -70 -7k -7k -7u -90 -7u -80|012345467|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu Mspu DTA0","Asia/Srednekolymsk|LMT MAGT MAGT MAGST MAGST MAGT SRET|-ae.Q -a0 -b0 -c0 -b0 -c0 -b0|012323232323232323232324123232323232323232323232323232323232323256|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0","Asia/Taipei|JWST JST CST CDT|-80 -90 -80 -90|01232323232323232323232323232323232323232|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0","Asia/Tashkent|LMT TAST TAST TASST TASST UZST UZT|-4B.b -50 -60 -70 -60 -60 -50|01232323232323232323232456|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 11y0 bf0","Asia/Tbilisi|TBMT TBIT TBIT TBIST TBIST GEST GET GET GEST|-2X.b -30 -40 -50 -40 -40 -30 -40 -50|0123232323232323232323245656565787878787878787878567|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 3y0 19f0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cM0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0","Asia/Tehran|LMT TMT IRST IRST IRDT IRDT|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0","Asia/Thimbu|LMT IST BTT|-5W.A -5u -60|012|-Su5W.A 1BGMs.A","Asia/Tokyo|JCST JST JDT|-90 -90 -a0|0121212121|-1iw90 pKq0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0","Asia/Ulaanbaatar|LMT ULAT ULAT ULAST|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0","Asia/Ust-Nera|LMT YAKT YAKT MAGST MAGT MAGST MAGT MAGT VLAT VLAT|-9w.S -80 -90 -c0 -b0 -b0 -a0 -c0 -b0 -a0|0123434343434343434343456434343434343434343434343434343434343434789|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0","Asia/Vladivostok|LMT VLAT VLAT VLAST VLAST VLAT|-8L.v -90 -a0 -b0 -a0 -b0|012323232323232323232324123232323232323232323232323232323232323252|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0","Asia/Yakutsk|LMT YAKT YAKT YAKST YAKST YAKT|-8C.W -80 -90 -a0 -90 -a0|012323232323232323232324123232323232323232323232323232323232323252|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0","Asia/Yekaterinburg|LMT PMT SVET SVET SVEST SVEST YEKT YEKST YEKT|-42.x -3J.5 -40 -50 -60 -50 -50 -60 -60|0123434343434343434343435267676767676767676767676767676767676767686|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0","Asia/Yerevan|LMT YERT YERT YERST YERST AMST AMT AMT AMST|-2W -30 -40 -50 -40 -40 -30 -40 -50|0123232323232323232323245656565657878787878787878787878787878787|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1am0 2r0 1cJ0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fb0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0","Atlantic/Azores|HMT AZOT AZOST AZOMT AZOT AZOST WET|1S.w 20 10 0 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545456545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Atlantic/Canary|LMT CANT WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Atlantic/Cape_Verde|LMT CVT CVST CVT|1y.4 20 10 10|01213|-2xomp.U 1qOMp.U 7zX0 1djf0","Atlantic/Faeroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Atlantic/Madeira|FMT MADT MADST MADMT WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Atlantic/Reykjavik|LMT IST ISST GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0","Atlantic/South_Georgia|GST|20|0|","Atlantic/Stanley|SMT FKT FKST FKT FKST|3P.o 40 30 30 20|0121212121212134343212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 U10 1qM0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10","Australia/ACT|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0","Australia/Eucla|ACWST ACWDT|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0","Australia/LHI|AEST LHST LHDT LHDT|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Chile/EasterIsland|EMT EAST EASST EAST EASST EAST|7h.s 70 60 60 50 50|012121212121212121212121212123434343434343434343434343434343434343434343434343434343434343434345|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 1wn0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Eire|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Etc/GMT+0|GMT|0|0|","Etc/GMT+1|GMT+1|10|0|","Etc/GMT+10|GMT+10|a0|0|","Etc/GMT+11|GMT+11|b0|0|","Etc/GMT+12|GMT+12|c0|0|","Etc/GMT+2|GMT+2|20|0|","Etc/GMT+3|GMT+3|30|0|","Etc/GMT+4|GMT+4|40|0|","Etc/GMT+5|GMT+5|50|0|","Etc/GMT+6|GMT+6|60|0|","Etc/GMT+7|GMT+7|70|0|","Etc/GMT+8|GMT+8|80|0|","Etc/GMT+9|GMT+9|90|0|","Etc/GMT-1|GMT-1|-10|0|","Etc/GMT-10|GMT-10|-a0|0|","Etc/GMT-11|GMT-11|-b0|0|","Etc/GMT-12|GMT-12|-c0|0|","Etc/GMT-13|GMT-13|-d0|0|","Etc/GMT-14|GMT-14|-e0|0|","Etc/GMT-2|GMT-2|-20|0|","Etc/GMT-3|GMT-3|-30|0|","Etc/GMT-4|GMT-4|-40|0|","Etc/GMT-5|GMT-5|-50|0|","Etc/GMT-6|GMT-6|-60|0|","Etc/GMT-7|GMT-7|-70|0|","Etc/GMT-8|GMT-8|-80|0|","Etc/GMT-9|GMT-9|-90|0|","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST NEST NET CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Belfast|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Bratislava|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Busingen|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|0123232323232323232345454676767676767676767623232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1ty0 2bD0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET FET|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454545454676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1cJ0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|01010101010101010101010121212121234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-28dd0 11A0 1go0 19A0 1co0 1dA0 b1A0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 iyo0 Rc0 18o0 1hc0 1io0 1a00 14o0 5aL0 MM0 1vc0 17A0 1i00 1bc0 1eo0 17d0 1in0 17A0 6hA0 10N0 XIL0 1a10 1in0 17d0 19X0 1cN0 1fz0 1a10 1fX0 1cp0 1cO0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2as10 M00 1cM0 1cM0 14o0 1o00 WM0 1qM0 17c0 1cM0 M3A0 5M20 WM0 1fA0 1cM0 1cM0 1cM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 Lz0 1C10 Lz0 1EN0 Lz0 1C10 Lz0 1zd0 Oo0 1C00 On0 1cp0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Minsk|MMT EET MSK CEST CET MSD EEST FET|-1O -20 -30 -20 -10 -40 -30 -30|012343432525252525252525252616161616161616161616161616161616161616172|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cK0 1cM0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hy0","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Moscow|MMT MMT MST MDST MSD MSK MSM EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c20 imv.j 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rU0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2as10 M00 1cM0 1cM0 14o0 1o00 WM0 1qM0 17c0 1cM0 M3A0 5M20 WM0 1fA0 1cM0 16K0 1iO0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 Lz0 1C10 Lz0 1EN0 Lz0 1C10 Lz0 1zd0 Oo0 1C00 On0 1C10 Lz0 1zd0 On0 1C10 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Samara|LMT SAMT SAMT KUYT KUYST MSD MSK EEST KUYT SAMST SAMST|-3k.k -30 -40 -40 -50 -40 -30 -30 -30 -50 -40|012343434343434343435656782929292929292929292929292929292929292a12|-22WNk.k qHak.k bcn0 1Qqo0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cN0 8o0 14j0 1cL0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646464647373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Volgograd|LMT TSAT STAT STAT VOLT VOLST VOLST VOLT MSD MSK MSK|-2V.E -30 -30 -40 -40 -50 -40 -30 -40 -30 -40|0123454545454545454546767489898989898989898989898989898989898989a9|-21IqV.E cLXV.E cEM0 1gqn0 Lco0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cJ0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Zaporozhye|CUT EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","HST|HST|a0|0|","Indian/Chagos|LMT IOT IOT|-4N.E -50 -60|012|-2xosN.E 3AGLN.E","Indian/Christmas|CXT|-70|0|","Indian/Cocos|CCT|-6u|0|","Indian/Kerguelen|zzz TFT|0 -50|01|-MG00","Indian/Mahe|LMT SCT|-3F.M -40|01|-2yO3F.M","Indian/Maldives|MMT MVT|-4S -50|01|-olgS","Indian/Mauritius|LMT MUT MUST|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0","Indian/Reunion|LMT RET|-3F.Q -40|01|-2mDDF.Q","Kwajalein|MHT KWAT MHT|-b0 c0 -c0|012|-AX0 W9X0","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","NZ-CHAT|CHAST CHAST CHADT|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Apia|LMT WSST SST SDT WSDT WSST|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00","Pacific/Bougainville|PGT JST BST|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0","Pacific/Chuuk|CHUT|-a0|0|","Pacific/Efate|LMT VUT VUST|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0","Pacific/Enderbury|PHOT PHOT PHOT|c0 b0 -d0|012|nIc0 B8n0","Pacific/Fakaofo|TKT TKT|b0 -d0|01|1Gfn0","Pacific/Fiji|LMT FJT FJST|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0","Pacific/Funafuti|TVT|-c0|0|","Pacific/Galapagos|LMT ECT GALT|5W.o 50 60|012|-1yVS1.A 2dTz1.A","Pacific/Gambier|LMT GAMT|8X.M 90|01|-2jof0.c","Pacific/Guadalcanal|LMT SBT|-aD.M -b0|01|-2joyD.M","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0","Pacific/Kiritimati|LINT LINT LINT|aE a0 -e0|012|nIaE B8nk","Pacific/Kosrae|KOST KOST|-b0 -c0|010|-AX0 1bdz0","Pacific/Majuro|MHT MHT|-b0 -c0|01|-AX0","Pacific/Marquesas|LMT MART|9i 9u|01|-2joeG","Pacific/Midway|LMT NST BST SST|bm.M b0 b0 b0|0123|-2nDMB.c 2gVzB.c EyM0","Pacific/Nauru|LMT NRT JST NRT|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu","Pacific/Niue|NUT NUT NUT|bk bu b0|012|-KfME 17y0a","Pacific/Norfolk|NMT NFT NFST NFT|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0","Pacific/Noumea|LMT NCT NCST|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0","Pacific/Palau|PWT|-90|0|","Pacific/Pitcairn|PNT PST|8u 80|01|18Vku","Pacific/Pohnpei|PONT|-b0|0|","Pacific/Port_Moresby|PGT|-a0|0|","Pacific/Rarotonga|CKT CKHST CKT|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu","Pacific/Tahiti|LMT TAHT|9W.g a0|01|-2joe1.I","Pacific/Tarawa|GILT|-c0|0|","Pacific/Tongatapu|TOT TOT TOST|-ck -d0 -e0|01212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0","Pacific/Wake|WAKT|-c0|0|","Pacific/Wallis|WFT|-c0|0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Addis_Ababa|Africa/Asmara","Africa/Addis_Ababa|Africa/Asmera","Africa/Addis_Ababa|Africa/Dar_es_Salaam","Africa/Addis_Ababa|Africa/Djibouti","Africa/Addis_Ababa|Africa/Kampala","Africa/Addis_Ababa|Africa/Mogadishu","Africa/Addis_Ababa|Africa/Nairobi","Africa/Addis_Ababa|Indian/Antananarivo","Africa/Addis_Ababa|Indian/Comoro","Africa/Addis_Ababa|Indian/Mayotte","Africa/Bangui|Africa/Brazzaville","Africa/Bangui|Africa/Douala","Africa/Bangui|Africa/Kinshasa","Africa/Bangui|Africa/Lagos","Africa/Bangui|Africa/Libreville","Africa/Bangui|Africa/Luanda","Africa/Bangui|Africa/Malabo","Africa/Bangui|Africa/Niamey","Africa/Bangui|Africa/Porto-Novo","Africa/Blantyre|Africa/Bujumbura","Africa/Blantyre|Africa/Gaborone","Africa/Blantyre|Africa/Harare","Africa/Blantyre|Africa/Kigali","Africa/Blantyre|Africa/Lubumbashi","Africa/Blantyre|Africa/Lusaka","Africa/Blantyre|Africa/Maputo","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Juba|Africa/Khartoum","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Anguilla|America/Antigua","America/Anguilla|America/Dominica","America/Anguilla|America/Grenada","America/Anguilla|America/Guadeloupe","America/Anguilla|America/Marigot","America/Anguilla|America/Montserrat","America/Anguilla|America/Port_of_Spain","America/Anguilla|America/St_Barthelemy","America/Anguilla|America/St_Kitts","America/Anguilla|America/St_Lucia","America/Anguilla|America/St_Thomas","America/Anguilla|America/St_Vincent","America/Anguilla|America/Tortola","America/Anguilla|America/Virgin","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Aruba|America/Curacao","America/Aruba|America/Kralendijk","America/Aruba|America/Lower_Princes","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Ensenada|America/Tijuana","America/Ensenada|Mexico/BajaNorte","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/Montreal|America/Toronto","America/Montreal|Canada/Eastern","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Phoenix|US/Arizona","America/Porto_Acre|America/Rio_Branco","America/Porto_Acre|Brazil/Acre","America/Regina|Canada/East-Saskatchewan","America/Regina|Canada/Saskatchewan","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Antarctica/McMurdo|Antarctica/South_Pole","Antarctica/McMurdo|NZ","Antarctica/McMurdo|Pacific/Auckland","Arctic/Longyearbyen|Atlantic/Jan_Mayen","Arctic/Longyearbyen|Europe/Oslo","Asia/Aden|Asia/Kuwait","Asia/Aden|Asia/Riyadh","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bahrain|Asia/Qatar","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Calcutta|Asia/Kolkata","Asia/Chongqing|Asia/Chungking","Asia/Chongqing|Asia/Harbin","Asia/Chongqing|Asia/Shanghai","Asia/Chongqing|PRC","Asia/Dacca|Asia/Dhaka","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Istanbul|Europe/Istanbul","Asia/Istanbul|Turkey","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kashgar|Asia/Urumqi","Asia/Kathmandu|Asia/Katmandu","Asia/Macao|Asia/Macau","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Seoul|ROK","Asia/Singapore|Singapore","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimbu|Asia/Thimphu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Atlantic/Faeroe|Atlantic/Faroe","Atlantic/Reykjavik|Iceland","Australia/ACT|Australia/Canberra","Australia/ACT|Australia/NSW","Australia/ACT|Australia/Sydney","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/LHI|Australia/Lord_Howe","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Chile/EasterIsland|Pacific/Easter","Eire|Europe/Dublin","Etc/GMT+0|Etc/GMT","Etc/GMT+0|Etc/GMT-0","Etc/GMT+0|Etc/GMT0","Etc/GMT+0|Etc/Greenwich","Etc/GMT+0|GMT","Etc/GMT+0|GMT+0","Etc/GMT+0|GMT-0","Etc/GMT+0|GMT0","Etc/GMT+0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belfast|Europe/Guernsey","Europe/Belfast|Europe/Isle_of_Man","Europe/Belfast|Europe/Jersey","Europe/Belfast|Europe/London","Europe/Belfast|GB","Europe/Belfast|GB-Eire","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Bratislava|Europe/Prague","Europe/Busingen|Europe/Vaduz","Europe/Busingen|Europe/Zurich","Europe/Chisinau|Europe/Tiraspol","Europe/Helsinki|Europe/Mariehamn","Europe/Lisbon|Portugal","Europe/Moscow|W-SU","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Kwajalein|Pacific/Kwajalein","NZ-CHAT|Pacific/Chatham","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Midway|Pacific/Pago_Pago","Pacific/Midway|Pacific/Samoa","Pacific/Midway|US/Samoa","Pacific/Pohnpei|Pacific/Ponape"]}

/***/ },
/* 1801 */
/***/ function(module, exports) {

	module.exports = [["8740","䏰䰲䘃䖦䕸𧉧䵷䖳𧲱䳢𧳅㮕䜶䝄䱇䱀𤊿𣘗𧍒𦺋𧃒䱗𪍑䝏䗚䲅𧱬䴇䪤䚡𦬣爥𥩔𡩣𣸆𣽡晍囻"],["8767","綕夝𨮹㷴霴𧯯寛𡵞媤㘥𩺰嫑宷峼杮薓𩥅瑡璝㡵𡵓𣚞𦀡㻬"],["87a1","𥣞㫵竼龗𤅡𨤍𣇪𠪊𣉞䌊蒄龖鐯䤰蘓墖靊鈘秐稲晠権袝瑌篅枂稬剏遆㓦珄𥶹瓆鿇垳䤯呌䄱𣚎堘穲𧭥讏䚮𦺈䆁𥶙箮𢒼鿈𢓁𢓉𢓌鿉蔄𣖻䂴鿊䓡𪷿拁灮鿋"],["8840","㇀",4,"𠄌㇅𠃑𠃍㇆㇇𠃋𡿨㇈𠃊㇉㇊㇋㇌𠄎㇍㇎ĀÁǍÀĒÉĚÈŌÓǑÒ࿿Ê̄Ế࿿Ê̌ỀÊāáǎàɑēéěèīíǐìōóǒòūúǔùǖǘǚ"],["88a1","ǜü࿿ê̄ế࿿ê̌ềêɡ⏚⏛"],["8940","𪎩𡅅"],["8943","攊"],["8946","丽滝鵎釟"],["894c","𧜵撑会伨侨兖兴农凤务动医华发变团声处备夲头学实実岚庆总斉柾栄桥济炼电纤纬纺织经统缆缷艺苏药视设询车轧轮"],["89a1","琑糼緍楆竉刧"],["89ab","醌碸酞肼"],["89b0","贋胶𠧧"],["89b5","肟黇䳍鷉鸌䰾𩷶𧀎鸊𪄳㗁"],["89c1","溚舾甙"],["89c5","䤑马骏龙禇𨑬𡷊𠗐𢫦两亁亀亇亿仫伷㑌侽㹈倃傈㑽㒓㒥円夅凛凼刅争剹劐匧㗇厩㕑厰㕓参吣㕭㕲㚁咓咣咴咹哐哯唘唣唨㖘唿㖥㖿嗗㗅"],["8a40","𧶄唥"],["8a43","𠱂𠴕𥄫喐𢳆㧬𠍁蹆𤶸𩓥䁓𨂾睺𢰸㨴䟕𨅝𦧲𤷪擝𠵼𠾴𠳕𡃴撍蹾𠺖𠰋𠽤𢲩𨉖𤓓"],["8a64","𠵆𩩍𨃩䟴𤺧𢳂骲㩧𩗴㿭㔆𥋇𩟔𧣈𢵄鵮頕"],["8a76","䏙𦂥撴哣𢵌𢯊𡁷㧻𡁯"],["8aa1","𦛚𦜖𧦠擪𥁒𠱃蹨𢆡𨭌𠜱"],["8aac","䠋𠆩㿺塳𢶍"],["8ab2","𤗈𠓼𦂗𠽌𠶖啹䂻䎺"],["8abb","䪴𢩦𡂝膪飵𠶜捹㧾𢝵跀嚡摼㹃"],["8ac9","𪘁𠸉𢫏𢳉"],["8ace","𡃈𣧂㦒㨆𨊛㕸𥹉𢃇噒𠼱𢲲𩜠㒼氽𤸻"],["8adf","𧕴𢺋𢈈𪙛𨳍𠹺𠰴𦠜羓𡃏𢠃𢤹㗻𥇣𠺌𠾍𠺪㾓𠼰𠵇𡅏𠹌"],["8af6","𠺫𠮩𠵈𡃀𡄽㿹𢚖搲𠾭"],["8b40","𣏴𧘹𢯎𠵾𠵿𢱑𢱕㨘𠺘𡃇𠼮𪘲𦭐𨳒𨶙𨳊閪哌苄喹"],["8b55","𩻃鰦骶𧝞𢷮煀腭胬尜𦕲脴㞗卟𨂽醶𠻺𠸏𠹷𠻻㗝𤷫㘉𠳖嚯𢞵𡃉𠸐𠹸𡁸𡅈𨈇𡑕𠹹𤹐𢶤婔𡀝𡀞𡃵𡃶垜𠸑"],["8ba1","𧚔𨋍𠾵𠹻𥅾㜃𠾶𡆀𥋘𪊽𤧚𡠺𤅷𨉼墙剨㘚𥜽箲孨䠀䬬鼧䧧鰟鮍𥭴𣄽嗻㗲嚉丨夂𡯁屮靑𠂆乛亻㔾尣彑忄㣺扌攵歺氵氺灬爫丬犭𤣩罒礻糹罓𦉪㓁"],["8bde","𦍋耂肀𦘒𦥑卝衤见𧢲讠贝钅镸长门𨸏韦页风飞饣𩠐鱼鸟黄歯龜丷𠂇阝户钢"],["8c40","倻淾𩱳龦㷉袏𤅎灷峵䬠𥇍㕙𥴰愢𨨲辧釶熑朙玺𣊁𪄇㲋𡦀䬐磤琂冮𨜏䀉橣𪊺䈣蘏𠩯稪𩥇𨫪靕灍匤𢁾鏴盙𨧣龧矝亣俰傼丯众龨吴綋墒壐𡶶庒庙忂𢜒斋"],["8ca1","𣏹椙橃𣱣泿"],["8ca7","爀𤔅玌㻛𤨓嬕璹讃𥲤𥚕窓篬糃繬苸薗龩袐龪躹龫迏蕟駠鈡龬𨶹𡐿䁱䊢娚"],["8cc9","顨杫䉶圽"],["8cce","藖𤥻芿𧄍䲁𦵴嵻𦬕𦾾龭龮宖龯曧繛湗秊㶈䓃𣉖𢞖䎚䔶"],["8ce6","峕𣬚諹屸㴒𣕑嵸龲煗䕘𤃬𡸣䱷㥸㑊𠆤𦱁諌侴𠈹妿腬顖𩣺弻"],["8d40","𠮟"],["8d42","𢇁𨥭䄂䚻𩁹㼇龳𪆵䃸㟖䛷𦱆䅼𨚲𧏿䕭㣔𥒚䕡䔛䶉䱻䵶䗪㿈𤬏㙡䓞䒽䇭崾嵈嵖㷼㠏嶤嶹㠠㠸幂庽弥徃㤈㤔㤿㥍惗愽峥㦉憷憹懏㦸戬抐拥挘㧸嚱"],["8da1","㨃揢揻搇摚㩋擀崕嘡龟㪗斆㪽旿晓㫲暒㬢朖㭂枤栀㭘桊梄㭲㭱㭻椉楃牜楤榟榅㮼槖㯝橥橴橱檂㯬檙㯲檫檵櫔櫶殁毁毪汵沪㳋洂洆洦涁㳯涤涱渕渘温溆𨧀溻滢滚齿滨滩漤漴㵆𣽁澁澾㵪㵵熷岙㶊瀬㶑灐灔灯灿炉𠌥䏁㗱𠻘"],["8e40","𣻗垾𦻓焾𥟠㙎榢𨯩孴穉𥣡𩓙穥穽𥦬窻窰竂竃燑𦒍䇊竚竝竪䇯咲𥰁笋筕笩𥌎𥳾箢筯莜𥮴𦱿篐萡箒箸𥴠㶭𥱥蒒篺簆簵𥳁籄粃𤢂粦晽𤕸糉糇糦籴糳糵糎"],["8ea1","繧䔝𦹄絝𦻖璍綉綫焵綳緒𤁗𦀩緤㴓緵𡟹緥𨍭縝𦄡𦅚繮纒䌫鑬縧罀罁罇礶𦋐駡羗𦍑羣𡙡𠁨䕜𣝦䔃𨌺翺𦒉者耈耝耨耯𪂇𦳃耻耼聡𢜔䦉𦘦𣷣𦛨朥肧𨩈脇脚墰𢛶汿𦒘𤾸擧𡒊舘𡡞橓𤩥𤪕䑺舩𠬍𦩒𣵾俹𡓽蓢荢𦬊𤦧𣔰𡝳𣷸芪椛芳䇛"],["8f40","蕋苐茚𠸖𡞴㛁𣅽𣕚艻苢茘𣺋𦶣𦬅𦮗𣗎㶿茝嗬莅䔋𦶥莬菁菓㑾𦻔橗蕚㒖𦹂𢻯葘𥯤葱㷓䓤檧葊𣲵祘蒨𦮖𦹷𦹃蓞萏莑䒠蒓蓤𥲑䉀𥳀䕃蔴嫲𦺙䔧蕳䔖枿蘖"],["8fa1","𨘥𨘻藁𧂈蘂𡖂𧃍䕫䕪蘨㙈𡢢号𧎚虾蝱𪃸蟮𢰧螱蟚蠏噡虬桖䘏衅衆𧗠𣶹𧗤衞袜䙛袴袵揁装睷𧜏覇覊覦覩覧覼𨨥觧𧤤𧪽誜瞓釾誐𧩙竩𧬺𣾏䜓𧬸煼謌謟𥐰𥕥謿譌譍誩𤩺讐讛誯𡛟䘕衏貛𧵔𧶏貫㜥𧵓賖𧶘𧶽贒贃𡤐賛灜贑𤳉㻐起"],["9040","趩𨀂𡀔𤦊㭼𨆼𧄌竧躭躶軃鋔輙輭𨍥𨐒辥錃𪊟𠩐辳䤪𨧞𨔽𣶻廸𣉢迹𪀔𨚼𨔁𢌥㦀𦻗逷𨔼𧪾遡𨕬𨘋邨𨜓郄𨛦邮都酧㫰醩釄粬𨤳𡺉鈎沟鉁鉢𥖹銹𨫆𣲛𨬌𥗛"],["90a1","𠴱錬鍫𨫡𨯫炏嫃𨫢𨫥䥥鉄𨯬𨰹𨯿鍳鑛躼閅閦鐦閠濶䊹𢙺𨛘𡉼𣸮䧟氜陻隖䅬隣𦻕懚隶磵𨫠隽双䦡𦲸𠉴𦐐𩂯𩃥𤫑𡤕𣌊霱虂霶䨏䔽䖅𤫩灵孁霛靜𩇕靗孊𩇫靟鐥僐𣂷𣂼鞉鞟鞱鞾韀韒韠𥑬韮琜𩐳響韵𩐝𧥺䫑頴頳顋顦㬎𧅵㵑𠘰𤅜"],["9140","𥜆飊颷飈飇䫿𦴧𡛓喰飡飦飬鍸餹𤨩䭲𩡗𩤅駵騌騻騐驘𥜥㛄𩂱𩯕髠髢𩬅髴䰎鬔鬭𨘀倴鬴𦦨㣃𣁽魐魀𩴾婅𡡣鮎𤉋鰂鯿鰌𩹨鷔𩾷𪆒𪆫𪃡𪄣𪇟鵾鶃𪄴鸎梈"],["91a1","鷄𢅛𪆓𪈠𡤻𪈳鴹𪂹𪊴麐麕麞麢䴴麪麯𤍤黁㭠㧥㴝伲㞾𨰫鼂鼈䮖鐤𦶢鼗鼖鼹嚟嚊齅馸𩂋韲葿齢齩竜龎爖䮾𤥵𤦻煷𤧸𤍈𤩑玞𨯚𡣺禟𨥾𨸶鍩鏳𨩄鋬鎁鏋𨥬𤒹爗㻫睲穃烐𤑳𤏸煾𡟯炣𡢾𣖙㻇𡢅𥐯𡟸㜢𡛻𡠹㛡𡝴𡣑𥽋㜣𡛀坛𤨥𡏾𡊨"],["9240","𡏆𡒶蔃𣚦蔃葕𤦔𧅥𣸱𥕜𣻻𧁒䓴𣛮𩦝𦼦柹㜳㰕㷧塬𡤢栐䁗𣜿𤃡𤂋𤄏𦰡哋嚞𦚱嚒𠿟𠮨𠸍鏆𨬓鎜仸儫㠙𤐶亼𠑥𠍿佋侊𥙑婨𠆫𠏋㦙𠌊𠐔㐵伩𠋀𨺳𠉵諚𠈌亘"],["92a1","働儍侢伃𤨎𣺊佂倮偬傁俌俥偘僼兙兛兝兞湶𣖕𣸹𣺿浲𡢄𣺉冨凃𠗠䓝𠒣𠒒𠒑赺𨪜𠜎剙劤𠡳勡鍮䙺熌𤎌𠰠𤦬𡃤槑𠸝瑹㻞璙琔瑖玘䮎𤪼𤂍叐㖄爏𤃉喴𠍅响𠯆圝鉝雴鍦埝垍坿㘾壋媙𨩆𡛺𡝯𡜐娬妸銏婾嫏娒𥥆𡧳𡡡𤊕㛵洅瑃娡𥺃"],["9340","媁𨯗𠐓鏠璌𡌃焅䥲鐈𨧻鎽㞠尞岞幞幈𡦖𡥼𣫮廍孏𡤃𡤄㜁𡢠㛝𡛾㛓脪𨩇𡶺𣑲𨦨弌弎𡤧𡞫婫𡜻孄蘔𧗽衠恾𢡠𢘫忛㺸𢖯𢖾𩂈𦽳懀𠀾𠁆𢘛憙憘恵𢲛𢴇𤛔𩅍"],["93a1","摱𤙥𢭪㨩𢬢𣑐𩣪𢹸挷𪑛撶挱揑𤧣𢵧护𢲡搻敫楲㯴𣂎𣊭𤦉𣊫唍𣋠𡣙𩐿曎𣊉𣆳㫠䆐𥖄𨬢𥖏𡛼𥕛𥐥磮𣄃𡠪𣈴㑤𣈏𣆂𤋉暎𦴤晫䮓昰𧡰𡷫晣𣋒𣋡昞𥡲㣑𣠺𣞼㮙𣞢𣏾瓐㮖枏𤘪梶栞㯄檾㡣𣟕𤒇樳橒櫉欅𡤒攑梘橌㯗橺歗𣿀𣲚鎠鋲𨯪𨫋"],["9440","銉𨀞𨧜鑧涥漋𤧬浧𣽿㶏渄𤀼娽渊塇洤硂焻𤌚𤉶烱牐犇犔𤞏𤜥兹𤪤𠗫瑺𣻸𣙟𤩊𤤗𥿡㼆㺱𤫟𨰣𣼵悧㻳瓌琼鎇琷䒟𦷪䕑疃㽣𤳙𤴆㽘畕癳𪗆㬙瑨𨫌𤦫𤦎㫻"],["94a1","㷍𤩎㻿𤧅𤣳釺圲鍂𨫣𡡤僟𥈡𥇧睸𣈲眎眏睻𤚗𣞁㩞𤣰琸璛㺿𤪺𤫇䃈𤪖𦆮錇𥖁砞碍碈磒珐祙𧝁𥛣䄎禛蒖禥樭𣻺稺秴䅮𡛦䄲鈵秱𠵌𤦌𠊙𣶺𡝮㖗啫㕰㚪𠇔𠰍竢婙𢛵𥪯𥪜娍𠉛磰娪𥯆竾䇹籝籭䈑𥮳𥺼𥺦糍𤧹𡞰粎籼粮檲緜縇緓罎𦉡"],["9540","𦅜𧭈綗𥺂䉪𦭵𠤖柖𠁎𣗏埄𦐒𦏸𤥢翝笧𠠬𥫩𥵃笌𥸎駦虅驣樜𣐿㧢𤧷𦖭騟𦖠蒀𧄧𦳑䓪脷䐂胆脉腂𦞴飃𦩂艢艥𦩑葓𦶧蘐𧈛媆䅿𡡀嬫𡢡嫤𡣘蚠蜨𣶏蠭𧐢娂"],["95a1","衮佅袇袿裦襥襍𥚃襔𧞅𧞄𨯵𨯙𨮜𨧹㺭蒣䛵䛏㟲訽訜𩑈彍鈫𤊄旔焩烄𡡅鵭貟賩𧷜妚矃姰䍮㛔踪躧𤰉輰轊䋴汘澻𢌡䢛潹溋𡟚鯩㚵𤤯邻邗啱䤆醻鐄𨩋䁢𨫼鐧𨰝𨰻蓥訫閙閧閗閖𨴴瑅㻂𤣿𤩂𤏪㻧𣈥随𨻧𨹦𨹥㻌𤧭𤩸𣿮琒瑫㻼靁𩂰"],["9640","桇䨝𩂓𥟟靝鍨𨦉𨰦𨬯𦎾銺嬑譩䤼珹𤈛鞛靱餸𠼦巁𨯅𤪲頟𩓚鋶𩗗釥䓀𨭐𤩧𨭤飜𨩅㼀鈪䤥萔餻饍𧬆㷽馛䭯馪驜𨭥𥣈檏騡嫾騯𩣱䮐𩥈馼䮽䮗鍽塲𡌂堢𤦸"],["96a1","𡓨硄𢜟𣶸棅㵽鑘㤧慐𢞁𢥫愇鱏鱓鱻鰵鰐魿鯏𩸭鮟𪇵𪃾鴡䲮𤄄鸘䲰鴌𪆴𪃭𪃳𩤯鶥蒽𦸒𦿟𦮂藼䔳𦶤𦺄𦷰萠藮𦸀𣟗𦁤秢𣖜𣙀䤭𤧞㵢鏛銾鍈𠊿碹鉷鑍俤㑀遤𥕝砽硔碶硋𡝗𣇉𤥁㚚佲濚濙瀞瀞吔𤆵垻壳垊鴖埗焴㒯𤆬燫𦱀𤾗嬨𡞵𨩉"],["9740","愌嫎娋䊼𤒈㜬䭻𨧼鎻鎸𡣖𠼝葲𦳀𡐓𤋺𢰦𤏁妔𣶷𦝁綨𦅛𦂤𤦹𤦋𨧺鋥珢㻩璴𨭣𡢟㻡𤪳櫘珳珻㻖𤨾𤪔𡟙𤩦𠎧𡐤𤧥瑈𤤖炥𤥶銄珦鍟𠓾錱𨫎𨨖鎆𨯧𥗕䤵𨪂煫"],["97a1","𤥃𠳿嚤𠘚𠯫𠲸唂秄𡟺緾𡛂𤩐𡡒䔮鐁㜊𨫀𤦭妰𡢿𡢃𧒄媡㛢𣵛㚰鉟婹𨪁𡡢鍴㳍𠪴䪖㦊僴㵩㵌𡎜煵䋻𨈘渏𩃤䓫浗𧹏灧沯㳖𣿭𣸭渂漌㵯𠏵畑㚼㓈䚀㻚䡱姄鉮䤾轁𨰜𦯀堒埈㛖𡑒烾𤍢𤩱𢿣𡊰𢎽梹楧𡎘𣓥𧯴𣛟𨪃𣟖𣏺𤲟樚𣚭𦲷萾䓟䓎"],["9840","𦴦𦵑𦲂𦿞漗𧄉茽𡜺菭𦲀𧁓𡟛妉媂𡞳婡婱𡤅𤇼㜭姯𡜼㛇熎鎐暚𤊥婮娫𤊓樫𣻹𧜶𤑛𤋊焝𤉙𨧡侰𦴨峂𤓎𧹍𤎽樌𤉖𡌄炦焳𤏩㶥泟勇𤩏繥姫崯㷳彜𤩝𡟟綤萦"],["98a1","咅𣫺𣌀𠈔坾𠣕𠘙㿥𡾞𪊶瀃𩅛嵰玏糓𨩙𩐠俈翧狍猐𧫴猸猹𥛶獁獈㺩𧬘遬燵𤣲珡臶㻊県㻑沢国琙琞琟㻢㻰㻴㻺瓓㼎㽓畂畭畲疍㽼痈痜㿀癍㿗癴㿜発𤽜熈嘣覀塩䀝睃䀹条䁅㗛瞘䁪䁯属瞾矋売砘点砜䂨砹硇硑硦葈𥔵礳栃礲䄃"],["9940","䄉禑禙辻稆込䅧窑䆲窼艹䇄竏竛䇏両筢筬筻簒簛䉠䉺类粜䊌粸䊔糭输烀𠳏総緔緐緽羮羴犟䎗耠耥笹耮耱联㷌垴炠肷胩䏭脌猪脎脒畠脔䐁㬹腖腙腚"],["99a1","䐓堺腼膄䐥膓䐭膥埯臁臤艔䒏芦艶苊苘苿䒰荗险榊萅烵葤惣蒈䔄蒾蓡蓸蔐蔸蕒䔻蕯蕰藠䕷虲蚒蚲蛯际螋䘆䘗袮裿褤襇覑𧥧訩訸誔誴豑賔賲贜䞘塟跃䟭仮踺嗘坔蹱嗵躰䠷軎転軤軭軲辷迁迊迌逳駄䢭飠鈓䤞鈨鉘鉫銱銮銿"],["9a40","鋣鋫鋳鋴鋽鍃鎄鎭䥅䥑麿鐗匁鐝鐭鐾䥪鑔鑹锭関䦧间阳䧥枠䨤靀䨵鞲韂噔䫤惨颹䬙飱塄餎餙冴餜餷饂饝饢䭰駅䮝騼鬏窃魩鮁鯝鯱鯴䱭鰠㝯𡯂鵉鰺"],["9aa1","黾噐鶓鶽鷀鷼银辶鹻麬麱麽黆铜黢黱黸竈齄𠂔𠊷𠎠椚铃妬𠓗塀铁㞹𠗕𠘕𠙶𡚺块煳𠫂𠫍𠮿呪吆𠯋咞𠯻𠰻𠱓𠱥𠱼惧𠲍噺𠲵𠳝𠳭𠵯𠶲𠷈楕鰯螥𠸄𠸎𠻗𠾐𠼭𠹳尠𠾼帋𡁜𡁏𡁶朞𡁻𡂈𡂖㙇𡂿𡃓𡄯𡄻卤蒭𡋣𡍵𡌶讁𡕷𡘙𡟃𡟇乸炻𡠭𡥪"],["9b40","𡨭𡩅𡰪𡱰𡲬𡻈拃𡻕𡼕熘桕𢁅槩㛈𢉼𢏗𢏺𢜪𢡱𢥏苽𢥧𢦓𢫕覥𢫨辠𢬎鞸𢬿顇骽𢱌"],["9b62","𢲈𢲷𥯨𢴈𢴒𢶷𢶕𢹂𢽴𢿌𣀳𣁦𣌟𣏞徱晈暿𧩹𣕧𣗳爁𤦺矗𣘚𣜖纇𠍆墵朎"],["9ba1","椘𣪧𧙗𥿢𣸑𣺹𧗾𢂚䣐䪸𤄙𨪚𤋮𤌍𤀻𤌴𤎖𤩅𠗊凒𠘑妟𡺨㮾𣳿𤐄𤓖垈𤙴㦛𤜯𨗨𩧉㝢𢇃譞𨭎駖𤠒𤣻𤨕爉𤫀𠱸奥𤺥𤾆𠝹軚𥀬劏圿煱𥊙𥐙𣽊𤪧喼𥑆𥑮𦭒釔㑳𥔿𧘲𥕞䜘𥕢𥕦𥟇𤤿𥡝偦㓻𣏌惞𥤃䝼𨥈𥪮𥮉𥰆𡶐垡煑澶𦄂𧰒遖𦆲𤾚譢𦐂𦑊"],["9c40","嵛𦯷輶𦒄𡤜諪𤧶𦒈𣿯𦔒䯀𦖿𦚵𢜛鑥𥟡憕娧晉侻嚹𤔡𦛼乪𤤴陖涏𦲽㘘襷𦞙𦡮𦐑𦡞營𦣇筂𩃀𠨑𦤦鄄𦤹穅鷰𦧺騦𦨭㙟𦑩𠀡禃𦨴𦭛崬𣔙菏𦮝䛐𦲤画补𦶮墶"],["9ca1","㜜𢖍𧁋𧇍㱔𧊀𧊅銁𢅺𧊋錰𧋦𤧐氹钟𧑐𠻸蠧裵𢤦𨑳𡞱溸𤨪𡠠㦤㚹尐秣䔿暶𩲭𩢤襃𧟌𧡘囖䃟𡘊㦡𣜯𨃨𡏅熭荦𧧝𩆨婧䲷𧂯𨦫𧧽𧨊𧬋𧵦𤅺筃祾𨀉澵𪋟樃𨌘厢𦸇鎿栶靝𨅯𨀣𦦵𡏭𣈯𨁈嶅𨰰𨂃圕頣𨥉嶫𤦈斾槕叒𤪥𣾁㰑朶𨂐𨃴𨄮𡾡𨅏"],["9d40","𨆉𨆯𨈚𨌆𨌯𨎊㗊𨑨𨚪䣺揦𨥖砈鉕𨦸䏲𨧧䏟𨧨𨭆𨯔姸𨰉輋𨿅𩃬筑𩄐𩄼㷷𩅞𤫊运犏嚋𩓧𩗩𩖰𩖸𩜲𩣑𩥉𩥪𩧃𩨨𩬎𩵚𩶛纟𩻸𩼣䲤镇𪊓熢𪋿䶑递𪗋䶜𠲜达嗁"],["9da1","辺𢒰边𤪓䔉繿潖檱仪㓤𨬬𧢝㜺躀𡟵𨀤𨭬𨮙𧨾𦚯㷫𧙕𣲷𥘵𥥖亚𥺁𦉘嚿𠹭踎孭𣺈𤲞揞拐𡟶𡡻攰嘭𥱊吚𥌑㷆𩶘䱽嘢嘞罉𥻘奵𣵀蝰东𠿪𠵉𣚺脗鵞贘瘻鱅癎瞹鍅吲腈苷嘥脲萘肽嗪祢噃吖𠺝㗎嘅嗱曱𨋢㘭甴嗰喺咗啲𠱁𠲖廐𥅈𠹶𢱢"],["9e40","𠺢麫絚嗞𡁵抝靭咔賍燶酶揼掹揾啩𢭃鱲𢺳冚㓟𠶧冧呍唞唓癦踭𦢊疱肶蠄螆裇膶萜𡃁䓬猄𤜆宐茋𦢓噻𢛴𧴯𤆣𧵳𦻐𧊶酰𡇙鈈𣳼𪚩𠺬𠻹牦𡲢䝎𤿂𧿹𠿫䃺"],["9ea1","鱝攟𢶠䣳𤟠𩵼𠿬𠸊恢𧖣𠿭"],["9ead","𦁈𡆇熣纎鵐业丄㕷嬍沲卧㚬㧜卽㚥𤘘墚𤭮舭呋垪𥪕𠥹"],["9ec5","㩒𢑥獴𩺬䴉鯭𣳾𩼰䱛𤾩𩖞𩿞葜𣶶𧊲𦞳𣜠挮紥𣻷𣸬㨪逈勌㹴㙺䗩𠒎癀嫰𠺶硺𧼮墧䂿噼鮋嵴癔𪐴麅䳡痹㟻愙𣃚𤏲"],["9ef5","噝𡊩垧𤥣𩸆刴𧂮㖭汊鵼"],["9f40","籖鬹埞𡝬屓擓𩓐𦌵𧅤蚭𠴨𦴢𤫢𠵱"],["9f4f","凾𡼏嶎霃𡷑麁遌笟鬂峑箣扨挵髿篏鬪籾鬮籂粆鰕篼鬉鼗鰛𤤾齚啳寃俽麘俲剠㸆勑坧偖妷帒韈鶫轜呩鞴饀鞺匬愰"],["9fa1","椬叚鰊鴂䰻陁榀傦畆𡝭駚剳"],["9fae","酙隁酜"],["9fb2","酑𨺗捿𦴣櫊嘑醎畺抅𠏼獏籰𥰡𣳽"],["9fc1","𤤙盖鮝个𠳔莾衂"],["9fc9","届槀僭坺刟巵从氱𠇲伹咜哚劚趂㗾弌㗳"],["9fdb","歒酼龥鮗頮颴骺麨麄煺笔"],["9fe7","毺蠘罸"],["9feb","嘠𪙊蹷齓"],["9ff0","跔蹏鸜踁抂𨍽踨蹵竓𤩷稾磘泪詧瘇"],["a040","𨩚鼦泎蟖痃𪊲硓咢贌狢獱謭猂瓱賫𤪻蘯徺袠䒷"],["a055","𡠻𦸅"],["a058","詾𢔛"],["a05b","惽癧髗鵄鍮鮏蟵"],["a063","蠏賷猬霡鮰㗖犲䰇籑饊𦅙慙䰄麖慽"],["a073","坟慯抦戹拎㩜懢厪𣏵捤栂㗒"],["a0a1","嵗𨯂迚𨸹"],["a0a6","僙𡵆礆匲阸𠼻䁥"],["a0ae","矾"],["a0b0","糂𥼚糚稭聦聣絍甅瓲覔舚朌聢𧒆聛瓰脃眤覉𦟌畓𦻑螩蟎臈螌詉貭譃眫瓸蓚㘵榲趦"],["a0d4","覩瑨涹蟁𤀑瓧㷛煶悤憜㳑煢恷"],["a0e2","罱𨬭牐惩䭾删㰘𣳇𥻗𧙖𥔱𡥄𡋾𩤃𦷜𧂭峁𦆭𨨏𣙷𠃮𦡆𤼎䕢嬟𦍌齐麦𦉫"],["a3c0","␀",31,"␡"],["c6a1","①",9,"⑴",9,"ⅰ",9,"丶丿亅亠冂冖冫勹匸卩厶夊宀巛⼳广廴彐彡攴无疒癶辵隶¨ˆヽヾゝゞ〃仝々〆〇ー［］✽ぁ",23],["c740","す",58,"ァアィイ"],["c7a1","ゥ",81,"А",5,"ЁЖ",4],["c840","Л",26,"ёж",25,"⇧↸↹㇏𠃌乚𠂊刂䒑"],["c8a1","龰冈龱𧘇"],["c8cd","￢￤＇＂㈱№℡゛゜⺀⺄⺆⺇⺈⺊⺌⺍⺕⺜⺝⺥⺧⺪⺬⺮⺶⺼⺾⻆⻊⻌⻍⻏⻖⻗⻞⻣"],["c8f5","ʃɐɛɔɵœøŋʊɪ"],["f9fe","￭"],["fa40","𠕇鋛𠗟𣿅蕌䊵珯况㙉𤥂𨧤鍄𡧛苮𣳈砼杄拟𤤳𨦪𠊠𦮳𡌅侫𢓭倈𦴩𧪄𣘀𤪱𢔓倩𠍾徤𠎀𠍇滛𠐟偽儁㑺儎顬㝃萖𤦤𠒇兠𣎴兪𠯿𢃼𠋥𢔰𠖎𣈳𡦃宂蝽𠖳𣲙冲冸"],["faa1","鴴凉减凑㳜凓𤪦决凢卂凭菍椾𣜭彻刋刦刼劵剗劔効勅簕蕂勠蘍𦬓包𨫞啉滙𣾀𠥔𣿬匳卄𠯢泋𡜦栛珕恊㺪㣌𡛨燝䒢卭却𨚫卾卿𡖖𡘓矦厓𨪛厠厫厮玧𥝲㽙玜叁叅汉义埾叙㪫𠮏叠𣿫𢶣叶𠱷吓灹唫晗浛呭𦭓𠵴啝咏咤䞦𡜍𠻝㶴𠵍"],["fb40","𨦼𢚘啇䳭启琗喆喩嘅𡣗𤀺䕒𤐵暳𡂴嘷曍𣊊暤暭噍噏磱囱鞇叾圀囯园𨭦㘣𡉏坆𤆥汮炋坂㚱𦱾埦𡐖堃𡑔𤍣堦𤯵塜墪㕡壠壜𡈼壻寿坃𪅐𤉸鏓㖡够梦㛃湙"],["fba1","𡘾娤啓𡚒蔅姉𠵎𦲁𦴪𡟜姙𡟻𡞲𦶦浱𡠨𡛕姹𦹅媫婣㛦𤦩婷㜈媖瑥嫓𦾡𢕔㶅𡤑㜲𡚸広勐孶斈孼𧨎䀄䡝𠈄寕慠𡨴𥧌𠖥寳宝䴐尅𡭄尓珎尔𡲥𦬨屉䣝岅峩峯嶋𡷹𡸷崐崘嵆𡺤岺巗苼㠭𤤁𢁉𢅳芇㠶㯂帮檊幵幺𤒼𠳓厦亷廐厨𡝱帉廴𨒂"],["fc40","廹廻㢠廼栾鐛弍𠇁弢㫞䢮𡌺强𦢈𢏐彘𢑱彣鞽𦹮彲鍀𨨶徧嶶㵟𥉐𡽪𧃸𢙨釖𠊞𨨩怱暅𡡷㥣㷇㘹垐𢞴祱㹀悞悤悳𤦂𤦏𧩓璤僡媠慤萤慂慈𦻒憁凴𠙖憇宪𣾷"],["fca1","𢡟懓𨮝𩥝懐㤲𢦀𢣁怣慜攞掋𠄘担𡝰拕𢸍捬𤧟㨗搸揸𡎎𡟼撐澊𢸶頔𤂌𥜝擡擥鑻㩦携㩗敍漖𤨨𤨣斅敭敟𣁾斵𤥀䬷旑䃘𡠩无旣忟𣐀昘𣇷𣇸晄𣆤𣆥晋𠹵晧𥇦晳晴𡸽𣈱𨗴𣇈𥌓矅𢣷馤朂𤎜𤨡㬫槺𣟂杞杧杢𤇍𩃭柗䓩栢湐鈼栁𣏦𦶠桝"],["fd40","𣑯槡樋𨫟楳棃𣗍椁椀㴲㨁𣘼㮀枬楡𨩊䋼椶榘㮡𠏉荣傐槹𣙙𢄪橅𣜃檝㯳枱櫈𩆜㰍欝𠤣惞欵歴𢟍溵𣫛𠎵𡥘㝀吡𣭚毡𣻼毜氷𢒋𤣱𦭑汚舦汹𣶼䓅𣶽𤆤𤤌𤤀"],["fda1","𣳉㛥㳫𠴲鮃𣇹𢒑羏样𦴥𦶡𦷫涖浜湼漄𤥿𤂅𦹲蔳𦽴凇沜渝萮𨬡港𣸯瑓𣾂秌湏媑𣁋濸㜍澝𣸰滺𡒗𤀽䕕鏰潄潜㵎潴𩅰㴻澟𤅄濓𤂑𤅕𤀹𣿰𣾴𤄿凟𤅖𤅗𤅀𦇝灋灾炧炁烌烕烖烟䄄㷨熴熖𤉷焫煅媈煊煮岜𤍥煏鍢𤋁焬𤑚𤨧𤨢熺𨯨炽爎"],["fe40","鑂爕夑鑃爤鍁𥘅爮牀𤥴梽牕牗㹕𣁄栍漽犂猪猫𤠣𨠫䣭𨠄猨献珏玪𠰺𦨮珉瑉𤇢𡛧𤨤昣㛅𤦷𤦍𤧻珷琕椃𤨦琹𠗃㻗瑜𢢭瑠𨺲瑇珤瑶莹瑬㜰瑴鏱樬璂䥓𤪌"],["fea1","𤅟𤩹𨮏孆𨰃𡢞瓈𡦈甎瓩甞𨻙𡩋寗𨺬鎅畍畊畧畮𤾂㼄𤴓疎瑝疞疴瘂瘬癑癏癯癶𦏵皐臯㟸𦤑𦤎皡皥皷盌𦾟葢𥂝𥅽𡸜眞眦着撯𥈠睘𣊬瞯𨥤𨥨𡛁矴砉𡍶𤨒棊碯磇磓隥礮𥗠磗礴碱𧘌辸袄𨬫𦂃𢘜禆褀椂禀𥡗禝𧬹礼禩渪𧄦㺨秆𩄍秔"]]

/***/ },
/* 1802 */
/***/ function(module, exports) {

	module.exports = [["0","\u0000",127],["8141","갂갃갅갆갋",4,"갘갞갟갡갢갣갥",6,"갮갲갳갴"],["8161","갵갶갷갺갻갽갾갿걁",9,"걌걎",5,"걕"],["8181","걖걗걙걚걛걝",18,"걲걳걵걶걹걻",4,"겂겇겈겍겎겏겑겒겓겕",6,"겞겢",5,"겫겭겮겱",6,"겺겾겿곀곂곃곅곆곇곉곊곋곍",7,"곖곘",7,"곢곣곥곦곩곫곭곮곲곴곷",4,"곾곿괁괂괃괅괇",4,"괎괐괒괓"],["8241","괔괕괖괗괙괚괛괝괞괟괡",7,"괪괫괮",5],["8261","괶괷괹괺괻괽",6,"굆굈굊",5,"굑굒굓굕굖굗"],["8281","굙",7,"굢굤",7,"굮굯굱굲굷굸굹굺굾궀궃",4,"궊궋궍궎궏궑",10,"궞",5,"궥",17,"궸",7,"귂귃귅귆귇귉",6,"귒귔",7,"귝귞귟귡귢귣귥",18],["8341","귺귻귽귾긂",5,"긊긌긎",5,"긕",7],["8361","긝",18,"긲긳긵긶긹긻긼"],["8381","긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗",4,"깞깢깣깤깦깧깪깫깭깮깯깱",6,"깺깾",5,"꺆",5,"꺍",46,"꺿껁껂껃껅",6,"껎껒",5,"껚껛껝",8],["8441","껦껧껩껪껬껮",5,"껵껶껷껹껺껻껽",8],["8461","꼆꼉꼊꼋꼌꼎꼏꼑",18],["8481","꼤",7,"꼮꼯꼱꼳꼵",6,"꼾꽀꽄꽅꽆꽇꽊",5,"꽑",10,"꽞",5,"꽦",18,"꽺",5,"꾁꾂꾃꾅꾆꾇꾉",6,"꾒꾓꾔꾖",5,"꾝",26,"꾺꾻꾽꾾"],["8541","꾿꿁",5,"꿊꿌꿏",4,"꿕",6,"꿝",4],["8561","꿢",5,"꿪",5,"꿲꿳꿵꿶꿷꿹",6,"뀂뀃"],["8581","뀅",6,"뀍뀎뀏뀑뀒뀓뀕",6,"뀞",9,"뀩",26,"끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞",29,"끾끿낁낂낃낅",6,"낎낐낒",5,"낛낝낞낣낤"],["8641","낥낦낧낪낰낲낶낷낹낺낻낽",6,"냆냊",5,"냒"],["8661","냓냕냖냗냙",6,"냡냢냣냤냦",10],["8681","냱",22,"넊넍넎넏넑넔넕넖넗넚넞",4,"넦넧넩넪넫넭",6,"넶넺",5,"녂녃녅녆녇녉",6,"녒녓녖녗녙녚녛녝녞녟녡",22,"녺녻녽녾녿놁놃",4,"놊놌놎놏놐놑놕놖놗놙놚놛놝"],["8741","놞",9,"놩",15],["8761","놹",18,"뇍뇎뇏뇑뇒뇓뇕"],["8781","뇖",5,"뇞뇠",7,"뇪뇫뇭뇮뇯뇱",7,"뇺뇼뇾",5,"눆눇눉눊눍",6,"눖눘눚",5,"눡",18,"눵",6,"눽",26,"뉙뉚뉛뉝뉞뉟뉡",6,"뉪",4],["8841","뉯",4,"뉶",5,"뉽",6,"늆늇늈늊",4],["8861","늏늒늓늕늖늗늛",4,"늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷"],["8881","늸",15,"닊닋닍닎닏닑닓",4,"닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉",6,"댒댖",5,"댝",54,"덗덙덚덝덠덡덢덣"],["8941","덦덨덪덬덭덯덲덳덵덶덷덹",6,"뎂뎆",5,"뎍"],["8961","뎎뎏뎑뎒뎓뎕",10,"뎢",5,"뎩뎪뎫뎭"],["8981","뎮",21,"돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩",18,"돽",18,"됑",6,"됙됚됛됝됞됟됡",6,"됪됬",7,"됵",15],["8a41","둅",10,"둒둓둕둖둗둙",6,"둢둤둦"],["8a61","둧",4,"둭",18,"뒁뒂"],["8a81","뒃",4,"뒉",19,"뒞",5,"뒥뒦뒧뒩뒪뒫뒭",7,"뒶뒸뒺",5,"듁듂듃듅듆듇듉",6,"듑듒듓듔듖",5,"듞듟듡듢듥듧",4,"듮듰듲",5,"듹",26,"딖딗딙딚딝"],["8b41","딞",5,"딦딫",4,"딲딳딵딶딷딹",6,"땂땆"],["8b61","땇땈땉땊땎땏땑땒땓땕",6,"땞땢",8],["8b81","땫",52,"떢떣떥떦떧떩떬떭떮떯떲떶",4,"떾떿뗁뗂뗃뗅",6,"뗎뗒",5,"뗙",18,"뗭",18],["8c41","똀",15,"똒똓똕똖똗똙",4],["8c61","똞",6,"똦",5,"똭",6,"똵",5],["8c81","똻",12,"뙉",26,"뙥뙦뙧뙩",50,"뚞뚟뚡뚢뚣뚥",5,"뚭뚮뚯뚰뚲",16],["8d41","뛃",16,"뛕",8],["8d61","뛞",17,"뛱뛲뛳뛵뛶뛷뛹뛺"],["8d81","뛻",4,"뜂뜃뜄뜆",33,"뜪뜫뜭뜮뜱",6,"뜺뜼",7,"띅띆띇띉띊띋띍",6,"띖",9,"띡띢띣띥띦띧띩",6,"띲띴띶",5,"띾띿랁랂랃랅",6,"랎랓랔랕랚랛랝랞"],["8e41","랟랡",6,"랪랮",5,"랶랷랹",8],["8e61","럂",4,"럈럊",19],["8e81","럞",13,"럮럯럱럲럳럵",6,"럾렂",4,"렊렋렍렎렏렑",6,"렚렜렞",5,"렦렧렩렪렫렭",6,"렶렺",5,"롁롂롃롅",11,"롒롔",7,"롞롟롡롢롣롥",6,"롮롰롲",5,"롹롺롻롽",7],["8f41","뢅",7,"뢎",17],["8f61","뢠",7,"뢩",6,"뢱뢲뢳뢵뢶뢷뢹",4],["8f81","뢾뢿룂룄룆",5,"룍룎룏룑룒룓룕",7,"룞룠룢",5,"룪룫룭룮룯룱",6,"룺룼룾",5,"뤅",18,"뤙",6,"뤡",26,"뤾뤿륁륂륃륅",6,"륍륎륐륒",5],["9041","륚륛륝륞륟륡",6,"륪륬륮",5,"륶륷륹륺륻륽"],["9061","륾",5,"릆릈릋릌릏",15],["9081","릟",12,"릮릯릱릲릳릵",6,"릾맀맂",5,"맊맋맍맓",4,"맚맜맟맠맢맦맧맩맪맫맭",6,"맶맻",4,"먂",5,"먉",11,"먖",33,"먺먻먽먾먿멁멃멄멅멆"],["9141","멇멊멌멏멐멑멒멖멗멙멚멛멝",6,"멦멪",5],["9161","멲멳멵멶멷멹",9,"몆몈몉몊몋몍",5],["9181","몓",20,"몪몭몮몯몱몳",4,"몺몼몾",5,"뫅뫆뫇뫉",14,"뫚",33,"뫽뫾뫿묁묂묃묅",7,"묎묐묒",5,"묙묚묛묝묞묟묡",6],["9241","묨묪묬",7,"묷묹묺묿",4,"뭆뭈뭊뭋뭌뭎뭑뭒"],["9261","뭓뭕뭖뭗뭙",7,"뭢뭤",7,"뭭",4],["9281","뭲",21,"뮉뮊뮋뮍뮎뮏뮑",18,"뮥뮦뮧뮩뮪뮫뮭",6,"뮵뮶뮸",7,"믁믂믃믅믆믇믉",6,"믑믒믔",35,"믺믻믽믾밁"],["9341","밃",4,"밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵"],["9361","밶밷밹",6,"뱂뱆뱇뱈뱊뱋뱎뱏뱑",8],["9381","뱚뱛뱜뱞",37,"벆벇벉벊벍벏",4,"벖벘벛",4,"벢벣벥벦벩",6,"벲벶",5,"벾벿볁볂볃볅",7,"볎볒볓볔볖볗볙볚볛볝",22,"볷볹볺볻볽"],["9441","볾",5,"봆봈봊",5,"봑봒봓봕",8],["9461","봞",5,"봥",6,"봭",12],["9481","봺",5,"뵁",6,"뵊뵋뵍뵎뵏뵑",6,"뵚",9,"뵥뵦뵧뵩",22,"붂붃붅붆붋",4,"붒붔붖붗붘붛붝",6,"붥",10,"붱",6,"붹",24],["9541","뷒뷓뷖뷗뷙뷚뷛뷝",11,"뷪",5,"뷱"],["9561","뷲뷳뷵뷶뷷뷹",6,"븁븂븄븆",5,"븎븏븑븒븓"],["9581","븕",6,"븞븠",35,"빆빇빉빊빋빍빏",4,"빖빘빜빝빞빟빢빣빥빦빧빩빫",4,"빲빶",4,"빾빿뺁뺂뺃뺅",6,"뺎뺒",5,"뺚",13,"뺩",14],["9641","뺸",23,"뻒뻓"],["9661","뻕뻖뻙",6,"뻡뻢뻦",5,"뻭",8],["9681","뻶",10,"뼂",5,"뼊",13,"뼚뼞",33,"뽂뽃뽅뽆뽇뽉",6,"뽒뽓뽔뽖",44],["9741","뾃",16,"뾕",8],["9761","뾞",17,"뾱",7],["9781","뾹",11,"뿆",5,"뿎뿏뿑뿒뿓뿕",6,"뿝뿞뿠뿢",89,"쀽쀾쀿"],["9841","쁀",16,"쁒",5,"쁙쁚쁛"],["9861","쁝쁞쁟쁡",6,"쁪",15],["9881","쁺",21,"삒삓삕삖삗삙",6,"삢삤삦",5,"삮삱삲삷",4,"삾샂샃샄샆샇샊샋샍샎샏샑",6,"샚샞",5,"샦샧샩샪샫샭",6,"샶샸샺",5,"섁섂섃섅섆섇섉",6,"섑섒섓섔섖",5,"섡섢섥섨섩섪섫섮"],["9941","섲섳섴섵섷섺섻섽섾섿셁",6,"셊셎",5,"셖셗"],["9961","셙셚셛셝",6,"셦셪",5,"셱셲셳셵셶셷셹셺셻"],["9981","셼",8,"솆",5,"솏솑솒솓솕솗",4,"솞솠솢솣솤솦솧솪솫솭솮솯솱",11,"솾",5,"쇅쇆쇇쇉쇊쇋쇍",6,"쇕쇖쇙",6,"쇡쇢쇣쇥쇦쇧쇩",6,"쇲쇴",7,"쇾쇿숁숂숃숅",6,"숎숐숒",5,"숚숛숝숞숡숢숣"],["9a41","숤숥숦숧숪숬숮숰숳숵",16],["9a61","쉆쉇쉉",6,"쉒쉓쉕쉖쉗쉙",6,"쉡쉢쉣쉤쉦"],["9a81","쉧",4,"쉮쉯쉱쉲쉳쉵",6,"쉾슀슂",5,"슊",5,"슑",6,"슙슚슜슞",5,"슦슧슩슪슫슮",5,"슶슸슺",33,"싞싟싡싢싥",5,"싮싰싲싳싴싵싷싺싽싾싿쌁",6,"쌊쌋쌎쌏"],["9b41","쌐쌑쌒쌖쌗쌙쌚쌛쌝",6,"쌦쌧쌪",8],["9b61","쌳",17,"썆",7],["9b81","썎",25,"썪썫썭썮썯썱썳",4,"썺썻썾",5,"쎅쎆쎇쎉쎊쎋쎍",50,"쏁",22,"쏚"],["9c41","쏛쏝쏞쏡쏣",4,"쏪쏫쏬쏮",5,"쏶쏷쏹",5],["9c61","쏿",8,"쐉",6,"쐑",9],["9c81","쐛",8,"쐥",6,"쐭쐮쐯쐱쐲쐳쐵",6,"쐾",9,"쑉",26,"쑦쑧쑩쑪쑫쑭",6,"쑶쑷쑸쑺",5,"쒁",18,"쒕",6,"쒝",12],["9d41","쒪",13,"쒹쒺쒻쒽",8],["9d61","쓆",25],["9d81","쓠",8,"쓪",5,"쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂",9,"씍씎씏씑씒씓씕",6,"씝",10,"씪씫씭씮씯씱",6,"씺씼씾",5,"앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩",6,"앲앶",5,"앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔"],["9e41","얖얙얚얛얝얞얟얡",7,"얪",9,"얶"],["9e61","얷얺얿",4,"엋엍엏엒엓엕엖엗엙",6,"엢엤엦엧"],["9e81","엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑",6,"옚옝",6,"옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉",6,"왒왖",5,"왞왟왡",10,"왭왮왰왲",5,"왺왻왽왾왿욁",6,"욊욌욎",5,"욖욗욙욚욛욝",6,"욦"],["9f41","욨욪",5,"욲욳욵욶욷욻",4,"웂웄웆",5,"웎"],["9f61","웏웑웒웓웕",6,"웞웟웢",5,"웪웫웭웮웯웱웲"],["9f81","웳",4,"웺웻웼웾",5,"윆윇윉윊윋윍",6,"윖윘윚",5,"윢윣윥윦윧윩",6,"윲윴윶윸윹윺윻윾윿읁읂읃읅",4,"읋읎읐읙읚읛읝읞읟읡",6,"읩읪읬",7,"읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛",4,"잢잧",4,"잮잯잱잲잳잵잶잷"],["a041","잸잹잺잻잾쟂",5,"쟊쟋쟍쟏쟑",6,"쟙쟚쟛쟜"],["a061","쟞",5,"쟥쟦쟧쟩쟪쟫쟭",13],["a081","쟻",4,"젂젃젅젆젇젉젋",4,"젒젔젗",4,"젞젟젡젢젣젥",6,"젮젰젲",5,"젹젺젻젽젾젿졁",6,"졊졋졎",5,"졕",26,"졲졳졵졶졷졹졻",4,"좂좄좈좉좊좎",5,"좕",7,"좞좠좢좣좤"],["a141","좥좦좧좩",18,"좾좿죀죁"],["a161","죂죃죅죆죇죉죊죋죍",6,"죖죘죚",5,"죢죣죥"],["a181","죦",14,"죶",5,"죾죿줁줂줃줇",4,"줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈",9,"±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢"],["a241","줐줒",5,"줙",18],["a261","줭",6,"줵",18],["a281","쥈",7,"쥒쥓쥕쥖쥗쥙",6,"쥢쥤",7,"쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®"],["a341","쥱쥲쥳쥵",6,"쥽",10,"즊즋즍즎즏"],["a361","즑",6,"즚즜즞",16],["a381","즯",16,"짂짃짅짆짉짋",4,"짒짔짗짘짛！",58,"￦］",32,"￣"],["a441","짞짟짡짣짥짦짨짩짪짫짮짲",5,"짺짻짽짾짿쨁쨂쨃쨄"],["a461","쨅쨆쨇쨊쨎",5,"쨕쨖쨗쨙",12],["a481","쨦쨧쨨쨪",28,"ㄱ",93],["a541","쩇",4,"쩎쩏쩑쩒쩓쩕",6,"쩞쩢",5,"쩩쩪"],["a561","쩫",17,"쩾",5,"쪅쪆"],["a581","쪇",16,"쪙",14,"ⅰ",9],["a5b0","Ⅰ",9],["a5c1","Α",16,"Σ",6],["a5e1","α",16,"σ",6],["a641","쪨",19,"쪾쪿쫁쫂쫃쫅"],["a661","쫆",5,"쫎쫐쫒쫔쫕쫖쫗쫚",5,"쫡",6],["a681","쫨쫩쫪쫫쫭",6,"쫵",18,"쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃",7],["a741","쬋",4,"쬑쬒쬓쬕쬖쬗쬙",6,"쬢",7],["a761","쬪",22,"쭂쭃쭄"],["a781","쭅쭆쭇쭊쭋쭍쭎쭏쭑",6,"쭚쭛쭜쭞",5,"쭥",7,"㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙",9,"㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰",9,"㎀",4,"㎺",5,"㎐",4,"Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆"],["a841","쭭",10,"쭺",14],["a861","쮉",18,"쮝",6],["a881","쮤",19,"쮹",11,"ÆÐªĦ"],["a8a6","Ĳ"],["a8a8","ĿŁØŒºÞŦŊ"],["a8b1","㉠",27,"ⓐ",25,"①",14,"½⅓⅔¼¾⅛⅜⅝⅞"],["a941","쯅",14,"쯕",10],["a961","쯠쯡쯢쯣쯥쯦쯨쯪",18],["a981","쯽",14,"찎찏찑찒찓찕",6,"찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀",27,"⒜",25,"⑴",14,"¹²³⁴ⁿ₁₂₃₄"],["aa41","찥찦찪찫찭찯찱",6,"찺찿",4,"챆챇챉챊챋챍챎"],["aa61","챏",4,"챖챚",5,"챡챢챣챥챧챩",6,"챱챲"],["aa81","챳챴챶",29,"ぁ",82],["ab41","첔첕첖첗첚첛첝첞첟첡",6,"첪첮",5,"첶첷첹"],["ab61","첺첻첽",6,"쳆쳈쳊",5,"쳑쳒쳓쳕",5],["ab81","쳛",8,"쳥",6,"쳭쳮쳯쳱",12,"ァ",85],["ac41","쳾쳿촀촂",5,"촊촋촍촎촏촑",6,"촚촜촞촟촠"],["ac61","촡촢촣촥촦촧촩촪촫촭",11,"촺",4],["ac81","촿",28,"쵝쵞쵟А",5,"ЁЖ",25],["acd1","а",5,"ёж",25],["ad41","쵡쵢쵣쵥",6,"쵮쵰쵲",5,"쵹",7],["ad61","춁",6,"춉",10,"춖춗춙춚춛춝춞춟"],["ad81","춠춡춢춣춦춨춪",5,"춱",18,"췅"],["ae41","췆",5,"췍췎췏췑",16],["ae61","췢",5,"췩췪췫췭췮췯췱",6,"췺췼췾",4],["ae81","츃츅츆츇츉츊츋츍",6,"츕츖츗츘츚",5,"츢츣츥츦츧츩츪츫"],["af41","츬츭츮츯츲츴츶",19],["af61","칊",13,"칚칛칝칞칢",5,"칪칬"],["af81","칮",5,"칶칷칹칺칻칽",6,"캆캈캊",5,"캒캓캕캖캗캙"],["b041","캚",5,"캢캦",5,"캮",12],["b061","캻",5,"컂",19],["b081","컖",13,"컦컧컩컪컭",6,"컶컺",5,"가각간갇갈갉갊감",7,"같",4,"갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆"],["b141","켂켃켅켆켇켉",6,"켒켔켖",5,"켝켞켟켡켢켣"],["b161","켥",6,"켮켲",5,"켹",11],["b181","콅",14,"콖콗콙콚콛콝",6,"콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸"],["b241","콭콮콯콲콳콵콶콷콹",6,"쾁쾂쾃쾄쾆",5,"쾍"],["b261","쾎",18,"쾢",5,"쾩"],["b281","쾪",5,"쾱",18,"쿅",6,"깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙"],["b341","쿌",19,"쿢쿣쿥쿦쿧쿩"],["b361","쿪",5,"쿲쿴쿶",5,"쿽쿾쿿퀁퀂퀃퀅",5],["b381","퀋",5,"퀒",5,"퀙",19,"끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫",4,"낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝"],["b441","퀮",5,"퀶퀷퀹퀺퀻퀽",6,"큆큈큊",5],["b461","큑큒큓큕큖큗큙",6,"큡",10,"큮큯"],["b481","큱큲큳큵",6,"큾큿킀킂",18,"뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫",4,"닳담답닷",4,"닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥"],["b541","킕",14,"킦킧킩킪킫킭",5],["b561","킳킶킸킺",5,"탂탃탅탆탇탊",5,"탒탖",4],["b581","탛탞탟탡탢탣탥",6,"탮탲",5,"탹",11,"덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸"],["b641","턅",7,"턎",17],["b661","턠",15,"턲턳턵턶턷턹턻턼턽턾"],["b681","턿텂텆",5,"텎텏텑텒텓텕",6,"텞텠텢",5,"텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗"],["b741","텮",13,"텽",6,"톅톆톇톉톊"],["b761","톋",20,"톢톣톥톦톧"],["b781","톩",6,"톲톴톶톷톸톹톻톽톾톿퇁",14,"래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩"],["b841","퇐",7,"퇙",17],["b861","퇫",8,"퇵퇶퇷퇹",13],["b881","툈툊",5,"툑",24,"륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많",4,"맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼"],["b941","툪툫툮툯툱툲툳툵",6,"툾퉀퉂",5,"퉉퉊퉋퉌"],["b961","퉍",14,"퉝",6,"퉥퉦퉧퉨"],["b981","퉩",22,"튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바",4,"받",4,"밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗"],["ba41","튍튎튏튒튓튔튖",5,"튝튞튟튡튢튣튥",6,"튭"],["ba61","튮튯튰튲",5,"튺튻튽튾틁틃",4,"틊틌",5],["ba81","틒틓틕틖틗틙틚틛틝",6,"틦",9,"틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤"],["bb41","틻",4,"팂팄팆",5,"팏팑팒팓팕팗",4,"팞팢팣"],["bb61","팤팦팧팪팫팭팮팯팱",6,"팺팾",5,"퍆퍇퍈퍉"],["bb81","퍊",31,"빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤"],["bc41","퍪",17,"퍾퍿펁펂펃펅펆펇"],["bc61","펈펉펊펋펎펒",5,"펚펛펝펞펟펡",6,"펪펬펮"],["bc81","펯",4,"펵펶펷펹펺펻펽",6,"폆폇폊",5,"폑",5,"샥샨샬샴샵샷샹섀섄섈섐섕서",4,"섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭"],["bd41","폗폙",7,"폢폤",7,"폮폯폱폲폳폵폶폷"],["bd61","폸폹폺폻폾퐀퐂",5,"퐉",13],["bd81","퐗",5,"퐞",25,"숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰"],["be41","퐸",7,"푁푂푃푅",14],["be61","푔",7,"푝푞푟푡푢푣푥",7,"푮푰푱푲"],["be81","푳",4,"푺푻푽푾풁풃",4,"풊풌풎",5,"풕",8,"쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄",6,"엌엎"],["bf41","풞",10,"풪",14],["bf61","풹",18,"퓍퓎퓏퓑퓒퓓퓕"],["bf81","퓖",5,"퓝퓞퓠",7,"퓩퓪퓫퓭퓮퓯퓱",6,"퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염",5,"옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨"],["c041","퓾",5,"픅픆픇픉픊픋픍",6,"픖픘",5],["c061","픞",25],["c081","픸픹픺픻픾픿핁핂핃핅",6,"핎핐핒",5,"핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응",7,"읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊"],["c141","핤핦핧핪핬핮",5,"핶핷핹핺핻핽",6,"햆햊햋"],["c161","햌햍햎햏햑",19,"햦햧"],["c181","햨",31,"점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓"],["c241","헊헋헍헎헏헑헓",4,"헚헜헞",5,"헦헧헩헪헫헭헮"],["c261","헯",4,"헶헸헺",5,"혂혃혅혆혇혉",6,"혒"],["c281","혖",5,"혝혞혟혡혢혣혥",7,"혮",9,"혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻"],["c341","혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝",4],["c361","홢",4,"홨홪",5,"홲홳홵",11],["c381","횁횂횄횆",5,"횎횏횑횒횓횕",7,"횞횠횢",5,"횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층"],["c441","횫횭횮횯횱",7,"횺횼",7,"훆훇훉훊훋"],["c461","훍훎훏훐훒훓훕훖훘훚",5,"훡훢훣훥훦훧훩",4],["c481","훮훯훱훲훳훴훶",5,"훾훿휁휂휃휅",11,"휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼"],["c541","휕휖휗휚휛휝휞휟휡",6,"휪휬휮",5,"휶휷휹"],["c561","휺휻휽",6,"흅흆흈흊",5,"흒흓흕흚",4],["c581","흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵",6,"흾흿힀힂",5,"힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜"],["c641","힍힎힏힑",6,"힚힜힞",5],["c6a1","퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁"],["c7a1","퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠"],["c8a1","혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝"],["caa1","伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕"],["cba1","匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢"],["cca1","瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械"],["cda1","棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜"],["cea1","科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾"],["cfa1","區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴"],["d0a1","鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣"],["d1a1","朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩",5,"那樂",4,"諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉"],["d2a1","納臘蠟衲囊娘廊",4,"乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧",5,"駑魯",10,"濃籠聾膿農惱牢磊腦賂雷尿壘",7,"嫩訥杻紐勒",5,"能菱陵尼泥匿溺多茶"],["d3a1","丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃"],["d4a1","棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅"],["d5a1","蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣"],["d6a1","煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼"],["d7a1","遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬"],["d8a1","立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅"],["d9a1","蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文"],["daa1","汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑"],["dba1","發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖"],["dca1","碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦"],["dda1","孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥"],["dea1","脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索"],["dfa1","傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署"],["e0a1","胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬"],["e1a1","聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁"],["e2a1","戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧"],["e3a1","嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁"],["e4a1","沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額"],["e5a1","櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬"],["e6a1","旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒"],["e7a1","簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳"],["e8a1","烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療"],["e9a1","窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓"],["eaa1","運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜"],["eba1","濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼"],["eca1","議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄"],["eda1","立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長"],["eea1","障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱"],["efa1","煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖"],["f0a1","靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫"],["f1a1","踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只"],["f2a1","咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯"],["f3a1","鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策"],["f4a1","責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢"],["f5a1","椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃"],["f6a1","贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託"],["f7a1","鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑"],["f8a1","阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃"],["f9a1","品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航"],["faa1","行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型"],["fba1","形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵"],["fca1","禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆"],["fda1","爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰"]]

/***/ },
/* 1803 */
/***/ function(module, exports) {

	module.exports = [["0","\u0000",127],["8ea1","｡",62],["a1a1","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇"],["a2a1","◆□■△▲▽▼※〒→←↑↓〓"],["a2ba","∈∋⊆⊇⊂⊃∪∩"],["a2ca","∧∨￢⇒⇔∀∃"],["a2dc","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["a2f2","Å‰♯♭♪†‡¶"],["a2fe","◯"],["a3b0","０",9],["a3c1","Ａ",25],["a3e1","ａ",25],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a8a1","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["ada1","①",19,"Ⅰ",9],["adc0","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["addf","㍻〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["b0a1","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["b1a1","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応"],["b2a1","押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["b3a1","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱"],["b4a1","粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["b5a1","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京"],["b6a1","供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["b7a1","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲"],["b8a1","検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["b9a1","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込"],["baa1","此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["bba1","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時"],["bca1","次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["bda1","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償"],["bea1","勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["bfa1","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾"],["c0a1","澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["c1a1","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎"],["c2a1","臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["c3a1","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵"],["c4a1","帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["c5a1","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到"],["c6a1","董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["c7a1","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦"],["c8a1","函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["c9a1","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服"],["caa1","福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["cba1","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満"],["cca1","漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["cda1","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃"],["cea1","痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["cfa1","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["d0a1","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["d1a1","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨"],["d2a1","辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["d3a1","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉"],["d4a1","圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["d5a1","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓"],["d6a1","屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["d7a1","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚"],["d8a1","悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["d9a1","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼"],["daa1","據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["dba1","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍"],["dca1","棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["dda1","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾"],["dea1","沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["dfa1","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼"],["e0a1","燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e1a1","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰"],["e2a1","癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e3a1","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐"],["e4a1","筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e5a1","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺"],["e6a1","罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e7a1","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙"],["e8a1","茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e9a1","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙"],["eaa1","蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["eba1","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫"],["eca1","譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["eda1","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸"],["eea1","遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["efa1","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞"],["f0a1","陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["f1a1","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷"],["f2a1","髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["f3a1","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠"],["f4a1","堯槇遙瑤凜熙"],["f9a1","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德"],["faa1","忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["fba1","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚"],["fca1","釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["fcf1","ⅰ",9,"￢￤＇＂"],["8fa2af","˘ˇ¸˙˝¯˛˚～΄΅"],["8fa2c2","¡¦¿"],["8fa2eb","ºª©®™¤№"],["8fa6e1","ΆΈΉΊΪ"],["8fa6e7","Ό"],["8fa6e9","ΎΫ"],["8fa6ec","Ώ"],["8fa6f1","άέήίϊΐόςύϋΰώ"],["8fa7c2","Ђ",10,"ЎЏ"],["8fa7f2","ђ",10,"ўџ"],["8fa9a1","ÆĐ"],["8fa9a4","Ħ"],["8fa9a6","Ĳ"],["8fa9a8","ŁĿ"],["8fa9ab","ŊØŒ"],["8fa9af","ŦÞ"],["8fa9c1","æđðħıĳĸłŀŉŋøœßŧþ"],["8faaa1","ÁÀÄÂĂǍĀĄÅÃĆĈČÇĊĎÉÈËÊĚĖĒĘ"],["8faaba","ĜĞĢĠĤÍÌÏÎǏİĪĮĨĴĶĹĽĻŃŇŅÑÓÒÖÔǑŐŌÕŔŘŖŚŜŠŞŤŢÚÙÜÛŬǓŰŪŲŮŨǗǛǙǕŴÝŸŶŹŽŻ"],["8faba1","áàäâăǎāąåãćĉčçċďéèëêěėēęǵĝğ"],["8fabbd","ġĥíìïîǐ"],["8fabc5","īįĩĵķĺľļńňņñóòöôǒőōõŕřŗśŝšşťţúùüûŭǔűūųůũǘǜǚǖŵýÿŷźžż"],["8fb0a1","丂丄丅丌丒丟丣两丨丫丮丯丰丵乀乁乄乇乑乚乜乣乨乩乴乵乹乿亍亖亗亝亯亹仃仐仚仛仠仡仢仨仯仱仳仵份仾仿伀伂伃伈伋伌伒伕伖众伙伮伱你伳伵伷伹伻伾佀佂佈佉佋佌佒佔佖佘佟佣佪佬佮佱佷佸佹佺佽佾侁侂侄"],["8fb1a1","侅侉侊侌侎侐侒侓侔侗侙侚侞侟侲侷侹侻侼侽侾俀俁俅俆俈俉俋俌俍俏俒俜俠俢俰俲俼俽俿倀倁倄倇倊倌倎倐倓倗倘倛倜倝倞倢倧倮倰倲倳倵偀偁偂偅偆偊偌偎偑偒偓偗偙偟偠偢偣偦偧偪偭偰偱倻傁傃傄傆傊傎傏傐"],["8fb2a1","傒傓傔傖傛傜傞",4,"傪傯傰傹傺傽僀僃僄僇僌僎僐僓僔僘僜僝僟僢僤僦僨僩僯僱僶僺僾儃儆儇儈儋儌儍儎僲儐儗儙儛儜儝儞儣儧儨儬儭儯儱儳儴儵儸儹兂兊兏兓兕兗兘兟兤兦兾冃冄冋冎冘冝冡冣冭冸冺冼冾冿凂"],["8fb3a1","凈减凑凒凓凕凘凞凢凥凮凲凳凴凷刁刂刅划刓刕刖刘刢刨刱刲刵刼剅剉剕剗剘剚剜剟剠剡剦剮剷剸剹劀劂劅劊劌劓劕劖劗劘劚劜劤劥劦劧劯劰劶劷劸劺劻劽勀勄勆勈勌勏勑勔勖勛勜勡勥勨勩勪勬勰勱勴勶勷匀匃匊匋"],["8fb4a1","匌匑匓匘匛匜匞匟匥匧匨匩匫匬匭匰匲匵匼匽匾卂卌卋卙卛卡卣卥卬卭卲卹卾厃厇厈厎厓厔厙厝厡厤厪厫厯厲厴厵厷厸厺厽叀叅叏叒叓叕叚叝叞叠另叧叵吂吓吚吡吧吨吪启吱吴吵呃呄呇呍呏呞呢呤呦呧呩呫呭呮呴呿"],["8fb5a1","咁咃咅咈咉咍咑咕咖咜咟咡咦咧咩咪咭咮咱咷咹咺咻咿哆哊响哎哠哪哬哯哶哼哾哿唀唁唅唈唉唌唍唎唕唪唫唲唵唶唻唼唽啁啇啉啊啍啐啑啘啚啛啞啠啡啤啦啿喁喂喆喈喎喏喑喒喓喔喗喣喤喭喲喿嗁嗃嗆嗉嗋嗌嗎嗑嗒"],["8fb6a1","嗓嗗嗘嗛嗞嗢嗩嗶嗿嘅嘈嘊嘍",5,"嘙嘬嘰嘳嘵嘷嘹嘻嘼嘽嘿噀噁噃噄噆噉噋噍噏噔噞噠噡噢噣噦噩噭噯噱噲噵嚄嚅嚈嚋嚌嚕嚙嚚嚝嚞嚟嚦嚧嚨嚩嚫嚬嚭嚱嚳嚷嚾囅囉囊囋囏囐囌囍囙囜囝囟囡囤",4,"囱囫园"],["8fb7a1","囶囷圁圂圇圊圌圑圕圚圛圝圠圢圣圤圥圩圪圬圮圯圳圴圽圾圿坅坆坌坍坒坢坥坧坨坫坭",4,"坳坴坵坷坹坺坻坼坾垁垃垌垔垗垙垚垜垝垞垟垡垕垧垨垩垬垸垽埇埈埌埏埕埝埞埤埦埧埩埭埰埵埶埸埽埾埿堃堄堈堉埡"],["8fb8a1","堌堍堛堞堟堠堦堧堭堲堹堿塉塌塍塏塐塕塟塡塤塧塨塸塼塿墀墁墇墈墉墊墌墍墏墐墔墖墝墠墡墢墦墩墱墲壄墼壂壈壍壎壐壒壔壖壚壝壡壢壩壳夅夆夋夌夒夓夔虁夝夡夣夤夨夯夰夳夵夶夿奃奆奒奓奙奛奝奞奟奡奣奫奭"],["8fb9a1","奯奲奵奶她奻奼妋妌妎妒妕妗妟妤妧妭妮妯妰妳妷妺妼姁姃姄姈姊姍姒姝姞姟姣姤姧姮姯姱姲姴姷娀娄娌娍娎娒娓娞娣娤娧娨娪娭娰婄婅婇婈婌婐婕婞婣婥婧婭婷婺婻婾媋媐媓媖媙媜媞媟媠媢媧媬媱媲媳媵媸媺媻媿"],["8fbaa1","嫄嫆嫈嫏嫚嫜嫠嫥嫪嫮嫵嫶嫽嬀嬁嬈嬗嬴嬙嬛嬝嬡嬥嬭嬸孁孋孌孒孖孞孨孮孯孼孽孾孿宁宄宆宊宎宐宑宓宔宖宨宩宬宭宯宱宲宷宺宼寀寁寍寏寖",4,"寠寯寱寴寽尌尗尞尟尣尦尩尫尬尮尰尲尵尶屙屚屜屢屣屧屨屩"],["8fbba1","屭屰屴屵屺屻屼屽岇岈岊岏岒岝岟岠岢岣岦岪岲岴岵岺峉峋峒峝峗峮峱峲峴崁崆崍崒崫崣崤崦崧崱崴崹崽崿嵂嵃嵆嵈嵕嵑嵙嵊嵟嵠嵡嵢嵤嵪嵭嵰嵹嵺嵾嵿嶁嶃嶈嶊嶒嶓嶔嶕嶙嶛嶟嶠嶧嶫嶰嶴嶸嶹巃巇巋巐巎巘巙巠巤"],["8fbca1","巩巸巹帀帇帍帒帔帕帘帟帠帮帨帲帵帾幋幐幉幑幖幘幛幜幞幨幪",4,"幰庀庋庎庢庤庥庨庪庬庱庳庽庾庿廆廌廋廎廑廒廔廕廜廞廥廫异弆弇弈弎弙弜弝弡弢弣弤弨弫弬弮弰弴弶弻弽弿彀彄彅彇彍彐彔彘彛彠彣彤彧"],["8fbda1","彯彲彴彵彸彺彽彾徉徍徏徖徜徝徢徧徫徤徬徯徰徱徸忄忇忈忉忋忐",4,"忞忡忢忨忩忪忬忭忮忯忲忳忶忺忼怇怊怍怓怔怗怘怚怟怤怭怳怵恀恇恈恉恌恑恔恖恗恝恡恧恱恾恿悂悆悈悊悎悑悓悕悘悝悞悢悤悥您悰悱悷"],["8fbea1","悻悾惂惄惈惉惊惋惎惏惔惕惙惛惝惞惢惥惲惵惸惼惽愂愇愊愌愐",4,"愖愗愙愜愞愢愪愫愰愱愵愶愷愹慁慅慆慉慞慠慬慲慸慻慼慿憀憁憃憄憋憍憒憓憗憘憜憝憟憠憥憨憪憭憸憹憼懀懁懂懎懏懕懜懝懞懟懡懢懧懩懥"],["8fbfa1","懬懭懯戁戃戄戇戓戕戜戠戢戣戧戩戫戹戽扂扃扄扆扌扐扑扒扔扖扚扜扤扭扯扳扺扽抍抎抏抐抦抨抳抶抷抺抾抿拄拎拕拖拚拪拲拴拼拽挃挄挊挋挍挐挓挖挘挩挪挭挵挶挹挼捁捂捃捄捆捊捋捎捒捓捔捘捛捥捦捬捭捱捴捵"],["8fc0a1","捸捼捽捿掂掄掇掊掐掔掕掙掚掞掤掦掭掮掯掽揁揅揈揎揑揓揔揕揜揠揥揪揬揲揳揵揸揹搉搊搐搒搔搘搞搠搢搤搥搩搪搯搰搵搽搿摋摏摑摒摓摔摚摛摜摝摟摠摡摣摭摳摴摻摽撅撇撏撐撑撘撙撛撝撟撡撣撦撨撬撳撽撾撿"],["8fc1a1","擄擉擊擋擌擎擐擑擕擗擤擥擩擪擭擰擵擷擻擿攁攄攈攉攊攏攓攔攖攙攛攞攟攢攦攩攮攱攺攼攽敃敇敉敐敒敔敟敠敧敫敺敽斁斅斊斒斕斘斝斠斣斦斮斲斳斴斿旂旈旉旎旐旔旖旘旟旰旲旴旵旹旾旿昀昄昈昉昍昑昒昕昖昝"],["8fc2a1","昞昡昢昣昤昦昩昪昫昬昮昰昱昳昹昷晀晅晆晊晌晑晎晗晘晙晛晜晠晡曻晪晫晬晾晳晵晿晷晸晹晻暀晼暋暌暍暐暒暙暚暛暜暟暠暤暭暱暲暵暻暿曀曂曃曈曌曎曏曔曛曟曨曫曬曮曺朅朇朎朓朙朜朠朢朳朾杅杇杈杌杔杕杝"],["8fc3a1","杦杬杮杴杶杻极构枎枏枑枓枖枘枙枛枰枱枲枵枻枼枽柹柀柂柃柅柈柉柒柗柙柜柡柦柰柲柶柷桒栔栙栝栟栨栧栬栭栯栰栱栳栻栿桄桅桊桌桕桗桘桛桫桮",4,"桵桹桺桻桼梂梄梆梈梖梘梚梜梡梣梥梩梪梮梲梻棅棈棌棏"],["8fc4a1","棐棑棓棖棙棜棝棥棨棪棫棬棭棰棱棵棶棻棼棽椆椉椊椐椑椓椖椗椱椳椵椸椻楂楅楉楎楗楛楣楤楥楦楨楩楬楰楱楲楺楻楿榀榍榒榖榘榡榥榦榨榫榭榯榷榸榺榼槅槈槑槖槗槢槥槮槯槱槳槵槾樀樁樃樏樑樕樚樝樠樤樨樰樲"],["8fc5a1","樴樷樻樾樿橅橆橉橊橎橐橑橒橕橖橛橤橧橪橱橳橾檁檃檆檇檉檋檑檛檝檞檟檥檫檯檰檱檴檽檾檿櫆櫉櫈櫌櫐櫔櫕櫖櫜櫝櫤櫧櫬櫰櫱櫲櫼櫽欂欃欆欇欉欏欐欑欗欛欞欤欨欫欬欯欵欶欻欿歆歊歍歒歖歘歝歠歧歫歮歰歵歽"],["8fc6a1","歾殂殅殗殛殟殠殢殣殨殩殬殭殮殰殸殹殽殾毃毄毉毌毖毚毡毣毦毧毮毱毷毹毿氂氄氅氉氍氎氐氒氙氟氦氧氨氬氮氳氵氶氺氻氿汊汋汍汏汒汔汙汛汜汫汭汯汴汶汸汹汻沅沆沇沉沔沕沗沘沜沟沰沲沴泂泆泍泏泐泑泒泔泖"],["8fc7a1","泚泜泠泧泩泫泬泮泲泴洄洇洊洎洏洑洓洚洦洧洨汧洮洯洱洹洼洿浗浞浟浡浥浧浯浰浼涂涇涑涒涔涖涗涘涪涬涴涷涹涽涿淄淈淊淎淏淖淛淝淟淠淢淥淩淯淰淴淶淼渀渄渞渢渧渲渶渹渻渼湄湅湈湉湋湏湑湒湓湔湗湜湝湞"],["8fc8a1","湢湣湨湳湻湽溍溓溙溠溧溭溮溱溳溻溿滀滁滃滇滈滊滍滎滏滫滭滮滹滻滽漄漈漊漌漍漖漘漚漛漦漩漪漯漰漳漶漻漼漭潏潑潒潓潗潙潚潝潞潡潢潨潬潽潾澃澇澈澋澌澍澐澒澓澔澖澚澟澠澥澦澧澨澮澯澰澵澶澼濅濇濈濊"],["8fc9a1","濚濞濨濩濰濵濹濼濽瀀瀅瀆瀇瀍瀗瀠瀣瀯瀴瀷瀹瀼灃灄灈灉灊灋灔灕灝灞灎灤灥灬灮灵灶灾炁炅炆炔",4,"炛炤炫炰炱炴炷烊烑烓烔烕烖烘烜烤烺焃",4,"焋焌焏焞焠焫焭焯焰焱焸煁煅煆煇煊煋煐煒煗煚煜煞煠"],["8fcaa1","煨煹熀熅熇熌熒熚熛熠熢熯熰熲熳熺熿燀燁燄燋燌燓燖燙燚燜燸燾爀爇爈爉爓爗爚爝爟爤爫爯爴爸爹牁牂牃牅牎牏牐牓牕牖牚牜牞牠牣牨牫牮牯牱牷牸牻牼牿犄犉犍犎犓犛犨犭犮犱犴犾狁狇狉狌狕狖狘狟狥狳狴狺狻"],["8fcba1","狾猂猄猅猇猋猍猒猓猘猙猞猢猤猧猨猬猱猲猵猺猻猽獃獍獐獒獖獘獝獞獟獠獦獧獩獫獬獮獯獱獷獹獼玀玁玃玅玆玎玐玓玕玗玘玜玞玟玠玢玥玦玪玫玭玵玷玹玼玽玿珅珆珉珋珌珏珒珓珖珙珝珡珣珦珧珩珴珵珷珹珺珻珽"],["8fcca1","珿琀琁琄琇琊琑琚琛琤琦琨",9,"琹瑀瑃瑄瑆瑇瑋瑍瑑瑒瑗瑝瑢瑦瑧瑨瑫瑭瑮瑱瑲璀璁璅璆璇璉璏璐璑璒璘璙璚璜璟璠璡璣璦璨璩璪璫璮璯璱璲璵璹璻璿瓈瓉瓌瓐瓓瓘瓚瓛瓞瓟瓤瓨瓪瓫瓯瓴瓺瓻瓼瓿甆"],["8fcda1","甒甖甗甠甡甤甧甩甪甯甶甹甽甾甿畀畃畇畈畎畐畒畗畞畟畡畯畱畹",5,"疁疅疐疒疓疕疙疜疢疤疴疺疿痀痁痄痆痌痎痏痗痜痟痠痡痤痧痬痮痯痱痹瘀瘂瘃瘄瘇瘈瘊瘌瘏瘒瘓瘕瘖瘙瘛瘜瘝瘞瘣瘥瘦瘩瘭瘲瘳瘵瘸瘹"],["8fcea1","瘺瘼癊癀癁癃癄癅癉癋癕癙癟癤癥癭癮癯癱癴皁皅皌皍皕皛皜皝皟皠皢",6,"皪皭皽盁盅盉盋盌盎盔盙盠盦盨盬盰盱盶盹盼眀眆眊眎眒眔眕眗眙眚眜眢眨眭眮眯眴眵眶眹眽眾睂睅睆睊睍睎睏睒睖睗睜睞睟睠睢"],["8fcfa1","睤睧睪睬睰睲睳睴睺睽瞀瞄瞌瞍瞔瞕瞖瞚瞟瞢瞧瞪瞮瞯瞱瞵瞾矃矉矑矒矕矙矞矟矠矤矦矪矬矰矱矴矸矻砅砆砉砍砎砑砝砡砢砣砭砮砰砵砷硃硄硇硈硌硎硒硜硞硠硡硣硤硨硪确硺硾碊碏碔碘碡碝碞碟碤碨碬碭碰碱碲碳"],["8fd0a1","碻碽碿磇磈磉磌磎磒磓磕磖磤磛磟磠磡磦磪磲磳礀磶磷磺磻磿礆礌礐礚礜礞礟礠礥礧礩礭礱礴礵礻礽礿祄祅祆祊祋祏祑祔祘祛祜祧祩祫祲祹祻祼祾禋禌禑禓禔禕禖禘禛禜禡禨禩禫禯禱禴禸离秂秄秇秈秊秏秔秖秚秝秞"],["8fd1a1","秠秢秥秪秫秭秱秸秼稂稃稇稉稊稌稑稕稛稞稡稧稫稭稯稰稴稵稸稹稺穄穅穇穈穌穕穖穙穜穝穟穠穥穧穪穭穵穸穾窀窂窅窆窊窋窐窑窔窞窠窣窬窳窵窹窻窼竆竉竌竎竑竛竨竩竫竬竱竴竻竽竾笇笔笟笣笧笩笪笫笭笮笯笰"],["8fd2a1","笱笴笽笿筀筁筇筎筕筠筤筦筩筪筭筯筲筳筷箄箉箎箐箑箖箛箞箠箥箬箯箰箲箵箶箺箻箼箽篂篅篈篊篔篖篗篙篚篛篨篪篲篴篵篸篹篺篼篾簁簂簃簄簆簉簋簌簎簏簙簛簠簥簦簨簬簱簳簴簶簹簺籆籊籕籑籒籓籙",5],["8fd3a1","籡籣籧籩籭籮籰籲籹籼籽粆粇粏粔粞粠粦粰粶粷粺粻粼粿糄糇糈糉糍糏糓糔糕糗糙糚糝糦糩糫糵紃紇紈紉紏紑紒紓紖紝紞紣紦紪紭紱紼紽紾絀絁絇絈絍絑絓絗絙絚絜絝絥絧絪絰絸絺絻絿綁綂綃綅綆綈綋綌綍綑綖綗綝"],["8fd4a1","綞綦綧綪綳綶綷綹緂",4,"緌緍緎緗緙縀緢緥緦緪緫緭緱緵緶緹緺縈縐縑縕縗縜縝縠縧縨縬縭縯縳縶縿繄繅繇繎繐繒繘繟繡繢繥繫繮繯繳繸繾纁纆纇纊纍纑纕纘纚纝纞缼缻缽缾缿罃罄罇罏罒罓罛罜罝罡罣罤罥罦罭"],["8fd5a1","罱罽罾罿羀羋羍羏羐羑羖羗羜羡羢羦羪羭羴羼羿翀翃翈翎翏翛翟翣翥翨翬翮翯翲翺翽翾翿耇耈耊耍耎耏耑耓耔耖耝耞耟耠耤耦耬耮耰耴耵耷耹耺耼耾聀聄聠聤聦聭聱聵肁肈肎肜肞肦肧肫肸肹胈胍胏胒胔胕胗胘胠胭胮"],["8fd6a1","胰胲胳胶胹胺胾脃脋脖脗脘脜脞脠脤脧脬脰脵脺脼腅腇腊腌腒腗腠腡腧腨腩腭腯腷膁膐膄膅膆膋膎膖膘膛膞膢膮膲膴膻臋臃臅臊臎臏臕臗臛臝臞臡臤臫臬臰臱臲臵臶臸臹臽臿舀舃舏舓舔舙舚舝舡舢舨舲舴舺艃艄艅艆"],["8fd7a1","艋艎艏艑艖艜艠艣艧艭艴艻艽艿芀芁芃芄芇芉芊芎芑芔芖芘芚芛芠芡芣芤芧芨芩芪芮芰芲芴芷芺芼芾芿苆苐苕苚苠苢苤苨苪苭苯苶苷苽苾茀茁茇茈茊茋荔茛茝茞茟茡茢茬茭茮茰茳茷茺茼茽荂荃荄荇荍荎荑荕荖荗荰荸"],["8fd8a1","荽荿莀莂莄莆莍莒莔莕莘莙莛莜莝莦莧莩莬莾莿菀菇菉菏菐菑菔菝荓菨菪菶菸菹菼萁萆萊萏萑萕萙莭萯萹葅葇葈葊葍葏葑葒葖葘葙葚葜葠葤葥葧葪葰葳葴葶葸葼葽蒁蒅蒒蒓蒕蒞蒦蒨蒩蒪蒯蒱蒴蒺蒽蒾蓀蓂蓇蓈蓌蓏蓓"],["8fd9a1","蓜蓧蓪蓯蓰蓱蓲蓷蔲蓺蓻蓽蔂蔃蔇蔌蔎蔐蔜蔞蔢蔣蔤蔥蔧蔪蔫蔯蔳蔴蔶蔿蕆蕏",4,"蕖蕙蕜",6,"蕤蕫蕯蕹蕺蕻蕽蕿薁薅薆薉薋薌薏薓薘薝薟薠薢薥薧薴薶薷薸薼薽薾薿藂藇藊藋藎薭藘藚藟藠藦藨藭藳藶藼"],["8fdaa1","藿蘀蘄蘅蘍蘎蘐蘑蘒蘘蘙蘛蘞蘡蘧蘩蘶蘸蘺蘼蘽虀虂虆虒虓虖虗虘虙虝虠",4,"虩虬虯虵虶虷虺蚍蚑蚖蚘蚚蚜蚡蚦蚧蚨蚭蚱蚳蚴蚵蚷蚸蚹蚿蛀蛁蛃蛅蛑蛒蛕蛗蛚蛜蛠蛣蛥蛧蚈蛺蛼蛽蜄蜅蜇蜋蜎蜏蜐蜓蜔蜙蜞蜟蜡蜣"],["8fdba1","蜨蜮蜯蜱蜲蜹蜺蜼蜽蜾蝀蝃蝅蝍蝘蝝蝡蝤蝥蝯蝱蝲蝻螃",6,"螋螌螐螓螕螗螘螙螞螠螣螧螬螭螮螱螵螾螿蟁蟈蟉蟊蟎蟕蟖蟙蟚蟜蟟蟢蟣蟤蟪蟫蟭蟱蟳蟸蟺蟿蠁蠃蠆蠉蠊蠋蠐蠙蠒蠓蠔蠘蠚蠛蠜蠞蠟蠨蠭蠮蠰蠲蠵"],["8fdca1","蠺蠼衁衃衅衈衉衊衋衎衑衕衖衘衚衜衟衠衤衩衱衹衻袀袘袚袛袜袟袠袨袪袺袽袾裀裊",4,"裑裒裓裛裞裧裯裰裱裵裷褁褆褍褎褏褕褖褘褙褚褜褠褦褧褨褰褱褲褵褹褺褾襀襂襅襆襉襏襒襗襚襛襜襡襢襣襫襮襰襳襵襺"],["8fdda1","襻襼襽覉覍覐覔覕覛覜覟覠覥覰覴覵覶覷覼觔",4,"觥觩觫觭觱觳觶觹觽觿訄訅訇訏訑訒訔訕訞訠訢訤訦訫訬訯訵訷訽訾詀詃詅詇詉詍詎詓詖詗詘詜詝詡詥詧詵詶詷詹詺詻詾詿誀誃誆誋誏誐誒誖誗誙誟誧誩誮誯誳"],["8fdea1","誶誷誻誾諃諆諈諉諊諑諓諔諕諗諝諟諬諰諴諵諶諼諿謅謆謋謑謜謞謟謊謭謰謷謼譂",4,"譈譒譓譔譙譍譞譣譭譶譸譹譼譾讁讄讅讋讍讏讔讕讜讞讟谸谹谽谾豅豇豉豋豏豑豓豔豗豘豛豝豙豣豤豦豨豩豭豳豵豶豻豾貆"],["8fdfa1","貇貋貐貒貓貙貛貜貤貹貺賅賆賉賋賏賖賕賙賝賡賨賬賯賰賲賵賷賸賾賿贁贃贉贒贗贛赥赩赬赮赿趂趄趈趍趐趑趕趞趟趠趦趫趬趯趲趵趷趹趻跀跅跆跇跈跊跎跑跔跕跗跙跤跥跧跬跰趼跱跲跴跽踁踄踅踆踋踑踔踖踠踡踢"],["8fe0a1","踣踦踧踱踳踶踷踸踹踽蹀蹁蹋蹍蹎蹏蹔蹛蹜蹝蹞蹡蹢蹩蹬蹭蹯蹰蹱蹹蹺蹻躂躃躉躐躒躕躚躛躝躞躢躧躩躭躮躳躵躺躻軀軁軃軄軇軏軑軔軜軨軮軰軱軷軹軺軭輀輂輇輈輏輐輖輗輘輞輠輡輣輥輧輨輬輭輮輴輵輶輷輺轀轁"],["8fe1a1","轃轇轏轑",4,"轘轝轞轥辝辠辡辤辥辦辵辶辸达迀迁迆迊迋迍运迒迓迕迠迣迤迨迮迱迵迶迻迾适逄逈逌逘逛逨逩逯逪逬逭逳逴逷逿遃遄遌遛遝遢遦遧遬遰遴遹邅邈邋邌邎邐邕邗邘邙邛邠邡邢邥邰邲邳邴邶邽郌邾郃"],["8fe2a1","郄郅郇郈郕郗郘郙郜郝郟郥郒郶郫郯郰郴郾郿鄀鄄鄅鄆鄈鄍鄐鄔鄖鄗鄘鄚鄜鄞鄠鄥鄢鄣鄧鄩鄮鄯鄱鄴鄶鄷鄹鄺鄼鄽酃酇酈酏酓酗酙酚酛酡酤酧酭酴酹酺酻醁醃醅醆醊醎醑醓醔醕醘醞醡醦醨醬醭醮醰醱醲醳醶醻醼醽醿"],["8fe3a1","釂釃釅釓釔釗釙釚釞釤釥釩釪釬",5,"釷釹釻釽鈀鈁鈄鈅鈆鈇鈉鈊鈌鈐鈒鈓鈖鈘鈜鈝鈣鈤鈥鈦鈨鈮鈯鈰鈳鈵鈶鈸鈹鈺鈼鈾鉀鉂鉃鉆鉇鉊鉍鉎鉏鉑鉘鉙鉜鉝鉠鉡鉥鉧鉨鉩鉮鉯鉰鉵",4,"鉻鉼鉽鉿銈銉銊銍銎銒銗"],["8fe4a1","銙銟銠銤銥銧銨銫銯銲銶銸銺銻銼銽銿",4,"鋅鋆鋇鋈鋋鋌鋍鋎鋐鋓鋕鋗鋘鋙鋜鋝鋟鋠鋡鋣鋥鋧鋨鋬鋮鋰鋹鋻鋿錀錂錈錍錑錔錕錜錝錞錟錡錤錥錧錩錪錳錴錶錷鍇鍈鍉鍐鍑鍒鍕鍗鍘鍚鍞鍤鍥鍧鍩鍪鍭鍯鍰鍱鍳鍴鍶"],["8fe5a1","鍺鍽鍿鎀鎁鎂鎈鎊鎋鎍鎏鎒鎕鎘鎛鎞鎡鎣鎤鎦鎨鎫鎴鎵鎶鎺鎩鏁鏄鏅鏆鏇鏉",4,"鏓鏙鏜鏞鏟鏢鏦鏧鏹鏷鏸鏺鏻鏽鐁鐂鐄鐈鐉鐍鐎鐏鐕鐖鐗鐟鐮鐯鐱鐲鐳鐴鐻鐿鐽鑃鑅鑈鑊鑌鑕鑙鑜鑟鑡鑣鑨鑫鑭鑮鑯鑱鑲钄钃镸镹"],["8fe6a1","镾閄閈閌閍閎閝閞閟閡閦閩閫閬閴閶閺閽閿闆闈闉闋闐闑闒闓闙闚闝闞闟闠闤闦阝阞阢阤阥阦阬阱阳阷阸阹阺阼阽陁陒陔陖陗陘陡陮陴陻陼陾陿隁隂隃隄隉隑隖隚隝隟隤隥隦隩隮隯隳隺雊雒嶲雘雚雝雞雟雩雯雱雺霂"],["8fe7a1","霃霅霉霚霛霝霡霢霣霨霱霳靁靃靊靎靏靕靗靘靚靛靣靧靪靮靳靶靷靸靻靽靿鞀鞉鞕鞖鞗鞙鞚鞞鞟鞢鞬鞮鞱鞲鞵鞶鞸鞹鞺鞼鞾鞿韁韄韅韇韉韊韌韍韎韐韑韔韗韘韙韝韞韠韛韡韤韯韱韴韷韸韺頇頊頙頍頎頔頖頜頞頠頣頦"],["8fe8a1","頫頮頯頰頲頳頵頥頾顄顇顊顑顒顓顖顗顙顚顢顣顥顦顪顬颫颭颮颰颴颷颸颺颻颿飂飅飈飌飡飣飥飦飧飪飳飶餂餇餈餑餕餖餗餚餛餜餟餢餦餧餫餱",4,"餹餺餻餼饀饁饆饇饈饍饎饔饘饙饛饜饞饟饠馛馝馟馦馰馱馲馵"],["8fe9a1","馹馺馽馿駃駉駓駔駙駚駜駞駧駪駫駬駰駴駵駹駽駾騂騃騄騋騌騐騑騖騞騠騢騣騤騧騭騮騳騵騶騸驇驁驄驊驋驌驎驑驔驖驝骪骬骮骯骲骴骵骶骹骻骾骿髁髃髆髈髎髐髒髕髖髗髛髜髠髤髥髧髩髬髲髳髵髹髺髽髿",4],["8feaa1","鬄鬅鬈鬉鬋鬌鬍鬎鬐鬒鬖鬙鬛鬜鬠鬦鬫鬭鬳鬴鬵鬷鬹鬺鬽魈魋魌魕魖魗魛魞魡魣魥魦魨魪",4,"魳魵魷魸魹魿鮀鮄鮅鮆鮇鮉鮊鮋鮍鮏鮐鮔鮚鮝鮞鮦鮧鮩鮬鮰鮱鮲鮷鮸鮻鮼鮾鮿鯁鯇鯈鯎鯐鯗鯘鯝鯟鯥鯧鯪鯫鯯鯳鯷鯸"],["8feba1","鯹鯺鯽鯿鰀鰂鰋鰏鰑鰖鰘鰙鰚鰜鰞鰢鰣鰦",4,"鰱鰵鰶鰷鰽鱁鱃鱄鱅鱉鱊鱎鱏鱐鱓鱔鱖鱘鱛鱝鱞鱟鱣鱩鱪鱜鱫鱨鱮鱰鱲鱵鱷鱻鳦鳲鳷鳹鴋鴂鴑鴗鴘鴜鴝鴞鴯鴰鴲鴳鴴鴺鴼鵅鴽鵂鵃鵇鵊鵓鵔鵟鵣鵢鵥鵩鵪鵫鵰鵶鵷鵻"],["8feca1","鵼鵾鶃鶄鶆鶊鶍鶎鶒鶓鶕鶖鶗鶘鶡鶪鶬鶮鶱鶵鶹鶼鶿鷃鷇鷉鷊鷔鷕鷖鷗鷚鷞鷟鷠鷥鷧鷩鷫鷮鷰鷳鷴鷾鸊鸂鸇鸎鸐鸑鸒鸕鸖鸙鸜鸝鹺鹻鹼麀麂麃麄麅麇麎麏麖麘麛麞麤麨麬麮麯麰麳麴麵黆黈黋黕黟黤黧黬黭黮黰黱黲黵"],["8feda1","黸黿鼂鼃鼉鼏鼐鼑鼒鼔鼖鼗鼙鼚鼛鼟鼢鼦鼪鼫鼯鼱鼲鼴鼷鼹鼺鼼鼽鼿齁齃",4,"齓齕齖齗齘齚齝齞齨齩齭",4,"齳齵齺齽龏龐龑龒龔龖龗龞龡龢龣龥"]]

/***/ },
/* 1804 */
/***/ function(module, exports) {

	module.exports = {"uChars":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],"gbChars":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}

/***/ },
/* 1805 */
/***/ function(module, exports) {

	module.exports = [["0","\u0000",128],["a1","｡",62],["8140","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×"],["8180","÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓"],["81b8","∈∋⊆⊇⊂⊃∪∩"],["81c8","∧∨￢⇒⇔∀∃"],["81da","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["81f0","Å‰♯♭♪†‡¶"],["81fc","◯"],["824f","０",9],["8260","Ａ",25],["8281","ａ",25],["829f","ぁ",82],["8340","ァ",62],["8380","ム",22],["839f","Α",16,"Σ",6],["83bf","α",16,"σ",6],["8440","А",5,"ЁЖ",25],["8470","а",5,"ёж",7],["8480","о",17],["849f","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["8740","①",19,"Ⅰ",9],["875f","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["877e","㍻"],["8780","〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["889f","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["8940","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円"],["8980","園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["8a40","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫"],["8a80","橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["8b40","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救"],["8b80","朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["8c40","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨"],["8c80","劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["8d40","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降"],["8d80","項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["8e40","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止"],["8e80","死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["8f40","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳"],["8f80","準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["9040","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨"],["9080","逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["9140","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻"],["9180","操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["9240","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄"],["9280","逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["9340","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬"],["9380","凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["9440","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅"],["9480","楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["9540","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷"],["9580","斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["9640","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆"],["9680","摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["9740","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲"],["9780","沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["9840","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["989f","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["9940","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭"],["9980","凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["9a40","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸"],["9a80","噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["9b40","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀"],["9b80","它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["9c40","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠"],["9c80","怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["9d40","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫"],["9d80","捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["9e40","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎"],["9e80","梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["9f40","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯"],["9f80","麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["e040","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝"],["e080","烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e140","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿"],["e180","痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e240","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰"],["e280","窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e340","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷"],["e380","縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e440","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤"],["e480","艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e540","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬"],["e580","蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["e640","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧"],["e680","諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["e740","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜"],["e780","轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["e840","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙"],["e880","閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["e940","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃"],["e980","騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["ea40","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯"],["ea80","黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙"],["ed40","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏"],["ed80","塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["ee40","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙"],["ee80","蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["eeef","ⅰ",9,"￢￤＇＂"],["f040","",62],["f080","",124],["f140","",62],["f180","",124],["f240","",62],["f280","",124],["f340","",62],["f380","",124],["f440","",62],["f480","",124],["f540","",62],["f580","",124],["f640","",62],["f680","",124],["f740","",62],["f780","",124],["f840","",62],["f880","",124],["f940",""],["fa40","ⅰ",9,"Ⅰ",9,"￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊"],["fa80","兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯"],["fb40","涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神"],["fb80","祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙"],["fc40","髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"]]

/***/ },
/* 1806 */
/***/ function(module, exports) {

	module.exports = {"version":"2025b","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.i -20|01|-2sw2a.i|26e5","Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0|28e5","America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5","America/Bahia_Banderas|LMT MST CST MDT CDT|71 70 60 60 50|01213121313131313131313131313131313142424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5","America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST CDT EDT|5L.4 60 50 50 40|01213132431313131313131313131313131313131312|-1UQG0 2q3C0 2tx0 wgP0 1lb0 14p0 1lb0 14o0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4","America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Coyhaique|LMT SMT -05 -04 -03|4M.g 4G.J 50 40 30|012131323232323232323434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvb.I MJbS.t fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0|","America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mp0 8lz0 SN0 1cL0 pHB0 83r0 AU0 5MN0 1Rz0 38N0 Wn0 1qP0 11z0 1o10 11z0 3NA0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST MDT|7n.Q 70 60 60|01213121313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5","America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST MDT|75.E 70 60 60|01213121313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4","America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q3C0 24n0 wG10 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5","America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT MST CST MDT CDT|6F.g 70 60 60 50|012131242424242424242424242424242424242424242424242424242424242|-1UQG0 dep0 8lz0 16p0 11z0 1dd0 2gmp0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452","America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4","Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25","Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5","Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4","Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le80 1dnX0 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5","Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|LMT LMT PST PDT JST|fU.8 -83.Q -80 -90 -90|012323432323232|-54m83.Q 2d8A3.Q 1urM0 un0 bW10 nb0 7qo0 1MM0 klB0 lz0 TwN0 1bb0 uNB0 rz0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 Dc0 1iMu JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|LMT HMT -02 -01 +00 WET WEST|1G.E 1S.w 20 10 0 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232323434343434343434343434356434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 CT90 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 Ap0 An0 wo0 Eo0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 BJ90 1a00 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4","Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30","Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5","Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2","Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5","Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-10|+10|-a0|0||","Etc/GMT-11|+11|-b0|0||","Etc/GMT-12|+12|-c0|0||","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Etc/GMT-7|+07|-70|0||","Etc/GMT-8|+08|-80|0||","Etc/GMT-9|+09|-90|0||","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+2|-02|20|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5","Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4","Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121212124121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 oiK0 1cM0 1cM0 1fB0 1cM0 1cM0 1cM0 1fA0 1a00 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5","Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6","Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4","Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3","Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4","Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2","Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3","Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56","Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/Reykjavik","Africa/Abidjan|Atlantic/St_Helena","Africa/Abidjan|Iceland","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|CST6CDT","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|MST7MDT","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|America/Yellowknife","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Iqaluit|America/Pangnirtung","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|PST8PDT","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|EST5EDT","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Panama|EST","America/Phoenix|America/Creston","America/Phoenix|MST","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|America/Nipigon","America/Toronto|America/Thunder_Bay","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|America/Rainy_River","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Bangkok|Indian/Christmas","Asia/Brunei|Asia/Kuching","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Dubai|Indian/Mahe","Asia/Dubai|Indian/Reunion","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Rangoon|Indian/Cocos","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Choibalsan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Athens|EET","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Berlin|Arctic/Longyearbyen","Europe/Berlin|Atlantic/Jan_Mayen","Europe/Berlin|Europe/Copenhagen","Europe/Berlin|Europe/Oslo","Europe/Berlin|Europe/Stockholm","Europe/Brussels|CET","Europe/Brussels|Europe/Amsterdam","Europe/Brussels|Europe/Luxembourg","Europe/Brussels|MET","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Kiev|Europe/Kyiv","Europe/Kiev|Europe/Uzhgorod","Europe/Kiev|Europe/Zaporozhye","Europe/Lisbon|Portugal","Europe/Lisbon|WET","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Paris|Europe/Monaco","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Maldives|Indian/Kerguelen","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guadalcanal|Pacific/Pohnpei","Pacific/Guadalcanal|Pacific/Ponape","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|HST","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Majuro","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Puerto_Rico America/Antigua","AI|America/Puerto_Rico America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Asia/Singapore Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla Asia/Tokyo","AW|America/Puerto_Rico America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Puerto_Rico America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Kuching Asia/Brunei","BO|America/La_Paz","BQ|America/Puerto_Rico America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Toronto America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston","CC|Asia/Yangon Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Coyhaique America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Puerto_Rico America/Curacao","CX|Asia/Bangkok Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Berlin Europe/Copenhagen","DM|America/Puerto_Rico America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Puerto_Rico America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Abidjan Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Puerto_Rico America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Africa/Abidjan Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Puerto_Rico America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Puerto_Rico America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Brussels Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Paris Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Puerto_Rico America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Puerto_Rico America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana","MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Brussels Europe/Amsterdam","NO|Europe/Berlin Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Asia/Dubai Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Asia/Dubai Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Berlin Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Berlin Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Puerto_Rico America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Asia/Dubai Indian/Maldives Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Puerto_Rico America/Port_of_Spain","TV|Pacific/Tarawa Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kyiv","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Puerto_Rico America/St_Vincent","VE|America/Caracas","VG|America/Puerto_Rico America/Tortola","VI|America/Puerto_Rico America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Tarawa Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ },
/* 1807 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! lazysizes - v1.4.0 */
	!function(a,b){var c=b(a,a.document);a.lazySizes=c,"object"==typeof module&&module.exports?module.exports=c:"function"=="function"&&__webpack_require__(1952)&&!(__WEBPACK_AMD_DEFINE_FACTORY__ = (c), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}(window,function(a,b){"use strict";if(b.getElementsByClassName){var c,d=b.documentElement,e=a.HTMLPictureElement&&"sizes"in b.createElement("img"),f="addEventListener",g="getAttribute",h=a[f],i=a.setTimeout,j=a.requestAnimationFrame||i,k=/^picture$/i,l=["load","error","lazyincluded","_lazyloaded"],m={},n=Array.prototype.forEach,o=function(a,b){return m[b]||(m[b]=new RegExp("(\\s|^)"+b+"(\\s|$)")),m[b].test(a[g]("class")||"")&&m[b]},p=function(a,b){o(a,b)||a.setAttribute("class",(a[g]("class")||"").trim()+" "+b)},q=function(a,b){var c;(c=o(a,b))&&a.setAttribute("class",(a[g]("class")||"").replace(c," "))},r=function(a,b,c){var d=c?f:"removeEventListener";c&&r(a,b),l.forEach(function(c){a[d](c,b)})},s=function(a,c,d,e,f){var g=b.createEvent("CustomEvent");return g.initCustomEvent(c,!e,!f,d||{}),a.dispatchEvent(g),g},t=function(b,d){var f;!e&&(f=a.picturefill||c.pf)?f({reevaluate:!0,elements:[b]}):d&&d.src&&(b.src=d.src)},u=function(a,b){return(getComputedStyle(a,null)||{})[b]},v=function(a,b,d){for(d=d||a.offsetWidth;d<c.minSize&&b&&!a._lazysizesWidth;)d=b.offsetWidth,b=b.parentNode;return d},w=function(b){var c,d=0,e=a.Date,f=function(){c=!1,d=e.now(),b()},g=function(){i(f)},h=function(){j(g)};return function(){if(!c){var a=125-(e.now()-d);c=!0,6>a&&(a=6),i(h,a)}}},x=function(){var e,l,m,v,x,z,A,B,C,D,E,F,G,H,I,J=/^img$/i,K=/^iframe$/i,L="onscroll"in a&&!/glebot/.test(navigator.userAgent),M=0,N=0,O=0,P=0,Q=function(a){O--,a&&a.target&&r(a.target,Q),(!a||0>O||!a.target)&&(O=0)},R=function(a,c){var e,f=a,g="hidden"==u(b.body,"visibility")||"hidden"!=u(a,"visibility");for(C-=c,F+=c,D-=c,E+=c;g&&(f=f.offsetParent)&&f!=b.body&&f!=d;)g=(u(f,"opacity")||1)>0,g&&"visible"!=u(f,"overflow")&&(e=f.getBoundingClientRect(),g=E>e.left&&D<e.right&&F>e.top-1&&C<e.bottom+1);return g},S=function(){var a,b,f,h,i,j,k,n,o;if((x=c.loadMode)&&8>O&&(a=e.length)){b=0,P++,null==H&&("expand"in c||(c.expand=d.clientHeight>600?d.clientWidth>860?500:410:359),G=c.expand,H=G*c.expFactor),H>N&&1>O&&P>3&&x>2?(N=H,P=0):N=x>1&&P>2&&6>O?G:M;for(;a>b;b++)if(e[b]&&!e[b]._lazyRace)if(L)if((n=e[b][g]("data-expand"))&&(j=1*n)||(j=N),o!==j&&(A=innerWidth+j*I,B=innerHeight+j,k=-1*j,o=j),f=e[b].getBoundingClientRect(),(F=f.bottom)>=k&&(C=f.top)<=B&&(E=f.right)>=k*I&&(D=f.left)<=A&&(F||E||D||C)&&(m&&3>O&&!n&&(3>x||4>P)||R(e[b],j))){if(Y(e[b]),i=!0,O>9)break}else!i&&m&&!h&&4>O&&4>P&&x>2&&(l[0]||c.preloadAfterLoad)&&(l[0]||!n&&(F||E||D||C||"auto"!=e[b][g](c.sizesAttr)))&&(h=l[0]||e[b]);else Y(e[b]);h&&!i&&Y(h)}},T=w(S),U=function(a){p(a.target,c.loadedClass),q(a.target,c.loadingClass),r(a.target,U)},V=function(a,b){try{a.contentWindow.location.replace(b)}catch(c){a.src=b}},W=function(a){var b,d,e=a[g](c.srcsetAttr);(b=c.customMedia[a[g]("data-media")||a[g]("media")])&&a.setAttribute("media",b),e&&a.setAttribute("srcset",e),b&&(d=a.parentNode,d.insertBefore(a.cloneNode(),a),d.removeChild(a))},X=function(){var a,b=[],c=function(){for(;b.length;)b.shift()();a=!1};return function(d){b.push(d),a||(a=!0,j(c))}}(),Y=function(a){var b,d,e,f,h,j,l,u=J.test(a.nodeName),w=u&&(a[g](c.sizesAttr)||a[g]("sizes")),x="auto"==w;(!x&&m||!u||!a.src&&!a.srcset||a.complete||o(a,c.errorClass))&&(x&&(l=a.offsetWidth),a._lazyRace=!0,O++,X(function(){a._lazyRace&&delete a._lazyRace,(h=s(a,"lazybeforeunveil")).defaultPrevented||(w&&(x?(y.updateElem(a,!0,l),p(a,c.autosizesClass)):a.setAttribute("sizes",w)),d=a[g](c.srcsetAttr),b=a[g](c.srcAttr),u&&(e=a.parentNode,f=e&&k.test(e.nodeName||"")),j=h.detail.firesLoad||"src"in a&&(d||b||f),h={target:a},j&&(r(a,Q,!0),clearTimeout(v),v=i(Q,2500),p(a,c.loadingClass),r(a,U,!0)),f&&n.call(e.getElementsByTagName("source"),W),d?a.setAttribute("srcset",d):b&&!f&&(K.test(a.nodeName)?V(a,b):a.src=b),(d||f)&&t(a,{src:b})),q(a,c.lazyClass),(!j||a.complete)&&(j?Q(h):O--,U(h))}))},Z=function(){if(!m){if(Date.now()-z<999)return void i(Z,999);var a,b=function(){c.loadMode=3,T()};m=!0,c.loadMode=3,O||(P?T():i(S)),h("scroll",function(){3==c.loadMode&&(c.loadMode=2),clearTimeout(a),a=i(b,99)},!0)}};return{_:function(){z=Date.now(),e=b.getElementsByClassName(c.lazyClass),l=b.getElementsByClassName(c.lazyClass+" "+c.preloadClass),I=c.hFac,h("scroll",T,!0),h("resize",T,!0),a.MutationObserver?new MutationObserver(T).observe(d,{childList:!0,subtree:!0,attributes:!0}):(d[f]("DOMNodeInserted",T,!0),d[f]("DOMAttrModified",T,!0),setInterval(T,999)),h("hashchange",T,!0),["focus","mouseover","click","load","transitionend","animationend","webkitAnimationEnd"].forEach(function(a){b[f](a,T,!0)}),/d$|^c/.test(b.readyState)?Z():(h("load",Z),b[f]("DOMContentLoaded",T),i(Z,2e4)),T(e.length>0)},checkElems:T,unveil:Y}}(),y=function(){var a,d=function(a,b,c){var d,e,f,g,h=a.parentNode;if(h&&(c=v(a,h,c),g=s(a,"lazybeforesizes",{width:c,dataAttr:!!b}),!g.defaultPrevented&&(c=g.detail.width,c&&c!==a._lazysizesWidth))){if(a._lazysizesWidth=c,c+="px",a.setAttribute("sizes",c),k.test(h.nodeName||""))for(d=h.getElementsByTagName("source"),e=0,f=d.length;f>e;e++)d[e].setAttribute("sizes",c);g.detail.dataAttr||t(a,g.detail)}},e=function(){var b,c=a.length;if(c)for(b=0;c>b;b++)d(a[b])},f=w(e);return{_:function(){a=b.getElementsByClassName(c.autosizesClass),h("resize",f)},checkElems:f,updateElem:d}}(),z=function(){z.i||(z.i=!0,y._(),x._())};return function(){var b,d={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:!0,expFactor:1.7,hFac:.8,loadMode:2};c=a.lazySizesConfig||a.lazysizesConfig||{};for(b in d)b in c||(c[b]=d[b]);a.lazySizesConfig=c,i(function(){c.init&&z()})}(),{cfg:c,autoSizer:y,loader:x,init:z,uP:t,aC:p,rC:q,hC:o,fire:s,gW:v}}});

/***/ },
/* 1809 */
/***/ function(module, exports) {

	(function(){
		'use strict';
		if(!window.addEventListener){return;}
	
		var regWhite = /\s+/g;
		var regSplitSet = /\s*\|\s+|\s+\|\s*/g;
		var regSource = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/;
		var allowedBackgroundSize = {contain: 1, cover: 1};
		var rAF = window.requestAnimationFrame || setTimeout;
	
		var proxyWidth = function(elem){
			var width = lazySizes.gW(elem, elem.parentNode);
			if(!elem._lazysizesWidth || width > elem._lazysizesWidth){
				elem._lazysizesWidth = width;
			}
			return elem._lazysizesWidth;
		};
	
		var createPicture = function(sets, elem, img){
			var picture = document.createElement('picture');
			var sizes = elem.getAttribute(lazySizesConfig.sizesAttr);
			var ratio = elem.getAttribute('data-ratio');
			var optimumx = elem.getAttribute('data-optimumx');
			var bgSize = (getComputedStyle(elem) || {getPropertyValue: function(){}}).getPropertyValue('background-size');
	
			if(!allowedBackgroundSize[bgSize] && allowedBackgroundSize[elem.style.backgroundSize]){
				bgSize = elem.style.backgroundSize;
			}
			if(allowedBackgroundSize[bgSize] && (sizes == 'auto' || !sizes)){
				img.setAttribute('data-parent-fit', bgSize);
				sizes = 'auto';
			}
	
			if(elem._lazybgset && elem._lazybgset.parentNode == elem){
				elem.removeChild(elem._lazybgset);
			}
	
			Object.defineProperty(img, '_lazybgset', {
				value: elem,
				writable: true
			});
			Object.defineProperty(elem, '_lazybgset', {
				value: picture,
				writable: true
			});
	
			sets = sets.replace(regWhite, ' ').split(regSplitSet);
	
			picture.style.display = 'none';
			img.className = lazySizesConfig.lazyClass;
	
			if(sets.length == 1 && !sizes){
				sizes = 'auto';
			}
	
			sets.forEach(function(set){
				var source = document.createElement('source');
	
				if(sizes && sizes != 'auto'){
					source.setAttribute('sizes', sizes);
				}
	
				if(set.match(regSource)){
					source.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1);
					if(RegExp.$2){
						source.setAttribute('media', lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2);
					}
				}
				picture.appendChild(source);
			});
	
			if(sizes){
				img.setAttribute(lazySizesConfig.sizesAttr, sizes);
				elem.removeAttribute(lazySizesConfig.sizesAttr);
				elem.removeAttribute('sizes');
			}
			if(optimumx){
				img.setAttribute('data-optimumx', optimumx);
			}
			if(ratio) {
				img.setAttribute('data-ratio', ratio);
			}
	
			picture.appendChild(img);
	
			elem.appendChild(picture);
		};
	
		var proxyLoad = function(e){
			if(!e.target._lazybgset){return;}
	
			var image = e.target;
			var elem = image._lazybgset;
			var bg = image.currentSrc || image.src;
	
			if(bg){
				elem.style.backgroundImage = 'url('+ bg +')';
			}
	
			if(image._lazybgsetLoading){
				lazySizes.fire(elem, '_lazyloaded', {}, false, true);
				delete image._lazybgsetLoading;
			}
		};
	
		addEventListener('lazybeforeunveil', function(e){
			var set, image, elem;
	
			if(e.defaultPrevented || !(set = e.target.getAttribute('data-bgset'))){return;}
	
			elem = e.target;
			image = document.createElement('img');
	
			image.alt = '';
	
			image._lazybgsetLoading = true;
			e.detail.firesLoad = true;
	
			createPicture(set, elem, image);
	
			setTimeout(function(){
				lazySizes.loader.unveil(image);
	
				rAF(function(){
					lazySizes.fire(image, '_lazyloaded', {}, true, true);
					if(image.complete) {
						proxyLoad({target: image});
					}
				});
			});
	
		});
	
		document.addEventListener('load', proxyLoad, true);
	
		document.documentElement.addEventListener('lazybeforesizes', function(e){
			if(e.defaultPrevented || !e.target._lazybgset){return;}
			e.detail.width = proxyWidth(e.target._lazybgset);
		});
	})();


/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	/*! @name m3u8-parser @version 4.8.0 @license Apache-2.0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _inheritsLoose = __webpack_require__(1277);
	var Stream = __webpack_require__(1531);
	var _extends = __webpack_require__(940);
	var _assertThisInitialized = __webpack_require__(1275);
	var decodeB64ToUint8Array = __webpack_require__(1279);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
	var Stream__default = /*#__PURE__*/_interopDefaultLegacy(Stream);
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
	var decodeB64ToUint8Array__default = /*#__PURE__*/_interopDefaultLegacy(decodeB64ToUint8Array);
	
	/**
	 * A stream that buffers string input and generates a `data` event for each
	 * line.
	 *
	 * @class LineStream
	 * @extends Stream
	 */
	
	var LineStream = /*#__PURE__*/function (_Stream) {
	  _inheritsLoose__default['default'](LineStream, _Stream);
	
	  function LineStream() {
	    var _this;
	
	    _this = _Stream.call(this) || this;
	    _this.buffer = '';
	    return _this;
	  }
	  /**
	   * Add new data to be parsed.
	   *
	   * @param {string} data the text to process
	   */
	
	
	  var _proto = LineStream.prototype;
	
	  _proto.push = function push(data) {
	    var nextNewline;
	    this.buffer += data;
	    nextNewline = this.buffer.indexOf('\n');
	
	    for (; nextNewline > -1; nextNewline = this.buffer.indexOf('\n')) {
	      this.trigger('data', this.buffer.substring(0, nextNewline));
	      this.buffer = this.buffer.substring(nextNewline + 1);
	    }
	  };
	
	  return LineStream;
	}(Stream__default['default']);
	
	var TAB = String.fromCharCode(0x09);
	
	var parseByterange = function parseByterange(byterangeString) {
	  // optionally match and capture 0+ digits before `@`
	  // optionally match and capture 0+ digits after `@`
	  var match = /([0-9.]*)?@?([0-9.]*)?/.exec(byterangeString || '');
	  var result = {};
	
	  if (match[1]) {
	    result.length = parseInt(match[1], 10);
	  }
	
	  if (match[2]) {
	    result.offset = parseInt(match[2], 10);
	  }
	
	  return result;
	};
	/**
	 * "forgiving" attribute list psuedo-grammar:
	 * attributes -> keyvalue (',' keyvalue)*
	 * keyvalue   -> key '=' value
	 * key        -> [^=]*
	 * value      -> '"' [^"]* '"' | [^,]*
	 */
	
	
	var attributeSeparator = function attributeSeparator() {
	  var key = '[^=]*';
	  var value = '"[^"]*"|[^,]*';
	  var keyvalue = '(?:' + key + ')=(?:' + value + ')';
	  return new RegExp('(?:^|,)(' + keyvalue + ')');
	};
	/**
	 * Parse attributes from a line given the separator
	 *
	 * @param {string} attributes the attribute line to parse
	 */
	
	
	var parseAttributes = function parseAttributes(attributes) {
	  // split the string using attributes as the separator
	  var attrs = attributes.split(attributeSeparator());
	  var result = {};
	  var i = attrs.length;
	  var attr;
	
	  while (i--) {
	    // filter out unmatched portions of the string
	    if (attrs[i] === '') {
	      continue;
	    } // split the key and value
	
	
	    attr = /([^=]*)=(.*)/.exec(attrs[i]).slice(1); // trim whitespace and remove optional quotes around the value
	
	    attr[0] = attr[0].replace(/^\s+|\s+$/g, '');
	    attr[1] = attr[1].replace(/^\s+|\s+$/g, '');
	    attr[1] = attr[1].replace(/^['"](.*)['"]$/g, '$1');
	    result[attr[0]] = attr[1];
	  }
	
	  return result;
	};
	/**
	 * A line-level M3U8 parser event stream. It expects to receive input one
	 * line at a time and performs a context-free parse of its contents. A stream
	 * interpretation of a manifest can be useful if the manifest is expected to
	 * be too large to fit comfortably into memory or the entirety of the input
	 * is not immediately available. Otherwise, it's probably much easier to work
	 * with a regular `Parser` object.
	 *
	 * Produces `data` events with an object that captures the parser's
	 * interpretation of the input. That object has a property `tag` that is one
	 * of `uri`, `comment`, or `tag`. URIs only have a single additional
	 * property, `line`, which captures the entirety of the input without
	 * interpretation. Comments similarly have a single additional property
	 * `text` which is the input without the leading `#`.
	 *
	 * Tags always have a property `tagType` which is the lower-cased version of
	 * the M3U8 directive without the `#EXT` or `#EXT-X-` prefix. For instance,
	 * `#EXT-X-MEDIA-SEQUENCE` becomes `media-sequence` when parsed. Unrecognized
	 * tags are given the tag type `unknown` and a single additional property
	 * `data` with the remainder of the input.
	 *
	 * @class ParseStream
	 * @extends Stream
	 */
	
	
	var ParseStream = /*#__PURE__*/function (_Stream) {
	  _inheritsLoose__default['default'](ParseStream, _Stream);
	
	  function ParseStream() {
	    var _this;
	
	    _this = _Stream.call(this) || this;
	    _this.customParsers = [];
	    _this.tagMappers = [];
	    return _this;
	  }
	  /**
	   * Parses an additional line of input.
	   *
	   * @param {string} line a single line of an M3U8 file to parse
	   */
	
	
	  var _proto = ParseStream.prototype;
	
	  _proto.push = function push(line) {
	    var _this2 = this;
	
	    var match;
	    var event; // strip whitespace
	
	    line = line.trim();
	
	    if (line.length === 0) {
	      // ignore empty lines
	      return;
	    } // URIs
	
	
	    if (line[0] !== '#') {
	      this.trigger('data', {
	        type: 'uri',
	        uri: line
	      });
	      return;
	    } // map tags
	
	
	    var newLines = this.tagMappers.reduce(function (acc, mapper) {
	      var mappedLine = mapper(line); // skip if unchanged
	
	      if (mappedLine === line) {
	        return acc;
	      }
	
	      return acc.concat([mappedLine]);
	    }, [line]);
	    newLines.forEach(function (newLine) {
	      for (var i = 0; i < _this2.customParsers.length; i++) {
	        if (_this2.customParsers[i].call(_this2, newLine)) {
	          return;
	        }
	      } // Comments
	
	
	      if (newLine.indexOf('#EXT') !== 0) {
	        _this2.trigger('data', {
	          type: 'comment',
	          text: newLine.slice(1)
	        });
	
	        return;
	      } // strip off any carriage returns here so the regex matching
	      // doesn't have to account for them.
	
	
	      newLine = newLine.replace('\r', ''); // Tags
	
	      match = /^#EXTM3U/.exec(newLine);
	
	      if (match) {
	        _this2.trigger('data', {
	          type: 'tag',
	          tagType: 'm3u'
	        });
	
	        return;
	      }
	
	      match = /^#EXTINF:?([0-9\.]*)?,?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'inf'
	        };
	
	        if (match[1]) {
	          event.duration = parseFloat(match[1]);
	        }
	
	        if (match[2]) {
	          event.title = match[2];
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-TARGETDURATION:?([0-9.]*)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'targetduration'
	        };
	
	        if (match[1]) {
	          event.duration = parseInt(match[1], 10);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-VERSION:?([0-9.]*)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'version'
	        };
	
	        if (match[1]) {
	          event.version = parseInt(match[1], 10);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-MEDIA-SEQUENCE:?(\-?[0-9.]*)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'media-sequence'
	        };
	
	        if (match[1]) {
	          event.number = parseInt(match[1], 10);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-DISCONTINUITY-SEQUENCE:?(\-?[0-9.]*)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'discontinuity-sequence'
	        };
	
	        if (match[1]) {
	          event.number = parseInt(match[1], 10);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-PLAYLIST-TYPE:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'playlist-type'
	        };
	
	        if (match[1]) {
	          event.playlistType = match[1];
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-BYTERANGE:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = _extends__default['default'](parseByterange(match[1]), {
	          type: 'tag',
	          tagType: 'byterange'
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-ALLOW-CACHE:?(YES|NO)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'allow-cache'
	        };
	
	        if (match[1]) {
	          event.allowed = !/NO/.test(match[1]);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-MAP:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'map'
	        };
	
	        if (match[1]) {
	          var attributes = parseAttributes(match[1]);
	
	          if (attributes.URI) {
	            event.uri = attributes.URI;
	          }
	
	          if (attributes.BYTERANGE) {
	            event.byterange = parseByterange(attributes.BYTERANGE);
	          }
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-STREAM-INF:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'stream-inf'
	        };
	
	        if (match[1]) {
	          event.attributes = parseAttributes(match[1]);
	
	          if (event.attributes.RESOLUTION) {
	            var split = event.attributes.RESOLUTION.split('x');
	            var resolution = {};
	
	            if (split[0]) {
	              resolution.width = parseInt(split[0], 10);
	            }
	
	            if (split[1]) {
	              resolution.height = parseInt(split[1], 10);
	            }
	
	            event.attributes.RESOLUTION = resolution;
	          }
	
	          if (event.attributes.BANDWIDTH) {
	            event.attributes.BANDWIDTH = parseInt(event.attributes.BANDWIDTH, 10);
	          }
	
	          if (event.attributes['FRAME-RATE']) {
	            event.attributes['FRAME-RATE'] = parseFloat(event.attributes['FRAME-RATE']);
	          }
	
	          if (event.attributes['PROGRAM-ID']) {
	            event.attributes['PROGRAM-ID'] = parseInt(event.attributes['PROGRAM-ID'], 10);
	          }
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-MEDIA:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'media'
	        };
	
	        if (match[1]) {
	          event.attributes = parseAttributes(match[1]);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-ENDLIST/.exec(newLine);
	
	      if (match) {
	        _this2.trigger('data', {
	          type: 'tag',
	          tagType: 'endlist'
	        });
	
	        return;
	      }
	
	      match = /^#EXT-X-DISCONTINUITY/.exec(newLine);
	
	      if (match) {
	        _this2.trigger('data', {
	          type: 'tag',
	          tagType: 'discontinuity'
	        });
	
	        return;
	      }
	
	      match = /^#EXT-X-PROGRAM-DATE-TIME:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'program-date-time'
	        };
	
	        if (match[1]) {
	          event.dateTimeString = match[1];
	          event.dateTimeObject = new Date(match[1]);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-KEY:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'key'
	        };
	
	        if (match[1]) {
	          event.attributes = parseAttributes(match[1]); // parse the IV string into a Uint32Array
	
	          if (event.attributes.IV) {
	            if (event.attributes.IV.substring(0, 2).toLowerCase() === '0x') {
	              event.attributes.IV = event.attributes.IV.substring(2);
	            }
	
	            event.attributes.IV = event.attributes.IV.match(/.{8}/g);
	            event.attributes.IV[0] = parseInt(event.attributes.IV[0], 16);
	            event.attributes.IV[1] = parseInt(event.attributes.IV[1], 16);
	            event.attributes.IV[2] = parseInt(event.attributes.IV[2], 16);
	            event.attributes.IV[3] = parseInt(event.attributes.IV[3], 16);
	            event.attributes.IV = new Uint32Array(event.attributes.IV);
	          }
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-START:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'start'
	        };
	
	        if (match[1]) {
	          event.attributes = parseAttributes(match[1]);
	          event.attributes['TIME-OFFSET'] = parseFloat(event.attributes['TIME-OFFSET']);
	          event.attributes.PRECISE = /YES/.test(event.attributes.PRECISE);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-CUE-OUT-CONT:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'cue-out-cont'
	        };
	
	        if (match[1]) {
	          event.data = match[1];
	        } else {
	          event.data = '';
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-CUE-OUT:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'cue-out'
	        };
	
	        if (match[1]) {
	          event.data = match[1];
	        } else {
	          event.data = '';
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-CUE-IN:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'cue-in'
	        };
	
	        if (match[1]) {
	          event.data = match[1];
	        } else {
	          event.data = '';
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-SKIP:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'skip'
	        };
	        event.attributes = parseAttributes(match[1]);
	
	        if (event.attributes.hasOwnProperty('SKIPPED-SEGMENTS')) {
	          event.attributes['SKIPPED-SEGMENTS'] = parseInt(event.attributes['SKIPPED-SEGMENTS'], 10);
	        }
	
	        if (event.attributes.hasOwnProperty('RECENTLY-REMOVED-DATERANGES')) {
	          event.attributes['RECENTLY-REMOVED-DATERANGES'] = event.attributes['RECENTLY-REMOVED-DATERANGES'].split(TAB);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-PART:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'part'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['DURATION'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseFloat(event.attributes[key]);
	          }
	        });
	        ['INDEPENDENT', 'GAP'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = /YES/.test(event.attributes[key]);
	          }
	        });
	
	        if (event.attributes.hasOwnProperty('BYTERANGE')) {
	          event.attributes.byterange = parseByterange(event.attributes.BYTERANGE);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'server-control'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['CAN-SKIP-UNTIL', 'PART-HOLD-BACK', 'HOLD-BACK'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseFloat(event.attributes[key]);
	          }
	        });
	        ['CAN-SKIP-DATERANGES', 'CAN-BLOCK-RELOAD'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = /YES/.test(event.attributes[key]);
	          }
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-PART-INF:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'part-inf'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['PART-TARGET'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseFloat(event.attributes[key]);
	          }
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'preload-hint'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['BYTERANGE-START', 'BYTERANGE-LENGTH'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseInt(event.attributes[key], 10);
	            var subkey = key === 'BYTERANGE-LENGTH' ? 'length' : 'offset';
	            event.attributes.byterange = event.attributes.byterange || {};
	            event.attributes.byterange[subkey] = event.attributes[key]; // only keep the parsed byterange object.
	
	            delete event.attributes[key];
	          }
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'rendition-report'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['LAST-MSN', 'LAST-PART'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseInt(event.attributes[key], 10);
	          }
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      } // unknown tag type
	
	
	      _this2.trigger('data', {
	        type: 'tag',
	        data: newLine.slice(4)
	      });
	    });
	  }
	  /**
	   * Add a parser for custom headers
	   *
	   * @param {Object}   options              a map of options for the added parser
	   * @param {RegExp}   options.expression   a regular expression to match the custom header
	   * @param {string}   options.customType   the custom type to register to the output
	   * @param {Function} [options.dataParser] function to parse the line into an object
	   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
	   */
	  ;
	
	  _proto.addParser = function addParser(_ref) {
	    var _this3 = this;
	
	    var expression = _ref.expression,
	        customType = _ref.customType,
	        dataParser = _ref.dataParser,
	        segment = _ref.segment;
	
	    if (typeof dataParser !== 'function') {
	      dataParser = function dataParser(line) {
	        return line;
	      };
	    }
	
	    this.customParsers.push(function (line) {
	      var match = expression.exec(line);
	
	      if (match) {
	        _this3.trigger('data', {
	          type: 'custom',
	          data: dataParser(line),
	          customType: customType,
	          segment: segment
	        });
	
	        return true;
	      }
	    });
	  }
	  /**
	   * Add a custom header mapper
	   *
	   * @param {Object}   options
	   * @param {RegExp}   options.expression   a regular expression to match the custom header
	   * @param {Function} options.map          function to translate tag into a different tag
	   */
	  ;
	
	  _proto.addTagMapper = function addTagMapper(_ref2) {
	    var expression = _ref2.expression,
	        map = _ref2.map;
	
	    var mapFn = function mapFn(line) {
	      if (expression.test(line)) {
	        return map(line);
	      }
	
	      return line;
	    };
	
	    this.tagMappers.push(mapFn);
	  };
	
	  return ParseStream;
	}(Stream__default['default']);
	
	var camelCase = function camelCase(str) {
	  return str.toLowerCase().replace(/-(\w)/g, function (a) {
	    return a[1].toUpperCase();
	  });
	};
	
	var camelCaseKeys = function camelCaseKeys(attributes) {
	  var result = {};
	  Object.keys(attributes).forEach(function (key) {
	    result[camelCase(key)] = attributes[key];
	  });
	  return result;
	}; // set SERVER-CONTROL hold back based upon targetDuration and partTargetDuration
	// we need this helper because defaults are based upon targetDuration and
	// partTargetDuration being set, but they may not be if SERVER-CONTROL appears before
	// target durations are set.
	
	
	var setHoldBack = function setHoldBack(manifest) {
	  var serverControl = manifest.serverControl,
	      targetDuration = manifest.targetDuration,
	      partTargetDuration = manifest.partTargetDuration;
	
	  if (!serverControl) {
	    return;
	  }
	
	  var tag = '#EXT-X-SERVER-CONTROL';
	  var hb = 'holdBack';
	  var phb = 'partHoldBack';
	  var minTargetDuration = targetDuration && targetDuration * 3;
	  var minPartDuration = partTargetDuration && partTargetDuration * 2;
	
	  if (targetDuration && !serverControl.hasOwnProperty(hb)) {
	    serverControl[hb] = minTargetDuration;
	    this.trigger('info', {
	      message: tag + " defaulting HOLD-BACK to targetDuration * 3 (" + minTargetDuration + ")."
	    });
	  }
	
	  if (minTargetDuration && serverControl[hb] < minTargetDuration) {
	    this.trigger('warn', {
	      message: tag + " clamping HOLD-BACK (" + serverControl[hb] + ") to targetDuration * 3 (" + minTargetDuration + ")"
	    });
	    serverControl[hb] = minTargetDuration;
	  } // default no part hold back to part target duration * 3
	
	
	  if (partTargetDuration && !serverControl.hasOwnProperty(phb)) {
	    serverControl[phb] = partTargetDuration * 3;
	    this.trigger('info', {
	      message: tag + " defaulting PART-HOLD-BACK to partTargetDuration * 3 (" + serverControl[phb] + ")."
	    });
	  } // if part hold back is too small default it to part target duration * 2
	
	
	  if (partTargetDuration && serverControl[phb] < minPartDuration) {
	    this.trigger('warn', {
	      message: tag + " clamping PART-HOLD-BACK (" + serverControl[phb] + ") to partTargetDuration * 2 (" + minPartDuration + ")."
	    });
	    serverControl[phb] = minPartDuration;
	  }
	};
	/**
	 * A parser for M3U8 files. The current interpretation of the input is
	 * exposed as a property `manifest` on parser objects. It's just two lines to
	 * create and parse a manifest once you have the contents available as a string:
	 *
	 * ```js
	 * var parser = new m3u8.Parser();
	 * parser.push(xhr.responseText);
	 * ```
	 *
	 * New input can later be applied to update the manifest object by calling
	 * `push` again.
	 *
	 * The parser attempts to create a usable manifest object even if the
	 * underlying input is somewhat nonsensical. It emits `info` and `warning`
	 * events during the parse if it encounters input that seems invalid or
	 * requires some property of the manifest object to be defaulted.
	 *
	 * @class Parser
	 * @extends Stream
	 */
	
	
	var Parser = /*#__PURE__*/function (_Stream) {
	  _inheritsLoose__default['default'](Parser, _Stream);
	
	  function Parser() {
	    var _this;
	
	    _this = _Stream.call(this) || this;
	    _this.lineStream = new LineStream();
	    _this.parseStream = new ParseStream();
	
	    _this.lineStream.pipe(_this.parseStream);
	    /* eslint-disable consistent-this */
	
	
	    var self = _assertThisInitialized__default['default'](_this);
	    /* eslint-enable consistent-this */
	
	
	    var uris = [];
	    var currentUri = {}; // if specified, the active EXT-X-MAP definition
	
	    var currentMap; // if specified, the active decryption key
	
	    var _key;
	
	    var hasParts = false;
	
	    var noop = function noop() {};
	
	    var defaultMediaGroups = {
	      'AUDIO': {},
	      'VIDEO': {},
	      'CLOSED-CAPTIONS': {},
	      'SUBTITLES': {}
	    }; // This is the Widevine UUID from DASH IF IOP. The same exact string is
	    // used in MPDs with Widevine encrypted streams.
	
	    var widevineUuid = 'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed'; // group segments into numbered timelines delineated by discontinuities
	
	    var currentTimeline = 0; // the manifest is empty until the parse stream begins delivering data
	
	    _this.manifest = {
	      allowCache: true,
	      discontinuityStarts: [],
	      segments: []
	    }; // keep track of the last seen segment's byte range end, as segments are not required
	    // to provide the offset, in which case it defaults to the next byte after the
	    // previous segment
	
	    var lastByterangeEnd = 0; // keep track of the last seen part's byte range end.
	
	    var lastPartByterangeEnd = 0;
	
	    _this.on('end', function () {
	      // only add preloadSegment if we don't yet have a uri for it.
	      // and we actually have parts/preloadHints
	      if (currentUri.uri || !currentUri.parts && !currentUri.preloadHints) {
	        return;
	      }
	
	      if (!currentUri.map && currentMap) {
	        currentUri.map = currentMap;
	      }
	
	      if (!currentUri.key && _key) {
	        currentUri.key = _key;
	      }
	
	      if (!currentUri.timeline && typeof currentTimeline === 'number') {
	        currentUri.timeline = currentTimeline;
	      }
	
	      _this.manifest.preloadSegment = currentUri;
	    }); // update the manifest with the m3u8 entry from the parse stream
	
	
	    _this.parseStream.on('data', function (entry) {
	      var mediaGroup;
	      var rendition;
	      ({
	        tag: function tag() {
	          // switch based on the tag type
	          (({
	            version: function version() {
	              if (entry.version) {
	                this.manifest.version = entry.version;
	              }
	            },
	            'allow-cache': function allowCache() {
	              this.manifest.allowCache = entry.allowed;
	
	              if (!('allowed' in entry)) {
	                this.trigger('info', {
	                  message: 'defaulting allowCache to YES'
	                });
	                this.manifest.allowCache = true;
	              }
	            },
	            byterange: function byterange() {
	              var byterange = {};
	
	              if ('length' in entry) {
	                currentUri.byterange = byterange;
	                byterange.length = entry.length;
	
	                if (!('offset' in entry)) {
	                  /*
	                   * From the latest spec (as of this writing):
	                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.2
	                   *
	                   * Same text since EXT-X-BYTERANGE's introduction in draft 7:
	                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-07#section-3.3.1)
	                   *
	                   * "If o [offset] is not present, the sub-range begins at the next byte
	                   * following the sub-range of the previous media segment."
	                   */
	                  entry.offset = lastByterangeEnd;
	                }
	              }
	
	              if ('offset' in entry) {
	                currentUri.byterange = byterange;
	                byterange.offset = entry.offset;
	              }
	
	              lastByterangeEnd = byterange.offset + byterange.length;
	            },
	            endlist: function endlist() {
	              this.manifest.endList = true;
	            },
	            inf: function inf() {
	              if (!('mediaSequence' in this.manifest)) {
	                this.manifest.mediaSequence = 0;
	                this.trigger('info', {
	                  message: 'defaulting media sequence to zero'
	                });
	              }
	
	              if (!('discontinuitySequence' in this.manifest)) {
	                this.manifest.discontinuitySequence = 0;
	                this.trigger('info', {
	                  message: 'defaulting discontinuity sequence to zero'
	                });
	              }
	
	              if (entry.duration > 0) {
	                currentUri.duration = entry.duration;
	              }
	
	              if (entry.duration === 0) {
	                currentUri.duration = 0.01;
	                this.trigger('info', {
	                  message: 'updating zero segment duration to a small value'
	                });
	              }
	
	              this.manifest.segments = uris;
	            },
	            key: function key() {
	              if (!entry.attributes) {
	                this.trigger('warn', {
	                  message: 'ignoring key declaration without attribute list'
	                });
	                return;
	              } // clear the active encryption key
	
	
	              if (entry.attributes.METHOD === 'NONE') {
	                _key = null;
	                return;
	              }
	
	              if (!entry.attributes.URI) {
	                this.trigger('warn', {
	                  message: 'ignoring key declaration without URI'
	                });
	                return;
	              }
	
	              if (entry.attributes.KEYFORMAT === 'com.apple.streamingkeydelivery') {
	                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.
	
	                this.manifest.contentProtection['com.apple.fps.1_0'] = {
	                  attributes: entry.attributes
	                };
	                return;
	              }
	
	              if (entry.attributes.KEYFORMAT === 'com.microsoft.playready') {
	                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.
	
	                this.manifest.contentProtection['com.microsoft.playready'] = {
	                  uri: entry.attributes.URI
	                };
	                return;
	              } // check if the content is encrypted for Widevine
	              // Widevine/HLS spec: https://storage.googleapis.com/wvdocs/Widevine_DRM_HLS.pdf
	
	
	              if (entry.attributes.KEYFORMAT === widevineUuid) {
	                var VALID_METHODS = ['SAMPLE-AES', 'SAMPLE-AES-CTR', 'SAMPLE-AES-CENC'];
	
	                if (VALID_METHODS.indexOf(entry.attributes.METHOD) === -1) {
	                  this.trigger('warn', {
	                    message: 'invalid key method provided for Widevine'
	                  });
	                  return;
	                }
	
	                if (entry.attributes.METHOD === 'SAMPLE-AES-CENC') {
	                  this.trigger('warn', {
	                    message: 'SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead'
	                  });
	                }
	
	                if (entry.attributes.URI.substring(0, 23) !== 'data:text/plain;base64,') {
	                  this.trigger('warn', {
	                    message: 'invalid key URI provided for Widevine'
	                  });
	                  return;
	                }
	
	                if (!(entry.attributes.KEYID && entry.attributes.KEYID.substring(0, 2) === '0x')) {
	                  this.trigger('warn', {
	                    message: 'invalid key ID provided for Widevine'
	                  });
	                  return;
	                } // if Widevine key attributes are valid, store them as `contentProtection`
	                // on the manifest to emulate Widevine tag structure in a DASH mpd
	
	
	                this.manifest.contentProtection = this.manifest.contentProtection || {};
	                this.manifest.contentProtection['com.widevine.alpha'] = {
	                  attributes: {
	                    schemeIdUri: entry.attributes.KEYFORMAT,
	                    // remove '0x' from the key id string
	                    keyId: entry.attributes.KEYID.substring(2)
	                  },
	                  // decode the base64-encoded PSSH box
	                  pssh: decodeB64ToUint8Array__default['default'](entry.attributes.URI.split(',')[1])
	                };
	                return;
	              }
	
	              if (!entry.attributes.METHOD) {
	                this.trigger('warn', {
	                  message: 'defaulting key method to AES-128'
	                });
	              } // setup an encryption key for upcoming segments
	
	
	              _key = {
	                method: entry.attributes.METHOD || 'AES-128',
	                uri: entry.attributes.URI
	              };
	
	              if (typeof entry.attributes.IV !== 'undefined') {
	                _key.iv = entry.attributes.IV;
	              }
	            },
	            'media-sequence': function mediaSequence() {
	              if (!isFinite(entry.number)) {
	                this.trigger('warn', {
	                  message: 'ignoring invalid media sequence: ' + entry.number
	                });
	                return;
	              }
	
	              this.manifest.mediaSequence = entry.number;
	            },
	            'discontinuity-sequence': function discontinuitySequence() {
	              if (!isFinite(entry.number)) {
	                this.trigger('warn', {
	                  message: 'ignoring invalid discontinuity sequence: ' + entry.number
	                });
	                return;
	              }
	
	              this.manifest.discontinuitySequence = entry.number;
	              currentTimeline = entry.number;
	            },
	            'playlist-type': function playlistType() {
	              if (!/VOD|EVENT/.test(entry.playlistType)) {
	                this.trigger('warn', {
	                  message: 'ignoring unknown playlist type: ' + entry.playlist
	                });
	                return;
	              }
	
	              this.manifest.playlistType = entry.playlistType;
	            },
	            map: function map() {
	              currentMap = {};
	
	              if (entry.uri) {
	                currentMap.uri = entry.uri;
	              }
	
	              if (entry.byterange) {
	                currentMap.byterange = entry.byterange;
	              }
	
	              if (_key) {
	                currentMap.key = _key;
	              }
	            },
	            'stream-inf': function streamInf() {
	              this.manifest.playlists = uris;
	              this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
	
	              if (!entry.attributes) {
	                this.trigger('warn', {
	                  message: 'ignoring empty stream-inf attributes'
	                });
	                return;
	              }
	
	              if (!currentUri.attributes) {
	                currentUri.attributes = {};
	              }
	
	              _extends__default['default'](currentUri.attributes, entry.attributes);
	            },
	            media: function media() {
	              this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
	
	              if (!(entry.attributes && entry.attributes.TYPE && entry.attributes['GROUP-ID'] && entry.attributes.NAME)) {
	                this.trigger('warn', {
	                  message: 'ignoring incomplete or missing media group'
	                });
	                return;
	              } // find the media group, creating defaults as necessary
	
	
	              var mediaGroupType = this.manifest.mediaGroups[entry.attributes.TYPE];
	              mediaGroupType[entry.attributes['GROUP-ID']] = mediaGroupType[entry.attributes['GROUP-ID']] || {};
	              mediaGroup = mediaGroupType[entry.attributes['GROUP-ID']]; // collect the rendition metadata
	
	              rendition = {
	                default: /yes/i.test(entry.attributes.DEFAULT)
	              };
	
	              if (rendition.default) {
	                rendition.autoselect = true;
	              } else {
	                rendition.autoselect = /yes/i.test(entry.attributes.AUTOSELECT);
	              }
	
	              if (entry.attributes.LANGUAGE) {
	                rendition.language = entry.attributes.LANGUAGE;
	              }
	
	              if (entry.attributes.URI) {
	                rendition.uri = entry.attributes.URI;
	              }
	
	              if (entry.attributes['INSTREAM-ID']) {
	                rendition.instreamId = entry.attributes['INSTREAM-ID'];
	              }
	
	              if (entry.attributes.CHARACTERISTICS) {
	                rendition.characteristics = entry.attributes.CHARACTERISTICS;
	              }
	
	              if (entry.attributes.FORCED) {
	                rendition.forced = /yes/i.test(entry.attributes.FORCED);
	              } // insert the new rendition
	
	
	              mediaGroup[entry.attributes.NAME] = rendition;
	            },
	            discontinuity: function discontinuity() {
	              currentTimeline += 1;
	              currentUri.discontinuity = true;
	              this.manifest.discontinuityStarts.push(uris.length);
	            },
	            'program-date-time': function programDateTime() {
	              if (typeof this.manifest.dateTimeString === 'undefined') {
	                // PROGRAM-DATE-TIME is a media-segment tag, but for backwards
	                // compatibility, we add the first occurence of the PROGRAM-DATE-TIME tag
	                // to the manifest object
	                // TODO: Consider removing this in future major version
	                this.manifest.dateTimeString = entry.dateTimeString;
	                this.manifest.dateTimeObject = entry.dateTimeObject;
	              }
	
	              currentUri.dateTimeString = entry.dateTimeString;
	              currentUri.dateTimeObject = entry.dateTimeObject;
	            },
	            targetduration: function targetduration() {
	              if (!isFinite(entry.duration) || entry.duration < 0) {
	                this.trigger('warn', {
	                  message: 'ignoring invalid target duration: ' + entry.duration
	                });
	                return;
	              }
	
	              this.manifest.targetDuration = entry.duration;
	              setHoldBack.call(this, this.manifest);
	            },
	            start: function start() {
	              if (!entry.attributes || isNaN(entry.attributes['TIME-OFFSET'])) {
	                this.trigger('warn', {
	                  message: 'ignoring start declaration without appropriate attribute list'
	                });
	                return;
	              }
	
	              this.manifest.start = {
	                timeOffset: entry.attributes['TIME-OFFSET'],
	                precise: entry.attributes.PRECISE
	              };
	            },
	            'cue-out': function cueOut() {
	              currentUri.cueOut = entry.data;
	            },
	            'cue-out-cont': function cueOutCont() {
	              currentUri.cueOutCont = entry.data;
	            },
	            'cue-in': function cueIn() {
	              currentUri.cueIn = entry.data;
	            },
	            'skip': function skip() {
	              this.manifest.skip = camelCaseKeys(entry.attributes);
	              this.warnOnMissingAttributes_('#EXT-X-SKIP', entry.attributes, ['SKIPPED-SEGMENTS']);
	            },
	            'part': function part() {
	              var _this2 = this;
	
	              hasParts = true; // parts are always specifed before a segment
	
	              var segmentIndex = this.manifest.segments.length;
	              var part = camelCaseKeys(entry.attributes);
	              currentUri.parts = currentUri.parts || [];
	              currentUri.parts.push(part);
	
	              if (part.byterange) {
	                if (!part.byterange.hasOwnProperty('offset')) {
	                  part.byterange.offset = lastPartByterangeEnd;
	                }
	
	                lastPartByterangeEnd = part.byterange.offset + part.byterange.length;
	              }
	
	              var partIndex = currentUri.parts.length - 1;
	              this.warnOnMissingAttributes_("#EXT-X-PART #" + partIndex + " for segment #" + segmentIndex, entry.attributes, ['URI', 'DURATION']);
	
	              if (this.manifest.renditionReports) {
	                this.manifest.renditionReports.forEach(function (r, i) {
	                  if (!r.hasOwnProperty('lastPart')) {
	                    _this2.trigger('warn', {
	                      message: "#EXT-X-RENDITION-REPORT #" + i + " lacks required attribute(s): LAST-PART"
	                    });
	                  }
	                });
	              }
	            },
	            'server-control': function serverControl() {
	              var attrs = this.manifest.serverControl = camelCaseKeys(entry.attributes);
	
	              if (!attrs.hasOwnProperty('canBlockReload')) {
	                attrs.canBlockReload = false;
	                this.trigger('info', {
	                  message: '#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false'
	                });
	              }
	
	              setHoldBack.call(this, this.manifest);
	
	              if (attrs.canSkipDateranges && !attrs.hasOwnProperty('canSkipUntil')) {
	                this.trigger('warn', {
	                  message: '#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set'
	                });
	              }
	            },
	            'preload-hint': function preloadHint() {
	              // parts are always specifed before a segment
	              var segmentIndex = this.manifest.segments.length;
	              var hint = camelCaseKeys(entry.attributes);
	              var isPart = hint.type && hint.type === 'PART';
	              currentUri.preloadHints = currentUri.preloadHints || [];
	              currentUri.preloadHints.push(hint);
	
	              if (hint.byterange) {
	                if (!hint.byterange.hasOwnProperty('offset')) {
	                  // use last part byterange end or zero if not a part.
	                  hint.byterange.offset = isPart ? lastPartByterangeEnd : 0;
	
	                  if (isPart) {
	                    lastPartByterangeEnd = hint.byterange.offset + hint.byterange.length;
	                  }
	                }
	              }
	
	              var index = currentUri.preloadHints.length - 1;
	              this.warnOnMissingAttributes_("#EXT-X-PRELOAD-HINT #" + index + " for segment #" + segmentIndex, entry.attributes, ['TYPE', 'URI']);
	
	              if (!hint.type) {
	                return;
	              } // search through all preload hints except for the current one for
	              // a duplicate type.
	
	
	              for (var i = 0; i < currentUri.preloadHints.length - 1; i++) {
	                var otherHint = currentUri.preloadHints[i];
	
	                if (!otherHint.type) {
	                  continue;
	                }
	
	                if (otherHint.type === hint.type) {
	                  this.trigger('warn', {
	                    message: "#EXT-X-PRELOAD-HINT #" + index + " for segment #" + segmentIndex + " has the same TYPE " + hint.type + " as preload hint #" + i
	                  });
	                }
	              }
	            },
	            'rendition-report': function renditionReport() {
	              var report = camelCaseKeys(entry.attributes);
	              this.manifest.renditionReports = this.manifest.renditionReports || [];
	              this.manifest.renditionReports.push(report);
	              var index = this.manifest.renditionReports.length - 1;
	              var required = ['LAST-MSN', 'URI'];
	
	              if (hasParts) {
	                required.push('LAST-PART');
	              }
	
	              this.warnOnMissingAttributes_("#EXT-X-RENDITION-REPORT #" + index, entry.attributes, required);
	            },
	            'part-inf': function partInf() {
	              this.manifest.partInf = camelCaseKeys(entry.attributes);
	              this.warnOnMissingAttributes_('#EXT-X-PART-INF', entry.attributes, ['PART-TARGET']);
	
	              if (this.manifest.partInf.partTarget) {
	                this.manifest.partTargetDuration = this.manifest.partInf.partTarget;
	              }
	
	              setHoldBack.call(this, this.manifest);
	            }
	          })[entry.tagType] || noop).call(self);
	        },
	        uri: function uri() {
	          currentUri.uri = entry.uri;
	          uris.push(currentUri); // if no explicit duration was declared, use the target duration
	
	          if (this.manifest.targetDuration && !('duration' in currentUri)) {
	            this.trigger('warn', {
	              message: 'defaulting segment duration to the target duration'
	            });
	            currentUri.duration = this.manifest.targetDuration;
	          } // annotate with encryption information, if necessary
	
	
	          if (_key) {
	            currentUri.key = _key;
	          }
	
	          currentUri.timeline = currentTimeline; // annotate with initialization segment information, if necessary
	
	          if (currentMap) {
	            currentUri.map = currentMap;
	          } // reset the last byterange end as it needs to be 0 between parts
	
	
	          lastPartByterangeEnd = 0; // prepare for the next URI
	
	          currentUri = {};
	        },
	        comment: function comment() {// comments are not important for playback
	        },
	        custom: function custom() {
	          // if this is segment-level data attach the output to the segment
	          if (entry.segment) {
	            currentUri.custom = currentUri.custom || {};
	            currentUri.custom[entry.customType] = entry.data; // if this is manifest-level data attach to the top level manifest object
	          } else {
	            this.manifest.custom = this.manifest.custom || {};
	            this.manifest.custom[entry.customType] = entry.data;
	          }
	        }
	      })[entry.type].call(self);
	    });
	
	    return _this;
	  }
	
	  var _proto = Parser.prototype;
	
	  _proto.warnOnMissingAttributes_ = function warnOnMissingAttributes_(identifier, attributes, required) {
	    var missing = [];
	    required.forEach(function (key) {
	      if (!attributes.hasOwnProperty(key)) {
	        missing.push(key);
	      }
	    });
	
	    if (missing.length) {
	      this.trigger('warn', {
	        message: identifier + " lacks required attribute(s): " + missing.join(', ')
	      });
	    }
	  }
	  /**
	   * Parse the input string and update the manifest object.
	   *
	   * @param {string} chunk a potentially incomplete portion of the manifest
	   */
	  ;
	
	  _proto.push = function push(chunk) {
	    this.lineStream.push(chunk);
	  }
	  /**
	   * Flush any remaining input. This can be handy if the last line of an M3U8
	   * manifest did not contain a trailing newline but the file has been
	   * completely received.
	   */
	  ;
	
	  _proto.end = function end() {
	    // flush any buffered input
	    this.lineStream.push('\n');
	    this.trigger('end');
	  }
	  /**
	   * Add an additional parser for non-standard tags
	   *
	   * @param {Object}   options              a map of options for the added parser
	   * @param {RegExp}   options.expression   a regular expression to match the custom header
	   * @param {string}   options.type         the type to register to the output
	   * @param {Function} [options.dataParser] function to parse the line into an object
	   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
	   */
	  ;
	
	  _proto.addParser = function addParser(options) {
	    this.parseStream.addParser(options);
	  }
	  /**
	   * Add a custom header mapper
	   *
	   * @param {Object}   options
	   * @param {RegExp}   options.expression   a regular expression to match the custom header
	   * @param {Function} options.map          function to translate tag into a different tag
	   */
	  ;
	
	  _proto.addTagMapper = function addTagMapper(options) {
	    this.parseStream.addTagMapper(options);
	  };
	
	  return Parser;
	}(Stream__default['default']);
	
	exports.LineStream = LineStream;
	exports.ParseStream = ParseStream;
	exports.Parser = Parser;


/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// install ES6 Promise polyfill
	__webpack_require__(1058);
	
	var interceptor = __webpack_require__(471);
	
	var callbackify = interceptor({
	  success: function (response) {
	    var callback = response && response.callback;
	
	    if (typeof callback === 'function') {
	      callback(null, response.entity, response);
	    }
	
	    return response;
	  },
	  error: function (response) {
	    var callback = response && response.callback;
	
	    if (typeof callback === 'function') {
	      var err = response.error || response.entity;
	      if (typeof err !== 'object') err = new Error(err);
	      callback(err);
	    }
	
	    return response;
	  }
	});
	
	module.exports = callbackify;


/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// install ES6 Promise polyfill
	__webpack_require__(1058);
	
	var rest = __webpack_require__(1849);
	
	// rest.js client with MIME support
	module.exports = function(config) {
	  return rest
	    .wrap(__webpack_require__(1852))
	    .wrap(__webpack_require__(1482), { prefix: config.endpoint })
	    .wrap(__webpack_require__(1853), { mime: 'application/json' })
	    .wrap(__webpack_require__(1483))
	    .wrap(__webpack_require__(1851), {
	      params: { access_token: config.accessToken }
	    })
	    .wrap(__webpack_require__(1816), { access_token: config.accessToken })
	    .wrap(__webpack_require__(1829))
	    .wrap(__webpack_require__(1811));
	};


/***/ },
/* 1813 */
/***/ function(module, exports) {

	
	module.exports.DEFAULT_ENDPOINT = 'https://api.mapbox.com';


/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(245),
	  invariantLocation = __webpack_require__(1057),
	  polyline = __webpack_require__(1831);
	
	/**
	 * Given a list of markers, encode them for display
	 * @param {Array<Object>} markers a list of markers
	 * @returns {string} encoded markers
	 * @private
	 */
	function encodeMarkers(markers) {
	  return markers.map(function(marker) {
	    invariantLocation(marker);
	    var size = marker.size || 'l';
	    var symbol = marker.symbol || 'circle';
	    return 'pin-' + size + '-' + symbol + '(' +
	      marker.longitude + ',' + marker.latitude + ')';
	  }).join(',');
	}
	
	module.exports.encodeMarkers = encodeMarkers;
	
	/**
	 * Given a path and style, encode it for display
	 * @param {Object} path an object of a path and style
	 * @param {Object} path.geojson a GeoJSON LineString
	 * @param {Object} [path.style={}] style parameters
	 * @returns {string} encoded path as polyline
	 * @private
	 */
	function encodePath(path) {
	  invariant(path.geojson.type === 'LineString', 'path line must be a LineString');
	  var encoded = polyline.fromGeoJSON(path.geojson);
	
	  var style = '';
	  if (path.style) {
	    if (path.style.strokewidth !== undefined) style += '-' + path.style.strokewidth;
	    if (path.style.strokecolor !== undefined) style += '+' + path.style.strokecolor;
	  }
	  return 'path' + style + '(' + encoded + ')';
	}
	
	module.exports.encodePath = encodePath;
	
	/**
	 * Given a GeoJSON object, encode it for a static map.
	 * @param {Object} geojson a geojson object
	 * @returns {string} encoded geojson as string
	 * @private
	 */
	function encodeGeoJSON(geojson) {
	  var encoded = JSON.stringify(geojson);
	  invariant(encoded.length < 4096, 'encoded GeoJSON must be shorter than 4096 characters long');
	  return 'geojson(' + encoded + ')';
	}
	
	module.exports.encodeGeoJSON = encodeGeoJSON;


/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var makeClient = __webpack_require__(269);
	var xtend = __webpack_require__(1340).extendMutable;
	var getUser = __webpack_require__(1339);
	var MapboxGeocoding = __webpack_require__(1819);
	var MapboxSurface = __webpack_require__(1824);
	var MapboxDirections = __webpack_require__(1818);
	var MapboxUploads = __webpack_require__(1828);
	var MapboxMatching = __webpack_require__(1820);
	var MapboxDatasets = __webpack_require__(1817);
	var MapboxMatrix = __webpack_require__(1821);
	var MapboxTilestats = __webpack_require__(1826);
	var MapboxStyles = __webpack_require__(1823);
	var MapboxStatic = __webpack_require__(1822);
	var MapboxTilesets = __webpack_require__(1825);
	var MapboxTokens = __webpack_require__(1827);
	
	
	/**
	 * The JavaScript API to Mapbox services
	 *
	 * @class
	 * @throws {Error} if accessToken is not provided
	 * @param {string} accessToken a private or public access token
	 * @param {Object} options additional options provided for configuration
	 * @param {string} [options.endpoint=https://api.mapbox.com] location
	 * of the Mapbox API pointed-to. This can be customized to point to a
	 * Mapbox Atlas Server instance, or a different service, a mock,
	 * or a staging endpoint. Usually you don't need to customize this.
	 * @param {string} [options.account] account id to use for api
	 * requests. If not is specified, the account defaults to the owner
	 * of the provided accessToken.
	 * @example
	 * var client = new MapboxClient('ACCESSTOKEN');
	 */
	var MapboxClient = makeClient('MapboxClient');
	
	// Combine all client APIs into one API for when people require()
	// the main mapbox-sdk-js library.
	xtend(
	  MapboxClient.prototype,
	  MapboxGeocoding.prototype,
	  MapboxSurface.prototype,
	  MapboxDirections.prototype,
	  MapboxMatrix.prototype,
	  MapboxMatching.prototype,
	  MapboxDatasets.prototype,
	  MapboxUploads.prototype,
	  MapboxTilestats.prototype,
	  MapboxStyles.prototype,
	  MapboxStatic.prototype,
	  MapboxTilesets.prototype,
	  MapboxTokens.prototype
	);
	
	MapboxClient.getUser = getUser;
	
	module.exports = MapboxClient;


/***/ },
/* 1816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// install ES6 Promise polyfill
	__webpack_require__(1058);
	
	var interceptor = __webpack_require__(471);
	var linkParser = __webpack_require__(1859);
	var url = __webpack_require__(1505);
	var querystring = __webpack_require__(1480);
	
	var paginator = interceptor({
	  success: function (response, config) {
	    var link = response && response.headers && response.headers.Link;
	    var client = response && response.request && response.request.originator;
	
	    if (link) {
	      var nextLink = linkParser.parse(link).filter(function (link) {
	        return link.rel === 'next';
	      })[0];
	
	      if (nextLink) {
	        response.nextPage = function (callback) {
	          var linkParts = url.parse(nextLink.href);
	          var linkQuery = querystring.parse(linkParts.query);
	          linkQuery.access_token = linkQuery.access_token || config.access_token;
	          linkParts.search = querystring.stringify(linkQuery);
	          return client({
	            path: url.format(linkParts),
	            callback: callback
	          });
	        };
	      }
	    }
	
	    return response;
	  }
	});
	
	module.exports = paginator;


/***/ },
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(245);
	var hat = __webpack_require__(1830);
	var makeService = __webpack_require__(269);
	
	var Datasets = module.exports = makeService('MapboxDatasets');
	
	var API_DATASET_DATASETS = '/datasets/v1/{owner}{?access_token,limit,fresh}';
	var API_DATASET_DATASET = '/datasets/v1/{owner}/{dataset}{?access_token}';
	var API_DATASET_FEATURES = '/datasets/v1/{owner}/{dataset}/features{?access_token,limit}';
	var API_DATASET_FEATURE = '/datasets/v1/{owner}/{dataset}/features/{id}{?access_token}';
	
	/**
	 * To retrieve a listing of datasets for a particular account.
	 * This request requires an access token with the datasets:read scope.
	 *
	 * @param {Object} [opts={}] list options
	 * @param {number} opts.limit limit, for paging
	 * @param {boolean} opts.fresh whether to request fresh data
	 * @param {Function} callback called with (err, datasets)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.listDatasets(function(err, datasets) {
	 *   console.log(datasets);
	 *   // [
	 *   //   {
	 *   //     "owner": {account},
	 *   //     "id": {dataset id},
	 *   //     "name": {dataset name},
	 *   //     "description": {dataset description},
	 *   //     "created": {timestamp},
	 *   //     "modified": {timestamp}
	 *   //   },
	 *   //   {
	 *   //     "owner": {account},
	 *   //     "id": {dataset id},
	 *   //     "name": {dataset name},
	 *   //     "description": {dataset description},
	 *   //     "created": {timestamp},
	 *   //     "modified": {timestamp}
	 *   //   }
	 *   // ]
	 * });
	 */
	Datasets.prototype.listDatasets = function(opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return this.client({
	    path: API_DATASET_DATASETS,
	    params: {
	      limit: opts.limit,
	      fresh: opts.fresh,
	      owner: this.owner
	    },
	    callback: callback
	  });
	};
	
	/**
	 * To create a new dataset. Valid properties include title and description (not required).
	 * This request requires an access token with the datasets:write scope.
	 *
	 * @param {object} [options] an object defining a dataset's properties
	 * @param {string} [options.name] the dataset's name
	 * @param {string} [options.description] the dataset's description
	 * @param {Function} callback called with (err, dataset)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.createDataset({ name: 'foo', description: 'bar' }, function(err, dataset) {
	 *   console.log(dataset);
	 *   // {
	 *   //   "owner": {account},
	 *   //   "id": {dataset id},
	 *   //   "name": "foo",
	 *   //   "description": "description",
	 *   //   "created": {timestamp},
	 *   //   "modified": {timestamp}
	 *   // }
	 * });
	 */
	Datasets.prototype.createDataset = function(options, callback) {
	  // permit the options argument to be omitted
	  if (callback === undefined && typeof options === 'function') {
	    callback = options;
	    options = {};
	  }
	
	  invariant(typeof options === 'object', 'options must be an object');
	
	  return this.client({
	    path: API_DATASET_DATASETS,
	    params: {
	      owner: this.owner
	    },
	    entity: options,
	    callback: callback
	  });
	};
	
	/**
	 * To retrieve information about a particular dataset.
	 * This request requires an access token with the datasets:read scope.
	 *
	 * @param {string} dataset the id for an existing dataset
	 * @param {Function} callback called with (err, dataset)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.readDataset('dataset-id', function(err, dataset) {
	 *   console.log(dataset);
	 *   // {
	 *   //   "owner": {account},
	 *   //   "id": "dataset-id",
	 *   //   "name": {dataset name},
	 *   //   "description": {dataset description},
	 *   //   "created": {timestamp},
	 *   //   "modified": {timestamp}
	 *   // }
	 * });
	 */
	Datasets.prototype.readDataset = function(dataset, callback) {
	  invariant(typeof dataset === 'string', 'dataset must be a string');
	
	  return this.client({
	    path: API_DATASET_DATASET,
	    params: {
	      owner: this.owner,
	      dataset: dataset
	    },
	    callback: callback
	  });
	};
	
	/**
	 * To make updates to a particular dataset's properties.
	 * This request requires an access token with the datasets:write scope.
	 *
	 * @param {string} dataset the id for an existing dataset
	 * @param {object} [options] an object defining updates to the dataset's properties
	 * @param {string} [options.name] the updated dataset's name
	 * @param {string} [options.description] the updated dataset's description
	 * @param {Function} callback called with (err, dataset)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * var options = { name: 'foo' };
	 * client.updateDataset('dataset-id', options, function(err, dataset) {
	 *   console.log(dataset);
	 *   // {
	 *   //   "owner": {account},
	 *   //   "id": "dataset-id",
	 *   //   "name": "foo",
	 *   //   "description": {dataset description},
	 *   //   "created": {timestamp},
	 *   //   "modified": {timestamp}
	 *   // }
	 * });
	 */
	Datasets.prototype.updateDataset = function(dataset, options, callback) {
	  invariant(typeof dataset === 'string', 'dataset must be a string');
	  invariant(typeof options === 'object', 'options must be an object');
	  invariant(!!options.name || !!options.description, 'options must include a name or a description');
	
	  return this.client({
	    path: API_DATASET_DATASET,
	    params: {
	      owner: this.owner,
	      dataset: dataset
	    },
	    method: 'patch',
	    entity: options,
	    callback: callback
	  });
	};
	
	/**
	 * To delete a particular dataset.
	 * This request requires an access token with the datasets:write scope.
	 *
	 * @param {string} dataset the id for an existing dataset
	 * @param {Function} callback called with (err)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.deleteDataset('dataset-id', function(err) {
	 *   if (!err) console.log('deleted!');
	 * });
	 */
	Datasets.prototype.deleteDataset = function(dataset, callback) {
	  invariant(typeof dataset === 'string', 'dataset must be a string');
	
	  return this.client({
	    path: API_DATASET_DATASET,
	    params: {
	      owner: this.owner,
	      dataset: dataset
	    },
	    method: 'delete',
	    callback: callback
	  });
	};
	
	/**
	 * Retrive a list of the features in a particular dataset. The response body will be a GeoJSON FeatureCollection.
	 * This request requires an access token with the datasets:read scope.
	 *
	 * @param {string} dataset the id for an existing dataset
	 * @param {object} [options] an object for passing pagination arguments
	 * @param {number} [options.limit] The maximum number of objects to return. This value must be between 1 and 100. The API will attempt to return the requested number of objects, but receiving fewer objects does not necessarily signal the end of the collection. Receiving an empty page of results is the only way to determine when you are at the end of a collection.
	 * @param {Function} callback called with (err, collection)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.listFeatures('dataset-id', options, function(err, collection) {
	 *   console.log(collection);
	 *   {
	 *     "type": "FeatureCollection",
	 *     "features": [
	 *       {
	 *         "id": {feature id},
	 *         "type": "Feature",
	 *         "properties": {feature properties}
	 *         "geometry": {feature geometry}
	 *       },
	 *       {
	 *         "id": {feature id},
	 *         "type": "Feature",
	 *         "properties": {feature properties}
	 *         "geometry": {feature geometry}
	 *       }
	 *     ]
	 *   }
	 * });
	 */
	Datasets.prototype.listFeatures = function(dataset, options, callback) {
	  // permit the options argument to be omitted
	  if (callback === undefined && typeof options === 'function') {
	    callback = options;
	    options = {};
	  }
	
	  invariant(typeof dataset === 'string', 'dataset must be a string');
	  invariant(typeof options === 'object', 'options must be a object');
	
	  var params = {
	    owner: this.owner,
	    dataset: dataset
	  };
	
	  if (options.limit) {
	    invariant(typeof options.limit === 'number', 'limit option must be a number');
	    params.limit = options.limit;
	  }
	
	  return this.client({
	    path: API_DATASET_FEATURES,
	    params: params,
	    callback: callback
	  });
	};
	
	/**
	 * Insert a feature into a dataset. This can be a new feature, or overwrite an existing one.
	 * If overwriting an existing feature, make sure that the feature's `id` property correctly identifies
	 * the feature you wish to overwrite.
	 * For new features, specifying an `id` is optional. If you do not specify an `id`, one will be assigned
	 * and returned as part of the response.
	 * This request requires an access token with the datasets:write scope.
	 * There are a number of limits to consider when making this request:
	 *   - a single feature cannot be larger than 500 KB
	 *   - the dataset must not exceed 2000 total features
	 *   - the dataset must not exceed a total of 5 MB
	 *
	 * @param {object} feature the feature to insert. Must be a valid GeoJSON feature per http://geojson.org/geojson-spec.html#feature-objects
	 * @param {string} dataset the id for an existing dataset
	 * @param {Function} callback called with (err, feature)
	 * @returns {Promise} response
	 * @example
	 * // Insert a brand new feature without an id
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * var feature = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "name": "Null Island"
	 *   },
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [0, 0]
	 *   }
	 * };
	 * client.insertFeature(feature, 'dataset-id', function(err, feature) {
	 *   console.log(feature);
	 *   // {
	 *   //   "id": {feature id},
	 *   //   "type": "Feature",
	 *   //   "properties": {
	 *   //     "name": "Null Island"
	 *   //   },
	 *   //   "geometry": {
	 *   //     "type": "Point",
	 *   //     "coordinates": [0, 0]
	 *   //   }
	 *   // }
	 * });
	 * @example
	 * // Insert a brand new feature with an id, or overwrite an existing feature at that id
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * var feature = {
	 *   "id": "feature-id",
	 *   "type": "Feature",
	 *   "properties": {
	 *     "name": "Null Island"
	 *   },
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [0, 0]
	 *   }
	 * };
	 * client.insertFeature(feature, 'dataset-id', function(err, feature) {
	 *   console.log(feature);
	 *   // {
	 *   //   "id": "feature-id",
	 *   //   "type": "Feature",
	 *   //   "properties": {
	 *   //     "name": "Null Island"
	 *   //   },
	 *   //   "geometry": {
	 *   //     "type": "Point",
	 *   //     "coordinates": [0, 0]
	 *   //   }
	 *   // }
	 * });
	 */
	Datasets.prototype.insertFeature = function(feature, dataset, callback) {
	  invariant(typeof dataset === 'string', 'dataset must be a string');
	
	  var id = feature.id || hat();
	  invariant(typeof id === 'string', 'The GeoJSON feature\'s id must be a string');
	
	  return this.client({
	    path: API_DATASET_FEATURE,
	    params: {
	      owner: this.owner,
	      dataset: dataset,
	      id: id
	    },
	    method: 'put',
	    entity: feature,
	    callback: callback
	  });
	};
	
	/**
	 * Read an existing feature from a dataset.
	 * This request requires an access token with the datasets:read scope.
	 *
	 * @param {string} id the `id` of the feature to read
	 * @param {string} dataset the id for an existing dataset
	 * @param {Function} callback called with (err, feature)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.readFeature('feature-id', 'dataset-id', function(err, feature) {
	 *   console.log(feature);
	 *   // {
	 *   //   "id": "feature-id",
	 *   //   "type": "Feature",
	 *   //   "properties": {
	 *   //     "name": "Null Island"
	 *   //   },
	 *   //   "geometry": {
	 *   //     "type": "Point",
	 *   //     "coordinates": [0, 0]
	 *   //   }
	 *   // }
	 * });
	 */
	Datasets.prototype.readFeature = function(id, dataset, callback) {
	  invariant(typeof id === 'string', 'id must be a string');
	  invariant(typeof dataset === 'string', 'dataset must be a string');
	
	  return this.client({
	    path: API_DATASET_FEATURE,
	    params: {
	      owner: this.owner,
	      dataset: dataset,
	      id: id
	    },
	    callback: callback
	  });
	};
	
	/**
	 * Delete an existing feature from a dataset.
	 * This request requires an access token with the datasets:write scope.
	 *
	 * @param {string} id the `id` of the feature to read
	 * @param {string} dataset the id for an existing dataset
	 * @param {Function} callback called with (err)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.deleteFeature('feature-id', 'dataset-id', function(err, feature) {
	 *   if (!err) console.log('deleted!');
	 * });
	 */
	Datasets.prototype.deleteFeature = function(id, dataset, callback) {
	  invariant(typeof id === 'string', 'id must be a string');
	  invariant(typeof dataset === 'string', 'dataset must be a string');
	
	  return this.client({
	    path: API_DATASET_FEATURE,
	    params: {
	      owner: this.owner,
	      dataset: dataset,
	      id: id
	    },
	    method: 'delete',
	    callback: callback
	  })};


/***/ },
/* 1818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(245);
	var formatPoints = __webpack_require__(1056);
	var makeService = __webpack_require__(269);
	
	var MapboxDirections = makeService('MapboxDirections');
	
	var API_DIRECTIONS = '/directions/v5/{account}/{profile}/{encodedWaypoints}.json{?access_token,alternatives,geometries,overview,radiuses,steps,continue_straight,bearings}';
	
	/**
	 * Find directions from A to B, or between any number of locations.
	 * Consult the [Mapbox Directions API](https://www.mapbox.com/api-documentation/#directions)
	 * for more documentation.
	 *
	 * @param {Array<Object>} waypoints an array of objects with `latitude`
	 * and `longitude` properties that represent waypoints in order. Up to
	 * 25 waypoints can be specified.
	 * @param {Object} [options={}] additional options meant to tune
	 * the request
	 * @param {string} [options.profile=driving] the directions
	 * profile, which determines how to prioritize different routes.
	 * Options are `'driving-traffic'` for automotive routing which factors
	 * in current and historic traffic conditions to avoid slowdowns,
	 * `'driving'`, which assumes transportation via an
	 * automobile and will use highways, `'walking'`, which avoids
	 * streets without sidewalks, and `'cycling'`, which prefers streets
	 * with bicycle lanes and lower speed limits for transportation via
	 * bicycle.
	 * @param {string} [options.account=mapbox] Account for the profile.
	 * @param {string} [options.alternatives=true] whether to generate
	 * alternative routes along with the preferred route.
	 * @param {string} [options.geometries=geojson] format for the returned
	 * route. Options are `'geojson'`, `'polyline'`, or `false`: `polyline`
	 * yields more compact responses which can be decoded on the client side.
	 * [GeoJSON](http://geojson.org/), the default, is compatible with libraries
	 * like [Mapbox GL](https://www.mapbox.com/mapbox-gl/),
	 * Leaflet and [Mapbox.js](https://www.mapbox.com/mapbox.js/). `false`
	 * omits the geometry entirely and only returns instructions.
	 * @param {string} [options.overview=simplified] type of returned overview
	 * geometry. Can be `full` (the most detailed geometry available), `simplified`
	 * (a simplified version of the full geometry), or `false`.
	 * @param {Array<number|string>} [options.radiuses] an array of integers in meters
	 * indicating the maximum distance each coordinate is allowed to move when
	 * snapped to a nearby road segment. There must be as many radiuses as there
	 * are coordinates in the request. Values can be any number greater than `0` or
	 * they can be the string `unlimited`. If no routable road is found within the
	 * radius, a `NoSegment` error is returned.
	 * @param {boolean} [options.steps=false] whether to return steps and
	 * turn-by-turn instructions. Can be `true` or `false`.
	 * @param {boolean} [options.continue_straight] sets allowed direction of travel
	 * when departing intermediate waypoints. If `true` the route will continue in
	 * the same direction of travel. If `false` the route may continue in the
	 * opposite direction of travel. Defaults to `true` for the `driving` profile
	 * and `false` for the `walking` and `cycling` profiles.
	 * @param {Array<Array>} [options.bearings] used to filter the road
	 * segment the waypoint will be placed on by direction and dictates the angle
	 * of approach. This option should always be used in conjunction with the
	 * `radiuses` option. The parameter takes two values per waypoint: the first is
	 * an angle clockwise from true north between `0` and `360`. The second is the
	 * range of degrees the angle can deviate by. We recommend a value of `45` or
	 * `90` for the range, as bearing measurements tend to be inaccurate. This is
	 * useful for making sure we reroute vehicles on new routes that continue
	 * traveling in their current direction. A request that does this would provide
	 * bearing and radius values for the first waypoint and leave the remaining
	 * values empty.If provided, the list of bearings must be the same length as
	 * the list of waypoints, but you can skip a coordinate and show its position
	 * by providing an empty array.
	 * @param {Function} callback called with (err, results)
	 * @returns {Promise} response
	 * @memberof MapboxClient
	 * @example
	 * var mapboxClient = new MapboxClient('ACCESSTOKEN');
	 * mapboxClient.getDirections(
	 *   [
	 *     { latitude: 33.6, longitude: -95.4431 },
	 *     { latitude: 33.2, longitude: -95.4431 } ],
	 *   function(err, res) {
	 *   // res is a document with directions
	 * });
	 *
	 * // With options
	 * mapboxClient.getDirections([
	 *   { latitude: 33.6875431, longitude: -95.4431142 },
	 *   { latitude: 33.6875431, longitude: -95.4831142 }
	 * ], {
	 *   profile: 'walking',
	 *   alternatives: false,
	 *   geometry: 'polyline'
	 * }, function(err, results) {
	 *   console.log(results);
	 * });
	 */
	MapboxDirections.prototype.getDirections = function(waypoints, options, callback) {
	
	  // permit the options argument to be omitted
	  if (callback === undefined && typeof options === 'function') {
	    callback = options;
	    options = {};
	  } else if (options === undefined) {
	    options = {};
	  }
	
	  // typecheck arguments
	  invariant(Array.isArray(waypoints), 'waypoints must be an array');
	  invariant(typeof options === 'object', 'options must be an object');
	
	  var encodedWaypoints = formatPoints(waypoints);
	
	  var params = {
	    encodedWaypoints: encodedWaypoints,
	    profile: 'driving',
	    account: 'mapbox',
	    alternatives: true,
	    steps: true,
	    geometries: 'geojson'
	  };
	
	  if (options.profile) {
	    invariant(typeof options.profile === 'string', 'profile option must be string');
	    params.profile = options.profile;
	  }
	
	  if (options.account) {
	    invariant(typeof options.account === 'string', 'account option must be string');
	    params.account = options.account;
	  }
	
	  if (typeof options.alternatives !== 'undefined') {
	    invariant(typeof options.alternatives === 'boolean', 'alternatives option must be boolean');
	    params.alternatives = options.alternatives;
	  }
	
	  if (options.radiuses) {
	    invariant(Array.isArray(options.radiuses), 'radiuses must be an array');
	    invariant(options.radiuses.length === waypoints.length, 'There must be as many radiuses as there are waypoints in the request');
	    params.radiuses = options.radiuses.join(';');
	  }
	
	  if (typeof options.steps !== 'undefined') {
	    invariant(typeof options.steps === 'boolean', 'steps option must be boolean');
	    params.steps = options.steps;
	  }
	
	  var allowedGeometries = ['polyline', 'geojson'];
	  if (options.geometries) {
	    invariant(allowedGeometries.indexOf(options.geometries) !== -1, 'geometries option must be ' + allowedGeometries);
	    params.geometries = options.geometries;
	  }
	
	  var allowedOverviews = ['simplified', 'full'];
	  if (options.overview) {
	    invariant(allowedOverviews.indexOf(options.overview) !== -1, 'overview option must be ' + allowedOverviews);
	    params.overview = options.overview;
	  }
	
	  if (typeof options.continue_straight !== 'undefined') {
	    invariant(typeof options.continue_straight === 'boolean', 'continue_straight option must be boolean');
	    params.continue_straight = options.continue_straight;
	  }
	
	  if (options.bearings) {
	    invariant(Array.isArray(options.radiuses), 'bearings must be an array');
	    invariant(options.bearings.length === waypoints.length, 'There must be as many bearings as there are waypoints in the request');
	    params.bearings = options.bearings.join(';');
	  }
	
	  return this.client({
	    path: API_DIRECTIONS,
	    params: params,
	    callback: callback
	  });
	};
	
	module.exports = MapboxDirections;


/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(245);
	var makeService = __webpack_require__(269);
	
	var MapboxGeocoding = makeService('MapboxGeocoding');
	
	var API_GEOCODING_FORWARD = '/geocoding/v5/{dataset}/{query}.json{?access_token,proximity,country,types,bbox,limit,autocomplete,language}';
	var API_GEOCODING_REVERSE = '/geocoding/v5/{dataset}/{longitude},{latitude}.json{?access_token,types,limit,language}';
	
	var REVERSE_GEOCODING_PRECISION = 5;
	var FORWARD_GEOCODING_PROXIMITY_PRECISION = 3;
	
	function roundTo(value, places) {
	  var mult = Math.pow(10, places);
	  return Math.round(value * mult) / mult;
	}
	
	/**
	 * Search for a location with a string, using the
	 * [Mapbox Geocoding API](https://www.mapbox.com/api-documentation/#geocoding).
	 *
	 * The `query` parmeter can be an array of strings only if batch geocoding
	 * is used by specifying `mapbox.places-permanent` as the `dataset` option.
	 *
	 * @param {string|Array<string>} query desired location
	 * @param {Object} [options={}] additional options meant to tune
	 * the request
	 * @param {Object} options.proximity a proximity argument: this is
	 * a geographical point given as an object with latitude and longitude
	 * properties. Search results closer to this point will be given
	 * higher priority.
	 * @param {Array} options.bbox a bounding box argument: this is
	 * a bounding box given as an array in the format [minX, minY, maxX, maxY].
	 * Search results will be limited to the bounding box.
	 * @param {string} options.language Specify the language to use for response text and, for forward geocoding, query result weighting. Options are IETF language tags comprised of a mandatory ISO 639-1 language code and optionally one or more IETF subtags for country or script. More than one value can also be specified, separated by commas. 
	 * @param {string} options.types a comma seperated list of types that filter
	 * results to match those specified. See https://www.mapbox.com/developers/api/geocoding/#filter-type
	 * for available types.
	 * @param {number} [options.limit=5] is the maximum number of results to return, between 1 and 10 inclusive.
	 * Some very specific queries may return fewer results than the limit.
	 * @param {string} options.country a comma separated list of country codes to
	 * limit results to specified country or countries.
	 * @param {boolean} [options.autocomplete=true] whether to include results that include
	 * the query only as a prefix. This is useful for UIs where users type
	 * values, but if you have complete addresses as input, you'll want to turn it off
	 * @param {string} [options.dataset=mapbox.places] the desired data to be
	 * geocoded against. The default, mapbox.places, does not permit unlimited
	 * caching. `mapbox.places-permanent` is available on request and does
	 * permit permanent caching.
	 * @param {Function} callback called with (err, results)
	 * @returns {Promise} response
	 * @memberof MapboxClient
	 * @example
	 * var mapboxClient = new MapboxClient('ACCESSTOKEN');
	 * mapboxClient.geocodeForward('Paris, France', function(err, res) {
	 *   // res is a GeoJSON document with geocoding matches
	 * });
	 * // using the proximity option to weight results closer to texas
	 * mapboxClient.geocodeForward('Paris, France', {
	 *   proximity: { latitude: 33.6875431, longitude: -95.4431142 }
	 * }, function(err, res) {
	 *   // res is a GeoJSON document with geocoding matches
	 * });
	 * // using the bbox option to limit results to a portion of Washington, D.C.
	 * mapboxClient.geocodeForward('Starbucks', {
	 *   bbox: [-77.083056,38.908611,-76.997778,38.959167]
	 * }, function(err, res) {
	 *   // res is a GeoJSON document with geocoding matches
	 * });
	 */
	MapboxGeocoding.prototype.geocodeForward = function(query, options, callback) {
	
	  // permit the options argument to be omitted
	  if (callback === undefined && typeof options === 'function') {
	    callback = options;
	    options = {};
	  }
	
	  // typecheck arguments
	  if (Array.isArray(query)) {
	    if (options.dataset !== 'mapbox.places-permanent') {
	      throw new Error('Batch geocoding is only available with the mapbox.places-permanent endpoint. See https://mapbox.com/api-documentation/#batch-requests for details');
	    } else {
	      query = query.join(';');
	    }
	  }
	  invariant(typeof query === 'string', 'query must be a string');
	  invariant(typeof options === 'object', 'options must be an object');
	
	  var queryOptions = {
	    query: query,
	    dataset: 'mapbox.places'
	  };
	
	  var precision = FORWARD_GEOCODING_PROXIMITY_PRECISION;
	  if (options.precision) {
	    invariant(typeof options.precision === 'number', 'precision option must be number');
	    precision = options.precision;
	  }
	
	  if (options.proximity) {
	    invariant(typeof options.proximity.latitude === 'number' &&
	      typeof options.proximity.longitude === 'number',
	      'proximity must be an object with numeric latitude & longitude properties');
	    queryOptions.proximity = roundTo(options.proximity.longitude, precision) + ',' + roundTo(options.proximity.latitude, precision);
	  }
	
	  if (options.bbox) {
	    invariant(typeof options.bbox[0] === 'number' &&
	      typeof options.bbox[1] === 'number' &&
	      typeof options.bbox[2] === 'number' &&
	      typeof options.bbox[3] === 'number' &&
	      options.bbox.length === 4,
	      'bbox must be an array with numeric values in the form [minX, minY, maxX, maxY]');
	    queryOptions.bbox = options.bbox[0] + ',' + options.bbox[1] + ',' + options.bbox[2] + ',' + options.bbox[3];
	  }
	
	  if (options.limit) {
	    invariant(typeof options.limit === 'number',
	      'limit must be a number');
	    queryOptions.limit = options.limit;
	  }
	
	  if (options.dataset) {
	    invariant(typeof options.dataset === 'string', 'dataset option must be string');
	    queryOptions.dataset = options.dataset;
	  }
	
	  if (options.country) {
	    invariant(typeof options.country === 'string', 'country option must be string');
	    queryOptions.country = options.country;
	  }
	
	  if (options.language) {
	    invariant(typeof options.language === 'string', 'language option must be string');
	    queryOptions.language = options.language;
	  }
	
	  if (options.types) {
	    invariant(typeof options.types === 'string', 'types option must be string');
	    queryOptions.types = options.types;
	  }
	
	  if (typeof options.autocomplete === 'boolean') {
	    invariant(typeof options.autocomplete === 'boolean', 'autocomplete must be a boolean');
	    queryOptions.autocomplete = options.autocomplete;
	  }
	
	  return this.client({
	    path: API_GEOCODING_FORWARD,
	    params: queryOptions,
	    callback: callback
	  });
	};
	
	/**
	 * Given a location, determine what geographical features are located
	 * there. This uses the [Mapbox Geocoding API](https://www.mapbox.com/api-documentation/#geocoding).
	 *
	 * @param {Object} location the geographical point to search
	 * @param {number} location.latitude decimal degrees latitude, in range -90 to 90
	 * @param {number} location.longitude decimal degrees longitude, in range -180 to 180
	 * @param {Object} [options={}] additional options meant to tune
	 * the request.
	 * @param {string} options.language Specify the language to use for response text and, for forward geocoding, query result weighting. Options are IETF language tags comprised of a mandatory ISO 639-1 language code and optionally one or more IETF subtags for country or script. More than one value can also be specified, separated by commas.
	 * @param {string} options.types a comma seperated list of types that filter
	 * results to match those specified. See
	 * https://www.mapbox.com/api-documentation/#retrieve-places-near-a-location
	 * for available types.
	 * @param {number} [options.limit=1] is the maximum number of results to return, between 1 and 5
	 * inclusive. Requires a single options.types to be specified (see example).
	 * @param {string} [options.dataset=mapbox.places] the desired data to be
	 * geocoded against. The default, mapbox.places, does not permit unlimited
	 * caching. `mapbox.places-permanent` is available on request and does
	 * permit permanent caching.
	 * @param {Function} callback called with (err, results)
	 * @returns {Promise} response
	 * @example
	 * var mapboxClient = new MapboxGeocoding('ACCESSTOKEN');
	 * mapboxClient.geocodeReverse(
	 *   { latitude: 33.6875431, longitude: -95.4431142 },
	 *   function(err, res) {
	 *   // res is a GeoJSON document with geocoding matches
	 * });
	 * @example
	 * var mapboxClient = new MapboxGeocoding('ACCESSTOKEN');
	 * mapboxClient.geocodeReverse(
	 *   { latitude: 33.6875431, longitude: -95.4431142, options: { types: address, limit: 3 } },
	 *   function(err, res) {
	 *   // res is a GeoJSON document with up to 3 geocoding matches
	 * });
	 */
	MapboxGeocoding.prototype.geocodeReverse = function(location, options, callback) {
	
	  // permit the options argument to be omitted
	  if (callback === undefined && typeof options === 'function') {
	    callback = options;
	    options = {};
	  }
	
	  // typecheck arguments
	  invariant(typeof location === 'object', 'location must be an object');
	  invariant(typeof options === 'object', 'options must be an object');
	
	  invariant(typeof location.latitude === 'number' &&
	    typeof location.longitude === 'number',
	    'location must be an object with numeric latitude & longitude properties');
	
	  var queryOptions = {
	    dataset: 'mapbox.places'
	  };
	
	  if (options.dataset) {
	    invariant(typeof options.dataset === 'string', 'dataset option must be string');
	    queryOptions.dataset = options.dataset;
	  }
	
	  var precision = REVERSE_GEOCODING_PRECISION;
	  if (options.precision) {
	    invariant(typeof options.precision === 'number', 'precision option must be number');
	    precision = options.precision;
	  }
	
	  if (options.language) {
	    invariant(typeof options.language === 'string', 'language option must be string');
	    queryOptions.language = options.language;
	  }
	
	  if (options.types) {
	    invariant(typeof options.types === 'string', 'types option must be string');
	    queryOptions.types = options.types;
	  }
	
	  if (options.limit) {
	    invariant(typeof options.limit === 'number', 'limit option must be a number');
	    invariant(options.types.split(',').length === 1, 'a single type must be specified to use the limit option');
	    queryOptions.limit = options.limit;
	  }
	
	  queryOptions.longitude = roundTo(location.longitude, precision);
	  queryOptions.latitude = roundTo(location.latitude, precision);
	
	  return this.client({
	    path: API_GEOCODING_REVERSE,
	    params: queryOptions,
	    callback: callback
	  });
	};
	
	module.exports = MapboxGeocoding;


/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(245);
	var makeService = __webpack_require__(269);
	
	var MapboxMatching = makeService('MapboxMatching');
	
	var API_MATCHING = '/matching/v5/{account}/{profile}/{coordinates}.json{?access_token,geometries,radiuses,steps,overview,timestamps,annotations}';
	
	/**
	 * Snap recorded location traces to roads and paths from OpenStreetMap.
	 * Consult the [Map Matching API](https://www.mapbox.com/api-documentation/#map-matching)
	 * for more documentation.
	 *
	 * @param {Array<Array<number>>} coordinates an array of coordinate pairs
	 * in [longitude, latitude] order. Up to 100 coordinates can be specified.
	 * @param {Object} [options={}] additional options meant to tune
	 * the request
	 * @param {string} [options.profile=driving] the directions
	 * profile, which determines how to prioritize different routes.
	 * Options are `'driving'`, which assumes transportation via an
	 * automobile and will use highways, `'walking'`, which avoids
	 * streets without sidewalks, and `'cycling'`, which prefers streets
	 * with bicycle lanes and lower speed limits for transportation via
	 * bicycle.
	 * @param {string} [options.geometries=geojson] format of the returned geometry.
	 * Allowed values are: `'geojson'` (as LineString), `'polyline'` with
	 * precision 5, `'polyline6'`. `'polyline'` yields more compact responses which
	 * can be decoded on the client side. [GeoJSON](http://geojson.org/), the
	 * default, is compatible with libraries like
	 * [Mapbox GL](https://www.mapbox.com/mapbox-gl/), Leaflet and
	 * [Mapbox.js](https://www.mapbox.com/mapbox.js/).
	 * @param {Array<number>} [options.radiuses] an array of integers in meters
	 * indicating the assumed precision of the used tracking device. There must be
	 * as many radiuses as there are coordinates in the request. Values can be a
	 * number between 0 and 30. Use higher numbers (20-30) for noisy traces and
	 * lower numbers (1-10) for clean traces. The default value is 5.
	 * @param {boolean} [options.steps=false] Whether to return steps and
	 * turn-by-turn instructions. Can be `true` or `false`.
	 * @param {string|boolean} [options.overview=simplified] type of returned
	 * overview geometry. Can be `'full'` (the most detailed geometry available),
	 * `'simplified'` (a simplified version of the full geometry), or `false`.
	 * @param {Array<number>} [options.timestamps] an array of timestamps
	 * corresponding to each coordinate provided in the request; must be numbers in
	 * [Unix time](https://en.wikipedia.org/wiki/Unix_time)
	 * (seconds since the Unix epoch). There must be as many timestamps as there
	 * are coordinates in the request.
	 * @param {Array<string>} [options.annotations] an array of fields that return
	 * additional metadata for each coordinate along the match geometry. Can be any
	 * of `'duration'`, `'distance'`, or `'nodes'`.
	 * @param {Function} callback called with (err, results)
	 * @returns {Promise} response
	 * @memberof MapboxClient
	 * @example
	 * var mapboxClient = new MapboxClient('ACCESSTOKEN');
	 * mapboxClient.matching([
	 *   [-95.4431142, 33.6875431],
	 *   [-95.0431142, 33.6875431],
	 *   [-95.0431142, 33.0875431],
	 *   [-95.0431142, 33.0175431],
	 *   [-95.4831142, 33.6875431]
	 * ], {
	 *  overview: 'full'
	 * }, function(err, res) {
	 *   // res is a match response object
	 * });
	 */
	MapboxMatching.prototype.matching = function(coordinates, options, callback) {
	
	  // permit the options argument to be omitted
	  if (callback === undefined && typeof options === 'function') {
	    callback = options;
	    options = {};
	  }
	
	  // typecheck arguments
	  invariant(Array.isArray(coordinates), 'coordinates must be an array');
	
	  var params = {
	    profile: 'driving',
	    account: 'mapbox',
	    geometries: 'geojson',
	    coordinates: coordinates.join(';')
	  };
	
	  if (options.profile) {
	    invariant(typeof options.profile === 'string', 'profile option must be string');
	    params.profile = options.profile;
	  }
	
	  var allowedGeometries = ['polyline', 'geojson'];
	  if (options.geometries) {
	    invariant(allowedGeometries.indexOf(options.geometries) !== -1, 'geometries option must be ' + allowedGeometries);
	    params.geometries = options.geometries;
	  }
	
	  if (options.radiuses) {
	    invariant(Array.isArray(options.radiuses), 'radiuses must be an array');
	    invariant(options.radiuses.length === coordinates.length, 'There must be as many radiuses as there are coordinates in the request');
	    params.radiuses = options.radiuses.join(';');
	  }
	
	  if (typeof options.steps !== 'undefined') {
	    invariant(typeof options.steps === 'boolean', 'steps option must be boolean');
	    params.steps = options.steps;
	  }
	
	  var allowedOverview = ['full', 'simplified'];
	  if (typeof options.overview !== 'undefined') {
	    invariant(allowedOverview.indexOf(options.overview) !== -1 || options.overview === false, 'overview option must be ' + allowedOverview + ' or false');
	    params.overview = options.overview;
	  }
	
	  if (options.timestamps) {
	    invariant(Array.isArray(options.timestamps), 'timestamps must be an array');
	    invariant(options.timestamps.length === coordinates.length, 'There must be as many timestamps as there are coordinates in the request');
	    params.timestamps = options.timestamps.join(';');
	  }
	
	  if (options.annotations) {
	    invariant(Array.isArray(options.annotations), 'annotations must be an array');
	    params.annotations = options.annotations.join();
	  }
	
	  return this.client({
	    path: API_MATCHING,
	    params: params,
	    method: 'get',
	    callback: callback
	  });
	};
	
	module.exports = MapboxMatching;


/***/ },
/* 1821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(245);
	var formatPoints = __webpack_require__(1056);
	var makeService = __webpack_require__(269);
	
	var MapboxMatrix = makeService('MapboxMatrix');
	
	var API_MATRIX = '/directions-matrix/v1/mapbox/{profile}/{encodedWaypoints}.json{?access_token}';
	
	/**
	 * Compute a table of travel-time estimates between a set of waypoints.
	 * Consult the [Mapbox Matrix API](https://www.mapbox.com/api-documentation/#matrix)
	 * for more documentation and limits.
	 *
	 * @param {Object} waypoints an array of coordinate object pairs
	 * in [longitude, latitude] order.
	 * @param {Object} [options={}] additional options meant to tune
	 * the request
	 * @param {string} [options.profile=driving] the directions
	 * profile, which determines how to prioritize different routes.
	 * Options are `'driving'`, which assumes transportation via an
	 * automobile and will use highways, `'walking'`, which avoids
	 * streets without sidewalks, and `'cycling'`, which prefers streets
	 * with bicycle lanes and lower speed limits for transportation via
	 * bicycle. The `'driving-traffic'` profile is not supported.
	 * @param {Function} callback called with (err, results)
	 * @returns {Promise} response
	 * @memberof MapboxClient
	 * @example
	 * var mapboxClient = new MapboxClient('ACCESSTOKEN');
	 * // Without options
	 * mapboxClient.getMatrix([{ 
	 *   longitude: -122.42,
	 *   latitude: 37.78
	 * },
	 * { 
	 *   longitude: -122.45,
	 *   latitude: 37.91
	 * },
	 * { 
	 *   longitude: -122.48,
	 *   latitude: 37.73
	 * }], {
	 * }, function(err, results) {
	 *   console.log(results);
	 * });
	 *
	 * // With options
	 * mapboxClient.getMatrix([{ 
	 *   longitude: -122.42,
	 *   latitude: 37.78
	 * },
	 * { 
	 *   longitude: -122.45,
	 *   latitude: 37.91
	 * },
	 * { 
	 *   longitude: -122.48,
	 *   latitude: 37.73
	 * }], { profile: 'walking' }, {
	 * }, function(err, results) {
	 *   console.log(results);
	 * });
	 *
	 * // Results is an object like:
	 * { durations:
	 *   [ [ 0, 1196, 3977, 3415, 5196 ],
	 *     [ 1207, 0, 3775, 3213, 4993 ],
	 *     [ 3976, 3774, 0, 2650, 2579 ],
	 *     [ 3415, 3212, 2650, 0, 3869 ],
	 *     [ 5208, 5006, 2579, 3882, 0 ] ] }
	 *
	 * // If the coordinates include an un-routable place, then
	 * // the table may contain 'null' values to indicate this, like
	 * { durations:
	 *   [ [ 0, 11642, 57965, null, 72782 ],
	 *     [ 11642, 0, 56394, null, 69918 ],
	 *     [ 57965, 56394, 0, null, 19284 ],
	 *     [ null, null, null, 0, null ],
	 *     [ 72782, 69918, 19284, null, 0 ] ] }
	 */
	
	MapboxMatrix.prototype.getMatrix = function(waypoints, options, callback) {
	
	  // permit the options argument to be omitted
	  if (callback === undefined && typeof options === 'function') {
	    callback = options;
	    options = {};
	  } else if (options === undefined) {
	    options = {};
	  }
	
	  // typecheck arguments
	  invariant(Array.isArray(waypoints), 'waypoints must be an array');
	  invariant(typeof options === 'object', 'options must be an object');
	
	  var encodedWaypoints = formatPoints(waypoints);
	
	  var params = {
	    encodedWaypoints: encodedWaypoints,
	    profile: 'driving'
	  };
	
	  if (options.profile) {
	    invariant(typeof options.profile === 'string', 'profile option must be string');
	    params.profile = options.profile;
	  }
	
	  return this.client({
	    path: API_MATRIX,
	    params: params,
	    callback: callback
	  });
	};
	
	module.exports = MapboxMatrix;


/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(245);
	var xtend = __webpack_require__(1340).extend;
	var uriTemplate = __webpack_require__(1062);
	var encodeOverlay = __webpack_require__(1814);
	var invariantLocation = __webpack_require__(1057);
	var makeService = __webpack_require__(269);
	
	var MapboxStatic = makeService('MapboxStatic');
	
	var API_STATIC = '/styles/v1/{username}/{styleid}/static{+overlay}/{+xyzbp}/{width}x{height}{+retina}{?access_token,attribution,logo,before_layer}';
	var API_STATIC_CLASSIC = '/v4/{mapid}{+overlay}/{+xyz}/{width}x{height}{+retina}{.format}{?access_token}';
	
	/**
	 * Determine a URL for a static map image, using the [Mapbox Static Map API](https://www.mapbox.com/api-documentation/#static).
	 *
	 * @param {string} username Mapbox username
	 * @param {string} styleid Mapbox Style ID
	 * @param {number} width width of the image
	 * @param {number} height height of the image
	 *
	 * @param {Object|string} position either an object with longitude and latitude members, or the string 'auto'
	 * @param {number} position.longitude east, west bearing
	 * @param {number} position.latitude north, south bearing
	 * @param {number} position.zoom map zoom level
	 * @param {number} position.bearing map bearing in degrees between 0 and 360
	 * @param {number} position.pitch map pitch in degrees between 0 (straight down, no pitch) and 60 (maximum pitch)
	 *
	 * @param {Object} options all map options
	 * @param {boolean} [options.retina=false] whether to double image pixel density
	 *
	 * @param {Array<Object>} [options.markers=[]] an array of simple marker objects as an overlay
	 * @param {Object} [options.geojson={}] geojson data for the overlay
	 * @param {Object} [options.path={}] a path and
	 * @param {Array<Object>} options.path.geojson data for the path as an array of longitude, latitude objects
	 * @param {Array<Object>} options.path.style optional style definitions for a path
	 * @param {boolean} options.attribution controlling whether there is attribution on the image; defaults to true
	 * @param {boolean} options.logo controlling whether there is a Mapbox logo on the image; defaults to true
	 * @param {string} options.before_layer value for controlling where the overlay is inserted in the style
	 *
	 * @returns {string} static map url
	 * @memberof MapboxClient
	 * @example
	 * var mapboxClient = new MapboxClient('ACCESSTOKEN');
	 * var url = mapboxClient.getStaticURL('mapbox', 'streets-v10', 600, 400, {
	 *   longitude: 151.22,
	 *   latitude: -33.87,
	 *   zoom: 11
	 * }, {
	 *   markers: [{ longitude: 151.22, latitude: -33.87 }],
	 *   before_layer: 'housenum-label'
	 * });
	 * // url = https://api.mapbox.com/styles/v1/mapbox/streets-v10/static/pin-l-circle(151.22,-33.87)/151.22,-33.87,11/600x400?access_token=ACCESS_TOKEN&before_layer=housenum-label
	 */
	MapboxStatic.prototype.getStaticURL = function(username, styleid, width, height, position, options) {
	  invariant(typeof username === 'string', 'username option required and must be a string');
	  invariant(typeof styleid === 'string', 'styleid option required and must be a string');
	  invariant(typeof width === 'number', 'width option required and must be a number');
	  invariant(typeof height === 'number', 'height option required and must be a number');
	
	  var defaults = {
	    retina: ''
	  };
	
	  var xyzbp;
	
	  if (position === 'auto') {
	    xyzbp = 'auto';
	  } else {
	    invariantLocation(position);
	    xyzbp = position.longitude + ',' + position.latitude + ',' + position.zoom;
	    if ('pitch' in position) {
	        xyzbp += ',' + (position.bearing || 0) + ',' + position.pitch;
	    } else if ('bearing' in position) {
	        xyzbp += ',' + position.bearing;
	    }
	  }
	
	  var userOptions = {};
	
	  if (options) {
	    invariant(typeof options === 'object', 'options must be an object');
	    if (options.format) {
	      invariant(typeof options.format === 'string', 'format must be a string');
	      userOptions.format = options.format;
	    }
	    if (options.retina) {
	      invariant(typeof options.retina === 'boolean', 'retina must be a boolean');
	      userOptions.retina = options.retina;
	    }
	    if (options.markers) {
	      userOptions.overlay = '/' + encodeOverlay.encodeMarkers(options.markers);
	    } else if (options.geojson) {
	      userOptions.overlay = '/' + encodeOverlay.encodeGeoJSON(options.geojson);
	    } else if (options.path) {
	      userOptions.overlay = '/' + encodeOverlay.encodePath(options.path);
	    }
	    if ('attribution' in options) {
	      invariant(typeof options.attribution === 'boolean', 'attribution must be a boolean');
	      userOptions.attribution = options.attribution;
	    }
	    if ('logo' in options) {
	      invariant(typeof options.logo === 'boolean', 'logo must be a boolean');
	      userOptions.logo = options.logo;
	    }
	    if (options.before_layer) {
	      invariant(typeof options.before_layer === 'string', 'before_layer must be a string');
	      userOptions.before_layer = options.before_layer;
	    }
	  }
	
	  var params = xtend(defaults, userOptions, {
	    username: username,
	    styleid: styleid,
	    width: width,
	    xyzbp: xyzbp,
	    height: height,
	    access_token: this.accessToken
	  });
	
	  if (params.retina === true) {
	    params.retina = '@2x';
	  }
	
	  return this.endpoint + uriTemplate.expand(API_STATIC, params);
	};
	
	/**
	 * Determine a URL for a static classic map image, using the [Mapbox Static (Classic) Map API](https://www.mapbox.com/api-documentation/pages/static_classic.html).
	 *
	 * @param {string} mapid a Mapbox map id in username.id form
	 * @param {number} width width of the image
	 * @param {number} height height of the image
	 *
	 * @param {Object|string} position either an object with longitude and latitude members, or the string 'auto'
	 * @param {number} position.longitude east, west bearing
	 * @param {number} position.latitude north, south bearing
	 * @param {number} position.zoom zoom level
	 *
	 * @param {Object} options all map options
	 * @param {string} [options.format=png] image format. can be jpg70, jpg80, jpg90, png32, png64, png128, png256
	 * @param {boolean} [options.retina=false] whether to double image pixel density
	 *
	 * @param {Array<Object>} [options.markers=[]] an array of simple marker objects as an overlay
	 * @param {Object} [options.geojson={}] geojson data for the overlay
	 * @param {Object} [options.path={}] a path and
	 * @param {Array<Object>} options.path.geojson data for the path as an array of longitude, latitude objects
	 * @param {Array<Object>} options.path.style optional style definitions for a path
	 *
	 * @returns {string} static classic map url
	 * @memberof MapboxClient
	 * @example
	 * var mapboxClient = new MapboxClient('ACCESSTOKEN');
	 */
	MapboxStatic.prototype.getStaticClassicURL = function(mapid, width, height, position, options) {
	  invariant(typeof mapid === 'string', 'mapid option required and must be a string');
	  invariant(typeof width === 'number', 'width option required and must be a number');
	  invariant(typeof height === 'number', 'height option required and must be a number');
	
	  var defaults = {
	    format: 'png',
	    retina: ''
	  };
	
	  var xyz;
	
	  if (position === 'auto') {
	    xyz = 'auto';
	  } else {
	    invariantLocation(position);
	    xyz = position.longitude + ',' + position.latitude + ',' + position.zoom;
	  }
	
	  var userOptions = {};
	
	  if (options) {
	    invariant(typeof options === 'object', 'options must be an object');
	    if (options.format) {
	      invariant(typeof options.format === 'string', 'format must be a string');
	      userOptions.format = options.format;
	    }
	    if (options.retina) {
	      invariant(typeof options.retina === 'boolean', 'retina must be a boolean');
	      userOptions.retina = options.retina;
	    }
	    if (options.markers) {
	      userOptions.overlay = '/' + encodeOverlay.encodeMarkers(options.markers);
	    } else if (options.geojson) {
	      userOptions.overlay = '/' + encodeOverlay.encodeGeoJSON(options.geojson);
	    } else if (options.path) {
	      userOptions.overlay = '/' + encodeOverlay.encodePath(options.path);
	    }
	  }
	
	  var params = xtend(defaults, userOptions, {
	    mapid: mapid,
	    width: width,
	    xyz: xyz,
	    height: height,
	    access_token: this.accessToken
	  });
	
	  if (params.retina === true) {
	    params.retina = '@2x';
	  }
	
	  return this.endpoint + uriTemplate.expand(API_STATIC_CLASSIC, params);
	};
	
	module.exports = MapboxStatic;


/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var invariant = __webpack_require__(245);
	var uriTemplate = __webpack_require__(1062);
	var makeService = __webpack_require__(269);
	
	var Styles = module.exports = makeService('MapboxStyles');
	
	var API_STYLES_LIST = '/styles/v1/{owner}{?access_token}';
	var API_STYLES_CREATE = '/styles/v1/{owner}{?access_token}';
	var API_STYLES_READ = '/styles/v1/{owner}/{styleid}{?access_token}';
	var API_STYLES_UPDATE = '/styles/v1/{owner}/{styleid}{?access_token}';
	var API_STYLES_DELETE = '/styles/v1/{owner}/{styleid}{?access_token}';
	var API_STYLES_EMBED = '/styles/v1/{owner}/{styleid}.html{?access_token,zoomwheel,title}';
	var API_STYLES_SPRITE = '/styles/v1/{owner}/{styleid}/sprite{+retina}{.format}{?access_token}';
	var API_STYLES_SPRITE_ICON = '/styles/v1/{owner}/{styleid}/sprite/{iconName}{?access_token}';
	var API_STYLES_FONT_GLYPH_RANGES = '/fonts/v1/{owner}/{font}/{start}-{end}.pbf{?access_token}';
	
	/**
	 * To retrieve a listing of styles for a particular account.
	 *
	 * @param {Function} callback called with (err, styles)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.listStyles(function(err, styles) {
	 *   console.log(styles);
	 *   // [{ version: 8,
	 *   //  name: 'Light',
	 *   //  center: [ -77.0469979435026, 38.898634927602814 ],
	 *   //  zoom: 12.511766533145998,
	 *   //  bearing: 0,
	 *   //  pitch: 0,
	 *   //  created: '2016-02-09T14:26:15.059Z',
	 *   //  id: 'STYLEID',
	 *   //  modified: '2016-02-09T14:28:31.253Z',
	 *   //  owner: '{username}' },
	 *   //  { version: 8,
	 *   //  name: 'Dark',
	 *   //  created: '2015-08-28T18:05:22.517Z',
	 *   //  id: 'STYILEID',
	 *   //  modified: '2015-08-28T18:05:22.517Z',
	 *   //  owner: '{username}' }]
	 * });
	 */
	Styles.prototype.listStyles = function(callback) {
	  return this.client({
	    path: API_STYLES_LIST,
	    params: {
	      owner: this.owner
	    },
	    callback: callback
	  });
	};
	
	/**
	 * Create a style, given the style as a JSON object.
	 *
	 * @param {Object} style Mapbox GL Style Spec object
	 * @param {Function} callback called with (err, createdStyle)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * var style = {
	 *   'version': 8,
	 *   'name': 'My Awesome Style',
	 *   'metadata': {},
	 *   'sources': {},
	 *   'layers': [],
	 *   'glyphs': 'mapbox://fonts/{owner}/{fontstack}/{range}.pbf'
	 * };
	 * client.createStyle(style, function(err, createdStyle) {
	 *   console.log(createdStyle);
	 * });
	 */
	Styles.prototype.createStyle = function(style, callback) {
	  return this.client({
	    path: API_STYLES_CREATE,
	    params: {
	      owner: this.owner
	    },
	    entity: style,
	    callback: callback
	  });
	};
	
	/**
	 * Update a style, given the style as a JSON object.
	 *
	 * @param {Object} style Mapbox GL Style Spec object
	 * @param {string} styleid style id
	 * @param {Function} callback called with (err, createdStyle)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * var style = {
	 *   'version': 8,
	 *   'name': 'My Awesome Style',
	 *   'metadata': {},
	 *   'sources': {},
	 *   'layers': [],
	 *   'glyphs': 'mapbox://fonts/{owner}/{fontstack}/{range}.pbf'
	 * };
	 * client.updateStyle(style, 'style-id', function(err, createdStyle) {
	 *   console.log(createdStyle);
	 * });
	 */
	Styles.prototype.updateStyle = function(style, styleid, callback) {
	  invariant(typeof styleid === 'string', 'style id must be a string');
	  return this.client({
	    path: API_STYLES_UPDATE,
	    params: {
	      owner: this.owner,
	      styleid: styleid
	    },
	    entity: style,
	    method: 'patch',
	    callback: callback
	  });
	};
	
	/**
	 * Deletes a particular style.
	 *
	 * @param {string} styleid the id for an existing style
	 * @param {Function} callback called with (err)
	 * @returns {Promise} a promise with the response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.deleteStyle('style-id', function(err) {
	 *   if (!err) console.log('deleted!');
	 * });
	 */
	Styles.prototype.deleteStyle = function(styleid, callback) {
	  invariant(typeof styleid === 'string', 'styleid must be a string');
	
	  return this.client({
	    path: API_STYLES_DELETE,
	    params: {
	      owner: this.owner,
	      styleid: styleid
	    },
	    method: 'delete',
	    callback: callback
	  });
	};
	
	/**
	 * Reads a particular style.
	 *
	 * @param {string} styleid the id for an existing style
	 * @param {Function} callback called with (err, style)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.readStyle('style-id', function(err, style) {
	 *   if (!err) console.log(style);
	 * });
	 */
	Styles.prototype.readStyle = function(styleid, callback) {
	  invariant(typeof styleid === 'string', 'styleid must be a string');
	
	  return this.client({
	    path: API_STYLES_READ,
	    params: {
	      owner: this.owner,
	      styleid: styleid
	    },
	    callback: callback
	  });
	};
	
	/**
	 * Read sprite
	 *
	 * @param {string} styleid the id for an existing style
	 * @param {Object=} options optional options
	 * @param {boolean} options.retina whether the sprite JSON should be for a
	 * retina sprite.
	 * @param {Function} callback called with (err)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.readSprite('style-id', {
	 *   retina: true
	 * }, function(err) {
	 *   if (!err) console.log('deleted!');
	 * });
	 */
	Styles.prototype.readSprite = function(styleid, options, callback) {
	  invariant(typeof styleid === 'string', 'styleid must be a string');
	
	  if (typeof options === 'function') {
	    callback = options;
	    options = {};
	  }
	
	  var retina = '';
	  if (options.retina) {
	    invariant(typeof options.retina === 'boolean',
	      'retina option must be a boolean value');
	    if (options.retina) {
	      retina = '@2x';
	    }
	  }
	
	  var format = 'json';
	  if (options.format) {
	    invariant(options.format === 'json' ||
	      options.format === 'png',
	      'format parameter must be either json or png');
	    format = options.format;
	  }
	
	  return this.client({
	    path: API_STYLES_SPRITE,
	    params: {
	      owner: this.owner,
	      retina: retina,
	      format: format,
	      styleid: styleid
	    },
	    callback: callback
	  });
	};
	
	/**
	 * Get font glyph ranges
	 *
	 * @param {string} font or fonts
	 * @param {number} start character code of starting glyph
	 * @param {number} end character code of last glyph. typically the same
	 * as start + 255
	 * @param {Function} callback called with (err)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.readFontGlyphRanges('Arial Unicode', 0, 255, function(err, ranges) {
	 *   if (!err) console.log(ranges);
	 * });
	 */
	Styles.prototype.readFontGlyphRanges = function(font, start, end, callback) {
	  invariant(typeof font === 'string', 'font must be a string');
	  invariant(typeof start === 'number', 'start must be a number');
	  invariant(typeof end === 'number', 'end must be a number');
	
	  return this.client({
	    path: API_STYLES_FONT_GLYPH_RANGES,
	    params: {
	      owner: this.owner,
	      font: font,
	      start: start,
	      end: end
	    },
	    callback: callback
	  });
	};
	
	/**
	 * Add an icon to a sprite.
	 *
	 * @param {string} styleid the id for an existing style
	 * @param {string} iconName icon's name
	 * @param {Buffer} icon icon content as a buffer
	 * @param {Function} callback called with (err)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var fs = require('fs');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.addIcon('style-id', 'icon-name', fs.readFileSync('icon.png'), function(err) {
	 *   if (!err) console.log('added icon!');
	 * });
	 */
	Styles.prototype.addIcon = function(styleid, iconName, icon, callback) {
	  invariant(typeof styleid === 'string', 'style must be a string');
	  invariant(typeof iconName === 'string', 'icon name must be a string');
	  invariant(Buffer.isBuffer(icon), 'icon must be a Buffer');
	
	  return this.client({
	    path: API_STYLES_SPRITE_ICON,
	    params: {
	      owner: this.owner,
	      styleid: styleid,
	      iconName: iconName
	    },
	    headers: {
	      'Content-Type': 'text/plain'
	    },
	    entity: icon,
	    method: 'put',
	    callback: callback
	  });
	};
	
	/**
	 * Delete an icon from a sprite.
	 *
	 * @param {string} styleid the id for an existing style
	 * @param {string} iconName icon's name
	 * @param {Function} callback called with (err)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.deleteIcon('style-id', 'icon-name', function(err) {
	 *   if (!err) console.log('deleted icon!');
	 * });
	 */
	Styles.prototype.deleteIcon = function(styleid, iconName, callback) {
	  invariant(typeof styleid === 'string', 'style must be a string');
	  invariant(typeof iconName === 'string', 'icon name must be a string');
	
	  return this.client({
	    path: API_STYLES_SPRITE_ICON,
	    params: {
	      owner: this.owner,
	      styleid: styleid,
	      iconName: iconName
	    },
	    method: 'delete',
	    callback: callback
	  });
	};
	
	/**
	 * Embed a style.
	 *
	 * @param {string} styleid the id for an existing style
	 * @param {Object} options optional params
	 * @param {boolean} [options.title=false] If true, shows a title box in upper right
	 * corner with map title and owner
	 * @param {boolean} [options.zoomwheel=true] Disables zooming with mouse scroll wheel
	 * @returns {string} URL of style embed page
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * var url = client.embedStyle('style-id');
	 */
	Styles.prototype.embedStyle = function(styleid, options) {
	  invariant(typeof styleid === 'string', 'style must be a string');
	
	  var params = {
	    styleid: styleid,
	    access_token: this.accessToken,
	    owner: this.owner,
	    title: false,
	    zoomwheel: true
	  };
	
	  if (options) {
	    if (options.title !== undefined) {
	      invariant(typeof options.title === 'boolean', 'title must be a boolean');
	      params.title = options.title;
	    }
	    if (options.zoomwheel !== undefined) {
	      invariant(typeof options.zoomwheel === 'boolean', 'zoomwheel must be a boolean');
	      params.zoomwheel = options.zoomwheel;
	    }
	  }
	
	  return this.endpoint + uriTemplate.expand(API_STYLES_EMBED, params);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(810).Buffer))

/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(245);
	var formatPoints = __webpack_require__(1056);
	var makeService = __webpack_require__(269);
	
	var MapboxSurface = makeService('MapboxSurface');
	
	var API_SURFACE = '/v4/surface/{mapid}.json{?access_token,layer,fields,points,geojson,interpolate,encoded_polyline}';
	
	/**
	 * Given a list of locations, retrieve vector tiles, find the nearest
	 * spatial features, extract their data values, and then absolute values and
	 * optionally interpolated values in-between, if the interpolate option is specified.
	 *
	 * Consult the [Surface API](https://www.mapbox.com/developers/api/surface/)
	 * for more documentation.
	 *
	 * @param {string} mapid a Mapbox mapid containing vector tiles against
	 * which we'll query
	 * @param {string} layer layer within the given `mapid` for which to pull
	 * data
	 * @param {Array<string>} fields layer within the given `mapid` for which to pull
	 * data
	 * @param {Array<Object>|string} path either an encoded polyline,
	 * provided as a string, or an array of objects with longitude and latitude
	 * properties, similar to waypoints.
	 * @param {Object} [options={}] additional options meant to tune
	 * the request
	 * @param {string} [options.geojson=false] whether to return data as a
	 * GeoJSON point
	 * @param {string} [options.zoom=maximum] zoom level at which features
	 * are queried
	 * @param {boolean} [options.interpolate=true] Whether to interpolate
	 * between matches in the feature collection.
	 * @param {Function} callback called with (err, results)
	 * @memberof MapboxClient
	 * @returns {Promise} response
	 * @example
	 * var mapboxClient = new MapboxClient('ACCESSTOKEN');
	 */
	MapboxSurface.prototype.surface = function(mapid, layer, fields, path, options, callback) {
	
	  // permit the options argument to be omitted
	  if (callback === undefined && typeof options === 'function') {
	    callback = options;
	    options = {};
	  }
	
	  // typecheck arguments
	  invariant(typeof mapid === 'string', 'mapid must be a string');
	  invariant(typeof layer === 'string', 'layer must be a string');
	  invariant(Array.isArray(fields), 'fields must be an array of strings');
	  invariant(Array.isArray(path) || typeof path === 'string', 'path must be an array of objects or a string');
	  invariant(typeof options === 'object', 'options must be an object');
	
	  var interpolate = true,
	    geojson = false;
	
	  if (options.interpolate !== undefined) {
	    invariant(typeof options.interpolate === 'boolean', 'interpolate must be a boolean');
	    interpolate = options.interpolate;
	  }
	
	  if (options.geojson !== undefined) {
	    invariant(typeof options.geojson === 'boolean', 'geojson option must be boolean');
	    geojson = options.geojson;
	  }
	
	  var surfaceOptions = {
	    geojson: geojson,
	    layer: layer,
	    mapid: mapid,
	    fields: fields.join(','),
	    interpolate: interpolate
	  };
	
	  if (Array.isArray(path)) {
	    surfaceOptions.points = formatPoints(path);
	  } else {
	    surfaceOptions.encoded_polyline = path;
	  }
	
	  if (options.zoom !== undefined) {
	    invariant(typeof options.zoom === 'number', 'zoom must be a number');
	    surfaceOptions.z = options.zoom;
	  }
	
	  return this.client({
	    path: API_SURFACE,
	    params: surfaceOptions,
	    callback: callback
	  });
	};
	
	module.exports = MapboxSurface;


/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(245);
	var makeService = __webpack_require__(269);
	
	var Tilesets = module.exports = makeService('MapboxTilesets');
	
	var API_TILESETS_TILEQUERY = '/v4/{mapid}/tilequery/{longitude},{latitude}.json{?access_token,radius,limit}';
	var API_TILESETS_LIST = '/tilesets/v1/{owner}{?access_token,limit}';
	
	/**
	 * Retrieve data about specific vector features at a specified location within a vector tileset
	 *
	 * @param {String} mapid Map ID of the tileset to query (eg. mapbox.mapbox-streets-v7)
	 * @param {Array} position An array in the form [longitude, latitude] of the position to query
	 * @param {Object} [options] optional options
	 * @param {Number} options.radius Approximate distance in meters to query for features
	 * @param {Number} options.limit Number of features between 1-50 to return
	 * @param {Function} [callback] called with (err, results, response)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.tilequery('mapbox.mapbox-streets-v7', [-77, 38], {}, function(err, response) {
	 *   console.log(response);
	 * });
	 */
	Tilesets.prototype.tilequery = function(mapid, position, options, callback) {
	  invariant(typeof mapid === 'string', 'mapid must be a string');
	  invariant(typeof position === 'object', 'position must be an array');
	  invariant(position.length == 2, 'position must be an array of length 2');
	  invariant(typeof position[0] === 'number' && typeof position[1] === 'number', 'position must be an array of two numbers');
	
	  if (typeof options === 'function') {
	    callback = options;
	    options = {};
	  }
	
	  return this.client({
	    path: API_TILESETS_TILEQUERY,
	    params: {
	      mapid: mapid,
	      longitude: position[0],
	      latitude: position[1],
	      radius: options.radius,
	      limit: options.limit
	    },
	    callback: callback
	  });
	};
	
	/**
	 * Retrieve all tilesets
	 *
	 * @param {Object} [options] optional options
	 * @param {Number} options.limit Maximum Number of tilesets to return
	 * @param {Function} [callback] called with (err, tilesets, response)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.listTilesets(function(err, tilesets) {
	 *   console.log(tilesets);
	 * });
	 */
	Tilesets.prototype.listTilesets = function(options, callback) {
	  if (typeof options === 'function') {
	    callback = options;
	    options = null;
	  }
	  options = options || {};
	
	  return this.client({
	    path: API_TILESETS_LIST,
	    params: {
	      owner: this.owner,
	      limit: options.limit
	    },
	    callback: callback
	  });
	};


/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(245);
	var makeService = __webpack_require__(269);
	
	var Tilestats = module.exports = makeService('MapboxTilestats');
	
	var API_TILESTATS_STATISTICS = '/tilestats/v1/{owner}/{tileset}{?access_token}';
	
	/**
	 * To retrieve statistics about a specific tileset.
	 *
	 * @param {String} tileset - the id for the tileset
	 * @param {Function} callback called with (err, tilestats)
	 * @returns {Promise} response
	 * @example
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.getTilestats('tileset-id', function(err, info) {
	 *   console.log(info);
	 *   // {
	 *   //   "layerCount": {layer count},
	 *   //   "layers": [
	 *   //     {
	 *   //       "layer": {layer name},
	 *   //       "geometry": {dominant geometry},
	 *   //       "count": {feature count},
	 *   //       "attributeCount": {attribute count}
	 *   //       "attributes": [
	 *   //         {
	 *   //           "attribute": {attribute name},
	 *   //           "type": {attribute type},
	 *   //           "count": {unique value count},
	 *   //           "min": {minimum value if type is number},
	 *   //           "max": {maximum value if type is number},
	 *   //           "values": [{...unique values}]
	 *   //         }
	 *   //       ]
	 *   //     }
	 *   //   ]
	 *   // }
	 * });
	 */
	Tilestats.prototype.getTilestats = function(tileset, callback) {
	  invariant(typeof tileset === 'string', 'tileset must be a string');
	
	  var owner = tileset.split('.')[0];
	  if (owner === tileset) owner = this.owner;
	
	  return this.client({
	    path: API_TILESTATS_STATISTICS,
	    params: {
	      owner: owner,
	      tileset: tileset
	    },
	    callback: callback
	  });
	};
	
	
	/**
	 * To create or update statistics about a specific tileset.
	 *
	 * @param {String} tileset - the id for the tileset
	 * @param {object} statistics - the statistics to upload
	 * @param {Function} callback called with (err, tilestats)
	 * @returns {Promise} response
	 * @example
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.getTilestats('tileset-id', function(err, stats) {
	 *   console.log(stats);
	 *   // {
	 *   //   "account": {account}
	 *   //   ... see stats example above (for Tilestats#getTilestats)
	 *   // }
	 * });
	 */
	Tilestats.prototype.putTilestats = function(tileset, statistics, callback) {
	  invariant(typeof tileset === 'string', 'tileset must be a string');
	
	  var owner = tileset.split('.')[0];
	  if (owner === tileset) owner = this.owner;
	
	  return this.client({
	    path: API_TILESTATS_STATISTICS,
	    params: {
	      owner: owner,
	      tileset: tileset
	    },
	    entity: statistics,
	    method: 'put',
	    callback: callback
	  });
	};


/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(245);
	var makeService = __webpack_require__(269);
	
	var Tokens = module.exports = makeService('MapboxTokens');
	
	var API_TOKENS_LIST = '/tokens/v2/{owner}{?access_token}';
	var API_TOKENS_CREATE = '/tokens/v2/{owner}{?access_token}';
	var API_TOKENS_UPDATE_AUTHORIZATION = '/tokens/v2/{owner}/{authorization_id}{?access_token}';
	var API_TOKENS_DELETE_AUTHORIZATION = '/tokens/v2/{owner}/{authorization_id}{?access_token}';
	var API_TOKENS_RETRIEVE = '/tokens/v2{?access_token}';
	var API_TOKENS_LIST_SCOPES = '/scopes/v1/{owner}{?access_token}';
	
	/**
	 * To retrieve a listing of tokens for a particular account.
	 *
	 * @param {Function} [callback] called with (err, tokens, response)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.listTokens(function(err, tokens) {
	 *   console.log(tokens);
	 *   // [{ client: 'api'
	 *   //  note: 'Default Public Token',
	 *   //  usage: 'pk',
	 *   //  id: 'TOKENID',
	 *   //  default: true,
	 *   //  scopes: ['styles:tiles','styles:read','fonts:read','datasets:read'],
	 *   //  created: '2016-02-09T14:26:15.059Z',
	 *   //  modified: '2016-02-09T14:28:31.253Z',
	 *   //  token: 'pk.TOKEN' }]
	 * });
	 */
	Tokens.prototype.listTokens = function(callback) {
	  return this.client({
	    path: API_TOKENS_LIST,
	    params: {
	      owner: this.owner
	    },
	    callback: callback
	  });
	};
	
	/**
	 * Create a token
	 *
	 * @param {string} note Note attached to the token
	 * @param {Array} scopes List of scopes for the new token
	 * @param {Function} [callback] called with (err, token, response)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.createToken('My top secret project', ["styles:read", "fonts:read"], function(err, createdToken) {
	 *   console.log(createdToken);
	 * });
	 */
	Tokens.prototype.createToken = function(note, scopes, callback) {
	  invariant(typeof note === 'string', 'note must be a string');
	  invariant(Object.prototype.toString.call(scopes) === '[object Array]', 'scopes must be an array');
	
	  return this.client({
	    path: API_TOKENS_CREATE,
	    params: {
	      owner: this.owner
	    },
	    entity: {
	      scopes: scopes,
	      note: note
	    },
	    callback: callback
	  });
	};
	
	/**
	 * Create a temporary token
	 *
	 * @param {string} expires Time token expires in RFC 3339
	 * @param {Array} scopes List of scopes for the new token
	 * @param {Function} [callback] called with (err, token, response)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.createToken('2016-09-15T19:27:53.000Z', ["styles:read", "fonts:read"], function(err, createdToken) {
	 *   console.log(createdToken);
	 * });
	 */
	Tokens.prototype.createTemporaryToken = function(expires, scopes, callback) {
	  invariant(typeof expires === 'string', 'expires must be a string');
	  invariant(Object.prototype.toString.call(scopes) === '[object Array]', 'scopes must be an array');
	
	  return this.client({
	    path: API_TOKENS_CREATE,
	    params: {
	      owner: this.owner
	    },
	    entity: {
	      scopes: scopes,
	      expires: expires
	    },
	    callback: callback
	  });
	};
	
	/**
	 * Update a token's authorization
	 *
	 * @param {string} authorization_id Authorization ID
	 * @param {Array} scopes List of scopes for the new token
	 * @param {Function} [callback] called with (err, token, response)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.updateTokenAuthorization('auth id', ["styles:read", "fonts:read"], function(err, updatedToken) {
	 *   console.log(updatedToken);
	 * });
	 */
	Tokens.prototype.updateTokenAuthorization = function(authorization_id, scopes, callback) {
	  invariant(typeof authorization_id === 'string', 'authorization_id must be a string');
	  invariant(Object.prototype.toString.call(scopes) === '[object Array]', 'scopes must be an array');
	
	  return this.client({
	    path: API_TOKENS_UPDATE_AUTHORIZATION,
	    params: {
	      authorization_id: authorization_id,
	      owner: this.owner
	    },
	    entity: {
	      scopes: scopes
	    },
	    method: 'patch',
	    callback: callback
	  });
	};
	
	/**
	 * Delete a token's authorization
	 *
	 * @param {string} authorization_id Authorization ID
	 * @param {Function} [callback] called with (err, token, response)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.deleteTokenAuthorization('auth id', function(err) {
	 * });
	 */
	Tokens.prototype.deleteTokenAuthorization = function(authorization_id, callback) {
	  invariant(typeof authorization_id === 'string', 'authorization_id must be a string');
	
	  return this.client({
	    path: API_TOKENS_DELETE_AUTHORIZATION,
	    params: {
	      authorization_id: authorization_id,
	      owner: this.owner
	    },
	    method: 'delete',
	    callback: callback
	  });
	};
	
	/**
	 * Retrieve a token
	 *
	 * @param {string} access_token access token to check
	 * @param {Function} [callback] called with (err, token, response)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.retrieveToken('ACCESSTOKEN', function(err, tokenResponse) {
	 *   console.log(tokenResponse);
	 * });
	 */
	Tokens.prototype.retrieveToken = function(access_token, callback) {
	  invariant(typeof access_token === 'string', 'access_token must be a string');
	
	  return this.client({
	    path: API_TOKENS_RETRIEVE,
	    params: {
	      access_token: access_token
	    },
	    callback: callback
	  });
	};
	
	/**
	 * List scopes
	 *
	 * @param {Function} [callback] called with (err, scopes, response)
	 * @returns {Promise} response
	 * @example
	 * var MapboxClient = require('mapbox');
	 * var client = new MapboxClient('ACCESSTOKEN');
	 * client.listScopes(function(err, scopes) {
	 *   console.log(scopes);
	 * });
	 */
	Tokens.prototype.listScopes = function(callback) {
	  return this.client({
	    path: API_TOKENS_LIST_SCOPES,
	    params: {
	      owner: this.owner
	    },
	    callback: callback
	  });
	};


/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(245);
	var makeService = __webpack_require__(269);
	
	var Uploads = module.exports = makeService('MapboxUploads');
	
	var API_UPLOADS = '/uploads/v1/{owner}{?access_token}';
	var API_UPLOAD = '/uploads/v1/{owner}/{upload}{?access_token}';
	var API_UPLOAD_CREDENTIALS = '/uploads/v1/{owner}/credentials{?access_token}';
	
	/**
	 * Retrieve a listing of uploads for a particular account.
	 *
	 * This request requires an access token with the uploads:list scope.
	 *
	 * @param {Function} callback called with (err, uploads)
	 * @returns {Promise} response
	 * @example
	 * var mapboxClient = new MapboxClient('ACCESSTOKEN');
	 * mapboxClient.listUploads(function(err, uploads) {
	 *   console.log(uploads);
	 *   // [
	 *   //   {
	 *   //     "complete": true,
	 *   //     "tileset": "example.mbtiles",
	 *   //     "error": null,
	 *   //     "id": "abc123",
	 *   //     "modified": "2014-11-21T19:41:10.000Z",
	 *   //     "created": "2014-11-21T19:41:10.000Z",
	 *   //     "owner": "example",
	 *   //     "progress": 1
	 *   //   },
	 *   //   {
	 *   //     "complete": false,
	 *   //     "tileset": "example.foo",
	 *   //     "error": null,
	 *   //     "id": "xyz789",
	 *   //     "modified": "2014-11-21T19:41:10.000Z",
	 *   //     "created": "2014-11-21T19:41:10.000Z",
	 *   //     "owner": "example",
	 *   //     "progress": 0
	 *   //   }
	 *   // ]
	 * });
	 */
	Uploads.prototype.listUploads = function(callback) {
	  return this.client({
	    path: API_UPLOADS,
	    params: { owner: this.owner },
	    callback: callback
	  });
	};
	
	/**
	 * Retrieve credentials that allow a new file to be staged on Amazon S3
	 * while an upload is processed. All uploads must be staged using these
	 * credentials before being uploaded to Mapbox.
	 *
	 * This request requires an access token with the uploads:write scope.
	 *
	 * @param {Function} callback called with (err, credentials)
	 * @returns {Promise} response
	 * @example
	 * var mapboxClient = new MapboxClient('ACCESSTOKEN');
	 * mapboxClient.createUploadCredentials(function(err, credentials) {
	 *   console.log(credentials);
	 *   // {
	 *   //   "accessKeyId": "{accessKeyId}",
	 *   //   "bucket": "somebucket",
	 *   //   "key": "hij456",
	 *   //   "secretAccessKey": "{secretAccessKey}",
	 *   //   "sessionToken": "{sessionToken}",
	 *   //   "url": "{s3 url}"
	 *   // }
	 *
	 *   // Use aws-sdk to stage the file on Amazon S3
	 *   var AWS = require('aws-sdk');
	 *   var s3 = new AWS.S3({
	 *        accessKeyId: credentials.accessKeyId,
	 *        secretAccessKey: credentials.secretAccessKey,
	 *        sessionToken: credentials.sessionToken,
	 *        region: 'us-east-1'
	 *   });
	 *   s3.putObject({
	 *     Bucket: credentials.bucket,
	 *     Key: credentials.key,
	 *     Body: fs.createReadStream('/path/to/file.mbtiles')
	 *   }, function(err, resp) {
	 *   });
	 * });
	 */
	Uploads.prototype.createUploadCredentials = function(callback) {
	  return this.client({
	    path: API_UPLOAD_CREDENTIALS,
	    params: { owner: this.owner },
	    method: 'post',
	    callback: callback
	  });
	};
	
	/**
	 * Create an new upload with a file previously staged on Amazon S3.
	 *
	 * This request requires an access token with the uploads:write scope.
	 *
	 * @param {Object} options an object that defines the upload's properties
	 * @param {String} options.tileset id of the tileset to create or
	 * replace. This must consist of an account id and a unique key
	 * separated by a period. Reuse of a tileset value will overwrite
	 * existing data. To avoid overwriting existing data, you must ensure
	 * that you are using unique tileset ids.
	 * @param {String} options.url https url of a file staged on Amazon S3.
	 * @param {Function} callback called with (err, upload)
	 * @returns {Promise} response
	 * @example
	 * var mapboxClient = new MapboxClient('ACCESSTOKEN');
	 * // Response from a call to createUploadCredentials
	 * var credentials = {
	 *   "accessKeyId": "{accessKeyId}",
	 *   "bucket": "somebucket",
	 *   "key": "hij456",
	 *   "secretAccessKey": "{secretAccessKey}",
	 *   "sessionToken": "{sessionToken}",
	 *   "url": "{s3 url}"
	 * };
	 * mapboxClient.createUpload({
	 *    tileset: [accountid, 'mytileset'].join('.'),
	 *    url: credentials.url
	 * }, function(err, upload) {
	 *   console.log(upload);
	 *   // {
	 *   //   "complete": false,
	 *   //   "tileset": "example.markers",
	 *   //   "error": null,
	 *   //   "id": "hij456",
	 *   //   "modified": "2014-11-21T19:41:10.000Z",
	 *   //   "created": "2014-11-21T19:41:10.000Z",
	 *   //   "owner": "example",
	 *   //   "progress": 0
	 *   // }
	 * });
	 */
	Uploads.prototype.createUpload = function(options, callback) {
	  invariant(typeof options === 'object', 'options must be an object');
	
	  return this.client({
	    path: API_UPLOADS,
	    params: { owner: this.owner },
	    entity: options,
	    callback: callback
	  });
	};
	
	/**
	 * Retrieve state of an upload.
	 *
	 * This request requires an access token with the uploads:read scope.
	 *
	 * @param {String} upload id of the upload to read
	 * @param {Function} callback called with (err, upload)
	 * @returns {Promise} response
	 * @example
	 * var mapboxClient = new MapboxClient('ACCESSTOKEN');
	 * mapboxClient.readUpload('hij456', function(err, upload) {
	 *   console.log(upload);
	 *   // {
	 *   //   "complete": true,
	 *   //   "tileset": "example.markers",
	 *   //   "error": null,
	 *   //   "id": "hij456",
	 *   //   "modified": "2014-11-21T19:41:10.000Z",
	 *   //   "created": "2014-11-21T19:41:10.000Z",
	 *   //   "owner": "example",
	 *   //   "progress": 1
	 *   // }
	 * });
	 */
	Uploads.prototype.readUpload = function(upload, callback) {
	  invariant(typeof upload === 'string', 'upload must be a string');
	
	  return this.client({
	    path: API_UPLOAD,
	    params: {
	      owner: this.owner,
	      upload: upload
	    },
	    callback: callback
	  });
	};
	
	/**
	 * Delete a completed upload. In-progress uploads cannot be deleted.
	 *
	 * This request requires an access token with the uploads:delete scope.
	 *
	 * @param {string} upload upload identifier
	 * @param {Function} callback called with (err)
	 * @returns {Promise} response
	 * @example
	 * var mapboxClient = new MapboxClient('ACCESSTOKEN');
	 * mapboxClient.deleteUpload('hij456', function(err) {
	 * });
	 */
	Uploads.prototype.deleteUpload = function(upload, callback) {
	  invariant(typeof upload === 'string', 'upload must be a string');
	
	  return this.client({
	    method: 'delete',
	    path: API_UPLOAD,
	    params: {
	      owner: this.owner,
	      upload: upload
	    },
	    callback: callback
	  });
	};


/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	var interceptor = __webpack_require__(471);
	
	var standardResponse = interceptor({
	  response: transform,
	});
	
	function transform(response) {
	  return {
	    url: response.url,
	    status: response.status && response.status.code,
	    headers: response.headers,
	    entity: response.entity,
	    error: response.error,
	    callback: response.request && response.request.callback,
	    nextPage: response.nextPage
	  };
	}
	
	module.exports = standardResponse;


/***/ },
/* 1830 */
/***/ function(module, exports) {

	/* eslint-disable */
	/*
	 * hat
	 * written by James Halliday, licensed under MIT/X11
	 * https://github.com/substack/node-hat
	 */
	var hat = module.exports = function (bits, base) {
	    if (!base) base = 16;
	    if (bits === undefined) bits = 128;
	    if (bits <= 0) return '0';
	    
	    var digits = Math.log(Math.pow(2, bits)) / Math.log(base);
	    for (var i = 2; digits === Infinity; i *= 2) {
	        digits = Math.log(Math.pow(2, bits / i)) / Math.log(base) * i;
	    }
	    
	    var rem = digits - Math.floor(digits);
	    
	    var res = '';
	    
	    for (var i = 0; i < Math.floor(digits); i++) {
	        var x = Math.floor(Math.random() * base).toString(base);
	        res = x + res;
	    }
	    
	    if (rem) {
	        var b = Math.pow(base, rem);
	        var x = Math.floor(Math.random() * b).toString(base);
	        res = x + res;
	    }
	    
	    var parsed = parseInt(res, base);
	    if (parsed !== Infinity && parsed >= Math.pow(2, bits)) {
	        return hat(bits, base)
	    }
	    else return res;
	};


/***/ },
/* 1831 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * polyline
	 *
	 * https://github.com/mapbox/polyline
	 *
	 * by John Firebaugh, Tom MacWright, and contributors
	 * licensed under BSD 3-clause
	 */
	
	/*
	 * Based off of [the offical Google document](https://developers.google.com/maps/documentation/utilities/polylinealgorithm)
	 *
	 * Some parts from [this implementation](http://facstaff.unca.edu/mcmcclur/GoogleMaps/EncodePolyline/PolylineEncoder.js)
	 * by [Mark McClure](http://facstaff.unca.edu/mcmcclur/)
	 *
	 * @module polyline
	 */
	
	var polyline = {};
	
	function encode(coordinate, factor) {
	    coordinate = Math.round(coordinate * factor);
	    coordinate <<= 1;
	    if (coordinate < 0) {
	        coordinate = ~coordinate;
	    }
	    var output = '';
	    while (coordinate >= 0x20) {
	        output += String.fromCharCode((0x20 | (coordinate & 0x1f)) + 63);
	        coordinate >>= 5;
	    }
	    output += String.fromCharCode(coordinate + 63);
	    return output;
	}
	
	/**
	 * Encodes the given [latitude, longitude] coordinates array.
	 *
	 * @param {Array.<Array.<Number>>} coordinates
	 * @param {Number} precision
	 * @returns {String}
	 */
	polyline.encode = function(coordinates, precision) {
	    if (!coordinates.length) { return ''; }
	
	    var factor = Math.pow(10, precision || 5),
	        output = encode(coordinates[0][0], factor) + encode(coordinates[0][1], factor);
	
	    for (var i = 1; i < coordinates.length; i++) {
	        var a = coordinates[i], b = coordinates[i - 1];
	        output += encode(a[0] - b[0], factor);
	        output += encode(a[1] - b[1], factor);
	    }
	
	    return output;
	};
	
	function flipped(coords) {
	    var flipped = [];
	    for (var i = 0; i < coords.length; i++) {
	        flipped.push(coords[i].slice().reverse());
	    }
	    return flipped;
	}
	
	/**
	 * Encodes a GeoJSON LineString feature/geometry.
	 *
	 * @param {Object} geojson
	 * @param {Number} precision
	 * @returns {String}
	 */
	polyline.fromGeoJSON = function(geojson, precision) {
	    if (geojson && geojson.type === 'Feature') {
	        geojson = geojson.geometry;
	    }
	    if (!geojson || geojson.type !== 'LineString') {
	        throw new Error('Input must be a GeoJSON LineString');
	    }
	    return polyline.encode(flipped(geojson.coordinates), precision);
	};
	
	module.exports = polyline;


/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.48
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (typeof module === 'object' && module.exports) {
			module.exports = factory(__webpack_require__(8)); // Node
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Resolves es6 module loading issue
		if (moment.version === undefined && moment.default) {
			moment = moment.default;
		}
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.48",
			zones = {},
			links = {},
			countries = {},
			names = {},
			guesses = {},
			cachedGuess;
	
		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}
	
		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		function closest (num, arr) {
			var len = arr.length;
			if (num < arr[0]) {
				return 0;
			} else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) {
				return len - 1;
			} else if (num >= arr[len - 1]) {
				return -1;
			}
	
			var mid;
			var lo = 0;
			var hi = len - 1;
			while (hi - lo > 1) {
				mid = Math.floor((lo + hi) / 2);
				if (arr[mid] <= num) {
					lo = mid;
				} else {
					hi = mid;
				}
			}
			return hi;
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				i = closest(target, untils);
				if (i >= 0) {
					return i;
				}
			},
	
			countries : function () {
				var zone_name = this.name;
				return Object.keys(countries).filter(function (country_code) {
					return countries[country_code].zones.indexOf(zone_name) !== -1;
				});
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Country object
		************************************/
	
		function Country (country_name, zone_names) {
			this.name = country_name;
			this.zones = zone_names;
		}
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				lastOffset = last.offset,
				offsets = [last],
				change, next, nextOffset, i;
	
			for (i = 1; i < 48; i++) {
				nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
				if (nextOffset !== lastOffset) {
					// Create OffsetAt here to avoid unnecessary abbr parsing before checking offsets
					next = new OffsetAt(new Date(startYear, i, 1));
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
					last = next;
					lastOffset = nextOffset;
				}
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			if (a.zone.population !== b.zone.population) {
				return b.zone.population - a.zone.population;
			}
			return b.zone.name.localeCompare(a.zone.name);
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				checkedOffsets = {},
				i, j, offset, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				offset = offsets[i].offset;
				if (checkedOffsets.hasOwnProperty(offset)) {
					continue;
				}
				guessesOffset = guesses[offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
				checkedOffsets[offset] = true;
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
	
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function getCountryNames () {
			return Object.keys(countries);
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function addCountries (data) {
			var i, country_code, country_zones, split;
			if (!data || !data.length) return;
			for (i = 0; i < data.length; i++) {
				split = data[i].split('|');
				country_code = split[0].toUpperCase();
				country_zones = split[1].split(' ');
				countries[country_code] = new Country(
					country_code,
					country_zones
				);
			}
		}
	
		function getCountry (name) {
			name = name.toUpperCase();
			return countries[name] || null;
		}
	
		function zonesForCountry(country, with_offset) {
			country = getCountry(country);
	
			if (!country) return null;
	
			var zones = country.zones.sort();
	
			if (with_offset) {
				return zones.map(function (zone_name) {
					var zone = getZone(zone_name);
					return {
						name: zone_name,
						offset: zone.utcOffset(new Date())
					};
				});
			}
	
			return zones;
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			addCountries(data.countries);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				out  = moment.utc.apply(null, args),
				zone;
	
			if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz._countries	= countries;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
		tz.countries    = getCountryNames;
		tz.zonesForCountry = zonesForCountry;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					var z = mom._z;
					mom.utcOffset(-offset, keepTime);
					mom._z = z;
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		function resetZoneWrap2 (old) {
			return function () {
				if (arguments.length > 0) this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName  = abbrWrap(fn.zoneName);
		fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
		fn.utc       = resetZoneWrap(fn.utc);
		fn.local     = resetZoneWrap(fn.local);
		fn.utcOffset = resetZoneWrap2(fn.utcOffset);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 1341,
		"./af.js": 1341,
		"./ar": 1349,
		"./ar-dz": 1342,
		"./ar-dz.js": 1342,
		"./ar-kw": 1343,
		"./ar-kw.js": 1343,
		"./ar-ly": 1344,
		"./ar-ly.js": 1344,
		"./ar-ma": 1345,
		"./ar-ma.js": 1345,
		"./ar-ps": 1346,
		"./ar-ps.js": 1346,
		"./ar-sa": 1347,
		"./ar-sa.js": 1347,
		"./ar-tn": 1348,
		"./ar-tn.js": 1348,
		"./ar.js": 1349,
		"./az": 1350,
		"./az.js": 1350,
		"./be": 1351,
		"./be.js": 1351,
		"./bg": 1352,
		"./bg.js": 1352,
		"./bm": 1353,
		"./bm.js": 1353,
		"./bn": 1355,
		"./bn-bd": 1354,
		"./bn-bd.js": 1354,
		"./bn.js": 1355,
		"./bo": 1356,
		"./bo.js": 1356,
		"./br": 1357,
		"./br.js": 1357,
		"./bs": 1358,
		"./bs.js": 1358,
		"./ca": 1359,
		"./ca.js": 1359,
		"./cs": 1360,
		"./cs.js": 1360,
		"./cv": 1361,
		"./cv.js": 1361,
		"./cy": 1362,
		"./cy.js": 1362,
		"./da": 1363,
		"./da.js": 1363,
		"./de": 1366,
		"./de-at": 1364,
		"./de-at.js": 1364,
		"./de-ch": 1365,
		"./de-ch.js": 1365,
		"./de.js": 1366,
		"./dv": 1367,
		"./dv.js": 1367,
		"./el": 1368,
		"./el.js": 1368,
		"./en-au": 1369,
		"./en-au.js": 1369,
		"./en-ca": 1370,
		"./en-ca.js": 1370,
		"./en-gb": 1371,
		"./en-gb.js": 1371,
		"./en-ie": 1372,
		"./en-ie.js": 1372,
		"./en-il": 1373,
		"./en-il.js": 1373,
		"./en-in": 1374,
		"./en-in.js": 1374,
		"./en-nz": 1375,
		"./en-nz.js": 1375,
		"./en-sg": 1376,
		"./en-sg.js": 1376,
		"./eo": 1377,
		"./eo.js": 1377,
		"./es": 1381,
		"./es-do": 1378,
		"./es-do.js": 1378,
		"./es-mx": 1379,
		"./es-mx.js": 1379,
		"./es-us": 1380,
		"./es-us.js": 1380,
		"./es.js": 1381,
		"./et": 1382,
		"./et.js": 1382,
		"./eu": 1383,
		"./eu.js": 1383,
		"./fa": 1384,
		"./fa.js": 1384,
		"./fi": 1385,
		"./fi.js": 1385,
		"./fil": 1386,
		"./fil.js": 1386,
		"./fo": 1387,
		"./fo.js": 1387,
		"./fr": 1390,
		"./fr-ca": 1388,
		"./fr-ca.js": 1388,
		"./fr-ch": 1389,
		"./fr-ch.js": 1389,
		"./fr.js": 1390,
		"./fy": 1391,
		"./fy.js": 1391,
		"./ga": 1392,
		"./ga.js": 1392,
		"./gd": 1393,
		"./gd.js": 1393,
		"./gl": 1394,
		"./gl.js": 1394,
		"./gom-deva": 1395,
		"./gom-deva.js": 1395,
		"./gom-latn": 1396,
		"./gom-latn.js": 1396,
		"./gu": 1397,
		"./gu.js": 1397,
		"./he": 1398,
		"./he.js": 1398,
		"./hi": 1399,
		"./hi.js": 1399,
		"./hr": 1400,
		"./hr.js": 1400,
		"./hu": 1401,
		"./hu.js": 1401,
		"./hy-am": 1402,
		"./hy-am.js": 1402,
		"./id": 1403,
		"./id.js": 1403,
		"./is": 1404,
		"./is.js": 1404,
		"./it": 1406,
		"./it-ch": 1405,
		"./it-ch.js": 1405,
		"./it.js": 1406,
		"./ja": 1407,
		"./ja.js": 1407,
		"./jv": 1408,
		"./jv.js": 1408,
		"./ka": 1409,
		"./ka.js": 1409,
		"./kk": 1410,
		"./kk.js": 1410,
		"./km": 1411,
		"./km.js": 1411,
		"./kn": 1412,
		"./kn.js": 1412,
		"./ko": 1413,
		"./ko.js": 1413,
		"./ku": 1415,
		"./ku-kmr": 1414,
		"./ku-kmr.js": 1414,
		"./ku.js": 1415,
		"./ky": 1416,
		"./ky.js": 1416,
		"./lb": 1417,
		"./lb.js": 1417,
		"./lo": 1418,
		"./lo.js": 1418,
		"./lt": 1419,
		"./lt.js": 1419,
		"./lv": 1420,
		"./lv.js": 1420,
		"./me": 1421,
		"./me.js": 1421,
		"./mi": 1422,
		"./mi.js": 1422,
		"./mk": 1423,
		"./mk.js": 1423,
		"./ml": 1424,
		"./ml.js": 1424,
		"./mn": 1425,
		"./mn.js": 1425,
		"./mr": 1426,
		"./mr.js": 1426,
		"./ms": 1428,
		"./ms-my": 1427,
		"./ms-my.js": 1427,
		"./ms.js": 1428,
		"./mt": 1429,
		"./mt.js": 1429,
		"./my": 1430,
		"./my.js": 1430,
		"./nb": 1431,
		"./nb.js": 1431,
		"./ne": 1432,
		"./ne.js": 1432,
		"./nl": 1434,
		"./nl-be": 1433,
		"./nl-be.js": 1433,
		"./nl.js": 1434,
		"./nn": 1435,
		"./nn.js": 1435,
		"./oc-lnc": 1436,
		"./oc-lnc.js": 1436,
		"./pa-in": 1437,
		"./pa-in.js": 1437,
		"./pl": 1438,
		"./pl.js": 1438,
		"./pt": 1440,
		"./pt-br": 1439,
		"./pt-br.js": 1439,
		"./pt.js": 1440,
		"./ro": 1441,
		"./ro.js": 1441,
		"./ru": 1442,
		"./ru.js": 1442,
		"./sd": 1443,
		"./sd.js": 1443,
		"./se": 1444,
		"./se.js": 1444,
		"./si": 1445,
		"./si.js": 1445,
		"./sk": 1446,
		"./sk.js": 1446,
		"./sl": 1447,
		"./sl.js": 1447,
		"./sq": 1448,
		"./sq.js": 1448,
		"./sr": 1450,
		"./sr-cyrl": 1449,
		"./sr-cyrl.js": 1449,
		"./sr.js": 1450,
		"./ss": 1451,
		"./ss.js": 1451,
		"./sv": 1452,
		"./sv.js": 1452,
		"./sw": 1453,
		"./sw.js": 1453,
		"./ta": 1454,
		"./ta.js": 1454,
		"./te": 1455,
		"./te.js": 1455,
		"./tet": 1456,
		"./tet.js": 1456,
		"./tg": 1457,
		"./tg.js": 1457,
		"./th": 1458,
		"./th.js": 1458,
		"./tk": 1459,
		"./tk.js": 1459,
		"./tl-ph": 1460,
		"./tl-ph.js": 1460,
		"./tlh": 1461,
		"./tlh.js": 1461,
		"./tr": 1462,
		"./tr.js": 1462,
		"./tzl": 1463,
		"./tzl.js": 1463,
		"./tzm": 1465,
		"./tzm-latn": 1464,
		"./tzm-latn.js": 1464,
		"./tzm.js": 1465,
		"./ug-cn": 1466,
		"./ug-cn.js": 1466,
		"./uk": 1467,
		"./uk.js": 1467,
		"./ur": 1468,
		"./ur.js": 1468,
		"./uz": 1470,
		"./uz-latn": 1469,
		"./uz-latn.js": 1469,
		"./uz.js": 1470,
		"./vi": 1471,
		"./vi.js": 1471,
		"./x-pseudo": 1472,
		"./x-pseudo.js": 1472,
		"./yo": 1473,
		"./yo.js": 1473,
		"./zh-cn": 1474,
		"./zh-cn.js": 1474,
		"./zh-hk": 1475,
		"./zh-hk.js": 1475,
		"./zh-mo": 1476,
		"./zh-mo.js": 1476,
		"./zh-tw": 1477,
		"./zh-tw.js": 1477
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1833;


/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	/*! @name mpd-parser @version 0.22.1 @license Apache-2.0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var resolveUrl = __webpack_require__(1281);
	var window = __webpack_require__(344);
	var mediaGroups = __webpack_require__(1526);
	var decodeB64ToUint8Array = __webpack_require__(1279);
	var xmldom = __webpack_require__(1536);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var resolveUrl__default = /*#__PURE__*/_interopDefaultLegacy(resolveUrl);
	var window__default = /*#__PURE__*/_interopDefaultLegacy(window);
	var decodeB64ToUint8Array__default = /*#__PURE__*/_interopDefaultLegacy(decodeB64ToUint8Array);
	
	var version = "0.22.1";
	
	var isObject = function isObject(obj) {
	  return !!obj && typeof obj === 'object';
	};
	
	var merge = function merge() {
	  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
	    objects[_key] = arguments[_key];
	  }
	
	  return objects.reduce(function (result, source) {
	    if (typeof source !== 'object') {
	      return result;
	    }
	
	    Object.keys(source).forEach(function (key) {
	      if (Array.isArray(result[key]) && Array.isArray(source[key])) {
	        result[key] = result[key].concat(source[key]);
	      } else if (isObject(result[key]) && isObject(source[key])) {
	        result[key] = merge(result[key], source[key]);
	      } else {
	        result[key] = source[key];
	      }
	    });
	    return result;
	  }, {});
	};
	var values = function values(o) {
	  return Object.keys(o).map(function (k) {
	    return o[k];
	  });
	};
	
	var range = function range(start, end) {
	  var result = [];
	
	  for (var i = start; i < end; i++) {
	    result.push(i);
	  }
	
	  return result;
	};
	var flatten = function flatten(lists) {
	  return lists.reduce(function (x, y) {
	    return x.concat(y);
	  }, []);
	};
	var from = function from(list) {
	  if (!list.length) {
	    return [];
	  }
	
	  var result = [];
	
	  for (var i = 0; i < list.length; i++) {
	    result.push(list[i]);
	  }
	
	  return result;
	};
	var findIndexes = function findIndexes(l, key) {
	  return l.reduce(function (a, e, i) {
	    if (e[key]) {
	      a.push(i);
	    }
	
	    return a;
	  }, []);
	};
	/**
	 * Returns the first index that satisfies the matching function, or -1 if not found.
	 *
	 * Only necessary because of IE11 support.
	 *
	 * @param {Array} list - the list to search through
	 * @param {Function} matchingFunction - the matching function
	 *
	 * @return {number} the matching index or -1 if not found
	 */
	
	var findIndex = function findIndex(list, matchingFunction) {
	  for (var i = 0; i < list.length; i++) {
	    if (matchingFunction(list[i])) {
	      return i;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Returns a union of the included lists provided each element can be identified by a key.
	 *
	 * @param {Array} list - list of lists to get the union of
	 * @param {Function} keyFunction - the function to use as a key for each element
	 *
	 * @return {Array} the union of the arrays
	 */
	
	var union = function union(lists, keyFunction) {
	  return values(lists.reduce(function (acc, list) {
	    list.forEach(function (el) {
	      acc[keyFunction(el)] = el;
	    });
	    return acc;
	  }, {}));
	};
	
	var errors = {
	  INVALID_NUMBER_OF_PERIOD: 'INVALID_NUMBER_OF_PERIOD',
	  DASH_EMPTY_MANIFEST: 'DASH_EMPTY_MANIFEST',
	  DASH_INVALID_XML: 'DASH_INVALID_XML',
	  NO_BASE_URL: 'NO_BASE_URL',
	  MISSING_SEGMENT_INFORMATION: 'MISSING_SEGMENT_INFORMATION',
	  SEGMENT_TIME_UNSPECIFIED: 'SEGMENT_TIME_UNSPECIFIED',
	  UNSUPPORTED_UTC_TIMING_SCHEME: 'UNSUPPORTED_UTC_TIMING_SCHEME'
	};
	
	/**
	 * @typedef {Object} SingleUri
	 * @property {string} uri - relative location of segment
	 * @property {string} resolvedUri - resolved location of segment
	 * @property {Object} byterange - Object containing information on how to make byte range
	 *   requests following byte-range-spec per RFC2616.
	 * @property {String} byterange.length - length of range request
	 * @property {String} byterange.offset - byte offset of range request
	 *
	 * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.35.1
	 */
	
	/**
	 * Converts a URLType node (5.3.9.2.3 Table 13) to a segment object
	 * that conforms to how m3u8-parser is structured
	 *
	 * @see https://github.com/videojs/m3u8-parser
	 *
	 * @param {string} baseUrl - baseUrl provided by <BaseUrl> nodes
	 * @param {string} source - source url for segment
	 * @param {string} range - optional range used for range calls,
	 *   follows  RFC 2616, Clause 14.35.1
	 * @return {SingleUri} full segment information transformed into a format similar
	 *   to m3u8-parser
	 */
	
	var urlTypeToSegment = function urlTypeToSegment(_ref) {
	  var _ref$baseUrl = _ref.baseUrl,
	      baseUrl = _ref$baseUrl === void 0 ? '' : _ref$baseUrl,
	      _ref$source = _ref.source,
	      source = _ref$source === void 0 ? '' : _ref$source,
	      _ref$range = _ref.range,
	      range = _ref$range === void 0 ? '' : _ref$range,
	      _ref$indexRange = _ref.indexRange,
	      indexRange = _ref$indexRange === void 0 ? '' : _ref$indexRange;
	  var segment = {
	    uri: source,
	    resolvedUri: resolveUrl__default['default'](baseUrl || '', source)
	  };
	
	  if (range || indexRange) {
	    var rangeStr = range ? range : indexRange;
	    var ranges = rangeStr.split('-'); // default to parsing this as a BigInt if possible
	
	    var startRange = window__default['default'].BigInt ? window__default['default'].BigInt(ranges[0]) : parseInt(ranges[0], 10);
	    var endRange = window__default['default'].BigInt ? window__default['default'].BigInt(ranges[1]) : parseInt(ranges[1], 10); // convert back to a number if less than MAX_SAFE_INTEGER
	
	    if (startRange < Number.MAX_SAFE_INTEGER && typeof startRange === 'bigint') {
	      startRange = Number(startRange);
	    }
	
	    if (endRange < Number.MAX_SAFE_INTEGER && typeof endRange === 'bigint') {
	      endRange = Number(endRange);
	    }
	
	    var length;
	
	    if (typeof endRange === 'bigint' || typeof startRange === 'bigint') {
	      length = window__default['default'].BigInt(endRange) - window__default['default'].BigInt(startRange) + window__default['default'].BigInt(1);
	    } else {
	      length = endRange - startRange + 1;
	    }
	
	    if (typeof length === 'bigint' && length < Number.MAX_SAFE_INTEGER) {
	      length = Number(length);
	    } // byterange should be inclusive according to
	    // RFC 2616, Clause 14.35.1
	
	
	    segment.byterange = {
	      length: length,
	      offset: startRange
	    };
	  }
	
	  return segment;
	};
	var byteRangeToString = function byteRangeToString(byterange) {
	  // `endRange` is one less than `offset + length` because the HTTP range
	  // header uses inclusive ranges
	  var endRange;
	
	  if (typeof byterange.offset === 'bigint' || typeof byterange.length === 'bigint') {
	    endRange = window__default['default'].BigInt(byterange.offset) + window__default['default'].BigInt(byterange.length) - window__default['default'].BigInt(1);
	  } else {
	    endRange = byterange.offset + byterange.length - 1;
	  }
	
	  return byterange.offset + "-" + endRange;
	};
	
	/**
	 * parse the end number attribue that can be a string
	 * number, or undefined.
	 *
	 * @param {string|number|undefined} endNumber
	 *        The end number attribute.
	 *
	 * @return {number|null}
	 *          The result of parsing the end number.
	 */
	
	var parseEndNumber = function parseEndNumber(endNumber) {
	  if (endNumber && typeof endNumber !== 'number') {
	    endNumber = parseInt(endNumber, 10);
	  }
	
	  if (isNaN(endNumber)) {
	    return null;
	  }
	
	  return endNumber;
	};
	/**
	 * Functions for calculating the range of available segments in static and dynamic
	 * manifests.
	 */
	
	
	var segmentRange = {
	  /**
	   * Returns the entire range of available segments for a static MPD
	   *
	   * @param {Object} attributes
	   *        Inheritied MPD attributes
	   * @return {{ start: number, end: number }}
	   *         The start and end numbers for available segments
	   */
	  static: function _static(attributes) {
	    var duration = attributes.duration,
	        _attributes$timescale = attributes.timescale,
	        timescale = _attributes$timescale === void 0 ? 1 : _attributes$timescale,
	        sourceDuration = attributes.sourceDuration,
	        periodDuration = attributes.periodDuration;
	    var endNumber = parseEndNumber(attributes.endNumber);
	    var segmentDuration = duration / timescale;
	
	    if (typeof endNumber === 'number') {
	      return {
	        start: 0,
	        end: endNumber
	      };
	    }
	
	    if (typeof periodDuration === 'number') {
	      return {
	        start: 0,
	        end: periodDuration / segmentDuration
	      };
	    }
	
	    return {
	      start: 0,
	      end: sourceDuration / segmentDuration
	    };
	  },
	
	  /**
	   * Returns the current live window range of available segments for a dynamic MPD
	   *
	   * @param {Object} attributes
	   *        Inheritied MPD attributes
	   * @return {{ start: number, end: number }}
	   *         The start and end numbers for available segments
	   */
	  dynamic: function dynamic(attributes) {
	    var NOW = attributes.NOW,
	        clientOffset = attributes.clientOffset,
	        availabilityStartTime = attributes.availabilityStartTime,
	        _attributes$timescale2 = attributes.timescale,
	        timescale = _attributes$timescale2 === void 0 ? 1 : _attributes$timescale2,
	        duration = attributes.duration,
	        _attributes$periodSta = attributes.periodStart,
	        periodStart = _attributes$periodSta === void 0 ? 0 : _attributes$periodSta,
	        _attributes$minimumUp = attributes.minimumUpdatePeriod,
	        minimumUpdatePeriod = _attributes$minimumUp === void 0 ? 0 : _attributes$minimumUp,
	        _attributes$timeShift = attributes.timeShiftBufferDepth,
	        timeShiftBufferDepth = _attributes$timeShift === void 0 ? Infinity : _attributes$timeShift;
	    var endNumber = parseEndNumber(attributes.endNumber); // clientOffset is passed in at the top level of mpd-parser and is an offset calculated
	    // after retrieving UTC server time.
	
	    var now = (NOW + clientOffset) / 1000; // WC stands for Wall Clock.
	    // Convert the period start time to EPOCH.
	
	    var periodStartWC = availabilityStartTime + periodStart; // Period end in EPOCH is manifest's retrieval time + time until next update.
	
	    var periodEndWC = now + minimumUpdatePeriod;
	    var periodDuration = periodEndWC - periodStartWC;
	    var segmentCount = Math.ceil(periodDuration * timescale / duration);
	    var availableStart = Math.floor((now - periodStartWC - timeShiftBufferDepth) * timescale / duration);
	    var availableEnd = Math.floor((now - periodStartWC) * timescale / duration);
	    return {
	      start: Math.max(0, availableStart),
	      end: typeof endNumber === 'number' ? endNumber : Math.min(segmentCount, availableEnd)
	    };
	  }
	};
	/**
	 * Maps a range of numbers to objects with information needed to build the corresponding
	 * segment list
	 *
	 * @name toSegmentsCallback
	 * @function
	 * @param {number} number
	 *        Number of the segment
	 * @param {number} index
	 *        Index of the number in the range list
	 * @return {{ number: Number, duration: Number, timeline: Number, time: Number }}
	 *         Object with segment timing and duration info
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping a range of numbers to
	 * information needed to build the segment list.
	 *
	 * @param {Object} attributes
	 *        Inherited MPD attributes
	 * @return {toSegmentsCallback}
	 *         Callback map function
	 */
	
	var toSegments = function toSegments(attributes) {
	  return function (number) {
	    var duration = attributes.duration,
	        _attributes$timescale3 = attributes.timescale,
	        timescale = _attributes$timescale3 === void 0 ? 1 : _attributes$timescale3,
	        periodStart = attributes.periodStart,
	        _attributes$startNumb = attributes.startNumber,
	        startNumber = _attributes$startNumb === void 0 ? 1 : _attributes$startNumb;
	    return {
	      number: startNumber + number,
	      duration: duration / timescale,
	      timeline: periodStart,
	      time: number * duration
	    };
	  };
	};
	/**
	 * Returns a list of objects containing segment timing and duration info used for
	 * building the list of segments. This uses the @duration attribute specified
	 * in the MPD manifest to derive the range of segments.
	 *
	 * @param {Object} attributes
	 *        Inherited MPD attributes
	 * @return {{number: number, duration: number, time: number, timeline: number}[]}
	 *         List of Objects with segment timing and duration info
	 */
	
	var parseByDuration = function parseByDuration(attributes) {
	  var type = attributes.type,
	      duration = attributes.duration,
	      _attributes$timescale4 = attributes.timescale,
	      timescale = _attributes$timescale4 === void 0 ? 1 : _attributes$timescale4,
	      periodDuration = attributes.periodDuration,
	      sourceDuration = attributes.sourceDuration;
	
	  var _segmentRange$type = segmentRange[type](attributes),
	      start = _segmentRange$type.start,
	      end = _segmentRange$type.end;
	
	  var segments = range(start, end).map(toSegments(attributes));
	
	  if (type === 'static') {
	    var index = segments.length - 1; // section is either a period or the full source
	
	    var sectionDuration = typeof periodDuration === 'number' ? periodDuration : sourceDuration; // final segment may be less than full segment duration
	
	    segments[index].duration = sectionDuration - duration / timescale * index;
	  }
	
	  return segments;
	};
	
	/**
	 * Translates SegmentBase into a set of segments.
	 * (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
	 * node should be translated into segment.
	 *
	 * @param {Object} attributes
	 *   Object containing all inherited attributes from parent elements with attribute
	 *   names as keys
	 * @return {Object.<Array>} list of segments
	 */
	
	var segmentsFromBase = function segmentsFromBase(attributes) {
	  var baseUrl = attributes.baseUrl,
	      _attributes$initializ = attributes.initialization,
	      initialization = _attributes$initializ === void 0 ? {} : _attributes$initializ,
	      sourceDuration = attributes.sourceDuration,
	      _attributes$indexRang = attributes.indexRange,
	      indexRange = _attributes$indexRang === void 0 ? '' : _attributes$indexRang,
	      periodStart = attributes.periodStart,
	      presentationTime = attributes.presentationTime,
	      _attributes$number = attributes.number,
	      number = _attributes$number === void 0 ? 0 : _attributes$number,
	      duration = attributes.duration; // base url is required for SegmentBase to work, per spec (Section 5.3.9.2.1)
	
	  if (!baseUrl) {
	    throw new Error(errors.NO_BASE_URL);
	  }
	
	  var initSegment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: initialization.sourceURL,
	    range: initialization.range
	  });
	  var segment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: baseUrl,
	    indexRange: indexRange
	  });
	  segment.map = initSegment; // If there is a duration, use it, otherwise use the given duration of the source
	  // (since SegmentBase is only for one total segment)
	
	  if (duration) {
	    var segmentTimeInfo = parseByDuration(attributes);
	
	    if (segmentTimeInfo.length) {
	      segment.duration = segmentTimeInfo[0].duration;
	      segment.timeline = segmentTimeInfo[0].timeline;
	    }
	  } else if (sourceDuration) {
	    segment.duration = sourceDuration;
	    segment.timeline = periodStart;
	  } // If presentation time is provided, these segments are being generated by SIDX
	  // references, and should use the time provided. For the general case of SegmentBase,
	  // there should only be one segment in the period, so its presentation time is the same
	  // as its period start.
	
	
	  segment.presentationTime = presentationTime || periodStart;
	  segment.number = number;
	  return [segment];
	};
	/**
	 * Given a playlist, a sidx box, and a baseUrl, update the segment list of the playlist
	 * according to the sidx information given.
	 *
	 * playlist.sidx has metadadata about the sidx where-as the sidx param
	 * is the parsed sidx box itself.
	 *
	 * @param {Object} playlist the playlist to update the sidx information for
	 * @param {Object} sidx the parsed sidx box
	 * @return {Object} the playlist object with the updated sidx information
	 */
	
	var addSidxSegmentsToPlaylist$1 = function addSidxSegmentsToPlaylist(playlist, sidx, baseUrl) {
	  // Retain init segment information
	  var initSegment = playlist.sidx.map ? playlist.sidx.map : null; // Retain source duration from initial main manifest parsing
	
	  var sourceDuration = playlist.sidx.duration; // Retain source timeline
	
	  var timeline = playlist.timeline || 0;
	  var sidxByteRange = playlist.sidx.byterange;
	  var sidxEnd = sidxByteRange.offset + sidxByteRange.length; // Retain timescale of the parsed sidx
	
	  var timescale = sidx.timescale; // referenceType 1 refers to other sidx boxes
	
	  var mediaReferences = sidx.references.filter(function (r) {
	    return r.referenceType !== 1;
	  });
	  var segments = [];
	  var type = playlist.endList ? 'static' : 'dynamic';
	  var periodStart = playlist.sidx.timeline;
	  var presentationTime = periodStart;
	  var number = playlist.mediaSequence || 0; // firstOffset is the offset from the end of the sidx box
	
	  var startIndex; // eslint-disable-next-line
	
	  if (typeof sidx.firstOffset === 'bigint') {
	    startIndex = window__default['default'].BigInt(sidxEnd) + sidx.firstOffset;
	  } else {
	    startIndex = sidxEnd + sidx.firstOffset;
	  }
	
	  for (var i = 0; i < mediaReferences.length; i++) {
	    var reference = sidx.references[i]; // size of the referenced (sub)segment
	
	    var size = reference.referencedSize; // duration of the referenced (sub)segment, in  the  timescale
	    // this will be converted to seconds when generating segments
	
	    var duration = reference.subsegmentDuration; // should be an inclusive range
	
	    var endIndex = void 0; // eslint-disable-next-line
	
	    if (typeof startIndex === 'bigint') {
	      endIndex = startIndex + window__default['default'].BigInt(size) - window__default['default'].BigInt(1);
	    } else {
	      endIndex = startIndex + size - 1;
	    }
	
	    var indexRange = startIndex + "-" + endIndex;
	    var attributes = {
	      baseUrl: baseUrl,
	      timescale: timescale,
	      timeline: timeline,
	      periodStart: periodStart,
	      presentationTime: presentationTime,
	      number: number,
	      duration: duration,
	      sourceDuration: sourceDuration,
	      indexRange: indexRange,
	      type: type
	    };
	    var segment = segmentsFromBase(attributes)[0];
	
	    if (initSegment) {
	      segment.map = initSegment;
	    }
	
	    segments.push(segment);
	
	    if (typeof startIndex === 'bigint') {
	      startIndex += window__default['default'].BigInt(size);
	    } else {
	      startIndex += size;
	    }
	
	    presentationTime += duration / timescale;
	    number++;
	  }
	
	  playlist.segments = segments;
	  return playlist;
	};
	
	var SUPPORTED_MEDIA_TYPES = ['AUDIO', 'SUBTITLES']; // allow one 60fps frame as leniency (arbitrarily chosen)
	
	var TIME_FUDGE = 1 / 60;
	/**
	 * Given a list of timelineStarts, combines, dedupes, and sorts them.
	 *
	 * @param {TimelineStart[]} timelineStarts - list of timeline starts
	 *
	 * @return {TimelineStart[]} the combined and deduped timeline starts
	 */
	
	var getUniqueTimelineStarts = function getUniqueTimelineStarts(timelineStarts) {
	  return union(timelineStarts, function (_ref) {
	    var timeline = _ref.timeline;
	    return timeline;
	  }).sort(function (a, b) {
	    return a.timeline > b.timeline ? 1 : -1;
	  });
	};
	/**
	 * Finds the playlist with the matching NAME attribute.
	 *
	 * @param {Array} playlists - playlists to search through
	 * @param {string} name - the NAME attribute to search for
	 *
	 * @return {Object|null} the matching playlist object, or null
	 */
	
	var findPlaylistWithName = function findPlaylistWithName(playlists, name) {
	  for (var i = 0; i < playlists.length; i++) {
	    if (playlists[i].attributes.NAME === name) {
	      return playlists[i];
	    }
	  }
	
	  return null;
	};
	/**
	 * Gets a flattened array of media group playlists.
	 *
	 * @param {Object} manifest - the main manifest object
	 *
	 * @return {Array} the media group playlists
	 */
	
	var getMediaGroupPlaylists = function getMediaGroupPlaylists(manifest) {
	  var mediaGroupPlaylists = [];
	  mediaGroups.forEachMediaGroup(manifest, SUPPORTED_MEDIA_TYPES, function (properties, type, group, label) {
	    mediaGroupPlaylists = mediaGroupPlaylists.concat(properties.playlists || []);
	  });
	  return mediaGroupPlaylists;
	};
	/**
	 * Updates the playlist's media sequence numbers.
	 *
	 * @param {Object} config - options object
	 * @param {Object} config.playlist - the playlist to update
	 * @param {number} config.mediaSequence - the mediaSequence number to start with
	 */
	
	var updateMediaSequenceForPlaylist = function updateMediaSequenceForPlaylist(_ref2) {
	  var playlist = _ref2.playlist,
	      mediaSequence = _ref2.mediaSequence;
	  playlist.mediaSequence = mediaSequence;
	  playlist.segments.forEach(function (segment, index) {
	    segment.number = playlist.mediaSequence + index;
	  });
	};
	/**
	 * Updates the media and discontinuity sequence numbers of newPlaylists given oldPlaylists
	 * and a complete list of timeline starts.
	 *
	 * If no matching playlist is found, only the discontinuity sequence number of the playlist
	 * will be updated.
	 *
	 * Since early available timelines are not supported, at least one segment must be present.
	 *
	 * @param {Object} config - options object
	 * @param {Object[]} oldPlaylists - the old playlists to use as a reference
	 * @param {Object[]} newPlaylists - the new playlists to update
	 * @param {Object} timelineStarts - all timelineStarts seen in the stream to this point
	 */
	
	var updateSequenceNumbers = function updateSequenceNumbers(_ref3) {
	  var oldPlaylists = _ref3.oldPlaylists,
	      newPlaylists = _ref3.newPlaylists,
	      timelineStarts = _ref3.timelineStarts;
	  newPlaylists.forEach(function (playlist) {
	    playlist.discontinuitySequence = findIndex(timelineStarts, function (_ref4) {
	      var timeline = _ref4.timeline;
	      return timeline === playlist.timeline;
	    }); // Playlists NAMEs come from DASH Representation IDs, which are mandatory
	    // (see ISO_23009-1-2012 5.3.5.2).
	    //
	    // If the same Representation existed in a prior Period, it will retain the same NAME.
	
	    var oldPlaylist = findPlaylistWithName(oldPlaylists, playlist.attributes.NAME);
	
	    if (!oldPlaylist) {
	      // Since this is a new playlist, the media sequence values can start from 0 without
	      // consequence.
	      return;
	    } // TODO better support for live SIDX
	    //
	    // As of this writing, mpd-parser does not support multiperiod SIDX (in live or VOD).
	    // This is evident by a playlist only having a single SIDX reference. In a multiperiod
	    // playlist there would need to be multiple SIDX references. In addition, live SIDX is
	    // not supported when the SIDX properties change on refreshes.
	    //
	    // In the future, if support needs to be added, the merging logic here can be called
	    // after SIDX references are resolved. For now, exit early to prevent exceptions being
	    // thrown due to undefined references.
	
	
	    if (playlist.sidx) {
	      return;
	    } // Since we don't yet support early available timelines, we don't need to support
	    // playlists with no segments.
	
	
	    var firstNewSegment = playlist.segments[0];
	    var oldMatchingSegmentIndex = findIndex(oldPlaylist.segments, function (oldSegment) {
	      return Math.abs(oldSegment.presentationTime - firstNewSegment.presentationTime) < TIME_FUDGE;
	    }); // No matching segment from the old playlist means the entire playlist was refreshed.
	    // In this case the media sequence should account for this update, and the new segments
	    // should be marked as discontinuous from the prior content, since the last prior
	    // timeline was removed.
	
	    if (oldMatchingSegmentIndex === -1) {
	      updateMediaSequenceForPlaylist({
	        playlist: playlist,
	        mediaSequence: oldPlaylist.mediaSequence + oldPlaylist.segments.length
	      });
	      playlist.segments[0].discontinuity = true;
	      playlist.discontinuityStarts.unshift(0); // No matching segment does not necessarily mean there's missing content.
	      //
	      // If the new playlist's timeline is the same as the last seen segment's timeline,
	      // then a discontinuity can be added to identify that there's potentially missing
	      // content. If there's no missing content, the discontinuity should still be rather
	      // harmless. It's possible that if segment durations are accurate enough, that the
	      // existence of a gap can be determined using the presentation times and durations,
	      // but if the segment timing info is off, it may introduce more problems than simply
	      // adding the discontinuity.
	      //
	      // If the new playlist's timeline is different from the last seen segment's timeline,
	      // then a discontinuity can be added to identify that this is the first seen segment
	      // of a new timeline. However, the logic at the start of this function that
	      // determined the disconinuity sequence by timeline index is now off by one (the
	      // discontinuity of the newest timeline hasn't yet fallen off the manifest...since
	      // we added it), so the disconinuity sequence must be decremented.
	      //
	      // A period may also have a duration of zero, so the case of no segments is handled
	      // here even though we don't yet support early available periods.
	
	      if (!oldPlaylist.segments.length && playlist.timeline > oldPlaylist.timeline || oldPlaylist.segments.length && playlist.timeline > oldPlaylist.segments[oldPlaylist.segments.length - 1].timeline) {
	        playlist.discontinuitySequence--;
	      }
	
	      return;
	    } // If the first segment matched with a prior segment on a discontinuity (it's matching
	    // on the first segment of a period), then the discontinuitySequence shouldn't be the
	    // timeline's matching one, but instead should be the one prior, and the first segment
	    // of the new manifest should be marked with a discontinuity.
	    //
	    // The reason for this special case is that discontinuity sequence shows how many
	    // discontinuities have fallen off of the playlist, and discontinuities are marked on
	    // the first segment of a new "timeline." Because of this, while DASH will retain that
	    // Period while the "timeline" exists, HLS keeps track of it via the discontinuity
	    // sequence, and that first segment is an indicator, but can be removed before that
	    // timeline is gone.
	
	
	    var oldMatchingSegment = oldPlaylist.segments[oldMatchingSegmentIndex];
	
	    if (oldMatchingSegment.discontinuity && !firstNewSegment.discontinuity) {
	      firstNewSegment.discontinuity = true;
	      playlist.discontinuityStarts.unshift(0);
	      playlist.discontinuitySequence--;
	    }
	
	    updateMediaSequenceForPlaylist({
	      playlist: playlist,
	      mediaSequence: oldPlaylist.segments[oldMatchingSegmentIndex].number
	    });
	  });
	};
	/**
	 * Given an old parsed manifest object and a new parsed manifest object, updates the
	 * sequence and timing values within the new manifest to ensure that it lines up with the
	 * old.
	 *
	 * @param {Array} oldManifest - the old main manifest object
	 * @param {Array} newManifest - the new main manifest object
	 *
	 * @return {Object} the updated new manifest object
	 */
	
	var positionManifestOnTimeline = function positionManifestOnTimeline(_ref5) {
	  var oldManifest = _ref5.oldManifest,
	      newManifest = _ref5.newManifest;
	  // Starting from v4.1.2 of the IOP, section 4.4.3.3 states:
	  //
	  // "MPD@availabilityStartTime and Period@start shall not be changed over MPD updates."
	  //
	  // This was added from https://github.com/Dash-Industry-Forum/DASH-IF-IOP/issues/160
	  //
	  // Because of this change, and the difficulty of supporting periods with changing start
	  // times, periods with changing start times are not supported. This makes the logic much
	  // simpler, since periods with the same start time can be considerred the same period
	  // across refreshes.
	  //
	  // To give an example as to the difficulty of handling periods where the start time may
	  // change, if a single period manifest is refreshed with another manifest with a single
	  // period, and both the start and end times are increased, then the only way to determine
	  // if it's a new period or an old one that has changed is to look through the segments of
	  // each playlist and determine the presentation time bounds to find a match. In addition,
	  // if the period start changed to exceed the old period end, then there would be no
	  // match, and it would not be possible to determine whether the refreshed period is a new
	  // one or the old one.
	  var oldPlaylists = oldManifest.playlists.concat(getMediaGroupPlaylists(oldManifest));
	  var newPlaylists = newManifest.playlists.concat(getMediaGroupPlaylists(newManifest)); // Save all seen timelineStarts to the new manifest. Although this potentially means that
	  // there's a "memory leak" in that it will never stop growing, in reality, only a couple
	  // of properties are saved for each seen Period. Even long running live streams won't
	  // generate too many Periods, unless the stream is watched for decades. In the future,
	  // this can be optimized by mapping to discontinuity sequence numbers for each timeline,
	  // but it may not become an issue, and the additional info can be useful for debugging.
	
	  newManifest.timelineStarts = getUniqueTimelineStarts([oldManifest.timelineStarts, newManifest.timelineStarts]);
	  updateSequenceNumbers({
	    oldPlaylists: oldPlaylists,
	    newPlaylists: newPlaylists,
	    timelineStarts: newManifest.timelineStarts
	  });
	  return newManifest;
	};
	
	var generateSidxKey = function generateSidxKey(sidx) {
	  return sidx && sidx.uri + '-' + byteRangeToString(sidx.byterange);
	};
	
	var mergeDiscontiguousPlaylists = function mergeDiscontiguousPlaylists(playlists) {
	  var mergedPlaylists = values(playlists.reduce(function (acc, playlist) {
	    // assuming playlist IDs are the same across periods
	    // TODO: handle multiperiod where representation sets are not the same
	    // across periods
	    var name = playlist.attributes.id + (playlist.attributes.lang || '');
	
	    if (!acc[name]) {
	      // First Period
	      acc[name] = playlist;
	      acc[name].attributes.timelineStarts = [];
	    } else {
	      // Subsequent Periods
	      if (playlist.segments) {
	        var _acc$name$segments;
	
	        // first segment of subsequent periods signal a discontinuity
	        if (playlist.segments[0]) {
	          playlist.segments[0].discontinuity = true;
	        }
	
	        (_acc$name$segments = acc[name].segments).push.apply(_acc$name$segments, playlist.segments);
	      } // bubble up contentProtection, this assumes all DRM content
	      // has the same contentProtection
	
	
	      if (playlist.attributes.contentProtection) {
	        acc[name].attributes.contentProtection = playlist.attributes.contentProtection;
	      }
	    }
	
	    acc[name].attributes.timelineStarts.push({
	      // Although they represent the same number, it's important to have both to make it
	      // compatible with HLS potentially having a similar attribute.
	      start: playlist.attributes.periodStart,
	      timeline: playlist.attributes.periodStart
	    });
	    return acc;
	  }, {}));
	  return mergedPlaylists.map(function (playlist) {
	    playlist.discontinuityStarts = findIndexes(playlist.segments || [], 'discontinuity');
	    return playlist;
	  });
	};
	
	var addSidxSegmentsToPlaylist = function addSidxSegmentsToPlaylist(playlist, sidxMapping) {
	  var sidxKey = generateSidxKey(playlist.sidx);
	  var sidxMatch = sidxKey && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx;
	
	  if (sidxMatch) {
	    addSidxSegmentsToPlaylist$1(playlist, sidxMatch, playlist.sidx.resolvedUri);
	  }
	
	  return playlist;
	};
	var addSidxSegmentsToPlaylists = function addSidxSegmentsToPlaylists(playlists, sidxMapping) {
	  if (sidxMapping === void 0) {
	    sidxMapping = {};
	  }
	
	  if (!Object.keys(sidxMapping).length) {
	    return playlists;
	  }
	
	  for (var i in playlists) {
	    playlists[i] = addSidxSegmentsToPlaylist(playlists[i], sidxMapping);
	  }
	
	  return playlists;
	};
	var formatAudioPlaylist = function formatAudioPlaylist(_ref, isAudioOnly) {
	  var _attributes;
	
	  var attributes = _ref.attributes,
	      segments = _ref.segments,
	      sidx = _ref.sidx,
	      mediaSequence = _ref.mediaSequence,
	      discontinuitySequence = _ref.discontinuitySequence,
	      discontinuityStarts = _ref.discontinuityStarts;
	  var playlist = {
	    attributes: (_attributes = {
	      NAME: attributes.id,
	      BANDWIDTH: attributes.bandwidth,
	      CODECS: attributes.codecs
	    }, _attributes['PROGRAM-ID'] = 1, _attributes),
	    uri: '',
	    endList: attributes.type === 'static',
	    timeline: attributes.periodStart,
	    resolvedUri: '',
	    targetDuration: attributes.duration,
	    discontinuitySequence: discontinuitySequence,
	    discontinuityStarts: discontinuityStarts,
	    timelineStarts: attributes.timelineStarts,
	    mediaSequence: mediaSequence,
	    segments: segments
	  };
	
	  if (attributes.contentProtection) {
	    playlist.contentProtection = attributes.contentProtection;
	  }
	
	  if (sidx) {
	    playlist.sidx = sidx;
	  }
	
	  if (isAudioOnly) {
	    playlist.attributes.AUDIO = 'audio';
	    playlist.attributes.SUBTITLES = 'subs';
	  }
	
	  return playlist;
	};
	var formatVttPlaylist = function formatVttPlaylist(_ref2) {
	  var _m3u8Attributes;
	
	  var attributes = _ref2.attributes,
	      segments = _ref2.segments,
	      mediaSequence = _ref2.mediaSequence,
	      discontinuityStarts = _ref2.discontinuityStarts,
	      discontinuitySequence = _ref2.discontinuitySequence;
	
	  if (typeof segments === 'undefined') {
	    // vtt tracks may use single file in BaseURL
	    segments = [{
	      uri: attributes.baseUrl,
	      timeline: attributes.periodStart,
	      resolvedUri: attributes.baseUrl || '',
	      duration: attributes.sourceDuration,
	      number: 0
	    }]; // targetDuration should be the same duration as the only segment
	
	    attributes.duration = attributes.sourceDuration;
	  }
	
	  var m3u8Attributes = (_m3u8Attributes = {
	    NAME: attributes.id,
	    BANDWIDTH: attributes.bandwidth
	  }, _m3u8Attributes['PROGRAM-ID'] = 1, _m3u8Attributes);
	
	  if (attributes.codecs) {
	    m3u8Attributes.CODECS = attributes.codecs;
	  }
	
	  return {
	    attributes: m3u8Attributes,
	    uri: '',
	    endList: attributes.type === 'static',
	    timeline: attributes.periodStart,
	    resolvedUri: attributes.baseUrl || '',
	    targetDuration: attributes.duration,
	    timelineStarts: attributes.timelineStarts,
	    discontinuityStarts: discontinuityStarts,
	    discontinuitySequence: discontinuitySequence,
	    mediaSequence: mediaSequence,
	    segments: segments
	  };
	};
	var organizeAudioPlaylists = function organizeAudioPlaylists(playlists, sidxMapping, isAudioOnly) {
	  if (sidxMapping === void 0) {
	    sidxMapping = {};
	  }
	
	  if (isAudioOnly === void 0) {
	    isAudioOnly = false;
	  }
	
	  var mainPlaylist;
	  var formattedPlaylists = playlists.reduce(function (a, playlist) {
	    var role = playlist.attributes.role && playlist.attributes.role.value || '';
	    var language = playlist.attributes.lang || '';
	    var label = playlist.attributes.label || 'main';
	
	    if (language && !playlist.attributes.label) {
	      var roleLabel = role ? " (" + role + ")" : '';
	      label = "" + playlist.attributes.lang + roleLabel;
	    }
	
	    if (!a[label]) {
	      a[label] = {
	        language: language,
	        autoselect: true,
	        default: role === 'main',
	        playlists: [],
	        uri: ''
	      };
	    }
	
	    var formatted = addSidxSegmentsToPlaylist(formatAudioPlaylist(playlist, isAudioOnly), sidxMapping);
	    a[label].playlists.push(formatted);
	
	    if (typeof mainPlaylist === 'undefined' && role === 'main') {
	      mainPlaylist = playlist;
	      mainPlaylist.default = true;
	    }
	
	    return a;
	  }, {}); // if no playlists have role "main", mark the first as main
	
	  if (!mainPlaylist) {
	    var firstLabel = Object.keys(formattedPlaylists)[0];
	    formattedPlaylists[firstLabel].default = true;
	  }
	
	  return formattedPlaylists;
	};
	var organizeVttPlaylists = function organizeVttPlaylists(playlists, sidxMapping) {
	  if (sidxMapping === void 0) {
	    sidxMapping = {};
	  }
	
	  return playlists.reduce(function (a, playlist) {
	    var label = playlist.attributes.lang || 'text';
	
	    if (!a[label]) {
	      a[label] = {
	        language: label,
	        default: false,
	        autoselect: false,
	        playlists: [],
	        uri: ''
	      };
	    }
	
	    a[label].playlists.push(addSidxSegmentsToPlaylist(formatVttPlaylist(playlist), sidxMapping));
	    return a;
	  }, {});
	};
	
	var organizeCaptionServices = function organizeCaptionServices(captionServices) {
	  return captionServices.reduce(function (svcObj, svc) {
	    if (!svc) {
	      return svcObj;
	    }
	
	    svc.forEach(function (service) {
	      var channel = service.channel,
	          language = service.language;
	      svcObj[language] = {
	        autoselect: false,
	        default: false,
	        instreamId: channel,
	        language: language
	      };
	
	      if (service.hasOwnProperty('aspectRatio')) {
	        svcObj[language].aspectRatio = service.aspectRatio;
	      }
	
	      if (service.hasOwnProperty('easyReader')) {
	        svcObj[language].easyReader = service.easyReader;
	      }
	
	      if (service.hasOwnProperty('3D')) {
	        svcObj[language]['3D'] = service['3D'];
	      }
	    });
	    return svcObj;
	  }, {});
	};
	
	var formatVideoPlaylist = function formatVideoPlaylist(_ref3) {
	  var _attributes2;
	
	  var attributes = _ref3.attributes,
	      segments = _ref3.segments,
	      sidx = _ref3.sidx,
	      discontinuityStarts = _ref3.discontinuityStarts;
	  var playlist = {
	    attributes: (_attributes2 = {
	      NAME: attributes.id,
	      AUDIO: 'audio',
	      SUBTITLES: 'subs',
	      RESOLUTION: {
	        width: attributes.width,
	        height: attributes.height
	      },
	      CODECS: attributes.codecs,
	      BANDWIDTH: attributes.bandwidth
	    }, _attributes2['PROGRAM-ID'] = 1, _attributes2),
	    uri: '',
	    endList: attributes.type === 'static',
	    timeline: attributes.periodStart,
	    resolvedUri: '',
	    targetDuration: attributes.duration,
	    discontinuityStarts: discontinuityStarts,
	    timelineStarts: attributes.timelineStarts,
	    segments: segments
	  };
	
	  if (attributes.frameRate) {
	    playlist.attributes['FRAME-RATE'] = attributes.frameRate;
	  }
	
	  if (attributes.contentProtection) {
	    playlist.contentProtection = attributes.contentProtection;
	  }
	
	  if (sidx) {
	    playlist.sidx = sidx;
	  }
	
	  return playlist;
	};
	
	var videoOnly = function videoOnly(_ref4) {
	  var attributes = _ref4.attributes;
	  return attributes.mimeType === 'video/mp4' || attributes.mimeType === 'video/webm' || attributes.contentType === 'video';
	};
	
	var audioOnly = function audioOnly(_ref5) {
	  var attributes = _ref5.attributes;
	  return attributes.mimeType === 'audio/mp4' || attributes.mimeType === 'audio/webm' || attributes.contentType === 'audio';
	};
	
	var vttOnly = function vttOnly(_ref6) {
	  var attributes = _ref6.attributes;
	  return attributes.mimeType === 'text/vtt' || attributes.contentType === 'text';
	};
	/**
	 * Contains start and timeline properties denoting a timeline start. For DASH, these will
	 * be the same number.
	 *
	 * @typedef {Object} TimelineStart
	 * @property {number} start - the start time of the timeline
	 * @property {number} timeline - the timeline number
	 */
	
	/**
	 * Adds appropriate media and discontinuity sequence values to the segments and playlists.
	 *
	 * Throughout mpd-parser, the `number` attribute is used in relation to `startNumber`, a
	 * DASH specific attribute used in constructing segment URI's from templates. However, from
	 * an HLS perspective, the `number` attribute on a segment would be its `mediaSequence`
	 * value, which should start at the original media sequence value (or 0) and increment by 1
	 * for each segment thereafter. Since DASH's `startNumber` values are independent per
	 * period, it doesn't make sense to use it for `number`. Instead, assume everything starts
	 * from a 0 mediaSequence value and increment from there.
	 *
	 * Note that VHS currently doesn't use the `number` property, but it can be helpful for
	 * debugging and making sense of the manifest.
	 *
	 * For live playlists, to account for values increasing in manifests when periods are
	 * removed on refreshes, merging logic should be used to update the numbers to their
	 * appropriate values (to ensure they're sequential and increasing).
	 *
	 * @param {Object[]} playlists - the playlists to update
	 * @param {TimelineStart[]} timelineStarts - the timeline starts for the manifest
	 */
	
	
	var addMediaSequenceValues = function addMediaSequenceValues(playlists, timelineStarts) {
	  // increment all segments sequentially
	  playlists.forEach(function (playlist) {
	    playlist.mediaSequence = 0;
	    playlist.discontinuitySequence = findIndex(timelineStarts, function (_ref7) {
	      var timeline = _ref7.timeline;
	      return timeline === playlist.timeline;
	    });
	
	    if (!playlist.segments) {
	      return;
	    }
	
	    playlist.segments.forEach(function (segment, index) {
	      segment.number = index;
	    });
	  });
	};
	/**
	 * Given a media group object, flattens all playlists within the media group into a single
	 * array.
	 *
	 * @param {Object} mediaGroupObject - the media group object
	 *
	 * @return {Object[]}
	 *         The media group playlists
	 */
	
	var flattenMediaGroupPlaylists = function flattenMediaGroupPlaylists(mediaGroupObject) {
	  if (!mediaGroupObject) {
	    return [];
	  }
	
	  return Object.keys(mediaGroupObject).reduce(function (acc, label) {
	    var labelContents = mediaGroupObject[label];
	    return acc.concat(labelContents.playlists);
	  }, []);
	};
	var toM3u8 = function toM3u8(_ref8) {
	  var _mediaGroups;
	
	  var dashPlaylists = _ref8.dashPlaylists,
	      locations = _ref8.locations,
	      _ref8$sidxMapping = _ref8.sidxMapping,
	      sidxMapping = _ref8$sidxMapping === void 0 ? {} : _ref8$sidxMapping,
	      previousManifest = _ref8.previousManifest;
	
	  if (!dashPlaylists.length) {
	    return {};
	  } // grab all main manifest attributes
	
	
	  var _dashPlaylists$0$attr = dashPlaylists[0].attributes,
	      duration = _dashPlaylists$0$attr.sourceDuration,
	      type = _dashPlaylists$0$attr.type,
	      suggestedPresentationDelay = _dashPlaylists$0$attr.suggestedPresentationDelay,
	      minimumUpdatePeriod = _dashPlaylists$0$attr.minimumUpdatePeriod;
	  var videoPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(videoOnly)).map(formatVideoPlaylist);
	  var audioPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(audioOnly));
	  var vttPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(vttOnly));
	  var captions = dashPlaylists.map(function (playlist) {
	    return playlist.attributes.captionServices;
	  }).filter(Boolean);
	  var manifest = {
	    allowCache: true,
	    discontinuityStarts: [],
	    segments: [],
	    endList: true,
	    mediaGroups: (_mediaGroups = {
	      AUDIO: {},
	      VIDEO: {}
	    }, _mediaGroups['CLOSED-CAPTIONS'] = {}, _mediaGroups.SUBTITLES = {}, _mediaGroups),
	    uri: '',
	    duration: duration,
	    playlists: addSidxSegmentsToPlaylists(videoPlaylists, sidxMapping)
	  };
	
	  if (minimumUpdatePeriod >= 0) {
	    manifest.minimumUpdatePeriod = minimumUpdatePeriod * 1000;
	  }
	
	  if (locations) {
	    manifest.locations = locations;
	  }
	
	  if (type === 'dynamic') {
	    manifest.suggestedPresentationDelay = suggestedPresentationDelay;
	  }
	
	  var isAudioOnly = manifest.playlists.length === 0;
	  var organizedAudioGroup = audioPlaylists.length ? organizeAudioPlaylists(audioPlaylists, sidxMapping, isAudioOnly) : null;
	  var organizedVttGroup = vttPlaylists.length ? organizeVttPlaylists(vttPlaylists, sidxMapping) : null;
	  var formattedPlaylists = videoPlaylists.concat(flattenMediaGroupPlaylists(organizedAudioGroup), flattenMediaGroupPlaylists(organizedVttGroup));
	  var playlistTimelineStarts = formattedPlaylists.map(function (_ref9) {
	    var timelineStarts = _ref9.timelineStarts;
	    return timelineStarts;
	  });
	  manifest.timelineStarts = getUniqueTimelineStarts(playlistTimelineStarts);
	  addMediaSequenceValues(formattedPlaylists, manifest.timelineStarts);
	
	  if (organizedAudioGroup) {
	    manifest.mediaGroups.AUDIO.audio = organizedAudioGroup;
	  }
	
	  if (organizedVttGroup) {
	    manifest.mediaGroups.SUBTITLES.subs = organizedVttGroup;
	  }
	
	  if (captions.length) {
	    manifest.mediaGroups['CLOSED-CAPTIONS'].cc = organizeCaptionServices(captions);
	  }
	
	  if (previousManifest) {
	    return positionManifestOnTimeline({
	      oldManifest: previousManifest,
	      newManifest: manifest
	    });
	  }
	
	  return manifest;
	};
	
	/**
	 * Calculates the R (repetition) value for a live stream (for the final segment
	 * in a manifest where the r value is negative 1)
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {number} time
	 *        current time (typically the total time up until the final segment)
	 * @param {number} duration
	 *        duration property for the given <S />
	 *
	 * @return {number}
	 *        R value to reach the end of the given period
	 */
	var getLiveRValue = function getLiveRValue(attributes, time, duration) {
	  var NOW = attributes.NOW,
	      clientOffset = attributes.clientOffset,
	      availabilityStartTime = attributes.availabilityStartTime,
	      _attributes$timescale = attributes.timescale,
	      timescale = _attributes$timescale === void 0 ? 1 : _attributes$timescale,
	      _attributes$periodSta = attributes.periodStart,
	      periodStart = _attributes$periodSta === void 0 ? 0 : _attributes$periodSta,
	      _attributes$minimumUp = attributes.minimumUpdatePeriod,
	      minimumUpdatePeriod = _attributes$minimumUp === void 0 ? 0 : _attributes$minimumUp;
	  var now = (NOW + clientOffset) / 1000;
	  var periodStartWC = availabilityStartTime + periodStart;
	  var periodEndWC = now + minimumUpdatePeriod;
	  var periodDuration = periodEndWC - periodStartWC;
	  return Math.ceil((periodDuration * timescale - time) / duration);
	};
	/**
	 * Uses information provided by SegmentTemplate.SegmentTimeline to determine segment
	 * timing and duration
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {Object[]} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *
	 * @return {{number: number, duration: number, time: number, timeline: number}[]}
	 *         List of Objects with segment timing and duration info
	 */
	
	
	var parseByTimeline = function parseByTimeline(attributes, segmentTimeline) {
	  var type = attributes.type,
	      _attributes$minimumUp2 = attributes.minimumUpdatePeriod,
	      minimumUpdatePeriod = _attributes$minimumUp2 === void 0 ? 0 : _attributes$minimumUp2,
	      _attributes$media = attributes.media,
	      media = _attributes$media === void 0 ? '' : _attributes$media,
	      sourceDuration = attributes.sourceDuration,
	      _attributes$timescale2 = attributes.timescale,
	      timescale = _attributes$timescale2 === void 0 ? 1 : _attributes$timescale2,
	      _attributes$startNumb = attributes.startNumber,
	      startNumber = _attributes$startNumb === void 0 ? 1 : _attributes$startNumb,
	      timeline = attributes.periodStart;
	  var segments = [];
	  var time = -1;
	
	  for (var sIndex = 0; sIndex < segmentTimeline.length; sIndex++) {
	    var S = segmentTimeline[sIndex];
	    var duration = S.d;
	    var repeat = S.r || 0;
	    var segmentTime = S.t || 0;
	
	    if (time < 0) {
	      // first segment
	      time = segmentTime;
	    }
	
	    if (segmentTime && segmentTime > time) {
	      // discontinuity
	      // TODO: How to handle this type of discontinuity
	      // timeline++ here would treat it like HLS discontuity and content would
	      // get appended without gap
	      // E.G.
	      //  <S t="0" d="1" />
	      //  <S d="1" />
	      //  <S d="1" />
	      //  <S t="5" d="1" />
	      // would have $Time$ values of [0, 1, 2, 5]
	      // should this be appened at time positions [0, 1, 2, 3],(#EXT-X-DISCONTINUITY)
	      // or [0, 1, 2, gap, gap, 5]? (#EXT-X-GAP)
	      // does the value of sourceDuration consider this when calculating arbitrary
	      // negative @r repeat value?
	      // E.G. Same elements as above with this added at the end
	      //  <S d="1" r="-1" />
	      //  with a sourceDuration of 10
	      // Would the 2 gaps be included in the time duration calculations resulting in
	      // 8 segments with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9] or 10 segments
	      // with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9, 10, 11] ?
	      time = segmentTime;
	    }
	
	    var count = void 0;
	
	    if (repeat < 0) {
	      var nextS = sIndex + 1;
	
	      if (nextS === segmentTimeline.length) {
	        // last segment
	        if (type === 'dynamic' && minimumUpdatePeriod > 0 && media.indexOf('$Number$') > 0) {
	          count = getLiveRValue(attributes, time, duration);
	        } else {
	          // TODO: This may be incorrect depending on conclusion of TODO above
	          count = (sourceDuration * timescale - time) / duration;
	        }
	      } else {
	        count = (segmentTimeline[nextS].t - time) / duration;
	      }
	    } else {
	      count = repeat + 1;
	    }
	
	    var end = startNumber + segments.length + count;
	    var number = startNumber + segments.length;
	
	    while (number < end) {
	      segments.push({
	        number: number,
	        duration: duration / timescale,
	        time: time,
	        timeline: timeline
	      });
	      time += duration;
	      number++;
	    }
	  }
	
	  return segments;
	};
	
	var identifierPattern = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g;
	/**
	 * Replaces template identifiers with corresponding values. To be used as the callback
	 * for String.prototype.replace
	 *
	 * @name replaceCallback
	 * @function
	 * @param {string} match
	 *        Entire match of identifier
	 * @param {string} identifier
	 *        Name of matched identifier
	 * @param {string} format
	 *        Format tag string. Its presence indicates that padding is expected
	 * @param {string} width
	 *        Desired length of the replaced value. Values less than this width shall be left
	 *        zero padded
	 * @return {string}
	 *         Replacement for the matched identifier
	 */
	
	/**
	 * Returns a function to be used as a callback for String.prototype.replace to replace
	 * template identifiers
	 *
	 * @param {Obect} values
	 *        Object containing values that shall be used to replace known identifiers
	 * @param {number} values.RepresentationID
	 *        Value of the Representation@id attribute
	 * @param {number} values.Number
	 *        Number of the corresponding segment
	 * @param {number} values.Bandwidth
	 *        Value of the Representation@bandwidth attribute.
	 * @param {number} values.Time
	 *        Timestamp value of the corresponding segment
	 * @return {replaceCallback}
	 *         Callback to be used with String.prototype.replace to replace identifiers
	 */
	
	var identifierReplacement = function identifierReplacement(values) {
	  return function (match, identifier, format, width) {
	    if (match === '$$') {
	      // escape sequence
	      return '$';
	    }
	
	    if (typeof values[identifier] === 'undefined') {
	      return match;
	    }
	
	    var value = '' + values[identifier];
	
	    if (identifier === 'RepresentationID') {
	      // Format tag shall not be present with RepresentationID
	      return value;
	    }
	
	    if (!format) {
	      width = 1;
	    } else {
	      width = parseInt(width, 10);
	    }
	
	    if (value.length >= width) {
	      return value;
	    }
	
	    return "" + new Array(width - value.length + 1).join('0') + value;
	  };
	};
	/**
	 * Constructs a segment url from a template string
	 *
	 * @param {string} url
	 *        Template string to construct url from
	 * @param {Obect} values
	 *        Object containing values that shall be used to replace known identifiers
	 * @param {number} values.RepresentationID
	 *        Value of the Representation@id attribute
	 * @param {number} values.Number
	 *        Number of the corresponding segment
	 * @param {number} values.Bandwidth
	 *        Value of the Representation@bandwidth attribute.
	 * @param {number} values.Time
	 *        Timestamp value of the corresponding segment
	 * @return {string}
	 *         Segment url with identifiers replaced
	 */
	
	var constructTemplateUrl = function constructTemplateUrl(url, values) {
	  return url.replace(identifierPattern, identifierReplacement(values));
	};
	/**
	 * Generates a list of objects containing timing and duration information about each
	 * segment needed to generate segment uris and the complete segment object
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {Object[]|undefined} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *        the SegmentTimeline element
	 * @return {{number: number, duration: number, time: number, timeline: number}[]}
	 *         List of Objects with segment timing and duration info
	 */
	
	var parseTemplateInfo = function parseTemplateInfo(attributes, segmentTimeline) {
	  if (!attributes.duration && !segmentTimeline) {
	    // if neither @duration or SegmentTimeline are present, then there shall be exactly
	    // one media segment
	    return [{
	      number: attributes.startNumber || 1,
	      duration: attributes.sourceDuration,
	      time: 0,
	      timeline: attributes.periodStart
	    }];
	  }
	
	  if (attributes.duration) {
	    return parseByDuration(attributes);
	  }
	
	  return parseByTimeline(attributes, segmentTimeline);
	};
	/**
	 * Generates a list of segments using information provided by the SegmentTemplate element
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {Object[]|undefined} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *        the SegmentTimeline element
	 * @return {Object[]}
	 *         List of segment objects
	 */
	
	var segmentsFromTemplate = function segmentsFromTemplate(attributes, segmentTimeline) {
	  var templateValues = {
	    RepresentationID: attributes.id,
	    Bandwidth: attributes.bandwidth || 0
	  };
	  var _attributes$initializ = attributes.initialization,
	      initialization = _attributes$initializ === void 0 ? {
	    sourceURL: '',
	    range: ''
	  } : _attributes$initializ;
	  var mapSegment = urlTypeToSegment({
	    baseUrl: attributes.baseUrl,
	    source: constructTemplateUrl(initialization.sourceURL, templateValues),
	    range: initialization.range
	  });
	  var segments = parseTemplateInfo(attributes, segmentTimeline);
	  return segments.map(function (segment) {
	    templateValues.Number = segment.number;
	    templateValues.Time = segment.time;
	    var uri = constructTemplateUrl(attributes.media || '', templateValues); // See DASH spec section 5.3.9.2.2
	    // - if timescale isn't present on any level, default to 1.
	
	    var timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0
	
	    var presentationTimeOffset = attributes.presentationTimeOffset || 0;
	    var presentationTime = // Even if the @t attribute is not specified for the segment, segment.time is
	    // calculated in mpd-parser prior to this, so it's assumed to be available.
	    attributes.periodStart + (segment.time - presentationTimeOffset) / timescale;
	    var map = {
	      uri: uri,
	      timeline: segment.timeline,
	      duration: segment.duration,
	      resolvedUri: resolveUrl__default['default'](attributes.baseUrl || '', uri),
	      map: mapSegment,
	      number: segment.number,
	      presentationTime: presentationTime
	    };
	    return map;
	  });
	};
	
	/**
	 * Converts a <SegmentUrl> (of type URLType from the DASH spec 5.3.9.2 Table 14)
	 * to an object that matches the output of a segment in videojs/mpd-parser
	 *
	 * @param {Object} attributes
	 *   Object containing all inherited attributes from parent elements with attribute
	 *   names as keys
	 * @param {Object} segmentUrl
	 *   <SegmentURL> node to translate into a segment object
	 * @return {Object} translated segment object
	 */
	
	var SegmentURLToSegmentObject = function SegmentURLToSegmentObject(attributes, segmentUrl) {
	  var baseUrl = attributes.baseUrl,
	      _attributes$initializ = attributes.initialization,
	      initialization = _attributes$initializ === void 0 ? {} : _attributes$initializ;
	  var initSegment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: initialization.sourceURL,
	    range: initialization.range
	  });
	  var segment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: segmentUrl.media,
	    range: segmentUrl.mediaRange
	  });
	  segment.map = initSegment;
	  return segment;
	};
	/**
	 * Generates a list of segments using information provided by the SegmentList element
	 * SegmentList (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
	 * node should be translated into segment.
	 *
	 * @param {Object} attributes
	 *   Object containing all inherited attributes from parent elements with attribute
	 *   names as keys
	 * @param {Object[]|undefined} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *        the SegmentTimeline element
	 * @return {Object.<Array>} list of segments
	 */
	
	
	var segmentsFromList = function segmentsFromList(attributes, segmentTimeline) {
	  var duration = attributes.duration,
	      _attributes$segmentUr = attributes.segmentUrls,
	      segmentUrls = _attributes$segmentUr === void 0 ? [] : _attributes$segmentUr,
	      periodStart = attributes.periodStart; // Per spec (5.3.9.2.1) no way to determine segment duration OR
	  // if both SegmentTimeline and @duration are defined, it is outside of spec.
	
	  if (!duration && !segmentTimeline || duration && segmentTimeline) {
	    throw new Error(errors.SEGMENT_TIME_UNSPECIFIED);
	  }
	
	  var segmentUrlMap = segmentUrls.map(function (segmentUrlObject) {
	    return SegmentURLToSegmentObject(attributes, segmentUrlObject);
	  });
	  var segmentTimeInfo;
	
	  if (duration) {
	    segmentTimeInfo = parseByDuration(attributes);
	  }
	
	  if (segmentTimeline) {
	    segmentTimeInfo = parseByTimeline(attributes, segmentTimeline);
	  }
	
	  var segments = segmentTimeInfo.map(function (segmentTime, index) {
	    if (segmentUrlMap[index]) {
	      var segment = segmentUrlMap[index]; // See DASH spec section 5.3.9.2.2
	      // - if timescale isn't present on any level, default to 1.
	
	      var timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0
	
	      var presentationTimeOffset = attributes.presentationTimeOffset || 0;
	      segment.timeline = segmentTime.timeline;
	      segment.duration = segmentTime.duration;
	      segment.number = segmentTime.number;
	      segment.presentationTime = periodStart + (segmentTime.time - presentationTimeOffset) / timescale;
	      return segment;
	    } // Since we're mapping we should get rid of any blank segments (in case
	    // the given SegmentTimeline is handling for more elements than we have
	    // SegmentURLs for).
	
	  }).filter(function (segment) {
	    return segment;
	  });
	  return segments;
	};
	
	var generateSegments = function generateSegments(_ref) {
	  var attributes = _ref.attributes,
	      segmentInfo = _ref.segmentInfo;
	  var segmentAttributes;
	  var segmentsFn;
	
	  if (segmentInfo.template) {
	    segmentsFn = segmentsFromTemplate;
	    segmentAttributes = merge(attributes, segmentInfo.template);
	  } else if (segmentInfo.base) {
	    segmentsFn = segmentsFromBase;
	    segmentAttributes = merge(attributes, segmentInfo.base);
	  } else if (segmentInfo.list) {
	    segmentsFn = segmentsFromList;
	    segmentAttributes = merge(attributes, segmentInfo.list);
	  }
	
	  var segmentsInfo = {
	    attributes: attributes
	  };
	
	  if (!segmentsFn) {
	    return segmentsInfo;
	  }
	
	  var segments = segmentsFn(segmentAttributes, segmentInfo.segmentTimeline); // The @duration attribute will be used to determin the playlist's targetDuration which
	  // must be in seconds. Since we've generated the segment list, we no longer need
	  // @duration to be in @timescale units, so we can convert it here.
	
	  if (segmentAttributes.duration) {
	    var _segmentAttributes = segmentAttributes,
	        duration = _segmentAttributes.duration,
	        _segmentAttributes$ti = _segmentAttributes.timescale,
	        timescale = _segmentAttributes$ti === void 0 ? 1 : _segmentAttributes$ti;
	    segmentAttributes.duration = duration / timescale;
	  } else if (segments.length) {
	    // if there is no @duration attribute, use the largest segment duration as
	    // as target duration
	    segmentAttributes.duration = segments.reduce(function (max, segment) {
	      return Math.max(max, Math.ceil(segment.duration));
	    }, 0);
	  } else {
	    segmentAttributes.duration = 0;
	  }
	
	  segmentsInfo.attributes = segmentAttributes;
	  segmentsInfo.segments = segments; // This is a sidx box without actual segment information
	
	  if (segmentInfo.base && segmentAttributes.indexRange) {
	    segmentsInfo.sidx = segments[0];
	    segmentsInfo.segments = [];
	  }
	
	  return segmentsInfo;
	};
	var toPlaylists = function toPlaylists(representations) {
	  return representations.map(generateSegments);
	};
	
	var findChildren = function findChildren(element, name) {
	  return from(element.childNodes).filter(function (_ref) {
	    var tagName = _ref.tagName;
	    return tagName === name;
	  });
	};
	var getContent = function getContent(element) {
	  return element.textContent.trim();
	};
	
	/**
	 * Converts the provided string that may contain a division operation to a number.
	 *
	 * @param {string} value - the provided string value
	 *
	 * @return {number} the parsed string value
	 */
	var parseDivisionValue = function parseDivisionValue(value) {
	  return parseFloat(value.split('/').reduce(function (prev, current) {
	    return prev / current;
	  }));
	};
	
	var parseDuration = function parseDuration(str) {
	  var SECONDS_IN_YEAR = 365 * 24 * 60 * 60;
	  var SECONDS_IN_MONTH = 30 * 24 * 60 * 60;
	  var SECONDS_IN_DAY = 24 * 60 * 60;
	  var SECONDS_IN_HOUR = 60 * 60;
	  var SECONDS_IN_MIN = 60; // P10Y10M10DT10H10M10.1S
	
	  var durationRegex = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/;
	  var match = durationRegex.exec(str);
	
	  if (!match) {
	    return 0;
	  }
	
	  var _match$slice = match.slice(1),
	      year = _match$slice[0],
	      month = _match$slice[1],
	      day = _match$slice[2],
	      hour = _match$slice[3],
	      minute = _match$slice[4],
	      second = _match$slice[5];
	
	  return parseFloat(year || 0) * SECONDS_IN_YEAR + parseFloat(month || 0) * SECONDS_IN_MONTH + parseFloat(day || 0) * SECONDS_IN_DAY + parseFloat(hour || 0) * SECONDS_IN_HOUR + parseFloat(minute || 0) * SECONDS_IN_MIN + parseFloat(second || 0);
	};
	var parseDate = function parseDate(str) {
	  // Date format without timezone according to ISO 8601
	  // YYY-MM-DDThh:mm:ss.ssssss
	  var dateRegex = /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/; // If the date string does not specifiy a timezone, we must specifiy UTC. This is
	  // expressed by ending with 'Z'
	
	  if (dateRegex.test(str)) {
	    str += 'Z';
	  }
	
	  return Date.parse(str);
	};
	
	var parsers = {
	  /**
	   * Specifies the duration of the entire Media Presentation. Format is a duration string
	   * as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  mediaPresentationDuration: function mediaPresentationDuration(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * Specifies the Segment availability start time for all Segments referred to in this
	   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
	   * time. Format is a date string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The date as seconds from unix epoch
	   */
	  availabilityStartTime: function availabilityStartTime(value) {
	    return parseDate(value) / 1000;
	  },
	
	  /**
	   * Specifies the smallest period between potential changes to the MPD. Format is a
	   * duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  minimumUpdatePeriod: function minimumUpdatePeriod(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * Specifies the suggested presentation delay. Format is a
	   * duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  suggestedPresentationDelay: function suggestedPresentationDelay(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * specifices the type of mpd. Can be either "static" or "dynamic"
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   *
	   * @return {string}
	   *         The type as a string
	   */
	  type: function type(value) {
	    return value;
	  },
	
	  /**
	   * Specifies the duration of the smallest time shifting buffer for any Representation
	   * in the MPD. Format is a duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  timeShiftBufferDepth: function timeShiftBufferDepth(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
	   * Format is a duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  start: function start(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * Specifies the width of the visual presentation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed width
	   */
	  width: function width(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the height of the visual presentation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed height
	   */
	  height: function height(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the bitrate of the representation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed bandwidth
	   */
	  bandwidth: function bandwidth(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the frame rate of the representation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed frame rate
	   */
	  frameRate: function frameRate(value) {
	    return parseDivisionValue(value);
	  },
	
	  /**
	   * Specifies the number of the first Media Segment in this Representation in the Period
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed number
	   */
	  startNumber: function startNumber(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the timescale in units per seconds
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed timescale
	   */
	  timescale: function timescale(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the presentationTimeOffset.
	   *
	   * @param {string} value
	   *        value of the attribute as a string
	   *
	   * @return {number}
	   *         The parsed presentationTimeOffset
	   */
	  presentationTimeOffset: function presentationTimeOffset(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the constant approximate Segment duration
	   * NOTE: The <Period> element also contains an @duration attribute. This duration
	   *       specifies the duration of the Period. This attribute is currently not
	   *       supported by the rest of the parser, however we still check for it to prevent
	   *       errors.
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed duration
	   */
	  duration: function duration(value) {
	    var parsedValue = parseInt(value, 10);
	
	    if (isNaN(parsedValue)) {
	      return parseDuration(value);
	    }
	
	    return parsedValue;
	  },
	
	  /**
	   * Specifies the Segment duration, in units of the value of the @timescale.
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed duration
	   */
	  d: function d(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the MPD start time, in @timescale units, the first Segment in the series
	   * starts relative to the beginning of the Period
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed time
	   */
	  t: function t(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the repeat count of the number of following contiguous Segments with the
	   * same duration expressed by the value of @d
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed number
	   */
	  r: function r(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Default parser for all other attributes. Acts as a no-op and just returns the value
	   * as a string
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {string}
	   *         Unparsed value
	   */
	  DEFAULT: function DEFAULT(value) {
	    return value;
	  }
	};
	/**
	 * Gets all the attributes and values of the provided node, parses attributes with known
	 * types, and returns an object with attribute names mapped to values.
	 *
	 * @param {Node} el
	 *        The node to parse attributes from
	 * @return {Object}
	 *         Object with all attributes of el parsed
	 */
	
	var parseAttributes = function parseAttributes(el) {
	  if (!(el && el.attributes)) {
	    return {};
	  }
	
	  return from(el.attributes).reduce(function (a, e) {
	    var parseFn = parsers[e.name] || parsers.DEFAULT;
	    a[e.name] = parseFn(e.value);
	    return a;
	  }, {});
	};
	
	var keySystemsMap = {
	  'urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b': 'org.w3.clearkey',
	  'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed': 'com.widevine.alpha',
	  'urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95': 'com.microsoft.playready',
	  'urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb': 'com.adobe.primetime'
	};
	/**
	 * Builds a list of urls that is the product of the reference urls and BaseURL values
	 *
	 * @param {string[]} referenceUrls
	 *        List of reference urls to resolve to
	 * @param {Node[]} baseUrlElements
	 *        List of BaseURL nodes from the mpd
	 * @return {string[]}
	 *         List of resolved urls
	 */
	
	var buildBaseUrls = function buildBaseUrls(referenceUrls, baseUrlElements) {
	  if (!baseUrlElements.length) {
	    return referenceUrls;
	  }
	
	  return flatten(referenceUrls.map(function (reference) {
	    return baseUrlElements.map(function (baseUrlElement) {
	      return resolveUrl__default['default'](reference, getContent(baseUrlElement));
	    });
	  }));
	};
	/**
	 * Contains all Segment information for its containing AdaptationSet
	 *
	 * @typedef {Object} SegmentInformation
	 * @property {Object|undefined} template
	 *           Contains the attributes for the SegmentTemplate node
	 * @property {Object[]|undefined} segmentTimeline
	 *           Contains a list of atrributes for each S node within the SegmentTimeline node
	 * @property {Object|undefined} list
	 *           Contains the attributes for the SegmentList node
	 * @property {Object|undefined} base
	 *           Contains the attributes for the SegmentBase node
	 */
	
	/**
	 * Returns all available Segment information contained within the AdaptationSet node
	 *
	 * @param {Node} adaptationSet
	 *        The AdaptationSet node to get Segment information from
	 * @return {SegmentInformation}
	 *         The Segment information contained within the provided AdaptationSet
	 */
	
	var getSegmentInformation = function getSegmentInformation(adaptationSet) {
	  var segmentTemplate = findChildren(adaptationSet, 'SegmentTemplate')[0];
	  var segmentList = findChildren(adaptationSet, 'SegmentList')[0];
	  var segmentUrls = segmentList && findChildren(segmentList, 'SegmentURL').map(function (s) {
	    return merge({
	      tag: 'SegmentURL'
	    }, parseAttributes(s));
	  });
	  var segmentBase = findChildren(adaptationSet, 'SegmentBase')[0];
	  var segmentTimelineParentNode = segmentList || segmentTemplate;
	  var segmentTimeline = segmentTimelineParentNode && findChildren(segmentTimelineParentNode, 'SegmentTimeline')[0];
	  var segmentInitializationParentNode = segmentList || segmentBase || segmentTemplate;
	  var segmentInitialization = segmentInitializationParentNode && findChildren(segmentInitializationParentNode, 'Initialization')[0]; // SegmentTemplate is handled slightly differently, since it can have both
	  // @initialization and an <Initialization> node.  @initialization can be templated,
	  // while the node can have a url and range specified.  If the <SegmentTemplate> has
	  // both @initialization and an <Initialization> subelement we opt to override with
	  // the node, as this interaction is not defined in the spec.
	
	  var template = segmentTemplate && parseAttributes(segmentTemplate);
	
	  if (template && segmentInitialization) {
	    template.initialization = segmentInitialization && parseAttributes(segmentInitialization);
	  } else if (template && template.initialization) {
	    // If it is @initialization we convert it to an object since this is the format that
	    // later functions will rely on for the initialization segment.  This is only valid
	    // for <SegmentTemplate>
	    template.initialization = {
	      sourceURL: template.initialization
	    };
	  }
	
	  var segmentInfo = {
	    template: template,
	    segmentTimeline: segmentTimeline && findChildren(segmentTimeline, 'S').map(function (s) {
	      return parseAttributes(s);
	    }),
	    list: segmentList && merge(parseAttributes(segmentList), {
	      segmentUrls: segmentUrls,
	      initialization: parseAttributes(segmentInitialization)
	    }),
	    base: segmentBase && merge(parseAttributes(segmentBase), {
	      initialization: parseAttributes(segmentInitialization)
	    })
	  };
	  Object.keys(segmentInfo).forEach(function (key) {
	    if (!segmentInfo[key]) {
	      delete segmentInfo[key];
	    }
	  });
	  return segmentInfo;
	};
	/**
	 * Contains Segment information and attributes needed to construct a Playlist object
	 * from a Representation
	 *
	 * @typedef {Object} RepresentationInformation
	 * @property {SegmentInformation} segmentInfo
	 *           Segment information for this Representation
	 * @property {Object} attributes
	 *           Inherited attributes for this Representation
	 */
	
	/**
	 * Maps a Representation node to an object containing Segment information and attributes
	 *
	 * @name inheritBaseUrlsCallback
	 * @function
	 * @param {Node} representation
	 *        Representation node from the mpd
	 * @return {RepresentationInformation}
	 *         Representation information needed to construct a Playlist object
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping Representation nodes to
	 * Segment information and attributes using inherited BaseURL nodes.
	 *
	 * @param {Object} adaptationSetAttributes
	 *        Contains attributes inherited by the AdaptationSet
	 * @param {string[]} adaptationSetBaseUrls
	 *        Contains list of resolved base urls inherited by the AdaptationSet
	 * @param {SegmentInformation} adaptationSetSegmentInfo
	 *        Contains Segment information for the AdaptationSet
	 * @return {inheritBaseUrlsCallback}
	 *         Callback map function
	 */
	
	var inheritBaseUrls = function inheritBaseUrls(adaptationSetAttributes, adaptationSetBaseUrls, adaptationSetSegmentInfo) {
	  return function (representation) {
	    var repBaseUrlElements = findChildren(representation, 'BaseURL');
	    var repBaseUrls = buildBaseUrls(adaptationSetBaseUrls, repBaseUrlElements);
	    var attributes = merge(adaptationSetAttributes, parseAttributes(representation));
	    var representationSegmentInfo = getSegmentInformation(representation);
	    return repBaseUrls.map(function (baseUrl) {
	      return {
	        segmentInfo: merge(adaptationSetSegmentInfo, representationSegmentInfo),
	        attributes: merge(attributes, {
	          baseUrl: baseUrl
	        })
	      };
	    });
	  };
	};
	/**
	 * Tranforms a series of content protection nodes to
	 * an object containing pssh data by key system
	 *
	 * @param {Node[]} contentProtectionNodes
	 *        Content protection nodes
	 * @return {Object}
	 *        Object containing pssh data by key system
	 */
	
	var generateKeySystemInformation = function generateKeySystemInformation(contentProtectionNodes) {
	  return contentProtectionNodes.reduce(function (acc, node) {
	    var attributes = parseAttributes(node); // Although it could be argued that according to the UUID RFC spec the UUID string (a-f chars) should be generated
	    // as a lowercase string it also mentions it should be treated as case-insensitive on input. Since the key system
	    // UUIDs in the keySystemsMap are hardcoded as lowercase in the codebase there isn't any reason not to do
	    // .toLowerCase() on the input UUID string from the manifest (at least I could not think of one).
	
	    if (attributes.schemeIdUri) {
	      attributes.schemeIdUri = attributes.schemeIdUri.toLowerCase();
	    }
	
	    var keySystem = keySystemsMap[attributes.schemeIdUri];
	
	    if (keySystem) {
	      acc[keySystem] = {
	        attributes: attributes
	      };
	      var psshNode = findChildren(node, 'cenc:pssh')[0];
	
	      if (psshNode) {
	        var pssh = getContent(psshNode);
	        acc[keySystem].pssh = pssh && decodeB64ToUint8Array__default['default'](pssh);
	      }
	    }
	
	    return acc;
	  }, {});
	}; // defined in ANSI_SCTE 214-1 2016
	
	
	var parseCaptionServiceMetadata = function parseCaptionServiceMetadata(service) {
	  // 608 captions
	  if (service.schemeIdUri === 'urn:scte:dash:cc:cea-608:2015') {
	    var values = typeof service.value !== 'string' ? [] : service.value.split(';');
	    return values.map(function (value) {
	      var channel;
	      var language; // default language to value
	
	      language = value;
	
	      if (/^CC\d=/.test(value)) {
	        var _value$split = value.split('=');
	
	        channel = _value$split[0];
	        language = _value$split[1];
	      } else if (/^CC\d$/.test(value)) {
	        channel = value;
	      }
	
	      return {
	        channel: channel,
	        language: language
	      };
	    });
	  } else if (service.schemeIdUri === 'urn:scte:dash:cc:cea-708:2015') {
	    var _values = typeof service.value !== 'string' ? [] : service.value.split(';');
	
	    return _values.map(function (value) {
	      var flags = {
	        // service or channel number 1-63
	        'channel': undefined,
	        // language is a 3ALPHA per ISO 639.2/B
	        // field is required
	        'language': undefined,
	        // BIT 1/0 or ?
	        // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
	        'aspectRatio': 1,
	        // BIT 1/0
	        // easy reader flag indicated the text is tailed to the needs of beginning readers
	        // default 0, or off
	        'easyReader': 0,
	        // BIT 1/0
	        // If 3d metadata is present (CEA-708.1) then 1
	        // default 0
	        '3D': 0
	      };
	
	      if (/=/.test(value)) {
	        var _value$split2 = value.split('='),
	            channel = _value$split2[0],
	            _value$split2$ = _value$split2[1],
	            opts = _value$split2$ === void 0 ? '' : _value$split2$;
	
	        flags.channel = channel;
	        flags.language = value;
	        opts.split(',').forEach(function (opt) {
	          var _opt$split = opt.split(':'),
	              name = _opt$split[0],
	              val = _opt$split[1];
	
	          if (name === 'lang') {
	            flags.language = val; // er for easyReadery
	          } else if (name === 'er') {
	            flags.easyReader = Number(val); // war for wide aspect ratio
	          } else if (name === 'war') {
	            flags.aspectRatio = Number(val);
	          } else if (name === '3D') {
	            flags['3D'] = Number(val);
	          }
	        });
	      } else {
	        flags.language = value;
	      }
	
	      if (flags.channel) {
	        flags.channel = 'SERVICE' + flags.channel;
	      }
	
	      return flags;
	    });
	  }
	};
	/**
	 * Maps an AdaptationSet node to a list of Representation information objects
	 *
	 * @name toRepresentationsCallback
	 * @function
	 * @param {Node} adaptationSet
	 *        AdaptationSet node from the mpd
	 * @return {RepresentationInformation[]}
	 *         List of objects containing Representaion information
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping AdaptationSet nodes to a list of
	 * Representation information objects
	 *
	 * @param {Object} periodAttributes
	 *        Contains attributes inherited by the Period
	 * @param {string[]} periodBaseUrls
	 *        Contains list of resolved base urls inherited by the Period
	 * @param {string[]} periodSegmentInfo
	 *        Contains Segment Information at the period level
	 * @return {toRepresentationsCallback}
	 *         Callback map function
	 */
	
	var toRepresentations = function toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo) {
	  return function (adaptationSet) {
	    var adaptationSetAttributes = parseAttributes(adaptationSet);
	    var adaptationSetBaseUrls = buildBaseUrls(periodBaseUrls, findChildren(adaptationSet, 'BaseURL'));
	    var role = findChildren(adaptationSet, 'Role')[0];
	    var roleAttributes = {
	      role: parseAttributes(role)
	    };
	    var attrs = merge(periodAttributes, adaptationSetAttributes, roleAttributes);
	    var accessibility = findChildren(adaptationSet, 'Accessibility')[0];
	    var captionServices = parseCaptionServiceMetadata(parseAttributes(accessibility));
	
	    if (captionServices) {
	      attrs = merge(attrs, {
	        captionServices: captionServices
	      });
	    }
	
	    var label = findChildren(adaptationSet, 'Label')[0];
	
	    if (label && label.childNodes.length) {
	      var labelVal = label.childNodes[0].nodeValue.trim();
	      attrs = merge(attrs, {
	        label: labelVal
	      });
	    }
	
	    var contentProtection = generateKeySystemInformation(findChildren(adaptationSet, 'ContentProtection'));
	
	    if (Object.keys(contentProtection).length) {
	      attrs = merge(attrs, {
	        contentProtection: contentProtection
	      });
	    }
	
	    var segmentInfo = getSegmentInformation(adaptationSet);
	    var representations = findChildren(adaptationSet, 'Representation');
	    var adaptationSetSegmentInfo = merge(periodSegmentInfo, segmentInfo);
	    return flatten(representations.map(inheritBaseUrls(attrs, adaptationSetBaseUrls, adaptationSetSegmentInfo)));
	  };
	};
	/**
	 * Contains all period information for mapping nodes onto adaptation sets.
	 *
	 * @typedef {Object} PeriodInformation
	 * @property {Node} period.node
	 *           Period node from the mpd
	 * @property {Object} period.attributes
	 *           Parsed period attributes from node plus any added
	 */
	
	/**
	 * Maps a PeriodInformation object to a list of Representation information objects for all
	 * AdaptationSet nodes contained within the Period.
	 *
	 * @name toAdaptationSetsCallback
	 * @function
	 * @param {PeriodInformation} period
	 *        Period object containing necessary period information
	 * @param {number} periodStart
	 *        Start time of the Period within the mpd
	 * @return {RepresentationInformation[]}
	 *         List of objects containing Representaion information
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping Period nodes to a list of
	 * Representation information objects
	 *
	 * @param {Object} mpdAttributes
	 *        Contains attributes inherited by the mpd
	 * @param {string[]} mpdBaseUrls
	 *        Contains list of resolved base urls inherited by the mpd
	 * @return {toAdaptationSetsCallback}
	 *         Callback map function
	 */
	
	var toAdaptationSets = function toAdaptationSets(mpdAttributes, mpdBaseUrls) {
	  return function (period, index) {
	    var periodBaseUrls = buildBaseUrls(mpdBaseUrls, findChildren(period.node, 'BaseURL'));
	    var periodAttributes = merge(mpdAttributes, {
	      periodStart: period.attributes.start
	    });
	
	    if (typeof period.attributes.duration === 'number') {
	      periodAttributes.periodDuration = period.attributes.duration;
	    }
	
	    var adaptationSets = findChildren(period.node, 'AdaptationSet');
	    var periodSegmentInfo = getSegmentInformation(period.node);
	    return flatten(adaptationSets.map(toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo)));
	  };
	};
	/**
	 * Gets Period@start property for a given period.
	 *
	 * @param {Object} options
	 *        Options object
	 * @param {Object} options.attributes
	 *        Period attributes
	 * @param {Object} [options.priorPeriodAttributes]
	 *        Prior period attributes (if prior period is available)
	 * @param {string} options.mpdType
	 *        The MPD@type these periods came from
	 * @return {number|null}
	 *         The period start, or null if it's an early available period or error
	 */
	
	var getPeriodStart = function getPeriodStart(_ref) {
	  var attributes = _ref.attributes,
	      priorPeriodAttributes = _ref.priorPeriodAttributes,
	      mpdType = _ref.mpdType;
	
	  // Summary of period start time calculation from DASH spec section 5.3.2.1
	  //
	  // A period's start is the first period's start + time elapsed after playing all
	  // prior periods to this one. Periods continue one after the other in time (without
	  // gaps) until the end of the presentation.
	  //
	  // The value of Period@start should be:
	  // 1. if Period@start is present: value of Period@start
	  // 2. if previous period exists and it has @duration: previous Period@start +
	  //    previous Period@duration
	  // 3. if this is first period and MPD@type is 'static': 0
	  // 4. in all other cases, consider the period an "early available period" (note: not
	  //    currently supported)
	  // (1)
	  if (typeof attributes.start === 'number') {
	    return attributes.start;
	  } // (2)
	
	
	  if (priorPeriodAttributes && typeof priorPeriodAttributes.start === 'number' && typeof priorPeriodAttributes.duration === 'number') {
	    return priorPeriodAttributes.start + priorPeriodAttributes.duration;
	  } // (3)
	
	
	  if (!priorPeriodAttributes && mpdType === 'static') {
	    return 0;
	  } // (4)
	  // There is currently no logic for calculating the Period@start value if there is
	  // no Period@start or prior Period@start and Period@duration available. This is not made
	  // explicit by the DASH interop guidelines or the DASH spec, however, since there's
	  // nothing about any other resolution strategies, it's implied. Thus, this case should
	  // be considered an early available period, or error, and null should suffice for both
	  // of those cases.
	
	
	  return null;
	};
	/**
	 * Traverses the mpd xml tree to generate a list of Representation information objects
	 * that have inherited attributes from parent nodes
	 *
	 * @param {Node} mpd
	 *        The root node of the mpd
	 * @param {Object} options
	 *        Available options for inheritAttributes
	 * @param {string} options.manifestUri
	 *        The uri source of the mpd
	 * @param {number} options.NOW
	 *        Current time per DASH IOP.  Default is current time in ms since epoch
	 * @param {number} options.clientOffset
	 *        Client time difference from NOW (in milliseconds)
	 * @return {RepresentationInformation[]}
	 *         List of objects containing Representation information
	 */
	
	var inheritAttributes = function inheritAttributes(mpd, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var _options = options,
	      _options$manifestUri = _options.manifestUri,
	      manifestUri = _options$manifestUri === void 0 ? '' : _options$manifestUri,
	      _options$NOW = _options.NOW,
	      NOW = _options$NOW === void 0 ? Date.now() : _options$NOW,
	      _options$clientOffset = _options.clientOffset,
	      clientOffset = _options$clientOffset === void 0 ? 0 : _options$clientOffset;
	  var periodNodes = findChildren(mpd, 'Period');
	
	  if (!periodNodes.length) {
	    throw new Error(errors.INVALID_NUMBER_OF_PERIOD);
	  }
	
	  var locations = findChildren(mpd, 'Location');
	  var mpdAttributes = parseAttributes(mpd);
	  var mpdBaseUrls = buildBaseUrls([manifestUri], findChildren(mpd, 'BaseURL')); // See DASH spec section 5.3.1.2, Semantics of MPD element. Default type to 'static'.
	
	  mpdAttributes.type = mpdAttributes.type || 'static';
	  mpdAttributes.sourceDuration = mpdAttributes.mediaPresentationDuration || 0;
	  mpdAttributes.NOW = NOW;
	  mpdAttributes.clientOffset = clientOffset;
	
	  if (locations.length) {
	    mpdAttributes.locations = locations.map(getContent);
	  }
	
	  var periods = []; // Since toAdaptationSets acts on individual periods right now, the simplest approach to
	  // adding properties that require looking at prior periods is to parse attributes and add
	  // missing ones before toAdaptationSets is called. If more such properties are added, it
	  // may be better to refactor toAdaptationSets.
	
	  periodNodes.forEach(function (node, index) {
	    var attributes = parseAttributes(node); // Use the last modified prior period, as it may contain added information necessary
	    // for this period.
	
	    var priorPeriod = periods[index - 1];
	    attributes.start = getPeriodStart({
	      attributes: attributes,
	      priorPeriodAttributes: priorPeriod ? priorPeriod.attributes : null,
	      mpdType: mpdAttributes.type
	    });
	    periods.push({
	      node: node,
	      attributes: attributes
	    });
	  });
	  return {
	    locations: mpdAttributes.locations,
	    representationInfo: flatten(periods.map(toAdaptationSets(mpdAttributes, mpdBaseUrls)))
	  };
	};
	
	var stringToMpdXml = function stringToMpdXml(manifestString) {
	  if (manifestString === '') {
	    throw new Error(errors.DASH_EMPTY_MANIFEST);
	  }
	
	  var parser = new xmldom.DOMParser();
	  var xml;
	  var mpd;
	
	  try {
	    xml = parser.parseFromString(manifestString, 'application/xml');
	    mpd = xml && xml.documentElement.tagName === 'MPD' ? xml.documentElement : null;
	  } catch (e) {// ie 11 throwsw on invalid xml
	  }
	
	  if (!mpd || mpd && mpd.getElementsByTagName('parsererror').length > 0) {
	    throw new Error(errors.DASH_INVALID_XML);
	  }
	
	  return mpd;
	};
	
	/**
	 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
	 *
	 * @param {string} mpd
	 *        XML string of the MPD manifest
	 * @return {Object|null}
	 *         Attributes of UTCTiming node specified in the manifest. Null if none found
	 */
	
	var parseUTCTimingScheme = function parseUTCTimingScheme(mpd) {
	  var UTCTimingNode = findChildren(mpd, 'UTCTiming')[0];
	
	  if (!UTCTimingNode) {
	    return null;
	  }
	
	  var attributes = parseAttributes(UTCTimingNode);
	
	  switch (attributes.schemeIdUri) {
	    case 'urn:mpeg:dash:utc:http-head:2014':
	    case 'urn:mpeg:dash:utc:http-head:2012':
	      attributes.method = 'HEAD';
	      break;
	
	    case 'urn:mpeg:dash:utc:http-xsdate:2014':
	    case 'urn:mpeg:dash:utc:http-iso:2014':
	    case 'urn:mpeg:dash:utc:http-xsdate:2012':
	    case 'urn:mpeg:dash:utc:http-iso:2012':
	      attributes.method = 'GET';
	      break;
	
	    case 'urn:mpeg:dash:utc:direct:2014':
	    case 'urn:mpeg:dash:utc:direct:2012':
	      attributes.method = 'DIRECT';
	      attributes.value = Date.parse(attributes.value);
	      break;
	
	    case 'urn:mpeg:dash:utc:http-ntp:2014':
	    case 'urn:mpeg:dash:utc:ntp:2014':
	    case 'urn:mpeg:dash:utc:sntp:2014':
	    default:
	      throw new Error(errors.UNSUPPORTED_UTC_TIMING_SCHEME);
	  }
	
	  return attributes;
	};
	
	var VERSION = version;
	/*
	 * Given a DASH manifest string and options, parses the DASH manifest into an object in the
	 * form outputed by m3u8-parser and accepted by videojs/http-streaming.
	 *
	 * For live DASH manifests, if `previousManifest` is provided in options, then the newly
	 * parsed DASH manifest will have its media sequence and discontinuity sequence values
	 * updated to reflect its position relative to the prior manifest.
	 *
	 * @param {string} manifestString - the DASH manifest as a string
	 * @param {options} [options] - any options
	 *
	 * @return {Object} the manifest object
	 */
	
	var parse = function parse(manifestString, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var parsedManifestInfo = inheritAttributes(stringToMpdXml(manifestString), options);
	  var playlists = toPlaylists(parsedManifestInfo.representationInfo);
	  return toM3u8({
	    dashPlaylists: playlists,
	    locations: parsedManifestInfo.locations,
	    sidxMapping: options.sidxMapping,
	    previousManifest: options.previousManifest
	  });
	};
	/**
	 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
	 *
	 * @param {string} manifestString
	 *        XML string of the MPD manifest
	 * @return {Object|null}
	 *         Attributes of UTCTiming node specified in the manifest. Null if none found
	 */
	
	
	var parseUTCTiming = function parseUTCTiming(manifestString) {
	  return parseUTCTimingScheme(stringToMpdXml(manifestString));
	};
	
	exports.VERSION = VERSION;
	exports.addSidxSegmentsToPlaylist = addSidxSegmentsToPlaylist$1;
	exports.generateSidxKey = generateSidxKey;
	exports.inheritAttributes = inheritAttributes;
	exports.parse = parse;
	exports.parseUTCTiming = parseUTCTiming;
	exports.stringToMpdXml = stringToMpdXml;
	exports.toM3u8 = toM3u8;
	exports.toPlaylists = toPlaylists;


/***/ },
/* 1835 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	var getUint64 = __webpack_require__(1838).getUint64;
	
	var parseSidx = function(data) {
	  var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	      result = {
	        version: data[0],
	        flags: new Uint8Array(data.subarray(1, 4)),
	        references: [],
	        referenceId: view.getUint32(4),
	        timescale: view.getUint32(8)
	      },
	    i = 12;
	
	  if (result.version === 0) {
	    result.earliestPresentationTime = view.getUint32(i);
	    result.firstOffset = view.getUint32(i + 4);
	    i += 8;
	  } else {
	    // read 64 bits
	    result.earliestPresentationTime = getUint64(data.subarray(i));
	    result.firstOffset = getUint64(data.subarray(i + 8));
	    i += 16;
	  }
	
	  i += 2; // reserved
	
	  var referenceCount = view.getUint16(i);
	
	  i += 2; // start of references
	
	  for (; referenceCount > 0; i += 12, referenceCount--) {
	    result.references.push({
	      referenceType: (data[i] & 0x80) >>> 7,
	      referencedSize: view.getUint32(i) & 0x7FFFFFFF,
	      subsegmentDuration: view.getUint32(i + 4),
	      startsWithSap: !!(data[i + 8] & 0x80),
	      sapType: (data[i + 8] & 0x70) >>> 4,
	      sapDeltaTime: view.getUint32(i + 8) & 0x0FFFFFFF
	    });
	  }
	
	  return result;
	};
	
	
	module.exports = parseSidx;


/***/ },
/* 1837 */
/***/ function(module, exports) {

	/**
	 * mux.js
	 *
	 * Copyright (c) Brightcove
	 * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	 */
	var
	  ONE_SECOND_IN_TS = 90000, // 90kHz clock
	  secondsToVideoTs,
	  secondsToAudioTs,
	  videoTsToSeconds,
	  audioTsToSeconds,
	  audioTsToVideoTs,
	  videoTsToAudioTs,
	  metadataTsToSeconds;
	
	secondsToVideoTs = function(seconds) {
	  return seconds * ONE_SECOND_IN_TS;
	};
	
	secondsToAudioTs = function(seconds, sampleRate) {
	  return seconds * sampleRate;
	};
	
	videoTsToSeconds = function(timestamp) {
	  return timestamp / ONE_SECOND_IN_TS;
	};
	
	audioTsToSeconds = function(timestamp, sampleRate) {
	  return timestamp / sampleRate;
	};
	
	audioTsToVideoTs = function(timestamp, sampleRate) {
	  return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
	};
	
	videoTsToAudioTs = function(timestamp, sampleRate) {
	  return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
	};
	
	/**
	 * Adjust ID3 tag or caption timing information by the timeline pts values
	 * (if keepOriginalTimestamps is false) and convert to seconds
	 */
	metadataTsToSeconds = function(timestamp, timelineStartPts, keepOriginalTimestamps) {
	  return videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
	};
	
	module.exports = {
	  ONE_SECOND_IN_TS: ONE_SECOND_IN_TS,
	  secondsToVideoTs: secondsToVideoTs,
	  secondsToAudioTs: secondsToAudioTs,
	  videoTsToSeconds: videoTsToSeconds,
	  audioTsToSeconds: audioTsToSeconds,
	  audioTsToVideoTs: audioTsToVideoTs,
	  videoTsToAudioTs: videoTsToAudioTs,
	  metadataTsToSeconds: metadataTsToSeconds
	};


/***/ },
/* 1838 */
/***/ function(module, exports) {

	var MAX_UINT32 = Math.pow(2, 32);
	
	var getUint64 = function(uint8) {
	  var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
	  var value;
	
	  if (dv.getBigUint64) {
	    value = dv.getBigUint64(0);
	
	    if (value < Number.MAX_SAFE_INTEGER) {
	      return Number(value);
	    }
	
	    return value;
	  }
	
	  return (dv.getUint32(0) * MAX_UINT32) + dv.getUint32(4);
	};
	
	module.exports = {
	  getUint64: getUint64,
	  MAX_UINT32: MAX_UINT32
	};


/***/ },
/* 1839 */
933,
/* 1840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(1478); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 1841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(1478);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1840);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! picturefill - v3.0.2 - 2016-02-12
	 * https://scottjehl.github.io/picturefill/
	 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
	 */
	/*! Gecko-Picture - v1.0
	 * https://github.com/scottjehl/picturefill/tree/3.0/src/plugins/gecko-picture
	 * Firefox's early picture implementation (prior to FF41) is static and does
	 * not react to viewport changes. This tiny module fixes this.
	 */
	(function(window) {
		/*jshint eqnull:true */
		var ua = navigator.userAgent;
	
		if ( window.HTMLPictureElement && ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 < 45) ) {
			addEventListener("resize", (function() {
				var timer;
	
				var dummySrc = document.createElement("source");
	
				var fixRespimg = function(img) {
					var source, sizes;
					var picture = img.parentNode;
	
					if (picture.nodeName.toUpperCase() === "PICTURE") {
						source = dummySrc.cloneNode();
	
						picture.insertBefore(source, picture.firstElementChild);
						setTimeout(function() {
							picture.removeChild(source);
						});
					} else if (!img._pfLastSize || img.offsetWidth > img._pfLastSize) {
						img._pfLastSize = img.offsetWidth;
						sizes = img.sizes;
						img.sizes += ",100vw";
						setTimeout(function() {
							img.sizes = sizes;
						});
					}
				};
	
				var findPictureImgs = function() {
					var i;
					var imgs = document.querySelectorAll("picture > img, img[srcset][sizes]");
					for (i = 0; i < imgs.length; i++) {
						fixRespimg(imgs[i]);
					}
				};
				var onResize = function() {
					clearTimeout(timer);
					timer = setTimeout(findPictureImgs, 99);
				};
				var mq = window.matchMedia && matchMedia("(orientation: landscape)");
				var init = function() {
					onResize();
	
					if (mq && mq.addListener) {
						mq.addListener(onResize);
					}
				};
	
				dummySrc.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
	
				if (/^[c|i]|d$/.test(document.readyState || "")) {
					init();
				} else {
					document.addEventListener("DOMContentLoaded", init);
				}
	
				return onResize;
			})());
		}
	})(window);
	
	/*! Picturefill - v3.0.2
	 * http://scottjehl.github.io/picturefill
	 * Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt;
	 *  License: MIT
	 */
	
	(function( window, document, undefined ) {
		// Enable strict mode
		"use strict";
	
		// HTML shim|v it for old IE (IE9 will still need the HTML video tag workaround)
		document.createElement( "picture" );
	
		var warn, eminpx, alwaysCheckWDescriptor, evalId;
		// local object for method references and testing exposure
		var pf = {};
		var isSupportTestReady = false;
		var noop = function() {};
		var image = document.createElement( "img" );
		var getImgAttr = image.getAttribute;
		var setImgAttr = image.setAttribute;
		var removeImgAttr = image.removeAttribute;
		var docElem = document.documentElement;
		var types = {};
		var cfg = {
			//resource selection:
			algorithm: ""
		};
		var srcAttr = "data-pfsrc";
		var srcsetAttr = srcAttr + "set";
		// ua sniffing is done for undetectable img loading features,
		// to do some non crucial perf optimizations
		var ua = navigator.userAgent;
		var supportAbort = (/rident/).test(ua) || ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 > 35 );
		var curSrcProp = "currentSrc";
		var regWDesc = /\s+\+?\d+(e\d+)?w/;
		var regSize = /(\([^)]+\))?\s*(.+)/;
		var setOptions = window.picturefillCFG;
		/**
		 * Shortcut property for https://w3c.github.io/webappsec/specs/mixedcontent/#restricts-mixed-content ( for easy overriding in tests )
		 */
		// baseStyle also used by getEmValue (i.e.: width: 1em is important)
		var baseStyle = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)";
		var fsCss = "font-size:100%!important;";
		var isVwDirty = true;
	
		var cssCache = {};
		var sizeLengthCache = {};
		var DPR = window.devicePixelRatio;
		var units = {
			px: 1,
			"in": 96
		};
		var anchor = document.createElement( "a" );
		/**
		 * alreadyRun flag used for setOptions. is it true setOptions will reevaluate
		 * @type {boolean}
		 */
		var alreadyRun = false;
	
		// Reusable, non-"g" Regexes
	
		// (Don't use \s, to avoid matching non-breaking space.)
		var regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
		    regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
		    regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
		    regexTrailingCommas = /[,]+$/,
		    regexNonNegativeInteger = /^\d+$/,
	
		    // ( Positive or negative or unsigned integers or decimals, without or without exponents.
		    // Must include at least one digit.
		    // According to spec tests any decimal point must be followed by a digit.
		    // No leading plus sign is allowed.)
		    // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
		    regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;
	
		var on = function(obj, evt, fn, capture) {
			if ( obj.addEventListener ) {
				obj.addEventListener(evt, fn, capture || false);
			} else if ( obj.attachEvent ) {
				obj.attachEvent( "on" + evt, fn);
			}
		};
	
		/**
		 * simple memoize function:
		 */
	
		var memoize = function(fn) {
			var cache = {};
			return function(input) {
				if ( !(input in cache) ) {
					cache[ input ] = fn(input);
				}
				return cache[ input ];
			};
		};
	
		// UTILITY FUNCTIONS
	
		// Manual is faster than RegEx
		// http://jsperf.com/whitespace-character/5
		function isSpace(c) {
			return (c === "\u0020" || // space
			        c === "\u0009" || // horizontal tab
			        c === "\u000A" || // new line
			        c === "\u000C" || // form feed
			        c === "\u000D");  // carriage return
		}
	
		/**
		 * gets a mediaquery and returns a boolean or gets a css length and returns a number
		 * @param css mediaqueries or css length
		 * @returns {boolean|number}
		 *
		 * based on: https://gist.github.com/jonathantneal/db4f77009b155f083738
		 */
		var evalCSS = (function() {
	
			var regLength = /^([\d\.]+)(em|vw|px)$/;
			var replace = function() {
				var args = arguments, index = 0, string = args[0];
				while (++index in args) {
					string = string.replace(args[index], args[++index]);
				}
				return string;
			};
	
			var buildStr = memoize(function(css) {
	
				return "return " + replace((css || "").toLowerCase(),
					// interpret `and`
					/\band\b/g, "&&",
	
					// interpret `,`
					/,/g, "||",
	
					// interpret `min-` as >=
					/min-([a-z-\s]+):/g, "e.$1>=",
	
					// interpret `max-` as <=
					/max-([a-z-\s]+):/g, "e.$1<=",
	
					//calc value
					/calc([^)]+)/g, "($1)",
	
					// interpret css values
					/(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)",
					//make eval less evil
					/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/ig, ""
				) + ";";
			});
	
			return function(css, length) {
				var parsedLength;
				if (!(css in cssCache)) {
					cssCache[css] = false;
					if (length && (parsedLength = css.match( regLength ))) {
						cssCache[css] = parsedLength[ 1 ] * units[parsedLength[ 2 ]];
					} else {
						/*jshint evil:true */
						try{
							cssCache[css] = new Function("e", buildStr(css))(units);
						} catch(e) {}
						/*jshint evil:false */
					}
				}
				return cssCache[css];
			};
		})();
	
		var setResolution = function( candidate, sizesattr ) {
			if ( candidate.w ) { // h = means height: || descriptor.type === 'h' do not handle yet...
				candidate.cWidth = pf.calcListLength( sizesattr || "100vw" );
				candidate.res = candidate.w / candidate.cWidth ;
			} else {
				candidate.res = candidate.d;
			}
			return candidate;
		};
	
		/**
		 *
		 * @param opt
		 */
		var picturefill = function( opt ) {
	
			if (!isSupportTestReady) {return;}
	
			var elements, i, plen;
	
			var options = opt || {};
	
			if ( options.elements && options.elements.nodeType === 1 ) {
				if ( options.elements.nodeName.toUpperCase() === "IMG" ) {
					options.elements =  [ options.elements ];
				} else {
					options.context = options.elements;
					options.elements =  null;
				}
			}
	
			elements = options.elements || pf.qsa( (options.context || document), ( options.reevaluate || options.reselect ) ? pf.sel : pf.selShort );
	
			if ( (plen = elements.length) ) {
	
				pf.setupRun( options );
				alreadyRun = true;
	
				// Loop through all elements
				for ( i = 0; i < plen; i++ ) {
					pf.fillImg(elements[ i ], options);
				}
	
				pf.teardownRun( options );
			}
		};
	
		/**
		 * outputs a warning for the developer
		 * @param {message}
		 * @type {Function}
		 */
		warn = ( window.console && console.warn ) ?
			function( message ) {
				console.warn( message );
			} :
			noop
		;
	
		if ( !(curSrcProp in image) ) {
			curSrcProp = "src";
		}
	
		// Add support for standard mime types.
		types[ "image/jpeg" ] = true;
		types[ "image/gif" ] = true;
		types[ "image/png" ] = true;
	
		function detectTypeSupport( type, typeUri ) {
			// based on Modernizr's lossless img-webp test
			// note: asynchronous
			var image = new window.Image();
			image.onerror = function() {
				types[ type ] = false;
				picturefill();
			};
			image.onload = function() {
				types[ type ] = image.width === 1;
				picturefill();
			};
			image.src = typeUri;
			return "pending";
		}
	
		// test svg support
		types[ "image/svg+xml" ] = document.implementation.hasFeature( "http://www.w3.org/TR/SVG11/feature#Image", "1.1" );
	
		/**
		 * updates the internal vW property with the current viewport width in px
		 */
		function updateMetrics() {
	
			isVwDirty = false;
			DPR = window.devicePixelRatio;
			cssCache = {};
			sizeLengthCache = {};
	
			pf.DPR = DPR || 1;
	
			units.width = Math.max(window.innerWidth || 0, docElem.clientWidth);
			units.height = Math.max(window.innerHeight || 0, docElem.clientHeight);
	
			units.vw = units.width / 100;
			units.vh = units.height / 100;
	
			evalId = [ units.height, units.width, DPR ].join("-");
	
			units.em = pf.getEmValue();
			units.rem = units.em;
		}
	
		function chooseLowRes( lowerValue, higherValue, dprValue, isCached ) {
			var bonusFactor, tooMuch, bonus, meanDensity;
	
			//experimental
			if (cfg.algorithm === "saveData" ){
				if ( lowerValue > 2.7 ) {
					meanDensity = dprValue + 1;
				} else {
					tooMuch = higherValue - dprValue;
					bonusFactor = Math.pow(lowerValue - 0.6, 1.5);
	
					bonus = tooMuch * bonusFactor;
	
					if (isCached) {
						bonus += 0.1 * bonusFactor;
					}
	
					meanDensity = lowerValue + bonus;
				}
			} else {
				meanDensity = (dprValue > 1) ?
					Math.sqrt(lowerValue * higherValue) :
					lowerValue;
			}
	
			return meanDensity > dprValue;
		}
	
		function applyBestCandidate( img ) {
			var srcSetCandidates;
			var matchingSet = pf.getSet( img );
			var evaluated = false;
			if ( matchingSet !== "pending" ) {
				evaluated = evalId;
				if ( matchingSet ) {
					srcSetCandidates = pf.setRes( matchingSet );
					pf.applySetCandidate( srcSetCandidates, img );
				}
			}
			img[ pf.ns ].evaled = evaluated;
		}
	
		function ascendingSort( a, b ) {
			return a.res - b.res;
		}
	
		function setSrcToCur( img, src, set ) {
			var candidate;
			if ( !set && src ) {
				set = img[ pf.ns ].sets;
				set = set && set[set.length - 1];
			}
	
			candidate = getCandidateForSrc(src, set);
	
			if ( candidate ) {
				src = pf.makeUrl(src);
				img[ pf.ns ].curSrc = src;
				img[ pf.ns ].curCan = candidate;
	
				if ( !candidate.res ) {
					setResolution( candidate, candidate.set.sizes );
				}
			}
			return candidate;
		}
	
		function getCandidateForSrc( src, set ) {
			var i, candidate, candidates;
			if ( src && set ) {
				candidates = pf.parseSet( set );
				src = pf.makeUrl(src);
				for ( i = 0; i < candidates.length; i++ ) {
					if ( src === pf.makeUrl(candidates[ i ].url) ) {
						candidate = candidates[ i ];
						break;
					}
				}
			}
			return candidate;
		}
	
		function getAllSourceElements( picture, candidates ) {
			var i, len, source, srcset;
	
			// SPEC mismatch intended for size and perf:
			// actually only source elements preceding the img should be used
			// also note: don't use qsa here, because IE8 sometimes doesn't like source as the key part in a selector
			var sources = picture.getElementsByTagName( "source" );
	
			for ( i = 0, len = sources.length; i < len; i++ ) {
				source = sources[ i ];
				source[ pf.ns ] = true;
				srcset = source.getAttribute( "srcset" );
	
				// if source does not have a srcset attribute, skip
				if ( srcset ) {
					candidates.push( {
						srcset: srcset,
						media: source.getAttribute( "media" ),
						type: source.getAttribute( "type" ),
						sizes: source.getAttribute( "sizes" )
					} );
				}
			}
		}
	
		/**
		 * Srcset Parser
		 * By Alex Bell |  MIT License
		 *
		 * @returns Array [{url: _, d: _, w: _, h:_, set:_(????)}, ...]
		 *
		 * Based super duper closely on the reference algorithm at:
		 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
		 */
	
		// 1. Let input be the value passed to this algorithm.
		// (TO-DO : Explain what "set" argument is here. Maybe choose a more
		// descriptive & more searchable name.  Since passing the "set" in really has
		// nothing to do with parsing proper, I would prefer this assignment eventually
		// go in an external fn.)
		function parseSrcset(input, set) {
	
			function collectCharacters(regEx) {
				var chars,
				    match = regEx.exec(input.substring(pos));
				if (match) {
					chars = match[ 0 ];
					pos += chars.length;
					return chars;
				}
			}
	
			var inputLength = input.length,
			    url,
			    descriptors,
			    currentDescriptor,
			    state,
			    c,
	
			    // 2. Let position be a pointer into input, initially pointing at the start
			    //    of the string.
			    pos = 0,
	
			    // 3. Let candidates be an initially empty source set.
			    candidates = [];
	
			/**
			* Adds descriptor properties to a candidate, pushes to the candidates array
			* @return undefined
			*/
			// (Declared outside of the while loop so that it's only created once.
			// (This fn is defined before it is used, in order to pass JSHINT.
			// Unfortunately this breaks the sequencing of the spec comments. :/ )
			function parseDescriptors() {
	
				// 9. Descriptor parser: Let error be no.
				var pError = false,
	
				// 10. Let width be absent.
				// 11. Let density be absent.
				// 12. Let future-compat-h be absent. (We're implementing it now as h)
				    w, d, h, i,
				    candidate = {},
				    desc, lastChar, value, intVal, floatVal;
	
				// 13. For each descriptor in descriptors, run the appropriate set of steps
				// from the following list:
				for (i = 0 ; i < descriptors.length; i++) {
					desc = descriptors[ i ];
	
					lastChar = desc[ desc.length - 1 ];
					value = desc.substring(0, desc.length - 1);
					intVal = parseInt(value, 10);
					floatVal = parseFloat(value);
	
					// If the descriptor consists of a valid non-negative integer followed by
					// a U+0077 LATIN SMALL LETTER W character
					if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {
	
						// If width and density are not both absent, then let error be yes.
						if (w || d) {pError = true;}
	
						// Apply the rules for parsing non-negative integers to the descriptor.
						// If the result is zero, let error be yes.
						// Otherwise, let width be the result.
						if (intVal === 0) {pError = true;} else {w = intVal;}
	
					// If the descriptor consists of a valid floating-point number followed by
					// a U+0078 LATIN SMALL LETTER X character
					} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {
	
						// If width, density and future-compat-h are not all absent, then let error
						// be yes.
						if (w || d || h) {pError = true;}
	
						// Apply the rules for parsing floating-point number values to the descriptor.
						// If the result is less than zero, let error be yes. Otherwise, let density
						// be the result.
						if (floatVal < 0) {pError = true;} else {d = floatVal;}
	
					// If the descriptor consists of a valid non-negative integer followed by
					// a U+0068 LATIN SMALL LETTER H character
					} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {
	
						// If height and density are not both absent, then let error be yes.
						if (h || d) {pError = true;}
	
						// Apply the rules for parsing non-negative integers to the descriptor.
						// If the result is zero, let error be yes. Otherwise, let future-compat-h
						// be the result.
						if (intVal === 0) {pError = true;} else {h = intVal;}
	
					// Anything else, Let error be yes.
					} else {pError = true;}
				} // (close step 13 for loop)
	
				// 15. If error is still no, then append a new image source to candidates whose
				// URL is url, associated with a width width if not absent and a pixel
				// density density if not absent. Otherwise, there is a parse error.
				if (!pError) {
					candidate.url = url;
	
					if (w) { candidate.w = w;}
					if (d) { candidate.d = d;}
					if (h) { candidate.h = h;}
					if (!h && !d && !w) {candidate.d = 1;}
					if (candidate.d === 1) {set.has1x = true;}
					candidate.set = set;
	
					candidates.push(candidate);
				}
			} // (close parseDescriptors fn)
	
			/**
			* Tokenizes descriptor properties prior to parsing
			* Returns undefined.
			* (Again, this fn is defined before it is used, in order to pass JSHINT.
			* Unfortunately this breaks the logical sequencing of the spec comments. :/ )
			*/
			function tokenize() {
	
				// 8.1. Descriptor tokeniser: Skip whitespace
				collectCharacters(regexLeadingSpaces);
	
				// 8.2. Let current descriptor be the empty string.
				currentDescriptor = "";
	
				// 8.3. Let state be in descriptor.
				state = "in descriptor";
	
				while (true) {
	
					// 8.4. Let c be the character at position.
					c = input.charAt(pos);
	
					//  Do the following depending on the value of state.
					//  For the purpose of this step, "EOF" is a special character representing
					//  that position is past the end of input.
	
					// In descriptor
					if (state === "in descriptor") {
						// Do the following, depending on the value of c:
	
					  // Space character
					  // If current descriptor is not empty, append current descriptor to
					  // descriptors and let current descriptor be the empty string.
					  // Set state to after descriptor.
						if (isSpace(c)) {
							if (currentDescriptor) {
								descriptors.push(currentDescriptor);
								currentDescriptor = "";
								state = "after descriptor";
							}
	
						// U+002C COMMA (,)
						// Advance position to the next character in input. If current descriptor
						// is not empty, append current descriptor to descriptors. Jump to the step
						// labeled descriptor parser.
						} else if (c === ",") {
							pos += 1;
							if (currentDescriptor) {
								descriptors.push(currentDescriptor);
							}
							parseDescriptors();
							return;
	
						// U+0028 LEFT PARENTHESIS (()
						// Append c to current descriptor. Set state to in parens.
						} else if (c === "\u0028") {
							currentDescriptor = currentDescriptor + c;
							state = "in parens";
	
						// EOF
						// If current descriptor is not empty, append current descriptor to
						// descriptors. Jump to the step labeled descriptor parser.
						} else if (c === "") {
							if (currentDescriptor) {
								descriptors.push(currentDescriptor);
							}
							parseDescriptors();
							return;
	
						// Anything else
						// Append c to current descriptor.
						} else {
							currentDescriptor = currentDescriptor + c;
						}
					// (end "in descriptor"
	
					// In parens
					} else if (state === "in parens") {
	
						// U+0029 RIGHT PARENTHESIS ())
						// Append c to current descriptor. Set state to in descriptor.
						if (c === ")") {
							currentDescriptor = currentDescriptor + c;
							state = "in descriptor";
	
						// EOF
						// Append current descriptor to descriptors. Jump to the step labeled
						// descriptor parser.
						} else if (c === "") {
							descriptors.push(currentDescriptor);
							parseDescriptors();
							return;
	
						// Anything else
						// Append c to current descriptor.
						} else {
							currentDescriptor = currentDescriptor + c;
						}
	
					// After descriptor
					} else if (state === "after descriptor") {
	
						// Do the following, depending on the value of c:
						// Space character: Stay in this state.
						if (isSpace(c)) {
	
						// EOF: Jump to the step labeled descriptor parser.
						} else if (c === "") {
							parseDescriptors();
							return;
	
						// Anything else
						// Set state to in descriptor. Set position to the previous character in input.
						} else {
							state = "in descriptor";
							pos -= 1;
	
						}
					}
	
					// Advance position to the next character in input.
					pos += 1;
	
				// Repeat this step.
				} // (close while true loop)
			}
	
			// 4. Splitting loop: Collect a sequence of characters that are space
			//    characters or U+002C COMMA characters. If any U+002C COMMA characters
			//    were collected, that is a parse error.
			while (true) {
				collectCharacters(regexLeadingCommasOrSpaces);
	
				// 5. If position is past the end of input, return candidates and abort these steps.
				if (pos >= inputLength) {
					return candidates; // (we're done, this is the sole return path)
				}
	
				// 6. Collect a sequence of characters that are not space characters,
				//    and let that be url.
				url = collectCharacters(regexLeadingNotSpaces);
	
				// 7. Let descriptors be a new empty list.
				descriptors = [];
	
				// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
				//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
				//         more than one character, that is a parse error.
				if (url.slice(-1) === ",") {
					url = url.replace(regexTrailingCommas, "");
					// (Jump ahead to step 9 to skip tokenization and just push the candidate).
					parseDescriptors();
	
				//	Otherwise, follow these substeps:
				} else {
					tokenize();
				} // (close else of step 8)
	
			// 16. Return to the step labeled splitting loop.
			} // (Close of big while loop.)
		}
	
		/*
		 * Sizes Parser
		 *
		 * By Alex Bell |  MIT License
		 *
		 * Non-strict but accurate and lightweight JS Parser for the string value <img sizes="here">
		 *
		 * Reference algorithm at:
		 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-sizes-attribute
		 *
		 * Most comments are copied in directly from the spec
		 * (except for comments in parens).
		 *
		 * Grammar is:
		 * <source-size-list> = <source-size># [ , <source-size-value> ]? | <source-size-value>
		 * <source-size> = <media-condition> <source-size-value>
		 * <source-size-value> = <length>
		 * http://www.w3.org/html/wg/drafts/html/master/embedded-content.html#attr-img-sizes
		 *
		 * E.g. "(max-width: 30em) 100vw, (max-width: 50em) 70vw, 100vw"
		 * or "(min-width: 30em), calc(30vw - 15px)" or just "30vw"
		 *
		 * Returns the first valid <css-length> with a media condition that evaluates to true,
		 * or "100vw" if all valid media conditions evaluate to false.
		 *
		 */
	
		function parseSizes(strValue) {
	
			// (Percentage CSS lengths are not allowed in this case, to avoid confusion:
			// https://html.spec.whatwg.org/multipage/embedded-content.html#valid-source-size-list
			// CSS allows a single optional plus or minus sign:
			// http://www.w3.org/TR/CSS2/syndata.html#numbers
			// CSS is ASCII case-insensitive:
			// http://www.w3.org/TR/CSS2/syndata.html#characters )
			// Spec allows exponential notation for <number> type:
			// http://dev.w3.org/csswg/css-values/#numbers
			var regexCssLengthWithUnits = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i;
	
			// (This is a quick and lenient test. Because of optional unlimited-depth internal
			// grouping parens and strict spacing rules, this could get very complicated.)
			var regexCssCalc = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;
	
			var i;
			var unparsedSizesList;
			var unparsedSizesListLength;
			var unparsedSize;
			var lastComponentValue;
			var size;
	
			// UTILITY FUNCTIONS
	
			//  (Toy CSS parser. The goals here are:
			//  1) expansive test coverage without the weight of a full CSS parser.
			//  2) Avoiding regex wherever convenient.
			//  Quick tests: http://jsfiddle.net/gtntL4gr/3/
			//  Returns an array of arrays.)
			function parseComponentValues(str) {
				var chrctr;
				var component = "";
				var componentArray = [];
				var listArray = [];
				var parenDepth = 0;
				var pos = 0;
				var inComment = false;
	
				function pushComponent() {
					if (component) {
						componentArray.push(component);
						component = "";
					}
				}
	
				function pushComponentArray() {
					if (componentArray[0]) {
						listArray.push(componentArray);
						componentArray = [];
					}
				}
	
				// (Loop forwards from the beginning of the string.)
				while (true) {
					chrctr = str.charAt(pos);
	
					if (chrctr === "") { // ( End of string reached.)
						pushComponent();
						pushComponentArray();
						return listArray;
					} else if (inComment) {
						if ((chrctr === "*") && (str[pos + 1] === "/")) { // (At end of a comment.)
							inComment = false;
							pos += 2;
							pushComponent();
							continue;
						} else {
							pos += 1; // (Skip all characters inside comments.)
							continue;
						}
					} else if (isSpace(chrctr)) {
						// (If previous character in loop was also a space, or if
						// at the beginning of the string, do not add space char to
						// component.)
						if ( (str.charAt(pos - 1) && isSpace( str.charAt(pos - 1) ) ) || !component ) {
							pos += 1;
							continue;
						} else if (parenDepth === 0) {
							pushComponent();
							pos +=1;
							continue;
						} else {
							// (Replace any space character with a plain space for legibility.)
							chrctr = " ";
						}
					} else if (chrctr === "(") {
						parenDepth += 1;
					} else if (chrctr === ")") {
						parenDepth -= 1;
					} else if (chrctr === ",") {
						pushComponent();
						pushComponentArray();
						pos += 1;
						continue;
					} else if ( (chrctr === "/") && (str.charAt(pos + 1) === "*") ) {
						inComment = true;
						pos += 2;
						continue;
					}
	
					component = component + chrctr;
					pos += 1;
				}
			}
	
			function isValidNonNegativeSourceSizeValue(s) {
				if (regexCssLengthWithUnits.test(s) && (parseFloat(s) >= 0)) {return true;}
				if (regexCssCalc.test(s)) {return true;}
				// ( http://www.w3.org/TR/CSS2/syndata.html#numbers says:
				// "-0 is equivalent to 0 and is not a negative number." which means that
				// unitless zero and unitless negative zero must be accepted as special cases.)
				if ((s === "0") || (s === "-0") || (s === "+0")) {return true;}
				return false;
			}
	
			// When asked to parse a sizes attribute from an element, parse a
			// comma-separated list of component values from the value of the element's
			// sizes attribute (or the empty string, if the attribute is absent), and let
			// unparsed sizes list be the result.
			// http://dev.w3.org/csswg/css-syntax/#parse-comma-separated-list-of-component-values
	
			unparsedSizesList = parseComponentValues(strValue);
			unparsedSizesListLength = unparsedSizesList.length;
	
			// For each unparsed size in unparsed sizes list:
			for (i = 0; i < unparsedSizesListLength; i++) {
				unparsedSize = unparsedSizesList[i];
	
				// 1. Remove all consecutive <whitespace-token>s from the end of unparsed size.
				// ( parseComponentValues() already omits spaces outside of parens. )
	
				// If unparsed size is now empty, that is a parse error; continue to the next
				// iteration of this algorithm.
				// ( parseComponentValues() won't push an empty array. )
	
				// 2. If the last component value in unparsed size is a valid non-negative
				// <source-size-value>, let size be its value and remove the component value
				// from unparsed size. Any CSS function other than the calc() function is
				// invalid. Otherwise, there is a parse error; continue to the next iteration
				// of this algorithm.
				// http://dev.w3.org/csswg/css-syntax/#parse-component-value
				lastComponentValue = unparsedSize[unparsedSize.length - 1];
	
				if (isValidNonNegativeSourceSizeValue(lastComponentValue)) {
					size = lastComponentValue;
					unparsedSize.pop();
				} else {
					continue;
				}
	
				// 3. Remove all consecutive <whitespace-token>s from the end of unparsed
				// size. If unparsed size is now empty, return size and exit this algorithm.
				// If this was not the last item in unparsed sizes list, that is a parse error.
				if (unparsedSize.length === 0) {
					return size;
				}
	
				// 4. Parse the remaining component values in unparsed size as a
				// <media-condition>. If it does not parse correctly, or it does parse
				// correctly but the <media-condition> evaluates to false, continue to the
				// next iteration of this algorithm.
				// (Parsing all possible compound media conditions in JS is heavy, complicated,
				// and the payoff is unclear. Is there ever an situation where the
				// media condition parses incorrectly but still somehow evaluates to true?
				// Can we just rely on the browser/polyfill to do it?)
				unparsedSize = unparsedSize.join(" ");
				if (!(pf.matchesMedia( unparsedSize ) ) ) {
					continue;
				}
	
				// 5. Return size and exit this algorithm.
				return size;
			}
	
			// If the above algorithm exhausts unparsed sizes list without returning a
			// size value, return 100vw.
			return "100vw";
		}
	
		// namespace
		pf.ns = ("pf" + new Date().getTime()).substr(0, 9);
	
		// srcset support test
		pf.supSrcset = "srcset" in image;
		pf.supSizes = "sizes" in image;
		pf.supPicture = !!window.HTMLPictureElement;
	
		// UC browser does claim to support srcset and picture, but not sizes,
		// this extended test reveals the browser does support nothing
		if (pf.supSrcset && pf.supPicture && !pf.supSizes) {
			(function(image2) {
				image.srcset = "data:,a";
				image2.src = "data:,a";
				pf.supSrcset = image.complete === image2.complete;
				pf.supPicture = pf.supSrcset && pf.supPicture;
			})(document.createElement("img"));
		}
	
		// Safari9 has basic support for sizes, but does't expose the `sizes` idl attribute
		if (pf.supSrcset && !pf.supSizes) {
	
			(function() {
				var width2 = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==";
				var width1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
				var img = document.createElement("img");
				var test = function() {
					var width = img.width;
	
					if (width === 2) {
						pf.supSizes = true;
					}
	
					alwaysCheckWDescriptor = pf.supSrcset && !pf.supSizes;
	
					isSupportTestReady = true;
					// force async
					setTimeout(picturefill);
				};
	
				img.onload = test;
				img.onerror = test;
				img.setAttribute("sizes", "9px");
	
				img.srcset = width1 + " 1w," + width2 + " 9w";
				img.src = width1;
			})();
	
		} else {
			isSupportTestReady = true;
		}
	
		// using pf.qsa instead of dom traversing does scale much better,
		// especially on sites mixing responsive and non-responsive images
		pf.selShort = "picture>img,img[srcset]";
		pf.sel = pf.selShort;
		pf.cfg = cfg;
	
		/**
		 * Shortcut property for `devicePixelRatio` ( for easy overriding in tests )
		 */
		pf.DPR = (DPR  || 1 );
		pf.u = units;
	
		// container of supported mime types that one might need to qualify before using
		pf.types =  types;
	
		pf.setSize = noop;
	
		/**
		 * Gets a string and returns the absolute URL
		 * @param src
		 * @returns {String} absolute URL
		 */
	
		pf.makeUrl = memoize(function(src) {
			anchor.href = src;
			return anchor.href;
		});
	
		/**
		 * Gets a DOM element or document and a selctor and returns the found matches
		 * Can be extended with jQuery/Sizzle for IE7 support
		 * @param context
		 * @param sel
		 * @returns {NodeList|Array}
		 */
		pf.qsa = function(context, sel) {
			return ( "querySelector" in context ) ? context.querySelectorAll(sel) : [];
		};
	
		/**
		 * Shortcut method for matchMedia ( for easy overriding in tests )
		 * wether native or pf.mMQ is used will be decided lazy on first call
		 * @returns {boolean}
		 */
		pf.matchesMedia = function() {
			if ( window.matchMedia && (matchMedia( "(min-width: 0.1em)" ) || {}).matches ) {
				pf.matchesMedia = function( media ) {
					return !media || ( matchMedia( media ).matches );
				};
			} else {
				pf.matchesMedia = pf.mMQ;
			}
	
			return pf.matchesMedia.apply( this, arguments );
		};
	
		/**
		 * A simplified matchMedia implementation for IE8 and IE9
		 * handles only min-width/max-width with px or em values
		 * @param media
		 * @returns {boolean}
		 */
		pf.mMQ = function( media ) {
			return media ? evalCSS(media) : true;
		};
	
		/**
		 * Returns the calculated length in css pixel from the given sourceSizeValue
		 * http://dev.w3.org/csswg/css-values-3/#length-value
		 * intended Spec mismatches:
		 * * Does not check for invalid use of CSS functions
		 * * Does handle a computed length of 0 the same as a negative and therefore invalid value
		 * @param sourceSizeValue
		 * @returns {Number}
		 */
		pf.calcLength = function( sourceSizeValue ) {
	
			var value = evalCSS(sourceSizeValue, true) || false;
			if (value < 0) {
				value = false;
			}
	
			return value;
		};
	
		/**
		 * Takes a type string and checks if its supported
		 */
	
		pf.supportsType = function( type ) {
			return ( type ) ? types[ type ] : true;
		};
	
		/**
		 * Parses a sourceSize into mediaCondition (media) and sourceSizeValue (length)
		 * @param sourceSizeStr
		 * @returns {*}
		 */
		pf.parseSize = memoize(function( sourceSizeStr ) {
			var match = ( sourceSizeStr || "" ).match(regSize);
			return {
				media: match && match[1],
				length: match && match[2]
			};
		});
	
		pf.parseSet = function( set ) {
			if ( !set.cands ) {
				set.cands = parseSrcset(set.srcset, set);
			}
			return set.cands;
		};
	
		/**
		 * returns 1em in css px for html/body default size
		 * function taken from respondjs
		 * @returns {*|number}
		 */
		pf.getEmValue = function() {
			var body;
			if ( !eminpx && (body = document.body) ) {
				var div = document.createElement( "div" ),
					originalHTMLCSS = docElem.style.cssText,
					originalBodyCSS = body.style.cssText;
	
				div.style.cssText = baseStyle;
	
				// 1em in a media query is the value of the default font size of the browser
				// reset docElem and body to ensure the correct value is returned
				docElem.style.cssText = fsCss;
				body.style.cssText = fsCss;
	
				body.appendChild( div );
				eminpx = div.offsetWidth;
				body.removeChild( div );
	
				//also update eminpx before returning
				eminpx = parseFloat( eminpx, 10 );
	
				// restore the original values
				docElem.style.cssText = originalHTMLCSS;
				body.style.cssText = originalBodyCSS;
	
			}
			return eminpx || 16;
		};
	
		/**
		 * Takes a string of sizes and returns the width in pixels as a number
		 */
		pf.calcListLength = function( sourceSizeListStr ) {
			// Split up source size list, ie ( max-width: 30em ) 100%, ( max-width: 50em ) 50%, 33%
			//
			//                           or (min-width:30em) calc(30% - 15px)
			if ( !(sourceSizeListStr in sizeLengthCache) || cfg.uT ) {
				var winningLength = pf.calcLength( parseSizes( sourceSizeListStr ) );
	
				sizeLengthCache[ sourceSizeListStr ] = !winningLength ? units.width : winningLength;
			}
	
			return sizeLengthCache[ sourceSizeListStr ];
		};
	
		/**
		 * Takes a candidate object with a srcset property in the form of url/
		 * ex. "images/pic-medium.png 1x, images/pic-medium-2x.png 2x" or
		 *     "images/pic-medium.png 400w, images/pic-medium-2x.png 800w" or
		 *     "images/pic-small.png"
		 * Get an array of image candidates in the form of
		 *      {url: "/foo/bar.png", resolution: 1}
		 * where resolution is http://dev.w3.org/csswg/css-values-3/#resolution-value
		 * If sizes is specified, res is calculated
		 */
		pf.setRes = function( set ) {
			var candidates;
			if ( set ) {
	
				candidates = pf.parseSet( set );
	
				for ( var i = 0, len = candidates.length; i < len; i++ ) {
					setResolution( candidates[ i ], set.sizes );
				}
			}
			return candidates;
		};
	
		pf.setRes.res = setResolution;
	
		pf.applySetCandidate = function( candidates, img ) {
			if ( !candidates.length ) {return;}
			var candidate,
				i,
				j,
				length,
				bestCandidate,
				curSrc,
				curCan,
				candidateSrc,
				abortCurSrc;
	
			var imageData = img[ pf.ns ];
			var dpr = pf.DPR;
	
			curSrc = imageData.curSrc || img[curSrcProp];
	
			curCan = imageData.curCan || setSrcToCur(img, curSrc, candidates[0].set);
	
			// if we have a current source, we might either become lazy or give this source some advantage
			if ( curCan && curCan.set === candidates[ 0 ].set ) {
	
				// if browser can abort image request and the image has a higher pixel density than needed
				// and this image isn't downloaded yet, we skip next part and try to save bandwidth
				abortCurSrc = (supportAbort && !img.complete && curCan.res - 0.1 > dpr);
	
				if ( !abortCurSrc ) {
					curCan.cached = true;
	
					// if current candidate is "best", "better" or "okay",
					// set it to bestCandidate
					if ( curCan.res >= dpr ) {
						bestCandidate = curCan;
					}
				}
			}
	
			if ( !bestCandidate ) {
	
				candidates.sort( ascendingSort );
	
				length = candidates.length;
				bestCandidate = candidates[ length - 1 ];
	
				for ( i = 0; i < length; i++ ) {
					candidate = candidates[ i ];
					if ( candidate.res >= dpr ) {
						j = i - 1;
	
						// we have found the perfect candidate,
						// but let's improve this a little bit with some assumptions ;-)
						if (candidates[ j ] &&
							(abortCurSrc || curSrc !== pf.makeUrl( candidate.url )) &&
							chooseLowRes(candidates[ j ].res, candidate.res, dpr, candidates[ j ].cached)) {
	
							bestCandidate = candidates[ j ];
	
						} else {
							bestCandidate = candidate;
						}
						break;
					}
				}
			}
	
			if ( bestCandidate ) {
	
				candidateSrc = pf.makeUrl( bestCandidate.url );
	
				imageData.curSrc = candidateSrc;
				imageData.curCan = bestCandidate;
	
				if ( candidateSrc !== curSrc ) {
					pf.setSrc( img, bestCandidate );
				}
				pf.setSize( img );
			}
		};
	
		pf.setSrc = function( img, bestCandidate ) {
			var origWidth;
			img.src = bestCandidate.url;
	
			// although this is a specific Safari issue, we don't want to take too much different code paths
			if ( bestCandidate.set.type === "image/svg+xml" ) {
				origWidth = img.style.width;
				img.style.width = (img.offsetWidth + 1) + "px";
	
				// next line only should trigger a repaint
				// if... is only done to trick dead code removal
				if ( img.offsetWidth + 1 ) {
					img.style.width = origWidth;
				}
			}
		};
	
		pf.getSet = function( img ) {
			var i, set, supportsType;
			var match = false;
			var sets = img [ pf.ns ].sets;
	
			for ( i = 0; i < sets.length && !match; i++ ) {
				set = sets[i];
	
				if ( !set.srcset || !pf.matchesMedia( set.media ) || !(supportsType = pf.supportsType( set.type )) ) {
					continue;
				}
	
				if ( supportsType === "pending" ) {
					set = supportsType;
				}
	
				match = set;
				break;
			}
	
			return match;
		};
	
		pf.parseSets = function( element, parent, options ) {
			var srcsetAttribute, imageSet, isWDescripor, srcsetParsed;
	
			var hasPicture = parent && parent.nodeName.toUpperCase() === "PICTURE";
			var imageData = element[ pf.ns ];
	
			if ( imageData.src === undefined || options.src ) {
				imageData.src = getImgAttr.call( element, "src" );
				if ( imageData.src ) {
					setImgAttr.call( element, srcAttr, imageData.src );
				} else {
					removeImgAttr.call( element, srcAttr );
				}
			}
	
			if ( imageData.srcset === undefined || options.srcset || !pf.supSrcset || element.srcset ) {
				srcsetAttribute = getImgAttr.call( element, "srcset" );
				imageData.srcset = srcsetAttribute;
				srcsetParsed = true;
			}
	
			imageData.sets = [];
	
			if ( hasPicture ) {
				imageData.pic = true;
				getAllSourceElements( parent, imageData.sets );
			}
	
			if ( imageData.srcset ) {
				imageSet = {
					srcset: imageData.srcset,
					sizes: getImgAttr.call( element, "sizes" )
				};
	
				imageData.sets.push( imageSet );
	
				isWDescripor = (alwaysCheckWDescriptor || imageData.src) && regWDesc.test(imageData.srcset || "");
	
				// add normal src as candidate, if source has no w descriptor
				if ( !isWDescripor && imageData.src && !getCandidateForSrc(imageData.src, imageSet) && !imageSet.has1x ) {
					imageSet.srcset += ", " + imageData.src;
					imageSet.cands.push({
						url: imageData.src,
						d: 1,
						set: imageSet
					});
				}
	
			} else if ( imageData.src ) {
				imageData.sets.push( {
					srcset: imageData.src,
					sizes: null
				} );
			}
	
			imageData.curCan = null;
			imageData.curSrc = undefined;
	
			// if img has picture or the srcset was removed or has a srcset and does not support srcset at all
			// or has a w descriptor (and does not support sizes) set support to false to evaluate
			imageData.supported = !( hasPicture || ( imageSet && !pf.supSrcset ) || (isWDescripor && !pf.supSizes) );
	
			if ( srcsetParsed && pf.supSrcset && !imageData.supported ) {
				if ( srcsetAttribute ) {
					setImgAttr.call( element, srcsetAttr, srcsetAttribute );
					element.srcset = "";
				} else {
					removeImgAttr.call( element, srcsetAttr );
				}
			}
	
			if (imageData.supported && !imageData.srcset && ((!imageData.src && element.src) ||  element.src !== pf.makeUrl(imageData.src))) {
				if (imageData.src === null) {
					element.removeAttribute("src");
				} else {
					element.src = imageData.src;
				}
			}
	
			imageData.parsed = true;
		};
	
		pf.fillImg = function(element, options) {
			var imageData;
			var extreme = options.reselect || options.reevaluate;
	
			// expando for caching data on the img
			if ( !element[ pf.ns ] ) {
				element[ pf.ns ] = {};
			}
	
			imageData = element[ pf.ns ];
	
			// if the element has already been evaluated, skip it
			// unless `options.reevaluate` is set to true ( this, for example,
			// is set to true when running `picturefill` on `resize` ).
			if ( !extreme && imageData.evaled === evalId ) {
				return;
			}
	
			if ( !imageData.parsed || options.reevaluate ) {
				pf.parseSets( element, element.parentNode, options );
			}
	
			if ( !imageData.supported ) {
				applyBestCandidate( element );
			} else {
				imageData.evaled = evalId;
			}
		};
	
		pf.setupRun = function() {
			if ( !alreadyRun || isVwDirty || (DPR !== window.devicePixelRatio) ) {
				updateMetrics();
			}
		};
	
		// If picture is supported, well, that's awesome.
		if ( pf.supPicture ) {
			picturefill = noop;
			pf.fillImg = noop;
		} else {
	
			 // Set up picture polyfill by polling the document
			(function() {
				var isDomReady;
				var regReady = window.attachEvent ? /d$|^c/ : /d$|^c|^i/;
	
				var run = function() {
					var readyState = document.readyState || "";
	
					timerId = setTimeout(run, readyState === "loading" ? 200 :  999);
					if ( document.body ) {
						pf.fillImgs();
						isDomReady = isDomReady || regReady.test(readyState);
						if ( isDomReady ) {
							clearTimeout( timerId );
						}
	
					}
				};
	
				var timerId = setTimeout(run, document.body ? 9 : 99);
	
				// Also attach picturefill on resize and readystatechange
				// http://modernjavascript.blogspot.com/2013/08/building-better-debounce.html
				var debounce = function(func, wait) {
					var timeout, timestamp;
					var later = function() {
						var last = (new Date()) - timestamp;
	
						if (last < wait) {
							timeout = setTimeout(later, wait - last);
						} else {
							timeout = null;
							func();
						}
					};
	
					return function() {
						timestamp = new Date();
	
						if (!timeout) {
							timeout = setTimeout(later, wait);
						}
					};
				};
				var lastClientWidth = docElem.clientHeight;
				var onResize = function() {
					isVwDirty = Math.max(window.innerWidth || 0, docElem.clientWidth) !== units.width || docElem.clientHeight !== lastClientWidth;
					lastClientWidth = docElem.clientHeight;
					if ( isVwDirty ) {
						pf.fillImgs();
					}
				};
	
				on( window, "resize", debounce(onResize, 99 ) );
				on( document, "readystatechange", run );
			})();
		}
	
		pf.picturefill = picturefill;
		//use this internally for easy monkey patching/performance testing
		pf.fillImgs = picturefill;
		pf.teardownRun = noop;
	
		/* expose methods for testing */
		picturefill._ = pf;
	
		window.picturefillCFG = {
			pf: pf,
			push: function(args) {
				var name = args.shift();
				if (typeof pf[name] === "function") {
					pf[name].apply(pf, args);
				} else {
					cfg[name] = args[0];
					if (alreadyRun) {
						pf.fillImgs( { reselect: true } );
					}
				}
			}
		};
	
		while (setOptions && setOptions.length) {
			window.picturefillCFG.push(setOptions.shift());
		}
	
		/* expose picturefill */
		window.picturefill = picturefill;
	
		/* expose picturefill */
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// CommonJS, just export
			module.exports = picturefill;
		} else if ( true ) {
			// AMD support
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return picturefill; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
		// IE8 evals this sync, so it must be the last thing we do
		if ( !pf.supPicture ) {
			types[ "image/webp" ] = detectTypeSupport("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==" );
		}
	
	} )( window, document );


/***/ },
/* 1843 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};


/***/ },
/* 1844 */
[2137, 1843, 1479],
/* 1845 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 1846 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 1847 */
/***/ function(module, exports) {

	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */
	
	module.exports = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];
	
	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};

/***/ },
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2012-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var mixin, xWWWFormURLEncoder, origin, urlRE, absoluteUrlRE, fullyQualifiedUrlRE;
	
	mixin = __webpack_require__(934);
	xWWWFormURLEncoder = __webpack_require__(1485);
	
	urlRE = /([a-z][a-z0-9\+\-\.]*:)\/\/([^@]+@)?(([^:\/]+)(:([0-9]+))?)?(\/[^?#]*)?(\?[^#]*)?(#\S*)?/i;
	absoluteUrlRE = /^([a-z][a-z0-9\-\+\.]*:\/\/|\/)/i;
	fullyQualifiedUrlRE = /([a-z][a-z0-9\+\-\.]*:)\/\/([^@]+@)?(([^:\/]+)(:([0-9]+))?)?\//i;
	
	/**
	 * Apply params to the template to create a URL.
	 *
	 * Parameters that are not applied directly to the template, are appended
	 * to the URL as query string parameters.
	 *
	 * @param {string} template the URI template
	 * @param {Object} params parameters to apply to the template
	 * @return {string} the resulting URL
	 */
	function buildUrl(template, params) {
		// internal builder to convert template with params.
		var url, name, queryStringParams, queryString, re;
	
		url = template;
		queryStringParams = {};
	
		if (params) {
			for (name in params) {
				/*jshint forin:false */
				re = new RegExp('\\{' + name + '\\}');
				if (re.test(url)) {
					url = url.replace(re, encodeURIComponent(params[name]), 'g');
				}
				else {
					queryStringParams[name] = params[name];
				}
			}
	
			queryString = xWWWFormURLEncoder.write(queryStringParams);
			if (queryString) {
				url += url.indexOf('?') === -1 ? '?' : '&';
				url += queryString;
			}
		}
		return url;
	}
	
	function startsWith(str, test) {
		return str.indexOf(test) === 0;
	}
	
	/**
	 * Create a new URL Builder
	 *
	 * @param {string|UrlBuilder} template the base template to build from, may be another UrlBuilder
	 * @param {Object} [params] base parameters
	 * @constructor
	 */
	function UrlBuilder(template, params) {
		if (!(this instanceof UrlBuilder)) {
			// invoke as a constructor
			return new UrlBuilder(template, params);
		}
	
		if (template instanceof UrlBuilder) {
			this._template = template.template;
			this._params = mixin({}, this._params, params);
		}
		else {
			this._template = (template || '').toString();
			this._params = params || {};
		}
	}
	
	UrlBuilder.prototype = {
	
		/**
		 * Create a new UrlBuilder instance that extends the current builder.
		 * The current builder is unmodified.
		 *
		 * @param {string} [template] URL template to append to the current template
		 * @param {Object} [params] params to combine with current params.  New params override existing params
		 * @return {UrlBuilder} the new builder
		 */
		append: function (template,  params) {
			// TODO consider query strings and fragments
			return new UrlBuilder(this._template + template, mixin({}, this._params, params));
		},
	
		/**
		 * Create a new UrlBuilder with a fully qualified URL based on the
		 * window's location or base href and the current templates relative URL.
		 *
		 * Path variables are preserved.
		 *
		 * *Browser only*
		 *
		 * @return {UrlBuilder} the fully qualified URL template
		 */
		fullyQualify: function () {
			if (typeof location === 'undefined') { return this; }
			if (this.isFullyQualified()) { return this; }
	
			var template = this._template;
	
			if (startsWith(template, '//')) {
				template = origin.protocol + template;
			}
			else if (startsWith(template, '/')) {
				template = origin.origin + template;
			}
			else if (!this.isAbsolute()) {
				template = origin.origin + origin.pathname.substring(0, origin.pathname.lastIndexOf('/') + 1);
			}
	
			if (template.indexOf('/', 8) === -1) {
				// default the pathname to '/'
				template = template + '/';
			}
	
			return new UrlBuilder(template, this._params);
		},
	
		/**
		 * True if the URL is absolute
		 *
		 * @return {boolean}
		 */
		isAbsolute: function () {
			return absoluteUrlRE.test(this.build());
		},
	
		/**
		 * True if the URL is fully qualified
		 *
		 * @return {boolean}
		 */
		isFullyQualified: function () {
			return fullyQualifiedUrlRE.test(this.build());
		},
	
		/**
		 * True if the URL is cross origin. The protocol, host and port must not be
		 * the same in order to be cross origin,
		 *
		 * @return {boolean}
		 */
		isCrossOrigin: function () {
			if (!origin) {
				return true;
			}
			var url = this.parts();
			return url.protocol !== origin.protocol ||
			       url.hostname !== origin.hostname ||
			       url.port !== origin.port;
		},
	
		/**
		 * Split a URL into its consituent parts following the naming convention of
		 * 'window.location'. One difference is that the port will contain the
		 * protocol default if not specified.
		 *
		 * @see https://developer.mozilla.org/en-US/docs/DOM/window.location
		 *
		 * @returns {Object} a 'window.location'-like object
		 */
		parts: function () {
			/*jshint maxcomplexity:20 */
			var url, parts;
			url = this.fullyQualify().build().match(urlRE);
			parts = {
				href: url[0],
				protocol: url[1],
				host: url[3] || '',
				hostname: url[4] || '',
				port: url[6],
				pathname: url[7] || '',
				search: url[8] || '',
				hash: url[9] || ''
			};
			parts.origin = parts.protocol + '//' + parts.host;
			parts.port = parts.port || (parts.protocol === 'https:' ? '443' : parts.protocol === 'http:' ? '80' : '');
			return parts;
		},
	
		/**
		 * Expand the template replacing path variables with parameters
		 *
		 * @param {Object} [params] params to combine with current params.  New params override existing params
		 * @return {string} the expanded URL
		 */
		build: function (params) {
			return buildUrl(this._template, mixin({}, this._params, params));
		},
	
		/**
		 * @see build
		 */
		toString: function () {
			return this.build();
		}
	
	};
	
	origin = typeof location !== 'undefined' ? new UrlBuilder(location.href).parts() : void 0;
	
	module.exports = UrlBuilder;


/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2014-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var rest = __webpack_require__(1481),
	    browser = __webpack_require__(1850);
	
	rest.setPlatformDefaultClient(browser);
	
	module.exports = rest;


/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2012-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var normalizeHeaderName, responsePromise, client, headerSplitRE;
	
	normalizeHeaderName = __webpack_require__(1487);
	responsePromise = __webpack_require__(1061);
	client = __webpack_require__(1060);
	
	// according to the spec, the line break is '\r\n', but doesn't hold true in practice
	headerSplitRE = /[\r|\n]+/;
	
	function parseHeaders(raw) {
		// Note: Set-Cookie will be removed by the browser
		var headers = {};
	
		if (!raw) { return headers; }
	
		raw.trim().split(headerSplitRE).forEach(function (header) {
			var boundary, name, value;
			boundary = header.indexOf(':');
			name = normalizeHeaderName(header.substring(0, boundary).trim());
			value = header.substring(boundary + 1).trim();
			if (headers[name]) {
				if (Array.isArray(headers[name])) {
					// add to an existing array
					headers[name].push(value);
				}
				else {
					// convert single value to array
					headers[name] = [headers[name], value];
				}
			}
			else {
				// new, single value
				headers[name] = value;
			}
		});
	
		return headers;
	}
	
	function safeMixin(target, source) {
		Object.keys(source || {}).forEach(function (prop) {
			// make sure the property already exists as
			// IE 6 will blow up if we add a new prop
			if (source.hasOwnProperty(prop) && prop in target) {
				try {
					target[prop] = source[prop];
				}
				catch (e) {
					// ignore, expected for some properties at some points in the request lifecycle
				}
			}
		});
	
		return target;
	}
	
	module.exports = client(function xhr(request) {
		return responsePromise.promise(function (resolve, reject) {
			/*jshint maxcomplexity:20 */
	
			var client, method, url, headers, entity, headerName, response, XHR;
	
			request = typeof request === 'string' ? { path: request } : request || {};
			response = { request: request };
	
			if (request.canceled) {
				response.error = 'precanceled';
				reject(response);
				return;
			}
	
			XHR = request.engine || XMLHttpRequest;
			if (!XHR) {
				reject({ request: request, error: 'xhr-not-available' });
				return;
			}
	
			entity = request.entity;
			request.method = request.method || (entity ? 'POST' : 'GET');
			method = request.method;
			url = response.url = request.path || '';
	
			try {
				client = response.raw = new XHR();
	
				// mixin extra request properties before and after opening the request as some properties require being set at different phases of the request
				safeMixin(client, request.mixin);
				client.open(method, url, true);
				safeMixin(client, request.mixin);
	
				headers = request.headers;
				for (headerName in headers) {
					/*jshint forin:false */
					if (headerName === 'Content-Type' && headers[headerName] === 'multipart/form-data') {
						// XMLHttpRequest generates its own Content-Type header with the
						// appropriate multipart boundary when sending multipart/form-data.
						continue;
					}
	
					client.setRequestHeader(headerName, headers[headerName]);
				}
	
				request.canceled = false;
				request.cancel = function cancel() {
					request.canceled = true;
					client.abort();
					reject(response);
				};
	
				client.onreadystatechange = function (/* e */) {
					if (request.canceled) { return; }
					if (client.readyState === (XHR.DONE || 4)) {
						response.status = {
							code: client.status,
							text: client.statusText
						};
						response.headers = parseHeaders(client.getAllResponseHeaders());
						response.entity = client.responseText;
	
						// #125 -- Sometimes IE8-9 uses 1223 instead of 204
						// http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
						if (response.status.code === 1223) {
							response.status.code = 204;
						}
	
						if (response.status.code > 0) {
							// check status code as readystatechange fires before error event
							resolve(response);
						}
						else {
							// give the error callback a chance to fire before resolving
							// requests for file:// URLs do not have a status code
							setTimeout(function () {
								resolve(response);
							}, 0);
						}
					}
				};
	
				try {
					client.onerror = function (/* e */) {
						response.error = 'loaderror';
						reject(response);
					};
				}
				catch (e) {
					// IE 6 will not support error handling
				}
	
				client.send(entity);
			}
			catch (e) {
				response.error = 'loaderror';
				reject(response);
			}
	
		});
	});


/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2013-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var interceptor, mixinUtil, defaulter;
	
	interceptor = __webpack_require__(471);
	mixinUtil = __webpack_require__(934);
	
	defaulter = (function () {
	
		function mixin(prop, target, defaults) {
			if (prop in target || prop in defaults) {
				target[prop] = mixinUtil({}, defaults[prop], target[prop]);
			}
		}
	
		function copy(prop, target, defaults) {
			if (prop in defaults && !(prop in target)) {
				target[prop] = defaults[prop];
			}
		}
	
		var mappings = {
			method: copy,
			path: copy,
			params: mixin,
			headers: mixin,
			entity: copy,
			mixin: mixin
		};
	
		return function (target, defaults) {
			for (var prop in mappings) {
				/*jshint forin: false */
				mappings[prop](prop, target, defaults);
			}
			return target;
		};
	
	}());
	
	/**
	 * Provide default values for a request. These values will be applied to the
	 * request if the request object does not already contain an explicit value.
	 *
	 * For 'params', 'headers', and 'mixin', individual values are mixed in with the
	 * request's values. The result is a new object representiing the combined
	 * request and config values. Neither input object is mutated.
	 *
	 * @param {Client} [client] client to wrap
	 * @param {string} [config.method] the default method
	 * @param {string} [config.path] the default path
	 * @param {Object} [config.params] the default params, mixed with the request's existing params
	 * @param {Object} [config.headers] the default headers, mixed with the request's existing headers
	 * @param {Object} [config.mixin] the default "mixins" (http/https options), mixed with the request's existing "mixins"
	 *
	 * @returns {Client}
	 */
	module.exports = interceptor({
		request: function handleRequest(request, config) {
			return defaulter(request, config);
		}
	});


/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2012-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var interceptor;
	
	interceptor = __webpack_require__(471);
	
	/**
	 * Rejects the response promise based on the status code.
	 *
	 * Codes greater than or equal to the provided value are rejected.  Default
	 * value 400.
	 *
	 * @param {Client} [client] client to wrap
	 * @param {number} [config.code=400] code to indicate a rejection
	 *
	 * @returns {Client}
	 */
	module.exports = interceptor({
		init: function (config) {
			config.code = config.code || 400;
			return config;
		},
		response: function (response, config) {
			if (response.status && response.status.code >= config.code) {
				return Promise.reject(response);
			}
			return response;
		}
	});


/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2012-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var interceptor, mime, registry, noopConverter, missingConverter, attempt;
	
	interceptor = __webpack_require__(471);
	mime = __webpack_require__(1484);
	registry = __webpack_require__(1854);
	attempt = __webpack_require__(1486);
	
	noopConverter = {
		read: function (obj) { return obj; },
		write: function (obj) { return obj; }
	};
	
	missingConverter = {
		read: function () { throw 'No read method found on converter'; },
		write: function () { throw 'No write method found on converter'; }
	};
	
	/**
	 * MIME type support for request and response entities.  Entities are
	 * (de)serialized using the converter for the MIME type.
	 *
	 * Request entities are converted using the desired converter and the
	 * 'Accept' request header prefers this MIME.
	 *
	 * Response entities are converted based on the Content-Type response header.
	 *
	 * @param {Client} [client] client to wrap
	 * @param {string} [config.mime='text/plain'] MIME type to encode the request
	 *   entity
	 * @param {string} [config.accept] Accept header for the request
	 * @param {Client} [config.client=<request.originator>] client passed to the
	 *   converter, defaults to the client originating the request
	 * @param {Registry} [config.registry] MIME registry, defaults to the root
	 *   registry
	 * @param {boolean} [config.permissive] Allow an unkown request MIME type
	 *
	 * @returns {Client}
	 */
	module.exports = interceptor({
		init: function (config) {
			config.registry = config.registry || registry;
			return config;
		},
		request: function (request, config) {
			var type, headers;
	
			headers = request.headers || (request.headers = {});
			type = mime.parse(headers['Content-Type'] || config.mime || 'text/plain');
			headers.Accept = headers.Accept || config.accept || type.raw + ', application/json;q=0.8, text/plain;q=0.5, */*;q=0.2';
	
			if (!('entity' in request)) {
				return request;
			}
	
			headers['Content-Type'] = type.raw;
	
			return config.registry.lookup(type)['catch'](function () {
				// failed to resolve converter
				if (config.permissive) {
					return noopConverter;
				}
				throw 'mime-unknown';
			}).then(function (converter) {
				var client = config.client || request.originator,
					write = converter.write || missingConverter.write;
	
				return attempt(write.bind(void 0, request.entity, { client: client, request: request, mime: type, registry: config.registry }))
					['catch'](function() {
						throw 'mime-serialization';
					})
					.then(function(entity) {
						request.entity = entity;
						return request;
					});
			});
		},
		response: function (response, config) {
			if (!(response.headers && response.headers['Content-Type'] && response.entity)) {
				return response;
			}
	
			var type = mime.parse(response.headers['Content-Type']);
	
			return config.registry.lookup(type)['catch'](function () { return noopConverter; }).then(function (converter) {
				var client = config.client || response.request && response.request.originator,
					read = converter.read || missingConverter.read;
	
				return attempt(read.bind(void 0, response.entity, { client: client, response: response, mime: type, registry: config.registry }))
					['catch'](function (e) {
						response.error = 'mime-deserialization';
						response.cause = e;
						throw response;
					})
					.then(function (entity) {
						response.entity = entity;
						return response;
					});
			});
		}
	});


/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2012-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var mime, registry;
	
	mime = __webpack_require__(1484);
	
	function Registry(mimes) {
	
		/**
		 * Lookup the converter for a MIME type
		 *
		 * @param {string} type the MIME type
		 * @return a promise for the converter
		 */
		this.lookup = function lookup(type) {
			var parsed;
	
			parsed = typeof type === 'string' ? mime.parse(type) : type;
	
			if (mimes[parsed.raw]) {
				return mimes[parsed.raw];
			}
			if (mimes[parsed.type + parsed.suffix]) {
				return mimes[parsed.type + parsed.suffix];
			}
			if (mimes[parsed.type]) {
				return mimes[parsed.type];
			}
			if (mimes[parsed.suffix]) {
				return mimes[parsed.suffix];
			}
	
			return Promise.reject(new Error('Unable to locate converter for mime "' + parsed.raw + '"'));
		};
	
		/**
		 * Create a late dispatched proxy to the target converter.
		 *
		 * Common when a converter is registered under multiple names and
		 * should be kept in sync if updated.
		 *
		 * @param {string} type mime converter to dispatch to
		 * @returns converter whose read/write methods target the desired mime converter
		 */
		this.delegate = function delegate(type) {
			return {
				read: function () {
					var args = arguments;
					return this.lookup(type).then(function (converter) {
						return converter.read.apply(this, args);
					}.bind(this));
				}.bind(this),
				write: function () {
					var args = arguments;
					return this.lookup(type).then(function (converter) {
						return converter.write.apply(this, args);
					}.bind(this));
				}.bind(this)
			};
		};
	
		/**
		 * Register a custom converter for a MIME type
		 *
		 * @param {string} type the MIME type
		 * @param converter the converter for the MIME type
		 * @return a promise for the converter
		 */
		this.register = function register(type, converter) {
			mimes[type] = Promise.resolve(converter);
			return mimes[type];
		};
	
		/**
		 * Create a child registry whoes registered converters remain local, while
		 * able to lookup converters from its parent.
		 *
		 * @returns child MIME registry
		 */
		this.child = function child() {
			return new Registry(Object.create(mimes));
		};
	
	}
	
	registry = new Registry({});
	
	// include provided serializers
	registry.register('application/hal', __webpack_require__(1855));
	registry.register('application/json', __webpack_require__(1856));
	registry.register('application/x-www-form-urlencoded', __webpack_require__(1485));
	registry.register('multipart/form-data', __webpack_require__(1857));
	registry.register('text/plain', __webpack_require__(1858));
	
	registry.register('+json', registry.delegate('application/json'));
	
	module.exports = registry;


/***/ },
/* 1855 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2013-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var pathPrefix, template, find, lazyPromise, responsePromise;
	
	pathPrefix = __webpack_require__(1482);
	template = __webpack_require__(1483);
	find = __webpack_require__(1861);
	lazyPromise = __webpack_require__(1862);
	responsePromise = __webpack_require__(1061);
	
	function defineProperty(obj, name, value) {
		Object.defineProperty(obj, name, {
			value: value,
			configurable: true,
			enumerable: false,
			writeable: true
		});
	}
	
	/**
	 * Hypertext Application Language serializer
	 *
	 * Implemented to https://tools.ietf.org/html/draft-kelly-json-hal-06
	 *
	 * As the spec is still a draft, this implementation will be updated as the
	 * spec evolves
	 *
	 * Objects are read as HAL indexing links and embedded objects on to the
	 * resource. Objects are written as plain JSON.
	 *
	 * Embedded relationships are indexed onto the resource by the relationship
	 * as a promise for the related resource.
	 *
	 * Links are indexed onto the resource as a lazy promise that will GET the
	 * resource when a handler is first registered on the promise.
	 *
	 * A `requestFor` method is added to the entity to make a request for the
	 * relationship.
	 *
	 * A `clientFor` method is added to the entity to get a full Client for a
	 * relationship.
	 *
	 * The `_links` and `_embedded` properties on the resource are made
	 * non-enumerable.
	 */
	module.exports = {
	
		read: function (str, opts) {
			var client, console;
	
			opts = opts || {};
			client = opts.client;
			console = opts.console || console;
	
			function deprecationWarning(relationship, deprecation) {
				if (deprecation && console && console.warn || console.log) {
					(console.warn || console.log).call(console, 'Relationship \'' + relationship + '\' is deprecated, see ' + deprecation);
				}
			}
	
			return opts.registry.lookup(opts.mime.suffix).then(function (converter) {
				return converter.read(str, opts);
			}).then(function (root) {
				find.findProperties(root, '_embedded', function (embedded, resource, name) {
					Object.keys(embedded).forEach(function (relationship) {
						if (relationship in resource) { return; }
						var related = responsePromise({
							entity: embedded[relationship]
						});
						defineProperty(resource, relationship, related);
					});
					defineProperty(resource, name, embedded);
				});
				find.findProperties(root, '_links', function (links, resource, name) {
					Object.keys(links).forEach(function (relationship) {
						var link = links[relationship];
						if (relationship in resource) { return; }
						defineProperty(resource, relationship, responsePromise.make(lazyPromise(function () {
							if (link.deprecation) { deprecationWarning(relationship, link.deprecation); }
							if (link.templated === true) {
								return template(client)({ path: link.href });
							}
							return client({ path: link.href });
						})));
					});
					defineProperty(resource, name, links);
					defineProperty(resource, 'clientFor', function (relationship, clientOverride) {
						var link = links[relationship];
						if (!link) {
							throw new Error('Unknown relationship: ' + relationship);
						}
						if (link.deprecation) { deprecationWarning(relationship, link.deprecation); }
						if (link.templated === true) {
							return template(
								clientOverride || client,
								{ template: link.href }
							);
						}
						return pathPrefix(
							clientOverride || client,
							{ prefix: link.href }
						);
					});
					defineProperty(resource, 'requestFor', function (relationship, request, clientOverride) {
						var client = this.clientFor(relationship, clientOverride);
						return client(request);
					});
				});
	
				return root;
			});
	
		},
	
		write: function (obj, opts) {
			return opts.registry.lookup(opts.mime.suffix).then(function (converter) {
				return converter.write(obj, opts);
			});
		}
	
	};


/***/ },
/* 1856 */
/***/ function(module, exports) {

	/*
	 * Copyright 2012-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	/**
	 * Create a new JSON converter with custom reviver/replacer.
	 *
	 * The extended converter must be published to a MIME registry in order
	 * to be used. The existing converter will not be modified.
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON
	 *
	 * @param {function} [reviver=undefined] custom JSON.parse reviver
	 * @param {function|Array} [replacer=undefined] custom JSON.stringify replacer
	 */
	function createConverter(reviver, replacer) {
		return {
	
			read: function (str) {
				return JSON.parse(str, reviver);
			},
	
			write: function (obj) {
				return JSON.stringify(obj, replacer);
			},
	
			extend: createConverter
	
		};
	}
	
	module.exports = createConverter();


/***/ },
/* 1857 */
/***/ function(module, exports) {

	/*
	 * Copyright 2014-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Michael Jackson
	 */
	
	/* global FormData, File, Blob */
	
	'use strict';
	
	function isFormElement(object) {
		return object &&
			object.nodeType === 1 && // Node.ELEMENT_NODE
			object.tagName === 'FORM';
	}
	
	function createFormDataFromObject(object) {
		var formData = new FormData();
	
		var value;
		for (var property in object) {
			if (object.hasOwnProperty(property)) {
				value = object[property];
	
				if (value instanceof File) {
					formData.append(property, value, value.name);
				} else if (value instanceof Blob) {
					formData.append(property, value);
				} else {
					formData.append(property, String(value));
				}
			}
		}
	
		return formData;
	}
	
	module.exports = {
	
		write: function (object) {
			if (typeof FormData === 'undefined') {
				throw new Error('The multipart/form-data mime serializer requires FormData support');
			}
	
			// Support FormData directly.
			if (object instanceof FormData) {
				return object;
			}
	
			// Support <form> elements.
			if (isFormElement(object)) {
				return new FormData(object);
			}
	
			// Support plain objects, may contain File/Blob as value.
			if (typeof object === 'object' && object !== null) {
				return createFormDataFromObject(object);
			}
	
			throw new Error('Unable to create FormData from object ' + object);
		}
	
	};


/***/ },
/* 1858 */
/***/ function(module, exports) {

	/*
	 * Copyright 2012-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	module.exports = {
	
		read: function (str) {
			return str;
		},
	
		write: function (obj) {
			return obj.toString();
		}
	
	};


/***/ },
/* 1859 */
/***/ function(module, exports) {

	module.exports = (function(){
	  /*
	   * Generated by PEG.js 0.7.0.
	   *
	   * http://pegjs.majda.cz/
	   */
	
	  function quote(s) {
	    /*
	     * ECMA-262, 5th ed., 7.8.4: All characters may appear literally in a
	     * string literal except for the closing quote character, backslash,
	     * carriage return, line separator, paragraph separator, and line feed.
	     * Any character may appear in the form of an escape sequence.
	     *
	     * For portability, we also escape escape all control and non-ASCII
	     * characters. Note that "\0" and "\v" escape sequences are not used
	     * because JSHint does not like the first and IE the second.
	     */
	     return '"' + s
	      .replace(/\\/g, '\\\\')  // backslash
	      .replace(/"/g, '\\"')    // closing quote character
	      .replace(/\x08/g, '\\b') // backspace
	      .replace(/\t/g, '\\t')   // horizontal tab
	      .replace(/\n/g, '\\n')   // line feed
	      .replace(/\f/g, '\\f')   // form feed
	      .replace(/\r/g, '\\r')   // carriage return
	      .replace(/[\x00-\x07\x0B\x0E-\x1F\x80-\uFFFF]/g, escape)
	      + '"';
	  }
	
	  var result = {
	    /*
	     * Parses the input with a generated parser. If the parsing is successfull,
	     * returns a value explicitly or implicitly specified by the grammar from
	     * which the parser was generated (see |PEG.buildParser|). If the parsing is
	     * unsuccessful, throws |PEG.parser.SyntaxError| describing the error.
	     */
	    parse: function(input, startRule) {
	      var parseFunctions = {
	        "start": parse_start,
	        "LinkValue": parse_LinkValue,
	        "LinkParams": parse_LinkParams,
	        "URIReference": parse_URIReference,
	        "LinkParam": parse_LinkParam,
	        "LinkParamName": parse_LinkParamName,
	        "LinkParamValue": parse_LinkParamValue,
	        "PToken": parse_PToken,
	        "PTokenChar": parse_PTokenChar,
	        "OptionalSP": parse_OptionalSP,
	        "QuotedString": parse_QuotedString,
	        "QuotedStringInternal": parse_QuotedStringInternal,
	        "Char": parse_Char,
	        "UpAlpha": parse_UpAlpha,
	        "LoAlpha": parse_LoAlpha,
	        "Alpha": parse_Alpha,
	        "Digit": parse_Digit,
	        "SP": parse_SP,
	        "DQ": parse_DQ,
	        "QDText": parse_QDText,
	        "QuotedPair": parse_QuotedPair
	      };
	
	      if (startRule !== undefined) {
	        if (parseFunctions[startRule] === undefined) {
	          throw new Error("Invalid rule name: " + quote(startRule) + ".");
	        }
	      } else {
	        startRule = "start";
	      }
	
	      var pos = 0;
	      var reportFailures = 0;
	      var rightmostFailuresPos = 0;
	      var rightmostFailuresExpected = [];
	
	      function padLeft(input, padding, length) {
	        var result = input;
	
	        var padLength = length - input.length;
	        for (var i = 0; i < padLength; i++) {
	          result = padding + result;
	        }
	
	        return result;
	      }
	
	      function escape(ch) {
	        var charCode = ch.charCodeAt(0);
	        var escapeChar;
	        var length;
	
	        if (charCode <= 0xFF) {
	          escapeChar = 'x';
	          length = 2;
	        } else {
	          escapeChar = 'u';
	          length = 4;
	        }
	
	        return '\\' + escapeChar + padLeft(charCode.toString(16).toUpperCase(), '0', length);
	      }
	
	      function matchFailed(failure) {
	        if (pos < rightmostFailuresPos) {
	          return;
	        }
	
	        if (pos > rightmostFailuresPos) {
	          rightmostFailuresPos = pos;
	          rightmostFailuresExpected = [];
	        }
	
	        rightmostFailuresExpected.push(failure);
	      }
	
	      function parse_start() {
	        var result0, result1, result2, result3, result4;
	        var pos0, pos1, pos2, pos3;
	
	        pos0 = pos;
	        pos1 = pos;
	        result0 = [];
	        pos2 = pos;
	        pos3 = pos;
	        result1 = parse_LinkValue();
	        if (result1 !== null) {
	          result2 = parse_OptionalSP();
	          if (result2 !== null) {
	            if (input.charCodeAt(pos) === 44) {
	              result3 = ",";
	              pos++;
	            } else {
	              result3 = null;
	              if (reportFailures === 0) {
	                matchFailed("\",\"");
	              }
	            }
	            if (result3 !== null) {
	              result4 = parse_OptionalSP();
	              if (result4 !== null) {
	                result1 = [result1, result2, result3, result4];
	              } else {
	                result1 = null;
	                pos = pos3;
	              }
	            } else {
	              result1 = null;
	              pos = pos3;
	            }
	          } else {
	            result1 = null;
	            pos = pos3;
	          }
	        } else {
	          result1 = null;
	          pos = pos3;
	        }
	        if (result1 !== null) {
	          result1 = (function(offset, i) {return i;})(pos2, result1[0]);
	        }
	        if (result1 === null) {
	          pos = pos2;
	        }
	        while (result1 !== null) {
	          result0.push(result1);
	          pos2 = pos;
	          pos3 = pos;
	          result1 = parse_LinkValue();
	          if (result1 !== null) {
	            result2 = parse_OptionalSP();
	            if (result2 !== null) {
	              if (input.charCodeAt(pos) === 44) {
	                result3 = ",";
	                pos++;
	              } else {
	                result3 = null;
	                if (reportFailures === 0) {
	                  matchFailed("\",\"");
	                }
	              }
	              if (result3 !== null) {
	                result4 = parse_OptionalSP();
	                if (result4 !== null) {
	                  result1 = [result1, result2, result3, result4];
	                } else {
	                  result1 = null;
	                  pos = pos3;
	                }
	              } else {
	                result1 = null;
	                pos = pos3;
	              }
	            } else {
	              result1 = null;
	              pos = pos3;
	            }
	          } else {
	            result1 = null;
	            pos = pos3;
	          }
	          if (result1 !== null) {
	            result1 = (function(offset, i) {return i;})(pos2, result1[0]);
	          }
	          if (result1 === null) {
	            pos = pos2;
	          }
	        }
	        if (result0 !== null) {
	          result1 = parse_LinkValue();
	          if (result1 !== null) {
	            result0 = [result0, result1];
	          } else {
	            result0 = null;
	            pos = pos1;
	          }
	        } else {
	          result0 = null;
	          pos = pos1;
	        }
	        if (result0 !== null) {
	          result0 = (function(offset, start, last) { return start.concat([last]) })(pos0, result0[0], result0[1]);
	        }
	        if (result0 === null) {
	          pos = pos0;
	        }
	        return result0;
	      }
	
	      function parse_LinkValue() {
	        var result0, result1, result2, result3, result4, result5;
	        var pos0, pos1;
	
	        pos0 = pos;
	        pos1 = pos;
	        if (input.charCodeAt(pos) === 60) {
	          result0 = "<";
	          pos++;
	        } else {
	          result0 = null;
	          if (reportFailures === 0) {
	            matchFailed("\"<\"");
	          }
	        }
	        if (result0 !== null) {
	          result1 = parse_URIReference();
	          if (result1 !== null) {
	            if (input.charCodeAt(pos) === 62) {
	              result2 = ">";
	              pos++;
	            } else {
	              result2 = null;
	              if (reportFailures === 0) {
	                matchFailed("\">\"");
	              }
	            }
	            if (result2 !== null) {
	              result3 = parse_OptionalSP();
	              if (result3 !== null) {
	                result4 = [];
	                result5 = parse_LinkParams();
	                while (result5 !== null) {
	                  result4.push(result5);
	                  result5 = parse_LinkParams();
	                }
	                if (result4 !== null) {
	                  result0 = [result0, result1, result2, result3, result4];
	                } else {
	                  result0 = null;
	                  pos = pos1;
	                }
	              } else {
	                result0 = null;
	                pos = pos1;
	              }
	            } else {
	              result0 = null;
	              pos = pos1;
	            }
	          } else {
	            result0 = null;
	            pos = pos1;
	          }
	        } else {
	          result0 = null;
	          pos = pos1;
	        }
	        if (result0 !== null) {
	          result0 = (function(offset, href, params) {
	            var link = {};
	            params.forEach(function (param) {
	              link[param[0]] = param[1];
	            });
	            link.href = href;
	            return link;
	          })(pos0, result0[1], result0[4]);
	        }
	        if (result0 === null) {
	          pos = pos0;
	        }
	        return result0;
	      }
	
	      function parse_LinkParams() {
	        var result0, result1, result2, result3;
	        var pos0, pos1;
	
	        pos0 = pos;
	        pos1 = pos;
	        if (input.charCodeAt(pos) === 59) {
	          result0 = ";";
	          pos++;
	        } else {
	          result0 = null;
	          if (reportFailures === 0) {
	            matchFailed("\";\"");
	          }
	        }
	        if (result0 !== null) {
	          result1 = parse_OptionalSP();
	          if (result1 !== null) {
	            result2 = parse_LinkParam();
	            if (result2 !== null) {
	              result3 = parse_OptionalSP();
	              if (result3 !== null) {
	                result0 = [result0, result1, result2, result3];
	              } else {
	                result0 = null;
	                pos = pos1;
	              }
	            } else {
	              result0 = null;
	              pos = pos1;
	            }
	          } else {
	            result0 = null;
	            pos = pos1;
	          }
	        } else {
	          result0 = null;
	          pos = pos1;
	        }
	        if (result0 !== null) {
	          result0 = (function(offset, param) { return param })(pos0, result0[2]);
	        }
	        if (result0 === null) {
	          pos = pos0;
	        }
	        return result0;
	      }
	
	      function parse_URIReference() {
	        var result0, result1;
	        var pos0;
	
	        pos0 = pos;
	        if (/^[^>]/.test(input.charAt(pos))) {
	          result1 = input.charAt(pos);
	          pos++;
	        } else {
	          result1 = null;
	          if (reportFailures === 0) {
	            matchFailed("[^>]");
	          }
	        }
	        if (result1 !== null) {
	          result0 = [];
	          while (result1 !== null) {
	            result0.push(result1);
	            if (/^[^>]/.test(input.charAt(pos))) {
	              result1 = input.charAt(pos);
	              pos++;
	            } else {
	              result1 = null;
	              if (reportFailures === 0) {
	                matchFailed("[^>]");
	              }
	            }
	          }
	        } else {
	          result0 = null;
	        }
	        if (result0 !== null) {
	          result0 = (function(offset, url) { return url.join('') })(pos0, result0);
	        }
	        if (result0 === null) {
	          pos = pos0;
	        }
	        return result0;
	      }
	
	      function parse_LinkParam() {
	        var result0, result1;
	        var pos0, pos1;
	
	        pos0 = pos;
	        pos1 = pos;
	        result0 = parse_LinkParamName();
	        if (result0 !== null) {
	          result1 = parse_LinkParamValue();
	          result1 = result1 !== null ? result1 : "";
	          if (result1 !== null) {
	            result0 = [result0, result1];
	          } else {
	            result0 = null;
	            pos = pos1;
	          }
	        } else {
	          result0 = null;
	          pos = pos1;
	        }
	        if (result0 !== null) {
	          result0 = (function(offset, name, value) { return [name, value] })(pos0, result0[0], result0[1]);
	        }
	        if (result0 === null) {
	          pos = pos0;
	        }
	        return result0;
	      }
	
	      function parse_LinkParamName() {
	        var result0, result1;
	        var pos0;
	
	        pos0 = pos;
	        if (/^[a-z]/.test(input.charAt(pos))) {
	          result1 = input.charAt(pos);
	          pos++;
	        } else {
	          result1 = null;
	          if (reportFailures === 0) {
	            matchFailed("[a-z]");
	          }
	        }
	        if (result1 !== null) {
	          result0 = [];
	          while (result1 !== null) {
	            result0.push(result1);
	            if (/^[a-z]/.test(input.charAt(pos))) {
	              result1 = input.charAt(pos);
	              pos++;
	            } else {
	              result1 = null;
	              if (reportFailures === 0) {
	                matchFailed("[a-z]");
	              }
	            }
	          }
	        } else {
	          result0 = null;
	        }
	        if (result0 !== null) {
	          result0 = (function(offset, name) { return name.join('') })(pos0, result0);
	        }
	        if (result0 === null) {
	          pos = pos0;
	        }
	        return result0;
	      }
	
	      function parse_LinkParamValue() {
	        var result0, result1;
	        var pos0, pos1;
	
	        pos0 = pos;
	        pos1 = pos;
	        if (input.charCodeAt(pos) === 61) {
	          result0 = "=";
	          pos++;
	        } else {
	          result0 = null;
	          if (reportFailures === 0) {
	            matchFailed("\"=\"");
	          }
	        }
	        if (result0 !== null) {
	          result1 = parse_PToken();
	          if (result1 === null) {
	            result1 = parse_QuotedString();
	          }
	          if (result1 !== null) {
	            result0 = [result0, result1];
	          } else {
	            result0 = null;
	            pos = pos1;
	          }
	        } else {
	          result0 = null;
	          pos = pos1;
	        }
	        if (result0 !== null) {
	          result0 = (function(offset, str) { return str })(pos0, result0[1]);
	        }
	        if (result0 === null) {
	          pos = pos0;
	        }
	        return result0;
	      }
	
	      function parse_PToken() {
	        var result0, result1;
	        var pos0;
	
	        pos0 = pos;
	        result1 = parse_PTokenChar();
	        if (result1 !== null) {
	          result0 = [];
	          while (result1 !== null) {
	            result0.push(result1);
	            result1 = parse_PTokenChar();
	          }
	        } else {
	          result0 = null;
	        }
	        if (result0 !== null) {
	          result0 = (function(offset, token) { return token.join('') })(pos0, result0);
	        }
	        if (result0 === null) {
	          pos = pos0;
	        }
	        return result0;
	      }
	
	      function parse_PTokenChar() {
	        var result0;
	
	        if (input.charCodeAt(pos) === 33) {
	          result0 = "!";
	          pos++;
	        } else {
	          result0 = null;
	          if (reportFailures === 0) {
	            matchFailed("\"!\"");
	          }
	        }
	        if (result0 === null) {
	          if (input.charCodeAt(pos) === 35) {
	            result0 = "#";
	            pos++;
	          } else {
	            result0 = null;
	            if (reportFailures === 0) {
	              matchFailed("\"#\"");
	            }
	          }
	          if (result0 === null) {
	            if (input.charCodeAt(pos) === 36) {
	              result0 = "$";
	              pos++;
	            } else {
	              result0 = null;
	              if (reportFailures === 0) {
	                matchFailed("\"$\"");
	              }
	            }
	            if (result0 === null) {
	              if (input.charCodeAt(pos) === 37) {
	                result0 = "%";
	                pos++;
	              } else {
	                result0 = null;
	                if (reportFailures === 0) {
	                  matchFailed("\"%\"");
	                }
	              }
	              if (result0 === null) {
	                if (input.charCodeAt(pos) === 38) {
	                  result0 = "&";
	                  pos++;
	                } else {
	                  result0 = null;
	                  if (reportFailures === 0) {
	                    matchFailed("\"&\"");
	                  }
	                }
	                if (result0 === null) {
	                  if (input.charCodeAt(pos) === 39) {
	                    result0 = "'";
	                    pos++;
	                  } else {
	                    result0 = null;
	                    if (reportFailures === 0) {
	                      matchFailed("\"'\"");
	                    }
	                  }
	                  if (result0 === null) {
	                    if (input.charCodeAt(pos) === 40) {
	                      result0 = "(";
	                      pos++;
	                    } else {
	                      result0 = null;
	                      if (reportFailures === 0) {
	                        matchFailed("\"(\"");
	                      }
	                    }
	                    if (result0 === null) {
	                      if (input.charCodeAt(pos) === 41) {
	                        result0 = ")";
	                        pos++;
	                      } else {
	                        result0 = null;
	                        if (reportFailures === 0) {
	                          matchFailed("\")\"");
	                        }
	                      }
	                      if (result0 === null) {
	                        if (input.charCodeAt(pos) === 42) {
	                          result0 = "*";
	                          pos++;
	                        } else {
	                          result0 = null;
	                          if (reportFailures === 0) {
	                            matchFailed("\"*\"");
	                          }
	                        }
	                        if (result0 === null) {
	                          if (input.charCodeAt(pos) === 43) {
	                            result0 = "+";
	                            pos++;
	                          } else {
	                            result0 = null;
	                            if (reportFailures === 0) {
	                              matchFailed("\"+\"");
	                            }
	                          }
	                          if (result0 === null) {
	                            if (input.charCodeAt(pos) === 45) {
	                              result0 = "-";
	                              pos++;
	                            } else {
	                              result0 = null;
	                              if (reportFailures === 0) {
	                                matchFailed("\"-\"");
	                              }
	                            }
	                            if (result0 === null) {
	                              if (input.charCodeAt(pos) === 46) {
	                                result0 = ".";
	                                pos++;
	                              } else {
	                                result0 = null;
	                                if (reportFailures === 0) {
	                                  matchFailed("\".\"");
	                                }
	                              }
	                              if (result0 === null) {
	                                if (input.charCodeAt(pos) === 124) {
	                                  result0 = "|";
	                                  pos++;
	                                } else {
	                                  result0 = null;
	                                  if (reportFailures === 0) {
	                                    matchFailed("\"|\"");
	                                  }
	                                }
	                                if (result0 === null) {
	                                  result0 = parse_Digit();
	                                  if (result0 === null) {
	                                    if (input.charCodeAt(pos) === 58) {
	                                      result0 = ":";
	                                      pos++;
	                                    } else {
	                                      result0 = null;
	                                      if (reportFailures === 0) {
	                                        matchFailed("\":\"");
	                                      }
	                                    }
	                                    if (result0 === null) {
	                                      if (input.charCodeAt(pos) === 60) {
	                                        result0 = "<";
	                                        pos++;
	                                      } else {
	                                        result0 = null;
	                                        if (reportFailures === 0) {
	                                          matchFailed("\"<\"");
	                                        }
	                                      }
	                                      if (result0 === null) {
	                                        if (input.charCodeAt(pos) === 61) {
	                                          result0 = "=";
	                                          pos++;
	                                        } else {
	                                          result0 = null;
	                                          if (reportFailures === 0) {
	                                            matchFailed("\"=\"");
	                                          }
	                                        }
	                                        if (result0 === null) {
	                                          if (input.charCodeAt(pos) === 62) {
	                                            result0 = ">";
	                                            pos++;
	                                          } else {
	                                            result0 = null;
	                                            if (reportFailures === 0) {
	                                              matchFailed("\">\"");
	                                            }
	                                          }
	                                          if (result0 === null) {
	                                            if (input.charCodeAt(pos) === 63) {
	                                              result0 = "?";
	                                              pos++;
	                                            } else {
	                                              result0 = null;
	                                              if (reportFailures === 0) {
	                                                matchFailed("\"?\"");
	                                              }
	                                            }
	                                            if (result0 === null) {
	                                              if (input.charCodeAt(pos) === 64) {
	                                                result0 = "@";
	                                                pos++;
	                                              } else {
	                                                result0 = null;
	                                                if (reportFailures === 0) {
	                                                  matchFailed("\"@\"");
	                                                }
	                                              }
	                                              if (result0 === null) {
	                                                result0 = parse_Alpha();
	                                                if (result0 === null) {
	                                                  if (input.charCodeAt(pos) === 91) {
	                                                    result0 = "[";
	                                                    pos++;
	                                                  } else {
	                                                    result0 = null;
	                                                    if (reportFailures === 0) {
	                                                      matchFailed("\"[\"");
	                                                    }
	                                                  }
	                                                  if (result0 === null) {
	                                                    if (input.charCodeAt(pos) === 93) {
	                                                      result0 = "]";
	                                                      pos++;
	                                                    } else {
	                                                      result0 = null;
	                                                      if (reportFailures === 0) {
	                                                        matchFailed("\"]\"");
	                                                      }
	                                                    }
	                                                    if (result0 === null) {
	                                                      if (input.charCodeAt(pos) === 94) {
	                                                        result0 = "^";
	                                                        pos++;
	                                                      } else {
	                                                        result0 = null;
	                                                        if (reportFailures === 0) {
	                                                          matchFailed("\"^\"");
	                                                        }
	                                                      }
	                                                      if (result0 === null) {
	                                                        if (input.charCodeAt(pos) === 95) {
	                                                          result0 = "_";
	                                                          pos++;
	                                                        } else {
	                                                          result0 = null;
	                                                          if (reportFailures === 0) {
	                                                            matchFailed("\"_\"");
	                                                          }
	                                                        }
	                                                        if (result0 === null) {
	                                                          if (input.charCodeAt(pos) === 96) {
	                                                            result0 = "`";
	                                                            pos++;
	                                                          } else {
	                                                            result0 = null;
	                                                            if (reportFailures === 0) {
	                                                              matchFailed("\"`\"");
	                                                            }
	                                                          }
	                                                          if (result0 === null) {
	                                                            if (input.charCodeAt(pos) === 123) {
	                                                              result0 = "{";
	                                                              pos++;
	                                                            } else {
	                                                              result0 = null;
	                                                              if (reportFailures === 0) {
	                                                                matchFailed("\"{\"");
	                                                              }
	                                                            }
	                                                            if (result0 === null) {
	                                                              if (/^[\/\/]/.test(input.charAt(pos))) {
	                                                                result0 = input.charAt(pos);
	                                                                pos++;
	                                                              } else {
	                                                                result0 = null;
	                                                                if (reportFailures === 0) {
	                                                                  matchFailed("[\\/\\/]");
	                                                                }
	                                                              }
	                                                              if (result0 === null) {
	                                                                if (input.charCodeAt(pos) === 125) {
	                                                                  result0 = "}";
	                                                                  pos++;
	                                                                } else {
	                                                                  result0 = null;
	                                                                  if (reportFailures === 0) {
	                                                                    matchFailed("\"}\"");
	                                                                  }
	                                                                }
	                                                                if (result0 === null) {
	                                                                  if (input.charCodeAt(pos) === 126) {
	                                                                    result0 = "~";
	                                                                    pos++;
	                                                                  } else {
	                                                                    result0 = null;
	                                                                    if (reportFailures === 0) {
	                                                                      matchFailed("\"~\"");
	                                                                    }
	                                                                  }
	                                                                }
	                                                              }
	                                                            }
	                                                          }
	                                                        }
	                                                      }
	                                                    }
	                                                  }
	                                                }
	                                              }
	                                            }
	                                          }
	                                        }
	                                      }
	                                    }
	                                  }
	                                }
	                              }
	                            }
	                          }
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	        return result0;
	      }
	
	      function parse_OptionalSP() {
	        var result0, result1;
	
	        result0 = [];
	        result1 = parse_SP();
	        while (result1 !== null) {
	          result0.push(result1);
	          result1 = parse_SP();
	        }
	        return result0;
	      }
	
	      function parse_QuotedString() {
	        var result0, result1, result2;
	        var pos0, pos1;
	
	        pos0 = pos;
	        pos1 = pos;
	        result0 = parse_DQ();
	        if (result0 !== null) {
	          result1 = parse_QuotedStringInternal();
	          if (result1 !== null) {
	            result2 = parse_DQ();
	            if (result2 !== null) {
	              result0 = [result0, result1, result2];
	            } else {
	              result0 = null;
	              pos = pos1;
	            }
	          } else {
	            result0 = null;
	            pos = pos1;
	          }
	        } else {
	          result0 = null;
	          pos = pos1;
	        }
	        if (result0 !== null) {
	          result0 = (function(offset, str) { return str })(pos0, result0[1]);
	        }
	        if (result0 === null) {
	          pos = pos0;
	        }
	        return result0;
	      }
	
	      function parse_QuotedStringInternal() {
	        var result0, result1;
	        var pos0;
	
	        pos0 = pos;
	        result0 = [];
	        result1 = parse_QDText();
	        if (result1 === null) {
	          result1 = parse_QuotedPair();
	        }
	        while (result1 !== null) {
	          result0.push(result1);
	          result1 = parse_QDText();
	          if (result1 === null) {
	            result1 = parse_QuotedPair();
	          }
	        }
	        if (result0 !== null) {
	          result0 = (function(offset, str) { return str.join('') })(pos0, result0);
	        }
	        if (result0 === null) {
	          pos = pos0;
	        }
	        return result0;
	      }
	
	      function parse_Char() {
	        var result0;
	
	        if (/^[\0-]/.test(input.charAt(pos))) {
	          result0 = input.charAt(pos);
	          pos++;
	        } else {
	          result0 = null;
	          if (reportFailures === 0) {
	            matchFailed("[\\0-]");
	          }
	        }
	        return result0;
	      }
	
	      function parse_UpAlpha() {
	        var result0;
	
	        if (/^[A-Z]/.test(input.charAt(pos))) {
	          result0 = input.charAt(pos);
	          pos++;
	        } else {
	          result0 = null;
	          if (reportFailures === 0) {
	            matchFailed("[A-Z]");
	          }
	        }
	        return result0;
	      }
	
	      function parse_LoAlpha() {
	        var result0;
	
	        if (/^[a-z]/.test(input.charAt(pos))) {
	          result0 = input.charAt(pos);
	          pos++;
	        } else {
	          result0 = null;
	          if (reportFailures === 0) {
	            matchFailed("[a-z]");
	          }
	        }
	        return result0;
	      }
	
	      function parse_Alpha() {
	        var result0;
	
	        result0 = parse_UpAlpha();
	        if (result0 === null) {
	          result0 = parse_LoAlpha();
	        }
	        return result0;
	      }
	
	      function parse_Digit() {
	        var result0;
	
	        if (/^[0-9]/.test(input.charAt(pos))) {
	          result0 = input.charAt(pos);
	          pos++;
	        } else {
	          result0 = null;
	          if (reportFailures === 0) {
	            matchFailed("[0-9]");
	          }
	        }
	        return result0;
	      }
	
	      function parse_SP() {
	        var result0;
	
	        if (/^[ ]/.test(input.charAt(pos))) {
	          result0 = input.charAt(pos);
	          pos++;
	        } else {
	          result0 = null;
	          if (reportFailures === 0) {
	            matchFailed("[ ]");
	          }
	        }
	        return result0;
	      }
	
	      function parse_DQ() {
	        var result0;
	
	        if (/^["]/.test(input.charAt(pos))) {
	          result0 = input.charAt(pos);
	          pos++;
	        } else {
	          result0 = null;
	          if (reportFailures === 0) {
	            matchFailed("[\"]");
	          }
	        }
	        return result0;
	      }
	
	      function parse_QDText() {
	        var result0;
	
	        if (/^[^"]/.test(input.charAt(pos))) {
	          result0 = input.charAt(pos);
	          pos++;
	        } else {
	          result0 = null;
	          if (reportFailures === 0) {
	            matchFailed("[^\"]");
	          }
	        }
	        return result0;
	      }
	
	      function parse_QuotedPair() {
	        var result0, result1;
	        var pos0;
	
	        pos0 = pos;
	        if (/^[\\]/.test(input.charAt(pos))) {
	          result0 = input.charAt(pos);
	          pos++;
	        } else {
	          result0 = null;
	          if (reportFailures === 0) {
	            matchFailed("[\\\\]");
	          }
	        }
	        if (result0 !== null) {
	          result1 = parse_Char();
	          if (result1 !== null) {
	            result0 = [result0, result1];
	          } else {
	            result0 = null;
	            pos = pos0;
	          }
	        } else {
	          result0 = null;
	          pos = pos0;
	        }
	        return result0;
	      }
	
	
	      function cleanupExpected(expected) {
	        expected.sort();
	
	        var lastExpected = null;
	        var cleanExpected = [];
	        for (var i = 0; i < expected.length; i++) {
	          if (expected[i] !== lastExpected) {
	            cleanExpected.push(expected[i]);
	            lastExpected = expected[i];
	          }
	        }
	        return cleanExpected;
	      }
	
	      function computeErrorPosition() {
	        /*
	         * The first idea was to use |String.split| to break the input up to the
	         * error position along newlines and derive the line and column from
	         * there. However IE's |split| implementation is so broken that it was
	         * enough to prevent it.
	         */
	
	        var line = 1;
	        var column = 1;
	        var seenCR = false;
	
	        for (var i = 0; i < Math.max(pos, rightmostFailuresPos); i++) {
	          var ch = input.charAt(i);
	          if (ch === "\n") {
	            if (!seenCR) { line++; }
	            column = 1;
	            seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            line++;
	            column = 1;
	            seenCR = true;
	          } else {
	            column++;
	            seenCR = false;
	          }
	        }
	
	        return { line: line, column: column };
	      }
	
	
	      var result = parseFunctions[startRule]();
	
	      /*
	       * The parser is now in one of the following three states:
	       *
	       * 1. The parser successfully parsed the whole input.
	       *
	       *    - |result !== null|
	       *    - |pos === input.length|
	       *    - |rightmostFailuresExpected| may or may not contain something
	       *
	       * 2. The parser successfully parsed only a part of the input.
	       *
	       *    - |result !== null|
	       *    - |pos < input.length|
	       *    - |rightmostFailuresExpected| may or may not contain something
	       *
	       * 3. The parser did not successfully parse any part of the input.
	       *
	       *   - |result === null|
	       *   - |pos === 0|
	       *   - |rightmostFailuresExpected| contains at least one failure
	       *
	       * All code following this comment (including called functions) must
	       * handle these states.
	       */
	      if (result === null || pos !== input.length) {
	        var offset = Math.max(pos, rightmostFailuresPos);
	        var found = offset < input.length ? input.charAt(offset) : null;
	        var errorPosition = computeErrorPosition();
	
	        throw new this.SyntaxError(
	          cleanupExpected(rightmostFailuresExpected),
	          found,
	          offset,
	          errorPosition.line,
	          errorPosition.column
	        );
	      }
	
	      return result;
	    },
	
	    /* Returns the parser source code. */
	    toSource: function() { return this._source; }
	  };
	
	  /* Thrown when a parser encounters a syntax error. */
	
	  result.SyntaxError = function(expected, found, offset, line, column) {
	    function buildMessage(expected, found) {
	      var expectedHumanized, foundHumanized;
	
	      switch (expected.length) {
	        case 0:
	          expectedHumanized = "end of input";
	          break;
	        case 1:
	          expectedHumanized = expected[0];
	          break;
	        default:
	          expectedHumanized = expected.slice(0, expected.length - 1).join(", ")
	            + " or "
	            + expected[expected.length - 1];
	      }
	
	      foundHumanized = found ? quote(found) : "end of input";
	
	      return "Expected " + expectedHumanized + " but " + foundHumanized + " found.";
	    }
	
	    this.name = "SyntaxError";
	    this.expected = expected;
	    this.found = found;
	    this.message = buildMessage(expected, found);
	    this.offset = offset;
	    this.line = line;
	    this.column = column;
	  };
	
	  result.SyntaxError.prototype = Error.prototype;
	
	  return result;
	})();


/***/ },
/* 1860 */
/***/ function(module, exports) {

	/*
	 * Copyright (c) 2009 Nicholas C. Zakas. All rights reserved.
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 */
	
	/*
	 * Base 64 implementation in JavaScript
	 * Original source available at https://raw.github.com/nzakas/computer-science-in-javascript/02a2745b4aa8214f2cae1bf0b15b447ca1a91b23/encodings/base64/base64.js
	 *
	 * Linter refinement by Scott Andrews
	 */
	
	'use strict';
	
	/*jshint bitwise: false */
	
	var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	/**
	 * Base64-encodes a string of text.
	 *
	 * @param {string} text The text to encode.
	 * @return {string} The base64-encoded string.
	 */
	function base64Encode(text) {
	
		if (/([^\u0000-\u00ff])/.test(text)) {
			throw new Error('Can\'t base64 encode non-ASCII characters.');
		}
	
		var i = 0,
			cur, prev, byteNum,
			result = [];
	
		while (i < text.length) {
	
			cur = text.charCodeAt(i);
			byteNum = i % 3;
	
			switch (byteNum) {
			case 0: //first byte
				result.push(digits.charAt(cur >> 2));
				break;
	
			case 1: //second byte
				result.push(digits.charAt((prev & 3) << 4 | (cur >> 4)));
				break;
	
			case 2: //third byte
				result.push(digits.charAt((prev & 0x0f) << 2 | (cur >> 6)));
				result.push(digits.charAt(cur & 0x3f));
				break;
			}
	
			prev = cur;
			i += 1;
		}
	
		if (byteNum === 0) {
			result.push(digits.charAt((prev & 3) << 4));
			result.push('==');
		} else if (byteNum === 1) {
			result.push(digits.charAt((prev & 0x0f) << 2));
			result.push('=');
		}
	
		return result.join('');
	}
	
	/**
	 * Base64-decodes a string of text.
	 *
	 * @param {string} text The text to decode.
	 * @return {string} The base64-decoded string.
	 */
	function base64Decode(text) {
	
		//ignore white space
		text = text.replace(/\s/g, '');
	
		//first check for any unexpected input
		if (!(/^[a-z0-9\+\/\s]+\={0,2}$/i.test(text)) || text.length % 4 > 0) {
			throw new Error('Not a base64-encoded string.');
		}
	
		//local variables
		var cur, prev, digitNum,
			i = 0,
			result = [];
	
		//remove any equals signs
		text = text.replace(/\=/g, '');
	
		//loop over each character
		while (i < text.length) {
	
			cur = digits.indexOf(text.charAt(i));
			digitNum = i % 4;
	
			switch (digitNum) {
	
			//case 0: first digit - do nothing, not enough info to work with
	
			case 1: //second digit
				result.push(String.fromCharCode(prev << 2 | cur >> 4));
				break;
	
			case 2: //third digit
				result.push(String.fromCharCode((prev & 0x0f) << 4 | cur >> 2));
				break;
	
			case 3: //fourth digit
				result.push(String.fromCharCode((prev & 3) << 6 | cur));
				break;
			}
	
			prev = cur;
			i += 1;
		}
	
		//return a string
		return result.join('');
	
	}
	
	module.exports = {
		encode: base64Encode,
		decode: base64Decode
	};


/***/ },
/* 1861 */
/***/ function(module, exports) {

	/*
	 * Copyright 2013-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	module.exports = {
	
		/**
		 * Find objects within a graph the contain a property of a certain name.
		 *
		 * NOTE: this method will not discover object graph cycles.
		 *
		 * @param {*} obj object to search on
		 * @param {string} prop name of the property to search for
		 * @param {Function} callback function to receive the found properties and their parent
		 */
		findProperties: function findProperties(obj, prop, callback) {
			if (typeof obj !== 'object' || obj === null) { return; }
			if (prop in obj) {
				callback(obj[prop], obj, prop);
			}
			Object.keys(obj).forEach(function (key) {
				findProperties(obj[key], prop, callback);
			});
		}
	
	};


/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2013-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var attempt = __webpack_require__(1486);
	
	/**
	 * Create a promise whose work is started only when a handler is registered.
	 *
	 * The work function will be invoked at most once. Thrown values will result
	 * in promise rejection.
	 *
	 * @param {Function} work function whose ouput is used to resolve the
	 *   returned promise.
	 * @returns {Promise} a lazy promise
	 */
	function lazyPromise(work) {
		var started, resolver, promise, then;
	
		started = false;
	
		promise = new Promise(function (resolve, reject) {
			resolver = {
				resolve: resolve,
				reject: reject
			};
		});
		then = promise.then;
	
		promise.then = function () {
			if (!started) {
				started = true;
				attempt(work).then(resolver.resolve, resolver.reject);
			}
			return then.apply(promise, arguments);
		};
	
		return promise;
	}
	
	module.exports = lazyPromise;


/***/ },
/* 1863 */
/***/ function(module, exports) {

	/*
	 * Copyright 2015-2016 the original author or authors
	 * @license MIT, see LICENSE.txt for details
	 *
	 * @author Scott Andrews
	 */
	
	'use strict';
	
	var charMap;
	
	charMap = (function () {
		var strings = {
			alpha: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
			digit: '0123456789'
		};
	
		strings.genDelims = ':/?#[]@';
		strings.subDelims = '!$&\'()*+,;=';
		strings.reserved = strings.genDelims + strings.subDelims;
		strings.unreserved = strings.alpha + strings.digit + '-._~';
		strings.url = strings.reserved + strings.unreserved;
		strings.scheme = strings.alpha + strings.digit + '+-.';
		strings.userinfo = strings.unreserved + strings.subDelims + ':';
		strings.host = strings.unreserved + strings.subDelims;
		strings.port = strings.digit;
		strings.pchar = strings.unreserved + strings.subDelims + ':@';
		strings.segment = strings.pchar;
		strings.path = strings.segment + '/';
		strings.query = strings.pchar + '/?';
		strings.fragment = strings.pchar + '/?';
	
		return Object.keys(strings).reduce(function (charMap, set) {
			charMap[set] = strings[set].split('').reduce(function (chars, myChar) {
				chars[myChar] = true;
				return chars;
			}, {});
			return charMap;
		}, {});
	}());
	
	function encode(str, allowed) {
		if (typeof str !== 'string') {
			throw new Error('String required for URL encoding');
		}
		return str.split('').map(function (myChar) {
			if (allowed.hasOwnProperty(myChar)) {
				return myChar;
			}
			var code = myChar.charCodeAt(0);
			if (code <= 127) {
				var encoded = code.toString(16).toUpperCase();
	 			return '%' + (encoded.length % 2 === 1 ? '0' : '') + encoded;
			}
			else {
				return encodeURIComponent(myChar).toUpperCase();
			}
		}).join('');
	}
	
	function makeEncoder(allowed) {
		allowed = allowed || charMap.unreserved;
		return function (str) {
			return encode(str, allowed);
		};
	}
	
	function decode(str) {
		return decodeURIComponent(str);
	}
	
	module.exports = {
	
		/*
		 * Decode URL encoded strings
		 *
		 * @param {string} URL encoded string
		 * @returns {string} URL decoded string
		 */
		decode: decode,
	
		/*
		 * URL encode a string
		 *
		 * All but alpha-numerics and a very limited set of punctuation - . _ ~ are
		 * encoded.
		 *
		 * @param {string} string to encode
		 * @returns {string} URL encoded string
		 */
		encode: makeEncoder(),
	
		/*
		* URL encode a URL
		*
		* All character permitted anywhere in a URL are left unencoded even
		* if that character is not permitted in that portion of a URL.
		*
		* Note: This method is typically not what you want.
		*
		* @param {string} string to encode
		* @returns {string} URL encoded string
		*/
		encodeURL: makeEncoder(charMap.url),
	
		/*
		 * URL encode the scheme portion of a URL
		 *
		 * @param {string} string to encode
		 * @returns {string} URL encoded string
		 */
		encodeScheme: makeEncoder(charMap.scheme),
	
		/*
		 * URL encode the user info portion of a URL
		 *
		 * @param {string} string to encode
		 * @returns {string} URL encoded string
		 */
		encodeUserInfo: makeEncoder(charMap.userinfo),
	
		/*
		 * URL encode the host portion of a URL
		 *
		 * @param {string} string to encode
		 * @returns {string} URL encoded string
		 */
		encodeHost: makeEncoder(charMap.host),
	
		/*
		 * URL encode the port portion of a URL
		 *
		 * @param {string} string to encode
		 * @returns {string} URL encoded string
		 */
		encodePort: makeEncoder(charMap.port),
	
		/*
		 * URL encode a path segment portion of a URL
		 *
		 * @param {string} string to encode
		 * @returns {string} URL encoded string
		 */
		encodePathSegment: makeEncoder(charMap.segment),
	
		/*
		 * URL encode the path portion of a URL
		 *
		 * @param {string} string to encode
		 * @returns {string} URL encoded string
		 */
		encodePath: makeEncoder(charMap.path),
	
		/*
		 * URL encode the query portion of a URL
		 *
		 * @param {string} string to encode
		 * @returns {string} URL encoded string
		 */
		encodeQuery: makeEncoder(charMap.query),
	
		/*
		 * URL encode the fragment portion of a URL
		 *
		 * @param {string} string to encode
		 * @returns {string} URL encoded string
		 */
		encodeFragment: makeEncoder(charMap.fragment)
	
	};


/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(339)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.prototype = Object.create(Buffer.prototype)
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 1865 */
/***/ function(module, exports) {

	module.exports = SafeParseTuple
	
	function SafeParseTuple(obj, reviver) {
	    var json
	    var error = null
	
	    try {
	        json = JSON.parse(obj, reviver)
	    } catch (err) {
	        error = err
	    }
	
	    return [error, json]
	}


/***/ },
/* 1866 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(586)


/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1489)


/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = __webpack_require__(1490);
	exports.Stream = __webpack_require__(345);
	exports.Readable = exports;
	exports.Writable = __webpack_require__(1064);
	exports.Duplex = __webpack_require__(586);
	exports.Transform = __webpack_require__(1063);
	exports.PassThrough = __webpack_require__(1489);
	if (!process.browser && process.env.READABLE_STREAM === 'disable') {
	  module.exports = __webpack_require__(345);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(235)))

/***/ },
/* 1870 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1063)


/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1064)


/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(1864).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 1873 */
/***/ function(module, exports) {

	
	/**
	 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
	 * embed the css on the page. This breaks all relative urls because now they are relative to a
	 * bundle instead of the current page.
	 *
	 * One solution is to only use full urls, but that may be impossible.
	 *
	 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
	 *
	 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
	 *
	 */
	
	module.exports = function (css) {
	  // get current location
	  var location = typeof window !== "undefined" && window.location;
	
	  if (!location) {
	    throw new Error("fixUrls requires window.location");
	  }
	
		// blank or null?
		if (!css || typeof css !== "string") {
		  return css;
	  }
	
	  var baseUrl = location.protocol + "//" + location.host;
	  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");
	
		// convert each url(...)
		/*
		This regular expression is just a way to recursively match brackets within
		a string.
	
		 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
		   (  = Start a capturing group
		     (?:  = Start a non-capturing group
		         [^)(]  = Match anything that isn't a parentheses
		         |  = OR
		         \(  = Match a start parentheses
		             (?:  = Start another non-capturing groups
		                 [^)(]+  = Match anything that isn't a parentheses
		                 |  = OR
		                 \(  = Match a start parentheses
		                     [^)(]*  = Match anything that isn't a parentheses
		                 \)  = Match a end parentheses
		             )  = End Group
	              *\) = Match anything and then a close parens
	          )  = Close non-capturing group
	          *  = Match anything
	       )  = Close capturing group
		 \)  = Match a close parens
	
		 /gi  = Get all matches, not the first.  Be case insensitive.
		 */
		var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
			// strip quotes (if they exist)
			var unquotedOrigUrl = origUrl
				.trim()
				.replace(/^"(.*)"$/, function(o, $1){ return $1; })
				.replace(/^'(.*)'$/, function(o, $1){ return $1; });
	
			// already a full url? no change
			if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			  return fullMatch;
			}
	
			// convert the url to a full url
			var newUrl;
	
			if (unquotedOrigUrl.indexOf("//") === 0) {
			  	//TODO: should we add protocol?
				newUrl = unquotedOrigUrl;
			} else if (unquotedOrigUrl.indexOf("/") === 0) {
				// path should be relative to the base url
				newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
			} else {
				// path should be relative to current directory
				newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
			}
	
			// send back the fixed url(...)
			return "url(" + JSON.stringify(newUrl) + ")";
		});
	
		// send back the fixed css
		return fixedCss;
	};


/***/ },
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1754);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./toastr.css", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./toastr.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(1761);
	var reduce = __webpack_require__(1847);
	
	/**
	 * Root reference for iframes.
	 */
	
	var root = 'undefined' == typeof window
	  ? this
	  : window;
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Determine XHR.
	 */
	
	function getXHR() {
	  if (root.XMLHttpRequest
	    && ('file:' != root.location.protocol || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	}
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return obj === Object(obj);
	}
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(obj[key]));
	    }
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  this.text = this.xhr.responseText;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype.parseBody = function(str){
	  var parse = request.parse[this.type];
	  return parse
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype.setStatusProperties = function(status){
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status || 1223 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var path = req.path;
	
	  var msg = 'cannot ' + method + ' ' + path + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.path = path;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  Emitter.call(this);
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {};
	  this._header = {};
	  this.on('end', function(){
	    var res = new Response(self);
	    if ('HEAD' == method) res.text = null;
	    self.callback(null, res);
	  });
	}
	
	/**
	 * Mixin `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.timeout = function(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.clearTimeout = function(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	
	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 */
	
	Request.prototype.getHeader = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass){
	  var str = btoa(user + ':' + pass);
	  this.set('Authorization', 'Basic ' + str);
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Send `data`, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // querystring
	 *       request.get('/search')
	 *         .end(callback)
	 *
	 *       // multiple data "writes"
	 *       request.get('/search')
	 *         .send({ search: 'query' })
	 *         .send({ range: '1..5' })
	 *         .send({ order: 'desc' })
	 *         .end(callback)
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"})
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this.getHeader('Content-Type');
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this.getHeader('Content-Type');
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj) return this;
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  if (2 == fn.length) return fn(err, res);
	  if (err) return this.emit('error', err);
	  fn(res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Origin is not allowed by Access-Control-Allow-Origin');
	  err.crossDomain = true;
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	    if (0 == xhr.status) {
	      if (self.aborted) return self.timeoutError();
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  if (xhr.upload) {
	    xhr.upload.onprogress = function(e){
	      e.percent = e.loaded / e.total * 100;
	      self.emit('progress', e);
	    };
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	
	  // initiate request
	  xhr.open(this.method, this.url, true);
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var serialize = request.serialize[this.getHeader('Content-Type')];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  // send stuff
	  xhr.send(data);
	  return this;
	};
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new Request('GET', method);
	  }
	
	  return new Request(method, url);
	}
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.del = function(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * Expose `request`.
	 */
	
	module.exports = request;


/***/ },
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */
/***/ function(module, exports) {

	module.exports = function chop(str, step) {
	  if (str == null) return [];
	  str = String(str);
	  step = ~~step;
	  return step > 0 ? str.match(new RegExp('.{1,' + step + '}', 'g')) : [str];
	};


/***/ },
/* 1895 */
/***/ function(module, exports, __webpack_require__) {

	var capitalize = __webpack_require__(1133);
	var camelize = __webpack_require__(1492);
	var makeString = __webpack_require__(124);
	
	module.exports = function classify(str) {
	  str = makeString(str);
	  return capitalize(camelize(str.replace(/[\W_]/g, ' ')).replace(/\s/g, ''));
	};


/***/ },
/* 1896 */
/***/ function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(455);
	
	module.exports = function clean(str) {
	  return trim(str).replace(/\s\s+/g, ' ');
	};


/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function(str, substr) {
	  str = makeString(str);
	  substr = makeString(substr);
	
	  if (str.length === 0 || substr.length === 0) return 0;
	  
	  return str.split(substr).length - 1;
	};


/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	function getIndent(str) {
	  var matches = str.match(/^[\s\\t]*/gm);
	  var indent = matches[0].length;
	  
	  for (var i = 1; i < matches.length; i++) {
	    indent = Math.min(matches[i].length, indent);
	  }
	
	  return indent;
	}
	
	module.exports = function dedent(str, pattern) {
	  str = makeString(str);
	  var indent = getIndent(str);
	  var reg;
	
	  if (indent === 0) return str;
	
	  if (typeof pattern === 'string') {
	    reg = new RegExp('^' + pattern, 'gm');
	  } else {
	    reg = new RegExp('^[ \\t]{' + indent + '}', 'gm');
	  }
	
	  return str.replace(reg, '');
	};


/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	var toPositive = __webpack_require__(1499);
	
	module.exports = function endsWith(str, ends, position) {
	  str = makeString(str);
	  ends = '' + ends;
	  if (typeof position == 'undefined') {
	    position = str.length - ends.length;
	  } else {
	    position = Math.min(toPositive(position), str.length) - ends.length;
	  }
	  return position >= 0 && str.indexOf(ends, position) === position;
	};


/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	var escapeChars = __webpack_require__(1902);
	
	var regexString = '[';
	for(var key in escapeChars) {
	  regexString += key;
	}
	regexString += ']';
	
	var regex = new RegExp( regexString, 'g');
	
	module.exports = function escapeHTML(str) {
	
	  return makeString(str).replace(regex, function(m) {
	    return '&' + escapeChars[m] + ';';
	  });
	};


/***/ },
/* 1901 */
/***/ function(module, exports) {

	module.exports = function() {
	  var result = {};
	
	  for (var prop in this) {
	    if (!this.hasOwnProperty(prop) || prop.match(/^(?:include|contains|reverse|join|map|wrap)$/)) continue;
	    result[prop] = this[prop];
	  }
	
	  return result;
	};


/***/ },
/* 1902 */
/***/ function(module, exports) {

	/* We're explicitly defining the list of entities we want to escape.
	nbsp is an HTML entity, but we don't want to escape all space characters in a string, hence its omission in this map.
	
	*/
	var escapeChars = {
	  '¢' : 'cent',
	  '£' : 'pound',
	  '¥' : 'yen',
	  '€': 'euro',
	  '©' :'copy',
	  '®' : 'reg',
	  '<' : 'lt',
	  '>' : 'gt',
	  '"' : 'quot',
	  '&' : 'amp',
	  '\'' : '#39'
	};
	
	module.exports = escapeChars;


/***/ },
/* 1903 */
/***/ function(module, exports) {

	/*
	We're explicitly defining the list of entities that might see in escape HTML strings
	*/
	var htmlEntities = {
	  nbsp: ' ',
	  cent: '¢',
	  pound: '£',
	  yen: '¥',
	  euro: '€',
	  copy: '©',
	  reg: '®',
	  lt: '<',
	  gt: '>',
	  quot: '"',
	  amp: '&',
	  apos: '\''
	};
	
	module.exports = htmlEntities;


/***/ },
/* 1904 */
/***/ function(module, exports, __webpack_require__) {

	var capitalize = __webpack_require__(1133);
	var underscored = __webpack_require__(1504);
	var trim = __webpack_require__(455);
	
	module.exports = function humanize(str) {
	  return capitalize(trim(underscored(str).replace(/_id$/, '').replace(/_/g, ' ')));
	};


/***/ },
/* 1905 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function include(str, needle) {
	  if (needle === '') return true;
	  return makeString(str).indexOf(needle) !== -1;
	};


/***/ },
/* 1906 */
/***/ function(module, exports, __webpack_require__) {

	var splice = __webpack_require__(1501);
	
	module.exports = function insert(str, i, substr) {
	  return splice(str, i, 0, substr);
	};


/***/ },
/* 1907 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	var slice = [].slice;
	
	module.exports = function join() {
	  var args = slice.call(arguments),
	    separator = args.shift();
	
	  return args.join(makeString(separator));
	};


/***/ },
/* 1908 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	/**
	 * Based on the implementation here: https://github.com/hiddentao/fast-levenshtein
	 */
	module.exports = function levenshtein(str1, str2) {
	  'use strict';
	  str1 = makeString(str1);
	  str2 = makeString(str2);
	
	  // Short cut cases  
	  if (str1 === str2) return 0;
	  if (!str1 || !str2) return Math.max(str1.length, str2.length);
	
	  // two rows
	  var prevRow = new Array(str2.length + 1);
	
	  // initialise previous row
	  for (var i = 0; i < prevRow.length; ++i) {
	    prevRow[i] = i;
	  }
	
	  // calculate current row distance from previous row
	  for (i = 0; i < str1.length; ++i) {
	    var nextCol = i + 1;
	
	    for (var j = 0; j < str2.length; ++j) {
	      var curCol = nextCol;
	
	      // substution
	      nextCol = prevRow[j] + ( (str1.charAt(i) === str2.charAt(j)) ? 0 : 1 );
	      // insertion
	      var tmp = curCol + 1;
	      if (nextCol > tmp) {
	        nextCol = tmp;
	      }
	      // deletion
	      tmp = prevRow[j + 1] + 1;
	      if (nextCol > tmp) {
	        nextCol = tmp;
	      }
	
	      // copy current col value into previous (in preparation for next iteration)
	      prevRow[j] = curCol;
	    }
	
	    // copy last col value into previous (in preparation for next iteration)
	    prevRow[j] = nextCol;
	  }
	
	  return nextCol;
	};


/***/ },
/* 1909 */
/***/ function(module, exports) {

	module.exports = function lines(str) {
	  if (str == null) return [];
	  return String(str).split(/\r\n?|\n/);
	};


/***/ },
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	var pad = __webpack_require__(937);
	
	module.exports = function lpad(str, length, padStr) {
	  return pad(str, length, padStr);
	};


/***/ },
/* 1911 */
/***/ function(module, exports, __webpack_require__) {

	var pad = __webpack_require__(937);
	
	module.exports = function lrpad(str, length, padStr) {
	  return pad(str, length, padStr, 'both');
	};


/***/ },
/* 1912 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	var defaultToWhiteSpace = __webpack_require__(1135);
	var nativeTrimLeft = String.prototype.trimLeft;
	
	module.exports = function ltrim(str, characters) {
	  str = makeString(str);
	  if (!characters && nativeTrimLeft) return nativeTrimLeft.call(str);
	  characters = defaultToWhiteSpace(characters);
	  return str.replace(new RegExp('^' + characters + '+'), '');
	};


/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function(str, callback) {
	  str = makeString(str);
	
	  if (str.length === 0 || typeof callback !== 'function') return str;
	
	  return str.replace(/./g, callback);
	};


/***/ },
/* 1914 */
/***/ function(module, exports) {

	module.exports = function naturalCmp(str1, str2) {
	  if (str1 == str2) return 0;
	  if (!str1) return -1;
	  if (!str2) return 1;
	
	  var cmpRegex = /(\.\d+|\d+|\D+)/g,
	    tokens1 = String(str1).match(cmpRegex),
	    tokens2 = String(str2).match(cmpRegex),
	    count = Math.min(tokens1.length, tokens2.length);
	
	  for (var i = 0; i < count; i++) {
	    var a = tokens1[i],
	      b = tokens2[i];
	
	    if (a !== b) {
	      var num1 = +a;
	      var num2 = +b;
	      if (num1 === num1 && num2 === num2) {
	        return num1 > num2 ? 1 : -1;
	      }
	      return a < b ? -1 : 1;
	    }
	  }
	
	  if (tokens1.length != tokens2.length)
	    return tokens1.length - tokens2.length;
	
	  return str1 < str2 ? -1 : 1;
	};


/***/ },
/* 1915 */
/***/ function(module, exports) {

	module.exports = function numberFormat(number, dec, dsep, tsep) {
	  if (isNaN(number) || number == null) return '';
	
	  number = number.toFixed(~~dec);
	  tsep = typeof tsep == 'string' ? tsep : ',';
	
	  var parts = number.split('.'),
	    fnums = parts[0],
	    decimals = parts[1] ? (dsep || '.') + parts[1] : '';
	
	  return fnums.replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + tsep) + decimals;
	};


/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__) {

	var adjacent = __webpack_require__(1496);
	
	module.exports = function succ(str) {
	  return adjacent(str, -1);
	};


/***/ },
/* 1917 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * _s.prune: a more elegant version of truncate
	 * prune extra chars, never leaving a half-chopped word.
	 * @author github.com/rwz
	 */
	var makeString = __webpack_require__(124);
	var rtrim = __webpack_require__(1136);
	
	module.exports = function prune(str, length, pruneStr) {
	  str = makeString(str);
	  length = ~~length;
	  pruneStr = pruneStr != null ? String(pruneStr) : '...';
	
	  if (str.length <= length) return str;
	
	  var tmpl = function(c) {
	      return c.toUpperCase() !== c.toLowerCase() ? 'A' : ' ';
	    },
	    template = str.slice(0, length + 1).replace(/.(?=\W*\w*$)/g, tmpl); // 'Hello, world' -> 'HellAA AAAAA'
	
	  if (template.slice(template.length - 2).match(/\w\w/))
	    template = template.replace(/\s*\S+$/, '');
	  else
	    template = rtrim(template.slice(0, template.length - 1));
	
	  return (template + pruneStr).length > str.length ? str : str.slice(0, template.length) + pruneStr;
	};


/***/ },
/* 1918 */
/***/ function(module, exports, __webpack_require__) {

	var surround = __webpack_require__(1502);
	
	module.exports = function quote(str, quoteChar) {
	  return surround(str, quoteChar || '"');
	};


/***/ },
/* 1919 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	var strRepeat = __webpack_require__(1498);
	
	module.exports = function repeat(str, qty, separator) {
	  str = makeString(str);
	
	  qty = ~~qty;
	
	  // using faster implementation if separator is not needed;
	  if (separator == null) return strRepeat(str, qty);
	
	  // this one is about 300x slower in Google Chrome
	  /*eslint no-empty: 0*/
	  for (var repeat = []; qty > 0; repeat[--qty] = str) {}
	  return repeat.join(separator);
	};


/***/ },
/* 1920 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function replaceAll(str, find, replace, ignorecase) {
	  var flags = (ignorecase === true)?'gi':'g';
	  var reg = new RegExp(find, flags);
	
	  return makeString(str).replace(reg, replace);
	};


/***/ },
/* 1921 */
/***/ function(module, exports, __webpack_require__) {

	var chars = __webpack_require__(1134);
	
	module.exports = function reverse(str) {
	  return chars(str).reverse().join('');
	};


/***/ },
/* 1922 */
/***/ function(module, exports, __webpack_require__) {

	var pad = __webpack_require__(937);
	
	module.exports = function rpad(str, length, padStr) {
	  return pad(str, length, padStr, 'right');
	};


/***/ },
/* 1923 */
/***/ function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(455);
	var dasherize = __webpack_require__(1494);
	var cleanDiacritics = __webpack_require__(1493);
	
	module.exports = function slugify(str) {
	  return trim(dasherize(cleanDiacritics(str).replace(/[^\w\s-]/g, '-').toLowerCase()), '-');
	};


/***/ },
/* 1924 */
/***/ function(module, exports, __webpack_require__) {

	var deprecate = __webpack_require__(1506);
	
	module.exports = deprecate(__webpack_require__(1488).sprintf,
	  'sprintf() will be removed in the next major release, use the sprintf-js package instead.');


/***/ },
/* 1925 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	var toPositive = __webpack_require__(1499);
	
	module.exports = function startsWith(str, starts, position) {
	  str = makeString(str);
	  starts = '' + starts;
	  position = position == null ? 0 : Math.min(toPositive(position), str.length);
	  return str.lastIndexOf(starts, position) === position;
	};


/***/ },
/* 1926 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function strLeft(str, sep) {
	  str = makeString(str);
	  sep = makeString(sep);
	  var pos = !sep ? -1 : str.indexOf(sep);
	  return~ pos ? str.slice(0, pos) : str;
	};


/***/ },
/* 1927 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function strLeftBack(str, sep) {
	  str = makeString(str);
	  sep = makeString(sep);
	  var pos = str.lastIndexOf(sep);
	  return~ pos ? str.slice(0, pos) : str;
	};


/***/ },
/* 1928 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function strRight(str, sep) {
	  str = makeString(str);
	  sep = makeString(sep);
	  var pos = !sep ? -1 : str.indexOf(sep);
	  return~ pos ? str.slice(pos + sep.length, str.length) : str;
	};


/***/ },
/* 1929 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function strRightBack(str, sep) {
	  str = makeString(str);
	  sep = makeString(sep);
	  var pos = !sep ? -1 : str.lastIndexOf(sep);
	  return~ pos ? str.slice(pos + sep.length, str.length) : str;
	};


/***/ },
/* 1930 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function stripTags(str) {
	  return makeString(str).replace(/<\/?[^>]+>/g, '');
	};


/***/ },
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	var adjacent = __webpack_require__(1496);
	
	module.exports = function succ(str) {
	  return adjacent(str, 1);
	};


/***/ },
/* 1932 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function swapCase(str) {
	  return makeString(str).replace(/\S/g, function(c) {
	    return c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase();
	  });
	};


/***/ },
/* 1933 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function titleize(str) {
	  return makeString(str).toLowerCase().replace(/(?:^|\s|-)\S/g, function(c) {
	    return c.toUpperCase();
	  });
	};


/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(455);
	
	function boolMatch(s, matchers) {
	  var i, matcher, down = s.toLowerCase();
	  matchers = [].concat(matchers);
	  for (i = 0; i < matchers.length; i += 1) {
	    matcher = matchers[i];
	    if (!matcher) continue;
	    if (matcher.test && matcher.test(s)) return true;
	    if (matcher.toLowerCase() === down) return true;
	  }
	}
	
	module.exports = function toBoolean(str, trueValues, falseValues) {
	  if (typeof str === 'number') str = '' + str;
	  if (typeof str !== 'string') return !!str;
	  str = trim(str);
	  if (boolMatch(str, trueValues || ['true', '1'])) return true;
	  if (boolMatch(str, falseValues || ['false', '0'])) return false;
	};


/***/ },
/* 1935 */
/***/ function(module, exports) {

	module.exports = function toNumber(num, precision) {
	  if (num == null) return 0;
	  var factor = Math.pow(10, isFinite(precision) ? precision : 0);
	  return Math.round(num * factor) / factor;
	};


/***/ },
/* 1936 */
/***/ function(module, exports, __webpack_require__) {

	var toSentence = __webpack_require__(1503);
	
	module.exports = function toSentenceSerial(array, sep, lastSep) {
	  return toSentence(array, sep, lastSep, true);
	};


/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	
	module.exports = function truncate(str, length, truncateStr) {
	  str = makeString(str);
	  truncateStr = truncateStr || '...';
	  length = ~~length;
	  return str.length > length ? str.slice(0, length) + truncateStr : str;
	};


/***/ },
/* 1938 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(124);
	var htmlEntities = __webpack_require__(1903);
	
	module.exports = function unescapeHTML(str) {
	  return makeString(str).replace(/\&([^;]{1,10});/g, function(entity, entityCode) {
	    var match;
	
	    if (entityCode in htmlEntities) {
	      return htmlEntities[entityCode];
	    /*eslint no-cond-assign: 0*/
	    } else if (match = entityCode.match(/^#x([\da-fA-F]+)$/)) {
	      return String.fromCharCode(parseInt(match[1], 16));
	    /*eslint no-cond-assign: 0*/
	    } else if (match = entityCode.match(/^#(\d+)$/)) {
	      return String.fromCharCode(~~match[1]);
	    } else {
	      return entity;
	    }
	  });
	};


/***/ },
/* 1939 */
/***/ function(module, exports) {

	module.exports = function unquote(str, quoteChar) {
	  quoteChar = quoteChar || '"';
	  if (str[0] === quoteChar && str[str.length - 1] === quoteChar)
	    return str.slice(1, str.length - 1);
	  else return str;
	};


/***/ },
/* 1940 */
/***/ function(module, exports, __webpack_require__) {

	var deprecate = __webpack_require__(1506);
	
	module.exports = deprecate(__webpack_require__(1488).vsprintf,
	  'vsprintf() will be removed in the next major release, use the sprintf-js package instead.');


/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	var isBlank = __webpack_require__(1500);
	var trim = __webpack_require__(455);
	
	module.exports = function words(str, delimiter) {
	  if (isBlank(str)) return [];
	  return trim(str, delimiter).split(delimiter || /\s+/);
	};


/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	// Wrap
	// wraps a string by a certain width
	
	var makeString = __webpack_require__(124);
	
	module.exports = function wrap(str, options){
	  str = makeString(str);
	  
	  options = options || {};
	  
	  var width = options.width || 75;
	  var seperator = options.seperator || '\n';
	  var cut = options.cut || false;
	  var preserveSpaces = options.preserveSpaces || false;
	  var trailingSpaces = options.trailingSpaces || false;
	  
	  var result;
	  
	  if(width <= 0){
	    return str;
	  }
	  
	  else if(!cut){
	  
	    var words = str.split(' ');
	    var current_column = 0;
	    result = '';
	  
	    while(words.length > 0){
	      
	      // if adding a space and the next word would cause this line to be longer than width...
	      if(1 + words[0].length + current_column > width){
	        //start a new line if this line is not already empty
	        if(current_column > 0){
	          // add a space at the end of the line is preserveSpaces is true
	          if (preserveSpaces){
	            result += ' ';
	            current_column++;
	          }
	          // fill the rest of the line with spaces if trailingSpaces option is true
	          else if(trailingSpaces){
	            while(current_column < width){
	              result += ' ';
	              current_column++;
	            }            
	          }
	          //start new line
	          result += seperator;
	          current_column = 0;
	        }
	      }
	  
	      // if not at the begining of the line, add a space in front of the word
	      if(current_column > 0){
	        result += ' ';
	        current_column++;
	      }
	  
	      // tack on the next word, update current column, a pop words array
	      result += words[0];
	      current_column += words[0].length;
	      words.shift();
	  
	    }
	  
	    // fill the rest of the line with spaces if trailingSpaces option is true
	    if(trailingSpaces){
	      while(current_column < width){
	        result += ' ';
	        current_column++;
	      }            
	    }
	  
	    return result;
	  
	  }
	  
	  else {
	  
	    var index = 0;
	    result = '';
	  
	    // walk through each character and add seperators where appropriate
	    while(index < str.length){
	      if(index % width == 0 && index > 0){
	        result += seperator;
	      }
	      result += str.charAt(index);
	      index++;
	    }
	  
	    // fill the rest of the line with spaces if trailingSpaces option is true
	    if(trailingSpaces){
	      while(index % width > 0){
	        result += ' ';
	        index++;
	      }            
	    }
	    
	    return result;
	  }
	};


/***/ },
/* 1943 */
/***/ function(module, exports, __webpack_require__) {

	// see https://tools.ietf.org/html/rfc1808
	
	(function (root) {
	  var URL_REGEX =
	    /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
	  var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
	  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
	  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;
	
	  var URLToolkit = {
	    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
	    // E.g
	    // With opts.alwaysNormalize = false (default, spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
	    // With opts.alwaysNormalize = true (not spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
	    buildAbsoluteURL: function (baseURL, relativeURL, opts) {
	      opts = opts || {};
	      // remove any remaining space and CRLF
	      baseURL = baseURL.trim();
	      relativeURL = relativeURL.trim();
	      if (!relativeURL) {
	        // 2a) If the embedded URL is entirely empty, it inherits the
	        // entire base URL (i.e., is set equal to the base URL)
	        // and we are done.
	        if (!opts.alwaysNormalize) {
	          return baseURL;
	        }
	        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
	        if (!basePartsForNormalise) {
	          throw new Error('Error trying to parse base URL.');
	        }
	        basePartsForNormalise.path = URLToolkit.normalizePath(
	          basePartsForNormalise.path
	        );
	        return URLToolkit.buildURLFromParts(basePartsForNormalise);
	      }
	      var relativeParts = URLToolkit.parseURL(relativeURL);
	      if (!relativeParts) {
	        throw new Error('Error trying to parse relative URL.');
	      }
	      if (relativeParts.scheme) {
	        // 2b) If the embedded URL starts with a scheme name, it is
	        // interpreted as an absolute URL and we are done.
	        if (!opts.alwaysNormalize) {
	          return relativeURL;
	        }
	        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
	        return URLToolkit.buildURLFromParts(relativeParts);
	      }
	      var baseParts = URLToolkit.parseURL(baseURL);
	      if (!baseParts) {
	        throw new Error('Error trying to parse base URL.');
	      }
	      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
	        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
	        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
	        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
	        baseParts.netLoc = pathParts[1];
	        baseParts.path = pathParts[2];
	      }
	      if (baseParts.netLoc && !baseParts.path) {
	        baseParts.path = '/';
	      }
	      var builtParts = {
	        // 2c) Otherwise, the embedded URL inherits the scheme of
	        // the base URL.
	        scheme: baseParts.scheme,
	        netLoc: relativeParts.netLoc,
	        path: null,
	        params: relativeParts.params,
	        query: relativeParts.query,
	        fragment: relativeParts.fragment,
	      };
	      if (!relativeParts.netLoc) {
	        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
	        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
	        // (if any) of the base URL.
	        builtParts.netLoc = baseParts.netLoc;
	        // 4) If the embedded URL path is preceded by a slash "/", the
	        // path is not relative and we skip to Step 7.
	        if (relativeParts.path[0] !== '/') {
	          if (!relativeParts.path) {
	            // 5) If the embedded URL path is empty (and not preceded by a
	            // slash), then the embedded URL inherits the base URL path
	            builtParts.path = baseParts.path;
	            // 5a) if the embedded URL's <params> is non-empty, we skip to
	            // step 7; otherwise, it inherits the <params> of the base
	            // URL (if any) and
	            if (!relativeParts.params) {
	              builtParts.params = baseParts.params;
	              // 5b) if the embedded URL's <query> is non-empty, we skip to
	              // step 7; otherwise, it inherits the <query> of the base
	              // URL (if any) and we skip to step 7.
	              if (!relativeParts.query) {
	                builtParts.query = baseParts.query;
	              }
	            }
	          } else {
	            // 6) The last segment of the base URL's path (anything
	            // following the rightmost slash "/", or the entire path if no
	            // slash is present) is removed and the embedded URL's path is
	            // appended in its place.
	            var baseURLPath = baseParts.path;
	            var newPath =
	              baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) +
	              relativeParts.path;
	            builtParts.path = URLToolkit.normalizePath(newPath);
	          }
	        }
	      }
	      if (builtParts.path === null) {
	        builtParts.path = opts.alwaysNormalize
	          ? URLToolkit.normalizePath(relativeParts.path)
	          : relativeParts.path;
	      }
	      return URLToolkit.buildURLFromParts(builtParts);
	    },
	    parseURL: function (url) {
	      var parts = URL_REGEX.exec(url);
	      if (!parts) {
	        return null;
	      }
	      return {
	        scheme: parts[1] || '',
	        netLoc: parts[2] || '',
	        path: parts[3] || '',
	        params: parts[4] || '',
	        query: parts[5] || '',
	        fragment: parts[6] || '',
	      };
	    },
	    normalizePath: function (path) {
	      // The following operations are
	      // then applied, in order, to the new path:
	      // 6a) All occurrences of "./", where "." is a complete path
	      // segment, are removed.
	      // 6b) If the path ends with "." as a complete path segment,
	      // that "." is removed.
	      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
	      // 6c) All occurrences of "<segment>/../", where <segment> is a
	      // complete path segment not equal to "..", are removed.
	      // Removal of these path segments is performed iteratively,
	      // removing the leftmost matching pattern on each iteration,
	      // until no matching pattern remains.
	      // 6d) If the path ends with "<segment>/..", where <segment> is a
	      // complete path segment not equal to "..", that
	      // "<segment>/.." is removed.
	      while (
	        path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length
	      ) {}
	      return path.split('').reverse().join('');
	    },
	    buildURLFromParts: function (parts) {
	      return (
	        parts.scheme +
	        parts.netLoc +
	        parts.path +
	        parts.params +
	        parts.query +
	        parts.fragment
	      );
	    },
	  };
	
	  if (true)
	    module.exports = URLToolkit;
	  else if (typeof define === 'function' && define.amd)
	    define([], function () {
	      return URLToolkit;
	    });
	  else if (typeof exports === 'object') exports['URLToolkit'] = URLToolkit;
	  else root['URLToolkit'] = URLToolkit;
	})(this);


/***/ },
/* 1944 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(671)(module), (function() { return this; }())))

/***/ },
/* 1945 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 1946 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 1947 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1946);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(1945);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(235)))

/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	// Default exports for Node. Export the extended versions of VTTCue and
	// VTTRegion in Node since we likely want the capability to convert back and
	// forth between JSON. If we don't then it's not that big of a deal since we're
	// off browser.
	
	var window = __webpack_require__(344);
	
	var vttjs = module.exports = {
	  WebVTT: __webpack_require__(1949),
	  VTTCue: __webpack_require__(1950),
	  VTTRegion: __webpack_require__(1951)
	};
	
	window.vttjs = vttjs;
	window.WebVTT = vttjs.WebVTT;
	
	var cueShim = vttjs.VTTCue;
	var regionShim = vttjs.VTTRegion;
	var nativeVTTCue = window.VTTCue;
	var nativeVTTRegion = window.VTTRegion;
	
	vttjs.shim = function() {
	  window.VTTCue = cueShim;
	  window.VTTRegion = regionShim;
	};
	
	vttjs.restore = function() {
	  window.VTTCue = nativeVTTCue;
	  window.VTTRegion = nativeVTTRegion;
	};
	
	if (!window.VTTCue) {
	  vttjs.shim();
	}


/***/ },
/* 1949 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/* -*- Mode: Java; tab-width: 2; indent-tabs-mode: nil; c-basic-offset: 2 -*- */
	/* vim: set shiftwidth=2 tabstop=2 autoindent cindent expandtab: */
	var document = __webpack_require__(1335);
	
	var _objCreate = Object.create || (function() {
	  function F() {}
	  return function(o) {
	    if (arguments.length !== 1) {
	      throw new Error('Object.create shim only accepts one parameter.');
	    }
	    F.prototype = o;
	    return new F();
	  };
	})();
	
	// Creates a new ParserError object from an errorData object. The errorData
	// object should have default code and message properties. The default message
	// property can be overriden by passing in a message parameter.
	// See ParsingError.Errors below for acceptable errors.
	function ParsingError(errorData, message) {
	  this.name = "ParsingError";
	  this.code = errorData.code;
	  this.message = message || errorData.message;
	}
	ParsingError.prototype = _objCreate(Error.prototype);
	ParsingError.prototype.constructor = ParsingError;
	
	// ParsingError metadata for acceptable ParsingErrors.
	ParsingError.Errors = {
	  BadSignature: {
	    code: 0,
	    message: "Malformed WebVTT signature."
	  },
	  BadTimeStamp: {
	    code: 1,
	    message: "Malformed time stamp."
	  }
	};
	
	// Try to parse input as a time stamp.
	function parseTimeStamp(input) {
	
	  function computeSeconds(h, m, s, f) {
	    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
	  }
	
	  var m = input.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
	  if (!m) {
	    return null;
	  }
	
	  if (m[3]) {
	    // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
	    return computeSeconds(m[1], m[2], m[3].replace(":", ""), m[4]);
	  } else if (m[1] > 59) {
	    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
	    // First position is hours as it's over 59.
	    return computeSeconds(m[1], m[2], 0,  m[4]);
	  } else {
	    // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
	    return computeSeconds(0, m[1], m[2], m[4]);
	  }
	}
	
	// A settings object holds key/value pairs and will ignore anything but the first
	// assignment to a specific key.
	function Settings() {
	  this.values = _objCreate(null);
	}
	
	Settings.prototype = {
	  // Only accept the first assignment to any key.
	  set: function(k, v) {
	    if (!this.get(k) && v !== "") {
	      this.values[k] = v;
	    }
	  },
	  // Return the value for a key, or a default value.
	  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
	  // a number of possible default values as properties where 'defaultKey' is
	  // the key of the property that will be chosen; otherwise it's assumed to be
	  // a single value.
	  get: function(k, dflt, defaultKey) {
	    if (defaultKey) {
	      return this.has(k) ? this.values[k] : dflt[defaultKey];
	    }
	    return this.has(k) ? this.values[k] : dflt;
	  },
	  // Check whether we have a value for a key.
	  has: function(k) {
	    return k in this.values;
	  },
	  // Accept a setting if its one of the given alternatives.
	  alt: function(k, v, a) {
	    for (var n = 0; n < a.length; ++n) {
	      if (v === a[n]) {
	        this.set(k, v);
	        break;
	      }
	    }
	  },
	  // Accept a setting if its a valid (signed) integer.
	  integer: function(k, v) {
	    if (/^-?\d+$/.test(v)) { // integer
	      this.set(k, parseInt(v, 10));
	    }
	  },
	  // Accept a setting if its a valid percentage.
	  percent: function(k, v) {
	    var m;
	    if ((m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/))) {
	      v = parseFloat(v);
	      if (v >= 0 && v <= 100) {
	        this.set(k, v);
	        return true;
	      }
	    }
	    return false;
	  }
	};
	
	// Helper function to parse input into groups separated by 'groupDelim', and
	// interprete each group as a key/value pair separated by 'keyValueDelim'.
	function parseOptions(input, callback, keyValueDelim, groupDelim) {
	  var groups = groupDelim ? input.split(groupDelim) : [input];
	  for (var i in groups) {
	    if (typeof groups[i] !== "string") {
	      continue;
	    }
	    var kv = groups[i].split(keyValueDelim);
	    if (kv.length !== 2) {
	      continue;
	    }
	    var k = kv[0].trim();
	    var v = kv[1].trim();
	    callback(k, v);
	  }
	}
	
	function parseCue(input, cue, regionList) {
	  // Remember the original input if we need to throw an error.
	  var oInput = input;
	  // 4.1 WebVTT timestamp
	  function consumeTimeStamp() {
	    var ts = parseTimeStamp(input);
	    if (ts === null) {
	      throw new ParsingError(ParsingError.Errors.BadTimeStamp,
	                            "Malformed timestamp: " + oInput);
	    }
	    // Remove time stamp from input.
	    input = input.replace(/^[^\sa-zA-Z-]+/, "");
	    return ts;
	  }
	
	  // 4.4.2 WebVTT cue settings
	  function consumeCueSettings(input, cue) {
	    var settings = new Settings();
	
	    parseOptions(input, function (k, v) {
	      switch (k) {
	      case "region":
	        // Find the last region we parsed with the same region id.
	        for (var i = regionList.length - 1; i >= 0; i--) {
	          if (regionList[i].id === v) {
	            settings.set(k, regionList[i].region);
	            break;
	          }
	        }
	        break;
	      case "vertical":
	        settings.alt(k, v, ["rl", "lr"]);
	        break;
	      case "line":
	        var vals = v.split(","),
	            vals0 = vals[0];
	        settings.integer(k, vals0);
	        settings.percent(k, vals0) ? settings.set("snapToLines", false) : null;
	        settings.alt(k, vals0, ["auto"]);
	        if (vals.length === 2) {
	          settings.alt("lineAlign", vals[1], ["start", "center", "end"]);
	        }
	        break;
	      case "position":
	        vals = v.split(",");
	        settings.percent(k, vals[0]);
	        if (vals.length === 2) {
	          settings.alt("positionAlign", vals[1], ["start", "center", "end"]);
	        }
	        break;
	      case "size":
	        settings.percent(k, v);
	        break;
	      case "align":
	        settings.alt(k, v, ["start", "center", "end", "left", "right"]);
	        break;
	      }
	    }, /:/, /\s/);
	
	    // Apply default values for any missing fields.
	    cue.region = settings.get("region", null);
	    cue.vertical = settings.get("vertical", "");
	    try {
	      cue.line = settings.get("line", "auto");
	    } catch (e) {}
	    cue.lineAlign = settings.get("lineAlign", "start");
	    cue.snapToLines = settings.get("snapToLines", true);
	    cue.size = settings.get("size", 100);
	    // Safari still uses the old middle value and won't accept center
	    try {
	      cue.align = settings.get("align", "center");
	    } catch (e) {
	      cue.align = settings.get("align", "middle");
	    }
	    try {
	      cue.position = settings.get("position", "auto");
	    } catch (e) {
	      cue.position = settings.get("position", {
	        start: 0,
	        left: 0,
	        center: 50,
	        middle: 50,
	        end: 100,
	        right: 100
	      }, cue.align);
	    }
	
	
	    cue.positionAlign = settings.get("positionAlign", {
	      start: "start",
	      left: "start",
	      center: "center",
	      middle: "center",
	      end: "end",
	      right: "end"
	    }, cue.align);
	  }
	
	  function skipWhitespace() {
	    input = input.replace(/^\s+/, "");
	  }
	
	  // 4.1 WebVTT cue timings.
	  skipWhitespace();
	  cue.startTime = consumeTimeStamp();   // (1) collect cue start time
	  skipWhitespace();
	  if (input.substr(0, 3) !== "-->") {     // (3) next characters must match "-->"
	    throw new ParsingError(ParsingError.Errors.BadTimeStamp,
	                           "Malformed time stamp (time stamps must be separated by '-->'): " +
	                           oInput);
	  }
	  input = input.substr(3);
	  skipWhitespace();
	  cue.endTime = consumeTimeStamp();     // (5) collect cue end time
	
	  // 4.1 WebVTT cue settings list.
	  skipWhitespace();
	  consumeCueSettings(input, cue);
	}
	
	// When evaluating this file as part of a Webpack bundle for server
	// side rendering, `document` is an empty object.
	var TEXTAREA_ELEMENT = document.createElement && document.createElement("textarea");
	
	var TAG_NAME = {
	  c: "span",
	  i: "i",
	  b: "b",
	  u: "u",
	  ruby: "ruby",
	  rt: "rt",
	  v: "span",
	  lang: "span"
	};
	
	// 5.1 default text color
	// 5.2 default text background color is equivalent to text color with bg_ prefix
	var DEFAULT_COLOR_CLASS = {
	  white: 'rgba(255,255,255,1)',
	  lime: 'rgba(0,255,0,1)',
	  cyan: 'rgba(0,255,255,1)',
	  red: 'rgba(255,0,0,1)',
	  yellow: 'rgba(255,255,0,1)',
	  magenta: 'rgba(255,0,255,1)',
	  blue: 'rgba(0,0,255,1)',
	  black: 'rgba(0,0,0,1)'
	};
	
	var TAG_ANNOTATION = {
	  v: "title",
	  lang: "lang"
	};
	
	var NEEDS_PARENT = {
	  rt: "ruby"
	};
	
	// Parse content into a document fragment.
	function parseContent(window, input) {
	  function nextToken() {
	    // Check for end-of-string.
	    if (!input) {
	      return null;
	    }
	
	    // Consume 'n' characters from the input.
	    function consume(result) {
	      input = input.substr(result.length);
	      return result;
	    }
	
	    var m = input.match(/^([^<]*)(<[^>]*>?)?/);
	    // If there is some text before the next tag, return it, otherwise return
	    // the tag.
	    return consume(m[1] ? m[1] : m[2]);
	  }
	
	  function unescape(s) {
	    TEXTAREA_ELEMENT.innerHTML = s;
	    s = TEXTAREA_ELEMENT.textContent;
	    TEXTAREA_ELEMENT.textContent = "";
	    return s;
	  }
	
	  function shouldAdd(current, element) {
	    return !NEEDS_PARENT[element.localName] ||
	           NEEDS_PARENT[element.localName] === current.localName;
	  }
	
	  // Create an element for this tag.
	  function createElement(type, annotation) {
	    var tagName = TAG_NAME[type];
	    if (!tagName) {
	      return null;
	    }
	    var element = window.document.createElement(tagName);
	    var name = TAG_ANNOTATION[type];
	    if (name && annotation) {
	      element[name] = annotation.trim();
	    }
	    return element;
	  }
	
	  var rootDiv = window.document.createElement("div"),
	      current = rootDiv,
	      t,
	      tagStack = [];
	
	  while ((t = nextToken()) !== null) {
	    if (t[0] === '<') {
	      if (t[1] === "/") {
	        // If the closing tag matches, move back up to the parent node.
	        if (tagStack.length &&
	            tagStack[tagStack.length - 1] === t.substr(2).replace(">", "")) {
	          tagStack.pop();
	          current = current.parentNode;
	        }
	        // Otherwise just ignore the end tag.
	        continue;
	      }
	      var ts = parseTimeStamp(t.substr(1, t.length - 2));
	      var node;
	      if (ts) {
	        // Timestamps are lead nodes as well.
	        node = window.document.createProcessingInstruction("timestamp", ts);
	        current.appendChild(node);
	        continue;
	      }
	      var m = t.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
	      // If we can't parse the tag, skip to the next tag.
	      if (!m) {
	        continue;
	      }
	      // Try to construct an element, and ignore the tag if we couldn't.
	      node = createElement(m[1], m[3]);
	      if (!node) {
	        continue;
	      }
	      // Determine if the tag should be added based on the context of where it
	      // is placed in the cuetext.
	      if (!shouldAdd(current, node)) {
	        continue;
	      }
	      // Set the class list (as a list of classes, separated by space).
	      if (m[2]) {
	        var classes = m[2].split('.');
	
	        classes.forEach(function(cl) {
	          var bgColor = /^bg_/.test(cl);
	          // slice out `bg_` if it's a background color
	          var colorName = bgColor ? cl.slice(3) : cl;
	
	          if (DEFAULT_COLOR_CLASS.hasOwnProperty(colorName)) {
	            var propName = bgColor ? 'background-color' : 'color';
	            var propValue = DEFAULT_COLOR_CLASS[colorName];
	
	            node.style[propName] = propValue;
	          }
	        });
	
	        node.className = classes.join(' ');
	      }
	      // Append the node to the current node, and enter the scope of the new
	      // node.
	      tagStack.push(m[1]);
	      current.appendChild(node);
	      current = node;
	      continue;
	    }
	
	    // Text nodes are leaf nodes.
	    current.appendChild(window.document.createTextNode(unescape(t)));
	  }
	
	  return rootDiv;
	}
	
	// This is a list of all the Unicode characters that have a strong
	// right-to-left category. What this means is that these characters are
	// written right-to-left for sure. It was generated by pulling all the strong
	// right-to-left characters out of the Unicode data table. That table can
	// found at: http://www.unicode.org/Public/UNIDATA/UnicodeData.txt
	var strongRTLRanges = [[0x5be, 0x5be], [0x5c0, 0x5c0], [0x5c3, 0x5c3], [0x5c6, 0x5c6],
	 [0x5d0, 0x5ea], [0x5f0, 0x5f4], [0x608, 0x608], [0x60b, 0x60b], [0x60d, 0x60d],
	 [0x61b, 0x61b], [0x61e, 0x64a], [0x66d, 0x66f], [0x671, 0x6d5], [0x6e5, 0x6e6],
	 [0x6ee, 0x6ef], [0x6fa, 0x70d], [0x70f, 0x710], [0x712, 0x72f], [0x74d, 0x7a5],
	 [0x7b1, 0x7b1], [0x7c0, 0x7ea], [0x7f4, 0x7f5], [0x7fa, 0x7fa], [0x800, 0x815],
	 [0x81a, 0x81a], [0x824, 0x824], [0x828, 0x828], [0x830, 0x83e], [0x840, 0x858],
	 [0x85e, 0x85e], [0x8a0, 0x8a0], [0x8a2, 0x8ac], [0x200f, 0x200f],
	 [0xfb1d, 0xfb1d], [0xfb1f, 0xfb28], [0xfb2a, 0xfb36], [0xfb38, 0xfb3c],
	 [0xfb3e, 0xfb3e], [0xfb40, 0xfb41], [0xfb43, 0xfb44], [0xfb46, 0xfbc1],
	 [0xfbd3, 0xfd3d], [0xfd50, 0xfd8f], [0xfd92, 0xfdc7], [0xfdf0, 0xfdfc],
	 [0xfe70, 0xfe74], [0xfe76, 0xfefc], [0x10800, 0x10805], [0x10808, 0x10808],
	 [0x1080a, 0x10835], [0x10837, 0x10838], [0x1083c, 0x1083c], [0x1083f, 0x10855],
	 [0x10857, 0x1085f], [0x10900, 0x1091b], [0x10920, 0x10939], [0x1093f, 0x1093f],
	 [0x10980, 0x109b7], [0x109be, 0x109bf], [0x10a00, 0x10a00], [0x10a10, 0x10a13],
	 [0x10a15, 0x10a17], [0x10a19, 0x10a33], [0x10a40, 0x10a47], [0x10a50, 0x10a58],
	 [0x10a60, 0x10a7f], [0x10b00, 0x10b35], [0x10b40, 0x10b55], [0x10b58, 0x10b72],
	 [0x10b78, 0x10b7f], [0x10c00, 0x10c48], [0x1ee00, 0x1ee03], [0x1ee05, 0x1ee1f],
	 [0x1ee21, 0x1ee22], [0x1ee24, 0x1ee24], [0x1ee27, 0x1ee27], [0x1ee29, 0x1ee32],
	 [0x1ee34, 0x1ee37], [0x1ee39, 0x1ee39], [0x1ee3b, 0x1ee3b], [0x1ee42, 0x1ee42],
	 [0x1ee47, 0x1ee47], [0x1ee49, 0x1ee49], [0x1ee4b, 0x1ee4b], [0x1ee4d, 0x1ee4f],
	 [0x1ee51, 0x1ee52], [0x1ee54, 0x1ee54], [0x1ee57, 0x1ee57], [0x1ee59, 0x1ee59],
	 [0x1ee5b, 0x1ee5b], [0x1ee5d, 0x1ee5d], [0x1ee5f, 0x1ee5f], [0x1ee61, 0x1ee62],
	 [0x1ee64, 0x1ee64], [0x1ee67, 0x1ee6a], [0x1ee6c, 0x1ee72], [0x1ee74, 0x1ee77],
	 [0x1ee79, 0x1ee7c], [0x1ee7e, 0x1ee7e], [0x1ee80, 0x1ee89], [0x1ee8b, 0x1ee9b],
	 [0x1eea1, 0x1eea3], [0x1eea5, 0x1eea9], [0x1eeab, 0x1eebb], [0x10fffd, 0x10fffd]];
	
	function isStrongRTLChar(charCode) {
	  for (var i = 0; i < strongRTLRanges.length; i++) {
	    var currentRange = strongRTLRanges[i];
	    if (charCode >= currentRange[0] && charCode <= currentRange[1]) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function determineBidi(cueDiv) {
	  var nodeStack = [],
	      text = "",
	      charCode;
	
	  if (!cueDiv || !cueDiv.childNodes) {
	    return "ltr";
	  }
	
	  function pushNodes(nodeStack, node) {
	    for (var i = node.childNodes.length - 1; i >= 0; i--) {
	      nodeStack.push(node.childNodes[i]);
	    }
	  }
	
	  function nextTextNode(nodeStack) {
	    if (!nodeStack || !nodeStack.length) {
	      return null;
	    }
	
	    var node = nodeStack.pop(),
	        text = node.textContent || node.innerText;
	    if (text) {
	      // TODO: This should match all unicode type B characters (paragraph
	      // separator characters). See issue #115.
	      var m = text.match(/^.*(\n|\r)/);
	      if (m) {
	        nodeStack.length = 0;
	        return m[0];
	      }
	      return text;
	    }
	    if (node.tagName === "ruby") {
	      return nextTextNode(nodeStack);
	    }
	    if (node.childNodes) {
	      pushNodes(nodeStack, node);
	      return nextTextNode(nodeStack);
	    }
	  }
	
	  pushNodes(nodeStack, cueDiv);
	  while ((text = nextTextNode(nodeStack))) {
	    for (var i = 0; i < text.length; i++) {
	      charCode = text.charCodeAt(i);
	      if (isStrongRTLChar(charCode)) {
	        return "rtl";
	      }
	    }
	  }
	  return "ltr";
	}
	
	function computeLinePos(cue) {
	  if (typeof cue.line === "number" &&
	      (cue.snapToLines || (cue.line >= 0 && cue.line <= 100))) {
	    return cue.line;
	  }
	  if (!cue.track || !cue.track.textTrackList ||
	      !cue.track.textTrackList.mediaElement) {
	    return -1;
	  }
	  var track = cue.track,
	      trackList = track.textTrackList,
	      count = 0;
	  for (var i = 0; i < trackList.length && trackList[i] !== track; i++) {
	    if (trackList[i].mode === "showing") {
	      count++;
	    }
	  }
	  return ++count * -1;
	}
	
	function StyleBox() {
	}
	
	// Apply styles to a div. If there is no div passed then it defaults to the
	// div on 'this'.
	StyleBox.prototype.applyStyles = function(styles, div) {
	  div = div || this.div;
	  for (var prop in styles) {
	    if (styles.hasOwnProperty(prop)) {
	      div.style[prop] = styles[prop];
	    }
	  }
	};
	
	StyleBox.prototype.formatStyle = function(val, unit) {
	  return val === 0 ? 0 : val + unit;
	};
	
	// Constructs the computed display state of the cue (a div). Places the div
	// into the overlay which should be a block level element (usually a div).
	function CueStyleBox(window, cue, styleOptions) {
	  StyleBox.call(this);
	  this.cue = cue;
	
	  // Parse our cue's text into a DOM tree rooted at 'cueDiv'. This div will
	  // have inline positioning and will function as the cue background box.
	  this.cueDiv = parseContent(window, cue.text);
	  var styles = {
	    color: "rgba(255, 255, 255, 1)",
	    backgroundColor:  "rgba(0, 0, 0, 0.8)",
	    position: "relative",
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0,
	    display: "inline",
	    writingMode: cue.vertical === "" ? "horizontal-tb"
	                                     : cue.vertical === "lr" ? "vertical-lr"
	                                                             : "vertical-rl",
	    unicodeBidi: "plaintext"
	  };
	
	  this.applyStyles(styles, this.cueDiv);
	
	  // Create an absolutely positioned div that will be used to position the cue
	  // div. Note, all WebVTT cue-setting alignments are equivalent to the CSS
	  // mirrors of them except middle instead of center on Safari.
	  this.div = window.document.createElement("div");
	  styles = {
	    direction: determineBidi(this.cueDiv),
	    writingMode: cue.vertical === "" ? "horizontal-tb"
	                                     : cue.vertical === "lr" ? "vertical-lr"
	                                                             : "vertical-rl",
	    unicodeBidi: "plaintext",
	    textAlign: cue.align === "middle" ? "center" : cue.align,
	    font: styleOptions.font,
	    whiteSpace: "pre-line",
	    position: "absolute"
	  };
	
	  this.applyStyles(styles);
	  this.div.appendChild(this.cueDiv);
	
	  // Calculate the distance from the reference edge of the viewport to the text
	  // position of the cue box. The reference edge will be resolved later when
	  // the box orientation styles are applied.
	  var textPos = 0;
	  switch (cue.positionAlign) {
	  case "start":
	  case "line-left":
	    textPos = cue.position;
	    break;
	  case "center":
	    textPos = cue.position - (cue.size / 2);
	    break;
	  case "end":
	  case "line-right":
	    textPos = cue.position - cue.size;
	    break;
	  }
	
	  // Horizontal box orientation; textPos is the distance from the left edge of the
	  // area to the left edge of the box and cue.size is the distance extending to
	  // the right from there.
	  if (cue.vertical === "") {
	    this.applyStyles({
	      left:  this.formatStyle(textPos, "%"),
	      width: this.formatStyle(cue.size, "%")
	    });
	  // Vertical box orientation; textPos is the distance from the top edge of the
	  // area to the top edge of the box and cue.size is the height extending
	  // downwards from there.
	  } else {
	    this.applyStyles({
	      top: this.formatStyle(textPos, "%"),
	      height: this.formatStyle(cue.size, "%")
	    });
	  }
	
	  this.move = function(box) {
	    this.applyStyles({
	      top: this.formatStyle(box.top, "px"),
	      bottom: this.formatStyle(box.bottom, "px"),
	      left: this.formatStyle(box.left, "px"),
	      right: this.formatStyle(box.right, "px"),
	      height: this.formatStyle(box.height, "px"),
	      width: this.formatStyle(box.width, "px")
	    });
	  };
	}
	CueStyleBox.prototype = _objCreate(StyleBox.prototype);
	CueStyleBox.prototype.constructor = CueStyleBox;
	
	// Represents the co-ordinates of an Element in a way that we can easily
	// compute things with such as if it overlaps or intersects with another Element.
	// Can initialize it with either a StyleBox or another BoxPosition.
	function BoxPosition(obj) {
	  // Either a BoxPosition was passed in and we need to copy it, or a StyleBox
	  // was passed in and we need to copy the results of 'getBoundingClientRect'
	  // as the object returned is readonly. All co-ordinate values are in reference
	  // to the viewport origin (top left).
	  var lh, height, width, top;
	  if (obj.div) {
	    height = obj.div.offsetHeight;
	    width = obj.div.offsetWidth;
	    top = obj.div.offsetTop;
	
	    var rects = (rects = obj.div.childNodes) && (rects = rects[0]) &&
	                rects.getClientRects && rects.getClientRects();
	    obj = obj.div.getBoundingClientRect();
	    // In certain cases the outter div will be slightly larger then the sum of
	    // the inner div's lines. This could be due to bold text, etc, on some platforms.
	    // In this case we should get the average line height and use that. This will
	    // result in the desired behaviour.
	    lh = rects ? Math.max((rects[0] && rects[0].height) || 0, obj.height / rects.length)
	               : 0;
	
	  }
	  this.left = obj.left;
	  this.right = obj.right;
	  this.top = obj.top || top;
	  this.height = obj.height || height;
	  this.bottom = obj.bottom || (top + (obj.height || height));
	  this.width = obj.width || width;
	  this.lineHeight = lh !== undefined ? lh : obj.lineHeight;
	}
	
	// Move the box along a particular axis. Optionally pass in an amount to move
	// the box. If no amount is passed then the default is the line height of the
	// box.
	BoxPosition.prototype.move = function(axis, toMove) {
	  toMove = toMove !== undefined ? toMove : this.lineHeight;
	  switch (axis) {
	  case "+x":
	    this.left += toMove;
	    this.right += toMove;
	    break;
	  case "-x":
	    this.left -= toMove;
	    this.right -= toMove;
	    break;
	  case "+y":
	    this.top += toMove;
	    this.bottom += toMove;
	    break;
	  case "-y":
	    this.top -= toMove;
	    this.bottom -= toMove;
	    break;
	  }
	};
	
	// Check if this box overlaps another box, b2.
	BoxPosition.prototype.overlaps = function(b2) {
	  return this.left < b2.right &&
	         this.right > b2.left &&
	         this.top < b2.bottom &&
	         this.bottom > b2.top;
	};
	
	// Check if this box overlaps any other boxes in boxes.
	BoxPosition.prototype.overlapsAny = function(boxes) {
	  for (var i = 0; i < boxes.length; i++) {
	    if (this.overlaps(boxes[i])) {
	      return true;
	    }
	  }
	  return false;
	};
	
	// Check if this box is within another box.
	BoxPosition.prototype.within = function(container) {
	  return this.top >= container.top &&
	         this.bottom <= container.bottom &&
	         this.left >= container.left &&
	         this.right <= container.right;
	};
	
	// Check if this box is entirely within the container or it is overlapping
	// on the edge opposite of the axis direction passed. For example, if "+x" is
	// passed and the box is overlapping on the left edge of the container, then
	// return true.
	BoxPosition.prototype.overlapsOppositeAxis = function(container, axis) {
	  switch (axis) {
	  case "+x":
	    return this.left < container.left;
	  case "-x":
	    return this.right > container.right;
	  case "+y":
	    return this.top < container.top;
	  case "-y":
	    return this.bottom > container.bottom;
	  }
	};
	
	// Find the percentage of the area that this box is overlapping with another
	// box.
	BoxPosition.prototype.intersectPercentage = function(b2) {
	  var x = Math.max(0, Math.min(this.right, b2.right) - Math.max(this.left, b2.left)),
	      y = Math.max(0, Math.min(this.bottom, b2.bottom) - Math.max(this.top, b2.top)),
	      intersectArea = x * y;
	  return intersectArea / (this.height * this.width);
	};
	
	// Convert the positions from this box to CSS compatible positions using
	// the reference container's positions. This has to be done because this
	// box's positions are in reference to the viewport origin, whereas, CSS
	// values are in referecne to their respective edges.
	BoxPosition.prototype.toCSSCompatValues = function(reference) {
	  return {
	    top: this.top - reference.top,
	    bottom: reference.bottom - this.bottom,
	    left: this.left - reference.left,
	    right: reference.right - this.right,
	    height: this.height,
	    width: this.width
	  };
	};
	
	// Get an object that represents the box's position without anything extra.
	// Can pass a StyleBox, HTMLElement, or another BoxPositon.
	BoxPosition.getSimpleBoxPosition = function(obj) {
	  var height = obj.div ? obj.div.offsetHeight : obj.tagName ? obj.offsetHeight : 0;
	  var width = obj.div ? obj.div.offsetWidth : obj.tagName ? obj.offsetWidth : 0;
	  var top = obj.div ? obj.div.offsetTop : obj.tagName ? obj.offsetTop : 0;
	
	  obj = obj.div ? obj.div.getBoundingClientRect() :
	                obj.tagName ? obj.getBoundingClientRect() : obj;
	  var ret = {
	    left: obj.left,
	    right: obj.right,
	    top: obj.top || top,
	    height: obj.height || height,
	    bottom: obj.bottom || (top + (obj.height || height)),
	    width: obj.width || width
	  };
	  return ret;
	};
	
	// Move a StyleBox to its specified, or next best, position. The containerBox
	// is the box that contains the StyleBox, such as a div. boxPositions are
	// a list of other boxes that the styleBox can't overlap with.
	function moveBoxToLinePosition(window, styleBox, containerBox, boxPositions) {
	
	  // Find the best position for a cue box, b, on the video. The axis parameter
	  // is a list of axis, the order of which, it will move the box along. For example:
	  // Passing ["+x", "-x"] will move the box first along the x axis in the positive
	  // direction. If it doesn't find a good position for it there it will then move
	  // it along the x axis in the negative direction.
	  function findBestPosition(b, axis) {
	    var bestPosition,
	        specifiedPosition = new BoxPosition(b),
	        percentage = 1; // Highest possible so the first thing we get is better.
	
	    for (var i = 0; i < axis.length; i++) {
	      while (b.overlapsOppositeAxis(containerBox, axis[i]) ||
	             (b.within(containerBox) && b.overlapsAny(boxPositions))) {
	        b.move(axis[i]);
	      }
	      // We found a spot where we aren't overlapping anything. This is our
	      // best position.
	      if (b.within(containerBox)) {
	        return b;
	      }
	      var p = b.intersectPercentage(containerBox);
	      // If we're outside the container box less then we were on our last try
	      // then remember this position as the best position.
	      if (percentage > p) {
	        bestPosition = new BoxPosition(b);
	        percentage = p;
	      }
	      // Reset the box position to the specified position.
	      b = new BoxPosition(specifiedPosition);
	    }
	    return bestPosition || specifiedPosition;
	  }
	
	  var boxPosition = new BoxPosition(styleBox),
	      cue = styleBox.cue,
	      linePos = computeLinePos(cue),
	      axis = [];
	
	  // If we have a line number to align the cue to.
	  if (cue.snapToLines) {
	    var size;
	    switch (cue.vertical) {
	    case "":
	      axis = [ "+y", "-y" ];
	      size = "height";
	      break;
	    case "rl":
	      axis = [ "+x", "-x" ];
	      size = "width";
	      break;
	    case "lr":
	      axis = [ "-x", "+x" ];
	      size = "width";
	      break;
	    }
	
	    var step = boxPosition.lineHeight,
	        position = step * Math.round(linePos),
	        maxPosition = containerBox[size] + step,
	        initialAxis = axis[0];
	
	    // If the specified intial position is greater then the max position then
	    // clamp the box to the amount of steps it would take for the box to
	    // reach the max position.
	    if (Math.abs(position) > maxPosition) {
	      position = position < 0 ? -1 : 1;
	      position *= Math.ceil(maxPosition / step) * step;
	    }
	
	    // If computed line position returns negative then line numbers are
	    // relative to the bottom of the video instead of the top. Therefore, we
	    // need to increase our initial position by the length or width of the
	    // video, depending on the writing direction, and reverse our axis directions.
	    if (linePos < 0) {
	      position += cue.vertical === "" ? containerBox.height : containerBox.width;
	      axis = axis.reverse();
	    }
	
	    // Move the box to the specified position. This may not be its best
	    // position.
	    boxPosition.move(initialAxis, position);
	
	  } else {
	    // If we have a percentage line value for the cue.
	    var calculatedPercentage = (boxPosition.lineHeight / containerBox.height) * 100;
	
	    switch (cue.lineAlign) {
	    case "center":
	      linePos -= (calculatedPercentage / 2);
	      break;
	    case "end":
	      linePos -= calculatedPercentage;
	      break;
	    }
	
	    // Apply initial line position to the cue box.
	    switch (cue.vertical) {
	    case "":
	      styleBox.applyStyles({
	        top: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    case "rl":
	      styleBox.applyStyles({
	        left: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    case "lr":
	      styleBox.applyStyles({
	        right: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    }
	
	    axis = [ "+y", "-x", "+x", "-y" ];
	
	    // Get the box position again after we've applied the specified positioning
	    // to it.
	    boxPosition = new BoxPosition(styleBox);
	  }
	
	  var bestPosition = findBestPosition(boxPosition, axis);
	  styleBox.move(bestPosition.toCSSCompatValues(containerBox));
	}
	
	function WebVTT() {
	  // Nothing
	}
	
	// Helper to allow strings to be decoded instead of the default binary utf8 data.
	WebVTT.StringDecoder = function() {
	  return {
	    decode: function(data) {
	      if (!data) {
	        return "";
	      }
	      if (typeof data !== "string") {
	        throw new Error("Error - expected string data.");
	      }
	      return decodeURIComponent(encodeURIComponent(data));
	    }
	  };
	};
	
	WebVTT.convertCueToDOMTree = function(window, cuetext) {
	  if (!window || !cuetext) {
	    return null;
	  }
	  return parseContent(window, cuetext);
	};
	
	var FONT_SIZE_PERCENT = 0.05;
	var FONT_STYLE = "sans-serif";
	var CUE_BACKGROUND_PADDING = "1.5%";
	
	// Runs the processing model over the cues and regions passed to it.
	// @param overlay A block level element (usually a div) that the computed cues
	//                and regions will be placed into.
	WebVTT.processCues = function(window, cues, overlay) {
	  if (!window || !cues || !overlay) {
	    return null;
	  }
	
	  // Remove all previous children.
	  while (overlay.firstChild) {
	    overlay.removeChild(overlay.firstChild);
	  }
	
	  var paddedOverlay = window.document.createElement("div");
	  paddedOverlay.style.position = "absolute";
	  paddedOverlay.style.left = "0";
	  paddedOverlay.style.right = "0";
	  paddedOverlay.style.top = "0";
	  paddedOverlay.style.bottom = "0";
	  paddedOverlay.style.margin = CUE_BACKGROUND_PADDING;
	  overlay.appendChild(paddedOverlay);
	
	  // Determine if we need to compute the display states of the cues. This could
	  // be the case if a cue's state has been changed since the last computation or
	  // if it has not been computed yet.
	  function shouldCompute(cues) {
	    for (var i = 0; i < cues.length; i++) {
	      if (cues[i].hasBeenReset || !cues[i].displayState) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  // We don't need to recompute the cues' display states. Just reuse them.
	  if (!shouldCompute(cues)) {
	    for (var i = 0; i < cues.length; i++) {
	      paddedOverlay.appendChild(cues[i].displayState);
	    }
	    return;
	  }
	
	  var boxPositions = [],
	      containerBox = BoxPosition.getSimpleBoxPosition(paddedOverlay),
	      fontSize = Math.round(containerBox.height * FONT_SIZE_PERCENT * 100) / 100;
	  var styleOptions = {
	    font: fontSize + "px " + FONT_STYLE
	  };
	
	  (function() {
	    var styleBox, cue;
	
	    for (var i = 0; i < cues.length; i++) {
	      cue = cues[i];
	
	      // Compute the intial position and styles of the cue div.
	      styleBox = new CueStyleBox(window, cue, styleOptions);
	      paddedOverlay.appendChild(styleBox.div);
	
	      // Move the cue div to it's correct line position.
	      moveBoxToLinePosition(window, styleBox, containerBox, boxPositions);
	
	      // Remember the computed div so that we don't have to recompute it later
	      // if we don't have too.
	      cue.displayState = styleBox.div;
	
	      boxPositions.push(BoxPosition.getSimpleBoxPosition(styleBox));
	    }
	  })();
	};
	
	WebVTT.Parser = function(window, vttjs, decoder) {
	  if (!decoder) {
	    decoder = vttjs;
	    vttjs = {};
	  }
	  if (!vttjs) {
	    vttjs = {};
	  }
	
	  this.window = window;
	  this.vttjs = vttjs;
	  this.state = "INITIAL";
	  this.buffer = "";
	  this.decoder = decoder || new TextDecoder("utf8");
	  this.regionList = [];
	};
	
	WebVTT.Parser.prototype = {
	  // If the error is a ParsingError then report it to the consumer if
	  // possible. If it's not a ParsingError then throw it like normal.
	  reportOrThrowError: function(e) {
	    if (e instanceof ParsingError) {
	      this.onparsingerror && this.onparsingerror(e);
	    } else {
	      throw e;
	    }
	  },
	  parse: function (data) {
	    var self = this;
	
	    // If there is no data then we won't decode it, but will just try to parse
	    // whatever is in buffer already. This may occur in circumstances, for
	    // example when flush() is called.
	    if (data) {
	      // Try to decode the data that we received.
	      self.buffer += self.decoder.decode(data, {stream: true});
	    }
	
	    function collectNextLine() {
	      var buffer = self.buffer;
	      var pos = 0;
	      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
	        ++pos;
	      }
	      var line = buffer.substr(0, pos);
	      // Advance the buffer early in case we fail below.
	      if (buffer[pos] === '\r') {
	        ++pos;
	      }
	      if (buffer[pos] === '\n') {
	        ++pos;
	      }
	      self.buffer = buffer.substr(pos);
	      return line;
	    }
	
	    // 3.4 WebVTT region and WebVTT region settings syntax
	    function parseRegion(input) {
	      var settings = new Settings();
	
	      parseOptions(input, function (k, v) {
	        switch (k) {
	        case "id":
	          settings.set(k, v);
	          break;
	        case "width":
	          settings.percent(k, v);
	          break;
	        case "lines":
	          settings.integer(k, v);
	          break;
	        case "regionanchor":
	        case "viewportanchor":
	          var xy = v.split(',');
	          if (xy.length !== 2) {
	            break;
	          }
	          // We have to make sure both x and y parse, so use a temporary
	          // settings object here.
	          var anchor = new Settings();
	          anchor.percent("x", xy[0]);
	          anchor.percent("y", xy[1]);
	          if (!anchor.has("x") || !anchor.has("y")) {
	            break;
	          }
	          settings.set(k + "X", anchor.get("x"));
	          settings.set(k + "Y", anchor.get("y"));
	          break;
	        case "scroll":
	          settings.alt(k, v, ["up"]);
	          break;
	        }
	      }, /=/, /\s/);
	
	      // Create the region, using default values for any values that were not
	      // specified.
	      if (settings.has("id")) {
	        var region = new (self.vttjs.VTTRegion || self.window.VTTRegion)();
	        region.width = settings.get("width", 100);
	        region.lines = settings.get("lines", 3);
	        region.regionAnchorX = settings.get("regionanchorX", 0);
	        region.regionAnchorY = settings.get("regionanchorY", 100);
	        region.viewportAnchorX = settings.get("viewportanchorX", 0);
	        region.viewportAnchorY = settings.get("viewportanchorY", 100);
	        region.scroll = settings.get("scroll", "");
	        // Register the region.
	        self.onregion && self.onregion(region);
	        // Remember the VTTRegion for later in case we parse any VTTCues that
	        // reference it.
	        self.regionList.push({
	          id: settings.get("id"),
	          region: region
	        });
	      }
	    }
	
	    // draft-pantos-http-live-streaming-20
	    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-20#section-3.5
	    // 3.5 WebVTT
	    function parseTimestampMap(input) {
	      var settings = new Settings();
	
	      parseOptions(input, function(k, v) {
	        switch(k) {
	        case "MPEGT":
	          settings.integer(k + 'S', v);
	          break;
	        case "LOCA":
	          settings.set(k + 'L', parseTimeStamp(v));
	          break;
	        }
	      }, /[^\d]:/, /,/);
	
	      self.ontimestampmap && self.ontimestampmap({
	        "MPEGTS": settings.get("MPEGTS"),
	        "LOCAL": settings.get("LOCAL")
	      });
	    }
	
	    // 3.2 WebVTT metadata header syntax
	    function parseHeader(input) {
	      if (input.match(/X-TIMESTAMP-MAP/)) {
	        // This line contains HLS X-TIMESTAMP-MAP metadata
	        parseOptions(input, function(k, v) {
	          switch(k) {
	          case "X-TIMESTAMP-MAP":
	            parseTimestampMap(v);
	            break;
	          }
	        }, /=/);
	      } else {
	        parseOptions(input, function (k, v) {
	          switch (k) {
	          case "Region":
	            // 3.3 WebVTT region metadata header syntax
	            parseRegion(v);
	            break;
	          }
	        }, /:/);
	      }
	
	    }
	
	    // 5.1 WebVTT file parsing.
	    try {
	      var line;
	      if (self.state === "INITIAL") {
	        // We can't start parsing until we have the first line.
	        if (!/\r\n|\n/.test(self.buffer)) {
	          return this;
	        }
	
	        line = collectNextLine();
	
	        var m = line.match(/^WEBVTT([ \t].*)?$/);
	        if (!m || !m[0]) {
	          throw new ParsingError(ParsingError.Errors.BadSignature);
	        }
	
	        self.state = "HEADER";
	      }
	
	      var alreadyCollectedLine = false;
	      while (self.buffer) {
	        // We can't parse a line until we have the full line.
	        if (!/\r\n|\n/.test(self.buffer)) {
	          return this;
	        }
	
	        if (!alreadyCollectedLine) {
	          line = collectNextLine();
	        } else {
	          alreadyCollectedLine = false;
	        }
	
	        switch (self.state) {
	        case "HEADER":
	          // 13-18 - Allow a header (metadata) under the WEBVTT line.
	          if (/:/.test(line)) {
	            parseHeader(line);
	          } else if (!line) {
	            // An empty line terminates the header and starts the body (cues).
	            self.state = "ID";
	          }
	          continue;
	        case "NOTE":
	          // Ignore NOTE blocks.
	          if (!line) {
	            self.state = "ID";
	          }
	          continue;
	        case "ID":
	          // Check for the start of NOTE blocks.
	          if (/^NOTE($|[ \t])/.test(line)) {
	            self.state = "NOTE";
	            break;
	          }
	          // 19-29 - Allow any number of line terminators, then initialize new cue values.
	          if (!line) {
	            continue;
	          }
	          self.cue = new (self.vttjs.VTTCue || self.window.VTTCue)(0, 0, "");
	          // Safari still uses the old middle value and won't accept center
	          try {
	            self.cue.align = "center";
	          } catch (e) {
	            self.cue.align = "middle";
	          }
	          self.state = "CUE";
	          // 30-39 - Check if self line contains an optional identifier or timing data.
	          if (line.indexOf("-->") === -1) {
	            self.cue.id = line;
	            continue;
	          }
	          // Process line as start of a cue.
	          /*falls through*/
	        case "CUE":
	          // 40 - Collect cue timings and settings.
	          try {
	            parseCue(line, self.cue, self.regionList);
	          } catch (e) {
	            self.reportOrThrowError(e);
	            // In case of an error ignore rest of the cue.
	            self.cue = null;
	            self.state = "BADCUE";
	            continue;
	          }
	          self.state = "CUETEXT";
	          continue;
	        case "CUETEXT":
	          var hasSubstring = line.indexOf("-->") !== -1;
	          // 34 - If we have an empty line then report the cue.
	          // 35 - If we have the special substring '-->' then report the cue,
	          // but do not collect the line as we need to process the current
	          // one as a new cue.
	          if (!line || hasSubstring && (alreadyCollectedLine = true)) {
	            // We are done parsing self cue.
	            self.oncue && self.oncue(self.cue);
	            self.cue = null;
	            self.state = "ID";
	            continue;
	          }
	          if (self.cue.text) {
	            self.cue.text += "\n";
	          }
	          self.cue.text += line.replace(/\u2028/g, '\n').replace(/u2029/g, '\n');
	          continue;
	        case "BADCUE": // BADCUE
	          // 54-62 - Collect and discard the remaining cue.
	          if (!line) {
	            self.state = "ID";
	          }
	          continue;
	        }
	      }
	    } catch (e) {
	      self.reportOrThrowError(e);
	
	      // If we are currently parsing a cue, report what we have.
	      if (self.state === "CUETEXT" && self.cue && self.oncue) {
	        self.oncue(self.cue);
	      }
	      self.cue = null;
	      // Enter BADWEBVTT state if header was not parsed correctly otherwise
	      // another exception occurred so enter BADCUE state.
	      self.state = self.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
	    }
	    return this;
	  },
	  flush: function () {
	    var self = this;
	    try {
	      // Finish decoding the stream.
	      self.buffer += self.decoder.decode();
	      // Synthesize the end of the current cue or region.
	      if (self.cue || self.state === "HEADER") {
	        self.buffer += "\n\n";
	        self.parse();
	      }
	      // If we've flushed, parsed, and we're still on the INITIAL state then
	      // that means we don't have enough of the stream to parse the first
	      // line.
	      if (self.state === "INITIAL") {
	        throw new ParsingError(ParsingError.Errors.BadSignature);
	      }
	    } catch(e) {
	      self.reportOrThrowError(e);
	    }
	    self.onflush && self.onflush();
	    return this;
	  }
	};
	
	module.exports = WebVTT;


/***/ },
/* 1950 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var autoKeyword = "auto";
	var directionSetting = {
	  "": 1,
	  "lr": 1,
	  "rl": 1
	};
	var alignSetting = {
	  "start": 1,
	  "center": 1,
	  "end": 1,
	  "left": 1,
	  "right": 1,
	  "auto": 1,
	  "line-left": 1,
	  "line-right": 1
	};
	
	function findDirectionSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var dir = directionSetting[value.toLowerCase()];
	  return dir ? value.toLowerCase() : false;
	}
	
	function findAlignSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var align = alignSetting[value.toLowerCase()];
	  return align ? value.toLowerCase() : false;
	}
	
	function VTTCue(startTime, endTime, text) {
	  /**
	   * Shim implementation specific properties. These properties are not in
	   * the spec.
	   */
	
	  // Lets us know when the VTTCue's data has changed in such a way that we need
	  // to recompute its display state. This lets us compute its display state
	  // lazily.
	  this.hasBeenReset = false;
	
	  /**
	   * VTTCue and TextTrackCue properties
	   * http://dev.w3.org/html5/webvtt/#vttcue-interface
	   */
	
	  var _id = "";
	  var _pauseOnExit = false;
	  var _startTime = startTime;
	  var _endTime = endTime;
	  var _text = text;
	  var _region = null;
	  var _vertical = "";
	  var _snapToLines = true;
	  var _line = "auto";
	  var _lineAlign = "start";
	  var _position = "auto";
	  var _positionAlign = "auto";
	  var _size = 100;
	  var _align = "center";
	
	  Object.defineProperties(this, {
	    "id": {
	      enumerable: true,
	      get: function() {
	        return _id;
	      },
	      set: function(value) {
	        _id = "" + value;
	      }
	    },
	
	    "pauseOnExit": {
	      enumerable: true,
	      get: function() {
	        return _pauseOnExit;
	      },
	      set: function(value) {
	        _pauseOnExit = !!value;
	      }
	    },
	
	    "startTime": {
	      enumerable: true,
	      get: function() {
	        return _startTime;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("Start time must be set to a number.");
	        }
	        _startTime = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "endTime": {
	      enumerable: true,
	      get: function() {
	        return _endTime;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("End time must be set to a number.");
	        }
	        _endTime = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "text": {
	      enumerable: true,
	      get: function() {
	        return _text;
	      },
	      set: function(value) {
	        _text = "" + value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "region": {
	      enumerable: true,
	      get: function() {
	        return _region;
	      },
	      set: function(value) {
	        _region = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "vertical": {
	      enumerable: true,
	      get: function() {
	        return _vertical;
	      },
	      set: function(value) {
	        var setting = findDirectionSetting(value);
	        // Have to check for false because the setting an be an empty string.
	        if (setting === false) {
	          throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
	        }
	        _vertical = setting;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "snapToLines": {
	      enumerable: true,
	      get: function() {
	        return _snapToLines;
	      },
	      set: function(value) {
	        _snapToLines = !!value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "line": {
	      enumerable: true,
	      get: function() {
	        return _line;
	      },
	      set: function(value) {
	        if (typeof value !== "number" && value !== autoKeyword) {
	          throw new SyntaxError("Line: an invalid number or illegal string was specified.");
	        }
	        _line = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "lineAlign": {
	      enumerable: true,
	      get: function() {
	        return _lineAlign;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          console.warn("lineAlign: an invalid or illegal string was specified.");
	        } else {
	          _lineAlign = setting;
	          this.hasBeenReset = true;
	        }
	      }
	    },
	
	    "position": {
	      enumerable: true,
	      get: function() {
	        return _position;
	      },
	      set: function(value) {
	        if (value < 0 || value > 100) {
	          throw new Error("Position must be between 0 and 100.");
	        }
	        _position = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "positionAlign": {
	      enumerable: true,
	      get: function() {
	        return _positionAlign;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          console.warn("positionAlign: an invalid or illegal string was specified.");
	        } else {
	          _positionAlign = setting;
	          this.hasBeenReset = true;
	        }
	      }
	    },
	
	    "size": {
	      enumerable: true,
	      get: function() {
	        return _size;
	      },
	      set: function(value) {
	        if (value < 0 || value > 100) {
	          throw new Error("Size must be between 0 and 100.");
	        }
	        _size = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "align": {
	      enumerable: true,
	      get: function() {
	        return _align;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
	        }
	        _align = setting;
	        this.hasBeenReset = true;
	      }
	    }
	  });
	
	  /**
	   * Other <track> spec defined properties
	   */
	
	  // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
	  this.displayState = undefined;
	}
	
	/**
	 * VTTCue methods
	 */
	
	VTTCue.prototype.getCueAsHTML = function() {
	  // Assume WebVTT.convertCueToDOMTree is on the global.
	  return WebVTT.convertCueToDOMTree(window, this.text);
	};
	
	module.exports = VTTCue;


/***/ },
/* 1951 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var scrollSetting = {
	  "": true,
	  "up": true
	};
	
	function findScrollSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var scroll = scrollSetting[value.toLowerCase()];
	  return scroll ? value.toLowerCase() : false;
	}
	
	function isValidPercentValue(value) {
	  return typeof value === "number" && (value >= 0 && value <= 100);
	}
	
	// VTTRegion shim http://dev.w3.org/html5/webvtt/#vttregion-interface
	function VTTRegion() {
	  var _width = 100;
	  var _lines = 3;
	  var _regionAnchorX = 0;
	  var _regionAnchorY = 100;
	  var _viewportAnchorX = 0;
	  var _viewportAnchorY = 100;
	  var _scroll = "";
	
	  Object.defineProperties(this, {
	    "width": {
	      enumerable: true,
	      get: function() {
	        return _width;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("Width must be between 0 and 100.");
	        }
	        _width = value;
	      }
	    },
	    "lines": {
	      enumerable: true,
	      get: function() {
	        return _lines;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("Lines must be set to a number.");
	        }
	        _lines = value;
	      }
	    },
	    "regionAnchorY": {
	      enumerable: true,
	      get: function() {
	        return _regionAnchorY;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("RegionAnchorX must be between 0 and 100.");
	        }
	        _regionAnchorY = value;
	      }
	    },
	    "regionAnchorX": {
	      enumerable: true,
	      get: function() {
	        return _regionAnchorX;
	      },
	      set: function(value) {
	        if(!isValidPercentValue(value)) {
	          throw new Error("RegionAnchorY must be between 0 and 100.");
	        }
	        _regionAnchorX = value;
	      }
	    },
	    "viewportAnchorY": {
	      enumerable: true,
	      get: function() {
	        return _viewportAnchorY;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("ViewportAnchorY must be between 0 and 100.");
	        }
	        _viewportAnchorY = value;
	      }
	    },
	    "viewportAnchorX": {
	      enumerable: true,
	      get: function() {
	        return _viewportAnchorX;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("ViewportAnchorX must be between 0 and 100.");
	        }
	        _viewportAnchorX = value;
	      }
	    },
	    "scroll": {
	      enumerable: true,
	      get: function() {
	        return _scroll;
	      },
	      set: function(value) {
	        var setting = findScrollSetting(value);
	        // Have to check for false as an empty string is a legal value.
	        if (setting === false) {
	          console.warn("Scroll: an invalid or illegal string was specified.");
	        } else {
	          _scroll = setting;
	        }
	      }
	    }
	  });
	}
	
	module.exports = VTTRegion;


/***/ },
/* 1952 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 1953 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Backbone.BabySitter
	// -------------------
	// v0.1.11
	//
	// Copyright (c)2016 Derick Bailey, Muted Solutions, LLC.
	// Distributed under MIT license
	//
	// http://github.com/marionettejs/backbone.babysitter
	
	(function(root, factory) {
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [(__webpack_require__(__webpack_module_template_argument_0__)), (__webpack_require__(__webpack_module_template_argument_1__))], __WEBPACK_AMD_DEFINE_RESULT__ = function(Backbone, _) {
	      return factory(Backbone, _);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined') {
	    var Backbone = require('backbone');
	    var _ = require('underscore');
	    module.exports = factory(Backbone, _);
	  } else {
	    factory(root.Backbone, root._);
	  }
	
	}(this, function(Backbone, _) {
	  'use strict';
	
	  var previousChildViewContainer = Backbone.ChildViewContainer;
	
	  // BabySitter.ChildViewContainer
	  // -----------------------------
	  //
	  // Provide a container to store, retrieve and
	  // shut down child views.
	  
	  Backbone.ChildViewContainer = (function (Backbone, _) {
	  
	    // Container Constructor
	    // ---------------------
	  
	    var Container = function(views){
	      this._views = {};
	      this._indexByModel = {};
	      this._indexByCustom = {};
	      this._updateLength();
	  
	      _.each(views, this.add, this);
	    };
	  
	    // Container Methods
	    // -----------------
	  
	    _.extend(Container.prototype, {
	  
	      // Add a view to this container. Stores the view
	      // by `cid` and makes it searchable by the model
	      // cid (and model itself). Optionally specify
	      // a custom key to store an retrieve the view.
	      add: function(view, customIndex){
	        var viewCid = view.cid;
	  
	        // store the view
	        this._views[viewCid] = view;
	  
	        // index it by model
	        if (view.model){
	          this._indexByModel[view.model.cid] = viewCid;
	        }
	  
	        // index by custom
	        if (customIndex){
	          this._indexByCustom[customIndex] = viewCid;
	        }
	  
	        this._updateLength();
	        return this;
	      },
	  
	      // Find a view by the model that was attached to
	      // it. Uses the model's `cid` to find it.
	      findByModel: function(model){
	        return this.findByModelCid(model.cid);
	      },
	  
	      // Find a view by the `cid` of the model that was attached to
	      // it. Uses the model's `cid` to find the view `cid` and
	      // retrieve the view using it.
	      findByModelCid: function(modelCid){
	        var viewCid = this._indexByModel[modelCid];
	        return this.findByCid(viewCid);
	      },
	  
	      // Find a view by a custom indexer.
	      findByCustom: function(index){
	        var viewCid = this._indexByCustom[index];
	        return this.findByCid(viewCid);
	      },
	  
	      // Find by index. This is not guaranteed to be a
	      // stable index.
	      findByIndex: function(index){
	        return _.values(this._views)[index];
	      },
	  
	      // retrieve a view by its `cid` directly
	      findByCid: function(cid){
	        return this._views[cid];
	      },
	  
	      // Remove a view
	      remove: function(view){
	        var viewCid = view.cid;
	  
	        // delete model index
	        if (view.model){
	          delete this._indexByModel[view.model.cid];
	        }
	  
	        // delete custom index
	        _.any(this._indexByCustom, function(cid, key) {
	          if (cid === viewCid) {
	            delete this._indexByCustom[key];
	            return true;
	          }
	        }, this);
	  
	        // remove the view from the container
	        delete this._views[viewCid];
	  
	        // update the length
	        this._updateLength();
	        return this;
	      },
	  
	      // Call a method on every view in the container,
	      // passing parameters to the call method one at a
	      // time, like `function.call`.
	      call: function(method){
	        this.apply(method, _.tail(arguments));
	      },
	  
	      // Apply a method on every view in the container,
	      // passing parameters to the call method one at a
	      // time, like `function.apply`.
	      apply: function(method, args){
	        _.each(this._views, function(view){
	          if (_.isFunction(view[method])){
	            view[method].apply(view, args || []);
	          }
	        });
	      },
	  
	      // Update the `.length` attribute on this container
	      _updateLength: function(){
	        this.length = _.size(this._views);
	      }
	    });
	  
	    // Borrowing this code from Backbone.Collection:
	    // http://backbonejs.org/docs/backbone.html#section-106
	    //
	    // Mix in methods from Underscore, for iteration, and other
	    // collection related features.
	    var methods = ['forEach', 'each', 'map', 'find', 'detect', 'filter',
	      'select', 'reject', 'every', 'all', 'some', 'any', 'include',
	      'contains', 'invoke', 'toArray', 'first', 'initial', 'rest',
	      'last', 'without', 'isEmpty', 'pluck', 'reduce'];
	  
	    _.each(methods, function(method) {
	      Container.prototype[method] = function() {
	        var views = _.values(this._views);
	        var args = [views].concat(_.toArray(arguments));
	        return _[method].apply(_, args);
	      };
	    });
	  
	    // return the public API
	    return Container;
	  })(Backbone, _);
	  
	
	  Backbone.ChildViewContainer.VERSION = '0.1.11';
	
	  Backbone.ChildViewContainer.noConflict = function () {
	    Backbone.ChildViewContainer = previousChildViewContainer;
	    return this;
	  };
	
	  return Backbone.ChildViewContainer;
	
	}));


/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// MarionetteJS (Backbone.Marionette)
	// ----------------------------------
	// v2.4.1
	//
	// Copyright (c)2015 Derick Bailey, Muted Solutions, LLC.
	// Distributed under MIT license
	//
	// http://marionettejs.com
	
	(function(root, factory) {
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [(__webpack_require__(__webpack_module_template_argument_0__)), (__webpack_require__(__webpack_module_template_argument_1__)), (__webpack_require__(__webpack_module_template_argument_2__)), (__webpack_require__(__webpack_module_template_argument_3__))], __WEBPACK_AMD_DEFINE_RESULT__ = function(Backbone, _) {
	      return (root.Marionette = root.Mn = factory(root, Backbone, _));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined') {
	    var Backbone = require('backbone');
	    var _ = require('underscore');
	    var Wreqr = require('backbone.wreqr');
	    var BabySitter = require('backbone.babysitter');
	    module.exports = factory(root, Backbone, _);
	  } else {
	    root.Marionette = root.Mn = factory(root, root.Backbone, root._);
	  }
	
	}(this, function(root, Backbone, _) {
	  'use strict';
	
	  var previousMarionette = root.Marionette;
	  var previousMn = root.Mn;
	
	  var Marionette = Backbone.Marionette = {};
	
	  Marionette.VERSION = '2.4.1';
	
	  Marionette.noConflict = function() {
	    root.Marionette = previousMarionette;
	    root.Mn = previousMn;
	    return this;
	  };
	
	  // Get the Deferred creator for later use
	  Marionette.Deferred = Backbone.$.Deferred;
	
	  Marionette.FEATURES = {
	  };
	  
	  Marionette.isEnabled = function(name) {
	    return !!Marionette.FEATURES[name];
	  };
	  
	  /* jshint unused: false *//* global console */
	  
	  // Helpers
	  // -------
	  
	  // Marionette.extend
	  // -----------------
	  
	  // Borrow the Backbone `extend` method so we can use it as needed
	  Marionette.extend = Backbone.Model.extend;
	  
	  // Marionette.isNodeAttached
	  // -------------------------
	  
	  // Determine if `el` is a child of the document
	  Marionette.isNodeAttached = function(el) {
	    return Backbone.$.contains(document.documentElement, el);
	  };
	  
	  // Merge `keys` from `options` onto `this`
	  Marionette.mergeOptions = function(options, keys) {
	    if (!options) { return; }
	    _.extend(this, _.pick(options, keys));
	  };
	  
	  // Marionette.getOption
	  // --------------------
	  
	  // Retrieve an object, function or other value from a target
	  // object or its `options`, with `options` taking precedence.
	  Marionette.getOption = function(target, optionName) {
	    if (!target || !optionName) { return; }
	    if (target.options && (target.options[optionName] !== undefined)) {
	      return target.options[optionName];
	    } else {
	      return target[optionName];
	    }
	  };
	  
	  // Proxy `Marionette.getOption`
	  Marionette.proxyGetOption = function(optionName) {
	    return Marionette.getOption(this, optionName);
	  };
	  
	  // Similar to `_.result`, this is a simple helper
	  // If a function is provided we call it with context
	  // otherwise just return the value. If the value is
	  // undefined return a default value
	  Marionette._getValue = function(value, context, params) {
	    if (_.isFunction(value)) {
	      value = params ? value.apply(context, params) : value.call(context);
	    }
	    return value;
	  };
	  
	  // Marionette.normalizeMethods
	  // ----------------------
	  
	  // Pass in a mapping of events => functions or function names
	  // and return a mapping of events => functions
	  Marionette.normalizeMethods = function(hash) {
	    return _.reduce(hash, function(normalizedHash, method, name) {
	      if (!_.isFunction(method)) {
	        method = this[method];
	      }
	      if (method) {
	        normalizedHash[name] = method;
	      }
	      return normalizedHash;
	    }, {}, this);
	  };
	  
	  // utility method for parsing @ui. syntax strings
	  // into associated selector
	  Marionette.normalizeUIString = function(uiString, ui) {
	    return uiString.replace(/@ui\.[a-zA-Z_$0-9]*/g, function(r) {
	      return ui[r.slice(4)];
	    });
	  };
	  
	  // allows for the use of the @ui. syntax within
	  // a given key for triggers and events
	  // swaps the @ui with the associated selector.
	  // Returns a new, non-mutated, parsed events hash.
	  Marionette.normalizeUIKeys = function(hash, ui) {
	    return _.reduce(hash, function(memo, val, key) {
	      var normalizedKey = Marionette.normalizeUIString(key, ui);
	      memo[normalizedKey] = val;
	      return memo;
	    }, {});
	  };
	  
	  // allows for the use of the @ui. syntax within
	  // a given value for regions
	  // swaps the @ui with the associated selector
	  Marionette.normalizeUIValues = function(hash, ui, properties) {
	    _.each(hash, function(val, key) {
	      if (_.isString(val)) {
	        hash[key] = Marionette.normalizeUIString(val, ui);
	      } else if (_.isObject(val) && _.isArray(properties)) {
	        _.extend(val, Marionette.normalizeUIValues(_.pick(val, properties), ui));
	        /* Value is an object, and we got an array of embedded property names to normalize. */
	        _.each(properties, function(property) {
	          var propertyVal = val[property];
	          if (_.isString(propertyVal)) {
	            val[property] = Marionette.normalizeUIString(propertyVal, ui);
	          }
	        });
	      }
	    });
	    return hash;
	  };
	  
	  // Mix in methods from Underscore, for iteration, and other
	  // collection related features.
	  // Borrowing this code from Backbone.Collection:
	  // http://backbonejs.org/docs/backbone.html#section-121
	  Marionette.actAsCollection = function(object, listProperty) {
	    var methods = ['forEach', 'each', 'map', 'find', 'detect', 'filter',
	      'select', 'reject', 'every', 'all', 'some', 'any', 'include',
	      'contains', 'invoke', 'toArray', 'first', 'initial', 'rest',
	      'last', 'without', 'isEmpty', 'pluck'];
	  
	    _.each(methods, function(method) {
	      object[method] = function() {
	        var list = _.values(_.result(this, listProperty));
	        var args = [list].concat(_.toArray(arguments));
	        return _[method].apply(_, args);
	      };
	    });
	  };
	  
	  var deprecate = Marionette.deprecate = function(message, test) {
	    if (_.isObject(message)) {
	      message = (
	        message.prev + ' is going to be removed in the future. ' +
	        'Please use ' + message.next + ' instead.' +
	        (message.url ? ' See: ' + message.url : '')
	      );
	    }
	  
	    if ((test === undefined || !test) && !deprecate._cache[message]) {
	      deprecate._warn('Deprecation warning: ' + message);
	      deprecate._cache[message] = true;
	    }
	  };
	  
	  deprecate._warn = typeof console !== 'undefined' && (console.warn || console.log) || function() {};
	  deprecate._cache = {};
	  
	  /* jshint maxstatements: 14, maxcomplexity: 7 */
	  
	  // Trigger Method
	  // --------------
	  
	  Marionette._triggerMethod = (function() {
	    // split the event name on the ":"
	    var splitter = /(^|:)(\w)/gi;
	  
	    // take the event section ("section1:section2:section3")
	    // and turn it in to uppercase name
	    function getEventName(match, prefix, eventName) {
	      return eventName.toUpperCase();
	    }
	  
	    return function(context, event, args) {
	      var noEventArg = arguments.length < 3;
	      if (noEventArg) {
	        args = event;
	        event = args[0];
	      }
	  
	      // get the method name from the event name
	      var methodName = 'on' + event.replace(splitter, getEventName);
	      var method = context[methodName];
	      var result;
	  
	      // call the onMethodName if it exists
	      if (_.isFunction(method)) {
	        // pass all args, except the event name
	        result = method.apply(context, noEventArg ? _.rest(args) : args);
	      }
	  
	      // trigger the event, if a trigger method exists
	      if (_.isFunction(context.trigger)) {
	        if (noEventArg + args.length > 1) {
	          context.trigger.apply(context, noEventArg ? args : [event].concat(_.drop(args, 0)));
	        } else {
	          context.trigger(event);
	        }
	      }
	  
	      return result;
	    };
	  })();
	  
	  // Trigger an event and/or a corresponding method name. Examples:
	  //
	  // `this.triggerMethod("foo")` will trigger the "foo" event and
	  // call the "onFoo" method.
	  //
	  // `this.triggerMethod("foo:bar")` will trigger the "foo:bar" event and
	  // call the "onFooBar" method.
	  Marionette.triggerMethod = function(event) {
	    return Marionette._triggerMethod(this, arguments);
	  };
	  
	  // triggerMethodOn invokes triggerMethod on a specific context
	  //
	  // e.g. `Marionette.triggerMethodOn(view, 'show')`
	  // will trigger a "show" event or invoke onShow the view.
	  Marionette.triggerMethodOn = function(context) {
	    var fnc = _.isFunction(context.triggerMethod) ?
	                  context.triggerMethod :
	                  Marionette.triggerMethod;
	  
	    return fnc.apply(context, _.rest(arguments));
	  };
	  
	  // DOM Refresh
	  // -----------
	  
	  // Monitor a view's state, and after it has been rendered and shown
	  // in the DOM, trigger a "dom:refresh" event every time it is
	  // re-rendered.
	  
	  Marionette.MonitorDOMRefresh = function(view) {
	  
	    // track when the view has been shown in the DOM,
	    // using a Marionette.Region (or by other means of triggering "show")
	    function handleShow() {
	      view._isShown = true;
	      triggerDOMRefresh();
	    }
	  
	    // track when the view has been rendered
	    function handleRender() {
	      view._isRendered = true;
	      triggerDOMRefresh();
	    }
	  
	    // Trigger the "dom:refresh" event and corresponding "onDomRefresh" method
	    function triggerDOMRefresh() {
	      if (view._isShown && view._isRendered && Marionette.isNodeAttached(view.el)) {
	        if (_.isFunction(view.triggerMethod)) {
	          view.triggerMethod('dom:refresh');
	        }
	      }
	    }
	  
	    view.on({
	      show: handleShow,
	      render: handleRender
	    });
	  };
	  
	  /* jshint maxparams: 5 */
	  
	  // Bind Entity Events & Unbind Entity Events
	  // -----------------------------------------
	  //
	  // These methods are used to bind/unbind a backbone "entity" (e.g. collection/model)
	  // to methods on a target object.
	  //
	  // The first parameter, `target`, must have the Backbone.Events module mixed in.
	  //
	  // The second parameter is the `entity` (Backbone.Model, Backbone.Collection or
	  // any object that has Backbone.Events mixed in) to bind the events from.
	  //
	  // The third parameter is a hash of { "event:name": "eventHandler" }
	  // configuration. Multiple handlers can be separated by a space. A
	  // function can be supplied instead of a string handler name.
	  
	  (function(Marionette) {
	    'use strict';
	  
	    // Bind the event to handlers specified as a string of
	    // handler names on the target object
	    function bindFromStrings(target, entity, evt, methods) {
	      var methodNames = methods.split(/\s+/);
	  
	      _.each(methodNames, function(methodName) {
	  
	        var method = target[methodName];
	        if (!method) {
	          throw new Marionette.Error('Method "' + methodName +
	            '" was configured as an event handler, but does not exist.');
	        }
	  
	        target.listenTo(entity, evt, method);
	      });
	    }
	  
	    // Bind the event to a supplied callback function
	    function bindToFunction(target, entity, evt, method) {
	      target.listenTo(entity, evt, method);
	    }
	  
	    // Bind the event to handlers specified as a string of
	    // handler names on the target object
	    function unbindFromStrings(target, entity, evt, methods) {
	      var methodNames = methods.split(/\s+/);
	  
	      _.each(methodNames, function(methodName) {
	        var method = target[methodName];
	        target.stopListening(entity, evt, method);
	      });
	    }
	  
	    // Bind the event to a supplied callback function
	    function unbindToFunction(target, entity, evt, method) {
	      target.stopListening(entity, evt, method);
	    }
	  
	    // generic looping function
	    function iterateEvents(target, entity, bindings, functionCallback, stringCallback) {
	      if (!entity || !bindings) { return; }
	  
	      // type-check bindings
	      if (!_.isObject(bindings)) {
	        throw new Marionette.Error({
	          message: 'Bindings must be an object or function.',
	          url: 'marionette.functions.html#marionettebindentityevents'
	        });
	      }
	  
	      // allow the bindings to be a function
	      bindings = Marionette._getValue(bindings, target);
	  
	      // iterate the bindings and bind them
	      _.each(bindings, function(methods, evt) {
	  
	        // allow for a function as the handler,
	        // or a list of event names as a string
	        if (_.isFunction(methods)) {
	          functionCallback(target, entity, evt, methods);
	        } else {
	          stringCallback(target, entity, evt, methods);
	        }
	  
	      });
	    }
	  
	    // Export Public API
	    Marionette.bindEntityEvents = function(target, entity, bindings) {
	      iterateEvents(target, entity, bindings, bindToFunction, bindFromStrings);
	    };
	  
	    Marionette.unbindEntityEvents = function(target, entity, bindings) {
	      iterateEvents(target, entity, bindings, unbindToFunction, unbindFromStrings);
	    };
	  
	    // Proxy `bindEntityEvents`
	    Marionette.proxyBindEntityEvents = function(entity, bindings) {
	      return Marionette.bindEntityEvents(this, entity, bindings);
	    };
	  
	    // Proxy `unbindEntityEvents`
	    Marionette.proxyUnbindEntityEvents = function(entity, bindings) {
	      return Marionette.unbindEntityEvents(this, entity, bindings);
	    };
	  })(Marionette);
	  
	
	  // Error
	  // -----
	  
	  var errorProps = ['description', 'fileName', 'lineNumber', 'name', 'message', 'number'];
	  
	  Marionette.Error = Marionette.extend.call(Error, {
	    urlRoot: 'http://marionettejs.com/docs/v' + Marionette.VERSION + '/',
	  
	    constructor: function(message, options) {
	      if (_.isObject(message)) {
	        options = message;
	        message = options.message;
	      } else if (!options) {
	        options = {};
	      }
	  
	      var error = Error.call(this, message);
	      _.extend(this, _.pick(error, errorProps), _.pick(options, errorProps));
	  
	      this.captureStackTrace();
	  
	      if (options.url) {
	        this.url = this.urlRoot + options.url;
	      }
	    },
	  
	    captureStackTrace: function() {
	      if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, Marionette.Error);
	      }
	    },
	  
	    toString: function() {
	      return this.name + ': ' + this.message + (this.url ? ' See: ' + this.url : '');
	    }
	  });
	  
	  Marionette.Error.extend = Marionette.extend;
	  
	  // Callbacks
	  // ---------
	  
	  // A simple way of managing a collection of callbacks
	  // and executing them at a later point in time, using jQuery's
	  // `Deferred` object.
	  Marionette.Callbacks = function() {
	    this._deferred = Marionette.Deferred();
	    this._callbacks = [];
	  };
	  
	  _.extend(Marionette.Callbacks.prototype, {
	  
	    // Add a callback to be executed. Callbacks added here are
	    // guaranteed to execute, even if they are added after the
	    // `run` method is called.
	    add: function(callback, contextOverride) {
	      var promise = _.result(this._deferred, 'promise');
	  
	      this._callbacks.push({cb: callback, ctx: contextOverride});
	  
	      promise.then(function(args) {
	        if (contextOverride) { args.context = contextOverride; }
	        callback.call(args.context, args.options);
	      });
	    },
	  
	    // Run all registered callbacks with the context specified.
	    // Additional callbacks can be added after this has been run
	    // and they will still be executed.
	    run: function(options, context) {
	      this._deferred.resolve({
	        options: options,
	        context: context
	      });
	    },
	  
	    // Resets the list of callbacks to be run, allowing the same list
	    // to be run multiple times - whenever the `run` method is called.
	    reset: function() {
	      var callbacks = this._callbacks;
	      this._deferred = Marionette.Deferred();
	      this._callbacks = [];
	  
	      _.each(callbacks, function(cb) {
	        this.add(cb.cb, cb.ctx);
	      }, this);
	    }
	  });
	  
	  // Controller
	  // ----------
	  
	  // A multi-purpose object to use as a controller for
	  // modules and routers, and as a mediator for workflow
	  // and coordination of other objects, views, and more.
	  Marionette.Controller = function(options) {
	    this.options = options || {};
	  
	    if (_.isFunction(this.initialize)) {
	      this.initialize(this.options);
	    }
	  };
	  
	  Marionette.Controller.extend = Marionette.extend;
	  
	  // Controller Methods
	  // --------------
	  
	  // Ensure it can trigger events with Backbone.Events
	  _.extend(Marionette.Controller.prototype, Backbone.Events, {
	    destroy: function() {
	      Marionette._triggerMethod(this, 'before:destroy', arguments);
	      Marionette._triggerMethod(this, 'destroy', arguments);
	  
	      this.stopListening();
	      this.off();
	      return this;
	    },
	  
	    // import the `triggerMethod` to trigger events with corresponding
	    // methods if the method exists
	    triggerMethod: Marionette.triggerMethod,
	  
	    // A handy way to merge options onto the instance
	    mergeOptions: Marionette.mergeOptions,
	  
	    // Proxy `getOption` to enable getting options from this or this.options by name.
	    getOption: Marionette.proxyGetOption
	  
	  });
	  
	  // Object
	  // ------
	  
	  // A Base Class that other Classes should descend from.
	  // Object borrows many conventions and utilities from Backbone.
	  Marionette.Object = function(options) {
	    this.options = _.extend({}, _.result(this, 'options'), options);
	  
	    this.initialize.apply(this, arguments);
	  };
	  
	  Marionette.Object.extend = Marionette.extend;
	  
	  // Object Methods
	  // --------------
	  
	  // Ensure it can trigger events with Backbone.Events
	  _.extend(Marionette.Object.prototype, Backbone.Events, {
	  
	    //this is a noop method intended to be overridden by classes that extend from this base
	    initialize: function() {},
	  
	    destroy: function() {
	      this.triggerMethod('before:destroy');
	      this.triggerMethod('destroy');
	      this.stopListening();
	  
	      return this;
	    },
	  
	    // Import the `triggerMethod` to trigger events with corresponding
	    // methods if the method exists
	    triggerMethod: Marionette.triggerMethod,
	  
	    // A handy way to merge options onto the instance
	    mergeOptions: Marionette.mergeOptions,
	  
	    // Proxy `getOption` to enable getting options from this or this.options by name.
	    getOption: Marionette.proxyGetOption,
	  
	    // Proxy `bindEntityEvents` to enable binding view's events from another entity.
	    bindEntityEvents: Marionette.proxyBindEntityEvents,
	  
	    // Proxy `unbindEntityEvents` to enable unbinding view's events from another entity.
	    unbindEntityEvents: Marionette.proxyUnbindEntityEvents
	  });
	  
	  /* jshint maxcomplexity: 16, maxstatements: 45, maxlen: 120 */
	  
	  // Region
	  // ------
	  
	  // Manage the visual regions of your composite application. See
	  // http://lostechies.com/derickbailey/2011/12/12/composite-js-apps-regions-and-region-managers/
	  
	  Marionette.Region = Marionette.Object.extend({
	    constructor: function(options) {
	  
	      // set options temporarily so that we can get `el`.
	      // options will be overriden by Object.constructor
	      this.options = options || {};
	      this.el = this.getOption('el');
	  
	      // Handle when this.el is passed in as a $ wrapped element.
	      this.el = this.el instanceof Backbone.$ ? this.el[0] : this.el;
	  
	      if (!this.el) {
	        throw new Marionette.Error({
	          name: 'NoElError',
	          message: 'An "el" must be specified for a region.'
	        });
	      }
	  
	      this.$el = this.getEl(this.el);
	      Marionette.Object.call(this, options);
	    },
	  
	    // Displays a backbone view instance inside of the region.
	    // Handles calling the `render` method for you. Reads content
	    // directly from the `el` attribute. Also calls an optional
	    // `onShow` and `onDestroy` method on your view, just after showing
	    // or just before destroying the view, respectively.
	    // The `preventDestroy` option can be used to prevent a view from
	    // the old view being destroyed on show.
	    // The `forceShow` option can be used to force a view to be
	    // re-rendered if it's already shown in the region.
	    show: function(view, options) {
	      if (!this._ensureElement()) {
	        return;
	      }
	  
	      this._ensureViewIsIntact(view);
	  
	      var showOptions     = options || {};
	      var isDifferentView = view !== this.currentView;
	      var preventDestroy  = !!showOptions.preventDestroy;
	      var forceShow       = !!showOptions.forceShow;
	  
	      // We are only changing the view if there is a current view to change to begin with
	      var isChangingView = !!this.currentView;
	  
	      // Only destroy the current view if we don't want to `preventDestroy` and if
	      // the view given in the first argument is different than `currentView`
	      var _shouldDestroyView = isDifferentView && !preventDestroy;
	  
	      // Only show the view given in the first argument if it is different than
	      // the current view or if we want to re-show the view. Note that if
	      // `_shouldDestroyView` is true, then `_shouldShowView` is also necessarily true.
	      var _shouldShowView = isDifferentView || forceShow;
	  
	      if (isChangingView) {
	        this.triggerMethod('before:swapOut', this.currentView, this, options);
	      }
	  
	      if (this.currentView) {
	        delete this.currentView._parent;
	      }
	  
	      if (_shouldDestroyView) {
	        this.empty();
	  
	      // A `destroy` event is attached to the clean up manually removed views.
	      // We need to detach this event when a new view is going to be shown as it
	      // is no longer relevant.
	      } else if (isChangingView && _shouldShowView) {
	        this.currentView.off('destroy', this.empty, this);
	      }
	  
	      if (_shouldShowView) {
	  
	        // We need to listen for if a view is destroyed
	        // in a way other than through the region.
	        // If this happens we need to remove the reference
	        // to the currentView since once a view has been destroyed
	        // we can not reuse it.
	        view.once('destroy', this.empty, this);
	        view.render();
	  
	        view._parent = this;
	  
	        if (isChangingView) {
	          this.triggerMethod('before:swap', view, this, options);
	        }
	  
	        this.triggerMethod('before:show', view, this, options);
	        Marionette.triggerMethodOn(view, 'before:show', view, this, options);
	  
	        if (isChangingView) {
	          this.triggerMethod('swapOut', this.currentView, this, options);
	        }
	  
	        // An array of views that we're about to display
	        var attachedRegion = Marionette.isNodeAttached(this.el);
	  
	        // The views that we're about to attach to the document
	        // It's important that we prevent _getNestedViews from being executed unnecessarily
	        // as it's a potentially-slow method
	        var displayedViews = [];
	  
	        var triggerBeforeAttach = showOptions.triggerBeforeAttach || this.triggerBeforeAttach;
	        var triggerAttach = showOptions.triggerAttach || this.triggerAttach;
	  
	        if (attachedRegion && triggerBeforeAttach) {
	          displayedViews = this._displayedViews(view);
	          this._triggerAttach(displayedViews, 'before:');
	        }
	  
	        this.attachHtml(view);
	        this.currentView = view;
	  
	        if (attachedRegion && triggerAttach) {
	          displayedViews = this._displayedViews(view);
	          this._triggerAttach(displayedViews);
	        }
	  
	        if (isChangingView) {
	          this.triggerMethod('swap', view, this, options);
	        }
	  
	        this.triggerMethod('show', view, this, options);
	        Marionette.triggerMethodOn(view, 'show', view, this, options);
	  
	        return this;
	      }
	  
	      return this;
	    },
	  
	    triggerBeforeAttach: true,
	    triggerAttach: true,
	  
	    _triggerAttach: function(views, prefix) {
	      var eventName = (prefix || '') + 'attach';
	      _.each(views, function(view) {
	        Marionette.triggerMethodOn(view, eventName, view, this);
	      }, this);
	    },
	  
	    _displayedViews: function(view) {
	      return _.union([view], _.result(view, '_getNestedViews') || []);
	    },
	  
	    _ensureElement: function() {
	      if (!_.isObject(this.el)) {
	        this.$el = this.getEl(this.el);
	        this.el = this.$el[0];
	      }
	  
	      if (!this.$el || this.$el.length === 0) {
	        if (this.getOption('allowMissingEl')) {
	          return false;
	        } else {
	          throw new Marionette.Error('An "el" ' + this.$el.selector + ' must exist in DOM');
	        }
	      }
	      return true;
	    },
	  
	    _ensureViewIsIntact: function(view) {
	      if (!view) {
	        throw new Marionette.Error({
	          name: 'ViewNotValid',
	          message: 'The view passed is undefined and therefore invalid. You must pass a view instance to show.'
	        });
	      }
	  
	      if (view.isDestroyed) {
	        throw new Marionette.Error({
	          name: 'ViewDestroyedError',
	          message: 'View (cid: "' + view.cid + '") has already been destroyed and cannot be used.'
	        });
	      }
	    },
	  
	    // Override this method to change how the region finds the DOM
	    // element that it manages. Return a jQuery selector object scoped
	    // to a provided parent el or the document if none exists.
	    getEl: function(el) {
	      return Backbone.$(el, Marionette._getValue(this.options.parentEl, this));
	    },
	  
	    // Override this method to change how the new view is
	    // appended to the `$el` that the region is managing
	    attachHtml: function(view) {
	      this.$el.contents().detach();
	  
	      this.el.appendChild(view.el);
	    },
	  
	    // Destroy the current view, if there is one. If there is no
	    // current view, it does nothing and returns immediately.
	    empty: function(options) {
	      var view = this.currentView;
	  
	      var preventDestroy = Marionette._getValue(options, 'preventDestroy', this);
	      // If there is no view in the region
	      // we should not remove anything
	      if (!view) { return; }
	  
	      view.off('destroy', this.empty, this);
	      this.triggerMethod('before:empty', view);
	      if (!preventDestroy) {
	        this._destroyView();
	      }
	      this.triggerMethod('empty', view);
	  
	      // Remove region pointer to the currentView
	      delete this.currentView;
	  
	      if (preventDestroy) {
	        this.$el.contents().detach();
	      }
	  
	      return this;
	    },
	  
	    // call 'destroy' or 'remove', depending on which is found
	    // on the view (if showing a raw Backbone view or a Marionette View)
	    _destroyView: function() {
	      var view = this.currentView;
	  
	      if (view.destroy && !view.isDestroyed) {
	        view.destroy();
	      } else if (view.remove) {
	        view.remove();
	  
	        // appending isDestroyed to raw Backbone View allows regions
	        // to throw a ViewDestroyedError for this view
	        view.isDestroyed = true;
	      }
	    },
	  
	    // Attach an existing view to the region. This
	    // will not call `render` or `onShow` for the new view,
	    // and will not replace the current HTML for the `el`
	    // of the region.
	    attachView: function(view) {
	      this.currentView = view;
	      return this;
	    },
	  
	    // Checks whether a view is currently present within
	    // the region. Returns `true` if there is and `false` if
	    // no view is present.
	    hasView: function() {
	      return !!this.currentView;
	    },
	  
	    // Reset the region by destroying any existing view and
	    // clearing out the cached `$el`. The next time a view
	    // is shown via this region, the region will re-query the
	    // DOM for the region's `el`.
	    reset: function() {
	      this.empty();
	  
	      if (this.$el) {
	        this.el = this.$el.selector;
	      }
	  
	      delete this.$el;
	      return this;
	    }
	  
	  },
	  
	  // Static Methods
	  {
	  
	    // Build an instance of a region by passing in a configuration object
	    // and a default region class to use if none is specified in the config.
	    //
	    // The config object should either be a string as a jQuery DOM selector,
	    // a Region class directly, or an object literal that specifies a selector,
	    // a custom regionClass, and any options to be supplied to the region:
	    //
	    // ```js
	    // {
	    //   selector: "#foo",
	    //   regionClass: MyCustomRegion,
	    //   allowMissingEl: false
	    // }
	    // ```
	    //
	    buildRegion: function(regionConfig, DefaultRegionClass) {
	      if (_.isString(regionConfig)) {
	        return this._buildRegionFromSelector(regionConfig, DefaultRegionClass);
	      }
	  
	      if (regionConfig.selector || regionConfig.el || regionConfig.regionClass) {
	        return this._buildRegionFromObject(regionConfig, DefaultRegionClass);
	      }
	  
	      if (_.isFunction(regionConfig)) {
	        return this._buildRegionFromRegionClass(regionConfig);
	      }
	  
	      throw new Marionette.Error({
	        message: 'Improper region configuration type.',
	        url: 'marionette.region.html#region-configuration-types'
	      });
	    },
	  
	    // Build the region from a string selector like '#foo-region'
	    _buildRegionFromSelector: function(selector, DefaultRegionClass) {
	      return new DefaultRegionClass({el: selector});
	    },
	  
	    // Build the region from a configuration object
	    // ```js
	    // { selector: '#foo', regionClass: FooRegion, allowMissingEl: false }
	    // ```
	    _buildRegionFromObject: function(regionConfig, DefaultRegionClass) {
	      var RegionClass = regionConfig.regionClass || DefaultRegionClass;
	      var options = _.omit(regionConfig, 'selector', 'regionClass');
	  
	      if (regionConfig.selector && !options.el) {
	        options.el = regionConfig.selector;
	      }
	  
	      return new RegionClass(options);
	    },
	  
	    // Build the region directly from a given `RegionClass`
	    _buildRegionFromRegionClass: function(RegionClass) {
	      return new RegionClass();
	    }
	  });
	  
	  // Region Manager
	  // --------------
	  
	  // Manage one or more related `Marionette.Region` objects.
	  Marionette.RegionManager = Marionette.Controller.extend({
	    constructor: function(options) {
	      this._regions = {};
	      this.length = 0;
	  
	      Marionette.Controller.call(this, options);
	  
	      this.addRegions(this.getOption('regions'));
	    },
	  
	    // Add multiple regions using an object literal or a
	    // function that returns an object literal, where
	    // each key becomes the region name, and each value is
	    // the region definition.
	    addRegions: function(regionDefinitions, defaults) {
	      regionDefinitions = Marionette._getValue(regionDefinitions, this, arguments);
	  
	      return _.reduce(regionDefinitions, function(regions, definition, name) {
	        if (_.isString(definition)) {
	          definition = {selector: definition};
	        }
	        if (definition.selector) {
	          definition = _.defaults({}, definition, defaults);
	        }
	  
	        regions[name] = this.addRegion(name, definition);
	        return regions;
	      }, {}, this);
	    },
	  
	    // Add an individual region to the region manager,
	    // and return the region instance
	    addRegion: function(name, definition) {
	      var region;
	  
	      if (definition instanceof Marionette.Region) {
	        region = definition;
	      } else {
	        region = Marionette.Region.buildRegion(definition, Marionette.Region);
	      }
	  
	      this.triggerMethod('before:add:region', name, region);
	  
	      region._parent = this;
	      this._store(name, region);
	  
	      this.triggerMethod('add:region', name, region);
	      return region;
	    },
	  
	    // Get a region by name
	    get: function(name) {
	      return this._regions[name];
	    },
	  
	    // Gets all the regions contained within
	    // the `regionManager` instance.
	    getRegions: function() {
	      return _.clone(this._regions);
	    },
	  
	    // Remove a region by name
	    removeRegion: function(name) {
	      var region = this._regions[name];
	      this._remove(name, region);
	  
	      return region;
	    },
	  
	    // Empty all regions in the region manager, and
	    // remove them
	    removeRegions: function() {
	      var regions = this.getRegions();
	      _.each(this._regions, function(region, name) {
	        this._remove(name, region);
	      }, this);
	  
	      return regions;
	    },
	  
	    // Empty all regions in the region manager, but
	    // leave them attached
	    emptyRegions: function() {
	      var regions = this.getRegions();
	      _.invoke(regions, 'empty');
	      return regions;
	    },
	  
	    // Destroy all regions and shut down the region
	    // manager entirely
	    destroy: function() {
	      this.removeRegions();
	      return Marionette.Controller.prototype.destroy.apply(this, arguments);
	    },
	  
	    // internal method to store regions
	    _store: function(name, region) {
	      if (!this._regions[name]) {
	        this.length++;
	      }
	  
	      this._regions[name] = region;
	    },
	  
	    // internal method to remove a region
	    _remove: function(name, region) {
	      this.triggerMethod('before:remove:region', name, region);
	      region.empty();
	      region.stopListening();
	  
	      delete region._parent;
	      delete this._regions[name];
	      this.length--;
	      this.triggerMethod('remove:region', name, region);
	    }
	  });
	  
	  Marionette.actAsCollection(Marionette.RegionManager.prototype, '_regions');
	  
	
	  // Template Cache
	  // --------------
	  
	  // Manage templates stored in `<script>` blocks,
	  // caching them for faster access.
	  Marionette.TemplateCache = function(templateId) {
	    this.templateId = templateId;
	  };
	  
	  // TemplateCache object-level methods. Manage the template
	  // caches from these method calls instead of creating
	  // your own TemplateCache instances
	  _.extend(Marionette.TemplateCache, {
	    templateCaches: {},
	  
	    // Get the specified template by id. Either
	    // retrieves the cached version, or loads it
	    // from the DOM.
	    get: function(templateId, options) {
	      var cachedTemplate = this.templateCaches[templateId];
	  
	      if (!cachedTemplate) {
	        cachedTemplate = new Marionette.TemplateCache(templateId);
	        this.templateCaches[templateId] = cachedTemplate;
	      }
	  
	      return cachedTemplate.load(options);
	    },
	  
	    // Clear templates from the cache. If no arguments
	    // are specified, clears all templates:
	    // `clear()`
	    //
	    // If arguments are specified, clears each of the
	    // specified templates from the cache:
	    // `clear("#t1", "#t2", "...")`
	    clear: function() {
	      var i;
	      var args = _.toArray(arguments);
	      var length = args.length;
	  
	      if (length > 0) {
	        for (i = 0; i < length; i++) {
	          delete this.templateCaches[args[i]];
	        }
	      } else {
	        this.templateCaches = {};
	      }
	    }
	  });
	  
	  // TemplateCache instance methods, allowing each
	  // template cache object to manage its own state
	  // and know whether or not it has been loaded
	  _.extend(Marionette.TemplateCache.prototype, {
	  
	    // Internal method to load the template
	    load: function(options) {
	      // Guard clause to prevent loading this template more than once
	      if (this.compiledTemplate) {
	        return this.compiledTemplate;
	      }
	  
	      // Load the template and compile it
	      var template = this.loadTemplate(this.templateId, options);
	      this.compiledTemplate = this.compileTemplate(template, options);
	  
	      return this.compiledTemplate;
	    },
	  
	    // Load a template from the DOM, by default. Override
	    // this method to provide your own template retrieval
	    // For asynchronous loading with AMD/RequireJS, consider
	    // using a template-loader plugin as described here:
	    // https://github.com/marionettejs/backbone.marionette/wiki/Using-marionette-with-requirejs
	    loadTemplate: function(templateId, options) {
	      var template = Backbone.$(templateId).html();
	  
	      if (!template || template.length === 0) {
	        throw new Marionette.Error({
	          name: 'NoTemplateError',
	          message: 'Could not find template: "' + templateId + '"'
	        });
	      }
	  
	      return template;
	    },
	  
	    // Pre-compile the template before caching it. Override
	    // this method if you do not need to pre-compile a template
	    // (JST / RequireJS for example) or if you want to change
	    // the template engine used (Handebars, etc).
	    compileTemplate: function(rawTemplate, options) {
	      return _.template(rawTemplate, options);
	    }
	  });
	  
	  // Renderer
	  // --------
	  
	  // Render a template with data by passing in the template
	  // selector and the data to render.
	  Marionette.Renderer = {
	  
	    // Render a template with data. The `template` parameter is
	    // passed to the `TemplateCache` object to retrieve the
	    // template function. Override this method to provide your own
	    // custom rendering and template handling for all of Marionette.
	    render: function(template, data) {
	      if (!template) {
	        throw new Marionette.Error({
	          name: 'TemplateNotFoundError',
	          message: 'Cannot render the template since its false, null or undefined.'
	        });
	      }
	  
	      var templateFunc = _.isFunction(template) ? template : Marionette.TemplateCache.get(template);
	  
	      return templateFunc(data);
	    }
	  };
	  
	
	  /* jshint maxlen: 114, nonew: false */
	  // View
	  // ----
	  
	  // The core view class that other Marionette views extend from.
	  Marionette.View = Backbone.View.extend({
	    isDestroyed: false,
	  
	    constructor: function(options) {
	      _.bindAll(this, 'render');
	  
	      options = Marionette._getValue(options, this);
	  
	      // this exposes view options to the view initializer
	      // this is a backfill since backbone removed the assignment
	      // of this.options
	      // at some point however this may be removed
	      this.options = _.extend({}, _.result(this, 'options'), options);
	  
	      this._behaviors = Marionette.Behaviors(this);
	  
	      Backbone.View.call(this, this.options);
	  
	      Marionette.MonitorDOMRefresh(this);
	    },
	  
	    // Get the template for this view
	    // instance. You can set a `template` attribute in the view
	    // definition or pass a `template: "whatever"` parameter in
	    // to the constructor options.
	    getTemplate: function() {
	      return this.getOption('template');
	    },
	  
	    // Serialize a model by returning its attributes. Clones
	    // the attributes to allow modification.
	    serializeModel: function(model) {
	      return model.toJSON.apply(model, _.rest(arguments));
	    },
	  
	    // Mix in template helper methods. Looks for a
	    // `templateHelpers` attribute, which can either be an
	    // object literal, or a function that returns an object
	    // literal. All methods and attributes from this object
	    // are copies to the object passed in.
	    mixinTemplateHelpers: function(target) {
	      target = target || {};
	      var templateHelpers = this.getOption('templateHelpers');
	      templateHelpers = Marionette._getValue(templateHelpers, this);
	      return _.extend(target, templateHelpers);
	    },
	  
	    // normalize the keys of passed hash with the views `ui` selectors.
	    // `{"@ui.foo": "bar"}`
	    normalizeUIKeys: function(hash) {
	      var uiBindings = _.result(this, '_uiBindings');
	      return Marionette.normalizeUIKeys(hash, uiBindings || _.result(this, 'ui'));
	    },
	  
	    // normalize the values of passed hash with the views `ui` selectors.
	    // `{foo: "@ui.bar"}`
	    normalizeUIValues: function(hash, properties) {
	      var ui = _.result(this, 'ui');
	      var uiBindings = _.result(this, '_uiBindings');
	      return Marionette.normalizeUIValues(hash, uiBindings || ui, properties);
	    },
	  
	    // Configure `triggers` to forward DOM events to view
	    // events. `triggers: {"click .foo": "do:foo"}`
	    configureTriggers: function() {
	      if (!this.triggers) { return; }
	  
	      // Allow `triggers` to be configured as a function
	      var triggers = this.normalizeUIKeys(_.result(this, 'triggers'));
	  
	      // Configure the triggers, prevent default
	      // action and stop propagation of DOM events
	      return _.reduce(triggers, function(events, value, key) {
	        events[key] = this._buildViewTrigger(value);
	        return events;
	      }, {}, this);
	    },
	  
	    // Overriding Backbone.View's delegateEvents to handle
	    // the `triggers`, `modelEvents`, and `collectionEvents` configuration
	    delegateEvents: function(events) {
	      this._delegateDOMEvents(events);
	      this.bindEntityEvents(this.model, this.getOption('modelEvents'));
	      this.bindEntityEvents(this.collection, this.getOption('collectionEvents'));
	  
	      _.each(this._behaviors, function(behavior) {
	        behavior.bindEntityEvents(this.model, behavior.getOption('modelEvents'));
	        behavior.bindEntityEvents(this.collection, behavior.getOption('collectionEvents'));
	      }, this);
	  
	      return this;
	    },
	  
	    // internal method to delegate DOM events and triggers
	    _delegateDOMEvents: function(eventsArg) {
	      var events = Marionette._getValue(eventsArg || this.events, this);
	  
	      // normalize ui keys
	      events = this.normalizeUIKeys(events);
	      if (_.isUndefined(eventsArg)) {this.events = events;}
	  
	      var combinedEvents = {};
	  
	      // look up if this view has behavior events
	      var behaviorEvents = _.result(this, 'behaviorEvents') || {};
	      var triggers = this.configureTriggers();
	      var behaviorTriggers = _.result(this, 'behaviorTriggers') || {};
	  
	      // behavior events will be overriden by view events and or triggers
	      _.extend(combinedEvents, behaviorEvents, events, triggers, behaviorTriggers);
	  
	      Backbone.View.prototype.delegateEvents.call(this, combinedEvents);
	    },
	  
	    // Overriding Backbone.View's undelegateEvents to handle unbinding
	    // the `triggers`, `modelEvents`, and `collectionEvents` config
	    undelegateEvents: function() {
	      Backbone.View.prototype.undelegateEvents.apply(this, arguments);
	  
	      this.unbindEntityEvents(this.model, this.getOption('modelEvents'));
	      this.unbindEntityEvents(this.collection, this.getOption('collectionEvents'));
	  
	      _.each(this._behaviors, function(behavior) {
	        behavior.unbindEntityEvents(this.model, behavior.getOption('modelEvents'));
	        behavior.unbindEntityEvents(this.collection, behavior.getOption('collectionEvents'));
	      }, this);
	  
	      return this;
	    },
	  
	    // Internal helper method to verify whether the view hasn't been destroyed
	    _ensureViewIsIntact: function() {
	      if (this.isDestroyed) {
	        throw new Marionette.Error({
	          name: 'ViewDestroyedError',
	          message: 'View (cid: "' + this.cid + '") has already been destroyed and cannot be used.'
	        });
	      }
	    },
	  
	    // Default `destroy` implementation, for removing a view from the
	    // DOM and unbinding it. Regions will call this method
	    // for you. You can specify an `onDestroy` method in your view to
	    // add custom code that is called after the view is destroyed.
	    destroy: function() {
	      if (this.isDestroyed) { return this; }
	  
	      var args = _.toArray(arguments);
	  
	      this.triggerMethod.apply(this, ['before:destroy'].concat(args));
	  
	      // mark as destroyed before doing the actual destroy, to
	      // prevent infinite loops within "destroy" event handlers
	      // that are trying to destroy other views
	      this.isDestroyed = true;
	      this.triggerMethod.apply(this, ['destroy'].concat(args));
	  
	      // unbind UI elements
	      this.unbindUIElements();
	  
	      this.isRendered = false;
	  
	      // remove the view from the DOM
	      this.remove();
	  
	      // Call destroy on each behavior after
	      // destroying the view.
	      // This unbinds event listeners
	      // that behaviors have registered for.
	      _.invoke(this._behaviors, 'destroy', args);
	  
	      return this;
	    },
	  
	    bindUIElements: function() {
	      this._bindUIElements();
	      _.invoke(this._behaviors, this._bindUIElements);
	    },
	  
	    // This method binds the elements specified in the "ui" hash inside the view's code with
	    // the associated jQuery selectors.
	    _bindUIElements: function() {
	      if (!this.ui) { return; }
	  
	      // store the ui hash in _uiBindings so they can be reset later
	      // and so re-rendering the view will be able to find the bindings
	      if (!this._uiBindings) {
	        this._uiBindings = this.ui;
	      }
	  
	      // get the bindings result, as a function or otherwise
	      var bindings = _.result(this, '_uiBindings');
	  
	      // empty the ui so we don't have anything to start with
	      this.ui = {};
	  
	      // bind each of the selectors
	      _.each(bindings, function(selector, key) {
	        this.ui[key] = this.$(selector);
	      }, this);
	    },
	  
	    // This method unbinds the elements specified in the "ui" hash
	    unbindUIElements: function() {
	      this._unbindUIElements();
	      _.invoke(this._behaviors, this._unbindUIElements);
	    },
	  
	    _unbindUIElements: function() {
	      if (!this.ui || !this._uiBindings) { return; }
	  
	      // delete all of the existing ui bindings
	      _.each(this.ui, function($el, name) {
	        delete this.ui[name];
	      }, this);
	  
	      // reset the ui element to the original bindings configuration
	      this.ui = this._uiBindings;
	      delete this._uiBindings;
	    },
	  
	    // Internal method to create an event handler for a given `triggerDef` like
	    // 'click:foo'
	    _buildViewTrigger: function(triggerDef) {
	      var hasOptions = _.isObject(triggerDef);
	  
	      var options = _.defaults({}, (hasOptions ? triggerDef : {}), {
	        preventDefault: true,
	        stopPropagation: true
	      });
	  
	      var eventName = hasOptions ? options.event : triggerDef;
	  
	      return function(e) {
	        if (e) {
	          if (e.preventDefault && options.preventDefault) {
	            e.preventDefault();
	          }
	  
	          if (e.stopPropagation && options.stopPropagation) {
	            e.stopPropagation();
	          }
	        }
	  
	        var args = {
	          view: this,
	          model: this.model,
	          collection: this.collection
	        };
	  
	        this.triggerMethod(eventName, args);
	      };
	    },
	  
	    setElement: function() {
	      var ret = Backbone.View.prototype.setElement.apply(this, arguments);
	  
	      // proxy behavior $el to the view's $el.
	      // This is needed because a view's $el proxy
	      // is not set until after setElement is called.
	      _.invoke(this._behaviors, 'proxyViewProperties', this);
	  
	      return ret;
	    },
	  
	    // import the `triggerMethod` to trigger events with corresponding
	    // methods if the method exists
	    triggerMethod: function() {
	      var ret = Marionette._triggerMethod(this, arguments);
	  
	      this._triggerEventOnBehaviors(arguments);
	      this._triggerEventOnParentLayout(arguments[0], _.rest(arguments));
	  
	      return ret;
	    },
	  
	    _triggerEventOnBehaviors: function(args) {
	      var triggerMethod = Marionette._triggerMethod;
	      var behaviors = this._behaviors;
	      // Use good ol' for as this is a very hot function
	      for (var i = 0, length = behaviors && behaviors.length; i < length; i++) {
	        triggerMethod(behaviors[i], args);
	      }
	    },
	  
	    _triggerEventOnParentLayout: function(eventName, args) {
	      var layoutView = this._parentLayoutView();
	      if (!layoutView) {
	        return;
	      }
	  
	      // invoke triggerMethod on parent view
	      var eventPrefix = Marionette.getOption(layoutView, 'childViewEventPrefix');
	      var prefixedEventName = eventPrefix + ':' + eventName;
	  
	      Marionette._triggerMethod(layoutView, [prefixedEventName, this].concat(args));
	  
	      // call the parent view's childEvents handler
	      var childEvents = Marionette.getOption(layoutView, 'childEvents');
	      var normalizedChildEvents = layoutView.normalizeMethods(childEvents);
	  
	      if (!!normalizedChildEvents && _.isFunction(normalizedChildEvents[eventName])) {
	        normalizedChildEvents[eventName].apply(layoutView, [this].concat(args));
	      }
	    },
	  
	    // This method returns any views that are immediate
	    // children of this view
	    _getImmediateChildren: function() {
	      return [];
	    },
	  
	    // Returns an array of every nested view within this view
	    _getNestedViews: function() {
	      var children = this._getImmediateChildren();
	  
	      if (!children.length) { return children; }
	  
	      return _.reduce(children, function(memo, view) {
	        if (!view._getNestedViews) { return memo; }
	        return memo.concat(view._getNestedViews());
	      }, children);
	    },
	  
	    // Internal utility for building an ancestor
	    // view tree list.
	    _getAncestors: function() {
	      var ancestors = [];
	      var parent  = this._parent;
	  
	      while (parent) {
	        ancestors.push(parent);
	        parent = parent._parent;
	      }
	  
	      return ancestors;
	    },
	  
	    // Returns the containing parent view.
	    _parentLayoutView: function() {
	      var ancestors = this._getAncestors();
	      return _.find(ancestors, function(parent) {
	        return parent instanceof Marionette.LayoutView;
	      });
	    },
	  
	    // Imports the "normalizeMethods" to transform hashes of
	    // events=>function references/names to a hash of events=>function references
	    normalizeMethods: Marionette.normalizeMethods,
	  
	    // A handy way to merge passed-in options onto the instance
	    mergeOptions: Marionette.mergeOptions,
	  
	    // Proxy `getOption` to enable getting options from this or this.options by name.
	    getOption: Marionette.proxyGetOption,
	  
	    // Proxy `bindEntityEvents` to enable binding view's events from another entity.
	    bindEntityEvents: Marionette.proxyBindEntityEvents,
	  
	    // Proxy `unbindEntityEvents` to enable unbinding view's events from another entity.
	    unbindEntityEvents: Marionette.proxyUnbindEntityEvents
	  });
	  
	  // Item View
	  // ---------
	  
	  // A single item view implementation that contains code for rendering
	  // with underscore.js templates, serializing the view's model or collection,
	  // and calling several methods on extended views, such as `onRender`.
	  Marionette.ItemView = Marionette.View.extend({
	  
	    // Setting up the inheritance chain which allows changes to
	    // Marionette.View.prototype.constructor which allows overriding
	    constructor: function() {
	      Marionette.View.apply(this, arguments);
	    },
	  
	    // Serialize the model or collection for the view. If a model is
	    // found, the view's `serializeModel` is called. If a collection is found,
	    // each model in the collection is serialized by calling
	    // the view's `serializeCollection` and put into an `items` array in
	    // the resulting data. If both are found, defaults to the model.
	    // You can override the `serializeData` method in your own view definition,
	    // to provide custom serialization for your view's data.
	    serializeData: function() {
	      if (!this.model && !this.collection) {
	        return {};
	      }
	  
	      var args = [this.model || this.collection];
	      if (arguments.length) {
	        args.push.apply(args, arguments);
	      }
	  
	      if (this.model) {
	        return this.serializeModel.apply(this, args);
	      } else {
	        return {
	          items: this.serializeCollection.apply(this, args)
	        };
	      }
	    },
	  
	    // Serialize a collection by serializing each of its models.
	    serializeCollection: function(collection) {
	      return collection.toJSON.apply(collection, _.rest(arguments));
	    },
	  
	    // Render the view, defaulting to underscore.js templates.
	    // You can override this in your view definition to provide
	    // a very specific rendering for your view. In general, though,
	    // you should override the `Marionette.Renderer` object to
	    // change how Marionette renders views.
	    render: function() {
	      this._ensureViewIsIntact();
	  
	      this.triggerMethod('before:render', this);
	  
	      this._renderTemplate();
	      this.isRendered = true;
	      this.bindUIElements();
	  
	      this.triggerMethod('render', this);
	  
	      return this;
	    },
	  
	    // Internal method to render the template with the serialized data
	    // and template helpers via the `Marionette.Renderer` object.
	    // Throws an `UndefinedTemplateError` error if the template is
	    // any falsely value but literal `false`.
	    _renderTemplate: function() {
	      var template = this.getTemplate();
	  
	      // Allow template-less item views
	      if (template === false) {
	        return;
	      }
	  
	      if (!template) {
	        throw new Marionette.Error({
	          name: 'UndefinedTemplateError',
	          message: 'Cannot render the template since it is null or undefined.'
	        });
	      }
	  
	      // Add in entity data and template helpers
	      var data = this.mixinTemplateHelpers(this.serializeData());
	  
	      // Render and add to el
	      var html = Marionette.Renderer.render(template, data, this);
	      this.attachElContent(html);
	  
	      return this;
	    },
	  
	    // Attaches the content of a given view.
	    // This method can be overridden to optimize rendering,
	    // or to render in a non standard way.
	    //
	    // For example, using `innerHTML` instead of `$el.html`
	    //
	    // ```js
	    // attachElContent: function(html) {
	    //   this.el.innerHTML = html;
	    //   return this;
	    // }
	    // ```
	    attachElContent: function(html) {
	      this.$el.html(html);
	  
	      return this;
	    }
	  });
	  
	  /* jshint maxstatements: 14 */
	  
	  // Collection View
	  // ---------------
	  
	  // A view that iterates over a Backbone.Collection
	  // and renders an individual child view for each model.
	  Marionette.CollectionView = Marionette.View.extend({
	  
	    // used as the prefix for child view events
	    // that are forwarded through the collectionview
	    childViewEventPrefix: 'childview',
	  
	    // flag for maintaining the sorted order of the collection
	    sort: true,
	  
	    // constructor
	    // option to pass `{sort: false}` to prevent the `CollectionView` from
	    // maintaining the sorted order of the collection.
	    // This will fallback onto appending childView's to the end.
	    //
	    // option to pass `{comparator: compFunction()}` to allow the `CollectionView`
	    // to use a custom sort order for the collection.
	    constructor: function(options) {
	  
	      this.once('render', this._initialEvents);
	      this._initChildViewStorage();
	  
	      Marionette.View.apply(this, arguments);
	  
	      this.on('show', this._onShowCalled);
	  
	      this.initRenderBuffer();
	    },
	  
	    // Instead of inserting elements one by one into the page,
	    // it's much more performant to insert elements into a document
	    // fragment and then insert that document fragment into the page
	    initRenderBuffer: function() {
	      this._bufferedChildren = [];
	    },
	  
	    startBuffering: function() {
	      this.initRenderBuffer();
	      this.isBuffering = true;
	    },
	  
	    endBuffering: function() {
	      this.isBuffering = false;
	      this._triggerBeforeShowBufferedChildren();
	  
	      this.attachBuffer(this);
	  
	      this._triggerShowBufferedChildren();
	      this.initRenderBuffer();
	    },
	  
	    _triggerBeforeShowBufferedChildren: function() {
	      if (this._isShown) {
	        _.each(this._bufferedChildren, _.partial(this._triggerMethodOnChild, 'before:show'));
	      }
	    },
	  
	    _triggerShowBufferedChildren: function() {
	      if (this._isShown) {
	        _.each(this._bufferedChildren, _.partial(this._triggerMethodOnChild, 'show'));
	  
	        this._bufferedChildren = [];
	      }
	    },
	  
	    // Internal method for _.each loops to call `Marionette.triggerMethodOn` on
	    // a child view
	    _triggerMethodOnChild: function(event, childView) {
	      Marionette.triggerMethodOn(childView, event);
	    },
	  
	    // Configured the initial events that the collection view
	    // binds to.
	    _initialEvents: function() {
	      if (this.collection) {
	        this.listenTo(this.collection, 'add', this._onCollectionAdd);
	        this.listenTo(this.collection, 'remove', this._onCollectionRemove);
	        this.listenTo(this.collection, 'reset', this.render);
	  
	        if (this.getOption('sort')) {
	          this.listenTo(this.collection, 'sort', this._sortViews);
	        }
	      }
	    },
	  
	    // Handle a child added to the collection
	    _onCollectionAdd: function(child, collection, opts) {
	      var index;
	      if (opts.at !== undefined) {
	        index = opts.at;
	      } else {
	        index = _.indexOf(this._filteredSortedModels(), child);
	      }
	  
	      if (this._shouldAddChild(child, index)) {
	        this.destroyEmptyView();
	        var ChildView = this.getChildView(child);
	        this.addChild(child, ChildView, index);
	      }
	    },
	  
	    // get the child view by model it holds, and remove it
	    _onCollectionRemove: function(model) {
	      var view = this.children.findByModel(model);
	      this.removeChildView(view);
	      this.checkEmpty();
	    },
	  
	    _onShowCalled: function() {
	      this.children.each(_.partial(this._triggerMethodOnChild, 'show'));
	    },
	  
	    // Render children views. Override this method to
	    // provide your own implementation of a render function for
	    // the collection view.
	    render: function() {
	      this._ensureViewIsIntact();
	      this.triggerMethod('before:render', this);
	      this._renderChildren();
	      this.isRendered = true;
	      this.triggerMethod('render', this);
	      return this;
	    },
	  
	    // Reorder DOM after sorting. When your element's rendering
	    // do not use their index, you can pass reorderOnSort: true
	    // to only reorder the DOM after a sort instead of rendering
	    // all the collectionView
	    reorder: function() {
	      var children = this.children;
	      var models = this._filteredSortedModels();
	      var modelsChanged = _.find(models, function(model) {
	        return !children.findByModel(model);
	      });
	  
	      // If the models we're displaying have changed due to filtering
	      // We need to add and/or remove child views
	      // So render as normal
	      if (modelsChanged) {
	        this.render();
	      } else {
	        // get the DOM nodes in the same order as the models
	        var els = _.map(models, function(model) {
	          return children.findByModel(model).el;
	        });
	  
	        // since append moves elements that are already in the DOM,
	        // appending the elements will effectively reorder them
	        this.triggerMethod('before:reorder');
	        this._appendReorderedChildren(els);
	        this.triggerMethod('reorder');
	      }
	    },
	  
	    // Render view after sorting. Override this method to
	    // change how the view renders after a `sort` on the collection.
	    // An example of this would be to only `renderChildren` in a `CompositeView`
	    // rather than the full view.
	    resortView: function() {
	      if (Marionette.getOption(this, 'reorderOnSort')) {
	        this.reorder();
	      } else {
	        this.render();
	      }
	    },
	  
	    // Internal method. This checks for any changes in the order of the collection.
	    // If the index of any view doesn't match, it will render.
	    _sortViews: function() {
	      var models = this._filteredSortedModels();
	  
	      // check for any changes in sort order of views
	      var orderChanged = _.find(models, function(item, index) {
	        var view = this.children.findByModel(item);
	        return !view || view._index !== index;
	      }, this);
	  
	      if (orderChanged) {
	        this.resortView();
	      }
	    },
	  
	    // Internal reference to what index a `emptyView` is.
	    _emptyViewIndex: -1,
	  
	    // Internal method. Separated so that CompositeView can append to the childViewContainer
	    // if necessary
	    _appendReorderedChildren: function(children) {
	      this.$el.append(children);
	    },
	  
	    // Internal method. Separated so that CompositeView can have
	    // more control over events being triggered, around the rendering
	    // process
	    _renderChildren: function() {
	      this.destroyEmptyView();
	      this.destroyChildren();
	  
	      if (this.isEmpty(this.collection)) {
	        this.showEmptyView();
	      } else {
	        this.triggerMethod('before:render:collection', this);
	        this.startBuffering();
	        this.showCollection();
	        this.endBuffering();
	        this.triggerMethod('render:collection', this);
	  
	        // If we have shown children and none have passed the filter, show the empty view
	        if (this.children.isEmpty()) {
	          this.showEmptyView();
	        }
	      }
	    },
	  
	    // Internal method to loop through collection and show each child view.
	    showCollection: function() {
	      var ChildView;
	  
	      var models = this._filteredSortedModels();
	  
	      _.each(models, function(child, index) {
	        ChildView = this.getChildView(child);
	        this.addChild(child, ChildView, index);
	      }, this);
	    },
	  
	    // Allow the collection to be sorted by a custom view comparator
	    _filteredSortedModels: function() {
	      var models;
	      var viewComparator = this.getViewComparator();
	  
	      if (viewComparator) {
	        if (_.isString(viewComparator) || viewComparator.length === 1) {
	          models = this.collection.sortBy(viewComparator, this);
	        } else {
	          models = _.clone(this.collection.models).sort(_.bind(viewComparator, this));
	        }
	      } else {
	        models = this.collection.models;
	      }
	  
	      // Filter after sorting in case the filter uses the index
	      if (this.getOption('filter')) {
	        models = _.filter(models, function(model, index) {
	          return this._shouldAddChild(model, index);
	        }, this);
	      }
	  
	      return models;
	    },
	  
	    // Internal method to show an empty view in place of
	    // a collection of child views, when the collection is empty
	    showEmptyView: function() {
	      var EmptyView = this.getEmptyView();
	  
	      if (EmptyView && !this._showingEmptyView) {
	        this.triggerMethod('before:render:empty');
	  
	        this._showingEmptyView = true;
	        var model = new Backbone.Model();
	        this.addEmptyView(model, EmptyView);
	  
	        this.triggerMethod('render:empty');
	      }
	    },
	  
	    // Internal method to destroy an existing emptyView instance
	    // if one exists. Called when a collection view has been
	    // rendered empty, and then a child is added to the collection.
	    destroyEmptyView: function() {
	      if (this._showingEmptyView) {
	        this.triggerMethod('before:remove:empty');
	  
	        this.destroyChildren();
	        delete this._showingEmptyView;
	  
	        this.triggerMethod('remove:empty');
	      }
	    },
	  
	    // Retrieve the empty view class
	    getEmptyView: function() {
	      return this.getOption('emptyView');
	    },
	  
	    // Render and show the emptyView. Similar to addChild method
	    // but "add:child" events are not fired, and the event from
	    // emptyView are not forwarded
	    addEmptyView: function(child, EmptyView) {
	  
	      // get the emptyViewOptions, falling back to childViewOptions
	      var emptyViewOptions = this.getOption('emptyViewOptions') ||
	                            this.getOption('childViewOptions');
	  
	      if (_.isFunction(emptyViewOptions)) {
	        emptyViewOptions = emptyViewOptions.call(this, child, this._emptyViewIndex);
	      }
	  
	      // build the empty view
	      var view = this.buildChildView(child, EmptyView, emptyViewOptions);
	  
	      view._parent = this;
	  
	      // Proxy emptyView events
	      this.proxyChildEvents(view);
	  
	      // trigger the 'before:show' event on `view` if the collection view
	      // has already been shown
	      if (this._isShown) {
	        Marionette.triggerMethodOn(view, 'before:show');
	      }
	  
	      // Store the `emptyView` like a `childView` so we can properly
	      // remove and/or close it later
	      this.children.add(view);
	  
	      // Render it and show it
	      this.renderChildView(view, this._emptyViewIndex);
	  
	      // call the 'show' method if the collection view
	      // has already been shown
	      if (this._isShown) {
	        Marionette.triggerMethodOn(view, 'show');
	      }
	    },
	  
	    // Retrieve the `childView` class, either from `this.options.childView`
	    // or from the `childView` in the object definition. The "options"
	    // takes precedence.
	    // This method receives the model that will be passed to the instance
	    // created from this `childView`. Overriding methods may use the child
	    // to determine what `childView` class to return.
	    getChildView: function(child) {
	      var childView = this.getOption('childView');
	  
	      if (!childView) {
	        throw new Marionette.Error({
	          name: 'NoChildViewError',
	          message: 'A "childView" must be specified'
	        });
	      }
	  
	      return childView;
	    },
	  
	    // Render the child's view and add it to the
	    // HTML for the collection view at a given index.
	    // This will also update the indices of later views in the collection
	    // in order to keep the children in sync with the collection.
	    addChild: function(child, ChildView, index) {
	      var childViewOptions = this.getOption('childViewOptions');
	      childViewOptions = Marionette._getValue(childViewOptions, this, [child, index]);
	  
	      var view = this.buildChildView(child, ChildView, childViewOptions);
	  
	      // increment indices of views after this one
	      this._updateIndices(view, true, index);
	  
	      this._addChildView(view, index);
	  
	      view._parent = this;
	  
	      return view;
	    },
	  
	    // Internal method. This decrements or increments the indices of views after the
	    // added/removed view to keep in sync with the collection.
	    _updateIndices: function(view, increment, index) {
	      if (!this.getOption('sort')) {
	        return;
	      }
	  
	      if (increment) {
	        // assign the index to the view
	        view._index = index;
	      }
	  
	      // update the indexes of views after this one
	      this.children.each(function(laterView) {
	        if (laterView._index >= view._index) {
	          laterView._index += increment ? 1 : -1;
	        }
	      });
	    },
	  
	    // Internal Method. Add the view to children and render it at
	    // the given index.
	    _addChildView: function(view, index) {
	      // set up the child view event forwarding
	      this.proxyChildEvents(view);
	  
	      this.triggerMethod('before:add:child', view);
	  
	      // trigger the 'before:show' event on `view` if the collection view
	      // has already been shown
	      if (this._isShown && !this.isBuffering) {
	        Marionette.triggerMethodOn(view, 'before:show');
	      }
	  
	      // Store the child view itself so we can properly
	      // remove and/or destroy it later
	      this.children.add(view);
	      this.renderChildView(view, index);
	  
	      if (this._isShown && !this.isBuffering) {
	        Marionette.triggerMethodOn(view, 'show');
	      }
	  
	      this.triggerMethod('add:child', view);
	    },
	  
	    // render the child view
	    renderChildView: function(view, index) {
	      view.render();
	      this.attachHtml(this, view, index);
	      return view;
	    },
	  
	    // Build a `childView` for a model in the collection.
	    buildChildView: function(child, ChildViewClass, childViewOptions) {
	      var options = _.extend({model: child}, childViewOptions);
	      return new ChildViewClass(options);
	    },
	  
	    // Remove the child view and destroy it.
	    // This function also updates the indices of
	    // later views in the collection in order to keep
	    // the children in sync with the collection.
	    removeChildView: function(view) {
	  
	      if (view) {
	        this.triggerMethod('before:remove:child', view);
	  
	        // call 'destroy' or 'remove', depending on which is found
	        if (view.destroy) {
	          view.destroy();
	        } else if (view.remove) {
	          view.remove();
	        }
	  
	        delete view._parent;
	        this.stopListening(view);
	        this.children.remove(view);
	        this.triggerMethod('remove:child', view);
	  
	        // decrement the index of views after this one
	        this._updateIndices(view, false);
	      }
	  
	      return view;
	    },
	  
	    // check if the collection is empty
	    isEmpty: function() {
	      return !this.collection || this.collection.length === 0;
	    },
	  
	    // If empty, show the empty view
	    checkEmpty: function() {
	      if (this.isEmpty(this.collection)) {
	        this.showEmptyView();
	      }
	    },
	  
	    // You might need to override this if you've overridden attachHtml
	    attachBuffer: function(collectionView) {
	      collectionView.$el.append(this._createBuffer(collectionView));
	    },
	  
	    // Create a fragment buffer from the currently buffered children
	    _createBuffer: function(collectionView) {
	      var elBuffer = document.createDocumentFragment();
	      _.each(collectionView._bufferedChildren, function(b) {
	        elBuffer.appendChild(b.el);
	      });
	      return elBuffer;
	    },
	  
	    // Append the HTML to the collection's `el`.
	    // Override this method to do something other
	    // than `.append`.
	    attachHtml: function(collectionView, childView, index) {
	      if (collectionView.isBuffering) {
	        // buffering happens on reset events and initial renders
	        // in order to reduce the number of inserts into the
	        // document, which are expensive.
	        collectionView._bufferedChildren.splice(index, 0, childView);
	      } else {
	        // If we've already rendered the main collection, append
	        // the new child into the correct order if we need to. Otherwise
	        // append to the end.
	        if (!collectionView._insertBefore(childView, index)) {
	          collectionView._insertAfter(childView);
	        }
	      }
	    },
	  
	    // Internal method. Check whether we need to insert the view into
	    // the correct position.
	    _insertBefore: function(childView, index) {
	      var currentView;
	      var findPosition = this.getOption('sort') && (index < this.children.length - 1);
	      if (findPosition) {
	        // Find the view after this one
	        currentView = this.children.find(function(view) {
	          return view._index === index + 1;
	        });
	      }
	  
	      if (currentView) {
	        currentView.$el.before(childView.el);
	        return true;
	      }
	  
	      return false;
	    },
	  
	    // Internal method. Append a view to the end of the $el
	    _insertAfter: function(childView) {
	      this.$el.append(childView.el);
	    },
	  
	    // Internal method to set up the `children` object for
	    // storing all of the child views
	    _initChildViewStorage: function() {
	      this.children = new Backbone.ChildViewContainer();
	    },
	  
	    // Handle cleanup and other destroying needs for the collection of views
	    destroy: function() {
	      if (this.isDestroyed) { return this; }
	  
	      this.triggerMethod('before:destroy:collection');
	      this.destroyChildren();
	      this.triggerMethod('destroy:collection');
	  
	      return Marionette.View.prototype.destroy.apply(this, arguments);
	    },
	  
	    // Destroy the child views that this collection view
	    // is holding on to, if any
	    destroyChildren: function() {
	      var childViews = this.children.map(_.identity);
	      this.children.each(this.removeChildView, this);
	      this.checkEmpty();
	      return childViews;
	    },
	  
	    // Return true if the given child should be shown
	    // Return false otherwise
	    // The filter will be passed (child, index, collection)
	    // Where
	    //  'child' is the given model
	    //  'index' is the index of that model in the collection
	    //  'collection' is the collection referenced by this CollectionView
	    _shouldAddChild: function(child, index) {
	      var filter = this.getOption('filter');
	      return !_.isFunction(filter) || filter.call(this, child, index, this.collection);
	    },
	  
	    // Set up the child view event forwarding. Uses a "childview:"
	    // prefix in front of all forwarded events.
	    proxyChildEvents: function(view) {
	      var prefix = this.getOption('childViewEventPrefix');
	  
	      // Forward all child view events through the parent,
	      // prepending "childview:" to the event name
	      this.listenTo(view, 'all', function() {
	        var args = _.toArray(arguments);
	        var rootEvent = args[0];
	        var childEvents = this.normalizeMethods(_.result(this, 'childEvents'));
	  
	        args[0] = prefix + ':' + rootEvent;
	        args.splice(1, 0, view);
	  
	        // call collectionView childEvent if defined
	        if (typeof childEvents !== 'undefined' && _.isFunction(childEvents[rootEvent])) {
	          childEvents[rootEvent].apply(this, args.slice(1));
	        }
	  
	        this.triggerMethod.apply(this, args);
	      });
	    },
	  
	    _getImmediateChildren: function() {
	      return _.values(this.children._views);
	    },
	  
	    getViewComparator: function() {
	      return this.getOption('viewComparator');
	    }
	  });
	  
	  /* jshint maxstatements: 17, maxlen: 117 */
	  
	  // Composite View
	  // --------------
	  
	  // Used for rendering a branch-leaf, hierarchical structure.
	  // Extends directly from CollectionView and also renders an
	  // a child view as `modelView`, for the top leaf
	  Marionette.CompositeView = Marionette.CollectionView.extend({
	  
	    // Setting up the inheritance chain which allows changes to
	    // Marionette.CollectionView.prototype.constructor which allows overriding
	    // option to pass '{sort: false}' to prevent the CompositeView from
	    // maintaining the sorted order of the collection.
	    // This will fallback onto appending childView's to the end.
	    constructor: function() {
	      Marionette.CollectionView.apply(this, arguments);
	    },
	  
	    // Configured the initial events that the composite view
	    // binds to. Override this method to prevent the initial
	    // events, or to add your own initial events.
	    _initialEvents: function() {
	  
	      // Bind only after composite view is rendered to avoid adding child views
	      // to nonexistent childViewContainer
	  
	      if (this.collection) {
	        this.listenTo(this.collection, 'add', this._onCollectionAdd);
	        this.listenTo(this.collection, 'remove', this._onCollectionRemove);
	        this.listenTo(this.collection, 'reset', this._renderChildren);
	  
	        if (this.getOption('sort')) {
	          this.listenTo(this.collection, 'sort', this._sortViews);
	        }
	      }
	    },
	  
	    // Retrieve the `childView` to be used when rendering each of
	    // the items in the collection. The default is to return
	    // `this.childView` or Marionette.CompositeView if no `childView`
	    // has been defined
	    getChildView: function(child) {
	      var childView = this.getOption('childView') || this.constructor;
	  
	      return childView;
	    },
	  
	    // Serialize the model for the view.
	    // You can override the `serializeData` method in your own view
	    // definition, to provide custom serialization for your view's data.
	    serializeData: function() {
	      var data = {};
	  
	      if (this.model) {
	        data = _.partial(this.serializeModel, this.model).apply(this, arguments);
	      }
	  
	      return data;
	    },
	  
	    // Renders the model and the collection.
	    render: function() {
	      this._ensureViewIsIntact();
	      this._isRendering = true;
	      this.resetChildViewContainer();
	  
	      this.triggerMethod('before:render', this);
	  
	      this._renderTemplate();
	      this._renderChildren();
	  
	      this._isRendering = false;
	      this.isRendered = true;
	      this.triggerMethod('render', this);
	      return this;
	    },
	  
	    _renderChildren: function() {
	      if (this.isRendered || this._isRendering) {
	        Marionette.CollectionView.prototype._renderChildren.call(this);
	      }
	    },
	  
	    // Render the root template that the children
	    // views are appended to
	    _renderTemplate: function() {
	      var data = {};
	      data = this.serializeData();
	      data = this.mixinTemplateHelpers(data);
	  
	      this.triggerMethod('before:render:template');
	  
	      var template = this.getTemplate();
	      var html = Marionette.Renderer.render(template, data, this);
	      this.attachElContent(html);
	  
	      // the ui bindings is done here and not at the end of render since they
	      // will not be available until after the model is rendered, but should be
	      // available before the collection is rendered.
	      this.bindUIElements();
	      this.triggerMethod('render:template');
	    },
	  
	    // Attaches the content of the root.
	    // This method can be overridden to optimize rendering,
	    // or to render in a non standard way.
	    //
	    // For example, using `innerHTML` instead of `$el.html`
	    //
	    // ```js
	    // attachElContent: function(html) {
	    //   this.el.innerHTML = html;
	    //   return this;
	    // }
	    // ```
	    attachElContent: function(html) {
	      this.$el.html(html);
	  
	      return this;
	    },
	  
	    // You might need to override this if you've overridden attachHtml
	    attachBuffer: function(compositeView) {
	      var $container = this.getChildViewContainer(compositeView);
	      $container.append(this._createBuffer(compositeView));
	    },
	  
	    // Internal method. Append a view to the end of the $el.
	    // Overidden from CollectionView to ensure view is appended to
	    // childViewContainer
	    _insertAfter: function(childView) {
	      var $container = this.getChildViewContainer(this, childView);
	      $container.append(childView.el);
	    },
	  
	    // Internal method. Append reordered childView'.
	    // Overidden from CollectionView to ensure reordered views
	    // are appended to childViewContainer
	    _appendReorderedChildren: function(children) {
	      var $container = this.getChildViewContainer(this);
	      $container.append(children);
	    },
	  
	    // Internal method to ensure an `$childViewContainer` exists, for the
	    // `attachHtml` method to use.
	    getChildViewContainer: function(containerView, childView) {
	      if ('$childViewContainer' in containerView) {
	        return containerView.$childViewContainer;
	      }
	  
	      var container;
	      var childViewContainer = Marionette.getOption(containerView, 'childViewContainer');
	      if (childViewContainer) {
	  
	        var selector = Marionette._getValue(childViewContainer, containerView);
	  
	        if (selector.charAt(0) === '@' && containerView.ui) {
	          container = containerView.ui[selector.substr(4)];
	        } else {
	          container = containerView.$(selector);
	        }
	  
	        if (container.length <= 0) {
	          throw new Marionette.Error({
	            name: 'ChildViewContainerMissingError',
	            message: 'The specified "childViewContainer" was not found: ' + containerView.childViewContainer
	          });
	        }
	  
	      } else {
	        container = containerView.$el;
	      }
	  
	      containerView.$childViewContainer = container;
	      return container;
	    },
	  
	    // Internal method to reset the `$childViewContainer` on render
	    resetChildViewContainer: function() {
	      if (this.$childViewContainer) {
	        delete this.$childViewContainer;
	      }
	    }
	  });
	  
	  // Layout View
	  // -----------
	  
	  // Used for managing application layoutViews, nested layoutViews and
	  // multiple regions within an application or sub-application.
	  //
	  // A specialized view class that renders an area of HTML and then
	  // attaches `Region` instances to the specified `regions`.
	  // Used for composite view management and sub-application areas.
	  Marionette.LayoutView = Marionette.ItemView.extend({
	    regionClass: Marionette.Region,
	  
	    options: {
	      destroyImmediate: false
	    },
	  
	    // used as the prefix for child view events
	    // that are forwarded through the layoutview
	    childViewEventPrefix: 'childview',
	  
	    // Ensure the regions are available when the `initialize` method
	    // is called.
	    constructor: function(options) {
	      options = options || {};
	  
	      this._firstRender = true;
	      this._initializeRegions(options);
	  
	      Marionette.ItemView.call(this, options);
	    },
	  
	    // LayoutView's render will use the existing region objects the
	    // first time it is called. Subsequent calls will destroy the
	    // views that the regions are showing and then reset the `el`
	    // for the regions to the newly rendered DOM elements.
	    render: function() {
	      this._ensureViewIsIntact();
	  
	      if (this._firstRender) {
	        // if this is the first render, don't do anything to
	        // reset the regions
	        this._firstRender = false;
	      } else {
	        // If this is not the first render call, then we need to
	        // re-initialize the `el` for each region
	        this._reInitializeRegions();
	      }
	  
	      return Marionette.ItemView.prototype.render.apply(this, arguments);
	    },
	  
	    // Handle destroying regions, and then destroy the view itself.
	    destroy: function() {
	      if (this.isDestroyed) { return this; }
	      // #2134: remove parent element before destroying the child views, so
	      // removing the child views doesn't retrigger repaints
	      if (this.getOption('destroyImmediate') === true) {
	        this.$el.remove();
	      }
	      this.regionManager.destroy();
	      return Marionette.ItemView.prototype.destroy.apply(this, arguments);
	    },
	  
	    showChildView: function(regionName, view) {
	      return this.getRegion(regionName).show(view);
	    },
	  
	    getChildView: function(regionName) {
	      return this.getRegion(regionName).currentView;
	    },
	  
	    // Add a single region, by name, to the layoutView
	    addRegion: function(name, definition) {
	      var regions = {};
	      regions[name] = definition;
	      return this._buildRegions(regions)[name];
	    },
	  
	    // Add multiple regions as a {name: definition, name2: def2} object literal
	    addRegions: function(regions) {
	      this.regions = _.extend({}, this.regions, regions);
	      return this._buildRegions(regions);
	    },
	  
	    // Remove a single region from the LayoutView, by name
	    removeRegion: function(name) {
	      delete this.regions[name];
	      return this.regionManager.removeRegion(name);
	    },
	  
	    // Provides alternative access to regions
	    // Accepts the region name
	    // getRegion('main')
	    getRegion: function(region) {
	      return this.regionManager.get(region);
	    },
	  
	    // Get all regions
	    getRegions: function() {
	      return this.regionManager.getRegions();
	    },
	  
	    // internal method to build regions
	    _buildRegions: function(regions) {
	      var defaults = {
	        regionClass: this.getOption('regionClass'),
	        parentEl: _.partial(_.result, this, 'el')
	      };
	  
	      return this.regionManager.addRegions(regions, defaults);
	    },
	  
	    // Internal method to initialize the regions that have been defined in a
	    // `regions` attribute on this layoutView.
	    _initializeRegions: function(options) {
	      var regions;
	      this._initRegionManager();
	  
	      regions = Marionette._getValue(this.regions, this, [options]) || {};
	  
	      // Enable users to define `regions` as instance options.
	      var regionOptions = this.getOption.call(options, 'regions');
	  
	      // enable region options to be a function
	      regionOptions = Marionette._getValue(regionOptions, this, [options]);
	  
	      _.extend(regions, regionOptions);
	  
	      // Normalize region selectors hash to allow
	      // a user to use the @ui. syntax.
	      regions = this.normalizeUIValues(regions, ['selector', 'el']);
	  
	      this.addRegions(regions);
	    },
	  
	    // Internal method to re-initialize all of the regions by updating the `el` that
	    // they point to
	    _reInitializeRegions: function() {
	      this.regionManager.invoke('reset');
	    },
	  
	    // Enable easy overriding of the default `RegionManager`
	    // for customized region interactions and business specific
	    // view logic for better control over single regions.
	    getRegionManager: function() {
	      return new Marionette.RegionManager();
	    },
	  
	    // Internal method to initialize the region manager
	    // and all regions in it
	    _initRegionManager: function() {
	      this.regionManager = this.getRegionManager();
	      this.regionManager._parent = this;
	  
	      this.listenTo(this.regionManager, 'before:add:region', function(name) {
	        this.triggerMethod('before:add:region', name);
	      });
	  
	      this.listenTo(this.regionManager, 'add:region', function(name, region) {
	        this[name] = region;
	        this.triggerMethod('add:region', name, region);
	      });
	  
	      this.listenTo(this.regionManager, 'before:remove:region', function(name) {
	        this.triggerMethod('before:remove:region', name);
	      });
	  
	      this.listenTo(this.regionManager, 'remove:region', function(name, region) {
	        delete this[name];
	        this.triggerMethod('remove:region', name, region);
	      });
	    },
	  
	    _getImmediateChildren: function() {
	      return _.chain(this.regionManager.getRegions())
	        .pluck('currentView')
	        .compact()
	        .value();
	    }
	  });
	  
	
	  // Behavior
	  // --------
	  
	  // A Behavior is an isolated set of DOM /
	  // user interactions that can be mixed into any View.
	  // Behaviors allow you to blackbox View specific interactions
	  // into portable logical chunks, keeping your views simple and your code DRY.
	  
	  Marionette.Behavior = Marionette.Object.extend({
	    constructor: function(options, view) {
	      // Setup reference to the view.
	      // this comes in handle when a behavior
	      // wants to directly talk up the chain
	      // to the view.
	      this.view = view;
	      this.defaults = _.result(this, 'defaults') || {};
	      this.options  = _.extend({}, this.defaults, options);
	      // Construct an internal UI hash using
	      // the views UI hash and then the behaviors UI hash.
	      // This allows the user to use UI hash elements
	      // defined in the parent view as well as those
	      // defined in the given behavior.
	      this.ui = _.extend({}, _.result(view, 'ui'), _.result(this, 'ui'));
	  
	      Marionette.Object.apply(this, arguments);
	    },
	  
	    // proxy behavior $ method to the view
	    // this is useful for doing jquery DOM lookups
	    // scoped to behaviors view.
	    $: function() {
	      return this.view.$.apply(this.view, arguments);
	    },
	  
	    // Stops the behavior from listening to events.
	    // Overrides Object#destroy to prevent additional events from being triggered.
	    destroy: function() {
	      this.stopListening();
	  
	      return this;
	    },
	  
	    proxyViewProperties: function(view) {
	      this.$el = view.$el;
	      this.el = view.el;
	    }
	  });
	  
	  /* jshint maxlen: 143 */
	  // Behaviors
	  // ---------
	  
	  // Behaviors is a utility class that takes care of
	  // gluing your behavior instances to their given View.
	  // The most important part of this class is that you
	  // **MUST** override the class level behaviorsLookup
	  // method for things to work properly.
	  
	  Marionette.Behaviors = (function(Marionette, _) {
	    // Borrow event splitter from Backbone
	    var delegateEventSplitter = /^(\S+)\s*(.*)$/;
	  
	    function Behaviors(view, behaviors) {
	  
	      if (!_.isObject(view.behaviors)) {
	        return {};
	      }
	  
	      // Behaviors defined on a view can be a flat object literal
	      // or it can be a function that returns an object.
	      behaviors = Behaviors.parseBehaviors(view, behaviors || _.result(view, 'behaviors'));
	  
	      // Wraps several of the view's methods
	      // calling the methods first on each behavior
	      // and then eventually calling the method on the view.
	      Behaviors.wrap(view, behaviors, _.keys(methods));
	      return behaviors;
	    }
	  
	    var methods = {
	      behaviorTriggers: function(behaviorTriggers, behaviors) {
	        var triggerBuilder = new BehaviorTriggersBuilder(this, behaviors);
	        return triggerBuilder.buildBehaviorTriggers();
	      },
	  
	      behaviorEvents: function(behaviorEvents, behaviors) {
	        var _behaviorsEvents = {};
	  
	        _.each(behaviors, function(b, i) {
	          var _events = {};
	          var behaviorEvents = _.clone(_.result(b, 'events')) || {};
	  
	          // Normalize behavior events hash to allow
	          // a user to use the @ui. syntax.
	          behaviorEvents = Marionette.normalizeUIKeys(behaviorEvents, getBehaviorsUI(b));
	  
	          var j = 0;
	          _.each(behaviorEvents, function(behaviour, key) {
	            var match     = key.match(delegateEventSplitter);
	  
	            // Set event name to be namespaced using the view cid,
	            // the behavior index, and the behavior event index
	            // to generate a non colliding event namespace
	            // http://api.jquery.com/event.namespace/
	            var eventName = match[1] + '.' + [this.cid, i, j++, ' '].join('');
	            var selector  = match[2];
	  
	            var eventKey  = eventName + selector;
	            var handler   = _.isFunction(behaviour) ? behaviour : b[behaviour];
	  
	            _events[eventKey] = _.bind(handler, b);
	          }, this);
	  
	          _behaviorsEvents = _.extend(_behaviorsEvents, _events);
	        }, this);
	  
	        return _behaviorsEvents;
	      }
	    };
	  
	    _.extend(Behaviors, {
	  
	      // Placeholder method to be extended by the user.
	      // The method should define the object that stores the behaviors.
	      // i.e.
	      //
	      // ```js
	      // Marionette.Behaviors.behaviorsLookup: function() {
	      //   return App.Behaviors
	      // }
	      // ```
	      behaviorsLookup: function() {
	        throw new Marionette.Error({
	          message: 'You must define where your behaviors are stored.',
	          url: 'marionette.behaviors.html#behaviorslookup'
	        });
	      },
	  
	      // Takes care of getting the behavior class
	      // given options and a key.
	      // If a user passes in options.behaviorClass
	      // default to using that. Otherwise delegate
	      // the lookup to the users `behaviorsLookup` implementation.
	      getBehaviorClass: function(options, key) {
	        if (options.behaviorClass) {
	          return options.behaviorClass;
	        }
	  
	        // Get behavior class can be either a flat object or a method
	        return Marionette._getValue(Behaviors.behaviorsLookup, this, [options, key])[key];
	      },
	  
	      // Iterate over the behaviors object, for each behavior
	      // instantiate it and get its grouped behaviors.
	      parseBehaviors: function(view, behaviors) {
	        return _.chain(behaviors).map(function(options, key) {
	          var BehaviorClass = Behaviors.getBehaviorClass(options, key);
	  
	          var behavior = new BehaviorClass(options, view);
	          var nestedBehaviors = Behaviors.parseBehaviors(view, _.result(behavior, 'behaviors'));
	  
	          return [behavior].concat(nestedBehaviors);
	        }).flatten().value();
	      },
	  
	      // Wrap view internal methods so that they delegate to behaviors. For example,
	      // `onDestroy` should trigger destroy on all of the behaviors and then destroy itself.
	      // i.e.
	      //
	      // `view.delegateEvents = _.partial(methods.delegateEvents, view.delegateEvents, behaviors);`
	      wrap: function(view, behaviors, methodNames) {
	        _.each(methodNames, function(methodName) {
	          view[methodName] = _.partial(methods[methodName], view[methodName], behaviors);
	        });
	      }
	    });
	  
	    // Class to build handlers for `triggers` on behaviors
	    // for views
	    function BehaviorTriggersBuilder(view, behaviors) {
	      this._view      = view;
	      this._behaviors = behaviors;
	      this._triggers  = {};
	    }
	  
	    _.extend(BehaviorTriggersBuilder.prototype, {
	      // Main method to build the triggers hash with event keys and handlers
	      buildBehaviorTriggers: function() {
	        _.each(this._behaviors, this._buildTriggerHandlersForBehavior, this);
	        return this._triggers;
	      },
	  
	      // Internal method to build all trigger handlers for a given behavior
	      _buildTriggerHandlersForBehavior: function(behavior, i) {
	        var triggersHash = _.clone(_.result(behavior, 'triggers')) || {};
	  
	        triggersHash = Marionette.normalizeUIKeys(triggersHash, getBehaviorsUI(behavior));
	  
	        _.each(triggersHash, _.bind(this._setHandlerForBehavior, this, behavior, i));
	      },
	  
	      // Internal method to create and assign the trigger handler for a given
	      // behavior
	      _setHandlerForBehavior: function(behavior, i, eventName, trigger) {
	        // Unique identifier for the `this._triggers` hash
	        var triggerKey = trigger.replace(/^\S+/, function(triggerName) {
	          return triggerName + '.' + 'behaviortriggers' + i;
	        });
	  
	        this._triggers[triggerKey] = this._view._buildViewTrigger(eventName);
	      }
	    });
	  
	    function getBehaviorsUI(behavior) {
	      return behavior._uiBindings || behavior.ui;
	    }
	  
	    return Behaviors;
	  
	  })(Marionette, _);
	  
	
	  // App Router
	  // ----------
	  
	  // Reduce the boilerplate code of handling route events
	  // and then calling a single method on another object.
	  // Have your routers configured to call the method on
	  // your object, directly.
	  //
	  // Configure an AppRouter with `appRoutes`.
	  //
	  // App routers can only take one `controller` object.
	  // It is recommended that you divide your controller
	  // objects in to smaller pieces of related functionality
	  // and have multiple routers / controllers, instead of
	  // just one giant router and controller.
	  //
	  // You can also add standard routes to an AppRouter.
	  
	  Marionette.AppRouter = Backbone.Router.extend({
	  
	    constructor: function(options) {
	      this.options = options || {};
	  
	      Backbone.Router.apply(this, arguments);
	  
	      var appRoutes = this.getOption('appRoutes');
	      var controller = this._getController();
	      this.processAppRoutes(controller, appRoutes);
	      this.on('route', this._processOnRoute, this);
	    },
	  
	    // Similar to route method on a Backbone Router but
	    // method is called on the controller
	    appRoute: function(route, methodName) {
	      var controller = this._getController();
	      this._addAppRoute(controller, route, methodName);
	    },
	  
	    // process the route event and trigger the onRoute
	    // method call, if it exists
	    _processOnRoute: function(routeName, routeArgs) {
	      // make sure an onRoute before trying to call it
	      if (_.isFunction(this.onRoute)) {
	        // find the path that matches the current route
	        var routePath = _.invert(this.getOption('appRoutes'))[routeName];
	        this.onRoute(routeName, routePath, routeArgs);
	      }
	    },
	  
	    // Internal method to process the `appRoutes` for the
	    // router, and turn them in to routes that trigger the
	    // specified method on the specified `controller`.
	    processAppRoutes: function(controller, appRoutes) {
	      if (!appRoutes) { return; }
	  
	      var routeNames = _.keys(appRoutes).reverse(); // Backbone requires reverted order of routes
	  
	      _.each(routeNames, function(route) {
	        this._addAppRoute(controller, route, appRoutes[route]);
	      }, this);
	    },
	  
	    _getController: function() {
	      return this.getOption('controller');
	    },
	  
	    _addAppRoute: function(controller, route, methodName) {
	      var method = controller[methodName];
	  
	      if (!method) {
	        throw new Marionette.Error('Method "' + methodName + '" was not found on the controller');
	      }
	  
	      this.route(route, methodName, _.bind(method, controller));
	    },
	  
	    mergeOptions: Marionette.mergeOptions,
	  
	    // Proxy `getOption` to enable getting options from this or this.options by name.
	    getOption: Marionette.proxyGetOption,
	  
	    triggerMethod: Marionette.triggerMethod,
	  
	    bindEntityEvents: Marionette.proxyBindEntityEvents,
	  
	    unbindEntityEvents: Marionette.proxyUnbindEntityEvents
	  });
	  
	  // Application
	  // -----------
	  
	  // Contain and manage the composite application as a whole.
	  // Stores and starts up `Region` objects, includes an
	  // event aggregator as `app.vent`
	  Marionette.Application = Marionette.Object.extend({
	    constructor: function(options) {
	      this._initializeRegions(options);
	      this._initCallbacks = new Marionette.Callbacks();
	      this.submodules = {};
	      _.extend(this, options);
	      this._initChannel();
	      Marionette.Object.call(this, options);
	    },
	  
	    // Command execution, facilitated by Backbone.Wreqr.Commands
	    execute: function() {
	      this.commands.execute.apply(this.commands, arguments);
	    },
	  
	    // Request/response, facilitated by Backbone.Wreqr.RequestResponse
	    request: function() {
	      return this.reqres.request.apply(this.reqres, arguments);
	    },
	  
	    // Add an initializer that is either run at when the `start`
	    // method is called, or run immediately if added after `start`
	    // has already been called.
	    addInitializer: function(initializer) {
	      this._initCallbacks.add(initializer);
	    },
	  
	    // kick off all of the application's processes.
	    // initializes all of the regions that have been added
	    // to the app, and runs all of the initializer functions
	    start: function(options) {
	      this.triggerMethod('before:start', options);
	      this._initCallbacks.run(options, this);
	      this.triggerMethod('start', options);
	    },
	  
	    // Add regions to your app.
	    // Accepts a hash of named strings or Region objects
	    // addRegions({something: "#someRegion"})
	    // addRegions({something: Region.extend({el: "#someRegion"}) });
	    addRegions: function(regions) {
	      return this._regionManager.addRegions(regions);
	    },
	  
	    // Empty all regions in the app, without removing them
	    emptyRegions: function() {
	      return this._regionManager.emptyRegions();
	    },
	  
	    // Removes a region from your app, by name
	    // Accepts the regions name
	    // removeRegion('myRegion')
	    removeRegion: function(region) {
	      return this._regionManager.removeRegion(region);
	    },
	  
	    // Provides alternative access to regions
	    // Accepts the region name
	    // getRegion('main')
	    getRegion: function(region) {
	      return this._regionManager.get(region);
	    },
	  
	    // Get all the regions from the region manager
	    getRegions: function() {
	      return this._regionManager.getRegions();
	    },
	  
	    // Create a module, attached to the application
	    module: function(moduleNames, moduleDefinition) {
	  
	      // Overwrite the module class if the user specifies one
	      var ModuleClass = Marionette.Module.getClass(moduleDefinition);
	  
	      var args = _.toArray(arguments);
	      args.unshift(this);
	  
	      // see the Marionette.Module object for more information
	      return ModuleClass.create.apply(ModuleClass, args);
	    },
	  
	    // Enable easy overriding of the default `RegionManager`
	    // for customized region interactions and business-specific
	    // view logic for better control over single regions.
	    getRegionManager: function() {
	      return new Marionette.RegionManager();
	    },
	  
	    // Internal method to initialize the regions that have been defined in a
	    // `regions` attribute on the application instance
	    _initializeRegions: function(options) {
	      var regions = _.isFunction(this.regions) ? this.regions(options) : this.regions || {};
	  
	      this._initRegionManager();
	  
	      // Enable users to define `regions` in instance options.
	      var optionRegions = Marionette.getOption(options, 'regions');
	  
	      // Enable region options to be a function
	      if (_.isFunction(optionRegions)) {
	        optionRegions = optionRegions.call(this, options);
	      }
	  
	      // Overwrite current regions with those passed in options
	      _.extend(regions, optionRegions);
	  
	      this.addRegions(regions);
	  
	      return this;
	    },
	  
	    // Internal method to set up the region manager
	    _initRegionManager: function() {
	      this._regionManager = this.getRegionManager();
	      this._regionManager._parent = this;
	  
	      this.listenTo(this._regionManager, 'before:add:region', function() {
	        Marionette._triggerMethod(this, 'before:add:region', arguments);
	      });
	  
	      this.listenTo(this._regionManager, 'add:region', function(name, region) {
	        this[name] = region;
	        Marionette._triggerMethod(this, 'add:region', arguments);
	      });
	  
	      this.listenTo(this._regionManager, 'before:remove:region', function() {
	        Marionette._triggerMethod(this, 'before:remove:region', arguments);
	      });
	  
	      this.listenTo(this._regionManager, 'remove:region', function(name) {
	        delete this[name];
	        Marionette._triggerMethod(this, 'remove:region', arguments);
	      });
	    },
	  
	    // Internal method to setup the Wreqr.radio channel
	    _initChannel: function() {
	      this.channelName = _.result(this, 'channelName') || 'global';
	      this.channel = _.result(this, 'channel') || Backbone.Wreqr.radio.channel(this.channelName);
	      this.vent = _.result(this, 'vent') || this.channel.vent;
	      this.commands = _.result(this, 'commands') || this.channel.commands;
	      this.reqres = _.result(this, 'reqres') || this.channel.reqres;
	    }
	  });
	  
	  /* jshint maxparams: 9 */
	  
	  // Module
	  // ------
	  
	  // A simple module system, used to create privacy and encapsulation in
	  // Marionette applications
	  Marionette.Module = function(moduleName, app, options) {
	    this.moduleName = moduleName;
	    this.options = _.extend({}, this.options, options);
	    // Allow for a user to overide the initialize
	    // for a given module instance.
	    this.initialize = options.initialize || this.initialize;
	  
	    // Set up an internal store for sub-modules.
	    this.submodules = {};
	  
	    this._setupInitializersAndFinalizers();
	  
	    // Set an internal reference to the app
	    // within a module.
	    this.app = app;
	  
	    if (_.isFunction(this.initialize)) {
	      this.initialize(moduleName, app, this.options);
	    }
	  };
	  
	  Marionette.Module.extend = Marionette.extend;
	  
	  // Extend the Module prototype with events / listenTo, so that the module
	  // can be used as an event aggregator or pub/sub.
	  _.extend(Marionette.Module.prototype, Backbone.Events, {
	  
	    // By default modules start with their parents.
	    startWithParent: true,
	  
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic when extending Marionette.Module.
	    initialize: function() {},
	  
	    // Initializer for a specific module. Initializers are run when the
	    // module's `start` method is called.
	    addInitializer: function(callback) {
	      this._initializerCallbacks.add(callback);
	    },
	  
	    // Finalizers are run when a module is stopped. They are used to teardown
	    // and finalize any variables, references, events and other code that the
	    // module had set up.
	    addFinalizer: function(callback) {
	      this._finalizerCallbacks.add(callback);
	    },
	  
	    // Start the module, and run all of its initializers
	    start: function(options) {
	      // Prevent re-starting a module that is already started
	      if (this._isInitialized) { return; }
	  
	      // start the sub-modules (depth-first hierarchy)
	      _.each(this.submodules, function(mod) {
	        // check to see if we should start the sub-module with this parent
	        if (mod.startWithParent) {
	          mod.start(options);
	        }
	      });
	  
	      // run the callbacks to "start" the current module
	      this.triggerMethod('before:start', options);
	  
	      this._initializerCallbacks.run(options, this);
	      this._isInitialized = true;
	  
	      this.triggerMethod('start', options);
	    },
	  
	    // Stop this module by running its finalizers and then stop all of
	    // the sub-modules for this module
	    stop: function() {
	      // if we are not initialized, don't bother finalizing
	      if (!this._isInitialized) { return; }
	      this._isInitialized = false;
	  
	      this.triggerMethod('before:stop');
	  
	      // stop the sub-modules; depth-first, to make sure the
	      // sub-modules are stopped / finalized before parents
	      _.invoke(this.submodules, 'stop');
	  
	      // run the finalizers
	      this._finalizerCallbacks.run(undefined, this);
	  
	      // reset the initializers and finalizers
	      this._initializerCallbacks.reset();
	      this._finalizerCallbacks.reset();
	  
	      this.triggerMethod('stop');
	    },
	  
	    // Configure the module with a definition function and any custom args
	    // that are to be passed in to the definition function
	    addDefinition: function(moduleDefinition, customArgs) {
	      this._runModuleDefinition(moduleDefinition, customArgs);
	    },
	  
	    // Internal method: run the module definition function with the correct
	    // arguments
	    _runModuleDefinition: function(definition, customArgs) {
	      // If there is no definition short circut the method.
	      if (!definition) { return; }
	  
	      // build the correct list of arguments for the module definition
	      var args = _.flatten([
	        this,
	        this.app,
	        Backbone,
	        Marionette,
	        Backbone.$, _,
	        customArgs
	      ]);
	  
	      definition.apply(this, args);
	    },
	  
	    // Internal method: set up new copies of initializers and finalizers.
	    // Calling this method will wipe out all existing initializers and
	    // finalizers.
	    _setupInitializersAndFinalizers: function() {
	      this._initializerCallbacks = new Marionette.Callbacks();
	      this._finalizerCallbacks = new Marionette.Callbacks();
	    },
	  
	    // import the `triggerMethod` to trigger events with corresponding
	    // methods if the method exists
	    triggerMethod: Marionette.triggerMethod
	  });
	  
	  // Class methods to create modules
	  _.extend(Marionette.Module, {
	  
	    // Create a module, hanging off the app parameter as the parent object.
	    create: function(app, moduleNames, moduleDefinition) {
	      var module = app;
	  
	      // get the custom args passed in after the module definition and
	      // get rid of the module name and definition function
	      var customArgs = _.drop(arguments, 3);
	  
	      // Split the module names and get the number of submodules.
	      // i.e. an example module name of `Doge.Wow.Amaze` would
	      // then have the potential for 3 module definitions.
	      moduleNames = moduleNames.split('.');
	      var length = moduleNames.length;
	  
	      // store the module definition for the last module in the chain
	      var moduleDefinitions = [];
	      moduleDefinitions[length - 1] = moduleDefinition;
	  
	      // Loop through all the parts of the module definition
	      _.each(moduleNames, function(moduleName, i) {
	        var parentModule = module;
	        module = this._getModule(parentModule, moduleName, app, moduleDefinition);
	        this._addModuleDefinition(parentModule, module, moduleDefinitions[i], customArgs);
	      }, this);
	  
	      // Return the last module in the definition chain
	      return module;
	    },
	  
	    _getModule: function(parentModule, moduleName, app, def, args) {
	      var options = _.extend({}, def);
	      var ModuleClass = this.getClass(def);
	  
	      // Get an existing module of this name if we have one
	      var module = parentModule[moduleName];
	  
	      if (!module) {
	        // Create a new module if we don't have one
	        module = new ModuleClass(moduleName, app, options);
	        parentModule[moduleName] = module;
	        // store the module on the parent
	        parentModule.submodules[moduleName] = module;
	      }
	  
	      return module;
	    },
	  
	    // ## Module Classes
	    //
	    // Module classes can be used as an alternative to the define pattern.
	    // The extend function of a Module is identical to the extend functions
	    // on other Backbone and Marionette classes.
	    // This allows module lifecyle events like `onStart` and `onStop` to be called directly.
	    getClass: function(moduleDefinition) {
	      var ModuleClass = Marionette.Module;
	  
	      if (!moduleDefinition) {
	        return ModuleClass;
	      }
	  
	      // If all of the module's functionality is defined inside its class,
	      // then the class can be passed in directly. `MyApp.module("Foo", FooModule)`.
	      if (moduleDefinition.prototype instanceof ModuleClass) {
	        return moduleDefinition;
	      }
	  
	      return moduleDefinition.moduleClass || ModuleClass;
	    },
	  
	    // Add the module definition and add a startWithParent initializer function.
	    // This is complicated because module definitions are heavily overloaded
	    // and support an anonymous function, module class, or options object
	    _addModuleDefinition: function(parentModule, module, def, args) {
	      var fn = this._getDefine(def);
	      var startWithParent = this._getStartWithParent(def, module);
	  
	      if (fn) {
	        module.addDefinition(fn, args);
	      }
	  
	      this._addStartWithParent(parentModule, module, startWithParent);
	    },
	  
	    _getStartWithParent: function(def, module) {
	      var swp;
	  
	      if (_.isFunction(def) && (def.prototype instanceof Marionette.Module)) {
	        swp = module.constructor.prototype.startWithParent;
	        return _.isUndefined(swp) ? true : swp;
	      }
	  
	      if (_.isObject(def)) {
	        swp = def.startWithParent;
	        return _.isUndefined(swp) ? true : swp;
	      }
	  
	      return true;
	    },
	  
	    _getDefine: function(def) {
	      if (_.isFunction(def) && !(def.prototype instanceof Marionette.Module)) {
	        return def;
	      }
	  
	      if (_.isObject(def)) {
	        return def.define;
	      }
	  
	      return null;
	    },
	  
	    _addStartWithParent: function(parentModule, module, startWithParent) {
	      module.startWithParent = module.startWithParent && startWithParent;
	  
	      if (!module.startWithParent || !!module.startWithParentIsConfigured) {
	        return;
	      }
	  
	      module.startWithParentIsConfigured = true;
	  
	      parentModule.addInitializer(function(options) {
	        if (module.startWithParent) {
	          module.start(options);
	        }
	      });
	    }
	  });
	  
	
	  return Marionette;
	}));


/***/ },
/* 1955 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/*
	  backbone.paginator
	  http://github.com/backbone-paginator/backbone.paginator
	
	  Copyright (c) 2016 Jimmy Yuen Ho Wong and contributors
	
	  @module
	  @license MIT
	*/
	
	(function (factory) {
	
	  // CommonJS
	  if (true) {
	    module.exports = factory(__webpack_require__(__webpack_module_template_argument_0__), __webpack_require__(__webpack_module_template_argument_1__));
	  }
	  // AMD
	  else if (typeof define == "function" && define.amd) {
	    define(["underscore", "backbone"], factory);
	  }
	  // Browser
	  else if (typeof _ !== "undefined" && typeof Backbone !== "undefined") {
	    var oldPageableCollection = Backbone.PageableCollection;
	    var PageableCollection = factory(_, Backbone);
	
	    /**
	       __BROWSER ONLY__
	
	       If you already have an object named `PageableCollection` attached to the
	       `Backbone` module, you can use this to return a local reference to this
	       PageableCollection class and reset the name PageableCollection to its
	       previous definition.
	
	           // The left hand side gives you a reference to this
	           // PageableCollection implementation, the right hand side
	           // resets PageableCollection to your other PageableCollection.
	           var PageableCollection = PageableCollection.noConflict();
	
	       @static
	       @return {PageableCollection}
	    */
	    Backbone.PageableCollection.noConflict = function () {
	      Backbone.PageableCollection = oldPageableCollection;
	      return PageableCollection;
	    };
	  }
	
	}(function (_, Backbone) {
	
	  "use strict";
	
	  var _extend = _.extend;
	  var _omit = _.omit;
	  var _clone = _.clone;
	  var _each = _.each;
	  var _pick = _.pick;
	  var _contains = _.includes;
	  var _isEmpty = _.isEmpty;
	  var _pairs = _.pairs || _.toPairs;
	  var _invert = _.invert;
	  var _isArray = _.isArray;
	  var _isFunction = _.isFunction;
	  var _isObject = _.isObject;
	  var _keys = _.keys;
	  var _isUndefined = _.isUndefined;
	  var ceil = Math.ceil;
	  var floor = Math.floor;
	  var max = Math.max;
	
	  var BBColProto = Backbone.Collection.prototype;
	
	  function finiteInt (val, name) {
	    if (!_.isNumber(val) || _.isNaN(val) || !_.isFinite(val) || ~~val !== val) {
	      throw new TypeError("`" + name + "` must be a finite integer");
	    }
	    return val;
	  }
	
	  function queryStringToParams (qs) {
	    var kvp, k, v, ls, params = {}, decode = decodeURIComponent;
	    var kvps = qs.split("&");
	    for (var i = 0, l = kvps.length; i < l; i++) {
	      var param = kvps[i];
	      kvp = param.split("="), k = kvp[0], v = kvp[1];
	      if (v == null) v = true;
	      k = decode(k), v = decode(v), ls = params[k];
	      if (_isArray(ls)) ls.push(v);
	      else if (ls) params[k] = [ls, v];
	      else params[k] = v;
	    }
	    return params;
	  }
	
	  // hack to make sure the whatever event handlers for this event is run
	  // before func is, and the event handlers that func will trigger.
	  function runOnceAtLastHandler (col, event, func) {
	    var eventHandlers = col._events[event];
	    if (eventHandlers && eventHandlers.length) {
	      var lastHandler = eventHandlers[eventHandlers.length - 1];
	      var oldCallback = lastHandler.callback;
	      lastHandler.callback = function () {
	        try {
	          oldCallback.apply(this, arguments);
	          func();
	        }
	        catch (e) {
	          throw e;
	        }
	        finally {
	          lastHandler.callback = oldCallback;
	        }
	      };
	    }
	    else func();
	  }
	
	  var PARAM_TRIM_RE = /[\s'"]/g;
	  var URL_TRIM_RE = /[<>\s'"]/g;
	
	
	  /**
	   * State change event. Fired when PageableCollection#state gets updated
	   *
	   * @event pageable:state:change
	   * @type {object} The PageableCollection#state object of this
	   * PageableCollection instance
	   */
	
	
	  /**
	     Drop-in replacement for Backbone.Collection. Supports server-side and
	     client-side pagination and sorting. Client-side mode also support fully
	     multi-directional synchronization of changes between pages.
	
	     @class PageableCollection
	     @extends Backbone.Collection
	  */
	  var PageableCollection = Backbone.PageableCollection = Backbone.Collection.extend({
	
	    /**
	       The container object to store all pagination states.
	
	       You can override the default state by extending this class or specifying
	       them in an `options` hash to the constructor.
	
	       @property {number} firstPage = 1 - The first page index. Set to 0 if
	       your server API uses 0-based indices. You should only override this value
	       during extension, initialization or reset by the server after
	       fetching. This value should be read only at other times.
	
	       @property {number} lastPage = null - The last page index. This value
	       is __read only__ and it's calculated based on whether `firstPage` is 0 or
	       1, during bootstrapping, fetching and resetting. Please don't change this
	       value under any circumstances.
	
	       @property {number} currentPage = null - The current page index. You
	       should only override this value during extension, initialization or reset
	       by the server after fetching. This value should be read only at other
	       times. Can be a 0-based or 1-based index, depending on whether
	       `firstPage` is 0 or 1. If left as default, it will be set to `firstPage`
	       on initialization.
	
	       @property {number} pageSize = 25 - How many records to show per
	       page. This value is __read only__ after initialization, if you want to
	       change the page size after initialization, you must call
	       PageableCollection#setPageSize.
	
	       @property {number} totalPages = null - How many pages there are. This
	       value is __read only__ and it is calculated from `totalRecords`.
	
	       @property {number} totalRecords = null - How many records there
	       are. This value is __required__ under server mode. This value is optional
	       for client mode as the number will be the same as the number of models
	       during bootstrapping and during fetching, either supplied by the server
	       in the metadata, or calculated from the size of the response.
	
	       @property {string} sortKey = null - The model attribute to use for
	       sorting.
	
	       @property {number} order = -1 - The order to use for sorting. Specify
	       -1 for ascending order or 1 for descending order. If 0, no client side
	       sorting will be done and the order query parameter will not be sent to
	       the server during a fetch.
	    */
	    state: {
	      firstPage: 1,
	      lastPage: null,
	      currentPage: null,
	      pageSize: 25,
	      totalPages: null,
	      totalRecords: null,
	      sortKey: null,
	      order: -1
	    },
	
	    /**
	       @property {string} mode = "server" The mode of operations for this
	       collection. `"server"` paginates on the server-side, `"client"` paginates
	       on the client-side and `"infinite"` paginates on the server-side for APIs
	       that do not support `totalRecords`.
	    */
	    mode: "server",
	
	    /**
	       A translation map to convert PageableCollection state attributes
	       to the query parameters accepted by your server API.
	
	       You can override the default state by extending this class or specifying
	       them in `options.queryParams` object hash to the constructor.
	
	       @property {string|function():string} currentPage = "page"
	       @property {string|function():string} pageSize = "per_page"
	       @property {string|function():string} totalPages = "total_pages"
	       @property {string|function():string} totalRecords = "total_entries"
	       @property {string|function():string} sortKey = "sort_by"
	       @property {string|function():string} order = "order"
	       @property {Object} directions = {"-1": "asc", "1": "desc"} - A map for
	       translating a PageableCollection#state.order constant to the ones your
	       server API accepts.
	    */
	    queryParams: {
	      currentPage: "page",
	      pageSize: "per_page",
	      totalPages: "total_pages",
	      totalRecords: "total_entries",
	      sortKey: "sort_by",
	      order: "order",
	      directions: {
	        "-1": "asc",
	        "1": "desc"
	      }
	    },
	
	    /**
	       Given a list of models or model attributues, bootstraps the full
	       collection in client mode or infinite mode, or just the page you want in
	       server mode.
	
	       If you want to initialize a collection to a different state than the
	       default, you can specify them in `options.state`. Any state parameters
	       supplied will be merged with the default. If you want to change the
	       default mapping from PageableCollection#state keys to your server API's
	       query parameter names, you can specifiy an object hash in
	       `option.queryParams`. Likewise, any mapping provided will be merged with
	       the default. Lastly, all Backbone.Collection constructor options are also
	       accepted.
	
	       See:
	
	       - PageableCollection#state
	       - PageableCollection#queryParams
	       - [Backbone.Collection#initialize](http://backbonejs.org/#Collection-constructor)
	
	       @constructor
	
	       @property {Backbone.Collection} fullCollection - __CLIENT MODE ONLY__
	       This collection is the internal storage for the bootstrapped or fetched
	       models. You can use this if you want to operate on all the pages.
	
	       @param {Array.<Object>} models
	
	       @param {Object} options
	
	       @param {function(*, *): number} options.comparator - If specified, this
	       comparator is set to the current page under server mode, or the
	       PageableCollection#fullCollection otherwise.
	
	       @param {boolean} options.full 0 If `false` and either a
	       `options.comparator` or `sortKey` is defined, the comparator is attached
	       to the current page. Default is `true` under client or infinite mode and
	       the comparator will be attached to the PageableCollection#fullCollection.
	
	       @param {Object} options.state - The state attributes overriding the defaults.
	
	       @param {string} options.state.sortKey - The model attribute to use for
	       sorting. If specified instead of `options.comparator`, a comparator will
	       be automatically created using this value, and optionally a sorting order
	       specified in `options.state.order`. The comparator is then attached to
	       the new collection instance.
	
	       @param {number} options.state.order - The order to use for sorting. Specify
	       -1 for ascending order and 1 for descending order.
	
	       @param {Object} options.queryParam
	    */
	    constructor: function (models, options) {
	
	      BBColProto.constructor.apply(this, arguments);
	
	      options = options || {};
	
	      var mode = this.mode = options.mode || this.mode || PageableProto.mode;
	
	      var queryParams = _extend({}, PageableProto.queryParams, this.queryParams,
	                                options.queryParams || {});
	
	      queryParams.directions = _extend({},
	                                       PageableProto.queryParams.directions,
	                                       this.queryParams.directions,
	                                       queryParams.directions);
	
	      this.queryParams = queryParams;
	
	      var state = this.state = _extend({}, PageableProto.state, this.state,
	                                       options.state);
	
	      state.currentPage = state.currentPage == null ?
	        state.firstPage :
	        state.currentPage;
	
	      if (!_isArray(models)) models = models ? [models] : [];
	      models = models.slice();
	
	      if (mode != "server" && state.totalRecords == null && !_isEmpty(models)) {
	        // Can't use models.length naively here because Backbone.Collection will
	        // dedupe by `idAttribute`
	        state.totalRecords = this.length;
	      }
	
	      this.switchMode(mode, _extend({fetch: false,
	                                     resetState: false,
	                                     models: models}, options));
	
	      var comparator = options.comparator;
	
	      if (state.sortKey && !comparator) {
	        this.setSorting(state.sortKey, state.order, options);
	      }
	
	      if (mode != "server") {
	        var fullCollection = this.fullCollection;
	
	        if (comparator && options.full) {
	          this.comparator = null;
	          fullCollection.comparator = comparator;
	        }
	
	        if (options.full) fullCollection.sort();
	
	        // make sure the models in the current page and full collection have the
	        // same references
	        if (!_isEmpty(models)) {
	          this.getPage(state.currentPage);
	        }
	      }
	
	      this._initState = _clone(this.state);
	    },
	
	    /**
	       Makes a Backbone.Collection that contains all the pages.
	
	       @private
	       @param {Array.<Object|Backbone.Model>} models
	       @param {Object} options Options for Backbone.Collection constructor.
	       @return {Backbone.Collection}
	    */
	    _makeFullCollection: function (models, options) {
	
	      var properties = ["url", "model", "sync", "comparator"];
	      var thisProto = this.constructor.prototype;
	      var i, length, prop;
	
	      var proto = {};
	      for (i = 0, length = properties.length; i < length; i++) {
	        prop = properties[i];
	        if (!_isUndefined(thisProto[prop])) {
	          proto[prop] = thisProto[prop];
	        }
	      }
	
	      var fullCollection = new (Backbone.Collection.extend(proto))(models, options);
	
	      for (i = 0, length = properties.length; i < length; i++) {
	        prop = properties[i];
	        if (this[prop] !== thisProto[prop]) {
	          fullCollection[prop] = this[prop];
	        }
	      }
	
	      return fullCollection;
	    },
	
	    /**
	       Factory method that returns a Backbone event handler that responses to
	       the `add`, `remove`, `reset`, and the `sort` events. The returned event
	       handler will synchronize the current page collection and the full
	       collection's models.
	
	       @private
	
	       @fires PageableCollection#pageable:state:change when handling an
	       `add`, `remove`, or `reset` event
	
	       @param {PageableCollection} pageCol
	       @param {Backbone.Collection} fullCol
	
	       @return {function(string, Backbone.Model, Backbone.Collection, Object)}
	       Collection event handler
	    */
	    _makeCollectionEventHandler: function (pageCol, fullCol) {
	
	      return function collectionEventHandler (event, model, collection, options) {
	
	        var handlers = pageCol._handlers;
	        _each(_keys(handlers), function (event) {
	          var handler = handlers[event];
	          pageCol.off(event, handler);
	          fullCol.off(event, handler);
	        });
	
	        var state = _clone(pageCol.state);
	        var firstPage = state.firstPage;
	        var currentPage = firstPage === 0 ?
	          state.currentPage :
	          state.currentPage - 1;
	        var pageSize = state.pageSize;
	        var pageStart = currentPage * pageSize, pageEnd = pageStart + pageSize;
	
	        if (event == "add") {
	          var pageIndex, fullIndex, addAt, colToAdd, options = options || {};
	          if (collection == fullCol) {
	            fullIndex = fullCol.indexOf(model);
	            if (fullIndex >= pageStart && fullIndex < pageEnd) {
	              colToAdd = pageCol;
	              pageIndex = addAt = fullIndex - pageStart;
	            }
	          }
	          else {
	            pageIndex = pageCol.indexOf(model);
	            fullIndex = pageStart + pageIndex;
	            colToAdd = fullCol;
	            var addAt = !_isUndefined(options.at) ?
	              options.at + pageStart :
	              fullIndex;
	          }
	
	          if (!options.onRemove) {
	            ++state.totalRecords;
	            delete options.onRemove;
	          }
	
	          pageCol.state = pageCol._checkState(state);
	
	          if (colToAdd) {
	            colToAdd.add(model, _extend({}, options, {at: addAt}));
	            var modelToRemove = pageIndex >= pageSize ?
	              model :
	              !_isUndefined(options.at) && addAt < pageEnd && pageCol.length > pageSize ?
	              pageCol.at(pageSize) :
	              null;
	            if (modelToRemove) {
	              runOnceAtLastHandler(collection, event, function () {
	                pageCol.remove(modelToRemove, {onAdd: true});
	              });
	            }
	          }
	
	          if (!options.silent) pageCol.trigger("pageable:state:change", pageCol.state);
	        }
	
	        // remove the model from the other collection as well
	        if (event == "remove") {
	          if (!options.onAdd) {
	            // decrement totalRecords and update totalPages and lastPage
	            if (!--state.totalRecords) {
	              state.totalRecords = null;
	              state.totalPages = null;
	            }
	            else {
	              var totalPages = state.totalPages = ceil(state.totalRecords / pageSize);
	              state.lastPage = firstPage === 0 ? totalPages - 1 : totalPages || firstPage;
	              if (state.currentPage > totalPages) state.currentPage = state.lastPage;
	            }
	            pageCol.state = pageCol._checkState(state);
	
	            var nextModel, removedIndex = options.index;
	            if (collection == pageCol) {
	              if (nextModel = fullCol.at(pageEnd)) {
	                runOnceAtLastHandler(pageCol, event, function () {
	                  pageCol.push(nextModel, {onRemove: true});
	                });
	              }
	              else if (!pageCol.length && state.totalRecords) {
	                pageCol.reset(fullCol.models.slice(pageStart - pageSize, pageEnd - pageSize),
	                              _extend({}, options, {parse: false}));
	              }
	              fullCol.remove(model);
	            }
	            else if (removedIndex >= pageStart && removedIndex < pageEnd) {
	              if (nextModel = fullCol.at(pageEnd - 1)) {
	                runOnceAtLastHandler(pageCol, event, function () {
	                  pageCol.push(nextModel, {onRemove: true});
	                });
	              }
	              pageCol.remove(model);
	              if (!pageCol.length && state.totalRecords) {
	                pageCol.reset(fullCol.models.slice(pageStart - pageSize, pageEnd - pageSize),
	                              _extend({}, options, {parse: false}));
	              }
	            }
	          }
	          else delete options.onAdd;
	
	          if (!options.silent) pageCol.trigger("pageable:state:change", pageCol.state);
	        }
	
	        if (event == "reset") {
	          options = collection;
	          collection = model;
	
	          // Reset that's not a result of getPage
	          if (collection == pageCol && options.from == null &&
	              options.to == null) {
	            var head = fullCol.models.slice(0, pageStart);
	            var tail = fullCol.models.slice(pageStart + pageCol.models.length);
	            fullCol.reset(head.concat(pageCol.models).concat(tail), options);
	          }
	          else if (collection == fullCol) {
	            if (!(state.totalRecords = fullCol.models.length)) {
	              state.totalRecords = null;
	              state.totalPages = null;
	            }
	            if (pageCol.mode == "client") {
	              firstPage = state.lastPage = state.currentPage = state.firstPage;
	              currentPage = firstPage === 0 ? state.currentPage : state.currentPage - 1;
	              pageStart = currentPage * pageSize;
	              pageEnd = pageStart + pageSize;
	            }
	            pageCol.state = pageCol._checkState(state);
	            pageCol.reset(fullCol.models.slice(pageStart, pageEnd),
	                          _extend({}, options, {parse: false}));
	          }
	
	          if (!options.silent) pageCol.trigger("pageable:state:change", pageCol.state);
	        }
	
	        if (event == "sort") {
	          options = collection;
	          collection = model;
	          if (collection === fullCol) {
	            pageCol.reset(fullCol.models.slice(pageStart, pageEnd),
	                          _extend({}, options, {parse: false}));
	          }
	        }
	
	        _each(_keys(handlers), function (event) {
	          var handler = handlers[event];
	          _each([pageCol, fullCol], function (col) {
	            col.on(event, handler);
	            var callbacks = col._events[event] || [];
	            callbacks.unshift(callbacks.pop());
	          });
	        });
	      };
	    },
	
	    /**
	       Sanity check this collection's pagination states. Only perform checks
	       when all the required pagination state values are defined and not null.
	       If `totalPages` is undefined or null, it is set to `totalRecords` /
	       `pageSize`. `lastPage` is set according to whether `firstPage` is 0 or 1
	       when no error occurs.
	
	       @private
	
	       @param {Object} state
	
	       @throws {TypeError} If `totalRecords`, `pageSize`, `currentPage` or
	       `firstPage` is not a finite integer.
	
	       @throws {RangeError} If `pageSize`, `currentPage` or `firstPage` is out
	       of bounds.
	
	       @return {Object} Returns the `state` object if no error was found.
	    */
	    _checkState: function (state) {
	      var mode = this.mode;
	      var links = this.links;
	      var totalRecords = state.totalRecords;
	      var pageSize = state.pageSize;
	      var currentPage = state.currentPage;
	      var firstPage = state.firstPage;
	      var totalPages = state.totalPages;
	
	      if (totalRecords != null && pageSize != null && currentPage != null &&
	          firstPage != null && (mode == "infinite" ? links : true)) {
	
	        totalRecords = finiteInt(totalRecords, "totalRecords");
	        pageSize = finiteInt(pageSize, "pageSize");
	        currentPage = finiteInt(currentPage, "currentPage");
	        firstPage = finiteInt(firstPage, "firstPage");
	
	        if (pageSize < 1) {
	          throw new RangeError("`pageSize` must be >= 1");
	        }
	
	        totalPages = state.totalPages = ceil(totalRecords / pageSize);
	
	        if (firstPage < 0 || firstPage > 1) {
	          throw new RangeError("`firstPage must be 0 or 1`");
	        }
	
	        state.lastPage = firstPage === 0 ? max(0, totalPages - 1) : totalPages || firstPage;
	
	        if (mode == "infinite") {
	          if (!links[currentPage]) {
	            throw new RangeError("No link found for page " + currentPage);
	          }
	        }
	        else if (currentPage < firstPage ||
	                 (totalPages > 0 &&
	                  (firstPage ? currentPage > totalPages : currentPage >= totalPages))) {
	          throw new RangeError("`currentPage` must be firstPage <= currentPage " +
	                               (firstPage ? "<" : "<=") +
	                               " totalPages if " + firstPage + "-based. Got " +
	                               currentPage + ".");
	        }
	      }
	
	      return state;
	    },
	
	    /**
	       Change the page size of this collection.
	
	       Under most if not all circumstances, you should call this method to
	       change the page size of a pageable collection because it will keep the
	       pagination state sane. By default, the method will recalculate the
	       current page number to one that will retain the current page's models
	       when increasing the page size. When decreasing the page size, this method
	       will retain the last models to the current page that will fit into the
	       smaller page size.
	
	       If `options.first` is true, changing the page size will also reset the
	       current page back to the first page instead of trying to be smart.
	
	       For server mode operations, changing the page size will trigger a
	       PageableCollection#fetch and subsequently a `reset` event.
	
	       For client mode operations, changing the page size will `reset` the
	       current page by recalculating the current page boundary on the client
	       side.
	
	       If `options.fetch` is true, a fetch can be forced if the collection is in
	       client mode.
	
	       @param {number} pageSize - The new page size to set to PageableCollection#state.
	       @param {Object} options - {@link PageableCollection#fetch} options.
	       @param {boolean} options.first = false 0 Reset the current page number to
	       the first page if `true`.
	       @param {boolean} options.fetch - If `true`, force a fetch in client mode.
	
	       @throws {TypeError} If `pageSize` is not a finite integer.
	       @throws {RangeError} If `pageSize` is less than 1.
	
	       @chainable
	       @return {XMLHttpRequest|PageableCollection} The XMLHttpRequest
	       from fetch or this.
	    */
	    setPageSize: function (pageSize, options) {
	      pageSize = finiteInt(pageSize, "pageSize");
	
	      options = options || {first: false};
	
	      var state = this.state;
	      var totalPages = ceil(state.totalRecords / pageSize);
	      var currentPage = totalPages ?
	          max(state.firstPage, floor(totalPages * state.currentPage / state.totalPages)) :
	        state.firstPage;
	
	      state = this.state = this._checkState(_extend({}, state, {
	        pageSize: pageSize,
	        currentPage: options.first ? state.firstPage : currentPage,
	        totalPages: totalPages
	      }));
	
	      return this.getPage(state.currentPage, _omit(options, ["first"]));
	    },
	
	    /**
	       Switching between client, server and infinite mode.
	
	       If switching from client to server mode, the #fullCollection is emptied
	       first and then deleted and a fetch is immediately issued for the current
	       page from the server. Pass `false` to `options.fetch` to skip fetching.
	
	       If switching to infinite mode, and if `options.models` is given for an
	       array of models,PageableCollection#links will be populated with a URL per
	       page, using the default URL for this collection.
	
	       If switching from server to client mode, all of the pages are immediately
	       refetched. If you have too many pages, you can pass `false` to
	       `options.fetch` to skip fetching.
	
	       If switching to any mode from infinite mode, thePageableCollection#links
	       will be deleted.
	
	       @fires PageableCollection#pageable:state:change
	
	       @param {"server"|"client"|"infinite"} mode - The mode to switch to.
	
	       @param {Object} options
	
	       @param {boolean} options.fetch = true - If `false`, no fetching is done.
	
	       @param {boolean} options.resetState = true - If 'false', the state is not
	       reset, but checked for sanity instead.
	
	       @chainable
	       @return {XMLHttpRequest|PageableCollection} The XMLHttpRequest
	       from fetch or this if `options.fetch` is `false`.
	    */
	    switchMode: function (mode, options) {
	
	      if (!_contains(["server", "client", "infinite"], mode)) {
	        throw new TypeError('`mode` must be one of "server", "client" or "infinite"');
	      }
	
	      options = options || {fetch: true, resetState: true};
	
	      var state = this.state = options.resetState ?
	        _clone(this._initState) :
	        this._checkState(_extend({}, this.state));
	
	      this.mode = mode;
	
	      var self = this;
	      var fullCollection = this.fullCollection;
	      var handlers = this._handlers = this._handlers || {}, handler;
	      if (mode != "server" && !fullCollection) {
	        fullCollection = this._makeFullCollection(options.models || [], options);
	        fullCollection.pageableCollection = this;
	        this.fullCollection = fullCollection;
	        var allHandler = this._makeCollectionEventHandler(this, fullCollection);
	        _each(["add", "remove", "reset", "sort"], function (event) {
	          handlers[event] = handler = _.bind(allHandler, {}, event);
	          self.on(event, handler);
	          fullCollection.on(event, handler);
	        });
	        fullCollection.comparator = this._fullComparator;
	      }
	      else if (mode == "server" && fullCollection) {
	        _each(_keys(handlers), function (event) {
	          handler = handlers[event];
	          self.off(event, handler);
	          fullCollection.off(event, handler);
	        });
	        delete this._handlers;
	        this._fullComparator = fullCollection.comparator;
	        delete this.fullCollection;
	      }
	
	      if (mode == "infinite") {
	        var links = this.links = {};
	        var firstPage = state.firstPage;
	        var totalPages = ceil(state.totalRecords / state.pageSize);
	        var lastPage = firstPage === 0 ? max(0, totalPages - 1) : totalPages || firstPage;
	        for (var i = state.firstPage; i <= lastPage; i++) {
	          links[i] = this.url;
	        }
	      }
	      else if (this.links) delete this.links;
	
	      if (!options.silent) this.trigger("pageable:state:change", state);
	
	      return options.fetch ?
	        this.fetch(_omit(options, "fetch", "resetState")) :
	        this;
	    },
	
	    /**
	       @return {boolean} `true` if this collection can page backward, `false`
	       otherwise.
	    */
	    hasPreviousPage: function () {
	      var state = this.state;
	      var currentPage = state.currentPage;
	      if (this.mode != "infinite") return currentPage > state.firstPage;
	      return !!this.links[currentPage - 1];
	    },
	
	    /**
	       @return {boolean} `true` if this collection can page forward, `false`
	       otherwise.
	    */
	    hasNextPage: function () {
	      var state = this.state;
	      var currentPage = this.state.currentPage;
	      if (this.mode != "infinite") return currentPage < state.lastPage;
	      return !!this.links[currentPage + 1];
	    },
	
	    /**
	       Fetch the first page in server mode, or reset the current page of this
	       collection to the first page in client or infinite mode.
	
	       @param {Object} options {@linkPageableCollection#getPage} options.
	
	       @chainable
	       @return {XMLHttpRequest|PageableCollection} The XMLHttpRequest
	       from fetch or this.
	    */
	    getFirstPage: function (options) {
	      return this.getPage("first", options);
	    },
	
	    /**
	       Fetch the previous page in server mode, or reset the current page of this
	       collection to the previous page in client or infinite mode.
	
	       @param {Object} options {@linkPageableCollection#getPage} options.
	
	       @chainable
	       @return {XMLHttpRequest|PageableCollection} The XMLHttpRequest
	       from fetch or this.
	    */
	    getPreviousPage: function (options) {
	      return this.getPage("prev", options);
	    },
	
	    /**
	       Fetch the next page in server mode, or reset the current page of this
	       collection to the next page in client mode.
	
	       @param {Object} options {@linkPageableCollection#getPage} options.
	
	       @chainable
	       @return {XMLHttpRequest|PageableCollection} The XMLHttpRequest
	       from fetch or this.
	    */
	    getNextPage: function (options) {
	      return this.getPage("next", options);
	    },
	
	    /**
	       Fetch the last page in server mode, or reset the current page of this
	       collection to the last page in client mode.
	
	       @param {Object} options {@linkPageableCollection#getPage} options.
	
	       @chainable
	       @return {XMLHttpRequest|PageableCollection} The XMLHttpRequest
	       from fetch or this.
	    */
	    getLastPage: function (options) {
	      return this.getPage("last", options);
	    },
	
	    /**
	       Given a page index, set PageableCollection#state.currentPage to that
	       index. If this collection is in server mode, fetch the page using the
	       updated state, otherwise, reset the current page of this collection to
	       the page specified by `index` in client mode. If `options.fetch` is true,
	       a fetch can be forced in client mode before resetting the current
	       page. Under infinite mode, if the index is less than the current page, a
	       reset is done as in client mode. If the index is greater than the current
	       page number, a fetch is made with the results **appended**
	       toPageableCollection#fullCollection.  The current page will then be reset
	       after fetching.
	
	       @fires PageableCollection#pageable:state:change
	
	       @param {number|string} index - The page index to go to, or the page name to
	       look up fromPageableCollection#links in infinite mode.
	       @param {Object} options - {@linkPageableCollection#fetch} options or
	       [reset](http://backbonejs.org/#Collection-reset) options for client mode
	       when `options.fetch` is `false`.
	       @param {boolean} options.fetch = false - If true, force a
	       {@linkPageableCollection#fetch} in client mode.
	
	       @throws {TypeError} If `index` is not a finite integer under server or
	       client mode, or does not yield a URL fromPageableCollection#links under
	       infinite mode.
	
	       @throws {RangeError} If `index` is out of bounds.
	
	       @chainable
	       @return {XMLHttpRequest|PageableCollection} The XMLHttpRequest
	       from fetch or this.
	    */
	    getPage: function (index, options) {
	
	      var mode = this.mode, fullCollection = this.fullCollection;
	
	      options = options || {fetch: false};
	
	      var state = this.state,
	      firstPage = state.firstPage,
	      currentPage = state.currentPage,
	      lastPage = state.lastPage,
	      pageSize = state.pageSize;
	
	      var pageNum = index;
	      switch (index) {
	        case "first": pageNum = firstPage; break;
	        case "prev": pageNum = currentPage - 1; break;
	        case "next": pageNum = currentPage + 1; break;
	        case "last": pageNum = lastPage; break;
	        default: pageNum = finiteInt(index, "index");
	      }
	
	      this.state = this._checkState(_extend({}, state, {currentPage: pageNum}));
	      if (!options.silent) this.trigger("pageable:state:change", this.state);
	
	      options.from = currentPage, options.to = pageNum;
	
	      var pageStart = (firstPage === 0 ? pageNum : pageNum - 1) * pageSize;
	      var pageModels = fullCollection && fullCollection.length ?
	        fullCollection.models.slice(pageStart, pageStart + pageSize) :
	        [];
	      if ((mode == "client" || (mode == "infinite" && !_isEmpty(pageModels))) &&
	          !options.fetch) {
	        this.reset(pageModels, _omit(options, "fetch"));
	        return this;
	      }
	
	      if (mode == "infinite") options.url = this.links[pageNum];
	
	      return this.fetch(_omit(options, "fetch"));
	    },
	
	    /**
	       Fetch the page for the provided item offset in server mode, or reset the
	       current page of this collection to the page for the provided item offset
	       in client mode.
	
	       @param {number} offset
	       @param {Object} options {@linkPageableCollection#getPage} options.
	
	       @chainable
	       @return {XMLHttpRequest|PageableCollection} The XMLHttpRequest
	       from fetch or this.
	    */
	    getPageByOffset: function (offset, options) {
	      if (offset < 0) {
	        throw new RangeError("`offset must be > 0`");
	      }
	      offset = finiteInt(offset, "offset");
	
	      var page = floor(offset / this.state.pageSize);
	      if (this.state.firstPage !== 0) page++;
	      if (page > this.state.lastPage) page = this.state.lastPage;
	      return this.getPage(page, options);
	    },
	
	    /**
	       Overidden to make `getPage` compatible with Zepto.
	
	       @param {string} method
	       @param {Backbone.Model|Backbone.Collection} model
	       @param {Object} options
	
	       @return {XMLHttpRequest}
	    */
	    sync: function (method, model, options) {
	      var self = this;
	      if (self.mode == "infinite") {
	        var success = options.success;
	        var currentPage = self.state.currentPage;
	        options.success = function (resp, status, xhr) {
	          var links = self.links;
	          var newLinks = self.parseLinks(resp, _extend({xhr: xhr}, options));
	          if (newLinks.first) links[self.state.firstPage] = newLinks.first;
	          if (newLinks.prev) links[currentPage - 1] = newLinks.prev;
	          if (newLinks.next) links[currentPage + 1] = newLinks.next;
	          if (success) success(resp, status, xhr);
	        };
	      }
	
	      return (BBColProto.sync || Backbone.sync).call(self, method, model, options);
	    },
	
	    /**
	       Parse pagination links from the server response. Only valid under
	       infinite mode.
	
	       Given a response body and a XMLHttpRequest object, extract pagination
	       links from them for infinite paging.
	
	       This default implementation parses the RFC 5988 `Link` header and extract
	       3 links from it - `first`, `prev`, `next`. Any subclasses overriding this
	       method __must__ return an object hash having only the keys
	       above. However, simply returning a `next` link or an empty hash if there
	       are no more links should be enough for most implementations.
	
	       @param {*} resp The deserialized response body.
	       @param {Object} options
	       @param {XMLHttpRequest} options.xhr - The XMLHttpRequest object for this
	       response.
	       @return {Object}
	    */
	    parseLinks: function (resp, options) {
	      var links = {};
	      var linkHeader = options.xhr.getResponseHeader("Link");
	      if (linkHeader) {
	        var relations = ["first", "prev", "next"];
	        _each(linkHeader.split(","), function (linkValue) {
	          var linkParts = linkValue.split(";");
	          var url = linkParts[0].replace(URL_TRIM_RE, "");
	          var params = linkParts.slice(1);
	          _each(params, function (param) {
	            var paramParts = param.split("=");
	            var key = paramParts[0].replace(PARAM_TRIM_RE, "");
	            var value = paramParts[1].replace(PARAM_TRIM_RE, "");
	            if (key == "rel" && _contains(relations, value)) links[value] = url;
	          });
	        });
	      }
	
	      return links;
	    },
	
	    /**
	       Parse server response data.
	
	       This default implementation assumes the response data is in one of two
	       structures:
	
	           [
	             {}, // Your new pagination state
	             [{}, ...] // An array of JSON objects
	           ]
	
	       Or,
	
	           [{}] // An array of JSON objects
	
	       The first structure is the preferred form because the pagination states
	       may have been updated on the server side, sending them down again allows
	       this collection to update its states. If the response has a pagination
	       state object, it is checked for errors.
	
	       The second structure is the
	       [Backbone.Collection#parse](http://backbonejs.org/#Collection-parse)
	       default.
	
	       **Note:** this method has been further simplified since 1.1.7. While
	       existingPageableCollection#parse implementations will continue to work,
	       new code is encouraged to overridePageableCollection#parseState
	       andPageableCollection#parseRecords instead.
	
	       @fires PageableCollection#pageable:state:change
	
	       @param {Object} resp The deserialized response data from the server.
	       @param {Object} options The options for the ajax request
	
	       @return {Array.<Object>} An array of model objects
	    */
	    parse: function (resp, options) {
	      var newState = this.parseState(resp, _clone(this.queryParams), _clone(this.state), options);
	      if (newState) {
	        this.state = this._checkState(_extend({}, this.state, newState));
	        if (!(options || {}).silent) this.trigger("pageable:state:change", this.state);
	      }
	      return this.parseRecords(resp, options);
	    },
	
	    /**
	       Parse server response for server pagination state updates. Not applicable
	       under infinite mode.
	
	       This default implementation first checks whether the response has any
	       state object as documented inPageableCollection#parse. If it exists, a
	       state object is returned by mapping the server state keys to this
	       pageable collection instance's query parameter keys using `queryParams`.
	
	       It is __NOT__ neccessary to return a full state object complete with all
	       the mappings defined inPageableCollection#queryParams. Any state object
	       resulted is merged with a copy of the current pageable collection state
	       and checked for sanity before actually updating. Most of the time, simply
	       providing a new `totalRecords` value is enough to trigger a full
	       pagination state recalculation.
	
	           parseState: function (resp, queryParams, state, options) {
	             return {totalRecords: resp.total_entries};
	           }
	
	       If you want to use header fields use:
	
	           parseState: function (resp, queryParams, state, options) {
	               return {totalRecords: options.xhr.getResponseHeader("X-total")};
	           }
	
	       This method __MUST__ return a new state object instead of directly
	       modifying the PageableCollection#state object. The behavior of directly
	       modifying PageableCollection#state is undefined.
	
	       @param {Object} resp - The deserialized response data from the server.
	       @param {Object} queryParams - A copy of PageableCollection#queryParams.
	       @param {Object} state - A copy of PageableCollection#state.
	       @param {Object} options - The options passed through from
	       `parse`. (backbone >= 0.9.10 only)
	
	       @return {Object} A new (partial) state object.
	     */
	    parseState: function (resp, queryParams, state, options) {
	      if (resp && resp.length === 2 && _isObject(resp[0]) && _isArray(resp[1])) {
	
	        var newState = _clone(state);
	        var serverState = resp[0];
	
	        _each(_pairs(_omit(queryParams, "directions")), function (kvp) {
	          var k = kvp[0], v = kvp[1];
	          var serverVal = serverState[v];
	          if (!_isUndefined(serverVal) && !_.isNull(serverVal)) newState[k] = serverState[v];
	        });
	
	        if (serverState.order) {
	          newState.order = _invert(queryParams.directions)[serverState.order] * 1;
	        }
	
	        return newState;
	      }
	    },
	
	    /**
	       Parse server response for an array of model objects.
	
	       This default implementation first checks whether the response has any
	       state object as documented inPageableCollection#parse. If it exists, the
	       array of model objects is assumed to be the second element, otherwise the
	       entire response is returned directly.
	
	       @param {Object} resp - The deserialized response data from the server.
	       @param {Object} options - The options passed through from the
	       `parse`. (backbone >= 0.9.10 only)
	
	       @return {Array.<Object>} An array of model objects
	     */
	    parseRecords: function (resp, options) {
	      if (resp && resp.length === 2 && _isObject(resp[0]) && _isArray(resp[1])) {
	        return resp[1];
	      }
	
	      return resp;
	    },
	
	    /**
	       Fetch a page from the server in server mode, or all the pages in client
	       mode. Under infinite mode, the current page is refetched by default and
	       then reset.
	
	       The query string is constructed by translating the current pagination
	       state to your server API query parameter
	       usingPageableCollection#queryParams. The current page will reset after
	       fetch.
	
	       @param {Object} options - Accepts all
	       [Backbone.Collection#fetch](http://backbonejs.org/#Collection-fetch)
	       options.
	
	       @return {XMLHttpRequest}
	    */
	    fetch: function (options) {
	
	      options = options || {};
	
	      var state = this._checkState(this.state);
	
	      var mode = this.mode;
	
	      if (mode == "infinite" && !options.url) {
	        options.url = this.links[state.currentPage];
	      }
	
	      var data = options.data || {};
	
	      // dedup query params
	      var url = options.url || this.url || "";
	      if (_isFunction(url)) url = url.call(this);
	      var qsi = url.indexOf("?");
	      if (qsi != -1) {
	        _extend(data, queryStringToParams(url.slice(qsi + 1)));
	        url = url.slice(0, qsi);
	      }
	
	      options.url = url;
	      options.data = data;
	
	      // pick the appropriate query param keys to map according to the mode
	      var queryParams = this.mode == "client" ?
	          _pick(this.queryParams, "sortKey") :
	          _omit(_pick(this.queryParams, _keys(PageableProto.queryParams)),
	                "order", "directions", "totalPages", "totalRecords");
	
	      // map the query params to the data object used by the underlying ajax lib
	      // to construct the query string
	      _each(queryParams, function (v, k) {
	        v = _isFunction(v) ? v.call(this) : v;
	        if (state[k] != null && v != null && _.isUndefined(data[v])) {
	          data[v] = state[k];
	        }
	      }, this);
	
	      var sortKey = _isFunction(this.queryParams.sortKey) ?
	          this.queryParams.sortKey.call(this) :
	          this.queryParams.sortKey;
	
	      var order = _isFunction(this.queryParams.order) ?
	          this.queryParams.order.call(this) :
	          this.queryParams.order;
	
	      if (sortKey != null && state.sortKey != null &&
	          order != null && state.order != null) {
	        if (_isArray(state.order)) {
	          data[order] = [];
	          for (var i = 0; i < state.order.length; i++) {
	            data[order].push(this.queryParams.directions[state.order[i]]);
	          }
	        }
	        else {
	          data[order] = this.queryParams.directions[state.order + ""];
	        }
	      }
	
	      // map extra query parameters
	      var extraKvps = _pairs(_omit(this.queryParams,
	                                   _keys(PageableProto.queryParams)));
	      for (var i = 0; i < extraKvps.length; i++) {
	        var kvp = extraKvps[i];
	        var v = kvp[1];
	        v = _isFunction(v) ? v.call(this) : v;
	        if (v != null) data[kvp[0]] = v;
	      }
	
	      if (mode != "server") {
	        var self = this, fullCol = this.fullCollection;
	        var success = options.success;
	        options.success = function (col, resp, opts) {
	
	          // make sure the caller's intent is obeyed
	          opts = opts || {};
	          if (_isUndefined(options.silent)) delete opts.silent;
	          else opts.silent = options.silent;
	
	          var models = col.models;
	          if (mode == "client") fullCol.reset(models, opts);
	          else {
	            fullCol.add(models, _extend({at: fullCol.length},
	                                        _extend(opts, {parse: false})));
	            self.trigger("reset", self, opts);
	          }
	
	          if (success) success(col, resp, opts);
	        };
	
	        // silent the first reset from backbone
	        return BBColProto.fetch.call(this, _extend({}, options, {silent: true}));
	      }
	
	      return BBColProto.fetch.call(this, options);
	    },
	
	    /**
	       Convenient method for making a `comparator` sorted by a model attribute
	       identified by `sortKey` and ordered by `order`.
	
	       Like a Backbone.Collection, a PageableCollection will maintain the
	       __current page__ in sorted order on the client side if a `comparator` is
	       attached to it. If the collection is in client mode, you can attach a
	       comparator toPageableCollection#fullCollection to have all the pages
	       reflect the global sorting order by specifying an option `full` to
	       `true`. You __must__ call `sort` manually
	       orPageableCollection#fullCollection.sort after calling this method to
	       force a resort.
	
	       While you can use this method to sort the current page in server mode,
	       the sorting order may not reflect the global sorting order due to the
	       additions or removals of the records on the server since the last
	       fetch. If you want the most updated page in a global sorting order, it is
	       recommended that you set PageableCollection#state.sortKey and optionally
	       PageableCollection#state.order, and then callPageableCollection#fetch.
	
	       @protected
	
	       @param {string} sortKey = this.state.sortKey - See `state.sortKey`.
	       @param {number} order = this.state.order - See `state.order`.
	       @param {(function(Backbone.Model, string): Object) | string} sortValue -
	       See PageableCollection#setSorting.
	
	       @return {function(Backbone.Model, string): number}
	
	       See [Backbone.Collection.comparator](http://backbonejs.org/#Collection-comparator).
	    */
	    _makeComparator: function (sortKey, order, sortValue) {
	      var state = this.state;
	
	      sortKey = sortKey || state.sortKey;
	      order = order || state.order;
	
	      if (!sortKey || !order) return;
	
	      if (!sortValue) {
	        sortValue = function (model, attr) {
	          return model.get(attr);
	        };
	      }
	
	      return function (left, right) {
	        var l = sortValue(left, sortKey), r = sortValue(right, sortKey), t;
	        if (order === 1) t = l, l = r, r = t;
	        if (l === r) return 0;
	        else if (l < r) return -1;
	        return 1;
	      };
	    },
	
	    /**
	       Adjusts the sorting for this pageable collection.
	
	       Given a `sortKey` and an `order`, sets `state.sortKey` and
	       `state.order`. A comparator can be applied on the client side to sort in
	       the order defined if `options.side` is `"client"`. By default the
	       comparator is applied to thePageableCollection#fullCollection. Set
	       `options.full` to `false` to apply a comparator to the current page under
	       any mode. Setting `sortKey` to `null` removes the comparator from both
	       the current page and the full collection.
	
	       If a `sortValue` function is given, it will be passed the `(model,
	       sortKey)` arguments and is used to extract a value from the model during
	       comparison sorts. If `sortValue` is not given, `model.get(sortKey)` is
	       used for sorting.
	
	       @chainable
	
	       @param {string} sortKey - See `state.sortKey`.
	       @param {number} order=this.state.order - See `state.order`.
	       @param {Object} options
	       @param {string} options.side - By default, `"client"` if `mode` is
	       `"client"`, `"server"` otherwise.
	       @param {boolean} options.full = true
	       @param {(function(Backbone.Model, string): Object) | string} options.sortValue
	
	       @return {PageableCollection} this
	    */
	    setSorting: function (sortKey, order, options) {
	
	      var state = this.state;
	
	      state.sortKey = sortKey;
	      state.order = order = order || state.order;
	
	      var fullCollection = this.fullCollection;
	
	      var delComp = false, delFullComp = false;
	
	      if (!sortKey) delComp = delFullComp = true;
	
	      var mode = this.mode;
	      options = _extend({side: mode == "client" ? mode : "server", full: true},
	                        options);
	
	      var comparator = this._makeComparator(sortKey, order, options.sortValue);
	
	      var full = options.full, side = options.side;
	
	      if (side == "client") {
	        if (full) {
	          if (fullCollection) fullCollection.comparator = comparator;
	          delComp = true;
	        }
	        else {
	          this.comparator = comparator;
	          delFullComp = true;
	        }
	      }
	      else if (side == "server" && !full) {
	        this.comparator = comparator;
	      }
	
	      if (delComp) this.comparator = null;
	      if (delFullComp && fullCollection) fullCollection.comparator = null;
	
	      return this;
	    }
	
	  });
	
	  var PageableProto = PageableCollection.prototype;
	
	  return PageableCollection;
	
	}));


/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// Backbone.Radio v2.0.0
	
	(function (global, factory) {
	   true ? module.exports = factory(__webpack_require__(__webpack_module_template_argument_0__), __webpack_require__(__webpack_module_template_argument_1__)) :
	  typeof define === 'function' && define.amd ? define(['underscore', 'backbone'], factory) :
	  (global.Backbone = global.Backbone || {}, global.Backbone.Radio = factory(global._,global.Backbone));
	}(this, function (_,Backbone) { 'use strict';
	
	  _ = 'default' in _ ? _['default'] : _;
	  Backbone = 'default' in Backbone ? Backbone['default'] : Backbone;
	
	  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	  };
	
	  var previousRadio = Backbone.Radio;
	
	  var Radio = Backbone.Radio = {};
	
	  Radio.VERSION = '2.0.0';
	
	  // This allows you to run multiple instances of Radio on the same
	  // webapp. After loading the new version, call `noConflict()` to
	  // get a reference to it. At the same time the old version will be
	  // returned to Backbone.Radio.
	  Radio.noConflict = function () {
	    Backbone.Radio = previousRadio;
	    return this;
	  };
	
	  // Whether or not we're in DEBUG mode or not. DEBUG mode helps you
	  // get around the issues of lack of warnings when events are mis-typed.
	  Radio.DEBUG = false;
	
	  // Format debug text.
	  Radio._debugText = function (warning, eventName, channelName) {
	    return warning + (channelName ? ' on the ' + channelName + ' channel' : '') + ': "' + eventName + '"';
	  };
	
	  // This is the method that's called when an unregistered event was called.
	  // By default, it logs warning to the console. By overriding this you could
	  // make it throw an Error, for instance. This would make firing a nonexistent event
	  // have the same consequence as firing a nonexistent method on an Object.
	  Radio.debugLog = function (warning, eventName, channelName) {
	    if (Radio.DEBUG && console && console.warn) {
	      console.warn(Radio._debugText(warning, eventName, channelName));
	    }
	  };
	
	  var eventSplitter = /\s+/;
	
	  // An internal method used to handle Radio's method overloading for Requests.
	  // It's borrowed from Backbone.Events. It differs from Backbone's overload
	  // API (which is used in Backbone.Events) in that it doesn't support space-separated
	  // event names.
	  Radio._eventsApi = function (obj, action, name, rest) {
	    if (!name) {
	      return false;
	    }
	
	    var results = {};
	
	    // Handle event maps.
	    if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	      for (var key in name) {
	        var result = obj[action].apply(obj, [key, name[key]].concat(rest));
	        eventSplitter.test(key) ? _.extend(results, result) : results[key] = result;
	      }
	      return results;
	    }
	
	    // Handle space separated event names.
	    if (eventSplitter.test(name)) {
	      var names = name.split(eventSplitter);
	      for (var i = 0, l = names.length; i < l; i++) {
	        results[names[i]] = obj[action].apply(obj, [names[i]].concat(rest));
	      }
	      return results;
	    }
	
	    return false;
	  };
	
	  // An optimized way to execute callbacks.
	  Radio._callHandler = function (callback, context, args) {
	    var a1 = args[0],
	        a2 = args[1],
	        a3 = args[2];
	    switch (args.length) {
	      case 0:
	        return callback.call(context);
	      case 1:
	        return callback.call(context, a1);
	      case 2:
	        return callback.call(context, a1, a2);
	      case 3:
	        return callback.call(context, a1, a2, a3);
	      default:
	        return callback.apply(context, args);
	    }
	  };
	
	  // A helper used by `off` methods to the handler from the store
	  function removeHandler(store, name, callback, context) {
	    var event = store[name];
	    if ((!callback || callback === event.callback || callback === event.callback._callback) && (!context || context === event.context)) {
	      delete store[name];
	      return true;
	    }
	  }
	
	  function removeHandlers(store, name, callback, context) {
	    store || (store = {});
	    var names = name ? [name] : _.keys(store);
	    var matched = false;
	
	    for (var i = 0, length = names.length; i < length; i++) {
	      name = names[i];
	
	      // If there's no event by this name, log it and continue
	      // with the loop
	      if (!store[name]) {
	        continue;
	      }
	
	      if (removeHandler(store, name, callback, context)) {
	        matched = true;
	      }
	    }
	
	    return matched;
	  }
	
	  /*
	   * tune-in
	   * -------
	   * Get console logs of a channel's activity
	   *
	   */
	
	  var _logs = {};
	
	  // This is to produce an identical function in both tuneIn and tuneOut,
	  // so that Backbone.Events unregisters it.
	  function _partial(channelName) {
	    return _logs[channelName] || (_logs[channelName] = _.bind(Radio.log, Radio, channelName));
	  }
	
	  _.extend(Radio, {
	
	    // Log information about the channel and event
	    log: function log(channelName, eventName) {
	      if (typeof console === 'undefined') {
	        return;
	      }
	      var args = _.toArray(arguments).slice(2);
	      console.log('[' + channelName + '] "' + eventName + '"', args);
	    },
	
	    // Logs all events on this channel to the console. It sets an
	    // internal value on the channel telling it we're listening,
	    // then sets a listener on the Backbone.Events
	    tuneIn: function tuneIn(channelName) {
	      var channel = Radio.channel(channelName);
	      channel._tunedIn = true;
	      channel.on('all', _partial(channelName));
	      return this;
	    },
	
	    // Stop logging all of the activities on this channel to the console
	    tuneOut: function tuneOut(channelName) {
	      var channel = Radio.channel(channelName);
	      channel._tunedIn = false;
	      channel.off('all', _partial(channelName));
	      delete _logs[channelName];
	      return this;
	    }
	  });
	
	  /*
	   * Backbone.Radio.Requests
	   * -----------------------
	   * A messaging system for requesting data.
	   *
	   */
	
	  function makeCallback(callback) {
	    return _.isFunction(callback) ? callback : function () {
	      return callback;
	    };
	  }
	
	  Radio.Requests = {
	
	    // Make a request
	    request: function request(name) {
	      var args = _.toArray(arguments).slice(1);
	      var results = Radio._eventsApi(this, 'request', name, args);
	      if (results) {
	        return results;
	      }
	      var channelName = this.channelName;
	      var requests = this._requests;
	
	      // Check if we should log the request, and if so, do it
	      if (channelName && this._tunedIn) {
	        Radio.log.apply(this, [channelName, name].concat(args));
	      }
	
	      // If the request isn't handled, log it in DEBUG mode and exit
	      if (requests && (requests[name] || requests['default'])) {
	        var handler = requests[name] || requests['default'];
	        args = requests[name] ? args : arguments;
	        return Radio._callHandler(handler.callback, handler.context, args);
	      } else {
	        Radio.debugLog('An unhandled request was fired', name, channelName);
	      }
	    },
	
	    // Set up a handler for a request
	    reply: function reply(name, callback, context) {
	      if (Radio._eventsApi(this, 'reply', name, [callback, context])) {
	        return this;
	      }
	
	      this._requests || (this._requests = {});
	
	      if (this._requests[name]) {
	        Radio.debugLog('A request was overwritten', name, this.channelName);
	      }
	
	      this._requests[name] = {
	        callback: makeCallback(callback),
	        context: context || this
	      };
	
	      return this;
	    },
	
	    // Set up a handler that can only be requested once
	    replyOnce: function replyOnce(name, callback, context) {
	      if (Radio._eventsApi(this, 'replyOnce', name, [callback, context])) {
	        return this;
	      }
	
	      var self = this;
	
	      var once = _.once(function () {
	        self.stopReplying(name);
	        return makeCallback(callback).apply(this, arguments);
	      });
	
	      return this.reply(name, once, context);
	    },
	
	    // Remove handler(s)
	    stopReplying: function stopReplying(name, callback, context) {
	      if (Radio._eventsApi(this, 'stopReplying', name)) {
	        return this;
	      }
	
	      // Remove everything if there are no arguments passed
	      if (!name && !callback && !context) {
	        delete this._requests;
	      } else if (!removeHandlers(this._requests, name, callback, context)) {
	        Radio.debugLog('Attempted to remove the unregistered request', name, this.channelName);
	      }
	
	      return this;
	    }
	  };
	
	  /*
	   * Backbone.Radio.channel
	   * ----------------------
	   * Get a reference to a channel by name.
	   *
	   */
	
	  Radio._channels = {};
	
	  Radio.channel = function (channelName) {
	    if (!channelName) {
	      throw new Error('You must provide a name for the channel.');
	    }
	
	    if (Radio._channels[channelName]) {
	      return Radio._channels[channelName];
	    } else {
	      return Radio._channels[channelName] = new Radio.Channel(channelName);
	    }
	  };
	
	  /*
	   * Backbone.Radio.Channel
	   * ----------------------
	   * A Channel is an object that extends from Backbone.Events,
	   * and Radio.Requests.
	   *
	   */
	
	  Radio.Channel = function (channelName) {
	    this.channelName = channelName;
	  };
	
	  _.extend(Radio.Channel.prototype, Backbone.Events, Radio.Requests, {
	
	    // Remove all handlers from the messaging systems of this channel
	    reset: function reset() {
	      this.off();
	      this.stopListening();
	      this.stopReplying();
	      return this;
	    }
	  });
	
	  /*
	   * Top-level API
	   * -------------
	   * Supplies the 'top-level API' for working with Channels directly
	   * from Backbone.Radio.
	   *
	   */
	
	  var channel;
	  var args;
	  var systems = [Backbone.Events, Radio.Requests];
	  _.each(systems, function (system) {
	    _.each(system, function (method, methodName) {
	      Radio[methodName] = function (channelName) {
	        args = _.toArray(arguments).slice(1);
	        channel = this.channel(channelName);
	        return channel[methodName].apply(channel, args);
	      };
	    });
	  });
	
	  Radio.reset = function (channelName) {
	    var channels = !channelName ? this._channels : [this._channels[channelName]];
	    _.each(channels, function (channel) {
	      channel.reset();
	    });
	  };
	
	  return Radio;
	
	}));
	//# sourceMappingURL=./backbone.radio.js.map

/***/ },
/* 1957 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Backbone.Stickit v0.9.2, MIT Licensed
	// Copyright (c) 2012-2015 The New York Times, CMS Group, Matthew DeLambo <delambo@gmail.com>
	
	(function (factory) {
	
	  // Set up Stickit appropriately for the environment. Start with AMD.
	  if (true)
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [(__webpack_require__(__webpack_module_template_argument_0__)), (__webpack_require__(__webpack_module_template_argument_1__)), exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Next for Node.js or CommonJS.
	  else if (typeof exports === 'object')
	    factory(require('underscore'), require('backbone'), exports);
	
	  // Finally, as a browser global.
	  else
	    factory(_, Backbone, {});
	
	}(function (_, Backbone, Stickit) {
	
	  // Stickit Namespace
	  // --------------------------
	
	  // Export onto Backbone object
	  Backbone.Stickit = Stickit;
	
	  Stickit._handlers = [];
	
	  Stickit.addHandler = function(handlers) {
	    // Fill-in default values.
	    handlers = _.map(_.flatten([handlers]), function(handler) {
	      return _.defaults({}, handler, {
	        updateModel: true,
	        updateView: true,
	        updateMethod: 'text'
	      });
	    });
	    this._handlers = this._handlers.concat(handlers);
	  };
	
	  // Backbone.View Mixins
	  // --------------------
	
	  Stickit.ViewMixin = {
	
	    // Collection of model event bindings.
	    //   [{model,event,fn,config}, ...]
	    _modelBindings: null,
	
	    // Unbind the model and event bindings from `this._modelBindings` and
	    // `this.$el`. If the optional `model` parameter is defined, then only
	    // delete bindings for the given `model` and its corresponding view events.
	    unstickit: function(model, bindingSelector) {
	
	      // Support passing a bindings hash in place of bindingSelector.
	      if (_.isObject(bindingSelector)) {
	        _.each(bindingSelector, function(v, selector) {
	          this.unstickit(model, selector);
	        }, this);
	        return;
	      }
	
	      var models = [], destroyFns = [];
	      this._modelBindings = _.reject(this._modelBindings, function(binding) {
	        if (model && binding.model !== model) return;
	        if (bindingSelector && binding.config.selector != bindingSelector) return;
	
	        binding.model.off(binding.event, binding.fn);
	        destroyFns.push(binding.config._destroy);
	        models.push(binding.model);
	        return true;
	      });
	
	      // Trigger an event for each model that was unbound.
	      _.invoke(_.uniq(models), 'trigger', 'stickit:unstuck', this.cid);
	
	      // Call `_destroy` on a unique list of the binding callbacks.
	      _.each(_.uniq(destroyFns), function(fn) { fn.call(this); }, this);
	
	      this.$el.off('.stickit' + (model ? '.' + model.cid : ''), bindingSelector);
	    },
	
	    // Initilize Stickit bindings for the view. Subsequent binding additions
	    // can either call `stickit` with the new bindings, or add them directly
	    // with `addBinding`. Both arguments to `stickit` are optional.
	    stickit: function(optionalModel, optionalBindingsConfig) {
	      var model = optionalModel || this.model,
	          bindings = optionalBindingsConfig || _.result(this, "bindings") || {};
	
	      this._modelBindings || (this._modelBindings = []);
	
	      // Add bindings in bulk using `addBinding`.
	      this.addBinding(model, bindings);
	
	      // Wrap `view.remove` to unbind stickit model and dom events.
	      var remove = this.remove;
	      if (!remove.stickitWrapped) {
	        this.remove = function() {
	          var ret = this;
	          this.unstickit();
	          if (remove) ret = remove.apply(this, arguments);
	          return ret;
	        };
	      }
	      this.remove.stickitWrapped = true;
	      return this;
	    },
	
	    // Add a single Stickit binding or a hash of bindings to the model. If
	    // `optionalModel` is ommitted, will default to the view's `model` property.
	    addBinding: function(optionalModel, selector, binding) {
	      var model = optionalModel || this.model,
	          namespace = '.stickit.' + model.cid;
	
	      binding = binding || {};
	
	      // Support jQuery-style {key: val} event maps.
	      if (_.isObject(selector)) {
	        var bindings = selector;
	        _.each(bindings, function(val, key) {
	          this.addBinding(model, key, val);
	        }, this);
	        return;
	      }
	
	      // Special case the ':el' selector to use the view's this.$el.
	      var $el = selector === ':el' ? this.$el : this.$(selector);
	
	      // Clear any previous matching bindings.
	      this.unstickit(model, selector);
	
	      // Fail fast if the selector didn't match an element.
	      if (!$el.length) return;
	
	      // Allow shorthand setting of model attributes - `'selector':'observe'`.
	      if (_.isString(binding)) binding = {observe: binding};
	
	      // Handle case where `observe` is in the form of a function.
	      if (_.isFunction(binding.observe)) binding.observe = binding.observe.call(this);
	
	      // Find all matching Stickit handlers that could apply to this element
	      // and store in a config object.
	      var config = getConfiguration($el, binding);
	
	      // The attribute we're observing in our config.
	      var modelAttr = config.observe;
	
	      // Store needed properties for later.
	      config.selector = selector;
	      config.view = this;
	
	      // Create the model set options with a unique `bindId` so that we
	      // can avoid double-binding in the `change:attribute` event handler.
	      var bindId = config.bindId = _.uniqueId();
	
	      // Add a reference to the view for handlers of stickitChange events
	      var options = _.extend({stickitChange: config}, config.setOptions);
	
	      // Add a `_destroy` callback to the configuration, in case `destroy`
	      // is a named function and we need a unique function when unsticking.
	      config._destroy = function() {
	        applyViewFn.call(this, config.destroy, $el, model, config);
	      };
	
	      initializeAttributes($el, config, model, modelAttr);
	      initializeVisible($el, config, model, modelAttr);
	      initializeClasses($el, config, model, modelAttr);
	
	      if (modelAttr) {
	        // Setup one-way (input element -> model) bindings.
	        _.each(config.events, function(type) {
	          var eventName = type + namespace;
	          var listener = function(event) {
	            var val = applyViewFn.call(this, config.getVal, $el, event, config, slice.call(arguments, 1));
	
	            // Don't update the model if false is returned from the `updateModel` configuration.
	            var currentVal = evaluateBoolean(config.updateModel, val, event, config);
	            if (currentVal) setAttr(model, modelAttr, val, options, config);
	          };
	          var sel = selector === ':el'? '' : selector;
	          this.$el.on(eventName, sel, _.bind(listener, this));
	        }, this);
	
	        // Setup a `change:modelAttr` observer to keep the view element in sync.
	        // `modelAttr` may be an array of attributes or a single string value.
	        _.each(_.flatten([modelAttr]), function(attr) {
	          observeModelEvent(model, 'change:' + attr, config, function(m, val, options) {
	            var changeId = options && options.stickitChange && options.stickitChange.bindId;
	            if (changeId !== bindId) {
	              var currentVal = getAttr(model, modelAttr, config);
	              updateViewBindEl($el, config, currentVal, model);
	            }
	          });
	        });
	
	        var currentVal = getAttr(model, modelAttr, config);
	        updateViewBindEl($el, config, currentVal, model, true);
	      }
	
	      // After each binding is setup, call the `initialize` callback.
	      applyViewFn.call(this, config.initialize, $el, model, config);
	    }
	  };
	
	  _.extend(Backbone.View.prototype, Stickit.ViewMixin);
	
	  // Helpers
	  // -------
	
	  var slice = [].slice;
	
	  // Evaluates the given `path` (in object/dot-notation) relative to the given
	  // `obj`. If the path is null/undefined, then the given `obj` is returned.
	  var evaluatePath = function(obj, path) {
	    var parts = (path || '').split('.');
	    var result = _.reduce(parts, function(memo, i) { return memo[i]; }, obj);
	    return result == null ? obj : result;
	  };
	
	  // If the given `fn` is a string, then view[fn] is called, otherwise it is
	  // a function that should be executed.
	  var applyViewFn = function(fn) {
	    fn = _.isString(fn) ? evaluatePath(this, fn) : fn;
	    if (fn) return (fn).apply(this, slice.call(arguments, 1));
	  };
	
	  // Given a function, string (view function reference), or a boolean
	  // value, returns the truthy result. Any other types evaluate as false.
	  // The first argument must be `reference` and the last must be `config`, but
	  // middle arguments can be variadic.
	  var evaluateBoolean = function(reference, val, config) {
	    if (_.isBoolean(reference)) {
	      return reference;
	    } else if (_.isFunction(reference) || _.isString(reference)) {
	      var view = _.last(arguments).view;
	      return applyViewFn.apply(view, arguments);
	    }
	    return false;
	  };
	
	  // Setup a model event binding with the given function, and track the event
	  // in the view's _modelBindings.
	  var observeModelEvent = function(model, event, config, fn) {
	    var view = config.view;
	    model.on(event, fn, view);
	    view._modelBindings.push({model:model, event:event, fn:fn, config:config});
	  };
	
	  // Prepares the given `val`ue and sets it into the `model`.
	  var setAttr = function(model, attr, val, options, config) {
	    var value = {}, view = config.view;
	    if (config.onSet) {
	      val = applyViewFn.call(view, config.onSet, val, config);
	    }
	
	    if (config.set) {
	      applyViewFn.call(view, config.set, attr, val, options, config);
	    } else {
	      value[attr] = val;
	      // If `observe` is defined as an array and `onSet` returned
	      // an array, then map attributes to their values.
	      if (_.isArray(attr) && _.isArray(val)) {
	        value = _.reduce(attr, function(memo, attribute, index) {
	          memo[attribute] = _.has(val, index) ? val[index] : null;
	          return memo;
	        }, {});
	      }
	      model.set(value, options);
	    }
	  };
	
	  // Returns the given `attr`'s value from the `model`, escaping and
	  // formatting if necessary. If `attr` is an array, then an array of
	  // respective values will be returned.
	  var getAttr = function(model, attr, config) {
	    var view = config.view;
	    var retrieveVal = function(field) {
	      return model[config.escape ? 'escape' : 'get'](field);
	    };
	    var sanitizeVal = function(val) {
	      return val == null ? '' : val;
	    };
	    var val = _.isArray(attr) ? _.map(attr, retrieveVal) : retrieveVal(attr);
	    if (config.onGet) val = applyViewFn.call(view, config.onGet, val, config);
	    return _.isArray(val) ? _.map(val, sanitizeVal) : sanitizeVal(val);
	  };
	
	  // Find handlers in `Backbone.Stickit._handlers` with selectors that match
	  // `$el` and generate a configuration by mixing them in the order that they
	  // were found with the given `binding`.
	  var getConfiguration = Stickit.getConfiguration = function($el, binding) {
	    var handlers = [{
	      updateModel: false,
	      updateMethod: 'text',
	      update: function($el, val, m, opts) { if ($el[opts.updateMethod]) $el[opts.updateMethod](val); },
	      getVal: function($el, e, opts) { return $el[opts.updateMethod](); }
	    }];
	    handlers = handlers.concat(_.filter(Stickit._handlers, function(handler) {
	      return $el.is(handler.selector);
	    }));
	    handlers.push(binding);
	
	    // Merge handlers into a single config object. Last props in wins.
	    var config = _.extend.apply(_, handlers);
	
	    // `updateView` is defaulted to false for configutrations with
	    // `visible`; otherwise, `updateView` is defaulted to true.
	    if (!_.has(config, 'updateView')) config.updateView = !config.visible;
	    return config;
	  };
	
	  // Setup the attributes configuration - a list that maps an attribute or
	  // property `name`, to an `observe`d model attribute, using an optional
	  // `onGet` formatter.
	  //
	  //     attributes: [{
	  //       name: 'attributeOrPropertyName',
	  //       observe: 'modelAttrName'
	  //       onGet: function(modelAttrVal, modelAttrName) { ... }
	  //     }, ...]
	  //
	  var initializeAttributes = function($el, config, model, modelAttr) {
	    var props = ['autofocus', 'autoplay', 'async', 'checked', 'controls',
	      'defer', 'disabled', 'hidden', 'indeterminate', 'loop', 'multiple',
	      'open', 'readonly', 'required', 'scoped', 'selected'];
	
	    var view = config.view;
	
	    _.each(config.attributes || [], function(attrConfig) {
	      attrConfig = _.clone(attrConfig);
	      attrConfig.view = view;
	
	      var lastClass = '';
	      var observed = attrConfig.observe || (attrConfig.observe = modelAttr);
	      var updateAttr = function() {
	        var updateType = _.contains(props, attrConfig.name) ? 'prop' : 'attr',
	            val = getAttr(model, observed, attrConfig);
	
	        // If it is a class then we need to remove the last value and add the new.
	        if (attrConfig.name === 'class') {
	          $el.removeClass(lastClass).addClass(val);
	          lastClass = val;
	        } else {
	          $el[updateType](attrConfig.name, val);
	        }
	      };
	
	      _.each(_.flatten([observed]), function(attr) {
	        observeModelEvent(model, 'change:' + attr, config, updateAttr);
	      });
	
	      // Initialize the matched element's state.
	      updateAttr();
	    });
	  };
	
	  var initializeClasses = function($el, config, model, modelAttr) {
	    _.each(config.classes || [], function(classConfig, name) {
	      if (_.isString(classConfig)) classConfig = {observe: classConfig};
	      classConfig.view = config.view;
	
	      var observed = classConfig.observe;
	      var updateClass = function() {
	        var val = getAttr(model, observed, classConfig);
	        $el.toggleClass(name, !!val);
	      };
	
	      _.each(_.flatten([observed]), function(attr) {
	        observeModelEvent(model, 'change:' + attr, config, updateClass);
	      });
	      updateClass();
	    });
	  };
	
	  // If `visible` is configured, then the view element will be shown/hidden
	  // based on the truthiness of the modelattr's value or the result of the
	  // given callback. If a `visibleFn` is also supplied, then that callback
	  // will be executed to manually handle showing/hiding the view element.
	  //
	  //     observe: 'isRight',
	  //     visible: true, // or function(val, options) {}
	  //     visibleFn: function($el, isVisible, options) {} // optional handler
	  //
	  var initializeVisible = function($el, config, model, modelAttr) {
	    if (config.visible == null) return;
	    var view = config.view;
	
	    var visibleCb = function() {
	      var visible = config.visible,
	          visibleFn = config.visibleFn,
	          val = getAttr(model, modelAttr, config),
	          isVisible = !!val;
	
	      // If `visible` is a function then it should return a boolean result to show/hide.
	      if (_.isFunction(visible) || _.isString(visible)) {
	        isVisible = !!applyViewFn.call(view, visible, val, config);
	      }
	
	      // Either use the custom `visibleFn`, if provided, or execute the standard show/hide.
	      if (visibleFn) {
	        applyViewFn.call(view, visibleFn, $el, isVisible, config);
	      } else {
	        $el.toggle(isVisible);
	      }
	    };
	
	    _.each(_.flatten([modelAttr]), function(attr) {
	      observeModelEvent(model, 'change:' + attr, config, visibleCb);
	    });
	
	    visibleCb();
	  };
	
	  // Update the value of `$el` using the given configuration and trigger the
	  // `afterUpdate` callback. This action may be blocked by `config.updateView`.
	  //
	  //     update: function($el, val, model, options) {},  // handler for updating
	  //     updateView: true, // defaults to true
	  //     afterUpdate: function($el, val, options) {} // optional callback
	  //
	  var updateViewBindEl = function($el, config, val, model, isInitializing) {
	    var view = config.view;
	    if (!evaluateBoolean(config.updateView, val, config)) return;
	    applyViewFn.call(view, config.update, $el, val, model, config);
	    if (!isInitializing) applyViewFn.call(view, config.afterUpdate, $el, val, config);
	  };
	
	  // Default Handlers
	  // ----------------
	
	  Stickit.addHandler([{
	    selector: '[contenteditable]',
	    updateMethod: 'html',
	    events: ['input', 'change']
	  }, {
	    selector: 'input',
	    events: ['propertychange', 'input', 'change'],
	    update: function($el, val) { $el.val(val); },
	    getVal: function($el) {
	      return $el.val();
	    }
	  }, {
	    selector: 'textarea',
	    events: ['propertychange', 'input', 'change'],
	    update: function($el, val) { $el.val(val); },
	    getVal: function($el) { return $el.val(); }
	  }, {
	    selector: 'input[type="radio"]',
	    events: ['change'],
	    update: function($el, val) {
	      $el.filter('[value="'+val+'"]').prop('checked', true);
	    },
	    getVal: function($el) {
	      return $el.filter(':checked').val();
	    }
	  }, {
	    selector: 'input[type="checkbox"]',
	    events: ['change'],
	    update: function($el, val, model, options) {
	      if ($el.length > 1) {
	        // There are multiple checkboxes so we need to go through them and check
	        // any that have value attributes that match what's in the array of `val`s.
	        val || (val = []);
	        $el.each(function(i, el) {
	          var checkbox = Backbone.$(el);
	          var checked = _.contains(val, checkbox.val());
	          checkbox.prop('checked', checked);
	        });
	      } else {
	        var checked = _.isBoolean(val) ? val : val === $el.val();
	        $el.prop('checked', checked);
	      }
	    },
	    getVal: function($el) {
	      var val;
	      if ($el.length > 1) {
	        val = _.reduce($el, function(memo, el) {
	          var checkbox = Backbone.$(el);
	          if (checkbox.prop('checked')) memo.push(checkbox.val());
	          return memo;
	        }, []);
	      } else {
	        val = $el.prop('checked');
	        // If the checkbox has a value attribute defined, then
	        // use that value. Most browsers use "on" as a default.
	        var boxval = $el.val();
	        if (boxval !== 'on' && boxval != null) {
	          val = val ? $el.val() : null;
	        }
	      }
	      return val;
	    }
	  }, {
	    selector: 'select',
	    events: ['change'],
	    update: function($el, val, model, options) {
	      var optList,
	        selectConfig = options.selectOptions,
	        list = selectConfig && selectConfig.collection || undefined,
	        isMultiple = $el.prop('multiple');
	
	      // If there are no `selectOptions` then we assume that the `<select>`
	      // is pre-rendered and that we need to generate the collection.
	      if (!selectConfig) {
	        selectConfig = {};
	        var getList = function($el) {
	          return $el.map(function(index, option) {
	            // Retrieve the text and value of the option, preferring "stickit-bind-val"
	            // data attribute over value property.
	            var dataVal = Backbone.$(option).data('stickit-bind-val');
	            return {
	              value: dataVal !== undefined ? dataVal : option.value,
	              label: option.text
	            };
	          }).get();
	        };
	        if ($el.find('optgroup').length) {
	          list = {opt_labels:[]};
	          // Search for options without optgroup
	          if ($el.find('> option').length) {
	            list.opt_labels.push(undefined);
	            _.each($el.find('> option'), function(el) {
	              list[undefined] = getList(Backbone.$(el));
	            });
	          }
	          _.each($el.find('optgroup'), function(el) {
	            var label = Backbone.$(el).attr('label');
	            list.opt_labels.push(label);
	            list[label] = getList(Backbone.$(el).find('option'));
	          });
	        } else {
	          list = getList($el.find('option'));
	        }
	      }
	
	      // Fill in default label and path values.
	      selectConfig.valuePath = selectConfig.valuePath || 'value';
	      selectConfig.labelPath = selectConfig.labelPath || 'label';
	      selectConfig.disabledPath = selectConfig.disabledPath || 'disabled';
	
	      var addSelectOptions = function(optList, $el, fieldVal) {
	        _.each(optList, function(obj) {
	          var option = Backbone.$('<option/>'), optionVal = obj;
	
	          var fillOption = function(text, val, disabled) {
	            option.text(text);
	            optionVal = val;
	            // Save the option value as data so that we can reference it later.
	            option.data('stickit-bind-val', optionVal);
	            if (!_.isArray(optionVal) && !_.isObject(optionVal)) option.val(optionVal);
	
	            if (disabled === true) option.prop('disabled', 'disabled');
	          };
	
	          var text, val, disabled;
	          if (obj === '__default__') {
	            text = fieldVal.label,
	            val = fieldVal.value,
	            disabled = fieldVal.disabled;
	          } else {
	            text = evaluatePath(obj, selectConfig.labelPath),
	            val = evaluatePath(obj, selectConfig.valuePath),
	            disabled = evaluatePath(obj, selectConfig.disabledPath);
	          }
	          fillOption(text, val, disabled);
	
	          // Determine if this option is selected.
	          var isSelected = function() {
	            if (!isMultiple && optionVal != null && fieldVal != null && optionVal === fieldVal) {
	              return true;
	            } else if (_.isObject(fieldVal) && _.isEqual(optionVal, fieldVal)) {
	              return true;
	            }
	            return false;
	          };
	
	          if (isSelected()) {
	            option.prop('selected', true);
	          } else if (isMultiple && _.isArray(fieldVal)) {
	            _.each(fieldVal, function(val) {
	              if (_.isObject(val)) val = evaluatePath(val, selectConfig.valuePath);
	              if (val === optionVal || (_.isObject(val) && _.isEqual(optionVal, val)))
	                option.prop('selected', true);
	            });
	          }
	
	          $el.append(option);
	        });
	      };
	
	      $el.find('*').remove();
	
	      // The `list` configuration is a function that returns the options list or a string
	      // which represents the path to the list relative to `window` or the view/`this`.
	      if (_.isString(list)) {
	        var context = window;
	        if (list.indexOf('this.') === 0) context = this;
	        list = list.replace(/^[a-z]*\.(.+)$/, '$1');
	        optList = evaluatePath(context, list);
	      } else if (_.isFunction(list)) {
	        optList = applyViewFn.call(this, list, $el, options);
	      } else {
	        optList = list;
	      }
	
	      // Support Backbone.Collection and deserialize.
	      if (optList instanceof Backbone.Collection) {
	        var collection = optList;
	        var refreshSelectOptions = function() {
	          var currentVal = getAttr(model, options.observe, options);
	          applyViewFn.call(this, options.update, $el, currentVal, model, options);
	        };
	        // We need to call this function after unstickit and after an update so we don't end up
	        // with multiple listeners doing the same thing
	        var removeCollectionListeners = function() {
	          collection.off('add remove reset sort', refreshSelectOptions);
	        };
	        var removeAllListeners = function() {
	          removeCollectionListeners();
	          collection.off('stickit:selectRefresh');
	          model.off('stickit:selectRefresh');
	        };
	        // Remove previously set event listeners by triggering a custom event
	        collection.trigger('stickit:selectRefresh');
	        collection.once('stickit:selectRefresh', removeCollectionListeners, this);
	
	        // Listen to the collection and trigger an update of the select options
	        collection.on('add remove reset sort', refreshSelectOptions, this);
	
	        // Remove the previous model event listener
	        model.trigger('stickit:selectRefresh');
	        model.once('stickit:selectRefresh', function() {
	          model.off('stickit:unstuck', removeAllListeners);
	        });
	        // Remove collection event listeners once this binding is unstuck
	        model.once('stickit:unstuck', removeAllListeners, this);
	        optList = optList.toJSON();
	      }
	
	      if (selectConfig.defaultOption) {
	        var option = _.isFunction(selectConfig.defaultOption) ?
	          selectConfig.defaultOption.call(this, $el, options) :
	          selectConfig.defaultOption;
	        addSelectOptions(["__default__"], $el, option);
	      }
	
	      if (_.isArray(optList)) {
	        addSelectOptions(optList, $el, val);
	      } else if (optList.opt_labels) {
	        // To define a select with optgroups, format selectOptions.collection as an object
	        // with an 'opt_labels' property, as in the following:
	        //
	        //     {
	        //       'opt_labels': ['Looney Tunes', 'Three Stooges'],
	        //       'Looney Tunes': [{id: 1, name: 'Bugs Bunny'}, {id: 2, name: 'Donald Duck'}],
	        //       'Three Stooges': [{id: 3, name : 'moe'}, {id: 4, name : 'larry'}, {id: 5, name : 'curly'}]
	        //     }
	        //
	        _.each(optList.opt_labels, function(label) {
	          var $group = Backbone.$('<optgroup/>').attr('label', label);
	          addSelectOptions(optList[label], $group, val);
	          $el.append($group);
	        });
	        // With no 'opt_labels' parameter, the object is assumed to be a simple value-label map.
	        // Pass a selectOptions.comparator to override the default order of alphabetical by label.
	      } else {
	        var opts = [], opt;
	        for (var i in optList) {
	          opt = {};
	          opt[selectConfig.valuePath] = i;
	          opt[selectConfig.labelPath] = optList[i];
	          opts.push(opt);
	        }
	        opts = _.sortBy(opts, selectConfig.comparator || selectConfig.labelPath);
	        addSelectOptions(opts, $el, val);
	      }
	    },
	    getVal: function($el) {
	      var selected = $el.find('option:selected');
	
	      if ($el.prop('multiple')) {
	        return _.map(selected, function(el) {
	          return Backbone.$(el).data('stickit-bind-val');
	        });
	      } else {
	        return selected.data('stickit-bind-val');
	      }
	    }
	  }]);
	
	  return Stickit;
	
	}));


/***/ },
/* 1958 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Backbone.Wreqr (Backbone.Marionette)
	// ----------------------------------
	// v1.4.0
	//
	// Copyright (c)2016 Derick Bailey, Muted Solutions, LLC.
	// Distributed under MIT license
	//
	// http://github.com/marionettejs/backbone.wreqr
	
	
	(function(root, factory) {
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [(__webpack_require__(__webpack_module_template_argument_0__)), (__webpack_require__(__webpack_module_template_argument_1__))], __WEBPACK_AMD_DEFINE_RESULT__ = function(Backbone, _) {
	      return factory(Backbone, _);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined') {
	    var Backbone = require('backbone');
	    var _ = require('underscore');
	    module.exports = factory(Backbone, _);
	  } else {
	    factory(root.Backbone, root._);
	  }
	
	}(this, function(Backbone, _) {
	  "use strict";
	
	  var previousWreqr = Backbone.Wreqr;
	
	  var Wreqr = Backbone.Wreqr = {};
	
	  Backbone.Wreqr.VERSION = '1.4.0';
	
	  Backbone.Wreqr.noConflict = function () {
	    Backbone.Wreqr = previousWreqr;
	    return this;
	  };
	
	  // Handlers
	  // --------
	  // A registry of functions to call, given a name
	  
	  Wreqr.Handlers = (function(Backbone, _){
	    "use strict";
	    
	    // Constructor
	    // -----------
	  
	    var Handlers = function(options){
	      this.options = options;
	      this._wreqrHandlers = {};
	      
	      if (_.isFunction(this.initialize)){
	        this.initialize(options);
	      }
	    };
	  
	    Handlers.extend = Backbone.Model.extend;
	  
	    // Instance Members
	    // ----------------
	  
	    _.extend(Handlers.prototype, Backbone.Events, {
	  
	      // Add multiple handlers using an object literal configuration
	      setHandlers: function(handlers){
	        _.each(handlers, _.bind(function(handler, name){
	          var context = null;
	  
	          if (_.isObject(handler) && !_.isFunction(handler)){
	            context = handler.context;
	            handler = handler.callback;
	          }
	  
	          this.setHandler(name, handler, context);
	        }, this));
	      },
	  
	      // Add a handler for the given name, with an
	      // optional context to run the handler within
	      setHandler: function(name, handler, context){
	        var config = {
	          callback: handler,
	          context: context
	        };
	  
	        this._wreqrHandlers[name] = config;
	  
	        this.trigger("handler:add", name, handler, context);
	      },
	  
	      // Determine whether or not a handler is registered
	      hasHandler: function(name){
	        return !! this._wreqrHandlers[name];
	      },
	  
	      // Get the currently registered handler for
	      // the specified name. Throws an exception if
	      // no handler is found.
	      getHandler: function(name){
	        var config = this._wreqrHandlers[name];
	  
	        if (!config){
	          return;
	        }
	  
	        return function(){
	          return config.callback.apply(config.context, arguments);
	        };
	      },
	  
	      // Remove a handler for the specified name
	      removeHandler: function(name){
	        delete this._wreqrHandlers[name];
	      },
	  
	      // Remove all handlers from this registry
	      removeAllHandlers: function(){
	        this._wreqrHandlers = {};
	      }
	    });
	  
	    return Handlers;
	  })(Backbone, _);
	  
	  // Wreqr.CommandStorage
	  // --------------------
	  //
	  // Store and retrieve commands for execution.
	  Wreqr.CommandStorage = (function(){
	    "use strict";
	  
	    // Constructor function
	    var CommandStorage = function(options){
	      this.options = options;
	      this._commands = {};
	  
	      if (_.isFunction(this.initialize)){
	        this.initialize(options);
	      }
	    };
	  
	    // Instance methods
	    _.extend(CommandStorage.prototype, Backbone.Events, {
	  
	      // Get an object literal by command name, that contains
	      // the `commandName` and the `instances` of all commands
	      // represented as an array of arguments to process
	      getCommands: function(commandName){
	        var commands = this._commands[commandName];
	  
	        // we don't have it, so add it
	        if (!commands){
	  
	          // build the configuration
	          commands = {
	            command: commandName, 
	            instances: []
	          };
	  
	          // store it
	          this._commands[commandName] = commands;
	        }
	  
	        return commands;
	      },
	  
	      // Add a command by name, to the storage and store the
	      // args for the command
	      addCommand: function(commandName, args){
	        var command = this.getCommands(commandName);
	        command.instances.push(args);
	      },
	  
	      // Clear all commands for the given `commandName`
	      clearCommands: function(commandName){
	        var command = this.getCommands(commandName);
	        command.instances = [];
	      }
	    });
	  
	    return CommandStorage;
	  })();
	  
	  // Wreqr.Commands
	  // --------------
	  //
	  // A simple command pattern implementation. Register a command
	  // handler and execute it.
	  Wreqr.Commands = (function(Wreqr, _){
	    "use strict";
	  
	    return Wreqr.Handlers.extend({
	      // default storage type
	      storageType: Wreqr.CommandStorage,
	  
	      constructor: function(options){
	        this.options = options || {};
	  
	        this._initializeStorage(this.options);
	        this.on("handler:add", this._executeCommands, this);
	  
	        Wreqr.Handlers.prototype.constructor.apply(this, arguments);
	      },
	  
	      // Execute a named command with the supplied args
	      execute: function(name){
	        name = arguments[0];
	        var args = _.rest(arguments);
	  
	        if (this.hasHandler(name)){
	          this.getHandler(name).apply(this, args);
	        } else {
	          this.storage.addCommand(name, args);
	        }
	  
	      },
	  
	      // Internal method to handle bulk execution of stored commands
	      _executeCommands: function(name, handler, context){
	        var command = this.storage.getCommands(name);
	  
	        // loop through and execute all the stored command instances
	        _.each(command.instances, function(args){
	          handler.apply(context, args);
	        });
	  
	        this.storage.clearCommands(name);
	      },
	  
	      // Internal method to initialize storage either from the type's
	      // `storageType` or the instance `options.storageType`.
	      _initializeStorage: function(options){
	        var storage;
	  
	        var StorageType = options.storageType || this.storageType;
	        if (_.isFunction(StorageType)){
	          storage = new StorageType();
	        } else {
	          storage = StorageType;
	        }
	  
	        this.storage = storage;
	      }
	    });
	  
	  })(Wreqr, _);
	  
	  // Wreqr.RequestResponse
	  // ---------------------
	  //
	  // A simple request/response implementation. Register a
	  // request handler, and return a response from it
	  Wreqr.RequestResponse = (function(Wreqr, _){
	    "use strict";
	  
	    return Wreqr.Handlers.extend({
	      request: function(name){
	        if (this.hasHandler(name)) {
	          return this.getHandler(name).apply(this, _.rest(arguments));
	        }
	      }
	    });
	  
	  })(Wreqr, _);
	  
	  // Event Aggregator
	  // ----------------
	  // A pub-sub object that can be used to decouple various parts
	  // of an application through event-driven architecture.
	  
	  Wreqr.EventAggregator = (function(Backbone, _){
	    "use strict";
	    var EA = function(){};
	  
	    // Copy the `extend` function used by Backbone's classes
	    EA.extend = Backbone.Model.extend;
	  
	    // Copy the basic Backbone.Events on to the event aggregator
	    _.extend(EA.prototype, Backbone.Events);
	  
	    return EA;
	  })(Backbone, _);
	  
	  // Wreqr.Channel
	  // --------------
	  //
	  // An object that wraps the three messaging systems:
	  // EventAggregator, RequestResponse, Commands
	  Wreqr.Channel = (function(Wreqr){
	    "use strict";
	  
	    var Channel = function(channelName) {
	      this.vent        = new Backbone.Wreqr.EventAggregator();
	      this.reqres      = new Backbone.Wreqr.RequestResponse();
	      this.commands    = new Backbone.Wreqr.Commands();
	      this.channelName = channelName;
	    };
	  
	    _.extend(Channel.prototype, {
	  
	      // Remove all handlers from the messaging systems of this channel
	      reset: function() {
	        this.vent.off();
	        this.vent.stopListening();
	        this.reqres.removeAllHandlers();
	        this.commands.removeAllHandlers();
	        return this;
	      },
	  
	      // Connect a hash of events; one for each messaging system
	      connectEvents: function(hash, context) {
	        this._connect('vent', hash, context);
	        return this;
	      },
	  
	      connectCommands: function(hash, context) {
	        this._connect('commands', hash, context);
	        return this;
	      },
	  
	      connectRequests: function(hash, context) {
	        this._connect('reqres', hash, context);
	        return this;
	      },
	  
	      // Attach the handlers to a given message system `type`
	      _connect: function(type, hash, context) {
	        if (!hash) {
	          return;
	        }
	  
	        context = context || this;
	        var method = (type === 'vent') ? 'on' : 'setHandler';
	  
	        _.each(hash, _.bind(function(fn, eventName) {
	          this[type][method](eventName, _.bind(fn, context));
	        }, this));
	      }
	    });
	  
	  
	    return Channel;
	  })(Wreqr);
	  
	  // Wreqr.Radio
	  // --------------
	  //
	  // An object that lets you communicate with many channels.
	  Wreqr.radio = (function(Wreqr, _){
	    "use strict";
	  
	    var Radio = function() {
	      this._channels = {};
	      this.vent = {};
	      this.commands = {};
	      this.reqres = {};
	      this._proxyMethods();
	    };
	  
	    _.extend(Radio.prototype, {
	  
	      channel: function(channelName) {
	        if (!channelName) {
	          throw new Error('Channel must receive a name');
	        }
	  
	        return this._getChannel( channelName );
	      },
	  
	      _getChannel: function(channelName) {
	        var channel = this._channels[channelName];
	  
	        if(!channel) {
	          channel = new Wreqr.Channel(channelName);
	          this._channels[channelName] = channel;
	        }
	  
	        return channel;
	      },
	  
	      _proxyMethods: function() {
	        _.each(['vent', 'commands', 'reqres'], _.bind(function(system) {
	          _.each( messageSystems[system], _.bind(function(method) {
	            this[system][method] = proxyMethod(this, system, method);
	          }, this));
	        }, this));
	      }
	    });
	  
	  
	    var messageSystems = {
	      vent: [
	        'on',
	        'off',
	        'trigger',
	        'once',
	        'stopListening',
	        'listenTo',
	        'listenToOnce'
	      ],
	  
	      commands: [
	        'execute',
	        'setHandler',
	        'setHandlers',
	        'removeHandler',
	        'removeAllHandlers'
	      ],
	  
	      reqres: [
	        'request',
	        'setHandler',
	        'setHandlers',
	        'removeHandler',
	        'removeAllHandlers'
	      ]
	    };
	  
	    var proxyMethod = function(radio, system, method) {
	      return function(channelName) {
	        var messageSystem = radio._getChannel(channelName)[system];
	  
	        return messageSystem[method].apply(messageSystem, _.rest(arguments));
	      };
	    };
	  
	    return new Radio();
	  
	  })(Wreqr, _);
	  
	
	  return Backbone.Wreqr;
	
	}));


/***/ },
/* 1959 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Backbone.js 1.1.2
	
	//     (c) 2010-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Backbone may be freely distributed under the MIT license.
	//     For all details and documentation:
	//     http://backbonejs.org
	
	(function(root, factory) {
	
	  // Set up Backbone appropriately for the environment. Start with AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [(__webpack_require__(__webpack_module_template_argument_0__)), (__webpack_require__(__webpack_module_template_argument_1__)), exports], __WEBPACK_AMD_DEFINE_RESULT__ = function(_, $, exports) {
	      // Export global even in AMD case in case this script is loaded with
	      // others that may still expect a global Backbone.
	      root.Backbone = factory(root, exports, _, $);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
	  } else if (typeof exports !== 'undefined') {
	    var _ = require('underscore');
	    factory(root, exports, _);
	
	  // Finally, as a browser global.
	  } else {
	    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
	  }
	
	}(this, function(root, Backbone, _, $) {
	
	  // Initial Setup
	  // -------------
	
	  // Save the previous value of the `Backbone` variable, so that it can be
	  // restored later on, if `noConflict` is used.
	  var previousBackbone = root.Backbone;
	
	  // Create local references to array methods we'll want to use later.
	  var array = [];
	  var push = array.push;
	  var slice = array.slice;
	  var splice = array.splice;
	
	  // Current version of the library. Keep in sync with `package.json`.
	  Backbone.VERSION = '1.1.2';
	
	  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
	  // the `$` variable.
	  Backbone.$ = $;
	
	  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
	  // to its previous owner. Returns a reference to this Backbone object.
	  Backbone.noConflict = function() {
	    root.Backbone = previousBackbone;
	    return this;
	  };
	
	  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
	  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
	  // set a `X-Http-Method-Override` header.
	  Backbone.emulateHTTP = false;
	
	  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
	  // `application/json` requests ... will encode the body as
	  // `application/x-www-form-urlencoded` instead and will send the model in a
	  // form param named `model`.
	  Backbone.emulateJSON = false;
	
	  // Backbone.Events
	  // ---------------
	
	  // A module that can be mixed in to *any object* in order to provide it with
	  // custom events. You may bind with `on` or remove with `off` callback
	  // functions to an event; `trigger`-ing an event fires all callbacks in
	  // succession.
	  //
	  //     var object = {};
	  //     _.extend(object, Backbone.Events);
	  //     object.on('expand', function(){ alert('expanded'); });
	  //     object.trigger('expand');
	  //
	  var Events = Backbone.Events = {
	
	    // Bind an event to a `callback` function. Passing `"all"` will bind
	    // the callback to all events fired.
	    on: function(name, callback, context) {
	      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
	      this._events || (this._events = {});
	      var events = this._events[name] || (this._events[name] = []);
	      events.push({callback: callback, context: context, ctx: context || this});
	      return this;
	    },
	
	    // Bind an event to only be triggered a single time. After the first time
	    // the callback is invoked, it will be removed.
	    once: function(name, callback, context) {
	      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
	      var self = this;
	      var once = _.once(function() {
	        self.off(name, once);
	        callback.apply(this, arguments);
	      });
	      once._callback = callback;
	      return this.on(name, once, context);
	    },
	
	    // Remove one or many callbacks. If `context` is null, removes all
	    // callbacks with that function. If `callback` is null, removes all
	    // callbacks for the event. If `name` is null, removes all bound
	    // callbacks for all events.
	    off: function(name, callback, context) {
	      var retain, ev, events, names, i, l, j, k;
	      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
	      if (!name && !callback && !context) {
	        this._events = void 0;
	        return this;
	      }
	      names = name ? [name] : _.keys(this._events);
	      for (i = 0, l = names.length; i < l; i++) {
	        name = names[i];
	        if (events = this._events[name]) {
	          this._events[name] = retain = [];
	          if (callback || context) {
	            for (j = 0, k = events.length; j < k; j++) {
	              ev = events[j];
	              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
	                  (context && context !== ev.context)) {
	                retain.push(ev);
	              }
	            }
	          }
	          if (!retain.length) delete this._events[name];
	        }
	      }
	
	      return this;
	    },
	
	    // Trigger one or many events, firing all bound callbacks. Callbacks are
	    // passed the same arguments as `trigger` is, apart from the event name
	    // (unless you're listening on `"all"`, which will cause your callback to
	    // receive the true name of the event as the first argument).
	    trigger: function(name) {
	      if (!this._events) return this;
	      var args = slice.call(arguments, 1);
	      if (!eventsApi(this, 'trigger', name, args)) return this;
	      var events = this._events[name];
	      var allEvents = this._events.all;
	      if (events) triggerEvents(events, args);
	      if (allEvents) triggerEvents(allEvents, arguments);
	      return this;
	    },
	
	    // Tell this object to stop listening to either specific events ... or
	    // to every object it's currently listening to.
	    stopListening: function(obj, name, callback) {
	      var listeningTo = this._listeningTo;
	      if (!listeningTo) return this;
	      var remove = !name && !callback;
	      if (!callback && typeof name === 'object') callback = this;
	      if (obj) (listeningTo = {})[obj._listenId] = obj;
	      for (var id in listeningTo) {
	        obj = listeningTo[id];
	        obj.off(name, callback, this);
	        if (remove || _.isEmpty(obj._events)) delete this._listeningTo[id];
	      }
	      return this;
	    }
	
	  };
	
	  // Regular expression used to split event strings.
	  var eventSplitter = /\s+/;
	
	  // Implement fancy features of the Events API such as multiple event
	  // names `"change blur"` and jQuery-style event maps `{change: action}`
	  // in terms of the existing API.
	  var eventsApi = function(obj, action, name, rest) {
	    if (!name) return true;
	
	    // Handle event maps.
	    if (typeof name === 'object') {
	      for (var key in name) {
	        obj[action].apply(obj, [key, name[key]].concat(rest));
	      }
	      return false;
	    }
	
	    // Handle space separated event names.
	    if (eventSplitter.test(name)) {
	      var names = name.split(eventSplitter);
	      for (var i = 0, l = names.length; i < l; i++) {
	        obj[action].apply(obj, [names[i]].concat(rest));
	      }
	      return false;
	    }
	
	    return true;
	  };
	
	  // A difficult-to-believe, but optimized internal dispatch function for
	  // triggering events. Tries to keep the usual cases speedy (most internal
	  // Backbone events have 3 arguments).
	  var triggerEvents = function(events, args) {
	    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
	    switch (args.length) {
	      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
	      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
	      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
	      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
	      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
	    }
	  };
	
	  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};
	
	  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
	  // listen to an event in another object ... keeping track of what it's
	  // listening to.
	  _.each(listenMethods, function(implementation, method) {
	    Events[method] = function(obj, name, callback) {
	      var listeningTo = this._listeningTo || (this._listeningTo = {});
	      var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
	      listeningTo[id] = obj;
	      if (!callback && typeof name === 'object') callback = this;
	      obj[implementation](name, callback, this);
	      return this;
	    };
	  });
	
	  // Aliases for backwards compatibility.
	  Events.bind   = Events.on;
	  Events.unbind = Events.off;
	
	  // Allow the `Backbone` object to serve as a global event bus, for folks who
	  // want global "pubsub" in a convenient place.
	  _.extend(Backbone, Events);
	
	  // Backbone.Model
	  // --------------
	
	  // Backbone **Models** are the basic data object in the framework --
	  // frequently representing a row in a table in a database on your server.
	  // A discrete chunk of data and a bunch of useful, related methods for
	  // performing computations and transformations on that data.
	
	  // Create a new model with the specified attributes. A client id (`cid`)
	  // is automatically generated and assigned for you.
	  var Model = Backbone.Model = function(attributes, options) {
	    var attrs = attributes || {};
	    options || (options = {});
	    this.cid = _.uniqueId('c');
	    this.attributes = {};
	    if (options.collection) this.collection = options.collection;
	    if (options.parse) attrs = this.parse(attrs, options) || {};
	    attrs = _.defaults({}, attrs, _.result(this, 'defaults'));
	    this.set(attrs, options);
	    this.changed = {};
	    this.initialize.apply(this, arguments);
	  };
	
	  // Attach all inheritable methods to the Model prototype.
	  _.extend(Model.prototype, Events, {
	
	    // A hash of attributes whose current and previous value differ.
	    changed: null,
	
	    // The value returned during the last failed validation.
	    validationError: null,
	
	    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
	    // CouchDB users may want to set this to `"_id"`.
	    idAttribute: 'id',
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Return a copy of the model's `attributes` object.
	    toJSON: function(options) {
	      return _.clone(this.attributes);
	    },
	
	    // Proxy `Backbone.sync` by default -- but override this if you need
	    // custom syncing semantics for *this* particular model.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Get the value of an attribute.
	    get: function(attr) {
	      return this.attributes[attr];
	    },
	
	    // Get the HTML-escaped value of an attribute.
	    escape: function(attr) {
	      return _.escape(this.get(attr));
	    },
	
	    // Returns `true` if the attribute contains a value that is not null
	    // or undefined.
	    has: function(attr) {
	      return this.get(attr) != null;
	    },
	
	    // Set a hash of model attributes on the object, firing `"change"`. This is
	    // the core primitive operation of a model, updating the data and notifying
	    // anyone who needs to know about the change in state. The heart of the beast.
	    set: function(key, val, options) {
	      var attr, attrs, unset, changes, silent, changing, prev, current;
	      if (key == null) return this;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      if (typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options || (options = {});
	
	      // Run validation.
	      if (!this._validate(attrs, options)) return false;
	
	      // Extract attributes and options.
	      unset           = options.unset;
	      silent          = options.silent;
	      changes         = [];
	      changing        = this._changing;
	      this._changing  = true;
	
	      if (!changing) {
	        this._previousAttributes = _.clone(this.attributes);
	        this.changed = {};
	      }
	      current = this.attributes, prev = this._previousAttributes;
	
	      // Check for changes of `id`.
	      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];
	
	      // For each `set` attribute, update or delete the current value.
	      for (attr in attrs) {
	        val = attrs[attr];
	        if (!_.isEqual(current[attr], val)) changes.push(attr);
	        if (!_.isEqual(prev[attr], val)) {
	          this.changed[attr] = val;
	        } else {
	          delete this.changed[attr];
	        }
	        unset ? delete current[attr] : current[attr] = val;
	      }
	
	      // Trigger all relevant attribute changes.
	      if (!silent) {
	        if (changes.length) this._pending = options;
	        for (var i = 0, l = changes.length; i < l; i++) {
	          this.trigger('change:' + changes[i], this, current[changes[i]], options);
	        }
	      }
	
	      // You might be wondering why there's a `while` loop here. Changes can
	      // be recursively nested within `"change"` events.
	      if (changing) return this;
	      if (!silent) {
	        while (this._pending) {
	          options = this._pending;
	          this._pending = false;
	          this.trigger('change', this, options);
	        }
	      }
	      this._pending = false;
	      this._changing = false;
	      return this;
	    },
	
	    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
	    // if the attribute doesn't exist.
	    unset: function(attr, options) {
	      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
	    },
	
	    // Clear all attributes on the model, firing `"change"`.
	    clear: function(options) {
	      var attrs = {};
	      for (var key in this.attributes) attrs[key] = void 0;
	      return this.set(attrs, _.extend({}, options, {unset: true}));
	    },
	
	    // Determine if the model has changed since the last `"change"` event.
	    // If you specify an attribute name, determine if that attribute has changed.
	    hasChanged: function(attr) {
	      if (attr == null) return !_.isEmpty(this.changed);
	      return _.has(this.changed, attr);
	    },
	
	    // Return an object containing all the attributes that have changed, or
	    // false if there are no changed attributes. Useful for determining what
	    // parts of a view need to be updated and/or what attributes need to be
	    // persisted to the server. Unset attributes will be set to undefined.
	    // You can also pass an attributes object to diff against the model,
	    // determining if there *would be* a change.
	    changedAttributes: function(diff) {
	      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
	      var val, changed = false;
	      var old = this._changing ? this._previousAttributes : this.attributes;
	      for (var attr in diff) {
	        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
	        (changed || (changed = {}))[attr] = val;
	      }
	      return changed;
	    },
	
	    // Get the previous value of an attribute, recorded at the time the last
	    // `"change"` event was fired.
	    previous: function(attr) {
	      if (attr == null || !this._previousAttributes) return null;
	      return this._previousAttributes[attr];
	    },
	
	    // Get all of the attributes of the model at the time of the previous
	    // `"change"` event.
	    previousAttributes: function() {
	      return _.clone(this._previousAttributes);
	    },
	
	    // Fetch the model from the server. If the server's representation of the
	    // model differs from its current attributes, they will be overridden,
	    // triggering a `"change"` event.
	    fetch: function(options) {
	      options = options ? _.clone(options) : {};
	      if (options.parse === void 0) options.parse = true;
	      var model = this;
	      var success = options.success;
	      options.success = function(resp) {
	        if (!model.set(model.parse(resp, options), options)) return false;
	        if (success) success(model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Set a hash of model attributes, and sync the model to the server.
	    // If the server returns an attributes hash that differs, the model's
	    // state will be `set` again.
	    save: function(key, val, options) {
	      var attrs, method, xhr, attributes = this.attributes;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      if (key == null || typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options = _.extend({validate: true}, options);
	
	      // If we're not waiting and attributes exist, save acts as
	      // `set(attr).save(null, opts)` with validation. Otherwise, check if
	      // the model will be valid when the attributes, if any, are set.
	      if (attrs && !options.wait) {
	        if (!this.set(attrs, options)) return false;
	      } else {
	        if (!this._validate(attrs, options)) return false;
	      }
	
	      // Set temporary attributes if `{wait: true}`.
	      if (attrs && options.wait) {
	        this.attributes = _.extend({}, attributes, attrs);
	      }
	
	      // After a successful server-side save, the client is (optionally)
	      // updated with the server-side state.
	      if (options.parse === void 0) options.parse = true;
	      var model = this;
	      var success = options.success;
	      options.success = function(resp) {
	        // Ensure attributes are restored during synchronous saves.
	        model.attributes = attributes;
	        var serverAttrs = model.parse(resp, options);
	        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
	        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
	          return false;
	        }
	        if (success) success(model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	
	      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
	      if (method === 'patch') options.attrs = attrs;
	      xhr = this.sync(method, this, options);
	
	      // Restore attributes.
	      if (attrs && options.wait) this.attributes = attributes;
	
	      return xhr;
	    },
	
	    // Destroy this model on the server if it was already persisted.
	    // Optimistically removes the model from its collection, if it has one.
	    // If `wait: true` is passed, waits for the server to respond before removal.
	    destroy: function(options) {
	      options = options ? _.clone(options) : {};
	      var model = this;
	      var success = options.success;
	
	      var destroy = function() {
	        model.trigger('destroy', model, model.collection, options);
	      };
	
	      options.success = function(resp) {
	        if (options.wait || model.isNew()) destroy();
	        if (success) success(model, resp, options);
	        if (!model.isNew()) model.trigger('sync', model, resp, options);
	      };
	
	      if (this.isNew()) {
	        options.success();
	        return false;
	      }
	      wrapError(this, options);
	
	      var xhr = this.sync('delete', this, options);
	      if (!options.wait) destroy();
	      return xhr;
	    },
	
	    // Default URL for the model's representation on the server -- if you're
	    // using Backbone's restful methods, override this to change the endpoint
	    // that will be called.
	    url: function() {
	      var base =
	        _.result(this, 'urlRoot') ||
	        _.result(this.collection, 'url') ||
	        urlError();
	      if (this.isNew()) return base;
	      return base.replace(/([^\/])$/, '$1/') + encodeURIComponent(this.id);
	    },
	
	    // **parse** converts a response into the hash of attributes to be `set` on
	    // the model. The default implementation is just to pass the response along.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new model with identical attributes to this one.
	    clone: function() {
	      return new this.constructor(this.attributes);
	    },
	
	    // A model is new if it has never been saved to the server, and lacks an id.
	    isNew: function() {
	      return !this.has(this.idAttribute);
	    },
	
	    // Check if the model is currently in a valid state.
	    isValid: function(options) {
	      return this._validate({}, _.extend(options || {}, { validate: true }));
	    },
	
	    // Run validation against the next complete set of model attributes,
	    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
	    _validate: function(attrs, options) {
	      if (!options.validate || !this.validate) return true;
	      attrs = _.extend({}, this.attributes, attrs);
	      var error = this.validationError = this.validate(attrs, options) || null;
	      if (!error) return true;
	      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
	      return false;
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Model.
	  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];
	
	  // Mix in each Underscore method as a proxy to `Model#attributes`.
	  _.each(modelMethods, function(method) {
	    Model.prototype[method] = function() {
	      var args = slice.call(arguments);
	      args.unshift(this.attributes);
	      return _[method].apply(_, args);
	    };
	  });
	
	  // Backbone.Collection
	  // -------------------
	
	  // If models tend to represent a single row of data, a Backbone Collection is
	  // more analagous to a table full of data ... or a small slice or page of that
	  // table, or a collection of rows that belong together for a particular reason
	  // -- all of the messages in this particular folder, all of the documents
	  // belonging to this particular author, and so on. Collections maintain
	  // indexes of their models, both in order, and for lookup by `id`.
	
	  // Create a new **Collection**, perhaps to contain a specific type of `model`.
	  // If a `comparator` is specified, the Collection will maintain
	  // its models in sort order, as they're added and removed.
	  var Collection = Backbone.Collection = function(models, options) {
	    options || (options = {});
	    if (options.model) this.model = options.model;
	    if (options.comparator !== void 0) this.comparator = options.comparator;
	    this._reset();
	    this.initialize.apply(this, arguments);
	    if (models) this.reset(models, _.extend({silent: true}, options));
	  };
	
	  // Default options for `Collection#set`.
	  var setOptions = {add: true, remove: true, merge: true};
	  var addOptions = {add: true, remove: false};
	
	  // Define the Collection's inheritable methods.
	  _.extend(Collection.prototype, Events, {
	
	    // The default model for a collection is just a **Backbone.Model**.
	    // This should be overridden in most cases.
	    model: Model,
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // The JSON representation of a Collection is an array of the
	    // models' attributes.
	    toJSON: function(options) {
	      return this.map(function(model){ return model.toJSON(options); });
	    },
	
	    // Proxy `Backbone.sync` by default.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Add a model, or list of models to the set.
	    add: function(models, options) {
	      return this.set(models, _.extend({merge: false}, options, addOptions));
	    },
	
	    // Remove a model, or a list of models from the set.
	    remove: function(models, options) {
	      var singular = !_.isArray(models);
	      models = singular ? [models] : _.clone(models);
	      options || (options = {});
	      var i, l, index, model;
	      for (i = 0, l = models.length; i < l; i++) {
	        model = models[i] = this.get(models[i]);
	        if (!model) continue;
	        delete this._byId[model.id];
	        delete this._byId[model.cid];
	        index = this.indexOf(model);
	        this.models.splice(index, 1);
	        this.length--;
	        if (!options.silent) {
	          options.index = index;
	          model.trigger('remove', model, this, options);
	        }
	        this._removeReference(model, options);
	      }
	      return singular ? models[0] : models;
	    },
	
	    // Update a collection by `set`-ing a new list of models, adding new ones,
	    // removing models that are no longer present, and merging models that
	    // already exist in the collection, as necessary. Similar to **Model#set**,
	    // the core operation for updating the data contained by the collection.
	    set: function(models, options) {
	      options = _.defaults({}, options, setOptions);
	      if (options.parse) models = this.parse(models, options);
	      var singular = !_.isArray(models);
	      models = singular ? (models ? [models] : []) : _.clone(models);
	      var i, l, id, model, attrs, existing, sort;
	      var at = options.at;
	      var targetModel = this.model;
	      var sortable = this.comparator && (at == null) && options.sort !== false;
	      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
	      var toAdd = [], toRemove = [], modelMap = {};
	      var add = options.add, merge = options.merge, remove = options.remove;
	      var order = !sortable && add && remove ? [] : false;
	
	      // Turn bare objects into model references, and prevent invalid models
	      // from being added.
	      for (i = 0, l = models.length; i < l; i++) {
	        attrs = models[i] || {};
	        if (attrs instanceof Model) {
	          id = model = attrs;
	        } else {
	          id = attrs[targetModel.prototype.idAttribute || 'id'];
	        }
	
	        // If a duplicate is found, prevent it from being added and
	        // optionally merge it into the existing model.
	        if (existing = this.get(id)) {
	          if (remove) modelMap[existing.cid] = true;
	          if (merge) {
	            attrs = attrs === model ? model.attributes : attrs;
	            if (options.parse) attrs = existing.parse(attrs, options);
	            existing.set(attrs, options);
	            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
	          }
	          models[i] = existing;
	
	        // If this is a new, valid model, push it to the `toAdd` list.
	        } else if (add) {
	          model = models[i] = this._prepareModel(attrs, options);
	          if (!model) continue;
	          toAdd.push(model);
	          this._addReference(model, options);
	        }
	
	        // Do not add multiple models with the same `id`.
	        model = existing || model;
	        if (order && (model.isNew() || !modelMap[model.id])) order.push(model);
	        modelMap[model.id] = true;
	      }
	
	      // Remove nonexistent models if appropriate.
	      if (remove) {
	        for (i = 0, l = this.length; i < l; ++i) {
	          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
	        }
	        if (toRemove.length) this.remove(toRemove, options);
	      }
	
	      // See if sorting is needed, update `length` and splice in new models.
	      if (toAdd.length || (order && order.length)) {
	        if (sortable) sort = true;
	        this.length += toAdd.length;
	        if (at != null) {
	          for (i = 0, l = toAdd.length; i < l; i++) {
	            this.models.splice(at + i, 0, toAdd[i]);
	          }
	        } else {
	          if (order) this.models.length = 0;
	          var orderedModels = order || toAdd;
	          for (i = 0, l = orderedModels.length; i < l; i++) {
	            this.models.push(orderedModels[i]);
	          }
	        }
	      }
	
	      // Silently sort the collection if appropriate.
	      if (sort) this.sort({silent: true});
	
	      // Unless silenced, it's time to fire all appropriate add/sort events.
	      if (!options.silent) {
	        for (i = 0, l = toAdd.length; i < l; i++) {
	          (model = toAdd[i]).trigger('add', model, this, options);
	        }
	        if (sort || (order && order.length)) this.trigger('sort', this, options);
	      }
	
	      // Return the added (or merged) model (or models).
	      return singular ? models[0] : models;
	    },
	
	    // When you have more items than you want to add or remove individually,
	    // you can reset the entire set with a new list of models, without firing
	    // any granular `add` or `remove` events. Fires `reset` when finished.
	    // Useful for bulk operations and optimizations.
	    reset: function(models, options) {
	      options || (options = {});
	      for (var i = 0, l = this.models.length; i < l; i++) {
	        this._removeReference(this.models[i], options);
	      }
	      options.previousModels = this.models;
	      this._reset();
	      models = this.add(models, _.extend({silent: true}, options));
	      if (!options.silent) this.trigger('reset', this, options);
	      return models;
	    },
	
	    // Add a model to the end of the collection.
	    push: function(model, options) {
	      return this.add(model, _.extend({at: this.length}, options));
	    },
	
	    // Remove a model from the end of the collection.
	    pop: function(options) {
	      var model = this.at(this.length - 1);
	      this.remove(model, options);
	      return model;
	    },
	
	    // Add a model to the beginning of the collection.
	    unshift: function(model, options) {
	      return this.add(model, _.extend({at: 0}, options));
	    },
	
	    // Remove a model from the beginning of the collection.
	    shift: function(options) {
	      var model = this.at(0);
	      this.remove(model, options);
	      return model;
	    },
	
	    // Slice out a sub-array of models from the collection.
	    slice: function() {
	      return slice.apply(this.models, arguments);
	    },
	
	    // Get a model from the set by id.
	    get: function(obj) {
	      if (obj == null) return void 0;
	      return this._byId[obj] || this._byId[obj.id] || this._byId[obj.cid];
	    },
	
	    // Get the model at the given index.
	    at: function(index) {
	      return this.models[index];
	    },
	
	    // Return models with matching attributes. Useful for simple cases of
	    // `filter`.
	    where: function(attrs, first) {
	      if (_.isEmpty(attrs)) return first ? void 0 : [];
	      return this[first ? 'find' : 'filter'](function(model) {
	        for (var key in attrs) {
	          if (attrs[key] !== model.get(key)) return false;
	        }
	        return true;
	      });
	    },
	
	    // Return the first model with matching attributes. Useful for simple cases
	    // of `find`.
	    findWhere: function(attrs) {
	      return this.where(attrs, true);
	    },
	
	    // Force the collection to re-sort itself. You don't need to call this under
	    // normal circumstances, as the set will maintain sort order as each item
	    // is added.
	    sort: function(options) {
	      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
	      options || (options = {});
	
	      // Run sort based on type of `comparator`.
	      if (_.isString(this.comparator) || this.comparator.length === 1) {
	        this.models = this.sortBy(this.comparator, this);
	      } else {
	        this.models.sort(_.bind(this.comparator, this));
	      }
	
	      if (!options.silent) this.trigger('sort', this, options);
	      return this;
	    },
	
	    // Pluck an attribute from each model in the collection.
	    pluck: function(attr) {
	      return _.invoke(this.models, 'get', attr);
	    },
	
	    // Fetch the default set of models for this collection, resetting the
	    // collection when they arrive. If `reset: true` is passed, the response
	    // data will be passed through the `reset` method instead of `set`.
	    fetch: function(options) {
	      options = options ? _.clone(options) : {};
	      if (options.parse === void 0) options.parse = true;
	      var success = options.success;
	      var collection = this;
	      options.success = function(resp) {
	        var method = options.reset ? 'reset' : 'set';
	        collection[method](resp, options);
	        if (success) success(collection, resp, options);
	        collection.trigger('sync', collection, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Create a new instance of a model in this collection. Add the model to the
	    // collection immediately, unless `wait: true` is passed, in which case we
	    // wait for the server to agree.
	    create: function(model, options) {
	      options = options ? _.clone(options) : {};
	      if (!(model = this._prepareModel(model, options))) return false;
	      if (!options.wait) this.add(model, options);
	      var collection = this;
	      var success = options.success;
	      options.success = function(model, resp) {
	        if (options.wait) collection.add(model, options);
	        if (success) success(model, resp, options);
	      };
	      model.save(null, options);
	      return model;
	    },
	
	    // **parse** converts a response into a list of models to be added to the
	    // collection. The default implementation is just to pass it through.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new collection with an identical list of models as this one.
	    clone: function() {
	      return new this.constructor(this.models);
	    },
	
	    // Private method to reset all internal state. Called when the collection
	    // is first initialized or reset.
	    _reset: function() {
	      this.length = 0;
	      this.models = [];
	      this._byId  = {};
	    },
	
	    // Prepare a hash of attributes (or other model) to be added to this
	    // collection.
	    _prepareModel: function(attrs, options) {
	      if (attrs instanceof Model) return attrs;
	      options = options ? _.clone(options) : {};
	      options.collection = this;
	      var model = new this.model(attrs, options);
	      if (!model.validationError) return model;
	      this.trigger('invalid', this, model.validationError, options);
	      return false;
	    },
	
	    // Internal method to create a model's ties to a collection.
	    _addReference: function(model, options) {
	      this._byId[model.cid] = model;
	      if (model.id != null) this._byId[model.id] = model;
	      if (!model.collection) model.collection = this;
	      model.on('all', this._onModelEvent, this);
	    },
	
	    // Internal method to sever a model's ties to a collection.
	    _removeReference: function(model, options) {
	      if (this === model.collection) delete model.collection;
	      model.off('all', this._onModelEvent, this);
	    },
	
	    // Internal method called every time a model in the set fires an event.
	    // Sets need to update their indexes when models change ids. All other
	    // events simply proxy through. "add" and "remove" events that originate
	    // in other collections are ignored.
	    _onModelEvent: function(event, model, collection, options) {
	      if ((event === 'add' || event === 'remove') && collection !== this) return;
	      if (event === 'destroy') this.remove(model, options);
	      if (model && event === 'change:' + model.idAttribute) {
	        delete this._byId[model.previous(model.idAttribute)];
	        if (model.id != null) this._byId[model.id] = model;
	      }
	      this.trigger.apply(this, arguments);
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Collection.
	  // 90% of the core usefulness of Backbone Collections is actually implemented
	  // right here:
	  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
	    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
	    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
	    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
	    'tail', 'drop', 'last', 'without', 'difference', 'indexOf', 'shuffle',
	    'lastIndexOf', 'isEmpty', 'chain', 'sample'];
	
	  // Mix in each Underscore method as a proxy to `Collection#models`.
	  _.each(methods, function(method) {
	    Collection.prototype[method] = function() {
	      var args = slice.call(arguments);
	      args.unshift(this.models);
	      return _[method].apply(_, args);
	    };
	  });
	
	  // Underscore methods that take a property name as an argument.
	  var attributeMethods = ['groupBy', 'countBy', 'sortBy', 'indexBy'];
	
	  // Use attributes instead of properties.
	  _.each(attributeMethods, function(method) {
	    Collection.prototype[method] = function(value, context) {
	      var iterator = _.isFunction(value) ? value : function(model) {
	        return model.get(value);
	      };
	      return _[method](this.models, iterator, context);
	    };
	  });
	
	  // Backbone.View
	  // -------------
	
	  // Backbone Views are almost more convention than they are actual code. A View
	  // is simply a JavaScript object that represents a logical chunk of UI in the
	  // DOM. This might be a single item, an entire list, a sidebar or panel, or
	  // even the surrounding frame which wraps your whole app. Defining a chunk of
	  // UI as a **View** allows you to define your DOM events declaratively, without
	  // having to worry about render order ... and makes it easy for the view to
	  // react to specific changes in the state of your models.
	
	  // Creating a Backbone.View creates its initial element outside of the DOM,
	  // if an existing element is not provided...
	  var View = Backbone.View = function(options) {
	    this.cid = _.uniqueId('view');
	    options || (options = {});
	    _.extend(this, _.pick(options, viewOptions));
	    this._ensureElement();
	    this.initialize.apply(this, arguments);
	    this.delegateEvents();
	  };
	
	  // Cached regex to split keys for `delegate`.
	  var delegateEventSplitter = /^(\S+)\s*(.*)$/;
	
	  // List of view options to be merged as properties.
	  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];
	
	  // Set up all inheritable **Backbone.View** properties and methods.
	  _.extend(View.prototype, Events, {
	
	    // The default `tagName` of a View's element is `"div"`.
	    tagName: 'div',
	
	    // jQuery delegate for element lookup, scoped to DOM elements within the
	    // current view. This should be preferred to global lookups where possible.
	    $: function(selector) {
	      return this.$el.find(selector);
	    },
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // **render** is the core function that your view should override, in order
	    // to populate its element (`this.el`), with the appropriate HTML. The
	    // convention is for **render** to always return `this`.
	    render: function() {
	      return this;
	    },
	
	    // Remove this view by taking the element out of the DOM, and removing any
	    // applicable Backbone.Events listeners.
	    remove: function() {
	      this.$el.remove();
	      this.stopListening();
	      return this;
	    },
	
	    // Change the view's element (`this.el` property), including event
	    // re-delegation.
	    setElement: function(element, delegate) {
	      if (this.$el) this.undelegateEvents();
	      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
	      this.el = this.$el[0];
	      if (delegate !== false) this.delegateEvents();
	      return this;
	    },
	
	    // Set callbacks, where `this.events` is a hash of
	    //
	    // *{"event selector": "callback"}*
	    //
	    //     {
	    //       'mousedown .title':  'edit',
	    //       'click .button':     'save',
	    //       'click .open':       function(e) { ... }
	    //     }
	    //
	    // pairs. Callbacks will be bound to the view, with `this` set properly.
	    // Uses event delegation for efficiency.
	    // Omitting the selector binds the event to `this.el`.
	    // This only works for delegate-able events: not `focus`, `blur`, and
	    // not `change`, `submit`, and `reset` in Internet Explorer.
	    delegateEvents: function(events) {
	      if (!(events || (events = _.result(this, 'events')))) return this;
	      this.undelegateEvents();
	      for (var key in events) {
	        var method = events[key];
	        if (!_.isFunction(method)) method = this[events[key]];
	        if (!method) continue;
	
	        var match = key.match(delegateEventSplitter);
	        var eventName = match[1], selector = match[2];
	        method = _.bind(method, this);
	        eventName += '.delegateEvents' + this.cid;
	        if (selector === '') {
	          this.$el.on(eventName, method);
	        } else {
	          this.$el.on(eventName, selector, method);
	        }
	      }
	      return this;
	    },
	
	    // Clears all callbacks previously bound to the view with `delegateEvents`.
	    // You usually don't need to use this, but may wish to if you have multiple
	    // Backbone views attached to the same DOM element.
	    undelegateEvents: function() {
	      this.$el.off('.delegateEvents' + this.cid);
	      return this;
	    },
	
	    // Ensure that the View has a DOM element to render into.
	    // If `this.el` is a string, pass it through `$()`, take the first
	    // matching element, and re-assign it to `el`. Otherwise, create
	    // an element from the `id`, `className` and `tagName` properties.
	    _ensureElement: function() {
	      if (!this.el) {
	        var attrs = _.extend({}, _.result(this, 'attributes'));
	        if (this.id) attrs.id = _.result(this, 'id');
	        if (this.className) attrs['class'] = _.result(this, 'className');
	        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
	        this.setElement($el, false);
	      } else {
	        this.setElement(_.result(this, 'el'), false);
	      }
	    }
	
	  });
	
	  // Backbone.sync
	  // -------------
	
	  // Override this function to change the manner in which Backbone persists
	  // models to the server. You will be passed the type of request, and the
	  // model in question. By default, makes a RESTful Ajax request
	  // to the model's `url()`. Some possible customizations could be:
	  //
	  // * Use `setTimeout` to batch rapid-fire updates into a single request.
	  // * Send up the models as XML instead of JSON.
	  // * Persist models via WebSockets instead of Ajax.
	  //
	  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
	  // as `POST`, with a `_method` parameter containing the true HTTP method,
	  // as well as all requests with the body as `application/x-www-form-urlencoded`
	  // instead of `application/json` with the model in a param named `model`.
	  // Useful when interfacing with server-side languages like **PHP** that make
	  // it difficult to read the body of `PUT` requests.
	  Backbone.sync = function(method, model, options) {
	    var type = methodMap[method];
	
	    // Default options, unless specified.
	    _.defaults(options || (options = {}), {
	      emulateHTTP: Backbone.emulateHTTP,
	      emulateJSON: Backbone.emulateJSON
	    });
	
	    // Default JSON-request options.
	    var params = {type: type, dataType: 'json'};
	
	    // Ensure that we have a URL.
	    if (!options.url) {
	      params.url = _.result(model, 'url') || urlError();
	    }
	
	    // Ensure that we have the appropriate request data.
	    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
	      params.contentType = 'application/json';
	      params.data = JSON.stringify(options.attrs || model.toJSON(options));
	    }
	
	    // For older servers, emulate JSON by encoding the request into an HTML-form.
	    if (options.emulateJSON) {
	      params.contentType = 'application/x-www-form-urlencoded';
	      params.data = params.data ? {model: params.data} : {};
	    }
	
	    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
	    // And an `X-HTTP-Method-Override` header.
	    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
	      params.type = 'POST';
	      if (options.emulateJSON) params.data._method = type;
	      var beforeSend = options.beforeSend;
	      options.beforeSend = function(xhr) {
	        xhr.setRequestHeader('X-HTTP-Method-Override', type);
	        if (beforeSend) return beforeSend.apply(this, arguments);
	      };
	    }
	
	    // Don't process data on a non-GET request.
	    if (params.type !== 'GET' && !options.emulateJSON) {
	      params.processData = false;
	    }
	
	    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
	    // that still has ActiveX enabled by default, override jQuery to use that
	    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
	    if (params.type === 'PATCH' && noXhrPatch) {
	      params.xhr = function() {
	        return new ActiveXObject("Microsoft.XMLHTTP");
	      };
	    }
	
	    // Make the request, allowing the user to override any Ajax options.
	    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
	    model.trigger('request', model, xhr, options);
	    return xhr;
	  };
	
	  var noXhrPatch =
	    typeof window !== 'undefined' && !!window.ActiveXObject &&
	      !(window.XMLHttpRequest && (new XMLHttpRequest).dispatchEvent);
	
	  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
	  var methodMap = {
	    'create': 'POST',
	    'update': 'PUT',
	    'patch':  'PATCH',
	    'delete': 'DELETE',
	    'read':   'GET'
	  };
	
	  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
	  // Override this if you'd like to use a different library.
	  Backbone.ajax = function() {
	    return Backbone.$.ajax.apply(Backbone.$, arguments);
	  };
	
	  // Backbone.Router
	  // ---------------
	
	  // Routers map faux-URLs to actions, and fire events when routes are
	  // matched. Creating a new one sets its `routes` hash, if not set statically.
	  var Router = Backbone.Router = function(options) {
	    options || (options = {});
	    if (options.routes) this.routes = options.routes;
	    this._bindRoutes();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regular expressions for matching named param parts and splatted
	  // parts of route strings.
	  var optionalParam = /\((.*?)\)/g;
	  var namedParam    = /(\(\?)?:\w+/g;
	  var splatParam    = /\*\w+/g;
	  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;
	
	  // Set up all inheritable **Backbone.Router** properties and methods.
	  _.extend(Router.prototype, Events, {
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Manually bind a single named route to a callback. For example:
	    //
	    //     this.route('search/:query/p:num', 'search', function(query, num) {
	    //       ...
	    //     });
	    //
	    route: function(route, name, callback) {
	      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
	      if (_.isFunction(name)) {
	        callback = name;
	        name = '';
	      }
	      if (!callback) callback = this[name];
	      var router = this;
	      Backbone.history.route(route, function(fragment) {
	        var args = router._extractParameters(route, fragment);
	        router.execute(callback, args);
	        router.trigger.apply(router, ['route:' + name].concat(args));
	        router.trigger('route', name, args);
	        Backbone.history.trigger('route', router, name, args);
	      });
	      return this;
	    },
	
	    // Execute a route handler with the provided parameters.  This is an
	    // excellent place to do pre-route setup or post-route cleanup.
	    execute: function(callback, args) {
	      if (callback) callback.apply(this, args);
	    },
	
	    // Simple proxy to `Backbone.history` to save a fragment into the history.
	    navigate: function(fragment, options) {
	      Backbone.history.navigate(fragment, options);
	      return this;
	    },
	
	    // Bind all defined routes to `Backbone.history`. We have to reverse the
	    // order of the routes here to support behavior where the most general
	    // routes can be defined at the bottom of the route map.
	    _bindRoutes: function() {
	      if (!this.routes) return;
	      this.routes = _.result(this, 'routes');
	      var route, routes = _.keys(this.routes);
	      while ((route = routes.pop()) != null) {
	        this.route(route, this.routes[route]);
	      }
	    },
	
	    // Convert a route string into a regular expression, suitable for matching
	    // against the current location hash.
	    _routeToRegExp: function(route) {
	      route = route.replace(escapeRegExp, '\\$&')
	                   .replace(optionalParam, '(?:$1)?')
	                   .replace(namedParam, function(match, optional) {
	                     return optional ? match : '([^/?]+)';
	                   })
	                   .replace(splatParam, '([^?]*?)');
	      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
	    },
	
	    // Given a route, and a URL fragment that it matches, return the array of
	    // extracted decoded parameters. Empty or unmatched parameters will be
	    // treated as `null` to normalize cross-browser behavior.
	    _extractParameters: function(route, fragment) {
	      var params = route.exec(fragment).slice(1);
	      return _.map(params, function(param, i) {
	        // Don't decode the search params.
	        if (i === params.length - 1) return param || null;
	        return param ? decodeURIComponent(param) : null;
	      });
	    }
	
	  });
	
	  // Backbone.History
	  // ----------------
	
	  // Handles cross-browser history management, based on either
	  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
	  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
	  // and URL fragments. If the browser supports neither (old IE, natch),
	  // falls back to polling.
	  var History = Backbone.History = function() {
	    this.handlers = [];
	    _.bindAll(this, 'checkUrl');
	
	    // Ensure that `History` can be used outside of the browser.
	    if (typeof window !== 'undefined') {
	      this.location = window.location;
	      this.history = window.history;
	    }
	  };
	
	  // Cached regex for stripping a leading hash/slash and trailing space.
	  var routeStripper = /^[#\/]|\s+$/g;
	
	  // Cached regex for stripping leading and trailing slashes.
	  var rootStripper = /^\/+|\/+$/g;
	
	  // Cached regex for detecting MSIE.
	  var isExplorer = /msie [\w.]+/;
	
	  // Cached regex for removing a trailing slash.
	  var trailingSlash = /\/$/;
	
	  // Cached regex for stripping urls of hash.
	  var pathStripper = /#.*$/;
	
	  // Has the history handling already been started?
	  History.started = false;
	
	  // Set up all inheritable **Backbone.History** properties and methods.
	  _.extend(History.prototype, Events, {
	
	    // The default interval to poll for hash changes, if necessary, is
	    // twenty times a second.
	    interval: 50,
	
	    // Are we at the app root?
	    atRoot: function() {
	      return this.location.pathname.replace(/[^\/]$/, '$&/') === this.root;
	    },
	
	    // Gets the true hash value. Cannot use location.hash directly due to bug
	    // in Firefox where location.hash will always be decoded.
	    getHash: function(window) {
	      var match = (window || this).location.href.match(/#(.*)$/);
	      return match ? match[1] : '';
	    },
	
	    // Get the cross-browser normalized URL fragment, either from the URL,
	    // the hash, or the override.
	    getFragment: function(fragment, forcePushState) {
	      if (fragment == null) {
	        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
	          fragment = decodeURI(this.location.pathname + this.location.search);
	          var root = this.root.replace(trailingSlash, '');
	          if (!fragment.indexOf(root)) fragment = fragment.slice(root.length);
	        } else {
	          fragment = this.getHash();
	        }
	      }
	      return fragment.replace(routeStripper, '');
	    },
	
	    // Start the hash change handling, returning `true` if the current URL matches
	    // an existing route, and `false` otherwise.
	    start: function(options) {
	      if (History.started) throw new Error("Backbone.history has already been started");
	      History.started = true;
	
	      // Figure out the initial configuration. Do we need an iframe?
	      // Is pushState desired ... is it available?
	      this.options          = _.extend({root: '/'}, this.options, options);
	      this.root             = this.options.root;
	      this._wantsHashChange = this.options.hashChange !== false;
	      this._wantsPushState  = !!this.options.pushState;
	      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
	      var fragment          = this.getFragment();
	      var docMode           = document.documentMode;
	      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));
	
	      // Normalize root to always include a leading and trailing slash.
	      this.root = ('/' + this.root + '/').replace(rootStripper, '/');
	
	      if (oldIE && this._wantsHashChange) {
	        var frame = Backbone.$('<iframe src="javascript:0" tabindex="-1">');
	        this.iframe = frame.hide().appendTo('body')[0].contentWindow;
	        this.navigate(fragment);
	      }
	
	      // Depending on whether we're using pushState or hashes, and whether
	      // 'onhashchange' is supported, determine how we check the URL state.
	      if (this._hasPushState) {
	        Backbone.$(window).on('popstate', this.checkUrl);
	      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
	        Backbone.$(window).on('hashchange', this.checkUrl);
	      } else if (this._wantsHashChange) {
	        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
	      }
	
	      // Determine if we need to change the base url, for a pushState link
	      // opened by a non-pushState browser.
	      this.fragment = fragment;
	      var loc = this.location;
	
	      // Transition from hashChange to pushState or vice versa if both are
	      // requested.
	      if (this._wantsHashChange && this._wantsPushState) {
	
	        // If we've started off with a route from a `pushState`-enabled
	        // browser, but we're currently in a browser that doesn't support it...
	        if (!this._hasPushState && !this.atRoot()) {
	          this.fragment = this.getFragment(null, true);
	          this.location.replace(this.root + '#' + this.fragment);
	          // Return immediately as browser will do redirect to new url
	          return true;
	
	        // Or if we've started out with a hash-based route, but we're currently
	        // in a browser where it could be `pushState`-based instead...
	        } else if (this._hasPushState && this.atRoot() && loc.hash) {
	          this.fragment = this.getHash().replace(routeStripper, '');
	          this.history.replaceState({}, document.title, this.root + this.fragment);
	        }
	
	      }
	
	      if (!this.options.silent) return this.loadUrl();
	    },
	
	    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
	    // but possibly useful for unit testing Routers.
	    stop: function() {
	      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
	      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
	      History.started = false;
	    },
	
	    // Add a route to be tested when the fragment changes. Routes added later
	    // may override previous routes.
	    route: function(route, callback) {
	      this.handlers.unshift({route: route, callback: callback});
	    },
	
	    // Checks the current URL to see if it has changed, and if it has,
	    // calls `loadUrl`, normalizing across the hidden iframe.
	    checkUrl: function(e) {
	      var current = this.getFragment();
	      if (current === this.fragment && this.iframe) {
	        current = this.getFragment(this.getHash(this.iframe));
	      }
	      if (current === this.fragment) return false;
	      if (this.iframe) this.navigate(current);
	      this.loadUrl();
	    },
	
	    // Attempt to load the current URL fragment. If a route succeeds with a
	    // match, returns `true`. If no defined routes matches the fragment,
	    // returns `false`.
	    loadUrl: function(fragment) {
	      fragment = this.fragment = this.getFragment(fragment);
	      return _.any(this.handlers, function(handler) {
	        if (handler.route.test(fragment)) {
	          handler.callback(fragment);
	          return true;
	        }
	      });
	    },
	
	    // Save a fragment into the hash history, or replace the URL state if the
	    // 'replace' option is passed. You are responsible for properly URL-encoding
	    // the fragment in advance.
	    //
	    // The options object can contain `trigger: true` if you wish to have the
	    // route callback be fired (not usually desirable), or `replace: true`, if
	    // you wish to modify the current URL without adding an entry to the history.
	    navigate: function(fragment, options) {
	      if (!History.started) return false;
	      if (!options || options === true) options = {trigger: !!options};
	
	      var url = this.root + (fragment = this.getFragment(fragment || ''));
	
	      // Strip the hash for matching.
	      fragment = fragment.replace(pathStripper, '');
	
	      if (this.fragment === fragment) return;
	      this.fragment = fragment;
	
	      // Don't include a trailing slash on the root.
	      if (fragment === '' && url !== '/') url = url.slice(0, -1);
	
	      // If pushState is available, we use it to set the fragment as a real URL.
	      if (this._hasPushState) {
	        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);
	
	      // If hash changes haven't been explicitly disabled, update the hash
	      // fragment to store history.
	      } else if (this._wantsHashChange) {
	        this._updateHash(this.location, fragment, options.replace);
	        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
	          // Opening and closing the iframe tricks IE7 and earlier to push a
	          // history entry on hash-tag change.  When replace is true, we don't
	          // want this.
	          if(!options.replace) this.iframe.document.open().close();
	          this._updateHash(this.iframe.location, fragment, options.replace);
	        }
	
	      // If you've told us that you explicitly don't want fallback hashchange-
	      // based history, then `navigate` becomes a page refresh.
	      } else {
	        return this.location.assign(url);
	      }
	      if (options.trigger) return this.loadUrl(fragment);
	    },
	
	    // Update the hash location, either replacing the current entry, or adding
	    // a new one to the browser history.
	    _updateHash: function(location, fragment, replace) {
	      if (replace) {
	        var href = location.href.replace(/(javascript:|#).*$/, '');
	        location.replace(href + '#' + fragment);
	      } else {
	        // Some browsers require that `hash` contains a leading #.
	        location.hash = '#' + fragment;
	      }
	    }
	
	  });
	
	  // Create the default Backbone.history.
	  Backbone.history = new History;
	
	  // Helpers
	  // -------
	
	  // Helper function to correctly set up the prototype chain, for subclasses.
	  // Similar to `goog.inherits`, but uses a hash of prototype properties and
	  // class properties to be extended.
	  var extend = function(protoProps, staticProps) {
	    var parent = this;
	    var child;
	
	    // The constructor function for the new subclass is either defined by you
	    // (the "constructor" property in your `extend` definition), or defaulted
	    // by us to simply call the parent's constructor.
	    if (protoProps && _.has(protoProps, 'constructor')) {
	      child = protoProps.constructor;
	    } else {
	      child = function(){ return parent.apply(this, arguments); };
	    }
	
	    // Add static properties to the constructor function, if supplied.
	    _.extend(child, parent, staticProps);
	
	    // Set the prototype chain to inherit from `parent`, without calling
	    // `parent`'s constructor function.
	    var Surrogate = function(){ this.constructor = child; };
	    Surrogate.prototype = parent.prototype;
	    child.prototype = new Surrogate;
	
	    // Add prototype properties (instance properties) to the subclass,
	    // if supplied.
	    if (protoProps) _.extend(child.prototype, protoProps);
	
	    // Set a convenience property in case the parent's prototype is needed
	    // later.
	    child.__super__ = parent.prototype;
	
	    return child;
	  };
	
	  // Set up inheritance for the model, collection, router, view and history.
	  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;
	
	  // Throw an error when a URL is needed, and none is supplied.
	  var urlError = function() {
	    throw new Error('A "url" property or function must be specified');
	  };
	
	  // Wrap an optional error callback with a fallback error event.
	  var wrapError = function(model, options) {
	    var error = options.error;
	    options.error = function(resp) {
	      if (error) error(model, resp, options);
	      model.trigger('error', model, resp, options);
	    };
	  };
	
	  return Backbone;
	
	}));


/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var moment = module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	moment.tz.load(__webpack_require__(__webpack_module_template_argument_1__));


/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ },
/* 1962 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 1963 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 1965 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 1966 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Arabic (Palestine) [ar-ps]
	//! author : Majd Al-Shihabi : https://github.com/majdal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arPs = moment.defineLocale('ar-ps', {
	        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
	            '_'
	        ),
	        monthsShort:
	            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('') // reversed since negative lookbehind not supported everywhere
	                .reverse()
	                .join('')
	                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('')
	                .reverse()
	                .join('')
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arPs;
	
	})));


/***/ },
/* 1967 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ },
/* 1971 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ },
/* 1972 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ },
/* 1973 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ },
/* 1976 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ },
/* 1977 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! author : Rasid Redzic : https://github.com/rasidre
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 'm':
	                return withoutSuffix
	                    ? 'jedna minuta'
	                    : isFuture
	                      ? 'jednu minutu'
	                      : 'jedne minute';
	        }
	    }
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jedan sat';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: processRelativeTime,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ },
/* 1980 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            standalone:
	                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                    '_'
	                ),
	            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                '_'
	            ),
	            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ },
/* 1981 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                      ? 'тан'
	                      : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ },
/* 1983 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ },
/* 1984 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 1985 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 1986 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ },
/* 1987 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ },
/* 1988 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ },
/* 1989 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 1990 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 1991 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 1992 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 1993 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 1994 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ },
/* 1995 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 1996 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ },
/* 1997 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ },
/* 1998 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 1999 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ },
/* 2000 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 2001 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ },
/* 2002 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ },
/* 2003 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ },
/* 2004 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ },
/* 2005 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ },
/* 2006 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ },
/* 2007 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ },
/* 2008 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 2009 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 2010 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ },
/* 2011 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ },
/* 2012 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ },
/* 2013 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ },
/* 2014 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ },
/* 2015 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 2017 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ },
/* 2018 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ },
/* 2019 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ },
/* 2020 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ },
/* 2021 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 2023 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ },
/* 2024 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ },
/* 2025 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 2026 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ },
/* 2027 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ },
/* 2028 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ },
/* 2030 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ },
/* 2031 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ },
/* 2032 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Northern Kurdish [ku-kmr]
	//! authors : Mazlum Özdogan : https://github.com/mergehez
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(num, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['çend sanîye', 'çend sanîyeyan'],
	            ss: [num + ' sanîye', num + ' sanîyeyan'],
	            m: ['deqîqeyek', 'deqîqeyekê'],
	            mm: [num + ' deqîqe', num + ' deqîqeyan'],
	            h: ['saetek', 'saetekê'],
	            hh: [num + ' saet', num + ' saetan'],
	            d: ['rojek', 'rojekê'],
	            dd: [num + ' roj', num + ' rojan'],
	            w: ['hefteyek', 'hefteyekê'],
	            ww: [num + ' hefte', num + ' hefteyan'],
	            M: ['mehek', 'mehekê'],
	            MM: [num + ' meh', num + ' mehan'],
	            y: ['salek', 'salekê'],
	            yy: [num + ' sal', num + ' salan'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    // function obliqueNumSuffix(num) {
	    //     if(num.includes(':'))
	    //         num = parseInt(num.split(':')[0]);
	    //     else
	    //         num = parseInt(num);
	    //     return num == 0 || num % 10 == 1 ? 'ê'
	    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
	    // }
	    function ezafeNumSuffix(num) {
	        num = '' + num;
	        var l = num.substring(num.length - 1),
	            ll = num.length > 1 ? num.substring(num.length - 2) : '';
	        if (
	            !(ll == 12 || ll == 13) &&
	            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
	        )
	            return 'yê';
	        return 'ê';
	    }
	
	    var kuKmr = moment.defineLocale('ku-kmr', {
	        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
	        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
	        // But the names below are more well known and handy
	        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
	            '_'
	        ),
	        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
	        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
	        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'bn' : 'BN';
	            } else {
	                return isLower ? 'pn' : 'PN';
	            }
	        },
	        meridiemParse: /bn|BN|pn|PN/,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[a] YYYY[an]',
	            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
	            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
	            ll: 'Do MMM[.] YYYY[an]',
	            lll: 'Do MMM[.] YYYY[an] HH:mm',
	            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Îro di saet] LT [de]',
	            nextDay: '[Sibê di saet] LT [de]',
	            nextWeek: 'dddd [di saet] LT [de]',
	            lastDay: '[Duh di saet] LT [de]',
	            lastWeek: 'dddd[a borî di saet] LT [de]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'di %s de',
	            past: 'berî %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
	        ordinal: function (num, period) {
	            var p = period.toLowerCase();
	            if (p.includes('w') || p.includes('m')) return num + '.';
	
	            return num + ezafeNumSuffix(num);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return kuKmr;
	
	})));


/***/ },
/* 2035 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ },
/* 2036 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ },
/* 2037 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ },
/* 2038 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ },
/* 2039 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	              ? forms(key)[1]
	              : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ },
/* 2040 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ },
/* 2041 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                  ? wordKey[1]
	                  : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ },
/* 2042 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ },
/* 2043 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ },
/* 2044 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ },
/* 2045 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ },
/* 2046 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ },
/* 2047 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 2048 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ },
/* 2049 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ },
/* 2050 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ },
/* 2051 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'én time',
	            hh: '%d timer',
	            d: 'én dag',
	            dd: '%d dager',
	            w: 'én uke',
	            ww: '%d uker',
	            M: 'én måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ },
/* 2052 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ },
/* 2053 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 2054 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ },
/* 2055 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ },
/* 2056 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ },
/* 2057 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 2058 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ },
/* 2059 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 2060 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ },
/* 2061 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ },
/* 2062 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ },
/* 2063 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ },
/* 2064 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ },
/* 2065 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ },
/* 2066 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ },
/* 2067 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ },
/* 2068 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ },
/* 2069 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 2070 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ },
/* 2071 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ },
/* 2072 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                          ? ':a'
	                          : b === 2
	                            ? ':a'
	                            : b === 3
	                              ? ':e'
	                              : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ },
/* 2073 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ },
/* 2074 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ },
/* 2075 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ },
/* 2076 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ },
/* 2077 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ },
/* 2078 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ },
/* 2079 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ },
/* 2080 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 2081 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'waQ'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'nem'
	                    : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'wen'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'ben'
	                    : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 2082 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ },
/* 2083 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	              ? format[key][0]
	              : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 2084 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 2085 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 2086 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 2087 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	              ? 'genitive'
	              : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ },
/* 2088 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ },
/* 2089 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 2090 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ },
/* 2091 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ },
/* 2092 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 2093 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ },
/* 2094 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 2095 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 2096 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ },
/* 2097 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 2098 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.30.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        var flags = null,
	            parsedParts = false,
	            isNowValid = m._d && !isNaN(m._d.getTime());
	        if (isNowValid) {
	            flags = getParsingFlags(m);
	            parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            isNowValid =
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidEra &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        } else {
	            return isNowValid;
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {
	        D: 'date',
	        dates: 'date',
	        date: 'date',
	        d: 'day',
	        days: 'day',
	        day: 'day',
	        e: 'weekday',
	        weekdays: 'weekday',
	        weekday: 'weekday',
	        E: 'isoWeekday',
	        isoweekdays: 'isoWeekday',
	        isoweekday: 'isoWeekday',
	        DDD: 'dayOfYear',
	        dayofyears: 'dayOfYear',
	        dayofyear: 'dayOfYear',
	        h: 'hour',
	        hours: 'hour',
	        hour: 'hour',
	        ms: 'millisecond',
	        milliseconds: 'millisecond',
	        millisecond: 'millisecond',
	        m: 'minute',
	        minutes: 'minute',
	        minute: 'minute',
	        M: 'month',
	        months: 'month',
	        month: 'month',
	        Q: 'quarter',
	        quarters: 'quarter',
	        quarter: 'quarter',
	        s: 'second',
	        seconds: 'second',
	        second: 'second',
	        gg: 'weekYear',
	        weekyears: 'weekYear',
	        weekyear: 'weekYear',
	        GG: 'isoWeekYear',
	        isoweekyears: 'isoWeekYear',
	        isoweekyear: 'isoWeekYear',
	        w: 'week',
	        weeks: 'week',
	        week: 'week',
	        W: 'isoWeek',
	        isoweeks: 'isoWeek',
	        isoweek: 'isoWeek',
	        y: 'year',
	        years: 'year',
	        year: 'year',
	    };
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {
	        date: 9,
	        day: 11,
	        weekday: 11,
	        isoWeekday: 11,
	        dayOfYear: 4,
	        hour: 13,
	        millisecond: 16,
	        minute: 14,
	        month: 8,
	        quarter: 7,
	        second: 15,
	        weekYear: 1,
	        isoWeekYear: 1,
	        week: 5,
	        isoWeek: 5,
	        year: 1,
	    };
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
	        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        if (!mom.isValid()) {
	            return NaN;
	        }
	
	        var d = mom._d,
	            isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
	            case 'Seconds':
	                return isUTC ? d.getUTCSeconds() : d.getSeconds();
	            case 'Minutes':
	                return isUTC ? d.getUTCMinutes() : d.getMinutes();
	            case 'Hours':
	                return isUTC ? d.getUTCHours() : d.getHours();
	            case 'Date':
	                return isUTC ? d.getUTCDate() : d.getDate();
	            case 'Day':
	                return isUTC ? d.getUTCDay() : d.getDay();
	            case 'Month':
	                return isUTC ? d.getUTCMonth() : d.getMonth();
	            case 'FullYear':
	                return isUTC ? d.getUTCFullYear() : d.getFullYear();
	            default:
	                return NaN; // Just in case
	        }
	    }
	
	    function set$1(mom, unit, value) {
	        var d, isUTC, year, month, date;
	
	        if (!mom.isValid() || isNaN(value)) {
	            return;
	        }
	
	        d = mom._d;
	        isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return void (isUTC
	                    ? d.setUTCMilliseconds(value)
	                    : d.setMilliseconds(value));
	            case 'Seconds':
	                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
	            case 'Minutes':
	                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
	            case 'Hours':
	                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
	            case 'Date':
	                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
	            // case 'Day': // Not real
	            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
	            // case 'Month': // Not used because we need to pass two variables
	            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
	            case 'FullYear':
	                break; // See below ...
	            default:
	                return; // Just in case
	        }
	
	        year = value;
	        month = mom.month();
	        date = mom.date();
	        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
	        void (isUTC
	            ? d.setUTCFullYear(year, month, date)
	            : d.setFullYear(year, month, date));
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // PARSING
	
	    addRegexToken('M', match1to2, match1to2NoLeadingZero);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        var month = value,
	            date = mom.date();
	
	        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
	        void (mom._isUTC
	            ? mom._d.setUTCMonth(month, date)
	            : mom._d.setMonth(month, date));
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            shortP,
	            longP;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortP = regexEscape(this.monthsShort(mom, ''));
	            longP = regexEscape(this.months(mom, ''));
	            shortPieces.push(shortP);
	            longPieces.push(longP);
	            mixedPieces.push(longP);
	            mixedPieces.push(shortP);
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // PARSING
	
	    addRegexToken('w', match1to2, match1to2NoLeadingZero);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2, match1to2NoLeadingZero);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	              ? weekdays[m.day()]
	              : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	              ? this._weekdaysShort[m.day()]
	              : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	              ? this._weekdaysMin[m.day()]
	              : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        var day = get(this, 'Day');
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2, match1to2HasZero);
	    addRegexToken('h', match1to2, match1to2NoLeadingZero);
	    addRegexToken('k', match1to2, match1to2NoLeadingZero);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        // Ensure name is available and function returns boolean
	        return !!(name && name.match('^[^/\\\\]*$'));
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(__webpack_module_template_argument_0__)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                      ? DATE
	                      : a[HOUR] < 0 ||
	                          a[HOUR] > 24 ||
	                          (a[HOUR] === 24 &&
	                              (a[MINUTE] !== 0 ||
	                                  a[SECOND] !== 0 ||
	                                  a[MILLISECOND] !== 0))
	                        ? HOUR
	                        : a[MINUTE] < 0 || a[MINUTE] > 59
	                          ? MINUTE
	                          : a[SECOND] < 0 || a[SECOND] > 59
	                            ? SECOND
	                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                              ? MILLISECOND
	                              : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	              ? 'lastWeek'
	              : diff < 0
	                ? 'lastDay'
	                : diff < 1
	                  ? 'sameDay'
	                  : diff < 2
	                    ? 'nextDay'
	                    : diff < 7
	                      ? 'nextWeek'
	                      : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            erasName,
	            erasAbbr,
	            erasNarrow,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            erasName = regexEscape(eras[i].name);
	            erasAbbr = regexEscape(eras[i].abbr);
	            erasNarrow = regexEscape(eras[i].narrow);
	
	            namePieces.push(erasName);
	            abbrPieces.push(erasAbbr);
	            narrowPieces.push(erasNarrow);
	            mixedPieces.push(erasName);
	            mixedPieces.push(erasAbbr);
	            mixedPieces.push(erasNarrow);
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday() + this.localeData()._week.dow,
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // PARSING
	
	    addRegexToken('D', match1to2, match1to2NoLeadingZero);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // PARSING
	
	    addRegexToken('m', match1to2, match1to2HasZero);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // PARSING
	
	    addRegexToken('s', match1to2, match1to2HasZero);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y'),
	        valueOf$1 = asMilliseconds;
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.30.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(671)(module)))

/***/ },
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 2106 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__)
	  , TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 2107 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__) {

	'use strict';
	var $            = __webpack_require__(__webpack_module_template_argument_0__)
	  , hide         = __webpack_require__(__webpack_module_template_argument_1__)
	  , redefineAll  = __webpack_require__(__webpack_module_template_argument_2__)
	  , ctx          = __webpack_require__(__webpack_module_template_argument_3__)
	  , strictNew    = __webpack_require__(__webpack_module_template_argument_4__)
	  , defined      = __webpack_require__(__webpack_module_template_argument_5__)
	  , forOf        = __webpack_require__(__webpack_module_template_argument_6__)
	  , $iterDefine  = __webpack_require__(__webpack_module_template_argument_7__)
	  , step         = __webpack_require__(__webpack_module_template_argument_8__)
	  , ID           = __webpack_require__(__webpack_module_template_argument_9__)('id')
	  , $has         = __webpack_require__(__webpack_module_template_argument_10__)
	  , isObject     = __webpack_require__(__webpack_module_template_argument_11__)
	  , setSpecies   = __webpack_require__(__webpack_module_template_argument_12__)
	  , DESCRIPTORS  = __webpack_require__(__webpack_module_template_argument_13__)
	  , isExtensible = Object.isExtensible || isObject
	  , SIZE         = DESCRIPTORS ? '_s' : 'size'
	  , id           = 0;
	
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!$has(it, ID)){
	    // can't set id to frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add id
	    if(!create)return 'E';
	    // add missing object id
	    hide(it, ID, ++id);
	  // return object id with prefix
	  } return 'O' + it[ID];
	};
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      strictNew(that, C, NAME);
	      that._i = $.create(null); // index
	      that._f = undefined;      // first entry
	      that._l = undefined;      // last entry
	      that[SIZE] = 0;           // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 2108 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var forOf   = __webpack_require__(__webpack_module_template_argument_0__)
	  , classof = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    var arr = [];
	    forOf(this, false, arr.push, arr);
	    return arr;
	  };
	};

/***/ },
/* 2109 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 2110 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 2111 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ctx         = __webpack_require__(__webpack_module_template_argument_0__)
	  , call        = __webpack_require__(__webpack_module_template_argument_1__)
	  , isArrayIter = __webpack_require__(__webpack_module_template_argument_2__)
	  , anObject    = __webpack_require__(__webpack_module_template_argument_3__)
	  , toLength    = __webpack_require__(__webpack_module_template_argument_4__)
	  , getIterFn   = __webpack_require__(__webpack_module_template_argument_5__);
	module.exports = function(iterable, entries, fn, that){
	  var iterFn = getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ },
/* 2112 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var $          = __webpack_require__(__webpack_module_template_argument_0__)
	  , createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 2113 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 2114 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(__webpack_module_template_argument_0__)
	  , ITERATOR   = __webpack_require__(__webpack_module_template_argument_1__)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 2115 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 2116 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var $              = __webpack_require__(__webpack_module_template_argument_0__)
	  , descriptor     = __webpack_require__(__webpack_module_template_argument_1__)
	  , setToStringTag = __webpack_require__(__webpack_module_template_argument_2__)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 2117 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	'use strict';
	var LIBRARY        = __webpack_require__(__webpack_module_template_argument_0__)
	  , $export        = __webpack_require__(__webpack_module_template_argument_1__)
	  , redefine       = __webpack_require__(__webpack_module_template_argument_2__)
	  , hide           = __webpack_require__(__webpack_module_template_argument_3__)
	  , has            = __webpack_require__(__webpack_module_template_argument_4__)
	  , Iterators      = __webpack_require__(__webpack_module_template_argument_5__)
	  , $iterCreate    = __webpack_require__(__webpack_module_template_argument_6__)
	  , setToStringTag = __webpack_require__(__webpack_module_template_argument_7__)
	  , getProto       = __webpack_require__(__webpack_module_template_argument_8__).getProto
	  , ITERATOR       = __webpack_require__(__webpack_module_template_argument_9__)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if($native){
	    var IteratorPrototype = getProto($default.call(new Base));
	    // Set @@toStringTag to native iterators
	    setToStringTag(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    // fix Array#{values, @@iterator}.name in V8 / FF
	    if(DEF_VALUES && $native.name !== VALUES){
	      VALUES_BUG = true;
	      $default = function values(){ return $native.call(this); };
	    }
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES  ? $default : getMethod(VALUES),
	      keys:    IS_SET      ? $default : getMethod(KEYS),
	      entries: !DEF_VALUES ? $default : getMethod('entries')
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 2118 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR     = __webpack_require__(__webpack_module_template_argument_0__)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 2119 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(__webpack_module_template_argument_0__)
	  , toObject = __webpack_require__(__webpack_module_template_argument_1__)
	  , IObject  = __webpack_require__(__webpack_module_template_argument_2__);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(__webpack_module_template_argument_3__)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ },
/* 2120 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $         = __webpack_require__(__webpack_module_template_argument_0__)
	  , toIObject = __webpack_require__(__webpack_module_template_argument_1__)
	  , isEnum    = $.isEnum;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = $.getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 2121 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var redefine = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function(target, src){
	  for(var key in src)redefine(target, key, src[key]);
	  return target;
	};

/***/ },
/* 2122 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).setDesc
	  , has = __webpack_require__(__webpack_module_template_argument_1__)
	  , TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 2123 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__)
	  , defined   = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 2125 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__)
	  , defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 2126 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 2127 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 2128 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store  = __webpack_require__(__webpack_module_template_argument_0__)('wks')
	  , uid    = __webpack_require__(__webpack_module_template_argument_1__)
	  , Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
	};

/***/ },
/* 2129 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof   = __webpack_require__(__webpack_module_template_argument_0__)
	  , ITERATOR  = __webpack_require__(__webpack_module_template_argument_1__)('iterator')
	  , Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 2130 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	'use strict';
	var ctx         = __webpack_require__(__webpack_module_template_argument_0__)
	  , $export     = __webpack_require__(__webpack_module_template_argument_1__)
	  , toObject    = __webpack_require__(__webpack_module_template_argument_2__)
	  , call        = __webpack_require__(__webpack_module_template_argument_3__)
	  , isArrayIter = __webpack_require__(__webpack_module_template_argument_4__)
	  , toLength    = __webpack_require__(__webpack_module_template_argument_5__)
	  , getIterFn   = __webpack_require__(__webpack_module_template_argument_6__);
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_7__)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , $$      = arguments
	      , $$len   = $$.length
	      , mapfn   = $$len > 1 ? $$[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, $$len > 2 ? $$[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        result[index] = mapping ? mapfn(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 2131 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__)
	  , step             = __webpack_require__(__webpack_module_template_argument_1__)
	  , Iterators        = __webpack_require__(__webpack_module_template_argument_2__)
	  , toIObject        = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 2132 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var strong = __webpack_require__(__webpack_module_template_argument_0__);
	
	// 23.1 Map Objects
	__webpack_require__(__webpack_module_template_argument_1__)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 2133 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(__webpack_module_template_argument_1__)});

/***/ },
/* 2134 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at  = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 2135 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.P, 'Map', {toJSON: __webpack_require__(__webpack_module_template_argument_1__)('Map')});

/***/ },
/* 2136 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// http://goo.gl/XkBrjD
	var $export = __webpack_require__(__webpack_module_template_argument_0__)
	  , $values = __webpack_require__(__webpack_module_template_argument_1__)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 2137 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(__webpack_module_template_argument_0__);
	exports.encode = exports.stringify = __webpack_require__(__webpack_module_template_argument_1__);


/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** vendor-994ef56c66c2b66b3bca.js
 **/